// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/react-clock/dist/Clock.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/react-datepicker/dist/react-datepicker.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/react-image-crop/dist/ReactCrop.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/react-bootstrap-typeahead/css/Typeahead.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/react-dropzone-uploader/dist/styles.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/react-dragula/dist/dragula.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/react-toastify/dist/ReactToastify.css";
import ___CSS_LOADER_AT_RULE_IMPORT_7___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/react-day-picker/dist/style.css";
import ___CSS_LOADER_AT_RULE_IMPORT_8___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/react-big-calendar/lib/css/react-big-calendar.css";
import ___CSS_LOADER_AT_RULE_IMPORT_9___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/react-vertical-timeline-component/style.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_10___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/easymde/dist/easymde.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_11___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/leaflet/dist/leaflet.css";
import ___CSS_LOADER_AT_RULE_IMPORT_12___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/react-18-image-lightbox/style.css";
import ___CSS_LOADER_AT_RULE_IMPORT_13___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/react-perfect-scrollbar/dist/css/styles.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23dee2e6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23198754%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2833, 37, 41, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%23212529%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("./assets/images/dashboard-5/profile-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("./assets/images/details_open.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("./assets/fonts/slick.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("./assets/fonts/slick.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("./assets/fonts/slick.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("./assets/fonts/slick.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("./assets/images/other-images/coming-soon-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("./assets/images/dashboard-2/balance-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("./assets/images/dashboard-3/bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("./assets/images/dashboard-4/bg-balance.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("./assets/images/dashboard/widget-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("./assets/images/other-images/maintenance-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("./assets/images/login/login_bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("./assets/images/social-app/social-image.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("./assets/images/other-images/bg-profile.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("./assets/images/other-images/boxbg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("./assets/fonts/themify/themify.eot?-fvbane", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("./assets/fonts/themify/themify.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("./assets/fonts/themify/themify.woff?-fvbane", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("./assets/fonts/themify/themify.ttf?-fvbane", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("./assets/fonts/themify/themify.svg?-fvbane", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("./assets/fonts/ico/icofont.eot?v=1.0.0-beta", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("./assets/fonts/ico/icofont.ttf?v=1.0.0-beta", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("./assets/fonts/ico/icofont.woff?v=1.0.0-beta", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("./assets/fonts/ico/icofont.svg?v=1.0.0-beta", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("./assets/fonts/flag-icon/es-ct.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("./assets/fonts/flag-icon/eu.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("./assets/fonts/flag-icon/gb-eng.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("./assets/fonts/flag-icon/gb-nir.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("./assets/fonts/flag-icon/gb-sct.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("./assets/fonts/flag-icon/gb-wls.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("./assets/fonts/flag-icon/un.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("./assets/fonts/flag-icon/ad.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("./assets/fonts/flag-icon/ae.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("./assets/fonts/flag-icon/af.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_51___ = new URL("./assets/fonts/flag-icon/ag.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_52___ = new URL("./assets/fonts/flag-icon/ai.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_53___ = new URL("./assets/fonts/flag-icon/al.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_54___ = new URL("./assets/fonts/flag-icon/am.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_55___ = new URL("./assets/fonts/flag-icon/ao.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_56___ = new URL("./assets/fonts/flag-icon/aq.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_57___ = new URL("./assets/fonts/flag-icon/ar.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_58___ = new URL("./assets/fonts/flag-icon/as.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_59___ = new URL("./assets/fonts/flag-icon/at.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_60___ = new URL("./assets/fonts/flag-icon/au.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_61___ = new URL("./assets/fonts/flag-icon/aw.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_62___ = new URL("./assets/fonts/flag-icon/ax.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_63___ = new URL("./assets/fonts/flag-icon/az.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_64___ = new URL("./assets/fonts/flag-icon/ba.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_65___ = new URL("./assets/fonts/flag-icon/bb.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_66___ = new URL("./assets/fonts/flag-icon/bd.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_67___ = new URL("./assets/fonts/flag-icon/be.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_68___ = new URL("./assets/fonts/flag-icon/bf.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_69___ = new URL("./assets/fonts/flag-icon/bg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_70___ = new URL("./assets/fonts/flag-icon/bh.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_71___ = new URL("./assets/fonts/flag-icon/bi.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_72___ = new URL("./assets/fonts/flag-icon/bj.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_73___ = new URL("./assets/fonts/flag-icon/bl.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_74___ = new URL("./assets/fonts/flag-icon/bm.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_75___ = new URL("./assets/fonts/flag-icon/bn.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_76___ = new URL("./assets/fonts/flag-icon/bo.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_77___ = new URL("./assets/fonts/flag-icon/bq.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_78___ = new URL("./assets/fonts/flag-icon/br.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_79___ = new URL("./assets/fonts/flag-icon/bs.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_80___ = new URL("./assets/fonts/flag-icon/bt.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_81___ = new URL("./assets/fonts/flag-icon/bv.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_82___ = new URL("./assets/fonts/flag-icon/bw.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_83___ = new URL("./assets/fonts/flag-icon/by.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_84___ = new URL("./assets/fonts/flag-icon/bz.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_85___ = new URL("./assets/fonts/flag-icon/ca.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_86___ = new URL("./assets/fonts/flag-icon/cc.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_87___ = new URL("./assets/fonts/flag-icon/cd.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_88___ = new URL("./assets/fonts/flag-icon/cf.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_89___ = new URL("./assets/fonts/flag-icon/cg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_90___ = new URL("./assets/fonts/flag-icon/ch.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_91___ = new URL("./assets/fonts/flag-icon/ci.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_92___ = new URL("./assets/fonts/flag-icon/ck.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_93___ = new URL("./assets/fonts/flag-icon/cl.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_94___ = new URL("./assets/fonts/flag-icon/cm.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_95___ = new URL("./assets/fonts/flag-icon/cn.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_96___ = new URL("./assets/fonts/flag-icon/co.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_97___ = new URL("./assets/fonts/flag-icon/cr.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_98___ = new URL("./assets/fonts/flag-icon/cu.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_99___ = new URL("./assets/fonts/flag-icon/cv.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_100___ = new URL("./assets/fonts/flag-icon/cw.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_101___ = new URL("./assets/fonts/flag-icon/cx.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_102___ = new URL("./assets/fonts/flag-icon/cy.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_103___ = new URL("./assets/fonts/flag-icon/cz.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_104___ = new URL("./assets/fonts/flag-icon/de.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_105___ = new URL("./assets/fonts/flag-icon/dj.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_106___ = new URL("./assets/fonts/flag-icon/dk.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_107___ = new URL("./assets/fonts/flag-icon/dm.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_108___ = new URL("./assets/fonts/flag-icon/do.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_109___ = new URL("./assets/fonts/flag-icon/dz.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_110___ = new URL("./assets/fonts/flag-icon/ec.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_111___ = new URL("./assets/fonts/flag-icon/ee.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_112___ = new URL("./assets/fonts/flag-icon/eg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_113___ = new URL("./assets/fonts/flag-icon/eh.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_114___ = new URL("./assets/fonts/flag-icon/er.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_115___ = new URL("./assets/fonts/flag-icon/es.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_116___ = new URL("./assets/fonts/flag-icon/et.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_117___ = new URL("./assets/fonts/flag-icon/fi.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_118___ = new URL("./assets/fonts/flag-icon/fj.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_119___ = new URL("./assets/fonts/flag-icon/fk.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_120___ = new URL("./assets/fonts/flag-icon/fm.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_121___ = new URL("./assets/fonts/flag-icon/fo.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_122___ = new URL("./assets/fonts/flag-icon/fr.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_123___ = new URL("./assets/fonts/flag-icon/ga.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_124___ = new URL("./assets/fonts/flag-icon/gb.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_125___ = new URL("./assets/fonts/flag-icon/gd.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_126___ = new URL("./assets/fonts/flag-icon/ge.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_127___ = new URL("./assets/fonts/flag-icon/gf.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_128___ = new URL("./assets/fonts/flag-icon/gg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_129___ = new URL("./assets/fonts/flag-icon/gh.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_130___ = new URL("./assets/fonts/flag-icon/gi.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_131___ = new URL("./assets/fonts/flag-icon/gl.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_132___ = new URL("./assets/fonts/flag-icon/gm.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_133___ = new URL("./assets/fonts/flag-icon/gn.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_134___ = new URL("./assets/fonts/flag-icon/gp.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_135___ = new URL("./assets/fonts/flag-icon/gq.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_136___ = new URL("./assets/fonts/flag-icon/gr.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_137___ = new URL("./assets/fonts/flag-icon/gs.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_138___ = new URL("./assets/fonts/flag-icon/gt.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_139___ = new URL("./assets/fonts/flag-icon/gu.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_140___ = new URL("./assets/fonts/flag-icon/gw.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_141___ = new URL("./assets/fonts/flag-icon/gy.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_142___ = new URL("./assets/fonts/flag-icon/hk.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_143___ = new URL("./assets/fonts/flag-icon/hm.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_144___ = new URL("./assets/fonts/flag-icon/hn.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_145___ = new URL("./assets/fonts/flag-icon/hr.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_146___ = new URL("./assets/fonts/flag-icon/ht.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_147___ = new URL("./assets/fonts/flag-icon/hu.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_148___ = new URL("./assets/fonts/flag-icon/id.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_149___ = new URL("./assets/fonts/flag-icon/ie.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_150___ = new URL("./assets/fonts/flag-icon/il.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_151___ = new URL("./assets/fonts/flag-icon/im.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_152___ = new URL("./assets/fonts/flag-icon/in.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_153___ = new URL("./assets/fonts/flag-icon/io.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_154___ = new URL("./assets/fonts/flag-icon/iq.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_155___ = new URL("./assets/fonts/flag-icon/ir.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_156___ = new URL("./assets/fonts/flag-icon/is.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_157___ = new URL("./assets/fonts/flag-icon/it.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_158___ = new URL("./assets/fonts/flag-icon/je.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_159___ = new URL("./assets/fonts/flag-icon/jm.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_160___ = new URL("./assets/fonts/flag-icon/jo.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_161___ = new URL("./assets/fonts/flag-icon/jp.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_162___ = new URL("./assets/fonts/flag-icon/ke.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_163___ = new URL("./assets/fonts/flag-icon/kg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_164___ = new URL("./assets/fonts/flag-icon/kh.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_165___ = new URL("./assets/fonts/flag-icon/ki.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_166___ = new URL("./assets/fonts/flag-icon/km.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_167___ = new URL("./assets/fonts/flag-icon/kn.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_168___ = new URL("./assets/fonts/flag-icon/kp.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_169___ = new URL("./assets/fonts/flag-icon/kr.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_170___ = new URL("./assets/fonts/flag-icon/kw.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_171___ = new URL("./assets/fonts/flag-icon/ky.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_172___ = new URL("./assets/fonts/flag-icon/kz.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_173___ = new URL("./assets/fonts/flag-icon/la.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_174___ = new URL("./assets/fonts/flag-icon/lb.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_175___ = new URL("./assets/fonts/flag-icon/lc.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_176___ = new URL("./assets/fonts/flag-icon/li.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_177___ = new URL("./assets/fonts/flag-icon/lk.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_178___ = new URL("./assets/fonts/flag-icon/lr.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_179___ = new URL("./assets/fonts/flag-icon/ls.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_180___ = new URL("./assets/fonts/flag-icon/lt.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_181___ = new URL("./assets/fonts/flag-icon/lu.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_182___ = new URL("./assets/fonts/flag-icon/lv.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_183___ = new URL("./assets/fonts/flag-icon/ly.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_184___ = new URL("./assets/fonts/flag-icon/ma.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_185___ = new URL("./assets/fonts/flag-icon/mc.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_186___ = new URL("./assets/fonts/flag-icon/md.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_187___ = new URL("./assets/fonts/flag-icon/me.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_188___ = new URL("./assets/fonts/flag-icon/mf.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_189___ = new URL("./assets/fonts/flag-icon/mg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_190___ = new URL("./assets/fonts/flag-icon/mh.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_191___ = new URL("./assets/fonts/flag-icon/mk.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_192___ = new URL("./assets/fonts/flag-icon/ml.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_193___ = new URL("./assets/fonts/flag-icon/mm.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_194___ = new URL("./assets/fonts/flag-icon/mn.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_195___ = new URL("./assets/fonts/flag-icon/mo.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_196___ = new URL("./assets/fonts/flag-icon/mp.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_197___ = new URL("./assets/fonts/flag-icon/mq.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_198___ = new URL("./assets/fonts/flag-icon/mr.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_199___ = new URL("./assets/fonts/flag-icon/ms.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_200___ = new URL("./assets/fonts/flag-icon/mt.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_201___ = new URL("./assets/fonts/flag-icon/mu.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_202___ = new URL("./assets/fonts/flag-icon/mv.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_203___ = new URL("./assets/fonts/flag-icon/mw.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_204___ = new URL("./assets/fonts/flag-icon/mx.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_205___ = new URL("./assets/fonts/flag-icon/my.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_206___ = new URL("./assets/fonts/flag-icon/mz.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_207___ = new URL("./assets/fonts/flag-icon/na.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_208___ = new URL("./assets/fonts/flag-icon/nc.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_209___ = new URL("./assets/fonts/flag-icon/ne.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_210___ = new URL("./assets/fonts/flag-icon/nf.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_211___ = new URL("./assets/fonts/flag-icon/ng.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_212___ = new URL("./assets/fonts/flag-icon/ni.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_213___ = new URL("./assets/fonts/flag-icon/nl.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_214___ = new URL("./assets/fonts/flag-icon/no.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_215___ = new URL("./assets/fonts/flag-icon/np.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_216___ = new URL("./assets/fonts/flag-icon/nr.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_217___ = new URL("./assets/fonts/flag-icon/nu.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_218___ = new URL("./assets/fonts/flag-icon/nz.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_219___ = new URL("./assets/fonts/flag-icon/om.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_220___ = new URL("./assets/fonts/flag-icon/pa.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_221___ = new URL("./assets/fonts/flag-icon/pe.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_222___ = new URL("./assets/fonts/flag-icon/pf.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_223___ = new URL("./assets/fonts/flag-icon/pg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_224___ = new URL("./assets/fonts/flag-icon/ph.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_225___ = new URL("./assets/fonts/flag-icon/pk.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_226___ = new URL("./assets/fonts/flag-icon/pl.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_227___ = new URL("./assets/fonts/flag-icon/pm.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_228___ = new URL("./assets/fonts/flag-icon/pn.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_229___ = new URL("./assets/fonts/flag-icon/pr.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_230___ = new URL("./assets/fonts/flag-icon/ps.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_231___ = new URL("./assets/fonts/flag-icon/pt.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_232___ = new URL("./assets/fonts/flag-icon/pw.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_233___ = new URL("./assets/fonts/flag-icon/py.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_234___ = new URL("./assets/fonts/flag-icon/qa.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_235___ = new URL("./assets/fonts/flag-icon/re.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_236___ = new URL("./assets/fonts/flag-icon/ro.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_237___ = new URL("./assets/fonts/flag-icon/rs.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_238___ = new URL("./assets/fonts/flag-icon/ru.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_239___ = new URL("./assets/fonts/flag-icon/rw.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_240___ = new URL("./assets/fonts/flag-icon/sa.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_241___ = new URL("./assets/fonts/flag-icon/sb.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_242___ = new URL("./assets/fonts/flag-icon/sc.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_243___ = new URL("./assets/fonts/flag-icon/sd.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_244___ = new URL("./assets/fonts/flag-icon/se.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_245___ = new URL("./assets/fonts/flag-icon/sg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_246___ = new URL("./assets/fonts/flag-icon/sh.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_247___ = new URL("./assets/fonts/flag-icon/si.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_248___ = new URL("./assets/fonts/flag-icon/sj.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_249___ = new URL("./assets/fonts/flag-icon/sk.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_250___ = new URL("./assets/fonts/flag-icon/sl.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_251___ = new URL("./assets/fonts/flag-icon/sm.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_252___ = new URL("./assets/fonts/flag-icon/sn.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_253___ = new URL("./assets/fonts/flag-icon/so.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_254___ = new URL("./assets/fonts/flag-icon/sr.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_255___ = new URL("./assets/fonts/flag-icon/ss.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_256___ = new URL("./assets/fonts/flag-icon/st.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_257___ = new URL("./assets/fonts/flag-icon/sv.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_258___ = new URL("./assets/fonts/flag-icon/sx.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_259___ = new URL("./assets/fonts/flag-icon/sy.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_260___ = new URL("./assets/fonts/flag-icon/sz.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_261___ = new URL("./assets/fonts/flag-icon/tc.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_262___ = new URL("./assets/fonts/flag-icon/td.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_263___ = new URL("./assets/fonts/flag-icon/tf.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_264___ = new URL("./assets/fonts/flag-icon/tg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_265___ = new URL("./assets/fonts/flag-icon/th.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_266___ = new URL("./assets/fonts/flag-icon/tj.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_267___ = new URL("./assets/fonts/flag-icon/tk.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_268___ = new URL("./assets/fonts/flag-icon/tl.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_269___ = new URL("./assets/fonts/flag-icon/tm.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_270___ = new URL("./assets/fonts/flag-icon/tn.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_271___ = new URL("./assets/fonts/flag-icon/to.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_272___ = new URL("./assets/fonts/flag-icon/tr.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_273___ = new URL("./assets/fonts/flag-icon/tt.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_274___ = new URL("./assets/fonts/flag-icon/tv.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_275___ = new URL("./assets/fonts/flag-icon/tw.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_276___ = new URL("./assets/fonts/flag-icon/tz.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_277___ = new URL("./assets/fonts/flag-icon/ua.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_278___ = new URL("./assets/fonts/flag-icon/ug.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_279___ = new URL("./assets/fonts/flag-icon/um.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_280___ = new URL("./assets/fonts/flag-icon/us.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_281___ = new URL("./assets/fonts/flag-icon/uy.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_282___ = new URL("./assets/fonts/flag-icon/uz.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_283___ = new URL("./assets/fonts/flag-icon/va.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_284___ = new URL("./assets/fonts/flag-icon/vc.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_285___ = new URL("./assets/fonts/flag-icon/ve.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_286___ = new URL("./assets/fonts/flag-icon/vg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_287___ = new URL("./assets/fonts/flag-icon/vi.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_288___ = new URL("./assets/fonts/flag-icon/vn.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_289___ = new URL("./assets/fonts/flag-icon/vu.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_290___ = new URL("./assets/fonts/flag-icon/wf.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_291___ = new URL("./assets/fonts/flag-icon/ws.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_292___ = new URL("./assets/fonts/flag-icon/ye.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_293___ = new URL("./assets/fonts/flag-icon/yt.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_294___ = new URL("./assets/fonts/flag-icon/za.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_295___ = new URL("./assets/fonts/flag-icon/zm.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_296___ = new URL("./assets/fonts/flag-icon/zw.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_297___ = new URL("./assets/fonts/font-awesome/fontawesome-webfont.eot?v=4.7.0", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_298___ = new URL("./assets/fonts/font-awesome/fontawesome-webfont.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_299___ = new URL("./assets/fonts/font-awesome/fontawesome-webfont.woff2?v=4.7.0", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_300___ = new URL("./assets/fonts/font-awesome/fontawesome-webfont.woff?v=4.7.0", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_301___ = new URL("./assets/fonts/font-awesome/fontawesome-webfont.ttf?v=4.7.0", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_302___ = new URL("./assets/fonts/font-awesome/fontawesome-webfont.svg?v=4.7.0", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_7___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_8___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_9___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_10___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_11___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_12___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___, { hash: "#slick" });
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___, { hash: "?#iefix-fvbane" });
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___, { hash: "#themify" });
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___, { hash: "#icofont" });
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_51___);
var ___CSS_LOADER_URL_REPLACEMENT_54___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_52___);
var ___CSS_LOADER_URL_REPLACEMENT_55___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_53___);
var ___CSS_LOADER_URL_REPLACEMENT_56___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_54___);
var ___CSS_LOADER_URL_REPLACEMENT_57___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_55___);
var ___CSS_LOADER_URL_REPLACEMENT_58___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_56___);
var ___CSS_LOADER_URL_REPLACEMENT_59___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_57___);
var ___CSS_LOADER_URL_REPLACEMENT_60___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_58___);
var ___CSS_LOADER_URL_REPLACEMENT_61___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_59___);
var ___CSS_LOADER_URL_REPLACEMENT_62___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_60___);
var ___CSS_LOADER_URL_REPLACEMENT_63___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_61___);
var ___CSS_LOADER_URL_REPLACEMENT_64___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_62___);
var ___CSS_LOADER_URL_REPLACEMENT_65___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_63___);
var ___CSS_LOADER_URL_REPLACEMENT_66___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_64___);
var ___CSS_LOADER_URL_REPLACEMENT_67___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_65___);
var ___CSS_LOADER_URL_REPLACEMENT_68___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_66___);
var ___CSS_LOADER_URL_REPLACEMENT_69___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_67___);
var ___CSS_LOADER_URL_REPLACEMENT_70___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_68___);
var ___CSS_LOADER_URL_REPLACEMENT_71___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_69___);
var ___CSS_LOADER_URL_REPLACEMENT_72___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_70___);
var ___CSS_LOADER_URL_REPLACEMENT_73___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_71___);
var ___CSS_LOADER_URL_REPLACEMENT_74___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_72___);
var ___CSS_LOADER_URL_REPLACEMENT_75___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_73___);
var ___CSS_LOADER_URL_REPLACEMENT_76___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_74___);
var ___CSS_LOADER_URL_REPLACEMENT_77___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_75___);
var ___CSS_LOADER_URL_REPLACEMENT_78___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_76___);
var ___CSS_LOADER_URL_REPLACEMENT_79___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_77___);
var ___CSS_LOADER_URL_REPLACEMENT_80___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_78___);
var ___CSS_LOADER_URL_REPLACEMENT_81___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_79___);
var ___CSS_LOADER_URL_REPLACEMENT_82___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_80___);
var ___CSS_LOADER_URL_REPLACEMENT_83___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_81___);
var ___CSS_LOADER_URL_REPLACEMENT_84___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_82___);
var ___CSS_LOADER_URL_REPLACEMENT_85___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_83___);
var ___CSS_LOADER_URL_REPLACEMENT_86___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_84___);
var ___CSS_LOADER_URL_REPLACEMENT_87___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_85___);
var ___CSS_LOADER_URL_REPLACEMENT_88___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_86___);
var ___CSS_LOADER_URL_REPLACEMENT_89___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_87___);
var ___CSS_LOADER_URL_REPLACEMENT_90___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_88___);
var ___CSS_LOADER_URL_REPLACEMENT_91___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_89___);
var ___CSS_LOADER_URL_REPLACEMENT_92___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_90___);
var ___CSS_LOADER_URL_REPLACEMENT_93___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_91___);
var ___CSS_LOADER_URL_REPLACEMENT_94___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_92___);
var ___CSS_LOADER_URL_REPLACEMENT_95___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_93___);
var ___CSS_LOADER_URL_REPLACEMENT_96___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_94___);
var ___CSS_LOADER_URL_REPLACEMENT_97___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_95___);
var ___CSS_LOADER_URL_REPLACEMENT_98___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_96___);
var ___CSS_LOADER_URL_REPLACEMENT_99___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_97___);
var ___CSS_LOADER_URL_REPLACEMENT_100___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_98___);
var ___CSS_LOADER_URL_REPLACEMENT_101___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_99___);
var ___CSS_LOADER_URL_REPLACEMENT_102___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_100___);
var ___CSS_LOADER_URL_REPLACEMENT_103___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_101___);
var ___CSS_LOADER_URL_REPLACEMENT_104___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_102___);
var ___CSS_LOADER_URL_REPLACEMENT_105___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_103___);
var ___CSS_LOADER_URL_REPLACEMENT_106___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_104___);
var ___CSS_LOADER_URL_REPLACEMENT_107___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_105___);
var ___CSS_LOADER_URL_REPLACEMENT_108___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_106___);
var ___CSS_LOADER_URL_REPLACEMENT_109___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_107___);
var ___CSS_LOADER_URL_REPLACEMENT_110___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_108___);
var ___CSS_LOADER_URL_REPLACEMENT_111___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_109___);
var ___CSS_LOADER_URL_REPLACEMENT_112___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_110___);
var ___CSS_LOADER_URL_REPLACEMENT_113___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_111___);
var ___CSS_LOADER_URL_REPLACEMENT_114___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_112___);
var ___CSS_LOADER_URL_REPLACEMENT_115___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_113___);
var ___CSS_LOADER_URL_REPLACEMENT_116___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_114___);
var ___CSS_LOADER_URL_REPLACEMENT_117___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_115___);
var ___CSS_LOADER_URL_REPLACEMENT_118___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_116___);
var ___CSS_LOADER_URL_REPLACEMENT_119___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_117___);
var ___CSS_LOADER_URL_REPLACEMENT_120___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_118___);
var ___CSS_LOADER_URL_REPLACEMENT_121___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_119___);
var ___CSS_LOADER_URL_REPLACEMENT_122___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_120___);
var ___CSS_LOADER_URL_REPLACEMENT_123___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_121___);
var ___CSS_LOADER_URL_REPLACEMENT_124___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_122___);
var ___CSS_LOADER_URL_REPLACEMENT_125___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_123___);
var ___CSS_LOADER_URL_REPLACEMENT_126___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_124___);
var ___CSS_LOADER_URL_REPLACEMENT_127___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_125___);
var ___CSS_LOADER_URL_REPLACEMENT_128___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_126___);
var ___CSS_LOADER_URL_REPLACEMENT_129___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_127___);
var ___CSS_LOADER_URL_REPLACEMENT_130___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_128___);
var ___CSS_LOADER_URL_REPLACEMENT_131___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_129___);
var ___CSS_LOADER_URL_REPLACEMENT_132___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_130___);
var ___CSS_LOADER_URL_REPLACEMENT_133___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_131___);
var ___CSS_LOADER_URL_REPLACEMENT_134___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_132___);
var ___CSS_LOADER_URL_REPLACEMENT_135___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_133___);
var ___CSS_LOADER_URL_REPLACEMENT_136___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_134___);
var ___CSS_LOADER_URL_REPLACEMENT_137___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_135___);
var ___CSS_LOADER_URL_REPLACEMENT_138___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_136___);
var ___CSS_LOADER_URL_REPLACEMENT_139___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_137___);
var ___CSS_LOADER_URL_REPLACEMENT_140___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_138___);
var ___CSS_LOADER_URL_REPLACEMENT_141___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_139___);
var ___CSS_LOADER_URL_REPLACEMENT_142___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_140___);
var ___CSS_LOADER_URL_REPLACEMENT_143___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_141___);
var ___CSS_LOADER_URL_REPLACEMENT_144___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_142___);
var ___CSS_LOADER_URL_REPLACEMENT_145___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_143___);
var ___CSS_LOADER_URL_REPLACEMENT_146___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_144___);
var ___CSS_LOADER_URL_REPLACEMENT_147___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_145___);
var ___CSS_LOADER_URL_REPLACEMENT_148___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_146___);
var ___CSS_LOADER_URL_REPLACEMENT_149___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_147___);
var ___CSS_LOADER_URL_REPLACEMENT_150___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_148___);
var ___CSS_LOADER_URL_REPLACEMENT_151___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_149___);
var ___CSS_LOADER_URL_REPLACEMENT_152___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_150___);
var ___CSS_LOADER_URL_REPLACEMENT_153___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_151___);
var ___CSS_LOADER_URL_REPLACEMENT_154___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_152___);
var ___CSS_LOADER_URL_REPLACEMENT_155___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_153___);
var ___CSS_LOADER_URL_REPLACEMENT_156___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_154___);
var ___CSS_LOADER_URL_REPLACEMENT_157___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_155___);
var ___CSS_LOADER_URL_REPLACEMENT_158___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_156___);
var ___CSS_LOADER_URL_REPLACEMENT_159___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_157___);
var ___CSS_LOADER_URL_REPLACEMENT_160___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_158___);
var ___CSS_LOADER_URL_REPLACEMENT_161___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_159___);
var ___CSS_LOADER_URL_REPLACEMENT_162___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_160___);
var ___CSS_LOADER_URL_REPLACEMENT_163___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_161___);
var ___CSS_LOADER_URL_REPLACEMENT_164___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_162___);
var ___CSS_LOADER_URL_REPLACEMENT_165___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_163___);
var ___CSS_LOADER_URL_REPLACEMENT_166___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_164___);
var ___CSS_LOADER_URL_REPLACEMENT_167___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_165___);
var ___CSS_LOADER_URL_REPLACEMENT_168___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_166___);
var ___CSS_LOADER_URL_REPLACEMENT_169___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_167___);
var ___CSS_LOADER_URL_REPLACEMENT_170___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_168___);
var ___CSS_LOADER_URL_REPLACEMENT_171___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_169___);
var ___CSS_LOADER_URL_REPLACEMENT_172___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_170___);
var ___CSS_LOADER_URL_REPLACEMENT_173___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_171___);
var ___CSS_LOADER_URL_REPLACEMENT_174___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_172___);
var ___CSS_LOADER_URL_REPLACEMENT_175___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_173___);
var ___CSS_LOADER_URL_REPLACEMENT_176___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_174___);
var ___CSS_LOADER_URL_REPLACEMENT_177___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_175___);
var ___CSS_LOADER_URL_REPLACEMENT_178___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_176___);
var ___CSS_LOADER_URL_REPLACEMENT_179___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_177___);
var ___CSS_LOADER_URL_REPLACEMENT_180___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_178___);
var ___CSS_LOADER_URL_REPLACEMENT_181___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_179___);
var ___CSS_LOADER_URL_REPLACEMENT_182___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_180___);
var ___CSS_LOADER_URL_REPLACEMENT_183___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_181___);
var ___CSS_LOADER_URL_REPLACEMENT_184___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_182___);
var ___CSS_LOADER_URL_REPLACEMENT_185___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_183___);
var ___CSS_LOADER_URL_REPLACEMENT_186___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_184___);
var ___CSS_LOADER_URL_REPLACEMENT_187___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_185___);
var ___CSS_LOADER_URL_REPLACEMENT_188___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_186___);
var ___CSS_LOADER_URL_REPLACEMENT_189___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_187___);
var ___CSS_LOADER_URL_REPLACEMENT_190___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_188___);
var ___CSS_LOADER_URL_REPLACEMENT_191___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_189___);
var ___CSS_LOADER_URL_REPLACEMENT_192___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_190___);
var ___CSS_LOADER_URL_REPLACEMENT_193___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_191___);
var ___CSS_LOADER_URL_REPLACEMENT_194___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_192___);
var ___CSS_LOADER_URL_REPLACEMENT_195___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_193___);
var ___CSS_LOADER_URL_REPLACEMENT_196___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_194___);
var ___CSS_LOADER_URL_REPLACEMENT_197___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_195___);
var ___CSS_LOADER_URL_REPLACEMENT_198___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_196___);
var ___CSS_LOADER_URL_REPLACEMENT_199___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_197___);
var ___CSS_LOADER_URL_REPLACEMENT_200___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_198___);
var ___CSS_LOADER_URL_REPLACEMENT_201___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_199___);
var ___CSS_LOADER_URL_REPLACEMENT_202___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_200___);
var ___CSS_LOADER_URL_REPLACEMENT_203___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_201___);
var ___CSS_LOADER_URL_REPLACEMENT_204___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_202___);
var ___CSS_LOADER_URL_REPLACEMENT_205___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_203___);
var ___CSS_LOADER_URL_REPLACEMENT_206___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_204___);
var ___CSS_LOADER_URL_REPLACEMENT_207___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_205___);
var ___CSS_LOADER_URL_REPLACEMENT_208___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_206___);
var ___CSS_LOADER_URL_REPLACEMENT_209___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_207___);
var ___CSS_LOADER_URL_REPLACEMENT_210___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_208___);
var ___CSS_LOADER_URL_REPLACEMENT_211___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_209___);
var ___CSS_LOADER_URL_REPLACEMENT_212___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_210___);
var ___CSS_LOADER_URL_REPLACEMENT_213___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_211___);
var ___CSS_LOADER_URL_REPLACEMENT_214___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_212___);
var ___CSS_LOADER_URL_REPLACEMENT_215___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_213___);
var ___CSS_LOADER_URL_REPLACEMENT_216___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_214___);
var ___CSS_LOADER_URL_REPLACEMENT_217___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_215___);
var ___CSS_LOADER_URL_REPLACEMENT_218___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_216___);
var ___CSS_LOADER_URL_REPLACEMENT_219___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_217___);
var ___CSS_LOADER_URL_REPLACEMENT_220___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_218___);
var ___CSS_LOADER_URL_REPLACEMENT_221___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_219___);
var ___CSS_LOADER_URL_REPLACEMENT_222___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_220___);
var ___CSS_LOADER_URL_REPLACEMENT_223___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_221___);
var ___CSS_LOADER_URL_REPLACEMENT_224___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_222___);
var ___CSS_LOADER_URL_REPLACEMENT_225___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_223___);
var ___CSS_LOADER_URL_REPLACEMENT_226___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_224___);
var ___CSS_LOADER_URL_REPLACEMENT_227___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_225___);
var ___CSS_LOADER_URL_REPLACEMENT_228___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_226___);
var ___CSS_LOADER_URL_REPLACEMENT_229___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_227___);
var ___CSS_LOADER_URL_REPLACEMENT_230___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_228___);
var ___CSS_LOADER_URL_REPLACEMENT_231___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_229___);
var ___CSS_LOADER_URL_REPLACEMENT_232___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_230___);
var ___CSS_LOADER_URL_REPLACEMENT_233___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_231___);
var ___CSS_LOADER_URL_REPLACEMENT_234___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_232___);
var ___CSS_LOADER_URL_REPLACEMENT_235___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_233___);
var ___CSS_LOADER_URL_REPLACEMENT_236___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_234___);
var ___CSS_LOADER_URL_REPLACEMENT_237___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_235___);
var ___CSS_LOADER_URL_REPLACEMENT_238___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_236___);
var ___CSS_LOADER_URL_REPLACEMENT_239___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_237___);
var ___CSS_LOADER_URL_REPLACEMENT_240___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_238___);
var ___CSS_LOADER_URL_REPLACEMENT_241___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_239___);
var ___CSS_LOADER_URL_REPLACEMENT_242___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_240___);
var ___CSS_LOADER_URL_REPLACEMENT_243___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_241___);
var ___CSS_LOADER_URL_REPLACEMENT_244___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_242___);
var ___CSS_LOADER_URL_REPLACEMENT_245___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_243___);
var ___CSS_LOADER_URL_REPLACEMENT_246___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_244___);
var ___CSS_LOADER_URL_REPLACEMENT_247___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_245___);
var ___CSS_LOADER_URL_REPLACEMENT_248___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_246___);
var ___CSS_LOADER_URL_REPLACEMENT_249___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_247___);
var ___CSS_LOADER_URL_REPLACEMENT_250___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_248___);
var ___CSS_LOADER_URL_REPLACEMENT_251___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_249___);
var ___CSS_LOADER_URL_REPLACEMENT_252___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_250___);
var ___CSS_LOADER_URL_REPLACEMENT_253___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_251___);
var ___CSS_LOADER_URL_REPLACEMENT_254___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_252___);
var ___CSS_LOADER_URL_REPLACEMENT_255___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_253___);
var ___CSS_LOADER_URL_REPLACEMENT_256___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_254___);
var ___CSS_LOADER_URL_REPLACEMENT_257___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_255___);
var ___CSS_LOADER_URL_REPLACEMENT_258___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_256___);
var ___CSS_LOADER_URL_REPLACEMENT_259___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_257___);
var ___CSS_LOADER_URL_REPLACEMENT_260___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_258___);
var ___CSS_LOADER_URL_REPLACEMENT_261___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_259___);
var ___CSS_LOADER_URL_REPLACEMENT_262___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_260___);
var ___CSS_LOADER_URL_REPLACEMENT_263___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_261___);
var ___CSS_LOADER_URL_REPLACEMENT_264___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_262___);
var ___CSS_LOADER_URL_REPLACEMENT_265___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_263___);
var ___CSS_LOADER_URL_REPLACEMENT_266___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_264___);
var ___CSS_LOADER_URL_REPLACEMENT_267___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_265___);
var ___CSS_LOADER_URL_REPLACEMENT_268___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_266___);
var ___CSS_LOADER_URL_REPLACEMENT_269___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_267___);
var ___CSS_LOADER_URL_REPLACEMENT_270___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_268___);
var ___CSS_LOADER_URL_REPLACEMENT_271___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_269___);
var ___CSS_LOADER_URL_REPLACEMENT_272___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_270___);
var ___CSS_LOADER_URL_REPLACEMENT_273___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_271___);
var ___CSS_LOADER_URL_REPLACEMENT_274___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_272___);
var ___CSS_LOADER_URL_REPLACEMENT_275___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_273___);
var ___CSS_LOADER_URL_REPLACEMENT_276___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_274___);
var ___CSS_LOADER_URL_REPLACEMENT_277___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_275___);
var ___CSS_LOADER_URL_REPLACEMENT_278___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_276___);
var ___CSS_LOADER_URL_REPLACEMENT_279___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_277___);
var ___CSS_LOADER_URL_REPLACEMENT_280___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_278___);
var ___CSS_LOADER_URL_REPLACEMENT_281___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_279___);
var ___CSS_LOADER_URL_REPLACEMENT_282___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_280___);
var ___CSS_LOADER_URL_REPLACEMENT_283___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_281___);
var ___CSS_LOADER_URL_REPLACEMENT_284___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_282___);
var ___CSS_LOADER_URL_REPLACEMENT_285___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_283___);
var ___CSS_LOADER_URL_REPLACEMENT_286___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_284___);
var ___CSS_LOADER_URL_REPLACEMENT_287___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_285___);
var ___CSS_LOADER_URL_REPLACEMENT_288___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_286___);
var ___CSS_LOADER_URL_REPLACEMENT_289___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_287___);
var ___CSS_LOADER_URL_REPLACEMENT_290___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_288___);
var ___CSS_LOADER_URL_REPLACEMENT_291___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_289___);
var ___CSS_LOADER_URL_REPLACEMENT_292___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_290___);
var ___CSS_LOADER_URL_REPLACEMENT_293___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_291___);
var ___CSS_LOADER_URL_REPLACEMENT_294___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_292___);
var ___CSS_LOADER_URL_REPLACEMENT_295___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_293___);
var ___CSS_LOADER_URL_REPLACEMENT_296___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_294___);
var ___CSS_LOADER_URL_REPLACEMENT_297___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_295___);
var ___CSS_LOADER_URL_REPLACEMENT_298___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_296___);
var ___CSS_LOADER_URL_REPLACEMENT_299___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_297___);
var ___CSS_LOADER_URL_REPLACEMENT_300___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_298___, { hash: "?#iefix&v=4.7.0" });
var ___CSS_LOADER_URL_REPLACEMENT_301___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_299___);
var ___CSS_LOADER_URL_REPLACEMENT_302___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_300___);
var ___CSS_LOADER_URL_REPLACEMENT_303___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_301___);
var ___CSS_LOADER_URL_REPLACEMENT_304___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_302___, { hash: "#fontawesomeregular" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*!
 * Bootstrap  v5.3.8 (https://getbootstrap.com/)
 * Copyright 2011-2025 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root,
[data-bs-theme=light] {
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #0d6efd;
  --bs-secondary: #6c757d;
  --bs-success: #198754;
  --bs-info: #0dcaf0;
  --bs-warning: #ffc107;
  --bs-danger: #dc3545;
  --bs-light: #f8f9fa;
  --bs-dark: #212529;
  --bs-primary-rgb: 13, 110, 253;
  --bs-secondary-rgb: 108, 117, 125;
  --bs-success-rgb: 25, 135, 84;
  --bs-info-rgb: 13, 202, 240;
  --bs-warning-rgb: 255, 193, 7;
  --bs-danger-rgb: 220, 53, 69;
  --bs-light-rgb: 248, 249, 250;
  --bs-dark-rgb: 33, 37, 41;
  --bs-primary-text-emphasis: rgb(2.0392156863%, 17.2549019608%, 39.6862745098%);
  --bs-secondary-text-emphasis: rgb(16.9411764706%, 18.3529411765%, 19.6078431373%);
  --bs-success-text-emphasis: rgb(3.9215686275%, 21.1764705882%, 13.1764705882%);
  --bs-info-text-emphasis: rgb(2.0392156863%, 31.6862745098%, 37.6470588235%);
  --bs-warning-text-emphasis: rgb(40%, 30.2745098039%, 1.0980392157%);
  --bs-danger-text-emphasis: rgb(34.5098039216%, 8.3137254902%, 10.8235294118%);
  --bs-light-text-emphasis: #495057;
  --bs-dark-text-emphasis: #495057;
  --bs-primary-bg-subtle: rgb(81.0196078431%, 88.6274509804%, 99.8431372549%);
  --bs-secondary-bg-subtle: rgb(88.4705882353%, 89.1764705882%, 89.8039215686%);
  --bs-success-bg-subtle: rgb(81.9607843137%, 90.5882352941%, 86.5882352941%);
  --bs-info-bg-subtle: rgb(81.0196078431%, 95.8431372549%, 98.8235294118%);
  --bs-warning-bg-subtle: rgb(100%, 95.137254902%, 80.5490196078%);
  --bs-danger-bg-subtle: rgb(97.2549019608%, 84.1568627451%, 85.4117647059%);
  --bs-light-bg-subtle: rgb(98.6274509804%, 98.8235294118%, 99.0196078431%);
  --bs-dark-bg-subtle: #ced4da;
  --bs-primary-border-subtle: rgb(62.0392156863%, 77.2549019608%, 99.6862745098%);
  --bs-secondary-border-subtle: rgb(76.9411764706%, 78.3529411765%, 79.6078431373%);
  --bs-success-border-subtle: rgb(63.9215686275%, 81.1764705882%, 73.1764705882%);
  --bs-info-border-subtle: rgb(62.0392156863%, 91.6862745098%, 97.6470588235%);
  --bs-warning-border-subtle: rgb(100%, 90.2745098039%, 61.0980392157%);
  --bs-danger-border-subtle: rgb(94.5098039216%, 68.3137254902%, 70.8235294118%);
  --bs-light-border-subtle: #e9ecef;
  --bs-dark-border-subtle: #adb5bd;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #212529;
  --bs-body-color-rgb: 33, 37, 41;
  --bs-body-bg: #fff;
  --bs-body-bg-rgb: 255, 255, 255;
  --bs-emphasis-color: #000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(33, 37, 41, 0.75);
  --bs-secondary-color-rgb: 33, 37, 41;
  --bs-secondary-bg: #e9ecef;
  --bs-secondary-bg-rgb: 233, 236, 239;
  --bs-tertiary-color: rgba(33, 37, 41, 0.5);
  --bs-tertiary-color-rgb: 33, 37, 41;
  --bs-tertiary-bg: #f8f9fa;
  --bs-tertiary-bg-rgb: 248, 249, 250;
  --bs-heading-color: inherit;
  --bs-link-color: #0d6efd;
  --bs-link-color-rgb: 13, 110, 253;
  --bs-link-decoration: underline;
  --bs-link-hover-color: rgb(4.0784313725%, 34.5098039216%, 79.3725490196%);
  --bs-link-hover-color-rgb: 10, 88, 202;
  --bs-code-color: #d63384;
  --bs-highlight-color: #212529;
  --bs-highlight-bg: rgb(100%, 95.137254902%, 80.5490196078%);
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #dee2e6;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.375rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.5rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(13, 110, 253, 0.25);
  --bs-form-valid-color: #198754;
  --bs-form-valid-border-color: #198754;
  --bs-form-invalid-color: #dc3545;
  --bs-form-invalid-border-color: #dc3545;
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color: #dee2e6;
  --bs-body-color-rgb: 222, 226, 230;
  --bs-body-bg: #212529;
  --bs-body-bg-rgb: 33, 37, 41;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(222, 226, 230, 0.75);
  --bs-secondary-color-rgb: 222, 226, 230;
  --bs-secondary-bg: #343a40;
  --bs-secondary-bg-rgb: 52, 58, 64;
  --bs-tertiary-color: rgba(222, 226, 230, 0.5);
  --bs-tertiary-color-rgb: 222, 226, 230;
  --bs-tertiary-bg: rgb(16.6666666667%, 18.6274509804%, 20.5882352941%);
  --bs-tertiary-bg-rgb: 43, 48, 53;
  --bs-primary-text-emphasis: rgb(43.0588235294%, 65.8823529412%, 99.5294117647%);
  --bs-secondary-text-emphasis: rgb(65.4117647059%, 67.5294117647%, 69.4117647059%);
  --bs-success-text-emphasis: rgb(45.8823529412%, 71.7647058824%, 59.7647058824%);
  --bs-info-text-emphasis: rgb(43.0588235294%, 87.5294117647%, 96.4705882353%);
  --bs-warning-text-emphasis: rgb(100%, 85.4117647059%, 41.6470588235%);
  --bs-danger-text-emphasis: rgb(91.7647058824%, 52.4705882353%, 56.2352941176%);
  --bs-light-text-emphasis: #f8f9fa;
  --bs-dark-text-emphasis: #dee2e6;
  --bs-primary-bg-subtle: rgb(1.0196078431%, 8.6274509804%, 19.8431372549%);
  --bs-secondary-bg-subtle: rgb(8.4705882353%, 9.1764705882%, 9.8039215686%);
  --bs-success-bg-subtle: rgb(1.9607843137%, 10.5882352941%, 6.5882352941%);
  --bs-info-bg-subtle: rgb(1.0196078431%, 15.8431372549%, 18.8235294118%);
  --bs-warning-bg-subtle: rgb(20%, 15.137254902%, 0.5490196078%);
  --bs-danger-bg-subtle: rgb(17.2549019608%, 4.1568627451%, 5.4117647059%);
  --bs-light-bg-subtle: #343a40;
  --bs-dark-bg-subtle: #1a1d20;
  --bs-primary-border-subtle: rgb(3.0588235294%, 25.8823529412%, 59.5294117647%);
  --bs-secondary-border-subtle: rgb(25.4117647059%, 27.5294117647%, 29.4117647059%);
  --bs-success-border-subtle: rgb(5.8823529412%, 31.7647058824%, 19.7647058824%);
  --bs-info-border-subtle: rgb(3.0588235294%, 47.5294117647%, 56.4705882353%);
  --bs-warning-border-subtle: rgb(60%, 45.4117647059%, 1.6470588235%);
  --bs-danger-border-subtle: rgb(51.7647058824%, 12.4705882353%, 16.2352941176%);
  --bs-light-border-subtle: #495057;
  --bs-dark-border-subtle: #343a40;
  --bs-heading-color: inherit;
  --bs-link-color: rgb(43.0588235294%, 65.8823529412%, 99.5294117647%);
  --bs-link-hover-color: rgb(54.4470588235%, 72.7058823529%, 99.6235294118%);
  --bs-link-color-rgb: 110, 168, 254;
  --bs-link-hover-color-rgb: 139, 185, 254;
  --bs-code-color: rgb(90.3529411765%, 52%, 71.0588235294%);
  --bs-highlight-color: #dee2e6;
  --bs-highlight-bg: rgb(40%, 30.2745098039%, 1.0980392157%);
  --bs-border-color: #495057;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: rgb(45.8823529412%, 71.7647058824%, 59.7647058824%);
  --bs-form-valid-border-color: rgb(45.8823529412%, 71.7647058824%, 59.7647058824%);
  --bs-form-invalid-color: rgb(91.7647058824%, 52.4705882353%, 56.2352941176%);
  --bs-form-invalid-border-color: rgb(91.7647058824%, 52.4705882353%, 56.2352941176%);
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: var(--bs-heading-color);
}

h1, .h1 {
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.5rem;
  }
}

h2, .h2 {
  font-size: calc(1.325rem + 0.9vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 2rem;
  }
}

h3, .h3 {
  font-size: calc(1.3rem + 0.6vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.75rem;
  }
}

h4, .h4 {
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  h4, .h4 {
    font-size: 1.5rem;
  }
}

h5, .h5 {
  font-size: 1.25rem;
}

h6, .h6 {
  font-size: 1rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.1875em;
  color: var(--bs-highlight-color);
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: underline;
}
a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--bs-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--bs-body-bg);
  background-color: var(--bs-body-color);
  border-radius: 0.25rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-secondary-color);
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  line-height: inherit;
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}
[type=search]::-webkit-search-cancel-button {
  cursor: pointer;
  filter: grayscale(1);
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.625rem + 4.5vw);
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.575rem + 3.9vw);
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.525rem + 3.3vw);
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.475rem + 2.7vw);
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.425rem + 2.1vw);
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #6c757d;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px;
}

.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem;
  }
}
.table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: var(--bs-emphasis-color);
  --bs-table-bg: var(--bs-body-bg);
  --bs-table-border-color: var(--bs-border-color);
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: var(--bs-emphasis-color);
  --bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05);
  --bs-table-active-color: var(--bs-emphasis-color);
  --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1);
  --bs-table-hover-color: var(--bs-emphasis-color);
  --bs-table-hover-bg: rgba(var(--bs-emphasis-color-rgb), 0.075);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: var(--bs-border-width);
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(var(--bs-border-width) * 2) solid currentcolor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: var(--bs-border-width) 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 var(--bs-border-width);
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg);
}

.table-primary {
  --bs-table-color: #000;
  --bs-table-bg: rgb(81.0196078431%, 88.6274509804%, 99.8431372549%);
  --bs-table-border-color: rgb(64.8156862745%, 70.9019607843%, 79.8745098039%);
  --bs-table-striped-bg: rgb(76.968627451%, 84.1960784314%, 94.8509803922%);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(72.9176470588%, 79.7647058824%, 89.8588235294%);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(74.9431372549%, 81.9803921569%, 92.3549019608%);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-secondary {
  --bs-table-color: #000;
  --bs-table-bg: rgb(88.4705882353%, 89.1764705882%, 89.8039215686%);
  --bs-table-border-color: rgb(70.7764705882%, 71.3411764706%, 71.8431372549%);
  --bs-table-striped-bg: rgb(84.0470588235%, 84.7176470588%, 85.3137254902%);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(79.6235294118%, 80.2588235294%, 80.8235294118%);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(81.8352941176%, 82.4882352941%, 83.068627451%);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-success {
  --bs-table-color: #000;
  --bs-table-bg: rgb(81.9607843137%, 90.5882352941%, 86.5882352941%);
  --bs-table-border-color: rgb(65.568627451%, 72.4705882353%, 69.2705882353%);
  --bs-table-striped-bg: rgb(77.862745098%, 86.0588235294%, 82.2588235294%);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(73.7647058824%, 81.5294117647%, 77.9294117647%);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(75.8137254902%, 83.7941176471%, 80.0941176471%);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-info {
  --bs-table-color: #000;
  --bs-table-bg: rgb(81.0196078431%, 95.8431372549%, 98.8235294118%);
  --bs-table-border-color: rgb(64.8156862745%, 76.6745098039%, 79.0588235294%);
  --bs-table-striped-bg: rgb(76.968627451%, 91.0509803922%, 93.8823529412%);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(72.9176470588%, 86.2588235294%, 88.9411764706%);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(74.9431372549%, 88.6549019608%, 91.4117647059%);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-warning {
  --bs-table-color: #000;
  --bs-table-bg: rgb(100%, 95.137254902%, 80.5490196078%);
  --bs-table-border-color: rgb(80%, 76.1098039216%, 64.4392156863%);
  --bs-table-striped-bg: rgb(95%, 90.3803921569%, 76.5215686275%);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(90%, 85.6235294118%, 72.4941176471%);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(92.5%, 88.0019607843%, 74.5078431373%);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-danger {
  --bs-table-color: #000;
  --bs-table-bg: rgb(97.2549019608%, 84.1568627451%, 85.4117647059%);
  --bs-table-border-color: rgb(77.8039215686%, 67.3254901961%, 68.3294117647%);
  --bs-table-striped-bg: rgb(92.3921568627%, 79.9490196078%, 81.1411764706%);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(87.5294117647%, 75.7411764706%, 76.8705882353%);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(89.9607843137%, 77.8450980392%, 79.0058823529%);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-light {
  --bs-table-color: #000;
  --bs-table-bg: #f8f9fa;
  --bs-table-border-color: rgb(77.8039215686%, 78.1176470588%, 78.431372549%);
  --bs-table-striped-bg: rgb(92.3921568627%, 92.7647058824%, 93.137254902%);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(87.5294117647%, 87.8823529412%, 88.2352941176%);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(89.9607843137%, 90.3235294118%, 90.6862745098%);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #212529;
  --bs-table-border-color: rgb(30.3529411765%, 31.6078431373%, 32.862745098%);
  --bs-table-striped-bg: rgb(17.2941176471%, 18.7843137255%, 20.2745098039%);
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: rgb(21.6470588235%, 23.0588235294%, 24.4705882353%);
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: rgb(19.4705882353%, 20.9215686275%, 22.3725490196%);
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.375rem + var(--bs-border-width));
  padding-bottom: calc(0.375rem + var(--bs-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + var(--bs-border-width));
  padding-bottom: calc(0.5rem + var(--bs-border-width));
  font-size: 1.25rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + var(--bs-border-width));
  padding-bottom: calc(0.25rem + var(--bs-border-width));
  font-size: 0.875rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-clip: padding-box;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: var(--bs-body-color);
  background-color: var(--bs-body-bg);
  border-color: rgb(52.5490196078%, 71.568627451%, 99.6078431373%);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder {
  color: var(--bs-secondary-color);
  opacity: 1;
}
.form-control:disabled {
  background-color: var(--bs-secondary-bg);
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  margin-inline-end: 0.75rem;
  color: var(--bs-body-color);
  background-color: var(--bs-tertiary-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: var(--bs-border-width);
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--bs-secondary-bg);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--bs-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: var(--bs-border-width) 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}
.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}
.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
  padding: 0.375rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}
.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}
.form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
.form-control-color.form-control-lg {
  height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: rgb(52.5490196078%, 71.568627451%, 99.6078431373%);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 0.75rem;
  background-image: none;
}
.form-select:disabled {
  background-color: var(--bs-secondary-bg);
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--bs-body-color);
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}

[data-bs-theme=dark] .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.form-check {
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right;
}
.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.5em;
  margin-left: 0;
}

.form-check-input {
  --bs-form-check-bg: var(--bs-body-bg);
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--bs-border-width) solid var(--bs-border-color);
  print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: rgb(52.5490196078%, 71.568627451%, 99.6078431373%);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}
.form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #0d6efd;
  border-color: #0d6efd;
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}
.form-switch .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  width: 2em;
  margin-left: -2.5em;
  background-image: var(--bs-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgb%2852.5490196078%, 71.568627451%, 99.6078431373%%29'/%3e%3c/svg%3e");
}
.form-switch .form-check-input:checked {
  background-position: right center;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}
.form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: rgb(71.5294117647%, 82.9411764706%, 99.7647058824%);
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: rgb(71.5294117647%, 82.9411764706%, 99.7647058824%);
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: var(--bs-secondary-color);
}
.form-range:disabled::-moz-range-thumb {
  background-color: var(--bs-secondary-color);
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  max-width: 100%;
  height: 100%;
  padding: 1rem 0.75rem;
  overflow: hidden;
  color: rgba(var(--bs-body-color-rgb), 0.65);
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: var(--bs-border-width) solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 0.75rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
  padding-left: 0.75rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:-webkit-autofill ~ label {
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > textarea:focus ~ label::after,
.form-floating > textarea:not(:placeholder-shown) ~ label::after {
  position: absolute;
  inset: 1rem 0.375rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: var(--bs-body-bg);
  border-radius: var(--bs-border-radius);
}
.form-floating > textarea:disabled ~ label::after {
  background-color: var(--bs-secondary-bg);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: var(--bs-border-width) 0;
}
.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: #6c757d;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-tertiary-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 3rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(-1 * var(--bs-border-width));
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-valid-color);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-success);
  border-radius: var(--bs-border-radius);
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: var(--bs-form-valid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: var(--bs-form-valid-color);
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: var(--bs-form-valid-color);
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-invalid-color);
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-danger);
  border-radius: var(--bs-border-radius);
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: var(--bs-form-invalid-color);
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: var(--bs-form-invalid-color);
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --bs-btn-padding-x: 0.75rem;
  --bs-btn-padding-y: 0.375rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 1rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: var(--bs-border-width);
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: var(--bs-border-radius);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}
.btn-check + .btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}
.btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked:focus-visible + .btn {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}

.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #0d6efd;
  --bs-btn-border-color: #0d6efd;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(4.3333333333%, 36.6666666667%, 84.3333333333%);
  --bs-btn-hover-border-color: rgb(4.0784313725%, 34.5098039216%, 79.3725490196%);
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(4.0784313725%, 34.5098039216%, 79.3725490196%);
  --bs-btn-active-border-color: rgb(3.8235294118%, 32.3529411765%, 74.4117647059%);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #0d6efd;
  --bs-btn-disabled-border-color: #0d6efd;
}

.btn-secondary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(36%, 39%, 41.6666666667%);
  --bs-btn-hover-border-color: rgb(33.8823529412%, 36.7058823529%, 39.2156862745%);
  --bs-btn-focus-shadow-rgb: 130, 138, 145;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(33.8823529412%, 36.7058823529%, 39.2156862745%);
  --bs-btn-active-border-color: rgb(31.7647058824%, 34.4117647059%, 36.7647058824%);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #6c757d;
  --bs-btn-disabled-border-color: #6c757d;
}

.btn-success {
  --bs-btn-color: #fff;
  --bs-btn-bg: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(8.3333333333%, 45%, 28%);
  --bs-btn-hover-border-color: rgb(7.8431372549%, 42.3529411765%, 26.3529411765%);
  --bs-btn-focus-shadow-rgb: 60, 153, 110;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(7.8431372549%, 42.3529411765%, 26.3529411765%);
  --bs-btn-active-border-color: rgb(7.3529411765%, 39.7058823529%, 24.7058823529%);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #198754;
  --bs-btn-disabled-border-color: #198754;
}

.btn-info {
  --bs-btn-color: #000;
  --bs-btn-bg: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(19.3333333333%, 82.3333333333%, 95%);
  --bs-btn-hover-border-color: rgb(14.5882352941%, 81.2941176471%, 94.7058823529%);
  --bs-btn-focus-shadow-rgb: 11, 172, 204;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(24.0784313725%, 83.3725490196%, 95.2941176471%);
  --bs-btn-active-border-color: rgb(14.5882352941%, 81.2941176471%, 94.7058823529%);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #0dcaf0;
  --bs-btn-disabled-border-color: #0dcaf0;
}

.btn-warning {
  --bs-btn-color: #000;
  --bs-btn-bg: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(100%, 79.3333333333%, 17.3333333333%);
  --bs-btn-hover-border-color: rgb(100%, 78.1176470588%, 12.4705882353%);
  --bs-btn-focus-shadow-rgb: 217, 164, 6;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(100%, 80.5490196078%, 22.1960784314%);
  --bs-btn-active-border-color: rgb(100%, 78.1176470588%, 12.4705882353%);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #ffc107;
  --bs-btn-disabled-border-color: #ffc107;
}

.btn-danger {
  --bs-btn-color: #fff;
  --bs-btn-bg: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(73.3333333333%, 17.6666666667%, 23%);
  --bs-btn-hover-border-color: rgb(69.0196078431%, 16.6274509804%, 21.6470588235%);
  --bs-btn-focus-shadow-rgb: 225, 83, 97;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(69.0196078431%, 16.6274509804%, 21.6470588235%);
  --bs-btn-active-border-color: rgb(64.7058823529%, 15.5882352941%, 20.2941176471%);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #dc3545;
  --bs-btn-disabled-border-color: #dc3545;
}

.btn-light {
  --bs-btn-color: #000;
  --bs-btn-bg: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(82.6666666667%, 83%, 83.3333333333%);
  --bs-btn-hover-border-color: rgb(77.8039215686%, 78.1176470588%, 78.431372549%);
  --bs-btn-focus-shadow-rgb: 211, 212, 213;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(77.8039215686%, 78.1176470588%, 78.431372549%);
  --bs-btn-active-border-color: rgb(72.9411764706%, 73.2352941176%, 73.5294117647%);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #f8f9fa;
  --bs-btn-disabled-border-color: #f8f9fa;
}

.btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(26%, 27.3333333333%, 28.6666666667%);
  --bs-btn-hover-border-color: rgb(21.6470588235%, 23.0588235294%, 24.4705882353%);
  --bs-btn-focus-shadow-rgb: 66, 70, 73;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(30.3529411765%, 31.6078431373%, 32.862745098%);
  --bs-btn-active-border-color: rgb(21.6470588235%, 23.0588235294%, 24.4705882353%);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #212529;
  --bs-btn-disabled-border-color: #212529;
}

.btn-outline-primary {
  --bs-btn-color: #0d6efd;
  --bs-btn-border-color: #0d6efd;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0d6efd;
  --bs-btn-hover-border-color: #0d6efd;
  --bs-btn-focus-shadow-rgb: 13, 110, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0d6efd;
  --bs-btn-active-border-color: #0d6efd;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0d6efd;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0d6efd;
  --bs-gradient: none;
}

.btn-outline-secondary {
  --bs-btn-color: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #6c757d;
  --bs-btn-hover-border-color: #6c757d;
  --bs-btn-focus-shadow-rgb: 108, 117, 125;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #6c757d;
  --bs-btn-active-border-color: #6c757d;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #6c757d;
  --bs-gradient: none;
}

.btn-outline-success {
  --bs-btn-color: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #198754;
  --bs-btn-hover-border-color: #198754;
  --bs-btn-focus-shadow-rgb: 25, 135, 84;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #198754;
  --bs-btn-active-border-color: #198754;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #198754;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #198754;
  --bs-gradient: none;
}

.btn-outline-info {
  --bs-btn-color: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #0dcaf0;
  --bs-btn-hover-border-color: #0dcaf0;
  --bs-btn-focus-shadow-rgb: 13, 202, 240;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #0dcaf0;
  --bs-btn-active-border-color: #0dcaf0;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0dcaf0;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0dcaf0;
  --bs-gradient: none;
}

.btn-outline-warning {
  --bs-btn-color: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ffc107;
  --bs-btn-hover-border-color: #ffc107;
  --bs-btn-focus-shadow-rgb: 255, 193, 7;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ffc107;
  --bs-btn-active-border-color: #ffc107;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffc107;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ffc107;
  --bs-gradient: none;
}

.btn-outline-danger {
  --bs-btn-color: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #dc3545;
  --bs-btn-hover-border-color: #dc3545;
  --bs-btn-focus-shadow-rgb: 220, 53, 69;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #dc3545;
  --bs-btn-active-border-color: #dc3545;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #dc3545;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #dc3545;
  --bs-gradient: none;
}

.btn-outline-light {
  --bs-btn-color: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #f8f9fa;
  --bs-btn-hover-border-color: #f8f9fa;
  --bs-btn-focus-shadow-rgb: 248, 249, 250;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #f8f9fa;
  --bs-btn-active-border-color: #f8f9fa;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f8f9fa;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f8f9fa;
  --bs-gradient: none;
}

.btn-outline-dark {
  --bs-btn-color: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #212529;
  --bs-btn-hover-border-color: #212529;
  --bs-btn-focus-shadow-rgb: 33, 37, 41;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #212529;
  --bs-btn-active-border-color: #212529;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #212529;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #212529;
  --bs-gradient: none;
}

.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: var(--bs-link-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: var(--bs-link-hover-color);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: var(--bs-link-hover-color);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  text-decoration: underline;
}
.btn-link:focus-visible {
  color: var(--bs-btn-color);
}
.btn-link:hover {
  color: var(--bs-btn-hover-color);
}

.btn-lg, .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-padding-x: 1rem;
  --bs-btn-font-size: 1.25rem;
  --bs-btn-border-radius: var(--bs-border-radius-lg);
}

.btn-sm, .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.25rem;
  --bs-btn-padding-x: 0.5rem;
  --bs-btn-font-size: 0.875rem;
  --bs-btn-border-radius: var(--bs-border-radius-sm);
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 1rem;
  --bs-dropdown-color: var(--bs-body-color);
  --bs-dropdown-bg: var(--bs-body-bg);
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-border-radius: var(--bs-border-radius);
  --bs-dropdown-border-width: var(--bs-border-width);
  --bs-dropdown-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width));
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: var(--bs-box-shadow);
  --bs-dropdown-link-color: var(--bs-body-color);
  --bs-dropdown-link-hover-color: var(--bs-body-color);
  --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);
  --bs-dropdown-item-padding-x: 1rem;
  --bs-dropdown-item-padding-y: 0.25rem;
  --bs-dropdown-header-color: #6c757d;
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}
.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropstart .dropdown-toggle::after {
  display: none;
}
.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  background-color: var(--bs-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.875rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
  --bs-dropdown-color: #dee2e6;
  --bs-dropdown-bg: #343a40;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #dee2e6;
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-header-color: #adb5bd;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: var(--bs-border-radius);
}
.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-left: calc(-1 * var(--bs-border-width));
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(-1 * var(--bs-border-width));
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn:nth-child(n+3),
.btn-group-vertical > :not(.btn-check) + .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  text-decoration: none;
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--bs-nav-link-hover-color);
}
.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.nav-link.disabled, .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --bs-nav-tabs-border-width: var(--bs-border-width);
  --bs-nav-tabs-border-color: var(--bs-border-color);
  --bs-nav-tabs-border-radius: var(--bs-border-radius);
  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);
  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);
  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);
  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --bs-nav-pills-border-radius: var(--bs-border-radius);
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #0d6efd;
}
.nav-pills .nav-link {
  border-radius: var(--bs-nav-pills-border-radius);
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
}
.nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--bs-nav-underline-border-width) solid transparent;
}
.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}
.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
  font-weight: 700;
  color: var(--bs-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-grow: 1;
  flex-basis: 0;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.5rem;
  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);
  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);
  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);
  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-padding-y: 0.3125rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.25rem;
  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.25rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);
  --bs-navbar-toggler-border-radius: var(--bs-border-radius);
  --bs-navbar-toggler-focus-width: 0.25rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}
.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
}

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--bs-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}

.navbar-collapse {
  flex-grow: 1;
  flex-basis: 100%;
  align-items: center;
}

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark,
.navbar[data-bs-theme=dark] {
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #fff;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}

[data-bs-theme=dark] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}

.card {
  --bs-card-spacer-y: 1rem;
  --bs-card-spacer-x: 1rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: var(--bs-border-width);
  --bs-card-border-color: var(--bs-border-color-translucent);
  --bs-card-border-radius: var(--bs-border-radius);
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-card-cap-padding-y: 0.5rem;
  --bs-card-cap-padding-x: 1rem;
  --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: var(--bs-body-bg);
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) > .card-img-top,
  .card-group > .card:not(:last-child) > .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) > .card-img-bottom,
  .card-group > .card:not(:last-child) > .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) > .card-img-top,
  .card-group > .card:not(:first-child) > .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) > .card-img-bottom,
  .card-group > .card:not(:first-child) > .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --bs-accordion-color: var(--bs-body-color);
  --bs-accordion-bg: var(--bs-body-bg);
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: var(--bs-border-color);
  --bs-accordion-border-width: var(--bs-border-width);
  --bs-accordion-border-radius: var(--bs-border-radius);
  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: var(--bs-body-color);
  --bs-accordion-btn-bg: var(--bs-accordion-bg);
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  --bs-accordion-btn-icon-width: 1.25rem;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='rgb%282.0392156863%, 17.2549019608%, 39.6862745098%%29' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='m2 5 6 6 6-6'/%3e%3c/svg%3e");
  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: var(--bs-primary-text-emphasis);
  --bs-accordion-active-bg: var(--bs-primary-bg-subtle);
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 1rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}
.accordion-item:first-of-type > .accordion-header .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
.accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:last-of-type > .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush > .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush > .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush > .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush > .accordion-item > .accordion-collapse,
.accordion-flush > .accordion-item > .accordion-header .accordion-button,
.accordion-flush > .accordion-item > .accordion-header .accordion-button.collapsed {
  border-radius: 0;
}

[data-bs-theme=dark] .accordion-button::after {
  --bs-accordion-btn-icon: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='rgb%2843.0588235294%, 65.8823529412%, 99.5294117647%%29'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708'/%3e%3c/svg%3e");
  --bs-accordion-btn-active-icon: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='rgb%2843.0588235294%, 65.8823529412%, 99.5294117647%%29'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708'/%3e%3c/svg%3e");
}

.breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 0;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: var(--bs-secondary-color);
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, "/") /* rtl: var(--bs-breadcrumb-divider, "/") */;
}
.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 1rem;
  --bs-pagination-color: var(--bs-link-color);
  --bs-pagination-bg: var(--bs-body-bg);
  --bs-pagination-border-width: var(--bs-border-width);
  --bs-pagination-border-color: var(--bs-border-color);
  --bs-pagination-border-radius: var(--bs-border-radius);
  --bs-pagination-hover-color: var(--bs-link-hover-color);
  --bs-pagination-hover-bg: var(--bs-tertiary-bg);
  --bs-pagination-hover-border-color: var(--bs-border-color);
  --bs-pagination-focus-color: var(--bs-link-hover-color);
  --bs-pagination-focus-bg: var(--bs-secondary-bg);
  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #0d6efd;
  --bs-pagination-active-border-color: #0d6efd;
  --bs-pagination-disabled-color: var(--bs-secondary-color);
  --bs-pagination-disabled-bg: var(--bs-secondary-bg);
  --bs-pagination-disabled-border-color: var(--bs-border-color);
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  text-decoration: none;
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: calc(-1 * var(--bs-border-width));
}
.page-item:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius);
}
.page-item:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1.25rem;
  --bs-pagination-border-radius: var(--bs-border-radius-lg);
}

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.875rem;
  --bs-pagination-border-radius: var(--bs-border-radius-sm);
}

.badge {
  --bs-badge-padding-x: 0.65em;
  --bs-badge-padding-y: 0.35em;
  --bs-badge-font-size: 0.75em;
  --bs-badge-font-weight: 700;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: var(--bs-border-radius);
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1rem;
  --bs-alert-padding-y: 1rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);
  --bs-alert-border-radius: var(--bs-border-radius);
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
  color: var(--bs-alert-link-color);
}

.alert-dismissible {
  padding-right: 3rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}

.alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis);
}

.alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis);
}

.alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis);
}

.alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis);
}

.alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis);
}

.alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis);
}

.alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis);
}

.alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: var(--bs-progress-height);
  }
}
.progress,
.progress-stacked {
  --bs-progress-height: 1rem;
  --bs-progress-font-size: 0.75rem;
  --bs-progress-bg: var(--bs-secondary-bg);
  --bs-progress-border-radius: var(--bs-border-radius);
  --bs-progress-box-shadow: var(--bs-box-shadow-inset);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: #0d6efd;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  --bs-list-group-color: var(--bs-body-color);
  --bs-list-group-bg: var(--bs-body-bg);
  --bs-list-group-border-color: var(--bs-border-color);
  --bs-list-group-border-width: var(--bs-border-width);
  --bs-list-group-border-radius: var(--bs-border-radius);
  --bs-list-group-item-padding-x: 1rem;
  --bs-list-group-item-padding-y: 0.5rem;
  --bs-list-group-action-color: var(--bs-secondary-color);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);
  --bs-list-group-action-active-color: var(--bs-body-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-bg);
  --bs-list-group-disabled-color: var(--bs-secondary-color);
  --bs-list-group-disabled-bg: var(--bs-body-bg);
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: #0d6efd;
  --bs-list-group-active-border-color: #0d6efd;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  text-decoration: none;
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:not(.active):hover, .list-group-item-action:not(.active):focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}
.list-group-item-action:not(.active):active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);
}

.list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);
}

.list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);
}

.list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);
}

.list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);
}

.list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);
}

.list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);
}

.list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);
}

.btn-close {
  --bs-btn-close-color: #000;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  filter: var(--bs-btn-close-filter);
  border: 0;
  border-radius: 0.375rem;
  opacity: var(--bs-btn-close-opacity);
}
.btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}
.btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}

.btn-close-white {
  --bs-btn-close-filter: invert(1) grayscale(100%) brightness(200%);
}

:root,
[data-bs-theme=light] {
  --bs-btn-close-filter: ;
}

[data-bs-theme=dark] {
  --bs-btn-close-filter: invert(1) grayscale(100%) brightness(200%);
}

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 1.5rem;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-border-width: var(--bs-border-width);
  --bs-toast-border-color: var(--bs-border-color-translucent);
  --bs-toast-border-radius: var(--bs-border-radius);
  --bs-toast-box-shadow: var(--bs-box-shadow);
  --bs-toast-header-color: var(--bs-secondary-color);
  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-header-border-color: var(--bs-border-color-translucent);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}
.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: var(--bs-body-color);
  --bs-modal-bg: var(--bs-body-bg);
  --bs-modal-border-color: var(--bs-border-color-translucent);
  --bs-modal-border-width: var(--bs-border-width);
  --bs-modal-border-radius: var(--bs-border-radius-lg);
  --bs-modal-box-shadow: var(--bs-box-shadow-sm);
  --bs-modal-inner-border-radius: calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: var(--bs-border-color);
  --bs-modal-header-border-width: var(--bs-border-width);
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: var(--bs-border-width);
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transform: translate(0, -50px);
  transition: transform 0.3s ease-out;
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #000;
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--bs-modal-header-padding-y));
  margin-right: calc(-0.5 * var(--bs-modal-header-padding-x));
  margin-bottom: calc(-0.5 * var(--bs-modal-header-padding-y));
  margin-left: auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: var(--bs-box-shadow);
  }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --bs-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 0.5rem;
  --bs-tooltip-padding-y: 0.25rem;
  --bs-tooltip-margin: ;
  --bs-tooltip-font-size: 0.875rem;
  --bs-tooltip-color: var(--bs-body-bg);
  --bs-tooltip-bg: var(--bs-emphasis-color);
  --bs-tooltip-border-radius: var(--bs-border-radius);
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 0.875rem;
  --bs-popover-bg: var(--bs-body-bg);
  --bs-popover-border-width: var(--bs-border-width);
  --bs-popover-border-color: var(--bs-border-color-translucent);
  --bs-popover-border-radius: var(--bs-border-radius-lg);
  --bs-popover-inner-border-radius: calc(var(--bs-border-radius-lg) - var(--bs-border-width));
  --bs-popover-box-shadow: var(--bs-box-shadow);
  --bs-popover-header-padding-x: 1rem;
  --bs-popover-header-padding-y: 0.5rem;
  --bs-popover-header-font-size: 1rem;
  --bs-popover-header-color: inherit;
  --bs-popover-header-bg: var(--bs-secondary-bg);
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 1rem;
  --bs-popover-body-color: var(--bs-body-color);
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
}
.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  filter: var(--bs-carousel-control-icon-filter);
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/%3e%3c/svg%3e")*/;
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/%3e%3c/svg%3e")*/;
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: var(--bs-carousel-indicator-active-bg);
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: var(--bs-carousel-caption-color);
  text-align: center;
}

.carousel-dark {
  --bs-carousel-indicator-active-bg: #000;
  --bs-carousel-caption-color: #000;
  --bs-carousel-control-icon-filter: invert(1) grayscale(100);
}

:root,
[data-bs-theme=light] {
  --bs-carousel-indicator-active-bg: #fff;
  --bs-carousel-caption-color: #fff;
  --bs-carousel-control-icon-filter: ;
}

[data-bs-theme=dark] {
  --bs-carousel-indicator-active-bg: #000;
  --bs-carousel-caption-color: #000;
  --bs-carousel-control-icon-filter: invert(1) grayscale(100);
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  flex-shrink: 0;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: var(--bs-body-bg);
  --bs-offcanvas-border-width: var(--bs-border-width);
  --bs-offcanvas-border-color: var(--bs-border-color-translucent);
  --bs-offcanvas-box-shadow: var(--bs-box-shadow-sm);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}
.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-right: calc(-0.5 * var(--bs-offcanvas-padding-x));
  margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-left: auto;
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #000 !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #000 !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #000 !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(10, 88, 202, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(10, 88, 202, var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(86, 94, 100, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(86, 94, 100, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(20, 108, 67, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(20, 108, 67, var(--bs-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: RGBA(61, 213, 243, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(61, 213, 243, var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(255, 205, 57, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 205, 57, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(176, 42, 55, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(176, 42, 55, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: RGBA(249, 250, 251, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(249, 250, 251, var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(26, 30, 33, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(26, 30, 33, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}
.visually-hidden *,
.visually-hidden-focusable:not(:focus):not(:focus-within) * {
  overflow: hidden !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: var(--bs-box-shadow) !important;
}

.shadow-sm {
  box-shadow: var(--bs-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: var(--bs-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 3rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1.5rem !important;
}

.column-gap-5 {
  column-gap: 3rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.375rem + 1.5vw) !important;
}

.fs-2 {
  font-size: calc(1.325rem + 0.9vw) !important;
}

.fs-3 {
  font-size: calc(1.3rem + 0.6vw) !important;
}

.fs-4 {
  font-size: calc(1.275rem + 0.3vw) !important;
}

.fs-5 {
  font-size: 1.25rem !important;
}

.fs-6 {
  font-size: 1rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --bs-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}

.link-opacity-25 {
  --bs-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}

.link-opacity-50 {
  --bs-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}

.link-opacity-75 {
  --bs-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}

.link-opacity-100 {
  --bs-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 1rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 3rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-3 {
    row-gap: 1rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-5 {
    row-gap: 3rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-md-3 {
    column-gap: 1rem !important;
  }
  .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-5 {
    column-gap: 3rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 1rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 3rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 3rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.5rem !important;
  }
  .fs-2 {
    font-size: 2rem !important;
  }
  .fs-3 {
    font-size: 1.75rem !important;
  }
  .fs-4 {
    font-size: 1.5rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
/*! -----------------------------------------------------------------------------------

    Template Name: Cuba Admin
    Template URI: http://admin.pixelstrap.com/cuba/theme
    Description: This is Admin theme
    Author: Pixelstrap
    Author URI: https://themeforest.net/user/pixelstrap

-----------------------------------------------------------------------------------


 */
:root {
  --theme-default: #7366ff;
  --theme-secondary: #f73164;
  --light-background: rgba(242, 243, 247, 0.7);
  --body-font-color: #2f2f3b;
  --chart-border: #ecf3fa;
  --recent-chart-bg: #fcfcfd;
  --light-bg: #f6f7f9;
  --white: #fff;
  --light2: #f5f6f9;
  --sidebar-border: rgba(0, 0, 0, 0.1);
  --chart-text-color: rgba(82, 82, 108, 0.8);
  --recent-dashed-border: rgba(82, 82, 108, 0.3);
  --chart-dashed-border: rgba(82, 82, 108, 0.2);
  --chart-progress-light: rgba(82, 82, 108, 0.1);
  --recent-box-bg: #f2f4f7;
  --recent-border: rgba(97, 101, 122, 0.25);
  --course-light-btn: #f2f3f7;
  --course-bg: #f7f7f7;
  --balance-profie-bg: #e0dfef;
  --view-grid-bg: #ecf3fa80;
  --view-border-marker: #cfcdfc;
  --fc-button-bg-color: var(--theme-default);
  --fc-button-active-bg-color: var(--theme-default);
  --fc-button-active-border-color: var(--theme-default);
  --fc-button-border-color: var(--theme-default);
  --fc-button-hover-bg-color: var(--theme-default);
  --fc-button-hover-border-color: var(--theme-default);
}

body[class=dark-only],
body.dark-only {
  --light-background: rgba(31, 32, 40, 0.65);
  --recent-chart-bg: #262932;
  --light-bg: #1d1e26;
  --white: #262932;
  --sidebar-border: rgba(255, 255, 255, 0.1);
  --light2: #1d1e26;
  --chart-border: #374558;
  --recent-box-bg: #1d1e26;
  --recent-border: #374558;
  --body-font-color: rgba(255, 255, 255, 0.6);
  --course-light-btn: var(--light-bg);
  --view-grid-bg: var(--light-bg);
  --view-border-marker: #2c2c45d4;
  -semi-dark: #1d1e26;
}

/**=====================
     Reset css start
==========================**/
.font-roboto {
  font-family: Roboto, sans-serif;
}

.f-light {
  color: rgba(82, 82, 108, 0.8);
}

svg.f-light {
  fill: #52526c;
  opacity: 0.8;
}

.light-card {
  background-color: var(--light-background);
}

.light-background {
  background-color: var(--light-bg);
}

.icon-arrow-down.icon-rotate,
.icon-arrow-up.icon-rotate {
  transform: rotate(-45deg);
  display: inline-block;
}

/*====== Padding css starts ======*/
.p-0 {
  padding: 0px;
}

.p-5 {
  padding: 5px;
}

.p-10 {
  padding: 10px;
}

.p-15 {
  padding: 15px;
}

.p-20 {
  padding: 20px;
}

.p-25 {
  padding: 25px;
}

.p-30 {
  padding: 30px;
}

.p-35 {
  padding: 35px;
}

.p-40 {
  padding: 40px;
}

.p-45 {
  padding: 45px;
}

.p-50 {
  padding: 50px;
}

/*====== Padding css ends ======*/
/*====== Padding-left css starts ======*/
.p-l-0 {
  padding-left: 0px;
}

.p-l-5 {
  padding-left: 5px;
}

.p-l-10 {
  padding-left: 10px;
}

.p-l-15 {
  padding-left: 15px;
}

.p-l-20 {
  padding-left: 20px;
}

.p-l-25 {
  padding-left: 25px;
}

.p-l-30 {
  padding-left: 30px;
}

.p-l-35 {
  padding-left: 35px;
}

.p-l-40 {
  padding-left: 40px;
}

.p-l-45 {
  padding-left: 45px;
}

.p-l-50 {
  padding-left: 50px;
}

/*====== Padding-left css ends ======*/
/*====== Padding-top css starts ======*/
.p-t-0 {
  padding-top: 0px !important;
}

.p-t-5 {
  padding-top: 5px !important;
}

.p-t-10 {
  padding-top: 10px !important;
}

.p-t-15 {
  padding-top: 15px !important;
}

.p-t-20 {
  padding-top: 20px !important;
}

.p-t-25 {
  padding-top: 25px !important;
}

.p-t-30 {
  padding-top: 30px !important;
}

.p-t-35 {
  padding-top: 35px !important;
}

.p-t-40 {
  padding-top: 40px !important;
}

.p-t-45 {
  padding-top: 45px !important;
}

.p-t-50 {
  padding-top: 50px !important;
}

/*====== Padding-top css ends ======*/
/*====== Padding-bottom css starts ======*/
.p-b-0 {
  padding-bottom: 0px !important;
}

.p-b-5 {
  padding-bottom: 5px !important;
}

.p-b-10 {
  padding-bottom: 10px !important;
}

.p-b-15 {
  padding-bottom: 15px !important;
}

.p-b-20 {
  padding-bottom: 20px !important;
}

.p-b-25 {
  padding-bottom: 25px !important;
}

.p-b-30 {
  padding-bottom: 30px !important;
}

.p-b-35 {
  padding-bottom: 35px !important;
}

.p-b-40 {
  padding-bottom: 40px !important;
}

.p-b-45 {
  padding-bottom: 45px !important;
}

.p-b-50 {
  padding-bottom: 50px !important;
}

/*====== Padding-bottom css ends ======*/
/*====== Padding-right css starts ======*/
.p-r-0 {
  padding-right: 0px;
}

.p-r-5 {
  padding-right: 5px;
}

.p-r-10 {
  padding-right: 10px;
}

.p-r-15 {
  padding-right: 15px;
}

.p-r-20 {
  padding-right: 20px;
}

.p-r-25 {
  padding-right: 25px;
}

.p-r-30 {
  padding-right: 30px;
}

.p-r-35 {
  padding-right: 35px;
}

.p-r-40 {
  padding-right: 40px;
}

.p-r-45 {
  padding-right: 45px;
}

.p-r-50 {
  padding-right: 50px;
}

/*====== Padding-right css ends ======*/
/*====== Margin css starts ======*/
.m-0 {
  margin: 0px !important;
}

.m-5 {
  margin: 5px !important;
}

.m-10 {
  margin: 10px !important;
}

.m-15 {
  margin: 15px !important;
}

.m-20 {
  margin: 20px !important;
}

.m-25 {
  margin: 25px !important;
}

.m-30 {
  margin: 30px !important;
}

.m-35 {
  margin: 35px !important;
}

.m-40 {
  margin: 40px !important;
}

.m-45 {
  margin: 45px !important;
}

.m-50 {
  margin: 50px !important;
}

/*====== Margin css ends ======*/
/*====== Margin-top css starts ======*/
.m-t-0 {
  margin-top: 0px !important;
}

.m-t-5 {
  margin-top: 5px !important;
}

.m-t-10 {
  margin-top: 10px !important;
}

.m-t-15 {
  margin-top: 15px !important;
}

.m-t-20 {
  margin-top: 20px !important;
}

.m-t-25 {
  margin-top: 25px !important;
}

.m-t-30 {
  margin-top: 30px !important;
}

.m-t-35 {
  margin-top: 35px !important;
}

.m-t-40 {
  margin-top: 40px !important;
}

.m-t-45 {
  margin-top: 45px !important;
}

.m-t-50 {
  margin-top: 50px !important;
}

/*====== Margin-top css ends ======*/
/*====== Margin-Bottom css starts ======*/
.m-b-0 {
  margin-bottom: 0px !important;
}

.m-b-5 {
  margin-bottom: 5px !important;
}

.m-b-10 {
  margin-bottom: 10px !important;
}

.m-b-15 {
  margin-bottom: 15px !important;
}

.m-b-20 {
  margin-bottom: 20px !important;
}

.m-b-25 {
  margin-bottom: 25px !important;
}

.m-b-30 {
  margin-bottom: 30px !important;
}

.m-b-35 {
  margin-bottom: 35px !important;
}

.m-b-40 {
  margin-bottom: 40px !important;
}

.m-b-45 {
  margin-bottom: 45px !important;
}

.m-b-50 {
  margin-bottom: 50px !important;
}

/*====== Margin-Bottom css ends ======*/
/*====== Margin-left css starts ======*/
.m-l-0 {
  margin-left: 0px !important;
}

.m-l-5 {
  margin-left: 5px !important;
}

.m-l-10 {
  margin-left: 10px !important;
}

.m-l-15 {
  margin-left: 15px !important;
}

.m-l-20 {
  margin-left: 20px !important;
}

.m-l-25 {
  margin-left: 25px !important;
}

.m-l-30 {
  margin-left: 30px !important;
}

.m-l-35 {
  margin-left: 35px !important;
}

.m-l-40 {
  margin-left: 40px !important;
}

.m-l-45 {
  margin-left: 45px !important;
}

.m-l-50 {
  margin-left: 50px !important;
}

/*====== Margin-left css ends ======*/
/*====== Margin-right css starts ======*/
.m-r-0 {
  margin-right: 0px;
}

.m-r-5 {
  margin-right: 5px;
}

.m-r-10 {
  margin-right: 10px;
}

.m-r-15 {
  margin-right: 15px;
}

.m-r-20 {
  margin-right: 20px;
}

.m-r-25 {
  margin-right: 25px;
}

.m-r-30 {
  margin-right: 30px;
}

.m-r-35 {
  margin-right: 35px;
}

.m-r-40 {
  margin-right: 40px;
}

.m-r-45 {
  margin-right: 45px;
}

.m-r-50 {
  margin-right: 50px;
}

/*====== Margin-right css ends ======*/
/*====== Border-radius css starts ======*/
.b-r-0 {
  border-radius: 0px !important;
}

.b-r-1 {
  border-radius: 1px !important;
}

.b-r-2 {
  border-radius: 2px !important;
}

.b-r-3 {
  border-radius: 3px !important;
}

.b-r-4 {
  border-radius: 4px !important;
}

.b-r-5 {
  border-radius: 5px !important;
}

.b-r-6 {
  border-radius: 6px !important;
}

.b-r-7 {
  border-radius: 7px !important;
}

.b-r-8 {
  border-radius: 8px !important;
}

.b-r-9 {
  border-radius: 9px !important;
}

.b-r-10 {
  border-radius: 10px !important;
}

/*====== Border-radius css ends ======*/
/*====== Font-size css starts ======*/
.f-12 {
  font-size: 12px !important;
}

.f-14 {
  font-size: 14px !important;
}

.f-16 {
  font-size: 16px !important;
}

.f-18 {
  font-size: 18px !important;
}

.f-20 {
  font-size: 20px !important;
}

.f-22 {
  font-size: 22px !important;
}

.f-24 {
  font-size: 24px !important;
}

.f-26 {
  font-size: 26px !important;
}

.f-28 {
  font-size: 28px !important;
}

.f-30 {
  font-size: 30px !important;
}

.f-32 {
  font-size: 32px !important;
}

.f-34 {
  font-size: 34px !important;
}

.f-36 {
  font-size: 36px !important;
}

.f-38 {
  font-size: 38px !important;
}

.f-40 {
  font-size: 40px !important;
}

.f-42 {
  font-size: 42px !important;
}

.f-44 {
  font-size: 44px !important;
}

.f-46 {
  font-size: 46px !important;
}

.f-48 {
  font-size: 48px !important;
}

.f-50 {
  font-size: 50px !important;
}

.f-52 {
  font-size: 52px !important;
}

.f-54 {
  font-size: 54px !important;
}

.f-56 {
  font-size: 56px !important;
}

.f-58 {
  font-size: 58px !important;
}

.f-60 {
  font-size: 60px !important;
}

.f-62 {
  font-size: 62px !important;
}

.f-64 {
  font-size: 64px !important;
}

.f-66 {
  font-size: 66px !important;
}

.f-68 {
  font-size: 68px !important;
}

.f-70 {
  font-size: 70px !important;
}

.f-72 {
  font-size: 72px !important;
}

.f-74 {
  font-size: 74px !important;
}

.f-76 {
  font-size: 76px !important;
}

.f-78 {
  font-size: 78px !important;
}

.f-80 {
  font-size: 80px !important;
}

.f-82 {
  font-size: 82px !important;
}

.f-84 {
  font-size: 84px !important;
}

.f-86 {
  font-size: 86px !important;
}

.f-88 {
  font-size: 88px !important;
}

.f-90 {
  font-size: 90px !important;
}

.f-92 {
  font-size: 92px !important;
}

.f-94 {
  font-size: 94px !important;
}

.f-96 {
  font-size: 96px !important;
}

.f-98 {
  font-size: 98px !important;
}

.f-100 {
  font-size: 100px !important;
}

/*====== Font-size css ends ======*/
/*====== Font-weight css starts ======*/
.f-w-100 {
  font-weight: 100;
}

.f-w-300 {
  font-weight: 300;
}

.f-w-500 {
  font-weight: 500;
}

.f-w-400 {
  font-weight: 400;
}

.f-w-600 {
  font-weight: 600;
}

.f-w-700 {
  font-weight: 700;
}

.f-w-900 {
  font-weight: 900;
}

/*====== Font-weight css ends ======*/
/*====== Font-style css starts ======*/
.f-s-normal {
  font-style: normal;
}

.f-s-italic {
  font-style: italic;
}

.f-s-oblique {
  font-style: oblique;
}

.f-s-initial {
  font-style: initial;
}

.f-s-inherit {
  font-style: inherit;
}

/*====== Font-style css ends ======*/
/*====== Text-Decoration css starts ======*/
.text-overline {
  text-decoration: overline;
}

.text-line-through {
  text-decoration: line-through;
}

.text-underline {
  text-decoration: underline;
}

.text-dashed {
  text-decoration: dashed;
}

.text-blink {
  text-decoration: blink;
}

.text-dotted {
  text-decoration: dotted;
}

.text-initial {
  text-decoration: initial;
}

.text-none {
  text-decoration: none;
}

.text-solid {
  text-decoration: solid;
}

.text-wavy {
  text-decoration: wavy;
}

.text-inherit {
  text-decoration: inherit;
}

.text-double {
  text-decoration: double;
}

/*====== Text-Decoration css ends ======*/
/*====== Vertical-Align css starts ======*/
.baseline {
  vertical-align: baseline;
}

.sub {
  vertical-align: sub;
}

.super {
  vertical-align: super;
}

.top {
  vertical-align: top;
}

.text-top {
  vertical-align: text-top;
}

.middle {
  vertical-align: middle;
}

.bottom {
  vertical-align: bottom;
}

.text-bottom {
  vertical-align: text-bottom;
}

.initial {
  vertical-align: initial;
}

.inherit {
  vertical-align: inherit;
}

/*====== Vertical-Align css ends ======*/
/*====== Position css starts ======*/
.p-static {
  position: static;
}

.p-absolute {
  position: absolute;
}

.p-fixed {
  position: fixed;
}

.p-relative {
  position: relative;
}

.p-initial {
  position: initial;
}

.p-inherit {
  position: inherit;
}

/*====== Position css ends ======*/
/*====== Float css starts ======*/
.f-left {
  float: left;
}

.f-right {
  float: right;
}

.f-none {
  float: none;
}

/*====== Float css ends ======*/
/*====== Overflow css starts ======*/
.o-hidden {
  overflow: hidden;
}

.o-visible {
  overflow: visible;
}

.o-auto {
  overflow: auto;
}

/*====== Overflow css ends ======*/
/*====== Image-sizes css starts ======*/
.img-10 {
  width: 10px !important;
}

.img-20 {
  width: 20px !important;
}

.img-30 {
  width: 30px !important;
}

.img-40 {
  width: 40px !important;
}

.img-50 {
  width: 50px !important;
}

.img-60 {
  width: 60px !important;
}

.img-70 {
  width: 70px !important;
}

.img-80 {
  width: 80px !important;
}

.img-90 {
  width: 90px !important;
}

.img-100 {
  width: 100px !important;
}

/*====== Image-sizes css ends ======*/
/*======= Text css starts ===========*/
.font-primary {
  color: #7366ff !important;
}

.font-secondary {
  color: #ff3364 !important;
}

.font-success {
  color: #54ba4a !important;
}

.font-danger {
  color: #fc4438 !important;
}

.font-info {
  color: #16c7f9 !important;
}

.font-light {
  color: #f4f4f4 !important;
}

.font-dark {
  color: #2c323f !important;
}

.font-warning {
  color: #ffaa05 !important;
}

.font-primary {
  color: var(--theme-default) !important;
}

.font-secondary {
  color: var(--theme-secondary) !important;
}

/*======= Text css ends ===========*/
/*======= Label-color css starts  ======= */
.label {
  border-radius: 2px;
  color: #fff;
  font-size: 12px;
  line-height: 1;
  margin-bottom: 0;
  text-transform: capitalize;
}

.label-theme {
  background-color: #7366ff;
}

.label-primary {
  background-color: #7366ff;
}

.label-secondary {
  background-color: #ff3364;
}

.label-success {
  background-color: #54ba4a;
}

.label-danger {
  background-color: #fc4438;
}

.label-info {
  background-color: #16c7f9;
}

.label-light {
  background-color: #f4f4f4;
}

.label-dark {
  background-color: #2c323f;
}

.label-warning {
  background-color: #ffaa05;
}

/*======= Label-color css ends  ======= */
/*======= Badge-color css starts  ======= */
.badge-primary {
  background-color: #7366ff;
}

.badge-secondary {
  background-color: #ff3364;
}

.badge-success {
  background-color: #54ba4a;
}

.badge-danger {
  background-color: #fc4438;
}

.badge-info {
  background-color: #16c7f9;
}

.badge-light {
  background-color: #f4f4f4;
}

.badge-dark {
  background-color: #2c323f;
}

.badge-warning {
  background-color: #ffaa05;
}

.badge-primary {
  background-color: var(--theme-default) !important;
}

.badge-secondary {
  background-color: var(--theme-secondary) !important;
}

/*======= Badge-color css end  ======= */
/*======= Background-color css starts  ======= */
.bg-primary {
  background-color: #7366ff !important;
  color: #fff;
}

.bg-light-primary {
  background-color: rgba(115, 102, 255, 0.1) !important;
  color: #fff;
}

.bg-secondary {
  background-color: #ff3364 !important;
  color: #fff;
}

.bg-light-secondary {
  background-color: rgba(255, 51, 100, 0.1) !important;
  color: #fff;
}

.bg-success {
  background-color: #54ba4a !important;
  color: #fff;
}

.bg-light-success {
  background-color: rgba(84, 186, 74, 0.1) !important;
  color: #fff;
}

.bg-danger {
  background-color: #fc4438 !important;
  color: #fff;
}

.bg-light-danger {
  background-color: rgba(252, 68, 56, 0.1) !important;
  color: #fff;
}

.bg-info {
  background-color: #16c7f9 !important;
  color: #fff;
}

.bg-light-info {
  background-color: rgba(22, 199, 249, 0.1) !important;
  color: #fff;
}

.bg-light {
  background-color: #f4f4f4 !important;
  color: #fff;
}

.bg-light-light {
  background-color: rgba(244, 244, 244, 0.1) !important;
  color: #fff;
}

.bg-dark {
  background-color: #2c323f !important;
  color: #fff;
}

.bg-light-dark {
  background-color: rgba(44, 50, 63, 0.1) !important;
  color: #fff;
}

.bg-warning {
  background-color: #ffaa05 !important;
  color: #fff;
}

.bg-light-warning {
  background-color: rgba(255, 170, 5, 0.1) !important;
  color: #fff;
}

.bg-primary {
  background-color: var(--theme-default) !important;
}

.bg-secondary {
  background-color: var(--theme-secondary) !important;
}

/*======= Background-color css end  ======= */
/*======= Font-color css starts  ======= */
.txt-primary {
  color: #7366ff !important;
}

.txt-secondary {
  color: #ff3364 !important;
}

.txt-success {
  color: #54ba4a !important;
}

.txt-danger {
  color: #fc4438 !important;
}

.txt-info {
  color: #16c7f9 !important;
}

.txt-light {
  color: #f4f4f4 !important;
}

.txt-dark {
  color: #2c323f !important;
}

.txt-warning {
  color: #ffaa05 !important;
}

.txt-google-plus {
  color: #c64e40 !important;
}

.txt-twitter {
  color: #6fa2d8 !important;
}

.txt-linkedin {
  color: #0077b5 !important;
}

.txt-fb {
  color: #50598e !important;
}

.txt-primary {
  color: var(--theme-default) !important;
}

.txt-secondary {
  color: var(--theme-secondary) !important;
}

/*======= Font-color css end  ======= */
/*======= Button-color css starts  ======= */
@keyframes push {
  50% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
}
.btn-primary {
  background-color: #7366ff !important;
  border-color: #7366ff !important;
  -webkit-tap-highlight-color: transparent;
  transform: translateZ(0);
}
.btn-primary.disabled, .btn-primary:disabled {
  background-color: #7366ff !important;
  border-color: #7366ff !important;
}
.btn-primary:focus {
  box-shadow: 0 0 0 0.2rem white;
}

.btn-secondary {
  background-color: #ff3364 !important;
  border-color: #ff3364 !important;
  -webkit-tap-highlight-color: transparent;
  transform: translateZ(0);
}
.btn-secondary.disabled, .btn-secondary:disabled {
  background-color: #ff3364 !important;
  border-color: #ff3364 !important;
}
.btn-secondary:focus {
  box-shadow: 0 0 0 0.2rem rgb(100%, 80%, 84.8039215686%);
}

.btn-success {
  background-color: #54ba4a !important;
  border-color: #54ba4a !important;
  -webkit-tap-highlight-color: transparent;
  transform: translateZ(0);
}
.btn-success.disabled, .btn-success:disabled {
  background-color: #54ba4a !important;
  border-color: #54ba4a !important;
}
.btn-success:focus {
  box-shadow: 0 0 0 0.2rem rgb(73.9811764706%, 89.5011764706%, 72.4596078431%);
}

.btn-danger {
  background-color: #fc4438 !important;
  border-color: #fc4438 !important;
  -webkit-tap-highlight-color: transparent;
  transform: translateZ(0);
}
.btn-danger.disabled, .btn-danger:disabled {
  background-color: #fc4438 !important;
  border-color: #fc4438 !important;
}
.btn-danger:focus {
  box-shadow: 0 0 0 0.2rem rgb(99.7146185207%, 82.2112211221%, 81.0696952048%);
}

.btn-info {
  background-color: #16c7f9 !important;
  border-color: #16c7f9 !important;
  -webkit-tap-highlight-color: transparent;
  transform: translateZ(0);
  color: #fff;
}
.btn-info:hover, .btn-info:focus, .btn-info:active, .btn-info.active {
  color: #fff;
}
.btn-info.disabled, .btn-info:disabled {
  background-color: #16c7f9 !important;
  border-color: #16c7f9 !important;
}
.btn-info:focus {
  box-shadow: 0 0 0 0.2rem rgb(67.1211748298%, 92.0977930921%, 99.1533349742%);
}

.btn-light {
  background-color: #f4f4f4 !important;
  border-color: #f4f4f4 !important;
  -webkit-tap-highlight-color: transparent;
  transform: translateZ(0);
}
.btn-light.disabled, .btn-light:disabled {
  background-color: #f4f4f4 !important;
  border-color: #f4f4f4 !important;
}
.btn-light:focus {
  box-shadow: 0 0 0 0.2rem white;
}

.btn-dark {
  background-color: #2c323f !important;
  border-color: #2c323f !important;
  -webkit-tap-highlight-color: transparent;
  transform: translateZ(0);
}
.btn-dark.disabled, .btn-dark:disabled {
  background-color: #2c323f !important;
  border-color: #2c323f !important;
}
.btn-dark:focus {
  box-shadow: 0 0 0 0.2rem rgb(42.2759758109%, 47.7735019241%, 59.6848085028%);
}

.btn-warning {
  background-color: #ffaa05 !important;
  border-color: #ffaa05 !important;
  -webkit-tap-highlight-color: transparent;
  transform: translateZ(0);
}
.btn-warning.disabled, .btn-warning:disabled {
  background-color: #ffaa05 !important;
  border-color: #ffaa05 !important;
}
.btn-warning:focus {
  box-shadow: 0 0 0 0.2rem rgb(100%, 87.0666666667%, 61.9607843137%);
}

.btn-light {
  background-color: rgba(115, 102, 255, 0.06) !important;
  border-color: rgba(115, 102, 255, 0.06) !important;
}
.btn-light:hover {
  background-color: rgba(115, 102, 255, 0.1) !important;
  border-color: rgba(115, 102, 255, 0.1) !important;
}

.btn-primary {
  background-color: var(--theme-default) !important;
  border-color: var(--theme-default) !important;
}

.btn-secondary {
  background-color: var(--theme-secondary) !important;
  border-color: var(--theme-secondary) !important;
}

.btn-hover-effect:hover {
  animation: push 0.5s linear 1;
}

/*======= Button-color css ends  ======= */
.btn-outline-primary-2x {
  border-width: 2px;
  border-color: #7366ff;
  color: #7366ff;
  background-color: transparent;
}
.btn-outline-primary-2x:hover, .btn-outline-primary-2x:focus, .btn-outline-primary-2x:active, .btn-outline-primary-2x.active {
  color: white;
  background-color: rgb(26.7973856209%, 20%, 100%) !important;
  border-color: rgb(26.7973856209%, 20%, 100%) !important;
  box-shadow: none;
}

.btn-outline-secondary-2x {
  border-width: 2px;
  border-color: #ff3364;
  color: #ff3364;
  background-color: transparent;
}
.btn-outline-secondary-2x:hover, .btn-outline-secondary-2x:focus, .btn-outline-secondary-2x:active, .btn-outline-secondary-2x.active {
  color: white;
  background-color: rgb(100%, 0%, 24.0196078431%) !important;
  border-color: rgb(100%, 0%, 24.0196078431%) !important;
  box-shadow: none;
}

.btn-outline-success-2x {
  border-width: 2px;
  border-color: #54ba4a;
  color: #54ba4a;
  background-color: transparent;
}
.btn-outline-success-2x:hover, .btn-outline-success-2x:focus, .btn-outline-success-2x:active, .btn-outline-success-2x.active {
  color: white;
  background-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%) !important;
  border-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%) !important;
  box-shadow: none;
}

.btn-outline-danger-2x {
  border-width: 2px;
  border-color: #fc4438;
  color: #fc4438;
  background-color: transparent;
}
.btn-outline-danger-2x:hover, .btn-outline-danger-2x:focus, .btn-outline-danger-2x:active, .btn-outline-danger-2x.active {
  color: white;
  background-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%) !important;
  border-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%) !important;
  box-shadow: none;
}

.btn-outline-info-2x {
  border-width: 2px;
  border-color: #16c7f9;
  color: #16c7f9;
  background-color: transparent;
}
.btn-outline-info-2x:hover, .btn-outline-info-2x:focus, .btn-outline-info-2x:active, .btn-outline-info-2x.active {
  color: white;
  background-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%) !important;
  border-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%) !important;
  box-shadow: none;
}

.btn-outline-light-2x {
  border-width: 2px;
  border-color: #f4f4f4;
  color: #f4f4f4;
  background-color: transparent;
}
.btn-outline-light-2x:hover, .btn-outline-light-2x:focus, .btn-outline-light-2x:active, .btn-outline-light-2x.active {
  color: white;
  background-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%) !important;
  border-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%) !important;
  box-shadow: none;
}

.btn-outline-dark-2x {
  border-width: 2px;
  border-color: #2c323f;
  color: #2c323f;
  background-color: transparent;
}
.btn-outline-dark-2x:hover, .btn-outline-dark-2x:focus, .btn-outline-dark-2x:active, .btn-outline-dark-2x.active {
  color: white;
  background-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%) !important;
  border-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%) !important;
  box-shadow: none;
}

.btn-outline-warning-2x {
  border-width: 2px;
  border-color: #ffaa05;
  color: #ffaa05;
  background-color: transparent;
}
.btn-outline-warning-2x:hover, .btn-outline-warning-2x:focus, .btn-outline-warning-2x:active, .btn-outline-warning-2x.active {
  color: white;
  background-color: rgb(81.9607843137%, 54.0941176471%, 0%) !important;
  border-color: rgb(81.9607843137%, 54.0941176471%, 0%) !important;
  box-shadow: none;
}

.btn-outline-primary {
  border-color: #7366ff;
  color: #7366ff;
  background-color: transparent;
}
.btn-outline-primary.disabled {
  color: #7366ff;
}
.btn-outline-primary:hover, .btn-outline-primary:focus, .btn-outline-primary:active, .btn-outline-primary.active {
  color: white;
  background-color: rgb(26.7973856209%, 20%, 100%) !important;
  border-color: rgb(26.7973856209%, 20%, 100%) !important;
}

.btn-outline-secondary {
  border-color: #ff3364;
  color: #ff3364;
  background-color: transparent;
}
.btn-outline-secondary.disabled {
  color: #ff3364;
}
.btn-outline-secondary:hover, .btn-outline-secondary:focus, .btn-outline-secondary:active, .btn-outline-secondary.active {
  color: white;
  background-color: rgb(100%, 0%, 24.0196078431%) !important;
  border-color: rgb(100%, 0%, 24.0196078431%) !important;
}

.btn-outline-success {
  border-color: #54ba4a;
  color: #54ba4a;
  background-color: transparent;
}
.btn-outline-success.disabled {
  color: #54ba4a;
}
.btn-outline-success:hover, .btn-outline-success:focus, .btn-outline-success:active, .btn-outline-success.active {
  color: white;
  background-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%) !important;
  border-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%) !important;
}

.btn-outline-danger {
  border-color: #fc4438;
  color: #fc4438;
  background-color: transparent;
}
.btn-outline-danger.disabled {
  color: #fc4438;
}
.btn-outline-danger:hover, .btn-outline-danger:focus, .btn-outline-danger:active, .btn-outline-danger.active {
  color: white;
  background-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%) !important;
  border-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%) !important;
}

.btn-outline-info {
  border-color: #16c7f9;
  color: #16c7f9;
  background-color: transparent;
}
.btn-outline-info.disabled {
  color: #16c7f9;
}
.btn-outline-info:hover, .btn-outline-info:focus, .btn-outline-info:active, .btn-outline-info.active {
  color: white;
  background-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%) !important;
  border-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%) !important;
}

.btn-outline-light {
  border-color: #f4f4f4;
  color: #f4f4f4;
  background-color: transparent;
}
.btn-outline-light.disabled {
  color: #f4f4f4;
}
.btn-outline-light {
  color: #2f2f3b;
}
.btn-outline-light:hover, .btn-outline-light:focus, .btn-outline-light:active, .btn-outline-light.active {
  color: white;
  background-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%) !important;
  border-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%) !important;
}

.btn-outline-dark {
  border-color: #2c323f;
  color: #2c323f;
  background-color: transparent;
}
.btn-outline-dark.disabled {
  color: #2c323f;
}
.btn-outline-dark:hover, .btn-outline-dark:focus, .btn-outline-dark:active, .btn-outline-dark.active {
  color: white;
  background-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%) !important;
  border-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%) !important;
}

.btn-outline-warning {
  border-color: #ffaa05;
  color: #ffaa05;
  background-color: transparent;
}
.btn-outline-warning.disabled {
  color: #ffaa05;
}
.btn-outline-warning:hover, .btn-outline-warning:focus, .btn-outline-warning:active, .btn-outline-warning.active {
  color: white;
  background-color: rgb(81.9607843137%, 54.0941176471%, 0%) !important;
  border-color: rgb(81.9607843137%, 54.0941176471%, 0%) !important;
}

.btn-primary:not([disabled]):not(.disabled).active {
  background-color: rgb(26.7973856209%, 20%, 100%);
  border-color: rgb(26.7973856209%, 20%, 100%);
  box-shadow: none !important;
}
.btn-primary:not([disabled]):not(.disabled).active:hover, .btn-primary:not([disabled]):not(.disabled).active:focus, .btn-primary:not([disabled]):not(.disabled).active:active, .btn-primary:not([disabled]):not(.disabled).active.active {
  color: white;
  background-color: rgb(26.7973856209%, 20%, 100%);
  border-color: rgb(26.7973856209%, 20%, 100%);
}

.btn-secondary:not([disabled]):not(.disabled).active {
  background-color: rgb(100%, 0%, 24.0196078431%);
  border-color: rgb(100%, 0%, 24.0196078431%);
  box-shadow: none !important;
}
.btn-secondary:not([disabled]):not(.disabled).active:hover, .btn-secondary:not([disabled]):not(.disabled).active:focus, .btn-secondary:not([disabled]):not(.disabled).active:active, .btn-secondary:not([disabled]):not(.disabled).active.active {
  color: white;
  background-color: rgb(100%, 0%, 24.0196078431%);
  border-color: rgb(100%, 0%, 24.0196078431%);
}

.btn-success:not([disabled]):not(.disabled).active {
  background-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%);
  border-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%);
  box-shadow: none !important;
}
.btn-success:not([disabled]):not(.disabled).active:hover, .btn-success:not([disabled]):not(.disabled).active:focus, .btn-success:not([disabled]):not(.disabled).active:active, .btn-success:not([disabled]):not(.disabled).active.active {
  color: white;
  background-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%);
  border-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%);
}

.btn-danger:not([disabled]):not(.disabled).active {
  background-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%);
  border-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%);
  box-shadow: none !important;
}
.btn-danger:not([disabled]):not(.disabled).active:hover, .btn-danger:not([disabled]):not(.disabled).active:focus, .btn-danger:not([disabled]):not(.disabled).active:active, .btn-danger:not([disabled]):not(.disabled).active.active {
  color: white;
  background-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%);
  border-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%);
}

.btn-info:not([disabled]):not(.disabled).active {
  background-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%);
  border-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%);
  box-shadow: none !important;
}
.btn-info:not([disabled]):not(.disabled).active:hover, .btn-info:not([disabled]):not(.disabled).active:focus, .btn-info:not([disabled]):not(.disabled).active:active, .btn-info:not([disabled]):not(.disabled).active.active {
  color: white;
  background-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%);
  border-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%);
}

.btn-light:not([disabled]):not(.disabled).active {
  background-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%);
  border-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%);
  box-shadow: none !important;
}
.btn-light:not([disabled]):not(.disabled).active:hover, .btn-light:not([disabled]):not(.disabled).active:focus, .btn-light:not([disabled]):not(.disabled).active:active, .btn-light:not([disabled]):not(.disabled).active.active {
  color: white;
  background-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%);
  border-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%);
}

.btn-dark:not([disabled]):not(.disabled).active {
  background-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%);
  border-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%);
  box-shadow: none !important;
}
.btn-dark:not([disabled]):not(.disabled).active:hover, .btn-dark:not([disabled]):not(.disabled).active:focus, .btn-dark:not([disabled]):not(.disabled).active:active, .btn-dark:not([disabled]):not(.disabled).active.active {
  color: white;
  background-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%);
  border-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%);
}

.btn-warning:not([disabled]):not(.disabled).active {
  background-color: rgb(81.9607843137%, 54.0941176471%, 0%);
  border-color: rgb(81.9607843137%, 54.0941176471%, 0%);
  box-shadow: none !important;
}
.btn-warning:not([disabled]):not(.disabled).active:hover, .btn-warning:not([disabled]):not(.disabled).active:focus, .btn-warning:not([disabled]):not(.disabled).active:active, .btn-warning:not([disabled]):not(.disabled).active.active {
  color: white;
  background-color: rgb(81.9607843137%, 54.0941176471%, 0%);
  border-color: rgb(81.9607843137%, 54.0941176471%, 0%);
}

.btn-outline-primary-2x:not([disabled]):not(.disabled).active {
  background-color: #7366ff;
  border-color: #7366ff;
  box-shadow: none !important;
  color: white;
}
.btn-outline-primary-2x:not([disabled]):not(.disabled).active:hover, .btn-outline-primary-2x:not([disabled]):not(.disabled).active:focus, .btn-outline-primary-2x:not([disabled]):not(.disabled).active:active, .btn-outline-primary-2x:not([disabled]):not(.disabled).active.active {
  color: white;
  box-shadow: none !important;
  background-color: rgb(26.7973856209%, 20%, 100%) !important;
  border-color: rgb(26.7973856209%, 20%, 100%) !important;
}

.btn-outline-secondary-2x:not([disabled]):not(.disabled).active {
  background-color: #ff3364;
  border-color: #ff3364;
  box-shadow: none !important;
  color: white;
}
.btn-outline-secondary-2x:not([disabled]):not(.disabled).active:hover, .btn-outline-secondary-2x:not([disabled]):not(.disabled).active:focus, .btn-outline-secondary-2x:not([disabled]):not(.disabled).active:active, .btn-outline-secondary-2x:not([disabled]):not(.disabled).active.active {
  color: white;
  box-shadow: none !important;
  background-color: rgb(100%, 0%, 24.0196078431%) !important;
  border-color: rgb(100%, 0%, 24.0196078431%) !important;
}

.btn-outline-success-2x:not([disabled]):not(.disabled).active {
  background-color: #54ba4a;
  border-color: #54ba4a;
  box-shadow: none !important;
  color: white;
}
.btn-outline-success-2x:not([disabled]):not(.disabled).active:hover, .btn-outline-success-2x:not([disabled]):not(.disabled).active:focus, .btn-outline-success-2x:not([disabled]):not(.disabled).active:active, .btn-outline-success-2x:not([disabled]):not(.disabled).active.active {
  color: white;
  box-shadow: none !important;
  background-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%) !important;
  border-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%) !important;
}

.btn-outline-danger-2x:not([disabled]):not(.disabled).active {
  background-color: #fc4438;
  border-color: #fc4438;
  box-shadow: none !important;
  color: white;
}
.btn-outline-danger-2x:not([disabled]):not(.disabled).active:hover, .btn-outline-danger-2x:not([disabled]):not(.disabled).active:focus, .btn-outline-danger-2x:not([disabled]):not(.disabled).active:active, .btn-outline-danger-2x:not([disabled]):not(.disabled).active.active {
  color: white;
  box-shadow: none !important;
  background-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%) !important;
  border-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%) !important;
}

.btn-outline-info-2x:not([disabled]):not(.disabled).active {
  background-color: #16c7f9;
  border-color: #16c7f9;
  box-shadow: none !important;
  color: white;
}
.btn-outline-info-2x:not([disabled]):not(.disabled).active:hover, .btn-outline-info-2x:not([disabled]):not(.disabled).active:focus, .btn-outline-info-2x:not([disabled]):not(.disabled).active:active, .btn-outline-info-2x:not([disabled]):not(.disabled).active.active {
  color: white;
  box-shadow: none !important;
  background-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%) !important;
  border-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%) !important;
}

.btn-outline-light-2x:not([disabled]):not(.disabled).active {
  background-color: #f4f4f4;
  border-color: #f4f4f4;
  box-shadow: none !important;
  color: white;
}
.btn-outline-light-2x:not([disabled]):not(.disabled).active:hover, .btn-outline-light-2x:not([disabled]):not(.disabled).active:focus, .btn-outline-light-2x:not([disabled]):not(.disabled).active:active, .btn-outline-light-2x:not([disabled]):not(.disabled).active.active {
  color: white;
  box-shadow: none !important;
  background-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%) !important;
  border-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%) !important;
}

.btn-outline-dark-2x:not([disabled]):not(.disabled).active {
  background-color: #2c323f;
  border-color: #2c323f;
  box-shadow: none !important;
  color: white;
}
.btn-outline-dark-2x:not([disabled]):not(.disabled).active:hover, .btn-outline-dark-2x:not([disabled]):not(.disabled).active:focus, .btn-outline-dark-2x:not([disabled]):not(.disabled).active:active, .btn-outline-dark-2x:not([disabled]):not(.disabled).active.active {
  color: white;
  box-shadow: none !important;
  background-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%) !important;
  border-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%) !important;
}

.btn-outline-warning-2x:not([disabled]):not(.disabled).active {
  background-color: #ffaa05;
  border-color: #ffaa05;
  box-shadow: none !important;
  color: white;
}
.btn-outline-warning-2x:not([disabled]):not(.disabled).active:hover, .btn-outline-warning-2x:not([disabled]):not(.disabled).active:focus, .btn-outline-warning-2x:not([disabled]):not(.disabled).active:active, .btn-outline-warning-2x:not([disabled]):not(.disabled).active.active {
  color: white;
  box-shadow: none !important;
  background-color: rgb(81.9607843137%, 54.0941176471%, 0%) !important;
  border-color: rgb(81.9607843137%, 54.0941176471%, 0%) !important;
}

/*======= Table-Border-Bottom-color css starts  ======= */
table thead .border-bottom-primary th,
table tbody .border-bottom-primary th,
table tbody .border-bottom-primary td {
  border-bottom: 1px solid #7366ff !important;
}

table thead .border-bottom-secondary th,
table tbody .border-bottom-secondary th,
table tbody .border-bottom-secondary td {
  border-bottom: 1px solid #ff3364 !important;
}

table thead .border-bottom-success th,
table tbody .border-bottom-success th,
table tbody .border-bottom-success td {
  border-bottom: 1px solid #54ba4a !important;
}

table thead .border-bottom-danger th,
table tbody .border-bottom-danger th,
table tbody .border-bottom-danger td {
  border-bottom: 1px solid #fc4438 !important;
}

table thead .border-bottom-info th,
table tbody .border-bottom-info th,
table tbody .border-bottom-info td {
  border-bottom: 1px solid #16c7f9 !important;
}

table thead .border-bottom-light th,
table tbody .border-bottom-light th,
table tbody .border-bottom-light td {
  border-bottom: 1px solid #f4f4f4 !important;
}

table thead .border-bottom-dark th,
table tbody .border-bottom-dark th,
table tbody .border-bottom-dark td {
  border-bottom: 1px solid #2c323f !important;
}

table thead .border-bottom-warning th,
table tbody .border-bottom-warning th,
table tbody .border-bottom-warning td {
  border-bottom: 1px solid #ffaa05 !important;
}

/*======= Table-Border-Bottom-color css ends  ======= */
/*======= Table styling css starts  ======= */
.table-styling .table-primary,
.table-styling.table-primary {
  background-color: #7366ff;
  color: #fff;
  border: 3px solid #7366ff;
}
.table-styling .table-primary thead,
.table-styling.table-primary thead {
  background-color: rgb(26.7973856209%, 20%, 100%);
  border: 3px solid rgb(26.7973856209%, 20%, 100%);
}
.table-styling .table-primary th,
.table-styling .table-primary td,
.table-styling.table-primary th,
.table-styling.table-primary td {
  background-color: transparent;
}

.table-styling .table-secondary,
.table-styling.table-secondary {
  background-color: #ff3364;
  color: #fff;
  border: 3px solid #ff3364;
}
.table-styling .table-secondary thead,
.table-styling.table-secondary thead {
  background-color: rgb(100%, 0%, 24.0196078431%);
  border: 3px solid rgb(100%, 0%, 24.0196078431%);
}
.table-styling .table-secondary th,
.table-styling .table-secondary td,
.table-styling.table-secondary th,
.table-styling.table-secondary td {
  background-color: transparent;
}

.table-styling .table-success,
.table-styling.table-success {
  background-color: #54ba4a;
  color: #fff;
  border: 3px solid #54ba4a;
}
.table-styling .table-success thead,
.table-styling.table-success thead {
  background-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%);
  border: 3px solid rgb(25.8996078431%, 59.3396078431%, 22.6211764706%);
}
.table-styling .table-success th,
.table-styling .table-success td,
.table-styling.table-success th,
.table-styling.table-success td {
  background-color: transparent;
}

.table-styling .table-danger,
.table-styling.table-danger {
  background-color: #fc4438;
  color: #fff;
  border: 3px solid #fc4438;
}
.table-styling .table-danger thead,
.table-styling.table-danger thead {
  background-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%);
  border: 3px solid rgb(98.5264997088%, 8.1518151815%, 2.2578140167%);
}
.table-styling .table-danger th,
.table-styling .table-danger td,
.table-styling.table-danger th,
.table-styling.table-danger td {
  background-color: transparent;
}

.table-styling .table-info,
.table-styling.table-info {
  background-color: #16c7f9;
  color: #fff;
  border: 3px solid #16c7f9;
}
.table-styling .table-info thead,
.table-styling.table-info thead {
  background-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%);
  border: 3px solid rgb(2.1658872754%, 66.0595619001%, 84.1086225285%);
}
.table-styling .table-info th,
.table-styling .table-info td,
.table-styling.table-info th,
.table-styling.table-info td {
  background-color: transparent;
}

.table-styling .table-light,
.table-styling.table-light {
  background-color: #f4f4f4;
  color: #fff;
  border: 3px solid #f4f4f4;
}
.table-styling .table-light thead,
.table-styling.table-light thead {
  background-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%);
  border: 3px solid rgb(85.6862745098%, 85.6862745098%, 85.6862745098%);
}
.table-styling .table-light th,
.table-styling .table-light td,
.table-styling.table-light th,
.table-styling.table-light td {
  background-color: transparent;
}

.table-styling .table-dark,
.table-styling.table-dark {
  background-color: #2c323f;
  color: #fff;
  border: 3px solid #2c323f;
}
.table-styling .table-dark thead,
.table-styling.table-dark thead {
  background-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%);
  border: 3px solid rgb(9.0306028954%, 10.2620487447%, 12.9301814184%);
}
.table-styling .table-dark th,
.table-styling .table-dark td,
.table-styling.table-dark th,
.table-styling.table-dark td {
  background-color: transparent;
}

.table-styling .table-warning,
.table-styling.table-warning {
  background-color: #ffaa05;
  color: #fff;
  border: 3px solid #ffaa05;
}
.table-styling .table-warning thead,
.table-styling.table-warning thead {
  background-color: rgb(81.9607843137%, 54.0941176471%, 0%);
  border: 3px solid rgb(81.9607843137%, 54.0941176471%, 0%);
}
.table-styling .table-warning th,
.table-styling .table-warning td,
.table-styling.table-warning th,
.table-styling.table-warning td {
  background-color: transparent;
}

/*======= Table styling css ends  ======= */
/*======= All-Borders-color css starts  ======= */
.b-primary {
  border: 1px solid #7366ff !important;
}

.b-t-primary {
  border-top: 1px solid #7366ff !important;
}

.b-b-primary {
  border-bottom: 1px solid #7366ff !important;
}

.b-l-primary {
  border-left: 1px solid #7366ff !important;
}

.b-r-primary {
  border-right: 1px solid #7366ff !important;
}

.b-secondary {
  border: 1px solid #ff3364 !important;
}

.b-t-secondary {
  border-top: 1px solid #ff3364 !important;
}

.b-b-secondary {
  border-bottom: 1px solid #ff3364 !important;
}

.b-l-secondary {
  border-left: 1px solid #ff3364 !important;
}

.b-r-secondary {
  border-right: 1px solid #ff3364 !important;
}

.b-success {
  border: 1px solid #54ba4a !important;
}

.b-t-success {
  border-top: 1px solid #54ba4a !important;
}

.b-b-success {
  border-bottom: 1px solid #54ba4a !important;
}

.b-l-success {
  border-left: 1px solid #54ba4a !important;
}

.b-r-success {
  border-right: 1px solid #54ba4a !important;
}

.b-danger {
  border: 1px solid #fc4438 !important;
}

.b-t-danger {
  border-top: 1px solid #fc4438 !important;
}

.b-b-danger {
  border-bottom: 1px solid #fc4438 !important;
}

.b-l-danger {
  border-left: 1px solid #fc4438 !important;
}

.b-r-danger {
  border-right: 1px solid #fc4438 !important;
}

.b-info {
  border: 1px solid #16c7f9 !important;
}

.b-t-info {
  border-top: 1px solid #16c7f9 !important;
}

.b-b-info {
  border-bottom: 1px solid #16c7f9 !important;
}

.b-l-info {
  border-left: 1px solid #16c7f9 !important;
}

.b-r-info {
  border-right: 1px solid #16c7f9 !important;
}

.b-light {
  border: 1px solid #f4f4f4 !important;
}

.b-t-light {
  border-top: 1px solid #f4f4f4 !important;
}

.b-b-light {
  border-bottom: 1px solid #f4f4f4 !important;
}

.b-l-light {
  border-left: 1px solid #f4f4f4 !important;
}

.b-r-light {
  border-right: 1px solid #f4f4f4 !important;
}

.b-dark {
  border: 1px solid #2c323f !important;
}

.b-t-dark {
  border-top: 1px solid #2c323f !important;
}

.b-b-dark {
  border-bottom: 1px solid #2c323f !important;
}

.b-l-dark {
  border-left: 1px solid #2c323f !important;
}

.b-r-dark {
  border-right: 1px solid #2c323f !important;
}

.b-warning {
  border: 1px solid #ffaa05 !important;
}

.b-t-warning {
  border-top: 1px solid #ffaa05 !important;
}

.b-b-warning {
  border-bottom: 1px solid #ffaa05 !important;
}

.b-l-warning {
  border-left: 1px solid #ffaa05 !important;
}

.b-r-warning {
  border-right: 1px solid #ffaa05 !important;
}

/*======= All-Borders-color css ends  ======= */
/*====== Border width css starts ======*/
.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-6 {
  border-width: 6px !important;
}

.border-7 {
  border-width: 7px !important;
}

.border-8 {
  border-width: 8px !important;
}

.border-9 {
  border-width: 9px !important;
}

.border-10 {
  border-width: 10px !important;
}

/*====== Border width css ends ======*/
.opacity-0 {
  opacity: 0;
}

.map-block {
  height: 350px;
  width: 100%;
}

.map-js-height {
  height: 500px;
}
.map-js-height .btn-group input {
  background-color: #7366ff;
  color: #fff;
}
.map-js-height .btn-group input + input {
  background-color: #ff3364;
}

/**====== custom scrollbar css start ======**/
.custom-scrollbar::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px #ecf3fa;
}
.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: rgba(68, 102, 242, 0.15);
}

/**====== Custom scrollbar css end ======**/
/**====== Animation css Start ======**/
.comment {
  color: #9f9ba5;
  font-style: italic;
}

.line {
  color: #2c323f;
}
.line pre {
  font-size: 100%;
}

/**====== Animation css end ======**/
/**====== list style css Start ======**/
.list-circle {
  list-style: circle;
}

/**====== list style css end ======**/
/**====== Modal style css Start ======**/
.theme-close {
  opacity: 1;
  height: 40px;
  width: 40px;
  position: absolute;
  font-weight: 400;
  z-index: 1;
  right: 0;
  background-color: #fff !important;
  border-radius: 5px;
}

/**====== Modal style css end ======**/
/**====== Animation css start ======**/
.options > div {
  color: #cccccc;
  display: inline-block;
  padding: 2px 10px;
  border: 1px solid;
  margin: 0 8px 8px 0;
  transition: all 0.3s ease;
}
.options > div:hover {
  background-color: #7366ff;
  color: #fff;
  transition: all 0.3s ease;
}

/**====== Animation css Ends ======**/
.modal-footer {
  flex-wrap: wrap;
}

.img-cropper #putData {
  margin-bottom: 0;
}
.img-cropper .img-container {
  min-height: auto;
  margin-bottom: 0;
}
.img-cropper .docs-data > .input-group:last-child {
  margin-bottom: 0;
}
.img-cropper .docs-preview {
  margin-top: 20px;
  margin-bottom: 10px;
}

.dropzone .dz-preview .dz-error-message {
  background: #fff !important;
  color: #7366ff !important;
  border: 1px solid #7366ff;
}
.dropzone .dz-preview .dz-error-message:after {
  border-bottom: 6px solid #7366ff !important;
}

.typeahead .theme-form .form-group {
  margin-bottom: 0;
}

.editor-statusbar {
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.page-builder .ge-canvas.ge-editing .row {
  padding: 30px;
  margin-bottom: 0;
  background-color: rgba(115, 102, 255, 0.02);
}
.page-builder .btn-screen {
  padding: 0 18px 0 0;
}

.bg-overlay.active {
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.2);
  position: fixed;
  z-index: 8;
  top: 0;
}

button:focus {
  outline: none !important;
}

.primary .svg-fill {
  fill: var(--theme-default);
}
.primary .svg-fill:not(.half-circle) {
  stroke: var(--theme-default);
}
.primary .bg-gradient {
  background-image: linear-gradient(144.16deg, rgba(115, 102, 255, 0.1) 19.06%, rgba(115, 102, 255, 0) 79.03%) !important;
}

.secondary .svg-fill {
  fill: var(--theme-secondary);
}
.secondary .svg-fill:not(.half-circle) {
  stroke: var(--theme-secondary);
}
.secondary .bg-gradient {
  background-image: linear-gradient(144.16deg, rgba(255, 51, 100, 0.1) 19.06%, rgba(255, 51, 100, 0) 79.03%) !important;
}

.success .svg-fill {
  fill: #54ba4a;
}
.success .bg-gradient {
  background-image: linear-gradient(144.16deg, rgba(84, 186, 74, 0.1) 19.06%, rgba(84, 186, 74, 0) 79.03%) !important;
}

.warning .svg-fill {
  fill: #ffaa05;
}
.warning .bg-gradient {
  background-image: linear-gradient(144.16deg, rgba(255, 170, 5, 0.1) 19.06%, rgba(255, 170, 5, 0) 79.03%) !important;
}

.dotted {
  border-style: dotted;
}

.dashed {
  border-style: dashed;
}

.double {
  border-style: double;
}

.groove {
  border-style: groove;
}

.ridge {
  border-style: ridge;
}

.inset {
  border-style: inset;
}

.outset {
  border-style: outset;
}

@keyframes fadeIncustom {
  0% {
    opacity: 0;
    top: 50px;
  }
  75% {
    opacity: 0.6;
    top: 0;
  }
  100% {
    opacity: 1;
  }
}
.daterangepicker select.monthselect, .daterangepicker select.yearselect {
  border-color: #efefef;
  background-color: #fff;
  font-size: 14px;
  color: #898989;
  padding: 5px 10px;
  border-radius: 5px;
  width: 46%;
}

.general-widget .cal-date-widget .datepicker {
  padding: 0;
}
.general-widget .cal-date-widget .datepicker .react-datepicker {
  background-color: transparent;
  box-shadow: none;
}

.general-cal .cal-date-widget .react-datepicker {
  background-color: transparent;
  box-shadow: none;
}

/**=====================
     Reset css Ends
==========================**/
.form-check-input:focus {
  outline: none;
  box-shadow: none;
  border: none;
}
.form-check-input[type=checkbox] {
  background-color: transparent;
  border-color: transparent;
}
.form-check-input[type=checkbox]:checked {
  background-color: transparent;
  border-color: transparent;
}

.empty-cart-cls {
  padding: 60px;
}

/**=====================
    Typography css start
==========================**/
body {
  font-size: 14px;
  overflow-x: hidden;
  font-family: Rubik, sans-serif;
  color: #2f2f3b;
}

ul {
  padding-left: 0px;
  list-style-type: none;
  margin-bottom: 0;
}

* a {
  color: var(--theme-default);
  text-decoration: none;
  letter-spacing: 1px;
}

a:hover {
  text-decoration: none;
  color: var(--theme-default);
}
a[class*=badge-]:hover {
  color: #fff;
}

.btn {
  font-size: 14px;
}

*.btn:focus {
  box-shadow: none !important;
}

p {
  font-size: 14px;
  line-height: 1.7;
  letter-spacing: 0.7px;
}

code {
  color: var(--theme-default) !important;
  background-color: rgba(115, 102, 255, 0.03);
  padding: 3px;
  margin: 0 3px;
  border-radius: 2px;
}

.media {
  display: flex;
  align-items: flex-start;
}
.media .media-body {
  flex: 1 1;
}

blockquote {
  border-left: 4px solid #ecf3fa;
  padding: 15px;
}

.figure.text-center blockquote {
  border: none !important;
}
.figure.text-end blockquote {
  border-left: none !important;
  border-right: 4px solid #ecf3fa;
}

.row > div {
  position: relative;
}

:focus {
  outline-color: var(--theme-default);
}

.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

svg {
  vertical-align: baseline;
}

input:focus {
  outline-color: transparent;
}

label {
  margin-bottom: 0.5rem;
}

.media-widgets .media-body {
  margin-bottom: 30px;
}

.typography h1,
.typography .h1,
.typography h2,
.typography .h2,
.typography h3,
.typography .h3,
.typography h4,
.typography .h4,
.typography h5,
.typography .h5,
.typography h6,
.typography .h6 {
  margin: 20px 0;
  margin-top: 0;
}
.typography h1:last-child,
.typography .h1:last-child,
.typography h2:last-child,
.typography .h2:last-child,
.typography h3:last-child,
.typography .h3:last-child,
.typography h4:last-child,
.typography .h4:last-child,
.typography h5:last-child,
.typography .h5:last-child,
.typography h6:last-child,
.typography .h6:last-child {
  margin-bottom: 0;
}
.typography small, .typography .small {
  padding-left: 10px;
  color: #2c323f;
}

pre {
  background-color: rgba(115, 102, 255, 0.03);
  padding: 20px 0;
}

.owl-theme .owl-dots .owl-dot span {
  background: rgb(81.6993464052%, 80%, 100%);
}
.owl-theme .owl-dots .owl-dot.active span, .owl-theme .owl-dots .owl-dot:hover span {
  background: var(--theme-default);
}
.owl-theme .owl-nav.disabled + .owl-dots {
  margin-bottom: -10px;
  margin-top: 25px;
}

.click2edit ~ .note-editor.note-frame {
  margin-bottom: 30px;
}

.note-editor.note-frame {
  border-color: #f4f4f4;
}
.note-editor.fullscreen .note-toolbar-wrapper {
  height: 0 !important;
}

.note-editor.note-frame {
  border-color: #f4f4f4;
}

.modal .modal-body .card {
  box-shadow: none !important;
}

.modal-dialog .modal-content .modal-body p a {
  margin-right: 0;
}

.notify-alert .close {
  color: #fff;
}
[dir=rtl] .notify-alert .close {
  right: unset !important;
  left: 10px !important;
}
.notify-alert.alert-light .close {
  color: #2f2f3b;
}

.alert-theme button {
  top: 25px !important;
  right: 20px !important;
  color: var(--theme-default);
}
[dir=rtl] .alert-theme button {
  right: unset !important;
  left: 20px !important;
}
.alert-theme span + span + span {
  background-color: #fff;
  color: var(--theme-default);
  border-radius: 4px;
  box-shadow: 0 2px 14px -3px rgba(0, 0, 0, 0.2);
}
.alert-theme .close {
  color: var(--theme-default);
}
.alert-theme i {
  padding: 20px;
  padding-right: 0 !important;
  margin-right: 20px !important;
}
.alert-theme .progress {
  margin-top: -2px !important;
  height: 2px;
  width: 100%;
}
.alert-theme .progress .progress-bar {
  background-color: var(--theme-default);
}

.alert-copy {
  border: 1px solid var(--theme-default);
  line-height: 1;
  display: inline-block;
  width: 300px;
  color: #fff;
  background-color: var(--theme-default);
}
.alert-copy .close {
  box-shadow: none;
  color: #fff;
  line-height: 1.4;
  font-weight: 100;
  top: -15px;
}
[dir=rtl] .alert-copy .close {
  right: unset !important;
  left: 10px !important;
}
.alert-copy .close:focus {
  outline: none;
}

.ace-editor {
  height: 400px;
  width: 100%;
}

.editor-toolbar {
  width: 100% !important;
}
.editor-toolbar.fullscreen {
  z-index: 100;
}

.CodeMirror {
  top: 0 !important;
}

.CodeMirror-fullscreen {
  top: 50px !important;
}

.irs-from,
.irs-to,
.irs-single {
  background: var(--theme-default);
}
.irs-from:after,
.irs-to:after,
.irs-single:after {
  border-top-color: var(--theme-default);
}

.irs-line-mid,
.irs-line-left,
.irs-line-right,
.irs-bar,
.irs-bar-edge {
  background-color: var(--theme-default);
}

.swal-button {
  background-color: var(--theme-default);
}
.swal-button:active {
  background-color: rgb(35.9477124183%, 30%, 100%);
}

.swal-button--cancel {
  background-color: #efefee !important;
}

.clipboaard-container h6, .clipboaard-container .h6 {
  line-height: 1.6;
  font-size: 14px;
}

fieldset .bootstrap-touchspin-postfix,
fieldset .bootstrap-touchspin-prefix {
  border-radius: 0;
  padding: 0.4rem 0.75rem;
}
fieldset .input-group-lg .touchspin {
  height: 50px;
}

.f1 .f1-steps .f1-step .f1-step-icon {
  padding: 12px;
}

.form-inline .form-group {
  display: flex;
}

.input-group-text i {
  line-height: 1.5;
}

.animated-modal .form-select {
  display: inline-block;
  width: auto;
  vertical-align: middle;
}

/**=====================
    Typography css Ends
==========================**/
/**=====================
    24. According CSS start
==========================**/
.default-according .avatar-showcase {
  margin-bottom: 0;
}
.default-according .card {
  margin-bottom: 0;
  box-shadow: none;
}
.default-according .card + .card {
  margin-top: 10px;
}
.default-according .card .btn-link {
  font-weight: 500;
  color: #2f2f3b;
  text-decoration: none;
}
.default-according .card .btn-link:focus, .default-according .card .btn-link:hover {
  text-decoration: none;
}
.default-according .card .card-header {
  padding: 0.75rem 1.25rem;
  border: 1px solid #ecf3fa;
}
.default-according .card .card-header i {
  position: absolute;
  left: 18px;
  font-size: 20px;
  top: 20px;
}
.default-according .card .card-header h5, .default-according .card .card-header .h5 {
  margin-top: 2px;
}
.default-according .card .card-body {
  border: 1px solid #ecf3fa;
  border-top: none;
}

.default-according.style-1 button {
  width: 100%;
  text-align: left;
}
.default-according.style-1 button:before {
  right: 20px;
  position: absolute;
  transition: 0.4s;
  font-size: 20px;
  top: 50%;
  transform: translateY(-50%);
}
@media (max-width: 575px) {
  .default-according.style-1 button:before {
    right: 15px;
  }
}
.default-according.style-1 button[aria-expanded=true]:before {
  content: "\\eb73";
  font-family: IcoFont;
}
.default-according.style-1 button[aria-expanded=false]:before {
  content: "\\eb7a";
  font-family: IcoFont;
}

/**=====================
     24. According CSS Ends
==========================**/
/**=====================
     15. Alert CSS start
==========================**/
.notify-alert .close {
  background: unset;
  border: none;
  font-size: 25px;
}

.alert {
  border-radius: 0.15rem;
  padding: 15px;
}
.alert svg {
  vertical-align: middle;
}
.alert .progress {
  margin-top: 15px;
}
.alert [data-notify=icon] {
  margin-right: 10px;
  line-height: 20px;
  position: absolute;
}
.alert [data-notify=message] {
  display: inline-block;
  width: 100%;
}
.alert i {
  margin-right: 5px;
  font-size: 16px;
}
.alert p {
  margin-bottom: 0;
}
.alert .close {
  opacity: 1;
}
.alert .close span {
  font-size: 24px;
  font-weight: 400;
  display: inline-block;
  border-radius: 3px;
  text-shadow: none;
  padding: 0 5px;
  padding-right: 0;
}

.alert-dismissible {
  padding-right: 2.5rem;
}
[dir=rtl] .alert-dismissible {
  padding-right: 15px;
  padding-left: 2.5rem;
}
.alert-dismissible .close {
  padding: 10px 1.25rem;
  top: 4px;
  padding-right: 13px;
  opacity: 0.5;
  transition: all 0.3s ease;
}
.alert-dismissible .close:hover {
  transition: all 0.3s ease;
  opacity: 1;
  color: inherit;
}

.card-body button:focus {
  outline: none;
}
.card-body .alert:last-child {
  margin-bottom: 0;
}
.card-body .alert svg {
  width: 14px;
  height: 14px;
  margin-right: 4px;
  position: absolute;
  top: 18px;
}
.card-body .alert svg ~ p {
  padding-left: 20px;
}

strong {
  display: inline-block;
}
strong ~ p {
  display: inline-block;
}

.alert-primary {
  background-color: rgba(115, 102, 255, 0.8);
  border-color: rgba(115, 102, 255, 0.9);
  color: #fff;
}
.alert-primary .progress {
  height: 5px;
  background-color: rgb(43.2679738562%, 38%, 100%);
  border-radius: 0;
}
.alert-primary .progress-bar {
  background-color: white;
}
.alert-primary .btn-close {
  filter: brightness(1) invert(1);
}
.alert-primary .alert-link {
  color: #7366ff;
}
.alert-primary hr {
  border-top-color: #7366ff;
}

.alert-primary.dark .alert-link {
  color: #fff;
}
.alert-primary.dark {
  background-color: #7366ff;
  border-color: #7366ff;
  color: #fafafa;
}

.alert-primary.outline, .alert-primary.outline-2x {
  background-color: transparent;
  border-color: #7366ff;
  color: #7366ff;
}
.alert-primary.outline .btn-close, .alert-primary.outline-2x .btn-close {
  filter: unset;
}

.alert-primary.inverse:before {
  top: 16px;
  content: "";
  position: absolute;
  left: 54px;
  width: 0;
  height: 0;
  border-left: 7px solid #7366ff;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
}
@media (max-width: 576px) {
  .alert-primary.inverse:before {
    left: 45px;
  }
}
.alert-primary.inverse {
  background-color: transparent;
  padding: 13px 20px 13px 65px;
  border-color: #7366ff;
  color: #2f2f3b;
}
.alert-primary.inverse i {
  padding: 17px 20px;
  display: inline-block;
  background-color: #7366ff;
  color: #fff;
  border-radius: 3px 0 0 3px;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
}
@media (max-width: 576px) {
  .alert-primary.inverse i {
    padding: 17px 14px;
  }
}
.alert-primary.inverse .btn-close {
  filter: unset;
  top: -3px;
}

.alert-secondary {
  background-color: rgba(255, 51, 100, 0.8);
  border-color: rgba(255, 51, 100, 0.9);
  color: #fff;
}
.alert-secondary .progress {
  height: 5px;
  background-color: rgb(100%, 18%, 37.6960784314%);
  border-radius: 0;
}
.alert-secondary .progress-bar {
  background-color: white;
}
.alert-secondary .btn-close {
  filter: brightness(1) invert(1);
}
.alert-secondary .alert-link {
  color: #ff3364;
}
.alert-secondary hr {
  border-top-color: #ff3364;
}

.alert-secondary.dark .alert-link {
  color: #fff;
}
.alert-secondary.dark {
  background-color: #ff3364;
  border-color: #ff3364;
  color: #fafafa;
}

.alert-secondary.outline, .alert-secondary.outline-2x {
  background-color: transparent;
  border-color: #ff3364;
  color: #ff3364;
}
.alert-secondary.outline .btn-close, .alert-secondary.outline-2x .btn-close {
  filter: unset;
}

.alert-secondary.inverse:before {
  top: 16px;
  content: "";
  position: absolute;
  left: 54px;
  width: 0;
  height: 0;
  border-left: 7px solid #ff3364;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
}
@media (max-width: 576px) {
  .alert-secondary.inverse:before {
    left: 45px;
  }
}
.alert-secondary.inverse {
  background-color: transparent;
  padding: 13px 20px 13px 65px;
  border-color: #ff3364;
  color: #2f2f3b;
}
.alert-secondary.inverse i {
  padding: 17px 20px;
  display: inline-block;
  background-color: #ff3364;
  color: #fff;
  border-radius: 3px 0 0 3px;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
}
@media (max-width: 576px) {
  .alert-secondary.inverse i {
    padding: 17px 14px;
  }
}
.alert-secondary.inverse .btn-close {
  filter: unset;
  top: -3px;
}

.alert-success {
  background-color: rgba(84, 186, 74, 0.8);
  border-color: rgba(84, 186, 74, 0.9);
  color: #fff;
}
.alert-success .progress {
  height: 5px;
  background-color: rgb(31.5876078431%, 72.3716078431%, 27.5891764706%);
  border-radius: 0;
}
.alert-success .progress-bar {
  background-color: white;
}
.alert-success .btn-close {
  filter: brightness(1) invert(1);
}
.alert-success .alert-link {
  color: #54ba4a;
}
.alert-success hr {
  border-top-color: #54ba4a;
}

.alert-success.dark .alert-link {
  color: #fff;
}
.alert-success.dark {
  background-color: #54ba4a;
  border-color: #54ba4a;
  color: #fafafa;
}

.alert-success.outline, .alert-success.outline-2x {
  background-color: transparent;
  border-color: #54ba4a;
  color: #54ba4a;
}
.alert-success.outline .btn-close, .alert-success.outline-2x .btn-close {
  filter: unset;
}

.alert-success.inverse:before {
  top: 16px;
  content: "";
  position: absolute;
  left: 54px;
  width: 0;
  height: 0;
  border-left: 7px solid #54ba4a;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
}
@media (max-width: 576px) {
  .alert-success.inverse:before {
    left: 45px;
  }
}
.alert-success.inverse {
  background-color: transparent;
  padding: 13px 20px 13px 65px;
  border-color: #54ba4a;
  color: #2f2f3b;
}
.alert-success.inverse i {
  padding: 17px 20px;
  display: inline-block;
  background-color: #54ba4a;
  color: #fff;
  border-radius: 3px 0 0 3px;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
}
@media (max-width: 576px) {
  .alert-success.inverse i {
    padding: 17px 14px;
  }
}
.alert-success.inverse .btn-close {
  filter: unset;
  top: -3px;
}

.alert-danger {
  background-color: rgba(252, 68, 56, 0.8);
  border-color: rgba(252, 68, 56, 0.9);
  color: #fff;
}
.alert-danger .progress {
  height: 5px;
  background-color: rgb(98.7938264415%, 24.8151815182%, 19.990487284%);
  border-radius: 0;
}
.alert-danger .progress-bar {
  background-color: white;
}
.alert-danger .btn-close {
  filter: brightness(1) invert(1);
}
.alert-danger .alert-link {
  color: #fc4438;
}
.alert-danger hr {
  border-top-color: #fc4438;
}

.alert-danger.dark .alert-link {
  color: #fff;
}
.alert-danger.dark {
  background-color: #fc4438;
  border-color: #fc4438;
  color: #fafafa;
}

.alert-danger.outline, .alert-danger.outline-2x {
  background-color: transparent;
  border-color: #fc4438;
  color: #fc4438;
}
.alert-danger.outline .btn-close, .alert-danger.outline-2x .btn-close {
  filter: unset;
}

.alert-danger.inverse:before {
  top: 16px;
  content: "";
  position: absolute;
  left: 54px;
  width: 0;
  height: 0;
  border-left: 7px solid #fc4438;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
}
@media (max-width: 576px) {
  .alert-danger.inverse:before {
    left: 45px;
  }
}
.alert-danger.inverse {
  background-color: transparent;
  padding: 13px 20px 13px 65px;
  border-color: #fc4438;
  color: #2f2f3b;
}
.alert-danger.inverse i {
  padding: 17px 20px;
  display: inline-block;
  background-color: #fc4438;
  color: #fff;
  border-radius: 3px 0 0 3px;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
}
@media (max-width: 576px) {
  .alert-danger.inverse i {
    padding: 17px 14px;
  }
}
.alert-danger.inverse .btn-close {
  filter: unset;
  top: -3px;
}

.alert-warning {
  background-color: rgba(255, 170, 5, 0.8);
  border-color: rgba(255, 170, 5, 0.9);
  color: #fff;
}
.alert-warning .progress {
  height: 5px;
  background-color: rgb(99.9607843137%, 65.9741176471%, 0%);
  border-radius: 0;
}
.alert-warning .progress-bar {
  background-color: white;
}
.alert-warning .btn-close {
  filter: brightness(1) invert(1);
}
.alert-warning .alert-link {
  color: #ffaa05;
}
.alert-warning hr {
  border-top-color: #ffaa05;
}

.alert-warning.dark .alert-link {
  color: #fff;
}
.alert-warning.dark {
  background-color: #ffaa05;
  border-color: #ffaa05;
  color: #fafafa;
}

.alert-warning.outline, .alert-warning.outline-2x {
  background-color: transparent;
  border-color: #ffaa05;
  color: #ffaa05;
}
.alert-warning.outline .btn-close, .alert-warning.outline-2x .btn-close {
  filter: unset;
}

.alert-warning.inverse:before {
  top: 16px;
  content: "";
  position: absolute;
  left: 54px;
  width: 0;
  height: 0;
  border-left: 7px solid #ffaa05;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
}
@media (max-width: 576px) {
  .alert-warning.inverse:before {
    left: 45px;
  }
}
.alert-warning.inverse {
  background-color: transparent;
  padding: 13px 20px 13px 65px;
  border-color: #ffaa05;
  color: #2f2f3b;
}
.alert-warning.inverse i {
  padding: 17px 20px;
  display: inline-block;
  background-color: #ffaa05;
  color: #fff;
  border-radius: 3px 0 0 3px;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
}
@media (max-width: 576px) {
  .alert-warning.inverse i {
    padding: 17px 14px;
  }
}
.alert-warning.inverse .btn-close {
  filter: unset;
  top: -3px;
}

.alert-info {
  background-color: rgba(22, 199, 249, 0.8);
  border-color: rgba(22, 199, 249, 0.9);
  color: #fff;
}
.alert-info .progress {
  height: 5px;
  background-color: rgb(6.6776601854%, 77.5705964394%, 97.5968496185%);
  border-radius: 0;
}
.alert-info .progress-bar {
  background-color: white;
}
.alert-info .btn-close {
  filter: brightness(1) invert(1);
}
.alert-info .alert-link {
  color: #16c7f9;
}
.alert-info hr {
  border-top-color: #16c7f9;
}

.alert-info.dark .alert-link {
  color: #fff;
}
.alert-info.dark {
  background-color: #16c7f9;
  border-color: #16c7f9;
  color: #fafafa;
}

.alert-info.outline, .alert-info.outline-2x {
  background-color: transparent;
  border-color: #16c7f9;
  color: #16c7f9;
}
.alert-info.outline .btn-close, .alert-info.outline-2x .btn-close {
  filter: unset;
}

.alert-info.inverse:before {
  top: 16px;
  content: "";
  position: absolute;
  left: 54px;
  width: 0;
  height: 0;
  border-left: 7px solid #16c7f9;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
}
@media (max-width: 576px) {
  .alert-info.inverse:before {
    left: 45px;
  }
}
.alert-info.inverse {
  background-color: transparent;
  padding: 13px 20px 13px 65px;
  border-color: #16c7f9;
  color: #2f2f3b;
}
.alert-info.inverse i {
  padding: 17px 20px;
  display: inline-block;
  background-color: #16c7f9;
  color: #fff;
  border-radius: 3px 0 0 3px;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
}
@media (max-width: 576px) {
  .alert-info.inverse i {
    padding: 17px 14px;
  }
}
.alert-info.inverse .btn-close {
  filter: unset;
  top: -3px;
}

.alert-light {
  background-color: rgba(244, 244, 244, 0.8);
  border-color: rgba(244, 244, 244, 0.9);
  color: #fff;
}
.alert-light .progress {
  height: 5px;
  background-color: rgb(94.6862745098%, 94.6862745098%, 94.6862745098%);
  border-radius: 0;
}
.alert-light .progress-bar {
  background-color: white;
}
.alert-light .btn-close {
  filter: brightness(1) invert(1);
}
.alert-light .alert-link {
  color: #f4f4f4;
  color: #2c323f;
}
.alert-light {
  color: #2c323f;
  background-color: #f4f4f4;
}
.alert-light .btn-close {
  filter: unset;
}
.alert-light hr {
  border-top-color: #f4f4f4;
}

.alert-light.dark .alert-link {
  color: #fff;
  color: #2c323f;
}
.alert-light.dark {
  background-color: #f4f4f4;
  border-color: #f4f4f4;
  color: #fafafa;
  color: #2c323f;
}

.alert-light.outline, .alert-light.outline-2x {
  background-color: transparent;
  border-color: #f4f4f4;
  color: #f4f4f4;
}
.alert-light.outline .btn-close, .alert-light.outline-2x .btn-close {
  filter: unset;
}
.alert-light.outline, .alert-light.outline-2x {
  color: #2c323f;
}

.alert-light.inverse:before {
  top: 16px;
  content: "";
  position: absolute;
  left: 54px;
  width: 0;
  height: 0;
  border-left: 7px solid #f4f4f4;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
}
@media (max-width: 576px) {
  .alert-light.inverse:before {
    left: 45px;
  }
}
.alert-light.inverse {
  background-color: transparent;
  padding: 13px 20px 13px 65px;
  border-color: #f4f4f4;
  color: #2f2f3b;
}
.alert-light.inverse i {
  padding: 17px 20px;
  display: inline-block;
  background-color: #f4f4f4;
  color: #fff;
  border-radius: 3px 0 0 3px;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
}
@media (max-width: 576px) {
  .alert-light.inverse i {
    padding: 17px 14px;
  }
}
.alert-light.inverse .btn-close {
  filter: unset;
  top: -3px;
}

.alert-dark {
  background-color: rgba(44, 50, 63, 0.8);
  border-color: rgba(44, 50, 63, 0.9);
  color: #fff;
}
.alert-dark .progress {
  height: 5px;
  background-color: rgb(16.4324720542%, 18.673263698%, 23.5283122595%);
  border-radius: 0;
}
.alert-dark .progress-bar {
  background-color: rgb(65.82737768%, 69.0819131391%, 76.1334066337%);
}
.alert-dark .btn-close {
  filter: brightness(1) invert(1);
}
.alert-dark .alert-link {
  color: #2c323f;
}
.alert-dark hr {
  border-top-color: #2c323f;
}

.alert-dark.dark .alert-link {
  color: #fff;
}
.alert-dark.dark {
  background-color: #2c323f;
  border-color: #2c323f;
  color: #fafafa;
}

.alert-dark.outline, .alert-dark.outline-2x {
  background-color: transparent;
  border-color: #2c323f;
  color: #2c323f;
}
.alert-dark.outline .btn-close, .alert-dark.outline-2x .btn-close {
  filter: unset;
}

.alert-dark.inverse:before {
  top: 16px;
  content: "";
  position: absolute;
  left: 54px;
  width: 0;
  height: 0;
  border-left: 7px solid #2c323f;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
}
@media (max-width: 576px) {
  .alert-dark.inverse:before {
    left: 45px;
  }
}
.alert-dark.inverse {
  background-color: transparent;
  padding: 13px 20px 13px 65px;
  border-color: #2c323f;
  color: #2f2f3b;
}
.alert-dark.inverse i {
  padding: 17px 20px;
  display: inline-block;
  background-color: #2c323f;
  color: #fff;
  border-radius: 3px 0 0 3px;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
}
@media (max-width: 576px) {
  .alert-dark.inverse i {
    padding: 17px 14px;
  }
}
.alert-dark.inverse .btn-close {
  filter: unset;
  top: -3px;
}

.dismiss-text .alert .btn-close {
  background: unset;
  opacity: 1;
  top: -6px;
  right: 40px;
}
.dismiss-text .alert .btn-close span {
  display: inline-block;
  border-radius: 3px;
  text-shadow: none;
  padding: 0 5px;
}

.outline-2x {
  border-width: 2px;
  padding: 11px 1.25rem;
}

/**=====================
     15. Alert CSS end
==========================**/
/**=====================
    80. avatars CSS start
==========================**/
.avatars .avatar {
  display: inline-block;
  margin-right: 10px;
  position: relative;
  width: auto;
}
.avatars .avatar:last-child {
  margin-right: 0;
}
.avatars .avatar .b-r-30 {
  border-radius: 30px;
}
.avatars .avatar .b-r-35 {
  border-radius: 35px;
}
.avatars .avatar .b-r-25 {
  border-radius: 25px;
}
.avatars .avatar .b-r-15 {
  border-radius: 15px;
}
.avatars .avatar.ratio img {
  width: auto;
}
.avatars .avatar .status {
  position: absolute;
  background-color: #999999;
  bottom: 0;
  right: 4px;
  border-radius: 100%;
  border: 1px solid #fff;
}
.avatars .avatar .status {
  position: absolute;
  height: 12%;
  width: 12%;
  background-color: #54ba4a;
  border-radius: 100%;
  bottom: 12%;
  right: 4%;
}

.customers ul {
  display: inline-block;
}
.customers ul li img {
  border: 2px solid #fff;
  transition: 0.5s;
}
.customers ul li img:hover {
  transform: translateY(-4px) scale(1.02);
  transition: 0.5s;
}
.customers ul li + li {
  margin-left: -7%;
}
.customers.avatar-group {
  margin-right: 30px;
}
.customers.avatar-group:last-child {
  margin-right: 0;
}

.avatar-showcase {
  margin-bottom: -10px;
}
.avatar-showcase .avatars .avatar {
  margin-bottom: 10px;
}
.avatar-showcase .avatar-group {
  margin-bottom: 10px;
}
.avatar-showcase .ratio > * {
  position: relative;
  top: unset;
  left: unset;
}
.avatar-showcase .add-friend .d-block {
  margin: 8px 0;
}

/**=====================
     80. avatars CSS Ends
==========================**/
/**=====================
    49. Badge CSS start
==========================**/
.badge {
  padding: 0.44em 0.7em;
  font-family: Roboto, sans-serif;
  font-weight: 500;
}
.badge + .badge {
  margin-left: 5px;
}
.badge svg {
  width: 12px;
  height: 12px;
  padding-top: 3px;
}

.pill-badge-primary {
  background-color: var(--theme-default);
  box-shadow: -0.5px 4.33px 16px 0px rgba(var(--theme-default), 0.25);
  color: #fff;
  border-radius: 0;
}

.pill-badge-secondary {
  background-color: #ff3364;
  box-shadow: -0.5px 4.33px 16px 0px rgba(255, 51, 100, 0.25);
  color: #fff;
  border-radius: 0;
}

.pill-badge-success {
  background-color: #54ba4a;
  box-shadow: -0.5px 4.33px 16px 0px rgba(84, 186, 74, 0.25);
  color: #fff;
  border-radius: 0;
}

.pill-badge-danger {
  background-color: #fc4438;
  box-shadow: -0.5px 4.33px 16px 0px rgba(252, 68, 56, 0.25);
  color: #fff;
  border-radius: 0;
}

.pill-badge-info {
  background-color: #16c7f9;
  box-shadow: -0.5px 4.33px 16px 0px rgba(22, 199, 249, 0.25);
  color: #fff;
  border-radius: 0;
}

.pill-badge-light {
  background-color: #f4f4f4;
  box-shadow: -0.5px 4.33px 16px 0px rgba(244, 244, 244, 0.25);
  color: #fff;
  border-radius: 0;
}

.pill-badge-dark {
  background-color: #2c323f;
  box-shadow: -0.5px 4.33px 16px 0px rgba(44, 50, 63, 0.25);
  color: #fff;
  border-radius: 0;
}

.pill-badge-warning {
  background-color: #ffaa05;
  box-shadow: -0.5px 4.33px 16px 0px rgba(255, 170, 5, 0.25);
  color: #fff;
  border-radius: 0;
}

.pill-badge-primary {
  background-color: var(--theme-default);
}

.pill-badge-secondary {
  background-color: var(--theme-secondary);
}

.round-badge-primary {
  border-radius: 6px;
  background-color: var(--theme-default);
  box-shadow: -0.5px -6.67px 14px 0px rgba(var(--theme-default), 0.18);
  color: #fff !important;
}

.round-badge-secondary {
  border-radius: 6px;
  background-color: #ff3364;
  box-shadow: -0.5px -6.67px 14px 0px rgba(255, 51, 100, 0.18);
  color: #fff !important;
}

.round-badge-success {
  border-radius: 6px;
  background-color: #54ba4a;
  box-shadow: -0.5px -6.67px 14px 0px rgba(84, 186, 74, 0.18);
  color: #fff !important;
}

.round-badge-danger {
  border-radius: 6px;
  background-color: #fc4438;
  box-shadow: -0.5px -6.67px 14px 0px rgba(252, 68, 56, 0.18);
  color: #fff !important;
}

.round-badge-info {
  border-radius: 6px;
  background-color: #16c7f9;
  box-shadow: -0.5px -6.67px 14px 0px rgba(22, 199, 249, 0.18);
  color: #fff !important;
}

.round-badge-light {
  border-radius: 6px;
  background-color: #f4f4f4;
  box-shadow: -0.5px -6.67px 14px 0px rgba(244, 244, 244, 0.18);
  color: #fff !important;
}

.round-badge-dark {
  border-radius: 6px;
  background-color: #2c323f;
  box-shadow: -0.5px -6.67px 14px 0px rgba(44, 50, 63, 0.18);
  color: #fff !important;
}

.round-badge-warning {
  border-radius: 6px;
  background-color: #ffaa05;
  box-shadow: -0.5px -6.67px 14px 0px rgba(255, 170, 5, 0.18);
  color: #fff !important;
}

.round-badge-primary {
  background-color: var(--theme-default);
}

.round-badge-secondary {
  background-color: var(--theme-secondary);
}

/**=====================
    49. Badge CSS Ends
==========================**/
/**=====================
    81. Bookmark CSS start
==========================**/
.bookmark ul li {
  display: inline-block;
}
.bookmark ul li .search-form {
  position: absolute;
  bottom: 53px;
  z-index: 1;
}
.bookmark ul li .search-form .form-control-search {
  top: 65px;
  position: absolute;
  transition: all linear 0.3s;
  right: -20px;
  transform: translateY(-35px) scaleY(0);
  opacity: 0;
  visibility: hidden;
}
.bookmark ul li .search-form .form-control-search input {
  width: 240px;
  background-color: #fff;
  box-shadow: 0 5px 21px rgba(0, 0, 0, 0.1);
}
.bookmark ul li .search-form .form-control-search.open {
  transform: translateY(0px) scaleY(1);
  opacity: 1;
  visibility: visible;
  transition: all linear 0.3s;
  z-index: 100;
}
.bookmark ul li .search-form .form-control-search:after {
  top: 12px;
  left: 20px;
  z-index: 1;
}
.bookmark ul li .search-form .form-control-search:before {
  left: 50px;
  top: 9px;
  z-index: 2;
}
.bookmark ul li a {
  position: relative;
  color: #2f2f3b;
}
.bookmark ul li a svg {
  vertical-align: middle;
  height: 20px;
  width: 20px;
}
.bookmark ul li + li {
  margin-left: 10px;
}
.bookmark ul li:last-child {
  padding-right: 0;
}
.bookmark ul li:last-child a {
  border-radius: 5px;
}
.bookmark ul li:last-child a svg {
  color: #ff9f40;
}

.offcanvas-bookmark.page-wrapper.horizontal-wrapper .page-body-wrapper .page-body .bookmark ul li a {
  z-index: 99999;
  color: rgba(255, 255, 255, 0.5);
}
.offcanvas-bookmark:before {
  position: fixed;
  content: "";
  background-color: rgba(0, 0, 0, 0.5);
  height: 100%;
  width: 100%;
  z-index: 1;
  right: 0;
  left: 0;
}

body.modal-open .select2-container--open {
  width: unset !important;
  display: block;
}
body.modal-open .select2-container--open .select2-dropdown {
  z-index: 1076;
}

/**=====================
    81. Bookmark CSS Ends
==========================**/
/**=====================
    57. breadcrumb CSS Start
==========================**/
.breadcrumb-colored {
  padding: 12px 16px;
  border-radius: 4px;
}
.breadcrumb-colored li a {
  color: #fff;
}
.breadcrumb-colored li.active {
  color: #fff;
  opacity: 0.7;
}
.breadcrumb-colored .breadcrumb-item:before {
  color: #fff;
}
.breadcrumb-colored .breadcrumb-item.txt-dark:before {
  color: #000;
}

.breadcrumb-icon {
  --bs-breadcrumb-divider: '>';
}
.breadcrumb-icon li {
  display: inline-block;
}

.breadcrumb-no-divider {
  --bs-breadcrumb-divider: '';
}

.breadcrumb-item.active {
  text-transform: capitalize;
}

/**=====================
    57. breadcrumb CSS ends
==========================**/
/**=====================
     35. Form builder css start
==========================**/
.form-builder .help-block {
  margin-bottom: 0;
  color: #cccccc;
  text-transform: capitalize;
}
.form-builder .btn-light {
  color: #cccccc;
}
.form-builder .copy-btn {
  padding: 8px;
}
.form-builder .nav-primary .nav-link.active, .form-builder .nav-primary .nav-primary .show > .nav-link, .form-builder .nav-primary .nav-pills.nav-primary .nav-link.active, .form-builder .nav-primary .nav-pills.nav-primary .show > .nav-link {
  border-radius: 5px;
}
.form-builder .nav-primary .nav-link, .form-builder .nav-primary .nav-pills.nav-primary .nav-link {
  color: #000;
  font-weight: 500;
}
.form-builder .theme-form {
  margin-top: 30px;
}

/**=====================
    35. Form builder css Ends
==========================**/
/**=====================
    06. Button CSS start
==========================**/
.btn-link {
  color: var(--theme-default);
}

.purchase-btn {
  background: linear-gradient(90deg, var(--theme-default) -18.33%, #563ee0 62.78%);
  padding: 12px 20px;
  min-width: 200px;
  border: none;
  transition: 0.5s;
}
.purchase-btn:hover {
  background: linear-gradient(90deg, #563ee0 -18.33%, var(--theme-default) 62.78%);
  transition: 0.5s;
}
@media (max-width: 991px) {
  .purchase-btn {
    min-width: 160px;
  }
}
@media (max-width: 767px) {
  .purchase-btn {
    min-width: 140px;
    padding: 10px 17px;
    font-size: 16px;
  }
}

.btn-light:not([disabled]):not(.disabled).active.active {
  color: #2f2f3b;
  background-color: rgb(93.6862745098%, 93.6862745098%, 93.6862745098%) !important;
}

.btn-primary-gradien {
  background-image: linear-gradient(to right, rgb(59.7385620915%, 56%, 100%) 0%, rgb(30.4575163399%, 24%, 100%) 51%, rgb(59.7385620915%, 56%, 100%) 100%);
  border: none;
  color: #fff;
  background-size: auto 200%;
  transition: all 0.3s ease;
  color: #fff;
}
.btn-primary-gradien:focus, .btn-primary-gradien:active, .btn-primary-gradien.active {
  transition: 1.5s;
  background-position: right center;
  background-image: linear-gradient(to right, rgb(59.7385620915%, 56%, 100%), 0%, rgb(30.4575163399%, 24%, 100%), 100%, #fff) !important;
}

.btn-secondary-gradien {
  background-image: linear-gradient(to right, rgb(100%, 36%, 51.3725490196%) 0%, rgb(100%, 4%, 27.0588235294%) 51%, rgb(100%, 36%, 51.3725490196%) 100%);
  border: none;
  color: #fff;
  background-size: auto 200%;
  transition: all 0.3s ease;
}
.btn-secondary-gradien:hover, .btn-secondary-gradien:focus, .btn-secondary-gradien:active, .btn-secondary-gradien.active, .btn-secondary-gradien.hover {
  transition: 1.5s;
  background-position: right center;
  background-image: linear-gradient(to right, rgb(100%, 36%, 51.3725490196%), 0%, rgb(100%, 4%, 27.0588235294%), 100%, #fff) !important;
}

.btn-success-gradien {
  background-image: linear-gradient(to right, rgb(43.8851764706%, 77.3571764706%, 40.6036078431%) 0%, rgb(27.1636078431%, 62.2356078431%, 23.7251764706%) 51%, rgb(43.8851764706%, 77.3571764706%, 40.6036078431%) 100%);
  border: none;
  color: #fff;
  background-size: auto 200%;
  transition: all 0.3s ease;
}
.btn-success-gradien:hover, .btn-success-gradien:focus, .btn-success-gradien:active, .btn-success-gradien.active, .btn-success-gradien.hover {
  transition: 1.5s;
  background-position: right center;
  background-image: linear-gradient(to right, rgb(43.8851764706%, 77.3571764706%, 40.6036078431%), 0%, rgb(27.1636078431%, 62.2356078431%, 23.7251764706%), 100%, #fff) !important;
}

.btn-danger-gradien {
  background-image: linear-gradient(to right, rgb(99.0611531741%, 41.4785478548%, 37.7231605513%) 0%, rgb(98.5859056494%, 11.8547854785%, 6.1984080761%) 51%, rgb(99.0611531741%, 41.4785478548%, 37.7231605513%) 100%);
  border: none;
  color: #fff;
  background-size: auto 200%;
  transition: all 0.3s ease;
}
.btn-danger-gradien:hover, .btn-danger-gradien:focus, .btn-danger-gradien:active, .btn-danger-gradien.active, .btn-danger-gradien.hover {
  transition: 1.5s;
  background-position: right center;
  background-image: linear-gradient(to right, rgb(99.0611531741%, 41.4785478548%, 37.7231605513%), 0%, rgb(98.5859056494%, 11.8547854785%, 6.1984080761%), 100%, #fff) !important;
}

.btn-warning-gradien {
  background-image: linear-gradient(to right, rgb(100%, 72.1066666667%, 17.9607843137%) 0%, rgb(85.9607843137%, 56.7341176471%, 0%) 51%, rgb(100%, 72.1066666667%, 17.9607843137%) 100%);
  border: none;
  color: #fff;
  background-size: auto 200%;
  transition: all 0.3s ease;
}
.btn-warning-gradien:hover, .btn-warning-gradien:focus, .btn-warning-gradien:active, .btn-warning-gradien.active, .btn-warning-gradien.hover {
  transition: 1.5s;
  background-position: right center;
  background-image: linear-gradient(to right, rgb(100%, 72.1066666667%, 17.9607843137%), 0%, rgb(85.9607843137%, 56.7341176471%, 0%), 100%, #fff) !important;
}

.btn-info-gradien {
  background-image: linear-gradient(to right, rgb(24.2257773402%, 81.7881696612%, 98.0487324637%) 0%, rgb(2.2663056855%, 69.1223234063%, 88.0082041185%) 51%, rgb(24.2257773402%, 81.7881696612%, 98.0487324637%) 100%);
  border: none;
  color: #fff;
  background-size: auto 200%;
  transition: all 0.3s ease;
}
.btn-info-gradien:hover, .btn-info-gradien:focus, .btn-info-gradien:active, .btn-info-gradien.active, .btn-info-gradien.hover {
  transition: 1.5s;
  background-position: right center;
  background-image: linear-gradient(to right, rgb(24.2257773402%, 81.7881696612%, 98.0487324637%), 0%, rgb(2.2663056855%, 69.1223234063%, 88.0082041185%), 100%, #fff) !important;
}

.btn-light-gradien {
  background-image: linear-gradient(to right, white 0%, rgb(87.6862745098%, 87.6862745098%, 87.6862745098%) 51%, white 100%);
  border: none;
  color: #fff;
  background-size: auto 200%;
  transition: all 0.3s ease;
}
.btn-light-gradien:hover, .btn-light-gradien:focus, .btn-light-gradien:active, .btn-light-gradien.active, .btn-light-gradien.hover {
  transition: 1.5s;
  background-position: right center;
  background-image: linear-gradient(to right, white, 0%, rgb(87.6862745098%, 87.6862745098%, 87.6862745098%), 100%, #fff) !important;
}

.btn-dark-gradien {
  background-image: linear-gradient(to right, rgb(23.8343412131%, 27.0844786513%, 34.1264431006%) 0%, rgb(10.6754627084%, 12.1312076232%, 15.2853216053%) 51%, rgb(23.8343412131%, 27.0844786513%, 34.1264431006%) 100%);
  border: none;
  color: #fff;
  background-size: auto 200%;
  transition: all 0.3s ease;
}
.btn-dark-gradien:hover, .btn-dark-gradien:focus, .btn-dark-gradien:active, .btn-dark-gradien.active, .btn-dark-gradien.hover {
  transition: 1.5s;
  background-position: right center;
  background-image: linear-gradient(to right, rgb(23.8343412131%, 27.0844786513%, 34.1264431006%), 0%, rgb(10.6754627084%, 12.1312076232%, 15.2853216053%), 100%, #fff) !important;
}

.btn {
  padding: 0.375rem 1.75rem;
}

.btn-lg, .btn-group-lg > .btn {
  font-size: 18px;
}

.btn-sm, .btn-group-sm > .btn {
  font-size: 12px;
}

.btn-xs {
  padding: 0.05rem 0.4rem;
  font-size: 11px;
}

.large-btn .btn {
  margin-right: 5px;
  margin-bottom: 15px;
}
.large-btn {
  margin-bottom: -20px;
}

.btn-outline-white {
  border: 1px solid #fff;
  color: #fff;
}
.btn-outline-white:hover, .btn-outline-white:focus {
  background: #fff;
  color: #212529;
}

.btn-air-primary {
  box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;
}
.btn-air-primary:hover, .btn-air-primary:active, .btn-air-primary:not([disabled]):not(.disabled):active {
  background-color: rgb(26.7973856209%, 20%, 100%);
  border-color: rgb(26.7973856209%, 20%, 100%);
}

.input-air-primary {
  box-shadow: 0 3px 5px 1px rgba(115, 102, 255, 0.1) !important;
}
.input-air-primary:focus {
  border-color: #7366ff;
}

.btn-air-secondary {
  box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;
}
.btn-air-secondary:hover, .btn-air-secondary:active, .btn-air-secondary:not([disabled]):not(.disabled):active {
  background-color: rgb(100%, 0%, 24.0196078431%);
  border-color: rgb(100%, 0%, 24.0196078431%);
}

.input-air-secondary {
  box-shadow: 0 3px 5px 1px rgba(255, 51, 100, 0.1) !important;
}
.input-air-secondary:focus {
  border-color: #ff3364;
}

.btn-air-success {
  box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;
}
.btn-air-success:hover, .btn-air-success:active, .btn-air-success:not([disabled]):not(.disabled):active {
  background-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%);
  border-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%);
}

.input-air-success {
  box-shadow: 0 3px 5px 1px rgba(84, 186, 74, 0.1) !important;
}
.input-air-success:focus {
  border-color: #54ba4a;
}

.btn-air-danger {
  box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;
}
.btn-air-danger:hover, .btn-air-danger:active, .btn-air-danger:not([disabled]):not(.disabled):active {
  background-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%);
  border-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%);
}

.input-air-danger {
  box-shadow: 0 3px 5px 1px rgba(252, 68, 56, 0.1) !important;
}
.input-air-danger:focus {
  border-color: #fc4438;
}

.btn-air-info {
  box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;
}
.btn-air-info:hover, .btn-air-info:active, .btn-air-info:not([disabled]):not(.disabled):active {
  background-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%);
  border-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%);
}

.input-air-info {
  box-shadow: 0 3px 5px 1px rgba(22, 199, 249, 0.1) !important;
}
.input-air-info:focus {
  border-color: #16c7f9;
}

.btn-air-light {
  box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;
}
.btn-air-light:hover, .btn-air-light:active, .btn-air-light:not([disabled]):not(.disabled):active {
  background-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%);
  border-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%);
}

.input-air-light {
  box-shadow: 0 3px 5px 1px rgba(244, 244, 244, 0.1) !important;
}
.input-air-light:focus {
  border-color: #f4f4f4;
}

.btn-air-dark {
  box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;
}
.btn-air-dark:hover, .btn-air-dark:active, .btn-air-dark:not([disabled]):not(.disabled):active {
  background-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%);
  border-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%);
}

.input-air-dark {
  box-shadow: 0 3px 5px 1px rgba(44, 50, 63, 0.1) !important;
}
.input-air-dark:focus {
  border-color: #2c323f;
}

.btn-air-warning {
  box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;
}
.btn-air-warning:hover, .btn-air-warning:active, .btn-air-warning:not([disabled]):not(.disabled):active {
  background-color: rgb(81.9607843137%, 54.0941176471%, 0%);
  border-color: rgb(81.9607843137%, 54.0941176471%, 0%);
}

.input-air-warning {
  box-shadow: 0 3px 5px 1px rgba(255, 170, 5, 0.1) !important;
}
.input-air-warning:focus {
  border-color: #ffaa05;
}

.btn-gradient {
  color: #fff !important;
  font-weight: 500;
  padding: 10px 30px;
  border-radius: 5px;
  background: linear-gradient(26deg, var(--theme-default) 0%, #a26cf8 100%);
  letter-spacing: 0.06rem;
}
.btn-gradient:hover {
  background-size: 100% !important;
}

.btn-warning {
  color: #fff;
}
.btn-warning:hover, .btn-warning.disabled {
  color: #fff;
}

[class*=-gradien]:hover {
  background-size: 50% 100%;
  transition: all 0.3s ease;
  color: #fff;
}

.btn-square {
  border-radius: 0px;
}

.btn-pill {
  border-radius: 60px;
}

.btn-group-pill .btn:first-child {
  border-radius: 60px 0 0 60px;
}
.btn-group-pill .btn:last-child {
  border-radius: 0 60px 60px 0;
}

.btn-group-square .btn:first-child {
  border-radius: 0px 0 0 0px;
}
.btn-group-square .btn:last-child {
  border-radius: 0 0px 0px 0;
}

.btn-showcase .btn {
  margin-bottom: 10px;
  margin-right: 10px;
}
.btn-showcase {
  margin-bottom: -10px;
}

.btn-dropdown-showcase .dropdown {
  margin-bottom: 10px;
  margin-right: 18px;
}
.btn-dropdown-showcase .btn-group {
  margin-bottom: 10px;
  margin-right: 18px;
}
.btn-dropdown-showcase {
  margin-bottom: -10px;
}

.btn-group .radio label::before {
  top: 2px;
}
.btn-group .radio label::after {
  top: 7px;
}
.btn-group .checkbox label {
  margin-top: 3px;
}

.btn-group-showcase > div {
  margin-bottom: -20px;
}
.btn-group-showcase > div label {
  margin-bottom: 0;
}
.btn-group-showcase .btn-group {
  margin-right: 20px;
  margin-bottom: 20px;
}
.btn-group-showcase .checkbox input[type=checkbox] {
  display: none;
}

.tooltiptext {
  visibility: visible;
  width: 120px;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -60px;
  opacity: 1;
  transition: opacity 0.3s;
}
.tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

/**=====================
     06. Button CSS end
==========================**/
/**=====================
    03.  Card CSS Start
==========================**/
.card {
  margin-bottom: 30px;
  border: none;
  transition: all 0.3s ease;
  letter-spacing: 0.5px;
  border-radius: 15px;
  box-shadow: 0px 9px 20px rgba(46, 35, 94, 0.07);
}
.card:hover {
  box-shadow: 0 0 40px rgba(8, 21, 66, 0.05);
  transition: all 0.3s ease;
}
.card .card-header {
  background-color: #fff;
  padding: 30px;
  border-bottom: 1px solid #ecf3fa;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  position: relative;
}
.card .card-header.card-no-border {
  border-bottom: none !important;
}
.card .card-header h5:not(.mb-0), .card .card-header .h5:not(.mb-0), .card .card-header h5:not(.m-0), .card .card-header .h5:not(.m-0) {
  margin-bottom: 0;
  text-transform: capitalize;
}
.card .card-header > span {
  font-size: 12px;
  color: #52526c;
  margin-top: 5px;
  display: block;
  letter-spacing: 1px;
}
.card .card-header .card-header-right {
  border-radius: 0 0 0 7px;
  right: 35px;
  top: 24px;
  display: inline-block;
  float: right;
  padding: 8px 0;
  position: absolute;
  background-color: #fff;
  z-index: 1;
}
.card .card-header .card-header-right .card-option {
  text-align: right;
  width: 35px;
  height: 20px;
  overflow: hidden;
  transition: 0.3s ease-in-out;
}
.card .card-header .card-header-right .card-option li {
  display: inline-block;
}
.card .card-header .card-header-right .card-option li:first-child i {
  transition: 1s;
  font-size: 16px;
  color: var(--theme-default);
}
.card .card-header .card-header-right .card-option li:first-child i.icofont {
  color: unset;
}
.card .card-header .card-header-right i {
  margin: 0 5px;
  cursor: pointer;
  color: #2c323f;
  line-height: 20px;
}
.card .card-header .card-header-right i.icofont-refresh {
  font-size: 13px;
}
.card .card-body {
  padding: 30px;
  background-color: transparent;
}
.card .card-body p:last-child {
  margin-bottom: 0;
}
.card .sub-title {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding-bottom: 5px;
  margin-bottom: 8px;
  font-size: 18px;
}
.card .card-footer {
  background-color: #fff;
  border-top: 1px solid #ecf3fa;
  padding: 30px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
}
.card.card-load .card-loader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 8;
  align-items: center;
  justify-content: center;
}
.card.card-load .card-loader i {
  margin: 0 auto;
  color: var(--theme-default);
  font-size: 20px;
}
.card.full-card {
  position: fixed;
  top: 0;
  z-index: 99999;
  box-shadow: none;
  right: 0;
  border-radius: 0;
  border: 1px solid #efefef;
  width: calc(100vw - 12px);
  height: 100vh;
}
.card.full-card .card-body {
  overflow: auto;
}

.page-body-wrapper .card .sub-title {
  font-family: Rubik, sans-serif;
  font-weight: normal;
  color: #52526c;
}

.card-absolute {
  margin-top: 20px;
}
.card-absolute .card-header {
  position: absolute;
  top: -20px;
  left: 15px;
  border-radius: 0.25rem;
  padding: 10px 15px;
}
.card-absolute .card-header h5, .card-absolute .card-header .h5 {
  font-size: 17px;
}
.card-absolute .card-body {
  margin-top: 10px;
}

.card-header .border-tab {
  margin-bottom: -13px;
}

.custom-card {
  overflow: hidden;
  padding: 30px;
}
.custom-card .card-header {
  padding: 0;
}
.custom-card .card-header img {
  border-radius: 50%;
  margin-top: -100px;
  transform: scale(1.5);
}
.custom-card .card-profile {
  text-align: center;
}
.custom-card .card-profile img {
  height: 110px;
  padding: 7px;
  background-color: #fff;
  z-index: 1;
  position: relative;
}
.custom-card .card-social {
  text-align: center;
}
.custom-card .card-social li {
  display: inline-block;
  padding: 15px 0;
}
.custom-card .card-social li:last-child a {
  margin-right: 0;
}
.custom-card .card-social li a {
  padding: 0;
  margin-right: 15px;
  color: rgb(188, 198, 222);
  font-size: 16px;
  transition: all 0.3s ease;
}
.custom-card .card-social li a:hover {
  color: var(--theme-default);
  transition: all 0.3s ease;
}
.custom-card .profile-details h6, .custom-card .profile-details .h6 {
  margin-bottom: 30px;
  margin-top: 10px;
  color: #52526c;
  font-size: 14px;
}
.custom-card .card-footer {
  padding: 0;
}
.custom-card .card-footer > div + div {
  border-left: 1px solid #efefef;
}
.custom-card .card-footer > div {
  padding: 15px;
  text-align: center;
}
.custom-card .card-footer > div h3, .custom-card .card-footer > div .h3 {
  margin-bottom: 0;
  font-size: 24px;
}
.custom-card .card-footer > div h6, .custom-card .card-footer > div .h6 {
  font-size: 14px;
  color: #52526c;
}
.custom-card .card-footer > div h5, .custom-card .card-footer > div .h5 {
  font-size: 16px;
  margin-bottom: 0;
}
.custom-card .card-footer > div i {
  font-size: 24px;
  display: inline-block;
  margin-bottom: 15px;
}
.custom-card .card-footer > div .m-b-card {
  margin-bottom: 10px;
}

.social-profile {
  text-align: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  background-repeat: no-repeat;
  background-size: cover;
}
.social-profile .card-body {
  padding-left: 20px;
  padding-right: 20px;
}
@media (max-width: 1399px) {
  .social-profile .card-body {
    padding: 23px 15px;
  }
}
.social-details {
  margin-top: 15px;
}
.social-details h5 a, .social-details .h5 a {
  color: var(--body-font-color);
}
.social-details .social-follow {
  column-count: 3;
  column-gap: 30px;
  margin-top: 25px;
}
@media (max-width: 1399px) {
  .social-details .social-follow {
    column-gap: 23px;
  }
}
.social-details .social-follow li {
  position: relative;
}
.social-details .social-follow li + li::before {
  position: absolute;
  content: "";
  width: 1px;
  height: 14px;
  background-color: var(--recent-dashed-border);
  left: -15px;
  top: 50%;
  transform: translateY(-50%);
}
[dir=rtl] .social-details .social-follow li + li::before {
  left: unset;
  right: -15px;
}
.social-details .card-social {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 15px;
}
.social-img-wrap {
  background: linear-gradient(253deg, var(--theme-default) 11.51%, rgba(115, 102, 255, 0) 82.07%);
  display: inline-block;
  border-radius: 100%;
  padding: 2px;
  position: relative;
}
.social-img-wrap .edit-icon {
  position: absolute;
  right: 0;
  bottom: 0;
}
.social-img-wrap .edit-icon svg {
  width: 20px;
  height: 20px;
  border-radius: 100%;
  border: 2px solid var(--white);
  background: var(--white);
}
.social-img {
  padding: 5px;
  background: var(--white);
  border-radius: 100%;
}
.social-img img {
  height: 68px;
  border-radius: 100%;
}

/**=====================
    03. Card CSS End
==========================**/
/**=====================
     07. Color CSS Start
==========================**/
.color-box {
  margin-bottom: -10px;
}
.color-box button {
  margin-bottom: 10px;
}
.color-box button + button {
  margin-left: 5px;
}

.light-font {
  color: #52526c;
}

/**=====================
     07. Color CSS Ends
==========================**/
/**=====================
    52. Datepicker CSS Start
==========================**/
.react-datepicker-popper {
  z-index: 2 !important;
}

.react-datepicker-wrapper {
  display: block !important;
}

.date-picker .react-datepicker__navigation {
  top: 8px;
}
.date-picker .theme-form .input-group {
  display: block !important;
}
.date-picker .theme-form .min-date .react-datepicker-wrapper {
  display: inline-block !important;
}

.react-datepicker__day--keyboard-selected,
.react-datepicker__month-text--keyboard-selected,
.react-datepicker__quarter-text--keyboard-selected,
.react-datepicker__year-text--keyboard-selected {
  background-color: var(--theme-default);
}
.react-datepicker__day--keyboard-selected:hover,
.react-datepicker__month-text--keyboard-selected:hover,
.react-datepicker__quarter-text--keyboard-selected:hover,
.react-datepicker__year-text--keyboard-selected:hover {
  background-color: var(--theme-default);
}

.react-datepicker {
  border: none !important;
  box-shadow: 0 4px 24px rgba(115, 102, 255, 0.08);
}
.react-datepicker .react-datepicker__navigation-icon--previous::before,
.react-datepicker .react-datepicker__navigation-icon--next::before {
  border-color: #fff;
}
.react-datepicker .react-datepicker__time-container {
  border-left: 1px solid #efefef;
}
.react-datepicker .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {
  background-color: var(--theme-default) !important;
}
.react-datepicker .react-datepicker__today-button {
  background-color: #fff !important;
  border-top: 1px solid #efefef;
}
.react-datepicker .react-datepicker__triangle {
  display: none;
}
.react-datepicker .react-datepicker__header {
  background-color: transparent !important;
  border-bottom: 1px solid #efefef;
}
.react-datepicker .react-datepicker__day-name {
  font-weight: 600;
}
.react-datepicker .react-datepicker__current-month {
  margin-bottom: 10px;
}
.react-datepicker .react-datepicker__current-month,
.react-datepicker .react-datepicker-time__header,
.react-datepicker .react-datepicker-year-header {
  color: var(--theme-default) !important;
}
.react-datepicker .react-datepicker__day-name,
.react-datepicker .react-datepicker__day,
.react-datepicker .react-datepicker__time-name {
  width: 30px !important;
  line-height: 30px !important;
}
.react-datepicker .react-datepicker__navigation--next {
  border-left-color: var(--theme-default) !important;
}
.react-datepicker .react-datepicker__navigation--previous {
  border-right-color: var(--theme-default) !important;
}
.react-datepicker .react-datepicker__day--selected,
.react-datepicker .react-datepicker__day--in-selecting-range,
.react-datepicker .react-datepicker__day--in-range,
.react-datepicker .react-datepicker__month-text--selected,
.react-datepicker .react-datepicker__month-text--in-selecting-range,
.react-datepicker .react-datepicker__month-text--in-range,
.react-datepicker .react-datepicker__quarter-text--selected,
.react-datepicker .react-datepicker__quarter-text--in-selecting-range,
.react-datepicker .react-datepicker__quarter-text--in-range {
  background-color: var(--theme-default) !important;
}
.react-datepicker .react-datepicker__day--selected:hover,
.react-datepicker .react-datepicker__day--in-selecting-range:hover,
.react-datepicker .react-datepicker__day--in-range:hover,
.react-datepicker .react-datepicker__month-text--selected:hover,
.react-datepicker .react-datepicker__month-text--in-selecting-range:hover,
.react-datepicker .react-datepicker__month-text--in-range:hover,
.react-datepicker .react-datepicker__quarter-text--selected:hover,
.react-datepicker .react-datepicker__quarter-text--in-selecting-range:hover,
.react-datepicker .react-datepicker__quarter-text--in-range:hover {
  background-color: var(--theme-default) !important;
}
.react-datepicker .react-datepicker__day--in-selecting-range,
.react-datepicker .react-datepicker__month-text--in-selecting-range,
.react-datepicker .react-datepicker__quarter-text--in-selecting-range {
  background-color: rgba(115, 102, 255, 0.15);
}
.react-datepicker .react-datepicker__month--selecting-range .react-datepicker__day--in-range,
.react-datepicker .react-datepicker__month--selecting-range .react-datepicker__month-text--in-range {
  color: #fff !important;
}
.react-datepicker .react-datepicker__quarter-text--in-range {
  color: #fff !important;
}
.react-datepicker .react-datepicker__day--today,
.react-datepicker .react-datepicker__day--selected {
  background-color: var(--theme-default) !important;
  color: #fff !important;
  border-radius: 0.3rem;
}

.classic_theme_container {
  height: 144px !important;
}

.react_times_button .wrapper {
  width: 100%;
}

.time_picker_wrapper2 {
  display: flex;
  width: auto !important;
}
.time_picker_wrapper2 .time_picker_container {
  width: 300px;
}
.time_picker_wrapper2 .time_picker_modal_container {
  top: unset !important;
  bottom: 82px !important;
}

.time_picker_wrapper,
.time_picker_wrapper2 {
  width: 300px;
}
.time_picker_wrapper .time_picker_container .time_picker_modal_header,
.time_picker_wrapper .time_picker_container .time_picker_modal_footer,
.time_picker_wrapper .time_picker_container .timezone_picker_modal_header,
.time_picker_wrapper2 .time_picker_container .time_picker_modal_header,
.time_picker_wrapper2 .time_picker_container .time_picker_modal_footer,
.time_picker_wrapper2 .time_picker_container .timezone_picker_modal_header {
  background-color: var(--theme-default);
}
.time_picker_wrapper .time_picker_container .picker_pointer,
.time_picker_wrapper2 .time_picker_container .picker_pointer {
  background-color: var(--theme-default);
}
.time_picker_wrapper .time_picker_container .picker_pointer .pointer_drag,
.time_picker_wrapper2 .time_picker_container .picker_pointer .pointer_drag {
  background-color: var(--theme-default);
}
.time_picker_wrapper .time_picker_container .picker_center,
.time_picker_wrapper2 .time_picker_container .picker_center {
  background-color: var(--theme-default);
}
.time_picker_wrapper .time_picker_container .classic_theme_container .classic_time.light.active, .time_picker_wrapper .time_picker_container .classic_theme_container .classic_time.light:hover,
.time_picker_wrapper2 .time_picker_container .classic_theme_container .classic_time.light.active,
.time_picker_wrapper2 .time_picker_container .classic_theme_container .classic_time.light:hover {
  background-color: var(--theme-default);
}
.time_picker_wrapper .gap,
.time_picker_wrapper2 .gap {
  padding: 10px;
}

.time_picker_modal_container {
  width: unset !important;
}

@media (max-width: 1660px) {
  .date-range {
    display: flex;
  }
}
@media (max-width: 1107px) {
  .date-range {
    display: unset;
  }
  .date-range .react-datepicker-wrapper:last-child {
    margin-top: 15px;
  }
}
@media (max-width: 575px) {
  .react-datepicker .react-datepicker__day-name,
  .react-datepicker .react-datepicker__day,
  .react-datepicker .react-datepicker__time-name {
    width: 25px !important;
    line-height: 25px !important;
  }
  .date-picker .theme-form .row .row .col-form-label {
    padding-left: 0;
  }
}
@media (max-width: 475px) {
  .date-range .react-datepicker-wrapper:last-child {
    margin-top: 15px;
  }
}
.calendar-basic .md-sidebar-aside {
  background-color: #fff;
}
.calendar-basic #external-events {
  padding: 20px;
  border: 1px solid #d7e2e9;
  background-color: var(--white);
  width: 100%;
}
.calendar-basic #external-events h4, .calendar-basic #external-events .h4 {
  margin-bottom: 14px;
}
.calendar-basic #external-events p {
  margin-top: 12px;
}
.calendar-basic #external-events .fc-h-event {
  padding: 12px;
  background-color: #7366ff;
  border: 1px solid #7366ff;
}
.calendar-basic #external-events .fc-h-event + .fc-h-event {
  margin-top: 10px;
}
.calendar-basic #external-events .fc-h-event .fc-event-main {
  font-size: 13px;
}
.calendar-basic .calendar-default .fc-daygrid-dot-event .fc-event-title {
  text-overflow: ellipsis;
}
.calendar-basic .calendar-default .fc td[role=presentation] {
  border: 0;
}
.calendar-basic .calendar-default .fc .fc-daygrid-day-number,
.calendar-basic .calendar-default .fc .fc-col-header-cell-cushion {
  color: #2f2f3b;
}
.calendar-basic .calendar-default .fc .fc-button .fc-icon {
  height: 23px;
}
.calendar-basic .calendar-default .fc-h-event {
  padding: 2px;
  background-color: #7366ff;
  border: 1px solid #7366ff;
}
.calendar-basic .calendar-default .fc-toolbar-chunk .fc-button-group ~ .fc-today-button {
  margin: 0 8px;
}

.fc-event-dragging {
  padding: 10px;
  background-color: var(--theme-default);
}

.fc .fc-toolbar {
  flex-wrap: wrap;
  gap: 10px;
}
.fc .fc-button-primary:focus {
  box-shadow: 0 0 0 0.2rem rgba(115, 102, 255, 0.5);
}

/**=====================
   52. Datepicker CSS End
==========================**/
/**=====================
    37. Dropdown CSS Start
==========================**/
.dropdown-divider {
  margin: 0;
}

.dropdown .dropdown-toggle {
  background-color: rgba(115, 102, 255, 0.08) !important;
  color: #7366ff;
  border-radius: 10px;
  padding: 5px 10px;
  width: 100px;
  text-align: left;
  border: none !important;
}
.dropdown .dropdown-toggle:after {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  content: "\\f107";
  border: none;
  font-family: "FontAwesome";
  font-size: 18px;
  margin: 0;
}
.dropdown .dropdown-toggle.btn-primary {
  color: #fff;
}
.dropdown .dropdown-menu {
  font-family: Rubik, sans-serif;
}

.docs-toggles .dropdown .dropdown-toggle {
  width: auto;
}

.nav-tabs .dropdown .dropdown-toggle {
  width: 120px;
}
@media only screen and (max-width: 575.98px) {
  .nav-tabs .dropdown .dropdown-toggle {
    width: 100%;
    text-align: center;
  }
}

.icon-dropdown .dropdown-toggle {
  background: transparent !important;
  color: #52526c;
  padding: 0;
  width: auto;
}
.icon-dropdown .dropdown-toggle i {
  font-size: 16px;
}
.icon-dropdown .dropdown-toggle::after {
  display: none;
}
.icon-dropdown .dropdown-item {
  line-height: 1.5;
}

.dropdown-basic {
  margin-bottom: -10px;
}
.dropdown-basic .btn-group {
  margin-right: 18px;
}
.dropdown-basic .btn-group .btn-round {
  border-radius: 50px;
}
.dropdown-basic .separated-btn {
  margin-left: -6px;
}
.dropdown-basic .separated-btn .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  padding: 10px;
}
.dropdown-basic button {
  max-height: 43px;
}
.dropdown-basic .dropdown {
  position: relative;
  display: inline-block;
  margin-bottom: 10px;
}
.dropdown-basic .dropdown .dropbtn {
  color: white;
  padding: 12px 35px;
  border: none;
  cursor: pointer;
}
.dropdown-basic .dropdown .dropdown-content {
  display: none;
  position: absolute;
  right: 0;
  background-color: #f9f9f9;
  min-width: 175px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  left: 0;
  top: 45px;
}
.dropdown-basic .dropdown .dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}
.dropdown-basic .dropdown .dropdown-content .dropdown-header {
  padding: 12px 16px;
}
.dropdown-basic .dropdown-content a:hover {
  background-color: #f1f1f1;
}
.dropdown-basic .dropdown:hover .dropdown-content {
  display: block;
}

.dropup-basic .dropup {
  position: relative;
  display: inline-block;
}
.dropup-basic .dropup .dropbtn {
  color: white;
  padding: 12px;
  border: none;
}
.dropup-basic .dropup .dropup-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 170px;
  bottom: 45px;
  z-index: 999;
  left: 0;
}
.dropup-basic .dropup .dropup-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}
.dropup-basic .dropup .dropup-content a:hover {
  background-color: #f1f1f1;
}
.dropup-basic .dropup:hover .dropup-content {
  display: block;
}
.dropup-basic .dropup:hover .dropup-content a.active {
  background-color: #f1f1f1;
}

/**=====================
    37. Dropdown CSS Ends
==========================**/
/**=====================
    30. Data-table CSS Start
==========================**/
div.dt-button-background {
  display: none !important;
}
div.DTS div.dataTables_scrollBody table {
  z-index: 1;
}
div .table-avtar {
  height: 32px;
  margin-right: 10px;
}
[dir=rtl] div .table-avtar {
  margin-right: unset;
  margin-left: 10px;
}
div .action {
  display: flex;
}
div .action i {
  font-size: 16px;
}
div .action .pdf i {
  font-size: 20px;
  color: #fc4438;
}
div .action .edit {
  margin-right: 5px;
}
div .action .edit i {
  color: #54ba4a;
}
[dir=rtl] div .action .edit {
  margin-left: 5px;
}
div .action .delete i {
  color: #fc4438;
}

#auto-generate-content_wrapper.dataTables_wrapper button {
  background-color: white;
  border: 1px solid var(--theme-default);
  color: var(--theme-default);
}

.dataTables_wrapper {
  width: calc(100% - 1px);
}
.dataTables_wrapper.no-footer .dataTables_scrollBody {
  border-bottom: 1px solid #ecf3fa;
}
.dataTables_wrapper .dt-buttons .btn {
  border-radius: 0.25rem !important;
}
.dataTables_wrapper {
  padding: 0;
}
.dataTables_wrapper .btn-group button {
  margin-right: 5px;
}
.dataTables_wrapper button {
  font-weight: 400;
  padding: 0.375rem 0.75rem;
  font-size: 14px;
  border-radius: 0.25rem;
  color: #fff;
}
.dataTables_wrapper + .dataTables_wrapper {
  margin-top: 20px;
}
.dataTables_wrapper .dataTables_paginate {
  margin-left: 15px !important;
  border: 1px solid #f4f4f4;
  border-radius: 0.25rem;
  padding-top: 0;
}
.dataTables_wrapper .dataTables_paginate .paginate_button {
  margin: 0;
}
.dataTables_wrapper .dataTables_paginate .paginate_button.current, .dataTables_wrapper .dataTables_paginate .paginate_button:active {
  background: var(--theme-default);
  color: #fff !important;
  box-shadow: none;
}
.dataTables_wrapper .dataTables_paginate .paginate_button:hover {
  border: 1px solid var(--theme-default);
  color: #2c323f !important;
  background: transparent !important;
}
.dataTables_wrapper .dataTables_length {
  margin-bottom: 30px;
}
.dataTables_wrapper .dataTables_length select {
  border-color: #f4f4f4;
  color: #2c323f;
  padding: 0 10px;
  margin: 0 10px;
  height: 2.7142em;
  background-color: #fff;
}
.dataTables_wrapper table.dataTable {
  border: 1px solid #efefef;
}
.dataTables_wrapper table.dataTable tbody td.select-checkbox,
.dataTables_wrapper table.dataTable tbody th.select-checkbox {
  padding-right: 40px !important;
}
.dataTables_wrapper table.dataTable tbody td.select-checkbox:before,
.dataTables_wrapper table.dataTable tbody th.select-checkbox:before {
  right: 20px;
  top: 22px;
  left: unset;
}
.dataTables_wrapper table.dataTable tbody td.select-checkbox:after,
.dataTables_wrapper table.dataTable tbody th.select-checkbox:after {
  margin-top: -5px;
  margin-left: 21px;
}
.dataTables_wrapper table.dataTable thead th,
.dataTables_wrapper table.dataTable thead td {
  border-bottom: 2px solid #efefef;
}
.dataTables_wrapper table.dataTable th,
.dataTables_wrapper table.dataTable td {
  padding: 0.75rem;
}
.dataTables_wrapper .dataTables_filter {
  margin-bottom: 25px;
  margin-left: 15px;
}
.dataTables_wrapper .dataTables_filter input[type=search] {
  border: 1px solid #efefef;
  padding: 0 10px;
  margin-left: 10px;
  height: 37px;
  border-radius: 0;
}

.dataTables_scrollHeadInner {
  width: 100% !important;
}

table .fixedHeader-floating {
  position: fixed !important;
  background-color: #fff;
}
table .box > div {
  padding: 5px 15px;
  background-color: var(--theme-default);
  display: inline-block;
  color: #fff;
  border-radius: 5px;
  margin-bottom: 15px;
  margin-right: 15px;
}
table.dataTable.fixedHeader-locked, table.dataTable.fixedHeader-floating {
  width: calc(100vw - 250px) !important;
  max-width: calc(100vw - 250px) !important;
  overflow: hidden !important;
  right: 0 !important;
  z-index: 99;
  left: 260px !important;
}
table.dataTable:not(.fixedHeader-locked):not(.fixedHeader-floating) {
  width: 100% !important;
}
table.dataTable {
  border-collapse: collapse !important;
  margin-top: 0 !important;
}
table.dataTable thead .sorting:before, table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:before,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:before,
table.dataTable thead .sorting_desc:after,
table.dataTable thead .sorting_asc_disabled:before,
table.dataTable thead .sorting_asc_disabled:after,
table.dataTable thead .sorting_desc_disabled:before,
table.dataTable thead .sorting_desc_disabled:after {
  bottom: 12px !important;
}
table.dataTable input,
table.dataTable select {
  border: 1px solid #efefef;
  height: 37px;
}

.user-datatable tr td:first-child,
.user-datatable tr th:first-child {
  min-width: 150px;
}

.jsgrid .jsgrid-button {
  width: 20px;
  height: 20px;
}
.jsgrid .jsgrid-delete-button {
  background-position: 0 -78px;
  width: 22px;
  height: 22px;
}
.jsgrid .jsgrid-edit-button {
  background-position: -2px -122px;
  width: 22px;
  height: 22px;
}
.jsgrid .jsgrid-insert-mode-button {
  background-position: -2px -160px;
  width: 25px;
  height: 25px;
}
.jsgrid .jsgrid-insert-button {
  background-position: -3px -202px;
  width: 16px;
  height: 16px;
}

.toolbar {
  padding: 5px 15px;
  background-color: var(--theme-default);
  display: inline-block;
  color: #fff;
  border-radius: 5px;
  margin-bottom: 15px;
  margin-right: 15px;
}

code.option {
  color: #fc4438 !important;
}
code.api {
  color: #54ba4a !important;
}

.dt-ext .dataTables_wrapper .page-item.active .page-link {
  background-color: var(--theme-default) !important;
  border-color: var(--theme-default) !important;
  color: #fff;
}
.dt-ext .dataTables_wrapper .dataTables_paginate {
  border: none;
}
.dt-ext .dataTables_wrapper .dataTables_paginate .paginate_button {
  padding: 0;
  border: none;
}
.dt-ext .dataTables_wrapper .dataTables_paginate .paginate_button.disabled, .dt-ext .dataTables_wrapper .dataTables_paginate .paginate_button.hover, .dt-ext .dataTables_wrapper .dataTables_paginate .paginate_button.active {
  border: none !important;
}
.dt-ext .dataTables_wrapper .dataTables_paginate .page-link {
  margin-left: 0px;
  color: var(--theme-default);
}
.dt-ext .dataTables_wrapper button.dt-button,
.dt-ext .dataTables_wrapper div.dt-button,
.dt-ext .dataTables_wrapper a.dt-button,
.dt-ext .dataTables_wrapper button.dt-button:focus:not(.disabled),
.dt-ext .dataTables_wrapper div.dt-button:focus:not(.disabled),
.dt-ext .dataTables_wrapper a.dt-button:focus:not(.disabled),
.dt-ext .dataTables_wrapper button.dt-button:active:not(.disabled),
.dt-ext .dataTables_wrapper button.dt-button.active:not(.disabled),
.dt-ext .dataTables_wrapper div.dt-button:active:not(.disabled),
.dt-ext .dataTables_wrapper div.dt-button.active:not(.disabled),
.dt-ext .dataTables_wrapper a.dt-button:active:not(.disabled),
.dt-ext .dataTables_wrapper a.dt-button.active:not(.disabled) {
  background-color: var(--theme-default);
  border-color: var(--theme-default);
  border-radius: 2px;
  color: #fff;
  background-image: none;
  font-size: 14px;
}
.dt-ext .dataTables_wrapper button.dt-button.btn-success,
.dt-ext .dataTables_wrapper div.dt-button.btn-success,
.dt-ext .dataTables_wrapper a.dt-button.btn-success {
  background-color: #54ba4a;
  border-color: #54ba4a;
}
.dt-ext .dataTables_wrapper button.dt-button.btn-primary,
.dt-ext .dataTables_wrapper div.dt-button.btn-primary,
.dt-ext .dataTables_wrapper a.dt-button.btn-primary {
  background-color: var(--theme-default);
  border-color: var(--theme-default);
}
.dt-ext .dataTables_wrapper button.dt-button.btn-danger,
.dt-ext .dataTables_wrapper div.dt-button.btn-danger,
.dt-ext .dataTables_wrapper a.dt-button.btn-danger {
  background-color: #fc4438;
  border-color: #fc4438;
}
.dt-ext .dataTables_wrapper table.dataTable th.focus,
.dt-ext .dataTables_wrapper table.dataTable td.focus {
  outline: 3px solid var(--theme-default);
}
.dt-ext .dataTables_wrapper table.dataTable.display tbody > tr.odd.selected > .sorting_1,
.dt-ext .dataTables_wrapper table.dataTable.order-column.stripe tbody > tr.odd.selected > .sorting_1 {
  background-color: white;
}
.dt-ext .dataTables_wrapper table.dataTable.stripe tbody > tr.odd.selected,
.dt-ext .dataTables_wrapper table.dataTable.stripe tbody > tr.odd > .selected,
.dt-ext .dataTables_wrapper table.dataTable.display tbody > tr.odd.selected,
.dt-ext .dataTables_wrapper table.dataTable.display tbody > tr.odd > .selected {
  background-color: white;
}
.dt-ext .dataTables_wrapper table.dataTable.display tbody > tr.even.selected > .sorting_1,
.dt-ext .dataTables_wrapper table.dataTable.order-column.stripe tbody > tr.even.selected > .sorting_1 {
  background-color: white;
}
.dt-ext .dataTables_wrapper table.dataTable tbody > tr.selected,
.dt-ext .dataTables_wrapper table.dataTable tbody > tr > .selected {
  background-color: white;
}

td.highlight {
  background-color: #f4f4f4 !important;
}

td.details-control {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) no-repeat center center;
  cursor: pointer;
}

.dataTables_scroll ~ .dataTables_paginate {
  margin-top: 20px !important;
}

.product-table th:last-child {
  min-width: 120px;
}
.product-table h6, .product-table .h6 {
  font-weight: 600;
  color: #2c323f;
}

table.dataTable.display tbody tr.odd > .sorting_1 {
  background-color: #fdfeff;
}

/**=====================
     30. Data-table CSS Ends
==========================**/
/**=====================
     29. Form Input CSS Start
==========================**/
.icon-addon .addon-md .fa, .icon-addon .addon-md .glyphicon {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 10px 0;
  top: 1px;
}

.icon-addon .glyphicon, .icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 10px 0;
  top: 1px;
}

.input-group-square .input-group-text, .input-group-square .form-control {
  border-radius: 0;
}

.input-group-solid .input-group-text, .input-group-solid .form-control {
  background: #f4f4f4;
}

.input-group-air {
  box-shadow: 0 3px 20px 0 #efefef;
}

.icon-addon {
  position: relative;
  color: #4c5667;
  display: block;
}
.icon-addon:after {
  display: table;
  content: "";
  clear: both;
}
.icon-addon:before {
  display: table;
  content: "";
}
.icon-addon .addon-md .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}
.pill-input-group span:last-child {
  border-top-right-radius: 1.3rem;
  border-bottom-right-radius: 1.3rem;
}
.pill-input-group span:first-child {
  border-top-left-radius: 1.3rem;
  border-bottom-left-radius: 1.3rem;
}

/**=====================
     29. Form Input CSS Ends
==========================**/
/**=====================
     48. Form Wizard CSS Start
==========================**/
ol {
  display: flex;
}
ol.progtrckr li {
  width: 100%;
}
ol.progtrckr li em {
  display: none;
}
ol.progtrckr li.progtrckr-todo:before, ol.progtrckr li.progtrckr-doing:before, ol.progtrckr li.progtrckr-done:before {
  font-size: 20px !important;
  width: 30px !important;
  height: 30px !important;
  line-height: 30px !important;
}

.multi-step {
  position: relative;
}
.multi-step .footer-buttons .btn-lg, .multi-step .footer-buttons .btn-group-lg > .btn {
  font-size: 14px;
}
.multi-step .btnsubmit {
  position: absolute;
  bottom: -34px;
  right: 15px;
}

@media (max-width: 485px) {
  ol.progtrckr li:before {
    bottom: -63px !important;
  }
  ol.progtrckr li span {
    padding: 0 !important;
  }
  ol.progtrckr li.progtrckr-todo:before, ol.progtrckr li.progtrckr-doing:before, ol.progtrckr li.progtrckr-done:before {
    font-size: 18px !important;
    width: 20px !important;
    height: 20px !important;
    line-height: 20px !important;
  }
}
/**=====================
    48. Form Wizard CSS Ends
==========================**/
/**=====================
    26. Form CSS Start
==========================**/
.form-label {
  margin-bottom: 4px;
}

.col-form-label {
  padding-bottom: 4px;
}

.form-space {
  margin-bottom: -10px;
}
.form-space > div {
  margin-bottom: 10px;
}

.theme-form .form-control :focus {
  box-shadow: 0 0 0 0.2rem rgba(171, 140, 228, 0.05);
}
.theme-form textarea {
  border-color: #efefef;
}
.theme-form textarea::-webkit-input-placeholder {
  color: #898989;
  font-size: 14px;
  letter-spacing: 1px;
  font-weight: 100;
}
.theme-form input[type=text],
.theme-form input[type=email],
.theme-form input[type=search],
.theme-form input[type=password],
.theme-form input[type=number],
.theme-form input[type=tel],
.theme-form input[type=date],
.theme-form input[type=datetime-local],
.theme-form input[type=time],
.theme-form input[type=datetime-local],
.theme-form input[type=month],
.theme-form input[type=week],
.theme-form input[type=url],
.theme-form input[type=file],
.theme-form textarea,
.theme-form select {
  border-color: #efefef;
  background-color: #fff;
  font-size: 14px;
  color: #898989;
  padding: 12px 10px;
  box-shadow: none;
}
.theme-form input[type=text]::-webkit-input-placeholder,
.theme-form input[type=email]::-webkit-input-placeholder,
.theme-form input[type=search]::-webkit-input-placeholder,
.theme-form input[type=password]::-webkit-input-placeholder,
.theme-form input[type=number]::-webkit-input-placeholder,
.theme-form input[type=tel]::-webkit-input-placeholder,
.theme-form input[type=date]::-webkit-input-placeholder,
.theme-form input[type=datetime-local]::-webkit-input-placeholder,
.theme-form input[type=time]::-webkit-input-placeholder,
.theme-form input[type=datetime-local]::-webkit-input-placeholder,
.theme-form input[type=month]::-webkit-input-placeholder,
.theme-form input[type=week]::-webkit-input-placeholder,
.theme-form input[type=url]::-webkit-input-placeholder,
.theme-form input[type=file]::-webkit-input-placeholder,
.theme-form textarea::-webkit-input-placeholder,
.theme-form select::-webkit-input-placeholder {
  color: #898989;
  font-size: 14px;
  letter-spacing: 1px;
  font-weight: 100;
}
.theme-form input[type=file] {
  height: auto;
}
.theme-form select.form-control:not([size]):not([multiple]) {
  border-color: #efefef;
  font-size: 14px;
}
.theme-form .checkbox label {
  padding-left: 10px;
}
.theme-form .form-divider {
  position: relative;
  clear: both;
  height: 0;
  margin: 30px 0;
  border-top: 1px solid #efefef;
}
.theme-form .form-divider:before {
  position: absolute;
  top: -11px;
  left: 40%;
  margin-left: -10px;
  padding: 0 5px;
  content: "Or Signup With";
  color: #242934;
  background: #fff;
}
.theme-form .login-divider {
  position: relative;
  clear: both;
  height: 0;
  margin: 30px 0;
  border-top: 1px solid #efefef;
}
.theme-form .login-divider:before {
  position: absolute;
  top: -11px;
  left: 40%;
  margin-left: -10px;
  padding: 0 5px;
  color: #242934;
  background: #fff;
  content: "Or Login With";
}
.theme-form .btn-fb,
.theme-form .btn-twitter,
.theme-form .btn-google,
.theme-form .btn-linkedin {
  color: #fff;
  width: 100%;
}
.theme-form .btn-fb {
  background-color: #50598e;
}
.theme-form .btn-twitter {
  background-color: #6fa2d8;
}
.theme-form .btn-google {
  background-color: #c64e40;
}
.theme-form .btn-linkedin {
  background-color: #0077b5;
}

.form-inline {
  display: flex;
  flex: 0 0 auto;
  flex-flow: row wrap;
  align-items: center;
  margin-bottom: 0;
}
.form-inline .col-form-label {
  margin-right: 5px;
}

.search-form .form-group:before {
  position: absolute;
  content: "";
  width: 1px;
  height: 25px;
  background: #e8ebf2;
  left: 82px;
  top: 50px;
}
.search-form .form-group:after {
  position: absolute;
  content: "\\f002";
  font-family: "FontAwesome";
  top: 53px;
  left: 53px;
  color: #8e8e8e;
}
.search-form input {
  border: 1px solid #efefef;
  padding: 10px 10px 10px 70px;
  border-radius: 10px;
  background-color: rgba(244, 244, 244, 0.3);
}
.search-form input:focus {
  outline: none !important;
}

.form-label-align-right label {
  text-align: right;
  padding-top: 17px;
  font-weight: 500;
}

/**=====================
    26. Form CSS Ends
==========================**/
/**=====================
    10. ICON CSS Start
==========================**/
.icon-lists div {
  cursor: pointer;
  line-height: 60px;
  white-space: nowrap;
  border-radius: 4px;
  display: flex;
  align-items: center;
}
.icon-lists div:hover {
  background-color: #fafafa;
}
.icon-lists div i {
  margin: 0 15px 0 10px;
  font-size: 24px;
}
.icon-lists.whether-icon svg {
  height: 50px;
  width: 50px;
}
.icon-lists.feather-icons .media svg {
  margin: 0 15px 0 10px;
}
.icon-lists .feather-icon .icon-first h6, .icon-lists .feather-icon .icon-first .h6 {
  display: none;
}

.flag-icons,
.feather-icons {
  margin-bottom: -15px;
  margin-top: -15px;
}
.flag-icons div,
.feather-icons div {
  line-height: 1;
  word-wrap: break-word;
  overflow: auto;
}
.flag-icons div .flag-icon,
.feather-icons div .flag-icon {
  height: 50px;
  width: 50px;
}
.flag-icons div .media,
.feather-icons div .media {
  padding-top: 15px;
  padding-bottom: 15px;
  width: 100%;
}
.flag-icons div .media-body h6, .flag-icons div .media-body .h6,
.feather-icons div .media-body h6,
.feather-icons div .media-body .h6 {
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  max-width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.flag-icons div .media-body h5, .flag-icons div .media-body .h5,
.feather-icons div .media-body h5,
.feather-icons div .media-body .h5 {
  background-color: var(--theme-default);
  display: inline-block;
  padding: 3px 5px;
  font-size: 11px;
  border-radius: 3px;
  margin-bottom: 5px;
  margin-right: 5px;
  color: #fff;
}

.icon-hover-bottom {
  background-color: #fdfeff;
  width: 100%;
  bottom: 0;
  left: 0;
  box-shadow: 0px 0px 1px 1px #f4f4f4;
  z-index: 999;
}
.icon-hover-bottom .icon-popup {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.icon-hover-bottom .icon-popup .close-icon {
  position: absolute;
  right: 10px;
  top: 10px;
  font-size: 20px;
  color: #cccccc;
  cursor: pointer;
}
[dir=rtl] .icon-hover-bottom .icon-popup .close-icon {
  right: unset;
  left: 10px;
}
.icon-hover-bottom .icon-popup {
  padding: 20px;
}
.icon-hover-bottom .icon-popup > div {
  display: inline-block;
}
.icon-hover-bottom .icon-popup > div .flag-icon {
  width: 60px;
  height: 60px;
}
.icon-hover-bottom .icon-popup .icon-class {
  margin: 0 20px;
  cursor: pointer;
}
.icon-hover-bottom .icon-popup .icon-last .form-inline .form-group {
  display: initial;
}
.icon-hover-bottom .icon-title {
  display: block;
  color: #2c323f;
  text-transform: uppercase;
  font-weight: 500;
}
.icon-hover-bottom span,
.icon-hover-bottom label,
.icon-hover-bottom .btn {
  font-family: Roboto, sans-serif;
}
.icon-hover-bottom .form-group input {
  display: inline-block;
  width: 300px;
  background-color: #fff;
  font-family: Roboto, sans-serif;
}

.fa-fa-icon-show-div,
.icons-show-div {
  display: none;
}

.icon-first i {
  color: #898989;
}
.icon-first h6, .icon-first .h6 {
  display: none;
}

/**=====================
     10. ICON CSS Ends
==========================**/
/**=====================
     17. List CSS Start
==========================**/
.list-group-item.active {
  background-color: var(--theme-default) !important;
  border-color: var(--theme-default) !important;
}

.list-group i {
  margin-right: 10px;
}
.list-group img {
  height: 40px;
  width: 40px;
  margin-right: 10px;
}

/**=====================
     17. List CSS Ends
==========================**/
/**=====================
     04. Loader CSS Start
==========================**/
.loader-wrapper {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  background-color: #fff;
  z-index: 11;
  top: 0;
  /*Color Loader*/
}
.loader-wrapper .loader-index {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  filter: url("#goo");
}
.loader-wrapper .loader-index:after {
  content: "";
  width: 4em;
  height: 4em;
  background: var(--theme-default);
  border-radius: 50%;
  position: absolute;
  transform: scale(0.5);
  animation: grow 2s cubic-bezier(0.14, 0.05, 0.55, 0.5) infinite alternate;
}
.loader-wrapper .loader-index span {
  width: 2em;
  height: 2em;
  background: var(--theme-secondary);
  border-radius: 50%;
  margin-right: 2em;
  position: relative;
  transform: translateX(7em);
  animation: move 4s ease-in-out infinite;
}
.loader-wrapper .loader-index span:before {
  content: "";
  width: 2em;
  height: 2em;
  background: var(--theme-default);
  border-radius: 50%;
  position: absolute;
  left: 3em;
  transform: translateX(0em);
  animation: shrink 2s ease-in-out infinite;
}
.loader-wrapper .loader-index span:after {
  content: "";
  width: 2em;
  height: 2em;
  background: #16c7f9;
  border-radius: 50%;
  position: absolute;
  right: 3em;
  transform: translateX(0em);
  animation: shrink 2s ease-in-out infinite;
}
@keyframes grow {
  0% {
    transform: scale(0.5);
    background: #16c7f9;
  }
  50% {
    transform: scale(1);
    background: var(--theme-secondary);
  }
}
@keyframes move {
  0% {
    transform: translateX(7em);
  }
  50% {
    transform: translateX(-5em);
  }
}
@keyframes shrink {
  0% {
    transform: translateX(0em);
  }
  50% {
    transform: translateX(-1em);
  }
}
.loader-wrapper svg {
  width: 0;
  height: 0;
}
.loader-wrapper {
  /*Color Loader*/
}
.loader-wrapper body {
  font-family: sans;
  min-height: 100vh;
  margin: 0;
  display: grid;
  place-content: center;
  background: black;
}
.loader-wrapper h1, .loader-wrapper .h1 {
  color: #fff;
  text-align: center;
  margin-bottom: 2em;
  letter-spacing: 3px;
  position: relative;
  z-index: 2;
}
.loader-wrapper h1:before, .loader-wrapper .h1:before {
  position: absolute;
  content: "";
  height: 1px;
  background: linear-gradient(to right, var(--theme-secondary), var(--theme-default), #16c7f9);
  color: #fff;
  top: 2.75em;
  left: 0.75em;
  width: 2.5em;
  font-weight: 400;
  font-variant: small-caps;
  font-size: 0.5em;
}

.loader-box {
  height: 150px;
  text-align: center;
  display: flex;
  align-items: center;
  vertical-align: middle;
  justify-content: center;
  transition: 0.3s color, 0.3s border, 0.3s transform, 0.3s opacity;
}
.loader-box [class*=loader-] {
  display: inline-block;
  width: 50px;
  height: 50px;
  color: inherit;
  vertical-align: middle;
}
.loader-box .loader-1 {
  border: 0.2em dotted var(--theme-default);
  border-radius: 50%;
  animation: 1s loader-01 linear infinite;
}
@keyframes loader-01 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.loader-box .loader-2 {
  border: 0.2em solid transparent;
  border-left-color: var(--theme-secondary);
  border-right-color: var(--theme-secondary);
  border-radius: 50%;
  animation: 1s loader-02 linear infinite;
}
@keyframes loader-02 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.loader-box .loader-3 {
  border: 0.2em solid #16c7f9;
  border-bottom-color: transparent;
  border-radius: 50%;
  animation: 1s loader-03 linear infinite;
  position: relative;
}
@keyframes loader-03 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.loader-box .loader-4 {
  border: 1px solid #16c7f9;
  border-radius: 50%;
  animation: 1s loader-04 linear infinite;
  position: relative;
}
.loader-box .loader-4:before {
  content: "";
  display: block;
  width: 0;
  height: 0;
  position: absolute;
  top: -0.2em;
  left: 50%;
  border: 0.2em solid #16c7f9;
  border-radius: 50%;
}
@keyframes loader-04 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.loader-box .loader-5 {
  border: 0.2em solid transparent;
  border-top-color: #ffaa05;
  border-radius: 50%;
  animation: 1s loader-05 linear infinite;
  position: relative;
}
.loader-box .loader-5:before {
  content: "";
  display: block;
  width: inherit;
  height: inherit;
  position: absolute;
  top: -0.2em;
  left: -0.2em;
  border: 0.2em solid #ffaa05;
  border-radius: 50%;
  opacity: 0.5;
}
@keyframes loader-05 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.loader-box .loader-6 {
  border: 0.2em solid #fc4438;
  border-radius: 50%;
  animation: loader-06 1s ease-out infinite;
}
@keyframes loader-06 {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}
.loader-box .loader-7 {
  border: 0 solid transparent;
  border-radius: 50%;
  position: relative;
}
.loader-box .loader-7:before, .loader-box .loader-7:after {
  content: "";
  border: 0.2em solid var(--theme-default);
  border-radius: 50%;
  width: inherit;
  height: inherit;
  position: absolute;
  top: 0;
  left: 0;
  animation: loader-07 1s linear infinite;
  opacity: 0;
}
.loader-box .loader-7:before {
  animation-delay: 1s;
}
.loader-box .loader-7:after {
  animation-delay: 0.5s;
}
@keyframes loader-07 {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}
.loader-box .loader-8 {
  position: relative;
}
.loader-box .loader-8:before, .loader-box .loader-8:after {
  content: "";
  width: inherit;
  height: inherit;
  border-radius: 50%;
  background-color: var(--theme-secondary);
  opacity: 0.6;
  position: absolute;
  top: 0;
  left: 0;
  animation: loader-08 2s infinite ease-in-out;
}
.loader-box .loader-8:after {
  animation-delay: -1s;
}
@keyframes loader-08 {
  0%, 100% {
    transform: scale(0);
  }
  50% {
    transform: scale(1);
  }
}
.loader-box .loader-9 {
  background-color: #16c7f9;
  border-radius: 50%;
  animation: loader-09 1s infinite ease-in-out;
}
@keyframes loader-09 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}
.loader-box .loader-10 {
  position: relative;
  animation: loader-10-1 2s infinite linear;
}
.loader-box .loader-10:before, .loader-box .loader-10:after {
  content: "";
  width: 0;
  height: 0;
  border: 0.5em solid #16c7f9;
  display: block;
  position: absolute;
  border-radius: 100%;
  animation: loader-10-2 2s infinite ease-in-out;
}
.loader-box .loader-10:before {
  top: 0;
  left: 50%;
}
.loader-box .loader-10:after {
  bottom: 0;
  right: 50%;
  animation-delay: -1s;
}
@keyframes loader-10-1 {
  100% {
    transform: rotate(360deg);
  }
}
@keyframes loader-10-2 {
  0%, 100% {
    transform: scale(0);
  }
  50% {
    transform: scale(1);
  }
}
.loader-box .loader-11 {
  background-color: #ffaa05;
  animation: loader-11 1.2s infinite ease-in-out;
}
@keyframes loader-11 {
  0% {
    transform: perspective(120px) rotateX(0deg) rotateY(0deg);
  }
  50% {
    transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
  }
  100% {
    transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
  }
}
.loader-box .loader-12 {
  position: relative;
}
.loader-box .loader-12:before, .loader-box .loader-12:after {
  content: "";
  display: block;
  position: absolute;
  background-color: #fc4438;
  left: 50%;
  right: 0;
  top: 0;
  bottom: 50%;
  box-shadow: -0.5em 0 0 #fc4438;
  animation: loader-12 1s linear infinite;
}
.loader-box .loader-12:after {
  top: 50%;
  bottom: 0;
  animation-delay: 0.25s;
}
@keyframes loader-12 {
  0%, 100% {
    box-shadow: -0.5em 0 0 transparent;
    background-color: #fc4438;
  }
  50% {
    box-shadow: -0.5em 0 0 #fc4438;
    background-color: transparent;
  }
}
.loader-box .loader-13:before,
.loader-box .loader-13:after,
.loader-box .loader-13 {
  border-radius: 50%;
  animation-fill-mode: both;
  animation: loader-13 1.8s infinite ease-in-out;
}
.loader-box .loader-13 {
  color: var(--theme-default);
  position: relative;
  transform: translateZ(0);
  animation-delay: -0.16s;
  top: -1em;
}
.loader-box .loader-13:before {
  right: 100%;
  animation-delay: -0.32s;
}
.loader-box .loader-13:after {
  left: 100%;
}
.loader-box .loader-13:before, .loader-box .loader-13:after {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  width: inherit;
  height: inherit;
}
@keyframes loader-13 {
  0%, 80%, 100% {
    box-shadow: 0 1em 0 -1em;
  }
  40% {
    box-shadow: 0 1em 0 -0.2em;
  }
}
.loader-box .loader-14 {
  border-radius: 50%;
  box-shadow: 0 1em 0 -0.2em var(--theme-secondary);
  position: relative;
  animation: loader-14 0.8s ease-in-out alternate infinite;
  animation-delay: 0.32s;
  top: -1em;
}
.loader-box .loader-14:after, .loader-box .loader-14:before {
  content: "";
  position: absolute;
  width: inherit;
  height: inherit;
  border-radius: inherit;
  box-shadow: inherit;
  animation: inherit;
}
.loader-box .loader-14:before {
  left: -1em;
  animation-delay: 0.48s;
}
.loader-box .loader-14:after {
  right: -1em;
  animation-delay: 0.16s;
}
@keyframes loader-14 {
  0% {
    box-shadow: 0 2em 0 -0.2em var(--theme-secondary);
  }
  100% {
    box-shadow: 0 1em 0 -0.2em var(--theme-secondary);
  }
}
.loader-box .loader-15 {
  background: #16c7f9;
  position: relative;
  animation: loader-15 1s ease-in-out infinite;
  animation-delay: 0.4s;
  width: 0.25em;
  height: 0.5em;
  margin: 0 0.5em;
}
.loader-box .loader-15:after, .loader-box .loader-15:before {
  content: "";
  position: absolute;
  width: inherit;
  height: inherit;
  background: inherit;
  animation: inherit;
}
.loader-box .loader-15:before {
  right: 0.5em;
  animation-delay: 0.2s;
}
.loader-box .loader-15:after {
  left: 0.5em;
  animation-delay: 0.6s;
}
@keyframes loader-15 {
  0%, 100% {
    box-shadow: 0 0 0 #16c7f9, 0 0 0 #16c7f9;
  }
  50% {
    box-shadow: 0 -0.25em 0 #16c7f9, 0 0.25em 0 #16c7f9;
  }
}
.loader-box .loader-16 {
  transform: rotateZ(45deg);
  perspective: 1000px;
  border-radius: 50%;
}
.loader-box .loader-16:before, .loader-box .loader-16:after {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: inherit;
  height: inherit;
  border-radius: 50%;
  animation: 1s spin linear infinite;
}
.loader-box .loader-16:before {
  transform: rotateX(70deg);
}
.loader-box .loader-16:after {
  transform: rotateY(70deg);
  animation-delay: 0.4s;
}
@keyframes rotate {
  0% {
    transform: translate(-50%, -50%) rotateZ(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotateZ(360deg);
  }
}
@keyframes rotateccw {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(-360deg);
  }
}
@keyframes spin {
  0%, 100% {
    box-shadow: 0.2em 0px 0 0px #16c7f9;
  }
  12% {
    box-shadow: 0.2em 0.2em 0 0 #16c7f9;
  }
  25% {
    box-shadow: 0 0.2em 0 0px #16c7f9;
  }
  37% {
    box-shadow: -0.2em 0.2em 0 0 #16c7f9;
  }
  50% {
    box-shadow: -0.2em 0 0 0 #16c7f9;
  }
  62% {
    box-shadow: -0.2em -0.2em 0 0 #16c7f9;
  }
  75% {
    box-shadow: 0px -0.2em 0 0 #16c7f9;
  }
  87% {
    box-shadow: 0.2em -0.2em 0 0 #16c7f9;
  }
}
.loader-box .loader-17 {
  position: relative;
  background-color: #ffaa05;
  border-radius: 50%;
}
.loader-box .loader-17:after, .loader-box .loader-17:before {
  content: "";
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  opacity: 0.8;
}
.loader-box .loader-17:after {
  left: -0.5em;
  top: -0.25em;
  background-color: #ffaa05;
  transform-origin: 30px 35px;
  animation: loader-17 1s linear infinite;
  opacity: 0.6;
}
.loader-box .loader-17:before {
  left: -1.25em;
  top: -0.75em;
  background-color: #ffaa05;
  transform-origin: 40px 40px;
  animation: loader-17 2s linear infinite;
}
@keyframes loader-17 {
  0% {
    transform: rotateZ(0deg) translate3d(0, 0, 0);
  }
  100% {
    transform: rotateZ(360deg) translate3d(0, 0, 0);
  }
}
.loader-box .loader-18 {
  position: relative;
}
.loader-box .loader-18:before, .loader-box .loader-18:after {
  content: "";
  display: block;
  position: absolute;
  border-radius: 50%;
  border: 0.1em solid transparent;
  border-bottom-color: #fc4438;
  top: 0;
  left: 0;
  animation: 1s loader-18 linear infinite;
}
.loader-box .loader-18:before {
  width: 40px;
  height: 40px;
}
.loader-box .loader-18:after {
  width: 30px;
  height: 30px;
  top: 0.1em;
  left: 0.1em;
  animation-direction: reverse;
}
@keyframes loader-18 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.loader-box .loader-19 {
  border-top: 0.2em solid var(--theme-default);
  border-right: 0.2em solid transparent;
  animation: loader-19 1s linear infinite;
  border-radius: 100%;
  position: relative;
}
@keyframes loader-19 {
  to {
    transform: rotate(360deg);
  }
}
.loader-box .loader-20 {
  background-color: transparent;
  box-shadow: inset 0px 0px 0px 0.1em var(--theme-secondary);
  border-radius: 50%;
  position: relative;
}
.loader-box .loader-20:after, .loader-box .loader-20:before {
  position: absolute;
  content: "";
  background-color: var(--theme-secondary);
  top: 24px;
  left: 24px;
  height: 0.1em;
  transform-origin: left center;
}
.loader-box .loader-20:after {
  width: 0.4em;
  animation: loader-20 2s linear infinite;
}
.loader-box .loader-20:before {
  width: 20px;
  animation: loader-20 8s linear infinite;
}
@keyframes loader-20 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.loader-box .loader-21 {
  position: relative;
}
.loader-box .loader-21:before, .loader-box .loader-21:after {
  position: absolute;
  content: "";
}
.loader-box .loader-21:before {
  width: 80%;
  height: 80%;
  left: 10%;
  bottom: 10%;
  border-radius: 100% 100% 100% 0;
  box-shadow: 0px 0px 0px 0.1em #16c7f9;
  animation: loader-21 1s linear infinite;
  transform: rotate(-46deg);
}
.loader-box .loader-21:after {
  width: 1em;
  height: 0.3em;
  border-radius: 100%;
  left: 0;
  background-color: rgba(255, 255, 255, 0.2);
  bottom: -0.2em;
  z-index: -1;
}
@keyframes loader-21 {
  0% {
    top: 0;
  }
  50% {
    top: -5px;
  }
  100% {
    top: 0;
  }
}
.loader-box .loader-22 {
  border: 0.1em #16c7f9 solid;
  border-radius: 100%;
  position: relative;
  overflow: hidden;
  z-index: 1;
}
.loader-box .loader-22:after, .loader-box .loader-22:before {
  position: absolute;
  content: "";
  background-color: #16c7f9;
}
.loader-box .loader-22:after {
  width: 50%;
  height: 0.1em;
  left: 50%;
  top: 50%;
  transform-origin: left center;
  animation: loader-22 2s linear infinite alternate;
}
.loader-box .loader-22:before {
  width: 100%;
  height: 40%;
  left: 0;
  bottom: 0;
}
@keyframes loader-22 {
  0% {
    transform: rotate(-160deg);
  }
  100% {
    transform: rotate(-20deg);
  }
}
.loader-box .loader-23 {
  height: 0.5em;
  border: 0.1em #ffaa05 solid;
  border-radius: 0.1em;
  position: relative;
  animation: loader-23 5s linear infinite;
}
.loader-box .loader-23:after {
  width: 0.07em;
  height: 100%;
  background-color: #ffaa05;
  border-radius: 0px 0.5em 0.5em 0px;
  position: absolute;
  content: "";
  top: 0;
  left: calc(100% + 0.1em);
}
@keyframes loader-23 {
  0% {
    box-shadow: inset 0px 0px 0px #ffaa05;
  }
  100% {
    box-shadow: inset 1em 0px 0px #ffaa05;
  }
}
.loader-box .loader-24 {
  width: 0.8em;
  height: 1em;
  border: 0.1em #fc4438 solid;
  border-radius: 0px 0px 0.2em 0.2em;
  position: relative;
}
.loader-box .loader-24:after, .loader-box .loader-24:before {
  position: absolute;
  content: "";
}
.loader-box .loader-24:after {
  width: 0.2em;
  height: 50%;
  border: 0.1em #fc4438 solid;
  border-left: none;
  border-radius: 0px 0.5em 0.5em 0px;
  left: calc(100% + 0.1em);
  top: 0.1em;
}
.loader-box .loader-24:before {
  width: 0.1em;
  height: 0.3em;
  background-color: #fc4438;
  top: -0.3em;
  left: 0.05em;
  box-shadow: 0.2em 0px 0px 0px #fc4438, 0.2em -0.2em 0px 0px #fc4438, 0.4em 0px 0px 0px #fc4438;
  animation: loader-24 1s linear infinite alternate;
}
@keyframes loader-24 {
  0% {
    height: 0px;
  }
  100% {
    height: 6px;
  }
}
.loader-box .loader-25 {
  border: 0.1em var(--theme-default) solid;
  position: relative;
  animation: loader-25-1 5s linear infinite;
}
.loader-box .loader-25:after {
  width: 0.2em;
  height: 0.2em;
  position: absolute;
  content: "";
  background-color: var(--theme-default);
  bottom: calc(100% + 0.2em);
  left: -0.4em;
  animation: loader-25-2 1s ease-in-out infinite;
}
@keyframes loader-25-1 {
  0% {
    box-shadow: inset 0 0 0 0 var(--theme-default);
  }
  100% {
    box-shadow: inset 0 -1em 0 0 var(--theme-default);
  }
}
@keyframes loader-25-2 {
  25% {
    left: calc(100% + 0.2em);
    bottom: calc(100% + 0.2em);
  }
  50% {
    left: calc(100% + 0.2em);
    bottom: -0.4em;
  }
  75% {
    left: -0.4em;
    bottom: -0.4em;
  }
  100% {
    left: -0.4em;
    bottom: calc(100% + 0.2em);
  }
}
.loader-box .loader-26 {
  width: 0.5em;
  height: 0.5em;
  background-color: var(--theme-secondary);
  box-shadow: 1em 0px 0px var(--theme-secondary);
  border-radius: 50%;
  animation: loader-26 1s ease-in-out infinite alternate;
}
@keyframes loader-26 {
  0% {
    opacity: 0.1;
    transform: rotate(0deg) scale(0.5);
  }
  100% {
    opacity: 1;
    transform: rotate(360deg) scale(1.2);
  }
}
.loader-box .loader-29 {
  border-radius: 50%;
  box-shadow: inset 0 0 0 0.1em #16c7f9, -0.5em -0.5em 0 -0.4em #16c7f9, 0 -0.7em 0 -0.4em #16c7f9, 0.5em -0.5em 0 -0.4em #16c7f9, -0.5em 0.5em 0 -0.4em #16c7f9, 0 0.7em 0 -0.4em #16c7f9, 0.5em 0.5em 0 -0.4em #16c7f9, -0.7em 0 0 -0.4em #16c7f9, 0.7em 0 0 -0.4em #16c7f9;
  animation: 5s loader-29 linear infinite;
}
@keyframes loader-29 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.loader-box .loader-30 {
  border: 0.2em solid transparent;
  border-top-color: #16c7f9;
  border-bottom-color: #16c7f9;
  border-radius: 50%;
  position: relative;
  animation: 1s loader-30 linear infinite;
}
.loader-box .loader-30:before, .loader-box .loader-30:after {
  content: "";
  display: block;
  width: 0;
  height: 0;
  position: absolute;
  border: 0.2em solid transparent;
  border-bottom-color: #16c7f9;
}
.loader-box .loader-30:before {
  transform: rotate(135deg);
  right: -0.3em;
  top: -0.05em;
}
.loader-box .loader-30:after {
  transform: rotate(-45deg);
  left: -0.3em;
  bottom: -0.05em;
}
@keyframes loader-30 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.loader-box .loader-31 {
  box-shadow: 0 0 2em #ffaa05;
  background-color: #ffaa05;
  position: relative;
  border-radius: 50%;
  transform: rotateX(-60deg) perspective(1000px);
}
.loader-box .loader-31:before, .loader-box .loader-31:after {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: inherit;
  height: inherit;
  border-radius: inherit;
  animation: 1s loader-31 ease-out infinite;
}
.loader-box .loader-31:after {
  animation-delay: 0.4s;
}
@keyframes loader-31 {
  0% {
    opacity: 1;
    transform: rotate(0deg);
    box-shadow: 0 0 0 -0.5em #ffaa05, 0 0 0 -0.5em #ffaa05, 0 0 0 -0.5em #ffaa05, 0 0 0 -0.5em #ffaa05, 0 0 0 -0.5em #ffaa05, 0 0 0 -0.5em #ffaa05, 0 0 0 -0.5em #ffaa05, 0 0 0 -0.5em #ffaa05;
  }
  100% {
    opacity: 0;
    transform: rotate(180deg);
    box-shadow: -1em -1em 0 -0.35em #ffaa05, 0 -1.5em 0 -0.35em #ffaa05, 1em -1em 0 -0.35em #ffaa05, -1.5em 0 0 -0.35em #ffaa05, 1.5em -0 0 -0.35em #ffaa05, -1em 1em 0 -0.35em #ffaa05, 0 1.5em 0 -0.35em #ffaa05, 1em 1em 0 -0.35em #ffaa05;
  }
}
.loader-box .loader-32 {
  position: relative;
  border-radius: 50%;
  box-shadow: 0 0 1em 0 #fc4438, inset 0 0 1em 0 #fc4438;
  animation: 1s loader-32 linear infinite;
}
.loader-box .loader-32:before, .loader-box .loader-32:after {
  content: "";
  display: block;
  width: inherit;
  height: inherit;
  position: absolute;
  border-radius: 50%;
}
.loader-box .loader-32:before {
  border-top: 0.2em solid #fc4438;
  border-right: 0.2em solid transparent;
  top: 0.28em;
  right: calc(50% - 0.22em);
}
.loader-box .loader-32:after {
  border-bottom: 0.2em solid #fc4438;
  border-left: 0.2em solid transparent;
  bottom: 0.28em;
  left: calc(50% - 0.22em);
}
@keyframes loader-32 {
  0% {
    transform: rotateX(-60deg) rotateZ(0deg);
  }
  100% {
    transform: rotateX(-60deg) rotateZ(360deg);
  }
}
.loader-box .loader-34 {
  position: relative;
  width: 1em;
  height: 0.5em;
}
.loader-box .loader-34:after, .loader-box .loader-34:before {
  position: absolute;
  content: "";
  height: 0.4em;
  width: 0.4em;
  top: 0;
  background-color: var(--theme-default);
  border-radius: 50%;
}
.loader-box .loader-34:after {
  right: 0;
  animation: loader-34-2 0.5s ease-in-out infinite;
  animation-direction: alternate;
}
.loader-box .loader-34:before {
  left: 0;
  animation: loader-34-1 0.5s ease-in-out infinite;
  animation-direction: alternate;
}
@keyframes loader-34-1 {
  0% {
    transform: translatex(0px);
  }
  65% {
    height: 0.4em;
    width: 0.4em;
  }
  100% {
    height: 0.5em;
    width: 0.3em;
    transform: translatex(0.2em);
  }
}
@keyframes loader-34-2 {
  0% {
    transform: translatex(0px);
  }
  65% {
    height: 0.4em;
    width: 0.4em;
  }
  100% {
    height: 0.5em;
    width: 0.3em;
    transform: translatex(-0.2em);
  }
}
.loader-box .loader-35 {
  margin: 0 0.5em;
  position: relative;
}
.loader-box .loader-35:before {
  border-radius: 50%;
  background-color: var(--theme-secondary);
  animation: loader-35 3s cubic-bezier(0.77, 0, 0.175, 1) infinite;
  content: "";
  width: inherit;
  height: inherit;
  top: 0;
  left: 0;
  position: absolute;
}
@keyframes loader-35 {
  0% {
    transform: translateX(0) scale(1);
  }
  25% {
    transform: translateX(-100%) scale(0.3);
  }
  50% {
    transform: translateX(0) scale(1);
  }
  75% {
    transform: translateX(100%) scale(0.3);
  }
  100% {
    transform: translateX(0) scale(1);
  }
}
.loader-box .loader-37 {
  border-right: 0.1em solid #16c7f9;
  border-radius: 100%;
  animation: loader-37 800ms linear infinite;
}
.loader-box .loader-37:before, .loader-box .loader-37:after {
  content: "";
  width: 0.8em;
  height: 0.8em;
  display: block;
  position: absolute;
  top: calc(50% - 0.4em);
  left: calc(50% - 0.4em);
  border-left: 0.08em solid #16c7f9;
  border-radius: 100%;
  animation: loader-37 400ms linear infinite reverse;
}
.loader-box .loader-37:after {
  width: 0.6em;
  height: 0.6em;
  top: calc(50% - 0.3em);
  left: calc(50% - 0.3em);
  border: 0;
  border-right: 0.05em solid #16c7f9;
  animation: none;
}
@keyframes loader-37 {
  from {
    transform: rotate(360deg);
  }
  to {
    transform: rotate(0deg);
  }
}
.loader-box .loader-38 {
  height: 0.1em;
  width: 0.1em;
  box-shadow: -0.2em -0.2em 0 0.1em #16c7f9, -0.2em -0.2em 0 0.1em #16c7f9, -0.2em -0.2em 0 0.1em #16c7f9, -0.2em -0.2em 0 0.1em #16c7f9;
  animation: loader-38 6s infinite;
}
@keyframes loader-38 {
  0% {
    box-shadow: -0.2em -0.2em 0 0.1em #16c7f9, -0.2em -0.2em 0 0.1em #16c7f9, -0.2em -0.2em 0 0.1em #16c7f9, -0.2em -0.2em 0 0.1em #16c7f9;
  }
  8.33% {
    box-shadow: -0.2em -0.2em 0 0.1em #16c7f9, 0.2em -0.2em 0 0.1em #16c7f9, 0.2em -0.2em 0 0.1em #16c7f9, 0.2em -0.2em 0 0.1em #16c7f9;
  }
  16.66% {
    box-shadow: -0.2em -0.2em 0 0.1em #16c7f9, 0.2em -0.2em 0 0.1em #16c7f9, 0.2em 0.2em 0 0.1em #16c7f9, 0.2em 0.2em 0 0.1em #16c7f9;
  }
  24.99% {
    box-shadow: -0.2em -0.2em 0 0.1em #16c7f9, 0.2em -0.2em 0 0.1em #16c7f9, 0.2em 0.2em 0 0.1em #16c7f9, -0.2em 0.2em 0 0.1em #16c7f9;
  }
  33.32% {
    box-shadow: -0.2em -0.2em 0 0.1em #16c7f9, 0.2em -0.2em 0 0.1em #16c7f9, 0.2em 0.2em 0 0.1em #16c7f9, -0.2em -0.2em 0 0.1em #16c7f9;
  }
  41.65% {
    box-shadow: 0.2em -0.2em 0 0.1em #16c7f9, 0.2em -0.2em 0 0.1em #16c7f9, 0.2em 0.2em 0 0.1em #16c7f9, 0.2em -0.2em 0 0.1em #16c7f9;
  }
  49.98% {
    box-shadow: 0.2em 0.2em 0 0.1em #16c7f9, 0.2em 0.2em 0 0.1em #16c7f9, 0.2em 0.2em 0 0.1em #16c7f9, 0.2em 0.2em 0 0.1em #16c7f9;
  }
  58.31% {
    box-shadow: -0.2em 0.2em 0 0.1em #16c7f9, -0.2em 0.2em 0 0.1em #16c7f9, 0.2em 0.2em 0 0.1em #16c7f9, -0.2em 0.2em 0 0.1em #16c7f9;
  }
  66.64% {
    box-shadow: -0.2em -0.2em 0 0.1em #16c7f9, -0.2em -0.2em 0 0.1em #16c7f9, 0.2em 0.2em 0 0.1em #16c7f9, -0.2em 0.2em 0 0.1em #16c7f9;
  }
  74.97% {
    box-shadow: -0.2em -0.2em 0 0.1em #16c7f9, 0.2em -0.2em 0 0.1em #16c7f9, 0.2em 0.2em 0 0.1em #16c7f9, -0.2em 0.2em 0 0.1em #16c7f9;
  }
  83.3% {
    box-shadow: -0.2em -0.2em 0 0.1em #16c7f9, 0.2em 0.2em 0 0.1em #16c7f9, 0.2em 0.2em 0 0.1em #16c7f9, -0.2em 0.2em 0 0.1em #16c7f9;
  }
  91.63% {
    box-shadow: -0.2em -0.2em 0 0.1em #16c7f9, -0.2em 0.2em 0 0.1em #16c7f9, -0.2em 0.2em 0 0.1em #16c7f9, -0.2em 0.2em 0 0.1em #16c7f9;
  }
  100% {
    box-shadow: -0.2em -0.2em 0 0.1em #16c7f9, -0.2em -0.2em 0 0.1em #16c7f9, -0.2em -0.2em 0 0.1em #16c7f9, -0.2em -0.2em 0 0.1em #16c7f9;
  }
}
.loader-box .loader-39 {
  position: relative;
  width: 0.15em;
  height: 0.15em;
  background-color: #ffaa05;
  border-radius: 100%;
  animation: loader-39-1 30s infinite linear;
}
.loader-box .loader-39:before, .loader-box .loader-39:after {
  content: "";
  border-radius: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.loader-box .loader-39:before {
  width: 20px;
  height: 60px;
  animation: loader-39-2 0.8s linear infinite;
}
.loader-box .loader-39:after {
  width: 60px;
  height: 20px;
  animation: loader-39-2 1.2s linear infinite;
}
@keyframes loader-39-1 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes loader-39-2 {
  0% {
    box-shadow: 0.04em -0.04em 0 0.02em #ffaa05;
  }
  25% {
    box-shadow: 0.04em 0.04em 0 0.02em #ffaa05;
  }
  50% {
    box-shadow: -0.04em 0.04em 0 0.02em #ffaa05;
  }
  75% {
    box-shadow: -0.04em -0.04em 0 0.02em #ffaa05;
  }
  100% {
    box-shadow: 0.04em -0.04em 0 0.02em #ffaa05;
  }
}
.loader-box .loader-40 {
  border: 0.05em #fc4438 solid;
  border-radius: 0.2em;
  overflow: hidden;
  position: relative;
}
.loader-box .loader-40:after, .loader-box .loader-40:before {
  content: "";
  border-radius: 50%;
  position: absolute;
  width: inherit;
  height: inherit;
  animation: loader-40 2s infinite linear;
}
.loader-box .loader-40:before {
  border-top: 0.2em #fc4438 solid;
  top: -0.15em;
  left: calc(-50% - 0.15em);
  transform-origin: right center;
}
.loader-box .loader-40:after {
  border-bottom: 0.2em #fc4438 solid;
  top: 0.15em;
  right: calc(-50% - 0.15em);
  transform-origin: left center;
}
@keyframes loader-40 {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
.loader-box .loader-41 {
  border: 0.05em var(--theme-default) solid;
  border-radius: 0.2em;
  position: relative;
  background: linear-gradient(45deg, transparent 48%, var(--theme-default) 50%, var(--theme-default) 50%, transparent 52%, transparent), linear-gradient(-45deg, transparent 48%, var(--theme-default) 50%, var(--theme-default) 50%, transparent 52%, transparent);
  background-size: 0.5em 0.5em;
  background-position: 0% 0%;
  animation: loader-41 1s infinite linear;
}
@keyframes loader-41 {
  from {
    background-position: 0 0;
  }
  to {
    background-position: -1em 0;
  }
}
.loader-box .loader-42 {
  width: 2em;
  height: 0.66em;
  border: 0.05em var(--theme-secondary) solid;
  border-radius: 0.1em;
  background: linear-gradient(-60deg, transparent 0%, transparent 50%, var(--theme-secondary) 50%, var(--theme-secondary) 75%, transparent 75%, transparent);
  background-size: 1em 2em;
  background-position: 0 0;
  animation: loader-42 0.8s infinite linear;
}
@keyframes loader-42 {
  from {
    background-position: 0 0;
  }
  to {
    background-position: -2em 0;
  }
}

/**=====================
     04. Loader CSS Ends
==========================**/
/**=====================
     16. Popover CSS Start
==========================**/
.popover-header {
  background-color: #2c323f;
  color: #fff;
}

.popover-main .btn-showcase a {
  color: #fff;
}
.popover-main .btn-showcase button:last-child {
  margin-right: 0;
}

/**=====================
     16. Popover CSS Ends
==========================**/
/**=====================
     77. Print CSS Start
==========================**/
@media print {
  .sidebar-wrapper, .page-header {
    display: none;
  }
  .page-body {
    margin: 0;
  }
  .page-wrapper .page-title {
    visibility: hidden;
  }
  .page-wrapper .page-body-wrapper .page-title {
    display: none;
  }
  .page-wrapper.compact-wrapper .page-body-wrapper .page-body {
    margin: 0;
  }
  table.fixedHeader-floating {
    display: none;
  }
}
.invoice-table {
  margin-top: 16px;
  margin-bottom: 16px;
}

.invoice .text-right input {
  margin-top: 6px;
}
.invoice .media {
  align-items: center;
}

/**=====================
    77. Print CSS Ends
==========================**/
/**=====================
     28. Radio CSS Start
==========================**/
.animate-chk label {
  line-height: 1.6;
  cursor: pointer;
}
.animate-chk label:last-child {
  margin-bottom: 0;
}

.checkbox_animated {
  cursor: pointer;
  position: relative;
  margin: 0 1rem 0 0;
}
.checkbox_animated:before {
  transition: transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75);
  transform: rotate(-45deg) scale(0, 0);
  content: "";
  position: absolute;
  left: 0.25rem;
  top: 0.225rem;
  z-index: 1;
  width: 0.75rem;
  height: 0.375rem;
  border: 2px solid var(--theme-default);
  border-top-style: none;
  border-right-style: none;
}
.checkbox_animated:after {
  content: "";
  position: absolute;
  top: -0.125rem;
  left: 0;
  width: 1.3rem;
  height: 1.3rem;
  background: #fff;
  border: 2px solid #ecf3fa;
  cursor: pointer;
}
.checkbox_animated:checked:before {
  transform: rotate(-45deg) scale(1, 1);
}

.radio_animated {
  position: relative;
  margin: 0 1rem 0 0;
  cursor: pointer;
}
.radio_animated:before {
  transition: transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75);
  transform: scale(0, 0);
  content: "";
  position: absolute;
  top: 0;
  left: 0.125rem;
  z-index: 1;
  width: 0.75rem;
  height: 0.75rem;
  background: var(--theme-default);
  border-radius: 50%;
}
.radio_animated:after {
  content: "";
  position: absolute;
  top: -0.25rem;
  left: -0.125rem;
  width: 1.25rem;
  height: 1.25rem;
  background: #fff;
  border: 2px solid #ecf3fa;
  border-radius: 50%;
}
.radio_animated:checked:before {
  transform: scale(1, 1);
}

.checkbox label {
  display: inline-block;
  position: relative;
  padding-left: 16px;
  cursor: pointer;
  margin-top: 10px;
  margin-bottom: 10px;
}
.checkbox label::before {
  content: "";
  display: inline-block;
  position: absolute;
  width: 19px;
  height: 19px;
  left: 0;
  margin-left: -16px;
  border: 1px solid #efefef;
  border-radius: 3px;
  background-color: #fff;
  transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
}
.checkbox label::after {
  display: inline-block;
  position: absolute;
  width: 16px;
  height: 16px;
  left: 0;
  top: 0;
  margin-left: -20px;
  padding-left: 3px;
  padding-top: 1px;
  font-size: 11px;
  color: #242934;
}
.checkbox input[type=checkbox] {
  opacity: 0;
}
.checkbox input[type=checkbox]:focus {
  outline-offset: -2px;
}
.checkbox input[type=checkbox]:focus + label::before {
  outline-offset: -2px;
}
.checkbox input[type=checkbox]:checked + label::before {
  font-family: themify;
  content: "\\e64c";
  text-align: center;
  line-height: 1.2;
}
.checkbox input[type=checkbox]:disabled + label {
  opacity: 0.65;
}
.checkbox input[type=checkbox]:disabled + label::before {
  background-color: #f4f4f4;
  cursor: not-allowed;
}
.checkbox .checkbox-circle label::before {
  border-radius: 50%;
}
.checkbox .checkbox-inline {
  margin-top: 0;
}

.m-squar label::before {
  border-radius: 0;
}
.m-squar .checkbox-circle label::before {
  border-radius: 50%;
}
.m-squar .checkbox-inline {
  margin-top: 0;
}

.checkbox-primary label::before {
  border-color: var(--theme-default);
}
.checkbox-primary input[type=checkbox]:checked + label::before {
  border-color: var(--theme-default);
  color: var(--theme-default);
}
.checkbox-primary input[type=checkbox]:checked + label::after {
  color: #fff;
}

.checkbox-solid-primary label:before {
  background-color: var(--theme-default);
  border-color: var(--theme-default);
  color: #fff;
}
.checkbox-solid-primary input[type=checkbox]:checked + label::before {
  background-color: var(--theme-default);
  border-color: var(--theme-default);
  color: #fff;
}
.checkbox-solid-primary input[type=checkbox]:checked + label::after {
  color: #fff;
}

.radio-primary input[type=radio] + label::before {
  border-color: var(--theme-default);
}
.radio-primary input[type=radio] + label::after {
  background-color: var(--theme-default);
}
.radio-primary input[type=radio]:checked + label::before {
  border-color: var(--theme-default);
}
.radio-primary input[type=radio]:checked + label::after {
  background-color: var(--theme-default);
}

.checkbox-secondary label::before {
  border-color: #ff3364;
}
.checkbox-secondary input[type=checkbox]:checked + label::before {
  border-color: #ff3364;
  color: #ff3364;
}
.checkbox-secondary input[type=checkbox]:checked + label::after {
  color: #fff;
}

.checkbox-solid-secondary label:before {
  background-color: #ff3364;
  border-color: #ff3364;
  color: #fff;
}
.checkbox-solid-secondary input[type=checkbox]:checked + label::before {
  background-color: #ff3364;
  border-color: #ff3364;
  color: #fff;
}
.checkbox-solid-secondary input[type=checkbox]:checked + label::after {
  color: #fff;
}

.radio-secondary input[type=radio] + label::before {
  border-color: #ff3364;
}
.radio-secondary input[type=radio] + label::after {
  background-color: #ff3364;
}
.radio-secondary input[type=radio]:checked + label::before {
  border-color: #ff3364;
}
.radio-secondary input[type=radio]:checked + label::after {
  background-color: #ff3364;
}

.checkbox-success label::before {
  border-color: #54ba4a;
}
.checkbox-success input[type=checkbox]:checked + label::before {
  border-color: #54ba4a;
  color: #54ba4a;
}
.checkbox-success input[type=checkbox]:checked + label::after {
  color: #fff;
}

.checkbox-solid-success label:before {
  background-color: #54ba4a;
  border-color: #54ba4a;
  color: #fff;
}
.checkbox-solid-success input[type=checkbox]:checked + label::before {
  background-color: #54ba4a;
  border-color: #54ba4a;
  color: #fff;
}
.checkbox-solid-success input[type=checkbox]:checked + label::after {
  color: #fff;
}

.radio-success input[type=radio] + label::before {
  border-color: #54ba4a;
}
.radio-success input[type=radio] + label::after {
  background-color: #54ba4a;
}
.radio-success input[type=radio]:checked + label::before {
  border-color: #54ba4a;
}
.radio-success input[type=radio]:checked + label::after {
  background-color: #54ba4a;
}

.checkbox-danger label::before {
  border-color: #fc4438;
}
.checkbox-danger input[type=checkbox]:checked + label::before {
  border-color: #fc4438;
  color: #fc4438;
}
.checkbox-danger input[type=checkbox]:checked + label::after {
  color: #fff;
}

.checkbox-solid-danger label:before {
  background-color: #fc4438;
  border-color: #fc4438;
  color: #fff;
}
.checkbox-solid-danger input[type=checkbox]:checked + label::before {
  background-color: #fc4438;
  border-color: #fc4438;
  color: #fff;
}
.checkbox-solid-danger input[type=checkbox]:checked + label::after {
  color: #fff;
}

.radio-danger input[type=radio] + label::before {
  border-color: #fc4438;
}
.radio-danger input[type=radio] + label::after {
  background-color: #fc4438;
}
.radio-danger input[type=radio]:checked + label::before {
  border-color: #fc4438;
}
.radio-danger input[type=radio]:checked + label::after {
  background-color: #fc4438;
}

.checkbox-info label::before {
  border-color: #16c7f9;
}
.checkbox-info input[type=checkbox]:checked + label::before {
  border-color: #16c7f9;
  color: #16c7f9;
}
.checkbox-info input[type=checkbox]:checked + label::after {
  color: #fff;
}

.checkbox-solid-info label:before {
  background-color: #16c7f9;
  border-color: #16c7f9;
  color: #fff;
}
.checkbox-solid-info input[type=checkbox]:checked + label::before {
  background-color: #16c7f9;
  border-color: #16c7f9;
  color: #fff;
}
.checkbox-solid-info input[type=checkbox]:checked + label::after {
  color: #fff;
}

.radio-info input[type=radio] + label::before {
  border-color: #16c7f9;
}
.radio-info input[type=radio] + label::after {
  background-color: #16c7f9;
}
.radio-info input[type=radio]:checked + label::before {
  border-color: #16c7f9;
}
.radio-info input[type=radio]:checked + label::after {
  background-color: #16c7f9;
}

.checkbox-light label::before {
  border-color: #f4f4f4;
}
.checkbox-light input[type=checkbox]:checked + label::before {
  border-color: #f4f4f4;
  color: #f4f4f4;
}
.checkbox-light input[type=checkbox]:checked + label::after {
  color: #fff;
}

.checkbox-solid-light label:before {
  background-color: #f4f4f4;
  border-color: #f4f4f4;
  color: #fff;
}
.checkbox-solid-light input[type=checkbox]:checked + label::before {
  background-color: #f4f4f4;
  border-color: #f4f4f4;
  color: #fff;
}
.checkbox-solid-light input[type=checkbox]:checked + label::after {
  color: #fff;
}

.radio-light input[type=radio] + label::before {
  border-color: #f4f4f4;
}
.radio-light input[type=radio] + label::after {
  background-color: #f4f4f4;
}
.radio-light input[type=radio]:checked + label::before {
  border-color: #f4f4f4;
}
.radio-light input[type=radio]:checked + label::after {
  background-color: #f4f4f4;
}

.checkbox-dark label::before {
  border-color: #2c323f;
}
.checkbox-dark input[type=checkbox]:checked + label::before {
  border-color: #2c323f;
  color: #2c323f;
}
.checkbox-dark input[type=checkbox]:checked + label::after {
  color: #fff;
}

.checkbox-solid-dark label:before {
  background-color: #2c323f;
  border-color: #2c323f;
  color: #fff;
}
.checkbox-solid-dark input[type=checkbox]:checked + label::before {
  background-color: #2c323f;
  border-color: #2c323f;
  color: #fff;
}
.checkbox-solid-dark input[type=checkbox]:checked + label::after {
  color: #fff;
}

.radio-dark input[type=radio] + label::before {
  border-color: #2c323f;
}
.radio-dark input[type=radio] + label::after {
  background-color: #2c323f;
}
.radio-dark input[type=radio]:checked + label::before {
  border-color: #2c323f;
}
.radio-dark input[type=radio]:checked + label::after {
  background-color: #2c323f;
}

.checkbox-warning label::before {
  border-color: #ffaa05;
}
.checkbox-warning input[type=checkbox]:checked + label::before {
  border-color: #ffaa05;
  color: #ffaa05;
}
.checkbox-warning input[type=checkbox]:checked + label::after {
  color: #fff;
}

.checkbox-solid-warning label:before {
  background-color: #ffaa05;
  border-color: #ffaa05;
  color: #fff;
}
.checkbox-solid-warning input[type=checkbox]:checked + label::before {
  background-color: #ffaa05;
  border-color: #ffaa05;
  color: #fff;
}
.checkbox-solid-warning input[type=checkbox]:checked + label::after {
  color: #fff;
}

.radio-warning input[type=radio] + label::before {
  border-color: #ffaa05;
}
.radio-warning input[type=radio] + label::after {
  background-color: #ffaa05;
}
.radio-warning input[type=radio]:checked + label::before {
  border-color: #ffaa05;
}
.radio-warning input[type=radio]:checked + label::after {
  background-color: #ffaa05;
}

.m-checkbox-inline .checkbox {
  display: inline-block;
}
.m-checkbox-inline .radio {
  display: inline-block;
}
.m-checkbox-inline label {
  margin-right: 20px;
}

.radio label {
  display: inline-block;
  position: relative;
  padding-left: 5px;
  cursor: pointer;
}
.radio label::before {
  content: "";
  display: inline-block;
  position: absolute;
  width: 19px;
  height: 19px;
  left: 0;
  margin-left: -20px;
  border: 1px solid #efefef;
  border-radius: 50%;
  background-color: #fff;
  transition: border 0.15s ease-in-out;
}
.radio label::after {
  display: inline-block;
  position: absolute;
  content: " ";
  width: 9px;
  height: 9px;
  left: 5px;
  top: 5px;
  margin-left: -20px;
  border-radius: 50%;
  background-color: #898989;
  transform: scale(0, 0);
  transition: transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);
}
.radio input[type=radio] {
  opacity: 0;
}
.radio input[type=radio]:focus + label::before {
  outline-offset: -2px;
}
.radio input[type=radio]:checked + label::after {
  transform: scale(1, 1);
}
.radio input[type=radio]:disabled + label {
  opacity: 0.65;
}
.radio input[type=radio]:disabled + label::before {
  cursor: not-allowed;
}
.radio .radio-inline {
  margin-top: 0;
}

/**=====================
     28. Radio CSS Ends
==========================**/
/**=====================
    56.  Ribbon CSS Start
==========================**/
[class*=ribbon-wrapper] {
  position: relative;
  padding-top: 40px;
}

.ribbon {
  padding: 0 20px;
  height: 30px;
  line-height: 30px;
  clear: left;
  position: absolute;
  top: 12px;
  left: 0px;
  color: #fff;
  z-index: 2;
}

.ribbon-clip {
  left: -14px;
}
.ribbon-clip:before {
  position: absolute;
  top: 30px;
  left: 0;
  width: 0;
  height: 0;
  content: "";
  border: 7px solid transparent;
  border-top-color: #2c323f;
  border-right-color: #2c323f;
}

.ribbon-vertical-left-wrapper {
  padding-left: 40px;
  position: relative;
}

.ribbon-vertical-right-wrapper {
  padding-right: 40px;
}

.ribbon-wrapper-bottom {
  padding-bottom: 40px;
  padding-top: 0;
}

.ribbon-wrapper-right-bottom {
  padding-right: 40px;
}

.ribbon-space-bottom {
  top: 0px;
}

.ribbon-bookmark:before {
  position: absolute;
  top: 0;
  left: 100%;
  display: block;
  width: 0;
  height: 0;
  content: "";
  border: 15px solid #2c323f;
  border-right: 10px solid transparent;
}

.ribbon-right {
  left: auto;
  right: -2px;
}

.ribbon-clip-right {
  right: -14px;
}
.ribbon-clip-right:before {
  position: absolute;
  top: 30px;
  right: 0;
  width: 0;
  height: 0;
  content: "";
  border: 7px solid transparent;
  border-top-color: #2c323f;
  border-right-color: #2c323f;
}

.ribbon-clip-bottom {
  left: -14px;
  bottom: 12px;
  top: auto;
}
.ribbon-clip-bottom:before {
  position: absolute;
  bottom: 30px;
  left: 0;
  width: 0;
  height: 0;
  content: "";
  border: 7px solid transparent;
  border-top-color: #2c323f;
  border-right-color: #2c323f;
}

.ribbon-clip-bottom-right {
  right: -14px;
  left: auto;
  bottom: 12px;
  top: auto;
}
.ribbon-clip-bottom-right:before {
  position: absolute;
  bottom: 30px;
  right: 0;
  width: 0;
  height: 0;
  content: "";
  border: 7px solid transparent;
  border-top-color: #2c323f;
  border-right-color: #2c323f;
}

.ribbon-bookmark.ribbon-right:before {
  right: 100%;
  left: auto;
  border-right: 15px solid #2c323f;
  border-left: 10px solid transparent;
}

.ribbon-vertical-left {
  clear: none;
  padding: 0 5px;
  height: 70px;
  width: 30px;
  line-height: 70px;
  text-align: center;
  left: 12px;
  top: -2px;
}

.ribbon-vertical-right {
  clear: none;
  padding: 0 5px;
  height: 70px;
  width: 30px;
  line-height: 70px;
  text-align: center;
  top: -2px;
  left: auto;
  right: 12px;
}

.ribbon-bookmark.ribbon-vertical-left:before, .ribbon-bookmark.ribbon-vertical-right:before {
  top: 100%;
  left: 0;
  margin-top: -14px;
  border-right: 15px solid #2c323f;
  border-bottom: 10px solid transparent;
}

.ribbon-primary {
  background: #7366ff;
}

.ribbon-primary {
  background: #7366ff;
}

.ribbon-bookmark.ribbon-primary:before {
  border-color: #7366ff;
  border-right-color: transparent;
}
.ribbon-bookmark.ribbon-right.ribbon-primary:before {
  border-right-color: #7366ff;
  border-left-color: transparent;
}
.ribbon-bookmark.ribbon-vertical-left.ribbon-primary:before, .ribbon-bookmark.ribbon-vertical-right.ribbon-primary:before {
  border-right-color: #7366ff;
  border-bottom-color: transparent;
}

.ribbon-primary.ribbon-corner:before {
  border-top-color: #7366ff;
  border-left-color: #7366ff;
}
.ribbon-primary.ribbon-corner.ribbon-right:before {
  border-right-color: #7366ff;
  border-left-color: transparent;
}
.ribbon-primary.ribbon-corner.ribbon-bottom:before {
  border-top-color: transparent;
  border-bottom-color: #7366ff;
}

.ribbon-primary.ribbon-clip:before {
  border-color: transparent;
  border-top-color: rgb(26.7973856209%, 20%, 100%);
  border-right-color: rgb(26.7973856209%, 20%, 100%);
}

.ribbon-primary.ribbon-clip-right:before {
  border-right-color: transparent;
  border-top-color: rgb(26.7973856209%, 20%, 100%);
  border-left-color: rgb(26.7973856209%, 20%, 100%);
}

.ribbon-primary.ribbon-clip-bottom:before {
  border-top-color: transparent;
  border-bottom-color: rgb(26.7973856209%, 20%, 100%);
  border-right-color: rgb(26.7973856209%, 20%, 100%);
}

.ribbon-primary.ribbon-clip-bottom-right:before {
  border-top-color: transparent;
  border-bottom-color: rgb(26.7973856209%, 20%, 100%);
  border-right-color: transparent;
  border-left-color: rgb(26.7973856209%, 20%, 100%);
}

.ribbon-secondary {
  background: #ff3364;
}

.ribbon-secondary {
  background: #ff3364;
}

.ribbon-bookmark.ribbon-secondary:before {
  border-color: #ff3364;
  border-right-color: transparent;
}
.ribbon-bookmark.ribbon-right.ribbon-secondary:before {
  border-right-color: #ff3364;
  border-left-color: transparent;
}
.ribbon-bookmark.ribbon-vertical-left.ribbon-secondary:before, .ribbon-bookmark.ribbon-vertical-right.ribbon-secondary:before {
  border-right-color: #ff3364;
  border-bottom-color: transparent;
}

.ribbon-secondary.ribbon-corner:before {
  border-top-color: #ff3364;
  border-left-color: #ff3364;
}
.ribbon-secondary.ribbon-corner.ribbon-right:before {
  border-right-color: #ff3364;
  border-left-color: transparent;
}
.ribbon-secondary.ribbon-corner.ribbon-bottom:before {
  border-top-color: transparent;
  border-bottom-color: #ff3364;
}

.ribbon-secondary.ribbon-clip:before {
  border-color: transparent;
  border-top-color: rgb(100%, 0%, 24.0196078431%);
  border-right-color: rgb(100%, 0%, 24.0196078431%);
}

.ribbon-secondary.ribbon-clip-right:before {
  border-right-color: transparent;
  border-top-color: rgb(100%, 0%, 24.0196078431%);
  border-left-color: rgb(100%, 0%, 24.0196078431%);
}

.ribbon-secondary.ribbon-clip-bottom:before {
  border-top-color: transparent;
  border-bottom-color: rgb(100%, 0%, 24.0196078431%);
  border-right-color: rgb(100%, 0%, 24.0196078431%);
}

.ribbon-secondary.ribbon-clip-bottom-right:before {
  border-top-color: transparent;
  border-bottom-color: rgb(100%, 0%, 24.0196078431%);
  border-right-color: transparent;
  border-left-color: rgb(100%, 0%, 24.0196078431%);
}

.ribbon-success {
  background: #54ba4a;
}

.ribbon-success {
  background: #54ba4a;
}

.ribbon-bookmark.ribbon-success:before {
  border-color: #54ba4a;
  border-right-color: transparent;
}
.ribbon-bookmark.ribbon-right.ribbon-success:before {
  border-right-color: #54ba4a;
  border-left-color: transparent;
}
.ribbon-bookmark.ribbon-vertical-left.ribbon-success:before, .ribbon-bookmark.ribbon-vertical-right.ribbon-success:before {
  border-right-color: #54ba4a;
  border-bottom-color: transparent;
}

.ribbon-success.ribbon-corner:before {
  border-top-color: #54ba4a;
  border-left-color: #54ba4a;
}
.ribbon-success.ribbon-corner.ribbon-right:before {
  border-right-color: #54ba4a;
  border-left-color: transparent;
}
.ribbon-success.ribbon-corner.ribbon-bottom:before {
  border-top-color: transparent;
  border-bottom-color: #54ba4a;
}

.ribbon-success.ribbon-clip:before {
  border-color: transparent;
  border-top-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%);
  border-right-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%);
}

.ribbon-success.ribbon-clip-right:before {
  border-right-color: transparent;
  border-top-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%);
  border-left-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%);
}

.ribbon-success.ribbon-clip-bottom:before {
  border-top-color: transparent;
  border-bottom-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%);
  border-right-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%);
}

.ribbon-success.ribbon-clip-bottom-right:before {
  border-top-color: transparent;
  border-bottom-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%);
  border-right-color: transparent;
  border-left-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%);
}

.ribbon-danger {
  background: #fc4438;
}

.ribbon-danger {
  background: #fc4438;
}

.ribbon-bookmark.ribbon-danger:before {
  border-color: #fc4438;
  border-right-color: transparent;
}
.ribbon-bookmark.ribbon-right.ribbon-danger:before {
  border-right-color: #fc4438;
  border-left-color: transparent;
}
.ribbon-bookmark.ribbon-vertical-left.ribbon-danger:before, .ribbon-bookmark.ribbon-vertical-right.ribbon-danger:before {
  border-right-color: #fc4438;
  border-bottom-color: transparent;
}

.ribbon-danger.ribbon-corner:before {
  border-top-color: #fc4438;
  border-left-color: #fc4438;
}
.ribbon-danger.ribbon-corner.ribbon-right:before {
  border-right-color: #fc4438;
  border-left-color: transparent;
}
.ribbon-danger.ribbon-corner.ribbon-bottom:before {
  border-top-color: transparent;
  border-bottom-color: #fc4438;
}

.ribbon-danger.ribbon-clip:before {
  border-color: transparent;
  border-top-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%);
  border-right-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%);
}

.ribbon-danger.ribbon-clip-right:before {
  border-right-color: transparent;
  border-top-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%);
  border-left-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%);
}

.ribbon-danger.ribbon-clip-bottom:before {
  border-top-color: transparent;
  border-bottom-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%);
  border-right-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%);
}

.ribbon-danger.ribbon-clip-bottom-right:before {
  border-top-color: transparent;
  border-bottom-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%);
  border-right-color: transparent;
  border-left-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%);
}

.ribbon-info {
  background: #16c7f9;
}

.ribbon-info {
  background: #16c7f9;
}

.ribbon-bookmark.ribbon-info:before {
  border-color: #16c7f9;
  border-right-color: transparent;
}
.ribbon-bookmark.ribbon-right.ribbon-info:before {
  border-right-color: #16c7f9;
  border-left-color: transparent;
}
.ribbon-bookmark.ribbon-vertical-left.ribbon-info:before, .ribbon-bookmark.ribbon-vertical-right.ribbon-info:before {
  border-right-color: #16c7f9;
  border-bottom-color: transparent;
}

.ribbon-info.ribbon-corner:before {
  border-top-color: #16c7f9;
  border-left-color: #16c7f9;
}
.ribbon-info.ribbon-corner.ribbon-right:before {
  border-right-color: #16c7f9;
  border-left-color: transparent;
}
.ribbon-info.ribbon-corner.ribbon-bottom:before {
  border-top-color: transparent;
  border-bottom-color: #16c7f9;
}

.ribbon-info.ribbon-clip:before {
  border-color: transparent;
  border-top-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%);
  border-right-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%);
}

.ribbon-info.ribbon-clip-right:before {
  border-right-color: transparent;
  border-top-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%);
  border-left-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%);
}

.ribbon-info.ribbon-clip-bottom:before {
  border-top-color: transparent;
  border-bottom-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%);
  border-right-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%);
}

.ribbon-info.ribbon-clip-bottom-right:before {
  border-top-color: transparent;
  border-bottom-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%);
  border-right-color: transparent;
  border-left-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%);
}

.ribbon-light {
  background: #f4f4f4;
}

.ribbon-light {
  background: #f4f4f4;
}

.ribbon-bookmark.ribbon-light:before {
  border-color: #f4f4f4;
  border-right-color: transparent;
}
.ribbon-bookmark.ribbon-right.ribbon-light:before {
  border-right-color: #f4f4f4;
  border-left-color: transparent;
}
.ribbon-bookmark.ribbon-vertical-left.ribbon-light:before, .ribbon-bookmark.ribbon-vertical-right.ribbon-light:before {
  border-right-color: #f4f4f4;
  border-bottom-color: transparent;
}

.ribbon-light.ribbon-corner:before {
  border-top-color: #f4f4f4;
  border-left-color: #f4f4f4;
}
.ribbon-light.ribbon-corner.ribbon-right:before {
  border-right-color: #f4f4f4;
  border-left-color: transparent;
}
.ribbon-light.ribbon-corner.ribbon-bottom:before {
  border-top-color: transparent;
  border-bottom-color: #f4f4f4;
}

.ribbon-light.ribbon-clip:before {
  border-color: transparent;
  border-top-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%);
  border-right-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%);
}

.ribbon-light.ribbon-clip-right:before {
  border-right-color: transparent;
  border-top-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%);
  border-left-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%);
}

.ribbon-light.ribbon-clip-bottom:before {
  border-top-color: transparent;
  border-bottom-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%);
  border-right-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%);
}

.ribbon-light.ribbon-clip-bottom-right:before {
  border-top-color: transparent;
  border-bottom-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%);
  border-right-color: transparent;
  border-left-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%);
}

.ribbon-dark {
  background: #2c323f;
}

.ribbon-dark {
  background: #2c323f;
}

.ribbon-bookmark.ribbon-dark:before {
  border-color: #2c323f;
  border-right-color: transparent;
}
.ribbon-bookmark.ribbon-right.ribbon-dark:before {
  border-right-color: #2c323f;
  border-left-color: transparent;
}
.ribbon-bookmark.ribbon-vertical-left.ribbon-dark:before, .ribbon-bookmark.ribbon-vertical-right.ribbon-dark:before {
  border-right-color: #2c323f;
  border-bottom-color: transparent;
}

.ribbon-dark.ribbon-corner:before {
  border-top-color: #2c323f;
  border-left-color: #2c323f;
}
.ribbon-dark.ribbon-corner.ribbon-right:before {
  border-right-color: #2c323f;
  border-left-color: transparent;
}
.ribbon-dark.ribbon-corner.ribbon-bottom:before {
  border-top-color: transparent;
  border-bottom-color: #2c323f;
}

.ribbon-dark.ribbon-clip:before {
  border-color: transparent;
  border-top-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%);
  border-right-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%);
}

.ribbon-dark.ribbon-clip-right:before {
  border-right-color: transparent;
  border-top-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%);
  border-left-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%);
}

.ribbon-dark.ribbon-clip-bottom:before {
  border-top-color: transparent;
  border-bottom-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%);
  border-right-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%);
}

.ribbon-dark.ribbon-clip-bottom-right:before {
  border-top-color: transparent;
  border-bottom-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%);
  border-right-color: transparent;
  border-left-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%);
}

.ribbon-warning {
  background: #ffaa05;
}

.ribbon-warning {
  background: #ffaa05;
}

.ribbon-bookmark.ribbon-warning:before {
  border-color: #ffaa05;
  border-right-color: transparent;
}
.ribbon-bookmark.ribbon-right.ribbon-warning:before {
  border-right-color: #ffaa05;
  border-left-color: transparent;
}
.ribbon-bookmark.ribbon-vertical-left.ribbon-warning:before, .ribbon-bookmark.ribbon-vertical-right.ribbon-warning:before {
  border-right-color: #ffaa05;
  border-bottom-color: transparent;
}

.ribbon-warning.ribbon-corner:before {
  border-top-color: #ffaa05;
  border-left-color: #ffaa05;
}
.ribbon-warning.ribbon-corner.ribbon-right:before {
  border-right-color: #ffaa05;
  border-left-color: transparent;
}
.ribbon-warning.ribbon-corner.ribbon-bottom:before {
  border-top-color: transparent;
  border-bottom-color: #ffaa05;
}

.ribbon-warning.ribbon-clip:before {
  border-color: transparent;
  border-top-color: rgb(81.9607843137%, 54.0941176471%, 0%);
  border-right-color: rgb(81.9607843137%, 54.0941176471%, 0%);
}

.ribbon-warning.ribbon-clip-right:before {
  border-right-color: transparent;
  border-top-color: rgb(81.9607843137%, 54.0941176471%, 0%);
  border-left-color: rgb(81.9607843137%, 54.0941176471%, 0%);
}

.ribbon-warning.ribbon-clip-bottom:before {
  border-top-color: transparent;
  border-bottom-color: rgb(81.9607843137%, 54.0941176471%, 0%);
  border-right-color: rgb(81.9607843137%, 54.0941176471%, 0%);
}

.ribbon-warning.ribbon-clip-bottom-right:before {
  border-top-color: transparent;
  border-bottom-color: rgb(81.9607843137%, 54.0941176471%, 0%);
  border-right-color: transparent;
  border-left-color: rgb(81.9607843137%, 54.0941176471%, 0%);
}

/**=====================
     56. Ribbon CSS Ends
==========================**/
/**=====================
    18. Switch  CSS Start
==========================**/
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}
.switch input {
  display: none;
}
.switch input:checked + .switch-state {
  background-color: var(--theme-default);
}
.switch input:checked + .switch-state:before {
  transform: translateX(26px);
}
.switch input:focus + .switch-state {
  box-shadow: 0 0 1px var(--theme-default);
}

.switch-state {
  border-radius: 20px;
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #f4f4f4;
  transition: 0.4s;
}
.switch-state:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: #fff;
  transition: 0.4s;
  border-radius: 20px;
}

.icon-state .switch-state:after {
  content: "\\efb8";
  font-family: IcoFont;
  left: 10px;
  position: absolute;
  top: 10px;
  color: #2c323f;
  transition: 0.4s;
  opacity: 0.3;
}
.icon-state input:checked + .switch-state:after {
  content: "\\efad";
  left: 36px;
  opacity: 1;
  transition: 0.4s;
}

.switch-lg .switch {
  width: 75px;
  height: 40px;
}
.switch-lg .switch .switch-state:before {
  height: 30px;
  width: 30px;
  left: 7px;
  bottom: 5px;
  top: 4px;
}

.switch-lg.icon-state .switch .switch-state:after {
  left: 12px;
  font-size: 18px;
}
.switch-lg.icon-state .switch input:checked + .switch-state:after {
  left: 47px;
}
.switch-lg.icon-state .switch input:checked + .switch-state:before {
  transform: translateX(32px);
}

.switch-sm.icon-state .switch .switch-state:after {
  top: 4px;
  left: 4px;
  font-size: 8px;
}
.switch-sm.icon-state .switch input:checked + .switch-state:after {
  left: 13px;
  top: 4px;
}
.switch-sm .switch {
  width: 25px;
  height: 16px;
  margin-top: 10px;
  margin-bottom: 0px;
}
.switch-sm .switch .switch-state:before {
  height: 8px;
  width: 8px;
  left: 4px;
  bottom: 4px;
}
.switch-sm input:checked + .switch-state:before {
  left: -13px;
}

.switch-outline .switch-state {
  background-color: #fff;
  border: 1px solid var(--theme-default);
  transition: 0.4s;
}
.switch-outline .switch-state:before {
  background-color: #f4f4f4;
  bottom: 3px;
  color: #fff;
}

.switch-outline .switch input {
  display: none;
}
.switch-outline .switch input:checked + .switch-state {
  background-color: transparent;
  border: 1px solid var(--theme-default);
}
.switch-outline .switch input:checked + .switch-state:before {
  background-color: var(--theme-default);
  bottom: 3px;
  transform: translateX(26px);
}
.switch-outline .switch input:checked + .switch-state:after {
  color: #fff;
}

.switch-outline .switch-state.bg-primary {
  border: 1px solid var(--theme-default);
  background-color: transparent !important;
}
.switch-outline .switch input:checked + .switch-state.bg-primary {
  background-color: transparent !important;
  border: 1px solid var(--theme-default);
}
.switch-outline .switch input:checked + .switch-state.bg-primary:before {
  background-color: var(--theme-default);
}
.switch-outline .switch-state.bg-dark {
  border: 1px solid #2c323f;
  background-color: transparent !important;
}
.switch-outline .switch input:checked + .switch-state.bg-dark {
  background-color: transparent !important;
  border: 1px solid #2c323f;
}
.switch-outline .switch input:checked + .switch-state.bg-dark:before {
  background-color: #2c323f;
}
.switch-outline .switch-state.bg-warning {
  border: 1px solid #ffaa05;
  background-color: transparent !important;
}
.switch-outline .switch input:checked + .switch-state.bg-warning {
  background-color: transparent !important;
  border: 1px solid #ffaa05;
}
.switch-outline .switch input:checked + .switch-state.bg-warning:before {
  background-color: #ffaa05;
}
.switch-outline .switch-state.bg-success {
  border: 1px solid #54ba4a;
  background-color: transparent !important;
}
.switch-outline .switch input:checked + .switch-state.bg-success {
  background-color: transparent !important;
  border: 1px solid #54ba4a;
}
.switch-outline .switch input:checked + .switch-state.bg-success:before {
  background-color: #54ba4a;
}
.switch-outline .switch-state.bg-info {
  border: 1px solid #16c7f9;
  background-color: transparent !important;
}
.switch-outline .switch input:checked + .switch-state.bg-info {
  background-color: transparent !important;
  border: 1px solid #16c7f9;
}
.switch-outline .switch input:checked + .switch-state.bg-info:before {
  background-color: #16c7f9;
}
.switch-outline .switch-state.bg-danger {
  border: 1px solid #fc4438;
  background-color: transparent !important;
}
.switch-outline .switch input:checked + .switch-state.bg-danger {
  background-color: transparent !important;
  border: 1px solid #fc4438;
}
.switch-outline .switch input:checked + .switch-state.bg-danger:before {
  background-color: #fc4438;
}
.switch-outline .switch-state.bg-primary {
  border: 1px solid var(--theme-default);
  background-color: transparent !important;
}
.switch-outline .switch input:checked + .switch-state.bg-primary {
  background-color: transparent !important;
  border: 1px solid var(--theme-default);
}
.switch-outline .switch input:checked + .switch-state.bg-primary:before {
  background-color: var(--theme-default);
}
.switch-outline .switch-state.bg-secondary {
  border: 1px solid var(--theme-secondary);
  background-color: transparent !important;
}
.switch-outline .switch input:checked + .switch-state.bg-secondary {
  background-color: transparent !important;
  border: 1px solid var(--theme-secondary);
}
.switch-outline .switch input:checked + .switch-state.bg-secondary:before {
  background-color: var(--theme-secondary);
}

.switch-showcase {
  margin-bottom: -8px;
}
.switch-showcase .media {
  line-height: 1;
}
.switch-showcase .form-check .form-check-input {
  float: right;
}

.form-switch .form-check-input:checked {
  background-color: var(--theme-default);
  border-color: var(--theme-default);
}

/**=====================
     18. Switch  CSS Ends
==========================**/
/**=====================
    44. Tabs CSS Start
==========================**/
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  background-color: var(--theme-default);
}

.nav i {
  margin-right: 10px;
}

.nav-right {
  justify-content: flex-end;
}

.nav-theme .nav-link,
.nav-pills.nav-theme .nav-link {
  color: var(--theme-default);
}
.nav-theme .nav-link.active,
.nav-theme .show > .nav-link,
.nav-pills.nav-theme .nav-link.active,
.nav-pills.nav-theme .show > .nav-link {
  background-color: var(--theme-default);
  color: #fff;
}

.nav-primary .nav-link,
.nav-pills.nav-primary .nav-link {
  color: var(--theme-default);
}
.nav-primary .nav-link.active,
.nav-primary .show > .nav-link,
.nav-pills.nav-primary .nav-link.active,
.nav-pills.nav-primary .show > .nav-link {
  background-color: var(--theme-default);
  color: #fff;
}

.nav-secondary .nav-link,
.nav-pills.nav-secondary .nav-link {
  color: #ff3364;
}
.nav-secondary .nav-link.active,
.nav-secondary .show > .nav-link,
.nav-pills.nav-secondary .nav-link.active,
.nav-pills.nav-secondary .show > .nav-link {
  background-color: #ff3364;
  color: #fff;
}

.nav-success .nav-link,
.nav-pills.nav-success .nav-link {
  color: #54ba4a;
}
.nav-success .nav-link.active,
.nav-success .show > .nav-link,
.nav-pills.nav-success .nav-link.active,
.nav-pills.nav-success .show > .nav-link {
  background-color: #54ba4a;
  color: #fff;
}

.nav-danger .nav-link,
.nav-pills.nav-danger .nav-link {
  color: #fc4438;
}
.nav-danger .nav-link.active,
.nav-danger .show > .nav-link,
.nav-pills.nav-danger .nav-link.active,
.nav-pills.nav-danger .show > .nav-link {
  background-color: #fc4438;
  color: #fff;
}

.nav-info .nav-link,
.nav-pills.nav-info .nav-link {
  color: #16c7f9;
}
.nav-info .nav-link.active,
.nav-info .show > .nav-link,
.nav-pills.nav-info .nav-link.active,
.nav-pills.nav-info .show > .nav-link {
  background-color: #16c7f9;
  color: #fff;
}

.nav-light .nav-link,
.nav-pills.nav-light .nav-link {
  color: #f4f4f4;
}
.nav-light .nav-link.active,
.nav-light .show > .nav-link,
.nav-pills.nav-light .nav-link.active,
.nav-pills.nav-light .show > .nav-link {
  background-color: #f4f4f4;
  color: #fff;
}

.nav-dark .nav-link,
.nav-pills.nav-dark .nav-link {
  color: #2c323f;
}
.nav-dark .nav-link.active,
.nav-dark .show > .nav-link,
.nav-pills.nav-dark .nav-link.active,
.nav-pills.nav-dark .show > .nav-link {
  background-color: #2c323f;
  color: #fff;
}

.nav-warning .nav-link,
.nav-pills.nav-warning .nav-link {
  color: #ffaa05;
}
.nav-warning .nav-link.active,
.nav-warning .show > .nav-link,
.nav-pills.nav-warning .nav-link.active,
.nav-pills.nav-warning .show > .nav-link {
  background-color: #ffaa05;
  color: #fff;
}

.nav-tabs.nav-bottom .nav-item .nav-link.active,
.nav-tabs.nav-bottom .nav-item .nav-link.focus,
.nav-tabs.nav-bottom .nav-item .nav-link.hover {
  border-color: #fff #dee2e6 #dee2e6;
}

.tab-content ~ .nav-tabs.border-tab {
  margin-bottom: 0;
  margin-top: 30px;
}

.border-tab.nav-tabs {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  margin-bottom: 30px;
}
.border-tab.nav-tabs .nav-item .nav-link {
  font-size: 16px;
  color: #2c323f;
  text-align: center;
  padding: 10px 25px;
  border: none;
  border-bottom: none;
  transition: 0.3s;
}
.border-tab.nav-tabs .nav-item .nav-link.active, .border-tab.nav-tabs .nav-item .nav-link.show, .border-tab.nav-tabs .nav-item .nav-link:focus, .border-tab.nav-tabs .nav-item .nav-link:hover {
  color: var(--theme-default);
}
.border-tab.nav-tabs .nav-item .nav-link.active, .border-tab.nav-tabs .nav-item .nav-link.show, .border-tab.nav-tabs .nav-item .nav-link:focus {
  border-bottom: none;
}

.border-tab.nav-left .nav-link {
  border-left: 2px solid transparent;
  transition: all 0.3s ease;
  color: #2c323f;
}
.border-tab.nav-left .nav-link.active,
.border-tab.nav-left .show > .nav-link {
  background-color: transparent;
  border-left-color: var(--theme-default);
  color: var(--theme-default);
  border-radius: 0;
  transition: all 0.3s ease;
}

.border-tab.nav-right .nav-link {
  border-right: 2px solid transparent;
  transition: all 0.3s ease;
  color: #2c323f;
  text-align: right;
}
.border-tab.nav-right .nav-link.active,
.border-tab.nav-right .show > .nav-link {
  background-color: transparent;
  border-right-color: var(--theme-default);
  color: var(--theme-default);
  border-radius: 0;
  transition: all 0.3s ease;
}

.border-tab.nav-theme .nav-link.active,
.border-tab.nav-theme .nav-item.show,
.border-tab.nav-theme .nav-link:focus,
.border-tab.nav-theme .nav-link:hover {
  color: var(--theme-default);
  background-color: transparent;
}
.border-tab.nav-theme .nav-item .nav-link {
  transition: 0.3s;
}
.border-tab.nav-theme .nav-item .nav-link.active, .border-tab.nav-theme .nav-item .nav-link.show, .border-tab.nav-theme .nav-item .nav-link:focus {
  border-bottom: 2px solid var(--theme-default);
}
.border-tab.nav-theme .nav-item .nav-link.active, .border-tab.nav-theme .nav-item .nav-link.show, .border-tab.nav-theme .nav-item .nav-link:focus, .border-tab.nav-theme .nav-item .nav-link:hover {
  color: var(--theme-default);
}

.border-tab.nav-left.nav-theme .nav-link.active,
.border-tab.nav-left.nav-theme .show > .nav-link {
  border-left-color: var(--theme-default);
  color: var(--theme-default);
}

.border-tab.nav-right.nav-theme .nav-link.active,
.border-tab.nav-right.nav-theme .show > .nav-link {
  border-right-color: var(--theme-default);
  color: var(--theme-default);
}

.border-tab.nav-primary .nav-link.active,
.border-tab.nav-primary .nav-item.show,
.border-tab.nav-primary .nav-link:focus,
.border-tab.nav-primary .nav-link:hover {
  color: var(--theme-default);
  background-color: transparent;
}
.border-tab.nav-primary .nav-item .nav-link {
  transition: 0.3s;
}
.border-tab.nav-primary .nav-item .nav-link.active, .border-tab.nav-primary .nav-item .nav-link.show, .border-tab.nav-primary .nav-item .nav-link:focus {
  border-bottom: 2px solid var(--theme-default);
}
.border-tab.nav-primary .nav-item .nav-link.active, .border-tab.nav-primary .nav-item .nav-link.show, .border-tab.nav-primary .nav-item .nav-link:focus, .border-tab.nav-primary .nav-item .nav-link:hover {
  color: var(--theme-default);
}

.border-tab.nav-left.nav-primary .nav-link.active,
.border-tab.nav-left.nav-primary .show > .nav-link {
  border-left-color: var(--theme-default);
  color: var(--theme-default);
}

.border-tab.nav-right.nav-primary .nav-link.active,
.border-tab.nav-right.nav-primary .show > .nav-link {
  border-right-color: var(--theme-default);
  color: var(--theme-default);
}

.border-tab.nav-secondary .nav-link.active,
.border-tab.nav-secondary .nav-item.show,
.border-tab.nav-secondary .nav-link:focus,
.border-tab.nav-secondary .nav-link:hover {
  color: #ff3364;
  background-color: transparent;
}
.border-tab.nav-secondary .nav-item .nav-link {
  transition: 0.3s;
}
.border-tab.nav-secondary .nav-item .nav-link.active, .border-tab.nav-secondary .nav-item .nav-link.show, .border-tab.nav-secondary .nav-item .nav-link:focus {
  border-bottom: 2px solid #ff3364;
}
.border-tab.nav-secondary .nav-item .nav-link.active, .border-tab.nav-secondary .nav-item .nav-link.show, .border-tab.nav-secondary .nav-item .nav-link:focus, .border-tab.nav-secondary .nav-item .nav-link:hover {
  color: #ff3364;
}

.border-tab.nav-left.nav-secondary .nav-link.active,
.border-tab.nav-left.nav-secondary .show > .nav-link {
  border-left-color: #ff3364;
  color: #ff3364;
}

.border-tab.nav-right.nav-secondary .nav-link.active,
.border-tab.nav-right.nav-secondary .show > .nav-link {
  border-right-color: #ff3364;
  color: #ff3364;
}

.border-tab.nav-success .nav-link.active,
.border-tab.nav-success .nav-item.show,
.border-tab.nav-success .nav-link:focus,
.border-tab.nav-success .nav-link:hover {
  color: #54ba4a;
  background-color: transparent;
}
.border-tab.nav-success .nav-item .nav-link {
  transition: 0.3s;
}
.border-tab.nav-success .nav-item .nav-link.active, .border-tab.nav-success .nav-item .nav-link.show, .border-tab.nav-success .nav-item .nav-link:focus {
  border-bottom: 2px solid #54ba4a;
}
.border-tab.nav-success .nav-item .nav-link.active, .border-tab.nav-success .nav-item .nav-link.show, .border-tab.nav-success .nav-item .nav-link:focus, .border-tab.nav-success .nav-item .nav-link:hover {
  color: #54ba4a;
}

.border-tab.nav-left.nav-success .nav-link.active,
.border-tab.nav-left.nav-success .show > .nav-link {
  border-left-color: #54ba4a;
  color: #54ba4a;
}

.border-tab.nav-right.nav-success .nav-link.active,
.border-tab.nav-right.nav-success .show > .nav-link {
  border-right-color: #54ba4a;
  color: #54ba4a;
}

.border-tab.nav-danger .nav-link.active,
.border-tab.nav-danger .nav-item.show,
.border-tab.nav-danger .nav-link:focus,
.border-tab.nav-danger .nav-link:hover {
  color: #fc4438;
  background-color: transparent;
}
.border-tab.nav-danger .nav-item .nav-link {
  transition: 0.3s;
}
.border-tab.nav-danger .nav-item .nav-link.active, .border-tab.nav-danger .nav-item .nav-link.show, .border-tab.nav-danger .nav-item .nav-link:focus {
  border-bottom: 2px solid #fc4438;
}
.border-tab.nav-danger .nav-item .nav-link.active, .border-tab.nav-danger .nav-item .nav-link.show, .border-tab.nav-danger .nav-item .nav-link:focus, .border-tab.nav-danger .nav-item .nav-link:hover {
  color: #fc4438;
}

.border-tab.nav-left.nav-danger .nav-link.active,
.border-tab.nav-left.nav-danger .show > .nav-link {
  border-left-color: #fc4438;
  color: #fc4438;
}

.border-tab.nav-right.nav-danger .nav-link.active,
.border-tab.nav-right.nav-danger .show > .nav-link {
  border-right-color: #fc4438;
  color: #fc4438;
}

.border-tab.nav-info .nav-link.active,
.border-tab.nav-info .nav-item.show,
.border-tab.nav-info .nav-link:focus,
.border-tab.nav-info .nav-link:hover {
  color: #16c7f9;
  background-color: transparent;
}
.border-tab.nav-info .nav-item .nav-link {
  transition: 0.3s;
}
.border-tab.nav-info .nav-item .nav-link.active, .border-tab.nav-info .nav-item .nav-link.show, .border-tab.nav-info .nav-item .nav-link:focus {
  border-bottom: 2px solid #16c7f9;
}
.border-tab.nav-info .nav-item .nav-link.active, .border-tab.nav-info .nav-item .nav-link.show, .border-tab.nav-info .nav-item .nav-link:focus, .border-tab.nav-info .nav-item .nav-link:hover {
  color: #16c7f9;
}

.border-tab.nav-left.nav-info .nav-link.active,
.border-tab.nav-left.nav-info .show > .nav-link {
  border-left-color: #16c7f9;
  color: #16c7f9;
}

.border-tab.nav-right.nav-info .nav-link.active,
.border-tab.nav-right.nav-info .show > .nav-link {
  border-right-color: #16c7f9;
  color: #16c7f9;
}

.border-tab.nav-light .nav-link.active,
.border-tab.nav-light .nav-item.show,
.border-tab.nav-light .nav-link:focus,
.border-tab.nav-light .nav-link:hover {
  color: #f4f4f4;
  background-color: transparent;
}
.border-tab.nav-light .nav-item .nav-link {
  transition: 0.3s;
}
.border-tab.nav-light .nav-item .nav-link.active, .border-tab.nav-light .nav-item .nav-link.show, .border-tab.nav-light .nav-item .nav-link:focus {
  border-bottom: 2px solid #f4f4f4;
}
.border-tab.nav-light .nav-item .nav-link.active, .border-tab.nav-light .nav-item .nav-link.show, .border-tab.nav-light .nav-item .nav-link:focus, .border-tab.nav-light .nav-item .nav-link:hover {
  color: #f4f4f4;
}

.border-tab.nav-left.nav-light .nav-link.active,
.border-tab.nav-left.nav-light .show > .nav-link {
  border-left-color: #f4f4f4;
  color: #f4f4f4;
}

.border-tab.nav-right.nav-light .nav-link.active,
.border-tab.nav-right.nav-light .show > .nav-link {
  border-right-color: #f4f4f4;
  color: #f4f4f4;
}

.border-tab.nav-dark .nav-link.active,
.border-tab.nav-dark .nav-item.show,
.border-tab.nav-dark .nav-link:focus,
.border-tab.nav-dark .nav-link:hover {
  color: #2c323f;
  background-color: transparent;
}
.border-tab.nav-dark .nav-item .nav-link {
  transition: 0.3s;
}
.border-tab.nav-dark .nav-item .nav-link.active, .border-tab.nav-dark .nav-item .nav-link.show, .border-tab.nav-dark .nav-item .nav-link:focus {
  border-bottom: 2px solid #2c323f;
}
.border-tab.nav-dark .nav-item .nav-link.active, .border-tab.nav-dark .nav-item .nav-link.show, .border-tab.nav-dark .nav-item .nav-link:focus, .border-tab.nav-dark .nav-item .nav-link:hover {
  color: #2c323f;
}

.border-tab.nav-left.nav-dark .nav-link.active,
.border-tab.nav-left.nav-dark .show > .nav-link {
  border-left-color: #2c323f;
  color: #2c323f;
}

.border-tab.nav-right.nav-dark .nav-link.active,
.border-tab.nav-right.nav-dark .show > .nav-link {
  border-right-color: #2c323f;
  color: #2c323f;
}

.border-tab.nav-warning .nav-link.active,
.border-tab.nav-warning .nav-item.show,
.border-tab.nav-warning .nav-link:focus,
.border-tab.nav-warning .nav-link:hover {
  color: #ffaa05;
  background-color: transparent;
}
.border-tab.nav-warning .nav-item .nav-link {
  transition: 0.3s;
}
.border-tab.nav-warning .nav-item .nav-link.active, .border-tab.nav-warning .nav-item .nav-link.show, .border-tab.nav-warning .nav-item .nav-link:focus {
  border-bottom: 2px solid #ffaa05;
}
.border-tab.nav-warning .nav-item .nav-link.active, .border-tab.nav-warning .nav-item .nav-link.show, .border-tab.nav-warning .nav-item .nav-link:focus, .border-tab.nav-warning .nav-item .nav-link:hover {
  color: #ffaa05;
}

.border-tab.nav-left.nav-warning .nav-link.active,
.border-tab.nav-left.nav-warning .show > .nav-link {
  border-left-color: #ffaa05;
  color: #ffaa05;
}

.border-tab.nav-right.nav-warning .nav-link.active,
.border-tab.nav-right.nav-warning .show > .nav-link {
  border-right-color: #ffaa05;
  color: #ffaa05;
}

.tabbed-card ul {
  position: absolute;
  right: 22px;
  top: 23px;
  border-bottom: none;
}
.tabbed-card ul.border-tab.nav-tabs {
  top: 12px;
}
.tabbed-card ul.border-tab.nav-tabs .nav-item {
  float: right;
}
.tabbed-card ul.border-tab.nav-tabs .nav-item .nav-link {
  padding: 23px 15px;
}

/**=====================
     44. Tabs CSS Ends
==========================**/
/**=====================
    25. Table  CSS Start
==========================**/
thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: #ecf3fa;
}

.pills-component {
  width: 20%;
}

.table {
  margin-bottom: 0px;
}
.table > :not(:last-child) > :last-child > * {
  border-bottom-color: #ecf3fa;
}
.table th,
.table td {
  padding: 0.75rem;
}
.table.table-primary th {
  color: #fff;
}
.table.table-primary td {
  color: #fff;
}
.table thead.bg-primary tr th {
  color: #fff;
}
.table thead.table-primary tr th {
  color: #7366ff;
}
.table thead.table-success tr th {
  color: #54ba4a;
}
.table tfoot.table-success tr td,
.table tfoot.table-success tr th {
  color: #54ba4a;
}
.table th {
  color: #2f2f3b;
  font-weight: 500;
}
.table td {
  color: #2f2f3b;
}
.table [class*=bg-] {
  color: #fff;
}
.table .bg-light {
  color: #2f2f3b;
}
.table tfoot {
  font-weight: bold;
}

.table-striped.table-styling > tbody > tr:nth-of-type(odd):hover > * {
  color: #7366ff;
}
.table-striped.table-styling > tbody > tr:nth-of-type(odd) > * {
  --bs-table-accent-bg: none;
  color: #fff;
}
.table-striped.bg-primary > tbody > tr:nth-of-type(odd) {
  background-color: rgba(245, 247, 250, 0.5);
}
.table-striped.bg-primary > tbody > tr:nth-of-type(odd) * {
  color: #fff;
}

.table-dark th {
  color: #fff;
}

.table-inverse {
  color: #fff;
  background-color: #292b2c;
}
.table-inverse th,
.table-inverse td {
  border-color: #fff;
  color: #fff;
}
.table-inverse.table-bordered {
  border: 0;
}

.table[class*=bg-] th,
.table[class*=bg-] td {
  color: #fff;
}

.table-hover > tbody > tr:hover {
  --bs-table-accent-bg: unset;
}

.table-double {
  border-left: 4px double #dee2e6;
  border-right: 4px double #dee2e6;
}
.table-double thead,
.table-double tbody,
.table-double tfoot,
.table-double tr,
.table-double td,
.table-double th {
  border-style: double;
  border-width: 4px;
  border-right: 0;
  border-left: 0;
}

.table-dotted {
  border-left: 2px dotted #dee2e6;
  border-right: 2px dotted #dee2e6;
}
.table-dotted thead,
.table-dotted tbody,
.table-dotted tfoot,
.table-dotted tr,
.table-dotted td,
.table-dotted th {
  border-style: dotted !important;
  border-width: 2px;
  border-right: 0;
  border-left: 0;
}

.table-dashed {
  border-left: 2px dashed #dee2e6;
  border-right: 2px dashed #dee2e6;
}
.table-dashed thead,
.table-dashed tbody,
.table-dashed tfoot,
.table-dashed tr,
.table-dashed td,
.table-dashed th {
  border-style: dashed !important;
  border-width: 2px;
  border-right: 0;
  border-left: 0;
}

.table-xl td,
.table-xl th {
  padding: 1.25rem 2rem;
  font-size: 120%;
}

.table-lg td,
.table-lg th {
  padding: 0.9rem 2rem;
  font-size: 110%;
}

.table-de td,
.table-de th {
  padding: 0.75rem 2rem;
}

.table-sm th,
.table-sm td {
  padding: 0.5rem 2rem;
  font-size: 90%;
}

.table-xs th,
.table-xs td {
  padding: 0.2rem 2rem;
  font-size: 80%;
}

.table-border-horizontal tr,
.table-border-horizontal th,
.table-border-horizontal td {
  border-top: 1px solid #f2f4ff;
  padding: 0.75rem;
}

.table-border-vertical tr,
.table-border-vertical th,
.table-border-vertical td {
  border-top: 0;
  border-right: 1px solid #f2f4ff;
}
.table-border-vertical tr td {
  border-bottom: 0;
}
.table-border-vertical tr td:last-child {
  border-right: none;
}
.table-border-vertical tbody tr th {
  border-bottom: 0;
}

.table-bordernone td {
  border: none !important;
}
.table-bordernone thead th {
  border: none !important;
}
.table-bordernone .u-s-tb {
  padding: 11px;
}

.table-striped tbody tr:nth-of-type(odd) {
  --bs-table-accent-bg: rgba(245, 247, 250, 0.5);
}

.table-bordered thead,
.table-bordered tbody,
.table-bordered tfoot,
.table-bordered tr,
.table-bordered td,
.table-bordered th {
  border-color: #ecf3fa;
}

.grid-wrrapper .table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(115, 102, 255, 0.1);
  --bs-table-accent-bg: unset;
}
.grid-wrrapper .table-striped tbody tr:nth-of-type(odd) th,
.grid-wrrapper .table-striped tbody tr:nth-of-type(odd) td {
  color: #7366ff;
}

/**=====================
     25.Table CSS Ends
==========================**/
.w-20 {
  width: 20px;
}

.h-20 {
  height: 20px;
}

.app-dark,
.app-light {
  display: flex;
  justify-content: center;
}

.app-dark .react-timekeeper__clock-wrapper {
  background-color: #7e7e7e;
  padding: 18px 0;
}
.app-dark .react-timekeeper__clock-wrapper .react-timekeeper-button-reset {
  color: #2f2f3b !important;
}

.App .react-timekeeper__clock-wrapper > div:last-of-type {
  padding: 0 10px;
  position: relative;
  z-index: 7;
  top: 0;
}

.App .react-timekeeper__top-bar {
  padding: 4px;
}

.App .react-timekeeper__top-bar .react-timekeeper__tb-minute-wrapper {
  width: auto;
}

.App .react-timekeeper__top-bar * {
  font-size: 22px !important;
}

.App .react-timekeeper__done-button {
  padding: 12px;
}

.timepicker-form .react-timekeeper__clock ~ div {
  z-index: 7;
}
.timepicker-form .react-timekeeper__hand-circle-outer {
  fill: var(--theme-default);
}
.timepicker-form .react-timekeeper__clock-hand {
  stroke: var(--theme-default);
}
.timepicker-form .react-timekeeper__clock-wrapper .react-timekeeper-button-reset {
  background-color: #e1eff6;
}
.timepicker-form .react-timekeeper__top-bar {
  background-color: var(--theme-default) !important;
}
.timepicker-form .react-timekeeper__tb-hour,
.timepicker-form .react-timekeeper__tb-colon,
.timepicker-form .react-timekeeper__tb-minute,
.timepicker-form .react-timekeeper-button-reset {
  color: #fff !important;
}
.timepicker-form .row > div:last-child .card .card-body .theme-form div.mb-0 {
  display: flex;
  justify-content: space-around;
}
.timepicker-form .row > div:last-child .card .card-body .theme-form div.mb-0 .react-timekeeper:first-child .react-timekeeper__top-bar {
  padding: 14px 8px;
}

@media screen and (max-width: 767px) {
  .timepicker-form .row > div:last-child .card .card-body .theme-form div.mb-0 {
    display: block;
  }
  .timepicker-form .row > div:last-child .card .card-body .theme-form div.mb-0 .react-timekeeper {
    display: block;
    margin: 0 auto;
  }
  .timepicker-form .row > div:last-child .card .card-body .theme-form div.mb-0 .react-timekeeper + .react-timekeeper {
    margin-top: 15px;
  }
}
@media screen and (max-width: 360px) {
  .timepicker-form .row > div:last-child .card .card-body .theme-form div.mb-0 .react-timekeeper {
    width: 240px !important;
  }
}
/**=====================
    20.  Touchspin  CSS Start
==========================**/
.bootstrap-touchspin input.touchspin {
  padding: 0 12px;
}
.bootstrap-touchspin .input-group .btn {
  padding: 0.5rem 1.75rem;
}
.bootstrap-touchspin .touchspin-vertical-tab .input-group .input-group-btn-vertical {
  position: relative;
  white-space: nowrap;
  width: 1%;
  vertical-align: middle;
  display: table-cell;
}
.bootstrap-touchspin .touchspin-vertical-tab .input-group .input-group-btn-vertical .bootstrap-touchspin-down {
  margin-top: -2px;
}
.bootstrap-touchspin .touchspin-vertical-tab .input-group .input-group-btn-vertical i {
  position: absolute;
  top: 4px;
  left: 7px;
  font-size: 10px;
  font-weight: normal;
}
.bootstrap-touchspin .touchspin-vertical-tab .input-group .input-group-btn-vertical > .btn {
  display: block;
  float: none;
  width: 100%;
  max-width: 100%;
  padding: 9px;
  margin-left: -1px;
  position: relative;
}
.bootstrap-touchspin .input-group {
  font-family: Rubik, sans-serif;
}
.bootstrap-touchspin .input-group .btn {
  border-radius: 0 !important;
}
.bootstrap-touchspin .dropdown-basic .dropdown .dropbtn {
  padding: 9px 30px;
}
.bootstrap-touchspin .dropdown-basic .dropdown .dropdown-content {
  z-index: 9999;
}

/**=====================
     20. Touchspin  CSS Ends
==========================**/
/**=====================
     54. Tour  CSS Start
==========================**/
.introjs-helperLayer {
  background-color: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(0, 0, 0, 0.5);
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.4);
}

.introjs-tooltipReferenceLayer {
  background-color: transparent;
}

.introjs-helperNumberLayer {
  color: #fff;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);
  background: #fc4438;
  background: linear-gradient(to bottom, var(--theme-default) 0%, var(--theme-default) 100%);
  border: 3px solid #fff;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.4);
}

.introjs-arrow {
  border: 12px solid #fff;
}
.introjs-arrow.top {
  border-top-color: transparent;
  border-right-color: transparent;
  border-bottom-color: var(--theme-default);
  border-left-color: transparent;
}
.introjs-arrow.top-right {
  border-top-color: transparent;
  border-right-color: transparent;
  border-bottom-color: var(--theme-default);
  border-left-color: transparent;
}
.introjs-arrow.top-middle {
  border-top-color: transparent;
  border-right-color: transparent;
  border-bottom-color: var(--theme-default);
  border-left-color: transparent;
}
.introjs-arrow.right {
  border-top-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
  border-left-color: var(--theme-default);
}
.introjs-arrow.right-bottom {
  border-top-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
  border-left-color: var(--theme-default);
}
.introjs-arrow.bottom {
  border-top-color: var(--theme-default);
  border-right-color: transparent;
  border-bottom-color: transparent;
  border-left-color: transparent;
}
.introjs-arrow.left {
  border-top-color: transparent;
  border-right-color: var(--theme-default);
  border-bottom-color: transparent;
  border-left-color: transparent;
}
.introjs-arrow.left-bottom {
  border-top-color: transparent;
  border-right-color: var(--theme-default);
  border-bottom-color: transparent;
  border-left-color: transparent;
}

.introjs-tooltip {
  background-color: var(--theme-default);
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.4);
  color: #fff;
  border-color: var(--theme-default);
}

.introjs-button {
  border: 1px solid #efefef;
  text-shadow: 1px 1px 0 #fff;
  color: #2f2f3b !important;
  background-color: #fff;
  background-image: linear-gradient(#fff, #fff);
}
.introjs-button:hover {
  border-color: #efefef;
}
.introjs-button:focus, .introjs-button:active {
  background-image: linear-gradient(#ecf3fa, #efefef);
}

.introjs-skipbutton {
  color: var(--theme-default);
}

.introjs-prevbutton.introjs-fullbutton {
  border: 1px solid #efefef;
}

.introjs-disabled {
  color: var(--theme-default);
  border-color: #efefef;
}
.introjs-disabled:hover, .introjs-disabled:focus {
  color: var(--theme-default);
  border-color: #efefef;
}

.introjs-bullets ul li a {
  background: #ecf3fa;
}
.introjs-bullets ul li a:hover {
  background: #fff;
}
.introjs-bullets ul li a.active {
  background: #fff;
}

.introjs-progress {
  background-color: #f4f4f4;
}

.introjs-progressbar {
  background-color: var(--theme-default);
}

.introjs-hint:hover > .introjs-hint-pulse {
  border: 5px solid rgba(60, 60, 60, 0.57);
}

.introjs-hint-pulse {
  border: 5px solid rgba(60, 60, 60, 0.27);
  background-color: rgba(136, 136, 136, 0.24);
}

.introjs-hint-dot {
  border: 10px solid rgba(146, 146, 146, 0.36);
}

/**=====================
    54. Tour  CSS Ends
==========================**/
/**=====================
     typahead-search  CSS Start
==========================**/
.Typeahead {
  width: 100%;
}
.Typeahead * {
  box-sizing: border-box;
}
.Typeahead *:before {
  box-sizing: border-box;
}
.Typeahead *:after {
  box-sizing: border-box;
}
.Typeahead .tt-hint {
  display: none !important;
}

.u-cf:before {
  content: " ";
  display: table;
}
.u-cf:after {
  content: " ";
  display: table;
  clear: both;
}

.u-hidden {
  display: none !important;
}

.u-posRelative {
  position: relative;
}

.Typeahead-spinner {
  position: absolute;
  top: 14px;
  right: 18px;
  display: none;
  color: #c5c5c5;
}

.ProfileCard-avatar svg {
  height: 18px;
  vertical-align: bottom;
}
.ProfileCard-avatar svg path {
  color: #7e7c7c !important;
}
.ProfileCard-avatar svg polygon {
  color: #7e7c7c !important;
}

.Typeahead-hint {
  width: 100%;
  padding: 5px 8px;
  font-size: 24px;
  line-height: 30px;
  border: 1px solid #024e6a;
  border-radius: 8px;
  position: absolute;
  top: 0;
  left: 0;
  color: #ccd6dd;
  opacity: 1;
}

.Typeahead-menu {
  position: absolute;
  top: 100%;
  left: 0;
  padding: 15px;
  z-index: 100;
  display: none;
  width: 100%;
  overflow: hidden;
  background-color: #fff;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
}

.Typeahead-menu.is-open {
  display: block;
}

.Typeahead-selectable {
  cursor: pointer;
}
.Typeahead-selectable + .Typeahead-selectable {
  border-top: 1px solid #ccd6dd;
}

.ProfileCard {
  position: relative;
  padding: 10px;
  border: 1px solid #cccccc !important;
  margin-bottom: 10px;
  border-radius: 10px;
}
.ProfileCard:hover .ProfileCard-avatar {
  border-color: #f5f8fa;
}
.ProfileCard:hover {
  color: #414345;
  background: #f8f8f8;
}
.ProfileCard:hover .ProfileCard-screenName {
  color: #fff;
}
.ProfileCard:hover .ProfileCard-stat-label {
  color: #fff;
}

.ProfileCard-avatar {
  position: absolute;
  border-radius: 5px;
}

.ProfileCard-details {
  padding-left: 35px;
  float: left;
}

.ProfileCard-realName {
  display: inline-block;
  color: #898989;
}

.ProfileCard-screenName {
  display: inline-block;
  color: #898989;
}

.ProfileCard-description {
  margin-top: 5px;
  font-size: 14px;
  line-height: 18px;
}

.ProfileCard-stats {
  float: right;
  text-align: right;
}

.ProfileCard-stat {
  display: inline-block;
  font-size: 12px;
  line-height: 16px;
  text-transform: uppercase;
}
.ProfileCard-stat + .ProfileCard-stat {
  margin-left: 5px;
}

.ProfileCard-stat-label {
  color: #898989;
  font-weight: 500;
}

.ProfileCard.is-active {
  color: #fff;
  background: var(--theme-default);
}
.ProfileCard.is-active .ProfileCard-screenName {
  color: #fff;
}
.ProfileCard.is-active .ProfileCard-stat-label {
  color: #fff;
}

.EmptyMessage {
  position: relative;
  padding: 10px;
  font-size: 14px;
  line-height: 30px;
  text-align: center;
}

.Typeahead-spinner {
  width: 1rem;
  height: 1rem;
}

.Typeahead .stroke-icon {
  stroke: #2f2f3b;
}
.Typeahead .fill-icon {
  fill: #2f2f3b;
}
.Typeahead a {
  color: #2f2f3b;
}
.Typeahead .header-search-suggestion {
  max-height: 320px;
  overflow: auto;
}

body.dark-only .Typeahead .stroke-icon {
  stroke: rgba(255, 255, 255, 0.6);
}
body.dark-only .Typeahead .fill-icon {
  fill: rgba(255, 255, 255, 0.6);
}
body.dark-only .Typeahead a {
  color: rgba(255, 255, 255, 0.6);
}

/**=====================
    typahead-search CSS Ends
==========================**/
/**=====================
      90. React-Plugin CSS Start
==========================**/
.simple-list .list-group-item {
  padding: 0;
  border: none;
  background-color: transparent;
}

body.dark-only .page-wrapper .list-group:not(.simple-list) .list-group-item,
.list-group-item {
  padding: 0;
  border: none;
  background-color: transparent;
}

img.media {
  display: unset;
  border: none;
  margin-bottom: 0;
}

ul.list-group {
  display: block;
}
ul.list-group li.list-group-item.active {
  background-color: transparent;
  border-color: transparent;
}
ul.list-group img {
  width: auto;
  height: auto;
}
ul.list-group i {
  margin-right: unset;
}

.slick-page .slick-slider {
  margin: -8px 0 20px;
}

.slick-slider {
  margin: -7px 0 0;
}
.slick-slider .item:focus {
  outline: none;
}
.slick-slider .slick-dots li button:before {
  font-size: 12px;
  color: var(--theme-default);
}
.slick-slider .slick-dots li.slick-active button:before {
  color: var(--theme-default);
}

.rangeslider-horizontal .rangeslider__fill,
.rangeslider-vertical .rangeslider__fill {
  background-color: var(--theme-default) !important;
}
.rangeslider-horizontal .rangeslider__handle:focus,
.rangeslider-vertical .rangeslider__handle:focus {
  outline: none;
}

.slider-vertical .value,
.vertical-height .value {
  text-align: center;
}

.rangeslider-vertical .rangeslider__labels {
  margin: 0 0 0 32px !important;
}

.input-range__slider {
  background: var(--theme-default);
  border: 1px solid var(--theme-default);
}

.input-range__track--active {
  background: var(--theme-default);
}

.input-range {
  margin-bottom: 34px;
}

.dzu-dropzone {
  border: 2px dashed var(--theme-default) !important;
  background: rgba(115, 102, 255, 0.2);
  overflow: auto !important;
}
.dzu-dropzone .dz-message .note {
  background-color: transparent;
}

.dzu-inputLabel {
  color: var(--theme-default) !important;
  text-align: center;
  margin-bottom: 0;
}

.dzu-previewContainer {
  padding: 30px !important;
  min-height: 115px;
}

.dzu-inputLabelWithFiles {
  margin-left: 30px !important;
  background-color: var(--theme-default) !important;
  color: #fff !important;
}

.dzu-submitButton {
  background-color: var(--theme-default) !important;
}
.dzu-submitButton:disabled {
  background-color: #e6e6e6 !important;
}

.input-cropper {
  margin-bottom: 15px;
  border: 1px solid #ced4da;
  padding: 10px;
  border-radius: 4px;
  width: auto;
}
.input-cropper input {
  width: -webkit-fill-available;
}

.crop-portion {
  margin-left: 0;
  margin-top: 30px;
  vertical-align: baseline;
}

.cropper-view-box {
  outline-color: var(--theme-default);
  outline: 1px solid var(--theme-default);
}

.cropper-point {
  background-color: var(--theme-default);
}

.note {
  background-color: rgba(115, 102, 255, 0.3);
}
.note:nth-child(2n) {
  background: rgba(255, 51, 100, 0.3);
}

.react-stickies-wrapper .close:before, .react-stickies-wrapper .close:after {
  background: transparent !important;
}
.react-stickies-wrapper .react-grid-layout .react-grid-item:nth-child(1n) .note {
  background: white !important;
}
.react-stickies-wrapper .react-grid-layout .react-grid-item:nth-child(2n) .note {
  background: rgb(100%, 90%, 92.4019607843%) !important;
}
.react-stickies-wrapper .react-grid-layout .react-grid-item:nth-child(3n) .note {
  background: white !important;
}
.react-stickies-wrapper .react-grid-layout .react-grid-item:nth-child(4n) .note {
  background: rgb(67.1211748298%, 92.0977930921%, 99.1533349742%) !important;
}
.react-stickies-wrapper .react-grid-layout .react-grid-item:nth-child(5n) .note {
  background: rgb(100%, 90.4666666667%, 71.9607843137%) !important;
}
.react-stickies-wrapper .react-grid-layout .react-grid-item:nth-child(6n) .note {
  background: rgb(99.5661036692%, 72.9537953795%, 71.2182100563%) !important;
}

.lead {
  margin-bottom: 5px;
}

.swal2-container .swal2-actions .swal2-styled {
  font-size: 14px;
}

.swal2-styled.swal2-confirm {
  background-color: var(--theme-default) !important;
}
.swal2-styled.swal2-confirm:focus {
  box-shadow: 0 0 0 1px #fff, 0 0 0 3px rgba(115, 102, 255, 0.4);
}

.swal2-title {
  font-size: 20px !important;
}

.swal2-progress-steps .swal2-progress-step,
.swal2-progress-steps .swal2-progress-step-line {
  background: var(--theme-default) !important;
}
.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step {
  background: var(--theme-default) !important;
}
.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step,
.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step-line {
  background: rgba(115, 102, 255, 0.2) !important;
}

.bootstrap-datetimepicker-widget tr th:active, .bootstrap-datetimepicker-widget tr th.active,
.bootstrap-datetimepicker-widget tr td:active,
.bootstrap-datetimepicker-widget tr td.active {
  background-color: var(--theme-default);
}
.bootstrap-datetimepicker-widget tr th span:active, .bootstrap-datetimepicker-widget tr th span.active,
.bootstrap-datetimepicker-widget tr td span:active,
.bootstrap-datetimepicker-widget tr td span.active {
  background-color: var(--theme-default);
}

.fileContainer {
  padding: 0 !important;
  margin: 0 !important;
  box-shadow: none !important;
}
.fileContainer .files-gallery {
  display: flex;
  justify-content: center;
}
.fileContainer .files-gallery .files-gallery-item {
  width: 45%;
  display: flex;
  margin: 0 auto;
}
.fileContainer .uploadPictureContainer {
  margin: 1% !important;
  padding: 10px;
}
.fileContainer .chooseFileButton {
  margin-top: 0 !important;
  padding: 6px 23px;
  background: #ff3364;
  border-radius: 30px;
  color: #fff;
  font-weight: 300;
  font-size: 14px;
  margin: 10px 0;
  transition: all 0.2s ease-in;
  cursor: pointer;
  outline: none;
  border: none;
}

.daterangepicker td.available:hover,
.daterangepicker th.available:hover {
  background-color: var(--theme-default);
}

.todo .action-box.large .icon .icon-trash,
.todo .action-box.large .icon .icon-check {
  color: var(--theme-default);
}
.todo .todo-list-wrapper #todo-list li.completed .task-container .task-label {
  color: var(--theme-default);
}
@keyframes taskHighlighter {
  0% {
    background: rgba(115, 102, 255, 0.5);
  }
  100% {
    background: #fff;
  }
}

.react-clock__face {
  border: 1px solid #fff !important;
}

.react-clock__mark__body,
.react-clock__hand__body {
  background-color: #fff !important;
}

.scrollarea {
  max-width: 800px;
  max-height: 300px;
}
.scrollarea .scrollbar-container {
  z-index: 7 !important;
}

ol.progtrckr {
  list-style-type: none;
  padding: 0;
  display: flex;
}
ol.progtrckr li {
  display: inline-block;
  text-align: center;
  line-height: 4.5rem;
  cursor: pointer;
  width: 100%;
}
ol.progtrckr li span {
  padding: 0 1.5rem;
}
ol.progtrckr li.progtrckr-doing {
  color: black;
  border-bottom: 4px solid #cccccc;
}
ol.progtrckr li.progtrckr-doing:before {
  content: "•";
  color: white;
  background-color: #cccccc;
  width: 1.2em;
  line-height: 1.2em;
  border-radius: 1.2em;
}
ol.progtrckr li.progtrckr-doing:hover:before {
  color: #ff4500;
}
ol.progtrckr li.progtrckr-done {
  color: black;
  border-bottom: 4px solid #5cb85c;
}
ol.progtrckr li.progtrckr-done:before {
  content: "✓";
  color: white;
  background-color: #5cb85c;
  width: 1.2em;
  line-height: 1.2em;
  border-radius: 1.2em;
}
ol.progtrckr li.progtrckr-done:hover:before {
  color: #333;
}
ol.progtrckr li:after {
  content: "  ";
}
ol.progtrckr li:before {
  position: relative;
  bottom: -3.7rem;
  float: left;
  left: 50%;
}
ol.progtrckr li.progtrckr-todo:before {
  content: "Ο";
  color: silver;
  background-color: transparent;
  width: 1.2em;
  line-height: 1.4em;
}
ol.progtrckr li.progtrckr-todo:hover:before {
  color: #ff4500;
}

.rbc-calendar {
  height: 1000px !important;
}

#external-events {
  position: absolute;
  z-index: 2;
  padding: 0 10px;
  border: 1px solid #ccc;
  background: #eee;
  overflow: auto;
}
#external-events p strong {
  font-size: 16px;
}

#external-events .fc-event {
  margin: 1em 0;
  cursor: move;
}

.rbt-token {
  color: var(--theme-default) !important;
  background-color: rgba(115, 102, 255, 0.1) !important;
}
.rbt-token .rbt-token-remove-button {
  top: 1px !important;
}

.rbt-aux .rbt-close {
  margin-top: 0;
}

.react_times_button .wrapper {
  display: block;
}

.basic-calendar .demo-app-calendar .fc-daygrid-day-events .fc-event {
  background-color: #7366ff;
  border: 1px solid #7366ff;
  color: white;
  font-size: 11.9px;
  padding: 0 10px;
}
.basic-calendar .demo-app-calendar .fc-daygrid-day-events .fc-event .fc-daygrid-event-dot {
  display: none;
}
.basic-calendar .demo-app-calendar .fc-daygrid-day-events .fc-event .fc-event-time {
  display: none;
}
.basic-calendar .fc-scrollgrid a {
  color: var(--body-font-color);
}
.basic-calendar .calendar-basic #external-events {
  background-color: #fff;
}

.time_picker_wrapper2 {
  display: flex;
}
.time_picker_wrapper2 .time_picker_container {
  width: 44%;
}
.time_picker_wrapper2 .gap {
  padding: 0 5px;
}

.Toastify__close-button {
  font-weight: 500;
}
.Toastify__close-button svg {
  stroke: #fff !important;
  fill: #fff !important;
}

.Toastify__toast--success {
  background: rgb(53.4611764706%, 81.2211764706%, 50.7396078431%) !important;
  color: #fff !important;
  font-weight: 500;
}
.Toastify__toast--success svg {
  fill: transparent !important;
  stroke: #fff !important;
}
.Toastify__toast--success .Toastify__progress-bar {
  background: rgb(80.8211764706%, 92.2611764706%, 79.6996078431%) !important;
}

.Toastify__toast--info {
  background: rgb(37.8743129051%, 85.0685043892%, 98.4001968988%) !important;
  color: #fff !important;
}
.Toastify__toast--info svg {
  fill: transparent !important;
  stroke: #fff !important;
}
.Toastify__toast--info .Toastify__progress-bar {
  background: rgb(76.8701288047%, 94.4408893264%, 99.4043809993%) !important;
}

.Toastify__toast--warning {
  background: rgb(100%, 70.0666666667%, 11.9607843137%) !important;
  color: #fff !important;
}
.Toastify__toast--warning svg {
  fill: transparent !important;
  stroke: #fff !important;
}
.Toastify__toast--warning .Toastify__progress-bar {
  background: rgb(100%, 76.8666666667%, 31.9607843137%) !important;
}

.Toastify__toast--error {
  background: rgb(99.1205591147%, 45.1815181518%, 41.6637546108%) !important;
  color: #fff !important;
  font-weight: 500;
}
.Toastify__toast--error svg {
  fill: transparent !important;
  stroke: #fff !important;
}
.Toastify__toast--error .Toastify__progress-bar {
  background: rgb(99.4175888177%, 63.696369637%, 61.3667249078%) !important;
}

.draggable-card > div > div {
  width: 100%;
  display: flex;
}
.draggable-card > div > div .react-kanban-column {
  width: 100%;
}
.draggable-card > div > div .react-kanban-card {
  min-width: 100%;
  max-width: 100%;
}

.ui-sortable .react-kanban-board div[data-rbd-droppable-id=board-droppable] {
  width: 100%;
  display: flex;
}
.ui-sortable .react-kanban-board .react-kanban-column {
  width: 100%;
}
.ui-sortable .react-kanban-board .react-kanban-card {
  max-width: 100%;
}

.jkanban-container .custom-board .kanban-drag .react-kanban-column:nth-child(2) div[data-rbd-drag-handle-context-id="1"] {
  background-color: #ffaa05;
}
.jkanban-container .custom-board .kanban-drag .react-kanban-column:nth-child(2) div[data-rbd-drag-handle-context-id="1"] ~ div {
  background-color: rgba(255, 170, 5, 0.3);
}
.jkanban-container .custom-board .kanban-drag .react-kanban-column:nth-child(3) div[data-rbd-drag-handle-context-id="1"] {
  background-color: #54ba4a;
}
.jkanban-container .custom-board .kanban-drag .react-kanban-column:nth-child(3) div[data-rbd-drag-handle-context-id="1"] ~ div {
  background-color: rgba(84, 186, 74, 0.3);
}
.jkanban-container .custom-board .kanban-drag div[data-rbd-drag-handle-context-id="1"] {
  background-color: #16c7f9;
  color: #fff;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.jkanban-container .custom-board .kanban-drag div[data-rbd-drag-handle-context-id="1"] ~ div {
  background-color: rgba(22, 199, 249, 0.3);
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
}
.jkanban-container .custom-board .kanban-drag div[data-rbd-drag-handle-context-id="1"] span {
  font-weight: 500;
}
.jkanban-container .custom-board .kanban-drag div[data-rbd-drag-handle-context-id="1"] span.badge {
  font-weight: 400;
}
.jkanban-container .kanban-container {
  display: flex;
}
.jkanban-container .kanban-container .kanban-board {
  width: 100%;
}
.jkanban-container .kanban-container .kanban-item .customers ul.simple-list li {
  background-color: transparent;
}
.jkanban-container .kanban-container .kanban-item .customers ul.simple-list li + li img {
  margin: 0;
}
.jkanban-container .kanban-container .kanban-item:focus {
  outline: none;
}
.jkanban-container .kanban-container .kanban-item .kanban-box {
  border: 1px solid #efefef;
  background-color: #fff !important;
  color: #2f2f3b;
}
.jkanban-container .kanban-container .kanban-item .kanban-box:focus {
  outline: none;
}
.jkanban-container .kanban-container .kanban-drag {
  width: 100%;
}
.jkanban-container .kanban-container .kanban-drag .react-kanban-column-header {
  font-weight: 500;
}
.jkanban-container .kanban-container .kanban-drag .react-kanban-column-header:focus {
  outline: none;
}
.jkanban-container .kanban-container .kanban-drag .react-kanban-column-header > div:focus {
  outline: none;
}
.jkanban-container .kanban-container .kanban-drag > div {
  padding: 0;
}
.jkanban-container .kanban-container .kanban-drag > div > div {
  display: flex;
  width: 100%;
  margin-bottom: -25px;
}
.jkanban-container .kanban-container .kanban-drag > div > div .react-kanban-column {
  width: 98%;
  background-color: #f8f8f8;
  border-radius: 8px;
  padding: 0;
  margin-bottom: 30px;
}
.jkanban-container .kanban-container .kanban-drag > div > div .react-kanban-column > div {
  width: 100%;
  padding: 20px;
  font-size: 16px;
}
.jkanban-container .kanban-container .kanban-drag > div > div .react-kanban-column > div[data-rbd-drag-handle-context-id="0"], .jkanban-container .kanban-container .kanban-drag > div > div .react-kanban-column > div[data-rbd-drag-handle-context-id="2"] {
  border-bottom: 1px solid #efefef;
}
.jkanban-container .kanban-container .kanban-drag > div > div .react-kanban-column > div p {
  font-weight: 400;
}
.jkanban-container .kanban-container .kanban-drag > div > div .react-kanban-column > div > div {
  padding-bottom: 0;
}
.jkanban-container .kanban-container .kanban-drag > div > div .react-kanban-column .react-kanban-board > div {
  width: 100%;
}
.jkanban-container .kanban-container .kanban-drag > div > div .react-kanban-column .react-kanban-board + .react-kanban-board {
  margin-top: 20px;
}
.jkanban-container .react-kanban-column {
  background-color: #f8f8f8;
}
.jkanban-container .react-kanban-column > div > div > div {
  display: block !important;
}
.jkanban-container .react-kanban-column div[tabindex="0"] + div[tabindex="0"] {
  margin-top: 20px;
}

.ui-sortable .container {
  display: block;
  width: 100%;
  padding: 10px;
  background-color: var(--theme-default);
}
.ui-sortable .container div {
  padding: 10px;
  background-color: rgb(43.2679738562%, 38%, 100%);
  transition: opacity 0.4s ease-in-out;
  color: #fff;
}
.ui-sortable .container div {
  cursor: move;
  cursor: grab;
  cursor: -webkit-grab;
  margin-bottom: 10px;
}
.ui-sortable .container div:last-child {
  margin-bottom: 0;
}
.ui-sortable .container.ex-moved {
  background-color: #e74c3c;
}
.ui-sortable .container.ex-over {
  background-color: var(--theme-default);
}
.ui-sortable .container:nth-child(odd) {
  background-color: var(--theme-default);
}

.gh-fork {
  position: fixed;
  top: 0;
  right: 0;
  border: 0;
}

.gu-mirror {
  padding: 10px;
  background-color: rgb(35.9477124183%, 30%, 100%);
  transition: opacity 0.4s ease-in-out;
  color: #fff;
  position: fixed !important;
  margin: 0 !important;
  z-index: 9999 !important;
  opacity: 0.8;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=80)";
  filter: alpha(opacity=80);
}

.gu-hide {
  display: none !important;
}

.gu-unselectable {
  -webkit-user-select: none !important;
  user-select: none !important;
}

.gu-transit {
  opacity: 0.2;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=20)";
  filter: alpha(opacity=20);
}

.wrapper {
  display: table;
}

.gu-mirror {
  cursor: grabbing;
  cursor: -webkit-grabbing;
}

.handle {
  padding: 0 5px;
  margin-right: 5px;
  background-color: rgb(17.6470588235%, 10%, 100%);
  cursor: move;
}

.vertical-timeline::before {
  background: #f4f4f4;
}
.vertical-timeline .vertical-timeline-element p {
  font-size: 13px !important;
}
.vertical-timeline .vertical-timeline-element .vertical-timeline-element-icon {
  color: #fff;
}
.vertical-timeline .vertical-timeline-element:first-child .vertical-timeline-element-icon, .vertical-timeline .vertical-timeline-element:nth-child(7) .vertical-timeline-element-icon {
  background-color: var(--theme-default);
}
.vertical-timeline .vertical-timeline-element:nth-child(2) .vertical-timeline-element-icon {
  background-color: #ff3364;
}
.vertical-timeline .vertical-timeline-element:nth-child(3) .vertical-timeline-element-icon, .vertical-timeline .vertical-timeline-element:last-child .vertical-timeline-element-icon {
  background-color: #54ba4a;
}
.vertical-timeline .vertical-timeline-element:nth-child(4) .vertical-timeline-element-icon {
  background-color: #16c7f9;
}
.vertical-timeline .vertical-timeline-element:nth-child(5) .vertical-timeline-element-icon {
  background-color: #ffaa05;
}
.vertical-timeline .vertical-timeline-element:nth-child(6) .vertical-timeline-element-icon {
  background-color: #fc4438;
}

.vertical-timeline-element-content {
  box-shadow: 1px 1px 2px 1px rgba(0, 0, 0, 0.08);
  background-color: #fdfeff;
}
.vertical-timeline-element-content audio {
  width: 100%;
  margin-top: 15px;
}
.vertical-timeline-element-content .vertical-timeline-element-date {
  font-size: 14px !important;
}
.vertical-timeline-element-content .vertical-timeline-element-content-arrow {
  border-right: 7px solid #f4f4f4;
}

.vertical-timeline--two-columns .vertical-timeline-element-content .vertical-timeline-element-date {
  top: 10px !important;
}

.vertical-timeline--one-column:before {
  left: 28px !important;
}
.vertical-timeline--one-column .vertical-timeline-element-icon {
  width: 60px;
  height: 60px;
}
.vertical-timeline--one-column .vertical-timeline-element-content {
  margin-left: 90px;
}
.vertical-timeline--one-column .vertical-timeline-element-content img {
  width: 500px;
}
.vertical-timeline--one-column .vertical-timeline-element-content .vertical-timeline-element-date {
  float: none;
  display: block;
}

.rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(4) .rdt_TableCol_Sortable {
  justify-content: center;
}
.rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(4) .rdt_TableCol_Sortable span {
  display: none;
}
.rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol .rdt_TableCol_Sortable {
  justify-content: flex-start;
}
.rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol .rdt_TableCol_Sortable > div {
  font-weight: 500 !important;
}
.rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell {
  padding: 12px;
}
.rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4) {
  justify-content: center !important;
}
.rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell + .rdt_TableCell {
  justify-content: flex-start;
}

.leaflet-top,
.leaflet-bottom {
  z-index: 7 !important;
}

.leaflet-pane {
  z-index: 1 !important;
}

.map-block svg g {
  transform-origin: 0 0;
}

#gmap-simple svg path {
  fill: var(--theme-default) !important;
}

#usa svg path {
  fill: #ff3364 !important;
}

#canada svg path {
  fill: #54ba4a !important;
}

#asia svg path {
  fill: #ffaa05 !important;
}

#europe svg path {
  fill: #fc4438 !important;
}

#america svg path {
  fill: #2c323f !important;
}

.ace_editor {
  width: auto !important;
  overflow: auto;
}

.carousal .slick-slider .slick-slide {
  margin-right: 15px;
}

.jvectormap-zoomin,
.jvectormap-zoomout {
  width: 20px;
  height: 20px;
}

.jvectormap-zoomin {
  bottom: 65px;
}

.jvectormap-zoomout {
  bottom: 30px;
}

.jvectormap-zoomin,
.jvectormap-zoomout,
.jvectormap-goback {
  position: absolute;
  border-radius: 3px;
  background: #292929;
  padding: 5px;
  color: #fff;
  cursor: pointer;
  text-align: center;
  box-sizing: content-box;
}

.rating {
  align-items: center;
}
.rating span .fa {
  color: var(--theme-default);
}
.rating span span span {
  color: var(--theme-default);
}

@media screen and (max-width: 600px) {
  .jkanban-container .kanban-container .kanban-drag {
    padding: 0;
  }
  .jkanban-container .kanban-container .kanban-drag > div {
    width: 100% !important;
  }
  .jkanban-container .kanban-container .kanban-drag > div > div div[data-rbd-drag-handle-context-id="1"] {
    width: 100% !important;
  }
}
.page-wrapper .page-header .header-wrapper .bookmark-flip {
  width: unset !important;
  box-shadow: unset !important;
  background-color: transparent !important;
  overflow: initial;
}
.page-wrapper .page-header .header-wrapper .bookmark-flip .Typeahead-menu {
  background-color: transparent !important;
  box-shadow: none;
  left: -1px;
  max-height: 85px;
  overflow: auto;
  top: 75px;
}
.page-wrapper .page-header .header-wrapper .bookmark-flip .Typeahead-menu .ProfileCard-realName {
  width: 100%;
}
.page-wrapper .page-header .header-wrapper .bookmark-flip .Typeahead-menu .ProfileCard-details {
  float: unset;
  text-align: left;
}
.page-wrapper .page-header .header-wrapper .bookmark-flip .Typeahead-menu .ProfileCard {
  border: none !important;
  padding: 8px;
  position: relative;
  margin: 0;
}
.page-wrapper .page-header .header-wrapper .bookmark-flip .Typeahead-menu .ProfileCard:hover {
  background-color: var(--chart-border);
}
.page-wrapper .page-header .header-wrapper .bookmark-flip .Typeahead-menu .ProfileCard .realname {
  text-transform: capitalize !important;
  text-decoration: none;
}
.page-wrapper .page-header .header-wrapper .bookmark-flip .Typeahead-menu .ProfileCard .pull-right {
  margin-left: auto;
}
.page-wrapper .page-header .header-wrapper .flip-card {
  width: 220px;
  height: 245px;
  background-color: transparent;
}
.page-wrapper .page-header .header-wrapper .flip-card .flip-card-inner {
  position: relative;
  height: 100%;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
}
.page-wrapper .page-header .header-wrapper .flip-card .flip-card-inner .back {
  position: absolute;
  backface-visibility: hidden;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 0 20px rgba(89, 102, 122, 0.1);
  width: 220px;
  height: auto;
}
.page-wrapper .page-header .header-wrapper .flip-card .flip-card-inner .back button {
  background-color: transparent;
  color: #7366ff;
  border: none;
}
.page-wrapper .page-header .header-wrapper .flip-card .flip-card-inner .back button:focus {
  outline: transparent;
}
.page-wrapper .page-header .header-wrapper .flip-card .flip-card-inner .back {
  background-color: #fff;
  transform: rotateY(180deg);
}
.page-wrapper .page-header .header-wrapper .flip-card .flip-card-inner .back li:first-child {
  height: 160px !important;
  margin-top: 0 !important;
}
.page-wrapper .page-header .header-wrapper .flip-card .flip-card-inner .back li:last-child {
  padding: 20px 0;
  border-top: 1px solid var(--chart-border);
}
.page-wrapper .page-header .header-wrapper .flip-card .flip-card-inner .back button {
  width: 100%;
}
.page-wrapper .page-header .header-wrapper .flip-card .flip-card-inner .back .flip-back-content .Typeahead-menu {
  max-height: 85px;
}
.page-wrapper .page-header .header-wrapper .flip-card .flip-card-inner .back .flip-back-content input {
  border-radius: 8px;
  padding: 6px 12px;
  width: 100%;
  border: 1px solid var(--chart-border);
}
.page-wrapper .page-header .header-wrapper .flip-card .flip-card-inner .back .flip-back-content input:focus {
  outline: unset;
}
.page-wrapper .page-header .header-wrapper .flip-card .flip-card-inner.flipped {
  transform: rotateY(180deg);
}
.page-wrapper .page-header .header-wrapper .flip-card .flip-card-inner.flipped .front {
  opacity: 0;
}

.default-datepicker .rdp {
  margin: 0;
}
.default-datepicker .rdp-caption_label {
  padding: 0;
}
.default-datepicker .rdp-nav_button {
  padding: 0;
  background: transparent !important;
  width: unset;
  height: unset;
}
.default-datepicker .rdp-nav_button svg {
  width: 11px;
  height: 11px;
}
.default-datepicker .rdp-caption_label {
  color: #2b2b2b;
  font-size: 20px;
  font-weight: 500;
}
.default-datepicker .rdp-head_cell span {
  color: #2b2b2b;
  font-size: 14px;
  font-weight: bold;
}

/**=====================
      90. React-Plugin CSS Ends
==========================**/
.product-table.table-bordernone .rdt_Table {
  border: 1px solid var(--chart-border);
}
.product-table.table-bordernone .rdt_Table .rdt_TableHead .rdt_TableHeadRow {
  border: none;
}
.product-table.table-bordernone .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol {
  border: none;
}
.product-table.table-bordernone .rdt_Table .rdt_TableBody .rdt_TableRow {
  border: none;
}
.product-table.orderHistoryTable .order-process {
  color: #242934;
  font-weight: 400;
}
.product-table.orderHistoryTable .rdt_TableBody .rdt_TableCell div {
  color: var(--body-font-color);
  font-weight: 400;
  font-size: 14px;
}
.product-table .gKbhqU {
  border: none;
}
.product-table .rdt_Table {
  border: 1px solid var(--chart-border);
}
.product-table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol {
  border: none;
}
.product-table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol h6, .product-table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol .h6 {
  margin: 0;
}
.product-table .rdt_TableHeadRow .rdt_TableCol {
  vertical-align: middle;
  border-top: none;
  border: 1px solid var(--chart-border);
  font-size: 16px;
  font-weight: 600;
}
.product-table .rdt_TableHeadRow .rdt_TableCol,
.product-table .rdt_TableBody .rdt_TableRow .rdt_TableCell {
  padding: 0.75rem;
}
.product-table .rdt_TableBody .rdt_TableRow:nth-child(odd) {
  background-color: rgb(246, 246, 246);
  border-color: var(--chart-border);
}
.product-table .rdt_TableBody .rdt_TableRow:nth-child(even) {
  background-color: #fff;
  border-color: var(--chart-border);
}
.product-table .rdt_TableBody .rdt_TableRow:hover {
  background-color: rgb(246, 246, 246);
}
.product-table .rdt_TableBody .rdt_TableRow .rdt_TableCell {
  vertical-align: middle;
  color: #999999;
  font-weight: 600;
}
.product-table .rdt_TableBody .rdt_TableRow .rdt_TableCell .product-name a {
  font-size: 15px;
  color: #898989;
  line-height: 25px;
}
.product-table .rdt_TableBody .rdt_TableRow .rdt_TableCell .product-name .order-process {
  font-size: 13px;
  padding-left: 15px;
}
.product-table .rdt_TableBody .rdt_TableRow .rdt_TableCell .product-name .order-process .order-process-circle {
  position: relative;
}
.product-table .rdt_TableBody .rdt_TableRow .rdt_TableCell .product-name .order-process .order-process-circle:before {
  position: absolute;
  content: "";
  width: 4px;
  height: 4px;
  border-radius: 100%;
  background-color: #898989;
  left: -15px;
  top: 6px;
}
.product-table .rdt_TableBody .rdt_TableRow .rdt_TableCell .product-name .order-process .order-process-circle.shipped-order:before {
  background-color: #54ba4a;
}
.product-table .rdt_TableBody .rdt_TableRow .rdt_TableCell .product-name .order-process .order-process-circle.cancel-order:before {
  background-color: #fc4438;
}
.product-table .rdt_TableBody .rdt_TableRow .rdt_TableCell.total-amount {
  color: #2f2f3b;
}
.product-table .product-name h6, .product-table .product-name .h6 {
  color: #2f2f3b;
  margin-bottom: unset;
  font-size: 14px;
}
.product-table .product-name span {
  color: #2f2f3b;
}

.email-compose .cke_chrome {
  border: none;
}
.email-compose .cke_top {
  border: none;
  padding-left: 0;
  padding-right: 0;
  background-color: transparent;
}
.email-compose .cke_bottom {
  display: none;
}

.theme-text {
  color: var(--body-font-color);
}

.focuse-none:focus {
  border: none;
  box-shadow: none;
  outline: unset;
}

.input-group-text-none .input-group-text {
  display: none;
}

.img-40 {
  width: 40px;
  height: 40px;
}

.deni-react-treeview-container.classic {
  width: 100%;
}
.deni-react-treeview-container.classic .deni-react-treeview-item-container.classic .treeview-item-example {
  display: flex;
}
.deni-react-treeview-container.classic .deni-react-treeview-item-container.classic .actionButton {
  margin-left: 6px;
}

body.dark-only .gYaFyO {
  border-bottom: var(--chart-border);
}
body.dark-only .gYaFyO:hover {
  border-color: var(--chart-border);
}
body.dark-only .qty-box .input-group-prepend {
  padding: 0;
}

.datetime-picker .input-group {
  flex-wrap: unset;
}
.datetime-picker .react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {
  right: 96px;
}

.react-datepicker__day--keyboard-selected,
.react-datepicker__month-text--keyboard-selected,
.react-datepicker__quarter-text--keyboard-selected,
.react-datepicker__year-text--keyboard-selected {
  background-color: #7366ff;
}

.react-datepicker__day--selected,
.react-datepicker__day--in-selecting-range,
.react-datepicker__day--in-range,
.react-datepicker__month-text--selected,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--selected,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--selected,
.react-datepicker__year-text--in-selecting-range,
.react-datepicker__year-text--in-range {
  background-color: #7366ff;
}

.react-datepicker__day--selected:hover,
.react-datepicker__day--in-selecting-range:hover,
.react-datepicker__day--in-range:hover,
.react-datepicker__month-text--selected:hover,
.react-datepicker__month-text--in-selecting-range:hover,
.react-datepicker__month-text--in-range:hover,
.react-datepicker__quarter-text--selected:hover,
.react-datepicker__quarter-text--in-selecting-range:hover,
.react-datepicker__quarter-text--in-range:hover,
.react-datepicker__year-text--selected:hover,
.react-datepicker__year-text--in-selecting-range:hover,
.react-datepicker__year-text--in-range:hover {
  background-color: #7366ff;
}

.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range),
.react-datepicker__month-text--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range),
.react-datepicker__quarter-text--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range),
.react-datepicker__year-text--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range) {
  background-color: rgba(115, 102, 255, 0.2);
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {
  background-color: #7366ff;
}

.react-datepicker__close-icon::after {
  background-color: #7366ff;
}

.date-range-picker .daterange-card {
  padding-bottom: 10px;
}
.date-range-picker .react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {
  right: 96px;
}

.date-picker .cal-date-widget .react-datepicker {
  border: none;
  padding: 8px 16px 0;
  width: 100%;
}
.date-picker .cal-date-widget .react-datepicker__navigation {
  top: 20px;
}
.date-picker .cal-date-widget .react-datepicker__day--keyboard-selected {
  background-color: #7366ff;
}
.date-picker .cal-date-widget .react-datepicker__navigation-icon::before {
  border-width: 2px 2px 0 0;
  width: 8px;
  height: 8px;
}
.date-picker .cal-date-widget .react-datepicker__day-name,
.date-picker .cal-date-widget .react-datepicker__day,
.date-picker .cal-date-widget .react-datepicker__time-name {
  height: 32px;
}
.date-picker .cal-date-widget .react-datepicker__day--outside-month {
  color: #cccccc;
}
.date-picker .cal-date-widget .react-datepicker__day:hover,
.date-picker .cal-date-widget .react-datepicker__month-text:hover,
.date-picker .cal-date-widget .react-datepicker__quarter-text:hover,
.date-picker .cal-date-widget .react-datepicker__year-text:hover {
  background-color: #7366ff;
  color: #fff;
}

.react-datepicker {
  border: 1px solid #efefef;
}

.react-datepicker__header {
  background-color: #fff;
  border: none;
}

.react-datepicker__navigation {
  background-color: #7366ff;
  border-radius: 20px;
  color: #fff;
  top: 13px;
}
.react-datepicker__navigation.react-datepicker__navigation--previous {
  left: 4px;
}
.react-datepicker__navigation.react-datepicker__navigation--next {
  right: 4px;
}

.react-datepicker__day--selected {
  background-color: #7366ff;
  border-radius: 10px;
}
.react-datepicker__day--selected:hover {
  background-color: #7366ff;
}

.react-datepicker__navigation-icon--next {
  left: -3px;
}

.react-datepicker__navigation-icon {
  top: 0px;
}

.react-datepicker__current-month,
.react-datepicker-time__header,
.react-datepicker-year-header {
  color: #7366ff;
  padding: 10px 10px 20px;
}

.react-datepicker__navigation-icon--previous {
  right: 0;
}

.react-datepicker__day-name {
  font-weight: bold;
}

.react-datepicker__week,
.react-datepicker__day {
  display: flex;
  justify-content: center;
  align-items: center;
}

.react-datepicker__navigation-icon--next::before,
.react-datepicker__navigation-icon--previous::before {
  top: 10px;
  left: -3px;
  border-color: #fff;
}

.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,
.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {
  margin-left: -10px;
}

.support-table .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(4) .rdt_TableCol_Sortable {
  justify-content: flex-start;
}
.support-table .rdt_Table .rdt_TableBody .rdt_TableRow {
  border-color: var(--chart-border);
}
.support-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4) {
  justify-content: start !important;
}

.loader-wrapper.loderhide {
  display: none;
}

/* Slider test*/
.slick-slider {
  position: relative;
  display: block;
  box-sizing: border-box;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
  touch-action: pan-y;
  -webkit-tap-highlight-color: transparent;
}

.slick-list {
  position: relative;
  overflow: hidden;
  display: block;
  margin: 0;
  padding: 0;
}
.slick-list:focus {
  outline: none;
}
.slick-list.dragging {
  cursor: pointer;
  cursor: hand;
}

.slick-slider .slick-track,
.slick-slider .slick-list {
  transform: translate3d(0, 0, 0);
}

.slick-track {
  position: relative;
  left: 0;
  top: 0;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.slick-track:before, .slick-track:after {
  content: "";
  display: table;
}
.slick-track:after {
  clear: both;
}
.slick-loading .slick-track {
  visibility: hidden;
}

.slick-slide {
  float: left;
  height: 100%;
  min-height: 1px;
}
[dir=rtl] .slick-slide {
  float: right;
}
.slick-slide img {
  display: block;
}
.slick-slide.slick-loading img {
  display: none;
}
.slick-slide {
  display: none;
}
.slick-slide.dragging img {
  pointer-events: none;
}
.slick-initialized .slick-slide {
  display: block;
}
.slick-loading .slick-slide {
  visibility: hidden;
}
.slick-vertical .slick-slide {
  display: block;
  height: auto;
  border: 1px solid transparent;
}

.slick-arrow.slick-hidden {
  display: none;
}

/* Icons */
@font-face {
  font-family: "slick";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
/* Arrows */
.slick-prev,
.slick-next {
  position: absolute;
  display: block;
  height: 20px;
  width: 20px;
  line-height: 0px;
  font-size: 0px;
  cursor: pointer;
  background: transparent;
  color: transparent;
  top: 50%;
  transform: translate(0, -50%);
  padding: 0;
  border: none;
  outline: none;
}
.slick-prev:hover, .slick-prev:focus,
.slick-next:hover,
.slick-next:focus {
  outline: none;
  background: transparent;
  color: transparent;
}
.slick-prev:hover:before, .slick-prev:focus:before,
.slick-next:hover:before,
.slick-next:focus:before {
  opacity: 1;
}
.slick-prev.slick-disabled:before,
.slick-next.slick-disabled:before {
  opacity: 0.25;
}
.slick-prev:before,
.slick-next:before {
  font-family: "slick";
  font-size: 20px;
  line-height: 1;
  color: white;
  opacity: 0.75;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.slick-prev {
  left: -25px;
}
[dir=rtl] .slick-prev {
  left: auto;
  right: -25px;
}
.slick-prev:before {
  content: "←";
}
[dir=rtl] .slick-prev:before {
  content: "→";
}

.slick-next {
  right: -25px;
}
[dir=rtl] .slick-next {
  left: -25px;
  right: auto;
}
.slick-next:before {
  content: "→";
}
[dir=rtl] .slick-next:before {
  content: "←";
}

/* Dots */
.slick-dotted.slick-slider {
  margin-bottom: 30px;
}

.slick-dots {
  position: absolute;
  bottom: -25px;
  list-style: none;
  display: block;
  text-align: center;
  padding: 0;
  margin: 0;
  width: 100%;
}
.slick-dots li {
  position: relative;
  display: inline-block;
  height: 20px;
  width: 20px;
  margin: 0 5px;
  padding: 0;
  cursor: pointer;
}
.slick-dots li button {
  border: 0;
  background: transparent;
  display: block;
  height: 20px;
  width: 20px;
  outline: none;
  line-height: 0px;
  font-size: 0px;
  color: transparent;
  padding: 5px;
  cursor: pointer;
}
.slick-dots li button:hover, .slick-dots li button:focus {
  outline: none;
}
.slick-dots li button:hover:before, .slick-dots li button:focus:before {
  opacity: 1;
}
.slick-dots li button:before {
  position: absolute;
  top: 0;
  left: 0;
  content: "•";
  width: 20px;
  height: 20px;
  font-family: "slick";
  font-size: 6px;
  line-height: 20px;
  text-align: center;
  color: black;
  opacity: 0.25;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.slick-dots li.slick-active button:before {
  color: black;
  opacity: 0.75;
}

/*=============Scrollable css start=============*/
.ps-container.ps-active-y > .ps-scrollbar-y-rail, .ps-container.ps-active-x > .ps-scrollbar-x-rail {
  background-color: transparent;
  display: block;
}

.scroll-demo {
  padding: 10px;
  position: relative;
  border: 1px solid #f4f4f4;
  overflow: auto;
  height: 300px;
}
.scroll-demo .horz-scroll-content {
  width: 1600px;
}

.ps-container {
  touch-action: none;
  overflow: hidden !important;
}
.ps-container.ps-in-scrolling {
  pointer-events: none;
}
.ps-container.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail {
  background-color: #f4f4f4;
  opacity: 0.9;
}
.ps-container.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail > .ps-scrollbar-x {
  background-color: #59667a;
}
.ps-container.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail {
  background-color: #f4f4f4;
  opacity: 0.9;
}
.ps-container.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail > .ps-scrollbar-y {
  background-color: #59667a;
}
.ps-container > .ps-scrollbar-x-rail {
  display: none;
  position: absolute;
  border-radius: 4px;
  opacity: 0;
  transition: background-color 0.2s linear, opacity 0.2s linear;
  bottom: 3px;
  height: 8px;
}
.ps-container > .ps-scrollbar-x-rail > .ps-scrollbar-x {
  position: absolute;
  background-color: #59667a;
  border-radius: 4px;
  transition: background-color 0.2s linear;
  bottom: 0;
  height: 8px;
}
.ps-container > .ps-scrollbar-y-rail {
  right: 3px;
  width: 8px;
  display: none;
  position: absolute;
  border-radius: 4px;
  opacity: 0;
  transition: background-color 0.2s linear, opacity 0.2s linear;
}
.ps-container > .ps-scrollbar-y-rail > .ps-scrollbar-y {
  width: 10px;
  position: absolute;
  background-color: #59667a;
  border-radius: 4px;
  transition: background-color 0.2s linear;
  right: 0;
}
.ps-container:hover.ps-in-scrolling {
  pointer-events: none;
}
.ps-container:hover.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail {
  background-color: #59667a;
  opacity: 0.9;
}
.ps-container:hover.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail > .ps-scrollbar-x {
  width: 128px;
  background-color: #999999;
}
.ps-container:hover.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail {
  background-color: #59667a;
  opacity: 0.9;
}
.ps-container:hover.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail > .ps-scrollbar-y {
  background-color: #999999;
}
.ps-container:hover > .ps-scrollbar-x-rail {
  opacity: 0.6;
}
.ps-container:hover > .ps-scrollbar-x-rail:hover {
  background-color: #f4f4f4;
  opacity: 0.9;
}
.ps-container:hover > .ps-scrollbar-x-rail:hover > .ps-scrollbar-x {
  background-color: #999999;
}
.ps-container:hover > .ps-scrollbar-y-rail {
  opacity: 0.6;
}
.ps-container:hover > .ps-scrollbar-y-rail:hover {
  background-color: #f4f4f4;
  opacity: 0.9;
}
.ps-container:hover > .ps-scrollbar-y-rail:hover > .ps-scrollbar-y {
  background-color: #59667a;
}
.always-visible.ps-container > .ps-scrollbar-x-rail {
  opacity: 0.6;
}
.always-visible.ps-container > .ps-scrollbar-y-rail {
  opacity: 0.6;
}

.large-margin.ps-container > .ps-scrollbar-x-rail {
  margin: 0 25%;
}
.large-margin.ps-container > .ps-scrollbar-y-rail {
  margin: 100px 0;
}

/*=============Scrollable css end=============*/
/**=====================
    46. Blog CSS start
==========================**/
.blog-box img {
  border-radius: 0.25rem;
}
.blog-box .top-radius-blog {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.blog-box h6, .blog-box .h6 {
  font-weight: 600;
  margin: 15px 0;
}
.blog-box .blog-details {
  padding-right: 20px;
}
.blog-box .blog-details .blog-social {
  margin-top: 30px;
}
.blog-box .blog-details .blog-social li {
  display: inline-block;
  font-size: 12px;
  color: #52526c;
}
.blog-box .blog-details .blog-social li + li {
  padding-left: 20px;
  padding-right: 0;
}
.blog-box .blog-details .blog-social li i {
  padding-right: 5px;
  font-weight: 300;
}
.blog-box .blog-details .blog-social li:first-child {
  border-right: 1px solid gray;
  padding-right: 20px;
}
.blog-box .blog-details-main hr {
  background-color: #cccccc;
}
.blog-box .blog-details-main .blog-social {
  margin: 20px 0;
}
.blog-box .blog-details-main .blog-social li {
  display: inline-block;
  font-size: 12px;
  color: #52526c;
  padding: 0 24px;
  border-right: 1px dotted;
}
@media (max-width: 1676px) {
  .blog-box .blog-details-main .blog-social li {
    padding: 0 10px;
  }
}
.blog-box .blog-details-main .blog-social li:last-child {
  border-right: 0;
}
.blog-box .blog-details-main .blog-social li i {
  padding-right: 5px;
}
.blog-box .blog-details-main .blog-bottom-details {
  margin: 20px;
  font-size: 14px;
  line-height: 1.714;
  font-weight: 500;
}
.blog-box .blog-date {
  color: #52526c;
}
.blog-box .blog-date span {
  font-size: 36px;
  font-weight: 500;
  padding-right: 5px;
}

.blog-box.blog-shadow:before {
  box-shadow: inset 0px -200px 100px -13px rgba(0, 0, 0, 0.6);
  transition: all 0.3s ease;
  border-radius: 5px;
  content: "";
  position: absolute;
  height: 100%;
  top: 0;
  width: 100%;
  bottom: 0;
}
.blog-box.blog-shadow:hover:before {
  box-shadow: inset 0px -200px 100px -13px rgba(0, 0, 0, 0.65);
  transition: all 0.3s ease;
}
.blog-box.blog-shadow .blog-details {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 20px;
}
.blog-box.blog-shadow .blog-details h4, .blog-box.blog-shadow .blog-details .h4 {
  color: #fff;
  margin-bottom: 0;
}
.blog-box.blog-shadow .blog-details p {
  font-size: 14px;
  color: #fff;
  margin-bottom: 10px;
}
.blog-box.blog-shadow .blog-details .blog-social li {
  color: #fff;
}

.blog-list .blog-details .blog-social {
  margin-top: 0;
}
.blog-list .blog-details h6, .blog-list .blog-details .h6 {
  margin-top: 0;
  color: gray;
  font-weight: 500;
}
.blog-list .blog-details hr {
  margin-top: 10px;
  margin-bottom: 10px;
}
.blog-list img {
  padding: 17px;
}

.blog-grid img {
  width: 100%;
}
.blog-grid .blog-details {
  padding: 20px;
}
.blog-grid .blog-details h6, .blog-grid .blog-details .h6 {
  font-size: 14px;
  margin-bottom: 0;
  line-height: 1.8;
}

.blog-box {
  position: relative;
  max-height: 100%;
  align-items: center;
}
.blog-box .blog-details h6, .blog-box .blog-details .h6 {
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.blog-box .blog-details p {
  font-size: 14px;
  line-height: 1.8;
  letter-spacing: 0.7px;
  margin-top: 30px;
  margin-bottom: 0;
  color: #52526c;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 3;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
@media (max-width: 1570px) {
  .blog-box .blog-details p {
    -webkit-line-clamp: 2;
  }
}
.blog-box .blog-details h4, .blog-box .blog-details .h4 {
  font-size: 18px;
  font-weight: 500;
  line-height: 1.5;
  margin-top: 20px;
  margin-bottom: 0;
}
.blog-box .blog-details .single-blog-content-top {
  margin-top: 20px;
  border-top: 1px solid #efefef;
}
.blog-box .blog-details .blog-social li,
.blog-box .blog-details .comment-social li {
  font-size: 14px;
}

.comment-box {
  padding-top: 50px;
  padding-bottom: 50px;
}
.comment-box hr {
  margin-top: 20px;
  margin-bottom: 30px;
}
.comment-box li {
  margin-bottom: 30px;
}
.comment-box li:last-child {
  margin-bottom: 0;
}
.comment-box ul ul {
  margin-left: 135px;
}
.comment-box p {
  font-size: 14px;
  line-height: 2;
  color: #52526c;
  text-align: justify;
  margin-bottom: 0;
}
.comment-box h4, .comment-box .h4 {
  font-weight: 600;
}
.comment-box .media img {
  margin-right: 30px;
  border-radius: 10px;
  height: 90px;
  padding: 7px;
  width: 90px;
  border: 1px solid #efefef;
}
.comment-box .media h6, .comment-box .media .h6 {
  font-weight: 500;
  margin-bottom: 5px;
}
.comment-box .media h6 span, .comment-box .media .h6 span {
  padding-left: 10px;
  font-size: 13px;
  color: #52526c;
  font-weight: 400;
}
.comment-box .comment-social li {
  display: inline-block;
  color: #cccccc;
  padding-left: 20px;
  margin-bottom: 0;
  text-transform: uppercase;
}
.comment-box .comment-social li:first-child {
  border-right: 1px solid #efefef;
  padding-right: 20px;
}
.comment-box .comment-social li i {
  padding-right: 10px;
}

.add-post .cke_top, .add-post .cke_bottom {
  background-color: transparent;
}

/**=====================
    46. Blog CSS ends
==========================**/
/**=====================
     85. bookmark app CSS Start
==========================**/
.modal-dialog.modal-bookmark .modal-body,
.modal-dialog.modal-bookmark .modal-header {
  padding: 25px;
}
.modal-dialog.modal-bookmark .modal-header {
  border-bottom: 1px solid #dee2e6 !important;
}
.modal-dialog.modal-bookmark .modal-header .btn-close {
  position: relative;
  top: 0;
  right: 0;
  margin-left: auto;
}

.modal-header {
  padding: 25px !important;
}

.bookmark-wrap .btn-mail {
  color: var(--theme-default) !important;
}
.bookmark-wrap .row .col-xl-3 + .col-xl-3 {
  padding-right: 15px;
}
.bookmark-wrap .left-bookmark ul li a {
  color: #2f2f3b;
}
.bookmark-wrap .left-bookmark ul li button {
  border: none;
  cursor: pointer;
}
.bookmark-wrap .left-bookmark ul li button:focus {
  outline: none;
}
.bookmark-wrap .left-bookmark ul li svg {
  width: 18px;
  height: 18px;
  vertical-align: sub;
}
.bookmark-wrap .left-bookmark ul li > .main-title {
  color: var(--theme-default);
  font-weight: 600;
  margin-bottom: 5px;
  display: block;
}
.bookmark-wrap .left-bookmark ul li > .main-title span a:hover {
  background-color: transparent;
}
.bookmark-wrap .left-bookmark ul li > .main-title svg {
  color: #898989;
  stroke-width: 1px;
}
.bookmark-wrap .left-bookmark ul li a > .title {
  text-transform: capitalize;
}

.email-wrap .email-right-aside .email-body.radius-left.card {
  border-radius: 0 15px 15px 0;
}
.email-wrap .email-right-aside .email-body.card {
  border-radius: 15px 0 0 15px;
}

.form-bookmark .form-row {
  display: flex;
  flex-wrap: wrap;
}
.form-bookmark .form-row .fill-color {
  width: 35px;
  height: 30px;
  padding: 3px;
}
.form-bookmark a {
  text-transform: capitalize !important;
  color: var(--theme-default) !important;
  line-height: 1 !important;
  font-weight: 500;
}
.form-bookmark a:hover {
  background-color: transparent !important;
}
.form-bookmark input#index_var {
  display: none;
}
.form-bookmark .form-group input,
.form-bookmark .form-group select {
  font-size: 14px;
}
.form-bookmark .form-group .select2-container .select2-selection--single {
  border-color: #ced4da !important;
}
.form-bookmark .form-group .select2 {
  width: 100% !important;
}
.form-bookmark .form-group .error {
  margin: 0 !important;
  font-size: 11px;
  color: red !important;
}

.email-wrap.bookmark-wrap .email-body.radius-left.card {
  border-radius: 15px;
}

.modal .bookmark-modal.modal-header {
  padding: 22px;
}

.contact-profile {
  margin: 0 auto;
  position: relative;
  display: flex;
  justify-content: center;
  width: fit-content;
}
.contact-profile .img-100 {
  height: 100px !important;
}
.contact-profile .upload {
  position: absolute;
  top: 0;
  opacity: 0;
}
.contact-profile .icon-wrapper {
  text-align: right;
  position: absolute;
  right: 0;
  bottom: 0;
  width: 35px;
  height: 35px;
  background: #fff;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

@keyframes displayTransition {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.bookmark-tabcontent .details-bookmark {
  height: auto;
  min-height: 359px;
}
.bookmark-tabcontent .details-bookmark .bookmark-card {
  position: relative;
  height: 91%;
}
.bookmark-tabcontent .details-bookmark .bookmark-card.card .favourite-icon {
  padding: 3px;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.2);
  width: 30px;
  position: absolute;
  right: 15px;
  top: 15px;
  opacity: 0;
  text-align: center;
}
.bookmark-tabcontent .details-bookmark .bookmark-card.card .favourite-icon i {
  color: #fff;
  font-size: 16px;
  vertical-align: text-bottom;
}
.bookmark-tabcontent .details-bookmark .bookmark-card.card .favourite-icon.favourite i {
  color: #fed112;
}
.bookmark-tabcontent .details-bookmark .bookmark-card.card .desciption-data {
  width: 100%;
}
.bookmark-tabcontent .details-bookmark .bookmark-card.card .desciption-data .content-general {
  display: none;
}
.bookmark-tabcontent .details-bookmark .bookmark-card.card .favourite-icon {
  transition: 0.5s;
}
.bookmark-tabcontent .details-bookmark .bookmark-card.card .title-bookmark {
  text-align: left;
  padding: 15px;
  border-top: 1px solid #f4f4f4;
}
.bookmark-tabcontent .details-bookmark .bookmark-card.card .title-bookmark p {
  margin-bottom: 10px;
  animation: displayTransition 1s;
}
.bookmark-tabcontent .details-bookmark .bookmark-card.card .title-bookmark .hover-block {
  display: none;
  margin-top: 15px;
}
.bookmark-tabcontent .details-bookmark .bookmark-card.card .title-bookmark .hover-block ul li {
  display: inline-block;
}
.bookmark-tabcontent .details-bookmark .bookmark-card.card .title-bookmark .hover-block ul li + li {
  margin-left: 5px;
}
.bookmark-tabcontent .details-bookmark .bookmark-card.card .title-bookmark .hover-block ul li i {
  width: 16px;
  height: 16px;
  color: #898989;
}
.bookmark-tabcontent .details-bookmark .bookmark-card.card:hover {
  box-shadow: 1px 4px 16px 3px rgba(0, 0, 0, 0.04);
  transition: 0.5s;
}
.bookmark-tabcontent .details-bookmark .bookmark-card.card:hover .title-bookmark p {
  display: none;
}
.bookmark-tabcontent .details-bookmark .bookmark-card.card:hover .title-bookmark .hover-block {
  display: block;
  animation: displayTransition 2s;
}
.bookmark-tabcontent .details-bookmark .bookmark-card.card:hover .favourite-icon {
  opacity: 1;
}
.bookmark-tabcontent .details-bookmark.list-bookmark .row .col-xl-3 {
  flex: 0 0 100%;
  max-width: 100%;
}
.bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card {
  height: unset;
}
.bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card .desciption-data .content-general {
  display: block;
}
.bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card .details-website {
  display: flex;
  align-items: center;
}
.bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card .details-website .title-bookmark p {
  display: block;
}
.bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card .details-website .title-bookmark .hover-block {
  position: absolute;
  right: 30px;
  display: block;
  text-align: right;
}
.bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card .details-website:hover .title-bookmark .hover-block {
  display: block;
  animation: displayTransition 0s;
}
.bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card.card .title-bookmark {
  border-top: none;
}
.bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card.card .title-bookmark p,
.bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card.card .title-bookmark h6,
.bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card.card .title-bookmark .h6 {
  margin-top: 0;
  display: inline-block;
}
.bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card.card .title-bookmark h6, .bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card.card .title-bookmark .h6 {
  position: relative;
  padding-right: 15px;
}
.bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card.card .title-bookmark h6::after, .bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card.card .title-bookmark .h6::after {
  position: absolute;
  content: "-";
  right: 0;
  color: #898989;
}
.bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card.card .title-bookmark .content-general {
  margin-top: 5px;
}
.bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card.card .title-bookmark .content-general p {
  width: 68%;
  margin-right: 20px;
}
.bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card img {
  width: 20%;
}
.bookmark-tabcontent .tab-content .card .d-flex {
  justify-content: space-between;
}
.bookmark-tabcontent .tab-content .card .d-flex svg {
  width: 18px;
  height: 18px;
  vertical-align: middle;
}
.bookmark-tabcontent .tab-content .card .d-flex ul li {
  display: inline-block;
}
.bookmark-tabcontent .tab-content .card .d-flex ul li + li {
  margin-left: 10px;
}

@media (max-width: 1660px) {
  .bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card.card .title-bookmark {
    padding-left: 5px;
  }
  .bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card.card .title-bookmark .content-general p {
    display: none;
  }
  .bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card.card .title-bookmark .hover-block {
    margin-top: 6px;
  }
}
@media screen and (min-width: 1200px) and (max-width: 1366px) {
  .bookmark-wrap .left-bookmark ul li .btn-mail svg {
    display: none;
  }
}
@media (max-width: 1366px) {
  .bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card img {
    width: 40%;
  }
}
@media (max-width: 1199px) {
  .bookmark-wrap .left-bookmark {
    height: auto;
  }
  .bookmark-tabcontent .details-bookmark {
    min-height: auto;
  }
}
@media (max-width: 991px) {
  .bookmark-tabcontent .details-bookmark .bookmark-card {
    height: 93%;
  }
  .bookmark-tabcontent .details-bookmark .bookmark-card.card .title-bookmark p {
    margin-bottom: 0;
  }
  .modal-bookmark .modal-body,
  .modal-bookmark .modal-header {
    padding: 20px;
  }
  .form-bookmark button {
    margin-top: 20px;
  }
}
@media (max-width: 767px) {
  .form-bookmark .row .form-group:last-child {
    margin-top: 15px;
  }
  .bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card .details-website .title-bookmark p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 172px;
  }
  .bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card .details-website:hover .title-bookmark .hover-block p {
    display: none;
  }
  .bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card .details-website:hover .title-bookmark .hover-block ul {
    position: relative;
    right: unset;
    top: unset;
  }
  .bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card img {
    width: 55%;
  }
}
@media (max-width: 575px) {
  .bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card.card .title-bookmark h6, .bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card.card .title-bookmark .h6 {
    display: block;
  }
  .bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card img {
    width: 100%;
  }
  .bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card .details-website {
    display: block;
  }
  .bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card .details-website .title-bookmark .hover-block {
    position: relative;
    right: unset;
    text-align: left;
  }
  .modal-bookmark .modal-body,
  .modal-bookmark .modal-header {
    padding: 15px;
  }
  .form-bookmark button {
    margin-top: 15px;
  }
}
/**=====================
   85. bookmark app CSS Ends
==========================**/
/**=====================
    82. cart CSS start
==========================**/
.cart .total-amount {
  text-align: right !important;
  margin-top: 30px;
  min-width: 140px;
}
.cart .total-amount + td {
  min-width: 160px;
}
.cart .amount-space {
  margin-left: 40px;
}
.cart .cart-btn-transform {
  text-transform: capitalize;
}
.cart .qty-box {
  width: 25%;
  margin: 0 auto;
}
.cart .qty-box .input-group .btn {
  background-color: transparent !important;
  border-color: #ddd !important;
  padding: 8px 12px;
}

.cart-buttons {
  margin-top: 30px;
}
.cart-buttons .cart-btn {
  float: right;
  padding-right: 85px;
}

/**=====================
    82. cart CSS Ends
==========================**/
/**=====================
    41. Chart CSS Start
==========================**/
.radial-bar.radial-bar-lg > img, .radial-bar.radial-bar-lg:after {
  width: 70px;
  height: 70px;
  margin-left: 15px;
  margin-top: 15px;
  line-height: 70px;
}

.radial-bar.radial-bar-sm > img, .radial-bar.radial-bar-sm:after {
  width: 35px;
  height: 35px;
  margin-left: 7.5px;
  margin-top: 7.5px;
  line-height: 35px;
}

.radial-bar.radial-bar-xs > img, .radial-bar.radial-bar-xs:after {
  width: 20px;
  height: 20px;
  margin-left: 5.5px;
  margin-top: 4.5px;
  line-height: 21px;
}

.chart-block canvas {
  width: 100% !important;
}
.chart-block .chart-overflow {
  overflow: hidden;
  text-align: center;
}

.candidcahrt {
  width: 100%;
  height: 470px;
}

.amcharts-export-canvas {
  position: absolute;
  display: none;
  z-index: 1;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: #fff;
}
.amcharts-export-canvas .canvas-container {
  transition: opacity 0.5s ease-out;
}
.amcharts-export-canvas.active {
  display: block;
}
.amcharts-export-canvas.dropbox .canvas-container {
  opacity: 0.5;
}

.flot-chart-container {
  box-sizing: border-box;
  width: 100%;
  height: 400px;
}
.flot-chart-container #toggling-series-flot {
  width: 79% !important;
}

.all-chart .flot-chart-container {
  height: 350px;
}

.flot-chart-placeholder {
  width: 100%;
  height: 100%;
  font-size: 14px;
  line-height: 1.2em;
  text-align: center;
}
.flot-chart-placeholder .legend table {
  border-spacing: 5px;
}

.morris-hover {
  position: absolute;
  z-index: 1;
}
.morris-hover.morris-default-style {
  border-radius: 10px;
  padding: 6px;
  color: #898989;
  background: #fff;
  border: solid 1px #ecf3fa;
  font-family: sans-serif;
  font-size: 12px;
  text-align: center;
}
.morris-hover.morris-default-style .morris-hover-row-label {
  font-weight: bold;
  margin: 0.25em 0;
}
.morris-hover.morris-default-style .morris-hover-point {
  white-space: nowrap;
  margin: 0.1em 0;
}

.chart-sparkline {
  position: absolute;
  left: 0;
  top: 0;
  visibility: hidden;
  background: rgba(49, 49, 49, 0.7);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=#99000000, endColorstr=#99000000);
  color: #fff;
  font: 10px Rubik, sans-serif;
  text-align: left;
  white-space: nowrap;
  padding: 5px;
  border: 1px solid rgba(49, 49, 49, 0.75);
  box-sizing: content-box;
  z-index: 10000;
  border-radius: 5px;
}
.chart-sparkline .jqsfield {
  color: #fff;
  font: 10px Rubik, sans-serif;
  text-align: left;
}

.radial-bar {
  position: relative;
  display: inline-block;
  border-radius: 50%;
  background-color: transparent;
  box-sizing: content-box;
  width: 80px;
  height: 80px;
  font-size: 18px;
  background-clip: content-box;
}
.radial-bar:after {
  display: inline-block;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 50%;
  text-align: center;
  font-weight: 500;
  color: #455a64;
  content: attr(data-label);
  background-color: #fff;
  z-index: 1;
  width: 56px;
  height: 56px;
  margin-left: 12px;
  margin-top: 12px;
  line-height: 56px;
}
.radial-bar > img {
  display: inline-block;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 50%;
  text-align: center;
  font-weight: 500;
  color: #455a64;
  z-index: 3;
  width: 56px;
  height: 56px;
  margin-left: 12px;
  margin-top: 12px;
  line-height: 56px;
}

.radial-bar-danger.radial-bar-20 {
  background-image: linear-gradient(90deg, #efefef 50%, transparent 50%, transparent), linear-gradient(162deg, #fc4438 50%, #efefef 50%, #efefef);
}

.radial-bar.radial-bar-lg {
  width: 100px;
  height: 100px;
  font-size: 20px;
}
.radial-bar.radial-bar-sm {
  width: 50px;
  height: 50px;
  font-size: 12px;
}
.radial-bar.radial-bar-xs {
  width: 30px;
  height: 30px;
  font-size: 8px;
}
.pieLabel div {
  color: #fff !important;
}
.pieLabel div input[type=checkbox] {
  margin: 7px;
}

.knob-chart {
  min-height: 255px;
}
.knob-chart .chart-clock-main {
  position: relative;
  width: 200px;
  margin: 45px auto;
}
.knob-chart .chart-clock-main .clock-large {
  position: absolute;
  left: -48px;
  top: -45px;
}
.knob-chart .chart-clock-main .clock-medium {
  position: absolute;
  left: 2px;
  top: 5px;
}
.knob-chart .chart-clock-main .clock-small {
  position: absolute;
  left: 15px;
  top: 55px;
}

.peity-charts svg {
  width: 100%;
  height: 250px;
}
.peity-charts.peity-chart-primary svg polygon {
  fill: rgba(115, 102, 255, 0.2);
}
.peity-charts.peity-chart-primary svg polyline {
  stroke: var(--theme-default);
}

.bar-odd-even svg rect:nth-child(odd) {
  fill: var(--theme-default);
}
.bar-odd-even svg rect:nth-child(even) {
  fill: var(--theme-secondary);
}

.donut-peity svg path:nth-child(odd) {
  fill: var(--theme-default);
}
.donut-peity svg path:nth-child(even) {
  fill: var(--theme-secondary);
}

.small-donut ~ svg path:nth-child(odd),
.small-donut svg path:nth-child(odd),
.donut-peity2 ~ svg path:nth-child(odd),
.donut-peity2 svg path:nth-child(odd),
.pie-peity ~ svg path:nth-child(odd),
.pie-peity svg path:nth-child(odd) {
  fill: var(--theme-default);
}
.small-donut ~ svg path:nth-child(even),
.small-donut svg path:nth-child(even),
.donut-peity2 ~ svg path:nth-child(even),
.donut-peity2 svg path:nth-child(even),
.pie-peity ~ svg path:nth-child(even),
.pie-peity svg path:nth-child(even) {
  fill: #efefef;
}

.small-donut2 ~ svg path:nth-child(odd) {
  fill: var(--theme-secondary);
}

.small-donut3 ~ svg path:nth-child(odd) {
  fill: #54ba4a;
}

.small-donut4 ~ svg path:nth-child(odd) {
  fill: #16c7f9;
}

.small-donut5 ~ svg path:nth-child(odd) {
  fill: #ffaa05;
}

.small-donut6 ~ svg path:nth-child(odd) {
  fill: #fc4438;
}

p.data-attributes svg {
  margin-right: 10px;
}

.knob-block {
  position: relative;
}
.knob-block input {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  height: 100% !important;
  width: 100% !important;
  left: 0 !important;
  top: 0 !important;
  margin-left: 0 !important;
  margin-top: -3px !important;
}

.knob-input-disable input {
  display: none !important;
}

.apex-chart {
  margin: 0 auto;
}

.apexcharts-toolbar {
  z-index: 1 !important;
}

.apexcharts-menu-item {
  width: 110px;
}

.word-tree {
  height: 400px;
}

.ct-series-a .ct-slice-pie,
.ct-series-a .ct-slice-donut-solid,
.ct-series-a .ct-area {
  fill: var(--theme-default);
}
.ct-series-a .ct-point,
.ct-series-a .ct-line,
.ct-series-a .ct-bar,
.ct-series-a .ct-slice-donut {
  stroke: var(--theme-default);
}

.ct-series-b .ct-point,
.ct-series-b .ct-line,
.ct-series-b .ct-bar,
.ct-series-b .ct-slice-donut {
  stroke: var(--theme-secondary);
}
.ct-series-b .ct-slice-pie,
.ct-series-b .ct-slice-donut-solid,
.ct-series-b .ct-area {
  fill: var(--theme-secondary);
}

.apache-cotainer {
  width: 100%;
  height: 350px;
  margin: 0;
}

.boxplot-cotainer {
  height: 420px;
}

.apache-cotainer-large {
  width: 100%;
  height: 500px;
  margin: 0;
}

.test-buttons button + button {
  margin-left: 10px;
}

.clip-chart-wrapper .test-chart-block {
  margin-bottom: -30px;
}

#echart-gauge .test-chart {
  width: 100%;
  height: 395px;
}

.polar-line {
  height: 350px;
}

#dotted {
  height: 390px;
}

.apexcharts-canvas .apexcharts-tooltip,
.apexcharts-canvas .apexcharts-xaxistooltip,
.apexcharts-canvas .apexcharts-yaxistooltip {
  z-index: 1;
}

@media (max-width: 1346px) {
  .flot-chart-container .flot-chart-placeholder ~ p.float-end {
    float: left !important;
  }
  [dir=rtl] .flot-chart-container .flot-chart-placeholder ~ p.float-end {
    float: right !important;
  }
}

/**=====================
     41. Chart CSS End
==========================**/
/**=====================
     14. Chat CSS Start
==========================**/
.chat-box .toogle-bar {
  display: none;
}
.chat-box .chat-menu {
  max-width: 340px;
}
.chat-box .people-list .search {
  position: relative;
}
.chat-box .people-list .search .form-control {
  background-color: #fafdff;
  border: 1px solid #f4f4f4;
}
.chat-box .people-list .search .form-control::placeholder {
  color: #59667a;
}
.chat-box .people-list .search i {
  position: absolute;
  right: 10px;
  top: 17px;
  font-size: 14px;
  color: #ecf3fa;
}
.chat-box .people-list ul {
  padding: 0;
}
.chat-box .people-list ul li {
  padding-bottom: 20px;
}
.chat-box .people-list ul li.active {
  background-color: transparent !important;
}
.chat-box .people-list ul li:last-child {
  padding-bottom: 0;
}
.chat-box .user-image {
  float: left;
  width: 52px;
  height: 52px;
  margin-right: 5px;
}
.chat-box .about {
  float: left;
  margin-top: 5px;
  padding-left: 10px;
}
.chat-box .about .name {
  color: #2c323f;
  letter-spacing: 1px;
  font-weight: 500;
}
.chat-box .status {
  color: #59667a;
  letter-spacing: 1px;
  font-size: 12px;
  margin-top: 5px;
}
.chat-box .status .chat-status {
  font-weight: 600;
  color: #2f2f3b;
}
.chat-box .status p {
  font-size: 14px;
}
.chat-box .chat-right-aside .chat .chat-header {
  padding: 15px;
  border-bottom: 1px solid #f4f4f4;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.chat-box .chat-right-aside .chat .chat-header img {
  float: left;
  width: 50px;
  height: 50px;
  box-shadow: 1px 1px 4px 1px #ecf3fa;
}
.chat-box .chat-right-aside .chat .chat-header .chat-menu-icons li {
  margin-right: 24px;
}
.chat-box .chat-right-aside .chat .chat-header .chat-menu-icons li a i {
  color: #52526c;
  font-size: 25px;
  cursor: pointer;
}
.chat-box .chat-right-aside .chat .chat-header .chat-menu-icons {
  margin-left: auto;
}
.chat-box .chat-right-aside .chat .chat-header .chat-menu-icons svg {
  color: #52526c;
  stroke: 1.4px;
}
[dir=rtl] .chat-box .chat-right-aside .chat .chat-header .chat-menu-icons {
  margin-right: auto;
  margin-left: unset;
}
.chat-box .chat-right-aside .chat .chat-msg-box {
  padding: 20px;
  overflow-y: auto;
  height: 560px;
  margin-bottom: 80px;
}
.chat-box .chat-right-aside .chat .chat-msg-box .chat-user-img {
  margin-top: -35px;
}
.chat-box .chat-right-aside .chat .chat-msg-box .message-data {
  margin-bottom: 10px;
}
.chat-box .chat-right-aside .chat .chat-msg-box .message-data-time {
  letter-spacing: 1px;
  font-size: 12px;
  color: #59667a;
}
.chat-box .chat-right-aside .chat .chat-msg-box .message {
  color: #2c323f;
  padding: 20px;
  line-height: 1.9;
  letter-spacing: 1px;
  font-size: 14px;
  margin-bottom: 30px;
  width: 50%;
  position: relative;
}
.chat-box .chat-right-aside .chat .chat-msg-box .my-message {
  border: 1px solid #f4f4f4;
  border-radius: 10px;
  border-top-left-radius: 0;
}
.chat-box .chat-right-aside .chat .chat-msg-box .other-message {
  background-color: #fdfeff;
  border-radius: 10px;
  border-top-right-radius: 0;
}
.chat-box .chat-right-aside .chat .chat-message {
  padding: 20px;
  border-top: 1px solid #fafdff;
  position: absolute;
  width: calc(100% - 15px);
  background-color: #fff;
  bottom: 0;
}
.chat-box .chat-right-aside .chat .chat-message .smiley-box {
  background: #efefef;
  padding: 10px;
  display: block;
  border-radius: 4px;
  margin-right: 0.5rem;
}
.chat-box .chat-right-aside .chat .chat-message .text-box {
  position: relative;
}
.chat-box .chat-right-aside .chat .chat-message .text-box .input-txt-bx {
  height: 50px;
  border: 2px solid var(--theme-default);
  padding-left: 18px;
  font-size: 12px;
  letter-spacing: 1px;
}
.chat-box .chat-right-aside .chat .chat-message .text-box i {
  position: absolute;
  right: 20px;
  top: 20px;
  font-size: 20px;
  color: #ecf3fa;
  cursor: pointer;
}
.chat-box .chat-right-aside .chat .chat-message .text-box .btn {
  font-size: 16px;
  font-weight: 500;
  padding: 0.74rem 1.75rem;
  border-radius: 0 5px 5px 0;
}
.chat-box .chat-menu {
  border-left: 1px solid #f4f4f4;
}
.chat-box .chat-menu .tab-pane {
  padding: 0 15px;
}
.chat-box .chat-menu ul li .about .status i {
  font-size: 10px;
}
.chat-box .chat-menu .user-profile {
  margin-top: 30px;
}
.chat-box .chat-menu .user-profile .user-content h5, .chat-box .chat-menu .user-profile .user-content .h5 {
  margin: 25px 0;
}
.chat-box .chat-menu .user-profile .user-content hr {
  margin: 25px 0;
}
.chat-box .chat-menu .user-profile .user-content p {
  font-size: 16px;
}
.chat-box .chat-menu .user-profile .border-tab.nav-tabs .nav-item .nav-link.active,
.chat-box .chat-menu .user-profile .border-tab.nav-tabs .nav-item .nav-link.show,
.chat-box .chat-menu .user-profile .border-tab.nav-tabs .nav-item .nav-link:focus {
  border-bottom: 0;
}
.chat-box .chat-menu .user-profile .image {
  position: relative;
}
.chat-box .chat-menu .user-profile .image .icon-wrapper {
  position: absolute;
  bottom: 0;
  left: 55%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 35px;
  width: 35px;
  border-radius: 50%;
  background-color: #fff;
  cursor: pointer;
  overflow: hidden;
  margin: 0 auto;
  font-size: 14px;
  box-shadow: 1px 1px 3px 1px #f4f4f4;
}
.chat-box .chat-menu .user-profile .image .avatar img {
  border-radius: 50%;
  border: 5px solid #f4f4f4;
}
.chat-box .chat-menu .user-profile .border-right {
  border-right: 1px solid #dee2e6;
}
.chat-box .chat-menu .user-profile .follow {
  margin-top: 0;
}
.chat-box .chat-menu .user-profile .follow .follow-num {
  font-size: 20px;
  color: #000;
}
.chat-box .chat-menu .user-profile .follow span {
  color: #242934;
  font-size: 14px;
  letter-spacing: 1px;
}
.chat-box .chat-menu .user-profile .social-media a {
  color: #59667a;
  font-size: 15px;
  padding: 0 7px;
}
.chat-box .chat-menu .user-profile .chat-profile-contact p {
  font-size: 14px;
  color: #59667a;
}
.chat-box .chat-menu .nav {
  margin-bottom: 20px;
}
.chat-box .chat-menu .nav-tabs .nav-item {
  width: 33.33%;
}
.chat-box .chat-menu .nav-tabs .nav-item a {
  padding: 15px !important;
  color: #59667a !important;
  letter-spacing: 1px;
  font-size: 14px;
  font-weight: 500;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.chat-box .chat-menu .nav-tabs .nav-item .material-border {
  border-width: 1px;
  border-color: var(--theme-default);
}
.chat-box .chat-menu .nav-tabs .nav-item .nav-link.active {
  color: #000 !important;
}
.chat-box .chat-history .call-content {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 300px;
}
.chat-box .chat-history .total-time h2, .chat-box .chat-history .total-time .h2 {
  font-size: 50px;
  color: #efefef;
  font-weight: 600;
  margin-bottom: 30px;
}
.chat-box .chat-history .receiver-img {
  margin-top: 55px;
}
.chat-box .chat-history .receiver-img img {
  border-radius: 5px;
}
.chat-box .chat-history .call-icons {
  margin-bottom: 35px;
}
.chat-box .chat-history .call-icons ul li {
  width: 60px;
  height: 60px;
  border: 1px solid #f4f4f4;
  border-radius: 50%;
  padding: 12px;
  cursor: pointer;
}
.chat-box .chat-history .call-icons ul li + li {
  margin-left: 10px;
}
.chat-box .chat-history .call-icons ul li a {
  color: #999;
  font-size: 25px;
}

.chat-left-aside > .media {
  margin-bottom: 15px;
}
.chat-left-aside .people-list {
  height: 625px;
}
.chat-left-aside ul li {
  position: relative;
}
.chat-left-aside .list-group-item.active {
  background-color: transparent !important;
}

.status-circle {
  width: 12px;
  height: 12px;
  position: absolute;
  top: 4px;
  left: 44px;
  border-radius: 50%;
  border: 2px solid #fff;
}

.away {
  background-color: #ffaa05;
}

.online {
  background-color: #54ba4a;
}

.offline {
  background-color: #fc4438;
}

.chat-container .aside-chat-left {
  width: 320px;
}
.chat-container .chat-right-aside {
  width: 320px;
}

.call-chat-sidebar {
  max-width: 320px;
}

.call-chat-sidebar .card .card-body,
.chat-body .card .card-body {
  padding: 15px;
}

body.dark-only .page-wrapper .people-list .list-group-item.active {
  background-color: transparent !important;
}

/**=====================
    14.  Chat CSS Ends
==========================**/
/**=====================
    84. Checkout CSS start
==========================**/
.checkout .checkout-details {
  background-color: #f9f9f9;
  border: 1px solid #dddddd;
  padding: 40px;
}
.checkout .checkout-details .order-place {
  margin-top: 15px;
}

.order-box .title-box {
  padding-bottom: 20px;
  color: #444444;
  font-size: 22px;
  border-bottom: 1px solid #ededed;
  margin-bottom: 20px;
}
.order-box .title-box span {
  width: 35%;
  float: right;
  font-weight: 600;
  text-align: right;
}
.order-box .title-box h4, .order-box .title-box .h4 {
  font-weight: 600;
}
.order-box .title-box .checkbox-title {
  display: flex;
  justify-content: space-between;
}
.order-box .sub-total li {
  position: relative;
  display: inline-block;
  font-size: 16px;
  font-weight: 600;
  color: #333333;
  line-height: 20px;
  margin-bottom: 20px;
  width: 100%;
}
.order-box .sub-total li .count {
  position: relative;
  font-size: 18px;
  line-height: 20px;
  font-weight: 400;
  width: 35%;
  float: right;
  text-align: right;
}
.order-box .sub-total .shipping-class {
  margin-bottom: 12px;
}
.order-box .sub-total .shipping-class .shopping-checkout-option {
  margin-top: -4px;
  position: relative;
  font-size: 18px;
  line-height: 20px;
  color: var(--theme-default);
  font-weight: 400;
  width: 35%;
  float: right;
  text-align: right;
}
.order-box .total {
  position: relative;
  margin-bottom: 30px;
}
.order-box .total li {
  position: relative;
  display: block;
  font-weight: 400;
  color: #333333;
  line-height: 20px;
  font-size: 18px;
}
.order-box .qty {
  position: relative;
  border-bottom: 1px solid #ededed;
  margin-bottom: 30px;
}
.order-box .qty li {
  position: relative;
  display: block;
  font-size: 15px;
  color: #444444;
  line-height: 20px;
  margin-bottom: 20px;
}
.order-box .qty li span {
  float: right;
  font-size: 18px;
  line-height: 20px;
  color: #232323;
  font-weight: 400;
  width: 35%;
  text-align: right;
}

.radio-option {
  position: relative;
}

.img-paypal {
  width: 30%;
  margin-left: 15px;
}

/**=====================
    86. Checkout CSS Ends
==========================**/
/**=====================
    Responsive CSS Start
==========================**/
@media screen and (max-width: 1199px) {
  .checkout .checkout-details {
    padding: 25px;
  }
  .order-box .title-box span {
    width: 30%;
  }
  .order-box .sub-total li .count {
    width: 38%;
  }
  .order-box .sub-total .shipping-class .shopping-checkout-option {
    width: 46%;
  }
  .order-box .qty li span {
    width: 38%;
  }
  .order-box .total li .count {
    width: 38%;
  }
}
@media screen and (max-width: 991px) {
  .order-box .sub-total .shipping-class .shopping-checkout-option {
    width: 38%;
  }
}
@media screen and (max-width: 575px) {
  .checkout .checkout-details {
    padding: 15px;
  }
  .order-box .sub-total .shipping-class .shopping-checkout-option {
    width: 50%;
  }
  .order-box .sub-total li .count {
    width: 50%;
  }
}
/**=====================
    84. Checkout CSS ends
==========================**/
/**=====================
     27. Coming Soon CSS Start
==========================**/
.comingsoon-bgimg {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  background-position: bottom;
  background-size: cover;
}

.comingsoon {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 50px 0;
}
.comingsoon .comingsoon-inner h5, .comingsoon .comingsoon-inner .h5 {
  font-size: 18px;
  letter-spacing: 1px;
  color: #52526c;
  font-weight: 500;
  margin-bottom: 30px;
  margin-top: 30px;
}
.comingsoon .comingsoon-inner .countdown {
  padding: 30px 0;
  border-top: 1px solid #f4f4f4;
  border-bottom: 1px solid #f4f4f4;
}
.comingsoon .comingsoon-inner .countdown .time {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  color: #fff;
  font-weight: 500;
  width: 100px;
  height: 100px;
  font-size: 36px;
  background: var(--theme-default);
}
.comingsoon .comingsoon-inner .countdown .title {
  padding-top: 13px;
  font-size: 14px;
  font-weight: 400;
  color: #52526c;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.comingsoon .comingsoon-inner .countdown ul li {
  display: inline-block;
  text-transform: uppercase;
  margin: 0 20px;
}
.comingsoon .comingsoon-inner .countdown ul li span {
  display: block;
}
.comingsoon video {
  position: fixed;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: -100;
  transform: translateX(-50%) translateY(-50%);
  transition: 1s opacity;
}

/**=====================
    27. Coming Soon CSS Ends
==========================**/
/**=====================
      86. contacts CSS Start
==========================**/
.alert-contactadd {
  background-color: #fff;
  border: 1px solid var(--theme-default);
  width: 12%;
  padding: 10px;
}

.updateimg {
  position: absolute;
  left: 15px;
  width: 100px;
  top: 32px;
  line-height: 93px;
  opacity: 0;
}

#right-history {
  top: 81px;
  right: -320px;
  height: 100%;
  position: fixed;
  width: 320px;
  z-index: 9;
  background-color: #fff;
  transition: 0.5s;
  box-shadow: 0 0 9px rgba(191, 191, 191, 0.36);
}
[dir=rtl] #right-history {
  right: unset;
  left: -320px;
}
#right-history h6 span a, #right-history .h6 span a {
  color: #2f2f3b;
}
#right-history.show {
  right: 0;
  transition: 0.3s;
}
[dir=rtl] #right-history.show {
  right: unset;
  left: 0;
}

.history-details > div {
  padding: 30px 0;
}
.history-details .media {
  padding: 30px 15px;
  border-top: 1px solid #f4f4f4;
}
.history-details .media i {
  padding: 5px;
  background: #fed112;
  color: #fff;
  border-radius: 100%;
}
.history-details .media h6, .history-details .media .h6 {
  margin-bottom: 5px;
}

.delete-contact {
  display: none;
}

.more-data {
  animation: displayTransition 1s;
}

.contact-editform {
  padding: 30px;
  animation: displayTransition 1s;
}
.contact-editform a {
  display: block;
}
.contact-editform button {
  margin-top: 30px;
}
.contact-editform .select2-container .select2-selection--single {
  height: 39px !important;
  border-color: #ced4da !important;
}

#deletemodal .modal-header {
  border-bottom: none;
}
#deletemodal .modal-header .delete-data span svg {
  vertical-align: middle;
  margin-right: 15px;
}

.contact-options li .btn-category {
  line-height: 39px;
  border-radius: 3px;
  padding-left: 40px !important;
  padding: 0;
  color: var(--theme-default);
  font-weight: 500;
}

.list-persons p {
  font-family: Roboto, sans-serif;
}
.list-persons .profile-mail {
  padding: 30px 0;
}
.list-persons .profile-mail .media img {
  height: 100px;
}
.list-persons .profile-mail .media .media-body h5, .list-persons .profile-mail .media .media-body .h5 {
  margin-bottom: 5px;
}
.list-persons .profile-mail .media .media-body ul {
  margin-top: 5px;
}
.list-persons .profile-mail .media .media-body ul li {
  display: inline-block;
}
.list-persons .profile-mail .media .media-body ul li a {
  font-size: 13px;
}
.list-persons .profile-mail .media .media-body ul li + li {
  padding-left: 10px;
  margin-left: 5px;
  border-left: 2px solid #f4f4f4;
}
.list-persons .profile-mail .email-general {
  padding-top: 50px;
}
.list-persons .profile-mail .email-general ul {
  padding-right: 20px;
}
.list-persons .profile-mail .email-general ul li {
  color: #898989;
  padding-bottom: 10px;
  margin-bottom: 10px;
}
.list-persons .profile-mail .email-general ul li:last-child {
  padding-bottom: 0;
  margin-bottom: 0;
}
.list-persons .profile-mail .email-general ul li > span {
  float: right;
}
.list-persons .profile-mail .email-general p span {
  margin-left: 30px;
}
.list-persons .profile-mail .email-general .gender {
  margin-top: 30px;
}

.contacts-tabs .nav-pills {
  border-right: 1px solid #f4f4f4;
  height: 100%;
}
.contacts-tabs .nav-pills .nav-link.active,
.contacts-tabs .nav-pills .nav-link > .nav-link,
.contacts-tabs .nav-pills .show.active,
.contacts-tabs .nav-pills .show > .nav-link {
  background-color: rgba(115, 102, 255, 0.05);
  color: #2f2f3b;
}
.contacts-tabs .nav-pills .nav-link {
  color: #2f2f3b;
  padding: 0;
}
.contacts-tabs .nav-pills .nav-link .media .img-50 {
  height: 50px;
}
.contacts-tabs .nav-pills .nav-link + .nav-link {
  border-top: 1px solid #f4f4f4;
}
.contacts-tabs .nav-pills .media {
  padding: 20px;
}
.contacts-tabs .tab-content .tab-content-child {
  animation: displayTransition 1s;
}

@media only screen and (max-width: 991px) {
  #right-history {
    top: 60px;
  }
  .updateimg {
    top: 21px;
  }
  .list-persons .profile-mail {
    padding: 20px;
  }
  .list-persons .profile-mail .email-general .gender {
    margin-top: 20px;
  }
  .contact-editform button {
    margin-top: 20px;
  }
}
@media only screen and (max-width: 767px) {
  .contact-editform {
    padding: 20px;
  }
  .contact-editform.pl-0 {
    padding-left: 20px !important;
  }
  .contacts-tabs .nav-pills {
    border-right: none;
    border-bottom: 1px solid #f4f4f4;
  }
}
@media only screen and (max-width: 575px) {
  #right-history {
    width: 270px;
  }
  .updateimg {
    top: 16px;
    left: 29px;
  }
  .contacts-tabs .media img.m-r-20 {
    margin-right: 15px;
  }
  .contacts-tabs .nav-pills .media {
    padding: 15px;
  }
  .list-persons .profile-mail {
    padding: 15px;
  }
  .list-persons .profile-mail .email-general .gender {
    margin-top: 15px;
  }
  .list-persons .nav-pills .nav-link .media .media-body {
    text-align: left;
  }
  .contact-editform {
    padding: 15px;
  }
  .contact-editform button {
    margin-top: 15px;
  }
  .contact-editform.pl-0 {
    padding-left: 15px !important;
  }
  .contact-editform form .row > div .row > div > div,
  .contact-options form .row > div .row > div > div {
    margin-bottom: 0;
  }
  .contact-editform form .row > div .row > div + div,
  .contact-options form .row > div .row > div + div {
    margin-top: 15px;
  }
}
@media only screen and (max-width: 360px) {
  .updateimg {
    line-height: 73px;
    width: 80px;
  }
  .list-persons .profile-mail .email-general p span {
    margin-left: 10px;
  }
  .list-persons .profile-mail .media {
    display: block;
  }
  .list-persons .profile-mail .media img {
    height: 80px;
    width: 80px !important;
    margin-bottom: 15px;
  }
}
/**=====================
    86. contacts CSS Ends
==========================**/
/**=====================
      67. Dashboard 2 CSS Start
==========================**/
.widget-decor {
  position: absolute;
  height: 60px;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

.balance-widget {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: right;
}
.balance-widget .mobile-right-img {
  position: absolute;
  top: 10px;
  right: 15px;
}
.balance-widget .mobile-right-img .left-mobile-img {
  margin-right: -20px;
}
.balance-widget .mobile-right-img .mobile-img {
  height: 130px;
}
[dir=rtl] .balance-widget .mobile-right-img {
  right: unset;
  left: 15px;
}
@media (max-width: 480px) {
  .balance-widget .mobile-right-img {
    right: 0;
  }
  .balance-widget .mobile-right-img .mobile-img {
    height: 100px;
  }
  [dir=rtl] .balance-widget .mobile-right-img {
    right: unset;
    left: 0;
  }
}
[dir=rtl] .balance-widget {
  text-align: right;
}
.balance-widget.card-body {
  padding: 20px 15px;
}
.balance-widget .purchase-btn {
  min-width: 170px;
}

.small-widget {
  overflow: hidden;
}
.small-widget h4, .small-widget .h4 {
  margin-bottom: -3px;
}
.small-widget i {
  font-weight: 700;
  font-size: 11px;
}
.small-widget .card-body {
  padding: 24px 15px;
}
.small-widget .bg-gradient {
  width: 66px;
  height: 67px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  right: -12px;
  top: 50%;
  position: absolute;
  transform: translateY(-50%);
}
[dir=rtl] .small-widget .bg-gradient {
  right: unset;
  left: -12px;
  transform: translateY(-50%) scaleX(-1);
}
@media (max-width: 1399px) {
  .small-widget .bg-gradient {
    width: 60px;
    height: 60px;
  }
}
.small-widget .bg-gradient svg {
  width: 25px;
  height: 25px;
}
@media (max-width: 1399px) {
  .small-widget .bg-gradient svg {
    width: 22px;
    height: 22px;
  }
}
.small-widget:hover {
  transform: translateY(-5px);
  transition: 0.5s;
}
.small-widget:hover .bg-gradient svg {
  animation: tada 1.5s ease infinite;
}

@media (max-width: 1470px) {
  .appointment .customer-table {
    height: 268px;
  }
}
@media (max-width: 1399px) {
  .appointment .customer-table {
    height: unset;
  }
}

.order-wrapper {
  margin: 0 -24px -17px -17px;
}

.categories-list {
  display: flex;
  flex-direction: column;
  gap: 18px;
}
@media (max-width: 767px) {
  .categories-list {
    flex-direction: row;
    flex-wrap: wrap;
  }
}
.categories-list li {
  gap: 10px;
}
.categories-list li .bg-light {
  min-width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.categories-list li .bg-light img {
  width: 25px;
  height: 25px;
  object-fit: contain;
  transition: 0.5s;
}
.categories-list li h6 a, .categories-list li .h6 a {
  transition: 0.5s;
  color: var(--body-font-color);
}
.categories-list li:hover .bg-light img {
  transition: 0.5s;
  transform: scale(1.1);
}
.categories-list li:hover h6 a, .categories-list li:hover .h6 a {
  transition: 0.5s;
  color: var(--theme-default);
}

.monthly-profit {
  margin-top: -10px;
}
@media (max-width: 1584px) {
  .monthly-profit {
    margin: -10px -8px 0;
  }
}
@media (max-width: 1520px) {
  .monthly-profit {
    margin: -10px -16px 0;
  }
}
@media (max-width: 1500px) {
  .monthly-profit {
    margin: -10px -14px 0;
  }
}
@media (max-width: 1472px) {
  .monthly-profit {
    margin: -10px -20px 0;
  }
}
@media (max-width: 1424px) {
  .monthly-profit {
    margin: -10px -25px 0;
  }
}
.monthly-profit .apexcharts-canvas .apexcharts-legend-marker {
  margin-right: 6px;
}
.monthly-profit .apexcharts-canvas .apexcharts-datalabels-group .apexcharts-datalabel-value {
  font-size: 14px;
  font-weight: 500;
  font-family: Rubik, sans-serif !important;
  fill: var(--chart-text-color);
}

.overview-wrapper {
  position: relative;
  z-index: 1;
}

.back-bar-container {
  position: absolute;
  width: calc(100% - 64px);
  bottom: -8px;
  margin: 0 auto !important;
  left: 28px;
}
@media (max-width: 1199px) {
  .back-bar-container {
    bottom: 22px;
  }
}
@media (max-width: 480px) {
  .back-bar-container {
    width: calc(100% - 34px);
    left: 18px;
  }
}
@media (max-width: 327px) {
  .back-bar-container {
    bottom: 42px;
  }
}

.overview-card .balance-data {
  right: 12px;
}
[dir=rtl] .overview-card .balance-data {
  right: unset;
  left: 12px;
}
@media (max-width: 767px) {
  .overview-card .balance-data {
    right: -40%;
  }
  [dir=rtl] .overview-card .balance-data {
    left: -40%;
  }
}

.order-container .apexcharts-canvas .apexcharts-marker {
  stroke-width: 4;
}

.purchase-card.discover {
  margin-top: 102px;
}
.purchase-card.discover img {
  width: 224px;
  margin: 0 auto;
  margin-top: -90px;
}
@media (max-width: 1550px) {
  .purchase-card.discover img {
    margin-top: -110px;
  }
}
@media (max-width: 1399px) {
  .purchase-card.discover img {
    margin-top: -90px;
  }
}
@media (max-width: 991px) {
  .purchase-card.discover img {
    margin-top: -110px;
  }
}
@media (max-width: 618px) {
  .purchase-card.discover img {
    width: 200px;
  }
}

.visitor-card .card-header svg {
  width: 18px;
  height: 18px;
  fill: var(--theme-default);
}

.visitors-container {
  margin: 0 -12px -27px -17px;
}
.visitors-container svg .apexcharts-series path {
  clip-path: inset(1% 0% 0% 0% round 3rem);
}
.visitors-container svg .apexcharts-legend.apexcharts-align-left .apexcharts-legend-series {
  display: flex;
}

.recent-order .nav {
  gap: 8px;
  flex-wrap: nowrap;
  overflow: auto;
  padding-bottom: 5px;
  display: flex;
}
.recent-order .frame-box {
  border: 1px solid transparent;
  padding: 0;
  transition: 0.5s;
}
.recent-order .frame-box.active {
  border: 1px solid var(--theme-default);
}
.recent-order .frame-box:hover {
  transform: translateY(-5px);
  transition: 0.5s;
}
.recent-order .tab-content {
  margin-top: 16px;
}

.recent-table table thead {
  background: var(--light2);
}
.recent-table table thead th {
  padding-top: 9px;
  padding-bottom: 9px;
  border-bottom: none;
}
.recent-table table tr td,
.recent-table table tr th {
  padding: 12px 8px;
  vertical-align: middle;
}
.recent-table table tr td:first-child,
.recent-table table tr th:first-child {
  min-width: 157px;
}
@media (max-width: 1660px) {
  .recent-table table tr td:nth-child(2),
  .recent-table table tr th:nth-child(2) {
    min-width: 97px;
  }
}
.recent-table table tr td:last-child,
.recent-table table tr th:last-child {
  min-width: 96px;
}
.recent-table table tr td:first-child {
  padding-left: 0;
}
[dir=rtl] .recent-table table tr td:first-child {
  padding-left: unset;
  padding-right: 0;
}
.recent-table table tr td:last-child {
  padding-right: 0;
}
[dir=rtl] .recent-table table tr td:last-child {
  padding-left: 0;
  padding-right: unset;
}
.recent-table table tr:last-child td {
  padding-bottom: 0;
  border-bottom: none;
}
.recent-table table tr .product-content h6 a, .recent-table table tr .product-content .h6 a {
  color: var(--body-font-color);
  transition: 0.5s;
}
.recent-table table tr:hover .product-content h6 a, .recent-table table tr:hover .product-content .h6 a {
  color: var(--theme-default);
  transition: 0.5s;
}
.recent-table .product-content {
  display: flex;
  align-items: center;
  gap: 8px;
}
.recent-table .product-content .order-image {
  background: var(--light2);
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.recent-table svg {
  width: 20px;
  height: 20px;
}
.recent-table .recent-status {
  display: flex;
  align-items: center;
}
.recent-table .recent-status.font-success svg {
  fill: #54ba4a;
}
.recent-table .recent-status.font-danger svg {
  fill: #fc4438;
}

.recent-activity h5, .recent-activity .h5 {
  padding: 30px 0 20px;
  margin-bottom: 0;
}
.recent-activity h6, .recent-activity .h6 {
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  display: -webkit-box;
}
.recent-activity ul li span {
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  display: -webkit-box;
}

.notification li .recent-images ul::before {
  display: none;
}
.notification li .recent-images li {
  padding-bottom: 3px;
}

.recent-images {
  margin-top: 10px;
}
.recent-images ul {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.recent-images li {
  border: 1px dashed var(--recent-dashed-border);
  padding: 3px;
  border-radius: 2px;
}
.recent-images li .recent-img-wrap {
  width: 40px;
  height: 40px;
  background: var(--light2);
  display: flex;
  align-items: center;
  justify-content: center;
}

.frame-box {
  background: var(--recent-box-bg);
  border-radius: 10px;
  min-width: 76px;
  box-shadow: 2px 2px 2px var(--recent-border);
}
@media (max-width: 575px) {
  .frame-box {
    min-width: 65px;
  }
}
.frame-box .frame-image {
  min-width: 62px;
  height: 62px;
  border-color: var(--recent-border) var(--white) var(--white) var(--recent-border);
  border-width: 1px;
  border-style: solid;
  margin: 6px;
  display: flex;
  align-items: center;
  border-radius: 4px;
}
@media (max-width: 575px) {
  .frame-box .frame-image {
    min-width: 50px;
    height: 50px;
    margin: 4px;
  }
}
.frame-box img {
  margin: 0 auto;
}
@media (max-width: 575px) {
  .frame-box img {
    height: 30px;
  }
}

.support-ticket-font ul {
  font-size: 12px;
}

.new-update .media .media-body span,
.new-update .media .media-body p {
  font-weight: 500;
}

.activity-dot-primary {
  min-width: 6px;
  width: 6px;
  height: 6px;
  background-color: #7366ff;
  border-radius: 100%;
  outline: 5px solid rgba(115, 102, 255, 0.25);
  position: relative;
  z-index: 2;
}

.activity-dot-secondary {
  min-width: 6px;
  width: 6px;
  height: 6px;
  background-color: #ff3364;
  border-radius: 100%;
  outline: 5px solid rgba(255, 51, 100, 0.25);
  position: relative;
  z-index: 2;
}

.activity-dot-success {
  min-width: 6px;
  width: 6px;
  height: 6px;
  background-color: #54ba4a;
  border-radius: 100%;
  outline: 5px solid rgba(84, 186, 74, 0.25);
  position: relative;
  z-index: 2;
}

.activity-dot-danger {
  min-width: 6px;
  width: 6px;
  height: 6px;
  background-color: #fc4438;
  border-radius: 100%;
  outline: 5px solid rgba(252, 68, 56, 0.25);
  position: relative;
  z-index: 2;
}

.activity-dot-info {
  min-width: 6px;
  width: 6px;
  height: 6px;
  background-color: #16c7f9;
  border-radius: 100%;
  outline: 5px solid rgba(22, 199, 249, 0.25);
  position: relative;
  z-index: 2;
}

.activity-dot-light {
  min-width: 6px;
  width: 6px;
  height: 6px;
  background-color: #f4f4f4;
  border-radius: 100%;
  outline: 5px solid rgba(244, 244, 244, 0.25);
  position: relative;
  z-index: 2;
}

.activity-dot-dark {
  min-width: 6px;
  width: 6px;
  height: 6px;
  background-color: #2c323f;
  border-radius: 100%;
  outline: 5px solid rgba(44, 50, 63, 0.25);
  position: relative;
  z-index: 2;
}

.activity-dot-warning {
  min-width: 6px;
  width: 6px;
  height: 6px;
  background-color: #ffaa05;
  border-radius: 100%;
  outline: 5px solid rgba(255, 170, 5, 0.25);
  position: relative;
  z-index: 2;
}

@media only screen and (max-width: 1800px) and (min-width: 1400px) {
  .grid-ed-none {
    display: none !important;
  }
  .grid-ed-12 {
    width: 100%;
  }
}
@media only screen and (max-width: 1660px) and (min-width: 1400px) {
  .col-ed-12 {
    width: 100%;
  }
  .col-ed-7 {
    width: 58%;
  }
  .col-ed-5 {
    width: 42%;
  }
  .col-ed-9 {
    width: 75%;
  }
  .col-ed-3 {
    width: 25%;
  }
  .col-ed-6 {
    width: 50%;
  }
  .col-ed-4 {
    width: 33.33333333%;
  }
  .col-ed-8 {
    width: 66.66%;
  }
  .col-ed-none {
    display: none !important;
  }
}
@media only screen and (max-width: 1660px) and (min-width: 1200px) {
  .xl-30 {
    max-width: 30%;
    flex: 0 0 30%;
  }
  .xl-70 {
    max-width: 70%;
    flex: 0 0 70%;
  }
}
@media only screen and (max-width: 420px) {
  .size-column .col-6 {
    width: 100%;
  }
}
/**=====================
     67. Dashboard 2  CSS End
==========================**/
/**=====================
     Dashboard 3 CSS Start
==========================**/
@keyframes hand-move {
  0% {
    transform: rotate(0deg);
  }
  20% {
    transform: rotate(15deg);
  }
  50% {
    transform: rotate(0deg);
  }
  80% {
    transform: rotate(-15deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
.welcome-card {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  color: #fff;
}
.welcome-card h4 img, .welcome-card .h4 img {
  margin-top: -6px;
  animation: hand-move 5s infinite ease-in;
}
.welcome-card p {
  width: 75%;
}
@media (max-width: 1830px) {
  .welcome-card p {
    width: 62%;
  }
}
@media (max-width: 991px) {
  .welcome-card p {
    width: 70%;
  }
}
@media (max-width: 480px) {
  .welcome-card p {
    width: 100%;
  }
}
.welcome-card .welcome-img {
  height: 200px;
  position: absolute;
  right: 0;
  bottom: -32px;
}
[dir=rtl] .welcome-card .welcome-img {
  right: unset;
  left: 0;
}
@media (max-width: 1780px) {
  .welcome-card .welcome-img {
    height: 180px;
    bottom: -28px;
  }
}
@media (max-width: 1700px) {
  .welcome-card .welcome-img {
    bottom: -23px;
  }
}
@media (max-width: 767px) {
  .welcome-card .welcome-img {
    height: 140px;
    bottom: -18px;
  }
}
@media (max-width: 480px) {
  .welcome-card .welcome-img {
    display: none;
  }
}

.course-box {
  overflow: hidden;
}
.course-box .card-body {
  padding: 25px 15px;
}
@media (max-width: 1722px) {
  .course-box .card-body {
    padding: 20px 15px;
  }
}
@media (max-width: 1660px) {
  .course-box .card-body {
    padding: 16px 15px;
  }
}
@media (max-width: 1660px) {
  .course-box.widget-course .card-body {
    padding: 25px 15px;
  }
}
.course-box:hover {
  transform: translateY(-5px);
  transition: 0.5s;
}
.course-box:hover .course-icon svg {
  animation: tada 1.5s ease infinite;
}

.course-widget {
  display: flex;
  gap: 8px;
}
.course-widget .course-icon {
  position: relative;
  width: 54px;
  height: 54px;
  clip-path: polygon(40% 7.67949%, 43.1596% 6.20615%, 46.52704% 5.30384%, 50% 5%, 53.47296% 5.30384%, 56.8404% 6.20615%, 60% 7.67949%, 81.65064% 20.17949%, 84.50639% 22.17911%, 86.97152% 24.64425%, 88.97114% 27.5%, 90.44449% 30.6596%, 91.34679% 34.02704%, 91.65064% 37.5%, 91.65064% 62.5%, 91.34679% 65.97296%, 90.44449% 69.3404%, 88.97114% 72.5%, 86.97152% 75.35575%, 84.50639% 77.82089%, 81.65064% 79.82051%, 60% 92.32051%, 56.8404% 93.79385%, 53.47296% 94.69616%, 50% 95%, 46.52704% 94.69616%, 43.1596% 93.79385%, 40% 92.32051%, 18.34936% 79.82051%, 15.49361% 77.82089%, 13.02848% 75.35575%, 11.02886% 72.5%, 9.55551% 69.3404%, 8.65321% 65.97296%, 8.34936% 62.5%, 8.34936% 37.5%, 8.65321% 34.02704%, 9.55551% 30.6596%, 11.02886% 27.5%, 13.02848% 24.64425%, 15.49361% 22.17911%, 18.34936% 20.17949%);
  background: linear-gradient(310.31deg, #ff3364 14.71%, #ff7f9e 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}
.course-widget .course-icon svg {
  width: 26px;
  height: 26px;
  fill: #fff;
}
.course-widget .course-icon.warning {
  background: linear-gradient(297.08deg, #ff9e2a -4.53%, #ffa941 98.25%);
}
.course-widget .btn-light {
  background: var(--course-light-btn) !important;
  border: none;
}
.course-widget a {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  margin-top: 25px;
}
.course-widget a span {
  display: block;
  margin-bottom: -5px;
}
.course-widget a svg {
  width: 13px;
  height: 13px;
}

.get-card .card-header {
  padding-left: 20px;
  padding-right: 20px;
}

.square-group {
  position: absolute;
  bottom: 0;
  right: 0;
  transform: scaleX(-1);
}
[dir=rtl] .square-group {
  right: unset;
  left: 0;
}
.square-group .square-1 {
  width: 12px;
  height: 18px;
}
.square-group .square-2 {
  width: 12px;
  height: 10px;
  margin-bottom: -10px;
}
.square-group .square-3 {
  width: 18px;
  height: 10px;
  margin-left: 10px;
}
[dir=rtl] .square-group .square-3 {
  margin-left: unset;
  margin-right: 10px;
}
.square-group .square-4 {
  width: 16px;
  height: 16px;
  position: absolute;
  top: 20px;
  right: -15px;
}
[dir=rtl] .square-group .square-4 {
  right: unset;
  left: -15px;
}
.square-group .square-5 {
  width: 6px;
  height: 6px;
  bottom: 22px;
  position: absolute;
  right: -1px;
}
[dir=rtl] .square-group .square-5 {
  right: unset;
  left: -1px;
}
.square-group .square-6,
.square-group .square-7 {
  position: absolute;
  width: 4px;
  height: 4px;
}
.square-group .square-6 {
  right: -23px;
  bottom: 5px;
}
[dir=rtl] .square-group .square-6 {
  right: unset;
  left: -23px;
}
.square-group .square-7 {
  right: 8px;
  bottom: 45px;
}
[dir=rtl] .square-group .square-7 {
  right: unset;
  left: 8px;
}
.square-group .warning1 {
  background: #ffd497 !important;
}
.square-group .warning {
  background: #ffa73b !important;
}
.square-group .primary {
  background: #7366ff !important;
}
.square-group .danger {
  background: #f54132 !important;
}
.square-group .light {
  background: #e6e8ef !important;
}
.square-group .success {
  background: #54ba4a !important;
}

.progress-chart-wrap {
  margin: -40px 0 -22px;
}
[dir=rtl] .progress-chart-wrap {
  direction: ltr;
}
@media (max-width: 991px) {
  .progress-chart-wrap {
    margin-top: -18px;
  }
}
.progress-chart-wrap .apexcharts-canvas {
  margin: 0 auto;
}
.progress-chart-wrap .apexcharts-canvas .apexcharts-datalabels-group .apexcharts-datalabel-label {
  fill: var(--chart-text-color);
}

.get-card .btn {
  margin-top: 15px;
  padding: 8px 15px;
}
.get-card .btn:hover svg {
  transform: translateX(5px);
  transition: 0.5s;
}
.get-card .btn svg {
  width: 13px;
  height: 13px;
  fill: #fff;
  vertical-align: middle;
  transition: 0.5s;
}

.default-datepicker .datepicker-inline .datepicker {
  width: auto;
  background: #fff;
  box-shadow: none;
  padding: 0;
}
.default-datepicker .datepicker-inline .datepicker .datepicker--content {
  padding: 0;
}
.default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--days-names {
  margin: 27px 0 0;
  padding: 15px 0;
}
.default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--days-names .datepicker--day-name {
  color: #2b2b2b;
  font-size: 14px;
}
.default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--cells .datepicker--cell-day {
  height: 35px;
  width: 14%;
  color: #2b2b2b;
}
.default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--cells .datepicker--cell-day.-other-month- {
  color: #2b2b2b;
  opacity: 20%;
}
.default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--cells .datepicker--cell-day.-weekend- + .-weekend- {
  color: #fc4438;
}
.default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--cells .datepicker--cell {
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  z-index: 0;
  letter-spacing: 2px;
}
.default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--cells .datepicker--cell.-selected- {
  background: var(--theme-default);
  color: #fff;
  position: relative;
  box-shadow: 0px 0px 13px 0 rgba(115, 102, 255, 0.5);
}
.default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--cells .datepicker--cell.-current- {
  background-color: #54ba4a;
  border: none;
  color: #fff;
}
.default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--cells .datepicker--cell.-current-::after {
  position: absolute;
  content: "";
  width: 10px;
  height: 10px;
  border: 2px solid var(--white);
  background: #fc4438;
  right: -3px;
  top: -2px;
  border-radius: 100%;
}
.default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--cells .datepicker--cell.-focus- {
  color: #fff;
  box-shadow: none;
}
.default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker-cell .datepicker--cell-month.-current-.-selected- {
  background-color: var(--theme-default);
}
.default-datepicker .datepicker-inline .datepicker .datepicker--nav {
  border-bottom: none;
  padding: 0;
  text-transform: capitalize;
  margin-top: 0;
}
.default-datepicker .datepicker-inline .datepicker .datepicker--nav .datepicker--nav-action {
  background-color: transparent;
  width: 22px;
  height: 22px;
}
.default-datepicker .datepicker-inline .datepicker .datepicker--nav .datepicker--nav-action[data-action=prev] {
  position: absolute;
  right: 50px;
}
[dir=rtl] .default-datepicker .datepicker-inline .datepicker .datepicker--nav .datepicker--nav-action[data-action=prev] {
  right: unset;
  left: 50px;
}
.default-datepicker .datepicker-inline .datepicker .datepicker--nav .datepicker--nav-action svg {
  width: 22px;
  height: 22px;
}
.default-datepicker .datepicker-inline .datepicker .datepicker--nav .datepicker--nav-action path {
  stroke: var(--chart-text-color);
}
.default-datepicker .datepicker-inline .datepicker .datepicker--nav-title {
  color: #2b2b2b;
  font-size: 20px;
  font-weight: 500;
}
@media (max-width: 767px) {
  .default-datepicker .datepicker-inline .datepicker .datepicker--nav-title {
    font-size: 14px;
  }
}
.default-datepicker .datepicker-inline .datepicker .datepicker--nav-title i {
  margin-left: 10px;
  font-weight: 500;
  font-size: 20px;
  color: #2b2b2b;
}
@media (max-width: 767px) {
  .default-datepicker .datepicker-inline .datepicker .datepicker--nav-title i {
    font-size: 14px;
  }
}

.learning-wrap {
  margin: -24px -10px -24px -15px;
}

.activity-wrap {
  margin: -22px 0 -22px -28px;
}
[dir=rtl] .activity-wrap {
  margin: -22px -28px -22px 0;
}

.upcoming-event-wrap {
  margin-bottom: -39px;
  margin-left: -24px;
}

.course-card .dropdown .dropdown-toggle {
  width: 125px;
}

.course-wrapper {
  text-align: center;
}
.course-wrapper .course-icon-box {
  position: relative;
  padding: 8px;
}
@media (max-width: 767px) {
  .course-wrapper .course-icon-box {
    padding: 0;
  }
}
.course-wrapper .course-icon-box .icon-wrap {
  width: 117px;
  height: 92px;
  background-color: var(--course-bg);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  margin: 0 auto;
  box-shadow: -18px 15px 20px rgba(119, 119, 119, 0.25);
}
@media (max-width: 1880px) {
  .course-wrapper .course-icon-box .icon-wrap {
    width: 112px;
  }
}
@media (max-width: 767px) {
  .course-wrapper .course-icon-box .icon-wrap {
    box-shadow: none;
  }
}
@media (max-width: 575px) {
  .course-wrapper .course-icon-box .icon-wrap {
    width: 92px;
    height: 82px;
  }
}
.course-wrapper .course-icon-box .icon-wrap img {
  width: 80px;
}
@media (max-width: 575px) {
  .course-wrapper .course-icon-box .icon-wrap img {
    width: 70px;
  }
}
.course-wrapper .course-icon-box .arrow-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: calc(100% + 20px);
  height: 100%;
}
[dir=rtl] .course-wrapper .course-icon-box .arrow-bg {
  left: unset;
  right: 0;
  transform: scaleX(-1);
}
@media (max-width: 767px) {
  .course-wrapper .course-icon-box .arrow-bg {
    display: none;
  }
}
.course-wrapper h6, .course-wrapper .h6 {
  margin-top: 25px;
  margin-bottom: 0;
}
@media (max-width: 575px) {
  .course-wrapper h6, .course-wrapper .h6 {
    margin-top: 15px;
  }
}

.course-main-card {
  display: flex;
  gap: 20px;
  justify-content: center;
}
@media (max-width: 1880px) {
  .course-main-card {
    flex-wrap: wrap;
  }
}
@media (max-width: 767px) {
  .course-main-card {
    gap: 12px;
    flex-wrap: nowrap;
  }
}
@media (max-width: 575px) {
  .course-main-card {
    gap: 20px;
    flex-wrap: wrap;
  }
}
.course-main-card .course-wrapper:last-child .arrow-bg {
  width: 100%;
}

.schedule-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
@media (max-width: 767px) {
  .schedule-list {
    flex-direction: row;
  }
}
@media (max-width: 575px) {
  .schedule-list {
    flex-direction: column;
  }
}
.schedule-list li {
  display: flex;
  align-items: center;
}
.schedule-list li h6, .schedule-list li .h6 {
  font-size: 14px;
}
.schedule-list li ul {
  column-count: 2;
  column-rule-style: solid;
  column-rule-color: var(--chart-text-color);
  column-gap: 20px;
  column-rule-width: 1px;
}
@media (max-width: 1712px) {
  .schedule-list li ul {
    column-gap: 14px;
  }
}
@media (max-width: 1199px) {
  .schedule-list li ul {
    display: flex;
    flex-wrap: wrap;
  }
}
.schedule-list li ul li {
  gap: 6px;
}
.schedule-list li img {
  border-radius: 100%;
  width: 37px;
  height: 37px;
  padding: 3px;
}
.schedule-list li svg {
  width: 15px;
  height: 15px;
}
.schedule-list li svg.f-success {
  fill: #54ba4a;
}
.schedule-list > li {
  padding: 15px 20px !important;
  box-shadow: 4px 7px 17px 5px rgba(46, 35, 94, 0.05) !important;
  gap: 10px;
  position: relative;
  border-radius: 10px;
}
@media (max-width: 1712px) {
  .schedule-list > li {
    padding: 16px 14px;
  }
}
.schedule-list > li::before {
  position: absolute;
  content: "";
  width: 5px;
  height: 100%;
  left: 0;
  top: 0;
  border-radius: 15px 0 0 15px;
}
[dir=rtl] .schedule-list > li::before {
  left: unset;
  right: 0;
  border-radius: 0 15px 15px 0;
}
.schedule-list > li.primary::before {
  background-color: var(--theme-default);
}
.schedule-list > li.primary img {
  border: 1px solid var(--theme-default);
}
.schedule-list > li.warning::before {
  background-color: #ffaa05;
}
.schedule-list > li.warning img {
  border: 1px solid #ffaa05;
}

.link-only {
  display: flex;
  align-items: center;
  color: #52526c;
}
.link-only svg {
  width: 16px;
  height: 16px;
}

.general-cal .react-datepicker__current-month {
  padding: 0;
}
.general-cal .react-datepicker__navigation {
  top: 0;
}
.general-cal .cal-date-widget .cal-datepicker .datepicker-here {
  width: 100%;
}
.general-cal .cal-date-widget .cal-datepicker .datepicker-here .react-datepicker {
  width: 100%;
  border: 0;
}
.general-cal .cal-date-widget .cal-datepicker .datepicker-here .react-datepicker .react-datepicker__month-container {
  float: none;
  width: 100%;
}
.general-cal .cal-date-widget .cal-datepicker .datepicker-here .react-datepicker__day,
.general-cal .cal-date-widget .cal-datepicker .datepicker-here .react-datepicker__time-name {
  width: 100% !important;
  line-height: 2.17rem !important;
  border-radius: 10px;
}
.general-cal .cal-date-widget .cal-datepicker .datepicker-here .react-datepicker__day-names {
  display: flex;
  justify-content: center;
  align-items: center;
}
.general-cal .cal-date-widget .cal-datepicker .datepicker-here .react-datepicker__day-names .react-datepicker__day-name {
  width: 100% !important;
}
.general-cal .datepicker {
  padding: 20px;
  border-radius: 20px;
}
.general-cal .cal-info h2, .general-cal .cal-info .h2 {
  font-size: 100px;
  color: #ecf3fa;
}

.lessons-lists li {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 0 !important;
}
.lessons-lists li img {
  transition: 0.5s;
}
.lessons-lists li + li {
  border-top: 1px solid var(--chart-dashed-border) !important;
}
.lessons-lists li:first-child {
  padding-top: 0 !important;
}
.lessons-lists li:last-child {
  padding-bottom: 0 !important;
}
.lessons-lists li:hover img {
  transform: scale(1.1);
  transition: 0.5s;
}

.lesson-wrap {
  width: 50px;
  margin-bottom: -11px;
  margin-top: -6px;
}
.lesson-wrap .apexcharts-canvas .apexcharts-datalabel-label {
  display: none;
}

@media only screen and (max-width: 575px) {
  .default-datepicker .datepicker-inline .datepicker .datepicker--nav-title {
    font-size: 17px;
  }
  .default-datepicker .datepicker-inline .datepicker .datepicker--nav-title i {
    font-size: 17px;
    margin-left: 10px;
  }
  .default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--cells .datepicker--cell {
    font-size: 13px;
  }
}
@media only screen and (max-width: 360px) {
  .default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--cells .datepicker--cell.-selected-:before {
    height: 36px;
  }
  .default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--cells .datepicker--cell-day {
    height: 36px;
  }
  .default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--days-names {
    margin: 13px 0 13px;
  }
  .default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--days-names .datepicker--day-name {
    font-size: 12px;
  }
  .default-datepicker .datepicker-inline .datepicker .datepicker--nav-title i {
    margin-left: 15px;
    font-size: 25px;
  }
}
/**=====================
     Dashboard 4 CSS Start
==========================**/
.widget-hover:hover {
  transform: translateY(-5px);
  transition: 0.5s;
}

.currency-widget .currency-icon-widget {
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  box-shadow: inset 2.66667px -2.66667px 2.66667px rgba(194, 128, 49, 0.1), inset -2.66667px 2.66667px 2.66667px rgba(255, 255, 255, 0.1);
}
.currency-widget .currency-icon-widget svg {
  width: 16px;
  height: 16px;
  fill: #fff;
}
.currency-widget .card {
  margin-top: 14px;
}
.currency-widget .card .card-body {
  padding: 15px;
  gap: 10px;
  justify-content: space-between;
}
@media (max-width: 1660px) {
  .currency-widget .card .card-body {
    flex-wrap: wrap;
  }
}
@media (max-width: 575px) {
  .currency-widget .card .card-body {
    flex-wrap: unset;
  }
}
.currency-widget .card:hover {
  transform: translateY(-5px);
  transition: 0.5s;
}
.currency-widget h6, .currency-widget .h6 {
  margin-bottom: 0;
}
.currency-widget .d-flex {
  gap: 10px;
  align-items: center;
}
.currency-widget span svg {
  width: 16px;
  height: 16px;
  vertical-align: middle;
}
.currency-widget div[class*=bg-light-] {
  color: #2f2f3b;
  padding: 15px;
  border-radius: 10px;
  width: 115px;
}
@media (max-width: 1660px) and (min-width: 1200px) {
  .currency-widget div[class*=bg-light-] {
    display: none;
  }
}
@media (max-width: 1199px) {
  .currency-widget div[class*=bg-light-] {
    width: 100%;
  }
}
@media (max-width: 575px) {
  .currency-widget div[class*=bg-light-] {
    width: 50%;
  }
}
@media (max-width: 1199px) and (min-width: 768px) {
  .currency-widget.widget-currency .card .card-body {
    flex-wrap: unset;
  }
}
.currency-widget.warning .currency-icon-widget {
  background-image: linear-gradient(to right, #ffaa05 80%, rgba(255, 170, 5, 0.2));
}
.currency-widget.primary .currency-icon-widget {
  background-image: linear-gradient(to right, #7366ff 80%, rgba(115, 102, 255, 0.2));
}
.currency-widget.success .currency-icon-widget {
  background-image: linear-gradient(to right, #54ba4a 80%, rgba(84, 186, 74, 0.2));
}
@media (max-width: 1399px) {
  .currency-widget.height-equal {
    min-height: unset !important;
  }
}

.currency-chart-wrap {
  margin: -28px -10px -20px -20px;
}
@media (max-width: 575px) {
  .currency-chart-wrap {
    width: 50%;
  }
}
.currency-chart-wrap .apexcharts-canvas .apexcharts-tooltip-text-y-label {
  display: none;
}

.tranaction-card .header-top {
  flex-wrap: wrap;
  gap: 10px;
}

.crypto-main-card {
  background-image: linear-gradient(to bottom right, #5f3deb, #ad79ff);
  color: #fff;
}
@media (max-width: 1199px) {
  .crypto-main-card .card-body {
    padding: 20px;
  }
}
.crypto-main-card .btn {
  padding: 8px 20px;
}
@media (max-width: 1660px) {
  .crypto-main-card .btn {
    padding: 8px 15px;
  }
}
.crypto-main-card .deposit-wrap > div {
  width: 65%;
}
@media (max-width: 1660px) {
  .crypto-main-card .deposit-wrap > div {
    width: 90%;
  }
}
@media (max-width: 1536px) {
  .crypto-main-card .deposit-wrap > div {
    width: 100%;
  }
}
@media (max-width: 1399px) {
  .crypto-main-card .deposit-wrap > div {
    width: 75%;
  }
}
@media (max-width: 1199px) {
  .crypto-main-card .deposit-wrap > div {
    width: 95%;
  }
}
@media (max-width: 1660px) {
  .crypto-main-card .deposit-wrap > div h5, .crypto-main-card .deposit-wrap > div .h5 {
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    display: -webkit-box;
  }
}
@media (max-width: 767px) {
  .crypto-main-card .deposit-wrap > div h5, .crypto-main-card .deposit-wrap > div .h5 {
    -webkit-line-clamp: 1;
  }
}
.crypto-main-card .deposit-wrap img {
  position: absolute;
  right: 10px;
  bottom: 10px;
  width: 55%;
}
[dir=rtl] .crypto-main-card .deposit-wrap img {
  right: unset;
  left: 10px;
  transform: scaleX(-1);
}
@media (max-width: 1660px) {
  .crypto-main-card .deposit-wrap img {
    width: 44%;
  }
}
@media (max-width: 1399px) {
  .crypto-main-card .deposit-wrap img {
    width: 52%;
  }
}
@media (max-width: 1199px) {
  .crypto-main-card .deposit-wrap img {
    width: 30%;
  }
}

.portfolio-card .dropdown-toggle {
  width: 80px;
}

.btn-white {
  color: #7366ff;
  background-color: #fff;
}

.radial-progress-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}
.radial-progress-card.card-body {
  padding: 23px 20px;
}
@media (max-width: 1199px) {
  .radial-progress-card.card-body {
    padding: 30px 20px;
  }
}
.radial-progress-card p {
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  display: -webkit-box;
}
.radial-progress-card h6, .radial-progress-card .h6 {
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  display: -webkit-box;
}
.radial-progress-card .sale-details {
  margin: 10px 0;
}
.radial-progress-card .sale-details svg {
  width: 15px;
  height: 15px;
  vertical-align: middle;
}
.radial-progress-card .radial-chart-wrap {
  width: 110px;
  margin-right: -25px;
}
[dir=rtl] .radial-progress-card .radial-chart-wrap {
  margin-right: unset;
  margin-left: -25px;
}
@media (max-width: 1820px) {
  .radial-progress-card .radial-chart-wrap {
    margin-right: -12px;
  }
  [dir=rtl] .radial-progress-card .radial-chart-wrap {
    margin-left: -12px;
  }
}
.radial-progress-card .radial-chart-wrap .apexcharts-canvas .apexcharts-datalabel-label {
  display: none;
}

.transaction-table table tr:first-child td {
  padding-top: 0;
}
.transaction-table table tr td:first-child {
  min-width: unset;
}
@media (max-width: 1775px) {
  .transaction-table table tr td:first-child {
    min-width: 130px;
  }
}
.transaction-table table tr td:last-child {
  text-align: right;
  min-width: 60px;
}
.transaction-table table tr,
.transaction-table table td {
  border-style: dashed;
}

.custom-tab {
  background: var(--light2);
  padding: 4px;
  border-radius: 5px;
}
.custom-tab.nav-tabs {
  border: none;
}
.custom-tab.nav-tabs .nav-link {
  border: none;
  padding: 6px 12px;
  color: var(--chart-text-color);
}
.custom-tab.nav-tabs .nav-link.active {
  color: var(--theme-default);
}

.market-chart-container {
  margin: -24px 0 -24px -15px;
}
[dir=rtl] .market-chart-container {
  margin: -24px -15px -24px 0;
}
@media (max-width: 575px) {
  .market-chart-container {
    margin-bottom: 0;
  }
}

.market-card .balance-card {
  padding: 10px;
}
@media (max-width: 575px) {
  .market-card .custom-tab {
    display: none;
  }
}

.currency-icon {
  width: 34px;
  height: 34px;
  background-color: var(--light2);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.currency-icon.warning svg {
  fill: #ffaa05;
}
.currency-icon.success svg {
  fill: #54ba4a;
}
.currency-icon.primary svg {
  fill: #7366ff;
}
.currency-icon.secondary svg {
  fill: #ff3364;
}
.currency-icon.dark-green svg {
  fill: #1ba27a;
}
.currency-icon.light-blue svg {
  fill: #038de7;
}

.recent-table tr:hover td:first-child h6, .recent-table tr:hover td:first-child .h6 {
  color: var(--theme-default);
}
.recent-table tr:hover .border-icon .social-circle {
  transform: scale(1.02);
  transition: 0.5s;
}
.recent-table tr:hover .currency-icon svg {
  animation: tada 1.5s ease infinite;
}
.recent-table tr:hover .badge-light-primary {
  background-color: var(--theme-default);
  color: #fff;
}

.currency-table .change-currency svg {
  width: 16px;
  height: 16px;
  vertical-align: sub;
}
.currency-table th:nth-child(3),
.currency-table td:nth-child(3) {
  min-width: 110px;
}
.currency-table th:nth-child(4),
.currency-table td:nth-child(4) {
  min-width: 115px;
}

select.crypto-select {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  right: 7px;
  width: 62px;
  background-position: right 0.25rem center;
  padding: 8px;
  border: none;
  font-weight: 500;
  background-size: 8px;
}
[dir=rtl] select.crypto-select {
  right: unset;
  left: 7px;
}
select.crypto-select.warning {
  background-color: rgba(255, 170, 5, 0.1) !important;
  color: #ffaa05 !important;
}
select.crypto-select.primary {
  background-color: rgba(115, 102, 255, 0.1) !important;
  color: #7366ff !important;
}

.crypto-form input::-webkit-outer-spin-button, .crypto-form input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.crypto-form input[type=number] {
  -moz-appearance: textfield;
}

.balance-box {
  text-align: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  background-position: right;
  background-size: cover;
}
.balance-box .balance-img {
  display: inline-block;
  padding: 5px;
  border: 2px solid var(--chart-border);
  border-left-color: #54ba4a;
  border-bottom-color: #54ba4a;
  border-radius: 100%;
  position: relative;
  margin-bottom: 15px;
}
.balance-box .balance-img img {
  background-color: var(--balance-profie-bg);
  border-radius: 100%;
}
.balance-box .balance-img .edit-icon {
  width: 26px;
  height: 26px;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid var(--white);
  background-color: #dfdff4;
  right: 0;
  bottom: 0;
  border-radius: 100%;
}
.balance-box .balance-img .edit-icon svg {
  width: 11px;
  height: 11px;
  fill: #7366ff;
}

.balance-profile ul {
  display: flex;
  justify-content: center;
  gap: 50px;
  margin-top: 16px;
}
@media (max-width: 1660px) {
  .balance-profile ul {
    gap: 25px;
  }
}
.balance-profile ul li {
  position: relative;
}
.balance-profile ul li + li::before {
  position: absolute;
  content: "";
  left: -25px;
  top: 50%;
  height: 40px;
  transform: translateY(-50%);
  border: 1px dashed var(--recent-dashed-border);
}
[dir=rtl] .balance-profile ul li + li::before {
  left: unset;
  right: -25px;
}
@media (max-width: 1660px) {
  .balance-profile ul li + li::before {
    left: -16px;
  }
  [dir=rtl] .balance-profile ul li + li::before {
    right: -16px;
  }
}

@media (max-width: 1399px) {
  .activity-card .appointment-table {
    height: 180px;
  }
}
@media (max-width: 575px) {
  .activity-card .appointment-table {
    height: unset;
  }
}
.activity-card .appointment-table tr td:nth-child(2) {
  min-width: 130px;
}

.balance-item {
  display: flex;
  gap: 10px;
}
.balance-item .balance-icon-wrap {
  width: 40px;
  min-width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}
@media (max-width: 1660px) {
  .balance-item .balance-icon-wrap {
    width: 25px;
    min-width: 25px;
    height: 25px;
    border-radius: 8px;
  }
}
.balance-item .balance-icon-wrap .balance-icon {
  width: 16px;
  height: 16px;
  border-radius: 100%;
}
@media (max-width: 1660px) {
  .balance-item .balance-icon-wrap .balance-icon {
    width: 14px;
    height: 14px;
  }
}
.balance-item .balance-icon-wrap .balance-icon svg {
  color: #fff;
  width: 14px;
  height: 14px;
}
@media (max-width: 1660px) {
  .balance-item .balance-icon-wrap .balance-icon svg {
    width: 12px;
    height: 12px;
    vertical-align: text-top;
  }
}
.balance-item .badge {
  padding: 8px 10px;
}
.balance-item.danger .balance-icon-wrap {
  background-color: rgba(252, 68, 56, 0.1);
}
.balance-item.danger .balance-icon-wrap .balance-icon {
  background-color: #fc4438;
}
.balance-item.success .balance-icon-wrap {
  background-color: rgba(84, 186, 74, 0.1);
}
.balance-item.success .balance-icon-wrap .balance-icon {
  background-color: #54ba4a;
}

.portfolio-chart-container {
  margin-top: -56px;
}
@media (max-width: 1399px) {
  .portfolio-chart-container {
    margin-top: -20px;
  }
}

.portfolio-table .status {
  width: 6px;
  height: 6px;
  border-radius: 100%;
  display: inline-block;
}
.portfolio-table table tr,
.portfolio-table table td {
  border-style: dashed;
}
@media (max-width: 1755px) {
  .portfolio-table table tr td:first-child,
  .portfolio-table table tr th:first-child {
    min-width: 100px;
  }
}
@media (max-width: 1755px) {
  .portfolio-table table tr td:last-child,
  .portfolio-table table tr th:last-child {
    min-width: 128px;
  }
}

/**=====================
     Dashboard 5 CSS Start
==========================**/
.social-img {
  padding: 5px;
  background: var(--white);
  border-radius: 100%;
}
.social-widget .card-body {
  padding: 15px;
}
.social-widget .social-icons {
  min-width: 55px;
  height: 55px;
  background: var(--white);
  box-shadow: 0px 42.1092px 27.8569px rgba(41, 72, 152, 0.0303704), 0px 8.90772px 7.12618px rgba(41, 72, 152, 0.0196296), 0px 2.02448px 3.44162px rgba(41, 72, 152, 0.012037);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 1399px) {
  .social-widget .social-icons {
    min-width: 40px;
    height: 40px;
  }
  .social-widget .social-icons img {
    height: 20px;
  }
}
.social-widget .social-content {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}
.social-widget .social-content .social-chart {
  margin: -34px -42px -13px;
  width: 150px;
}
.social-widget .social-content .social-chart .apexcharts-canvas .apexcharts-datalabels-group .apexcharts-datalabel-label {
  display: none;
}

.follower-chart {
  margin: -20px 0 -20px -34px;
}
@media (max-width: 717px) {
  .follower-chart {
    margin-left: 0;
  }
}

@keyframes wave-speaker {
  0% {
    transform: translateX(5px);
  }
  50% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(5px);
  }
}
.mobile-app-card .card-header {
  background: transparent;
  padding: 20px;
  width: 68%;
}
@media (max-width: 1693px) {
  .mobile-app-card .card-header {
    width: 75%;
  }
}
@media (max-width: 1316px) {
  .mobile-app-card .card-header {
    width: 86%;
  }
}
@media (max-width: 991px) {
  .mobile-app-card .card-header {
    width: 64%;
  }
}
@media (max-width: 350px) {
  .mobile-app-card .card-header {
    width: 75%;
  }
}
.mobile-app-card .card-body {
  margin-top: -10px;
}
@media (max-width: 1199px) {
  .mobile-app-card .card-body {
    margin-top: 26px;
  }
}
@media (max-width: 991px) {
  .mobile-app-card .card-body {
    margin-top: 20px;
  }
}
.mobile-app-card .card-body .wavy {
  width: 26px;
  margin-right: -37px;
  margin-top: -10px;
  animation: wave-speaker 2s ease infinite;
}
.mobile-app-card .purchase-btn {
  padding: 10px 25px;
  min-width: unset;
}

.subscriber-chart-container {
  margin: -22px -10px -24px;
}

.click-widgets .card-body {
  padding: 28px 15px;
}
.click-widgets .click-chart {
  margin: 0;
}

@media (max-width: 1693px) {
  .follower-wrap .card-body,
  .follower-wrap .card-header {
    padding: 22px;
  }
}
.follower-wrap .card-header {
  padding-bottom: 20px;
}

.campaign-list {
  column-count: 2;
  column-gap: 20px;
  margin-bottom: 15px;
}
.campaign-list li {
  position: relative;
}
.campaign-list li + li::before {
  position: absolute;
  content: "";
  width: 1px;
  height: 20px;
  background-color: var(--chart-text-color);
  top: 50%;
  transform: translateY(-50%);
  left: -10px;
  opacity: 0.6;
}
[dir=rtl] .campaign-list li + li::before {
  left: unset;
  right: -10px;
}
.campaign-list .campaign-box {
  background: linear-gradient(180deg, var(--course-light-btn) 0%, rgba(242, 243, 247, 0) 100%);
  border-radius: 5px;
  padding: 6px 10px;
}

.social-circle {
  width: 34px;
  height: 34px;
  border-width: 1px;
  border-style: solid;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.5s;
}

.campaign-table table tr:hover td:nth-child(2) {
  color: var(--theme-default);
}
.campaign-table .border-icon > div {
  border-left: 2px solid #2f84f4;
  padding-left: 15px;
}
[dir=rtl] .campaign-table .border-icon > div {
  padding-left: unset;
  padding-right: 15px;
}
.campaign-table .facebook > div {
  border-left: 2px solid #2f84f4;
}
[dir=rtl] .campaign-table .facebook > div {
  border-left: unset;
  border-right: 2px solid #2f84f4;
}
.campaign-table .facebook .social-circle {
  background-color: rgba(47, 132, 244, 0.1);
  border-color: #2f84f4;
  color: #2f84f4;
}
.campaign-table .instagram > div {
  border-left: 2px solid #fc971e;
}
[dir=rtl] .campaign-table .instagram > div {
  border-left: unset;
  border-right: 2px solid #fc971e;
}
.campaign-table .instagram .social-circle {
  background-color: rgba(252, 151, 30, 0.1);
  border-color: #fc971e;
  color: #fc971e;
}
.campaign-table .pinterest > div {
  border-left: 2px solid #ff3364;
}
[dir=rtl] .campaign-table .pinterest > div {
  border-left: unset;
  border-right: 2px solid #ff3364;
}
.campaign-table .pinterest .social-circle {
  background-color: rgba(255, 51, 100, 0.1);
  border-color: #ff3364;
  color: #ff3364;
}
.campaign-table .plus-btn {
  width: 24px;
  border-radius: 5px;
  background-color: transparent;
  border: 1px solid var(--body-font-color);
  color: var(--body-font-color);
}
.campaign-table .plus-btn:hover {
  background-color: var(--body-font-color);
  color: var(--white);
}
.campaign-table .twitter > div {
  border-left: 2px solid #57b9f6;
}
[dir=rtl] .campaign-table .twitter > div {
  border-left: unset;
  border-right: 2px solid #57b9f6;
}
.campaign-table .twitter .social-circle {
  background-color: rgba(87, 185, 246, 0.1);
  border-color: #57b9f6;
  color: #57b9f6;
}
.campaign-table .you-tube > div {
  border-left: 2px solid #f42f2f;
}
[dir=rtl] .campaign-table .you-tube > div {
  border-left: unset;
  border-right: 2px solid #f42f2f;
}
.campaign-table .you-tube .social-circle {
  background-color: rgba(244, 47, 47, 0.1);
  border-color: #f42f2f;
  color: #f42f2f;
}
.campaign-table .badge-light-primary,
.campaign-table .badge-light-light {
  padding: 4px 12px;
}
.campaign-table tr td,
.campaign-table tr th {
  border-style: dashed;
}
.campaign-table tr td:nth-child(5),
.campaign-table tr th:nth-child(5) {
  min-width: 190px;
}
.campaign-table .recent-table tr td:nth-child(2),
.campaign-table .recent-table tr th:nth-child(2) {
  min-width: 120px;
}
.campaign-table .recent-table tr td:first-child,
.campaign-table .recent-table tr th:first-child {
  min-width: 110px;
}
.campaign-table .recent-table tr td:nth-child(3), .campaign-table .recent-table tr td:last-child,
.campaign-table .recent-table tr th:nth-child(3),
.campaign-table .recent-table tr th:last-child {
  min-width: 50px;
}

.view-container .apexcharts-canvas .apexcharts-grid-row {
  stroke-width: 15px;
  stroke: var(--white);
}
.view-container .apexcharts-canvas .apexcharts-gridlines-vertical line,
.view-container .apexcharts-canvas .apexcharts-gridlines-vertical react,
.view-container .apexcharts-canvas .apexcharts-gridlines-horizontal line,
.view-container .apexcharts-canvas .apexcharts-gridlines-horizontal react {
  stroke-width: 15px;
  stroke: var(--white);
}
.view-container .apexcharts-canvas .apexcharts-point-annotations circle {
  outline: 25px solid #f0effd;
  border-radius: 100%;
}
@media (max-width: 480px) {
  .view-container .apexcharts-canvas .apexcharts-point-annotations circle {
    outline-width: 10px;
  }
}

/**=====================
53. Dashboard CSS Start
==========================**/
.form-control-plaintext {
  width: auto !important;
}

@keyframes bounce-effect {
  0% {
    transform: translateY(0);
    transition: 0.5s;
  }
  50% {
    transform: translateY(-5px);
    transition: 0.5s;
  }
  100% {
    transform: translateY(0);
    transition: 0.5s;
  }
}
@keyframes round {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
.badge-light-primary {
  background-color: white;
  color: #7366ff;
}

.badge-light-secondary {
  background-color: rgb(100%, 96%, 96.9607843137%);
  color: #ff3364;
}

.badge-light-success {
  background-color: rgb(84.9251764706%, 93.9171764706%, 84.0436078431%);
  color: #54ba4a;
}

.badge-light-danger {
  background-color: rgb(99.9522422831%, 97.0231023102%, 96.8320714424%);
  color: #fc4438;
}

.badge-light-info {
  background-color: rgb(82.7195011896%, 95.846747067%, 99.5550086143%);
  color: #16c7f9;
}

.badge-light-light {
  background-color: rgb(71.8687306502%, 71.8687306502%, 78.6410732714%);
  color: #52526c;
}

.badge-light-dark {
  background-color: rgb(51.6965365585%, 56.2968664101%, 66.2642477552%);
  color: #2c323f;
}

.badge-light-warning {
  background-color: rgb(100%, 92.5066666667%, 77.9607843137%);
  color: #ffaa05;
}

.badge-light-light {
  background-color: rgb(91.1950464396%, 91.1950464396%, 93.3147574819%);
}

.badge-light-primary {
  background-color: rgba(115, 102, 255, 0.1);
}

.badge-light-success {
  background-color: rgba(84, 186, 74, 0.15);
}

.badge-light-secondary {
  background-color: rgba(255, 51, 100, 0.08);
}

.table thead th {
  border-bottom: 2px solid #ecf3fa;
}

@media (max-width: 1712px) {
  .overall-card .balance-card {
    padding: 12px;
  }
}
@media (max-width: 1662px) and (min-width: 1600px) {
  .overall-card .col-xl-9 {
    width: 73%;
  }
  .overall-card .col-xl-3 {
    width: 27%;
  }
}
@media (max-width: 1650px) and (min-width: 1600px) {
  .overall-card .col-xl-9 {
    width: 72%;
  }
  .overall-card .col-xl-3 {
    width: 28%;
  }
}
@media (max-width: 1600px) and (min-width: 1500px) {
  .overall-card .col-xl-9 {
    width: 70%;
  }
  .overall-card .col-xl-3 {
    width: 30%;
  }
}
@media (max-width: 1500px) and (min-width: 1200px) {
  .overall-card .col-xl-9 {
    width: 65%;
  }
  .overall-card .col-xl-3 {
    width: 35%;
  }
}

/* Clock styles */
.clockbox {
  margin-bottom: -5px;
}
.clockbox svg {
  width: 45px;
  height: 45px;
}
@media (max-width: 767px) {
  .clockbox svg {
    height: 36px;
  }
}

.clockbox,
#clock {
  width: 100%;
}

.circle {
  fill: #fff;
  stroke: rgba(255, 255, 255, 0.4);
  stroke-width: 80px;
  stroke-miterlimit: 10;
}

.mid-circle {
  fill: #000;
}

.hour-marks {
  fill: none;
  stroke: #52526c;
  stroke-width: 9;
  stroke-miterlimit: 10;
}

.hour-hand {
  fill: none;
  stroke: #ff7e00;
  stroke-width: 17;
  stroke-miterlimit: 10;
}

.minute-hand {
  fill: none;
  stroke: #ff7e00;
  stroke-width: 11;
  stroke-miterlimit: 10;
}

.second-hand {
  fill: none;
  stroke: #ffaa05;
  stroke-width: 15px;
  stroke-miterlimit: 10;
}

.sizing-box {
  fill: none;
}

#hour,
#minute,
#second {
  transform-origin: 300px 300px;
  transition: transform 0.5s ease-in-out;
}

@media (min-width: 1400px) {
  .widget-grid .height-equal {
    min-height: unset !important;
  }
}
@media (min-width: 1400px) {
  .widget-grid > .col-xxl-auto {
    width: 22.22%;
  }
}

.order-chart > div {
  margin-top: -25px;
  margin-bottom: -43px;
}
.order-chart svg path {
  clip-path: inset(7% 0% 0% 0% round 0.6rem);
}

.growth-wrap .card-header {
  position: relative;
  z-index: 1;
}

.growth-wrapper > div {
  margin-top: -54px;
  margin-bottom: -25px;
}
@media (max-width: 1481px) {
  .growth-wrapper > div {
    margin-top: -50px;
  }
}

.profit-chart > div {
  margin-top: -45px;
  margin-bottom: -48px;
}
.profit-chart .apexcharts-canvas .apexcharts-tooltip-text-label {
  display: none;
}

.widget-1 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
  background-size: cover;
  margin-bottom: 25px;
}
.widget-1 i {
  font-weight: 700;
  font-size: 12px;
}
.widget-1 .f-w-500 {
  display: flex;
  align-items: center;
}
@media (max-width: 1580px) and (min-width: 1200px) {
  .widget-1 .f-w-500 {
    display: none;
  }
}
.widget-1 .card-body {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 18px 25px;
}
@media (max-width: 1720px) {
  .widget-1 .card-body {
    padding: 18px;
  }
}
.widget-1 .widget-round {
  position: relative;
  display: inline-block;
  border-width: 1px;
  border-style: solid;
  border-radius: 100%;
}
.widget-1 .widget-round .bg-round {
  width: 56px;
  height: 56px;
  box-shadow: 1px 2px 21px -2px rgba(214, 214, 227, 0.83);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  margin: 6px;
  position: relative;
  z-index: 1;
}
.widget-1 .widget-round .bg-round svg {
  width: 24px;
  height: 24px;
}
.widget-1 .widget-round .bg-round .half-circle {
  height: 52px;
  position: absolute;
  left: -9px;
  width: 35px;
  bottom: -8px;
  background: #fff;
  z-index: -1;
}
@media (max-width: 1600px) {
  .widget-1 .widget-round .bg-round {
    width: 40px;
    height: 40px;
  }
  .widget-1 .widget-round .bg-round svg {
    width: 22px;
    height: 22px;
  }
  .widget-1 .widget-round .bg-round .half-circle {
    height: 40px;
    left: -10px;
    width: 30px;
    bottom: -8px;
  }
}
.widget-1 .widget-round.primary {
  border-color: var(--theme-default);
}
.widget-1 .widget-round.secondary {
  border-color: var(--theme-secondary);
}
.widget-1 .widget-round.success {
  border-color: #54ba4a;
}
.widget-1 .widget-round.warning {
  border-color: #ffaa05;
}
.widget-1 .widget-content {
  display: flex;
  align-items: center;
  gap: 15px;
}
@media (max-width: 1600px) {
  .widget-1 .widget-content {
    gap: 10px;
  }
}
.widget-1 .widget-content h4, .widget-1 .widget-content .h4 {
  margin-bottom: 4px;
}
.widget-1:hover {
  transform: translateY(-5px);
  transition: 0.5s;
}
.widget-1:hover .widget-round .svg-fill:not(.half-circle) {
  animation: tada 1.5s ease infinite;
}

.widget-with-chart .card-body {
  align-items: center;
}

.profile-box {
  background: linear-gradient(103.75deg, #33b1ee -13.9%, var(--theme-default) 79.68%);
  color: #fff;
}
.profile-box .cartoon {
  position: absolute;
  bottom: -15px;
  right: 20px;
  animation: bounce-effect 5s infinite ease-in;
}
[dir=rtl] .profile-box .cartoon {
  right: unset !important;
  left: 5px;
}
@media (max-width: 1660px) {
  .profile-box .cartoon {
    right: 30px;
    text-align: right;
  }
  [dir=rtl] .profile-box .cartoon {
    left: -6px;
    text-align: left;
  }
  .profile-box .cartoon img {
    width: 80%;
  }
}
@media (max-width: 1500px) {
  .profile-box .cartoon img {
    width: 60%;
  }
}
@media (max-width: 767px) {
  .profile-box .cartoon {
    right: 10px;
  }
  [dir=rtl] .profile-box .cartoon {
    left: -10px;
  }
  .profile-box .cartoon img {
    width: 52%;
  }
}
@media (max-width: 575px) {
  .profile-box .cartoon {
    right: 30px;
  }
  [dir=rtl] .profile-box .cartoon {
    left: 10px;
  }
  .profile-box .cartoon img {
    width: 48%;
  }
}
.profile-box .greeting-user p {
  width: 60%;
}
@media (max-width: 1500px) {
  .profile-box .greeting-user p {
    width: 70%;
  }
}
@media (max-width: 1199px) {
  .profile-box .greeting-user p {
    width: 80%;
  }
}
@media (max-width: 767px) {
  .profile-box .greeting-user p {
    width: 98%;
  }
}
@media (max-width: 600px) {
  .profile-box .greeting-user p {
    width: 100%;
  }
}
@media (max-width: 575px) {
  .profile-box .greeting-user p {
    width: 98%;
  }
}
.profile-box .whatsnew-btn {
  margin-top: 3.5rem;
}
@media (max-width: 1500px) {
  .profile-box .whatsnew-btn {
    margin-top: 1.7rem;
  }
}
@media (max-width: 991px) {
  .profile-box .whatsnew-btn {
    margin-top: 3.5rem;
  }
}
@media (max-width: 638px) {
  .profile-box .whatsnew-btn {
    margin-top: 2rem;
  }
}
@media (max-width: 767px) {
  .profile-box .whatsnew-btn .btn {
    padding: 6px 10px;
  }
}

.header-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4px;
}
.header-top a i {
  font-size: 14px;
  margin-bottom: -2px;
}
.header-top a.btn {
  padding: 8px 12px;
}
@media (max-width: 575px) {
  .header-top a.btn {
    padding: 5px;
  }
}
.header-top a.btn.badge-light-primary:hover {
  background-color: var(--theme-default);
}

.user-details {
  display: flex;
  align-items: center;
  gap: 15px;
}
@media (max-width: 1399px) {
  .user-details {
    gap: 6px;
  }
}
.user-details .customers {
  width: 200px;
}
@media (max-width: 575px) {
  .user-details {
    flex-wrap: wrap;
  }
}

.papernote-wrap .banner-img {
  border-radius: 15px;
  width: 100%;
}
.papernote-wrap .note-labels {
  display: flex;
  align-items: center;
}
.papernote-wrap .note-labels > * {
  padding: 3px 0;
}
.papernote-wrap .note-labels ul {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
@media (max-width: 575px) {
  .papernote-wrap .note-labels ul {
    gap: 4px;
  }
}
.papernote-wrap .note-labels .badge {
  font-size: 14px;
  padding: 6px 12px;
}
@media (max-width: 575px) {
  .papernote-wrap .note-labels .badge {
    font-size: 12px;
    padding: 5px 6px;
  }
}
.papernote-wrap .note-labels .last-label {
  padding-left: 16px;
  margin-left: 16px;
  border-left: 1px dashed rgba(82, 82, 108, 0.7);
}
[dir=rtl] .papernote-wrap .note-labels .last-label {
  padding-left: unset;
  margin-left: unset;
  margin-right: 16px;
  padding-right: 16px;
  border-left: none;
  border-right: 1px dashed rgba(82, 82, 108, 0.7);
}
@media (max-width: 575px) {
  .papernote-wrap .note-labels .last-label {
    padding-left: 8px;
    margin-left: 8px;
  }
  [dir=rtl] .papernote-wrap .note-labels .last-label {
    margin-right: 8px;
    padding-right: 8px;
  }
}
.papernote-wrap .light-card {
  width: 40px;
  height: 40px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--light2);
  border: 1px solid rgba(82, 82, 108, 0.2);
}

.appointment-sec .card-header-right-icon select {
  background-color: rgba(115, 102, 255, 0.08) !important;
  border: none;
  color: var(--theme-default) !important;
  width: auto !important;
  height: 32px !important;
  border-radius: 10px;
  padding: 5px 10px;
  line-height: 50px !important;
  font-weight: 500;
  border: none;
  outline: none !important;
}
.appointment-sec .card-header-right-icon select:hover {
  background-color: rgba(115, 102, 255, 0.08) !important;
  color: var(--theme-default) !important;
}
.appointment-sec .bottom-btn {
  text-align: center;
}
.appointment-sec .bottom-btn a {
  font-family: Roboto, sans-serif;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.3px;
  text-decoration-line: underline;
  text-transform: uppercase;
}

.notification ul {
  position: relative;
}
.notification ul::before {
  position: absolute;
  content: "";
  border: 1px dashed #52526c;
  opacity: 0.3;
  top: 12px;
  left: 2px;
  height: calc(100% - 12px);
}
[dir=rtl] .notification ul::before {
  left: unset;
  right: 2px;
}
.notification li {
  padding-bottom: 22px !important;
  border: none !important;
}
.notification div[class*=activity-dot-] {
  margin-top: 12px;
  animation: round 1.3s ease-in-out infinite;
}
.notification .card .d-flex .w-100 p .badge {
  color: #fff;
  margin-left: 10px;
  font-weight: 500;
}
.notification .card .d-flex .w-100 h6, .notification .card .d-flex .w-100 .h6 {
  margin-bottom: 5px;
  position: relative;
}
.notification .card .d-flex .w-100 h6 ~ p, .notification .card .d-flex .w-100 .h6 ~ p {
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-emphasis: inherit;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  width: 260px;
}
@media (max-width: 767px) {
  .notification .card .d-flex .w-100 h6 ~ p, .notification .card .d-flex .w-100 .h6 ~ p {
    -webkit-line-clamp: unset;
    text-emphasis: unset;
    white-space: unset;
    text-overflow: unset;
    display: block;
    width: unset;
    overflow: visible;
  }
}
@keyframes round {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
.notification .card .d-flex .w-100 span {
  color: #52526c;
}
.notification .card .d-flex:nth-child(2) .media-body h6 .dot-notification, .notification .card .d-flex:nth-child(2) .media-body .h6 .dot-notification {
  background-color: #ffaa05;
  border: 5px solid rgb(100%, 87.0666666667%, 61.9607843137%);
}
.notification .card .d-flex:last-child {
  margin-bottom: 0 !important;
}
.notification .date-content {
  padding: 4px 8px;
  border-radius: 5px;
}

.schedule-container > div {
  margin-bottom: -40px;
}
.schedule-container svg path {
  clip-path: inset(1% 0% 0% 0% round 1.5rem);
}

.purchase-card {
  text-align: center;
  margin-top: 200px;
}
@media (max-width: 1560px) {
  .purchase-card {
    margin-top: 170px;
  }
}
@media (max-width: 1399px) {
  .purchase-card {
    margin-top: 160px;
  }
}
@media (max-width: 500px) {
  .purchase-card {
    margin-top: 110px;
  }
}
@media (max-width: 420px) {
  .purchase-card {
    margin-top: 90px;
  }
}
.purchase-card img {
  margin-top: -208px;
}
@media (max-width: 1560px) {
  .purchase-card img {
    margin-top: -170px;
  }
}
@media (max-width: 1399px) {
  .purchase-card img {
    width: 70%;
    margin: -160px auto 0 auto;
  }
}
@media (max-width: 1366px) {
  .purchase-card img {
    width: 76%;
  }
}
@media (max-width: 1199px) {
  .purchase-card img {
    width: 86%;
  }
}
@media (max-width: 991px) {
  .purchase-card img {
    width: 72%;
  }
}
@media (max-width: 767px) {
  .purchase-card img {
    width: 50%;
  }
}
@media (max-width: 500px) {
  .purchase-card img {
    margin-top: -110px;
  }
}
@media (max-width: 420px) {
  .purchase-card img {
    margin-top: -90px;
    width: 60%;
  }
}
.purchase-card .purchase-btn {
  min-width: auto;
}

.user-list {
  column-count: 2;
  column-rule-style: dashed;
  column-rule-color: rgba(82, 82, 108, 0.7);
  column-gap: 120px;
  column-rule-width: 1px;
}
@media (max-width: 1780px) {
  .user-list {
    column-gap: 80px;
  }
}
@media (max-width: 1660px) {
  .user-list {
    column-gap: 40px;
  }
}
@media (max-width: 360px) {
  .user-list {
    column-gap: 25px;
  }
}
.user-list li {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
}
@media (max-width: 1540px) {
  .user-list li {
    gap: 5px;
  }
}
.user-list li i {
  font-size: 12px;
  font-weight: 700;
}
@media (max-width: 360px) {
  .user-list li h5, .user-list li .h5 {
    font-size: 16px;
  }
}
@media (max-width: 360px) {
  .user-list li span {
    font-size: 13px;
  }
}
.user-list li:hover .user-box svg {
  animation: tada 1.5s ease infinite;
}
.user-list .user-icon {
  border-radius: 100%;
  display: inline-block;
}
.user-list .user-icon .user-box {
  margin: 3px;
  width: 47px;
  height: 47px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 1540px) {
  .user-list .user-icon .user-box {
    width: 30px;
    height: 30px;
  }
  .user-list .user-icon .user-box svg {
    width: 18px;
    height: 18px;
  }
}
.user-list .user-icon.primary {
  border: 1px solid #7366ff;
}
.user-list .user-icon.primary .user-box {
  background: rgb(90.8496732026%, 90%, 100%);
}
.user-list .user-icon.success {
  border: 1px solid #54ba4a;
}
.user-list .user-icon.success .user-box {
  background: rgb(87.6611764706%, 95.0211764706%, 86.9396078431%);
}

.appointment-table table tr td {
  position: relative;
  border-top: none;
  padding: 15px 0;
  vertical-align: middle;
}
.appointment-table table tr td:first-child {
  width: 50px;
}
.appointment-table table tr td .status-circle {
  top: 1px;
  left: 35px;
  border-width: 3px;
}
.appointment-table table tr td p,
.appointment-table table tr td .btn {
  font-weight: 500;
  font-size: 12px;
}
.appointment-table table tr td .btn {
  padding: 4px 12px;
}
.appointment-table table tr .img-content-box a {
  color: var(--body-font-color);
  transition: 0.5s;
  display: inline-block !important;
}
.appointment-table table tr .img-content-box span {
  display: block;
}
.appointment-table table tr:hover .img-content-box a {
  color: var(--theme-default);
  transition: 0.5s;
}
.appointment-table table tr:first-child td {
  padding-top: 0 !important;
}
.appointment-table table tr:last-child td {
  padding-bottom: 0 !important;
}
.appointment-table.customer-table table tr td {
  padding: 10px 0;
}
.appointment-table.customer-table table tr td img {
  min-width: 40px;
}

.icon-box {
  width: 50px;
  height: 32px;
  background-color: rgba(115, 102, 255, 0.08);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon-box i {
  color: var(--theme-default);
  font-size: 22px;
}
.icon-box svg {
  stroke: var(--theme-default);
}

.balance-card {
  display: flex;
  padding: 15px;
  border-radius: 5px;
  gap: 15px;
  transition: 0.5s;
}
@media (max-width: 1199px) {
  .balance-card {
    gap: 8px;
  }
}
.balance-card .svg-box {
  width: 43px;
  height: 43px;
  background: #fff;
  box-shadow: 0px 71.2527px 51.5055px rgba(229, 229, 245, 0.189815), 0px 42.3445px 28.0125px rgba(229, 229, 245, 0.151852), 0px 21.9866px 14.2913px rgba(229, 229, 245, 0.125), 0px 8.95749px 7.16599px rgba(229, 229, 245, 0.0981481), 0px 2.03579px 3.46085px rgba(229, 229, 245, 0.0601852);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 1199px) {
  .balance-card .svg-box {
    width: 35px;
    height: 35px;
  }
}
.balance-card .svg-box svg {
  height: 20px;
  fill: rgba(82, 82, 108, 0.85);
}
@media (max-width: 1199px) {
  .balance-card .svg-box svg {
    height: 17px;
  }
}

.btn-light-secondary {
  background-color: rgba(var(--theme-secondary), 0.1);
  font-size: 12px;
  padding: 6px 12px;
  font-weight: 600;
}

.crm-activity > li + li {
  border-top: 1px solid #efefef;
  margin-top: 10px;
  padding-top: 10px;
}
.crm-activity > li + li h6, .crm-activity > li + li .h6 {
  font-size: 14px;
  line-height: 18px;
  margin-bottom: 5px;
}
.crm-activity > li h6, .crm-activity > li .h6 {
  font-size: 14px;
}
.crm-activity span {
  font-size: 40px;
}
.crm-activity ul.dates h6, .crm-activity ul.dates .h6 {
  color: #2f2f3b;
}
.crm-activity ul.dates li {
  color: #52526c;
  font-size: 12px;
  display: inline-block;
  line-height: 1;
}
.crm-activity ul.dates li + li {
  border-left: 1px solid #efefef;
  padding-left: 10px;
  margin-left: 5px;
}

.fill-primary {
  fill: #7366ff;
}

.fill-secondary {
  fill: #ff3364;
}

.fill-success {
  fill: #54ba4a;
}

.fill-warning {
  fill: #ffaa05;
}

.fill-info {
  fill: #16c7f9;
}

.fill-danger {
  fill: #fc4438;
}

.ecommerce-widget {
  box-shadow: none;
  border: 1px solid #f1f3ff !important;
  border-radius: 5px;
}
.ecommerce-widget .total-num {
  color: #2f2f3b;
  margin: 0;
  letter-spacing: 1px;
}
.ecommerce-widget .total-num span {
  color: #000;
}
.ecommerce-widget .row {
  align-items: center;
}
.ecommerce-widget .progress-showcase {
  margin-top: 30px;
}
.ecommerce-widget span {
  color: #52526c;
  margin: 0;
  cursor: pointer;
}
.ecommerce-widget .icon {
  color: #efefef;
  font-size: 40px;
}
.ecommerce-widget .flot-chart-container {
  height: 100px;
  padding: 0;
  margin: 0;
  border: transparent;
}
.ecommerce-widget .morris-default-style {
  display: none !important;
}
.ecommerce-widget svg {
  filter: drop-shadow(12px 12px 7px rgba(0, 0, 0, 0.3));
}

.redial-social-widget {
  border-radius: 100%;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 25px;
  margin: 0 auto;
  background-image: linear-gradient(90deg, #f4f4f4 50%, transparent 50%, transparent), linear-gradient(90deg, #ecf3fa 50%, #f4f4f4 50%, #f4f4f4);
}
.redial-social-widget i {
  background-color: #fff;
  height: 80px;
  width: 80px;
  border-radius: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.redial-social-widget.radial-bar-70 {
  background-image: linear-gradient(342deg, var(--theme-default) 50%, transparent 50%, transparent), linear-gradient(270deg, var(--theme-default) 50%, #f4f4f4 50%, #f4f4f4);
}

.browser-widget:hover img {
  filter: grayscale(0%);
  transition: all 0.3s ease;
  transform: scale(1.1) rotate(5deg);
}
.browser-widget img {
  height: 80px;
  filter: grayscale(100%);
  transform: scale(1) rotate(0deg);
  transition: all 0.3s ease;
}
.browser-widget .media-body {
  text-align: center;
  column-count: 3;
  column-rule: 1px solid #f4f4f4;
}
.browser-widget .media-body p {
  margin-bottom: 5px;
}
.browser-widget .media-body span {
  margin-bottom: 0;
  color: #52526c;
}
.browser-widget .media-body h4, .browser-widget .media-body .h4 {
  color: #2f2f3b;
  margin-bottom: 0;
  font-size: 18px;
}
.browser-widget .media-body h4 span, .browser-widget .media-body .h4 span {
  color: #333333;
}

.testimonial i {
  font-size: 60px;
  color: rgba(43, 43, 43, 0.7);
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0.1;
  z-index: -1;
}
.testimonial p {
  color: #52526c;
  font-style: italic;
  margin-bottom: 30px;
  margin-top: 30px;
}
.testimonial h5, .testimonial .h5 {
  color: #2f2f3b;
  padding-top: 10px;
}
.testimonial span {
  color: #52526c;
}
.testimonial img {
  margin: 0 auto;
}

.widget-charts .widget-1 .card-body {
  padding: 30px 25px;
}

.chart-widget-top #chart-widget1,
.chart-widget-top #chart-widget2,
.chart-widget-top #chart-widget3 {
  margin-bottom: -14px;
}
.chart-widget-top #chart-widget1 .apexcharts-xaxistooltip,
.chart-widget-top #chart-widget2 .apexcharts-xaxistooltip,
.chart-widget-top #chart-widget3 .apexcharts-xaxistooltip {
  display: none;
}
.chart-widget-top span {
  color: #6c757d;
}

.bar-chart-widget .apexcharts-legend {
  bottom: 0 !important;
}
.bar-chart-widget .apexcharts-legend .apexcharts-legend-series {
  margin: 0 10px !important;
}
.bar-chart-widget .apexcharts-legend .apexcharts-legend-marker {
  margin-right: 5px;
}
.bar-chart-widget .top-content {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.bar-chart-widget .earning-details {
  height: 100%;
  align-items: center;
  justify-content: center;
  text-align: center;
  display: flex;
  letter-spacing: 1px;
}
.bar-chart-widget .earning-details i {
  font-size: 230px;
  position: absolute;
  opacity: 0.1;
  right: -30px;
  top: 0;
}
.bar-chart-widget .earning-details i:hover {
  transform: rotate(-5deg) scale(1.1);
  transition: all 0.3s ease;
}
.bar-chart-widget .num {
  font-weight: 600;
}
.bar-chart-widget .num .color-bottom {
  color: #000;
}

.skill-chart {
  margin-bottom: -48px;
}
.skill-chart .apexcharts-legend .apexcharts-legend-series span {
  display: block;
}
.skill-chart .apexcharts-legend .apexcharts-legend-series .apexcharts-legend-text {
  margin: 10px 0 20px;
}

.progress-chart {
  margin: -11px 0 -20px;
}
.progress-chart .apexcharts-canvas svg path,
.progress-chart .apexcharts-canvas svg rect {
  clip-path: inset(1% 0% 0% 0% round 1rem);
}

.bottom-content span {
  color: #52526c;
}
.bottom-content .block-bottom {
  display: block;
}

@keyframes am-moving-dashes {
  100% {
    stroke-dashoffset: -30px;
  }
}
@keyframes am-pulsating {
  0% {
    stroke-opacity: 1;
    stroke-width: 0;
  }
  100% {
    stroke-opacity: 0;
    stroke-width: 50px;
  }
}
@keyframes am-draw {
  0% {
    stroke-dashoffset: 500%;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
.serial-chart .chart-container {
  width: 100%;
  height: 500px;
}
.serial-chart .chart-container .lastBullet {
  animation: am-pulsating 1s ease-out infinite;
}
.serial-chart .chart-container .amcharts-graph-column-front {
  transition: all 0.3s 0.3s ease-out;
}
.serial-chart .chart-container .amcharts-graph-column-front:hover {
  fill: var(--theme-secondary);
  stroke: var(--theme-secondary);
  transition: all 0.3s ease-out;
}
.serial-chart .chart-container .amcharts-graph-g3 {
  stroke-linejoin: round;
  stroke-linecap: round;
  stroke-dasharray: 0;
  stroke-dashoffset: 0;
  animation: am-draw 40s;
}
.serial-chart .chart-container .amcharts-graph-g2 .amcharts-graph-stroke {
  stroke-dasharray: 3px 3px;
  stroke-linejoin: round;
  stroke-linecap: round;
  animation: am-moving-dashes 1s linear infinite;
}

.chart-container .apexcharts-xaxis-label,
.chart-container .apexcharts-yaxis-label {
  font-size: 14px !important;
  color: #6c757d !important;
}
.chart-container .apexcharts-xaxis-annotations rect {
  clip-path: inset(1% 0% 0% 0% round 0.2rem);
}

.crypto-chart {
  margin-left: -20px;
}
.crypto-chart .apexcharts-tooltip-title {
  display: none;
}
.crypto-chart .apexcharts-tooltip-series-group:last-child, .crypto-chart .apexcharts-tooltip-series-group.active {
  padding-bottom: 0;
}

.speed-chart .chart-container {
  width: 100%;
  height: 530px;
}
.speed-chart .content {
  margin-top: -200px;
  margin-bottom: 20px;
}
.speed-chart .content h4, .speed-chart .content .h4 {
  font-weight: 600;
  padding-top: 2px;
}

.status-widget svg {
  width: 20px;
  height: 20px;
  vertical-align: text-top;
}
.status-widget .card .card-header h5, .status-widget .card .card-header .h5 {
  line-height: 1.38;
}
.status-widget .status-chart {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  overflow: hidden;
}

.small-chart-widget .chart-container {
  height: 311px;
  padding: 0;
  margin: 0;
  border: none;
}

.small-chart-widget .card .card-body {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.donut-chart-widget .chart-container {
  height: 300px;
  border: 0;
  margin: 0;
  padding: 0;
}

.status-details h4, .status-details .h4 {
  font-weight: 600;
}
.status-details h4 span, .status-details .h4 span {
  color: inherit;
}
.status-details span {
  color: #52526c;
}

.status-chart .chart-container {
  height: 200px;
  border: 0;
  padding: 0;
  margin: 0;
}

.map-chart .chart-container {
  width: 100%;
  height: 500px;
}

.serial-chart {
  width: 100%;
}

.live-products,
.turnover,
.uses,
.monthly {
  height: 300px;
}

.live-products .ct-series-a .ct-area,
.live-products .ct-series-a .ct-point,
.live-products .ct-series-a .ct-line,
.live-products .ct-series-a .ct-bar,
.live-products .ct-series-a .ct-slice-donut {
  stroke: rgba(255, 255, 255, 0.77);
}
.live-products .ct-label {
  fill: #fff;
  color: #fff;
}
.live-products .ct-grid {
  stroke: rgba(255, 255, 255, 0.7);
}

.turnover .ct-series-a .ct-area,
.turnover .ct-series-a .ct-point,
.turnover .ct-series-a .ct-line,
.turnover .ct-series-a .ct-bar,
.turnover .ct-series-a .ct-slice-donut,
.uses .ct-series-a .ct-area,
.uses .ct-series-a .ct-point,
.uses .ct-series-a .ct-line,
.uses .ct-series-a .ct-bar,
.uses .ct-series-a .ct-slice-donut,
.monthly .ct-series-a .ct-area,
.monthly .ct-series-a .ct-point,
.monthly .ct-series-a .ct-line,
.monthly .ct-series-a .ct-bar,
.monthly .ct-series-a .ct-slice-donut {
  stroke: rgb(255, 255, 255);
  fill: transparent;
}
.turnover .ct-series-b .ct-area,
.turnover .ct-series-b .ct-point,
.turnover .ct-series-b .ct-line,
.turnover .ct-series-b .ct-bar,
.turnover .ct-series-b .ct-slice-donut,
.uses .ct-series-b .ct-area,
.uses .ct-series-b .ct-point,
.uses .ct-series-b .ct-line,
.uses .ct-series-b .ct-bar,
.uses .ct-series-b .ct-slice-donut,
.monthly .ct-series-b .ct-area,
.monthly .ct-series-b .ct-point,
.monthly .ct-series-b .ct-line,
.monthly .ct-series-b .ct-bar,
.monthly .ct-series-b .ct-slice-donut {
  stroke: rgba(255, 255, 255, 0.7);
  fill: transparent;
}
.turnover .ct-series-c .ct-area,
.turnover .ct-series-c .ct-point,
.turnover .ct-series-c .ct-line,
.turnover .ct-series-c .ct-bar,
.turnover .ct-series-c .ct-slice-donut,
.uses .ct-series-c .ct-area,
.uses .ct-series-c .ct-point,
.uses .ct-series-c .ct-line,
.uses .ct-series-c .ct-bar,
.uses .ct-series-c .ct-slice-donut,
.monthly .ct-series-c .ct-area,
.monthly .ct-series-c .ct-point,
.monthly .ct-series-c .ct-line,
.monthly .ct-series-c .ct-bar,
.monthly .ct-series-c .ct-slice-donut {
  stroke: rgba(255, 255, 255, 0.4);
  fill: transparent;
}
.turnover .ct-label,
.uses .ct-label,
.monthly .ct-label {
  fill: #fff;
  color: #fff;
}
.turnover .ct-grid,
.uses .ct-grid,
.monthly .ct-grid {
  stroke: rgba(255, 255, 255, 0.7);
}

#draggableMultiple .ui-sortable-handle .card {
  cursor: move;
}

.tilt-showcase ul li .line {
  padding-top: 10px;
}
.tilt-showcase .pre-mt {
  margin-top: 5px;
}

.wow-title h5, .wow-title .h5 {
  display: flex;
  align-items: center;
  font-size: 18px;
}
.wow-title h5 .badge, .wow-title .h5 .badge {
  -webkit-text-fill-color: #fff;
}

.alert-center {
  display: flex !important;
  align-items: center;
}

.box-shadow-title .sub-title {
  margin: 30px 0;
}

.hovercard .info .social-media ul li {
  padding-top: 3px;
}
.hovercard .cardheader {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.sticky-header-main .card .card-header h5, .sticky-header-main .card .card-header .h5 {
  line-height: 35px;
}
.sticky-header-main .card .card-header h5 a, .sticky-header-main .card .card-header .h5 a {
  color: #fff;
  -webkit-text-fill-color: #fff;
}

.custom-radio-ml {
  margin-left: 3px;
}

.daterangepicker .ltr tr td.active {
  color: #fff;
}

.twitter-typeahead {
  display: block !important;
}

span.twitter-typeahead .league-name {
  font-size: 16px;
  padding: 6px 10px 0;
}
span.twitter-typeahead .tt-menu {
  float: left;
  width: 100%;
  min-width: 10rem;
  margin: 0.125rem 0 0;
  font-size: 1rem;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 0.25rem;
  box-shadow: 0 0 20px rgba(89, 102, 122, 0.1);
  border: none;
  padding: 0;
}
span.twitter-typeahead .tt-suggestion {
  color: #2b2b2b;
  opacity: 0.6;
  font-size: 13px;
  padding: 6px 12px;
  border-top: 1px solid #efefef;
  background: #fff;
  cursor: pointer;
}
span.twitter-typeahead .tt-suggestion:hover, span.twitter-typeahead .tt-suggestion:focus {
  background-color: #fff;
}
span.twitter-typeahead .tt-suggestion.active, span.twitter-typeahead .tt-suggestion:active {
  color: #fff;
  background-color: var(--theme-default);
}

#scrollable-dropdown-menu .twitter-typeahead .tt-menu .tt-dataset {
  max-height: 100px;
  overflow-y: auto;
}

.chart-right {
  position: relative;
}

.balance-data {
  display: flex;
  gap: 15px;
  position: absolute;
  top: -50px;
  right: 2%;
}
[dir=rtl] .balance-data {
  right: unset;
  left: 2%;
}
@media (max-width: 991px) {
  .balance-data {
    top: -42px;
    right: 0%;
  }
}
@media (max-width: 575px) {
  .balance-data {
    display: none !important;
  }
}
.balance-data li {
  display: flex;
  align-items: center;
  font-weight: 500;
}
.balance-data .circle {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 100%;
}

.current-sale-container {
  padding-right: 12px;
}
[dir=rtl] .current-sale-container {
  padding-right: unset;
  padding-left: 12px;
}
.current-sale-container > div {
  margin: -22px 0 -30px -16px;
}
@media (max-width: 1199px) {
  .current-sale-container > div {
    margin-bottom: 0;
  }
}
@media (max-width: 404px) {
  .current-sale-container > div {
    margin-bottom: -30px;
  }
}
.current-sale-container .apexcharts-xaxistooltip {
  color: var(--theme-default);
  background: rgba(115, 102, 255, 0.1);
  border: 1px solid var(--theme-default);
}
.current-sale-container .apexcharts-xaxistooltip-bottom:before {
  border-bottom-color: var(--theme-default);
}
.current-sale-container .apexcharts-tooltip.light .apexcharts-tooltip-title {
  background: rgba(115, 102, 255, 0.1);
  color: var(--theme-default);
}
@media (max-width: 575px) {
  .current-sale-container.order-container {
    padding-right: 0;
  }
  [dir=rtl] .current-sale-container.order-container {
    padding-left: 0;
  }
}
@media (max-width: 404px) {
  .current-sale-container.order-container > div {
    margin-bottom: 0;
  }
}

.recent-circle {
  min-width: 10px;
  height: 10px;
  border-radius: 100%;
  display: inline-block;
  margin-top: 5px;
}

.recent-wrapper {
  align-items: center;
}
.recent-wrapper .order-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 36px;
}
@media (max-width: 1199px) {
  .recent-wrapper .order-content {
    gap: 20px;
  }
}
@media (max-width: 575px) {
  .recent-wrapper .order-content {
    justify-content: center;
    flex-wrap: wrap;
    flex-direction: row;
  }
}
.recent-wrapper .order-content li {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}
@media (max-width: 1660px) {
  .recent-wrapper .recent-chart .apexcharts-canvas .apexcharts-datalabel-label {
    font-size: 15px;
  }
}
@media (max-width: 1560px) and (min-width: 1400px) {
  .recent-wrapper > div {
    width: 100%;
  }
}
@media (max-width: 1560px) and (min-width: 1400px) {
  .recent-wrapper > div:last-child {
    display: none;
  }
}

.apexcharts-series.apexcharts-radial-series {
  position: relative;
}
.apexcharts-series.apexcharts-radial-series::after {
  position: absolute;
  content: "";
  background: linear-gradient(0deg, #ffffff 0.05%, #f4f4f4 19.91%, #f5f6f9 55.02%, #eaecf4 100%);
  width: calc(100% + 10px);
  height: calc(100% + 10px);
  top: 0;
  left: 0;
}

.card-block .table-responsive .table caption {
  padding-left: 10px;
}
.card-block .table-responsive .table-bordered td {
  vertical-align: middle;
}
.card-block .table-border-radius {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
.card-block .default-checkbox-align #checkbox1 {
  margin-right: 10px;
}
.card-block .default-checkbox-align #radio {
  margin-right: 5px;
}

#example-style-3_wrapper #example-style-3 tfoot {
  border-top: 2px solid #efefef;
}

.chart-vertical-center {
  display: flex;
  justify-content: center;
}
.chart-vertical-center #myDoughnutGraph,
.chart-vertical-center #myPolarGraph {
  width: auto !important;
}

.cke_focus {
  padding: 15px;
  margin-top: 13px;
}

#editor .ace_scroller .ace_content .ace_layer .ace_print-margin {
  visibility: hidden !important;
}

.helper-classes {
  padding: 30px;
  margin-bottom: 0;
  white-space: pre-line;
}

.starter-kit-fix .page-body {
  margin-bottom: 52px;
}

.starter-main .card-body p {
  font-size: 14px;
}
.starter-main .card-body ul {
  padding-left: 30px;
  list-style-type: disc;
  margin-bottom: 15px;
}
.starter-main .card-body h5, .starter-main .card-body .h5 {
  font-size: 18px;
}
.starter-main .card-body pre {
  white-space: pre-line;
  padding: 30px;
}
.starter-main .card-body .alert-primary.inverse:before {
  top: 32px;
}
.starter-main .alert {
  background-color: rgba(68, 102, 242, 0.2) !important;
}
.starter-main .alert i {
  display: flex;
  align-items: center;
}

footer.blockquote-footer {
  bottom: unset;
}

@media only screen and (max-width: 991px) {
  .notification li {
    padding-bottom: 20px;
  }
  .notification .card .card-body .d-flex .w-100 p {
    margin: 0;
  }
  .notification .card .card-body .d-flex .w-100 h6, .notification .card .card-body .d-flex .w-100 .h6 {
    margin-top: 10px;
  }
}
@media only screen and (max-width: 767px) {
  .footer-fix .pull-right {
    float: none !important;
    text-align: center !important;
  }
}
@media only screen and (max-width: 575px) {
  .notification li {
    padding-bottom: 15px;
  }
  .media-dropdown {
    display: block;
  }
  .media-dropdown .media-body {
    margin-bottom: 15px;
  }
}
@media only screen and (max-width: 360px) {
  .footer {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .footer p {
    font-size: 12px;
  }
  .appointment-table table tr td {
    min-width: 103px;
  }
  .appointment-table table tr td:first-child {
    min-width: 50px;
  }
  .appointment-table table tr td:nth-child(2) {
    min-width: 120px;
  }
}
/**=====================
53. Dashboard CSS Ends
==========================**/
/**=====================
    33.  Ecommerce  CSS Start
==========================**/
/**====== Product Start ======**/
.toggle-data {
  cursor: pointer;
}

.filter-block ul li {
  padding-top: 15px !important;
  opacity: 0.5;
}
@media (max-width: 1500px) {
  .filter-block ul li {
    padding-top: 10px !important;
  }
}

.collection-filter-block svg {
  width: 50px;
  height: 25px;
  stroke: var(--theme-default);
  fill: #e8e5ff;
  margin-right: 10px;
}
.collection-filter-block h5, .collection-filter-block .h5 {
  margin-bottom: 0;
  font-size: 16px;
}
.collection-filter-block p {
  font-size: 13px;
}
.collection-filter-block .media-body {
  opacity: 0.5;
}
.collection-filter-block li + li {
  margin-top: 16px;
}
.collection-filter-block ul.pro-services li svg {
  width: auto;
}

.qty-box .btn {
  background-color: transparent !important;
  border-color: #ecf3fa !important;
  padding: 8px 12px;
}
.qty-box .btn i {
  color: #898989;
}
.qty-box .btn svg {
  width: 14px !important;
  stroke: #2c323f;
}
.qty-box span {
  padding: 0 0px;
}
.qty-box .input-group {
  background-color: rgba(44, 50, 63, 0.1);
}
.qty-box input {
  background-color: rgba(44, 50, 63, 0.1);
  color: #2c323f;
  max-width: 44px;
  padding: 0;
  text-align: center;
  border: none;
  max-height: 37px;
}

.product-social li a {
  color: #898989;
  font-size: 15px;
  border: 1px solid #cccccc;
  border-radius: 100%;
  height: 35px;
  width: 35px;
  display: inline-block;
  text-align: center;
  line-height: 2.3;
  transition: all 0.3s ease;
}
.product-social li a:hover {
  border-color: #7366ff;
  color: #7366ff;
  background-color: rgba(115, 102, 255, 0.1);
  transition: all 0.3s ease;
}
.product-social li:nth-child(n+2) {
  margin-left: 10px;
}
[dir=rtl] .product-social li:nth-child(n+2) {
  margin-left: unset;
  margin-right: 10px;
}

.product-sidebar .filter-section .card .card-header {
  padding: 16px 30px;
  border-radius: 5px;
}
.product-sidebar .filter-section .card .card-header h6, .product-sidebar .filter-section .card .card-header .h6 {
  position: relative;
}
.product-sidebar .filter-section .card .card-header h6 .pull-right i, .product-sidebar .filter-section .card .card-header .h6 .pull-right i {
  position: absolute;
  top: 4px;
  left: 0;
  font-size: 10px;
  width: 100%;
  height: 10px;
  text-align: right;
  cursor: pointer;
}

.product-wrapper .product-sidebar .filter-section .card .left-filter {
  z-index: 0;
  opacity: 0;
  visibility: hidden;
  height: 0;
  transition: 0.3s;
  min-width: 320px;
}
.product-wrapper .product-sidebar .filter-section .card .left-filter .product-filter .irs-with-grid {
  margin-bottom: 15px;
}
.product-wrapper .product-grid .product-wrapper-grid {
  margin-left: 0;
  transition: 0.3s;
}
.product-wrapper.sidebaron .product-sidebar .filter-section .card .left-filter {
  z-index: 3;
  opacity: 1;
  visibility: visible;
  position: absolute;
  width: 100%;
  background-color: white;
  top: 53px;
  height: auto;
}

.d-none-productlist {
  display: none;
}
.d-none-productlist svg {
  vertical-align: middle;
  cursor: pointer;
}

.product-wrapper-grid.list-view .product-box {
  display: flex;
  align-items: center;
}
.product-wrapper-grid.list-view .product-box .product-img {
  width: 20%;
}
.product-wrapper-grid.list-view .product-box .product-details {
  text-align: left;
}

.slider-product {
  padding: 15px 0;
  border-top: 1px solid #f4f4f4;
  border-bottom: 1px solid #f4f4f4;
  margin-bottom: 15px;
}

.products-total {
  display: flex;
  align-items: center;
}

.grid-options {
  height: 33px;
  margin-left: 10px;
}
.grid-options ul li a {
  position: relative;
}
.grid-options ul li a .line-grid {
  position: absolute;
  width: 4px;
  height: 15px;
  top: 9px;
}
.grid-options ul li a .line-grid-1 {
  left: 12px;
}
.grid-options ul li a .line-grid-2 {
  left: 18px;
}
.grid-options ul li a .line-grid-3 {
  left: 36px;
}
.grid-options ul li a .line-grid-4 {
  left: 42px;
}
.grid-options ul li a .line-grid-5 {
  left: 48px;
}
.grid-options ul li a .line-grid-6 {
  left: 66px;
}
.grid-options ul li a .line-grid-7 {
  left: 72px;
}
.grid-options ul li a .line-grid-8 {
  left: 78px;
}
.grid-options ul li a .line-grid-9 {
  left: 84px;
}
.grid-options ul li a .line-grid-10 {
  left: 103px;
}
.grid-options ul li a .line-grid-11 {
  left: 109px;
}
.grid-options ul li a .line-grid-12 {
  left: 115px;
}
.grid-options ul li a .line-grid-13 {
  left: 121px;
}
.grid-options ul li a .line-grid-14 {
  left: 127px;
}
.grid-options ul li a .line-grid-15 {
  left: 133px;
}

.square-product-setting {
  height: 36px;
  vertical-align: middle;
}
.square-product-setting a {
  color: #2f2f3b;
}
.square-product-setting .icon-grid {
  padding: 7px;
  background-color: #fff;
  display: flex;
  align-items: center;
  margin: 0 10px;
}
.square-product-setting .icon-grid svg {
  width: 20px;
  height: 20px;
}

.product-filter .banner-product {
  margin-top: 15px;
}
.product-filter h6, .product-filter .h6 {
  margin-bottom: 15px;
}
.product-filter .color-selector {
  line-height: 0.9;
}
.product-filter .color-selector ul li {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 1px solid #444;
  border-radius: 100%;
  cursor: pointer;
}
.product-filter .color-selector ul li.white {
  background-color: #fff;
}
.product-filter .color-selector ul li.gray {
  background-color: #52526c;
}
.product-filter .color-selector ul li.black {
  background-color: #000;
}
.product-filter .color-selector ul li.orange {
  background-color: #ffb17a;
}
.product-filter .color-selector ul li.green {
  background-color: #6fb866;
}
.product-filter .color-selector ul li.pink {
  background-color: pink;
}
.product-filter .color-selector ul li.yellow {
  background-color: #f2f896;
}
.product-filter .color-selector ul li.blue {
  background-color: #63b4f2;
}
.product-filter .color-selector ul li.red {
  background-color: #ff647f;
}
.product-filter.new-products {
  margin-top: 20px;
}
.product-filter.new-products button {
  width: auto;
}
.product-filter.new-products .owl-theme .owl-nav {
  margin-top: 0;
  position: absolute;
  top: -46px;
  right: 0;
}
.product-filter.new-products .owl-theme .owl-nav button:focus {
  outline: transparent;
}
.product-filter.new-products .owl-theme .owl-nav button span {
  font-size: 20px;
}
.product-filter.new-products .owl-theme .owl-nav button span:focus {
  outline-color: transparent;
}
.product-filter.new-products .owl-theme .owl-nav [class*=owl-]:hover {
  background-color: transparent;
  color: inherit;
}
.product-filter.new-products .owl-theme .owl-item .item .product-box .product-details {
  padding: 25px 0;
}
.product-filter.new-products .owl-theme .owl-item .item .product-box + .product-box {
  margin-top: 15px;
}

.select2-drpdwn-product .form-control {
  border: none;
  box-shadow: 1px 5px 24px 0 rgba(68, 102, 242, 0.05);
  margin-bottom: 10px;
  height: 36px;
}

.feature-products form .form-group {
  position: relative;
}
.feature-products form .form-group input {
  margin-bottom: 15px;
  border: none;
  box-shadow: 1px 5px 24px 0 rgba(68, 102, 242, 0.05);
  height: 50px;
  padding-left: 30px;
}
.feature-products form .form-group i {
  position: absolute;
  top: 18px;
  right: 30px;
  color: #898989;
}

.product-page-main {
  padding: 30px;
}
.product-page-main .small-slick {
  margin-top: 20px;
}
.product-page-main .small-slick .item {
  border: 1px solid #f4f4f4;
  border-radius: 5px;
}
.product-page-main .small-slick .slick-slide {
  padding: 0 10px;
}
.product-page-main .small-slick .slick-slide.slick-current .item {
  border: 1px solid var(--theme-default);
}

.modal .modal-header {
  padding: 0;
  border: none;
}
.modal .modal-header .product-box .product-details {
  padding: 25px 0;
}
.modal .modal-header .product-box .product-details h6, .modal .modal-header .product-box .product-details .h6 {
  text-transform: capitalize;
}
.modal .modal-header .product-box .product-details .product-price {
  font-size: 22px;
  margin-bottom: 10px;
}
.modal .modal-header .product-box .product-details .product-view {
  padding: 20px 0;
  border-top: 1px dotted #59667a;
  border-bottom: 1px dotted #59667a;
}
.modal .modal-header .product-box .product-details .product-size {
  margin: 20px 0;
}
.modal .modal-header .product-box .product-details .product-size ul li {
  display: inline-block;
}
.modal .modal-header .product-box .product-details .product-qnty fieldset {
  margin-bottom: 20px;
}
.modal .modal-header .product-box .product-details .product-qnty fieldset .input-group {
  width: 35%;
}
.modal .modal-header .product-box .product-details .product-qnty fieldset .input-group .btn {
  padding: 5px 12px;
}
.modal .modal-header .product-box .product-details .product-qnty fieldset .input-group .btn-primary {
  background-color: #59667a !important;
  border: 1px solid #59667a !important;
}
.modal .modal-header .btn-close {
  position: absolute;
  right: 15px;
  top: 10px;
}

.product-box {
  border-radius: 10px;
  overflow: hidden;
}
.product-box .product-details {
  padding: 15px 25px;
}
.product-box .product-details > a {
  color: #2f2f3b;
}
.product-box .product-details p {
  margin-bottom: 0;
  opacity: 0.8;
}
.product-box .product-details h4, .product-box .product-details .h4 {
  margin-bottom: 0;
  margin-top: 5px;
  font-size: 20px;
  font-family: roboto;
}
.product-box .product-details h6, .product-box .product-details .h6 {
  color: #2f2f3b;
  text-transform: uppercase;
  margin-bottom: 10px;
}
.product-box .product-details span {
  color: #898989;
}
.product-box .product-details .rating i {
  font-size: 16px;
  letter-spacing: 3px;
  color: #ffa800;
}
.product-box .modal .modal-header .product-box .product-details {
  padding: 25px 0;
}
.product-box .modal .modal-header .product-box .product-details h6, .product-box .modal .modal-header .product-box .product-details .h6 {
  text-transform: capitalize;
}
.product-box .modal .modal-header .product-box .product-details .product-price {
  font-size: 22px;
  margin-bottom: 10px;
}
.product-box .modal .modal-header .product-box .product-details .product-view {
  padding: 20px 0;
  border-top: 1px dotted #59667a;
  border-bottom: 1px dotted #59667a;
}
.product-box .modal .modal-header .product-box .product-details .product-size {
  margin: 20px 0;
}
.product-box .modal .modal-header .product-box .product-details .product-size ul li {
  display: inline-block;
}
.product-box .modal .modal-header .product-box .product-details .product-qnty fieldset {
  margin-bottom: 20px;
}
.product-box .modal .modal-header .product-box .product-details .product-qnty fieldset .input-group {
  width: 35%;
}
.product-box .modal .modal-header .product-box .product-details .product-qnty fieldset .input-group .btn {
  padding: 5px 12px;
}
.product-box .modal .modal-header .product-box .product-details .product-qnty fieldset .input-group .btn-primary {
  background-color: #59667a !important;
  border: 1px solid #59667a !important;
}
.product-box .modal .modal-header .btn-close {
  position: absolute;
  right: 15px;
  top: 10px;
}
.product-box .product-img {
  position: relative;
}
.product-box .product-img .product-hover {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.3);
  opacity: 0;
  border-radius: 100%;
  transform: scale(0);
  transition: all 0.3s ease;
}
.product-box .product-img .product-hover ul li {
  display: inline-block;
  box-shadow: 1px 1px 2px 1px rgba(0, 0, 0, 0.08);
  padding: 10px 12px;
  background-color: #fff;
  font-size: 18px;
  border-radius: 10px;
  height: 45px;
  width: 45px;
  margin: 0 3px;
  cursor: pointer;
}
.product-box .product-img .product-hover ul li i {
  color: #59667a;
  font-size: 18px;
}
.product-box .product-img .product-hover ul li .btn {
  padding: 0;
}
.product-box .product-img .product-hover ul li:hover {
  background-color: var(--theme-default);
  transition: all 0.3s ease;
}
.product-box .product-img .product-hover ul li:hover .btn,
.product-box .product-img .product-hover ul li:hover i {
  color: #fff;
}
.product-box:hover .product-hover {
  opacity: 1;
  border-radius: 0%;
  transform: scale(1);
  transition: all 0.3s ease;
}

.product-page-main {
  padding: 30px;
}
.product-page-main .owl-item .item {
  border: 1px solid #f4f4f4;
  border-radius: 5px;
  background-color: #f8f8f8;
}
.product-page-main .owl-item.current .item {
  border: 1px solid var(--theme-default);
}
@media (min-width: 1400px) {
  .product-page-main .product-slider img {
    height: 520px;
    object-fit: cover;
  }
}
@media (min-width: 1500px) {
  .product-page-main .product-slider img {
    height: 400px;
    object-fit: cover;
  }
}
.product-page-main .product-color {
  margin-top: 10px;
}

.product-page-details h4, .product-page-details .h4 {
  color: #2f2f3b;
  text-transform: uppercase;
  font-size: 18px;
}
.product-page-details span {
  padding-left: 15px;
}

.br-theme-fontawesome-stars .br-widget a,
.br-theme-fontawesome-stars .br-widget a.br-selected:after,
.br-theme-fontawesome-stars .br-widget a.br-active:after {
  color: #ffa800 !important;
  font: normal normal normal 14px/1 FontAwesome;
}

.product-price {
  font-size: 18px;
  font-weight: 700;
  margin-top: 5px;
  color: var(--theme-default);
}
.product-price del {
  color: rgba(44, 50, 63, 0.4);
  padding-left: 10px;
  font-size: 80%;
}

.product-color li {
  display: inline-block;
  border-radius: 100% !important;
  height: 20px;
  width: 20px;
  margin: 0 2px;
}

.product-page-main p {
  font-size: 15px;
}
.product-page-main .nav-link {
  text-transform: uppercase;
  font-weight: 500;
}

/**====== Product  Ends ======**/
.payment-opt li {
  display: inline-block;
}
.payment-opt li img {
  height: 20px;
  margin: 15px 15px 0 0;
}

/**=====================
    33. Ecommerce  CSS End
==========================**/
@media screen and (max-width: 1660px) and (min-width: 1200px) {
  .owl-carousel .owl-item img {
    max-width: 420px;
    margin: 0 auto;
  }
}
/**=====================
    13.  Email Application  CSS Start
==========================**/
.email-wrap .row .col-xl-3 + .col-xl-3 {
  padding-right: 0;
}
.email-wrap .row .col-xl-6 {
  padding-left: 0;
}
.email-wrap .dropdown .dropdown-toggle {
  background-color: rgba(115, 102, 255, 0.08);
  color: #7366ff;
  border-radius: 10px;
  padding: 5px 10px;
  width: 100px;
  text-align: left;
}
[dir=rtl] .email-wrap .dropdown .dropdown-toggle {
  text-align: right;
}
.email-wrap .dropdown .dropdown-toggle:after {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  content: "\\f107";
  border: none;
  font-family: "FontAwesome";
  font-size: 18px;
  margin: 0;
}
[dir=rtl] .email-wrap .dropdown .dropdown-toggle:after {
  right: unset;
  left: 10px;
}
.email-wrap .dropdown .dropdown-menu {
  box-shadow: 0 0 20px rgba(89, 102, 122, 0.1);
  border: none;
  padding: 0;
}
.email-wrap .dropdown .dropdown-menu .dropdown-item {
  color: #2b2b2b;
  opacity: 0.6;
  font-size: 13px;
  padding: 6px 12px;
  border-top: 1px solid #f5f5f5;
  background: #fff;
  line-height: 19px;
}
.email-wrap .dropdown .dropdown-menu .dropdown-item:hover {
  background-color: #fff;
}
.email-wrap .email-app-sidebar .media img {
  border: 2px solid #ecf3fa;
}
.email-wrap .email-app-sidebar .main-menu > li {
  width: 100%;
  text-align: left;
}
.email-wrap .email-app-sidebar .main-menu > li a {
  line-height: 39px;
  text-transform: uppercase;
  border-radius: 3px;
}
.email-wrap .email-app-sidebar .main-menu > li a i {
  margin-right: 10px;
}
.email-wrap .email-app-sidebar .main-menu > li a.active > a {
  color: #000;
}
.email-wrap .email-app-sidebar .main-menu > li a:hover {
  background-color: #f5f6f9;
  text-decoration: none;
}
.email-wrap .email-app-sidebar ul li a {
  display: flex;
  padding-left: 20px;
  align-items: center;
}
.email-wrap .email-app-sidebar ul li a > .title {
  width: 100%;
  color: #2c323f;
}
.email-wrap .email-app-sidebar ul li a > .badge {
  align-self: center;
  color: #898989;
}
.email-wrap .email-left-aside {
  float: left;
  width: 100%;
}
.email-wrap .email-left-aside .card-body {
  padding: 20px;
}
@media (min-width: 1200px) {
  .email-wrap .email-right-aside .email-body .pr-0 {
    padding-right: 0;
  }
  [dir=rtl] .email-wrap .email-right-aside .email-body .pr-0 {
    padding-right: 12px;
    padding-left: 0;
  }
}
@media (min-width: 1200px) {
  .email-wrap .email-right-aside .email-body .pl-0 {
    padding-left: 0;
  }
  [dir=rtl] .email-wrap .email-right-aside .email-body .pl-0 {
    padding-left: 12px;
    padding-right: 0;
  }
}
.email-wrap .email-right-aside .email-body .inbox {
  overflow: auto;
}
@media (max-width: 1199.98px) {
  .email-wrap .email-right-aside .email-body .inbox {
    display: flex;
    flex-wrap: wrap;
  }
}
.email-wrap .email-right-aside .email-body .inbox .media {
  padding: 20px;
}
.email-wrap .email-right-aside .email-body .inbox .media.active {
  background-color: rgb(99.6862745098%, 99.6862745098%, 99.6862745098%);
}
.email-wrap .email-right-aside .radius-left {
  border-radius: 8px;
  height: 100%;
}
.email-wrap .btn-mail {
  border-radius: 2px;
  text-align: left;
  padding: 13px 15px;
  margin: 20px 0 20px;
  letter-spacing: 1px;
  line-height: 12px !important;
}
.email-wrap p {
  margin-bottom: 0;
  color: #898989;
}
.email-wrap .media-body {
  margin-top: 5px;
}
.email-wrap .media-body h6, .email-wrap .media-body .h6 {
  margin-bottom: 2px;
  color: #242934;
  margin-top: 3px;
}
.email-wrap .media-body h6 small, .email-wrap .media-body .h6 small, .email-wrap .media-body h6 .small, .email-wrap .media-body .h6 .small {
  font-size: 12px;
}
.email-wrap .media-body h6 small span, .email-wrap .media-body .h6 small span, .email-wrap .media-body h6 .small span, .email-wrap .media-body .h6 .small span {
  color: #777777;
}
.email-wrap .media-body p {
  color: #52526c;
  font-size: 12px;
}
.email-wrap .email-top {
  padding: 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  line-height: 49px;
}
.email-wrap .email-top i {
  cursor: pointer;
}
.email-wrap .email-top h5, .email-wrap .email-top .h5 {
  margin-bottom: 0;
  padding: 12px 0;
}
.email-wrap .email-top .d-flex {
  padding: 13px 0;
}
.email-wrap .email-wrapper {
  padding: 20px;
}
.email-wrap .email-wrapper hr {
  margin-top: 0;
  margin-bottom: 20px;
}
.email-wrap .email-wrapper .d-inline-block {
  width: 100%;
}
.email-wrap .email-wrapper h6, .email-wrap .email-wrapper .h6 {
  margin-bottom: 11px;
  float: left;
}
.email-wrap .email-wrapper .right-download {
  float: right;
}
.email-wrap .email-wrapper p + p {
  margin-bottom: 20px;
}
.email-wrap .email-wrapper h5, .email-wrap .email-wrapper .h5 {
  margin-bottom: 20px;
}
.email-wrap .email-content .email-top .user-emailid:after {
  content: "";
  position: relative;
  height: 20px;
  width: 1px;
  right: 0;
  top: 3px;
  z-index: 2;
  border: 1px solid #efefef;
  float: right;
  padding: 0;
  margin: 0 20px;
}
.email-wrap .email-body .attachment ul li img {
  margin-bottom: 20px;
  width: 80px;
  height: 80px;
  object-fit: cover;
}
.email-wrap .email-body .attachment .list-inline .list-inline-item {
  padding-right: 13px;
}
.email-wrap .email-body .email-compose .cke_contents.cke_reset {
  max-height: 178px;
  width: 100%;
  border: 1px solid #ecf3fa;
}
.email-wrap .email-body .email-compose .email-top h4, .email-wrap .email-body .email-compose .email-top .h4 {
  padding: 11px 0;
}
.email-wrap .email-body .email-compose .compose-border .btn-middle {
  padding-top: 5px;
}
.email-wrap .actions li {
  display: inline-block;
  margin-right: 25px;
}

/**=====================
    13.  Email Application  CSS Ends
==========================**/
/**=====================
     09. Error-page  CSS Start
==========================**/
.error-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  text-align: center;
}
.error-wrapper.maintenance-bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
  background-color: rgba(255, 255, 255, 0.6);
  background-blend-mode: overlay;
}
.error-wrapper .maintenance-icons li i {
  color: #59667a;
  font-size: 50px;
  animation: rotate-effect 40s infinite linear reverse;
}
.error-wrapper .maintenance-icons li:nth-child(2) i {
  font-size: 100px;
  margin-left: 110px;
  margin-top: -25px;
  animation: rotate-effect 40s linear infinite reverse;
}
.error-wrapper .maintenance-icons li:nth-child(3) i {
  animation: rotate-effect 30s infinite linear;
  font-size: 150px;
  margin-top: -85px;
  margin-right: 120px;
}
.error-wrapper .maintenance-heading {
  margin-top: 70px;
}
.error-wrapper .maintenance-heading .headline {
  font-size: 99px;
  font-weight: 900;
  letter-spacing: 10px;
  color: var(--theme-default);
  z-index: 2;
  position: relative;
  margin-top: -70px;
}
.error-wrapper .error-heading {
  margin-top: 115px;
}
.error-wrapper .error-heading .headline {
  font-size: 285px;
  font-weight: 700;
  letter-spacing: 1px;
  margin-top: -130px;
}
.error-wrapper .sub-content {
  font-size: 18px;
  color: #2f2f3b;
  letter-spacing: 1px;
  font-weight: normal;
  line-height: 35px;
  z-index: 3;
  position: relative;
  margin-top: 30px;
  margin-bottom: 0;
}
.error-wrapper .btn {
  margin-top: 40px;
}

.error {
  margin: 70px 0 100px;
  color: #000;
}
.error .error-title {
  font-size: 9.5rem;
  color: #fff;
  text-shadow: 6px 6px 7px rgba(0, 0, 0, 0.32);
}
.error .line-bottom {
  width: 10%;
  height: 5px;
  background-color: #ffaa05;
  border: none;
}
.error .c-white {
  color: #fff;
}
.error .error-btn {
  text-align: center;
}
.error .padd {
  padding: 10px 30px 10px 30px;
}
.error .btn-back-home {
  background-color: #f4f4f4;
  color: #000;
}
.error .btn-back-home:hover {
  background-color: #ffaa05;
  color: #fff;
  box-shadow: 0 20px 35px 0 rgba(0, 0, 0, 0.21);
}
.error .btn-adnc-serc {
  background-color: #2c323f;
  color: #fff;
}
.error .btn-adnc-serc:hover {
  background-color: #ffaa05;
  color: #fff;
  box-shadow: 0 20px 35px 0 rgba(0, 0, 0, 0.21);
}

/**=====================
     09. Error-page CSS Ends
==========================**/
/**=====================
     71. Faq CSS start
==========================**/
.knowledgebase-bg {
  height: 500px;
  border-radius: 15px;
  margin-bottom: 30px;
}

.knowledgebase-search {
  position: absolute;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  left: 5%;
}
.knowledgebase-search .form-inline {
  background-color: #fff;
  width: 500px;
  padding: 12px 50px;
  border-radius: 10px;
  border: 1px solid #e6e6e6;
  margin-top: 10px;
  position: relative;
}
.knowledgebase-search .form-inline ::placeholder {
  color: #cccccc;
}
.knowledgebase-search .form-inline svg {
  position: absolute;
  left: 20px;
  width: 20px;
  top: 17px;
  stroke: #cccccc;
}

.faq-widgets {
  align-items: center;
}
.faq-widgets .media-body h5, .faq-widgets .media-body .h5 {
  font-weight: 600;
}
.faq-widgets .media-body p {
  padding-right: 20px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
  text-overflow: ellipsis;
}
.faq-widgets svg {
  width: 50px;
  height: 50px;
  opacity: 0.5;
}

.header-faq h5, .header-faq .h5 {
  font-weight: 600;
}
.header-faq {
  margin-bottom: 30px;
}

.features-faq.card .card-body,
.features-faq.card .card-footer {
  padding: 20px 25px;
}
.features-faq .faq-image img {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  width: 100%;
}
.features-faq .card-body h6, .features-faq .card-body .h6 {
  font-weight: 500;
}

.add-project.table td {
  vertical-align: middle;
}
.add-project .text-inherit {
  color: black;
}

.faq-accordion.default-according {
  margin-bottom: 30px;
}
.faq-accordion.default-according .card .btn-link {
  display: flex;
}
.faq-accordion.default-according .card .btn-link svg {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
.faq-accordion.default-according .card .faq-header {
  position: relative;
  padding: 30px;
}
.faq-accordion.default-according .card .faq-header svg {
  position: absolute;
  right: 30px;
  top: 30px;
  width: 20px;
  height: 20px;
}
.faq-accordion.default-according .card .faq-header span {
  margin-top: 3px;
}
.faq-accordion.default-according .faq-body {
  padding: 20px !important;
}
.faq-accordion.default-according .card-mb-faq {
  margin-bottom: 30px;
}

.faq-title {
  margin: 30px 0;
}
.faq-title h6, .faq-title .h6 {
  color: #999999;
  font-weight: 600;
}

.faq-form {
  position: relative;
}
.faq-form .search-icon {
  position: absolute;
  right: 12px;
  top: 9px;
  width: 20px;
  height: 20px;
}

.navigation-btn a {
  display: flex;
  align-items: center;
  justify-content: center;
}
.navigation-btn a svg {
  width: 15px;
  height: 15px;
}
.navigation-btn {
  margin-bottom: 20px;
}

.navigation-option ul li {
  position: relative;
  padding: 8px 8px 8px 0 !important;
}
.navigation-option ul li:hover {
  background-color: #fdfeff;
}
.navigation-option ul li a {
  padding-left: 40px;
  color: #2f2f3b;
}
.navigation-option ul li a svg {
  position: absolute;
  width: 15px;
  height: 15px;
  top: 11px;
  left: 15px;
}

.updates-faq {
  width: 40px;
  height: 40px;
  border: 2px solid var(--theme-default);
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
}
.updates-faq svg {
  width: 18px;
  height: 18px;
}

.updates-bottom-time p {
  margin-bottom: 2px;
}
.updates-bottom-time p + p {
  color: #999999;
}

.updates-faq-main {
  margin-bottom: 20px;
}
.updates-faq-main a {
  font-weight: 500;
}
.updates-faq-main:last-child {
  margin-bottom: 0;
}

@media only screen and (max-width: 1399.98px) {
  .faq-widgets svg {
    width: 30px;
    height: 30px;
  }
}
@media only screen and (max-width: 1199px) {
  .faq-accordion {
    margin-bottom: 30px;
  }
}
@media only screen and (max-width: 991px) {
  .faq-accordion.default-according .card .faq-header {
    padding: 20px !important;
  }
  .faq-accordion.default-according .card .faq-header svg {
    right: 20px;
    top: 20px;
  }
  .navigation-option ul li {
    padding: 10px 10px 10px 0;
  }
  .navigation-option ul li a svg {
    top: 12px;
  }
}
@media only screen and (max-width: 767px) {
  .xs-mt-search {
    margin-top: 30px;
  }
}
@media only screen and (max-width: 575px) {
  .xs-mt-search {
    margin-top: 0px;
  }
  .faq-widgets svg {
    width: 30px;
    height: 30px;
  }
  .faq-title {
    margin: 15px 0;
  }
  .header-faq {
    margin-bottom: 15px;
    margin-top: 10px;
  }
  .faq-accordion {
    margin-bottom: 0px;
  }
  .faq-accordion .faq-header {
    padding: 15px !important;
  }
  .faq-accordion .faq-header .pull-right {
    float: right;
  }
  .faq-accordion .faq-header svg {
    right: 15px;
    top: 15px;
  }
  .navigation-btn,
  .updates-faq-main {
    margin-bottom: 15px;
  }
}
/**=====================
     71. Faq CSS end
==========================**/
/**=====================
    File Manager
==========================**/
.file-sidebar .card .card-body,
.file-sidebar .card .card-header,
.file-content .card .card-body,
.file-content .card .card-header {
  padding: 20px !important;
}

.file-sidebar ul li + li {
  margin-top: 8px;
}
.file-sidebar .btn {
  display: flex;
  align-items: center;
}
.file-sidebar .btn.btn-light:hover {
  color: var(--theme-default) !important;
}
.file-sidebar .btn.btn-light:hover svg {
  stroke: var(--theme-default);
}
.file-sidebar .btn svg {
  width: 15px;
  vertical-align: middle;
  margin-right: 8px;
}
.file-sidebar .pricing-plan {
  border: 1px solid #ecf3fa;
  border-radius: 5px;
  margin-top: 10px;
  padding: 15px;
  position: relative;
  overflow: hidden;
}
.file-sidebar .pricing-plan h6, .file-sidebar .pricing-plan .h6 {
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 2px;
  color: #898989;
}
.file-sidebar .pricing-plan h5, .file-sidebar .pricing-plan .h5 {
  font-weight: 800;
}
.file-sidebar .pricing-plan p {
  margin-bottom: 5px;
  color: #898989;
}
.file-sidebar .pricing-plan .btn {
  display: inline-block;
}
.file-sidebar .pricing-plan .bg-img {
  position: absolute;
  top: 40px;
  opacity: 0.1;
  transform: rotate(-45deg);
  right: -40px;
}

.file-manager > h6, .file-manager > .h6 {
  opacity: 0.6;
  font-weight: 400 !important;
  font-size: 15px;
  margin-bottom: 12px;
}
.file-manager .files .file-box:nth-child(1) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 100000ms;
}
.file-manager .files .file-box:nth-child(2) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 200000ms;
}
.file-manager .files .file-box:nth-child(3) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 300000ms;
}
.file-manager .files .file-box:nth-child(4) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 400000ms;
}
.file-manager .files .file-box:nth-child(5) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 500000ms;
}
.file-manager .files .file-box:nth-child(6) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 600000ms;
}
.file-manager .files .file-box:nth-child(7) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 700000ms;
}
.file-manager .files .file-box:nth-child(8) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 800000ms;
}
.file-manager .files .file-box:nth-child(9) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 900000ms;
}
.file-manager .files .file-box:nth-child(10) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 1000000ms;
}
.file-manager .files .file-box:nth-child(11) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 1100000ms;
}
.file-manager .files .file-box:nth-child(12) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 1200000ms;
}
.file-manager .files .file-box:nth-child(13) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 1300000ms;
}
.file-manager .files .file-box:nth-child(14) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 1400000ms;
}
.file-manager .files .file-box:nth-child(15) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 1500000ms;
}
.file-manager .files h6, .file-manager .files .h6 {
  margin-top: 10px;
  margin-bottom: 0;
}
.file-manager p {
  opacity: 0.9;
  font-size: 12px;
}

.files h6, .files .h6,
.folder h6,
.folder .h6 {
  opacity: 0.9;
  font-weight: 500 !important;
  font-size: 14px;
}

.file-content .ellips {
  position: absolute;
  top: 30px;
  right: 30px;
  opacity: 0.7;
}
.file-content .form-inline {
  border: 1px solid #f4f4f4;
  border-radius: 5px;
  padding: 0 20px;
}
.file-content .form-inline i {
  padding-right: 10px;
  color: #898989;
  line-height: 3;
}
.file-content .form-inline input::-webkit-input-placeholder {
  color: #898989;
}
.file-content .form-inline input:focus {
  outline: none !important;
}
.file-content .search-form input {
  padding: 5px 10px 5px 70px;
  border-radius: 5px;
}
.file-content .search-form .form-group:before {
  left: 82px;
  top: 37px;
}
.file-content .search-form .form-group:after {
  top: 39px;
  left: 53px;
}
.file-content .btn svg {
  height: 15px;
  margin-right: 2px;
  vertical-align: middle;
}
.file-content h4, .file-content .h4 {
  font-weight: 500;
}
.file-content .folder .folder-box {
  border: 1px solid #f1f1f1;
  border-radius: 5px;
  padding: 15px;
  background-color: #f6f7fb;
  width: calc(25% - 15px);
  display: inline-block;
  margin: 3px;
}
.file-content .folder .folder-box:nth-child(1) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 100000ms;
}
.file-content .folder .folder-box:nth-child(2) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 200000ms;
}
.file-content .folder .folder-box:nth-child(3) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 300000ms;
}
.file-content .folder .folder-box:nth-child(4) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 400000ms;
}
.file-content .folder .folder-box:nth-child(5) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 500000ms;
}
.file-content .folder .folder-box:nth-child(6) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 600000ms;
}
.file-content .folder .folder-box:nth-child(7) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 700000ms;
}
.file-content .folder .folder-box:nth-child(8) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 800000ms;
}
.file-content .folder .folder-box:nth-child(9) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 900000ms;
}
.file-content .folder .folder-box:nth-child(10) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 1000000ms;
}
.file-content .folder .folder-box:nth-child(11) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 1100000ms;
}
.file-content .folder .folder-box:nth-child(12) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 1200000ms;
}
.file-content .folder .folder-box:nth-child(13) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 1300000ms;
}
.file-content .folder .folder-box:nth-child(14) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 1400000ms;
}
.file-content .folder .folder-box:nth-child(15) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 1500000ms;
}
.file-content .files .file-box {
  border: 1px solid #f1f1f1;
  border-radius: 5px;
  padding: 15px !important;
  background-color: #f6f7fb;
  width: calc(25% - 15px);
  display: inline-block;
  position: relative;
  margin: 3px;
}
.file-content .files .file-box .file-top {
  height: 100px;
  background-color: #fff;
  border: 1px solid #ececec;
  border-radius: 5px;
  font-size: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media screen and (max-width: 1440px) {
  .file-content .folder .folder-box .media {
    display: block;
  }
  .file-content .folder .folder-box .media .media-body {
    margin-left: 0 !important;
    margin-top: 5px;
  }
}
@media screen and (max-width: 1366px) {
  .file-content .files {
    margin-bottom: -10px;
  }
  .file-content .files .file-box {
    width: calc(50% - 15px);
    margin-bottom: 10px;
  }
}
@media screen and (max-width: 768px) {
  .file-content .folder {
    margin-bottom: -10px;
  }
  .file-content .folder .folder-box {
    width: calc(50% - 15px);
    margin-bottom: 10px;
    margin-right: 8px;
  }
  .file-content .media {
    display: block;
    text-align: center;
  }
  .file-content .media .media-body {
    margin-top: 20px;
    text-align: center !important;
  }
}
@media screen and (max-width: 575px) {
  .file-content .folder .folder-box,
  .file-content .files .file-box {
    width: 100%;
  }
}
/**=====================
     File Manager
==========================**/
/**=====================
     45. Gallery CSS Start
==========================**/
.profile-img-style img,
.scroll-bar-wrap img {
  width: 100%;
}

.gallery {
  margin-bottom: -30px;
}
.gallery > a {
  margin-bottom: 30px;
}
.gallery > a:before {
  content: "\\edee";
  font-family: IcoFont;
  position: absolute;
  height: calc(100% - 10px);
  left: 20px;
  width: calc(100% - 40px);
  background-color: rgba(255, 255, 255, 0.27);
  top: 5px;
  transform: scale(0);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  color: #000;
}
.gallery > a:hover:before {
  transform: scale(1);
  transition: all 0.3s ease;
}
.gallery > a .img-thumbnail {
  border-radius: 0;
  border: 1px solid var(--bs-border-color) !important;
}

.my-gallery .img-thumbnail {
  border: 1px solid var(--bs-border-color) !important;
}

.gallery-with-description {
  margin-bottom: -30px;
}
.gallery-with-description a .img-thumbnail {
  border: 1px solid var(--bs-border-color) !important;
  border-bottom: none !important;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.gallery-with-description a > div {
  padding: 10px;
  border: 1px solid rgb(89.3787795492%, 90.390324354%, 92.5820047645%);
  margin-bottom: 30px;
  border-radius: 0 0 5px 5px;
  border-top: none;
}
.gallery-with-description a:hover {
  text-decoration: none !important;
}
.gallery-with-description.masonry-with-dec a .img-thumbnail {
  padding: 10px 10px 5px 10px !important;
}
.gallery-with-description h4, .gallery-with-description .h4 {
  color: #2c323f;
  margin-top: 15px;
  font-size: 18px;
}
.gallery-with-description p {
  color: rgb(63.7254901961%, 63.7254901961%, 63.7254901961%);
}

.lg-backdrop {
  background-color: #fff;
}

.lg-outer .lg-actions .lg-next,
.lg-outer .lg-actions .lg-prev {
  background-color: rgb(255, 255, 255);
  border: 1px solid #efefef;
}
.lg-outer .lg-actions .lg-next:hover,
.lg-outer .lg-actions .lg-prev:hover {
  color: #2c323f;
}
.lg-outer .lg-toolbar {
  background-color: rgba(255, 255, 255, 0.45);
  border-bottom: 1px solid #2c323f;
}
.lg-outer .lg-toolbar .lg-icon:hover {
  color: #2c323f;
}
.lg-outer #lg-counter {
  color: #2c323f;
}
.lg-outer .lg-sub-html {
  background-color: rgba(255, 255, 255, 0.45);
}
.lg-outer .lg-sub-html h4, .lg-outer .lg-sub-html .h4 {
  font-size: inherit;
  color: #2c323f;
}
.lg-outer .lg-sub-html p {
  color: #2c323f;
}
.lg-outer .lg-thumb-outer {
  background-color: #ecf3fa;
}
.lg-outer .lg-thumb-item {
  padding: 4px;
  border: 1px solid #efefef;
  border-radius: 0;
}
.lg-outer .lg-thumb-item .active, .lg-outer .lg-thumb-item:hover {
  border-color: #000;
}

.gallery a:before, .gallery a:after {
  content: none;
}
.gallery .img-hover > div {
  overflow: hidden;
}
.gallery .hover-1 img {
  transform: scale(1);
  transition: 0.3s ease-in-out;
}
.gallery .hover-1 img:hover {
  transform: scale(1.2);
}
.gallery .hover-2 img {
  width: 100%;
  height: auto;
  transition: 0.3s ease-in-out;
  transform: translateX(0px);
}
.gallery .hover-2:hover img {
  transform: translateX(40px) scale(1.2);
}
.gallery .hover-3 img {
  transform: scale(1.2);
  transition: 0.3s ease-in-out;
}
.gallery .hover-3:hover img {
  transform: scale(1);
}
.gallery .hover-4 img {
  transform: scale(1.5);
  transition: 0.3s ease-in-out;
}
.gallery .hover-4:hover img {
  transform: scale(1);
}
.gallery .hover-5 img {
  margin-left: 30px;
  transform: scale(1.3);
  transition: 0.3s ease-in-out;
}
.gallery .hover-5:hover img {
  margin-left: 0;
}
.gallery .hover-6 img {
  transform: rotate(15deg) scale(1.4);
  transition: 0.3s ease-in-out;
}
.gallery .hover-6:hover img {
  transform: rotate(0) scale(1);
}
.gallery .hover-7 img {
  filter: blur(3px);
  transition: 0.3s ease-in-out;
}
.gallery .hover-7:hover img {
  filter: blur(0);
}
.gallery .hover-8 img {
  filter: grayscale(100%);
  transition: 0.3s ease-in-out;
}
.gallery .hover-8:hover img {
  filter: grayscale(0);
}
.gallery .hover-9 img {
  filter: sepia(100%);
  transition: 0.3s ease-in-out;
}
.gallery .hover-9:hover img {
  filter: sepia(0);
}
.gallery .hover-10 img {
  filter: grayscale(0) blur(0);
  transition: 0.3s ease-in-out;
}
.gallery .hover-10:hover img {
  filter: grayscale(100%) blur(3px);
}
.gallery .hover-11 img {
  opacity: 1;
  transition: 0.3s ease-in-out;
}
.gallery .hover-11:hover img {
  opacity: 0.5;
}
@keyframes flash {
  0% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}
.gallery .hover-13:hover img {
  opacity: 1;
  animation: flash 1.5s;
}
@keyframes shine {
  100% {
    left: 125%;
  }
}
.gallery .hover-14 div {
  position: relative;
}
.gallery .hover-14 div:before {
  position: absolute;
  top: 0;
  left: -75%;
  z-index: 2;
  display: block;
  content: "";
  width: 50%;
  height: 100%;
  background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.3) 100%);
  transform: skewX(-25deg);
}
.gallery .hover-14 div:hover:before {
  animation: shine 0.75s;
}
.gallery .hover-15 div {
  position: relative;
}
.gallery .hover-15 div:before {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 2;
  display: block;
  content: "";
  width: 0;
  height: 0;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 100%;
  transform: translate(-50%, -50%);
  opacity: 0;
}
.gallery .hover-15 div:hover:before {
  animation: circle 0.75s;
}
@keyframes circle {
  0% {
    opacity: 1;
  }
  40% {
    opacity: 1;
  }
  100% {
    width: 200%;
    height: 200%;
    opacity: 0;
  }
}
* {
  box-sizing: border-box;
}
*:after, *:before {
  box-sizing: border-box;
}

.grid {
  position: relative;
}

/* clear fix */
.grid:after {
  content: "";
  display: block;
  clear: both;
}

/* ---- .grid-item ---- */
.grid-item img {
  max-width: 100%;
  padding: 0.25rem;
  background-color: #fff;
  border: 1px solid #dee2e6;
}

.gallery-with-description .grid-item img {
  border: 0;
  padding: 0;
}

/**=====================
     45. Gallery CSS Ends
==========================**/
/**=====================
     74. internationalization css start
==========================**/
.hdg_main {
  position: relative;
}

.main .langChoice {
  position: absolute;
  right: 40px;
  top: 31px;
  padding: 10px 12px;
  background-color: transparent;
}

@media (max-width: 991px) {
  .main .langChoice {
    right: 20px;
    top: 11px;
    padding: 8px;
  }
}
@media only screen and (max-width: 575px) {
  .main .langChoice {
    top: 14px;
    padding: 4px 7px;
  }
  .language-xs {
    margin-top: 15px;
  }
}
@media only screen and (max-width: 360px) {
  .language-header {
    padding-bottom: 60px !important;
  }
  .main .langChoice {
    left: 0;
    margin: 0 auto;
    top: 50px;
    width: 30%;
    right: 0;
  }
}
/**=====================
     74. internationalization CSS end
==========================**/
/**=====================
     72. Job CSS start
==========================**/
.filter-cards-view .job-filter:first-child {
  margin-bottom: 30px;
}
.filter-cards-view .checkbox-animated {
  margin-top: 30px;
  margin-bottom: 30px;
}

.location-checkbox span {
  color: #999999;
  padding-left: 33px;
}

.job-accordion .card {
  margin-bottom: 30px;
}
.job-accordion .btn-block {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.job-search p {
  margin-top: 30px;
}
.job-search .media .media-body h6, .job-search .media .media-body .h6 {
  margin-bottom: 3px;
}
.job-search .media .media-body h6 span, .job-search .media .media-body .h6 span {
  font-size: 13px;
  color: #999999;
  font-weight: normal;
}
.job-search .media .media-body h6 span.badge, .job-search .media .media-body .h6 span.badge {
  color: #fff;
}
.job-search .media .media-body p {
  margin-top: 0;
  color: #999999;
}
.job-search .job-description {
  margin-top: 30px;
}
.job-search .job-description h6, .job-search .job-description .h6 {
  font-weight: 600;
}
.job-search .job-description p {
  margin-top: 0;
  margin-bottom: 6px;
}
.job-search .job-description ul {
  list-style-type: disc;
  list-style-position: inside;
}
.job-search .job-description ul li {
  margin-bottom: 10px;
}
.job-search .job-description ul li:last-child {
  margin-bottom: 0;
}
.job-search .job-description .theme-form {
  margin-top: 30px;
  margin-bottom: 30px;
}
.job-search .job-description .theme-form .row div[class^=col-] + div[class^=col-] .select2-container {
  margin-top: 18px;
}
.job-search .job-description .theme-form .row div[class^=col-] .job-select2 ~ .select2-container {
  margin-top: 0 !important;
}
.job-search .job-description .theme-form .row div[class^=col-] .input-group .datepicker-here {
  font-size: 14px;
  border: 1px solid #efefef;
  padding-top: 12px;
  padding-bottom: 12px;
}

.select2-container .select2-selection--single {
  border-radius: 0.25rem !important;
  border-color: #efefef;
  height: 47px !important;
  padding: 10px;
}

.job-pagination {
  margin-bottom: 30px;
}
.job-pagination nav ul {
  justify-content: center;
}

@media only screen and (max-width: 1366px) {
  .xl-mt-job {
    margin-bottom: 20px;
  }
}
@media only screen and (max-width: 991px) {
  .filter-cards-view {
    padding: 20px !important;
  }
  .filter-cards-view .job-filter:first-child {
    margin-bottom: 20px;
  }
  .filter-cards-view .checkbox-animated {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .job-accordion .animate-chk {
    padding: 20px !important;
  }
  .job-search p {
    margin-top: 20px;
  }
}
@media only screen and (max-width: 575px) {
  .filter-cards-view {
    padding: 15px !important;
  }
  .filter-cards-view .job-filter:first-child {
    margin-bottom: 15px;
  }
  .filter-cards-view .checkbox-animated {
    margin-top: 15px;
    margin-bottom: 15px;
  }
  .job-accordion .animate-chk {
    padding: 15px !important;
  }
  .job-search p {
    margin-top: 15px;
  }
  .job-search .media {
    display: block;
    text-align: center;
  }
  .job-search .media .media-body h6 .pull-right, .job-search .media .media-body .h6 .pull-right {
    float: none;
    margin-top: 3px;
    display: block;
  }
  .job-search .media .media-body h6 a, .job-search .media .media-body .h6 a {
    display: block;
  }
  .job-search .media .media-body p span + span {
    display: block;
  }
  .job-search .media img {
    margin-bottom: 15px;
  }
  .job-search .media .m-r-20 {
    margin-right: 0;
  }
  .job-search .job-description {
    margin-top: 15px;
  }
  .job-search .job-description .theme-form {
    margin-top: 15px;
    margin-bottom: 15px;
  }
  .job-search .job-description .theme-form .row div[class^=col-] + div[class^=col-] .select2-container {
    margin-top: 2px;
  }
  .job-search .job-description .theme-form .xs-mt-period {
    margin-top: 15px;
  }
  .job-pagination {
    margin-bottom: 15px;
  }
  .xl-mt-job {
    margin-bottom: 15px;
  }
}
@media only screen and (max-width: 360px) {
  .job-search .job-description .btn {
    padding: 6px 12px;
  }
}
/**=====================
     72. Job CSS end
==========================**/
/**=====================
     31. JS datagrid CSS Start
==========================**/
.jsgrid .jsgrid-grid-body .jsgrid-cell {
  padding: 0.75rem;
}
.jsgrid .jsgrid-pager-container {
  text-align: right;
}
.jsgrid .jsgrid-pager {
  padding: 0;
  margin-top: 20px;
}
.jsgrid .jsgrid-pager .jsgrid-pager-nav-inactive-button {
  margin-right: -5px;
}
.jsgrid .jsgrid-pager .jsgrid-pager-nav-inactive-button:first-child {
  border-radius: 5px 0 0 5px;
}
.jsgrid .jsgrid-pager .jsgrid-pager-page ~ .jsgrid-pager-nav-button {
  margin-left: -5px;
}
.jsgrid .jsgrid-pager .jsgrid-pager-page ~ .jsgrid-pager-nav-button:last-child {
  border-radius: 0 5px 5px 0;
}
.jsgrid .jsgrid-pager [class*=jsgrid-pager] {
  display: inline-block;
  min-width: 1.5em;
  padding: 0.5em 1em;
  border: 1px solid #f4f4f4;
}
.jsgrid .jsgrid-pager .jsgrid-pager-page a {
  color: #2c323f;
}
.jsgrid .jsgrid-pager .jsgrid-pager-current-page {
  color: #2c323f;
}
.jsgrid .jsgrid-selected-row > .jsgrid-cell {
  background: #f4f4f4;
  border-color: #fafafa;
}
.jsgrid .jsgrid-header-row > .jsgrid-header-cell {
  padding: 0.75rem;
  font-weight: 500;
}

/**=====================
     31. JS datagrid CSS Ends
==========================**/
/**=====================
   61. base_inputs CSS start
==========================**/
.jkanban-container .btn {
  margin-bottom: 10px;
}
.jkanban-container .note a {
  display: contents;
}

.kanban-board-header {
  height: auto;
  width: auto;
  line-height: unset;
  background: #f8f8f8;
  border-bottom: 1px solid #ddd;
}
.kanban-board-header.bg-info ~ .kanban-drag {
  background-color: rgba(22, 199, 249, 0.3) !important;
}
.kanban-board-header.bg-warning ~ .kanban-drag {
  background-color: rgba(255, 170, 5, 0.3) !important;
}
.kanban-board-header.bg-success ~ .kanban-drag {
  background-color: rgba(84, 186, 74, 0.3) !important;
}

.kanban-container {
  display: contents;
}

.kanban-board {
  margin-bottom: 30px;
  transition: all 0.3s ease;
  letter-spacing: 0.5px;
  border-radius: 8px;
  box-shadow: 1px 5px 24px 0 rgba(68, 102, 242, 0.05);
  overflow: hidden;
  width: calc(33.3333333333% - 30px) !important;
}
.kanban-board .kanban-drag {
  background: #f8f8f8;
}

.kanban-item {
  background: transparent;
  padding: 0;
  margin-bottom: 20px;
}
.kanban-item p {
  opacity: 0.7;
}
.kanban-item:last-child {
  margin-bottom: 0;
}
.kanban-item .list {
  display: inline-block;
  opacity: 0.4;
}
.kanban-item .list li {
  display: inline-block;
  font-size: 12px;
}
.kanban-item .list li i {
  margin-right: 10px;
}
.kanban-item .kanban-box {
  border: 1px solid #efefef;
  border-radius: 5px;
  padding: 20px;
  position: relative;
  display: block;
  color: inherit;
  background-color: #fff;
}
.kanban-item .kanban-box:hover {
  color: inherit;
}
.kanban-item .kanban-box + .kanban-box {
  margin-top: 20px;
}
.kanban-item .kanban-box .badge {
  font-weight: 400;
}
.kanban-item .kanban-box h6, .kanban-item .kanban-box .h6 {
  font-size: 15px;
  margin-top: 5px;
  font-weight: 500;
}
.kanban-item .kanban-box .dropdown {
  display: inline-block;
  right: 10px;
  position: absolute;
  top: 20px;
}
.kanban-item .kanban-box .dropdown .dropdown-item {
  font-size: 13px;
  font-weight: 500;
  padding: 5px 10px;
  text-align: left;
}
.kanban-item .kanban-box .dropdown svg {
  height: 14px;
}
.kanban-item .kanban-box .d-flex {
  justify-content: space-between;
}
.kanban-item .kanban-box .dropdown-toggle:after {
  content: none;
}
.kanban-item .kanban-box .customers ul li + li {
  margin-left: -10px;
}
.kanban-item .kanban-box .date {
  font-size: 11px;
  opacity: 0.5;
}

footer {
  margin: 0;
  padding: 0;
}

@media only screen and (max-width: 1199px) {
  .jkanban-container .btn {
    margin-bottom: 10px;
    margin-left: 20px;
  }
  .kanban-container .kanban-board {
    width: 320px !important;
  }
}
@media only screen and (max-width: 600px) {
  .kanban-board .kanban-drag,
  .kanban-container .kanban-item .kanban-box {
    padding: 10px 15px;
  }
  .kanban-container .kanban-board {
    margin-left: 10px !important;
    margin-right: 10px !important;
  }
}
@media only screen and (max-width: 480px) {
  .jkanban-container .card-body {
    padding: 20px 0 !important;
  }
  .kanban-board .kanban-drag,
  .kanban-container .kanban-item .kanban-box {
    padding: 10px 15px;
  }
  .kanban-container .kanban-board {
    width: 270px !important;
  }
}
/**=====================
    61. base_inputs CSS ends
==========================**/
/**=====================
     73. knowledgebase CSS start
==========================**/
.browse .browse-articles span {
  vertical-align: middle;
  position: relative;
}
.browse .browse-articles span:nth-child(2) {
  padding-left: 20px;
}
[dir=rtl] .browse .browse-articles span:nth-child(2) {
  padding-left: unset;
  padding-right: 20px;
}
.browse .browse-articles span svg {
  width: 14px;
  height: 14px;
  margin-right: 10px;
  vertical-align: text-top;
  position: absolute;
  left: 0;
  top: 3px;
}
[dir=rtl] .browse .browse-articles span svg {
  left: unset;
  right: 0;
}
.browse .browse-articles h6, .browse .browse-articles .h6 {
  padding-bottom: 10px;
  margin-bottom: 0px;
  border-bottom: 1px solid #fdfeff;
  padding-left: 25px;
}
[dir=rtl] .browse .browse-articles h6, [dir=rtl] .browse .browse-articles .h6 {
  padding-left: unset;
  padding-right: 25px;
}
.browse .browse-articles h6 span svg, .browse .browse-articles .h6 span svg {
  width: 16px;
  height: 16px;
  vertical-align: text-top;
  top: 0;
  left: -30px;
}
[dir=rtl] .browse .browse-articles h6 span svg, [dir=rtl] .browse .browse-articles .h6 span svg {
  left: unset;
  right: -30px;
}
.browse .browse-articles ul li {
  padding: 8px !important;
  border-radius: 8px;
}
.browse .browse-articles ul li a {
  color: #2f2f3b;
}
.browse .browse-articles ul li:hover {
  background-color: #fdfeff;
}

@media only screen and (max-width: 1366px) {
  .browse div[class^=col-]:nth-child(3) {
    margin-top: 30px;
  }
}
@media only screen and (max-width: 360px) {
  .browse .browse-articles ul li a span:nth-child(2) {
    width: 158px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
  }
}
/**=====================
     73. knowledgebase CSS end
==========================**/
/**=====================
     76. Language CSS start
==========================**/
.current_lang {
  cursor: pointer;
  text-transform: uppercase;
  overflow: hidden;
}

.lang.selected {
  display: none;
}
.lang span.lang-txt {
  display: inline-flex;
  margin-left: 8px;
  font-weight: 500;
}
.lang span span {
  color: #999;
  font-weight: 400;
  margin-left: 5px;
}

/*more lang*/
.more_lang {
  transform: translateY(-20px);
  opacity: 0;
  cursor: pointer;
  display: none;
  transition: all 0.3s cubic-bezier(0.25, 1.15, 0.35, 1.15);
}

.translate_wrapper.active .more_lang {
  display: block;
  position: absolute;
  background-color: #fff;
  top: 47px;
  right: 0;
  box-shadow: 0 0 20px rgba(89, 102, 122, 0.1);
}
.translate_wrapper.active .more_lang:before {
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #fff;
  content: "";
  top: -7px;
  position: absolute;
  right: 20px;
  z-index: 2;
}
.translate_wrapper.active .more_lang:after {
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #bdc2c5;
  content: "";
  top: -7px;
  position: absolute;
  right: 20px;
  z-index: 1;
}

.more_lang.active {
  opacity: 1;
  transform: translateY(-0px);
}
.more_lang .lang {
  padding: 10px 15px;
  display: flex;
}
.more_lang .lang:hover {
  background: var(--theme-default);
  color: #fff;
}
.more_lang .lang:hover span {
  color: #fff;
}

.translate_wrapper.active .more_lang .lang {
  border-bottom: 1px solid #eaeaea;
}

/**=====================
     76. Language CSS end
==========================**/
/**=====================
     75. Learning CSS start
==========================**/
.learning-header {
  margin-bottom: 10px;
}

.categories {
  padding: 30px 0;
}
.categories .learning-header {
  padding-left: 15px;
}
.categories ul li {
  padding: 10px 15px !important;
}
.categories ul li a {
  color: #2f2f3b;
}
.categories ul li:hover {
  background-color: #f4f4f4;
}

.upcoming-course .media + .media {
  margin-top: 30px;
}

.job-accordion {
  margin-bottom: 0;
}

@media screen and (min-width: 1200px) and (max-width: 1366px) {
  .learning-comment {
    margin-left: -14px !important;
    float: left !important;
  }
  .blog-box .blog-details .blog-social li:first-child {
    padding-right: 30px;
  }
  .blog-box .blog-details .blog-social li + li {
    padding-left: 30px;
  }
}
@media only screen and (max-width: 991px) {
  .categories {
    padding: 20px 0;
  }
  .upcoming-course .media + .media {
    margin-top: 20px;
  }
}
@media only screen and (max-width: 575px) {
  .categories {
    padding: 15px 0;
  }
  .upcoming-course .media + .media {
    margin-top: 15px;
  }
}
/**=====================
     75. Learning CSS end
==========================**/
/**=====================
    25. Authentication CSS Start
==========================**/
.login-card {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
  background-position: center;
  padding: 30px 12px;
}
.login-card .logo {
  display: block;
  margin-bottom: 30px;
  text-align: center;
}
.login-card .btn-showcase .btn {
  line-height: 1;
  padding: 10px 15px;
  margin: 0;
}
.login-card .btn-showcase .btn + .btn {
  margin-left: 5px;
}
.login-card .btn-showcase .btn svg {
  height: 16px;
  vertical-align: bottom;
}
.login-card .login-main {
  width: 450px;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 0 37px rgba(8, 21, 66, 0.05);
  margin: 0 auto;
  background-color: #fff;
}
.login-card .login-main .theme-form h4, .login-card .login-main .theme-form .h4 {
  margin-bottom: 5px;
}
.login-card .login-main .theme-form label {
  font-size: 15px;
  letter-spacing: 0.4px;
}
.login-card .login-main .theme-form .checkbox label::before {
  background-color: #f9f9fa;
  border: 1px solid #dfdfdf;
}
.login-card .login-main .theme-form .or {
  position: relative;
}
.login-card .login-main .theme-form .or:before {
  content: "";
  position: absolute;
  width: 65%;
  height: 2px;
  background-color: #f3f3ff;
  top: 9px;
  z-index: 0;
  right: 0;
}
.login-card .login-main .theme-form input {
  background-color: #f3f3ff;
  transition: all 0.3s ease;
}
.login-card .login-main .theme-form input::-webkit-input-placeholder {
  color: #999999;
}
.login-card .login-main .theme-form input:hover, .login-card .login-main .theme-form input:focus {
  border: 1px solid rgb(72.6772604777%, 75.588699935%, 80.0678375616%);
  box-shadow: none !important;
  transition: all 0.3s ease;
}
.login-card .login-main .theme-form p {
  margin-bottom: 25px;
  font-size: 14px;
  color: #898989;
}
.login-card .login-main .theme-form .form-group {
  margin-bottom: 10px;
  position: relative;
}
.login-card .login-main .theme-form .link {
  position: absolute;
  top: 10px;
  right: 0;
}
.login-card .login-main.login-tab {
  position: relative;
  border-top-left-radius: 0;
  height: 100%;
}
.login-card .login-main.login-tab .nav-tabs {
  border-bottom: none;
  position: absolute;
  background-color: #fff;
  box-shadow: 0 0 37px rgba(8, 21, 66, 0.05);
  left: -70px;
  top: 0;
  margin-bottom: 0;
}
.login-card .login-main.login-tab .nav-tabs .nav-item .nav-link {
  position: relative;
}
.login-card .login-main.login-tab .nav-tabs .nav-item .nav-link img {
  filter: grayscale(100%);
  width: 20px;
  height: 20px;
  transition: 0.5s;
}
.login-card .login-main.login-tab .nav-tabs .nav-item .nav-link:after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
  top: 12px;
  border-width: 5px 0 5px 5px;
  border-left-color: rgb(90.8496732026%, 90%, 100%);
  opacity: 0;
  transform: scale(0);
  color: #fff;
  left: 14px;
  z-index: 2;
  transition: all 0.3s ease;
}
.login-card .login-main.login-tab .nav-tabs .nav-item .nav-link span {
  position: absolute;
  right: 0;
  width: max-content;
  text-align: right;
  padding: 7px 10px;
  display: block;
  top: 0;
  border-radius: 5px;
  transform: scale(0);
  transition: all 0.3s ease;
  opacity: 0;
  color: var(--theme-default);
  background-color: rgb(90.8496732026%, 90%, 100%);
  box-shadow: 0 0 37px rgba(8, 21, 66, 0.1);
}
.login-card .login-main.login-tab .nav-tabs .nav-item .nav-link:hover:after {
  opacity: 1;
  transform: scale(1);
  transition: all 0.3s ease;
}
.login-card .login-main.login-tab .nav-tabs .nav-item .nav-link:hover span {
  opacity: 1;
  right: 56px;
  transform: scale(1);
  transition: all 0.3s ease;
}
.login-card .login-main.login-tab .nav-tabs .nav-item .nav-link.active img {
  filter: initial;
  transition: 0.5s;
}
.login-card .login-main.login-tab .tab-content {
  height: 512px;
}
.login-card .login-main.login-tab .border-tab {
  border-radius: 0;
}
.login-card .login-main.login-tab .border-tab.nav-tabs .nav-item .nav-link {
  border-bottom: none;
  border-right: 2px solid transparent;
  border-top-right-radius: 0;
}
.login-card .login-main.login-tab .border-tab.nav-tabs .nav-item .nav-link.active, .login-card .login-main.login-tab .border-tab.nav-tabs .nav-item .nav-link.show, .login-card .login-main.login-tab .border-tab.nav-tabs .nav-item .nav-link:focus {
  border-right: 2px solid var(--theme-default);
  border-bottom: none;
}
.login-card .login-main.login-tab .auth-content {
  text-align: center;
}
.login-card .login-main.login-tab .auth-content img {
  height: 300px;
}

.show-hide {
  position: absolute;
  top: 52px;
  right: 20px;
  transform: translateY(-50%);
}
.show-hide span {
  cursor: pointer;
  font-size: 13px;
  color: var(--theme-default);
}
.show-hide span.show:before {
  content: "show";
}
.show-hide span:before {
  content: "hide";
}

.needs-validation .invalid-feedback {
  color: #898989;
}
.needs-validation .show-hide {
  right: 30px;
}
.needs-validation .invalid-tooltip {
  top: 10px;
  right: 10px;
}

/**=====================
    25. Authentication CSS Ends
==========================**/
/**=====================
   19. Mega option CSS Start
==========================**/
.mega-inline {
  margin-bottom: -30px;
  display: flex;
}
.mega-inline .card {
  border: 1px solid #f3f3f3;
  box-shadow: 0 0 10px 0 rgba(68, 102, 242, 0.05);
}
.mega-inline .mega-title-badge {
  display: table;
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
}
.mega-inline .media .radio {
  margin-left: 3px;
}

.mega-vertical {
  display: flex;
  flex-wrap: wrap;
}
.mega-vertical .card {
  box-shadow: 0 0 10px 0 rgba(68, 102, 242, 0.05);
}
.mega-vertical .mega-title-badge {
  display: table;
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
}
.mega-vertical .media .radio {
  margin-left: 3px;
}

.mega-title {
  font-weight: 600;
}

.mega-horizontal {
  display: flex;
  flex-wrap: wrap;
}
.mega-horizontal .card {
  border: 1px solid #f3f3f3;
  box-shadow: 0 0 10px 0 rgba(68, 102, 242, 0.05);
}
.mega-horizontal .mega-title-badge {
  display: table;
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
}
.mega-horizontal .media .radio {
  margin-left: 3px;
}

.plain-style .card {
  box-shadow: none;
  border: none !important;
}

.border-style .card {
  box-shadow: none;
  border: 1px solid #ecf3fa !important;
}

.offer-style .card {
  box-shadow: none;
  border: 1px dashed #ecf3fa !important;
}

.rating-star-wrapper {
  color: #797979;
}

/**=====================
     19. Mega option CSS Ends
==========================**/
/**=====================
     76. Order History CSS start
==========================**/
.prooduct-details-box .close {
  position: absolute;
  top: 10px;
  right: 10px;
  height: 16px;
  cursor: pointer;
}
.prooduct-details-box .media {
  border: 1px solid #d7e2e9;
  border-radius: 10px;
  padding: 15px 0;
  width: 100%;
  position: relative;
}
.prooduct-details-box .media .media {
  border: none;
  border-radius: 0;
  padding: 0;
}
.prooduct-details-box .rating {
  color: #ffaf45;
  letter-spacing: 3px;
}
.prooduct-details-box .product-name a {
  color: gray;
}
.prooduct-details-box .product-name h6, .prooduct-details-box .product-name .h6 {
  margin-bottom: 0;
}
.prooduct-details-box .btn {
  position: absolute;
  right: 15px;
  bottom: 15px;
}

.order-history .input-group {
  text-align: right;
  max-width: 300px;
}
.order-history table th,
.order-history table td {
  text-align: center;
}
.order-history table thead tr th {
  vertical-align: middle;
  border-top: none;
  background-color: #f8f8f8;
  border: 1px solid #ecf3fa;
  padding: 1.25rem;
  font-size: 16px;
}
.order-history table .qty-box {
  min-width: 270px;
  margin: 0 auto;
  border-radius: 5px;
  overflow: hidden;
}
.order-history table .qty-box input {
  width: 44px;
  max-width: 44px;
  background-color: transparent;
  border: none !important;
}
.order-history table .qty-box .input-group {
  align-items: center;
  background-color: transparent;
  border-radius: 5px;
  border: 1px solid #ecf3fa;
  overflow: hidden;
  display: inline-flex;
  width: unset;
}
.order-history table .qty-box .btn {
  background-color: transparent;
  border: none;
}
.order-history table .qty-box .btn.bootstrap-touchspin-down {
  border-right: 1px solid;
}
[dir=rtl] .order-history table .qty-box .btn.bootstrap-touchspin-down {
  border-right: unset;
  border-left: 1px solid;
}
.order-history table .qty-box .btn.bootstrap-touchspin-up {
  border-left: 1px solid;
}
[dir=rtl] .order-history table .qty-box .btn.bootstrap-touchspin-up {
  border-left: unset;
  border-right: 1px solid;
}
.order-history table tbody tr td {
  vertical-align: middle;
}
.order-history table tbody tr td .product-name {
  min-width: 160px;
}
.order-history table tbody tr td .product-name a {
  font-size: 15px;
  color: #898989;
}
.order-history table tbody tr td .product-name .order-process {
  font-size: 13px;
  padding-left: 15px;
}
.order-history table tbody tr td .product-name .order-process .order-process-circle {
  position: relative;
}
.order-history table tbody tr td .product-name .order-process .order-process-circle:before {
  position: absolute;
  content: "";
  width: 4px;
  height: 4px;
  border-radius: 100%;
  background-color: #898989;
  left: -15px;
  top: 4px;
}
.order-history table tbody tr td .product-name .order-process .order-process-circle.shipped-order:before {
  background-color: #54ba4a;
}
.order-history table tbody tr td .product-name .order-process .order-process-circle.cancel-order:before {
  background-color: #fc4438;
}

@media only screen and (max-width: 1199px) {
  .order-history table {
    width: 900px;
    overflow: auto;
  }
}
/**=====================
     76. Order History CSS end
==========================**/
/**=====================
     32. pagination CSS Start
==========================**/
/*test Nav bar color */
.pagination-theme .page-item .page-link {
  color: var(--theme-default) !important;
}
@media only screen and (max-width: 575px) {
  .pagination-theme .page-item .page-link {
    font-size: 13px;
  }
}
.pagination-theme .page-item.active .page-link {
  color: #fff !important;
  background-color: var(--theme-default) !important;
  border-color: var(--theme-default);
}

.pagination-primary .page-item .page-link {
  color: var(--theme-default) !important;
}
@media only screen and (max-width: 575px) {
  .pagination-primary .page-item .page-link {
    font-size: 13px;
  }
}
.pagination-primary .page-item.active .page-link {
  color: #fff !important;
  background-color: var(--theme-default) !important;
  border-color: var(--theme-default);
}

.pagination-secondary .page-item .page-link {
  color: #ff3364 !important;
}
@media only screen and (max-width: 575px) {
  .pagination-secondary .page-item .page-link {
    font-size: 13px;
  }
}
.pagination-secondary .page-item.active .page-link {
  color: #fff !important;
  background-color: #ff3364 !important;
  border-color: #ff3364;
}

.pagination-success .page-item .page-link {
  color: #54ba4a !important;
}
@media only screen and (max-width: 575px) {
  .pagination-success .page-item .page-link {
    font-size: 13px;
  }
}
.pagination-success .page-item.active .page-link {
  color: #fff !important;
  background-color: #54ba4a !important;
  border-color: #54ba4a;
}

.pagination-danger .page-item .page-link {
  color: #fc4438 !important;
}
@media only screen and (max-width: 575px) {
  .pagination-danger .page-item .page-link {
    font-size: 13px;
  }
}
.pagination-danger .page-item.active .page-link {
  color: #fff !important;
  background-color: #fc4438 !important;
  border-color: #fc4438;
}

.pagination-info .page-item .page-link {
  color: #16c7f9 !important;
}
@media only screen and (max-width: 575px) {
  .pagination-info .page-item .page-link {
    font-size: 13px;
  }
}
.pagination-info .page-item.active .page-link {
  color: #fff !important;
  background-color: #16c7f9 !important;
  border-color: #16c7f9;
}

.pagination-dark .page-item .page-link {
  color: #2c323f !important;
}
@media only screen and (max-width: 575px) {
  .pagination-dark .page-item .page-link {
    font-size: 13px;
  }
}
.pagination-dark .page-item.active .page-link {
  color: #fff !important;
  background-color: #2c323f !important;
  border-color: #2c323f;
}

.pagination-warning .page-item .page-link {
  color: #ffaa05 !important;
}
@media only screen and (max-width: 575px) {
  .pagination-warning .page-item .page-link {
    font-size: 13px;
  }
}
.pagination-warning .page-item.active .page-link {
  color: #fff !important;
  background-color: #ffaa05 !important;
  border-color: #ffaa05;
}

/**=====================
     32. pagination CSS Ends
==========================**/
/**=====================
     34. Pricing CSS Start
==========================**/
.pricing-simple {
  box-shadow: 0 0 10px 5px rgba(68, 102, 242, 0.05);
  margin-bottom: 0 !important;
}
.pricing-simple .card-body {
  border-bottom: none;
}
.pricing-simple .card-body h3, .pricing-simple .card-body .h3 {
  position: relative;
  margin-bottom: 38px;
}
.pricing-simple .card-body h3:before, .pricing-simple .card-body .h3:before {
  position: absolute;
  content: "";
  width: 80px;
  height: 1px;
  margin: 0 auto;
  left: 0;
  right: 0;
  bottom: -10px;
  background-color: #999999;
}
.pricing-simple .card-body h1, .pricing-simple .card-body .h1 {
  font-size: 30px;
  line-height: 0.9;
  margin-bottom: 30px;
  font-weight: 400;
}

.pricingtable {
  text-align: center;
  padding-top: 45px;
  padding-bottom: 45px;
  border-radius: 10px;
  box-shadow: 0 0 40px rgba(8, 21, 66, 0.05);
  overflow: hidden;
  position: relative;
  z-index: 1;
  height: 100%;
}
.pricingtable:before, .pricingtable:after {
  content: "";
  background-color: var(--theme-default);
  width: 300px;
  height: 300px;
  border-radius: 50%;
  position: absolute;
  right: -213px;
  z-index: -1;
  opacity: 0.1;
}

.pricingtable:after {
  background-color: var(--theme-default);
  height: 300px;
  width: 300px;
  top: auto;
  bottom: -210px;
  right: auto;
  left: -160px;
  opacity: 0.1;
}
.pricingtable .title {
  text-transform: uppercase;
  margin-bottom: 20px;
}
.pricingtable .price-value {
  color: #fff;
  background-color: var(--theme-default);
  width: 130px;
  height: 130px;
  padding: 45px 0 0;
  margin: 0 auto 25px;
  border-radius: 50%;
}
.pricingtable .price-value .duration {
  margin: 0 0 0 -5px;
}
.pricingtable .price-value .amount {
  font-size: 58px;
  font-weight: 700;
  line-height: 45px;
  display: inline-block;
}
.pricingtable .price-value .currency {
  vertical-align: top;
}
.pricingtable .pricing-content {
  margin: 0 0 25px;
  display: inline-block;
}
.pricingtable .pricing-content li {
  font-weight: 500;
  text-align: left;
  margin: 0 0 20px;
  position: relative;
  padding-left: 30px;
}
.pricingtable .pricing-content li:last-child {
  margin: 0;
}
.pricingtable .pricing-content li:before {
  content: "\\f00c";
  color: var(--theme-default);
  font-family: FontAwesome;
  text-align: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  position: absolute;
  top: 1px;
  left: 0;
}

@media (max-width: 1470px) {
  .pricing-block > div {
    flex: 50% 1;
  }
  .pricing-block > div:nth-child(n+3) {
    margin-top: 30px;
  }
}
@media only screen and (max-width: 991px) {
  .pricing-simple .card-body h1, .pricing-simple .card-body .h1 {
    margin-bottom: 20px;
  }
  .pricing-simple .card-body h3, .pricing-simple .card-body .h3 {
    margin-bottom: 28px;
  }
  .pricing-block > div:nth-child(n+2) {
    margin-top: 20px;
  }
}
@media only screen and (max-width: 575px) {
  .pricing-simple .card-body h1, .pricing-simple .card-body .h1 {
    margin-bottom: 15px;
  }
  .pricing-block > div {
    flex: 100% 1;
  }
  .pricingtable {
    padding-top: 30px;
    padding-bottom: 30px;
  }
}
/**=====================
    34. Pricing CSS Ends
==========================**/
/**=====================
     23. Progress CSS Start
==========================**/
.progress-showcase .progress {
  margin-bottom: 10px;
}
.progress-showcase .progress:last-child {
  margin-bottom: 0;
}

.sm-progress-bar {
  height: 5px;
}

.lg-progress-bar {
  height: 20px;
}

/**=====================
     23. Progress CSS Ends
==========================**/
.project-list .row {
  margin: 15px;
}
.project-list button:focus {
  outline: none !important;
}
.project-list .theme-form .form-group {
  margin-bottom: 15px;
}
.project-list .border-tab.nav-tabs .nav-item .nav-link {
  border: 1px solid transparent;
  padding: 5px 30px 5px 0;
  border-radius: 5px;
  display: flex;
  align-items: center;
}
.project-list .btn {
  margin-right: 5px;
  vertical-align: -12px;
  float: right;
}
[dir=rtl] .project-list .btn {
  float: left;
}
.project-list .btn svg {
  vertical-align: middle;
  height: 16px;
}
.project-list ul {
  margin-bottom: 0 !important;
  border-bottom: 0;
}
.project-list ul li svg {
  height: 18px;
  vertical-align: middle;
  margin-right: 5px;
}

.tab-content .row > div.col-xl-4:nth-child(1) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 100000ms;
}
.tab-content .row > div.col-xl-4:nth-child(2) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 200000ms;
}
.tab-content .row > div.col-xl-4:nth-child(3) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 300000ms;
}
.tab-content .row > div.col-xl-4:nth-child(4) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 400000ms;
}
.tab-content .row > div.col-xl-4:nth-child(5) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 500000ms;
}
.tab-content .row > div.col-xl-4:nth-child(6) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 600000ms;
}
.tab-content .row > div.col-xl-4:nth-child(7) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 700000ms;
}
.tab-content .row > div.col-xl-4:nth-child(8) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 800000ms;
}
.tab-content .row > div.col-xl-4:nth-child(9) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 900000ms;
}
.tab-content .row > div.col-xl-4:nth-child(10) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 1000000ms;
}
.tab-content .row > div.col-xl-4:nth-child(11) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 1100000ms;
}
.tab-content .row > div.col-xl-4:nth-child(12) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 1200000ms;
}
.tab-content .row > div.col-xl-4:nth-child(13) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 1300000ms;
}
.tab-content .row > div.col-xl-4:nth-child(14) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 1400000ms;
}
.tab-content .row > div.col-xl-4:nth-child(15) {
  animation-fill-mode: both;
  animation: fadeIncustom 0.5s linear 1500000ms;
}

.project-cards .tab-content {
  margin-bottom: -30px;
}

.project-box {
  border: 1px solid #efefef;
  border-radius: 5px;
  padding: 30px;
  background-color: white;
  margin-bottom: 30px;
}
.project-box h6, .project-box .h6 {
  font-weight: 500 !important;
}
.project-box .badge {
  position: absolute;
  right: 30px;
  top: 15px;
}
.project-box .project-status p {
  margin-bottom: 5px;
  font-weight: 800;
}
.project-box .media {
  margin-bottom: 15px;
}
.project-box .media .media-body {
  opacity: 0.5;
}
.project-box .details div {
  margin-bottom: 5px;
  opacity: 0.7;
}

.projectdetails .card .card-body {
  padding: 20px;
}
.projectdetails .card .card-footer {
  padding: 20px;
}
.projectdetails .card select {
  width: 90px;
  height: 28px;
  font-size: 11px;
  right: 20px;
  top: 20px;
}

.projectmore .details .col-4 {
  margin-bottom: 5px;
}
.projectmore .details .col-4:nth-child(even) {
  opacity: 0.5;
}
.projectmore h5, .projectmore .h5 {
  font-size: 20px;
  font-weight: 600;
}
.projectmore .task-list {
  position: relative;
}
.projectmore .task-list ul li {
  margin-bottom: 5px;
}
.projectmore .task-list ul + ul {
  position: absolute;
  left: 50%;
  top: 0;
}

.new-users.activity .gradient-round {
  padding: 13px;
  font-size: 20px;
  line-height: 1.4;
  text-align: center;
  top: unset !important;
}
.new-users.activity .gradient-round::after {
  display: none;
}

/**=====================
     79. social app css start
==========================**/
.user-profile .hovercard .socialheader {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
}
.user-profile .hovercard .user-image .share-icons {
  position: absolute;
  right: 100px;
  top: -27px;
}
.user-profile .hovercard .user-image .share-icons li {
  display: inline-block;
  margin-right: 10px;
}
.user-profile .hovercard .user-image .share-icons li .social-icon {
  width: 50px;
  height: 50px;
  text-align: center;
  display: flex;
  align-items: center;
  vertical-align: middle;
  justify-content: center;
  border-radius: 100%;
}
.user-profile .hovercard .user-image .share-icons li .social-icon i {
  color: #fff;
  font-size: 25px;
}
.user-profile .hovercard .user-image .share-icons li:last-child {
  margin-right: 0;
}
.user-profile .card-footer > div h3, .user-profile .card-footer > div .h3 {
  font-size: 16px;
}

.market-tabs .border-tab.nav-tabs .nav-item .nav-link.active {
  border-bottom: none !important;
}
.market-tabs .nav {
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
}
.market-tabs .nav .nav-item {
  width: 100%;
}
.market-tabs .nav .nav-item .nav-link {
  height: 81px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  padding-top: 30px;
  text-align: center;
}

.tabs-scoial {
  border-bottom: none;
  margin-bottom: 20px !important;
  margin-top: 20px;
}
.tabs-scoial li a {
  font-weight: 600;
}
.tabs-scoial li a svg circle {
  color: #999999;
}

.social-network span {
  margin-bottom: 30px;
  display: block;
}

.social-list .media {
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.social-list .media:last-child {
  margin-bottom: 0;
}
.social-list .media .media-body a {
  color: #999999;
}
.social-list .media .media-body span {
  font-weight: 600;
}
.social-list .media .media-body:hover a {
  color: var(--theme-default);
}

.photos {
  margin-bottom: -15px;
}
.photos ul li {
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 10px;
  width: 70px;
}
.photos ul li:nth-child(4n) {
  margin-right: 0;
}

.new-users-social {
  margin-bottom: 30px;
}
.new-users-social svg {
  cursor: pointer;
}
.new-users-social .media img {
  width: 58px;
}
.new-users-social .media .media-body {
  margin-top: 10px;
}
.new-users-social svg circle {
  color: #999999;
}

.like-content span i {
  font-size: 14px;
}

.timeline-content p {
  margin-top: 30px;
  color: #999999;
}
.timeline-content .comment-number i {
  color: #999999;
  margin-right: 20px;
}
.timeline-content .comments-box {
  margin-top: 30px;
}
.timeline-content .comments-box .input-group {
  margin-top: 6px;
}
.timeline-content .comments-box .input-group .input-txt-bx {
  border: none;
}
.timeline-content .comments-box .input-group .input-txt-bx::placeholder {
  color: #999999;
}
.timeline-content .comments-box .input-group .input-group-append .btn i {
  font-size: 20px;
  display: flex;
  color: #999999;
}

.social-chat {
  margin-top: 30px;
}
.social-chat span span {
  font-weight: normal;
  color: #999999;
  font-size: 12px;
}
.social-chat .media-body {
  padding: 30px;
  border: 1px solid #f4f4f4;
  position: relative;
}
.social-chat .media-body p {
  margin-top: 5px;
}
.social-chat .media-body:before {
  content: "";
  position: absolute;
  top: 19px;
  right: 100%;
  border: 7px solid transparent;
  border-right: 7px solid #59667a;
}
.social-chat .media-body:after {
  content: "";
  position: absolute;
  top: 19px;
  right: 100%;
  border: 7px solid transparent;
  border-right: 7px solid #fff;
}
.social-chat .your-msg,
.social-chat .other-msg {
  margin-bottom: 30px;
}
.social-chat .other-msg {
  margin-left: 40px;
}

.socialprofile span {
  color: #999999;
}
.socialprofile .social-btngroup {
  margin: 30px 0;
}
.socialprofile .likes-profile h5 span, .socialprofile .likes-profile .h5 span {
  color: #2f2f3b;
}
.socialprofile .social-group {
  margin-top: 30px;
}
.socialprofile .social-group ul li:nth-child(4) {
  margin-left: -22px;
}

.social-status form .form-group .form-control-social {
  border: 1px solid #f4f4f4;
  padding-left: 15px;
  margin-bottom: 30px;
}
.social-status .media {
  position: relative;
  margin-bottom: 30px;
}
.social-status .media:last-child {
  margin-bottom: 0;
}
.social-status .media .social-status {
  content: "";
  position: absolute;
  width: 12px;
  height: 12px;
  background-color: #fff;
  bottom: 0;
  left: 35px;
  border-radius: 100%;
}
.social-status .media .social-online {
  border: 3px solid #54ba4a;
}
.social-status .media .social-busy {
  border: 3px solid #ffaa05;
}
.social-status .media .social-offline {
  border: 3px solid #59667a;
}
.social-status .media .media-body p {
  color: #999999;
  margin-bottom: 5px;
}
.social-status .media .media-body span + span {
  color: #999999;
}
.social-status .media .media-body .light-span {
  color: #999999;
}

.social-header h5 span:first-child, .social-header .h5 span:first-child {
  line-height: 1.48;
}
.social-header h5 span svg circle, .social-header .h5 span svg circle {
  color: #999999;
}

.details-about + .details-about {
  margin-top: 30px;
}
.details-about .your-details p {
  color: #999999;
}

.avatar-showcase .friend-pic {
  margin-right: 8px;
  margin-bottom: 10px;
}
.avatar-showcase .pepole-knows ul li {
  display: inline-block;
  margin-right: 20px;
  margin-bottom: 10px;
}
.avatar-showcase .pepole-knows ul li:last-child {
  margin-right: 0;
}
.avatar-showcase .pepole-knows ul li .add-friend h6, .avatar-showcase .pepole-knows ul li .add-friend .h6 {
  margin-top: 3px;
}

.activity-log .my-activity + .my-activity {
  margin-top: 30px;
}
.activity-log .my-activity p {
  margin-bottom: 5px;
}
.activity-log .my-activity p span svg {
  width: 15px;
  height: 15px;
}

/**=====================
     79. social app CSS end
==========================**/
/**=====================
     87. task app CSS Start
==========================**/
.modal-open .datepickers-container {
  z-index: 1075;
}

.date-details {
  align-items: center;
}
.date-details > div + div {
  margin-left: 10px;
}

.taskadd table tr td {
  border-top: none;
}
.taskadd table tr td:first-child {
  padding-left: 30px;
}
.taskadd table tr td:last-child {
  padding-right: 30px;
}
.taskadd table tr td svg {
  width: 18px;
  height: 18px;
  color: #59667a;
}
.taskadd table tr:first-child td {
  padding-top: 30px;
}
.taskadd table tr:last-child td {
  padding-bottom: 30px;
}

@media only screen and (max-width: 1660px) {
  .taskadd table tr td:first-child {
    min-width: 160px;
  }
  .taskadd table tr td:nth-child(3) {
    min-width: 70px;
  }
}
@media only screen and (max-width: 991px) {
  .date-details {
    display: block !important;
    margin-bottom: -10px;
  }
  .date-details .d-inline-block {
    margin-bottom: 10px;
  }
  .taskadd table tr td:first-child {
    padding-left: 20px;
  }
  .taskadd table tr:first-child td {
    padding-top: 20px;
  }
  .taskadd table tr:last-child td {
    padding-bottom: 20px;
  }
}
@media only screen and (max-width: 767px) {
  .taskadd table tr td:nth-child(2) {
    min-width: 745px;
  }
}
@media only screen and (max-width: 575px) {
  .taskadd table tr td:first-child {
    padding-left: 15px;
  }
  .taskadd table tr:first-child td {
    padding-top: 15px;
  }
  .taskadd table tr:last-child td {
    padding-bottom: 15px;
  }
}
/**=====================
   87. task app CSS Ends
==========================**/
/**=====================
     42. Timeline CSS Start
==========================**/
.activity .media {
  margin-bottom: 30px;
}
.activity .media:last-child {
  margin-bottom: 0;
}
.activity .media .gradient-round {
  position: relative;
  width: 53px;
  height: 53px;
  background-image: linear-gradient(26deg, var(--theme-default) 0%, #a26cf8 100%);
  border-radius: 100%;
  top: -18px;
}
.activity .media .gradient-round svg {
  position: absolute;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
  top: 18px;
  right: 0;
  margin: 0 auto;
}
.activity .media .gradient-round svg path,
.activity .media .gradient-round svg line,
.activity .media .gradient-round svg circle {
  color: #fff;
}
.activity .media .gradient-round.gradient-line-1:after {
  position: absolute;
  content: "";
  background-color: #e9e9e9;
  width: 2px;
  height: 62px;
  bottom: -77px;
  left: 0;
  right: 0;
  margin: 0 auto;
}
.activity .media .gradient-round.small-line:after {
  position: absolute;
  content: "";
  background-color: #e9e9e9;
  width: 2px;
  height: 19px;
  bottom: -34px;
  left: 0;
  right: 0;
  margin: 0 auto;
}
.activity .media .gradient-round.medium-line:after {
  position: absolute;
  content: "";
  background-color: #e9e9e9;
  width: 2px;
  height: 53px;
  bottom: -68px;
  left: 0;
  right: 0;
  margin: 0 auto;
}
.activity .media .media-body h6, .activity .media .media-body .h6 {
  font-weight: 600;
  margin-bottom: 30px;
}
.activity .media .media-body h6 span, .activity .media .media-body .h6 span {
  font-weight: normal;
  color: #999999;
}
.activity .media .media-body p {
  width: 80%;
}

.timeline-small .media {
  margin-bottom: 30px;
}
.timeline-small .media:last-child {
  margin-bottom: 0;
}
.timeline-small .media .timeline-round {
  position: relative;
  width: 53px;
  height: 53px;
  border-radius: 100%;
  border-radius: 15px;
  top: -18px;
}
.timeline-small .media .timeline-round svg {
  position: absolute;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
  top: 18px;
  right: 0;
  margin: 0 auto;
}
.timeline-small .media .timeline-round svg path,
.timeline-small .media .timeline-round svg line,
.timeline-small .media .timeline-round svg circle {
  color: #fff;
}
.timeline-small .media .timeline-round.timeline-line-1:after {
  position: absolute;
  content: "";
  background-color: #e9e9e9;
  width: 2px;
  height: 62px;
  bottom: -88px;
  left: 0;
  right: 0;
  margin: 0 auto;
}
.timeline-small .media .timeline-round.small-line:after {
  position: absolute;
  content: "";
  background-color: #e9e9e9;
  width: 2px;
  height: 19px;
  bottom: -34px;
  left: 0;
  right: 0;
  margin: 0 auto;
}
.timeline-small .media .timeline-round.medium-line:after {
  position: absolute;
  content: "";
  background-color: #e9e9e9;
  width: 2px;
  height: 53px;
  bottom: -68px;
  left: 0;
  right: 0;
  margin: 0 auto;
}
.timeline-small .media .media-body h6, .timeline-small .media .media-body .h6 {
  margin-bottom: 30px;
}
.timeline-small .media .media-body h6 span, .timeline-small .media .media-body .h6 span {
  font-weight: normal;
  color: #999999;
}
.timeline-small .media .media-body p {
  width: 80%;
}

.cd-container {
  width: 90%;
  max-width: 1170px;
  margin: 0 auto;
}

.cd-container::after {
  content: "";
  display: table;
  clear: both;
}

@media only screen and (min-width: 1170px) {
  #cd-timeline::before {
    left: 50% !important;
    margin-left: -2px;
  }
  .cd-timeline-block {
    margin: 4em 0;
  }
  .cd-timeline-block:first-child {
    margin-top: 0;
  }
  .cd-timeline-block:last-child {
    margin-bottom: 0;
  }
  .cd-timeline-block:nth-child(even) .cd-timeline-content {
    float: right;
  }
  .cd-timeline-block:nth-child(even) .cd-timeline-content .cd-date {
    left: auto;
    right: 122%;
    text-align: right;
  }
  .cd-timeline-block:nth-child(even) .cd-timeline-content::before {
    top: 24px;
    left: auto;
    right: 100%;
    border-color: transparent;
    border-right-color: #f4f4f4;
  }
  .cd-timeline-img {
    width: 60px;
    height: 60px;
    left: 50%;
    margin-left: -30px;
  }
  .cd-timeline-img > i {
    font-size: 18px;
    top: 50%;
    left: 50%;
    padding: 3px;
  }
  .cssanimations .cd-timeline-img.is-hidden {
    visibility: hidden;
  }
  .cssanimations .cd-timeline-img.bounce-in {
    visibility: visible;
    animation: cd-bounce-1 0.6s;
  }
  .cssanimations .cd-timeline-content.is-hidden {
    visibility: hidden;
  }
  .cssanimations .cd-timeline-content.bounce-in {
    visibility: visible;
    animation: cd-bounce-2 0.6s;
  }
  .cssanimations .cd-timeline-block:nth-child(even) .cd-timeline-content.bounce-in {
    animation: cd-bounce-2-inverse 0.6s;
  }
  .cd-timeline-content {
    margin-left: 0;
    padding: 1.6em;
    width: 45%;
  }
  .cd-timeline-content .cd-date {
    position: absolute;
    width: 100%;
    left: 122%;
    top: 6px;
    font-size: 16px;
  }
  .cd-timeline-content::before {
    top: 24px;
    left: 100%;
    border-color: transparent;
    border-left-color: #fff;
  }
}
#cd-timeline {
  position: relative;
  padding: 2em 0;
}

#cd-timeline::before {
  content: "";
  position: absolute;
  top: 0;
  font-size: 1.5rem;
  height: 100%;
  width: 2px;
  background: #f4f4f4;
  left: -15px;
}

.cd-timeline-block {
  position: relative;
  margin: 30px 0;
}
.cd-timeline-block:after {
  content: "";
  display: table;
  clear: both;
}
.cd-timeline-block:first-child {
  margin-top: 0;
}
.cd-timeline-block:last-child {
  margin-bottom: 0;
}

.cd-timeline-img {
  width: 60px;
  height: 60px;
  left: 50%;
  margin-left: -30px;
  -webkit-transform: translateZ(0);
  -webkit-backface-visibility: hidden;
  position: absolute;
  top: 0;
  border-radius: 4px;
}
.cd-timeline-img i {
  display: block;
  position: relative;
  left: 45%;
  top: 44%;
  margin-left: -12px;
  margin-top: -12px;
  font-size: 27px;
  color: #fff;
}
@keyframes cd-bounce-1 {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  60% {
    opacity: 1;
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
.cd-timeline-content {
  position: relative;
  background: #fdfeff;
  border-radius: 4px;
  padding: 30px;
  box-shadow: 1px 1px 2px 1px rgba(0, 0, 0, 0.08);
}
.cd-timeline-content p {
  padding-top: 9px;
}
.cd-timeline-content h4, .cd-timeline-content .h4 {
  margin-bottom: 0;
}
.cd-timeline-content:after {
  content: "";
  display: table;
  clear: both;
}
.cd-timeline-content audio {
  width: 100%;
}
.cd-timeline-content .cd-date {
  font-size: 13px;
  display: inline-block;
  float: left;
  padding: 0.8em 0 0;
  opacity: 0.7;
}

.cd-timeline-content::before {
  content: "";
  position: absolute;
  top: 16px;
  right: 100%;
  height: 0;
  width: 0;
  border: 7px solid transparent;
  border-left: 7px solid #f4f4f4;
}

@media only screen and (min-width: 768px) {
  .cd-timeline-content .cd-date {
    font-size: 14px;
    padding-bottom: 0;
  }
}
@keyframes cd-bounce-2 {
  0% {
    opacity: 0;
    transform: translateX(-100px);
  }
  60% {
    opacity: 1;
    transform: translateX(20px);
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes cd-bounce-2-inverse {
  0% {
    opacity: 0;
    transform: translateX(100px);
  }
  60% {
    opacity: 1;
    transform: translateX(-20px);
  }
  100% {
    transform: translateX(0);
  }
}
@media only screen and (max-width: 1169px) {
  .cd-timeline-block .cd-timeline-img {
    left: -2px;
    height: 30px;
    width: 30px;
    margin-left: -30px;
    top: 14px;
    z-index: 7;
  }
  .cd-timeline-block .cd-timeline-img > i {
    font-size: 15px;
    top: 16px;
    left: 17px;
    padding: 3px;
  }
  .landing-main #cd-timeline::before {
    left: -39px;
  }
  .landing-main .cd-timeline-block .cd-timeline-img {
    left: -34px;
    height: 50px;
    width: 50px;
    top: 1px;
    z-index: 8;
  }
  .landing-main .cd-timeline-block .cd-timeline-img > i {
    font-size: 23px;
    top: 21px;
    left: 7px;
    padding: 3px;
  }
}
@media only screen and (max-width: 576px) {
  .cd-timeline-content {
    padding: 15px;
  }
  .cd-timeline-content h4, .cd-timeline-content .h4 {
    font-size: 18px;
  }
}
/**=====================
     42. Timeline  CSS Ends
==========================**/
/**=====================
    43. Timeline 2 CSS Start
==========================**/
.timeliny {
  position: relative;
  display: block;
  padding: 10rem 0;
  width: 100%;
  border-top: 1px solid rgb(98.6862745098%, 98.6862745098%, 98.6862745098%);
  border-bottom: 1px solid rgb(98.6862745098%, 98.6862745098%, 98.6862745098%);
  text-rendering: optimizeLegibility;
  color: #f4f4f4;
  opacity: 0;
  overflow: hidden;
  cursor: move;
}
.timeliny.loaded {
  opacity: 1;
}
.timeliny::before {
  content: "";
  position: absolute;
  background-color: #898989;
  width: 100%;
  height: 1px;
  top: 50%;
  left: 0;
}
.timeliny .timeliny-wrapper {
  display: block;
  margin: auto;
  width: 100%;
  max-width: 1024px;
}
.timeliny .timeliny-dot {
  transition: all 0.35s ease-in-out;
  display: block;
  position: absolute;
  top: 50%;
  left: 0;
  margin-top: -0.6rem;
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 50%;
  border: 1px solid #898989;
  background-color: #fff;
}
.timeliny .timeliny-dot::before {
  transition: all 0.35s ease-in-out;
  content: attr(data-year);
  display: block;
  position: absolute;
  top: -5rem;
  left: 1.25rem;
  color: #2c323f;
  font-family: Rubik, sans-serif;
  font-size: 22px;
}
.timeliny .timeliny-dot::after {
  transition: all 0.35s ease-in-out;
  transform: translateY(-50%);
  content: attr(data-text);
  display: block;
  position: absolute;
  width: 256px;
  top: 5.6rem;
  left: 1.25rem;
  color: #f4f4f4;
  opacity: 0;
  font-size: 0.9em;
}
@media (min-width: 768px) {
  .timeliny .timeliny-dot::after {
    width: 341.3333333333px;
  }
}
.timeliny .timeliny-timeline {
  position: absolute;
  top: 50%;
  left: 0;
  display: table;
  width: 100%;
  z-index: 5;
}
.timeliny .timeliny-timeline .timeliny-timeblock {
  display: table-cell;
  position: relative;
}
.timeliny .timeliny-timeline .timeliny-timeblock.active .timeliny-dot {
  border-color: var(--theme-default);
  background-color: var(--theme-default);
  box-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.33);
}
.timeliny .timeliny-timeline .timeliny-timeblock.active .timeliny-dot::before {
  color: #2c323f;
}
.timeliny .timeliny-timeline .timeliny-timeblock.active .timeliny-dot::after {
  color: #2c323f;
  opacity: 1;
  background-color: white;
  border: 1px solid #efefef;
  padding: 10px;
  border-radius: 5px;
}
.timeliny .timeliny-timeline .timeliny-timeblock.inactive .timeliny-dot {
  cursor: move;
}
.timeliny .timeliny-timeline .timeliny-timeblock.inactive .timeliny-dot::before {
  color: #f4f4f4;
}
.timeliny .timeliny-timeline .timeliny-timeblock:not(.inactive):not(.active) .timeliny-dot:hover {
  border-color: #2c323f;
  background-color: #2c323f;
}
.timeliny .timeliny-timeline .timeliny-timeblock:not(.inactive):not(.active) .timeliny-dot:hover::before {
  color: #2c323f;
}
.timeliny .timeliny-timeline .timeliny-timeblock .timeliny-dot:hover::after {
  color: #2c323f;
  opacity: 1;
  background-color: #fff;
  border: 1px solid #efefef;
  padding: 10px;
  border-radius: 5px;
}
.timeliny .timeliny-vertical-line {
  position: absolute;
  display: block;
  z-index: 1;
  left: 16%;
  top: 0;
  width: 1px;
  height: 100%;
  background-color: var(--theme-default);
}
@media (min-width: 768px) {
  .timeliny .timeliny-vertical-line {
    left: 32%;
  }
}
.timeliny .timeliny-vertical-line::before {
  content: "";
  position: absolute;
  top: 0;
  left: -7px;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid var(--theme-default);
}
.timeliny .timeliny-vertical-line::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: -7px;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid var(--theme-default);
}

/**=====================
     43. Timeline 2 CSS Ends
==========================**/
/**=====================
     22. User profile css start
==========================**/
.user-profile .ttl-info h6, .user-profile .ttl-info .h6 {
  font-size: 12px;
  color: #59667a;
}
.user-profile .border-right {
  border-right: 1px solid #f4f4f4;
}
.user-profile hr {
  margin: 30px 0;
}
.user-profile .hovercard .cardheader {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
  background-size: cover;
  background-position: 10%;
  height: 470px;
}
.user-profile .hovercard .user-image {
  position: relative;
  height: 0;
}
.user-profile .hovercard .user-image .avatar {
  margin-top: -80px;
}
.user-profile .hovercard .user-image .avatar img {
  width: 100px;
  height: 100px;
  max-width: 155px;
  max-height: 155px;
  border-radius: 50%;
  border: 7px solid #fff;
}
.user-profile .hovercard .user-image .icon-wrapper {
  position: absolute;
  bottom: -20px;
  left: 51%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background-color: #fff;
  cursor: pointer;
  overflow: hidden;
  margin: 0 auto;
  font-size: 17px;
  box-shadow: 0 0 6px 3px rgba(68, 102, 242, 0.1);
}
.user-profile .hovercard .user-image .icon-wrapper .upload {
  position: absolute;
  left: 0;
  right: 0;
  opacity: 0;
}
.user-profile .hovercard .info {
  padding: 30px;
}
.user-profile .hovercard .info .title {
  margin-bottom: 4px;
  font-size: 24px;
  line-height: 1;
  color: #2c323f;
  vertical-align: middle;
}
.user-profile .hovercard .info .title a {
  color: #242934;
  font-size: 20px;
  text-transform: uppercase;
  font-weight: 500;
}
.user-profile .hovercard .info .desc {
  overflow: hidden;
  font-size: 14px;
  line-height: 20px;
  color: #59667a;
  text-overflow: ellipsis;
  text-transform: uppercase;
}
.user-profile .follow {
  margin-top: 20px;
}
.user-profile .follow .follow-num {
  font-size: 20px;
  color: #242934;
  font-family: Rubik, sans-serif;
  font-weight: 500;
}
.user-profile .follow span {
  color: #59667a;
}
.user-profile .profile-img-style {
  padding: 30px;
}
.user-profile .profile-img-style .img-container {
  margin-top: 30px;
}
.user-profile .profile-img-style .user-name {
  font-size: 14px;
  color: #242934;
  margin: 0;
  font-weight: 600;
}
.user-profile .profile-img-style p {
  line-height: 30px;
  font-size: 14px;
  color: #898989;
  margin-bottom: 0;
}
.user-profile .profile-img-style .media img {
  width: 50px;
}
.user-profile .like-comment a {
  color: #898989;
}
.user-profile .like-comment a:hover {
  color: #fc4438;
}
.user-profile .like-comment span {
  font-family: Rubik, sans-serif;
}
.user-profile .social-media a {
  padding: 0 15px;
  color: #59667a;
  font-size: 24px;
  cursor: pointer;
}
.user-profile .social-media a:hover {
  color: var(--theme-default);
}

.edit-profile .profile-title .media {
  align-items: center;
  margin-bottom: 30px;
}
.edit-profile .profile-title .media .media-body {
  margin-left: 14px;
}
.edit-profile .profile-title .media .media-body a {
  color: #2f2f3b;
}
[dir=rtl] .edit-profile .profile-title .media .media-body {
  margin-left: unset;
  margin-right: 14px;
}

/**=====================
     22. User profile css Ends
==========================**/
/**=====================
    83. Wishlist CSS start
==========================**/
.wishlist table tr td svg {
  color: #898989;
  cursor: pointer;
}

/**=====================
    83. Wishlist CSS Ends
==========================**/
/**=====================
     47. Footer CSS Start
==========================**/
.footer {
  background-color: #fff;
  box-shadow: 0 0 20px rgba(89, 102, 122, 0.1);
  padding: 15px;
  bottom: 0;
  left: 0;
  margin-left: 265px;
  transition: 0.5s;
}
.footer.footer-dark {
  background-color: #242934;
}
.footer.footer-dark p {
  color: #fff;
}

.footer-fix {
  width: calc(100% - 265px);
  position: fixed;
}

/**=====================
     47. Footer CSS Ends
==========================**/
/**=====================
      08. GRID CSS Start
==========================**/
.grid-showcase {
  margin-bottom: -10px;
}
.grid-showcase span {
  display: block;
  border: 1px solid #f4f4f4;
  padding: 10px;
  margin-bottom: 10px;
  text-align: center;
  background-color: #fff;
}

.grid-align {
  margin-bottom: -30px;
}
.grid-align .row {
  padding: 15px 0;
  min-height: 10rem;
  border: 1px solid rgba(115, 102, 255, 0.02);
  margin-bottom: 30px;
  background-color: rgba(115, 102, 255, 0.02);
}

/**=====================
      08. GRID CSS Ends
==========================**/
/*======= Page Header css Start ======= */
.left-header .d-flex {
  align-items: center;
}
[dir=rtl] .left-header .d-flex {
  justify-content: flex-end;
}
.left-header h6, .left-header .h6 {
  line-height: 1.6;
}
@media (max-width: 1199px) {
  .left-header h6, .left-header .h6 {
    width: 160px;
    overflow: hidden;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
@media (max-width: 991px) {
  .left-header h6, .left-header .h6 {
    width: 120px;
  }
}
@media (max-width: 767px) {
  .left-header h6, .left-header .h6 {
    width: 66px;
  }
}
@media (max-width: 755px) {
  .left-header {
    display: none;
  }
}
.left-header img {
  margin-top: -12px;
  height: 26px;
}
.left-header i {
  font-weight: 600;
  font-size: 12px;
  margin-bottom: -4px;
}

/*======= Page Header css ends  ======= */
/**======Main Header css Start ======**/
.offcanvas .page-wrapper .page-body-wrapper .page-body,
.offcanvas-bookmark .page-wrapper .page-body-wrapper .page-body {
  position: relative;
  filter: blur(5px) grayscale(100%);
}

.offcanvas {
  position: unset;
  visibility: visible;
  background: unset;
  z-index: 2;
}

.toggle-sidebar {
  position: absolute;
  right: 30px;
  top: 30px;
  cursor: pointer;
}
.toggle-sidebar svg {
  width: 20px;
  height: 20px;
}
.toggle-sidebar:before {
  content: "";
  position: absolute;
  height: 40px;
  width: 40px;
  background-color: rgba(115, 102, 255, 0.1);
  border-radius: 100%;
  left: -11px;
  z-index: -2;
  top: -8px;
  transform: scale(0);
  transition: all 0.3s ease;
}
.toggle-sidebar:hover:before {
  height: 40px;
  width: 40px;
  transform: scale(1);
  transition: all 0.3s ease;
}
.toggle-sidebar:hover > svg {
  color: var(--theme-default) !important;
  stroke: var(--theme-default) !important;
}

.onhover-dropdown {
  cursor: pointer;
  position: relative;
}
.onhover-show-div {
  top: 80px;
  position: absolute;
  z-index: 8;
  background-color: #fff;
  transition: all linear 0.3s;
}
.onhover-show-div li a svg {
  margin-top: 0 !important;
}
.onhover-show-div li a svg path,
.onhover-show-div li a svg line {
  color: #2f2f3b !important;
}

/**======Main Header css Ends ======**/
/*=======Mega menu css start=======*/
.mega-menu .default-according .card .btn-link {
  font-weight: 500;
  color: gray;
}
.mega-menu .default-according .card .card-body {
  font-size: 12px;
}
.mega-menu .onhover-show-div {
  width: 1500px;
}
.mega-menu .card-body {
  padding: 20px;
}
.mega-menu div > div a {
  margin-bottom: 0px;
  display: inline-block;
  color: #52526c;
}
.mega-menu .list-unstyled div a {
  padding: 8px 35px 8px 0;
  transition: 0.5s;
}
.mega-menu .list-unstyled div a:hover {
  padding: 8px 35px 8px 10px;
  transition: 0.5s;
}

/*=======Mega menu css end=======*/
/**=====================
    05. Header CSS Ends
==========================**/
/**=====================
     36. NAV CSS Start
==========================**/
#accordionoc #collapseicon,
#accordionoc #collapseicon1 {
  padding-top: 0px;
}
#accordionoc li button {
  display: flex;
  align-items: center;
}

.navs-icon.default-according.style-1 li button {
  position: relative;
}
.navs-icon.default-according.style-1 li button:hover {
  color: var(--theme-default) !important;
}
.navs-icon.default-according.style-1 li button[aria-expanded=true]:before {
  right: 2px;
  top: 6px;
}
.navs-icon.default-according.style-1 li button[aria-expanded=false]:before {
  right: 2px;
  top: 6px;
}

.navs-icon {
  padding: 30px;
}
.navs-icon li {
  padding: 9px 0;
}
.navs-icon li a {
  color: #2f2f3b;
}
.navs-icon li a:hover {
  color: var(--theme-default);
}
.navs-icon li ul {
  padding-top: 9px;
}

.onhover-dropdown.navs-dropdown:hover .onhover-show-div:before, .onhover-dropdown.navs-dropdown:hover .onhover-show-div:after {
  right: 77px;
  left: unset;
}

.icon-lists {
  font-family: Rubik, sans-serif;
}

.pl-navs-inline {
  padding-left: 30px !important;
}

.inline-nav li {
  line-height: 1.3;
}

/**=====================
     36. NAV CSS Ends
==========================**/
/**=====================
     51. Search CSS Start
==========================**/
.search-page .theme-form input {
  border: 1px solid var(--theme-default);
  padding-left: 20px;
  border-radius: 10px 0 0 10px;
  flex: 1 1 auto;
}
.search-page .theme-form input::placeholder {
  color: #7366ff;
}
.search-page .theme-form input:focus {
  outline: none;
}
.search-page .theme-form .input-group .btn {
  line-height: 32px;
  font-size: 16px;
}
.search-page .theme-form .input-group .form-control-plaintext {
  background: transparent;
}
.search-page h6, .search-page .h6 {
  line-height: 1.4;
}
.search-page .nav-link {
  font-weight: 500;
  text-transform: uppercase;
}
.search-page .border-tab.nav-tabs .material-border {
  border-bottom-width: 1px;
}
.search-page .border-tab.nav-tabs .nav-item .nav-link {
  font-size: 15px;
  padding: 10px 18px;
}
.search-page .media .media-body {
  overflow: hidden;
}
.search-page .info-block {
  padding: 30px;
  border-radius: 15px;
  border: 1px solid #f4f4f4;
}
.search-page .info-block a {
  color: #656565;
  margin-bottom: 3px;
  display: block;
}
.search-page .info-block h6, .search-page .info-block .h6 {
  color: #7366ff;
}
.search-page .info-block + .info-block {
  margin-top: 20px;
}
.search-page .border-tab.nav-tabs {
  align-items: left;
  justify-content: flex-end;
}
.search-page .border-tab.nav-tabs .nav-item {
  width: auto;
}
.search-page .search-links h6, .search-page .search-links .h6 {
  margin-bottom: 10px;
}
.search-page p {
  text-transform: lowercase;
  margin-bottom: 0;
  color: #a5a2a2;
}
.search-page ul.search-info li {
  display: inline-block;
  font-size: 12px;
  line-height: 1;
  color: #586082;
}
.search-page ul.search-info li + li {
  border-left: 1px solid rgb(65.82737768%, 69.0819131391%, 76.1334066337%);
  padding-left: 8px;
  margin-left: 8px;
}
.search-page ul.search-info li i {
  color: #ffaa05;
}
.search-page ul.search-info li i:not(:last-child) {
  margin-right: 4px;
}
.search-page #video-links .embed-responsive + .embed-responsive {
  margin-top: 30px;
}

.search-list {
  margin-bottom: 30px;
  width: auto;
  display: inline-flex;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #7366ff;
  border: none;
}
.search-list .nav-item {
  background-color: rgba(115, 102, 255, 0.1);
}
.search-list .nav-item .nav-link {
  border: none;
  padding: 0.7rem 1.5rem;
  opacity: 0.5;
}
.search-list .nav-item .nav-link.active {
  background-color: rgba(115, 102, 255, 0.1);
  color: var(--theme-default);
  opacity: 1;
}
.search-list .nav-item.show, .search-list .nav-item.active {
  background-color: rgba(115, 102, 255, 0.1);
}

/**=====================
    51. Search CSS Ends
==========================**/
/**=====================
     21. Select 2 CSS Start
==========================**/
.select2 {
  max-width: 100%;
}

.add-post #cke_text-box {
  border: 1px solid #efefef;
}
.add-post form .m-checkbox-inline label {
  margin-bottom: 0;
}
.add-post form .form-control {
  border: 1px solid #efefef;
}
.add-post form .col-form-label {
  padding-bottom: 0;
  padding-top: 0;
}
.add-post form .col-form-label .select2-container--default {
  margin-top: 10px;
  max-width: 100%;
}
.add-post form .col-form-label .select2-container--default .selection .select2-selection .select2-search__field {
  padding: 2px;
}
.add-post form .col-form-label .select2-container--default .select2-selection--multiple {
  border: 1px solid #efefef;
  max-width: 100%;
}
.add-post form .col-form-label .select2-container--default .select2-selection--multiple .select2-selection__rendered li {
  margin-top: 6px !important;
}
.add-post .dropzone {
  margin-bottom: 30px;
}

.select2-container--open .select2-dropdown {
  z-index: 7;
}

.select2-container {
  width: 100% !important;
}

.select2-drpdwn .select2-selection {
  border-radius: 0 !important;
  border-color: #f4f4f4 !important;
  height: 40px !important;
  padding: 5px;
}
.select2-drpdwn .form-control {
  border-radius: 5px;
}
.select2-drpdwn .form-control-primary {
  border-color: var(--theme-default);
  color: var(--theme-default);
}
.select2-drpdwn .form-control-secondary {
  border-color: var(--theme-secondary);
  color: var(--theme-secondary);
}
.select2-drpdwn .form-control-success {
  border-color: #54ba4a;
  color: #54ba4a;
}
.select2-drpdwn .form-control-info {
  border-color: #16c7f9;
  color: #16c7f9;
}
.select2-drpdwn .form-control-warning {
  border-color: #ffaa05;
  color: #ffaa05;
}
.select2-drpdwn .form-control-danger {
  border-color: #fc4438;
  color: #fc4438;
}
.select2-drpdwn .form-control-inverse {
  border-color: #2c323f;
  color: #2c323f;
}
.select2-drpdwn .form-control-primary-fill {
  background-color: var(--theme-default);
  color: #fff;
}
.select2-drpdwn .form-control-secondary-fill {
  background-color: var(--theme-secondary);
  color: #fff;
}
.select2-drpdwn .form-control-success-fill {
  background-color: #54ba4a;
  color: #fff;
}
.select2-drpdwn .form-control-info-fill {
  background-color: #16c7f9;
  color: #fff;
}
.select2-drpdwn .form-control-warning-fill {
  background-color: #ffaa05;
  color: #fff;
}
.select2-drpdwn .form-control-danger-fill {
  background-color: #fc4438;
  color: #fff;
}
.select2-drpdwn .form-control-inverse-fill {
  background-color: #2c323f;
  color: #fff;
}

.selection .select2-selection {
  border-radius: 5px !important;
}
.selection .select2-selection .select2-search__field {
  margin-top: 0;
  padding: 3px;
}

.select2-container--classic .select2-selection--multiple .select2-selection__choice {
  padding: 2px 6px !important;
  margin-top: 0 !important;
  background-color: var(--theme-default) !important;
  border-color: var(--theme-default) !important;
  color: #fff;
  margin-right: 8px !important;
}
.select2-container--classic .select2-selection--multiple .select2-selection__choice__remove {
  color: #fff !important;
  float: right;
  margin-left: 0.5rem;
}
.select2-container--classic .select2-results__option--highlighted[aria-selected] {
  background-color: #e0e0e0 !important;
  color: #424242 !important;
}
.select2-container--classic .select2-results__options .select2-results__option[aria-selected=true] {
  background-color: var(--theme-default) !important;
  color: #fff !important;
}

.select2-container--default .select2-selection--single .select2-selection__arrow {
  top: 11px !important;
  right: 10px !important;
}
.select2-container--default .select2-selection--multiple .select2-selection__choice {
  padding: 2px 6px !important;
  margin-top: 0 !important;
  background-color: var(--theme-default) !important;
  border-color: var(--theme-default) !important;
  color: #fff;
  margin-right: 8px !important;
}
.select2-container--default .select2-selection--multiple .select2-selection__choice__remove {
  color: #fff !important;
  float: right;
  margin-left: 0.5rem;
}
.select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #e0e0e0 !important;
  color: #424242 !important;
}
.select2-container--default .select2-results__options .select2-results__option[aria-selected=true] {
  background-color: var(--theme-default) !important;
  color: #fff !important;
}

/**=====================
     21. Select 2 CSS Ends
==========================**/
/**=====================
    78. Sidebar CSS Start
==========================**/
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title h5:after, .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title .h5:after, .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a:after {
  position: absolute;
  content: "";
  top: 48%;
  width: 8px;
  border-top: 1px solid rgba(82, 82, 108, 0.4);
}

.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title h5::before, .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title .h5::before, .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a::before {
  position: absolute;
  content: "";
  width: 5px;
  height: 5px;
  top: 50%;
  transform: translateY(-50%);
  left: 25px;
  border-radius: 100%;
  background: var(--theme-default);
  opacity: 0;
  visibility: hidden;
}
[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title h5::before, .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title [dir=rtl] h5::before, [dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title .h5::before, .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title [dir=rtl] .h5::before, [dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a::before, .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li [dir=rtl] a::before {
  left: unset;
  right: 25px;
}

.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container::before, .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu::before {
  position: absolute;
  content: "";
  width: 1px;
  height: 0;
  background: rgba(82, 82, 108, 0.4);
  top: -10px;
  left: 27px;
  transition: height 0.5s;
}
[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container::before, .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li [dir=rtl] .mega-menu-container::before, [dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu::before, .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li [dir=rtl] .sidebar-submenu::before {
  left: unset;
  right: 27px;
}

.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a:after {
  position: absolute;
  content: "";
  top: 49%;
  width: 5px;
  height: 1px;
  border-radius: 100%;
  background-color: #59667a;
}

.onhover-show-div {
  box-shadow: 0 0 20px rgba(89, 102, 122, 0.1);
  transform: translateY(30px);
  opacity: 0;
  visibility: hidden;
  left: 0;
}

.onhover-dropdown:hover .onhover-show-div {
  opacity: 1;
  transform: translateY(0px);
  visibility: visible;
  border-radius: 5px;
  overflow: hidden;
}
.onhover-dropdown:hover .onhover-show-div:before {
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #fff;
  content: "";
  top: -7px;
  position: absolute;
  left: 10px;
  z-index: 2;
}
.onhover-dropdown:hover .onhover-show-div:after {
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #d7e2e9;
  content: "";
  top: -7px;
  position: absolute;
  left: 10px;
  z-index: 1;
}

.page-wrapper {
  position: relative;
}
.page-wrapper .page-header {
  max-width: 100vw;
  position: fixed;
  top: 0;
  z-index: 8;
  transition: 0.5s;
  background-color: #fff;
  box-shadow: 0px 4px 40px rgba(39, 32, 120, 0.1);
}
.page-wrapper .page-header .header-wrapper {
  width: 100%;
  align-items: center;
  padding: 22px 30px;
  position: relative;
}
@media (max-width: 1399px) {
  .page-wrapper .page-header .header-wrapper {
    padding: 22px 20px;
  }
}
.page-wrapper .page-header .header-wrapper .search-full {
  background-color: #fff;
  position: absolute;
  right: 0;
  z-index: 1;
  height: 0;
  width: 0;
  transform: scale(0);
  transition: all 0.3s ease;
}
.page-wrapper .page-header .header-wrapper .search-full.open {
  height: 100%;
  width: 100%;
  animation: zoomIn 0.5s ease-in-out;
  transform: scale(1);
  transition: all 0.3s ease;
}
.page-wrapper .page-header .header-wrapper .search-full input {
  line-height: 65px;
  padding-left: 60px;
  width: 100% !important;
}
.page-wrapper .page-header .header-wrapper .search-full input:focus {
  outline: none !important;
}
.page-wrapper .page-header .header-wrapper .search-full .form-group .close-search {
  position: absolute;
  font-size: 15px;
  right: 30px;
  top: 30px;
  color: #898989;
  cursor: pointer;
}
.page-wrapper .page-header .header-wrapper .search-full .form-group:before {
  position: absolute;
  left: 30px;
  top: 27px;
  content: "\\f002";
  font-size: 16px;
  color: #898989;
  font-family: FontAwesome;
}
.page-wrapper .page-header .header-wrapper .nav-right {
  justify-content: flex-end;
}
.page-wrapper .page-header .header-wrapper .nav-right ul li svg {
  vertical-align: middle;
  width: 20px;
  height: 20px;
  stroke: rgba(47, 47, 59, 0.9);
  fill: none;
}
.page-wrapper .page-header .header-wrapper .nav-right ul li svg path {
  color: #242934;
}
.page-wrapper .page-header .header-wrapper .nav-right ul li .mode.active svg {
  fill: #fff;
}
.page-wrapper .page-header .header-wrapper .nav-right.right-header ul li .mode {
  cursor: pointer;
  text-align: center;
}
.page-wrapper .page-header .header-wrapper .nav-right.right-header ul li .mode i {
  font-size: 18px;
  font-weight: 600;
  transition: all 0.3s ease;
}
.page-wrapper .page-header .header-wrapper .nav-right.right-header ul li .mode i.fa-lightbulb-o {
  font-weight: 500;
  font-size: 22px;
  transition: all 0.3s ease;
  animation: zoomIn 300ms ease-in-out;
}
.page-wrapper .page-header .header-wrapper .nav-right.right-header ul li .header-search {
  cursor: pointer;
}
.page-wrapper .page-header .header-wrapper .nav-right.right-header ul li .profile-media .media-body {
  margin-left: 15px;
}
.page-wrapper .page-header .header-wrapper .nav-right.right-header ul li .profile-media .media-body span {
  font-weight: 500;
}
.page-wrapper .page-header .header-wrapper .nav-right.right-header ul li .profile-media .media-body p {
  font-size: 12px;
  line-height: 1;
  color: rgba(47, 47, 59, 0.7);
}
.page-wrapper .page-header .header-wrapper .nav-right > ul {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.page-wrapper .page-header .header-wrapper .nav-right > ul > li {
  padding: 6px 10px;
  display: inline-block;
  position: relative;
}
.page-wrapper .page-header .header-wrapper .nav-right > ul > li .badge {
  position: absolute;
  right: -5px;
  top: -6px;
  padding: 2px 4px;
  font-size: 11px;
  font-weight: 700;
  font-family: work-Sans, sans-serif;
}
.page-wrapper .page-header .header-wrapper .nav-right > ul > li span ul {
  left: inherit;
  right: -10px;
  width: 130px;
}
.page-wrapper .page-header .header-wrapper .nav-right > ul > li span ul:before, .page-wrapper .page-header .header-wrapper .nav-right > ul > li span ul:after {
  left: inherit;
  right: 10px;
}
.page-wrapper .page-header .header-wrapper .nav-right > ul > li span ul li {
  display: block;
}
.page-wrapper .page-header .header-wrapper .nav-right > ul > li span ul li a {
  font-size: 14px;
  color: #2c323f;
}
.page-wrapper .page-header .header-wrapper .nav-right > ul > li span ul li a i {
  margin-left: 10px;
  font-size: 13px;
  color: #2c323f;
}
.page-wrapper .page-header .header-wrapper .nav-right > ul .flag-icon {
  font-size: 16px;
}
.page-wrapper .page-header .header-wrapper .nav-right .bookmark-flip {
  width: unset !important;
  box-shadow: unset !important;
  background-color: transparent !important;
  overflow: initial;
}
.page-wrapper .page-header .header-wrapper .nav-right .bookmark-flip::after, .page-wrapper .page-header .header-wrapper .nav-right .bookmark-flip::before {
  display: none;
}
.page-wrapper .page-header .header-wrapper .nav-right .bookmark-flip .bookmark-dropdown .bookmark-content {
  text-align: center;
}
.page-wrapper .page-header .header-wrapper .nav-right .bookmark-flip .bookmark-dropdown .bookmark-content .bookmark-icon {
  width: 52px;
  height: 52px;
  background-color: #f9f9f9;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}
.page-wrapper .page-header .header-wrapper .nav-right .bookmark-flip .bookmark-dropdown .bookmark-content span {
  font-family: Roboto, sans-serif;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.5px;
}
.page-wrapper .page-header .header-wrapper .nav-right .flip-card {
  width: 300px;
  height: 260px;
  background-color: transparent;
}
.page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner {
  position: relative;
  height: 100%;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
}
.page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .front,
.page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .back {
  position: absolute;
  backface-visibility: hidden;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 0 20px rgba(89, 102, 122, 0.1);
  width: 300px;
  height: 260px;
}
.page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .front button,
.page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .back button {
  background-color: transparent;
  color: #7366ff;
  border: none;
}
.page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .front button:focus,
.page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .back button:focus {
  outline: transparent;
}
.page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .front {
  background-color: #fff;
  transition: 0.3s;
}
.page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .front svg {
  stroke: #2c323f;
  transition: all 0.3s ease;
}
.page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .front svg:hover {
  stroke: var(--theme-default);
  transition: all 0.3s ease;
}
.page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .back {
  background-color: #fff;
  transform: rotateY(180deg);
}
.page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .back li:first-child {
  margin-top: 20px;
  height: 140px !important;
}
.page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .back button {
  width: 100%;
}
.page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .back .flip-back-content input {
  border-radius: 25px;
  padding: 6px 12px;
  width: 100%;
  border: 1px solid #ddd;
}
.page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .back .flip-back-content input:focus {
  outline: none;
}
.page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner.flipped {
  transform: rotateY(180deg);
}
.page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner.flipped .front {
  opacity: 0;
}
.page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div {
  width: 330px;
  top: 50px;
  right: 0;
  left: unset;
}
.page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div .dropdown-title {
  padding: 20px;
  text-align: center;
  border-bottom: 1px solid rgba(145, 142, 153, 0.3);
}
.page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div ul {
  padding: 15px;
}
.page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div li {
  padding: 15px;
}
.page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div li p {
  font-size: 14px;
  letter-spacing: 0.3px;
  margin-bottom: 0;
}
.page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div li a {
  text-decoration: underline;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  font-family: Roboto, sans-serif;
}
.page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div li + li {
  margin-top: 15px;
}
.page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div li:last-child {
  padding-bottom: 15px;
}
.page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div li .media {
  position: relative;
}
.page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div li .media img {
  width: 40px;
  position: relative;
}
.page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div li .media .status-circle {
  left: 0;
}
.page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div li .media .media-body > span {
  letter-spacing: 0.8px;
  padding-right: 10px;
  display: inline-block;
}
.page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div li .media .media-body p {
  margin-bottom: 8px;
}
.page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div:before, .page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div:after {
  right: 10px !important;
  left: unset !important;
}
.page-wrapper .page-header .header-wrapper .nav-right .notification-box {
  position: relative;
}
.page-wrapper .page-header .header-wrapper .nav-right .cart-box {
  position: relative;
}
.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown ul {
  padding: 0 0 15px;
}
.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown li {
  margin: 0 15px;
  padding: 10px 0;
}
.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown li .media {
  align-items: center;
}
.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown li .media .media-body {
  margin-right: 20px;
}
[dir=rtl] .page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown li .media .media-body {
  margin-right: unset;
  margin-left: 20px;
}
.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown li + li {
  margin-top: 0;
  border-top: 1px solid rgba(145, 142, 153, 0.1);
}
.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown li:last-child {
  padding: 20px 15px;
  border-top: none;
}
.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown p {
  line-height: 1.3;
  margin-top: 3px;
  opacity: 0.6;
}
.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown .close-circle {
  position: absolute;
  right: 0;
  top: 0;
}
.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown .close-circle a {
  width: 18px;
  height: 18px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown .close-circle svg {
  width: 14px;
  stroke: #fff;
}
.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown .qty-box {
  margin: 5px 0;
}
.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown .qty-box .input-group-text {
  background-color: transparent;
}
.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown .qty-box .input-group {
  width: 80px;
  background-color: transparent;
}
.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown .qty-box .input-group input {
  background-color: transparent;
}
.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown .qty-box .input-group input,
.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown .qty-box .input-group .btn {
  font-size: 10px;
  font-family: Roboto, sans-serif;
  font-weight: 700;
}
.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown .qty-box .input-group .btn {
  padding: 2px;
  background-color: #f7f6ff !important;
  border-color: #f7f6ff !important;
  border-radius: 100%;
  font-size: 14px;
  color: #2f2f3b;
  display: flex;
}
.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown .total {
  margin: 0;
  padding: 15px;
  background-color: #f9f9f9;
  border: none;
}
.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown .total h6, .page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown .total .h6 {
  font-family: Roboto, sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.5px;
}
.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown .total h6 span, .page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown .total .h6 span {
  font-size: 14px;
}
.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown .view-checkout {
  text-decoration: unset;
}
.page-wrapper .page-header .header-wrapper .nav-right .notification-box svg {
  animation: swing 1.5s ease infinite;
}
.page-wrapper .page-header .header-wrapper .nav-right .notification-dropdown {
  top: 52px;
  width: 300px;
  right: -20px !important;
  left: unset;
}
@media (max-width: 575.98px) {
  .page-wrapper .page-header .header-wrapper .nav-right .notification-dropdown {
    width: calc(100vw - 30px);
  }
}
.page-wrapper .page-header .header-wrapper .nav-right .notification-dropdown li {
  background-color: #f9f9f9;
  border-radius: 5px;
}
.page-wrapper .page-header .header-wrapper .nav-right .notification-dropdown li:last-child {
  text-align: center;
  background-color: transparent;
}
.page-wrapper .page-header .header-wrapper .nav-right .notification-dropdown li p {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.page-wrapper .page-header .header-wrapper .nav-right .notification-dropdown li p span {
  font-size: 11px;
  vertical-align: middle;
}
.page-wrapper .page-header .header-wrapper .nav-right .notification-dropdown:before, .page-wrapper .page-header .header-wrapper .nav-right .notification-dropdown:after {
  right: 28px !important;
  left: unset !important;
}
.page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown {
  width: 160px;
  top: 57px;
  left: -12px;
  padding: 0 10px;
}
.page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown li {
  padding: 10px !important;
}
.page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown li a {
  text-decoration: unset;
}
.page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown li:hover a span {
  color: var(--theme-default);
  transition: color 0.3s ease;
}
.page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown li:hover a svg {
  stroke: var(--theme-default);
  transition: stroke 0.3s ease;
}
.page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown li:hover a svg path {
  stroke: var(--theme-default);
  transition: stroke 0.3s ease;
}
.page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown li + li {
  margin-top: 0;
}
.page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown li:last-child {
  padding-top: 10px !important;
}
.page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown li span {
  color: #2c323f;
}
.page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown li svg {
  width: 16px;
  vertical-align: bottom;
  margin-right: 10px;
  stroke: #2c323f;
}
.page-wrapper .page-body-wrapper {
  background-color: #f7f8f9;
}
.page-wrapper .page-body-wrapper .page-body {
  min-height: calc(100vh - 136px);
  margin-top: 136px;
  padding: 0 15px 0 15px;
  position: relative;
  transition: 0.5s;
}
.page-wrapper .page-body-wrapper .page-body:before {
  animation: fadeIn 0.5s ease-in-out;
}
.page-wrapper .page-body-wrapper .page-title {
  padding: 15px 30px;
  margin: 0 -27px 30px;
  background-color: #fff;
}
.page-wrapper .page-body-wrapper .page-title > .row {
  margin: 0;
}
.page-wrapper .page-body-wrapper .page-title > .row .col-6 {
  padding: 0;
}
.page-wrapper .page-body-wrapper .page-title .row {
  align-items: center;
}
.page-wrapper .page-body-wrapper .page-title .row h3, .page-wrapper .page-body-wrapper .page-title .row .h3 {
  font-size: 24px;
  margin-bottom: 0;
  text-transform: capitalize;
}
.page-wrapper .page-body-wrapper .page-title .row h3 small, .page-wrapper .page-body-wrapper .page-title .row .h3 small, .page-wrapper .page-body-wrapper .page-title .row h3 .small, .page-wrapper .page-body-wrapper .page-title .row .h3 .small {
  display: block;
  font-size: 12px;
  margin-bottom: 5px;
  text-transform: capitalize;
  color: #52526c;
}
.page-wrapper .page-body-wrapper .page-title .breadcrumb {
  background-color: transparent;
  padding: 0;
  margin-bottom: 0;
  align-items: center;
  justify-content: flex-end;
}
.page-wrapper .page-body-wrapper .page-title .breadcrumb li {
  font-size: 13px;
  letter-spacing: 1px;
  font-family: Roboto, sans-serif;
}
.page-wrapper .page-body-wrapper .page-title .breadcrumb .breadcrumb-item + .breadcrumb-item:before {
  content: "/";
}
.page-wrapper .page-body-wrapper .page-title .breadcrumb .breadcrumb-item a svg {
  width: 16px;
  height: 16px;
  stroke: #2c323f;
  vertical-align: text-top;
}
.page-wrapper .page-body-wrapper .page-title .breadcrumb .breadcrumb-item.active {
  color: var(--theme-default);
  font-weight: 500;
}
.page-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a svg.stroke-icon {
  stroke: #2c323f;
}
.page-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a svg.fill-icon {
  fill: #757589;
}
.page-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a.active svg {
  transition: all 0.3s ease;
}
.page-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a.active svg.stroke-icon {
  stroke: var(--theme-default);
}
.page-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a.active svg.fill-icon {
  fill: var(--theme-default);
}
.page-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a {
  text-transform: capitalize;
}
.page-wrapper.horizontal-wrapper [data-simplebar] {
  position: relative;
}
.page-wrapper.horizontal-wrapper .footer {
  margin-left: 0;
}
.page-wrapper.horizontal-wrapper .header-logo-wrapper {
  width: 150px;
}
.page-wrapper.horizontal-wrapper .header-logo-wrapper .toggle-sidebar {
  display: none;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper {
  height: 54px;
  line-height: inherit;
  top: 79px;
  background: #fff;
  box-shadow: 0px 9px 24px rgba(89, 102, 122, 0.05);
  overflow-x: hidden;
  z-index: 1;
  overflow-y: visible;
  position: fixed;
  width: 100vw;
  border-top: 1px solid #efefef;
  z-index: 3;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper li {
  display: inline-block;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .badge {
  position: absolute;
  top: 2px;
  right: 0px;
  z-index: 1;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .logo-wrapper,
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .logo-icon-wrapper {
  display: none;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main {
  text-align: left;
  position: relative;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .left-arrow,
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .right-arrow {
  position: absolute;
  top: 0px;
  padding: 15px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  cursor: pointer;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .left-arrow.disabled,
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .right-arrow.disabled {
  display: none;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .left-arrow {
  left: 0;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .right-arrow {
  right: 0;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links {
  list-style: none;
  margin: 0;
  padding: 0;
  line-height: normal;
  direction: ltr;
  text-align: left;
  display: -webkit-box !important;
  padding: 0 5px;
  transition: all 0.5s ease;
  white-space: nowrap;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links li.sidebar-list a.active .according-menu i:before {
  content: "-";
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links li.sidebar-list a .according-menu {
  display: none;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links li.sidebar-list:hover > .sidebar-submenu {
  display: block !important;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links li.sidebar-list:hover > .sidebar-submenu > li > .sidebar-submenu {
  display: block !important;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links li.sidebar-list:hover > .sidebar-submenu > li .sub-arrow i {
  font-size: 10px;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links li.sidebar-list:hover > .sidebar-submenu > li:hover {
  display: block !important;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links li.sidebar-list ul.sidebar-submenu li a.active {
  color: var(--theme-default);
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links li.sidebar-list ul.sidebar-submenu li a.active:after {
  background-color: var(--theme-default);
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li {
  position: relative;
  padding-top: 10px;
  padding-bottom: 10px;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li:hover > a > span {
  color: var(--theme-default);
  transition: all 0.3s ease;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li:hover a {
  background-color: rgba(115, 102, 255, 0.0015);
  transition: all 0.3s ease;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li:hover a svg.stroke-icon {
  stroke: var(--theme-default);
  transition: all 0.3s ease;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li:hover a svg.fill-icon {
  fill: var(--theme-default);
  transition: all 0.3s ease;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li:first-child {
  display: none !important;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li > a {
  display: block;
  color: #2f2f3b;
  line-height: 23px;
  text-decoration: none;
  text-transform: capitalize;
  padding: 5px 15px;
  margin: 0 3px;
  letter-spacing: 0.04em;
  position: relative;
  border-radius: 5px;
  font-weight: 500;
  transition: all 0.3s ease;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li > a.active {
  background-color: rgb(85.3594771242%, 84%, 100%);
  transition: all 0.3s ease;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li > a.active svg,
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li > a.active span {
  color: var(--theme-default);
  transition: all 0.3s ease;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li > a .badge {
  position: absolute;
  top: -5px;
  margin-left: 1px;
  right: 10px;
  padding: 0.2em 0.7em;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li > a svg {
  width: 18px;
  height: 18px;
  vertical-align: middle;
  margin-right: 10px;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu {
  position: fixed;
  z-index: 4;
  box-shadow: 0 0 1px 0 #898989;
  padding: 15px 0px 15px 0px;
  background: white;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li {
  border: 0;
  float: none;
  position: relative;
  display: block;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a {
  background: transparent;
  padding: 4px 30px;
  display: block;
  transition: all 0.5s ease;
  line-height: 1.9;
  color: rgba(43, 43, 43, 0.6);
  letter-spacing: 0.06em;
  font-weight: 500;
  font-family: Roboto;
  transition: all 0.3s ease;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a:after {
  left: 20px;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a:hover {
  color: var(--theme-default);
  letter-spacing: 1.5px;
  transition: all 0.3s ease;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a:hover:after {
  background-color: var(--theme-default);
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container {
  position: fixed;
  right: 0;
  left: 0;
  margin: 0 auto;
  z-index: 4;
  box-shadow: 0 0 1px 0 #898989;
  padding: 30px;
  background: white;
  width: 95%;
  border-radius: 4px;
  display: block !important;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box {
  width: 20%;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title h5, .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title .h5 {
  text-transform: uppercase;
  font-size: 14px;
  margin-left: -13px;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content {
  box-shadow: none;
  background-color: transparent;
  position: relative;
  display: block;
  padding: 0;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content li {
  border: 0;
  float: none;
  position: relative;
  display: block;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content li a {
  border: 0 !important;
  background: transparent;
  color: #2f2f3b;
  border-radius: 0 !important;
  text-transform: capitalize;
  padding: 3px 0;
  font-size: 13px;
  display: block;
  letter-spacing: 0.07em;
  line-height: 1.9;
  position: relative;
  transition: all 0.3s ease;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content li a:hover {
  color: var(--theme-default);
  letter-spacing: 1.5px;
  transition: all 0.3s ease;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content li a:hover:after {
  color: var(--theme-default);
  transition: all 0.3s ease;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content li a:after {
  position: absolute;
  content: "";
  left: -12px;
  top: 50%;
  width: 5px;
  height: 1px;
  background-color: #59667a;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li:hover > a:after {
  left: 0;
  right: 0;
  opacity: 1;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li.mega-menu {
  position: unset;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper.overlay-white {
  background-color: rgba(255, 255, 255, 0.08);
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .toggle-nav {
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .toggle-nav i {
  font-size: 24px;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .page-body {
  margin-top: 135px;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-main-title {
  display: none !important;
}
.page-wrapper.horizontal-wrapper .page-body-wrapper.scorlled .sidebar-wrapper {
  display: none;
  transition: all 0.3s ease;
}
.page-wrapper.horizontal-wrapper .page-header {
  width: 100%;
  box-shadow: none;
}
.page-wrapper.horizontal-wrapper .page-header .header-wrapper .form-control-plaintext {
  width: auto !important;
}
.page-wrapper.horizontal-wrapper .page-header .header-wrapper .left-header {
  width: 30%;
}
@media (max-width: 1428px) and (min-width: 1324px) {
  .page-wrapper.horizontal-wrapper .page-header .header-wrapper .left-header {
    width: 32%;
  }
}
@media (max-width: 1323px) and (min-width: 1200px) {
  .page-wrapper.horizontal-wrapper .page-header .header-wrapper .left-header {
    width: 37%;
  }
}
@media (max-width: 1199px) and (min-width: 992px) {
  .page-wrapper.horizontal-wrapper .page-header .header-wrapper .left-header {
    width: 32%;
  }
}
@media (max-width: 1428px) and (min-width: 1324px) {
  .page-wrapper.horizontal-wrapper .page-header .header-wrapper .nav-right {
    width: 55%;
  }
}
@media (max-width: 1323px) and (min-width: 1200px) {
  .page-wrapper.horizontal-wrapper .page-header .header-wrapper .nav-right {
    width: 40%;
  }
}
@media (max-width: 1199px) and (min-width: 992px) {
  .page-wrapper.horizontal-wrapper .page-header .header-wrapper .nav-right {
    width: 50%;
  }
}
.page-wrapper.horizontal-wrapper.enterprice-type footer {
  margin-left: 0;
}
.page-wrapper.material-icon .card {
  border-radius: 30px;
  box-shadow: 0 0 20px rgba(115, 102, 255, 0.1);
}
.page-wrapper .sidebar-main-title h6, .page-wrapper .sidebar-main-title .h6 {
  font-size: 14px;
  font-weight: 600;
  color: #52526c;
  text-transform: uppercase;
  margin-bottom: 0;
  letter-spacing: 0.4px;
}
.page-wrapper.compact-wrapper .page-header {
  margin-left: 265px;
  width: calc(100% - 265px);
}
.page-wrapper.compact-wrapper .page-header.close_icon {
  margin-left: 90px;
  width: calc(100% - 90px);
}
.page-wrapper.compact-wrapper .page-header .header-wrapper .logo-wrapper {
  display: none;
}
.page-wrapper.compact-wrapper .page-header .header-wrapper .toggle-sidebar {
  display: none;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper {
  position: fixed;
  top: 0;
  z-index: 9;
  height: auto;
  line-height: inherit;
  background: #fff;
  width: 265px;
  text-align: left;
  transition: 0.3s;
  box-shadow: 0 0 21px 0 rgba(89, 102, 122, 0.1);
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .logo-wrapper,
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .logo-icon-wrapper {
  padding: 27px 30px;
  box-shadow: -9px 0 20px rgba(89, 102, 122, 0.1);
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .logo-icon-wrapper {
  display: none;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon {
  width: auto;
  transition: all 0.3s ease;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon .badge {
  opacity: 0;
  width: 0;
  padding: 0;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon .sidebar-main .sidebar-links > li {
  max-width: 86px;
  margin: 0;
  transition: all 0.3s ease;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon .sidebar-main .sidebar-links > li .sidebar-submenu a {
  display: none;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon .sidebar-main .sidebar-links > li a {
  text-align: center;
  padding: 12px 14px;
  transition: all 0.3s ease;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon .sidebar-main-title {
  display: none !important;
  opacity: 0;
  transition: all 0.3s ease;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon .logo-wrapper {
  display: none;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon .logo-icon-wrapper {
  text-align: right;
  display: block;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon:hover {
  width: 265px;
  transition: all 0.3s ease;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon:hover .badge {
  opacity: 1;
  width: auto;
  transition: all 0.3s ease;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon:hover .sidebar-main .sidebar-links > li {
  max-width: unset;
  margin: initial;
  transition: all 0.3s ease;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon:hover .sidebar-main .sidebar-links > li a {
  text-align: left;
}
[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon:hover .sidebar-main .sidebar-links > li a {
  text-align: right;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon:hover .sidebar-main .sidebar-links > li .sidebar-submenu a {
  display: block;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon:hover .sidebar-main .sidebar-links > li > a {
  padding: 12px 15px;
  transition: all 0.3s ease;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon:hover .sidebar-main .sidebar-links > li > a svg {
  margin-right: 15px;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon:hover .sidebar-main .sidebar-links > li > a span {
  display: inline-block;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon:hover .sidebar-main-title {
  opacity: 1;
  display: block !important;
  transition: all 0.3s ease;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon:hover .logo-wrapper {
  display: block;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon:hover .logo-icon-wrapper {
  display: none;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon .mobile-sidebar {
  transform: translate(183px);
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon ~ .page-body,
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon ~ footer {
  margin-left: 90px;
  transition: 0.5s;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon ~ .footer-fix {
  width: calc(100% - 90px);
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon .sidebar-main .sidebar-links {
  height: calc(100vh - 118px);
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon .sidebar-main .sidebar-links > li .sidebar-link::before {
  right: 20px;
  left: unset;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon .sidebar-main .sidebar-links > li a svg {
  margin: 0;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon .sidebar-main .sidebar-links > li a span {
  display: none;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon .sidebar-main .sidebar-links .sidebar-list .sidebar-title.active ~ .sidebar-submenu {
  display: none;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon .according-menu {
  display: none;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .left-arrow,
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .right-arrow {
  display: none;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links {
  height: calc(100vh - 115px);
  left: -300px;
  z-index: 99;
  transition: color 1s ease;
  overflow: auto;
  color: rgba(0, 0, 0, 0);
  margin-top: 20px;
  margin-bottom: 30px;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a {
  font-weight: 500;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a svg {
  width: 18px;
  height: 18px;
  margin-right: 10px;
  vertical-align: -2px;
  float: none;
  transition: all 0.3s ease;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a span {
  letter-spacing: 0.7px;
  text-transform: capitalize;
  color: rgba(82, 82, 108, 0.8);
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a.link-nav .according-menu {
  display: none;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li:last-child {
  border-bottom: none;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links.opennav {
  left: 0;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .back-btn {
  display: block;
  width: 100%;
  padding: 0;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .back-btn .mobile-back {
  padding: 20px;
  color: #242934;
  font-weight: 700;
  text-transform: uppercase;
  border-bottom: 1px solid #efefef;
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li {
  display: block;
  width: 100%;
  position: relative;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li.sidebar-main-title {
  padding: 25px 0 6px 20px;
  margin-top: 10px;
}
[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li.sidebar-main-title {
  padding: 25px 20px 6px 0;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li.sidebar-main-title::before {
  position: absolute;
  content: "";
  top: 0;
  left: 50%;
  background: var(--sidebar-border);
  width: calc(100% - 40px);
  height: 1px;
  transform: translateX(-50%);
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li.sidebar-main-title:nth-child(2) {
  margin-top: 0;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li.sidebar-main-title:nth-child(2)::before {
  display: none;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li.sidebar-list .badge {
  position: absolute;
  right: 50px;
  top: 14.5px;
  padding: 0.45em 0.8em 0.33em;
  z-index: 1;
  font-size: 10px;
  letter-spacing: 0.7px;
  font-weight: 600;
  font-family: Roboto, sans-serif;
  border-radius: 10px;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li.sidebar-list:hover > a:hover {
  background-color: rgba(115, 102, 255, 0.07);
  transition: all 0.3s ease;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li:hover .sidebar-link:not(.active):hover svg {
  fill: rgba(115, 102, 255, 0.001);
  stroke: var(--theme-default);
  transition: all 0.3s ease;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li:hover .sidebar-link:not(.active):hover svg.fill-icon {
  fill: var(--theme-default);
  stroke: none;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li:hover .sidebar-link:not(.active):hover span {
  color: var(--theme-default);
  transition: all 0.3s ease;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li:hover .sidebar-link:not(.active):hover .according-menu i {
  color: var(--theme-default);
  transition: all 0.3s ease;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a {
  padding: 12px 20px;
  position: relative;
  color: #222222;
  transition: all 0.3s ease;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a .sub-arrow {
  right: 20px;
  position: absolute;
  top: 10px;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a .sub-arrow i {
  display: none;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a .sub-arrow:before {
  display: none;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li:first-child {
  display: none !important;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu {
  width: 100%;
  padding: 0;
  position: relative !important;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu > li a {
  padding-left: 48px !important;
  font-weight: 400;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu .submenu-title .according-menu {
  top: 7px;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu.opensubmenu {
  display: block;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li:hover > a {
  color: var(--theme-default);
  transition: all 0.3s ease;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li .nav-sub-childmenu {
  display: none;
  position: relative !important;
  right: 0;
  width: 100%;
  padding: 0;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li .nav-sub-childmenu.opensubchild {
  display: block;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li .nav-sub-childmenu li a {
  padding: 6px 45px;
  padding-left: 56px !important;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li .nav-sub-childmenu li a:after {
  display: none;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a {
  padding: 7px 25px;
  font-size: 14px;
  color: rgba(47, 47, 59, 0.6);
  display: block;
  position: relative;
  letter-spacing: 0.06em;
  font-weight: 500;
  transition: all 0.3s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a.active {
  color: var(--theme-default);
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a.active::before {
  opacity: 1;
  visibility: visible;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a:after {
  left: 27px;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a:hover {
  margin-left: 0;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container {
  padding: 0;
  position: relative;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container.opensubmenu {
  display: block;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box {
  width: 100%;
  padding: 0;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section:hover h5, .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section:hover .h5 {
  color: var(--theme-default) !important;
  transition: all 0.3s ease;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title {
  position: relative;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title h5, .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title .h5 {
  margin-bottom: 0;
  line-height: 1.9;
  padding: 6px 25px 6px 45px;
  font-size: 14px;
  position: relative;
  color: rgba(43, 43, 43, 0.6);
  display: block;
  letter-spacing: 0.06em;
  font-weight: 500;
  font-family: Roboto;
  cursor: pointer;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title h5:after, .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title .h5:after {
  left: 28px;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title.active h5, .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title.active .h5 {
  color: var(--theme-default);
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title.active h5::before, .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title.active .h5::before {
  opacity: 1;
  visibility: visible;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title .according-menu {
  top: 8px;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content.opensubmegamenu li a {
  margin-bottom: 0;
  line-height: 1.9;
  padding: 6px 25px 6px 45px;
  font-size: 14px;
  position: relative;
  color: rgba(43, 43, 43, 0.6);
  display: block;
  letter-spacing: 0.06em;
  font-weight: 500;
  font-family: Roboto;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content.opensubmegamenu li a:after {
  display: none;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content.opensubmegamenu li a.active {
  color: var(--theme-default);
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content ul li a {
  line-height: 1.9;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content ul li a:hover {
  margin-left: 0;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li.mega-menu .sidebar-title.active ~ .mega-menu-container {
  display: block !important;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li.mega-menu .sidebar-title.active ~ .mega-menu-container::before {
  height: calc(100% - 9px);
  transition: height 0.5s;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link {
  transition: all 0.5s ease;
  display: block;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link::after {
  position: absolute;
  content: "";
  width: 4px;
  height: 35px;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  background-color: #7366ff;
  border-radius: 5px 0px 0px 5px;
  opacity: 0;
  visibility: hidden;
}
[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link::after {
  right: unset;
  left: 0;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active {
  transition: all 0.5s ease;
  position: relative;
  margin-bottom: 10px;
  background-color: rgb(94.5098039216%, 94%, 100%);
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active::after {
  opacity: 1;
  visibility: visible;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active ~ .sidebar-submenu::before {
  height: calc(100% - 8px);
  transition: height 0.5s;
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active .according-menu i {
  color: var(--theme-default);
}
.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active span {
  color: var(--theme-default);
  transition: all 0.3s ease;
}
.page-wrapper.compact-wrapper .page-body-wrapper .mega-box.col {
  flex-basis: unset;
}
.page-wrapper.compact-wrapper .page-body-wrapper .according-menu {
  position: absolute;
  right: 20px;
  top: 13px;
  display: block;
}
.page-wrapper.compact-wrapper .page-body-wrapper .according-menu i {
  vertical-align: middle;
  color: rgba(82, 82, 108, 0.8);
  font-weight: 500;
}
.page-wrapper.compact-wrapper .page-body-wrapper .main-menu.border-section {
  border: none;
}
.page-wrapper.compact-wrapper .page-body-wrapper .main-menu .menu-left .main-menu-right .toggle-nav {
  position: absolute;
  z-index: 2;
  right: 145px;
  top: 6px;
}
.page-wrapper.compact-wrapper .page-body-wrapper .main-menu .menu-left .main-menu-right .toggle-nav .sidebar-name {
  font-size: 18px;
  padding-left: 5px;
  text-transform: uppercase;
}
.page-wrapper.compact-wrapper .page-body-wrapper .page-body {
  min-height: calc(100vh - 80px);
  margin-top: 80px;
  margin-left: 265px;
}
.page-wrapper.compact-wrapper.dark-sidebar .sidebar-main-title h6, .page-wrapper.compact-wrapper.dark-sidebar .sidebar-main-title .h6, .page-wrapper.compact-wrapper.color-sidebar .sidebar-main-title h6, .page-wrapper.compact-wrapper.color-sidebar .sidebar-main-title .h6 {
  color: rgba(255, 255, 255, 0.6);
}
.page-wrapper.compact-wrapper.dark-sidebar .toggle-sidebar svg, .page-wrapper.compact-wrapper.color-sidebar .toggle-sidebar svg {
  stroke: var(--theme-default);
}
.page-wrapper.compact-wrapper.dark-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a svg.stroke-icon, .page-wrapper.compact-wrapper.color-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a svg.stroke-icon {
  stroke: rgba(255, 255, 255, 0.6);
}
.page-wrapper.compact-wrapper.dark-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a svg.fill-icon, .page-wrapper.compact-wrapper.color-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a svg.fill-icon {
  fill: rgba(255, 255, 255, 0.6);
}
.page-wrapper.compact-wrapper.dark-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a.active svg.stroke-icon, .page-wrapper.compact-wrapper.color-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a.active svg.stroke-icon {
  stroke: var(--theme-default);
}
.page-wrapper.compact-wrapper.dark-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a.active svg.fill-icon, .page-wrapper.compact-wrapper.color-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a.active svg.fill-icon {
  fill: var(--theme-default);
}
.page-wrapper.compact-wrapper.dark-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li.sidebar-main-title::before, .page-wrapper.compact-wrapper.color-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li.sidebar-main-title::before {
  background: #374558;
}
.page-wrapper.compact-wrapper.dark-sidebar div.sidebar-wrapper, .page-wrapper.compact-wrapper.color-sidebar div.sidebar-wrapper {
  background-color: #262932;
}
.page-wrapper.compact-wrapper.dark-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links li a span, .page-wrapper.compact-wrapper.color-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links li a span {
  color: rgba(255, 255, 255, 0.6);
}
.page-wrapper.compact-wrapper.dark-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links li a svg.stroke-icon, .page-wrapper.compact-wrapper.color-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links li a svg.stroke-icon {
  stroke: rgba(255, 255, 255, 0.6);
}
.page-wrapper.compact-wrapper.dark-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links li a svg.fill-icon, .page-wrapper.compact-wrapper.color-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links li a svg.fill-icon {
  fill: rgba(255, 255, 255, 0.6);
}
.page-wrapper.compact-wrapper.dark-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title h5, .page-wrapper.compact-wrapper.dark-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title .h5, .page-wrapper.compact-wrapper.color-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title h5, .page-wrapper.compact-wrapper.color-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title .h5 {
  color: rgba(255, 255, 255, 0.6);
}
.page-wrapper.compact-wrapper.dark-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content.opensubmegamenu li a, .page-wrapper.compact-wrapper.color-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content.opensubmegamenu li a {
  color: rgba(255, 255, 255, 0.6);
  font-weight: 400;
}
.page-wrapper.compact-wrapper.dark-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container::after, .page-wrapper.compact-wrapper.color-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container::after {
  background-color: rgba(255, 255, 255, 0.2);
}
.page-wrapper.compact-wrapper.dark-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active, .page-wrapper.compact-wrapper.color-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active {
  background-color: rgba(115, 102, 255, 0.2);
}
.page-wrapper.compact-wrapper.dark-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active svg, .page-wrapper.compact-wrapper.color-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active svg {
  color: var(--theme-default);
  stroke: var(--theme-default);
}
.page-wrapper.compact-wrapper.dark-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a, .page-wrapper.compact-wrapper.color-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a {
  color: rgba(255, 255, 255, 0.6);
}
.page-wrapper.compact-wrapper.dark-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list ul.sidebar-submenu li a span, .page-wrapper.compact-wrapper.color-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list ul.sidebar-submenu li a span {
  color: rgba(255, 255, 255, 0.6);
}
.page-wrapper.compact-wrapper.dark-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list ul.sidebar-submenu li a.active, .page-wrapper.compact-wrapper.color-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list ul.sidebar-submenu li a.active {
  color: var(--theme-default);
}
.page-wrapper.compact-wrapper.dark-sidebar div.sidebar-wrapper .logo-wrapper .for-light, .page-wrapper.compact-wrapper.color-sidebar div.sidebar-wrapper .logo-wrapper .for-light {
  display: none;
}
.page-wrapper.compact-wrapper.dark-sidebar div.sidebar-wrapper .logo-wrapper .for-dark, .page-wrapper.compact-wrapper.color-sidebar div.sidebar-wrapper .logo-wrapper .for-dark {
  display: block;
}
.page-wrapper.compact-wrapper.dark-sidebar .according-menu i, .page-wrapper.compact-wrapper.color-sidebar .according-menu i {
  color: rgba(255, 255, 255, 0.6);
}
.page-wrapper.compact-wrapper.color-sidebar div.sidebar-wrapper {
  background-color: #2f3c4e;
}
.page-wrapper.compact-sidebar ~ .bg-overlay1 {
  transition: 0.8s;
}
.page-wrapper.compact-sidebar ~ .bg-overlay1.active {
  z-index: 8;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.2);
  position: fixed;
  top: 0;
}
.page-wrapper.compact-sidebar .toggle-sidebar {
  position: relative;
  right: unset;
  top: unset;
  margin-right: 15px;
}
.page-wrapper.compact-sidebar .sidebar-main-title {
  display: none;
}
.page-wrapper.compact-sidebar .logo-wrapper {
  display: none;
}
.page-wrapper.compact-sidebar .logo-icon-wrapper {
  display: block;
  text-align: center;
  padding: 24px 30px;
  box-shadow: -9px 0 20px rgba(89, 102, 122, 0.1);
}
.page-wrapper.compact-sidebar .page-header {
  margin-left: 150px;
  width: calc(100% - 150px);
}
.page-wrapper.compact-sidebar .page-header .header-wrapper .logo-wrapper {
  display: none;
}
.page-wrapper.compact-sidebar .page-header .header-wrapper .left-header {
  width: 30%;
}
@media (max-width: 1578px) and (min-width: 1274px) {
  .page-wrapper.compact-sidebar .page-header .header-wrapper .left-header {
    width: 38%;
  }
}
@media (max-width: 1273px) and (min-width: 1200px) {
  .page-wrapper.compact-sidebar .page-header .header-wrapper .left-header {
    width: 45%;
  }
}
@media (max-width: 991px) and (min-width: 768px) {
  .page-wrapper.compact-sidebar .page-header .header-wrapper .left-header {
    width: 36%;
  }
}
@media (max-width: 767px) and (min-width: 756px) {
  .page-wrapper.compact-sidebar .page-header .header-wrapper .left-header {
    width: 28%;
  }
}
@media (max-width: 1199px) {
  .page-wrapper.compact-sidebar .page-header .header-wrapper .left-header h6, .page-wrapper.compact-sidebar .page-header .header-wrapper .left-header .h6 {
    width: 132px;
  }
}
@media (max-width: 767px) {
  .page-wrapper.compact-sidebar .page-header .header-wrapper .left-header h6, .page-wrapper.compact-sidebar .page-header .header-wrapper .left-header .h6 {
    width: 83px;
  }
}
.page-wrapper.compact-sidebar .page-header.close_icon {
  margin-left: 0;
  width: calc(100% - 0px);
}
.page-wrapper.compact-sidebar .page-body-wrapper .page-body {
  margin-top: 80px;
  margin-left: 150px;
}
.page-wrapper.compact-sidebar .page-body-wrapper .footer {
  margin-left: 150px;
}
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper {
  position: fixed;
  top: 0;
  z-index: 9;
  background-color: #fff;
}
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper > div {
  height: auto;
  line-height: inherit;
  background: #fff;
  width: 150px;
  text-align: center;
  transition: 0.3s;
  box-shadow: 0 0 21px 0 rgba(89, 102, 122, 0.1);
}
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .left-arrow,
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .right-arrow {
  display: none;
}
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links {
  margin: 30px 0;
  height: calc(100vh - 113px);
  overflow: auto;
}
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a {
  color: #2c323f;
}
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a span {
  text-transform: capitalize;
  color: #2c323f;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: 14px;
}
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a.active {
  background: rgba(115, 102, 255, 0.1);
  color: #7366ff;
  border-radius: 20px;
  margin: 0 10px;
}
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a.active span {
  color: #7366ff;
}
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a.active ~ .sidebar-submenu,
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a.active ~ .mega-menu-container {
  animation: fadeInLeft 300ms ease-in-out;
}
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-title {
  display: block;
  padding: 20px 0;
  border-bottom: 1px solid #f3f3f3;
}
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu,
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container {
  position: fixed;
  top: 0px;
  height: calc(100vh - 0px);
  overflow: auto;
  left: 150px;
  width: 230px;
  background-color: #fff;
  box-shadow: 0 16px 15px 15px rgba(126, 55, 216, 0.03);
  transition: all 0.5s ease-in-out;
  display: none;
  padding-top: 20px;
  z-index: -1;
}
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu li a,
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container li a {
  padding: 15px 15px 15px 40px;
  display: block;
  position: relative;
  border-bottom: 1px solid #f1f1f1;
}
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu li a .sub-arrow,
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container li a .sub-arrow {
  display: none;
}
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu li a .according-menu,
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container li a .according-menu {
  position: absolute;
  right: 20px;
  top: 16px;
}
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu li a.active,
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container li a.active {
  background-color: rgba(115, 102, 255, 0.1);
  color: #7366ff;
  transition: all 0.3s ease;
}
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu li .submenu-content li a.active,
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container li .submenu-content li a.active {
  background-color: transparent;
}
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu > li > a::after,
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container > li > a::after {
  position: absolute;
  content: "";
  left: 20px;
  top: 48%;
  width: 8px;
  border-top: 2px solid rgba(82, 82, 108, 0.4);
}
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu .mega-box,
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container .mega-box {
  flex: 0 0 100%;
  max-width: 100%;
  padding: 0;
}
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu .mega-box .link-section,
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container .mega-box .link-section {
  text-align: left;
}
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu .mega-box .link-section .submenu-title h5, .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu .mega-box .link-section .submenu-title .h5,
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container .mega-box .link-section .submenu-title h5,
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container .mega-box .link-section .submenu-title .h5 {
  position: relative;
  font-size: 14px;
  font-weight: 400;
  padding: 15px 15px 15px 40px;
  letter-spacing: 1px;
  margin-bottom: 0;
}
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu .mega-box .link-section .submenu-title h5::after, .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu .mega-box .link-section .submenu-title .h5::after,
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container .mega-box .link-section .submenu-title h5::after,
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container .mega-box .link-section .submenu-title .h5::after {
  position: absolute;
  content: "";
  left: 20px;
  top: 48%;
  width: 6px;
  border-top: 2px solid #595c60;
}
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li:hover .sidebar-submenu {
  display: block !important;
}
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list {
  position: relative;
}
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list .badge {
  position: absolute;
  left: 53%;
  top: 7px;
  font-weight: 500;
  font-size: 9px;
}
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list .sidebar-link {
  text-align: center;
}
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list .sidebar-link svg {
  margin: 0 auto 6px;
  width: 24px;
  height: 24px;
}
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list .sidebar-link > span {
  display: block;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: 14px;
  word-break: break-word;
}
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list .sidebar-link .according-menu {
  display: none;
}
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .mega-menu {
  text-align: center;
  padding: 0;
}
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .mega-menu svg {
  width: 24px;
  height: 24px;
}
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .mega-menu .according-menu {
  position: absolute;
  right: 20px;
  top: 13px;
}
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper[sidebar-layout=stroke-svg] .sidebar-links .mega-menu svg.stroke-icon {
  display: block;
  margin: 0 auto 6px;
}
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper[sidebar-layout=stroke-svg] .sidebar-links .mega-menu svg.fill-icon {
  display: none;
}
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper[sidebar-layout=fill-svg] .sidebar-links .mega-menu svg.stroke-icon {
  display: none;
}
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper[sidebar-layout=fill-svg] .sidebar-links .mega-menu svg.fill-icon {
  display: block;
  margin: 0 auto 6px;
}
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper.close_icon {
  transform: translateX(-150px);
}
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper.close_icon ~ .page-body,
.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper.close_icon ~ .footer {
  margin-left: 0px;
}
.page-wrapper.compact-small .toggle-sidebar {
  position: relative;
  right: unset;
  top: unset;
  margin-right: 15px;
}
.page-wrapper.compact-small .sidebar-main-title,
.page-wrapper.compact-small .logo-wrapper {
  display: none;
}
.page-wrapper.compact-small .logo-icon-wrapper {
  display: block;
  text-align: center;
  padding: 27px 30px;
  box-shadow: -9px 0 20px rgba(89, 102, 122, 0.1);
}
.page-wrapper.compact-small .page-header {
  margin-left: 90px;
  width: calc(100% - 90px);
}
.page-wrapper.compact-small .page-header .header-wrapper .logo-wrapper {
  display: none;
}
.page-wrapper.compact-small .page-header.close_icon {
  margin-left: 0;
  width: calc(100% - 0px);
}
.page-wrapper.compact-small .page-body-wrapper .page-body {
  margin-left: 90px;
}
.page-wrapper.compact-small .page-body-wrapper .footer {
  margin-left: 90px;
}
.page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper > div {
  width: 90px;
}
@media (max-width: 420px) {
  .page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links {
    height: calc(100vh - 105px);
  }
}
.page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-title {
  display: block;
  padding: 15px 0;
}
.page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu,
.page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container {
  left: 90px;
}
.page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu li a,
.page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container li a {
  padding: 10px 15px 10px 40px;
}
.page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu li a .sub-arrow,
.page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container li a .sub-arrow {
  display: none;
}
.page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu li a .according-menu,
.page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container li a .according-menu {
  top: 11px;
}
.page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list .badge {
  display: none;
}
.page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list .sidebar-link svg {
  margin: 0 auto;
  width: 20px;
  height: 20px;
}
.page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list .sidebar-link > span {
  display: none;
}
.page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .mega-menu svg {
  margin: 0 auto;
}
.page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .mega-menu a > span {
  display: none;
}
.page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper.close_icon {
  transform: translateX(-150px);
}
.page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper.close_icon ~ .page-body,
.page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper.close_icon ~ .footer {
  margin-left: 0px;
}
.page-wrapper.only-body {
  background-color: #f2f0fa;
}
.page-wrapper.only-body .page-body-wrapper {
  background-color: #f2f0fa;
}
.page-wrapper.only-body .page-header {
  position: relative;
}
.page-wrapper.only-body .page-header .header-logo-wrapper {
  display: none;
}
.page-wrapper.only-body .page-header .header-wrapper {
  padding: 0 !important;
}
.page-wrapper.only-body .page-header .header-wrapper .left-header {
  display: none;
}
.page-wrapper.only-body .page-header .header-wrapper .nav-right {
  position: absolute;
  right: 60px;
  top: 58px;
}
.page-wrapper.only-body .page-header .header-wrapper .search-full {
  top: 37px;
  width: calc(100% - 50px);
  left: 25px;
}
[dir=rtl] .page-wrapper.only-body .page-header .header-wrapper .search-full {
  left: unset;
  right: 25px;
}
.page-wrapper.only-body .page-header .header-wrapper .search-full .form-group .Typeahead .u-posRelative {
  background-color: #fff;
  border-radius: 15px;
}
.page-wrapper.only-body .page-header .header-wrapper .search-full .Typeahead-menu {
  top: 78px;
  width: calc(100% - 30px);
  margin: 0 auto;
  right: 0;
}
.page-wrapper.only-body .page-body-wrapper .page-title {
  padding-top: 20px;
  padding-bottom: 20px;
}
.page-wrapper.only-body .sidebar-wrapper,
.page-wrapper.only-body footer {
  display: none;
}
.page-wrapper.only-body .page-body-wrapper .page-body {
  margin-top: 0px;
  min-height: calc(100vh - 0px);
}
.page-wrapper.only-body .page-body-wrapper .page-title {
  padding-left: 30px;
  padding-right: 30px;
  margin: 30px 0;
  border-radius: 15px;
}
@media (max-width: 991.98px) {
  .page-wrapper.only-body .page-body-wrapper .page-title {
    padding-left: 20px;
    padding-right: 20px;
    margin: 20px 0;
  }
}
.page-wrapper.only-body .page-body-wrapper .page-title > .row .col-6 {
  flex: 0 0 100%;
  max-width: 100%;
}
.page-wrapper.only-body .page-body-wrapper .page-title .breadcrumb {
  margin-top: 5px;
  justify-content: flex-start;
}
.page-wrapper.modern-type .progress-chart-wrap {
  margin-left: -22px;
}
[dir=rtl] .page-wrapper.modern-type .progress-chart-wrap {
  margin-left: unset;
  margin-right: -22px;
}
.page-wrapper.modern-type .ecommerce-widget {
  border: 1px solid rgb(85.3594771242%, 84%, 100%) !important;
}
.page-wrapper.modern-type .file-sidebar .pricing-plan {
  border: 1px solid rgb(85.3594771242%, 84%, 100%) !important;
}
.page-wrapper.modern-type .alert-primary {
  color: #7366ff;
}
.page-wrapper.modern-type .project-box {
  background-color: rgb(85.3594771242%, 84%, 100%);
}
.page-wrapper.modern-type .nav-tabs .nav-link.active {
  background-color: transparent;
}
.page-wrapper.modern-type .simplebar-mask {
  top: 10px;
}
.page-wrapper.modern-type .page-header {
  margin-left: 0px;
  width: calc(100% - 0px);
}
.page-wrapper.modern-type .page-header.close_icon {
  margin-left: 0px;
  width: calc(100% - 0px);
}
.page-wrapper.modern-type .page-header .header-wrapper .left-header {
  width: 30%;
}
@media (max-width: 1428px) and (min-width: 1200px) {
  .page-wrapper.modern-type .page-header .header-wrapper .left-header {
    width: 37%;
  }
}
@media (max-width: 818px) {
  .page-wrapper.modern-type .page-header .header-wrapper .left-header {
    width: 36%;
  }
}
@media (max-width: 1669px) {
  .page-wrapper.modern-type .page-header .header-wrapper .nav-right {
    width: 50%;
  }
}
@media (max-width: 1428px) and (min-width: 1200px) {
  .page-wrapper.modern-type .page-header .header-wrapper .nav-right {
    width: 40%;
  }
}
.page-wrapper.modern-type .page-header .header-wrapper .header-logo-wrapper {
  display: flex;
  align-items: center;
}
.page-wrapper.modern-type .page-header .header-wrapper .logo-wrapper {
  display: block;
  margin-right: 30px;
}
.page-wrapper.modern-type .page-header .header-wrapper .toggle-sidebar {
  display: block;
  position: relative;
  top: unset;
  right: unset;
  margin-right: 15px;
}
.page-wrapper.modern-type .page-body-wrapper .page-title {
  background-color: transparent;
  padding-bottom: 0;
}
.page-wrapper.modern-type .page-body-wrapper div.sidebar-wrapper {
  margin: 30px !important;
  top: 80px;
  bottom: 0;
  border-radius: 15px;
}
.page-wrapper.modern-type .page-body-wrapper div.sidebar-wrapper .logo-wrapper,
.page-wrapper.modern-type .page-body-wrapper div.sidebar-wrapper .logo-icon-wrapper {
  display: none;
}
.page-wrapper.modern-type .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links {
  height: calc(100vh - 160px);
}
.page-wrapper.modern-type .page-body-wrapper div.sidebar-wrapper.close_icon .logo-icon-wrapper {
  display: none;
}
.page-wrapper.modern-type .page-body-wrapper div.sidebar-wrapper.close_icon ~ .page-body {
  margin-left: 0px;
}
.page-wrapper.modern-type .page-body-wrapper div.sidebar-wrapper.close_icon ~ footer {
  margin-left: 0px;
  margin-right: 0px;
}
.page-wrapper.modern-type .page-body-wrapper div.sidebar-wrapper.close_icon:hover .logo-wrapper {
  display: none;
}
.page-wrapper.modern-type .page-body-wrapper .page-body {
  margin-left: 296px;
}
.page-wrapper.modern-type .page-body-wrapper .page-body .container-fluid, .page-wrapper.modern-type .page-body-wrapper .page-body .container-sm, .page-wrapper.modern-type .page-body-wrapper .page-body .container-md, .page-wrapper.modern-type .page-body-wrapper .page-body .container-lg, .page-wrapper.modern-type .page-body-wrapper .page-body .container-xl, .page-wrapper.modern-type .page-body-wrapper .page-body .container-xxl {
  max-width: 1500px;
}
.page-wrapper.modern-type .page-body-wrapper .footer {
  margin-left: 360px;
  margin-right: 70px;
  border-radius: 10px;
}
@media (max-width: 991px) {
  .page-wrapper.modern-type .page-body-wrapper .footer {
    margin-right: 0;
    margin-left: 0;
  }
}
.page-wrapper.material-type {
  position: relative;
}
.page-wrapper.material-type::before {
  position: absolute;
  content: "";
  left: 0;
  top: -50px;
  width: 100%;
  height: 300px;
  background-image: linear-gradient(103.75deg, #33b1ee -13.9%, var(--theme-default) 79.68%);
}
.page-wrapper.material-type .card {
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
}
.page-wrapper.material-type .page-header {
  position: relative;
  max-width: 1560px;
  margin: 50px auto 0;
  border-radius: 15px 15px 0 0;
}
.page-wrapper.material-type .page-header .header-wrapper .left-header {
  width: 31%;
}
@media (max-width: 1600px) {
  .page-wrapper.material-type .page-header .header-wrapper .left-header {
    width: 33%;
  }
}
@media (max-width: 1366px) {
  .page-wrapper.material-type .page-header .header-wrapper .left-header {
    width: 38%;
  }
}
@media (max-width: 1199px) {
  .page-wrapper.material-type .page-header .header-wrapper .left-header {
    width: 30%;
  }
}
@media (max-width: 1600px) {
  .page-wrapper.material-type .page-header .header-wrapper .nav-right {
    width: 40%;
  }
}
@media (max-width: 1199px) {
  .page-wrapper.material-type .page-header .header-wrapper .nav-right {
    width: 45%;
  }
}
.page-wrapper.material-type .page-body-wrapper {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
  background-blend-mode: overlay;
  background-color: rgba(255, 255, 255, 0.5);
}
.page-wrapper.material-type .page-body-wrapper .sidebar-wrapper {
  position: relative;
  max-width: 1560px;
  margin: 0 auto;
  top: unset;
  height: 56px;
}
.page-wrapper.material-type .page-body-wrapper .page-body {
  margin: 0 auto;
  max-width: 1560px;
  background-color: #f8f8f8;
  box-shadow: 0 0 20px 7px rgba(8, 21, 66, 0.05);
  border-radius: 0 0 15px 15px;
}
.page-wrapper.material-type .footer {
  margin-top: 40px;
}
.page-wrapper.material-type.compact-wrapper .page-header .header-wrapper .left-header {
  width: 38%;
}
@media (max-width: 991px) {
  .page-wrapper.material-type.compact-wrapper .page-header .header-wrapper .nav-right {
    width: 50%;
  }
}
.page-wrapper.advance-layout {
  background-blend-mode: overlay;
  background-color: #f7f8f9;
}
.page-wrapper.advance-layout .card {
  border-radius: 5px;
  box-shadow: none;
  border: 1px solid #ecf3fa;
}
.page-wrapper.advance-layout .page-header {
  position: relative;
  background-color: #fff;
  margin: 0 auto;
}
.page-wrapper.advance-layout .page-body-wrapper {
  background: transparent;
}
.page-wrapper.advance-layout .page-body-wrapper .sidebar-wrapper {
  position: relative !important;
  top: unset !important;
  height: unset;
  box-shadow: none;
  border-top: 1px solid #efefef;
  border-bottom: 1px solid #efefef;
}
.page-wrapper.advance-layout .page-body-wrapper .sidebar-wrapper > div {
  overflow-x: hidden;
}
.page-wrapper.advance-layout .page-body-wrapper .page-body {
  margin-top: 0 !important;
}

@keyframes pagebody {
  from {
    opacity: 0;
    transform: scale3d(0.98, 0.98, 0.98) translate(-20px, -50px);
  }
  50% {
    opacity: 1;
  }
}
.md-sidebar {
  position: relative;
}
.md-sidebar .md-sidebar-toggle {
  display: none;
  width: fit-content;
  text-transform: capitalize;
  margin-bottom: 20px;
}

@media screen and (max-width: 1480px) {
  .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container {
    right: -18%;
    width: 91%;
  }
}
@media screen and (max-width: 1460px) {
  .page-wrapper.horizontal-wrapper .page-body-wrapper.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container {
    right: -54%;
    width: 75%;
  }
  .sidebar-wrapper .sidebar-main .sidebar-links > li {
    margin-right: 8px;
  }
}
@media screen and (max-width: 1366px) {
  .page-wrapper.horizontal-wrapper .page-body-wrapper.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container {
    right: -49%;
    width: 70%;
  }
  .profile-dropdown.onhover-show-div {
    right: 0;
    left: unset !important;
  }
  .profile-dropdown.onhover-show-div:before, .profile-dropdown.onhover-show-div:after {
    right: 10px !important;
    left: unset !important;
  }
}
@media screen and (max-width: 1199px) {
  .page-wrapper .page-header .header-wrapper .nav-right > ul > li {
    padding: 6px;
  }
  .mobile-title.d-none {
    display: flex !important;
    justify-content: space-between;
    padding: 20px 30px 17px;
    border-bottom: 1px solid #ddd;
    margin: 0 -15px;
  }
  .mobile-title.d-none h5, .mobile-title.d-none .h5 {
    color: var(--theme-default);
  }
  .mobile-title.d-none svg {
    stroke: var(--theme-default) !important;
  }
  .page-wrapper.horizontal-wrapper .page-body-wrapper.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container {
    right: -35%;
    width: 56%;
  }
}
@media screen and (min-width: 992px) {
  .page-header .header-wrapper .nav-right .notification-dropdown {
    top: 46px;
  }
  .responsive-btn {
    display: none;
  }
  .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-main .sidebar-links .simplebar-mask {
    top: 0;
  }
  .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu {
    width: 200px;
    opacity: 0;
    visibility: hidden;
    border-radius: 5px;
    transition: all 0.5s ease;
  }
  .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu a .sub-arrow {
    position: absolute;
    right: 20px;
    top: 5px;
    color: #59667a;
    font-weight: 100;
    transition: all 0.5s ease;
    font-size: 15px;
    top: 5px;
  }
  .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li .nav-sub-childmenu {
    display: none;
    border-radius: 4px;
  }
  .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li:hover .nav-sub-childmenu {
    display: block !important;
    position: absolute;
    left: 200px;
    background-color: #fff;
    top: -10px;
    padding: 15px 0px 15px 0px;
    box-shadow: 0 0 1px 0 #898989;
  }
  .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a:hover .sub-arrow {
    right: 16px;
    transition: all 0.5s ease;
  }
  .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-main .sidebar-links > li .mega-menu-container {
    opacity: 0;
    visibility: hidden;
    transition: all 0.5s ease;
  }
  .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-main .sidebar-links > li.hoverd .sidebar-submenu {
    opacity: 1;
    visibility: visible;
    margin-top: 8px;
    transition: all 0.5s ease;
  }
  .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-main .sidebar-links > li:hover .mega-menu-container {
    opacity: 1;
    visibility: visible;
    margin-top: 20px;
    transition: all 0.5s ease;
  }
  .page-wrapper.horizontal-wrapper .page-body-wrapper .toggle-nav {
    display: none;
  }
  .page-wrapper.horizontal-wrapper .page-body-wrapper .mobile-back {
    display: none !important;
  }
}
@media only screen and (min-width: 768px) {
  .page-wrapper.material-icon {
    position: relative;
  }
  .page-wrapper.material-icon::before {
    position: absolute;
    content: "";
    left: 0;
    width: 100%;
    height: 200px;
    background: linear-gradient(103.75deg, #33b1ee -13.9%, var(--theme-default) 79.68%);
  }
  .page-wrapper.material-icon .toggle-sidebar {
    color: rgba(255, 255, 255, 0.8);
  }
  .page-wrapper.material-icon .toggle-sidebar:hover > svg {
    color: #fff !important;
    stroke: #fff !important;
  }
  .page-wrapper.material-icon .page-header {
    position: relative;
    background: transparent;
    padding-left: 90px;
    max-width: 1660px;
    margin: 0 auto;
    width: calc(100% - 0px);
    box-shadow: none;
  }
  .page-wrapper.material-icon .page-header .f-light {
    color: #fff;
  }
  .page-wrapper.material-icon .page-header .header-wrapper .nav-right ul li svg {
    stroke: #fff;
  }
  .page-wrapper.material-icon .page-header .header-wrapper .nav-right ul li .profile-dropdown li svg {
    stroke: #2f2f3b;
  }
  .page-wrapper.material-icon .page-header .header-wrapper .nav-right > ul > li {
    color: #fff;
  }
  .page-wrapper.material-icon .page-header .header-wrapper .nav-right > ul > li .notification-box svg,
  .page-wrapper.material-icon .page-header .header-wrapper .nav-right > ul > li .cart-box svg {
    stroke: #fff;
  }
  .page-wrapper.material-icon .page-header .header-wrapper .nav-right > ul > li > a > svg {
    stroke: #fff;
  }
  .page-wrapper.material-icon .page-header .header-wrapper .nav-right > ul > li > svg {
    stroke: #fff;
  }
  .page-wrapper.material-icon .page-header .header-wrapper .nav-right .language-nav .more_lang {
    color: #2f2f3b;
  }
  .page-wrapper.material-icon .page-header .header-wrapper .nav-right .onhover-show-div {
    color: #2f2f3b;
  }
  .page-wrapper.material-icon .page-header .header-wrapper .nav-right.right-header ul li .profile-media .media-body p {
    color: rgba(255, 255, 255, 0.7);
  }
  .page-wrapper.material-icon .page-header.close_icon {
    padding-left: 0;
    margin: 0 auto !important;
  }
  .page-wrapper.material-icon .page-body-wrapper .page-body {
    margin-top: 0 !important;
    padding-left: 90px;
    max-width: 1660px;
    margin: 0 auto;
  }
  .page-wrapper.material-icon .page-body-wrapper div.sidebar-wrapper.close_icon ~ .page-body {
    padding-left: 15px;
    margin: 0 auto !important;
  }
  .page-wrapper.material-icon .page-body-wrapper .page-title {
    color: #fff;
    background-color: transparent;
    border-bottom: none;
    box-shadow: none;
  }
  .page-wrapper.material-icon .page-body-wrapper .page-title .breadcrumb .breadcrumb-item a svg {
    stroke: #fff;
  }
  .page-wrapper.material-icon .page-body-wrapper .page-title .breadcrumb .breadcrumb-item.active {
    color: rgba(255, 255, 255, 0.6);
  }
  .page-wrapper.material-icon .page-body-wrapper .page-title .breadcrumb .breadcrumb-item + .breadcrumb-item::before {
    color: rgba(255, 255, 255, 0.8);
  }
}
@media only screen and (min-width: 992px) {
  .page-wrapper.material-icon::before {
    height: 240px;
  }
}
@media screen and (max-width: 767px) {
  .sidebar-wrapper .menu .brand-logo img {
    width: 120px;
  }
}
@media screen and (max-width: 576px) {
  .toggle-nav i {
    font-size: 20px;
  }
}
.page-wrapper[sidebar-layout=stroke-svg] .sidebar-wrapper .stroke-icon,
.page-wrapper[sidebar-layout=stroke-svg] .page-header .stroke-icon {
  display: inline-block;
}
.page-wrapper[sidebar-layout=stroke-svg] .sidebar-wrapper .fill-icon,
.page-wrapper[sidebar-layout=stroke-svg] .page-header .fill-icon {
  display: none;
}
.page-wrapper[sidebar-layout=fill-svg] .sidebar-wrapper .stroke-icon,
.page-wrapper[sidebar-layout=fill-svg] .page-header .stroke-icon {
  display: none;
}
.page-wrapper[sidebar-layout=fill-svg] .sidebar-wrapper .fill-icon,
.page-wrapper[sidebar-layout=fill-svg] .page-header .fill-icon {
  display: inline-block;
}

/**=====================
    78. Sidebar CSS Ends
==========================**/
/**=====================
    60. RTL CSS Start
==========================**/
html[dir=rtl] ul {
  padding-right: 0;
}
html[dir=rtl] .location-checkbox span {
  padding-left: 0;
  padding-right: 33px;
}
html[dir=rtl] .border-end {
  border-left: 1px solid var(--chart-border) !important;
  border-right: initial !important;
}
html[dir=rtl] .follow .text-md-end {
  text-align: left !important;
}
html[dir=rtl] .ms-auto {
  margin-left: unset !important;
  margin-right: auto !important;
}
html[dir=rtl] .f-right {
  float: left;
}
html[dir=rtl] .papernote-wrap .note-labels ul {
  gap: 9px;
}
html[dir=rtl] .form-check-inline {
  margin-right: unset;
  margin-left: 1rem;
}
html[dir=rtl] .color-box button + button {
  margin-left: unset;
  margin-right: 5px;
}
html[dir=rtl] .knowledgebase-search .form-inline svg {
  left: unset;
  right: 20px;
}
html[dir=rtl] .switch-showcase .form-check .form-check-input {
  float: left;
}
html[dir=rtl] .pill-input-group span:last-child {
  border-top-right-radius: unset !important;
  border-bottom-right-radius: unset !important;
  border-top-left-radius: 1.3rem !important;
  border-bottom-left-radius: 1.3rem !important;
}
html[dir=rtl] .pill-input-group span:first-child {
  border-top-left-radius: unset !important;
  border-top-right-radius: unset !important;
  border-top-right-radius: 1.3rem !important;
  border-bottom-right-radius: 1.3rem !important;
}
html[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper {
  text-align: right;
}
html[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper .toggle-sidebar {
  right: unset;
  left: 30px;
}
html[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links {
  padding: 0;
}
html[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .badge {
  left: 50px !important;
  right: unset !important;
}
html[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper.close_icon {
  margin-right: 0;
  margin-left: unset;
}
html[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper.close_icon .logo-icon-wrapper {
  text-align: left;
}
html[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper.close_icon .logo-icon-wrapper img {
  margin-left: 8px;
}
html[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper.close_icon ~ .page-body,
html[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper.close_icon ~ footer {
  margin-left: 0;
  margin-right: 100px;
  transition: 0.5s;
}
html[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper.close_icon .sidebar-main .sidebar-links > li a svg {
  margin-left: 0;
}
html[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper.close_icon .sidebar-main .sidebar-links .sidebar-list .sidebar-title.active ~ .sidebar-submenu {
  display: none !important;
}
html[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper.close_icon .according-menu {
  display: none;
}
html[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper.close_icon:hover .sidebar-main .sidebar-links > li a svg {
  margin-left: 13px;
}
html[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper:hover {
  transform: translate(0px);
}
html[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper:hover .sidebar-main .sidebar-links .sidebar-list .sidebar-title.active ~ .sidebar-submenu {
  display: block !important;
}
html[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper:hover .sidebar-main .sidebar-links > li a svg {
  float: none;
}
html[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper:hover .according-menu {
  display: block;
}
html[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu:after {
  right: 30px;
  left: unset;
}
html[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu > li a {
  padding-right: 45px !important;
  padding-left: unset !important;
}
html[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu > li a:after {
  right: 26px;
  left: unset;
}
html[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .page-body {
  margin-left: unset;
  margin-right: 265px;
}
html[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li a svg {
  margin-right: unset;
  margin-left: 15px;
}
html[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .according-menu {
  right: unset;
  left: 20px;
}
html[dir=rtl] .page-wrapper.only-body .page-header .header-wrapper .nav-right {
  right: unset;
  left: 30px;
}
html[dir=rtl] .date-details > div + div {
  margin-left: unset;
  margin-right: 10px;
}
html[dir=rtl] .contact-editform.ps-0 {
  padding-left: 20px !important;
}
html[dir=rtl] .contact-options li .btn-category {
  padding-left: unset !important;
  padding-right: 40px;
}
html[dir=rtl] .list-persons .profile-mail .email-general ul {
  padding-right: unset;
  padding-left: 20px;
}
html[dir=rtl] .list-persons .profile-mail .email-general ul li > span {
  float: left;
}
html[dir=rtl] .list-persons .profile-mail .media .media-body ul li + li {
  padding-left: unset;
  padding-right: 10px;
  margin-left: unset;
  margin-right: 5px;
  border-left: unset;
  border-right: 1px solid #f4f4f4;
}
html[dir=rtl] .file-content .form-inline i {
  padding-right: unset;
  padding-left: 10px;
}
html[dir=rtl] .file-sidebar .btn svg {
  margin-right: unset;
  margin-left: 8px;
}
html[dir=rtl] .form-select {
  background-position: left 0.75rem center;
}
html[dir=rtl] .customers ul li + li {
  margin-left: unset;
  margin-right: -10%;
}
html[dir=rtl] .project-list .border-tab.nav-tabs .nav-item .nav-link {
  padding: 5px 0 5px 30px;
}
html[dir=rtl] .project-box .badge {
  right: unset;
  left: 30px;
}
html[dir=rtl] .kanban-board {
  float: right;
}
html[dir=rtl] .kanban-item .kanban-box .customers ul li + li {
  margin-left: unset;
  margin-right: -10px;
}
html[dir=rtl] .kanban-item .list li i {
  margin-right: unset;
  margin-left: 10px;
}
html[dir=rtl] .page-wrapper.horizontal-wrapper .header-logo-wrapper {
  text-align: right;
}
html[dir=rtl] .page-wrapper.horizontal-wrapper .page-body-wrapper .page-body {
  margin-right: 0;
}
html[dir=rtl] .page-wrapper.horizontal-wrapper .page-body-wrapper footer {
  margin-right: 0;
}
html[dir=rtl] .page-wrapper.material-type .page-body-wrapper .page-body {
  margin-right: auto;
}
html[dir=rtl] .page-header .header-wrapper .nav-right > ul > li:first-child {
  margin-right: 0;
}
html[dir=rtl] .page-header .header-wrapper .nav-right.right-header ul li .profile-media .media-body {
  margin-right: 15px;
  margin-left: unset;
}
html[dir=rtl] .page-header .header-wrapper .toggle-sidebar {
  margin-left: 2px;
  margin-right: unset;
}
html[dir=rtl] .page-wrapper .page-header .header-wrapper .nav-right .notification-dropdown {
  left: -20px !important;
  right: unset !important;
}
@media (max-width: 575.98px) {
  html[dir=rtl] .page-wrapper .page-header .header-wrapper .nav-right .notification-dropdown {
    left: 12px !important;
  }
}
html[dir=rtl] .page-wrapper .page-header .header-wrapper .search-full input {
  padding-left: unset;
  padding-right: 60px;
  text-align: right;
}
html[dir=rtl] .page-wrapper .page-header .header-wrapper .search-full .form-group:before {
  left: unset;
  right: 30px;
}
html[dir=rtl] .page-wrapper .page-header .header-wrapper .search-full .form-group .close-search {
  right: unset;
  left: 0;
}
html[dir=rtl] .page-wrapper.compact-sidebar .toggle-sidebar {
  margin-left: 15px;
  margin-right: unset;
}
html[dir=rtl] .page-wrapper.compact-sidebar .page-header {
  margin-left: unset;
  margin-right: 150px;
}
html[dir=rtl] .page-wrapper.compact-sidebar .page-header.close_icon {
  margin-right: 0;
}
html[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper .page-body {
  margin-left: unset;
  margin-right: 150px;
}
html[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper .footer {
  margin-left: unset;
  margin-right: 150px;
}
html[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper > div {
  text-align: right;
}
html[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a.active ~ .sidebar-submenu,
html[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a.active ~ .mega-menu-container {
  animation: fadeInRight 1000ms ease-in-out;
}
html[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu,
html[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container {
  right: 150px;
  left: unset;
}
html[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu li a,
html[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container li a {
  padding: 15px 40px 15px 15px;
}
html[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu li a .according-menu,
html[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container li a .according-menu {
  right: 20px;
}
html[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu > li > a::after,
html[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container > li > a::after {
  left: unset;
  right: 20px;
}
html[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu .mega-box .link-section,
html[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container .mega-box .link-section {
  text-align: right;
}
html[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu .mega-box .link-section .submenu-title h5, html[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu .mega-box .link-section .submenu-title .h5,
html[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container .mega-box .link-section .submenu-title h5,
html[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container .mega-box .link-section .submenu-title .h5 {
  padding: 15px 40px 15px 15px;
}
html[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu .mega-box .link-section .submenu-title h5::after, html[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu .mega-box .link-section .submenu-title .h5::after,
html[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container .mega-box .link-section .submenu-title h5::after,
html[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container .mega-box .link-section .submenu-title .h5::after {
  left: unset;
  right: 20px;
}
html[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list .badge {
  left: unset;
  right: 53%;
}
html[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list .sidebar-link {
  text-align: center;
}
html[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .mega-menu {
  text-align: center;
}
html[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .mega-menu .according-menu {
  right: unset;
  left: 20px;
}
html[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper.close_icon {
  transform: translateX(150px);
}
html[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper.close_icon ~ .page-body,
html[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper.close_icon ~ .footer {
  margin-right: 0px;
}
html[dir=rtl] .page-wrapper.compact-small .page-header {
  margin-right: 90px;
}
html[dir=rtl] .page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu,
html[dir=rtl] .page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container {
  right: 90px;
}
html[dir=rtl] .page-wrapper.compact-small .page-body-wrapper .footer,
html[dir=rtl] .page-wrapper.compact-small .page-body-wrapper .page-body {
  margin-right: 90px;
}
html[dir=rtl] .page-wrapper.material-icon .page-header {
  padding-left: unset;
  padding-right: 90px;
  margin: 0 auto;
}
html[dir=rtl] .page-wrapper.material-icon .page-header.close_icon {
  padding-right: 0;
}
html[dir=rtl] .page-wrapper.material-icon .page-body-wrapper .page-body {
  padding-left: 15px;
  padding-right: 90px;
  margin: 0 auto;
}
html[dir=rtl] .page-wrapper.material-icon .page-body-wrapper div.sidebar-wrapper.close_icon ~ .page-body {
  padding-right: 15px;
  margin: 0 auto !important;
}
html[dir=rtl] .apexcharts-canvas {
  direction: ltr;
}
html[dir=rtl] .email-wrap .btn-mail {
  text-align: right;
}
html[dir=rtl] .email-wrap .email-app-sidebar ul li a {
  padding-left: unset;
  padding-right: 20px;
}
html[dir=rtl] .bookmark-tabcontent .details-bookmark .bookmark-card.card .favourite-icon {
  text-align: center;
}
html[dir=rtl] .bookmark-tabcontent .details-bookmark .bookmark-card.card .title-bookmark {
  text-align: right;
}
html[dir=rtl] .bookmark-wrap .details-bookmark .row > div + div {
  padding-left: 15px !important;
}
html[dir=rtl] .appointment-table table tr td .status-circle {
  left: unset;
  right: 35px;
}
html[dir=rtl] .notification .card .d-flex .w-100 p .badge {
  margin-left: unset;
  margin-right: 10px;
}
html[dir=rtl] .progress-gradient-primary {
  background-image: linear-gradient(to right, var(--theme-default), transparent);
}
html[dir=rtl] .progress-gradient-primary::after {
  right: unset;
  left: -1px;
}
html[dir=rtl] .progress-gradient-primary .animate-circle {
  right: unset;
  left: -8px;
}
html[dir=rtl] .progress-gradient-secondary {
  background-image: linear-gradient(to right, #ff3364, transparent);
}
html[dir=rtl] .progress-gradient-secondary::after {
  right: unset;
  left: -1px;
}
html[dir=rtl] .progress-gradient-secondary .animate-circle {
  right: unset;
  left: -8px;
}
html[dir=rtl] .progress-gradient-success {
  background-image: linear-gradient(to right, #54ba4a, transparent);
}
html[dir=rtl] .progress-gradient-success::after {
  right: unset;
  left: -1px;
}
html[dir=rtl] .progress-gradient-success .animate-circle {
  right: unset;
  left: -8px;
}
html[dir=rtl] .progress-gradient-danger {
  background-image: linear-gradient(to right, #fc4438, transparent);
}
html[dir=rtl] .progress-gradient-danger::after {
  right: unset;
  left: -1px;
}
html[dir=rtl] .progress-gradient-danger .animate-circle {
  right: unset;
  left: -8px;
}
html[dir=rtl] .progress-gradient-info {
  background-image: linear-gradient(to right, #16c7f9, transparent);
}
html[dir=rtl] .progress-gradient-info::after {
  right: unset;
  left: -1px;
}
html[dir=rtl] .progress-gradient-info .animate-circle {
  right: unset;
  left: -8px;
}
html[dir=rtl] .progress-gradient-light {
  background-image: linear-gradient(to right, #f4f4f4, transparent);
}
html[dir=rtl] .progress-gradient-light::after {
  right: unset;
  left: -1px;
}
html[dir=rtl] .progress-gradient-light .animate-circle {
  right: unset;
  left: -8px;
}
html[dir=rtl] .progress-gradient-dark {
  background-image: linear-gradient(to right, #2c323f, transparent);
}
html[dir=rtl] .progress-gradient-dark::after {
  right: unset;
  left: -1px;
}
html[dir=rtl] .progress-gradient-dark .animate-circle {
  right: unset;
  left: -8px;
}
html[dir=rtl] .progress-gradient-warning {
  background-image: linear-gradient(to right, #ffaa05, transparent);
}
html[dir=rtl] .progress-gradient-warning::after {
  right: unset;
  left: -1px;
}
html[dir=rtl] .progress-gradient-warning .animate-circle {
  right: unset;
  left: -8px;
}
html[dir=rtl] .progress-animate span {
  left: -10px;
  right: unset;
}
html[dir=rtl] .me-4 {
  margin-left: 1.5rem !important;
  margin-right: unset !important;
}
html[dir=rtl] .pe-4 {
  padding-left: 1.5rem !important;
  padding-right: unset !important;
}
html[dir=rtl] .me-1 {
  margin-left: 0.25rem !important;
  margin-right: unset !important;
}
html[dir=rtl] .navs-dropdown .onhover-show-div {
  right: 0;
}
html[dir=rtl] .default-according.style-1 button {
  text-align: right;
}
html[dir=rtl] .default-according.style-1 button:before {
  left: 20px;
  right: unset;
}
@media (max-width: 575px) {
  html[dir=rtl] .default-according.style-1 button:before {
    left: 15px;
  }
}
html[dir=rtl] .default-according.style-1 button i {
  right: 18px;
  left: unset;
}
html[dir=rtl] .default-according .card .card-header i {
  right: 18px;
  left: unset;
}
html[dir=rtl] .faq-wrap .faq-accordion .card .card-header .btn-link {
  padding-right: 20px !important;
}
@media (max-width: 575.98px) {
  html[dir=rtl] .faq-wrap .faq-accordion .card .card-header .btn-link {
    padding-right: 10px !important;
  }
}
html[dir=rtl] .ProfileCard-details {
  padding-right: 30px;
  padding-left: unset;
  float: right;
}
html[dir=rtl] .starter-main .card-body ul {
  padding-right: 30px;
  padding-left: unset;
}
html[dir=rtl] .theme-tab .tab-title li a svg {
  margin-left: 5px;
  margin-right: unset;
}
html[dir=rtl] .spent .spent-graph .project-budget {
  margin-left: 30px;
  margin-right: unset;
}
html[dir=rtl] .support-table table tbody tr td:first-child {
  padding-right: 0;
  padding-left: unset;
}
html[dir=rtl] .order-box .sub-total .shipping-class .shopping-checkout-option,
html[dir=rtl] .order-box .sub-total .shipping-class span,
html[dir=rtl] .order-box .sub-total li .shopping-checkout-option,
html[dir=rtl] .order-box .sub-total li span,
html[dir=rtl] .order-box .total .shipping-class .shopping-checkout-option,
html[dir=rtl] .order-box .total .shipping-class span,
html[dir=rtl] .order-box .total li .shopping-checkout-option,
html[dir=rtl] .order-box .total li span,
html[dir=rtl] .order-box .qty .shipping-class .shopping-checkout-option,
html[dir=rtl] .order-box .qty .shipping-class span,
html[dir=rtl] .order-box .qty li .shopping-checkout-option,
html[dir=rtl] .order-box .qty li span {
  float: left;
}
html[dir=rtl] .order-box .sub-total li .count,
html[dir=rtl] .order-box .total li .count,
html[dir=rtl] .order-box .qty li .count {
  float: left;
}
html[dir=rtl] .img-paypal {
  margin-right: 15px;
  margin-left: unset;
}
html[dir=rtl] .cart .qty-box .input-group .btn {
  border-radius: 0 !important;
}
html[dir=rtl] .product-qnty fieldset .input-group .input-group-prepend .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
html[dir=rtl] .grid-options {
  margin-right: 10px;
  margin-left: unset;
}
html[dir=rtl] .grid-options ul li a .line-grid-1 {
  right: 12px;
  left: unset;
}
html[dir=rtl] .grid-options ul li a .line-grid-2 {
  right: 18px;
  left: unset;
}
html[dir=rtl] .grid-options ul li a .line-grid-3 {
  right: 36px;
  left: unset;
}
html[dir=rtl] .grid-options ul li a .line-grid-4 {
  right: 42px;
  left: unset;
}
html[dir=rtl] .grid-options ul li a .line-grid-5 {
  right: 48px;
  left: unset;
}
html[dir=rtl] .grid-options ul li a .line-grid-6 {
  right: 66px;
  left: unset;
}
html[dir=rtl] .grid-options ul li a .line-grid-7 {
  right: 72px;
  left: unset;
}
html[dir=rtl] .grid-options ul li a .line-grid-8 {
  right: 78px;
  left: unset;
}
html[dir=rtl] .grid-options ul li a .line-grid-9 {
  right: 84px;
  left: unset;
}
html[dir=rtl] .grid-options ul li a .line-grid-10 {
  right: 103px;
  left: unset;
}
html[dir=rtl] .grid-options ul li a .line-grid-11 {
  right: 109px;
  left: unset;
}
html[dir=rtl] .grid-options ul li a .line-grid-12 {
  right: 115px;
  left: unset;
}
html[dir=rtl] .grid-options ul li a .line-grid-13 {
  right: 121px;
  left: unset;
}
html[dir=rtl] .grid-options ul li a .line-grid-14 {
  right: 127px;
  left: unset;
}
html[dir=rtl] .grid-options ul li a .line-grid-15 {
  right: 133px;
  left: unset;
}
html[dir=rtl] .product-filter.new-products .owl-theme .owl-nav {
  left: 0;
  right: unset;
}
html[dir=rtl] .product-filter.new-products .owl-theme .owl-item .item .product-box .product-details.text-start {
  text-align: left !important;
}
html[dir=rtl] .product-sidebar .filter-section .card .card-header h6 .pull-right i, html[dir=rtl] .product-sidebar .filter-section .card .card-header .h6 .pull-right i {
  left: auto;
  right: unset;
}
html[dir=rtl] .prooduct-details-box .btn {
  right: unset;
  left: 15px;
}
html[dir=rtl] .prooduct-details-box .close {
  right: unset;
  left: 10px;
}
html[dir=rtl] .collection-filter-block svg {
  margin-right: unset;
  margin-left: 10px;
}
html[dir=rtl] .feature-products form .form-group i {
  left: 30px;
  right: unset;
}
html[dir=rtl] .product-wrapper-grid.list-view .product-box .product-details {
  text-align: right;
}
html[dir=rtl] .page-wrapper .page-body-wrapper .page-title .breadcrumb {
  margin-left: unset;
}
html[dir=rtl] .bookmark ul li + li {
  margin-left: unset;
  margin-right: 10px;
}
html[dir=rtl] .bookmark ul li .search-form .form-control-search {
  left: -50px;
  right: unset;
}
html[dir=rtl] .bookmark ul li .search-form .form-control-search:before {
  right: 50px;
  left: unset;
}
html[dir=rtl] .bookmark ul li .search-form .form-control-search:after {
  right: 20px;
  left: unset;
}
html[dir=rtl] .me-0 {
  margin-left: 0 !important;
  margin-right: unset !important;
}
html[dir=rtl] .footer .pull-right {
  float: none;
}
html[dir=rtl] .checkbox_animated,
html[dir=rtl] .radio_animated {
  margin: 0 8px 0 16px;
}
html[dir=rtl] .button.remove {
  left: -10px;
  right: unset;
}
html[dir=rtl] .code-box-copy__btn {
  left: 11px;
  right: unset;
}
html[dir=rtl] ul.nav-menus {
  border-bottom: none;
}
html[dir=rtl] ul.notification-dropdown.onhover-show-div li {
  text-align: right;
}
html[dir=rtl] .badge + .badge {
  margin-right: 5px;
  margin-left: unset;
}
html[dir=rtl] .offset-xl-3 {
  margin-right: 25%;
  margin-left: unset;
}
html[dir=rtl] .m-l-10 {
  margin-right: 10px !important;
  margin-left: unset !important;
}
html[dir=rtl] .m-r-20 {
  margin-left: 20px;
  margin-right: unset;
}
html[dir=rtl] .m-r-30 {
  margin-left: 30px;
  margin-right: unset;
}
html[dir=rtl] .m-r-5 {
  margin-left: 5px;
  margin-right: unset;
}
html[dir=rtl] .text-start {
  text-align: right !important;
}
html[dir=rtl] .m-r-10 {
  margin-left: 10px;
  margin-right: unset;
}
html[dir=rtl] .pe-3 {
  padding-left: 1rem !important;
  padding-right: unset !important;
}
html[dir=rtl] .p-r-0 {
  padding-left: 0;
  padding-right: 15px;
}
html[dir=rtl] .m-l-20 {
  margin-right: 20px !important;
  margin-left: unset !important;
}
html[dir=rtl] .ps-3 {
  padding-right: 1rem !important;
}
html[dir=rtl] .b-r-light {
  border-left: 1px solid #f4f4f4 !important;
  border-right: unset !important;
}
html[dir=rtl] .float-end {
  float: left !important;
}
html[dir=rtl] .float-start {
  float: right !important;
}
html[dir=rtl] .text-end {
  text-align: left !important;
}
html[dir=rtl] .border-right {
  border-left: 1px solid #dee2e6 !important;
  border-right: unset !important;
}
html[dir=rtl] .pe-0 {
  padding-left: 0 !important;
  padding-right: 12px !important;
}
html[dir=rtl] .ps-0 {
  padding-right: 0 !important;
  padding-left: unset !important;
}
html[dir=rtl] .ms-1 {
  margin-left: unset !important;
  margin-right: 0.25rem !important;
}
html[dir=rtl] .owl-carousel {
  direction: ltr;
}
html[dir=rtl] .btn-group > .btn:not(:last-child):not(.dropdown-toggle),
html[dir=rtl] .btn-group > :not(:last-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
html[dir=rtl] .btn-group > .btn:not(:first-child) {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
html[dir=rtl] .btn-group > .btn:nth-child(2) {
  border-radius: 0 !important;
}
html[dir=rtl] .btn-group .btn-group > :not(:first-child) > .btn {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
html[dir=rtl] .btn-group .btn + .btn,
html[dir=rtl] .btn-group .btn + .btn-group {
  margin-right: -1px;
  border-right: none;
}
html[dir=rtl] .btn-group .btn-group + .btn,
html[dir=rtl] .btn-group .btn-group + .btn-group {
  margin-right: -1px;
}
html[dir=rtl] .btn-group .btn-group-vertical .btn + .btn,
html[dir=rtl] .btn-group .btn-group-vertical .btn + .btn-group {
  margin-right: -1px;
}
html[dir=rtl] .btn-group .btn-group-vertical .btn-group + .btn,
html[dir=rtl] .btn-group .btn-group-vertical .btn-group + .btn-group {
  margin-right: -1px;
}
html[dir=rtl] .me-3 {
  margin-right: unset !important;
  margin-left: 1rem !important;
}
html[dir=rtl] .me-5 {
  margin-left: 3rem !important;
  margin-right: unset !important;
}
html[dir=rtl] .ms-3 {
  margin-right: 1rem !important;
  margin-left: unset !important;
}
html[dir=rtl] .m-r-15 {
  margin-left: 15px;
  margin-right: unset;
}
html[dir=rtl] .b-l-light {
  border-right: 1px solid #f4f4f4 !important;
  border-left: unset !important;
}
html[dir=rtl] .p-l-0 {
  padding-left: unset;
  padding-right: 0px;
}
html[dir=rtl] .ps-4 {
  padding-right: 1.5rem !important;
  padding-left: unset !important;
}
html[dir=rtl] .me-2 {
  margin-left: 0.5rem !important;
  margin-right: unset !important;
}
html[dir=rtl] .ms-2 {
  margin-right: 0.5rem !important;
  margin-left: unset !important;
}
html[dir=rtl] .pe-2 {
  padding-right: unset !important;
  padding-left: 0.5rem !important;
}
html[dir=rtl] .prooduct-details-box .media-body {
  margin-right: 0 !important;
}
html[dir=rtl] .alert {
  text-align: right;
}
html[dir=rtl] .pull-right {
  float: left;
}
html[dir=rtl] .form-inline .form-group {
  margin-left: 15px;
  margin-right: 0;
}
html[dir=rtl] .card {
  text-align: right;
}
html[dir=rtl] .card.social-profile {
  text-align: center;
}
html[dir=rtl] .card .card-header h5:not(.mb-0), html[dir=rtl] .card .card-header .h5:not(.mb-0) {
  float: right;
}
html[dir=rtl] .card .card-header span {
  clear: both;
}
html[dir=rtl] .card .card-header .card-header-right {
  left: 35px;
  right: unset;
}
html[dir=rtl] .card .card-header .card-header-right .card-option {
  text-align: left;
}
html[dir=rtl] .card .card-header .card-header-right .card-option.list-unstyled {
  padding-right: 0;
  padding-left: unset;
}
html[dir=rtl] .card .card-header .pull-left {
  float: right;
}
html[dir=rtl] .card.full-card {
  left: 0;
  right: unset;
}
html[dir=rtl] .card .card-body .alert svg {
  margin-left: 4px;
  margin-right: unset;
}
html[dir=rtl] .card .card-body .value-left {
  margin-left: 30px;
  margin-right: unset;
}
html[dir=rtl] .card .card-body .square {
  margin-left: 5px;
  margin-right: unset;
}
html[dir=rtl] .balance-box {
  text-align: center;
}
html[dir=rtl] .purchase-card {
  text-align: center;
}
html[dir=rtl] .modal-header .btn-close {
  margin: -0.5rem auto -0.5rem -0.5rem;
}
html[dir=rtl] .modal-footer > :not(:first-child) {
  margin-right: 0.5rem;
  margin-left: 0;
}
html[dir=rtl] .form-inline .form-group .col-form-label {
  margin-left: 5px;
  margin-right: 0;
}
html[dir=rtl] .breadcrumb-item + .breadcrumb-item {
  padding-right: 0.5rem;
  padding-left: unset;
}
html[dir=rtl] .breadcrumb-item + .breadcrumb-item::before {
  padding-left: 0.5rem;
  padding-right: unset;
  float: right;
}
html[dir=rtl] code[class*=language-],
html[dir=rtl] pre[class*=language-] {
  text-align: right;
}
html[dir=rtl] .input-group-prepend {
  margin-left: -1px;
  margin-right: unset;
}
html[dir=rtl] .input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu),
html[dir=rtl] .input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3) {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
html[dir=rtl] .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: unset;
  margin-right: -1px;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
html[dir=rtl] .was-validated .form-control:invalid,
html[dir=rtl] .form-control.is-invalid,
html[dir=rtl] .was-validated .form-control:valid,
html[dir=rtl] .form-control.is-valid {
  background-position: left calc(0.375em + 0.1875rem) center;
  padding-left: calc(1.5em + 0.75rem);
  padding-right: 12px;
}
html[dir=rtl] .input-group > .form-control:not(:last-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
html[dir=rtl] .input-group > .input-group-prepend > .btn,
html[dir=rtl] .input-group > .input-group-prepend > .input-group-text,
html[dir=rtl] .input-group > .input-group-append:not(:last-child) > .btn,
html[dir=rtl] .input-group > .input-group-append:not(:last-child) > .input-group-text,
html[dir=rtl] .input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),
html[dir=rtl] .input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
html[dir=rtl] .input-group > .input-group-append > .btn,
html[dir=rtl] .input-group > .input-group-append > .input-group-text,
html[dir=rtl] .input-group > .input-group-prepend:not(:first-child) > .btn,
html[dir=rtl] .input-group > .input-group-prepend:not(:first-child) > .input-group-text,
html[dir=rtl] .input-group > .input-group-prepend:first-child > .btn:not(:first-child),
html[dir=rtl] .input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
html[dir=rtl] .border-tab.nav-left .nav-link {
  text-align: left;
}
html[dir=rtl] .socialprofile .social-group ul li:nth-child(4) {
  margin-right: -22px;
}
html[dir=rtl] .social-status form .form-group .form-control-social {
  padding-right: 15px;
  padding-left: unset;
}
html[dir=rtl] .social-status .media .social-status {
  right: 35px;
  left: unset;
}
html[dir=rtl] .social-chat .other-msg {
  margin-right: 40px;
  margin-left: unset;
}
html[dir=rtl] .social-chat .media-body:before {
  left: 100%;
  right: unset;
  border-left: 7px solid var(-semi-dark);
  border-right: unset;
}
html[dir=rtl] .social-chat .media-body:after {
  left: 100%;
  right: unset;
  border-left: 7px solid #fff;
  border-right: unset;
}
html[dir=rtl] .timeline-content .comment-number i {
  margin-left: 20px;
  margin-right: unset;
}
html[dir=rtl] .vertical-timeline.vertical-timeline--one-column-left::before {
  left: unset;
  right: 18px;
}
html[dir=rtl] .vertical-timeline.vertical-timeline--one-column-left .vertical-timeline-element-icon {
  right: 0;
  left: unset;
}
html[dir=rtl] .vertical-timeline.vertical-timeline--one-column-left .vertical-timeline-element-icon svg {
  right: 50%;
  left: unset;
  margin-left: unset;
  margin-right: -12px;
}
html[dir=rtl] .vertical-timeline.vertical-timeline--one-column-left .vertical-timeline-element-content {
  margin-right: 60px;
  margin-left: unset;
}
html[dir=rtl] .vertical-timeline.vertical-timeline--one-column-left .vertical-timeline-element-content .vertical-timeline-element-date {
  float: right;
}
html[dir=rtl] .vertical-timeline.vertical-timeline--one-column-left .vertical-timeline-element-content .vertical-timeline-element-content-arrow {
  border-left: 7px solid #f4f4f4;
  border-right: unset;
  left: 100%;
  right: unset;
}
html[dir=rtl] .vertical-timeline.vertical-timeline--two-columns .vertical-timeline-element-content .vertical-timeline-element-content-arrow {
  border-left: 7px solid #f4f4f4;
  border-right: unset;
}
html[dir=rtl] .vertical-timeline.vertical-timeline--two-columns .vertical-timeline-element-icon svg {
  right: 50%;
  left: unset;
  margin-left: unset;
  margin-right: -12px;
}
html[dir=rtl] .vertical-timeline--two-columns .vertical-timeline-element-content .vertical-timeline-element-date {
  right: 124%;
  left: unset;
}
html[dir=rtl] .vertical-timeline--two-columns .vertical-timeline-element.vertical-timeline-element--right .vertical-timeline-element-content .vertical-timeline-element-date {
  right: auto;
  left: 124%;
  text-align: left;
}
html[dir=rtl] .vertical-timeline--two-columns .vertical-timeline-element:nth-child(even):not(.vertical-timeline-element--left) .vertical-timeline-element-content .vertical-timeline-element-date {
  right: auto;
  left: 124%;
  text-align: left;
}
html[dir=rtl] .vertical-timeline--two-columns .vertical-timeline-element.vertical-timeline-element--right .vertical-timeline-element-content {
  float: left;
}
html[dir=rtl] .vertical-timeline--two-columns .vertical-timeline-element:nth-child(even):not(.vertical-timeline-element--left) .vertical-timeline-element-content {
  float: left;
}
@media only screen and (max-width: 1170px) {
  html[dir=rtl] .vertical-timeline::before {
    left: unset;
    right: 18px;
  }
  html[dir=rtl] .vertical-timeline .vertical-timeline-element-icon {
    right: 0;
    left: unset;
  }
  html[dir=rtl] .vertical-timeline .vertical-timeline-element-icon svg {
    right: 50%;
    left: unset;
    margin-left: unset;
    margin-right: -12px;
  }
  html[dir=rtl] .vertical-timeline .vertical-timeline-element-content {
    margin-right: 60px;
    margin-left: unset;
  }
  html[dir=rtl] .vertical-timeline .vertical-timeline-element-content .vertical-timeline-element-date {
    float: right;
  }
  html[dir=rtl] .vertical-timeline .vertical-timeline-element-content .vertical-timeline-element-content-arrow {
    border-left: 7px solid #f4f4f4;
    border-right: unset;
    left: 100%;
    right: unset;
  }
}
html[dir=rtl] .vertical-timeline.vertical-timeline--one-column-left .vertical-timeline-element-content .vertical-timeline-element-content-arrow {
  border-left: 7px solid #1d1e26 !important;
  border-right: unset !important;
}
html[dir=rtl] .photos ul li {
  margin-right: unset;
  margin-left: 10px;
}
html[dir=rtl] .avatar-showcase .friend-pic {
  margin-left: 8px;
  margin-right: unset;
}
html[dir=rtl] .avatar-showcase .pepole-knows ul li {
  margin-left: 21px;
  margin-right: unset;
}
html[dir=rtl] .avatar-showcase .pepole-knows ul li:last-child {
  margin-left: 0;
}
html[dir=rtl] .user-profile .hovercard .user-image .share-icons {
  left: 100px;
  right: unset;
}
html[dir=rtl] .user-profile .hovercard .user-image .share-icons li {
  margin-left: 10px;
  margin-right: unset;
}
html[dir=rtl] .user-profile .hovercard .user-image .share-icons li:last-child {
  margin-left: 0;
}
html[dir=rtl] .faq-form .search-icon {
  left: 12px;
  right: unset;
}
html[dir=rtl] .faq-widgets .media-body p {
  padding-left: 20px;
  padding-right: unset;
}
html[dir=rtl] .header-faq,
html[dir=rtl] .faq-title {
  text-align: right;
}
html[dir=rtl] .faq-accordion.default-according .card .faq-header svg {
  left: 30px;
  right: unset;
}
html[dir=rtl] .faq-accordion.default-according .card .btn-link svg {
  margin-left: 10px;
  margin-right: unset;
}
html[dir=rtl] .navigation-option ul li {
  padding: 8px 0 8px 8px;
}
html[dir=rtl] .navigation-option ul li a {
  padding-right: 40px;
  padding-left: unset;
}
html[dir=rtl] .navigation-option ul li a svg {
  right: 15px;
  left: unset;
}
html[dir=rtl] .updates-faq {
  margin-right: unset;
  margin-left: 20px;
}
html[dir=rtl] .browse .browse-articles span svg {
  margin-left: 10px;
  margin-right: unset;
}
html[dir=rtl] .categories .learning-header {
  padding-right: 15px;
  padding-left: unset;
}
html[dir=rtl] .main .langChoice {
  left: 30px;
  right: unset;
}
html[dir=rtl] .pricing-block svg {
  direction: ltr;
}
html[dir=rtl] p.data-attributes svg {
  margin-left: 10px;
  margin-right: unset;
}
html[dir=rtl] .avatars .avatar {
  margin-left: 10px;
  margin-right: unset;
}
html[dir=rtl] .avatars .avatar:last-child {
  margin-left: 0;
}
html[dir=rtl] .avatars .avatar .status {
  left: 4px;
  right: unset;
}
html[dir=rtl] .customers.avatar-group {
  margin-left: 30px;
  margin-right: unset;
}
html[dir=rtl] .card .card-header h5, html[dir=rtl] .card .card-header .h5 {
  float: none !important;
}
html[dir=rtl] .knob-chart .chart-clock-main .clock-small {
  right: 10px;
  left: unset;
}
html[dir=rtl] .todo .todo-list-wrapper .mark-all-tasks .btn-label {
  margin-left: 5px;
  margin-right: unset;
}
html[dir=rtl] .todo .todo-list-wrapper .mark-all-tasks {
  left: 30px;
  right: unset;
}
html[dir=rtl] .todo .todo-list-wrapper #todo-list li .task-container .task-action-btn {
  text-align: left;
}
html[dir=rtl] .todo .notification-popup {
  left: 10px;
  right: unset;
}
html[dir=rtl] .todo-options .badges-todo h6, html[dir=rtl] .todo-options .badges-todo .h6 {
  margin-left: 10px;
  margin-right: unset;
}
html[dir=rtl] .todo-options .badges-todo h6:last-child, html[dir=rtl] .todo-options .badges-todo .h6:last-child {
  margin-left: 0;
}
html[dir=rtl] .todo-list-btns .dropdown-basic .btn-group .form-group .checkbox {
  padding-right: 14px;
  border-top-right-radius: 25px;
  border-bottom-right-radius: 25px;
  padding-left: unset;
  border-top-left-radius: unset;
  border-bottom-left-radius: unset;
}
html[dir=rtl] .todo-list-btns .dropdown-basic .separated-btn {
  margin-right: -6px;
  margin-left: unset;
}
html[dir=rtl] .todo-list-btns .dropdown-basic .separated-btn .btn {
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
}
html[dir=rtl] .search-todo .dropdown-basic .btn-group {
  margin-left: 18px;
  margin-right: unset;
}
html[dir=rtl] .sticky-note .note {
  float: right;
}
html[dir=rtl] .mega-menu .list-unstyled div a {
  padding: 8px 0 8px 35px;
}
html[dir=rtl] .mega-menu .list-unstyled div a:hover {
  padding: 8px 10px 8px 35px;
}
html[dir=rtl] #testimonial .owl-stage-outer .owl-stage .owl-item .slide--item .media .me-3 {
  margin-right: 1rem !important;
  margin-left: unset !important;
}
html[dir=rtl] .needs-validation .input-group > .form-control:not(:last-child),
html[dir=rtl] .needs-validation .input-group > .custom-select:not(:last-child),
html[dir=rtl] .form-row .input-group > .form-control:not(:last-child),
html[dir=rtl] .form-row .input-group > .custom-select:not(:last-child) {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
html[dir=rtl] .form-check {
  padding-right: 1.25rem;
  padding-left: unset;
}
html[dir=rtl] .form-check .form-check-input {
  float: right;
  margin-left: unset;
  margin-right: -1.5em;
}
html[dir=rtl] .mega-menu .default-according .card .btn-link {
  text-align: right;
}
html[dir=rtl] .mega-menu .default-according.style-1 button[aria-expanded=true]:before,
html[dir=rtl] .mega-menu .default-according.style-1 button[aria-expanded=false]:before {
  right: unset;
  left: 20px;
}
html[dir=rtl] .email-wrap .row .col-xl-6 {
  padding-right: 0;
  padding-left: 15px;
}
html[dir=rtl] .email-wrap .row .col-xl-3 + .col-xl-3 {
  padding-left: 0;
  padding-right: 15px;
}
html[dir=rtl] .email-wrap .email-app-sidebar .main-menu > li {
  text-align: right;
}
html[dir=rtl] .email-wrap .email-app-sidebar .main-menu > li a i {
  margin-right: unset;
  margin-left: 10px;
}
html[dir=rtl] .email-wrap .email-app-sidebar ul {
  padding-right: 0;
}
html[dir=rtl] .email-wrap .email-content .email-top .user-emailid:after {
  float: left;
}
html[dir=rtl] .email-wrap .email-right-aside .email-body .pe-0 {
  padding-right: unset !important;
}
html[dir=rtl] .email-wrap .email-right-aside .radius-left {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-radius: 4px;
}
html[dir=rtl] #renderRange {
  float: left;
  padding-left: unset;
  padding-right: 12px;
}
html[dir=rtl] .event-calendar {
  direction: ltr;
}
html[dir=rtl] .calendar-wrap .fc {
  direction: rtl;
  text-align: right;
}
html[dir=rtl] .calendar-wrap .fc .fc-toolbar .fc-left {
  float: right;
}
html[dir=rtl] .calendar-wrap .fc .fc-toolbar .fc-right {
  float: left;
}
html[dir=rtl] .calendar-wrap .fc .fc-toolbar > * > * {
  margin-left: 0;
}
html[dir=rtl] .calendar-wrap .fc-events-container {
  text-align: right;
}
html[dir=rtl] .calendar-wrap .fc-scroller {
  margin-right: unset;
  margin-left: -17px;
}
html[dir=rtl] .fc-agenda-view .fc-day-grid .fc-row {
  margin-right: 0 !important;
}
html[dir=rtl] .fc-unthemed .fc-row {
  margin-right: 0 !important;
}
html[dir=rtl] .btn-group-showcase .btn-group {
  margin-left: 20px;
  margin-right: unset;
}
html[dir=rtl] .btn-showcase .btn {
  margin-right: unset;
  margin-left: 10px;
}
html[dir=rtl] .btn-square.dropdown-toggle {
  border-top-left-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
html[dir=rtl].button-builder ul.the-icons li {
  float: right;
}
html[dir=rtl].button-builder .color-slelector {
  float: right;
}
html[dir=rtl].button-builder .custom-button-color .form-control {
  border-radius: 0 5px 5px 0;
}
html[dir=rtl].button-builder .custom-button-color .form-control.pull-left {
  float: right;
}
html[dir=rtl].button-builder .hint-label {
  float: right;
  padding: 4px 20px 0 0;
}
html[dir=rtl] #customer-review .owl-item img {
  order: 2;
}
html[dir=rtl] .options > div {
  margin: 0 0 8px 8px;
}
html[dir=rtl] .modal-dialog .modal-content .modal-body p a {
  margin-left: 0;
}
html[dir=rtl] .drag-box fieldset .component .form-group .text-lg-left {
  text-align: right !important;
}
html[dir=rtl] .drag-box fieldset .component .form-group .input-group .input-group-prepend .btn,
html[dir=rtl] .drag-box fieldset .component .form-group .input-group .input-group-prepend .input-group-text {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
html[dir=rtl] .drag-box fieldset .component .form-group .input-group .input-group-prepend .btn-right,
html[dir=rtl] .drag-box fieldset .component .form-group .input-group .input-group-prepend .checkbox-radius {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
html[dir=rtl] .drag-box fieldset .component .form-group .input-group #prependedcheckbox {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
html[dir=rtl] .drag-box fieldset .component .form-group .input-group #appendedcheckbox {
  border-right-color: #efefef;
}
html[dir=rtl] .drag-box fieldset .component .form-group .input-group #buttondropdown {
  margin-right: unset;
  margin-left: -1px;
}
html[dir=rtl] .drag form {
  text-align: right;
}
html[dir=rtl] .drag form input {
  text-align: right;
}
html[dir=rtl] .drag form label {
  text-align: right !important;
}
html[dir=rtl] .drag form .form-group .input-group .input-group-prepend .btn,
html[dir=rtl] .drag form .form-group .input-group .input-group-prepend .input-group-text {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
html[dir=rtl] .drag form .form-group .input-group .input-group-prepend .btn-right,
html[dir=rtl] .drag form .form-group .input-group .input-group-prepend .checkbox-radius {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
html[dir=rtl] .drag form .form-group .input-group #buttondropdown {
  margin-right: unset;
  margin-left: -1px;
}
html[dir=rtl] .draggable label {
  text-align: right;
}
html[dir=rtl] .form-builder-column .tab-content .tab-pane .theme-form .ui-draggable .input-group > .input-group-prepend > .input-group-text {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
html[dir=rtl] .form-builder-column #pills-tabContent .theme-form .form-group .input-group #buttondropdown,
html[dir=rtl] .form-builder-column #pills-tabContent .theme-form .ui-draggable .input-group #buttondropdown {
  margin-right: unset;
  margin-left: 15px;
}
html[dir=rtl] .form-builder-column #pills-tabContent .theme-form .form-group .input-group .input-group-btn button,
html[dir=rtl] .form-builder-column #pills-tabContent .theme-form .ui-draggable .input-group .input-group-btn button {
  border-radius: 4px !important;
}
html[dir=rtl] .form-horizontal.theme-form fieldset .tab-content .tab-pane .component .form-group .text-lg-left {
  text-align: right !important;
}
html[dir=rtl] .form-horizontal.theme-form fieldset .tab-content .tab-pane .component .form-group .input-group .input-group-prepend .btn,
html[dir=rtl] .form-horizontal.theme-form fieldset .tab-content .tab-pane .component .form-group .input-group .input-group-prepend .input-group-text {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
html[dir=rtl] .form-horizontal.theme-form fieldset .tab-content .tab-pane .component .form-group .input-group .input-group-prepend .btn-right,
html[dir=rtl] .form-horizontal.theme-form fieldset .tab-content .tab-pane .component .form-group .input-group .input-group-prepend .checkbox-radius {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
html[dir=rtl] .form-horizontal.theme-form fieldset .tab-content .tab-pane .component .form-group .input-group #prependedcheckbox {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
html[dir=rtl] .form-horizontal.theme-form fieldset .tab-content .tab-pane .component .form-group .input-group #appendedcheckbox {
  border-right-color: #efefef;
}
html[dir=rtl] .form-builder .component .form-group .input-group #buttondropdown {
  margin-right: unset;
  margin-left: -1px;
}
html[dir=rtl] .form-builder .component .form-group .pl-md-radios {
  padding-right: 37px;
  padding-left: unset;
}
html[dir=rtl] .page-wrapper .page-body-wrapper .logo-wrapper {
  box-shadow: 9px 0 20px rgba(89, 102, 122, 0.1) !important;
}
html[dir=rtl] .page-wrapper .page-body-wrapper .logo-wrapper a {
  transform: translate(-64px);
}
html[dir=rtl] .search-page .nav i {
  margin-left: 10px;
  margin-right: unset;
}
html[dir=rtl] .product-stts {
  display: inline-block;
}
html[dir=rtl] .product-stts .ms-1 {
  margin-right: 0.25rem !important;
  margin-left: unset !important;
}
html[dir=rtl] .search-form input {
  padding: 10px 70px 10px 10px;
  text-align: right;
}
html[dir=rtl] .icon-hover-bottom .icon-title {
  text-align: right;
}
html[dir=rtl] .icon-lists div i {
  margin: 0 10px 0 15px;
}
html[dir=rtl] .icon-lists ul {
  padding-right: 0;
}
html[dir=rtl] ul.icon-lists {
  padding-right: 30px;
}
html[dir=rtl] .floated-customizer-btn.third-floated-btn {
  left: 35px;
  right: unset;
}
html[dir=rtl] .floated-customizer-btn > span {
  margin-right: 10px;
}
html[dir=rtl] .floated-customizer-panel {
  text-align: right;
  left: -85px;
  right: unset;
}
html[dir=rtl] .floated-customizer-panel.active {
  left: 35px;
  right: unset;
}
html[dir=rtl] .floated-customizer-panel .close-customizer-btn {
  left: 30px;
  right: unset;
}
html[dir=rtl] .floated-customizer-panel ul {
  padding-right: 0;
}
html[dir=rtl] .form-builder-2-header > div nav {
  float: left;
}
html[dir=rtl] .radio label {
  padding-left: 0;
  padding-right: 15px;
}
html[dir=rtl] .radio label::before {
  right: 0;
  margin-right: -20px;
  left: unset;
}
html[dir=rtl] .page-wrapper .page-body-wrapper .page-title .row h3, html[dir=rtl] .page-wrapper .page-body-wrapper .page-title .row .h3 {
  text-align: right;
  padding-left: 20px;
  padding-right: unset !important;
}
html[dir=rtl] .page-wrapper .page-body-wrapper .page-title .row h6, html[dir=rtl] .page-wrapper .page-body-wrapper .page-title .row .h6 {
  text-align: right;
}
html[dir=rtl] .page-wrapper.compact-wrapper .page-header {
  margin-right: 265px;
  margin-left: unset;
  width: calc(100% - 265px);
}
html[dir=rtl] .page-wrapper.compact-wrapper .page-header.close_icon {
  margin-right: 100px;
  margin-left: unset;
  width: calc(100% - 100px);
}
html[dir=rtl] .page-wrapper.modern-type .page-header {
  margin-right: 0;
  width: calc(100% - 0px);
}
html[dir=rtl] .page-wrapper.modern-type .page-header.close_icon {
  margin-right: 0;
  width: calc(100% - 0px);
}
html[dir=rtl] .page-wrapper.modern-type .page-header .header-wrapper .logo-wrapper {
  margin-right: unset;
  margin-left: 30px;
}
html[dir=rtl] .page-wrapper.modern-type .page-header .header-wrapper .toggle-sidebar {
  margin-right: unset;
  margin-left: 15px;
}
html[dir=rtl] .page-wrapper.modern-type .page-body-wrapper .page-body {
  margin-right: 310px;
}
html[dir=rtl] .page-wrapper.modern-type .page-body-wrapper .footer {
  margin-left: 55px;
  margin-right: 360px;
}
html[dir=rtl] .page-wrapper.modern-type .page-body-wrapper div.sidebar-wrapper.close_icon ~ .page-body {
  margin-right: 0px;
}
html[dir=rtl] .page-wrapper.modern-type .page-body-wrapper div.sidebar-wrapper.close_icon ~ footer {
  margin-right: 0;
}
html[dir=rtl] .page-header .header-wrapper .nav-right {
  text-align: right;
}
html[dir=rtl] .page-header .header-wrapper .nav-right .onhover-show-div {
  right: unset;
  left: 0;
}
@media (max-width: 575.98px) {
  html[dir=rtl] .page-header .header-wrapper .nav-right .onhover-show-div {
    left: 12px;
  }
}
@media (max-width: 575.98px) {
  html[dir=rtl] .page-header .header-wrapper .nav-right .cart-dropdown li {
    padding: 10px;
  }
}
html[dir=rtl] .page-header .header-wrapper .nav-right .cart-dropdown .close-circle {
  right: unset;
  left: 0;
}
html[dir=rtl] .page-header .header-wrapper .nav-right > ul > li .lang-txt {
  margin-left: 0;
  margin-right: 8px;
}
html[dir=rtl] .page-header .header-wrapper .nav-right > ul > li:before {
  right: 0;
  left: unset;
}
html[dir=rtl] .page-header .header-wrapper .nav-right > ul > li .dot {
  left: 17px;
  right: unset;
}
html[dir=rtl] .page-header .header-wrapper .nav-right > ul > li.onhover-dropdown:hover .onhover-show-div:before {
  right: 10px;
  left: unset;
}
html[dir=rtl] .page-header .header-wrapper .nav-right > ul > li.onhover-dropdown:hover .onhover-show-div:after {
  right: 10px;
  left: unset;
}
html[dir=rtl] .page-header .header-wrapper .nav-right > ul > li.onhover-dropdown:last-child {
  padding-left: 0;
  padding-right: 0 !important;
}
html[dir=rtl] .page-header .header-wrapper .nav-right > ul > li:last-child {
  padding-right: 20px;
  padding-left: 0;
}
html[dir=rtl] .page-header .header-wrapper .nav-right > ul > li {
  text-align: right;
}
html[dir=rtl] .page-header .header-wrapper .nav-right > ul > li i.ms-2 {
  margin-right: 0.5rem !important;
  margin-left: unset !important;
}
html[dir=rtl] .page-header .header-wrapper .nav-right .profile-dropdown li svg {
  margin-right: unset;
  margin-left: 10px;
}
html[dir=rtl] .page-header .header-wrapper .mobile-sidebar {
  padding-left: 20px;
  padding-right: unset;
}
html[dir=rtl] .page-header.open {
  margin-right: 0;
}
html[dir=rtl] ul.notification-dropdown.onhover-show-div {
  right: initial;
  left: -30px;
  padding: 0;
}
html[dir=rtl] ul.notification-dropdown.onhover-show-div:before {
  right: inherit !important;
  left: 35px !important;
}
html[dir=rtl] ul.notification-dropdown.onhover-show-div:after {
  right: inherit !important;
  left: 35px !important;
}
html[dir=rtl] ul.notification-dropdown.onhover-show-div li {
  margin-right: 0 !important;
}
html[dir=rtl] ul.notification-dropdown.onhover-show-div li span.badge {
  margin-left: unset !important;
}
html[dir=rtl] ul.notification-dropdown.onhover-show-div li span svg {
  margin-right: unset;
  margin-left: 10px;
}
html[dir=rtl] ul.notification-dropdown.onhover-show-div li .notification-icon {
  margin-left: 20px;
  margin-right: unset;
}
html[dir=rtl] .card-body .alert svg ~ p {
  padding-left: unset;
  padding-right: 20px;
}
html[dir=rtl] .alert i {
  margin-left: 5px;
  margin-right: 0;
}
html[dir=rtl] .inverse {
  padding: 13px 65px 13px 20px;
}
html[dir=rtl] .inverse i {
  left: unset;
  right: 0;
}
html[dir=rtl] .alert-primary.inverse:before {
  border-right: 7px solid #7366ff;
  right: 54px;
  left: unset;
  border-left: unset;
}
html[dir=rtl] .alert-secondary.inverse:before {
  border-right: 7px solid #ff3364;
  right: 54px;
  left: unset;
  border-left: unset;
}
html[dir=rtl] .alert-success.inverse:before {
  border-right: 7px solid #54ba4a;
  right: 54px;
  left: unset;
  border-left: unset;
}
html[dir=rtl] .alert-danger.inverse:before {
  border-right: 7px solid #fc4438;
  right: 54px;
  left: unset;
  border-left: unset;
}
html[dir=rtl] .alert-warning.inverse:before {
  border-right: 7px solid #ffaa05;
  right: 54px;
  left: unset;
  border-left: unset;
}
html[dir=rtl] .alert-info.inverse:before {
  border-right: 7px solid #16c7f9;
  right: 54px;
  left: unset;
  border-left: unset;
}
html[dir=rtl] .alert-light.inverse:before {
  border-right: 7px solid #f4f4f4;
  right: 54px;
  left: unset;
  border-left: unset;
}
html[dir=rtl] .alert-dark.inverse:before {
  border-right: 7px solid #2c323f;
  right: 54px;
  left: unset;
  border-left: unset;
}
html[dir=rtl] .alert-dismissible .btn-close {
  left: 0;
  right: unset;
}
html[dir=rtl] .alert-dismissible .btn-close span {
  padding-left: 0;
  padding-right: unset;
}
html[dir=rtl] .icofont.icofont-truck {
  display: inline-block;
}
html[dir=rtl] .blog-box .blog-details {
  padding-left: 20px;
  text-align: right;
}
html[dir=rtl] .blog-box .blog-details .blog-social {
  padding-right: 0;
}
html[dir=rtl] .blog-box .blog-details .blog-social li {
  padding-left: 40px;
  padding-right: unset;
}
html[dir=rtl] .blog-box .blog-details .blog-social li:first-child {
  border-left: 1px solid #777777;
  border-right: unset;
  padding-left: 40px;
  padding-right: unset;
}
html[dir=rtl] .blog-box .blog-details .blog-social li + li {
  margin-right: 30px;
  margin-left: unset;
  padding-left: 0;
}
html[dir=rtl] .blog-box .blog-details-main .blog-social li {
  border-left: 1px dotted;
  border-right: unset;
}
html[dir=rtl] .blog-box .blog-details-main .blog-social li:last-child {
  border-left: none;
}
html[dir=rtl] .blog-box .blog-date span {
  font-size: 36px;
  font-weight: 500;
  padding-left: 5px;
}
html[dir=rtl] .comment-box .media img {
  margin-left: 45px;
  margin-right: unset;
}
html[dir=rtl] .comment-box .media h6, html[dir=rtl] .comment-box .media .h6 {
  text-align: right;
}
html[dir=rtl] .comment-box ul ul {
  margin-right: 135px;
  margin-left: unset;
  padding-right: 0;
}
@media (max-width: 575.98px) {
  html[dir=rtl] .comment-box ul ul {
    margin-right: 30px;
  }
}
html[dir=rtl] .comment-box .comment-social {
  text-align: left;
}
html[dir=rtl] .comment-box .comment-social li {
  padding-left: 0;
  padding-right: 20px;
}
html[dir=rtl] .comment-box .comment-social li:first-child {
  border-left: 1px solid #efefef;
  border-right: unset;
  padding-right: 0;
  padding-left: 20px;
}
html[dir=rtl] .button-builder-wrap .form-group .btn {
  margin-left: 15px;
  margin-right: 0;
  padding: 9px;
}
html[dir=rtl] .button-builder ul.the-icons {
  padding-right: 0 !important;
}
html[dir=rtl] .call-chat-body .chat-box .chat-right-aside .chat .chat-history .caller-img.ps-0 {
  padding-left: 15px !important;
}
html[dir=rtl] .chat-box .user-image {
  float: right;
  margin-left: 5px;
  margin-right: 0;
}
html[dir=rtl] .chat-box .people-list .search i {
  left: 10px;
  right: unset;
}
html[dir=rtl] .chat-box .about {
  float: right;
  padding-right: 10px;
  padding-left: unset;
  text-align: right;
}
html[dir=rtl] .chat-box .chat-menu {
  border-right: 1px solid #f4f4f4;
  border-left: unset;
}
html[dir=rtl] .chat-box .chat-menu .nav {
  padding-right: 0;
}
html[dir=rtl] .chat-box .chat-menu.ps-0 {
  padding-left: 15px !important;
}
html[dir=rtl] .chat-box .chat-right-aside .chat .chat-message .smiley-box {
  margin-left: 0.5rem;
  margin-right: unset;
}
html[dir=rtl] .chat-box .chat-right-aside .chat .chat-message .text-box .btn {
  border-radius: 5px 0 0 5px;
}
html[dir=rtl] .chat-box .chat-right-aside.pe-0 {
  padding-right: 15px !important;
}
html[dir=rtl] .chat-box .chat .chat-message .text-box .input-group-append {
  margin-right: -2px;
}
html[dir=rtl] .chat-msg-box ul {
  padding-right: 0;
}
html[dir=rtl] .chat-left-aside .status-circle {
  left: unset;
  right: 40px;
}
html[dir=rtl] .chat-right-aside .chat .chat-header .chat-menu-icons {
  padding-left: 0;
  padding-right: unset;
}
html[dir=rtl] .chat-right-aside .chat .chat-header .chat-menu-icons.float-sm-right {
  float: left !important;
}
html[dir=rtl] .chat-right-aside .chat .chat-header img {
  float: right;
}
html[dir=rtl] .cke_toolbar,
html[dir=rtl] .cke_toolgroup,
html[dir=rtl] a.cke_button,
html[dir=rtl] .cke_combo_text {
  float: right;
}
html[dir=rtl] .cke_reset_all,
html[dir=rtl] .cke_reset_all *,
html[dir=rtl] .cke_reset_all a,
html[dir=rtl] .cke_reset_all textarea {
  text-align: right;
}
html[dir=rtl] .cke_combo_text {
  padding-left: unset;
  padding-right: 10px;
}
html[dir=rtl] #editor1 #cke_editor1 #cke_1_contents iframe html {
  direction: rtl !important;
}
html[dir=rtl] #clockdiv ul {
  padding-right: 0;
}
html[dir=rtl] .custom-card .card-footer > div + div {
  border-right: 1px solid #efefef;
  border-left: unset !important;
}
html[dir=rtl] .card-social {
  padding-right: 0;
}
html[dir=rtl] .card-absolute .card-header {
  right: 15px;
  left: unset;
}
html[dir=rtl] .dataTables_wrapper .dataTables_filter input[type=search] {
  margin-right: 10px;
  margin-left: 0;
}
html[dir=rtl] .dataTables_wrapper .dataTables_length {
  float: right;
}
html[dir=rtl] .dataTables_wrapper .dataTables_filter {
  margin-left: unset;
  margin-right: 15px;
  float: left;
}
html[dir=rtl] .dataTables_wrapper .dataTables_info {
  float: right;
}
html[dir=rtl] .dataTables_wrapper .advance-5_filter {
  margin-left: 0;
}
html[dir=rtl] .dataTables_wrapper .btn-group button {
  margin-left: 5px;
  margin-right: unset;
}
html[dir=rtl] .dataTables_wrapper .btn-group button:last-child {
  margin-left: 0;
}
html[dir=rtl] .dataTables_wrapper table.dataTable tbody td.select-checkbox:after,
html[dir=rtl] .dataTables_wrapper table.dataTable tbody th.select-checkbox:after {
  margin-left: 31px;
}
html[dir=rtl] div.dataTables_wrapper div.dataTables_paginate {
  margin-right: 15px !important;
  margin-left: 0 !important;
  float: left;
}
html[dir=rtl] table.dataTable thead > tr > th {
  padding-left: 30px;
  padding-right: 12px;
}
html[dir=rtl] table.dataTable thead > tr > th:before {
  left: 1em !important;
  right: unset;
}
html[dir=rtl] table.dataTable thead > tr > th:after {
  left: 0.5em !important;
  right: unset;
}
html[dir=rtl] table.dataTable thead .sorting:before,
html[dir=rtl] table.dataTable thead .sorting_asc:before,
html[dir=rtl] table.dataTable thead .sorting_desc:before,
html[dir=rtl] table.dataTable thead .sorting_asc_disabled:before,
html[dir=rtl] table.dataTable thead .sorting_desc_disabled:before {
  left: 1em !important;
  right: unset;
}
html[dir=rtl] .dataTables_scrollHeadInner {
  padding-right: unset !important;
  padding-left: 0 !important;
}
html[dir=rtl] div.table-responsive > div.dataTables_wrapper > div.row > div[class^=col-]:first-child {
  padding-right: 0;
  padding-left: 0;
}
html[dir=rtl] div.table-responsive > div.dataTables_wrapper > div.row > div[class^=col-]:last-child {
  padding-right: 0;
  padding-left: 0;
}
html[dir=rtl] .dt-plugin-buttons button.m-r-10 {
  margin-left: 10px;
  margin-right: 0;
}
html[dir=rtl] .datetime-picker .theme-form .form-group label {
  text-align: left !important;
}
html[dir=rtl] .datetime-picker .theme-form .form-group .input-group-text {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
html[dir=rtl] .datetime-picker .theme-form .form-group .input-group .form-control {
  border-radius: 0.25rem;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
html[dir=rtl] .dropdown-basic .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}
html[dir=rtl] .dropdown-basic .separated-btn .btn {
  border-radius: 0.25rem;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
html[dir=rtl] .dropdown-basic .btn-group {
  margin-right: unset;
  margin-left: 18px;
}
html[dir=rtl] .error-wrapper .col-md-8.offset-md-2 {
  margin: 0 auto !important;
}
html[dir=rtl] .product-price del {
  padding-left: 20px;
  padding-right: 0;
}
html[dir=rtl] .product-box .modal .modal-header .btn-close {
  right: unset;
  left: 15px;
}
html[dir=rtl] .product-box .ribbon-bookmark.ribbon-vertical-left.ribbon-info:before,
html[dir=rtl] .product-box .ribbon-bookmark.ribbon-vertical-right.ribbon-info:before {
  border-left-color: #007bff;
}
html[dir=rtl] .product-box .ribbon-bookmark.ribbon-vertical-left:before,
html[dir=rtl] .product-box .ribbon-bookmark.ribbon-vertical-right:before {
  right: 0;
  left: unset;
  border-left: 15px solid #2a3142;
}
html[dir=rtl] .product-box .ribbon-bookmark.ribbon-info:before {
  border-left-color: transparent;
}
html[dir=rtl] .product-box .ribbon-warning.ribbon-clip:before {
  border-left-color: #ff850d;
  border-right-color: unset;
}
html[dir=rtl] .product-box .ribbon-clip {
  right: -14px;
  left: unset;
}
html[dir=rtl] .product-box .ribbon-clip:before {
  right: 0;
  left: unset;
}
html[dir=rtl] .product-hover ul {
  padding-right: 0;
}
html[dir=rtl] .customer-review .media img {
  margin-left: 25px;
  margin-right: 0;
}
html[dir=rtl] .nav {
  padding-right: 0;
}
html[dir=rtl] .custom-tab {
  padding: 4px;
}
html[dir=rtl] .custom-file-label::after {
  left: 0;
  right: unset;
}
html[dir=rtl] .wizard-4 ul.anchor {
  float: right;
}
html[dir=rtl] .wizard-4 .step-container {
  clear: unset;
}
html[dir=rtl] .wizard-4 .form-group {
  text-align: right;
}
html[dir=rtl] .wizard-4 .action-bar .btn {
  float: left;
}
html[dir=rtl] .f1 .f1-buttons {
  text-align: left;
}
html[dir=rtl] .f1 .f1-steps .f1-step {
  float: right;
}
html[dir=rtl] .jstree-default .jstree-node {
  margin-left: unset;
  margin-right: 24px;
  background-position: -292px -4px;
  background-repeat: repeat-y;
}
html[dir=rtl] .img-cropper .btn-group {
  margin-right: 0;
  margin-left: 10px;
}
html[dir=rtl] .img-cropper .btn-group button:last-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
html[dir=rtl] .img-cropper .btn-group button:first-child {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
html[dir=rtl] .docs-toggles .btn-group .btn {
  border-radius: 0;
}
html[dir=rtl] .docs-toggles .btn-group .btn:last-child {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
html[dir=rtl] .docs-toggles .btn-group .btn:first-child {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
html[dir=rtl] .btn-group > .btn:not(:last-child):not(.dropdown-toggle) > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
html[dir=rtl] .jsgrid-button + .jsgrid-button {
  margin-right: 5px;
  margin-left: unset;
}
html[dir=rtl] .product-table .rdt_TableBody .rdt_TableRow .rdt_TableCell .product-name .order-process {
  padding-right: 15px;
  padding-left: unset;
}
html[dir=rtl] .product-table .rdt_TableBody .rdt_TableRow .rdt_TableCell .product-name .order-process .order-process-circle::before {
  left: 10px;
}
html[dir=rtl] .list-group {
  padding-right: 0;
}
html[dir=rtl] .list-group i,
html[dir=rtl] .list-group img {
  margin-left: 10px;
  margin-right: 0;
}
html[dir=rtl] .list-group i {
  margin-left: 0;
  margin-right: 0;
}
html[dir=rtl] .authentication-box {
  text-align: right;
}
html[dir=rtl] .mega-horizontal .offset-sm-3 {
  margin-right: 25%;
  margin-left: unset;
}
html[dir=rtl] .navs-icon svg {
  margin-left: 10px;
  margin-right: unset;
}
html[dir=rtl] .navs-icon .fa {
  margin-left: 10px;
  margin-right: unset;
}
html[dir=rtl] .nav-list .nav-list-disc {
  text-align: right;
  padding-right: 0;
}
html[dir=rtl] .pl-navs-inline {
  padding-right: 30px !important;
  padding-left: 0 !important;
}
html[dir=rtl] .onhover-dropdown.navs-dropdown:hover .onhover-show-div:before {
  left: 77px;
  right: unset;
}
html[dir=rtl] .onhover-dropdown.navs-dropdown:hover .onhover-show-div:after {
  left: 77px;
  right: unset;
}
html[dir=rtl] .navs-dropdown .onhover-show-div .navs-icon li {
  text-align: right;
}
html[dir=rtl] .navs-icon.default-according.style-1 li button[aria-expanded=true]:before {
  left: 2px;
  right: unset;
}
html[dir=rtl] .navs-icon.default-according.style-1 li button[aria-expanded=false]:before {
  left: 2px;
  right: unset;
}
html[dir=rtl] .search-form .form-group:after {
  right: 53px;
  left: unset;
}
html[dir=rtl] .search-form .form-group:before {
  right: 82px;
  left: unset;
}
html[dir=rtl] .order-history table tbody tr td .product-name .order-process .order-process-circle:before {
  right: -15px;
  left: unset;
}
html[dir=rtl] .order-history table th:first-child,
html[dir=rtl] .order-history table td:first-child {
  text-align: right;
}
html[dir=rtl] .product-page-details span {
  padding-right: 15px;
  padding-left: 0;
}
html[dir=rtl] .m-checkbox-inline label {
  margin-left: 20px;
  margin-right: 0;
}
html[dir=rtl] .form-label-align-right label {
  text-align: left;
}
html[dir=rtl] .br-theme-bars-reversed .br-widget .br-current-rating,
html[dir=rtl] .br-theme-bars-movie .br-widget .br-current-rating,
html[dir=rtl] .br-theme-bars-1to10 .br-widget .br-current-rating,
html[dir=rtl] .br-theme-bars-square .br-widget .br-current-rating {
  float: right;
}
html[dir=rtl] .br-theme-bars-reversed .br-widget a,
html[dir=rtl] .br-theme-bars-movie .br-widget a,
html[dir=rtl] .br-theme-bars-1to10 .br-widget a,
html[dir=rtl] .br-theme-bars-square .br-widget a {
  float: right;
}
html[dir=rtl] .ribbon-left {
  right: auto;
  left: -2px;
}
html[dir=rtl] .ribbon-vertical-left {
  right: auto;
  left: 12px;
}
html[dir=rtl] .ribbon-vertical-right {
  right: auto;
  left: 12px;
}
html[dir=rtl] .star-ratings ul.search-info {
  padding-right: 0;
}
html[dir=rtl] .star-ratings ul.search-info li + li {
  border-right: 1px solid #a5afc6;
  border-left: unset;
  padding-right: 8px;
  padding-left: 0;
  margin-right: 8px;
  margin-left: 0;
}
html[dir=rtl] .select2-container--default .select2-selection--single .select2-selection__arrow {
  left: 10px !important;
  right: unset !important;
}
html[dir=rtl] .select2-container--default .select2-selection--multiple .select2-selection__choice {
  float: right;
}
html[dir=rtl] .selection .select2-selection .select2-search__field {
  text-align: right;
}
html[dir=rtl] .select2-results__option {
  text-align: right;
}
html[dir=rtl] .editor-statusbar {
  text-align: left;
}
html[dir=rtl] .editor-statusbar span {
  margin-right: 1em;
  margin-left: unset;
}
html[dir=rtl] .CodeMirror-scroll {
  margin-left: -30px;
  margin-right: unset;
}
html[dir=rtl] .primary-color ul,
html[dir=rtl] .yellow-color ul {
  padding-right: 0;
}
html[dir=rtl] .u-step-desc {
  text-align: right;
}
html[dir=rtl] .u-step-number {
  right: 20px;
  left: unset;
}
html[dir=rtl] .u-step-number ~ .u-step-desc {
  margin-right: 50px;
}
html[dir=rtl] .u-pearl:after {
  left: 0;
  right: unset;
}
html[dir=rtl] .u-pearl:before {
  right: 0;
  left: unset;
}
html[dir=rtl] .u-step-icon {
  float: right;
  margin-left: 0.5em;
  margin-right: unset;
}
html[dir=rtl] .list-icons {
  padding-right: 0;
}
html[dir=rtl] .card-header.note-toolbar .note-color .dropdown-toggle {
  padding-right: 5px;
}
html[dir=rtl] .card-header.note-toolbar .form-group.draggable {
  text-align: right;
}
html[dir=rtl] .card-header.note-toolbar .form-check {
  padding-right: 24px;
  padding-left: unset;
}
html[dir=rtl] .card-header.note-toolbar form .custom-control {
  padding-right: 24px;
  padding-left: unset;
}
html[dir=rtl] .card-header.note-toolbar form .custom-control .custom-control-label::after {
  right: 0;
  left: unset;
}
html[dir=rtl] .card-header.note-toolbar form .custom-control .custom-control-label::before {
  right: 0;
  left: unset;
}
html[dir=rtl] .dropdown-toggle::after {
  margin-right: 0.255em;
  margin-left: unset;
}
html[dir=rtl] .tabbed-card ul {
  left: 22px;
  right: unset;
}
html[dir=rtl] .checkbox label {
  padding-right: 16px;
  padding-left: unset;
}
html[dir=rtl] .checkbox label::before {
  right: 0;
  left: unset;
  margin-right: -16px;
  margin-left: unset;
}
html[dir=rtl] .radio label::after {
  right: 5px;
  left: unset;
  margin-right: -20px;
  margin-left: unset;
}
html[dir=rtl] .cd-timeline-content::before {
  border-right: 7px solid #f4f4f4;
  border-left-color: transparent;
}
html[dir=rtl] .cd-timeline-img i {
  right: 40%;
  left: unset;
  margin-right: -12px;
  margin-left: unset;
}
html[dir=rtl] .cd-timeline-block:nth-child(even) .cd-timeline-content {
  float: left;
  border-left: 7px solid #eeeeee;
  border-right: unset;
}
html[dir=rtl] .cd-timeline-block:nth-child(even) .cd-timeline-content .cd-date {
  right: auto;
  left: 122%;
  text-align: left;
}
html[dir=rtl] .cd-timeline-block:nth-child(even) .cd-timeline-content::before {
  right: auto;
  left: 100%;
  border-left-color: #eeeeee;
  border-right-color: transparent;
}
html[dir=rtl] .cd-timeline-content .cd-date {
  right: 122%;
  left: unset;
}
html[dir=rtl] .introjs-tooltip {
  right: 0;
  left: unset;
}
html[dir=rtl] .introjs-helperNumberLayer {
  right: -16px;
  left: unset;
}
html[dir=rtl] .introjs-tooltipReferenceLayer .introjs-tooltip .introjs-tooltiptext {
  text-align: right;
}
html[dir=rtl] .introjs-tooltipReferenceLayer .introjs-tooltip .introjs-tooltipbuttons {
  text-align: left;
}
html[dir=rtl] .introjs-tooltipReferenceLayer .introjs-tooltip .introjs-tooltipbuttons .introjs-skipbutton {
  margin-left: 5px;
  margin-right: unset;
}
html[dir=rtl] .introjs-tooltipReferenceLayer .introjs-tooltip .introjs-tooltipbuttons .introjs-nextbutton {
  border-radius: 0.2em 0 0 0.2em;
}
html[dir=rtl] .list-inline-item:not(:last-child) {
  margin-left: 0.5rem;
  margin-right: unset;
}
html[dir=rtl] .like-comment ul.list-inline {
  padding-right: 0;
}
html[dir=rtl] .typeahead {
  text-align: right;
}
html[dir=rtl] .listing ul {
  padding-right: 0;
}
html[dir=rtl] .listing ul .icofont {
  float: right;
}
html[dir=rtl] .gallery .hover-5 img {
  margin-right: 30px;
}
html[dir=rtl] .gallery .hover-5:hover img {
  margin-right: 0;
}
html[dir=rtl] .lg-outer {
  text-align: right;
}
html[dir=rtl] .lg-toolbar .lg-icon {
  float: left;
}
html[dir=rtl] #lg-counter {
  padding-right: 20px;
  padding-left: unset;
  float: right;
}
html[dir=rtl] .chart-widget-top .text-end {
  text-align: left !important;
}
html[dir=rtl] .chart-widget-top .num .ms-1 {
  margin-right: 0.25rem !important;
}
html[dir=rtl] .bar-chart-widget .earning-details i {
  left: -240px;
}
html[dir=rtl] .bar-chart-widget .bottom-content .b-r-light {
  border-left: 1px solid #eeeeee !important;
  border-right: unset !important;
}
html[dir=rtl] .bar-chart-widget .bottom-content .num .ms-1 {
  margin-right: 0.25rem !important;
}
html[dir=rtl] .chart-vertical-center #myDoughnutGraph,
html[dir=rtl] .chart-vertical-center #myPolarGraph {
  width: auto !important;
}
html[dir=rtl] .crm-activity ul.dates li + li {
  border-right: 1px solid #ddd;
  padding-right: 10px;
  margin-right: 5px;
  border-left: unset;
  padding-left: unset;
  margin-left: unset;
}
html[dir=rtl] div.dt-buttons {
  float: right;
}
html[dir=rtl] .dt-button-collection {
  left: -39px !important;
}
html[dir=rtl] .dropzone .dz-preview .dz-error-mark,
html[dir=rtl] .dropzone .dz-preview .dz-success-mark {
  right: 50%;
  margin-right: -27px;
  margin-left: unset;
  left: unset;
}
html[dir=rtl] .page-wrapper .page-body-wrapper footer {
  margin-right: 265px;
  margin-left: unset;
}
html[dir=rtl] .page-wrapper .page-body-wrapper footer p i {
  margin-right: 5px;
  margin-left: unset;
}
html[dir=rtl] .footer-copyright {
  text-align: right;
}
html[dir=rtl] .footer-links {
  text-align: left;
}
html[dir=rtl] .page-item:first-child .page-link {
  margin-right: 0;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: none;
}
html[dir=rtl] .page-item:last-child .page-link {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
html[dir=rtl] .popover.top > .arrow:after,
html[dir=rtl] .popover.bottom > .arrow:after {
  margin-right: -10px;
  margin-left: unset;
}
html[dir=rtl] .bootstrap-touchspin > .input-group-append > .btn,
html[dir=rtl] .bootstrap-touchspin > .input-group-append > .input-group-text {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
html[dir=rtl] .bootstrap-touchspin > .form-control:not(:last-child),
html[dir=rtl] .bootstrap-touchspin > .custom-select:not(:last-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
html[dir=rtl] .typeahead span.twitter-typeahead .tt-suggestion {
  text-align: right;
}
html[dir=rtl] .typeahead .league-name {
  text-align: right;
  margin-right: 5px;
}
html[dir=rtl] .follow .text-md-right {
  text-align: left !important;
}
html[dir=rtl] .jvectormap-zoomin,
html[dir=rtl] .jvectormap-zoomout,
html[dir=rtl] .jvectormap-goback {
  right: 10px;
  left: unset;
}
html[dir=rtl] .customizer-links {
  right: unset;
  left: 0;
}
html[dir=rtl] .customizer-links > .nav {
  padding-right: 10px;
}
html[dir=rtl] .customizer-links .nav-link:after {
  right: -10px;
  left: unset;
  border-width: 5px 5px 5px 0;
  border-left-color: unset;
  border-right-color: rgb(90.8496732026%, 90%, 100%);
}
html[dir=rtl] .customizer-links .nav-link span {
  right: unset;
  left: -60px;
}
html[dir=rtl] .customizer-links .nav-link:hover span {
  left: 48px;
}
html[dir=rtl] .customizer-links.open {
  right: unset;
  left: 330px;
  border-radius: 0 8px 8px 0;
}
html[dir=rtl] .customizer-contain {
  width: 330px;
  right: unset;
  left: -330px;
}
html[dir=rtl] .customizer-contain.open {
  right: unset;
  left: 0px;
}
html[dir=rtl] .customizer-contain .customizer-header .icon-close {
  left: unset;
  right: 30px;
}
html[dir=rtl] .box-layout.page-wrapper.horizontal-wrapper .page-header {
  padding-right: 250px;
  padding-left: unset;
}
html[dir=rtl] .box-layout.page-wrapper.horizontal-wrapper .page-header.open {
  padding-right: 0;
}
html[dir=rtl] .box-layout.page-wrapper.compact-wrapper .page-body-wrapper .page-body {
  margin-left: unset;
  margin-right: 230px;
}
html[dir=rtl] .box-layout.page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper.close_icon ~ footer {
  width: 1280px;
  padding-left: 0;
  left: 50%;
}
html[dir=rtl] .box-layout.page-wrapper.compact-wrapper .page-header {
  margin-left: auto;
  margin-right: auto;
  padding-left: unset;
  padding-right: 230px;
}
html[dir=rtl] .box-layout.page-wrapper.compact-wrapper .page-header.close_icon {
  padding-right: 100px;
}
html[dir=rtl] body.dark-only .custom-card .card-footer > div + div {
  border-right: 1px solid #374558;
}
html[dir=rtl] body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .b-r-light,
html[dir=rtl] body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .border-right {
  border-right: none !important;
  border-left: 1px solid #374558 !important;
}
@media screen and (max-width: 1660px) {
  html[dir=rtl] .caller-img {
    left: unset;
    right: 15px;
  }
}
@media only screen and (max-width: 1366px) {
  html[dir=rtl] .profile-dropdown.onhover-show-div {
    right: unset !important;
    left: 0 !important;
  }
  html[dir=rtl] .product-wrapper .product-grid .feature-products {
    margin-right: 0;
  }
  html[dir=rtl] .product-grid {
    margin-right: 0;
  }
  html[dir=rtl] .d-none-productlist {
    margin-left: 10px;
    margin-right: unset;
  }
  html[dir=rtl] .photos ul li:nth-child(3n) {
    margin-left: 15px;
    margin-right: unset;
  }
  html[dir=rtl] .chat-left-aside .status-circle {
    left: unset;
    right: 22px;
  }
}
@media (min-width: 1200px) {
  html[dir=rtl] .float-xl-end {
    float: left !important;
  }
  html[dir=rtl] .chat-box .pe-xl-0 {
    padding-left: 0 !important;
    padding-right: 15px !important;
  }
  html[dir=rtl] .chat-box .ps-xl-0 {
    padding-right: 0 !important;
    padding-left: 15px !important;
  }
  html[dir=rtl] .pixelstrap ul a:hover .sub-arrow, html[dir=rtl] .pixelstrap ul a:focus .sub-arrow, html[dir=rtl] .pixelstrap ul a:active .sub-arrow, html[dir=rtl] .pixelstrap ul a.highlighted .sub-arrow {
    left: 3px;
    right: unset;
  }
}
@media (min-width: 992px) {
  html[dir=rtl] .text-lg-start {
    text-align: right !important;
  }
}
@media only screen and (max-width: 1199.98px) {
  html[dir=rtl] .jkanban-container .btn {
    margin-left: unset;
    margin-right: 20px;
  }
  html[dir=rtl] .link-section > div > h6:before, html[dir=rtl] .link-section > div > .h6:before {
    right: unset;
    left: 10px;
  }
  html[dir=rtl] .page-wrapper .page-header .header-wrapper .nav-right > ul li .submenu li:first-child {
    padding-right: 15px !important;
    padding-left: 15px !important;
  }
  html[dir=rtl] .user-profile .hovercard .user-image .share-icons {
    left: 45px;
  }
  html[dir=rtl] .email-wrap .row .col-xl-6 {
    padding-right: 15px;
  }
  html[dir=rtl] .email-wrap .row .col-xl-3 + .col-xl-3 {
    padding-left: 15px;
  }
  html[dir=rtl] .email-wrap .email-app-sidebar .main-menu > li {
    text-align: right;
  }
  html[dir=rtl] .email-wrap .email-app-sidebar .main-menu > li a i {
    margin-right: unset;
    margin-left: 10px;
  }
  html[dir=rtl] .email-wrap .email-app-sidebar ul {
    padding-right: 0;
  }
  html[dir=rtl] .email-wrap .email-content .email-top .user-emailid:after {
    float: left;
  }
  html[dir=rtl] .email-wrap .email-right-aside .email-body .pe-0 {
    padding-right: unset !important;
  }
  html[dir=rtl] .email-wrap .email-right-aside .radius-left {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    border-radius: 4px;
  }
  html[dir=rtl] .chat-menu-icons {
    text-align: left;
  }
  html[dir=rtl] .chat-box .chat-history .row .col-sm-7 {
    padding-left: 0 !important;
    padding-right: unset !important;
  }
  html[dir=rtl] .chat-menu {
    left: 0;
    right: unset;
  }
}
@media only screen and (max-width: 991.98px) {
  html[dir=rtl] .todo .todo-list-wrapper .mark-all-tasks {
    left: 20px;
  }
  html[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon {
    transform: translate(285px);
  }
  html[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon:hover {
    transform: translate(285px);
  }
  html[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .logo-wrapper .back-btn {
    float: left;
    transform: rotate(180deg);
  }
  html[dir=rtl] .page-wrapper.compact-wrapper .page-header .header-wrapper .toggle-sidebar {
    margin-right: 0;
    border-right: none;
    padding-right: 0;
    border-left: 1px solid #ddd;
    margin-left: 15px;
    padding-left: 15px;
  }
  html[dir=rtl] .page-wrapper.compact-sidebar .page-header {
    margin-right: 0;
  }
  html[dir=rtl] .page-wrapper.material-icon .page-header {
    padding-right: 0;
  }
  html[dir=rtl] .page-wrapper.material-icon .page-body-wrapper .page-body {
    padding-right: 15px;
  }
  html[dir=rtl] .faq-accordion .faq-header svg {
    left: 20px;
  }
  html[dir=rtl] .page-wrapper .page-header .header-logo-wrapper .logo-wrapper img {
    margin-left: 15px;
    margin-right: unset;
  }
  html[dir=rtl] .page-body-wrapper .page-body,
  html[dir=rtl] .page-body-wrapper footer {
    margin-right: 0 !important;
  }
  html[dir=rtl] .main .langChoice {
    left: 20px;
  }
  html[dir=rtl] .cd-timeline-img i {
    right: 50% !important;
  }
  html[dir=rtl] .page-wrapper .page-body-wrapper .page-title .breadcrumb {
    margin-right: 0;
  }
  html[dir=rtl] .page-wrapper .page-body-wrapper .page-body {
    min-height: calc(100vh - 60px);
  }
  html[dir=rtl] .page-wrapper .page-header {
    margin-right: 0;
  }
  html[dir=rtl] .page-wrapper.compact-wrapper .page-header {
    margin-right: 0 !important;
    margin-left: unset !important;
  }
  html[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper.sidebar-wrapper.close_icon {
    transform: translate(285px);
  }
  html[dir=rtl] .card-body .value-left {
    margin-left: 20px;
  }
  html[dir=rtl] .bookmark ul li .search-form .form-control-search {
    left: -127px;
  }
  html[dir=rtl] .card .card-header .card-header-right {
    left: 15px;
  }
}
@media only screen and (max-width: 991px) and (min-width: 768px) {
  html[dir=rtl] .page-wrapper.compact-wrapper.material-type .page-body-wrapper div.sidebar-wrapper {
    left: unset;
    right: 0;
  }
}
@media (min-width: 768px) {
  html[dir=rtl] .float-md-end {
    float: left !important;
  }
  html[dir=rtl] .text-md-end {
    text-align: left !important;
  }
  html[dir=rtl] .offset-md-3 {
    margin-right: 25%;
    margin-left: unset;
  }
  html[dir=rtl] .text-md-start {
    text-align: right !important;
  }
  html[dir=rtl] .ecommerce-widget .text-md-end {
    text-align: left !important;
  }
  html[dir=rtl] .ecommerce-widget .text-md-end ul {
    text-align: left;
  }
}
@media only screen and (max-width: 767.98px) {
  html[dir=rtl] .list-persons .profile-mail .email-general ul {
    padding-left: 0;
  }
  html[dir=rtl] .product-wrapper.sidebaron .product-grid .product-wrapper-grid {
    margin-right: 0;
  }
  html[dir=rtl] .product-sidebar {
    transform: translateX(300px) scaleX(1);
  }
  html[dir=rtl] .product-sidebar.open {
    transform: translateX(0px) scaleX(1);
  }
  html[dir=rtl] .feature-products .filter-toggle {
    margin-right: 10px;
    margin-left: unset;
  }
  html[dir=rtl] .user-profile .hovercard .user-image .share-icons {
    left: 25px !important;
  }
  html[dir=rtl] .ecommerce-widget .text-md-right {
    text-align: left !important;
  }
  html[dir=rtl] .bar-chart-widget .earning-details i {
    left: -147px !important;
  }
}
@media (min-width: 576px) {
  html[dir=rtl] .offset-sm-3 {
    margin-right: 25%;
    margin-left: unset;
  }
  html[dir=rtl] .text-sm-end {
    text-align: left !important;
  }
  html[dir=rtl] .float-sm-end {
    float: left !important;
  }
  html[dir=rtl] .me-sm-2 {
    margin-left: 0.5rem !important;
    margin-right: unset !important;
  }
}
@media only screen and (max-width: 575.98px) {
  html[dir=rtl] .todo .todo-list-wrapper .mark-all-tasks {
    left: 15px;
  }
  html[dir=rtl] .list-persons .nav-pills .nav-link .media .media-body {
    text-align: right;
  }
  html[dir=rtl] .mega-menu {
    padding-left: unset;
    padding-right: 15px;
  }
  html[dir=rtl] .page-wrapper .page-header .header-wrapper .nav-right > ul li {
    margin-right: unset;
    margin-left: 1px;
  }
  html[dir=rtl] .page-wrapper .page-header .header-wrapper .search-full .form-group .close-search {
    left: 0;
  }
  html[dir=rtl] .page-wrapper.compact-wrapper .page-header .header-wrapper .toggle-sidebar, html[dir=rtl] .page-wrapper.compact-sidebar .page-header .header-wrapper .toggle-sidebar {
    margin-left: 8px;
    padding-left: 8px;
    margin-right: unset;
    padding-right: unset;
    border-right: unset;
    border-left: 1px solid #ddd;
  }
  html[dir=rtl] .translate_wrapper.active .more_lang.active {
    left: unset;
    right: 12px;
  }
  html[dir=rtl] .page-header .header-wrapper .nav-right > ul > li:last-child {
    padding-right: 10px;
  }
  html[dir=rtl] .page-header .header-wrapper .nav-right.right-header ul.notification-dropdown {
    left: unset !important;
    right: 15px !important;
  }
  html[dir=rtl] .faq-accordion .faq-header svg {
    left: 15px;
  }
  html[dir=rtl] .user-profile .hovercard .user-image .share-icons {
    left: 15px !important;
  }
  html[dir=rtl] .user-profile .hovercard .user-image .share-icons li {
    margin-left: 0px;
  }
  html[dir=rtl] .main .langChoice {
    left: 15px;
  }
  html[dir=rtl] .page-wrapper .search-form .form-group {
    margin-left: 0;
  }
  html[dir=rtl] .card-body .value-left {
    margin-left: 15px;
  }
}
@media only screen and (max-width: 480px) {
  html[dir=rtl] .page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div {
    right: unset;
    left: 20px;
  }
  html[dir=rtl] .knob-chart .chart-clock-main {
    width: unset;
  }
  html[dir=rtl] .knob-chart .chart-clock-main .clock-small {
    right: 32px;
  }
  html[dir=rtl] .knob-chart .chart-clock-main .clock-large {
    right: 0;
    left: unset;
  }
  html[dir=rtl] .knob-chart .chart-clock-main .clock-medium {
    right: 32px;
    left: unset;
  }
}
@media only screen and (max-width: 420px) {
  html[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu,
  html[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container {
    right: 112px;
  }
  html[dir=rtl] .page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu,
  html[dir=rtl] .page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container {
    right: 80px;
  }
}
@media only screen and (max-width: 360px) {
  html[dir=rtl] .prooduct-details-box .close {
    left: 0;
  }
  html[dir=rtl] .social-app-profile .hovercard .user-image .avatar img {
    width: 85px;
    height: 85px;
  }
  html[dir=rtl] .social-app-profile .hovercard .user-image .avatar {
    margin-top: -47px;
  }
  html[dir=rtl] .social-chat .other-msg {
    margin-right: 15px;
  }
}
@media screen and (max-width: 1460px) {
  html[dir=rtl] .sidebar-wrapper .sidebar-main .sidebar-links > li {
    margin-left: 8px;
    margin-right: unset;
  }
}

@media screen and (min-width: 992px) {
  .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-main .sidebar-links > li:hover .sidebar-submenu {
    margin-top: 8px;
    opacity: 1;
    transition: all 0.5s ease;
    visibility: visible;
  }
}
/**=====================
    60. RTL CSS Ends
==========================**/
/**=====================
    63. Box-layout CSS start
==========================**/
.box-layout {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
  background-blend-mode: overlay;
  background-color: rgba(255, 255, 255, 0.5);
}
@media only screen and (min-width: 1280px) {
  .box-layout .learning-filter {
    order: -1;
  }
  .box-layout .md-sidebar .md-sidebar-toggle {
    display: block;
  }
  .box-layout .md-sidebar .md-sidebar-aside {
    position: absolute;
    top: 40px;
    left: 0;
    opacity: 0;
    visibility: hidden;
    z-index: 3;
    width: 280px;
  }
  .box-layout .md-sidebar .md-sidebar-aside.open {
    opacity: 1;
    visibility: visible;
  }
  .box-layout .job-sidebar {
    background-color: var(--white);
    padding: 20px;
  }
  .box-layout .widget-1.mb-xl-0 {
    margin-bottom: 25px !important;
  }
  .box-layout .radial-progress-card .radial-chart-wrap {
    margin-right: -10px;
  }
  .box-layout .currency-widget div[class*=bg-light-] {
    display: none;
  }
  .box-layout .box-order .order-1 {
    order: 1 !important;
  }
  .box-layout .activity-card .appointment-table.customer-table {
    height: 187px;
  }
  .box-layout .transaction-table tr td:first-child {
    min-width: 150px;
  }
  .box-layout .welcome-card .welcome-img {
    height: 170px;
    bottom: -22px;
  }
  .box-layout .purchase-card img {
    margin: -210px auto 0;
    width: 80%;
  }
  .box-layout .purchase-card.discover {
    margin-top: 90px;
  }
  .box-layout .purchase-card.discover img {
    margin-top: -90px;
    width: 64%;
  }
  .box-layout .apache-cotainer-large > div,
  .box-layout .apache-cotainer-large canvas,
  .box-layout #line-visual > div,
  .box-layout #line-visual canvas,
  .box-layout #line-visulH > div,
  .box-layout #line-visulH canvas {
    width: 100% !important;
  }
  .box-layout .page-wrapper.box-layout, .box-layout.page-wrapper.box-layout {
    padding-top: 40px;
    margin-top: 0 !important;
  }
  .box-layout .page-wrapper.compact-wrapper, .box-layout.page-wrapper.compact-wrapper {
    margin-top: 40px;
  }
  .box-layout .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper, .box-layout.page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper {
    width: 230px;
    top: 40px;
    border-radius: 10px 0 0 10px;
  }
  .box-layout .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper.close_icon ~ footer, .box-layout.page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper.close_icon ~ footer {
    width: 1200px;
    left: 47%;
  }
  .box-layout .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper.close_icon ~ .footer-fix, .box-layout.page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper.close_icon ~ .footer-fix {
    padding-left: 0;
  }
  .box-layout .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper.close_icon .sidebar-main .sidebar-links, .box-layout.page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper.close_icon .sidebar-main .sidebar-links {
    height: calc(100vh - 196px);
  }
  .box-layout .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper .logo-wrapper, .box-layout.page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper .logo-wrapper {
    box-shadow: 0 8px 6px -6px rgba(89, 102, 122, 0.1);
  }
  .box-layout .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links, .box-layout.page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links {
    margin-top: 10px;
    margin-bottom: 20px;
    height: calc(100vh - 191px);
  }
  .box-layout .page-wrapper.compact-wrapper .page-body-wrapper .page-body, .box-layout.page-wrapper.compact-wrapper .page-body-wrapper .page-body {
    min-height: calc(100vh - 130px);
    margin-top: 0;
    top: 80px;
    overflow: scroll;
    max-height: calc(100vh - 220px);
    padding-bottom: 80px;
    margin-left: 230px;
  }
  .box-layout .page-wrapper.compact-wrapper .page-body-wrapper .page-body::-webkit-scrollbar-track, .box-layout.page-wrapper.compact-wrapper .page-body-wrapper .page-body::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px #ecf3fa;
  }
  .box-layout .page-wrapper.compact-wrapper .page-body-wrapper .page-body::-webkit-scrollbar, .box-layout.page-wrapper.compact-wrapper .page-body-wrapper .page-body::-webkit-scrollbar {
    width: 6px;
  }
  .box-layout .page-wrapper.compact-wrapper .page-body-wrapper .page-body::-webkit-scrollbar-thumb, .box-layout.page-wrapper.compact-wrapper .page-body-wrapper .page-body::-webkit-scrollbar-thumb {
    background-color: rgba(68, 102, 242, 0.15);
  }
  .box-layout .page-wrapper.compact-sidebar .page-header, .box-layout.page-wrapper.compact-sidebar .page-header {
    padding-left: 148px;
  }
  .box-layout .page-wrapper.compact-sidebar .page-body-wrapper, .box-layout.page-wrapper.compact-sidebar .page-body-wrapper {
    margin-top: 40px;
  }
  .box-layout .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper, .box-layout.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper {
    top: 40px;
  }
  .box-layout .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper.close_icon, .box-layout.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper.close_icon {
    display: none;
    transition: 0.5s;
  }
  .box-layout .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links, .box-layout.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links {
    height: calc(100vh - 166px);
    margin: 0;
  }
  .box-layout .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu,
  .box-layout .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container, .box-layout.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu,
  .box-layout.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container {
    left: 470px;
    top: 40px;
    height: calc(100vh - 84px);
  }
  .box-layout .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a.active ~ .sidebar-submenu,
  .box-layout .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a.active ~ .mega-menu-container, .box-layout.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a.active ~ .sidebar-submenu,
  .box-layout.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a.active ~ .mega-menu-container {
    animation: unset;
  }
  .box-layout .page-wrapper.compact-sidebar .page-body-wrapper .footer, .box-layout.page-wrapper.compact-sidebar .page-body-wrapper .footer {
    margin-left: 0;
  }
  .box-layout .page-wrapper.compact-sidebar .page-body-wrapper .page-body, .box-layout.page-wrapper.compact-sidebar .page-body-wrapper .page-body {
    min-height: calc(100vh - 90px);
    margin-top: 0;
    top: 80px;
    overflow: scroll;
    max-height: calc(100vh - 170px);
    padding-bottom: 80px;
  }
  .box-layout .page-wrapper.compact-sidebar .page-body-wrapper .page-body::-webkit-scrollbar-track, .box-layout.page-wrapper.compact-sidebar .page-body-wrapper .page-body::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px #ecf3fa;
  }
  .box-layout .page-wrapper.compact-sidebar .page-body-wrapper .page-body::-webkit-scrollbar, .box-layout.page-wrapper.compact-sidebar .page-body-wrapper .page-body::-webkit-scrollbar {
    width: 6px;
  }
  .box-layout .page-wrapper.compact-sidebar .page-body-wrapper .page-body::-webkit-scrollbar-thumb, .box-layout.page-wrapper.compact-sidebar .page-body-wrapper .page-body::-webkit-scrollbar-thumb {
    background-color: rgba(68, 102, 242, 0.15);
  }
  .box-layout .page-wrapper.compact-sidebar.compact-small .page-header, .box-layout.page-wrapper.compact-sidebar.compact-small .page-header {
    padding-left: 90px;
  }
  .box-layout .page-wrapper.compact-sidebar.compact-small .page-header.close_icon, .box-layout.page-wrapper.compact-sidebar.compact-small .page-header.close_icon {
    padding-left: 0;
  }
  .box-layout .page-wrapper.compact-sidebar.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu,
  .box-layout .page-wrapper.compact-sidebar.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container, .box-layout.page-wrapper.compact-sidebar.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu,
  .box-layout.page-wrapper.compact-sidebar.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container {
    left: 410px;
  }
  .box-layout .page-wrapper.horizontal-wrapper:before, .box-layout.page-wrapper.horizontal-wrapper:before {
    display: none;
  }
  .box-layout .page-wrapper.horizontal-wrapper .page-body-wrapper, .box-layout.page-wrapper.horizontal-wrapper .page-body-wrapper {
    margin-top: 40px;
  }
  .box-layout .page-wrapper.horizontal-wrapper .page-body-wrapper .page-body, .box-layout.page-wrapper.horizontal-wrapper .page-body-wrapper .page-body {
    margin-top: 80px;
    min-height: calc(100vh - 310px);
    max-height: calc(100vh - 230px);
    overflow: scroll;
  }
  .box-layout .page-wrapper.horizontal-wrapper .page-body-wrapper .page-body::-webkit-scrollbar-track, .box-layout.page-wrapper.horizontal-wrapper .page-body-wrapper .page-body::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px #ecf3fa;
  }
  .box-layout .page-wrapper.horizontal-wrapper .page-body-wrapper .page-body::-webkit-scrollbar, .box-layout.page-wrapper.horizontal-wrapper .page-body-wrapper .page-body::-webkit-scrollbar {
    width: 6px;
  }
  .box-layout .page-wrapper.horizontal-wrapper .page-body-wrapper .page-body::-webkit-scrollbar-thumb, .box-layout.page-wrapper.horizontal-wrapper .page-body-wrapper .page-body::-webkit-scrollbar-thumb {
    background-color: rgba(68, 102, 242, 0.15);
  }
  .box-layout .page-wrapper.horizontal-wrapper .page-body-wrapper .footer, .box-layout.page-wrapper.horizontal-wrapper .page-body-wrapper .footer {
    padding-left: 15px;
  }
  .box-layout .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper, .box-layout.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper {
    width: 1280px;
    top: 80px;
    margin: 0;
    overflow-x: unset;
    position: relative;
  }
  .box-layout .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main #sidebar-menu, .box-layout.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main #sidebar-menu {
    left: 0%;
    transform: translate(0, 0);
    top: 125px;
    background-color: #fff;
  }
  .box-layout .page-wrapper.horizontal-wrapper .page-header, .box-layout.page-wrapper.horizontal-wrapper .page-header {
    padding-left: 0;
  }
  .box-layout .page-wrapper.modern-type .page-header, .box-layout.page-wrapper.modern-type .page-header {
    padding-left: 0px;
  }
  .box-layout .page-wrapper.modern-type .page-header .header-wrapper .left-header, .box-layout.page-wrapper.modern-type .page-header .header-wrapper .left-header {
    width: 36%;
  }
  .box-layout .page-wrapper.modern-type .page-header .header-wrapper .nav-right, .box-layout.page-wrapper.modern-type .page-header .header-wrapper .nav-right {
    width: 46%;
  }
  .box-layout .page-wrapper.modern-type .page-body-wrapper .page-body, .box-layout.page-wrapper.modern-type .page-body-wrapper .page-body {
    margin-left: 260px;
  }
  .box-layout .page-wrapper.modern-type .page-body-wrapper .sidebar-wrapper, .box-layout.page-wrapper.modern-type .page-body-wrapper .sidebar-wrapper {
    top: 120px;
  }
  .box-layout .page-wrapper.modern-type .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links, .box-layout.page-wrapper.modern-type .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links {
    height: calc(100vh - 311px);
  }
  .box-layout .page-wrapper.modern-type .page-body-wrapper .sidebar-wrapper.close_icon .sidebar-main .sidebar-links, .box-layout.page-wrapper.modern-type .page-body-wrapper .sidebar-wrapper.close_icon .sidebar-main .sidebar-links {
    height: calc(100vh - 316px);
  }
  .box-layout .page-wrapper.modern-type .page-body-wrapper .sidebar-wrapper.close_icon ~ footer, .box-layout.page-wrapper.modern-type .page-body-wrapper .sidebar-wrapper.close_icon ~ footer {
    width: 1280px;
    left: 50%;
    margin-left: 0;
  }
  .box-layout .page-wrapper.modern-type .page-body-wrapper .footer, .box-layout.page-wrapper.modern-type .page-body-wrapper .footer {
    margin-left: 0;
  }
  .box-layout .page-wrapper .page-header, .box-layout.page-wrapper .page-header {
    max-width: 1280px;
    margin: 0 auto;
    left: 0;
    right: 0;
    transition: 0.5s;
    padding-left: 230px;
    margin-top: 40px;
    border-radius: 10px;
    width: unset;
  }
  .box-layout .page-wrapper .page-header.close_icon, .box-layout.page-wrapper .page-header.close_icon {
    padding-left: 0;
    margin-left: auto;
    width: calc(100% - 0px);
    transition: 0.5s;
  }
  .box-layout .page-wrapper .page-header .header-wrapper, .box-layout.page-wrapper .page-header .header-wrapper {
    border: 1px solid #f8f8f8;
    border-radius: 10px 10px 0 0;
  }
  .box-layout .page-wrapper.horizontal-wrapper .page-header .header-wrapper .nav-right,
  .box-layout .page-wrapper.horizontal-wrapper .page-header .header-wrapper .left-header, .box-layout.page-wrapper.horizontal-wrapper .page-header .header-wrapper .nav-right,
  .box-layout.page-wrapper.horizontal-wrapper .page-header .header-wrapper .left-header {
    width: 36%;
  }
  .box-layout .page-wrapper.material-type .page-body-wrapper, .box-layout.page-wrapper.material-type .page-body-wrapper {
    margin-top: 0;
  }
  .box-layout .page-wrapper.material-type .page-body-wrapper .page-body, .box-layout.page-wrapper.material-type .page-body-wrapper .page-body {
    margin-top: 0;
  }
  .box-layout .page-wrapper.material-type .page-body-wrapper .sidebar-wrapper, .box-layout.page-wrapper.material-type .page-body-wrapper .sidebar-wrapper {
    top: 0;
  }
  .box-layout .page-wrapper.material-icon .page-header.close_icon, .box-layout.page-wrapper.material-icon .page-header.close_icon {
    margin-top: 40px !important;
  }
  .box-layout .page-wrapper.material-icon .page-body-wrapper, .box-layout.page-wrapper.material-icon .page-body-wrapper {
    margin-top: 0;
  }
  .box-layout .page-wrapper.material-icon .page-body-wrapper .page-body, .box-layout.page-wrapper.material-icon .page-body-wrapper .page-body {
    top: 0;
    min-height: calc(100vh - 170px);
    padding-bottom: 40px;
  }
  .box-layout .page-wrapper.advance-layout .page-header, .box-layout.page-wrapper.advance-layout .page-header {
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.07);
  }
  .box-layout .page-wrapper.advance-layout .page-body-wrapper, .box-layout.page-wrapper.advance-layout .page-body-wrapper {
    margin-top: 0;
  }
  .box-layout .page-wrapper .page-body-wrapper, .box-layout.page-wrapper .page-body-wrapper {
    width: 1280px;
    box-shadow: 4px 11px 25px rgba(0, 0, 0, 0.07);
    margin: 0 auto;
    overflow: hidden;
  }
  .box-layout .page-wrapper .page-body-wrapper .todo .todo-list-wrapper #todo-list li .task-responsive, .box-layout.page-wrapper .page-body-wrapper .todo .todo-list-wrapper #todo-list li .task-responsive {
    min-width: 1087px;
    overflow: auto;
  }
  .box-layout .page-wrapper .page-body-wrapper .active-order-table, .box-layout.page-wrapper .page-body-wrapper .active-order-table {
    max-width: 443px;
    overflow: auto;
  }
  .box-layout .page-wrapper .page-body-wrapper .active-order-table table tbody tr td p, .box-layout.page-wrapper .page-body-wrapper .active-order-table table tbody tr td p {
    width: 100px;
  }
  .box-layout .page-wrapper .page-body-wrapper .activity .media .gradient-round.gradient-line-1:after, .box-layout.page-wrapper .page-body-wrapper .activity .media .gradient-round.gradient-line-1:after {
    height: 57px;
    bottom: -64px;
  }
  .box-layout .page-wrapper .page-body-wrapper .activity .media .gradient-round.small-line:after, .box-layout.page-wrapper .page-body-wrapper .activity .media .gradient-round.small-line:after {
    height: 36px;
    bottom: -43px;
  }
  .box-layout .page-wrapper .page-body-wrapper .activity .media .gradient-round.medium-line:after, .box-layout.page-wrapper .page-body-wrapper .activity .media .gradient-round.medium-line:after {
    height: 40px;
    bottom: -48px;
  }
  .box-layout .page-wrapper .page-body-wrapper footer, .box-layout.page-wrapper .page-body-wrapper footer {
    width: 1280px;
    margin: 0 auto;
    padding-left: 230px;
    margin-bottom: 40px !important;
    position: fixed;
    left: 50%;
    transform: translate(-50%, 0);
    border-radius: 0 0 10px;
  }
  .box-layout .page-wrapper .page-body-wrapper .blockquote-footer, .box-layout.page-wrapper .page-body-wrapper .blockquote-footer {
    margin-left: 0;
    width: 100%;
  }
  .box-layout .page-wrapper .page-body-wrapper .footer-fix, .box-layout.page-wrapper .page-body-wrapper .footer-fix {
    padding-left: 230px;
  }
  .box-layout .page-wrapper .page-body-wrapper .chat-box .chat-history .call-content, .box-layout.page-wrapper .page-body-wrapper .chat-box .chat-history .call-content {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 300px;
  }
  .box-layout .page-wrapper .page-body-wrapper .chat-box .chat-history .call-content > div, .box-layout.page-wrapper .page-body-wrapper .chat-box .chat-history .call-content > div {
    z-index: 8;
    background-color: rgba(255, 255, 255, 0.75);
    background-blend-mode: overlay;
    width: 100%;
    padding: 30px;
    left: 15px;
  }
  .box-layout .page-wrapper .page-body-wrapper .chat-box .chat-history .call-content button, .box-layout.page-wrapper .page-body-wrapper .chat-box .chat-history .call-content button {
    width: 40%;
    font-size: 14px;
    margin: 0 auto;
  }
  .box-layout .page-wrapper .page-body-wrapper .chat-box .chat-history .call-icons, .box-layout.page-wrapper .page-body-wrapper .chat-box .chat-history .call-icons {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .box-layout .page-wrapper .page-body-wrapper .chat-box .chat-history .call-icons ul li, .box-layout.page-wrapper .page-body-wrapper .chat-box .chat-history .call-icons ul li {
    border: 1px solid #717171;
    width: 50px;
    height: 50px;
    padding: 8px;
  }
  .box-layout .page-wrapper .page-body-wrapper .chat-box .chat-history .receiver-img, .box-layout.page-wrapper .page-body-wrapper .chat-box .chat-history .receiver-img {
    margin-top: 30px;
    margin-bottom: 30px;
  }
  .box-layout .page-wrapper .page-body-wrapper .chat-box .chat-history .receiver-img img, .box-layout.page-wrapper .page-body-wrapper .chat-box .chat-history .receiver-img img {
    width: 38%;
  }
  .box-layout .page-wrapper .page-body-wrapper .chat-box .chat-history .total-time h2, .box-layout .page-wrapper .page-body-wrapper .chat-box .chat-history .total-time .h2, .box-layout.page-wrapper .page-body-wrapper .chat-box .chat-history .total-time h2, .box-layout.page-wrapper .page-body-wrapper .chat-box .chat-history .total-time .h2 {
    font-size: 28px;
    color: #717171;
  }
  .box-layout .page-wrapper .page-body-wrapper canvas#myLineCharts, .box-layout.page-wrapper .page-body-wrapper canvas#myLineCharts {
    width: 100%;
  }
  .box-layout .page-wrapper .page-body-wrapper .chat-right-aside, .box-layout.page-wrapper .page-body-wrapper .chat-right-aside {
    flex: 0 0 60%;
    max-width: 60%;
    overflow: hidden;
  }
  .box-layout .page-wrapper .page-body-wrapper .caller-img, .box-layout.page-wrapper .page-body-wrapper .caller-img {
    position: absolute;
    width: 100%;
    max-width: 100%;
    left: 15px;
  }
  .box-layout .page-wrapper .page-body-wrapper .caller-img img, .box-layout.page-wrapper .page-body-wrapper .caller-img img {
    opacity: 0.7;
  }
  .box-layout .page-wrapper .page-body-wrapper .browser-widget img, .box-layout.page-wrapper .page-body-wrapper .browser-widget img {
    height: 65px;
  }
  .box-layout .page-wrapper .page-body-wrapper .custom-card .card-header img, .box-layout.page-wrapper .page-body-wrapper .custom-card .card-header img {
    margin-top: -73px;
  }
  .box-layout .page-wrapper .page-body-wrapper .custom-card .card-profile img, .box-layout.page-wrapper .page-body-wrapper .custom-card .card-profile img {
    height: 130px;
    top: -17px;
  }
  .box-layout .page-wrapper .page-body-wrapper .select2, .box-layout.page-wrapper .page-body-wrapper .select2 {
    width: 901.781px;
  }
  .box-layout .page-wrapper ul.close_icon > li label, .box-layout.page-wrapper ul.close_icon > li label {
    padding: 0;
  }
  .box-layout .page-wrapper ul.close_icon > li label:after, .box-layout.page-wrapper ul.close_icon > li label:after {
    display: none;
  }
  .box-layout .page-wrapper .bookmark ul, .box-layout.page-wrapper .bookmark ul {
    margin-right: -1px;
  }
  .box-layout .page-wrapper #batchDelete .jsgrid-grid-header .jsgrid-table tr th .btn, .box-layout.page-wrapper #batchDelete .jsgrid-grid-header .jsgrid-table tr th .btn {
    padding-left: 20px;
    padding-right: 20px;
  }
  .box-layout .page-wrapper .btn-group-showcase .btn-radio .btn-group .radio input[type=radio], .box-layout.page-wrapper .btn-group-showcase .btn-radio .btn-group .radio input[type=radio] {
    display: none;
  }
  .box-layout .page-wrapper .media.bitcoin-graph, .box-layout.page-wrapper .media.bitcoin-graph {
    display: block;
  }
  .box-layout .page-wrapper .media.bitcoin-graph .top-bitcoin, .box-layout.page-wrapper .media.bitcoin-graph .top-bitcoin {
    display: inline-block;
    vertical-align: middle;
  }
  .box-layout .page-wrapper .media.bitcoin-graph .media-body, .box-layout.page-wrapper .media.bitcoin-graph .media-body {
    margin-top: 30px;
  }
  .box-layout .page-wrapper .media.bitcoin-graph .media-body .bitcoin-content .bitcoin-numbers h6, .box-layout .page-wrapper .media.bitcoin-graph .media-body .bitcoin-content .bitcoin-numbers .h6, .box-layout.page-wrapper .media.bitcoin-graph .media-body .bitcoin-content .bitcoin-numbers h6, .box-layout.page-wrapper .media.bitcoin-graph .media-body .bitcoin-content .bitcoin-numbers .h6 {
    font-size: 14px;
  }
  .box-layout .page-wrapper .media.bitcoin-graph .media-body .bitcoin-content.text-right, .box-layout.page-wrapper .media.bitcoin-graph .media-body .bitcoin-content.text-right {
    text-align: center !important;
  }
  .box-layout .page-wrapper .alert.inverse p, .box-layout.page-wrapper .alert.inverse p {
    max-width: 238px;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .box-layout .page-wrapper .auth-bg-effect .second-effect, .box-layout.page-wrapper .auth-bg-effect .second-effect {
    left: 55%;
  }
  .box-layout .page-wrapper .auth-bg-video video, .box-layout.page-wrapper .auth-bg-video video {
    min-width: 67%;
    width: 67%;
  }
  .box-layout .page-wrapper .page-builder .ge-canvas.ge-layout-desktop, .box-layout.page-wrapper .page-builder .ge-canvas.ge-layout-desktop {
    margin-top: 40px;
  }
  .box-layout .page-wrapper .page-builder .ge-addRowGroup, .box-layout.page-wrapper .page-builder .ge-addRowGroup {
    margin-bottom: 10px;
  }
  .box-layout .page-wrapper .pricing-wrapper-card, .box-layout.page-wrapper .pricing-wrapper-card {
    padding: 50px 20px;
  }
  .box-layout .page-wrapper .card .blog-box.blog-grid.set-min-height, .box-layout.page-wrapper .card .blog-box.blog-grid.set-min-height {
    min-height: 400px;
  }
  .box-layout .page-wrapper .flot-chart-placeholder#donut-color-chart-morris-daily, .box-layout.page-wrapper .flot-chart-placeholder#donut-color-chart-morris-daily {
    min-height: 430px;
  }
  .box-layout .page-wrapper .flot-chart-placeholder#donut-color-chart-morris, .box-layout.page-wrapper .flot-chart-placeholder#donut-color-chart-morris {
    min-height: 430px;
  }
  .box-layout .page-wrapper .box-col-12, .box-layout.page-wrapper .box-col-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .box-layout .page-wrapper .box-col-6, .box-layout.page-wrapper .box-col-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .box-layout .page-wrapper .box-col-3, .box-layout.page-wrapper .box-col-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .box-layout .page-wrapper .box-col-7, .box-layout.page-wrapper .box-col-7 {
    flex: 0 0 60%;
    max-width: 60%;
  }
  .box-layout .page-wrapper .box-col-5, .box-layout.page-wrapper .box-col-5 {
    flex: 0 0 40%;
    max-width: 40%;
  }
  .box-layout .page-wrapper .box-col-8, .box-layout.page-wrapper .box-col-8 {
    flex: 0 0 70%;
    max-width: 70%;
  }
  .box-layout .page-wrapper .box-col-4e, .box-layout.page-wrapper .box-col-4e {
    flex: 0 0 30%;
    max-width: 30%;
  }
  .box-layout .page-wrapper .box-col-4, .box-layout.page-wrapper .box-col-4 {
    flex: 0 0 33.33%;
    max-width: 33%;
  }
  .box-layout .page-wrapper .box-col-8e, .box-layout.page-wrapper .box-col-8e {
    flex: 0 0 66.67%;
    max-width: 66.67%;
  }
  .box-layout .page-wrapper .box-col-none, .box-layout.page-wrapper .box-col-none {
    display: none !important;
  }
  .box-layout .page-wrapper .chat-box .chat-right-aside .chat .chat-header .chat-menu-icons li a i, .box-layout.page-wrapper .chat-box .chat-right-aside .chat .chat-header .chat-menu-icons li a i {
    font-size: 19px;
  }
  .box-layout .page-wrapper .chat-box .chat-right-aside, .box-layout.page-wrapper .chat-box .chat-right-aside {
    flex: 0 0 100%;
    max-width: calc(100% - 15px);
    overflow: hidden;
  }
  .box-layout .page-wrapper .chat-box .toogle-bar, .box-layout.page-wrapper .chat-box .toogle-bar {
    display: inline-block;
    margin-right: 0 !important;
  }
  .box-layout .page-wrapper .chat-menu, .box-layout.page-wrapper .chat-menu {
    right: 0;
    border-top: 1px solid #ddd;
    opacity: 0;
    transform: translateY(-30px);
    visibility: hidden;
    top: 81px;
    position: absolute;
    z-index: 9;
    background-color: #fff;
    transition: all linear 0.3s;
  }
  .box-layout .page-wrapper .chat-menu.show, .box-layout.page-wrapper .chat-menu.show {
    opacity: 1;
    visibility: visible;
    transform: translateY(0px);
    transition: all linear 0.3s;
    padding-bottom: 25px;
  }
  .box-layout .page-wrapper .ct-10.total-chart .ct-chart-bar .ct-series .ct-bar, .box-layout.page-wrapper .ct-10.total-chart .ct-chart-bar .ct-series .ct-bar {
    stroke-width: 23px !important;
  }
  .box-layout .page-wrapper .social-app-profile #friends .box-col-4, .box-layout.page-wrapper .social-app-profile #friends .box-col-4 {
    flex: 0 0 30%;
    max-width: 30%;
  }
  .box-layout .page-wrapper .email-wrap .email-body .email-compose .cke_contents.cke_reset, .box-layout.page-wrapper .email-wrap .email-body .email-compose .cke_contents.cke_reset {
    max-height: 165px;
  }
  .box-layout .page-wrapper .email-wrap .row .col-xl-6, .box-layout.page-wrapper .email-wrap .row .col-xl-6 {
    padding-left: 12px;
  }
  .box-layout .page-wrapper .email-wrap .row .col-xl-3 + .col-xl-3, .box-layout.page-wrapper .email-wrap .row .col-xl-3 + .col-xl-3 {
    padding-right: 12px;
  }
  .box-layout .page-wrapper .email-wrap .email-right-aside .email-body .inbox, .box-layout.page-wrapper .email-wrap .email-right-aside .email-body .inbox {
    height: 644px;
  }
  .box-layout .page-wrapper .email-wrap .email-content .email-top .user-emailid:after, .box-layout.page-wrapper .email-wrap .email-content .email-top .user-emailid:after {
    right: -10px;
  }
  .box-layout .page-wrapper .todo .notification-popup, .box-layout.page-wrapper .todo .notification-popup {
    right: 320px;
  }
  .box-layout .page-wrapper .touchspin, .box-layout.page-wrapper .touchspin {
    padding: 0 10px;
  }
  .box-layout .page-wrapper .vertical-menu-main, .box-layout.page-wrapper .vertical-menu-main {
    width: 1280px;
    margin: 0 auto;
    left: 0;
    right: 0;
  }
  .box-layout .page-wrapper .vertical-menu-main .mega-menu, .box-layout.page-wrapper .vertical-menu-main .mega-menu {
    width: 1050px !important;
    max-width: 1050px !important;
    left: -320px !important;
  }
  .box-layout .page-wrapper .comingsoon video, .box-layout.page-wrapper .comingsoon video {
    min-width: 67%;
    width: 67%;
  }
}

/**=====================
    63. Box-layout CSS ends
==========================**/
/* ---------------------
	*** themes **
-----------------------*/
/**=====================
55. theme layout CSS Start
==========================**/
body.dark-only {
  color: rgba(255, 255, 255, 0.6);
  background-color: #1d1e26;
}
body.dark-only .page-body .bg-light {
  background-color: #1d1e26 !important;
}
body.dark-only .edit-profile .card .card-body form .row a h5, body.dark-only .edit-profile .card .card-body form .row a .h5 {
  color: rgba(255, 255, 255, 0.7);
}
body.dark-only .wizard-4 .step-container {
  background-color: #262932;
  border-color: #374558;
}
body.dark-only .wizard-4 .login-card .login-main {
  background-color: #1d1e26;
}
body.dark-only .icon-state .switch-state:after {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .kanban-board-header {
  background-color: #1d1e26 !important;
  border-bottom: 1px solid #262932 !important;
}
body.dark-only .kanban-container .kanban-item .kanban-box {
  border: 1px solid rgba(115, 102, 255, 0.15);
  background-color: #1d1e26;
}
body.dark-only .editor-toolbar {
  border-top: 1px solid #374558;
  border-left: 1px solid #374558;
  border-right: 1px solid #374558;
}
body.dark-only .editor-toolbar a {
  color: rgba(255, 255, 255, 0.6) !important;
}
body.dark-only .editor-toolbar a:hover, body.dark-only .editor-toolbar a.active {
  background: #374558;
}
body.dark-only .editor-toolbar i.separator {
  border-left: 1px solid #374558;
  border-right: 1px solid #374558;
}
body.dark-only .editor-toolbar button {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .editor-toolbar button:hover, body.dark-only .editor-toolbar button:focus, body.dark-only .editor-toolbar button.active {
  background: #1d1e26;
  border-color: #374558 #374558;
}
body.dark-only .editor-toolbar.fullscreen::before, body.dark-only .editor-toolbar.fullscreen::after {
  background: linear-gradient(to right, #1d1e26 0, #1d1e26 100%);
}
body.dark-only .editor-toolbar.disabled-for-preview a:not(.no-disable) {
  background: #374558;
}
body.dark-only .editor-preview {
  background-color: #262932;
}
body.dark-only .editor-toolbar.fullscreen,
body.dark-only .editor-preview-side {
  background: #262932;
  border: 1px solid #98a6ad;
}
body.dark-only .editor-toolbar.disabled-for-preview a:not(.no-disable) {
  background: #374558;
}
body.dark-only .editor-preview {
  background-color: #262932;
}
body.dark-only .editor-toolbar.fullscreen,
body.dark-only .editor-preview-side {
  background: #262932;
  border: 1px solid #98a6ad;
}
body.dark-only .knowledgebase-search {
  color: #2f2f3b;
}
body.dark-only .knowledgebase-search .form-inline .form-control {
  background: transparent !important;
  border-color: transparent !important;
}
body.dark-only .support-table .progress {
  background: #1d1e26;
}
body.dark-only .jkanban-container .kanban-container .kanban-drag > div > div .react-kanban-column > div[data-rbd-drag-handle-context-id="0"], body.dark-only .jkanban-container .kanban-container .kanban-drag > div > div .react-kanban-column > div[data-rbd-drag-handle-context-id="2"] {
  border-bottom: 1px solid #374558;
}
body.dark-only .jkanban-container .kanban-container .kanban-drag > div > div .react-kanban-column > div[data-rbd-drag-handle-context-id="0"], body.dark-only .jkanban-container .kanban-container .kanban-drag > div > div .react-kanban-column > div[data-rbd-drag-handle-context-id="2"] {
  border-bottom: 1px solid #374558;
}
body.dark-only .jkanban-container .kanban-container .kanban-drag > div > div .react-kanban-column {
  background-color: #1d1e26;
}
body.dark-only .react-kanban-column {
  background-color: #1d1e26;
}
body.dark-only .react-kanban-column .react-kanban-card {
  background-color: #262932;
}
body.dark-only .react-kanban-column .react-kanban-card .react-kanban-card__title {
  border-bottom: 1px solid #374558;
}
body.dark-only .jkanban-container .kanban-container .kanban-item .kanban-box {
  background-color: #262932 !important;
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .jkanban-container .kanban-container .kanban-item .kanban-box {
  background-color: #262932 !important;
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .jkanban-container .kanban-container .kanban-item .kanban-box {
  background-color: #262932 !important;
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .kanban-container .kanban-item .kanban-box {
  background-color: #262932;
}
body.dark-only .jkanban-container .kanban-container .kanban-item .kanban-box {
  border: 1px solid #374558;
}
body.dark-only .rdt_TableRow:nth-of-type(odd) {
  color: rgba(255, 255, 255, 0.6);
  background-color: #1d1e26;
}
body.dark-only .rdt_TableRow:nth-of-type(even) {
  color: rgba(255, 255, 255, 0.6);
  background-color: #262932;
}
body.dark-only .rdt_TableRow:hover {
  border-color: #262932 !important;
}
body.dark-only .product-table .rdt_TableBody .rdt_TableRow .rdt_TableCell {
  color: #242934;
}
body.dark-only .product-table .rdt_TableBody .rdt_TableRow .rdt_TableCell:first-child {
  background-color: #1d1e26;
}
body.dark-only .product-table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(n+2) {
  background-color: #262932;
}
body.dark-only .product-table .rdt_TableBody .rdt_TableRow:nth-child(odd) .rdt_TableCell:first-child {
  background-color: #262932;
}
body.dark-only .product-table .rdt_TableBody .rdt_TableRow:nth-child(odd) .rdt_TableCell:nth-child(n+2) {
  background-color: #1d1e26;
}
body.dark-only .product-table .rdt_TableBody .rdt_TableRow .rdt_TableCell:first-child {
  background-color: #1d1e26;
}
body.dark-only .product-table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(n+2) {
  background-color: #262932;
}
body.dark-only .product-table .rdt_TableBody .rdt_TableRow:nth-child(odd) .rdt_TableCell:first-child {
  background-color: #262932;
}
body.dark-only .product-table .rdt_TableBody .rdt_TableRow:nth-child(odd) .rdt_TableCell:nth-child(n+2) {
  background-color: #1d1e26;
}
body.dark-only .social-widget .social-icons {
  box-shadow: 0px 42.1092px 27.8569px #1d1e26, 0px 8.90772px 7.12618px #1d1e26, 0px 2.02448px 3.44162px #1d1e26;
}
body.dark-only .calendar-basic .md-sidebar-aside {
  background: #262932;
}
body.dark-only .calendar-basic #external-events {
  border-color: #374558;
}
body.dark-only .calendar-basic .calendar-default .fc .fc-daygrid-day-number,
body.dark-only .calendar-basic .calendar-default .fc .fc-col-header-cell-cushion {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .clockpicker-popover .popover-title {
  background-color: #262932;
}
body.dark-only .clockpicker-popover.bottom > .arrow {
  border-bottom-color: #1d1e26;
}
body.dark-only .clockpicker-popover.bottom > .arrow:after {
  border-bottom-color: #262932;
}
body.dark-only .clockpicker-popover.top > .arrow {
  border-top-color: #1d1e26;
}
body.dark-only .clockpicker-popover.top > .arrow::after {
  border-top-color: #262932;
}
body.dark-only .clockpicker-popover.left > .arrow {
  border-left-color: #1d1e26;
}
body.dark-only .clockpicker-popover.left > .arrow::after {
  border-left-color: #262932;
}
body.dark-only .clockpicker-popover .popover-title {
  border-bottom-color: #262932;
}
body.dark-only .fc-theme-standard .fc-scrollgrid,
body.dark-only .fc-theme-standard .fc-list {
  border-color: #374558;
}
body.dark-only .fc-theme-standard .fc-list-day-cushion {
  background-color: #1d1e26;
}
body.dark-only .fc .fc-list-event:hover td {
  background-color: #1d1e26;
}
body.dark-only .view-container .apexcharts-canvas .apexcharts-point-annotations circle {
  outline: 25px solid rgba(62, 61, 114, 0.3490196078);
}
body.dark-only .vertical-timeline-element-content {
  background-color: #1d1e26;
}
body.dark-only .vertical-timeline-element-content .vertical-timeline-element-content-arrow {
  border-right: 7px solid #1d1e26;
}
body.dark-only .vertical-timeline::before {
  background: #1d1e26;
}
body.dark-only .vertical-timeline-element-icon {
  box-shadow: 0 0 0 4px #1d1e26, inset 0 2px 0 rgba(0, 0, 0, 0.08), 0 3px 0 4px rgba(0, 0, 0, 0.05);
}
body.dark-only .currency-widget div[class*=bg-light-] {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .btn.badge-light-primary:hover {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .portfolio-chart-container .apexcharts-canvas .apexcharts-radialbar image {
  display: none;
}
body.dark-only svg.f-light {
  fill: rgba(255, 255, 255, 0.6);
  opacity: 1;
}
body.dark-only .course-widget .btn-light {
  background-color: #1d1e26 !important;
}
body.dark-only .schedule-list > li {
  box-shadow: 4px 7px 17px 5px rgba(29, 30, 38, 0.2);
}
body.dark-only .upcoming-event-wrap .apexcharts-canvas .apexcharts-data-labels rect {
  fill: none;
  stroke: none;
}
body.dark-only .page-wrapper.advance-layout .page-header {
  background: #262932;
}
body.dark-only .page-wrapper.advance-layout .page-body-wrapper .sidebar-wrapper {
  border-bottom: 1px solid #374558;
}
body.dark-only .page-wrapper.only-body {
  background: #1d1e26;
}
body.dark-only .balance-card .svg-box {
  background: #262932;
  box-shadow: none;
}
body.dark-only .balance-card .svg-box svg {
  fill: rgba(255, 255, 255, 0.6);
}
body.dark-only .f-light {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .apexcharts-tooltip.light .apexcharts-tooltip-title {
  background: #262932;
  color: #fff;
}
body.dark-only .card {
  background-color: #262932;
}
body.dark-only .ecommerce-widget {
  border: 1px solid #374558 !important;
}
body.dark-only .btn-light {
  color: rgba(255, 255, 255, 0.6) !important;
}
body.dark-only .form-select {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .add-project .text-inherit {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .knowledgebase-search {
  color: #2f2f3b;
}
body.dark-only .knowledgebase-search .form-control-plaintext {
  color: #2f2f3b;
}
body.dark-only .btn-close {
  filter: brightness(0.8) invert(1);
}
body.dark-only .prooduct-details-box .media {
  border: 1px solid #374558;
}
body.dark-only .product-price del {
  color: #98a6ad;
}
body.dark-only .ProfileCard {
  border: 1px solid #374558 !important;
}
body.dark-only .form-control-plaintext {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .form-select {
  background-color: #1d1e26;
  border: 1px solid #1d1e26;
}
body.dark-only .box-layout {
  background-color: #1d1e26;
}
body.dark-only .box-layout .page-wrapper .page-header .header-wrapper, body.dark-only .box-layout.page-wrapper .page-header .header-wrapper {
  border: 1px solid #1d1e26;
}
body.dark-only .form-check-input {
  background-color: #1d1e26;
}
body.dark-only .switch-state:before {
  background-color: #262932;
}
body.dark-only .rdt_Table {
  border: 1px solid #374558;
}
body.dark-only .rdt_TableHeadRow {
  background-color: #262932;
}
body.dark-only .rdt_TableCol,
body.dark-only .rdt_TableCol_Sortable,
body.dark-only .___react-data-table-allow-propagation___ {
  color: rgba(255, 255, 255, 0.6);
}
border body.dark-only .rdt_TableRow:nth-of-type(odd) {
  color: rgba(255, 255, 255, 0.6);
  background-color: #1d1e26;
}
body.dark-only .rdt_TableRow:nth-of-type(even) {
  color: rgba(255, 255, 255, 0.6);
  background-color: #262932;
}
body.dark-only .fpZHHx {
  fill: rgba(255, 255, 255, 0.6);
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .rdt_Pagination {
  background-color: #262932;
  border-top-color: #374558;
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .rdt_Pagination button {
  color: rgba(255, 255, 255, 0.6);
  fill: rgba(255, 255, 255, 0.6);
}
body.dark-only .rdt_Pagination button:disabled {
  color: #98a6ad;
  fill: #98a6ad;
}
body.dark-only .rdt_TableCol_Sortable:hover {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .rdt_TableHeader {
  background-color: #1d1e26 !important;
}
body.dark-only .rdt_TableHeader > div:last-child {
  background-color: #1d1e26 !important;
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .daterangepicker:before {
  border-bottom-color: #262932;
}
body.dark-only .daterangepicker .ranges li {
  background-color: #1d1e26;
  border-color: #262932;
  color: #898989;
}
body.dark-only .daterangepicker .daterangepicker_input .form-control {
  background-color: #1d1e26;
  border-color: #262932 !important;
}
body.dark-only .daterangepicker .calendar-time select {
  border-color: #262932;
  background-color: #1d1e26;
}
body.dark-only .daterangepicker.dropdown-menu {
  background-color: #262932;
  box-shadow: 0 0 14px #1d1e26;
}
body.dark-only .daterangepicker .calendar-table {
  background-color: #262932;
  border-color: #262932;
}
body.dark-only .daterangepicker.ltr td.in-range, body.dark-only .daterangepicker.ltr td.off {
  background-color: #1d1e26;
  color: #fff;
}
body.dark-only .tooltip.bs-tooltip-top .tooltip-arrow:before, body.dark-only .tooltip.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow:before {
  border-top-color: #323846;
}
body.dark-only .tooltip.bs-tooltip-bottom .tooltip-arrow:before, body.dark-only .tooltip.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow:before {
  border-bottom-color: #323846;
  border-top-color: transparent;
}
body.dark-only .tooltip.bs-tooltip-start .tooltip-arrow:before, body.dark-only .tooltip.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow:before {
  border-left-color: #323846;
  border-top-color: transparent;
}
body.dark-only .tooltip.bs-tooltip-end .tooltip-arrow:before, body.dark-only .tooltip.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow:before {
  border-right-color: #323846;
  border-top-color: transparent;
}
body.dark-only .tooltip .tooltip-inner {
  background-color: #323846;
  color: #fff;
}
body.dark-only .tooltip .tooltip-arrow:before {
  border-top-color: #323846;
}
body.dark-only .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {
  background-color: #262932;
}
body.dark-only .react-datepicker .react-datepicker__time-container {
  border-left: 1px solid #374558;
}
body.dark-only .react-datepicker__time-container .react-datepicker__time {
  background: #1d1e26;
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .react-datepicker {
  background-color: #262932;
}
body.dark-only .react-datepicker .react-datepicker__header {
  background-color: #262932 !important;
  border-bottom: 1px solid #374558;
}
body.dark-only .react-datepicker .react-datepicker__day-name,
body.dark-only .react-datepicker .react-datepicker__day,
body.dark-only .react-datepicker .react-datepicker__time-name {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .react-datepicker .react-datepicker__day:hover,
body.dark-only .react-datepicker .react-datepicker__month-text:hover,
body.dark-only .react-datepicker .react-datepicker__quarter-text:hover,
body.dark-only .react-datepicker .react-datepicker__year-text:hover {
  background-color: #262932;
}
body.dark-only .default-datepicker .react-datepicker .react-datepicker__month,
body.dark-only .default-datepicker .react-datepicker .react-datepicker__header {
  background-color: #262932 !important;
}
body.dark-only .default-datepicker .react-datepicker {
  background: transparent;
}
body.dark-only .default-datepicker .react-datepicker__day-name,
body.dark-only .default-datepicker .react-datepicker__day,
body.dark-only .default-datepicker .react-datepicker__time-name {
  color: rgba(255, 255, 255, 0.7);
}
body.dark-only .default-datepicker .react-datepicker__day--outside-month {
  color: #98a6ad;
}
body.dark-only .default-datepicker .react-datepicker__header {
  border-bottom: 1px solid #374558;
}
body.dark-only .default-datepicker .react-datepicker__day:hover,
body.dark-only .default-datepicker .react-datepicker__month-text:hover,
body.dark-only .default-datepicker .react-datepicker__quarter-text:hover,
body.dark-only .default-datepicker .react-datepicker__year-text:hover {
  background-color: #1d1e26;
}
body.dark-only .draggable-card > div > div div[data-testid=lane] {
  background-color: #1d1e26;
}
body.dark-only .draggable-card > div > div div[data-testid=card] > div > div {
  background-color: #262932;
}
body.dark-only .draggable-card > div > div div[data-testid=card] > div > div span > div {
  border-bottom: 1px solid #374558;
}
body.dark-only .page-wrapper.only-body .page-body-wrapper .page-title > .row .col-6:first-child h6, body.dark-only .page-wrapper.only-body .page-body-wrapper .page-title > .row .col-6:first-child .h6 {
  color: rgba(255, 255, 255, 0.5);
}
body.dark-only .page-wrapper.only-body .page-header .header-wrapper .search-full .form-group .Typeahead .u-posRelative {
  background-color: #262932;
}
body.dark-only .page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown li span {
  color: #fff;
}
body.dark-only .page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .back {
  background-color: #1d1e26 !important;
}
body.dark-only .page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .back .flip-back-content input {
  background-color: #1d1e26;
  border: 1px solid #374558;
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .back li:last-child {
  border-top: 1px solid #374558;
}
body.dark-only .page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .front {
  background-color: #1d1e26 !important;
}
body.dark-only .page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .front svg {
  stroke: #fff;
}
body.dark-only .page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown .total {
  background-color: #262932;
}
body.dark-only .page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown .qty-box .input-group .btn {
  color: rgba(255, 255, 255, 0.4);
  border-color: #262932 !important;
  background-color: #262932 !important;
}
body.dark-only .qty-box input {
  color: rgba(255, 255, 255, 0.5);
}
body.dark-only .customizer-contain {
  color: #1d1e26;
}
body.dark-only .customizer-contain .customizer-body .main-layout .box-layout {
  background-color: #fff;
}
body.dark-only .login-card .btn-showcase .btn {
  background-color: #262932 !important;
  color: #fff;
  border-color: #262932 !important;
}
body.dark-only .login-card .login-main {
  box-shadow: 0 0 37px rgba(255, 255, 255, 0.05);
}
body.dark-only .login-card .login-main .theme-form input {
  background-color: #262932 !important;
}
body.dark-only .login-card .login-main .theme-form .or:before {
  background-color: #262932;
}
body.dark-only .login-card .login-main .theme-form .checkbox label::before {
  background-color: #262932 !important;
  border-color: #262932 !important;
}
body.dark-only .H_ui ~ div {
  background-color: #1d1e26 !important;
}
body.dark-only .swal-icon--success:after,
body.dark-only .swal-icon--success:before {
  background: #262932;
}
body.dark-only .swal-icon--success__hide-corners {
  background-color: #262932;
}
body.dark-only .note-editor.note-frame .note-status-output {
  border-top: 1px solid #262932;
}
body.dark-only .note-editor.note-frame .note-statusbar {
  border-top: 1px solid #262932;
}
body.dark-only .note-editor.note-frame .note-statusbar .note-resizebar {
  background-color: #262932;
}
body.dark-only .light-font {
  color: rgba(255, 255, 255, 0.7);
}
body.dark-only .page-link {
  background-color: #1d1e26;
  border: 1px solid #374558;
}
body.dark-only .b-r-light {
  border-right: 1px solid #374558 !important;
}
body.dark-only .history-details .media {
  border-top: 1px solid #374558;
}
body.dark-only .modal-header {
  border-bottom: 1px solid #374558;
}
body.dark-only #right-history {
  background-color: #262932;
  box-shadow: 0 0 9px #1d1e26;
}
body.dark-only #right-history h6 span a, body.dark-only #right-history .h6 span a {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .ProfileCard:hover {
  color: rgba(255, 255, 255, 0.6);
  background-color: #262932;
}
body.dark-only .translate_wrapper.active .more_lang:before {
  border-bottom: 7px solid #262932;
}
body.dark-only .translate_wrapper.active .more_lang .lang {
  border-bottom: 1px solid #1d1e26;
}
body.dark-only .toggle-sidebar svg {
  stroke: var(--theme-default);
}
body.dark-only .page-wrapper .page-body-wrapper {
  background-color: #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-title {
  background-color: #262932;
  border-bottom: 1px solid #374558;
  box-shadow: rgba(0, 0, 0, 0.07) 0px 4px 40px;
}
body.dark-only .page-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a svg.stroke-icon {
  stroke: #fff;
}
body.dark-only .page-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a svg.fill-icon {
  fill: rgba(255, 255, 255, 0.5);
  stroke: transparent;
}
body.dark-only .page-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a.active svg.stroke-icon {
  stroke: var(--theme-default);
}
body.dark-only .page-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a.active svg.fill-icon {
  fill: var(--theme-default);
  stroke: transparent;
}
body.dark-only .page-wrapper .page-body-wrapper .sidebar-main .sidebar-links .sidebar-link.active svg.stroke-icon {
  stroke: var(--theme-default);
}
body.dark-only .page-wrapper .page-body-wrapper .sidebar-main .sidebar-links li a span {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active {
  background-color: rgba(115, 102, 255, 0.2);
}
body.dark-only .page-wrapper .page-body-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title h5, body.dark-only .page-wrapper .page-body-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title .h5 {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content.opensubmegamenu li a {
  color: rgba(255, 255, 255, 0.6);
  font-weight: 400;
}
body.dark-only .page-wrapper .page-body-wrapper .sidebar-main .sidebar-links > li .mega-menu-container::after {
  background-color: rgba(255, 255, 255, 0.2);
}
body.dark-only .page-wrapper .page-body-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a.active {
  color: var(--theme-default);
}
body.dark-only .page-wrapper .page-body-wrapper .sidebar-main .sidebar-links .sidebar-list ul.sidebar-submenu li a span {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .sidebar-main .sidebar-links .sidebar-list ul.sidebar-submenu li a.active {
  color: var(--theme-default);
}
body.dark-only .page-wrapper.modern-type .page-body-wrapper .page-title {
  background-color: transparent;
  border: none;
}
body.dark-only .page-wrapper .sidebar-main-title p {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper {
  background-color: #262932;
}
body.dark-only .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-link.active svg {
  stroke: var(--theme-default);
}
body.dark-only .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a span {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active {
  background-color: rgba(115, 102, 255, 0.2);
}
body.dark-only .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title h5, body.dark-only .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title .h5 {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content.opensubmegamenu li a {
  color: rgba(255, 255, 255, 0.6);
  font-weight: 400;
}
body.dark-only .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container::after {
  background-color: rgba(255, 255, 255, 0.2);
}
body.dark-only .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a.active {
  color: var(--theme-default);
}
body.dark-only .page-wrapper.compact-wrapper .sidebar-list ul.sidebar-submenu li a span {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper.compact-wrapper .sidebar-list ul.sidebar-submenu li a.active {
  color: var(--theme-default);
}
body.dark-only .page-wrapper.compact-wrapper .sidebar-list .according-menu i {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper {
  background: #262932;
  border-top: 1px solid #374558;
}
body.dark-only .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li > a {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu {
  background: #262932;
}
body.dark-only .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a.active, body.dark-only .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a:hover {
  color: var(--theme-default);
}
body.dark-only .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li .nav-sub-childmenu {
  background: #262932;
}
body.dark-only .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container {
  background: #262932;
}
body.dark-only .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content li a {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .left-arrow,
body.dark-only .page-wrapper .right-arrow {
  background-color: #262932;
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper > div {
  background: #262932;
}
body.dark-only .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-title {
  border-bottom: 1px solid #374558;
}
body.dark-only .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a span {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a svg {
  stroke: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu,
body.dark-only .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container {
  background-color: #262932;
}
body.dark-only .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu li a,
body.dark-only .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container li a {
  border-bottom: 1px solid #374558;
}
body.dark-only .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active {
  background-color: rgba(115, 102, 255, 0.2);
}
body.dark-only .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active span {
  color: var(--theme-default);
}
body.dark-only .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active svg {
  color: var(--theme-default);
  stroke: var(--theme-default);
}
body.dark-only .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title h5, body.dark-only .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title .h5 {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content.opensubmegamenu li a {
  color: rgba(255, 255, 255, 0.6);
  font-weight: 400;
}
body.dark-only .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container::after {
  background-color: rgba(255, 255, 255, 0.2);
}
body.dark-only .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list ul.sidebar-submenu li a span {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list ul.sidebar-submenu li a.active {
  color: var(--theme-default);
}
body.dark-only .page-wrapper.compact-sidebar .page-body-wrapper .according-menu i {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper.material-type .page-header .header-wrapper {
  border-radius: 15px 15px 0 0;
}
body.dark-only .page-wrapper.material-icon .page-header .header-wrapper {
  background-color: transparent;
}
body.dark-only .page-wrapper.material-icon .page-header .header-wrapper .nav-right .language-nav .more_lang {
  color: #fff;
}
body.dark-only .page-wrapper.material-icon .page-header .header-wrapper .nav-right .onhover-show-div {
  color: #fff;
}
body.dark-only .page-wrapper.material-icon .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .back .flip-back-content input {
  border: 1px solid #1d1e26;
  background: #1d1e26;
  color: #fff;
}
body.dark-only .page-wrapper.material-icon .page-header .header-logo-wrapper {
  background-color: transparent;
}
body.dark-only .page-wrapper.material-icon .page-body-wrapper .page-body {
  background-color: transparent;
}
body.dark-only .page-wrapper.advance-layout {
  background-color: #1d1e26;
}
body.dark-only .page-wrapper.advance-layout .page-header .header-wrapper {
  background: transparent;
}
body.dark-only .page-wrapper.advance-layout .page-header .header-wrapper .header-logo-wrapper {
  background: transparent;
}
body.dark-only .page-wrapper.advance-layout .page-body-wrapper {
  background: transparent;
}
body.dark-only .page-wrapper.advance-layout .page-body-wrapper .page-body {
  background: transparent;
}
body.dark-only .page-wrapper.material-icon .page-body-wrapper .page-title {
  background-color: transparent;
  box-shadow: none;
  border: none;
}
body.dark-only .page-wrapper .page-header .header-wrapper .search-full {
  background-color: #262932;
}
body.dark-only .page-wrapper .page-header .header-wrapper .search-full input {
  color: rgba(255, 255, 255, 0.6);
}
@media only screen and (min-width: 768px) {
  body.dark-only .page-wrapper.material-icon .page-header .header-wrapper .nav-right ul li .profile-dropdown li svg {
    stroke: #fff;
  }
}
body.dark-only ::-webkit-calendar-picker-indicator {
  filter: invert(1);
}
body.dark-only .kanban-board-header {
  background-color: #1d1e26;
  border-bottom: 1px solid #262932;
}
body.dark-only .kanban-board .kanban-drag {
  background: #1d1e26;
}
body.dark-only .kanban-container .kanban-item .kanban-box {
  border: 1px solid rgba(115, 102, 255, 0.15);
  background-color: #1d1e26;
}
body.dark-only .project-box {
  border: 1px solid rgba(115, 102, 255, 0.15);
  background-color: #1d1e26;
}
body.dark-only .file-content .form-inline {
  border: 1px solid #1d1e26;
}
body.dark-only .file-content .files .file-box {
  border: 1px solid rgba(115, 102, 255, 0.15);
  background-color: #1d1e26;
}
body.dark-only .file-content .files .file-box .file-top {
  background-color: #262932;
  border: 1px solid rgba(115, 102, 255, 0.15);
}
body.dark-only .file-content .folder .folder-box {
  border: 1px solid rgba(115, 102, 255, 0.15);
  background-color: #1d1e26;
}
body.dark-only .file-sidebar .pricing-plan {
  border: 1px solid rgba(115, 102, 255, 0.15) !important;
}
body.dark-only .file-sidebar .btn-light {
  color: rgba(255, 255, 255, 0.6);
  background-color: #1d1e26 !important;
  border: 1px solid rgba(115, 102, 255, 0.15) !important;
}
body.dark-only #lnb {
  border-right: 1px solid #374558;
}
body.dark-only .lnb-new-schedule,
body.dark-only .lnb-calendars > div {
  border-bottom: 1px solid #374558;
}
body.dark-only #menu .sidebar-list .btn-default {
  color: rgba(255, 255, 255, 0.2);
}
body.dark-only .tui-full-calendar-timegrid-hour {
  background-color: #262932;
  color: #fff !important;
}
body.dark-only .tui-full-calendar-timegrid-gridline {
  border-bottom: 1px solid #374558 !important;
}
body.dark-only .tui-full-calendar-time-date,
body.dark-only .tui-full-calendar-weekday-grid-line,
body.dark-only .tui-full-calendar-left,
body.dark-only .tui-full-calendar-timegrid-timezone {
  border-right-color: #374558 !important;
}
body.dark-only .tui-full-calendar-popup {
  color: #2f2f3b;
}
body.dark-only #menu .btn-default {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only #menu .btn-default:hover {
  color: #2f2f3b;
}
body.dark-only #menu .dropdown-menu {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .tui-full-calendar-dayname-container,
body.dark-only .tui-full-calendar-splitter {
  border-top-color: #374558 !important;
  border-bottom-color: #374558 !important;
}
body.dark-only span.tui-full-calendar-dayname-date-area {
  color: #fff !important;
}
body.dark-only .tui-full-calendar-layout {
  background-color: #262932 !important;
}
body.dark-only .blockquote {
  border-left: 4px solid #374558;
}
body.dark-only .figure.text-end blockquote {
  border-right-color: #374558;
}
body.dark-only .contacts-tabs .nav-pills {
  border-right: 1px solid #374558;
}
body.dark-only .contacts-tabs .nav-pills .nav-link + .nav-link {
  border-top: 1px solid #374558;
}
body.dark-only .list-persons .profile-mail .media .media-body ul li + li {
  border-left: 2px solid #374558;
}
body.dark-only .product-wrapper.sidebaron .product-sidebar .filter-section .card .left-filter {
  background-color: #262932;
}
body.dark-only .apexcharts-gridline {
  stroke: #1d1e26;
}
body.dark-only .apexcharts-tooltip-title,
body.dark-only .apexcharts-tooltip-series-group,
body.dark-only .apexcharts-tooltip.light,
body.dark-only .apexcharts-menu-item {
  color: #000;
}
body.dark-only .small-donut ~ svg path:nth-child(even),
body.dark-only .small-donut svg path:nth-child(even),
body.dark-only .donut-peity2 ~ svg path:nth-child(even),
body.dark-only .donut-peity2 svg path:nth-child(even),
body.dark-only .pie-peity ~ svg path:nth-child(even),
body.dark-only .pie-peity svg path:nth-child(even) {
  fill: #1d1e26;
}
body.dark-only .appointment-table table tr td.img-content-box .font-roboto {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .notification .card .d-flex .w-100 p span {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .notification .card .d-flex .w-100 span {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .datepicker {
  background-color: #323846;
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .datepicker .datepicker--cell.-current- {
  color: #7366ff;
}
body.dark-only .datepicker .datepicker--cell.-current-.-focus- {
  color: #fff;
}
body.dark-only .datepicker .datepicker--cell-day.-other-month-,
body.dark-only .datepicker .datepicker--cell-year.-other-decade- {
  color: rgba(255, 255, 255, 0.4);
}
body.dark-only .datepicker .datepicker--nav {
  border-bottom: 1px solid #374558;
}
body.dark-only .datepicker .datepicker--pointer {
  background: #323846;
  border-top-color: #323846;
  border-right-color: #323846;
}
body.dark-only .default-datepicker .datepicker-inline .datepicker {
  background: #262932;
}
body.dark-only .default-datepicker .datepicker-inline .datepicker .datepicker--nav-title {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .default-datepicker .datepicker-inline .datepicker .datepicker--nav-title i {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--days-names .datepicker--day-name,
body.dark-only .default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--days-names .datepicker--cell-day,
body.dark-only .default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--cells .datepicker--day-name,
body.dark-only .default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--cells .datepicker--cell-day {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--days-names .datepicker--day-name.-selected-,
body.dark-only .default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--days-names .datepicker--cell-day.-selected-,
body.dark-only .default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--cells .datepicker--day-name.-selected-,
body.dark-only .default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--cells .datepicker--cell-day.-selected- {
  color: #fff;
}
body.dark-only [class*=activity-dot-] {
  background-color: #262932;
}
body.dark-only .page-header .header-wrapper .nav-right .profile-dropdown li:last-child {
  border-top: 1px solid #374558 !important;
}
body.dark-only .alert-primary {
  background-color: rgba(115, 102, 255, 0.8) !important;
  border-color: rgba(115, 102, 255, 0.9) !important;
  color: #fff;
}
body.dark-only .alert-primary .progress {
  height: 5px;
  background-color: rgb(43.2679738562%, 38%, 100%);
  border-radius: 0;
}
body.dark-only .alert-primary .progress-bar {
  background-color: white;
}
body.dark-only .alert-primary.inverse {
  background-color: transparent !important;
}
body.dark-only .alert-primary.inverse .btn-close {
  filter: brightness(1) invert(1);
}
body.dark-only .alert-primary.outline .btn-close,
body.dark-only .alert-primary.outline-2x .btn-close {
  filter: brightness(1) invert(1);
}
body.dark-only .dismiss-text .alert-dismissible .btn-close {
  filter: unset;
}
body.dark-only .dismiss-text .alert-dismissible .btn-close .bg-light {
  color: #2f2f3b !important;
}
body.dark-only .alert-secondary {
  background-color: rgba(255, 51, 100, 0.8) !important;
  border-color: rgba(255, 51, 100, 0.9) !important;
  color: #fff;
}
body.dark-only .alert-secondary .progress {
  height: 5px;
  background-color: rgb(100%, 18%, 37.6960784314%);
  border-radius: 0;
}
body.dark-only .alert-secondary .progress-bar {
  background-color: white;
}
body.dark-only .alert-secondary.inverse {
  background-color: transparent !important;
}
body.dark-only .alert-secondary.inverse .btn-close {
  filter: brightness(1) invert(1);
}
body.dark-only .alert-secondary.outline .btn-close,
body.dark-only .alert-secondary.outline-2x .btn-close {
  filter: brightness(1) invert(1);
}
body.dark-only .dismiss-text .alert-dismissible .btn-close {
  filter: unset;
}
body.dark-only .dismiss-text .alert-dismissible .btn-close .bg-light {
  color: #2f2f3b !important;
}
body.dark-only .alert-success {
  background-color: rgba(84, 186, 74, 0.8) !important;
  border-color: rgba(84, 186, 74, 0.9) !important;
  color: #fff;
}
body.dark-only .alert-success .progress {
  height: 5px;
  background-color: rgb(31.5876078431%, 72.3716078431%, 27.5891764706%);
  border-radius: 0;
}
body.dark-only .alert-success .progress-bar {
  background-color: white;
}
body.dark-only .alert-success.inverse {
  background-color: transparent !important;
}
body.dark-only .alert-success.inverse .btn-close {
  filter: brightness(1) invert(1);
}
body.dark-only .alert-success.outline .btn-close,
body.dark-only .alert-success.outline-2x .btn-close {
  filter: brightness(1) invert(1);
}
body.dark-only .dismiss-text .alert-dismissible .btn-close {
  filter: unset;
}
body.dark-only .dismiss-text .alert-dismissible .btn-close .bg-light {
  color: #2f2f3b !important;
}
body.dark-only .alert-danger {
  background-color: rgba(252, 68, 56, 0.8) !important;
  border-color: rgba(252, 68, 56, 0.9) !important;
  color: #fff;
}
body.dark-only .alert-danger .progress {
  height: 5px;
  background-color: rgb(98.7938264415%, 24.8151815182%, 19.990487284%);
  border-radius: 0;
}
body.dark-only .alert-danger .progress-bar {
  background-color: white;
}
body.dark-only .alert-danger.inverse {
  background-color: transparent !important;
}
body.dark-only .alert-danger.inverse .btn-close {
  filter: brightness(1) invert(1);
}
body.dark-only .alert-danger.outline .btn-close,
body.dark-only .alert-danger.outline-2x .btn-close {
  filter: brightness(1) invert(1);
}
body.dark-only .dismiss-text .alert-dismissible .btn-close {
  filter: unset;
}
body.dark-only .dismiss-text .alert-dismissible .btn-close .bg-light {
  color: #2f2f3b !important;
}
body.dark-only .alert-warning {
  background-color: rgba(255, 170, 5, 0.8) !important;
  border-color: rgba(255, 170, 5, 0.9) !important;
  color: #fff;
}
body.dark-only .alert-warning .progress {
  height: 5px;
  background-color: rgb(99.9607843137%, 65.9741176471%, 0%);
  border-radius: 0;
}
body.dark-only .alert-warning .progress-bar {
  background-color: white;
}
body.dark-only .alert-warning.inverse {
  background-color: transparent !important;
}
body.dark-only .alert-warning.inverse .btn-close {
  filter: brightness(1) invert(1);
}
body.dark-only .alert-warning.outline .btn-close,
body.dark-only .alert-warning.outline-2x .btn-close {
  filter: brightness(1) invert(1);
}
body.dark-only .dismiss-text .alert-dismissible .btn-close {
  filter: unset;
}
body.dark-only .dismiss-text .alert-dismissible .btn-close .bg-light {
  color: #2f2f3b !important;
}
body.dark-only .alert-info {
  background-color: rgba(22, 199, 249, 0.8) !important;
  border-color: rgba(22, 199, 249, 0.9) !important;
  color: #fff;
}
body.dark-only .alert-info .progress {
  height: 5px;
  background-color: rgb(6.6776601854%, 77.5705964394%, 97.5968496185%);
  border-radius: 0;
}
body.dark-only .alert-info .progress-bar {
  background-color: white;
}
body.dark-only .alert-info.inverse {
  background-color: transparent !important;
}
body.dark-only .alert-info.inverse .btn-close {
  filter: brightness(1) invert(1);
}
body.dark-only .alert-info.outline .btn-close,
body.dark-only .alert-info.outline-2x .btn-close {
  filter: brightness(1) invert(1);
}
body.dark-only .dismiss-text .alert-dismissible .btn-close {
  filter: unset;
}
body.dark-only .dismiss-text .alert-dismissible .btn-close .bg-light {
  color: #2f2f3b !important;
}
body.dark-only .alert-light {
  background-color: rgba(244, 244, 244, 0.8) !important;
  border-color: rgba(244, 244, 244, 0.9) !important;
  color: #fff;
}
body.dark-only .alert-light .progress {
  height: 5px;
  background-color: rgb(94.6862745098%, 94.6862745098%, 94.6862745098%);
  border-radius: 0;
}
body.dark-only .alert-light .progress-bar {
  background-color: white;
}
body.dark-only .alert-light.inverse {
  background-color: transparent !important;
}
body.dark-only .alert-light.inverse .btn-close {
  filter: brightness(1) invert(1);
}
body.dark-only .alert-light.outline .btn-close,
body.dark-only .alert-light.outline-2x .btn-close {
  filter: brightness(1) invert(1);
}
body.dark-only .dismiss-text .alert-dismissible .btn-close {
  filter: unset;
}
body.dark-only .dismiss-text .alert-dismissible .btn-close .bg-light {
  color: #2f2f3b !important;
}
body.dark-only .alert-dark {
  background-color: rgba(44, 50, 63, 0.8) !important;
  border-color: rgba(44, 50, 63, 0.9) !important;
  color: #fff;
}
body.dark-only .alert-dark .progress {
  height: 5px;
  background-color: rgb(16.4324720542%, 18.673263698%, 23.5283122595%);
  border-radius: 0;
}
body.dark-only .alert-dark .progress-bar {
  background-color: rgb(65.82737768%, 69.0819131391%, 76.1334066337%);
}
body.dark-only .alert-dark.inverse {
  background-color: transparent !important;
}
body.dark-only .alert-dark.inverse .btn-close {
  filter: brightness(1) invert(1);
}
body.dark-only .alert-dark.outline .btn-close,
body.dark-only .alert-dark.outline-2x .btn-close {
  filter: brightness(1) invert(1);
}
body.dark-only .dismiss-text .alert-dismissible .btn-close {
  filter: unset;
}
body.dark-only .dismiss-text .alert-dismissible .btn-close .bg-light {
  color: #2f2f3b !important;
}
body.dark-only .options > div {
  border: 1px solid #374558;
}
body.dark-only .was-validated .custom-control-input:invalid ~ .custom-control-label::before {
  background-color: #1d1e26;
}
body.dark-only .pricing-simple {
  box-shadow: 1px 1px 2px 1px #1d1e26 !important;
}
body.dark-only .pricing-block {
  box-shadow: 0 0 10px 5px rgba(115, 102, 255, 0.05) !important;
}
body.dark-only .search-page ul.search-info li + li {
  border-left: 1px solid #1d1e26;
}
body.dark-only .browse .browse-articles h6, body.dark-only .browse .browse-articles .h6 {
  border-bottom: 1px solid #1d1e26;
}
body.dark-only .job-search .job-description .theme-form .row div[class^=col-] .input-group .datepicker-here {
  border: 1px solid #1d1e26;
}
body.dark-only .calendar-wrap .fc-unthemed td,
body.dark-only .calendar-wrap .fc-unthemed th {
  border-color: #1d1e26;
}
body.dark-only .mega-inline .card,
body.dark-only .mega-horizontal .card,
body.dark-only .mega-vertical .card {
  box-shadow: 1px 1px 7px 0 rgba(55, 69, 88, 0.5) !important;
}
body.dark-only .mega-inline.plain-style .card, body.dark-only .mega-inline.border-style .card, body.dark-only .mega-inline.offer-style .card,
body.dark-only .mega-horizontal.plain-style .card,
body.dark-only .mega-horizontal.border-style .card,
body.dark-only .mega-horizontal.offer-style .card,
body.dark-only .mega-vertical.plain-style .card,
body.dark-only .mega-vertical.border-style .card,
body.dark-only .mega-vertical.offer-style .card {
  box-shadow: none !important;
}
body.dark-only .mega-inline.border-style .card,
body.dark-only .mega-horizontal.border-style .card,
body.dark-only .mega-vertical.border-style .card {
  border: 1px solid #374558 !important;
}
body.dark-only .mega-inline.offer-style .card,
body.dark-only .mega-horizontal.offer-style .card,
body.dark-only .mega-vertical.offer-style .card {
  border: 1px dashed #374558 !important;
}
body.dark-only .setting-dot .setting-bg {
  background-color: var(--theme-secondary);
}
body.dark-only .bookmark.pull-right {
  border: none;
}
body.dark-only .popover.bs-popover-bottom .popover-arrow:after, body.dark-only .popover.bs-popover-auto[data-popper-placement^=bottom] .popover-arrow:after {
  border-bottom-color: #1d1e26;
  border-right-color: transparent;
}
body.dark-only .popover.bs-popover-top .popover-arrow:after, body.dark-only .popover.bs-popover-auto[data-popper-placement^=top] .popover-arrow:after {
  border-right-color: transparent;
  border-top-color: #1d1e26;
}
body.dark-only .popover.bs-popover-start .popover-arrow:after, body.dark-only .popover.bs-popover-auto[data-popper-placement^=left] .popover-arrow:after {
  border-left-color: #1d1e26;
}
body.dark-only .popover {
  background-color: #1d1e26;
}
body.dark-only .popover .popover-header {
  background-color: #262932;
}
body.dark-only .popover .popover-arrow:after {
  border-right-color: #1d1e26;
}
body.dark-only .popover .popover-body {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .popover code {
  background-color: unset;
}
body.dark-only .apex-chart-container .apexcharts-legend .apexcharts-legend-series span {
  color: rgba(255, 255, 255, 0.6) !important;
}
body.dark-only .apexcharts-canvas svg .apexcharts-title-text {
  fill: #fff;
}
body.dark-only .apexcharts-canvas svg .apexcharts-subtitle-text {
  fill: #fff;
}
body.dark-only .apexcharts-canvas svg .apexcharts-yaxis .apexcharts-yaxis-texts-g .apexcharts-yaxis-label {
  fill: #fff;
}
body.dark-only .apexcharts-canvas svg .apexcharts-xaxis .apexcharts-xaxis-texts-g .apexcharts-xaxis-label {
  fill: #fff;
}
body.dark-only .apexcharts-canvas svg .apexcharts-legend-series span {
  color: rgba(255, 255, 255, 0.6) !important;
}
body.dark-only .apexcharts-canvas svg .apexcharts-datalabels-group .apexcharts-datalabel-label {
  fill: #fff;
}
body.dark-only .apexcharts-canvas svg .apexcharts-datalabels-group .apexcharts-datalabel-value {
  fill: #fff;
}
body.dark-only .Typeahead-menu {
  background-color: #1d1e26;
}
body.dark-only .ecommerce-widget {
  border: 1px solid #1d1e26;
}
body.dark-only .bookmark ul li .search-form .form-control-search input {
  background-color: #1d1e26;
  border: 1px solid #1d1e26;
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .bookmark ul li .search-form .form-control-search:before {
  background: #1d1e26;
}
body.dark-only .cart .qty-box .input-group .btn {
  background-color: #2e3648 !important;
  border-color: #374558 !important;
}
body.dark-only .checkout .checkout-details {
  background-color: #1d1e26;
  border: 1px solid #1d1e26;
  padding: 40px;
}
body.dark-only .checkout .checkout-details .animate-chk .radio_animated:after {
  border: 2px solid #262932;
}
body.dark-only .order-box .title-box {
  color: #bfc2c6;
  border-bottom: 1px solid #1d1e26;
}
body.dark-only .order-box .qty li {
  color: #bfc2c6;
}
body.dark-only .order-box .qty li span {
  color: #bfc2c6;
}
body.dark-only .order-box .qty {
  border-bottom: 1px solid #1d1e26;
}
body.dark-only .order-box .sub-total li {
  color: #bfc2c6;
}
body.dark-only .order-box .total li {
  color: #bfc2c6;
}
body.dark-only .shopping-checkout-option .checkbox_animated:after {
  border: 2px solid #262932;
}
body.dark-only .animate-chk .radio_animated:after {
  border: 2px solid #1d1e26;
}
body.dark-only .custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: rgba(41, 50, 64, 0.52);
}
body.dark-only .product-box .product-img .product-hover ul li .btn {
  color: #98a6ad;
}
body.dark-only .product-box .product-img .product-hover ul li:hover .btn {
  color: #fff;
}
body.dark-only .radio_animated:after,
body.dark-only .checkbox_animated:after {
  background: #1d1e26;
  border: 2px solid #1d1e26;
}
body.dark-only .slider-product {
  border-top: 1px solid #1d1e26;
  border-bottom: 1px solid #1d1e26;
}
body.dark-only .square-product-setting .icon-grid {
  background-color: #262932;
}
body.dark-only .square-product-setting .icon-grid svg {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .active-order-table table thead tr th,
body.dark-only .market-table table thead tr th {
  border-top: none !important;
}
body.dark-only .active-order-table table tbody tr td,
body.dark-only .market-table table tbody tr td {
  border-bottom: 1px solid #1d1e26;
}
body.dark-only .active-order-table table tbody tr:last-child td,
body.dark-only .market-table table tbody tr:last-child td {
  border-bottom: none;
}
body.dark-only .pricing-card-design-2 .pricing-block .pricing-inner ul li {
  border-bottom: 1px solid #1d1e26;
}
body.dark-only .flot-chart-container .legend .table tbody {
  background-color: #262932;
  color: #fff;
}
body.dark-only .flot-chart-container .legend .table tbody .legendLabel {
  padding-left: 5px;
}
body.dark-only .google-visualization-tooltip text {
  fill: rgba(0, 0, 0, 0.7) !important;
}
body.dark-only .nav-dark .nav-link,
body.dark-only .nav-pills.nav-dark .nav-link {
  color: #fff;
}
body.dark-only .loader-wrapper {
  background-color: #1d1e26;
}
body.dark-only .loader-wrapper .loader {
  background-color: #1d1e26 !important;
}
body.dark-only .page-wrapper .sidebar-main-title h6, body.dark-only .page-wrapper .sidebar-main-title .h6 {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper {
  /* Main Header start */
}
body.dark-only .page-wrapper .page-header .translate_wrapper.active .more_lang {
  background-color: #1d1e26;
}
body.dark-only .page-wrapper .page-header .translate_wrapper.active .lang {
  background-color: #262932;
}
body.dark-only .page-wrapper .page-header form {
  background-color: #1d1e26;
}
body.dark-only .page-wrapper .page-header .header-wrapper {
  background-color: #262932;
}
body.dark-only .page-wrapper .page-header .header-wrapper li i {
  color: #f4f4f4;
}
body.dark-only .page-wrapper .page-header .header-wrapper .nav-right > ul > li svg {
  stroke: #fff;
}
body.dark-only .page-wrapper .page-header .header-wrapper .nav-right.right-header > ul > li .profile-media .media-body p {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-header .header-wrapper .nav-right .nav-menus li .media .media-body .txt-dark {
  color: rgba(255, 255, 255, 0.6) !important;
}
body.dark-only .page-wrapper .page-header .header-wrapper .nav-right .nav-menus li .onhover-show-div {
  background-color: #1d1e26;
  box-shadow: 0 0 14px #1d1e26;
}
body.dark-only .page-wrapper .page-header .header-wrapper .nav-right .nav-menus li .onhover-show-div li {
  border-color: #262932;
}
body.dark-only .page-wrapper .page-header .header-wrapper .nav-right .nav-menus li .onhover-show-div p {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-header .header-wrapper .nav-right .nav-menus li .onhover-show-div:before {
  border-bottom: 7px solid #1d1e26;
}
body.dark-only .page-wrapper .page-header .header-wrapper .nav-right .nav-menus li .onhover-show-div:after {
  border-bottom: 7px solid #1d1e26;
}
body.dark-only .page-wrapper .page-header .header-wrapper .nav-right .nav-menus li .notification-dropdown.onhover-show-div li {
  background-color: #262932;
}
body.dark-only .page-wrapper .page-header .header-wrapper .nav-right .nav-menus li .notification-dropdown.onhover-show-div li span {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-header .header-wrapper .nav-right .nav-menus li .notification-dropdown.onhover-show-div .bg-light {
  background-color: #282e38 !important;
  color: rgba(255, 255, 255, 0.6) !important;
}
body.dark-only .page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown li a {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown li a svg path,
body.dark-only .page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown li a svg line,
body.dark-only .page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown li a svg circle {
  color: rgba(255, 255, 255, 0.6) !important;
}
body.dark-only .page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown li a:hover {
  color: var(--theme-default);
}
body.dark-only .page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown li a:hover svg line,
body.dark-only .page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown li a:hover svg path,
body.dark-only .page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown li a:hover svg circle {
  color: var(--theme-default) !important;
}
body.dark-only .page-wrapper .page-header .header-wrapper .nav-right > ul > li .media .media-body .txt-dark {
  color: rgba(255, 255, 255, 0.6) !important;
}
body.dark-only .page-wrapper .page-header .header-wrapper .nav-right > ul > li .onhover-show-div {
  background-color: #1d1e26;
  box-shadow: 0 0 2px 2px #262932;
}
body.dark-only .page-wrapper .page-header .header-wrapper .nav-right > ul > li .onhover-show-div:before {
  border-bottom: 7px solid #1d1e26;
}
body.dark-only .page-wrapper .page-header .header-wrapper .nav-right > ul > li .onhover-show-div:after {
  border-bottom: 7px solid #1d1e26;
}
body.dark-only .page-wrapper .page-header .header-wrapper .nav-right > ul > li .notification-dropdown.onhover-show-div li {
  border-color: #262932;
}
body.dark-only .page-wrapper .page-header .header-wrapper .nav-right > ul > li .notification-dropdown.onhover-show-div li span {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-header .header-wrapper .nav-right .bookmark-flip .bookmark-dropdown .bookmark-content .bookmark-icon {
  background-color: #262932;
}
body.dark-only .page-wrapper .page-header .header-logo-wrapper {
  background-color: #262932;
}
body.dark-only .page-wrapper .page-header .header-logo-wrapper .logo-wrapper a .image-dark {
  display: none;
}
body.dark-only .page-wrapper .page-header .header-logo-wrapper .logo-wrapper a .image-light {
  display: block;
}
body.dark-only .page-wrapper {
  /* Main Header ends */
}
body.dark-only .page-wrapper .page-body-wrapper {
  /* body start*/
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .topper-lists table tbody tr td p {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .header-small {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .statistics p {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .feather-main .media-body p,
body.dark-only .page-wrapper .page-body-wrapper .page-body .feather-main .professor-block p,
body.dark-only .page-wrapper .page-body-wrapper .page-body .professor-table .media-body p,
body.dark-only .page-wrapper .page-body-wrapper .page-body .professor-table .professor-block p {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .logs-element span + span {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .progress-block .progress-title span + span {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .ecommerce-icons div span {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .new-users .media .media-body p,
body.dark-only .page-wrapper .page-body-wrapper .page-body .recent-notification .media .media-body p {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .progress-media .media .media-body span {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .progress-media .progress-change span {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .topper-lists table tbody tr td {
  border-top: none !important;
  border-bottom: 1px solid #374558;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .topper-lists table tbody tr:last-child td {
  border-bottom: none;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .notifiaction-media .media .media-body .circle-left {
  border: 5px solid #334154;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .upcoming-event .upcoming-innner {
  border-bottom: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .upcoming-event .upcoming-innner:last-child {
  border-bottom: none;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .professor-table table tbody tr td {
  border-top: none !important;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .number-widgets .media .media-body h6, body.dark-only .page-wrapper .page-body-wrapper .page-body .number-widgets .media .media-body .h6 {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .activity .media .gradient-round.gradient-line-1:after, body.dark-only .page-wrapper .page-body-wrapper .page-body .activity .media .gradient-round.small-line:after, body.dark-only .page-wrapper .page-body-wrapper .page-body .activity .media .gradient-round.medium-line:after {
  background-color: #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .activity .media .media-body h6 span, body.dark-only .page-wrapper .page-body-wrapper .page-body .activity .media .media-body .h6 span {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card.custom-card .card-header {
  border-bottom: none !important;
}
body.dark-only .page-wrapper .page-body-wrapper .custom-card .card-header img {
  background-color: #000;
  opacity: 0.8;
}
body.dark-only .page-wrapper .page-body-wrapper .page-title .row h3 small, body.dark-only .page-wrapper .page-body-wrapper .page-title .row .h3 small, body.dark-only .page-wrapper .page-body-wrapper .page-title .row h3 .small, body.dark-only .page-wrapper .page-body-wrapper .page-title .row .h3 .small {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-title .breadcrumb li {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-title .breadcrumb .breadcrumb-item a svg {
  stroke: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body {
  background-color: #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .default-according .card:not(.email-body) {
  border: none;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) {
  background-color: #262932;
  box-shadow: 1px 1px 2px 1px rgba(29, 28, 28, 0.08);
  border: 1px solid #374558;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body).widget-1 {
  background-color: #1b1d24;
  background-blend-mode: overlay;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body).widget-1 .widget-round .bg-round {
  box-shadow: 1px 2px 21px -2px rgba(14, 14, 16, 0.83);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body).widget-1 .widget-round .bg-round .half-circle {
  background: rgba(49, 53, 66, 0);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body).social-profile {
  background-blend-mode: overlay;
  background-color: #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table.table-light tr th,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table.table-light tr td {
  color: #2f2f3b;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) table thead .border-bottom-light th,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) table thead .border-bottom-light td,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) table tbody .border-bottom-light th,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) table tbody .border-bottom-light td {
  border-bottom: 1px solid #374558 !important;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body).balance-box {
  background-blend-mode: overlay;
  background-color: #16171c;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-block #bar-chart2 svg > rect {
  fill: #262932;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-block #bar-chart2 svg > g text {
  fill: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-block .word-tree svg > g > rect {
  fill: #262932;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-block .word-tree svg > g > text {
  fill: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-header {
  background-color: transparent;
  border-bottom: 1px solid #374558;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-header > span {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-header h1, body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-header .h1,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-header h2,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-header .h2,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-header h3,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-header .h3,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-header h4,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-header .h4,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-header h5,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-header .h5,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-header h6,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-header .h6 {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-header .card-header-right {
  background-color: #262932;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-header .card-header-right i {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-header .card-header-right i.fa-cog {
  color: var(--theme-default);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-header.note-toolbar {
  background-color: #262932;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .alert-dark {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .alert-dark a {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .alert-light.outline,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .alert-light.outline-2x,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .alert-light.inverse {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) #animation-box .animate-widget p {
  color: #98a6ad !important;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .grid-item img {
  background-color: #262932;
  border: 1px solid #374558;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .line {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) thead,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) tbody,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) tfoot,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) tr,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) td,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) th {
  border-color: #374558;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table th,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table td {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table thead th {
  border-bottom: 1px solid #374558;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table thead .border-bottom-primary th {
  border-bottom: 1px solid var(--theme-default);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .table-primary th,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .table-primary td,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .table-secondary th,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .table-secondary td,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .table-success th,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .table-success td,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .table-info th,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .table-info td,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .table-warning th,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .table-warning td,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .table-light th,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .table-light td,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .table-danger th,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .table-danger td {
  color: #262932;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .bg-primary,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .bg-secondary,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .bg-success,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .bg-info,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .bg-warning,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .bg-danger {
  color: #fff;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .bg-light {
  color: #000;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .thead-light th {
  color: #000;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table tbody .border-bottom-primary th,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table tbody .border-bottom-primary td {
  border-bottom: 1px solid var(--theme-default);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table[class*=bg-] th,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table[class*=bg-] td {
  color: #fff;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table-striped tbody tr:nth-of-type(odd) {
  --bs-table-accent-bg: rgba(0, 0, 0, 0.05);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table-striped tbody tr:nth-of-type(odd):hover th,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table-striped tbody tr:nth-of-type(odd):hover td {
  color: #fff;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table-double,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table-dotted,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table-dashed {
  border-left-color: #374558;
  border-right-color: #374558;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table-bordered {
  border-color: #374558 !important;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table-bordered td,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table-bordered th {
  border-color: #374558 !important;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table-inverse tbody tr:nth-of-type(odd):hover td {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table-border-vertical tr,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table-border-vertical th,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table-border-vertical td {
  border-right: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table-styling thead th,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table-styling thead td,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table-styling tbody th,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table-styling tbody td {
  color: #fff;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-footer {
  background-color: #262932;
  border-top: 1px solid #374558;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .switch .switch-state {
  background-color: #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .switch input:checked + .switch-state {
  background-color: var(--theme-default);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .bg-white {
  background-color: #fff !important;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .b-l-light {
  border-left: 1px solid #1d1e26 !important;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .ct-grid {
  stroke: #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .ct-label {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) hr {
  border-top: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .text-muted {
  color: rgba(255, 255, 255, 0.6) !important;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .btn-outline-light,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .btn-outline-dark,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .btn-outline-light-2x {
  color: #fff !important;
  border: 1px solid #374558;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .btn-outline-light:hover {
  color: #000 !important;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .border-right {
  border-right: 1px solid #1d1e26 !important;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .flot-chart-placeholder .flot-text {
  color: rgba(255, 255, 255, 0.6) !important;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .flot-chart-placeholder svg text {
  fill: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-overflow#gantt_chart svg g rect:first-child {
  fill: #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-overflow#gantt_chart rect:nth-child(6) {
  fill: #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-overflow#line-chart rect, body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-overflow#column-chart1 rect, body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-overflow#column-chart2 rect {
  fill: #262932;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-overflow svg > rect {
  fill: #262932;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-overflow svg > g > g > g text {
  fill: rgb(177, 177, 178);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-overflow svg > g > text {
  fill: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .radial-bar:after {
  background-color: #262932;
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .bar-chart-widget .bottom-content .num {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .bar-chart-widget .bottom-content .num .color-bottom {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .b-r-light {
  border-right: 1px solid #374558 !important;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-container .live-products .ct-labels .ct-label,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-container .turnover .ct-labels .ct-label,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-container .monthly .ct-labels .ct-label,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-container .uses .ct-labels .ct-label {
  color: #fff;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-container .live-products .ct-grid,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-container .turnover .ct-grid,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-container .monthly .ct-grid,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-container .uses .ct-grid {
  stroke: #fff;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-container #browser-uses-chart svg text,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-container #website-visiter-chart svg text {
  fill: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .status-details h4, body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .status-details .h4 {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .status-details h4 span, body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .status-details .h4 span {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .status-details span {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .clipboaard-container .form-control {
  background-color: #1d1e26;
  color: #98a6ad;
  border: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .img-thumbnail {
  background-color: #1d1e26;
  border: 1px solid #374558;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper button {
  color: #000;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper.no-footer .dataTables_scrollBody {
  border-bottom: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper .btn-danger,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper .btn-success,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper .btn-primary {
  color: #fff;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper .dataTables_length select {
  background-color: #1d1e26;
  color: rgba(255, 255, 255, 0.6);
  border: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper .dataTables_length,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper .dataTables_filter,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper .dataTables_info,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper .dataTables_processing,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper .dataTables_paginate {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper .dataTables_paginate {
  border: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper .dataTables_filter input[type=search] {
  background-color: #1d1e26;
  border: 1px solid #1d1e26;
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.display tbody tr,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.order-column.stripe tbody tr {
  background-color: #262932;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.display tbody tr:hover > .sorting_1,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.order-column.stripe tbody tr:hover > .sorting_1 {
  background-color: #1c212b;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.display tbody tr.odd,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.order-column.stripe tbody tr.odd {
  background-color: #1f232b;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.display tbody tr.odd > .sorting_1,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.order-column.stripe tbody tr.odd > .sorting_1 {
  background-color: #1c212b;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.display tbody tr.even > .sorting_1,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.order-column.stripe tbody tr.even > .sorting_1 {
  background-color: #22262f;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable {
  border: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable thead th,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable thead td {
  border-bottom: 2px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable input,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable select {
  background-color: #1d1e26;
  color: rgba(255, 255, 255, 0.6);
  border: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable tbody tr {
  background-color: #262932;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable tbody td.select-checkbox:before,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable tbody th.select-checkbox:before {
  border: 1px solid #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper .table-striped tbody tr:nth-of-type(odd) {
  --bs-table-accent-bg: #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper .dataTables_paginate .paginate_button {
  color: rgba(255, 255, 255, 0.6) !important;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper .dataTables_paginate .paginate_button.current, body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper .dataTables_paginate .paginate_button:active {
  border-color: var(--theme-default);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper .dataTables_paginate .paginate_button.disabled {
  color: #98a6ad !important;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper .dataTables_paginate .paginate_button.disabled:hover,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper .dataTables_paginate .paginate_button.disabled :active {
  color: #98a6ad !important;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.row-border tbody th,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.row-border tbody td,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.display tbody th,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.display tbody td {
  border-top: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.display tbody tr.even:hover > .sorting_1,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.order-column.hover tbody tr.even:hover > .sorting_1 {
  background-color: #191e27;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.hover tbody tr:hover,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.display tbody tr:hover {
  background-color: #1c212b;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.cell-border th,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.cell-border td {
  border-top: 1px solid #1d1e26;
  border-right: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.cell-border th:first-child,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.cell-border td:first-child {
  border-left: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.order-column tbody tr > .sorting_1,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.order-column tbody tr > .sorting_2,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.order-column tbody tr > .sorting_3,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.display tbody tr > .sorting_1,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.display tbody tr > .sorting_2,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.display tbody tr > .sorting_3 {
  background-color: #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) #example-style-3_wrapper #example-style-3 tfoot {
  border-top: 2px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .page-link {
  border: 1px solid #374558;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .page-item.disabled .page-link {
  background-color: #262932;
  border-color: #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .page-link {
  color: rgba(255, 255, 255, 0.6);
  background-color: #262932;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .page-item:hover .page-link {
  background-color: #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .page-item.active .page-link {
  background-color: #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .ecommerce-widget .icon {
  color: #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .ecommerce-widget .total-num {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .ecommerce-widget .total-num span {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .ecommerce-widget span {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .flot-chart-container-small {
  background-color: #262932;
  border-top: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .product-table #API-2_wrapper #API-2 tbody td span,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .product-table #API-2_wrapper #API-2 tbody td p {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .product-table h6, body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .product-table .h6 {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .border-tab.nav-tabs {
  border-bottom: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .border-tab.nav-tabs .nav-item .nav-link {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .border-tab.nav-tabs .nav-link.active, body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .border-tab.nav-tabs .nav-link:focus, body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .border-tab.nav-tabs .nav-link:hover {
  color: var(--theme-default);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-bars-1to10 .br-widget a,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-bars-movie .br-widget a,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-bars-pill .br-widget a,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-bars-reversed .br-widget a,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-bars-horizontal .br-widget a {
  background-color: #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-bars-1to10 .br-widget a.br-active, body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-bars-1to10 .br-widget a.br-selected,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-bars-movie .br-widget a.br-active,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-bars-movie .br-widget a.br-selected,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-bars-pill .br-widget a.br-active,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-bars-pill .br-widget a.br-selected,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-bars-reversed .br-widget a.br-active,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-bars-reversed .br-widget a.br-selected,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-bars-horizontal .br-widget a.br-active,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-bars-horizontal .br-widget a.br-selected {
  background-color: var(--theme-default);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-bars-square .br-widget a {
  border: 2px solid #1d1e26;
  background-color: #262932;
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-bars-square .br-widget a.br-active, body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-bars-square .br-widget a.br-selected {
  border: 2px solid var(--theme-default);
  color: var(--theme-default);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-fontawesome-stars .br-widget a.br-selected:after, body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-fontawesome-stars .br-widget a.br-active:after,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-fontawesome-stars-o .br-widget a.br-selected:after,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-fontawesome-stars-o .br-widget a.br-active:after {
  color: var(--theme-default);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .scroll-demo {
  border: 1px solid #374558;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .search-form input {
  border: 1px solid #1d1e26;
  color: rgba(255, 255, 255, 0.6);
  background-color: #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .search-form .form-group:before {
  background: #262932;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .cd-timeline-content {
  background-color: #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .cd-timeline-content::before {
  border-left: 7px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .cd-timeline-block:nth-child(even) .cd-timeline-content::before {
  border-right-color: #1d1e26;
  border-left: transparent;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .breadcrumb.bg-white {
  background-color: #262932 !important;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) #donut-color-chart-morris-daily svg,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) #donut-color-chart-morris svg,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) #browser-uses-chart svg,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) #website-visiter-chart svg {
  opacity: 0.5;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .form-builder-header-1,
body.dark-only .page-wrapper .page-body-wrapper .page-body .form-builder-2-header {
  background-color: #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .show > .nav-link {
  color: #fff;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-link {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-link.active {
  color: #fff;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-pills.nav-primary .show > .nav-link {
  color: #fff;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-pills.nav-primary .nav-link {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-pills.nav-primary .nav-link.active {
  color: #fff;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .form-builder .drag-box fieldset {
  border: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .form-builder .help-block {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body #viewhtml .render {
  background-color: #262932;
  color: rgba(255, 255, 255, 0.6);
  border-color: #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .form-builder-column .drag-bx {
  border: 1px dotted #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .wizard-4 ul.anchor li a.disabled {
  color: #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .gallery-with-description h4, body.dark-only .page-wrapper .page-body-wrapper .page-body .gallery-with-description .h4 {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .gallery-with-description a > div {
  border: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .gallery-with-description p {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-grid-header {
  background-color: #262932;
  border: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row > .jsgrid-header-cell,
body.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row > .jsgrid-cell,
body.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row > .jsgrid-header-cell,
body.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row > .jsgrid-cell {
  background: #262932;
  border: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row > .jsgrid-header-cell input,
body.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row > .jsgrid-cell input,
body.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row > .jsgrid-header-cell input,
body.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row > .jsgrid-cell input {
  background-color: #1d1e26;
  border-color: #1d1e26;
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row > .jsgrid-header-cell input:focus,
body.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row > .jsgrid-cell input:focus,
body.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row > .jsgrid-header-cell input:focus,
body.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row > .jsgrid-cell input:focus {
  outline: none;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row select,
body.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row select {
  background-color: #1d1e26;
  border-color: #1d1e26;
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-row > .jsgrid-cell {
  background-color: #262932;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-alt-row > .jsgrid-cell {
  background-color: #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-cell,
body.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-grid-body {
  border: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-selected-row > .jsgrid-cell {
  background-color: #1c212b;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid .jsgrid-pager [class*=jsgrid-pager] {
  border: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid .jsgrid-pager .jsgrid-pager-page a {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-pager-current-page {
  color: rgba(255, 255, 255, 0.6);
  font-weight: 700;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .sub-title {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card .sub-title {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .navs-icon li a {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .navs-icon li a:hover {
  color: var(--theme-default);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .navs-icon .separator {
  border-bottom: 1px solid #374558;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .default-according li .text-muted {
  color: rgba(255, 255, 255, 0.6) !important;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .navs-icon.default-according.style-1 li button:hover {
  color: var(--theme-default) !important;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .nav-list .nav-list-disc li a {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .nav-list .nav-list-disc li:hover {
  color: var(--theme-default);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .nav-list .nav-list-disc li:hover a {
  color: var(--theme-default);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .navs-dropdown .onhover-show-div {
  background-color: #1d1e26;
  box-shadow: 0 0 14px 0 #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .navs-dropdown .onhover-show-div .navs-icon li p {
  color: #fff;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .navs-dropdown .onhover-show-div .navs-icon li a svg path,
body.dark-only .page-wrapper .page-body-wrapper .page-body .navs-dropdown .onhover-show-div .navs-icon li a svg line,
body.dark-only .page-wrapper .page-body-wrapper .page-body .navs-dropdown .onhover-show-div .navs-icon li a svg polyline,
body.dark-only .page-wrapper .page-body-wrapper .page-body .navs-dropdown .onhover-show-div .navs-icon li a svg polygon,
body.dark-only .page-wrapper .page-body-wrapper .page-body .navs-dropdown .onhover-show-div .navs-icon li a svg rect {
  color: rgba(255, 255, 255, 0.6) !important;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .navs-dropdown .onhover-show-div .navs-icon li a:hover svg path,
body.dark-only .page-wrapper .page-body-wrapper .page-body .navs-dropdown .onhover-show-div .navs-icon li a:hover svg line,
body.dark-only .page-wrapper .page-body-wrapper .page-body .navs-dropdown .onhover-show-div .navs-icon li a:hover svg polyline,
body.dark-only .page-wrapper .page-body-wrapper .page-body .navs-dropdown .onhover-show-div .navs-icon li a:hover svg polygon,
body.dark-only .page-wrapper .page-body-wrapper .page-body .navs-dropdown .onhover-show-div .navs-icon li a:hover svg rect {
  color: var(--theme-default) !important;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .onhover-dropdown:hover .onhover-show-div:before {
  border-bottom: 7px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .default-according .card .btn-link {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .default-according .card .card-body {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .default-according .card .card-body {
  border: 1px solid #374558;
  border-top: none;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .border {
  border: 1px solid #374558 !important;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .blog-box .blog-date {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .blog-social li,
body.dark-only .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .blog-social li {
  color: #98a6ad;
  border-right: 1px solid #374558;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .blog-social li:first-child,
body.dark-only .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .blog-social li:first-child {
  border-right: 1px solid #374558;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .blog-social li:last-child,
body.dark-only .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .blog-social li:last-child {
  border-right: none;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details p,
body.dark-only .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main p {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .single-blog-content-top,
body.dark-only .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .single-blog-content-top {
  border-top: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .single-blog-content-top p,
body.dark-only .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .single-blog-content-top p {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .comment-box .media h6 span, body.dark-only .page-wrapper .page-body-wrapper .page-body .comment-box .media .h6 span {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .comment-box .media img {
  border: 1px solid #374558;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .comment-box p {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .comment-box .comment-social li {
  color: #98a6ad;
  border: none;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .comment-box .comment-social li:first-child {
  border-right: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .comment-box hr {
  border-top: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .table-hover > tbody > tr:hover {
  --bs-table-accent-bg: #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .table-hover > tbody > tr:hover td,
body.dark-only .page-wrapper .page-body-wrapper .page-body .table-hover > tbody > tr:hover th {
  color: #fff;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body ul.the-icons li {
  border: 1px dotted #374558;
  color: rgba(255, 255, 255, 0.6);
  display: inline-block;
  padding: 10px;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body ul.the-icons li:hover {
  background: #000;
  box-shadow: 0 0 3px #262932;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body ul.the-icons li em {
  display: none;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .button-builder-wrap .box {
  background-color: #262932;
  border: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .button-builder-wrap .button-preview h2, body.dark-only .page-wrapper .page-body-wrapper .page-body .button-builder-wrap .button-preview .h2 {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .button-builder-wrap pre.well {
  background-color: #262932 !important;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .crm-activity > li + li {
  border-top: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .crm-activity > li h6, body.dark-only .page-wrapper .page-body-wrapper .page-body .crm-activity > li .h6 {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .crm-activity ul.dates li {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body #donut-color-chart-morris svg text,
body.dark-only .page-wrapper .page-body-wrapper .page-body #donut-color-chart-morris-daily svg text {
  fill: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .custom-card .card-profile img {
  background-color: #262932;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .custom-card .profile-details h6, body.dark-only .page-wrapper .page-body-wrapper .page-body .custom-card .profile-details .h6 {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .custom-card .card-social li a {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .custom-card .card-footer > div h6, body.dark-only .page-wrapper .page-body-wrapper .page-body .custom-card .card-footer > div .h6 {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .custom-card .card-footer > div + div {
  border-left: 1px solid #323846;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .form-control {
  background-color: #1d1e26;
  color: rgba(255, 255, 255, 0.6);
  border: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .form-control.touchspin {
  background-color: #262932;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .checkbox label::before,
body.dark-only .page-wrapper .page-body-wrapper .page-body .radio label::before {
  background-color: #1d1e26;
  border: 1px solid #1d1e26;
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .dropdown-basic .dropdown .dropdown-content {
  background-color: #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .dropdown-basic .dropdown .dropdown-content a {
  color: rgba(255, 255, 255, 0.6);
  background-color: transparent;
  border-color: #262932;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .dropdown-basic .dropdown .dropdown-content a:hover {
  background-color: #262932;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .dropdown-basic .dropdown .dropdown-content .dropdown-header {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .dropdown-basic .dropdown .dropdown-content .dropdown-divider {
  border: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .dropup-basic .dropup .dropup-content {
  background-color: #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .dropup-basic .dropup .dropup-content a {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .dropup-basic .dropup .dropup-content a:hover, body.dark-only .page-wrapper .page-body-wrapper .page-body .dropup-basic .dropup .dropup-content a.active {
  background-color: #262932;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .dropzone.dz-clickable .dz-message h6, body.dark-only .page-wrapper .page-body-wrapper .page-body .dropzone.dz-clickable .dz-message .h6 {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .dropzone.dz-clickable .dz-message span {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .dropzone .dz-preview {
  background-color: #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .dropzone .dz-preview .dz-details {
  background-color: #262932;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .browser-widget .media-body {
  column-rule: 1px solid #374558;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .browser-widget .media-body h4, body.dark-only .page-wrapper .page-body-wrapper .page-body .browser-widget .media-body .h4 {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .browser-widget .media-body h4 span, body.dark-only .page-wrapper .page-body-wrapper .page-body .browser-widget .media-body .h4 span {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .browser-widget .media-body span {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .email-app-sidebar .media img {
  border: 2px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .email-app-sidebar .main-menu > li a {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .email-app-sidebar .main-menu > li a:hover {
  background-color: #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .email-app-sidebar ul li a > .title {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .email-right-aside .email-body .row .col-xl-4 {
  border-right: 1px solid rgba(0, 0, 0, 0.1);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .email-right-aside .email-body .inbox .media.active {
  background-color: #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body h6, body.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body .h6 {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body h6 small, body.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body .h6 small, body.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body h6 .small, body.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body .h6 .small {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body h6 small span, body.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body .h6 small span, body.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body h6 .small span, body.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body .h6 .small span {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body p {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .email-top {
  border-bottom: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap p {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .email-content .email-top .user-emailid:after {
  border: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .notification-popup p {
  color: #fff;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .dropdown-menu {
  background-color: #1d1e26;
  border: 1px solid #262932;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .dropdown-menu a {
  color: rgba(255, 255, 255, 0.6);
  background: transparent;
  border-top-color: #262932;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .dropdown-menu a:hover {
  background-color: #262932;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .icon-lists div i {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .icon-lists div:hover {
  background-color: #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .redial-social-widget i {
  background-color: #262932;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .b-b-light {
  border-bottom: 1px solid #374558 !important;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .b-r-dark {
  border-right: 1px solid #fff !important;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .testimonial i {
  color: #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .testimonial p {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .testimonial h5, body.dark-only .page-wrapper .page-body-wrapper .page-body .testimonial .h5 {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .testimonial span {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .grid-showcase span {
  background-color: #262932;
  border: 1px solid #374558;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .grid-align .row {
  background-color: #1d1e26;
  border: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .page-builder .ge-html-output {
  background-color: #1d1e26;
  color: #98a6ad;
  border: 1px solid #374558;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .page-builder .btn-grid {
  background-color: #262932;
  color: #98a6ad !important;
  border-right: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .page-builder .ge-mainControls .ge-addRowGroup .ge-row-icon .column {
  border-left: 3px solid #262932;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .page-builder .btn-code,
body.dark-only .page-wrapper .page-body-wrapper .page-body .page-builder .btn-screen {
  color: #98a6ad;
  border-right: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .page-builder .ge-canvas.ge-editing .row {
  background-color: #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .page-builder .ge-canvas.ge-editing .column {
  border: 1px solid #1d1e26;
  background-color: #262932;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .page-builder .ge-canvas.ge-editing .ge-tools-drawer .ge-details input {
  background-color: #1d1e26;
  border-color: #1d1e26;
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .page-builder .ge-canvas.ge-editing .ge-tools-drawer .ge-details .btn-group a {
  color: #98a6ad;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .page-builder .ge-content-type-ckeditor {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .search-page .info-block {
  border: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .card-absolute .bg-primary h5, body.dark-only .page-wrapper .page-body-wrapper .page-body .card-absolute .bg-primary .h5,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card-absolute .bg-secondary h5,
body.dark-only .page-wrapper .page-body-wrapper .page-body .card-absolute .bg-secondary .h5 {
  color: #fff;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body .timeline-small .media .timeline-round.timeline-line-1:after, body.dark-only .page-wrapper .page-body-wrapper .page-body .timeline-small .media .timeline-round.small-line:after, body.dark-only .page-wrapper .page-body-wrapper .page-body .timeline-small .media .timeline-round.medium-line:after {
  background-color: #374558;
}
body.dark-only .page-wrapper .page-body-wrapper .page-body {
  /* body end*/
}
body.dark-only .page-wrapper .page-body-wrapper .footer p {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .footer {
  border-top: 1px solid #1d1e26;
  background-color: #262932;
}
body.dark-only .page-wrapper .page-body-wrapper .custom-select,
body.dark-only .page-wrapper .page-body-wrapper .custom-file-label {
  background: #1d1e26;
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .page-body-wrapper .footer-fix {
  background-color: #262932;
  border-top: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .note textarea {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .dt-button-info {
  background-color: #262932;
  border: 1px solid #98a6ad;
}
body.dark-only .page-wrapper .dt-button-info h2, body.dark-only .page-wrapper .dt-button-info .h2 {
  background-color: #262932;
}
body.dark-only .page-wrapper .chat-box .about .name {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .chat-box .chat-menu {
  border-left: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .chat-box .chat-menu .nav-tabs {
  border-bottom: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .chat-box .chat-menu .nav-tabs .nav-item .nav-link.active {
  color: rgba(255, 255, 255, 0.6) !important;
}
body.dark-only .page-wrapper .chat-box .chat-menu .user-profile .image .icon-wrapper {
  background-color: #262932;
  box-shadow: 1px 1px 3px 1px #1d1e26;
}
body.dark-only .page-wrapper .chat-box .chat-menu .user-profile .image .avatar img {
  border: 5px solid #1d1e26;
}
body.dark-only .page-wrapper .chat-box .chat-menu .user-profile .social-media a {
  color: #98a6ad;
}
body.dark-only .page-wrapper .chat-box .chat-menu .user-profile .follow span {
  color: #98a6ad;
}
body.dark-only .page-wrapper .chat-box .chat-menu .user-profile .follow .follow-num {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .chat-box .status {
  color: #98a6ad;
}
body.dark-only .page-wrapper .chat-box .status p {
  color: rgba(255, 255, 255, 0.6) !important;
}
body.dark-only .page-wrapper .chat-box .chat-right-aside .chat .chat-header {
  border-bottom: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .chat-box .chat-right-aside .chat .chat-header .chat-menu-icons li a i {
  color: #98a6ad;
}
body.dark-only .page-wrapper .chat-box .chat-right-aside .chat .chat-header img {
  box-shadow: 1px 1px 4px 1px #1d1e26;
}
body.dark-only .page-wrapper .chat-box .chat-right-aside .chat .chat-msg-box .my-message {
  border: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .chat-box .chat-right-aside .chat .chat-msg-box .message {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .chat-box .chat-right-aside .chat .chat-msg-box .other-message {
  background-color: #1d1e26;
}
body.dark-only .page-wrapper .chat-box .chat-right-aside .chat .chat-message {
  background-color: #262932;
  border-top: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .chat-box .chat-right-aside .chat .chat-message .input-group .form-control {
  background-color: #262932;
}
body.dark-only .page-wrapper .chat-box .chat-history .call-icons ul li {
  border: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .chat-box .chat-history .call-icons ul li a {
  color: #98a6ad;
}
body.dark-only .page-wrapper pre {
  background-color: #1d1e26;
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .scorlled {
  background-color: #1d1e26;
}
body.dark-only .page-wrapper .input-group-air {
  box-shadow: 0 3px 20px 0 #1d1e26;
}
body.dark-only .page-wrapper .input-group-text {
  background-color: #262932;
  border: 1px solid #1d1e26;
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .input-group-text i {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .input-group-solid .input-group-text,
body.dark-only .page-wrapper .input-group-solid .form-control {
  background: #1d1e26;
  border: 1px solid #1d1e26;
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .semilight-bg-color,
body.dark-only .page-wrapper .header-bg-color {
  background-color: #fff;
}
body.dark-only .page-wrapper .list-group-item {
  background-color: #262932;
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .list-group-item + .list-group-item {
  border-top-width: 0;
}
body.dark-only .page-wrapper .list-group-item.active {
  background-color: var(--theme-default) !important;
  border-color: var(--theme-default);
  color: #fff;
}
body.dark-only .page-wrapper .list-group-item:hover, body.dark-only .page-wrapper .list-group-item:focus {
  z-index: 1;
  text-decoration: none;
}
body.dark-only .page-wrapper .list-group-item-action:hover:not(.active), body.dark-only .page-wrapper .list-group-item-action:focus {
  background-color: #1d1e26;
}
body.dark-only .page-wrapper .list-group-flush .list-group-item {
  border-left: 0;
  border-right: 0;
  border-radius: 0;
}
body.dark-only .page-wrapper .list-group-item-primary {
  color: #004085;
  background-color: #b8daff;
}
body.dark-only .page-wrapper .list-group-item-secondary {
  color: #383d41;
  background-color: #d6d8db;
}
body.dark-only .page-wrapper .list-group-item-success {
  color: #155724;
  background-color: #c3e6cb;
}
body.dark-only .page-wrapper .list-group-item-danger {
  color: #721c24;
  background-color: #f5c6cb;
}
body.dark-only .page-wrapper .list-group-item-warning {
  color: #856404;
  background-color: #ffeeba;
}
body.dark-only .page-wrapper .list-group-item-info {
  color: #0c5460;
  background-color: #bee5eb;
}
body.dark-only .page-wrapper .list-group-item-light {
  color: #818182;
  background-color: #fdfdfe;
}
body.dark-only .page-wrapper .list-group-item-dark {
  color: #1b1e21;
  background-color: #c6c8ca;
}
body.dark-only .page-wrapper .auth-bg {
  background-blend-mode: overlay;
  background-color: rgba(54, 64, 74, 0.9);
}
body.dark-only .page-wrapper .auth-bg .authentication-box .card {
  background-color: #262932;
}
body.dark-only .page-wrapper .auth-bg .authentication-box .card .theme-form .form-group input {
  color: rgba(255, 255, 255, 0.6);
  background-color: #1d1e26;
  border: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .auth-bg .authentication-box .card .theme-form .form-group label {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .auth-bg .authentication-box .card .theme-form .checkbox label {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .auth-bg .authentication-box .card .theme-form .checkbox label::before {
  background-color: #1d1e26;
  border: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .auth-bg .authentication-box h3, body.dark-only .page-wrapper .auth-bg .authentication-box .h3,
body.dark-only .page-wrapper .auth-bg .authentication-box h4,
body.dark-only .page-wrapper .auth-bg .authentication-box .h4,
body.dark-only .page-wrapper .auth-bg .authentication-box h6,
body.dark-only .page-wrapper .auth-bg .authentication-box .h6 {
  color: #fff;
}
body.dark-only .page-wrapper .auth-bg-video {
  background-blend-mode: overlay;
  background-color: rgba(54, 64, 74, 0.7);
}
body.dark-only .page-wrapper .auth-bg-video .authentication-box h4, body.dark-only .page-wrapper .auth-bg-video .authentication-box .h4,
body.dark-only .page-wrapper .auth-bg-video .authentication-box h3,
body.dark-only .page-wrapper .auth-bg-video .authentication-box .h3 {
  color: #fff;
}
body.dark-only .page-wrapper .auth-bg-video .authentication-box h6, body.dark-only .page-wrapper .auth-bg-video .authentication-box .h6 {
  color: #98a6ad;
}
body.dark-only .page-wrapper .auth-bg-video .authentication-box .card {
  background-color: #262932;
}
body.dark-only .page-wrapper .auth-bg-video .authentication-box .card .theme-form .form-group input[type=text],
body.dark-only .page-wrapper .auth-bg-video .authentication-box .card .theme-form .form-group input[type=password] {
  background-color: #1d1e26;
  border: 1px solid #1d1e26;
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .auth-bg-video .authentication-box .card .theme-form .checkbox label::before {
  background-color: #1d1e26;
  border: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .error-wrapper .maintenance-icons li i {
  color: #1d1e26;
}
body.dark-only .page-wrapper .error-wrapper .maintenance-icons li:nth-child(3) i {
  color: #1d1e26;
}
body.dark-only .page-wrapper .modal-content {
  background-color: #262932;
}
body.dark-only .page-wrapper .modal-content .modal-header {
  border-bottom: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .modal-content .modal-header .close {
  color: #98a6ad;
}
body.dark-only .page-wrapper .modal-content .modal-footer {
  border-top: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .comingsoon {
  background-blend-mode: overlay;
  background-color: rgba(54, 64, 74, 0.9);
}
body.dark-only .page-wrapper .comingsoon .comingsoon-inner h5, body.dark-only .page-wrapper .comingsoon .comingsoon-inner .h5 {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .comingsoon .comingsoon-inner .countdown {
  border-top: 1px solid #1d1e26;
  border-bottom: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .comingsoon .comingsoon-inner .countdown .title {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .comingsoon .comingsoon-inner .coming-soon-bottom-link a {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .theme-form .login-divider {
  border-top: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .theme-form .login-divider:before {
  background: #1d1e26;
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .authentication-main {
  background-color: #1d1e26;
}
body.dark-only .page-wrapper .authentication-main .auth-innerright .reset-password-box .card {
  background-color: #262932;
}
body.dark-only .page-wrapper .authentication-main .auth-innerright .reset-password-box .reset-password-link {
  color: #98a6ad;
}
body.dark-only .page-wrapper .authentication-main .auth-innerright .reset-password-box .theme-form .form-group label {
  color: #98a6ad;
}
body.dark-only .page-wrapper .authentication-main .auth-innerright .reset-password-box .theme-form .form-group .form-control {
  background-color: #1d1e26;
  color: rgba(255, 255, 255, 0.6);
  border-color: #1d1e26;
}
body.dark-only .page-wrapper .authentication-main .auth-innerright .reset-password-box .theme-form .opt-box {
  background-color: #1d1e26;
}
body.dark-only .page-wrapper .authentication-main .auth-innerright .authentication-box h4, body.dark-only .page-wrapper .authentication-main .auth-innerright .authentication-box .h4 {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .authentication-main .auth-innerright .authentication-box h6, body.dark-only .page-wrapper .authentication-main .auth-innerright .authentication-box .h6 {
  color: #98a6ad;
}
body.dark-only .page-wrapper .authentication-main .auth-innerright .authentication-box h3, body.dark-only .page-wrapper .authentication-main .auth-innerright .authentication-box .h3 {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .authentication-main .auth-innerright .authentication-box .card {
  background-color: #262932;
}
body.dark-only .page-wrapper .authentication-main .auth-innerright .authentication-box .card .theme-form .form-group input[type=text],
body.dark-only .page-wrapper .authentication-main .auth-innerright .authentication-box .card .theme-form .form-group input[type=password] {
  background-color: #1d1e26;
  border: 1px solid #1d1e26;
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .page-wrapper .authentication-main .auth-innerright .authentication-box .card .theme-form .checkbox label::before {
  background-color: #1d1e26;
  border: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .vertical-menu-main {
  background-color: #262932;
}
body.dark-only .page-wrapper .mega-menu .title {
  color: rgba(255, 255, 255, 0.6);
  border-bottom: 1px solid #1d1e26;
}
body.dark-only .page-wrapper .mega-menu .list-unstyled div a:hover {
  color: var(--theme-default);
}
body.dark-only .page-wrapper .default-according .card {
  background-color: #262932;
}
body.dark-only .page-wrapper .default-according .card .btn-link {
  background-color: #262932;
  border: 1px solid #374558;
  border-bottom: none;
  color: #fff;
}
body.dark-only .page-wrapper .default-according .card .text-muted {
  color: #98a6ad !important;
}
body.dark-only .page-wrapper .default-according .bg-primary .btn-link {
  background-color: var(--theme-default);
  border: 1px solid var(--theme-default);
}
body.dark-only .page-wrapper .default-according .bg-secondary .btn-link {
  background-color: var(--theme-secondary);
  border: 1px solid var(--theme-secondary);
}
body.dark-only .page-wrapper .collapse .card-body {
  background-color: #262932;
}
body.dark-only .page-wrapper .balance-widget.card-body {
  background-color: #262932;
  background-blend-mode: overlay;
}
@media screen and (max-width: 1660px) {
  body.dark-only .page-wrapper .chat-box .chat-history .call-icons ul li {
    border: 1px solid #1d1e26;
  }
  body.dark-only .page-wrapper .chat-box .chat-history .total-time h2, body.dark-only .page-wrapper .chat-box .chat-history .total-time .h2 {
    color: rgba(255, 255, 255, 0.6);
  }
  body.dark-only .page-wrapper .caller-img img {
    opacity: 0.7;
  }
  body.dark-only .page-wrapper .chat-box .chat-history .call-content > div {
    background-color: rgba(0, 0, 0, 0.75);
    background-blend-mode: overlay;
  }
}
@media only screen and (max-width: 1199px) {
  body.dark-only .page-wrapper .mobile-title.d-none {
    border-bottom: 1px solid #374558;
  }
  body.dark-only .page-wrapper .chat-menu {
    border-top: 1px solid #1d1e26;
    background-color: #262932;
  }
  body.dark-only .page-wrapper .error-wrapper .maintenance-icons li i {
    color: #2c323f;
  }
}
@media only screen and (max-width: 575.98px) {
  body.dark-only .page-wrapper .user-profile .hovercard .info .user-designation {
    border-top: 1px solid #1d1e26;
    border-bottom: 1px solid #1d1e26;
  }
  body.dark-only .page-wrapper .page-wrapper.compact-wrapper .page-header .header-wrapper .toggle-sidebar, body.dark-only .page-wrapper .page-wrapper.compact-sidebar .page-header .header-wrapper .toggle-sidebar {
    border-right: 1px solid #374558;
  }
}
body.dark-only .lg-backdrop {
  background-color: #1d1e26;
}
body.dark-only .lg-outer .lg-thumb-outer {
  background-color: #262932;
}
body.dark-only .drag {
  background-color: #262932;
}
body.dark-only .drag form {
  background: #262932;
  box-shadow: 0 0 30px #1d1e26;
  border: 1px dotted #1d1e26;
}
body.dark-only .drag form input {
  background-color: #1d1e26;
  border: 1px solid #1d1e26;
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .drag form .help-block {
  text-transform: capitalize;
  color: #98a6ad;
}
body.dark-only .draggable input {
  background-color: #1d1e26;
  color: rgba(255, 255, 255, 0.6);
  border: 1px solid #1d1e26;
}
body.dark-only .draggable p {
  color: #98a6ad;
}
body.dark-only .draggable select {
  background-color: #1d1e26;
  color: rgba(255, 255, 255, 0.6);
  border: 1px solid #1d1e26;
}
body.dark-only .draggable .radio label::before,
body.dark-only .draggable .checkbox label::before {
  background-color: #1d1e26;
  border: 1px solid #1d1e26;
}
body.dark-only .select2-container--default .select2-selection--multiple,
body.dark-only .select2-container--default .select2-selection--single {
  background-color: #1d1e26;
  border: 1px solid #1d1e26 !important;
}
body.dark-only .select2-container--default .select2-search--inline .select2-search__field {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .select2-container--default .select2-selection--single .select2-selection__rendered {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .select2-container--default .select2-search--dropdown .select2-search__field {
  background-color: #1d1e26;
  border: 1px solid #1d1e26;
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #262932 !important;
  color: rgba(255, 255, 255, 0.6) !important;
}
body.dark-only .select2-dropdown {
  background-color: #1d1e26;
  border: 1px solid #1d1e26;
}
body.dark-only .select2-drpdwn .form-control-primary {
  border-color: var(--theme-default) !important;
  color: var(--theme-default) !important;
}
body.dark-only .select2-drpdwn .form-control-secondary {
  border-color: var(--theme-secondary) !important;
  color: var(--theme-secondary) !important;
}
body.dark-only .select2-drpdwn .form-control-success {
  border-color: #54ba4a !important;
  color: #54ba4a !important;
}
body.dark-only .select2-drpdwn .form-control-info {
  border-color: #16c7f9 !important;
  color: #16c7f9 !important;
}
body.dark-only .select2-drpdwn .form-control-warning {
  border-color: #ffaa05 !important;
  color: #ffaa05 !important;
}
body.dark-only .select2-drpdwn .form-control-danger {
  border-color: #fc4438 !important;
  color: #fc4438 !important;
}
body.dark-only .select2-drpdwn .form-control-inverse {
  border-color: #fff !important;
  color: #fff !important;
}
body.dark-only .select2-drpdwn .form-control-primary-fill {
  background-color: var(--theme-default) !important;
  color: #fff !important;
}
body.dark-only .select2-drpdwn .form-control-secondary-fill {
  background-color: var(--theme-secondary) !important;
  color: #fff !important;
}
body.dark-only .select2-drpdwn .form-control-success-fill {
  background-color: #54ba4a !important;
  color: #fff !important;
}
body.dark-only .select2-drpdwn .form-control-info-fill {
  background-color: #16c7f9 !important;
  color: #fff !important;
}
body.dark-only .select2-drpdwn .form-control-warning-fill {
  background-color: #ffaa05 !important;
  color: #fff !important;
}
body.dark-only .select2-drpdwn .form-control-danger-fill {
  background-color: #fc4438 !important;
  color: #fff !important;
}
body.dark-only .select2-drpdwn .form-control-inverse-fill {
  background-color: #fff !important;
  color: #000 !important;
}
body.dark-only .select2-container--default.select2-container--disabled .select2-selection--single {
  background-color: #1d1e26;
}
body.dark-only .theme-form .form-group select.form-control:not([size]):not([multiple]) {
  background-color: #1d1e26;
  color: rgba(255, 255, 255, 0.6);
  border-color: #1d1e26;
}
body.dark-only .theme-form .form-group input[type=text],
body.dark-only .theme-form .form-group input[type=email],
body.dark-only .theme-form .form-group input[type=search],
body.dark-only .theme-form .form-group input[type=password],
body.dark-only .theme-form .form-group input[type=number],
body.dark-only .theme-form .form-group input[type=tel],
body.dark-only .theme-form .form-group input[type=date],
body.dark-only .theme-form .form-group input[type=datetime-local],
body.dark-only .theme-form .form-group input[type=time],
body.dark-only .theme-form .form-group input[type=datetime-local],
body.dark-only .theme-form .form-group input[type=month],
body.dark-only .theme-form .form-group input[type=week],
body.dark-only .theme-form .form-group input[type=url],
body.dark-only .theme-form .form-group input[type=file],
body.dark-only .theme-form .form-group select {
  border-color: #1d1e26;
  background-color: #1d1e26;
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .theme-form .form-group input[type=text]::-webkit-input-placeholder,
body.dark-only .theme-form .form-group input[type=email]::-webkit-input-placeholder,
body.dark-only .theme-form .form-group input[type=search]::-webkit-input-placeholder,
body.dark-only .theme-form .form-group input[type=password]::-webkit-input-placeholder,
body.dark-only .theme-form .form-group input[type=number]::-webkit-input-placeholder,
body.dark-only .theme-form .form-group input[type=tel]::-webkit-input-placeholder,
body.dark-only .theme-form .form-group input[type=date]::-webkit-input-placeholder,
body.dark-only .theme-form .form-group input[type=datetime-local]::-webkit-input-placeholder,
body.dark-only .theme-form .form-group input[type=time]::-webkit-input-placeholder,
body.dark-only .theme-form .form-group input[type=datetime-local]::-webkit-input-placeholder,
body.dark-only .theme-form .form-group input[type=month]::-webkit-input-placeholder,
body.dark-only .theme-form .form-group input[type=week]::-webkit-input-placeholder,
body.dark-only .theme-form .form-group input[type=url]::-webkit-input-placeholder,
body.dark-only .theme-form .form-group input[type=file]::-webkit-input-placeholder,
body.dark-only .theme-form .form-group select::-webkit-input-placeholder {
  color: #98a6ad;
}
body.dark-only .theme-form .form-group .form-control {
  background-color: #1d1e26;
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .theme-form .form-group textarea {
  border-color: #1d1e26;
}
body.dark-only .theme-form .form-divider {
  border-top: 1px solid #1d1e26;
}
body.dark-only .theme-form .form-divider::before {
  background: #262932;
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .CodeMirror {
  background: #262932;
  border: 1px solid #98a6ad;
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .CodeMirror .CodeMirror-code pre {
  background: #262932;
}
body.dark-only .editor-toolbar {
  border-top: 1px solid #98a6ad;
  border-left: 1px solid #98a6ad;
  border-right: 1px solid #98a6ad;
}
body.dark-only .editor-toolbar a {
  color: rgba(255, 255, 255, 0.6) !important;
}
body.dark-only .editor-toolbar a:hover, body.dark-only .editor-toolbar a.active {
  background: #1d1e26;
}
body.dark-only .editor-toolbar i.separator {
  border-left: 1px solid #98a6ad;
  border-right: 1px solid #98a6ad;
}
body.dark-only .editor-toolbar.fullscreen::before {
  background: linear-gradient(to right, #1d1e26 0, rgba(0, 0, 0, 0) 100%);
}
body.dark-only .editor-toolbar.fullscreen::after {
  background: linear-gradient(to right, rgba(0, 0, 0, 0) 0, #1d1e26 100%);
}
body.dark-only .editor-toolbar.disabled-for-preview a:not(.no-disable) {
  background: #1d1e26;
}
body.dark-only .editor-preview {
  background-color: #262932;
}
body.dark-only .editor-toolbar.fullscreen,
body.dark-only .editor-preview-side {
  background: #262932;
  border: 1px solid #98a6ad;
}
body.dark-only .u-step {
  background: #1d1e26;
}
body.dark-only .u-step.active, body.dark-only .u-step.current {
  background: var(--theme-default);
  color: #fff;
}
body.dark-only .u-step-title,
body.dark-only .u-pearl-title {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .u-step-number {
  background-color: #262932;
}
body.dark-only .u-pearl:before {
  background-color: #1d1e26;
}
body.dark-only .u-pearl-number,
body.dark-only .u-pearl-icon {
  background: #1d1e26;
  border: 2px solid #1d1e26;
}
body.dark-only .u-pearl.disabled .u-pearl-icon,
body.dark-only .u-pearl.disabled .u-pearl-number {
  background: #1d1e26;
  border: 2px solid #1d1e26;
}
body.dark-only .u-pearl.disabled:after {
  background-color: #334053;
}
body.dark-only .u-pearl.error:after {
  background-color: #1d1e26;
}
body.dark-only .note-editor.note-frame {
  border-color: #1d1e26;
}
body.dark-only .note-editor.note-frame .note-editing-area .note-editable {
  background-color: #262932;
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .swal-modal {
  background-color: #262932;
}
body.dark-only .swal-modal .swal-title {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .swal-modal .swal-text {
  color: #98a6ad;
}
body.dark-only .swal-modal .swal-content__input {
  background-color: #1d1e26;
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .nav-tabs {
  border-bottom: 1px solid #374558;
}
body.dark-only .nav-tabs .nav-link {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .nav-tabs .nav-link.active {
  background-color: #262932;
  color: rgba(255, 255, 255, 0.6);
  border-color: #374558 #374558 #262932;
}
body.dark-only .nav-tabs .nav-link:hover, body.dark-only .nav-tabs .nav-link:focus {
  border-color: #374558 #374558 #323846;
}
body.dark-only .nav-tabs .nav-item.show .nav-link {
  background-color: #262932;
  color: rgba(255, 255, 255, 0.6);
  border-color: #1d1e26 #1d1e26 #262932;
}
body.dark-only .nav-primary .nav-link.active {
  background-color: var(--theme-default);
}
body.dark-only .nav-primary .nav-item.show .nav-link {
  background-color: var(--theme-default);
}
body.dark-only .custom-tab.nav-tabs {
  border-bottom: none;
}
body.dark-only .nav-tabs.nav-bottom .nav-item .nav-link.active, body.dark-only .nav-tabs.nav-bottom .nav-item .nav-link.focus, body.dark-only .nav-tabs.nav-bottom .nav-item .nav-link.hover {
  border-color: #262932 #1d1e26 #1d1e26;
}
body.dark-only .border-tab .nav-link.active {
  background-color: transparent;
}
body.dark-only .border-tab .show > .nav-link {
  background-color: transparent;
}
body.dark-only .border-tab.nav-left .nav-link,
body.dark-only .border-tab.nav-right .nav-link {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .border-tab.nav-left .nav-link.active,
body.dark-only .border-tab.nav-right .nav-link.active {
  color: var(--theme-default);
}
body.dark-only .border-tab.nav-left .show > .nav-link,
body.dark-only .border-tab.nav-right .show > .nav-link {
  color: var(--theme-default);
}
body.dark-only .border-tab.nav-left.nav-secondary .nav-link.active, body.dark-only .border-tab.nav-left.nav-secondary .nav-link:focus, body.dark-only .border-tab.nav-left.nav-secondary .nav-link:hover {
  border-left-color: var(--theme-secondary);
  color: var(--theme-secondary) !important;
}
body.dark-only .border-tab.nav-left.nav-secondary .show > .nav-link {
  border-left-color: var(--theme-secondary);
  color: var(--theme-secondary) !important;
}
body.dark-only .border-tab.nav-left.nav-secondary .nav-item.show {
  color: var(--theme-secondary) !important;
  border-left-color: var(--theme-secondary);
}
body.dark-only .border-tab.nav-left.nav-success .nav-link.active, body.dark-only .border-tab.nav-left.nav-success .nav-link:focus, body.dark-only .border-tab.nav-left.nav-success .nav-link:hover {
  color: #54ba4a !important;
}
body.dark-only .border-tab.nav-left.nav-success .show > .nav-link {
  border-left-color: #54ba4a;
  color: #54ba4a !important;
}
body.dark-only .border-tab.nav-left.nav-success .nav-item.show {
  color: #54ba4a !important;
  border-left-color: #54ba4a;
}
body.dark-only .border-tab.nav-right.nav-info .nav-link.active, body.dark-only .border-tab.nav-right.nav-info .nav-link:focus, body.dark-only .border-tab.nav-right.nav-info .nav-link:hover {
  color: #16c7f9 !important;
}
body.dark-only .border-tab.nav-right.nav-info .show > .nav-link {
  border-left-color: #16c7f9;
  color: #16c7f9 !important;
}
body.dark-only .border-tab.nav-right.nav-info .nav-item.show {
  color: #16c7f9 !important;
  border-left-color: #16c7f9;
}
body.dark-only .border-tab.nav-secondary .nav-link.active, body.dark-only .border-tab.nav-secondary .nav-link:focus, body.dark-only .border-tab.nav-secondary .nav-link:hover {
  color: var(--theme-secondary) !important;
}
body.dark-only .border-tab.nav-secondary .nav-item.show {
  color: var(--theme-secondary) !important;
}
body.dark-only .border-tab.nav-success .nav-link.active, body.dark-only .border-tab.nav-success .nav-link:focus, body.dark-only .border-tab.nav-success .nav-link:hover {
  color: #54ba4a !important;
}
body.dark-only .border-tab.nav-success .nav-item.show {
  color: #54ba4a !important;
}
body.dark-only .dropdown-divider {
  border-top: 1px solid #1d1e26;
}
body.dark-only .icon-hover-bottom {
  background-color: #262932;
  box-shadow: 0px 0px 1px 1px #1d1e26;
}
body.dark-only .icon-hover-bottom .icon-title {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .icon-hover-bottom span {
  color: #98a6ad;
}
body.dark-only .icon-hover-bottom .form-group input {
  background-color: #1d1e26;
  color: rgba(255, 255, 255, 0.6);
  border: 1px solid #1d1e26;
}
body.dark-only .icon-hover-bottom .icon-first i {
  color: #98a6ad;
}
body.dark-only code {
  background-color: #1d1e26;
  border-radius: 2px;
}
body.dark-only #cd-timeline::before {
  background: #1d1e26;
}
body.dark-only .timeliny {
  border-top: 1px solid #1d1e26;
  border-bottom: 1px solid #1d1e26;
}
body.dark-only .timeliny::before {
  background-color: #fff;
}
body.dark-only .timeliny .timeliny-dot {
  background-color: #262932;
  border: 1px solid #fff;
}
body.dark-only .timeliny .timeliny-dot::before {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .timeliny .timeliny-timeline .timeliny-timeblock.active .timeliny-dot::before {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .timeliny .timeliny-timeline .timeliny-timeblock.active .timeliny-dot::after {
  background-color: #1d1e26;
  color: rgba(255, 255, 255, 0.6);
  border: none;
}
body.dark-only .timeliny .timeliny-timeline .timeliny-timeblock:not(.inactive):not(.active) .timeliny-dot:hover {
  background-color: #fff;
}
body.dark-only .timeliny .timeliny-timeline .timeliny-timeblock:not(.inactive):not(.active) .timeliny-dot:hover::before {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .timeliny .timeliny-timeline .timeliny-timeblock .timeliny-dot:hover::after {
  background-color: #262932;
  border: 1px solid #1d1e26;
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .todo .todo-list-wrapper #todo-list li .task-container {
  background: #262932;
  border-bottom: 1px solid #1d1e26;
}
body.dark-only .todo .todo-list-wrapper #todo-list li .task-container .task-label {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .todo .todo-list-wrapper #todo-list li .task-container:hover h4, body.dark-only .todo .todo-list-wrapper #todo-list li .task-container:hover .h4 {
  color: #fff;
}
body.dark-only .todo .todo-list-wrapper #todo-list li .task-container .task-action-btn .action-box:hover:not(.active) {
  background: #262932;
  border: 1px solid #1d1e26;
}
body.dark-only .todo .todo-list-wrapper #todo-list li.completed .task-container .task-label {
  color: var(--theme-default);
}
body.dark-only .todo .todo-list-wrapper #todo-list li.completed .task-container .complete-btn:hover {
  border: 1px solid #54ba4a !important;
}
body.dark-only .todo .todo-list-wrapper .todo-list-footer .new-task-wrapper textarea {
  background-color: #262932;
  border: 1px solid #1d1e26;
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .user-profile .ttl-info h6, body.dark-only .user-profile .ttl-info .h6 {
  color: #98a6ad;
}
body.dark-only .user-profile .ttl-info span {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .user-profile .hovercard .info .title a {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .user-profile .hovercard .user-image .avatar img {
  border: 10px solid #262932;
}
body.dark-only .user-profile .hovercard .user-image .icon-wrapper {
  background-color: #262932;
}
body.dark-only .user-profile .hovercard .tabs-scoial {
  border-bottom: none !important;
}
body.dark-only .user-profile .follow .follow-num {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .user-profile .profile-img-style .user-name {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .user-profile .profile-img-style p {
  color: #98a6ad;
}
body.dark-only .introjs-helperLayer {
  background-color: rgba(54, 64, 74, 0.9);
  border: rgba(255, 255, 255, 0.5);
}
body.dark-only .jstree-default .jstree-node,
body.dark-only .jstree-default .jstree-icon {
  color: #455869 !important;
}
body.dark-only .jstree-default .jstree-anchor {
  color: #98a6ad;
}
body.dark-only .jstree-default .jstree-clicked {
  color: #fff;
  background-color: transparent;
}
body.dark-only .jstree-default .jstree-hovered {
  background-color: #1d1e26;
  border: 1px solid #1d1e26;
}
body.dark-only span.twitter-typeahead .tt-menu {
  background-color: #1d1e26;
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only span.twitter-typeahead .tt-suggestion {
  color: rgba(255, 255, 255, 0.6);
  background-color: #1d1e26;
  border-top: 1px solid #374558;
}
body.dark-only span.twitter-typeahead .tt-suggestion:hover, body.dark-only span.twitter-typeahead .tt-suggestion:focus {
  background-color: #262932;
}
body.dark-only .typography small, body.dark-only .typography .small {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .code-box-copy pre {
  background-color: #1d1e26;
}
body.dark-only .code-box-copy pre code {
  background-color: #1d1e26;
}
body.dark-only .code-box-copy pre[class*=language-] {
  border: 1px solid #1d1e26;
}
body.dark-only .code-box-copy .code-box-copy__btn {
  background-color: #1d1e26;
  border: 1px solid #1d1e26;
  color: #fff;
}
body.dark-only .code-box-copy code[class*=language-],
body.dark-only .code-box-copy pre[class*=language-] {
  text-shadow: 0px 1px #000;
}
body.dark-only .code-box-copy code[class*=language-] ::selection,
body.dark-only .code-box-copy pre[class*=language-] ::selection {
  text-shadow: none;
  background: #262932;
}
body.dark-only table.fixedHeader-floating {
  background-color: #1d1e26;
}
body.dark-only .note textarea {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .dt-button-info {
  background-color: #262932;
  border: 1px solid #1d1e26;
}
body.dark-only .dt-button-info h2, body.dark-only .dt-button-info .h2 {
  background-color: #262932;
  border-bottom: 1px solid #1d1e26;
}
body.dark-only pre {
  background-color: #1d1e26;
}
body.dark-only #keytable_wrapper .dataTables_paginate,
body.dark-only #column-selector_wrapper .dataTables_paginate,
body.dark-only #auto-fill_wrapper .dataTables_paginate,
body.dark-only #custom-button_wrapper .dataTables_paginate,
body.dark-only #class-button_wrapper .dataTables_paginate,
body.dark-only #keyboard-btn_wrapper .dataTables_paginate,
body.dark-only #multilevel-btn_wrapper .dataTables_paginate,
body.dark-only #pagelength-btn_wrapper .dataTables_paginate,
body.dark-only #basic-colreorder_wrapper .dataTables_paginate,
body.dark-only #state-saving_wrapper .dataTables_paginate,
body.dark-only #real-time_wrapper .dataTables_paginate,
body.dark-only #basic-fixed-header_wrapper .dataTables_paginate,
body.dark-only #fixed-header-footer_wrapper .dataTables_paginate,
body.dark-only #export-button_wrapper .dataTables_paginate,
body.dark-only #excel-cust-bolder_wrapper .dataTables_paginate,
body.dark-only #cust-json_wrapper .dataTables_paginate,
body.dark-only #basic-key-table_wrapper .dataTables_paginate,
body.dark-only #focus-cell_wrapper .dataTables_paginate,
body.dark-only #responsive_wrapper .dataTables_paginate,
body.dark-only #new-cons_wrapper .dataTables_paginate,
body.dark-only #show-hidden-row_wrapper .dataTables_paginate,
body.dark-only #basic-row-reorder_wrapper .dataTables_paginate,
body.dark-only #full-row_wrapper .dataTables_paginate,
body.dark-only #rest-column_wrapper .dataTables_paginate {
  border: none;
}
body.dark-only #example-style-8_wrapper table.dataTable.stripe tbody tr.odd,
body.dark-only #example-style-8_wrapper table.dataTable.display tbody tr.odd {
  background-color: #1d1e26;
}
body.dark-only .error-wrapper {
  background-color: rgba(54, 64, 74, 0.8);
}
body.dark-only .error-wrapper .sub-content {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .b-light {
  border: 1px solid #1d1e26 !important;
}
body.dark-only .modal-content {
  background-color: #262932;
}
body.dark-only .modal-content .modal-header {
  border-bottom: 1px solid #374558;
}
body.dark-only .modal-content .modal-header .close {
  color: rgba(255, 255, 255, 0.6);
  font-weight: 400;
}
body.dark-only .modal-content .ui-front .form-control {
  background-color: #262932;
  color: rgba(255, 255, 255, 0.6);
  border: 1px solid #374558;
}
body.dark-only .stepwizard .stepwizard-row:before {
  background-color: #374558;
}
body.dark-only .modal .theme-close {
  color: rgba(255, 255, 255, 0.2);
}
body.dark-only .token.atrule,
body.dark-only .token.attr-value,
body.dark-only .token.keyword {
  color: #16c7f9;
}
body.dark-only .token.boolean, body.dark-only .token.constant, body.dark-only .token.deleted, body.dark-only .token.number, body.dark-only .token.property, body.dark-only .token.symbol, body.dark-only .token.tag {
  color: #fc4438;
}
body.dark-only .loader-box.card-loader {
  background-color: #262932;
}
body.dark-only .my-gallery.gallery-with-description img {
  border: 1px solid #1d1e26 !important;
  border-bottom: none !important;
}
body.dark-only .alert-primary.inverse {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .alert-secondary.inverse {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .alert-success.inverse {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .alert-danger.inverse {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .alert-warning.inverse {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .alert-info.inverse {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .alert-light.inverse {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .alert-dark.inverse {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .alert-theme span + span + span {
  border-left: 5px solid var(--theme-default);
  background-color: #1d1e26;
  border-radius: 4px;
}
body.dark-only .alert-theme i {
  color: #fff;
  padding: 20px;
  margin-right: 20px !important;
}
body.dark-only .user-card .user-deatils h6, body.dark-only .user-card .user-deatils .h6 {
  color: #98a6ad;
}
body.dark-only .user-card .card-footer > div:first-child {
  border-right: 1px solid #1d1e26;
}
body.dark-only .user-card .card-footer .user-footer h6, body.dark-only .user-card .card-footer .user-footer .h6 {
  color: #98a6ad;
}
body.dark-only .user-card .card-footer .user-footer svg path,
body.dark-only .user-card .card-footer .user-footer svg rect {
  color: #98a6ad;
}
body.dark-only .order-history table .qty-box button {
  background-color: #1d1e26 !important;
  border: none !important;
}
body.dark-only .order-history table .qty-box .input-group {
  border-color: #374558;
}
body.dark-only .order-history table thead tr th {
  background-color: #1d1e26;
}
body.dark-only .order-history table tr td,
body.dark-only .order-history table tr th {
  border-top: none !important;
}
body.dark-only .order-history .title-orders {
  background-color: #1d1e26;
}
body.dark-only .navigation-option ul li a {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .navigation-option ul li:hover {
  background-color: #1d1e26;
}
body.dark-only .product-box .product-details h6, body.dark-only .product-box .product-details .h6 {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .product-box .product-details > a {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .product-box .product-details span {
  color: #98a6ad;
}
body.dark-only .product-box .product-img .product-hover ul li {
  background-color: #262932;
}
body.dark-only .product-box .product-img .product-hover ul li:hover {
  background-color: #000;
  color: #fff;
}
body.dark-only .browse .browse-articles ul li a {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .browse .browse-articles ul li:hover {
  background-color: #1d1e26;
}
body.dark-only .radio-primary input[type=radio] + label::before {
  border-color: var(--theme-default) !important;
}
body.dark-only .radio-primary input[type=radio] + label::after {
  background-color: var(--theme-default);
}
body.dark-only .radio-primary input[type=radio]:checked + label::before {
  border-color: var(--theme-default) !important;
}
body.dark-only .radio-primary input[type=radio]:checked + label::after {
  background-color: var(--theme-default);
}
body.dark-only .radio-secondary input[type=radio] + label::before {
  border-color: #ff3364 !important;
}
body.dark-only .radio-secondary input[type=radio] + label::after {
  background-color: #ff3364;
}
body.dark-only .radio-secondary input[type=radio]:checked + label::before {
  border-color: #ff3364 !important;
}
body.dark-only .radio-secondary input[type=radio]:checked + label::after {
  background-color: #ff3364;
}
body.dark-only .radio-success input[type=radio] + label::before {
  border-color: #54ba4a !important;
}
body.dark-only .radio-success input[type=radio] + label::after {
  background-color: #54ba4a;
}
body.dark-only .radio-success input[type=radio]:checked + label::before {
  border-color: #54ba4a !important;
}
body.dark-only .radio-success input[type=radio]:checked + label::after {
  background-color: #54ba4a;
}
body.dark-only .radio-danger input[type=radio] + label::before {
  border-color: #fc4438 !important;
}
body.dark-only .radio-danger input[type=radio] + label::after {
  background-color: #fc4438;
}
body.dark-only .radio-danger input[type=radio]:checked + label::before {
  border-color: #fc4438 !important;
}
body.dark-only .radio-danger input[type=radio]:checked + label::after {
  background-color: #fc4438;
}
body.dark-only .radio-info input[type=radio] + label::before {
  border-color: #16c7f9 !important;
}
body.dark-only .radio-info input[type=radio] + label::after {
  background-color: #16c7f9;
}
body.dark-only .radio-info input[type=radio]:checked + label::before {
  border-color: #16c7f9 !important;
}
body.dark-only .radio-info input[type=radio]:checked + label::after {
  background-color: #16c7f9;
}
body.dark-only .radio-light input[type=radio] + label::before {
  border-color: #f4f4f4 !important;
}
body.dark-only .radio-light input[type=radio] + label::after {
  background-color: #f4f4f4;
}
body.dark-only .radio-light input[type=radio]:checked + label::before {
  border-color: #f4f4f4 !important;
}
body.dark-only .radio-light input[type=radio]:checked + label::after {
  background-color: #f4f4f4;
}
body.dark-only .radio-dark input[type=radio] + label::before {
  border-color: #2c323f !important;
}
body.dark-only .radio-dark input[type=radio] + label::after {
  background-color: #2c323f;
}
body.dark-only .radio-dark input[type=radio]:checked + label::before {
  border-color: #2c323f !important;
}
body.dark-only .radio-dark input[type=radio]:checked + label::after {
  background-color: #2c323f;
}
body.dark-only .radio-warning input[type=radio] + label::before {
  border-color: #ffaa05 !important;
}
body.dark-only .radio-warning input[type=radio] + label::after {
  background-color: #ffaa05;
}
body.dark-only .radio-warning input[type=radio]:checked + label::before {
  border-color: #ffaa05 !important;
}
body.dark-only .radio-warning input[type=radio]:checked + label::after {
  background-color: #ffaa05;
}
body.dark-only .checkbox-primary label::before {
  border-color: var(--theme-default) !important;
}
body.dark-only .checkbox-secondary label::before {
  border-color: #ff3364 !important;
}
body.dark-only .checkbox-success label::before {
  border-color: #54ba4a !important;
}
body.dark-only .checkbox-danger label::before {
  border-color: #fc4438 !important;
}
body.dark-only .checkbox-info label::before {
  border-color: #16c7f9 !important;
}
body.dark-only .checkbox-light label::before {
  border-color: #f4f4f4 !important;
}
body.dark-only .checkbox-dark label::before {
  border-color: #2c323f !important;
}
body.dark-only .checkbox-warning label::before {
  border-color: #ffaa05 !important;
}
body.dark-only .checkbox-solid-primary label:before {
  background-color: var(--theme-default) !important;
  border-color: var(--theme-default) !important;
  color: #fff !important;
}
body.dark-only .checkbox-solid-primary input[type=checkbox]:checked + label::before {
  background-color: var(--theme-default) !important;
  border-color: var(--theme-default) !important;
  color: #fff !important;
}
body.dark-only .checkbox-solid-primary input[type=checkbox]:checked + label::after {
  color: #fff !important;
}
body.dark-only .checkbox-solid-secondary label:before {
  background-color: #ff3364 !important;
  border-color: #ff3364 !important;
  color: #fff !important;
}
body.dark-only .checkbox-solid-secondary input[type=checkbox]:checked + label::before {
  background-color: #ff3364 !important;
  border-color: #ff3364 !important;
  color: #fff !important;
}
body.dark-only .checkbox-solid-secondary input[type=checkbox]:checked + label::after {
  color: #fff !important;
}
body.dark-only .checkbox-solid-success label:before {
  background-color: #54ba4a !important;
  border-color: #54ba4a !important;
  color: #fff !important;
}
body.dark-only .checkbox-solid-success input[type=checkbox]:checked + label::before {
  background-color: #54ba4a !important;
  border-color: #54ba4a !important;
  color: #fff !important;
}
body.dark-only .checkbox-solid-success input[type=checkbox]:checked + label::after {
  color: #fff !important;
}
body.dark-only .checkbox-solid-danger label:before {
  background-color: #fc4438 !important;
  border-color: #fc4438 !important;
  color: #fff !important;
}
body.dark-only .checkbox-solid-danger input[type=checkbox]:checked + label::before {
  background-color: #fc4438 !important;
  border-color: #fc4438 !important;
  color: #fff !important;
}
body.dark-only .checkbox-solid-danger input[type=checkbox]:checked + label::after {
  color: #fff !important;
}
body.dark-only .checkbox-solid-info label:before {
  background-color: #16c7f9 !important;
  border-color: #16c7f9 !important;
  color: #fff !important;
}
body.dark-only .checkbox-solid-info input[type=checkbox]:checked + label::before {
  background-color: #16c7f9 !important;
  border-color: #16c7f9 !important;
  color: #fff !important;
}
body.dark-only .checkbox-solid-info input[type=checkbox]:checked + label::after {
  color: #fff !important;
}
body.dark-only .checkbox-solid-light label:before {
  background-color: #f4f4f4 !important;
  border-color: #f4f4f4 !important;
  color: #fff !important;
}
body.dark-only .checkbox-solid-light input[type=checkbox]:checked + label::before {
  background-color: #f4f4f4 !important;
  border-color: #f4f4f4 !important;
  color: #fff !important;
}
body.dark-only .checkbox-solid-light input[type=checkbox]:checked + label::after {
  color: #fff !important;
}
body.dark-only .checkbox-solid-dark label:before {
  background-color: #2c323f !important;
  border-color: #2c323f !important;
  color: #fff !important;
}
body.dark-only .checkbox-solid-dark input[type=checkbox]:checked + label::before {
  background-color: #2c323f !important;
  border-color: #2c323f !important;
  color: #fff !important;
}
body.dark-only .checkbox-solid-dark input[type=checkbox]:checked + label::after {
  color: #fff !important;
}
body.dark-only .checkbox-solid-warning label:before {
  background-color: #ffaa05 !important;
  border-color: #ffaa05 !important;
  color: #fff !important;
}
body.dark-only .checkbox-solid-warning input[type=checkbox]:checked + label::before {
  background-color: #ffaa05 !important;
  border-color: #ffaa05 !important;
  color: #fff !important;
}
body.dark-only .checkbox-solid-warning input[type=checkbox]:checked + label::after {
  color: #fff !important;
}
body.dark-only .bootstrap-datetimepicker-widget ul li {
  color: rgba(255, 255, 255, 0.6);
  border-bottom: 1px solid #1d1e26;
}
body.dark-only .bootstrap-datetimepicker-widget tr th:hover,
body.dark-only .bootstrap-datetimepicker-widget tr td:hover {
  background-color: #262932;
}
body.dark-only .bootstrap-datetimepicker-widget tr th span:hover,
body.dark-only .bootstrap-datetimepicker-widget tr td span:hover {
  background-color: #262932;
}
body.dark-only .bootstrap-datetimepicker-widget tr th.prev:hover, body.dark-only .bootstrap-datetimepicker-widget tr th.next:hover,
body.dark-only .bootstrap-datetimepicker-widget tr td.prev:hover,
body.dark-only .bootstrap-datetimepicker-widget tr td.next:hover {
  background-color: #262932;
}
body.dark-only .bootstrap-datetimepicker-widget tr:first-child th:hover {
  background-color: #262932;
}
body.dark-only .btn-transparent {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only #cal-basic .fc-toolbar .fc-left .fc-next-button .fc-icon-right-single-arrow:after,
body.dark-only #cal-basic .fc-toolbar .fc-right .fc-next-button .fc-icon-right-single-arrow:after {
  color: #98a6ad;
}
body.dark-only #cal-basic .fc-toolbar .fc-left .fc-prev-button .fc-icon-left-single-arrow:after,
body.dark-only #cal-basic .fc-toolbar .fc-right .fc-prev-button .fc-icon-left-single-arrow:after {
  color: #98a6ad;
}
body.dark-only #cal-basic .fc-toolbar .fc-left .fc-button-group .fc-month-button {
  color: #fff !important;
}
body.dark-only .fc-button-group .fc-basicWeek-button,
body.dark-only .fc-button-group .fc-basicDay-button,
body.dark-only .fc-button-group .fc-agendaWeek-button,
body.dark-only .fc-button-group .fc-agendaDay-button {
  color: #000 !important;
}
body.dark-only .fc-button-group .fc-month-button {
  color: #fff !important;
}
body.dark-only .btn-light:not([disabled]):not(.disabled).active.active {
  background-color: #1d1e26 !important;
}
body.dark-only .btn-light.disabled, body.dark-only .btn-light:disabled {
  color: rgba(47, 47, 59, 0.5) !important;
}
body.dark-only #cal-agenda-view .fc-toolbar .fc-right .fc-button-group .fc-month-button,
body.dark-only #cal-agenda-view .fc-toolbar .fc-right .fc-button-group .btn-light {
  color: #000 !important;
}
body.dark-only #cal-agenda-view .fc-toolbar .fc-right .fc-button-group .fc-agendaWeek-button {
  color: #fff !important;
}
body.dark-only #cal-agenda-view .fc-toolbar .fc-right .fc-button-group .fc-agendaWeek-button:hover {
  color: #000 !important;
}
body.dark-only .basic-calendar .fc-toolbar .fc-right .fc-button-group .fc-basicWeek-button,
body.dark-only .basic-calendar .fc-toolbar .fc-right .fc-button-group .btn-light,
body.dark-only #cal-bg-events .fc-toolbar .fc-right .fc-button-group .fc-basicWeek-button,
body.dark-only #cal-bg-events .fc-toolbar .fc-right .fc-button-group .btn-light,
body.dark-only #cal-event-colors .fc-toolbar .fc-right .fc-button-group .fc-basicWeek-button,
body.dark-only #cal-event-colors .fc-toolbar .fc-right .fc-button-group .btn-light {
  color: #000 !important;
}
body.dark-only .basic-calendar .fc-toolbar .fc-right .fc-button-group .fc-month-button,
body.dark-only #cal-bg-events .fc-toolbar .fc-right .fc-button-group .fc-month-button,
body.dark-only #cal-event-colors .fc-toolbar .fc-right .fc-button-group .fc-month-button {
  color: #fff !important;
}
body.dark-only .basic-calendar .fc-toolbar .fc-right .fc-button-group .fc-month-button:hover,
body.dark-only #cal-bg-events .fc-toolbar .fc-right .fc-button-group .fc-month-button:hover,
body.dark-only #cal-event-colors .fc-toolbar .fc-right .fc-button-group .fc-month-button:hover {
  color: #000 !important;
}
body.dark-only .categories ul li a {
  color: #98a6ad;
}
body.dark-only .categories ul li:hover {
  background-color: #1d1e26;
}
body.dark-only .socialprofile .likes-profile h5 span, body.dark-only .socialprofile .likes-profile .h5 span {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-only .socialprofile span {
  color: #98a6ad;
}
body.dark-only .social-status .media .media-body span + span {
  color: #98a6ad;
}
body.dark-only .social-status .media .media-body p,
body.dark-only .social-status .media .media-body .light-span {
  color: #98a6ad;
}
body.dark-only .filter-cards-view p,
body.dark-only .timeline-content p {
  color: #98a6ad;
}
body.dark-only .filter-cards-view .comment-number i,
body.dark-only .timeline-content .comment-number i {
  color: #98a6ad;
}
body.dark-only .filter-cards-view .comments-box .input-group .form-control,
body.dark-only .timeline-content .comments-box .input-group .form-control {
  border: none !important;
}
body.dark-only .filter-cards-view .comments-box .input-group .input-group-append,
body.dark-only .timeline-content .comments-box .input-group .input-group-append {
  background-color: #1d1e26;
}
body.dark-only .social-chat .media-body {
  border: 1px solid #1d1e26;
}
body.dark-only .social-chat .media-body:after {
  border-right: 7px solid #262932;
}
body.dark-only .social-chat span span {
  color: #98a6ad;
}
body.dark-only .details-about .your-details p {
  color: #98a6ad;
}
body.dark-only .activity-log .my-activity p {
  color: #98a6ad;
}
body.dark-only .bookmark ul li a {
  color: rgba(255, 255, 255, 0.6);
}
@media only screen and (max-width: 991.98px) {
  body.dark-only .page-wrapper.compact-wrapper .page-header .header-wrapper .toggle-sidebar {
    border-right: 1px solid #374558;
  }
}
@media only screen and (max-width: 767.98px) {
  body.dark-only .page-wrapper.material-icon .page-header {
    background-color: #262932;
  }
}
body.dark-only .apexcharts-tooltip.light {
  border-color: #374558;
  background-color: #1d1e26;
}
body.dark-only .apexcharts-tooltip.light .apexcharts-tooltip-title {
  border-color: #374558;
}
body.dark-only .apexcharts-tooltip.light .apexcharts-tooltip-text-label,
body.dark-only .apexcharts-tooltip.light .apexcharts-tooltip-text-value {
  color: #fff;
}
body.dark-sidebar .toggle-sidebar svg {
  stroke: var(--theme-default);
}
body.dark-sidebar .page-wrapper .sidebar-main-title p {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-sidebar .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper {
  background-color: #262932;
}
body.dark-sidebar .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a span {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-sidebar .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a svg {
  stroke: rgba(255, 255, 255, 0.6);
}
body.dark-sidebar .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active {
  background-color: rgba(115, 102, 255, 0.2);
}
body.dark-sidebar .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active svg {
  color: var(--theme-default);
  stroke: var(--theme-default);
}
body.dark-sidebar .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title h5, body.dark-sidebar .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title .h5 {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-sidebar .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content.opensubmegamenu li a {
  color: rgba(255, 255, 255, 0.6);
  font-weight: 400;
}
body.dark-sidebar .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container::after {
  background-color: rgba(255, 255, 255, 0.2);
}
body.dark-sidebar .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-sidebar .page-wrapper.compact-wrapper .sidebar-list ul.sidebar-submenu li a span {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-sidebar .page-wrapper.compact-wrapper .sidebar-list ul.sidebar-submenu li a.active {
  color: var(--theme-default);
}
body.dark-sidebar .page-wrapper.compact-wrapper .sidebar-list .according-menu i {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-sidebar .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper {
  background: #262932;
}
body.dark-sidebar .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main {
  background-color: #262932;
}
body.dark-sidebar .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li > a {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-sidebar .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu {
  background: #262932;
}
body.dark-sidebar .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-sidebar .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a.active, body.dark-sidebar .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a:hover {
  color: var(--theme-default);
}
body.dark-sidebar .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li .nav-sub-childmenu {
  background: #262932;
}
body.dark-sidebar .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container {
  background: #262932;
}
body.dark-sidebar .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content li a {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-sidebar .page-wrapper .left-arrow,
body.dark-sidebar .page-wrapper .right-arrow {
  background-color: #262932;
  color: rgba(255, 255, 255, 0.6);
}
body.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper > div {
  background: #262932;
}
body.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-title {
  border-bottom: 1px solid #374558;
}
body.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a span {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a svg {
  stroke: rgba(255, 255, 255, 0.6);
}
body.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu,
body.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container {
  background-color: #262932;
}
body.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu li a,
body.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container li a {
  border-bottom: 1px solid #374558;
}
body.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active {
  background-color: rgba(115, 102, 255, 0.2);
}
body.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active span {
  color: var(--theme-default);
}
body.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active svg {
  color: var(--theme-default);
  stroke: var(--theme-default);
}
body.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title h5, body.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title .h5 {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content.opensubmegamenu li a {
  color: rgba(255, 255, 255, 0.6);
  font-weight: 400;
}
body.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container::after {
  background-color: rgba(255, 255, 255, 0.2);
}
body.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list ul.sidebar-submenu li a span {
  color: rgba(255, 255, 255, 0.6);
}
body.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list ul.sidebar-submenu li a.active {
  color: var(--theme-default);
}
body.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper .according-menu i {
  color: rgba(255, 255, 255, 0.6);
}
body .for-dark {
  display: none;
}
body[class*=dark-] .for-dark {
  display: block;
}
body[class*=dark-] .for-light {
  display: none;
}

/**=====================
55. theme layout CSS ends
==========================**/
/**=====================
   59. Customizer  CSS Start
==========================**/
.customizer-links {
  position: fixed;
  right: 0px;
  top: 50%;
  z-index: 3;
  transform: translate(0, -50%);
  box-shadow: 0 0 37px rgba(8, 21, 66, 0.1);
}
.customizer-links > .nav {
  border-radius: 8px;
  padding: 10px;
  background-color: #fff;
}
.customizer-links.open {
  right: 330px;
  border-radius: 8px 0 0 8px;
  transition: all 0.3s ease;
}
.customizer-links .nav-link {
  padding: 0;
  position: relative;
}
.customizer-links .nav-link:before {
  content: "";
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: rgba(115, 102, 255, 0.1);
  border-radius: 5px;
  transform: scale(0);
  transition: all 0.3s ease;
}
.customizer-links .nav-link:after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
  top: 12px;
  border-width: 5px 0 5px 5px;
  border-left-color: rgb(90.8496732026%, 90%, 100%);
  opacity: 0;
  transform: scale(0);
  color: #fff;
  left: -10px;
  z-index: 2;
  transition: all 0.3s ease;
}
.customizer-links .nav-link:hover i {
  color: var(--theme-default);
}
.customizer-links .nav-link:hover:before, .customizer-links .nav-link:hover:after {
  opacity: 1;
  transform: scale(1);
  transition: all 0.3s ease;
}
.customizer-links .nav-link:hover span {
  opacity: 1;
  right: 48px;
  transform: scale(1);
  transition: all 0.3s ease;
}
.customizer-links .nav-link + .nav-link {
  margin-bottom: 5px;
}
.customizer-links .nav-link span {
  position: absolute;
  right: -60px;
  width: max-content;
  text-align: right;
  padding: 7px 10px;
  display: block;
  top: 0;
  border-radius: 5px;
  transform: scale(0);
  transition: all 0.3s ease;
  opacity: 0;
  color: var(--theme-default);
  background-color: rgb(90.8496732026%, 90%, 100%);
  box-shadow: 0 0 37px rgba(8, 21, 66, 0.1);
}
.customizer-links .nav-link i {
  font-size: 17px;
  padding: 8px 10px;
  display: inline-block;
  cursor: pointer;
  margin: 0;
  color: gray;
  border-radius: 5px;
}

.customizer-contain {
  direction: ltr;
  position: fixed;
  height: 100vh;
  top: 79px;
  width: 333px;
  right: -335px;
  background-color: #fff;
  z-index: 8;
  transition: all 0.3s ease;
}
.customizer-contain.open {
  right: 0px;
  transition: all 0.3s ease;
  box-shadow: 0 0 10px 1px rgba(68, 102, 242, 0.05);
}
.customizer-contain li,
.customizer-contain .list-group-item {
  position: relative;
}
.customizer-contain li.active,
.customizer-contain .list-group-item.active {
  box-shadow: 0 0 11px 5px rgba(226, 226, 226, 0.5) !important;
  background-color: #fff !important;
}
.customizer-contain h6, .customizer-contain .h6 {
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 0.5px;
  margin-top: 12px;
  padding-top: 12px;
  margin-bottom: 5px;
}
.customizer-contain .customizer-header {
  padding: 15px 25px;
  border-bottom: 1px solid #f4f4f4;
}
.customizer-contain .customizer-header .icon-close {
  position: absolute;
  font-size: 18px;
  cursor: pointer;
  font-weight: 900;
  right: 24px;
  color: var(--theme-default);
}
.customizer-contain .customizer-header h5, .customizer-contain .customizer-header .h5 {
  text-transform: uppercase;
}
.customizer-contain .customizer-body {
  padding: 15px 25px;
  max-height: calc(100vh - 200px);
  overflow-y: scroll;
}
.customizer-contain .customizer-body .fade:not(.show) {
  display: none;
}
.customizer-contain .customizer-body .unlimited-color-layout {
  display: flex;
  align-items: center;
}
.customizer-contain .customizer-body .unlimited-color-layout .btn {
  font-size: 15px;
  padding: 4px 20px;
}
.customizer-contain .customizer-body .unlimited-color-layout input {
  border: 1px solid #cccccc;
  height: 35px;
  width: 35px;
  border-radius: 5px;
  background-color: #fff;
  margin-right: 5px;
}
.customizer-contain .customizer-body .layout-grid.customizer-mix .color-layout {
  height: 70px;
  width: 80px;
  border: 1px solid #f6f7fb;
  border-radius: 5px;
}
.customizer-contain .customizer-body .tab-pane > h6:first-child, .customizer-contain .customizer-body .tab-pane > .h6:first-child {
  padding-top: 0;
  margin-top: 0;
}
.customizer-contain .customizer-body li {
  cursor: pointer;
  opacity: 0.9;
}
.customizer-contain .customizer-body li.active {
  opacity: 1;
}
.customizer-contain .customizer-body .color-layout {
  height: 35px;
  width: 35px;
  border-radius: 6px;
  display: inline-block;
  margin-right: 3px;
  border: 1px solid #b8b8b8;
  padding: 3px;
}
.customizer-contain .customizer-body .color-layout > div {
  background-color: #7366ff;
  height: 100%;
  width: 100%;
  border-radius: 5px;
}
.customizer-contain .customizer-body .color-layout[data-attr=color-2] div {
  background-color: #4831d4;
}
.customizer-contain .customizer-body .color-layout[data-attr=color-3] div {
  background-color: #d64dcf;
}
.customizer-contain .customizer-body .color-layout[data-attr=color-4] div {
  background-color: #4c2fbf;
}
.customizer-contain .customizer-body .color-layout[data-attr=color-5] div {
  background-color: #7c4dff;
}
.customizer-contain .customizer-body .color-layout[data-attr=color-6] div {
  background-color: #3949ab;
}
.customizer-contain .customizer-body .dark > li {
  background-color: #2f3c4e;
}
.customizer-contain .customizer-body .main-layout > li {
  height: 65px;
  width: 85px;
  border: 1px solid #f4f4f4;
  border-radius: 10px;
  display: inline-block;
}
.customizer-contain .customizer-body .main-layout > li + li {
  margin-left: 7px;
}
.customizer-contain .customizer-body .main-layout .box-layout .body .badge {
  left: -14px;
}
.customizer-contain .customizer-body .sidebar-type > li,
.customizer-contain .customizer-body .sidebar-setting > li {
  height: 70px;
  width: 85px;
  border: 1px solid #f4f4f4;
  border-radius: 5px;
  display: inline-block;
}
.customizer-contain .customizer-body .sidebar-type > li + li,
.customizer-contain .customizer-body .sidebar-setting > li + li {
  margin-left: 7px;
}
.customizer-contain .customizer-body .sidebar-type li[data-attr=normal-sidebar] .body ul li.bg-dark, .customizer-contain .customizer-body .sidebar-type li[data-attr=normal-sidebar] .body ul li.sidebar {
  width: 100%;
  height: 10px;
  display: block;
}
.customizer-contain .customizer-body .sidebar-type li[data-attr=normal-sidebar] .body ul li.bg-light, .customizer-contain .customizer-body .sidebar-type li[data-attr=normal-sidebar] .body ul li.body {
  height: calc(100% - 10px);
  width: 100%;
}
.customizer-contain .customizer-body .sidebar-type li[data-attr=normal-sidebar].body-compact .body ul li.body {
  width: calc(100% - 25px);
}
.customizer-contain .customizer-body .layout-types {
  margin-bottom: -30px;
}
.customizer-contain .customizer-body .layout-types > li {
  display: block;
  width: unset;
  height: unset;
  margin-bottom: 30px;
}
.customizer-contain .customizer-body .layout-types > li .layout-img h6, .customizer-contain .customizer-body .layout-types > li .layout-img .h6 {
  padding-top: 0;
  text-transform: inherit;
  text-align: center;
}
.customizer-contain .customizer-body .layout-types .box-layout {
  background: unset;
}

.layout-grid:not(.customizer-color) li {
  padding: 5px;
}
.layout-grid:not(.customizer-color) li > .header {
  height: 9px;
  border-radius: 3px;
  position: relative;
}
.layout-grid:not(.customizer-color) li > .header ul {
  position: absolute;
  top: -8px;
  left: 5px;
}
.layout-grid:not(.customizer-color) li > .header ul > li {
  display: inline-block;
  width: 4px;
  height: 4px;
  border-radius: 5px;
  top: calc(50% - 3px);
  background-color: var(--theme-default);
  margin-right: 2px;
  padding: 0;
}
.layout-grid:not(.customizer-color) li > .header ul > li:nth-child(2) {
  background-color: var(--theme-secondary);
}
.layout-grid:not(.customizer-color) li > .header ul > li:nth-child(3) {
  background-color: #54ba4a;
}
.layout-grid:not(.customizer-color) li > .body {
  background-color: #f4f4f4;
  height: calc(100% - 16px);
  border-radius: 3px;
  position: relative;
  margin-top: 5px;
  text-align: center;
  line-height: 3.1;
}
.layout-grid:not(.customizer-color) li > .body ul {
  height: 100%;
  background-color: #fff;
}
.layout-grid:not(.customizer-color) li > .body ul .sidebar {
  width: 18px;
  height: 100%;
  border-radius: 3px;
  display: inline-block;
  margin-right: 3px;
  padding: 0;
}
.layout-grid:not(.customizer-color) li > .body ul .sidebar.compact {
  width: 12px;
}
.layout-grid:not(.customizer-color) li > .body ul .sidebar.compact ~ .body {
  width: calc(100% - 19px);
}
.layout-grid:not(.customizer-color) li > .body ul .body {
  width: calc(100% - 25px);
  padding: 0;
  margin: 0;
  height: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
}
.layout-grid:not(.customizer-color) li > .body ul .body .badge {
  position: absolute;
}

/**=====================
     59.Customizer CSS Ends
==========================**/
/**=====================
     62. Responsive CSS Start
==========================**/
/* ========= min and max scss for 1200 to 1366 screen ========= */
@media (max-width: 1800px) {
  .todo-wrap .todo-list-body .task-container div.d-flex {
    min-width: 240px;
    justify-content: flex-end;
  }
  .caller-img {
    display: none;
  }
}
@media screen and (max-width: 1660px) {
  .photos ul li {
    width: 26%;
  }
  .bar-chart canvas {
    width: 100% !important;
  }
  .chat-box .chat-history .call-icons ul li {
    border: 1px solid #898989;
  }
  .chat-box .chat-history .total-time h2, .chat-box .chat-history .total-time .h2 {
    color: #898989;
  }
  .chat-box .chat-history .call-content .btn {
    width: auto;
    margin: 0 auto;
  }
  .chat-box .chat-history .call-content > div {
    z-index: 2;
    background-color: rgba(255, 255, 255, 0.75);
    background-blend-mode: overlay;
    width: 100%;
    padding: 30px;
  }
  .chat-box .chat-history .receiver-img {
    margin-top: 25px;
  }
  .chat-left-aside .people-list {
    height: 520px;
  }
  .chat-box .chat-right-aside .chat .chat-msg-box {
    height: 440px;
  }
  .chat-box .people-list ul {
    max-height: 450px;
    overflow: auto;
  }
  .call-chat-body .chat-box .people-list ul {
    max-height: 550px;
    overflow: auto;
  }
  .call-chat-body .chat-box {
    overflow: hidden;
    height: 625px;
  }
  .caller-img {
    position: absolute;
    width: 100%;
    max-width: 100%;
    left: 15px;
  }
  .caller-img img {
    opacity: 0.7;
  }
  .timeline-small .media .timeline-round.timeline-line-1:after {
    bottom: -78px;
  }
}
@media screen and (max-width: 1600px) {
  .page-wrapper.horizontal-wrapper.material-type .page-header {
    max-width: 1320px;
  }
  .page-wrapper.horizontal-wrapper.material-type .page-body-wrapper .sidebar-wrapper,
  .page-wrapper.horizontal-wrapper.material-type .page-body-wrapper .page-body {
    max-width: 1320px;
  }
  .chat-box .chat-right-aside .chat .chat-header .chat-menu-icons li {
    margin-right: 10px;
  }
}
@media (max-width: 1470px) {
  .basic_table .table-responsive .table tbody tr td:nth-child(n+2) {
    min-width: 180px;
  }
  .signal-table.table-responsive .table tbody tr td:nth-child(n+2) {
    min-width: 240px;
  }
}
@media screen and (max-width: 1660px) and (min-width: 1200px) {
  .xl-none {
    display: none;
  }
  .xl-60 {
    max-width: 60%;
    flex: 0 0 60%;
  }
  .xl-50 {
    max-width: 50%;
    flex: 0 0 50%;
  }
  .xl-100 {
    max-width: 100%;
    flex: 0 0 100%;
  }
  .xl-23 {
    max-width: 23%;
    flex: 0 0 23%;
  }
  .xl-25 {
    max-width: 25%;
    flex: 0 0 25%;
  }
  .xl-40 {
    max-width: 40%;
    flex: 0 0 40%;
  }
  .xl-4 {
    max-width: 33.33%;
    flex: 0 0 33.33%;
  }
}
@media (max-width: 1280px) {
  .img-gallery-set1,
  .img-gallery-set5 {
    display: none;
  }
  .box-layout.page-wrapper.horizontal-wrapper .page-header {
    padding-left: unset;
    max-width: unset;
    left: unset;
  }
  .box-layout.page-wrapper.horizontal-wrapper .page-body-wrapper {
    width: unset;
  }
}
@media screen and (max-width: 1580px) and (min-width: 1200px) {
  .docs-buttons,
  .docs-toggles {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
@media screen and (max-width: 1366px) and (min-width: 1200px) {
  .flot-chart-container-small {
    height: 227px;
  }
  .call-chat-sidebar {
    max-width: 262px;
  }
  .product-box .product-details {
    padding: 15px;
  }
  .product-box .product-details p {
    margin-bottom: 10px;
  }
  .flot-chart-container {
    height: 130px;
  }
  .custom-card .card-profile img {
    height: 115px;
  }
  .custom-card .profile-details h4, .custom-card .profile-details .h4 {
    font-size: 18px;
  }
  .custom-card .profile-details h6, .custom-card .profile-details .h6 {
    margin-bottom: 24px;
  }
  .custom-card .card-footer > div h3, .custom-card .card-footer > div .h3 {
    font-size: 18px;
  }
  .crm-activity {
    height: 291px;
    overflow-y: auto;
  }
  .crm-activity .media .media-body .dates {
    display: flex;
  }
  .chat-body {
    padding: 10px;
  }
  .chat-box .chat-history .call-content .btn {
    font-size: 15px;
  }
  .chat-box .chat-history .total-time h2, .chat-box .chat-history .total-time .h2 {
    font-size: 30px;
  }
  .chat-box .chat-history .receiver-img {
    margin-top: 30px;
  }
  .chat-box .chat-history .call-icons {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .chat-box .chat-history .call-icons ul li {
    width: 50px;
    height: 50px;
    padding: 7px;
  }
  .chat-box .user-image {
    width: 30px;
    height: 30px;
    margin-top: 3px;
    margin-right: 3px;
  }
  .chat-box .about {
    margin-top: 0;
  }
  .chat-box .border-tab.nav-tabs .nav-item a {
    padding: 13px 4px !important;
    color: #59667a !important;
    letter-spacing: 0;
    font-size: 12px !important;
    line-height: 6;
  }
  .chat-box .chat-menu .people-list ul.list {
    max-height: 376px;
    overflow-y: auto;
  }
  .chat-box .chat-menu .user-profile .image .avatar img {
    width: 100px;
    height: 100px;
  }
  .chat-box .chat-menu .user-profile .image .icon-wrapper {
    width: 30px;
    height: 30px;
    font-size: 13px;
  }
  .chat-left-aside .people-list {
    height: 420px;
  }
  .chat-left-aside .people-list ul {
    max-height: 376px;
    overflow-y: auto;
  }
  .chat-left-aside .status-circle {
    top: 4px;
    left: 36px;
  }
  .blog-box .blog-details-main .blog-bottom-details {
    margin: 20px 10px;
  }
  .blog-box .blog-details-main .blog-social li {
    padding: 0px 10px;
  }
  .blog-bottom-content {
    display: none;
  }
  .blog-box.blog-shadow .blog-details {
    padding: 10px;
  }
  .browser-widget .media-img {
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 15px;
  }
  .browser-widget img {
    height: 50px;
  }
  .email-wrap .email-left-aside .email-app-sidebar .media {
    display: block;
  }
  .email-wrap .email-left-aside .email-app-sidebar .media .media-size-email {
    width: 100%;
    text-align: center;
  }
  .email-wrap .email-left-aside .email-app-sidebar .media .media-size-email img {
    margin: 0 auto !important;
  }
  .email-wrap .email-left-aside .email-app-sidebar .media .media-body {
    text-align: center;
  }
  .email-wrap .email-right-aside .email-body .attachment ul li img {
    width: 73px;
    height: 73px;
  }
  .email-wrap .email-right-aside .email-body .email-top {
    line-height: 50px;
  }
  .email-wrap .email-right-aside .email-body .email-top .float-right {
    display: none !important;
  }
  .email-wrap .email-right-aside .email-body .email-top h5, .email-wrap .email-right-aside .email-body .email-top .h5 {
    padding: 13px 0;
  }
  .email-wrap .email-right-aside .email-body .inbox {
    max-height: 668px;
    overflow: auto;
  }
  .email-wrap .email-right-aside .email-body .inbox .media {
    display: block;
    text-align: center;
  }
  .email-wrap .email-right-aside .email-body .inbox .media .media-size-email {
    width: 100%;
    text-align: center;
  }
  .email-wrap .email-right-aside .email-body .inbox .media .media-size-email .mr-3 {
    margin-right: 0 !important;
  }
  .email-wrap .email-right-aside .email-body .inbox .media-body {
    text-align: center;
  }
  .email-wrap .email-right-aside .email-body .inbox .media-body h6, .email-wrap .email-right-aside .email-body .inbox .media-body .h6 {
    font-size: 14px;
  }
  .email-wrap .email-right-aside .email-body .email-compose .cke_contents.cke_reset {
    max-height: 144px;
    width: 99%;
  }
  .email-wrap .email-right-aside .email-body .email-compose .compose-border {
    margin: 0;
  }
  .alert-dismissible p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 181px;
  }
  .bootstrap-touchspin .touchspin-vertical-tab .input-group {
    width: 96% !important;
  }
}
@media only screen and (max-width: 1366px) {
  .bookmark-wrap .task-sidebar {
    height: auto;
  }
  .grid-options ul li:last-child {
    display: none;
  }
  .product-wrapper-grid.list-view .product-box .product-img {
    width: 25%;
  }
  .cart .qty-box {
    width: 40%;
  }
  .alert-dismissible strong ~ p {
    display: inline;
  }
  .timeline-small .media .media-body p {
    width: 95%;
  }
  .map-js-height {
    height: 350px;
  }
  .chat-right-aside {
    flex: 0 0 60%;
    max-width: 60%;
    overflow: hidden;
  }
  .chat-right-aside .chat .chat-message .smiley-box {
    width: 45px;
  }
  .chat-box .chat-right-aside .chat .chat-msg-box {
    height: 364px;
  }
  .chat-box .chat-right-aside .chat .chat-msg-box .chat-user-img {
    margin-top: -30px;
  }
  .chat-box .chat-right-aside .chat .chat-msg-box .message {
    width: 100%;
    padding: 15px;
  }
  .chat-box .chat-right-aside .chat .chat-header .chat-menu-icons li a i {
    font-size: 20px;
  }
  .chat-box .chat-history .receiver-img img {
    height: 150px;
  }
  .call-chat-body .chat-box {
    overflow: hidden;
    height: 565px;
  }
  .equal-height-xl {
    height: 517px;
  }
  .authentication-main .auth-innerright {
    background-size: cover;
  }
  .grp-btns {
    display: inline-block;
  }
  .button-builder .button-generator-bx {
    position: relative;
    width: 100%;
  }
  .page-builder .btn-group {
    display: inline-block;
    margin-bottom: 10px;
  }
  .page-builder .btn-grid {
    margin-bottom: 15px;
    margin-right: 0px;
    border-right: none;
    display: inline-block;
  }
  .page-builder .ge-canvas.ge-layout-desktop {
    margin-top: 50px;
  }
  .ecommerce-widget .total-num {
    font-size: 23px;
    letter-spacing: 0px;
  }
  .support-ticket-font .total-num {
    font-size: 22px;
  }
  .order-history table.dataTable.table thead th {
    padding-right: 50px;
  }
  .custom-card {
    padding: 15px;
  }
  .custom-card .card-social li a {
    padding: 12px;
  }
  .map-chart .chart-container {
    height: 300px;
  }
  .speed-chart .chart-container {
    height: 250px;
    margin-top: -40px;
    margin-bottom: 100px;
  }
  .candidcahrt {
    height: 360px;
  }
  .status-details h3, .status-details .h3 {
    font-size: 18px;
  }
  .chart-widget-top .total-value {
    font-size: 20px;
  }
  .status-widget .card-body {
    padding: 10px;
  }
  .browser-widget .media {
    flex-wrap: wrap;
  }
  .browser-widget .media .media-body h3, .browser-widget .media .media-body .h3 {
    font-size: 20px;
  }
  .browser-widget .media .media-body p {
    margin-bottom: 2px;
  }
  .browser-widget .media .media-body h4, .browser-widget .media .media-body .h4 {
    font-size: 20px;
  }
  .testimonial i {
    font-size: 46px;
  }
  .testimonial p {
    margin-top: 20px;
  }
  .redial-social-widget {
    width: 125px;
    height: 125px;
  }
  .redial-social-widget i {
    width: 100px;
    height: 100px;
    font-size: 35px;
  }
  .chat-body {
    padding: 10px;
  }
  .chat-box .chat-history .call-content .btn {
    font-size: 15px;
  }
  .chat-box .chat-history .total-time h2, .chat-box .chat-history .total-time .h2 {
    font-size: 30px;
  }
  .chat-box .chat-history .receiver-img {
    margin-top: 30px;
  }
  .chat-box .chat-history .call-icons {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .chat-box .chat-history .call-icons ul li {
    width: 50px;
    height: 50px;
    padding: 7px;
  }
  .chat-box .user-image {
    width: 45px;
    height: 45px;
  }
  .chat-box .about {
    margin-top: 0;
  }
  .chat-box .border-tab.nav-tabs .nav-item a {
    padding: 13px 4px !important;
    color: #59667a !important;
    letter-spacing: 0;
    font-size: 12px !important;
    line-height: 6;
  }
  .chat-box .chat-menu .people-list ul.list {
    max-height: 455px;
    overflow-y: auto;
  }
  .chat-box .chat-menu .user-profile {
    margin-top: 0;
  }
  .chat-box .chat-menu .user-profile .image .avatar img {
    width: 100px;
    height: 100px;
  }
  .chat-box .chat-menu .user-profile .image .icon-wrapper {
    width: 30px;
    height: 30px;
    font-size: 13px;
  }
  .chat-box .chat-menu .user-profile .user-content p {
    font-size: 14px;
    margin-bottom: 10px;
  }
  .chat-box .chat-menu .user-profile .user-content h5, .chat-box .chat-menu .user-profile .user-content .h5 {
    margin: 20px 0;
  }
  .chat-box .chat-menu .user-profile .user-content hr {
    margin: 20px 0;
  }
  .chat-box .chat-menu .user-profile .follow .follow-num {
    font-size: 20px;
  }
  .chat-left-aside .people-list {
    height: 490px;
  }
  .chat-left-aside .people-list ul {
    max-height: 434px;
    overflow-y: auto;
  }
  .status-circle {
    top: 4px;
    left: 37px;
  }
  .mega-menu .onhover-show-div {
    left: 164px;
  }
  .img-cropper .docs-toggles {
    margin-top: 8px;
  }
  .bootstrap-touchspin .dropdown-basic .dropdown .dropdown-content {
    left: -21px;
  }
  #advance-5_wrapper .dataTables_paginate {
    margin-bottom: 8px;
  }
  #batchDelete .jsgrid-grid-header .jsgrid-table .jsgrid-header-row .jsgrid-header-cell:first-child {
    width: 67px !important;
  }
  #batchDelete .jsgrid-grid-body .jsgrid-table .jsgrid-row .jsgrid-cell:first-child {
    width: 67px !important;
  }
  .reset-password-box .theme-form .form-group .btn {
    padding: 6px 22px;
  }
}
@media only screen and (max-width: 1366px) and (min-width: 1200px) {
  .page-wrapper.horizontal-wrapper.material-type .page-header {
    max-width: 1140px;
  }
  .page-wrapper.horizontal-wrapper.material-type .page-body-wrapper .sidebar-wrapper,
  .page-wrapper.horizontal-wrapper.material-type .page-body-wrapper .page-body {
    max-width: 1140px;
  }
}
@media only screen and (max-width: 1199.98px) {
  .md-sidebar .md-sidebar-toggle {
    display: block;
  }
  .md-sidebar .md-sidebar-aside {
    position: absolute;
    top: 40px;
    left: 0;
    opacity: 0;
    visibility: hidden;
    z-index: 3;
    width: 280px;
  }
  [dir=rtl] .md-sidebar .md-sidebar-aside {
    left: unset;
    right: 0;
  }
  .md-sidebar .md-sidebar-aside.open {
    opacity: 1;
    visibility: visible;
  }
  .md-sidebar .job-sidebar {
    background-color: var(--white);
    padding: 20px;
  }
  .md-sidebar .job-sidebar .faq-accordion.default-according {
    margin-bottom: 0;
  }
  .md-sidebar .job-sidebar .faq-accordion.default-according .row > div:last-child .card {
    margin-bottom: 0;
  }
  .jkanban-container .kanban-container .kanban-drag > div {
    width: 400px;
    flex-wrap: wrap;
  }
  .jkanban-container .kanban-container .kanban-drag > div > div {
    flex-wrap: wrap;
  }
  .jkanban-container .kanban-container .kanban-drag > div > div .react-kanban-column {
    display: block !important;
    margin-bottom: 20px;
  }
  .jkanban-container .kanban-container .kanban-board {
    width: 400px;
  }
  .jkanban-container .kanban-container .kanban-board .kanban-drag > div > div {
    display: block;
  }
  .jkanban-container .kanban-container .kanban-board .kanban-drag > div > div div[data-testid=lane] {
    display: block;
  }
  .file-sidebar {
    padding-right: 12px;
  }
  [dir=rtl] .file-sidebar {
    padding-right: 0;
  }
  .col-xl-7.b-center.bg-size {
    top: 0;
    height: 100vh;
    opacity: 0.5;
    position: fixed;
  }
  .login-card {
    background: transparent;
  }
  .knowledgebase-bg {
    height: 400px;
  }
  .knowledgebase-search .form-inline {
    width: 400px;
    padding: 7px 45px;
  }
  .knowledgebase-search .form-inline svg {
    top: 14px;
  }
  .btn-group .btn {
    padding: 0.375rem 1.25rem;
  }
  .link-section > div.active > h6:before, .link-section > div.active > .h6:before {
    content: "\\f107";
    transition: content 0.3s ease;
  }
  .link-section > div > h6, .link-section > div > .h6 {
    position: relative;
  }
  .link-section > div > h6:before, .link-section > div > .h6:before {
    content: "\\f105";
    font-family: fontAwesome;
    position: absolute;
    right: 10px;
    font-size: 18px;
    transition: content 0.3s ease;
  }
  .alert-theme {
    min-width: 420px;
  }
  .mega-menu-header .header-wrapper .vertical-mobile-sidebar {
    display: block;
    margin-right: 15px;
  }
  .page-wrapper .page-header .header-wrapper .nav-right {
    position: unset;
    padding: 0;
  }
  .page-wrapper .page-header .header-wrapper .nav-right > ul li .submenu li:first-child {
    padding-left: 15px !important;
  }
  .page-wrapper .page-header .header-wrapper .mobile-sidebar .switch-sm .switch {
    margin-top: 6px;
  }
  .photos ul li {
    width: auto;
  }
  .photos ul li:nth-child(3n) {
    margin-right: 15px;
  }
  .user-profile .hovercard .user-image .share-icons {
    position: absolute;
    right: 45px;
    top: -22px;
  }
  .user-profile .hovercard .user-image .share-icons li .social-icon {
    width: 40px;
    height: 40px;
  }
  .user-profile .hovercard .user-image .share-icons li .social-icon i {
    font-size: 18px;
  }
  .user-profile .hovercard .user-image .share-icons li {
    color: #fff;
    font-size: 25px;
  }
  .timeline-small .media .timeline-round.timeline-line-1:after {
    height: 33px;
    bottom: -52px;
  }
  .timeline-small .media .timeline-round.small-line:after {
    height: 18px;
    bottom: -34px;
  }
  .timeline-small .media .timeline-round.medium-line:after {
    height: 30px;
    bottom: -52px;
  }
  .timeline-small .media .media-body p {
    width: 100%;
  }
  .lg-mt-col {
    margin-top: 30px;
  }
  .xl-none {
    display: none;
  }
  .lg-mt {
    margin-top: 30px;
  }
  .product-wrapper-grid.list-view .product-box .product-img {
    width: 32%;
  }
  .debit-card {
    order: 1;
  }
  .typography .row div + div {
    margin-top: 30px;
  }
  .listing .card-body .row > div + div {
    margin-top: 30px;
  }
  .flot-chart-container {
    height: 200px;
  }
  .img-cropper #putData {
    margin-bottom: 10px;
  }
  .img-cropper .docs-toggles > .dropdown {
    margin-bottom: 0;
  }
  .error-wrapper .maintenance-icons li i {
    color: #f4f4f4;
    font-size: 40px;
  }
  .error-wrapper .maintenance-icons li:nth-child(2) i {
    font-size: 80px;
    margin-left: 90px;
  }
  .error-wrapper .maintenance-icons li:nth-child(3) i {
    font-size: 120px;
    margin-top: -75px;
    margin-right: 110px;
  }
  div.dataTables_wrapper div.dataTables_paginate ~ .dataTables_filter {
    display: block;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 0;
  }
  .jvector-map-height {
    height: 280px;
  }
  .blog-list .blog-details p {
    margin-bottom: 5px;
  }
  .custom-card .card-profile .card-footer > div h3, .custom-card .card-profile .card-footer > div .h3 {
    font-size: 18px;
  }
  .equal-height-lg {
    min-height: unset !important;
  }
  .mega-menu .onhover-show-div {
    height: 435px;
    overflow-x: scroll;
    left: 215px;
  }
  .mega-menu .mega-bg {
    display: none;
  }
  .mega-menu .lg-mt {
    margin-top: 25px;
  }
  .button-builder .button-generator-bx {
    position: relative;
    width: 100%;
  }
  .blog-single .comment-box ul .comment-social {
    margin-left: 0;
  }
  [dir=rtl] .blog-single .comment-box ul .comment-social {
    margin-left: unset;
    margin-right: 0;
  }
  .error-wrapper .maintenance-heading {
    margin-top: 30px;
  }
  .error-wrapper .maintenance-heading .headline {
    font-size: 50px;
    margin-top: -15%;
    margin-bottom: 0px;
  }
  .error-wrapper .maintenance-heading .cloud-second {
    margin-top: -25px;
  }
  .testimonial p {
    margin-top: 17px;
  }
  .browser-widget {
    padding: 0px;
  }
  .browser-widget img {
    height: 50px;
  }
  .browser-widget .media .media-body h4, .browser-widget .media .media-body .h4 {
    font-size: 17px;
  }
  .browser-widget .media .media-img {
    width: 100%;
    text-align: center;
    margin-bottom: 10px;
  }
  .crm-overall .overall-chart {
    height: 200px;
  }
  .product-table table.dataTable thead > tr > th {
    padding-right: 50px;
  }
  .chat-menu-icons {
    display: block;
    clear: both;
  }
  .chat-menu {
    right: 0;
    border-top: 1px solid #efefef;
    opacity: 0;
    transform: translateY(-30px);
    visibility: hidden;
    top: 60px;
    position: absolute !important;
    z-index: 3;
    background-color: #fff;
    transition: all linear 0.3s;
  }
  .chat-menu.show {
    opacity: 1;
    visibility: visible;
    transform: translateY(0px);
    transition: all linear 0.3s;
    padding-bottom: 25px;
  }
  .chat-box .chat-menu .people-list ul.list {
    max-height: 444px;
    overflow-y: auto;
  }
  .chat-box .btn-lg, .chat-box .btn-group-lg > .btn {
    font-size: 12px;
  }
  .chat-box .people-list ul {
    height: auto;
  }
  .chat-box .chat-right-aside .chat .chat-header {
    height: auto;
  }
  .chat-box .chat-right-aside .chat .chat-header .chat-menu-icons {
    gap: 5px;
  }
  .chat-box .chat-right-aside .chat .chat-header .chat-menu-icons li a i {
    font-size: 19px;
  }
  .chat-box .chat-right-aside .chat .chat-header .chat-menu-icons li a svg {
    width: 19px;
    height: 19px;
  }
  .chat-box .chat-right-aside .chat .chat-message {
    margin: 0;
  }
  .chat-box .chat-history .total-time h2, .chat-box .chat-history .total-time .h2 {
    font-size: 25px;
  }
  .chat-box .chat-history .row .col-sm-7 {
    padding-right: 0;
  }
  .chat-box .border-tab.nav-tabs {
    width: 100%;
  }
  .chat-box .border-tab.nav-tabs .nav-item {
    margin-right: 5px;
  }
  .chat-box .chat-left-aside .people-list {
    height: 493px;
  }
  .chat-box .chat-history .call-content > div {
    padding-top: 70px;
  }
  .chat-box .toogle-bar {
    display: inline-block;
    margin-right: 0 !important;
  }
  .chat-right-aside {
    flex: 0 0 100%;
    max-width: calc(100% - 15px);
    overflow: hidden;
  }
  .call-chat-body .chat-box {
    overflow: auto;
    height: auto;
  }
  .email-wrap .email-right-aside .email-body .b-r-light {
    border-right: none !important;
  }
  .email-wrap .email-right-aside .radius-left {
    border-top-left-radius: 4px !important;
    border-bottom-left-radius: 4px !important;
  }
  .email-wrap .row .col-xl-3 + .col-xl-3 {
    padding-right: 15px;
  }
  .email-wrap .row .col-xl-6 {
    padding-left: 15px;
  }
  .icon-lists div {
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 209px;
  }
  .like-comment-lg-mb {
    margin-bottom: 12px;
  }
  .ribbon-space-bottom {
    top: 9px;
  }
  .bootstrap-touchspin .touchspin-vertical-tab .input-group {
    width: 98.5% !important;
  }
  #batchDelete .jsgrid-grid-header .jsgrid-table .jsgrid-header-row .jsgrid-header-cell:first-child {
    width: 95px !important;
  }
  #batchDelete .jsgrid-grid-body .jsgrid-table .jsgrid-row .jsgrid-cell:first-child {
    width: 95px !important;
  }
  .profile-img-style #aniimated-thumbnials-3 {
    text-align: center;
  }
  .vertical-menu-mt {
    margin-top: 80px !important;
  }
  .vertical-menu-mt .xl-none {
    display: block;
  }
  .calendar-wrap .fc-day-grid-event {
    width: 87%;
  }
  .product-page-main .product-page-details h3, .product-page-main .product-page-details .h3 {
    font-size: 26px;
  }
}
@media only screen and (max-width: 1199px) and (min-width: 992px) {
  .page-wrapper.horizontal-wrapper.material-type .page-header {
    max-width: 930px;
  }
  .page-wrapper.horizontal-wrapper.material-type .page-body-wrapper .sidebar-wrapper,
  .page-wrapper.horizontal-wrapper.material-type .page-body-wrapper .page-body {
    max-width: 930px;
  }
}
@media only screen and (max-width: 991.98px) {
  .todo-list-wrapper #todo-list li .task-container .task-label {
    min-width: 460px;
  }
  .simplebar-mask {
    top: 70px;
  }
  .project-cards .tab-content {
    margin-bottom: -20px;
  }
  .project-box {
    margin-bottom: 20px;
  }
  .page-wrapper.modern-type .simplebar-mask {
    top: 70px;
  }
  .page-wrapper.compact-sidebar .simplebar-mask {
    top: 87px;
  }
  .page-wrapper.compact-sidebar .page-header {
    margin-left: 0;
    width: calc(100% - 0px);
  }
  .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper.close_icon .sidebar-main .sidebar-links li .sidebar-link.active ~ .sidebar-submenu {
    display: none !important;
  }
  .page-wrapper.compact-sidebar .page-body-wrapper .page-body {
    margin-top: 60px;
  }
  .page-wrapper.only-body .page-header .header-wrapper .search-full .Typeahead-menu {
    top: 65px;
  }
  .page-wrapper.advance-layout .page-body-wrapper .sidebar-wrapper {
    position: fixed !important;
    top: 0 !important;
  }
  .product-box .modal .modal-header .product-box .product-details {
    padding-left: 15px;
    padding-right: 15px;
  }
  .search-form .form-group:before {
    top: 33px;
  }
  .search-form .form-group:after {
    top: 35px;
  }
  .mobile-title.d-none {
    padding: 11px 30px 10px;
  }
  .page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown {
    top: 50px;
  }
  .page-wrapper .page-header .header-wrapper .search-full input {
    line-height: 50px;
  }
  .page-wrapper .page-header .header-wrapper .search-full .form-group .close-search {
    top: 20px;
  }
  .page-wrapper .page-header .header-wrapper .search-full .form-group:before {
    top: 18px;
  }
  .page-wrapper .current_lang .lang span.lang-txt {
    display: none;
  }
  .customizer-contain {
    top: 62px;
  }
  .m-r-30 {
    margin-right: 20px;
  }
  .card.full-card {
    top: 60px;
    width: calc(100vw - 0px);
  }
  .vertical-mobile-sidebar {
    right: 75px;
    top: 18px;
  }
  .gallery {
    margin-bottom: -20px;
  }
  .my-gallery figure {
    margin-bottom: 20px;
  }
  #aniimated-thumbnials figure:nth-child(12), #aniimated-thumbnials figure:nth-child(11), #aniimated-thumbnials figure:nth-child(10), #aniimated-thumbnials figure:nth-child(9) {
    margin-bottom: 20px;
  }
  .photoswipe-pb-responsive {
    padding-bottom: 25px !important;
  }
  table.dataTable.fixedHeader-locked, table.dataTable.fixedHeader-floating {
    left: 0 !important;
    width: 100% !important;
  }
  .page-wrapper .section-space {
    padding: 60px 0;
  }
  .page-wrapper .card {
    margin-bottom: 30px;
  }
  .page-wrapper .card .card-header,
  .page-wrapper .card .card-body,
  .page-wrapper .card .card-footer {
    padding: 20px;
  }
  .page-wrapper .card .card-header .tab-content .m-t-30,
  .page-wrapper .card .card-body .tab-content .m-t-30,
  .page-wrapper .card .card-footer .tab-content .m-t-30 {
    margin-top: 20px !important;
  }
  .page-wrapper .card .card-header .tab-content .m-b-30,
  .page-wrapper .card .card-body .tab-content .m-b-30,
  .page-wrapper .card .card-footer .tab-content .m-b-30 {
    margin-bottom: 20px !important;
  }
  .page-wrapper .page-body-wrapper .footer-fix {
    margin-left: 0px;
    padding-right: 15px;
    width: calc(100% - 0px) !important;
  }
  .page-wrapper.compact-wrapper .page-header {
    margin-left: 0 !important;
    width: calc(100% - 0px) !important;
  }
  .page-wrapper.compact-wrapper .page-header .header-wrapper .maximize {
    display: none;
  }
  .page-wrapper.compact-wrapper .page-header .header-wrapper .header-logo-wrapper {
    display: flex;
  }
  .page-wrapper.compact-wrapper .page-header .header-wrapper .toggle-sidebar {
    position: unset;
    margin-right: 15px;
    border-right: 1px solid #ddd;
    padding-right: 15px;
    display: block;
  }
  .page-wrapper.compact-wrapper .page-header .header-wrapper .toggle-sidebar:before {
    display: none;
  }
  .page-wrapper.compact-wrapper .page-header .header-wrapper .toggle-nav {
    display: none;
  }
  .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper {
    top: 0;
  }
  .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon:hover {
    transform: translate(-285px);
  }
  .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .logo-wrapper {
    padding: 17px 30px;
  }
  .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .logo-wrapper .back-btn {
    display: inline-block;
    float: right;
    font-size: 20px;
  }
  .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .logo-wrapper .toggle-sidebar {
    display: none;
  }
  .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links {
    height: calc(100vh - 95px);
  }
  .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon {
    transform: translate(-285px);
  }
  .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon .sidebar-main .sidebar-links {
    height: unset;
  }
  .page-wrapper.compact-wrapper .page-body-wrapper .page-body {
    margin-top: 60px;
    padding: 0 15px;
  }
  .page-wrapper.compact-sidebar .page-header .header-wrapper .maximize {
    display: none;
  }
  .page-wrapper.modern-type .page-header .header-wrapper .logo-wrapper {
    display: none;
    margin-right: 0;
  }
  .page-wrapper.modern-type .page-body-wrapper div.sidebar-wrapper {
    margin: 0 !important;
  }
  .page-wrapper.modern-type .page-body-wrapper div.sidebar-wrapper .logo-wrapper {
    display: block;
  }
  .page-wrapper.material-icon .page-header {
    padding-left: 0;
  }
  .page-wrapper.material-icon .page-body-wrapper .page-body {
    padding-left: 15px;
  }
  .page-wrapper .page-header .header-wrapper {
    margin: 0;
    padding: 12px 30px;
  }
  .page-wrapper .page-header .header-wrapper .nav-right .notification {
    top: 10px;
  }
  .page-wrapper .page-header .header-wrapper > .mobile-toggle {
    cursor: pointer;
    display: flex;
    align-items: center;
  }
  .page-wrapper .page-header .header-wrapper .header-logo-wrapper {
    margin-right: 0;
  }
  .page-wrapper .page-header .header-logo-wrapper .logo-wrapper img {
    margin-top: 0;
  }
  .page-body-wrapper .page-body,
  .page-body-wrapper footer {
    margin-left: 0 !important;
  }
  .page-body-wrapper .page-body #customer-review .owl-stage-outer,
  .page-body-wrapper footer #customer-review .owl-stage-outer {
    width: 100% !important;
  }
  .default-according .card {
    margin-bottom: 10px !important;
  }
  .default-according .card .card-header {
    padding: 0 !important;
  }
  .faq-wrap .faq-accordion.default-according .card .faq-header {
    padding: 20px 20px 0 !important;
  }
  .crm-activity > li + li {
    margin-top: 10px;
    padding-top: 10px;
  }
  .add-post .dropzone {
    margin-bottom: 20px;
  }
  .customers.avatar-group {
    margin-right: 20px;
  }
  .socialprofile .social-btngroup {
    margin: 20px 0;
  }
  .socialprofile .social-group {
    margin-top: 20px;
  }
  .social-status form .form-group .form-control-social {
    margin-bottom: 20px;
  }
  .social-status .media {
    margin-bottom: 20px;
  }
  .timeline-content p,
  .timeline-content .comments-box {
    margin-top: 20px;
  }
  .social-chat {
    margin-top: 20px;
  }
  .social-chat .media-body {
    padding: 20px;
  }
  .social-chat .your-msg,
  .social-chat .other-msg {
    margin-bottom: 20px;
  }
  .social-network span {
    margin-bottom: 20px;
  }
  .details-about + .details-about {
    margin-top: 20px;
  }
  .activity-log .my-activity + .my-activity {
    margin-top: 20px;
  }
  .new-users-social {
    margin-bottom: 20px;
  }
  .timeline-small .media {
    margin-bottom: 20px;
  }
  .timeline-small .media .media-body h6, .timeline-small .media .media-body .h6 {
    margin-bottom: 20px;
  }
  .timeline-small .media .media-body p {
    width: 75%;
  }
  .timeline-small .media .timeline-round {
    width: 45px;
    height: 45px;
    top: -14px;
  }
  .timeline-small .media .timeline-round.timeline-line-1:after {
    bottom: -41px;
    height: 25px;
  }
  .timeline-small .media .timeline-round.small-line:after {
    bottom: -26px;
    height: 14px;
  }
  .timeline-small .media .timeline-round.medium-line:after {
    bottom: -33px;
    height: 17px;
  }
  .timeline-small .media .timeline-round svg {
    top: 14px;
  }
  .helper-classes {
    padding: 20px;
  }
  .floated-customizer-btn,
  .floated-customizer-panel {
    display: none;
  }
  .page-builder .ge-canvas.ge-editing .row {
    padding: 20px;
  }
  .ecommerce-widget .progress-showcase {
    margin-top: 20px;
  }
  .crm-overall {
    margin: 0 -20px -20px;
  }
  .product-page-main {
    padding: 20px;
  }
  .grid-options ul li:nth-child(3) {
    display: none;
  }
  .feature-products form .form-group i {
    right: 20px;
  }
  .tabbed-card ul {
    padding: 18px 15px;
  }
  .tabbed-card ul {
    top: -7px;
    right: 0;
  }
  .tabbed-card ul.border-tab.nav-tabs {
    padding: 0;
  }
  .tabbed-card ul.border-tab.nav-tabs .nav-item .nav-link {
    padding: 10px 15px;
  }
  .tilt-showcase .tilt-image {
    text-align: center;
  }
  .tilt-showcase .mt-4 {
    margin-top: 20px !important;
  }
  .todo .todo-list-wrapper .mark-all-tasks {
    top: 20px;
    right: 20px;
  }
  .custom-card {
    padding-bottom: 0;
  }
  .custom-card .card-footer {
    padding: 0 15px 15px 15px !important;
  }
  .custom-card .card-header {
    border: none;
  }
  .custom-card .dashboard-card {
    padding: 0;
  }
  .custom-card .card-profile img {
    height: 155px;
  }
  .display-1 {
    font-size: 4rem;
  }
  .display-2 {
    font-size: 3.5rem;
  }
  .display-3 {
    font-size: 2.5rem;
  }
  .display-4 {
    font-size: 1.5rem;
  }
  .typography .h1 {
    font-size: 34px;
  }
  .typography .h2 {
    font-size: 30px;
  }
  .typography .h3 {
    font-size: 22px;
  }
  .typography .h4 {
    font-size: 20px;
  }
  .typography .h5 {
    font-size: 18px;
  }
  .typography .h6 {
    font-size: 15px;
  }
  h1, .h1 {
    font-size: 34px;
  }
  h2, .h2 {
    font-size: 28px;
  }
  h3, .h3 {
    font-size: 26px;
  }
  h4, .h4 {
    font-size: 22px;
  }
  h5, .h5 {
    font-size: 18px;
  }
  h6, .h6 {
    font-size: 15px;
  }
  .card-absolute .card-header {
    padding: 10px 15px !important;
  }
  .comingsoon .comingsoon-inner .countdown .time {
    width: 80px;
    height: 80px;
    font-size: 26px;
  }
  .calendar-wrap .basic-calendar .external-events .fc-event + .fc-event {
    margin-top: 10px;
  }
  .owl-theme .owl-nav.disabled + .owl-dots {
    margin-bottom: -10px;
    margin-top: 15px;
  }
  .card .card-header h5, .card .card-header .h5 {
    font-size: 18px;
  }
  .card .card-header .card-header-right {
    top: 12px;
    right: 15px;
  }
  .page-builder .ge-addRowGroup {
    width: 100%;
  }
  .user-profile .hovercard .info .user-designation {
    margin-bottom: 20px;
  }
  .search-list {
    justify-content: center;
  }
  .blog-single .comment-box .comment-social li {
    padding-left: 15px;
  }
  .error-wrapper {
    padding: 35px 0;
  }
  .error-wrapper .sub-content {
    font-size: 14px;
    line-height: 25px;
    margin-top: 0px;
  }
  .error-wrapper .error-heading {
    margin-top: 30px;
  }
  .error-wrapper .error-heading .headline {
    font-size: 180px;
    margin-top: 0;
  }
  .error-wrapper .maintenance-heading {
    margin-top: 30px;
  }
  .editor_container .CodeMirror {
    min-height: 250px;
    height: 250px;
  }
  .search-page .info-block {
    flex-wrap: wrap;
  }
  .search-page .tab-content .pb-4 {
    padding-bottom: 20px !important;
  }
  .xl-none {
    display: block;
  }
  .top-radius-blog {
    width: 100%;
  }
  .sm-100-w {
    width: 100%;
    height: 100%;
  }
  /*Form Wizard One start*/
  .form-wizard .btn-mb {
    margin-bottom: 20px;
  }
  /*Form Wizard One ends*/
  /*Form Wizard Two Start*/
  .stepwizard {
    margin-bottom: 20px;
  }
  /*Form Wizard Two Ends*/
  /*Form Wizard Three Start*/
  .f1 .f1-steps {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  /*Form Wizard Three ends*/
  /*Form Wizard Four Start*/
  .wizard-4 ul.anchor {
    padding-right: 20px;
    width: 40%;
  }
  .wizard-4 ul.anchor li a.done h4:before, .wizard-4 ul.anchor li a.done .h4:before {
    top: -8px;
  }
  .wizard-4 ul.anchor li h4, .wizard-4 ul.anchor li .h4 {
    padding: 11px 18px;
    width: 50px;
  }
  .wizard-4 ul.anchor li + li a {
    padding-left: 65px;
  }
  [dir=rtl] .wizard-4 ul.anchor li + li a {
    padding-right: 65px;
  }
  .wizard-4 .step-container {
    width: 60%;
  }
  .wizard-4 .step-container div.content .wizard-title {
    width: 380px;
  }
  .wizard-4 .login-card .login-main {
    width: 380px;
  }
  .wizard-4 .msg-box {
    top: 25px !important;
  }
  /*Form Wizard Four ends*/
  .border-tab.nav-tabs {
    margin-bottom: 20px;
  }
  .tab-content ~ .nav-tabs.border-tab {
    margin-top: 20px;
  }
  .dataTables_wrapper .dataTables_length {
    margin-bottom: 20px;
  }
  .dataTables_wrapper table.dataTable {
    margin-bottom: 20px !important;
  }
  .search-page .info-block + .info-block {
    padding-top: 20px;
    margin-top: 20px;
  }
  .search-page #video-links .embed-responsive + .embed-responsive {
    margin-top: 20px;
  }
  .lg-mt {
    margin-top: 20px;
  }
  .gallery-with-description {
    margin-bottom: -20px;
  }
  .gallery-with-description a > div {
    margin-bottom: 20px;
  }
  .clipboaard-container p {
    margin-bottom: 8px;
  }
  .m-b-30 {
    margin-bottom: 20px !important;
  }
  .email-wrap .email-left-aside .email-app-sidebar ul li hr {
    margin: 13px 0;
  }
  .nav-md-mt {
    margin-top: 20px;
  }
  .navs-icon {
    padding: 20px;
  }
  .navs-icon .main-section {
    padding-top: 20px;
  }
  .navs-icon .separator {
    margin: 20px 0;
  }
  .nav-list {
    padding: 20px;
  }
  .navs-dropdown button {
    margin-top: 20px;
  }
  .navs-dropdown .onhover-show-div {
    top: 68px;
  }
  .animated-modal .form-group {
    width: 100%;
    display: block;
  }
  .animated-modal .mr-4 {
    margin-right: 0 !important;
  }
  .steps-md-mt {
    margin-top: 20px;
  }
  .btn-group-wrapper .m-b-30:last-child {
    margin-bottom: 0 !important;
  }
  #advance-5_wrapper .dataTables_paginate {
    margin-bottom: 20px;
  }
  .click2edit ~ .note-editor.note-frame {
    margin-bottom: 20px;
  }
  .chat-box .chat-left-aside .people-list {
    height: 483px;
  }
  .chat-box .chat-right-aside .chat .chat-header .chat-menu-icons li {
    margin-right: 5px;
  }
  .card .card-body form.animated-modal {
    display: flex;
  }
  .card .card-body form.animated-modal .animated-modal-md-mb {
    margin-bottom: 20px !important;
  }
  .wizard-4 .msg-box {
    top: 40px;
    right: 0%;
    bottom: unset;
    left: unset;
  }
  .theme-form.form-inline {
    display: flex;
  }
}
@media only screen and (max-width: 991px) and (min-width: 768px) {
  .page-wrapper.compact-wrapper.material-type::before {
    height: 230px;
  }
  .page-wrapper.compact-wrapper.material-type .page-header {
    width: calc(100% - 60px) !important;
    margin: 50px auto 0 !important;
  }
  .page-wrapper.compact-wrapper.material-type .page-body-wrapper {
    margin: 0 30px;
  }
  .page-wrapper.compact-wrapper.material-type .page-body-wrapper div.sidebar-wrapper {
    left: 0;
  }
  .page-wrapper.compact-wrapper.material-type .page-body-wrapper .page-body {
    margin-top: 0;
  }
}
@media only screen and (max-width: 810px) {
  .page-wrapper .page-header .header-wrapper .nav-right > ul > li .profile-media .media-body {
    display: none;
  }
}
@media only screen and (max-width: 767.98px) {
  .wizard-4 ul.anchor {
    width: 100%;
    height: auto;
    padding: 30px;
  }
  .wizard-4 .step-container {
    width: 100%;
  }
  .contact-editform {
    padding-left: 20px !important;
  }
  .event-calendar {
    display: block !important;
  }
  .event-calendar #right {
    width: 100%;
  }
  .event-calendar #calendar {
    clear: both;
  }
  .page-wrapper.material-type::before {
    display: none;
  }
  .page-wrapper.material-type .page-header {
    margin-top: 0;
    border-radius: 0;
  }
  .page-wrapper.material-type .page-body-wrapper .page-body {
    margin-top: 0 !important;
  }
  .page-wrapper.only-body .page-header .header-wrapper .nav-right > ul > li {
    margin-right: -2px;
  }
  .page-wrapper.only-body .page-header .header-wrapper .nav-right .nav-menus {
    margin-right: -10px;
  }
  .new-products .owl-carousel .product-box.row > div {
    width: auto;
  }
  .profile-media .media-body {
    display: none;
  }
  .form-inline .form-group:not(.form-control-search) {
    width: 100%;
  }
  .form-inline .form-group:not(.form-control-search) + .form-group {
    margin-top: 10px;
  }
  .form-inline .form-group:not(.form-control-search) input {
    width: 100%;
  }
  .credit-card .text-center img {
    margin-bottom: 20px;
  }
  .starter-kit-fix .page-body {
    margin-bottom: 78px;
  }
  .blog-box .blog-details-main .blog-social li {
    padding: 0 12px;
  }
  .blog-box .blog-details .blog-social li:first-child {
    padding-right: 25px;
  }
  .blog-box .blog-details .blog-social li + li {
    padding-left: 25px;
  }
  .footer-copyright ~ div {
    text-align: center;
  }
  .footer-copyright ~ div p {
    float: none;
    margin-top: 5px;
  }
  .btn-showcase {
    text-align: center;
  }
  .user-profile .hovercard .user-image .share-icons {
    right: 25px;
    top: -19px;
  }
  .user-profile .hovercard .user-image .share-icons li .social-icon {
    width: 35px;
    height: 35px;
  }
  .tabs-scoial.border-tab.nav-tabs {
    display: flex;
  }
  .timeline-small .media .media-body p {
    width: 100%;
  }
  .my-gallery figure:nth-child(9), .my-gallery figure:nth-child(10) {
    margin-bottom: 20px;
  }
  .project-list .btn {
    float: left;
    margin-top: 5px;
  }
  .chat-box .chat-right-aside .chat .chat-message .text-box .btn {
    font-size: 0;
  }
  .chat-box .chat-right-aside .chat .chat-message .text-box .btn:before {
    position: absolute;
    content: "\\e661";
    font-family: themify;
    font-size: 18px;
    top: 11px;
    left: 20px;
  }
  .chat-box .border-tab.nav-tabs {
    display: flex;
  }
  .chat-box .chat-menu .nav-tabs .nav-item a {
    height: 50px;
  }
  .chat-box .chat-history .call-content > div {
    padding-top: 40px;
    height: auto;
  }
  .chat-box .chat-history .receiver-img {
    margin-bottom: unset;
  }
  .chat-box .chat-left-aside .people-list {
    height: auto;
  }
  .call-chat-sidebar {
    max-width: 100%;
    width: 100%;
    flex-basis: auto;
  }
  .call-chat-sidebar .people-list {
    height: auto;
  }
  .chat-left-aside .people-list ul {
    max-height: 100px;
  }
  .clockpicker-align-top {
    left: 55px !important;
    top: 470px !important;
  }
  .clockpicker-align-top .arrow {
    display: none;
  }
  .form-builder-column .form-body {
    min-height: 250px;
  }
  .form-builder-2-header {
    flex-wrap: wrap;
  }
  .form-builder-2-header > div {
    width: 100%;
    margin-top: 10px;
  }
  .form-builder-2-header > div nav {
    float: none;
  }
  .lg-mt-col {
    margin-top: 20px;
  }
  .form-builder .drag-box fieldset {
    padding: 20px;
    margin-top: 20px;
  }
  .form-builder #components {
    margin-top: 20px;
  }
  .form-builder .component label {
    padding-top: 0px;
  }
  .mega-menu .onhover-show-div {
    height: 415px;
    left: 0;
    top: 61px;
    padding: 20px;
  }
  .mega-menu .lg-mt {
    margin-top: 15px;
  }
  .page-builder .ge-canvas.ge-editing .ge-tools-drawer {
    margin: 10px 0 0 10px;
  }
  .page-builder .ge-canvas.ge-editing .ge-tools-drawer > a {
    padding: 0 5px;
  }
  .reader {
    margin-top: 15px;
    height: auto !important;
  }
  .range-slider.theme-form .form-group {
    margin-bottom: 0;
  }
  .note-editor .btn-group .btn {
    font-size: 11px;
  }
  .text-md-right {
    text-align: right;
  }
  .star-ratings .stars {
    padding: 0;
  }
  .form-inline.d-inline-block {
    display: block !important;
    width: 100%;
  }
  .form-inline.d-inline-block .form-control {
    margin-bottom: 10px;
  }
  .reset-password-box {
    width: 500px;
    margin: 0 auto;
  }
  .reset-password-box .card {
    padding: 20px;
  }
  .custom-card .card-profile img {
    height: 136px;
    bottom: 0;
  }
  .error-wrapper .maintenance-icons li i {
    color: #f4f4f4;
    font-size: 30px;
  }
  .error-wrapper .maintenance-icons li:nth-child(2) i {
    font-size: 60px;
    margin-top: -10px;
    margin-left: 70px;
  }
  .error-wrapper .maintenance-icons li:nth-child(3) i {
    font-size: 90px;
    margin-right: 80px;
  }
  .authentication-main .auth-innerright .social-media li {
    font-size: 14px;
  }
  .authentication-main .auth-innerright {
    min-height: unset;
    padding: 0;
  }
  .loader-box {
    justify-content: center;
  }
  .dataTables_wrapper .dataTables_length {
    margin-bottom: 20px;
  }
  .dataTables_wrapper .dataTables_filter {
    margin-left: 0;
    margin-top: 0;
    margin-bottom: 20px;
  }
  div.dataTables_wrapper div.dataTables_info {
    padding-top: 0;
  }
  div.dataTables_wrapper div.dataTables_length label, div.dataTables_wrapper div.dataTables_filter label {
    float: none;
  }
  div.dataTables_wrapper div.dataTables_paginate {
    float: none;
    margin-top: 20px !important;
    margin-left: 0 !important;
  }
  .calendar-wrap .fc-basic-view .fc-day-number {
    padding: 0 0px !important;
  }
  .calendar-wrap .fc-events-container {
    margin-top: 0px;
  }
  .calendar-wrap .fc-events-container h6, .calendar-wrap .fc-events-container .h6,
  .calendar-wrap .fc-events-container .checkbox {
    text-align: right;
  }
  .calendar-wrap .checkbox label {
    margin-top: 0;
  }
  .calendar-wrap .fc-toolbar .fc-left .fc-next-button .fc-icon-right-single-arrow:after {
    font-size: 12px !important;
  }
  .calendar-wrap .fc-toolbar .fc-left .fc-prev-button .fc-icon-left-single-arrow:after {
    font-size: 12px !important;
  }
  .calendar-wrap .fc-toolbar .fc-left .fc-today-button,
  .calendar-wrap .fc-toolbar .fc-right .fc-today-button {
    padding-top: 0px !important;
  }
  .calendar-wrap .fc button {
    font-size: 14px !important;
    padding: 0 5px !important;
  }
  .calendar-wrap .fc .fc-left {
    margin-bottom: 10px;
  }
  .calendar-wrap .fc .fc-toolbar > div {
    display: block !important;
    float: none !important;
  }
  .calendar-wrap .fc .fc-toolbar > * :first-child {
    font-size: 18px;
  }
  .calendar-wrap .fc .fc-toolbar > * > * {
    float: none !important;
  }
  .calendar-wrap .fc {
    margin-top: 0px;
  }
  .btn-group-wrapper {
    text-align: center;
  }
  .btn-group-wrapper .m-b-30 {
    margin-bottom: 15px !important;
  }
  .btn-group-showcase {
    text-align: center;
  }
  .btn-group-showcase .btn-group {
    margin-right: 0;
    margin-bottom: 15px;
  }
  .btn-group .btn {
    font-size: 14px;
    padding: 0.375rem 1.3rem;
  }
  .animate-widget .text-center {
    display: none;
  }
  .mega-menu .onhover-show-div {
    height: 350px;
  }
  .page-builder .ge-canvas .column {
    padding: 0 !important;
  }
  .page-builder .ge-content-type-ckeditor h3, .page-builder .ge-content-type-ckeditor .h3 {
    font-size: 20px;
  }
  .page-builder .ge-content-type-ckeditor p {
    font-size: 12px;
  }
  .page-builder .ge-row-icon {
    display: none !important;
  }
  /* font-awesom icon page */
  .icon-hover-bottom .form-group input {
    min-width: 270px;
  }
  .user-profile .hovercard .cardheader {
    height: 350px;
  }
  .user-profile .hovercard .info {
    padding: 35px;
  }
  .user-profile .hovercard .info .ttl-info {
    margin-bottom: 20px;
  }
  .user-profile .hovercard .info .ttl-sm-mb-0 {
    margin-bottom: 0;
  }
  .calendar-wrap .fc button {
    padding: 5px;
  }
  .calendar-wrap .fc-day-grid-event {
    margin: 0;
    padding: 5px;
    width: inherit;
  }
  .calendar-wrap .fc-toolbar h2, .calendar-wrap .fc-toolbar .h2 {
    font-size: 20px;
    line-height: 35px;
    font-weight: bold;
  }
  .calendar-wrap .basic-calendar .external-events {
    margin-top: 0px;
  }
  .blog-single .comment-box .media h6, .blog-single .comment-box .media .h6 {
    margin-bottom: 10px;
  }
  .blog-single .comment-box .media img {
    margin-right: 30px;
  }
  .blog-single .comment-box .comment-social {
    margin-bottom: 5px;
  }
  .blog-single .comment-box .comment-social li:first-child {
    padding-left: 0;
    padding-right: 15px;
  }
  .tabbed-card ul.border-tab {
    margin-bottom: 15px;
  }
  .tabbed-card ul.border-tab.nav-tabs {
    top: unset;
  }
  .tabbed-card ul.border-tab.nav-tabs .nav-item .nav-link {
    padding: 5px 15px 10px;
  }
  .tabbed-card ul {
    padding: 10px 0 5px 0;
    position: relative;
    width: 100%;
    left: 0;
  }
  .search-page #image-links .info-block.m-t-30 {
    margin-top: 0 !important;
  }
  .authentication-main .authentication-box {
    width: 100%;
  }
  .authentication-main .auth-innerright {
    display: inherit;
  }
  .map-chart .chart-container {
    height: 300px;
  }
  .candidcahrt {
    height: 250px;
  }
  .bar-chart-widget .earning-details i {
    right: 0;
  }
  .serial-chart .chart-container {
    height: 300px;
  }
  .bottom-content {
    padding: 10px;
  }
  .bottom-content p {
    font-size: 12px;
  }
  .stepwizard .stepwizard-row:before {
    top: 17px;
  }
  .icon-hover-bottom .icon-popup {
    display: block;
  }
  .icon-hover-bottom .icon-popup > .icon-last {
    display: block;
    margin-top: 15px;
  }
  .icon-hover-bottom .icon-popup > .icon-last .form-inline .form-group {
    display: flex;
  }
  .icon-hover-bottom .icon-popup div .flag-icon {
    width: 30px;
    height: auto;
  }
  .icon-hover-bottom .form-group input {
    display: block;
    width: auto !important;
  }
  .footer-links {
    text-align: center;
  }
  .footer-copyright {
    text-align: center !important;
  }
  .jvector-map-height {
    height: 150px;
  }
  .sm-left-text {
    text-align: left !important;
  }
  [dir=rtl] .sm-left-text {
    text-align: right !important;
  }
  .email-wrap .email-right-aside .email-content .email-top .d-flex {
    padding-bottom: 0;
  }
  .email-wrap .email-right-aside .email-content .email-top .float-right {
    float: left !important;
  }
  .email-wrap .email-right-aside .email-content .email-wrapper .attachment {
    text-align: center;
  }
  .email-wrap .email-right-aside .email-content .email-wrapper .attachment ul li:last-child {
    padding-right: 0;
  }
  .email-wrap .email-right-aside .email-content .email-wrapper .attachment ul li img {
    width: 140px;
    height: 140px;
  }
  .alert-dismissible p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 294px;
  }
  .button-group-mb-sm {
    margin-bottom: 5px;
  }
  .card-block .table-responsive .table tbody tr td span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100px;
  }
  .card-block .table-responsive .progress-content tbody tr td span {
    text-overflow: ellipsis;
    white-space: normal;
    max-width: 50px;
  }
  .card-block .table-responsive .checkbox-td-width tbody tr td,
  .card-block .table-responsive .radio-first-col-width tbody tr td {
    min-width: 200px !important;
  }
  #batchDelete .jsgrid-grid-header .jsgrid-table .jsgrid-header-row .jsgrid-header-cell:first-child {
    width: 119px !important;
  }
  #batchDelete .jsgrid-grid-body .jsgrid-table .jsgrid-row .jsgrid-cell:first-child {
    width: 119px !important;
  }
  .jsgrid .jsgrid-pager-container {
    text-align: center;
  }
  .chat-box .chat-right-aside .chat .chat-msg-box {
    height: auto;
  }
  .chat-box .chat-menu .nav-tabs .nav-item {
    width: 32.33%;
  }
  .chat-box .chat-menu .people-list ul.list {
    max-height: 433px;
    margin-bottom: 15px;
  }
  .chat-box .chat-menu #info-profile,
  .chat-box .chat-menu #info-contact {
    margin-bottom: 15px;
  }
  .hovercard .info .follow .text-md-right {
    text-align: center;
  }
  .profile-img-style .like-comment-sm-mb {
    margin-bottom: 20px;
  }
  .reset-password-box .theme-form .form-group .btn {
    margin-top: 15px !important;
  }
  .lg-outer .lg-actions .lg-next,
  .lg-outer .lg-actions .lg-prev {
    top: 48%;
  }
  .feature-products .filter-toggle {
    padding: 8px 15px;
    background-color: #fff;
    margin-left: 10px;
    border-radius: 5px;
  }
  .feature-products .select2-drpdwn-product {
    float: left;
    margin-right: 10px;
    margin-top: 8px;
  }
  [dir=rtl] .feature-products .select2-drpdwn-product {
    float: right;
    margin-right: unset;
    margin-left: 10px;
  }
  .feature-products span.f-w-600 {
    padding-top: 15px;
    display: inline-block;
  }
  .feature-products .text-right {
    text-align: left !important;
  }
  .d-none-productlist {
    display: block;
    margin-right: 10px;
  }
  .grid-options ul li {
    display: none;
  }
  .product-sidebar {
    transform: translateX(-300px) scaleX(0);
    opacity: 0;
    visibility: hidden;
    transition: 0.3s;
    height: 0;
    position: absolute;
    z-index: 3;
    width: 300px;
  }
  .product-sidebar.open {
    transform: translateX(0px) scaleX(1);
    box-shadow: 1px 5px 24px 0 rgba(68, 102, 242, 0.05);
    visibility: visible;
    opacity: 1;
    height: auto;
    top: -45px;
  }
  .product-sidebar.open:before, .product-sidebar.open:after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 7px solid #fff;
    right: 120px;
    top: -7px;
  }
  .product-sidebar .filter-section .card-header {
    display: none;
  }
  .product-wrapper.sidebaron .product-grid .product-wrapper-grid {
    margin-left: 0;
  }
  .product-wrapper.sidebaron .product-sidebar .filter-section .card .left-filter {
    top: unset;
    min-width: unset;
  }
  .product-wrapper-grid.list-view .product-box .product-img {
    width: 42%;
  }
  .product-filter .product-box {
    flex-wrap: nowrap;
  }
  .product-filter .product-box .product-img {
    width: 100px;
  }
  .product-filter .product-box .product-details {
    padding: 0 !important;
  }
}
@media only screen and (max-width: 575.98px) {
  .todo .todo-list-wrapper .mark-all-tasks .mark-all-tasks-container {
    display: none;
  }
  .border-tab.nav-tabs {
    display: block;
  }
  .page-wrapper .page-header .header-wrapper .search-full input {
    padding-left: 30px;
    line-height: 40px;
  }
  .page-wrapper .page-header .header-wrapper .search-full .form-group::before {
    top: 14px;
    left: 12px;
  }
  .page-wrapper .page-header .header-wrapper .search-full .form-group .close-search {
    top: 18px;
    right: 0;
    width: 18px;
    height: 18px;
  }
  .page-wrapper.only-body .page-header .header-wrapper .nav-right {
    right: 30px;
  }
  .date-picker .theme-form > .row > div:last-child {
    margin-top: 0;
  }
  .search-page .info-block {
    display: block;
  }
  .form-bookmark .row > div .row > .col-sm-6 + .col-sm-6 {
    margin-top: 10px;
  }
  .btn {
    padding: 6px 16px;
  }
  .alert-theme {
    min-width: 380px;
  }
  .knowledgebase-bg {
    height: 250px;
  }
  .login-card .login-main .theme-form .or:before {
    width: 55%;
  }
  .knowledgebase-search {
    width: calc(100% - 30px);
    left: 15px;
    height: calc(100% - 30px);
    background-color: rgba(255, 255, 255, 0.7);
  }
  .knowledgebase-search .form-inline {
    width: 90%;
    padding: 3px 45px;
  }
  .knowledgebase-search .form-inline svg {
    top: 10px;
  }
  .knowledgebase-search > div {
    width: 100%;
    text-align: center;
    padding: 15px;
    border-right: 10px;
  }
  .knowledgebase-search > div h3, .knowledgebase-search > div .h3 {
    font-size: 20px;
    margin-bottom: 0;
  }
  .knowledgebase-search > div .form-group {
    margin-bottom: 0;
  }
  .invoice .text-md-end {
    margin-top: 10px;
  }
  .invoice .text-right {
    text-align: right;
  }
  .invoice .text-xs-center {
    text-align: center;
  }
  .login-card {
    padding-top: 40px;
    padding-bottom: 40px;
  }
  .login-card .logo {
    margin-bottom: 10px;
  }
  .login-card .login-main {
    width: auto;
    padding: 20px;
  }
  .login-card .login-main .theme-form .form-group {
    margin-bottom: 5px;
  }
  .login-card .login-main .theme-form p {
    margin-bottom: 5px;
  }
  .login-card .btn-showcase .btn {
    width: 100%;
  }
  .login-card .btn-showcase .btn + .btn {
    margin-left: 0;
    margin-top: 5px;
  }
  .bookmark ul li a svg {
    height: 16px;
    width: 16px;
  }
  .bookmark ul li + li {
    margin-left: 5px;
  }
  .page-wrapper .page-header .header-wrapper .nav-right > ul > li {
    padding: 4px 6px;
  }
  .page-header .header-wrapper .nav-right .cart-box .badge,
  .page-header .header-wrapper .nav-right .notification-box .badge {
    font-size: 10px;
  }
  .page-wrapper .page-body-wrapper .page-title > .row .col-6:first-child {
    display: block;
  }
  .page-wrapper .page-body-wrapper .page-title > .row .col-6:first-child h3, .page-wrapper .page-body-wrapper .page-title > .row .col-6:first-child .h3 {
    padding-right: 0;
  }
  .page-wrapper .page-header .header-wrapper .nav-right ul li i {
    font-size: 14px !important;
  }
  .page-wrapper .page-header .header-wrapper .nav-right ul li svg {
    width: 18px;
  }
  .page-wrapper .page-body-wrapper .page-title .breadcrumb {
    margin-top: 0;
  }
  .page-wrapper.compact-wrapper .page-header .header-wrapper .logo-wrapper, .page-wrapper.compact-sidebar .page-header .header-wrapper .logo-wrapper {
    display: none;
  }
  .page-wrapper.compact-wrapper .page-header .header-wrapper .toggle-sidebar, .page-wrapper.compact-sidebar .page-header .header-wrapper .toggle-sidebar {
    margin-left: 0;
    padding-left: 0;
    border-left: none;
    border-right: 1px solid #ddd;
    padding-right: 8px;
    margin-right: 8px;
  }
  .page-wrapper.compact-wrapper .page-header .header-wrapper .toggle-sidebar svg, .page-wrapper.compact-sidebar .page-header .header-wrapper .toggle-sidebar svg {
    width: 18px;
  }
  .page-wrapper.compact-sidebar .sidebar-wrapper .back-btn {
    display: none;
  }
  .page-wrapper.compact-sidebar .sidebar-wrapper .sidebar-main .sidebar-links > li {
    margin-right: 0;
  }
  .page-wrapper .page-header .header-wrapper {
    padding: 12px 15px !important;
  }
  .page-wrapper .page-header .header-wrapper .nav-right > ul {
    top: 58px;
  }
  .page-wrapper .page-header .header-wrapper .nav-right > ul .search-form i {
    display: none;
  }
  .page-wrapper .page-header .header-wrapper .nav-right.right-header ul li.px-0 {
    padding: 6px !important;
  }
  .page-wrapper .page-header .header-wrapper .nav-right > ul li .flag-icon {
    font-size: 14px !important;
  }
  .page-wrapper .page-header .header-wrapper .nav-right > ul li .profile-media img {
    width: 25px;
  }
  .page-wrapper .page-header .header-wrapper .nav-right .notification-dropdown.onhover-show-div:before, .page-wrapper .page-header .header-wrapper .nav-right .notification-dropdown.onhover-show-div:after {
    left: 24px !important;
    right: unset !important;
  }
  .page-wrapper .page-body-wrapper .page-title .btn-group .btn {
    padding: 8px 30px;
  }
  .page-wrapper.compact-wrapper .page-body-wrapper .page-body {
    margin-top: 53px;
  }
  .page-wrapper.compact-wrapper .page-body-wrapper.sidebar-wrapper .sidebar-main .sidebar-links {
    height: calc(100vh - 79px);
  }
  .alert-dismissible {
    padding-right: 30px;
  }
  .alert-dismissible p {
    max-width: 209px;
  }
  .customizer-links {
    display: none;
  }
  .m-r-30 {
    margin-right: 15px;
  }
  .wishlist .text-end {
    text-align: left !important;
  }
  .add-post form .m-checkbox-inline label {
    margin-right: 15px;
  }
  .add-post .dropzone {
    margin-bottom: 15px;
  }
  .wizard-4 .msg-box {
    top: 10px !important;
  }
  .wizard-4 .login-card .login-main {
    width: 280px;
  }
  .wizard-4 .step-container div.content .wizard-title {
    width: 280px;
  }
  .wizard-4 .action-bar {
    right: 10px;
  }
  .wizard-4 .action-bar [dir=rtl] {
    left: 10px;
  }
  .customers.avatar-group {
    margin-right: 15px;
  }
  .vertical-mobile-sidebar {
    top: 19px;
  }
  .alert-theme i {
    margin-right: 10px !important;
  }
  .alert-theme button {
    top: 0px !important;
  }
  .bar-chart-widget .earning-details i {
    right: -30px;
  }
  .clockpicker-align-top {
    left: 45px !important;
    top: 406px !important;
  }
  .gallery {
    margin-bottom: -15px;
  }
  .my-gallery figure {
    margin-bottom: 15px;
  }
  .my-gallery figure:nth-child(9), .my-gallery figure:nth-child(10) {
    margin-bottom: 15px;
  }
  .my-gallery.gallery-with-description figure:last-child {
    margin-bottom: 20px;
  }
  #aniimated-thumbnials figure:nth-child(12), #aniimated-thumbnials figure:nth-child(11), #aniimated-thumbnials figure:nth-child(10), #aniimated-thumbnials figure:nth-child(9) {
    margin-bottom: 15px;
  }
  .photoswipe-pb-responsive {
    padding-bottom: 30px !important;
  }
  .avatar-showcase .pepole-knows {
    text-align: center;
  }
  .avatar-showcase .pepole-knows ul li {
    margin-right: 14px;
  }
  .social-app-profile .hovercard .user-image .avatar {
    margin-top: -56px;
  }
  .social-app-profile .hovercard .user-image .avatar img {
    width: 100px;
    height: 100px;
  }
  .social-app-profile .hovercard .user-image .icon-wrapper {
    left: 52%;
    top: 10px;
    height: 30px;
    width: 30px;
    font-size: 15px;
  }
  .social-app-profile .hovercard .user-image .icon-wrapper:hover {
    font-size: 12px;
  }
  .social-app-profile .hovercard .user-image .share-icons {
    right: 15px;
  }
  .social-app-profile .hovercard .user-image .share-icons li {
    margin-right: 0px;
  }
  .social-app-profile .hovercard .info .tabs-scoial .user-designation {
    border-top: none;
    border-bottom: none;
    margin-bottom: 0;
    padding: 0px 0px;
  }
  .social-app-profile .tabs-scoial {
    margin-bottom: 0 !important;
  }
  .socialprofile .social-btngroup {
    margin: 15px 0;
  }
  .socialprofile .social-group {
    margin-top: 15px;
  }
  .social-status form .form-group .form-control-social {
    margin-bottom: 15px;
  }
  .social-status .media {
    margin-bottom: 15px;
  }
  .new-users-social {
    margin-bottom: 15px;
  }
  .tabs-scoial {
    position: relative;
    padding-top: 80px;
  }
  .tabs-scoial li:nth-child(3) {
    position: absolute;
    top: 25px;
    left: 0;
    right: 0;
    margin: 0 auto;
  }
  .tabs-scoial.border-tab.nav-tabs .nav-item .nav-link {
    padding: 10px;
    height: 60px;
  }
  .timeline-content p,
  .timeline-content .comments-box {
    margin-top: 15px;
  }
  .timeline-content .comments-box .media .m-r-20 {
    margin-right: 10px;
  }
  .timeline-content .comments-box .media .media-body .input-group .input-group-append .btn {
    padding: 6px;
  }
  .timeline-content .comment-number i {
    margin-right: 15px;
  }
  #cd-timeline {
    margin-right: 0;
  }
  .social-chat {
    margin-top: 15px;
  }
  .social-chat .media-body {
    padding: 15px;
  }
  .social-chat .your-msg,
  .social-chat .other-msg {
    margin-bottom: 15px;
  }
  .social-network span {
    margin-bottom: 15px;
  }
  .social-list .media {
    margin-bottom: 15px;
  }
  .details-about + .details-about {
    margin-top: 15px;
  }
  .your-details-xs {
    margin-top: 15px;
  }
  .social-header h5 span.pull-right, .social-header .h5 span.pull-right {
    float: right !important;
    margin-top: 0 !important;
  }
  .social-header h5 span.pull-right svg, .social-header .h5 span.pull-right svg {
    width: 18px;
    height: 18px;
  }
  .activity-log .my-activity + .my-activity {
    margin-top: 15px;
  }
  .photos ul li {
    width: 26%;
  }
  .photos ul li:nth-child(3n) {
    margin-right: 0;
  }
  .chat-box .chat-history .call-content > div {
    padding-top: 30px;
  }
  .timeline-small .media {
    margin-bottom: 15px;
  }
  .timeline-small .media .media-body h6, .timeline-small .media .media-body .h6 {
    margin-bottom: 15px;
  }
  .timeline-small .media .timeline-round.timeline-line-1:after {
    bottom: -39px;
    height: 30px;
  }
  .timeline-small .media .timeline-round.small-line:after {
    bottom: -17px;
    height: 8px;
  }
  .timeline-small .media .timeline-round.medium-line:after {
    bottom: -30px;
    height: 22px;
  }
  .helper-classes {
    padding: 15px;
  }
  .form-builder-2-header ul li {
    text-align: left;
  }
  .form-builder-2-header .form-inline {
    display: block;
    width: 100%;
  }
  .form-builder-2-header .form-inline .form-group {
    width: 100%;
    margin-right: 0;
  }
  .form-builder-2-header .form-inline button {
    width: 100%;
    text-align: left;
  }
  .page-builder .btn-grid {
    margin-bottom: 7px;
    padding-right: 5px;
  }
  .page-builder .ge-canvas.ge-editing .row {
    padding: 15px;
  }
  .page-builder .ge-canvas.ge-editing .ge-tools-drawer {
    margin: 10px;
  }
  .page-builder .ge-canvas.ge-layout-desktop [class*=col-] {
    width: inherit !important;
  }
  .wizard-4 .step-container div.content {
    margin-top: 10px;
  }
  .nav-tabs .nav-item.show .nav-link {
    border-top: 0;
    border-bottom: 0;
  }
  .nav-tabs .nav-link {
    border-top: 0;
    border-bottom: 0;
  }
  .nav-tabs .nav-link:hover, .nav-tabs .nav-link.active, .nav-tabs .nav-link:focus {
    border-top: 0;
    border-bottom: 0;
  }
  .border-tab.nav-tabs .nav-item {
    width: 100% !important;
  }
  .border-tab .ecommerce-widget .progress-showcase {
    margin-top: 15px;
  }
  .nav {
    display: inherit;
    text-align: center;
    border-bottom: none;
  }
  .editor_container .CodeMirror {
    min-height: 190px;
    height: 190px;
  }
  .order-history table.dataTable.table thead th {
    padding-right: 60px;
  }
  .border-tab.nav-left .nav-link {
    text-align: center;
    border-left: none;
  }
  .border-tab.nav-right .nav-link {
    text-align: center;
    border-right: none;
  }
  .border-tab.nav-tabs {
    margin-bottom: 10px;
  }
  .tab-content ~ .nav-tabs.border-tab {
    margin-top: 10px;
  }
  .nav-pills {
    text-align: center;
  }
  .crm-overall {
    margin: 0 -15px -15px;
  }
  .product-color li {
    width: 15px;
    height: 15px;
  }
  .product-social li a {
    width: 30px;
    height: 30px;
    font-size: 13px;
  }
  .product-social li:nth-child(n+2) {
    margin-left: 5px;
  }
  [dir=rtl] .product-social li:nth-child(n+2) {
    margin-left: unset;
    margin-right: 5px;
  }
  .product-page-main {
    padding: 15px;
  }
  .product-page-main .product-page-details h3, .product-page-main .product-page-details .h3 {
    font-size: 24px;
  }
  .todo .action-box.large {
    height: 25px;
    width: 25px;
  }
  .todo .action-box.large .icon {
    font-size: 14px;
    vertical-align: -3px;
  }
  .todo .todo-list-wrapper #todo-list li .task-container .task-label {
    font-size: 14px;
  }
  .todo .todo-list-wrapper .mark-all-tasks {
    right: 15px;
  }
  .datetime-picker label {
    text-align: left !important;
  }
  .redial-chart-block {
    text-align: center;
  }
  #nav-tabContent {
    margin-top: 15px;
  }
  .reset-password-box {
    width: 430px;
  }
  .auth-bg {
    padding: 25px 15px;
  }
  .auth-bg-effect {
    display: none;
  }
  .date-picker .text-right {
    text-align: left !important;
  }
  .dataTables_wrapper table.dataTable {
    margin-bottom: 15px !important;
  }
  ul.pagination li:before {
    line-height: 3;
  }
  div.table-responsive > div.dataTables_wrapper > div.row > div[class^=col-]:last-child {
    padding-left: 0 !important;
  }
  div.table-responsive > div.dataTables_wrapper > div.row > div[class^=col-]:first-child {
    padding-right: 0 !important;
  }
  div.dataTables_wrapper div.dataTables_length {
    margin-bottom: 15px;
  }
  div.dataTables_wrapper div.dataTables_length select {
    min-height: 30px;
  }
  div.dataTables_wrapper table.dataTable th,
  div.dataTables_wrapper table.dataTable td {
    padding: 0.5rem;
  }
  div.dataTables_wrapper div.dataTables_paginate {
    margin-top: 15px !important;
  }
  div.dataTables_wrapper div.dataTables_paginate .paginate_button {
    padding: 1px 7px;
  }
  div.dataTables_wrapper div.dataTables_paginate .paginate_button.previous {
    font-size: 0;
    padding: 0;
  }
  div.dataTables_wrapper div.dataTables_paginate .paginate_button.previous a {
    border: none !important;
  }
  div.dataTables_wrapper div.dataTables_paginate .paginate_button.previous:before {
    content: "\\e64a";
    font-family: themify;
    font-size: 11px;
    padding: 0 5px;
  }
  div.dataTables_wrapper div.dataTables_paginate .paginate_button.next {
    font-size: 0;
    padding: 0;
  }
  div.dataTables_wrapper div.dataTables_paginate .paginate_button.next a {
    border: none !important;
  }
  div.dataTables_wrapper div.dataTables_paginate .paginate_button.next:before {
    content: "\\e649";
    font-family: themify;
    font-size: 11px;
    padding: 0 5px;
  }
  div.dataTables_wrapper .dataTables_filter {
    margin-bottom: 15px;
  }
  div.dataTables_wrapper .dataTables_filter input[type=search] {
    height: 30px;
  }
  .page-wrapper .page-body-wrapper .user-profile .profile-img-style {
    padding: 15px;
  }
  .page-wrapper .page-body-wrapper .user-profile .profile-img-style .img-container {
    margin-top: 15px;
  }
  .page-wrapper .page-body-wrapper .user-profile hr {
    margin: 15px 0;
  }
  .page-wrapper .page-body-wrapper .user-profile .like-comment {
    margin-top: 15px;
  }
  .jvector-map-height {
    height: 250px;
  }
  .user-profile .order-sm-0 {
    order: -1;
  }
  .user-profile .hovercard .info .ttl-info {
    text-align: center !important;
  }
  .user-profile .hovercard .info .ttl-xs-mt {
    margin-top: 20px;
  }
  .icon-hover-bottom .form-group {
    display: block !important;
    margin-bottom: 0;
  }
  .icon-hover-bottom .form-group input {
    width: 100% !important;
  }
  .icon-hover-bottom .form-group .btn {
    margin-top: 15px;
  }
  .icon-hover-bottom .icon-popup {
    padding: 15px;
  }
  .icon-hover-bottom svg.climacon {
    height: 50px;
    width: 50px;
  }
  .blog-box.blog-shadow:before {
    box-shadow: inset 0px -100px 100px -13px rgba(0, 0, 0, 0.6);
  }
  .blog-box .blog-details p,
  .blog-box .blog-details .single-blog-content-top {
    margin-top: 15px;
  }
  .blog-box .blog-details h4, .blog-box .blog-details .h4 {
    margin-top: 15px;
  }
  .blog-box .blog-details .blog-social {
    margin-top: 15px;
  }
  .blog-box .blog-details .blog-social li + li {
    padding-left: 20px;
  }
  .blog-box .blog-details .blog-social li + li > span {
    display: none;
  }
  .blog-box .blog-details .blog-social li:first-child {
    margin-right: 10px;
    padding-right: 20px;
  }
  .comment-box {
    padding-top: 40px;
    padding-bottom: 40px;
  }
  .comment-box ul ul {
    margin-left: 30px;
  }
  .comment-box li .media {
    display: block;
  }
  .comment-box li .media img {
    height: 50px;
    width: 50px;
    padding: 3px;
    margin-bottom: 10px;
  }
  .ace-editor {
    height: 320px;
  }
  .gallery > a {
    margin-bottom: 15px;
    text-align: center;
  }
  .card .card-header h5, .card .card-header .h5 {
    font-size: 17px;
  }
  .theme-form .form-group {
    margin-bottom: 15px;
  }
  .page-wrapper .page-body-wrapper .default-according .card .card-header,
  .page-wrapper .page-body-wrapper .default-according .card .card-body,
  .page-wrapper .page-body-wrapper .default-according .card .card-footer {
    padding: 0.75rem 1.25rem;
  }
  .page-wrapper .page-body-wrapper .card {
    margin-bottom: 20px;
  }
  .page-wrapper .page-body-wrapper .card .card-header .tab-content .m-t-30,
  .page-wrapper .page-body-wrapper .card .card-body .tab-content .m-t-30,
  .page-wrapper .page-body-wrapper .card .card-footer .tab-content .m-t-30 {
    margin-top: 20px !important;
  }
  .page-wrapper .page-body-wrapper .card .card-header .tab-content .m-b-30,
  .page-wrapper .page-body-wrapper .card .card-body .tab-content .m-b-30,
  .page-wrapper .page-body-wrapper .card .card-footer .tab-content .m-b-30 {
    margin-bottom: 20px !important;
  }
  .page-wrapper .page-body-wrapper .page-body {
    padding: 0 !important;
  }
  .page-wrapper .page-body-wrapper .page-title {
    padding-top: 15px;
    padding-bottom: 15px;
    margin: 0 -12px 30px !important;
  }
  .page-wrapper .page-body-wrapper .page-title .row h3, .page-wrapper .page-body-wrapper .page-title .row .h3 {
    font-size: 20px;
  }
  /* alert responsive css start here */
  .alert-primary.inverse {
    background-color: transparent;
  }
  .alert-secondary.inverse {
    background-color: transparent;
  }
  .alert-success.inverse {
    background-color: transparent;
  }
  .alert-danger.inverse {
    background-color: transparent;
  }
  .alert-warning.inverse {
    background-color: transparent;
  }
  .alert-info.inverse {
    background-color: transparent;
  }
  .alert-light.inverse {
    background-color: transparent;
  }
  .alert-dark.inverse {
    background-color: transparent;
  }
  .alert .close {
    height: 100%;
  }
  .user-profile hr {
    margin: 15px 0;
  }
  .user-profile .hovercard .cardheader {
    height: 300px;
  }
  .user-profile .hovercard .info {
    padding: 20px;
  }
  .user-profile .hovercard .info .user-designation {
    border-top: 1px solid #f4f4f4;
    border-bottom: 1px solid #f4f4f4;
    margin-bottom: 15px;
    padding: 15px 0px;
  }
  .user-profile .hovercard .social-media a {
    margin-right: 0px;
    font-size: 16px;
  }
  .user-profile .hovercard .follow .follow-num {
    font-size: 20px;
  }
  .user-profile .profile-img-style .pictures img {
    margin-bottom: 10px;
  }
  .custom-card .card-footer > div h6, .custom-card .card-footer > div .h6 {
    font-size: 14px;
    font-weight: 600;
  }
  .custom-card .card-footer > div h3, .custom-card .card-footer > div .h3 {
    font-size: 24px;
  }
  .calendar-wrap .fc-toolbar .fc-center {
    margin-top: 10px;
  }
  .calendar-wrap a.fc-more {
    font-size: 0.7em;
  }
  .mega-inline {
    display: block;
  }
  .megaoptions-border-space-sm {
    padding-bottom: 30px !important;
  }
  .blog-box.blog-shadow .blog-details {
    padding: 15px;
  }
  .blog-box.blog-shadow .blog-details p {
    margin-bottom: 0;
  }
  .blog-box.blog-shadow .blog-details h4, .blog-box.blog-shadow .blog-details .h4 {
    margin-bottom: 10px;
  }
  .blog-box.blog-list .blog-details {
    padding-top: 0;
  }
  .blog-box .blog-details {
    padding: 20px;
  }
  .blog-box .blog-date span {
    font-size: 25px;
  }
  .blog-single .blog-box .blog-details {
    padding: 0;
  }
  .error-wrapper {
    padding: 20px 0;
  }
  .error-wrapper .btn {
    margin-top: 15px;
  }
  .error-wrapper .img-100 {
    width: 50px !important;
  }
  .error-wrapper .error-heading {
    margin-top: 20px;
  }
  .error-wrapper .error-heading .cloud-second {
    margin-top: -60px;
  }
  .error-wrapper .error-heading .headline {
    font-size: 150px;
  }
  .error-wrapper .maintenance-heading .cloud-second {
    display: none;
  }
  .error-wrapper .maintenance-heading .headline {
    font-size: 25px;
    margin-top: -10%;
    letter-spacing: 2px;
  }
  .comingsoon .comingsoon-inner .coming-soon-bottom-link {
    margin-top: 20px;
    line-height: 1;
  }
  .comingsoon .comingsoon-inner h5, .comingsoon .comingsoon-inner .h5 {
    margin-bottom: 20px;
    margin-top: 20px;
  }
  .comingsoon .comingsoon-inner .countdown {
    padding: 20px 0px;
  }
  .comingsoon .comingsoon-inner .countdown ul li {
    margin: 0 7px;
  }
  .comingsoon .comingsoon-inner .countdown .title {
    font-size: 12px;
  }
  .comingsoon .comingsoon-inner .countdown .time {
    width: 45px;
    height: 45px;
    line-height: 45px;
    font-size: 16px;
    margin: 0 auto;
  }
  .form-wizard .btn-mb {
    margin-bottom: 15px;
  }
  .stepwizard {
    margin-bottom: 15px;
  }
  .f1 .f1-steps {
    margin-top: 15px;
    margin-bottom: 15px;
  }
  .wizard-4 ul.anchor {
    width: 100%;
    padding-bottom: 15px;
  }
  .wizard-4 .step-container {
    width: 100%;
  }
  .status-widget .text-sm-right {
    text-align: right;
  }
  .mega-menu {
    padding-left: 15px;
  }
  .mega-menu .onhover-show-div {
    height: 405px;
    left: 0;
    top: 61px;
    padding: 15px;
  }
  .mega-menu .lg-mt {
    margin-top: 10px;
  }
  .mega-menu .xs-mt {
    margin-top: 15px;
  }
  .nav-md-mt {
    margin-top: 15px;
  }
  .navs-icon {
    padding: 15px;
  }
  .navs-icon .main-section {
    padding-top: 15px;
  }
  .navs-icon .separator {
    margin: 15px 0;
  }
  .nav-list {
    padding: 15px;
  }
  .navs-dropdown button {
    margin-top: 15px;
  }
  .navs-dropdown .onhover-show-div {
    top: 64px;
  }
  .lg-mt {
    margin-top: 15px;
  }
  #aniimated-thumbnials a:last-child img {
    margin-bottom: 15px;
  }
  .tilt-showcase .mt-4 {
    margin-top: 15px !important;
  }
  .tilt-showcase ol .m-b-20 {
    margin-bottom: 15px !important;
  }
  .xs-mt {
    margin-top: 15px;
  }
  span:last-child.tag-pills-sm-mb {
    margin-top: 3px;
  }
  .animated-modal .form-group .form-control {
    width: 50%;
    margin: 0 auto;
  }
  .animated-modal .animated-modal-md-mb {
    margin-bottom: 15px !important;
  }
  .steps-md-mt {
    margin-top: 15px;
  }
  .steps-sizing-sm-mb {
    margin-bottom: 15px;
  }
  .bootstrap-touchspin .touchspin-vertical-tab .input-group {
    width: 96% !important;
  }
  #API-chield-row_wrapper #API-chield-row tbody tr td:first-child {
    min-width: 20px;
  }
  .chart-block .flot-chart-container p#choices {
    width: 100%;
  }
  .chart-block .flot-chart-container #toggling-series-flot {
    width: 100% !important;
  }
  .click2edit ~ .note-editor.note-frame {
    margin-bottom: 15px;
  }
  .ecommerce-widget .progress-showcase {
    margin-top: 15px;
  }
  .reset-password-box .theme-form .form-group .btn {
    margin-top: 13px !important;
  }
  .gallery-with-description a > div {
    margin-bottom: 15px;
  }
  .gallery-img-mb-sm {
    margin-bottom: 15px;
  }
  .xm-mb-peity {
    margin-bottom: 8px;
  }
  .authentication-main {
    padding: 30px 15px;
  }
  .translate_wrapper.active .more_lang:before, .translate_wrapper.active .more_lang:after {
    display: none;
  }
  .translate_wrapper.active .more_lang.active {
    position: fixed;
    width: calc(100vw - 30px);
    left: 15px;
    top: 60px;
  }
  .onhover-dropdown:hover .onhover-show-div {
    opacity: 0;
    transform: none;
    visibility: hidden;
  }
  .onhover-dropdown:hover .onhover-show-div.active {
    opacity: 1;
    transform: translateY(0px);
    visibility: visible;
    border-radius: 5px;
    overflow: hidden;
  }
  .page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div {
    width: calc(100vw - 30px);
    position: fixed;
    top: 60px;
    right: 12px;
  }
  .page-wrapper .page-header .header-wrapper .nav-right .notification-dropdown {
    width: calc(100vw - 30px);
    position: fixed;
    top: 60px;
    left: 15px !important;
  }
  .page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown {
    left: 15px;
  }
  .page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown {
    top: 43px;
  }
  .wizard-4 .action-bar .btn {
    margin: 0 2px;
  }
  .tabbed-card ul {
    right: 0px;
    left: unset;
  }
  .dropdown-basic .btn-group {
    margin-right: unset;
  }
}
@media only screen and (max-width: 480px) {
  .page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div {
    width: 280px;
  }
  .page-wrapper.only-body .page-header .header-wrapper .nav-right {
    display: none;
  }
  .chat-menu {
    top: 120px;
  }
  .product-wrapper-grid.list-view .product-box {
    display: block;
  }
  .product-wrapper-grid.list-view .product-box .product-img {
    width: 100%;
  }
  .jkanban-container .kanban-container .kanban-drag .react-kanban-board {
    justify-content: center;
  }
  .jkanban-container .kanban-container .kanban-drag > div > div {
    justify-content: center;
  }
  .datetime-picker .react-datepicker__month-container,
  .datetime-picker .react-datepicker__time-container {
    width: 100%;
  }
  .datetime-picker .react-datepicker__time-container {
    border-left: 1px solid #efefef;
  }
  .datetime-picker .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {
    width: 100%;
  }
  .datetime-picker .react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {
    right: 1px;
  }
  .cal-date-widget .react-datepicker {
    padding: 0;
  }
  .cal-date-widget .react-datepicker__navigation.react-datepicker__navigation--previous {
    left: 0;
  }
  .cal-date-widget .react-datepicker__navigation.react-datepicker__navigation--next {
    right: 0;
  }
  .jkanban-container .kanban-container .kanban-board {
    width: 100%;
  }
  .pagination-lg .page-link {
    font-size: 1rem;
  }
  h6, .h6 {
    font-size: 14px;
  }
  .prooduct-details-box .media-body {
    margin-left: 0rem !important;
  }
  .knob-block .chart-clock-main {
    margin: auto;
    width: auto;
  }
  .knob-block .chart-clock-main .clock-medium {
    position: absolute;
    left: 33px;
    top: 33px;
  }
  .knob-block .chart-clock-main .clock-medium canvas {
    width: 180px !important;
    height: 180px !important;
  }
  .knob-block .chart-clock-main .clock-small {
    left: 34px;
    top: 74px;
  }
  .knob-block .chart-clock-main .clock-large {
    left: 0;
    top: 0;
    margin: 0 auto;
  }
  .knob-block .chart-clock-main .clock-large canvas {
    width: 245px !important;
    height: 245px !important;
  }
  .knob-block > div:not(.chart-clock-main) canvas {
    width: 245px !important;
    height: 245px !important;
  }
  .wizard-4 .action-bar .btn {
    width: 100%;
  }
  .wizard-4 .action-bar .btn + .btn {
    margin-top: 10px;
  }
  ul.notification-dropdown.onhover-show-div {
    width: 260px;
    right: -80px;
  }
  ul.notification-dropdown.onhover-show-div:before, ul.notification-dropdown.onhover-show-div:after {
    right: 89px !important;
  }
  .inline-block-sm {
    display: inline-block;
  }
  .pagination-lg .page-link {
    padding: 0.3rem 0.65rem;
  }
  .nav-pills li {
    width: 100%;
  }
  .reset-password-box {
    width: 290px;
  }
  .icon-hover-bottom .icon-first {
    margin-right: 10px;
  }
  .icon-hover-bottom .icon-popup .icon-class {
    display: none;
  }
  .error-wrapper .maintenance-heading {
    margin-top: 0;
  }
  .custom-card {
    padding: 0;
  }
  .custom-card .card-footer > div h3, .custom-card .card-footer > div .h3 {
    font-size: 20px;
  }
  .custom-card .card-social li {
    padding: 5px 0;
  }
  .custom-card .profile-details h6, .custom-card .profile-details .h6 {
    margin-bottom: 15px;
  }
  .custom-card .profile-details h4, .custom-card .profile-details .h4 {
    font-size: 20px;
  }
  .custom-card .card-profile img {
    height: 93px;
  }
  .card .card-header .card-header-right i {
    margin: 0 3px;
    font-size: 14px;
  }
  .card .card-header > span + span {
    display: none;
  }
  .timeline-small .media .timeline-round.timeline-line-1:after {
    bottom: -50px;
  }
  .timeline-small .media .timeline-round.medium-line:after {
    bottom: -40px;
  }
  .dropdown-basic {
    text-align: center;
  }
  .dropup-basic {
    text-align: center;
  }
  .blog-box.blog-shadow .blog-details {
    padding: 10px;
  }
  .blog-box.blog-shadow .blog-details h4, .blog-box.blog-shadow .blog-details .h4 {
    font-size: 14px;
  }
  .stepwizard .stepwizard-row:before {
    top: 17px;
  }
  .stepwizard .stepwizard-row .stepwizard-step .btn {
    padding: 6px 22px;
  }
  .email-wrap .email-right-aside .email-content .email-wrapper .attachment ul li img {
    width: 83px;
    height: 83px;
  }
  .mega-menu {
    padding-left: 20px;
    padding-top: 3px;
  }
  .mega-menu .onhover-show-div {
    height: 405px;
    left: 0;
    top: 61px;
    padding: 15px;
  }
  .badge {
    padding: 0.42em 0.7em;
  }
  .alert-dismissible .close {
    top: -1px;
  }
  .alert-dismissible .close span {
    font-size: 19px;
  }
  .notify-alert {
    width: 90%;
  }
  .chat-box .chat-right-aside .chat .chat-header {
    display: block;
  }
  .chat-box .chat-right-aside .chat .chat-header .chat-menu-icons {
    margin-top: 15px;
    padding-left: 10px;
  }
}
@media only screen and (max-width: 420px) {
  .product-sidebar.open {
    top: -75px;
  }
  .alert-theme {
    font-size: 12px;
    min-width: 300px;
  }
  .alert-theme button {
    right: 30px !important;
  }
  .alert-theme i {
    display: none;
  }
  .alert-theme span + span + span {
    padding: 15px;
  }
  .and-many-more {
    font-size: 37px;
  }
  .tabbed-card ul.border-tab.nav-tabs .nav-item .nav-link {
    padding: 5px 15px 8px;
  }
  .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper > div {
    width: 112px;
  }
  .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu,
  .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container {
    left: 112px;
    width: 190px;
  }
  .page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper > div {
    width: 80px;
  }
  .page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu,
  .page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container {
    left: 80px;
    width: 210px;
  }
  .login-card .login-main .theme-form .link {
    position: unset;
  }
}
@media only screen and (max-width: 360px) {
  .product-box .modal .modal-header .product-box .product-details .product-qnty fieldset .input-group {
    width: 45%;
  }
  .cal-date-widget.card-body {
    padding: 14px !important;
  }
  .cal-date-widget .react-datepicker {
    min-height: 290px;
  }
  .cal-date-widget .cal-datepicker .datepicker-here .react-datepicker__day {
    line-height: 2rem;
  }
  .cal-date-widget .cal-datepicker .datepicker-here .react-datepicker__time-name {
    line-height: 2rem;
  }
  .prooduct-details-box .close {
    right: 0;
    top: 5px;
  }
  .prooduct-details-box .btn {
    padding: 4px 8px;
  }
  .prooduct-details-box .media {
    padding: 15px;
    display: block;
  }
  .prooduct-details-box .media .media-body {
    margin-top: 15px;
  }
  .datepicker--nav-action {
    width: 20px;
    margin-left: -10px;
    background-color: transparent;
  }
  .datepicker--nav-action path {
    stroke: var(--theme-default);
  }
  .clockpicker-align-top {
    top: 426px !important;
  }
  .note {
    min-width: 250px;
  }
  .datepicker {
    width: 239px;
  }
  .add-post form .m-checkbox-inline label {
    margin-bottom: 8px;
  }
  .add-post form .m-checkbox-inline label:last-child {
    margin-bottom: 0;
  }
  .map-js-height {
    height: 250px;
  }
  .bar-chart-widget .earning-details i {
    right: -73px;
  }
  .status-widget svg {
    width: 18px;
    height: 18px;
  }
  .tabs-scoial.border-tab.nav-tabs .nav-item .nav-link {
    padding: 10px 5px;
    font-size: 14px;
  }
  .user-profile .hovercard .user-image .share-icons {
    right: 6px;
    top: -15px;
  }
  .user-profile .hovercard .user-image .share-icons li .social-icon {
    width: 25px;
    height: 25px;
  }
  .user-profile .hovercard .user-image .share-icons li .social-icon i {
    font-size: 14px;
  }
  .social-chat .other-msg {
    margin-left: 15px;
  }
  .social-header h5 span.pull-right, .social-header .h5 span.pull-right {
    display: none;
  }
  .timeline-small .media .timeline-round.timeline-line-1:after {
    bottom: -74px;
    height: 56px;
  }
  .timeline-small .media .timeline-round.small-line:after {
    bottom: -32px;
    height: 14px;
  }
  .timeline-small .media .timeline-round.medium-line:after {
    bottom: -59px;
    height: 40px;
  }
  .timeline-small .media .media-body p {
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -webkit-line-clamp: 4;
  }
  .custom-card .dashboard-card {
    padding-top: 0;
  }
  .custom-card .card-profile img {
    bottom: 25px;
  }
  .custom-card .card-footer > div h6, .custom-card .card-footer > div .h6 {
    font-size: 12px;
  }
  .flot-chart-container {
    height: 230px;
  }
  .map-block {
    height: 250px;
  }
  .img-cropper .docs-tooltip {
    font-size: 11px;
  }
  .img-cropper .docs-toggles .btn-group .btn {
    padding: 0.375rem 0.2rem;
  }
  .blog-box .blog-details p {
    line-height: 1.5;
  }
  .blog-box .blog-details .blog-social li:last-child {
    padding-left: 0;
  }
  .blog-box .blog-details-main .blog-social li {
    padding: 0 10px;
  }
  .button-builder-wrap .btn-lg, .button-builder-wrap .btn-group-lg > .btn {
    font-size: 18px;
  }
  .tabs-responsive-side {
    max-width: 100%;
  }
  .browser-widget .media i {
    font-size: 52px;
  }
  .browser-widget .media .media-body h4, .browser-widget .media .media-body .h4 {
    font-size: 20px;
  }
  .bar-chart-widget .bottom-content .num {
    font-size: 17px;
  }
  .search-page .theme-form .input-group .form-control-plaintext {
    padding-left: 10px;
  }
  .search-page .theme-form .input-group .btn {
    padding: 6px 4px;
  }
  .search-page .info-block {
    padding: 20px;
  }
  .stepwizard .stepwizard-row .stepwizard-step .btn {
    padding: 6px 20px;
  }
  .wizard-4 ul.anchor {
    padding-top: 15px;
  }
  .wizard-4 .msg-box {
    top: 40px !important;
  }
  .xs-width-100 {
    min-width: 100%;
  }
  .email-wrap .action-wrapper .actions li {
    margin-right: 5px;
  }
  .email-wrap .email-body .attachment .list-inline .list-inline-item {
    padding-right: 5px;
  }
  .email-wrap .email-right-aside .email-content .email-wrapper .attachment ul li img {
    width: 65px;
    height: 65px;
  }
  .email-wrap .email-right-aside .email-top .dropdown-menu {
    left: -58px;
  }
  .form-builder #components .component .form-group #button1id {
    margin-bottom: 15px;
  }
  .default-according .card .card-header i {
    font-size: 14px;
    top: 24px;
  }
  .default-according .card .btn-link {
    display: block;
    width: 100%;
    padding-left: 17px;
  }
  .star-ratings .stars .title {
    line-height: 1;
  }
  .user-profile .hovercard .social-media a {
    padding: 0 6px;
  }
  .bootstrap-touchspin .touchspin-vertical-tab .input-group {
    width: 93% !important;
  }
  .step-container {
    height: 280px !important;
  }
  .sort-panel .d-inline .btn {
    margin-left: 87px;
  }
  .jsgrid .jsgrid-pager-container .jsgrid-pager .jsgrid-pager-page {
    padding: 0.5em 0.62em;
  }
  .chat-box .chat-right-aside {
    flex: 0 0 96%;
    max-width: 96%;
  }
  .chat-box .chat-right-aside .chat .chat-message {
    width: calc(100% - 20px);
  }
  .error-wrapper .error-heading .headline {
    font-size: 100px;
  }
  .lg-toolbar .lg-icon {
    width: 40px;
  }
  .calendar-wrap a.fc-more {
    font-size: 0.59em;
  }
  .calendar-wrap .fc th {
    font-size: 10px;
  }
  .modal-footer {
    display: block;
    text-align: center;
  }
  .modal-footer button:first-child {
    margin-bottom: 10px;
  }
  .order-box .qty li {
    font-size: 14px;
  }
  .order-box .qty li span {
    font-size: 14px;
  }
  .order-box ul li span {
    text-align: right;
  }
  .order-box ul li label {
    text-align: right;
    font-size: 14px;
  }
  .order-box .sub-total li .count {
    font-size: 14px;
  }
  .checkout .text-end {
    text-align: left !important;
    margin-top: 15px;
  }
}
@media only screen and (min-width: 576px) {
  .product-wrapper-grid.list-view .col-sm-6 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .sidebar-wrapper .back-btn {
    display: none;
  }
}
@media (width: 768px) and (height: 1024px) {
  .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links {
    height: calc(100vh - 210px);
  }
}
/**=====================
     62. Responsive CSS Ends
==========================**/
.jsgrid-filter-row select,
.jsgrid-filter-row input {
  padding: 6px 10px;
  border: 1px solid #f2f4ff;
  background: #fff;
}

.popover {
  background-color: #fff;
  border: none;
  box-shadow: 0 0 20px rgba(115, 102, 255, 0.1);
}
.popover .popover-header {
  background-color: #eae8ff;
  color: #7366ff;
  border-bottom: none;
}
.popover .popover-body {
  color: rgba(43, 43, 43, 0.7);
}

.tooltip.bs-tooltip-top .tooltip-arrow:before, .tooltip.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow:before {
  border-top-color: #eae8ff;
}
.tooltip.bs-tooltip-bottom .tooltip-arrow:before, .tooltip.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow:before {
  border-bottom-color: #eae8ff;
  border-top-color: transparent;
}
.tooltip.bs-tooltip-start .tooltip-arrow:before, .tooltip.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow:before {
  border-left-color: #eae8ff;
  border-top-color: transparent;
}
.tooltip.bs-tooltip-end .tooltip-arrow:before, .tooltip.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow:before {
  border-right-color: #eae8ff;
  border-top-color: transparent;
}
.tooltip .tooltip-inner {
  background-color: #eae8ff;
  color: #7366ff;
}
.tooltip .tooltip-arrow:before {
  border-top-color: #eae8ff;
}

.dropdown-basic .dropdown .dropdown-content a {
  padding: 6px 16px;
  color: #2b2b2b;
  opacity: 0.6;
  font-size: 13px;
  border-top: 1px solid #efefef;
  background: #fff;
}
.dropdown-basic .dropdown .dropdown-content a:hover {
  background-color: #fff;
}
.dropdown-basic .dropdown .dropdown-content .dropdown-header {
  padding: 8px 16px;
  font-weight: 400;
  color: #2c323f;
  font-size: 13px;
}
.dropdown-basic .dropup .dropup-content {
  top: auto;
}

.default-according .card .card-header {
  padding: 0;
  border: none;
  border-radius: 0;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.default-according .card .card-header.bg-primary .btn, .default-according .card .card-header.bg-secondary .btn {
  border-color: transparent;
}
.default-according .card .card-header i {
  position: initial;
  font-size: 20px;
  display: inline-block;
  vertical-align: text-bottom;
  margin-right: 5px;
}
[dir=rtl] .default-according .card .card-header i {
  margin-right: unset;
  margin-left: 5px;
}
.default-according .card .card-header h5, .default-according .card .card-header .h5 {
  margin-top: 0;
}
.default-according .card .card-header .btn-link {
  padding: 12px 20px;
  width: 100%;
  text-align: left;
  letter-spacing: 0.7px;
  font-family: Roboto;
  border: 1px solid #efefef;
  border-radius: 0;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
[dir=rtl] .default-according .card .card-header .btn-link {
  text-align: right;
}
@media (max-width: 575px) {
  .default-according .card .card-header .btn-link {
    padding: 12px 15px;
  }
}
.default-according .card .card-body {
  padding: 15px 20px;
  line-height: 22px;
  font-size: 13px;
  border-color: #efefef;
  border-radius: 0;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  color: #2c323f;
}

.nav-tabs {
  border-bottom-color: #efefef;
}
.nav-tabs .nav-bottom .nav-item .nav-link.active {
  border-color: #efefef;
}

.nav-tabs .nav-item.show .nav-link {
  font-weight: 500;
}
.nav-tabs .nav-link {
  color: #2c323f;
}
.nav-tabs .nav-link.active {
  font-weight: 500;
}
.nav-tabs.nav-bottom .nav-item .nav-link.active {
  border-color: #ecf3fa #ecf3fa #fff;
}

.dropdown-menu {
  box-shadow: 0 0 20px rgba(89, 102, 122, 0.1);
  border: none;
  padding: 0;
  z-index: 1;
}
.dropdown-menu .dropdown-item {
  color: #2b2b2b;
  opacity: 0.6;
  font-size: 13px;
  padding: 6px 12px;
  border-top: 1px solid #efefef;
  background: #fff;
}
.dropdown-menu .dropdown-item:hover {
  background-color: #fff;
}
.dropdown-menu .dropdown-divider {
  margin: 0;
  border-top: 1px solid #cccccc;
}

.border-tab .nav-tabs .nav-item .nav-link.active {
  border-bottom: 2px solid #7366ff;
}
.border-tab .nav-tabs .nav-item .nav-link.show {
  border-bottom: 2px solid #7366ff;
}
.border-tab .nav-tabs .nav-item .nav-link:focus {
  border-bottom: 2px solid #7366ff;
}

.tabbed-card .nav-tabs .nav-item .nav-link {
  top: 17px;
}

.timeliny .timeliny-dot::before {
  font-size: 18px;
}

.form-builder-header-1,
.form-builder-2-header {
  background-color: #f7f6ff;
}
.form-builder-header-1 .nav-primary .nav-link,
.form-builder-2-header .nav-primary .nav-link {
  color: #2c323f;
  font-weight: 400;
}
.form-builder-header-1 .nav-primary .nav-link.active,
.form-builder-2-header .nav-primary .nav-link.active {
  color: #fff;
}
.form-builder-header-1 h6, .form-builder-header-1 .h6,
.form-builder-2-header h6,
.form-builder-2-header .h6 {
  margin-bottom: 0;
  font-weight: 400;
  line-height: 36px;
}

.component .input-group .btn {
  line-height: 32px;
  text-transform: capitalize;
}

.form-builder .drag-box fieldset {
  margin-top: 0;
}

.login-card .login-main .theme-form label {
  font-size: 14px;
}
.login-card .login-main .theme-form .show-hide {
  top: 50%;
}

.faq-accordion .card .btn-link svg {
  margin-left: 20px;
}
@media (max-width: 575.98px) {
  .faq-accordion .card .btn-link svg {
    margin-left: 10px;
  }
}

.job-filter .faq-form .form-control {
  font-size: 14px;
}
.job-filter .faq-form .search-icon {
  width: 16px;
  height: 16px;
}

button[data-toggle=dropdown]:hover ~ .dropdown-menu {
  display: block;
  min-width: 300px;
  top: 35px;
}

.ct-label {
  fill: rgba(0, 0, 0, 0.4);
  color: rgba(0, 0, 0, 0.4);
  font-size: 0.75rem;
  line-height: 1;
}

.ct-chart-line .ct-label,
.ct-chart-bar .ct-label {
  display: block;
  display: flex;
}

.ct-chart-pie .ct-label,
.ct-chart-donut .ct-label {
  dominant-baseline: central;
}

.ct-label.ct-horizontal.ct-start {
  align-items: flex-end;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start;
}

.ct-label.ct-horizontal.ct-end {
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start;
}

.ct-label.ct-vertical.ct-start {
  align-items: flex-end;
  justify-content: flex-end;
  text-align: right;
  text-anchor: end;
}

.ct-label.ct-vertical.ct-end {
  align-items: flex-end;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start;
}

.ct-chart-bar .ct-label.ct-horizontal.ct-start {
  align-items: flex-end;
  justify-content: center;
  text-align: center;
  text-anchor: start;
}

.ct-chart-bar .ct-label.ct-horizontal.ct-end {
  align-items: flex-start;
  justify-content: center;
  text-align: center;
  text-anchor: start;
}

.ct-chart-bar.ct-horizontal-bars .ct-label.ct-horizontal.ct-start {
  align-items: flex-end;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start;
}

.ct-chart-bar.ct-horizontal-bars .ct-label.ct-horizontal.ct-end {
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start;
}

.ct-chart-bar.ct-horizontal-bars .ct-label.ct-vertical.ct-start {
  align-items: center;
  justify-content: flex-end;
  text-align: right;
  text-anchor: end;
}

.ct-chart-bar.ct-horizontal-bars .ct-label.ct-vertical.ct-end {
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  text-anchor: end;
}

.ct-grid {
  stroke: rgba(0, 0, 0, 0.2);
  stroke-width: 1px;
  stroke-dasharray: 2px;
}

.ct-grid-background {
  fill: none;
}

.ct-point {
  stroke-width: 10px;
  stroke-linecap: round;
}

.ct-line {
  fill: none;
  stroke-width: 4px;
}

.ct-area {
  stroke: none;
  fill-opacity: 0.1;
}

.ct-bar {
  fill: none;
  stroke-width: 10px;
}

.ct-slice-donut {
  fill: none;
  stroke-width: 60px;
}

.ct-series-a .ct-point, .ct-series-a .ct-line, .ct-series-a .ct-bar, .ct-series-a .ct-slice-donut {
  stroke: #7366ff;
}
.ct-series-a .ct-slice-pie, .ct-series-a .ct-slice-donut-solid, .ct-series-a .ct-area {
  fill: #7366ff;
}

.ct-series-b .ct-point, .ct-series-b .ct-line, .ct-series-b .ct-bar, .ct-series-b .ct-slice-donut {
  stroke: #f73164;
}
.ct-series-b .ct-slice-pie, .ct-series-b .ct-slice-donut-solid, .ct-series-b .ct-area {
  fill: #f73164;
}

.ct-series-c .ct-point, .ct-series-c .ct-line, .ct-series-c .ct-bar, .ct-series-c .ct-slice-donut {
  stroke: #51bb25;
}
.ct-series-c .ct-slice-pie, .ct-series-c .ct-slice-donut-solid, .ct-series-c .ct-area {
  fill: #51bb25;
}

.ct-series-d .ct-point, .ct-series-d .ct-line, .ct-series-d .ct-bar, .ct-series-d .ct-slice-donut {
  stroke: #f8d62b;
}
.ct-series-d .ct-slice-pie, .ct-series-d .ct-slice-donut-solid, .ct-series-d .ct-area {
  fill: #f8d62b;
}

.ct-series-e .ct-point, .ct-series-e .ct-line, .ct-series-e .ct-bar, .ct-series-e .ct-slice-donut {
  stroke: #f8d62b;
}
.ct-series-e .ct-slice-pie, .ct-series-e .ct-slice-donut-solid, .ct-series-e .ct-area {
  fill: #f8d62b;
}

.ct-series-f .ct-point, .ct-series-f .ct-line, .ct-series-f .ct-bar, .ct-series-f .ct-slice-donut {
  stroke: #dc3545;
}
.ct-series-f .ct-slice-pie, .ct-series-f .ct-slice-donut-solid, .ct-series-f .ct-area {
  fill: #dc3545;
}

.ct-series-g .ct-point, .ct-series-g .ct-line, .ct-series-g .ct-bar, .ct-series-g .ct-slice-donut {
  stroke: #7366ff;
}
.ct-series-g .ct-slice-pie, .ct-series-g .ct-slice-donut-solid, .ct-series-g .ct-area {
  fill: #7366ff;
}

.ct-series-h .ct-point, .ct-series-h .ct-line, .ct-series-h .ct-bar, .ct-series-h .ct-slice-donut {
  stroke: #7366ff;
}
.ct-series-h .ct-slice-pie, .ct-series-h .ct-slice-donut-solid, .ct-series-h .ct-area {
  fill: #7366ff;
}

.ct-series-i .ct-point, .ct-series-i .ct-line, .ct-series-i .ct-bar, .ct-series-i .ct-slice-donut {
  stroke: #7366ff;
}
.ct-series-i .ct-slice-pie, .ct-series-i .ct-slice-donut-solid, .ct-series-i .ct-area {
  fill: #7366ff;
}

.ct-series-j .ct-point, .ct-series-j .ct-line, .ct-series-j .ct-bar, .ct-series-j .ct-slice-donut {
  stroke: #7366ff;
}
.ct-series-j .ct-slice-pie, .ct-series-j .ct-slice-donut-solid, .ct-series-j .ct-area {
  fill: #7366ff;
}

.ct-series-k .ct-point, .ct-series-k .ct-line, .ct-series-k .ct-bar, .ct-series-k .ct-slice-donut {
  stroke: #7366ff;
}
.ct-series-k .ct-slice-pie, .ct-series-k .ct-slice-donut-solid, .ct-series-k .ct-area {
  fill: #7366ff;
}

.ct-series-l .ct-point, .ct-series-l .ct-line, .ct-series-l .ct-bar, .ct-series-l .ct-slice-donut {
  stroke: #7366ff;
}
.ct-series-l .ct-slice-pie, .ct-series-l .ct-slice-donut-solid, .ct-series-l .ct-area {
  fill: #7366ff;
}

.ct-series-m .ct-point, .ct-series-m .ct-line, .ct-series-m .ct-bar, .ct-series-m .ct-slice-donut {
  stroke: #7366ff;
}
.ct-series-m .ct-slice-pie, .ct-series-m .ct-slice-donut-solid, .ct-series-m .ct-area {
  fill: #7366ff;
}

.ct-series-n .ct-point, .ct-series-n .ct-line, .ct-series-n .ct-bar, .ct-series-n .ct-slice-donut {
  stroke: #7366ff;
}
.ct-series-n .ct-slice-pie, .ct-series-n .ct-slice-donut-solid, .ct-series-n .ct-area {
  fill: #7366ff;
}

.ct-series-o .ct-point, .ct-series-o .ct-line, .ct-series-o .ct-bar, .ct-series-o .ct-slice-donut {
  stroke: #7366ff;
}
.ct-series-o .ct-slice-pie, .ct-series-o .ct-slice-donut-solid, .ct-series-o .ct-area {
  fill: #7366ff;
}

.ct-square {
  display: block;
  position: relative;
  width: 100%;
}
.ct-square:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 100%;
}
.ct-square:after {
  content: "";
  display: table;
  clear: both;
}
.ct-square > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-minor-second {
  display: block;
  position: relative;
  width: 100%;
}
.ct-minor-second:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 93.75%;
}
.ct-minor-second:after {
  content: "";
  display: table;
  clear: both;
}
.ct-minor-second > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-second {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-second:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 88.8888888889%;
}
.ct-major-second:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-second > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-minor-third {
  display: block;
  position: relative;
  width: 100%;
}
.ct-minor-third:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 83.3333333333%;
}
.ct-minor-third:after {
  content: "";
  display: table;
  clear: both;
}
.ct-minor-third > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-third {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-third:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 80%;
}
.ct-major-third:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-third > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-perfect-fourth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-perfect-fourth:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 75%;
}
.ct-perfect-fourth:after {
  content: "";
  display: table;
  clear: both;
}
.ct-perfect-fourth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-perfect-fifth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-perfect-fifth:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 66.6666666667%;
}
.ct-perfect-fifth:after {
  content: "";
  display: table;
  clear: both;
}
.ct-perfect-fifth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-minor-sixth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-minor-sixth:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 62.5%;
}
.ct-minor-sixth:after {
  content: "";
  display: table;
  clear: both;
}
.ct-minor-sixth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-golden-section {
  display: block;
  position: relative;
  width: 100%;
}
.ct-golden-section:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 61.804697157%;
}
.ct-golden-section:after {
  content: "";
  display: table;
  clear: both;
}
.ct-golden-section > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-sixth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-sixth:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 60%;
}
.ct-major-sixth:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-sixth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-minor-seventh {
  display: block;
  position: relative;
  width: 100%;
}
.ct-minor-seventh:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 56.25%;
}
.ct-minor-seventh:after {
  content: "";
  display: table;
  clear: both;
}
.ct-minor-seventh > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-seventh {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-seventh:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 53.3333333333%;
}
.ct-major-seventh:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-seventh > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-octave {
  display: block;
  position: relative;
  width: 100%;
}
.ct-octave:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 50%;
}
.ct-octave:after {
  content: "";
  display: table;
  clear: both;
}
.ct-octave > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-tenth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-tenth:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 40%;
}
.ct-major-tenth:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-tenth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-eleventh {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-eleventh:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 37.5%;
}
.ct-major-eleventh:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-eleventh > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-twelfth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-twelfth:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 33.3333333333%;
}
.ct-major-twelfth:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-twelfth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-double-octave {
  display: block;
  position: relative;
  width: 100%;
}
.ct-double-octave:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 25%;
}
.ct-double-octave:after {
  content: "";
  display: table;
  clear: both;
}
.ct-double-octave > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

/* FONT PATH
 * -------------------------- */
@font-face {
  font-family: "themify";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_34___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_35___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_36___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_37___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
[class^=icon-],
[class*=" icon-"] {
  font-family: "themify";
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  *margin-right: 0.3em;
}

[class^=icon-]:before,
[class*=" icon-"]:before {
  text-decoration: inherit;
  display: inline-block;
  speak: none;
}

/* makes the font 33% larger relative to the icon container */
.icon-large:before {
  vertical-align: -10%;
  font-size: 1.3333333333em;
}

/* makes sure icons active on rollover in links */
a [class^=icon-],
a [class*=" icon-"] {
  display: inline;
}

/* increased font size for icon-large */
[class^=icon-].icon-fixed-width,
[class*=" icon-"].icon-fixed-width {
  display: inline-block;
  width: 1.1428571429em;
  text-align: right;
  padding-right: 0.2857142857em;
}
[class^=icon-].icon-fixed-width.icon-large,
[class*=" icon-"].icon-fixed-width.icon-large {
  width: 1.4285714286em;
}

.icons-ul {
  margin-left: 2.1428571429em;
  list-style-type: none;
}
.icons-ul > li {
  position: relative;
}
.icons-ul .icon-li {
  position: absolute;
  left: -2.1428571429em;
  width: 2.1428571429em;
  text-align: center;
  line-height: inherit;
}

[class^=icon-].hide,
[class*=" icon-"].hide {
  display: none;
}

.icon-muted {
  color: #eeeeee;
}

.icon-light {
  color: white;
}

.icon-dark {
  color: #333333;
}

.icon-border {
  border: solid 1px #eeeeee;
  padding: 0.2em 0.25em 0.15em;
  border-radius: 3px;
}

.icon-2x {
  font-size: 2em;
}
.icon-2x.icon-border {
  border-width: 2px;
  border-radius: 4px;
}

.icon-3x {
  font-size: 3em;
}
.icon-3x.icon-border {
  border-width: 3px;
  border-radius: 5px;
}

.icon-4x {
  font-size: 4em;
}
.icon-4x.icon-border {
  border-width: 4px;
  border-radius: 6px;
}

.icon-5x {
  font-size: 5em;
}
.icon-5x.icon-border {
  border-width: 5px;
  border-radius: 7px;
}

.pull-right {
  float: right;
}

.pull-left {
  float: left;
}

[class^=icon-].pull-left,
[class*=" icon-"].pull-left {
  margin-right: 0.3em;
}
[class^=icon-].pull-right,
[class*=" icon-"].pull-right {
  margin-left: 0.3em;
}

/* EXTRAS
 * -------------------------- */
/* Stacked and layered icon */
.icon-stack {
  position: relative;
  display: inline-block;
  width: 2em;
  height: 2em;
  line-height: 2em;
  vertical-align: -35%;
}
.icon-stack [class^=icon-],
.icon-stack [class*=" icon-"] {
  display: block;
  text-align: center;
  position: absolute;
  width: 100%;
  height: 100%;
  font-size: 1em;
  line-height: inherit;
  *line-height: 2em;
}
.icon-stack .icon-stack-base {
  font-size: 2em;
  *line-height: 1em;
}

/* Animated rotating icon */
.icon-spin {
  display: inline-block;
  animation: spin 2s infinite linear;
}

/* Prevent stack and spinners from being taken inline when inside a link */
a .icon-stack,
a .icon-spin {
  display: inline-block;
  text-decoration: none;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}
/* Icon rotations and mirroring */
.icon-rotate-90:before {
  transform: rotate(90deg);
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
}

.icon-rotate-180:before {
  transform: rotate(180deg);
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
}

.icon-rotate-270:before {
  transform: rotate(270deg);
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
}

.icon-flip-horizontal:before {
  transform: scale(-1, 1);
}

.icon-flip-vertical:before {
  transform: scale(1, -1);
}

/* ensure rotation occurs inside anchor tags */
a .icon-rotate-90:before, a .icon-rotate-180:before, a .icon-rotate-270:before, a .icon-flip-horizontal:before, a .icon-flip-vertical:before {
  display: inline-block;
}

.icon-wand:before {
  content: "\\e600";
}

.icon-volume:before {
  content: "\\e601";
}

.icon-user:before {
  content: "\\e602";
}

.icon-unlock:before {
  content: "\\e603";
}

.icon-unlink:before {
  content: "\\e604";
}

.icon-trash:before {
  content: "\\e605";
}

.icon-thought:before {
  content: "\\e606";
}

.icon-target:before {
  content: "\\e607";
}

.icon-tag:before {
  content: "\\e608";
}

.icon-tablet:before {
  content: "\\e609";
}

.icon-star:before {
  content: "\\e60a";
}

.icon-spray:before {
  content: "\\e60b";
}

.icon-signal:before {
  content: "\\e60c";
}

.icon-shopping-cart:before {
  content: "\\e60d";
}

.icon-shopping-cart-full:before {
  content: "\\e60e";
}

.icon-settings:before {
  content: "\\e60f";
}

.icon-search:before {
  content: "\\e610";
}

.icon-zoom-in:before {
  content: "\\e611";
}

.icon-zoom-out:before {
  content: "\\e612";
}

.icon-cut:before {
  content: "\\e613";
}

.icon-ruler:before {
  content: "\\e614";
}

.icon-ruler-pencil:before {
  content: "\\e615";
}

.icon-ruler-alt:before {
  content: "\\e616";
}

.icon-bookmark:before {
  content: "\\e617";
}

.icon-bookmark-alt:before {
  content: "\\e618";
}

.icon-reload:before {
  content: "\\e619";
}

.icon-plus:before {
  content: "\\e61a";
}

.icon-pin:before {
  content: "\\e61b";
}

.icon-pencil:before {
  content: "\\e61c";
}

.icon-pencil-alt:before {
  content: "\\e61d";
}

.icon-paint-roller:before {
  content: "\\e61e";
}

.icon-paint-bucket:before {
  content: "\\e61f";
}

.icon-na:before {
  content: "\\e620";
}

.icon-mobile:before {
  content: "\\e621";
}

.icon-minus:before {
  content: "\\e622";
}

.icon-medall:before {
  content: "\\e623";
}

.icon-medall-alt:before {
  content: "\\e624";
}

.icon-marker:before {
  content: "\\e625";
}

.icon-marker-alt:before {
  content: "\\e626";
}

.icon-arrow-up:before {
  content: "\\e627";
}

.icon-arrow-right:before {
  content: "\\e628";
}

.icon-arrow-left:before {
  content: "\\e629";
}

.icon-arrow-down:before {
  content: "\\e62a";
}

.icon-lock:before {
  content: "\\e62b";
}

.icon-location-arrow:before {
  content: "\\e62c";
}

.icon-link:before {
  content: "\\e62d";
}

.icon-layout:before {
  content: "\\e62e";
}

.icon-layers:before {
  content: "\\e62f";
}

.icon-layers-alt:before {
  content: "\\e630";
}

.icon-key:before {
  content: "\\e631";
}

.icon-import:before {
  content: "\\e632";
}

.icon-image:before {
  content: "\\e633";
}

.icon-heart:before {
  content: "\\e634";
}

.icon-heart-broken:before {
  content: "\\e635";
}

.icon-hand-stop:before {
  content: "\\e636";
}

.icon-hand-open:before {
  content: "\\e637";
}

.icon-hand-drag:before {
  content: "\\e638";
}

.icon-folder:before {
  content: "\\e639";
}

.icon-flag:before {
  content: "\\e63a";
}

.icon-flag-alt:before {
  content: "\\e63b";
}

.icon-flag-alt-2:before {
  content: "\\e63c";
}

.icon-eye:before {
  content: "\\e63d";
}

.icon-export:before {
  content: "\\e63e";
}

.icon-exchange-vertical:before {
  content: "\\e63f";
}

.icon-desktop:before {
  content: "\\e640";
}

.icon-cup:before {
  content: "\\e641";
}

.icon-crown:before {
  content: "\\e642";
}

.icon-comments:before {
  content: "\\e643";
}

.icon-comment:before {
  content: "\\e644";
}

.icon-comment-alt:before {
  content: "\\e645";
}

.icon-close:before {
  content: "\\e646";
}

.icon-clip:before {
  content: "\\e647";
}

.icon-angle-up:before {
  content: "\\e648";
}

.icon-angle-right:before {
  content: "\\e649";
}

.icon-angle-left:before {
  content: "\\e64a";
}

.icon-angle-down:before {
  content: "\\e64b";
}

.icon-check:before {
  content: "\\e64c";
}

.icon-check-box:before {
  content: "\\e64d";
}

.icon-camera:before {
  content: "\\e64e";
}

.icon-announcement:before {
  content: "\\e64f";
}

.icon-brush:before {
  content: "\\e650";
}

.icon-briefcase:before {
  content: "\\e651";
}

.icon-bolt:before {
  content: "\\e652";
}

.icon-bolt-alt:before {
  content: "\\e653";
}

.icon-blackboard:before {
  content: "\\e654";
}

.icon-bag:before {
  content: "\\e655";
}

.icon-move:before {
  content: "\\e656";
}

.icon-arrows-vertical:before {
  content: "\\e657";
}

.icon-arrows-horizontal:before {
  content: "\\e658";
}

.icon-fullscreen:before {
  content: "\\e659";
}

.icon-arrow-top-right:before {
  content: "\\e65a";
}

.icon-arrow-top-left:before {
  content: "\\e65b";
}

.icon-arrow-circle-up:before {
  content: "\\e65c";
}

.icon-arrow-circle-right:before {
  content: "\\e65d";
}

.icon-arrow-circle-left:before {
  content: "\\e65e";
}

.icon-arrow-circle-down:before {
  content: "\\e65f";
}

.icon-angle-double-up:before {
  content: "\\e660";
}

.icon-angle-double-right:before {
  content: "\\e661";
}

.icon-angle-double-left:before {
  content: "\\e662";
}

.icon-angle-double-down:before {
  content: "\\e663";
}

.icon-zip:before {
  content: "\\e664";
}

.icon-world:before {
  content: "\\e665";
}

.icon-wheelchair:before {
  content: "\\e666";
}

.icon-view-list:before {
  content: "\\e667";
}

.icon-view-list-alt:before {
  content: "\\e668";
}

.icon-view-grid:before {
  content: "\\e669";
}

.icon-uppercase:before {
  content: "\\e66a";
}

.icon-upload:before {
  content: "\\e66b";
}

.icon-underline:before {
  content: "\\e66c";
}

.icon-truck:before {
  content: "\\e66d";
}

.icon-timer:before {
  content: "\\e66e";
}

.icon-ticket:before {
  content: "\\e66f";
}

.icon-thumb-up:before {
  content: "\\e670";
}

.icon-thumb-down:before {
  content: "\\e671";
}

.icon-text:before {
  content: "\\e672";
}

.icon-stats-up:before {
  content: "\\e673";
}

.icon-stats-down:before {
  content: "\\e674";
}

.icon-split-v:before {
  content: "\\e675";
}

.icon-split-h:before {
  content: "\\e676";
}

.icon-smallcap:before {
  content: "\\e677";
}

.icon-shine:before {
  content: "\\e678";
}

.icon-shift-right:before {
  content: "\\e679";
}

.icon-shift-left:before {
  content: "\\e67a";
}

.icon-shield:before {
  content: "\\e67b";
}

.icon-notepad:before {
  content: "\\e67c";
}

.icon-server:before {
  content: "\\e67d";
}

.icon-quote-right:before {
  content: "\\e67e";
}

.icon-quote-left:before {
  content: "\\e67f";
}

.icon-pulse:before {
  content: "\\e680";
}

.icon-printer:before {
  content: "\\e681";
}

.icon-power-off:before {
  content: "\\e682";
}

.icon-plug:before {
  content: "\\e683";
}

.icon-pie-chart:before {
  content: "\\e684";
}

.icon-paragraph:before {
  content: "\\e685";
}

.icon-panel:before {
  content: "\\e686";
}

.icon-package:before {
  content: "\\e687";
}

.icon-music:before {
  content: "\\e688";
}

.icon-music-alt:before {
  content: "\\e689";
}

.icon-mouse:before {
  content: "\\e68a";
}

.icon-mouse-alt:before {
  content: "\\e68b";
}

.icon-money:before {
  content: "\\e68c";
}

.icon-microphone:before {
  content: "\\e68d";
}

.icon-menu:before {
  content: "\\e68e";
}

.icon-menu-alt:before {
  content: "\\e68f";
}

.icon-map:before {
  content: "\\e690";
}

.icon-map-alt:before {
  content: "\\e691";
}

.icon-loop:before {
  content: "\\e692";
}

.icon-location-pin:before {
  content: "\\e693";
}

.icon-list:before {
  content: "\\e694";
}

.icon-light-bulb:before {
  content: "\\e695";
}

.icon-Italic:before {
  content: "\\e696";
}

.icon-info:before {
  content: "\\e697";
}

.icon-infinite:before {
  content: "\\e698";
}

.icon-id-badge:before {
  content: "\\e699";
}

.icon-hummer:before {
  content: "\\e69a";
}

.icon-home:before {
  content: "\\e69b";
}

.icon-help:before {
  content: "\\e69c";
}

.icon-headphone:before {
  content: "\\e69d";
}

.icon-harddrives:before {
  content: "\\e69e";
}

.icon-harddrive:before {
  content: "\\e69f";
}

.icon-gift:before {
  content: "\\e6a0";
}

.icon-game:before {
  content: "\\e6a1";
}

.icon-filter:before {
  content: "\\e6a2";
}

.icon-files:before {
  content: "\\e6a3";
}

.icon-file:before {
  content: "\\e6a4";
}

.icon-eraser:before {
  content: "\\e6a5";
}

.icon-envelope:before {
  content: "\\e6a6";
}

.icon-download:before {
  content: "\\e6a7";
}

.icon-direction:before {
  content: "\\e6a8";
}

.icon-direction-alt:before {
  content: "\\e6a9";
}

.icon-dashboard:before {
  content: "\\e6aa";
}

.icon-control-stop:before {
  content: "\\e6ab";
}

.icon-control-shuffle:before {
  content: "\\e6ac";
}

.icon-control-play:before {
  content: "\\e6ad";
}

.icon-control-pause:before {
  content: "\\e6ae";
}

.icon-control-forward:before {
  content: "\\e6af";
}

.icon-control-backward:before {
  content: "\\e6b0";
}

.icon-cloud:before {
  content: "\\e6b1";
}

.icon-cloud-up:before {
  content: "\\e6b2";
}

.icon-cloud-down:before {
  content: "\\e6b3";
}

.icon-clipboard:before {
  content: "\\e6b4";
}

.icon-car:before {
  content: "\\e6b5";
}

.icon-calendar:before {
  content: "\\e6b6";
}

.icon-book:before {
  content: "\\e6b7";
}

.icon-bell:before {
  content: "\\e6b8";
}

.icon-basketball:before {
  content: "\\e6b9";
}

.icon-bar-chart:before {
  content: "\\e6ba";
}

.icon-bar-chart-alt:before {
  content: "\\e6bb";
}

.icon-back-right:before {
  content: "\\e6bc";
}

.icon-back-left:before {
  content: "\\e6bd";
}

.icon-arrows-corner:before {
  content: "\\e6be";
}

.icon-archive:before {
  content: "\\e6bf";
}

.icon-anchor:before {
  content: "\\e6c0";
}

.icon-align-right:before {
  content: "\\e6c1";
}

.icon-align-left:before {
  content: "\\e6c2";
}

.icon-align-justify:before {
  content: "\\e6c3";
}

.icon-align-center:before {
  content: "\\e6c4";
}

.icon-alert:before {
  content: "\\e6c5";
}

.icon-alarm-clock:before {
  content: "\\e6c6";
}

.icon-agenda:before {
  content: "\\e6c7";
}

.icon-write:before {
  content: "\\e6c8";
}

.icon-window:before {
  content: "\\e6c9";
}

.icon-widgetized:before {
  content: "\\e6ca";
}

.icon-widget:before {
  content: "\\e6cb";
}

.icon-widget-alt:before {
  content: "\\e6cc";
}

.icon-wallet:before {
  content: "\\e6cd";
}

.icon-video-clapper:before {
  content: "\\e6ce";
}

.icon-video-camera:before {
  content: "\\e6cf";
}

.icon-vector:before {
  content: "\\e6d0";
}

.icon-themify-logo:before {
  content: "\\e6d1";
}

.icon-themify-favicon:before {
  content: "\\e6d2";
}

.icon-themify-favicon-alt:before {
  content: "\\e6d3";
}

.icon-support:before {
  content: "\\e6d4";
}

.icon-stamp:before {
  content: "\\e6d5";
}

.icon-split-v-alt:before {
  content: "\\e6d6";
}

.icon-slice:before {
  content: "\\e6d7";
}

.icon-shortcode:before {
  content: "\\e6d8";
}

.icon-shift-right-alt:before {
  content: "\\e6d9";
}

.icon-shift-left-alt:before {
  content: "\\e6da";
}

.icon-ruler-alt-2:before {
  content: "\\e6db";
}

.icon-receipt:before {
  content: "\\e6dc";
}

.icon-pin2:before {
  content: "\\e6dd";
}

.icon-pin-alt:before {
  content: "\\e6de";
}

.icon-pencil-alt2:before {
  content: "\\e6df";
}

.icon-palette:before {
  content: "\\e6e0";
}

.icon-more:before {
  content: "\\e6e1";
}

.icon-more-alt:before {
  content: "\\e6e2";
}

.icon-microphone-alt:before {
  content: "\\e6e3";
}

.icon-magnet:before {
  content: "\\e6e4";
}

.icon-line-double:before {
  content: "\\e6e5";
}

.icon-line-dotted:before {
  content: "\\e6e6";
}

.icon-line-dashed:before {
  content: "\\e6e7";
}

.icon-layout-width-full:before {
  content: "\\e6e8";
}

.icon-layout-width-default:before {
  content: "\\e6e9";
}

.icon-layout-width-default-alt:before {
  content: "\\e6ea";
}

.icon-layout-tab:before {
  content: "\\e6eb";
}

.icon-layout-tab-window:before {
  content: "\\e6ec";
}

.icon-layout-tab-v:before {
  content: "\\e6ed";
}

.icon-layout-tab-min:before {
  content: "\\e6ee";
}

.icon-layout-slider:before {
  content: "\\e6ef";
}

.icon-layout-slider-alt:before {
  content: "\\e6f0";
}

.icon-layout-sidebar-right:before {
  content: "\\e6f1";
}

.icon-layout-sidebar-none:before {
  content: "\\e6f2";
}

.icon-layout-sidebar-left:before {
  content: "\\e6f3";
}

.icon-layout-placeholder:before {
  content: "\\e6f4";
}

.icon-layout-menu:before {
  content: "\\e6f5";
}

.icon-layout-menu-v:before {
  content: "\\e6f6";
}

.icon-layout-menu-separated:before {
  content: "\\e6f7";
}

.icon-layout-menu-full:before {
  content: "\\e6f8";
}

.icon-layout-media-right-alt:before {
  content: "\\e6f9";
}

.icon-layout-media-right:before {
  content: "\\e6fa";
}

.icon-layout-media-overlay:before {
  content: "\\e6fb";
}

.icon-layout-media-overlay-alt:before {
  content: "\\e6fc";
}

.icon-layout-media-overlay-alt-2:before {
  content: "\\e6fd";
}

.icon-layout-media-left-alt:before {
  content: "\\e6fe";
}

.icon-layout-media-left:before {
  content: "\\e6ff";
}

.icon-layout-media-center-alt:before {
  content: "\\e700";
}

.icon-layout-media-center:before {
  content: "\\e701";
}

.icon-layout-list-thumb:before {
  content: "\\e702";
}

.icon-layout-list-thumb-alt:before {
  content: "\\e703";
}

.icon-layout-list-post:before {
  content: "\\e704";
}

.icon-layout-list-large-image:before {
  content: "\\e705";
}

.icon-layout-line-solid:before {
  content: "\\e706";
}

.icon-layout-grid4:before {
  content: "\\e707";
}

.icon-layout-grid3:before {
  content: "\\e708";
}

.icon-layout-grid2:before {
  content: "\\e709";
}

.icon-layout-grid2-thumb:before {
  content: "\\e70a";
}

.icon-layout-cta-right:before {
  content: "\\e70b";
}

.icon-layout-cta-left:before {
  content: "\\e70c";
}

.icon-layout-cta-center:before {
  content: "\\e70d";
}

.icon-layout-cta-btn-right:before {
  content: "\\e70e";
}

.icon-layout-cta-btn-left:before {
  content: "\\e70f";
}

.icon-layout-column4:before {
  content: "\\e710";
}

.icon-layout-column3:before {
  content: "\\e711";
}

.icon-layout-column2:before {
  content: "\\e712";
}

.icon-layout-accordion-separated:before {
  content: "\\e713";
}

.icon-layout-accordion-merged:before {
  content: "\\e714";
}

.icon-layout-accordion-list:before {
  content: "\\e715";
}

.icon-ink-pen:before {
  content: "\\e716";
}

.icon-info-alt:before {
  content: "\\e717";
}

.icon-help-alt:before {
  content: "\\e718";
}

.icon-headphone-alt:before {
  content: "\\e719";
}

.icon-hand-point-up:before {
  content: "\\e71a";
}

.icon-hand-point-right:before {
  content: "\\e71b";
}

.icon-hand-point-left:before {
  content: "\\e71c";
}

.icon-hand-point-down:before {
  content: "\\e71d";
}

.icon-gallery:before {
  content: "\\e71e";
}

.icon-face-smile:before {
  content: "\\e71f";
}

.icon-face-sad:before {
  content: "\\e720";
}

.icon-credit-card:before {
  content: "\\e721";
}

.icon-control-skip-forward:before {
  content: "\\e722";
}

.icon-control-skip-backward:before {
  content: "\\e723";
}

.icon-control-record:before {
  content: "\\e724";
}

.icon-control-eject:before {
  content: "\\e725";
}

.icon-comments-smiley:before {
  content: "\\e726";
}

.icon-brush-alt:before {
  content: "\\e727";
}

.icon-youtube:before {
  content: "\\e728";
}

.icon-vimeo:before {
  content: "\\e729";
}

.icon-twitter:before {
  content: "\\e72a";
}

.icon-time:before {
  content: "\\e72b";
}

.icon-tumblr:before {
  content: "\\e72c";
}

.icon-skype:before {
  content: "\\e72d";
}

.icon-share:before {
  content: "\\e72e";
}

.icon-share-alt:before {
  content: "\\e72f";
}

.icon-rocket:before {
  content: "\\e730";
}

.icon-pinterest:before {
  content: "\\e731";
}

.icon-new-window:before {
  content: "\\e732";
}

.icon-microsoft:before {
  content: "\\e733";
}

.icon-list-ol:before {
  content: "\\e734";
}

.icon-linkedin:before {
  content: "\\e735";
}

.icon-layout-sidebar-2:before {
  content: "\\e736";
}

.icon-layout-grid4-alt:before {
  content: "\\e737";
}

.icon-layout-grid3-alt:before {
  content: "\\e738";
}

.icon-layout-grid2-alt:before {
  content: "\\e739";
}

.icon-layout-column4-alt:before {
  content: "\\e73a";
}

.icon-layout-column3-alt:before {
  content: "\\e73b";
}

.icon-layout-column2-alt:before {
  content: "\\e73c";
}

.icon-instagram:before {
  content: "\\e73d";
}

.icon-google:before {
  content: "\\e73e";
}

.icon-github:before {
  content: "\\e73f";
}

.icon-flickr:before {
  content: "\\e740";
}

.icon-facebook:before {
  content: "\\e741";
}

.icon-dropbox:before {
  content: "\\e742";
}

.icon-dribbble:before {
  content: "\\e743";
}

.icon-apple:before {
  content: "\\e744";
}

.icon-android:before {
  content: "\\e745";
}

.icon-save:before {
  content: "\\e746";
}

.icon-save-alt:before {
  content: "\\e747";
}

.icon-yahoo:before {
  content: "\\e748";
}

.icon-wordpress:before {
  content: "\\e749";
}

.icon-vimeo-alt:before {
  content: "\\e74a";
}

.icon-twitter-alt:before {
  content: "\\e74b";
}

.icon-tumblr-alt:before {
  content: "\\e74c";
}

.icon-trello:before {
  content: "\\e74d";
}

.icon-stack-overflow:before {
  content: "\\e74e";
}

.icon-soundcloud:before {
  content: "\\e74f";
}

.icon-sharethis:before {
  content: "\\e750";
}

.icon-sharethis-alt:before {
  content: "\\e751";
}

.icon-reddit:before {
  content: "\\e752";
}

.icon-pinterest-alt:before {
  content: "\\e753";
}

.icon-microsoft-alt:before {
  content: "\\e754";
}

.icon-linux:before {
  content: "\\e755";
}

.icon-jsfiddle:before {
  content: "\\e756";
}

.icon-joomla:before {
  content: "\\e757";
}

.icon-html5:before {
  content: "\\e758";
}

.icon-flickr-alt:before {
  content: "\\e759";
}

.icon-email:before {
  content: "\\e75a";
}

.icon-drupal:before {
  content: "\\e75b";
}

.icon-dropbox-alt:before {
  content: "\\e75c";
}

.icon-css3:before {
  content: "\\e75d";
}

.icon-rss:before {
  content: "\\e75e";
}

.icon-rss-alt:before {
  content: "\\e75f";
}

/* VARIABLES */
/* Applies a stroke to the icons. Can use percentage for responsive */
.climacon_component-stroke {
  fill: #dcdada;
  stroke-width: 1px;
  stroke: #717171;
}

.climacon_component-fill {
  fill: rgba(113, 113, 113, 0.2509803922);
  stroke-width: 0;
  stroke: #ddd;
}

/* SVG GLOBAL */
svg.climacon {
  display: inline-block;
  width: 80px;
  height: 80px;
  shape-rendering: geometricPrecision;
}

g, path, circle, rect {
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  transform-origin: 50% 50%;
  animation-duration: 18s;
  animation-direction: normal;
}

/* SUN */
.climacon_componentWrap-sun {
  animation-name: rotate;
}

.climacon_componentWrap_sunSpoke .climacon_component-stroke_sunSpoke {
  animation-name: scale;
  animation-direction: alternate;
  animation-duration: 4.5s;
}

.climacon_componentWrap_sunSpoke .climacon_component-stroke_sunSpoke:nth-child(even) {
  animation-delay: 4.5s;
}

/* MOON */
.climacon_componentWrap-moon {
  animation-name: partialRotate;
  animation-duration: 18s;
  animation-direction: alternate;
}

/* WIND */
.climacon_componentWrap-wind {
  animation-name: translateWind;
  animation-duration: 6s;
  animation-direction: alternate;
  animation-timing-function: ease-in-out;
}

/* SNOWFLAKE */
.climacon_componentWrap-snowflake {
  animation-name: rotate;
  animation-duration: 54s;
  animation-direction: normal;
}

/* CLOUD SUN */
.climacon_componentWrap-sun_cloud {
  animation-name: behindCloudMove, rotate;
  animation-iteration-count: 1, infinite;
  animation-timing-function: ease-out, linear;
  animation-delay: 0, 4.5s;
  animation-duration: 4.5s, 18s;
}

.climacon_componentWrap-sun_cloud .climacon_componentWrap_sunSpoke .climacon_component-stroke_sunSpoke {
  fill-opacity: 0;
  animation-name: fillOpacity, scale;
  animation-iteration-count: 1, infinite;
  animation-delay: 4.5s, 0;
  animation-fill-mode: both;
}

.climacon_componentWrap-sun_cloud .climacon_componentWrap_sunSpoke .climacon_component-stroke_sunSpoke:nth-child(even) {
  animation-delay: 4.5s;
}

/* CLOUD MOON */
.climacon_componentWrap-moon_cloud {
  animation-name: behindCloudMove, partialRotate;
  animation-iteration-count: 1, infinite;
  animation-timing-function: ease-out, linear;
  animation-delay: 0, 4.5s;
  animation-duration: 4.5s, 18s;
}

/* DRIZZLE */
.climacon_component-stroke_drizzle {
  fill-opacity: 0;
  animation-name: drizzleFall, fillOpacity2;
  animation-timing-function: ease-in;
  animation-duration: 1.5s;
}

.climacon_component-stroke_drizzle:nth-child(1) {
  animation-delay: 0s;
}

.climacon_component-stroke_drizzle:nth-child(2) {
  animation-delay: 0.9s;
}

.climacon_component-stroke_drizzle:nth-child(3) {
  animation-delay: 1.8s;
}

/* RAIN */
.climacon_component-stroke_rain {
  fill-opacity: 0;
  animation-name: rainFall, fillOpacity2;
  animation-timing-function: ease-in;
  animation-duration: 3s;
}

.climacon_component-stroke_rain:nth-child(n+4) {
  animation-delay: 1.5s;
}

.climacon_component-stroke_rain_alt:nth-child(2) {
  animation-delay: 1.5s;
}

/* HAIL */
/* HAIL ALT */
.climacon_component-stroke_hailAlt {
  fill-opacity: 1;
  animation-timing-function: ease-in;
  animation-duration: 1s;
}

.climacon_component-stroke_hailAlt-left {
  animation-name: hailLeft, fillOpacity2;
}

.climacon_component-stroke_hailAlt-middle {
  animation-name: hailMiddle, fillOpacity2;
}

.climacon_component-stroke_hailAlt-middle:nth-child(2) {
  animation-name: hailMiddle2, fillOpacity2;
}

.climacon_component-stroke_hailAlt-right {
  animation-name: hailRight, fillOpacity2;
}

.climacon_component-stroke_hailAlt:nth-child(1) {
  animation-delay: 0s;
}

.climacon_component-stroke_hailAlt:nth-child(2) {
  animation-delay: 0.1666666667s;
}

.climacon_component-stroke_hailAlt:nth-child(3) {
  animation-delay: 0.3333333333s;
}

.climacon_component-stroke_hailAlt:nth-child(4) {
  animation-delay: 0.5s;
}

.climacon_component-stroke_hailAlt:nth-child(5) {
  animation-delay: 0.6666666667s;
}

.climacon_component-stroke_hailAlt:nth-child(6) {
  animation-delay: 0.8333333333s;
}

/* SNOW */
.climacon_component-stroke_snow {
  fill-opacity: 0;
  animation-name: snowFall, fillOpacity2;
  animation-timing-function: ease-in-out;
  animation-duration: 9s;
}

.climacon_component-stroke_snow:nth-child(3) {
  animation-name: snowFall2, fillOpacity2;
}

.climacon_component-stroke_snow:nth-child(1) {
  animation-delay: 0s;
}

.climacon_component-stroke_snow:nth-child(2) {
  animation-delay: 3s;
}

.climacon_component-stroke_snow:nth-child(3) {
  animation-delay: 6s;
}

/* SNOW ALT */
.climacon_wrapperComponent-snowAlt {
  fill-opacity: 0;
  animation-name: snowFall, fillOpacity2;
  animation-timing-function: ease-in-out;
  animation-duration: 9s;
}

/* FOG */
.climacon_component-stroke_fogLine {
  fill-opacity: 0.5;
  animation-name: translateFog, fillOpacityFog;
  animation-iteration-count: infinite;
  animation-direction: normal;
  animation-timing-function: ease-in;
  animation-duration: 18s;
}

.climacon_component-stroke_fogLine:nth-child(even) {
  animation-delay: 9s;
}

/* LIGHTNING */
.climacon_component-stroke_lightning {
  fill-opacity: 0;
  animation-name: fillOpacityLightning;
  animation-iteration-count: infinite;
  animation-direction: normal;
  animation-timing-function: ease-out;
  animation-duration: 18s;
}

/* TORNADO */
.climacon_component-stroke_tornadoLine {
  animation-name: translateTornado1;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  animation-timing-function: ease-in-out;
  animation-duration: 18s;
}

.climacon_component-stroke_tornadoLine:nth-child(1) {
  animation-name: translateTornado1;
}

.climacon_component-stroke_tornadoLine:nth-child(2) {
  animation-name: translateTornado2;
}

.climacon_component-stroke_tornadoLine:nth-child(3) {
  animation-name: translateTornado3;
}

.climacon_component-stroke_tornadoLine:nth-child(4) {
  animation-name: translateTornado4;
}

.climacon_component-stroke_tornadoLine:nth-child(5) {
  animation-name: translateTornado5;
}

.climacon_component-stroke_tornadoLine:nth-child(6) {
  animation-name: translateTornado6;
}

.climacon_componentWrap-sunsetAlt {
  animation-name: translateSunset;
  animation-duration: 4.5s;
  animation-iteration-count: 1;
  animation-timing-function: ease-out;
}

.climacon_componentWrap-sunsetAlt {
  animation-name: translateSunset;
  animation-iteration-count: 1;
}

.climacon_iconWrap-sun .climacon_component-stroke_sunSpoke, .climacon_iconWrap-sunFill .climacon_component-stroke_sunSpoke {
  fill-opacity: 1;
  animation-name: scale;
  animation-duration: 3s;
  animation-iteration-count: infinite;
  animation-delay: 0s;
  animation-fill-mode: both;
  animation-direction: alternate;
}

.climacon_iconWrap-sun .climacon_component-stroke_sunSpoke:nth-child(even), .climacon_iconWrap-sunFill .climacon_component-stroke_sunSpoke:nth-child(even) {
  animation-delay: 4.5s;
}

.climacon-iconWrap_sunFill .climacon_component-stroke_sunSpoke {
  fill-opacity: 1;
  animation-name: scale;
  animation-iteration-count: infinite;
  animation-delay: 0s;
  animation-fill-mode: both;
  animation-direction: alternate;
}

.climacon-iconWrap_sunFill .climacon_component-stroke_sunSpoke:nth-child(even) {
  animation-delay: 4.5s;
}

.climacon_component-stroke_arrow-up {
  fill-opacity: 0;
  animation-name: fillOpacity2, translateArrowUp;
  animation-duration: 4.5s;
}

.climacon_component-stroke_arrow-down {
  fill-opacity: 0;
  animation-name: fillOpacity2, translateArrowDown;
  animation-duration: 4.5s;
}

.climacon_componentWrap-sunrise .climacon_component-stroke_sunSpoke, .climacon_componentWrap-sunset .climacon_component-stroke_sunSpoke {
  animation-name: scale;
  animation-direction: alternate;
  animation-iteration-count: infinite;
  animation-duration: 4.5s;
  animation-delay: 0s;
  animation-fill-mode: both;
}

.climacon_componentWrap-sunrise .climacon_component-stroke_sunSpoke:nth-child(even), .climacon_componentWrap-sunset .climacon_component-stroke_sunSpoke:nth-child(even) {
  animation-delay: 4.5s;
}

.climacon_componentWrap-sunriseAlt {
  animation-name: translateSunrise, fillOpacity;
  animation-duration: 18s, 9s;
  animation-direction: normal;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
}

.climacon_componentWrap-sunriseAlt .climacon_component-stroke_sunSpoke {
  fill-opacity: 0;
  animation-name: fillOpacity, scale;
  animation-direction: normal, alternate;
  animation-iteration-count: 1, infinite;
  animation-duration: 4.5s;
  animation-delay: 4.5s, 0;
  animation-fill-mode: both;
}

.climacon_componentWrap-sunriseAlt .climacon_component-stroke_sunSpoke:nth-child(even) {
  animation-delay: 4.5s, 4.5s;
}

.climacon_componentWrap-sunsetAlt {
  animation-name: translateSunset;
  animation-delay: 0s;
  animation-duration: 18s;
  animation-direction: normal;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
}

/* ANIMATIONS */
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes partialRotate {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(-15deg);
  }
  50% {
    transform: rotate(0deg);
  }
  75% {
    transform: rotate(15deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
@keyframes scale {
  0% {
    transform: scale(1, 1);
  }
  100% {
    transform: scale(0.5, 0.5);
  }
}
@keyframes behindCloudMove {
  0% {
    transform: translateX(-1.75px) translateY(1.75px);
  }
  100% {
    transform: translateX(0) translateY(0);
  }
}
@keyframes drizzleFall {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(21px);
  }
}
@keyframes rainFall {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(14px);
  }
}
@keyframes rainFall2 {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(14px);
  }
  100% {
    transform: translateX(14px) translateY(14px);
  }
}
@keyframes hailLeft {
  50% {
    transform: translateY(17.5px);
  }
  51% {
    transform: translateY(17.5px) translateX(-0.3px);
  }
  53% {
    transform: translateY(16.4033342063px) translateX(-0.9px);
  }
  55% {
    transform: translateY(15.3239634873px) translateX(-1.5px);
  }
  57% {
    transform: translateY(14.278910164px) translateX(-2.1px);
  }
  59% {
    transform: translateY(13.2846553516px) translateX(-2.7px);
  }
  61% {
    transform: translateY(12.3568790424px) translateX(-3.3px);
  }
  63% {
    transform: translateY(11.5102128231px) translateX(-3.9px);
  }
  65% {
    transform: translateY(10.7580091257px) translateX(-4.5px);
  }
  67% {
    transform: translateY(10.1121306519px) translateX(-5.1px);
  }
  69% {
    transform: translateY(9.5827632909px) translateX(-5.7px);
  }
  71% {
    transform: translateY(9.1782554824px) translateX(-6.3px);
  }
  73% {
    transform: translateY(8.9049865561px) translateX(-6.9px);
  }
  75% {
    transform: translateY(8.7672661263px) translateX(-7.5px);
  }
  77% {
    transform: translateY(8.7672661263px) translateX(-8.1px);
  }
  79% {
    transform: translateY(8.9049865561px) translateX(-8.7px);
  }
  81% {
    transform: translateY(9.1782554824px) translateX(-9.3px);
  }
  83% {
    transform: translateY(9.5827632909px) translateX(-9.9px);
  }
  85% {
    transform: translateY(10.1121306519px) translateX(-10.5px);
  }
  87% {
    transform: translateY(10.7580091257px) translateX(-11.1px);
  }
  89% {
    transform: translateY(11.5102128231px) translateX(-11.7px);
  }
  91% {
    transform: translateY(12.3568790424px) translateX(-12.3px);
  }
  93% {
    transform: translateY(13.2846553516px) translateX(-12.9px);
  }
  95% {
    transform: translateY(14.278910164px) translateX(-13.5px);
  }
  97% {
    transform: translateY(15.3239634873px) translateX(-14.1px);
  }
  99% {
    transform: translateY(16.4033342063px) translateX(-14.7px);
  }
}
@keyframes hailMiddle {
  50% {
    transform: translateY(17.5px);
  }
  51% {
    transform: translateY(17.5px) translateX(-0.15px);
  }
  53% {
    transform: translateY(16.4033342063px) translateX(-0.45px);
  }
  55% {
    transform: translateY(15.3239634873px) translateX(-0.75px);
  }
  57% {
    transform: translateY(14.278910164px) translateX(-1.05px);
  }
  59% {
    transform: translateY(13.2846553516px) translateX(-1.35px);
  }
  61% {
    transform: translateY(12.3568790424px) translateX(-1.65px);
  }
  63% {
    transform: translateY(11.5102128231px) translateX(-1.95px);
  }
  65% {
    transform: translateY(10.7580091257px) translateX(-2.25px);
  }
  67% {
    transform: translateY(10.1121306519px) translateX(-2.55px);
  }
  69% {
    transform: translateY(9.5827632909px) translateX(-2.85px);
  }
  71% {
    transform: translateY(9.1782554824px) translateX(-3.15px);
  }
  73% {
    transform: translateY(8.9049865561px) translateX(-3.45px);
  }
  75% {
    transform: translateY(8.7672661263px) translateX(-3.75px);
  }
  77% {
    transform: translateY(8.7672661263px) translateX(-4.05px);
  }
  79% {
    transform: translateY(8.9049865561px) translateX(-4.35px);
  }
  81% {
    transform: translateY(9.1782554824px) translateX(-4.65px);
  }
  83% {
    transform: translateY(9.5827632909px) translateX(-4.95px);
  }
  85% {
    transform: translateY(10.1121306519px) translateX(-5.25px);
  }
  87% {
    transform: translateY(10.7580091257px) translateX(-5.55px);
  }
  89% {
    transform: translateY(11.5102128231px) translateX(-5.85px);
  }
  91% {
    transform: translateY(12.3568790424px) translateX(-6.15px);
  }
  93% {
    transform: translateY(13.2846553516px) translateX(-6.45px);
  }
  95% {
    transform: translateY(14.278910164px) translateX(-6.75px);
  }
  97% {
    transform: translateY(15.3239634873px) translateX(-7.05px);
  }
  99% {
    transform: translateY(16.4033342063px) translateX(-7.35px);
  }
}
@keyframes hailMiddle2 {
  50% {
    transform: translateY(17.5px);
  }
  51% {
    transform: translateY(17.5px) translateX(0.15px);
  }
  53% {
    transform: translateY(16.4033342063px) translateX(0.45px);
  }
  55% {
    transform: translateY(15.3239634873px) translateX(0.75px);
  }
  57% {
    transform: translateY(14.278910164px) translateX(1.05px);
  }
  59% {
    transform: translateY(13.2846553516px) translateX(1.35px);
  }
  61% {
    transform: translateY(12.3568790424px) translateX(1.65px);
  }
  63% {
    transform: translateY(11.5102128231px) translateX(1.95px);
  }
  65% {
    transform: translateY(10.7580091257px) translateX(2.25px);
  }
  67% {
    transform: translateY(10.1121306519px) translateX(2.55px);
  }
  69% {
    transform: translateY(9.5827632909px) translateX(2.85px);
  }
  71% {
    transform: translateY(9.1782554824px) translateX(3.15px);
  }
  73% {
    transform: translateY(8.9049865561px) translateX(3.45px);
  }
  75% {
    transform: translateY(8.7672661263px) translateX(3.75px);
  }
  77% {
    transform: translateY(8.7672661263px) translateX(4.05px);
  }
  79% {
    transform: translateY(8.9049865561px) translateX(4.35px);
  }
  81% {
    transform: translateY(9.1782554824px) translateX(4.65px);
  }
  83% {
    transform: translateY(9.5827632909px) translateX(4.95px);
  }
  85% {
    transform: translateY(10.1121306519px) translateX(5.25px);
  }
  87% {
    transform: translateY(10.7580091257px) translateX(5.55px);
  }
  89% {
    transform: translateY(11.5102128231px) translateX(5.85px);
  }
  91% {
    transform: translateY(12.3568790424px) translateX(6.15px);
  }
  93% {
    transform: translateY(13.2846553516px) translateX(6.45px);
  }
  95% {
    transform: translateY(14.278910164px) translateX(6.75px);
  }
  97% {
    transform: translateY(15.3239634873px) translateX(7.05px);
  }
  99% {
    transform: translateY(16.4033342063px) translateX(7.35px);
  }
}
@keyframes hailRight {
  50% {
    transform: translateY(17.5px);
  }
  51% {
    transform: translateY(17.5px) translateX(0.3px);
  }
  53% {
    transform: translateY(16.4033342063px) translateX(0.9px);
  }
  55% {
    transform: translateY(15.3239634873px) translateX(1.5px);
  }
  57% {
    transform: translateY(14.278910164px) translateX(2.1px);
  }
  59% {
    transform: translateY(13.2846553516px) translateX(2.7px);
  }
  61% {
    transform: translateY(12.3568790424px) translateX(3.3px);
  }
  63% {
    transform: translateY(11.5102128231px) translateX(3.9px);
  }
  65% {
    transform: translateY(10.7580091257px) translateX(4.5px);
  }
  67% {
    transform: translateY(10.1121306519px) translateX(5.1px);
  }
  69% {
    transform: translateY(9.5827632909px) translateX(5.7px);
  }
  71% {
    transform: translateY(9.1782554824px) translateX(6.3px);
  }
  73% {
    transform: translateY(8.9049865561px) translateX(6.9px);
  }
  75% {
    transform: translateY(8.7672661263px) translateX(7.5px);
  }
  77% {
    transform: translateY(8.7672661263px) translateX(8.1px);
  }
  79% {
    transform: translateY(8.9049865561px) translateX(8.7px);
  }
  81% {
    transform: translateY(9.1782554824px) translateX(9.3px);
  }
  83% {
    transform: translateY(9.5827632909px) translateX(9.9px);
  }
  85% {
    transform: translateY(10.1121306519px) translateX(10.5px);
  }
  87% {
    transform: translateY(10.7580091257px) translateX(11.1px);
  }
  89% {
    transform: translateY(11.5102128231px) translateX(11.7px);
  }
  91% {
    transform: translateY(12.3568790424px) translateX(12.3px);
  }
  93% {
    transform: translateY(13.2846553516px) translateX(12.9px);
  }
  95% {
    transform: translateY(14.278910164px) translateX(13.5px);
  }
  97% {
    transform: translateY(15.3239634873px) translateX(14.1px);
  }
  99% {
    transform: translateY(16.4033342063px) translateX(14.7px);
  }
}
@keyframes fillOpacity {
  0% {
    fill-opacity: 0;
    stroke-opacity: 0;
  }
  100% {
    fill-opacity: 1;
    stroke-opacity: 1;
  }
}
@keyframes fillOpacity2 {
  0% {
    fill-opacity: 0;
    stroke-opacity: 0;
  }
  50% {
    fill-opacity: 1;
    stroke-opacity: 1;
  }
  100% {
    fill-opacity: 0;
    stroke-opacity: 0;
  }
}
@keyframes lightningFlash {
  0% {
    fill-opacity: 0;
  }
  1% {
    fill-opacity: 1;
  }
  2% {
    fill-opacity: 0;
  }
  50% {
    fill-opacity: 0;
  }
  51% {
    fill-opacity: 1;
  }
  52% {
    fill-opacity: 0;
  }
  53% {
    fill-opacity: 1;
  }
  54% {
    fill-opacity: 0;
  }
  100% {
    fill-opacity: 0;
  }
}
@keyframes snowFall {
  0% {
    transform: translateY(0px) translateX(0px);
  }
  2% {
    transform: translateY(0.35px) translateX(0.7534862344px);
  }
  4% {
    transform: translateY(0.7px) translateX(1.441332186px);
  }
  6% {
    transform: translateY(1.05px) translateX(2.0611944604px);
  }
  8% {
    transform: translateY(1.4px) translateX(2.6112438152px);
  }
  10% {
    transform: translateY(1.75px) translateX(3.0901699437px);
  }
  12% {
    transform: translateY(2.1px) translateX(3.4971832505px);
  }
  14% {
    transform: translateY(2.45px) translateX(3.8320136241px);
  }
  16% {
    transform: translateY(2.8px) translateX(4.0949062299px);
  }
  18% {
    transform: translateY(3.15px) translateX(4.2866143598px);
  }
  20% {
    transform: translateY(3.5px) translateX(4.4083893922px);
  }
  22% {
    transform: translateY(3.85px) translateX(4.4619679282px);
  }
  24% {
    transform: translateY(4.2px) translateX(4.4495561885px);
  }
  26% {
    transform: translateY(4.55px) translateX(4.3738117645px);
  }
  28% {
    transform: translateY(4.9px) translateX(4.2378228353px);
  }
  30% {
    transform: translateY(5.25px) translateX(4.0450849719px);
  }
  32% {
    transform: translateY(5.6px) translateX(3.7994756648px);
  }
  34% {
    transform: translateY(5.95px) translateX(3.5052267202px);
  }
  36% {
    transform: translateY(6.3px) translateX(3.1668946836px);
  }
  38% {
    transform: translateY(6.65px) translateX(2.7893294577px);
  }
  40% {
    transform: translateY(7px) translateX(2.3776412907px);
  }
  42% {
    transform: translateY(7.35px) translateX(1.9371663223px);
  }
  44% {
    transform: translateY(7.7px) translateX(1.4734308761px);
  }
  46% {
    transform: translateY(8.05px) translateX(0.9921147013px);
  }
  48% {
    transform: translateY(8.4px) translateX(0.4990133642px);
  }
  50% {
    transform: translateY(8.75px) translateX(-0px);
  }
  52% {
    transform: translateY(9.1px) translateX(-0.4990133642px);
  }
  54% {
    transform: translateY(9.45px) translateX(-0.9921147013px);
  }
  56% {
    transform: translateY(9.8px) translateX(-1.4734308761px);
  }
  58% {
    transform: translateY(10.15px) translateX(-1.9371663223px);
  }
  60% {
    transform: translateY(10.5px) translateX(-2.3776412907px);
  }
  62% {
    transform: translateY(10.85px) translateX(-2.7893294577px);
  }
  64% {
    transform: translateY(11.2px) translateX(-3.1668946836px);
  }
  66% {
    transform: translateY(11.55px) translateX(-3.5052267202px);
  }
  68% {
    transform: translateY(11.9px) translateX(-3.7994756648px);
  }
  70% {
    transform: translateY(12.25px) translateX(-4.0450849719px);
  }
  72% {
    transform: translateY(12.6px) translateX(-4.2378228353px);
  }
  74% {
    transform: translateY(12.95px) translateX(-4.3738117645px);
  }
  76% {
    transform: translateY(13.3px) translateX(-4.4495561885px);
  }
  78% {
    transform: translateY(13.65px) translateX(-4.4619679282px);
  }
  80% {
    transform: translateY(14px) translateX(-4.4083893922px);
  }
  82% {
    transform: translateY(14.35px) translateX(-4.2866143598px);
  }
  84% {
    transform: translateY(14.7px) translateX(-4.0949062299px);
  }
  86% {
    transform: translateY(15.05px) translateX(-3.8320136241px);
  }
  88% {
    transform: translateY(15.4px) translateX(-3.4971832505px);
  }
  90% {
    transform: translateY(15.75px) translateX(-3.0901699438px);
  }
  92% {
    transform: translateY(16.1px) translateX(-2.6112438152px);
  }
  94% {
    transform: translateY(16.45px) translateX(-2.0611944605px);
  }
  96% {
    transform: translateY(16.8px) translateX(-1.441332186px);
  }
  98% {
    transform: translateY(17.15px) translateX(-0.7534862344px);
  }
  100% {
    transform: translateY(17.5px) translateX(-0.0000000001px);
  }
}
@keyframes snowFall2 {
  0% {
    transform: translateY(0px) translateX(-0px);
  }
  2% {
    transform: translateY(0.35px) translateX(-0.7534862344px);
  }
  4% {
    transform: translateY(0.7px) translateX(-1.441332186px);
  }
  6% {
    transform: translateY(1.05px) translateX(-2.0611944604px);
  }
  8% {
    transform: translateY(1.4px) translateX(-2.6112438152px);
  }
  10% {
    transform: translateY(1.75px) translateX(-3.0901699437px);
  }
  12% {
    transform: translateY(2.1px) translateX(-3.4971832505px);
  }
  14% {
    transform: translateY(2.45px) translateX(-3.8320136241px);
  }
  16% {
    transform: translateY(2.8px) translateX(-4.0949062299px);
  }
  18% {
    transform: translateY(3.15px) translateX(-4.2866143598px);
  }
  20% {
    transform: translateY(3.5px) translateX(-4.4083893922px);
  }
  22% {
    transform: translateY(3.85px) translateX(-4.4619679282px);
  }
  24% {
    transform: translateY(4.2px) translateX(-4.4495561885px);
  }
  26% {
    transform: translateY(4.55px) translateX(-4.3738117645px);
  }
  28% {
    transform: translateY(4.9px) translateX(-4.2378228353px);
  }
  30% {
    transform: translateY(5.25px) translateX(-4.0450849719px);
  }
  32% {
    transform: translateY(5.6px) translateX(-3.7994756648px);
  }
  34% {
    transform: translateY(5.95px) translateX(-3.5052267202px);
  }
  36% {
    transform: translateY(6.3px) translateX(-3.1668946836px);
  }
  38% {
    transform: translateY(6.65px) translateX(-2.7893294577px);
  }
  40% {
    transform: translateY(7px) translateX(-2.3776412907px);
  }
  42% {
    transform: translateY(7.35px) translateX(-1.9371663223px);
  }
  44% {
    transform: translateY(7.7px) translateX(-1.4734308761px);
  }
  46% {
    transform: translateY(8.05px) translateX(-0.9921147013px);
  }
  48% {
    transform: translateY(8.4px) translateX(-0.4990133642px);
  }
  50% {
    transform: translateY(8.75px) translateX(0px);
  }
  52% {
    transform: translateY(9.1px) translateX(0.4990133642px);
  }
  54% {
    transform: translateY(9.45px) translateX(0.9921147013px);
  }
  56% {
    transform: translateY(9.8px) translateX(1.4734308761px);
  }
  58% {
    transform: translateY(10.15px) translateX(1.9371663223px);
  }
  60% {
    transform: translateY(10.5px) translateX(2.3776412907px);
  }
  62% {
    transform: translateY(10.85px) translateX(2.7893294577px);
  }
  64% {
    transform: translateY(11.2px) translateX(3.1668946836px);
  }
  66% {
    transform: translateY(11.55px) translateX(3.5052267202px);
  }
  68% {
    transform: translateY(11.9px) translateX(3.7994756648px);
  }
  70% {
    transform: translateY(12.25px) translateX(4.0450849719px);
  }
  72% {
    transform: translateY(12.6px) translateX(4.2378228353px);
  }
  74% {
    transform: translateY(12.95px) translateX(4.3738117645px);
  }
  76% {
    transform: translateY(13.3px) translateX(4.4495561885px);
  }
  78% {
    transform: translateY(13.65px) translateX(4.4619679282px);
  }
  80% {
    transform: translateY(14px) translateX(4.4083893922px);
  }
  82% {
    transform: translateY(14.35px) translateX(4.2866143598px);
  }
  84% {
    transform: translateY(14.7px) translateX(4.0949062299px);
  }
  86% {
    transform: translateY(15.05px) translateX(3.8320136241px);
  }
  88% {
    transform: translateY(15.4px) translateX(3.4971832505px);
  }
  90% {
    transform: translateY(15.75px) translateX(3.0901699438px);
  }
  92% {
    transform: translateY(16.1px) translateX(2.6112438152px);
  }
  94% {
    transform: translateY(16.45px) translateX(2.0611944605px);
  }
  96% {
    transform: translateY(16.8px) translateX(1.441332186px);
  }
  98% {
    transform: translateY(17.15px) translateX(0.7534862344px);
  }
  100% {
    transform: translateY(17.5px) translateX(0.0000000001px);
  }
}
/* Tornado */
@keyframes translateTornado1 {
  0% {
    transform: translateY(0);
  }
  25% {
    transform: translateX(3.997px);
  }
  75% {
    transform: translateX(-3.997px);
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes translateTornado2 {
  0% {
    transform: translateY(0);
  }
  25% {
    transform: translateX(2.002px);
  }
  75% {
    transform: translateX(-2.002px);
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes translateTornado3 {
  0% {
    transform: translateY(0);
  }
  25% {
    transform: translateX(8.001px);
  }
  75% {
    transform: translateX(-8.001px);
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes translateTornado4 {
  0% {
    transform: translateY(0);
  }
  25% {
    transform: translateX(5.999px);
  }
  75% {
    transform: translateX(-5.999px);
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes translateTornado5 {
  0% {
    transform: translateY(0);
  }
  25% {
    transform: translateX(10.003px);
  }
  75% {
    transform: translateX(-10.003px);
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes translateTornado6 {
  0% {
    transform: translateY(0);
  }
  25% {
    transform: translateX(5.999px);
  }
  75% {
    transform: translateX(-5.999px);
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes fillOpacityLightning {
  0% {
    fill-opacity: 0;
    stroke-opacity: 0;
  }
  1% {
    fill-opacity: 1;
    stroke-opacity: 1;
  }
  7% {
    fill-opacity: 0;
    stroke-opacity: 0;
  }
  50% {
    fill-opacity: 0;
    stroke-opacity: 0;
  }
  51% {
    fill-opacity: 1;
    stroke-opacity: 1;
  }
  53% {
    fill-opacity: 0;
    stroke-opacity: 0;
  }
  54% {
    fill-opacity: 1;
    stroke-opacity: 1;
  }
  60% {
    fill-opacity: 0;
    stroke-opacity: 0;
  }
  100% {
    fill-opacity: 0;
    stroke-opacity: 0;
  }
}
@keyframes translateFog {
  0% {
    transform: translateY(0);
  }
  25% {
    transform: translateX(2.499px);
  }
  75% {
    transform: translateX(-2.499px);
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes fillOpacityFog {
  0% {
    fill-opacity: 0.5;
    stroke-opacity: 0.5;
  }
  50% {
    fill-opacity: 1;
    stroke-opacity: 1;
  }
  100% {
    fill-opacity: 0.5;
    stroke-opacity: 0.5;
  }
}
@keyframes translateSunrise {
  0% {
    transform: translateY(0);
  }
  25% {
    transform: translateY(-16.002px);
  }
  100% {
    transform: translateY(-16.002px);
  }
}
@keyframes translateSunset {
  0% {
    transform: translateY(-16.002px);
  }
  25% {
    transform: translateY(-3.997px);
  }
  100% {
    transform: translateY(-3.997px);
  }
}
@keyframes translateArrowDown {
  0% {
    transform: translateY(2.002px);
  }
  100% {
    transform: translateY(4.998px);
  }
}
@keyframes translateArrowUp {
  0% {
    transform: translateY(-2.002px);
  }
  100% {
    transform: translateY(-4.998px);
  }
}
@keyframes translateWind {
  0% {
    transform: translateY(0);
  }
  25% {
    transform: translateX(4.998px);
  }
  75% {
    transform: translateX(-4.998px);
  }
  100% {
    transform: translateX(0);
  }
}
/**
 * @package IcoFont by ThemeHunt - https://themehunt.com
 * @version 1.0.0 Beta
 * @author IcoFont http://icofont.com
 * @copyright Copyright (c) 2018 IcoFont
 * @license - http://icofont.com/license/
*/
@font-face {
  font-family: "icofont";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_39___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_40___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_41___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_42___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
.icofont {
  font-family: "IcoFont" !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icofont-angry-monster:before {
  content: "\\e901";
}

.icofont-bathtub:before {
  content: "\\e902";
}

.icofont-bird-wings:before {
  content: "\\e903";
}

.icofont-bow:before {
  content: "\\e904";
}

.icofont-brain-alt:before {
  content: "\\e905";
}

.icofont-butterfly-alt:before {
  content: "\\e906";
}

.icofont-castle:before {
  content: "\\e907";
}

.icofont-circuit:before {
  content: "\\e908";
}

.icofont-dart:before {
  content: "\\e909";
}

.icofont-dice-alt:before {
  content: "\\e90a";
}

.icofont-disability-race:before {
  content: "\\e90b";
}

.icofont-diving-goggle:before {
  content: "\\e90c";
}

.icofont-fire-alt:before {
  content: "\\e90d";
}

.icofont-flame-torch:before {
  content: "\\e90e";
}

.icofont-flora-flower:before {
  content: "\\e90f";
}

.icofont-flora:before {
  content: "\\e910";
}

.icofont-gift-box:before {
  content: "\\e911";
}

.icofont-halloween-pumpkin:before {
  content: "\\e912";
}

.icofont-hand-power:before {
  content: "\\e913";
}

.icofont-hand-thunder:before {
  content: "\\e914";
}

.icofont-king-crown:before {
  content: "\\e915";
}

.icofont-king-monster:before {
  content: "\\e916";
}

.icofont-love:before {
  content: "\\e917";
}

.icofont-magician-hat:before {
  content: "\\e918";
}

.icofont-native-american:before {
  content: "\\e919";
}

.icofont-open-eye:before {
  content: "\\e91a";
}

.icofont-owl-look:before {
  content: "\\e91b";
}

.icofont-phoenix:before {
  content: "\\e91c";
}

.icofont-queen-crown:before {
  content: "\\e91d";
}

.icofont-robot-face:before {
  content: "\\e91e";
}

.icofont-sand-clock:before {
  content: "\\e91f";
}

.icofont-shield-alt:before {
  content: "\\e920";
}

.icofont-ship-wheel:before {
  content: "\\e921";
}

.icofont-skull-danger:before {
  content: "\\e922";
}

.icofont-skull-face:before {
  content: "\\e923";
}

.icofont-snail:before {
  content: "\\e924";
}

.icofont-snow-alt:before {
  content: "\\e925";
}

.icofont-snow-flake:before {
  content: "\\e926";
}

.icofont-snowmobile:before {
  content: "\\e927";
}

.icofont-space-shuttle:before {
  content: "\\e928";
}

.icofont-star-shape:before {
  content: "\\e929";
}

.icofont-swirl:before {
  content: "\\e92a";
}

.icofont-tattoo-wing:before {
  content: "\\e92b";
}

.icofont-throne:before {
  content: "\\e92c";
}

.icofont-touch:before {
  content: "\\e92d";
}

.icofont-tree-alt:before {
  content: "\\e92e";
}

.icofont-triangle:before {
  content: "\\e92f";
}

.icofont-unity-hand:before {
  content: "\\e930";
}

.icofont-weed:before {
  content: "\\e931";
}

.icofont-woman-bird:before {
  content: "\\e932";
}

.icofont-animal-bat:before {
  content: "\\e933";
}

.icofont-animal-bear-tracks:before {
  content: "\\e934";
}

.icofont-animal-bear:before {
  content: "\\e935";
}

.icofont-animal-bird-alt:before {
  content: "\\e936";
}

.icofont-animal-bird:before {
  content: "\\e937";
}

.icofont-animal-bone:before {
  content: "\\e938";
}

.icofont-animal-bull:before {
  content: "\\e939";
}

.icofont-animal-camel-alt:before {
  content: "\\e93a";
}

.icofont-animal-camel-head:before {
  content: "\\e93b";
}

.icofont-animal-camel:before {
  content: "\\e93c";
}

.icofont-animal-cat-alt-1:before {
  content: "\\e93d";
}

.icofont-animal-cat-alt-2:before {
  content: "\\e93e";
}

.icofont-animal-cat-alt-3:before {
  content: "\\e93f";
}

.icofont-animal-cat-alt-4:before {
  content: "\\e940";
}

.icofont-animal-cat-with-dog:before {
  content: "\\e941";
}

.icofont-animal-cat:before {
  content: "\\e942";
}

.icofont-animal-cow-head:before {
  content: "\\e943";
}

.icofont-animal-cow:before {
  content: "\\e944";
}

.icofont-animal-crab:before {
  content: "\\e945";
}

.icofont-animal-crocodile:before {
  content: "\\e946";
}

.icofont-animal-deer-head:before {
  content: "\\e947";
}

.icofont-animal-dog-alt:before {
  content: "\\e948";
}

.icofont-animal-dog-barking:before {
  content: "\\e949";
}

.icofont-animal-dog:before {
  content: "\\e94a";
}

.icofont-animal-dolphin:before {
  content: "\\e94b";
}

.icofont-animal-duck-tracks:before {
  content: "\\e94c";
}

.icofont-animal-eagle-head:before {
  content: "\\e94d";
}

.icofont-animal-eaten-fish:before {
  content: "\\e94e";
}

.icofont-animal-elephant-alt:before {
  content: "\\e94f";
}

.icofont-animal-elephant-head-alt:before {
  content: "\\e950";
}

.icofont-animal-elephant-head:before {
  content: "\\e951";
}

.icofont-animal-elephant:before {
  content: "\\e952";
}

.icofont-animal-elk:before {
  content: "\\e953";
}

.icofont-animal-fish-alt-1:before {
  content: "\\e954";
}

.icofont-animal-fish-alt-2:before {
  content: "\\e955";
}

.icofont-animal-fish-alt-3:before {
  content: "\\e956";
}

.icofont-animal-fish-alt-4:before {
  content: "\\e957";
}

.icofont-animal-fish:before {
  content: "\\e958";
}

.icofont-animal-fox-alt:before {
  content: "\\e959";
}

.icofont-animal-fox:before {
  content: "\\e95a";
}

.icofont-animal-frog-tracks:before {
  content: "\\e95b";
}

.icofont-animal-frog:before {
  content: "\\e95c";
}

.icofont-animal-froggy:before {
  content: "\\e95d";
}

.icofont-animal-giraffe-alt:before {
  content: "\\e95e";
}

.icofont-animal-giraffe:before {
  content: "\\e95f";
}

.icofont-animal-goat-head-alt-1:before {
  content: "\\e960";
}

.icofont-animal-goat-head-alt-2:before {
  content: "\\e961";
}

.icofont-animal-goat-head:before {
  content: "\\e962";
}

.icofont-animal-gorilla:before {
  content: "\\e963";
}

.icofont-animal-hen-tracks:before {
  content: "\\e964";
}

.icofont-animal-horse-head-alt-1:before {
  content: "\\e965";
}

.icofont-animal-horse-head-alt-2:before {
  content: "\\e966";
}

.icofont-animal-horse-head:before {
  content: "\\e967";
}

.icofont-animal-horse-tracks:before {
  content: "\\e968";
}

.icofont-animal-jellyfish:before {
  content: "\\e969";
}

.icofont-animal-kangaroo:before {
  content: "\\e96a";
}

.icofont-animal-lemur:before {
  content: "\\e96b";
}

.icofont-animal-lion-alt:before {
  content: "\\e96c";
}

.icofont-animal-lion-head-alt:before {
  content: "\\e96d";
}

.icofont-animal-lion-head:before {
  content: "\\e96e";
}

.icofont-animal-lion:before {
  content: "\\e96f";
}

.icofont-animal-monkey-alt-1:before {
  content: "\\e970";
}

.icofont-animal-monkey-alt-2:before {
  content: "\\e971";
}

.icofont-animal-monkey-alt-3:before {
  content: "\\e972";
}

.icofont-animal-monkey:before {
  content: "\\e973";
}

.icofont-animal-octopus-alt:before {
  content: "\\e974";
}

.icofont-animal-octopus:before {
  content: "\\e975";
}

.icofont-animal-owl:before {
  content: "\\e976";
}

.icofont-animal-panda-alt:before {
  content: "\\e977";
}

.icofont-animal-panda:before {
  content: "\\e978";
}

.icofont-animal-panther:before {
  content: "\\e979";
}

.icofont-animal-parrot-lip:before {
  content: "\\e97a";
}

.icofont-animal-parrot:before {
  content: "\\e97b";
}

.icofont-animal-paw:before {
  content: "\\e97c";
}

.icofont-animal-pelican:before {
  content: "\\e97d";
}

.icofont-animal-penguin:before {
  content: "\\e97e";
}

.icofont-animal-pig-alt:before {
  content: "\\e97f";
}

.icofont-animal-pig:before {
  content: "\\e980";
}

.icofont-animal-pigeon-alt:before {
  content: "\\e981";
}

.icofont-animal-pigeon:before {
  content: "\\e982";
}

.icofont-animal-pigeons:before {
  content: "\\e983";
}

.icofont-animal-rabbit-running:before {
  content: "\\e984";
}

.icofont-animal-rat-alt:before {
  content: "\\e985";
}

.icofont-animal-rhino-head:before {
  content: "\\e986";
}

.icofont-animal-rhino:before {
  content: "\\e987";
}

.icofont-animal-rooster:before {
  content: "\\e988";
}

.icofont-animal-seahorse:before {
  content: "\\e989";
}

.icofont-animal-seal:before {
  content: "\\e98a";
}

.icofont-animal-shrimp:before {
  content: "\\e98b";
}

.icofont-animal-snail-alt-1:before {
  content: "\\e98c";
}

.icofont-animal-snail-alt-2:before {
  content: "\\e98d";
}

.icofont-animal-snail:before {
  content: "\\e98e";
}

.icofont-animal-snake:before {
  content: "\\e98f";
}

.icofont-animal-squid:before {
  content: "\\e990";
}

.icofont-animal-squirrel:before {
  content: "\\e991";
}

.icofont-animal-tiger-alt:before {
  content: "\\e992";
}

.icofont-animal-tiger:before {
  content: "\\e993";
}

.icofont-animal-turtle:before {
  content: "\\e994";
}

.icofont-animal-whale:before {
  content: "\\e995";
}

.icofont-animal-woodpecker:before {
  content: "\\e996";
}

.icofont-animal-zebra:before {
  content: "\\e997";
}

.icofont-brand-acer:before {
  content: "\\e998";
}

.icofont-brand-adidas:before {
  content: "\\e999";
}

.icofont-brand-adobe:before {
  content: "\\e99a";
}

.icofont-brand-air-new-zealand:before {
  content: "\\e99b";
}

.icofont-brand-airbnb:before {
  content: "\\e99c";
}

.icofont-brand-aircell:before {
  content: "\\e99d";
}

.icofont-brand-airtel:before {
  content: "\\e99e";
}

.icofont-brand-alcatel:before {
  content: "\\e99f";
}

.icofont-brand-alibaba:before {
  content: "\\e9a0";
}

.icofont-brand-aliexpress:before {
  content: "\\e9a1";
}

.icofont-brand-alipay:before {
  content: "\\e9a2";
}

.icofont-brand-amazon:before {
  content: "\\e9a3";
}

.icofont-brand-amd:before {
  content: "\\e9a4";
}

.icofont-brand-american-airlines:before {
  content: "\\e9a5";
}

.icofont-brand-android-robot:before {
  content: "\\e9a6";
}

.icofont-brand-android:before {
  content: "\\e9a7";
}

.icofont-brand-aol:before {
  content: "\\e9a8";
}

.icofont-brand-apple:before {
  content: "\\e9a9";
}

.icofont-brand-appstore:before {
  content: "\\e9aa";
}

.icofont-brand-asus:before {
  content: "\\e9ab";
}

.icofont-brand-ati:before {
  content: "\\e9ac";
}

.icofont-brand-att:before {
  content: "\\e9ad";
}

.icofont-brand-audi:before {
  content: "\\e9ae";
}

.icofont-brand-axiata:before {
  content: "\\e9af";
}

.icofont-brand-bada:before {
  content: "\\e9b0";
}

.icofont-brand-bbc:before {
  content: "\\e9b1";
}

.icofont-brand-bing:before {
  content: "\\e9b2";
}

.icofont-brand-blackberry:before {
  content: "\\e9b3";
}

.icofont-brand-bmw:before {
  content: "\\e9b4";
}

.icofont-brand-box:before {
  content: "\\e9b5";
}

.icofont-brand-burger-king:before {
  content: "\\e9b6";
}

.icofont-brand-business-insider:before {
  content: "\\e9b7";
}

.icofont-brand-buzzfeed:before {
  content: "\\e9b8";
}

.icofont-brand-cannon:before {
  content: "\\e9b9";
}

.icofont-brand-casio:before {
  content: "\\e9ba";
}

.icofont-brand-china-mobile:before {
  content: "\\e9bb";
}

.icofont-brand-china-telecom:before {
  content: "\\e9bc";
}

.icofont-brand-china-unicom:before {
  content: "\\e9bd";
}

.icofont-brand-cisco:before {
  content: "\\e9be";
}

.icofont-brand-citibank:before {
  content: "\\e9bf";
}

.icofont-brand-cnet:before {
  content: "\\e9c0";
}

.icofont-brand-cnn:before {
  content: "\\e9c1";
}

.icofont-brand-cocal-cola:before {
  content: "\\e9c2";
}

.icofont-brand-compaq:before {
  content: "\\e9c3";
}

.icofont-brand-copy:before {
  content: "\\e9c4";
}

.icofont-brand-debian:before {
  content: "\\e9c5";
}

.icofont-brand-delicious:before {
  content: "\\e9c6";
}

.icofont-brand-dell:before {
  content: "\\e9c7";
}

.icofont-brand-designbump:before {
  content: "\\e9c8";
}

.icofont-brand-designfloat:before {
  content: "\\e9c9";
}

.icofont-brand-disney:before {
  content: "\\e9ca";
}

.icofont-brand-dodge:before {
  content: "\\e9cb";
}

.icofont-brand-dove:before {
  content: "\\e9cc";
}

.icofont-brand-ebay:before {
  content: "\\e9cd";
}

.icofont-brand-eleven:before {
  content: "\\e9ce";
}

.icofont-brand-emirates:before {
  content: "\\e9cf";
}

.icofont-brand-espn:before {
  content: "\\e9d0";
}

.icofont-brand-etihad-airways:before {
  content: "\\e9d1";
}

.icofont-brand-etisalat:before {
  content: "\\e9d2";
}

.icofont-brand-etsy:before {
  content: "\\e9d3";
}

.icofont-brand-facebook:before {
  content: "\\e9d4";
}

.icofont-brand-fastrack:before {
  content: "\\e9d5";
}

.icofont-brand-fedex:before {
  content: "\\e9d6";
}

.icofont-brand-ferrari:before {
  content: "\\e9d7";
}

.icofont-brand-fitbit:before {
  content: "\\e9d8";
}

.icofont-brand-flikr:before {
  content: "\\e9d9";
}

.icofont-brand-forbes:before {
  content: "\\e9da";
}

.icofont-brand-foursquare:before {
  content: "\\e9db";
}

.icofont-brand-fox:before {
  content: "\\e9dc";
}

.icofont-brand-foxconn:before {
  content: "\\e9dd";
}

.icofont-brand-fujitsu:before {
  content: "\\e9de";
}

.icofont-brand-general-electric:before {
  content: "\\e9df";
}

.icofont-brand-gillette:before {
  content: "\\e9e0";
}

.icofont-brand-gizmodo:before {
  content: "\\e9e1";
}

.icofont-brand-gnome:before {
  content: "\\e9e2";
}

.icofont-brand-google:before {
  content: "\\e9e3";
}

.icofont-brand-gopro:before {
  content: "\\e9e4";
}

.icofont-brand-gucci:before {
  content: "\\e9e5";
}

.icofont-brand-hallmark:before {
  content: "\\e9e6";
}

.icofont-brand-hi5:before {
  content: "\\e9e7";
}

.icofont-brand-honda:before {
  content: "\\e9e8";
}

.icofont-brand-hp:before {
  content: "\\e9e9";
}

.icofont-brand-hsbc:before {
  content: "\\e9ea";
}

.icofont-brand-htc:before {
  content: "\\e9eb";
}

.icofont-brand-huawei:before {
  content: "\\e9ec";
}

.icofont-brand-hulu:before {
  content: "\\e9ed";
}

.icofont-brand-hyundai:before {
  content: "\\e9ee";
}

.icofont-brand-ibm:before {
  content: "\\e9ef";
}

.icofont-brand-icofont:before {
  content: "\\e9f0";
}

.icofont-brand-icq:before {
  content: "\\e9f1";
}

.icofont-brand-ikea:before {
  content: "\\e9f2";
}

.icofont-brand-imdb:before {
  content: "\\e9f3";
}

.icofont-brand-indiegogo:before {
  content: "\\e9f4";
}

.icofont-brand-intel:before {
  content: "\\e9f5";
}

.icofont-brand-ipair:before {
  content: "\\e9f6";
}

.icofont-brand-jaguar:before {
  content: "\\e9f7";
}

.icofont-brand-java:before {
  content: "\\e9f8";
}

.icofont-brand-joomshaper:before {
  content: "\\e9f9";
}

.icofont-brand-kickstarter:before {
  content: "\\e9fa";
}

.icofont-brand-kik:before {
  content: "\\e9fb";
}

.icofont-brand-lastfm:before {
  content: "\\e9fc";
}

.icofont-brand-lego:before {
  content: "\\e9fd";
}

.icofont-brand-lenovo:before {
  content: "\\e9fe";
}

.icofont-brand-levis:before {
  content: "\\e9ff";
}

.icofont-brand-lexus:before {
  content: "\\ea00";
}

.icofont-brand-lg:before {
  content: "\\ea01";
}

.icofont-brand-life-hacker:before {
  content: "\\ea02";
}

.icofont-brand-line-messenger:before {
  content: "\\ea03";
}

.icofont-brand-linkedin:before {
  content: "\\ea04";
}

.icofont-brand-linux-mint:before {
  content: "\\ea05";
}

.icofont-brand-linux:before {
  content: "\\ea06";
}

.icofont-brand-lionix:before {
  content: "\\ea07";
}

.icofont-brand-live-messenger:before {
  content: "\\ea08";
}

.icofont-brand-loreal:before {
  content: "\\ea09";
}

.icofont-brand-louis-vuitton:before {
  content: "\\ea0a";
}

.icofont-brand-mac-os:before {
  content: "\\ea0b";
}

.icofont-brand-marvel-app:before {
  content: "\\ea0c";
}

.icofont-brand-mashable:before {
  content: "\\ea0d";
}

.icofont-brand-mazda:before {
  content: "\\ea0e";
}

.icofont-brand-mcdonals:before {
  content: "\\ea0f";
}

.icofont-brand-mercedes:before {
  content: "\\ea10";
}

.icofont-brand-micromax:before {
  content: "\\ea11";
}

.icofont-brand-microsoft:before {
  content: "\\ea12";
}

.icofont-brand-mobileme:before {
  content: "\\ea13";
}

.icofont-brand-mobily:before {
  content: "\\ea14";
}

.icofont-brand-motorola:before {
  content: "\\ea15";
}

.icofont-brand-msi:before {
  content: "\\ea16";
}

.icofont-brand-mts:before {
  content: "\\ea17";
}

.icofont-brand-myspace:before {
  content: "\\ea18";
}

.icofont-brand-mytv:before {
  content: "\\ea19";
}

.icofont-brand-nasa:before {
  content: "\\ea1a";
}

.icofont-brand-natgeo:before {
  content: "\\ea1b";
}

.icofont-brand-nbc:before {
  content: "\\ea1c";
}

.icofont-brand-nescafe:before {
  content: "\\ea1d";
}

.icofont-brand-nestle:before {
  content: "\\ea1e";
}

.icofont-brand-netflix:before {
  content: "\\ea1f";
}

.icofont-brand-nexus:before {
  content: "\\ea20";
}

.icofont-brand-nike:before {
  content: "\\ea21";
}

.icofont-brand-nokia:before {
  content: "\\ea22";
}

.icofont-brand-nvidia:before {
  content: "\\ea23";
}

.icofont-brand-omega:before {
  content: "\\ea24";
}

.icofont-brand-opensuse:before {
  content: "\\ea25";
}

.icofont-brand-oracle:before {
  content: "\\ea26";
}

.icofont-brand-panasonic:before {
  content: "\\ea27";
}

.icofont-brand-paypal:before {
  content: "\\ea28";
}

.icofont-brand-pepsi:before {
  content: "\\ea29";
}

.icofont-brand-philips:before {
  content: "\\ea2a";
}

.icofont-brand-pizza-hut:before {
  content: "\\ea2b";
}

.icofont-brand-playstation:before {
  content: "\\ea2c";
}

.icofont-brand-puma:before {
  content: "\\ea2d";
}

.icofont-brand-qatar-air:before {
  content: "\\ea2e";
}

.icofont-brand-qvc:before {
  content: "\\ea2f";
}

.icofont-brand-readernaut:before {
  content: "\\ea30";
}

.icofont-brand-redbull:before {
  content: "\\ea31";
}

.icofont-brand-reebok:before {
  content: "\\ea32";
}

.icofont-brand-reuters:before {
  content: "\\ea33";
}

.icofont-brand-samsung:before {
  content: "\\ea34";
}

.icofont-brand-sap:before {
  content: "\\ea35";
}

.icofont-brand-saudia-airlines:before {
  content: "\\ea36";
}

.icofont-brand-scribd:before {
  content: "\\ea37";
}

.icofont-brand-shell:before {
  content: "\\ea38";
}

.icofont-brand-siemens:before {
  content: "\\ea39";
}

.icofont-brand-sk-telecom:before {
  content: "\\ea3a";
}

.icofont-brand-slideshare:before {
  content: "\\ea3b";
}

.icofont-brand-smashing-magazine:before {
  content: "\\ea3c";
}

.icofont-brand-snapchat:before {
  content: "\\ea3d";
}

.icofont-brand-sony-ericsson:before {
  content: "\\ea3e";
}

.icofont-brand-sony:before {
  content: "\\ea3f";
}

.icofont-brand-soundcloud:before {
  content: "\\ea40";
}

.icofont-brand-sprint:before {
  content: "\\ea41";
}

.icofont-brand-squidoo:before {
  content: "\\ea42";
}

.icofont-brand-starbucks:before {
  content: "\\ea43";
}

.icofont-brand-stc:before {
  content: "\\ea44";
}

.icofont-brand-steam:before {
  content: "\\ea45";
}

.icofont-brand-suzuki:before {
  content: "\\ea46";
}

.icofont-brand-symbian:before {
  content: "\\ea47";
}

.icofont-brand-t-mobile:before {
  content: "\\ea48";
}

.icofont-brand-tango:before {
  content: "\\ea49";
}

.icofont-brand-target:before {
  content: "\\ea4a";
}

.icofont-brand-tata-indicom:before {
  content: "\\ea4b";
}

.icofont-brand-techcrunch:before {
  content: "\\ea4c";
}

.icofont-brand-telenor:before {
  content: "\\ea4d";
}

.icofont-brand-teliasonera:before {
  content: "\\ea4e";
}

.icofont-brand-tesla:before {
  content: "\\ea4f";
}

.icofont-brand-the-verge:before {
  content: "\\ea50";
}

.icofont-brand-thenextweb:before {
  content: "\\ea51";
}

.icofont-brand-toshiba:before {
  content: "\\ea52";
}

.icofont-brand-toyota:before {
  content: "\\ea53";
}

.icofont-brand-tribenet:before {
  content: "\\ea54";
}

.icofont-brand-ubuntu:before {
  content: "\\ea55";
}

.icofont-brand-unilever:before {
  content: "\\ea56";
}

.icofont-brand-vaio:before {
  content: "\\ea57";
}

.icofont-brand-verizon:before {
  content: "\\ea58";
}

.icofont-brand-viber:before {
  content: "\\ea59";
}

.icofont-brand-vodafone:before {
  content: "\\ea5a";
}

.icofont-brand-volkswagen:before {
  content: "\\ea5b";
}

.icofont-brand-walmart:before {
  content: "\\ea5c";
}

.icofont-brand-warnerbros:before {
  content: "\\ea5d";
}

.icofont-brand-whatsapp:before {
  content: "\\ea5e";
}

.icofont-brand-wikipedia:before {
  content: "\\ea5f";
}

.icofont-brand-windows:before {
  content: "\\ea60";
}

.icofont-brand-wire:before {
  content: "\\ea61";
}

.icofont-brand-yahoobuzz:before {
  content: "\\ea62";
}

.icofont-brand-yamaha:before {
  content: "\\ea63";
}

.icofont-brand-youtube:before {
  content: "\\ea64";
}

.icofont-brand-zain:before {
  content: "\\ea65";
}

.icofont-bank-alt:before {
  content: "\\ea66";
}

.icofont-barcode:before {
  content: "\\ea67";
}

.icofont-basket:before {
  content: "\\ea68";
}

.icofont-bill-alt:before {
  content: "\\ea69";
}

.icofont-billboard:before {
  content: "\\ea6a";
}

.icofont-briefcase-alt-1:before {
  content: "\\ea6b";
}

.icofont-briefcase-alt-2:before {
  content: "\\ea6c";
}

.icofont-building-alt:before {
  content: "\\ea6d";
}

.icofont-businessman:before {
  content: "\\ea6e";
}

.icofont-businesswoman:before {
  content: "\\ea6f";
}

.icofont-cart-alt:before {
  content: "\\ea70";
}

.icofont-chair:before {
  content: "\\ea71";
}

.icofont-clip:before {
  content: "\\ea72";
}

.icofont-coins:before {
  content: "\\ea73";
}

.icofont-company:before {
  content: "\\ea74";
}

.icofont-contact-add:before {
  content: "\\ea75";
}

.icofont-deal:before {
  content: "\\ea76";
}

.icofont-files:before {
  content: "\\ea77";
}

.icofont-growth:before {
  content: "\\ea78";
}

.icofont-id-card:before {
  content: "\\ea79";
}

.icofont-idea:before {
  content: "\\ea7a";
}

.icofont-list:before {
  content: "\\ea7b";
}

.icofont-meeting-add:before {
  content: "\\ea7c";
}

.icofont-money-bag:before {
  content: "\\ea7d";
}

.icofont-people:before {
  content: "\\ea7e";
}

.icofont-pie-chart:before {
  content: "\\ea7f";
}

.icofont-presentation-alt:before {
  content: "\\ea80";
}

.icofont-stamp:before {
  content: "\\ea81";
}

.icofont-stock-mobile:before {
  content: "\\ea82";
}

.icofont-support:before {
  content: "\\ea83";
}

.icofont-tasks-alt:before {
  content: "\\ea84";
}

.icofont-wheel:before {
  content: "\\ea85";
}

.icofont-chart-arrows-axis:before {
  content: "\\ea86";
}

.icofont-chart-bar-graph:before {
  content: "\\ea87";
}

.icofont-chart-flow-alt-1:before {
  content: "\\ea88";
}

.icofont-chart-flow-alt-2:before {
  content: "\\ea89";
}

.icofont-chart-flow:before {
  content: "\\ea8a";
}

.icofont-chart-histogram-alt:before {
  content: "\\ea8b";
}

.icofont-chart-histogram:before {
  content: "\\ea8c";
}

.icofont-chart-line-alt:before {
  content: "\\ea8d";
}

.icofont-chart-line:before {
  content: "\\ea8e";
}

.icofont-chart-pie-alt:before {
  content: "\\ea8f";
}

.icofont-chart-pie:before {
  content: "\\ea90";
}

.icofont-chart-radar-graph:before {
  content: "\\ea91";
}

.icofont-cur-afghani-false:before {
  content: "\\ea92";
}

.icofont-cur-afghani-minus:before {
  content: "\\ea93";
}

.icofont-cur-afghani-plus:before {
  content: "\\ea94";
}

.icofont-cur-afghani-true:before {
  content: "\\ea95";
}

.icofont-cur-afghani:before {
  content: "\\ea96";
}

.icofont-cur-baht-false:before {
  content: "\\ea97";
}

.icofont-cur-baht-minus:before {
  content: "\\ea98";
}

.icofont-cur-baht-plus:before {
  content: "\\ea99";
}

.icofont-cur-baht-true:before {
  content: "\\ea9a";
}

.icofont-cur-baht:before {
  content: "\\ea9b";
}

.icofont-cur-bitcoin-false:before {
  content: "\\ea9c";
}

.icofont-cur-bitcoin-minus:before {
  content: "\\ea9d";
}

.icofont-cur-bitcoin-plus:before {
  content: "\\ea9e";
}

.icofont-cur-bitcoin-true:before {
  content: "\\ea9f";
}

.icofont-cur-bitcoin:before {
  content: "\\eaa0";
}

.icofont-cur-dollar-flase:before {
  content: "\\eaa1";
}

.icofont-cur-dollar-minus:before {
  content: "\\eaa2";
}

.icofont-cur-dollar-plus:before {
  content: "\\eaa3";
}

.icofont-cur-dollar-true:before {
  content: "\\eaa4";
}

.icofont-cur-dollar:before {
  content: "\\eaa5";
}

.icofont-cur-dong-false:before {
  content: "\\eaa6";
}

.icofont-cur-dong-minus:before {
  content: "\\eaa7";
}

.icofont-cur-dong-plus:before {
  content: "\\eaa8";
}

.icofont-cur-dong-true:before {
  content: "\\eaa9";
}

.icofont-cur-dong:before {
  content: "\\eaaa";
}

.icofont-cur-euro-false:before {
  content: "\\eaab";
}

.icofont-cur-euro-minus:before {
  content: "\\eaac";
}

.icofont-cur-euro-plus:before {
  content: "\\eaad";
}

.icofont-cur-euro-true:before {
  content: "\\eaae";
}

.icofont-cur-euro:before {
  content: "\\eaaf";
}

.icofont-cur-frank-false:before {
  content: "\\eab0";
}

.icofont-cur-frank-minus:before {
  content: "\\eab1";
}

.icofont-cur-frank-plus:before {
  content: "\\eab2";
}

.icofont-cur-frank-true:before {
  content: "\\eab3";
}

.icofont-cur-frank:before {
  content: "\\eab4";
}

.icofont-cur-hryvnia-false:before {
  content: "\\eab5";
}

.icofont-cur-hryvnia-minus:before {
  content: "\\eab6";
}

.icofont-cur-hryvnia-plus:before {
  content: "\\eab7";
}

.icofont-cur-hryvnia-true:before {
  content: "\\eab8";
}

.icofont-cur-hryvnia:before {
  content: "\\eab9";
}

.icofont-cur-lira-false:before {
  content: "\\eaba";
}

.icofont-cur-lira-minus:before {
  content: "\\eabb";
}

.icofont-cur-lira-plus:before {
  content: "\\eabc";
}

.icofont-cur-lira-true:before {
  content: "\\eabd";
}

.icofont-cur-lira:before {
  content: "\\eabe";
}

.icofont-cur-peseta-false:before {
  content: "\\eabf";
}

.icofont-cur-peseta-minus:before {
  content: "\\eac0";
}

.icofont-cur-peseta-plus:before {
  content: "\\eac1";
}

.icofont-cur-peseta-true:before {
  content: "\\eac2";
}

.icofont-cur-peseta:before {
  content: "\\eac3";
}

.icofont-cur-peso-false:before {
  content: "\\eac4";
}

.icofont-cur-peso-minus:before {
  content: "\\eac5";
}

.icofont-cur-peso-plus:before {
  content: "\\eac6";
}

.icofont-cur-peso-true:before {
  content: "\\eac7";
}

.icofont-cur-peso:before {
  content: "\\eac8";
}

.icofont-cur-pound-false:before {
  content: "\\eac9";
}

.icofont-cur-pound-minus:before {
  content: "\\eaca";
}

.icofont-cur-pound-plus:before {
  content: "\\eacb";
}

.icofont-cur-pound-true:before {
  content: "\\eacc";
}

.icofont-cur-pound:before {
  content: "\\eacd";
}

.icofont-cur-renminbi-false:before {
  content: "\\eace";
}

.icofont-cur-renminbi-minus:before {
  content: "\\eacf";
}

.icofont-cur-renminbi-plus:before {
  content: "\\ead0";
}

.icofont-cur-renminbi-true:before {
  content: "\\ead1";
}

.icofont-cur-renminbi:before {
  content: "\\ead2";
}

.icofont-cur-riyal-false:before {
  content: "\\ead3";
}

.icofont-cur-riyal-minus:before {
  content: "\\ead4";
}

.icofont-cur-riyal-plus:before {
  content: "\\ead5";
}

.icofont-cur-riyal-true:before {
  content: "\\ead6";
}

.icofont-cur-riyal:before {
  content: "\\ead7";
}

.icofont-cur-rouble-false:before {
  content: "\\ead8";
}

.icofont-cur-rouble-minus:before {
  content: "\\ead9";
}

.icofont-cur-rouble-plus:before {
  content: "\\eada";
}

.icofont-cur-rouble-true:before {
  content: "\\eadb";
}

.icofont-cur-rouble:before {
  content: "\\eadc";
}

.icofont-cur-rupee-false:before {
  content: "\\eadd";
}

.icofont-cur-rupee-minus:before {
  content: "\\eade";
}

.icofont-cur-rupee-plus:before {
  content: "\\eadf";
}

.icofont-cur-rupee-true:before {
  content: "\\eae0";
}

.icofont-cur-rupee:before {
  content: "\\eae1";
}

.icofont-cur-taka-false:before {
  content: "\\eae2";
}

.icofont-cur-taka-minus:before {
  content: "\\eae3";
}

.icofont-cur-taka-plus:before {
  content: "\\eae4";
}

.icofont-cur-taka-true:before {
  content: "\\eae5";
}

.icofont-cur-taka:before {
  content: "\\eae6";
}

.icofont-cur-turkish-lira-false:before {
  content: "\\eae7";
}

.icofont-cur-turkish-lira-minus:before {
  content: "\\eae8";
}

.icofont-cur-turkish-lira-plus:before {
  content: "\\eae9";
}

.icofont-cur-turkish-lira-true:before {
  content: "\\eaea";
}

.icofont-cur-turkish-lira:before {
  content: "\\eaeb";
}

.icofont-cur-won-false:before {
  content: "\\eaec";
}

.icofont-cur-won-minus:before {
  content: "\\eaed";
}

.icofont-cur-won-plus:before {
  content: "\\eaee";
}

.icofont-cur-won-true:before {
  content: "\\eaef";
}

.icofont-cur-won:before {
  content: "\\eaf0";
}

.icofont-cur-yen-false:before {
  content: "\\eaf1";
}

.icofont-cur-yen-minus:before {
  content: "\\eaf2";
}

.icofont-cur-yen-plus:before {
  content: "\\eaf3";
}

.icofont-cur-yen-true:before {
  content: "\\eaf4";
}

.icofont-cur-yen:before {
  content: "\\eaf5";
}

.icofont-android-nexus:before {
  content: "\\eaf6";
}

.icofont-android-tablet:before {
  content: "\\eaf7";
}

.icofont-apple-watch:before {
  content: "\\eaf8";
}

.icofont-drwaing-tablet:before {
  content: "\\eaf9";
}

.icofont-earphone:before {
  content: "\\eafa";
}

.icofont-flash-drive:before {
  content: "\\eafb";
}

.icofont-game-control:before {
  content: "\\eafc";
}

.icofont-headphone-alt:before {
  content: "\\eafd";
}

.icofont-htc-one:before {
  content: "\\eafe";
}

.icofont-imac:before {
  content: "\\eaff";
}

.icofont-ipad-touch:before {
  content: "\\eb00";
}

.icofont-iphone:before {
  content: "\\eb01";
}

.icofont-ipod-nano:before {
  content: "\\eb02";
}

.icofont-ipod-touch:before {
  content: "\\eb03";
}

.icofont-keyboard-alt:before {
  content: "\\eb04";
}

.icofont-keyboard-wireless:before {
  content: "\\eb05";
}

.icofont-laptop-alt:before {
  content: "\\eb06";
}

.icofont-macbook:before {
  content: "\\eb07";
}

.icofont-magic-mouse:before {
  content: "\\eb08";
}

.icofont-microphone-alt:before {
  content: "\\eb09";
}

.icofont-monitor:before {
  content: "\\eb0a";
}

.icofont-mouse:before {
  content: "\\eb0b";
}

.icofont-nintendo:before {
  content: "\\eb0c";
}

.icofont-playstation:before {
  content: "\\eb0d";
}

.icofont-psvita:before {
  content: "\\eb0e";
}

.icofont-radio-mic:before {
  content: "\\eb0f";
}

.icofont-refrigerator:before {
  content: "\\eb10";
}

.icofont-samsung-galaxy:before {
  content: "\\eb11";
}

.icofont-surface-tablet:before {
  content: "\\eb12";
}

.icofont-washing-machine:before {
  content: "\\eb13";
}

.icofont-wifi-router:before {
  content: "\\eb14";
}

.icofont-wii-u:before {
  content: "\\eb15";
}

.icofont-windows-lumia:before {
  content: "\\eb16";
}

.icofont-wireless-mouse:before {
  content: "\\eb17";
}

.icofont-xbox-360:before {
  content: "\\eb18";
}

.icofont-arrow-down:before {
  content: "\\eb19";
}

.icofont-arrow-left:before {
  content: "\\eb1a";
}

.icofont-arrow-right:before {
  content: "\\eb1b";
}

.icofont-arrow-up:before {
  content: "\\eb1c";
}

.icofont-block-down:before {
  content: "\\eb1d";
}

.icofont-block-left:before {
  content: "\\eb1e";
}

.icofont-block-right:before {
  content: "\\eb1f";
}

.icofont-block-up:before {
  content: "\\eb20";
}

.icofont-bubble-down:before {
  content: "\\eb21";
}

.icofont-bubble-left:before {
  content: "\\eb22";
}

.icofont-bubble-right:before {
  content: "\\eb23";
}

.icofont-bubble-up:before {
  content: "\\eb24";
}

.icofont-caret-down:before {
  content: "\\eb25";
}

.icofont-caret-left:before {
  content: "\\eb26";
}

.icofont-caret-right:before {
  content: "\\eb27";
}

.icofont-caret-up:before {
  content: "\\eb28";
}

.icofont-circled-down:before {
  content: "\\eb29";
}

.icofont-circled-left:before {
  content: "\\eb2a";
}

.icofont-circled-right:before {
  content: "\\eb2b";
}

.icofont-circled-up:before {
  content: "\\eb2c";
}

.icofont-collapse:before {
  content: "\\eb2d";
}

.icofont-cursor-drag:before {
  content: "\\eb2e";
}

.icofont-curved-double-left:before {
  content: "\\eb2f";
}

.icofont-curved-double-right:before {
  content: "\\eb30";
}

.icofont-curved-down:before {
  content: "\\eb31";
}

.icofont-curved-left:before {
  content: "\\eb32";
}

.icofont-curved-right:before {
  content: "\\eb33";
}

.icofont-curved-up:before {
  content: "\\eb34";
}

.icofont-dotted-down:before {
  content: "\\eb35";
}

.icofont-dotted-left:before {
  content: "\\eb36";
}

.icofont-dotted-right:before {
  content: "\\eb37";
}

.icofont-dotted-up:before {
  content: "\\eb38";
}

.icofont-double-left:before {
  content: "\\eb39";
}

.icofont-double-right:before {
  content: "\\eb3a";
}

.icofont-drag:before {
  content: "\\eb3b";
}

.icofont-drag1:before {
  content: "\\eb3c";
}

.icofont-drag2:before {
  content: "\\eb3d";
}

.icofont-drag3:before {
  content: "\\eb3e";
}

.icofont-expand-alt:before {
  content: "\\eb3f";
}

.icofont-hand-down:before {
  content: "\\eb40";
}

.icofont-hand-drag:before {
  content: "\\eb41";
}

.icofont-hand-drag1:before {
  content: "\\eb42";
}

.icofont-hand-drag2:before {
  content: "\\eb43";
}

.icofont-hand-drawn-alt-down:before {
  content: "\\eb44";
}

.icofont-hand-drawn-alt-left:before {
  content: "\\eb45";
}

.icofont-hand-drawn-alt-right:before {
  content: "\\eb46";
}

.icofont-hand-drawn-alt-up:before {
  content: "\\eb47";
}

.icofont-hand-drawn-down:before {
  content: "\\eb48";
}

.icofont-hand-drawn-left:before {
  content: "\\eb49";
}

.icofont-hand-drawn-right:before {
  content: "\\eb4a";
}

.icofont-hand-drawn-up:before {
  content: "\\eb4b";
}

.icofont-hand-left:before {
  content: "\\eb4c";
}

.icofont-hand-right:before {
  content: "\\eb4d";
}

.icofont-hand-up:before {
  content: "\\eb4e";
}

.icofont-line-block-down:before {
  content: "\\eb4f";
}

.icofont-line-block-left:before {
  content: "\\eb50";
}

.icofont-line-block-right:before {
  content: "\\eb51";
}

.icofont-line-block-up:before {
  content: "\\eb52";
}

.icofont-long-arrow-down:before {
  content: "\\eb53";
}

.icofont-long-arrow-left:before {
  content: "\\eb54";
}

.icofont-long-arrow-right:before {
  content: "\\eb55";
}

.icofont-long-arrow-up:before {
  content: "\\eb56";
}

.icofont-rounded-collapse:before {
  content: "\\eb57";
}

.icofont-rounded-double-left:before {
  content: "\\eb58";
}

.icofont-rounded-double-right:before {
  content: "\\eb59";
}

.icofont-rounded-down:before {
  content: "\\eb5a";
}

.icofont-rounded-expand:before {
  content: "\\eb5b";
}

.icofont-rounded-left-down:before {
  content: "\\eb5c";
}

.icofont-rounded-left-up:before {
  content: "\\eb5d";
}

.icofont-rounded-left:before {
  content: "\\eb5e";
}

.icofont-rounded-right-down:before {
  content: "\\eb5f";
}

.icofont-rounded-right-up:before {
  content: "\\eb60";
}

.icofont-rounded-right:before {
  content: "\\eb61";
}

.icofont-rounded-up:before {
  content: "\\eb62";
}

.icofont-scroll-bubble-down:before {
  content: "\\eb63";
}

.icofont-scroll-bubble-left:before {
  content: "\\eb64";
}

.icofont-scroll-bubble-right:before {
  content: "\\eb65";
}

.icofont-scroll-bubble-up:before {
  content: "\\eb66";
}

.icofont-scroll-double-down:before {
  content: "\\eb67";
}

.icofont-scroll-double-left:before {
  content: "\\eb68";
}

.icofont-scroll-double-right:before {
  content: "\\eb69";
}

.icofont-scroll-double-up:before {
  content: "\\eb6a";
}

.icofont-scroll-down:before {
  content: "\\eb6b";
}

.icofont-scroll-left:before {
  content: "\\eb6c";
}

.icofont-scroll-long-down:before {
  content: "\\eb6d";
}

.icofont-scroll-long-left:before {
  content: "\\eb6e";
}

.icofont-scroll-long-right:before {
  content: "\\eb6f";
}

.icofont-scroll-long-up:before {
  content: "\\eb70";
}

.icofont-scroll-right:before {
  content: "\\eb71";
}

.icofont-scroll-up:before {
  content: "\\eb72";
}

.icofont-simple-down:before {
  content: "\\eb73";
}

.icofont-simple-left-down:before {
  content: "\\eb74";
}

.icofont-simple-left-up:before {
  content: "\\eb75";
}

.icofont-simple-left:before {
  content: "\\eb76";
}

.icofont-simple-right-down:before {
  content: "\\eb77";
}

.icofont-simple-right-up:before {
  content: "\\eb78";
}

.icofont-simple-right:before {
  content: "\\eb79";
}

.icofont-simple-up:before {
  content: "\\eb7a";
}

.icofont-square-down:before {
  content: "\\eb7b";
}

.icofont-square-left:before {
  content: "\\eb7c";
}

.icofont-square-right:before {
  content: "\\eb7d";
}

.icofont-square-up:before {
  content: "\\eb7e";
}

.icofont-stylish-down:before {
  content: "\\eb7f";
}

.icofont-stylish-left:before {
  content: "\\eb80";
}

.icofont-stylish-right:before {
  content: "\\eb81";
}

.icofont-stylish-up:before {
  content: "\\eb82";
}

.icofont-swoosh-down:before {
  content: "\\eb83";
}

.icofont-swoosh-left:before {
  content: "\\eb84";
}

.icofont-swoosh-right:before {
  content: "\\eb85";
}

.icofont-swoosh-up:before {
  content: "\\eb86";
}

.icofont-thin-double-left:before {
  content: "\\eb87";
}

.icofont-thin-double-right:before {
  content: "\\eb88";
}

.icofont-thin-down:before {
  content: "\\eb89";
}

.icofont-thin-left:before {
  content: "\\eb8a";
}

.icofont-thin-right:before {
  content: "\\eb8b";
}

.icofont-thin-up:before {
  content: "\\eb8c";
}

.icofont-atom:before {
  content: "\\eb8d";
}

.icofont-award:before {
  content: "\\eb8e";
}

.icofont-bell-alt:before {
  content: "\\eb8f";
}

.icofont-book-alt:before {
  content: "\\eb90";
}

.icofont-brainstorming:before {
  content: "\\eb91";
}

.icofont-certificate-alt-1:before {
  content: "\\eb92";
}

.icofont-certificate-alt-2:before {
  content: "\\eb93";
}

.icofont-dna-alt-2:before {
  content: "\\eb94";
}

.icofont-education:before {
  content: "\\eb95";
}

.icofont-electron:before {
  content: "\\eb96";
}

.icofont-fountain-pen:before {
  content: "\\eb97";
}

.icofont-globe-alt:before {
  content: "\\eb98";
}

.icofont-graduate-alt:before {
  content: "\\eb99";
}

.icofont-group-students:before {
  content: "\\eb9a";
}

.icofont-hat-alt:before {
  content: "\\eb9b";
}

.icofont-hat:before {
  content: "\\eb9c";
}

.icofont-instrument:before {
  content: "\\eb9d";
}

.icofont-lamp-light:before {
  content: "\\eb9e";
}

.icofont-microscope-alt:before {
  content: "\\eb9f";
}

.icofont-paper:before {
  content: "\\eba0";
}

.icofont-pen-alt-4:before {
  content: "\\eba1";
}

.icofont-pen-nib:before {
  content: "\\eba2";
}

.icofont-pencil-alt-5:before {
  content: "\\eba3";
}

.icofont-quill-pen:before {
  content: "\\eba4";
}

.icofont-read-book-alt:before {
  content: "\\eba5";
}

.icofont-read-book:before {
  content: "\\eba6";
}

.icofont-school-bag:before {
  content: "\\eba7";
}

.icofont-school-bus:before {
  content: "\\eba8";
}

.icofont-student-alt:before {
  content: "\\eba9";
}

.icofont-student:before {
  content: "\\ebaa";
}

.icofont-teacher:before {
  content: "\\ebab";
}

.icofont-test-bulb:before {
  content: "\\ebac";
}

.icofont-test-tube-alt:before {
  content: "\\ebad";
}

.icofont-university:before {
  content: "\\ebae";
}

.icofont-emo-angry:before {
  content: "\\ebaf";
}

.icofont-emo-astonished:before {
  content: "\\ebb0";
}

.icofont-emo-confounded:before {
  content: "\\ebb1";
}

.icofont-emo-confused:before {
  content: "\\ebb2";
}

.icofont-emo-crying:before {
  content: "\\ebb3";
}

.icofont-emo-dizzy:before {
  content: "\\ebb4";
}

.icofont-emo-expressionless:before {
  content: "\\ebb5";
}

.icofont-emo-heart-eyes:before {
  content: "\\ebb6";
}

.icofont-emo-laughing:before {
  content: "\\ebb7";
}

.icofont-emo-nerd-smile:before {
  content: "\\ebb8";
}

.icofont-emo-open-mouth:before {
  content: "\\ebb9";
}

.icofont-emo-rage:before {
  content: "\\ebba";
}

.icofont-emo-rolling-eyes:before {
  content: "\\ebbb";
}

.icofont-emo-sad:before {
  content: "\\ebbc";
}

.icofont-emo-simple-smile:before {
  content: "\\ebbd";
}

.icofont-emo-slightly-smile:before {
  content: "\\ebbe";
}

.icofont-emo-smirk:before {
  content: "\\ebbf";
}

.icofont-emo-stuck-out-tongue:before {
  content: "\\ebc0";
}

.icofont-emo-wink-smile:before {
  content: "\\ebc1";
}

.icofont-emo-worried:before {
  content: "\\ebc2";
}

.icofont-architecture-alt:before {
  content: "\\ebc3";
}

.icofont-architecture:before {
  content: "\\ebc4";
}

.icofont-barricade:before {
  content: "\\ebc5";
}

.icofont-bricks:before {
  content: "\\ebc6";
}

.icofont-calculations:before {
  content: "\\ebc7";
}

.icofont-cement-mix:before {
  content: "\\ebc8";
}

.icofont-cement-mixer:before {
  content: "\\ebc9";
}

.icofont-danger-zone:before {
  content: "\\ebca";
}

.icofont-drill:before {
  content: "\\ebcb";
}

.icofont-eco-energy:before {
  content: "\\ebcc";
}

.icofont-eco-environmen:before {
  content: "\\ebcd";
}

.icofont-energy-air:before {
  content: "\\ebce";
}

.icofont-energy-oil:before {
  content: "\\ebcf";
}

.icofont-energy-savings:before {
  content: "\\ebd0";
}

.icofont-energy-solar:before {
  content: "\\ebd1";
}

.icofont-energy-water:before {
  content: "\\ebd2";
}

.icofont-engineer:before {
  content: "\\ebd3";
}

.icofont-fire-extinguisher-alt:before {
  content: "\\ebd4";
}

.icofont-fix-tools:before {
  content: "\\ebd5";
}

.icofont-glue-oil:before {
  content: "\\ebd6";
}

.icofont-hammer-alt:before {
  content: "\\ebd7";
}

.icofont-help-robot:before {
  content: "\\ebd8";
}

.icofont-industries-alt-1:before {
  content: "\\ebd9";
}

.icofont-industries-alt-2:before {
  content: "\\ebda";
}

.icofont-industries-alt-3:before {
  content: "\\ebdb";
}

.icofont-industries-alt-4:before {
  content: "\\ebdc";
}

.icofont-industries-alt-5:before {
  content: "\\ebdd";
}

.icofont-industries:before {
  content: "\\ebde";
}

.icofont-labour:before {
  content: "\\ebdf";
}

.icofont-mining:before {
  content: "\\ebe0";
}

.icofont-paint-brush:before {
  content: "\\ebe1";
}

.icofont-pollution:before {
  content: "\\ebe2";
}

.icofont-power-zone:before {
  content: "\\ebe3";
}

.icofont-radio-active:before {
  content: "\\ebe4";
}

.icofont-recycle-alt:before {
  content: "\\ebe5";
}

.icofont-recycling-man:before {
  content: "\\ebe6";
}

.icofont-safety-hat-light:before {
  content: "\\ebe7";
}

.icofont-safety-hat:before {
  content: "\\ebe8";
}

.icofont-saw:before {
  content: "\\ebe9";
}

.icofont-screw-driver:before {
  content: "\\ebea";
}

.icofont-settings-alt:before {
  content: "\\ebeb";
}

.icofont-tools-alt-1:before {
  content: "\\ebec";
}

.icofont-tools-alt-2:before {
  content: "\\ebed";
}

.icofont-tools-bag:before {
  content: "\\ebee";
}

.icofont-trolley:before {
  content: "\\ebef";
}

.icofont-trowel:before {
  content: "\\ebf0";
}

.icofont-under-construction-alt:before {
  content: "\\ebf1";
}

.icofont-under-construction:before {
  content: "\\ebf2";
}

.icofont-vehicle-cement:before {
  content: "\\ebf3";
}

.icofont-vehicle-crane:before {
  content: "\\ebf4";
}

.icofont-vehicle-delivery-van:before {
  content: "\\ebf5";
}

.icofont-vehicle-dozer:before {
  content: "\\ebf6";
}

.icofont-vehicle-excavator:before {
  content: "\\ebf7";
}

.icofont-vehicle-trucktor:before {
  content: "\\ebf8";
}

.icofont-vehicle-wrecking:before {
  content: "\\ebf9";
}

.icofont-worker-group:before {
  content: "\\ebfa";
}

.icofont-worker:before {
  content: "\\ebfb";
}

.icofont-wrench:before {
  content: "\\ebfc";
}

.icofont-file-audio:before {
  content: "\\ebfd";
}

.icofont-file-avi-mp4:before {
  content: "\\ebfe";
}

.icofont-file-bmp:before {
  content: "\\ebff";
}

.icofont-file-code:before {
  content: "\\ec00";
}

.icofont-file-css:before {
  content: "\\ec01";
}

.icofont-file-document:before {
  content: "\\ec02";
}

.icofont-file-eps:before {
  content: "\\ec03";
}

.icofont-file-excel:before {
  content: "\\ec04";
}

.icofont-file-exe:before {
  content: "\\ec05";
}

.icofont-file-file:before {
  content: "\\ec06";
}

.icofont-file-flv:before {
  content: "\\ec07";
}

.icofont-file-gif:before {
  content: "\\ec08";
}

.icofont-file-html5:before {
  content: "\\ec09";
}

.icofont-file-image:before {
  content: "\\ec0a";
}

.icofont-file-iso:before {
  content: "\\ec0b";
}

.icofont-file-java:before {
  content: "\\ec0c";
}

.icofont-file-javascript:before {
  content: "\\ec0d";
}

.icofont-file-jpg:before {
  content: "\\ec0e";
}

.icofont-file-midi:before {
  content: "\\ec0f";
}

.icofont-file-mov:before {
  content: "\\ec10";
}

.icofont-file-mp3:before {
  content: "\\ec11";
}

.icofont-file-pdf:before {
  content: "\\ec12";
}

.icofont-file-php:before {
  content: "\\ec13";
}

.icofont-file-png:before {
  content: "\\ec14";
}

.icofont-file-powerpoint:before {
  content: "\\ec15";
}

.icofont-file-presentation:before {
  content: "\\ec16";
}

.icofont-file-psb:before {
  content: "\\ec17";
}

.icofont-file-psd:before {
  content: "\\ec18";
}

.icofont-file-python:before {
  content: "\\ec19";
}

.icofont-file-ruby:before {
  content: "\\ec1a";
}

.icofont-file-spreadsheet:before {
  content: "\\ec1b";
}

.icofont-file-sql:before {
  content: "\\ec1c";
}

.icofont-file-svg:before {
  content: "\\ec1d";
}

.icofont-file-text:before {
  content: "\\ec1e";
}

.icofont-file-tiff:before {
  content: "\\ec1f";
}

.icofont-file-video:before {
  content: "\\ec20";
}

.icofont-file-wave:before {
  content: "\\ec21";
}

.icofont-file-wmv:before {
  content: "\\ec22";
}

.icofont-file-word:before {
  content: "\\ec23";
}

.icofont-file-zip:before {
  content: "\\ec24";
}

.icofont-apple:before {
  content: "\\ec25";
}

.icofont-arabian-coffee:before {
  content: "\\ec26";
}

.icofont-artichoke:before {
  content: "\\ec27";
}

.icofont-asparagus:before {
  content: "\\ec28";
}

.icofont-avocado:before {
  content: "\\ec29";
}

.icofont-baby-food:before {
  content: "\\ec2a";
}

.icofont-banana:before {
  content: "\\ec2b";
}

.icofont-bbq:before {
  content: "\\ec2c";
}

.icofont-beans:before {
  content: "\\ec2d";
}

.icofont-beer:before {
  content: "\\ec2e";
}

.icofont-bell-pepper-capsicum:before {
  content: "\\ec2f";
}

.icofont-birthday-cake:before {
  content: "\\ec30";
}

.icofont-bread:before {
  content: "\\ec31";
}

.icofont-broccoli:before {
  content: "\\ec32";
}

.icofont-burger:before {
  content: "\\ec33";
}

.icofont-cabbage:before {
  content: "\\ec34";
}

.icofont-carrot:before {
  content: "\\ec35";
}

.icofont-cauli-flower:before {
  content: "\\ec36";
}

.icofont-cheese:before {
  content: "\\ec37";
}

.icofont-chef:before {
  content: "\\ec38";
}

.icofont-cherry:before {
  content: "\\ec39";
}

.icofont-chicken-fry:before {
  content: "\\ec3a";
}

.icofont-chicken:before {
  content: "\\ec3b";
}

.icofont-cocktail:before {
  content: "\\ec3c";
}

.icofont-coconut:before {
  content: "\\ec3d";
}

.icofont-coffee-alt:before {
  content: "\\ec3e";
}

.icofont-coffee-mug:before {
  content: "\\ec3f";
}

.icofont-coffee-pot:before {
  content: "\\ec40";
}

.icofont-cola:before {
  content: "\\ec41";
}

.icofont-corn:before {
  content: "\\ec42";
}

.icofont-croissant:before {
  content: "\\ec43";
}

.icofont-crop-plant:before {
  content: "\\ec44";
}

.icofont-cucumber:before {
  content: "\\ec45";
}

.icofont-cup-cake:before {
  content: "\\ec46";
}

.icofont-dining-table:before {
  content: "\\ec47";
}

.icofont-donut:before {
  content: "\\ec48";
}

.icofont-egg-plant:before {
  content: "\\ec49";
}

.icofont-egg-poached:before {
  content: "\\ec4a";
}

.icofont-farmer:before {
  content: "\\ec4b";
}

.icofont-farmer1:before {
  content: "\\ec4c";
}

.icofont-fast-food:before {
  content: "\\ec4d";
}

.icofont-fish:before {
  content: "\\ec4e";
}

.icofont-food-basket:before {
  content: "\\ec4f";
}

.icofont-food-cart:before {
  content: "\\ec50";
}

.icofont-fork-and-knife:before {
  content: "\\ec51";
}

.icofont-french-fries:before {
  content: "\\ec52";
}

.icofont-fresh-juice:before {
  content: "\\ec53";
}

.icofont-fruits:before {
  content: "\\ec54";
}

.icofont-grapes:before {
  content: "\\ec55";
}

.icofont-honey:before {
  content: "\\ec56";
}

.icofont-hot-dog:before {
  content: "\\ec57";
}

.icofont-hotel-alt:before {
  content: "\\ec58";
}

.icofont-ice-cream-alt:before {
  content: "\\ec59";
}

.icofont-ice-cream:before {
  content: "\\ec5a";
}

.icofont-ketchup:before {
  content: "\\ec5b";
}

.icofont-kiwi:before {
  content: "\\ec5c";
}

.icofont-layered-cake:before {
  content: "\\ec5d";
}

.icofont-lemon-alt:before {
  content: "\\ec5e";
}

.icofont-lobster:before {
  content: "\\ec5f";
}

.icofont-mango:before {
  content: "\\ec60";
}

.icofont-milk:before {
  content: "\\ec61";
}

.icofont-mushroom:before {
  content: "\\ec62";
}

.icofont-noodles:before {
  content: "\\ec63";
}

.icofont-onion:before {
  content: "\\ec64";
}

.icofont-orange:before {
  content: "\\ec65";
}

.icofont-pear:before {
  content: "\\ec66";
}

.icofont-peas:before {
  content: "\\ec67";
}

.icofont-pepper:before {
  content: "\\ec68";
}

.icofont-pie-alt:before {
  content: "\\ec69";
}

.icofont-pineapple:before {
  content: "\\ec6a";
}

.icofont-pizza-slice:before {
  content: "\\ec6b";
}

.icofont-pizza:before {
  content: "\\ec6c";
}

.icofont-plant:before {
  content: "\\ec6d";
}

.icofont-popcorn:before {
  content: "\\ec6e";
}

.icofont-potato:before {
  content: "\\ec6f";
}

.icofont-pumpkin:before {
  content: "\\ec70";
}

.icofont-raddish:before {
  content: "\\ec71";
}

.icofont-restaurant-menu:before {
  content: "\\ec72";
}

.icofont-restaurant:before {
  content: "\\ec73";
}

.icofont-salt-and-pepper:before {
  content: "\\ec74";
}

.icofont-sandwich:before {
  content: "\\ec75";
}

.icofont-sausage:before {
  content: "\\ec76";
}

.icofont-shrimp:before {
  content: "\\ec77";
}

.icofont-sof-drinks:before {
  content: "\\ec78";
}

.icofont-soup-bowl:before {
  content: "\\ec79";
}

.icofont-spoon-and-fork:before {
  content: "\\ec7a";
}

.icofont-steak:before {
  content: "\\ec7b";
}

.icofont-strawberry:before {
  content: "\\ec7c";
}

.icofont-sub-sandwich:before {
  content: "\\ec7d";
}

.icofont-sushi:before {
  content: "\\ec7e";
}

.icofont-taco:before {
  content: "\\ec7f";
}

.icofont-tea-pot:before {
  content: "\\ec80";
}

.icofont-tea:before {
  content: "\\ec81";
}

.icofont-tomato:before {
  content: "\\ec82";
}

.icofont-waiter-alt:before {
  content: "\\ec83";
}

.icofont-watermelon:before {
  content: "\\ec84";
}

.icofont-wheat:before {
  content: "\\ec85";
}

.icofont-abc:before {
  content: "\\ec86";
}

.icofont-baby-cloth:before {
  content: "\\ec87";
}

.icofont-baby-milk-bottle:before {
  content: "\\ec88";
}

.icofont-baby-trolley:before {
  content: "\\ec89";
}

.icofont-back-pack:before {
  content: "\\ec8a";
}

.icofont-candy:before {
  content: "\\ec8b";
}

.icofont-cycling:before {
  content: "\\ec8c";
}

.icofont-holding-hands:before {
  content: "\\ec8d";
}

.icofont-infant-nipple:before {
  content: "\\ec8e";
}

.icofont-kids-scooter:before {
  content: "\\ec8f";
}

.icofont-safety-pin:before {
  content: "\\ec90";
}

.icofont-teddy-bear:before {
  content: "\\ec91";
}

.icofont-toy-ball:before {
  content: "\\ec92";
}

.icofont-toy-cat:before {
  content: "\\ec93";
}

.icofont-toy-duck:before {
  content: "\\ec94";
}

.icofont-toy-elephant:before {
  content: "\\ec95";
}

.icofont-toy-hand:before {
  content: "\\ec96";
}

.icofont-toy-horse:before {
  content: "\\ec97";
}

.icofont-toy-lattu:before {
  content: "\\ec98";
}

.icofont-toy-train:before {
  content: "\\ec99";
}

.icofont-unique-idea:before {
  content: "\\ec9a";
}

.icofont-bag-alt:before {
  content: "\\ec9b";
}

.icofont-burglar:before {
  content: "\\ec9c";
}

.icofont-cannon-firing:before {
  content: "\\ec9d";
}

.icofont-cc-camera:before {
  content: "\\ec9e";
}

.icofont-cop-badge:before {
  content: "\\ec9f";
}

.icofont-cop:before {
  content: "\\eca0";
}

.icofont-court-hammer:before {
  content: "\\eca1";
}

.icofont-court:before {
  content: "\\eca2";
}

.icofont-finger-print:before {
  content: "\\eca3";
}

.icofont-handcuff-alt:before {
  content: "\\eca4";
}

.icofont-handcuff:before {
  content: "\\eca5";
}

.icofont-investigation:before {
  content: "\\eca6";
}

.icofont-investigator:before {
  content: "\\eca7";
}

.icofont-jail:before {
  content: "\\eca8";
}

.icofont-judge:before {
  content: "\\eca9";
}

.icofont-law-alt-1:before {
  content: "\\ecaa";
}

.icofont-law-alt-2:before {
  content: "\\ecab";
}

.icofont-law-alt-3:before {
  content: "\\ecac";
}

.icofont-law-book:before {
  content: "\\ecad";
}

.icofont-law-document:before {
  content: "\\ecae";
}

.icofont-law:before {
  content: "\\ecaf";
}

.icofont-lawyer-alt-1:before {
  content: "\\ecb0";
}

.icofont-lawyer-alt-2:before {
  content: "\\ecb1";
}

.icofont-lawyer:before {
  content: "\\ecb2";
}

.icofont-order:before {
  content: "\\ecb3";
}

.icofont-pistol:before {
  content: "\\ecb4";
}

.icofont-police-badge:before {
  content: "\\ecb5";
}

.icofont-police-cap:before {
  content: "\\ecb6";
}

.icofont-police-car-alt-1:before {
  content: "\\ecb7";
}

.icofont-police-car-alt-2:before {
  content: "\\ecb8";
}

.icofont-police-hat:before {
  content: "\\ecb9";
}

.icofont-police-van:before {
  content: "\\ecba";
}

.icofont-police:before {
  content: "\\ecbb";
}

.icofont-protect:before {
  content: "\\ecbc";
}

.icofont-scales:before {
  content: "\\ecbd";
}

.icofont-thief-alt:before {
  content: "\\ecbe";
}

.icofont-thief:before {
  content: "\\ecbf";
}

.icofont-abacus-alt:before {
  content: "\\ecc0";
}

.icofont-abacus:before {
  content: "\\ecc1";
}

.icofont-angle:before {
  content: "\\ecc2";
}

.icofont-calculator-alt-1:before {
  content: "\\ecc3";
}

.icofont-calculator-alt-2:before {
  content: "\\ecc4";
}

.icofont-circle-ruler-alt:before {
  content: "\\ecc5";
}

.icofont-circle-ruler:before {
  content: "\\ecc6";
}

.icofont-compass-alt-1:before {
  content: "\\ecc7";
}

.icofont-compass-alt-2:before {
  content: "\\ecc8";
}

.icofont-compass-alt-3:before {
  content: "\\ecc9";
}

.icofont-compass-alt-4:before {
  content: "\\ecca";
}

.icofont-degrees-alt-1:before {
  content: "\\eccb";
}

.icofont-degrees-alt-2:before {
  content: "\\eccc";
}

.icofont-degrees:before {
  content: "\\eccd";
}

.icofont-golden-ratio:before {
  content: "\\ecce";
}

.icofont-marker-alt-1:before {
  content: "\\eccf";
}

.icofont-marker-alt-2:before {
  content: "\\ecd0";
}

.icofont-marker-alt-3:before {
  content: "\\ecd1";
}

.icofont-mathematical-alt-1:before {
  content: "\\ecd2";
}

.icofont-mathematical-alt-2:before {
  content: "\\ecd3";
}

.icofont-mathematical:before {
  content: "\\ecd4";
}

.icofont-pen-alt-1:before {
  content: "\\ecd5";
}

.icofont-pen-alt-2:before {
  content: "\\ecd6";
}

.icofont-pen-alt-3:before {
  content: "\\ecd7";
}

.icofont-pen-holder-alt-1:before {
  content: "\\ecd8";
}

.icofont-pen-holder:before {
  content: "\\ecd9";
}

.icofont-pencil-alt-1:before {
  content: "\\ecda";
}

.icofont-pencil-alt-2:before {
  content: "\\ecdb";
}

.icofont-pencil-alt-3:before {
  content: "\\ecdc";
}

.icofont-pencil-alt-4:before {
  content: "\\ecdd";
}

.icofont-ruler-alt-1:before {
  content: "\\ecde";
}

.icofont-ruler-alt-2:before {
  content: "\\ecdf";
}

.icofont-ruler-compass-alt:before {
  content: "\\ece0";
}

.icofont-ruler-compass:before {
  content: "\\ece1";
}

.icofont-ruler-pencil-alt-1:before {
  content: "\\ece2";
}

.icofont-ruler-pencil-alt-2:before {
  content: "\\ece3";
}

.icofont-ruler-pencil:before {
  content: "\\ece4";
}

.icofont-ruler:before {
  content: "\\ece5";
}

.icofont-rulers-alt:before {
  content: "\\ece6";
}

.icofont-rulers:before {
  content: "\\ece7";
}

.icofont-square-root:before {
  content: "\\ece8";
}

.icofont-aids:before {
  content: "\\ece9";
}

.icofont-ambulance:before {
  content: "\\ecea";
}

.icofont-autism:before {
  content: "\\eceb";
}

.icofont-bandage:before {
  content: "\\ecec";
}

.icofont-bed-patient:before {
  content: "\\eced";
}

.icofont-blind:before {
  content: "\\ecee";
}

.icofont-blood-drop:before {
  content: "\\ecef";
}

.icofont-blood-test:before {
  content: "\\ecf0";
}

.icofont-blood:before {
  content: "\\ecf1";
}

.icofont-capsule:before {
  content: "\\ecf2";
}

.icofont-crutches:before {
  content: "\\ecf3";
}

.icofont-dna-alt-1:before {
  content: "\\ecf4";
}

.icofont-dna:before {
  content: "\\ecf5";
}

.icofont-doctor-alt:before {
  content: "\\ecf6";
}

.icofont-doctor:before {
  content: "\\ecf7";
}

.icofont-drug-pack:before {
  content: "\\ecf8";
}

.icofont-drug:before {
  content: "\\ecf9";
}

.icofont-eye-alt:before {
  content: "\\ecfa";
}

.icofont-first-aid-alt:before {
  content: "\\ecfb";
}

.icofont-garbage:before {
  content: "\\ecfc";
}

.icofont-heart-alt:before {
  content: "\\ecfd";
}

.icofont-heartbeat:before {
  content: "\\ecfe";
}

.icofont-herbal:before {
  content: "\\ecff";
}

.icofont-hospital:before {
  content: "\\ed00";
}

.icofont-icu:before {
  content: "\\ed01";
}

.icofont-injection-syringe:before {
  content: "\\ed02";
}

.icofont-laboratory:before {
  content: "\\ed03";
}

.icofont-medical-sign-alt:before {
  content: "\\ed04";
}

.icofont-medical-sign:before {
  content: "\\ed05";
}

.icofont-nurse-alt:before {
  content: "\\ed06";
}

.icofont-nurse:before {
  content: "\\ed07";
}

.icofont-nursing-home:before {
  content: "\\ed08";
}

.icofont-operation-theater:before {
  content: "\\ed09";
}

.icofont-paralysis-disability:before {
  content: "\\ed0a";
}

.icofont-pills:before {
  content: "\\ed0b";
}

.icofont-prescription:before {
  content: "\\ed0c";
}

.icofont-pulse:before {
  content: "\\ed0d";
}

.icofont-stethoscope-alt:before {
  content: "\\ed0e";
}

.icofont-stethoscope:before {
  content: "\\ed0f";
}

.icofont-stretcher:before {
  content: "\\ed10";
}

.icofont-surgeon-alt:before {
  content: "\\ed11";
}

.icofont-surgeon:before {
  content: "\\ed12";
}

.icofont-tablets:before {
  content: "\\ed13";
}

.icofont-test-bottle:before {
  content: "\\ed14";
}

.icofont-test-tube:before {
  content: "\\ed15";
}

.icofont-thermometer-alt:before {
  content: "\\ed16";
}

.icofont-tooth:before {
  content: "\\ed17";
}

.icofont-xray:before {
  content: "\\ed18";
}

.icofont-ui-add:before {
  content: "\\ed19";
}

.icofont-ui-alarm:before {
  content: "\\ed1a";
}

.icofont-ui-battery:before {
  content: "\\ed1b";
}

.icofont-ui-block:before {
  content: "\\ed1c";
}

.icofont-ui-bluetooth:before {
  content: "\\ed1d";
}

.icofont-ui-brightness:before {
  content: "\\ed1e";
}

.icofont-ui-browser:before {
  content: "\\ed1f";
}

.icofont-ui-calculator:before {
  content: "\\ed20";
}

.icofont-ui-calendar:before {
  content: "\\ed21";
}

.icofont-ui-call:before {
  content: "\\ed22";
}

.icofont-ui-camera:before {
  content: "\\ed23";
}

.icofont-ui-cart:before {
  content: "\\ed24";
}

.icofont-ui-cell-phone:before {
  content: "\\ed25";
}

.icofont-ui-chat:before {
  content: "\\ed26";
}

.icofont-ui-check:before {
  content: "\\ed27";
}

.icofont-ui-clip-board:before {
  content: "\\ed28";
}

.icofont-ui-clip:before {
  content: "\\ed29";
}

.icofont-ui-clock:before {
  content: "\\ed2a";
}

.icofont-ui-close:before {
  content: "\\ed2b";
}

.icofont-ui-contact-list:before {
  content: "\\ed2c";
}

.icofont-ui-copy:before {
  content: "\\ed2d";
}

.icofont-ui-cut:before {
  content: "\\ed2e";
}

.icofont-ui-delete:before {
  content: "\\ed2f";
}

.icofont-ui-dial-phone:before {
  content: "\\ed30";
}

.icofont-ui-edit:before {
  content: "\\ed31";
}

.icofont-ui-email:before {
  content: "\\ed32";
}

.icofont-ui-file:before {
  content: "\\ed33";
}

.icofont-ui-fire-wall:before {
  content: "\\ed34";
}

.icofont-ui-flash-light:before {
  content: "\\ed35";
}

.icofont-ui-flight:before {
  content: "\\ed36";
}

.icofont-ui-folder:before {
  content: "\\ed37";
}

.icofont-ui-game:before {
  content: "\\ed38";
}

.icofont-ui-handicapped:before {
  content: "\\ed39";
}

.icofont-ui-head-phone:before {
  content: "\\ed3a";
}

.icofont-ui-home:before {
  content: "\\ed3b";
}

.icofont-ui-image:before {
  content: "\\ed3c";
}

.icofont-ui-keyboard:before {
  content: "\\ed3d";
}

.icofont-ui-laoding:before {
  content: "\\ed3e";
}

.icofont-ui-lock:before {
  content: "\\ed3f";
}

.icofont-ui-love-add:before {
  content: "\\ed40";
}

.icofont-ui-love-broken:before {
  content: "\\ed41";
}

.icofont-ui-love-remove:before {
  content: "\\ed42";
}

.icofont-ui-love:before {
  content: "\\ed43";
}

.icofont-ui-map:before {
  content: "\\ed44";
}

.icofont-ui-message:before {
  content: "\\ed45";
}

.icofont-ui-messaging:before {
  content: "\\ed46";
}

.icofont-ui-movie:before {
  content: "\\ed47";
}

.icofont-ui-music-player:before {
  content: "\\ed48";
}

.icofont-ui-music:before {
  content: "\\ed49";
}

.icofont-ui-mute:before {
  content: "\\ed4a";
}

.icofont-ui-network:before {
  content: "\\ed4b";
}

.icofont-ui-next:before {
  content: "\\ed4c";
}

.icofont-ui-note:before {
  content: "\\ed4d";
}

.icofont-ui-office:before {
  content: "\\ed4e";
}

.icofont-ui-password:before {
  content: "\\ed4f";
}

.icofont-ui-pause:before {
  content: "\\ed50";
}

.icofont-ui-play-stop:before {
  content: "\\ed51";
}

.icofont-ui-play:before {
  content: "\\ed52";
}

.icofont-ui-pointer:before {
  content: "\\ed53";
}

.icofont-ui-power:before {
  content: "\\ed54";
}

.icofont-ui-press:before {
  content: "\\ed55";
}

.icofont-ui-previous:before {
  content: "\\ed56";
}

.icofont-ui-rate-add:before {
  content: "\\ed57";
}

.icofont-ui-rate-blank:before {
  content: "\\ed58";
}

.icofont-ui-rate-remove:before {
  content: "\\ed59";
}

.icofont-ui-rating:before {
  content: "\\ed5a";
}

.icofont-ui-record:before {
  content: "\\ed5b";
}

.icofont-ui-remove:before {
  content: "\\ed5c";
}

.icofont-ui-reply:before {
  content: "\\ed5d";
}

.icofont-ui-rotation:before {
  content: "\\ed5e";
}

.icofont-ui-rss:before {
  content: "\\ed5f";
}

.icofont-ui-search:before {
  content: "\\ed60";
}

.icofont-ui-settings:before {
  content: "\\ed61";
}

.icofont-ui-social-link:before {
  content: "\\ed62";
}

.icofont-ui-tag:before {
  content: "\\ed63";
}

.icofont-ui-text-chat:before {
  content: "\\ed64";
}

.icofont-ui-text-loading:before {
  content: "\\ed65";
}

.icofont-ui-theme:before {
  content: "\\ed66";
}

.icofont-ui-timer:before {
  content: "\\ed67";
}

.icofont-ui-touch-phone:before {
  content: "\\ed68";
}

.icofont-ui-travel:before {
  content: "\\ed69";
}

.icofont-ui-unlock:before {
  content: "\\ed6a";
}

.icofont-ui-user-group:before {
  content: "\\ed6b";
}

.icofont-ui-user:before {
  content: "\\ed6c";
}

.icofont-ui-v-card:before {
  content: "\\ed6d";
}

.icofont-ui-video-chat:before {
  content: "\\ed6e";
}

.icofont-ui-video-message:before {
  content: "\\ed6f";
}

.icofont-ui-video-play:before {
  content: "\\ed70";
}

.icofont-ui-video:before {
  content: "\\ed71";
}

.icofont-ui-volume:before {
  content: "\\ed72";
}

.icofont-ui-weather:before {
  content: "\\ed73";
}

.icofont-ui-wifi:before {
  content: "\\ed74";
}

.icofont-ui-zoom-in:before {
  content: "\\ed75";
}

.icofont-ui-zoom-out:before {
  content: "\\ed76";
}

.icofont-cassette-player:before {
  content: "\\ed77";
}

.icofont-cassette:before {
  content: "\\ed78";
}

.icofont-forward:before {
  content: "\\ed79";
}

.icofont-game:before {
  content: "\\ed7a";
}

.icofont-guiter:before {
  content: "\\ed7b";
}

.icofont-headphone-alt-1:before {
  content: "\\ed7c";
}

.icofont-headphone-alt-2:before {
  content: "\\ed7d";
}

.icofont-headphone-alt-3:before {
  content: "\\ed7e";
}

.icofont-listening:before {
  content: "\\ed7f";
}

.icofont-megaphone-alt:before {
  content: "\\ed80";
}

.icofont-megaphone:before {
  content: "\\ed81";
}

.icofont-movie:before {
  content: "\\ed82";
}

.icofont-mp3-player:before {
  content: "\\ed83";
}

.icofont-multimedia:before {
  content: "\\ed84";
}

.icofont-music-disk:before {
  content: "\\ed85";
}

.icofont-music-note:before {
  content: "\\ed86";
}

.icofont-pause:before {
  content: "\\ed87";
}

.icofont-play-alt-1:before {
  content: "\\ed88";
}

.icofont-play-alt-2:before {
  content: "\\ed89";
}

.icofont-play-alt-3:before {
  content: "\\ed8a";
}

.icofont-play-pause:before {
  content: "\\ed8b";
}

.icofont-record:before {
  content: "\\ed8c";
}

.icofont-retro-music-disk:before {
  content: "\\ed8d";
}

.icofont-rewind:before {
  content: "\\ed8e";
}

.icofont-song-notes:before {
  content: "\\ed8f";
}

.icofont-sound-wave-alt:before {
  content: "\\ed90";
}

.icofont-sound-wave:before {
  content: "\\ed91";
}

.icofont-stop:before {
  content: "\\ed92";
}

.icofont-video-alt:before {
  content: "\\ed93";
}

.icofont-video-cam:before {
  content: "\\ed94";
}

.icofont-volume-bar:before {
  content: "\\ed95";
}

.icofont-volume-mute:before {
  content: "\\ed96";
}

.icofont-youtube-play:before {
  content: "\\ed97";
}

.icofont-amazon-alt:before {
  content: "\\ed98";
}

.icofont-amazon:before {
  content: "\\ed99";
}

.icofont-american-express-alt:before {
  content: "\\ed9a";
}

.icofont-american-express:before {
  content: "\\ed9b";
}

.icofont-apple-pay-alt:before {
  content: "\\ed9c";
}

.icofont-apple-pay:before {
  content: "\\ed9d";
}

.icofont-bank-transfer-alt:before {
  content: "\\ed9e";
}

.icofont-bank-transfer:before {
  content: "\\ed9f";
}

.icofont-braintree-alt:before {
  content: "\\eda0";
}

.icofont-braintree:before {
  content: "\\eda1";
}

.icofont-cash-on-delivery-alt:before {
  content: "\\eda2";
}

.icofont-cash-on-delivery:before {
  content: "\\eda3";
}

.icofont-checkout-alt:before {
  content: "\\eda4";
}

.icofont-checkout:before {
  content: "\\eda5";
}

.icofont-diners-club-alt-1:before {
  content: "\\eda6";
}

.icofont-diners-club-alt-2:before {
  content: "\\eda7";
}

.icofont-diners-club-alt-3:before {
  content: "\\eda8";
}

.icofont-diners-club:before {
  content: "\\eda9";
}

.icofont-discover-alt:before {
  content: "\\edaa";
}

.icofont-discover:before {
  content: "\\edab";
}

.icofont-eway-alt:before {
  content: "\\edac";
}

.icofont-eway:before {
  content: "\\edad";
}

.icofont-google-wallet-alt-1:before {
  content: "\\edae";
}

.icofont-google-wallet-alt-2:before {
  content: "\\edaf";
}

.icofont-google-wallet-alt-3:before {
  content: "\\edb0";
}

.icofont-google-wallet:before {
  content: "\\edb1";
}

.icofont-jcb-alt:before {
  content: "\\edb2";
}

.icofont-jcb:before {
  content: "\\edb3";
}

.icofont-maestro-alt:before {
  content: "\\edb4";
}

.icofont-maestro:before {
  content: "\\edb5";
}

.icofont-mastercard-alt:before {
  content: "\\edb6";
}

.icofont-mastercard:before {
  content: "\\edb7";
}

.icofont-payoneer-alt:before {
  content: "\\edb8";
}

.icofont-payoneer:before {
  content: "\\edb9";
}

.icofont-paypal-alt:before {
  content: "\\edba";
}

.icofont-paypal:before {
  content: "\\edbb";
}

.icofont-sage-alt:before {
  content: "\\edbc";
}

.icofont-sage:before {
  content: "\\edbd";
}

.icofont-skrill-alt:before {
  content: "\\edbe";
}

.icofont-skrill:before {
  content: "\\edbf";
}

.icofont-stripe-alt:before {
  content: "\\edc0";
}

.icofont-stripe:before {
  content: "\\edc1";
}

.icofont-visa-alt:before {
  content: "\\edc2";
}

.icofont-visa-electron:before {
  content: "\\edc3";
}

.icofont-visa:before {
  content: "\\edc4";
}

.icofont-western-union-alt:before {
  content: "\\edc5";
}

.icofont-western-union:before {
  content: "\\edc6";
}

.icofont-boy:before {
  content: "\\edc7";
}

.icofont-business-man-alt-1:before {
  content: "\\edc8";
}

.icofont-business-man-alt-2:before {
  content: "\\edc9";
}

.icofont-business-man-alt-3:before {
  content: "\\edca";
}

.icofont-business-man:before {
  content: "\\edcb";
}

.icofont-funky-man:before {
  content: "\\edcc";
}

.icofont-girl-alt:before {
  content: "\\edcd";
}

.icofont-girl:before {
  content: "\\edce";
}

.icofont-hotel-boy-alt:before {
  content: "\\edcf";
}

.icofont-hotel-boy:before {
  content: "\\edd0";
}

.icofont-man-in-glasses:before {
  content: "\\edd1";
}

.icofont-user-alt-1:before {
  content: "\\edd2";
}

.icofont-user-alt-2:before {
  content: "\\edd3";
}

.icofont-user-alt-3:before {
  content: "\\edd4";
}

.icofont-user-alt-4:before {
  content: "\\edd5";
}

.icofont-user-alt-5:before {
  content: "\\edd6";
}

.icofont-user-alt-6:before {
  content: "\\edd7";
}

.icofont-user-alt-7:before {
  content: "\\edd8";
}

.icofont-user-female:before {
  content: "\\edd9";
}

.icofont-user-male:before {
  content: "\\edda";
}

.icofont-user-suited:before {
  content: "\\eddb";
}

.icofont-user:before {
  content: "\\eddc";
}

.icofont-users-alt-1:before {
  content: "\\eddd";
}

.icofont-users-alt-2:before {
  content: "\\edde";
}

.icofont-users-alt-3:before {
  content: "\\eddf";
}

.icofont-users-alt-4:before {
  content: "\\ede0";
}

.icofont-users-alt-5:before {
  content: "\\ede1";
}

.icofont-users-alt-6:before {
  content: "\\ede2";
}

.icofont-users-social:before {
  content: "\\ede3";
}

.icofont-users:before {
  content: "\\ede4";
}

.icofont-waiter:before {
  content: "\\ede5";
}

.icofont-woman-in-glasses:before {
  content: "\\ede6";
}

.icofont-document-search:before {
  content: "\\ede7";
}

.icofont-folder-search:before {
  content: "\\ede8";
}

.icofont-home-search:before {
  content: "\\ede9";
}

.icofont-job-search:before {
  content: "\\edea";
}

.icofont-map-search:before {
  content: "\\edeb";
}

.icofont-restaurant-search:before {
  content: "\\edec";
}

.icofont-search-alt-1:before {
  content: "\\eded";
}

.icofont-search-alt-2:before {
  content: "\\edee";
}

.icofont-search:before {
  content: "\\edef";
}

.icofont-stock-search:before {
  content: "\\edf0";
}

.icofont-user-search:before {
  content: "\\edf1";
}

.icofont-social-aim:before {
  content: "\\edf2";
}

.icofont-social-badoo:before {
  content: "\\edf3";
}

.icofont-social-bebo:before {
  content: "\\edf4";
}

.icofont-social-behance:before {
  content: "\\edf5";
}

.icofont-social-blogger:before {
  content: "\\edf6";
}

.icofont-social-bootstrap:before {
  content: "\\edf7";
}

.icofont-social-brightkite:before {
  content: "\\edf8";
}

.icofont-social-cloudapp:before {
  content: "\\edf9";
}

.icofont-social-concrete5:before {
  content: "\\edfa";
}

.icofont-social-designbump:before {
  content: "\\edfb";
}

.icofont-social-designfloat:before {
  content: "\\edfc";
}

.icofont-social-deviantart:before {
  content: "\\edfd";
}

.icofont-social-digg:before {
  content: "\\edfe";
}

.icofont-social-dotcms:before {
  content: "\\edff";
}

.icofont-social-dribble:before {
  content: "\\ee00";
}

.icofont-social-dropbox:before {
  content: "\\ee01";
}

.icofont-brand-drupal:before {
  content: "\\ee02";
}

.icofont-social-ebuddy:before {
  content: "\\ee03";
}

.icofont-social-ello:before {
  content: "\\ee04";
}

.icofont-social-ember:before {
  content: "\\ee05";
}

.icofont-social-envato:before {
  content: "\\ee06";
}

.icofont-social-evernote:before {
  content: "\\ee07";
}

.icofont-social-facebook:before {
  content: "\\ee08";
}

.icofont-social-feedburner:before {
  content: "\\ee09";
}

.icofont-social-folkd:before {
  content: "\\ee0a";
}

.icofont-social-friendfeed:before {
  content: "\\ee0b";
}

.icofont-social-ghost:before {
  content: "\\ee0c";
}

.icofont-social-github:before {
  content: "\\ee0d";
}

.icofont-social-gnome:before {
  content: "\\ee0e";
}

.icofont-social-google-buzz:before {
  content: "\\ee0f";
}

.icofont-social-google-map:before {
  content: "\\ee10";
}

.icofont-social-google-plus:before {
  content: "\\ee11";
}

.icofont-social-google-talk:before {
  content: "\\ee12";
}

.icofont-social-hype-machine:before {
  content: "\\ee13";
}

.icofont-social-instagram:before {
  content: "\\ee14";
}

.icofont-brand-joomla:before {
  content: "\\ee15";
}

.icofont-social-kickstarter:before {
  content: "\\ee16";
}

.icofont-social-line:before {
  content: "\\ee17";
}

.icofont-social-linux-mint:before {
  content: "\\ee18";
}

.icofont-social-livejournal:before {
  content: "\\ee19";
}

.icofont-social-magento:before {
  content: "\\ee1a";
}

.icofont-social-meetup:before {
  content: "\\ee1b";
}

.icofont-social-mixx:before {
  content: "\\ee1c";
}

.icofont-social-newsvine:before {
  content: "\\ee1d";
}

.icofont-social-nimbuss:before {
  content: "\\ee1e";
}

.icofont-social-opencart:before {
  content: "\\ee1f";
}

.icofont-social-oscommerce:before {
  content: "\\ee20";
}

.icofont-social-pandora:before {
  content: "\\ee21";
}

.icofont-social-picasa:before {
  content: "\\ee22";
}

.icofont-social-pinterest:before {
  content: "\\ee23";
}

.icofont-social-prestashop:before {
  content: "\\ee24";
}

.icofont-social-qik:before {
  content: "\\ee25";
}

.icofont-social-readernaut:before {
  content: "\\ee26";
}

.icofont-social-reddit:before {
  content: "\\ee27";
}

.icofont-social-rss:before {
  content: "\\ee28";
}

.icofont-social-shopify:before {
  content: "\\ee29";
}

.icofont-social-silverstripe:before {
  content: "\\ee2a";
}

.icofont-social-skype:before {
  content: "\\ee2b";
}

.icofont-social-slashdot:before {
  content: "\\ee2c";
}

.icofont-social-smugmug:before {
  content: "\\ee2d";
}

.icofont-social-steam:before {
  content: "\\ee2e";
}

.icofont-social-stumbleupon:before {
  content: "\\ee2f";
}

.icofont-social-technorati:before {
  content: "\\ee30";
}

.icofont-social-telegram:before {
  content: "\\ee31";
}

.icofont-social-tinder:before {
  content: "\\ee32";
}

.icofont-social-tumblr:before {
  content: "\\ee33";
}

.icofont-social-twitter:before {
  content: "\\ee34";
}

.icofont-social-typo3:before {
  content: "\\ee35";
}

.icofont-social-ubercart:before {
  content: "\\ee36";
}

.icofont-social-viber:before {
  content: "\\ee37";
}

.icofont-social-viddler:before {
  content: "\\ee38";
}

.icofont-social-vimeo:before {
  content: "\\ee39";
}

.icofont-social-vine:before {
  content: "\\ee3a";
}

.icofont-social-virb:before {
  content: "\\ee3b";
}

.icofont-social-virtuemart:before {
  content: "\\ee3c";
}

.icofont-social-wechat:before {
  content: "\\ee3d";
}

.icofont-brand-wordpress:before {
  content: "\\ee3e";
}

.icofont-social-xing:before {
  content: "\\ee3f";
}

.icofont-social-yahoo:before {
  content: "\\ee40";
}

.icofont-social-yelp:before {
  content: "\\ee41";
}

.icofont-social-zencart:before {
  content: "\\ee42";
}

.icofont-badminton-birdie:before {
  content: "\\ee43";
}

.icofont-baseball:before {
  content: "\\ee44";
}

.icofont-baseballer:before {
  content: "\\ee45";
}

.icofont-basketball-hoop:before {
  content: "\\ee46";
}

.icofont-basketball:before {
  content: "\\ee47";
}

.icofont-billiard-ball:before {
  content: "\\ee48";
}

.icofont-boot-alt-1:before {
  content: "\\ee49";
}

.icofont-boot-alt-2:before {
  content: "\\ee4a";
}

.icofont-bowling-alt:before {
  content: "\\ee4b";
}

.icofont-bowling:before {
  content: "\\ee4c";
}

.icofont-canoe:before {
  content: "\\ee4d";
}

.icofont-cheer-leader:before {
  content: "\\ee4e";
}

.icofont-climbing:before {
  content: "\\ee4f";
}

.icofont-corner:before {
  content: "\\ee50";
}

.icofont-cyclist:before {
  content: "\\ee51";
}

.icofont-dumbbell-alt:before {
  content: "\\ee52";
}

.icofont-dumbbell:before {
  content: "\\ee53";
}

.icofont-field-alt:before {
  content: "\\ee54";
}

.icofont-field:before {
  content: "\\ee55";
}

.icofont-football-alt:before {
  content: "\\ee56";
}

.icofont-foul:before {
  content: "\\ee57";
}

.icofont-goal-keeper:before {
  content: "\\ee58";
}

.icofont-goal:before {
  content: "\\ee59";
}

.icofont-golf-alt:before {
  content: "\\ee5a";
}

.icofont-golf-bag:before {
  content: "\\ee5b";
}

.icofont-golf-field:before {
  content: "\\ee5c";
}

.icofont-golf:before {
  content: "\\ee5d";
}

.icofont-golfer:before {
  content: "\\ee5e";
}

.icofont-gym-alt-1:before {
  content: "\\ee5f";
}

.icofont-gym-alt-2:before {
  content: "\\ee60";
}

.icofont-gym-alt-3:before {
  content: "\\ee61";
}

.icofont-gym:before {
  content: "\\ee62";
}

.icofont-hand-grippers:before {
  content: "\\ee63";
}

.icofont-heart-beat-alt:before {
  content: "\\ee64";
}

.icofont-helmet:before {
  content: "\\ee65";
}

.icofont-hockey-alt:before {
  content: "\\ee66";
}

.icofont-hockey:before {
  content: "\\ee67";
}

.icofont-ice-skate:before {
  content: "\\ee68";
}

.icofont-jersey-alt:before {
  content: "\\ee69";
}

.icofont-jersey:before {
  content: "\\ee6a";
}

.icofont-jumping:before {
  content: "\\ee6b";
}

.icofont-kick:before {
  content: "\\ee6c";
}

.icofont-leg:before {
  content: "\\ee6d";
}

.icofont-match-review:before {
  content: "\\ee6e";
}

.icofont-medal-alt:before {
  content: "\\ee6f";
}

.icofont-muscle-alt:before {
  content: "\\ee70";
}

.icofont-muscle:before {
  content: "\\ee71";
}

.icofont-offside:before {
  content: "\\ee72";
}

.icofont-olympic-logo:before {
  content: "\\ee73";
}

.icofont-olympic:before {
  content: "\\ee74";
}

.icofont-padding:before {
  content: "\\ee75";
}

.icofont-penalty-card:before {
  content: "\\ee76";
}

.icofont-racer:before {
  content: "\\ee77";
}

.icofont-racing-car:before {
  content: "\\ee78";
}

.icofont-racing-flag-alt:before {
  content: "\\ee79";
}

.icofont-racing-flag:before {
  content: "\\ee7a";
}

.icofont-racings-wheel:before {
  content: "\\ee7b";
}

.icofont-referee:before {
  content: "\\ee7c";
}

.icofont-refree-jersey:before {
  content: "\\ee7d";
}

.icofont-result:before {
  content: "\\ee7e";
}

.icofont-rugby-ball:before {
  content: "\\ee7f";
}

.icofont-rugby-player:before {
  content: "\\ee80";
}

.icofont-rugby:before {
  content: "\\ee81";
}

.icofont-runner-alt-1:before {
  content: "\\ee82";
}

.icofont-runner-alt-2:before {
  content: "\\ee83";
}

.icofont-runner:before {
  content: "\\ee84";
}

.icofont-score-board:before {
  content: "\\ee85";
}

.icofont-skiing-man:before {
  content: "\\ee86";
}

.icofont-skydiving-goggles:before {
  content: "\\ee87";
}

.icofont-snow-mobile:before {
  content: "\\ee88";
}

.icofont-steering:before {
  content: "\\ee89";
}

.icofont-substitute:before {
  content: "\\ee8a";
}

.icofont-swimmer:before {
  content: "\\ee8b";
}

.icofont-table-tennis:before {
  content: "\\ee8c";
}

.icofont-team-alt:before {
  content: "\\ee8d";
}

.icofont-team:before {
  content: "\\ee8e";
}

.icofont-tennis-player:before {
  content: "\\ee8f";
}

.icofont-tennis:before {
  content: "\\ee90";
}

.icofont-time:before {
  content: "\\ee91";
}

.icofont-track:before {
  content: "\\ee92";
}

.icofont-tracking:before {
  content: "\\ee93";
}

.icofont-trophy-alt:before {
  content: "\\ee94";
}

.icofont-trophy:before {
  content: "\\ee95";
}

.icofont-volleyball-alt:before {
  content: "\\ee96";
}

.icofont-volleyball-fire:before {
  content: "\\ee97";
}

.icofont-volleyball:before {
  content: "\\ee98";
}

.icofont-water-bottle:before {
  content: "\\ee99";
}

.icofont-whisle:before {
  content: "\\ee9a";
}

.icofont-win-trophy:before {
  content: "\\ee9b";
}

.icofont-align-center:before {
  content: "\\ee9c";
}

.icofont-align-left:before {
  content: "\\ee9d";
}

.icofont-align-right:before {
  content: "\\ee9e";
}

.icofont-all-caps:before {
  content: "\\ee9f";
}

.icofont-bold:before {
  content: "\\eea0";
}

.icofont-brush:before {
  content: "\\eea1";
}

.icofont-clip-board:before {
  content: "\\eea2";
}

.icofont-code-alt:before {
  content: "\\eea3";
}

.icofont-color-bucket:before {
  content: "\\eea4";
}

.icofont-color-picker:before {
  content: "\\eea5";
}

.icofont-copy-alt:before {
  content: "\\eea6";
}

.icofont-copy-black:before {
  content: "\\eea7";
}

.icofont-cut:before {
  content: "\\eea8";
}

.icofont-delete-alt:before {
  content: "\\eea9";
}

.icofont-edit-alt:before {
  content: "\\eeaa";
}

.icofont-eraser-alt:before {
  content: "\\eeab";
}

.icofont-file-alt:before {
  content: "\\eeac";
}

.icofont-font:before {
  content: "\\eead";
}

.icofont-header:before {
  content: "\\eeae";
}

.icofont-indent:before {
  content: "\\eeaf";
}

.icofont-italic-alt:before {
  content: "\\eeb0";
}

.icofont-justify-all:before {
  content: "\\eeb1";
}

.icofont-justify-center:before {
  content: "\\eeb2";
}

.icofont-justify-left:before {
  content: "\\eeb3";
}

.icofont-justify-right:before {
  content: "\\eeb4";
}

.icofont-line-height:before {
  content: "\\eeb5";
}

.icofont-link-alt:before {
  content: "\\eeb6";
}

.icofont-listine-dots:before {
  content: "\\eeb7";
}

.icofont-listing-box:before {
  content: "\\eeb8";
}

.icofont-listing-number:before {
  content: "\\eeb9";
}

.icofont-marker:before {
  content: "\\eeba";
}

.icofont-outdent:before {
  content: "\\eebb";
}

.icofont-paper-clip:before {
  content: "\\eebc";
}

.icofont-paragraph:before {
  content: "\\eebd";
}

.icofont-pin:before {
  content: "\\eebe";
}

.icofont-printer:before {
  content: "\\eebf";
}

.icofont-redo:before {
  content: "\\eec0";
}

.icofont-rotation:before {
  content: "\\eec1";
}

.icofont-save:before {
  content: "\\eec2";
}

.icofont-small-cap:before {
  content: "\\eec3";
}

.icofont-strike-through:before {
  content: "\\eec4";
}

.icofont-sub-listing:before {
  content: "\\eec5";
}

.icofont-subscript:before {
  content: "\\eec6";
}

.icofont-superscript:before {
  content: "\\eec7";
}

.icofont-table:before {
  content: "\\eec8";
}

.icofont-text-height:before {
  content: "\\eec9";
}

.icofont-text-width:before {
  content: "\\eeca";
}

.icofont-trash:before {
  content: "\\eecb";
}

.icofont-underline:before {
  content: "\\eecc";
}

.icofont-undo:before {
  content: "\\eecd";
}

.icofont-unlink:before {
  content: "\\eece";
}

.icofont-air-balloon:before {
  content: "\\eecf";
}

.icofont-airplane-alt:before {
  content: "\\eed0";
}

.icofont-airplane:before {
  content: "\\eed1";
}

.icofont-ambulance-crescent:before {
  content: "\\eed2";
}

.icofont-ambulance-cross:before {
  content: "\\eed3";
}

.icofont-articulated-truck:before {
  content: "\\eed4";
}

.icofont-auto-rickshaw:before {
  content: "\\eed5";
}

.icofont-bicycle-alt-1:before {
  content: "\\eed6";
}

.icofont-bicycle-alt-2:before {
  content: "\\eed7";
}

.icofont-bull-dozer:before {
  content: "\\eed8";
}

.icofont-bus-alt-1:before {
  content: "\\eed9";
}

.icofont-bus-alt-2:before {
  content: "\\eeda";
}

.icofont-bus-alt-3:before {
  content: "\\eedb";
}

.icofont-cable-car:before {
  content: "\\eedc";
}

.icofont-car-alt-1:before {
  content: "\\eedd";
}

.icofont-car-alt-2:before {
  content: "\\eede";
}

.icofont-car-alt-3:before {
  content: "\\eedf";
}

.icofont-car-alt-4:before {
  content: "\\eee0";
}

.icofont-concrete-mixer:before {
  content: "\\eee1";
}

.icofont-delivery-time:before {
  content: "\\eee2";
}

.icofont-excavator:before {
  content: "\\eee3";
}

.icofont-fast-delivery:before {
  content: "\\eee4";
}

.icofont-fire-truck-alt:before {
  content: "\\eee5";
}

.icofont-fire-truck:before {
  content: "\\eee6";
}

.icofont-fork-lift:before {
  content: "\\eee7";
}

.icofont-free-delivery:before {
  content: "\\eee8";
}

.icofont-golf-cart:before {
  content: "\\eee9";
}

.icofont-helicopter:before {
  content: "\\eeea";
}

.icofont-motor-bike-alt:before {
  content: "\\eeeb";
}

.icofont-motor-bike:before {
  content: "\\eeec";
}

.icofont-motor-biker:before {
  content: "\\eeed";
}

.icofont-oil-truck:before {
  content: "\\eeee";
}

.icofont-police-car:before {
  content: "\\eeef";
}

.icofont-rickshaw:before {
  content: "\\eef0";
}

.icofont-rocket-alt-1:before {
  content: "\\eef1";
}

.icofont-rocket-alt-2:before {
  content: "\\eef2";
}

.icofont-sail-boat:before {
  content: "\\eef3";
}

.icofont-scooter:before {
  content: "\\eef4";
}

.icofont-sea-plane:before {
  content: "\\eef5";
}

.icofont-ship-alt:before {
  content: "\\eef6";
}

.icofont-speed-boat:before {
  content: "\\eef7";
}

.icofont-taxi:before {
  content: "\\eef8";
}

.icofont-tow-truck:before {
  content: "\\eef9";
}

.icofont-tractor:before {
  content: "\\eefa";
}

.icofont-traffic-light:before {
  content: "\\eefb";
}

.icofont-train-line:before {
  content: "\\eefc";
}

.icofont-train-steam:before {
  content: "\\eefd";
}

.icofont-tram:before {
  content: "\\eefe";
}

.icofont-truck-alt:before {
  content: "\\eeff";
}

.icofont-truck-loaded:before {
  content: "\\ef00";
}

.icofont-truck:before {
  content: "\\ef01";
}

.icofont-van-alt:before {
  content: "\\ef02";
}

.icofont-van:before {
  content: "\\ef03";
}

.icofont-yacht:before {
  content: "\\ef04";
}

.icofont-5-star-hotel:before {
  content: "\\ef05";
}

.icofont-anchor-alt:before {
  content: "\\ef06";
}

.icofont-beach-bed:before {
  content: "\\ef07";
}

.icofont-camping-vest:before {
  content: "\\ef08";
}

.icofont-coconut-alt:before {
  content: "\\ef09";
}

.icofont-direction-sign:before {
  content: "\\ef0a";
}

.icofont-hill-side:before {
  content: "\\ef0b";
}

.icofont-island-alt:before {
  content: "\\ef0c";
}

.icofont-long-drive:before {
  content: "\\ef0d";
}

.icofont-map-pins:before {
  content: "\\ef0e";
}

.icofont-plane-ticket:before {
  content: "\\ef0f";
}

.icofont-sail-boat-alt-1:before {
  content: "\\ef10";
}

.icofont-sail-boat-alt-2:before {
  content: "\\ef11";
}

.icofont-sandals-female:before {
  content: "\\ef12";
}

.icofont-sandals-male:before {
  content: "\\ef13";
}

.icofont-travelling:before {
  content: "\\ef14";
}

.icofont-breakdown:before {
  content: "\\ef15";
}

.icofont-celsius:before {
  content: "\\ef16";
}

.icofont-clouds:before {
  content: "\\ef17";
}

.icofont-cloudy:before {
  content: "\\ef18";
}

.icofont-compass-alt:before {
  content: "\\ef19";
}

.icofont-dust:before {
  content: "\\ef1a";
}

.icofont-eclipse:before {
  content: "\\ef1b";
}

.icofont-fahrenheit:before {
  content: "\\ef1c";
}

.icofont-forest-fire:before {
  content: "\\ef1d";
}

.icofont-full-night:before {
  content: "\\ef1e";
}

.icofont-full-sunny:before {
  content: "\\ef1f";
}

.icofont-hail-night:before {
  content: "\\ef20";
}

.icofont-hail-rainy-night:before {
  content: "\\ef21";
}

.icofont-hail-rainy-sunny:before {
  content: "\\ef22";
}

.icofont-hail-rainy:before {
  content: "\\ef23";
}

.icofont-hail-sunny:before {
  content: "\\ef24";
}

.icofont-hail-thunder-night:before {
  content: "\\ef25";
}

.icofont-hail-thunder-sunny:before {
  content: "\\ef26";
}

.icofont-hail-thunder:before {
  content: "\\ef27";
}

.icofont-hail:before {
  content: "\\ef28";
}

.icofont-hill-night:before {
  content: "\\ef29";
}

.icofont-hill-sunny:before {
  content: "\\ef2a";
}

.icofont-hill:before {
  content: "\\ef2b";
}

.icofont-hurricane:before {
  content: "\\ef2c";
}

.icofont-island:before {
  content: "\\ef2d";
}

.icofont-meteor:before {
  content: "\\ef2e";
}

.icofont-night:before {
  content: "\\ef2f";
}

.icofont-rainy-night:before {
  content: "\\ef30";
}

.icofont-rainy-sunny:before {
  content: "\\ef31";
}

.icofont-rainy-thunder:before {
  content: "\\ef32";
}

.icofont-rainy:before {
  content: "\\ef33";
}

.icofont-showy-night-hail:before {
  content: "\\ef34";
}

.icofont-snow-temp:before {
  content: "\\ef35";
}

.icofont-snow:before {
  content: "\\ef36";
}

.icofont-snowy-hail:before {
  content: "\\ef37";
}

.icofont-snowy-night-rainy:before {
  content: "\\ef38";
}

.icofont-snowy-night:before {
  content: "\\ef39";
}

.icofont-snowy-rainy:before {
  content: "\\ef3a";
}

.icofont-snowy-sunny-hail:before {
  content: "\\ef3b";
}

.icofont-snowy-sunny-rainy:before {
  content: "\\ef3c";
}

.icofont-snowy-sunny:before {
  content: "\\ef3d";
}

.icofont-snowy-thunder-night:before {
  content: "\\ef3e";
}

.icofont-snowy-thunder-sunny:before {
  content: "\\ef3f";
}

.icofont-snowy-thunder:before {
  content: "\\ef40";
}

.icofont-snowy-windy-night:before {
  content: "\\ef41";
}

.icofont-snowy-windy-sunny:before {
  content: "\\ef42";
}

.icofont-snowy-windy:before {
  content: "\\ef43";
}

.icofont-snowy:before {
  content: "\\ef44";
}

.icofont-sun-alt:before {
  content: "\\ef45";
}

.icofont-sun-rise:before {
  content: "\\ef46";
}

.icofont-sun-set:before {
  content: "\\ef47";
}

.icofont-sunny-day-temp:before {
  content: "\\ef48";
}

.icofont-sunny:before {
  content: "\\ef49";
}

.icofont-thermometer:before {
  content: "\\ef4a";
}

.icofont-thinder-light:before {
  content: "\\ef4b";
}

.icofont-tornado:before {
  content: "\\ef4c";
}

.icofont-umbrella-alt:before {
  content: "\\ef4d";
}

.icofont-volcano:before {
  content: "\\ef4e";
}

.icofont-wave:before {
  content: "\\ef4f";
}

.icofont-wind-scale-0:before {
  content: "\\ef50";
}

.icofont-wind-scale-1:before {
  content: "\\ef51";
}

.icofont-wind-scale-2:before {
  content: "\\ef52";
}

.icofont-wind-scale-3:before {
  content: "\\ef53";
}

.icofont-wind-scale-4:before {
  content: "\\ef54";
}

.icofont-wind-scale-5:before {
  content: "\\ef55";
}

.icofont-wind-scale-6:before {
  content: "\\ef56";
}

.icofont-wind-scale-7:before {
  content: "\\ef57";
}

.icofont-wind-scale-8:before {
  content: "\\ef58";
}

.icofont-wind-scale-9:before {
  content: "\\ef59";
}

.icofont-wind-scale-10:before {
  content: "\\ef5a";
}

.icofont-wind-scale-11:before {
  content: "\\ef5b";
}

.icofont-wind-scale-12:before {
  content: "\\ef5c";
}

.icofont-wind-waves:before {
  content: "\\ef5d";
}

.icofont-wind:before {
  content: "\\ef5e";
}

.icofont-windy-hail:before {
  content: "\\ef5f";
}

.icofont-windy-night:before {
  content: "\\ef60";
}

.icofont-windy-raining:before {
  content: "\\ef61";
}

.icofont-windy-sunny:before {
  content: "\\ef62";
}

.icofont-windy-thunder-raining:before {
  content: "\\ef63";
}

.icofont-windy-thunder:before {
  content: "\\ef64";
}

.icofont-windy:before {
  content: "\\ef65";
}

.icofont-addons:before {
  content: "\\ef66";
}

.icofont-address-book:before {
  content: "\\ef67";
}

.icofont-adjust:before {
  content: "\\ef68";
}

.icofont-alarm:before {
  content: "\\ef69";
}

.icofont-anchor:before {
  content: "\\ef6a";
}

.icofont-archive:before {
  content: "\\ef6b";
}

.icofont-at:before {
  content: "\\ef6c";
}

.icofont-attachment:before {
  content: "\\ef6d";
}

.icofont-audio:before {
  content: "\\ef6e";
}

.icofont-auto-mobile:before {
  content: "\\ef6f";
}

.icofont-automation:before {
  content: "\\ef70";
}

.icofont-baby:before {
  content: "\\ef71";
}

.icofont-badge:before {
  content: "\\ef72";
}

.icofont-bag:before {
  content: "\\ef73";
}

.icofont-ban:before {
  content: "\\ef74";
}

.icofont-bank:before {
  content: "\\ef75";
}

.icofont-bar-code:before {
  content: "\\ef76";
}

.icofont-bars:before {
  content: "\\ef77";
}

.icofont-battery-empty:before {
  content: "\\ef78";
}

.icofont-battery-full:before {
  content: "\\ef79";
}

.icofont-battery-half:before {
  content: "\\ef7a";
}

.icofont-battery-low:before {
  content: "\\ef7b";
}

.icofont-beach:before {
  content: "\\ef7c";
}

.icofont-beaker:before {
  content: "\\ef7d";
}

.icofont-bear:before {
  content: "\\ef7e";
}

.icofont-beard:before {
  content: "\\ef7f";
}

.icofont-bed:before {
  content: "\\ef80";
}

.icofont-bell:before {
  content: "\\ef81";
}

.icofont-beverage:before {
  content: "\\ef82";
}

.icofont-bicycle:before {
  content: "\\ef83";
}

.icofont-bill:before {
  content: "\\ef84";
}

.icofont-bin:before {
  content: "\\ef85";
}

.icofont-binary:before {
  content: "\\ef86";
}

.icofont-binoculars:before {
  content: "\\ef87";
}

.icofont-bird:before {
  content: "\\ef88";
}

.icofont-birds:before {
  content: "\\ef89";
}

.icofont-black-board:before {
  content: "\\ef8a";
}

.icofont-bluetooth:before {
  content: "\\ef8b";
}

.icofont-bolt:before {
  content: "\\ef8c";
}

.icofont-bomb:before {
  content: "\\ef8d";
}

.icofont-book-mark:before {
  content: "\\ef8e";
}

.icofont-book:before {
  content: "\\ef8f";
}

.icofont-boot:before {
  content: "\\ef90";
}

.icofont-box:before {
  content: "\\ef91";
}

.icofont-brain:before {
  content: "\\ef92";
}

.icofont-briefcase:before {
  content: "\\ef93";
}

.icofont-broken:before {
  content: "\\ef94";
}

.icofont-bucket:before {
  content: "\\ef95";
}

.icofont-bucket1:before {
  content: "\\ef96";
}

.icofont-bucket2:before {
  content: "\\ef97";
}

.icofont-bug:before {
  content: "\\ef98";
}

.icofont-building:before {
  content: "\\ef99";
}

.icofont-bullet:before {
  content: "\\ef9a";
}

.icofont-bullhorn:before {
  content: "\\ef9b";
}

.icofont-bullseye:before {
  content: "\\ef9c";
}

.icofont-bus:before {
  content: "\\ef9d";
}

.icofont-butterfly:before {
  content: "\\ef9e";
}

.icofont-cab:before {
  content: "\\ef9f";
}

.icofont-calculator:before {
  content: "\\efa0";
}

.icofont-calendar:before {
  content: "\\efa1";
}

.icofont-camera-alt:before {
  content: "\\efa2";
}

.icofont-camera:before {
  content: "\\efa3";
}

.icofont-car:before {
  content: "\\efa4";
}

.icofont-card:before {
  content: "\\efa5";
}

.icofont-cart:before {
  content: "\\efa6";
}

.icofont-cc:before {
  content: "\\efa7";
}

.icofont-certificate:before {
  content: "\\efa8";
}

.icofont-charging:before {
  content: "\\efa9";
}

.icofont-chat:before {
  content: "\\efaa";
}

.icofont-check-alt:before {
  content: "\\efab";
}

.icofont-check-circled:before {
  content: "\\efac";
}

.icofont-check:before {
  content: "\\efad";
}

.icofont-checked:before {
  content: "\\efae";
}

.icofont-children-care:before {
  content: "\\efaf";
}

.icofont-clock-time:before {
  content: "\\efb0";
}

.icofont-close-circled:before {
  content: "\\efb1";
}

.icofont-close-line-circled:before {
  content: "\\efb2";
}

.icofont-close-line-squared-alt:before {
  content: "\\efb3";
}

.icofont-close-line-squared:before {
  content: "\\efb4";
}

.icofont-close-line:before {
  content: "\\efb5";
}

.icofont-close-squared-alt:before {
  content: "\\efb6";
}

.icofont-close-squared:before {
  content: "\\efb7";
}

.icofont-close:before {
  content: "\\efb8";
}

.icofont-cloud-download:before {
  content: "\\efb9";
}

.icofont-cloud-refresh:before {
  content: "\\efba";
}

.icofont-cloud-upload:before {
  content: "\\efbb";
}

.icofont-cloud:before {
  content: "\\efbc";
}

.icofont-code-not-allowed:before {
  content: "\\efbd";
}

.icofont-code:before {
  content: "\\efbe";
}

.icofont-coffee-cup:before {
  content: "\\efbf";
}

.icofont-comment:before {
  content: "\\efc0";
}

.icofont-compass:before {
  content: "\\efc1";
}

.icofont-computer:before {
  content: "\\efc2";
}

.icofont-connection:before {
  content: "\\efc3";
}

.icofont-console:before {
  content: "\\efc4";
}

.icofont-contacts:before {
  content: "\\efc5";
}

.icofont-contrast:before {
  content: "\\efc6";
}

.icofont-copy:before {
  content: "\\efc7";
}

.icofont-copyright:before {
  content: "\\efc8";
}

.icofont-credit-card:before {
  content: "\\efc9";
}

.icofont-crop:before {
  content: "\\efca";
}

.icofont-crown:before {
  content: "\\efcb";
}

.icofont-cube:before {
  content: "\\efcc";
}

.icofont-cubes:before {
  content: "\\efcd";
}

.icofont-culinary:before {
  content: "\\efce";
}

.icofont-dashboard-web:before {
  content: "\\efcf";
}

.icofont-dashboard:before {
  content: "\\efd0";
}

.icofont-data:before {
  content: "\\efd1";
}

.icofont-database-add:before {
  content: "\\efd2";
}

.icofont-database-locked:before {
  content: "\\efd3";
}

.icofont-database-remove:before {
  content: "\\efd4";
}

.icofont-database:before {
  content: "\\efd5";
}

.icofont-delete:before {
  content: "\\efd6";
}

.icofont-diamond:before {
  content: "\\efd7";
}

.icofont-dice:before {
  content: "\\efd8";
}

.icofont-disabled:before {
  content: "\\efd9";
}

.icofont-disc:before {
  content: "\\efda";
}

.icofont-diskette:before {
  content: "\\efdb";
}

.icofont-document-folder:before {
  content: "\\efdc";
}

.icofont-download-alt:before {
  content: "\\efdd";
}

.icofont-download:before {
  content: "\\efde";
}

.icofont-downloaded:before {
  content: "\\efdf";
}

.icofont-earth:before {
  content: "\\efe0";
}

.icofont-ebook:before {
  content: "\\efe1";
}

.icofont-edit:before {
  content: "\\efe2";
}

.icofont-eject:before {
  content: "\\efe3";
}

.icofont-email:before {
  content: "\\efe4";
}

.icofont-envelope-open:before {
  content: "\\efe5";
}

.icofont-envelope:before {
  content: "\\efe6";
}

.icofont-eraser:before {
  content: "\\efe7";
}

.icofont-error:before {
  content: "\\efe8";
}

.icofont-exchange:before {
  content: "\\efe9";
}

.icofont-exclamation-circle:before {
  content: "\\efea";
}

.icofont-exclamation-square:before {
  content: "\\efeb";
}

.icofont-exclamation-tringle:before {
  content: "\\efec";
}

.icofont-exclamation:before {
  content: "\\efed";
}

.icofont-exit:before {
  content: "\\efee";
}

.icofont-expand:before {
  content: "\\efef";
}

.icofont-external-link:before {
  content: "\\eff0";
}

.icofont-external:before {
  content: "\\eff1";
}

.icofont-eye-blocked:before {
  content: "\\eff2";
}

.icofont-eye-dropper:before {
  content: "\\eff3";
}

.icofont-eye:before {
  content: "\\eff4";
}

.icofont-favourite:before {
  content: "\\eff5";
}

.icofont-fax:before {
  content: "\\eff6";
}

.icofont-female:before {
  content: "\\eff7";
}

.icofont-file:before {
  content: "\\eff8";
}

.icofont-film:before {
  content: "\\eff9";
}

.icofont-filter:before {
  content: "\\effa";
}

.icofont-fire-burn:before {
  content: "\\effb";
}

.icofont-fire-extinguisher:before {
  content: "\\effc";
}

.icofont-fire:before {
  content: "\\effd";
}

.icofont-first-aid:before {
  content: "\\effe";
}

.icofont-flag-alt-1:before {
  content: "\\efff";
}

.icofont-flag-alt-2:before {
  content: "\\f000";
}

.icofont-flag:before {
  content: "\\f001";
}

.icofont-flash-light:before {
  content: "\\f002";
}

.icofont-flash:before {
  content: "\\f003";
}

.icofont-flask:before {
  content: "\\f004";
}

.icofont-focus:before {
  content: "\\f005";
}

.icofont-folder-open:before {
  content: "\\f006";
}

.icofont-folder:before {
  content: "\\f007";
}

.icofont-foot-print:before {
  content: "\\f008";
}

.icofont-football-american:before {
  content: "\\f009";
}

.icofont-football:before {
  content: "\\f00a";
}

.icofont-game-console:before {
  content: "\\f00b";
}

.icofont-game-pad:before {
  content: "\\f00c";
}

.icofont-gavel:before {
  content: "\\f00d";
}

.icofont-gear:before {
  content: "\\f00e";
}

.icofont-gears:before {
  content: "\\f00f";
}

.icofont-gift:before {
  content: "\\f010";
}

.icofont-glass:before {
  content: "\\f011";
}

.icofont-globe:before {
  content: "\\f012";
}

.icofont-graduate:before {
  content: "\\f013";
}

.icofont-graffiti:before {
  content: "\\f014";
}

.icofont-grocery:before {
  content: "\\f015";
}

.icofont-group:before {
  content: "\\f016";
}

.icofont-hammer:before {
  content: "\\f017";
}

.icofont-hand:before {
  content: "\\f018";
}

.icofont-hanger:before {
  content: "\\f019";
}

.icofont-hard-disk:before {
  content: "\\f01a";
}

.icofont-headphone:before {
  content: "\\f01b";
}

.icofont-heart-beat:before {
  content: "\\f01c";
}

.icofont-heart:before {
  content: "\\f01d";
}

.icofont-history:before {
  content: "\\f01e";
}

.icofont-home:before {
  content: "\\f01f";
}

.icofont-horn:before {
  content: "\\f020";
}

.icofont-hotel:before {
  content: "\\f021";
}

.icofont-hour-glass:before {
  content: "\\f022";
}

.icofont-id:before {
  content: "\\f023";
}

.icofont-image:before {
  content: "\\f024";
}

.icofont-inbox:before {
  content: "\\f025";
}

.icofont-infinite:before {
  content: "\\f026";
}

.icofont-info-circle:before {
  content: "\\f027";
}

.icofont-info-square:before {
  content: "\\f028";
}

.icofont-info:before {
  content: "\\f029";
}

.icofont-institution:before {
  content: "\\f02a";
}

.icofont-interface:before {
  content: "\\f02b";
}

.icofont-invisible:before {
  content: "\\f02c";
}

.icofont-italic:before {
  content: "\\f02d";
}

.icofont-jacket:before {
  content: "\\f02e";
}

.icofont-jar:before {
  content: "\\f02f";
}

.icofont-jewlery:before {
  content: "\\f030";
}

.icofont-karate:before {
  content: "\\f031";
}

.icofont-key-hole:before {
  content: "\\f032";
}

.icofont-key:before {
  content: "\\f033";
}

.icofont-keyboard:before {
  content: "\\f034";
}

.icofont-kid:before {
  content: "\\f035";
}

.icofont-label:before {
  content: "\\f036";
}

.icofont-lamp:before {
  content: "\\f037";
}

.icofont-laptop:before {
  content: "\\f038";
}

.icofont-layers:before {
  content: "\\f039";
}

.icofont-layout:before {
  content: "\\f03a";
}

.icofont-leaf:before {
  content: "\\f03b";
}

.icofont-leaflet:before {
  content: "\\f03c";
}

.icofont-learn:before {
  content: "\\f03d";
}

.icofont-legal:before {
  content: "\\f03e";
}

.icofont-lego:before {
  content: "\\f03f";
}

.icofont-lemon:before {
  content: "\\f040";
}

.icofont-lens:before {
  content: "\\f041";
}

.icofont-letter:before {
  content: "\\f042";
}

.icofont-letterbox:before {
  content: "\\f043";
}

.icofont-library:before {
  content: "\\f044";
}

.icofont-license:before {
  content: "\\f045";
}

.icofont-life-bouy:before {
  content: "\\f046";
}

.icofont-life-buoy:before {
  content: "\\f047";
}

.icofont-life-jacket:before {
  content: "\\f048";
}

.icofont-life-ring:before {
  content: "\\f049";
}

.icofont-light-bulb:before {
  content: "\\f04a";
}

.icofont-lighter:before {
  content: "\\f04b";
}

.icofont-lightning-ray:before {
  content: "\\f04c";
}

.icofont-like:before {
  content: "\\f04d";
}

.icofont-link:before {
  content: "\\f04e";
}

.icofont-live-support:before {
  content: "\\f04f";
}

.icofont-location-arrow:before {
  content: "\\f050";
}

.icofont-location-pin:before {
  content: "\\f051";
}

.icofont-lock:before {
  content: "\\f052";
}

.icofont-login:before {
  content: "\\f053";
}

.icofont-logout:before {
  content: "\\f054";
}

.icofont-lollipop:before {
  content: "\\f055";
}

.icofont-look:before {
  content: "\\f056";
}

.icofont-loop:before {
  content: "\\f057";
}

.icofont-luggage:before {
  content: "\\f058";
}

.icofont-lunch:before {
  content: "\\f059";
}

.icofont-lungs:before {
  content: "\\f05a";
}

.icofont-magic-alt:before {
  content: "\\f05b";
}

.icofont-magic:before {
  content: "\\f05c";
}

.icofont-magnet:before {
  content: "\\f05d";
}

.icofont-mail-box:before {
  content: "\\f05e";
}

.icofont-mail:before {
  content: "\\f05f";
}

.icofont-male:before {
  content: "\\f060";
}

.icofont-map:before {
  content: "\\f061";
}

.icofont-math:before {
  content: "\\f062";
}

.icofont-maximize:before {
  content: "\\f063";
}

.icofont-measure:before {
  content: "\\f064";
}

.icofont-medal:before {
  content: "\\f065";
}

.icofont-medical:before {
  content: "\\f066";
}

.icofont-medicine:before {
  content: "\\f067";
}

.icofont-mega-phone:before {
  content: "\\f068";
}

.icofont-memorial:before {
  content: "\\f069";
}

.icofont-memory-card:before {
  content: "\\f06a";
}

.icofont-mic-mute:before {
  content: "\\f06b";
}

.icofont-mic:before {
  content: "\\f06c";
}

.icofont-micro-chip:before {
  content: "\\f06d";
}

.icofont-microphone:before {
  content: "\\f06e";
}

.icofont-microscope:before {
  content: "\\f06f";
}

.icofont-military:before {
  content: "\\f070";
}

.icofont-mill:before {
  content: "\\f071";
}

.icofont-minus-circle:before {
  content: "\\f072";
}

.icofont-minus-square:before {
  content: "\\f073";
}

.icofont-minus:before {
  content: "\\f074";
}

.icofont-mobile-phone:before {
  content: "\\f075";
}

.icofont-molecule:before {
  content: "\\f076";
}

.icofont-money:before {
  content: "\\f077";
}

.icofont-moon:before {
  content: "\\f078";
}

.icofont-mop:before {
  content: "\\f079";
}

.icofont-muffin:before {
  content: "\\f07a";
}

.icofont-music-alt:before {
  content: "\\f07b";
}

.icofont-music-notes:before {
  content: "\\f07c";
}

.icofont-music:before {
  content: "\\f07d";
}

.icofont-mustache:before {
  content: "\\f07e";
}

.icofont-mute-volume:before {
  content: "\\f07f";
}

.icofont-navigation-menu:before {
  content: "\\f080";
}

.icofont-navigation:before {
  content: "\\f081";
}

.icofont-network-tower:before {
  content: "\\f082";
}

.icofont-network:before {
  content: "\\f083";
}

.icofont-news:before {
  content: "\\f084";
}

.icofont-newspaper:before {
  content: "\\f085";
}

.icofont-no-smoking:before {
  content: "\\f086";
}

.icofont-not-allowed:before {
  content: "\\f087";
}

.icofont-notebook:before {
  content: "\\f088";
}

.icofont-notepad:before {
  content: "\\f089";
}

.icofont-notification:before {
  content: "\\f08a";
}

.icofont-numbered:before {
  content: "\\f08b";
}

.icofont-opposite:before {
  content: "\\f08c";
}

.icofont-optic:before {
  content: "\\f08d";
}

.icofont-options:before {
  content: "\\f08e";
}

.icofont-package:before {
  content: "\\f08f";
}

.icofont-page:before {
  content: "\\f090";
}

.icofont-paint:before {
  content: "\\f091";
}

.icofont-paper-plane:before {
  content: "\\f092";
}

.icofont-paperclip:before {
  content: "\\f093";
}

.icofont-papers:before {
  content: "\\f094";
}

.icofont-paw:before {
  content: "\\f095";
}

.icofont-pay:before {
  content: "\\f096";
}

.icofont-pen:before {
  content: "\\f097";
}

.icofont-pencil:before {
  content: "\\f098";
}

.icofont-penguin-linux:before {
  content: "\\f099";
}

.icofont-pestle:before {
  content: "\\f09a";
}

.icofont-phone-circle:before {
  content: "\\f09b";
}

.icofont-phone:before {
  content: "\\f09c";
}

.icofont-picture:before {
  content: "\\f09d";
}

.icofont-pie:before {
  content: "\\f09e";
}

.icofont-pine:before {
  content: "\\f09f";
}

.icofont-pixels:before {
  content: "\\f0a0";
}

.icofont-play:before {
  content: "\\f0a1";
}

.icofont-plugin:before {
  content: "\\f0a2";
}

.icofont-plus-circle:before {
  content: "\\f0a3";
}

.icofont-plus-square:before {
  content: "\\f0a4";
}

.icofont-plus:before {
  content: "\\f0a5";
}

.icofont-polygonal:before {
  content: "\\f0a6";
}

.icofont-power:before {
  content: "\\f0a7";
}

.icofont-presentation:before {
  content: "\\f0a8";
}

.icofont-price:before {
  content: "\\f0a9";
}

.icofont-print:before {
  content: "\\f0aa";
}

.icofont-puzzle:before {
  content: "\\f0ab";
}

.icofont-qr-code:before {
  content: "\\f0ac";
}

.icofont-queen:before {
  content: "\\f0ad";
}

.icofont-question-circle:before {
  content: "\\f0ae";
}

.icofont-question-square:before {
  content: "\\f0af";
}

.icofont-question:before {
  content: "\\f0b0";
}

.icofont-quote-left:before {
  content: "\\f0b1";
}

.icofont-quote-right:before {
  content: "\\f0b2";
}

.icofont-radio:before {
  content: "\\f0b3";
}

.icofont-random:before {
  content: "\\f0b4";
}

.icofont-recycle:before {
  content: "\\f0b5";
}

.icofont-refresh:before {
  content: "\\f0b6";
}

.icofont-repair:before {
  content: "\\f0b7";
}

.icofont-reply-all:before {
  content: "\\f0b8";
}

.icofont-reply:before {
  content: "\\f0b9";
}

.icofont-resize:before {
  content: "\\f0ba";
}

.icofont-responsive:before {
  content: "\\f0bb";
}

.icofont-retweet:before {
  content: "\\f0bc";
}

.icofont-road:before {
  content: "\\f0bd";
}

.icofont-robot:before {
  content: "\\f0be";
}

.icofont-rocket:before {
  content: "\\f0bf";
}

.icofont-royal:before {
  content: "\\f0c0";
}

.icofont-rss-feed:before {
  content: "\\f0c1";
}

.icofont-safety:before {
  content: "\\f0c2";
}

.icofont-sale-discount:before {
  content: "\\f0c3";
}

.icofont-satellite:before {
  content: "\\f0c4";
}

.icofont-send-mail:before {
  content: "\\f0c5";
}

.icofont-server:before {
  content: "\\f0c6";
}

.icofont-settings:before {
  content: "\\f0c7";
}

.icofont-share-alt:before {
  content: "\\f0c8";
}

.icofont-share-boxed:before {
  content: "\\f0c9";
}

.icofont-share:before {
  content: "\\f0ca";
}

.icofont-shield:before {
  content: "\\f0cb";
}

.icofont-ship:before {
  content: "\\f0cc";
}

.icofont-shopping-cart:before {
  content: "\\f0cd";
}

.icofont-sign-in:before {
  content: "\\f0ce";
}

.icofont-sign-out:before {
  content: "\\f0cf";
}

.icofont-signal:before {
  content: "\\f0d0";
}

.icofont-site-map:before {
  content: "\\f0d1";
}

.icofont-smart-phone:before {
  content: "\\f0d2";
}

.icofont-soccer:before {
  content: "\\f0d3";
}

.icofont-sort-alt:before {
  content: "\\f0d4";
}

.icofont-sort:before {
  content: "\\f0d5";
}

.icofont-space:before {
  content: "\\f0d6";
}

.icofont-spanner:before {
  content: "\\f0d7";
}

.icofont-speech-comments:before {
  content: "\\f0d8";
}

.icofont-speed-meter:before {
  content: "\\f0d9";
}

.icofont-spinner-alt-1:before {
  content: "\\f0da";
}

.icofont-spinner-alt-2:before {
  content: "\\f0db";
}

.icofont-spinner-alt-3:before {
  content: "\\f0dc";
}

.icofont-spinner-alt-4:before {
  content: "\\f0dd";
}

.icofont-spinner-alt-5:before {
  content: "\\f0de";
}

.icofont-spinner-alt-6:before {
  content: "\\f0df";
}

.icofont-spinner:before {
  content: "\\f0e0";
}

.icofont-spreadsheet:before {
  content: "\\f0e1";
}

.icofont-square:before {
  content: "\\f0e2";
}

.icofont-ssl-security:before {
  content: "\\f0e3";
}

.icofont-star-alt-1:before {
  content: "\\f0e4";
}

.icofont-star-alt-2:before {
  content: "\\f0e5";
}

.icofont-star:before {
  content: "\\f0e6";
}

.icofont-street-view:before {
  content: "\\f0e7";
}

.icofont-sun:before {
  content: "\\f0e8";
}

.icofont-support-faq:before {
  content: "\\f0e9";
}

.icofont-tack-pin:before {
  content: "\\f0ea";
}

.icofont-tag:before {
  content: "\\f0eb";
}

.icofont-tags:before {
  content: "\\f0ec";
}

.icofont-tasks:before {
  content: "\\f0ed";
}

.icofont-telephone:before {
  content: "\\f0ee";
}

.icofont-telescope:before {
  content: "\\f0ef";
}

.icofont-terminal:before {
  content: "\\f0f0";
}

.icofont-thumbs-down:before {
  content: "\\f0f1";
}

.icofont-thumbs-up:before {
  content: "\\f0f2";
}

.icofont-tick-boxed:before {
  content: "\\f0f3";
}

.icofont-tick-mark:before {
  content: "\\f0f4";
}

.icofont-ticket:before {
  content: "\\f0f5";
}

.icofont-tie:before {
  content: "\\f0f6";
}

.icofont-toggle-off:before {
  content: "\\f0f7";
}

.icofont-toggle-on:before {
  content: "\\f0f8";
}

.icofont-tools:before {
  content: "\\f0f9";
}

.icofont-transparent:before {
  content: "\\f0fa";
}

.icofont-tree:before {
  content: "\\f0fb";
}

.icofont-umbrella:before {
  content: "\\f0fc";
}

.icofont-unlock:before {
  content: "\\f0fd";
}

.icofont-unlocked:before {
  content: "\\f0fe";
}

.icofont-upload-alt:before {
  content: "\\f0ff";
}

.icofont-upload:before {
  content: "\\f100";
}

.icofont-usb-drive:before {
  content: "\\f101";
}

.icofont-usb:before {
  content: "\\f102";
}

.icofont-vector-path:before {
  content: "\\f103";
}

.icofont-verification-check:before {
  content: "\\f104";
}

.icofont-video-clapper:before {
  content: "\\f105";
}

.icofont-video:before {
  content: "\\f106";
}

.icofont-volume-down:before {
  content: "\\f107";
}

.icofont-volume-off:before {
  content: "\\f108";
}

.icofont-volume-up:before {
  content: "\\f109";
}

.icofont-wall-clock:before {
  content: "\\f10a";
}

.icofont-wall:before {
  content: "\\f10b";
}

.icofont-wallet:before {
  content: "\\f10c";
}

.icofont-warning-alt:before {
  content: "\\f10d";
}

.icofont-warning:before {
  content: "\\f10e";
}

.icofont-water-drop:before {
  content: "\\f10f";
}

.icofont-web:before {
  content: "\\f110";
}

.icofont-wheelchair:before {
  content: "\\f111";
}

.icofont-wifi-alt:before {
  content: "\\f112";
}

.icofont-wifi:before {
  content: "\\f113";
}

.icofont-world:before {
  content: "\\f114";
}

.icofont-zigzag:before {
  content: "\\f115";
}

.icofont-zipped:before {
  content: "\\f116";
}

.icofont-social-500px:before {
  content: "\\f117";
}

.icofont-social-baidu-tieba:before {
  content: "\\f118";
}

.icofont-social-bbm-messenger:before {
  content: "\\f119";
}

.icofont-social-delicious:before {
  content: "\\f11a";
}

.icofont-social-dribbble:before {
  content: "\\f11b";
}

.icofont-social-facebook-messenger:before {
  content: "\\f11c";
}

.icofont-social-flikr:before {
  content: "\\f11d";
}

.icofont-social-foursquare:before {
  content: "\\f11e";
}

.icofont-social-google-hangouts:before {
  content: "\\f11f";
}

.icofont-social-kakaotalk:before {
  content: "\\f120";
}

.icofont-social-kik:before {
  content: "\\f121";
}

.icofont-social-kiwibox:before {
  content: "\\f122";
}

.icofont-social-linkedin:before {
  content: "\\f123";
}

.icofont-social-meetme:before {
  content: "\\f124";
}

.icofont-social-odnoklassniki:before {
  content: "\\f125";
}

.icofont-social-photobucket:before {
  content: "\\f126";
}

.icofont-social-qq:before {
  content: "\\f127";
}

.icofont-social-renren:before {
  content: "\\f128";
}

.icofont-social-slack:before {
  content: "\\f129";
}

.icofont-social-slidshare:before {
  content: "\\f12a";
}

.icofont-social-snapchat:before {
  content: "\\f12b";
}

.icofont-social-soundcloud:before {
  content: "\\f12c";
}

.icofont-social-spotify:before {
  content: "\\f12d";
}

.icofont-social-stack-exchange:before {
  content: "\\f12e";
}

.icofont-social-stack-overflow:before {
  content: "\\f12f";
}

.icofont-social-tagged:before {
  content: "\\f130";
}

.icofont-social-trello:before {
  content: "\\f131";
}

.icofont-social-twitch:before {
  content: "\\f132";
}

.icofont-social-vk:before {
  content: "\\f133";
}

.icofont-social-weibo:before {
  content: "\\f134";
}

.icofont-social-whatsapp:before {
  content: "\\f135";
}

.icofont-social-youku:before {
  content: "\\f136";
}

.icofont-social-youtube-play:before {
  content: "\\f137";
}

.icofont-social-youtube:before {
  content: "\\f138";
}

.icofont-brand-xiaomi:before {
  content: "\\f139";
}

/*Font size*/
.icofont-lg {
  font-size: 1.33333333em;
  line-height: 0.75em;
  vertical-align: -15%;
}

.icofont-2x {
  font-size: 2em;
}

.icofont-3x {
  font-size: 3em;
}

.icofont-4x {
  font-size: 4em;
}

.icofont-5x {
  font-size: 5em;
}

.icofont-fw {
  display: inline-block;
  width: 1.28571429em;
  text-align: center;
  width: 1.28571429em;
  text-align: center;
}

/*Fixed Width Icons*/
/*Custom list icons*/
.icofont-ul {
  padding-left: 0;
  margin-left: 2.14285714em;
  list-style-type: none;
}
.icofont-ul > li {
  position: relative;
}

.icofont-li {
  position: absolute;
  left: -2.14285714em;
  width: 2.14285714em;
  top: 0.14285714em;
  text-align: center;
}

/*Animation*/
.icofont-rotate {
  display: inline-block;
  animation: icofont-rotate 2s infinite linear;
}
@keyframes icofont-rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}
.flag-icon-background, .flag-icon {
  background-size: contain;
  background-position: 50%;
  background-repeat: no-repeat;
}

.flag-icon {
  position: relative;
  display: inline-block;
  width: 1.3333333333em;
  line-height: 1em;
}
.flag-icon:before {
  content: " ";
}
.flag-icon.flag-icon-squared {
  width: 1em;
}

.flag-icon-es-ct {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
}
.flag-icon-es-ct.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
}

.flag-icon-eu {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
}
.flag-icon-eu.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
}

.flag-icon-gb-eng {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
}
.flag-icon-gb-eng.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
}

.flag-icon-gb-nir {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
}
.flag-icon-gb-nir.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
}

.flag-icon-gb-sct {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_47___});
}
.flag-icon-gb-sct.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_47___});
}

.flag-icon-gb-wls {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
}
.flag-icon-gb-wls.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
}

.flag-icon-un {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_49___});
}
.flag-icon-un.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_49___});
}

.flag-icon-ad {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_50___});
}
.flag-icon-ad.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_50___});
}

.flag-icon-ae {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_51___});
}
.flag-icon-ae.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_51___});
}

.flag-icon-af {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_52___});
}
.flag-icon-af.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_52___});
}

.flag-icon-ag {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_53___});
}
.flag-icon-ag.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_53___});
}

.flag-icon-ai {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_54___});
}
.flag-icon-ai.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_54___});
}

.flag-icon-al {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_55___});
}
.flag-icon-al.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_55___});
}

.flag-icon-am {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_56___});
}
.flag-icon-am.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_56___});
}

.flag-icon-ao {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_57___});
}
.flag-icon-ao.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_57___});
}

.flag-icon-aq {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_58___});
}
.flag-icon-aq.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_58___});
}

.flag-icon-ar {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_59___});
}
.flag-icon-ar.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_59___});
}

.flag-icon-as {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_60___});
}
.flag-icon-as.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_60___});
}

.flag-icon-at {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_61___});
}
.flag-icon-at.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_61___});
}

.flag-icon-au {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_62___});
}
.flag-icon-au.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_62___});
}

.flag-icon-aw {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_63___});
}
.flag-icon-aw.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_63___});
}

.flag-icon-ax {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_64___});
}
.flag-icon-ax.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_64___});
}

.flag-icon-az {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_65___});
}
.flag-icon-az.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_65___});
}

.flag-icon-ba {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_66___});
}
.flag-icon-ba.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_66___});
}

.flag-icon-bb {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_67___});
}
.flag-icon-bb.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_67___});
}

.flag-icon-bd {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_68___});
}
.flag-icon-bd.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_68___});
}

.flag-icon-be {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_69___});
}
.flag-icon-be.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_69___});
}

.flag-icon-bf {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_70___});
}
.flag-icon-bf.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_70___});
}

.flag-icon-bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_71___});
}
.flag-icon-bg.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_71___});
}

.flag-icon-bh {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_72___});
}
.flag-icon-bh.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_72___});
}

.flag-icon-bi {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_73___});
}
.flag-icon-bi.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_73___});
}

.flag-icon-bj {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_74___});
}
.flag-icon-bj.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_74___});
}

.flag-icon-bl {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_75___});
}
.flag-icon-bl.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_75___});
}

.flag-icon-bm {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_76___});
}
.flag-icon-bm.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_76___});
}

.flag-icon-bn {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_77___});
}
.flag-icon-bn.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_77___});
}

.flag-icon-bo {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_78___});
}
.flag-icon-bo.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_78___});
}

.flag-icon-bq {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_79___});
}
.flag-icon-bq.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_79___});
}

.flag-icon-br {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_80___});
}
.flag-icon-br.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_80___});
}

.flag-icon-bs {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_81___});
}
.flag-icon-bs.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_81___});
}

.flag-icon-bt {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_82___});
}
.flag-icon-bt.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_82___});
}

.flag-icon-bv {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_83___});
}
.flag-icon-bv.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_83___});
}

.flag-icon-bw {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_84___});
}
.flag-icon-bw.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_84___});
}

.flag-icon-by {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_85___});
}
.flag-icon-by.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_85___});
}

.flag-icon-bz {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_86___});
}
.flag-icon-bz.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_86___});
}

.flag-icon-ca {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_87___});
}
.flag-icon-ca.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_87___});
}

.flag-icon-cc {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_88___});
}
.flag-icon-cc.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_88___});
}

.flag-icon-cd {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_89___});
}
.flag-icon-cd.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_89___});
}

.flag-icon-cf {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_90___});
}
.flag-icon-cf.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_90___});
}

.flag-icon-cg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_91___});
}
.flag-icon-cg.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_91___});
}

.flag-icon-ch {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_92___});
}
.flag-icon-ch.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_92___});
}

.flag-icon-ci {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_93___});
}
.flag-icon-ci.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_93___});
}

.flag-icon-ck {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_94___});
}
.flag-icon-ck.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_94___});
}

.flag-icon-cl {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_95___});
}
.flag-icon-cl.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_95___});
}

.flag-icon-cm {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_96___});
}
.flag-icon-cm.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_96___});
}

.flag-icon-cn {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_97___});
}
.flag-icon-cn.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_97___});
}

.flag-icon-co {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_98___});
}
.flag-icon-co.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_98___});
}

.flag-icon-cr {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_99___});
}
.flag-icon-cr.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_99___});
}

.flag-icon-cu {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_100___});
}
.flag-icon-cu.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_100___});
}

.flag-icon-cv {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_101___});
}
.flag-icon-cv.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_101___});
}

.flag-icon-cw {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_102___});
}
.flag-icon-cw.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_102___});
}

.flag-icon-cx {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_103___});
}
.flag-icon-cx.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_103___});
}

.flag-icon-cy {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_104___});
}
.flag-icon-cy.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_104___});
}

.flag-icon-cz {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_105___});
}
.flag-icon-cz.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_105___});
}

.flag-icon-de {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_106___});
}
.flag-icon-de.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_106___});
}

.flag-icon-dj {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_107___});
}
.flag-icon-dj.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_107___});
}

.flag-icon-dk {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_108___});
}
.flag-icon-dk.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_108___});
}

.flag-icon-dm {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_109___});
}
.flag-icon-dm.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_109___});
}

.flag-icon-do {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_110___});
}
.flag-icon-do.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_110___});
}

.flag-icon-dz {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
}
.flag-icon-dz.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
}

.flag-icon-ec {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_112___});
}
.flag-icon-ec.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_112___});
}

.flag-icon-ee {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_113___});
}
.flag-icon-ee.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_113___});
}

.flag-icon-eg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_114___});
}
.flag-icon-eg.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_114___});
}

.flag-icon-eh {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_115___});
}
.flag-icon-eh.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_115___});
}

.flag-icon-er {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_116___});
}
.flag-icon-er.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_116___});
}

.flag-icon-es {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_117___});
}
.flag-icon-es.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_117___});
}

.flag-icon-et {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_118___});
}
.flag-icon-et.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_118___});
}

.flag-icon-fi {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_119___});
}
.flag-icon-fi.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_119___});
}

.flag-icon-fj {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_120___});
}
.flag-icon-fj.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_120___});
}

.flag-icon-fk {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_121___});
}
.flag-icon-fk.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_121___});
}

.flag-icon-fm {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_122___});
}
.flag-icon-fm.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_122___});
}

.flag-icon-fo {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_123___});
}
.flag-icon-fo.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_123___});
}

.flag-icon-fr {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_124___});
}
.flag-icon-fr.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_124___});
}

.flag-icon-ga {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_125___});
}
.flag-icon-ga.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_125___});
}

.flag-icon-gb {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_126___});
}
.flag-icon-gb.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_126___});
}

.flag-icon-gd {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_127___});
}
.flag-icon-gd.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_127___});
}

.flag-icon-ge {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_128___});
}
.flag-icon-ge.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_128___});
}

.flag-icon-gf {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_129___});
}
.flag-icon-gf.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_129___});
}

.flag-icon-gg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_130___});
}
.flag-icon-gg.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_130___});
}

.flag-icon-gh {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_131___});
}
.flag-icon-gh.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_131___});
}

.flag-icon-gi {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_132___});
}
.flag-icon-gi.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_132___});
}

.flag-icon-gl {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_133___});
}
.flag-icon-gl.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_133___});
}

.flag-icon-gm {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_134___});
}
.flag-icon-gm.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_134___});
}

.flag-icon-gn {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_135___});
}
.flag-icon-gn.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_135___});
}

.flag-icon-gp {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_136___});
}
.flag-icon-gp.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_136___});
}

.flag-icon-gq {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_137___});
}
.flag-icon-gq.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_137___});
}

.flag-icon-gr {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_138___});
}
.flag-icon-gr.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_138___});
}

.flag-icon-gs {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_139___});
}
.flag-icon-gs.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_139___});
}

.flag-icon-gt {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_140___});
}
.flag-icon-gt.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_140___});
}

.flag-icon-gu {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_141___});
}
.flag-icon-gu.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_141___});
}

.flag-icon-gw {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_142___});
}
.flag-icon-gw.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_142___});
}

.flag-icon-gy {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_143___});
}
.flag-icon-gy.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_143___});
}

.flag-icon-hk {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_144___});
}
.flag-icon-hk.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_144___});
}

.flag-icon-hm {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_145___});
}
.flag-icon-hm.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_145___});
}

.flag-icon-hn {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_146___});
}
.flag-icon-hn.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_146___});
}

.flag-icon-hr {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_147___});
}
.flag-icon-hr.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_147___});
}

.flag-icon-ht {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_148___});
}
.flag-icon-ht.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_148___});
}

.flag-icon-hu {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_149___});
}
.flag-icon-hu.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_149___});
}

.flag-icon-id {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_150___});
}
.flag-icon-id.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_150___});
}

.flag-icon-ie {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_151___});
}
.flag-icon-ie.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_151___});
}

.flag-icon-il {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_152___});
}
.flag-icon-il.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_152___});
}

.flag-icon-im {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_153___});
}
.flag-icon-im.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_153___});
}

.flag-icon-in {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_154___});
}
.flag-icon-in.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_154___});
}

.flag-icon-io {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_155___});
}
.flag-icon-io.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_155___});
}

.flag-icon-iq {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_156___});
}
.flag-icon-iq.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_156___});
}

.flag-icon-ir {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_157___});
}
.flag-icon-ir.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_157___});
}

.flag-icon-is {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_158___});
}
.flag-icon-is.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_158___});
}

.flag-icon-it {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_159___});
}
.flag-icon-it.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_159___});
}

.flag-icon-je {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_160___});
}
.flag-icon-je.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_160___});
}

.flag-icon-jm {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_161___});
}
.flag-icon-jm.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_161___});
}

.flag-icon-jo {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_162___});
}
.flag-icon-jo.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_162___});
}

.flag-icon-jp {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_163___});
}
.flag-icon-jp.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_163___});
}

.flag-icon-ke {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_164___});
}
.flag-icon-ke.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_164___});
}

.flag-icon-kg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_165___});
}
.flag-icon-kg.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_165___});
}

.flag-icon-kh {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_166___});
}
.flag-icon-kh.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_166___});
}

.flag-icon-ki {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_167___});
}
.flag-icon-ki.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_167___});
}

.flag-icon-km {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_168___});
}
.flag-icon-km.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_168___});
}

.flag-icon-kn {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_169___});
}
.flag-icon-kn.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_169___});
}

.flag-icon-kp {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_170___});
}
.flag-icon-kp.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_170___});
}

.flag-icon-kr {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_171___});
}
.flag-icon-kr.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_171___});
}

.flag-icon-kw {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_172___});
}
.flag-icon-kw.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_172___});
}

.flag-icon-ky {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_173___});
}
.flag-icon-ky.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_173___});
}

.flag-icon-kz {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_174___});
}
.flag-icon-kz.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_174___});
}

.flag-icon-la {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_175___});
}
.flag-icon-la.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_175___});
}

.flag-icon-lb {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_176___});
}
.flag-icon-lb.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_176___});
}

.flag-icon-lc {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_177___});
}
.flag-icon-lc.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_177___});
}

.flag-icon-li {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_178___});
}
.flag-icon-li.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_178___});
}

.flag-icon-lk {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_179___});
}
.flag-icon-lk.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_179___});
}

.flag-icon-lr {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_180___});
}
.flag-icon-lr.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_180___});
}

.flag-icon-ls {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_181___});
}
.flag-icon-ls.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_181___});
}

.flag-icon-lt {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_182___});
}
.flag-icon-lt.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_182___});
}

.flag-icon-lu {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_183___});
}
.flag-icon-lu.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_183___});
}

.flag-icon-lv {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_184___});
}
.flag-icon-lv.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_184___});
}

.flag-icon-ly {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_185___});
}
.flag-icon-ly.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_185___});
}

.flag-icon-ma {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_186___});
}
.flag-icon-ma.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_186___});
}

.flag-icon-mc {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_187___});
}
.flag-icon-mc.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_187___});
}

.flag-icon-md {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_188___});
}
.flag-icon-md.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_188___});
}

.flag-icon-me {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_189___});
}
.flag-icon-me.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_189___});
}

.flag-icon-mf {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_190___});
}
.flag-icon-mf.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_190___});
}

.flag-icon-mg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_191___});
}
.flag-icon-mg.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_191___});
}

.flag-icon-mh {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_192___});
}
.flag-icon-mh.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_192___});
}

.flag-icon-mk {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_193___});
}
.flag-icon-mk.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_193___});
}

.flag-icon-ml {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_194___});
}
.flag-icon-ml.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_194___});
}

.flag-icon-mm {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_195___});
}
.flag-icon-mm.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_195___});
}

.flag-icon-mn {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_196___});
}
.flag-icon-mn.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_196___});
}

.flag-icon-mo {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_197___});
}
.flag-icon-mo.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_197___});
}

.flag-icon-mp {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_198___});
}
.flag-icon-mp.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_198___});
}

.flag-icon-mq {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_199___});
}
.flag-icon-mq.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_199___});
}

.flag-icon-mr {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_200___});
}
.flag-icon-mr.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_200___});
}

.flag-icon-ms {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_201___});
}
.flag-icon-ms.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_201___});
}

.flag-icon-mt {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_202___});
}
.flag-icon-mt.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_202___});
}

.flag-icon-mu {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_203___});
}
.flag-icon-mu.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_203___});
}

.flag-icon-mv {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_204___});
}
.flag-icon-mv.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_204___});
}

.flag-icon-mw {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_205___});
}
.flag-icon-mw.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_205___});
}

.flag-icon-mx {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_206___});
}
.flag-icon-mx.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_206___});
}

.flag-icon-my {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_207___});
}
.flag-icon-my.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_207___});
}

.flag-icon-mz {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_208___});
}
.flag-icon-mz.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_208___});
}

.flag-icon-na {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_209___});
}
.flag-icon-na.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_209___});
}

.flag-icon-nc {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_210___});
}
.flag-icon-nc.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_210___});
}

.flag-icon-ne {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_211___});
}
.flag-icon-ne.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_211___});
}

.flag-icon-nf {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_212___});
}
.flag-icon-nf.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_212___});
}

.flag-icon-ng {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_213___});
}
.flag-icon-ng.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_213___});
}

.flag-icon-ni {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_214___});
}
.flag-icon-ni.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_214___});
}

.flag-icon-nl {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_215___});
}
.flag-icon-nl.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_215___});
}

.flag-icon-no {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_216___});
}
.flag-icon-no.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_216___});
}

.flag-icon-np {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_217___});
}
.flag-icon-np.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_217___});
}

.flag-icon-nr {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_218___});
}
.flag-icon-nr.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_218___});
}

.flag-icon-nu {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_219___});
}
.flag-icon-nu.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_219___});
}

.flag-icon-nz {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_220___});
}
.flag-icon-nz.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_220___});
}

.flag-icon-om {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_221___});
}
.flag-icon-om.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_221___});
}

.flag-icon-pa {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_222___});
}
.flag-icon-pa.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_222___});
}

.flag-icon-pe {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_223___});
}
.flag-icon-pe.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_223___});
}

.flag-icon-pf {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_224___});
}
.flag-icon-pf.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_224___});
}

.flag-icon-pg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_225___});
}
.flag-icon-pg.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_225___});
}

.flag-icon-ph {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_226___});
}
.flag-icon-ph.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_226___});
}

.flag-icon-pk {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_227___});
}
.flag-icon-pk.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_227___});
}

.flag-icon-pl {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_228___});
}
.flag-icon-pl.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_228___});
}

.flag-icon-pm {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_229___});
}
.flag-icon-pm.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_229___});
}

.flag-icon-pn {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_230___});
}
.flag-icon-pn.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_230___});
}

.flag-icon-pr {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_231___});
}
.flag-icon-pr.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_231___});
}

.flag-icon-ps {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_232___});
}
.flag-icon-ps.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_232___});
}

.flag-icon-pt {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_233___});
}
.flag-icon-pt.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_233___});
}

.flag-icon-pw {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_234___});
}
.flag-icon-pw.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_234___});
}

.flag-icon-py {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_235___});
}
.flag-icon-py.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_235___});
}

.flag-icon-qa {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_236___});
}
.flag-icon-qa.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_236___});
}

.flag-icon-re {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_237___});
}
.flag-icon-re.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_237___});
}

.flag-icon-ro {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_238___});
}
.flag-icon-ro.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_238___});
}

.flag-icon-rs {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_239___});
}
.flag-icon-rs.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_239___});
}

.flag-icon-ru {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_240___});
}
.flag-icon-ru.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_240___});
}

.flag-icon-rw {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_241___});
}
.flag-icon-rw.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_241___});
}

.flag-icon-sa {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_242___});
}
.flag-icon-sa.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_242___});
}

.flag-icon-sb {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_243___});
}
.flag-icon-sb.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_243___});
}

.flag-icon-sc {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_244___});
}
.flag-icon-sc.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_244___});
}

.flag-icon-sd {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_245___});
}
.flag-icon-sd.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_245___});
}

.flag-icon-se {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_246___});
}
.flag-icon-se.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_246___});
}

.flag-icon-sg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_247___});
}
.flag-icon-sg.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_247___});
}

.flag-icon-sh {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_248___});
}
.flag-icon-sh.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_248___});
}

.flag-icon-si {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_249___});
}
.flag-icon-si.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_249___});
}

.flag-icon-sj {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_250___});
}
.flag-icon-sj.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_250___});
}

.flag-icon-sk {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_251___});
}
.flag-icon-sk.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_251___});
}

.flag-icon-sl {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_252___});
}
.flag-icon-sl.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_252___});
}

.flag-icon-sm {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_253___});
}
.flag-icon-sm.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_253___});
}

.flag-icon-sn {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_254___});
}
.flag-icon-sn.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_254___});
}

.flag-icon-so {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_255___});
}
.flag-icon-so.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_255___});
}

.flag-icon-sr {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_256___});
}
.flag-icon-sr.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_256___});
}

.flag-icon-ss {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_257___});
}
.flag-icon-ss.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_257___});
}

.flag-icon-st {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_258___});
}
.flag-icon-st.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_258___});
}

.flag-icon-sv {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_259___});
}
.flag-icon-sv.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_259___});
}

.flag-icon-sx {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_260___});
}
.flag-icon-sx.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_260___});
}

.flag-icon-sy {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_261___});
}
.flag-icon-sy.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_261___});
}

.flag-icon-sz {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_262___});
}
.flag-icon-sz.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_262___});
}

.flag-icon-tc {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_263___});
}
.flag-icon-tc.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_263___});
}

.flag-icon-td {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_264___});
}
.flag-icon-td.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_264___});
}

.flag-icon-tf {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_265___});
}
.flag-icon-tf.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_265___});
}

.flag-icon-tg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_266___});
}
.flag-icon-tg.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_266___});
}

.flag-icon-th {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_267___});
}
.flag-icon-th.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_267___});
}

.flag-icon-tj {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_268___});
}
.flag-icon-tj.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_268___});
}

.flag-icon-tk {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_269___});
}
.flag-icon-tk.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_269___});
}

.flag-icon-tl {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_270___});
}
.flag-icon-tl.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_270___});
}

.flag-icon-tm {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_271___});
}
.flag-icon-tm.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_271___});
}

.flag-icon-tn {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_272___});
}
.flag-icon-tn.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_272___});
}

.flag-icon-to {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_273___});
}
.flag-icon-to.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_273___});
}

.flag-icon-tr {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_274___});
}
.flag-icon-tr.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_274___});
}

.flag-icon-tt {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_275___});
}
.flag-icon-tt.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_275___});
}

.flag-icon-tv {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_276___});
}
.flag-icon-tv.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_276___});
}

.flag-icon-tw {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_277___});
}
.flag-icon-tw.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_277___});
}

.flag-icon-tz {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_278___});
}
.flag-icon-tz.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_278___});
}

.flag-icon-ua {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_279___});
}
.flag-icon-ua.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_279___});
}

.flag-icon-ug {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_280___});
}
.flag-icon-ug.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_280___});
}

.flag-icon-um {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_281___});
}
.flag-icon-um.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_281___});
}

.flag-icon-us {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_282___});
}
.flag-icon-us.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_282___});
}

.flag-icon-uy {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_283___});
}
.flag-icon-uy.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_283___});
}

.flag-icon-uz {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_284___});
}
.flag-icon-uz.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_284___});
}

.flag-icon-va {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_285___});
}
.flag-icon-va.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_285___});
}

.flag-icon-vc {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_286___});
}
.flag-icon-vc.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_286___});
}

.flag-icon-ve {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_287___});
}
.flag-icon-ve.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_287___});
}

.flag-icon-vg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_288___});
}
.flag-icon-vg.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_288___});
}

.flag-icon-vi {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_289___});
}
.flag-icon-vi.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_289___});
}

.flag-icon-vn {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_290___});
}
.flag-icon-vn.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_290___});
}

.flag-icon-vu {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_291___});
}
.flag-icon-vu.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_291___});
}

.flag-icon-wf {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_292___});
}
.flag-icon-wf.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_292___});
}

.flag-icon-ws {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_293___});
}
.flag-icon-ws.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_293___});
}

.flag-icon-ye {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_294___});
}
.flag-icon-ye.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_294___});
}

.flag-icon-yt {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_295___});
}
.flag-icon-yt.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_295___});
}

.flag-icon-za {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_296___});
}
.flag-icon-za.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_296___});
}

.flag-icon-zm {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_297___});
}
.flag-icon-zm.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_297___});
}

.flag-icon-zw {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_298___});
}
.flag-icon-zw.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_298___});
}

/**
 * @package IcoFont by ThemeHunt - https://themehunt.com
 * @version 1.0.0 Beta
 * @author IcoFont http://icofont.com
 * @copyright Copyright (c) 2018 IcoFont
 * @license - http://icofont.com/license/
*/
@font-face {
  font-family: "icofont";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_39___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_40___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_41___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_42___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
.icofont {
  font-family: "IcoFont" !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icofont-angry-monster:before {
  content: "\\e901";
}

.icofont-bathtub:before {
  content: "\\e902";
}

.icofont-bird-wings:before {
  content: "\\e903";
}

.icofont-bow:before {
  content: "\\e904";
}

.icofont-brain-alt:before {
  content: "\\e905";
}

.icofont-butterfly-alt:before {
  content: "\\e906";
}

.icofont-castle:before {
  content: "\\e907";
}

.icofont-circuit:before {
  content: "\\e908";
}

.icofont-dart:before {
  content: "\\e909";
}

.icofont-dice-alt:before {
  content: "\\e90a";
}

.icofont-disability-race:before {
  content: "\\e90b";
}

.icofont-diving-goggle:before {
  content: "\\e90c";
}

.icofont-fire-alt:before {
  content: "\\e90d";
}

.icofont-flame-torch:before {
  content: "\\e90e";
}

.icofont-flora-flower:before {
  content: "\\e90f";
}

.icofont-flora:before {
  content: "\\e910";
}

.icofont-gift-box:before {
  content: "\\e911";
}

.icofont-halloween-pumpkin:before {
  content: "\\e912";
}

.icofont-hand-power:before {
  content: "\\e913";
}

.icofont-hand-thunder:before {
  content: "\\e914";
}

.icofont-king-crown:before {
  content: "\\e915";
}

.icofont-king-monster:before {
  content: "\\e916";
}

.icofont-love:before {
  content: "\\e917";
}

.icofont-magician-hat:before {
  content: "\\e918";
}

.icofont-native-american:before {
  content: "\\e919";
}

.icofont-open-eye:before {
  content: "\\e91a";
}

.icofont-owl-look:before {
  content: "\\e91b";
}

.icofont-phoenix:before {
  content: "\\e91c";
}

.icofont-queen-crown:before {
  content: "\\e91d";
}

.icofont-robot-face:before {
  content: "\\e91e";
}

.icofont-sand-clock:before {
  content: "\\e91f";
}

.icofont-shield-alt:before {
  content: "\\e920";
}

.icofont-ship-wheel:before {
  content: "\\e921";
}

.icofont-skull-danger:before {
  content: "\\e922";
}

.icofont-skull-face:before {
  content: "\\e923";
}

.icofont-snail:before {
  content: "\\e924";
}

.icofont-snow-alt:before {
  content: "\\e925";
}

.icofont-snow-flake:before {
  content: "\\e926";
}

.icofont-snowmobile:before {
  content: "\\e927";
}

.icofont-space-shuttle:before {
  content: "\\e928";
}

.icofont-star-shape:before {
  content: "\\e929";
}

.icofont-swirl:before {
  content: "\\e92a";
}

.icofont-tattoo-wing:before {
  content: "\\e92b";
}

.icofont-throne:before {
  content: "\\e92c";
}

.icofont-touch:before {
  content: "\\e92d";
}

.icofont-tree-alt:before {
  content: "\\e92e";
}

.icofont-triangle:before {
  content: "\\e92f";
}

.icofont-unity-hand:before {
  content: "\\e930";
}

.icofont-weed:before {
  content: "\\e931";
}

.icofont-woman-bird:before {
  content: "\\e932";
}

.icofont-animal-bat:before {
  content: "\\e933";
}

.icofont-animal-bear-tracks:before {
  content: "\\e934";
}

.icofont-animal-bear:before {
  content: "\\e935";
}

.icofont-animal-bird-alt:before {
  content: "\\e936";
}

.icofont-animal-bird:before {
  content: "\\e937";
}

.icofont-animal-bone:before {
  content: "\\e938";
}

.icofont-animal-bull:before {
  content: "\\e939";
}

.icofont-animal-camel-alt:before {
  content: "\\e93a";
}

.icofont-animal-camel-head:before {
  content: "\\e93b";
}

.icofont-animal-camel:before {
  content: "\\e93c";
}

.icofont-animal-cat-alt-1:before {
  content: "\\e93d";
}

.icofont-animal-cat-alt-2:before {
  content: "\\e93e";
}

.icofont-animal-cat-alt-3:before {
  content: "\\e93f";
}

.icofont-animal-cat-alt-4:before {
  content: "\\e940";
}

.icofont-animal-cat-with-dog:before {
  content: "\\e941";
}

.icofont-animal-cat:before {
  content: "\\e942";
}

.icofont-animal-cow-head:before {
  content: "\\e943";
}

.icofont-animal-cow:before {
  content: "\\e944";
}

.icofont-animal-crab:before {
  content: "\\e945";
}

.icofont-animal-crocodile:before {
  content: "\\e946";
}

.icofont-animal-deer-head:before {
  content: "\\e947";
}

.icofont-animal-dog-alt:before {
  content: "\\e948";
}

.icofont-animal-dog-barking:before {
  content: "\\e949";
}

.icofont-animal-dog:before {
  content: "\\e94a";
}

.icofont-animal-dolphin:before {
  content: "\\e94b";
}

.icofont-animal-duck-tracks:before {
  content: "\\e94c";
}

.icofont-animal-eagle-head:before {
  content: "\\e94d";
}

.icofont-animal-eaten-fish:before {
  content: "\\e94e";
}

.icofont-animal-elephant-alt:before {
  content: "\\e94f";
}

.icofont-animal-elephant-head-alt:before {
  content: "\\e950";
}

.icofont-animal-elephant-head:before {
  content: "\\e951";
}

.icofont-animal-elephant:before {
  content: "\\e952";
}

.icofont-animal-elk:before {
  content: "\\e953";
}

.icofont-animal-fish-alt-1:before {
  content: "\\e954";
}

.icofont-animal-fish-alt-2:before {
  content: "\\e955";
}

.icofont-animal-fish-alt-3:before {
  content: "\\e956";
}

.icofont-animal-fish-alt-4:before {
  content: "\\e957";
}

.icofont-animal-fish:before {
  content: "\\e958";
}

.icofont-animal-fox-alt:before {
  content: "\\e959";
}

.icofont-animal-fox:before {
  content: "\\e95a";
}

.icofont-animal-frog-tracks:before {
  content: "\\e95b";
}

.icofont-animal-frog:before {
  content: "\\e95c";
}

.icofont-animal-froggy:before {
  content: "\\e95d";
}

.icofont-animal-giraffe-alt:before {
  content: "\\e95e";
}

.icofont-animal-giraffe:before {
  content: "\\e95f";
}

.icofont-animal-goat-head-alt-1:before {
  content: "\\e960";
}

.icofont-animal-goat-head-alt-2:before {
  content: "\\e961";
}

.icofont-animal-goat-head:before {
  content: "\\e962";
}

.icofont-animal-gorilla:before {
  content: "\\e963";
}

.icofont-animal-hen-tracks:before {
  content: "\\e964";
}

.icofont-animal-horse-head-alt-1:before {
  content: "\\e965";
}

.icofont-animal-horse-head-alt-2:before {
  content: "\\e966";
}

.icofont-animal-horse-head:before {
  content: "\\e967";
}

.icofont-animal-horse-tracks:before {
  content: "\\e968";
}

.icofont-animal-jellyfish:before {
  content: "\\e969";
}

.icofont-animal-kangaroo:before {
  content: "\\e96a";
}

.icofont-animal-lemur:before {
  content: "\\e96b";
}

.icofont-animal-lion-alt:before {
  content: "\\e96c";
}

.icofont-animal-lion-head-alt:before {
  content: "\\e96d";
}

.icofont-animal-lion-head:before {
  content: "\\e96e";
}

.icofont-animal-lion:before {
  content: "\\e96f";
}

.icofont-animal-monkey-alt-1:before {
  content: "\\e970";
}

.icofont-animal-monkey-alt-2:before {
  content: "\\e971";
}

.icofont-animal-monkey-alt-3:before {
  content: "\\e972";
}

.icofont-animal-monkey:before {
  content: "\\e973";
}

.icofont-animal-octopus-alt:before {
  content: "\\e974";
}

.icofont-animal-octopus:before {
  content: "\\e975";
}

.icofont-animal-owl:before {
  content: "\\e976";
}

.icofont-animal-panda-alt:before {
  content: "\\e977";
}

.icofont-animal-panda:before {
  content: "\\e978";
}

.icofont-animal-panther:before {
  content: "\\e979";
}

.icofont-animal-parrot-lip:before {
  content: "\\e97a";
}

.icofont-animal-parrot:before {
  content: "\\e97b";
}

.icofont-animal-paw:before {
  content: "\\e97c";
}

.icofont-animal-pelican:before {
  content: "\\e97d";
}

.icofont-animal-penguin:before {
  content: "\\e97e";
}

.icofont-animal-pig-alt:before {
  content: "\\e97f";
}

.icofont-animal-pig:before {
  content: "\\e980";
}

.icofont-animal-pigeon-alt:before {
  content: "\\e981";
}

.icofont-animal-pigeon:before {
  content: "\\e982";
}

.icofont-animal-pigeons:before {
  content: "\\e983";
}

.icofont-animal-rabbit-running:before {
  content: "\\e984";
}

.icofont-animal-rat-alt:before {
  content: "\\e985";
}

.icofont-animal-rhino-head:before {
  content: "\\e986";
}

.icofont-animal-rhino:before {
  content: "\\e987";
}

.icofont-animal-rooster:before {
  content: "\\e988";
}

.icofont-animal-seahorse:before {
  content: "\\e989";
}

.icofont-animal-seal:before {
  content: "\\e98a";
}

.icofont-animal-shrimp:before {
  content: "\\e98b";
}

.icofont-animal-snail-alt-1:before {
  content: "\\e98c";
}

.icofont-animal-snail-alt-2:before {
  content: "\\e98d";
}

.icofont-animal-snail:before {
  content: "\\e98e";
}

.icofont-animal-snake:before {
  content: "\\e98f";
}

.icofont-animal-squid:before {
  content: "\\e990";
}

.icofont-animal-squirrel:before {
  content: "\\e991";
}

.icofont-animal-tiger-alt:before {
  content: "\\e992";
}

.icofont-animal-tiger:before {
  content: "\\e993";
}

.icofont-animal-turtle:before {
  content: "\\e994";
}

.icofont-animal-whale:before {
  content: "\\e995";
}

.icofont-animal-woodpecker:before {
  content: "\\e996";
}

.icofont-animal-zebra:before {
  content: "\\e997";
}

.icofont-brand-acer:before {
  content: "\\e998";
}

.icofont-brand-adidas:before {
  content: "\\e999";
}

.icofont-brand-adobe:before {
  content: "\\e99a";
}

.icofont-brand-air-new-zealand:before {
  content: "\\e99b";
}

.icofont-brand-airbnb:before {
  content: "\\e99c";
}

.icofont-brand-aircell:before {
  content: "\\e99d";
}

.icofont-brand-airtel:before {
  content: "\\e99e";
}

.icofont-brand-alcatel:before {
  content: "\\e99f";
}

.icofont-brand-alibaba:before {
  content: "\\e9a0";
}

.icofont-brand-aliexpress:before {
  content: "\\e9a1";
}

.icofont-brand-alipay:before {
  content: "\\e9a2";
}

.icofont-brand-amazon:before {
  content: "\\e9a3";
}

.icofont-brand-amd:before {
  content: "\\e9a4";
}

.icofont-brand-american-airlines:before {
  content: "\\e9a5";
}

.icofont-brand-android-robot:before {
  content: "\\e9a6";
}

.icofont-brand-android:before {
  content: "\\e9a7";
}

.icofont-brand-aol:before {
  content: "\\e9a8";
}

.icofont-brand-apple:before {
  content: "\\e9a9";
}

.icofont-brand-appstore:before {
  content: "\\e9aa";
}

.icofont-brand-asus:before {
  content: "\\e9ab";
}

.icofont-brand-ati:before {
  content: "\\e9ac";
}

.icofont-brand-att:before {
  content: "\\e9ad";
}

.icofont-brand-audi:before {
  content: "\\e9ae";
}

.icofont-brand-axiata:before {
  content: "\\e9af";
}

.icofont-brand-bada:before {
  content: "\\e9b0";
}

.icofont-brand-bbc:before {
  content: "\\e9b1";
}

.icofont-brand-bing:before {
  content: "\\e9b2";
}

.icofont-brand-blackberry:before {
  content: "\\e9b3";
}

.icofont-brand-bmw:before {
  content: "\\e9b4";
}

.icofont-brand-box:before {
  content: "\\e9b5";
}

.icofont-brand-burger-king:before {
  content: "\\e9b6";
}

.icofont-brand-business-insider:before {
  content: "\\e9b7";
}

.icofont-brand-buzzfeed:before {
  content: "\\e9b8";
}

.icofont-brand-cannon:before {
  content: "\\e9b9";
}

.icofont-brand-casio:before {
  content: "\\e9ba";
}

.icofont-brand-china-mobile:before {
  content: "\\e9bb";
}

.icofont-brand-china-telecom:before {
  content: "\\e9bc";
}

.icofont-brand-china-unicom:before {
  content: "\\e9bd";
}

.icofont-brand-cisco:before {
  content: "\\e9be";
}

.icofont-brand-citibank:before {
  content: "\\e9bf";
}

.icofont-brand-cnet:before {
  content: "\\e9c0";
}

.icofont-brand-cnn:before {
  content: "\\e9c1";
}

.icofont-brand-cocal-cola:before {
  content: "\\e9c2";
}

.icofont-brand-compaq:before {
  content: "\\e9c3";
}

.icofont-brand-copy:before {
  content: "\\e9c4";
}

.icofont-brand-debian:before {
  content: "\\e9c5";
}

.icofont-brand-delicious:before {
  content: "\\e9c6";
}

.icofont-brand-dell:before {
  content: "\\e9c7";
}

.icofont-brand-designbump:before {
  content: "\\e9c8";
}

.icofont-brand-designfloat:before {
  content: "\\e9c9";
}

.icofont-brand-disney:before {
  content: "\\e9ca";
}

.icofont-brand-dodge:before {
  content: "\\e9cb";
}

.icofont-brand-dove:before {
  content: "\\e9cc";
}

.icofont-brand-ebay:before {
  content: "\\e9cd";
}

.icofont-brand-eleven:before {
  content: "\\e9ce";
}

.icofont-brand-emirates:before {
  content: "\\e9cf";
}

.icofont-brand-espn:before {
  content: "\\e9d0";
}

.icofont-brand-etihad-airways:before {
  content: "\\e9d1";
}

.icofont-brand-etisalat:before {
  content: "\\e9d2";
}

.icofont-brand-etsy:before {
  content: "\\e9d3";
}

.icofont-brand-facebook:before {
  content: "\\e9d4";
}

.icofont-brand-fastrack:before {
  content: "\\e9d5";
}

.icofont-brand-fedex:before {
  content: "\\e9d6";
}

.icofont-brand-ferrari:before {
  content: "\\e9d7";
}

.icofont-brand-fitbit:before {
  content: "\\e9d8";
}

.icofont-brand-flikr:before {
  content: "\\e9d9";
}

.icofont-brand-forbes:before {
  content: "\\e9da";
}

.icofont-brand-foursquare:before {
  content: "\\e9db";
}

.icofont-brand-fox:before {
  content: "\\e9dc";
}

.icofont-brand-foxconn:before {
  content: "\\e9dd";
}

.icofont-brand-fujitsu:before {
  content: "\\e9de";
}

.icofont-brand-general-electric:before {
  content: "\\e9df";
}

.icofont-brand-gillette:before {
  content: "\\e9e0";
}

.icofont-brand-gizmodo:before {
  content: "\\e9e1";
}

.icofont-brand-gnome:before {
  content: "\\e9e2";
}

.icofont-brand-google:before {
  content: "\\e9e3";
}

.icofont-brand-gopro:before {
  content: "\\e9e4";
}

.icofont-brand-gucci:before {
  content: "\\e9e5";
}

.icofont-brand-hallmark:before {
  content: "\\e9e6";
}

.icofont-brand-hi5:before {
  content: "\\e9e7";
}

.icofont-brand-honda:before {
  content: "\\e9e8";
}

.icofont-brand-hp:before {
  content: "\\e9e9";
}

.icofont-brand-hsbc:before {
  content: "\\e9ea";
}

.icofont-brand-htc:before {
  content: "\\e9eb";
}

.icofont-brand-huawei:before {
  content: "\\e9ec";
}

.icofont-brand-hulu:before {
  content: "\\e9ed";
}

.icofont-brand-hyundai:before {
  content: "\\e9ee";
}

.icofont-brand-ibm:before {
  content: "\\e9ef";
}

.icofont-brand-icofont:before {
  content: "\\e9f0";
}

.icofont-brand-icq:before {
  content: "\\e9f1";
}

.icofont-brand-ikea:before {
  content: "\\e9f2";
}

.icofont-brand-imdb:before {
  content: "\\e9f3";
}

.icofont-brand-indiegogo:before {
  content: "\\e9f4";
}

.icofont-brand-intel:before {
  content: "\\e9f5";
}

.icofont-brand-ipair:before {
  content: "\\e9f6";
}

.icofont-brand-jaguar:before {
  content: "\\e9f7";
}

.icofont-brand-java:before {
  content: "\\e9f8";
}

.icofont-brand-joomshaper:before {
  content: "\\e9f9";
}

.icofont-brand-kickstarter:before {
  content: "\\e9fa";
}

.icofont-brand-kik:before {
  content: "\\e9fb";
}

.icofont-brand-lastfm:before {
  content: "\\e9fc";
}

.icofont-brand-lego:before {
  content: "\\e9fd";
}

.icofont-brand-lenovo:before {
  content: "\\e9fe";
}

.icofont-brand-levis:before {
  content: "\\e9ff";
}

.icofont-brand-lexus:before {
  content: "\\ea00";
}

.icofont-brand-lg:before {
  content: "\\ea01";
}

.icofont-brand-life-hacker:before {
  content: "\\ea02";
}

.icofont-brand-line-messenger:before {
  content: "\\ea03";
}

.icofont-brand-linkedin:before {
  content: "\\ea04";
}

.icofont-brand-linux-mint:before {
  content: "\\ea05";
}

.icofont-brand-linux:before {
  content: "\\ea06";
}

.icofont-brand-lionix:before {
  content: "\\ea07";
}

.icofont-brand-live-messenger:before {
  content: "\\ea08";
}

.icofont-brand-loreal:before {
  content: "\\ea09";
}

.icofont-brand-louis-vuitton:before {
  content: "\\ea0a";
}

.icofont-brand-mac-os:before {
  content: "\\ea0b";
}

.icofont-brand-marvel-app:before {
  content: "\\ea0c";
}

.icofont-brand-mashable:before {
  content: "\\ea0d";
}

.icofont-brand-mazda:before {
  content: "\\ea0e";
}

.icofont-brand-mcdonals:before {
  content: "\\ea0f";
}

.icofont-brand-mercedes:before {
  content: "\\ea10";
}

.icofont-brand-micromax:before {
  content: "\\ea11";
}

.icofont-brand-microsoft:before {
  content: "\\ea12";
}

.icofont-brand-mobileme:before {
  content: "\\ea13";
}

.icofont-brand-mobily:before {
  content: "\\ea14";
}

.icofont-brand-motorola:before {
  content: "\\ea15";
}

.icofont-brand-msi:before {
  content: "\\ea16";
}

.icofont-brand-mts:before {
  content: "\\ea17";
}

.icofont-brand-myspace:before {
  content: "\\ea18";
}

.icofont-brand-mytv:before {
  content: "\\ea19";
}

.icofont-brand-nasa:before {
  content: "\\ea1a";
}

.icofont-brand-natgeo:before {
  content: "\\ea1b";
}

.icofont-brand-nbc:before {
  content: "\\ea1c";
}

.icofont-brand-nescafe:before {
  content: "\\ea1d";
}

.icofont-brand-nestle:before {
  content: "\\ea1e";
}

.icofont-brand-netflix:before {
  content: "\\ea1f";
}

.icofont-brand-nexus:before {
  content: "\\ea20";
}

.icofont-brand-nike:before {
  content: "\\ea21";
}

.icofont-brand-nokia:before {
  content: "\\ea22";
}

.icofont-brand-nvidia:before {
  content: "\\ea23";
}

.icofont-brand-omega:before {
  content: "\\ea24";
}

.icofont-brand-opensuse:before {
  content: "\\ea25";
}

.icofont-brand-oracle:before {
  content: "\\ea26";
}

.icofont-brand-panasonic:before {
  content: "\\ea27";
}

.icofont-brand-paypal:before {
  content: "\\ea28";
}

.icofont-brand-pepsi:before {
  content: "\\ea29";
}

.icofont-brand-philips:before {
  content: "\\ea2a";
}

.icofont-brand-pizza-hut:before {
  content: "\\ea2b";
}

.icofont-brand-playstation:before {
  content: "\\ea2c";
}

.icofont-brand-puma:before {
  content: "\\ea2d";
}

.icofont-brand-qatar-air:before {
  content: "\\ea2e";
}

.icofont-brand-qvc:before {
  content: "\\ea2f";
}

.icofont-brand-readernaut:before {
  content: "\\ea30";
}

.icofont-brand-redbull:before {
  content: "\\ea31";
}

.icofont-brand-reebok:before {
  content: "\\ea32";
}

.icofont-brand-reuters:before {
  content: "\\ea33";
}

.icofont-brand-samsung:before {
  content: "\\ea34";
}

.icofont-brand-sap:before {
  content: "\\ea35";
}

.icofont-brand-saudia-airlines:before {
  content: "\\ea36";
}

.icofont-brand-scribd:before {
  content: "\\ea37";
}

.icofont-brand-shell:before {
  content: "\\ea38";
}

.icofont-brand-siemens:before {
  content: "\\ea39";
}

.icofont-brand-sk-telecom:before {
  content: "\\ea3a";
}

.icofont-brand-slideshare:before {
  content: "\\ea3b";
}

.icofont-brand-smashing-magazine:before {
  content: "\\ea3c";
}

.icofont-brand-snapchat:before {
  content: "\\ea3d";
}

.icofont-brand-sony-ericsson:before {
  content: "\\ea3e";
}

.icofont-brand-sony:before {
  content: "\\ea3f";
}

.icofont-brand-soundcloud:before {
  content: "\\ea40";
}

.icofont-brand-sprint:before {
  content: "\\ea41";
}

.icofont-brand-squidoo:before {
  content: "\\ea42";
}

.icofont-brand-starbucks:before {
  content: "\\ea43";
}

.icofont-brand-stc:before {
  content: "\\ea44";
}

.icofont-brand-steam:before {
  content: "\\ea45";
}

.icofont-brand-suzuki:before {
  content: "\\ea46";
}

.icofont-brand-symbian:before {
  content: "\\ea47";
}

.icofont-brand-t-mobile:before {
  content: "\\ea48";
}

.icofont-brand-tango:before {
  content: "\\ea49";
}

.icofont-brand-target:before {
  content: "\\ea4a";
}

.icofont-brand-tata-indicom:before {
  content: "\\ea4b";
}

.icofont-brand-techcrunch:before {
  content: "\\ea4c";
}

.icofont-brand-telenor:before {
  content: "\\ea4d";
}

.icofont-brand-teliasonera:before {
  content: "\\ea4e";
}

.icofont-brand-tesla:before {
  content: "\\ea4f";
}

.icofont-brand-the-verge:before {
  content: "\\ea50";
}

.icofont-brand-thenextweb:before {
  content: "\\ea51";
}

.icofont-brand-toshiba:before {
  content: "\\ea52";
}

.icofont-brand-toyota:before {
  content: "\\ea53";
}

.icofont-brand-tribenet:before {
  content: "\\ea54";
}

.icofont-brand-ubuntu:before {
  content: "\\ea55";
}

.icofont-brand-unilever:before {
  content: "\\ea56";
}

.icofont-brand-vaio:before {
  content: "\\ea57";
}

.icofont-brand-verizon:before {
  content: "\\ea58";
}

.icofont-brand-viber:before {
  content: "\\ea59";
}

.icofont-brand-vodafone:before {
  content: "\\ea5a";
}

.icofont-brand-volkswagen:before {
  content: "\\ea5b";
}

.icofont-brand-walmart:before {
  content: "\\ea5c";
}

.icofont-brand-warnerbros:before {
  content: "\\ea5d";
}

.icofont-brand-whatsapp:before {
  content: "\\ea5e";
}

.icofont-brand-wikipedia:before {
  content: "\\ea5f";
}

.icofont-brand-windows:before {
  content: "\\ea60";
}

.icofont-brand-wire:before {
  content: "\\ea61";
}

.icofont-brand-yahoobuzz:before {
  content: "\\ea62";
}

.icofont-brand-yamaha:before {
  content: "\\ea63";
}

.icofont-brand-youtube:before {
  content: "\\ea64";
}

.icofont-brand-zain:before {
  content: "\\ea65";
}

.icofont-bank-alt:before {
  content: "\\ea66";
}

.icofont-barcode:before {
  content: "\\ea67";
}

.icofont-basket:before {
  content: "\\ea68";
}

.icofont-bill-alt:before {
  content: "\\ea69";
}

.icofont-billboard:before {
  content: "\\ea6a";
}

.icofont-briefcase-alt-1:before {
  content: "\\ea6b";
}

.icofont-briefcase-alt-2:before {
  content: "\\ea6c";
}

.icofont-building-alt:before {
  content: "\\ea6d";
}

.icofont-businessman:before {
  content: "\\ea6e";
}

.icofont-businesswoman:before {
  content: "\\ea6f";
}

.icofont-cart-alt:before {
  content: "\\ea70";
}

.icofont-chair:before {
  content: "\\ea71";
}

.icofont-clip:before {
  content: "\\ea72";
}

.icofont-coins:before {
  content: "\\ea73";
}

.icofont-company:before {
  content: "\\ea74";
}

.icofont-contact-add:before {
  content: "\\ea75";
}

.icofont-deal:before {
  content: "\\ea76";
}

.icofont-files:before {
  content: "\\ea77";
}

.icofont-growth:before {
  content: "\\ea78";
}

.icofont-id-card:before {
  content: "\\ea79";
}

.icofont-idea:before {
  content: "\\ea7a";
}

.icofont-list:before {
  content: "\\ea7b";
}

.icofont-meeting-add:before {
  content: "\\ea7c";
}

.icofont-money-bag:before {
  content: "\\ea7d";
}

.icofont-people:before {
  content: "\\ea7e";
}

.icofont-pie-chart:before {
  content: "\\ea7f";
}

.icofont-presentation-alt:before {
  content: "\\ea80";
}

.icofont-stamp:before {
  content: "\\ea81";
}

.icofont-stock-mobile:before {
  content: "\\ea82";
}

.icofont-support:before {
  content: "\\ea83";
}

.icofont-tasks-alt:before {
  content: "\\ea84";
}

.icofont-wheel:before {
  content: "\\ea85";
}

.icofont-chart-arrows-axis:before {
  content: "\\ea86";
}

.icofont-chart-bar-graph:before {
  content: "\\ea87";
}

.icofont-chart-flow-alt-1:before {
  content: "\\ea88";
}

.icofont-chart-flow-alt-2:before {
  content: "\\ea89";
}

.icofont-chart-flow:before {
  content: "\\ea8a";
}

.icofont-chart-histogram-alt:before {
  content: "\\ea8b";
}

.icofont-chart-histogram:before {
  content: "\\ea8c";
}

.icofont-chart-line-alt:before {
  content: "\\ea8d";
}

.icofont-chart-line:before {
  content: "\\ea8e";
}

.icofont-chart-pie-alt:before {
  content: "\\ea8f";
}

.icofont-chart-pie:before {
  content: "\\ea90";
}

.icofont-chart-radar-graph:before {
  content: "\\ea91";
}

.icofont-cur-afghani-false:before {
  content: "\\ea92";
}

.icofont-cur-afghani-minus:before {
  content: "\\ea93";
}

.icofont-cur-afghani-plus:before {
  content: "\\ea94";
}

.icofont-cur-afghani-true:before {
  content: "\\ea95";
}

.icofont-cur-afghani:before {
  content: "\\ea96";
}

.icofont-cur-baht-false:before {
  content: "\\ea97";
}

.icofont-cur-baht-minus:before {
  content: "\\ea98";
}

.icofont-cur-baht-plus:before {
  content: "\\ea99";
}

.icofont-cur-baht-true:before {
  content: "\\ea9a";
}

.icofont-cur-baht:before {
  content: "\\ea9b";
}

.icofont-cur-bitcoin-false:before {
  content: "\\ea9c";
}

.icofont-cur-bitcoin-minus:before {
  content: "\\ea9d";
}

.icofont-cur-bitcoin-plus:before {
  content: "\\ea9e";
}

.icofont-cur-bitcoin-true:before {
  content: "\\ea9f";
}

.icofont-cur-bitcoin:before {
  content: "\\eaa0";
}

.icofont-cur-dollar-flase:before {
  content: "\\eaa1";
}

.icofont-cur-dollar-minus:before {
  content: "\\eaa2";
}

.icofont-cur-dollar-plus:before {
  content: "\\eaa3";
}

.icofont-cur-dollar-true:before {
  content: "\\eaa4";
}

.icofont-cur-dollar:before {
  content: "\\eaa5";
}

.icofont-cur-dong-false:before {
  content: "\\eaa6";
}

.icofont-cur-dong-minus:before {
  content: "\\eaa7";
}

.icofont-cur-dong-plus:before {
  content: "\\eaa8";
}

.icofont-cur-dong-true:before {
  content: "\\eaa9";
}

.icofont-cur-dong:before {
  content: "\\eaaa";
}

.icofont-cur-euro-false:before {
  content: "\\eaab";
}

.icofont-cur-euro-minus:before {
  content: "\\eaac";
}

.icofont-cur-euro-plus:before {
  content: "\\eaad";
}

.icofont-cur-euro-true:before {
  content: "\\eaae";
}

.icofont-cur-euro:before {
  content: "\\eaaf";
}

.icofont-cur-frank-false:before {
  content: "\\eab0";
}

.icofont-cur-frank-minus:before {
  content: "\\eab1";
}

.icofont-cur-frank-plus:before {
  content: "\\eab2";
}

.icofont-cur-frank-true:before {
  content: "\\eab3";
}

.icofont-cur-frank:before {
  content: "\\eab4";
}

.icofont-cur-hryvnia-false:before {
  content: "\\eab5";
}

.icofont-cur-hryvnia-minus:before {
  content: "\\eab6";
}

.icofont-cur-hryvnia-plus:before {
  content: "\\eab7";
}

.icofont-cur-hryvnia-true:before {
  content: "\\eab8";
}

.icofont-cur-hryvnia:before {
  content: "\\eab9";
}

.icofont-cur-lira-false:before {
  content: "\\eaba";
}

.icofont-cur-lira-minus:before {
  content: "\\eabb";
}

.icofont-cur-lira-plus:before {
  content: "\\eabc";
}

.icofont-cur-lira-true:before {
  content: "\\eabd";
}

.icofont-cur-lira:before {
  content: "\\eabe";
}

.icofont-cur-peseta-false:before {
  content: "\\eabf";
}

.icofont-cur-peseta-minus:before {
  content: "\\eac0";
}

.icofont-cur-peseta-plus:before {
  content: "\\eac1";
}

.icofont-cur-peseta-true:before {
  content: "\\eac2";
}

.icofont-cur-peseta:before {
  content: "\\eac3";
}

.icofont-cur-peso-false:before {
  content: "\\eac4";
}

.icofont-cur-peso-minus:before {
  content: "\\eac5";
}

.icofont-cur-peso-plus:before {
  content: "\\eac6";
}

.icofont-cur-peso-true:before {
  content: "\\eac7";
}

.icofont-cur-peso:before {
  content: "\\eac8";
}

.icofont-cur-pound-false:before {
  content: "\\eac9";
}

.icofont-cur-pound-minus:before {
  content: "\\eaca";
}

.icofont-cur-pound-plus:before {
  content: "\\eacb";
}

.icofont-cur-pound-true:before {
  content: "\\eacc";
}

.icofont-cur-pound:before {
  content: "\\eacd";
}

.icofont-cur-renminbi-false:before {
  content: "\\eace";
}

.icofont-cur-renminbi-minus:before {
  content: "\\eacf";
}

.icofont-cur-renminbi-plus:before {
  content: "\\ead0";
}

.icofont-cur-renminbi-true:before {
  content: "\\ead1";
}

.icofont-cur-renminbi:before {
  content: "\\ead2";
}

.icofont-cur-riyal-false:before {
  content: "\\ead3";
}

.icofont-cur-riyal-minus:before {
  content: "\\ead4";
}

.icofont-cur-riyal-plus:before {
  content: "\\ead5";
}

.icofont-cur-riyal-true:before {
  content: "\\ead6";
}

.icofont-cur-riyal:before {
  content: "\\ead7";
}

.icofont-cur-rouble-false:before {
  content: "\\ead8";
}

.icofont-cur-rouble-minus:before {
  content: "\\ead9";
}

.icofont-cur-rouble-plus:before {
  content: "\\eada";
}

.icofont-cur-rouble-true:before {
  content: "\\eadb";
}

.icofont-cur-rouble:before {
  content: "\\eadc";
}

.icofont-cur-rupee-false:before {
  content: "\\eadd";
}

.icofont-cur-rupee-minus:before {
  content: "\\eade";
}

.icofont-cur-rupee-plus:before {
  content: "\\eadf";
}

.icofont-cur-rupee-true:before {
  content: "\\eae0";
}

.icofont-cur-rupee:before {
  content: "\\eae1";
}

.icofont-cur-taka-false:before {
  content: "\\eae2";
}

.icofont-cur-taka-minus:before {
  content: "\\eae3";
}

.icofont-cur-taka-plus:before {
  content: "\\eae4";
}

.icofont-cur-taka-true:before {
  content: "\\eae5";
}

.icofont-cur-taka:before {
  content: "\\eae6";
}

.icofont-cur-turkish-lira-false:before {
  content: "\\eae7";
}

.icofont-cur-turkish-lira-minus:before {
  content: "\\eae8";
}

.icofont-cur-turkish-lira-plus:before {
  content: "\\eae9";
}

.icofont-cur-turkish-lira-true:before {
  content: "\\eaea";
}

.icofont-cur-turkish-lira:before {
  content: "\\eaeb";
}

.icofont-cur-won-false:before {
  content: "\\eaec";
}

.icofont-cur-won-minus:before {
  content: "\\eaed";
}

.icofont-cur-won-plus:before {
  content: "\\eaee";
}

.icofont-cur-won-true:before {
  content: "\\eaef";
}

.icofont-cur-won:before {
  content: "\\eaf0";
}

.icofont-cur-yen-false:before {
  content: "\\eaf1";
}

.icofont-cur-yen-minus:before {
  content: "\\eaf2";
}

.icofont-cur-yen-plus:before {
  content: "\\eaf3";
}

.icofont-cur-yen-true:before {
  content: "\\eaf4";
}

.icofont-cur-yen:before {
  content: "\\eaf5";
}

.icofont-android-nexus:before {
  content: "\\eaf6";
}

.icofont-android-tablet:before {
  content: "\\eaf7";
}

.icofont-apple-watch:before {
  content: "\\eaf8";
}

.icofont-drwaing-tablet:before {
  content: "\\eaf9";
}

.icofont-earphone:before {
  content: "\\eafa";
}

.icofont-flash-drive:before {
  content: "\\eafb";
}

.icofont-game-control:before {
  content: "\\eafc";
}

.icofont-headphone-alt:before {
  content: "\\eafd";
}

.icofont-htc-one:before {
  content: "\\eafe";
}

.icofont-imac:before {
  content: "\\eaff";
}

.icofont-ipad-touch:before {
  content: "\\eb00";
}

.icofont-iphone:before {
  content: "\\eb01";
}

.icofont-ipod-nano:before {
  content: "\\eb02";
}

.icofont-ipod-touch:before {
  content: "\\eb03";
}

.icofont-keyboard-alt:before {
  content: "\\eb04";
}

.icofont-keyboard-wireless:before {
  content: "\\eb05";
}

.icofont-laptop-alt:before {
  content: "\\eb06";
}

.icofont-macbook:before {
  content: "\\eb07";
}

.icofont-magic-mouse:before {
  content: "\\eb08";
}

.icofont-microphone-alt:before {
  content: "\\eb09";
}

.icofont-monitor:before {
  content: "\\eb0a";
}

.icofont-mouse:before {
  content: "\\eb0b";
}

.icofont-nintendo:before {
  content: "\\eb0c";
}

.icofont-playstation:before {
  content: "\\eb0d";
}

.icofont-psvita:before {
  content: "\\eb0e";
}

.icofont-radio-mic:before {
  content: "\\eb0f";
}

.icofont-refrigerator:before {
  content: "\\eb10";
}

.icofont-samsung-galaxy:before {
  content: "\\eb11";
}

.icofont-surface-tablet:before {
  content: "\\eb12";
}

.icofont-washing-machine:before {
  content: "\\eb13";
}

.icofont-wifi-router:before {
  content: "\\eb14";
}

.icofont-wii-u:before {
  content: "\\eb15";
}

.icofont-windows-lumia:before {
  content: "\\eb16";
}

.icofont-wireless-mouse:before {
  content: "\\eb17";
}

.icofont-xbox-360:before {
  content: "\\eb18";
}

.icofont-arrow-down:before {
  content: "\\eb19";
}

.icofont-arrow-left:before {
  content: "\\eb1a";
}

.icofont-arrow-right:before {
  content: "\\eb1b";
}

.icofont-arrow-up:before {
  content: "\\eb1c";
}

.icofont-block-down:before {
  content: "\\eb1d";
}

.icofont-block-left:before {
  content: "\\eb1e";
}

.icofont-block-right:before {
  content: "\\eb1f";
}

.icofont-block-up:before {
  content: "\\eb20";
}

.icofont-bubble-down:before {
  content: "\\eb21";
}

.icofont-bubble-left:before {
  content: "\\eb22";
}

.icofont-bubble-right:before {
  content: "\\eb23";
}

.icofont-bubble-up:before {
  content: "\\eb24";
}

.icofont-caret-down:before {
  content: "\\eb25";
}

.icofont-caret-left:before {
  content: "\\eb26";
}

.icofont-caret-right:before {
  content: "\\eb27";
}

.icofont-caret-up:before {
  content: "\\eb28";
}

.icofont-circled-down:before {
  content: "\\eb29";
}

.icofont-circled-left:before {
  content: "\\eb2a";
}

.icofont-circled-right:before {
  content: "\\eb2b";
}

.icofont-circled-up:before {
  content: "\\eb2c";
}

.icofont-collapse:before {
  content: "\\eb2d";
}

.icofont-cursor-drag:before {
  content: "\\eb2e";
}

.icofont-curved-double-left:before {
  content: "\\eb2f";
}

.icofont-curved-double-right:before {
  content: "\\eb30";
}

.icofont-curved-down:before {
  content: "\\eb31";
}

.icofont-curved-left:before {
  content: "\\eb32";
}

.icofont-curved-right:before {
  content: "\\eb33";
}

.icofont-curved-up:before {
  content: "\\eb34";
}

.icofont-dotted-down:before {
  content: "\\eb35";
}

.icofont-dotted-left:before {
  content: "\\eb36";
}

.icofont-dotted-right:before {
  content: "\\eb37";
}

.icofont-dotted-up:before {
  content: "\\eb38";
}

.icofont-double-left:before {
  content: "\\eb39";
}

.icofont-double-right:before {
  content: "\\eb3a";
}

.icofont-drag:before {
  content: "\\eb3b";
}

.icofont-drag1:before {
  content: "\\eb3c";
}

.icofont-drag2:before {
  content: "\\eb3d";
}

.icofont-drag3:before {
  content: "\\eb3e";
}

.icofont-expand-alt:before {
  content: "\\eb3f";
}

.icofont-hand-down:before {
  content: "\\eb40";
}

.icofont-hand-drag:before {
  content: "\\eb41";
}

.icofont-hand-drag1:before {
  content: "\\eb42";
}

.icofont-hand-drag2:before {
  content: "\\eb43";
}

.icofont-hand-drawn-alt-down:before {
  content: "\\eb44";
}

.icofont-hand-drawn-alt-left:before {
  content: "\\eb45";
}

.icofont-hand-drawn-alt-right:before {
  content: "\\eb46";
}

.icofont-hand-drawn-alt-up:before {
  content: "\\eb47";
}

.icofont-hand-drawn-down:before {
  content: "\\eb48";
}

.icofont-hand-drawn-left:before {
  content: "\\eb49";
}

.icofont-hand-drawn-right:before {
  content: "\\eb4a";
}

.icofont-hand-drawn-up:before {
  content: "\\eb4b";
}

.icofont-hand-left:before {
  content: "\\eb4c";
}

.icofont-hand-right:before {
  content: "\\eb4d";
}

.icofont-hand-up:before {
  content: "\\eb4e";
}

.icofont-line-block-down:before {
  content: "\\eb4f";
}

.icofont-line-block-left:before {
  content: "\\eb50";
}

.icofont-line-block-right:before {
  content: "\\eb51";
}

.icofont-line-block-up:before {
  content: "\\eb52";
}

.icofont-long-arrow-down:before {
  content: "\\eb53";
}

.icofont-long-arrow-left:before {
  content: "\\eb54";
}

.icofont-long-arrow-right:before {
  content: "\\eb55";
}

.icofont-long-arrow-up:before {
  content: "\\eb56";
}

.icofont-rounded-collapse:before {
  content: "\\eb57";
}

.icofont-rounded-double-left:before {
  content: "\\eb58";
}

.icofont-rounded-double-right:before {
  content: "\\eb59";
}

.icofont-rounded-down:before {
  content: "\\eb5a";
}

.icofont-rounded-expand:before {
  content: "\\eb5b";
}

.icofont-rounded-left-down:before {
  content: "\\eb5c";
}

.icofont-rounded-left-up:before {
  content: "\\eb5d";
}

.icofont-rounded-left:before {
  content: "\\eb5e";
}

.icofont-rounded-right-down:before {
  content: "\\eb5f";
}

.icofont-rounded-right-up:before {
  content: "\\eb60";
}

.icofont-rounded-right:before {
  content: "\\eb61";
}

.icofont-rounded-up:before {
  content: "\\eb62";
}

.icofont-scroll-bubble-down:before {
  content: "\\eb63";
}

.icofont-scroll-bubble-left:before {
  content: "\\eb64";
}

.icofont-scroll-bubble-right:before {
  content: "\\eb65";
}

.icofont-scroll-bubble-up:before {
  content: "\\eb66";
}

.icofont-scroll-double-down:before {
  content: "\\eb67";
}

.icofont-scroll-double-left:before {
  content: "\\eb68";
}

.icofont-scroll-double-right:before {
  content: "\\eb69";
}

.icofont-scroll-double-up:before {
  content: "\\eb6a";
}

.icofont-scroll-down:before {
  content: "\\eb6b";
}

.icofont-scroll-left:before {
  content: "\\eb6c";
}

.icofont-scroll-long-down:before {
  content: "\\eb6d";
}

.icofont-scroll-long-left:before {
  content: "\\eb6e";
}

.icofont-scroll-long-right:before {
  content: "\\eb6f";
}

.icofont-scroll-long-up:before {
  content: "\\eb70";
}

.icofont-scroll-right:before {
  content: "\\eb71";
}

.icofont-scroll-up:before {
  content: "\\eb72";
}

.icofont-simple-down:before {
  content: "\\eb73";
}

.icofont-simple-left-down:before {
  content: "\\eb74";
}

.icofont-simple-left-up:before {
  content: "\\eb75";
}

.icofont-simple-left:before {
  content: "\\eb76";
}

.icofont-simple-right-down:before {
  content: "\\eb77";
}

.icofont-simple-right-up:before {
  content: "\\eb78";
}

.icofont-simple-right:before {
  content: "\\eb79";
}

.icofont-simple-up:before {
  content: "\\eb7a";
}

.icofont-square-down:before {
  content: "\\eb7b";
}

.icofont-square-left:before {
  content: "\\eb7c";
}

.icofont-square-right:before {
  content: "\\eb7d";
}

.icofont-square-up:before {
  content: "\\eb7e";
}

.icofont-stylish-down:before {
  content: "\\eb7f";
}

.icofont-stylish-left:before {
  content: "\\eb80";
}

.icofont-stylish-right:before {
  content: "\\eb81";
}

.icofont-stylish-up:before {
  content: "\\eb82";
}

.icofont-swoosh-down:before {
  content: "\\eb83";
}

.icofont-swoosh-left:before {
  content: "\\eb84";
}

.icofont-swoosh-right:before {
  content: "\\eb85";
}

.icofont-swoosh-up:before {
  content: "\\eb86";
}

.icofont-thin-double-left:before {
  content: "\\eb87";
}

.icofont-thin-double-right:before {
  content: "\\eb88";
}

.icofont-thin-down:before {
  content: "\\eb89";
}

.icofont-thin-left:before {
  content: "\\eb8a";
}

.icofont-thin-right:before {
  content: "\\eb8b";
}

.icofont-thin-up:before {
  content: "\\eb8c";
}

.icofont-atom:before {
  content: "\\eb8d";
}

.icofont-award:before {
  content: "\\eb8e";
}

.icofont-bell-alt:before {
  content: "\\eb8f";
}

.icofont-book-alt:before {
  content: "\\eb90";
}

.icofont-brainstorming:before {
  content: "\\eb91";
}

.icofont-certificate-alt-1:before {
  content: "\\eb92";
}

.icofont-certificate-alt-2:before {
  content: "\\eb93";
}

.icofont-dna-alt-2:before {
  content: "\\eb94";
}

.icofont-education:before {
  content: "\\eb95";
}

.icofont-electron:before {
  content: "\\eb96";
}

.icofont-fountain-pen:before {
  content: "\\eb97";
}

.icofont-globe-alt:before {
  content: "\\eb98";
}

.icofont-graduate-alt:before {
  content: "\\eb99";
}

.icofont-group-students:before {
  content: "\\eb9a";
}

.icofont-hat-alt:before {
  content: "\\eb9b";
}

.icofont-hat:before {
  content: "\\eb9c";
}

.icofont-instrument:before {
  content: "\\eb9d";
}

.icofont-lamp-light:before {
  content: "\\eb9e";
}

.icofont-microscope-alt:before {
  content: "\\eb9f";
}

.icofont-paper:before {
  content: "\\eba0";
}

.icofont-pen-alt-4:before {
  content: "\\eba1";
}

.icofont-pen-nib:before {
  content: "\\eba2";
}

.icofont-pencil-alt-5:before {
  content: "\\eba3";
}

.icofont-quill-pen:before {
  content: "\\eba4";
}

.icofont-read-book-alt:before {
  content: "\\eba5";
}

.icofont-read-book:before {
  content: "\\eba6";
}

.icofont-school-bag:before {
  content: "\\eba7";
}

.icofont-school-bus:before {
  content: "\\eba8";
}

.icofont-student-alt:before {
  content: "\\eba9";
}

.icofont-student:before {
  content: "\\ebaa";
}

.icofont-teacher:before {
  content: "\\ebab";
}

.icofont-test-bulb:before {
  content: "\\ebac";
}

.icofont-test-tube-alt:before {
  content: "\\ebad";
}

.icofont-university:before {
  content: "\\ebae";
}

.icofont-emo-angry:before {
  content: "\\ebaf";
}

.icofont-emo-astonished:before {
  content: "\\ebb0";
}

.icofont-emo-confounded:before {
  content: "\\ebb1";
}

.icofont-emo-confused:before {
  content: "\\ebb2";
}

.icofont-emo-crying:before {
  content: "\\ebb3";
}

.icofont-emo-dizzy:before {
  content: "\\ebb4";
}

.icofont-emo-expressionless:before {
  content: "\\ebb5";
}

.icofont-emo-heart-eyes:before {
  content: "\\ebb6";
}

.icofont-emo-laughing:before {
  content: "\\ebb7";
}

.icofont-emo-nerd-smile:before {
  content: "\\ebb8";
}

.icofont-emo-open-mouth:before {
  content: "\\ebb9";
}

.icofont-emo-rage:before {
  content: "\\ebba";
}

.icofont-emo-rolling-eyes:before {
  content: "\\ebbb";
}

.icofont-emo-sad:before {
  content: "\\ebbc";
}

.icofont-emo-simple-smile:before {
  content: "\\ebbd";
}

.icofont-emo-slightly-smile:before {
  content: "\\ebbe";
}

.icofont-emo-smirk:before {
  content: "\\ebbf";
}

.icofont-emo-stuck-out-tongue:before {
  content: "\\ebc0";
}

.icofont-emo-wink-smile:before {
  content: "\\ebc1";
}

.icofont-emo-worried:before {
  content: "\\ebc2";
}

.icofont-architecture-alt:before {
  content: "\\ebc3";
}

.icofont-architecture:before {
  content: "\\ebc4";
}

.icofont-barricade:before {
  content: "\\ebc5";
}

.icofont-bricks:before {
  content: "\\ebc6";
}

.icofont-calculations:before {
  content: "\\ebc7";
}

.icofont-cement-mix:before {
  content: "\\ebc8";
}

.icofont-cement-mixer:before {
  content: "\\ebc9";
}

.icofont-danger-zone:before {
  content: "\\ebca";
}

.icofont-drill:before {
  content: "\\ebcb";
}

.icofont-eco-energy:before {
  content: "\\ebcc";
}

.icofont-eco-environmen:before {
  content: "\\ebcd";
}

.icofont-energy-air:before {
  content: "\\ebce";
}

.icofont-energy-oil:before {
  content: "\\ebcf";
}

.icofont-energy-savings:before {
  content: "\\ebd0";
}

.icofont-energy-solar:before {
  content: "\\ebd1";
}

.icofont-energy-water:before {
  content: "\\ebd2";
}

.icofont-engineer:before {
  content: "\\ebd3";
}

.icofont-fire-extinguisher-alt:before {
  content: "\\ebd4";
}

.icofont-fix-tools:before {
  content: "\\ebd5";
}

.icofont-glue-oil:before {
  content: "\\ebd6";
}

.icofont-hammer-alt:before {
  content: "\\ebd7";
}

.icofont-help-robot:before {
  content: "\\ebd8";
}

.icofont-industries-alt-1:before {
  content: "\\ebd9";
}

.icofont-industries-alt-2:before {
  content: "\\ebda";
}

.icofont-industries-alt-3:before {
  content: "\\ebdb";
}

.icofont-industries-alt-4:before {
  content: "\\ebdc";
}

.icofont-industries-alt-5:before {
  content: "\\ebdd";
}

.icofont-industries:before {
  content: "\\ebde";
}

.icofont-labour:before {
  content: "\\ebdf";
}

.icofont-mining:before {
  content: "\\ebe0";
}

.icofont-paint-brush:before {
  content: "\\ebe1";
}

.icofont-pollution:before {
  content: "\\ebe2";
}

.icofont-power-zone:before {
  content: "\\ebe3";
}

.icofont-radio-active:before {
  content: "\\ebe4";
}

.icofont-recycle-alt:before {
  content: "\\ebe5";
}

.icofont-recycling-man:before {
  content: "\\ebe6";
}

.icofont-safety-hat-light:before {
  content: "\\ebe7";
}

.icofont-safety-hat:before {
  content: "\\ebe8";
}

.icofont-saw:before {
  content: "\\ebe9";
}

.icofont-screw-driver:before {
  content: "\\ebea";
}

.icofont-settings-alt:before {
  content: "\\ebeb";
}

.icofont-tools-alt-1:before {
  content: "\\ebec";
}

.icofont-tools-alt-2:before {
  content: "\\ebed";
}

.icofont-tools-bag:before {
  content: "\\ebee";
}

.icofont-trolley:before {
  content: "\\ebef";
}

.icofont-trowel:before {
  content: "\\ebf0";
}

.icofont-under-construction-alt:before {
  content: "\\ebf1";
}

.icofont-under-construction:before {
  content: "\\ebf2";
}

.icofont-vehicle-cement:before {
  content: "\\ebf3";
}

.icofont-vehicle-crane:before {
  content: "\\ebf4";
}

.icofont-vehicle-delivery-van:before {
  content: "\\ebf5";
}

.icofont-vehicle-dozer:before {
  content: "\\ebf6";
}

.icofont-vehicle-excavator:before {
  content: "\\ebf7";
}

.icofont-vehicle-trucktor:before {
  content: "\\ebf8";
}

.icofont-vehicle-wrecking:before {
  content: "\\ebf9";
}

.icofont-worker-group:before {
  content: "\\ebfa";
}

.icofont-worker:before {
  content: "\\ebfb";
}

.icofont-wrench:before {
  content: "\\ebfc";
}

.icofont-file-audio:before {
  content: "\\ebfd";
}

.icofont-file-avi-mp4:before {
  content: "\\ebfe";
}

.icofont-file-bmp:before {
  content: "\\ebff";
}

.icofont-file-code:before {
  content: "\\ec00";
}

.icofont-file-css:before {
  content: "\\ec01";
}

.icofont-file-document:before {
  content: "\\ec02";
}

.icofont-file-eps:before {
  content: "\\ec03";
}

.icofont-file-excel:before {
  content: "\\ec04";
}

.icofont-file-exe:before {
  content: "\\ec05";
}

.icofont-file-file:before {
  content: "\\ec06";
}

.icofont-file-flv:before {
  content: "\\ec07";
}

.icofont-file-gif:before {
  content: "\\ec08";
}

.icofont-file-html5:before {
  content: "\\ec09";
}

.icofont-file-image:before {
  content: "\\ec0a";
}

.icofont-file-iso:before {
  content: "\\ec0b";
}

.icofont-file-java:before {
  content: "\\ec0c";
}

.icofont-file-javascript:before {
  content: "\\ec0d";
}

.icofont-file-jpg:before {
  content: "\\ec0e";
}

.icofont-file-midi:before {
  content: "\\ec0f";
}

.icofont-file-mov:before {
  content: "\\ec10";
}

.icofont-file-mp3:before {
  content: "\\ec11";
}

.icofont-file-pdf:before {
  content: "\\ec12";
}

.icofont-file-php:before {
  content: "\\ec13";
}

.icofont-file-png:before {
  content: "\\ec14";
}

.icofont-file-powerpoint:before {
  content: "\\ec15";
}

.icofont-file-presentation:before {
  content: "\\ec16";
}

.icofont-file-psb:before {
  content: "\\ec17";
}

.icofont-file-psd:before {
  content: "\\ec18";
}

.icofont-file-python:before {
  content: "\\ec19";
}

.icofont-file-ruby:before {
  content: "\\ec1a";
}

.icofont-file-spreadsheet:before {
  content: "\\ec1b";
}

.icofont-file-sql:before {
  content: "\\ec1c";
}

.icofont-file-svg:before {
  content: "\\ec1d";
}

.icofont-file-text:before {
  content: "\\ec1e";
}

.icofont-file-tiff:before {
  content: "\\ec1f";
}

.icofont-file-video:before {
  content: "\\ec20";
}

.icofont-file-wave:before {
  content: "\\ec21";
}

.icofont-file-wmv:before {
  content: "\\ec22";
}

.icofont-file-word:before {
  content: "\\ec23";
}

.icofont-file-zip:before {
  content: "\\ec24";
}

.icofont-apple:before {
  content: "\\ec25";
}

.icofont-arabian-coffee:before {
  content: "\\ec26";
}

.icofont-artichoke:before {
  content: "\\ec27";
}

.icofont-asparagus:before {
  content: "\\ec28";
}

.icofont-avocado:before {
  content: "\\ec29";
}

.icofont-baby-food:before {
  content: "\\ec2a";
}

.icofont-banana:before {
  content: "\\ec2b";
}

.icofont-bbq:before {
  content: "\\ec2c";
}

.icofont-beans:before {
  content: "\\ec2d";
}

.icofont-beer:before {
  content: "\\ec2e";
}

.icofont-bell-pepper-capsicum:before {
  content: "\\ec2f";
}

.icofont-birthday-cake:before {
  content: "\\ec30";
}

.icofont-bread:before {
  content: "\\ec31";
}

.icofont-broccoli:before {
  content: "\\ec32";
}

.icofont-burger:before {
  content: "\\ec33";
}

.icofont-cabbage:before {
  content: "\\ec34";
}

.icofont-carrot:before {
  content: "\\ec35";
}

.icofont-cauli-flower:before {
  content: "\\ec36";
}

.icofont-cheese:before {
  content: "\\ec37";
}

.icofont-chef:before {
  content: "\\ec38";
}

.icofont-cherry:before {
  content: "\\ec39";
}

.icofont-chicken-fry:before {
  content: "\\ec3a";
}

.icofont-chicken:before {
  content: "\\ec3b";
}

.icofont-cocktail:before {
  content: "\\ec3c";
}

.icofont-coconut:before {
  content: "\\ec3d";
}

.icofont-coffee-alt:before {
  content: "\\ec3e";
}

.icofont-coffee-mug:before {
  content: "\\ec3f";
}

.icofont-coffee-pot:before {
  content: "\\ec40";
}

.icofont-cola:before {
  content: "\\ec41";
}

.icofont-corn:before {
  content: "\\ec42";
}

.icofont-croissant:before {
  content: "\\ec43";
}

.icofont-crop-plant:before {
  content: "\\ec44";
}

.icofont-cucumber:before {
  content: "\\ec45";
}

.icofont-cup-cake:before {
  content: "\\ec46";
}

.icofont-dining-table:before {
  content: "\\ec47";
}

.icofont-donut:before {
  content: "\\ec48";
}

.icofont-egg-plant:before {
  content: "\\ec49";
}

.icofont-egg-poached:before {
  content: "\\ec4a";
}

.icofont-farmer:before {
  content: "\\ec4b";
}

.icofont-farmer1:before {
  content: "\\ec4c";
}

.icofont-fast-food:before {
  content: "\\ec4d";
}

.icofont-fish:before {
  content: "\\ec4e";
}

.icofont-food-basket:before {
  content: "\\ec4f";
}

.icofont-food-cart:before {
  content: "\\ec50";
}

.icofont-fork-and-knife:before {
  content: "\\ec51";
}

.icofont-french-fries:before {
  content: "\\ec52";
}

.icofont-fresh-juice:before {
  content: "\\ec53";
}

.icofont-fruits:before {
  content: "\\ec54";
}

.icofont-grapes:before {
  content: "\\ec55";
}

.icofont-honey:before {
  content: "\\ec56";
}

.icofont-hot-dog:before {
  content: "\\ec57";
}

.icofont-hotel-alt:before {
  content: "\\ec58";
}

.icofont-ice-cream-alt:before {
  content: "\\ec59";
}

.icofont-ice-cream:before {
  content: "\\ec5a";
}

.icofont-ketchup:before {
  content: "\\ec5b";
}

.icofont-kiwi:before {
  content: "\\ec5c";
}

.icofont-layered-cake:before {
  content: "\\ec5d";
}

.icofont-lemon-alt:before {
  content: "\\ec5e";
}

.icofont-lobster:before {
  content: "\\ec5f";
}

.icofont-mango:before {
  content: "\\ec60";
}

.icofont-milk:before {
  content: "\\ec61";
}

.icofont-mushroom:before {
  content: "\\ec62";
}

.icofont-noodles:before {
  content: "\\ec63";
}

.icofont-onion:before {
  content: "\\ec64";
}

.icofont-orange:before {
  content: "\\ec65";
}

.icofont-pear:before {
  content: "\\ec66";
}

.icofont-peas:before {
  content: "\\ec67";
}

.icofont-pepper:before {
  content: "\\ec68";
}

.icofont-pie-alt:before {
  content: "\\ec69";
}

.icofont-pineapple:before {
  content: "\\ec6a";
}

.icofont-pizza-slice:before {
  content: "\\ec6b";
}

.icofont-pizza:before {
  content: "\\ec6c";
}

.icofont-plant:before {
  content: "\\ec6d";
}

.icofont-popcorn:before {
  content: "\\ec6e";
}

.icofont-potato:before {
  content: "\\ec6f";
}

.icofont-pumpkin:before {
  content: "\\ec70";
}

.icofont-raddish:before {
  content: "\\ec71";
}

.icofont-restaurant-menu:before {
  content: "\\ec72";
}

.icofont-restaurant:before {
  content: "\\ec73";
}

.icofont-salt-and-pepper:before {
  content: "\\ec74";
}

.icofont-sandwich:before {
  content: "\\ec75";
}

.icofont-sausage:before {
  content: "\\ec76";
}

.icofont-shrimp:before {
  content: "\\ec77";
}

.icofont-sof-drinks:before {
  content: "\\ec78";
}

.icofont-soup-bowl:before {
  content: "\\ec79";
}

.icofont-spoon-and-fork:before {
  content: "\\ec7a";
}

.icofont-steak:before {
  content: "\\ec7b";
}

.icofont-strawberry:before {
  content: "\\ec7c";
}

.icofont-sub-sandwich:before {
  content: "\\ec7d";
}

.icofont-sushi:before {
  content: "\\ec7e";
}

.icofont-taco:before {
  content: "\\ec7f";
}

.icofont-tea-pot:before {
  content: "\\ec80";
}

.icofont-tea:before {
  content: "\\ec81";
}

.icofont-tomato:before {
  content: "\\ec82";
}

.icofont-waiter-alt:before {
  content: "\\ec83";
}

.icofont-watermelon:before {
  content: "\\ec84";
}

.icofont-wheat:before {
  content: "\\ec85";
}

.icofont-abc:before {
  content: "\\ec86";
}

.icofont-baby-cloth:before {
  content: "\\ec87";
}

.icofont-baby-milk-bottle:before {
  content: "\\ec88";
}

.icofont-baby-trolley:before {
  content: "\\ec89";
}

.icofont-back-pack:before {
  content: "\\ec8a";
}

.icofont-candy:before {
  content: "\\ec8b";
}

.icofont-cycling:before {
  content: "\\ec8c";
}

.icofont-holding-hands:before {
  content: "\\ec8d";
}

.icofont-infant-nipple:before {
  content: "\\ec8e";
}

.icofont-kids-scooter:before {
  content: "\\ec8f";
}

.icofont-safety-pin:before {
  content: "\\ec90";
}

.icofont-teddy-bear:before {
  content: "\\ec91";
}

.icofont-toy-ball:before {
  content: "\\ec92";
}

.icofont-toy-cat:before {
  content: "\\ec93";
}

.icofont-toy-duck:before {
  content: "\\ec94";
}

.icofont-toy-elephant:before {
  content: "\\ec95";
}

.icofont-toy-hand:before {
  content: "\\ec96";
}

.icofont-toy-horse:before {
  content: "\\ec97";
}

.icofont-toy-lattu:before {
  content: "\\ec98";
}

.icofont-toy-train:before {
  content: "\\ec99";
}

.icofont-unique-idea:before {
  content: "\\ec9a";
}

.icofont-bag-alt:before {
  content: "\\ec9b";
}

.icofont-burglar:before {
  content: "\\ec9c";
}

.icofont-cannon-firing:before {
  content: "\\ec9d";
}

.icofont-cc-camera:before {
  content: "\\ec9e";
}

.icofont-cop-badge:before {
  content: "\\ec9f";
}

.icofont-cop:before {
  content: "\\eca0";
}

.icofont-court-hammer:before {
  content: "\\eca1";
}

.icofont-court:before {
  content: "\\eca2";
}

.icofont-finger-print:before {
  content: "\\eca3";
}

.icofont-handcuff-alt:before {
  content: "\\eca4";
}

.icofont-handcuff:before {
  content: "\\eca5";
}

.icofont-investigation:before {
  content: "\\eca6";
}

.icofont-investigator:before {
  content: "\\eca7";
}

.icofont-jail:before {
  content: "\\eca8";
}

.icofont-judge:before {
  content: "\\eca9";
}

.icofont-law-alt-1:before {
  content: "\\ecaa";
}

.icofont-law-alt-2:before {
  content: "\\ecab";
}

.icofont-law-alt-3:before {
  content: "\\ecac";
}

.icofont-law-book:before {
  content: "\\ecad";
}

.icofont-law-document:before {
  content: "\\ecae";
}

.icofont-law:before {
  content: "\\ecaf";
}

.icofont-lawyer-alt-1:before {
  content: "\\ecb0";
}

.icofont-lawyer-alt-2:before {
  content: "\\ecb1";
}

.icofont-lawyer:before {
  content: "\\ecb2";
}

.icofont-order:before {
  content: "\\ecb3";
}

.icofont-pistol:before {
  content: "\\ecb4";
}

.icofont-police-badge:before {
  content: "\\ecb5";
}

.icofont-police-cap:before {
  content: "\\ecb6";
}

.icofont-police-car-alt-1:before {
  content: "\\ecb7";
}

.icofont-police-car-alt-2:before {
  content: "\\ecb8";
}

.icofont-police-hat:before {
  content: "\\ecb9";
}

.icofont-police-van:before {
  content: "\\ecba";
}

.icofont-police:before {
  content: "\\ecbb";
}

.icofont-protect:before {
  content: "\\ecbc";
}

.icofont-scales:before {
  content: "\\ecbd";
}

.icofont-thief-alt:before {
  content: "\\ecbe";
}

.icofont-thief:before {
  content: "\\ecbf";
}

.icofont-abacus-alt:before {
  content: "\\ecc0";
}

.icofont-abacus:before {
  content: "\\ecc1";
}

.icofont-angle:before {
  content: "\\ecc2";
}

.icofont-calculator-alt-1:before {
  content: "\\ecc3";
}

.icofont-calculator-alt-2:before {
  content: "\\ecc4";
}

.icofont-circle-ruler-alt:before {
  content: "\\ecc5";
}

.icofont-circle-ruler:before {
  content: "\\ecc6";
}

.icofont-compass-alt-1:before {
  content: "\\ecc7";
}

.icofont-compass-alt-2:before {
  content: "\\ecc8";
}

.icofont-compass-alt-3:before {
  content: "\\ecc9";
}

.icofont-compass-alt-4:before {
  content: "\\ecca";
}

.icofont-degrees-alt-1:before {
  content: "\\eccb";
}

.icofont-degrees-alt-2:before {
  content: "\\eccc";
}

.icofont-degrees:before {
  content: "\\eccd";
}

.icofont-golden-ratio:before {
  content: "\\ecce";
}

.icofont-marker-alt-1:before {
  content: "\\eccf";
}

.icofont-marker-alt-2:before {
  content: "\\ecd0";
}

.icofont-marker-alt-3:before {
  content: "\\ecd1";
}

.icofont-mathematical-alt-1:before {
  content: "\\ecd2";
}

.icofont-mathematical-alt-2:before {
  content: "\\ecd3";
}

.icofont-mathematical:before {
  content: "\\ecd4";
}

.icofont-pen-alt-1:before {
  content: "\\ecd5";
}

.icofont-pen-alt-2:before {
  content: "\\ecd6";
}

.icofont-pen-alt-3:before {
  content: "\\ecd7";
}

.icofont-pen-holder-alt-1:before {
  content: "\\ecd8";
}

.icofont-pen-holder:before {
  content: "\\ecd9";
}

.icofont-pencil-alt-1:before {
  content: "\\ecda";
}

.icofont-pencil-alt-2:before {
  content: "\\ecdb";
}

.icofont-pencil-alt-3:before {
  content: "\\ecdc";
}

.icofont-pencil-alt-4:before {
  content: "\\ecdd";
}

.icofont-ruler-alt-1:before {
  content: "\\ecde";
}

.icofont-ruler-alt-2:before {
  content: "\\ecdf";
}

.icofont-ruler-compass-alt:before {
  content: "\\ece0";
}

.icofont-ruler-compass:before {
  content: "\\ece1";
}

.icofont-ruler-pencil-alt-1:before {
  content: "\\ece2";
}

.icofont-ruler-pencil-alt-2:before {
  content: "\\ece3";
}

.icofont-ruler-pencil:before {
  content: "\\ece4";
}

.icofont-ruler:before {
  content: "\\ece5";
}

.icofont-rulers-alt:before {
  content: "\\ece6";
}

.icofont-rulers:before {
  content: "\\ece7";
}

.icofont-square-root:before {
  content: "\\ece8";
}

.icofont-aids:before {
  content: "\\ece9";
}

.icofont-ambulance:before {
  content: "\\ecea";
}

.icofont-autism:before {
  content: "\\eceb";
}

.icofont-bandage:before {
  content: "\\ecec";
}

.icofont-bed-patient:before {
  content: "\\eced";
}

.icofont-blind:before {
  content: "\\ecee";
}

.icofont-blood-drop:before {
  content: "\\ecef";
}

.icofont-blood-test:before {
  content: "\\ecf0";
}

.icofont-blood:before {
  content: "\\ecf1";
}

.icofont-capsule:before {
  content: "\\ecf2";
}

.icofont-crutches:before {
  content: "\\ecf3";
}

.icofont-dna-alt-1:before {
  content: "\\ecf4";
}

.icofont-dna:before {
  content: "\\ecf5";
}

.icofont-doctor-alt:before {
  content: "\\ecf6";
}

.icofont-doctor:before {
  content: "\\ecf7";
}

.icofont-drug-pack:before {
  content: "\\ecf8";
}

.icofont-drug:before {
  content: "\\ecf9";
}

.icofont-eye-alt:before {
  content: "\\ecfa";
}

.icofont-first-aid-alt:before {
  content: "\\ecfb";
}

.icofont-garbage:before {
  content: "\\ecfc";
}

.icofont-heart-alt:before {
  content: "\\ecfd";
}

.icofont-heartbeat:before {
  content: "\\ecfe";
}

.icofont-herbal:before {
  content: "\\ecff";
}

.icofont-hospital:before {
  content: "\\ed00";
}

.icofont-icu:before {
  content: "\\ed01";
}

.icofont-injection-syringe:before {
  content: "\\ed02";
}

.icofont-laboratory:before {
  content: "\\ed03";
}

.icofont-medical-sign-alt:before {
  content: "\\ed04";
}

.icofont-medical-sign:before {
  content: "\\ed05";
}

.icofont-nurse-alt:before {
  content: "\\ed06";
}

.icofont-nurse:before {
  content: "\\ed07";
}

.icofont-nursing-home:before {
  content: "\\ed08";
}

.icofont-operation-theater:before {
  content: "\\ed09";
}

.icofont-paralysis-disability:before {
  content: "\\ed0a";
}

.icofont-pills:before {
  content: "\\ed0b";
}

.icofont-prescription:before {
  content: "\\ed0c";
}

.icofont-pulse:before {
  content: "\\ed0d";
}

.icofont-stethoscope-alt:before {
  content: "\\ed0e";
}

.icofont-stethoscope:before {
  content: "\\ed0f";
}

.icofont-stretcher:before {
  content: "\\ed10";
}

.icofont-surgeon-alt:before {
  content: "\\ed11";
}

.icofont-surgeon:before {
  content: "\\ed12";
}

.icofont-tablets:before {
  content: "\\ed13";
}

.icofont-test-bottle:before {
  content: "\\ed14";
}

.icofont-test-tube:before {
  content: "\\ed15";
}

.icofont-thermometer-alt:before {
  content: "\\ed16";
}

.icofont-tooth:before {
  content: "\\ed17";
}

.icofont-xray:before {
  content: "\\ed18";
}

.icofont-ui-add:before {
  content: "\\ed19";
}

.icofont-ui-alarm:before {
  content: "\\ed1a";
}

.icofont-ui-battery:before {
  content: "\\ed1b";
}

.icofont-ui-block:before {
  content: "\\ed1c";
}

.icofont-ui-bluetooth:before {
  content: "\\ed1d";
}

.icofont-ui-brightness:before {
  content: "\\ed1e";
}

.icofont-ui-browser:before {
  content: "\\ed1f";
}

.icofont-ui-calculator:before {
  content: "\\ed20";
}

.icofont-ui-calendar:before {
  content: "\\ed21";
}

.icofont-ui-call:before {
  content: "\\ed22";
}

.icofont-ui-camera:before {
  content: "\\ed23";
}

.icofont-ui-cart:before {
  content: "\\ed24";
}

.icofont-ui-cell-phone:before {
  content: "\\ed25";
}

.icofont-ui-chat:before {
  content: "\\ed26";
}

.icofont-ui-check:before {
  content: "\\ed27";
}

.icofont-ui-clip-board:before {
  content: "\\ed28";
}

.icofont-ui-clip:before {
  content: "\\ed29";
}

.icofont-ui-clock:before {
  content: "\\ed2a";
}

.icofont-ui-close:before {
  content: "\\ed2b";
}

.icofont-ui-contact-list:before {
  content: "\\ed2c";
}

.icofont-ui-copy:before {
  content: "\\ed2d";
}

.icofont-ui-cut:before {
  content: "\\ed2e";
}

.icofont-ui-delete:before {
  content: "\\ed2f";
}

.icofont-ui-dial-phone:before {
  content: "\\ed30";
}

.icofont-ui-edit:before {
  content: "\\ed31";
}

.icofont-ui-email:before {
  content: "\\ed32";
}

.icofont-ui-file:before {
  content: "\\ed33";
}

.icofont-ui-fire-wall:before {
  content: "\\ed34";
}

.icofont-ui-flash-light:before {
  content: "\\ed35";
}

.icofont-ui-flight:before {
  content: "\\ed36";
}

.icofont-ui-folder:before {
  content: "\\ed37";
}

.icofont-ui-game:before {
  content: "\\ed38";
}

.icofont-ui-handicapped:before {
  content: "\\ed39";
}

.icofont-ui-head-phone:before {
  content: "\\ed3a";
}

.icofont-ui-home:before {
  content: "\\ed3b";
}

.icofont-ui-image:before {
  content: "\\ed3c";
}

.icofont-ui-keyboard:before {
  content: "\\ed3d";
}

.icofont-ui-laoding:before {
  content: "\\ed3e";
}

.icofont-ui-lock:before {
  content: "\\ed3f";
}

.icofont-ui-love-add:before {
  content: "\\ed40";
}

.icofont-ui-love-broken:before {
  content: "\\ed41";
}

.icofont-ui-love-remove:before {
  content: "\\ed42";
}

.icofont-ui-love:before {
  content: "\\ed43";
}

.icofont-ui-map:before {
  content: "\\ed44";
}

.icofont-ui-message:before {
  content: "\\ed45";
}

.icofont-ui-messaging:before {
  content: "\\ed46";
}

.icofont-ui-movie:before {
  content: "\\ed47";
}

.icofont-ui-music-player:before {
  content: "\\ed48";
}

.icofont-ui-music:before {
  content: "\\ed49";
}

.icofont-ui-mute:before {
  content: "\\ed4a";
}

.icofont-ui-network:before {
  content: "\\ed4b";
}

.icofont-ui-next:before {
  content: "\\ed4c";
}

.icofont-ui-note:before {
  content: "\\ed4d";
}

.icofont-ui-office:before {
  content: "\\ed4e";
}

.icofont-ui-password:before {
  content: "\\ed4f";
}

.icofont-ui-pause:before {
  content: "\\ed50";
}

.icofont-ui-play-stop:before {
  content: "\\ed51";
}

.icofont-ui-play:before {
  content: "\\ed52";
}

.icofont-ui-pointer:before {
  content: "\\ed53";
}

.icofont-ui-power:before {
  content: "\\ed54";
}

.icofont-ui-press:before {
  content: "\\ed55";
}

.icofont-ui-previous:before {
  content: "\\ed56";
}

.icofont-ui-rate-add:before {
  content: "\\ed57";
}

.icofont-ui-rate-blank:before {
  content: "\\ed58";
}

.icofont-ui-rate-remove:before {
  content: "\\ed59";
}

.icofont-ui-rating:before {
  content: "\\ed5a";
}

.icofont-ui-record:before {
  content: "\\ed5b";
}

.icofont-ui-remove:before {
  content: "\\ed5c";
}

.icofont-ui-reply:before {
  content: "\\ed5d";
}

.icofont-ui-rotation:before {
  content: "\\ed5e";
}

.icofont-ui-rss:before {
  content: "\\ed5f";
}

.icofont-ui-search:before {
  content: "\\ed60";
}

.icofont-ui-settings:before {
  content: "\\ed61";
}

.icofont-ui-social-link:before {
  content: "\\ed62";
}

.icofont-ui-tag:before {
  content: "\\ed63";
}

.icofont-ui-text-chat:before {
  content: "\\ed64";
}

.icofont-ui-text-loading:before {
  content: "\\ed65";
}

.icofont-ui-theme:before {
  content: "\\ed66";
}

.icofont-ui-timer:before {
  content: "\\ed67";
}

.icofont-ui-touch-phone:before {
  content: "\\ed68";
}

.icofont-ui-travel:before {
  content: "\\ed69";
}

.icofont-ui-unlock:before {
  content: "\\ed6a";
}

.icofont-ui-user-group:before {
  content: "\\ed6b";
}

.icofont-ui-user:before {
  content: "\\ed6c";
}

.icofont-ui-v-card:before {
  content: "\\ed6d";
}

.icofont-ui-video-chat:before {
  content: "\\ed6e";
}

.icofont-ui-video-message:before {
  content: "\\ed6f";
}

.icofont-ui-video-play:before {
  content: "\\ed70";
}

.icofont-ui-video:before {
  content: "\\ed71";
}

.icofont-ui-volume:before {
  content: "\\ed72";
}

.icofont-ui-weather:before {
  content: "\\ed73";
}

.icofont-ui-wifi:before {
  content: "\\ed74";
}

.icofont-ui-zoom-in:before {
  content: "\\ed75";
}

.icofont-ui-zoom-out:before {
  content: "\\ed76";
}

.icofont-cassette-player:before {
  content: "\\ed77";
}

.icofont-cassette:before {
  content: "\\ed78";
}

.icofont-forward:before {
  content: "\\ed79";
}

.icofont-game:before {
  content: "\\ed7a";
}

.icofont-guiter:before {
  content: "\\ed7b";
}

.icofont-headphone-alt-1:before {
  content: "\\ed7c";
}

.icofont-headphone-alt-2:before {
  content: "\\ed7d";
}

.icofont-headphone-alt-3:before {
  content: "\\ed7e";
}

.icofont-listening:before {
  content: "\\ed7f";
}

.icofont-megaphone-alt:before {
  content: "\\ed80";
}

.icofont-megaphone:before {
  content: "\\ed81";
}

.icofont-movie:before {
  content: "\\ed82";
}

.icofont-mp3-player:before {
  content: "\\ed83";
}

.icofont-multimedia:before {
  content: "\\ed84";
}

.icofont-music-disk:before {
  content: "\\ed85";
}

.icofont-music-note:before {
  content: "\\ed86";
}

.icofont-pause:before {
  content: "\\ed87";
}

.icofont-play-alt-1:before {
  content: "\\ed88";
}

.icofont-play-alt-2:before {
  content: "\\ed89";
}

.icofont-play-alt-3:before {
  content: "\\ed8a";
}

.icofont-play-pause:before {
  content: "\\ed8b";
}

.icofont-record:before {
  content: "\\ed8c";
}

.icofont-retro-music-disk:before {
  content: "\\ed8d";
}

.icofont-rewind:before {
  content: "\\ed8e";
}

.icofont-song-notes:before {
  content: "\\ed8f";
}

.icofont-sound-wave-alt:before {
  content: "\\ed90";
}

.icofont-sound-wave:before {
  content: "\\ed91";
}

.icofont-stop:before {
  content: "\\ed92";
}

.icofont-video-alt:before {
  content: "\\ed93";
}

.icofont-video-cam:before {
  content: "\\ed94";
}

.icofont-volume-bar:before {
  content: "\\ed95";
}

.icofont-volume-mute:before {
  content: "\\ed96";
}

.icofont-youtube-play:before {
  content: "\\ed97";
}

.icofont-amazon-alt:before {
  content: "\\ed98";
}

.icofont-amazon:before {
  content: "\\ed99";
}

.icofont-american-express-alt:before {
  content: "\\ed9a";
}

.icofont-american-express:before {
  content: "\\ed9b";
}

.icofont-apple-pay-alt:before {
  content: "\\ed9c";
}

.icofont-apple-pay:before {
  content: "\\ed9d";
}

.icofont-bank-transfer-alt:before {
  content: "\\ed9e";
}

.icofont-bank-transfer:before {
  content: "\\ed9f";
}

.icofont-braintree-alt:before {
  content: "\\eda0";
}

.icofont-braintree:before {
  content: "\\eda1";
}

.icofont-cash-on-delivery-alt:before {
  content: "\\eda2";
}

.icofont-cash-on-delivery:before {
  content: "\\eda3";
}

.icofont-checkout-alt:before {
  content: "\\eda4";
}

.icofont-checkout:before {
  content: "\\eda5";
}

.icofont-diners-club-alt-1:before {
  content: "\\eda6";
}

.icofont-diners-club-alt-2:before {
  content: "\\eda7";
}

.icofont-diners-club-alt-3:before {
  content: "\\eda8";
}

.icofont-diners-club:before {
  content: "\\eda9";
}

.icofont-discover-alt:before {
  content: "\\edaa";
}

.icofont-discover:before {
  content: "\\edab";
}

.icofont-eway-alt:before {
  content: "\\edac";
}

.icofont-eway:before {
  content: "\\edad";
}

.icofont-google-wallet-alt-1:before {
  content: "\\edae";
}

.icofont-google-wallet-alt-2:before {
  content: "\\edaf";
}

.icofont-google-wallet-alt-3:before {
  content: "\\edb0";
}

.icofont-google-wallet:before {
  content: "\\edb1";
}

.icofont-jcb-alt:before {
  content: "\\edb2";
}

.icofont-jcb:before {
  content: "\\edb3";
}

.icofont-maestro-alt:before {
  content: "\\edb4";
}

.icofont-maestro:before {
  content: "\\edb5";
}

.icofont-mastercard-alt:before {
  content: "\\edb6";
}

.icofont-mastercard:before {
  content: "\\edb7";
}

.icofont-payoneer-alt:before {
  content: "\\edb8";
}

.icofont-payoneer:before {
  content: "\\edb9";
}

.icofont-paypal-alt:before {
  content: "\\edba";
}

.icofont-paypal:before {
  content: "\\edbb";
}

.icofont-sage-alt:before {
  content: "\\edbc";
}

.icofont-sage:before {
  content: "\\edbd";
}

.icofont-skrill-alt:before {
  content: "\\edbe";
}

.icofont-skrill:before {
  content: "\\edbf";
}

.icofont-stripe-alt:before {
  content: "\\edc0";
}

.icofont-stripe:before {
  content: "\\edc1";
}

.icofont-visa-alt:before {
  content: "\\edc2";
}

.icofont-visa-electron:before {
  content: "\\edc3";
}

.icofont-visa:before {
  content: "\\edc4";
}

.icofont-western-union-alt:before {
  content: "\\edc5";
}

.icofont-western-union:before {
  content: "\\edc6";
}

.icofont-boy:before {
  content: "\\edc7";
}

.icofont-business-man-alt-1:before {
  content: "\\edc8";
}

.icofont-business-man-alt-2:before {
  content: "\\edc9";
}

.icofont-business-man-alt-3:before {
  content: "\\edca";
}

.icofont-business-man:before {
  content: "\\edcb";
}

.icofont-funky-man:before {
  content: "\\edcc";
}

.icofont-girl-alt:before {
  content: "\\edcd";
}

.icofont-girl:before {
  content: "\\edce";
}

.icofont-hotel-boy-alt:before {
  content: "\\edcf";
}

.icofont-hotel-boy:before {
  content: "\\edd0";
}

.icofont-man-in-glasses:before {
  content: "\\edd1";
}

.icofont-user-alt-1:before {
  content: "\\edd2";
}

.icofont-user-alt-2:before {
  content: "\\edd3";
}

.icofont-user-alt-3:before {
  content: "\\edd4";
}

.icofont-user-alt-4:before {
  content: "\\edd5";
}

.icofont-user-alt-5:before {
  content: "\\edd6";
}

.icofont-user-alt-6:before {
  content: "\\edd7";
}

.icofont-user-alt-7:before {
  content: "\\edd8";
}

.icofont-user-female:before {
  content: "\\edd9";
}

.icofont-user-male:before {
  content: "\\edda";
}

.icofont-user-suited:before {
  content: "\\eddb";
}

.icofont-user:before {
  content: "\\eddc";
}

.icofont-users-alt-1:before {
  content: "\\eddd";
}

.icofont-users-alt-2:before {
  content: "\\edde";
}

.icofont-users-alt-3:before {
  content: "\\eddf";
}

.icofont-users-alt-4:before {
  content: "\\ede0";
}

.icofont-users-alt-5:before {
  content: "\\ede1";
}

.icofont-users-alt-6:before {
  content: "\\ede2";
}

.icofont-users-social:before {
  content: "\\ede3";
}

.icofont-users:before {
  content: "\\ede4";
}

.icofont-waiter:before {
  content: "\\ede5";
}

.icofont-woman-in-glasses:before {
  content: "\\ede6";
}

.icofont-document-search:before {
  content: "\\ede7";
}

.icofont-folder-search:before {
  content: "\\ede8";
}

.icofont-home-search:before {
  content: "\\ede9";
}

.icofont-job-search:before {
  content: "\\edea";
}

.icofont-map-search:before {
  content: "\\edeb";
}

.icofont-restaurant-search:before {
  content: "\\edec";
}

.icofont-search-alt-1:before {
  content: "\\eded";
}

.icofont-search-alt-2:before {
  content: "\\edee";
}

.icofont-search:before {
  content: "\\edef";
}

.icofont-stock-search:before {
  content: "\\edf0";
}

.icofont-user-search:before {
  content: "\\edf1";
}

.icofont-social-aim:before {
  content: "\\edf2";
}

.icofont-social-badoo:before {
  content: "\\edf3";
}

.icofont-social-bebo:before {
  content: "\\edf4";
}

.icofont-social-behance:before {
  content: "\\edf5";
}

.icofont-social-blogger:before {
  content: "\\edf6";
}

.icofont-social-bootstrap:before {
  content: "\\edf7";
}

.icofont-social-brightkite:before {
  content: "\\edf8";
}

.icofont-social-cloudapp:before {
  content: "\\edf9";
}

.icofont-social-concrete5:before {
  content: "\\edfa";
}

.icofont-social-designbump:before {
  content: "\\edfb";
}

.icofont-social-designfloat:before {
  content: "\\edfc";
}

.icofont-social-deviantart:before {
  content: "\\edfd";
}

.icofont-social-digg:before {
  content: "\\edfe";
}

.icofont-social-dotcms:before {
  content: "\\edff";
}

.icofont-social-dribble:before {
  content: "\\ee00";
}

.icofont-social-dropbox:before {
  content: "\\ee01";
}

.icofont-brand-drupal:before {
  content: "\\ee02";
}

.icofont-social-ebuddy:before {
  content: "\\ee03";
}

.icofont-social-ello:before {
  content: "\\ee04";
}

.icofont-social-ember:before {
  content: "\\ee05";
}

.icofont-social-envato:before {
  content: "\\ee06";
}

.icofont-social-evernote:before {
  content: "\\ee07";
}

.icofont-social-facebook:before {
  content: "\\ee08";
}

.icofont-social-feedburner:before {
  content: "\\ee09";
}

.icofont-social-folkd:before {
  content: "\\ee0a";
}

.icofont-social-friendfeed:before {
  content: "\\ee0b";
}

.icofont-social-ghost:before {
  content: "\\ee0c";
}

.icofont-social-github:before {
  content: "\\ee0d";
}

.icofont-social-gnome:before {
  content: "\\ee0e";
}

.icofont-social-google-buzz:before {
  content: "\\ee0f";
}

.icofont-social-google-map:before {
  content: "\\ee10";
}

.icofont-social-google-plus:before {
  content: "\\ee11";
}

.icofont-social-google-talk:before {
  content: "\\ee12";
}

.icofont-social-hype-machine:before {
  content: "\\ee13";
}

.icofont-social-instagram:before {
  content: "\\ee14";
}

.icofont-brand-joomla:before {
  content: "\\ee15";
}

.icofont-social-kickstarter:before {
  content: "\\ee16";
}

.icofont-social-line:before {
  content: "\\ee17";
}

.icofont-social-linux-mint:before {
  content: "\\ee18";
}

.icofont-social-livejournal:before {
  content: "\\ee19";
}

.icofont-social-magento:before {
  content: "\\ee1a";
}

.icofont-social-meetup:before {
  content: "\\ee1b";
}

.icofont-social-mixx:before {
  content: "\\ee1c";
}

.icofont-social-newsvine:before {
  content: "\\ee1d";
}

.icofont-social-nimbuss:before {
  content: "\\ee1e";
}

.icofont-social-opencart:before {
  content: "\\ee1f";
}

.icofont-social-oscommerce:before {
  content: "\\ee20";
}

.icofont-social-pandora:before {
  content: "\\ee21";
}

.icofont-social-picasa:before {
  content: "\\ee22";
}

.icofont-social-pinterest:before {
  content: "\\ee23";
}

.icofont-social-prestashop:before {
  content: "\\ee24";
}

.icofont-social-qik:before {
  content: "\\ee25";
}

.icofont-social-readernaut:before {
  content: "\\ee26";
}

.icofont-social-reddit:before {
  content: "\\ee27";
}

.icofont-social-rss:before {
  content: "\\ee28";
}

.icofont-social-shopify:before {
  content: "\\ee29";
}

.icofont-social-silverstripe:before {
  content: "\\ee2a";
}

.icofont-social-skype:before {
  content: "\\ee2b";
}

.icofont-social-slashdot:before {
  content: "\\ee2c";
}

.icofont-social-smugmug:before {
  content: "\\ee2d";
}

.icofont-social-steam:before {
  content: "\\ee2e";
}

.icofont-social-stumbleupon:before {
  content: "\\ee2f";
}

.icofont-social-technorati:before {
  content: "\\ee30";
}

.icofont-social-telegram:before {
  content: "\\ee31";
}

.icofont-social-tinder:before {
  content: "\\ee32";
}

.icofont-social-tumblr:before {
  content: "\\ee33";
}

.icofont-social-twitter:before {
  content: "\\ee34";
}

.icofont-social-typo3:before {
  content: "\\ee35";
}

.icofont-social-ubercart:before {
  content: "\\ee36";
}

.icofont-social-viber:before {
  content: "\\ee37";
}

.icofont-social-viddler:before {
  content: "\\ee38";
}

.icofont-social-vimeo:before {
  content: "\\ee39";
}

.icofont-social-vine:before {
  content: "\\ee3a";
}

.icofont-social-virb:before {
  content: "\\ee3b";
}

.icofont-social-virtuemart:before {
  content: "\\ee3c";
}

.icofont-social-wechat:before {
  content: "\\ee3d";
}

.icofont-brand-wordpress:before {
  content: "\\ee3e";
}

.icofont-social-xing:before {
  content: "\\ee3f";
}

.icofont-social-yahoo:before {
  content: "\\ee40";
}

.icofont-social-yelp:before {
  content: "\\ee41";
}

.icofont-social-zencart:before {
  content: "\\ee42";
}

.icofont-badminton-birdie:before {
  content: "\\ee43";
}

.icofont-baseball:before {
  content: "\\ee44";
}

.icofont-baseballer:before {
  content: "\\ee45";
}

.icofont-basketball-hoop:before {
  content: "\\ee46";
}

.icofont-basketball:before {
  content: "\\ee47";
}

.icofont-billiard-ball:before {
  content: "\\ee48";
}

.icofont-boot-alt-1:before {
  content: "\\ee49";
}

.icofont-boot-alt-2:before {
  content: "\\ee4a";
}

.icofont-bowling-alt:before {
  content: "\\ee4b";
}

.icofont-bowling:before {
  content: "\\ee4c";
}

.icofont-canoe:before {
  content: "\\ee4d";
}

.icofont-cheer-leader:before {
  content: "\\ee4e";
}

.icofont-climbing:before {
  content: "\\ee4f";
}

.icofont-corner:before {
  content: "\\ee50";
}

.icofont-cyclist:before {
  content: "\\ee51";
}

.icofont-dumbbell-alt:before {
  content: "\\ee52";
}

.icofont-dumbbell:before {
  content: "\\ee53";
}

.icofont-field-alt:before {
  content: "\\ee54";
}

.icofont-field:before {
  content: "\\ee55";
}

.icofont-football-alt:before {
  content: "\\ee56";
}

.icofont-foul:before {
  content: "\\ee57";
}

.icofont-goal-keeper:before {
  content: "\\ee58";
}

.icofont-goal:before {
  content: "\\ee59";
}

.icofont-golf-alt:before {
  content: "\\ee5a";
}

.icofont-golf-bag:before {
  content: "\\ee5b";
}

.icofont-golf-field:before {
  content: "\\ee5c";
}

.icofont-golf:before {
  content: "\\ee5d";
}

.icofont-golfer:before {
  content: "\\ee5e";
}

.icofont-gym-alt-1:before {
  content: "\\ee5f";
}

.icofont-gym-alt-2:before {
  content: "\\ee60";
}

.icofont-gym-alt-3:before {
  content: "\\ee61";
}

.icofont-gym:before {
  content: "\\ee62";
}

.icofont-hand-grippers:before {
  content: "\\ee63";
}

.icofont-heart-beat-alt:before {
  content: "\\ee64";
}

.icofont-helmet:before {
  content: "\\ee65";
}

.icofont-hockey-alt:before {
  content: "\\ee66";
}

.icofont-hockey:before {
  content: "\\ee67";
}

.icofont-ice-skate:before {
  content: "\\ee68";
}

.icofont-jersey-alt:before {
  content: "\\ee69";
}

.icofont-jersey:before {
  content: "\\ee6a";
}

.icofont-jumping:before {
  content: "\\ee6b";
}

.icofont-kick:before {
  content: "\\ee6c";
}

.icofont-leg:before {
  content: "\\ee6d";
}

.icofont-match-review:before {
  content: "\\ee6e";
}

.icofont-medal-alt:before {
  content: "\\ee6f";
}

.icofont-muscle-alt:before {
  content: "\\ee70";
}

.icofont-muscle:before {
  content: "\\ee71";
}

.icofont-offside:before {
  content: "\\ee72";
}

.icofont-olympic-logo:before {
  content: "\\ee73";
}

.icofont-olympic:before {
  content: "\\ee74";
}

.icofont-padding:before {
  content: "\\ee75";
}

.icofont-penalty-card:before {
  content: "\\ee76";
}

.icofont-racer:before {
  content: "\\ee77";
}

.icofont-racing-car:before {
  content: "\\ee78";
}

.icofont-racing-flag-alt:before {
  content: "\\ee79";
}

.icofont-racing-flag:before {
  content: "\\ee7a";
}

.icofont-racings-wheel:before {
  content: "\\ee7b";
}

.icofont-referee:before {
  content: "\\ee7c";
}

.icofont-refree-jersey:before {
  content: "\\ee7d";
}

.icofont-result:before {
  content: "\\ee7e";
}

.icofont-rugby-ball:before {
  content: "\\ee7f";
}

.icofont-rugby-player:before {
  content: "\\ee80";
}

.icofont-rugby:before {
  content: "\\ee81";
}

.icofont-runner-alt-1:before {
  content: "\\ee82";
}

.icofont-runner-alt-2:before {
  content: "\\ee83";
}

.icofont-runner:before {
  content: "\\ee84";
}

.icofont-score-board:before {
  content: "\\ee85";
}

.icofont-skiing-man:before {
  content: "\\ee86";
}

.icofont-skydiving-goggles:before {
  content: "\\ee87";
}

.icofont-snow-mobile:before {
  content: "\\ee88";
}

.icofont-steering:before {
  content: "\\ee89";
}

.icofont-substitute:before {
  content: "\\ee8a";
}

.icofont-swimmer:before {
  content: "\\ee8b";
}

.icofont-table-tennis:before {
  content: "\\ee8c";
}

.icofont-team-alt:before {
  content: "\\ee8d";
}

.icofont-team:before {
  content: "\\ee8e";
}

.icofont-tennis-player:before {
  content: "\\ee8f";
}

.icofont-tennis:before {
  content: "\\ee90";
}

.icofont-time:before {
  content: "\\ee91";
}

.icofont-track:before {
  content: "\\ee92";
}

.icofont-tracking:before {
  content: "\\ee93";
}

.icofont-trophy-alt:before {
  content: "\\ee94";
}

.icofont-trophy:before {
  content: "\\ee95";
}

.icofont-volleyball-alt:before {
  content: "\\ee96";
}

.icofont-volleyball-fire:before {
  content: "\\ee97";
}

.icofont-volleyball:before {
  content: "\\ee98";
}

.icofont-water-bottle:before {
  content: "\\ee99";
}

.icofont-whisle:before {
  content: "\\ee9a";
}

.icofont-win-trophy:before {
  content: "\\ee9b";
}

.icofont-align-center:before {
  content: "\\ee9c";
}

.icofont-align-left:before {
  content: "\\ee9d";
}

.icofont-align-right:before {
  content: "\\ee9e";
}

.icofont-all-caps:before {
  content: "\\ee9f";
}

.icofont-bold:before {
  content: "\\eea0";
}

.icofont-brush:before {
  content: "\\eea1";
}

.icofont-clip-board:before {
  content: "\\eea2";
}

.icofont-code-alt:before {
  content: "\\eea3";
}

.icofont-color-bucket:before {
  content: "\\eea4";
}

.icofont-color-picker:before {
  content: "\\eea5";
}

.icofont-copy-alt:before {
  content: "\\eea6";
}

.icofont-copy-black:before {
  content: "\\eea7";
}

.icofont-cut:before {
  content: "\\eea8";
}

.icofont-delete-alt:before {
  content: "\\eea9";
}

.icofont-edit-alt:before {
  content: "\\eeaa";
}

.icofont-eraser-alt:before {
  content: "\\eeab";
}

.icofont-file-alt:before {
  content: "\\eeac";
}

.icofont-font:before {
  content: "\\eead";
}

.icofont-header:before {
  content: "\\eeae";
}

.icofont-indent:before {
  content: "\\eeaf";
}

.icofont-italic-alt:before {
  content: "\\eeb0";
}

.icofont-justify-all:before {
  content: "\\eeb1";
}

.icofont-justify-center:before {
  content: "\\eeb2";
}

.icofont-justify-left:before {
  content: "\\eeb3";
}

.icofont-justify-right:before {
  content: "\\eeb4";
}

.icofont-line-height:before {
  content: "\\eeb5";
}

.icofont-link-alt:before {
  content: "\\eeb6";
}

.icofont-listine-dots:before {
  content: "\\eeb7";
}

.icofont-listing-box:before {
  content: "\\eeb8";
}

.icofont-listing-number:before {
  content: "\\eeb9";
}

.icofont-marker:before {
  content: "\\eeba";
}

.icofont-outdent:before {
  content: "\\eebb";
}

.icofont-paper-clip:before {
  content: "\\eebc";
}

.icofont-paragraph:before {
  content: "\\eebd";
}

.icofont-pin:before {
  content: "\\eebe";
}

.icofont-printer:before {
  content: "\\eebf";
}

.icofont-redo:before {
  content: "\\eec0";
}

.icofont-rotation:before {
  content: "\\eec1";
}

.icofont-save:before {
  content: "\\eec2";
}

.icofont-small-cap:before {
  content: "\\eec3";
}

.icofont-strike-through:before {
  content: "\\eec4";
}

.icofont-sub-listing:before {
  content: "\\eec5";
}

.icofont-subscript:before {
  content: "\\eec6";
}

.icofont-superscript:before {
  content: "\\eec7";
}

.icofont-table:before {
  content: "\\eec8";
}

.icofont-text-height:before {
  content: "\\eec9";
}

.icofont-text-width:before {
  content: "\\eeca";
}

.icofont-trash:before {
  content: "\\eecb";
}

.icofont-underline:before {
  content: "\\eecc";
}

.icofont-undo:before {
  content: "\\eecd";
}

.icofont-unlink:before {
  content: "\\eece";
}

.icofont-air-balloon:before {
  content: "\\eecf";
}

.icofont-airplane-alt:before {
  content: "\\eed0";
}

.icofont-airplane:before {
  content: "\\eed1";
}

.icofont-ambulance-crescent:before {
  content: "\\eed2";
}

.icofont-ambulance-cross:before {
  content: "\\eed3";
}

.icofont-articulated-truck:before {
  content: "\\eed4";
}

.icofont-auto-rickshaw:before {
  content: "\\eed5";
}

.icofont-bicycle-alt-1:before {
  content: "\\eed6";
}

.icofont-bicycle-alt-2:before {
  content: "\\eed7";
}

.icofont-bull-dozer:before {
  content: "\\eed8";
}

.icofont-bus-alt-1:before {
  content: "\\eed9";
}

.icofont-bus-alt-2:before {
  content: "\\eeda";
}

.icofont-bus-alt-3:before {
  content: "\\eedb";
}

.icofont-cable-car:before {
  content: "\\eedc";
}

.icofont-car-alt-1:before {
  content: "\\eedd";
}

.icofont-car-alt-2:before {
  content: "\\eede";
}

.icofont-car-alt-3:before {
  content: "\\eedf";
}

.icofont-car-alt-4:before {
  content: "\\eee0";
}

.icofont-concrete-mixer:before {
  content: "\\eee1";
}

.icofont-delivery-time:before {
  content: "\\eee2";
}

.icofont-excavator:before {
  content: "\\eee3";
}

.icofont-fast-delivery:before {
  content: "\\eee4";
}

.icofont-fire-truck-alt:before {
  content: "\\eee5";
}

.icofont-fire-truck:before {
  content: "\\eee6";
}

.icofont-fork-lift:before {
  content: "\\eee7";
}

.icofont-free-delivery:before {
  content: "\\eee8";
}

.icofont-golf-cart:before {
  content: "\\eee9";
}

.icofont-helicopter:before {
  content: "\\eeea";
}

.icofont-motor-bike-alt:before {
  content: "\\eeeb";
}

.icofont-motor-bike:before {
  content: "\\eeec";
}

.icofont-motor-biker:before {
  content: "\\eeed";
}

.icofont-oil-truck:before {
  content: "\\eeee";
}

.icofont-police-car:before {
  content: "\\eeef";
}

.icofont-rickshaw:before {
  content: "\\eef0";
}

.icofont-rocket-alt-1:before {
  content: "\\eef1";
}

.icofont-rocket-alt-2:before {
  content: "\\eef2";
}

.icofont-sail-boat:before {
  content: "\\eef3";
}

.icofont-scooter:before {
  content: "\\eef4";
}

.icofont-sea-plane:before {
  content: "\\eef5";
}

.icofont-ship-alt:before {
  content: "\\eef6";
}

.icofont-speed-boat:before {
  content: "\\eef7";
}

.icofont-taxi:before {
  content: "\\eef8";
}

.icofont-tow-truck:before {
  content: "\\eef9";
}

.icofont-tractor:before {
  content: "\\eefa";
}

.icofont-traffic-light:before {
  content: "\\eefb";
}

.icofont-train-line:before {
  content: "\\eefc";
}

.icofont-train-steam:before {
  content: "\\eefd";
}

.icofont-tram:before {
  content: "\\eefe";
}

.icofont-truck-alt:before {
  content: "\\eeff";
}

.icofont-truck-loaded:before {
  content: "\\ef00";
}

.icofont-truck:before {
  content: "\\ef01";
}

.icofont-van-alt:before {
  content: "\\ef02";
}

.icofont-van:before {
  content: "\\ef03";
}

.icofont-yacht:before {
  content: "\\ef04";
}

.icofont-5-star-hotel:before {
  content: "\\ef05";
}

.icofont-anchor-alt:before {
  content: "\\ef06";
}

.icofont-beach-bed:before {
  content: "\\ef07";
}

.icofont-camping-vest:before {
  content: "\\ef08";
}

.icofont-coconut-alt:before {
  content: "\\ef09";
}

.icofont-direction-sign:before {
  content: "\\ef0a";
}

.icofont-hill-side:before {
  content: "\\ef0b";
}

.icofont-island-alt:before {
  content: "\\ef0c";
}

.icofont-long-drive:before {
  content: "\\ef0d";
}

.icofont-map-pins:before {
  content: "\\ef0e";
}

.icofont-plane-ticket:before {
  content: "\\ef0f";
}

.icofont-sail-boat-alt-1:before {
  content: "\\ef10";
}

.icofont-sail-boat-alt-2:before {
  content: "\\ef11";
}

.icofont-sandals-female:before {
  content: "\\ef12";
}

.icofont-sandals-male:before {
  content: "\\ef13";
}

.icofont-travelling:before {
  content: "\\ef14";
}

.icofont-breakdown:before {
  content: "\\ef15";
}

.icofont-celsius:before {
  content: "\\ef16";
}

.icofont-clouds:before {
  content: "\\ef17";
}

.icofont-cloudy:before {
  content: "\\ef18";
}

.icofont-compass-alt:before {
  content: "\\ef19";
}

.icofont-dust:before {
  content: "\\ef1a";
}

.icofont-eclipse:before {
  content: "\\ef1b";
}

.icofont-fahrenheit:before {
  content: "\\ef1c";
}

.icofont-forest-fire:before {
  content: "\\ef1d";
}

.icofont-full-night:before {
  content: "\\ef1e";
}

.icofont-full-sunny:before {
  content: "\\ef1f";
}

.icofont-hail-night:before {
  content: "\\ef20";
}

.icofont-hail-rainy-night:before {
  content: "\\ef21";
}

.icofont-hail-rainy-sunny:before {
  content: "\\ef22";
}

.icofont-hail-rainy:before {
  content: "\\ef23";
}

.icofont-hail-sunny:before {
  content: "\\ef24";
}

.icofont-hail-thunder-night:before {
  content: "\\ef25";
}

.icofont-hail-thunder-sunny:before {
  content: "\\ef26";
}

.icofont-hail-thunder:before {
  content: "\\ef27";
}

.icofont-hail:before {
  content: "\\ef28";
}

.icofont-hill-night:before {
  content: "\\ef29";
}

.icofont-hill-sunny:before {
  content: "\\ef2a";
}

.icofont-hill:before {
  content: "\\ef2b";
}

.icofont-hurricane:before {
  content: "\\ef2c";
}

.icofont-island:before {
  content: "\\ef2d";
}

.icofont-meteor:before {
  content: "\\ef2e";
}

.icofont-night:before {
  content: "\\ef2f";
}

.icofont-rainy-night:before {
  content: "\\ef30";
}

.icofont-rainy-sunny:before {
  content: "\\ef31";
}

.icofont-rainy-thunder:before {
  content: "\\ef32";
}

.icofont-rainy:before {
  content: "\\ef33";
}

.icofont-showy-night-hail:before {
  content: "\\ef34";
}

.icofont-snow-temp:before {
  content: "\\ef35";
}

.icofont-snow:before {
  content: "\\ef36";
}

.icofont-snowy-hail:before {
  content: "\\ef37";
}

.icofont-snowy-night-rainy:before {
  content: "\\ef38";
}

.icofont-snowy-night:before {
  content: "\\ef39";
}

.icofont-snowy-rainy:before {
  content: "\\ef3a";
}

.icofont-snowy-sunny-hail:before {
  content: "\\ef3b";
}

.icofont-snowy-sunny-rainy:before {
  content: "\\ef3c";
}

.icofont-snowy-sunny:before {
  content: "\\ef3d";
}

.icofont-snowy-thunder-night:before {
  content: "\\ef3e";
}

.icofont-snowy-thunder-sunny:before {
  content: "\\ef3f";
}

.icofont-snowy-thunder:before {
  content: "\\ef40";
}

.icofont-snowy-windy-night:before {
  content: "\\ef41";
}

.icofont-snowy-windy-sunny:before {
  content: "\\ef42";
}

.icofont-snowy-windy:before {
  content: "\\ef43";
}

.icofont-snowy:before {
  content: "\\ef44";
}

.icofont-sun-alt:before {
  content: "\\ef45";
}

.icofont-sun-rise:before {
  content: "\\ef46";
}

.icofont-sun-set:before {
  content: "\\ef47";
}

.icofont-sunny-day-temp:before {
  content: "\\ef48";
}

.icofont-sunny:before {
  content: "\\ef49";
}

.icofont-thermometer:before {
  content: "\\ef4a";
}

.icofont-thinder-light:before {
  content: "\\ef4b";
}

.icofont-tornado:before {
  content: "\\ef4c";
}

.icofont-umbrella-alt:before {
  content: "\\ef4d";
}

.icofont-volcano:before {
  content: "\\ef4e";
}

.icofont-wave:before {
  content: "\\ef4f";
}

.icofont-wind-scale-0:before {
  content: "\\ef50";
}

.icofont-wind-scale-1:before {
  content: "\\ef51";
}

.icofont-wind-scale-2:before {
  content: "\\ef52";
}

.icofont-wind-scale-3:before {
  content: "\\ef53";
}

.icofont-wind-scale-4:before {
  content: "\\ef54";
}

.icofont-wind-scale-5:before {
  content: "\\ef55";
}

.icofont-wind-scale-6:before {
  content: "\\ef56";
}

.icofont-wind-scale-7:before {
  content: "\\ef57";
}

.icofont-wind-scale-8:before {
  content: "\\ef58";
}

.icofont-wind-scale-9:before {
  content: "\\ef59";
}

.icofont-wind-scale-10:before {
  content: "\\ef5a";
}

.icofont-wind-scale-11:before {
  content: "\\ef5b";
}

.icofont-wind-scale-12:before {
  content: "\\ef5c";
}

.icofont-wind-waves:before {
  content: "\\ef5d";
}

.icofont-wind:before {
  content: "\\ef5e";
}

.icofont-windy-hail:before {
  content: "\\ef5f";
}

.icofont-windy-night:before {
  content: "\\ef60";
}

.icofont-windy-raining:before {
  content: "\\ef61";
}

.icofont-windy-sunny:before {
  content: "\\ef62";
}

.icofont-windy-thunder-raining:before {
  content: "\\ef63";
}

.icofont-windy-thunder:before {
  content: "\\ef64";
}

.icofont-windy:before {
  content: "\\ef65";
}

.icofont-addons:before {
  content: "\\ef66";
}

.icofont-address-book:before {
  content: "\\ef67";
}

.icofont-adjust:before {
  content: "\\ef68";
}

.icofont-alarm:before {
  content: "\\ef69";
}

.icofont-anchor:before {
  content: "\\ef6a";
}

.icofont-archive:before {
  content: "\\ef6b";
}

.icofont-at:before {
  content: "\\ef6c";
}

.icofont-attachment:before {
  content: "\\ef6d";
}

.icofont-audio:before {
  content: "\\ef6e";
}

.icofont-auto-mobile:before {
  content: "\\ef6f";
}

.icofont-automation:before {
  content: "\\ef70";
}

.icofont-baby:before {
  content: "\\ef71";
}

.icofont-badge:before {
  content: "\\ef72";
}

.icofont-bag:before {
  content: "\\ef73";
}

.icofont-ban:before {
  content: "\\ef74";
}

.icofont-bank:before {
  content: "\\ef75";
}

.icofont-bar-code:before {
  content: "\\ef76";
}

.icofont-bars:before {
  content: "\\ef77";
}

.icofont-battery-empty:before {
  content: "\\ef78";
}

.icofont-battery-full:before {
  content: "\\ef79";
}

.icofont-battery-half:before {
  content: "\\ef7a";
}

.icofont-battery-low:before {
  content: "\\ef7b";
}

.icofont-beach:before {
  content: "\\ef7c";
}

.icofont-beaker:before {
  content: "\\ef7d";
}

.icofont-bear:before {
  content: "\\ef7e";
}

.icofont-beard:before {
  content: "\\ef7f";
}

.icofont-bed:before {
  content: "\\ef80";
}

.icofont-bell:before {
  content: "\\ef81";
}

.icofont-beverage:before {
  content: "\\ef82";
}

.icofont-bicycle:before {
  content: "\\ef83";
}

.icofont-bill:before {
  content: "\\ef84";
}

.icofont-bin:before {
  content: "\\ef85";
}

.icofont-binary:before {
  content: "\\ef86";
}

.icofont-binoculars:before {
  content: "\\ef87";
}

.icofont-bird:before {
  content: "\\ef88";
}

.icofont-birds:before {
  content: "\\ef89";
}

.icofont-black-board:before {
  content: "\\ef8a";
}

.icofont-bluetooth:before {
  content: "\\ef8b";
}

.icofont-bolt:before {
  content: "\\ef8c";
}

.icofont-bomb:before {
  content: "\\ef8d";
}

.icofont-book-mark:before {
  content: "\\ef8e";
}

.icofont-book:before {
  content: "\\ef8f";
}

.icofont-boot:before {
  content: "\\ef90";
}

.icofont-box:before {
  content: "\\ef91";
}

.icofont-brain:before {
  content: "\\ef92";
}

.icofont-briefcase:before {
  content: "\\ef93";
}

.icofont-broken:before {
  content: "\\ef94";
}

.icofont-bucket:before {
  content: "\\ef95";
}

.icofont-bucket1:before {
  content: "\\ef96";
}

.icofont-bucket2:before {
  content: "\\ef97";
}

.icofont-bug:before {
  content: "\\ef98";
}

.icofont-building:before {
  content: "\\ef99";
}

.icofont-bullet:before {
  content: "\\ef9a";
}

.icofont-bullhorn:before {
  content: "\\ef9b";
}

.icofont-bullseye:before {
  content: "\\ef9c";
}

.icofont-bus:before {
  content: "\\ef9d";
}

.icofont-butterfly:before {
  content: "\\ef9e";
}

.icofont-cab:before {
  content: "\\ef9f";
}

.icofont-calculator:before {
  content: "\\efa0";
}

.icofont-calendar:before {
  content: "\\efa1";
}

.icofont-camera-alt:before {
  content: "\\efa2";
}

.icofont-camera:before {
  content: "\\efa3";
}

.icofont-car:before {
  content: "\\efa4";
}

.icofont-card:before {
  content: "\\efa5";
}

.icofont-cart:before {
  content: "\\efa6";
}

.icofont-cc:before {
  content: "\\efa7";
}

.icofont-certificate:before {
  content: "\\efa8";
}

.icofont-charging:before {
  content: "\\efa9";
}

.icofont-chat:before {
  content: "\\efaa";
}

.icofont-check-alt:before {
  content: "\\efab";
}

.icofont-check-circled:before {
  content: "\\efac";
}

.icofont-check:before {
  content: "\\efad";
}

.icofont-checked:before {
  content: "\\efae";
}

.icofont-children-care:before {
  content: "\\efaf";
}

.icofont-clock-time:before {
  content: "\\efb0";
}

.icofont-close-circled:before {
  content: "\\efb1";
}

.icofont-close-line-circled:before {
  content: "\\efb2";
}

.icofont-close-line-squared-alt:before {
  content: "\\efb3";
}

.icofont-close-line-squared:before {
  content: "\\efb4";
}

.icofont-close-line:before {
  content: "\\efb5";
}

.icofont-close-squared-alt:before {
  content: "\\efb6";
}

.icofont-close-squared:before {
  content: "\\efb7";
}

.icofont-close:before {
  content: "\\efb8";
}

.icofont-cloud-download:before {
  content: "\\efb9";
}

.icofont-cloud-refresh:before {
  content: "\\efba";
}

.icofont-cloud-upload:before {
  content: "\\efbb";
}

.icofont-cloud:before {
  content: "\\efbc";
}

.icofont-code-not-allowed:before {
  content: "\\efbd";
}

.icofont-code:before {
  content: "\\efbe";
}

.icofont-coffee-cup:before {
  content: "\\efbf";
}

.icofont-comment:before {
  content: "\\efc0";
}

.icofont-compass:before {
  content: "\\efc1";
}

.icofont-computer:before {
  content: "\\efc2";
}

.icofont-connection:before {
  content: "\\efc3";
}

.icofont-console:before {
  content: "\\efc4";
}

.icofont-contacts:before {
  content: "\\efc5";
}

.icofont-contrast:before {
  content: "\\efc6";
}

.icofont-copy:before {
  content: "\\efc7";
}

.icofont-copyright:before {
  content: "\\efc8";
}

.icofont-credit-card:before {
  content: "\\efc9";
}

.icofont-crop:before {
  content: "\\efca";
}

.icofont-crown:before {
  content: "\\efcb";
}

.icofont-cube:before {
  content: "\\efcc";
}

.icofont-cubes:before {
  content: "\\efcd";
}

.icofont-culinary:before {
  content: "\\efce";
}

.icofont-dashboard-web:before {
  content: "\\efcf";
}

.icofont-dashboard:before {
  content: "\\efd0";
}

.icofont-data:before {
  content: "\\efd1";
}

.icofont-database-add:before {
  content: "\\efd2";
}

.icofont-database-locked:before {
  content: "\\efd3";
}

.icofont-database-remove:before {
  content: "\\efd4";
}

.icofont-database:before {
  content: "\\efd5";
}

.icofont-delete:before {
  content: "\\efd6";
}

.icofont-diamond:before {
  content: "\\efd7";
}

.icofont-dice:before {
  content: "\\efd8";
}

.icofont-disabled:before {
  content: "\\efd9";
}

.icofont-disc:before {
  content: "\\efda";
}

.icofont-diskette:before {
  content: "\\efdb";
}

.icofont-document-folder:before {
  content: "\\efdc";
}

.icofont-download-alt:before {
  content: "\\efdd";
}

.icofont-download:before {
  content: "\\efde";
}

.icofont-downloaded:before {
  content: "\\efdf";
}

.icofont-earth:before {
  content: "\\efe0";
}

.icofont-ebook:before {
  content: "\\efe1";
}

.icofont-edit:before {
  content: "\\efe2";
}

.icofont-eject:before {
  content: "\\efe3";
}

.icofont-email:before {
  content: "\\efe4";
}

.icofont-envelope-open:before {
  content: "\\efe5";
}

.icofont-envelope:before {
  content: "\\efe6";
}

.icofont-eraser:before {
  content: "\\efe7";
}

.icofont-error:before {
  content: "\\efe8";
}

.icofont-exchange:before {
  content: "\\efe9";
}

.icofont-exclamation-circle:before {
  content: "\\efea";
}

.icofont-exclamation-square:before {
  content: "\\efeb";
}

.icofont-exclamation-tringle:before {
  content: "\\efec";
}

.icofont-exclamation:before {
  content: "\\efed";
}

.icofont-exit:before {
  content: "\\efee";
}

.icofont-expand:before {
  content: "\\efef";
}

.icofont-external-link:before {
  content: "\\eff0";
}

.icofont-external:before {
  content: "\\eff1";
}

.icofont-eye-blocked:before {
  content: "\\eff2";
}

.icofont-eye-dropper:before {
  content: "\\eff3";
}

.icofont-eye:before {
  content: "\\eff4";
}

.icofont-favourite:before {
  content: "\\eff5";
}

.icofont-fax:before {
  content: "\\eff6";
}

.icofont-female:before {
  content: "\\eff7";
}

.icofont-file:before {
  content: "\\eff8";
}

.icofont-film:before {
  content: "\\eff9";
}

.icofont-filter:before {
  content: "\\effa";
}

.icofont-fire-burn:before {
  content: "\\effb";
}

.icofont-fire-extinguisher:before {
  content: "\\effc";
}

.icofont-fire:before {
  content: "\\effd";
}

.icofont-first-aid:before {
  content: "\\effe";
}

.icofont-flag-alt-1:before {
  content: "\\efff";
}

.icofont-flag-alt-2:before {
  content: "\\f000";
}

.icofont-flag:before {
  content: "\\f001";
}

.icofont-flash-light:before {
  content: "\\f002";
}

.icofont-flash:before {
  content: "\\f003";
}

.icofont-flask:before {
  content: "\\f004";
}

.icofont-focus:before {
  content: "\\f005";
}

.icofont-folder-open:before {
  content: "\\f006";
}

.icofont-folder:before {
  content: "\\f007";
}

.icofont-foot-print:before {
  content: "\\f008";
}

.icofont-football-american:before {
  content: "\\f009";
}

.icofont-football:before {
  content: "\\f00a";
}

.icofont-game-console:before {
  content: "\\f00b";
}

.icofont-game-pad:before {
  content: "\\f00c";
}

.icofont-gavel:before {
  content: "\\f00d";
}

.icofont-gear:before {
  content: "\\f00e";
}

.icofont-gears:before {
  content: "\\f00f";
}

.icofont-gift:before {
  content: "\\f010";
}

.icofont-glass:before {
  content: "\\f011";
}

.icofont-globe:before {
  content: "\\f012";
}

.icofont-graduate:before {
  content: "\\f013";
}

.icofont-graffiti:before {
  content: "\\f014";
}

.icofont-grocery:before {
  content: "\\f015";
}

.icofont-group:before {
  content: "\\f016";
}

.icofont-hammer:before {
  content: "\\f017";
}

.icofont-hand:before {
  content: "\\f018";
}

.icofont-hanger:before {
  content: "\\f019";
}

.icofont-hard-disk:before {
  content: "\\f01a";
}

.icofont-headphone:before {
  content: "\\f01b";
}

.icofont-heart-beat:before {
  content: "\\f01c";
}

.icofont-heart:before {
  content: "\\f01d";
}

.icofont-history:before {
  content: "\\f01e";
}

.icofont-home:before {
  content: "\\f01f";
}

.icofont-horn:before {
  content: "\\f020";
}

.icofont-hotel:before {
  content: "\\f021";
}

.icofont-hour-glass:before {
  content: "\\f022";
}

.icofont-id:before {
  content: "\\f023";
}

.icofont-image:before {
  content: "\\f024";
}

.icofont-inbox:before {
  content: "\\f025";
}

.icofont-infinite:before {
  content: "\\f026";
}

.icofont-info-circle:before {
  content: "\\f027";
}

.icofont-info-square:before {
  content: "\\f028";
}

.icofont-info:before {
  content: "\\f029";
}

.icofont-institution:before {
  content: "\\f02a";
}

.icofont-interface:before {
  content: "\\f02b";
}

.icofont-invisible:before {
  content: "\\f02c";
}

.icofont-italic:before {
  content: "\\f02d";
}

.icofont-jacket:before {
  content: "\\f02e";
}

.icofont-jar:before {
  content: "\\f02f";
}

.icofont-jewlery:before {
  content: "\\f030";
}

.icofont-karate:before {
  content: "\\f031";
}

.icofont-key-hole:before {
  content: "\\f032";
}

.icofont-key:before {
  content: "\\f033";
}

.icofont-keyboard:before {
  content: "\\f034";
}

.icofont-kid:before {
  content: "\\f035";
}

.icofont-label:before {
  content: "\\f036";
}

.icofont-lamp:before {
  content: "\\f037";
}

.icofont-laptop:before {
  content: "\\f038";
}

.icofont-layers:before {
  content: "\\f039";
}

.icofont-layout:before {
  content: "\\f03a";
}

.icofont-leaf:before {
  content: "\\f03b";
}

.icofont-leaflet:before {
  content: "\\f03c";
}

.icofont-learn:before {
  content: "\\f03d";
}

.icofont-legal:before {
  content: "\\f03e";
}

.icofont-lego:before {
  content: "\\f03f";
}

.icofont-lemon:before {
  content: "\\f040";
}

.icofont-lens:before {
  content: "\\f041";
}

.icofont-letter:before {
  content: "\\f042";
}

.icofont-letterbox:before {
  content: "\\f043";
}

.icofont-library:before {
  content: "\\f044";
}

.icofont-license:before {
  content: "\\f045";
}

.icofont-life-bouy:before {
  content: "\\f046";
}

.icofont-life-buoy:before {
  content: "\\f047";
}

.icofont-life-jacket:before {
  content: "\\f048";
}

.icofont-life-ring:before {
  content: "\\f049";
}

.icofont-light-bulb:before {
  content: "\\f04a";
}

.icofont-lighter:before {
  content: "\\f04b";
}

.icofont-lightning-ray:before {
  content: "\\f04c";
}

.icofont-like:before {
  content: "\\f04d";
}

.icofont-link:before {
  content: "\\f04e";
}

.icofont-live-support:before {
  content: "\\f04f";
}

.icofont-location-arrow:before {
  content: "\\f050";
}

.icofont-location-pin:before {
  content: "\\f051";
}

.icofont-lock:before {
  content: "\\f052";
}

.icofont-login:before {
  content: "\\f053";
}

.icofont-logout:before {
  content: "\\f054";
}

.icofont-lollipop:before {
  content: "\\f055";
}

.icofont-look:before {
  content: "\\f056";
}

.icofont-loop:before {
  content: "\\f057";
}

.icofont-luggage:before {
  content: "\\f058";
}

.icofont-lunch:before {
  content: "\\f059";
}

.icofont-lungs:before {
  content: "\\f05a";
}

.icofont-magic-alt:before {
  content: "\\f05b";
}

.icofont-magic:before {
  content: "\\f05c";
}

.icofont-magnet:before {
  content: "\\f05d";
}

.icofont-mail-box:before {
  content: "\\f05e";
}

.icofont-mail:before {
  content: "\\f05f";
}

.icofont-male:before {
  content: "\\f060";
}

.icofont-map:before {
  content: "\\f061";
}

.icofont-math:before {
  content: "\\f062";
}

.icofont-maximize:before {
  content: "\\f063";
}

.icofont-measure:before {
  content: "\\f064";
}

.icofont-medal:before {
  content: "\\f065";
}

.icofont-medical:before {
  content: "\\f066";
}

.icofont-medicine:before {
  content: "\\f067";
}

.icofont-mega-phone:before {
  content: "\\f068";
}

.icofont-memorial:before {
  content: "\\f069";
}

.icofont-memory-card:before {
  content: "\\f06a";
}

.icofont-mic-mute:before {
  content: "\\f06b";
}

.icofont-mic:before {
  content: "\\f06c";
}

.icofont-micro-chip:before {
  content: "\\f06d";
}

.icofont-microphone:before {
  content: "\\f06e";
}

.icofont-microscope:before {
  content: "\\f06f";
}

.icofont-military:before {
  content: "\\f070";
}

.icofont-mill:before {
  content: "\\f071";
}

.icofont-minus-circle:before {
  content: "\\f072";
}

.icofont-minus-square:before {
  content: "\\f073";
}

.icofont-minus:before {
  content: "\\f074";
}

.icofont-mobile-phone:before {
  content: "\\f075";
}

.icofont-molecule:before {
  content: "\\f076";
}

.icofont-money:before {
  content: "\\f077";
}

.icofont-moon:before {
  content: "\\f078";
}

.icofont-mop:before {
  content: "\\f079";
}

.icofont-muffin:before {
  content: "\\f07a";
}

.icofont-music-alt:before {
  content: "\\f07b";
}

.icofont-music-notes:before {
  content: "\\f07c";
}

.icofont-music:before {
  content: "\\f07d";
}

.icofont-mustache:before {
  content: "\\f07e";
}

.icofont-mute-volume:before {
  content: "\\f07f";
}

.icofont-navigation-menu:before {
  content: "\\f080";
}

.icofont-navigation:before {
  content: "\\f081";
}

.icofont-network-tower:before {
  content: "\\f082";
}

.icofont-network:before {
  content: "\\f083";
}

.icofont-news:before {
  content: "\\f084";
}

.icofont-newspaper:before {
  content: "\\f085";
}

.icofont-no-smoking:before {
  content: "\\f086";
}

.icofont-not-allowed:before {
  content: "\\f087";
}

.icofont-notebook:before {
  content: "\\f088";
}

.icofont-notepad:before {
  content: "\\f089";
}

.icofont-notification:before {
  content: "\\f08a";
}

.icofont-numbered:before {
  content: "\\f08b";
}

.icofont-opposite:before {
  content: "\\f08c";
}

.icofont-optic:before {
  content: "\\f08d";
}

.icofont-options:before {
  content: "\\f08e";
}

.icofont-package:before {
  content: "\\f08f";
}

.icofont-page:before {
  content: "\\f090";
}

.icofont-paint:before {
  content: "\\f091";
}

.icofont-paper-plane:before {
  content: "\\f092";
}

.icofont-paperclip:before {
  content: "\\f093";
}

.icofont-papers:before {
  content: "\\f094";
}

.icofont-paw:before {
  content: "\\f095";
}

.icofont-pay:before {
  content: "\\f096";
}

.icofont-pen:before {
  content: "\\f097";
}

.icofont-pencil:before {
  content: "\\f098";
}

.icofont-penguin-linux:before {
  content: "\\f099";
}

.icofont-pestle:before {
  content: "\\f09a";
}

.icofont-phone-circle:before {
  content: "\\f09b";
}

.icofont-phone:before {
  content: "\\f09c";
}

.icofont-picture:before {
  content: "\\f09d";
}

.icofont-pie:before {
  content: "\\f09e";
}

.icofont-pine:before {
  content: "\\f09f";
}

.icofont-pixels:before {
  content: "\\f0a0";
}

.icofont-play:before {
  content: "\\f0a1";
}

.icofont-plugin:before {
  content: "\\f0a2";
}

.icofont-plus-circle:before {
  content: "\\f0a3";
}

.icofont-plus-square:before {
  content: "\\f0a4";
}

.icofont-plus:before {
  content: "\\f0a5";
}

.icofont-polygonal:before {
  content: "\\f0a6";
}

.icofont-power:before {
  content: "\\f0a7";
}

.icofont-presentation:before {
  content: "\\f0a8";
}

.icofont-price:before {
  content: "\\f0a9";
}

.icofont-print:before {
  content: "\\f0aa";
}

.icofont-puzzle:before {
  content: "\\f0ab";
}

.icofont-qr-code:before {
  content: "\\f0ac";
}

.icofont-queen:before {
  content: "\\f0ad";
}

.icofont-question-circle:before {
  content: "\\f0ae";
}

.icofont-question-square:before {
  content: "\\f0af";
}

.icofont-question:before {
  content: "\\f0b0";
}

.icofont-quote-left:before {
  content: "\\f0b1";
}

.icofont-quote-right:before {
  content: "\\f0b2";
}

.icofont-radio:before {
  content: "\\f0b3";
}

.icofont-random:before {
  content: "\\f0b4";
}

.icofont-recycle:before {
  content: "\\f0b5";
}

.icofont-refresh:before {
  content: "\\f0b6";
}

.icofont-repair:before {
  content: "\\f0b7";
}

.icofont-reply-all:before {
  content: "\\f0b8";
}

.icofont-reply:before {
  content: "\\f0b9";
}

.icofont-resize:before {
  content: "\\f0ba";
}

.icofont-responsive:before {
  content: "\\f0bb";
}

.icofont-retweet:before {
  content: "\\f0bc";
}

.icofont-road:before {
  content: "\\f0bd";
}

.icofont-robot:before {
  content: "\\f0be";
}

.icofont-rocket:before {
  content: "\\f0bf";
}

.icofont-royal:before {
  content: "\\f0c0";
}

.icofont-rss-feed:before {
  content: "\\f0c1";
}

.icofont-safety:before {
  content: "\\f0c2";
}

.icofont-sale-discount:before {
  content: "\\f0c3";
}

.icofont-satellite:before {
  content: "\\f0c4";
}

.icofont-send-mail:before {
  content: "\\f0c5";
}

.icofont-server:before {
  content: "\\f0c6";
}

.icofont-settings:before {
  content: "\\f0c7";
}

.icofont-share-alt:before {
  content: "\\f0c8";
}

.icofont-share-boxed:before {
  content: "\\f0c9";
}

.icofont-share:before {
  content: "\\f0ca";
}

.icofont-shield:before {
  content: "\\f0cb";
}

.icofont-ship:before {
  content: "\\f0cc";
}

.icofont-shopping-cart:before {
  content: "\\f0cd";
}

.icofont-sign-in:before {
  content: "\\f0ce";
}

.icofont-sign-out:before {
  content: "\\f0cf";
}

.icofont-signal:before {
  content: "\\f0d0";
}

.icofont-site-map:before {
  content: "\\f0d1";
}

.icofont-smart-phone:before {
  content: "\\f0d2";
}

.icofont-soccer:before {
  content: "\\f0d3";
}

.icofont-sort-alt:before {
  content: "\\f0d4";
}

.icofont-sort:before {
  content: "\\f0d5";
}

.icofont-space:before {
  content: "\\f0d6";
}

.icofont-spanner:before {
  content: "\\f0d7";
}

.icofont-speech-comments:before {
  content: "\\f0d8";
}

.icofont-speed-meter:before {
  content: "\\f0d9";
}

.icofont-spinner-alt-1:before {
  content: "\\f0da";
}

.icofont-spinner-alt-2:before {
  content: "\\f0db";
}

.icofont-spinner-alt-3:before {
  content: "\\f0dc";
}

.icofont-spinner-alt-4:before {
  content: "\\f0dd";
}

.icofont-spinner-alt-5:before {
  content: "\\f0de";
}

.icofont-spinner-alt-6:before {
  content: "\\f0df";
}

.icofont-spinner:before {
  content: "\\f0e0";
}

.icofont-spreadsheet:before {
  content: "\\f0e1";
}

.icofont-square:before {
  content: "\\f0e2";
}

.icofont-ssl-security:before {
  content: "\\f0e3";
}

.icofont-star-alt-1:before {
  content: "\\f0e4";
}

.icofont-star-alt-2:before {
  content: "\\f0e5";
}

.icofont-star:before {
  content: "\\f0e6";
}

.icofont-street-view:before {
  content: "\\f0e7";
}

.icofont-sun:before {
  content: "\\f0e8";
}

.icofont-support-faq:before {
  content: "\\f0e9";
}

.icofont-tack-pin:before {
  content: "\\f0ea";
}

.icofont-tag:before {
  content: "\\f0eb";
}

.icofont-tags:before {
  content: "\\f0ec";
}

.icofont-tasks:before {
  content: "\\f0ed";
}

.icofont-telephone:before {
  content: "\\f0ee";
}

.icofont-telescope:before {
  content: "\\f0ef";
}

.icofont-terminal:before {
  content: "\\f0f0";
}

.icofont-thumbs-down:before {
  content: "\\f0f1";
}

.icofont-thumbs-up:before {
  content: "\\f0f2";
}

.icofont-tick-boxed:before {
  content: "\\f0f3";
}

.icofont-tick-mark:before {
  content: "\\f0f4";
}

.icofont-ticket:before {
  content: "\\f0f5";
}

.icofont-tie:before {
  content: "\\f0f6";
}

.icofont-toggle-off:before {
  content: "\\f0f7";
}

.icofont-toggle-on:before {
  content: "\\f0f8";
}

.icofont-tools:before {
  content: "\\f0f9";
}

.icofont-transparent:before {
  content: "\\f0fa";
}

.icofont-tree:before {
  content: "\\f0fb";
}

.icofont-umbrella:before {
  content: "\\f0fc";
}

.icofont-unlock:before {
  content: "\\f0fd";
}

.icofont-unlocked:before {
  content: "\\f0fe";
}

.icofont-upload-alt:before {
  content: "\\f0ff";
}

.icofont-upload:before {
  content: "\\f100";
}

.icofont-usb-drive:before {
  content: "\\f101";
}

.icofont-usb:before {
  content: "\\f102";
}

.icofont-vector-path:before {
  content: "\\f103";
}

.icofont-verification-check:before {
  content: "\\f104";
}

.icofont-video-clapper:before {
  content: "\\f105";
}

.icofont-video:before {
  content: "\\f106";
}

.icofont-volume-down:before {
  content: "\\f107";
}

.icofont-volume-off:before {
  content: "\\f108";
}

.icofont-volume-up:before {
  content: "\\f109";
}

.icofont-wall-clock:before {
  content: "\\f10a";
}

.icofont-wall:before {
  content: "\\f10b";
}

.icofont-wallet:before {
  content: "\\f10c";
}

.icofont-warning-alt:before {
  content: "\\f10d";
}

.icofont-warning:before {
  content: "\\f10e";
}

.icofont-water-drop:before {
  content: "\\f10f";
}

.icofont-web:before {
  content: "\\f110";
}

.icofont-wheelchair:before {
  content: "\\f111";
}

.icofont-wifi-alt:before {
  content: "\\f112";
}

.icofont-wifi:before {
  content: "\\f113";
}

.icofont-world:before {
  content: "\\f114";
}

.icofont-zigzag:before {
  content: "\\f115";
}

.icofont-zipped:before {
  content: "\\f116";
}

.icofont-social-500px:before {
  content: "\\f117";
}

.icofont-social-baidu-tieba:before {
  content: "\\f118";
}

.icofont-social-bbm-messenger:before {
  content: "\\f119";
}

.icofont-social-delicious:before {
  content: "\\f11a";
}

.icofont-social-dribbble:before {
  content: "\\f11b";
}

.icofont-social-facebook-messenger:before {
  content: "\\f11c";
}

.icofont-social-flikr:before {
  content: "\\f11d";
}

.icofont-social-foursquare:before {
  content: "\\f11e";
}

.icofont-social-google-hangouts:before {
  content: "\\f11f";
}

.icofont-social-kakaotalk:before {
  content: "\\f120";
}

.icofont-social-kik:before {
  content: "\\f121";
}

.icofont-social-kiwibox:before {
  content: "\\f122";
}

.icofont-social-linkedin:before {
  content: "\\f123";
}

.icofont-social-meetme:before {
  content: "\\f124";
}

.icofont-social-odnoklassniki:before {
  content: "\\f125";
}

.icofont-social-photobucket:before {
  content: "\\f126";
}

.icofont-social-qq:before {
  content: "\\f127";
}

.icofont-social-renren:before {
  content: "\\f128";
}

.icofont-social-slack:before {
  content: "\\f129";
}

.icofont-social-slidshare:before {
  content: "\\f12a";
}

.icofont-social-snapchat:before {
  content: "\\f12b";
}

.icofont-social-soundcloud:before {
  content: "\\f12c";
}

.icofont-social-spotify:before {
  content: "\\f12d";
}

.icofont-social-stack-exchange:before {
  content: "\\f12e";
}

.icofont-social-stack-overflow:before {
  content: "\\f12f";
}

.icofont-social-tagged:before {
  content: "\\f130";
}

.icofont-social-trello:before {
  content: "\\f131";
}

.icofont-social-twitch:before {
  content: "\\f132";
}

.icofont-social-vk:before {
  content: "\\f133";
}

.icofont-social-weibo:before {
  content: "\\f134";
}

.icofont-social-whatsapp:before {
  content: "\\f135";
}

.icofont-social-youku:before {
  content: "\\f136";
}

.icofont-social-youtube-play:before {
  content: "\\f137";
}

.icofont-social-youtube:before {
  content: "\\f138";
}

.icofont-brand-xiaomi:before {
  content: "\\f139";
}

/*Font size*/
.icofont-lg {
  font-size: 1.33333333em;
  line-height: 0.75em;
  vertical-align: -15%;
}

.icofont-2x {
  font-size: 2em;
}

.icofont-3x {
  font-size: 3em;
}

.icofont-4x {
  font-size: 4em;
}

.icofont-5x {
  font-size: 5em;
}

.icofont-fw {
  display: inline-block;
  width: 1.28571429em;
  text-align: center;
  width: 1.28571429em;
  text-align: center;
}

/*Fixed Width Icons*/
/*Custom list icons*/
.icofont-ul {
  padding-left: 0;
  margin-left: 2.14285714em;
  list-style-type: none;
}
.icofont-ul > li {
  position: relative;
}

.icofont-li {
  position: absolute;
  left: -2.14285714em;
  width: 2.14285714em;
  top: 0.14285714em;
  text-align: center;
}

/*Animation*/
.icofont-rotate {
  display: inline-block;
  animation: icofont-rotate 2s infinite linear;
}
@keyframes icofont-rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}
/*!
 *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome
 *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)
 */
/* FONT PATH
 * -------------------------- */
@font-face {
  font-family: "FontAwesome";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_299___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_300___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_301___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_302___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_303___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_304___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
.fa {
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* makes the font 33% larger relative to the icon container */
.fa-lg {
  font-size: 1.3333333333em;
  line-height: 0.75em;
  vertical-align: -15%;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-fw {
  width: 1.2857142857em;
  text-align: center;
}

.fa-ul {
  padding-left: 0;
  margin-left: 2.1428571429em;
  list-style-type: none;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  position: absolute;
  left: -2.1428571429em;
  width: 2.1428571429em;
  top: 0.1428571429em;
  text-align: center;
}
.fa-li.fa-lg {
  left: -1.8571428571em;
}

.fa-border {
  padding: 0.2em 0.25em 0.15em;
  border: solid 0.08em #eee;
  border-radius: 0.1em;
}

.fa-pull-left {
  float: left;
}

.fa-pull-right {
  float: right;
}

.fa.fa-pull-left {
  margin-right: 0.3em;
}
.fa.fa-pull-right {
  margin-left: 0.3em;
}

/* Deprecated as of 4.4.0 */
.pull-right {
  float: right;
}

.pull-left {
  float: left;
}

.fa.pull-left {
  margin-right: 0.3em;
}
.fa.pull-right {
  margin-left: 0.3em;
}

.fa-spin {
  animation: fa-spin 2s infinite linear;
}

.fa-pulse {
  animation: fa-spin 1s infinite steps(8);
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}
.fa-rotate-90 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";
  transform: rotate(90deg);
}

.fa-rotate-180 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";
  transform: rotate(180deg);
}

.fa-rotate-270 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";
  transform: scale(-1, 1);
}

.fa-flip-vertical {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
  transform: scale(1, -1);
}

:root .fa-rotate-90,
:root .fa-rotate-180,
:root .fa-rotate-270,
:root .fa-flip-horizontal,
:root .fa-flip-vertical {
  filter: none;
}

.fa-stack {
  position: relative;
  display: inline-block;
  width: 2em;
  height: 2em;
  line-height: 2em;
  vertical-align: middle;
}

.fa-stack-1x, .fa-stack-2x {
  position: absolute;
  left: 0;
  width: 100%;
  text-align: center;
}

.fa-stack-1x {
  line-height: inherit;
}

.fa-stack-2x {
  font-size: 2em;
}

.fa-inverse {
  color: #fff;
}

/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen
   readers do not read off random characters that represent icons */
.fa-glass:before {
  content: "\\f000";
}

.fa-music:before {
  content: "\\f001";
}

.fa-search:before {
  content: "\\f002";
}

.fa-envelope-o:before {
  content: "\\f003";
}

.fa-heart:before {
  content: "\\f004";
}

.fa-star:before {
  content: "\\f005";
}

.fa-star-o:before {
  content: "\\f006";
}

.fa-user:before {
  content: "\\f007";
}

.fa-film:before {
  content: "\\f008";
}

.fa-th-large:before {
  content: "\\f009";
}

.fa-th:before {
  content: "\\f00a";
}

.fa-th-list:before {
  content: "\\f00b";
}

.fa-check:before {
  content: "\\f00c";
}

.fa-remove:before,
.fa-close:before,
.fa-times:before {
  content: "\\f00d";
}

.fa-search-plus:before {
  content: "\\f00e";
}

.fa-search-minus:before {
  content: "\\f010";
}

.fa-power-off:before {
  content: "\\f011";
}

.fa-signal:before {
  content: "\\f012";
}

.fa-gear:before,
.fa-cog:before {
  content: "\\f013";
}

.fa-trash-o:before {
  content: "\\f014";
}

.fa-home:before {
  content: "\\f015";
}

.fa-file-o:before {
  content: "\\f016";
}

.fa-clock-o:before {
  content: "\\f017";
}

.fa-road:before {
  content: "\\f018";
}

.fa-download:before {
  content: "\\f019";
}

.fa-arrow-circle-o-down:before {
  content: "\\f01a";
}

.fa-arrow-circle-o-up:before {
  content: "\\f01b";
}

.fa-inbox:before {
  content: "\\f01c";
}

.fa-play-circle-o:before {
  content: "\\f01d";
}

.fa-rotate-right:before,
.fa-repeat:before {
  content: "\\f01e";
}

.fa-refresh:before {
  content: "\\f021";
}

.fa-list-alt:before {
  content: "\\f022";
}

.fa-lock:before {
  content: "\\f023";
}

.fa-flag:before {
  content: "\\f024";
}

.fa-headphones:before {
  content: "\\f025";
}

.fa-volume-off:before {
  content: "\\f026";
}

.fa-volume-down:before {
  content: "\\f027";
}

.fa-volume-up:before {
  content: "\\f028";
}

.fa-qrcode:before {
  content: "\\f029";
}

.fa-barcode:before {
  content: "\\f02a";
}

.fa-tag:before {
  content: "\\f02b";
}

.fa-tags:before {
  content: "\\f02c";
}

.fa-book:before {
  content: "\\f02d";
}

.fa-bookmark:before {
  content: "\\f02e";
}

.fa-print:before {
  content: "\\f02f";
}

.fa-camera:before {
  content: "\\f030";
}

.fa-font:before {
  content: "\\f031";
}

.fa-bold:before {
  content: "\\f032";
}

.fa-italic:before {
  content: "\\f033";
}

.fa-text-height:before {
  content: "\\f034";
}

.fa-text-width:before {
  content: "\\f035";
}

.fa-align-left:before {
  content: "\\f036";
}

.fa-align-center:before {
  content: "\\f037";
}

.fa-align-right:before {
  content: "\\f038";
}

.fa-align-justify:before {
  content: "\\f039";
}

.fa-list:before {
  content: "\\f03a";
}

.fa-dedent:before,
.fa-outdent:before {
  content: "\\f03b";
}

.fa-indent:before {
  content: "\\f03c";
}

.fa-video-camera:before {
  content: "\\f03d";
}

.fa-photo:before,
.fa-image:before,
.fa-picture-o:before {
  content: "\\f03e";
}

.fa-pencil:before {
  content: "\\f040";
}

.fa-map-marker:before {
  content: "\\f041";
}

.fa-adjust:before {
  content: "\\f042";
}

.fa-tint:before {
  content: "\\f043";
}

.fa-edit:before,
.fa-pencil-square-o:before {
  content: "\\f044";
}

.fa-share-square-o:before {
  content: "\\f045";
}

.fa-check-square-o:before {
  content: "\\f046";
}

.fa-arrows:before {
  content: "\\f047";
}

.fa-step-backward:before {
  content: "\\f048";
}

.fa-fast-backward:before {
  content: "\\f049";
}

.fa-backward:before {
  content: "\\f04a";
}

.fa-play:before {
  content: "\\f04b";
}

.fa-pause:before {
  content: "\\f04c";
}

.fa-stop:before {
  content: "\\f04d";
}

.fa-forward:before {
  content: "\\f04e";
}

.fa-fast-forward:before {
  content: "\\f050";
}

.fa-step-forward:before {
  content: "\\f051";
}

.fa-eject:before {
  content: "\\f052";
}

.fa-chevron-left:before {
  content: "\\f053";
}

.fa-chevron-right:before {
  content: "\\f054";
}

.fa-plus-circle:before {
  content: "\\f055";
}

.fa-minus-circle:before {
  content: "\\f056";
}

.fa-times-circle:before {
  content: "\\f057";
}

.fa-check-circle:before {
  content: "\\f058";
}

.fa-question-circle:before {
  content: "\\f059";
}

.fa-info-circle:before {
  content: "\\f05a";
}

.fa-crosshairs:before {
  content: "\\f05b";
}

.fa-times-circle-o:before {
  content: "\\f05c";
}

.fa-check-circle-o:before {
  content: "\\f05d";
}

.fa-ban:before {
  content: "\\f05e";
}

.fa-arrow-left:before {
  content: "\\f060";
}

.fa-arrow-right:before {
  content: "\\f061";
}

.fa-arrow-up:before {
  content: "\\f062";
}

.fa-arrow-down:before {
  content: "\\f063";
}

.fa-mail-forward:before,
.fa-share:before {
  content: "\\f064";
}

.fa-expand:before {
  content: "\\f065";
}

.fa-compress:before {
  content: "\\f066";
}

.fa-plus:before {
  content: "\\f067";
}

.fa-minus:before {
  content: "\\f068";
}

.fa-asterisk:before {
  content: "\\f069";
}

.fa-exclamation-circle:before {
  content: "\\f06a";
}

.fa-gift:before {
  content: "\\f06b";
}

.fa-leaf:before {
  content: "\\f06c";
}

.fa-fire:before {
  content: "\\f06d";
}

.fa-eye:before {
  content: "\\f06e";
}

.fa-eye-slash:before {
  content: "\\f070";
}

.fa-warning:before,
.fa-exclamation-triangle:before {
  content: "\\f071";
}

.fa-plane:before {
  content: "\\f072";
}

.fa-calendar:before {
  content: "\\f073";
}

.fa-random:before {
  content: "\\f074";
}

.fa-comment:before {
  content: "\\f075";
}

.fa-magnet:before {
  content: "\\f076";
}

.fa-chevron-up:before {
  content: "\\f077";
}

.fa-chevron-down:before {
  content: "\\f078";
}

.fa-retweet:before {
  content: "\\f079";
}

.fa-shopping-cart:before {
  content: "\\f07a";
}

.fa-folder:before {
  content: "\\f07b";
}

.fa-folder-open:before {
  content: "\\f07c";
}

.fa-arrows-v:before {
  content: "\\f07d";
}

.fa-arrows-h:before {
  content: "\\f07e";
}

.fa-bar-chart-o:before,
.fa-bar-chart:before {
  content: "\\f080";
}

.fa-twitter-square:before {
  content: "\\f081";
}

.fa-facebook-square:before {
  content: "\\f082";
}

.fa-camera-retro:before {
  content: "\\f083";
}

.fa-key:before {
  content: "\\f084";
}

.fa-gears:before,
.fa-cogs:before {
  content: "\\f085";
}

.fa-comments:before {
  content: "\\f086";
}

.fa-thumbs-o-up:before {
  content: "\\f087";
}

.fa-thumbs-o-down:before {
  content: "\\f088";
}

.fa-star-half:before {
  content: "\\f089";
}

.fa-heart-o:before {
  content: "\\f08a";
}

.fa-sign-out:before {
  content: "\\f08b";
}

.fa-linkedin-square:before {
  content: "\\f08c";
}

.fa-thumb-tack:before {
  content: "\\f08d";
}

.fa-external-link:before {
  content: "\\f08e";
}

.fa-sign-in:before {
  content: "\\f090";
}

.fa-trophy:before {
  content: "\\f091";
}

.fa-github-square:before {
  content: "\\f092";
}

.fa-upload:before {
  content: "\\f093";
}

.fa-lemon-o:before {
  content: "\\f094";
}

.fa-phone:before {
  content: "\\f095";
}

.fa-square-o:before {
  content: "\\f096";
}

.fa-bookmark-o:before {
  content: "\\f097";
}

.fa-phone-square:before {
  content: "\\f098";
}

.fa-twitter:before {
  content: "\\f099";
}

.fa-facebook-f:before,
.fa-facebook:before {
  content: "\\f09a";
}

.fa-github:before {
  content: "\\f09b";
}

.fa-unlock:before {
  content: "\\f09c";
}

.fa-credit-card:before {
  content: "\\f09d";
}

.fa-feed:before,
.fa-rss:before {
  content: "\\f09e";
}

.fa-hdd-o:before {
  content: "\\f0a0";
}

.fa-bullhorn:before {
  content: "\\f0a1";
}

.fa-bell:before {
  content: "\\f0f3";
}

.fa-certificate:before {
  content: "\\f0a3";
}

.fa-hand-o-right:before {
  content: "\\f0a4";
}

.fa-hand-o-left:before {
  content: "\\f0a5";
}

.fa-hand-o-up:before {
  content: "\\f0a6";
}

.fa-hand-o-down:before {
  content: "\\f0a7";
}

.fa-arrow-circle-left:before {
  content: "\\f0a8";
}

.fa-arrow-circle-right:before {
  content: "\\f0a9";
}

.fa-arrow-circle-up:before {
  content: "\\f0aa";
}

.fa-arrow-circle-down:before {
  content: "\\f0ab";
}

.fa-globe:before {
  content: "\\f0ac";
}

.fa-wrench:before {
  content: "\\f0ad";
}

.fa-tasks:before {
  content: "\\f0ae";
}

.fa-filter:before {
  content: "\\f0b0";
}

.fa-briefcase:before {
  content: "\\f0b1";
}

.fa-arrows-alt:before {
  content: "\\f0b2";
}

.fa-group:before,
.fa-users:before {
  content: "\\f0c0";
}

.fa-chain:before,
.fa-link:before {
  content: "\\f0c1";
}

.fa-cloud:before {
  content: "\\f0c2";
}

.fa-flask:before {
  content: "\\f0c3";
}

.fa-cut:before,
.fa-scissors:before {
  content: "\\f0c4";
}

.fa-copy:before,
.fa-files-o:before {
  content: "\\f0c5";
}

.fa-paperclip:before {
  content: "\\f0c6";
}

.fa-save:before,
.fa-floppy-o:before {
  content: "\\f0c7";
}

.fa-square:before {
  content: "\\f0c8";
}

.fa-navicon:before,
.fa-reorder:before,
.fa-bars:before {
  content: "\\f0c9";
}

.fa-list-ul:before {
  content: "\\f0ca";
}

.fa-list-ol:before {
  content: "\\f0cb";
}

.fa-strikethrough:before {
  content: "\\f0cc";
}

.fa-underline:before {
  content: "\\f0cd";
}

.fa-table:before {
  content: "\\f0ce";
}

.fa-magic:before {
  content: "\\f0d0";
}

.fa-truck:before {
  content: "\\f0d1";
}

.fa-pinterest:before {
  content: "\\f0d2";
}

.fa-pinterest-square:before {
  content: "\\f0d3";
}

.fa-google-plus-square:before {
  content: "\\f0d4";
}

.fa-google-plus:before {
  content: "\\f0d5";
}

.fa-money:before {
  content: "\\f0d6";
}

.fa-caret-down:before {
  content: "\\f0d7";
}

.fa-caret-up:before {
  content: "\\f0d8";
}

.fa-caret-left:before {
  content: "\\f0d9";
}

.fa-caret-right:before {
  content: "\\f0da";
}

.fa-columns:before {
  content: "\\f0db";
}

.fa-unsorted:before,
.fa-sort:before {
  content: "\\f0dc";
}

.fa-sort-down:before,
.fa-sort-desc:before {
  content: "\\f0dd";
}

.fa-sort-up:before,
.fa-sort-asc:before {
  content: "\\f0de";
}

.fa-envelope:before {
  content: "\\f0e0";
}

.fa-linkedin:before {
  content: "\\f0e1";
}

.fa-rotate-left:before,
.fa-undo:before {
  content: "\\f0e2";
}

.fa-legal:before,
.fa-gavel:before {
  content: "\\f0e3";
}

.fa-dashboard:before,
.fa-tachometer:before {
  content: "\\f0e4";
}

.fa-comment-o:before {
  content: "\\f0e5";
}

.fa-comments-o:before {
  content: "\\f0e6";
}

.fa-flash:before,
.fa-bolt:before {
  content: "\\f0e7";
}

.fa-sitemap:before {
  content: "\\f0e8";
}

.fa-umbrella:before {
  content: "\\f0e9";
}

.fa-paste:before,
.fa-clipboard:before {
  content: "\\f0ea";
}

.fa-lightbulb-o:before {
  content: "\\f0eb";
}

.fa-exchange:before {
  content: "\\f0ec";
}

.fa-cloud-download:before {
  content: "\\f0ed";
}

.fa-cloud-upload:before {
  content: "\\f0ee";
}

.fa-user-md:before {
  content: "\\f0f0";
}

.fa-stethoscope:before {
  content: "\\f0f1";
}

.fa-suitcase:before {
  content: "\\f0f2";
}

.fa-bell-o:before {
  content: "\\f0a2";
}

.fa-coffee:before {
  content: "\\f0f4";
}

.fa-cutlery:before {
  content: "\\f0f5";
}

.fa-file-text-o:before {
  content: "\\f0f6";
}

.fa-building-o:before {
  content: "\\f0f7";
}

.fa-hospital-o:before {
  content: "\\f0f8";
}

.fa-ambulance:before {
  content: "\\f0f9";
}

.fa-medkit:before {
  content: "\\f0fa";
}

.fa-fighter-jet:before {
  content: "\\f0fb";
}

.fa-beer:before {
  content: "\\f0fc";
}

.fa-h-square:before {
  content: "\\f0fd";
}

.fa-plus-square:before {
  content: "\\f0fe";
}

.fa-angle-double-left:before {
  content: "\\f100";
}

.fa-angle-double-right:before {
  content: "\\f101";
}

.fa-angle-double-up:before {
  content: "\\f102";
}

.fa-angle-double-down:before {
  content: "\\f103";
}

.fa-angle-left:before {
  content: "\\f104";
}

.fa-angle-right:before {
  content: "\\f105";
}

.fa-angle-up:before {
  content: "\\f106";
}

.fa-angle-down:before {
  content: "\\f107";
}

.fa-desktop:before {
  content: "\\f108";
}

.fa-laptop:before {
  content: "\\f109";
}

.fa-tablet:before {
  content: "\\f10a";
}

.fa-mobile-phone:before,
.fa-mobile:before {
  content: "\\f10b";
}

.fa-circle-o:before {
  content: "\\f10c";
}

.fa-quote-left:before {
  content: "\\f10d";
}

.fa-quote-right:before {
  content: "\\f10e";
}

.fa-spinner:before {
  content: "\\f110";
}

.fa-circle:before {
  content: "\\f111";
}

.fa-mail-reply:before,
.fa-reply:before {
  content: "\\f112";
}

.fa-github-alt:before {
  content: "\\f113";
}

.fa-folder-o:before {
  content: "\\f114";
}

.fa-folder-open-o:before {
  content: "\\f115";
}

.fa-smile-o:before {
  content: "\\f118";
}

.fa-frown-o:before {
  content: "\\f119";
}

.fa-meh-o:before {
  content: "\\f11a";
}

.fa-gamepad:before {
  content: "\\f11b";
}

.fa-keyboard-o:before {
  content: "\\f11c";
}

.fa-flag-o:before {
  content: "\\f11d";
}

.fa-flag-checkered:before {
  content: "\\f11e";
}

.fa-terminal:before {
  content: "\\f120";
}

.fa-code:before {
  content: "\\f121";
}

.fa-mail-reply-all:before,
.fa-reply-all:before {
  content: "\\f122";
}

.fa-star-half-empty:before,
.fa-star-half-full:before,
.fa-star-half-o:before {
  content: "\\f123";
}

.fa-location-arrow:before {
  content: "\\f124";
}

.fa-crop:before {
  content: "\\f125";
}

.fa-code-fork:before {
  content: "\\f126";
}

.fa-unlink:before,
.fa-chain-broken:before {
  content: "\\f127";
}

.fa-question:before {
  content: "\\f128";
}

.fa-info:before {
  content: "\\f129";
}

.fa-exclamation:before {
  content: "\\f12a";
}

.fa-superscript:before {
  content: "\\f12b";
}

.fa-subscript:before {
  content: "\\f12c";
}

.fa-eraser:before {
  content: "\\f12d";
}

.fa-puzzle-piece:before {
  content: "\\f12e";
}

.fa-microphone:before {
  content: "\\f130";
}

.fa-microphone-slash:before {
  content: "\\f131";
}

.fa-shield:before {
  content: "\\f132";
}

.fa-calendar-o:before {
  content: "\\f133";
}

.fa-fire-extinguisher:before {
  content: "\\f134";
}

.fa-rocket:before {
  content: "\\f135";
}

.fa-maxcdn:before {
  content: "\\f136";
}

.fa-chevron-circle-left:before {
  content: "\\f137";
}

.fa-chevron-circle-right:before {
  content: "\\f138";
}

.fa-chevron-circle-up:before {
  content: "\\f139";
}

.fa-chevron-circle-down:before {
  content: "\\f13a";
}

.fa-html5:before {
  content: "\\f13b";
}

.fa-css3:before {
  content: "\\f13c";
}

.fa-anchor:before {
  content: "\\f13d";
}

.fa-unlock-alt:before {
  content: "\\f13e";
}

.fa-bullseye:before {
  content: "\\f140";
}

.fa-ellipsis-h:before {
  content: "\\f141";
}

.fa-ellipsis-v:before {
  content: "\\f142";
}

.fa-rss-square:before {
  content: "\\f143";
}

.fa-play-circle:before {
  content: "\\f144";
}

.fa-ticket:before {
  content: "\\f145";
}

.fa-minus-square:before {
  content: "\\f146";
}

.fa-minus-square-o:before {
  content: "\\f147";
}

.fa-level-up:before {
  content: "\\f148";
}

.fa-level-down:before {
  content: "\\f149";
}

.fa-check-square:before {
  content: "\\f14a";
}

.fa-pencil-square:before {
  content: "\\f14b";
}

.fa-external-link-square:before {
  content: "\\f14c";
}

.fa-share-square:before {
  content: "\\f14d";
}

.fa-compass:before {
  content: "\\f14e";
}

.fa-toggle-down:before,
.fa-caret-square-o-down:before {
  content: "\\f150";
}

.fa-toggle-up:before,
.fa-caret-square-o-up:before {
  content: "\\f151";
}

.fa-toggle-right:before,
.fa-caret-square-o-right:before {
  content: "\\f152";
}

.fa-euro:before,
.fa-eur:before {
  content: "\\f153";
}

.fa-gbp:before {
  content: "\\f154";
}

.fa-dollar:before,
.fa-usd:before {
  content: "\\f155";
}

.fa-rupee:before,
.fa-inr:before {
  content: "\\f156";
}

.fa-cny:before,
.fa-rmb:before,
.fa-yen:before,
.fa-jpy:before {
  content: "\\f157";
}

.fa-ruble:before,
.fa-rouble:before,
.fa-rub:before {
  content: "\\f158";
}

.fa-won:before,
.fa-krw:before {
  content: "\\f159";
}

.fa-bitcoin:before,
.fa-btc:before {
  content: "\\f15a";
}

.fa-file:before {
  content: "\\f15b";
}

.fa-file-text:before {
  content: "\\f15c";
}

.fa-sort-alpha-asc:before {
  content: "\\f15d";
}

.fa-sort-alpha-desc:before {
  content: "\\f15e";
}

.fa-sort-amount-asc:before {
  content: "\\f160";
}

.fa-sort-amount-desc:before {
  content: "\\f161";
}

.fa-sort-numeric-asc:before {
  content: "\\f162";
}

.fa-sort-numeric-desc:before {
  content: "\\f163";
}

.fa-thumbs-up:before {
  content: "\\f164";
}

.fa-thumbs-down:before {
  content: "\\f165";
}

.fa-youtube-square:before {
  content: "\\f166";
}

.fa-youtube:before {
  content: "\\f167";
}

.fa-xing:before {
  content: "\\f168";
}

.fa-xing-square:before {
  content: "\\f169";
}

.fa-youtube-play:before {
  content: "\\f16a";
}

.fa-dropbox:before {
  content: "\\f16b";
}

.fa-stack-overflow:before {
  content: "\\f16c";
}

.fa-instagram:before {
  content: "\\f16d";
}

.fa-flickr:before {
  content: "\\f16e";
}

.fa-adn:before {
  content: "\\f170";
}

.fa-bitbucket:before {
  content: "\\f171";
}

.fa-bitbucket-square:before {
  content: "\\f172";
}

.fa-tumblr:before {
  content: "\\f173";
}

.fa-tumblr-square:before {
  content: "\\f174";
}

.fa-long-arrow-down:before {
  content: "\\f175";
}

.fa-long-arrow-up:before {
  content: "\\f176";
}

.fa-long-arrow-left:before {
  content: "\\f177";
}

.fa-long-arrow-right:before {
  content: "\\f178";
}

.fa-apple:before {
  content: "\\f179";
}

.fa-windows:before {
  content: "\\f17a";
}

.fa-android:before {
  content: "\\f17b";
}

.fa-linux:before {
  content: "\\f17c";
}

.fa-dribbble:before {
  content: "\\f17d";
}

.fa-skype:before {
  content: "\\f17e";
}

.fa-foursquare:before {
  content: "\\f180";
}

.fa-trello:before {
  content: "\\f181";
}

.fa-female:before {
  content: "\\f182";
}

.fa-male:before {
  content: "\\f183";
}

.fa-gittip:before,
.fa-gratipay:before {
  content: "\\f184";
}

.fa-sun-o:before {
  content: "\\f185";
}

.fa-moon-o:before {
  content: "\\f186";
}

.fa-archive:before {
  content: "\\f187";
}

.fa-bug:before {
  content: "\\f188";
}

.fa-vk:before {
  content: "\\f189";
}

.fa-weibo:before {
  content: "\\f18a";
}

.fa-renren:before {
  content: "\\f18b";
}

.fa-pagelines:before {
  content: "\\f18c";
}

.fa-stack-exchange:before {
  content: "\\f18d";
}

.fa-arrow-circle-o-right:before {
  content: "\\f18e";
}

.fa-arrow-circle-o-left:before {
  content: "\\f190";
}

.fa-toggle-left:before,
.fa-caret-square-o-left:before {
  content: "\\f191";
}

.fa-dot-circle-o:before {
  content: "\\f192";
}

.fa-wheelchair:before {
  content: "\\f193";
}

.fa-vimeo-square:before {
  content: "\\f194";
}

.fa-turkish-lira:before,
.fa-try:before {
  content: "\\f195";
}

.fa-plus-square-o:before {
  content: "\\f196";
}

.fa-space-shuttle:before {
  content: "\\f197";
}

.fa-slack:before {
  content: "\\f198";
}

.fa-envelope-square:before {
  content: "\\f199";
}

.fa-wordpress:before {
  content: "\\f19a";
}

.fa-openid:before {
  content: "\\f19b";
}

.fa-institution:before,
.fa-bank:before,
.fa-university:before {
  content: "\\f19c";
}

.fa-mortar-board:before,
.fa-graduation-cap:before {
  content: "\\f19d";
}

.fa-yahoo:before {
  content: "\\f19e";
}

.fa-google:before {
  content: "\\f1a0";
}

.fa-reddit:before {
  content: "\\f1a1";
}

.fa-reddit-square:before {
  content: "\\f1a2";
}

.fa-stumbleupon-circle:before {
  content: "\\f1a3";
}

.fa-stumbleupon:before {
  content: "\\f1a4";
}

.fa-delicious:before {
  content: "\\f1a5";
}

.fa-digg:before {
  content: "\\f1a6";
}

.fa-pied-piper-pp:before {
  content: "\\f1a7";
}

.fa-pied-piper-alt:before {
  content: "\\f1a8";
}

.fa-drupal:before {
  content: "\\f1a9";
}

.fa-joomla:before {
  content: "\\f1aa";
}

.fa-language:before {
  content: "\\f1ab";
}

.fa-fax:before {
  content: "\\f1ac";
}

.fa-building:before {
  content: "\\f1ad";
}

.fa-child:before {
  content: "\\f1ae";
}

.fa-paw:before {
  content: "\\f1b0";
}

.fa-spoon:before {
  content: "\\f1b1";
}

.fa-cube:before {
  content: "\\f1b2";
}

.fa-cubes:before {
  content: "\\f1b3";
}

.fa-behance:before {
  content: "\\f1b4";
}

.fa-behance-square:before {
  content: "\\f1b5";
}

.fa-steam:before {
  content: "\\f1b6";
}

.fa-steam-square:before {
  content: "\\f1b7";
}

.fa-recycle:before {
  content: "\\f1b8";
}

.fa-automobile:before,
.fa-car:before {
  content: "\\f1b9";
}

.fa-cab:before,
.fa-taxi:before {
  content: "\\f1ba";
}

.fa-tree:before {
  content: "\\f1bb";
}

.fa-spotify:before {
  content: "\\f1bc";
}

.fa-deviantart:before {
  content: "\\f1bd";
}

.fa-soundcloud:before {
  content: "\\f1be";
}

.fa-database:before {
  content: "\\f1c0";
}

.fa-file-pdf-o:before {
  content: "\\f1c1";
}

.fa-file-word-o:before {
  content: "\\f1c2";
}

.fa-file-excel-o:before {
  content: "\\f1c3";
}

.fa-file-powerpoint-o:before {
  content: "\\f1c4";
}

.fa-file-photo-o:before,
.fa-file-picture-o:before,
.fa-file-image-o:before {
  content: "\\f1c5";
}

.fa-file-zip-o:before,
.fa-file-archive-o:before {
  content: "\\f1c6";
}

.fa-file-sound-o:before,
.fa-file-audio-o:before {
  content: "\\f1c7";
}

.fa-file-movie-o:before,
.fa-file-video-o:before {
  content: "\\f1c8";
}

.fa-file-code-o:before {
  content: "\\f1c9";
}

.fa-vine:before {
  content: "\\f1ca";
}

.fa-codepen:before {
  content: "\\f1cb";
}

.fa-jsfiddle:before {
  content: "\\f1cc";
}

.fa-life-bouy:before,
.fa-life-buoy:before,
.fa-life-saver:before,
.fa-support:before,
.fa-life-ring:before {
  content: "\\f1cd";
}

.fa-circle-o-notch:before {
  content: "\\f1ce";
}

.fa-ra:before,
.fa-resistance:before,
.fa-rebel:before {
  content: "\\f1d0";
}

.fa-ge:before,
.fa-empire:before {
  content: "\\f1d1";
}

.fa-git-square:before {
  content: "\\f1d2";
}

.fa-git:before {
  content: "\\f1d3";
}

.fa-y-combinator-square:before,
.fa-yc-square:before,
.fa-hacker-news:before {
  content: "\\f1d4";
}

.fa-tencent-weibo:before {
  content: "\\f1d5";
}

.fa-qq:before {
  content: "\\f1d6";
}

.fa-wechat:before,
.fa-weixin:before {
  content: "\\f1d7";
}

.fa-send:before,
.fa-paper-plane:before {
  content: "\\f1d8";
}

.fa-send-o:before,
.fa-paper-plane-o:before {
  content: "\\f1d9";
}

.fa-history:before {
  content: "\\f1da";
}

.fa-circle-thin:before {
  content: "\\f1db";
}

.fa-header:before {
  content: "\\f1dc";
}

.fa-paragraph:before {
  content: "\\f1dd";
}

.fa-sliders:before {
  content: "\\f1de";
}

.fa-share-alt:before {
  content: "\\f1e0";
}

.fa-share-alt-square:before {
  content: "\\f1e1";
}

.fa-bomb:before {
  content: "\\f1e2";
}

.fa-soccer-ball-o:before,
.fa-futbol-o:before {
  content: "\\f1e3";
}

.fa-tty:before {
  content: "\\f1e4";
}

.fa-binoculars:before {
  content: "\\f1e5";
}

.fa-plug:before {
  content: "\\f1e6";
}

.fa-slideshare:before {
  content: "\\f1e7";
}

.fa-twitch:before {
  content: "\\f1e8";
}

.fa-yelp:before {
  content: "\\f1e9";
}

.fa-newspaper-o:before {
  content: "\\f1ea";
}

.fa-wifi:before {
  content: "\\f1eb";
}

.fa-calculator:before {
  content: "\\f1ec";
}

.fa-paypal:before {
  content: "\\f1ed";
}

.fa-google-wallet:before {
  content: "\\f1ee";
}

.fa-cc-visa:before {
  content: "\\f1f0";
}

.fa-cc-mastercard:before {
  content: "\\f1f1";
}

.fa-cc-discover:before {
  content: "\\f1f2";
}

.fa-cc-amex:before {
  content: "\\f1f3";
}

.fa-cc-paypal:before {
  content: "\\f1f4";
}

.fa-cc-stripe:before {
  content: "\\f1f5";
}

.fa-bell-slash:before {
  content: "\\f1f6";
}

.fa-bell-slash-o:before {
  content: "\\f1f7";
}

.fa-trash:before {
  content: "\\f1f8";
}

.fa-copyright:before {
  content: "\\f1f9";
}

.fa-at:before {
  content: "\\f1fa";
}

.fa-eyedropper:before {
  content: "\\f1fb";
}

.fa-paint-brush:before {
  content: "\\f1fc";
}

.fa-birthday-cake:before {
  content: "\\f1fd";
}

.fa-area-chart:before {
  content: "\\f1fe";
}

.fa-pie-chart:before {
  content: "\\f200";
}

.fa-line-chart:before {
  content: "\\f201";
}

.fa-lastfm:before {
  content: "\\f202";
}

.fa-lastfm-square:before {
  content: "\\f203";
}

.fa-toggle-off:before {
  content: "\\f204";
}

.fa-toggle-on:before {
  content: "\\f205";
}

.fa-bicycle:before {
  content: "\\f206";
}

.fa-bus:before {
  content: "\\f207";
}

.fa-ioxhost:before {
  content: "\\f208";
}

.fa-angellist:before {
  content: "\\f209";
}

.fa-cc:before {
  content: "\\f20a";
}

.fa-shekel:before,
.fa-sheqel:before,
.fa-ils:before {
  content: "\\f20b";
}

.fa-meanpath:before {
  content: "\\f20c";
}

.fa-buysellads:before {
  content: "\\f20d";
}

.fa-connectdevelop:before {
  content: "\\f20e";
}

.fa-dashcube:before {
  content: "\\f210";
}

.fa-forumbee:before {
  content: "\\f211";
}

.fa-leanpub:before {
  content: "\\f212";
}

.fa-sellsy:before {
  content: "\\f213";
}

.fa-shirtsinbulk:before {
  content: "\\f214";
}

.fa-simplybuilt:before {
  content: "\\f215";
}

.fa-skyatlas:before {
  content: "\\f216";
}

.fa-cart-plus:before {
  content: "\\f217";
}

.fa-cart-arrow-down:before {
  content: "\\f218";
}

.fa-diamond:before {
  content: "\\f219";
}

.fa-ship:before {
  content: "\\f21a";
}

.fa-user-secret:before {
  content: "\\f21b";
}

.fa-motorcycle:before {
  content: "\\f21c";
}

.fa-street-view:before {
  content: "\\f21d";
}

.fa-heartbeat:before {
  content: "\\f21e";
}

.fa-venus:before {
  content: "\\f221";
}

.fa-mars:before {
  content: "\\f222";
}

.fa-mercury:before {
  content: "\\f223";
}

.fa-intersex:before,
.fa-transgender:before {
  content: "\\f224";
}

.fa-transgender-alt:before {
  content: "\\f225";
}

.fa-venus-double:before {
  content: "\\f226";
}

.fa-mars-double:before {
  content: "\\f227";
}

.fa-venus-mars:before {
  content: "\\f228";
}

.fa-mars-stroke:before {
  content: "\\f229";
}

.fa-mars-stroke-v:before {
  content: "\\f22a";
}

.fa-mars-stroke-h:before {
  content: "\\f22b";
}

.fa-neuter:before {
  content: "\\f22c";
}

.fa-genderless:before {
  content: "\\f22d";
}

.fa-facebook-official:before {
  content: "\\f230";
}

.fa-pinterest-p:before {
  content: "\\f231";
}

.fa-whatsapp:before {
  content: "\\f232";
}

.fa-server:before {
  content: "\\f233";
}

.fa-user-plus:before {
  content: "\\f234";
}

.fa-user-times:before {
  content: "\\f235";
}

.fa-hotel:before,
.fa-bed:before {
  content: "\\f236";
}

.fa-viacoin:before {
  content: "\\f237";
}

.fa-train:before {
  content: "\\f238";
}

.fa-subway:before {
  content: "\\f239";
}

.fa-medium:before {
  content: "\\f23a";
}

.fa-yc:before,
.fa-y-combinator:before {
  content: "\\f23b";
}

.fa-optin-monster:before {
  content: "\\f23c";
}

.fa-opencart:before {
  content: "\\f23d";
}

.fa-expeditedssl:before {
  content: "\\f23e";
}

.fa-battery-4:before,
.fa-battery:before,
.fa-battery-full:before {
  content: "\\f240";
}

.fa-battery-3:before,
.fa-battery-three-quarters:before {
  content: "\\f241";
}

.fa-battery-2:before,
.fa-battery-half:before {
  content: "\\f242";
}

.fa-battery-1:before,
.fa-battery-quarter:before {
  content: "\\f243";
}

.fa-battery-0:before,
.fa-battery-empty:before {
  content: "\\f244";
}

.fa-mouse-pointer:before {
  content: "\\f245";
}

.fa-i-cursor:before {
  content: "\\f246";
}

.fa-object-group:before {
  content: "\\f247";
}

.fa-object-ungroup:before {
  content: "\\f248";
}

.fa-sticky-note:before {
  content: "\\f249";
}

.fa-sticky-note-o:before {
  content: "\\f24a";
}

.fa-cc-jcb:before {
  content: "\\f24b";
}

.fa-cc-diners-club:before {
  content: "\\f24c";
}

.fa-clone:before {
  content: "\\f24d";
}

.fa-balance-scale:before {
  content: "\\f24e";
}

.fa-hourglass-o:before {
  content: "\\f250";
}

.fa-hourglass-1:before,
.fa-hourglass-start:before {
  content: "\\f251";
}

.fa-hourglass-2:before,
.fa-hourglass-half:before {
  content: "\\f252";
}

.fa-hourglass-3:before,
.fa-hourglass-end:before {
  content: "\\f253";
}

.fa-hourglass:before {
  content: "\\f254";
}

.fa-hand-grab-o:before,
.fa-hand-rock-o:before {
  content: "\\f255";
}

.fa-hand-stop-o:before,
.fa-hand-paper-o:before {
  content: "\\f256";
}

.fa-hand-scissors-o:before {
  content: "\\f257";
}

.fa-hand-lizard-o:before {
  content: "\\f258";
}

.fa-hand-spock-o:before {
  content: "\\f259";
}

.fa-hand-pointer-o:before {
  content: "\\f25a";
}

.fa-hand-peace-o:before {
  content: "\\f25b";
}

.fa-trademark:before {
  content: "\\f25c";
}

.fa-registered:before {
  content: "\\f25d";
}

.fa-Cuba-commons:before {
  content: "\\f25e";
}

.fa-gg:before {
  content: "\\f260";
}

.fa-gg-circle:before {
  content: "\\f261";
}

.fa-tripadvisor:before {
  content: "\\f262";
}

.fa-odnoklassniki:before {
  content: "\\f263";
}

.fa-odnoklassniki-square:before {
  content: "\\f264";
}

.fa-get-pocket:before {
  content: "\\f265";
}

.fa-wikipedia-w:before {
  content: "\\f266";
}

.fa-safari:before {
  content: "\\f267";
}

.fa-chrome:before {
  content: "\\f268";
}

.fa-firefox:before {
  content: "\\f269";
}

.fa-opera:before {
  content: "\\f26a";
}

.fa-internet-explorer:before {
  content: "\\f26b";
}

.fa-tv:before,
.fa-television:before {
  content: "\\f26c";
}

.fa-contao:before {
  content: "\\f26d";
}

.fa-500px:before {
  content: "\\f26e";
}

.fa-amazon:before {
  content: "\\f270";
}

.fa-calendar-plus-o:before {
  content: "\\f271";
}

.fa-calendar-minus-o:before {
  content: "\\f272";
}

.fa-calendar-times-o:before {
  content: "\\f273";
}

.fa-calendar-check-o:before {
  content: "\\f274";
}

.fa-industry:before {
  content: "\\f275";
}

.fa-map-pin:before {
  content: "\\f276";
}

.fa-map-signs:before {
  content: "\\f277";
}

.fa-map-o:before {
  content: "\\f278";
}

.fa-map:before {
  content: "\\f279";
}

.fa-commenting:before {
  content: "\\f27a";
}

.fa-commenting-o:before {
  content: "\\f27b";
}

.fa-houzz:before {
  content: "\\f27c";
}

.fa-vimeo:before {
  content: "\\f27d";
}

.fa-black-tie:before {
  content: "\\f27e";
}

.fa-fonticons:before {
  content: "\\f280";
}

.fa-reddit-alien:before {
  content: "\\f281";
}

.fa-edge:before {
  content: "\\f282";
}

.fa-credit-card-alt:before {
  content: "\\f283";
}

.fa-codiepie:before {
  content: "\\f284";
}

.fa-modx:before {
  content: "\\f285";
}

.fa-fort-awesome:before {
  content: "\\f286";
}

.fa-usb:before {
  content: "\\f287";
}

.fa-product-hunt:before {
  content: "\\f288";
}

.fa-mixcloud:before {
  content: "\\f289";
}

.fa-scribd:before {
  content: "\\f28a";
}

.fa-pause-circle:before {
  content: "\\f28b";
}

.fa-pause-circle-o:before {
  content: "\\f28c";
}

.fa-stop-circle:before {
  content: "\\f28d";
}

.fa-stop-circle-o:before {
  content: "\\f28e";
}

.fa-shopping-bag:before {
  content: "\\f290";
}

.fa-shopping-basket:before {
  content: "\\f291";
}

.fa-hashtag:before {
  content: "\\f292";
}

.fa-bluetooth:before {
  content: "\\f293";
}

.fa-bluetooth-b:before {
  content: "\\f294";
}

.fa-percent:before {
  content: "\\f295";
}

.fa-gitlab:before {
  content: "\\f296";
}

.fa-wpbeginner:before {
  content: "\\f297";
}

.fa-wpforms:before {
  content: "\\f298";
}

.fa-envira:before {
  content: "\\f299";
}

.fa-Cuba-access:before {
  content: "\\f29a";
}

.fa-wheelchair-alt:before {
  content: "\\f29b";
}

.fa-question-circle-o:before {
  content: "\\f29c";
}

.fa-blind:before {
  content: "\\f29d";
}

.fa-audio-description:before {
  content: "\\f29e";
}

.fa-volume-control-phone:before {
  content: "\\f2a0";
}

.fa-braille:before {
  content: "\\f2a1";
}

.fa-assistive-listening-systems:before {
  content: "\\f2a2";
}

.fa-asl-interpreting:before,
.fa-american-sign-language-interpreting:before {
  content: "\\f2a3";
}

.fa-deafness:before,
.fa-hard-of-hearing:before,
.fa-deaf:before {
  content: "\\f2a4";
}

.fa-glide:before {
  content: "\\f2a5";
}

.fa-glide-g:before {
  content: "\\f2a6";
}

.fa-signing:before,
.fa-sign-language:before {
  content: "\\f2a7";
}

.fa-low-vision:before {
  content: "\\f2a8";
}

.fa-viadeo:before {
  content: "\\f2a9";
}

.fa-viadeo-square:before {
  content: "\\f2aa";
}

.fa-snapchat:before {
  content: "\\f2ab";
}

.fa-snapchat-ghost:before {
  content: "\\f2ac";
}

.fa-snapchat-square:before {
  content: "\\f2ad";
}

.fa-pied-piper:before {
  content: "\\f2ae";
}

.fa-first-order:before {
  content: "\\f2b0";
}

.fa-yoast:before {
  content: "\\f2b1";
}

.fa-themeisle:before {
  content: "\\f2b2";
}

.fa-google-plus-circle:before,
.fa-google-plus-official:before {
  content: "\\f2b3";
}

.fa-fa:before,
.fa-font-awesome:before {
  content: "\\f2b4";
}

.fa-handshake-o:before {
  content: "\\f2b5";
}

.fa-envelope-open:before {
  content: "\\f2b6";
}

.fa-envelope-open-o:before {
  content: "\\f2b7";
}

.fa-linode:before {
  content: "\\f2b8";
}

.fa-address-book:before {
  content: "\\f2b9";
}

.fa-address-book-o:before {
  content: "\\f2ba";
}

.fa-vcard:before,
.fa-address-card:before {
  content: "\\f2bb";
}

.fa-vcard-o:before,
.fa-address-card-o:before {
  content: "\\f2bc";
}

.fa-user-circle:before {
  content: "\\f2bd";
}

.fa-user-circle-o:before {
  content: "\\f2be";
}

.fa-user-o:before {
  content: "\\f2c0";
}

.fa-id-badge:before {
  content: "\\f2c1";
}

.fa-drivers-license:before,
.fa-id-card:before {
  content: "\\f2c2";
}

.fa-drivers-license-o:before,
.fa-id-card-o:before {
  content: "\\f2c3";
}

.fa-quora:before {
  content: "\\f2c4";
}

.fa-free-code-camp:before {
  content: "\\f2c5";
}

.fa-telegram:before {
  content: "\\f2c6";
}

.fa-thermometer-4:before,
.fa-thermometer:before,
.fa-thermometer-full:before {
  content: "\\f2c7";
}

.fa-thermometer-3:before,
.fa-thermometer-three-quarters:before {
  content: "\\f2c8";
}

.fa-thermometer-2:before,
.fa-thermometer-half:before {
  content: "\\f2c9";
}

.fa-thermometer-1:before,
.fa-thermometer-quarter:before {
  content: "\\f2ca";
}

.fa-thermometer-0:before,
.fa-thermometer-empty:before {
  content: "\\f2cb";
}

.fa-shower:before {
  content: "\\f2cc";
}

.fa-bathtub:before,
.fa-s15:before,
.fa-bath:before {
  content: "\\f2cd";
}

.fa-podcast:before {
  content: "\\f2ce";
}

.fa-window-maximize:before {
  content: "\\f2d0";
}

.fa-window-minimize:before {
  content: "\\f2d1";
}

.fa-window-restore:before {
  content: "\\f2d2";
}

.fa-times-rectangle:before,
.fa-window-close:before {
  content: "\\f2d3";
}

.fa-times-rectangle-o:before,
.fa-window-close-o:before {
  content: "\\f2d4";
}

.fa-bandcamp:before {
  content: "\\f2d5";
}

.fa-grav:before {
  content: "\\f2d6";
}

.fa-etsy:before {
  content: "\\f2d7";
}

.fa-imdb:before {
  content: "\\f2d8";
}

.fa-ravelry:before {
  content: "\\f2d9";
}

.fa-eercast:before {
  content: "\\f2da";
}

.fa-microchip:before {
  content: "\\f2db";
}

.fa-snowflake-o:before {
  content: "\\f2dc";
}

.fa-superpowers:before {
  content: "\\f2dd";
}

.fa-wpexplorer:before {
  content: "\\f2de";
}

.fa-meetup:before {
  content: "\\f2e0";
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.sr-only-focusable:active, .sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  clip: auto;
}

.animated {
  animation-duration: 1s;
  animation-fill-mode: both;
}
.animated.infinite {
  animation-iteration-count: infinite;
}
.animated.hinge {
  animation-duration: 2s;
}
.animated.bounceIn {
  animation-duration: 0.75s;
}
.animated.bounceOut {
  animation-duration: 0.75s;
}
.animated.flipOutX {
  animation-duration: 0.75s;
}
.animated.flipOutY {
  animation-duration: 0.75s;
}
.animated.flip {
  backface-visibility: visible;
  animation-name: flip;
}

@keyframes bounce {
  0% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translateZ(0);
  }
  20% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translateZ(0);
  }
  53% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translateZ(0);
  }
  80% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translateZ(0);
  }
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translateZ(0);
  }
  40% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -30px, 0);
  }
  43% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -30px, 0);
  }
  70% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -15px, 0);
  }
  90% {
    transform: translate3d(0, -4px, 0);
  }
}
.bounce {
  animation-name: bounce;
  transform-origin: center bottom;
}

@keyframes flash {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  to {
    opacity: 1;
  }
  25% {
    opacity: 0;
  }
  75% {
    opacity: 0;
  }
}
.flash {
  animation-name: flash;
}

@keyframes pulse {
  0% {
    transform: scaleX(1);
  }
  50% {
    transform: scale3d(1.05, 1.05, 1.05);
  }
  to {
    transform: scaleX(1);
  }
}
.pulse {
  animation-name: pulse;
}

@keyframes rubberBand {
  0% {
    transform: scaleX(1);
  }
  30% {
    transform: scale3d(1.25, 0.75, 1);
  }
  40% {
    transform: scale3d(0.75, 1.25, 1);
  }
  50% {
    transform: scale3d(1.15, 0.85, 1);
  }
  65% {
    transform: scale3d(0.95, 1.05, 1);
  }
  75% {
    transform: scale3d(1.05, 0.95, 1);
  }
  to {
    transform: scaleX(1);
  }
}
.rubberBand {
  animation-name: rubberBand;
}

@keyframes shake {
  0% {
    transform: translateZ(0);
  }
  to {
    transform: translateZ(0);
  }
  10% {
    transform: translate3d(-10px, 0, 0);
  }
  30% {
    transform: translate3d(-10px, 0, 0);
  }
  50% {
    transform: translate3d(-10px, 0, 0);
  }
  70% {
    transform: translate3d(-10px, 0, 0);
  }
  90% {
    transform: translate3d(-10px, 0, 0);
  }
  20% {
    transform: translate3d(10px, 0, 0);
  }
  40% {
    transform: translate3d(10px, 0, 0);
  }
  60% {
    transform: translate3d(10px, 0, 0);
  }
  80% {
    transform: translate3d(10px, 0, 0);
  }
}
.shake {
  animation-name: shake;
}

@keyframes headShake {
  0% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(0);
  }
  0.5% {
    transform: translateX(-6px) rotateY(-9deg);
  }
  1.5% {
    transform: translateX(5px) rotateY(7deg);
  }
  2.5% {
    transform: translateX(-3px) rotateY(-5deg);
  }
  3.5% {
    transform: translateX(2px) rotateY(3deg);
  }
}
.headShake {
  animation-timing-function: ease-in-out;
  animation-name: headShake;
}

@keyframes swing {
  20% {
    transform: rotate(15deg);
  }
  40% {
    transform: rotate(-10deg);
  }
  60% {
    transform: rotate(5deg);
  }
  80% {
    transform: rotate(-5deg);
  }
  to {
    transform: rotate(0deg);
  }
}
.swing {
  transform-origin: top center;
  animation-name: swing;
}

@keyframes tada {
  0% {
    transform: scaleX(1);
  }
  10% {
    transform: scale3d(0.9, 0.9, 0.9) rotate(-3deg);
  }
  20% {
    transform: scale3d(0.9, 0.9, 0.9) rotate(-3deg);
  }
  30% {
    transform: scale3d(1.1, 1.1, 1.1) rotate(3deg);
  }
  50% {
    transform: scale3d(1.1, 1.1, 1.1) rotate(3deg);
  }
  70% {
    transform: scale3d(1.1, 1.1, 1.1) rotate(3deg);
  }
  90% {
    transform: scale3d(1.1, 1.1, 1.1) rotate(3deg);
  }
  40% {
    transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg);
  }
  60% {
    transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg);
  }
  80% {
    transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg);
  }
  to {
    transform: scaleX(1);
  }
}
.tada {
  animation-name: tada;
}

@keyframes wobble {
  0% {
    transform: none;
  }
  15% {
    transform: translate3d(-25%, 0, 0) rotate(-5deg);
  }
  30% {
    transform: translate3d(20%, 0, 0) rotate(3deg);
  }
  45% {
    transform: translate3d(-15%, 0, 0) rotate(-3deg);
  }
  60% {
    transform: translate3d(10%, 0, 0) rotate(2deg);
  }
  75% {
    transform: translate3d(-5%, 0, 0) rotate(-1deg);
  }
  to {
    transform: none;
  }
}
.wobble {
  animation-name: wobble;
}

@keyframes jello {
  0% {
    transform: none;
  }
  to {
    transform: none;
  }
  0.1% {
    transform: none;
  }
  1.2% {
    transform: skewX(-12.5deg) skewY(-12.5deg);
  }
  2.3% {
    transform: skewX(6.25deg) skewY(6.25deg);
  }
  3.4% {
    transform: skewX(-3.125deg) skewY(-3.125deg);
  }
  4.5% {
    transform: skewX(1.5625deg) skewY(1.5625deg);
  }
  5.6% {
    transform: skewX(-0.78125deg) skewY(-0.78125deg);
  }
  6.7% {
    transform: skewX(0.390625deg) skewY(0.390625deg);
  }
  7.8% {
    transform: skewX(-0.1953125deg) skewY(-0.1953125deg);
  }
}
.jello {
  animation-name: jello;
  transform-origin: center;
}

@keyframes bounceIn {
  0% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  20% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: scale3d(1.1, 1.1, 1.1);
  }
  40% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: scale3d(0.9, 0.9, 0.9);
  }
  60% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    opacity: 1;
    transform: scale3d(1.03, 1.03, 1.03);
  }
  80% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: scale3d(0.97, 0.97, 0.97);
  }
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    opacity: 1;
    transform: scaleX(1);
  }
}
.bounceIn {
  animation-name: bounceIn;
}

@keyframes bounceInDown {
  0% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    opacity: 0;
    transform: translate3d(0, -3000px, 0);
  }
  60% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    opacity: 1;
    transform: translate3d(0, 25px, 0);
  }
  75% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, -10px, 0);
  }
  90% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 5px, 0);
  }
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: none;
  }
}
.bounceInDown {
  animation-name: bounceInDown;
}

@keyframes bounceInLeft {
  0% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    opacity: 0;
    transform: translate3d(-3000px, 0, 0);
  }
  60% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    opacity: 1;
    transform: translate3d(25px, 0, 0);
  }
  75% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(-10px, 0, 0);
  }
  90% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(5px, 0, 0);
  }
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: none;
  }
}
.bounceInLeft {
  animation-name: bounceInLeft;
}

@keyframes bounceInRight {
  0% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    opacity: 0;
    transform: translate3d(3000px, 0, 0);
  }
  60% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    opacity: 1;
    transform: translate3d(-25px, 0, 0);
  }
  75% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(10px, 0, 0);
  }
  90% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(-5px, 0, 0);
  }
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: none;
  }
}
.bounceInRight {
  animation-name: bounceInRight;
}

@keyframes bounceInUp {
  0% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    opacity: 0;
    transform: translate3d(0, 3000px, 0);
  }
  60% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    opacity: 1;
    transform: translate3d(0, -20px, 0);
  }
  75% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 10px, 0);
  }
  90% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, -5px, 0);
  }
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translateZ(0);
  }
}
.bounceInUp {
  animation-name: bounceInUp;
}

@keyframes bounceOut {
  20% {
    transform: scale3d(0.9, 0.9, 0.9);
  }
  50% {
    opacity: 1;
    transform: scale3d(1.1, 1.1, 1.1);
  }
  55% {
    opacity: 1;
    transform: scale3d(1.1, 1.1, 1.1);
  }
  to {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
}
.bounceOut {
  animation-name: bounceOut;
}

@keyframes bounceOutDown {
  20% {
    transform: translate3d(0, 10px, 0);
  }
  40% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
  }
  45% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, 2000px, 0);
  }
}
.bounceOutDown {
  animation-name: bounceOutDown;
}

@keyframes bounceOutLeft {
  20% {
    opacity: 1;
    transform: translate3d(20px, 0, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(-2000px, 0, 0);
  }
}
.bounceOutLeft {
  animation-name: bounceOutLeft;
}

@keyframes bounceOutRight {
  20% {
    opacity: 1;
    transform: translate3d(-20px, 0, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(2000px, 0, 0);
  }
}
.bounceOutRight {
  animation-name: bounceOutRight;
}

@keyframes bounceOutUp {
  20% {
    transform: translate3d(0, -10px, 0);
  }
  40% {
    opacity: 1;
    transform: translate3d(0, 20px, 0);
  }
  45% {
    opacity: 1;
    transform: translate3d(0, 20px, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
  }
}
.bounceOutUp {
  animation-name: bounceOutUp;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.fadeIn {
  animation-name: fadeIn;
}

@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.fadeInDown {
  animation-name: fadeInDown;
}

@keyframes fadeInDownBig {
  0% {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.fadeInDownBig {
  animation-name: fadeInDownBig;
}

@keyframes fadeInLeft {
  0% {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.fadeInLeft {
  animation-name: fadeInLeft;
}

@keyframes fadeInLeftBig {
  0% {
    opacity: 0;
    transform: translate3d(-2000px, 0, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.fadeInLeftBig {
  animation-name: fadeInLeftBig;
}

@keyframes fadeInRight {
  0% {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.fadeInRight {
  animation-name: fadeInRight;
}

@keyframes fadeInRightBig {
  0% {
    opacity: 0;
    transform: translate3d(2000px, 0, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.fadeInRightBig {
  animation-name: fadeInRightBig;
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.fadeInUp {
  animation-name: fadeInUp;
}

@keyframes fadeInUpBig {
  0% {
    opacity: 0;
    transform: translate3d(0, 2000px, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.fadeInUpBig {
  animation-name: fadeInUpBig;
}

@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.fadeOut {
  animation-name: fadeOut;
}

@keyframes fadeOutDown {
  0% {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }
}
.fadeOutDown {
  animation-name: fadeOutDown;
}

@keyframes fadeOutDownBig {
  0% {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(0, 2000px, 0);
  }
}
.fadeOutDownBig {
  animation-name: fadeOutDownBig;
}

@keyframes fadeOutLeft {
  0% {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
}
.fadeOutLeft {
  animation-name: fadeOutLeft;
}

@keyframes fadeOutLeftBig {
  0% {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(-2000px, 0, 0);
  }
}
.fadeOutLeftBig {
  animation-name: fadeOutLeftBig;
}

@keyframes fadeOutRight {
  0% {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }
}
.fadeOutRight {
  animation-name: fadeOutRight;
}

@keyframes fadeOutRightBig {
  0% {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(2000px, 0, 0);
  }
}
.fadeOutRightBig {
  animation-name: fadeOutRightBig;
}

@keyframes fadeOutUp {
  0% {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
}
.fadeOutUp {
  animation-name: fadeOutUp;
}

@keyframes fadeOutUpBig {
  0% {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
  }
}
.fadeOutUpBig {
  animation-name: fadeOutUpBig;
}

@keyframes flip {
  0% {
    transform: perspective(400px) rotateY(-1turn);
    animation-timing-function: ease-out;
  }
  40% {
    transform: perspective(400px) translateZ(150px) rotateY(-190deg);
    animation-timing-function: ease-out;
  }
  50% {
    transform: perspective(400px) translateZ(150px) rotateY(-170deg);
    animation-timing-function: ease-in;
  }
  80% {
    transform: perspective(400px) scale3d(0.95, 0.95, 0.95);
    animation-timing-function: ease-in;
  }
  to {
    transform: perspective(400px);
    animation-timing-function: ease-in;
  }
}
@keyframes flipInX {
  0% {
    transform: perspective(400px) rotateX(90deg);
    animation-timing-function: ease-in;
    opacity: 0;
  }
  40% {
    transform: perspective(400px) rotateX(-20deg);
    animation-timing-function: ease-in;
  }
  60% {
    transform: perspective(400px) rotateX(10deg);
    opacity: 1;
  }
  80% {
    transform: perspective(400px) rotateX(-5deg);
  }
  to {
    transform: perspective(400px);
  }
}
.flipInX {
  backface-visibility: visible !important;
  animation-name: flipInX;
}

@keyframes flipInY {
  0% {
    transform: perspective(400px) rotateY(90deg);
    animation-timing-function: ease-in;
    opacity: 0;
  }
  40% {
    transform: perspective(400px) rotateY(-20deg);
    animation-timing-function: ease-in;
  }
  60% {
    transform: perspective(400px) rotateY(10deg);
    opacity: 1;
  }
  80% {
    transform: perspective(400px) rotateY(-5deg);
  }
  to {
    transform: perspective(400px);
  }
}
.flipInY {
  backface-visibility: visible !important;
  animation-name: flipInY;
}

@keyframes flipOutX {
  0% {
    transform: perspective(400px);
  }
  30% {
    transform: perspective(400px) rotateX(-20deg);
    opacity: 1;
  }
  to {
    transform: perspective(400px) rotateX(90deg);
    opacity: 0;
  }
}
.flipOutX {
  animation-name: flipOutX;
  backface-visibility: visible !important;
}

@keyframes flipOutY {
  0% {
    transform: perspective(400px);
  }
  30% {
    transform: perspective(400px) rotateY(-15deg);
    opacity: 1;
  }
  to {
    transform: perspective(400px) rotateY(90deg);
    opacity: 0;
  }
}
.flipOutY {
  backface-visibility: visible !important;
  animation-name: flipOutY;
}

@keyframes lightSpeedIn {
  0% {
    transform: translate3d(100%, 0, 0) skewX(-30deg);
    opacity: 0;
  }
  60% {
    transform: skewX(20deg);
    opacity: 1;
  }
  80% {
    transform: skewX(-5deg);
    opacity: 1;
  }
  to {
    transform: none;
    opacity: 1;
  }
}
.lightSpeedIn {
  animation-name: lightSpeedIn;
  animation-timing-function: ease-out;
}

@keyframes lightSpeedOut {
  0% {
    opacity: 1;
  }
  to {
    transform: translate3d(100%, 0, 0) skewX(30deg);
    opacity: 0;
  }
}
.lightSpeedOut {
  animation-name: lightSpeedOut;
  animation-timing-function: ease-in;
}

@keyframes rotateIn {
  0% {
    transform-origin: center;
    transform: rotate(-200deg);
    opacity: 0;
  }
  to {
    transform-origin: center;
    transform: none;
    opacity: 1;
  }
}
.rotateIn {
  animation-name: rotateIn;
}

@keyframes rotateInDownLeft {
  0% {
    transform-origin: left bottom;
    transform: rotate(-45deg);
    opacity: 0;
  }
  to {
    transform-origin: left bottom;
    transform: none;
    opacity: 1;
  }
}
.rotateInDownLeft {
  animation-name: rotateInDownLeft;
}

@keyframes rotateInDownRight {
  0% {
    transform-origin: right bottom;
    transform: rotate(45deg);
    opacity: 0;
  }
  to {
    transform-origin: right bottom;
    transform: none;
    opacity: 1;
  }
}
.rotateInDownRight {
  animation-name: rotateInDownRight;
}

@keyframes rotateInUpLeft {
  0% {
    transform-origin: left bottom;
    transform: rotate(45deg);
    opacity: 0;
  }
  to {
    transform-origin: left bottom;
    transform: none;
    opacity: 1;
  }
}
.rotateInUpLeft {
  animation-name: rotateInUpLeft;
}

@keyframes rotateInUpRight {
  0% {
    transform-origin: right bottom;
    transform: rotate(-90deg);
    opacity: 0;
  }
  to {
    transform-origin: right bottom;
    transform: none;
    opacity: 1;
  }
}
.rotateInUpRight {
  animation-name: rotateInUpRight;
}

@keyframes rotateOut {
  0% {
    transform-origin: center;
    opacity: 1;
  }
  to {
    transform-origin: center;
    transform: rotate(200deg);
    opacity: 0;
  }
}
.rotateOut {
  animation-name: rotateOut;
}

@keyframes rotateOutDownLeft {
  0% {
    transform-origin: left bottom;
    opacity: 1;
  }
  to {
    transform-origin: left bottom;
    transform: rotate(45deg);
    opacity: 0;
  }
}
.rotateOutDownLeft {
  animation-name: rotateOutDownLeft;
}

@keyframes rotateOutDownRight {
  0% {
    transform-origin: right bottom;
    opacity: 1;
  }
  to {
    transform-origin: right bottom;
    transform: rotate(-45deg);
    opacity: 0;
  }
}
.rotateOutDownRight {
  animation-name: rotateOutDownRight;
}

@keyframes rotateOutUpLeft {
  0% {
    transform-origin: left bottom;
    opacity: 1;
  }
  to {
    transform-origin: left bottom;
    transform: rotate(-45deg);
    opacity: 0;
  }
}
.rotateOutUpLeft {
  animation-name: rotateOutUpLeft;
}

@keyframes rotateOutUpRight {
  0% {
    transform-origin: right bottom;
    opacity: 1;
  }
  to {
    transform-origin: right bottom;
    transform: rotate(90deg);
    opacity: 0;
  }
}
.rotateOutUpRight {
  animation-name: rotateOutUpRight;
}

@keyframes hinge {
  0% {
    transform-origin: top left;
    animation-timing-function: ease-in-out;
  }
  20% {
    transform: rotate(80deg);
    transform-origin: top left;
    animation-timing-function: ease-in-out;
  }
  60% {
    transform: rotate(80deg);
    transform-origin: top left;
    animation-timing-function: ease-in-out;
  }
  40% {
    transform: rotate(60deg);
    transform-origin: top left;
    animation-timing-function: ease-in-out;
    opacity: 1;
  }
  80% {
    transform: rotate(60deg);
    transform-origin: top left;
    animation-timing-function: ease-in-out;
    opacity: 1;
  }
  to {
    transform: translate3d(0, 700px, 0);
    opacity: 0;
  }
}
.hinge {
  animation-name: hinge;
}

@keyframes jackInTheBox {
  0% {
    opacity: 0;
    transform: scale(0.1) rotate(30deg);
    transform-origin: center bottom;
  }
  50% {
    transform: rotate(-10deg);
  }
  70% {
    transform: rotate(3deg);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
.jackInTheBox {
  animation-name: jackInTheBox;
}

@keyframes rollIn {
  0% {
    opacity: 0;
    transform: translate3d(-100%, 0, 0) rotate(-120deg);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.rollIn {
  animation-name: rollIn;
}

@keyframes rollOut {
  0% {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(100%, 0, 0) rotate(120deg);
  }
}
.rollOut {
  animation-name: rollOut;
}

@keyframes zoomIn {
  0% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    opacity: 1;
  }
}
.zoomIn {
  animation-name: zoomIn;
}

@keyframes zoomInDown {
  0% {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }
  60% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
}
.zoomInDown {
  animation-name: zoomInDown;
}

@keyframes zoomInLeft {
  0% {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }
  60% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
}
.zoomInLeft {
  animation-name: zoomInLeft;
}

@keyframes zoomInRight {
  0% {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }
  60% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
}
.zoomInRight {
  animation-name: zoomInRight;
}

@keyframes zoomInUp {
  0% {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }
  60% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
}
.zoomInUp {
  animation-name: zoomInUp;
}

@keyframes zoomOut {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  to {
    opacity: 0;
  }
}
.zoomOut {
  animation-name: zoomOut;
}

@keyframes zoomOutDown {
  40% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }
  to {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 2000px, 0);
    transform-origin: center bottom;
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
}
.zoomOutDown {
  animation-name: zoomOutDown;
}

@keyframes zoomOutLeft {
  40% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(42px, 0, 0);
  }
  to {
    opacity: 0;
    transform: scale(0.1) translate3d(-2000px, 0, 0);
    transform-origin: left center;
  }
}
.zoomOutLeft {
  animation-name: zoomOutLeft;
}

@keyframes zoomOutRight {
  40% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(-42px, 0, 0);
  }
  to {
    opacity: 0;
    transform: scale(0.1) translate3d(2000px, 0, 0);
    transform-origin: right center;
  }
}
.zoomOutRight {
  animation-name: zoomOutRight;
}

@keyframes zoomOutUp {
  40% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }
  to {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -2000px, 0);
    transform-origin: center bottom;
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
}
.zoomOutUp {
  animation-name: zoomOutUp;
}

@keyframes slideInDown {
  0% {
    transform: translate3d(0, -100%, 0);
    visibility: visible;
  }
  to {
    transform: translateZ(0);
  }
}
.slideInDown {
  animation-name: slideInDown;
}

@keyframes slideInLeft {
  0% {
    transform: translate3d(-100%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translateZ(0);
  }
}
.slideInLeft {
  animation-name: slideInLeft;
}

@keyframes slideInRight {
  0% {
    transform: translate3d(100%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translateZ(0);
  }
}
.slideInRight {
  animation-name: slideInRight;
}

@keyframes slideInUp {
  0% {
    transform: translate3d(0, 100%, 0);
    visibility: visible;
  }
  to {
    transform: translateZ(0);
  }
}
.slideInUp {
  animation-name: slideInUp;
}

@keyframes slideOutDown {
  0% {
    transform: translateZ(0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, 100%, 0);
  }
}
.slideOutDown {
  animation-name: slideOutDown;
}

@keyframes slideOutLeft {
  0% {
    transform: translateZ(0);
  }
  to {
    visibility: hidden;
    transform: translate3d(-100%, 0, 0);
  }
}
.slideOutLeft {
  animation-name: slideOutLeft;
}

@keyframes slideOutRight {
  0% {
    transform: translateZ(0);
  }
  to {
    visibility: hidden;
    transform: translate3d(100%, 0, 0);
  }
}
.slideOutRight {
  animation-name: slideOutRight;
}

@keyframes slideOutUp {
  0% {
    transform: translateZ(0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, -100%, 0);
  }
}
.slideOutUp {
  animation-name: slideOutUp;
}

/* * Hide from both screenreaders and browsers: h5bp.com/u */
.hidden {
  display: none !important;
  visibility: hidden;
}

/* * Hide only visually, but have it available for screenreaders: h5bp.com/v */
.visuallyhidden {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

/* * Extends the .visuallyhidden class to allow the element to be focusable * when navigated to via the keyboard: h5bp.com/p */
.visuallyhidden.focusable:active,
.visuallyhidden.focusable:focus {
  clip: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  position: static;
  width: auto;
} /* * Hide visually and from screenreaders, but maintain layout */
.invisible {
  visibility: hidden;
}

.clearfix:before,
.clearfix:after {
  content: " "; /* 1 */
  display: table; /* 2 */
}

.clearfix:after {
  clear: both;
}

.noflick, .button, .note {
  perspective: 1000;
  backface-visibility: hidden;
  transform: translate3d(0, 0, 0);
}

.sticky-note {
  margin: -22px -15px 0;
}

.note {
  float: left;
  display: block;
  position: relative;
  padding: 1em;
  width: calc(25% - 30px);
  min-height: 300px;
  margin: 22px 15px 0;
  border-radius: 5px;
  background-color: rgb(81.6993464052%, 80%, 100%);
  transition: transform 0.15s;
  z-index: 1;
}
.note:hover {
  cursor: move;
}
.note.ui-draggable-dragging:nth-child(n) {
  box-shadow: 5px 5px 15px 0 rgba(0, 0, 0, 0.3);
  transform: scale(1.125) !important;
  z-index: 100;
  cursor: move;
  transition: transform 0.15s;
}
.note textarea {
  background-color: transparent;
  border: none;
  resize: vertical;
  font-style: italic;
  width: 100%;
  padding: 5px;
}
.note textarea:focus {
  outline: none;
  border: none;
  box-shadow: 0 0 0px 1px rgba(0, 0, 0, 0.2) inset;
}
.note textarea.title {
  font-size: 24px;
  line-height: 1.2;
  color: #000000;
  height: 64px;
  margin-top: 20px;
}
.note textarea.cnt {
  min-height: 200px;
}
.note:nth-child(2n) {
  background: rgb(100%, 90%, 92.4019607843%);
}
.note:nth-child(3n) {
  background: white;
}
.note:nth-child(4n) {
  background: rgb(57.3722208549%, 89.7546968578%, 98.9022889491%);
}
.note:nth-child(5n) {
  background: rgb(100%, 90.4666666667%, 71.9607843137%);
}
.note:nth-child(6n) {
  background: rgb(99.5661036692%, 72.9537953795%, 71.2182100563%);
}

/* Button style  */
.button {
  color: #FFFFFF;
  padding: 1em 2em;
  text-decoration: none;
  transition: transform 0.15s, background 0.01s;
}
.button.remove {
  position: absolute;
  top: 0;
  right: -10px;
  color: #999;
}

@media (max-width: 1199px) {
  .note {
    min-width: 260px;
    min-height: 260px;
  }
}
/*====todo css start====*/
.todo .action-box {
  background: transparent;
  height: 20px;
  width: 20px;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  transition: all 300ms ease;
}
.todo .action-box .icon {
  vertical-align: 0;
}
.todo .action-box.completed {
  background: #fc4438;
  border: 1px solid #fc4438;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.todo .action-box.completed .icon {
  color: #fff;
  font-size: 14px;
  width: 16px;
  height: 16px;
}
.todo .action-box.large {
  height: 30px;
  width: 30px;
}
.todo .action-box.large .icon {
  font-size: 20px;
  vertical-align: -5px;
}
.todo .action-box.large .icon .icon-trash {
  color: var(--theme-default);
}
.todo .action-box.large .icon .icon-check {
  color: var(--theme-default);
}
.todo .todo-list-wrapper {
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
}
.todo .todo-list-wrapper .mark-all-tasks {
  display: flex;
  align-items: center;
}
.todo .todo-list-wrapper .mark-all-tasks .mark-all-tasks-container {
  overflow: hidden;
  position: relative;
}
.todo .todo-list-wrapper .mark-all-tasks .mark-all-btn {
  cursor: pointer;
  display: inline-block;
  transition: all 200ms ease;
}
.todo .todo-list-wrapper .mark-all-tasks .mark-all-btn#mark-all-finished {
  color: #fc4438;
}
.todo .todo-list-wrapper .mark-all-tasks .mark-all-btn#mark-all-incomplete {
  color: #54ba4a;
}
.todo .todo-list-wrapper .mark-all-tasks .mark-all-btn#mark-all-incomplete .action-box {
  border: 2px solid #54ba4a;
  border-radius: 4px;
}
.todo .todo-list-wrapper .mark-all-tasks .mark-all-btn#mark-all-incomplete .action-box .icon {
  color: #54ba4a;
}
.todo .todo-list-wrapper .mark-all-tasks .mark-all-btn.move-up {
  transform: translateY(-30px);
  position: absolute;
  right: 0;
}
.todo .todo-list-wrapper .mark-all-tasks .mark-all-btn.move-down {
  transform: translateY(30px);
  position: absolute;
  right: 0;
}
.todo .todo-list-wrapper .mark-all-tasks .btn-label {
  margin-right: 5px;
  font-weight: 600;
}
.todo .todo-list-wrapper .todo-list-footer {
  position: relative;
}
.todo .todo-list-wrapper .todo-list-footer h5, .todo .todo-list-wrapper .todo-list-footer .h5 {
  text-align: center;
  color: #2f2f3b;
}
.todo .todo-list-wrapper .todo-list-footer .add-task-btn:hover {
  background: var(--theme-default);
}
.todo .todo-list-wrapper .todo-list-footer .add-task-btn:hover .icon {
  color: #f4f4f4;
}
.todo .todo-list-wrapper .todo-list-footer .add-task-btn .icon {
  color: var(--theme-default);
  font-size: 20px;
}
.todo .todo-list-wrapper .todo-list-footer .new-task-wrapper {
  transition: all 300ms ease;
  max-height: 0;
  overflow: hidden;
}
.todo .todo-list-wrapper .todo-list-footer .new-task-wrapper textarea {
  box-sizing: border-box;
  width: 100%;
  border: 1px solid #f4f4f4;
  height: 90px;
  padding: 10px 15px;
  margin-bottom: 10px;
  border-radius: 4px;
  transition: all 300ms ease;
}
.todo .todo-list-wrapper .todo-list-footer .new-task-wrapper textarea:focus {
  border: 1px solid #efefef;
  outline: none;
}
.todo .todo-list-wrapper .todo-list-footer .new-task-wrapper textarea.error {
  border: 1px solid #fc4438;
  outline: none;
}
.todo .todo-list-wrapper .todo-list-footer .new-task-wrapper .error-message {
  color: #fc4438;
  font-style: italic;
}
.todo .todo-list-wrapper .todo-list-footer .new-task-wrapper.visible {
  max-height: 300px;
  overflow: auto;
}
.todo .todo-list-wrapper .todo-list-footer .new-task-wrapper::after {
  content: "";
  display: block;
  clear: both;
}
.todo .todo-list-wrapper .todo-list-body {
  max-height: 500px;
  overflow: auto;
}
.todo .todo-list-wrapper #todo-list {
  list-style: none;
  margin: 0;
  padding: 0;
}
.todo .todo-list-wrapper #todo-list .task:first-child .task-container {
  padding-top: 0;
}
.todo .todo-list-wrapper #todo-list .task:first-child .task-container h4, .todo .todo-list-wrapper #todo-list .task:first-child .task-container .h4 {
  padding-top: 0;
}
.todo .todo-list-wrapper #todo-list li {
  margin: 0;
  padding: 0;
}
.todo .todo-list-wrapper #todo-list li .task-container {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  width: 100%;
  border-bottom: 1px solid #f4f4f4;
  box-sizing: border-box;
  position: relative;
  transition: background 200ms ease;
}
.todo .todo-list-wrapper #todo-list li .task-container .assign-name {
  font-size: 14px;
}
.todo .todo-list-wrapper #todo-list li .task-container .task-label {
  display: block;
  font-size: 17px;
  vertical-align: middle;
  color: #898989;
  word-break: break-all;
  padding-top: 5px;
  font-weight: 300;
}
.todo .todo-list-wrapper #todo-list li .task-container .task-action-btn {
  display: table-cell;
  vertical-align: middle;
  text-align: right;
  min-width: 65px;
}
.todo .todo-list-wrapper #todo-list li .task-container .task-action-btn .action-box {
  margin-left: 5px;
  margin-top: 2px;
  border: 1px solid transparent;
  margin-bottom: 2px;
}
.todo .todo-list-wrapper #todo-list li .task-container .task-action-btn .action-box .icon {
  font-size: 16px;
}
.todo .todo-list-wrapper #todo-list li .task-container .task-action-btn .action-box:hover {
  border: 1px solid #59667a;
  background: #fff;
  border-radius: 4px;
}
.todo .todo-list-wrapper #todo-list li .task-container .task-action-btn .action-box:hover .icon {
  color: #59667a;
}
.todo .todo-list-wrapper #todo-list li .task-container:hover h4, .todo .todo-list-wrapper #todo-list li .task-container:hover .h4 {
  color: #2c323f;
  transition: all 0.3s ease;
}
.todo .todo-list-wrapper #todo-list li.completed .task-container .complete-btn {
  border: 1px solid var(--theme-default);
  border-radius: 4px;
}
.todo .todo-list-wrapper #todo-list li.completed .task-container .complete-btn .icon {
  font-weight: bold;
}
.todo .todo-list-wrapper #todo-list li.completed .task-container .complete-btn:hover {
  background: #fff;
  border: 1px solid #54ba4a;
}
.todo .todo-list-wrapper #todo-list li.completed .task-container .complete-btn:hover .icon {
  color: #fff;
}
.todo .todo-list-wrapper #todo-list li.completed .task-container .task-label {
  text-decoration: line-through;
  color: var(--theme-default);
}
.todo .todo-list-wrapper #todo-list li.new .task-container {
  animation: taskHighlighter 2000ms linear 1;
}
.todo .todo-list-wrapper .todo-list-header h5, .todo .todo-list-wrapper .todo-list-header .h5 {
  text-align: center;
  color: #efefef;
}
.todo .notification-popup {
  position: fixed;
  top: 85px;
  right: 10px;
  width: 300px;
  display: inline-block;
  background: #54ba4a;
  border: 1px solid #54ba4a;
  color: #fff;
  padding: 20px;
  opacity: 0.9;
  border-radius: 2px;
  box-sizing: border-box;
  transition: all 300ms ease;
}
.todo .notification-popup.success {
  background: #54ba4a;
  border: 1px solid #54ba4a;
}
.todo .notification-popup p {
  margin-top: 0;
  margin-bottom: 0;
  color: #fff;
}
.todo .notification-popup .task {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
  display: inline-block;
}
.todo .notification-popup .notification-text {
  font-size: 14px;
  display: inline-block;
  overflow: hidden;
}
.todo .notification-popup.hide {
  opacity: 0;
  visibility: hidden;
}
@keyframes taskHighlighter {
  0% {
    background: rgba(68, 102, 242, 0.5);
  }
  100% {
    background: #fff;
  }
}

.todo-wrap .todo-list-body .assign-name {
  opacity: 0.4;
}
.todo-wrap .left-bookmark ul li .iconbg {
  padding: 8px;
  border-radius: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.todo-wrap.email-wrap .email-app-sidebar .main-menu > li + li {
  padding-top: 12px;
}
.todo-wrap.email-wrap .email-app-sidebar .main-menu > li a {
  padding: 0 16px;
}
.todo-wrap.email-wrap .email-app-sidebar .main-menu > li a .badge {
  color: #fff;
  padding: 4px 5px 3px;
}
.todo-wrap.email-wrap .email-app-sidebar .main-menu > li a:hover {
  background-color: transparent;
}
.todo-wrap.email-wrap .email-app-sidebar .main-menu > li a:hover .badge {
  color: #fff;
}
.todo-wrap.email-wrap .btn-mail {
  color: #fff !important;
}

/*====todo css end====*/`, "",{"version":3,"sources":["webpack://./src/index.scss","webpack://./node_modules/bootstrap-scss/mixins/_banner.scss","webpack://./node_modules/bootstrap-scss/_root.scss","webpack://./node_modules/bootstrap-scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap-scss/mixins/_color-mode.scss","webpack://./node_modules/bootstrap-scss/_reboot.scss","webpack://./node_modules/bootstrap-scss/_variables.scss","webpack://./node_modules/bootstrap-scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap-scss/_type.scss","webpack://./node_modules/bootstrap-scss/mixins/_lists.scss","webpack://./node_modules/bootstrap-scss/_images.scss","webpack://./node_modules/bootstrap-scss/mixins/_image.scss","webpack://./node_modules/bootstrap-scss/_containers.scss","webpack://./node_modules/bootstrap-scss/mixins/_container.scss","webpack://./node_modules/bootstrap-scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap-scss/_grid.scss","webpack://./node_modules/bootstrap-scss/mixins/_grid.scss","webpack://./node_modules/bootstrap-scss/_tables.scss","webpack://./node_modules/bootstrap-scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap-scss/forms/_labels.scss","webpack://./node_modules/bootstrap-scss/forms/_form-text.scss","webpack://./node_modules/bootstrap-scss/forms/_form-control.scss","webpack://./node_modules/bootstrap-scss/mixins/_transition.scss","webpack://./node_modules/bootstrap-scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap-scss/forms/_form-select.scss","webpack://./node_modules/bootstrap-scss/forms/_form-check.scss","webpack://./node_modules/bootstrap-scss/forms/_form-range.scss","webpack://./node_modules/bootstrap-scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap-scss/forms/_input-group.scss","webpack://./node_modules/bootstrap-scss/mixins/_forms.scss","webpack://./node_modules/bootstrap-scss/_buttons.scss","webpack://./node_modules/bootstrap-scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap-scss/_transitions.scss","webpack://./node_modules/bootstrap-scss/_dropdown.scss","webpack://./node_modules/bootstrap-scss/mixins/_caret.scss","webpack://./node_modules/bootstrap-scss/_button-group.scss","webpack://./node_modules/bootstrap-scss/_nav.scss","webpack://./node_modules/bootstrap-scss/_navbar.scss","webpack://./node_modules/bootstrap-scss/_card.scss","webpack://./node_modules/bootstrap-scss/_accordion.scss","webpack://./node_modules/bootstrap-scss/_breadcrumb.scss","webpack://./node_modules/bootstrap-scss/_pagination.scss","webpack://./node_modules/bootstrap-scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap-scss/_badge.scss","webpack://./node_modules/bootstrap-scss/_alert.scss","webpack://./node_modules/bootstrap-scss/_progress.scss","webpack://./node_modules/bootstrap-scss/_list-group.scss","webpack://./node_modules/bootstrap-scss/_close.scss","webpack://./node_modules/bootstrap-scss/_toasts.scss","webpack://./node_modules/bootstrap-scss/_modal.scss","webpack://./node_modules/bootstrap-scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap-scss/_tooltip.scss","webpack://./node_modules/bootstrap-scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap-scss/_popover.scss","webpack://./node_modules/bootstrap-scss/_carousel.scss","webpack://./node_modules/bootstrap-scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap-scss/_spinners.scss","webpack://./node_modules/bootstrap-scss/_offcanvas.scss","webpack://./node_modules/bootstrap-scss/_placeholders.scss","webpack://./node_modules/bootstrap-scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap-scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap-scss/helpers/_focus-ring.scss","webpack://./node_modules/bootstrap-scss/helpers/_icon-link.scss","webpack://./node_modules/bootstrap-scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap-scss/helpers/_position.scss","webpack://./node_modules/bootstrap-scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap-scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap-scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap-scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap-scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap-scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap-scss/helpers/_vr.scss","webpack://./node_modules/bootstrap-scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap-scss/utilities/_api.scss","webpack://./src/assets/scss/style.scss","webpack://./src/assets/scss/base/_reset.scss","webpack://./src/assets/scss/utils/_variables.scss","webpack://./src/assets/scss/base/_typography.scss","webpack://./src/assets/scss/components/_according.scss","webpack://./src/assets/scss/components/_alert.scss","webpack://./src/assets/scss/components/_avatars.scss","webpack://./src/assets/scss/components/_badge.scss","webpack://./src/assets/scss/components/_bookmark.scss","webpack://./src/assets/scss/components/_breadcrumb.scss","webpack://./src/assets/scss/components/_builders.scss","webpack://./src/assets/scss/components/_buttons.scss","webpack://./src/assets/scss/components/_card.scss","webpack://./src/assets/scss/components/_color.scss","webpack://./src/assets/scss/components/_datepicker.scss","webpack://./src/assets/scss/components/_dropdown.scss","webpack://./src/assets/scss/components/_datatable.scss","webpack://./src/assets/scss/components/_form-input.scss","webpack://./src/assets/scss/components/_form-wizard.scss","webpack://./src/assets/scss/components/_forms.scss","webpack://./src/assets/scss/components/_icons.scss","webpack://./src/assets/scss/components/_list.scss","webpack://./src/assets/scss/components/_loader.scss","webpack://./src/assets/scss/components/_popover.scss","webpack://./src/assets/scss/components/_print.scss","webpack://./src/assets/scss/components/_radio.scss","webpack://./src/assets/scss/components/_ribbon.scss","webpack://./src/assets/scss/components/_switch.scss","webpack://./src/assets/scss/components/_tab.scss","webpack://./src/assets/scss/components/_table.scss","webpack://./src/assets/scss/components/_timePeeker.scss","webpack://./src/assets/scss/components/_touchspin.scss","webpack://./src/assets/scss/components/_tour.scss","webpack://./src/assets/scss/components/_typeahead-search.scss","webpack://./src/assets/scss/components/_react-plugin.scss","webpack://./src/assets/scss/components/slick.scss","webpack://./src/assets/scss/components/slick-theme.scss","webpack://./src/assets/scss/components/_scrollbar.scss","webpack://./src/assets/scss/pages/_blog.scss","webpack://./src/assets/scss/pages/_bookmark-app.scss","webpack://./src/assets/scss/pages/_cart.scss","webpack://./src/assets/scss/pages/_chart.scss","webpack://./src/assets/scss/pages/_chat.scss","webpack://./src/assets/scss/pages/_checkout.scss","webpack://./src/assets/scss/pages/_comingsoon.scss","webpack://./src/assets/scss/pages/_contacts.scss","webpack://./src/assets/scss/pages/_dashboard_2.scss","webpack://./src/assets/scss/pages/_dashboard_3.scss","webpack://./src/assets/scss/pages/_dashboard_4.scss","webpack://./src/assets/scss/pages/_dashboard_5.scss","webpack://./src/assets/scss/pages/_dashboard_default.scss","webpack://./src/assets/scss/pages/_ecommerce.scss","webpack://./src/assets/scss/pages/_email-application.scss","webpack://./src/assets/scss/pages/_errorpage.scss","webpack://./src/assets/scss/pages/_faq.scss","webpack://./src/assets/scss/pages/_file.scss","webpack://./src/assets/scss/pages/_gallery.scss","webpack://./src/assets/scss/pages/_internationalization.scss","webpack://./src/assets/scss/pages/_job-search.scss","webpack://./src/assets/scss/pages/_jsgrid.scss","webpack://./src/assets/scss/pages/_kanban.scss","webpack://./src/assets/scss/pages/_knowledgebase.scss","webpack://./src/assets/scss/pages/_language.scss","webpack://./src/assets/scss/pages/_learning.scss","webpack://./src/assets/scss/pages/_login.scss","webpack://./src/assets/scss/pages/_megaoption.scss","webpack://./src/assets/scss/pages/_order-history.scss","webpack://./src/assets/scss/pages/_page.scss","webpack://./src/assets/scss/pages/_pricing.scss","webpack://./src/assets/scss/pages/_progress.scss","webpack://./src/assets/scss/pages/_projectlist.scss","webpack://./src/assets/scss/pages/_social-app.scss","webpack://./src/assets/scss/pages/_task.scss","webpack://./src/assets/scss/pages/_timeline-v.scss","webpack://./src/assets/scss/pages/_timeliny.scss","webpack://./src/assets/scss/pages/_user-profile.scss","webpack://./src/assets/scss/pages/_wishlist.scss","webpack://./src/assets/scss/layout/_footer.scss","webpack://./src/assets/scss/layout/_grid.scss","webpack://./src/assets/scss/layout/_header.scss","webpack://./src/assets/scss/layout/_navs.scss","webpack://./src/assets/scss/layout/_search.scss","webpack://./src/assets/scss/layout/_select2.scss","webpack://./src/assets/scss/layout/_sidebar.scss","webpack://./src/assets/scss/layout/_rtl.scss","webpack://./src/assets/scss/layout/_box-layout.scss","webpack://./src/assets/scss/themes/_dark.scss","webpack://./src/assets/scss/themes/_theme-customizer.scss","webpack://./src/assets/scss/themes/_responsive.scss","webpack://./src/assets/scss/themes/_update.scss","webpack://./src/assets/scss/vendors/chartist/_chartist.scss","webpack://./src/assets/scss/vendors/chartist/_chartist-settings.scss","webpack://./src/assets/scss/vendors/themify/_path.scss","webpack://./src/assets/scss/vendors/themify/_core.scss","webpack://./src/assets/scss/vendors/themify/_mixins.scss","webpack://./src/assets/scss/vendors/themify/_variables.scss","webpack://./src/assets/scss/vendors/themify/_extras.scss","webpack://./src/assets/scss/vendors/themify/_icons.scss","webpack://./src/assets/scss/vendors/whether-icon/_whether-icon.scss","webpack://./src/assets/scss/vendors/icoicon/_icons.scss","webpack://./src/assets/scss/vendors/flag-icon/_flag-icon-base.scss","webpack://./src/assets/scss/vendors/fontawesome.scss","webpack://./src/assets/scss/vendors/font-awesome/_path.scss","webpack://./src/assets/scss/vendors/font-awesome/_core.scss","webpack://./src/assets/scss/vendors/font-awesome/_larger.scss","webpack://./src/assets/scss/vendors/font-awesome/_fixed-width.scss","webpack://./src/assets/scss/vendors/font-awesome/_list.scss","webpack://./src/assets/scss/vendors/font-awesome/_variables.scss","webpack://./src/assets/scss/vendors/font-awesome/_bordered-pulled.scss","webpack://./src/assets/scss/vendors/font-awesome/_animated.scss","webpack://./src/assets/scss/vendors/font-awesome/_rotated-flipped.scss","webpack://./src/assets/scss/vendors/font-awesome/_mixins.scss","webpack://./src/assets/scss/vendors/font-awesome/_stacked.scss","webpack://./src/assets/scss/vendors/font-awesome/_icons.scss","webpack://./src/assets/scss/vendors/font-awesome/_screen-reader.scss","webpack://./src/assets/scss/vendors/animate/_animate.scss","webpack://./src/assets/scss/vendors/sticky/_sticky.scss","webpack://./src/assets/scss/vendors/todo/_todo.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACCd;;;;EAAA;ACDF;;EASI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAIA,8BAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,6BAAA;EAAA,yBAAA;EAIA,8EAAA;EAAA,iFAAA;EAAA,8EAAA;EAAA,2EAAA;EAAA,mEAAA;EAAA,6EAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,2EAAA;EAAA,6EAAA;EAAA,2EAAA;EAAA,wEAAA;EAAA,gEAAA;EAAA,0EAAA;EAAA,yEAAA;EAAA,4BAAA;EAIA,+EAAA;EAAA,iFAAA;EAAA,+EAAA;EAAA,4EAAA;EAAA,qEAAA;EAAA,8EAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,6BAAA;EACA,uBAAA;EAMA,qNAAA;EACA,yGAAA;EACA,yFAAA;EAOA,gDAAA;EC2OI,yBALI;EDpOR,0BAAA;EACA,0BAAA;EAKA,wBAAA;EACA,+BAAA;EACA,kBAAA;EACA,+BAAA;EAEA,yBAAA;EACA,gCAAA;EAEA,4CAAA;EACA,oCAAA;EACA,0BAAA;EACA,oCAAA;EAEA,0CAAA;EACA,mCAAA;EACA,yBAAA;EACA,mCAAA;EAGA,2BAAA;EAEA,wBAAA;EACA,iCAAA;EACA,+BAAA;EAEA,yEAAA;EACA,sCAAA;EAMA,wBAAA;EACA,6BAAA;EACA,2DAAA;EAGA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,mDAAA;EAEA,4BAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mDAAA;EACA,8BAAA;EAGA,kDAAA;EACA,2DAAA;EACA,oDAAA;EACA,2DAAA;EAIA,8BAAA;EACA,6BAAA;EACA,+CAAA;EAIA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AFaF;;AI7HI;EFsHA,kBAAA;EAGA,wBAAA;EACA,kCAAA;EACA,qBAAA;EACA,4BAAA;EAEA,yBAAA;EACA,sCAAA;EAEA,+CAAA;EACA,uCAAA;EACA,0BAAA;EACA,iCAAA;EAEA,6CAAA;EACA,sCAAA;EACA,qEAAA;EACA,gCAAA;EAGE,+EAAA;EAAA,iFAAA;EAAA,+EAAA;EAAA,4EAAA;EAAA,qEAAA;EAAA,8EAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,yEAAA;EAAA,0EAAA;EAAA,yEAAA;EAAA,uEAAA;EAAA,8DAAA;EAAA,wEAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,8EAAA;EAAA,iFAAA;EAAA,8EAAA;EAAA,2EAAA;EAAA,mEAAA;EAAA,8EAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,2BAAA;EAEA,oEAAA;EACA,0EAAA;EACA,kCAAA;EACA,wCAAA;EAEA,yDAAA;EACA,6BAAA;EACA,0DAAA;EAEA,0BAAA;EACA,wDAAA;EAEA,0EAAA;EACA,iFAAA;EACA,4EAAA;EACA,mFAAA;AFaJ;;AKrLA;;;EAGE,sBAAA;ALwLF;;AKzKI;EANJ;IAOM,uBAAA;EL6KJ;AACF;;AKhKA;EACE,SAAA;EACA,uCAAA;EF6OI,mCALI;EEtOR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,6CAAA;ALmKF;;AK1JA;EACE,cAAA;EACA,cCmnB4B;EDlnB5B,SAAA;EACA,wCAAA;EACA,aCynB4B;AN5d9B;;AKnJA;EACE,aAAA;EACA,qBCwjB4B;EDrjB5B,gBCwjB4B;EDvjB5B,gBCwjB4B;EDvjB5B,8BAAA;ALoJF;;AKjJA;EFuMQ,iCAAA;AHlDR;AG1GI;EE3CJ;IF8MQ,iBAAA;EHrDN;AACF;;AKrJA;EFkMQ,iCAAA;AHzCR;AGnHI;EEtCJ;IFyMQ,eAAA;EH5CN;AACF;;AKzJA;EF6LQ,+BAAA;AHhCR;AG5HI;EEjCJ;IFoMQ,kBAAA;EHnCN;AACF;;AK7JA;EFwLQ,iCAAA;AHvBR;AGrII;EE5BJ;IF+LQ,iBAAA;EH1BN;AACF;;AKjKA;EF+KM,kBALI;AHLV;;AKhKA;EF0KM,eALI;AHDV;;AKzJA;EACE,aAAA;EACA,mBCwV0B;AN5L5B;;AKlJA;EACE,iCAAA;EACA,YAAA;EACA,8BAAA;ALqJF;;AK/IA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;ALkJF;;AK5IA;;EAEE,kBAAA;AL+IF;;AK5IA;;;EAGE,aAAA;EACA,mBAAA;AL+IF;;AK5IA;;;;EAIE,gBAAA;AL+IF;;AK5IA;EACE,gBC6b4B;AN9S9B;;AK1IA;EACE,qBAAA;EACA,cAAA;AL6IF;;AKvIA;EACE,gBAAA;AL0IF;;AKlIA;;EAEE,mBCsa4B;ANjS9B;;AK7HA;EF6EM,kBALI;AHyDV;;AK1HA;EACE,iBCqf4B;EDpf5B,gCAAA;EACA,wCAAA;AL6HF;;AKpHA;;EAEE,kBAAA;EFwDI,iBALI;EEjDR,cAAA;EACA,wBAAA;ALuHF;;AKpHA;EAAM,eAAA;ALwHN;;AKvHA;EAAM,WAAA;AL2HN;;AKtHA;EACE,gEAAA;EACA,0BCgNwC;ANvF1C;AKvHE;EACE,mDAAA;ALyHJ;;AK9GE;EAEE,cAAA;EACA,qBAAA;ALgHJ;;AKzGA;;;;EAIE,qCCgV4B;EHlUxB,cALI;AHoGV;;AKrGA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EFEI,kBALI;AH4GV;AKpGE;EFHI,kBALI;EEUN,cAAA;EACA,kBAAA;ALsGJ;;AKlGA;EFVM,kBALI;EEiBR,2BAAA;EACA,qBAAA;ALqGF;AKlGE;EACE,cAAA;ALoGJ;;AKhGA;EACE,2BAAA;EFtBI,kBALI;EE6BR,wBC25CkC;ED15ClC,sCC25CkC;EChsDhC,sBAAA;APyYJ;AKjGE;EACE,UAAA;EF7BE,cALI;AHsIV;;AKzFA;EACE,gBAAA;AL4FF;;AKtFA;;EAEE,sBAAA;ALyFF;;AKjFA;EACE,oBAAA;EACA,yBAAA;ALoFF;;AKjFA;EACE,mBC4X4B;ED3X5B,sBC2X4B;ED1X5B,gCC4Z4B;ED3Z5B,gBAAA;ALoFF;;AK7EA;EAEE,mBAAA;EACA,gCAAA;AL+EF;;AK5EA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;AL+EF;;AKvEA;EACE,qBAAA;AL0EF;;AKpEA;EAEE,gBAAA;ALsEF;;AK9DA;EACE,UAAA;ALiEF;;AK5DA;;;;;EAKE,SAAA;EACA,oBAAA;EF5HI,kBALI;EEmIR,oBAAA;AL+DF;;AK3DA;;EAEE,oBAAA;AL8DF;;AKzDA;EACE,eAAA;AL4DF;;AKzDA;EAGE,iBAAA;AL0DF;AKvDE;EACE,UAAA;ALyDJ;;AKlDA;EACE,wBAAA;ALqDF;;AK7CA;;;;EAIE,0BAAA;ALgDF;AK7CI;;;;EACE,eAAA;ALkDN;;AK3CA;EACE,UAAA;EACA,kBAAA;AL8CF;;AKzCA;EACE,gBAAA;AL4CF;;AKlCA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;ALqCF;;AK7BA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBCmN4B;EDjN5B,oBAAA;EFnNM,iCAAA;AHmPR;AG/YI;EEyWJ;IFtMQ,iBAAA;EHgPN;AACF;AKlCE;EACE,WAAA;ALoCJ;;AK7BA;;;;;;;EAOE,UAAA;ALgCF;;AK7BA;EACE,YAAA;ALgCF;;AKvBA;EACE,6BAAA;EACA,oBAAA;AL0BF;AKvBE;EACE,eAAA;EACA,oBAAA;ALyBJ;;AKhBA;;;;;;;CAAA;AAWA;EACE,wBAAA;ALgBF;;AKXA;EACE,UAAA;ALcF;;AKPA;EACE,aAAA;EACA,0BAAA;ALUF;;AKLA;EACE,qBAAA;ALQF;;AKHA;EACE,SAAA;ALMF;;AKCA;EACE,kBAAA;EACA,eAAA;ALEF;;AKMA;EACE,wBAAA;ALHF;;AKWA;EACE,wBAAA;ALRF;;AQnkBA;ELmQM,kBALI;EK5PR,gBFwoB4B;ANlE9B;;AQjkBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AHuUR;AGneI;EKpGF;ILuQM,eAAA;EHoUN;AACF;;AQ5kBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AHkVR;AG9eI;EKpGF;ILuQM,iBAAA;EH+UN;AACF;;AQvlBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AH6VR;AGzfI;EKpGF;ILuQM,eAAA;EH0VN;AACF;;AQlmBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AHwWR;AGpgBI;EKpGF;ILuQM,iBAAA;EHqWN;AACF;;AQ7mBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AHmXR;AG/gBI;EKpGF;ILuQM,eAAA;EHgXN;AACF;;AQxnBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AH8XR;AG1hBI;EKpGF;ILuQM,iBAAA;EH2XN;AACF;;AQ3mBA;ECvDE,eAAA;EACA,gBAAA;ATsqBF;;AQ3mBA;EC5DE,eAAA;EACA,gBAAA;AT2qBF;;AQ7mBA;EACE,qBAAA;ARgnBF;AQ9mBE;EACE,oBFsoB0B;ANtB9B;;AQtmBA;EL8MM,kBALI;EKvMR,yBAAA;ARymBF;;AQrmBA;EACE,mBFiUO;EH1HH,kBALI;AHuaV;AQtmBE;EACE,gBAAA;ARwmBJ;;AQpmBA;EACE,iBAAA;EACA,mBFuTO;EH1HH,kBALI;EKtLR,cFtFS;AN6rBX;AQrmBE;EACE,aAAA;ARumBJ;;AUvsBA;ECIE,eAAA;EAGA,YAAA;AXqsBF;;AUtsBA;EACE,gBJ+jDkC;EI9jDlC,mCJ+jDkC;EI9jDlC,2DAAA;EHGE,sCAAA;EIRF,eAAA;EAGA,YAAA;AX8sBF;;AUhsBA;EAEE,qBAAA;AVksBF;;AU/rBA;EACE,qBAAA;EACA,cAAA;AVksBF;;AU/rBA;EPyPM,kBALI;EOlPR,gCJkjDkC;ANh3BpC;;AYpuBE;;;;;;;ECHA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;AbivBF;;Ac3rBI;EF5CE;IACE,gBNkee;ENyQrB;AACF;AcjsBI;EF5CE;IACE,gBNkee;EN8QrB;AACF;ActsBI;EF5CE;IACE,gBNkee;ENmRrB;AACF;Ac3sBI;EF5CE;IACE,iBNkee;ENwRrB;AACF;AchtBI;EF5CE;IACE,iBNkee;EN6RrB;AACF;AehxBA;EAEI,qBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;AfsxBJ;;AejxBE;ECNA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;AhB0xBF;AexxBI;ECOF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AhBoxBF;;AgBruBM;EACE,SAAA;AhBwuBR;;AgBruBM;EApCJ,cAAA;EACA,WAAA;AhB6wBF;;AgB/vBE;EACE,cAAA;EACA,WAAA;AhBkwBJ;;AgBpwBE;EACE,cAAA;EACA,UAAA;AhBuwBJ;;AgBzwBE;EACE,cAAA;EACA,mBAAA;AhB4wBJ;;AgB9wBE;EACE,cAAA;EACA,UAAA;AhBixBJ;;AgBnxBE;EACE,cAAA;EACA,UAAA;AhBsxBJ;;AgBxxBE;EACE,cAAA;EACA,mBAAA;AhB2xBJ;;AgB5vBM;EAhDJ,cAAA;EACA,WAAA;AhBgzBF;;AgB3vBU;EAhEN,cAAA;EACA,kBAAA;AhB+zBJ;;AgBhwBU;EAhEN,cAAA;EACA,mBAAA;AhBo0BJ;;AgBrwBU;EAhEN,cAAA;EACA,UAAA;AhBy0BJ;;AgB1wBU;EAhEN,cAAA;EACA,mBAAA;AhB80BJ;;AgB/wBU;EAhEN,cAAA;EACA,mBAAA;AhBm1BJ;;AgBpxBU;EAhEN,cAAA;EACA,UAAA;AhBw1BJ;;AgBzxBU;EAhEN,cAAA;EACA,mBAAA;AhB61BJ;;AgB9xBU;EAhEN,cAAA;EACA,mBAAA;AhBk2BJ;;AgBnyBU;EAhEN,cAAA;EACA,UAAA;AhBu2BJ;;AgBxyBU;EAhEN,cAAA;EACA,mBAAA;AhB42BJ;;AgB7yBU;EAhEN,cAAA;EACA,mBAAA;AhBi3BJ;;AgBlzBU;EAhEN,cAAA;EACA,WAAA;AhBs3BJ;;AgB/yBY;EAxDV,wBAAA;AhB22BF;;AgBnzBY;EAxDV,yBAAA;AhB+2BF;;AgBvzBY;EAxDV,gBAAA;AhBm3BF;;AgB3zBY;EAxDV,yBAAA;AhBu3BF;;AgB/zBY;EAxDV,yBAAA;AhB23BF;;AgBn0BY;EAxDV,gBAAA;AhB+3BF;;AgBv0BY;EAxDV,yBAAA;AhBm4BF;;AgB30BY;EAxDV,yBAAA;AhBu4BF;;AgB/0BY;EAxDV,gBAAA;AhB24BF;;AgBn1BY;EAxDV,yBAAA;AhB+4BF;;AgBv1BY;EAxDV,yBAAA;AhBm5BF;;AgBh1BQ;;EAEE,gBAAA;AhBm1BV;;AgBh1BQ;;EAEE,gBAAA;AhBm1BV;;AgB11BQ;;EAEE,sBAAA;AhB61BV;;AgB11BQ;;EAEE,sBAAA;AhB61BV;;AgBp2BQ;;EAEE,qBAAA;AhBu2BV;;AgBp2BQ;;EAEE,qBAAA;AhBu2BV;;AgB92BQ;;EAEE,mBAAA;AhBi3BV;;AgB92BQ;;EAEE,mBAAA;AhBi3BV;;AgBx3BQ;;EAEE,qBAAA;AhB23BV;;AgBx3BQ;;EAEE,qBAAA;AhB23BV;;AgBl4BQ;;EAEE,mBAAA;AhBq4BV;;AgBl4BQ;;EAEE,mBAAA;AhBq4BV;;Ac/7BI;EEUE;IACE,SAAA;EhBy7BN;EgBt7BI;IApCJ,cAAA;IACA,WAAA;EhB69BA;EgB/8BA;IACE,cAAA;IACA,WAAA;EhBi9BF;EgBn9BA;IACE,cAAA;IACA,UAAA;EhBq9BF;EgBv9BA;IACE,cAAA;IACA,mBAAA;EhBy9BF;EgB39BA;IACE,cAAA;IACA,UAAA;EhB69BF;EgB/9BA;IACE,cAAA;IACA,UAAA;EhBi+BF;EgBn+BA;IACE,cAAA;IACA,mBAAA;EhBq+BF;EgBt8BI;IAhDJ,cAAA;IACA,WAAA;EhBy/BA;EgBp8BQ;IAhEN,cAAA;IACA,kBAAA;EhBugCF;EgBx8BQ;IAhEN,cAAA;IACA,mBAAA;EhB2gCF;EgB58BQ;IAhEN,cAAA;IACA,UAAA;EhB+gCF;EgBh9BQ;IAhEN,cAAA;IACA,mBAAA;EhBmhCF;EgBp9BQ;IAhEN,cAAA;IACA,mBAAA;EhBuhCF;EgBx9BQ;IAhEN,cAAA;IACA,UAAA;EhB2hCF;EgB59BQ;IAhEN,cAAA;IACA,mBAAA;EhB+hCF;EgBh+BQ;IAhEN,cAAA;IACA,mBAAA;EhBmiCF;EgBp+BQ;IAhEN,cAAA;IACA,UAAA;EhBuiCF;EgBx+BQ;IAhEN,cAAA;IACA,mBAAA;EhB2iCF;EgB5+BQ;IAhEN,cAAA;IACA,mBAAA;EhB+iCF;EgBh/BQ;IAhEN,cAAA;IACA,WAAA;EhBmjCF;EgB5+BU;IAxDV,cAAA;EhBuiCA;EgB/+BU;IAxDV,wBAAA;EhB0iCA;EgBl/BU;IAxDV,yBAAA;EhB6iCA;EgBr/BU;IAxDV,gBAAA;EhBgjCA;EgBx/BU;IAxDV,yBAAA;EhBmjCA;EgB3/BU;IAxDV,yBAAA;EhBsjCA;EgB9/BU;IAxDV,gBAAA;EhByjCA;EgBjgCU;IAxDV,yBAAA;EhB4jCA;EgBpgCU;IAxDV,yBAAA;EhB+jCA;EgBvgCU;IAxDV,gBAAA;EhBkkCA;EgB1gCU;IAxDV,yBAAA;EhBqkCA;EgB7gCU;IAxDV,yBAAA;EhBwkCA;EgBrgCM;;IAEE,gBAAA;EhBugCR;EgBpgCM;;IAEE,gBAAA;EhBsgCR;EgB7gCM;;IAEE,sBAAA;EhB+gCR;EgB5gCM;;IAEE,sBAAA;EhB8gCR;EgBrhCM;;IAEE,qBAAA;EhBuhCR;EgBphCM;;IAEE,qBAAA;EhBshCR;EgB7hCM;;IAEE,mBAAA;EhB+hCR;EgB5hCM;;IAEE,mBAAA;EhB8hCR;EgBriCM;;IAEE,qBAAA;EhBuiCR;EgBpiCM;;IAEE,qBAAA;EhBsiCR;EgB7iCM;;IAEE,mBAAA;EhB+iCR;EgB5iCM;;IAEE,mBAAA;EhB8iCR;AACF;AczmCI;EEUE;IACE,SAAA;EhBkmCN;EgB/lCI;IApCJ,cAAA;IACA,WAAA;EhBsoCA;EgBxnCA;IACE,cAAA;IACA,WAAA;EhB0nCF;EgB5nCA;IACE,cAAA;IACA,UAAA;EhB8nCF;EgBhoCA;IACE,cAAA;IACA,mBAAA;EhBkoCF;EgBpoCA;IACE,cAAA;IACA,UAAA;EhBsoCF;EgBxoCA;IACE,cAAA;IACA,UAAA;EhB0oCF;EgB5oCA;IACE,cAAA;IACA,mBAAA;EhB8oCF;EgB/mCI;IAhDJ,cAAA;IACA,WAAA;EhBkqCA;EgB7mCQ;IAhEN,cAAA;IACA,kBAAA;EhBgrCF;EgBjnCQ;IAhEN,cAAA;IACA,mBAAA;EhBorCF;EgBrnCQ;IAhEN,cAAA;IACA,UAAA;EhBwrCF;EgBznCQ;IAhEN,cAAA;IACA,mBAAA;EhB4rCF;EgB7nCQ;IAhEN,cAAA;IACA,mBAAA;EhBgsCF;EgBjoCQ;IAhEN,cAAA;IACA,UAAA;EhBosCF;EgBroCQ;IAhEN,cAAA;IACA,mBAAA;EhBwsCF;EgBzoCQ;IAhEN,cAAA;IACA,mBAAA;EhB4sCF;EgB7oCQ;IAhEN,cAAA;IACA,UAAA;EhBgtCF;EgBjpCQ;IAhEN,cAAA;IACA,mBAAA;EhBotCF;EgBrpCQ;IAhEN,cAAA;IACA,mBAAA;EhBwtCF;EgBzpCQ;IAhEN,cAAA;IACA,WAAA;EhB4tCF;EgBrpCU;IAxDV,cAAA;EhBgtCA;EgBxpCU;IAxDV,wBAAA;EhBmtCA;EgB3pCU;IAxDV,yBAAA;EhBstCA;EgB9pCU;IAxDV,gBAAA;EhBytCA;EgBjqCU;IAxDV,yBAAA;EhB4tCA;EgBpqCU;IAxDV,yBAAA;EhB+tCA;EgBvqCU;IAxDV,gBAAA;EhBkuCA;EgB1qCU;IAxDV,yBAAA;EhBquCA;EgB7qCU;IAxDV,yBAAA;EhBwuCA;EgBhrCU;IAxDV,gBAAA;EhB2uCA;EgBnrCU;IAxDV,yBAAA;EhB8uCA;EgBtrCU;IAxDV,yBAAA;EhBivCA;EgB9qCM;;IAEE,gBAAA;EhBgrCR;EgB7qCM;;IAEE,gBAAA;EhB+qCR;EgBtrCM;;IAEE,sBAAA;EhBwrCR;EgBrrCM;;IAEE,sBAAA;EhBurCR;EgB9rCM;;IAEE,qBAAA;EhBgsCR;EgB7rCM;;IAEE,qBAAA;EhB+rCR;EgBtsCM;;IAEE,mBAAA;EhBwsCR;EgBrsCM;;IAEE,mBAAA;EhBusCR;EgB9sCM;;IAEE,qBAAA;EhBgtCR;EgB7sCM;;IAEE,qBAAA;EhB+sCR;EgBttCM;;IAEE,mBAAA;EhBwtCR;EgBrtCM;;IAEE,mBAAA;EhButCR;AACF;AclxCI;EEUE;IACE,SAAA;EhB2wCN;EgBxwCI;IApCJ,cAAA;IACA,WAAA;EhB+yCA;EgBjyCA;IACE,cAAA;IACA,WAAA;EhBmyCF;EgBryCA;IACE,cAAA;IACA,UAAA;EhBuyCF;EgBzyCA;IACE,cAAA;IACA,mBAAA;EhB2yCF;EgB7yCA;IACE,cAAA;IACA,UAAA;EhB+yCF;EgBjzCA;IACE,cAAA;IACA,UAAA;EhBmzCF;EgBrzCA;IACE,cAAA;IACA,mBAAA;EhBuzCF;EgBxxCI;IAhDJ,cAAA;IACA,WAAA;EhB20CA;EgBtxCQ;IAhEN,cAAA;IACA,kBAAA;EhBy1CF;EgB1xCQ;IAhEN,cAAA;IACA,mBAAA;EhB61CF;EgB9xCQ;IAhEN,cAAA;IACA,UAAA;EhBi2CF;EgBlyCQ;IAhEN,cAAA;IACA,mBAAA;EhBq2CF;EgBtyCQ;IAhEN,cAAA;IACA,mBAAA;EhBy2CF;EgB1yCQ;IAhEN,cAAA;IACA,UAAA;EhB62CF;EgB9yCQ;IAhEN,cAAA;IACA,mBAAA;EhBi3CF;EgBlzCQ;IAhEN,cAAA;IACA,mBAAA;EhBq3CF;EgBtzCQ;IAhEN,cAAA;IACA,UAAA;EhBy3CF;EgB1zCQ;IAhEN,cAAA;IACA,mBAAA;EhB63CF;EgB9zCQ;IAhEN,cAAA;IACA,mBAAA;EhBi4CF;EgBl0CQ;IAhEN,cAAA;IACA,WAAA;EhBq4CF;EgB9zCU;IAxDV,cAAA;EhBy3CA;EgBj0CU;IAxDV,wBAAA;EhB43CA;EgBp0CU;IAxDV,yBAAA;EhB+3CA;EgBv0CU;IAxDV,gBAAA;EhBk4CA;EgB10CU;IAxDV,yBAAA;EhBq4CA;EgB70CU;IAxDV,yBAAA;EhBw4CA;EgBh1CU;IAxDV,gBAAA;EhB24CA;EgBn1CU;IAxDV,yBAAA;EhB84CA;EgBt1CU;IAxDV,yBAAA;EhBi5CA;EgBz1CU;IAxDV,gBAAA;EhBo5CA;EgB51CU;IAxDV,yBAAA;EhBu5CA;EgB/1CU;IAxDV,yBAAA;EhB05CA;EgBv1CM;;IAEE,gBAAA;EhBy1CR;EgBt1CM;;IAEE,gBAAA;EhBw1CR;EgB/1CM;;IAEE,sBAAA;EhBi2CR;EgB91CM;;IAEE,sBAAA;EhBg2CR;EgBv2CM;;IAEE,qBAAA;EhBy2CR;EgBt2CM;;IAEE,qBAAA;EhBw2CR;EgB/2CM;;IAEE,mBAAA;EhBi3CR;EgB92CM;;IAEE,mBAAA;EhBg3CR;EgBv3CM;;IAEE,qBAAA;EhBy3CR;EgBt3CM;;IAEE,qBAAA;EhBw3CR;EgB/3CM;;IAEE,mBAAA;EhBi4CR;EgB93CM;;IAEE,mBAAA;EhBg4CR;AACF;Ac37CI;EEUE;IACE,SAAA;EhBo7CN;EgBj7CI;IApCJ,cAAA;IACA,WAAA;EhBw9CA;EgB18CA;IACE,cAAA;IACA,WAAA;EhB48CF;EgB98CA;IACE,cAAA;IACA,UAAA;EhBg9CF;EgBl9CA;IACE,cAAA;IACA,mBAAA;EhBo9CF;EgBt9CA;IACE,cAAA;IACA,UAAA;EhBw9CF;EgB19CA;IACE,cAAA;IACA,UAAA;EhB49CF;EgB99CA;IACE,cAAA;IACA,mBAAA;EhBg+CF;EgBj8CI;IAhDJ,cAAA;IACA,WAAA;EhBo/CA;EgB/7CQ;IAhEN,cAAA;IACA,kBAAA;EhBkgDF;EgBn8CQ;IAhEN,cAAA;IACA,mBAAA;EhBsgDF;EgBv8CQ;IAhEN,cAAA;IACA,UAAA;EhB0gDF;EgB38CQ;IAhEN,cAAA;IACA,mBAAA;EhB8gDF;EgB/8CQ;IAhEN,cAAA;IACA,mBAAA;EhBkhDF;EgBn9CQ;IAhEN,cAAA;IACA,UAAA;EhBshDF;EgBv9CQ;IAhEN,cAAA;IACA,mBAAA;EhB0hDF;EgB39CQ;IAhEN,cAAA;IACA,mBAAA;EhB8hDF;EgB/9CQ;IAhEN,cAAA;IACA,UAAA;EhBkiDF;EgBn+CQ;IAhEN,cAAA;IACA,mBAAA;EhBsiDF;EgBv+CQ;IAhEN,cAAA;IACA,mBAAA;EhB0iDF;EgB3+CQ;IAhEN,cAAA;IACA,WAAA;EhB8iDF;EgBv+CU;IAxDV,cAAA;EhBkiDA;EgB1+CU;IAxDV,wBAAA;EhBqiDA;EgB7+CU;IAxDV,yBAAA;EhBwiDA;EgBh/CU;IAxDV,gBAAA;EhB2iDA;EgBn/CU;IAxDV,yBAAA;EhB8iDA;EgBt/CU;IAxDV,yBAAA;EhBijDA;EgBz/CU;IAxDV,gBAAA;EhBojDA;EgB5/CU;IAxDV,yBAAA;EhBujDA;EgB//CU;IAxDV,yBAAA;EhB0jDA;EgBlgDU;IAxDV,gBAAA;EhB6jDA;EgBrgDU;IAxDV,yBAAA;EhBgkDA;EgBxgDU;IAxDV,yBAAA;EhBmkDA;EgBhgDM;;IAEE,gBAAA;EhBkgDR;EgB//CM;;IAEE,gBAAA;EhBigDR;EgBxgDM;;IAEE,sBAAA;EhB0gDR;EgBvgDM;;IAEE,sBAAA;EhBygDR;EgBhhDM;;IAEE,qBAAA;EhBkhDR;EgB/gDM;;IAEE,qBAAA;EhBihDR;EgBxhDM;;IAEE,mBAAA;EhB0hDR;EgBvhDM;;IAEE,mBAAA;EhByhDR;EgBhiDM;;IAEE,qBAAA;EhBkiDR;EgB/hDM;;IAEE,qBAAA;EhBiiDR;EgBxiDM;;IAEE,mBAAA;EhB0iDR;EgBviDM;;IAEE,mBAAA;EhByiDR;AACF;AcpmDI;EEUE;IACE,SAAA;EhB6lDN;EgB1lDI;IApCJ,cAAA;IACA,WAAA;EhBioDA;EgBnnDA;IACE,cAAA;IACA,WAAA;EhBqnDF;EgBvnDA;IACE,cAAA;IACA,UAAA;EhBynDF;EgB3nDA;IACE,cAAA;IACA,mBAAA;EhB6nDF;EgB/nDA;IACE,cAAA;IACA,UAAA;EhBioDF;EgBnoDA;IACE,cAAA;IACA,UAAA;EhBqoDF;EgBvoDA;IACE,cAAA;IACA,mBAAA;EhByoDF;EgB1mDI;IAhDJ,cAAA;IACA,WAAA;EhB6pDA;EgBxmDQ;IAhEN,cAAA;IACA,kBAAA;EhB2qDF;EgB5mDQ;IAhEN,cAAA;IACA,mBAAA;EhB+qDF;EgBhnDQ;IAhEN,cAAA;IACA,UAAA;EhBmrDF;EgBpnDQ;IAhEN,cAAA;IACA,mBAAA;EhBurDF;EgBxnDQ;IAhEN,cAAA;IACA,mBAAA;EhB2rDF;EgB5nDQ;IAhEN,cAAA;IACA,UAAA;EhB+rDF;EgBhoDQ;IAhEN,cAAA;IACA,mBAAA;EhBmsDF;EgBpoDQ;IAhEN,cAAA;IACA,mBAAA;EhBusDF;EgBxoDQ;IAhEN,cAAA;IACA,UAAA;EhB2sDF;EgB5oDQ;IAhEN,cAAA;IACA,mBAAA;EhB+sDF;EgBhpDQ;IAhEN,cAAA;IACA,mBAAA;EhBmtDF;EgBppDQ;IAhEN,cAAA;IACA,WAAA;EhButDF;EgBhpDU;IAxDV,cAAA;EhB2sDA;EgBnpDU;IAxDV,wBAAA;EhB8sDA;EgBtpDU;IAxDV,yBAAA;EhBitDA;EgBzpDU;IAxDV,gBAAA;EhBotDA;EgB5pDU;IAxDV,yBAAA;EhButDA;EgB/pDU;IAxDV,yBAAA;EhB0tDA;EgBlqDU;IAxDV,gBAAA;EhB6tDA;EgBrqDU;IAxDV,yBAAA;EhBguDA;EgBxqDU;IAxDV,yBAAA;EhBmuDA;EgB3qDU;IAxDV,gBAAA;EhBsuDA;EgB9qDU;IAxDV,yBAAA;EhByuDA;EgBjrDU;IAxDV,yBAAA;EhB4uDA;EgBzqDM;;IAEE,gBAAA;EhB2qDR;EgBxqDM;;IAEE,gBAAA;EhB0qDR;EgBjrDM;;IAEE,sBAAA;EhBmrDR;EgBhrDM;;IAEE,sBAAA;EhBkrDR;EgBzrDM;;IAEE,qBAAA;EhB2rDR;EgBxrDM;;IAEE,qBAAA;EhB0rDR;EgBjsDM;;IAEE,mBAAA;EhBmsDR;EgBhsDM;;IAEE,mBAAA;EhBksDR;EgBzsDM;;IAEE,qBAAA;EhB2sDR;EgBxsDM;;IAEE,qBAAA;EhB0sDR;EgBjtDM;;IAEE,mBAAA;EhBmtDR;EgBhtDM;;IAEE,mBAAA;EhBktDR;AACF;AiBx0DA;EAEE,8BAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,0CAAA;EACA,gCAAA;EACA,+CAAA;EACA,iCAAA;EACA,kDAAA;EACA,+DAAA;EACA,iDAAA;EACA,6DAAA;EACA,gDAAA;EACA,8DAAA;EAEA,WAAA;EACA,mBXkYO;EWjYP,mBXusB4B;EWtsB5B,0CAAA;AjBu0DF;AiBh0DE;EACE,sBAAA;EAEA,qFAAA;EACA,oCAAA;EACA,2CX+sB0B;EW9sB1B,2GAAA;AjBi0DJ;AiB9zDE;EACE,uBAAA;AjBg0DJ;AiB7zDE;EACE,sBAAA;AjB+zDJ;;AiB3zDA;EACE,+DAAA;AjB8zDF;;AiBvzDA;EACE,iBAAA;AjB0zDF;;AiBhzDE;EACE,wBAAA;AjBmzDJ;;AiBpyDE;EACE,sCAAA;AjBuyDJ;AiBpyDI;EACE,sCAAA;AjBsyDN;;AiB/xDE;EACE,sBAAA;AjBkyDJ;AiB/xDE;EACE,mBAAA;AjBiyDJ;;AiBvxDE;EACE,oDAAA;EACA,8CAAA;AjB0xDJ;;AiBpxDE;EACE,oDAAA;EACA,8CAAA;AjBuxDJ;;AiB/wDA;EACE,oDAAA;EACA,8CAAA;AjBkxDF;;AiB1wDE;EACE,mDAAA;EACA,6CAAA;AjB6wDJ;;AkBz5DE;EAOE,sBAAA;EACA,kEAAA;EACA,4EAAA;EACA,yEAAA;EACA,8BAAA;EACA,yEAAA;EACA,6BAAA;EACA,wEAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlBq5DJ;;AkBv6DE;EAOE,sBAAA;EACA,kEAAA;EACA,4EAAA;EACA,0EAAA;EACA,8BAAA;EACA,yEAAA;EACA,6BAAA;EACA,uEAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlBm6DJ;;AkBr7DE;EAOE,sBAAA;EACA,kEAAA;EACA,2EAAA;EACA,yEAAA;EACA,8BAAA;EACA,yEAAA;EACA,6BAAA;EACA,wEAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlBi7DJ;;AkBn8DE;EAOE,sBAAA;EACA,kEAAA;EACA,4EAAA;EACA,yEAAA;EACA,8BAAA;EACA,yEAAA;EACA,6BAAA;EACA,wEAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlB+7DJ;;AkBj9DE;EAOE,sBAAA;EACA,uDAAA;EACA,iEAAA;EACA,+DAAA;EACA,8BAAA;EACA,8DAAA;EACA,6BAAA;EACA,+DAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlB68DJ;;AkB/9DE;EAOE,sBAAA;EACA,kEAAA;EACA,4EAAA;EACA,0EAAA;EACA,8BAAA;EACA,yEAAA;EACA,6BAAA;EACA,wEAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlB29DJ;;AkB7+DE;EAOE,sBAAA;EACA,sBAAA;EACA,2EAAA;EACA,yEAAA;EACA,8BAAA;EACA,yEAAA;EACA,6BAAA;EACA,wEAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlBy+DJ;;AkB3/DE;EAOE,sBAAA;EACA,sBAAA;EACA,2EAAA;EACA,0EAAA;EACA,8BAAA;EACA,yEAAA;EACA,6BAAA;EACA,wEAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlBu/DJ;;AiBt2DI;EACE,gBAAA;EACA,iCAAA;AjBy2DN;;Acp8DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjB+2DJ;AACF;Ac38DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjBq3DJ;AACF;Acj9DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjB23DJ;AACF;Acv9DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjBi4DJ;AACF;Ac79DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjBu4DJ;AACF;AmB3iEA;EACE,qBbu2BsC;ANssCxC;;AmBpiEA;EACE,oDAAA;EACA,uDAAA;EACA,gBAAA;EhB8QI,kBALI;EgBrQR,gBb+lB4B;ANs8C9B;;AmBjiEA;EACE,kDAAA;EACA,qDAAA;EhBoQI,kBALI;AHsyDV;;AmBjiEA;EACE,mDAAA;EACA,sDAAA;EhB8PI,mBALI;AH4yDV;;AoBlkEA;EACE,mBd+1BsC;EHrkBlC,kBALI;EiBjRR,gCd+1BsC;ANouCxC;;AqBxkEA;EACE,cAAA;EACA,WAAA;EACA,yBAAA;ElBwRI,eALI;EkBhRR,gBfkmB4B;EejmB5B,gBfymB4B;EexmB5B,2Bf43BsC;Ee33BtC,gBAAA;EACA,mCfq3BsC;Eep3BtC,4BAAA;EACA,2DAAA;EdGE,sCAAA;EeHE,wEDMJ;ArBskEF;AsBxkEM;EDhBN;ICiBQ,gBAAA;EtB2kEN;AACF;AqBzkEE;EACE,gBAAA;ArB2kEJ;AqBzkEI;EACE,eAAA;ArB2kEN;AqBtkEE;EACE,2Bfs2BoC;Eer2BpC,mCfg2BoC;Ee/1BpC,gEf82BoC;Ee72BpC,UAAA;EAKE,kDfkhBkB;ANkjDxB;AqBhkEE;EAME,eAAA;EAMA,aAAA;EAKA,SAAA;ArBojEJ;AqB/iEE;EACE,cAAA;EACA,UAAA;ArBijEJ;AqB7iEE;EACE,gCf40BoC;Ee10BpC,UAAA;ArB8iEJ;AqBtiEE;EAEE,wCf8yBoC;Ee3yBpC,UAAA;ArBqiEJ;AqBjiEE;EACE,yBAAA;EACA,0BAAA;EACA,0BforB0B;EenrB1B,2BfsyBoC;EiBp4BtC,uCjBqiCgC;Eer8B9B,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,+CfgsB0B;Ee/rB1B,gBAAA;ECzFE,qID0FF;ArBmiEJ;AsBznEM;ED0EJ;ICzEM,gBAAA;EtB4nEN;AACF;AqBriEE;EACE,wCf47B8B;AN2mClC;;AqB9hEA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBfwf4B;Eevf5B,2Bf2xBsC;Ee1xBtC,6BAAA;EACA,yBAAA;EACA,sCAAA;ArBiiEF;AqB/hEE;EACE,UAAA;ArBiiEJ;AqB9hEE;EAEE,gBAAA;EACA,eAAA;ArB+hEJ;;AqBphEA;EACE,mEf4wBsC;Ee3wBtC,uBAAA;ElByII,mBALI;EIvQN,yCAAA;AP4pEJ;AqBrhEE;EACE,uBAAA;EACA,wBAAA;EACA,yBfooB0B;ANm5C9B;;AqBnhEA;EACE,iEfgwBsC;Ee/vBtC,oBAAA;ElB4HI,kBALI;EIvQN,yCAAA;APwqEJ;AqBphEE;EACE,oBAAA;EACA,qBAAA;EACA,uBf2nB0B;AN25C9B;;AqB9gEE;EACE,oEf6uBoC;ANoyCxC;AqB9gEE;EACE,mEf0uBoC;ANsyCxC;AqB7gEE;EACE,iEfuuBoC;ANwyCxC;;AqB1gEA;EACE,WfquBsC;EepuBtC,gEf8tBsC;Ee7tBtC,iBfilB4B;AN47C9B;AqB3gEE;EACE,eAAA;ArB6gEJ;AqB1gEE;EACE,oBAAA;EdvLA,sCAAA;APosEJ;AqBzgEE;EACE,oBAAA;Ed5LA,sCAAA;APwsEJ;AqBxgEE;EAAoB,+Df8sBkB;AN6zCxC;AqB1gEE;EAAoB,6Df8sBkB;AN+zCxC;;AwB5tEA;EACE,gEAAA;EAEA,cAAA;EACA,WAAA;EACA,0CAAA;ErBqRI,eALI;EqB7QR,gBlB+lB4B;EkB9lB5B,gBlBsmB4B;EkBrmB5B,2BlBy3BsC;EkBx3BtC,gBAAA;EACA,mClBk3BsC;EkBj3BtC,mFAAA;EACA,4BAAA;EACA,yClB+9BkC;EkB99BlC,0BlB+9BkC;EkB99BlC,2DAAA;EjBHE,sCAAA;EeHE,wEESJ;AxB4tEF;AsBjuEM;EEfN;IFgBQ,gBAAA;EtBouEN;AACF;AwB/tEE;EACE,gElBs3BoC;EkBr3BpC,UAAA;EAKE,kDlBi+B4B;AN4vClC;AwBztEE;EAEE,sBlB6uB0B;EkB5uB1B,sBAAA;AxB0tEJ;AwBvtEE;EAEE,wClBu1BoC;ANi4CxC;AwBntEE;EACE,kBAAA;EACA,uCAAA;AxBqtEJ;;AwBjtEA;EACE,oBlBsuB4B;EkBruB5B,uBlBquB4B;EkBpuB5B,oBlBquB4B;EHlgBxB,mBALI;EIvQN,yCAAA;AP+vEJ;;AwBjtEA;EACE,mBlBkuB4B;EkBjuB5B,sBlBiuB4B;EkBhuB5B,kBlBiuB4B;EHtgBxB,kBALI;EIvQN,yCAAA;APuwEJ;;AwB/sEI;EACE,gEAAA;AxBktEN;;AyB1xEA;EACE,cAAA;EACA,kBnBq6BwC;EmBp6BxC,mBnBq6BwC;EmBp6BxC,uBnBq6BwC;ANw3C1C;AyB3xEE;EACE,WAAA;EACA,mBAAA;AzB6xEJ;;AyBzxEA;EACE,oBnB25BwC;EmB15BxC,eAAA;EACA,iBAAA;AzB4xEF;AyB1xEE;EACE,YAAA;EACA,oBAAA;EACA,cAAA;AzB4xEJ;;AyBxxEA;EACE,qCAAA;EAEA,cAAA;EACA,UnB04BwC;EmBz4BxC,WnBy4BwC;EmBx4BxC,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,+CAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,2DnB24BwC;EmB14BxC,yBAAA;AzB0xEF;AyBvxEE;ElB3BE,qBAAA;APqzEJ;AyBtxEE;EAEE,kBnBm4BsC;ANo5C1C;AyBpxEE;EACE,uBnB03BsC;AN45C1C;AyBnxEE;EACE,gEnBs1BoC;EmBr1BpC,UAAA;EACA,kDnB8foB;ANuxDxB;AyBlxEE;EACE,yBnB5BM;EmB6BN,qBnB7BM;ANizEV;AyBlxEI;EAII,iEAAA;AzBixER;AyB7wEI;EAII,iEAAA;AzB4wER;AyBvwEE;EACE,yBnBjDM;EmBkDN,qBnBlDM;EmBuDJ,iEAAA;AzBqwEN;AyBjwEE;EACE,oBAAA;EACA,YAAA;EACA,YnBk2BuC;ANi6C3C;AyB5vEI;EACE,eAAA;EACA,YnBy1BqC;ANq6C3C;;AyBhvEA;EACE,mBnBo1BgC;AN+5ClC;AyBjvEE;EACE,4DAAA;EAEA,UnB80B8B;EmB70B9B,mBAAA;EACA,0CAAA;EACA,gCAAA;ElBjHA,kBAAA;EeHE,iDGsHF;AzBkvEJ;AsBp2EM;EG0GJ;IHzGM,gBAAA;EtBu2EN;AACF;AyBrvEI;EACE,0MAAA;AzBuvEN;AyBpvEI;EACE,iCnB60B4B;EmBx0B1B,4DAAA;AzBkvER;AyB7uEE;EACE,oBnBwzB8B;EmBvzB9B,eAAA;AzB+uEJ;AyB7uEI;EACE,oBAAA;EACA,cAAA;AzB+uEN;;AyB1uEA;EACE,qBAAA;EACA,kBnBsyBgC;ANu8ClC;;AyB1uEA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;AzB6uEF;AyBzuEI;EACE,oBAAA;EACA,YAAA;EACA,anBspBwB;ANqlD9B;;AyBpuEI;EACE,4DAAA;AzBuuEN;;A0B15EA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;A1B65EF;A0B35EE;EACE,UAAA;A1B65EJ;A0Bz5EI;EAA0B,kEpB8gCa;AN84C3C;A0B35EI;EAA0B,kEpB6gCa;ANi5C3C;A0B35EE;EACE,SAAA;A1B65EJ;A0B15EE;EACE,WpB+/BuC;EoB9/BvC,YpB8/BuC;EoB7/BvC,oBAAA;EACA,gBAAA;EH1BF,yBjBkCQ;EoBNN,SpB6/BuC;EC1gCvC,mBAAA;EeHE,oHImBF;EJnBE,4GImBF;A1B25EJ;AsB16EM;EIMJ;IJLM,wBAAA;IAAA,gBAAA;EtB66EN;AACF;A0B95EI;EHjCF,qEjB8hCyC;ANo6C3C;A0B55EE;EACE,WpBw+B8B;EoBv+B9B,cpBw+B8B;EoBv+B9B,kBAAA;EACA,epBu+B8B;EoBt+B9B,wCpBu+B8B;EoBt+B9B,yBAAA;EnB7BA,mBAAA;AP47EJ;A0B15EE;EACE,WpBo+BuC;EoBn+BvC,YpBm+BuC;EoBl+BvC,gBAAA;EHpDF,yBjBkCQ;EoBoBN,SpBm+BuC;EC1gCvC,mBAAA;EeHE,iHI6CF;EJ7CE,4GI6CF;A1B25EJ;AsBp8EM;EIiCJ;IJhCM,qBAAA;IAAA,gBAAA;EtBu8EN;AACF;A0B95EI;EH3DF,qEjB8hCyC;AN87C3C;A0B55EE;EACE,WpB88B8B;EoB78B9B,cpB88B8B;EoB78B9B,kBAAA;EACA,epB68B8B;EoB58B9B,wCpB68B8B;EoB58B9B,yBAAA;EnBvDA,mBAAA;APs9EJ;A0B15EE;EACE,oBAAA;A1B45EJ;A0B15EI;EACE,2CpBg9BqC;AN48C3C;A0Bz5EI;EACE,2CpB48BqC;AN+8C3C;;A2Bl/EA;EACE,kBAAA;A3Bq/EF;A2Bn/EE;;;EAGE,uDrBwiCoC;EqBviCpC,2DrBuiCoC;EqBtiCpC,iBrBuiCoC;AN88CxC;A2Bl/EE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,2CAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gDAAA;EACA,qBAAA;ELVE,gEKWF;A3Bo/EJ;AsB3/EM;EKTJ;ILUM,gBAAA;EtB8/EN;AACF;A2Bt/EE;;EAEE,qBAAA;A3Bw/EJ;A2Bt/EI;;EACE,kBAAA;A3By/EN;A2Bt/EI;;;EAEE,qBrB0gCkC;EqBzgClC,wBrB0gCkC;AN++CxC;A2Bt/EI;;EACE,qBrBqgCkC;EqBpgClC,wBrBqgCkC;ANo/CxC;A2Br/EE;EACE,qBrB+/BoC;EqB9/BpC,wBrB+/BoC;EqB9/BpC,qBrBguB0B;ANuxD9B;A2Bh/EI;;;;EACE,8DrBy/BkC;AN4/CxC;A2Bh/EI;EACE,8DrBm/BkC;AN+/CxC;A2B7+EI;;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,arBw+BkC;EqBv+BlC,WAAA;EACA,mCrBqzBkC;ECh3BpC,sCAAA;AP4iFJ;A2B7+EE;EACE,wCrBkzBoC;AN6rDxC;A2B3+EI;EACE,sCAAA;A3B6+EN;A2Bz+EE;;EAEE,crBhFO;AN2jFX;;A4BrkFA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A5BwkFF;A4BtkFE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A5BwkFJ;A4BpkFE;;;EAGE,UAAA;A5BskFJ;A4BhkFE;EACE,kBAAA;EACA,UAAA;A5BkkFJ;A4BhkFI;EACE,UAAA;A5BkkFN;;A4BvjFA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EzB8OI,eALI;EyBvOR,gBtByjB4B;EsBxjB5B,gBtBgkB4B;EsB/jB5B,2BtBm1BsC;EsBl1BtC,kBAAA;EACA,mBAAA;EACA,uCtB06BsC;EsBz6BtC,2DAAA;ErBtCE,sCAAA;APimFJ;;A4BjjFA;;;;EAIE,oBAAA;EzBwNI,kBALI;EIvQN,yCAAA;AP0mFJ;;A4BjjFA;;;;EAIE,uBAAA;EzB+MI,mBALI;EIvQN,yCAAA;APmnFJ;;A4BjjFA;;EAEE,mBAAA;A5BojFF;;A4BviFI;;;;ErBjEA,0BAAA;EACA,6BAAA;AP+mFJ;A4BtiFI;;;;ErB1EA,0BAAA;EACA,6BAAA;APsnFJ;A4BhiFE;EACE,8CAAA;ErB1EA,yBAAA;EACA,4BAAA;AP6mFJ;A4BhiFE;;ErB9EE,yBAAA;EACA,4BAAA;APknFJ;;A6B1oFE;EACE,aAAA;EACA,WAAA;EACA,mBvBu0BoC;EHrkBlC,kBALI;E0B1PN,iCvBkjCqB;AN0lDzB;;A6BzoFE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E1BqPE,mBALI;E0B7ON,WvBqiCqB;EuBpiCrB,mCvBoiCqB;EC/jCrB,sCAAA;APuqFJ;;A6BvoFI;;;;EAEE,cAAA;A7B4oFN;;A6B3rFI;EAqDE,+CvBuhCmB;EuBphCjB,oCvB81BgC;EuB71BhC,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A7BwoFR;A6BroFM;EACE,+CvB4gCiB;EuBvgCf,2DvBugCe;AN4nDzB;;A6BxsFI;EA+EI,oCvBu0BgC;EuBt0BhC,kFAAA;A7B6nFR;;A6B7sFI;EAuFE,+CvBq/BmB;ANqoDzB;A6BvnFQ;EAEE,iEAAA;EACA,uBvBq5B8B;EuBp5B9B,+DAAA;EACA,2EAAA;A7BwnFV;A6BpnFM;EACE,+CvBw+BiB;EuBn+Bf,2DvBm+Be;AN+oDzB;;A6B3tFI;EAkHI,yCAAA;A7B6mFR;;A6B/tFI;EAyHE,+CvBm9BmB;ANupDzB;A6BxmFM;EACE,4CvBg9BiB;AN0pDzB;A6BvmFM;EACE,2DvB48BiB;AN6pDzB;A6BtmFM;EACE,iCvBw8BiB;ANgqDzB;;A6BnmFI;EACE,kBAAA;A7BsmFN;;A6BhvFI;;;;;EAoJM,UAAA;A7BomFV;;A6BpuFE;EACE,aAAA;EACA,WAAA;EACA,mBvBu0BoC;EHrkBlC,kBALI;E0B1PN,mCvBkjCqB;ANorDzB;;A6BnuFE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E1BqPE,mBALI;E0B7ON,WvBqiCqB;EuBpiCrB,kCvBoiCqB;EC/jCrB,sCAAA;APiwFJ;;A6BjuFI;;;;EAEE,cAAA;A7BsuFN;;A6BrxFI;EAqDE,iDvBuhCmB;EuBphCjB,oCvB81BgC;EuB71BhC,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A7BkuFR;A6B/tFM;EACE,iDvB4gCiB;EuBvgCf,0DvBugCe;ANstDzB;;A6BlyFI;EA+EI,oCvBu0BgC;EuBt0BhC,kFAAA;A7ButFR;;A6BvyFI;EAuFE,iDvBq/BmB;AN+tDzB;A6BjtFQ;EAEE,iEAAA;EACA,uBvBq5B8B;EuBp5B9B,+DAAA;EACA,2EAAA;A7BktFV;A6B9sFM;EACE,iDvBw+BiB;EuBn+Bf,0DvBm+Be;ANyuDzB;;A6BrzFI;EAkHI,yCAAA;A7BusFR;;A6BzzFI;EAyHE,iDvBm9BmB;ANivDzB;A6BlsFM;EACE,8CvBg9BiB;ANovDzB;A6BjsFM;EACE,0DvB48BiB;ANuvDzB;A6BhsFM;EACE,mCvBw8BiB;AN0vDzB;;A6B7rFI;EACE,kBAAA;A7BgsFN;;A6B10FI;;;;;EAsJM,UAAA;A7B4rFV;;A8Bp1FA;EAEE,2BAAA;EACA,4BAAA;EACA,sBAAA;E3BuRI,wBALI;E2BhRR,yBAAA;EACA,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,6CAAA;EACA,kCAAA;EACA,+CAAA;EACA,wCAAA;EACA,4FAAA;EACA,+BAAA;EACA,iFAAA;EAGA,qBAAA;EACA,wDAAA;EACA,sCAAA;E3BsQI,kCALI;E2B/PR,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mEAAA;EvBjBE,0CAAA;EgBfF,kCOkCqB;ERtBjB,qIQwBJ;A9Bk1FF;AsBt2FM;EQhBN;IRiBQ,gBAAA;EtBy2FN;AACF;A8Br1FE;EACE,gCAAA;EAEA,wCAAA;EACA,8CAAA;A9Bs1FJ;A8Bn1FE;EAEE,0BAAA;EACA,kCAAA;EACA,wCAAA;A9Bo1FJ;A8Bj1FE;EACE,gCAAA;EPrDF,wCOsDuB;EACrB,8CAAA;EACA,UAAA;EAKE,0CAAA;A9B+0FN;A8B30FE;EACE,8CAAA;EACA,UAAA;EAKE,0CAAA;A9By0FN;A8Br0FE;EAKE,iCAAA;EACA,yCAAA;EAGA,+CAAA;A9Bi0FJ;A8B9zFI;EAKI,0CAAA;A9B4zFR;A8BvzFE;EAKI,0CAAA;A9BqzFN;A8BjzFE;EAGE,mCAAA;EACA,oBAAA;EACA,2CAAA;EAEA,iDAAA;EACA,uCAAA;A9BgzFJ;;A8BpyFE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,qEAAA;EACA,+EAAA;EACA,uCAAA;EACA,2BAAA;EACA,sEAAA;EACA,gFAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/Bu5FF;;A8BrzFE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,gDAAA;EACA,gFAAA;EACA,wCAAA;EACA,2BAAA;EACA,uEAAA;EACA,iFAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/Bw6FF;;A8Bt0FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,+CAAA;EACA,+EAAA;EACA,uCAAA;EACA,2BAAA;EACA,sEAAA;EACA,gFAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/By7FF;;A8Bv1FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2DAAA;EACA,gFAAA;EACA,uCAAA;EACA,2BAAA;EACA,uEAAA;EACA,iFAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B08FF;;A8Bx2FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4DAAA;EACA,sEAAA;EACA,sCAAA;EACA,2BAAA;EACA,6DAAA;EACA,uEAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B29FF;;A8Bz3FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2DAAA;EACA,gFAAA;EACA,sCAAA;EACA,2BAAA;EACA,uEAAA;EACA,iFAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B4+FF;;A8B14FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2DAAA;EACA,+EAAA;EACA,wCAAA;EACA,2BAAA;EACA,sEAAA;EACA,iFAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B6/FF;;A8B35FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2DAAA;EACA,gFAAA;EACA,qCAAA;EACA,2BAAA;EACA,sEAAA;EACA,iFAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B8gGF;;A8Bl5FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/BsgGF;;A8Bn6FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/BuhGF;;A8Bp7FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/BwiGF;;A8Br8FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/ByjGF;;A8Bt9FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/B0kGF;;A8Bv+FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/B2lGF;;A8Bx/FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/B4mGF;;A8BzgGE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/B6nGF;;A8B9gGA;EACE,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,kCAAA;EACA,gDAAA;EACA,wCAAA;EACA,iDAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,+BAAA;EACA,uCAAA;EAEA,0BxB8QwC;ANkwF1C;A8BtgGE;EACE,0BAAA;A9BwgGJ;A8BrgGE;EACE,gCAAA;A9BugGJ;;A8B5/FA;ECjJE,0BAAA;EACA,wBAAA;E5B8NI,2BALI;E4BvNR,kDAAA;A/BipGF;;A8B//FA;ECrJE,2BAAA;EACA,0BAAA;E5B8NI,4BALI;E4BvNR,kDAAA;A/BwpGF;;AgC3tGA;EVgBM,gCUfJ;AhC8tGF;AsB3sGM;EUpBN;IVqBQ,gBAAA;EtB8sGN;AACF;AgCjuGE;EACE,UAAA;AhCmuGJ;;AgC7tGE;EACE,aAAA;AhCguGJ;;AgC5tGA;EACE,SAAA;EACA,gBAAA;EVDI,6BUEJ;AhC+tGF;AsB7tGM;EULN;IVMQ,gBAAA;EtBguGN;AACF;AgCluGE;EACE,QAAA;EACA,YAAA;EVNE,4BUOF;AhCouGJ;AsBvuGM;EUAJ;IVCM,gBAAA;EtB0uGN;AACF;;AiC/vGA;;;;;;EAME,kBAAA;AjCkwGF;;AiC/vGA;EACE,mBAAA;AjCkwGF;AkC1uGI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EArCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;AlCkxGF;AkCxtGI;EACE,cAAA;AlC0tGN;;AiCxwGA;EAEE,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;E9BuQI,6BALI;E8BhQR,yCAAA;EACA,mCAAA;EACA,8DAAA;EACA,oDAAA;EACA,kDAAA;EACA,yFAAA;EACA,4DAAA;EACA,sCAAA;EACA,8CAAA;EACA,8CAAA;EACA,oDAAA;EACA,kDAAA;EACA,qCAAA;EACA,qCAAA;EACA,2DAAA;EACA,kCAAA;EACA,qCAAA;EACA,mCAAA;EACA,oCAAA;EACA,sCAAA;EAGA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;E9B0OI,uCALI;E8BnOR,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;E1BzCE,+CAAA;APkzGJ;AiCrwGE;EACE,SAAA;EACA,OAAA;EACA,qCAAA;AjCuwGJ;;AiC/uGI;EACE,oBAAA;AjCkvGN;AiChvGM;EACE,WAAA;EACA,OAAA;AjCkvGR;;AiC9uGI;EACE,kBAAA;AjCivGN;AiC/uGM;EACE,QAAA;EACA,UAAA;AjCivGR;;Ac3xGI;EmB4BA;IACE,oBAAA;EjCmwGJ;EiCjwGI;IACE,WAAA;IACA,OAAA;EjCmwGN;EiC/vGE;IACE,kBAAA;EjCiwGJ;EiC/vGI;IACE,QAAA;IACA,UAAA;EjCiwGN;AACF;Ac5yGI;EmB4BA;IACE,oBAAA;EjCmxGJ;EiCjxGI;IACE,WAAA;IACA,OAAA;EjCmxGN;EiC/wGE;IACE,kBAAA;EjCixGJ;EiC/wGI;IACE,QAAA;IACA,UAAA;EjCixGN;AACF;Ac5zGI;EmB4BA;IACE,oBAAA;EjCmyGJ;EiCjyGI;IACE,WAAA;IACA,OAAA;EjCmyGN;EiC/xGE;IACE,kBAAA;EjCiyGJ;EiC/xGI;IACE,QAAA;IACA,UAAA;EjCiyGN;AACF;Ac50GI;EmB4BA;IACE,oBAAA;EjCmzGJ;EiCjzGI;IACE,WAAA;IACA,OAAA;EjCmzGN;EiC/yGE;IACE,kBAAA;EjCizGJ;EiC/yGI;IACE,QAAA;IACA,UAAA;EjCizGN;AACF;Ac51GI;EmB4BA;IACE,oBAAA;EjCm0GJ;EiCj0GI;IACE,WAAA;IACA,OAAA;EjCm0GN;EiC/zGE;IACE,kBAAA;EjCi0GJ;EiC/zGI;IACE,QAAA;IACA,UAAA;EjCi0GN;AACF;AiCxzGE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;AjC0zGJ;AkC94GI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EA9BJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;AlC+6GF;AkC53GI;EACE,cAAA;AlC83GN;;AiC9zGE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;AjCi0GJ;AkCn6GI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EAvBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;AlC67GF;AkCj5GI;EACE,cAAA;AlCm5GN;AiCz0GI;EACE,iBAAA;AjC20GN;;AiCr0GE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;AjCw0GJ;AkC37GI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;AlC67GN;AkCl7GM;EACE,aAAA;AlCo7GR;AkCj7GM;EACE,qBAAA;EACA,qB5B0gBsB;E4BzgBtB,uB5BwgBsB;E4BvgBtB,WAAA;EAnCN,mCAAA;EACA,yBAAA;EACA,sCAAA;AlCu9GF;AkCj7GI;EACE,cAAA;AlCm7GN;AiCx1GI;EACE,iBAAA;AjC01GN;;AiCn1GA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;AjCs1GF;;AiCh1GA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gB3Byb4B;E2Bxb5B,oCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;E1BtKE,uDAAA;AP0/GJ;AiCj1GE;EAEE,0CAAA;EV1LF,kDU4LuB;AjCi1GzB;AiC90GE;EAEE,2CAAA;EACA,qBAAA;EVlMF,mDUmMuB;AjC+0GzB;AiC50GE;EAEE,6CAAA;EACA,oBAAA;EACA,6BAAA;AjC60GJ;;AiCv0GA;EACE,cAAA;AjC00GF;;AiCt0GA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;E9BmEI,mBALI;E8B5DR,sCAAA;EACA,mBAAA;AjCy0GF;;AiCr0GA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;AjCw0GF;;AiCp0GA;EAEE,4BAAA;EACA,yBAAA;EACA,8DAAA;EACA,0BAAA;EACA,iCAAA;EACA,oCAAA;EACA,4DAAA;EACA,sDAAA;EACA,qCAAA;EACA,qCAAA;EACA,0CAAA;EACA,mCAAA;AjCs0GF;;AmC5jHA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;AnC+jHF;AmC7jHE;;EACE,kBAAA;EACA,cAAA;AnCgkHJ;AmC3jHE;;;;;;;;;;;;EAME,UAAA;AnCmkHJ;;AmC9jHA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;AnCikHF;AmC/jHE;EACE,WAAA;AnCikHJ;;AmC7jHA;E5BhBI,sCAAA;APilHJ;AmC7jHE;;EAEE,8CAAA;AnC+jHJ;AmC3jHE;;;E5BVE,0BAAA;EACA,6BAAA;AP0kHJ;AmCvjHE;;;E5BNE,yBAAA;EACA,4BAAA;APkkHJ;;AmC1iHA;EACE,wBAAA;EACA,uBAAA;AnC6iHF;AmC3iHE;EAGE,cAAA;AnC2iHJ;AmCxiHE;EACE,eAAA;AnC0iHJ;;AmCtiHA;EACE,uBAAA;EACA,sBAAA;AnCyiHF;;AmCtiHA;EACE,sBAAA;EACA,qBAAA;AnCyiHF;;AmCrhHA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AnCwhHF;AmCthHE;;EAEE,WAAA;AnCwhHJ;AmCrhHE;;EAEE,6CAAA;AnCuhHJ;AmCnhHE;;E5B1FE,6BAAA;EACA,4BAAA;APinHJ;AmC/gHE;;;E5BjHE,yBAAA;EACA,0BAAA;APqoHJ;;AoC7pHA;EAEE,6BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,uDAAA;EAGA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ApC4pHF;;AoCzpHA;EACE,cAAA;EACA,kEAAA;EjCsQI,uCALI;EiC/PR,2CAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBAAA;EACA,SAAA;EdfI,uGcgBJ;ApC4pHF;AsBxqHM;EcGN;IdFQ,gBAAA;EtB2qHN;AACF;AoC/pHE;EAEE,qCAAA;ApCgqHJ;AoC5pHE;EACE,UAAA;EACA,kD9BkhBoB;AN4oGxB;AoC1pHE;EAEE,wCAAA;EACA,oBAAA;EACA,eAAA;ApC2pHJ;;AoCnpHA;EAEE,kDAAA;EACA,kDAAA;EACA,oDAAA;EACA,2GAAA;EACA,yDAAA;EACA,+CAAA;EACA,uGAAA;EAGA,oFAAA;ApCmpHF;AoCjpHE;EACE,yDAAA;EACA,yDAAA;E7B7CA,wDAAA;EACA,yDAAA;APisHJ;AoClpHI;EAGE,kBAAA;EACA,wDAAA;ApCkpHN;AoC9oHE;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;ApCgpHJ;AoC7oHE;EAEE,sDAAA;E7BjEA,yBAAA;EACA,0BAAA;APgtHJ;;AoCroHA;EAEE,qDAAA;EACA,sCAAA;EACA,sCAAA;ApCuoHF;AoCpoHE;E7B5FE,gDAAA;APmuHJ;AoCnoHE;;EAEE,4CAAA;EbjHF,oDakHuB;ApCqoHzB;;AoC5nHA;EAEE,4BAAA;EACA,yCAAA;EACA,8DAAA;EAGA,gCAAA;ApC4nHF;AoC1nHE;EACE,gBAAA;EACA,eAAA;EACA,qEAAA;ApC4nHJ;AoC1nHI;EAEE,iCAAA;ApC2nHN;AoCvnHE;;EAEE,gB9B0d0B;E8Bzd1B,gDAAA;EACA,iCAAA;ApCynHJ;;AoC/mHE;;EAEE,cAAA;EACA,kBAAA;ApCknHJ;;AoC7mHE;;EAEE,YAAA;EACA,aAAA;EACA,kBAAA;ApCgnHJ;;AoC1mHE;;EACE,WAAA;ApC8mHJ;;AoCpmHE;EACE,aAAA;ApCumHJ;AoCrmHE;EACE,cAAA;ApCumHJ;;AqCpyHA;EAEE,wBAAA;EACA,6BAAA;EACA,2DAAA;EACA,gEAAA;EACA,mEAAA;EACA,+DAAA;EACA,sCAAA;EACA,kCAAA;EACA,oCAAA;EACA,8DAAA;EACA,oEAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,qEAAA;EACA,0EAAA;EACA,0DAAA;EACA,wCAAA;EACA,4DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;ArCoyHF;AqC9xHE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;ArCsyHJ;AqClxHA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;ElC4NI,2CALI;EkCrNR,mCAAA;EACA,qBAAA;EACA,mBAAA;ArCoxHF;AqClxHE;EAEE,yCAAA;ArCmxHJ;;AqCzwHA;EAEE,0BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EAGA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ArCwwHF;AqCrwHI;EAEE,oCAAA;ArCswHN;AqClwHE;EACE,gBAAA;ArCowHJ;;AqC3vHA;EACE,mB/B8gCkC;E+B7gClC,sB/B6gCkC;E+B5gClC,6BAAA;ArC8vHF;AqC5vHE;;;EAGE,oCAAA;ArC8vHJ;;AqCjvHA;EACE,YAAA;EACA,gBAAA;EAGA,mBAAA;ArCkvHF;;AqC9uHA;EACE,8EAAA;ElCyII,6CALI;EkClIR,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,0EAAA;E9BxIE,qDAAA;EeHE,+Ce6IJ;ArCivHF;AsB13HM;EeiIN;IfhIQ,gBAAA;EtB63HN;AACF;AqCpvHE;EACE,qBAAA;ArCsvHJ;AqCnvHE;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;ArCqvHJ;;AqC/uHA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;ArCkvHF;;AqC/uHA;EACE,yCAAA;EACA,gBAAA;ArCkvHF;;Ac52HI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErCyuHN;EqCvuHM;IACE,mBAAA;ErCyuHR;EqCvuHQ;IACE,kBAAA;ErCyuHV;EqCtuHQ;IACE,kDAAA;IACA,iDAAA;ErCwuHV;EqCpuHM;IACE,iBAAA;ErCsuHR;EqCnuHM;IACE,wBAAA;IACA,gBAAA;ErCquHR;EqCluHM;IACE,aAAA;ErCouHR;EqCjuHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErCiuHR;EqC9tHQ;IACE,aAAA;ErCguHV;EqC7tHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErC+tHV;AACF;Ac55HI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErCwxHN;EqCtxHM;IACE,mBAAA;ErCwxHR;EqCtxHQ;IACE,kBAAA;ErCwxHV;EqCrxHQ;IACE,kDAAA;IACA,iDAAA;ErCuxHV;EqCnxHM;IACE,iBAAA;ErCqxHR;EqClxHM;IACE,wBAAA;IACA,gBAAA;ErCoxHR;EqCjxHM;IACE,aAAA;ErCmxHR;EqChxHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErCgxHR;EqC7wHQ;IACE,aAAA;ErC+wHV;EqC5wHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErC8wHV;AACF;Ac38HI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErCu0HN;EqCr0HM;IACE,mBAAA;ErCu0HR;EqCr0HQ;IACE,kBAAA;ErCu0HV;EqCp0HQ;IACE,kDAAA;IACA,iDAAA;ErCs0HV;EqCl0HM;IACE,iBAAA;ErCo0HR;EqCj0HM;IACE,wBAAA;IACA,gBAAA;ErCm0HR;EqCh0HM;IACE,aAAA;ErCk0HR;EqC/zHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErC+zHR;EqC5zHQ;IACE,aAAA;ErC8zHV;EqC3zHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErC6zHV;AACF;Ac1/HI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErCs3HN;EqCp3HM;IACE,mBAAA;ErCs3HR;EqCp3HQ;IACE,kBAAA;ErCs3HV;EqCn3HQ;IACE,kDAAA;IACA,iDAAA;ErCq3HV;EqCj3HM;IACE,iBAAA;ErCm3HR;EqCh3HM;IACE,wBAAA;IACA,gBAAA;ErCk3HR;EqC/2HM;IACE,aAAA;ErCi3HR;EqC92HM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErC82HR;EqC32HQ;IACE,aAAA;ErC62HV;EqC12HQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErC42HV;AACF;AcziII;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErCq6HN;EqCn6HM;IACE,mBAAA;ErCq6HR;EqCn6HQ;IACE,kBAAA;ErCq6HV;EqCl6HQ;IACE,kDAAA;IACA,iDAAA;ErCo6HV;EqCh6HM;IACE,iBAAA;ErCk6HR;EqC/5HM;IACE,wBAAA;IACA,gBAAA;ErCi6HR;EqC95HM;IACE,aAAA;ErCg6HR;EqC75HM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErC65HR;EqC15HQ;IACE,aAAA;ErC45HV;EqCz5HQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErC25HV;AACF;AqCl9HI;EAEI,iBAAA;EACA,2BAAA;ArCm9HR;AqCj9HQ;EACE,mBAAA;ArCm9HV;AqCj9HU;EACE,kBAAA;ArCm9HZ;AqCh9HU;EACE,kDAAA;EACA,iDAAA;ArCk9HZ;AqC98HQ;EACE,iBAAA;ArCg9HV;AqC78HQ;EACE,wBAAA;EACA,gBAAA;ArC+8HV;AqC58HQ;EACE,aAAA;ArC88HV;AqC38HQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;Ef9NJ,gBegOI;ArC28HV;AqCx8HU;EACE,aAAA;ArC08HZ;AqCv8HU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;ArCy8HZ;;AqCx7HA;;EAGE,4CAAA;EACA,kDAAA;EACA,qDAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,0DAAA;EACA,qEAAA;ArC07HF;;AqCp7HI;EACE,qEAAA;ArCu7HN;;AsChtIA;EAEE,wBAAA;EACA,wBAAA;EACA,gCAAA;EACA,uBAAA;EACA,0BAAA;EACA,8CAAA;EACA,0DAAA;EACA,gDAAA;EACA,sBAAA;EACA,uFAAA;EACA,+BAAA;EACA,6BAAA;EACA,sDAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,mCAAA;EACA,+BAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,2BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;E/BjBE,2CAAA;APkuIJ;AsC7sIE;EACE,eAAA;EACA,cAAA;AtC+sIJ;AsC5sIE;EACE,mBAAA;EACA,sBAAA;AtC8sIJ;AsC5sII;EACE,mBAAA;E/BtBF,0DAAA;EACA,2DAAA;APquIJ;AsC5sII;EACE,sBAAA;E/BbF,8DAAA;EACA,6DAAA;AP4tIJ;AsCzsIE;;EAEE,aAAA;AtC2sIJ;;AsCvsIA;EAGE,cAAA;EACA,wDAAA;EACA,2BAAA;AtCwsIF;;AsCrsIA;EACE,4CAAA;EACA,iCAAA;AtCwsIF;;AsCrsIA;EACE,sDAAA;EACA,gBAAA;EACA,oCAAA;AtCwsIF;;AsCrsIA;EACE,gBAAA;AtCwsIF;;AsChsIE;EACE,oCAAA;AtCmsIJ;;AsC3rIA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;AtC8rIF;AsC5rIE;E/B7FE,wFAAA;AP4xIJ;;AsC1rIA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;AtC6rIF;AsC3rIE;E/BxGE,wFAAA;APsyIJ;;AsCprIA;EACE,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;AtCurIF;AsCrrIE;EACE,mCAAA;EACA,sCAAA;AtCurIJ;;AsCnrIA;EACE,uDAAA;EACA,sDAAA;AtCsrIF;;AsClrIA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;E/B1IE,iDAAA;APg0IJ;;AsClrIA;;;EAGE,WAAA;AtCqrIF;;AsClrIA;;E/B3II,0DAAA;EACA,2DAAA;APk0IJ;;AsCnrIA;;E/BlII,8DAAA;EACA,6DAAA;AP0zIJ;;AsC5qIE;EACE,0CAAA;AtC+qIJ;Ac1yII;EwBuHJ;IAQI,aAAA;IACA,mBAAA;EtC+qIF;EsC5qIE;IACE,SAAA;IACA,gBAAA;EtC8qIJ;EsC5qII;IACE,cAAA;IACA,cAAA;EtC8qIN;EsCzqIM;I/B1KJ,0BAAA;IACA,6BAAA;EPs1IF;EsC1qIQ;;IAGE,0BAAA;EtC2qIV;EsCzqIQ;;IAGE,6BAAA;EtC0qIV;EsCtqIM;I/B3KJ,yBAAA;IACA,4BAAA;EPo1IF;EsCvqIQ;;IAGE,yBAAA;EtCwqIV;EsCtqIQ;;IAGE,4BAAA;EtCuqIV;AACF;;AuC34IA;EAEE,0CAAA;EACA,oCAAA;EACA,8KAAA;EACA,mDAAA;EACA,mDAAA;EACA,qDAAA;EACA,4FAAA;EACA,qCAAA;EACA,kCAAA;EACA,8CAAA;EACA,6CAAA;EACA,iEAAA;EACA,sCAAA;EACA,kDAAA;EACA,8DAAA;EACA,2RAAA;EACA,2EAAA;EACA,sCAAA;EACA,mCAAA;EACA,4DAAA;EACA,qDAAA;AvC64IF;;AuCz4IA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;EpC4PI,eALI;EoCrPR,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;EhCrBE,gBAAA;EgCuBF,qBAAA;EjB1BI,0CiB2BJ;AvC44IF;AsBn6IM;EiBUN;IjBTQ,gBAAA;EtBs6IN;AACF;AuC/4IE;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;AvCi5IJ;AuC/4II;EACE,qDAAA;EACA,iDAAA;AvCi5IN;AuC54IE;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EjBjDE,mDiBkDF;AvC84IJ;AsB57IM;EiBqCJ;IjBpCM,gBAAA;EtB+7IN;AACF;AuCh5IE;EACE,UAAA;AvCk5IJ;AuC/4IE;EACE,UAAA;EACA,UAAA;EACA,oDAAA;AvCi5IJ;;AuC74IA;EACE,gBAAA;AvCg5IF;;AuC74IA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;AvCg5IF;AuC94IE;EhC7DE,yDAAA;EACA,0DAAA;AP88IJ;AuC/4II;EhChEA,+DAAA;EACA,gEAAA;APk9IJ;AuC94IE;EACE,aAAA;AvCg5IJ;AuC54IE;EhC5DE,6DAAA;EACA,4DAAA;AP28IJ;AuC54IM;EhChEF,mEAAA;EACA,kEAAA;AP+8IJ;AuC34II;EhCrEA,6DAAA;EACA,4DAAA;APm9IJ;;AuCz4IA;EACE,8EAAA;AvC44IF;;AuCn4IE;EACE,eAAA;EACA,cAAA;EhC9GA,gBAAA;APq/IJ;AuCp4II;EAAgB,aAAA;AvCu4IpB;AuCt4II;EAAe,gBAAA;AvCy4InB;AuCt4II;;;EhCrHA,gBAAA;APggJJ;;AuCh4II;EACE,qVAAA;EACA,4VAAA;AvCm4IN;;AwCxhJA;EAEE,4BAAA;EACA,4BAAA;EACA,mCAAA;EAEA,oBAAA;EACA,+BAAA;EACA,wDAAA;EACA,sCAAA;EACA,4DAAA;EAGA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;ErC+QI,yCALI;EqCxQR,gBAAA;EACA,yCAAA;EjCAE,iDAAA;APwhJJ;;AwClhJE;EACE,iDAAA;AxCqhJJ;AwCnhJI;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,uFAAA;AxCqhJN;AwCjhJE;EACE,6CAAA;AxCmhJJ;;AyCxjJA;EAEE,kCAAA;EACA,mCAAA;EtC4RI,+BALI;EsCrRR,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,uDAAA;EACA,+CAAA;EACA,0DAAA;EACA,uDAAA;EACA,gDAAA;EACA,wEAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EACA,yDAAA;EACA,mDAAA;EACA,6DAAA;EAGA,aAAA;EhCpBA,eAAA;EACA,gBAAA;AT6kJF;;AyCtjJA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;EtCgQI,yCALI;EsCzPR,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;EnBpBI,qImBqBJ;AzCyjJF;AsB1kJM;EmBQN;InBPQ,gBAAA;EtB6kJN;AACF;AyC5jJE;EACE,UAAA;EACA,uCAAA;EAEA,+CAAA;EACA,qDAAA;AzC6jJJ;AyC1jJE;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UnC2uCgC;EmC1uChC,iDAAA;AzC4jJJ;AyCzjJE;EAEE,UAAA;EACA,wCAAA;ElBtDF,gDkBuDuB;EACrB,sDAAA;AzC0jJJ;AyCvjJE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;AzCwjJJ;;AyCnjJE;EACE,8CnC8sCgC;ANw2GpC;AyCjjJM;ElC9BF,0DAAA;EACA,6DAAA;APklJJ;AyC/iJM;ElClDF,2DAAA;EACA,8DAAA;APomJJ;;AyCliJA;EClGE,iCAAA;EACA,kCAAA;EvC0RI,kCALI;EuCnRR,yDAAA;A1CwoJF;;AyCriJA;ECtGE,iCAAA;EACA,kCAAA;EvC0RI,mCALI;EuCnRR,yDAAA;A1C+oJF;;A2CjpJA;EAEE,4BAAA;EACA,4BAAA;ExCuRI,4BALI;EwChRR,2BAAA;EACA,sBAAA;EACA,iDAAA;EAGA,qBAAA;EACA,4DAAA;ExC+QI,oCALI;EwCxQR,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EpCJE,4CAAA;APspJJ;A2C7oJE;EACE,aAAA;A3C+oJJ;;A2C1oJA;EACE,kBAAA;EACA,SAAA;A3C6oJF;;A4C7qJA;EAEE,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,4EAAA;EACA,iDAAA;EACA,8BAAA;EAGA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;ErCHE,4CAAA;APirJJ;;A4CzqJA;EAEE,cAAA;A5C2qJF;;A4CvqJA;EACE,gBtC6kB4B;EsC5kB5B,iCAAA;A5C0qJF;;A4ClqJA;EACE,mBtCs+C8B;AN+rGhC;A4ClqJE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;A5CoqJJ;;A4C5pJE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A5C+pJJ;;A4CnqJE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;A5CsqJJ;;A4C1qJE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A5C6qJJ;;A4CjrJE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A5CorJJ;;A4CxrJE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A5C2rJJ;;A4C/rJE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;A5CksJJ;;A4CtsJE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;A5CysJJ;;A4C7sJE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A5CgtJJ;;A6C5wJE;EACE;IAAK,gDAAA;E7CgxJP;AACF;A6C5wJA;;EAGE,0BAAA;E1CkRI,gCALI;E0C3QR,wCAAA;EACA,oDAAA;EACA,oDAAA;EACA,6BAAA;EACA,6BAAA;EACA,6CAAA;EAGA,aAAA;EACA,iCAAA;EACA,gBAAA;E1CsQI,uCALI;E0C/PR,uCAAA;EtCRE,+CAAA;APoxJJ;;A6CvwJA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EvBxBI,6CuByBJ;A7C0wJF;AsB/xJM;EuBYN;IvBXQ,gBAAA;EtBkyJN;AACF;;A6C5wJA;EtBAE,qMAAA;EsBEA,oEAAA;A7C+wJF;;A6C5wJA;EACE,iBAAA;A7C+wJF;;A6C5wJA;EACE,WAAA;A7C+wJF;;A6C3wJE;EACE,kDAAA;A7C8wJJ;A6C3wJM;EAJJ;IAKM,eAAA;E7C8wJN;AACF;;A8C10JA;EAEE,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,oCAAA;EACA,sCAAA;EACA,uDAAA;EACA,4DAAA;EACA,sDAAA;EACA,yDAAA;EACA,wDAAA;EACA,yDAAA;EACA,8CAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EAGA,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;EvCXE,iDAAA;APo1JJ;;A8Cr0JA;EACE,qBAAA;EACA,sBAAA;A9Cw0JF;A8Ct0JE;EAEE,oCAAA;EACA,0BAAA;A9Cu0JJ;;A8C/zJA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;A9Ck0JF;A8Ch0JE;EvC9BE,+BAAA;EACA,gCAAA;APi2JJ;A8Ch0JE;EvCpBE,mCAAA;EACA,kCAAA;APu1JJ;A8Ch0JE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;A9Ci0JJ;A8C7zJE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;A9C+zJJ;A8C3zJE;EACE,mBAAA;A9C6zJJ;A8C3zJI;EACE,wDAAA;EACA,mDAAA;A9C6zJN;;A8CnzJA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;A9CszJF;A8ClzJI;EAEE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;A9CmzJN;A8ChzJI;EACE,+CAAA;EACA,uDAAA;A9CkzJN;;A8CryJI;EACE,mBAAA;A9CwyJN;A8CryJQ;EvCzDJ,6DAAA;EAZA,0BAAA;AP82JJ;A8CpyJQ;EvC1EJ,2DAAA;EAYA,4BAAA;APs2JJ;A8CnyJQ;EACE,aAAA;A9CqyJV;A8ClyJQ;EACE,mDAAA;EACA,oBAAA;A9CoyJV;A8ClyJU;EACE,yDAAA;EACA,oDAAA;A9CoyJZ;;Ac53JI;EgCgEA;IACE,mBAAA;E9Cg0JJ;E8C7zJM;IvCzDJ,6DAAA;IAZA,0BAAA;EPs4JF;E8C5zJM;IvC1EJ,2DAAA;IAYA,4BAAA;EP83JF;E8C3zJM;IACE,aAAA;E9C6zJR;E8C1zJM;IACE,mDAAA;IACA,oBAAA;E9C4zJR;E8C1zJQ;IACE,yDAAA;IACA,oDAAA;E9C4zJV;AACF;Acr5JI;EgCgEA;IACE,mBAAA;E9Cw1JJ;E8Cr1JM;IvCzDJ,6DAAA;IAZA,0BAAA;EP85JF;E8Cp1JM;IvC1EJ,2DAAA;IAYA,4BAAA;EPs5JF;E8Cn1JM;IACE,aAAA;E9Cq1JR;E8Cl1JM;IACE,mDAAA;IACA,oBAAA;E9Co1JR;E8Cl1JQ;IACE,yDAAA;IACA,oDAAA;E9Co1JV;AACF;Ac76JI;EgCgEA;IACE,mBAAA;E9Cg3JJ;E8C72JM;IvCzDJ,6DAAA;IAZA,0BAAA;EPs7JF;E8C52JM;IvC1EJ,2DAAA;IAYA,4BAAA;EP86JF;E8C32JM;IACE,aAAA;E9C62JR;E8C12JM;IACE,mDAAA;IACA,oBAAA;E9C42JR;E8C12JQ;IACE,yDAAA;IACA,oDAAA;E9C42JV;AACF;Acr8JI;EgCgEA;IACE,mBAAA;E9Cw4JJ;E8Cr4JM;IvCzDJ,6DAAA;IAZA,0BAAA;EP88JF;E8Cp4JM;IvC1EJ,2DAAA;IAYA,4BAAA;EPs8JF;E8Cn4JM;IACE,aAAA;E9Cq4JR;E8Cl4JM;IACE,mDAAA;IACA,oBAAA;E9Co4JR;E8Cl4JQ;IACE,yDAAA;IACA,oDAAA;E9Co4JV;AACF;Ac79JI;EgCgEA;IACE,mBAAA;E9Cg6JJ;E8C75JM;IvCzDJ,6DAAA;IAZA,0BAAA;EPs+JF;E8C55JM;IvC1EJ,2DAAA;IAYA,4BAAA;EP89JF;E8C35JM;IACE,aAAA;E9C65JR;E8C15JM;IACE,mDAAA;IACA,oBAAA;E9C45JR;E8C15JQ;IACE,yDAAA;IACA,oDAAA;E9C45JV;AACF;A8C/4JA;EvClJI,gBAAA;APoiKJ;A8C/4JE;EACE,mDAAA;A9Ci5JJ;A8C/4JI;EACE,sBAAA;A9Ci5JN;;A8Cp4JE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A9Cu4JJ;;A8Cj5JE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;A9Co5JJ;;A8C95JE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A9Ci6JJ;;A8C36JE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;A9C86JJ;;A8Cx7JE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A9C27JJ;;A8Cr8JE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;A9Cw8JJ;;A8Cl9JE;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;A9Cq9JJ;;A8C/9JE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;A9Ck+JJ;;A+ChqKA;EAEE,0BAAA;EACA,2DAAA;EACA,2BAAA;EACA,kCAAA;EACA,mEAAA;EACA,+BAAA;EACA,qCAAA;EAGA,uBAAA;EACA,UzCupD2B;EyCtpD3B,WzCspD2B;EyCrpD3B,sBAAA;EACA,gCAAA;EACA,wEAAA;EACA,kCAAA;EACA,SAAA;ExCJE,uBAAA;EwCMF,oCAAA;A/CgqKF;A+C7pKE;EACE,gCAAA;EACA,qBAAA;EACA,0CAAA;A/C+pKJ;A+C5pKE;EACE,UAAA;EACA,4CAAA;EACA,0CAAA;A/C8pKJ;A+C3pKE;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6CAAA;A/C4pKJ;;A+CppKA;EAHE,iEAAA;A/C2pKF;;A+CppKA;;EAEE,uBAAA;A/CupKF;;AIlsKI;E2CkCF,iEAAA;A/CoqKF;;AgDrtKA;EAEE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;E7CyRI,8BALI;E6ClRR,kBAAA;EACA,gDAAA;EACA,+CAAA;EACA,2DAAA;EACA,iDAAA;EACA,2CAAA;EACA,kDAAA;EACA,uDAAA;EACA,kEAAA;EAGA,gCAAA;EACA,eAAA;E7C2QI,oCALI;E6CpQR,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;EzCRE,4CAAA;AP8tKJ;AgDntKE;EACE,UAAA;AhDqtKJ;AgDltKE;EACE,aAAA;AhDotKJ;;AgDhtKA;EACE,uBAAA;EAEA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AhDktKF;AgDhtKE;EACE,sCAAA;AhDktKJ;;AgD9sKA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;EzChCE,0FAAA;EACA,2FAAA;APkvKJ;AgDhtKE;EACE,oDAAA;EACA,sCAAA;AhDktKJ;;AgD9sKA;EACE,kCAAA;EACA,qBAAA;AhDitKF;;AiD/wKA;EAEE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,sCAAA;EACA,gCAAA;EACA,2DAAA;EACA,+CAAA;EACA,oDAAA;EACA,8CAAA;EACA,2FAAA;EACA,iCAAA;EACA,iCAAA;EACA,oCAAA;EACA,sDAAA;EACA,sDAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,sDAAA;EACA,sDAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;AjD6wKF;;AiDtwKA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;AjDwwKF;AiDrwKE;EACE,8B3Cm8CgC;EgBh/C9B,mC2B8CF;AjDuwKJ;AsBjzKM;E2BwCJ;I3BvCM,gBAAA;EtBozKN;AACF;AiD1wKE;EACE,e3Cg8CgC;AN40HpC;AiDxwKE;EACE,sB3C67CgC;AN60HpC;;AiDtwKA;EACE,+CAAA;AjDywKF;AiDvwKE;EACE,gBAAA;EACA,gBAAA;AjDywKJ;AiDtwKE;EACE,gBAAA;AjDwwKJ;;AiDpwKA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;AjDuwKF;;AiDnwKA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;E1CrFE,4CAAA;E0CyFF,UAAA;AjDmwKF;;AiD/vKA;EAEE,0BAAA;EACA,sBAAA;EACA,0BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,uCD+G4D;AjDqwK9D;AkDj3KE;EAAS,UAAA;AlDo3KX;AkDn3KE;EAAS,mCD2GiF;AjD2wK5F;;AiDtwKA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uCAAA;EACA,4FAAA;E1CrGE,2DAAA;EACA,4DAAA;AP+2KJ;AiDxwKE;EACE,kGAAA;EAEA,yDAAA;EACA,2DAAA;EACA,4DAAA;EACA,iBAAA;AjDywKJ;;AiDpwKA;EACE,gBAAA;EACA,8CAAA;AjDuwKF;;AiDlwKA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;AjDmwKF;;AiD/vKA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;E1C7HE,+DAAA;EACA,8DAAA;APg4KJ;AiD9vKE;EACE,8CAAA;AjDgwKJ;;Ac/2KI;EmCqHF;IACE,0BAAA;IACA,2CAAA;EjD8vKF;EiD1vKA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;EjD4vKF;EiDzvKA;IACE,uBAAA;EjD2vKF;AACF;Ac93KI;EmCuIF;;IAEE,uBAAA;EjD0vKF;AACF;Acp4KI;EmC8IF;IACE,wBAAA;EjDyvKF;AACF;AiDhvKI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AjDkvKN;AiDhvKM;EACE,YAAA;EACA,SAAA;E1C7MJ,gBAAA;APg8KJ;AiD/uKM;;E1CjNF,gBAAA;APo8KJ;AiD9uKM;EACE,gBAAA;AjDgvKR;;Ac94KI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjDswKJ;EiDpwKI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EPo9KF;EiDnwKI;;I1CjNF,gBAAA;EPw9KF;EiDlwKI;IACE,gBAAA;EjDowKN;AACF;Acn6KI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjD0xKJ;EiDxxKI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EPw+KF;EiDvxKI;;I1CjNF,gBAAA;EP4+KF;EiDtxKI;IACE,gBAAA;EjDwxKN;AACF;Acv7KI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjD8yKJ;EiD5yKI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EP4/KF;EiD3yKI;;I1CjNF,gBAAA;EPggLF;EiD1yKI;IACE,gBAAA;EjD4yKN;AACF;Ac38KI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjDk0KJ;EiDh0KI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EPghLF;EiD/zKI;;I1CjNF,gBAAA;EPohLF;EiD9zKI;IACE,gBAAA;EjDg0KN;AACF;Ac/9KI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjDs1KJ;EiDp1KI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EPoiLF;EiDn1KI;;I1CjNF,gBAAA;EPwiLF;EiDl1KI;IACE,gBAAA;EjDo1KN;AACF;AmD9jLA;EAEE,yBAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,qBAAA;EhDwRI,gCALI;EgDjRR,qCAAA;EACA,yCAAA;EACA,mDAAA;EACA,yBAAA;EACA,gCAAA;EACA,iCAAA;EAGA,iCAAA;EACA,cAAA;EACA,gCAAA;EClBA,sC9C+lB4B;E8C7lB5B,kBAAA;EACA,gB9CwmB4B;E8CvmB5B,gB9C+mB4B;E8C9mB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EgDhQR,qBAAA;EACA,UAAA;AnDskLF;AmDpkLE;EAAS,kCAAA;AnDukLX;AmDrkLE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AnDukLJ;AmDrkLI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AnDukLN;;AmDlkLA;EACE,iDAAA;AnDqkLF;AmDnkLE;EACE,SAAA;EACA,wFAAA;EACA,sCAAA;AnDqkLJ;;AmDjkLA,qBAAA;AACA;EACE,+CAAA;EACA,qCAAA;EACA,qCAAA;AnDokLF;AmDlkLE;EACE,WAAA;EACA,kIAAA;EACA,wCAAA;AnDokLJ;;AmDhkLA,mBAAA;AAEA;EACE,8CAAA;AnDkkLF;AmDhkLE;EACE,YAAA;EACA,wFAAA;EACA,yCAAA;AnDkkLJ;;AmD9jLA,qBAAA;AACA;EACE,gDAAA;EACA,qCAAA;EACA,qCAAA;AnDikLF;AmD/jLE;EACE,UAAA;EACA,kIAAA;EACA,uCAAA;AnDikLJ;;AmD7jLA,mBAAA;AAkBA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;E5CjGE,8CAAA;APipLJ;;AqDpqLA;EAEE,yBAAA;EACA,6BAAA;ElD4RI,gCALI;EkDrRR,kCAAA;EACA,iDAAA;EACA,6DAAA;EACA,sDAAA;EACA,2FAAA;EACA,6CAAA;EACA,mCAAA;EACA,qCAAA;ElDmRI,mCALI;EkD5QR,kCAAA;EACA,8CAAA;EACA,iCAAA;EACA,iCAAA;EACA,6CAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EAGA,iCAAA;EACA,cAAA;EACA,sCAAA;EDzBA,sC9C+lB4B;E8C7lB5B,kBAAA;EACA,gB9CwmB4B;E8CvmB5B,gB9C+mB4B;E8C9mB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EkD1PR,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;E9ChBE,8CAAA;AP+rLJ;AqD3qLE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;ArD6qLJ;AqD3qLI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;ArD4qLN;;AqDtqLE;EACE,oFAAA;ArDyqLJ;AqDvqLI;EAEE,wFAAA;ArDwqLN;AqDrqLI;EACE,SAAA;EACA,gDAAA;ArDuqLN;AqDpqLI;EACE,sCAAA;EACA,sCAAA;ArDsqLN;;AqDjqLA,qBAAA;AAEE;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;ArDmqLJ;AqDjqLI;EAEE,kIAAA;ArDkqLN;AqD/pLI;EACE,OAAA;EACA,kDAAA;ArDiqLN;AqD9pLI;EACE,oCAAA;EACA,wCAAA;ArDgqLN;;AqD3pLA,mBAAA;AAGE;EACE,iFAAA;ArD4pLJ;AqD1pLI;EAEE,wFAAA;ArD2pLN;AqDxpLI;EACE,MAAA;EACA,mDAAA;ArD0pLN;AqDvpLI;EACE,mCAAA;EACA,yCAAA;ArDypLN;AqDppLE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,uDAAA;EACA,WAAA;EACA,+EAAA;ArDspLJ;;AqDlpLA,qBAAA;AAEE;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;ArDopLJ;AqDlpLI;EAEE,kIAAA;ArDmpLN;AqDhpLI;EACE,QAAA;EACA,iDAAA;ArDkpLN;AqD/oLI;EACE,qCAAA;EACA,uCAAA;ArDipLN;;AqD5oLA,mBAAA;AAkBA;EACE,8EAAA;EACA,gBAAA;ElD2GI,6CALI;EkDpGR,qCAAA;EACA,6CAAA;EACA,kFAAA;E9C5JE,6DAAA;EACA,8DAAA;AP2xLJ;AqD7nLE;EACE,aAAA;ArD+nLJ;;AqD3nLA;EACE,0EAAA;EACA,mCAAA;ArD8nLF;;AsDnzLA;EACE,kBAAA;AtDszLF;;AsDnzLA;EACE,mBAAA;AtDszLF;;AsDnzLA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AtDszLF;AuD50LE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AvD80LJ;;AsDvzLA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EhClBI,sCgCmBJ;AtD0zLF;AsBz0LM;EgCQN;IhCPQ,gBAAA;EtB40LN;AACF;;AsD5zLA;;;EAGE,cAAA;AtD+zLF;;AsD5zLA;;EAEE,2BAAA;AtD+zLF;;AsD5zLA;;EAEE,4BAAA;AtD+zLF;;AsDtzLE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AtDyzLJ;AsDtzLE;;;EAGE,UAAA;EACA,UAAA;AtDwzLJ;AsDrzLE;;EAEE,UAAA;EACA,UAAA;EhC5DE,2BgC6DF;AtDuzLJ;AsBh3LM;EgCqDJ;;IhCpDM,gBAAA;EtBo3LN;AACF;;AsDpzLA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UhDkhDmC;EgDjhDnC,UAAA;EACA,WhD1FS;EgD2FT,kBAAA;EACA,gBAAA;EACA,8CAAA;EACA,SAAA;EACA,YhD4gDmC;EgBnmD/B,8BgCwFJ;AtDszLF;AsB14LM;EgCkEN;;IhCjEQ,gBAAA;EtB84LN;AACF;AsDzzLE;;;EAEE,WhDrGO;EgDsGP,qBAAA;EACA,UAAA;EACA,YhDogDiC;ANwzIrC;;AsDzzLA;EACE,OAAA;AtD4zLF;;AsDzzLA;EACE,QAAA;AtD4zLF;;AsDvzLA;;EAEE,qBAAA;EACA,WhDsgDmC;EgDrgDnC,YhDqgDmC;EgDpgDnC,4BAAA;EACA,wBAAA;EACA,0BAAA;AtD0zLF;;AsDvzLA;EACE,0TAAA;AtD0zLF;;AsDxzLA;EACE,yTAAA;AtD2zLF;;AsDnzLA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBhDq9CmC;EgDp9CnC,mBAAA;EACA,gBhDm9CmC;ANk2IrC;AsDnzLE;EACE,uBAAA;EACA,cAAA;EACA,WhDo9CiC;EgDn9CjC,WhDo9CiC;EgDn9CjC,UAAA;EACA,iBhDo9CiC;EgDn9CjC,gBhDm9CiC;EgDl9CjC,mBAAA;EACA,eAAA;EACA,wDAAA;EACA,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YhD28CiC;EgB5mD/B,6BgCkKF;AtDozLJ;AsBl9LM;EgC6IJ;IhC5IM,gBAAA;EtBq9LN;AACF;AsDtzLE;EACE,UhDw8CiC;ANg3IrC;;AsD/yLA;EACE,kBAAA;EACA,UAAA;EACA,ehDk8CmC;EgDj8CnC,SAAA;EACA,oBhD+7CmC;EgD97CnC,uBhD87CmC;EgD77CnC,uCAAA;EACA,kBAAA;AtDkzLF;;AsDvyLA;EALE,uCAAA;EACA,iCAAA;EACA,2DAAA;AtDgzLF;;AsDzyLA;;EAEE,uCAAA;EACA,iCAAA;EACA,mCAAA;AtD4yLF;;AIv/LI;EkD8LF,uCAAA;EACA,iCAAA;EACA,2DAAA;AtD6zLF;;AwDxgMA;;EAEE,qBAAA;EACA,cAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,6FAAA;AxD0gMF;;AwDtgMA;EACE;IAAK,0CAAA;ExD0gML;AACF;AwDvgMA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EAGA,yDAAA;EACA,+BAAA;AxDsgMF;;AwDngMA;EAEE,wBAAA;EACA,yBAAA;EACA,gCAAA;AxDqgMF;;AwD5/LA;EACE;IACE,mBAAA;ExD+/LF;EwD7/LA;IACE,UAAA;IACA,eAAA;ExD+/LF;AACF;AwD3/LA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EAGA,8BAAA;EACA,UAAA;AxD0/LF;;AwDv/LA;EACE,wBAAA;EACA,yBAAA;AxD0/LF;;AwDt/LE;EACE;;IAEE,kCAAA;ExDy/LJ;AACF;AyD1kMA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,8BAAA;EACA,0CAAA;EACA,oCAAA;EACA,mDAAA;EACA,+DAAA;EACA,kDAAA;EACA,qDAAA;EACA,qCAAA;AzD2kMF;;Ac9gMI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzD4jMJ;AACF;AsBvlMM;EmCYJ;InCXM,gBAAA;EtB0lMN;AACF;AcpiMI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzDmkMN;EyDhkMI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzDkkMN;EyD/jMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzDikMN;EyD9jMI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzDgkMN;EyD7jMI;IAEE,eAAA;EzD8jMN;EyD3jMI;IAGE,mBAAA;EzD2jMN;AACF;AcxlMI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzD0jMN;EyDxjMM;IACE,aAAA;EzD0jMR;EyDvjMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDwjMR;AACF;;Ac5lMI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzD0oMJ;AACF;AsBrqMM;EmCYJ;InCXM,gBAAA;EtBwqMN;AACF;AclnMI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzDipMN;EyD9oMI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzDgpMN;EyD7oMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzD+oMN;EyD5oMI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzD8oMN;EyD3oMI;IAEE,eAAA;EzD4oMN;EyDzoMI;IAGE,mBAAA;EzDyoMN;AACF;ActqMI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzDwoMN;EyDtoMM;IACE,aAAA;EzDwoMR;EyDroMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDsoMR;AACF;;Ac1qMI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzDwtMJ;AACF;AsBnvMM;EmCYJ;InCXM,gBAAA;EtBsvMN;AACF;AchsMI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzD+tMN;EyD5tMI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzD8tMN;EyD3tMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzD6tMN;EyD1tMI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzD4tMN;EyDztMI;IAEE,eAAA;EzD0tMN;EyDvtMI;IAGE,mBAAA;EzDutMN;AACF;AcpvMI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzDstMN;EyDptMM;IACE,aAAA;EzDstMR;EyDntMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDotMR;AACF;;AcxvMI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzDsyMJ;AACF;AsBj0MM;EmCYJ;InCXM,gBAAA;EtBo0MN;AACF;Ac9wMI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzD6yMN;EyD1yMI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzD4yMN;EyDzyMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzD2yMN;EyDxyMI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzD0yMN;EyDvyMI;IAEE,eAAA;EzDwyMN;EyDryMI;IAGE,mBAAA;EzDqyMN;AACF;Acl0MI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzDoyMN;EyDlyMM;IACE,aAAA;EzDoyMR;EyDjyMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDkyMR;AACF;;Act0MI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzDo3MJ;AACF;AsB/4MM;EmCYJ;InCXM,gBAAA;EtBk5MN;AACF;Ac51MI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzD23MN;EyDx3MI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzD03MN;EyDv3MI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzDy3MN;EyDt3MI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzDw3MN;EyDr3MI;IAEE,eAAA;EzDs3MN;EyDn3MI;IAGE,mBAAA;EzDm3MN;AACF;Ach5MI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzDk3MN;EyDh3MM;IACE,aAAA;EzDk3MR;EyD/2MM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDg3MR;AACF;;AyDh8ME;EAEI,eAAA;EACA,SAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;EnC5BA,0CmC8BA;AzDi8MN;AsB39MM;EmCYJ;InCXM,gBAAA;EtB89MN;AACF;AyDp8MM;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;AzDs8MR;AyDn8MM;EACE,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;AzDq8MR;AyDl8MM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;AzDo8MR;AyDj8MM;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;AzDm8MR;AyDh8MM;EAEE,eAAA;AzDi8MR;AyD97MM;EAGE,mBAAA;AzD87MR;;AyDn6MA;EPpHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a5C0mCkC;E4CzmClC,YAAA;EACA,aAAA;EACA,sB5CUS;ANihNX;AkDxhNE;EAAS,UAAA;AlD2hNX;AkD1hNE;EAAS,Y5Cm+CyB;AN0jKpC;;AyD/6MA;EACE,aAAA;EACA,mBAAA;EACA,oEAAA;AzDk7MF;AyDh7ME;EACE,4FAAA;EAEA,sDAAA;EACA,wDAAA;EACA,yDAAA;EACA,iBAAA;AzDi7MJ;;AyD76MA;EACE,gBAAA;EACA,kDAAA;AzDg7MF;;AyD76MA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;AzDg7MF;;A0DjkNA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YpDgzCkC;ANoxKpC;A0DlkNE;EACE,qBAAA;EACA,WAAA;A1DokNJ;;A0D/jNA;EACE,iBAAA;A1DkkNF;;A0D/jNA;EACE,iBAAA;A1DkkNF;;A0D/jNA;EACE,iBAAA;A1DkkNF;;A0D7jNE;EACE,mDAAA;A1DgkNJ;;A0D5jNA;EACE;IACE,YpDmxCgC;EN4yKlC;AACF;A0D5jNA;EACE,+EAAA;EACA,oBAAA;EACA,8CAAA;A1D8jNF;;A0D3jNA;EACE;IACE,uBAAA;E1D8jNF;AACF;AuD7mNE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AvD+mNJ;;A2DlnNE;EACE,sBAAA;EACA,iFAAA;A3DqnNJ;;A2DvnNE;EACE,sBAAA;EACA,mFAAA;A3D0nNJ;;A2D5nNE;EACE,sBAAA;EACA,iFAAA;A3D+nNJ;;A2DjoNE;EACE,sBAAA;EACA,8EAAA;A3DooNJ;;A2DtoNE;EACE,sBAAA;EACA,iFAAA;A3DyoNJ;;A2D3oNE;EACE,sBAAA;EACA,gFAAA;A3D8oNJ;;A2DhpNE;EACE,sBAAA;EACA,+EAAA;A3DmpNJ;;A2DrpNE;EACE,sBAAA;EACA,8EAAA;A3DwpNJ;;A4D1pNE;EACE,wEAAA;EACA,kGAAA;A5D6pNJ;A4D1pNM;EAGE,8DAAA;EACA,wFAAA;A5D0pNR;;A4DnqNE;EACE,0EAAA;EACA,oGAAA;A5DsqNJ;A4DnqNM;EAGE,8DAAA;EACA,wFAAA;A5DmqNR;;A4D5qNE;EACE,wEAAA;EACA,kGAAA;A5D+qNJ;A4D5qNM;EAGE,8DAAA;EACA,wFAAA;A5D4qNR;;A4DrrNE;EACE,qEAAA;EACA,+FAAA;A5DwrNJ;A4DrrNM;EAGE,+DAAA;EACA,yFAAA;A5DqrNR;;A4D9rNE;EACE,wEAAA;EACA,kGAAA;A5DisNJ;A4D9rNM;EAGE,+DAAA;EACA,yFAAA;A5D8rNR;;A4DvsNE;EACE,uEAAA;EACA,iGAAA;A5D0sNJ;A4DvsNM;EAGE,8DAAA;EACA,wFAAA;A5DusNR;;A4DhtNE;EACE,sEAAA;EACA,gGAAA;A5DmtNJ;A4DhtNM;EAGE,gEAAA;EACA,0FAAA;A5DgtNR;;A4DztNE;EACE,qEAAA;EACA,+FAAA;A5D4tNJ;A4DztNM;EAGE,6DAAA;EACA,uFAAA;A5DytNR;;A4DltNA;EACE,+EAAA;EACA,yGAAA;A5DqtNF;A4DltNI;EAEE,kFAAA;EACA,4GAAA;A5DmtNN;;A6D7uNA;EACE,UAAA;EAEA,kJAAA;A7D+uNF;;A8DlvNA;EACE,oBAAA;EACA,axD6c4B;EwD5c5B,mBAAA;EACA,kFAAA;EACA,6BxD2c4B;EwD1c5B,2BAAA;A9DqvNF;A8DnvNE;EACE,cAAA;EACA,UxDuc0B;EwDtc1B,WxDsc0B;EwDrc1B,kBAAA;ExCIE,sCwCHF;A9DqvNJ;AsB9uNM;EwCZJ;IxCaM,gBAAA;EtBivNN;AACF;;A8DnvNI;EACE,mEAAA;A9DsvNN;;A+DzwNA;EACE,kBAAA;EACA,WAAA;A/D4wNF;A+D1wNE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;A/D4wNJ;A+DzwNE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;A/D2wNJ;;A+DtwNE;EACE,uBAAA;A/DywNJ;;A+D1wNE;EACE,sBAAA;A/D6wNJ;;A+D9wNE;EACE,yBAAA;A/DixNJ;;A+DlxNE;EACE,iCAAA;A/DqxNJ;;AgE1yNA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a1DumCkC;ANssLpC;;AgE1yNA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a1D+lCkC;AN8sLpC;;AgEryNI;EACE,gBAAA;EACA,MAAA;EACA,a1DmlC8B;ANqtLpC;;AgEryNI;EACE,gBAAA;EACA,SAAA;EACA,a1D6kC8B;AN2tLpC;;AczwNI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;ENkuLlC;EgElzNE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;ENuuLlC;AACF;ActxNI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;EN8uLlC;EgE9zNE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;ENmvLlC;AACF;AclyNI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;EN0vLlC;EgE10NE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;EN+vLlC;AACF;Ac9yNI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;ENswLlC;EgEt1NE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;EN2wLlC;AACF;Ac1zNI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;ENkxLlC;EgEl2NE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;ENuxLlC;AACF;AiEp4NA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AjEs4NF;;AiEn4NA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AjEs4NF;;AkE94NA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AnE+4NF;AmE54NE;;EACE,6BAAA;AnE+4NJ;AmE34NE;;EACE,2BAAA;AnE84NJ;;AoEj6NE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,U9DgcsC;E8D/btC,WAAA;ApEo6NJ;;AqE56NA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;AtEg7NF;;AuEt7NA;EACE,qBAAA;EACA,mBAAA;EACA,6BjEisB4B;EiEhsB5B,eAAA;EACA,8BAAA;EACA,ajE2rB4B;AN8vM9B;;AwE73NQ;EAOI,mCAAA;AxE03NZ;;AwEj4NQ;EAOI,8BAAA;AxE83NZ;;AwEr4NQ;EAOI,iCAAA;AxEk4NZ;;AwEz4NQ;EAOI,iCAAA;AxEs4NZ;;AwE74NQ;EAOI,sCAAA;AxE04NZ;;AwEj5NQ;EAOI,mCAAA;AxE84NZ;;AwEr5NQ;EAOI,sBAAA;AxEk5NZ;;AwEz5NQ;EAOI,uBAAA;AxEs5NZ;;AwE75NQ;EAOI,sBAAA;AxE05NZ;;AwEj6NQ;EAOI,8BAAA;AxE85NZ;;AwEr6NQ;EAOI,4BAAA;AxEk6NZ;;AwEz6NQ;EAOI,2BAAA;AxEs6NZ;;AwE76NQ;EAOI,iCAAA;AxE06NZ;;AwEj7NQ;EAOI,2BAAA;AxE86NZ;;AwEr7NQ;EAOI,qBAAA;AxEk7NZ;;AwEz7NQ;EAOI,wBAAA;AxEs7NZ;;AwE77NQ;EAOI,uBAAA;AxE07NZ;;AwEj8NQ;EAOI,wBAAA;AxE87NZ;;AwEr8NQ;EAOI,qBAAA;AxEk8NZ;;AwEz8NQ;EAOI,yBAAA;AxEs8NZ;;AwE78NQ;EAOI,2BAAA;AxE08NZ;;AwEj9NQ;EAOI,4BAAA;AxE88NZ;;AwEr9NQ;EAOI,2BAAA;AxEk9NZ;;AwEz9NQ;EAOI,2BAAA;AxEs9NZ;;AwE79NQ;EAOI,6BAAA;AxE09NZ;;AwEj+NQ;EAOI,8BAAA;AxE89NZ;;AwEr+NQ;EAOI,6BAAA;AxEk+NZ;;AwEz+NQ;EAOI,2BAAA;AxEs+NZ;;AwE7+NQ;EAOI,6BAAA;AxE0+NZ;;AwEj/NQ;EAOI,8BAAA;AxE8+NZ;;AwEr/NQ;EAOI,6BAAA;AxEk/NZ;;AwEz/NQ;EAOI,0BAAA;AxEs/NZ;;AwE7/NQ;EAOI,gCAAA;AxE0/NZ;;AwEjgOQ;EAOI,yBAAA;AxE8/NZ;;AwErgOQ;EAOI,wBAAA;AxEkgOZ;;AwEzgOQ;EAOI,+BAAA;AxEsgOZ;;AwE7gOQ;EAOI,yBAAA;AxE0gOZ;;AwEjhOQ;EAOI,6BAAA;AxE8gOZ;;AwErhOQ;EAOI,8BAAA;AxEkhOZ;;AwEzhOQ;EAOI,wBAAA;AxEshOZ;;AwE7hOQ;EAOI,+BAAA;AxE0hOZ;;AwEjiOQ;EAOI,wBAAA;AxE8hOZ;;AwEriOQ;EAOI,2CAAA;AxEkiOZ;;AwEziOQ;EAOI,8CAAA;AxEsiOZ;;AwE7iOQ;EAOI,8CAAA;AxE0iOZ;;AwEjjOQ;EAOI,2BAAA;AxE8iOZ;;AwE/jOQ;EACE,gFAAA;AxEkkOV;;AwEnkOQ;EACE,kFAAA;AxEskOV;;AwEvkOQ;EACE,gFAAA;AxE0kOV;;AwE3kOQ;EACE,6EAAA;AxE8kOV;;AwE/kOQ;EACE,gFAAA;AxEklOV;;AwEnlOQ;EACE,+EAAA;AxEslOV;;AwEvlOQ;EACE,8EAAA;AxE0lOV;;AwE3lOQ;EACE,6EAAA;AxE8lOV;;AwErlOQ;EAOI,2BAAA;AxEklOZ;;AwEzlOQ;EAOI,6BAAA;AxEslOZ;;AwE7lOQ;EAOI,6BAAA;AxE0lOZ;;AwEjmOQ;EAOI,0BAAA;AxE8lOZ;;AwErmOQ;EAOI,2BAAA;AxEkmOZ;;AwEzmOQ;EAOI,iBAAA;AxEsmOZ;;AwE7mOQ;EAOI,mBAAA;AxE0mOZ;;AwEjnOQ;EAOI,oBAAA;AxE8mOZ;;AwErnOQ;EAOI,oBAAA;AxEknOZ;;AwEznOQ;EAOI,sBAAA;AxEsnOZ;;AwE7nOQ;EAOI,uBAAA;AxE0nOZ;;AwEjoOQ;EAOI,kBAAA;AxE8nOZ;;AwEroOQ;EAOI,oBAAA;AxEkoOZ;;AwEzoOQ;EAOI,qBAAA;AxEsoOZ;;AwE7oOQ;EAOI,mBAAA;AxE0oOZ;;AwEjpOQ;EAOI,qBAAA;AxE8oOZ;;AwErpOQ;EAOI,sBAAA;AxEkpOZ;;AwEzpOQ;EAOI,2CAAA;AxEspOZ;;AwE7pOQ;EAOI,sCAAA;AxE0pOZ;;AwEjqOQ;EAOI,sCAAA;AxE8pOZ;;AwErqOQ;EAOI,uFAAA;AxEkqOZ;;AwEzqOQ;EAOI,oBAAA;AxEsqOZ;;AwE7qOQ;EAOI,2FAAA;AxE0qOZ;;AwEjrOQ;EAOI,wBAAA;AxE8qOZ;;AwErrOQ;EAOI,6FAAA;AxEkrOZ;;AwEzrOQ;EAOI,0BAAA;AxEsrOZ;;AwE7rOQ;EAOI,8FAAA;AxE0rOZ;;AwEjsOQ;EAOI,2BAAA;AxE8rOZ;;AwErsOQ;EAOI,4FAAA;AxEksOZ;;AwEzsOQ;EAOI,yBAAA;AxEssOZ;;AwE7sOQ;EAIQ,sBAAA;EAGJ,8EAAA;AxE2sOZ;;AwEltOQ;EAIQ,sBAAA;EAGJ,gFAAA;AxEgtOZ;;AwEvtOQ;EAIQ,sBAAA;EAGJ,8EAAA;AxEqtOZ;;AwE5tOQ;EAIQ,sBAAA;EAGJ,2EAAA;AxE0tOZ;;AwEjuOQ;EAIQ,sBAAA;EAGJ,8EAAA;AxE+tOZ;;AwEtuOQ;EAIQ,sBAAA;EAGJ,6EAAA;AxEouOZ;;AwE3uOQ;EAIQ,sBAAA;EAGJ,4EAAA;AxEyuOZ;;AwEhvOQ;EAIQ,sBAAA;EAGJ,2EAAA;AxE8uOZ;;AwErvOQ;EAIQ,sBAAA;EAGJ,4EAAA;AxEmvOZ;;AwE1vOQ;EAIQ,sBAAA;EAGJ,4EAAA;AxEwvOZ;;AwE/vOQ;EAOI,wDAAA;AxE4vOZ;;AwEnwOQ;EAOI,0DAAA;AxEgwOZ;;AwEvwOQ;EAOI,wDAAA;AxEowOZ;;AwE3wOQ;EAOI,qDAAA;AxEwwOZ;;AwE/wOQ;EAOI,wDAAA;AxE4wOZ;;AwEnxOQ;EAOI,uDAAA;AxEgxOZ;;AwEvxOQ;EAOI,sDAAA;AxEoxOZ;;AwE3xOQ;EAOI,qDAAA;AxEwxOZ;;AwE/xOQ;EAOI,4BAAA;AxE4xOZ;;AwEnyOQ;EAOI,4BAAA;AxEgyOZ;;AwEvyOQ;EAOI,4BAAA;AxEoyOZ;;AwE3yOQ;EAOI,4BAAA;AxEwyOZ;;AwE/yOQ;EAOI,4BAAA;AxE4yOZ;;AwE7zOQ;EACE,wBAAA;AxEg0OV;;AwEj0OQ;EACE,yBAAA;AxEo0OV;;AwEr0OQ;EACE,wBAAA;AxEw0OV;;AwEz0OQ;EACE,yBAAA;AxE40OV;;AwE70OQ;EACE,sBAAA;AxEg1OV;;AwEv0OQ;EAOI,qBAAA;AxEo0OZ;;AwE30OQ;EAOI,qBAAA;AxEw0OZ;;AwE/0OQ;EAOI,qBAAA;AxE40OZ;;AwEn1OQ;EAOI,sBAAA;AxEg1OZ;;AwEv1OQ;EAOI,sBAAA;AxEo1OZ;;AwE31OQ;EAOI,0BAAA;AxEw1OZ;;AwE/1OQ;EAOI,uBAAA;AxE41OZ;;AwEn2OQ;EAOI,2BAAA;AxEg2OZ;;AwEv2OQ;EAOI,sBAAA;AxEo2OZ;;AwE32OQ;EAOI,sBAAA;AxEw2OZ;;AwE/2OQ;EAOI,sBAAA;AxE42OZ;;AwEn3OQ;EAOI,uBAAA;AxEg3OZ;;AwEv3OQ;EAOI,uBAAA;AxEo3OZ;;AwE33OQ;EAOI,2BAAA;AxEw3OZ;;AwE/3OQ;EAOI,wBAAA;AxE43OZ;;AwEn4OQ;EAOI,4BAAA;AxEg4OZ;;AwEv4OQ;EAOI,yBAAA;AxEo4OZ;;AwE34OQ;EAOI,8BAAA;AxEw4OZ;;AwE/4OQ;EAOI,iCAAA;AxE44OZ;;AwEn5OQ;EAOI,sCAAA;AxEg5OZ;;AwEv5OQ;EAOI,yCAAA;AxEo5OZ;;AwE35OQ;EAOI,uBAAA;AxEw5OZ;;AwE/5OQ;EAOI,uBAAA;AxE45OZ;;AwEn6OQ;EAOI,yBAAA;AxEg6OZ;;AwEv6OQ;EAOI,yBAAA;AxEo6OZ;;AwE36OQ;EAOI,0BAAA;AxEw6OZ;;AwE/6OQ;EAOI,4BAAA;AxE46OZ;;AwEn7OQ;EAOI,kCAAA;AxEg7OZ;;AwEv7OQ;EAOI,sCAAA;AxEo7OZ;;AwE37OQ;EAOI,oCAAA;AxEw7OZ;;AwE/7OQ;EAOI,kCAAA;AxE47OZ;;AwEn8OQ;EAOI,yCAAA;AxEg8OZ;;AwEv8OQ;EAOI,wCAAA;AxEo8OZ;;AwE38OQ;EAOI,wCAAA;AxEw8OZ;;AwE/8OQ;EAOI,kCAAA;AxE48OZ;;AwEn9OQ;EAOI,gCAAA;AxEg9OZ;;AwEv9OQ;EAOI,8BAAA;AxEo9OZ;;AwE39OQ;EAOI,gCAAA;AxEw9OZ;;AwE/9OQ;EAOI,+BAAA;AxE49OZ;;AwEn+OQ;EAOI,oCAAA;AxEg+OZ;;AwEv+OQ;EAOI,kCAAA;AxEo+OZ;;AwE3+OQ;EAOI,gCAAA;AxEw+OZ;;AwE/+OQ;EAOI,uCAAA;AxE4+OZ;;AwEn/OQ;EAOI,sCAAA;AxEg/OZ;;AwEv/OQ;EAOI,iCAAA;AxEo/OZ;;AwE3/OQ;EAOI,2BAAA;AxEw/OZ;;AwE//OQ;EAOI,iCAAA;AxE4/OZ;;AwEngPQ;EAOI,+BAAA;AxEggPZ;;AwEvgPQ;EAOI,6BAAA;AxEogPZ;;AwE3gPQ;EAOI,+BAAA;AxEwgPZ;;AwE/gPQ;EAOI,8BAAA;AxE4gPZ;;AwEnhPQ;EAOI,oBAAA;AxEghPZ;;AwEvhPQ;EAOI,mBAAA;AxEohPZ;;AwE3hPQ;EAOI,mBAAA;AxEwhPZ;;AwE/hPQ;EAOI,mBAAA;AxE4hPZ;;AwEniPQ;EAOI,mBAAA;AxEgiPZ;;AwEviPQ;EAOI,mBAAA;AxEoiPZ;;AwE3iPQ;EAOI,mBAAA;AxEwiPZ;;AwE/iPQ;EAOI,mBAAA;AxE4iPZ;;AwEnjPQ;EAOI,oBAAA;AxEgjPZ;;AwEvjPQ;EAOI,0BAAA;AxEojPZ;;AwE3jPQ;EAOI,yBAAA;AxEwjPZ;;AwE/jPQ;EAOI,uBAAA;AxE4jPZ;;AwEnkPQ;EAOI,yBAAA;AxEgkPZ;;AwEvkPQ;EAOI,uBAAA;AxEokPZ;;AwE3kPQ;EAOI,uBAAA;AxEwkPZ;;AwE/kPQ;EAOI,0BAAA;EAAA,yBAAA;AxE6kPZ;;AwEplPQ;EAOI,gCAAA;EAAA,+BAAA;AxEklPZ;;AwEzlPQ;EAOI,+BAAA;EAAA,8BAAA;AxEulPZ;;AwE9lPQ;EAOI,6BAAA;EAAA,4BAAA;AxE4lPZ;;AwEnmPQ;EAOI,+BAAA;EAAA,8BAAA;AxEimPZ;;AwExmPQ;EAOI,6BAAA;EAAA,4BAAA;AxEsmPZ;;AwE7mPQ;EAOI,6BAAA;EAAA,4BAAA;AxE2mPZ;;AwElnPQ;EAOI,wBAAA;EAAA,2BAAA;AxEgnPZ;;AwEvnPQ;EAOI,8BAAA;EAAA,iCAAA;AxEqnPZ;;AwE5nPQ;EAOI,6BAAA;EAAA,gCAAA;AxE0nPZ;;AwEjoPQ;EAOI,2BAAA;EAAA,8BAAA;AxE+nPZ;;AwEtoPQ;EAOI,6BAAA;EAAA,gCAAA;AxEooPZ;;AwE3oPQ;EAOI,2BAAA;EAAA,8BAAA;AxEyoPZ;;AwEhpPQ;EAOI,2BAAA;EAAA,8BAAA;AxE8oPZ;;AwErpPQ;EAOI,wBAAA;AxEkpPZ;;AwEzpPQ;EAOI,8BAAA;AxEspPZ;;AwE7pPQ;EAOI,6BAAA;AxE0pPZ;;AwEjqPQ;EAOI,2BAAA;AxE8pPZ;;AwErqPQ;EAOI,6BAAA;AxEkqPZ;;AwEzqPQ;EAOI,2BAAA;AxEsqPZ;;AwE7qPQ;EAOI,2BAAA;AxE0qPZ;;AwEjrPQ;EAOI,0BAAA;AxE8qPZ;;AwErrPQ;EAOI,gCAAA;AxEkrPZ;;AwEzrPQ;EAOI,+BAAA;AxEsrPZ;;AwE7rPQ;EAOI,6BAAA;AxE0rPZ;;AwEjsPQ;EAOI,+BAAA;AxE8rPZ;;AwErsPQ;EAOI,6BAAA;AxEksPZ;;AwEzsPQ;EAOI,6BAAA;AxEssPZ;;AwE7sPQ;EAOI,2BAAA;AxE0sPZ;;AwEjtPQ;EAOI,iCAAA;AxE8sPZ;;AwErtPQ;EAOI,gCAAA;AxEktPZ;;AwEztPQ;EAOI,8BAAA;AxEstPZ;;AwE7tPQ;EAOI,gCAAA;AxE0tPZ;;AwEjuPQ;EAOI,8BAAA;AxE8tPZ;;AwEruPQ;EAOI,8BAAA;AxEkuPZ;;AwEzuPQ;EAOI,yBAAA;AxEsuPZ;;AwE7uPQ;EAOI,+BAAA;AxE0uPZ;;AwEjvPQ;EAOI,8BAAA;AxE8uPZ;;AwErvPQ;EAOI,4BAAA;AxEkvPZ;;AwEzvPQ;EAOI,8BAAA;AxEsvPZ;;AwE7vPQ;EAOI,4BAAA;AxE0vPZ;;AwEjwPQ;EAOI,4BAAA;AxE8vPZ;;AwErwPQ;EAOI,qBAAA;AxEkwPZ;;AwEzwPQ;EAOI,2BAAA;AxEswPZ;;AwE7wPQ;EAOI,0BAAA;AxE0wPZ;;AwEjxPQ;EAOI,wBAAA;AxE8wPZ;;AwErxPQ;EAOI,0BAAA;AxEkxPZ;;AwEzxPQ;EAOI,wBAAA;AxEsxPZ;;AwE7xPQ;EAOI,2BAAA;EAAA,0BAAA;AxE2xPZ;;AwElyPQ;EAOI,iCAAA;EAAA,gCAAA;AxEgyPZ;;AwEvyPQ;EAOI,gCAAA;EAAA,+BAAA;AxEqyPZ;;AwE5yPQ;EAOI,8BAAA;EAAA,6BAAA;AxE0yPZ;;AwEjzPQ;EAOI,gCAAA;EAAA,+BAAA;AxE+yPZ;;AwEtzPQ;EAOI,8BAAA;EAAA,6BAAA;AxEozPZ;;AwE3zPQ;EAOI,yBAAA;EAAA,4BAAA;AxEyzPZ;;AwEh0PQ;EAOI,+BAAA;EAAA,kCAAA;AxE8zPZ;;AwEr0PQ;EAOI,8BAAA;EAAA,iCAAA;AxEm0PZ;;AwE10PQ;EAOI,4BAAA;EAAA,+BAAA;AxEw0PZ;;AwE/0PQ;EAOI,8BAAA;EAAA,iCAAA;AxE60PZ;;AwEp1PQ;EAOI,4BAAA;EAAA,+BAAA;AxEk1PZ;;AwEz1PQ;EAOI,yBAAA;AxEs1PZ;;AwE71PQ;EAOI,+BAAA;AxE01PZ;;AwEj2PQ;EAOI,8BAAA;AxE81PZ;;AwEr2PQ;EAOI,4BAAA;AxEk2PZ;;AwEz2PQ;EAOI,8BAAA;AxEs2PZ;;AwE72PQ;EAOI,4BAAA;AxE02PZ;;AwEj3PQ;EAOI,2BAAA;AxE82PZ;;AwEr3PQ;EAOI,iCAAA;AxEk3PZ;;AwEz3PQ;EAOI,gCAAA;AxEs3PZ;;AwE73PQ;EAOI,8BAAA;AxE03PZ;;AwEj4PQ;EAOI,gCAAA;AxE83PZ;;AwEr4PQ;EAOI,8BAAA;AxEk4PZ;;AwEz4PQ;EAOI,4BAAA;AxEs4PZ;;AwE74PQ;EAOI,kCAAA;AxE04PZ;;AwEj5PQ;EAOI,iCAAA;AxE84PZ;;AwEr5PQ;EAOI,+BAAA;AxEk5PZ;;AwEz5PQ;EAOI,iCAAA;AxEs5PZ;;AwE75PQ;EAOI,+BAAA;AxE05PZ;;AwEj6PQ;EAOI,0BAAA;AxE85PZ;;AwEr6PQ;EAOI,gCAAA;AxEk6PZ;;AwEz6PQ;EAOI,+BAAA;AxEs6PZ;;AwE76PQ;EAOI,6BAAA;AxE06PZ;;AwEj7PQ;EAOI,+BAAA;AxE86PZ;;AwEr7PQ;EAOI,6BAAA;AxEk7PZ;;AwEz7PQ;EAOI,iBAAA;AxEs7PZ;;AwE77PQ;EAOI,uBAAA;AxE07PZ;;AwEj8PQ;EAOI,sBAAA;AxE87PZ;;AwEr8PQ;EAOI,oBAAA;AxEk8PZ;;AwEz8PQ;EAOI,sBAAA;AxEs8PZ;;AwE78PQ;EAOI,oBAAA;AxE08PZ;;AwEj9PQ;EAOI,qBAAA;AxE88PZ;;AwEr9PQ;EAOI,2BAAA;AxEk9PZ;;AwEz9PQ;EAOI,0BAAA;AxEs9PZ;;AwE79PQ;EAOI,wBAAA;AxE09PZ;;AwEj+PQ;EAOI,0BAAA;AxE89PZ;;AwEr+PQ;EAOI,wBAAA;AxEk+PZ;;AwEz+PQ;EAOI,wBAAA;AxEs+PZ;;AwE7+PQ;EAOI,8BAAA;AxE0+PZ;;AwEj/PQ;EAOI,6BAAA;AxE8+PZ;;AwEr/PQ;EAOI,2BAAA;AxEk/PZ;;AwEz/PQ;EAOI,6BAAA;AxEs/PZ;;AwE7/PQ;EAOI,2BAAA;AxE0/PZ;;AwEjgQQ;EAOI,gDAAA;AxE8/PZ;;AwErgQQ;EAOI,4CAAA;AxEkgQZ;;AwEzgQQ;EAOI,4CAAA;AxEsgQZ;;AwE7gQQ;EAOI,0CAAA;AxE0gQZ;;AwEjhQQ;EAOI,4CAAA;AxE8gQZ;;AwErhQQ;EAOI,6BAAA;AxEkhQZ;;AwEzhQQ;EAOI,0BAAA;AxEshQZ;;AwE7hQQ;EAOI,6BAAA;AxE0hQZ;;AwEjiQQ;EAOI,6BAAA;AxE8hQZ;;AwEriQQ;EAOI,+BAAA;AxEkiQZ;;AwEziQQ;EAOI,2BAAA;AxEsiQZ;;AwE7iQQ;EAOI,2BAAA;AxE0iQZ;;AwEjjQQ;EAOI,2BAAA;AxE8iQZ;;AwErjQQ;EAOI,2BAAA;AxEkjQZ;;AwEzjQQ;EAOI,2BAAA;AxEsjQZ;;AwE7jQQ;EAOI,8BAAA;AxE0jQZ;;AwEjkQQ;EAOI,yBAAA;AxE8jQZ;;AwErkQQ;EAOI,4BAAA;AxEkkQZ;;AwEzkQQ;EAOI,2BAAA;AxEskQZ;;AwE7kQQ;EAOI,yBAAA;AxE0kQZ;;AwEjlQQ;EAOI,2BAAA;AxE8kQZ;;AwErlQQ;EAOI,4BAAA;AxEklQZ;;AwEzlQQ;EAOI,6BAAA;AxEslQZ;;AwE7lQQ;EAOI,gCAAA;AxE0lQZ;;AwEjmQQ;EAOI,qCAAA;AxE8lQZ;;AwErmQQ;EAOI,wCAAA;AxEkmQZ;;AwEzmQQ;EAOI,oCAAA;AxEsmQZ;;AwE7mQQ;EAOI,oCAAA;AxE0mQZ;;AwEjnQQ;EAOI,qCAAA;AxE8mQZ;;AwErnQQ;EAOI,8BAAA;AxEknQZ;;AwEznQQ;EAOI,8BAAA;AxEsnQZ;;AwE3oQQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;AxE4nQZ;;AwEzmQQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,qEAAA;AxEkoQZ;;AwEzoQQ;EAIQ,oBAAA;EAGJ,uEAAA;AxEuoQZ;;AwE9oQQ;EAIQ,oBAAA;EAGJ,qEAAA;AxE4oQZ;;AwEnpQQ;EAIQ,oBAAA;EAGJ,kEAAA;AxEipQZ;;AwExpQQ;EAIQ,oBAAA;EAGJ,qEAAA;AxEspQZ;;AwE7pQQ;EAIQ,oBAAA;EAGJ,oEAAA;AxE2pQZ;;AwElqQQ;EAIQ,oBAAA;EAGJ,mEAAA;AxEgqQZ;;AwEvqQQ;EAIQ,oBAAA;EAGJ,kEAAA;AxEqqQZ;;AwE5qQQ;EAIQ,oBAAA;EAGJ,mEAAA;AxE0qQZ;;AwEjrQQ;EAIQ,oBAAA;EAGJ,mEAAA;AxE+qQZ;;AwEtrQQ;EAIQ,oBAAA;EAGJ,wEAAA;AxEorQZ;;AwE3rQQ;EAIQ,oBAAA;EAGJ,2CAAA;AxEyrQZ;;AwEhsQQ;EAIQ,oBAAA;EAGJ,oCAAA;AxE8rQZ;;AwErsQQ;EAIQ,oBAAA;EAGJ,0CAAA;AxEmsQZ;;AwE1sQQ;EAIQ,oBAAA;EAGJ,2CAAA;AxEwsQZ;;AwE/sQQ;EAIQ,oBAAA;EAGJ,0CAAA;AxE6sQZ;;AwEptQQ;EAIQ,oBAAA;EAGJ,0CAAA;AxEktQZ;;AwEztQQ;EAIQ,oBAAA;EAGJ,yBAAA;AxEutQZ;;AwExuQQ;EACE,uBAAA;AxE2uQV;;AwE5uQQ;EACE,sBAAA;AxE+uQV;;AwEhvQQ;EACE,uBAAA;AxEmvQV;;AwEpvQQ;EACE,oBAAA;AxEuvQV;;AwE9uQQ;EAOI,iDAAA;AxE2uQZ;;AwElvQQ;EAOI,mDAAA;AxE+uQZ;;AwEtvQQ;EAOI,iDAAA;AxEmvQZ;;AwE1vQQ;EAOI,8CAAA;AxEuvQZ;;AwE9vQQ;EAOI,iDAAA;AxE2vQZ;;AwElwQQ;EAOI,gDAAA;AxE+vQZ;;AwEtwQQ;EAOI,+CAAA;AxEmwQZ;;AwE1wQQ;EAOI,8CAAA;AxEuwQZ;;AwExxQQ;EACE,sBAAA;AxE2xQV;;AwEvxQU;EACE,sBAAA;AxE0xQZ;;AwEhyQQ;EACE,uBAAA;AxEmyQV;;AwE/xQU;EACE,uBAAA;AxEkyQZ;;AwExyQQ;EACE,sBAAA;AxE2yQV;;AwEvyQU;EACE,sBAAA;AxE0yQZ;;AwEhzQQ;EACE,uBAAA;AxEmzQV;;AwE/yQU;EACE,uBAAA;AxEkzQZ;;AwExzQQ;EACE,oBAAA;AxE2zQV;;AwEvzQU;EACE,oBAAA;AxE0zQZ;;AwEtzQQ;EAOI,yCAAA;AxEmzQZ;;AwE9yQU;EAOI,yCAAA;AxE2yQd;;AwE9zQQ;EAOI,wCAAA;AxE2zQZ;;AwEtzQU;EAOI,wCAAA;AxEmzQd;;AwEt0QQ;EAOI,yCAAA;AxEm0QZ;;AwE9zQU;EAOI,yCAAA;AxE2zQd;;AwE90QQ;EAIQ,8BAAA;EAGJ,+FAAA;AxE40QZ;;AwEn1QQ;EAIQ,8BAAA;EAGJ,iGAAA;AxEi1QZ;;AwEx1QQ;EAIQ,8BAAA;EAGJ,+FAAA;AxEs1QZ;;AwE71QQ;EAIQ,8BAAA;EAGJ,4FAAA;AxE21QZ;;AwEl2QQ;EAIQ,8BAAA;EAGJ,+FAAA;AxEg2QZ;;AwEv2QQ;EAIQ,8BAAA;EAGJ,8FAAA;AxEq2QZ;;AwE52QQ;EAIQ,8BAAA;EAGJ,6FAAA;AxE02QZ;;AwEj3QQ;EAIQ,8BAAA;EAGJ,4FAAA;AxE+2QZ;;AwEt3QQ;EAIQ,8BAAA;EAGJ,qGAAA;AxEo3QZ;;AwEr4QQ;EACE,8BAAA;AxEw4QV;;AwEp4QU;EACE,8BAAA;AxEu4QZ;;AwE74QQ;EACE,gCAAA;AxEg5QV;;AwE54QU;EACE,gCAAA;AxE+4QZ;;AwEr5QQ;EACE,iCAAA;AxEw5QV;;AwEp5QU;EACE,iCAAA;AxEu5QZ;;AwE75QQ;EACE,gCAAA;AxEg6QV;;AwE55QU;EACE,gCAAA;AxE+5QZ;;AwEr6QQ;EACE,iCAAA;AxEw6QV;;AwEp6QU;EACE,iCAAA;AxEu6QZ;;AwE76QQ;EACE,8BAAA;AxEg7QV;;AwE56QU;EACE,8BAAA;AxE+6QZ;;AwE36QQ;EAIQ,kBAAA;EAGJ,8EAAA;AxEy6QZ;;AwEh7QQ;EAIQ,kBAAA;EAGJ,gFAAA;AxE86QZ;;AwEr7QQ;EAIQ,kBAAA;EAGJ,8EAAA;AxEm7QZ;;AwE17QQ;EAIQ,kBAAA;EAGJ,2EAAA;AxEw7QZ;;AwE/7QQ;EAIQ,kBAAA;EAGJ,8EAAA;AxE67QZ;;AwEp8QQ;EAIQ,kBAAA;EAGJ,6EAAA;AxEk8QZ;;AwEz8QQ;EAIQ,kBAAA;EAGJ,4EAAA;AxEu8QZ;;AwE98QQ;EAIQ,kBAAA;EAGJ,2EAAA;AxE48QZ;;AwEn9QQ;EAIQ,kBAAA;EAGJ,4EAAA;AxEi9QZ;;AwEx9QQ;EAIQ,kBAAA;EAGJ,4EAAA;AxEs9QZ;;AwE79QQ;EAIQ,kBAAA;EAGJ,8EAAA;AxE29QZ;;AwEl+QQ;EAIQ,kBAAA;EAGJ,wCAAA;AxEg+QZ;;AwEv+QQ;EAIQ,kBAAA;EAGJ,mFAAA;AxEq+QZ;;AwE5+QQ;EAIQ,kBAAA;EAGJ,kFAAA;AxE0+QZ;;AwE3/QQ;EACE,oBAAA;AxE8/QV;;AwE//QQ;EACE,qBAAA;AxEkgRV;;AwEngRQ;EACE,oBAAA;AxEsgRV;;AwEvgRQ;EACE,qBAAA;AxE0gRV;;AwE3gRQ;EACE,kBAAA;AxE8gRV;;AwErgRQ;EAOI,wDAAA;AxEkgRZ;;AwEzgRQ;EAOI,0DAAA;AxEsgRZ;;AwE7gRQ;EAOI,wDAAA;AxE0gRZ;;AwEjhRQ;EAOI,qDAAA;AxE8gRZ;;AwErhRQ;EAOI,wDAAA;AxEkhRZ;;AwEzhRQ;EAOI,uDAAA;AxEshRZ;;AwE7hRQ;EAOI,sDAAA;AxE0hRZ;;AwEjiRQ;EAOI,qDAAA;AxE8hRZ;;AwEriRQ;EAOI,+CAAA;AxEkiRZ;;AwEziRQ;EAOI,mCAAA;UAAA,2BAAA;AxEsiRZ;;AwE7iRQ;EAOI,oCAAA;UAAA,4BAAA;AxE0iRZ;;AwEjjRQ;EAOI,oCAAA;UAAA,4BAAA;AxE8iRZ;;AwErjRQ;EAOI,+BAAA;AxEkjRZ;;AwEzjRQ;EAOI,+BAAA;AxEsjRZ;;AwE7jRQ;EAOI,iDAAA;AxE0jRZ;;AwEjkRQ;EAOI,2BAAA;AxE8jRZ;;AwErkRQ;EAOI,oDAAA;AxEkkRZ;;AwEzkRQ;EAOI,iDAAA;AxEskRZ;;AwE7kRQ;EAOI,oDAAA;AxE0kRZ;;AwEjlRQ;EAOI,oDAAA;AxE8kRZ;;AwErlRQ;EAOI,qDAAA;AxEklRZ;;AwEzlRQ;EAOI,6BAAA;AxEslRZ;;AwE7lRQ;EAOI,sDAAA;AxE0lRZ;;AwEjmRQ;EAOI,0DAAA;EAAA,2DAAA;AxE+lRZ;;AwEtmRQ;EAOI,oCAAA;EAAA,qCAAA;AxEomRZ;;AwE3mRQ;EAOI,6DAAA;EAAA,8DAAA;AxEymRZ;;AwEhnRQ;EAOI,0DAAA;EAAA,2DAAA;AxE8mRZ;;AwErnRQ;EAOI,6DAAA;EAAA,8DAAA;AxEmnRZ;;AwE1nRQ;EAOI,6DAAA;EAAA,8DAAA;AxEwnRZ;;AwE/nRQ;EAOI,8DAAA;EAAA,+DAAA;AxE6nRZ;;AwEpoRQ;EAOI,sCAAA;EAAA,uCAAA;AxEkoRZ;;AwEzoRQ;EAOI,+DAAA;EAAA,gEAAA;AxEuoRZ;;AwE9oRQ;EAOI,2DAAA;EAAA,8DAAA;AxE4oRZ;;AwEnpRQ;EAOI,qCAAA;EAAA,wCAAA;AxEipRZ;;AwExpRQ;EAOI,8DAAA;EAAA,iEAAA;AxEspRZ;;AwE7pRQ;EAOI,2DAAA;EAAA,8DAAA;AxE2pRZ;;AwElqRQ;EAOI,8DAAA;EAAA,iEAAA;AxEgqRZ;;AwEvqRQ;EAOI,8DAAA;EAAA,iEAAA;AxEqqRZ;;AwE5qRQ;EAOI,+DAAA;EAAA,kEAAA;AxE0qRZ;;AwEjrRQ;EAOI,uCAAA;EAAA,0CAAA;AxE+qRZ;;AwEtrRQ;EAOI,gEAAA;EAAA,mEAAA;AxEorRZ;;AwE3rRQ;EAOI,8DAAA;EAAA,6DAAA;AxEyrRZ;;AwEhsRQ;EAOI,wCAAA;EAAA,uCAAA;AxE8rRZ;;AwErsRQ;EAOI,iEAAA;EAAA,gEAAA;AxEmsRZ;;AwE1sRQ;EAOI,8DAAA;EAAA,6DAAA;AxEwsRZ;;AwE/sRQ;EAOI,iEAAA;EAAA,gEAAA;AxE6sRZ;;AwEptRQ;EAOI,iEAAA;EAAA,gEAAA;AxEktRZ;;AwEztRQ;EAOI,kEAAA;EAAA,iEAAA;AxEutRZ;;AwE9tRQ;EAOI,0CAAA;EAAA,yCAAA;AxE4tRZ;;AwEnuRQ;EAOI,mEAAA;EAAA,kEAAA;AxEiuRZ;;AwExuRQ;EAOI,6DAAA;EAAA,0DAAA;AxEsuRZ;;AwE7uRQ;EAOI,uCAAA;EAAA,oCAAA;AxE2uRZ;;AwElvRQ;EAOI,gEAAA;EAAA,6DAAA;AxEgvRZ;;AwEvvRQ;EAOI,6DAAA;EAAA,0DAAA;AxEqvRZ;;AwE5vRQ;EAOI,gEAAA;EAAA,6DAAA;AxE0vRZ;;AwEjwRQ;EAOI,gEAAA;EAAA,6DAAA;AxE+vRZ;;AwEtwRQ;EAOI,iEAAA;EAAA,8DAAA;AxEowRZ;;AwE3wRQ;EAOI,yCAAA;EAAA,sCAAA;AxEywRZ;;AwEhxRQ;EAOI,kEAAA;EAAA,+DAAA;AxE8wRZ;;AwErxRQ;EAOI,8BAAA;AxEkxRZ;;AwEzxRQ;EAOI,6BAAA;AxEsxRZ;;AwE7xRQ;EAOI,sBAAA;AxE0xRZ;;AwEjyRQ;EAOI,qBAAA;AxE8xRZ;;AwEryRQ;EAOI,qBAAA;AxEkyRZ;;AwEzyRQ;EAOI,qBAAA;AxEsyRZ;;AwE7yRQ;EAOI,qBAAA;AxE0yRZ;;AcpzRI;E0DGI;IAOI,sBAAA;ExE+yRV;EwEtzRM;IAOI,uBAAA;ExEkzRV;EwEzzRM;IAOI,sBAAA;ExEqzRV;EwE5zRM;IAOI,8BAAA;ExEwzRV;EwE/zRM;IAOI,4BAAA;ExE2zRV;EwEl0RM;IAOI,2BAAA;ExE8zRV;EwEr0RM;IAOI,iCAAA;ExEi0RV;EwEx0RM;IAOI,2BAAA;ExEo0RV;EwE30RM;IAOI,0BAAA;ExEu0RV;EwE90RM;IAOI,gCAAA;ExE00RV;EwEj1RM;IAOI,yBAAA;ExE60RV;EwEp1RM;IAOI,wBAAA;ExEg1RV;EwEv1RM;IAOI,+BAAA;ExEm1RV;EwE11RM;IAOI,yBAAA;ExEs1RV;EwE71RM;IAOI,6BAAA;ExEy1RV;EwEh2RM;IAOI,8BAAA;ExE41RV;EwEn2RM;IAOI,wBAAA;ExE+1RV;EwEt2RM;IAOI,+BAAA;ExEk2RV;EwEz2RM;IAOI,wBAAA;ExEq2RV;EwE52RM;IAOI,yBAAA;ExEw2RV;EwE/2RM;IAOI,8BAAA;ExE22RV;EwEl3RM;IAOI,iCAAA;ExE82RV;EwEr3RM;IAOI,sCAAA;ExEi3RV;EwEx3RM;IAOI,yCAAA;ExEo3RV;EwE33RM;IAOI,uBAAA;ExEu3RV;EwE93RM;IAOI,uBAAA;ExE03RV;EwEj4RM;IAOI,yBAAA;ExE63RV;EwEp4RM;IAOI,yBAAA;ExEg4RV;EwEv4RM;IAOI,0BAAA;ExEm4RV;EwE14RM;IAOI,4BAAA;ExEs4RV;EwE74RM;IAOI,kCAAA;ExEy4RV;EwEh5RM;IAOI,sCAAA;ExE44RV;EwEn5RM;IAOI,oCAAA;ExE+4RV;EwEt5RM;IAOI,kCAAA;ExEk5RV;EwEz5RM;IAOI,yCAAA;ExEq5RV;EwE55RM;IAOI,wCAAA;ExEw5RV;EwE/5RM;IAOI,wCAAA;ExE25RV;EwEl6RM;IAOI,kCAAA;ExE85RV;EwEr6RM;IAOI,gCAAA;ExEi6RV;EwEx6RM;IAOI,8BAAA;ExEo6RV;EwE36RM;IAOI,gCAAA;ExEu6RV;EwE96RM;IAOI,+BAAA;ExE06RV;EwEj7RM;IAOI,oCAAA;ExE66RV;EwEp7RM;IAOI,kCAAA;ExEg7RV;EwEv7RM;IAOI,gCAAA;ExEm7RV;EwE17RM;IAOI,uCAAA;ExEs7RV;EwE77RM;IAOI,sCAAA;ExEy7RV;EwEh8RM;IAOI,iCAAA;ExE47RV;EwEn8RM;IAOI,2BAAA;ExE+7RV;EwEt8RM;IAOI,iCAAA;ExEk8RV;EwEz8RM;IAOI,+BAAA;ExEq8RV;EwE58RM;IAOI,6BAAA;ExEw8RV;EwE/8RM;IAOI,+BAAA;ExE28RV;EwEl9RM;IAOI,8BAAA;ExE88RV;EwEr9RM;IAOI,oBAAA;ExEi9RV;EwEx9RM;IAOI,mBAAA;ExEo9RV;EwE39RM;IAOI,mBAAA;ExEu9RV;EwE99RM;IAOI,mBAAA;ExE09RV;EwEj+RM;IAOI,mBAAA;ExE69RV;EwEp+RM;IAOI,mBAAA;ExEg+RV;EwEv+RM;IAOI,mBAAA;ExEm+RV;EwE1+RM;IAOI,mBAAA;ExEs+RV;EwE7+RM;IAOI,oBAAA;ExEy+RV;EwEh/RM;IAOI,0BAAA;ExE4+RV;EwEn/RM;IAOI,yBAAA;ExE++RV;EwEt/RM;IAOI,uBAAA;ExEk/RV;EwEz/RM;IAOI,yBAAA;ExEq/RV;EwE5/RM;IAOI,uBAAA;ExEw/RV;EwE//RM;IAOI,uBAAA;ExE2/RV;EwElgSM;IAOI,0BAAA;IAAA,yBAAA;ExE+/RV;EwEtgSM;IAOI,gCAAA;IAAA,+BAAA;ExEmgSV;EwE1gSM;IAOI,+BAAA;IAAA,8BAAA;ExEugSV;EwE9gSM;IAOI,6BAAA;IAAA,4BAAA;ExE2gSV;EwElhSM;IAOI,+BAAA;IAAA,8BAAA;ExE+gSV;EwEthSM;IAOI,6BAAA;IAAA,4BAAA;ExEmhSV;EwE1hSM;IAOI,6BAAA;IAAA,4BAAA;ExEuhSV;EwE9hSM;IAOI,wBAAA;IAAA,2BAAA;ExE2hSV;EwEliSM;IAOI,8BAAA;IAAA,iCAAA;ExE+hSV;EwEtiSM;IAOI,6BAAA;IAAA,gCAAA;ExEmiSV;EwE1iSM;IAOI,2BAAA;IAAA,8BAAA;ExEuiSV;EwE9iSM;IAOI,6BAAA;IAAA,gCAAA;ExE2iSV;EwEljSM;IAOI,2BAAA;IAAA,8BAAA;ExE+iSV;EwEtjSM;IAOI,2BAAA;IAAA,8BAAA;ExEmjSV;EwE1jSM;IAOI,wBAAA;ExEsjSV;EwE7jSM;IAOI,8BAAA;ExEyjSV;EwEhkSM;IAOI,6BAAA;ExE4jSV;EwEnkSM;IAOI,2BAAA;ExE+jSV;EwEtkSM;IAOI,6BAAA;ExEkkSV;EwEzkSM;IAOI,2BAAA;ExEqkSV;EwE5kSM;IAOI,2BAAA;ExEwkSV;EwE/kSM;IAOI,0BAAA;ExE2kSV;EwEllSM;IAOI,gCAAA;ExE8kSV;EwErlSM;IAOI,+BAAA;ExEilSV;EwExlSM;IAOI,6BAAA;ExEolSV;EwE3lSM;IAOI,+BAAA;ExEulSV;EwE9lSM;IAOI,6BAAA;ExE0lSV;EwEjmSM;IAOI,6BAAA;ExE6lSV;EwEpmSM;IAOI,2BAAA;ExEgmSV;EwEvmSM;IAOI,iCAAA;ExEmmSV;EwE1mSM;IAOI,gCAAA;ExEsmSV;EwE7mSM;IAOI,8BAAA;ExEymSV;EwEhnSM;IAOI,gCAAA;ExE4mSV;EwEnnSM;IAOI,8BAAA;ExE+mSV;EwEtnSM;IAOI,8BAAA;ExEknSV;EwEznSM;IAOI,yBAAA;ExEqnSV;EwE5nSM;IAOI,+BAAA;ExEwnSV;EwE/nSM;IAOI,8BAAA;ExE2nSV;EwEloSM;IAOI,4BAAA;ExE8nSV;EwEroSM;IAOI,8BAAA;ExEioSV;EwExoSM;IAOI,4BAAA;ExEooSV;EwE3oSM;IAOI,4BAAA;ExEuoSV;EwE9oSM;IAOI,qBAAA;ExE0oSV;EwEjpSM;IAOI,2BAAA;ExE6oSV;EwEppSM;IAOI,0BAAA;ExEgpSV;EwEvpSM;IAOI,wBAAA;ExEmpSV;EwE1pSM;IAOI,0BAAA;ExEspSV;EwE7pSM;IAOI,wBAAA;ExEypSV;EwEhqSM;IAOI,2BAAA;IAAA,0BAAA;ExE6pSV;EwEpqSM;IAOI,iCAAA;IAAA,gCAAA;ExEiqSV;EwExqSM;IAOI,gCAAA;IAAA,+BAAA;ExEqqSV;EwE5qSM;IAOI,8BAAA;IAAA,6BAAA;ExEyqSV;EwEhrSM;IAOI,gCAAA;IAAA,+BAAA;ExE6qSV;EwEprSM;IAOI,8BAAA;IAAA,6BAAA;ExEirSV;EwExrSM;IAOI,yBAAA;IAAA,4BAAA;ExEqrSV;EwE5rSM;IAOI,+BAAA;IAAA,kCAAA;ExEyrSV;EwEhsSM;IAOI,8BAAA;IAAA,iCAAA;ExE6rSV;EwEpsSM;IAOI,4BAAA;IAAA,+BAAA;ExEisSV;EwExsSM;IAOI,8BAAA;IAAA,iCAAA;ExEqsSV;EwE5sSM;IAOI,4BAAA;IAAA,+BAAA;ExEysSV;EwEhtSM;IAOI,yBAAA;ExE4sSV;EwEntSM;IAOI,+BAAA;ExE+sSV;EwEttSM;IAOI,8BAAA;ExEktSV;EwEztSM;IAOI,4BAAA;ExEqtSV;EwE5tSM;IAOI,8BAAA;ExEwtSV;EwE/tSM;IAOI,4BAAA;ExE2tSV;EwEluSM;IAOI,2BAAA;ExE8tSV;EwEruSM;IAOI,iCAAA;ExEiuSV;EwExuSM;IAOI,gCAAA;ExEouSV;EwE3uSM;IAOI,8BAAA;ExEuuSV;EwE9uSM;IAOI,gCAAA;ExE0uSV;EwEjvSM;IAOI,8BAAA;ExE6uSV;EwEpvSM;IAOI,4BAAA;ExEgvSV;EwEvvSM;IAOI,kCAAA;ExEmvSV;EwE1vSM;IAOI,iCAAA;ExEsvSV;EwE7vSM;IAOI,+BAAA;ExEyvSV;EwEhwSM;IAOI,iCAAA;ExE4vSV;EwEnwSM;IAOI,+BAAA;ExE+vSV;EwEtwSM;IAOI,0BAAA;ExEkwSV;EwEzwSM;IAOI,gCAAA;ExEqwSV;EwE5wSM;IAOI,+BAAA;ExEwwSV;EwE/wSM;IAOI,6BAAA;ExE2wSV;EwElxSM;IAOI,+BAAA;ExE8wSV;EwErxSM;IAOI,6BAAA;ExEixSV;EwExxSM;IAOI,iBAAA;ExEoxSV;EwE3xSM;IAOI,uBAAA;ExEuxSV;EwE9xSM;IAOI,sBAAA;ExE0xSV;EwEjySM;IAOI,oBAAA;ExE6xSV;EwEpySM;IAOI,sBAAA;ExEgySV;EwEvySM;IAOI,oBAAA;ExEmySV;EwE1ySM;IAOI,qBAAA;ExEsySV;EwE7ySM;IAOI,2BAAA;ExEyySV;EwEhzSM;IAOI,0BAAA;ExE4ySV;EwEnzSM;IAOI,wBAAA;ExE+ySV;EwEtzSM;IAOI,0BAAA;ExEkzSV;EwEzzSM;IAOI,wBAAA;ExEqzSV;EwE5zSM;IAOI,wBAAA;ExEwzSV;EwE/zSM;IAOI,8BAAA;ExE2zSV;EwEl0SM;IAOI,6BAAA;ExE8zSV;EwEr0SM;IAOI,2BAAA;ExEi0SV;EwEx0SM;IAOI,6BAAA;ExEo0SV;EwE30SM;IAOI,2BAAA;ExEu0SV;EwE90SM;IAOI,2BAAA;ExE00SV;EwEj1SM;IAOI,4BAAA;ExE60SV;EwEp1SM;IAOI,6BAAA;ExEg1SV;AACF;Ac31SI;E0DGI;IAOI,sBAAA;ExEq1SV;EwE51SM;IAOI,uBAAA;ExEw1SV;EwE/1SM;IAOI,sBAAA;ExE21SV;EwEl2SM;IAOI,8BAAA;ExE81SV;EwEr2SM;IAOI,4BAAA;ExEi2SV;EwEx2SM;IAOI,2BAAA;ExEo2SV;EwE32SM;IAOI,iCAAA;ExEu2SV;EwE92SM;IAOI,2BAAA;ExE02SV;EwEj3SM;IAOI,0BAAA;ExE62SV;EwEp3SM;IAOI,gCAAA;ExEg3SV;EwEv3SM;IAOI,yBAAA;ExEm3SV;EwE13SM;IAOI,wBAAA;ExEs3SV;EwE73SM;IAOI,+BAAA;ExEy3SV;EwEh4SM;IAOI,yBAAA;ExE43SV;EwEn4SM;IAOI,6BAAA;ExE+3SV;EwEt4SM;IAOI,8BAAA;ExEk4SV;EwEz4SM;IAOI,wBAAA;ExEq4SV;EwE54SM;IAOI,+BAAA;ExEw4SV;EwE/4SM;IAOI,wBAAA;ExE24SV;EwEl5SM;IAOI,yBAAA;ExE84SV;EwEr5SM;IAOI,8BAAA;ExEi5SV;EwEx5SM;IAOI,iCAAA;ExEo5SV;EwE35SM;IAOI,sCAAA;ExEu5SV;EwE95SM;IAOI,yCAAA;ExE05SV;EwEj6SM;IAOI,uBAAA;ExE65SV;EwEp6SM;IAOI,uBAAA;ExEg6SV;EwEv6SM;IAOI,yBAAA;ExEm6SV;EwE16SM;IAOI,yBAAA;ExEs6SV;EwE76SM;IAOI,0BAAA;ExEy6SV;EwEh7SM;IAOI,4BAAA;ExE46SV;EwEn7SM;IAOI,kCAAA;ExE+6SV;EwEt7SM;IAOI,sCAAA;ExEk7SV;EwEz7SM;IAOI,oCAAA;ExEq7SV;EwE57SM;IAOI,kCAAA;ExEw7SV;EwE/7SM;IAOI,yCAAA;ExE27SV;EwEl8SM;IAOI,wCAAA;ExE87SV;EwEr8SM;IAOI,wCAAA;ExEi8SV;EwEx8SM;IAOI,kCAAA;ExEo8SV;EwE38SM;IAOI,gCAAA;ExEu8SV;EwE98SM;IAOI,8BAAA;ExE08SV;EwEj9SM;IAOI,gCAAA;ExE68SV;EwEp9SM;IAOI,+BAAA;ExEg9SV;EwEv9SM;IAOI,oCAAA;ExEm9SV;EwE19SM;IAOI,kCAAA;ExEs9SV;EwE79SM;IAOI,gCAAA;ExEy9SV;EwEh+SM;IAOI,uCAAA;ExE49SV;EwEn+SM;IAOI,sCAAA;ExE+9SV;EwEt+SM;IAOI,iCAAA;ExEk+SV;EwEz+SM;IAOI,2BAAA;ExEq+SV;EwE5+SM;IAOI,iCAAA;ExEw+SV;EwE/+SM;IAOI,+BAAA;ExE2+SV;EwEl/SM;IAOI,6BAAA;ExE8+SV;EwEr/SM;IAOI,+BAAA;ExEi/SV;EwEx/SM;IAOI,8BAAA;ExEo/SV;EwE3/SM;IAOI,oBAAA;ExEu/SV;EwE9/SM;IAOI,mBAAA;ExE0/SV;EwEjgTM;IAOI,mBAAA;ExE6/SV;EwEpgTM;IAOI,mBAAA;ExEggTV;EwEvgTM;IAOI,mBAAA;ExEmgTV;EwE1gTM;IAOI,mBAAA;ExEsgTV;EwE7gTM;IAOI,mBAAA;ExEygTV;EwEhhTM;IAOI,mBAAA;ExE4gTV;EwEnhTM;IAOI,oBAAA;ExE+gTV;EwEthTM;IAOI,0BAAA;ExEkhTV;EwEzhTM;IAOI,yBAAA;ExEqhTV;EwE5hTM;IAOI,uBAAA;ExEwhTV;EwE/hTM;IAOI,yBAAA;ExE2hTV;EwEliTM;IAOI,uBAAA;ExE8hTV;EwEriTM;IAOI,uBAAA;ExEiiTV;EwExiTM;IAOI,0BAAA;IAAA,yBAAA;ExEqiTV;EwE5iTM;IAOI,gCAAA;IAAA,+BAAA;ExEyiTV;EwEhjTM;IAOI,+BAAA;IAAA,8BAAA;ExE6iTV;EwEpjTM;IAOI,6BAAA;IAAA,4BAAA;ExEijTV;EwExjTM;IAOI,+BAAA;IAAA,8BAAA;ExEqjTV;EwE5jTM;IAOI,6BAAA;IAAA,4BAAA;ExEyjTV;EwEhkTM;IAOI,6BAAA;IAAA,4BAAA;ExE6jTV;EwEpkTM;IAOI,wBAAA;IAAA,2BAAA;ExEikTV;EwExkTM;IAOI,8BAAA;IAAA,iCAAA;ExEqkTV;EwE5kTM;IAOI,6BAAA;IAAA,gCAAA;ExEykTV;EwEhlTM;IAOI,2BAAA;IAAA,8BAAA;ExE6kTV;EwEplTM;IAOI,6BAAA;IAAA,gCAAA;ExEilTV;EwExlTM;IAOI,2BAAA;IAAA,8BAAA;ExEqlTV;EwE5lTM;IAOI,2BAAA;IAAA,8BAAA;ExEylTV;EwEhmTM;IAOI,wBAAA;ExE4lTV;EwEnmTM;IAOI,8BAAA;ExE+lTV;EwEtmTM;IAOI,6BAAA;ExEkmTV;EwEzmTM;IAOI,2BAAA;ExEqmTV;EwE5mTM;IAOI,6BAAA;ExEwmTV;EwE/mTM;IAOI,2BAAA;ExE2mTV;EwElnTM;IAOI,2BAAA;ExE8mTV;EwErnTM;IAOI,0BAAA;ExEinTV;EwExnTM;IAOI,gCAAA;ExEonTV;EwE3nTM;IAOI,+BAAA;ExEunTV;EwE9nTM;IAOI,6BAAA;ExE0nTV;EwEjoTM;IAOI,+BAAA;ExE6nTV;EwEpoTM;IAOI,6BAAA;ExEgoTV;EwEvoTM;IAOI,6BAAA;ExEmoTV;EwE1oTM;IAOI,2BAAA;ExEsoTV;EwE7oTM;IAOI,iCAAA;ExEyoTV;EwEhpTM;IAOI,gCAAA;ExE4oTV;EwEnpTM;IAOI,8BAAA;ExE+oTV;EwEtpTM;IAOI,gCAAA;ExEkpTV;EwEzpTM;IAOI,8BAAA;ExEqpTV;EwE5pTM;IAOI,8BAAA;ExEwpTV;EwE/pTM;IAOI,yBAAA;ExE2pTV;EwElqTM;IAOI,+BAAA;ExE8pTV;EwErqTM;IAOI,8BAAA;ExEiqTV;EwExqTM;IAOI,4BAAA;ExEoqTV;EwE3qTM;IAOI,8BAAA;ExEuqTV;EwE9qTM;IAOI,4BAAA;ExE0qTV;EwEjrTM;IAOI,4BAAA;ExE6qTV;EwEprTM;IAOI,qBAAA;ExEgrTV;EwEvrTM;IAOI,2BAAA;ExEmrTV;EwE1rTM;IAOI,0BAAA;ExEsrTV;EwE7rTM;IAOI,wBAAA;ExEyrTV;EwEhsTM;IAOI,0BAAA;ExE4rTV;EwEnsTM;IAOI,wBAAA;ExE+rTV;EwEtsTM;IAOI,2BAAA;IAAA,0BAAA;ExEmsTV;EwE1sTM;IAOI,iCAAA;IAAA,gCAAA;ExEusTV;EwE9sTM;IAOI,gCAAA;IAAA,+BAAA;ExE2sTV;EwEltTM;IAOI,8BAAA;IAAA,6BAAA;ExE+sTV;EwEttTM;IAOI,gCAAA;IAAA,+BAAA;ExEmtTV;EwE1tTM;IAOI,8BAAA;IAAA,6BAAA;ExEutTV;EwE9tTM;IAOI,yBAAA;IAAA,4BAAA;ExE2tTV;EwEluTM;IAOI,+BAAA;IAAA,kCAAA;ExE+tTV;EwEtuTM;IAOI,8BAAA;IAAA,iCAAA;ExEmuTV;EwE1uTM;IAOI,4BAAA;IAAA,+BAAA;ExEuuTV;EwE9uTM;IAOI,8BAAA;IAAA,iCAAA;ExE2uTV;EwElvTM;IAOI,4BAAA;IAAA,+BAAA;ExE+uTV;EwEtvTM;IAOI,yBAAA;ExEkvTV;EwEzvTM;IAOI,+BAAA;ExEqvTV;EwE5vTM;IAOI,8BAAA;ExEwvTV;EwE/vTM;IAOI,4BAAA;ExE2vTV;EwElwTM;IAOI,8BAAA;ExE8vTV;EwErwTM;IAOI,4BAAA;ExEiwTV;EwExwTM;IAOI,2BAAA;ExEowTV;EwE3wTM;IAOI,iCAAA;ExEuwTV;EwE9wTM;IAOI,gCAAA;ExE0wTV;EwEjxTM;IAOI,8BAAA;ExE6wTV;EwEpxTM;IAOI,gCAAA;ExEgxTV;EwEvxTM;IAOI,8BAAA;ExEmxTV;EwE1xTM;IAOI,4BAAA;ExEsxTV;EwE7xTM;IAOI,kCAAA;ExEyxTV;EwEhyTM;IAOI,iCAAA;ExE4xTV;EwEnyTM;IAOI,+BAAA;ExE+xTV;EwEtyTM;IAOI,iCAAA;ExEkyTV;EwEzyTM;IAOI,+BAAA;ExEqyTV;EwE5yTM;IAOI,0BAAA;ExEwyTV;EwE/yTM;IAOI,gCAAA;ExE2yTV;EwElzTM;IAOI,+BAAA;ExE8yTV;EwErzTM;IAOI,6BAAA;ExEizTV;EwExzTM;IAOI,+BAAA;ExEozTV;EwE3zTM;IAOI,6BAAA;ExEuzTV;EwE9zTM;IAOI,iBAAA;ExE0zTV;EwEj0TM;IAOI,uBAAA;ExE6zTV;EwEp0TM;IAOI,sBAAA;ExEg0TV;EwEv0TM;IAOI,oBAAA;ExEm0TV;EwE10TM;IAOI,sBAAA;ExEs0TV;EwE70TM;IAOI,oBAAA;ExEy0TV;EwEh1TM;IAOI,qBAAA;ExE40TV;EwEn1TM;IAOI,2BAAA;ExE+0TV;EwEt1TM;IAOI,0BAAA;ExEk1TV;EwEz1TM;IAOI,wBAAA;ExEq1TV;EwE51TM;IAOI,0BAAA;ExEw1TV;EwE/1TM;IAOI,wBAAA;ExE21TV;EwEl2TM;IAOI,wBAAA;ExE81TV;EwEr2TM;IAOI,8BAAA;ExEi2TV;EwEx2TM;IAOI,6BAAA;ExEo2TV;EwE32TM;IAOI,2BAAA;ExEu2TV;EwE92TM;IAOI,6BAAA;ExE02TV;EwEj3TM;IAOI,2BAAA;ExE62TV;EwEp3TM;IAOI,2BAAA;ExEg3TV;EwEv3TM;IAOI,4BAAA;ExEm3TV;EwE13TM;IAOI,6BAAA;ExEs3TV;AACF;Acj4TI;E0DGI;IAOI,sBAAA;ExE23TV;EwEl4TM;IAOI,uBAAA;ExE83TV;EwEr4TM;IAOI,sBAAA;ExEi4TV;EwEx4TM;IAOI,8BAAA;ExEo4TV;EwE34TM;IAOI,4BAAA;ExEu4TV;EwE94TM;IAOI,2BAAA;ExE04TV;EwEj5TM;IAOI,iCAAA;ExE64TV;EwEp5TM;IAOI,2BAAA;ExEg5TV;EwEv5TM;IAOI,0BAAA;ExEm5TV;EwE15TM;IAOI,gCAAA;ExEs5TV;EwE75TM;IAOI,yBAAA;ExEy5TV;EwEh6TM;IAOI,wBAAA;ExE45TV;EwEn6TM;IAOI,+BAAA;ExE+5TV;EwEt6TM;IAOI,yBAAA;ExEk6TV;EwEz6TM;IAOI,6BAAA;ExEq6TV;EwE56TM;IAOI,8BAAA;ExEw6TV;EwE/6TM;IAOI,wBAAA;ExE26TV;EwEl7TM;IAOI,+BAAA;ExE86TV;EwEr7TM;IAOI,wBAAA;ExEi7TV;EwEx7TM;IAOI,yBAAA;ExEo7TV;EwE37TM;IAOI,8BAAA;ExEu7TV;EwE97TM;IAOI,iCAAA;ExE07TV;EwEj8TM;IAOI,sCAAA;ExE67TV;EwEp8TM;IAOI,yCAAA;ExEg8TV;EwEv8TM;IAOI,uBAAA;ExEm8TV;EwE18TM;IAOI,uBAAA;ExEs8TV;EwE78TM;IAOI,yBAAA;ExEy8TV;EwEh9TM;IAOI,yBAAA;ExE48TV;EwEn9TM;IAOI,0BAAA;ExE+8TV;EwEt9TM;IAOI,4BAAA;ExEk9TV;EwEz9TM;IAOI,kCAAA;ExEq9TV;EwE59TM;IAOI,sCAAA;ExEw9TV;EwE/9TM;IAOI,oCAAA;ExE29TV;EwEl+TM;IAOI,kCAAA;ExE89TV;EwEr+TM;IAOI,yCAAA;ExEi+TV;EwEx+TM;IAOI,wCAAA;ExEo+TV;EwE3+TM;IAOI,wCAAA;ExEu+TV;EwE9+TM;IAOI,kCAAA;ExE0+TV;EwEj/TM;IAOI,gCAAA;ExE6+TV;EwEp/TM;IAOI,8BAAA;ExEg/TV;EwEv/TM;IAOI,gCAAA;ExEm/TV;EwE1/TM;IAOI,+BAAA;ExEs/TV;EwE7/TM;IAOI,oCAAA;ExEy/TV;EwEhgUM;IAOI,kCAAA;ExE4/TV;EwEngUM;IAOI,gCAAA;ExE+/TV;EwEtgUM;IAOI,uCAAA;ExEkgUV;EwEzgUM;IAOI,sCAAA;ExEqgUV;EwE5gUM;IAOI,iCAAA;ExEwgUV;EwE/gUM;IAOI,2BAAA;ExE2gUV;EwElhUM;IAOI,iCAAA;ExE8gUV;EwErhUM;IAOI,+BAAA;ExEihUV;EwExhUM;IAOI,6BAAA;ExEohUV;EwE3hUM;IAOI,+BAAA;ExEuhUV;EwE9hUM;IAOI,8BAAA;ExE0hUV;EwEjiUM;IAOI,oBAAA;ExE6hUV;EwEpiUM;IAOI,mBAAA;ExEgiUV;EwEviUM;IAOI,mBAAA;ExEmiUV;EwE1iUM;IAOI,mBAAA;ExEsiUV;EwE7iUM;IAOI,mBAAA;ExEyiUV;EwEhjUM;IAOI,mBAAA;ExE4iUV;EwEnjUM;IAOI,mBAAA;ExE+iUV;EwEtjUM;IAOI,mBAAA;ExEkjUV;EwEzjUM;IAOI,oBAAA;ExEqjUV;EwE5jUM;IAOI,0BAAA;ExEwjUV;EwE/jUM;IAOI,yBAAA;ExE2jUV;EwElkUM;IAOI,uBAAA;ExE8jUV;EwErkUM;IAOI,yBAAA;ExEikUV;EwExkUM;IAOI,uBAAA;ExEokUV;EwE3kUM;IAOI,uBAAA;ExEukUV;EwE9kUM;IAOI,0BAAA;IAAA,yBAAA;ExE2kUV;EwEllUM;IAOI,gCAAA;IAAA,+BAAA;ExE+kUV;EwEtlUM;IAOI,+BAAA;IAAA,8BAAA;ExEmlUV;EwE1lUM;IAOI,6BAAA;IAAA,4BAAA;ExEulUV;EwE9lUM;IAOI,+BAAA;IAAA,8BAAA;ExE2lUV;EwElmUM;IAOI,6BAAA;IAAA,4BAAA;ExE+lUV;EwEtmUM;IAOI,6BAAA;IAAA,4BAAA;ExEmmUV;EwE1mUM;IAOI,wBAAA;IAAA,2BAAA;ExEumUV;EwE9mUM;IAOI,8BAAA;IAAA,iCAAA;ExE2mUV;EwElnUM;IAOI,6BAAA;IAAA,gCAAA;ExE+mUV;EwEtnUM;IAOI,2BAAA;IAAA,8BAAA;ExEmnUV;EwE1nUM;IAOI,6BAAA;IAAA,gCAAA;ExEunUV;EwE9nUM;IAOI,2BAAA;IAAA,8BAAA;ExE2nUV;EwEloUM;IAOI,2BAAA;IAAA,8BAAA;ExE+nUV;EwEtoUM;IAOI,wBAAA;ExEkoUV;EwEzoUM;IAOI,8BAAA;ExEqoUV;EwE5oUM;IAOI,6BAAA;ExEwoUV;EwE/oUM;IAOI,2BAAA;ExE2oUV;EwElpUM;IAOI,6BAAA;ExE8oUV;EwErpUM;IAOI,2BAAA;ExEipUV;EwExpUM;IAOI,2BAAA;ExEopUV;EwE3pUM;IAOI,0BAAA;ExEupUV;EwE9pUM;IAOI,gCAAA;ExE0pUV;EwEjqUM;IAOI,+BAAA;ExE6pUV;EwEpqUM;IAOI,6BAAA;ExEgqUV;EwEvqUM;IAOI,+BAAA;ExEmqUV;EwE1qUM;IAOI,6BAAA;ExEsqUV;EwE7qUM;IAOI,6BAAA;ExEyqUV;EwEhrUM;IAOI,2BAAA;ExE4qUV;EwEnrUM;IAOI,iCAAA;ExE+qUV;EwEtrUM;IAOI,gCAAA;ExEkrUV;EwEzrUM;IAOI,8BAAA;ExEqrUV;EwE5rUM;IAOI,gCAAA;ExEwrUV;EwE/rUM;IAOI,8BAAA;ExE2rUV;EwElsUM;IAOI,8BAAA;ExE8rUV;EwErsUM;IAOI,yBAAA;ExEisUV;EwExsUM;IAOI,+BAAA;ExEosUV;EwE3sUM;IAOI,8BAAA;ExEusUV;EwE9sUM;IAOI,4BAAA;ExE0sUV;EwEjtUM;IAOI,8BAAA;ExE6sUV;EwEptUM;IAOI,4BAAA;ExEgtUV;EwEvtUM;IAOI,4BAAA;ExEmtUV;EwE1tUM;IAOI,qBAAA;ExEstUV;EwE7tUM;IAOI,2BAAA;ExEytUV;EwEhuUM;IAOI,0BAAA;ExE4tUV;EwEnuUM;IAOI,wBAAA;ExE+tUV;EwEtuUM;IAOI,0BAAA;ExEkuUV;EwEzuUM;IAOI,wBAAA;ExEquUV;EwE5uUM;IAOI,2BAAA;IAAA,0BAAA;ExEyuUV;EwEhvUM;IAOI,iCAAA;IAAA,gCAAA;ExE6uUV;EwEpvUM;IAOI,gCAAA;IAAA,+BAAA;ExEivUV;EwExvUM;IAOI,8BAAA;IAAA,6BAAA;ExEqvUV;EwE5vUM;IAOI,gCAAA;IAAA,+BAAA;ExEyvUV;EwEhwUM;IAOI,8BAAA;IAAA,6BAAA;ExE6vUV;EwEpwUM;IAOI,yBAAA;IAAA,4BAAA;ExEiwUV;EwExwUM;IAOI,+BAAA;IAAA,kCAAA;ExEqwUV;EwE5wUM;IAOI,8BAAA;IAAA,iCAAA;ExEywUV;EwEhxUM;IAOI,4BAAA;IAAA,+BAAA;ExE6wUV;EwEpxUM;IAOI,8BAAA;IAAA,iCAAA;ExEixUV;EwExxUM;IAOI,4BAAA;IAAA,+BAAA;ExEqxUV;EwE5xUM;IAOI,yBAAA;ExEwxUV;EwE/xUM;IAOI,+BAAA;ExE2xUV;EwElyUM;IAOI,8BAAA;ExE8xUV;EwEryUM;IAOI,4BAAA;ExEiyUV;EwExyUM;IAOI,8BAAA;ExEoyUV;EwE3yUM;IAOI,4BAAA;ExEuyUV;EwE9yUM;IAOI,2BAAA;ExE0yUV;EwEjzUM;IAOI,iCAAA;ExE6yUV;EwEpzUM;IAOI,gCAAA;ExEgzUV;EwEvzUM;IAOI,8BAAA;ExEmzUV;EwE1zUM;IAOI,gCAAA;ExEszUV;EwE7zUM;IAOI,8BAAA;ExEyzUV;EwEh0UM;IAOI,4BAAA;ExE4zUV;EwEn0UM;IAOI,kCAAA;ExE+zUV;EwEt0UM;IAOI,iCAAA;ExEk0UV;EwEz0UM;IAOI,+BAAA;ExEq0UV;EwE50UM;IAOI,iCAAA;ExEw0UV;EwE/0UM;IAOI,+BAAA;ExE20UV;EwEl1UM;IAOI,0BAAA;ExE80UV;EwEr1UM;IAOI,gCAAA;ExEi1UV;EwEx1UM;IAOI,+BAAA;ExEo1UV;EwE31UM;IAOI,6BAAA;ExEu1UV;EwE91UM;IAOI,+BAAA;ExE01UV;EwEj2UM;IAOI,6BAAA;ExE61UV;EwEp2UM;IAOI,iBAAA;ExEg2UV;EwEv2UM;IAOI,uBAAA;ExEm2UV;EwE12UM;IAOI,sBAAA;ExEs2UV;EwE72UM;IAOI,oBAAA;ExEy2UV;EwEh3UM;IAOI,sBAAA;ExE42UV;EwEn3UM;IAOI,oBAAA;ExE+2UV;EwEt3UM;IAOI,qBAAA;ExEk3UV;EwEz3UM;IAOI,2BAAA;ExEq3UV;EwE53UM;IAOI,0BAAA;ExEw3UV;EwE/3UM;IAOI,wBAAA;ExE23UV;EwEl4UM;IAOI,0BAAA;ExE83UV;EwEr4UM;IAOI,wBAAA;ExEi4UV;EwEx4UM;IAOI,wBAAA;ExEo4UV;EwE34UM;IAOI,8BAAA;ExEu4UV;EwE94UM;IAOI,6BAAA;ExE04UV;EwEj5UM;IAOI,2BAAA;ExE64UV;EwEp5UM;IAOI,6BAAA;ExEg5UV;EwEv5UM;IAOI,2BAAA;ExEm5UV;EwE15UM;IAOI,2BAAA;ExEs5UV;EwE75UM;IAOI,4BAAA;ExEy5UV;EwEh6UM;IAOI,6BAAA;ExE45UV;AACF;Acv6UI;E0DGI;IAOI,sBAAA;ExEi6UV;EwEx6UM;IAOI,uBAAA;ExEo6UV;EwE36UM;IAOI,sBAAA;ExEu6UV;EwE96UM;IAOI,8BAAA;ExE06UV;EwEj7UM;IAOI,4BAAA;ExE66UV;EwEp7UM;IAOI,2BAAA;ExEg7UV;EwEv7UM;IAOI,iCAAA;ExEm7UV;EwE17UM;IAOI,2BAAA;ExEs7UV;EwE77UM;IAOI,0BAAA;ExEy7UV;EwEh8UM;IAOI,gCAAA;ExE47UV;EwEn8UM;IAOI,yBAAA;ExE+7UV;EwEt8UM;IAOI,wBAAA;ExEk8UV;EwEz8UM;IAOI,+BAAA;ExEq8UV;EwE58UM;IAOI,yBAAA;ExEw8UV;EwE/8UM;IAOI,6BAAA;ExE28UV;EwEl9UM;IAOI,8BAAA;ExE88UV;EwEr9UM;IAOI,wBAAA;ExEi9UV;EwEx9UM;IAOI,+BAAA;ExEo9UV;EwE39UM;IAOI,wBAAA;ExEu9UV;EwE99UM;IAOI,yBAAA;ExE09UV;EwEj+UM;IAOI,8BAAA;ExE69UV;EwEp+UM;IAOI,iCAAA;ExEg+UV;EwEv+UM;IAOI,sCAAA;ExEm+UV;EwE1+UM;IAOI,yCAAA;ExEs+UV;EwE7+UM;IAOI,uBAAA;ExEy+UV;EwEh/UM;IAOI,uBAAA;ExE4+UV;EwEn/UM;IAOI,yBAAA;ExE++UV;EwEt/UM;IAOI,yBAAA;ExEk/UV;EwEz/UM;IAOI,0BAAA;ExEq/UV;EwE5/UM;IAOI,4BAAA;ExEw/UV;EwE//UM;IAOI,kCAAA;ExE2/UV;EwElgVM;IAOI,sCAAA;ExE8/UV;EwErgVM;IAOI,oCAAA;ExEigVV;EwExgVM;IAOI,kCAAA;ExEogVV;EwE3gVM;IAOI,yCAAA;ExEugVV;EwE9gVM;IAOI,wCAAA;ExE0gVV;EwEjhVM;IAOI,wCAAA;ExE6gVV;EwEphVM;IAOI,kCAAA;ExEghVV;EwEvhVM;IAOI,gCAAA;ExEmhVV;EwE1hVM;IAOI,8BAAA;ExEshVV;EwE7hVM;IAOI,gCAAA;ExEyhVV;EwEhiVM;IAOI,+BAAA;ExE4hVV;EwEniVM;IAOI,oCAAA;ExE+hVV;EwEtiVM;IAOI,kCAAA;ExEkiVV;EwEziVM;IAOI,gCAAA;ExEqiVV;EwE5iVM;IAOI,uCAAA;ExEwiVV;EwE/iVM;IAOI,sCAAA;ExE2iVV;EwEljVM;IAOI,iCAAA;ExE8iVV;EwErjVM;IAOI,2BAAA;ExEijVV;EwExjVM;IAOI,iCAAA;ExEojVV;EwE3jVM;IAOI,+BAAA;ExEujVV;EwE9jVM;IAOI,6BAAA;ExE0jVV;EwEjkVM;IAOI,+BAAA;ExE6jVV;EwEpkVM;IAOI,8BAAA;ExEgkVV;EwEvkVM;IAOI,oBAAA;ExEmkVV;EwE1kVM;IAOI,mBAAA;ExEskVV;EwE7kVM;IAOI,mBAAA;ExEykVV;EwEhlVM;IAOI,mBAAA;ExE4kVV;EwEnlVM;IAOI,mBAAA;ExE+kVV;EwEtlVM;IAOI,mBAAA;ExEklVV;EwEzlVM;IAOI,mBAAA;ExEqlVV;EwE5lVM;IAOI,mBAAA;ExEwlVV;EwE/lVM;IAOI,oBAAA;ExE2lVV;EwElmVM;IAOI,0BAAA;ExE8lVV;EwErmVM;IAOI,yBAAA;ExEimVV;EwExmVM;IAOI,uBAAA;ExEomVV;EwE3mVM;IAOI,yBAAA;ExEumVV;EwE9mVM;IAOI,uBAAA;ExE0mVV;EwEjnVM;IAOI,uBAAA;ExE6mVV;EwEpnVM;IAOI,0BAAA;IAAA,yBAAA;ExEinVV;EwExnVM;IAOI,gCAAA;IAAA,+BAAA;ExEqnVV;EwE5nVM;IAOI,+BAAA;IAAA,8BAAA;ExEynVV;EwEhoVM;IAOI,6BAAA;IAAA,4BAAA;ExE6nVV;EwEpoVM;IAOI,+BAAA;IAAA,8BAAA;ExEioVV;EwExoVM;IAOI,6BAAA;IAAA,4BAAA;ExEqoVV;EwE5oVM;IAOI,6BAAA;IAAA,4BAAA;ExEyoVV;EwEhpVM;IAOI,wBAAA;IAAA,2BAAA;ExE6oVV;EwEppVM;IAOI,8BAAA;IAAA,iCAAA;ExEipVV;EwExpVM;IAOI,6BAAA;IAAA,gCAAA;ExEqpVV;EwE5pVM;IAOI,2BAAA;IAAA,8BAAA;ExEypVV;EwEhqVM;IAOI,6BAAA;IAAA,gCAAA;ExE6pVV;EwEpqVM;IAOI,2BAAA;IAAA,8BAAA;ExEiqVV;EwExqVM;IAOI,2BAAA;IAAA,8BAAA;ExEqqVV;EwE5qVM;IAOI,wBAAA;ExEwqVV;EwE/qVM;IAOI,8BAAA;ExE2qVV;EwElrVM;IAOI,6BAAA;ExE8qVV;EwErrVM;IAOI,2BAAA;ExEirVV;EwExrVM;IAOI,6BAAA;ExEorVV;EwE3rVM;IAOI,2BAAA;ExEurVV;EwE9rVM;IAOI,2BAAA;ExE0rVV;EwEjsVM;IAOI,0BAAA;ExE6rVV;EwEpsVM;IAOI,gCAAA;ExEgsVV;EwEvsVM;IAOI,+BAAA;ExEmsVV;EwE1sVM;IAOI,6BAAA;ExEssVV;EwE7sVM;IAOI,+BAAA;ExEysVV;EwEhtVM;IAOI,6BAAA;ExE4sVV;EwEntVM;IAOI,6BAAA;ExE+sVV;EwEttVM;IAOI,2BAAA;ExEktVV;EwEztVM;IAOI,iCAAA;ExEqtVV;EwE5tVM;IAOI,gCAAA;ExEwtVV;EwE/tVM;IAOI,8BAAA;ExE2tVV;EwEluVM;IAOI,gCAAA;ExE8tVV;EwEruVM;IAOI,8BAAA;ExEiuVV;EwExuVM;IAOI,8BAAA;ExEouVV;EwE3uVM;IAOI,yBAAA;ExEuuVV;EwE9uVM;IAOI,+BAAA;ExE0uVV;EwEjvVM;IAOI,8BAAA;ExE6uVV;EwEpvVM;IAOI,4BAAA;ExEgvVV;EwEvvVM;IAOI,8BAAA;ExEmvVV;EwE1vVM;IAOI,4BAAA;ExEsvVV;EwE7vVM;IAOI,4BAAA;ExEyvVV;EwEhwVM;IAOI,qBAAA;ExE4vVV;EwEnwVM;IAOI,2BAAA;ExE+vVV;EwEtwVM;IAOI,0BAAA;ExEkwVV;EwEzwVM;IAOI,wBAAA;ExEqwVV;EwE5wVM;IAOI,0BAAA;ExEwwVV;EwE/wVM;IAOI,wBAAA;ExE2wVV;EwElxVM;IAOI,2BAAA;IAAA,0BAAA;ExE+wVV;EwEtxVM;IAOI,iCAAA;IAAA,gCAAA;ExEmxVV;EwE1xVM;IAOI,gCAAA;IAAA,+BAAA;ExEuxVV;EwE9xVM;IAOI,8BAAA;IAAA,6BAAA;ExE2xVV;EwElyVM;IAOI,gCAAA;IAAA,+BAAA;ExE+xVV;EwEtyVM;IAOI,8BAAA;IAAA,6BAAA;ExEmyVV;EwE1yVM;IAOI,yBAAA;IAAA,4BAAA;ExEuyVV;EwE9yVM;IAOI,+BAAA;IAAA,kCAAA;ExE2yVV;EwElzVM;IAOI,8BAAA;IAAA,iCAAA;ExE+yVV;EwEtzVM;IAOI,4BAAA;IAAA,+BAAA;ExEmzVV;EwE1zVM;IAOI,8BAAA;IAAA,iCAAA;ExEuzVV;EwE9zVM;IAOI,4BAAA;IAAA,+BAAA;ExE2zVV;EwEl0VM;IAOI,yBAAA;ExE8zVV;EwEr0VM;IAOI,+BAAA;ExEi0VV;EwEx0VM;IAOI,8BAAA;ExEo0VV;EwE30VM;IAOI,4BAAA;ExEu0VV;EwE90VM;IAOI,8BAAA;ExE00VV;EwEj1VM;IAOI,4BAAA;ExE60VV;EwEp1VM;IAOI,2BAAA;ExEg1VV;EwEv1VM;IAOI,iCAAA;ExEm1VV;EwE11VM;IAOI,gCAAA;ExEs1VV;EwE71VM;IAOI,8BAAA;ExEy1VV;EwEh2VM;IAOI,gCAAA;ExE41VV;EwEn2VM;IAOI,8BAAA;ExE+1VV;EwEt2VM;IAOI,4BAAA;ExEk2VV;EwEz2VM;IAOI,kCAAA;ExEq2VV;EwE52VM;IAOI,iCAAA;ExEw2VV;EwE/2VM;IAOI,+BAAA;ExE22VV;EwEl3VM;IAOI,iCAAA;ExE82VV;EwEr3VM;IAOI,+BAAA;ExEi3VV;EwEx3VM;IAOI,0BAAA;ExEo3VV;EwE33VM;IAOI,gCAAA;ExEu3VV;EwE93VM;IAOI,+BAAA;ExE03VV;EwEj4VM;IAOI,6BAAA;ExE63VV;EwEp4VM;IAOI,+BAAA;ExEg4VV;EwEv4VM;IAOI,6BAAA;ExEm4VV;EwE14VM;IAOI,iBAAA;ExEs4VV;EwE74VM;IAOI,uBAAA;ExEy4VV;EwEh5VM;IAOI,sBAAA;ExE44VV;EwEn5VM;IAOI,oBAAA;ExE+4VV;EwEt5VM;IAOI,sBAAA;ExEk5VV;EwEz5VM;IAOI,oBAAA;ExEq5VV;EwE55VM;IAOI,qBAAA;ExEw5VV;EwE/5VM;IAOI,2BAAA;ExE25VV;EwEl6VM;IAOI,0BAAA;ExE85VV;EwEr6VM;IAOI,wBAAA;ExEi6VV;EwEx6VM;IAOI,0BAAA;ExEo6VV;EwE36VM;IAOI,wBAAA;ExEu6VV;EwE96VM;IAOI,wBAAA;ExE06VV;EwEj7VM;IAOI,8BAAA;ExE66VV;EwEp7VM;IAOI,6BAAA;ExEg7VV;EwEv7VM;IAOI,2BAAA;ExEm7VV;EwE17VM;IAOI,6BAAA;ExEs7VV;EwE77VM;IAOI,2BAAA;ExEy7VV;EwEh8VM;IAOI,2BAAA;ExE47VV;EwEn8VM;IAOI,4BAAA;ExE+7VV;EwEt8VM;IAOI,6BAAA;ExEk8VV;AACF;Ac78VI;E0DGI;IAOI,sBAAA;ExEu8VV;EwE98VM;IAOI,uBAAA;ExE08VV;EwEj9VM;IAOI,sBAAA;ExE68VV;EwEp9VM;IAOI,8BAAA;ExEg9VV;EwEv9VM;IAOI,4BAAA;ExEm9VV;EwE19VM;IAOI,2BAAA;ExEs9VV;EwE79VM;IAOI,iCAAA;ExEy9VV;EwEh+VM;IAOI,2BAAA;ExE49VV;EwEn+VM;IAOI,0BAAA;ExE+9VV;EwEt+VM;IAOI,gCAAA;ExEk+VV;EwEz+VM;IAOI,yBAAA;ExEq+VV;EwE5+VM;IAOI,wBAAA;ExEw+VV;EwE/+VM;IAOI,+BAAA;ExE2+VV;EwEl/VM;IAOI,yBAAA;ExE8+VV;EwEr/VM;IAOI,6BAAA;ExEi/VV;EwEx/VM;IAOI,8BAAA;ExEo/VV;EwE3/VM;IAOI,wBAAA;ExEu/VV;EwE9/VM;IAOI,+BAAA;ExE0/VV;EwEjgWM;IAOI,wBAAA;ExE6/VV;EwEpgWM;IAOI,yBAAA;ExEggWV;EwEvgWM;IAOI,8BAAA;ExEmgWV;EwE1gWM;IAOI,iCAAA;ExEsgWV;EwE7gWM;IAOI,sCAAA;ExEygWV;EwEhhWM;IAOI,yCAAA;ExE4gWV;EwEnhWM;IAOI,uBAAA;ExE+gWV;EwEthWM;IAOI,uBAAA;ExEkhWV;EwEzhWM;IAOI,yBAAA;ExEqhWV;EwE5hWM;IAOI,yBAAA;ExEwhWV;EwE/hWM;IAOI,0BAAA;ExE2hWV;EwEliWM;IAOI,4BAAA;ExE8hWV;EwEriWM;IAOI,kCAAA;ExEiiWV;EwExiWM;IAOI,sCAAA;ExEoiWV;EwE3iWM;IAOI,oCAAA;ExEuiWV;EwE9iWM;IAOI,kCAAA;ExE0iWV;EwEjjWM;IAOI,yCAAA;ExE6iWV;EwEpjWM;IAOI,wCAAA;ExEgjWV;EwEvjWM;IAOI,wCAAA;ExEmjWV;EwE1jWM;IAOI,kCAAA;ExEsjWV;EwE7jWM;IAOI,gCAAA;ExEyjWV;EwEhkWM;IAOI,8BAAA;ExE4jWV;EwEnkWM;IAOI,gCAAA;ExE+jWV;EwEtkWM;IAOI,+BAAA;ExEkkWV;EwEzkWM;IAOI,oCAAA;ExEqkWV;EwE5kWM;IAOI,kCAAA;ExEwkWV;EwE/kWM;IAOI,gCAAA;ExE2kWV;EwEllWM;IAOI,uCAAA;ExE8kWV;EwErlWM;IAOI,sCAAA;ExEilWV;EwExlWM;IAOI,iCAAA;ExEolWV;EwE3lWM;IAOI,2BAAA;ExEulWV;EwE9lWM;IAOI,iCAAA;ExE0lWV;EwEjmWM;IAOI,+BAAA;ExE6lWV;EwEpmWM;IAOI,6BAAA;ExEgmWV;EwEvmWM;IAOI,+BAAA;ExEmmWV;EwE1mWM;IAOI,8BAAA;ExEsmWV;EwE7mWM;IAOI,oBAAA;ExEymWV;EwEhnWM;IAOI,mBAAA;ExE4mWV;EwEnnWM;IAOI,mBAAA;ExE+mWV;EwEtnWM;IAOI,mBAAA;ExEknWV;EwEznWM;IAOI,mBAAA;ExEqnWV;EwE5nWM;IAOI,mBAAA;ExEwnWV;EwE/nWM;IAOI,mBAAA;ExE2nWV;EwEloWM;IAOI,mBAAA;ExE8nWV;EwEroWM;IAOI,oBAAA;ExEioWV;EwExoWM;IAOI,0BAAA;ExEooWV;EwE3oWM;IAOI,yBAAA;ExEuoWV;EwE9oWM;IAOI,uBAAA;ExE0oWV;EwEjpWM;IAOI,yBAAA;ExE6oWV;EwEppWM;IAOI,uBAAA;ExEgpWV;EwEvpWM;IAOI,uBAAA;ExEmpWV;EwE1pWM;IAOI,0BAAA;IAAA,yBAAA;ExEupWV;EwE9pWM;IAOI,gCAAA;IAAA,+BAAA;ExE2pWV;EwElqWM;IAOI,+BAAA;IAAA,8BAAA;ExE+pWV;EwEtqWM;IAOI,6BAAA;IAAA,4BAAA;ExEmqWV;EwE1qWM;IAOI,+BAAA;IAAA,8BAAA;ExEuqWV;EwE9qWM;IAOI,6BAAA;IAAA,4BAAA;ExE2qWV;EwElrWM;IAOI,6BAAA;IAAA,4BAAA;ExE+qWV;EwEtrWM;IAOI,wBAAA;IAAA,2BAAA;ExEmrWV;EwE1rWM;IAOI,8BAAA;IAAA,iCAAA;ExEurWV;EwE9rWM;IAOI,6BAAA;IAAA,gCAAA;ExE2rWV;EwElsWM;IAOI,2BAAA;IAAA,8BAAA;ExE+rWV;EwEtsWM;IAOI,6BAAA;IAAA,gCAAA;ExEmsWV;EwE1sWM;IAOI,2BAAA;IAAA,8BAAA;ExEusWV;EwE9sWM;IAOI,2BAAA;IAAA,8BAAA;ExE2sWV;EwEltWM;IAOI,wBAAA;ExE8sWV;EwErtWM;IAOI,8BAAA;ExEitWV;EwExtWM;IAOI,6BAAA;ExEotWV;EwE3tWM;IAOI,2BAAA;ExEutWV;EwE9tWM;IAOI,6BAAA;ExE0tWV;EwEjuWM;IAOI,2BAAA;ExE6tWV;EwEpuWM;IAOI,2BAAA;ExEguWV;EwEvuWM;IAOI,0BAAA;ExEmuWV;EwE1uWM;IAOI,gCAAA;ExEsuWV;EwE7uWM;IAOI,+BAAA;ExEyuWV;EwEhvWM;IAOI,6BAAA;ExE4uWV;EwEnvWM;IAOI,+BAAA;ExE+uWV;EwEtvWM;IAOI,6BAAA;ExEkvWV;EwEzvWM;IAOI,6BAAA;ExEqvWV;EwE5vWM;IAOI,2BAAA;ExEwvWV;EwE/vWM;IAOI,iCAAA;ExE2vWV;EwElwWM;IAOI,gCAAA;ExE8vWV;EwErwWM;IAOI,8BAAA;ExEiwWV;EwExwWM;IAOI,gCAAA;ExEowWV;EwE3wWM;IAOI,8BAAA;ExEuwWV;EwE9wWM;IAOI,8BAAA;ExE0wWV;EwEjxWM;IAOI,yBAAA;ExE6wWV;EwEpxWM;IAOI,+BAAA;ExEgxWV;EwEvxWM;IAOI,8BAAA;ExEmxWV;EwE1xWM;IAOI,4BAAA;ExEsxWV;EwE7xWM;IAOI,8BAAA;ExEyxWV;EwEhyWM;IAOI,4BAAA;ExE4xWV;EwEnyWM;IAOI,4BAAA;ExE+xWV;EwEtyWM;IAOI,qBAAA;ExEkyWV;EwEzyWM;IAOI,2BAAA;ExEqyWV;EwE5yWM;IAOI,0BAAA;ExEwyWV;EwE/yWM;IAOI,wBAAA;ExE2yWV;EwElzWM;IAOI,0BAAA;ExE8yWV;EwErzWM;IAOI,wBAAA;ExEizWV;EwExzWM;IAOI,2BAAA;IAAA,0BAAA;ExEqzWV;EwE5zWM;IAOI,iCAAA;IAAA,gCAAA;ExEyzWV;EwEh0WM;IAOI,gCAAA;IAAA,+BAAA;ExE6zWV;EwEp0WM;IAOI,8BAAA;IAAA,6BAAA;ExEi0WV;EwEx0WM;IAOI,gCAAA;IAAA,+BAAA;ExEq0WV;EwE50WM;IAOI,8BAAA;IAAA,6BAAA;ExEy0WV;EwEh1WM;IAOI,yBAAA;IAAA,4BAAA;ExE60WV;EwEp1WM;IAOI,+BAAA;IAAA,kCAAA;ExEi1WV;EwEx1WM;IAOI,8BAAA;IAAA,iCAAA;ExEq1WV;EwE51WM;IAOI,4BAAA;IAAA,+BAAA;ExEy1WV;EwEh2WM;IAOI,8BAAA;IAAA,iCAAA;ExE61WV;EwEp2WM;IAOI,4BAAA;IAAA,+BAAA;ExEi2WV;EwEx2WM;IAOI,yBAAA;ExEo2WV;EwE32WM;IAOI,+BAAA;ExEu2WV;EwE92WM;IAOI,8BAAA;ExE02WV;EwEj3WM;IAOI,4BAAA;ExE62WV;EwEp3WM;IAOI,8BAAA;ExEg3WV;EwEv3WM;IAOI,4BAAA;ExEm3WV;EwE13WM;IAOI,2BAAA;ExEs3WV;EwE73WM;IAOI,iCAAA;ExEy3WV;EwEh4WM;IAOI,gCAAA;ExE43WV;EwEn4WM;IAOI,8BAAA;ExE+3WV;EwEt4WM;IAOI,gCAAA;ExEk4WV;EwEz4WM;IAOI,8BAAA;ExEq4WV;EwE54WM;IAOI,4BAAA;ExEw4WV;EwE/4WM;IAOI,kCAAA;ExE24WV;EwEl5WM;IAOI,iCAAA;ExE84WV;EwEr5WM;IAOI,+BAAA;ExEi5WV;EwEx5WM;IAOI,iCAAA;ExEo5WV;EwE35WM;IAOI,+BAAA;ExEu5WV;EwE95WM;IAOI,0BAAA;ExE05WV;EwEj6WM;IAOI,gCAAA;ExE65WV;EwEp6WM;IAOI,+BAAA;ExEg6WV;EwEv6WM;IAOI,6BAAA;ExEm6WV;EwE16WM;IAOI,+BAAA;ExEs6WV;EwE76WM;IAOI,6BAAA;ExEy6WV;EwEh7WM;IAOI,iBAAA;ExE46WV;EwEn7WM;IAOI,uBAAA;ExE+6WV;EwEt7WM;IAOI,sBAAA;ExEk7WV;EwEz7WM;IAOI,oBAAA;ExEq7WV;EwE57WM;IAOI,sBAAA;ExEw7WV;EwE/7WM;IAOI,oBAAA;ExE27WV;EwEl8WM;IAOI,qBAAA;ExE87WV;EwEr8WM;IAOI,2BAAA;ExEi8WV;EwEx8WM;IAOI,0BAAA;ExEo8WV;EwE38WM;IAOI,wBAAA;ExEu8WV;EwE98WM;IAOI,0BAAA;ExE08WV;EwEj9WM;IAOI,wBAAA;ExE68WV;EwEp9WM;IAOI,wBAAA;ExEg9WV;EwEv9WM;IAOI,8BAAA;ExEm9WV;EwE19WM;IAOI,6BAAA;ExEs9WV;EwE79WM;IAOI,2BAAA;ExEy9WV;EwEh+WM;IAOI,6BAAA;ExE49WV;EwEn+WM;IAOI,2BAAA;ExE+9WV;EwEt+WM;IAOI,2BAAA;ExEk+WV;EwEz+WM;IAOI,4BAAA;ExEq+WV;EwE5+WM;IAOI,6BAAA;ExEw+WV;AACF;AyE/hXA;ED+CQ;IAOI,4BAAA;ExE6+WV;EwEp/WM;IAOI,0BAAA;ExEg/WV;EwEv/WM;IAOI,6BAAA;ExEm/WV;EwE1/WM;IAOI,4BAAA;ExEs/WV;AACF;AyE1hXA;ED4BQ;IAOI,0BAAA;ExE2/WV;EwElgXM;IAOI,gCAAA;ExE8/WV;EwErgXM;IAOI,yBAAA;ExEigXV;EwExgXM;IAOI,wBAAA;ExEogXV;EwE3gXM;IAOI,+BAAA;ExEugXV;EwE9gXM;IAOI,yBAAA;ExE0gXV;EwEjhXM;IAOI,6BAAA;ExE6gXV;EwEphXM;IAOI,8BAAA;ExEghXV;EwEvhXM;IAOI,wBAAA;ExEmhXV;EwE1hXM;IAOI,+BAAA;ExEshXV;EwE7hXM;IAOI,wBAAA;ExEyhXV;AACF;A0EnmXA;;;;;;;;;;;EAAA;AAiBA;EACE,wBAAA;EACA,0BAAA;EACA,4CAAA;EACA,0BAAA;EACA,uBAAA;EACA,0BAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,oCAAA;EACA,0CAAA;EACA,8CAAA;EACA,6CAAA;EACA,8CAAA;EACA,wBAAA;EACA,yCAAA;EACA,2BAAA;EACA,oBAAA;EACA,4BAAA;EACA,yBAAA;EACA,6BAAA;EAEA,0CAAA;EACA,iDAAA;EACA,qDAAA;EACA,8CAAA;EACA,gDAAA;EACA,oDAAA;A1E+lXF;;A0E5lXA;;EAEE,0CAAA;EACA,0BAAA;EACA,mBAAA;EACA,gBAAA;EACA,0CAAA;EACA,iBAAA;EACA,uBAAA;EACA,wBAAA;EACA,wBAAA;EACA,2CAAA;EACA,mCAAA;EACA,+BAAA;EACA,+BAAA;EACA,mBAAA;A1E+lXF;;A2E9pXA;;4BAAA;AAGA;EACE,+BAAA;A3EiqXF;;A2E/pXA;EACE,6BAAA;A3EkqXF;;A2E/pXE;EACE,aCRyB;EDSzB,YAAA;A3EkqXJ;;A2E/pXA;EACE,yCAAA;A3EkqXF;;A2EhqXA;EACE,iCAAA;A3EmqXF;;A2E9pXE;;EACE,yBAAA;EACA,qBAAA;A3EkqXJ;;A2E9pXA,mCAAA;AAIE;EACE,YAAA;A3E8pXJ;;A2E/pXE;EACE,YAAA;A3EkqXJ;;A2EnqXE;EACE,aAAA;A3EsqXJ;;A2EvqXE;EACE,aAAA;A3E0qXJ;;A2E3qXE;EACE,aAAA;A3E8qXJ;;A2E/qXE;EACE,aAAA;A3EkrXJ;;A2EnrXE;EACE,aAAA;A3EsrXJ;;A2EvrXE;EACE,aAAA;A3E0rXJ;;A2E3rXE;EACE,aAAA;A3E8rXJ;;A2E/rXE;EACE,aAAA;A3EksXJ;;A2EnsXE;EACE,aAAA;A3EssXJ;;A2EhsXA,iCAAA;AAEA,wCAAA;AAIE;EACE,iBAAA;A3E+rXJ;;A2EhsXE;EACE,iBAAA;A3EmsXJ;;A2EpsXE;EACE,kBAAA;A3EusXJ;;A2ExsXE;EACE,kBAAA;A3E2sXJ;;A2E5sXE;EACE,kBAAA;A3E+sXJ;;A2EhtXE;EACE,kBAAA;A3EmtXJ;;A2EptXE;EACE,kBAAA;A3EutXJ;;A2ExtXE;EACE,kBAAA;A3E2tXJ;;A2E5tXE;EACE,kBAAA;A3E+tXJ;;A2EhuXE;EACE,kBAAA;A3EmuXJ;;A2EpuXE;EACE,kBAAA;A3EuuXJ;;A2EjuXA,sCAAA;AAEA,uCAAA;AAIE;EACE,2BAAA;A3EguXJ;;A2EjuXE;EACE,2BAAA;A3EouXJ;;A2EruXE;EACE,4BAAA;A3EwuXJ;;A2EzuXE;EACE,4BAAA;A3E4uXJ;;A2E7uXE;EACE,4BAAA;A3EgvXJ;;A2EjvXE;EACE,4BAAA;A3EovXJ;;A2ErvXE;EACE,4BAAA;A3EwvXJ;;A2EzvXE;EACE,4BAAA;A3E4vXJ;;A2E7vXE;EACE,4BAAA;A3EgwXJ;;A2EjwXE;EACE,4BAAA;A3EowXJ;;A2ErwXE;EACE,4BAAA;A3EwwXJ;;A2ElwXA,qCAAA;AAEA,0CAAA;AAIE;EACE,8BAAA;A3EiwXJ;;A2ElwXE;EACE,8BAAA;A3EqwXJ;;A2EtwXE;EACE,+BAAA;A3EywXJ;;A2E1wXE;EACE,+BAAA;A3E6wXJ;;A2E9wXE;EACE,+BAAA;A3EixXJ;;A2ElxXE;EACE,+BAAA;A3EqxXJ;;A2EtxXE;EACE,+BAAA;A3EyxXJ;;A2E1xXE;EACE,+BAAA;A3E6xXJ;;A2E9xXE;EACE,+BAAA;A3EiyXJ;;A2ElyXE;EACE,+BAAA;A3EqyXJ;;A2EtyXE;EACE,+BAAA;A3EyyXJ;;A2EnyXA,wCAAA;AAEA,yCAAA;AAIE;EACE,kBAAA;A3EkyXJ;;A2EnyXE;EACE,kBAAA;A3EsyXJ;;A2EvyXE;EACE,mBAAA;A3E0yXJ;;A2E3yXE;EACE,mBAAA;A3E8yXJ;;A2E/yXE;EACE,mBAAA;A3EkzXJ;;A2EnzXE;EACE,mBAAA;A3EszXJ;;A2EvzXE;EACE,mBAAA;A3E0zXJ;;A2E3zXE;EACE,mBAAA;A3E8zXJ;;A2E/zXE;EACE,mBAAA;A3Ek0XJ;;A2En0XE;EACE,mBAAA;A3Es0XJ;;A2Ev0XE;EACE,mBAAA;A3E00XJ;;A2Ep0XA,uCAAA;AAEA,kCAAA;AAIE;EACE,sBAAA;A3Em0XJ;;A2Ep0XE;EACE,sBAAA;A3Eu0XJ;;A2Ex0XE;EACE,uBAAA;A3E20XJ;;A2E50XE;EACE,uBAAA;A3E+0XJ;;A2Eh1XE;EACE,uBAAA;A3Em1XJ;;A2Ep1XE;EACE,uBAAA;A3Eu1XJ;;A2Ex1XE;EACE,uBAAA;A3E21XJ;;A2E51XE;EACE,uBAAA;A3E+1XJ;;A2Eh2XE;EACE,uBAAA;A3Em2XJ;;A2Ep2XE;EACE,uBAAA;A3Eu2XJ;;A2Ex2XE;EACE,uBAAA;A3E22XJ;;A2Er2XA,gCAAA;AAEA,sCAAA;AAIE;EACE,0BAAA;A3Eo2XJ;;A2Er2XE;EACE,0BAAA;A3Ew2XJ;;A2Ez2XE;EACE,2BAAA;A3E42XJ;;A2E72XE;EACE,2BAAA;A3Eg3XJ;;A2Ej3XE;EACE,2BAAA;A3Eo3XJ;;A2Er3XE;EACE,2BAAA;A3Ew3XJ;;A2Ez3XE;EACE,2BAAA;A3E43XJ;;A2E73XE;EACE,2BAAA;A3Eg4XJ;;A2Ej4XE;EACE,2BAAA;A3Eo4XJ;;A2Er4XE;EACE,2BAAA;A3Ew4XJ;;A2Ez4XE;EACE,2BAAA;A3E44XJ;;A2Et4XA,oCAAA;AAEA,yCAAA;AAIE;EACE,6BAAA;A3Eq4XJ;;A2Et4XE;EACE,6BAAA;A3Ey4XJ;;A2E14XE;EACE,8BAAA;A3E64XJ;;A2E94XE;EACE,8BAAA;A3Ei5XJ;;A2El5XE;EACE,8BAAA;A3Eq5XJ;;A2Et5XE;EACE,8BAAA;A3Ey5XJ;;A2E15XE;EACE,8BAAA;A3E65XJ;;A2E95XE;EACE,8BAAA;A3Ei6XJ;;A2El6XE;EACE,8BAAA;A3Eq6XJ;;A2Et6XE;EACE,8BAAA;A3Ey6XJ;;A2E16XE;EACE,8BAAA;A3E66XJ;;A2Ev6XA,uCAAA;AAEA,uCAAA;AAIE;EACE,2BAAA;A3Es6XJ;;A2Ev6XE;EACE,2BAAA;A3E06XJ;;A2E36XE;EACE,4BAAA;A3E86XJ;;A2E/6XE;EACE,4BAAA;A3Ek7XJ;;A2En7XE;EACE,4BAAA;A3Es7XJ;;A2Ev7XE;EACE,4BAAA;A3E07XJ;;A2E37XE;EACE,4BAAA;A3E87XJ;;A2E/7XE;EACE,4BAAA;A3Ek8XJ;;A2En8XE;EACE,4BAAA;A3Es8XJ;;A2Ev8XE;EACE,4BAAA;A3E08XJ;;A2E38XE;EACE,4BAAA;A3E88XJ;;A2Ex8XA,qCAAA;AAEA,wCAAA;AAIE;EACE,iBAAA;A3Eu8XJ;;A2Ex8XE;EACE,iBAAA;A3E28XJ;;A2E58XE;EACE,kBAAA;A3E+8XJ;;A2Eh9XE;EACE,kBAAA;A3Em9XJ;;A2Ep9XE;EACE,kBAAA;A3Eu9XJ;;A2Ex9XE;EACE,kBAAA;A3E29XJ;;A2E59XE;EACE,kBAAA;A3E+9XJ;;A2Eh+XE;EACE,kBAAA;A3Em+XJ;;A2Ep+XE;EACE,kBAAA;A3Eu+XJ;;A2Ex+XE;EACE,kBAAA;A3E2+XJ;;A2E5+XE;EACE,kBAAA;A3E++XJ;;A2Ez+XA,sCAAA;AAEA,yCAAA;AAIE;EACE,6BAAA;A3Ew+XJ;;A2Ez+XE;EACE,6BAAA;A3E4+XJ;;A2E7+XE;EACE,6BAAA;A3Eg/XJ;;A2Ej/XE;EACE,6BAAA;A3Eo/XJ;;A2Er/XE;EACE,6BAAA;A3Ew/XJ;;A2Ez/XE;EACE,6BAAA;A3E4/XJ;;A2E7/XE;EACE,6BAAA;A3EggYJ;;A2EjgYE;EACE,6BAAA;A3EogYJ;;A2ErgYE;EACE,6BAAA;A3EwgYJ;;A2EzgYE;EACE,6BAAA;A3E4gYJ;;A2E7gYE;EACE,8BAAA;A3EghYJ;;A2E1gYA,uCAAA;AAEA,qCAAA;AAIE;EACE,0BAAA;A3EygYJ;;A2E1gYE;EACE,0BAAA;A3E6gYJ;;A2E9gYE;EACE,0BAAA;A3EihYJ;;A2ElhYE;EACE,0BAAA;A3EqhYJ;;A2EthYE;EACE,0BAAA;A3EyhYJ;;A2E1hYE;EACE,0BAAA;A3E6hYJ;;A2E9hYE;EACE,0BAAA;A3EiiYJ;;A2EliYE;EACE,0BAAA;A3EqiYJ;;A2EtiYE;EACE,0BAAA;A3EyiYJ;;A2E1iYE;EACE,0BAAA;A3E6iYJ;;A2E9iYE;EACE,0BAAA;A3EijYJ;;A2EljYE;EACE,0BAAA;A3EqjYJ;;A2EtjYE;EACE,0BAAA;A3EyjYJ;;A2E1jYE;EACE,0BAAA;A3E6jYJ;;A2E9jYE;EACE,0BAAA;A3EikYJ;;A2ElkYE;EACE,0BAAA;A3EqkYJ;;A2EtkYE;EACE,0BAAA;A3EykYJ;;A2E1kYE;EACE,0BAAA;A3E6kYJ;;A2E9kYE;EACE,0BAAA;A3EilYJ;;A2EllYE;EACE,0BAAA;A3EqlYJ;;A2EtlYE;EACE,0BAAA;A3EylYJ;;A2E1lYE;EACE,0BAAA;A3E6lYJ;;A2E9lYE;EACE,0BAAA;A3EimYJ;;A2ElmYE;EACE,0BAAA;A3EqmYJ;;A2EtmYE;EACE,0BAAA;A3EymYJ;;A2E1mYE;EACE,0BAAA;A3E6mYJ;;A2E9mYE;EACE,0BAAA;A3EinYJ;;A2ElnYE;EACE,0BAAA;A3EqnYJ;;A2EtnYE;EACE,0BAAA;A3EynYJ;;A2E1nYE;EACE,0BAAA;A3E6nYJ;;A2E9nYE;EACE,0BAAA;A3EioYJ;;A2EloYE;EACE,0BAAA;A3EqoYJ;;A2EtoYE;EACE,0BAAA;A3EyoYJ;;A2E1oYE;EACE,0BAAA;A3E6oYJ;;A2E9oYE;EACE,0BAAA;A3EipYJ;;A2ElpYE;EACE,0BAAA;A3EqpYJ;;A2EtpYE;EACE,0BAAA;A3EypYJ;;A2E1pYE;EACE,0BAAA;A3E6pYJ;;A2E9pYE;EACE,0BAAA;A3EiqYJ;;A2ElqYE;EACE,0BAAA;A3EqqYJ;;A2EtqYE;EACE,0BAAA;A3EyqYJ;;A2E1qYE;EACE,0BAAA;A3E6qYJ;;A2E9qYE;EACE,0BAAA;A3EirYJ;;A2ElrYE;EACE,0BAAA;A3EqrYJ;;A2EtrYE;EACE,2BAAA;A3EyrYJ;;A2EnrYA,mCAAA;AAEA,uCAAA;AAIE;EACE,gBAJA;A3EsrYJ;;A2EnrYE;EACE,gBAJA;A3E0rYJ;;A2EvrYE;EACE,gBAJA;A3E8rYJ;;A2E3rYE;EACE,gBAJA;A3EksYJ;;A2E/rYE;EACE,gBAJA;A3EssYJ;;A2EnsYE;EACE,gBAJA;A3E0sYJ;;A2EvsYE;EACE,gBAJA;A3E8sYJ;;A2EtsYA,qCAAA;AAEA,sCAAA;AAIE;EACE,kBAJA;A3EysYJ;;A2EtsYE;EACE,kBAJA;A3E6sYJ;;A2E1sYE;EACE,mBAJA;A3EitYJ;;A2E9sYE;EACE,mBAJA;A3EqtYJ;;A2EltYE;EACE,mBAJA;A3EytYJ;;A2EjtYA,oCAAA;AAEA,2CAAA;AAKE;EACE,yBAJA;A3EmtYJ;;A2EhtYE;EACE,6BAJA;A3EutYJ;;A2EptYE;EACE,0BAJA;A3E2tYJ;;A2ExtYE;EACE,uBAJA;A3E+tYJ;;A2E5tYE;EACE,sBAJA;A3EmuYJ;;A2EhuYE;EACE,uBAJA;A3EuuYJ;;A2EpuYE;EACE,wBAJA;A3E2uYJ;;A2ExuYE;EACE,qBAJA;A3E+uYJ;;A2E5uYE;EACE,sBAJA;A3EmvYJ;;A2EhvYE;EACE,qBAJA;A3EuvYJ;;A2EpvYE;EACE,wBAJA;A3E2vYJ;;A2ExvYE;EACE,uBAJA;A3E+vYJ;;A2EvvYA,yCAAA;AAEA,0CAAA;AAIE;EACE,wBAJA;A3E0vYJ;;A2EvvYE;EACE,mBAJA;A3E8vYJ;;A2E3vYE;EACE,qBAJA;A3EkwYJ;;A2E/vYE;EACE,mBAJA;A3EswYJ;;A2EnwYE;EACE,wBAJA;A3E0wYJ;;A2EvwYE;EACE,sBAJA;A3E8wYJ;;A2E3wYE;EACE,sBAJA;A3EkxYJ;;A2E/wYE;EACE,2BAJA;A3EsxYJ;;A2EnxYE;EACE,uBAJA;A3E0xYJ;;A2EvxYE;EACE,uBAJA;A3E8xYJ;;A2EtxYA,wCAAA;AAEA,oCAAA;AAKE;EACE,gBAJA;A3EwxYJ;;A2ErxYE;EACE,kBAJA;A3E4xYJ;;A2EzxYE;EACE,eAJA;A3EgyYJ;;A2E7xYE;EACE,kBAJA;A3EoyYJ;;A2EjyYE;EACE,iBAJA;A3EwyYJ;;A2EryYE;EACE,iBAJA;A3E4yYJ;;A2EpyYA,kCAAA;AAEA,iCAAA;AAIE;EACE,WAJA;A3EuyYJ;;A2EpyYE;EACE,YAJA;A3E2yYJ;;A2ExyYE;EACE,WAJA;A3E+yYJ;;A2EvyYA,+BAAA;AAEA,oCAAA;AAIE;EACE,gBAJA;A3E0yYJ;;A2EvyYE;EACE,iBAJA;A3E8yYJ;;A2E3yYE;EACE,cAJA;A3EkzYJ;;A2E1yYA,kCAAA;AAEA,uCAAA;AAIE;EACE,sBAAA;A3EyyYJ;;A2E1yYE;EACE,sBAAA;A3E6yYJ;;A2E9yYE;EACE,sBAAA;A3EizYJ;;A2ElzYE;EACE,sBAAA;A3EqzYJ;;A2EtzYE;EACE,sBAAA;A3EyzYJ;;A2E1zYE;EACE,sBAAA;A3E6zYJ;;A2E9zYE;EACE,sBAAA;A3Ei0YJ;;A2El0YE;EACE,sBAAA;A3Eq0YJ;;A2Et0YE;EACE,sBAAA;A3Ey0YJ;;A2E10YE;EACE,uBAAA;A3E60YJ;;A2Ev0YA,qCAAA;AAEA,sCAAA;AAOE;EACE,yBAAA;A3Em0YJ;;A2Ep0YE;EACE,yBAAA;A3Eu0YJ;;A2Ex0YE;EACE,yBAAA;A3E20YJ;;A2E50YE;EACE,yBAAA;A3E+0YJ;;A2Eh1YE;EACE,yBAAA;A3Em1YJ;;A2Ep1YE;EACE,yBAAA;A3Eu1YJ;;A2Ex1YE;EACE,yBAAA;A3E21YJ;;A2E51YE;EACE,yBAAA;A3E+1YJ;;A2E31YA;EACE,sCAAA;A3E81YF;;A2E31YA;EACE,wCAAA;A3E81YF;;A2E31YA,oCAAA;AAEA,2CAAA;AAEA;EACE,kBAAA;EACA,WCzQM;ED0QN,eAAA;EACA,cAAA;EACA,gBAAA;EACA,0BAAA;A3E41YF;;A2En1YE;EACE,yBAAA;A3Es1YJ;;A2Ev1YE;EACE,yBAAA;A3E01YJ;;A2E31YE;EACE,yBAAA;A3E81YJ;;A2E/1YE;EACE,yBAAA;A3Ek2YJ;;A2En2YE;EACE,yBAAA;A3Es2YJ;;A2Ev2YE;EACE,yBAAA;A3E02YJ;;A2E32YE;EACE,yBAAA;A3E82YJ;;A2E/2YE;EACE,yBAAA;A3Ek3YJ;;A2En3YE;EACE,yBAAA;A3Es3YJ;;A2El3YA,yCAAA;AAEA,2CAAA;AAQE;EACE,yBAAA;A3E62YJ;;A2E92YE;EACE,yBAAA;A3Ei3YJ;;A2El3YE;EACE,yBAAA;A3Eq3YJ;;A2Et3YE;EACE,yBAAA;A3Ey3YJ;;A2E13YE;EACE,yBAAA;A3E63YJ;;A2E93YE;EACE,yBAAA;A3Ei4YJ;;A2El4YE;EACE,yBAAA;A3Eq4YJ;;A2Et4YE;EACE,yBAAA;A3Ey4YJ;;A2Ej4YA;EACE,iDAAA;A3Eo4YF;;A2Ej4YA;EACE,mDAAA;A3Eo4YF;;A2Ej4YA,wCAAA;AAEA,gDAAA;AAQE;EACE,oCAAA;EACA,WClUI;A5E8rZR;;A2Ez3YE;EACE,qDAAA;EACA,WCvUI;A5EmsZR;;A2En4YE;EACE,oCAAA;EACA,WClUI;A5EwsZR;;A2En4YE;EACE,oDAAA;EACA,WCvUI;A5E6sZR;;A2E74YE;EACE,oCAAA;EACA,WClUI;A5EktZR;;A2E74YE;EACE,mDAAA;EACA,WCvUI;A5EutZR;;A2Ev5YE;EACE,oCAAA;EACA,WClUI;A5E4tZR;;A2Ev5YE;EACE,mDAAA;EACA,WCvUI;A5EiuZR;;A2Ej6YE;EACE,oCAAA;EACA,WClUI;A5EsuZR;;A2Ej6YE;EACE,oDAAA;EACA,WCvUI;A5E2uZR;;A2E36YE;EACE,oCAAA;EACA,WClUI;A5EgvZR;;A2E36YE;EACE,qDAAA;EACA,WCvUI;A5EqvZR;;A2Er7YE;EACE,oCAAA;EACA,WClUI;A5E0vZR;;A2Er7YE;EACE,kDAAA;EACA,WCvUI;A5E+vZR;;A2E/7YE;EACE,oCAAA;EACA,WClUI;A5EowZR;;A2E/7YE;EACE,mDAAA;EACA,WCvUI;A5EywZR;;A2E97YA;EACE,iDAAA;A3Ei8YF;;A2E97YA;EACE,mDAAA;A3Ei8YF;;A2E97YA,6CAAA;AAEA,0CAAA;AAQE;EACE,yBAAA;A3Ey7YJ;;A2E17YE;EACE,yBAAA;A3E67YJ;;A2E97YE;EACE,yBAAA;A3Ei8YJ;;A2El8YE;EACE,yBAAA;A3Eq8YJ;;A2Et8YE;EACE,yBAAA;A3Ey8YJ;;A2E18YE;EACE,yBAAA;A3E68YJ;;A2E98YE;EACE,yBAAA;A3Ei9YJ;;A2El9YE;EACE,yBAAA;A3Eq9YJ;;A2Et9YE;EACE,yBAAA;A3Ey9YJ;;A2E19YE;EACE,yBAAA;A3E69YJ;;A2E99YE;EACE,yBAAA;A3Ei+YJ;;A2El+YE;EACE,yBAAA;A3Eq+YJ;;A2Ej+YA;EACE,sCAAA;A3Eo+YF;;A2Ej+YA;EACE,wCAAA;A3Eo+YF;;A2Ej+YA,uCAAA;AAEA,4CAAA;AAEA;EACE;IACE,sBAAA;E3Ek+YF;E2Eh+YA;IACE,mBAAA;E3Ek+YF;AACF;A2E/9YE;EACE,oCAAA;EACA,gCAAA;EACA,wCAAA;EACA,wBAAA;A3Ei+YJ;A2Er9YI;EAEE,oCAAA;EACA,gCAAA;A3Es9YN;A2En9YI;EACE,8BAAA;A3Eq9YN;;A2E5+YE;EACE,oCAAA;EACA,gCAAA;EACA,wCAAA;EACA,wBAAA;A3E++YJ;A2En+YI;EAEE,oCAAA;EACA,gCAAA;A3Eo+YN;A2Ej+YI;EACE,uDAAA;A3Em+YN;;A2E1/YE;EACE,oCAAA;EACA,gCAAA;EACA,wCAAA;EACA,wBAAA;A3E6/YJ;A2Ej/YI;EAEE,oCAAA;EACA,gCAAA;A3Ek/YN;A2E/+YI;EACE,4EAAA;A3Ei/YN;;A2ExgZE;EACE,oCAAA;EACA,gCAAA;EACA,wCAAA;EACA,wBAAA;A3E2gZJ;A2E//YI;EAEE,oCAAA;EACA,gCAAA;A3EggZN;A2E7/YI;EACE,4EAAA;A3E+/YN;;A2EthZE;EACE,oCAAA;EACA,gCAAA;EACA,wCAAA;EACA,wBAAA;EAGE,WC9XE;A5Eq5ZR;A2EthZM;EAIE,WCnYA;A5Ew5ZR;A2EjhZI;EAEE,oCAAA;EACA,gCAAA;A3EkhZN;A2E/gZI;EACE,4EAAA;A3EihZN;;A2ExiZE;EACE,oCAAA;EACA,gCAAA;EACA,wCAAA;EACA,wBAAA;A3E2iZJ;A2E/hZI;EAEE,oCAAA;EACA,gCAAA;A3EgiZN;A2E7hZI;EACE,8BAAA;A3E+hZN;;A2EtjZE;EACE,oCAAA;EACA,gCAAA;EACA,wCAAA;EACA,wBAAA;A3EyjZJ;A2E7iZI;EAEE,oCAAA;EACA,gCAAA;A3E8iZN;A2E3iZI;EACE,4EAAA;A3E6iZN;;A2EpkZE;EACE,oCAAA;EACA,gCAAA;EACA,wCAAA;EACA,wBAAA;A3EukZJ;A2E3jZI;EAEE,oCAAA;EACA,gCAAA;A3E4jZN;A2EzjZI;EACE,kEAAA;A3E2jZN;;A2EtjZA;EACE,sDAAA;EACA,kDAAA;A3EyjZF;A2EvjZE;EACE,qDAAA;EACA,iDAAA;A3EyjZJ;;A2ErjZA;EACE,iDAAA;EACA,6CAAA;A3EwjZF;;A2ErjZA;EACE,mDAAA;EACA,+CAAA;A3EwjZF;;A2EpjZE;EACE,6BAAA;A3EujZJ;;A2EnjZA,0CAAA;AAEE;EACE,iBAAA;EACA,qBAH2B;EAI3B,cAJ2B;EAK3B,6BAAA;A3EqjZJ;A2EnjZI;EAIE,YAAA;EACA,2DAAA;EACA,uDAAA;EACA,gBAAA;A3EkjZN;;A2E/jZE;EACE,iBAAA;EACA,qBAH2B;EAI3B,cAJ2B;EAK3B,6BAAA;A3EkkZJ;A2EhkZI;EAIE,YAAA;EACA,0DAAA;EACA,sDAAA;EACA,gBAAA;A3E+jZN;;A2E5kZE;EACE,iBAAA;EACA,qBAH2B;EAI3B,cAJ2B;EAK3B,6BAAA;A3E+kZJ;A2E7kZI;EAIE,YAAA;EACA,gFAAA;EACA,4EAAA;EACA,gBAAA;A3E4kZN;;A2EzlZE;EACE,iBAAA;EACA,qBAH2B;EAI3B,cAJ2B;EAK3B,6BAAA;A3E4lZJ;A2E1lZI;EAIE,YAAA;EACA,8EAAA;EACA,0EAAA;EACA,gBAAA;A3EylZN;;A2EtmZE;EACE,iBAAA;EACA,qBAH2B;EAI3B,cAJ2B;EAK3B,6BAAA;A3EymZJ;A2EvmZI;EAIE,YAAA;EACA,+EAAA;EACA,2EAAA;EACA,gBAAA;A3EsmZN;;A2EnnZE;EACE,iBAAA;EACA,qBAH2B;EAI3B,cAJ2B;EAK3B,6BAAA;A3EsnZJ;A2EpnZI;EAIE,YAAA;EACA,gFAAA;EACA,4EAAA;EACA,gBAAA;A3EmnZN;;A2EhoZE;EACE,iBAAA;EACA,qBAH2B;EAI3B,cAJ2B;EAK3B,6BAAA;A3EmoZJ;A2EjoZI;EAIE,YAAA;EACA,+EAAA;EACA,2EAAA;EACA,gBAAA;A3EgoZN;;A2E7oZE;EACE,iBAAA;EACA,qBAH2B;EAI3B,cAJ2B;EAK3B,6BAAA;A3EgpZJ;A2E9oZI;EAIE,YAAA;EACA,oEAAA;EACA,gEAAA;EACA,gBAAA;A3E6oZN;;A2EtoZE;EACE,qBAF2B;EAG3B,cAH2B;EAI3B,6BAAA;A3EyoZJ;A2EvoZI;EACE,cAPyB;A3EgpZ/B;A2EloZI;EAIE,YAAA;EACA,2DAAA;EACA,uDAAA;A3EioZN;;A2EppZE;EACE,qBAF2B;EAG3B,cAH2B;EAI3B,6BAAA;A3EupZJ;A2ErpZI;EACE,cAPyB;A3E8pZ/B;A2EhpZI;EAIE,YAAA;EACA,0DAAA;EACA,sDAAA;A3E+oZN;;A2ElqZE;EACE,qBAF2B;EAG3B,cAH2B;EAI3B,6BAAA;A3EqqZJ;A2EnqZI;EACE,cAPyB;A3E4qZ/B;A2E9pZI;EAIE,YAAA;EACA,gFAAA;EACA,4EAAA;A3E6pZN;;A2EhrZE;EACE,qBAF2B;EAG3B,cAH2B;EAI3B,6BAAA;A3EmrZJ;A2EjrZI;EACE,cAPyB;A3E0rZ/B;A2E5qZI;EAIE,YAAA;EACA,8EAAA;EACA,0EAAA;A3E2qZN;;A2E9rZE;EACE,qBAF2B;EAG3B,cAH2B;EAI3B,6BAAA;A3EisZJ;A2E/rZI;EACE,cAPyB;A3EwsZ/B;A2E1rZI;EAIE,YAAA;EACA,+EAAA;EACA,2EAAA;A3EyrZN;;A2E5sZE;EACE,qBAF2B;EAG3B,cAH2B;EAI3B,6BAAA;A3E+sZJ;A2E7sZI;EACE,cAPyB;A3EstZ/B;A2ErtZE;EAUI,cClfkB;A5EgsaxB;A2E3sZI;EAIE,YAAA;EACA,gFAAA;EACA,4EAAA;A3E0sZN;;A2E7tZE;EACE,qBAF2B;EAG3B,cAH2B;EAI3B,6BAAA;A3EguZJ;A2E9tZI;EACE,cAPyB;A3EuuZ/B;A2EztZI;EAIE,YAAA;EACA,+EAAA;EACA,2EAAA;A3EwtZN;;A2E3uZE;EACE,qBAF2B;EAG3B,cAH2B;EAI3B,6BAAA;A3E8uZJ;A2E5uZI;EACE,cAPyB;A3EqvZ/B;A2EvuZI;EAIE,YAAA;EACA,oEAAA;EACA,gEAAA;A3EsuZN;;A2E9tZE;EACE,gDAAA;EACA,4CAAA;EACA,2BAAA;A3EiuZJ;A2E/tZI;EAIE,YAAA;EACA,gDAAA;EACA,4CAAA;A3E8tZN;;A2EzuZE;EACE,+CAAA;EACA,2CAAA;EACA,2BAAA;A3E4uZJ;A2E1uZI;EAIE,YAAA;EACA,+CAAA;EACA,2CAAA;A3EyuZN;;A2EpvZE;EACE,qEAAA;EACA,iEAAA;EACA,2BAAA;A3EuvZJ;A2ErvZI;EAIE,YAAA;EACA,qEAAA;EACA,iEAAA;A3EovZN;;A2E/vZE;EACE,mEAAA;EACA,+DAAA;EACA,2BAAA;A3EkwZJ;A2EhwZI;EAIE,YAAA;EACA,mEAAA;EACA,+DAAA;A3E+vZN;;A2E1wZE;EACE,oEAAA;EACA,gEAAA;EACA,2BAAA;A3E6wZJ;A2E3wZI;EAIE,YAAA;EACA,oEAAA;EACA,gEAAA;A3E0wZN;;A2ErxZE;EACE,qEAAA;EACA,iEAAA;EACA,2BAAA;A3EwxZJ;A2EtxZI;EAIE,YAAA;EACA,qEAAA;EACA,iEAAA;A3EqxZN;;A2EhyZE;EACE,oEAAA;EACA,gEAAA;EACA,2BAAA;A3EmyZJ;A2EjyZI;EAIE,YAAA;EACA,oEAAA;EACA,gEAAA;A3EgyZN;;A2E3yZE;EACE,yDAAA;EACA,qDAAA;EACA,2BAAA;A3E8yZJ;A2E5yZI;EAIE,YAAA;EACA,yDAAA;EACA,qDAAA;A3E2yZN;;A2EnyZE;EACE,yBAF2B;EAG3B,qBAH2B;EAI3B,2BAAA;EACA,YAAA;A3EsyZJ;A2EpyZI;EAIE,YAAA;EACA,2BAAA;EACA,2DAAA;EACA,uDAAA;A3EmyZN;;A2EhzZE;EACE,yBAF2B;EAG3B,qBAH2B;EAI3B,2BAAA;EACA,YAAA;A3EmzZJ;A2EjzZI;EAIE,YAAA;EACA,2BAAA;EACA,0DAAA;EACA,sDAAA;A3EgzZN;;A2E7zZE;EACE,yBAF2B;EAG3B,qBAH2B;EAI3B,2BAAA;EACA,YAAA;A3Eg0ZJ;A2E9zZI;EAIE,YAAA;EACA,2BAAA;EACA,gFAAA;EACA,4EAAA;A3E6zZN;;A2E10ZE;EACE,yBAF2B;EAG3B,qBAH2B;EAI3B,2BAAA;EACA,YAAA;A3E60ZJ;A2E30ZI;EAIE,YAAA;EACA,2BAAA;EACA,8EAAA;EACA,0EAAA;A3E00ZN;;A2Ev1ZE;EACE,yBAF2B;EAG3B,qBAH2B;EAI3B,2BAAA;EACA,YAAA;A3E01ZJ;A2Ex1ZI;EAIE,YAAA;EACA,2BAAA;EACA,+EAAA;EACA,2EAAA;A3Eu1ZN;;A2Ep2ZE;EACE,yBAF2B;EAG3B,qBAH2B;EAI3B,2BAAA;EACA,YAAA;A3Eu2ZJ;A2Er2ZI;EAIE,YAAA;EACA,2BAAA;EACA,gFAAA;EACA,4EAAA;A3Eo2ZN;;A2Ej3ZE;EACE,yBAF2B;EAG3B,qBAH2B;EAI3B,2BAAA;EACA,YAAA;A3Eo3ZJ;A2El3ZI;EAIE,YAAA;EACA,2BAAA;EACA,+EAAA;EACA,2EAAA;A3Ei3ZN;;A2E93ZE;EACE,yBAF2B;EAG3B,qBAH2B;EAI3B,2BAAA;EACA,YAAA;A3Ei4ZJ;A2E/3ZI;EAIE,YAAA;EACA,2BAAA;EACA,oEAAA;EACA,gEAAA;A3E83ZN;;A2Ez3ZA,yDAAA;AAQE;;;EAGE,2CAAA;A3Eq3ZJ;;A2Ex3ZE;;;EAGE,2CAAA;A3E23ZJ;;A2E93ZE;;;EAGE,2CAAA;A3Ei4ZJ;;A2Ep4ZE;;;EAGE,2CAAA;A3Eu4ZJ;;A2E14ZE;;;EAGE,2CAAA;A3E64ZJ;;A2Eh5ZE;;;EAGE,2CAAA;A3Em5ZJ;;A2Et5ZE;;;EAGE,2CAAA;A3Ey5ZJ;;A2E55ZE;;;EAGE,2CAAA;A3E+5ZJ;;A2E35ZA,uDAAA;AAEA,6CAAA;AAQE;;EAEE,yBAAA;EACA,WC/hBI;EDgiBJ,yBAAA;A3Es5ZJ;A2Ep5ZI;;EACE,gDAAA;EACA,gDAAA;A3Eu5ZN;A2Ep5ZI;;;;EAEE,6BAAA;A3Ew5ZN;;A2Er6ZE;;EAEE,yBAAA;EACA,WC/hBI;EDgiBJ,yBAAA;A3Ew6ZJ;A2Et6ZI;;EACE,+CAAA;EACA,+CAAA;A3Ey6ZN;A2Et6ZI;;;;EAEE,6BAAA;A3E06ZN;;A2Ev7ZE;;EAEE,yBAAA;EACA,WC/hBI;EDgiBJ,yBAAA;A3E07ZJ;A2Ex7ZI;;EACE,qEAAA;EACA,qEAAA;A3E27ZN;A2Ex7ZI;;;;EAEE,6BAAA;A3E47ZN;;A2Ez8ZE;;EAEE,yBAAA;EACA,WC/hBI;EDgiBJ,yBAAA;A3E48ZJ;A2E18ZI;;EACE,mEAAA;EACA,mEAAA;A3E68ZN;A2E18ZI;;;;EAEE,6BAAA;A3E88ZN;;A2E39ZE;;EAEE,yBAAA;EACA,WC/hBI;EDgiBJ,yBAAA;A3E89ZJ;A2E59ZI;;EACE,oEAAA;EACA,oEAAA;A3E+9ZN;A2E59ZI;;;;EAEE,6BAAA;A3Eg+ZN;;A2E7+ZE;;EAEE,yBAAA;EACA,WC/hBI;EDgiBJ,yBAAA;A3Eg/ZJ;A2E9+ZI;;EACE,qEAAA;EACA,qEAAA;A3Ei/ZN;A2E9+ZI;;;;EAEE,6BAAA;A3Ek/ZN;;A2E//ZE;;EAEE,yBAAA;EACA,WC/hBI;EDgiBJ,yBAAA;A3EkgaJ;A2EhgaI;;EACE,oEAAA;EACA,oEAAA;A3EmgaN;A2EhgaI;;;;EAEE,6BAAA;A3EogaN;;A2EjhaE;;EAEE,yBAAA;EACA,WC/hBI;EDgiBJ,yBAAA;A3EohaJ;A2ElhaI;;EACE,yDAAA;EACA,yDAAA;A3EqhaN;A2ElhaI;;;;EAEE,6BAAA;A3EshaN;;A2EjhaA,2CAAA;AAEA,iDAAA;AAQE;EACE,oCAAA;A3E4gaJ;;A2EzgaE;EACE,wCAAA;A3E4gaJ;;A2EzgaE;EACE,2CAAA;A3E4gaJ;;A2EzgaE;EACE,yCAAA;A3E4gaJ;;A2EzgaE;EACE,0CAAA;A3E4gaJ;;A2E7haE;EACE,oCAAA;A3EgiaJ;;A2E7haE;EACE,wCAAA;A3EgiaJ;;A2E7haE;EACE,2CAAA;A3EgiaJ;;A2E7haE;EACE,yCAAA;A3EgiaJ;;A2E7haE;EACE,0CAAA;A3EgiaJ;;A2EjjaE;EACE,oCAAA;A3EojaJ;;A2EjjaE;EACE,wCAAA;A3EojaJ;;A2EjjaE;EACE,2CAAA;A3EojaJ;;A2EjjaE;EACE,yCAAA;A3EojaJ;;A2EjjaE;EACE,0CAAA;A3EojaJ;;A2ErkaE;EACE,oCAAA;A3EwkaJ;;A2ErkaE;EACE,wCAAA;A3EwkaJ;;A2ErkaE;EACE,2CAAA;A3EwkaJ;;A2ErkaE;EACE,yCAAA;A3EwkaJ;;A2ErkaE;EACE,0CAAA;A3EwkaJ;;A2EzlaE;EACE,oCAAA;A3E4laJ;;A2EzlaE;EACE,wCAAA;A3E4laJ;;A2EzlaE;EACE,2CAAA;A3E4laJ;;A2EzlaE;EACE,yCAAA;A3E4laJ;;A2EzlaE;EACE,0CAAA;A3E4laJ;;A2E7maE;EACE,oCAAA;A3EgnaJ;;A2E7maE;EACE,wCAAA;A3EgnaJ;;A2E7maE;EACE,2CAAA;A3EgnaJ;;A2E7maE;EACE,yCAAA;A3EgnaJ;;A2E7maE;EACE,0CAAA;A3EgnaJ;;A2EjoaE;EACE,oCAAA;A3EooaJ;;A2EjoaE;EACE,wCAAA;A3EooaJ;;A2EjoaE;EACE,2CAAA;A3EooaJ;;A2EjoaE;EACE,yCAAA;A3EooaJ;;A2EjoaE;EACE,0CAAA;A3EooaJ;;A2ErpaE;EACE,oCAAA;A3EwpaJ;;A2ErpaE;EACE,wCAAA;A3EwpaJ;;A2ErpaE;EACE,2CAAA;A3EwpaJ;;A2ErpaE;EACE,yCAAA;A3EwpaJ;;A2ErpaE;EACE,0CAAA;A3EwpaJ;;A2EppaA,+CAAA;AAEA,wCAAA;AAIE;EACE,4BAAA;A3EmpaJ;;A2EppaE;EACE,4BAAA;A3EupaJ;;A2ExpaE;EACE,4BAAA;A3E2paJ;;A2E5paE;EACE,4BAAA;A3E+paJ;;A2EhqaE;EACE,4BAAA;A3EmqaJ;;A2EpqaE;EACE,4BAAA;A3EuqaJ;;A2ExqaE;EACE,4BAAA;A3E2qaJ;;A2E5qaE;EACE,4BAAA;A3E+qaJ;;A2EhraE;EACE,4BAAA;A3EmraJ;;A2EpraE;EACE,6BAAA;A3EuraJ;;A2EjraA,sCAAA;AAEA;EACE,UAAA;A3EmraF;;A2EhraA;EACE,aAAA;EACA,WAAA;A3EmraF;;A2EhraA;EACE,aAAA;A3EmraF;A2EhraI;EACE,yBCzoBU;ED0oBV,WC3mBE;A5E6xbR;A2EhraM;EACE,yBC5oBU;A5E8zblB;;A2E5qaA,6CAAA;AAEE;EACE,yCAAA;A3E8qaJ;A2E3qaE;EACE,UAAA;A3E6qaJ;A2E1qaE;EACE,0CAAA;A3E4qaJ;;A2ExqaA,2CAAA;AAEA,sCAAA;AACA;EACE,cAAA;EACA,kBAAA;A3E0qaF;;A2EvqaA;EACE,cC7pBW;A5Eu0bb;A2ExqaE;EACE,eAAA;A3E0qaJ;;A2EtqaA,oCAAA;AAEA,uCAAA;AACA;EACE,kBAAA;A3EwqaF;;A2ErqaA,qCAAA;AAEA,wCAAA;AACA;EACE,UAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,QAAA;EACA,iCAAA;EACA,kBAAA;A3EuqaF;;A2EpqaA,sCAAA;AAEA,sCAAA;AAEE;EACE,cC9rBM;ED+rBN,qBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;A3EqqaJ;A2EnqaI;EACE,yBCrtBU;EDstBV,WCvrBE;EDwrBF,yBAAA;A3EqqaN;;A2EhqaA,qCAAA;AAEA;EACE,eAAA;A3EkqaF;;A2E9paE;EACE,gBAAA;A3EiqaJ;A2E9paE;EACE,gBAAA;EACA,gBAAA;A3EgqaJ;A2E3paM;EACE,gBAAA;A3E6paR;A2ExpaE;EACE,gBAAA;EACA,mBAAA;A3E0paJ;;A2EppaI;EACE,2BAAA;EACA,yBAAA;EACA,yBAAA;A3EupaN;A2ErpaM;EACE,2CAAA;A3EupaR;;A2E/oaI;EACE,gBAAA;A3EkpaN;;A2E7oaA;EACE,6CAAA;A3EgpaF;;A2E1oaM;EACE,aAAA;EACA,gBAAA;EACA,2CAAA;A3E6oaR;A2ExoaE;EACE,mBAAA;A3E0oaJ;;A2EroaE;EACE,aAAA;EACA,YAAA;EACA,oCAAA;EACA,eAAA;EACA,UAAA;EACA,MAAA;A3EwoaJ;;A2EnoaE;EACE,wBAAA;A3EsoaJ;;A2EloaE;EACE,0BAAA;A3EqoaJ;A2EpoaI;EACE,4BAAA;A3EsoaN;A2EnoaE;EACE,uHAAA;A3EqoaJ;;A2EjoaE;EACE,4BAAA;A3EooaJ;A2EnoaI;EACE,8BAAA;A3EqoaN;A2EloaE;EACE,qHAAA;A3EooaJ;;A2EhoaE;EACE,aC10BY;A5E68bhB;A2EjoaE;EACE,mHAAA;A3EmoaJ;;A2E/naE;EACE,aCh1BY;A5Ek9bhB;A2EhoaE;EACE,mHAAA;A3EkoaJ;;A2E9naA;EACE,oBAAA;A3EioaF;;A2E9naA;EACE,oBAAA;A3EioaF;;A2E9naA;EACE,oBAAA;A3EioaF;;A2E9naA;EACE,oBAAA;A3EioaF;;A2E9naA;EACE,mBAAA;A3EioaF;;A2E9naA;EACE,mBAAA;A3EioaF;;A2E9naA;EACE,oBAAA;A3EioaF;;A2E9naA;EACE;IACE,UAAA;IACA,SAAA;E3EioaF;E2E9naA;IACE,YAAA;IACA,MAAA;E3EgoaF;E2E7naA;IACE,UAAA;E3E+naF;AACF;A2E1naI;EAEE,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;A3E2naN;;A2ErnaI;EACE,UAAA;A3EwnaN;A2EtnaM;EACE,6BAAA;EACA,gBAAA;A3EwnaR;;A2EjnaI;EACE,6BAAA;EACA,gBAAA;A3EonaN;;A2EhnaA;;4BAAA;AAIE;EACE,aAAA;EACA,gBAAA;EACA,YAAA;A3EknaJ;A2EhnaE;EACE,6BAAA;EACA,yBAAA;A3EknaJ;A2EjnaI;EACE,6BAAA;EACA,yBAAA;A3EmnaN;;A2E9maA;EACE,aAAA;A3EinaF;;A6EtjcA;;4BAAA;AAIA;EACE,eDsFe;ECrFf,kBAAA;EACA,8BAAA;EACA,cDNsB;A5E8jcxB;;A6ErjcA;EACE,iBDiFgB;EChFhB,qBAAA;EACA,gBAAA;A7EwjcF;;A6ErjcA;EACE,2BAAA;EACA,qBAAA;EACA,mBAAA;A7EwjcF;;A6EpjcE;EACE,qBAAA;EACA,2BAAA;A7EujcJ;A6EpjcI;EACE,WDSE;A5E6icR;;A6EjjcA;EACE,eAAA;A7EojcF;;A6EjjcA;EACE,2BAAA;A7EojcF;;A6EjjcA;EACE,eDsDoB;ECrDpB,gBDsDsB;ECrDtB,qBDsDyB;A5E8/b3B;;A6EjjcA;EACE,sCAAA;EACA,2CDoDkB;ECnDlB,YDoDiB;ECnDjB,aDoDgB;ECnDhB,kBDoDwB;A5Eggc1B;;A6EjjcA;EACE,aAAA;EACA,uBAAA;A7EojcF;A6EljcE;EACE,SAAA;A7EojcJ;;A6EhjcA;EACE,8BD0CkB;ECzClB,aDwCmB;A5E2gcrB;;A6E/icI;EACE,uBAAA;A7EkjcN;A6E9icI;EACE,4BAAA;EACA,+BD8Bc;A5EkhcpB;;A6E1icE;EACE,kBAAA;A7E6icJ;;A6EzicA;EACE,mCDKwB;A5Euic1B;;A6EzicA;EACE,mBAAA;EACA,YAAA;A7E4icF;;A6EzicA;EACE,wBAAA;A7E4icF;;A6ExicE;EACE,0BDhFgB;A5E2ncpB;;A6EvicA;EACE,qBAAA;A7E0icF;;A6EticE;EACE,mBAAA;A7EyicJ;;A6EjicE;;;;;;;;;;;;EAYE,cAAA;EACA,aAAA;A7EoicJ;A6ElicI;;;;;;;;;;;;EACE,gBAAA;A7E+icN;A6E3icE;EACE,kBDjCgB;ECkChB,cD3HS;A5Ewqcb;;A6EzicA;EACE,2CDpCiB;ECqCjB,eDpCgB;A5EglclB;;A6EricM;EACE,0CAAA;A7EwicR;A6EnicQ;EACE,gCAAA;A7EqicV;A6E7hcM;EACE,oBAAA;EACA,gBAAA;A7E+hcR;;A6EvhcI;EACE,mBAAA;A7E0hcN;;A6EphcE;EACE,qBDjLU;A5Ewscd;A6EphcI;EACE,oBAAA;A7EshcN;;A6EhhcE;EACE,qBD5LU;A5E+scd;;A6E5gcI;EACE,2BAAA;A7E+gcN;;A6EtgcQ;EACE,eAAA;A7EygcV;;A6EhgcE;EACE,WD/LI;A5EkscR;A6ElgcI;EACE,uBAAA;EACA,qBAAA;A7EogcN;A6EhgcI;EACE,cD5OkB;A5E8ucxB;;A6E7/bE;EACE,oBAAA;EACA,sBAAA;EACA,2BAAA;A7EggcJ;A6E//bI;EACE,uBAAA;EACA,qBAAA;A7EigcN;A6E5/bM;EAEE,sBDzNA;EC0NA,2BAAA;EACA,kBAAA;EACA,8CAAA;A7E6/bR;A6Ex/bE;EACE,2BAAA;A7E0/bJ;A6Ev/bE;EACE,aAAA;EACA,2BAAA;EACA,6BAAA;A7Ey/bJ;A6Et/bE;EACE,2BAAA;EACA,WAAA;EACA,WAAA;A7Ew/bJ;A6Ev/bI;EACE,sCAAA;A7Ey/bN;;A6Ep/bA;EACE,sCAAA;EACA,cAAA;EACA,qBAAA;EACA,YAAA;EACA,WD1PM;EC2PN,sCAAA;A7Eu/bF;A6Er/bE;EACE,gBAAA;EACA,WD/PI;ECgQJ,gBAAA;EACA,gBAAA;EACA,UAAA;A7Eu/bJ;A6Et/bI;EACE,uBAAA;EACA,qBAAA;A7Ew/bN;A6Er/bI;EACE,aAAA;A7Eu/bN;;A6El/bA;EACE,aAAA;EACA,WAAA;A7Eq/bF;;A6El/bA;EACE,sBAAA;A7Eq/bF;A6Ep/bE;EACE,YAAA;A7Es/bJ;;A6El/bA;EACE,iBAAA;A7Eq/bF;;A6En/bA;EACE,oBAAA;A7Es/bF;;A6El/bA;;;EAGE,gCAAA;A7Eq/bF;A6En/bE;;;EACE,sCAAA;A7Eu/bJ;;A6En/bA;;;;;EAKE,sCAAA;A7Es/bF;;A6El/bA;EACE,sCAAA;A7Eq/bF;A6En/bE;EACE,gDAAA;A7Eq/bJ;;A6Ej/bA;EACE,oCAAA;A7Eo/bF;;A6Eh/bE;EACE,gBAAA;EACA,eDzQkB;A5E4vctB;;A6E9+bE;;EAEE,gBAAA;EACA,uBAAA;A7Ei/bJ;A6E7+bI;EACE,YAAA;A7E++bN;;A6E1+bA;EACE,aAAA;A7E6+bF;;A6E1+bA;EACE,aAAA;A7E6+bF;;A6Ez+bE;EACE,gBAAA;A7E4+bJ;;A6Et+bE;EACE,qBAAA;EACA,WAAA;EACA,sBAAA;A7Ey+bJ;;A6Er+bA;;4BAAA;ACpZA;;4BAAA;AAII;EACI,gBAAA;A9E83cR;A8E53cI;EACI,gBAAA;EACA,gBAAA;A9E83cR;A8E73cQ;EACI,gBFsIgB;A5Eyvc5B;A8E73cQ;EACI,gBFoIW;EEnIX,cFbY;EEcZ,qBAAA;A9E+3cZ;A8E53cY;EACI,qBAAA;A9E83chB;A8E33cQ;EACI,wBF4HoB;EE3HpB,yBFgKQ;A5E6tcpB;A8E53cY;EACI,kBAAA;EACA,UAAA;EACA,eAAA;EACA,SAAA;A9E83chB;A8E53cY;EACI,eAAA;A9E83chB;A8E33cQ;EACI,yBFoJQ;EEnJR,gBAAA;A9E63cZ;;A8Ex3cI;EACI,WAAA;EACA,gBAAA;A9E23cR;A8E13cQ;EACI,WAAA;EACA,kBAAA;EAEA,gBAAA;EACA,eAAA;EACA,QAAA;EAEA,2BAAA;A9E43cZ;A8E33cY;EATJ;IAUQ,WAAA;E9E83cd;AACF;A8E33cY;EACI,gBFyFM;EExFN,oBFSL;A5Eo3cX;A8Ez3cY;EACI,gBFoFO;EEnFP,oBFGL;A5Ew3cX;;A8Et3cA;;4BAAA;ACzEA;;4BAAA;AAIE;EACE,iBAAA;EACA,YAAA;EACA,eAAA;A/Eo8cJ;;A+Ej8cA;EACE,sBHgJqB;EG/IrB,aAAA;A/Eo8cF;A+En8cE;EACE,sBAAA;A/Eq8cJ;A+En8cE;EACE,gBH2IY;A5E0zchB;A+En8cE;EACE,kBAAA;EACA,iBAAA;EACA,kBAAA;A/Eq8cJ;A+El8cE;EACE,qBAAA;EACA,WAAA;A/Eo8cJ;A+El8cE;EACE,iBAAA;EACA,eH8HkB;A5Es0ctB;A+El8cE;EACE,gBAAA;A/Eo8cJ;A+El8cE;EACE,UAAA;A/Eo8cJ;A+En8cI;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;A/Eq8cN;;A+Ej8cA;EACE,qBAAA;A/Eo8cF;A+En8cE;EACE,mBAAA;EACA,oBAAA;A/Eq8cJ;A+En8cE;EACE,qBAAA;EACA,QAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;A/Eq8cJ;A+Ep8cI;EACE,yBAAA;EACA,UAAA;EACA,cAAA;A/Es8cN;;A+Eh8cI;EACE,aAAA;A/Em8cN;A+E/7cI;EACE,gBAAA;A/Ei8cN;A+E/7cI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;A/Ei8cN;A+Eh8cM;EACE,kBAAA;A/Ek8cR;;A+E77cA;EACE,qBAAA;A/Eg8cF;A+E/7cE;EACE,qBAAA;A/Ei8cJ;;A+Ez6cE;EACE,0CAAA;EACA,sCAAA;EACA,WHjFI;A5E6/cR;A+E36cI;EACE,WAAA;EACA,gDAAA;EACA,gBAAA;A/E66cN;A+E36cI;EACE,uBAAA;A/E66cN;A+E36cK;EACE,+BAAA;A/E66cP;A+E36cI;EACE,cAAA;A/E66cN;A+Ej6cI;EACE,yBAAA;A/Em6cN;;A+E/5cI;EACE,WHhHE;A5EkhdR;A+Ep6cE;EAOE,yBAAA;EACA,qBAAA;EACA,cHpIY;A5EoidhB;;A+E15cE;EACE,6BH5IgB;EG6IhB,qBAAA;EACA,cAAA;A/E65cJ;A+E55cI;EACE,aAAA;A/E85cN;;A+Ev5cI;EACE,SAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,iCAAA;EACA,oCAAA;A/E05cN;A+Ez5cM;EAVF;IAWI,UAAA;E/E45cN;AACF;A+Ez6cE;EAeE,6BAAA;EACA,4BAAA;EACA,qBAAA;EACA,cH/LoB;A5E4ldxB;A+E55cI;EACE,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,WH/JE;EGgKF,0BAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;A/E85cN;A+E75cM;EAVF;IAWI,kBAAA;E/Eg6cN;AACF;A+E95cI;EACE,aAAA;EACA,SAAA;A/Eg6cN;;A+E7/cE;EACE,yCAAA;EACA,qCAAA;EACA,WHjFI;A5EildR;A+E//cI;EACE,WAAA;EACA,gDAAA;EACA,gBAAA;A/EigdN;A+E//cI;EACE,uBAAA;A/EigdN;A+E//cK;EACE,+BAAA;A/EigdP;A+E//cI;EACE,cAAA;A/EigdN;A+Er/cI;EACE,yBAAA;A/Eu/cN;;A+En/cI;EACE,WHhHE;A5EsmdR;A+Ex/cE;EAOE,yBAAA;EACA,qBAAA;EACA,cHpIY;A5EwndhB;;A+E9+cE;EACE,6BH5IgB;EG6IhB,qBAAA;EACA,cAAA;A/Ei/cJ;A+Eh/cI;EACE,aAAA;A/Ek/cN;;A+E3+cI;EACE,SAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,iCAAA;EACA,oCAAA;A/E8+cN;A+E7+cM;EAVF;IAWI,UAAA;E/Eg/cN;AACF;A+E7/cE;EAeE,6BAAA;EACA,4BAAA;EACA,qBAAA;EACA,cH/LoB;A5EgrdxB;A+Eh/cI;EACE,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,WH/JE;EGgKF,0BAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;A/Ek/cN;A+Ej/cM;EAVF;IAWI,kBAAA;E/Eo/cN;AACF;A+El/cI;EACE,aAAA;EACA,SAAA;A/Eo/cN;;A+EjldE;EACE,wCAAA;EACA,oCAAA;EACA,WHjFI;A5EqqdR;A+EnldI;EACE,WAAA;EACA,qEAAA;EACA,gBAAA;A/EqldN;A+EnldI;EACE,uBAAA;A/EqldN;A+EnldK;EACE,+BAAA;A/EqldP;A+EnldI;EACE,cAAA;A/EqldN;A+EzkdI;EACE,yBAAA;A/E2kdN;;A+EvkdI;EACE,WHhHE;A5E0rdR;A+E5kdE;EAOE,yBAAA;EACA,qBAAA;EACA,cHpIY;A5E4sdhB;;A+ElkdE;EACE,6BH5IgB;EG6IhB,qBAAA;EACA,cAAA;A/EqkdJ;A+EpkdI;EACE,aAAA;A/EskdN;;A+E/jdI;EACE,SAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,iCAAA;EACA,oCAAA;A/EkkdN;A+EjkdM;EAVF;IAWI,UAAA;E/EokdN;AACF;A+EjldE;EAeE,6BAAA;EACA,4BAAA;EACA,qBAAA;EACA,cH/LoB;A5EowdxB;A+EpkdI;EACE,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,WH/JE;EGgKF,0BAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;A/EskdN;A+ErkdM;EAVF;IAWI,kBAAA;E/EwkdN;AACF;A+EtkdI;EACE,aAAA;EACA,SAAA;A/EwkdN;;A+ErqdE;EACE,wCAAA;EACA,oCAAA;EACA,WHjFI;A5EyvdR;A+EvqdI;EACE,WAAA;EACA,oEAAA;EACA,gBAAA;A/EyqdN;A+EvqdI;EACE,uBAAA;A/EyqdN;A+EvqdK;EACE,+BAAA;A/EyqdP;A+EvqdI;EACE,cAAA;A/EyqdN;A+E7pdI;EACE,yBAAA;A/E+pdN;;A+E3pdI;EACE,WHhHE;A5E8wdR;A+EhqdE;EAOE,yBAAA;EACA,qBAAA;EACA,cHpIY;A5EgydhB;;A+EtpdE;EACE,6BH5IgB;EG6IhB,qBAAA;EACA,cAAA;A/EypdJ;A+ExpdI;EACE,aAAA;A/E0pdN;;A+EnpdI;EACE,SAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,iCAAA;EACA,oCAAA;A/EspdN;A+ErpdM;EAVF;IAWI,UAAA;E/EwpdN;AACF;A+ErqdE;EAeE,6BAAA;EACA,4BAAA;EACA,qBAAA;EACA,cH/LoB;A5Ew1dxB;A+ExpdI;EACE,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,WH/JE;EGgKF,0BAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;A/E0pdN;A+EzpdM;EAVF;IAWI,kBAAA;E/E4pdN;AACF;A+E1pdI;EACE,aAAA;EACA,SAAA;A/E4pdN;;A+EzvdE;EACE,wCAAA;EACA,oCAAA;EACA,WHjFI;A5E60dR;A+E3vdI;EACE,WAAA;EACA,yDAAA;EACA,gBAAA;A/E6vdN;A+E3vdI;EACE,uBAAA;A/E6vdN;A+E3vdK;EACE,+BAAA;A/E6vdP;A+E3vdI;EACE,cAAA;A/E6vdN;A+EjvdI;EACE,yBAAA;A/EmvdN;;A+E/udI;EACE,WHhHE;A5Ek2dR;A+EpvdE;EAOE,yBAAA;EACA,qBAAA;EACA,cHpIY;A5Eo3dhB;;A+E1udE;EACE,6BH5IgB;EG6IhB,qBAAA;EACA,cAAA;A/E6udJ;A+E5udI;EACE,aAAA;A/E8udN;;A+EvudI;EACE,SAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,iCAAA;EACA,oCAAA;A/E0udN;A+EzudM;EAVF;IAWI,UAAA;E/E4udN;AACF;A+EzvdE;EAeE,6BAAA;EACA,4BAAA;EACA,qBAAA;EACA,cH/LoB;A5E46dxB;A+E5udI;EACE,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,WH/JE;EGgKF,0BAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;A/E8udN;A+E7udM;EAVF;IAWI,kBAAA;E/EgvdN;AACF;A+E9udI;EACE,aAAA;EACA,SAAA;A/EgvdN;;A+E70dE;EACE,yCAAA;EACA,qCAAA;EACA,WHjFI;A5Ei6dR;A+E/0dI;EACE,WAAA;EACA,oEAAA;EACA,gBAAA;A/Ei1dN;A+E/0dI;EACE,uBAAA;A/Ei1dN;A+E/0dK;EACE,+BAAA;A/Ei1dP;A+E/0dI;EACE,cAAA;A/Ei1dN;A+Er0dI;EACE,yBAAA;A/Eu0dN;;A+En0dI;EACE,WHhHE;A5Es7dR;A+Ex0dE;EAOE,yBAAA;EACA,qBAAA;EACA,cHpIY;A5Ew8dhB;;A+E9zdE;EACE,6BH5IgB;EG6IhB,qBAAA;EACA,cAAA;A/Ei0dJ;A+Eh0dI;EACE,aAAA;A/Ek0dN;;A+E3zdI;EACE,SAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,iCAAA;EACA,oCAAA;A/E8zdN;A+E7zdM;EAVF;IAWI,UAAA;E/Eg0dN;AACF;A+E70dE;EAeE,6BAAA;EACA,4BAAA;EACA,qBAAA;EACA,cH/LoB;A5EggexB;A+Eh0dI;EACE,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,WH/JE;EGgKF,0BAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;A/Ek0dN;A+Ej0dM;EAVF;IAWI,kBAAA;E/Eo0dN;AACF;A+El0dI;EACE,aAAA;EACA,SAAA;A/Eo0dN;;A+Ej6dE;EACE,0CAAA;EACA,sCAAA;EACA,WHjFI;A5Eq/dR;A+En6dI;EACE,WAAA;EACA,qEAAA;EACA,gBAAA;A/Eq6dN;A+En6dI;EACE,uBAAA;A/Eq6dN;A+En6dK;EACE,+BAAA;A/Eq6dP;A+En6dI;EACE,cAAA;EAEE,cHjHK;A5Eqheb;A+Et7dE;EAsBI,cHrHO;EGsHP,yBH9HQ;A5Eiied;A+El6dM;EACE,aAAA;A/Eo6dR;A+Ej6dI;EACE,yBAAA;A/Em6dN;;A+E/5dI;EACE,WHhHE;EGkHA,cHnIK;A5Eoieb;A+Er6dE;EAOE,yBAAA;EACA,qBAAA;EACA,cHpIY;EGuIV,cH3IO;A5E0ieb;;A+E55dE;EACE,6BH5IgB;EG6IhB,qBAAA;EACA,cAAA;A/E+5dJ;A+E95dI;EACE,aAAA;A/Eg6dN;A+Er6dE;EAQI,cHtJO;A5Esjeb;;A+E55dI;EACE,SAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,iCAAA;EACA,oCAAA;A/E+5dN;A+E95dM;EAVF;IAWI,UAAA;E/Ei6dN;AACF;A+E96dE;EAeE,6BAAA;EACA,4BAAA;EACA,qBAAA;EACA,cH/LoB;A5EimexB;A+Ej6dI;EACE,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,WH/JE;EGgKF,0BAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;A/Em6dN;A+El6dM;EAVF;IAWI,kBAAA;E/Eq6dN;AACF;A+En6dI;EACE,aAAA;EACA,SAAA;A/Eq6dN;;A+ElgeE;EACE,uCAAA;EACA,mCAAA;EACA,WHjFI;A5EsleR;A+EpgeI;EACE,WAAA;EACA,oEAAA;EACA,gBAAA;A/EsgeN;A+EpgeI;EACE,mEAAA;A/EsgeN;A+EpgeK;EACE,+BAAA;A/EsgeP;A+EpgeI;EACE,cAAA;A/EsgeN;A+E1/dI;EACE,yBAAA;A/E4/dN;;A+Ex/dI;EACE,WHhHE;A5E2meR;A+E7/dE;EAOE,yBAAA;EACA,qBAAA;EACA,cHpIY;A5E6nehB;;A+En/dE;EACE,6BH5IgB;EG6IhB,qBAAA;EACA,cAAA;A/Es/dJ;A+Er/dI;EACE,aAAA;A/Eu/dN;;A+Eh/dI;EACE,SAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,iCAAA;EACA,oCAAA;A/Em/dN;A+El/dM;EAVF;IAWI,UAAA;E/Eq/dN;AACF;A+ElgeE;EAeE,6BAAA;EACA,4BAAA;EACA,qBAAA;EACA,cH/LoB;A5EqrexB;A+Er/dI;EACE,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,WH/JE;EGgKF,0BAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;A/Eu/dN;A+Et/dM;EAVF;IAWI,kBAAA;E/Ey/dN;AACF;A+Ev/dI;EACE,aAAA;EACA,SAAA;A/Ey/dN;;A+En/dI;EACE,iBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;A/Es/dN;A+Ep/dM;EACE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;A/Es/dR;;A+Ej/dA;EACE,iBAAA;EACA,qBAAA;A/Eo/dF;;A+Ej/dA;;4BAAA;AC5OA;;4BAAA;AAII;EACI,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AhFkueR;AgFjueQ;EACI,eAAA;AhFmueZ;AgFjueQ;EACI,mBAAA;AhFmueZ;AgFjueQ;EACI,mBAAA;AhFmueZ;AgFjueQ;EACI,mBAAA;AhFmueZ;AgFjueQ;EACI,mBAAA;AhFmueZ;AgFhueY;EACI,WAAA;AhFkuehB;AgF/teQ;EACI,kBAAA;EACA,yBJFC;EIGD,SAAA;EACA,UAAA;EACA,mBAAA;EACA,sBAAA;AhFiueZ;AgF/teQ;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,yBJ/BI;EIgCJ,mBAAA;EACA,WAAA;EACA,SAAA;AhFiueZ;;AgF5teI;EACI,qBAAA;AhF+teR;AgF7teY;EACI,sBAAA;EACA,gBAAA;AhF+tehB;AgF9tegB;EACI,uCAAA;EACA,gBAAA;AhFguepB;AgF7teY;EACI,gBAAA;AhF+tehB;AgF3teI;EACG,kBAAA;AhF6teP;AgF5teQ;EACI,eAAA;AhF8teZ;;AgF1teA;EACI,oBAAA;AhF6teJ;AgF3teQ;EACI,mBAAA;AhF6teZ;AgF1teI;EACI,mBAAA;AhF4teR;AgFzteQ;EACI,kBAAA;EACA,UAAA;EACA,WAAA;AhF2teZ;AgFvteQ;EACI,aAAA;AhFyteZ;;AgFrteA;;4BAAA;AC/FA;;4BAAA;AAGA;EACE,qBL4Jc;EK3Jd,+BAAA;EACA,gBAAA;AjF0zeF;AiFxzeE;EACE,gBAAA;AjF0zeJ;AiFvzeE;EACE,WLoJa;EKnJb,YLmJa;EKlJb,gBAAA;AjFyzeJ;;AiFnzeE;EACE,sCAFyC;EAGzC,mEAAA;EACA,WLeI;EKdJ,gBAAA;AjFszeJ;;AiF1zeE;EACE,yBAFyC;EAGzC,2DAAA;EACA,WLeI;EKdJ,gBAAA;AjF6zeJ;;AiFj0eE;EACE,yBAFyC;EAGzC,0DAAA;EACA,WLeI;EKdJ,gBAAA;AjFo0eJ;;AiFx0eE;EACE,yBAFyC;EAGzC,0DAAA;EACA,WLeI;EKdJ,gBAAA;AjF20eJ;;AiF/0eE;EACE,yBAFyC;EAGzC,2DAAA;EACA,WLeI;EKdJ,gBAAA;AjFk1eJ;;AiFt1eE;EACE,yBAFyC;EAGzC,4DAAA;EACA,WLeI;EKdJ,gBAAA;AjFy1eJ;;AiF71eE;EACE,yBAFyC;EAGzC,yDAAA;EACA,WLeI;EKdJ,gBAAA;AjFg2eJ;;AiFp2eE;EACE,yBAFyC;EAGzC,0DAAA;EACA,WLeI;EKdJ,gBAAA;AjFu2eJ;;AiFn2eA;EACE,sCAAA;AjFs2eF;;AiFn2eA;EACE,wCAAA;AjFs2eF;;AiFj2eE;EACE,kBAAA;EACA,sCAH2C;EAI3C,oEAAA;EACA,sBAAA;AjFo2eJ;;AiFx2eE;EACE,kBAAA;EACA,yBAH2C;EAI3C,4DAAA;EACA,sBAAA;AjF22eJ;;AiF/2eE;EACE,kBAAA;EACA,yBAH2C;EAI3C,2DAAA;EACA,sBAAA;AjFk3eJ;;AiFt3eE;EACE,kBAAA;EACA,yBAH2C;EAI3C,2DAAA;EACA,sBAAA;AjFy3eJ;;AiF73eE;EACE,kBAAA;EACA,yBAH2C;EAI3C,4DAAA;EACA,sBAAA;AjFg4eJ;;AiFp4eE;EACE,kBAAA;EACA,yBAH2C;EAI3C,6DAAA;EACA,sBAAA;AjFu4eJ;;AiF34eE;EACE,kBAAA;EACA,yBAH2C;EAI3C,0DAAA;EACA,sBAAA;AjF84eJ;;AiFl5eE;EACE,kBAAA;EACA,yBAH2C;EAI3C,2DAAA;EACA,sBAAA;AjFq5eJ;;AiFj5eA;EACE,sCAAA;AjFo5eF;;AiFj5eA;EACE,wCAAA;AjFo5eF;;AiFj5eA;;4BAAA;ACvDA;;4BAAA;AAKI;EACE,qBAAA;AlF48eN;AkF38eM;EACE,kBAAA;EACA,YAAA;EACA,UAAA;AlF68eR;AkF58eQ;EACE,SAAA;EACA,kBAAA;EACA,2BAAA;EACA,YAAA;EACA,sCAAA;EACA,UAAA;EACA,kBAAA;AlF88eV;AkF78eU;EACE,YAAA;EACA,sBNkBJ;EMjBI,yCAAA;AlF+8eZ;AkF78eU;EACE,oCAAA;EACA,UAAA;EACA,mBAAA;EACA,2BAAA;EACA,YAAA;AlF+8eZ;AkF78eU;EACE,SAAA;EACA,UAAA;EACA,UAAA;AlF+8eZ;AkF78eU;EACE,UAAA;EACA,QAAA;EACA,UAAA;AlF+8eZ;AkF38eM;EACE,kBAAA;EACA,cN3CgB;A5Ew/exB;AkF58eQ;EACE,sBAAA;EACA,YAAA;EACA,WAAA;AlF88eV;AkF38eM;EACE,iBAAA;AlF68eR;AkF38eM;EACE,gBAAA;AlF68eR;AkF58eQ;EACE,kBAAA;AlF88eV;AkF78eU;EACE,cAAA;AlF+8eZ;;AkFj8ec;EACE,cAAA;EACA,+BAAA;AlFo8ehB;AkF57eE;EACE,eAAA;EACA,WAAA;EACA,oCAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;EACA,OAAA;AlF87eJ;;AkF17eE;EACE,uBAAA;EACA,cAAA;AlF67eJ;AkF57eI;EACE,aAAA;AlF87eN;;AkF17eA;;4BAAA;ACxGA;;4BAAA;AAGA;EACC,kBAAA;EACA,kBAAA;AnFwifD;AmFtifE;EACC,WP+BK;A5EygfR;AmFtifE;EACC,WP4BK;EO3BL,YAAA;AnFwifH;AmFpifE;EACC,WPsBK;A5EghfR;AmFlifE;EACC,WPgBK;A5EohfR;;AmFhifA;EACC,4BAAA;AnFmifD;AmFjifC;EACC,qBAAA;AnFmifF;;AmF/hfA;EACC,2BAAA;AnFkifD;;AmF/hfC;EACC,0BAAA;AnFkifF;;AmF/hfA;;4BAAA;AC1CA;;4BAAA;AAIE;EACE,gBAAA;EACA,cRiBM;EQhBN,0BAAA;ApF8kfJ;AoF5kfE;EACE,cRaM;A5EikfV;AoF5kfE;EACE,YAAA;ApF8kfJ;AoF3kfI;EACE,kBAAA;ApF6kfN;AoF3kfI;EACE,WRkBE;EQjBF,gBAAA;ApF6kfN;AoF1kfE;EACE,gBAAA;ApF4kfJ;;AoFzkfA;;4BAAA;AC5BA;;4BAAA;AAGA;EACE,2BAAA;ArF2mfF;;AqFxmfA;EACE,gFAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;ArF2mfF;AqF1mfE;EACE,gFAAA;EACA,gBAAA;ArF4mfJ;AqF1mfE;EAVF;IAWI,gBAAA;ErF6mfF;AACF;AqF5mfE;EAbF;IAcI,gBAAA;IACA,kBAAA;IACA,eAAA;ErF+mfF;AACF;;AqF5mfE;EACE,cT1BoB;ES2BpB,gFAAA;ArF+mfJ;;AqFpmfA;EANE,uJAAA;EACA,YAAA;EACA,WTGM;ESFN,0BAAA;EACA,yBAAA;EAIA,WTHM;A5E8mfR;AqF1mfE;EAGE,gBAAA;EACA,iCAAA;EACA,sIAAA;ArF0mfJ;;AqFvmfA;EAjBE,sJAAA;EACA,YAAA;EACA,WTGM;ESFN,0BAAA;EACA,yBAAA;ArF4nfF;AqF7mfE;EAKE,gBAAA;EACA,iCAAA;EACA,qIAAA;ArF2mfJ;;AqFxmfA;EA7BE,sNAAA;EACA,YAAA;EACA,WTGM;ESFN,0BAAA;EACA,yBAAA;ArFyofF;AqF9mfE;EAKE,gBAAA;EACA,iCAAA;EACA,gLAAA;ArF4mfJ;;AqFzmfA;EAzCE,qNAAA;EACA,YAAA;EACA,WTGM;ESFN,0BAAA;EACA,yBAAA;ArFspfF;AqF/mfE;EAKE,gBAAA;EACA,iCAAA;EACA,+KAAA;ArF6mfJ;;AqF1mfA;EArDE,sLAAA;EACA,YAAA;EACA,WTGM;ESFN,0BAAA;EACA,yBAAA;ArFmqfF;AqFhnfE;EAKE,gBAAA;EACA,iCAAA;EACA,0JAAA;ArF8mfJ;;AqF3mfA;EAjEE,qNAAA;EACA,YAAA;EACA,WTGM;ESFN,0BAAA;EACA,yBAAA;ArFgrfF;AqFjnfE;EAKE,gBAAA;EACA,iCAAA;EACA,+KAAA;ArF+mfJ;;AqF5mfA;EA7EE,0HAAA;EACA,YAAA;EACA,WTGM;ESFN,0BAAA;EACA,yBAAA;ArF6rfF;AqFlnfE;EAKE,gBAAA;EACA,iCAAA;EACA,kIAAA;ArFgnfJ;;AqF7mfA;EAzFE,sNAAA;EACA,YAAA;EACA,WTGM;ESFN,0BAAA;EACA,yBAAA;ArF0sfF;AqFnnfE;EAKE,gBAAA;EACA,iCAAA;EACA,gLAAA;ArFinfJ;;AqFhmfA;EACE,yBT0BY;A5Eykfd;;AqFjmfA;EACE,eTwBiB;A5E4kfnB;;AqFlmfA;EACE,eTsBiB;A5E+kfnB;;AqFnmfA;EACE,uBTqBe;ESpBf,eTmBiB;A5EmlfnB;;AqFnmfE;EACE,iBAAA;EACA,mBAAA;ArFsmfJ;AqFzmfA;EAKE,oBAAA;ArFumfF;;AqFrmfA;EACE,sBAAA;EACA,WTpIM;A5E4ufR;AqFvmfE;EAEE,gBTvII;ESwIJ,cAAA;ArFwmfJ;;AqFnmfE;EACE,8DAAA;ArFsmfJ;AqFrmfI;EAGE,gDAAA;EACA,4CAAA;ArFqmfN;;AqFlmfE;EACE,6DAAA;ArFqmfJ;AqFpmfI;EACE,qBAbyB;ArFmnf/B;;AqFlnfE;EACE,8DAAA;ArFqnfJ;AqFpnfI;EAGE,+CAAA;EACA,2CAAA;ArFonfN;;AqFjnfE;EACE,4DAAA;ArFonfJ;AqFnnfI;EACE,qBAbyB;ArFkof/B;;AqFjofE;EACE,8DAAA;ArFoofJ;AqFnofI;EAGE,qEAAA;EACA,iEAAA;ArFmofN;;AqFhofE;EACE,2DAAA;ArFmofJ;AqFlofI;EACE,qBAbyB;ArFipf/B;;AqFhpfE;EACE,8DAAA;ArFmpfJ;AqFlpfI;EAGE,mEAAA;EACA,+DAAA;ArFkpfN;;AqF/ofE;EACE,2DAAA;ArFkpfJ;AqFjpfI;EACE,qBAbyB;ArFgqf/B;;AqF/pfE;EACE,8DAAA;ArFkqfJ;AqFjqfI;EAGE,oEAAA;EACA,gEAAA;ArFiqfN;;AqF9pfE;EACE,4DAAA;ArFiqfJ;AqFhqfI;EACE,qBAbyB;ArF+qf/B;;AqF9qfE;EACE,8DAAA;ArFirfJ;AqFhrfI;EAGE,qEAAA;EACA,iEAAA;ArFgrfN;;AqF7qfE;EACE,6DAAA;ArFgrfJ;AqF/qfI;EACE,qBAbyB;ArF8rf/B;;AqF7rfE;EACE,8DAAA;ArFgsfJ;AqF/rfI;EAGE,oEAAA;EACA,gEAAA;ArF+rfN;;AqF5rfE;EACE,0DAAA;ArF+rfJ;AqF9rfI;EACE,qBAbyB;ArF6sf/B;;AqF5sfE;EACE,8DAAA;ArF+sfJ;AqF9sfI;EAGE,yDAAA;EACA,qDAAA;ArF8sfN;;AqF3sfE;EACE,2DAAA;ArF8sfJ;AqF7sfI;EACE,qBAbyB;ArF4tf/B;;AqF1sfA;EACE,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yET7JiB;ES8JjB,uBAAA;ArF6sfF;AqF5sfE;EACE,gCAAA;ArF8sfJ;;AqF1sfA;EACE,WT3KM;A5Ew3fR;AqF5sfE;EAEE,WT9KI;A5E23fR;;AqFxsfE;EACE,yBAAA;EACA,yBAAA;EACA,WTtLI;A5Ei4fR;;AqFvsfA;EAxFE,kBAAA;ArFmyfF;;AqFxsfA;EA3FE,mBAAA;ArFuyfF;;AqFvsfI;EA1FF,4BAAA;ArFqyfF;AqFxsfI;EA1FF,4BAAA;ArFqyfF;;AqFpsfI;EApGF,0BAAA;ArF4yfF;AqFrsfI;EApGF,0BAAA;ArF4yfF;;AqFlsfE;EACE,mBAAA;EACA,kBAAA;ArFqsfJ;AqFxsfA;EAKE,oBAAA;ArFssfF;;AqFlsfE;EACE,mBAAA;EACA,kBAAA;ArFqsfJ;AqFnsfE;EACE,mBAAA;EACA,kBAAA;ArFqsfJ;AqF5sfA;EASE,oBAAA;ArFssfF;;AqFjsfM;EACE,QAAA;ArFosfR;AqFlsfM;EACE,QAAA;ArFosfR;AqF/rfI;EACE,eAAA;ArFisfN;;AqF5rfE;EACE,oBAAA;ArF+rfJ;AqF9rfI;EACE,gBAAA;ArFgsfN;AqF7rfE;EACE,kBAAA;EACA,mBAAA;ArF+rfJ;AqF5rfI;EACE,aAAA;ArF8rfN;;AqF1rfA;EACE,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,WT7QM;ES8QN,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;EACA,wBAAA;ArF6rfF;AqF5rfE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,sDAAA;ArF8rfJ;;AqF3rfA;;4BAAA;AC1UA;;4BAAA;AAIA;EACE,mBVmLmB;EUlLnB,YAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBViLoB;EUhLpB,+CVkLgB;A5Ew1flB;AsFxggBE;EACE,0CVsLoB;EUrLpB,yBAAA;AtF0ggBJ;AsFvggBE;EACE,sBVqBI;EUpBJ,aVoKW;EUnKX,gCVqKgB;EUpKhB,4BVqKkB;EUpKlB,6BVoKkB;EUnKlB,kBAAA;AtFyggBJ;AsFvggBI;EACE,8BAAA;AtFyggBN;AsFrggBM;EAEE,gBAAA;EACA,0BV6JqB;A5Ey2f7B;AsFlggBI;EACE,eVyJkB;EUxJlB,cVpCuB;EUqCvB,eAAA;EACA,cAAA;EACA,mBAAA;AtFoggBN;AsFjggBI;EACE,wBAAA;EACA,WAAA;EACA,SAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,sBVdE;EUeF,UAAA;AtFmggBN;AsFjggBM;EACE,iBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,4BAAA;AtFmggBR;AsFjggBQ;EACE,qBAAA;AtFmggBV;AsFhggBY;EACE,cAAA;EACA,eAAA;EACA,2BAAA;AtFkggBd;AsFhggBc;EACE,YAAA;AtFkggBhB;AsF3/fM;EACE,aAAA;EACA,eAAA;EACA,cV7DK;EU8DL,iBAAA;AtF6/fR;AsF3/fQ;EACE,eAAA;AtF6/fV;AsFv/fE;EACE,aVyFW;EUxFX,6BVtEgB;A5E+jgBpB;AsFt/fM;EACE,gBAAA;AtFw/fR;AsFn/fE;EACE,2CAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AtFq/fJ;AsFl/fE;EACE,sBVzEI;EU0EJ,6BVwEgB;EUvEhB,aVqEW;EUpEX,+BVuEkB;EUtElB,gCVsEkB;A5E86ftB;AsFh/fI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,0CAAA;EACA,UAAA;EACA,mBAAA;EACA,uBAAA;AtFk/fN;AsFh/fM;EACE,cAAA;EACA,2BAAA;EACA,eAAA;AtFk/fR;AsF7+fE;EACE,eAAA;EACA,MAAA;EACA,cAAA;EACA,gBAAA;EACA,QAAA;EACA,gBAAA;EACA,yBAAA;EACA,yBAAA;EACA,aAAA;AtF++fJ;AsF7+fI;EACE,cAAA;AtF++fN;;AsFz+fI;EACE,8BAAA;EACA,mBAAA;EACA,cV9JuB;A5E0ogB7B;;AsFv+fA;EACE,gBAAA;AtF0+fF;AsFx+fE;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,sBAAA;EACA,kBAAA;AtF0+fJ;AsFx+fI;EACE,eAAA;AtF0+fN;AsFt+fE;EACE,gBAAA;AtFw+fJ;;AsFn+fE;EACE,oBAAA;AtFs+fJ;;AsFl+fA;EACE,gBAAA;EACA,aAAA;AtFq+fF;AsFp+fE;EACE,UAAA;AtFs+fJ;AsFp+fI;EACE,kBAAA;EACA,kBAAA;EACA,qBAAA;AtFs+fN;AsFl+fE;EACE,kBAAA;AtFo+fJ;AsFl+fI;EACE,aAAA;EACA,YAAA;EACA,sBV5KE;EU6KF,UAAA;EACA,kBAAA;AtFo+fN;AsFh+fE;EACE,kBAAA;AtFk+fJ;AsFh+fI;EACE,qBAAA;EACA,eAAA;AtFk+fN;AsFh+fQ;EACE,eAAA;AtFk+fV;AsF/9fM;EACE,UAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,yBAAA;AtFi+fR;AsF/9fQ;EACE,2BAAA;EACA,yBAAA;AtFi+fV;AsF19fI;EACE,mBAAA;EACA,gBAAA;EACA,cVpPuB;EUqPvB,eAAA;AtF49fN;AsFx9fE;EACE,UAAA;AtF09fJ;AsFv9fM;EACE,8BAAA;AtFy9fR;AsF39fI;EAKE,aAAA;EACA,kBAAA;AtFy9fN;AsFv9fM;EACE,gBAAA;EACA,eAAA;AtFy9fR;AsFt9fM;EACE,eAAA;EACA,cV3QqB;A5EmugB7B;AsFt9fM;EACE,eAAA;EACA,gBAAA;AtFw9fR;AsFt9fM;EACE,eAAA;EACA,qBAAA;EACA,mBAAA;AtFw9fR;AsFr9fM;EACE,mBAAA;AtFu9fR;;AsFh9fE;EACE,kBAAA;EACA,0DAAA;EACA,4BAAA;EACA,sBAAA;AtFm9fJ;AsFl9fI;EACE,kBAAA;EACA,mBAAA;AtFo9fN;AsFn9fM;EAHF;IAII,kBAAA;EtFs9fN;AACF;AsFn9fE;EACE,gBAAA;AtFq9fJ;AsFn9fM;EACE,6BAAA;AtFq9fR;AsFl9fI;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AtFo9fN;AsFn9fM;EAJF;IAKI,gBAAA;EtFs9fN;AACF;AsFr9fM;EACE,kBAAA;AtFu9fR;AsFr9fU;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,6CAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;AtFu9fZ;AsFt9fY;EACE,WAAA;EACA,YAAA;AtFw9fd;AsFl9fI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;AtFo9fN;AsFj9fE;EACE,+FAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AtFm9fJ;AsFl9fI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;AtFo9fN;AsFn9fM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,wBAAA;AtFq9fR;AsFj9fE;EACE,YAAA;EACA,wBAAA;EACA,mBAAA;AtFm9fJ;AsFl9fI;EACE,YAAA;EACA,mBAAA;AtFo9fN;;AsF/8fA;;4BAAA;ACvXA;;4BAAA;AAGA;EACE,oBAAA;AvF40gBF;AuF10gBE;EACE,mBAAA;AvF40gBJ;AuF10gBI;EACE,gBAAA;AvF40gBN;;AuFt0gBA;EACE,cXd2B;A5Eu1gB7B;;AuFt0gBA;;4BAAA;ACpBA;;4BAAA;AAGA;EACE,qBAAA;AxFg2gBF;;AwF91gBA;EACE,yBAAA;AxFi2gBF;;AwF91gBE;EACE,QAAA;AxFi2gBJ;AwF91gBI;EACE,yBAAA;AxFg2gBN;AwF71gBM;EACE,gCAAA;AxF+1gBR;;AwFz1gBA;;;;EAIE,sCAAA;AxF41gBF;AwF31gBE;;;;EACE,sCAAA;AxFg2gBJ;;AwF71gBA;EACE,uBAAA;EACA,gDAAA;AxFg2gBF;AwF71gBI;;EACE,kBZDE;A5Ei2gBR;AwF71gBE;EACE,8BAAA;AxF+1gBJ;AwFz1gBc;EACE,iDAAA;AxF21gBhB;AwFn1gBE;EACE,iCAAA;EACA,6BAAA;AxFq1gBJ;AwFn1gBE;EACE,aAAA;AxFq1gBJ;AwFn1gBE;EACE,wCAAA;EACA,gCAAA;AxFq1gBJ;AwFn1gBE;EACE,gBAAA;AxFq1gBJ;AwFn1gBE;EACE,mBAAA;AxFq1gBJ;AwFn1gBE;;;EAGE,sCAAA;AxFq1gBJ;AwFn1gBE;;;EAGE,sBAAA;EACA,4BAAA;AxFq1gBJ;AwFn1gBE;EACE,kDAAA;AxFq1gBJ;AwFn1gBE;EACE,mDAAA;AxFq1gBJ;AwFn1gBE;;;;;;;;;EASE,iDAAA;AxFq1gBJ;AwFp1gBI;;;;;;;;;EACE,iDAAA;AxF81gBN;AwF31gBE;;;EAGE,2CAAA;AxF61gBJ;AwF11gBI;;EAEE,sBAAA;AxF41gBN;AwFz1gBE;EACE,sBAAA;AxF21gBJ;AwFz1gBE;;EAEE,iDAAA;EACA,sBAAA;EACA,qBAAA;AxF21gBJ;;AwFt1gBA;EACE,wBAAA;AxFy1gBF;;AwFt1gBE;EACE,WAAA;AxFy1gBJ;;AwFt1gBA;EACE,aAAA;EACA,sBAAA;AxFy1gBF;AwFx1gBE;EACE,YAAA;AxF01gBJ;AwFx1gBE;EACE,qBAAA;EACA,uBAAA;AxF01gBJ;;AwFv1gBA;;EAEE,YAAA;AxF01gBF;AwFx1gBI;;;;;;EAGE,sCAAA;AxF61gBN;AwF31gBI;;EACE,sCAAA;AxF81gBN;AwF71gBM;;EACE,sCAAA;AxFg2gBR;AwF71gBI;;EACE,sCAAA;AxFg2gBN;AwF31gBU;;;EAEE,sCAAA;AxF81gBZ;AwFx1gBE;;EACE,aAAA;AxF21gBJ;;AwFx1gBA;EACE,uBAAA;AxF21gBF;;AwFx1gBA;EACE;IACE,aAAA;ExF21gBF;AACF;AwFz1gBA;EACE;IACE,cAAA;ExF21gBF;EwFz1gBI;IACE,gBAAA;ExF21gBN;AACF;AwFv1gBA;EAEI;;;IAGE,sBAAA;IACA,4BAAA;ExFw1gBJ;EwFj1gBQ;IACE,eAAA;ExFm1gBV;AACF;AwF70gBA;EAGM;IACE,gBAAA;ExF60gBN;AACF;AwFt0gBE;EACE,sBZpMI;A5E4ghBR;AwFt0gBE;EACE,aAAA;EACA,yBAAA;EACA,8BAAA;EACA,WAAA;AxFw0gBJ;AwFv0gBI;EACE,mBAAA;AxFy0gBN;AwFv0gBI;EACE,gBAAA;AxFy0gBN;AwFv0gBI;EACE,aAAA;EACA,yBZlPU;EYmPV,yBAAA;AxFy0gBN;AwFx0gBM;EACE,gBAAA;AxF00gBR;AwFx0gBM;EACE,eAAA;AxF00gBR;AwFp0gBM;EACE,uBAAA;AxFs0gBR;AwFl0gBM;EACE,SAAA;AxFo0gBR;AwFl0gBM;;EAEE,cZ9QgB;A5EklhBxB;AwFj0gBQ;EACE,YAAA;AxFm0gBV;AwF/zgBI;EACE,YAAA;EACA,yBZlRU;EYmRV,yBAAA;AxFi0gBN;AwF7zgBQ;EACE,aAAA;AxF+zgBV;;AwFzzgBA;EACE,aAAA;EACA,sCAAA;AxF4zgBF;;AwFzzgBE;EACE,eAAA;EACA,SAAA;AxF4zgBJ;AwFzzgBI;EACE,iDAAA;AxF2zgBN;;AwFvzgBA;;4BAAA;ACrTA;;4BAAA;AAGA;EACE,SAAA;AzFknhBF;;AyF/mhBE;EACE,sDAAA;EACA,cbDY;EaEZ,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;AzFknhBJ;AyFjnhBI;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EAEA,2BAAA;EACA,gBAAA;EACA,YAAA;EACA,0BAAA;EACA,eAAA;EACA,SAAA;AzFmnhBN;AyFjnhBI;EACE,WbWE;A5EwmhBR;AyFhnhBE;EACE,8BAAA;AzFknhBJ;;AyF7mhBI;EACE,WAAA;AzFgnhBN;;AyF1mhBI;EACE,YAAA;AzF6mhBN;AyF5mhBM;EAFF;IAGI,WAAA;IACA,kBAAA;EzF+mhBN;AACF;;AyF1mhBE;EACE,kCAAA;EACA,cbrDyB;EasDzB,UAAA;EACA,WAAA;AzF6mhBJ;AyF5mhBI;EACE,eAAA;AzF8mhBN;AyF5mhBI;EACE,aAAA;AzF8mhBN;AyF3mhBE;EACE,gBAAA;AzF6mhBJ;;AyF1mhBA;EACE,oBAAA;AzF6mhBF;AyF5mhBE;EACE,kBAAA;AzF8mhBJ;AyF7mhBI;EACE,mBAAA;AzF+mhBN;AyF5mhBE;EACE,iBAAA;AzF8mhBJ;AyF7mhBI;EACE,yBAAA;EACA,4BAAA;EACA,aAAA;AzF+mhBN;AyF5mhBE;EACE,gBAAA;AzF8mhBJ;AyF5mhBE;EACE,kBAAA;EACA,qBAAA;EACA,mBAAA;AzF8mhBJ;AyF7mhBI;EACE,YAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AzF+mhBN;AyF7mhBI;EACE,aAAA;EACA,kBAAA;EACA,QAAA;EACA,yBAAA;EACA,gBAAA;EACA,+CAAA;EACA,UAAA;EACA,OAAA;EACA,SAAA;AzF+mhBN;AyF9mhBM;EACE,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;AzFgnhBR;AyF9mhBM;EACE,kBAAA;AzFgnhBR;AyF3mhBE;EACE,yBAAA;AzF6mhBJ;AyF3mhBE;EACE,cAAA;AzF6mhBJ;;AyFzmhBE;EACE,kBAAA;EACA,qBAAA;AzF4mhBJ;AyF3mhBI;EACE,YAAA;EACA,aAAA;EACA,YAAA;AzF6mhBN;AyF3mhBI;EACE,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,OAAA;AzF6mhBN;AyF5mhBM;EACE,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;AzF8mhBR;AyFzmhBE;EACE,yBAAA;AzF2mhBJ;AyFzmhBE;EACE,cAAA;AzF2mhBJ;AyFzmhBM;EACE,yBAAA;AzF2mhBR;;AyFrmhBA;;4BAAA;ACvKA;;4BAAA;AAIE;EACE,wBAAA;A1FixhBJ;A0F5whBQ;EACE,UAAA;A1F8whBV;A0FzwhBE;EACE,YAAA;EACA,kBAAA;A1F2whBJ;A0F1whBI;EACE,mBAAA;EACA,iBAAA;A1F4whBN;A0FzwhBE;EACE,aAAA;A1F2whBJ;A0F1whBI;EACE,eAAA;A1F4whBN;A0FzwhBM;EACE,eAAA;EACA,cdnBO;A5E8xhBf;A0FxwhBI;EACE,iBAAA;A1F0whBN;A0FzwhBM;EACE,cd5BQ;A5EuyhBhB;A0FzwhBM;EACE,gBAAA;A1F2whBR;A0FvwhBM;EACE,cdjCO;A5E0yhBf;;A0FlwhBI;EACE,uBAAA;EACA,sCAAA;EACA,2BAAA;A1FqwhBN;;A0FjwhBA;EACE,uBAAA;A1FowhBF;A0FlwhBI;EACE,gCAAA;A1FowhBN;A0FhwhBI;EACE,iCAAA;A1FkwhBN;A0F3whBA;EAYE,UAAA;A1FkwhBF;A0FhwhBI;EACE,iBAAA;A1FkwhBN;A0F/vhBE;EACE,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,sBAAA;EACA,Wd5CI;A5E6yhBR;A0F/vhBE;EACE,gBAAA;A1FiwhBJ;A0F/vhBE;EACE,4BAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;A1FiwhBJ;A0FhwhBI;EACE,SAAA;A1FkwhBN;A0FjwhBM;EAEE,gCAAA;EACA,sBAAA;EACA,gBAAA;A1FkwhBR;A0FhwhBM;EACE,sCAAA;EACA,yBAAA;EACA,kCAAA;A1FkwhBR;A0F9vhBE;EACE,mBAAA;A1FgwhBJ;A0F/vhBI;EACE,qBdjGQ;EckGR,cd1FO;Ec2FP,eAAA;EACA,cAAA;EACA,gBAAA;EACA,sBd7EE;A5E80hBR;A0F9vhBE;EACE,yBAAA;A1FgwhBJ;A0F5vhBQ;;EACE,8BAAA;A1F+vhBV;A0F9vhBU;;EACE,WAAA;EACA,SAAA;EACA,WAAA;A1FiwhBZ;A0F/vhBU;;EACE,gBAAA;EACA,iBAAA;A1FkwhBZ;A0F5vhBM;;EAEE,gCAAA;A1F8vhBR;A0F3vhBI;;EAEE,gBAAA;A1F6vhBN;A0F1vhBE;EACE,mBAAA;EACA,iBAAA;A1F4vhBJ;A0F3vhBI;EACE,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;A1F6vhBN;;A0FzvhBA;EACE,sBAAA;A1F4vhBF;;A0FzvhBE;EACE,0BAAA;EACA,sBdhII;A5E43hBR;A0FzvhBI;EACE,iBAAA;EACA,sCAAA;EACA,qBAAA;EACA,WdvIE;EcwIF,kBAAA;EACA,mBAAA;EACA,kBAAA;A1F2vhBN;A0FvvhBI;EAEE,qCAAA;EACA,yCAAA;EACA,2BAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;A1FwvhBN;A0FrvhBM;EACE,sBAAA;A1FuvhBR;A0FnvhBE;EACE,oCAAA;EACA,wBAAA;A1FqvhBJ;A0F9uhBQ;;;;;;;;;EAEE,uBAAA;A1FuvhBV;A0FnvhBI;;EAEE,yBAAA;EACA,YAAA;A1FqvhBN;;A0F7uhBM;;EACE,gBAAA;A1FivhBR;;A0F3uhBE;EACE,WAAA;EACA,YAAA;A1F8uhBJ;A0F5uhBE;EACE,4BAAA;EACA,WAAA;EACA,YAAA;A1F8uhBJ;A0F5uhBE;EACE,gCAAA;EACA,WAAA;EACA,YAAA;A1F8uhBJ;A0F5uhBE;EACE,gCAAA;EACA,WAAA;EACA,YAAA;A1F8uhBJ;A0F5uhBE;EACE,gCAAA;EACA,WAAA;EACA,YAAA;A1F8uhBJ;;A0F3uhBA;EACE,iBAAA;EACA,sCAAA;EACA,qBAAA;EACA,Wd3NM;Ec4NN,kBAAA;EACA,mBAAA;EACA,kBAAA;A1F8uhBF;;A0F3uhBE;EACE,yBAAA;A1F8uhBJ;A0F5uhBE;EACE,yBAAA;A1F8uhBJ;;A0FruhBQ;EACE,iDAAA;EACA,6CAAA;EACA,WdjPF;A5Ey9hBR;A0FnuhBI;EACE,YAAA;A1FquhBN;A0FpuhBM;EACE,UAAA;EACA,YAAA;A1FsuhBR;A0FruhBQ;EAGE,uBAAA;A1FquhBV;A0FluhBM;EACE,gBAAA;EACA,2BAAA;A1FouhBR;A0FjuhBI;;;;;;;;;;;;EAYE,sCAAA;EACA,kCAAA;EACA,kBAAA;EACA,WdrRE;EcsRF,sBAAA;EACA,eAAA;A1FmuhBN;A0FjuhBI;;;EAGE,yBdzTU;Ec0TV,qBd1TU;A5E6hiBhB;A0FjuhBI;;;EAGE,sCAAA;EACA,kCAAA;A1FmuhBN;A0FjuhBI;;;EAGE,yBdlUS;EcmUT,qBdnUS;A5EsiiBf;A0FjuhBI;;EAEE,uCAAA;A1FmuhBN;A0FjuhBI;;EAEE,uBAAA;A1FmuhBN;A0FjuhBI;;;;EAIE,uBAAA;A1FmuhBN;A0FjuhBI;;EAEE,uBAAA;A1FmuhBN;A0FjuhBI;;EAEE,uBAAA;A1FmuhBN;;A0F9thBA;EACE,oCAAA;A1FiuhBF;;A0F/thBA;EACE,4EAAA;EACA,eAAA;A1FkuhBF;;A0F5thBE;EACE,2BAAA;A1F+thBJ;;A0F1thBI;EACE,gBAAA;A1F6thBN;A0F1thBE;EACE,gBAAA;EACA,cd5WS;A5EwkiBb;;A0FnthBY;EACE,yBdjXN;A5EukiBR;;A0F9shBA;;4BAAA;ACpZA;;4BAAA;AAGA;EACC,kBAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,QAAA;A3FwmiBD;;A2FtmiBA;EACC,kBAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,QAAA;A3FymiBD;;A2FtmiBC;EACC,gBAAA;A3FymiBF;;A2FrmiBC;EACC,mBflBY;A5E0niBd;;A2FrmiBA;EACC,gCAAA;A3FwmiBD;;A2FtmiBA;EACC,kBAAA;EACA,cfJc;EeKd,cAAA;A3FymiBD;A2FxmiBC;EACC,cAAA;EACA,WAAA;EACA,WAAA;A3F0miBF;A2FxmiBC;EACC,cAAA;EACA,WAAA;A3F0miBF;A2FvmiBE;EACC,kBAAA;EACA,WAAA;EACA,mBAAA;A3FymiBH;A2FhmiBC;EACC,kBAAA;EACA,WAAA;EACA,mBAAA;A3FkmiBF;A2F3liBC;EACC,+BAAA;EACA,kCAAA;A3F6liBF;A2F1liBC;EACC,8BAAA;EACA,iCAAA;A3F4liBF;;A2FzliBA;;4BAAA;ACpFA;;4BAAA;AAIA;EACE,aAAA;A5FkriBF;A4FhriBI;EACE,WAAA;A5FkriBN;A4FjriBM;EACE,aAAA;A5FmriBR;A4F9qiBQ;EACE,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,4BAAA;A5FgriBV;;A4F1qiBA;EACE,kBAAA;A5F6qiBF;A4F3qiBI;EACE,eAAA;A5F6qiBN;A4F1qiBE;EACE,kBAAA;EACA,aAAA;EACA,WAAA;A5F4qiBJ;;A4FxqiBA;EAIQ;IACE,wBAAA;E5FwqiBR;E4FtqiBM;IACE,qBAAA;E5FwqiBR;E4FnqiBQ;IACE,0BAAA;IACA,sBAAA;IACA,uBAAA;IACA,4BAAA;E5FqqiBV;AACF;A4F/piBA;;4BAAA;AC/DA;;4BAAA;AAGA;EACE,kBAAA;A7FmuiBF;;A6FjuiBA;EACE,mBAAA;A7FouiBF;;A6FluiBA;EACE,oBAAA;A7FquiBF;A6FnuiBE;EACE,mBAAA;A7FquiBJ;;A6FhuiBI;EACE,kDAAA;A7FmuiBN;A6F/tiBG;EACE,qBjBNa;A5EuuiBlB;A6F/tiBK;EACE,cjBNK;EiBOL,ejBmLsB;EiBlLtB,mBjBmL2B;EiBlL3B,gBjBmLwB;A5E8iiB/B;A6F7tiBG;;;;;;;;;;;;;;;;EAgBE,qBjBhCa;EiBiCb,sBjBZG;EiBaH,ejB2JwB;EiB1JxB,cjBhCO;EiBiCP,kBAAA;EAEA,gBAAA;A7F+tiBL;A6F9tiBK;;;;;;;;;;;;;;;;EACE,cjBrCK;EiBsCL,ejBoJsB;EiBnJtB,mBjBoJ2B;EiBnJ3B,gBjBoJwB;A5E2liB/B;A6F3uiBG;EACC,YAAA;A7F6uiBJ;A6F1uiBG;EACE,qBjBpDa;EiBqDb,ejBwIwB;A5EomiB7B;A6FzuiBI;EACE,kBAAA;A7F2uiBN;A6FvuiBE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;EACA,6BAAA;A7FyuiBJ;A6FvuiBI;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,cjB5Fa;EiB6Fb,gBjBvDE;A5EgyiBR;A6FruiBE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;EACA,6BAAA;A7FuuiBJ;A6FruiBI;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;EACA,cjB9Ga;EiB+Gb,gBjBzEE;EiB0EF,wBAAA;A7FuuiBN;A6FnuiBE;;;;EAIE,WjBlFI;EiBmFJ,WAAA;A7FquiBJ;A6FluiBE;EACE,yBjB7EC;A5EiziBL;A6FjuiBE;EACE,yBjBhFM;A5EmziBV;A6FhuiBE;EACE,yBjBnFU;A5EqziBd;A6F/tiBE;EACE,yBjBtFO;A5EuziBX;;A6F7tiBA;EACI,aAAA;EAGA,cAAA;EAGA,mBAAA;EAGA,mBAAA;EACA,gBAAA;A7FguiBJ;A6F/tiBE;EACE,iBAAA;A7FiuiBJ;;A6F3tiBI;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;A7F8tiBN;A6F3tiBI;EACE,kBAAA;EACA,gBAAA;EACA,0BAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;A7F6tiBN;A6FztiBE;EACE,yBAAA;EACA,4BAAA;EACA,mBAAA;EACA,0CAAA;A7F2tiBJ;A6FztiBI;EACE,wBAAA;A7F2tiBN;;A6FrtiBE;EACE,iBAAA;EACA,iBAAA;EACA,gBAAA;A7FwtiBJ;;A6FptiBA;;4BAAA;ACzMA;;4BAAA;AAIE;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;A9Fk6iBJ;A8Fh6iBI;EACE,yBlBaU;A5Eq5iBhB;A8Fh6iBI;EACE,qBAAA;EACA,eAAA;A9Fk6iBN;A8F95iBI;EACE,YAAA;EACA,WAAA;A9Fg6iBN;A8F35iBM;EACE,qBAAA;A9F65iBR;A8Fv5iBM;EACE,aAAA;A9Fy5iBR;;A8Fp5iBA;;EAEE,oBAAA;EACA,iBAAA;A9Fu5iBF;A8Ft5iBE;;EACE,cAAA;EACA,qBAAA;EACA,cAAA;A9Fy5iBJ;A8Fx5iBI;;EACE,YAAA;EACA,WAAA;A9F25iBN;A8Fz5iBI;;EACE,iBAAA;EACA,oBAAA;EACA,WAAA;A9F45iBN;A8Fz5iBM;;;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;A9F65iBR;A8F35iBM;;;EACE,sCAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,WlBrCA;A5Eo8iBR;;A8F15iBA;EACE,yBlBvDM;EkBwDN,WAAA;EACA,SAAA;EACA,OAAA;EACA,mCAAA;EACA,YAAA;A9F65iBF;A8F55iBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;A9F85iBJ;A8F75iBI;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EACA,clB3EI;EkB4EJ,eAAA;A9F+5iBN;A8F95iBM;EACE,YAAA;EACA,UAAA;A9Fg6iBR;A8F96iBE;EAiBE,aAAA;A9Fg6iBJ;A8F/5iBI;EACE,qBAAA;A9Fi6iBN;A8Fh6iBM;EACE,WAAA;EACA,YAAA;A9Fk6iBR;A8F/5iBI;EACE,cAAA;EACA,eAAA;A9Fi6iBN;A8F75iBQ;EACE,gBAAA;A9F+5iBV;A8F15iBE;EACE,cAAA;EACA,clBzGS;EkB0GT,yBAAA;EACA,gBAAA;A9F45iBJ;A8F15iBE;;;EAGE,+BAAA;A9F45iBJ;A8Fz5iBI;EACE,qBAAA;EACA,YAAA;EACA,sBlBrGE;EkBsGF,+BAAA;A9F25iBN;;A8Fv5iBA;;EAEE,aAAA;A9F05iBF;;A8Fv5iBE;EACE,clBlIQ;A5E4hjBZ;A8Fx5iBE;EACE,aAAA;A9F05iBJ;;A8Fv5iBA;;4BAAA;AC7JA;;4BAAA;AAGA;EACE,iDAAA;EACA,6CAAA;A/F0jjBF;;A+FvjjBE;EACE,kBnB+GgB;A5E28iBpB;A+FxjjBE;EACE,YAAA;EACA,WAAA;EACA,kBnB0GgB;A5Eg9iBpB;;A+FvjjBA;;4BAAA;ACjBA;;4BAAA;AAGA;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,sBpB6BM;EoB5BN,WAAA;EACA,MAAA;EAEA,eAAA;AhG6kjBF;AgG5kjBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;AhG8kjBJ;AgG5kjBI;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,gCAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,yEAAA;AhG8kjBN;AgG3kjBI;EACE,UAAA;EACA,WAAA;EACA,kCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;EACA,uCAAA;AhG6kjBN;AgG3kjBM;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,gCAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,0BAAA;EACA,yCAAA;AhG6kjBR;AgG1kjBM;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,mBpBhDK;EoBiDL,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,0BAAA;EACA,yCAAA;AhG4kjBR;AgGvkjBE;EACE;IACE,qBAAA;IACA,mBpB7DO;E5EsojBX;EgGtkjBE;IACE,mBAAA;IACA,kCAAA;EhGwkjBJ;AACF;AgGrkjBE;EACE;IACE,0BAAA;EhGukjBJ;EgGpkjBE;IACE,2BAAA;EhGskjBJ;AACF;AgGnkjBE;EACE;IACE,0BAAA;EhGqkjBJ;EgGlkjBE;IACE,2BAAA;EhGokjBJ;AACF;AgGjkjBE;EACE,QAAA;EACA,SAAA;AhGmkjBJ;AgGvqjBA;EAuGE,eAAA;AhGmkjBF;AgGjkjBE;EACE,iBAAA;EACA,iBAAA;EACA,SAAA;EACA,aAAA;EACA,qBAAA;EACA,iBAAA;AhGmkjBJ;AgGhkjBE;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EAEA,kBAAA;EACA,UAAA;AhGikjBJ;AgG/jjBI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,4FAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,wBAAA;EACA,gBAAA;AhGikjBN;;AgG5jjBA;EACE,aAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,iEAAA;AhG+jjBF;AgG7jjBE;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;AhG+jjBJ;AgG5jjBE;EACE,yCAAA;EACA,kBAAA;EACA,uCAAA;AhG8jjBJ;AgG3jjBE;EACE;IACE,uBAAA;EhG6jjBJ;EgG1jjBE;IACE,yBAAA;EhG4jjBJ;AACF;AgGzjjBE;EACE,+BAAA;EACA,yCAAA;EACA,0CAAA;EACA,kBAAA;EACA,uCAAA;AhG2jjBJ;AgGxjjBE;EACE;IACE,uBAAA;EhG0jjBJ;EgGvjjBE;IACE,yBAAA;EhGyjjBJ;AACF;AgGtjjBE;EACE,2BAAA;EACA,gCAAA;EACA,kBAAA;EACA,uCAAA;EACA,kBAAA;AhGwjjBJ;AgGrjjBE;EACE;IACE,uBAAA;EhGujjBJ;EgGpjjBE;IACE,yBAAA;EhGsjjBJ;AACF;AgGnjjBE;EACE,yBAAA;EACA,kBAAA;EACA,uCAAA;EACA,kBAAA;AhGqjjBJ;AgGnjjBI;EACE,WAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,2BAAA;EACA,kBAAA;AhGqjjBN;AgGjjjBE;EACE;IACE,uBAAA;EhGmjjBJ;EgGhjjBE;IACE,yBAAA;EhGkjjBJ;AACF;AgG/ijBE;EACE,+BAAA;EACA,yBpBtOY;EoBuOZ,kBAAA;EACA,uCAAA;EACA,kBAAA;AhGijjBJ;AgG/ijBI;EACE,WAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,kBAAA;EACA,YAAA;AhGijjBN;AgG7ijBE;EACE;IACE,uBAAA;EhG+ijBJ;EgG5ijBE;IACE,yBAAA;EhG8ijBJ;AACF;AgG3ijBE;EACE,2BAAA;EACA,kBAAA;EACA,yCAAA;AhG6ijBJ;AgG1ijBE;EACE;IACE,mBAAA;IACA,UAAA;EhG4ijBJ;EgGzijBE;IACE,UAAA;EhG2ijBJ;EgGxijBE;IACE,mBAAA;IACA,UAAA;EhG0ijBJ;AACF;AgGvijBE;EACE,2BAAA;EACA,kBAAA;EACA,kBAAA;AhGyijBJ;AgGvijBI;EAEE,WAAA;EACA,wCAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,uCAAA;EACA,UAAA;AhGwijBN;AgGrijBI;EACE,mBAAA;AhGuijBN;AgGpijBI;EACE,qBAAA;AhGsijBN;AgGlijBE;EACE;IACE,mBAAA;IACA,UAAA;EhGoijBJ;EgGjijBE;IACE,UAAA;EhGmijBJ;EgGhijBE;IACE,mBAAA;IACA,UAAA;EhGkijBJ;AACF;AgG/hjBE;EACE,kBAAA;AhGiijBJ;AgG/hjBI;EAEE,WAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,wCAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,4CAAA;AhGgijBN;AgG7hjBI;EACE,oBAAA;AhG+hjBN;AgG3hjBE;EACE;IAEE,mBAAA;EhG4hjBJ;EgGzhjBE;IACE,mBAAA;EhG2hjBJ;AACF;AgGxhjBE;EACE,yBpBxWS;EoByWT,kBAAA;EACA,4CAAA;AhG0hjBJ;AgGvhjBE;EACE;IACE,mBAAA;EhGyhjBJ;EgGthjBE;IACE,mBAAA;IACA,UAAA;EhGwhjBJ;AACF;AgGrhjBE;EACE,kBAAA;EACA,yCAAA;AhGuhjBJ;AgGrhjBI;EAEE,WAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,8CAAA;AhGshjBN;AgGnhjBI;EACE,MAAA;EACA,SAAA;AhGqhjBN;AgGlhjBI;EACE,SAAA;EACA,UAAA;EACA,oBAAA;AhGohjBN;AgGhhjBE;EACE;IACE,yBAAA;EhGkhjBJ;AACF;AgG/gjBE;EACE;IAEE,mBAAA;EhGghjBJ;EgG7gjBE;IACE,mBAAA;EhG+gjBJ;AACF;AgG5gjBE;EACE,yBpBraY;EoBsaZ,8CAAA;AhG8gjBJ;AgG3gjBE;EACE;IACE,yDAAA;EhG6gjBJ;EgG1gjBE;IACE,8DAAA;EhG4gjBJ;EgGzgjBE;IACE,iEAAA;EhG2gjBJ;AACF;AgGxgjBE;EACE,kBAAA;AhG0gjBJ;AgGxgjBI;EAEE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,yBpB9bS;EoB+bT,SAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;EACA,8BAAA;EACA,uCAAA;AhGygjBN;AgGtgjBI;EACE,QAAA;EACA,SAAA;EACA,sBAAA;AhGwgjBN;AgGpgjBE;EACE;IAEE,kCAAA;IACA,yBpBldS;E5Eu9jBb;EgGlgjBE;IACE,8BAAA;IACA,6BAAA;EhGogjBJ;AACF;AgGjgjBE;;;EAGE,kBAAA;EACA,yBAAA;EACA,8CAAA;AhGmgjBJ;AgGhgjBE;EACE,2BAAA;EACA,kBAAA;EACA,wBAAA;EACA,uBAAA;EACA,SAAA;AhGkgjBJ;AgGhgjBI;EACE,WAAA;EACA,uBAAA;AhGkgjBN;AgG//iBI;EACE,UAAA;AhGigjBN;AgG9/iBI;EAEE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,cAAA;EACA,eAAA;AhG+/iBN;AgG3/iBE;EACE;IAGE,wBAAA;EhG2/iBJ;EgGx/iBE;IACE,0BAAA;EhG0/iBJ;AACF;AgGv/iBE;EACE,kBAAA;EACA,iDAAA;EACA,kBAAA;EACA,wDAAA;EACA,sBAAA;EACA,SAAA;AhGy/iBJ;AgGv/iBI;EAEE,WAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AhGw/iBN;AgGr/iBI;EACE,UAAA;EACA,sBAAA;AhGu/iBN;AgGp/iBI;EACE,WAAA;EACA,sBAAA;AhGs/iBN;AgGl/iBE;EACE;IACE,iDAAA;EhGo/iBJ;EgGj/iBE;IACE,iDAAA;EhGm/iBJ;AACF;AgGh/iBE;EACE,mBpBrjBS;EoBsjBT,kBAAA;EACA,4CAAA;EACA,qBAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;AhGk/iBJ;AgGh/iBI;EAEE,WAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AhGi/iBN;AgG9+iBI;EACE,YAAA;EACA,qBAAA;AhGg/iBN;AgG7+iBI;EACE,WAAA;EACA,qBAAA;AhG++iBN;AgG3+iBE;EACE;IAEE,wCAAA;EhG4+iBJ;EgGz+iBE;IACE,mDAAA;EhG2+iBJ;AACF;AgGx+iBE;EACE,yBAAA;EACA,mBAAA;EACA,kBAAA;AhG0+iBJ;AgGx+iBI;EAEE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,kCAAA;AhGy+iBN;AgGt+iBI;EACE,yBAAA;AhGw+iBN;AgGr+iBI;EACE,yBAAA;EACA,qBAAA;AhGu+iBN;AgGn+iBE;EACE;IACE,8CAAA;EhGq+iBJ;EgGl+iBE;IACE,gDAAA;EhGo+iBJ;AACF;AgGj+iBE;EACE;IACE,6CAAA;EhGm+iBJ;EgGh+iBE;IACE,gDAAA;EhGk+iBJ;AACF;AgG/9iBE;EACE;IAEE,mCAAA;EhGg+iBJ;EgG79iBE;IACE,mCAAA;EhG+9iBJ;EgG59iBE;IACE,iCAAA;EhG89iBJ;EgG39iBE;IACE,oCAAA;EhG69iBJ;EgG19iBE;IACE,gCAAA;EhG49iBJ;EgGz9iBE;IACE,qCAAA;EhG29iBJ;EgGx9iBE;IACE,kCAAA;EhG09iBJ;EgGv9iBE;IACE,oCAAA;EhGy9iBJ;AACF;AgGt9iBE;EACE,kBAAA;EACA,yBpBjrBY;EoBkrBZ,kBAAA;AhGw9iBJ;AgGt9iBI;EAEE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;AhGu9iBN;AgGp9iBI;EACE,YAAA;EACA,YAAA;EACA,yBpBjsBU;EoBksBV,2BAAA;EACA,uCAAA;EACA,YAAA;AhGs9iBN;AgGn9iBI;EACE,aAAA;EACA,YAAA;EACA,yBpB1sBU;EoB2sBV,2BAAA;EACA,uCAAA;AhGq9iBN;AgGj9iBE;EACE;IACE,6CAAA;EhGm9iBJ;EgGh9iBE;IACE,+CAAA;EhGk9iBJ;AACF;AgG/8iBE;EACE,kBAAA;AhGi9iBJ;AgG/8iBI;EAEE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,+BAAA;EACA,4BpBnuBS;EoBouBT,MAAA;EACA,OAAA;EACA,uCAAA;AhGg9iBN;AgG78iBI;EACE,WAAA;EACA,YAAA;AhG+8iBN;AgG58iBI;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,4BAAA;AhG88iBN;AgG18iBE;EACE;IACE,uBAAA;EhG48iBJ;EgGz8iBE;IACE,yBAAA;EhG28iBJ;AACF;AgGx8iBE;EACE,4CAAA;EACA,qCAAA;EACA,uCAAA;EACA,mBAAA;EACA,kBAAA;AhG08iBJ;AgGv8iBE;EACE;IACE,yBAAA;EhGy8iBJ;AACF;AgGt8iBE;EACE,6BAAA;EACA,0DAAA;EACA,kBAAA;EACA,kBAAA;AhGw8iBJ;AgGt8iBI;EAEE,kBAAA;EACA,WAAA;EACA,wCAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,6BAAA;AhGu8iBN;AgGp8iBI;EACE,YAAA;EACA,uCAAA;AhGs8iBN;AgGn8iBI;EACE,WAAA;EACA,uCAAA;AhGq8iBN;AgGj8iBE;EACE;IACE,uBAAA;EhGm8iBJ;EgGh8iBE;IACE,yBAAA;EhGk8iBJ;AACF;AgG/7iBE;EACE,kBAAA;AhGi8iBJ;AgG/7iBI;EAEE,kBAAA;EACA,WAAA;AhGg8iBN;AgG77iBI;EACE,UAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,+BAAA;EACA,qCAAA;EACA,uCAAA;EACA,yBAAA;AhG+7iBN;AgG57iBI;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,OAAA;EACA,0CAAA;EACA,cAAA;EACA,WAAA;AhG87iBN;AgG17iBE;EACE;IACE,MAAA;EhG47iBJ;EgGz7iBE;IACE,SAAA;EhG27iBJ;EgGx7iBE;IACE,MAAA;EhG07iBJ;AACF;AgGv7iBE;EACE,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;AhGy7iBJ;AgGv7iBI;EAEE,kBAAA;EACA,WAAA;EACA,yBpB/2BO;A5EuykBb;AgGr7iBI;EACE,UAAA;EACA,aAAA;EACA,SAAA;EACA,QAAA;EACA,6BAAA;EACA,iDAAA;AhGu7iBN;AgGp7iBI;EACE,WAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;AhGs7iBN;AgGl7iBE;EACE;IACE,0BAAA;EhGo7iBJ;EgGj7iBE;IACE,yBAAA;EhGm7iBJ;AACF;AgGh7iBE;EACE,aAAA;EACA,2BAAA;EACA,oBAAA;EACA,kBAAA;EACA,uCAAA;AhGk7iBJ;AgGh7iBI;EACE,aAAA;EACA,YAAA;EACA,yBpBt5BU;EoBu5BV,kCAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,wBAAA;AhGk7iBN;AgG96iBE;EACE;IACE,qCAAA;EhGg7iBJ;EgG76iBE;IACE,qCAAA;EhG+6iBJ;AACF;AgG56iBE;EACE,YAAA;EACA,WAAA;EACA,2BAAA;EACA,kCAAA;EACA,kBAAA;AhG86iBJ;AgG56iBI;EAEE,kBAAA;EACA,WAAA;AhG66iBN;AgG16iBI;EACE,YAAA;EACA,WAAA;EACA,2BAAA;EACA,iBAAA;EACA,kCAAA;EACA,wBAAA;EACA,UAAA;AhG46iBN;AgGz6iBI;EACE,YAAA;EACA,aAAA;EACA,yBpBl8BS;EoBm8BT,WAAA;EACA,YAAA;EACA,8FAAA;EACA,iDAAA;AhG26iBN;AgGv6iBE;EACE;IACE,WAAA;EhGy6iBJ;EgGt6iBE;IACE,WAAA;EhGw6iBJ;AACF;AgGr6iBE;EACE,wCAAA;EACA,kBAAA;EACA,yCAAA;AhGu6iBJ;AgGr6iBI;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,sCAAA;EACA,0BAAA;EACA,YAAA;EACA,8CAAA;AhGu6iBN;AgGn6iBE;EACE;IACE,8CAAA;EhGq6iBJ;EgGl6iBE;IACE,iDAAA;EhGo6iBJ;AACF;AgGj6iBE;EACE;IACE,wBAAA;IACA,0BAAA;EhGm6iBJ;EgGh6iBE;IACE,wBAAA;IACA,cAAA;EhGk6iBJ;EgG/5iBE;IACE,YAAA;IACA,cAAA;EhGi6iBJ;EgG95iBE;IACE,YAAA;IACA,0BAAA;EhGg6iBJ;AACF;AgG75iBE;EACE,YAAA;EACA,aAAA;EACA,wCAAA;EACA,8CAAA;EACA,kBAAA;EACA,sDAAA;AhG+5iBJ;AgG55iBE;EACE;IACE,YAAA;IACA,kCAAA;EhG85iBJ;EgG35iBE;IACE,UAAA;IACA,oCAAA;EhG65iBJ;AACF;AgG15iBE;EACE,kBAAA;EACA,2QAAA;EACA,uCAAA;AhG45iBJ;AgGz5iBE;EACE;IACE,uBAAA;EhG25iBJ;EgGx5iBE;IACE,yBAAA;EhG05iBJ;AACF;AgGv5iBE;EACE,+BAAA;EACA,yBpB9iCS;EoB+iCT,4BpB/iCS;EoBgjCT,kBAAA;EACA,kBAAA;EACA,uCAAA;AhGy5iBJ;AgGv5iBI;EAEE,WAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,+BAAA;EACA,4BpB5jCO;A5Eo9kBb;AgGr5iBI;EACE,yBAAA;EACA,aAAA;EACA,YAAA;AhGu5iBN;AgGp5iBI;EACE,yBAAA;EACA,YAAA;EACA,eAAA;AhGs5iBN;AgGl5iBE;EACE;IACE,uBAAA;EhGo5iBJ;EgGj5iBE;IACE,yBAAA;EhGm5iBJ;AACF;AgGh5iBE;EACE,2BAAA;EACA,yBpBvlCY;EoBwlCZ,kBAAA;EACA,kBAAA;EACA,8CAAA;AhGk5iBJ;AgGh5iBI;EAEE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;EACA,yCAAA;AhGi5iBN;AgG94iBI;EACE,qBAAA;AhGg5iBN;AgG54iBE;EACE;IACE,UAAA;IACA,uBAAA;IACA,0LAAA;EhG84iBJ;EgG34iBE;IACE,UAAA;IACA,yBAAA;IACA,yOAAA;EhG64iBJ;AACF;AgG14iBE;EACE,kBAAA;EACA,kBAAA;EACA,sDAAA;EACA,uCAAA;AhG44iBJ;AgG14iBI;EAEE,WAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AhG24iBN;AgGx4iBI;EACE,+BAAA;EACA,qCAAA;EACA,WAAA;EACA,yBAAA;AhG04iBN;AgGv4iBI;EACE,kCAAA;EACA,oCAAA;EACA,cAAA;EACA,wBAAA;AhGy4iBN;AgGr4iBE;EACE;IACE,wCAAA;EhGu4iBJ;EgGp4iBE;IACE,0CAAA;EhGs4iBJ;AACF;AgGn4iBE;EACE,kBAAA;EACA,UAAA;EACA,aAAA;AhGq4iBJ;AgGn4iBI;EAEE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,MAAA;EACA,sCAAA;EACA,kBAAA;AhGo4iBN;AgGj4iBI;EACE,QAAA;EACA,gDAAA;EACA,8BAAA;AhGm4iBN;AgGh4iBI;EACE,OAAA;EACA,gDAAA;EACA,8BAAA;AhGk4iBN;AgG93iBE;EACE;IACE,0BAAA;EhGg4iBJ;EgG73iBE;IACE,aAAA;IACA,YAAA;EhG+3iBJ;EgG53iBE;IACE,aAAA;IACA,YAAA;IACA,4BAAA;EhG83iBJ;AACF;AgG33iBE;EACE;IACE,0BAAA;EhG63iBJ;EgG13iBE;IACE,aAAA;IACA,YAAA;EhG43iBJ;EgGz3iBE;IACE,aAAA;IACA,YAAA;IACA,6BAAA;EhG23iBJ;AACF;AgGx3iBE;EACE,eAAA;EACA,kBAAA;AhG03iBJ;AgGx3iBI;EACE,kBAAA;EACA,wCAAA;EACA,gEAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kBAAA;AhG03iBN;AgGt3iBE;EACE;IACE,iCAAA;EhGw3iBJ;EgGr3iBE;IACE,uCAAA;EhGu3iBJ;EgGp3iBE;IACE,iCAAA;EhGs3iBJ;EgGn3iBE;IACE,sCAAA;EhGq3iBJ;EgGl3iBE;IACE,iCAAA;EhGo3iBJ;AACF;AgGj3iBE;EACE,iCAAA;EACA,mBAAA;EACA,0CAAA;AhGm3iBJ;AgGj3iBI;EAEE,WAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,iCAAA;EACA,mBAAA;EACA,kDAAA;AhGk3iBN;AgG/2iBI;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,kCAAA;EACA,eAAA;AhGi3iBN;AgG72iBE;EACE;IACE,yBAAA;EhG+2iBJ;EgG52iBE;IACE,uBAAA;EhG82iBJ;AACF;AgG32iBE;EACE,aAAA;EACA,YAAA;EACA,sIAAA;EACA,gCAAA;AhG62iBJ;AgG12iBE;EACE;IACE,sIAAA;EhG42iBJ;EgGz2iBE;IACE,mIAAA;EhG22iBJ;EgGx2iBE;IACE,iIAAA;EhG02iBJ;EgGv2iBE;IACE,kIAAA;EhGy2iBJ;EgGt2iBE;IACE,mIAAA;EhGw2iBJ;EgGr2iBE;IACE,iIAAA;EhGu2iBJ;EgGp2iBE;IACE,8HAAA;EhGs2iBJ;EgGn2iBE;IACE,iIAAA;EhGq2iBJ;EgGl2iBE;IACE,mIAAA;EhGo2iBJ;EgGj2iBE;IACE,kIAAA;EhGm2iBJ;EgGh2iBE;IACE,iIAAA;EhGk2iBJ;EgG/1iBE;IACE,mIAAA;EhGi2iBJ;EgG91iBE;IACE,sIAAA;EhGg2iBJ;AACF;AgG71iBE;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,yBpBp3CY;EoBq3CZ,mBAAA;EACA,0CAAA;AhG+1iBJ;AgG71iBI;EAEE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AhG81iBN;AgG31iBI;EACE,WAAA;EACA,YAAA;EACA,2CAAA;AhG61iBN;AgG11iBI;EACE,WAAA;EACA,YAAA;EACA,2CAAA;AhG41iBN;AgGx1iBE;EACE;IACE,uBAAA;EhG01iBJ;EgGv1iBE;IACE,yBAAA;EhGy1iBJ;AACF;AgGt1iBE;EACE;IACE,2CAAA;EhGw1iBJ;EgGr1iBE;IACE,0CAAA;EhGu1iBJ;EgGp1iBE;IACE,2CAAA;EhGs1iBJ;EgGn1iBE;IACE,4CAAA;EhGq1iBJ;EgGl1iBE;IACE,2CAAA;EhGo1iBJ;AACF;AgGj1iBE;EACE,4BAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;AhGm1iBJ;AgGj1iBI;EAEE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,uCAAA;AhGk1iBN;AgG/0iBI;EACE,+BAAA;EACA,YAAA;EACA,yBAAA;EACA,8BAAA;AhGi1iBN;AgG90iBI;EACE,kCAAA;EACA,WAAA;EACA,0BAAA;EACA,6BAAA;AhGg1iBN;AgG50iBE;EACE;IACE,uBAAA;EhG80iBJ;EgG30iBE;IACE,yBAAA;EhG60iBJ;AACF;AgG10iBE;EACE,yCAAA;EACA,oBAAA;EACA,kBAAA;EACA,iQAAA;EACA,4BAAA;EACA,0BAAA;EACA,uCAAA;AhG40iBJ;AgGz0iBE;EACE;IACE,wBAAA;EhG20iBJ;EgGx0iBE;IACE,2BAAA;EhG00iBJ;AACF;AgGv0iBE;EACE,UAAA;EACA,cAAA;EACA,2CAAA;EACA,oBAAA;EACA,0JAAA;EACA,wBAAA;EACA,wBAAA;EACA,yCAAA;AhGy0iBJ;AgGt0iBE;EACE;IACE,wBAAA;EhGw0iBJ;EgGr0iBE;IACE,2BAAA;EhGu0iBJ;AACF;;AgGn0iBA;;4BAAA;AC9gDA;;4BAAA;AAGA;EACE,yBrBkBW;EqBjBX,WrBkCM;A5EqzlBR;;AiGn1lBI;EACE,WrB6BE;A5EyzlBR;AiGn1lBM;EACE,eAAA;AjGq1lBR;;AiGh1lBA;;4BAAA;ACnBA;;4BAAA;AAGA;EACE;IACE,aAAA;ElGy2lBF;EkGt2lBC;IACO,SAAA;ElGw2lBR;EkGr2lBE;IACE,kBAAA;ElGu2lBJ;EkGp2lBI;IACE,aAAA;ElGs2lBN;EkGj2lBM;IACE,SAAA;ElGm2lBR;EkG91lBA;IACE,aAAA;ElGg2lBF;AACF;AkG91lBA;EACE,gBAAA;EACA,mBAAA;AlGg2lBF;;AkG51lBI;EACE,eAAA;AlG+1lBN;AkG51lBE;EACE,mBAAA;AlG81lBJ;;AkG31lBA;;4BAAA;AC9CA;;4BAAA;AAIE;EACE,gBAAA;EACA,eAAA;AnG84lBJ;AmG74lBI;EACE,gBAAA;AnG+4lBN;;AmG34lBA;EACE,eAAA;EACA,kBAAA;EACA,kBAAA;AnG84lBF;AmG74lBE;EACE,6DAAA;EACA,qCAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,UAAA;EACA,cAAA;EACA,gBAAA;EACA,sCAAA;EACA,sBAAA;EACA,wBAAA;AnG+4lBJ;AmG74lBE;EACE,WAAA;EACA,kBAAA;EACA,cAAA;EACA,OAAA;EACA,aAAA;EACA,cAAA;EACA,gBvBEI;EuBDJ,yBAAA;EACA,eAAA;AnG+4lBJ;AmG74lBE;EACE,qCAAA;AnG+4lBJ;;AmG54lBA;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;AnG+4lBF;AmG94lBE;EACE,6DAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,cAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;AnGg5lBJ;AmG94lBE;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBvB9BI;EuB+BJ,yBAAA;EACA,kBAAA;AnGg5lBJ;AmG94lBE;EACE,sBAAA;AnGg5lBJ;;AmG34lBE;EACE,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AnG84lBJ;AmG74lBI;EACE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBvBzDE;EuB4DF,6DAAA;AnG+4lBN;AmG74lBI;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,cvB/Ga;A5E8/lBnB;AmG54lBE;EACE,UAAA;AnG84lBJ;AmG74lBI;EACE,oBAAA;AnG+4lBN;AmG74lBQ;EACE,oBAAA;AnG+4lBV;AmGv4lBQ;EACE,oBvB7DK;EuB8DL,gBAAA;EACA,kBAAA;EACA,gBAAA;AnGy4lBV;AmGp4lBM;EACE,aAAA;AnGs4lBR;AmGr4lBQ;EACE,yBvB/HI;EuBgIJ,mBAAA;AnGu4lBV;AmGh4lBM;EACE,kBAAA;AnGk4lBR;AmG93lBE;EACE,aAAA;AnGg4lBJ;;AmG33lBI;EACE,gBAAA;AnG83lBN;AmGz3lBM;EACE,kBAAA;AnG23lBR;AmGv3lBE;EACE,aAAA;AnGy3lBJ;;AmGn3lBM;EACE,kCAJuB;AnG03lB/B;AmGh3lBU;EACE,kCAXmB;EAYnB,2BAZmB;AnG83lB/B;AmGh3lBU;EACE,WvBvJJ;A5EygmBR;;AmG12lBM;EACE,sCAxBuB;EAyBvB,kCAzBuB;EA0BvB,WvBlKA;A5E+gmBR;AmGv2lBU;EACE,sCAjCmB;EAkCnB,kCAlCmB;EAmCnB,WvB3KJ;A5EohmBR;AmGv2lBU;EACE,WvB9KJ;A5EuhmBR;;AmGh2lBQ;EACE,kCAhDqB;AnGm5lB/B;AmGj2lBQ;EACE,sCAnDqB;AnGs5lB/B;AmG91lBU;EACE,kCAzDmB;AnGy5lB/B;AmG91lBU;EACE,sCA5DmB;AnG45lB/B;;AmGz5lBM;EACE,qBAJuB;AnGg6lB/B;AmGt5lBU;EACE,qBAXmB;EAYnB,cAZmB;AnGo6lB/B;AmGt5lBU;EACE,WvBvJJ;A5E+imBR;;AmGh5lBM;EACE,yBAxBuB;EAyBvB,qBAzBuB;EA0BvB,WvBlKA;A5EqjmBR;AmG74lBU;EACE,yBAjCmB;EAkCnB,qBAlCmB;EAmCnB,WvB3KJ;A5E0jmBR;AmG74lBU;EACE,WvB9KJ;A5E6jmBR;;AmGt4lBQ;EACE,qBAhDqB;AnGy7lB/B;AmGv4lBQ;EACE,yBAnDqB;AnG47lB/B;AmGp4lBU;EACE,qBAzDmB;AnG+7lB/B;AmGp4lBU;EACE,yBA5DmB;AnGk8lB/B;;AmG/7lBM;EACE,qBAJuB;AnGs8lB/B;AmG57lBU;EACE,qBAXmB;EAYnB,cAZmB;AnG08lB/B;AmG57lBU;EACE,WvBvJJ;A5EqlmBR;;AmGt7lBM;EACE,yBAxBuB;EAyBvB,qBAzBuB;EA0BvB,WvBlKA;A5E2lmBR;AmGn7lBU;EACE,yBAjCmB;EAkCnB,qBAlCmB;EAmCnB,WvB3KJ;A5EgmmBR;AmGn7lBU;EACE,WvB9KJ;A5EmmmBR;;AmG56lBQ;EACE,qBAhDqB;AnG+9lB/B;AmG76lBQ;EACE,yBAnDqB;AnGk+lB/B;AmG16lBU;EACE,qBAzDmB;AnGq+lB/B;AmG16lBU;EACE,yBA5DmB;AnGw+lB/B;;AmGr+lBM;EACE,qBAJuB;AnG4+lB/B;AmGl+lBU;EACE,qBAXmB;EAYnB,cAZmB;AnGg/lB/B;AmGl+lBU;EACE,WvBvJJ;A5E2nmBR;;AmG59lBM;EACE,yBAxBuB;EAyBvB,qBAzBuB;EA0BvB,WvBlKA;A5EiomBR;AmGz9lBU;EACE,yBAjCmB;EAkCnB,qBAlCmB;EAmCnB,WvB3KJ;A5EsomBR;AmGz9lBU;EACE,WvB9KJ;A5EyomBR;;AmGl9lBQ;EACE,qBAhDqB;AnGqgmB/B;AmGn9lBQ;EACE,yBAnDqB;AnGwgmB/B;AmGh9lBU;EACE,qBAzDmB;AnG2gmB/B;AmGh9lBU;EACE,yBA5DmB;AnG8gmB/B;;AmG3gmBM;EACE,qBAJuB;AnGkhmB/B;AmGxgmBU;EACE,qBAXmB;EAYnB,cAZmB;AnGshmB/B;AmGxgmBU;EACE,WvBvJJ;A5EiqmBR;;AmGlgmBM;EACE,yBAxBuB;EAyBvB,qBAzBuB;EA0BvB,WvBlKA;A5EuqmBR;AmG//lBU;EACE,yBAjCmB;EAkCnB,qBAlCmB;EAmCnB,WvB3KJ;A5E4qmBR;AmG//lBU;EACE,WvB9KJ;A5E+qmBR;;AmGx/lBQ;EACE,qBAhDqB;AnG2imB/B;AmGz/lBQ;EACE,yBAnDqB;AnG8imB/B;AmGt/lBU;EACE,qBAzDmB;AnGijmB/B;AmGt/lBU;EACE,yBA5DmB;AnGojmB/B;;AmGjjmBM;EACE,qBAJuB;AnGwjmB/B;AmG9imBU;EACE,qBAXmB;EAYnB,cAZmB;AnG4jmB/B;AmG9imBU;EACE,WvBvJJ;A5EusmBR;;AmGximBM;EACE,yBAxBuB;EAyBvB,qBAzBuB;EA0BvB,WvBlKA;A5E6smBR;AmGrimBU;EACE,yBAjCmB;EAkCnB,qBAlCmB;EAmCnB,WvB3KJ;A5EktmBR;AmGrimBU;EACE,WvB9KJ;A5EqtmBR;;AmG9hmBQ;EACE,qBAhDqB;AnGilmB/B;AmG/hmBQ;EACE,yBAnDqB;AnGolmB/B;AmG5hmBU;EACE,qBAzDmB;AnGulmB/B;AmG5hmBU;EACE,yBA5DmB;AnG0lmB/B;;AmGvlmBM;EACE,qBAJuB;AnG8lmB/B;AmGplmBU;EACE,qBAXmB;EAYnB,cAZmB;AnGkmmB/B;AmGplmBU;EACE,WvBvJJ;A5E6umBR;;AmG9kmBM;EACE,yBAxBuB;EAyBvB,qBAzBuB;EA0BvB,WvBlKA;A5EmvmBR;AmG3kmBU;EACE,yBAjCmB;EAkCnB,qBAlCmB;EAmCnB,WvB3KJ;A5EwvmBR;AmG3kmBU;EACE,WvB9KJ;A5E2vmBR;;AmGpkmBQ;EACE,qBAhDqB;AnGunmB/B;AmGrkmBQ;EACE,yBAnDqB;AnG0nmB/B;AmGlkmBU;EACE,qBAzDmB;AnG6nmB/B;AmGlkmBU;EACE,yBA5DmB;AnGgomB/B;;AmG7nmBM;EACE,qBAJuB;AnGoomB/B;AmG1nmBU;EACE,qBAXmB;EAYnB,cAZmB;AnGwomB/B;AmG1nmBU;EACE,WvBvJJ;A5EmxmBR;;AmGpnmBM;EACE,yBAxBuB;EAyBvB,qBAzBuB;EA0BvB,WvBlKA;A5EyxmBR;AmGjnmBU;EACE,yBAjCmB;EAkCnB,qBAlCmB;EAmCnB,WvB3KJ;A5E8xmBR;AmGjnmBU;EACE,WvB9KJ;A5EiymBR;;AmG1mmBQ;EACE,qBAhDqB;AnG6pmB/B;AmG3mmBQ;EACE,yBAnDqB;AnGgqmB/B;AmGxmmBU;EACE,qBAzDmB;AnGmqmB/B;AmGxmmBU;EACE,yBA5DmB;AnGsqmB/B;;AmGlmmBE;EACE,qBAAA;AnGqmmBJ;AmGnmmBE;EACE,qBAAA;AnGqmmBJ;AmGnmmBE;EACE,kBAAA;AnGqmmBJ;;AmGjmmBE;EACE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AnGommBJ;AmGnmmBI;EACE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBvBtOE;EuByOF,oCAAA;AnGqmmBN;AmGnmmBI;EACE,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBvBvQM;EuB2QN,sBAAA;EAIA,8DAAA;AnGqmmBN;AmGlmmBE;EACE,UAAA;AnGommBJ;AmGjmmBQ;EACE,oBAAA;AnGmmmBV;AmG7lmBQ;EAIE,sBAAA;AnG+lmBV;AmG1lmBM;EACE,aAAA;AnG4lmBR;AmG3lmBQ;EACE,mBAAA;AnG6lmBV;AmGxlmBE;EACE,aAAA;AnG0lmBJ;;AmGvlmBA;;4BAAA;ACvUA;;4BAAA;AAGA;EACE,kBAAA;EACA,iBAAA;ApGo6mBF;;AoGl6mBA;EACE,eAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,WxBwBM;EwBvBN,UAAA;ApGq6mBF;;AoGn6mBA;EACE,WAAA;ApGs6mBF;AoGr6mBE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,6BAAA;EACA,yBxBNS;EwBOT,2BxBPS;A5E86mBb;;AoGn6mBA;EACE,kBAAA;EACA,kBAAA;ApGs6mBF;;AoGn6mBA;EACE,mBAAA;ApGs6mBF;;AoGp6mBA;EACE,oBAAA;EACA,cAAA;ApGu6mBF;;AoGr6mBA;EACE,mBAAA;ApGw6mBF;;AoGr6mBA;EACE,QAAA;ApGw6mBF;;AoGp6mBE;EACE,kBAAA;EACA,MAAA;EACA,UAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,0BAAA;EACA,oCAAA;ApGu6mBJ;;AoGp6mBA;EACE,UAAA;EACA,WAAA;ApGu6mBF;;AoGr6mBA;EACE,YAAA;ApGw6mBF;AoGv6mBE;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,6BAAA;EACA,yBxB1DS;EwB2DT,2BxB3DS;A5Eo+mBb;;AoGt6mBA;EACE,WAAA;EACA,YAAA;EACA,SAAA;ApGy6mBF;AoGx6mBE;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,6BAAA;EACA,yBxB1ES;EwB2ET,2BxB3ES;A5Eq/mBb;;AoGv6mBA;EACE,YAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;ApG06mBF;AoGz6mBE;EACE,kBAAA;EACA,YAAA;EACA,QAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,6BAAA;EACA,yBxB3FS;EwB4FT,2BxB5FS;A5EugnBb;;AoGx6mBA;EACE,WAAA;EACA,UAAA;EACA,gCAAA;EACA,mCAAA;ApG26mBF;;AoGz6mBA;EACE,WAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;ApG46mBF;;AoG16mBA;EACE,WAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;ApG66mBF;;AoG16mBE;EACE,SAAA;EACA,OAAA;EACA,iBAAA;EACA,gCAAA;EACA,qCAAA;ApG66mBJ;;AoGh6mBE;EACE,mBATiC;ApG46mBrC;;AoGj6mBE;EACE,mBAZiC;ApGg7mBrC;;AoGj6mBI;EACE,qBAhB+B;EAiB/B,+BAAA;ApGo6mBN;AoGl6mBI;EACE,2BApB+B;EAqB/B,8BAAA;ApGo6mBN;AoGl6mBI;EACE,2BAxB+B;EAyB/B,gCAAA;ApGo6mBN;;AoGh6mBI;EACE,yBA9B+B;EA+B/B,0BA/B+B;ApGk8mBrC;AoGj6mBI;EACE,2BAlC+B;EAmC/B,8BAAA;ApGm6mBN;AoGj6mBI;EACE,6BAAA;EACA,4BAvC+B;ApG08mBrC;;AoG/5mBI;EACE,yBAAA;EACA,gDAAA;EACA,kDAAA;ApGk6mBN;;AoG95mBI;EACE,+BAAA;EACA,gDAAA;EACA,iDAAA;ApGi6mBN;;AoG75mBI;EACE,6BAAA;EACA,mDAAA;EACA,kDAAA;ApGg6mBN;;AoG55mBI;EACE,6BAAA;EACA,mDAAA;EACA,+BAAA;EACA,iDAAA;ApG+5mBN;;AoG39mBE;EACE,mBATiC;ApGu+mBrC;;AoG59mBE;EACE,mBAZiC;ApG2+mBrC;;AoG59mBI;EACE,qBAhB+B;EAiB/B,+BAAA;ApG+9mBN;AoG79mBI;EACE,2BApB+B;EAqB/B,8BAAA;ApG+9mBN;AoG79mBI;EACE,2BAxB+B;EAyB/B,gCAAA;ApG+9mBN;;AoG39mBI;EACE,yBA9B+B;EA+B/B,0BA/B+B;ApG6/mBrC;AoG59mBI;EACE,2BAlC+B;EAmC/B,8BAAA;ApG89mBN;AoG59mBI;EACE,6BAAA;EACA,4BAvC+B;ApGqgnBrC;;AoG19mBI;EACE,yBAAA;EACA,+CAAA;EACA,iDAAA;ApG69mBN;;AoGz9mBI;EACE,+BAAA;EACA,+CAAA;EACA,gDAAA;ApG49mBN;;AoGx9mBI;EACE,6BAAA;EACA,kDAAA;EACA,iDAAA;ApG29mBN;;AoGv9mBI;EACE,6BAAA;EACA,kDAAA;EACA,+BAAA;EACA,gDAAA;ApG09mBN;;AoGthnBE;EACE,mBATiC;ApGkinBrC;;AoGvhnBE;EACE,mBAZiC;ApGsinBrC;;AoGvhnBI;EACE,qBAhB+B;EAiB/B,+BAAA;ApG0hnBN;AoGxhnBI;EACE,2BApB+B;EAqB/B,8BAAA;ApG0hnBN;AoGxhnBI;EACE,2BAxB+B;EAyB/B,gCAAA;ApG0hnBN;;AoGthnBI;EACE,yBA9B+B;EA+B/B,0BA/B+B;ApGwjnBrC;AoGvhnBI;EACE,2BAlC+B;EAmC/B,8BAAA;ApGyhnBN;AoGvhnBI;EACE,6BAAA;EACA,4BAvC+B;ApGgknBrC;;AoGrhnBI;EACE,yBAAA;EACA,qEAAA;EACA,uEAAA;ApGwhnBN;;AoGphnBI;EACE,+BAAA;EACA,qEAAA;EACA,sEAAA;ApGuhnBN;;AoGnhnBI;EACE,6BAAA;EACA,wEAAA;EACA,uEAAA;ApGshnBN;;AoGlhnBI;EACE,6BAAA;EACA,wEAAA;EACA,+BAAA;EACA,sEAAA;ApGqhnBN;;AoGjlnBE;EACE,mBATiC;ApG6lnBrC;;AoGllnBE;EACE,mBAZiC;ApGimnBrC;;AoGllnBI;EACE,qBAhB+B;EAiB/B,+BAAA;ApGqlnBN;AoGnlnBI;EACE,2BApB+B;EAqB/B,8BAAA;ApGqlnBN;AoGnlnBI;EACE,2BAxB+B;EAyB/B,gCAAA;ApGqlnBN;;AoGjlnBI;EACE,yBA9B+B;EA+B/B,0BA/B+B;ApGmnnBrC;AoGllnBI;EACE,2BAlC+B;EAmC/B,8BAAA;ApGolnBN;AoGllnBI;EACE,6BAAA;EACA,4BAvC+B;ApG2nnBrC;;AoGhlnBI;EACE,yBAAA;EACA,mEAAA;EACA,qEAAA;ApGmlnBN;;AoG/knBI;EACE,+BAAA;EACA,mEAAA;EACA,oEAAA;ApGklnBN;;AoG9knBI;EACE,6BAAA;EACA,sEAAA;EACA,qEAAA;ApGilnBN;;AoG7knBI;EACE,6BAAA;EACA,sEAAA;EACA,+BAAA;EACA,oEAAA;ApGglnBN;;AoG5onBE;EACE,mBATiC;ApGwpnBrC;;AoG7onBE;EACE,mBAZiC;ApG4pnBrC;;AoG7onBI;EACE,qBAhB+B;EAiB/B,+BAAA;ApGgpnBN;AoG9onBI;EACE,2BApB+B;EAqB/B,8BAAA;ApGgpnBN;AoG9onBI;EACE,2BAxB+B;EAyB/B,gCAAA;ApGgpnBN;;AoG5onBI;EACE,yBA9B+B;EA+B/B,0BA/B+B;ApG8qnBrC;AoG7onBI;EACE,2BAlC+B;EAmC/B,8BAAA;ApG+onBN;AoG7onBI;EACE,6BAAA;EACA,4BAvC+B;ApGsrnBrC;;AoG3onBI;EACE,yBAAA;EACA,oEAAA;EACA,sEAAA;ApG8onBN;;AoG1onBI;EACE,+BAAA;EACA,oEAAA;EACA,qEAAA;ApG6onBN;;AoGzonBI;EACE,6BAAA;EACA,uEAAA;EACA,sEAAA;ApG4onBN;;AoGxonBI;EACE,6BAAA;EACA,uEAAA;EACA,+BAAA;EACA,qEAAA;ApG2onBN;;AoGvsnBE;EACE,mBATiC;ApGmtnBrC;;AoGxsnBE;EACE,mBAZiC;ApGutnBrC;;AoGxsnBI;EACE,qBAhB+B;EAiB/B,+BAAA;ApG2snBN;AoGzsnBI;EACE,2BApB+B;EAqB/B,8BAAA;ApG2snBN;AoGzsnBI;EACE,2BAxB+B;EAyB/B,gCAAA;ApG2snBN;;AoGvsnBI;EACE,yBA9B+B;EA+B/B,0BA/B+B;ApGyunBrC;AoGxsnBI;EACE,2BAlC+B;EAmC/B,8BAAA;ApG0snBN;AoGxsnBI;EACE,6BAAA;EACA,4BAvC+B;ApGivnBrC;;AoGtsnBI;EACE,yBAAA;EACA,qEAAA;EACA,uEAAA;ApGysnBN;;AoGrsnBI;EACE,+BAAA;EACA,qEAAA;EACA,sEAAA;ApGwsnBN;;AoGpsnBI;EACE,6BAAA;EACA,wEAAA;EACA,uEAAA;ApGusnBN;;AoGnsnBI;EACE,6BAAA;EACA,wEAAA;EACA,+BAAA;EACA,sEAAA;ApGssnBN;;AoGlwnBE;EACE,mBATiC;ApG8wnBrC;;AoGnwnBE;EACE,mBAZiC;ApGkxnBrC;;AoGnwnBI;EACE,qBAhB+B;EAiB/B,+BAAA;ApGswnBN;AoGpwnBI;EACE,2BApB+B;EAqB/B,8BAAA;ApGswnBN;AoGpwnBI;EACE,2BAxB+B;EAyB/B,gCAAA;ApGswnBN;;AoGlwnBI;EACE,yBA9B+B;EA+B/B,0BA/B+B;ApGoynBrC;AoGnwnBI;EACE,2BAlC+B;EAmC/B,8BAAA;ApGqwnBN;AoGnwnBI;EACE,6BAAA;EACA,4BAvC+B;ApG4ynBrC;;AoGjwnBI;EACE,yBAAA;EACA,oEAAA;EACA,sEAAA;ApGownBN;;AoGhwnBI;EACE,+BAAA;EACA,oEAAA;EACA,qEAAA;ApGmwnBN;;AoG/vnBI;EACE,6BAAA;EACA,uEAAA;EACA,sEAAA;ApGkwnBN;;AoG9vnBI;EACE,6BAAA;EACA,uEAAA;EACA,+BAAA;EACA,qEAAA;ApGiwnBN;;AoG7znBE;EACE,mBATiC;ApGy0nBrC;;AoG9znBE;EACE,mBAZiC;ApG60nBrC;;AoG9znBI;EACE,qBAhB+B;EAiB/B,+BAAA;ApGi0nBN;AoG/znBI;EACE,2BApB+B;EAqB/B,8BAAA;ApGi0nBN;AoG/znBI;EACE,2BAxB+B;EAyB/B,gCAAA;ApGi0nBN;;AoG7znBI;EACE,yBA9B+B;EA+B/B,0BA/B+B;ApG+1nBrC;AoG9znBI;EACE,2BAlC+B;EAmC/B,8BAAA;ApGg0nBN;AoG9znBI;EACE,6BAAA;EACA,4BAvC+B;ApGu2nBrC;;AoG5znBI;EACE,yBAAA;EACA,yDAAA;EACA,2DAAA;ApG+znBN;;AoG3znBI;EACE,+BAAA;EACA,yDAAA;EACA,0DAAA;ApG8znBN;;AoG1znBI;EACE,6BAAA;EACA,4DAAA;EACA,2DAAA;ApG6znBN;;AoGzznBI;EACE,6BAAA;EACA,4DAAA;EACA,+BAAA;EACA,0DAAA;ApG4znBN;;AoGxznBA;;4BAAA;ACnOA;;4BAAA;AAGA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;ArGiioBF;AqG/hoBE;EACE,aAAA;ArGiioBJ;AqG/hoBI;EACE,sCAAA;ArGiioBN;AqG/hoBM;EACE,2BAAA;ArGiioBR;AqG7hoBI;EACE,wCAAA;ArG+hoBN;;AqG1hoBA;EACE,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBzBpBY;EyBqBZ,gBAAA;ArG6hoBF;AqG3hoBE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,sBzBLI;EyBMJ,gBAAA;EACA,mBAAA;ArG6hoBJ;;AqGvhoBI;EACE,gBAAA;EACA,oBzBiBK;EyBhBL,UAAA;EACA,kBAAA;EACA,SAAA;EACA,czBpCO;EyBqCP,gBAAA;EACA,YAAA;ArG0hoBN;AqGphoBM;EACE,gBAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;ArGshoBR;;AqG/goBE;EACE,WAAA;EACA,YAAA;ArGkhoBJ;AqG/goBM;EACE,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,QAAA;ArGihoBR;;AqGxgoBM;EACE,UAAA;EACA,eAAA;ArG2goBR;AqGrgoBQ;EACE,UAAA;ArGugoBV;AqGpgoBQ;EACE,2BAAA;ArGsgoBV;;AqG3/nBQ;EACE,QAAA;EACA,SAAA;EACA,cAAA;ArG8/nBV;AqGx/nBU;EACE,UAAA;EACA,QAAA;ArG0/nBZ;AqGn/nBE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;ArGq/nBJ;AqGl/nBM;EACE,WAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;ArGo/nBR;AqG7+nBM;EACE,WAAA;ArG++nBR;;AqGx+nBE;EACE,sBzB9HI;EyB+HJ,sCAAA;EACA,gBAAA;ArG2+nBJ;AqGz+nBI;EACE,yBzB5JQ;EyB6JR,WAAA;EACA,WzBrIE;A5EgnoBR;;AqGp+nBI;EACE,aAAA;ArGu+nBN;AqGr+nBM;EACE,6BzB9JY;EyB+JZ,sCAAA;ArGu+nBR;AqGr+nBQ;EACE,sCAAA;EACA,WAAA;EACA,2BAAA;ArGu+nBV;AqGp+nBQ;EACE,WzB1JF;A5EgooBR;;AqG99nBE;EACE,sCAAA;EACA,wCAAA;ArGi+nBJ;AqG59nBM;EACE,wCAAA;EACA,sCAAA;ArG89nBR;AqG59nBQ;EACE,sCAAA;ArG89nBV;AqGx9nBE;EACE,yBAAA;EACA,wCAAA;ArG09nBJ;AqGr9nBM;EACE,wCAAA;EACA,yBAAA;ArGu9nBR;AqGr9nBQ;EACE,yBzBjNG;A5EwqoBb;AqGj9nBE;EACE,yBAAA;EACA,wCAAA;ArGm9nBJ;AqG98nBM;EACE,wCAAA;EACA,yBAAA;ArGg9nBR;AqG98nBQ;EACE,yBzB7OM;A5E6roBhB;AqG18nBE;EACE,yBAAA;EACA,wCAAA;ArG48nBJ;AqGv8nBM;EACE,wCAAA;EACA,yBAAA;ArGy8nBR;AqGv8nBQ;EACE,yBzBjQM;A5E0soBhB;AqGn8nBE;EACE,yBAAA;EACA,wCAAA;ArGq8nBJ;AqGh8nBM;EACE,wCAAA;EACA,yBAAA;ArGk8nBR;AqGh8nBQ;EACE,yBzBlRG;A5EotoBb;AqG57nBE;EACE,yBAAA;EACA,wCAAA;ArG87nBJ;AqGz7nBM;EACE,wCAAA;EACA,yBAAA;ArG27nBR;AqGz7nBQ;EACE,yBzBlSK;A5E6toBf;AqGr7nBE;EACE,sCAAA;EACA,wCAAA;ArGu7nBJ;AqGl7nBM;EACE,wCAAA;EACA,sCAAA;ArGo7nBR;AqGl7nBQ;EACE,sCAAA;ArGo7nBV;AqG96nBE;EACE,wCAAA;EACA,wCAAA;ArGg7nBJ;AqG36nBM;EACE,wCAAA;EACA,wCAAA;ArG66nBR;AqG36nBQ;EACE,wCAAA;ArG66nBV;;AqGt6nBA;EACE,mBAAA;ArGy6nBF;AqGv6nBE;EACE,cAAA;ArGy6nBJ;AqGr6nBI;EACE,YAAA;ArGu6nBN;;AqGj6nBI;EACE,sCAAA;EACA,kCAAA;ArGo6nBN;;AqG/5nBA;;4BAAA;AChXA;;4BAAA;AAIE;;EAEE,sCAAA;AtGoxoBJ;;AsGhxoBE;EACE,kBAAA;AtGmxoBJ;;AsG/woBA;EACE,yBAAA;AtGkxoBF;;AsGzwoBI;;EACE,2BAAA;AtG6woBN;AsG3woBI;;;;EAEE,sCAAA;EACA,W1BQE;A5EuwoBR;;AsGrxoBI;;EACE,2BAAA;AtGyxoBN;AsGvxoBI;;;;EAEE,sCAAA;EACA,W1BQE;A5EmxoBR;;AsGjyoBI;;EACE,cAAA;AtGqyoBN;AsGnyoBI;;;;EAEE,yBAAA;EACA,W1BQE;A5E+xoBR;;AsG7yoBI;;EACE,cAAA;AtGizoBN;AsG/yoBI;;;;EAEE,yBAAA;EACA,W1BQE;A5E2yoBR;;AsGzzoBI;;EACE,cAAA;AtG6zoBN;AsG3zoBI;;;;EAEE,yBAAA;EACA,W1BQE;A5EuzoBR;;AsGr0oBI;;EACE,cAAA;AtGy0oBN;AsGv0oBI;;;;EAEE,yBAAA;EACA,W1BQE;A5Em0oBR;;AsGj1oBI;;EACE,cAAA;AtGq1oBN;AsGn1oBI;;;;EAEE,yBAAA;EACA,W1BQE;A5E+0oBR;;AsG71oBI;;EACE,cAAA;AtGi2oBN;AsG/1oBI;;;;EAEE,yBAAA;EACA,W1BQE;A5E21oBR;;AsGz2oBI;;EACE,cAAA;AtG62oBN;AsG32oBI;;;;EAEE,yBAAA;EACA,W1BQE;A5Eu2oBR;;AsGz2oBI;;;EAGE,kCAAA;AtG42oBN;;AsGt2oBI;EACE,gBAAA;EACA,gBAAA;AtGy2oBN;;AsGp2oBA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;AtGu2oBF;AsGr2oBI;EACE,eAAA;EACA,c1BvCO;E0BwCP,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AtGu2oBN;AsGt2oBM;EAIE,2BAAA;AtGq2oBR;AsGn2oBM;EAGE,mBAAA;AtGm2oBR;;AsG71oBE;EACE,kCAAA;EACA,yBAAA;EACA,c1B/DS;A5E+5oBb;AsG91oBE;;EAEE,6BAAA;EACA,uCAAA;EACA,2BAAA;EACA,gBAAA;EACA,yBAAA;AtGg2oBJ;;AsG51oBE;EACE,mCAAA;EACA,yBAAA;EACA,c1B9ES;E0B+ET,iBAAA;AtG+1oBJ;AsG71oBE;;EAEE,6BAAA;EACA,wCAAA;EACA,2BAAA;EACA,gBAAA;EACA,yBAAA;AtG+1oBJ;;AsGv1oBI;;;;EAIE,2BAAA;EACA,6BAAA;AtG01oBN;AsGv1oBM;EACE,gBAAA;AtGy1oBR;AsGx1oBQ;EAGE,6CAAA;AtGw1oBV;AsGt1oBQ;EAIE,2BAAA;AtGq1oBV;;AsG/0oBI;;EAEE,uCAAA;EACA,2BAAA;AtGk1oBN;;AsG90oBI;;EAEE,wCAAA;EACA,2BAAA;AtGi1oBN;;AsGp3oBI;;;;EAIE,2BAAA;EACA,6BAAA;AtGu3oBN;AsGp3oBM;EACE,gBAAA;AtGs3oBR;AsGr3oBQ;EAGE,6CAAA;AtGq3oBV;AsGn3oBQ;EAIE,2BAAA;AtGk3oBV;;AsG52oBI;;EAEE,uCAAA;EACA,2BAAA;AtG+2oBN;;AsG32oBI;;EAEE,wCAAA;EACA,2BAAA;AtG82oBN;;AsGj5oBI;;;;EAIE,cAAA;EACA,6BAAA;AtGo5oBN;AsGj5oBM;EACE,gBAAA;AtGm5oBR;AsGl5oBQ;EAGE,gCAAA;AtGk5oBV;AsGh5oBQ;EAIE,cAAA;AtG+4oBV;;AsGz4oBI;;EAEE,0BAAA;EACA,cAAA;AtG44oBN;;AsGx4oBI;;EAEE,2BAAA;EACA,cAAA;AtG24oBN;;AsG96oBI;;;;EAIE,cAAA;EACA,6BAAA;AtGi7oBN;AsG96oBM;EACE,gBAAA;AtGg7oBR;AsG/6oBQ;EAGE,gCAAA;AtG+6oBV;AsG76oBQ;EAIE,cAAA;AtG46oBV;;AsGt6oBI;;EAEE,0BAAA;EACA,cAAA;AtGy6oBN;;AsGr6oBI;;EAEE,2BAAA;EACA,cAAA;AtGw6oBN;;AsG38oBI;;;;EAIE,cAAA;EACA,6BAAA;AtG88oBN;AsG38oBM;EACE,gBAAA;AtG68oBR;AsG58oBQ;EAGE,gCAAA;AtG48oBV;AsG18oBQ;EAIE,cAAA;AtGy8oBV;;AsGn8oBI;;EAEE,0BAAA;EACA,cAAA;AtGs8oBN;;AsGl8oBI;;EAEE,2BAAA;EACA,cAAA;AtGq8oBN;;AsGx+oBI;;;;EAIE,cAAA;EACA,6BAAA;AtG2+oBN;AsGx+oBM;EACE,gBAAA;AtG0+oBR;AsGz+oBQ;EAGE,gCAAA;AtGy+oBV;AsGv+oBQ;EAIE,cAAA;AtGs+oBV;;AsGh+oBI;;EAEE,0BAAA;EACA,cAAA;AtGm+oBN;;AsG/9oBI;;EAEE,2BAAA;EACA,cAAA;AtGk+oBN;;AsGrgpBI;;;;EAIE,cAAA;EACA,6BAAA;AtGwgpBN;AsGrgpBM;EACE,gBAAA;AtGugpBR;AsGtgpBQ;EAGE,gCAAA;AtGsgpBV;AsGpgpBQ;EAIE,cAAA;AtGmgpBV;;AsG7/oBI;;EAEE,0BAAA;EACA,cAAA;AtGggpBN;;AsG5/oBI;;EAEE,2BAAA;EACA,cAAA;AtG+/oBN;;AsGlipBI;;;;EAIE,cAAA;EACA,6BAAA;AtGqipBN;AsGlipBM;EACE,gBAAA;AtGoipBR;AsGnipBQ;EAGE,gCAAA;AtGmipBV;AsGjipBQ;EAIE,cAAA;AtGgipBV;;AsG1hpBI;;EAEE,0BAAA;EACA,cAAA;AtG6hpBN;;AsGzhpBI;;EAEE,2BAAA;EACA,cAAA;AtG4hpBN;;AsG/jpBI;;;;EAIE,cAAA;EACA,6BAAA;AtGkkpBN;AsG/jpBM;EACE,gBAAA;AtGikpBR;AsGhkpBQ;EAGE,gCAAA;AtGgkpBV;AsG9jpBQ;EAIE,cAAA;AtG6jpBV;;AsGvjpBI;;EAEE,0BAAA;EACA,cAAA;AtG0jpBN;;AsGtjpBI;;EAEE,2BAAA;EACA,cAAA;AtGyjpBN;;AsGpjpBE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;AtGujpBJ;AsGrjpBM;EACE,SAAA;AtGujpBR;AsGtjpBQ;EACE,YAAA;AtGwjpBV;AsGvjpBU;EACE,kBAAA;AtGyjpBZ;;AsGjjpBA;;4BAAA;AChLA;;4BAAA;AAGA;;;;;;EAME,qB3BOW;A5EgupBb;;AuGrupBA;EACE,UAAA;AvGwupBF;;AuGtupBA;EACE,kB3B4Ge;A5E6npBjB;AuGtupBM;EACE,4B3BHK;A5E2upBb;AuGpupBE;;EAEE,gBAAA;AvGsupBJ;AuGnupBI;EACE,W3BUE;A5E2tpBR;AuGnupBI;EACE,W3BOE;A5E8tpBR;AuG/tpBQ;EACE,WAAA;AvGiupBV;AuG3tpBQ;EACE,c3BtCM;A5EmwpBhB;AuGvtpBQ;EACE,c3B3CM;A5EowpBhB;AuGjtpBQ;;EAEE,c3BrDM;A5EwwpBhB;AuG9spBE;EACE,c3BnEoB;E2BoEpB,gBAAA;AvGgtpBJ;AuG9spBE;EACE,c3BvEoB;A5EuxpBxB;AuG7spBE;EACE,W3BtCI;A5EqvpBR;AuG7spBE;EACE,c3B9EoB;A5E6xpBxB;AuG7spBE;EACE,iB3B2CuB;A5EoqpB3B;;AuGtspBY;EACE,c3BrFE;A5E8xpBhB;AuGtspBU;EACE,0BAAA;EACA,W3B3DJ;A5EmwpBR;AuG/rpBQ;EACE,0CAAA;AvGispBV;AuGhspBU;EACE,W3BvEJ;A5EywpBR;;AuG1rpBE;EACE,W3BhFI;A5E6wpBR;;AuG1rpBA;EACE,W3BpFM;E2BqFN,yB3BkBuB;A5E2qpBzB;AuG5rpBE;;EAEE,kB3BxFI;E2ByFJ,W3BzFI;A5EuxpBR;AuG5rpBE;EACE,SAAA;AvG8rpBJ;;AuG1rpBE;;EAEE,W3BlGI;A5E+xpBR;;AuGxrpBI;EACE,2BAAA;AvG2rpBN;;AuGvrpBA;EACE,+BAAA;EACA,gCAAA;AvG0rpBF;AuGzrpBE;;;;;;EAME,oBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;AvG2rpBJ;;AuGxrpBA;EACE,+BAAA;EACA,gCAAA;AvG2rpBF;AuG1rpBE;;;;;;EAME,+BAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;AvG4rpBJ;;AuGzrpBA;EACE,+BAAA;EACA,gCAAA;AvG4rpBF;AuG3rpBE;;;;;;EAME,+BAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;AvG6rpBJ;;AuGxrpBE;;EAEE,qB3BlEe;E2BmEf,e3BlEY;A5E6vpBhB;;AuGvrpBE;;EAEE,oB3BvEe;E2BwEf,e3BvEY;A5EiwpBhB;;AuGtrpBE;;EAEE,qB3B5Ee;A5EqwpBnB;;AuGrrpBE;;EAEE,oB3BhFe;E2BiFf,c3BhFY;A5EwwpBhB;;AuGprpBE;;EAEE,oB3BrFe;E2BsFf,c3BrFY;A5E4wpBhB;;AuGlrpBE;;;EAGE,6BAAA;EACA,gBAAA;AvGqrpBJ;;AuGjrpBE;;;EAGE,aAAA;EACA,+BAAA;AvGorpBJ;AuGjrpBI;EACE,gBAAA;AvGmrpBN;AuGjrpBM;EACE,kBAAA;AvGmrpBR;AuG7qpBM;EACE,gBAAA;AvG+qpBR;;AuGzqpBE;EACE,uBAAA;AvG4qpBJ;AuGzqpBI;EACE,uBAAA;AvG2qpBN;AuGxqpBE;EACE,aAAA;AvG0qpBJ;;AuGpqpBM;EACE,8CAAA;AvGuqpBR;;AuGjqpBE;;;;;;EAME,qB3BjRS;A5Eq7pBb;;AuG7ppBQ;EACE,0CAAA;EACA,2BAAA;AvGgqpBV;AuG/ppBU;;EAEE,c3BrSI;A5Es8pBhB;;AuG1ppBA;;4BAAA;AAGA;EACE,WAAA;AvG6ppBF;;AuG3ppBA;EACE,YAAA;AvG8ppBF;;AwGz9pBA;;EAEE,aAAA;EACA,uBAAA;AxG49pBF;;AwG19pBA;EACE,yBAAA;EACA,eAAA;AxG69pBF;AwG59pBE;EACE,yBAAA;AxG89pBJ;;AwG39pBA;EACE,eAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;AxG89pBF;;AwG59pBA;EACE,YAAA;AxG+9pBF;;AwG79pBA;EACE,WAAA;AxGg+pBF;;AwG99pBA;EACE,0BAAA;AxGi+pBF;;AwG/9pBA;EACE,aAAA;AxGk+pBF;;AwG99pBI;EACE,UAAA;AxGi+pBN;AwG99pBE;EACE,0BAAA;AxGg+pBJ;AwG99pBE;EACE,4BAAA;AxGg+pBJ;AwG79pBI;EACE,yBAAA;AxG+9pBN;AwG59pBE;EACE,iDAAA;AxG89pBJ;AwG59pBE;;;;EAIE,sBAAA;AxG89pBJ;AwGt9pBc;EACE,aAAA;EACA,6BAAA;AxGw9pBhB;AwGr9pBoB;EACE,iBAAA;AxGu9pBtB;;AwG38pBA;EAQgB;IACE,cAAA;ExGu8pBhB;EwGt8pBgB;IACE,cAAA;IACA,cAAA;ExGw8pBlB;EwGv8pBkB;IACE,gBAAA;ExGy8pBpB;AACF;AwG97pBA;EASkB;IACE,uBAAA;ExGw7pBlB;AACF;AyG7iqBA;;4BAAA;AAKI;EACE,eAAA;AzG6iqBN;AyG1iqBE;EACE,uBAAA;AzG4iqBJ;AyGxiqBM;EACE,kBAAA;EACA,mBAAA;EACA,SAAA;EACA,sBAAA;EACA,mBAAA;AzG0iqBR;AyGziqBQ;EACE,gBAAA;AzG2iqBV;AyGziqBQ;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;AzG2iqBV;AyGziqBQ;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AzG2iqBV;AyGtiqBE;EACE,8BAAA;AzGwiqBJ;AyGviqBI;EACE,2BAAA;AzGyiqBN;AyGpiqBM;EACE,iBAAA;AzGsiqBR;AyGpiqBM;EACE,aAAA;AzGsiqBR;;AyGjiqBA;;4BAAA;AC3DA;;4BAAA;AAIA;EACE,0CAAA;EACA,oCAAA;EACA,yCAAA;A1GimqBF;;A0G/lqBA;EACE,6BAAA;A1GkmqBF;;A0GhmqBA;EACE,W9B0BM;E8BzBN,2CAAA;EACA,mB9BFa;E8BGb,0FAAA;EACA,sBAAA;EACA,wCAAA;A1GmmqBF;;A0GjmqBA;EACE,uBAAA;A1GomqBF;A0GnmqBE;EACE,6BAAA;EACA,+BAAA;EACA,yC9B6LS;E8B5LT,8BAAA;A1GqmqBJ;A0GnmqBE;EACE,6BAAA;EACA,+BAAA;EACA,yC9BuLS;E8BtLT,8BAAA;A1GqmqBJ;A0GnmqBE;EACE,6BAAA;EACA,+BAAA;EACA,yC9BiLS;E8BhLT,8BAAA;A1GqmqBJ;A0GnmqBE;EACE,6BAAA;EACA,+BAAA;EACA,gCAAA;EACA,uC9B0KS;A5E27pBb;A0GnmqBE;EACE,6BAAA;EACA,+BAAA;EACA,gCAAA;EACA,uC9BoKS;A5Ei8pBb;A0GnmqBE;EACE,sC9BiKS;E8BhKT,+BAAA;EACA,gCAAA;EACA,8BAAA;A1GqmqBJ;A0GnmqBE;EACE,6BAAA;EACA,wC9B0JS;E8BzJT,gCAAA;EACA,8BAAA;A1GqmqBJ;A0GnmqBE;EACE,6BAAA;EACA,wC9BoJS;E8BnJT,gCAAA;EACA,8BAAA;A1GqmqBJ;;A0GlmqBA;EACE,sC9B8IW;E8B7IX,yCAAA;EACA,W9BnCM;E8BoCN,kC9B2IW;A5E09pBb;;A0GnmqBA;EACE,yBAAA;EACA,2BAAA;EACA,yBAAA;EACA,sB9B1CM;E8B2CN,6CAAA;A1GsmqBF;A0GrmqBE;EACE,qB9BlEc;A5EyqqBlB;A0GrmqBE;EACE,mDAAA;A1GumqBJ;;A0GpmqBA;EACE,2B9B2HW;A5E4+pBb;;A0GpmqBE;EACE,yBAAA;A1GumqBJ;;A0GpmqBA;EACE,2B9BmHW;E8BlHX,qB9BlFgB;A5EyrqBlB;A0GtmqBE;EACE,2B9BgHS;E8B/GT,qB9BrFc;A5E6rqBlB;;A0GlmqBM;EACE,mB9B9FK;A5EmsqBb;A0GpmqBQ;EACE,gB9BzEF;A5E+qqBR;A0GpmqBQ;EACE,gB9B5EF;A5EkrqBR;;A0GhmqBA;EACE,yB9B5GY;A5E+sqBd;;A0GjmqBA;EACE,sC9ByFW;A5E2gqBb;;A0GlmqBA;EACE,wCAAA;A1GqmqBF;;A0GnmqBA;EACE,wCAAA;EACA,2CAAA;A1GsmqBF;;A0GpmqBA;EACE,4CAAA;A1GumqBF;;A0GrmqBA;;4BAAA;ACzIA;;4BAAA;AAGA;EACE,WAAA;A3GovqBF;A2GlvqBE;EACE,sBAAA;A3GovqBJ;A2GlvqBI;EACE,sBAAA;A3GovqBN;A2GjvqBI;EACE,sBAAA;A3GmvqBN;A2G/uqBE;EACE,wBAAA;A3GivqBJ;;A2G5uqBE;EACE,YAAA;EACA,cAAA;A3G+uqBJ;A2G5uqBE;EACE,YAAA;EACA,cAAA;EACA,WAAA;A3G8uqBJ;;A2G1uqBA;EACE,wBAAA;A3G6uqBF;;A2G1uqBA;EACE,kBAAA;A3G6uqBF;;A2G1uqBA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;A3G6uqBF;;A2GzuqBE;EACE,YAAA;EACA,sBAAA;A3G4uqBJ;A2G1uqBI;EACE,yBAAA;A3G4uqBN;A2GzuqBI;EACE,yBAAA;A3G2uqBN;;A2GtuqBA;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EAGA,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,cAAA;EACA,UAAA;A3GyuqBF;;A2GtuqBA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,sB/BrDM;E+BsDN,yCAAA;A3GyuqBF;;A2GtuqBA;EACE,cAAA;A3GyuqBF;;A2GtuqBA;EACE,eAAA;A3GyuqBF;A2GtuqBI;EACE,6BAAA;A3GwuqBN;;A2GnuqBA;EACE,kBAAA;EACA,aAAA;EACA,oCAAA;EACA,mBAAA;EACA,mBAAA;A3GsuqBF;A2GnuqBI;EACE,qBAAA;A3GquqBN;A2GvuqBE;EAKE,cAAA;EACA,mBAAA;A3GquqBJ;A2GnuqBI;EACE,W/BvFE;A5E4zqBR;A2GluqBI;EACE,W/B3FE;A5E+zqBR;;A2G/tqBA;EACE,kBAAA;EACA,kBAAA;A3GkuqBF;;A2G/tqBA;EACE,kBAAA;EACA,WAAA;A3GkuqBF;;A2G/tqBA;EACE,qBAAA;EACA,c/B9HU;A5Eg2qBZ;;A2G/tqBA;EACE,qBAAA;EACA,c/BnIU;A5Eq2qBZ;;A2G/tqBA;EACE,eAAA;EACA,eAAA;EACA,iBAAA;A3GkuqBF;;A2G/tqBA;EACE,YAAA;EACA,iBAAA;A3GkuqBF;;A2G/tqBA;EACE,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;A3GkuqBF;A2G/tqBI;EACE,gBAAA;A3GiuqBN;;A2G5tqBA;EACE,c/B/JU;E+BgKV,gBAAA;A3G+tqBF;;A2G5tqBA;EACE,W/BlJM;E+BmJN,gCAAA;A3G+tqBF;A2G7tqBE;EACE,W/BtJI;A5Eq3qBR;A2G5tqBE;EACE,W/B1JI;A5Ew3qBR;;A2G1tqBA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;A3G6tqBF;;A2G1tqBA;EACE,WAAA;EACA,YAAA;A3G6tqBF;;A2G1tqBE;EACE,e/BjNoB;A5E86qBxB;A2G3tqBE;EACE,a/BpNoB;A5Ei7qBxB;A2G3tqBE;EACE,c/BvNoB;A5Eo7qBxB;A2G3tqBE;EACE,iBAAA;EACA,cAAA;A3G6tqBJ;;A2GxtqBI;EACE,gCAAA;A3G2tqBN;A2GztqBI;EACE,8BAAA;A3G2tqBN;A2GztqBI;EACE,+BAAA;A3G2tqBN;;A2GvtqBA;;4BAAA;AC7OA;;4BAAA;AAIE;EACE,UAAA;EACA,YAAA;EACA,6BAAA;A5Gy8qBJ;;A4Gt8qBA;;EAEE,UAAA;EACA,YAAA;EACA,6BAAA;A5Gy8qBF;;A4Gv8qBA;EACE,cAAA;EACA,YAAA;EACA,gBAAA;A5G08qBF;;A4Gx8qBA;EACE,cAAA;A5G28qBF;A4G18qBE;EACE,6BhCCgB;EgCAhB,yBAAA;A5G48qBJ;A4G18qBE;EACE,WAAA;EACA,YAAA;A5G48qBJ;A4G18qBE;EACE,mBAAA;A5G48qBJ;;A4Gv8qBE;EACE,mBAAA;A5G08qBJ;;A4Gt8qBA;EACE,gBAAA;A5Gy8qBF;A4Gt8qBI;EACE,aAAA;A5Gw8qBN;A4Gj8qBQ;EACE,eAAA;EACA,2BAAA;A5Gm8qBV;A4G77qBU;EACE,2BAAA;A5G+7qBZ;;A4Gp7qBE;;EACE,iDAAA;A5Gw7qBJ;A4Gp7qBI;;EACE,aAAA;A5Gu7qBN;;A4Gh7qBE;;EACE,kBAAA;A5Go7qBJ;;A4G/6qBE;EACE,6BAAA;A5Gk7qBJ;;A4G96qBA;EACE,gCAAA;EACA,sCAAA;A5Gi7qBF;;A4G96qBA;EACE,gCAAA;A5Gi7qBF;;A4G96qBA;EACE,mBAAA;A5Gi7qBF;;A4G76qBA;EACE,kDAAA;EACA,oCAAA;EACA,yBAAA;A5Gg7qBF;A4G76qBI;EACE,6BhC9Fc;A5E6grBpB;;A4G16qBA;EACE,sCAAA;EACA,kBAAA;EACA,gBAAA;A5G66qBF;;A4G16qBA;EACE,wBAAA;EACA,iBAAA;A5G66qBF;;A4G16qBA;EACE,4BAAA;EACA,iDAAA;EACA,sBAAA;A5G66qBF;;A4G16qBA;EACE,iDAAA;A5G66qBF;A4G36qBE;EACE,oCAAA;A5G66qBJ;;A4Gx6qBA;EACE,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;A5G26qBF;A4Gz6qBE;EACE,6BAAA;A5G26qBJ;;A4Gv6qBA;EACE,cAAA;EACA,gBAAA;EACA,wBAAA;A5G06qBF;;A4Gv6qBA;EACE,mCAAA;EACA,uCAAA;A5G06qBF;;A4Gv6qBA;EACE,sCAAA;A5G06qBF;;A4Gt6qBA;EACE,0CAAA;A5Gy6qBF;A4Gv6qBE;EACE,mCAAA;A5Gy6qBJ;;A4Gn6qBI;EAEE,kCAAA;A5Gq6qBN;A4G95qBQ;EACE,4BAAA;A5Gg6qBV;A4G35qBQ;EACE,qDAAA;A5G65qBV;A4Gx5qBQ;EACE,4BAAA;A5G05qBV;A4Gr5qBQ;EACE,0EAAA;A5Gu5qBV;A4Gl5qBQ;EACE,gEAAA;A5Go5qBV;A4G/4qBQ;EACE,0EAAA;A5Gi5qBV;;A4Gz4qBA;EACE,kBAAA;A5G44qBF;;A4Gv4qBI;EACE,eAAA;A5G04qBN;;A4Gp4qBE;EACE,iDAAA;A5Gu4qBJ;A4Gr4qBI;EACE,8DAAA;A5Gu4qBN;;A4Gl4qBA;EACE,0BAAA;A5Gq4qBF;;A4Gj4qBE;;EAEE,2CAAA;A5Go4qBJ;A4Gh4qBI;EACE,2CAAA;A5Gk4qBN;A4Gh4qBM;;EAEE,+CAAA;A5Gk4qBR;;A4Gv3qBM;;;EAEE,sCAAA;A5G23qBR;A4Gv3qBQ;;;EAEE,sCAAA;A5G03qBV;;A4Gl3qBA;EACE,qBAAA;EACA,oBAAA;EACA,2BAAA;A5Gq3qBF;A4Gn3qBE;EACE,aAAA;EACA,uBAAA;A5Gq3qBJ;A4Gn3qBI;EACE,UAAA;EACA,aAAA;EACA,cAAA;A5Gq3qBN;A4Gj3qBE;EACE,qBAAA;EACA,aAAA;A5Gm3qBJ;A4Gh3qBE;EACE,wBAAA;EACA,iBAAA;EACA,mBhC5Tc;EgC6Td,mBAAA;EACA,WhChSI;EgCiSJ,gBAAA;EACA,eAAA;EACA,cAAA;EACA,4BAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;A5Gk3qBJ;;A4Gz2qBM;;EACE,sCAAA;A5G62qBR;;A4Gl2qBQ;;EAEE,2BAAA;A5Gq2qBV;A4G11qBY;EACE,2BAAA;A5G41qBd;A4G10qBE;EACE;IACE,oCAAA;E5Go1qBJ;E4Gj1qBE;IACE,gBhClWE;E5EqrrBN;AACF;;A4G90qBA;EACE,iCAAA;A5Gi1qBF;;A4G90qBA;;EAEE,iCAAA;A5Gi1qBF;;A4G70qBA;EACE,gBAAA;EACA,iBAAA;A5Gg1qBF;A4G90qBE;EACE,qBAAA;A5Gg1qBJ;;A4G10qBE;EACE,qBAAA;EACA,UAAA;EACA,aAAA;A5G60qBJ;A4G30qBI;EACE,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;A5G60qBN;A4G30qBM;EACE,iBAAA;A5G60qBR;A4G10qBM;EACE,YAAA;EACA,gCAAA;A5G40qBR;A4G10qBQ;EACE,YAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;A5G40qBV;A4Gx0qBU;EACE,cAAA;A5G00qBZ;A4Gr0qBM;EACE,YAAA;EACA,gCAAA;A5Gu0qBR;A4Gr0qBQ;EACE,YAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;A5Gu0qBV;A4Gn0qBU;EACE,WAAA;A5Gq0qBZ;A4Gh0qBM;EACE,aAAA;A5Gk0qBR;A4G/zqBM;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;A5Gi0qBR;A4G7zqBQ;EACE,YAAA;EACA,aAAA;EACA,6BhCldU;EgCmdV,YAAA;EACA,kBAAA;A5G+zqBV;A4G3zqBU;EACE,cAAA;A5G6zqBZ;;A4GpzqBA;EACE,yBAAA;A5GuzqBF;;A4GpzqBA;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;A5GuzqBF;A4GpzqBI;EACE,eAAA;A5GszqBN;;A4GjzqBA;EACE,aAAA;EACA,YAAA;A5GozqBF;;A4GhzqBA;EACE,sCAAA;EACA,qDAAA;A5GmzqBF;A4GjzqBE;EACE,mBAAA;A5GmzqBJ;;A4G/yqBE;EACE,aAAA;A5GkzqBJ;;A4G5yqBE;EACE,cAAA;A5G+yqBJ;;A4GxyqBM;EACE,yBAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;A5G2yqBR;A4G1yqBQ;EACE,aAAA;A5G4yqBV;A4G1yqBQ;EACE,aAAA;A5G4yqBV;A4GryqBI;EACE,6BAAA;A5GuyqBN;A4GpyqBE;EACE,sBhC3hBI;A5Ei0rBR;;A4GlyqBA;EACE,aAAA;A5GqyqBF;A4GnyqBE;EACE,UAAA;A5GqyqBJ;A4GlyqBE;EACE,cAAA;A5GoyqBJ;;A4G/xqBA;EACE,gBAAA;A5GkyqBF;A4GhyqBE;EACE,uBAAA;EACA,qBAAA;A5GkyqBJ;;A4G9xqBA;EACE,0EAAA;EACA,sBAAA;EACA,gBAAA;A5GiyqBF;A4G/xqBE;EACE,4BAAA;EACA,uBAAA;A5GiyqBJ;A4G9xqBE;EACE,0EAAA;A5GgyqBJ;;A4G5xqBA;EACE,0EAAA;EACA,sBAAA;A5G+xqBF;A4G7xqBE;EACE,4BAAA;EACA,uBAAA;A5G+xqBJ;A4G5xqBE;EACE,0EAAA;A5G8xqBJ;;A4G1xqBA;EACE,gEAAA;EACA,sBAAA;A5G6xqBF;A4G3xqBE;EACE,4BAAA;EACA,uBAAA;A5G6xqBJ;A4G1xqBE;EACE,gEAAA;A5G4xqBJ;;A4GxxqBA;EACE,0EAAA;EACA,sBAAA;EACA,gBAAA;A5G2xqBF;A4GzxqBE;EACE,4BAAA;EACA,uBAAA;A5G2xqBJ;A4GxxqBE;EACE,yEAAA;A5G0xqBJ;;A4GnxqBI;EACE,WAAA;EACA,aAAA;A5GsxqBN;A4GpxqBM;EACE,WAAA;A5GsxqBR;A4GnxqBM;EACE,eAAA;EACA,eAAA;A5GqxqBR;;A4G7wqBI;EACE,WAAA;EACA,aAAA;A5GgxqBN;A4G7wqBI;EACE,WAAA;A5G+wqBN;A4G5wqBI;EACE,eAAA;A5G8wqBN;;A4GpwqBU;EACE,yBhCprBI;A5E27rBhB;A4GrwqBY;EACE,wCAAA;A5GuwqBd;A4GjwqBU;EACE,yBhChsBI;A5Em8rBhB;A4GjwqBY;EACE,wCAAA;A5GmwqBd;A4G7vqBM;EACE,yBhCzsBK;EgC0sBL,WhC9qBA;EgC+qBA,2BAAA;EACA,4BAAA;A5G+vqBR;A4G7vqBQ;EACE,yCAAA;EACA,+BAAA;EACA,gCAAA;A5G+vqBV;A4G5vqBQ;EACE,gBAAA;A5G8vqBV;A4G3vqBQ;EACE,gBAAA;A5G6vqBV;A4GvvqBE;EACE,aAAA;A5GyvqBJ;A4GvvqBI;EACE,WAAA;A5GyvqBN;A4GnvqBU;EACE,6BhC5tBQ;A5Ei9rBpB;A4GlvqBc;EACE,SAAA;A5GovqBhB;A4G7uqBM;EACE,aAAA;A5G+uqBR;A4G5uqBM;EACE,yBAAA;EACA,iCAAA;EACA,chCrwBgB;A5Em/rBxB;A4G5uqBQ;EACE,aAAA;A5G8uqBV;A4GzuqBI;EACE,WAAA;A5G2uqBN;A4GzuqBM;EACE,gBAAA;A5G2uqBR;A4GzuqBQ;EACE,aAAA;A5G2uqBV;A4GvuqBU;EACE,aAAA;A5GyuqBZ;A4GpuqBM;EACE,UAAA;A5GsuqBR;A4GpuqBQ;EACE,aAAA;EACA,WAAA;EACA,oBAAA;A5GsuqBV;A4GpuqBU;EACE,UAAA;EACA,yBhCtyBC;EgCuyBD,kBAAA;EACA,UAAA;EACA,mBAAA;A5GsuqBZ;A4GpuqBY;EACE,WAAA;EACA,aAAA;EACA,eAAA;A5GsuqBd;A4GruqBc;EAEE,gCAAA;A5GsuqBhB;A4GpuqBc;EACE,gBAAA;A5GsuqBhB;A4GnuqBc;EACE,iBAAA;A5GquqBhB;A4GhuqBc;EACE,WAAA;A5GkuqBhB;A4G/tqBc;EACE,gBAAA;A5GiuqBhB;A4GxtqBE;EACE,yBhC50BS;A5EsisBb;A4GttqBQ;EACE,yBAAA;A5GwtqBV;A4GltqBM;EACE,gBAAA;A5GotqBR;;A4G5sqBE;EACE,cAAA;EACA,WAAA;EACA,aAAA;EACA,sCAAA;A5G+sqBJ;A4G7sqBI;EACE,aAAA;EACA,gDAAA;EACA,oCAAA;EACA,WhCv0BE;A5EshsBR;A4G5sqBI;EACE,YAAA;EACA,YAAA;EAEA,oBAAA;EACA,mBAAA;A5G8sqBN;A4G5sqBM;EACE,gBAAA;A5G8sqBR;A4G1sqBI;EACE,yBAAA;A5G4sqBN;A4GzsqBI;EACE,sCAAA;A5G2sqBN;A4GxsqBI;EACE,sCAAA;A5G0sqBN;;A4GrsqBA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;A5GwsqBF;;A4GrsqBA;EACE,aAAA;EACA,gDAAA;EACA,oCAAA;EACA,WhC/2BM;EgCg3BN,0BAAA;EACA,oBAAA;EACA,wBAAA;EACA,YAAA;EACA,iEAAA;EACA,yBAAA;A5GwsqBF;;A4GrsqBA;EACE,wBAAA;A5GwsqBF;;A4GrsqBA;EACE,oCAAA;EAGA,4BAAA;A5GwsqBF;;A4GrsqBA;EACE,YAAA;EACA,iEAAA;EACA,yBAAA;A5GwsqBF;;A4GrsqBA;EACE,cAAA;A5GwsqBF;;A4GrsqBA;EACE,gBAAA;EAEA,wBAAA;A5GwsqBF;;A4GrsqBA;EACE,cAAA;EACA,iBAAA;EACA,gDAAA;EACA,YAAA;A5GwsqBF;;A4GnsqBE;EACE,mBhCt7BU;A5E4nsBd;A4GlsqBI;EACE,0BAAA;A5GosqBN;A4GjsqBI;EACE,WhCt6BE;A5EymsBR;A4G9rqBM;EACE,sCAAA;A5GgsqBR;A4G3rqBM;EACE,yBhCh9BU;A5E6osBlB;A4GvrqBM;EACE,yBhCt9BQ;A5E+osBhB;A4GprqBM;EACE,yBhC39BK;A5EipsBb;A4GjrqBM;EACE,yBhCh+BQ;A5EmpsBhB;A4G9qqBM;EACE,yBhCr+BO;A5EqpsBf;;A4G1qqBA;EACE,+CAAA;EACA,yBhC/9BM;A5E4osBR;A4G3qqBE;EACE,WAAA;EACA,gBAAA;A5G6qqBJ;A4G1qqBE;EACE,0BAAA;A5G4qqBJ;A4GzqqBE;EACE,+BAAA;A5G2qqBJ;;A4GrqqBI;EACE,oBAAA;A5GwqqBN;;A4GlqqBE;EACE,qBAAA;A5GqqqBJ;A4GlqqBE;EACE,WAAA;EACA,YAAA;A5GoqqBJ;A4GjqqBE;EACE,iBAAA;A5GmqqBJ;A4GjqqBI;EACE,YAAA;A5GmqqBN;A4GhqqBI;EACE,WAAA;EACA,cAAA;A5GkqqBN;;A4GxpqBU;EACE,uBAAA;A5G2pqBZ;A4GzpqBY;EACE,aAAA;A5G2pqBd;A4GtpqBQ;EACE,2BAAA;A5GwpqBV;A4GtpqBU;EACE,2BAAA;A5GwpqBZ;A4G/oqBM;EACE,aAAA;A5GipqBR;A4G/oqBQ;EACE,kCAAA;A5GipqBV;A4G9oqBQ;EACE,2BAAA;A5GgpqBV;;A4GxoqBA;;EAEE,qBAAA;A5G2oqBF;;A4GxoqBA;EACE,qBAAA;A5G2oqBF;;A4GroqBI;EACE,qBAAA;A5GwoqBN;;A4GjoqBI;EACE,qCAAA;A5GooqBN;;A4G7nqBI;EACE,wBAAA;A5GgoqBN;;A4GznqBI;EACE,wBAAA;A5G4nqBN;;A4GrnqBI;EACE,wBAAA;A5GwnqBN;;A4GjnqBI;EACE,wBAAA;A5GonqBN;;A4G7mqBI;EACE,wBAAA;A5GgnqBN;;A4G5mqBA;EACE,sBAAA;EACA,cAAA;A5G+mqBF;;A4G3mqBI;EACE,kBAAA;A5G8mqBN;;A4G1mqBA;;EAEE,WAAA;EACA,YAAA;A5G6mqBF;;A4G1mqBA;EACE,YAAA;A5G6mqBF;;A4G1mqBA;EACE,YAAA;A5G6mqBF;;A4G1mqBA;;;EAGE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;A5G6mqBF;;A4GzmqBA;EACE,mBAAA;A5G4mqBF;A4GzmqBI;EACE,2BAAA;A5G2mqBN;A4GvmqBM;EACE,2BAAA;A5GymqBR;;A4GnmqBA;EAGM;IACE,UAAA;E5GomqBN;E4GlmqBM;IACE,sBAAA;E5GomqBR;E4GjmqBU;IACE,sBAAA;E5GmmqBZ;AACF;A4G3lqBE;EACE,uBAAA;EACA,4BAAA;EACA,wCAAA;EACA,iBAAA;A5G6lqBJ;A4G5lqBI;EACE,wCAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;A5G8lqBN;A4G7lqBM;EACE,WAAA;A5G+lqBR;A4G7lqBM;EACE,YAAA;EACA,gBAAA;A5G+lqBR;A4G5lqBM;EACE,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;A5G8lqBR;A4G7lqBQ;EACE,qCAAA;A5G+lqBV;A4G7lqBQ;EACE,qCAAA;EACA,qBAAA;A5G+lqBV;A4G7lqBQ;EACE,iBAAA;A5G+lqBV;A4G1lqBE;EACE,YAAA;EACA,aAAA;EACA,6BAAA;A5G4lqBJ;A4G3lqBI;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;EACA,4BAAA;A5G6lqBN;A4G5lqBM;EACE,kBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,4CAAA;EACA,YAAA;EACA,YAAA;A5G8lqBR;A4G7lqBQ;EACE,6BhCjwCU;EgCkwCV,chCnxCM;EgCoxCN,YAAA;A5G+lqBV;A4G9lqBU;EACE,oBhCrwCQ;A5Eq2sBpB;A4G3lqBM;EACE,sBhC7vCA;EgC8vCA,0BAAA;A5G6lqBR;A4G3lqBU;EACE,wBAAA;EACA,wBAAA;A5G6lqBZ;A4G3lqBU;EACE,eAAA;EACA,yCAAA;A5G6lqBZ;A4G1lqBQ;EACE,WAAA;A5G4lqBV;A4GzlqBU;EACE,gBAAA;A5G2lqBZ;A4GzlqBU;EACE,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,qCAAA;A5G2lqBZ;A4G1lqBY;EACE,cAAA;A5G4lqBd;A4GvlqBM;EACE,0BAAA;A5GylqBR;A4GxlqBQ;EACE,UAAA;A5G0lqBV;;A4GllqBE;EACE,SAAA;A5GqlqBJ;A4GplqBI;EACE,UAAA;A5GslqBN;A4GnlqBM;EACE,UAAA;EACA,kCAAA;EACA,YAAA;EACA,aAAA;A5GqlqBR;A4GplqBQ;EACE,WAAA;EACA,YAAA;A5GslqBV;A4GllqBI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;A5GolqBN;A4GjlqBM;EACE,cAAA;EACA,eAAA;EACA,iBAAA;A5GmlqBR;;A4G7kqBA;;4BAAA;AAMI;EACE,qCAAA;A5G6kqBN;A4G3kqBQ;EACE,YAAA;A5G6kqBV;A4G5kqBU;EACE,YAAA;A5G8kqBZ;A4GzkqBQ;EACE,YAAA;A5G2kqBV;A4GrkqBI;EACE,chCr4Ca;EgCs4Cb,gBAAA;A5GukqBN;A4GnkqBQ;EACE,6BAAA;EACA,gBAAA;EACA,eAAA;A5GqkqBV;A4GhkqBE;EACE,YAAA;A5GkkqBJ;A4GhkqBE;EACE,qCAAA;A5GkkqBJ;A4G9jqBM;EACE,YAAA;A5GgkqBR;A4G/jqBQ;EACE,SAAA;A5GikqBV;A4G3jqBE;EACE,sBAAA;EACA,gBAAA;EACA,qCAAA;EACA,eAAA;EACA,gBAAA;A5G6jqBJ;A4G3jqBE;;EAEE,gBAAA;A5G6jqBJ;A4GxjqBM;EACE,oCAAA;EACA,iCAAA;A5G0jqBR;A4GxjqBM;EACE,sBAAA;EACA,iCAAA;A5G0jqBR;A4GxjqBM;EACE,oCAAA;A5G0jqBR;A4GxjqBM;EACE,sBAAA;EACA,chCl6CK;EgCm6CL,gBAAA;A5G0jqBR;A4GxjqBU;EACE,eAAA;EACA,chC/6CA;EgCg7CA,iBAAA;A5G0jqBZ;A4GxjqBU;EACE,eAAA;EACA,kBAAA;A5G0jqBZ;A4GxjqBY;EACE,kBAAA;A5G0jqBd;A4GzjqBc;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,yBhC97CJ;EgC+7CI,WAAA;EACA,QAAA;A5G2jqBhB;A4GvjqBgB;EACE,yBhCh9CF;A5EygtBhB;A4GpjqBgB;EACE,yBhCn9CH;A5EygtBf;A4GhjqBQ;EACE,chCr+Cc;A5EuhtBxB;A4G3iqBI;EACE,chC7+CkB;EgC8+ClB,oBAAA;EACA,eAAA;A5G6iqBN;A4G3iqBI;EACE,chCl/CkB;A5E+htBxB;;A4GviqBE;EACE,YAAA;A5G0iqBJ;A4GxiqBE;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;A5G0iqBJ;A4GxiqBE;EACE,aAAA;A5G0iqBJ;;A4GtiqBA;EACE,6BAAA;A5GyiqBF;;A4GriqBE;EACE,YAAA;EACA,gBAAA;EACA,cAAA;A5GwiqBJ;;A4GniqBE;EACE,aAAA;A5GsiqBJ;;A4GliqBA;EACE,WAAA;EACA,YAAA;A5GqiqBF;;A4GniqBA;EACE,WAAA;A5GsiqBF;A4GpiqBI;EACE,aAAA;A5GsiqBN;A4GpiqBI;EACE,gBAAA;A5GsiqBN;;A4GjiqBE;EACE,kCAAA;A5GoiqBJ;A4GniqBI;EACE,iCAAA;A5GqiqBN;A4GjiqBI;EACE,UAAA;A5GmiqBN;;A4G7hqBE;EACE,gBAAA;A5GgiqBJ;A4G9hqBE;EACE,WAAA;A5GgiqBJ;;A4G7hqBA;;;;EAIE,yBhC3jDc;A5E2ltBhB;;A4G9hqBA;;;;;;;;;;;;EAYE,yBhCzkDc;A5E0mtBhB;;A4G/hqBA;;;;;;;;;;;;EAYE,yBhCvlDc;A5EyntBhB;;A4GhiqBA;;;;EAIE,0CAAA;A5GmiqBF;;A4GjiqBA;EACE,yBhChmDc;A5EootBhB;;A4GjiqBE;EACE,yBhCpmDY;A5EwotBhB;;A4GhiqBE;EACE,oBAAA;A5GmiqBJ;A4GjiqBE;EACE,WAAA;A5GmiqBJ;;A4G/hqBE;EACE,YAAA;EACA,mBAAA;EACA,WAAA;A5GkiqBJ;A4GhiqBE;EACE,SAAA;A5GkiqBJ;A4GhiqBE;EACE,yBhCznDY;A5E2ptBhB;A4G/hqBI;EACE,yBAAA;EACA,UAAA;EACA,WAAA;A5GiiqBN;A4G9hqBE;;;EAGE,YAAA;A5GgiqBJ;A4G9hqBE;EACE,chCznDM;A5EyptBV;A4G1hqBI;;;;EACE,yBhC/oDU;EgCgpDV,WhCjnDE;A5EgptBR;;A4G3hqBA;EACE,yBAAA;A5G8hqBF;;A4G5hqBA;EACE,sBhCznDM;EgC0nDN,YAAA;A5G+hqBF;;A4G7hqBA;EACE,yBhC5pDc;EgC6pDd,mBAAA;EACA,WhC/nDM;EgCgoDN,SAAA;A5GgiqBF;A4G/hqBE;EACE,SAAA;A5GiiqBJ;A4G/hqBE;EACE,UAAA;A5GiiqBJ;;A4G9hqBA;EACE,yBhCxqDc;EgCyqDd,mBAAA;A5GiiqBF;A4GhiqBE;EACE,yBhC3qDY;A5E6stBhB;;A4G/hqBA;EACE,UAAA;A5GkiqBF;;A4GhiqBA;EACE,QAAA;A5GmiqBF;;A4GjiqBA;;;EAGE,chCvrDc;EgCwrDd,uBAAA;A5GoiqBF;;A4GliqBA;EACE,QAAA;A5GqiqBF;;A4GniqBA;EACE,iBAAA;A5GsiqBF;;A4GpiqBA;;EAEE,aAAA;EACA,uBAAA;EACA,mBAAA;A5GuiqBF;;A4GniqBE;;EACE,SAAA;EACA,UAAA;EACA,kBhC5qDI;A5EmttBR;;A4GliqBE;;EACE,kBAAA;A5GsiqBJ;;A4G9hqBU;EACE,2BAAA;A5GiiqBZ;A4G3hqBM;EACE,iCAAA;A5G6hqBR;A4G5hqBQ;EACE,iCAAA;A5G8hqBV;;A4GvhqBA;EACE,aAAA;A5G0hqBF;;A6G7wtBA,eAAA;AAEA;EACE,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,2BAAA;EACA,yBAAA;EAIA,iBAAA;EAEA,mBAAA;EACA,wCAAA;A7G+wtBF;;A6G7wtBA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;A7GgxtBF;A6G9wtBE;EACE,aAAA;A7GgxtBJ;A6G7wtBE;EACE,eAAA;EACA,YAAA;A7G+wtBJ;;A6G5wtBA;;EAME,+BAAA;A7G+wtBF;;A6G5wtBA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;A7G+wtBF;A6G7wtBE;EAEE,WAAA;EACA,cAAA;A7G8wtBJ;A6G3wtBE;EACE,WAAA;A7G6wtBJ;A6G1wtBE;EACE,kBAAA;A7G4wtBJ;;A6GzwtBA;EACE,WAAA;EACA,YAAA;EACA,eAAA;A7G4wtBF;A6G3wtBE;EACE,YAAA;A7G6wtBJ;A6G3wtBE;EACE,cAAA;A7G6wtBJ;A6G3wtBE;EACE,aAAA;A7G6wtBJ;A6GxxtBA;EAcE,aAAA;A7G6wtBF;A6G3wtBE;EACE,oBAAA;A7G6wtBJ;A6G1wtBE;EACE,cAAA;A7G4wtBJ;A6GzwtBE;EACE,kBAAA;A7G2wtBJ;A6GxwtBE;EACE,cAAA;EACA,YAAA;EACA,6BAAA;A7G0wtBJ;;A6GvwtBA;EACE,aAAA;A7G0wtBF;;A8Gp0tBA,UAAA;AAEE;EACE,oBAAA;EACA,6CAAA;EACA,uPAAA;EAIA,mBAAA;EACA,kBAAA;A9Gm0tBJ;A8G/ztBA,WAAA;AAEA;;EAEE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;EAGA,6BAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;A9Gg0tBF;A8G/ztBE;;;EAEE,aAAA;EACA,uBAAA;EACA,kBAAA;A9Gk0tBJ;A8Gj0tBI;;;EACE,UA5DmB;A9Gi4tBzB;A8Gl0tBE;;EACE,aA/DuB;A9Go4tB3B;A8Gn0tBE;;EACE,oBA7EgB;EA8EhB,eAAA;EACA,cAAA;EACA,YA9EgB;EA+EhB,aAxEoB;EAyEpB,mCAAA;EACA,kCAAA;A9Gs0tBJ;;A8Gl0tBA;EACE,WAAA;A9Gq0tBF;A8Gp0tBE;EACE,UAAA;EACA,YAAA;A9Gs0tBJ;A8Gp0tBE;EACE,YAzFmB;A9G+5tBvB;A8Gr0tBI;EACE,YA1FiB;A9Gi6tBvB;;A8Gl0tBA;EACE,YAAA;A9Gq0tBF;A8Gp0tBE;EACE,WAAA;EACA,WAAA;A9Gs0tBJ;A8Gp0tBE;EACE,YAtGmB;A9G46tBvB;A8Gr0tBI;EACE,YAzGiB;A9Gg7tBvB;;A8Gl0tBA,SAAA;AAEA;EACE,mBAAA;A9Go0tBF;;A8Gj0tBA;EACE,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;A9Go0tBF;A8Gn0tBE;EACE,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;EACA,eAAA;A9Gq0tBJ;A8Gp0tBI;EACE,SAAA;EACA,uBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;A9Gs0tBN;A8Gr0tBM;EAEE,aAAA;A9Gs0tBR;A8Gr0tBQ;EACE,UAhJe;A9Gu9tBzB;A8Gp0tBM;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YA1Jc;EA2Jd,WAAA;EACA,YAAA;EACA,oBApKY;EAqKZ,cA7JS;EA8JT,iBAAA;EACA,kBAAA;EACA,YArKU;EAsKV,aA9JmB;EA+JnB,mCAAA;EACA,kCAAA;A9Gs0tBR;A8Gn0tBI;EACE,YA5KY;EA6KZ,aAvKkB;A9G4+tBxB;;A+G//tBA,iDAAA;AAEA;EACE,6BnCsBkB;EmCrBlB,cAAA;A/GiguBF;;A+G//tBA;EACE,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;A/GkguBF;A+GjguBE;EACE,aAAA;A/GmguBJ;;A+GhguBA;EACE,kBAAA;EACA,2BAAA;A/GmguBF;A+GlguBE;EACE,oBAAA;A/GoguBJ;A+GnguBI;EACE,yBnCRQ;EmCSR,YAAA;A/GqguBN;A+GpguBM;EACE,yBnCGI;A5EmguBZ;A+GnguBI;EACE,yBnCfQ;EmCgBR,YAAA;A/GqguBN;A+GpguBM;EACE,yBnCJI;A5E0guBZ;A+GjguBI;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,6DAAA;EACA,WAAA;EACA,WAAA;A/GmguBN;A+GlguBM;EACE,kBAAA;EACA,yBnCnBI;EmCoBJ,kBAAA;EACA,wCAAA;EACA,SAAA;EACA,WAAA;A/GoguBR;A+GjguBI;EACE,UAAA;EACA,UAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,6DAAA;A/GmguBN;A+GlguBM;EACE,WAAA;EACA,kBAAA;EACA,yBnCrCI;EmCsCJ,kBAAA;EACA,wCAAA;EACA,QAAA;A/GoguBR;A+G//tBI;EACE,oBAAA;A/GiguBN;A+GhguBM;EACE,yBnChDI;EmCiDJ,YAAA;A/GkguBR;A+GjguBQ;EACE,YAAA;EACA,yBAAA;A/GmguBV;A+GhguBM;EACE,yBnCxDI;EmCyDJ,YAAA;A/GkguBR;A+GjguBQ;EACE,yBAAA;A/GmguBV;A+G9/tBM;EACE,YAAA;A/GgguBR;A+G//tBQ;EACE,yBnCjFI;EmCkFJ,YAAA;A/GiguBV;A+GhguBU;EACE,yBAAA;A/GkguBZ;A+G9/tBM;EACE,YAAA;A/GgguBR;A+G//tBQ;EACE,yBnC3FI;EmC4FJ,YAAA;A/GiguBV;A+GhguBU;EACE,yBnChFA;A5EkluBZ;A+Gp/tBE;EACE,YAAA;A/Gs/tBJ;A+Gp/tBE;EACE,YAAA;A/Gs/tBJ;;A+Gl/tBE;EACE,aAAA;A/Gq/tBJ;A+Gn/tBE;EACE,eAAA;A/Gq/tBJ;;A+Gl/tBA,+CAAA;ACzIA;;4BAAA;AAIE;EACE,sBAAA;AhH8nuBJ;AgH5nuBE;EACE,4BAAA;EACA,6BAAA;AhH8nuBJ;AgH5nuBE;EACE,gBAAA;EACA,cAAA;AhH8nuBJ;AgH5nuBE;EACE,mBAAA;AhH8nuBJ;AgH7nuBI;EACE,gBAAA;AhH+nuBN;AgH9nuBM;EACE,qBAAA;EACA,eAAA;EACA,cpCnBqB;A5EmpuB7B;AgH/nuBQ;EACE,kBAAA;EACA,gBAAA;AhHiouBV;AgH/nuBQ;EACE,kBAAA;EACA,gBAAA;AhHiouBV;AgH/nuBQ;EACE,4BAAA;EACA,mBAAA;AhHiouBV;AgH3nuBI;EACE,yBpCjBI;A5E8ouBV;AgH3nuBI;EACE,cAAA;AhH6nuBN;AgH5nuBM;EACE,qBAAA;EACA,eAAA;EACA,cpC5CqB;EoC6CrB,eAAA;EACA,wBAAA;AhH8nuBR;AgH7nuBQ;EANF;IAOI,eAAA;EhHgouBR;AACF;AgH/nuBQ;EACE,eAAA;AhHiouBV;AgH/nuBQ;EACE,kBAAA;AhHiouBV;AgH7nuBI;EACE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AhH+nuBN;AgH5nuBE;EACE,cpClEyB;A5EgsuB7B;AgH7nuBI;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AhH+nuBN;;AgH1nuBE;EACE,2DAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,MAAA;EACA,WAAA;EACA,SAAA;AhH6nuBJ;AgH1nuBI;EACE,4DAAA;EACA,yBAAA;AhH4nuBN;AgHznuBE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;AhH2nuBJ;AgH1nuBI;EACE,WpC9DE;EoC+DF,gBAAA;AhH4nuBN;AgH1nuBI;EACE,eAAA;EACA,WpCnEE;EoCoEF,mBAAA;AhH4nuBN;AgHznuBM;EACE,WpCxEA;A5EmsuBR;;AgHpnuBI;EACE,aAAA;AhHunuBN;AgHrnuBI;EACE,aAAA;EACA,WAAA;EACA,gBAAA;AhHunuBN;AgHrnuBI;EACE,gBAAA;EACA,mBAAA;AhHunuBN;AgHpnuBE;EACE,aAAA;AhHsnuBJ;;AgHlnuBE;EACE,WAAA;AhHqnuBJ;AgHnnuBE;EACE,aAAA;AhHqnuBJ;AgHpnuBI;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AhHsnuBN;;AgHjnuBA;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;AhHonuBF;AgHlnuBI;EACE,uBAAA;EACA,gBAAA;EACA,qBAAA;EACA,oBAAA;EACA,4BAAA;AhHonuBN;AgHlnuBI;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cpCpKuB;EoCqKvB,uBAAA;EACA,gBAAA;EACA,qBAAA;EACA,oBAAA;EACA,4BAAA;AhHonuBN;AgHnnuBM;EAZF;IAaI,qBAAA;EhHsnuBN;AACF;AgHpnuBI;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AhHsnuBN;AgHpnuBI;EACE,gBAAA;EACA,6BAAA;AhHsnuBN;AgHlnuBM;;EACE,eAAA;AhHqnuBR;;AgHhnuBA;EACE,iBAAA;EACA,oBAAA;AhHmnuBF;AgHlnuBE;EACE,gBAAA;EACA,mBAAA;AhHonuBJ;AgHlnuBE;EACE,mBAAA;AhHonuBJ;AgHnnuBI;EACE,gBAAA;AhHqnuBN;AgHjnuBI;EACE,kBAAA;AhHmnuBN;AgHhnuBE;EACE,eAAA;EACA,cAAA;EACA,cpCtNyB;EoCuNzB,mBAAA;EACA,gBAAA;AhHknuBJ;AgHhnuBE;EACE,gBAAA;AhHknuBJ;AgH/muBI;EACE,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;AhHinuBN;AgH/muBI;EACE,gBAAA;EACA,kBAAA;AhHinuBN;AgHhnuBM;EACE,kBAAA;EACA,eAAA;EACA,cpC5OqB;EoC6OrB,gBAAA;AhHknuBR;AgH7muBI;EACE,qBAAA;EACA,cpChOI;EoCiOJ,kBAAA;EACA,gBAAA;EACA,yBAAA;AhH+muBN;AgH9muBM;EACE,+BAAA;EACA,mBAAA;AhHgnuBR;AgH9muBM;EACE,mBAAA;AhHgnuBR;;AgHzmuBE;EACD,6BAAA;AhH4muBD;;AgHzmuBA;;4BAAA;AC3QA;;4BAAA;AAKI;;EAEE,aAAA;AjHw3uBN;AiHt3uBI;EACE,2CAAA;AjHw3uBN;AiHv3uBM;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,iBAAA;AjHy3uBR;;AiHp3uBA;EACE,wBAAA;AjHu3uBF;;AiHp3uBE;EACE,sCAAA;AjHu3uBJ;AiHn3uBM;EACE,mBAAA;AjHq3uBR;AiH92uBQ;EACE,crCpCc;A5Eo5uBxB;AiH92uBQ;EACE,YAAA;EACA,eAAA;AjHg3uBV;AiH/2uBU;EACE,aAAA;AjHi3uBZ;AiH92uBQ;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AjHg3uBV;AiH92uBQ;EACE,2BAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AjHg3uBV;AiH72uBc;EACE,6BrCnCI;A5Ek5uBpB;AiH32uBU;EACE,crC5CA;EqC6CA,iBAAA;AjH62uBZ;AiHz2uBU;EACE,0BAAA;AjH22uBZ;;AiHl2uBI;EACE,4BAAA;AjHq2uBN;AiHj2uBI;EACE,4BAAA;AjHm2uBN;;AiH91uBE;EACE,aAAA;EACA,eAAA;AjHi2uBJ;AiHh2uBI;EACE,WAAA;EACA,YAAA;EACA,YAAA;AjHk2uBN;AiH91uBE;EACE,qCAAA;EACA,sCAAA;EACA,yBAAA;EACA,gBAAA;AjHg2uBJ;AiH/1uBI;EACE,wCAAA;AjHi2uBN;AiH71uBI;EACE,aAAA;AjH+1uBN;AiH31uBI;;EAEE,eAAA;AjH61uBN;AiH11uBM;EACE,gCAAA;AjH41uBR;AiHz1uBI;EACE,sBAAA;AjH21uBN;AiHz1uBI;EACE,oBAAA;EACA,eAAA;EACA,qBAAA;AjH21uBN;;AiHt1uBE;EACE,mBAAA;AjHy1uBJ;;AiHr1uBE;EACE,aAAA;AjHw1uBJ;;AiHr1uBA;EACE,cAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;AjHw1uBF;AiHv1uBE;EACE,wBAAA;AjHy1uBJ;AiHv1uBE;EACE,kBAAA;EACA,MAAA;EACA,UAAA;AjHy1uBJ;AiHv1uBE;EACE,iBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,gBrC/HI;EqCgIJ,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AjHy1uBJ;;AiHr1uBA;EACE;IACE,UAAA;EjHw1uBF;EiHt1uBA;IACE,UAAA;EjHw1uBF;AACF;AiHr1uBE;EACE,YAAA;EACA,iBAAA;AjHu1uBJ;AiHt1uBI;EACE,kBAAA;EACA,WAAA;AjHw1uBN;AiHt1uBQ;EACE,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;AjHw1uBV;AiHv1uBU;EACE,WrClKJ;EqCmKI,eAAA;EACA,2BAAA;AjHy1uBZ;AiHt1uBY;EACE,cAAA;AjHw1uBd;AiHp1uBQ;EACE,WAAA;AjHs1uBV;AiHr1uBU;EACE,aAAA;AjHu1uBZ;AiHp1uBQ;EACE,gBAAA;AjHs1uBV;AiHp1uBQ;EACE,gBAAA;EACA,aAAA;EACA,6BAAA;AjHs1uBV;AiHr1uBU;EACE,mBAAA;EACA,+BAAA;AjHu1uBZ;AiHr1uBU;EACE,aAAA;EACA,gBAAA;AjHu1uBZ;AiHr1uBc;EACE,qBAAA;AjHu1uBhB;AiHt1uBgB;EACE,gBAAA;AjHw1uBlB;AiHt1uBgB;EACE,WAAA;EACA,YAAA;EACA,crC3NN;A5EmjvBZ;AiHl1uBQ;EACE,gDAAA;EACA,gBAAA;AjHo1uBV;AiHl1uBY;EACE,aAAA;AjHo1uBd;AiHl1uBY;EACE,cAAA;EACA,+BAAA;AjHo1uBd;AiHj1uBU;EACE,UAAA;AjHm1uBZ;AiH50uBQ;EACE,cAAA;EACA,eAAA;AjH80uBV;AiH30uBM;EACE,aAAA;AjH60uBR;AiH30uBU;EACE,cAAA;AjH60uBZ;AiH10uBQ;EACE,aAAA;EACA,mBAAA;AjH40uBV;AiH10uBY;EACE,cAAA;AjH40uBd;AiH10uBY;EACE,kBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;AjH40uBd;AiHv0uBc;EACE,cAAA;EACA,+BAAA;AjHy0uBhB;AiHn0uBU;EACE,gBAAA;AjHq0uBZ;AiHp0uBY;;;EAEE,aAAA;EACA,qBAAA;AjHu0uBd;AiHr0uBY;EACE,kBAAA;EACA,mBAAA;AjHu0uBd;AiHt0uBc;EACE,kBAAA;EACA,YAAA;EACA,QAAA;EACA,crCvSJ;A5E+mvBZ;AiHr0uBY;EACE,eAAA;AjHu0uBd;AiHt0uBc;EACE,UAAA;EACA,kBAAA;AjHw0uBhB;AiHn0uBQ;EACE,UAAA;AjHq0uBV;AiH9zuBM;EACE,8BAAA;AjHg0uBR;AiH/zuBQ;EACE,WAAA;EACA,YAAA;EACA,sBAAA;AjHi0uBV;AiH9zuBU;EACE,qBAAA;AjHg0uBZ;AiH/zuBY;EACE,iBAAA;AjHi0uBd;;AiHvzuBA;EAMY;IACE,iBAAA;EjHqzuBZ;EiHnzuBc;IACE,aAAA;EjHqzuBhB;EiHlzuBY;IACE,eAAA;EjHozuBd;AACF;AiH5yuBA;EAMY;IACE,aAAA;EjHyyuBZ;AACF;AiHlyuBA;EAKU;IACE,UAAA;EjHgyuBV;AACF;AiH1xuBA;EAEI;IACE,YAAA;EjH2xuBJ;EiHvxuBE;IACE,gBAAA;EjHyxuBJ;AACF;AiHtxuBA;EAGM;IACE,WAAA;EjHsxuBN;EiHlxuBQ;IACE,gBAAA;EjHoxuBV;EiH7wuBE;;IAEE,aAAA;EjH+wuBJ;EiH3wuBE;IACE,gBAAA;EjH6wuBJ;AACF;AiH1wuBA;EAIQ;IACE,gBAAA;EjHywuBR;EiH9vuBY;IACE,gBAAA;IACA,uBAAA;IACA,mBAAA;IACA,gBAAA;EjHgwuBd;EiH1vuBgB;IACE,aAAA;EjH4vuBlB;EiH1vuBgB;IACE,kBAAA;IACA,YAAA;IACA,UAAA;EjH4vuBlB;EiHtvuBQ;IACE,UAAA;EjHwvuBV;AACF;AiHlvuBA;EAMY;IACE,cAAA;EjH+uuBZ;EiH1uuBQ;IACE,WAAA;EjH4uuBV;EiH1uuBQ;IACE,cAAA;EjH4uuBV;EiH1uuBY;IACE,kBAAA;IACA,YAAA;IACA,gBAAA;EjH4uuBd;EiHnuuBE;;IAEE,aAAA;EjHquuBJ;EiHjuuBE;IACE,gBAAA;EjHmuuBJ;AACF;AiHhuuBA;;4BAAA;ACthBA;;4BAAA;AAIE;EACE,4BAAA;EACA,gBAAA;EACA,gBAAA;AlH0vvBJ;AkHzvvBI;EACE,gBAAA;AlH2vvBN;AkHxvvBE;EACE,iBAAA;AlH0vvBJ;AkHxvvBE;EACE,0BAAA;AlH0vvBJ;AkHxvvBE;EACE,UAAA;EACA,cAAA;AlH0vvBJ;AkHxvvBM;EACE,wCAAA;EACA,6BAAA;EACA,iBAAA;AlH0vvBR;;AkHrvvBA;EACE,gBAAA;AlHwvvBF;AkHvvvBE;EACE,YAAA;EACA,mBAAA;AlHyvvBJ;;AkHtvvBA;;4BAAA;ACrCA;;4BAAA;AAUA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AnH0xvBF;;AmHvxvBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;AnH0xvBF;;AmHvxvBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;AnH0xvBF;;AmHtxvBE;EACE,sBAAA;AnHyxvBJ;AmHtxvBE;EACE,gBAAA;EACA,kBAAA;AnHwxvBJ;;AmHpxvBA;EACE,WAAA;EACA,aAAA;AnHuxvBF;;AmHpxvBA;EACE,kBAAA;EACA,aAAA;EACA,UAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,sBvCnBM;A5E0yvBR;AmHrxvBE;EACE,iCAAA;AnHuxvBJ;AmHpxvBE;EACE,cAAA;AnHsxvBJ;AmHnxvBE;EACE,YAAA;AnHqxvBJ;;AmHjxvBA;EAEE,sBAAA;EACA,WAAA;EACA,aAAA;AnHmxvBF;AmHjxvBE;EACE,qBAAA;AnHmxvBJ;;AmH9wvBE;EACE,aAAA;AnHixvBJ;;AmH7wvBA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AnHgxvBF;AmH9wvBE;EACE,mBAAA;AnHgxvBJ;;AmH5wvBA;EACE,kBAAA;EACA,UAAA;AnH+wvBF;AmH7wvBE;EACE,mBAAA;EACA,YAAA;EACA,cvCxFQ;EuCyFR,gBvCvEI;EuCwEJ,yBAAA;EACA,uBvC7CS;EuC8CT,eAAA;EACA,kBAAA;AnH+wvBJ;AmH7wvBI;EACE,iBAAA;EACA,gBAAA;AnH+wvBN;AmH5wvBI;EACE,mBAAA;EACA,eAAA;AnH8wvBN;;AmHzwvBA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,kBAAA;EACA,iCAAA;EACA,kGAAA;EACA,WvChGM;EuCiGN,4BAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,wCAAA;EACA,uBAAA;EACA,cAAA;EACA,kBAAA;AnH4wvBF;AmH1wvBE;EACE,WvC3GI;EuC4GJ,4BAAA;EACA,gBAAA;AnH4wvBJ;;AmHxwvBA;EACE,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,6BAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,4BAAA;AnH2wvBF;AmHzwvBE;EACE,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cvCtIU;EuCuIV,yBAAA;EACA,sBvCtII;EuCuIJ,UAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AnH2wvBJ;AmHxwvBE;EACE,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cvCzJU;EuC0JV,UAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AnH0wvBJ;;AmHrwvBE;EACE,+IAAA;AnHwwvBJ;;AmHnwvBE;EACE,YAAA;EACA,aAAA;EACA,eAAA;AnHswvBJ;AmH3vvBE;EACE,WAAA;EACA,YAAA;EACA,eAAA;AnH6vvBJ;AmHlvvBE;EACE,WAAA;EACA,YAAA;EACA,cAAA;AnHovvBJ;AmHvuvBE;EACE,sBAAA;AnHyuvBJ;AmHvuvBI;EACE,WAAA;AnHyuvBN;;AmHnuvBA;EACE,iBAAA;AnHsuvBF;AmHpuvBE;EACE,kBAAA;EACA,YAAA;EACA,iBAAA;AnHsuvBJ;AmHpuvBI;EACE,kBAAA;EACA,WAAA;EACA,UAAA;AnHsuvBN;AmHnuvBI;EACE,kBAAA;EACA,SAAA;EACA,QAAA;AnHquvBN;AmHluvBI;EACE,kBAAA;EACA,UAAA;EACA,SAAA;AnHouvBN;;AmH7tvBE;EACE,WAAA;EACA,aAAA;AnHguvBJ;AmH3tvBM;EACE,8BAAA;AnH6tvBR;AmH1tvBM;EACE,4BAAA;AnH4tvBR;;AmHntvBM;EACE,0BAAA;AnHstvBR;AmHntvBM;EACE,4BAAA;AnHqtvBR;;AmH5svBM;EACE,0BAAA;AnH+svBR;AmH5svBM;EACE,4BAAA;AnH8svBR;;AmHlsvBM;;;;;;EACE,0BAAA;AnH0svBR;AmHvsvBM;;;;;;EACE,avC1UU;A5EwhwBlB;;AmHrsvBM;EACE,4BAAA;AnHwsvBR;;AmH/rvBM;EACE,avCtWQ;A5EwiwBhB;;AmHzrvBM;EACE,avC/WK;A5E2iwBb;;AmHnrvBM;EACE,avCxXQ;A5E8iwBhB;;AmH7qvBM;EACE,avCjYO;A5EijwBf;;AmHxqvBI;EACE,kBAAA;AnH2qvBN;;AmHrqvBA;EACE,kBAAA;AnHwqvBF;AmHtqvBE;EACE,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,2BAAA;AnHwqvBJ;;AmHnqvBE;EACE,wBAAA;AnHsqvBJ;;AmHjqvBA;EACE,cAAA;AnHoqvBF;;AmHlqvBA;EACE,qBAAA;AnHqqvBF;;AmHlqvBA;EACE,YAAA;AnHqqvBF;;AmHlqvBA;EACE,aAAA;AnHqqvBF;;AmHhqvBE;;;EAGE,0BAAA;AnHmqvBJ;AmHhqvBE;;;;EAIE,4BAAA;AnHkqvBJ;;AmH7pvBE;;;;EAIE,8BAAA;AnHgqvBJ;AmH7pvBE;;;EAGE,4BAAA;AnH+pvBJ;;AmH1pvBA;EACE,WAAA;EACA,aAAA;EACA,SAAA;AnH6pvBF;;AmH1pvBA;EACE,aAAA;AnH6pvBF;;AmH1pvBA;EACE,WAAA;EACA,aAAA;EACA,SAAA;AnH6pvBF;;AmHxpvBI;EACE,iBAAA;AnH2pvBN;;AmHrpvBE;EACE,oBAAA;AnHwpvBJ;;AmHnpvBE;EACE,WAAA;EACA,aAAA;AnHspvBJ;;AmHlpvBA;EACE,aAAA;AnHqpvBF;;AmHlpvBA;EACE,aAAA;AnHqpvBF;;AmHjpvBE;;;EAGE,UAAA;AnHopvBJ;;AmH7ovBM;EADF;IAEI,sBAAA;EnHipvBN;EmHhpvBM;IACE,uBAAA;EnHkpvBR;AACF;;AmH7ovBA;;4BAAA;ACpiBA;;4BAAA;AAIE;EACE,aAAA;ApHsrwBJ;AoHprwBE;EACE,gBAAA;ApHsrwBJ;AoHnrwBI;EACE,kBAAA;ApHqrwBN;AoHprwBM;EACE,yBxCgDc;EwC/Cd,yBAAA;ApHsrwBR;AoHrrwBQ;EACE,cxCWE;A5E4qwBZ;AoHprwBM;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EACA,cxCTK;A5E+rwBb;AoHnrwBI;EACE,UAAA;ApHqrwBN;AoHprwBM;EACE,oBAAA;ApHsrwBR;AoHrrwBQ;EACE,wCAAA;ApHurwBV;AoHrrwBQ;EACE,iBAAA;ApHurwBV;AoHlrwBE;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;ApHorwBJ;AoHlrwBE;EACE,WAAA;EACA,eAAA;EACA,kBAAA;ApHorwBJ;AoHnrwBI;EACE,cxC9BO;EwC+BP,mBAAA;EACA,gBAAA;ApHqrwBN;AoHlrwBE;EACE,cxC9BQ;EwC+BR,mBAAA;EACA,eAAA;EACA,eAAA;ApHorwBJ;AoHnrwBI;EACE,gBAAA;EACA,cxC9DkB;A5EmvwBxB;AoHnrwBI;EACE,eAAA;ApHqrwBN;AoHhrwBM;EACE,aAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;ApHkrwBR;AoHjrwBQ;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,mCAAA;ApHmrwBV;AoHhrwBU;EACE,kBAAA;ApHkrwBZ;AoHjrwBY;EACE,cxCrFe;EwCsFf,eAAA;EACA,eAAA;ApHmrwBd;AoH9qwBQ;EACE,iBAAA;ApHgrwBV;AoH/qwBU;EACE,cAAA;EACA,aAAA;ApHirwBZ;AoH/qwBU;EACE,kBAAA;EACA,kBAAA;ApHirwBZ;AoH7qwBM;EACE,aAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;ApH+qwBR;AoH9qwBQ;EACE,iBAAA;ApHgrwBV;AoH9qwBQ;EACE,mBAAA;ApHgrwBV;AoH9qwBQ;EACE,mBAAA;EACA,eAAA;EACA,cxC7FE;A5E6wwBZ;AoH9qwBQ;EACE,cxCtGG;EwCuGH,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;ApHgrwBV;AoH9qwBQ;EACE,yBAAA;EACA,mBAAA;EACA,yBAAA;ApHgrwBV;AoH9qwBQ;EACE,yBxChHF;EwCiHE,mBAAA;EACA,0BAAA;ApHgrwBV;AoH7qwBM;EACE,aAAA;EACA,6BAAA;EACA,kBAAA;EACA,wBAAA;EACA,sBxC9GA;EwC+GA,SAAA;ApH+qwBR;AoH9qwBQ;EACE,mBxCtIQ;EwCuIR,aAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;ApHgrwBV;AoH9qwBQ;EACE,kBAAA;ApHgrwBV;AoH/qwBU;EACE,YAAA;EACA,sCAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;ApHirwBZ;AoH/qwBU;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EACA,cxC5JC;EwC6JD,eAAA;ApHirwBZ;AoH/qwBU;EACE,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,0BAAA;ApHirwBZ;AoH3qwBE;EACE,8BAAA;ApH6qwBJ;AoH5qwBI;EACE,eAAA;ApH8qwBN;AoHxqwBY;EACE,eAAA;ApH0qwBd;AoHpqwBI;EACE,gBAAA;ApHsqwBN;AoHpqwBQ;EACE,cAAA;ApHsqwBV;AoHpqwBQ;EACE,cAAA;ApHsqwBV;AoHpqwBQ;EACE,eAAA;ApHsqwBV;AoHnqwBM;;;EAGE,gBAAA;ApHqqwBR;AoHnqwBM;EACE,kBAAA;ApHqqwBR;AoHpqwBQ;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,sBxChMF;EwCiME,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,mCAAA;ApHsqwBV;AoHpqwBQ;EACE,kBAAA;EACA,yBAAA;ApHsqwBV;AoHnqwBM;EACE,+BAAA;ApHqqwBR;AoHnqwBM;EACE,aAAA;ApHqqwBR;AoHpqwBQ;EACE,eAAA;EACA,WxCpNF;A5E03wBR;AoHpqwBQ;EACE,cxC5PS;EwC6PT,eAAA;EACA,mBAAA;ApHsqwBV;AoHnqwBM;EACE,cxCvOI;EwCwOJ,eAAA;EACA,cAAA;ApHqqwBR;AoHlqwBQ;EACE,eAAA;EACA,cxC9OE;A5Ek5wBZ;AoHhqwBI;EACE,mBAAA;ApHkqwBN;AoHhqwBI;EACE,aAAA;ApHkqwBN;AoHjqwBM;EACE,wBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ApHmqwBR;AoHjqwBM;EACE,iBAAA;EACA,kCAAA;ApHmqwBR;AoHjqwBM;EACE,sBAAA;ApHmqwBR;AoH9pwBI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;ApHgqwBN;AoH9pwBI;EACE,eAAA;EACA,cxC9RY;EwC+RZ,gBAAA;EACA,mBAAA;ApHgqwBN;AoH9pwBI;EACE,gBAAA;ApHgqwBN;AoH/pwBM;EACE,kBAAA;ApHiqwBR;AoH9pwBI;EACE,mBAAA;ApHgqwBN;AoH9pwBQ;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;ApHgqwBV;AoH/pwBU;EACE,iBAAA;ApHiqwBZ;AoH/pwBU;EACE,WAAA;EACA,eAAA;ApHiqwBZ;;AoHzpwBE;EACE,mBAAA;ApH4pwBJ;AoH1pwBE;EACE,aAAA;ApH4pwBJ;AoH1pwBE;EACE,kBAAA;ApH4pwBJ;AoHzpwBI;EACE,wCAAA;ApH2pwBN;;AoHvpwBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,kBAAA;EACA,sBAAA;ApH0pwBF;;AoHxpwBA;EACE,yBxC9Vc;A5Ey/wBhB;;AoHzpwBA;EACE,yBxCnWc;A5E+/wBhB;;AoH1pwBA;EACE,yBxCnWa;A5EggxBf;;AoH1pwBE;EACE,YAAA;ApH6pwBJ;AoH3pwBE;EACE,YAAA;ApH6pwBJ;;AoH1pwBA;EACE,gBAAA;ApH6pwBF;;AoHxpwBI;;EACE,aAAA;ApH4pwBN;;AoHtpwBI;EACE,wCAAA;ApHypwBN;;AoHrpwBA;;4BAAA;AC5YA;;4BAAA;AAIE;EACE,yBAAA;EACA,yBAAA;EACA,aAAA;ArHsixBJ;AqHrixBI;EACE,gBAAA;ArHuixBN;;AqHjixBE;EACE,oBAAA;EACA,cAAA;EACA,eAAA;EACA,gCAAA;EACA,mBAAA;ArHoixBJ;AqHlixBI;EACE,UAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;ArHoixBN;AqHjixBI;EACE,gBAAA;ArHmixBN;AqHhixBI;EACE,aAAA;EACA,8BAAA;ArHkixBN;AqH7hxBI;EACE,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;ArH+hxBN;AqH7hxBM;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;ArH+hxBR;AqH3hxBI;EACE,mBAAA;ArH6hxBN;AqH3hxBM;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;ArH6hxBR;AqHxhxBE;EACE,kBAAA;EACA,mBAAA;ArH0hxBJ;AqHxhxBI;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;ArH0hxBN;AqHthxBE;EACE,kBAAA;EACA,gCAAA;EACA,mBAAA;ArHwhxBJ;AqHthxBI;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;ArHwhxBN;AqHthxBM;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,UAAA;EACA,iBAAA;ArHwhxBR;;AqHlhxBA;EACE,kBAAA;ArHqhxBF;;AqHlhxBA;EACE,UAAA;EACA,iBAAA;ArHqhxBF;;AqHlhxBA;;4BAAA;AAIA;;4BAAA;AAGA;EAEI;IACE,aAAA;ErHmhxBJ;EqH7gxBI;IACE,UAAA;ErH+gxBN;EqHzgxBM;IACE,UAAA;ErH2gxBR;EqHtgxBM;IACE,UAAA;ErHwgxBR;EqHjgxBM;IACE,UAAA;ErHmgxBR;EqH5/wBM;IACE,UAAA;ErH8/wBR;AACF;AqHx/wBA;EAIQ;IACE,UAAA;ErHu/wBR;AACF;AqHj/wBA;EAEI;IACE,aAAA;ErHk/wBJ;EqH5+wBM;IACE,UAAA;ErH8+wBR;EqHz+wBM;IACE,UAAA;ErH2+wBR;AACF;AqHr+wBA;;4BAAA;ACvNA;;4BAAA;AAGA;EACE,oDAAA;EACA,2BAAA;EACA,sBAAA;AtHisxBF;;AsH9rxBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,eAAA;AtHisxBF;AsH9rxBI;EACE,eAAA;EACA,mBAAA;EACA,c1CjBuB;E0CkBvB,gBAAA;EACA,mBAAA;EACA,gBAAA;AtHgsxBN;AsH7rxBI;EACE,eAAA;EACA,6BAAA;EACA,gCAAA;AtH+rxBN;AsH7rxBM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,W1CGA;E0CFA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,gCAAA;AtH+rxBR;AsH5rxBM;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,c1C7CqB;E0C8CrB,yBAAA;EACA,mBAAA;AtH8rxBR;AsH3rxBM;EACE,qBAAA;EACA,yBAAA;EACA,cAAA;AtH6rxBR;AsH3rxBQ;EACE,cAAA;AtH6rxBV;AsHvrxBE;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,4CAAA;EACA,sBAAA;AtHyrxBJ;;AsHrrxBA;;4BAAA;AC/EA;;4BAAA;AAGA;EACE,sB3CmCM;E2ClCN,sCAAA;EACA,UAAA;EACA,aAAA;AvH0wxBF;;AuHvwxBA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,UAAA;AvH0wxBF;;AuHvwxBA;EACE,SAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;EACA,sB3CaM;E2CZN,gBAAA;EACA,6CAAA;AvH0wxBF;AuHzwxBE;EACE,YAAA;EACA,YAAA;AvH2wxBJ;AuHtwxBM;EACE,c3CnCgB;A5E2yxBxB;AuHnwxBE;EACE,QAAA;EACA,gBAAA;AvHqwxBJ;AuHpwxBI;EACE,YAAA;EACA,OAAA;AvHswxBN;;AuHhwxBE;EACE,eAAA;AvHmwxBJ;AuHhwxBE;EACE,kBAAA;EACA,6BAAA;AvHkwxBJ;AuHhwxBI;EACE,YAAA;EACA,mBAAA;EACA,W3CzBE;E2C0BF,mBAAA;AvHkwxBN;AuH/vxBI;EACE,kBAAA;AvHiwxBN;;AuH5vxBA;EACE,aAAA;AvH+vxBF;;AuH5vxBA;EACE,+BAAA;AvH+vxBF;;AuH5vxBA;EACE,aAAA;EACA,+BAAA;AvH+vxBF;AuH7vxBE;EACE,cAAA;AvH+vxBJ;AuH5vxBE;EACE,gBAAA;AvH8vxBJ;AuH1vxBI;EACE,uBAAA;EACA,gCAAA;AvH4vxBN;;AuHtvxBE;EACE,mBAAA;AvHyvxBJ;AuHrvxBQ;EACE,sBAAA;EACA,kBAAA;AvHuvxBV;;AuH9uxBI;EACE,iBAAA;EACA,kBAAA;EACA,6BAAA;EACA,UAAA;EACA,2BAAA;EACA,gBAAA;AvHivxBN;;AuH3uxBE;EACE,+BAAA;AvH8uxBJ;AuH3uxBE;EACE,eAAA;AvH6uxBJ;AuH1uxBM;EACE,aAAA;AvH4uxBR;AuHxuxBQ;EACE,kBAAA;AvH0uxBV;AuHvuxBQ;EACE,eAAA;AvHyuxBV;AuHvuxBU;EACE,qBAAA;AvHyuxBZ;AuHvuxBY;EACE,eAAA;AvHyuxBd;AuHtuxBY;EACE,kBAAA;EACA,gBAAA;EACA,8BAAA;AvHwuxBd;AuHjuxBI;EACE,iBAAA;AvHmuxBN;AuHjuxBM;EACE,mBAAA;AvHmuxBR;AuHjuxBQ;EACE,c3C1JE;E2C2JF,oBAAA;EACA,mBAAA;AvHmuxBV;AuHjuxBU;EACE,iBAAA;EACA,gBAAA;AvHmuxBZ;AuHhuxBU;EACE,YAAA;AvHkuxBZ;AuH5txBQ;EACE,iBAAA;AvH8txBV;AuH1txBM;EACE,gBAAA;AvH4txBR;;AuHrtxBE;EACE,+BAAA;EACA,YAAA;AvHwtxBJ;AuHptxBM;;;;EAEE,2CAAA;EACA,c3CnNgB;A5E26xBxB;AuHptxBI;EACE,c3CxNkB;E2CyNlB,UAAA;AvHstxBN;AuHntxBQ;EACE,YAAA;AvHqtxBV;AuHjtxBM;EACE,6BAAA;AvHmtxBR;AuH/sxBI;EACE,aAAA;AvHitxBN;AuH5sxBI;EACE,+BAAA;AvH8sxBN;;AuHxsxBA;EACE;IACE,SAAA;EvH2sxBF;EuHxsxBA;IACE,SAAA;EvH0sxBF;EuHtsxBE;IACE,aAAA;EvHwsxBJ;EuHrsxBM;IACE,gBAAA;EvHusxBR;EuHhsxBE;IACE,gBAAA;EvHksxBJ;AACF;AuH9rxBA;EACE;IACE,aAAA;EvHgsxBF;EuH9rxBE;IACE,6BAAA;EvHgsxBJ;EuH3rxBE;IACE,kBAAA;IACA,gCAAA;EvH6rxBJ;AACF;AuHzrxBA;EACE;IACE,YAAA;EvH2rxBF;EuHxrxBA;IACE,SAAA;IACA,UAAA;EvH0rxBF;EuHprxBM;IACE,kBAAA;EvHsrxBR;EuHhrxBI;IACE,aAAA;EvHkrxBN;EuH5qxBE;IACE,aAAA;EvH8qxBJ;EuH3qxBM;IACE,gBAAA;EvH6qxBR;EuHrqxBQ;IACE,gBAAA;EvHuqxBV;EuHhqxBA;IACE,aAAA;EvHkqxBF;EuHhqxBE;IACE,gBAAA;EvHkqxBJ;EuH/pxBE;IACE,6BAAA;EvHiqxBJ;EuHtpxBY;;IACE,gBAAA;EvHypxBd;EuHtpxBY;;IACE,gBAAA;EvHypxBd;AACF;AuHhpxBA;EACE;IACE,iBAAA;IACA,WAAA;EvHkpxBF;EuH3oxBQ;IACE,iBAAA;EvH6oxBV;EuHxoxBI;IACE,cAAA;EvH0oxBN;EuHxoxBM;IACE,YAAA;IACA,sBAAA;IACA,mBAAA;EvH0oxBR;AACF;AuHpoxBA;;4BAAA;ACjZA;;4BAAA;AAGA;EACE,kBAAA;EACA,YAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;AxH0hyBF;;AwHxhyBA;EACE,0DAAA;EACA,sBAAA;EACA,4BAAA;EACA,0BAAA;AxH2hyBF;AwH1hyBE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AxH4hyBJ;AwH3hyBI;EACE,mBAAA;AxH6hyBN;AwH3hyBI;EACE,aAAA;AxH6hyBN;AwH3hyBI;EACE,YAAA;EACA,UAAA;AxH6hyBN;AwH3hyBI;EAdF;IAeI,QAAA;ExH8hyBJ;EwH7hyBI;IACE,aAAA;ExH+hyBN;EwH7hyBI;IACE,YAAA;IACA,OAAA;ExH+hyBN;AACF;AwH5hyBE;EACE,iBAAA;AxH8hyBJ;AwH5hyBE;EACE,kBAAA;AxH8hyBJ;AwH5hyBE;EACE,gBAAA;AxH8hyBJ;;AwH3hyBA;EACE,gBAAA;AxH8hyBF;AwH7hyBE;EACE,mBAAA;AxH+hyBJ;AwH7hyBE;EACE,gBAAA;EACA,eAAA;AxH+hyBJ;AwH7hyBE;EACE,kBAAA;AxH+hyBJ;AwH7hyBE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,YAAA;EACA,QAAA;EACA,kBAAA;EACA,2BAAA;AxH+hyBJ;AwH9hyBI;EACE,YAAA;EACA,WAAA;EACA,sCAAA;AxHgiyBN;AwH9hyBI;EAhBF;IAiBI,WAAA;IACA,YAAA;ExHiiyBJ;AACF;AwHhiyBI;EACE,WAAA;EACA,YAAA;AxHkiyBN;AwHjiyBM;EAHF;IAII,WAAA;IACA,YAAA;ExHoiyBN;AACF;AwHjiyBE;EACE,2BAAA;EACA,gBAAA;AxHmiyBJ;AwHjiyBM;EACE,kCAAA;AxHmiyBR;;AwH5hyBI;EADF;IAEI,aAAA;ExHgiyBJ;AACF;AwH/hyBI;EAJF;IAKI,aAAA;ExHkiyBJ;AACF;;AwH/hyBA;EACE,2BAAA;AxHkiyBF;;AwHhiyBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AxHmiyBF;AwHliyBE;EAJF;IAKI,mBAAA;IACA,eAAA;ExHqiyBF;AACF;AwHpiyBE;EACE,SAAA;AxHsiyBJ;AwHriyBI;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AxHuiyBN;AwHtiyBM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AxHwiyBR;AwHpiyBM;EACE,gBAAA;EACA,6BAAA;AxHsiyBR;AwHjiyBQ;EACE,gBAAA;EACA,qBAAA;AxHmiyBV;AwH/hyBQ;EACE,gBAAA;EACA,2BAAA;AxHiiyBV;;AwH3hyBA;EACE,iBAAA;AxH8hyBF;AwH7hyBE;EAFF;IAGI,oBAAA;ExHgiyBF;AACF;AwH/hyBE;EALF;IAMI,qBAAA;ExHkiyBF;AACF;AwHjiyBE;EARF;IASI,qBAAA;ExHoiyBF;AACF;AwHniyBE;EAXF;IAYI,qBAAA;ExHsiyBF;AACF;AwHriyBE;EAdF;IAeI,qBAAA;ExHwiyBF;AACF;AwHtiyBI;EACE,iBAAA;AxHwiyBN;AwHriyBM;EACE,eAAA;EACA,gBAAA;EACA,yCAAA;EACA,6BAAA;AxHuiyBR;;AwHliyBA;EACE,kBAAA;EACA,UAAA;AxHqiyBF;;AwHniyBA;EACE,kBAAA;EACA,wBAAA;EACA,YAAA;EACA,yBAAA;EACA,UAAA;AxHsiyBF;AwHriyBE;EANF;IAOI,YAAA;ExHwiyBF;AACF;AwHviyBE;EATF;IAUI,wBAAA;IACA,UAAA;ExH0iyBF;AACF;AwHziyBE;EAbF;IAcI,YAAA;ExH4iyBF;AACF;;AwHziyBE;EACE,WAAA;AxH4iyBJ;AwH3iyBI;EACE,YAAA;EACA,UAAA;AxH6iyBN;AwH3iyBI;EANF;IAOI,WAAA;ExH8iyBJ;EwH7iyBI;IACE,UAAA;ExH+iyBN;AACF;;AwHziyBI;EACE,eAAA;AxH4iyBN;;AwHxiyBA;EACE,iBAAA;AxH2iyBF;AwH1iyBE;EACE,YAAA;EACA,cAAA;EACA,iBAAA;AxH4iyBJ;AwH3iyBI;EAJF;IAKI,kBAAA;ExH8iyBJ;AACF;AwH7iyBI;EAPF;IAQI,iBAAA;ExHgjyBJ;AACF;AwH/iyBI;EAVF;IAWI,kBAAA;ExHkjyBJ;AACF;AwHjjyBI;EAbF;IAcI,YAAA;ExHojyBJ;AACF;;AwH/iyBI;EACE,WAAA;EACA,YAAA;EACA,0BAAA;AxHkjyBN;;AwH9iyBA;EACE,2BAAA;AxHijyBF;AwH9iyBM;EACE,wCAAA;AxHgjyBR;AwH5iyBM;EACE,aAAA;AxH8iyBR;;AwHxiyBE;EACE,QAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;AxH2iyBJ;AwHziyBE;EACE,6BAAA;EACA,UAAA;EACA,gBAAA;AxH2iyBJ;AwH1iyBI;EACE,sCAAA;AxH4iyBN;AwH1iyBI;EACE,2BAAA;EACA,gBAAA;AxH4iyBN;AwHziyBE;EACE,gBAAA;AxH2iyBJ;;AwHtiyBI;EACE,yBAAA;AxHyiyBN;AwHxiyBM;EACE,gBAAA;EACA,mBAAA;EACA,mBAAA;AxH0iyBR;AwHtiyBM;;EAEE,iBAAA;EACA,sBAAA;AxHwiyBR;AwHviyBQ;;EACE,gBAAA;AxH0iyBV;AwHviyBU;EADF;;IAEI,eAAA;ExH2iyBV;AACF;AwHziyBQ;;EACE,eAAA;AxH4iyBV;AwHxiyBQ;EACE,eAAA;AxH0iyBV;AwHziyBU;EACE,mBAAA;EACA,gBAAA;AxH2iyBZ;AwHxiyBQ;EACE,gBAAA;AxH0iyBV;AwHziyBU;EACE,eAAA;EACA,oBAAA;AxH2iyBZ;AwHtiyBQ;EACE,iBAAA;EACA,mBAAA;AxHwiyBV;AwHniyBU;EACE,6BAAA;EACA,gBAAA;AxHqiyBZ;AwH9hyBY;EACE,2BAAA;EACA,gBAAA;AxHgiyBd;AwHzhyBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AxH2hyBJ;AwH1hyBI;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AxH4hyBN;AwHzhyBE;EACE,WAAA;EACA,YAAA;AxH2hyBJ;AwHzhyBE;EACE,aAAA;EACA,mBAAA;AxH2hyBJ;AwHzhyBM;EACE,a5C9XQ;A5Ey5yBhB;AwHvhyBM;EACE,a5ChYO;A5Ey5yBf;;AwHnhyBE;EACE,oBAAA;EACA,gBAAA;AxHshyBJ;AwHphyBE;EACE,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,oBAAA;AxHshyBJ;AwHlhyBM;EACE,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,oBAAA;AxHohyBR;;AwH3gyBQ;EACE,aAAA;AxH8gyBV;AwH3gyBM;EACE,mBAAA;AxH6gyBR;;AwHxgyBA;EACE,gBAAA;AxH2gyBF;AwH1gyBE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;AxH4gyBJ;AwH1gyBE;EACE,8CAAA;EACA,YAAA;EACA,kBAAA;AxH4gyBJ;AwH3gyBI;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AxH6gyBN;;AwHzgyBA;EACE,gCAAA;EACA,mBAAA;EACA,eAAA;EACA,4CAAA;AxH4gyBF;AwH3gyBE;EALF;IAMI,eAAA;ExH8gyBF;AACF;AwH7gyBE;EACE,eAAA;EACA,YAAA;EACA,iFAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AxH+gyBJ;AwH9gyBI;EAVF;IAWI,eAAA;IACA,YAAA;IACA,WAAA;ExHihyBJ;AACF;AwH/gyBE;EACE,cAAA;AxHihyBJ;AwHhhyBI;EAFF;IAGI,YAAA;ExHmhyBJ;AACF;;AwH9gyBE;EACE,eAAA;AxHihyBJ;;AwH3gyBM;;EAEE,gBAAA;AxH8gyBR;;AwHvgyBE;EACE,cAAA;EACA,UAAA;EACA,WAAA;EACA,yBAL6C;EAM7C,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,UAAA;AxH0gyBJ;;AwHlhyBE;EACE,cAAA;EACA,UAAA;EACA,WAAA;EACA,yBAL6C;EAM7C,mBAAA;EACA,2CAAA;EACA,kBAAA;EACA,UAAA;AxHqhyBJ;;AwH7hyBE;EACE,cAAA;EACA,UAAA;EACA,WAAA;EACA,yBAL6C;EAM7C,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,UAAA;AxHgiyBJ;;AwHxiyBE;EACE,cAAA;EACA,UAAA;EACA,WAAA;EACA,yBAL6C;EAM7C,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,UAAA;AxH2iyBJ;;AwHnjyBE;EACE,cAAA;EACA,UAAA;EACA,WAAA;EACA,yBAL6C;EAM7C,mBAAA;EACA,2CAAA;EACA,kBAAA;EACA,UAAA;AxHsjyBJ;;AwH9jyBE;EACE,cAAA;EACA,UAAA;EACA,WAAA;EACA,yBAL6C;EAM7C,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,UAAA;AxHikyBJ;;AwHzkyBE;EACE,cAAA;EACA,UAAA;EACA,WAAA;EACA,yBAL6C;EAM7C,mBAAA;EACA,yCAAA;EACA,kBAAA;EACA,UAAA;AxH4kyBJ;;AwHplyBE;EACE,cAAA;EACA,UAAA;EACA,WAAA;EACA,yBAL6C;EAM7C,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,UAAA;AxHulyBJ;;AwHllyBA;EACE;IACE,wBAAA;ExHqlyBF;EwHnlyBA;IACE,WAAA;ExHqlyBF;AACF;AwHnlyBA;EACE;IACE,WAAA;ExHqlyBF;EwHnlyBA;IACE,UAAA;ExHqlyBF;EwHnlyBA;IACE,UAAA;ExHqlyBF;EwHnlyBA;IACE,UAAA;ExHqlyBF;EwHnlyBA;IACE,UAAA;ExHqlyBF;EwHnlyBA;IACE,UAAA;ExHqlyBF;EwHnlyBA;IACE,mBAAA;ExHqlyBF;EwHnlyBA;IACE,aAAA;ExHqlyBF;EwHnlyBA;IACE,wBAAA;ExHqlyBF;AACF;AwHnlyBA;EACE;IACE,cAAA;IACA,aAAA;ExHqlyBF;EwHnlyBA;IACE,cAAA;IACA,aAAA;ExHqlyBF;AACF;AwHllyBA;EAEI;IACE,WAAA;ExHmlyBJ;AACF;AwH/kyBA;;4BAAA;ACpkBA;;4BAAA;AAGA;EACE;IACE,uBAAA;EzHwpzBF;EyHtpzBA;IACE,wBAAA;EzHwpzBF;EyHtpzBA;IACE,uBAAA;EzHwpzBF;EyHtpzBA;IACE,yBAAA;EzHwpzBF;EyHtpzBA;IACE,uBAAA;EzHwpzBF;AACF;AyHtpzBA;EACE,0DAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,W7CcM;A5E0ozBR;AyHtpzBI;EACE,gBAAA;EACA,wCAAA;AzHwpzBN;AyHrpzBE;EACE,UAAA;AzHupzBJ;AyHtpzBI;EAFF;IAGI,UAAA;EzHypzBJ;AACF;AyHxpzBI;EALF;IAMI,UAAA;EzH2pzBJ;AACF;AyH1pzBI;EARF;IASI,WAAA;EzH6pzBJ;AACF;AyH3pzBE;EACE,aAAA;EACA,kBAAA;EACA,QAAA;EACA,aAAA;AzH6pzBJ;AyH5pzBI;EACE,YAAA;EACA,OAAA;AzH8pzBN;AyH5pzBI;EATF;IAUI,aAAA;IACA,aAAA;EzH+pzBJ;AACF;AyH9pzBI;EAbF;IAcI,aAAA;EzHiqzBJ;AACF;AyHhqzBI;EAhBF;IAiBI,aAAA;IACA,aAAA;EzHmqzBJ;AACF;AyHlqzBI;EApBF;IAqBI,aAAA;EzHqqzBJ;AACF;;AyHlqzBA;EACE,gBAAA;AzHqqzBF;AyHpqzBE;EACE,kBAAA;AzHsqzBJ;AyHrqzBI;EAFF;IAGI,kBAAA;EzHwqzBJ;AACF;AyHvqzBI;EALF;IAMI,kBAAA;EzH0qzBJ;AACF;AyHtqzBM;EADF;IAEI,kBAAA;EzHyqzBN;AACF;AyHtqzBE;EACE,2BAAA;EACA,gBAAA;AzHwqzBJ;AyHtqzBM;EACE,kCAAA;AzHwqzBR;;AyHnqzBA;EACE,aAAA;EACA,QAAA;AzHsqzBF;AyHrqzBE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,+xBAAA;EA4CA,oEAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AzH4nzBJ;AyH3nzBI;EACE,WAAA;EACA,YAAA;EACA,U7CpHE;A5EivzBR;AyH3nzBI;EACE,sEAAA;AzH6nzBN;AyH1nzBE;EACE,8CAAA;EACA,YAAA;AzH4nzBJ;AyH1nzBE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AzH4nzBJ;AyH3nzBI;EACE,cAAA;EACA,mBAAA;AzH6nzBN;AyH3nzBI;EACE,WAAA;EACA,YAAA;AzH6nzBN;;AyHxnzBE;EACE,kBAAA;EACA,mBAAA;AzH2nzBJ;;AyHxnzBA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,qBAAA;AzH2nzBF;AyH1nzBE;EACE,YAAA;EACA,OAAA;AzH4nzBJ;AyH1nzBE;EACE,WAAA;EACA,YAAA;AzH4nzBJ;AyH1nzBE;EACE,WAAA;EACA,YAAA;EACA,oBAAA;AzH4nzBJ;AyH1nzBE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AzH4nzBJ;AyH3nzBI;EACE,kBAAA;EACA,kBAAA;AzH6nzBN;AyH1nzBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;AzH4nzBJ;AyH3nzBI;EACE,YAAA;EACA,WAAA;AzH6nzBN;AyH1nzBE;EACE,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AzH4nzBJ;AyH3nzBI;EACE,YAAA;EACA,UAAA;AzH6nzBN;AyH1nzBE;;EAEE,kBAAA;EACA,UAAA;EACA,WAAA;AzH4nzBJ;AyH1nzBE;EACE,YAAA;EACA,WAAA;AzH4nzBJ;AyH3nzBI;EACE,YAAA;EACA,WAAA;AzH6nzBN;AyH1nzBE;EACE,UAAA;EACA,YAAA;AzH4nzBJ;AyH3nzBI;EACE,YAAA;EACA,SAAA;AzH6nzBN;AyH1nzBE;EACE,8BAAA;AzH4nzBJ;AyH1nzBE;EACE,8BAAA;AzH4nzBJ;AyH1nzBE;EACE,8BAAA;AzH4nzBJ;AyH1nzBE;EACE,8BAAA;AzH4nzBJ;AyH1nzBE;EACE,8BAAA;AzH4nzBJ;AyH1nzBE;EACE,8BAAA;AzH4nzBJ;;AyHznzBA;EACE,qBAAA;AzH4nzBF;AyH3nzBE;EACE,cAAA;AzH6nzBJ;AyH3nzBE;EALF;IAMI,iBAAA;EzH8nzBF;AACF;AyH7nzBE;EACE,cAAA;AzH+nzBJ;AyH7nzBM;EACE,6BAAA;AzH+nzBR;;AyHznzBE;EACE,gBAAA;EACA,iBAAA;AzH4nzBJ;AyH1nzBM;EACE,0BAAA;EACA,gBAAA;AzH4nzBR;AyHznzBI;EACE,WAAA;EACA,YAAA;EACA,U7C3QE;E6C4QF,sBAAA;EACA,gBAAA;AzH2nzBN;;AyHrnzBI;EACE,WAAA;EACA,gB7CrRE;E6CsRF,gBAAA;EACA,UAAA;AzHwnzBN;AyHtnzBM;EACE,UAAA;AzHwnzBR;AyHtnzBU;EACE,gBAAA;EACA,eAAA;AzHwnzBZ;AyHtnzBY;EACE,c7CrPS;E6CsPT,eAAA;AzHwnzBd;AyHnnzBY;EACE,YAAA;EACA,UAAA;EACA,c7C9PS;A5Em3zBvB;AyHnnzBc;EACE,c7CjQO;E6CkQP,YAAA;AzHqnzBhB;AyHlnzBgB;EACE,c7C5UH;A5Eg8zBf;AyH/mzBY;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;AzHinzBd;AyH/mzBc;EACE,gCAAA;EACA,W7ChUR;E6CiUQ,kBAAA;EACA,mDAAA;AzHinzBhB;AyH9mzBc;EACE,yB7CnWA;E6CoWA,YAAA;EACA,W7CxUR;A5Ew7zBR;AyH/mzBgB;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,mB7CzWH;E6C0WG,WAAA;EACA,SAAA;EACA,mBAAA;AzHinzBlB;AyH7mzBc;EACE,W7CvVR;E6CwVQ,gBAAA;AzH+mzBhB;AyHtmzBc;EACE,sCAAA;AzHwmzBhB;AyHjmzBM;EACE,mBAAA;EACA,UAAA;EACA,0BAAA;EACA,aAAA;AzHmmzBR;AyHjmzBQ;EACE,6BAAA;EACA,WAAA;EACA,YAAA;AzHmmzBV;AyHlmzBU;EACE,kBAAA;EACA,WAAA;AzHomzBZ;AyHnmzBY;EACE,YAAA;EACA,UAAA;AzHqmzBd;AyHlmzBU;EACE,WAAA;EACA,YAAA;AzHomzBZ;AyHlmzBU;EACE,+BAAA;AzHomzBZ;AyH/lzBM;EACE,c7C1Ve;E6C2Vf,eAAA;EACA,gBAAA;AzHimzBR;AyHhmzBQ;EAJF;IAKI,eAAA;EzHmmzBR;AACF;AyHjmzBQ;EACE,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,c7CrWa;A5Ew8zBvB;AyHlmzBU;EALF;IAMI,eAAA;EzHqmzBV;AACF;;AyH/lzBA;EACE,+BAAA;AzHkmzBF;;AyHhmzBA;EACE,2BAAA;AzHmmzBF;AyHlmzBE;EACE,2BAAA;AzHomzBJ;;AyHjmzBA;EACE,oBAAA;EACA,kBAAA;AzHomzBF;;AyHhmzBI;EACE,YAAA;AzHmmzBN;;AyH/lzBA;EACE,kBAAA;AzHkmzBF;AyHjmzBE;EACE,kBAAA;EACA,YAAA;AzHmmzBJ;AyHlmzBI;EAHF;IAII,UAAA;EzHqmzBJ;AACF;AyHpmzBI;EACE,YAAA;EACA,YAAA;EACA,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,qDAAA;AzHsmzBN;AyHrmzBM;EAVF;IAWI,YAAA;EzHwmzBN;AACF;AyHvmzBM;EAbF;IAcI,gBAAA;EzH0mzBN;AACF;AyHzmzBM;EAhBF;IAiBI,WAAA;IACA,YAAA;EzH4mzBN;AACF;AyH3mzBM;EACE,WAAA;AzH6mzBR;AyH5mzBQ;EAFF;IAGI,WAAA;EzH+mzBR;AACF;AyH5mzBI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,wBAAA;EACA,YAAA;AzH8mzBN;AyH7mzBM;EACE,WAAA;EACA,QAAA;EACA,qBAAA;AzH+mzBR;AyH7mzBM;EAXF;IAYI,aAAA;EzHgnzBN;AACF;AyH7mzBE;EACE,gBAAA;EACA,gBAAA;AzH+mzBJ;AyH9mzBI;EAHF;IAII,gBAAA;EzHinzBJ;AACF;;AyH9mzBA;EACE,aAAA;EACA,SAAA;EACA,uBAAA;AzHinzBF;AyHhnzBE;EAJF;IAKI,eAAA;EzHmnzBF;AACF;AyHlnzBE;EAPF;IAQI,SAAA;IACA,iBAAA;EzHqnzBF;AACF;AyHpnzBE;EAXF;IAYI,SAAA;IACA,eAAA;EzHunzBF;AACF;AyHpnzBM;EACE,WAAA;AzHsnzBR;;AyHjnzBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AzHonzBF;AyHnnzBE;EAJF;IAKI,mBAAA;EzHsnzBF;AACF;AyHrnzBE;EAPF;IAQI,sBAAA;EzHwnzBF;AACF;AyHvnzBE;EACE,aAAA;EACA,mBAAA;AzHynzBJ;AyHxnzBI;EACE,eAAA;AzH0nzBN;AyHxnzBI;EACE,eAAA;EACA,wBAAA;EACA,0CAAA;EACA,gBAAA;EACA,sBAAA;AzH0nzBN;AyHznzBM;EANF;IAOI,gBAAA;EzH4nzBN;AACF;AyH3nzBM;EATF;IAUI,aAAA;IACA,eAAA;EzH8nzBN;AACF;AyH7nzBM;EACE,QAAA;AzH+nzBR;AyH5nzBI;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AzH8nzBN;AyH5nzBI;EACE,WAAA;EACA,YAAA;AzH8nzBN;AyH7nzBM;EACE,a7CxkBQ;A5Eus0BhB;AyH3nzBE;EACE,6BAAA;EACA,8DAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;AzH6nzBJ;AyH5nzBI;EANF;IAOI,kBAAA;EzH+nzBJ;AACF;AyH9nzBI;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,4BAAA;AzHgozBN;AyH/nzBM;EACE,WAAA;EACA,QAAA;EACA,4BAAA;AzHiozBR;AyH7nzBM;EACE,sCAAA;AzH+nzBR;AyH7nzBM;EACE,sCAAA;AzH+nzBR;AyH3nzBM;EACE,yB7C3mBQ;A5Ewu0BhB;AyH3nzBM;EACE,yBAAA;AzH6nzBR;;AyHxnzBA;EACE,aAAA;EACA,mBAAA;EACA,c7C/nB2B;A5E0v0B7B;AyH1nzBE;EACE,WAAA;EACA,YAAA;AzH4nzBJ;;AyHxnzBE;EACE,UAAA;AzH2nzBJ;AyHznzBE;EACE,MAAA;AzH2nzBJ;AyHvnzBM;EACE,WAAA;AzHynzBR;AyHxnzBQ;EACE,WAAA;EACA,SAAA;AzH0nzBV;AyHznzBU;EACE,WAAA;EACA,WAAA;AzH2nzBZ;AyHvnzBQ;;EAEE,sBAAA;EACA,+BAAA;EACA,mBAAA;AzHynzBV;AyHvnzBQ;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AzHynzBV;AyHxnzBU;EACE,sBAAA;AzH0nzBZ;AyHpnzBE;EACE,aAAA;EACA,mBAAA;AzHsnzBJ;AyHpnzBE;EACE,gBAAA;EACA,c7CnqBS;A5Eyx0Bb;;AyHlnzBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,0BAAA;AzHqnzBJ;AyHpnzBI;EACE,gBAAA;AzHsnzBN;AyHpnzBI;EACE,2DAAA;AzHsnzBN;AyHpnzBI;EACE,yBAAA;AzHsnzBN;AyHpnzBI;EACE,4BAAA;AzHsnzBN;AyHnnzBM;EACE,qBAAA;EACA,gBAAA;AzHqnzBR;;AyHhnzBA;EACE,WAAA;EACA,oBAAA;EACA,gBAAA;AzHmnzBF;AyHjnzBI;EACE,aAAA;AzHmnzBN;;AyH5mzBA;EAIQ;IACE,eAAA;EzH4mzBR;EyH1mzBQ;IACE,eAAA;IACA,iBAAA;EzH4mzBV;EyHrmzBY;IACE,eAAA;EzHumzBd;AACF;AyH9lzBA;EASkB;IACE,YAAA;EzHwlzBlB;EyHnlzBY;IACE,YAAA;EzHqlzBd;EyHjlzBU;IACE,mBAAA;EzHmlzBZ;EyHjlzBY;IACE,eAAA;EzHmlzBd;EyH5kzBQ;IACE,iBAAA;IACA,eAAA;EzH8kzBV;AACF;A0Hx20BA;;4BAAA;AAIE;EACE,2BAAA;EACA,gBAAA;A1Hy20BJ;;A0Hr20BE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,uIAAA;A1Hw20BJ;A0Hv20BI;EACE,WAAA;EACA,YAAA;EACA,U9CkBE;A5Eu10BR;A0Ht20BE;EACE,gBAAA;A1Hw20BJ;A0Hv20BI;EACE,aAAA;EACA,SAAA;EACA,8BAAA;A1Hy20BN;A0Hx20BM;EAJF;IAKI,eAAA;E1H220BN;AACF;A0H120BM;EAPF;IAQI,gBAAA;E1H620BN;AACF;A0H320BI;EACE,2BAAA;EACA,gBAAA;A1H620BN;A0H120BE;EACE,gBAAA;A1H420BJ;A0H120BE;EACE,SAAA;EACA,mBAAA;A1H420BJ;A0Hz20BI;EACE,WAAA;EACA,YAAA;EACA,sBAAA;A1H220BN;A0Hx20BE;EACE,c9CvDoB;E8CwDpB,aAAA;EACA,mBAAA;EACA,YAAA;A1H020BJ;A0Hz20BI;EALF;IAMI,aAAA;E1H420BJ;AACF;A0H320BI;EARF;IASI,WAAA;E1H820BJ;AACF;A0H720BI;EAXF;IAYI,UAAA;E1Hg30BJ;AACF;A0H320BQ;EADF;IAEI,gBAAA;E1H820BR;AACF;A0Hz20BI;EACE,gFAAA;A1H220BN;A0Hv20BI;EACE,kFAAA;A1Hy20BN;A0Hr20BI;EACE,gFAAA;A1Hu20BN;A0Hn20BI;EADF;IAEI,4BAAA;E1Hs20BJ;AACF;;A0Hn20BA;EACE,+BAAA;A1Hs20BF;A0Hr20BE;EAFF;IAGI,UAAA;E1Hw20BF;AACF;A0Ht20BI;EACE,aAAA;A1Hw20BN;;A0Hn20BE;EACE,eAAA;EACA,SAAA;A1Hs20BJ;;A0Hn20BA;EACE,oEAAA;EACA,W9CjFM;A5Eu70BR;A0Hp20BI;EADF;IAEI,aAAA;E1Hu20BJ;AACF;A0Hr20BE;EACE,iBAAA;A1Hu20BJ;A0Ht20BI;EAFF;IAGI,iBAAA;E1Hy20BJ;AACF;A0Ht20BI;EACE,UAAA;A1Hw20BN;A0Hv20BM;EAFF;IAGI,UAAA;E1H020BN;AACF;A0Hz20BM;EALF;IAMI,WAAA;E1H420BN;AACF;A0H320BM;EARF;IASI,UAAA;E1H820BN;AACF;A0H720BM;EAXF;IAYI,UAAA;E1Hg30BN;AACF;A0H920BQ;EADF;IAEI,4BAAA;IACA,gBAAA;IACA,uBAAA;IACA,qBAAA;IACA,oBAAA;E1Hi30BR;AACF;A0Hh30BQ;EARF;IASI,qBAAA;E1Hm30BR;AACF;A0Hh30BI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;A1Hk30BN;A0Hj30BM;EACE,YAAA;EACA,UAAA;EACA,qBAAA;A1Hm30BR;A0Hj30BM;EAVF;IAWI,UAAA;E1Ho30BN;AACF;A0Hn30BM;EAbF;IAcI,UAAA;E1Hs30BN;AACF;A0Hr30BM;EAhBF;IAiBI,UAAA;E1Hw30BN;AACF;;A0Hn30BE;EACE,WAAA;A1Hs30BJ;;A0Hn30BA;EACE,c9CpLc;E8CqLd,sB9CtJM;A5E4g1BR;;A0Hp30BA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;A1Hu30BF;A0Ht30BE;EACE,kBAAA;A1Hw30BJ;A0Hv30BI;EAFF;IAGI,kBAAA;E1H030BJ;AACF;A0Hx30BE;EACE,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,4BAAA;EACA,oBAAA;A1H030BJ;A0Hx30BE;EACE,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,oBAAA;A1H030BJ;A0Hv30BE;EACE,cAAA;A1Hy30BJ;A0Hx30BI;EACE,WAAA;EACA,YAAA;EACA,sBAAA;A1H030BN;A0Hv30BE;EACE,YAAA;EACA,mBAAA;A1Hy30BJ;A0Hx30BI;EACE,mBAAA;EACA,kBAAA;A1H030BN;A0Hx30BI;EAPF;IAQI,mBAAA;E1H230BJ;E0H130BI;IACE,kBAAA;E1H430BN;AACF;A0Hz30BM;EACE,aAAA;A1H230BR;;A0Hl30BQ;EACE,cAAA;A1Hq30BV;A0Hj30BQ;EACE,gBAAA;A1Hm30BV;A0Hl30BU;EAFF;IAGI,gBAAA;E1Hq30BV;AACF;A0Hn30BQ;EACE,iBAAA;EACA,eAAA;A1Hq30BV;A0Hj30BI;;EAEE,oBAAA;A1Hm30BN;;A0H/20BA;EACE,yBAAA;EACA,YAAA;EACA,kBAAA;A1Hk30BF;A0Hj30BE;EACE,YAAA;A1Hm30BJ;A0Hl30BI;EACE,YAAA;EACA,iBAAA;EACA,8BAAA;A1Ho30BN;A0Hn30BM;EACE,2BAAA;A1Hq30BR;;A0Hh30BA;EACE,2BAAA;A1Hm30BF;A0Hl30BE;EACE,2BAAA;A1Ho30BJ;A0Hl30BE;EALF;IAMI,gBAAA;E1Hq30BF;AACF;;A0Hl30BE;EACE,aAAA;A1Hq30BJ;A0Hl30BI;EADF;IAEI,aAAA;E1Hq30BJ;AACF;;A0Hl30BA;EACE,WAAA;EACA,YAAA;EACA,+BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A1Hq30BF;A0Hn30BI;EACE,a9CjTU;A5Esq1BhB;A0Hj30BI;EACE,a9CxTU;A5E2q1BhB;A0H/20BI;EACE,a9C/TU;A5Egr1BhB;A0H720BI;EACE,a9CnUY;A5Ekr1BlB;A0H320BI;EACE,aAAA;A1H620BN;A0Hz20BI;EACE,aAAA;A1H220BN;;A0Hl20BU;EACE,2BAAA;A1Hq20BZ;A0Hh20BQ;EACE,sBAAA;EACA,gBAAA;A1Hk20BV;A0H910BQ;EACE,kCAAA;A1Hg20BV;A0H710BM;EACE,sCAAA;EACA,W9C1UA;A5Eyq1BR;;A0Hx10BI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;A1H210BN;A0Ht10BI;;EACE,gBAAA;A1Hy10BN;A0Hv10BI;;EACE,gBAAA;A1H010BN;;A0Hp10BE;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,yCAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;A1Hu10BJ;A0Ht10BI;EACE,YAAA;EACA,SAAA;A1Hw10BN;A0Ht10BI;EACE,mDAAA;EACA,yBAAA;A1Hw10BN;A0Ht10BI;EACE,qDAAA;EACA,yBAAA;A1Hw10BN;;A0Hj10BI;EAEE,wBAAA;EACA,SAAA;A1Hm10BN;A0Hj10BI;EACE,0BAAA;A1Hm10BN;;A0H/00BA;EACE,kBAAA;EACA,0DAAA;EACA,0BAAA;EACA,sBAAA;A1Hk10BF;A0Hj10BE;EACE,qBAAA;EACA,YAAA;EACA,qCAAA;EACA,0B9ChbY;E8CibZ,4B9CjbY;E8CkbZ,mBAAA;EACA,kBAAA;EACA,mBAAA;A1Hm10BJ;A0Hl10BI;EACE,0CAAA;EACA,mBAAA;A1Ho10BN;A0Hl10BI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,yBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;A1Ho10BN;A0Hn10BM;EACE,WAAA;EACA,YAAA;EACA,a9C1cQ;A5E+x1BhB;;A0H/00BE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;A1Hk10BJ;A0Hj10BI;EALF;IAMI,SAAA;E1Ho10BJ;AACF;A0Hn10BI;EACE,kBAAA;A1Hq10BN;A0Hn10BQ;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,YAAA;EACA,2BAAA;EACA,8CAAA;A1Hq10BV;A0Hp10BU;EACE,WAAA;EACA,YAAA;A1Hs10BZ;A0Hp10BU;EAZF;IAaI,WAAA;E1Hu10BV;E0Ht10BU;IACE,YAAA;E1Hw10BZ;AACF;;A0H/00BI;EADF;IAEI,aAAA;E1Hm10BJ;AACF;A0Hl10BI;EAJF;IAKI,aAAA;E1Hq10BJ;AACF;A0Hl10BQ;EACE,gBAAA;A1Ho10BV;;A0H900BA;EACE,aAAA;EACA,SAAA;A1Hi10BF;A0Hh10BE;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;A1Hk10BJ;A0Hj10BI;EARF;IASI,WAAA;IACA,eAAA;IACA,YAAA;IACA,kBAAA;E1Ho10BJ;AACF;A0Hn10BI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;A1Hq10BN;A0Hp10BM;EAJF;IAKI,WAAA;IACA,YAAA;E1Hu10BN;AACF;A0Ht10BM;EACE,W9C9fA;E8C+fA,WAAA;EACA,YAAA;A1Hw10BR;A0Hv10BQ;EAJF;IAKI,WAAA;IACA,YAAA;IACA,wBAAA;E1H010BR;AACF;A0Ht10BE;EACE,iBAAA;A1Hw10BJ;A0Hr10BI;EACE,wCAAA;A1Hu10BN;A0Ht10BM;EACE,yB9C1iBO;A5Ek41Bf;A0Hn10BI;EACE,wCAAA;A1Hq10BN;A0Hp10BM;EACE,yB9CrjBQ;A5E241BhB;;A0Hj10BA;EACE,iBAAA;A1Ho10BF;A0Hn10BE;EAFF;IAGI,iBAAA;E1Hs10BF;AACF;;A0Hn10BE;EACE,UAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;A1Hs10BJ;A0Hn10BI;;EAEE,oBAAA;A1Hq10BN;A0H/00BU;EADF;;IAEI,gBAAA;E1Hm10BV;AACF;A0Hh10BU;EADF;;IAEI,gBAAA;E1Ho10BV;AACF;;A2Hr71BA;;4BAAA;AAIE;EACE,YAAA;EACA,wBAAA;EACA,mBAAA;A3Hu71BJ;A2Hn71BI;EACE,aAAA;A3Hq71BN;A2Hn71BI;EACE,eAAA;EACA,YAAA;EACA,wBAAA;EACA,2KAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A3Hq71BN;A2Hp71BM;EATF;IAUI,eAAA;IACA,YAAA;E3Hu71BN;E2Ht71BM;IACE,YAAA;E3Hw71BR;AACF;A2Hr71BI;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;A3Hu71BN;A2Ht71BM;EACE,yBAAA;EACA,YAAA;A3Hw71BR;A2Hr71BY;EACE,aAAA;A3Hu71Bd;;A2H/61BA;EACE,2BAAA;A3Hk71BF;A2Hj71BE;EAFF;IAGI,cAAA;E3Ho71BF;AACF;;A2Hl71BA;EACE;IACE,0BAAA;E3Hq71BF;E2Hn71BA;IACE,wBAAA;E3Hq71BF;E2Hn71BA;IACE,0BAAA;E3Hq71BF;AACF;A2Hl71BE;EACE,uBAAA;EACA,aAAA;EACA,UAAA;A3Ho71BJ;A2Hn71BI;EAJF;IAKI,UAAA;E3Hs71BJ;AACF;A2Hr71BI;EAPF;IAQI,UAAA;E3Hw71BJ;AACF;A2Hv71BI;EAVF;IAWI,UAAA;E3H071BJ;AACF;A2Hz71BI;EAbF;IAcI,UAAA;E3H471BJ;AACF;A2H171BE;EACE,iBAAA;A3H471BJ;A2H371BI;EAFF;IAGI,gBAAA;E3H871BJ;AACF;A2H771BI;EALF;IAMI,gBAAA;E3Hg81BJ;AACF;A2H/71BI;EACE,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,wCAAA;A3Hi81BN;A2H971BE;EACE,kBAAA;EACA,gBAAA;A3Hg81BJ;;A2H771BA;EACE,yBAAA;A3Hg81BF;;A2H771BE;EACE,kBAAA;A3Hg81BJ;A2H971BE;EACE,SAAA;A3Hg81BJ;;A2H171BI;EAFF;;IAGI,aAAA;E3H+71BJ;AACF;A2H771BE;EACE,oBAAA;A3H+71BJ;;A2H571BA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;A3H+71BF;A2H971BE;EACE,kBAAA;A3Hg81BJ;A2H971BM;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,yCAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;A3Hg81BR;A2H/71BQ;EACE,WAAA;EACA,YAAA;A3Hi81BV;A2H571BE;EACE,4FAAA;EACA,kBAAA;EACA,iBAAA;A3H871BJ;;A2H371BA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;A3H871BF;;A2Hv71BU;EACE,2BAAA;A3H071BZ;A2Hn71BI;EACE,8BAAA;EACA,kBAAA;A3Hq71BN;A2Hp71BM;EACE,mBAAA;EACA,mBAAA;A3Hs71BR;A2Hj71BI;EACE,8BAAA;A3Hm71BN;A2Hl71BM;EACE,kBAAA;EACA,+BAAA;A3Ho71BR;A2Hj71BI;EACE,yCAAA;EACA,qB/ChJK;E+CiJL,c/CjJK;A5Eok2BX;A2H/61BI;EACE,8BAAA;A3Hi71BN;A2Hh71BM;EACE,kBAAA;EACA,+BAAA;A3Hk71BR;A2H/61BI;EACE,yCAAA;EACA,qB/C7JQ;E+C8JR,c/C9JQ;A5E+k2Bd;A2H761BI;EACE,8BAAA;A3H+61BN;A2H961BM;EACE,kBAAA;EACA,+BAAA;A3Hg71BR;A2H761BI;EACE,yCAAA;EACA,qB/C1NY;E+C2NZ,c/C3NY;A5E0o2BlB;A2H561BE;EACE,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,wCAAA;EACA,6BAAA;A3H861BJ;A2H761BI;EACE,wCAAA;EACA,mBAAA;A3H+61BN;A2H361BI;EACE,8BAAA;A3H661BN;A2H561BM;EACE,kBAAA;EACA,+BAAA;A3H861BR;A2H361BI;EACE,yCAAA;EACA,qB/ClMU;E+CmMV,c/CnMU;A5Egn2BhB;A2Hz61BI;EACE,8BAAA;A3H261BN;A2H161BM;EACE,kBAAA;EACA,+BAAA;A3H461BR;A2Hz61BI;EACE,wCAAA;EACA,qB/C/MU;E+CgNV,c/ChNU;A5E2n2BhB;A2Hx61BE;;EAEE,iBAAA;A3H061BJ;A2Hv61BI;;EAEE,oBAAA;A3Hy61BN;A2Hx61BM;;EACE,gBAAA;A3H261BR;A2Hn61BQ;;EACE,gBAAA;A3Hs61BV;A2Hp61BQ;;EACE,gBAAA;A3Hu61BV;A2Hr61BQ;;;EAEE,eAAA;A3Hw61BV;;A2H/51BI;EACE,kBAAA;EACA,oBAAA;A3Hk61BN;A2H951BM;;;;EAEE,kBAAA;EACA,oBAAA;A3Hk61BR;A2H951BM;EACE,2BAAA;EACA,mBAAA;A3Hg61BR;A2H/51BQ;EAHF;IAII,mBAAA;E3Hk61BR;AACF;;A4Hpu2BA;;4BAAA;AAKA;EACE,sBAAA;A5Hqu2BF;;A4Hlu2BA;EACE;IACE,wBAAA;IACA,gBAAA;E5Hqu2BF;E4Hnu2BA;IACE,2BAAA;IACA,gBAAA;E5Hqu2BF;E4Hnu2BA;IACE,wBAAA;IACA,gBAAA;E5Hqu2BF;AACF;A4Hlu2BA;EACE;IACE,mBAAA;E5Hou2BF;E4Hlu2BA;IACE,qBAAA;E5Hou2BF;E4Hlu2BA;IACE,mBAAA;E5Hou2BF;AACF;A4Hhu2BE;EACE,uBAAA;EACA,cAH2C;A5Hqu2B/C;;A4Hpu2BE;EACE,gDAAA;EACA,cAH2C;A5H0u2B/C;;A4Hzu2BE;EACE,qEAAA;EACA,cAH2C;A5H+u2B/C;;A4H9u2BE;EACE,qEAAA;EACA,cAH2C;A5Hov2B/C;;A4Hnv2BE;EACE,oEAAA;EACA,cAH2C;A5Hyv2B/C;;A4Hxv2BE;EACE,qEAAA;EACA,cAH2C;A5H8v2B/C;;A4H7v2BE;EACE,qEAAA;EACA,cAH2C;A5Hmw2B/C;;A4Hlw2BE;EACE,2DAAA;EACA,cAH2C;A5Hww2B/C;;A4Hlw2BA;EACE,qEAAA;A5Hqw2BF;;A4Hnw2BA;EACE,0CAAA;A5Hsw2BF;;A4Hnw2BA;EACE,yCAAA;A5Hsw2BF;;A4Hpw2BA;EACE,0CAAA;A5Huw2BF;;A4Hlw2BI;EACE,gCAAA;A5Hqw2BN;;A4H/v2BI;EADF;IAEI,aAAA;E5Hmw2BJ;AACF;A4Hjw2BE;EACE;IACE,UAAA;E5Hmw2BJ;E4Hjw2BE;IACE,UAAA;E5Hmw2BJ;AACF;A4Hjw2BE;EACE;IACE,UAAA;E5Hmw2BJ;E4Hjw2BE;IACE,UAAA;E5Hmw2BJ;AACF;A4Hjw2BE;EACE;IACE,UAAA;E5Hmw2BJ;E4Hjw2BE;IACE,UAAA;E5Hmw2BJ;AACF;A4Hjw2BE;EACE;IACE,UAAA;E5Hmw2BJ;E4Hjw2BE;IACE,UAAA;E5Hmw2BJ;AACF;;A4Hhw2BA,iBAAA;AACA;EACE,mBAAA;A5Hmw2BF;A4Hlw2BE;EACE,WAAA;EACA,YAAA;A5How2BJ;A4Hnw2BI;EAHF;IAII,YAAA;E5Hsw2BJ;AACF;;A4Hnw2BA;;EAEE,WAAA;A5Hsw2BF;;A4Hpw2BA;EACE,UhD/EM;EgDgFN,gCAAA;EACA,kBAAA;EACA,qBAAA;A5Huw2BF;;A4Hpw2BA;EACE,UAAA;A5Huw2BF;;A4Hrw2BA;EACE,UAAA;EACA,ehD9H2B;EgD+H3B,eAAA;EACA,qBAAA;A5Hww2BF;;A4Hrw2BA;EACE,UAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;A5Hww2BF;;A4Hrw2BA;EACE,UAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;A5Hww2BF;;A4Hrw2BA;EACE,UAAA;EACA,ehD1Ic;EgD2Id,kBAAA;EACA,qBAAA;A5Hww2BF;;A4Htw2BA;EACE,UAAA;A5Hyw2BF;;A4Hvw2BA;;;EAGE,6BAAA;EACA,sCAAA;A5H0w2BF;;A4Htw2BI;EADF;IAEI,4BAAA;E5H0w2BJ;AACF;A4Hvw2BI;EADF;IAEI,aAAA;E5H0w2BJ;AACF;;A4Htw2BE;EACE,iBAAA;EACA,oBAAA;A5Hyw2BJ;A4Htw2BI;EACE,0CAAA;A5Hww2BN;;A4Hnw2BE;EACE,kBAAA;EACA,UAAA;A5Hsw2BJ;;A4Hlw2BE;EACE,iBAAA;EACA,oBAAA;A5Hqw2BJ;A4Hpw2BI;EAHF;IAII,iBAAA;E5Huw2BJ;AACF;;A4Hnw2BE;EACE,iBAAA;EACA,oBAAA;A5Hsw2BJ;A4Hnw2BI;EACE,aAAA;A5Hqw2BN;;A4Hjw2BA;EACE,0DAAA;EACA,sBAAA;EACA,mBAAA;A5How2BF;A4Hnw2BE;EACE,gBAAA;EACA,eAAA;A5Hqw2BJ;A4Hnw2BE;EACE,aAAA;EACA,mBAAA;A5Hqw2BJ;A4Hpw2BI;EAHF;IAII,aAAA;E5Huw2BJ;AACF;A4Hrw2BE;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,kBAAA;A5Huw2BJ;A4Htw2BI;EALF;IAMI,aAAA;E5Hyw2BJ;AACF;A4Hvw2BE;EACE,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;A5Hyw2BJ;A4Hxw2BI;EACE,WAAA;EACA,YAAA;EACA,uDhDuDU;EgDtDV,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;A5H0w2BN;A4Hzw2BM;EACE,WAAA;EACA,YAAA;A5H2w2BR;A4Hzw2BM;EACE,YAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,gBhDhOA;EgDiOA,WAAA;A5H2w2BR;A4Hzw2BM;EAxBF;IAyBI,WAAA;IACA,YAAA;E5H4w2BN;E4H3w2BM;IACE,WAAA;IACA,YAAA;E5H6w2BR;E4H3w2BM;IACE,YAAA;IACA,WAAA;IACA,WAAA;IACA,YAAA;E5H6w2BR;AACF;A4H1w2BI;EACE,kCAAA;A5H4w2BN;A4H1w2BI;EACE,oCAAA;A5H4w2BN;A4H1w2BI;EACE,qBhDtRU;A5Eki3BhB;A4H1w2BI;EACE,qBhDvRU;A5Emi3BhB;A4Hzw2BE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;A5H2w2BJ;A4H1w2BI;EAJF;IAKI,SAAA;E5H6w2BJ;AACF;A4H5w2BI;EACE,kBAAA;A5H8w2BN;A4H3w2BE;EACE,2BAAA;EACA,gBAAA;A5H6w2BJ;A4H3w2BM;EACE,kCAAA;A5H6w2BR;;A4Hvw2BE;EACE,mBAAA;A5H0w2BJ;;A4Htw2BA;EACE,mFhDpRoB;EgDqRpB,WhD5RM;A5Eqi3BR;A4Hxw2BE;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,4CAAA;A5H0w2BJ;A4Hzw2BI;EACE,uBAAA;EACA,SAAA;A5H2w2BN;A4Hzw2BI;EATF;IAUI,WAAA;IACA,iBAAA;E5H4w2BJ;E4H3w2BI;IACE,UAAA;IACA,gBAAA;E5H6w2BN;E4H3w2BI;IACE,UAAA;E5H6w2BN;AACF;A4H3w2BI;EACE;IACE,UAAA;E5H6w2BN;AACF;A4H3w2BI;EAzBF;IA0BI,WAAA;E5H8w2BJ;E4H7w2BI;IACE,WAAA;E5H+w2BN;E4H7w2BI;IACE,UAAA;E5H+w2BN;AACF;A4H7w2BI;EAlCF;IAmCI,WAAA;E5Hgx2BJ;E4H/w2BI;IACE,UAAA;E5Hix2BN;E4H/w2BI;IACE,UAAA;E5Hix2BN;AACF;A4H7w2BI;EACE,UAAA;A5H+w2BN;A4H9w2BM;EAFF;IAGI,UAAA;E5Hix2BN;AACF;A4Hhx2BM;EALF;IAMI,UAAA;E5Hmx2BN;AACF;A4Hlx2BM;EARF;IASI,UAAA;E5Hqx2BN;AACF;A4Hpx2BM;EAXF;IAYI,WAAA;E5Hux2BN;AACF;A4Htx2BM;EAdF;IAeI,UAAA;E5Hyx2BN;AACF;A4Htx2BE;EACE,kBAAA;A5Hwx2BJ;A4Hvx2BI;EAFF;IAGI,kBAAA;E5H0x2BJ;AACF;A4Hzx2BI;EALF;IAMI,kBAAA;E5H4x2BJ;AACF;A4H3x2BI;EARF;IASI,gBAAA;E5H8x2BJ;AACF;A4H5x2BM;EADF;IAEI,iBAAA;E5H+x2BN;AACF;;A4H1x2BA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;A5H6x2BF;A4H3x2BI;EACE,eAAA;EACA,mBAAA;A5H6x2BN;A4H3x2BI;EACE,iBAAA;A5H6x2BN;A4H5x2BM;EAFF;IAGI,YAAA;E5H+x2BN;AACF;A4H7x2BQ;EACE,sCAAA;A5H+x2BV;;A4Hzx2BA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;A5H4x2BF;A4H3x2BE;EAJF;IAKI,QAAA;E5H8x2BF;AACF;A4H7x2BE;EACE,YAAA;A5H+x2BJ;A4H7x2BE;EAVF;IAWI,eAAA;E5Hgy2BF;AACF;;A4H7x2BE;EACE,mBAAA;EACA,WAAA;A5Hgy2BJ;A4H9x2BE;EACE,aAAA;EACA,mBAAA;A5Hgy2BJ;A4H/x2BI;EACE,cAAA;A5Hiy2BN;A4H/x2BI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;A5Hiy2BN;A4Hhy2BM;EALF;IAMI,QAAA;E5Hmy2BN;AACF;A4Hjy2BI;EACE,eAAA;EACA,iBAAA;A5Hmy2BN;A4Hly2BM;EAHF;IAII,eAAA;IACA,gBAAA;E5Hqy2BN;AACF;A4Hny2BI;EACE,kBAAA;EACA,iBAAA;EACA,8CAAA;A5Hqy2BN;A4Hpy2BM;EACE,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,+CAAA;A5Hsy2BR;A4Hpy2BM;EAZF;IAaI,iBAAA;IACA,gBAAA;E5Huy2BN;E4Hty2BM;IACE,iBAAA;IACA,kBAAA;E5Hwy2BR;AACF;A4Hpy2BE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,wCAAA;A5Hsy2BJ;;A4Hjy2BI;EACE,sDAAA;EACA,YAAA;EACA,sCAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,4BAAA;EACA,gBAAA;EACA,YAAA;EACA,wBAAA;A5Hoy2BN;A4Hly2BM;EACE,sDAAA;EACA,sCAAA;A5Hoy2BR;A4Hhy2BE;EACE,kBAAA;A5Hky2BJ;A4Hjy2BI;EACE,+BAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,+BAAA;EACA,yBAAA;A5Hmy2BN;;A4H7x2BE;EACE,kBAAA;A5Hgy2BJ;A4H/x2BI;EACE,kBAAA;EACA,WAAA;EACA,0BAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;EACA,yBAAA;A5Hiy2BN;A4Hhy2BM;EACE,WAAA;EACA,UAAA;A5Hky2BR;A4H9x2BE;EACE,+BAAA;EACA,uBAAA;A5Hgy2BJ;A4H9x2BE;EACE,gBAAA;EACA,0CAAA;A5Hgy2BJ;A4H1x2BU;EACE,WhDnhBJ;EgDohBI,iBAAA;EACA,gBAAA;A5H4x2BZ;A4Hxx2BQ;EACE,kBAAA;EACA,kBAAA;A5H0x2BV;A4Hzx2BU;EACE,4BAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;EACA,YAAA;A5H2x2BZ;A4H1x2BY;EATF;IAUI,yBAAA;IACA,oBAAA;IACA,kBAAA;IACA,oBAAA;IACA,cAAA;IACA,YAAA;IACA,iBAAA;E5H6x2BZ;AACF;A4H1x2BU;EACE;IACE,mBAAA;E5H4x2BZ;E4Hzx2BU;IACE,qBAAA;E5H2x2BZ;E4Hxx2BU;IACE,mBAAA;E5H0x2BZ;AACF;A4Htx2BQ;EACE,chDpmBmB;A5E433B7B;A4Hjx2BY;EACE,yBhDnmBE;EgDomBF,2DAAA;A5Hmx2Bd;A4H7w2BM;EACE,2BAAA;A5H+w2BR;A4H3w2BE;EACE,gBAAA;EACA,kBAAA;A5H6w2BJ;;A4Hxw2BE;EACE,oBAAA;A5H2w2BJ;A4Hxw2BI;EACE,0CAAA;A5H0w2BN;;A4Hrw2BA;EACE,kBAAA;EACA,iBAAA;A5Hww2BF;A4Hvw2BE;EAHF;IAII,iBAAA;E5H0w2BF;AACF;A4Hzw2BE;EANF;IAOI,iBAAA;E5H4w2BF;AACF;A4H3w2BE;EATF;IAUI,iBAAA;E5H8w2BF;AACF;A4H7w2BE;EAZF;IAaI,gBAAA;E5Hgx2BF;AACF;A4H/w2BE;EACE,kBAAA;A5Hix2BJ;A4Hhx2BI;EAFF;IAGI,kBAAA;E5Hmx2BJ;AACF;A4Hlx2BI;EALF;IAMI,UAAA;IACA,0BAAA;E5Hqx2BJ;AACF;A4Hpx2BI;EATF;IAUI,UAAA;E5Hux2BJ;AACF;A4Htx2BI;EAZF;IAaI,UAAA;E5Hyx2BJ;AACF;A4Hxx2BI;EAfF;IAgBI,UAAA;E5H2x2BJ;AACF;A4H1x2BI;EAlBF;IAmBI,UAAA;E5H6x2BJ;AACF;A4H5x2BI;EArBF;IAsBI,kBAAA;E5H+x2BJ;AACF;A4H9x2BI;EAxBF;IAyBI,iBAAA;IACA,UAAA;E5Hiy2BJ;AACF;A4H/x2BE;EACE,eAAA;A5Hiy2BJ;;A4H7x2BA;EACE,eAAA;EACA,yBAAA;EACA,yCAAA;EACA,iBAAA;EACA,sBAAA;A5Hgy2BF;A4H/x2BE;EANF;IAOI,gBAAA;E5Hky2BF;AACF;A4Hjy2BE;EATF;IAUI,gBAAA;E5Hoy2BF;AACF;A4Hny2BE;EAZF;IAaI,gBAAA;E5Hsy2BF;AACF;A4Hry2BE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;A5Huy2BJ;A4Hty2BI;EANF;IAOI,QAAA;E5Hyy2BJ;AACF;A4Hxy2BI;EACE,eAAA;EACA,gBAAA;A5H0y2BN;A4Hvy2BM;EADF;IAEI,eAAA;E5H0y2BN;AACF;A4Hvy2BM;EADF;IAEI,eAAA;E5H0y2BN;AACF;A4Hty2BQ;EACE,kCAAA;A5Hwy2BV;A4Hny2BE;EACE,mBAAA;EACA,qBAAA;A5Hqy2BJ;A4Hpy2BI;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A5Hsy2BN;A4Hry2BM;EARF;IASI,WAAA;IACA,YAAA;E5Hwy2BN;E4Hvy2BM;IACE,WAAA;IACA,YAAA;E5Hyy2BR;AACF;A4Hty2BI;EACE,yBAAA;A5Hwy2BN;A4Hvy2BM;EACE,0CAAA;A5Hyy2BR;A4Hty2BI;EACE,yBAAA;A5Hwy2BN;A4Hvy2BM;EACE,+DAAA;A5Hyy2BR;;A4Hhy2BM;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;A5Hmy2BR;A4Hly2BQ;EACE,WAAA;A5Hoy2BV;A4Hjy2BQ;EACE,QAAA;EACA,UAAA;EACA,iBAAA;A5Hmy2BV;A4Hhy2BQ;;EAEE,gBAAA;EACA,eAAA;A5Hky2BV;A4H/x2BQ;EACE,iBAAA;A5Hiy2BV;A4H7x2BQ;EACE,6BAAA;EACA,gBAAA;EACA,gCAAA;A5H+x2BV;A4H7x2BQ;EACE,cAAA;A5H+x2BV;A4H1x2BU;EACE,2BAAA;EACA,gBAAA;A5H4x2BZ;A4Hvx2BQ;EACE,yBAAA;A5Hyx2BV;A4Hrx2BQ;EACE,4BAAA;A5Hux2BV;A4H/w2BQ;EACE,eAAA;A5Hix2BV;A4Hhx2BU;EACE,eAAA;A5Hkx2BZ;;A4H1w2BA;EACE,WAAA;EACA,YAAA;EACA,2CAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A5H6w2BF;A4H3w2BE;EACE,2BAAA;EACA,eAAA;A5H6w2BJ;A4H3w2BE;EACE,4BAAA;A5H6w2BJ;;A4H1w2BA;EACE,aAAA;EACA,aAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;A5H6w2BF;A4H5w2BE;EANF;IAOI,QAAA;E5H+w2BF;AACF;A4H9w2BE;EACE,WAAA;EACA,YAAA;EACA,gBhD50BI;EgD60BJ,4RAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A5Hgx2BJ;A4H/w2BI;EATF;IAUI,WAAA;IACA,YAAA;E5Hkx2BJ;AACF;A4Hjx2BI;EACE,YAAA;EACA,6BAAA;A5Hmx2BN;A4Hlx2BM;EAHF;IAII,YAAA;E5Hqx2BN;AACF;;A4Hhx2BA;EACE,mDAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;A5Hmx2BF;;A4H5w2BI;EACE,6BAAA;EACA,gBAAA;EACA,iBAAA;A5H+w2BN;A4H7w2BM;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;A5H+w2BR;A4H3w2BI;EACE,eAAA;A5H6w2BN;A4Hzw2BE;EACE,eAAA;A5H2w2BJ;A4Hvw2BI;EACE,chDv6BkB;A5Egr4BxB;A4Htw2BI;EACE,chD16BuB;EgD26BvB,eAAA;EACA,qBAAA;EACA,cAAA;A5Hww2BN;A4Htw2BM;EACE,8BAAA;EACA,kBAAA;EACA,gBAAA;A5Hww2BR;;A4Hhw2BA;EACE,ahDt7Bc;A5Eyr4BhB;;A4Hjw2BA;EACE,ahDx7BgB;A5E4r4BlB;;A4Hlw2BA;EACE,ahD17Bc;A5E+r4BhB;;A4Hnw2BA;EACE,ahD37Bc;A5Eis4BhB;;A4Hpw2BA;EACE,ahD/7BW;A5Ess4Bb;;A4Hrw2BA;EACE,ahDh8Ba;A5Ews4Bf;;A4Hrw2BA;EACE,gBAAA;EACA,oCAAA;EACA,kBAAA;A5Hww2BF;A4Hvw2BE;EACE,chDn9BoB;EgDo9BpB,SAAA;EACA,mBAAA;A5Hyw2BJ;A4Hvw2BI;EACE,WhDp7BE;A5E6r4BR;A4Hrw2BE;EACE,mBAAA;A5Huw2BJ;A4Hpw2BE;EACE,gBAAA;A5Hsw2BJ;A4Hnw2BE;EACE,chDp+ByB;EgDq+BzB,SAAA;EACA,eAAA;A5Hqw2BJ;A4Hlw2BE;EACE,chD39Bc;EgD49Bd,eAAA;A5How2BJ;A4Hjw2BE;EACE,aAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;A5Hmw2BJ;A4Hhw2BE;EACE,wBAAA;A5Hkw2BJ;A4H/v2BE;EAEE,qDAAA;A5Hiw2BJ;;A4H7v2BA;EACE,mBAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,8IAAA;A5Hgw2BF;A4H9v2BE;EACE,sBhDv+BI;EgDw+BJ,YAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A5Hgw2BJ;A4H7v2BE;EACE,0KAAA;A5H+v2BJ;;A4Hzv2BI;EAEE,qBAAA;EACA,yBAAA;EACA,kCAAA;A5H4v2BN;A4Hxv2BE;EACE,YAAA;EACA,uBAAA;EACA,gCAAA;EACA,yBAAA;A5H0v2BJ;A4Hvv2BE;EACE,kBAAA;EACA,eAAA;EACA,8BAAA;A5Hyv2BJ;A4Hxv2BI;EACE,kBAAA;A5H0v2BN;A4Hxv2BI;EACE,gBAAA;EACA,chDpjCuB;A5E8y4B7B;A4Hvv2BI;EACE,chDzjCkB;EgD0jClB,gBAAA;EACA,ehD54Ba;A5Eqo4BnB;A4Hvv2BM;EACE,cAAA;A5Hyv2BR;;A4Hlv2BE;EACE,eAAA;EACA,4BAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;A5Hqv2BJ;A4Hlv2BE;EACE,chD/kCyB;EgDglCzB,kBAAA;EACA,mBAAA;EACA,gBAAA;A5Hov2BJ;A4Hjv2BE;EACE,chDvlCoB;EgDwlCpB,iBAAA;A5Hmv2BJ;A4Hhv2BE;EACE,chD3lCyB;A5E604B7B;A4H/u2BE;EACE,cAAA;A5Hiv2BJ;;A4H1u2BI;EACE,kBAAA;A5H6u2BN;;A4Htu2BE;;;EAGE,oBAAA;A5Hyu2BJ;A4Hxu2BI;;;EACE,aAAA;A5H4u2BN;A4Hzu2BE;EACE,chDvmCc;A5Ek14BlB;;A4Hvu2BE;EACE,oBAAA;A5H0u2BJ;A4Hzu2BI;EACE,yBAAA;A5H2u2BN;A4Hzu2BI;EACE,iBAAA;A5H2u2BN;A4Hxu2BE;EACE,2BAAA;EACA,4BAAA;A5H0u2BJ;A4Hvu2BE;EACE,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;A5Hyu2BJ;A4Hvu2BI;EACE,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,MAAA;A5Hyu2BN;A4Hvu2BM;EACE,mCAAA;EACA,yBAAA;A5Hyu2BR;A4Hpu2BE;EACE,gBAAA;A5Hsu2BJ;A4Hpu2BI;EACE,WhDhoCE;A5Es24BR;;A4Hlu2BA;EACE,oBAAA;A5Hqu2BF;A4Hlu2BM;EACE,cAAA;A5Hou2BR;A4Hlu2BM;EACE,mBAAA;A5Hou2BR;;A4H/t2BA;EACE,qBAAA;A5Hku2BF;A4H/t2BM;;EAEE,wCAAA;A5Hiu2BR;;A4H3t2BE;EACE,chDjsCyB;A5E+54B7B;A4H5t2BE;EACE,cAAA;A5H8t2BJ;;A4H1t2BA;EACE;IACE,wBAAA;E5H6t2BF;AACF;A4H9s2BA;EACE;IACE,iBAAA;IACA,eAAA;E5H0t2BF;E4Hvt2BA;IACE,iBAAA;IACA,kBAAA;E5Hyt2BF;AACF;A4H5s2BA;EACE;IACE,uBAAA;E5Hst2BF;E4Hnt2BA;IACE,oBAAA;E5Hqt2BF;AACF;A4Hlt2BA;EACE,WAAA;EACA,aAAA;A5Hot2BF;A4Hlt2BE;EACE,4CAAA;A5Hot2BJ;A4Hjt2BE;EACE,kCAAA;A5Hmt2BJ;A4Hjt2BI;EACE,4BAAA;EACA,8BAAA;EACA,6BAAA;A5Hmt2BN;A4H/s2BE;EACE,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,oBAAA;EACA,sBAAA;A5Hit2BJ;A4H9s2BE;EACE,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8CAAA;A5Hgt2BJ;;A4H5s2BE;;EAEE,0BAAA;EACA,yBAAA;A5H+s2BJ;A4H5s2BI;EACE,0CAAA;A5H8s2BN;;A4Hzs2BA;EACE,kBAAA;A5H4s2BF;A4H3s2BE;EACE,aAAA;A5H6s2BJ;A4H1s2BI;EAEE,iBAAA;A5H2s2BN;;A4Hrs2BE;EACE,WAAA;EACA,aAAA;A5Hws2BJ;A4Hrs2BE;EACE,kBAAA;EACA,mBAAA;A5Hus2BJ;A4Hrs2BI;EACE,gBAAA;EACA,gBAAA;A5Hus2BN;;A4Hjs2BE;EACE,WAAA;EACA,YAAA;EACA,wBAAA;A5Hos2BJ;A4H/r2BM;EACE,iBAAA;A5His2BR;A4H5r2BE;EACE,8BAAA;EACA,+BAAA;EACA,gBAAA;A5H8r2BJ;;A4H1r2BA;EACE,aAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;A5H6r2BF;;A4Hxr2BI;EACE,8BAAA;EACA,+BAAA;A5H2r2BN;;A4Htr2BA;EACE,aAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;A5Hyr2BF;;A4Hrr2BE;EACE,gBAAA;A5Hwr2BJ;A4Htr2BI;EACE,cAAA;A5Hwr2BN;A4Hpr2BE;EACE,chD73CyB;A5Emj5B7B;;A4Hlr2BA;EACE,aAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;A5Hqr2BF;;A4Hlr2BA;EACE,WAAA;EACA,aAAA;A5Hqr2BF;;A4Hlr2BA;EACE,WAAA;A5Hqr2BF;;A4Hlr2BA;;;;EAIE,aAAA;A5Hqr2BF;;A4Hhr2BI;;;;;EAKE,iCAAA;A5Hmr2BN;A4H/q2BE;EACE,UhDh4CI;EgDi4CJ,WhDj4CI;A5Ekj5BR;A4H9q2BE;EACE,gCAAA;A5Hgr2BJ;;A4Hxq2BI;;;;;;;;;;;;;;;EAKE,0BAAA;EACA,iBAAA;A5Hqr2BN;A4Hhr2BI;;;;;;;;;;;;;;;EAKE,gCAAA;EACA,iBAAA;A5H4r2BN;A4Hvr2BI;;;;;;;;;;;;;;;EAKE,gCAAA;EACA,iBAAA;A5Hms2BN;A4H/r2BE;;;EACE,UhD96CI;EgD+6CJ,WhD/6CI;A5Ekn5BR;A4Hhs2BE;;;EACE,gCAAA;A5Hos2BJ;;A4H7r2BI;EACE,YAAA;A5Hgs2BN;;A4Hvr2BM;EACE,iBAAA;A5H0r2BR;A4Hrr2BE;EACE,eAAA;A5Hur2BJ;;A4Hjr2BE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;A5Hor2BJ;A4Hlr2BI;EACE,6BhDv9CE;A5E2o5BR;;A4H9q2BA;EACE,wBAAA;EACA,mBAAA;A5Hir2BF;;A4H5q2BE;EACE,cAAA;A5H+q2BJ;;A4Htq2BQ;EACE,gBAAA;A5Hyq2BV;A4Hnq2BE;EACE,2BAAA;EACA,4BAAA;A5Hqq2BJ;;A4H7p2BM;EACE,iBAAA;A5Hgq2BR;A4H9p2BQ;EACE,WhDngDF;EgDogDE,6BhDpgDF;A5Eoq5BR;;A4Hxp2BA;EACE,gBAAA;A5H2p2BF;;A4Hnp2BQ;EACE,WhDthDF;A5E4q5BR;;A4H7o2BA;EACE,yBAAA;A5Hgp2BF;;A4H5o2BE;EACE,eAAA;EACA,mBAAA;A5H+o2BJ;A4H5o2BE;EACE,WAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBhDljDI;EgDmjDJ,4BAAA;EACA,sBAAA;EAEA,4CAAA;EACA,YAAA;EACA,UAAA;A5H8o2BJ;A4H3o2BE;EACE,chDhhDmB;EgDihDnB,YAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,gBhDjkDI;EgDkkDJ,eAAA;A5H6o2BJ;A4H5o2BI;EAEE,sBhDrkDE;A5Ekt5BR;A4H1o2BI;EAEE,WhD1kDE;EgD2kDF,sCAAA;A5H2o2BN;;A4Hno2BM;EACE,iBAAA;EACA,gBAAA;A5Hso2BR;;A4Hjo2BA;EACE,kBAAA;A5Hoo2BF;;A4Hlo2BA;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;A5Hqo2BF;A4Hpo2BE;EACE,YAAA;EACA,QAAA;A5Hso2BJ;A4Hpo2BE;EAVF;IAWI,UAAA;IACA,SAAA;E5Huo2BF;AACF;A4Hno2BE;EAjBF;IAkBI,wBAAA;E5Hso2BF;AACF;A4Hro2BE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;A5Huo2BJ;A4Hro2BE;EACE,qBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;A5Huo2BJ;;A4Hpo2BA;EACE,mBAAA;A5Huo2BF;A4Hto2BE;EACE,oBAAA;EACA,kBAAA;A5Hwo2BJ;A4Hto2BE;EACE,2BAAA;A5Hwo2BJ;A4Hvo2BI;EAFF;IAGI,gBAAA;E5H0o2BJ;AACF;A4Hzo2BI;EALF;IAMI,oBAAA;E5H4o2BJ;AACF;A4H1o2BE;EACE,2BAAA;EACA,oCAAA;EACA,sCAAA;A5H4o2BJ;A4Hzo2BE;EACE,yCAAA;A5H2o2BJ;A4Hxo2BE;EACE,oCAAA;EACA,2BAAA;A5H0o2BJ;A4Hvo2BI;EADF;IAEI,gBAAA;E5H0o2BJ;E4Hzo2BI;IACE,eAAA;E5H2o2BN;AACF;A4Hxo2BM;EADF;IAEI,gBAAA;E5H2o2BN;AACF;;A4Hvo2BA;EACE,eAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;A5H0o2BF;;A4Hxo2BA;EACE,mBAAA;A5H2o2BF;A4H1o2BE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;A5H4o2BJ;A4H3o2BI;EALF;IAMI,SAAA;E5H8o2BJ;AACF;A4H7o2BI;EARF;IASI,uBAAA;IACA,eAAA;IACA,mBAAA;E5Hgp2BJ;AACF;A4H/o2BI;EACE,aAAA;EACA,uBAAA;EACA,QAAA;A5Hip2BN;A4H3o2BQ;EADF;IAEI,eAAA;E5H8o2BR;AACF;A4Hzo2BI;EADF;IAEI,WAAA;E5H4o2BJ;AACF;A4H1o2BM;EADF;IAEI,aAAA;E5H6o2BN;AACF;;A4Hzo2BA;EACE,kBAAA;A5H4o2BF;A4H3o2BE;EACE,kBAAA;EACA,WAAA;EACA,8FAAA;EACA,wBAAA;EACA,yBAAA;EACA,MAAA;EACA,OAAA;A5H6o2BJ;;A4Hro2BM;EACE,kBAAA;A5Hwo2BR;A4Hno2BM;EACE,sBAAA;A5Hqo2BR;A4Hho2BE;EACE,8BAAA;EACA,+BAAA;A5Hko2BJ;A4H9n2BI;EACE,kBAAA;A5Hgo2BN;A4H7n2BI;EACE,iBAAA;A5H+n2BN;;A4Hvn2BI;EACE,6BAAA;A5H0n2BN;;A4Hpn2BA;EACE,aAAA;EACA,uBAAA;A5Hun2BF;A4Hrn2BE;;EAEE,sBAAA;A5Hun2BJ;;A4Hln2BA;EACE,aAAA;EACA,gBAAA;A5Hqn2BF;;A4H7m2BQ;EACE,6BAAA;A5Hgn2BV;;A4Hxm2BA;EACE,aAAA;EACA,gBAAA;EACA,qBAAA;A5H2m2BF;;A4Htm2BE;EACE,mBAAA;A5Hym2BJ;;A4Hnm2BI;EACE,eAAA;A5Hsm2BN;A4Hnm2BI;EACE,kBAAA;EACA,qBAAA;EACA,mBAAA;A5Hqm2BN;A4Hlm2BI;EACE,eAAA;A5Hom2BN;A4Hjm2BI;EACE,qBAAA;EACA,aAAA;A5Hmm2BN;A4H9l2BQ;EACE,SAAA;A5Hgm2BV;A4H1l2BE;EACE,oDAAA;A5H4l2BJ;A4H1l2BI;EACE,aAAA;EACA,mBAAA;A5H4l2BN;;A4Hrl2BE;EACE,aAAA;A5Hwl2BJ;;A4Hll2BA;EAEI;IACE,oBAAA;E5Hol2BJ;E4H9k2BU;IACE,SAAA;E5Hgl2BZ;E4H7k2BU;IACE,gBAAA;E5H+k2BZ;AACF;A4Hvk2BA;EAEI;IACE,sBAAA;IACA,6BAAA;E5Hwk2BJ;AACF;A4Hpk2BA;EAEI;IACE,oBAAA;E5Hqk2BJ;E4Hjk2BA;IACE,cAAA;E5Hmk2BF;E4Hjk2BE;IACE,mBAAA;E5Hmk2BJ;AACF;A4H/j2BA;EACE;IACE,0BAAA;IACA,2BAAA;E5Hik2BF;E4H/j2BE;IACE,eAAA;E5Hik2BJ;E4H1j2BM;IACE,gBAAA;E5H4j2BR;E4H1j2BQ;IACE,eAAA;E5H4j2BV;E4Hzj2BQ;IACE,gBAAA;E5H2j2BV;AACF;A4Hpj2BA;;4BAAA;AC/9DA;;4BAAA;AAIA,gCAAA;AACA;EACE,eAAA;A7Huh6BF;;A6Hlh6BI;EACE,4BAAA;EACA,YAAA;A7Hqh6BN;A6Hph6BM;EAHF;IAII,4BAAA;E7Huh6BN;AACF;;A6Hlh6BE;EACE,WAAA;EACA,YAAA;EACA,4BAAA;EACA,aAAA;EACA,kBAAA;A7Hqh6BJ;A6Hlh6BE;EACE,gBAAA;EACA,eAAA;A7Hoh6BJ;A6Hlh6BE;EACE,eAAA;A7Hoh6BJ;A6Hjh6BE;EACE,YAAA;A7Hmh6BJ;A6Hhh6BI;EACE,gBAAA;A7Hkh6BN;A6H7g6BM;EACE,WAAA;A7H+g6BR;;A6Hxg6BE;EACE,wCAAA;EACA,gCAAA;EACA,iBAAA;A7H2g6BJ;A6H1g6BI;EACE,cjDvCM;A5Emj6BZ;A6H1g6BI;EACE,sBAAA;EACA,ejD1CO;A5Esj6Bb;A6Hxg6BE;EACE,cAAA;A7H0g6BJ;A6Hxg6BE;EACE,uCAAA;A7H0g6BJ;A6Htg6BE;EACE,uCAAA;EACA,cjDxDS;EiDyDT,eAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;A7Hwg6BJ;;A6Hng6BI;EACE,cjDpEM;EiDqEN,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;A7Hsg6BN;A6Hpg6BM;EACE,qBjD7FQ;EiD8FR,cjD9FQ;EiD+FR,0CAAA;EACA,yBAAA;A7Hsg6BR;A6Hng6BI;EACE,iBAAA;A7Hqg6BN;A6Hpg6BM;EACE,kBAAA;EACA,kBAAA;A7Hsg6BR;;A6H7/5BM;EACE,kBAAA;EACA,kBAAA;A7Hgg6BR;A6H//5BQ;EACE,kBAAA;A7Hig6BV;A6H//5BY;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;A7Hig6Bd;;A6Hp/5BQ;EACE,UAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;A7Hu/5BV;A6Hp/5BY;EACE,mBAAA;A7Hs/5Bd;A6H7+5BI;EACE,cAAA;EACA,gBAAA;A7H++5BN;A6Hv+5BU;EACE,UAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,SAAA;EACA,YAAA;A7Hy+5BZ;;A6Hj+5BA;EACE,aAAA;A7Ho+5BF;A6Hl+5BE;EACE,sBAAA;EACA,eAAA;A7Ho+5BJ;;A6H995BI;EACE,aAAA;EACA,mBAAA;A7Hi+5BN;A6H/95BM;EACE,UAAA;A7Hi+5BR;A6H995BM;EACE,gBAAA;A7Hg+5BR;;A6H195BA;EACE,eAAA;EACA,6BAAA;EACA,gCAAA;EACA,mBAAA;A7H695BF;;A6H195BA;EACE,aAAA;EACA,mBAAA;A7H695BF;;A6H195BA;EACE,YAAA;EACA,iBAAA;A7H695BF;A6Hz95BM;EACE,kBAAA;A7H295BR;A6Hz95BQ;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,QAAA;A7H295BV;A6Hx95BQ;EACE,UAAA;A7H095BV;A6Hv95BQ;EACE,UAAA;A7Hy95BV;A6Ht95BQ;EACE,UAAA;A7Hw95BV;A6Hr95BQ;EACE,UAAA;A7Hu95BV;A6Hp95BQ;EACE,UAAA;A7Hs95BV;A6Hn95BQ;EACE,UAAA;A7Hq95BV;A6Hl95BQ;EACE,UAAA;A7Ho95BV;A6Hj95BQ;EACE,UAAA;A7Hm95BV;A6Hh95BQ;EACE,UAAA;A7Hk95BV;A6H/85BQ;EACE,WAAA;A7Hi95BV;A6H985BQ;EACE,WAAA;A7Hg95BV;A6H785BQ;EACE,WAAA;A7H+85BV;A6H585BQ;EACE,WAAA;A7H885BV;A6H385BQ;EACE,WAAA;A7H685BV;A6H185BQ;EACE,WAAA;A7H485BV;;A6Hr85BA;EACE,YAAA;EACA,sBAAA;A7Hw85BF;A6Ht85BE;EACE,cjDzToB;A5Eiw6BxB;A6Hr85BE;EACE,YAAA;EACA,sBjDzRI;EiD0RJ,aAAA;EACA,mBAAA;EACA,cAAA;A7Hu85BJ;A6Hr85BI;EACE,WAAA;EACA,YAAA;A7Hu85BN;;A6Hj85BE;EACE,gBAAA;A7Ho85BJ;A6Hj85BE;EACE,mBAAA;A7Hm85BJ;A6Hh85BE;EACE,gBAAA;A7Hk85BJ;A6H/75BM;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;A7Hi85BR;A6H/75BQ;EACE,sBjD3TF;A5E4v6BR;A6H975BQ;EACE,yBjDnWmB;A5Emy6B7B;A6H775BQ;EACE,sBjDpUF;A5Emw6BR;A6H575BQ;EACE,yBAAA;A7H875BV;A6H375BQ;EACE,yBAAA;A7H675BV;A6H175BQ;EACE,sBAAA;A7H475BV;A6Hz75BQ;EACE,yBAAA;A7H275BV;A6Hx75BQ;EACE,yBAAA;A7H075BV;A6Hv75BQ;EACE,yBAAA;A7Hy75BV;A6Hn75BE;EACE,gBAAA;A7Hq75BJ;A6Hn75BI;EACE,WAAA;A7Hq75BN;A6Hj75BM;EACE,aAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;A7Hm75BR;A6Hh75BU;EACE,oBjD/XQ;A5Eiz6BpB;A6H/65BU;EACE,eAAA;A7Hi75BZ;A6H/65BY;EACE,0BjDtYM;A5Euz6BpB;A6H165BQ;EACE,6BjD9YU;EiD+YV,cAAA;A7H465BV;A6Hr65BY;EACE,eAAA;A7Hu65Bd;A6Hp65BY;EACE,gBAAA;A7Hs65Bd;;A6H555BE;EACE,YAAA;EACA,mDAAA;EACA,mBAAA;EACA,YAAA;A7H+55BJ;;A6Hz55BI;EACE,kBAAA;A7H455BN;A6H155BM;EACE,mBAAA;EACA,YAAA;EACA,mDAAA;EACA,YAAA;EACA,kBAAA;A7H455BR;A6Hz55BM;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,cjDlcI;A5E616BZ;;A6Ht55BA;EACE,aAAA;A7Hy55BF;A6Hv55BE;EACE,gBAAA;A7Hy55BJ;A6Hx55BI;EACE,yBAAA;EACA,kBAAA;A7H055BN;A6Hx55BI;EACE,eAAA;A7H055BN;A6Hx55BQ;EACE,sCAAA;A7H055BV;;A6Hl55BE;EACE,UAAA;EACA,YAAA;A7Hq55BJ;A6Hn55BM;EACE,eAAA;A7Hq55BR;A6Hn55BQ;EACE,0BAAA;A7Hq55BV;A6Hl55BQ;EACE,eAAA;EACA,mBAAA;A7Ho55BV;A6Hj55BQ;EACE,eAAA;EACA,8BAAA;EACA,iCAAA;A7Hm55BV;A6Hh55BQ;EACE,cAAA;A7Hk55BV;A6H/45BY;EACE,qBAAA;A7Hi55Bd;A6H345BU;EACE,mBAAA;A7H645BZ;A6H345BY;EACE,UAAA;A7H645Bd;A6H345Bc;EACE,iBAAA;A7H645BhB;A6H145Bc;EACE,oCAAA;EACA,oCAAA;A7H445BhB;A6Hr45BI;EACE,kBAAA;EACA,WAAA;EACA,SAAA;A7Hu45BN;;A6Hn45BA;EACE,mBAAA;EACA,gBAAA;A7Hs45BF;A6Hp45BE;EACE,kBAAA;A7Hs45BJ;A6Hp45BI;EACE,cjDljBkB;A5Ew76BxB;A6Hn45BI;EACE,gBAAA;EACA,YAAA;A7Hq45BN;A6Hl45BI;EACE,gBAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;A7Ho45BN;A6Hj45BI;EACE,cjDlkBkB;EiDmkBlB,yBAAA;EACA,mBAAA;A7Hm45BN;A6Hh45BI;EACE,cjDrjBM;A5Eu76BZ;A6H935BM;EACE,eAAA;EACA,mBAAA;EACA,cAAA;A7Hg45BR;A6Hx35BQ;EACE,eAAA;A7H035BV;A6Hx35BU;EACE,0BAAA;A7H035BZ;A6Hv35BU;EACE,eAAA;EACA,mBAAA;A7Hy35BZ;A6Ht35BU;EACE,eAAA;EACA,8BAAA;EACA,iCAAA;A7Hw35BZ;A6Hr35BU;EACE,cAAA;A7Hu35BZ;A6Hp35Bc;EACE,qBAAA;A7Hs35BhB;A6Hh35BY;EACE,mBAAA;A7Hk35Bd;A6Hh35Bc;EACE,UAAA;A7Hk35BhB;A6Hh35BgB;EACE,iBAAA;A7Hk35BlB;A6H/25BgB;EACE,oCAAA;EACA,oCAAA;A7Hi35BlB;A6H125BM;EACE,kBAAA;EACA,WAAA;EACA,SAAA;A7H425BR;A6Hv25BE;EACE,kBAAA;A7Hy25BJ;A6Hv25BI;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,MAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,UAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;A7Hy25BN;A6Ht25BQ;EACE,qBAAA;EACA,+CAAA;EACA,kBAAA;EACA,sBjDhoBF;EiDioBE,eAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;A7Hw25BV;A6Ht25BU;EACE,cjDppBA;EiDqpBA,eAAA;A7Hw25BZ;A6Hr25BU;EACE,UAAA;A7Hu25BZ;A6Hp25BU;EACE,sCAAA;EACA,yBAAA;A7Hs25BZ;A6Hp25BY;;EAEE,WjDvpBN;A5E6/6BR;A6H715BI;EACE,UAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;A7H+15BN;;A6H115BA;EACE,aAAA;A7H615BF;A6H315BI;EACE,yBAAA;EACA,kBAAA;EACA,yBAAA;A7H615BN;A6H115BM;EACE,sCAAA;A7H415BR;A6Ht15BM;EADF;IAEI,aAAA;IACA,iBAAA;E7Hy15BN;AACF;A6Hx15BM;EALF;IAMI,aAAA;IACA,iBAAA;E7H215BN;AACF;A6Hx15BE;EACE,gBAAA;A7H015BJ;;A6Hr15BE;EACE,cjD/uBoB;EiDgvBpB,yBAAA;EACA,eAAA;A7Hw15BJ;A6Hr15BE;EACE,kBAAA;A7Hu15BJ;;A6Hj15BI;;;EAGE,yBAAA;EACA,6CAAA;A7Ho15BN;;A6H/05BA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,2BAAA;A7Hk15BF;A6Hh15BE;EACE,4BAAA;EACA,kBAAA;EACA,cAAA;A7Hk15BJ;;A6H705BE;EACE,qBAAA;EACA,8BAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;A7Hg15BJ;;A6H305BE;EACE,eAAA;A7H805BJ;A6H305BE;EACE,yBAAA;EACA,gBAAA;A7H605BJ;;A6Hz05BA,gCAAA;AAGE;EACE,qBAAA;A7H005BJ;A6Hx05BI;EACE,YAAA;EACA,qBAAA;A7H005BN;;A6Hr05BA;;4BAAA;AAGA;EACE;IACE,gBAAA;IACA,cAAA;E7Hw05BF;AACF;A8Hpo7BA;;4BAAA;AAYM;EACE,gBAAA;A9H6n7BR;A8H1n7BI;EACE,eAAA;A9H4n7BN;A8Hxn7BI;EACE,2CAAA;EACA,clDfU;EkDgBV,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;A9H0n7BN;A8Hzn7BM;EACE,iBAAA;A9H2n7BR;A8Hzn7BM;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EAEA,2BAAA;EACA,gBAAA;EACA,YAAA;EACA,0BAAA;EACA,eAAA;EACA,SAAA;A9H2n7BR;A8H1n7BQ;EACE,YAAA;EACA,UAAA;A9H4n7BV;A8Hxn7BI;EAEE,4CAAA;EACA,YAAA;EACA,UAAA;A9H0n7BN;A8Hzn7BM;EACE,cAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,gBlDpBA;EkDqBA,iBAAA;A9H2n7BR;A8H1n7BQ;EACE,sBlDvBF;A5Emp7BR;A8Htn7BI;EACE,yBAAA;A9Hwn7BN;A8Hrn7BM;EACE,WAAA;EACA,gBAAA;A9Hun7BR;A8Htn7BQ;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;A9Hwn7BV;A8Hvn7BU;EACE,kBAAA;A9Hyn7BZ;A8Hvn7BU;EACE,WlD7CJ;A5Esq7BR;A8Hvn7BU;EACE,yBAAA;EACA,qBAAA;A9Hyn7BZ;A8Hln7BM;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;A9Hon7BR;A8Hjn7BU;EACE,WAAA;EACA,clDhFC;A5Ems7Bb;A8Hhn7BU;EACE,kBAAA;EACA,clDtFA;A5Ews7BZ;A8H3m7BE;EACE,WAAA;EACA,WAAA;A9H6m7BJ;A8H3m7BI;EACE,aAAA;A9H6m7BN;A8Htm7BQ;EADF;IAEI,gBAAA;E9Hym7BR;E8Hxm7BQ;IACE,mBAAA;IACA,eAAA;E9H0m7BV;AACF;A8Hrm7BQ;EADF;IAEI,eAAA;E9Hwm7BR;E8Hvm7BQ;IACE,kBAAA;IACA,gBAAA;E9Hym7BV;AACF;A8Htm7BM;EACE,cAAA;A9Hwm7BR;A8Hvm7BQ;EAFF;IAGI,aAAA;IACA,eAAA;E9H0m7BR;AACF;A8Hzm7BQ;EACE,aAAA;A9H2m7BV;A8Hzm7BU;EACE,qEAAA;A9H2m7BZ;A8Hrm7BI;EACE,kBAAA;EACA,YAAA;A9Hum7BN;A8Hnm7BE;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,4BAAA;A9Hqm7BJ;A8Hlm7BE;EACE,gBAAA;EACA,clD5JQ;A5Egw7BZ;A8Hjm7BE;EACE,eAAA;A9Hmm7BJ;A8Hjm7BI;EACE,kBAAA;EACA,clDxLa;EkDyLb,eAAA;A9Hmm7BN;A8Hjm7BM;EACE,eAAA;A9Hmm7BR;A8Hlm7BQ;EACE,cAAA;A9Hom7BV;A8H/l7BI;EACE,clDlMuB;EkDmMvB,eAAA;A9Him7BN;A8H7l7BE;EACE,aAAA;EACA,2CAAA;EACA,iBAAA;A9H+l7BJ;A8H9l7BI;EACE,eAAA;A9Hgm7BN;A8H9l7BI;EACE,gBAAA;EACA,eAAA;A9Hgm7BN;A8H7l7BI;EACE,eAAA;A9H+l7BN;A8H5l7BE;EACE,aAAA;A9H8l7BJ;A8H7l7BI;EACE,aAAA;EACA,mBAAA;A9H+l7BN;A8H7l7BI;EACE,WAAA;A9H+l7BN;A8H7l7BI;EACE,mBAAA;EACA,WAAA;A9H+l7BN;A8H7l7BI;EACE,YAAA;A9H+l7BN;A8H5l7BM;EACE,mBAAA;A9H8l7BR;A8H1l7BI;EACE,mBAAA;A9H4l7BN;A8Hxl7BE;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,QAAA;EACA,QAAA;EACA,UAAA;EACA,yBAAA;EACA,YAAA;EACA,UAAA;EACA,cAAA;A9H0l7BJ;A8Hnl7BU;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;A9Hql7BZ;A8H/k7BQ;EACE,mBAAA;A9Hil7BV;A8H1k7BM;EACE,iBAAA;EACA,WAAA;EACA,yBAAA;A9H4k7BR;A8Hxk7BQ;EACE,eAAA;A9H0k7BV;A8Hpk7BQ;EACE,gBAAA;A9Hsk7BV;A8Hhk7BE;EACE,qBAAA;EACA,kBAAA;A9Hkk7BJ;;A8H9j7BA;;4BAAA;ACpTA;;4BAAA;AAGA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;A/Hw37BF;A+Hv37BE;EACE,0DAAA;EACA,0CAAA;EACA,8BAAA;A/Hy37BJ;A+Hr37BM;EACE,cnDWI;EmDVJ,eAAA;EACA,oDAAA;A/Hu37BR;A+Hp37BQ;EACE,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oDAAA;A/Hs37BV;A+Hl37BQ;EACE,4CAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;A/Ho37BV;A+H/27BE;EACE,gBAAA;A/Hi37BJ;A+Hh37BI;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,2BAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;A/Hk37BN;A+H/27BE;EACE,iBAAA;A/Hi37BJ;A+Hh37BI;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;A/Hk37BN;A+H/27BE;EACE,eAAA;EACA,cnD5DoB;EmD6DpB,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;A/Hi37BJ;A+H/27BE;EACE,gBAAA;A/Hi37BJ;;A+H927BA;EACE,oBAAA;EACA,WnDvCM;A5Ew57BR;A+Hh37BE;EACE,iBAAA;EACA,WnDzCI;EmD0CJ,4CAAA;A/Hk37BJ;A+Hh37BE;EACE,UAAA;EACA,WAAA;EACA,yBnD1EY;EmD2EZ,YAAA;A/Hk37BJ;A+Hh37BE;EACE,WnDnDI;A5Eq67BR;A+Hh37BE;EACE,kBAAA;A/Hk37BJ;A+Hh37BE;EACE,4BAAA;A/Hk37BJ;A+Hh37BE;EACE,yBnDrFU;EmDsFV,WnD9DI;A5Eg77BR;A+Hh37BI;EACE,yBnD3FU;EmD4FV,WnDjEE;EmDkEF,6CAAA;A/Hk37BN;A+H/27BE;EACE,yBnDvFS;EmDwFT,WnDvEI;A5Ew77BR;A+Hh37BI;EACE,yBnDpGU;EmDqGV,WnD1EE;EmD2EF,6CAAA;A/Hk37BN;;A+H927BA;;4BAAA;ACrGA;;4BAAA;AAGA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AhIy97BF;;AgIt97BA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AhIy97BF;AgIv97BE;EACE,sBpDII;EoDHJ,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;AhIy97BJ;AgIv97BI;EACE,cpDrBI;A5E8+7BV;AgIt97BI;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,epD7BI;A5Eq/7BV;;AgIn97BA;EACE,mBAAA;AhIs97BF;AgIn97BI;EACE,gBAAA;AhIq97BN;AgIl97BI;EACE,mBAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;AhIo97BN;AgIh97BE;EACE,WAAA;EACA,YAAA;EACA,YAAA;AhIk97BJ;;AgI787BE;EACE,gBAAA;AhIg97BJ;AgIl97BA;EAKE,mBAAA;AhIg97BF;;AgI387BI;;EAEE,kBAAA;AhI887BN;AgIz87BI;EACE,2BAAA;EACA,4BAAA;EACA,WAAA;AhI287BN;AgIt87BI;EACE,gBAAA;AhIw87BN;;AgIl87BE;EACE,sBAAA;AhIq87BJ;AgIl87BE;EACE,YAAA;AhIo87BJ;;AgIh87BA;EACE,mBAAA;AhIm87BF;AgIh87BI;EACE,aAAA;AhIk87BN;AgIh87BM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AhIk87BR;AgI/77BI;EACE,kBAAA;EACA,aAAA;AhIi87BN;AgI/77BM;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AhIi87BR;AgI977BM;EACE,eAAA;AhIg87BR;AgI377BE;EACE,wBAAA;AhI677BJ;AgI177BE;EACE,mBAAA;AhI477BJ;;AgIx77BA;EACE,cAAA;AhI277BF;AgIz77BE;EACE,cpD1IS;EoD2IT,gBAAA;AhI277BJ;;AgIv77BA;EACE,kBAAA;AhI077BF;AgIx77BE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;AhI077BJ;;AgIr77BE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AhIw77BJ;AgIt77BI;EACE,WAAA;EACA,YAAA;AhIw77BN;AgIh87BA;EAYE,mBAAA;AhIu77BF;;AgIl77BI;EACE,kBAAA;EACA,iCAAA;AhIq77BN;AgIn77BM;EACE,yBpDnLA;A5Ewm8BR;AgIl77BM;EACE,kBAAA;EACA,cpDjNgB;A5Eqo8BxB;AgIl77BQ;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;AhIo77BV;;AgI767BA;EACE,WAAA;EACA,YAAA;EACA,sCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AhIg77BF;AgI967BE;EACE,WAAA;EACA,YAAA;AhIg77BJ;;AgI367BE;EACE,kBAAA;AhI867BJ;AgI567BI;EACE,cpDzNO;A5Euo8Bb;;AgIz67BA;EACE,mBAAA;AhI467BF;AgI167BE;EACE,gBAAA;AhI467BJ;AgIz67BE;EACE,gBAAA;AhI267BJ;;AgIx67BA;EAEI;IACE,WAAA;IACA,YAAA;EhI067BJ;AACF;AgIt67BA;EACE;IACE,mBAAA;EhIw67BF;AACF;AgIr67BA;EAGM;IACE,wBAAA;EhIq67BN;EgIn67BM;IACE,WAAA;IACA,SAAA;EhIq67BR;EgI757BI;IACE,yBAAA;EhI+57BN;EgI557BQ;IACE,SAAA;EhI857BV;AACF;AgIv57BA;EACE;IACE,gBAAA;EhIy57BF;AACF;AgIt57BA;EACE;IACE,eAAA;EhIw57BF;EgIp57BE;IACE,WAAA;IACA,YAAA;EhIs57BJ;EgIl57BA;IACE,cAAA;EhIo57BF;EgIj57BA;IACE,mBAAA;IACA,gBAAA;EhIm57BF;EgIh57BA;IACE,kBAAA;EhIk57BF;EgIh57BE;IACE,wBAAA;EhIk57BJ;EgIh57BI;IACE,YAAA;EhIk57BN;EgI/47BI;IACE,WAAA;IACA,SAAA;EhIi57BN;EgI547BA;;IAEE,mBAAA;EhI847BF;AACF;AgI347BA;;4BAAA;ACpWA;;4BAAA;AAOI;;;;EAEE,wBAAA;AjIkv8BN;;AiI1u8BM;EACE,eAAA;AjI6u8BR;AiIxu8BE;EACE,aAAA;EACA,mBAAA;AjI0u8BJ;AiIvu8BM;EACE,sCAAA;AjIyu8BR;AiIvu8BQ;EACE,4BAAA;AjIyu8BV;AiIpu8BI;EACE,WAAA;EACA,sBAAA;EACA,iBAAA;AjIsu8BN;AiIlu8BE;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;AjIou8BJ;AiIlu8BI;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,crDnCM;A5Euw8BZ;AiIju8BI;EACE,gBAAA;AjImu8BN;AiIhu8BI;EACE,kBAAA;EACA,crD5CM;A5E8w8BZ;AiI/t8BI;EACE,qBAAA;AjIiu8BN;AiI9t8BI;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;AjIgu8BN;;AiI1t8BE;EACE,YAAA;EACA,2BAAA;EACA,eAAA;EACA,mBAAA;AjI6t8BJ;AiIpt8BU;EACE,yBAAA;EACA,4CAAA;AjIst8BZ;AiIxt8BU;EACE,yBAAA;EACA,4CAAA;AjI0t8BZ;AiI5t8BU;EACE,yBAAA;EACA,4CAAA;AjI8t8BZ;AiIhu8BU;EACE,yBAAA;EACA,4CAAA;AjIku8BZ;AiIpu8BU;EACE,yBAAA;EACA,4CAAA;AjIsu8BZ;AiIxu8BU;EACE,yBAAA;EACA,4CAAA;AjI0u8BZ;AiI5u8BU;EACE,yBAAA;EACA,4CAAA;AjI8u8BZ;AiIhv8BU;EACE,yBAAA;EACA,4CAAA;AjIkv8BZ;AiIpv8BU;EACE,yBAAA;EACA,4CAAA;AjIsv8BZ;AiIxv8BU;EACE,yBAAA;EACA,6CAAA;AjI0v8BZ;AiI5v8BU;EACE,yBAAA;EACA,6CAAA;AjI8v8BZ;AiIhw8BU;EACE,yBAAA;EACA,6CAAA;AjIkw8BZ;AiIpw8BU;EACE,yBAAA;EACA,6CAAA;AjIsw8BZ;AiIxw8BU;EACE,yBAAA;EACA,6CAAA;AjI0w8BZ;AiI5w8BU;EACE,yBAAA;EACA,6CAAA;AjI8w8BZ;AiIxw8BI;EACE,gBAAA;EACA,gBAAA;AjI0w8BN;AiItw8BE;EACE,YAAA;EACA,eAAA;AjIww8BJ;;AiIlw8BE;;;EACE,YAAA;EACA,2BAAA;EACA,eAAA;AjIuw8BJ;;AiIlw8BE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AjIqw8BJ;AiIlw8BE;EACE,yBAAA;EACA,kBAAA;EACA,eAAA;AjIow8BJ;AiIlw8BI;EACE,mBAAA;EACA,crDvHM;EqDwHN,cAAA;AjIow8BN;AiIhw8BM;EACE,crD7HI;A5E+38BZ;AiI/v8BM;EACE,wBAAA;AjIiw8BR;AiI3v8BI;EACE,0BAAA;EACA,kBAAA;AjI6v8BN;AiIzv8BM;EACE,UAAA;EACA,SAAA;AjI2v8BR;AiIxv8BM;EACE,SAAA;EACA,UAAA;AjI0v8BR;AiIpv8BI;EACE,YAAA;EACA,iBAAA;EACA,sBAAA;AjIsv8BN;AiIlv8BE;EACE,gBAAA;AjIov8BJ;AiIhv8BI;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,uBAAA;EACA,qBAAA;EACA,WAAA;AjIkv8BN;AiI5u8BU;EACE,yBAAA;EACA,4CAAA;AjI8u8BZ;AiIhv8BU;EACE,yBAAA;EACA,4CAAA;AjIkv8BZ;AiIpv8BU;EACE,yBAAA;EACA,4CAAA;AjIsv8BZ;AiIxv8BU;EACE,yBAAA;EACA,4CAAA;AjI0v8BZ;AiI5v8BU;EACE,yBAAA;EACA,4CAAA;AjI8v8BZ;AiIhw8BU;EACE,yBAAA;EACA,4CAAA;AjIkw8BZ;AiIpw8BU;EACE,yBAAA;EACA,4CAAA;AjIsw8BZ;AiIxw8BU;EACE,yBAAA;EACA,4CAAA;AjI0w8BZ;AiI5w8BU;EACE,yBAAA;EACA,4CAAA;AjI8w8BZ;AiIhx8BU;EACE,yBAAA;EACA,6CAAA;AjIkx8BZ;AiIpx8BU;EACE,yBAAA;EACA,6CAAA;AjIsx8BZ;AiIxx8BU;EACE,yBAAA;EACA,6CAAA;AjI0x8BZ;AiI5x8BU;EACE,yBAAA;EACA,6CAAA;AjI8x8BZ;AiIhy8BU;EACE,yBAAA;EACA,6CAAA;AjIky8BZ;AiIpy8BU;EACE,yBAAA;EACA,6CAAA;AjIsy8BZ;AiI9x8BI;EACE,yBAAA;EACA,kBAAA;EACA,wBAAA;EACA,yBAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;AjIgy8BN;AiI9x8BM;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AjIgy8BR;;AiI1x8BA;EACE;IACE,cAAA;EjI6x8BF;EiI3x8BE;IACE,yBAAA;IACA,eAAA;EjI6x8BJ;AACF;AiIzx8BA;EACE;IACE,oBAAA;EjI2x8BF;EiIzx8BE;IACE,uBAAA;IACA,mBAAA;EjI2x8BJ;AACF;AiIvx8BA;EAEI;IACE,oBAAA;EjIwx8BJ;EiItx8BI;IACE,uBAAA;IACA,mBAAA;IACA,iBAAA;EjIwx8BN;EiIpx8BE;IACE,cAAA;IACA,kBAAA;EjIsx8BJ;EiIpx8BI;IACE,gBAAA;IACA,6BAAA;EjIsx8BN;AACF;AiIjx8BA;EACE;;IAEE,WAAA;EjImx8BF;AACF;AiI1w8BA;;4BAAA;ACrSA;;4BAAA;AAKE;;EACE,WAAA;AlImj9BJ;;AkIhj9BA;EACE,oBAAA;AlImj9BF;AkIlj9BE;EACE,mBAAA;AlIoj9BJ;AkInj9BI;EACE,gBAAA;EACA,oBtDwDK;EsDvDL,kBAAA;EACA,yBAAA;EACA,UAAA;EACA,wBAAA;EACA,2CAAA;EACA,QAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,WtDUE;A5E2i9BR;AkIlj9BM;EACE,mBAAA;EACA,yBAAA;AlIoj9BR;AkIjj9BI;EACE,gBAAA;EACA,mDAAA;AlImj9BN;;AkI9i9BE;EACE,mDAAA;AlIij9BJ;;AkI9i9BA;EACE,oBAAA;AlIij9BF;AkI/i9BI;EACE,mDAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;AlIij9BN;AkI/i9BI;EACE,aAAA;EACA,oEAAA;EACA,mBAAA;EACA,0BAAA;EACA,gBAAA;AlIij9BN;AkI/i9BI;EACE,gCAAA;AlIij9BN;AkI5i9BM;EACE,sCAAA;AlI8i9BR;AkI1i9BE;EACE,ctDrDS;EsDsDT,gBAAA;EACA,eAAA;AlI4i9BJ;AkI1i9BE;EACE,0DAAA;AlI4i9BJ;;AkIzi9BA;EACE,sBtD7CM;A5Eyl9BR;;AkIxi9BI;;EAEE,oCAAA;EACA,yBAAA;AlI2i9BN;AkI1i9BM;;EACE,ctDvEK;A5Eon9Bb;AkIzi9BE;EACE,2CAAA;EACA,gCAAA;AlI2i9BJ;AkI1i9BI;EACE,ctD/EO;A5E2n9Bb;AkIzi9BE;EACE,ctDnFS;A5E8n9Bb;AkIzi9BE;EACE,2CAAA;AlI2i9BJ;AkI1i9BI;EACE,kBAAA;EACA,ctDzFO;A5Eqo9Bb;AkI1i9BI;EACE,ctD5FO;A5Ewo9Bb;AkIzi9BE;EACE,yBtDtGS;A5Eip9Bb;AkIzi9BE;EACE,YAAA;EACA,yBAAA;EACA,gBAAA;AlI2i9BJ;AkI1i9BI;EAEE,kBtDxFE;A5Emo9BR;;AkIri9BI;EAEE,aAAA;AlIui9BN;AkIni9BI;EACE,gBAAA;AlIqi9BN;AkIji9BI;EAEE,mBAAA;EAEA,4BAAA;AlImi9BN;AkIli9BM;EAEE,qBAAA;AlIoi9BR;AkI/h9BI;EACE,WAAA;EACA,YAAA;EAEA,4BAAA;EACA,0BAAA;AlIii9BN;AkI9h9BM;EACE,sCAAA;AlIgi9BR;AkI3h9BI;EAEE,qBAAA;EAEA,4BAAA;AlI6h9BN;AkI1h9BM;EAEE,mBAAA;AlI4h9BR;AkIvh9BI;EAEE,qBAAA;EAEA,4BAAA;AlIyh9BN;AkIth9BM;EAEE,mBAAA;AlIwh9BR;AkInh9BI;EACE,iBAAA;EAEA,qBAAA;EAEA,4BAAA;AlIqh9BN;AkIlh9BM;EACE,cAAA;AlIoh9BR;AkI/g9BI;EAEE,mCAAA;EAEA,4BAAA;AlIih9BN;AkI9g9BM;EAEE,6BAAA;AlIgh9BR;AkI3g9BI;EAEE,iBAAA;EAEA,4BAAA;AlI6g9BN;AkI1g9BM;EAEE,eAAA;AlI4g9BR;AkItg9BI;EAEE,uBAAA;EAEA,4BAAA;AlIwg9BN;AkIrg9BM;EAEE,oBAAA;AlIug9BR;AkIjg9BI;EAEE,mBAAA;EAEA,4BAAA;AlImg9BN;AkIhg9BM;EAEE,gBAAA;AlIkg9BR;AkI7/8BI;EAEE,4BAAA;EAEA,4BAAA;AlI+/8BN;AkI5/8BM;EAEE,iCAAA;AlI8/8BR;AkIz/8BI;EACE,UAAA;EAEA,4BAAA;AlI2/8BN;AkIx/8BM;EACE,YAAA;AlI0/8BR;AkI7+8BE;EACE;IACE,YAAA;ElIu/8BJ;EkIr/8BE;IACE,UAAA;ElIu/8BJ;AACF;AkIl/8BM;EACE,UAAA;EAEA,qBAAA;AlIo/8BR;AkI1+8BE;EACE;IACE,UAAA;ElIi/8BJ;AACF;AkI9+8BI;EACE,kBAAA;AlIg/8BN;AkI/+8BM;EACE,kBAAA;EACA,MAAA;EACA,UAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EAEA,+FAAA;EAEA,wBAAA;AlIi/8BR;AkI9+8BQ;EAEE,sBAAA;AlIg/8BV;AkI1+8BI;EACE,kBAAA;AlI4+8BN;AkI3+8BM;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,mBAAA;EAEA,gCAAA;EACA,UAAA;AlI6+8BR;AkI1+8BQ;EAEE,uBAAA;AlI4+8BV;AkIx98BA;EACE;IACE,UAAA;ElIw+8BF;EkIt+8BA;IACE,UAAA;ElIw+8BF;EkIt+8BA;IACE,WAAA;IACA,YAAA;IACA,UAAA;ElIw+8BF;AACF;AkIt+8BA;EACE,sBAAA;AlIw+8BF;AkIv+8BE;EAEE,sBAAA;AlIw+8BJ;;AkIr+8BA;EACE,kBAAA;AlIw+8BF;;AkIt+8BA,cAAA;AACA;EACE,WAAA;EACA,cAAA;EACA,WAAA;AlIy+8BF;;AkIv+8BA,yBAAA;AAEE;EACE,eAAA;EACA,gBAAA;EACA,sBtDzYI;EsD0YJ,yBAAA;AlIy+8BJ;;AkIp+8BI;EACE,SAAA;EACA,UAAA;AlIu+8BN;;AkIl+8BA;;4BAAA;AC7bA;;4BAAA;AAGA;EACE,kBAAA;AnIq69BF;;AmIl69BE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,6BvDagB;A5Ew59BpB;;AmIj69BA;EAEI;IACE,WAAA;IACA,SAAA;IACA,YAAA;EnIm69BJ;AACF;AmI/59BA;EAEI;IACE,SAAA;IACA,gBAAA;EnIg69BJ;EmI759BA;IACE,gBAAA;EnI+59BF;AACF;AmI559BA;EACG;IACC,+BAAA;EnI859BF;EmI359BE;IACE,OAAA;IACA,cAAA;IACA,SAAA;IACA,UAAA;IACA,QAAA;EnI659BJ;AACF;AmI159BA;;4BAAA;ACpDA;;4BAAA;AAKI;EACE,mBAAA;ApIi99BN;AoI789BE;EACE,gBAAA;EACA,mBAAA;ApI+89BJ;;AoI189BE;EACE,cxDWS;EwDVT,kBAAA;ApI689BJ;;AoIx89BE;EACE,mBAAA;ApI289BJ;AoIx89BE;EACE,yBAAA;EACA,0BAAA;ApI089BJ;;AoIr89BE;EACE,gBAAA;ApIw89BJ;AoIn89BM;EACE,kBAAA;ApIq89BR;AoIn89BQ;EACE,eAAA;EACA,cxDjBG;EwDkBH,mBAAA;ApIq89BV;AoIn89BU;EACE,WxDXJ;A5Eg99BR;AoIh89BM;EACE,aAAA;EACA,cxD5BK;A5E899Bb;AoI779BE;EACE,gBAAA;ApI+79BJ;AoI779BI;EACE,gBAAA;ApI+79BN;AoI579BI;EACE,aAAA;EACA,kBAAA;ApI879BN;AoI379BI;EACE,qBAAA;EACA,2BAAA;ApI679BN;AoI379BM;EACE,mBAAA;ApI679BR;AoI379BQ;EACE,gBAAA;ApI679BV;AoIx79BI;EACE,gBAAA;EACA,mBAAA;ApI079BN;AoIr79BY;EACE,gBAAA;ApIu79Bd;AoIl79BY;EACE,wBAAA;ApIo79Bd;AoI/69BY;EACE,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,oBAAA;ApIi79Bd;;AoIt69BE;EACE,iCAAA;EACA,qBxDzGc;EwD0Gd,uBAAA;EACA,aAAA;ApIy69BJ;;AoIr69BA;EACE,mBAAA;ApIw69BF;AoIr69BI;EACE,uBAAA;ApIu69BN;;AoIl69BA;EACE;IACE,mBAAA;EpIq69BF;AACF;AoIl69BA;EACE;IACE,wBAAA;EpIo69BF;EoIj69BI;IACE,mBAAA;EpIm69BN;EoI/59BE;IACE,gBAAA;IACA,mBAAA;EpIi69BJ;EoI559BE;IACE,wBAAA;EpI859BJ;EoIz59BE;IACE,gBAAA;EpI259BJ;AACF;AoIv59BA;EACE;IACE,wBAAA;EpIy59BF;EoIt59BI;IACE,mBAAA;EpIw59BN;EoIp59BE;IACE,gBAAA;IACA,mBAAA;EpIs59BJ;EoIj59BE;IACE,wBAAA;EpIm59BJ;EoI949BE;IACE,gBAAA;EpIg59BJ;EoI749BE;IACE,cAAA;IACA,kBAAA;EpI+49BJ;EoI349BQ;IACE,WAAA;IACA,eAAA;IACA,cAAA;EpI649BV;EoI149BQ;IACE,cAAA;EpI449BV;EoIt49BU;IACE,cAAA;EpIw49BZ;EoIl49BI;IACE,mBAAA;EpIo49BN;EoIj49BI;IACE,eAAA;EpIm49BN;EoI/39BE;IACE,gBAAA;EpIi49BJ;EoI/39BI;IACE,gBAAA;IACA,mBAAA;EpIi49BN;EoI539BY;IACE,eAAA;EpI839Bd;EoIx39BM;IACE,gBAAA;EpI039BR;EoIp39BA;IACE,mBAAA;EpIs39BF;EoIn39BA;IACE,mBAAA;EpIq39BF;AACF;AoIl39BA;EAGM;IACE,iBAAA;EpIk39BN;AACF;AoI729BA;;4BAAA;ACvRA;;4BAAA;AAKI;EACE,gBAAA;ArIuo+BN;AqIpo+BE;EACE,iBAAA;ArIso+BJ;AqIpo+BE;EACE,UAAA;EACA,gBAAA;ArIso+BJ;AqIro+BI;EACE,kBAAA;ArIuo+BN;AqIto+BM;EACE,0BAAA;ArIwo+BR;AqIpo+BM;EACE,iBAAA;ArIso+BR;AqIro+BQ;EACE,0BAAA;ArIuo+BV;AqIno+BI;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;ArIqo+BN;AqIlo+BM;EACE,czDfK;A5Emp+Bb;AqIjo+BI;EACE,czDnBO;A5Esp+Bb;AqI/n+BI;EACE,mBzDhCQ;EyDiCR,qBzDrBU;A5Esp+BhB;AqI7n+BI;EACE,gBAAA;EACA,gBAAA;ArI+n+BN;;AqI3n+BA;;4BAAA;ACzDA;;4BAAA;AAIE;EACE,mBAAA;AtIyr+BJ;AsIrr+BI;EACE,iBAAA;AtIur+BN;;AsIlr+BA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mB1DfW;E0DgBX,6BAAA;AtIqr+BF;AsIlr+BI;EACE,oDAAA;AtIor+BN;AsI/q+BI;EACE,mDAAA;AtIir+BN;AsI5q+BI;EACE,mDAAA;AtI8q+BN;;AsIzq+BA;EACE,iBAAA;AtI4q+BF;;AsIzq+BA;EACE,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mDAAA;EACA,gBAAA;EACA,6CAAA;AtI4q+BF;AsI3q+BE;EACE,mB1DlDS;A5E+t+Bb;;AsIzq+BA;EACE,uBAAA;EACA,UAAA;EACA,mBAAA;AtI4q+BF;AsI1q+BE;EACE,YAAA;AtI4q+BJ;AsIzq+BE;EACE,gBAAA;AtI2q+BJ;AsIxq+BE;EACE,qBAAA;EACA,YAAA;AtI0q+BJ;AsIxq+BI;EACE,qBAAA;EACA,eAAA;AtI0q+BN;AsIxq+BM;EACE,kBAAA;AtI0q+BR;AsIrq+BE;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;EACA,sB1DrDI;A5E4t+BR;AsIrq+BI;EACE,cAAA;AtIuq+BN;AsIpq+BI;EACE,gBAAA;AtIsq+BN;AsInq+BI;EACE,gBAAA;AtIqq+BN;AsIlq+BI;EACE,eAAA;EACA,eAAA;EACA,gBAAA;AtIoq+BN;AsIjq+BI;EACE,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;AtImq+BN;AsIjq+BM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AtImq+BR;AsIhq+BM;EACE,YAAA;AtIkq+BR;AsI9p+BI;EACE,8BAAA;AtIgq+BN;AsI5p+BM;EACE,aAAA;AtI8p+BR;AsI1p+BI;EACE,kBAAA;AtI4p+BN;AsIzp+BI;EACE,eAAA;EACA,YAAA;AtI2p+BN;;AsItp+BA;EACE,SAAA;EACA,UAAA;AtIyp+BF;;AsItp+BA;EACE;IACE,mBAAA;IACA,iBAAA;EtIyp+BF;EsItp+BE;IACE,uBAAA;EtIwp+BJ;AACF;AsIpp+BA;EAEE;;IAEE,kBAAA;EtIqp+BF;EsIlp+BA;IACE,4BAAA;IACA,6BAAA;EtIop+BF;AACF;AsIjp+BA;EAEI;IACE,0BAAA;EtIkp+BJ;EsI9o+BA;;IAEE,kBAAA;EtIgp+BF;EsI7o+BA;IACE,uBAAA;EtI+o+BF;AACF;AsI5o+BA;;4BAAA;ACtMA;;4BAAA;AAKI;EACE,sBAAA;EACA,kBAAA;AvIq1+BN;AuIp1+BM;EACE,kBAAA;AvIs1+BR;AuIr1+BQ;EACE,mBAAA;EACA,mBAAA;AvIu1+BV;AuIp1+BM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,wBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;AvIs1+BR;AuIr1+BQ;EACE,WAAA;EACA,QAAA;AvIu1+BV;AuIn1+BI;EACE,oBAAA;EACA,kBAAA;EACA,gCAAA;EACA,kBAAA;AvIq1+BN;AuIp1+BM;EACE,mBAAA;EACA,mBAAA;AvIs1+BR;AuIn1+BQ;EACE,WAAA;EACA,YAAA;EACA,wBAAA;EACA,MAAA;EACA,WAAA;AvIq1+BV;AuIp1+BU;EACE,WAAA;EACA,YAAA;AvIs1+BZ;AuIh1+BM;EACE,uBAAA;EACA,kBAAA;AvIk1+BR;AuIj1+BQ;EACE,c3DvDc;A5E04+BxB;AuIj1+BQ;EACE,yB3DjCF;A5Eo3+BR;;AuI50+BA;EAGM;IACE,gBAAA;EvI60+BN;AACF;AuIz0+BA;EAOc;IACE,YAAA;IACA,mBAAA;IACA,gBAAA;IACA,uBAAA;IACA,qBAAA;EvIq0+Bd;AACF;AuI7z+BA;;4BAAA;ACjGA;;4BAAA;AAGA;EACE,eAAA;EACA,yBAAA;EACA,gBAAA;AxIm6+BF;;AwIh6+BE;EACE,aAAA;AxIm6+BJ;AwIj6+BE;EACE,oBAAA;EACA,gBAAA;EACA,gBAAA;AxIm6+BJ;AwI/5+BI;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;AxIi6+BN;;AwI55+BA,YAAA;AAEA;EACE,4BAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,yDAAA;AxI85+BF;;AwI55+BA;EACE,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,SAAA;EACA,QAAA;EACA,4CAAA;AxI+5+BF;AwI95+BE;EACE,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,6BAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AxIg6+BJ;AwI95+BE;EACE,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,gCAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AxIg6+BJ;;AwI35+BE;EACE,UAAA;EACA,2BAAA;AxI85+BJ;AwI55+BE;EACE,kBAAA;EACA,aAAA;AxI85+BJ;AwI75+BI;EACE,gCAAA;EACA,W5DxCE;A5Eu8+BR;AwI95+BM;EACE,W5D1CA;A5E08+BR;;AwIv5+BM;EACE,gCAAA;AxI05+BR;;AwIr5+BA;;4BAAA;AChGA;;4BAAA;AAGA;EACE,mBAAA;AzI2/+BF;;AyIx/+BA;EACE,eAAA;AzI2/+BF;AyIz/+BE;EACE,kBAAA;AzI2/+BJ;AyIv/+BI;EACE,6BAAA;AzIy/+BN;AyIv/+BM;EACE,c7DjBgB;A5E0g/BxB;AyIt/+BM;EACE,yB7DTM;A5Eig/Bd;;AyIh/+BI;EACE,gBAAA;AzIm/+BN;;AyI9++BA;EACE,gBAAA;AzIi/+BF;;AyI9++BA;EACE;IACE,6BAAA;IACA,sBAAA;EzIi/+BF;EyI1++BQ;IACE,mBAAA;EzI4++BV;EyIz++BQ;IACE,kBAAA;EzI2++BV;AACF;AyIp++BA;EACE;IACE,eAAA;EzIs++BF;EyIj++BI;IACE,gBAAA;EzIm++BN;AACF;AyI99+BA;EACE;IACE,eAAA;EzIg++BF;EyI39+BI;IACE,gBAAA;EzI69+BN;AACF;AyIx9+BA;;4BAAA;AC5FA;;4BAAA;AAIA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,oDAAA;EACA,2BAAA;EACA,kBAAA;A1Iwj/BF;A0Itj/BE;EACE,cAAA;EACA,mBAAA;EACA,kBAAA;A1Iwj/BJ;A0Ipj/BI;EACE,cAAA;EACA,kBAAA;EACA,SAAA;A1Isj/BN;A0Ipj/BM;EACE,gBAAA;A1Isj/BR;A0Inj/BM;EACE,YAAA;EACA,sBAAA;A1Iqj/BR;A0Ihj/BE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,cAAA;EACA,sB9DJI;A5Esj/BR;A0I/i/BM;EACE,kBAAA;A1Iij/BR;A0I9i/BM;EACE,eAAA;EACA,qBAAA;A1Igj/BR;A0I7i/BM;EACE,yB9DhCU;E8DiCV,yBAAA;A1I+i/BR;A0I5i/BM;EACE,kBAAA;A1I8i/BR;A0I5i/BQ;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,QAAA;EACA,UAAA;EACA,QAAA;A1I8i/BV;A0I1i/BM;EACE,yBAAA;EACA,yBAAA;A1I4i/BR;A0I1i/BQ;EACE,c9DnDG;A5E+l/Bb;A0Izi/BQ;EAEE,oEAAA;EACA,2BAAA;EACA,yBAAA;A1I0i/BV;A0Iti/BM;EACE,mBAAA;EACA,eAAA;EACA,c9DzEI;A5Ein/BZ;A0Iri/BM;EACE,mBAAA;EACA,kBAAA;A1Iui/BR;A0Ipi/BM;EACE,kBAAA;EACA,SAAA;EACA,QAAA;A1Isi/BR;A0Ini/BI;EACE,kBAAA;EACA,yBAAA;EACA,YAAA;A1Iqi/BN;A0Ipi/BM;EACE,mBAAA;EACA,kBAAA;EACA,sB9D5EA;E8D6EA,0CAAA;EACA,WAAA;EACA,MAAA;EACA,gBAAA;A1Isi/BR;A0Ipi/BU;EACE,kBAAA;A1Isi/BZ;A0Iri/BY;EACE,uBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;A1Iui/Bd;A0Iri/BY;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;EACA,2BAAA;EACA,iDAAA;EACA,UAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;EACA,yBAAA;A1Iui/Bd;A0Iri/BY;EACE,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,MAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,UAAA;EACA,2BAAA;EACA,gDAAA;EACA,yCAAA;A1Iui/Bd;A0Ini/Bc;EACE,UAAA;EACA,mBAAA;EACA,yBAAA;A1Iqi/BhB;A0Ili/Bc;EACE,UAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;A1Ioi/BhB;A0Ihi/Bc;EACE,eAAA;EACA,gBAAA;A1Iki/BhB;A0I5h/BM;EACE,aAAA;A1I8h/BR;A0I3h/BM;EACE,gBAAA;A1I6h/BR;A0I1h/BY;EACE,mBAAA;EACA,mCAAA;EACA,0BAAA;A1I4h/Bd;A0I3h/Bc;EAGE,4CAAA;EACA,mBAAA;A1I2h/BhB;A0Irh/BM;EACE,kBAAA;A1Iuh/BR;A0Ith/BQ;EACE,aAAA;A1Iwh/BV;;A0Ijh/BA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,2BAAA;A1Ioh/BF;A0Ilh/BE;EACE,eAAA;EACA,eAAA;EACA,2BAAA;A1Ioh/BJ;A0Ijh/BM;EACE,eAAA;A1Imh/BR;A0I/g/BI;EACE,eAAA;A1Iih/BN;;A0I3g/BE;EACE,c9D9NQ;A5E4u/BZ;A0I3g/BE;EACE,WAAA;A1I6g/BJ;A0I1g/BE;EACE,SAAA;EACA,WAAA;A1I4g/BJ;;A0Ixg/BA;;4BAAA;AChQA;;4BAAA;AAGA;EACC,oBAAA;EACA,aAAA;A3I8w/BD;A2I7w/BC;EACC,yBAAA;EACA,+CXFgB;AhIix/BlB;A2I7w/BC;EACC,cAAA;EACA,WAAA;EACA,eAAA;EACG,gBAAA;EACA,yBAAA;A3I+w/BL;A2I5w/BE;EACC,gBAAA;A3I8w/BH;;A2I1w/BA;EACC,aAAA;EACA,eAAA;A3I6w/BD;A2I5w/BC;EACC,+CXrBgB;AhImy/BlB;A2I5w/BC;EACC,cAAA;EACA,WAAA;EACA,eAAA;EACG,gBAAA;EACA,yBAAA;A3I8w/BL;A2I3w/BE;EACC,gBAAA;A3I6w/BH;;A2Izw/BA;EACC,gBAAA;A3I4w/BD;;A2I1w/BA;EACC,aAAA;EACA,eAAA;A3I6w/BD;A2I5w/BC;EACC,yBAAA;EACA,+CX5CgB;AhI0z/BlB;A2I5w/BC;EACC,cAAA;EACA,WAAA;EACA,eAAA;EACG,gBAAA;EACA,yBAAA;A3I8w/BL;A2I3w/BE;EACC,gBAAA;A3I6w/BH;;A2Ixw/BC;EACC,gBAAA;EACA,uBAAA;A3I2w/BF;;A2Ivw/BC;EACC,gBAAA;EACA,oCAAA;A3I0w/BF;;A2Itw/BC;EACC,gBAAA;EACA,qCAAA;A3Iyw/BF;;A2Itw/BA;EACC,cAAA;A3Iyw/BD;;A2Ivw/BA;;4BAAA;ACtFA;;4BAAA;AAIE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;A5Ik2/BJ;A4I/1/BE;EACE,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;A5Ii2/BJ;A4Ih2/BI;EACE,YAAA;EACA,gBAAA;EACA,UAAA;A5Ik2/BN;A4I91/BE;EACE,cAAA;EACA,mBAAA;A5Ig2/BJ;A4I51/BI;EACE,WAAA;A5I81/BN;A4I51/BI;EACE,gBAAA;A5I81/BN;A4I11/BE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;A5I41/BJ;;A4Iv1/BE;EACE,iBAAA;EACA,gBAAA;A5I01/BJ;A4Iv1/BI;;EAEE,kBAAA;A5Iy1/BN;A4Ir1/BQ;EACE,sBAAA;EACA,gBAAA;EACA,yBhEzDG;EgE0DH,yBAAA;EACA,gBAAA;EACA,eAAA;A5Iu1/BV;A4Il1/BI;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;A5Io1/BN;A4In1/BM;EACE,WAAA;EACA,eAAA;EACA,6BAAA;EACA,uBAAA;A5Iq1/BR;A4In1/BM;EACE,mBAAA;EACA,6BAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,oBAAA;EACA,YAAA;A5Iq1/BR;A4In1/BM;EACE,6BAAA;EACA,YAAA;A5Iq1/BR;A4Ip1/BQ;EACE,uBAAA;A5Is1/BV;A4Ir1/BU;EACE,mBAAA;EACA,sBAAA;A5Iu1/BZ;A4Ip1/BQ;EACE,sBAAA;A5Is1/BV;A4Ir1/BU;EACE,kBAAA;EACA,uBAAA;A5Iu1/BZ;A4I/0/BQ;EACE,sBAAA;A5Ii1/BV;A4I/0/BU;EACE,gBAAA;A5Ii1/BZ;A4Ih1/BY;EACE,eAAA;EACA,chEjGF;A5Em7/BZ;A4I/0/BY;EACE,eAAA;EACA,kBAAA;A5Ii1/Bd;A4I/0/Bc;EACE,kBAAA;A5Ii1/BhB;A4I/0/BgB;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,yBhEjHN;EgEkHM,WAAA;EACA,QAAA;A5Ii1/BlB;A4I70/BkB;EACE,yBhEnIJ;A5Ek9/BhB;A4I10/BkB;EACE,yBhEtIL;A5Ek9/Bf;;A4Ih0/BA;EAEI;IACE,YAAA;IACA,cAAA;E5Ik0/BJ;AACF;A4I9z/BA;;4BAAA;ACxKA;;4BAAA;AAGA,sBAAA;AAOM;EACE,sCAAA;A7Iq+/BR;A6Ip+/BQ;EAFF;IAGI,eAAA;E7Iu+/BR;AACF;A6Ip+/BQ;EACE,sBAAA;EACA,iDAAA;EACA,kCAAA;A7Is+/BV;;A6Ih//BM;EACE,sCAAA;A7Im//BR;A6Il//BQ;EAFF;IAGI,eAAA;E7Iq//BR;AACF;A6Il//BQ;EACE,sBAAA;EACA,iDAAA;EACA,kCAAA;A7Io//BV;;A6I9//BM;EACE,yBAAA;A7IiggCR;A6IhggCQ;EAFF;IAGI,eAAA;E7ImggCR;AACF;A6IhggCQ;EACE,sBAAA;EACA,oCAAA;EACA,qBAAA;A7IkggCV;;A6I5ggCM;EACE,yBAAA;A7I+ggCR;A6I9ggCQ;EAFF;IAGI,eAAA;E7IihgCR;AACF;A6I9ggCQ;EACE,sBAAA;EACA,oCAAA;EACA,qBAAA;A7IghgCV;;A6I1hgCM;EACE,yBAAA;A7I6hgCR;A6I5hgCQ;EAFF;IAGI,eAAA;E7I+hgCR;AACF;A6I5hgCQ;EACE,sBAAA;EACA,oCAAA;EACA,qBAAA;A7I8hgCV;;A6IxigCM;EACE,yBAAA;A7I2igCR;A6I1igCQ;EAFF;IAGI,eAAA;E7I6igCR;AACF;A6I1igCQ;EACE,sBAAA;EACA,oCAAA;EACA,qBAAA;A7I4igCV;;A6ItjgCM;EACE,yBAAA;A7IyjgCR;A6IxjgCQ;EAFF;IAGI,eAAA;E7I2jgCR;AACF;A6IxjgCQ;EACE,sBAAA;EACA,oCAAA;EACA,qBAAA;A7I0jgCV;;A6IpkgCM;EACE,yBAAA;A7IukgCR;A6ItkgCQ;EAFF;IAGI,eAAA;E7IykgCR;AACF;A6ItkgCQ;EACE,sBAAA;EACA,oCAAA;EACA,qBAAA;A7IwkgCV;;A6IlkgCA;;4BAAA;AC1BA;;4BAAA;AAGA;EACE,iDAAA;EACA,2BAAA;A9IkmgCF;A8IjmgCE;EACE,mBAAA;A9ImmgCJ;A8IlmgCI;EACE,kBAAA;EACA,mBAAA;A9IomgCN;A8IlmgCM;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,yBlEQK;A5E4lgCb;A8IhmgCI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;A9IkmgCN;;A8I7lgCA;EACE,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,0ClE4JsB;EkE3JtB,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;A9IgmgCF;A8I/lgCE;EAEE,WAAA;EACA,sCAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;A9IgmgCJ;;A8I3lgCE;EACE,sCAAA;EACA,aAAA;EACA,YAAA;EACA,SAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;A9I8lgCJ;A8I3lgCE;EACE,yBAAA;EACA,mBAAA;A9I6lgCJ;A8I1lgCE;EACE,WlErCI;EkEsCJ,sCAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;A9I4lgCJ;A8I3lgCI;EACE,kBAAA;A9I6lgCN;A8I3lgCI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;A9I6lgCN;A8I1lgCI;EACE,mBAAA;A9I4lgCN;A8IxlgCE;EACE,gBAAA;EACA,qBAAA;A9I0lgCJ;A8IzlgCI;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;A9I2lgCN;A8IzlgCM;EACE,SAAA;A9I2lgCR;A8IxlgCM;EACE,gBAAA;EACA,2BAAA;EACA,wBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;A9I0lgCR;;A8IplgCA;EAEI;IACE,WAAA;E9IslgCJ;E8IrlgCI;IACE,gBAAA;E9IulgCN;AACF;A8IllgCA;EAGM;IACE,mBAAA;E9IklgCN;E8IhlgCI;IACE,mBAAA;E9IklgCN;E8I3kgCI;IACE,gBAAA;E9I6kgCN;AACF;A8IxkgCA;EAGM;IACE,mBAAA;E9IwkgCN;E8InkgCE;IACE,YAAA;E9IqkgCJ;E8IjkgCA;IACE,iBAAA;IACA,oBAAA;E9ImkgCF;AACF;A8IhkgCA;;4BAAA;ACpLA;;4BAAA;AAIC;EACC,mBAAA;A/IwvgCF;A+IvvgCE;EACC,gBAAA;A/IyvgCH;;A+IrvgCA;EACC,WAAA;A/IwvgCD;;A+ItvgCA;EACC,YAAA;A/IyvgCD;;A+IvvgCA;;4BAAA;AChBC;EACC,YAAA;AhJ6wgCF;AgJ3wgCC;EACC,wBAAA;AhJ6wgCF;AgJ3wgCC;EACC,mBAAA;AhJ6wgCF;AgJzwgCE;EACC,6BAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AhJ2wgCH;AgJxwgCC;EACC,iBAAA;EACA,qBAAA;EACA,YAAA;AhJ0wgCF;AgJzwgCE;EACC,WAAA;AhJ2wgCH;AgJzwgCE;EACC,sBAAA;EACA,YAAA;AhJ2wgCH;AgJvwgCC;EACC,2BAAA;EACA,gBAAA;AhJywgCF;AgJtwgCG;EACC,YAAA;EACA,sBAAA;EACA,iBAAA;AhJwwgCJ;;AgJ1vgCK;EACC,yBAAA;EACA,4CAAA;AhJ6vgCN;AgJ/vgCK;EACC,yBAAA;EACA,4CAAA;AhJiwgCN;AgJnwgCK;EACC,yBAAA;EACA,4CAAA;AhJqwgCN;AgJvwgCK;EACC,yBAAA;EACA,4CAAA;AhJywgCN;AgJ3wgCK;EACC,yBAAA;EACA,4CAAA;AhJ6wgCN;AgJ/wgCK;EACC,yBAAA;EACA,4CAAA;AhJixgCN;AgJnxgCK;EACC,yBAAA;EACA,4CAAA;AhJqxgCN;AgJvxgCK;EACC,yBAAA;EACA,4CAAA;AhJyxgCN;AgJ3xgCK;EACC,yBAAA;EACA,4CAAA;AhJ6xgCN;AgJ/xgCK;EACC,yBAAA;EACA,6CAAA;AhJiygCN;AgJnygCK;EACC,yBAAA;EACA,6CAAA;AhJqygCN;AgJvygCK;EACC,yBAAA;EACA,6CAAA;AhJyygCN;AgJ3ygCK;EACC,yBAAA;EACA,6CAAA;AhJ6ygCN;AgJ/ygCK;EACC,yBAAA;EACA,6CAAA;AhJizgCN;AgJnzgCK;EACC,yBAAA;EACA,6CAAA;AhJqzgCN;;AgJ5ygCC;EACC,oBAAA;AhJ+ygCF;;AgJ5ygCA;EACC,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AhJ+ygCD;AgJ7ygCC;EACC,2BAAA;AhJ+ygCF;AgJ5ygCC;EACC,kBAAA;EACA,WAAA;EACA,SAAA;AhJ8ygCF;AgJ1ygCE;EACC,kBAAA;EACA,gBAAA;AhJ4ygCH;AgJxygCC;EACC,mBAAA;AhJ0ygCF;AgJxygCE;EACC,YAAA;AhJ0ygCH;AgJrygCE;EACC,kBAAA;EACA,YAAA;AhJuygCH;;AgJhygCE;EACC,aAAA;AhJmygCH;AgJhygCE;EACC,aAAA;AhJkygCH;AgJ/xgCE;EACC,WAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;AhJiygCH;;AgJ1xgCE;EACC,kBAAA;AhJ6xgCH;AgJ3xgCG;EACC,YAAA;AhJ6xgCJ;AgJxxgCC;EACC,eAAA;EACA,gBAAA;AhJ0xgCF;AgJvxgCC;EACC,kBAAA;AhJyxgCF;AgJtxgCG;EACC,kBAAA;AhJwxgCJ;AgJrxgCG;EACC,kBAAA;EACA,SAAA;EACA,MAAA;AhJuxgCJ;;AgJ/wgCE;EACC,aAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AhJkxgCH;AgJhxgCG;EACC,aAAA;AhJkxgCJ;;AiJ/7gCA;;4BAAA;AAKI;EACE,oDAAA;AjJg8gCN;AiJ57gCM;EACE,kBAAA;EACA,YAAA;EACA,UAAA;AjJ87gCR;AiJ57gCQ;EACE,qBAAA;EACA,kBAAA;AjJ87gCV;AiJ57gCU;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AjJ87gCZ;AiJ57gCY;EACE,WrESN;EqERM,eAAA;AjJ87gCd;AiJ17gCU;EACE,eAAA;AjJ47gCZ;AiJp7gCM;EACE,eAAA;AjJs7gCR;;AiJ/6gCE;EACE,8BAAA;AjJk7gCJ;AiJ/6gCE;EACE,iBAAA;EACA,mBAAA;EACA,uBAAA;AjJi7gCJ;AiJ/6gCI;EACE,WAAA;AjJi7gCN;AiJ/6gCM;EACE,YAAA;EACA,yBAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;AjJi7gCR;;AiJ36gCA;EACE,mBAAA;EACA,8BAAA;EACA,gBAAA;AjJ86gCF;AiJ36gCI;EACE,gBAAA;AjJ66gCN;AiJ16gCQ;EACE,crEzDG;A5Eq+gCb;;AiJp6gCE;EACE,mBAAA;EACA,cAAA;AjJu6gCJ;;AiJl6gCE;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AjJq6gCJ;AiJn6gCI;EACE,gBAAA;AjJq6gCN;AiJj6gCM;EACE,crEpFK;A5Eu/gCb;AiJh6gCM;EACE,gBAAA;AjJk6gCR;AiJ95gCQ;EACE,2BAAA;AjJg6gCV;;AiJz5gCA;EACE,oBAAA;AjJ45gCF;AiJz5gCI;EACE,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;AjJ25gCN;AiJz5gCM;EACE,eAAA;AjJ25gCR;;AiJr5gCA;EACE,mBAAA;AjJw5gCF;AiJv5gCE;EACE,eAAA;AjJy5gCJ;AiJt5gCI;EACE,WAAA;AjJw5gCN;AiJr5gCI;EACE,gBAAA;AjJu5gCN;AiJl5gCI;EACE,crEtIO;A5E0hhCb;;AiJ74gCI;EACE,eAAA;AjJg5gCN;;AiJ14gCE;EACE,gBAAA;EACA,crEtJS;A5EmihCb;AiJz4gCI;EACE,crE3JO;EqE4JP,kBAAA;AjJ24gCN;AiJv4gCE;EACE,gBAAA;AjJy4gCJ;AiJv4gCI;EACE,eAAA;AjJy4gCN;AiJv4gCM;EACE,YAAA;AjJy4gCR;AiJv4gCQ;EACE,crE1KG;A5EmjhCb;AiJn4gCU;EACE,eAAA;EACA,aAAA;EACA,crEnLC;A5EwjhCb;;AiJ73gCA;EACE,gBAAA;AjJg4gCF;AiJ73gCI;EACE,mBAAA;EACA,crEjMO;EqEkMP,eAAA;AjJ+3gCN;AiJ33gCE;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;AjJ63gCJ;AiJ33gCI;EACE,eAAA;AjJ63gCN;AiJ13gCI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,6BAAA;EACA,+BAAA;AjJ43gCN;AiJz3gCI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,6BAAA;EACA,4BAAA;AjJ23gCN;AiJv3gCE;;EAEE,mBAAA;AjJy3gCJ;AiJt3gCE;EACE,iBAAA;AjJw3gCJ;;AiJn3gCE;EACE,crE9OS;A5EomhCb;AiJn3gCE;EACE,cAAA;AjJq3gCJ;AiJh3gCM;EACE,crEnRgB;A5EqohCxB;AiJ72gCE;EACE,gBAAA;AjJ+2gCJ;AiJ32gCQ;EACE,kBAAA;AjJ62gCV;;AiJn2gCM;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;AjJs2gCR;AiJj2gCE;EACE,kBAAA;EACA,mBAAA;AjJm2gCJ;AiJj2gCI;EACE,gBAAA;AjJm2gCN;AiJh2gCI;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;AjJk2gCN;AiJ/1gCI;EACE,yBAAA;AjJi2gCN;AiJ91gCI;EACE,yBAAA;AjJg2gCN;AiJ71gCI;EACE,yBAAA;AjJ+1gCN;AiJ31gCM;EACE,crEtTK;EqEuTL,kBAAA;AjJ61gCR;AiJz1gCQ;EACE,crE5TG;A5EuphCb;AiJv1gCM;EACE,crEjUK;A5E0phCb;;AiJh1gCM;EACE,iBAAA;AjJm1gCR;AiJ/0gCQ;EACE,crEhVG;A5EiqhCb;;AiJz0gCE;EACE,gBAAA;AjJ40gCJ;AiJx0gCI;EACE,crE9VO;A5EwqhCb;;AiJp0gCE;EACE,iBAAA;EACA,mBAAA;AjJu0gCJ;AiJl0gCM;EACE,qBAAA;EACA,kBAAA;EACA,mBAAA;AjJo0gCR;AiJl0gCQ;EACE,eAAA;AjJo0gCV;AiJh0gCU;EACE,eAAA;AjJk0gCZ;;AiJxzgCI;EACE,gBAAA;AjJ2zgCN;AiJxzgCI;EACE,kBAAA;AjJ0zgCN;AiJvzgCQ;EACE,WAAA;EACA,YAAA;AjJyzgCV;;AiJlzgCA;;4BAAA;AC9aA;;4BAAA;AAIE;EACE,aAAA;AlJquhCJ;;AkJluhCA;EACE,mBAAA;AlJquhCF;AkJnuhCI;EACE,iBAAA;AlJquhCN;;AkJ9thCM;EACE,gBAAA;AlJiuhCR;AkJhuhCQ;EACE,kBAAA;AlJkuhCV;AkJhuhCQ;EACE,mBAAA;AlJkuhCV;AkJhuhCQ;EACE,WAAA;EACA,YAAA;EACA,ctEFE;A5EouhCZ;AkJ9thCQ;EACE,iBAAA;AlJguhCV;AkJ5thCQ;EACE,oBAAA;AlJ8thCV;;AkJvthCA;EAKU;IACE,gBAAA;ElJsthCV;EkJpthCQ;IACE,eAAA;ElJsthCV;AACF;AkJhthCA;EACE;IACE,yBAAA;IACA,oBAAA;ElJkthCF;EkJjthCE;IACE,mBAAA;ElJmthCJ;EkJ5shCQ;IACE,kBAAA;ElJ8shCV;EkJ1shCQ;IACE,iBAAA;ElJ4shCV;EkJxshCQ;IACE,oBAAA;ElJ0shCV;AACF;AkJpshCA;EAKU;IACE,gBAAA;ElJkshCV;AACF;AkJ5rhCA;EAKU;IACE,kBAAA;ElJ0rhCV;EkJtrhCQ;IACE,iBAAA;ElJwrhCV;EkJprhCQ;IACE,oBAAA;ElJsrhCV;AACF;AkJhrhCA;;4BAAA;ACjIA;;4BAAA;AAIC;EACC,mBAAA;AnJqzhCF;AmJnzhCE;EACC,gBAAA;AnJqzhCH;AmJlzhCE;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,+EvE8BgB;EuE7BhB,mBAAA;EACA,UAAA;AnJozhCH;AmJlzhCG;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,cAAA;AnJozhCJ;AmJlzhCI;;;EAGC,WvEKG;A5E+yhCR;AmJ/yhCI;EACC,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;AnJizhCL;AmJ5yhCI;EACC,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;AnJ8yhCL;AmJzyhCI;EACC,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;AnJ2yhCL;AmJryhCG;EACC,gBAAA;EACA,mBAAA;AnJuyhCJ;AmJryhCI;EACC,mBAAA;EACA,cvE3DQ;A5Ek2hCb;AmJnyhCG;EACC,UAAA;AnJqyhCJ;;AmJ9xhCC;EACC,mBAAA;AnJiyhCF;AmJ/xhCE;EACC,gBAAA;AnJiyhCH;AmJ9xhCE;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,UAAA;AnJgyhCH;AmJ9xhCG;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,cAAA;AnJgyhCJ;AmJ9xhCI;;;EAGC,WvE3FG;A5E23hCR;AmJ3xhCI;EACC,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;AnJ6xhCL;AmJxxhCI;EACC,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;AnJ0xhCL;AmJrxhCI;EACC,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;AnJuxhCL;AmJjxhCG;EACC,mBAAA;AnJmxhCJ;AmJjxhCI;EACC,mBAAA;EACA,cvE1JQ;A5E66hCb;AmJ/whCG;EACC,UAAA;AnJixhCJ;;AmJ3whCA;EACC,UAAA;EACA,iBAAA;EACA,cAAA;AnJ8whCD;;AmJ3whCA;EACC,WAAA;EACA,cAAA;EACA,WAAA;AnJ8whCD;;AmJ3whCA;EAEC;IACC,oBAAA;IACA,iBAAA;EnJ6whCA;EmJ1whCD;IACC,aAAA;EnJ4whCA;EmJ1whCA;IACC,aAAA;EnJ4whCD;EmJzwhCA;IACC,gBAAA;EnJ2whCD;EmJvwhCC;IACC,YAAA;EnJywhCF;EmJvwhCE;IACC,UAAA;IACA,WAAA;IACA,iBAAA;EnJywhCH;EmJrwhCC;IACC,SAAA;IACA,UAAA;IACA,WAAA;IACA,yBAAA;IACA,2BvElOU;E5Ey+hCZ;EmJlwhCD;IACC,WAAA;IACA,YAAA;IACA,SAAA;IACA,kBAAA;EnJowhCA;EmJlwhCA;IACC,eAAA;IACA,QAAA;IACA,SAAA;IACA,YAAA;EnJowhCD;EmJ9vhCC;IACC,kBAAA;EnJgwhCF;EmJ7vhCC;IACC,mBAAA;IACA,2BAAA;EnJ+vhCF;EmJ1vhCC;IACC,kBAAA;EnJ4vhCF;EmJzvhCC;IACC,mBAAA;IACA,2BAAA;EnJ2vhCF;EmJvvhCA;IACC,mCAAA;EnJyvhCD;EmJrvhCD;IACC,cAAA;IACA,cAAA;IACA,UAAA;EnJuvhCA;EmJrvhCA;IACC,kBAAA;IACA,WAAA;IACA,UAAA;IACA,QAAA;IACA,eAAA;EnJuvhCD;EmJnvhCD;IACC,SAAA;IACA,UAAA;IACA,yBAAA;IACA,uBvE1QM;E5E+/hCN;AACF;AmJlvhCA;EACC,kBAAA;EACA,cAAA;AnJovhCD;;AmJjvhCA;EACC,WAAA;EACA,kBAAA;EACA,MAAA;EACA,iBAAA;EACA,YAAA;EACA,UAAA;EACA,mBvEnTa;EuEoTb,WAAA;AnJovhCD;;AmJjvhCA;EACC,kBAAA;EACA,cAAA;AnJovhCD;AmJlvhCC;EACC,WAAA;EACA,cAAA;EACA,WAAA;AnJovhCF;AmJjvhCC;EACC,aAAA;AnJmvhCF;AmJhvhCC;EACC,gBAAA;AnJkvhCF;;AmJ9uhCA;EACC,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;EACA,mCAAA;EACA,kBAAA;EACA,MAAA;EACA,kBAAA;AnJivhCD;AmJ/uhCC;EACC,cAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,WvEpUM;A5EqjiCR;AmJzthCA;EACC;IACC,UAAA;IACA,qBAAA;EnJ4uhCA;EmJzuhCD;IACC,UAAA;IACA,qBAAA;EnJ2uhCA;EmJxuhCD;IACC,mBAAA;EnJ0uhCA;AACF;AmJvuhCA;EACC,kBAAA;EACA,mBvE1XO;EuE2XP,kBAAA;EACA,aAAA;EACA,+CAAA;AnJyuhCD;AmJvuhCC;EACC,gBAAA;AnJyuhCF;AmJtuhCC;EACC,gBAAA;AnJwuhCF;AmJruhCC;EACC,WAAA;EACA,cAAA;EACA,WAAA;AnJuuhCF;AmJpuhCC;EACC,WAAA;AnJsuhCF;AmJnuhCC;EACC,eAAA;EACA,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;AnJquhCF;;AmJjuhCA;EACC,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,6BAAA;EACA,8BAAA;AnJouhCD;;AmJjuhCA;EAEE;IACC,eAAA;IACA,iBAAA;EnJmuhCD;AACF;AmJzshCA;EACC;IACC,UAAA;IACA,6BAAA;EnJ2thCA;EmJxthCD;IACC,UAAA;IACA,2BAAA;EnJ0thCA;EmJvthCD;IACC,wBAAA;EnJythCA;AACF;AmJhshCA;EACC;IACC,UAAA;IACA,4BAAA;EnJkthCA;EmJ/shCD;IACC,UAAA;IACA,4BAAA;EnJithCA;EmJ9shCD;IACC,wBAAA;EnJgthCA;AACF;AmJ7shCA;EAEE;IACC,UAAA;IACA,YAAA;IACA,WAAA;IACA,kBAAA;IACA,SAAA;IACA,UAAA;EnJ8shCD;EmJ5shCC;IACC,eAAA;IACA,SAAA;IACA,UAAA;IACA,YAAA;EnJ8shCF;EmJxshCA;IACC,WAAA;EnJ0shCD;EmJtshCC;IACC,WAAA;IACA,YAAA;IACA,WAAA;IACA,QAAA;IACA,UAAA;EnJwshCF;EmJtshCE;IACC,eAAA;IACA,SAAA;IACA,SAAA;IACA,YAAA;EnJwshCH;AACF;AmJlshCA;EACC;IACC,aAAA;EnJoshCA;EmJlshCA;IACC,eAAA;EnJoshCD;AACF;AmJhshCA;;4BAAA;AC1kBA;;4BAAA;AAYA;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,WAXsB;EAYtB,yEAAA;EACA,4EAAA;EACA,kCAAA;EACA,cxENY;EwEOZ,UAAA;EACA,gBAAA;EACA,YAAA;ApJswiCF;AoJrwiCE;EACE,UAAA;ApJuwiCJ;AoJrwiCE;EACE,WAAA;EACA,kBAAA;EACA,yBxETQ;EwEUR,WAAA;EACA,WAAA;EACA,QAAA;EACA,OAAA;ApJuwiCJ;AoJrwiCE;EACE,cAAA;EACA,YAAA;EACA,WAAA;EACA,iBAlCuB;ApJyyiC3B;AoJrwiCE;EAGE,iCAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBxEhBI;A5EuxiCR;AoJtwiCI;EAGE,iCAAA;EACA,wBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,cxE3CO;EwE4CP,8BAAA;EACA,eAAA;ApJwwiCN;AoJtwiCI;EAGE,iCAAA;EAGA,2BAAA;EACA,wBAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,cxEpEQ;EwEqER,UAAA;EACA,gBAAA;ApJwwiCN;AoJvwiCM;EAhBF;IAiBI,uBAAA;EpJ0wiCN;AACF;AoJvwiCE;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;ApJywiCJ;AoJxwiCI;EACE,mBAAA;EACA,kBAAA;ApJ0wiCN;AoJxwiCQ;EACE,kCAAA;EACA,sCAAA;EACA,+CAAA;ApJ0wiCV;AoJzwiCU;EACE,cxEpFC;A5E+1iCb;AoJzwiCU;EACE,cxEvFC;EwEwFD,UAAA;EACA,uBAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;ApJ2wiCZ;AoJrwiCQ;EACE,YAAA;ApJuwiCV;AoJrwiCU;EACE,cxE9GE;A5Eq3iCd;AoJjwiCQ;EACE,qBxE7GG;EwE8GH,yBxE9GG;A5Ei3iCb;AoJlwiCU;EACE,cxEhHC;A5Eo3iCb;AoJ9viCQ;EACE,cxEvHG;EwEwHH,UAAA;EACA,sBxExGF;EwEyGE,yBAAA;EACA,aAAA;EACA,kBAAA;ApJgwiCV;AoJ1viCE;EACE,kBAAA;EACA,cAAA;EACA,UAAA;EACA,SAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,sCAAA;ApJ4viCJ;AoJ1viCI;EAVF;IAWI,SA1JuB;EpJu5iC3B;AACF;AoJ5viCI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,0CAAA;ApJ8viCN;AoJ5viCI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,6CAAA;ApJ8viCN;;AoJ1viCA;;4BAAA;AC7LA;;4BAAA;AAKI;EACE,eAAA;EACA,czEqBM;A5Es6iCZ;AqJx7iCE;EACE,+BAAA;ArJ07iCJ;AqJx7iCE;EACE,cAAA;ArJ07iCJ;AqJv7iCI;EACE,oDAAA;EACA,sBAAA;EACA,wBAAA;EACA,aAAA;ArJy7iCN;AqJv7iCI;EACE,kBAAA;EACA,SAAA;ArJy7iCN;AqJx7iCM;EACE,iBAAA;ArJ07iCR;AqJz7iCQ;EACE,YAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;ArJ27iCV;AqJx7iCM;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,sBzERA;EyESA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,+CAAA;ArJ07iCR;AqJz7iCQ;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;ArJ27iCV;AqJv7iCI;EACE,aAAA;ArJy7iCN;AqJx7iCM;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,czE7CK;EyE8CL,sBAAA;ArJ07iCR;AqJz7iCQ;EACE,czErES;EyEsET,eAAA;EACA,yBAAA;EACA,gBAAA;ArJ27iCV;AqJx7iCM;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,czEpDI;EyEqDJ,uBAAA;EACA,yBAAA;ArJ07iCR;AqJt7iCE;EACE,gBAAA;ArJw7iCJ;AqJv7iCI;EACE,eAAA;EACA,czEzFa;EyE0Fb,8BAAA;EACA,gBAAA;ArJy7iCN;AqJv7iCI;EACE,czEnEM;A5E4/iCZ;AqJt7iCE;EACE,aAAA;ArJw7iCJ;AqJv7iCI;EACE,gBAAA;ArJy7iCN;AqJv7iCI;EACE,eAAA;EACA,czExGa;EyEyGb,SAAA;EACA,gBAAA;ArJy7iCN;AqJv7iCI;EACE,iBAAA;EACA,eAAA;EACA,czE3FM;EyE4FN,gBAAA;ArJy7iCN;AqJt7iCM;EACE,WAAA;ArJw7iCR;AqJn7iCI;EACE,czEtGM;A5E2hjCZ;AqJp7iCM;EACE,czEhHO;A5EsijCf;AqJn7iCI;EACE,8BAAA;ArJq7iCN;AqJj7iCI;EACE,eAAA;EACA,czE3GM;EyE4GN,eAAA;EACA,eAAA;ArJm7iCN;AqJl7iCM;EACE,2BAAA;ArJo7iCR;;AqJ36iCI;EACE,mBAAA;EACA,mBAAA;ArJ86iCN;AqJ76iCM;EACE,iBAAA;ArJ+6iCR;AqJ96iCQ;EACE,czExJc;A5EwkjCxB;AqJ96iCQ;EACE,kBAAA;EACA,kBAAA;ArJg7iCV;;AqJz6iCA;;4BAAA;ACrKA;;4BAAA;AAOI;EACC,c1EaO;E0EZP,eAAA;AtJgljCL;;AsJzkjCA;;4BAAA;AChBA;;4BAAA;AAGA;EACE,sB3EmCM;E2ElCN,4C3EkMkB;E2EjMlB,aAAA;EACA,SAAA;EACA,OAAA;EACA,kB3E6PsB;E2E5PtB,gBAAA;AvJ+ljCF;AuJ9ljCE;EACE,yB3EXe;A5E2mjCnB;AuJ/ljCI;EACE,W3EyBE;A5EwkjCR;;AuJ7ljCA;EACE,yBAAA;EACA,eAAA;AvJgmjCF;;AuJ9ljCA;;4BAAA;ACtBA;;4BAAA;AAGA;EACE,oBAAA;AxJ0njCF;AwJxnjCE;EACE,cAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,sB5E2BI;A5E+ljCR;;AwJtnjCA;EACE,oBAAA;AxJynjCF;AwJvnjCE;EACE,eAAA;EACA,iBAAA;EACA,2CAAA;EACA,mBAAA;EACA,2CAAA;AxJynjCJ;;AwJrnjCA;;4BAAA;AC5BA,yCAAA;AAEE;EACE,mBAAA;AzJspjCJ;AyJrpjCI;EACE,yBAAA;AzJupjCN;AyJppjCE;EACE,gBAAA;AzJspjCJ;AyJrpjCI;EAFF;IAGI,YAAA;IACA,gBAAA;IACA,qBAAA;IACA,uBAAA;IACA,mBAAA;EzJwpjCJ;AACF;AyJvpjCI;EATF;IAUI,YAAA;EzJ0pjCJ;AACF;AyJzpjCI;EAZF;IAaI,WAAA;EzJ4pjCJ;AACF;AyJ1pjCE;EAvBF;IAwBI,aAAA;EzJ6pjCF;AACF;AyJ5pjCE;EACE,iBAAA;EACA,YAAA;AzJ8pjCJ;AyJ5pjCE;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;AzJ8pjCJ;;AyJ3pjCA,yCAAA;AAEA,uCAAA;AAKM;;EACE,kBAAA;EACA,iCAAA;AzJ0pjCR;;AyJrpjCA;EACE,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,UAAA;AzJwpjCF;;AyJrpjCA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;AzJwpjCF;AyJtpjCE;EACE,W7EoO2B;E6EnO3B,Y7EmO2B;A5Eq7iC/B;AyJrpjCE;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,0CAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;AzJupjCJ;AyJnpjCI;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;AzJqpjCN;AyJlpjCI;EACE,sCAAA;EACA,uCAAA;AzJopjCN;;AyJ/ojCA;EACE,eAAA;EACA,kBAAA;AzJkpjCF;AyJzojCA;EACE,SAAA;EACA,kBAAA;EACA,UAAA;EACA,sB7E1EM;E6E2EN,2BAAA;AzJ2ojCF;AyJtojCM;EACE,wBAAA;AzJwojCR;AyJtojCQ;;EAEE,yBAAA;AzJwojCV;;AyJjojCA,sCAAA;AAEA,oCAAA;AAIM;EACE,gBAAA;EACA,WAAA;AzJgojCR;AyJ7njCM;EACE,eAAA;AzJ+njCR;AyJ1njCE;EACE,aAAA;AzJ4njCJ;AyJznjCE;EACE,aAAA;AzJ2njCJ;AyJtnjCM;EACE,kBAAA;EACA,qBAAA;EACA,c7E9JqB;A5EsxjC7B;AyJjnjCM;EACE,uBAAA;EACA,gB7EqDa;A5E8jjCrB;AyJjnjCQ;EACE,0BAAA;EACA,gB7EiDW;A5EkkjCrB;;AyJ5mjCA,kCAAA;AAEA;;4BAAA;ACvLA;;4BAAA;AAIE;;EAEE,gBAAA;A1JuyjCJ;A0JpyjCI;EACE,aAAA;EACA,mBAAA;A1JsyjCN;;A0JhyjCI;EACE,kBAAA;A1JmyjCN;A0JlyjCM;EACE,sCAAA;A1JoyjCR;A0JhyjCM;EACE,UAAA;EACA,QAAA;A1JkyjCR;A0J/xjCI;EACE,UAAA;EACA,QAAA;A1JiyjCN;;A0J7xjCA;EACE,aAAA;A1JgyjCF;A0J/xjCE;EACE,cAAA;A1JiyjCJ;A0JhyjCI;EACE,c9EtCkB;A5Ew0jCxB;A0JjyjCM;EACE,2BAAA;A1JmyjCR;A0JhyjCI;EACE,gBAAA;A1JkyjCN;;A0J1xjCQ;EAEE,WAAA;EACA,WAAA;A1J4xjCV;;A0JtxjCA;EACE,8BAAA;A1JyxjCF;;A0JvxjCA;EACE,6BAAA;A1J0xjCF;;A0JvxjCE;EACE,gBAAA;A1J0xjCJ;;A0JvxjCA;;4BAAA;AC1EA;;4BAAA;AAKI;EACE,sCAAA;EACA,kBAAA;EACA,4BAAA;EACA,cAAA;A3Jq2jCN;A2Jp2jCM;EACE,c/EHQ;A5Ey2jChB;A2Jp2jCM;EACE,aAAA;A3Js2jCR;A2Jl2jCM;EACE,iBAAA;EACA,eAAA;A3Jo2jCR;A2Jl2jCM;EACE,uBAAA;A3Jo2jCR;A2J/1jCE;EACE,gBAAA;A3Ji2jCJ;A2J91jCE;EACE,gBAAA;EACA,yBAAA;A3Jg2jCJ;A2J31jCM;EACE,wBAAA;A3J61jCR;A2Jz1jCQ;EACE,eAAA;EACA,kBAAA;A3J21jCV;A2Jp1jCI;EACE,gBAAA;A3Js1jCN;A2Jl1jCE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;A3Jo1jCJ;A2Jl1jCI;EACE,cAAA;EACA,kBAAA;EACA,cAAA;A3Jo1jCN;A2Jj1jCI;EACE,c/E9DU;A5Ei5jChB;A2Jh1jCI;EACE,gBAAA;A3Jk1jCN;A2J90jCE;EACE,iBAAA;EACA,yBAAA;A3Jg1jCJ;A2J90jCI;EACE,WAAA;A3Jg1jCN;A2J30jCI;EACE,mBAAA;A3J60jCN;A2Jz0jCE;EACE,yBAAA;EACA,gBAAA;EACA,cAAA;A3J20jCJ;A2Jv0jCI;EACE,qBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;A3Jy0jCN;A2Jv0jCM;EACE,wEAAA;EACA,iBAAA;EACA,gBAAA;A3Jy0jCR;A2Jt0jCM;EACE,c/ErGQ;A5E66jChB;A2Jv0jCQ;EACE,iBAAA;A3Jy0jCV;A2Jl0jCI;EACE,gBAAA;A3Jo0jCN;;A2J/zjCA;EACE,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;A3Jk0jCF;A2Jh0jCE;EACE,0CAAA;A3Jk0jCJ;A2Jh0jCI;EACE,YAAA;EACA,sBAAA;EACA,YAAA;A3Jk0jCN;A2Jh0jCM;EACE,0CAAA;EACA,2BAAA;EACA,UAAA;A3Jk0jCR;A2J9zjCI;EAEE,0CAAA;A3J+zjCN;;A2J1zjCA;;4BAAA;AC/JA;;4BAAA;AAGA;EACE,eAAA;A5J+9jCF;;A4J39jCE;EACE,yBAAA;A5J89jCJ;A4Jz9jCM;EACE,gBAAA;A5J29jCR;A4Jv9jCI;EACE,yBAAA;A5Jy9jCN;A4Jt9jCI;EACE,iBAAA;EACA,cAAA;A5Jw9jCN;A4Jt9jCM;EACE,gBAAA;EACA,eAAA;A5Jw9jCR;A4Jp9jCY;EACE,YAAA;A5Js9jCd;A4Jj9jCQ;EACE,yBAAA;EACA,eAAA;A5Jm9jCV;A4Jh9jCY;EACE,0BAAA;A5Jk9jCd;A4J18jCE;EACE,mBAAA;A5J48jCJ;;A4Jv8jCE;EACE,UAAA;A5J08jCJ;;A4Jt8jCA;EACE,sBAAA;A5Jy8jCF;;A4Jr8jCE;EACE,2BAAA;EACA,gCAAA;EACA,uBAAA;EACA,YAAA;A5Jw8jCJ;A4Jr8jCE;EACE,kBAAA;A5Ju8jCJ;A4Jp8jCE;EACE,kCAAA;EACA,2BAAA;A5Js8jCJ;A4Jn8jCE;EACE,oCAAA;EACA,6BAAA;A5Jq8jCJ;A4Jl8jCE;EACE,qBhFjFY;EgFkFZ,chFlFY;A5EshkChB;A4Jj8jCE;EACE,qBhFrFS;EgFsFT,chFtFS;A5EyhkCb;A4Jh8jCE;EACE,qBhFzFY;EgF0FZ,chF1FY;A5E4hkChB;A4J/7jCE;EACE,qBhF7FW;EgF8FX,chF9FW;A5E+hkCf;A4J97jCE;EACE,qBhFzFS;EgF0FT,chF1FS;A5E0hkCb;A4J77jCE;EACE,sCAAA;EACA,WhF9EI;A5E6gkCR;A4J57jCE;EACE,wCAAA;EACA,WhFnFI;A5EihkCR;A4J37jCE;EACE,yBhFpHY;EgFqHZ,WhFxFI;A5EqhkCR;A4J17jCE;EACE,yBhFxHS;EgFyHT,WhF7FI;A5EyhkCR;A4Jz7jCE;EACE,yBhF5HY;EgF6HZ,WhFlGI;A5E6hkCR;A4Jx7jCE;EACE,yBhFhIW;EgFiIX,WhFvGI;A5EiikCR;A4Jv7jCE;EACE,yBhF5HS;EgF6HT,WhF5GI;A5EqikCR;;A4Jh7jCE;EACE,6BAAA;A5Jm7jCJ;A4Jj7jCI;EACE,aAAA;EACA,YAAA;A5Jm7jCN;;A4J56jCI;EACE,2BAAA;EACA,wBAAA;EACA,iDAAA;EACA,6CAAA;EACA,WhFtIE;EgFuIF,4BAAA;A5J+6jCN;A4J56jCI;EACE,sBAAA;EACA,YAAA;EACA,mBAAA;A5J86jCN;A4J16jCE;EACE,oCAAA;EACA,yBAAA;A5J46jCJ;A4Jz6jCE;EACE,iDAAA;EACA,sBAAA;A5J26jCJ;;A4Jr6jCI;EACE,oBAAA;EACA,sBAAA;A5Jw6jCN;A4Jn6jCI;EACE,2BAAA;EACA,wBAAA;EACA,iDAAA;EACA,6CAAA;EACA,WhF1KE;EgF2KF,4BAAA;A5Jq6jCN;A4Jl6jCI;EACE,sBAAA;EACA,YAAA;EACA,mBAAA;A5Jo6jCN;A4Jh6jCE;EACE,oCAAA;EACA,yBAAA;A5Jk6jCJ;A4J/5jCE;EACE,iDAAA;EACA,sBAAA;A5Ji6jCJ;;A4J75jCA;;4BAAA;ACvOA;;4BAAA;AAGA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;EACA,4CAAA;A7J0okCF;;A6JvokCA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,mBAAA;EACA,gCAAA;EACA,UAAA;EACA,kBAAA;A7J0okCF;A6JzokCE;EACE,WAAA;EACA,WAAA;A7J2okCJ;;A6JvokCA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,kCAAA;EACA,UAAA;EACA,UAAA;EACA,uBAAA;A7J0okCF;A6JzokCE;EACE,WAAA;EACA,WAAA;A7J2okCJ;;A6JvokCA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;A7J0okCF;;A6JvokCA;EACE,4CjFoNmB;EiFnNnB,2BAAA;EACA,UAAA;EACA,kBAAA;EACA,OAAA;A7J0okCF;;A6JvokCA;EACE,UAAA;EACA,0BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;A7J0okCF;A6JxokCE;EACE,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,6BAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;A7J0okCJ;A6JvokCE;EACE,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,gCAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;A7JyokCJ;;A6JtokCA;EACE,kBAAA;A7JyokCF;A6JxokCE;EACE,gBAAA;EACA,ejFsKmB;EiFrKnB,MjFsKc;EiFrKd,UjF6LkB;EiF5LlB,gBjFyHiB;EiFxHjB,sBjFhEI;EiFiEJ,+CjFoKmB;A5Es+jCvB;A6JzokCI;EACE,WAAA;EACA,mBAAA;EACA,kBjFuLmB;EiFtLnB,kBAAA;A7J2okCN;A6J1okCM;EALF;IAMI,kBAAA;E7J6okCN;AACF;A6J5okCM;EACE,sBjF3EA;EiF4EA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,QAAA;EACA,mBAAA;EACA,yBAAA;A7J8okCR;A6J7okCQ;EACE,YAAA;EACA,WAAA;EACA,kCAAA;EACA,mBAAA;EACA,yBAAA;A7J+okCV;A6J7okCQ;EACE,iBAAA;EACA,kBAAA;EACA,sBAAA;A7J+okCV;A6J7okCU;EACE,wBAAA;A7J+okCZ;A6J1okCU;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,cjF5HA;EiF6HA,eAAA;A7J4okCZ;A6JzokCU;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,cjFtIA;EiFuIA,wBAAA;A7J2okCZ;A6JtokCM;EACE,yBAAA;A7JwokCR;A6JpokCY;EACE,sBjFgIkB;EiF/HlB,WjF6HiB;EiF5HjB,YjF4HiB;EiF3HjB,6BAAA;EACA,UAAA;A7JsokCd;A6JrokCc;EACE,cjF5KG;A5EmzkCnB;A6JlokCgB;EACE,UjF5IV;A5EgxkCR;A6J1nkCc;EACE,eAAA;EACA,kBAAA;A7J4nkChB;A6J1nkCgB;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;A7J4nkClB;A6J1nkCkB;EACE,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,mCAAA;A7J4nkCpB;A6JvnkCc;EACE,eAAA;A7JynkChB;A6JrnkCgB;EACE,iBAAA;A7JunkClB;A6JrnkCkB;EACE,gBAAA;A7JunkCpB;A6JpnkCkB;EACE,eAAA;EACA,cAAA;EACA,4BAAA;A7JsnkCpB;A6J9mkCQ;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;A7JgnkCV;A6J9mkCU;EACE,iBAAA;EACA,qBAAA;EACA,kBAAA;A7JgnkCZ;A6J9mkCY;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;A7JgnkCd;A6J5mkCc;EACE,aAAA;EACA,YAAA;EACA,YAAA;A7J8mkChB;A6J5mkCgB;EAEE,aAAA;EACA,WAAA;A7J6mkClB;A6J1mkCgB;EACE,cAAA;A7J4mkClB;A6J1mkCkB;EACE,eAAA;EACA,cjFrPP;A5Ei2kCb;A6J1mkCoB;EACE,iBAAA;EACA,eAAA;EACA,cjF1PT;A5Es2kCb;A6JpmkCU;EACE,eAAA;A7JsmkCZ;A6JlmkCQ;EACE,uBAAA;EACA,4BAAA;EACA,wCAAA;EACA,iBAAA;A7JomkCV;A6JnmkCU;EAEE,aAAA;A7JomkCZ;A6JhmkCY;EACE,kBAAA;A7JkmkCd;A6JjmkCc;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;A7JmmkChB;A6JjmkCc;EACE,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;A7JmmkChB;A6J7lkCQ;EACE,YAAA;EACA,aAAA;EACA,6BAAA;A7J+lkCV;A6J7lkCU;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;EACA,4BAAA;A7J+lkCZ;A6J7lkCY;;EAEE,kBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,4CAAA;EACA,YAAA;EACA,aAAA;A7J+lkCd;A6J7lkCc;;EACE,6BjF5TI;EiF6TJ,cjF9UA;EiF+UA,YAAA;A7JgmkChB;A6J9lkCgB;;EACE,oBjFjUE;A5Ek6kCpB;A6J5lkCY;EACE,sBjFzTN;EiF0TM,gBAAA;A7J8lkCd;A6J5lkCc;EACE,ejF9UH;EiF+UG,yBAAA;A7J8lkChB;A6J5lkCgB;EACE,4BAAA;EACA,yBAAA;A7J8lkClB;A6JzlkCY;EACE,sBjFxUN;EiFyUM,0BAAA;A7J2lkCd;A6JxlkCgB;EACE,gBAAA;EACA,wBAAA;A7J0lkClB;A6JtlkCc;EACE,WAAA;A7JwlkChB;A6JplkCgB;EACE,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,sBAAA;A7JslkClB;A6JrlkCkB;EACE,aAAA;A7JulkCpB;A6JjlkCY;EACE,0BAAA;A7JmlkCd;A6JjlkCc;EACE,UAAA;A7JmlkChB;A6J7kkCQ;EACE,YAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;A7J+kkCV;A6J9kkCU;EACE,aAAA;EACA,kBAAA;EACA,iDAAA;A7JglkCZ;A6J9kkCU;EACE,aAAA;A7JglkCZ;A6J9kkCU;EACE,aAAA;A7JglkCZ;A6J/kkCY;EACE,eAAA;EACA,qBAAA;EACA,gBAAA;A7JilkCd;A6J/kkCY;EACE,0BAAA;EACA,yBAAA;EACA,qBAAA;EACA,+BAAA;A7JilkCd;A6J9kkCY;EACE,gBAAA;A7JglkCd;A6J7kkCY;EACE,oBAAA;A7J+kkCd;A6J5kkCY;EACE,kBAAA;A7J8kkCd;A6J5kkCc;EACE,WAAA;EACA,kBAAA;A7J8kkChB;A6J3kkCc;EACE,OAAA;A7J6kkChB;A6JzkkCgB;EACE,qBAAA;EACA,mBAAA;EACA,qBAAA;A7J2kkClB;A6JxkkCgB;EACE,kBAAA;A7J0kkClB;A6JpkkCU;EAEE,sBAAA;EACA,sBAAA;A7JqkkCZ;A6JjkkCQ;EACE,kBAAA;A7JmkkCV;A6JhkkCQ;EACE,kBAAA;A7JkkkCV;A6J9jkCU;EACE,iBAAA;A7JgkkCZ;A6J9jkCU;EACE,cAAA;EACA,eAAA;A7JgkkCZ;A6J/jkCY;EACE,mBAAA;A7JikkCd;A6JhkkCc;EACE,kBAAA;A7JkkkChB;A6JjkkCgB;EACE,mBAAA;EACA,iBAAA;A7JmkkClB;A6J9jkCY;EACE,aAAA;EACA,8CAAA;A7JgkkCd;A6J9jkCY;EACE,kBAAA;EACA,gBAAA;A7JgkkCd;A6J5jkCU;EACE,gBAAA;EACA,eAAA;EACA,YAAA;A7J8jkCZ;A6J3jkCU;EACE,kBAAA;EACA,QAAA;EACA,MAAA;A7J6jkCZ;A6J5jkCY;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A7J8jkCd;A6J3jkCY;EACE,WAAA;EACA,YjF1eN;A5EuilCR;A6J1jkCU;EACE,aAAA;A7J4jkCZ;A6J3jkCY;EACE,6BAAA;A7J6jkCd;A6J3jkCY;EACE,WAAA;EACA,6BAAA;A7J6jkCd;A6J5jkCc;EACE,6BAAA;A7J8jkChB;A6J5jkCc;;EAEE,eAAA;EACA,+BAAA;EACA,gBAAA;A7J8jkChB;A6J5jkCc;EACE,YAAA;EACA,oCAAA;EACA,gCAAA;EACA,mBAAA;EACA,eAAA;EACA,cjFziBQ;EiF0iBR,aAAA;A7J8jkChB;A6J1jkCU;EACE,SAAA;EACA,aAAA;EACA,yBAAA;EACA,YAAA;A7J4jkCZ;A6J3jkCY;EACE,+BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;A7J6jkCd;A6J5jkCc;EACE,eAAA;A7J8jkChB;A6J1jkCU;EACE,sBAAA;A7J4jkCZ;A6JvjkCU;EACE,mCAAA;A7JyjkCZ;A6JtjkCQ;EACE,SAAA;EACA,YAAA;EACA,uBAAA;EACA,WAAA;A7JwjkCV;A6JvjkCU;EALF;IAMI,yBAAA;E7J0jkCV;AACF;A6JzjkCU;EACE,yBAAA;EACA,kBAAA;A7J2jkCZ;A6J1jkCY;EACE,kBAAA;EACA,6BAAA;A7J4jkCd;A6JzjkCY;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;A7J2jkCd;A6J1jkCc;EACE,eAAA;EACA,sBAAA;A7J4jkChB;A6JvjkCU;EAEE,sBAAA;EACA,sBAAA;A7JwjkCZ;A6JpjkCQ;EACE,YAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;A7JsjkCV;A6JpjkCU;EACE,wBAAA;A7JsjkCZ;A6JrjkCY;EACE,sBAAA;A7JujkCd;A6JljkCgB;EACE,2BAAA;EACA,2BAAA;A7JojkClB;A6JjjkCgB;EACE,4BAAA;EACA,4BAAA;A7JmjkClB;A6JjjkCkB;EACE,4BAAA;EACA,4BAAA;A7JmjkCpB;A6J9ikCY;EACE,aAAA;A7JgjkCd;A6J7ikCY;EACE,4BAAA;A7J+ikCd;A6J5ikCY;EACE,cjF7nBD;A5E2qlCb;A6J3ikCY;EACE,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,ejFpoBD;A5EirlCb;A6JrikCE;EACE,yBjF9pBc;A5EqslClB;A6JrikCI;EACE,+BAAA;EACA,iBjF/XQ;EiFgYR,sBjFzZc;EiF0Zd,kBAAA;EACA,gBAAA;A7JuikCN;A6JrikCM;EACE,kCAAA;A7JuikCR;A6JnikCI;EACE,kBjFhae;EiFiaf,oBAAA;EACA,sBjF7oBE;A5EkrlCR;A6JpikCM;EACE,SAAA;A7JsikCR;A6JrikCQ;EACE,UAAA;A7JuikCV;A6JnikCM;EACE,mBAAA;A7JqikCR;A6JnikCQ;EACE,ejF5aa;EiF6ab,gBjF5aiB;EiF6ajB,0BjF5aiB;A5Ei9kC3B;A6JnikCU;EACE,cjF9ae;EiF+af,ejF9aiB;EiF+ajB,kBjF9aqB;EiF+arB,0BjF9asB;EiF+atB,cjFtsBiB;A5E2ulC7B;A6JhikCM;EACE,6BjFtrBY;EiFurBZ,UAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;A7JkikCR;A6JhikCQ;EACE,eAAA;EACA,mBAAA;EACA,+BAAA;A7JkikCV;A6J7hkCY;EACE,YjFjcO;A5Eg+kCrB;A6J1hkCY;EACE,WAAA;EACA,YAAA;EACA,ejFhtBD;EiFitBC,wBAAA;A7J4hkCd;A6JzhkCU;EACE,2BAAA;EACA,gBAAA;A7J2hkCZ;A6J/gkCgB;EACE,ejFnuBL;A5EovlCb;A6J/gkCgB;EACE,ajF5hBQ;A5E6ilC1B;A6J7gkCgB;EACE,yBAAA;A7J+gkClB;A6J9gkCkB;EACE,4BAAA;A7JghkCpB;A6J9gkCkB;EACE,0BAAA;A7JghkCpB;A6JzgkCY;EACE,0BAAA;A7J2gkCd;A6JlgkCI;EACE,kBAAA;A7JogkCN;A6JlgkCI;EACE,cAAA;A7JogkCN;A6JjgkCI;EACE,YAAA;A7JmgkCN;A6JjgkCM;EACE,aAAA;A7JmgkCR;A6J9/jCM;EACE,YAAA;EACA,oBAAA;EACA,SAAA;EACA,gBjFpwBA;EiFqwBA,iDAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,6BAAA;EACA,UAAA;A7JggkCR;A6J//jCQ;EACE,qBAAA;A7JigkCV;A6J//jCQ;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;A7JigkCV;A6J9/jCQ;;EAEE,aAAA;A7JggkCV;A6J7/jCQ;EACE,gBAAA;EACA,kBAAA;A7J+/jCV;A6J7/jCU;;EAEE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,sBjFryBJ;EiFsyBI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,eAAA;A7J+/jCZ;A6J7/jCY;;EACE,aAAA;A7JggkCd;A6J5/jCU;EACE,OAAA;A7J8/jCZ;A6J3/jCU;EACE,QAAA;A7J6/jCZ;A6J1/jCU;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,+BAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;A7J4/jCZ;A6Jp/jCwB;EACE,YAAA;A7Js/jC1B;A6Jh/jCkB;EACE,aAAA;A7Jk/jCpB;A6J9+jCkB;EACE,yBAAA;A7Jg/jCpB;A6J9+jCsB;EACE,yBAAA;A7Jg/jCxB;A6J7+jCwB;EACE,eAAA;A7J++jC1B;A6J5+jCsB;EACE,yBAAA;A7J8+jCxB;A6Jt+jCsB;EACE,2BAAA;A7Jw+jCxB;A6Jt+jCwB;EACE,sCAAA;A7Jw+jC1B;A6J/9jCY;EACE,kBAAA;EACA,iBAAA;EACA,oBAAA;A7Ji+jCd;A6J79jCkB;EACE,2BAAA;EACA,yBAAA;A7J+9jCpB;A6J39jCgB;EACE,6CAAA;EACA,yBAAA;A7J69jClB;A6J19jCoB;EACE,4BAAA;EACA,yBAAA;A7J49jCtB;A6J19jCoB;EACE,0BAAA;EACA,yBAAA;A7J49jCtB;A6Jt9jCc;EACE,wBAAA;A7Jw9jChB;A6Jr9jCc;EACE,cAAA;EACA,cjFj8BQ;EiFk8BR,iBAAA;EACA,qBAAA;EACA,0BAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;A7Ju9jChB;A6Jr9jCgB;EAEE,gDAAA;EACA,yBAAA;A7Js9jClB;A6Jp9jCkB;;EAEE,2BAAA;EACA,yBAAA;A7Js9jCpB;A6Jl9jCgB;EACE,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,WAAA;EACA,oBAAA;A7Jo9jClB;A6Jj9jCgB;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;A7Jm9jClB;A6J/8jCc;EACE,eAAA;EAEA,UAAA;EACA,6BAAA;EACA,0BAAA;EACA,iBAAA;A7Jg9jChB;A6J/8jCgB;EACE,SAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;A7Ji9jClB;A6J/8jCkB;EACE,uBAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,4BAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;A7Ji9jCpB;A6J/8jCoB;EACE,UAAA;A7Ji9jCtB;A6J78jCoB;EACE,2BAAA;EACA,qBAAA;EACA,yBAAA;A7J+8jCtB;A6J78jCsB;EACE,sCAAA;A7J+8jCxB;A6Jx8jCc;EACE,eAAA;EACA,QAAA;EACA,OAAA;EACA,cAAA;EACA,UAAA;EACA,6BAAA;EACA,aAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;A7J08jChB;A6Jx8jCgB;EACE,UAAA;A7J08jClB;A6Jt8jCsB;EACE,yBAAA;EACA,eAAA;EACA,kBAAA;A7Jw8jCxB;A6Jp8jCoB;EACE,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;A7Js8jCtB;A6Jr8jCsB;EACE,SAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;A7Ju8jCxB;A6Jr8jCwB;EACE,oBAAA;EACA,uBAAA;EACA,cjF5jCF;EiF6jCE,2BAAA;EACA,0BAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;A7Ju8jC1B;A6Jr8jC0B;EACE,2BAAA;EACA,qBAAA;EACA,yBAAA;A7Ju8jC5B;A6Jr8jC4B;EACE,2BAAA;EACA,yBAAA;A7Ju8jC9B;A6Jn8jC0B;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,yBjF/jChB;A5EogmCZ;A6J17jCkB;EACE,OAAA;EACA,QAAA;EACA,UAAA;A7J47jCpB;A6Jv7jCc;EACE,eAAA;A7Jy7jChB;A6Jn7jCQ;EACE,2CAAA;A7Jq7jCV;A6Jj7jCM;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;A7Jm7jCR;A6Jl7jCQ;EACE,eAAA;A7Jo7jCV;A6Jj7jCM;EACE,iBAAA;A7Jm7jCR;A6Jj7jCM;EACE,wBAAA;A7Jm7jCR;A6Jh7jCQ;EACE,aAAA;EACA,yBAAA;A7Jk7jCV;A6J76jCI;EACE,WAAA;EACA,gBAAA;A7J+6jCN;A6J56jCQ;EACE,sBAAA;A7J86jCV;A6J56jCQ;EACE,UAAA;A7J86jCV;A6J76jCU;EAFF;IAGI,UAAA;E7Jg7jCV;AACF;A6J/6jCU;EALF;IAMI,UAAA;E7Jk7jCV;AACF;A6Jj7jCU;EARF;IASI,UAAA;E7Jo7jCV;AACF;A6Jj7jCU;EADF;IAEI,UAAA;E7Jo7jCV;AACF;A6Jn7jCU;EAJF;IAKI,UAAA;E7Js7jCV;AACF;A6Jr7jCU;EAPF;IAQI,UAAA;E7Jw7jCV;AACF;A6Jl7jCM;EACE,cAAA;A7Jo7jCR;A6J/6jCI;EACE,mBAAA;EACA,6CAAA;A7Ji7jCN;A6J76jCI;EACE,eAAA;EACA,gBAAA;EACA,cjFhsCuB;EiFisCvB,yBAAA;EACA,gBAAA;EACA,qBAAA;A7J+6jCN;A6Jz6jCI;EACE,kBjFv8BkB;EiFw8BlB,yBAAA;A7J26jCN;A6Jz6jCM;EACE,iBAAA;EACA,wBAAA;A7J26jCR;A6Jv6jCQ;EACE,aAAA;A7Jy6jCV;A6Jt6jCQ;EACE,aAAA;A7Jw6jCV;A6Jj6jCQ;EACE,eAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,oBAAA;EACA,gBjFjsCF;EiFksCE,YjFn+Bc;EiFo+Bd,gBAAA;EACA,gBAAA;EACA,8CAAA;A7Jm6jCV;A6Jj6jCU;;EAEE,kBAAA;EACA,+CAAA;A7Jm6jCZ;A6Jh6jCU;EACE,aAAA;A7Jk6jCZ;A6Jh6jCU;EACE,WAAA;EACA,yBAAA;A7Jk6jCZ;A6Jj6jCY;EACE,UAAA;EACA,QAAA;EACA,UAAA;A7Jm6jCd;A6J/5jCgB;EACE,eAAA;EACA,SAAA;EACA,yBAAA;A7Ji6jClB;A6J/5jCoB;EACE,aAAA;A7Ji6jCtB;A6J75jCkB;EACE,kBAAA;EACA,kBAAA;EACA,yBAAA;A7J+5jCpB;A6Jz5jCY;EACE,wBAAA;EACA,UAAA;EACA,yBAAA;A7J25jCd;A6Jx5jCY;EACE,aAAA;A7J05jCd;A6Jv5jCY;EACE,iBAAA;EACA,cAAA;A7Jy5jCd;A6Jt5jCY;EACE,YAAA;EACA,yBAAA;A7Jw5jCd;A6Jt5jCc;EACE,UAAA;EACA,WAAA;EACA,yBAAA;A7Jw5jChB;A6Jn5jCkB;EACE,gBAAA;EACA,eAAA;EACA,yBAAA;A7Jq5jCpB;A6Jp5jCoB;EACE,gBAAA;A7Js5jCtB;A6Jr5jCsB;EACE,iBAAA;A7Ju5jCxB;A6Jl5jCsB;EACE,cAAA;A7Jo5jCxB;A6Jh5jCoB;EACE,kBAAA;EACA,yBAAA;A7Jk5jCtB;A6Jj5jCsB;EACE,kBAAA;A7Jm5jCxB;A6Jj5jCsB;EACE,qBAAA;A7Jm5jCxB;A6J54jCc;EACE,UAAA;EACA,yBAAA;EACA,yBAAA;A7J84jChB;A6J34jCc;EACE,cAAA;A7J64jChB;A6J14jCc;EACE,aAAA;A7J44jChB;A6Jx4jCY;EACE,2BAAA;A7J04jCd;A6Jv4jCY;;EAEE,iBAAA;EACA,gBAAA;A7Jy4jCd;A6Jt4jCY;EACE,wBAAA;A7Jw4jCd;A6Jp4jCc;EACE,2BAAA;A7Js4jChB;A6Jl4jCoB;EACE,WAAA;EACA,WAAA;A7Jo4jCtB;A6J/3jCoB;EACE,SAAA;A7Ji4jCtB;A6J/3jCoB;EACE,aAAA;A7Ji4jCtB;A6J13jCsB;EACE,aAAA;A7J43jCxB;A6Jp3jCY;EACE,aAAA;A7Js3jCd;A6Jj3jCY;;EAEE,aAAA;A7Jm3jCd;A6Jh3jCY;EACE,2BjFnpCG;EiFopCH,YAAA;EACA,WAAA;EACA,yBAAA;EACA,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;A7Jk3jCd;A6J/2jCgB;EACE,gBAAA;A7Ji3jClB;A6J/2jCkB;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,yBAAA;A7Ji3jCpB;A6J92jCkB;EACE,qBAAA;EACA,0BAAA;EACA,6BAAA;A7Jg3jCpB;A6J52jCoB;EACE,aAAA;A7J82jCtB;A6Jz2jCgB;EACE,mBAAA;A7J22jClB;A6Jv2jCc;EACE,OAAA;A7Jy2jChB;A6Jt2jCc;EACE,cAAA;EACA,WAAA;EACA,UAAA;A7Jw2jChB;A6Jt2jCgB;EACE,aAAA;EACA,cjF18CC;EiF28CD,gBAAA;EACA,yBAAA;EACA,gCAAA;EACA,eAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;A7Jw2jClB;A6Jp2jCc;EACE,cAAA;EACA,WAAA;EACA,kBAAA;A7Js2jChB;A6Jp2jCgB;EACE,wBAAA;EACA,gBAAA;A7Js2jClB;A6Jr2jCkB;EACE,wBAAA;A7Ju2jCpB;A6Jr2jCkB;EACE,kBAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,iCAAA;EACA,wBAAA;EACA,WAAA;EACA,2BAAA;A7Ju2jCpB;A6Jr2jCkB;EACE,aAAA;A7Ju2jCpB;A6Jt2jCoB;EACE,aAAA;A7Jw2jCtB;A6Jl2jCkB;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,4BAAA;EACA,UAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,+BAAA;EACA,mBAAA;A7Jo2jCpB;A6J/1jCsB;EACE,2CAAA;EACA,yBAAA;A7Ji2jCxB;A6Jx1jCsB;EACE,gCAAA;EACA,4BAAA;EACA,yBAAA;A7J01jCxB;A6Jz1jCwB;EACE,0BAAA;EACA,YAAA;A7J21jC1B;A6Jv1jCsB;EACE,2BAAA;EACA,yBAAA;A7Jy1jCxB;A6Jr1jCwB;EACE,2BAAA;EACA,yBAAA;A7Ju1jC1B;A6Jh1jCgB;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;A7Jk1jClB;A6Jh1jCkB;EACE,WAAA;EACA,kBAAA;EACA,SAAA;A7Jk1jCpB;A6Jh1jCoB;EACE,aAAA;A7Jk1jCtB;A6J/0jCoB;EACE,aAAA;A7Ji1jCtB;A6J50jCgB;EACE,wBAAA;A7J80jClB;A6J30jCgB;EACE,WAAA;EACA,UAAA;EACA,6BAAA;A7J60jClB;A6Jv0jCoB;EACE,6BAAA;EACA,gBAAA;A7Jy0jCtB;A6Jp0jCoB;EACE,QAAA;A7Js0jCtB;A6Jl0jCkB;EACE,cAAA;A7Jo0jCpB;A6J/zjCsB;EACE,2BAAA;EACA,yBAAA;A7Ji0jCxB;A6J7zjCoB;EACE,aAAA;EACA,6BAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;A7J+zjCtB;A6J7zjCsB;EACE,cAAA;A7J+zjCxB;A6J3zjCwB;EACE,iBAAA;EACA,6BAAA;A7J6zjC1B;A6J3zjC0B;EACE,aAAA;A7J6zjC5B;A6JxzjCoB;EACE,iBAAA;EACA,eAAA;EACA,4BAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;A7J0zjCtB;A6JtzjCsB;EACE,2BAAA;A7JwzjCxB;A6JvzjCwB;EACE,UAAA;EACA,mBAAA;A7JyzjC1B;A6JrzjCsB;EACE,UAAA;A7JuzjCxB;A6JnzjCsB;EACE,cAAA;A7JqzjCxB;A6J/yjCgB;EACE,UAAA;EACA,kBAAA;A7JizjClB;A6J5yjCkB;EACE,cAAA;A7J8yjCpB;A6J3yjCkB;EACE,WAAA;EACA,UAAA;A7J6yjCpB;A6JzyjCwB;EACE,sCAAA;EACA,yBAAA;A7J2yjC1B;A6JvyjCsB;EACE,kBAAA;A7JyyjCxB;A6JvyjCwB;EACE,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,4BAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;A7JyyjC1B;A6JvyjC0B;EACE,UAAA;A7JyyjC5B;A6JjyjC0B;EACE,2BAAA;A7JmyjC5B;A6JlyjC4B;EACE,UAAA;EACA,mBAAA;A7JoyjC9B;A6J/xjCwB;EACE,QAAA;A7JiyjC1B;A6J1xjC4B;EACE,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,4BAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;A7J4xjC9B;A6J1xjC8B;EACE,aAAA;A7J4xjChC;A6JzxjC8B;EACE,2BAAA;A7J2xjChC;A6JnxjC4B;EACE,gBAAA;A7JqxjC9B;A6JnxjC8B;EACE,cAAA;A7JqxjChC;A6JxwjCsB;EACE,yBAAA;A7J0wjCxB;A6JzwjCwB;EACE,wBAAA;EACA,uBAAA;A7J2wjC1B;A6JpwjCgB;EACE,yBAAA;EACA,cAAA;A7JswjClB;A6JrwjCkB;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;EACA,yBjFnxDJ;EiFoxDI,8BAAA;EACA,UAAA;EACA,kBAAA;A7JuwjCpB;A6JtwjCoB;EACE,YAAA;EACA,OAAA;A7JwwjCtB;A6JrwjCkB;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gDAAA;A7JuwjCpB;A6JtwjCoB;EACE,UAAA;EACA,mBAAA;A7JwwjCtB;A6JrwjCsB;EACE,wBAAA;EACA,uBAAA;A7JuwjCxB;A6JnwjCsB;EACE,2BAAA;A7JqwjCxB;A6JjwjCoB;EACE,2BAAA;EACA,yBAAA;A7JmwjCtB;A6JxvjCQ;EACE,iBAAA;A7J0vjCV;A6JtvjCM;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;A7JwvjCR;A6JtvjCQ;EACE,sBAAA;EACA,6BAAA;EACA,gBAAA;A7JwvjCV;A6JnvjCQ;EACE,YAAA;A7JqvjCV;A6JhvjCY;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,QAAA;A7JkvjCd;A6JhvjCc;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;A7JkvjChB;A6J3ujCM;EACE,8BAAA;EACA,gBAAA;EACA,kBjF5mDgB;A5Ey1mCxB;A6JrujCQ;EACE,+BjF7yDY;A5EohnCtB;A6JnujCQ;EACE,4BAAA;A7JqujCV;A6J3tjCoB;EACE,gCjF7zDA;A5E0hnCtB;A6J3tjCoB;EACE,8BjFh0DA;A5E6hnCtB;A6JxtjCsB;EACE,4BAAA;A7J0tjCxB;A6JxtjCsB;EACE,0BAAA;A7J0tjCxB;A6JptjCkB;EACE,mBjF50DD;A5EkinCnB;A6J7sjCM;EACE,yBjF71De;A5E4inCvB;A6JzsjCgB;EACE,+BjFj2DI;A5E4inCtB;A6JvsjCkB;EACE,gCjFt2DE;A5E+inCtB;A6JvsjCkB;EACE,8BjFz2DE;A5EkjnCtB;A6J9rjCsB;EACE,+BjFr3DF;A5EqjnCtB;A6JzrjC0B;EACE,+BjF73DN;EiF83DM,gBAAA;A7J2rjC5B;A6JnrjCgB;EACE,0CjFt4DK;A5E2jnCvB;A6JhrjCgB;EACE,0CAAA;A7JkrjClB;A6JhrjCkB;EACE,2BAAA;EACA,4BAAA;A7JkrjCpB;A6J3qjCkB;EACE,+BjFz5DE;A5EsknCtB;A6JnqjCoB;EACE,+BjFp6DA;A5EyknCtB;A6JlqjCoB;EACE,2BAAA;A7JoqjCtB;A6J1pjCU;EACE,aAAA;A7J4pjCZ;A6JzpjCU;EACE,cAAA;A7J2pjCZ;A6JrpjCQ;EACE,+BjF97DY;A5EqlnCtB;A6JjpjCM;EACE,yBAAA;A7JmpjCR;A6J5ojCI;EACE,gBAAA;A7J8ojCN;A6J5ojCM;EACE,UAAA;EACA,aAAA;EACA,YAAA;EACA,oCAAA;EACA,eAAA;EACA,MAAA;A7J8ojCR;A6J1ojCI;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;A7J4ojCN;A6JzojCI;EACE,aAAA;A7J2ojCN;A6JxojCI;EACE,aAAA;A7J0ojCN;A6JvojCI;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,+CAAA;A7JyojCN;A6JvojCI;EACE,kBAAA;EACA,yBAAA;A7JyojCN;A6JtojCQ;EACE,aAAA;A7JwojCV;A6JtojCQ;EACE,UAAA;A7JwojCV;A6JvojCU;EAFF;IAGI,UAAA;E7J0ojCV;AACF;A6JzojCU;EALF;IAMI,UAAA;E7J4ojCV;AACF;A6J3ojCU;EARF;IASI,UAAA;E7J8ojCV;AACF;A6J7ojCU;EAXF;IAYI,UAAA;E7JgpjCV;AACF;A6J9ojCY;EADF;IAEI,YAAA;E7JipjCZ;AACF;A6JhpjCY;EAJF;IAKI,WAAA;E7JmpjCZ;AACF;A6J9ojCM;EACE,cAAA;EACA,uBAAA;A7JgpjCR;A6J3ojCM;EACE,gBAAA;EACA,kBAAA;A7J6ojCR;A6J1ojCM;EACE,kBAAA;A7J4ojCR;A6JzojCM;EACE,eAAA;EACA,MAAA;EACA,UAAA;EACA,sBjF1kEA;A5EqtnCR;A6J1ojCQ;EACE,YAAA;EACA,oBAAA;EACA,gBjF9kEF;EiF+kEE,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;A7J4ojCV;A6JxojCU;;EAEE,aAAA;A7J0ojCZ;A6JvojCU;EACE,cAAA;EACA,2BAAA;EACA,cAAA;A7JyojCZ;A6JtojCc;EACE,cjFnnEH;A5E2vnCb;A6JtojCgB;EACE,0BAAA;EACA,cjFvnEL;EiFwnEK,gBAAA;EACA,mBAAA;EACA,eAAA;A7JwojClB;A6JrojCgB;EACE,oCAAA;EACA,cjF7oEF;EiF8oEE,mBAAA;EACA,cAAA;A7JuojClB;A6JtojCkB;EACE,cjFjpEJ;A5EyxnChB;A6JrojCkB;;EAEE,uCAAA;A7JuojCpB;A6JlojCc;EACE,cAAA;EACA,eAAA;EACA,gCAAA;A7JoojChB;A6JjojCc;;EAEE,eAAA;EACA,QAAA;EACA,yBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,sBjF1oER;EiF2oEQ,qDAAA;EACA,gCAAA;EACA,aAAA;EACA,iBAAA;EACA,WAAA;A7JmojChB;A6JhojCkB;;EACE,4BAAA;EACA,cAAA;EACA,kBAAA;EACA,gCAAA;A7JmojCpB;A6JjojCoB;;EACE,aAAA;A7JoojCtB;A6JjojCoB;;EACE,kBAAA;EACA,WAAA;EACA,SAAA;A7JoojCtB;A6JjojCoB;;EACE,0CAAA;EACA,cjFnsEN;EiFosEM,yBAAA;A7JoojCtB;A6J7njCwB;;EACE,6BjF3rEN;A5E2znCpB;A6JvnjCoB;;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;EACA,4CAAA;A7J0njCtB;A6JrnjCgB;;EACE,cAAA;EACA,eAAA;EACA,UAAA;A7JwnjClB;A6JtnjCkB;;EACE,gBAAA;A7JynjCpB;A6JtnjCsB;;;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,4BAAA;EACA,mBAAA;EACA,gBAAA;A7J0njCxB;A6JxnjCwB;;;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;EACA,6BAAA;A7J4njC1B;A6JpnjCgB;EACE,yBAAA;A7JsnjClB;A6JjnjCY;EACE,kBAAA;A7JmnjCd;A6JjnjCc;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gBAAA;EACA,cAAA;A7JmnjChB;A6JhnjCc;EACE,kBAAA;A7JknjChB;A6JhnjCgB;EACE,kBAAA;EACA,WAAA;EACA,YAAA;A7JknjClB;A6J/mjCgB;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;A7JinjClB;A6J9mjCgB;EACE,aAAA;A7JgnjClB;A6J3mjCY;EACE,kBAAA;EACA,UAAA;A7J6mjCd;A6J5mjCc;EACE,WAAA;EACA,YAAA;A7J8mjChB;A6J3mjCc;EACE,kBAAA;EACA,WAAA;EACA,SAAA;A7J6mjChB;A6JnmjCgB;EACE,cAAA;EACA,kBAAA;A7JqmjClB;A6JnmjCgB;EACE,aAAA;A7JqmjClB;A6J3ljCgB;EACE,aAAA;A7J6ljClB;A6J3ljCgB;EACE,cAAA;EACA,kBAAA;A7J6ljClB;A6JtljCQ;EACE,6BAAA;A7JwljCV;A6JtljCU;;EAEE,gBAAA;A7JwljCZ;A6J/kjCI;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;A7JiljCN;A6J9kjCI;;EAEE,aAAA;A7JgljCN;A6J7kjCI;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,+CAAA;A7J+kjCN;A6J5kjCI;EACE,iBAAA;EACA,wBAAA;A7J8kjCN;A6J3kjCQ;EACE,aAAA;A7J6kjCV;A6JzkjCM;EACE,cAAA;EACA,uBAAA;A7J2kjCR;A6JtkjCM;EACE,iBAAA;A7JwkjCR;A6JrkjCM;EACE,iBAAA;A7JukjCR;A6JnkjCQ;EACE,WAAA;A7JqkjCV;A6JhkjCY;EADF;IAEI,2BAAA;E7JmkjCZ;AACF;A6JhkjCc;EACE,cAAA;EACA,eAAA;A7JkkjChB;A6J/jjCc;;EAEE,UAAA;A7JikjChB;A6J9jjCkB;;EACE,4BAAA;A7JikjCpB;A6J/jjCoB;;EACE,aAAA;A7JkkjCtB;A6J/jjCoB;;EACE,SAAA;A7JkkjCtB;A6J1jjCc;EACE,aAAA;A7J4jjChB;A6JxjjCgB;EACE,cAAA;EACA,WAAA;EACA,YAAA;A7J0jjClB;A6JvjjCgB;EACE,aAAA;A7JyjjClB;A6JnjjCc;EACE,cAAA;A7JqjjChB;A6JjjjCgB;EACE,aAAA;A7JmjjClB;A6J5ijCQ;EACE,6BAAA;A7J8ijCV;A6J5ijCU;;EAEE,gBAAA;A7J8ijCZ;A6JtijCE;EACE,yBAAA;A7JwijCJ;A6JvijCI;EACE,yBAAA;A7JyijCN;A6JvijCI;EACE,kBAAA;A7JyijCN;A6JxijCM;EACE,aAAA;A7J0ijCR;A6JvijCM;EACE,qBAAA;A7JyijCR;A6JxijCQ;EACE,aAAA;A7J0ijCV;A6JxijCQ;EACE,kBAAA;EACA,WAAA;EACA,SAAA;A7J0ijCV;A6JxijCQ;EACE,SAAA;EACA,wBAAA;EACA,UAAA;A7J0ijCV;A6JzijCU;EACE,WAAA;EACA,WAAA;A7J2ijCZ;A6JvijCc;EACE,sBjFp+ER;EiFq+EQ,mBAAA;A7JyijChB;A6JpijCU;EACE,SAAA;EACA,wBAAA;EACA,cAAA;EACA,QAAA;A7JsijCZ;A6JhijCM;EACE,iBAAA;EACA,oBAAA;A7JkijCR;A6J/hjCI;;EAEE,aAAA;A7JiijCN;A6J7hjCM;EACE,eAAA;EACA,6BAAA;A7J+hjCR;A6J5hjCM;EACE,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;A7J8hjCR;A6J7hjCQ;EALF;IAMI,kBAAA;IACA,mBAAA;IACA,cAAA;E7JgijCR;AACF;A6J9hjCU;EACE,cAAA;EACA,eAAA;A7JgijCZ;A6J5hjCQ;EACE,eAAA;EACA,2BAAA;A7J8hjCV;A6JthjCI;EACE,kBAAA;A7JwhjCN;A6JvhjCM;EACE,kBAAA;EACA,mBAAA;A7JyhjCR;A6JthjCI;EACE,2DAAA;A7JwhjCN;A6JthjCI;EACE,2DAAA;A7JwhjCN;A6JthjCI;EACE,cjF5kFU;A5EomoChB;A6JthjCI;EACE,gDAAA;A7JwhjCN;A6JthjCI;EACE,6BAAA;A7JwhjCN;A6JthjCI;EACE,SAAA;A7JwhjCN;A6JthjCI;EACE,gBAAA;EACA,uBAAA;A7JwhjCN;A6JthjCM;EACE,gBAAA;EACA,uBAAA;A7JwhjCR;A6JphjCQ;EACE,UAAA;A7JshjCV;A6JrhjCU;EAFF;IAGI,UAAA;E7JwhjCV;AACF;A6JvhjCU;EALF;IAMI,UAAA;E7J0hjCV;AACF;A6JvhjCU;EADF;IAEI,UAAA;E7J0hjCV;AACF;A6JzhjCU;EAJF;IAKI,UAAA;E7J4hjCV;AACF;A6J1hjCQ;EACE,aAAA;EACA,mBAAA;A7J4hjCV;A6JzhjCQ;EACE,cAAA;EACA,kBAAA;A7J2hjCV;A6JxhjCQ;EACE,cAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;A7J0hjCV;A6JphjCM;EACE,6BAAA;EACA,iBAAA;A7JshjCR;A6JphjCM;EACE,uBAAA;EACA,SAAA;EACA,SAAA;EACA,mBAAA;A7JshjCR;A6JphjCQ;;EAEE,aAAA;A7JshjCV;A6JlhjCU;EACE,2BAAA;A7JohjCZ;A6J/gjCU;EACE,aAAA;A7JihjCZ;A6J9gjCU;EACE,gBAAA;A7JghjCZ;A6J7gjCU;EACE,gBAAA;EACA,iBAAA;A7J+gjCZ;A6J3gjCY;EACE,aAAA;A7J6gjCd;A6JvgjCM;EACE,kBAAA;A7JygjCR;A6JvgjCQ;EACE,iBAAA;A7JygjCV;A6JtgjCM;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;A7JwgjCR;A6JvgjCQ;EAJF;IAKI,eAAA;IACA,cAAA;E7J0gjCR;AACF;A6JpgjCE;EACE,kBAAA;A7JsgjCJ;A6JpgjCI;EACE,kBAAA;EACA,WAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,yFjF1qFgB;A5EgroCtB;A6JngjCI;EACE,wCAAA;A7JqgjCN;A6JlgjCI;EACE,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,4BAAA;A7JogjCN;A6JlgjCQ;EACE,UAAA;A7JogjCV;A6JngjCU;EAFF;IAGI,UAAA;E7JsgjCV;AACF;A6JrgjCU;EALF;IAMI,UAAA;E7JwgjCV;AACF;A6JvgjCU;EARF;IASI,UAAA;E7J0gjCV;AACF;A6JvgjCU;EADF;IAEI,UAAA;E7J0gjCV;AACF;A6JzgjCU;EAJF;IAKI,UAAA;E7J4gjCV;AACF;A6JvgjCI;EACE,0DAAA;EACA,8BAAA;EACA,0CAAA;A7JygjCN;A6JvgjCM;EACE,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;A7JygjCR;A6JtgjCM;EACE,cAAA;EACA,iBAAA;EACA,yBjFxwFK;EiFywFL,8CAAA;EACA,4BAAA;A7JwgjCR;A6JpgjCI;EACE,gBAAA;A7JsgjCN;A6JjgjCU;EACE,UAAA;A7JmgjCZ;A6JhgjCY;EADF;IAEI,UAAA;E7JmgjCZ;AACF;A6J5/iCE;EACE,8BAAA;EACA,yBjFlyFc;A5EgyoClB;A6J7/iCI;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;A7J+/iCN;A6J5/iCI;EACE,kBAAA;EACA,sBjFzwFE;EiF0wFF,cAAA;A7J8/iCN;A6J3/iCI;EACE,uBAAA;A7J6/iCN;A6J3/iCM;EACE,6BAAA;EACA,qBAAA;EACA,aAAA;EACA,gBAAA;EACA,6BAAA;EACA,gCAAA;A7J6/iCR;A6J5/iCQ;EACE,kBAAA;A7J8/iCV;A6J1/iCM;EACE,wBAAA;A7J4/iCR;;A6Jt/iCA;EACE;IACE,UAAA;IACA,4DAAA;E7Jy/iCF;E6Jt/iCA;IACE,UAAA;E7Jw/iCF;AACF;A6Jp/iCA;EACE,kBAAA;A7Js/iCF;A6Jr/iCE;EACE,aAAA;EACA,kBAAA;EACA,0BAAA;EACA,mBAAA;A7Ju/iCJ;;A6Jn9iCA;EAQgB;IACE,WAAA;IACA,UAAA;E7J+8iChB;AACF;A6Jr8iCA;EAQgB;IACE,WAAA;IACA,UAAA;E7Jg8iChB;E6Jn7iCM;IACE,iBAAA;E7Jq7iCR;AACF;A6J/6iCA;EAQgB;IACE,WAAA;IACA,UAAA;E7J06iChB;E6J/5iCE;IACE,QAAA;IACA,sBAAA;E7Ji6iCJ;E6J/5iCI;IAEE,sBAAA;IACA,sBAAA;E7Jg6iCN;AACF;A6J35iCA;EAMY;IACE,YAAA;E7Jw5iCZ;E6J/4iCE;IACE,wBAAA;IACA,8BAAA;IACA,uBAAA;IACA,6BAAA;IACA,eAAA;E7Ji5iCJ;E6J/4iCI;IACE,2BAAA;E7Ji5iCN;E6J94iCI;IACE,uCAAA;E7Jg5iCN;E6Jp4iCc;IACE,WAAA;IACA,UAAA;E7Js4iChB;AACF;A6J53iCA;EAIQ;IACE,SAAA;E7J23iCR;E6Jr3iCA;IACE,aAAA;E7Ju3iCF;E6J/2iCU;IACE,MAAA;E7Ji3iCZ;E6J72iCY;IACE,YAAA;IACA,UAAA;IACA,kBAAA;IACA,kBAAA;IACA,yBAAA;E7J+2iCd;E6J52iCgB;IACE,kBAAA;IACA,WAAA;IACA,QAAA;IACA,cjFphGR;IiFqhGQ,gBAAA;IACA,yBAAA;IACA,eAAA;IACA,QAAA;E7J82iClB;E6Jz2iCgB;IACE,aAAA;IACA,kBAAA;E7J22iClB;E6Jv2iCkB;IACE,yBAAA;IACA,kBAAA;IACA,WAAA;IACA,sBjF5hGd;IiF6hGc,UAAA;IACA,0BAAA;IACA,6BAAA;E7Jy2iCpB;E6Jn2iCoB;IACE,WAAA;IACA,yBAAA;E7Jq2iCtB;E6J91iCY;IACE,UAAA;IACA,kBAAA;IACA,yBAAA;E7Jg2iCd;E6J51iCc;IACE,UAAA;IACA,mBAAA;IACA,eAAA;IACA,yBAAA;E7J81iChB;E6J11iCc;IACE,UAAA;IACA,mBAAA;IACA,gBAAA;IACA,yBAAA;E7J41iChB;E6Jr1iCM;IACE,aAAA;E7Ju1iCR;E6Jp1iCM;IACE,wBAAA;E7Js1iCR;AACF;A6Jh1iCA;EAGI;IACE,kBAAA;E7Jg1iCJ;E6J90iCI;IACE,kBAAA;IACA,WAAA;IACA,OAAA;IACA,WAAA;IACA,aAAA;IACA,mFjFzlGc;E5Ey6oCpB;E6J90iCI;IACE,+BAAA;E7Jg1iCN;E6J70iCQ;IACE,sBAAA;IACA,uBAAA;E7J+0iCV;E6J10iCI;IACE,kBAAA;IACA,uBAAA;IACA,kBAAA;IACA,iBAAA;IACA,cAAA;IACA,uBAAA;IACA,gBAAA;E7J40iCN;E6J30iCM;IACE,WjFtnGF;E5Em8oCN;E6Jt0iCc;IACE,YjF9nGV;E5Es8oCN;E6Jp0iCkB;IACE,ejFxqGE;E5E8+oCtB;E6J/ziCY;IACE,WjF3oGR;E5E48oCN;E6J7ziCgB;;IACE,YjFhpGZ;E5Eg9oCN;E6J3ziCgB;IACE,YjFtpGZ;E5Em9oCN;E6JzziCc;IACE,YjF3pGV;E5Es9oCN;E6JrziCY;IACE,cjFvsGQ;E5E8/oCtB;E6JnziCU;IACE,cjF5sGU;E5EigpCtB;E6J7yiCoB;IACE,+BAAA;E7J+yiCtB;E6JryiCM;IACE,eAAA;IACA,yBAAA;E7JuyiCR;E6JlyiCM;IACE,wBAAA;IACA,kBAAA;IACA,iBAAA;IACA,cAAA;E7JoyiCR;E6J/xiCU;IACE,kBAAA;IACA,yBAAA;E7JiyiCZ;E6J5xiCM;IACE,WjFltGF;IiFmtGE,6BAAA;IACA,mBAAA;IACA,gBAAA;E7J8xiCR;E6J1xiCc;IACE,YjF1tGV;E5Es/oCN;E6JxxiCY;IACE,+BAAA;E7J0xiCd;E6JtxiCc;IACE,+BAAA;E7JwxiChB;AACF;A6J9wiCA;EAIM;IACE,aAAA;E7J6wiCN;AACF;A6JxwiCA;EAIQ;IACE,YAAA;E7JuwiCR;AACF;A6JjwiCA;EAEI;IACE,eAAA;E7JkwiCJ;AACF;A6J1viCM;;EACE,qBAAA;A7J6viCR;A6J3viCM;;EACE,aAAA;A7J8viCR;A6JvviCM;;EACE,aAAA;A7J0viCR;A6JxviCM;;EACE,qBAAA;A7J2viCR;;A6JrviCA;;4BAAA;AC90GA;;4BAAA;AAKE;EACE,gBAAA;A9JukpCJ;A8JrkpCE;EACE,eAAA;EACA,mBAAA;A9JukpCJ;A8JrkpCE;EACE,qDAAA;EACA,gCAAA;A9JukpCJ;A8JrkpCE;EACE,2BAAA;A9JukpCJ;A8JrkpCE;EACE,6BAAA;EACA,6BAAA;A9JukpCJ;A8JrkpCE;EACE,WAAA;A9JukpCJ;A8JnkpCM;EACE,QAAA;A9JqkpCR;A8JjkpCE;EACE,mBAAA;EACA,iBAAA;A9JmkpCJ;A8J/jpCM;EACE,kBAAA;EACA,iBAAA;A9JikpCR;A8J3jpCM;EACE,WAAA;EACA,WAAA;A9J6jpCR;A8JvjpCM;EACE,WAAA;A9JyjpCR;A8JpjpCI;EACE,yCAAA;EACA,4CAAA;EACA,yCAAA;EACA,4CAAA;A9JsjpCN;A8JnjpCI;EACE,wCAAA;EACA,yCAAA;EACA,0CAAA;EACA,6CAAA;A9JqjpCN;A8J/ipCQ;EACE,iBAAA;A9JijpCV;A8J/ipCU;EACE,YAAA;EACA,UAAA;A9JijpCZ;A8J9ipCU;EACE,UAAA;A9JgjpCZ;A8J9ipCY;EACE,qBAAA;EACA,uBAAA;A9JgjpCd;A8J5ipCU;EACE,eAAA;EACA,kBAAA;A9J8ipCZ;A8J7ipCY;EACE,gBAAA;A9J+ipCd;A8J9ipCc;EACE,gBAAA;A9JgjpChB;A8J7ipCY;;EAEE,cAAA;EACA,mBAAA;EACA,gBAAA;A9J+ipCd;A8JxipCoB;EACE,cAAA;A9J0ipCtB;A8JnipCsB;EACE,wBAAA;A9JqipCxB;A8J7hpCY;EACE,aAAA;A9J+hpCd;A8JvhpCsB;EACE,iBAAA;A9JyhpCxB;A8JhhpCU;EACE,yBAAA;A9JkhpCZ;A8J3gpCsB;EACE,yBAAA;A9J6gpCxB;A8JrgpCoB;EACE,WAAA;A9JugpCtB;A8JhgpCY;EACE,cAAA;A9JkgpCd;A8J1/oCkB;EACE,WAAA;EACA,WAAA;A9J4/oCpB;A8Jx/oCoB;EACE,8BAAA;EACA,8BAAA;A9J0/oCtB;A8Jx/oCsB;EACE,WAAA;EACA,WAAA;A9J0/oCxB;A8Jh/oCQ;EACE,kBAAA;EACA,mBAAA;A9Jk/oCV;A8J1+oCkB;EACE,mBAAA;EACA,iBAAA;A9J4+oCpB;A8Jp+oCQ;EACE,YAAA;EACA,UAAA;A9Js+oCV;A8J/9oCU;EACE,YAAA;EACA,UAAA;A9Ji+oCZ;A8Jx9oCM;EACE,kBAAA;EACA,kBAAA;A9J09oCR;A8Jp9oCI;EACE,6BAAA;A9Js9oCN;A8Jj9oCM;EACE,8BAAA;EACA,mBAAA;A9Jm9oCR;A8J58oCQ;EACE,oBAAA;EACA,kBAAA;A9J88oCV;A8J58oCY;EACE,WAAA;A9J88oCd;A8Jr8oCc;EACE,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,+BAAA;A9Ju8oChB;A8J57oCM;EACE,oBAAA;EACA,kBAAA;A9J87oCR;A8Jx7oCM;EACE,mBAAA;EACA,gBAAA;A9J07oCR;A8Jr7oCE;EACE,wCAAA;A9Ju7oCJ;A8Jl7oCQ;EACE,kBAAA;EACA,kBAAA;A9Jo7oCV;A8J36oCU;EACE,uBAAA;A9J66oCZ;A8Jt6oCI;EACE,YAAA;EACA,UAAA;A9Jw6oCN;A8Jp6oCE;EACE,YAAA;A9Js6oCJ;A8J95oCY;EACE,kBAAA;EACA,mBAAA;A9Jg6oCd;A8Jx5oCQ;EACE,mBAAA;EACA,iBAAA;A9J05oCV;A8Jl5oCM;EACE,iBAAA;A9Jo5oCR;A8Jj5oCQ;EACE,eAAA;A9Jm5oCV;A8Jj5oCQ;EACE,eAAA;A9Jm5oCV;A8J74oCQ;EACE,kBAAA;A9J+4oCV;A8Jr4oCY;EACE,eAAA;A9Ju4oCd;A8J/3oCgB;EACE,kBAAA;EACA,kBAAA;A9Ji4oClB;A8J13oCM;EACE,gBAAA;EACA,mBAAA;A9J43oCR;A8Jn3oCU;EACE,sBAAA;EACA,uBAAA;A9Jq3oCZ;A8Jp3oCY;EAHF;IAII,qBAAA;E9Ju3oCZ;AACF;A8Jn3oCU;EACE,mBAAA;EACA,mBAAA;EACA,iBAAA;A9Jq3oCZ;A8Jl3oCY;EACE,WAAA;EACA,WAAA;A9Jo3oCd;A8Jl3oCY;EACE,YAAA;EACA,OAAA;A9Jo3oCd;A8J72oCM;EACE,iBAAA;EACA,mBAAA;A9J+2oCR;A8J52oCM;EACE,kBAAA;EACA,mBAAA;A9J82oCR;A8J52oCQ;EACE,eAAA;A9J82oCV;A8Jz2oCQ;EACE,kBAAA;EACA,mBAAA;A9J22oCV;A8Jx2oCQ;EACE,kBAAA;EACA,mBAAA;A9J02oCV;A8Jt2oCU;EACE,iBAAA;A9Jw2oCZ;A8Jh2oCoB;;EAEE,yCAAA;A9Jk2oCtB;A8J71oCgB;;EAEE,YAAA;EACA,WAAA;A9J+1oClB;A8J51oCoB;;EACE,4BAAA;A9J+1oCtB;A8J71oCsB;;EACE,WAAA;A9Jg2oCxB;A8Jz1oCsB;;EACE,WAAA;EACA,WAAA;A9J41oCxB;A8Jt1oCoB;;EACE,iBAAA;A9Jy1oCtB;A8Jt1oCwB;;;EACE,4BAAA;A9J01oC1B;A8Jx1oC0B;;;EACE,WAAA;EACA,WAAA;A9J41oC5B;A8Jl1oCgB;EACE,WAAA;EACA,UAAA;A9Jo1oClB;A8Jj1oCgB;EACE,kBAAA;A9Jm1oClB;A8J/0oCc;EACE,kBAAA;A9Ji1oChB;A8J/0oCgB;EACE,YAAA;EACA,UAAA;A9Ji1oClB;A8J30oCU;EACE,4BAAA;A9J60oCZ;A8J30oCY;;EAEE,iBAAA;A9J60oCd;A8Jt0oCM;EACE,kBAAA;A9Jw0oCR;A8Jj0oCgB;;EAEE,WAAA;A9Jm0oClB;A8J7zoCQ;;EAEE,kBAAA;A9J+zoCV;A8J1zoCM;EACE,mBAAA;EACA,mBAAA;EACA,cAAA;A9J4zoCR;A8J3zoCQ;EACE,gBAAA;A9J6zoCV;A8JzzoCQ;EACE,kBAAA;EACA,mBAAA;EACA,cAAA;A9J2zoCV;A8JvzoCY;EACE,mBAAA;EACA,yBAAA;A9JyzoCd;A8JlzoCE;EACE,cAAA;A9JozoCJ;A8JhzoCI;EACE,iBAAA;A9JkzoCN;A8J7yoCU;EACE,mBAAA;EACA,mBAAA;A9J+yoCZ;A8JryoCU;EACE,kBAAA;A9JuyoCZ;A8JryoCU;EACE,iBAAA;A9JuyoCZ;A8J7xoCU;EACE,6BAAA;A9J+xoCZ;A8JpxoCU;EACE,WAAA;EACA,WAAA;A9JsxoCZ;A8J3woCY;EACE,kBAAA;EACA,kBAAA;A9J6woCd;A8JpwoCI;EACE,8EAAA;A9JswoCN;A8JrwoCM;EACE,YAAA;EACA,UAAA;A9JuwoCR;A8JrwoCM;EACE,YAAA;EACA,UAAA;A9JuwoCR;A8J/woCI;EACE,iEAAA;A9JixoCN;A8JhxoCM;EACE,YAAA;EACA,UAAA;A9JkxoCR;A8JhxoCM;EACE,YAAA;EACA,UAAA;A9JkxoCR;A8J1xoCI;EACE,iEAAA;A9J4xoCN;A8J3xoCM;EACE,YAAA;EACA,UAAA;A9J6xoCR;A8J3xoCM;EACE,YAAA;EACA,UAAA;A9J6xoCR;A8JryoCI;EACE,iEAAA;A9JuyoCN;A8JtyoCM;EACE,YAAA;EACA,UAAA;A9JwyoCR;A8JtyoCM;EACE,YAAA;EACA,UAAA;A9JwyoCR;A8JhzoCI;EACE,iEAAA;A9JkzoCN;A8JjzoCM;EACE,YAAA;EACA,UAAA;A9JmzoCR;A8JjzoCM;EACE,YAAA;EACA,UAAA;A9JmzoCR;A8J3zoCI;EACE,iEAAA;A9J6zoCN;A8J5zoCM;EACE,YAAA;EACA,UAAA;A9J8zoCR;A8J5zoCM;EACE,YAAA;EACA,UAAA;A9J8zoCR;A8Jt0oCI;EACE,iEAAA;A9Jw0oCN;A8Jv0oCM;EACE,YAAA;EACA,UAAA;A9Jy0oCR;A8Jv0oCM;EACE,YAAA;EACA,UAAA;A9Jy0oCR;A8Jj1oCI;EACE,iEAAA;A9Jm1oCN;A8Jl1oCM;EACE,YAAA;EACA,UAAA;A9Jo1oCR;A8Jl1oCM;EACE,YAAA;EACA,UAAA;A9Jo1oCR;A8J/0oCI;EACE,WAAA;EACA,YAAA;A9Ji1oCN;A8J70oCE;EACE,8BAAA;EACA,8BAAA;A9J+0oCJ;A8J70oCE;EACE,+BAAA;EACA,+BAAA;A9J+0oCJ;A8J70oCE;EACE,+BAAA;EACA,8BAAA;A9J+0oCJ;A8J50oCI;EACE,QAAA;A9J80oCN;A8Jz0oCM;EACE,iBAAA;A9J20oCR;A8J10oCQ;EACE,UAAA;EACA,YAAA;A9J40oCV;A8J30oCU;EAHF;IAII,UAAA;E9J80oCV;AACF;A8J50oCQ;EACE,WAAA;EACA,WAAA;A9J80oCV;A8Jx0oCQ;EACE,WAAA;EACA,WAAA;A9J00oCV;A8Jj0oCU;EACE,8BAAA;A9Jm0oCZ;A8Jl0oCY;EAFF;IAGI,8BAAA;E9Jq0oCZ;AACF;A8J/zoCE;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;A9Ji0oCJ;A8J7zoCM;EACE,mBAAA;EACA,mBAAA;A9J+zoCR;A8JvzoCU;EACE,gBAAA;EACA,mBAAA;A9JyzoCZ;A8JjzoCM;EACE,iBAAA;EACA,mBAAA;A9JmzoCR;A8J1yoCY;EACE,gBAAA;EACA,mBAAA;A9J4yoCd;A8J/xoCQ;;;;;;;;;;;;EAEE,WAAA;A9J2yoCV;A8JvyoCQ;;;EACE,WAAA;A9J2yoCV;A8JtyoCE;EACE,kBAAA;EACA,kBAAA;A9JwyoCJ;A8JnyoCQ;EACE,2BAAA;A9JqyoCV;A8J5xoCU;EACE,0BAAA;EACA,6BAAA;A9J8xoCZ;A8JxxoCE;EACE,kBAAA;EACA,kBAAA;A9J0xoCJ;A8JtxoCU;EACE,WAAA;EACA,WAAA;A9JwxoCZ;A8JtxoCU;EACE,WAAA;EACA,WAAA;A9JwxoCZ;A8JtxoCU;EACE,WAAA;EACA,WAAA;A9JwxoCZ;A8JtxoCU;EACE,WAAA;EACA,WAAA;A9JwxoCZ;A8JtxoCU;EACE,WAAA;EACA,WAAA;A9JwxoCZ;A8JtxoCU;EACE,WAAA;EACA,WAAA;A9JwxoCZ;A8JtxoCU;EACE,WAAA;EACA,WAAA;A9JwxoCZ;A8JtxoCU;EACE,WAAA;EACA,WAAA;A9JwxoCZ;A8JtxoCU;EACE,WAAA;EACA,WAAA;A9JwxoCZ;A8JtxoCU;EACE,YAAA;EACA,WAAA;A9JwxoCZ;A8JtxoCU;EACE,YAAA;EACA,WAAA;A9JwxoCZ;A8JtxoCU;EACE,YAAA;EACA,WAAA;A9JwxoCZ;A8JtxoCU;EACE,YAAA;EACA,WAAA;A9JwxoCZ;A8JtxoCU;EACE,YAAA;EACA,WAAA;A9JwxoCZ;A8JtxoCU;EACE,YAAA;EACA,WAAA;A9JwxoCZ;A8J/woCQ;EACE,OAAA;EACA,YAAA;A9JixoCV;A8J3woCgB;EACE,2BAAA;A9J6woClB;A8J9voCc;EACE,UAAA;EACA,YAAA;A9JgwoChB;A8JvvoCI;EACE,YAAA;EACA,UAAA;A9JyvoCN;A8JvvoCI;EACE,YAAA;EACA,UAAA;A9JyvoCN;A8JrvoCI;EACE,mBAAA;EACA,iBAAA;A9JuvoCN;A8JjvoCQ;EACE,UAAA;EACA,YAAA;A9JmvoCV;A8J3uoCQ;EACE,iBAAA;A9J6uoCV;A8JruoCQ;EACE,kBAAA;A9JuuoCV;A8J/toCQ;EACE,kBAAA;EACA,kBAAA;A9JiuoCV;A8J9toCU;EACE,WAAA;EACA,YAAA;A9JguoCZ;A8J/toCY;EACE,WAAA;EACA,WAAA;A9JiuoCd;A8J/toCY;EACE,WAAA;EACA,WAAA;A9JiuoCd;A8J1toCE;EACE,yBAAA;EACA,8BAAA;A9J4toCJ;A8JztoCI;EACE,WAAA;A9J2toCN;A8JxtoCE;;EAEE,oBAAA;A9J0toCJ;A8JxtoCE;EACE,WAAA;EACA,YAAA;A9J0toCJ;A8JxtoCE;EACE,UAAA;EACA,YAAA;A9J0toCJ;A8JvtoCI;EACE,mBAAA;A9JytoCN;A8JrtoCQ;EACE,iBAAA;A9JutoCV;A8JjtoCI;EACE,iBAAA;EACA,kBAAA;A9JmtoCN;A8JhtoCE;EACE,iBAAA;EACA,kBAAA;A9JktoCJ;A8JhtoCE;EACE,6BAAA;EACA,6BAAA;A9JktoCJ;A8JhtoCE;EACE,iBAAA;EACA,mBAAA;A9JktoCJ;A8JhtoCE;EACE,iBAAA;EACA,mBAAA;A9JktoCJ;A8JhtoCE;EACE,gBAAA;EACA,mBAAA;A9JktoCJ;A8JhtoCE;EACE,4BAAA;A9JktoCJ;A8JhtoCE;EACE,iBAAA;EACA,mBAAA;A9JktoCJ;A8JhtoCE;EACE,6BAAA;EACA,+BAAA;A9JktoCJ;A8JhtoCE;EACE,eAAA;EACA,mBAAA;A9JktoCJ;A8JhtoCE;EACE,6BAAA;EACA,6BAAA;A9JktoCJ;A8JhtoCE;EACE,8BAAA;A9JktoCJ;A8JhtoCE;EACE,yCAAA;EACA,8BAAA;A9JktoCJ;A8JhtoCE;EACE,sBAAA;A9JktoCJ;A8JhtoCE;EACE,uBAAA;A9JktoCJ;A8JhtoCE;EACE,2BAAA;A9JktoCJ;A8JhtoCE;EACE,yCAAA;EACA,8BAAA;A9JktoCJ;A8JhtoCE;EACE,0BAAA;EACA,8BAAA;A9JktoCJ;A8JhtoCE;EACE,2BAAA;EACA,8BAAA;A9JktoCJ;A8JhtoCE;EACE,6BAAA;EACA,gCAAA;A9JktoCJ;A8JhtoCE;EACE,cAAA;A9JktoCJ;A8J9soCM;;EAEE,yBAAA;EACA,4BAAA;EACA,gCAAA;EACA,mCAAA;A9JgtoCR;A8J9soCM;EACE,+BAAA;EACA,kCAAA;EACA,0BAAA;EACA,6BAAA;A9JgtoCR;A8J9soCM;EACE,2BAAA;A9JgtoCR;A8J5soCI;EACE,+BAAA;EACA,kCAAA;EACA,0BAAA;EACA,6BAAA;A9J8soCN;A8J3soCM;;EAEE,kBAAA;EACA,kBAAA;A9J6soCR;A8JzsoCM;;EAEE,kBAAA;A9J2soCR;A8JtsoCQ;;EAEE,kBAAA;A9JwsoCV;A8JpsoCQ;;EAEE,kBAAA;A9JssoCV;A8JjsoCE;EACE,8BAAA;EACA,4BAAA;A9JmsoCJ;A8JjsoCE;EACE,4BAAA;EACA,8BAAA;A9JmsoCJ;A8JjsoCE;EACE,6BAAA;EACA,6BAAA;A9JmsoCJ;A8JjsoCE;EACE,iBAAA;EACA,mBAAA;A9JmsoCJ;A8JjsoCE;EACE,0CAAA;EACA,6BAAA;A9JmsoCJ;A8JjsoCE;EACE,mBAAA;EACA,kBAAA;A9JmsoCJ;A8JjsoCE;EACE,gCAAA;EACA,8BAAA;A9JmsoCJ;A8JjsoCE;EACE,8BAAA;EACA,8BAAA;A9JmsoCJ;A8JjsoCE;EACE,+BAAA;EACA,6BAAA;A9JmsoCJ;A8JjsoCE;EACE,+BAAA;EACA,+BAAA;A9JmsoCJ;A8JhsoCI;EACE,0BAAA;A9JksoCN;A8J/roCE;EACE,iBAAA;A9JisoCJ;A8J/roCE;EACE,WAAA;A9JisoCJ;A8J9roCI;EACE,iBAAA;EACA,eAAA;A9JgsoCN;A8J7roCE;EACE,iBAAA;A9J+roCJ;A8J9roCI;EACE,kBAAA;A9JgsoCN;A8J7roCM;EACE,YAAA;A9J+roCR;A8J7roCM;EACE,WAAA;A9J+roCR;A8J7roCM;EACE,UAAA;EACA,YAAA;A9J+roCR;A8J9roCQ;EACE,gBAAA;A9JgsoCV;A8J/roCU;EACE,gBAAA;EACA,mBAAA;A9JisoCZ;A8J7roCM;EACE,YAAA;A9J+roCR;A8J5roCI;EACE,OAAA;EACA,YAAA;A9J8roCN;A8J1roCQ;EACE,gBAAA;EACA,mBAAA;A9J4roCV;A8JzroCM;EACE,iBAAA;EACA,mBAAA;A9J2roCR;A8JzroCM;EACE,gBAAA;EACA,mBAAA;A9J2roCR;A8JvroCE;EACE,kBAAA;A9JyroCJ;A8JvroCE;EACE,kBAAA;A9JyroCJ;A8JtroCI;EACE,oCAAA;A9JwroCN;A8JproCI;EACE,oBAAA;EACA,cAAA;A9JsroCN;A8JjroCM;EACE,gBAAA;EACA,eAAA;A9JmroCR;A8J9qoCI;EACE,qBAAA;EACA,mBAAA;A9JgroCN;A8J/qoCM;EACE,oBAAA;EACA,oBAAA;EACA,YAAA;A9JiroCR;A8J7qoCE;;EAEE,iBAAA;A9J+qoCJ;A8J7qoCE;EACE,iBAAA;EACA,mBAAA;A9J+qoCJ;A8J7qoCE;;EAEE,gCAAA;EACA,mCAAA;EACA,yBAAA;EACA,4BAAA;A9J+qoCJ;A8J7qoCE;EACE,kBAAA;EACA,kBAAA;EACA,+BAAA;EACA,kCAAA;EACA,0BAAA;EACA,6BAAA;A9J+qoCJ;A8J7qoCE;;;;EAIE,0DAAA;EACA,mCAAA;EACA,mBAAA;A9J+qoCJ;A8J7qoCE;EACE,yBAAA;EACA,4BAAA;EACA,0BAAA;EACA,6BAAA;A9J+qoCJ;A8J7qoCE;;;;;;EAME,yBAAA;EACA,4BAAA;EACA,gCAAA;EACA,mCAAA;A9J+qoCJ;A8J7qoCE;;;;;;EAME,yBAAA;EACA,4BAAA;EACA,0BAAA;EACA,6BAAA;A9J+qoCJ;A8J7qoCE;EACE,gBAAA;A9J+qoCJ;A8JxqoCU;EACE,mBAAA;A9J0qoCZ;A8JjqoCQ;EACE,mBAAA;EACA,mBAAA;A9JmqoCV;A8J9poCM;EACE,WAAA;EACA,WAAA;A9JgqoCR;A8J3poCI;EACE,kBAAA;EACA,kBAAA;A9J6poCN;A8J1poCM;EACE,UAAA;EACA,YAAA;EACA,sCAAA;EACA,mBAAA;A9J4poCR;A8J1poCM;EACE,UAAA;EACA,YAAA;EACA,2BAAA;EACA,mBAAA;A9J4poCR;A8JtpoCM;EACE,iBAAA;EACA,mBAAA;A9JwpoCR;A8JnpoCI;EACE,WAAA;EACA,WAAA;A9JqpoCN;A8JnpoCI;EACE,QAAA;EACA,WAAA;A9JqpoCN;A8JppoCM;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;A9JspoCR;A8JnpoCI;EACE,kBAAA;EACA,kBAAA;A9JqpoCN;A8JppoCM;EACE,YAAA;A9JspoCR;A8JppoCM;EACE,8BAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;A9JspoCR;A8JhpoCM;EACE,8BAAA;EACA,mBAAA;A9JkpoCR;A8J9ooCM;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;A9JgpoCR;A8J1ooCM;EACE,WAAA;EACA,WAAA;A9J4ooCR;A8JrooCQ;EACE,WAAA;EACA,UAAA;EACA,gBAAA;A9JuooCV;A8J/noCY;EACE,WAAA;EACA,UAAA;EACA,gBAAA;A9JiooCd;A8JxnoCM;EACE,WAAA;A9J0noCR;A8JpnoCU;EACE,WAAA;A9JsnoCZ;A8J/moCE;EAEI;IACE,WAAA;IACA,WAAA;E9JgnoCN;E8J9moCI;IACE,QAAA;IACA,WAAA;E9JgnoCN;E8J/moCM;IACE,UAAA;IACA,WAAA;IACA,kBAAA;IACA,mBAAA;E9JinoCR;E8J9moCI;IACE,kBAAA;IACA,kBAAA;E9JgnoCN;E8J/moCM;IACE,YAAA;E9JinoCR;E8J/moCM;IACE,8BAAA;IACA,mBAAA;IACA,UAAA;IACA,YAAA;E9JinoCR;AACF;A8J3moCM;EACE,yCAAA;EACA,8BAAA;A9J6moCR;A8JvmoCM;EACE,mBAAA;EACA,iBAAA;A9JymoCR;A8JpmoCI;EACE,gBAAA;EACA,mBAAA;A9JsmoCN;A8JlmoCQ;EACE,iBAAA;EACA,mBAAA;A9JomoCV;A8JnmoCU;EACE,cAAA;A9JqmoCZ;A8J5loCQ;EACE,WAAA;EACA,YAAA;A9J8loCV;A8J7loCU;EACE,iBAAA;EACA,mBAAA;A9J+loCZ;A8J9loCY;EACE,cAAA;A9JgmoCd;A8JvloCI;EACE,UAAA;EACA,YAAA;A9JyloCN;A8JploCM;EACE,kBAAA;EACA,oBAAA;A9JsloCR;A8JlloCE;;EAEE,iBAAA;A9JoloCJ;A8J/koCQ;EACE,UAAA;EACA,YAAA;A9JiloCV;A8J7koCQ;EACE,iBAAA;EACA,mBAAA;A9J+koCV;A8JxkoCM;EACE,sBAAA;A9J0koCR;A8JzkoCQ;EACE,mBAAA;EACA,mBAAA;A9J2koCV;A8J1koCU;EACE,WAAA;EACA,WAAA;A9J4koCZ;A8JtkoCE;EACE,mBAAA;EACA,iBAAA;A9JwkoCJ;A8JlkoCQ;EACE,iBAAA;EACA,mBAAA;A9JokoCV;A8J7joCI;EACE,mBAAA;EACA,mBAAA;A9J+joCN;A8J1joCI;EACE,UAAA;EACA,YAAA;A9J4joCN;A8JxjoCI;EACE,cAAA;A9J0joCN;A8JpjoCM;EACE,iBAAA;EACA,mBAAA;A9JsjoCR;A8JhjoCI;EACE,iBAAA;EACA,mBAAA;A9JkjoCN;A8JjjoCM;EACE,cAAA;A9JmjoCR;A8JjjoCM;EACE,SAAA;EACA,YAAA;A9JmjoCR;A8J9ioCI;EACE,iBAAA;EACA,mBAAA;A9JgjoCN;A8J3ioCM;EACE,sBAAA;A9J6ioCR;A8JtioCM;EACE,WAAA;EACA,WAAA;A9JwioCR;A8JhioCQ;EACE,gBAAA;EACA,mBAAA;A9JkioCV;A8JrioCM;EAKE,UAAA;EACA,YAAA;A9JmioCR;A8J9hoCY;EACE,gBAAA;A9JgioCd;A8J1hoCI;EACE,UAAA;EACA,YAAA;A9J4hoCN;A8JvhoCM;EACE,iBAAA;EACA,mBAAA;A9JyhoCR;A8JxhoCQ;EACE,cAAA;A9J0hoCV;A8JjhoCU;EACE,mBAAA;EACA,6BAAA;EACA,gCAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;A9JmhoCZ;A8J/goCM;EACE,kBAAA;EACA,kBAAA;A9JihoCR;A8JhhoCQ;EACE,4BAAA;EACA,+BAAA;A9JkhoCV;A8J3goCM;EACE,iBAAA;EACA,mBAAA;A9J6goCR;A8JvgoCI;EACE,YAAA;A9JygoCN;A8JlgoCQ;EACE,uBAAA;A9JogoCV;A8JngoCU;EACE,0BAAA;A9JqgoCZ;A8Jz/nCc;EACE,6BAAA;EACA,6BAAA;A9J2/nChB;A8Jj/nCI;;;;EAEE,+BAAA;EACA,kCAAA;EACA,0BAAA;EACA,6BAAA;A9Jq/nCN;A8Jl/nCE;EACE,sBAAA;EACA,mBAAA;A9Jo/nCJ;A8Jn/nCI;EACE,YAAA;EACA,kBAAA;EACA,oBAAA;A9Jq/nCN;A8J/+nCQ;EACE,iBAAA;A9Ji/nCV;A8J3+nCU;;EACE,YAAA;EACA,UAAA;A9J8+nCZ;A8Jr+nCM;EACE,gBAAA;EACA,kBAAA;A9Ju+nCR;A8Jp+nCQ;EACE,eAAA;EACA,mBAAA;A9Js+nCV;A8Jh+nCQ;EACE,iBAAA;A9Jk+nCV;A8Jh+nCY;EACE,mBAAA;EACA,iBAAA;A9Jk+nCd;A8J79nCM;EACE,gBAAA;A9J+9nCR;A8Jz9nCU;EACE,WAAA;A9J29nCZ;A8Jp9nCQ;EACE,+BAAA;A9Js9nCV;A8Jn9nCM;EACE,qCAAA;EACA,wCAAA;EACA,kBAAA;A9Jq9nCR;A8Jh9nCE;EACE,WAAA;EACA,mBAAA;EACA,mBAAA;A9Jk9nCJ;A8Jh9nCE;EACE,cAAA;A9Jk9nCJ;A8J/8nCI;EACE,cAAA;EACA,iBAAA;A9Ji9nCN;A8J98nCQ;EACE,YAAA;A9Jg9nCV;A8J98nCQ;EACE,WAAA;A9Jg9nCV;A8J78nCU;EACE,cAAA;A9J+8nCZ;A8J18nCI;EACE,iBAAA;A9J48nCN;A8J18nCI;EACE,mBAAA;EACA,kBAAA;A9J48nCN;A8Jv8nCM;EACE,0BAAA;A9Jy8nCR;A8Jp8nCI;EACE,0BAAA;A9Js8nCN;A8Jj8nCI;EACE,iBAAA;EACA,mBAAA;A9Jm8nCN;A8J/7nCI;EACE,mBAAA;EACA,iBAAA;A9Ji8nCN;A8J77nCI;EACE,0CAAA;EACA,6CAAA;EACA,qCAAA;EACA,wCAAA;A9J+7nCN;A8Jz7nCM;EACE,YAAA;A9J27nCR;A8Jx7nCI;EACE,YAAA;A9J07nCN;A8Jv7nCM;EACE,0BAAA;A9Jy7nCR;A8Jx7nCQ;EACE,YAAA;A9J07nCV;A8Jt7nCI;EACE,YAAA;EACA,qBAAA;A9Jw7nCN;A8Jn7nCM;EACE,QAAA;A9Jq7nCR;A8Jh7nCI;EACE,mBAAA;A9Jk7nCN;A8J16nCU;EACE,cAAA;A9J46nCZ;A8Jj6nCU;EACE,4BAAA;A9Jm6nCZ;A8J/5nCc;;EAEE,yBAAA;EACA,4BAAA;EACA,gCAAA;EACA,mCAAA;A9Ji6nChB;A8J/5nCc;;EAEE,+BAAA;EACA,kCAAA;EACA,0BAAA;EACA,6BAAA;A9Ji6nChB;A8J95nCY;EACE,qCAAA;EACA,wCAAA;A9Jg6nCd;A8J95nCY;EACE,2BlF1iEI;A5E08rClB;A8J95nCY;EACE,mBAAA;EACA,iBAAA;A9Jg6nCd;A8Jx5nCI;EACE,iBAAA;A9J05nCN;A8Jz5nCM;EACE,iBAAA;A9J25nCR;A8Jz5nCM;EACE,4BAAA;A9J25nCR;A8Jt5nCY;;EAEE,yBAAA;EACA,4BAAA;EACA,gCAAA;EACA,mCAAA;A9Jw5nCd;A8Jt5nCY;;EAEE,+BAAA;EACA,kCAAA;EACA,0BAAA;EACA,6BAAA;A9Jw5nCd;A8Jr5nCU;EACE,mBAAA;EACA,iBAAA;A9Ju5nCZ;A8Jh5nCI;EACE,iBAAA;A9Jk5nCN;A8Jx4nCgB;EACE,yBAAA;EACA,4BAAA;EACA,gCAAA;EACA,mCAAA;A9J04nClB;A8J73nCY;;EACE,mBAAA;EACA,iBAAA;A9Jg4nCd;A8J73nCc;;EACE,6BAAA;A9Jg4nChB;A8Jj3nCgB;EACE,4BAAA;A9Jm3nClB;A8J/2nCoB;;EAEE,yBAAA;EACA,4BAAA;EACA,gCAAA;EACA,mCAAA;A9Ji3nCtB;A8J/2nCoB;;EAEE,+BAAA;EACA,kCAAA;EACA,0BAAA;EACA,6BAAA;A9Ji3nCtB;A8J92nCkB;EACE,qCAAA;EACA,wCAAA;A9Jg3nCpB;A8J92nCkB;EACE,2BlFnqEF;A5EmhsClB;A8Jl2nCU;EACE,mBAAA;EACA,iBAAA;A9Jo2nCZ;A8Jj2nCQ;EACE,mBAAA;EACA,mBAAA;A9Jm2nCV;A8J31nCM;EACE,yDAAA;A9J61nCR;A8J51nCQ;EACE,2BAAA;A9J81nCV;A8Jv1nCI;EACE,iBAAA;EACA,mBAAA;A9Jy1nCN;A8Jt1nCE;EACE,qBAAA;A9Jw1nCJ;A8Jv1nCI;EACE,gCAAA;EACA,6BAAA;A9Jy1nCN;A8Jt1nCE;EACE,4BAAA;EACA,iBAAA;A9Jw1nCJ;A8Jp1nCI;EACE,iBAAA;A9Js1nCN;A8Jj1nCM;EACE,qBAAA;A9Jm1nCR;A8Jh1nCI;EACE,gBAAA;A9Jk1nCN;A8J90nCI;EACE,mBAAA;A9Jg1nCN;A8J30nCI;EACE,UAAA;EACA,YAAA;A9J60nCN;A8J30nCI;EACE,kBAAA;A9J60nCN;A8J10nCE;EACE,iBAAA;EACA,WAAA;EACA,YAAA;A9J40nCJ;A8J30nCI;EACE,UAAA;EACA,YAAA;A9J60nCN;A8J30nCI;EACE,UAAA;EACA,YAAA;A9J60nCN;A8J30nCI;EACE,gBAAA;A9J60nCN;A8Jv0nCM;EACE,WAAA;A9Jy0nCR;A8Jp0nCI;EACE,eAAA;EACA,mBAAA;A9Js0nCN;A8Jr0nCM;EACE,QAAA;EACA,mBAAA;EACA,WAAA;A9Ju0nCR;A8J9znCU;EACE,iBAAA;EACA,kBAAA;EACA,+BAAA;A9Jg0nCZ;A8J9znCU;EACE,iBAAA;A9Jg0nCZ;A8J1znCM;EACE,mBAAA;EACA,kBAAA;EACA,yBAAA;A9J4znCR;A8J3znCQ;EACE,mBAAA;EACA,kBAAA;EACA,yBAAA;A9J6znCV;A8JxznCM;EACE,eAAA;EACA,uBAAA;A9J0znCR;A8JzznCQ;EACE,eAAA;EACA,uBAAA;A9J2znCV;A8JxznCU;EACE,mBAAA;EACA,iBAAA;A9J0znCZ;A8JxznCU;EACE,mBAAA;EACA,iBAAA;A9J0znCZ;A8JrznCQ;EACE,mBAAA;A9JuznCV;A8JrznCQ;EACE,iBAAA;EACA,mBAAA;A9JuznCV;A8JnznCY;EACE,iBAAA;A9JqznCd;A8JnznCY;EACE,eAAA;A9JqznCd;A8J1ynCM;EACE,iBAAA;A9J4ynCR;A8J3ynCQ;EACE,YAAA;EACA,OAAA;A9J6ynCV;A8J5ynCU;EAHF;IAII,UAAA;E9J+ynCV;AACF;A8J5ynCU;EACE;IACE,aAAA;E9J8ynCZ;AACF;A8J5ynCU;EACE,YAAA;EACA,OAAA;A9J8ynCZ;A8JzynCY;EACE,cAAA;EACA,iBAAA;A9J2ynCd;A8JzynCY;EACE,QAAA;EACA,WAAA;A9J2ynCd;A8JzynCY;EACE,UAAA;EACA,YAAA;A9J2ynCd;A8JtynCkB;EACE,WAAA;EACA,WAAA;A9JwynCpB;A8JtynCkB;EACE,WAAA;EACA,WAAA;A9JwynCpB;A8JpynCc;EACE,eAAA;EACA,2BAAA;A9JsynChB;A8JnynCY;EACE,mBAAA;EACA,eAAA;A9JqynCd;A8Jt0nCU;EAmCE,iBAAA;A9JsynCZ;A8JpynCc;EACE,+BAAA;EACA,6BAAA;A9JsynChB;A8J/xnCY;EACE,mBAAA;EACA,iBAAA;A9JiynCd;A8J5xnCM;EACE,kBAAA;EACA,oBAAA;A9J8xnCR;A8J3xnCI;EACE,eAAA;A9J6xnCN;A8JxxnCM;EACE,cAAA;EACA,WAAA;EACA,UAAA;A9J0xnCR;A8JzxnCQ;EACE,yBAAA;EACA,qBAAA;A9J2xnCV;A8JzxnCQ;EACE,yBAAA;EACA,qBAAA;A9J2xnCV;A8JzxnCQ;EACE,0BAAA;A9J2xnCV;A8JzxnCY;EACE,6BAAA;A9J2xnCd;A8JzxnCY;EACE,mBAAA;EACA,iBAAA;A9J2xnCd;A8JxxnCU;EACE,iBAAA;EACA,mBAAA;A9J0xnCZ;A8JhxnCQ;EACE,mBAAA;EACA,mBAAA;A9JkxnCV;A8J5wnCI;EACE,gBAAA;EACA,eAAA;A9J8wnCN;A8J3wnCE;EACE,4BAAA;A9J6wnCJ;A8J5wnCI;EACE,WAAA;EACA,QAAA;A9J8wnCN;A8JxwnCM;EACE,+BAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;A9J0wnCR;A8J9wnCM;EACE,+BAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;A9JgxnCR;A8JpxnCM;EACE,+BAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;A9JsxnCR;A8J1xnCM;EACE,+BAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;A9J4xnCR;A8JhynCM;EACE,+BAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;A9JkynCR;A8JtynCM;EACE,+BAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;A9JwynCR;A8J5ynCM;EACE,+BAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;A9J8ynCR;A8JlznCM;EACE,+BAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;A9JoznCR;A8J/ynCI;EACE,OAAA;EACA,YAAA;A9JiznCN;A8JhznCM;EACE,eAAA;EACA,oBAAA;A9JkznCR;A8J7ynCI;EACE,qBAAA;A9J+ynCN;A8J1ynCI;EACE,kBAAA;EACA,iBAAA;A9J4ynCN;A8J3ynCM;EACE,gBAAA;A9J6ynCR;A8J5ynCQ;EACE,kBAAA;EACA,oBAAA;A9J8ynCV;A8J7ynCU;EACE,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;A9J+ynCZ;A8J7ynCU;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;A9J+ynCZ;A8JxynCQ;EACE,uBAAA;EACA,mBAAA;A9J0ynCV;A8JzynCU;EACE,iBAAA;A9J2ynCZ;A8JrynCM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;A9JuynCR;A8JjynCM;EACE,iBAAA;EACA,mBAAA;A9JmynCR;A8JjynCM;EACE,iBAAA;A9JmynCR;A8J/xnCM;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;A9JiynCR;A8JhynCQ;EAJF;IAKI,kBAAA;E9JmynCR;AACF;A8JhynCI;EACE,gBAAA;A9JkynCN;A8JjynCM;EACE,eAAA;EACA,mBAAA;A9JmynCR;A8JlynCQ;EACE,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;A9JoynCV;A8J5xnCM;EACE,iBAAA;EACA,eAAA;EACA,YAAA;A9J8xnCR;A8JxxnCM;EACE,2BAAA;A9J0xnCR;A8J/wnCc;EACE,6BAAA;A9JixnChB;A8JxwnCI;EACE,YAAA;EACA,gBAAA;EACA,eAAA;A9J0wnCN;A8JtwnCQ;EACE,UAAA;EACA,YAAA;A9JwwnCV;A8JpwnCI;EACE,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;A9JswnCN;A8JpwnCI;EACE,+BAAA;EACA,kBAAA;A9JswnCN;A8JrwnCM;EACE,gBAAA;A9JuwnCR;A8JrwnCM;EACE,6BAAA;A9JuwnCR;A8JjwnCU;EACE,mBAAA;EACA,mBAAA;A9JmwnCZ;A8JhwnCY;EACE,0BAAA;A9JkwnCd;A8J7vnCM;EACE,8BAAA;A9J+vnCR;A8JzvnCU;EACE,kBAAA;A9J2vnCZ;A8JpvnCI;EACE,gBAAA;A9JsvnCN;A8JlvnCI;EACE,WAAA;EACA,WAAA;A9JovnCN;A8J9unCQ;EACE,eAAA;EACA,oBAAA;A9JgvnCV;A8J/unCU;EACE,sBAAA;A9JivnCZ;A8J9unCQ;EACE,YAAA;A9JgvnCV;A8J1unCE;;;;EAIE,YAAA;A9J4unCJ;A8J1unCE;;;;EAIE,iBAAA;A9J4unCJ;A8J1unCE;EACE,mBAAA;EACA,mBAAA;A9J4unCJ;A8JtunCU;EACE,yBAAA;A9JwunCZ;A8JhunCI;EACE,gBAAA;A9JkunCN;A8J3tnCQ;EACE,+BAAA;EACA,6BAAA;A9J6tnCV;A8JxtnCE;EACE,gBAAA;A9J0tnCJ;A8JvtnCI;EACE,WAAA;EACA,WAAA;A9JytnCN;A8JntnCM;EACE,kBAAA;EACA,cAAA;A9JqtnCR;A8JltnCI;EACE,YAAA;A9JotnCN;A8JltnCI;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;A9JotnCN;A8JltnCI;EACE,YAAA;A9JotnCN;A8JltnCI;EACE,cAAA;A9JotnCN;A8JjtnCM;EACE,gBAAA;EACA,mBAAA;A9JmtnCR;A8JltnCQ;EACE,cAAA;A9JotnCV;A8J1snCc;;EACE,iBAAA;A9J6snChB;A8JlsnCQ;EACE,6BAAA;EACA,yBAAA;EACA,WAAA;A9JosnCV;A8J3rnCU;EACE,kBAAA;EACA,mBAAA;A9J6rnCZ;A8J5rnCY;EACE,oBAAA;EACA,YAAA;A9J8rnCd;A8J5rnCY;EACE,sBAAA;EACA,YAAA;A9J8rnCd;A8JvrnCE;;;;;EAKE,oBAAA;EACA,YAAA;A9JyrnCJ;A8JvrnCE;EACE,+BAAA;EACA,0BAAA;A9JyrnCJ;A8JjrnCc;EACE,gBAAA;EACA,eAAA;A9JmrnChB;A8JjrnCc;EACE,gBAAA;EACA,eAAA;A9JmrnChB;A8JzqnCM;EACE,iBAAA;EACA,eAAA;A9J2qnCR;A8JnqnCQ;EACE,2BAAA;A9JqqnCV;A8JnqnCQ;EACE,0BAAA;EACA,6BAAA;A9JqqnCV;A8JlqnCU;EACE,sBAAA;EACA,yBAAA;EACA,4BAAA;A9JoqnCZ;A8J5pnCI;EACE,yBAAA;EACA,4BAAA;EACA,2CAAA;EACA,8CAAA;A9J8pnCN;A8J3pnCM;EACE,sBAAA;EACA,qCAAA;EACA,wCAAA;A9J6pnCR;A8J1pnCI;EACE,mBAAA;EACA,iBAAA;A9J4pnCN;A8JtpnCM;EACE,yBAAA;A9JwpnCR;A8JlpnCI;EACE,kBAAA;EACA,gBAAA;A9JopnCN;A8J9onCQ;EACE,YAAA;EACA,UAAA;A9JgpnCV;A8J5onCI;;EAEE,0BAAA;A9J8onCN;A8J5onCI;;EAEE,QAAA;EACA,WAAA;EACA,+BAAA;A9J8onCN;A8J5onCI;EACE,8BAAA;A9J8onCN;A8J5onCI;EACE,0BAAA;EACA,yBAAA;A9J8onCN;A8J5onCI;EACE,YAAA;EACA,WAAA;A9J8onCN;A8J7onCM;EACE,QAAA;EACA,WAAA;A9J+onCR;A8J1onCI;EACE,gBAAA;A9J4onCN;A8JvonCM;EACE,iBAAA;EACA,eAAA;A9JyonCR;A8JronCE;EACE,gBAAA;A9JuonCJ;A8JronCE;EACE,YAAA;A9JuonCJ;A8JponCI;EACE,OAAA;EACA,YAAA;A9JsonCN;A8JhonCM;EACE,YAAA;A9JkonCR;A8J/nnCI;EACE,YAAA;A9JionCN;A8J/nnCI;EACE,iBAAA;A9JionCN;A8J9nnCM;EACE,WAAA;A9JgonCR;A8J3nnCI;EACE,gBAAA;A9J6nnCN;A8J1nnCM;EACE,YAAA;A9J4nnCR;A8JtnnCI;EACE,kBAAA;EACA,kBAAA;EACA,gCAAA;EACA,2BAAA;A9JwnnCN;A8JnnnCI;EACE,eAAA;EACA,iBAAA;A9JqnnCN;A8JnnnCQ;EACE,0BAAA;EACA,6BAAA;EACA,+BAAA;EACA,kCAAA;A9JqnnCV;A8JnnnCQ;EACE,gCAAA;EACA,mCAAA;EACA,yBAAA;EACA,4BAAA;A9JqnnCV;A8J9mnCM;EACE,gBAAA;A9JgnnCR;A8J/mnCQ;EACE,+BAAA;EACA,kCAAA;A9JinnCV;A8J/mnCQ;EACE,gCAAA;EACA,mCAAA;A9JinnCV;A8J1mnCM;EACE,0BAAA;EACA,6BAAA;A9J4mnCR;A8JvmnCI;EACE,iBAAA;EACA,kBAAA;A9JymnCN;A8JtmnCE;EACE,mBAAA;EACA,mBAAA;A9JwmnCJ;A8JtmnCM;EACE,UAAA;A9JwmnCR;A8JpmnCE;EACE,gBAAA;A9JsmnCJ;A8JrmnCI;;EAEE,iBAAA;EACA,eAAA;A9JumnCN;A8JpmnCE;EACE,cAAA;EACA,eAAA;A9JsmnCJ;A8JnmnCE;EACE,iBAAA;A9JqmnCJ;A8JjmnCI;EACE,iBAAA;EACA,kBAAA;A9JmmnCN;A8J9lnCI;EACE,iBAAA;EACA,mBAAA;A9JgmnCN;A8J9lnCI;EACE,iBAAA;EACA,mBAAA;A9JgmnCN;A8J5lnCI;EACE,iBAAA;EACA,gBAAA;A9J8lnCN;A8J3lnCE;EACE,8BAAA;EACA,0BAAA;A9J6lnCJ;A8J3lnCE;EACE,UAAA;EACA,YAAA;A9J6lnCJ;A8J3lnCE;EACE,UAAA;EACA,YAAA;A9J6lnCJ;A8JxlnCQ;EACE,iBAAA;A9J0lnCV;A8JllnCQ;EACE,SAAA;EACA,YAAA;A9JolnCV;A8JjlnCM;EACE,SAAA;EACA,YAAA;A9JmlnCR;A8J5knCM;EACE,WAAA;EACA,WAAA;A9J8knCR;A8J5knCM;EACE,WAAA;EACA,WAAA;A9J8knCR;A8JjknCkB;EACE,YAAA;EACA,WAAA;A9JmknCpB;A8JzjnCQ;;EACE,iBAAA;A9J4jnCV;A8JrjnCI;EACE,mBAAA;EACA,eAAA;A9JujnCN;A8JnjnCI;EACE,iBAAA;EACA,eAAA;A9JqjnCN;A8JjjnCI;EACE,gBAAA;A9JmjnCN;A8J1inCM;;;;EACE,YAAA;A9J+inCR;A8J7inCM;;;;EACE,YAAA;A9JkjnCR;A8J7inCE;EACE,WAAA;EACA,UAAA;A9J+inCJ;A8J7inCE;EACE,WAAA;EACA,UAAA;A9J+inCJ;A8J7inCE;EACE,WAAA;EACA,UAAA;A9J+inCJ;A8J1inCM;EACE,gBAAA;A9J4inCR;A8J1inCU;EACE,+BAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;A9J4inCZ;A8JninCM;EACE,qBAAA;EACA,uBAAA;A9JqinCR;A8JjinCM;EACE,YAAA;A9JminCR;A8J7hnCM;EACE,iBAAA;A9J+hnCR;A8J3hnCE;EACE,iBAAA;A9J6hnCJ;A8J3hnCE;EACE,gBAAA;A9J6hnCJ;A8J5hnCI;EACE,iBAAA;EACA,kBAAA;A9J8hnCN;A8J3hnCE;EACE,kBAAA;EACA,mBAAA;A9J6hnCJ;A8JzhnCI;;EACE,gBAAA;A9J4hnCN;A8JxhnCE;EACE,iBAAA;A9J0hnCJ;A8JxhnCE;EACE,WAAA;EACA,WAAA;A9J0hnCJ;A8JzhnCI;EACE,kBAAA;A9J2hnCN;A8JvhnCI;EACE,OAAA;EACA,YAAA;A9JyhnCN;A8JvhnCI;EACE,QAAA;EACA,WAAA;A9JyhnCN;A8JthnCE;EACE,YAAA;EACA,kBAAA;EACA,mBAAA;A9JwhnCJ;A8JrhnCE;EACE,gBAAA;A9JuhnCJ;A8JnhnCM;EACE,kBAAA;A9JqhnCR;A8JjhnCM;EACE,iBAAA;A9JmhnCR;A8J/gnCI;EACE,mBAAA;EACA,mBAAA;A9JihnCN;A8J9gnCM;EACE,mBAAA;EACA,mBAAA;A9JghnCR;A8J9gnCU;EACE,QAAA;EACA,WAAA;A9JghnCZ;A8J9gnCU;EACE,QAAA;EACA,WAAA;A9JghnCZ;A8JzgnCE;EACE,qBAAA;EACA,kBAAA;A9J2gnCJ;A8JvgnCI;EACE,UAAA;EACA,YAAA;A9JygnCN;A8JpgnCI;EACE,mBAAA;EACA,mBAAA;A9JsgnCN;A8JrgnCM;EACE,QAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;A9JugnCR;A8JjgnCM;EACE,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;A9JmgnCR;A8J7/mCI;EACE,+BAAA;EACA,8BAAA;A9J+/mCN;A8J3/mCI;EACE,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;A9J6/mCN;A8Jx/mCM;EACE,WAAA;EACA,8BAAA;EACA,mBAAA;A9J0/mCR;A8Jz/mCQ;EACE,WAAA;EACA,UAAA;EACA,gBAAA;A9J2/mCV;A8Jz/mCQ;EACE,WAAA;EACA,UAAA;EACA,0BAAA;EACA,+BAAA;A9J2/mCV;A8Jr/mCI;EACE,WAAA;EACA,WAAA;A9Ju/mCN;A8Jn/mCE;EACE,QAAA;EACA,WAAA;A9Jq/mCJ;A8Jn/mCE;EACE,YAAA;EACA,WAAA;A9Jq/mCJ;A8Jj/mCM;EACE,iBAAA;A9Jm/mCR;A8Jj/mCM;EACE,gBAAA;A9Jm/mCR;A8Jl/mCQ;EACE,gBAAA;EACA,mBAAA;A9Jo/mCV;A8Jl/mCQ;EAGE,8BAAA;A9Jo/mCV;A8J9+mCI;EACE,mBAAA;EACA,mBAAA;A9Jg/mCN;A8J3+mCM;EACE,gBAAA;A9J6+mCR;A8Jz+mCE;EACE,iBAAA;A9J2+mCJ;A8Jx+mCI;EACE,gBAAA;A9J0+mCN;A8Jz+mCM;EACE,YAAA;A9J2+mCR;A8Jp+mCM;EACE,kBAAA;A9Js+mCR;A8Jn+mCQ;EACE,eAAA;A9Jq+mCV;A8Jh+mCE;EACE,iBAAA;A9Jk+mCJ;A8Jh+mCE;EACE,WAAA;A9Jk+mCJ;A8Jh+mCE;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;A9Jk+mCJ;A8J99mCI;EACE,2BAAA;A9Jg+mCN;A8J79mCM;EACE,gCAAA;A9J+9mCR;A8Jz9mCM;EACE,YAAA;A9J29mCR;A8Jv9mCM;EACE,yCAAA;EACA,8BAAA;A9Jy9mCR;A8Jt9mCQ;EACE,gCAAA;A9Jw9mCV;A8Jj9mCI;;EAEE,sBAAA;A9Jm9mCN;A8J58mCU;EACE,4BAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;A9J88mCZ;A8Jv8mCI;EACE,YAAA;A9Jy8mCN;A8Jt8mCE;EACE,sBAAA;A9Jw8mCJ;A8Jn8mCM;;EAEE,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;A9Jq8mCR;A8J97mCM;EACE,mBAAA;EACA,kBAAA;A9Jg8mCR;A8J97mCU;EACE,iBAAA;EACA,kBAAA;A9Jg8mCZ;A8J17mCE;EACE,iBAAA;A9J47mCJ;A8J17mCE;EACE,gBAAA;A9J47mCJ;A8Jx7mCM;EACE,eAAA;EACA,gCAAA;EACA,mCAAA;EACA,yBAAA;EACA,4BAAA;EACA,iBAAA;A9J07mCR;A8Jt7mCM;EACE,+BAAA;EACA,kCAAA;EACA,0BAAA;EACA,6BAAA;A9Jw7mCR;A8Jj7mCI;;EACE,mBAAA;EACA,kBAAA;A9Jo7mCN;A8J96mCM;;EAEE,qCAAA;EACA,wCAAA;EACA,oCAAA;EACA,uCAAA;A9Jg7mCR;A8J36mCM;;EACE,yBAAA;EACA,4BAAA;EACA,0BAAA;EACA,6BAAA;A9J86mCR;A8Jt6mCQ;EACE,iBAAA;A9Jw6mCV;A8Jp6mCI;EACE,iBAAA;EACA,iBAAA;A9Js6mCN;A8Jj6mCI;EACE,2BAAA;A9Jm6mCN;A8J/5mCE;;;EAGE,WAAA;EACA,WAAA;A9Ji6mCJ;A8J75mCE;EACE,YAAA;EACA,OAAA;A9J+5mCJ;A8J95mCI;EACE,mBAAA;A9Jg6mCN;A8J75mCM;EACE,YAAA;EACA,WAAA;EACA,2BAAA;EACA,wBAAA;EACA,kDAAA;A9J+5mCR;A8J75mCM;EACE,YAAA;EACA,WAAA;A9J+5mCR;A8J55mCQ;EACE,UAAA;A9J85mCV;A8J15mCI;EACE,YAAA;EACA,WAAA;EACA,0BAAA;A9J45mCN;A8Jz5mCE;EACE,YAAA;EACA,YAAA;EACA,YAAA;A9J25mCJ;A8J15mCI;EACE,YAAA;EACA,SAAA;A9J45mCN;A8Jz5mCM;EACE,WAAA;EACA,WAAA;A9J25mCR;A8Jp5mCM;EACE,oBAAA;EACA,mBAAA;A9Js5mCR;A8Jr5mCQ;EACE,gBAAA;A9Ju5mCV;A8Jh5mCU;EACE,kBAAA;EACA,mBAAA;A9Jk5mCZ;A8J94mCc;EACE,aAAA;EACA,eAAA;EACA,SAAA;A9Jg5mChB;A8J34mCQ;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;A9J64mCV;A8J54mCU;EACE,oBAAA;A9J84mCZ;A8Jp4mCU;EACE,+BAAA;A9Js4mCZ;A8J73mCY;;EAEE,6BAAA;EACA,yCAAA;A9J+3mCd;A8Jv3mCE;EAEE;IACE,WAAA;IACA,WAAA;E9Jw3mCJ;AACF;A8Jt3mCE;EAEI;IACE,uBAAA;IACA,kBAAA;E9Ju3mCN;E8Jl3mCM;IACE,eAAA;E9Jo3mCR;E8Jh3mCE;IACE,eAAA;E9Jk3mCJ;E8Jh3mCE;IACE,iBAAA;IACA,mBAAA;E9Jk3mCJ;E8J72mCQ;IACE,iBAAA;IACA,mBAAA;E9J+2mCV;E8Jx2mCI;IACE,WAAA;IACA,WAAA;E9J02mCN;AACF;A8Jv2mCE;EACE;IACE,sBAAA;E9Jy2mCJ;E8Jr2mCI;IACE,0BAAA;IACA,8BAAA;E9Ju2mCN;E8Jr2mCI;IACE,2BAAA;IACA,6BAAA;E9Ju2mCN;E8J51mCU;IACE,SAAA;IACA,YAAA;E9J81mCZ;AACF;A8Jx1mCE;EACE;IACE,4BAAA;E9J01mCJ;AACF;A8Jx1mCE;EAEI;IACE,kBAAA;IACA,kBAAA;E9Jy1mCN;E8Jt1mCE;IACE,YAAA;IACA,UAAA;E9Jw1mCJ;E8J90mCkB;IACE,8BAAA;IACA,6BAAA;E9Jg1mCpB;E8Jl0mCQ;IACE,UAAA;E9Jo0mCV;E8J7zmCM;IACE,mBAAA;E9J+zmCR;E8J5zmCQ;IACE,kBAAA;E9J8zmCV;E8JxzmCQ;IACE,iBAAA;E9J0zmCV;E8JxzmCY;IACE,mBAAA;IACA,iBAAA;E9J0zmCd;E8JrzmCM;IACE,gBAAA;E9JuzmCR;E8JjzmCU;IACE,WAAA;E9JmzmCZ;E8J5ymCQ;IACE,+BAAA;E9J8ymCV;E8J3ymCM;IACE,qCAAA;IACA,wCAAA;IACA,kBAAA;E9J6ymCR;E8JzymCE;IACE,gBAAA;E9J2ymCJ;E8JtymCQ;IACE,0BAAA;IACA,+BAAA;E9JwymCV;E8JnymCE;IACE,OAAA;IACA,YAAA;E9JqymCJ;AACF;A8JnymCE;EAGM;IACE,UAAA;E9JmymCR;E8J3xmCU;IACE,2BAAA;E9J6xmCZ;E8J5xmCY;IACE,2BAAA;E9J8xmCd;E8J1xmCY;IACE,WAAA;IACA,yBAAA;E9J4xmCd;E8JrxmCU;IACE,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,2BAAA;IACA,iBAAA;IACA,kBAAA;E9JuxmCZ;E8JjxmCM;IACE,eAAA;E9JmxmCR;E8J/wmCM;IACE,gBAAA;E9JixmCR;E8J9wmCQ;IACE,mBAAA;E9JgxmCV;E8JzwmCM;IACE,UAAA;E9J2wmCR;E8JnwmCU;IACE,iBAAA;IACA,mBAAA;E9JqwmCZ;E8J9vmCI;;IAEE,0BAAA;E9JgwmCN;E8J5vmCI;IACE,UAAA;E9J8vmCN;E8J1vmCI;IACE,qBAAA;E9J4vmCN;E8JtvmCQ;IACE,eAAA;E9JwvmCV;E8JrvmCM;IACE,8BAAA;E9JuvmCR;E8JpvmCI;IACE,eAAA;E9JsvmCN;E8JnvmCM;IACE,0BAAA;IACA,6BAAA;E9JqvmCR;E8JjvmCU;IACE,2BAAA;E9JmvmCZ;E8J5umCI;IACE,iBAAA;E9J8umCN;E8JvumCU;IACE,YAAA;E9JyumCZ;E8JjumCM;IACE,UAAA;E9JmumCR;AACF;A8J/tmCE;EAKU;IACE,WAAA;IACA,QAAA;E9J6tmCZ;AACF;A8JvtmCE;EACE;IACE,sBAAA;E9JytmCJ;E8JvtmCE;IACE,2BAAA;E9JytmCJ;E8JvtmCE;IACE,iBAAA;IACA,kBAAA;E9JytmCJ;E8JvtmCE;IACE,4BAAA;E9JytmCJ;E8JttmCI;IACE,2BAAA;E9JwtmCN;E8JvtmCM;IACE,gBAAA;E9JytmCR;AACF;A8JrtmCE;EAIQ;IACE,eAAA;E9JotmCV;E8J5smCQ;IACE,eAAA;E9J8smCV;E8JzsmCE;IACE,sCAAA;E9J2smCJ;E8J1smCI;IACE,oCAAA;E9J4smCN;E8JxsmCI;IACE,kBAAA;IACA,kBAAA;E9J0smCN;E8JpsmCQ;IACE,qBAAA;E9JssmCV;E8JhsmCI;IACE,2BAAA;E9JksmCN;E8J7rmCM;IACE,uBAAA;E9J+rmCR;AACF;A8J3rmCE;EACE;IACE,iBAAA;IACA,kBAAA;E9J6rmCJ;E8J3rmCE;IACE,2BAAA;E9J6rmCJ;E8J3rmCE;IACE,sBAAA;E9J6rmCJ;E8J3rmCE;IACE,8BAAA;IACA,8BAAA;E9J6rmCJ;AACF;A8J3rmCE;EAGM;IACE,UAAA;E9J2rmCR;E8JnrmCU;IACE,iBAAA;E9JqrmCZ;E8J/qmCE;IACE,mBAAA;IACA,mBAAA;E9JirmCJ;E8J1qmCY;IACE,mBAAA;IACA,gBAAA;E9J4qmCd;E8JtqmCY;IACE,OAAA;E9JwqmCd;E8J9pmCU;IACE,gBAAA;IACA,iBAAA;IACA,mBAAA;IACA,oBAAA;IACA,mBAAA;IACA,2BAAA;E9JgqmCZ;E8JvpmCQ;IACE,WAAA;IACA,WAAA;E9JypmCV;E8J/omCY;IACE,mBAAA;E9JipmCd;E8J3omCY;IACE,sBAAA;IACA,sBAAA;E9J6omCd;E8JpomCM;IACE,UAAA;E9JsomCR;E8J/nmCQ;IACE,qBAAA;E9JiomCV;E8JhomCU;IACE,gBAAA;E9JkomCZ;E8J3nmCI;IACE,UAAA;E9J6nmCN;E8JxnmCM;IACE,cAAA;E9J0nmCR;E8JrnmCI;IACE,iBAAA;E9JunmCN;AACF;A8JpnmCE;EAKU;IACE,YAAA;IACA,UAAA;E9JknmCZ;E8J3mmCI;IACE,YAAA;E9J6mmCN;E8J5mmCM;IACE,WAAA;E9J8mmCR;E8J5mmCM;IACE,QAAA;IACA,WAAA;E9J8mmCR;E8J5mmCM;IACE,WAAA;IACA,WAAA;E9J8mmCR;AACF;A8J1mmCE;EAQgB;;IAEE,YAAA;E9JqmmClB;E8JvlmCgB;;IAEE,WAAA;E9JylmClB;AACF;A8JhlmCE;EAEI;IACE,OAAA;E9JilmCN;E8J1kmCU;IACE,WAAA;IACA,YAAA;E9J4kmCZ;E8J/kmCQ;IAKE,iBAAA;E9J6kmCV;E8JvkmCI;IACE,kBAAA;E9JykmCN;AACF;A8JtkmCE;EAIQ;IACE,gBAAA;IACA,mBAAA;E9JqkmCV;AACF;;A8J/jmCA;EACE;IACE,eAAA;IACA,UAAA;IACA,yBAAA;IACA,mBAAA;E9JkkmCF;AACF;A8J/jmCA;;4BAAA;ACj9IA;;4BAAA;AAIA;EACE,0DAAA;EACA,8BAAA;EACA,0CAAA;A/JohvCF;A+JlhvCE;EACE;IACE,SAAA;E/JohvCJ;E+JjhvCI;IACE,cAAA;E/JmhvCN;E+JjhvCI;IACE,kBAAA;IACA,SAAA;IACA,OAAA;IACA,UAAA;IACA,kBAAA;IACA,UAAA;IACA,YAAA;E/JmhvCN;E+JlhvCM;IACE,UAAA;IACA,mBAAA;E/JohvCR;E+JhhvCE;IACE,8BAAA;IACA,aAAA;E/JkhvCJ;E+J/gvCI;IACE,8BAAA;E/JihvCN;E+J7gvCI;IACE,mBAAA;E/J+gvCN;E+J3gvCI;IACE,aAAA;E/J6gvCN;E+JzgvCI;IACE,mBAAA;E/J2gvCN;E+JtgvCM;IACE,aAAA;E/JwgvCR;E+JjgvCQ;IACE,gBAAA;E/JmgvCV;E+J7/uCI;IACE,aAAA;IACA,aAAA;E/J+/uCN;E+J3/uCI;IACE,qBAAA;IACA,UAAA;E/J6/uCN;E+J3/uCI;IACE,gBAAA;E/J6/uCN;E+J5/uCM;IACE,iBAAA;IACA,UAAA;E/J8/uCR;E+Jv/uCI;;;;;;IAEE,sBAAA;E/J6/uCN;E+Jv/uCI;IACE,iBAAA;IACA,wBAAA;E/Jy/uCN;E+Jv/uCI;IACE,gBnF+LW;E5E0zuCjB;E+Jt/uCQ;IACE,YAAA;IACA,SnF0LO;ImFzLP,4BAAA;E/Jw/uCV;E+Jr/uCY;IACE,aAAA;IACA,SAAA;E/Ju/uCd;E+Jp/uCY;IACE,eAAA;E/Js/uCd;E+Jl/uCc;IACE,2BAAA;E/Jo/uChB;E+J/+uCU;IACE,kDAAA;E/Ji/uCZ;E+J7+uCY;IACE,gBAAA;IACA,mBAAA;IACA,2BAAA;E/J++uCd;E+J1+uCQ;IACE,+BAAA;IACA,aAAA;IACA,SAAA;IACA,gBAAA;IACA,+BAAA;IACA,oBAAA;IACA,kBAAA;E/J4+uCV;E+J1+uCU;IACE,yCAAA;E/J4+uCZ;E+Jz+uCU;IACE,UAAA;E/J2+uCZ;E+Jx+uCU;IACE,0CAAA;E/J0+uCZ;E+Jn+uCM;IACE,mBAAA;E/Jq+uCR;E+Jl+uCM;IACE,gBAAA;E/Jo+uCR;E+Jl+uCQ;IACE,SAAA;E/Jo+uCV;E+Jl+uCU;IACE,aAAA;IACA,gBAAA;E/Jo+uCZ;E+Jh+uCY;IACE,2BAAA;IACA,SAAA;E/Jk+uCd;E+J/9uCgB;;;IAEE,WAAA;IACA,SAAA;IACA,0BAAA;E/Jk+uClB;E+J79uCoB;;;IAEE,gBAAA;E/Jg+uCtB;E+Jv9uCQ;IACE,cAAA;E/Jy9uCV;E+Jt9uCQ;IACE,8BAAA;IACA,aAAA;IACA,SAAA;IACA,gBAAA;IACA,+BAAA;IACA,oBAAA;E/Jw9uCV;E+Jt9uCU;IACE,yCAAA;E/Jw9uCZ;E+Jr9uCU;IACE,UAAA;E/Ju9uCZ;E+Jp9uCU;IACE,0CAAA;E/Js9uCZ;E+Jh9uCQ;IACE,kBAAA;E/Jk9uCV;E+Jh9uCU;IACE,eAAA;E/Jk9uCZ;E+Jz8uCkB;;;IAEE,WAAA;E/J48uCpB;E+Jj8uCM;IACE,aAAA;E/Jm8uCR;E+Jh8uCM;IACE,gBAAA;E/Jk8uCR;E+Jh8uCQ;IACE,gBAAA;IACA,+BAAA;IACA,+BAAA;IACA,gBAAA;E/Jk8uCV;E+Jh8uCU;IACE,yCAAA;E/Jk8uCZ;E+J/7uCU;IACE,UAAA;E/Ji8uCZ;E+J97uCU;IACE,0CAAA;E/Jg8uCZ;E+J57uCQ;IACE,kBAAA;E/J87uCV;E+J37uCQ;IACE,aAAA;IACA,SAAA;IACA,SAAA;IACA,iBAAA;IACA,kBAAA;E/J67uCV;E+J17uCY;IACE,QAAA;IACA,0BAAA;IACA,UAAA;IACA,sBnF1QR;E5EssvCN;E+Jt7uCM;IACE,eAAA;E/Jw7uCR;E+Jn7uCM;IACE,iBAAA;E/Jq7uCR;E+Jl7uCU;IACE,UAAA;E/Jo7uCZ;E+Jl7uCU;IACE,UAAA;E/Jo7uCZ;E+J96uCQ;IACE,kBAAA;E/Jg7uCV;E+J76uCQ;IACE,UAAA;E/J+6uCV;E+J56uCY;IACE,2BAAA;E/J86uCd;E+Jx6uCc;IACE,2BAAA;E/J06uChB;E+Jt6uCY;IACE,aAAA;IACA,SAAA;IACA,cAAA;E/Jw6uCd;E+Jn6uCQ;IACE,cAAA;E/Jq6uCV;E+Jh6uCI;IACE,iBAAA;IACA,cAAA;IACA,OAAA;IACA,QAAA;IACA,gBnFnJa;ImFoJb,mBAAA;IACA,gBnF3EW;ImF4EX,mBAAA;IACA,YAAA;E/Jk6uCN;E+Jh6uCM;IACE,eAAA;IACA,iBAAA;IACA,uBAAA;IACA,gBnF7JW;E5E+jvCnB;E+J/5uCM;IACE,yBAAA;IACA,4BAAA;E/Ji6uCR;E+J15uCU;;;IAEE,UAAA;E/J65uCZ;E+Jt5uCM;IACE,aAAA;E/Jw5uCR;E+Jt5uCQ;IACE,aAAA;E/Jw5uCV;E+Jr5uCQ;IACE,MAAA;E/Ju5uCV;E+Jh5uCQ;IACE,2BAAA;E/Jk5uCV;E+J94uCM;IACE,aAAA;E/Jg5uCR;E+J94uCQ;IACE,MAAA;IACA,+BAAA;IACA,oBAAA;E/Jg5uCV;E+J14uCM;IACE,4CAAA;E/J44uCR;E+Jz4uCM;IACE,aAAA;E/J24uCR;E+Jv4uCI;IACE,aAAA;IACA,6CAAA;IACA,cAAA;IACA,gBAAA;E/Jy4uCN;E+Jn4uCc;IACE,iBAAA;IACA,cAAA;E/Jq4uChB;E+J93uCM;IACE,gBAAA;IACA,cAAA;E/Jg4uCR;E+J13uCgB;IACE,YAAA;E/J43uClB;E+Jh3uCc;IACE,YAAA;IACA,aAAA;E/Jk3uChB;E+J72uCc;IACE,YAAA;IACA,aAAA;E/J+2uChB;E+J12uCc;IACE,YAAA;IACA,aAAA;E/J42uChB;E+Jr2uCM;IACE,aAAA;IACA,cAAA;IACA,mBAAA;IACA,8BAAA;IACA,eAAA;IACA,SAAA;IACA,6BAAA;IACA,uBAAA;E/Ju2uCR;E+Jp2uCM;IACE,cAAA;IACA,WAAA;E/Js2uCR;E+Jn2uCM;IACE,mBAAA;E/Jq2uCR;E+Jh2uCU;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,gBAAA;E/Jk2uCZ;E+Jh2uCY;IACE,UAAA;IACA,2CAAA;IACA,8BAAA;IACA,WAAA;IACA,aAAA;IACA,UAAA;E/Jk2uCd;E+J/1uCY;IACE,UAAA;IACA,eAAA;IACA,cAAA;E/Ji2uCd;E+J71uCU;IACE,gBAAA;IACA,mBAAA;E/J+1uCZ;E+J51uCc;IACE,yBAAA;IACA,WAAA;IACA,YAAA;IACA,YAAA;E/J81uChB;E+Jz1uCU;IACE,gBAAA;IACA,mBAAA;E/J21uCZ;E+Jz1uCY;IACE,UAAA;E/J21uCd;E+Jt1uCY;IACE,eAAA;IACA,cAAA;E/Jw1uCd;E+Jj1uCQ;IACE,WAAA;E/Jm1uCV;E+J/0uCM;IACE,aAAA;IACA,cAAA;IACA,gBAAA;E/Ji1uCR;E+J90uCM;IACE,kBAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;E/Jg1uCR;E+J90uCQ;IACE,YAAA;E/Jg1uCV;E+J30uCQ;IACE,YAAA;E/J60uCV;E+Jv0uCU;IACE,iBAAA;E/Jy0uCZ;E+Jp0uCU;IACE,aAAA;IACA,UAAA;E/Js0uCZ;E+Jj0uCM;IACE,gBAAA;E/Jm0uCR;E+J5zuCU;IACE,UAAA;E/J8zuCZ;E+J5zuCY;IACE,aAAA;E/J8zuCd;E+JtzuCM;IACE,kBAAA;E/JwzuCR;E+J/yuCc;IACE,kBAAA;IACA,mBAAA;E/JizuChB;E+JryuCY;IACE,aAAA;E/JuyuCd;E+JhyuCI;IACE,cAAA;E/JkyuCN;E+JhyuCM;IACE,qBAAA;IACA,sBAAA;E/JkyuCR;E+J/xuCM;IACE,gBAAA;E/JiyuCR;E+J7xuCY;IACE,eAAA;E/J+xuCd;E+J3xuCU;IACE,6BAAA;E/J6xuCZ;E+JrxuCQ;IACE,gBAAA;IACA,cAAA;IACA,mBAAA;IACA,gBAAA;IACA,uBAAA;E/JuxuCV;E+JjxuCM;IACE,SAAA;E/JmxuCR;E+J9wuCM;IACE,cAAA;IACA,UAAA;E/JgxuCR;E+J3wuCM;IACE,gBnFhbS;E5E6rvCjB;E+J1wuCM;IACE,mBAAA;E/J4wuCR;E+JxwuCI;IACE,kBAAA;E/J0wuCN;E+JpwuCU;IACE,iBAAA;E/JswuCZ;E+J/vuCM;IACE,iBAAA;E/JiwuCR;E+J5vuCM;IACE,iBAAA;E/J8vuCR;E+J1vuCI;IACE,cAAA;IACA,eAAA;E/J4vuCN;E+JzvuCI;IACE,aAAA;IACA,cAAA;E/J2vuCN;E+JxvuCI;IACE,aAAA;IACA,cAAA;E/J0vuCN;E+JvvuCI;IACE,aAAA;IACA,cAAA;E/JyvuCN;E+JtvuCI;IACE,aAAA;IACA,cAAA;E/JwvuCN;E+JrvuCI;IACE,aAAA;IACA,cAAA;E/JuvuCN;E+JpvuCI;IACE,aAAA;IACA,cAAA;E/JsvuCN;E+JnvuCI;IACE,gBAAA;IACA,cAAA;E/JqvuCN;E+JlvuCI;IACE,gBAAA;IACA,iBAAA;E/JovuCN;E+JjvuCI;IACE,wBAAA;E/JmvuCN;E+JzuuCkB;IACE,eAAA;E/J2uuCpB;E+JlvuCM;IAeE,cAAA;IACA,4BAAA;IACA,gBAAA;E/JsuuCR;E+JnuuCM;IACE,qBAAA;IACA,0BAAA;E/JquuCR;E+JjuuCI;IACE,QAAA;IACA,0BAAA;IACA,UAAA;IACA,4BAAA;IACA,kBAAA;IACA,SAAA;IACA,kBAAA;IACA,UAAA;IACA,sBAAA;IACA,2BAAA;E/JmuuCN;E+JjuuCM;IACE,UAAA;IACA,mBAAA;IACA,0BAAA;IACA,2BAAA;IACA,oBAAA;E/JmuuCR;E+J5tuCU;IACE,6BAAA;E/J8tuCZ;E+JttuCQ;IACE,aAAA;IACA,cAAA;E/JwtuCV;E+J/suCY;IACE,iBAAA;E/JituCd;E+J1suCQ;IACE,kBAAA;E/J4suCV;E+JxsuCU;IACE,mBAAA;E/J0suCZ;E+JnsuCU;IACE,aAAA;E/JqsuCZ;E+J7ruCY;IACE,YAAA;E/J+ruCd;E+JvruCM;IACE,YAAA;E/JyruCR;E+JrruCI;IACE,eAAA;E/JuruCN;E+JpruCI;IACE,aAAA;IACA,cAAA;IACA,OAAA;IACA,QAAA;E/JsruCN;E+JpruCM;IACE,wBAAA;IACA,4BAAA;IACA,uBAAA;E/JsruCR;E+JjruCM;IACE,cAAA;IACA,UAAA;E/JmruCR;AACF;;A+J7quCA;;4BAAA;ArFvxBA;;wBAAA;AsFnKA;;4BAAA;AAKE;EACE,+BpFwEkB;EoFvElB,yBpFmEmB;A5E2iwCvB;AgK5mwCM;EACE,oCAAA;AhK8mwCR;AgK1mwCI;EACE,+BAAA;AhK4mwCN;AgKxmwCM;EACE,yBpFuDe;EoFtDf,qBpF6DW;A5E6iwCnB;AgKvmwCQ;EACE,yBpFiDa;A5EwjwCvB;AgKnmwCQ;EACE,+BpF8CY;A5EujwCtB;AgKjmwCI;EACE,oCAAA;EACA,2CAAA;AhKmmwCN;AgK/lwCQ;EACE,2CAAA;EACA,yBpF8Ba;A5EmkwCvB;AgK5lwCI;EACE,6BAAA;EACA,8BAAA;EACA,+BAAA;AhK8lwCN;AgK7lwCM;EACE,0CAAA;AhK+lwCR;AgK9lwCQ;EAEE,mBpFyBS;A5EskwCnB;AgK5lwCM;EACE,8BAAA;EACA,+BAAA;AhK8lwCR;AgK5lwCM;EACE,+BpFac;A5EilwCtB;AgK7lwCQ;EAGE,mBpFKa;EoFJb,6BAAA;AhK6lwCV;AgKzlwCQ;EAEE,8DAAA;AhK0lwCV;AgKplwCQ;EACE,mBpFDS;A5EulwCnB;AgKllwCI;EACE,yBpFbiB;A5EimwCvB;AgKllwCI;;EAEE,mBpFjBiB;EoFkBjB,yBAAA;AhKolwCN;AgKhlwCQ;EACE,mBpFhBS;A5EkmwCnB;AgK7kwCI;EACE,yBpF7BiB;A5E4mwCvB;AgK5kwCI;;EAEE,mBpFlCiB;EoFmCjB,yBAAA;AhK8kwCN;AgK3kwCI;EACE,cpFhHkB;A5E6rwCxB;AgK3kwCQ;EACE,kCAAA;EACA,oCAAA;AhK6kwCV;AgKxkwCM;EACE,mBpFlDe;A5E4nwCvB;AgKhkwCkB;EAEE,gCAAA;AhKikwCpB;AgKjjwCkB;EAEE,gCAAA;AhKkjwCpB;AgKpiwCc;EACE,yBpF/FO;A5EqowCvB;AgK/hwCI;EACE,yBpFvGiB;A5EwowCvB;AgKhiwCM;EACE,yBpFxGe;A5E0owCvB;AgKjiwCQ;EACE,gCAAA;AhKmiwCV;AgK5hwCU;EACE,oCAAA;EACA,+BpFhHU;A5E8owCtB;AgKthwCU;EACE,oCAAA;EACA,+BpF1HU;A5EkpwCtB;AgKhhwCU;EACE,oCAAA;EACA,+BpFpIU;A5EspwCtB;AgKzgwCQ;EACE,yBpFjJa;A5E4pwCvB;AgKpgwCU;EACE,yBAAA;AhKsgwCZ;AgKhgwCM;EACE,+BpF7Jc;EoF8Jd,yBpFlKe;A5EoqwCvB;AgKhgwCM;EACE,+BpFjKc;EoFkKd,yBpFrKe;A5EuqwCvB;AgKhgwCM;EACE,gCAAA;AhKkgwCR;AgK5/vCU;EACE,cpFzPO;A5EuvwCnB;AgK5/vCU;EACE,yBpFnLW;A5EirwCvB;AgK5/vCU;EACE,yBpFrLW;A5EmrwCvB;AgK1/vCU;EACE,yBpF1LW;A5EsrwCvB;AgK1/vCU;EACE,yBpF9LW;A5E0rwCvB;AgKp/vCU;EACE,yBpFvMW;A5E6rwCvB;AgKp/vCU;EACE,yBpFzMW;A5E+rwCvB;AgKl/vCU;EACE,yBpF9MW;A5EkswCvB;AgKl/vCU;EACE,yBpFlNW;A5EsswCvB;AgK9+vCM;EACE,6GAAA;AhKg/vCR;AgK5+vCM;EACE,mBpF7Ne;A5E2swCvB;AgK5+vCM;EACE,qBpFzNW;A5EuswCnB;AgK1+vCU;;EAEE,+BpFnOU;A5E+swCtB;AgKt+vCM;EACE,yBpF7Oe;A5EqtwCvB;AgKr+vCQ;EACE,4BpFlPa;A5EytwCvB;AgKt+vCU;EACE,4BpFnPW;A5E2twCvB;AgKn+vCQ;EACE,yBpF1Pa;A5E+twCvB;AgKp+vCU;EACE,yBpF3PW;A5EiuwCvB;AgKj+vCQ;EACE,0BpFlQa;A5EquwCvB;AgKl+vCU;EACE,0BpFnQW;A5EuuwCvB;AgKh+vCM;EACE,4BpFxQe;A5E0uwCvB;AgK99vCM;;EAEE,qBpFvQW;A5EuuwCnB;AgK99vCM;EACE,yBpFlRe;A5EkvwCvB;AgK19vCU;EACE,yBpFzRW;A5EqvwCvB;AgKp9vCU;EACE,mDAAA;AhKs9vCZ;AgK/8vCI;EACE,yBpF1SiB;A5E2vwCvB;AgKh9vCM;EACE,+BAAA;AhKk9vCR;AgK98vCM;EACE,mBpFjTe;A5EiwwCvB;AgK78vCI;EACE,iGAAA;AhK+8vCN;AgK18vCM;EACE,+BpFvTc;A5EmwwCtB;AgKv8vCQ;EACE,+BAAA;AhKy8vCV;AgKl8vCU;EACE,aAAA;AhKo8vCZ;AgK97vCI;EACE,8BAAA;EACA,UAAA;AhKg8vCN;AgK77vCM;EACE,oCAAA;AhK+7vCR;AgK37vCM;EACE,kDAAA;AhK67vCR;AgKv7vCU;EACE,UAAA;EACA,YAAA;AhKy7vCZ;AgKj7vCQ;EACE,mBpF1Wa;A5E6xwCvB;AgKh7vCU;EACE,gCAAA;AhKk7vCZ;AgK96vCM;EACE,mBpFpXe;A5EoywCvB;AgK56vCM;EACE,mBpFxXe;EoFyXf,gBAAA;AhK86vCR;AgK76vCQ;EACE,8BpFxXY;A5EuywCtB;AgK36vCI;EACE,+BpF7XgB;A5E0ywCtB;AgK16vCM;EACE,mBpFpYe;EoFqYf,WpFzaA;A5Eq1wCR;AgKz6vCI;EACE,yBpFzYiB;A5EozwCvB;AgKz6vCI;EACE,oCAAA;AhK26vCN;AgKz6vCI;EACE,0CAAA;AhK26vCN;AgKz6vCI;EACE,+BpF/YgB;A5E0zwCtB;AgKx6vCM;EACE,+BpFnZc;A5E6zwCtB;AgKv6vCI;EACE,cpFnekB;A5E44wCxB;AgKx6vCM;EACE,cpFregB;A5E+4wCxB;AgKv6vCI;EACE,iCAAA;AhKy6vCN;AgKt6vCM;EACE,yBAAA;AhKw6vCR;AgKp6vCM;EACE,cpFvagB;A5E60wCxB;AgKn6vCI;EACE,oCAAA;AhKq6vCN;AgKn6vCI;EACE,+BpF7agB;A5Ek1wCtB;AgKn6vCI;EACE,yBpFpbiB;EoFqbjB,yBAAA;AhKq6vCN;AgKn6vCI;EACE,yBpFxbiB;A5E61wCvB;AgKh6vCU;EACE,yBAAA;AhKk6vCZ;AgK75vCI;EACE,yBpFpciB;A5Em2wCvB;AgK55vCM;EACE,yBpFvce;A5Eq2wCvB;AgK15vCI;EACE,yBAAA;AhK45vCN;AgK15vCI;EACE,yBpF/ciB;A5E22wCvB;AgK15vCI;;;EAGE,+BpFjdgB;A5E62wCtB;AgKz5vCM;EACE,+BpFrdc;EoFsdd,yBpF1de;A5Eq3wCvB;AgKz5vCM;EACE,+BpFzdc;EoF0dd,yBpF7de;A5Ew3wCvB;AgKx5vCI;EACE,8BpF9dgB;EoF+dhB,+BpF/dgB;A5Ey3wCtB;AgKx5vCI;EACE,yBpFreiB;EoFsejB,yBpF/da;EoFgeb,+BpFpegB;A5E83wCtB;AgKz5vCM;EACE,+BpFtec;EoFued,8BpFvec;A5Ek4wCtB;AgK15vCQ;EACE,cpF1ec;EoF2ed,apF3ec;A5Eu4wCxB;AgKv5vCM;EACE,+BpFhfc;A5Ey4wCtB;AgKt5vCI;EACE,oCAAA;AhKw5vCN;AgKt5vCQ;EACE,oCAAA;EACA,+BpFxfY;A5Eg5wCtB;AgKl5vCM;EACE,4BpFlgBe;A5Es5wCvB;AgKj5vCQ;EACE,yBpFvgBa;EoFwgBb,qBpFvgBa;EoFwgBb,cpF9jBE;A5Ei9wCZ;AgK/4vCQ;EACE,yBpF9gBa;EoF+gBb,gCAAA;AhKi5vCV;AgK74vCQ;EACE,qBpFnhBa;EoFohBb,yBpFrhBa;A5Eo6wCvB;AgK54vCM;EACE,yBpFxhBe;EoF0hBf,4BAAA;AhK84vCR;AgK54vCM;EACE,yBpF7hBe;EoF8hBf,qBpF9hBe;A5E46wCvB;AgK14vCU;EAEE,yBpFriBW;EoFsiBX,WpFzkBJ;A5Eo9wCR;AgKh4vCU;EACE,yBpFhjBM;A5Ek7wClB;AgK53vCU;EACE,4BpFvjBM;EoFwjBN,6BpF3mBQ;A5Ey+wCpB;AgKx3vCU;EACE,0BpF/jBM;EoFgkBN,6BpFnnBQ;A5E6+wCpB;AgKp3vCU;EACE,2BpFvkBM;EoFwkBN,6BpF3nBQ;A5Ei/wCpB;AgKl3vCM;EACE,yBpF7kBU;EoF8kBV,WpFnnBA;A5Eu+wCR;AgKj3vCQ;EACE,yBpFllBQ;A5Eq8wClB;AgKz2vCc;EACE,yBpF9lBO;A5Ey8wCvB;AgKn2vCM;EACE,8BAAA;AhKq2vCR;AgKj2vCM;EACE,mBpF7mBe;EoF8mBf,+BpF1mBc;A5E68wCtB;AgKh2vCI;EACE,yBpFjnBiB;A5Em9wCvB;AgKj2vCM;EACE,oCAAA;EACA,gCAAA;AhKm2vCR;AgKj2vCM;;;EAGE,+BpFtnBc;A5Ey9wCtB;AgK71vCQ;;;;EACE,yBpFhoBa;A5Ek+wCvB;AgK51vCQ;;EAEE,oCAAA;AhK81vCV;AgKz1vCM;EACE,uBAAA;AhK21vCR;AgKz1vCM;;;EAGE,+BAAA;AhK21vCR;AgKz1vCM;EACE,cpFppBgB;A5E++wCxB;AgKz1vCM;EACE,gCAAA;AhK21vCR;AgKp1vCQ;;;;EACE,yBpFlqBa;A5E2/wCvB;AgKj1vCU;EACE,yBpF3qBW;A5E8/wCvB;AgK/0vCc;EACE,yBpF/qBO;A5EggxCvB;AgK/0vCkB;EACE,gCAAA;AhKi1vCpB;AgKh0vCkB;EACE,+BAAA;AhKk0vCpB;AgKtzvCkB;EACE,yBpFjtBG;A5EygxCvB;AgK5yvCY;EACE,WpFlwBN;A5EgjxCR;AgK1yvCc;EACE,oCAAA;AhK4yvChB;AgK1yvCkB;EACE,yBpFvuBG;EoFwuBH,yBAAA;EACA,+BpFruBE;A5EihxCtB;AgKxyvCkB;EACE,6BAAA;AhK0yvCpB;AgKryvCc;EACE,oCAAA;AhKuyvChB;AgKryvCgB;EACE,YpF1xBV;A5EikxCR;AgKjyvCc;EACE,yBpF7vBO;A5EgixCvB;AgK/xvCkB;EACE,+BAAA;EACA,gCAAA;EACA,oCAAA;AhKiyvCpB;AgKtxvCM;EACE,+BAAA;AhKwxvCR;AgKpxvCI;EACE,cpFtxBiB;A5E4ixCvB;AgKlxvCU;EACE,sBpF9zBJ;A5EklxCR;AgK7wvCM;EACE,oCAAA;EACA,WAAA;EACA,gCAAA;AhK+wvCR;AgK5wvCM;EACE,8CAAA;AhK8wvCR;AgK3wvCU;EACE,oCAAA;AhK6wvCZ;AgKzwvCY;EACE,yBpFjzBS;A5E4jxCvB;AgKvwvCU;EACE,oCAAA;EACA,gCAAA;AhKywvCZ;AgKlwvCM;EACE,oCAAA;AhKowvCR;AgKhwvCI;;EAEE,mBpFr0BiB;A5EukxCvB;AgK/vvCI;EACE,yBpFz0BiB;A5E0kxCvB;AgK7vvCM;EACE,6BAAA;AhK+vvCR;AgK5vvCM;EACE,6BAAA;AhK8vvCR;AgK5vvCQ;EACE,yBpFr1Ba;A5EmlxCvB;AgKzvvCI;EACE,+BAAA;AhK2vvCN;AgKxvvCI;EACE,yBpFh2BiB;EoFi2BjB,yBAAA;AhK0vvCN;AgKvvvCI;EACE,0CAAA;AhKyvvCN;AgKrvvCM;EACE,6BAAA;AhKuvvCR;AgKnvvCI;EACE,gCAAA;AhKqvvCN;AgKlvvCI;EACE,yBpFl3BiB;EoFm3BjB,2BAAA;AhKovvCN;AgKjvvCU;EACE,+BpFp3BU;A5EumxCtB;AgK5uvCM;EACE,+BpF53Bc;EoF63Bd,yBpFh4Be;A5E8mxCvB;AgKzuvCM;EACE,gCAAA;AhK2uvCR;AgKxuvCM;EACE,gCAAA;AhK0uvCR;AgKruvCM;EACE,4BAAA;AhKuuvCR;AgKluvCM;EACE,yBpFv5Be;A5E2nxCvB;AgKnuvCQ;EACE,yBpFx5Ba;EoFy5Bb,gCAAA;EACA,4CAAA;AhKquvCV;AgK7tvCoB;EACE,YpFv8Bd;A5EsqxCR;AgK7tvCoB;EACE,8BAAA;EACA,mBAAA;AhK+tvCtB;AgK1tvCsB;EACE,4BAAA;AhK4tvCxB;AgK1tvCsB;EACE,0BAAA;EACA,mBAAA;AhK4tvCxB;AgK/svCgB;EACE,4BAAA;AhKitvClB;AgK1svCgB;EACE,+BpFp8BI;A5EgpxCtB;AgKrsvCgB;EACE,0CAAA;AhKusvClB;AgK/rvCsB;EACE,+BpFr9BF;A5EspxCtB;AgK1rvC0B;EACE,+BpF79BN;EoF89BM,gBAAA;AhK4rvC5B;AgKprvCgB;EACE,0CpFt+BK;A5E4pxCvB;AgKhrvCkB;EACE,+BpF9+BE;A5EgqxCtB;AgKjrvCoB;EACE,2BAAA;AhKmrvCtB;AgKzqvCoB;EACE,+BpF3/BA;A5EsqxCtB;AgKxqvCoB;EACE,2BAAA;AhK0qvCtB;AgK9pvCU;EACE,6BAAA;EACA,YAAA;AhKgqvCZ;AgK1pvCQ;EACE,+BpFphCY;A5EgrxCtB;AgKtpvCU;EACE,yBpF9hCW;A5EsrxCvB;AgKnpvCkB;EACE,4BAAA;AhKqpvCpB;AgK/ovCoB;EACE,+BpFxiCA;A5EyrxCtB;AgK1ovCoB;EACE,0CAAA;AhK4ovCtB;AgKpovC0B;EACE,+BpFzjCN;A5E+rxCtB;AgK/nvC8B;EACE,+BpFjkCV;EoFkkCU,gBAAA;AhKiovChC;AgKznvCoB;EACE,0CpF1kCC;A5EqsxCvB;AgKrnvCsB;EACE,+BpFllCF;A5EysxCtB;AgKtnvCwB;EACE,2BAAA;AhKwnvC1B;AgK1mvCgB;EACE,+BpFnmCI;A5E+sxCtB;AgKzmvCgB;EACE,2BAAA;AhK2mvClB;AgKpmvCY;EACE,+BpF/mCQ;A5EqtxCtB;AgK9lvCU;EACE,mBpF3nCW;EoF4nCX,6BAAA;AhKgmvCZ;AgK3lvCkB;EACE,+BpF/nCE;A5E4txCtB;AgK1lvCkB;EACE,mBpFtoCG;A5EkuxCvB;AgKzlvCsB;EACE,+BpFvoCF;A5EkuxCtB;AgKzlvCwB;EAEE,2BAAA;AhK0lvC1B;AgKtlvCsB;EACE,mBpFnpCD;A5E2uxCvB;AgKnlvCkB;EACE,mBpFzpCG;A5E8uxCvB;AgK/kvC4B;EACE,+BpF7pCR;A5E8uxCtB;AgKnkvCM;;EAEE,yBpFhrCe;EoFirCf,+BpF9qCc;A5EmvxCtB;AgK9jvCc;EACE,mBpFzrCO;A5EyvxCvB;AgK1jvCoB;EACE,gCAAA;AhK4jvCtB;AgKzjvCsB;EACE,+BpFjsCF;A5E4vxCtB;AgKxjvCsB;EACE,gCpFrsCF;A5E+vxCtB;AgKtjvCoB;;EAEE,yBpF9sCC;A5EswxCvB;AgKtjvCwB;;EACE,gCAAA;AhKyjvC1B;AgKjjvCsB;EACE,0CAAA;AhKmjvCxB;AgKjjvCwB;EACE,2BAAA;AhKmjvC1B;AgKhjvCwB;EACE,2BAAA;EACA,4BAAA;AhKkjvC1B;AgKzivC4B;EACE,+BpFzuCR;A5EoxxCtB;AgKpivCgC;EACE,+BpFjvCZ;EoFkvCY,gBAAA;AhKsivClC;AgK9hvCsB;EACE,0CpF1vCD;A5E0xxCvB;AgK1hvCwB;EACE,+BpFlwCJ;A5E8xxCtB;AgKlhvC0B;EACE,+BpF7wCN;A5EiyxCtB;AgKjhvC0B;EACE,2BAAA;AhKmhvC5B;AgKvgvCY;EACE,+BpF9xCQ;A5EuyxCtB;AgKjgvCU;EACE,4BAAA;AhKmgvCZ;AgK3/uCU;EACE,6BpFr2CQ;A5Ek2xCpB;AgKz/uCgB;EACE,WpF51CV;A5Eu1xCR;AgKv/uCc;EACE,WpFj2CR;A5E01xCR;AgKl/uCsB;EACE,yBAAA;EACA,mBpFv0CD;EoFw0CC,WpF32ChB;A5E+1xCR;AgK3+uCU;EACE,6BpFn4CQ;A5Eg3xCpB;AgKx+uCU;EACE,6BpFz4CQ;A5Em3xCpB;AgKr+uCM;EACE,yBpF91Ce;A5Eq0xCvB;AgKr+uCU;EACE,uBpFl5CQ;A5Ey3xCpB;AgKr+uCY;EACE,uBpFr5CM;A5E43xCpB;AgKl+uCQ;EACE,uBpF35CU;A5E+3xCpB;AgKl+uCU;EACE,uBpF95CQ;A5Ek4xCpB;AgK79uCU;EACE,6BAAA;EACA,gBAAA;EACA,YAAA;AhK+9uCZ;AgKx9uCU;EACE,yBpF93CW;A5Ew1xCvB;AgKx9uCY;EACE,+BpF93CQ;A5Ew1xCtB;AgKp9uCI;EAUoB;IACE,YpFt7ClB;E5Em4xCN;AACF;AgKj8uCI;EACE,iBAAA;AhKm8uCN;AgKh8uCI;EACE,yBpFr6CiB;EoFs6CjB,gCAAA;AhKk8uCN;AgK/7uCI;EACE,mBpF16CiB;A5E22xCvB;AgK57uCQ;EACE,2CAAA;EACA,yBpFj7Ca;A5E+2xCvB;AgKz7uCI;EACE,2CAAA;EACA,yBpFx7CiB;A5Em3xCvB;AgKv7uCM;EACE,yBAAA;AhKy7uCR;AgKr7uCQ;EACE,2CAAA;EACA,yBpFn8Ca;A5E03xCvB;AgKr7uCU;EACE,yBpFr8CW;EoFs8CX,2CAAA;AhKu7uCZ;AgKl7uCM;EACE,2CAAA;EACA,yBpF98Ce;A5Ek4xCvB;AgK/6uCM;EACE,sDAAA;AhKi7uCR;AgK96uCM;EACE,+BpFp9Cc;EoFq9Cd,oCAAA;EACA,sDAAA;AhKg7uCR;AgK56uCI;EACE,+BAAA;AhK86uCN;AgK36uCI;;EAEE,gCAAA;AhK66uCN;AgK16uCI;EACE,+BAAA;AhK46uCN;AgKz6uCI;EACE,yBpF3+CiB;EoF4+CjB,sBAAA;AhK26uCN;AgKx6uCI;EACE,2CAAA;AhK06uCN;AgKv6uCI;;;;EAIE,sCAAA;AhKy6uCN;AgKt6uCI;EACE,cpFpkDkB;A5E4+xCxB;AgKp6uCM;EACE,+BpF7/Cc;A5Em6xCtB;AgKr6uCQ;EACE,cpF3kDc;A5Ek/xCxB;AgKp6uCM;EACE,+BpFngDc;A5Ey6xCtB;AgKl6uCI;;EAEE,oCAAA;EACA,uCAAA;AhKo6uCN;AgKj6uCI;EACE,sBAAA;AhKm6uCN;AgKh6uCI;EACE,oCAAA;AhKk6uCN;AgK95uCI;EACE,8BAAA;AhKg6uCN;AgK55uCQ;EACE,2BpFxhDS;A5Es7xCnB;AgKx5uCM;EACE,+BAAA;AhK05uCR;AgKv5uCU;EACE,6BAAA;AhKy5uCZ;AgK74uCgB;EACE,8BAAA;AhK+4uClB;AgKj4uCc;EACE,yBpFtkDO;A5Ey8xCvB;AgK53uCI;EACE,epF/kDiB;A5E68xCvB;AgK33uCI;;;;EAIE,WpF1nDE;A5Eu/xCR;AgKn3uCU;;;;;;EACE,apFjmDW;A5E29xCvB;AgK92uCc;EACE,+BpF1mDM;A5E09xCtB;AgKn2uCc;EACE,+BpFxnDM;A5E69xCtB;AgKj2uCY;EACE,+BpF7nDQ;A5Eg+xCtB;AgK71uCI;EACE,yBpFtoDY;EoFuoDZ,+BpFroDgB;A5Eo+xCtB;AgK91uCM;EACE,cpF7sDQ;A5E6iyChB;AgK91uCM;EACE,WpFjrDA;A5EihyCR;AgK91uCM;;EAEE,+BAAA;AhKg2uCR;AgK91uCM;EACE,gCAAA;AhKg2uCR;AgK91uCM;EACE,mBpFtpDU;EoFupDV,yBpFvpDU;EoFwpDV,2BpFxpDU;A5Ew/xClB;AgK31uCQ;EACE,mBpF/pDa;A5E4/xCvB;AgK31uCU;EACE,+BpF/pDU;A5E4/xCtB;AgK31uCY;EACE,+BpFlqDQ;A5E+/xCtB;AgKr1uCgB;;;;EAEE,+BpF5qDI;A5EqgyCtB;AgKv1uCkB;;;;EACE,WpFttDZ;A5EkjyCR;AgKh1uCI;EACE,yBpF/rDiB;A5EihyCvB;AgKz0uCc;EACE,wCAAA;AhK20uChB;AgK7zuCM;EACE,qDAAA;EACA,iDAAA;EACA,WpF9vDA;A5E6jyCR;AgK7zuCQ;EACE,WAAA;EACA,gDAAA;EACA,gBAAA;AhK+zuCV;AgK5zuCQ;EACE,uBAAA;AhK8zuCV;AgK1zuCM;EACE,wCAAA;AhK4zuCR;AgK3zuCQ;EACE,+BAAA;AhK6zuCV;AgKxzuCQ;;EACE,+BAAA;AhK2zuCV;AgKtzuCU;EACE,aAAA;AhKwzuCZ;AgKtzuCY;EACE,yBAAA;AhKwzuCd;AgK11uCM;EACE,oDAAA;EACA,gDAAA;EACA,WpF9vDA;A5E0lyCR;AgK11uCQ;EACE,WAAA;EACA,gDAAA;EACA,gBAAA;AhK41uCV;AgKz1uCQ;EACE,uBAAA;AhK21uCV;AgKv1uCM;EACE,wCAAA;AhKy1uCR;AgKx1uCQ;EACE,+BAAA;AhK01uCV;AgKr1uCQ;;EACE,+BAAA;AhKw1uCV;AgKn1uCU;EACE,aAAA;AhKq1uCZ;AgKn1uCY;EACE,yBAAA;AhKq1uCd;AgKv3uCM;EACE,mDAAA;EACA,+CAAA;EACA,WpF9vDA;A5EunyCR;AgKv3uCQ;EACE,WAAA;EACA,qEAAA;EACA,gBAAA;AhKy3uCV;AgKt3uCQ;EACE,uBAAA;AhKw3uCV;AgKp3uCM;EACE,wCAAA;AhKs3uCR;AgKr3uCQ;EACE,+BAAA;AhKu3uCV;AgKl3uCQ;;EACE,+BAAA;AhKq3uCV;AgKh3uCU;EACE,aAAA;AhKk3uCZ;AgKh3uCY;EACE,yBAAA;AhKk3uCd;AgKp5uCM;EACE,mDAAA;EACA,+CAAA;EACA,WpF9vDA;A5EopyCR;AgKp5uCQ;EACE,WAAA;EACA,oEAAA;EACA,gBAAA;AhKs5uCV;AgKn5uCQ;EACE,uBAAA;AhKq5uCV;AgKj5uCM;EACE,wCAAA;AhKm5uCR;AgKl5uCQ;EACE,+BAAA;AhKo5uCV;AgK/4uCQ;;EACE,+BAAA;AhKk5uCV;AgK74uCU;EACE,aAAA;AhK+4uCZ;AgK74uCY;EACE,yBAAA;AhK+4uCd;AgKj7uCM;EACE,mDAAA;EACA,+CAAA;EACA,WpF9vDA;A5EiryCR;AgKj7uCQ;EACE,WAAA;EACA,yDAAA;EACA,gBAAA;AhKm7uCV;AgKh7uCQ;EACE,uBAAA;AhKk7uCV;AgK96uCM;EACE,wCAAA;AhKg7uCR;AgK/6uCQ;EACE,+BAAA;AhKi7uCV;AgK56uCQ;;EACE,+BAAA;AhK+6uCV;AgK16uCU;EACE,aAAA;AhK46uCZ;AgK16uCY;EACE,yBAAA;AhK46uCd;AgK98uCM;EACE,oDAAA;EACA,gDAAA;EACA,WpF9vDA;A5E8syCR;AgK98uCQ;EACE,WAAA;EACA,oEAAA;EACA,gBAAA;AhKg9uCV;AgK78uCQ;EACE,uBAAA;AhK+8uCV;AgK38uCM;EACE,wCAAA;AhK68uCR;AgK58uCQ;EACE,+BAAA;AhK88uCV;AgKz8uCQ;;EACE,+BAAA;AhK48uCV;AgKv8uCU;EACE,aAAA;AhKy8uCZ;AgKv8uCY;EACE,yBAAA;AhKy8uCd;AgK3+uCM;EACE,qDAAA;EACA,iDAAA;EACA,WpF9vDA;A5E2uyCR;AgK3+uCQ;EACE,WAAA;EACA,qEAAA;EACA,gBAAA;AhK6+uCV;AgK1+uCQ;EACE,uBAAA;AhK4+uCV;AgKx+uCM;EACE,wCAAA;AhK0+uCR;AgKz+uCQ;EACE,+BAAA;AhK2+uCV;AgKt+uCQ;;EACE,+BAAA;AhKy+uCV;AgKp+uCU;EACE,aAAA;AhKs+uCZ;AgKp+uCY;EACE,yBAAA;AhKs+uCd;AgKxgvCM;EACE,kDAAA;EACA,8CAAA;EACA,WpF9vDA;A5EwwyCR;AgKxgvCQ;EACE,WAAA;EACA,oEAAA;EACA,gBAAA;AhK0gvCV;AgKvgvCQ;EACE,mEAAA;AhKygvCV;AgKrgvCM;EACE,wCAAA;AhKugvCR;AgKtgvCQ;EACE,+BAAA;AhKwgvCV;AgKngvCQ;;EACE,+BAAA;AhKsgvCV;AgKjgvCU;EACE,aAAA;AhKmgvCZ;AgKjgvCY;EACE,yBAAA;AhKmgvCd;AgK3/uCM;EACE,yBAAA;AhK6/uCR;AgKr/uCY;EACE,yBpF5wDS;A5EmwyCvB;AgKh/uCI;EACE,8CAAA;AhKk/uCN;AgK/+uCI;EACE,6DAAA;AhKi/uCN;AgK1+uCY;EACE,8BAAA;AhK4+uCd;AgKn+uCQ;EACE,gCAAA;AhKq+uCV;AgK19uCgB;EACE,yBAAA;AhK49uClB;AgKj9uCQ;;EAEE,qBpFn0Da;A5EsxyCvB;AgK38uCM;;;EACE,0DAAA;AhK+8uCR;AgKz8uCQ;;;;;;;EACE,2BAAA;AhKi9uCV;AgK58uCQ;;;EACE,oCAAA;AhKg9uCV;AgK38uCQ;;;EACE,qCAAA;AhK+8uCV;AgKz8uCM;EACE,wCAAA;AhK28uCR;AgKv8uCI;EACE,YAAA;AhKy8uCN;AgKn8uCU;EACE,4BpFl3DW;EoFm3DX,+BpFp6DQ;A5Ey2yCpB;AgK/7uCU;EACE,+BpF36DQ;EoF46DR,yBpF33DW;A5E4zyCvB;AgK37uCU;EACE,0BpFl4DW;A5E+zyCvB;AgKj9uCI;EAwBE,yBpFt4DiB;A5Ek0yCvB;AgK37uCM;EACE,yBpFv4De;A5Eo0yCvB;AgK17uCQ;EACE,2BpF54Da;A5Ew0yCvB;AgKz7uCM;EACE,+BAAA;AhK27uCR;AgKz7uCM;EACE,uBAAA;AhK27uCR;AgKn7uCU;EACE,0CAAA;AhKq7uCZ;AgK76uCQ;EACE,UpFx8DF;A5Eu3yCR;AgK56uCQ;EACE,UpF58DF;A5E03yCR;AgKz6uCY;EACE,UpFl9DN;A5E63yCR;AgKp6uCY;EACE,UpF19DN;A5Eg4yCR;AgKh6uCU;EACE,0CAAA;AhKk6uCZ;AgK75uCU;EACE,UpFv+DJ;A5Es4yCR;AgK55uCU;EACE,UpF3+DJ;A5Ey4yCR;AgKx5uCI;EACE,yBpF/8DiB;A5Ey2yCvB;AgKv5uCI;EACE,yBAAA;AhKy5uCN;AgKj5uCc;EACE,yBpF59DO;EoF69DP,yBAAA;EACA,+BpF19DM;A5E62yCtB;AgKh5uCc;EACE,mBpFl+DO;A5Eo3yCvB;AgKv4uCU;EACE,oCAAA;EACA,gCAAA;AhKy4uCZ;AgKh4uCM;EACE,yBpFz/De;EoF0/Df,yBAAA;EACA,aAAA;AhKk4uCR;AgK93uCY;EACE,yBAAA;AhKg4uCd;AgKx3uCM;EACE,cAAA;EACA,gCAAA;AhK03uCR;AgKt3uCQ;EACE,cAAA;AhKw3uCV;AgKt3uCU;EACE,cAAA;AhKw3uCZ;AgK73uCM;EASE,gCAAA;AhKu3uCR;AgKn3uCQ;EACE,cAAA;AhKq3uCV;AgKh3uCQ;EACE,cAAA;AhKk3uCV;AgK32uCQ;EACE,yBAAA;AhK62uCV;AgKt2uCQ;EACE,yBAAA;AhKw2uCV;AgKn2uCI;EACE,wCAAA;AhKq2uCN;AgK71uCc;EACE,cpF7jEQ;A5E45yCxB;AgK31uCgB;EACE,WpFxmEV;A5Eq8yCR;AgKl1uCM;;EACE,mBpFjlEe;EoFklEf,yBAAA;AhKq1uCR;AgKj1uCI;EACE,6BAAA;EACA,gCAAA;AhKm1uCN;AgK/0uCM;EACE,yBpF5lEe;A5E66yCvB;AgK/0uCQ;EACE,+BpF5lEY;A5E66yCtB;AgKv0uCY;;EACE,2BAAA;AhK00uCd;AgKn0uCY;;EACE,gCAAA;AhKs0uCd;AgKl0uCc;;EACE,mBAAA;AhKq0uChB;AgKzzuCY;EACE,gCAAA;AhK2zuCd;AgKjzuCU;EACE,yBpF/oEW;EoFgpEX,WpFprEJ;A5Eu+yCR;AgKjzuCY;EACE,iBAAA;AhKmzuCd;AgK3yuCM;EACE,mCAAA;AhK6yuCR;AgKvyuCM;;EACE,WpFvsEA;A5Ei/yCR;AgKtyuCI;EACE,yBpFzqEiB;A5Ei9yCvB;AgKtyuCM;EACE,oCAAA;AhKwyuCR;AgKlyuCQ;EACE,+BpF/qEY;A5Em9yCtB;AgKvyuCI;EAME,sBAAA;AhKoyuCN;AgKhyuCY;EACE,yBpF3rES;A5E69yCvB;AgK/xuCY;EACE,yBpF9rES;A5E+9yCvB;AgK5xuCQ;EACE,yBpFrsEa;A5Em+yCvB;AgK3xuCQ;EACE,yBpFxsEa;A5Eq+yCvB;AgK1xuCY;EACE,cpFzwEA;A5EqizCd;AgKrxuCgB;EACE,YpFxvEV;A5E+gzCR;AgK7wuCsB;EACE,+BpF5tEF;A5E2+yCtB;AgKnwuCoB;EACE,0CAAA;AhKqwuCtB;AgKhwuCgB;EACE,yBpFnvEK;EoFovEL,4BAAA;AhKkwuClB;AgKhwuCkB;EACE,qBpFtvEG;A5Ew/yCvB;AgK/vuCkB;EACE,+BpFvvEE;A5Ew/yCtB;AgK9vuCkB;EACE,gCAAA;AhKgwuCpB;AgK7vuCkB;EACE,gCAAA;AhK+vuCpB;AgK1vuCkB;EACE,yBpFxwEG;A5EogzCvB;AgK3vuCoB;EACE,cpFxwEE;A5EqgzCxB;AgKzvuCkB;EACE,oCAAA;EACA,0CAAA;AhK2vuCpB;AgKnvuCgB;EACE,+BpFtxEI;A5E2gzCtB;AgKlvuCoB;;;EAGE,0CAAA;AhKovuCtB;AgKhvuCkB;EACE,2BAAA;AhKkvuCpB;AgK/uuCsB;;;EAGE,sCAAA;AhKivuCxB;AgKruuCoB;EACE,0CAAA;AhKuuuCtB;AgKluuCgB;EACE,yBpF9zEK;EoF+zEL,+BAAA;AhKouuClB;AgKluuCkB;EACE,gCAAA;AhKouuCpB;AgKjuuCkB;EACE,gCAAA;AhKmuuCpB;AgK9tuCkB;EACE,qBpF30EG;A5E2izCvB;AgK9tuCoB;EACE,cpF50EE;A5E4izCxB;AgKttuCkB;EACE,yBpFz1EG;A5EijzCvB;AgKhtuCQ;EACE,yBpFl2Ea;A5EojzCvB;AgK9suCc;EACE,aAAA;AhKgtuChB;AgK7suCc;EACE,cAAA;AhK+suChB;AgK34uCI;EAmME,qBAAA;AhK2suCN;AgK1suCM;EACE,cAAA;AhK4suCR;AgKrsuCoB;EACE,cpF13EE;A5EikzCxB;AgK/ruCU;EACE,cpFn4EY;A5EokzCxB;AgK7ruCY;EACE,cpFx4EU;A5EukzCxB;AgKvruCc;;;;EACE,cpFj5EQ;A5E6kzCxB;AgKrruCc;EACE,cpFz5EQ;A5EglzCxB;AgK/quCgB;EACE,cpFl6EM;A5EmlzCxB;AgKzquCc;EACE,cpF36EQ;A5EslzCxB;AgKlquCgB;;EACE,cpFr7EM;A5E0lzCxB;AgK5puCgB;EACE,cpF/7EM;A5E6lzCxB;AgKxpuCc;EACE,cpFt8EQ;A5EgmzCxB;AgKjpuCkB;EACE,2BAAA;EACA,gCAAA;AhKmpuCpB;AgK/ouCoB;EACE,mBAAA;AhKipuCtB;AgKtouCgB;EACE,yBAAA;AhKwouClB;AgKjouCY;EACE,gCAAA;AhKmouCd;AgKjouCc;EACE,mBAAA;AhKmouChB;AgK1nuCkB;EACE,2BAAA;AhK4nuCpB;AgKlnuCgB;EACE,+BpFjgFI;A5EqnzCtB;AgKxmuCkB;EACE,yBpFlhFG;A5E4nzCvB;AgKnmuCkB;EACE,cpFvhFI;A5E4nzCxB;AgK7luCY;EACE,8BAAA;AhK+luCd;AgK1luCQ;EACE,sBpF7kFF;EoF8kFE,YAAA;AhK4luCV;AgKtluCc;EACE,cpF9iFQ;A5EsozCxB;AgKlluCY;EACE,+BpFpjFQ;A5EwozCtB;AgKhluCgB;EACE,gCpFzjFI;A5E2ozCtB;AgK3kuCQ;EACE,yBpFrkFa;A5EkpzCvB;AgK3kuCY;EACE,YAAA;AhK6kuCd;AgK1kuCU;EACE,yBpF3kFW;EoF4kFX,kDAAA;EACA,yBAAA;AhK4kuCZ;AgK3kuCY;EACE,yBAAA;EACA,8BAAA;AhK6kuCd;AgK3kuCgB;EACE,oDAAA;AhK6kuClB;AgK5kuCkB;EACE,+BAAA;AhK8kuCpB;AgKzkuCY;EACE,8BAAA;EACA,yBpF7lFS;A5EwqzCvB;AgKtkuCkB;;EAEE,cpF5qFI;A5EovzCxB;AgK/juCkB;;;;EAEE,2CAAA;AhKmkuCpB;AgK7juCY;EACE,8BAAA;EACA,yBAAA;AhK+juCd;AgKxjuCkB;EACE,apF9nFG;A5EwrzCvB;AgKtjuCoB;EACE,8BpFhoFA;A5EwrzCtB;AgK/iuCoB;EACE,apF7oFC;A5E8rzCvB;AgK9iuCoB;EACE,8BpF9oFA;A5E8rzCtB;AgKziuCY;EACE,6BpF3sFM;EoF4sFN,gCAAA;AhK2iuCd;AgKziuCc;EACE,+BpF1pFM;A5EqszCtB;AgKxiuCc;;;;;;;;;;;EAME,+BpFnqFM;A5EktzCtB;AgK5iuCc;EACE,yBpF1qFO;A5EwtzCvB;AgK5iuCgB;EACE,+BpF1qFI;A5EwtzCtB;AgK5iuCkB;EACE,2BAAA;AhK8iuCpB;AgK1iuCc;EACE,yBpFrrFO;A5EiuzCvB;AgKxiuCY;EACE,cpFxrFU;A5EkuzCxB;AgKxiuCc;EACE,cpF3rFQ;A5EquzCxB;AgKtiuCY;;;EAGE,+BpFjsFQ;A5EyuzCtB;AgKniuCgB;EACE,yBAAA;AhKqiuClB;AgK/huCc;EACE,yBpFjtFO;EoFktFP,yBAAA;AhKiiuChB;AgK7huCY;EACE,+BpFptFQ;A5EmvzCtB;AgK5huCY;;;;;;EAME,qBpFztFK;A5EuvzCnB;AgK3huCc;;EAEE,+BpFluFM;A5E+vzCtB;AgKzhuCgB;EACE,gCAAA;AhK2huClB;AgKvhuCkB;EACE,6CAAA;AhKyhuCpB;AgK7guCgB;;;;;;;;;;;;;;EAEE,cpF7vFK;A5EwxzCvB;AgKvhuCc;;;;;;EAME,WpF3yFR;A5Eo0zCR;AgKthuCc;EACE,WpFhzFR;A5Ew0zCR;AgKphuCgB;EACE,WpFrzFV;A5E20zCR;AgKhhuCkB;;EAEE,6CAAA;AhKkhuCpB;AgK3guCc;;EAEE,WpFr0FR;A5Ek1zCR;AgKtguCkB;EACE,yCAAA;AhKwguCpB;AgKrguCsB;;EAEE,WpFl1FhB;A5Ey1zCR;AgK//tCY;;;EAGE,0BpFlzFK;EoFmzFL,2BpFnzFK;A5EozzCnB;AgK9/tCY;EACE,gCAAA;AhKgguCd;AgK9/tCc;;EAEE,gCAAA;AhKgguChB;AgKv/tCsB;EACE,+BpFz0FF;A5Ek0zCtB;AgKh/tCc;;;EAGE,+BAAA;AhKk/tChB;AgK3+tCgB;;;;EAEE,WpFr4FV;A5Eo3zCR;AgK1+tCY;EACE,yBpFv2FS;EoFw2FT,6BAAA;AhK4+tCd;AgKx+tCc;EACE,yBpF92FO;A5Ew1zCvB;AgKr+tCkB;EACE,sCAAA;AhKu+tCpB;AgKj+tCY;EACE,iCAAA;AhKm+tCd;AgKh+tCY;EACE,yCAAA;AhKk+tCd;AgK/9tCY;EACE,epFn4FS;A5Eo2zCvB;AgK99tCY;EACE,cpFp4FU;A5Eo2zCxB;AgK79tCY;EACE,6BAAA;AhK+9tCd;AgK59tCY;EACE,0CAAA;AhK89tCd;AgK39tCY;;;EAGE,sBAAA;EACA,yBAAA;AhK69tCd;AgK19tCc;EACE,sBAAA;AhK49tChB;AgKz9tCY;EACE,0CAAA;AhK29tCd;AgKx9tCc;EACE,0CAAA;AhK09tChB;AgKv9tCgB;EACE,8BpFl6FI;A5E23zCtB;AgKh9tCsB;EACE,apFh7FD;A5Ek4zCvB;AgK58tCkB;EACE,apFv7FG;A5Eq4zCvB;AgKv8tCgB;EACE,apF97FK;A5Eu4zCvB;AgKr8tCgB;EACE,apFn8FK;A5E04zCvB;AgKj8tCsB;EACE,wBAAA;AhKm8tCxB;AgK97tCkB;EACE,8BpF78FE;A5E64zCtB;AgKz7tCc;EACE,yBpFx9FO;EoFy9FP,+BpFt9FM;A5Ei5zCtB;AgKr7tCgB;EACE,+BpF79FI;A5Eo5zCtB;AgKr7tCkB;EACE,+BpFh+FE;A5Eu5zCtB;AgKj7tCY;EACE,0CAAA;AhKm7tCd;AgK16tCkB;;;;EACE,WpFxhGZ;A5Eu8zCR;AgK36tCgB;;;;EACE,YpF7hGV;A5E68zCR;AgKz6tCkB;;EACE,8BpF9/FE;A5E06zCtB;AgKr6tCc;EACE,+BpFtgGM;A5E66zCtB;AgKr6tCgB;EACE,+BpFzgGI;A5Eg7zCtB;AgKn6tCc;EACE,cpF/gGQ;A5Eo7zCxB;AgKh6tCc;EACE,yBpFxhGO;EoFyhGP,cpFthGQ;EoFuhGR,yBAAA;AhKk6tChB;AgK95tCY;EACE,yBpF/hGS;EoFgiGT,yBAAA;AhKg6tCd;AgK55tCc;EACE,WpFzkGR;A5Eu+zCR;AgK15tCgB;EACE,gCAAA;AhK45tClB;AgKx5tCc;;;EAGE,WpFplGR;A5E8+zCR;AgKt5tCgB;EACE,yBpFtjGK;EoFujGL,+BpFnjGI;EoFojGJ,yBAAA;AhKw5tClB;AgKp5tCc;;;;;EAKE,+BpF7jGM;A5Em9zCtB;AgKn5tCc;EACE,yBAAA;AhKq5tChB;AgKj5tCgB;EACE,yBpF1kGK;EoF2kGL,yBAAA;EACA,+BpFxkGI;A5E29zCtB;AgK54tCkB;;EACE,yBpFnlGG;A5Ek+zCvB;AgK54tCsB;;EACE,yBpF5kGC;A5E29zCzB;AgK14tCkB;;EACE,yBpFnlGC;A5Eg+zCrB;AgK34tCoB;;EACE,yBpFrlGG;A5Em+zCzB;AgKz4tCoB;;EACE,yBpF1lGQ;A5Es+zC9B;AgKt4tCc;EACE,yBAAA;AhKw4tChB;AgKr4tCkB;;EAEE,gCAAA;AhKu4tCpB;AgKn4tCgB;;EAEE,yBpFznGK;EoF0nGL,+BpFtnGI;EoFunGJ,yBAAA;AhKq4tClB;AgKj4tCkB;EACE,yBpF/nGG;A5Ekg0CvB;AgK93tCoB;;EACE,yBAAA;AhKi4tCtB;AgKx3tCoB;EACE,6BAAA;AhK03tCtB;AgKn3tCgB;EACE,0CAAA;AhKq3tClB;AgKn3tCkB;EAEE,kCAAA;AhKo3tCpB;AgKh3tCgB;EACE,yBAAA;AhKk3tClB;AgKh3tCkB;;EAEE,yBAAA;AhKk3tCpB;AgK12tCkB;;;;EAEE,6BAAA;AhK82tCpB;AgKp2tCsB;;EACE,yBpF5qGE;A5Emh0C1B;AgK51tCoB;;EACE,yBpF1rGG;A5Eyh0CzB;AgKx1tCgB;;EAEE,6BAAA;EACA,+BAAA;AhK01tClB;AgKx1tCkB;;EACE,8BAAA;AhK21tCpB;AgKl1tCoB;;;;;;EAGE,yBpF/tGC;A5Esj0CvB;AgK90tCgB;EACE,6BAAA;AhKg1tClB;AgK30tCY;EACE,yBAAA;AhK60tCd;AgKz0tCc;EACE,yBpFnvGO;EoFovGP,qBpFrvGO;A5Egk0CvB;AgKv0tCY;EACE,+BpFtvGQ;EoFuvGR,yBpF1vGS;A5Emk0CvB;AgKp0tCgB;EACE,yBpFjwGK;A5Euk0CvB;AgKh0tCc;EACE,yBpFxwGO;A5E0k0CvB;AgK7ztCc;EACE,cpF9wGO;A5E6k0CvB;AgK5ztCc;EACE,+BpF9wGM;A5E4k0CtB;AgK5ztCgB;EACE,+BpFjxGI;A5E+k0CtB;AgK1ztCc;EACE,cpFvxGQ;A5Eml0CxB;AgKxztCY;EACE,yBpF9xGS;EoF+xGT,6BAAA;AhK0ztCd;AgKlztCsB;;EAEE,cpFvyGA;A5E2l0CxB;AgK7ytCc;EACE,cpF/yGQ;A5E8l0CxB;AgK3ytCY;EACE,gCAAA;AhK6ytCd;AgK1ytCgB;EACE,+BpFvzGI;A5Emm0CtB;AgKvytCgB;EAGE,2BAAA;AhKuytClB;AgK5xtCgB;;;;;EACE,yBpF/0GK;A5Ein0CvB;AgKhytCkB;;;;;;;;;EAEE,sCAAA;AhKyytCpB;AgKjytCgB;EACE,yBAAA;EACA,yBpF51GK;EoF61GL,+BpF11GI;A5E6n0CtB;AgKjytCkB;EAEE,sCAAA;EACA,2BAAA;AhKkytCpB;AgKtxtCoB;;;EACE,2BAAA;AhK0xtCtB;AgKnxtCY;EACE,yBAAA;AhKqxtCd;AgKjxtCc;EACE,yBAAA;EACA,+BpF13GM;EoF23GN,yBpF/3GO;A5Ekp0CvB;AgK/wtCgB;EACE,mBpFn4GK;A5Eop0CvB;AgK5wtCY;EACE,yBpF14GS;A5Ewp0CvB;AgK5wtCc;EACE,8BAAA;AhK8wtChB;AgKvwtCkB;EACE,2BpFr5GG;EoFs5GH,wBpFv8GA;A5Egt0CpB;AgKlwtCc;EACE,oCAAA;AhKowtChB;AgK5vtCc;;;;EACE,YAAA;AhKiwtChB;AgK5vtCU;;EAEE,yBpF96GW;A5E4q0CvB;AgKxvtCgB;EACE,WpFx9GV;A5Ekt0CR;AgKtvtCc;EACE,+BpFt7GM;A5E8q0CtB;AgKtvtCgB;EACE,WpFh+GV;A5Ewt0CR;AgKlvtCkB;EACE,WpFv+GZ;A5E2t0CR;AgKhvtCgB;EACE,+BpFr8GI;A5Eur0CtB;AgKhvtCkB;EACE,WpF/+GZ;A5Eiu0CR;AgK3utCc;EACE,yBAAA;AhK6utChB;AgKzutCY;EACE,cpFt9GU;A5Eis0CxB;AgKtutCY;EACE,yBpF99GS;EoF+9GT,+BpF59GQ;EoF69GR,qBpFj+GS;A5Eys0CvB;AgKnutCY;EACE,0BAAA;AhKqutCd;AgK9ttCgB;EACE,cpF/+GK;A5E+s0CvB;AgKzttCY;EACE,+BpFn/GQ;A5E8s0CtB;AgKvttCc;EACE,yBAAA;AhKyttChB;AgKrttCY;EACE,cpF9/GU;A5Eqt0CxB;AgKnttCU;EACE,yBpFrgHW;EoFsgHX,yBAAA;AhKqttCZ;AgKhttCY;;;;EAEE,mBpF7gHS;EoF8gHT,yBAAA;AhKottCd;AgKlttCc;;;;EACE,yBpFlhHO;EoFmhHP,qBpFnhHO;EoFohHP,+BpFhhHM;A5Euu0CtB;AgKrttCgB;;;;EACE,aAAA;AhK0ttClB;AgKrttCY;;EACE,yBpF7hHS;EoF8hHT,qBpF9hHS;EoF+hHT,+BpF3hHQ;A5Emv0CtB;AgKnttCY;EACE,yBpFpiHS;A5Eyv0CvB;AgKhttCY;EACE,yBpF3iHS;A5E6v0CvB;AgK9stCU;;EAEE,yBAAA;AhKgttCZ;AgK5stCY;EACE,yBpF1iHW;A5Ewv0CzB;AgKxstCc;EACE,yBAAA;AhK0stChB;AgKtstCgB;EACE,+BpF9jHI;A5Esw0CtB;AgKlstCU;EACE,+BpFrkHU;EoFskHV,gBAAA;AhKostCZ;AgKjstCU;EACE,iDAAA;AhKmstCZ;AgK/rtCY;EACE,+BpF/kHQ;A5Egx0CtB;AgK3rtCc;EACE,+BpFtlHM;A5Emx0CtB;AgK3rtCgB;EACE,2BAAA;AhK6rtClB;AgKxrtCY;EACE,gCAAA;AhK0rtCd;AgKprtCc;EACE,0CAAA;AhKsrtChB;AgK9qtCgB;EACE,sCAAA;AhKgrtClB;AgKvqtCgB;EACE,+BpFznHI;A5Eky0CtB;AgKtqtCgB;EACE,2BAAA;AhKwqtClB;AgKtqtCkB;EACE,2BAAA;AhKwqtCpB;AgKhqtCY;EACE,yBpF7oHS;EoF8oHT,8BAAA;AhKkqtCd;AgK9ptCkB;EACE,WpFtrHZ;A5Es10CR;AgK3ptCsB;;;;;EAKE,0CAAA;AhK6ptCxB;AgKvptCwB;;;;;EAKE,sCAAA;AhKyptC1B;AgK5otCgB;EACE,gCAAA;AhK8otClB;AgKtotCc;EACE,+BpF3rHM;A5Em00CtB;AgKrotCc;EACE,cpFhsHQ;A5Eu00CxB;AgKpotCc;EACE,yBAAA;EACA,gBAAA;AhKsotChB;AgKjotCU;EACE,oCAAA;AhKmotCZ;AgK/ntCY;EACE,+BpF/sHQ;A5Eg10CtB;AgK3ntCgB;;EACE,cpFvtHM;EoFwtHN,+BAAA;AhK8ntClB;AgK5ntCkB;;EACE,+BAAA;AhK+ntCpB;AgK5ntCkB;;EACE,kBAAA;AhK+ntCpB;AgK1ntCc;;EACE,+BpFpuHM;A5Ei20CtB;AgK1ntCc;;EACE,6BAAA;AhK6ntChB;AgK3ntCgB;;EACE,cpF5uHM;A5E020CxB;AgKrntCgB;EACE,cpFtvHM;A5E620CxB;AgKnntCc;EACE,yBAAA;AhKqntChB;AgKjntCY;EACE,cpFhwHU;A5Em30CxB;AgK/mtCc;EACE,cpFrwHQ;EoFswHR,YAAA;AhKintChB;AgKhntCgB;EACE,+BAAA;AhKkntClB;AgK7mtCY;EACE,6BAAA;AhK+mtCd;AgKxmtCgB;EACE,6BAAA;AhK0mtClB;AgKxmtCkB;;EAEE,WpFh0HZ;A5E060CR;AgKlmtCY;EACE,0BAAA;EACA,+BpFjyHe;EoFkyHf,qBAAA;EACA,aAAA;AhKomtCd;AgKlmtCc;EACE,gBpFh1HR;EoFi1HQ,2BAAA;AhKomtChB;AgKlmtCc;EACE,aAAA;AhKomtChB;AgK9ltCY;EACE,yBpFtzHS;EoFuzHT,yBAAA;AhKgmtCd;AgK5ltCc;EACE,+BpFzzHM;A5Eu50CtB;AgK1ltCY;EACE,oCAAA;AhK4ltCd;AgKtltCc;EACE,6BAAA;AhKwltChB;AgKrltCc;EACE,+BpFz0HM;A5Eg60CtB;AgKlltCc;EACE,cpFh1HQ;A5Eo60CxB;AgK5ktCc;;EACE,8BpFx1HM;A5Eu60CtB;AgKxktCc;EACE,yBpFn2HO;A5E660CvB;AgKrktCc;EACE,cpFv2HQ;A5E860CxB;AgKjktCgB;EACE,cpF92HM;A5Ei70CxB;AgK5jtCgB;EACE,cpFt3HM;A5Eo70CxB;AgK3jtCgB;EACE,8BAAA;AhK6jtClB;AgKvjtCU;EACE,yBpFp4HW;EoFq4HX,+BpFj4HU;EoFk4HV,yBAAA;AhKyjtCZ;AgKxjtCY;EACE,yBpFv4HS;A5Ei80CvB;AgKnjtCc;;EACE,yBpFh5HO;EoFi5HP,yBAAA;EACA,+BpF94HM;A5Eo80CtB;AgK/itCc;EACE,yBpF15HO;A5E280CvB;AgK/itCgB;EACE,+BpFz5HI;EoF05HJ,6BpF/8HE;EoFg9HF,qBpF95HK;A5E+80CvB;AgKhjtCkB;EACE,yBpFh6HG;A5Ek90CvB;AgK/itCgB;EACE,+BpFj6HI;A5Ek90CtB;AgK/itCgB;EACE,yBAAA;AhKijtClB;AgKzitCc;EACE,yBpFj7HO;A5E490CvB;AgKzitCgB;EACE,+BpFh7HI;A5E290CtB;AgKzitCkB;EAEE,yBpFv7HG;A5Ei+0CvB;AgKjitCc;EACE,+BpF97HM;A5Ei+0CtB;AgKhitCc;EACE,cpFn8HQ;A5Eq+0CxB;AgK5htCY;EACE,yBpF78HS;A5E2+0CvB;AgK5htCc;EACE,yBpF/8HO;A5E6+0CvB;AgKxhtCY;EACE,8BAAA;AhK0htCd;AgKxhtCc;EACE,+BpFt9HM;A5Eg/0CtB;AgKxhtCgB;EACE,+BpFz9HI;A5Em/0CtB;AgKthtCc;EACE,cpF/9HQ;A5Eu/0CxB;AgKhhtCgB;EACE,yBAAA;AhKkhtClB;AgK5gtCkB;EACE,+BpF9+HE;A5E4/0CtB;AgK5gtCoB;EACE,yBpFr/HC;A5Emg1CvB;AgKtgtCoB;EACE,+BpF1/HA;A5Ekg1CtB;AgK9/sCkB;EACE,0CAAA;AhKggtCpB;AgK5/sCkB;EACE,yBpF9gIG;A5E4g1CvB;AgKv/sCc;EACE,+BpFlhIM;A5E2g1CtB;AgKv/sCgB;EACE,cpFthIM;A5E+g1CxB;AgKv/sCkB;EACE,cpFzhII;A5Ekh1CxB;AgKp/sCc;EACE,cpF/hIQ;A5Eqh1CxB;AgKl/sCY;EACE,gCAAA;AhKo/sCd;AgKj/sCY;EACE,cpFxiIU;A5E2h1CxB;AgK9+sCgB;EACE,yBAAA;AhKg/sClB;AgK3+sCc;EACE,WpF1lIR;A5Euk1CR;AgKx+sCU;EACE,yBpF7jIW;EoF8jIX,yBAAA;AhK0+sCZ;AgKz+sCY;EACE,+BpF5jIQ;EoF6jIR,uBpFlnIM;EoFmnIN,yBpFjkIS;A5E4i1CvB;AgK1+sCc;EACE,yBpFnkIO;A5E+i1CvB;AgKr+sCc;EACE,cpFzkIQ;A5Egj1CxB;AgKp+sCc;EACE,yBpFhlIO;A5Esj1CvB;AgKh+sCY;EACE,yBpFtlIS;A5Ewj1CvB;AgK99sCU;EACE,2CAAA;AhKg+sCZ;AgK79sCU;EACE,uCAAA;AhK+9sCZ;AgK39sCY;EACE,cpFrmIS;A5Ekk1CvB;AgK19sCY;EACE,+BpFrmIQ;A5Eik1CtB;AgKz9sCY;EACE,+BpFzmIQ;A5Eok1CtB;AgKx9sCY;EACE,cpF9mIU;A5Ewk1CxB;AgKr9sCY;EACE,yBpFtnIS;EoFunIT,yBAAA;AhKu9sCd;AgKl9sCY;EACE,yBpF9nIS;EoF+nIT,yBAAA;AhKo9sCd;AgK/8sCY;EACE,yBpFroIS;EoFsoIT,cpFnoIU;EoFooIV,yBAAA;AhKi9sCd;AgK98sCY;EACE,yBpF1oIS;EoF2oIT,yBAAA;EACA,+BAAA;AhKg9sCd;AgK18sCkB;EACE,8BAAA;AhK48sCpB;AgKt8sCY;;EAEE,cpFzpIU;EoF0pIV,+BAAA;AhKw8sCd;AgKp8sCc;EACE,yBpFlqIO;A5Ewm1CvB;AgKn8sCc;EACE,yBAAA;EACA,yBpFtqIO;A5E2m1CvB;AgKh8sCkB;EACE,yBpF7qIG;EoF8qIH,qBpF9qIG;EoF+qIH,cpF5qII;A5E8m1CxB;AgK97sCoB;EACE,cpFjrIE;A5Ein1CxB;AgKz7sCY;EACE,+BpFxrIQ;A5Emn1CtB;AgKt7sCY;EACE,yBAAA;AhKw7sCd;AgKj7sCc;;;EACE,WpF7uIR;A5Ekq1CR;AgK16sCkB;EACE,yBpF9sID;A5E0n1CnB;AgK9jwCQ;EAypDE,YAAA;AhKw6sCV;AgKp6sCU;EACE,+BpF9tIU;A5Eoo1CtB;AgKx6sCQ;EAKE,6BAAA;EACA,yBpFruIa;A5E2o1CvB;AgKn6sCQ;;EAEE,mBpF3uIa;EoF4uIb,+BpFxuIY;A5E6o1CtB;AgKl6sCQ;EACE,yBpF/uIa;EoFgvIb,6BAAA;AhKo6sCV;AgK/5sCQ;EACE,+BpFnvIY;A5Eop1CtB;AgK75sCM;EACE,yBpF3vIe;EoF4vIf,yBAAA;AhK+5sCR;AgK75sCQ;EACE,yBpF/vIa;A5E8p1CvB;AgKz5sCU;EACE,+BpFnwIU;A5E8p1CtB;AgKv5sCQ;EACE,8BAAA;AhKy5sCV;AgKv5sCU;EACE,gCAAA;AhKy5sCZ;AgKr5sCgB;EACE,0CAAA;AhKu5sClB;AgK/4sCc;EACE,yBpF5xIO;EoF6xIP,mCAAA;AhKi5sChB;AgK74sCgB;EACE,yBAAA;AhK+4sClB;AgKz4sCc;EACE,cpFvyIQ;A5Ekr1CxB;AgKt4sCc;EACE,cpF7yIQ;A5Eqr1CxB;AgKr4sCc;EACE,+BpFhzIM;A5Eur1CtB;AgKj4sCQ;EACE,cpFxzIc;A5E2r1CxB;AgKj4sCU;EACE,0CAAA;AhKm4sCZ;AgK73sCY;EACE,gCAAA;AhK+3sCd;AgK13sCoB;EACE,cpFx0IE;A5Eos1CxB;AgKt3sCc;EACE,mCAAA;AhKw3sChB;AgKn3sCc;EACE,yBAAA;AhKq3sChB;AgKl3sCc;EACE,+BpFx1IM;A5E4s1CtB;AgKj3sCc;EACE,yBpFh2IO;A5Emt1CvB;AgK/2sCY;EACE,yBpFp2IS;EoFq2IT,6BAAA;AhKi3sCd;AgK92sCgB;EACE,yBpFz2IK;A5Eyt1CvB;AgKt2sCc;EACE,yBAAA;AhKw2sChB;AgKt2sCgB;EACE,cpFr3IM;A5E6t1CxB;AgKh2sCM;EACE,yBpFj4Ie;EoFk4If,+BpF93Ic;A5Egu1CtB;AgK/1sCM;EACE,yBpFt4Ie;A5Euu1CvB;AgK91sCM;EACE,gCAAA;AhKg2sCR;AgK91sCM;EACE,yBpF54Ie;EoF64If,yBAAA;EACA,+BAAA;AhKg2sCR;AgK/1sCQ;EACE,+BAAA;AhKi2sCV;AgK71sCQ;;EAEE,mBpFv5Ia;EoFw5Ib,yBAAA;EACA,+BpFr5IY;A5Eov1CtB;AgK31sCM;;EAEE,sBpFl8IA;A5E+x1CR;AgK11sCM;EACE,yBpFl6Ie;EoFm6If,0CAAA;EACA,+BpFj6Ic;A5E6v1CtB;AgK11sCQ;EACE,mBAAA;AhK41sCV;AgKz1sCQ;EACE,iDAAA;EACA,kCAAA;EACA,WpFj9IF;A5E4y1CR;AgKx1sCQ;EAEE,UAAA;EACA,qBAAA;AhKy1sCV;AgKp1sCQ;EAEE,yBpF37Ia;A5Egx1CvB;AgKh1sCQ;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AhKk1sCV;AgK90sCM;EACE,cAAA;EACA,yBAAA;AhKg1sCR;AgK70sCM;EACE,cAAA;EACA,yBAAA;AhK+0sCR;AgK50sCM;EACE,cAAA;EACA,yBAAA;AhK80sCR;AgK30sCM;EACE,cAAA;EACA,yBAAA;AhK60sCR;AgK10sCM;EACE,cAAA;EACA,yBAAA;AhK40sCR;AgKz0sCM;EACE,cAAA;EACA,yBAAA;AhK20sCR;AgKx0sCM;EACE,cAAA;EACA,yBAAA;AhK00sCR;AgKv0sCM;EACE,cAAA;EACA,yBAAA;AhKy0sCR;AgKt0sCM;EACE,8BAAA;EACA,uCAAA;AhKw0sCR;AgKr0sCU;EACE,yBpFp/IW;A5E2z1CvB;AgKn0sCgB;EACE,+BpFt/II;EoFu/IJ,yBpF3/IK;EoF4/IL,yBAAA;AhKq0sClB;AgKl0sCgB;EACE,+BpF5/II;A5Eg01CtB;AgK/zsCgB;EACE,+BpFlgJI;A5Em01CtB;AgK/zsCkB;EACE,yBpFzgJG;EoF0gJH,yBAAA;AhKi0sCpB;AgK1zsCU;;;;;EAGE,WpFvjJJ;A5Eq31CR;AgKzzsCM;EACE,8BAAA;EACA,uCAAA;AhK2zsCR;AgKxzsCU;;;EAEE,WpFnkJJ;A5E831CR;AgKxzsCU;EACE,cpFjiJY;A5E211CxB;AgKvzsCU;EACE,yBpFviJW;A5Eg21CvB;AgKrzsCgB;;EAEE,yBpF9iJK;EoF+iJL,yBAAA;EACA,+BpF5iJI;A5Em21CtB;AgKjzsCkB;EACE,yBpFvjJG;EoFwjJH,yBAAA;AhKmzsCpB;AgKvysCY;EACE,cpFrkJS;A5E821CvB;AgKrysCc;EACE,cpF1kJO;A5Ei31CvB;AgKhysCM;EACE,yBpFjlJe;A5Em31CvB;AgKhysCQ;EACE,gCAAA;AhKkysCV;AgKhysCU;EACE,cpFrlJY;A5Eu31CxB;AgK9xsCQ;EACE,6BAAA;AhKgysCV;AgK5xsCM;EACE,8BAAA;EACA,uCAAA;AhK8xsCR;AgK3xsCU;EACE,+BpFnmJU;A5Eg41CtB;AgK1xsCU;EACE,6BAAA;EACA,gCAAA;AhK4xsCZ;AgK1xsCY;EACE,+BpF3mJQ;A5Eu41CtB;AgKvxsCY;EACE,+BpFjnJQ;A5E041CtB;AgKlxsCQ;EACE,6BAAA;AhKoxsCV;AgKlxsCU;EACE,mBpFhoJW;EoFioJX,+BpF7nJU;A5Ei51CtB;AgK/wsCM;EACE,yBpFvoJe;A5Ew51CvB;AgK7wsCY;EACE,yBpF3oJS;A5E051CvB;AgK5wsCY;EACE,cpF7oJU;A5E251CxB;AgKzwsCgB;EACE,cpFnpJM;A5E851CxB;AgKxwsCgB;EACE,yBpF1pJK;EoF2pJL,+BpFvpJI;EoFwpJJ,qBpF5pJK;A5Es61CvB;AgKtwsCc;EACE,yBpFjqJO;A5Ey61CvB;AgKlwsCY;EACE,+BpFpqJQ;A5Ew61CtB;AgKjwsCY;EACE,cpFzqJU;A5E461CxB;AgKhwsCY;EACE,+BpF5qJQ;A5E861CtB;AgK/vsCY;EACE,yBpFnrJS;A5Eo71CvB;AgK7vsCkB;;EAEE,yBpF1rJG;EoF2rJH,yBAAA;EACA,+BpFxrJE;A5Eu71CtB;AgKzvsCoB;EACE,yBpFnsJC;EoFosJD,yBAAA;AhK2vsCtB;AgKjvsCM;EACE,yBpF9sJe;A5Ei81CvB;AgK/usCQ;EACE,+BpFhtJY;EoFitJZ,gCAAA;AhKivsCV;AgK3usCc;EACE,2BAAA;AhK6usChB;AgKrusCQ;EACE,yBpFpuJa;A5E281CvB;AgKrusCU;EACE,yBpFvuJW;EoFwuJX,yBAAA;EACA,mBAAA;EACA,WpF9wJJ;A5Eq/1CR;AgKpusCU;EACE,yBAAA;AhKsusCZ;AgKjusCU;EACE,sCAAA;EACA,sCAAA;AhKmusCZ;AgK9tsCU;EACE,wCAAA;EACA,wCAAA;AhKgusCZ;AgK1tsCQ;EACE,yBpFnwJa;A5E+91CvB;AgKztsCM;EACE,yBpFvwJe;EoFwwJf,8BAAA;AhK2tsCR;AgKxtsCM;EAKU;IACE,yBAAA;EhKstsChB;EgKhtsCY;IACE,+BpFrxJM;E5Eu+1CpB;EgK3ssCQ;IACE,YAAA;EhK6ssCV;EgKtssCY;IACE,qCAAA;IACA,8BAAA;EhKwssCd;AACF;AgKnssCM;EAEI;IACE,gCAAA;EhKossCV;EgKjssCM;IACE,6BAAA;IACA,yBpFvzJa;E5E0/1CrB;EgK7rsCY;IACE,cpFn3JH;E5Ekj2CX;AACF;AgKzrsCM;EAIQ;IACE,6BAAA;IACA,gCAAA;EhKwrsCd;EgK9qsCc;IACE,+BAAA;EhKgrsChB;AACF;AgKxqsCI;EACE,yBpFj2JiB;A5E2g2CvB;AgKtqsCM;EACE,yBpFr2Je;A5E6g2CvB;AgKpqsCI;EACE,yBpF12JiB;A5Egh2CvB;AgKpqsCM;EACE,mBpF72Je;EoF82Jf,4BAAA;EACA,0BAAA;AhKsqsCR;AgKpqsCQ;EACE,yBpFn3Ja;EoFo3Jb,yBAAA;EACA,+BpFj3JY;A5Euh2CtB;AgKnqsCQ;EACE,0BAAA;EACA,cpFv3Jc;A5E4h2CxB;AgK/psCM;EACE,yBpFj4Je;EoFk4Jf,+BpF93Jc;EoF+3Jd,yBAAA;AhKiqsCR;AgK9psCM;EACE,cpFp4JgB;A5Eoi2CxB;AgK7psCM;EACE,yBpF34Je;EoF44Jf,+BpFx4Jc;EoFy4Jd,yBAAA;AhK+psCR;AgKzpsCU;;EACE,yBpFp5JW;EoFq5JX,yBAAA;AhK4psCZ;AgKrpsCM;;EAEE,yBpF95Je;EoF+5Jf,oCAAA;AhKupsCR;AgKnpsCQ;EACE,+BpFh6JY;A5Eqj2CtB;AgKhpsCQ;EACE,+BpFt6JY;A5Ewj2CtB;AgK7osCQ;EACE,yBpFh7Ja;EoFi7Jb,yBAAA;EACA,+BpF96JY;A5E6j2CtB;AgK3osCM;EACE,oCAAA;EACA,0CAAA;AhK6osCR;AgKzosCI;EACE,yBpF77JiB;EoF87JjB,yBAAA;AhK2osCN;AgKvosCM;EACE,6CAAA;EACA,sCAAA;AhKyosCR;AgKtosCM;EACE,+CAAA;EACA,wCAAA;AhKwosCR;AgKrosCM;EACE,gCAAA;EACA,yBAAA;AhKuosCR;AgKposCM;EACE,gCAAA;EACA,yBAAA;AhKsosCR;AgKnosCM;EACE,gCAAA;EACA,yBAAA;AhKqosCR;AgKlosCM;EACE,gCAAA;EACA,yBAAA;AhKoosCR;AgKjosCM;EACE,6BAAA;EACA,sBAAA;AhKmosCR;AgKhosCM;EACE,iDAAA;EACA,sBAAA;AhKkosCR;AgK/nsCM;EACE,mDAAA;EACA,sBAAA;AhKiosCR;AgK9nsCM;EACE,oCAAA;EACA,sBAAA;AhKgosCR;AgK7nsCM;EACE,oCAAA;EACA,sBAAA;AhK+nsCR;AgK5nsCM;EACE,oCAAA;EACA,sBAAA;AhK8nsCR;AgK3nsCM;EACE,oCAAA;EACA,sBAAA;AhK6nsCR;AgK1nsCM;EACE,iCAAA;EACA,sBAAA;AhK4nsCR;AgKvnsCM;EACE,yBpF3gKe;A5Eoo2CvB;AgKnnsCQ;EACE,yBpFlhKa;EoFmhKb,+BpF/gKY;EoFghKZ,qBpFphKa;A5Eyo2CvB;AgKlnsCQ;;;;;;;;;;;;;;;EAeE,qBpFtiKa;EoFuiKb,yBpFviKa;EoFwiKb,+BpFpiKY;A5Ewp2CtB;AgKlnsCU;;;;;;;;;;;;;;;EACE,cpFxiKY;A5E0q2CxB;AgK9nsCQ;EACE,yBpFhjKa;EoFijKb,+BpF7iKY;A5E6q2CtB;AgK7nsCQ;EACE,qBpFrjKa;A5Eor2CvB;AgK3nsCM;EACE,6BAAA;AhK6nsCR;AgK3nsCQ;EACE,mBpF5jKa;EoF6jKb,+BpF1jKY;A5Eur2CtB;AgKxnsCI;EACE,mBpFnkKiB;EoFokKjB,yBAAA;EACA,+BpFlkKgB;A5E4r2CtB;AgKvnsCQ;EACE,mBpFzkKa;A5Eks2CvB;AgKpnsCI;EACE,6BAAA;EACA,8BAAA;EACA,+BAAA;AhKsnsCN;AgKpnsCM;EACE,0CAAA;AhKsnsCR;AgKpnsCQ;EAEE,mBpFzlKa;A5E8s2CvB;AgKjnsCM;EACE,8BAAA;EACA,+BAAA;AhKmnsCR;AgKhnsCQ;EACE,uEAAA;AhKknsCV;AgKhnsCQ;EACE,uEAAA;AhKknsCV;AgK3msCQ;EACE,mBpF9mKa;A5E2t2CvB;AgKxmsCI;EACE,yBpFnnKiB;A5E6t2CvB;AgKvmsCI;;EAEE,mBpFxnKiB;EoFynKjB,yBAAA;AhKymsCN;AgKtmsCI;EACE,mBpF9nKiB;A5Esu2CvB;AgKtmsCM;EAEE,gCAAA;EACA,WpFtqKA;A5E6w2CR;AgKnmsCI;;EAEE,+BpFroKgB;A5E0u2CtB;AgKlmsCI;EACE,yBpF5oKiB;A5Egv2CvB;AgKhmsCM;EACE,yBpFlpKe;A5Eov2CvB;AgK9lsCI;;EAEE,mBpFxpKiB;EoFypKjB,yBAAA;AhKgmsCN;AgK5lsCM;;EAEE,mBpF/pKe;EoFgqKf,yBAAA;AhK8lsCR;AgK3lsCM;EACE,yBAAA;AhK6lsCR;AgKxlsCM;EACE,yBpF1qKe;A5Eow2CvB;AgKtlsCI;EACE,qBpF/qKiB;A5Euw2CvB;AgKrlsCQ;EACE,yBpFlrKa;EoFmrKb,+BpFhrKY;A5Euw2CtB;AgKllsCI;EACE,yBpFzrKiB;A5E6w2CvB;AgKllsCM;EACE,+BpFzrKc;A5E6w2CtB;AgKjlsCM;EACE,cpF9rKgB;A5Eix2CxB;AgKhlsCM;EACE,yBpFrsKe;EoFssKf,+BpFlsKc;A5Eox2CtB;AgK9ksCI;EACE,gCAAA;AhKglsCN;AgK9ksCM;EACE,+BpF1sKc;A5E0x2CtB;AgK/ksCQ;EACE,yBpF/sKa;EoFgtKb,+BpF7sKY;EoF8sKZ,qCAAA;AhKilsCV;AgK9ksCQ;EAEE,qCAAA;AhK+ksCV;AgK1ksCQ;EACE,yBpF5tKa;EoF6tKb,+BpF1tKY;EoF2tKZ,qCAAA;AhK4ksCV;AgKrksCQ;EACE,sCAAA;AhKuksCV;AgKlksCQ;EACE,sCAAA;AhKoksCV;AgK9jsCM;EACE,mBAAA;AhKgksCR;AgKzjsCU;EAGE,qCAAA;AhKyjsCZ;AgKljsCQ;EACE,6BAAA;AhKojsCV;AgK/isCQ;EACE,6BAAA;AhKijsCV;AgK3isCM;;EACE,+BpF/wKc;A5E6z2CtB;AgK5isCQ;;EACE,2BAAA;AhK+isCV;AgK1isCQ;;EACE,2BAAA;AhK6isCV;AgKtisCQ;EAGE,yCAAA;EACA,wCAAA;AhKsisCV;AgKlisCM;EACE,yCAAA;EACA,wCAAA;AhKoisCR;AgKjisCM;EACE,wCAAA;EACA,yCAAA;AhKmisCR;AgK7hsCQ;EAGE,yBAAA;AhK6hsCV;AgKzhsCM;EACE,0BpFh4KQ;EoFi4KR,yBAAA;AhK2hsCR;AgKxhsCM;EACE,yBAAA;EACA,0BpFt4KQ;A5Eg62ChB;AgKphsCQ;EAGE,yBAAA;AhKohsCV;AgKhhsCM;EACE,0BpFn5KK;EoFo5KL,yBAAA;AhKkhsCR;AgK/gsCM;EACE,yBAAA;EACA,0BpFz5KK;A5E062Cb;AgK3gsCQ;EAGE,wCAAA;AhK2gsCV;AgKtgsCQ;EACE,wCAAA;AhKwgsCV;AgKjgsCQ;EAGE,yBAAA;AhKigsCV;AgK5/rCQ;EACE,yBAAA;AhK8/rCV;AgKz/rCI;EACE,6BAAA;AhK2/rCN;AgKx/rCI;EACE,yBpFl4KiB;EoFm4KjB,mCAAA;AhK0/rCN;AgKx/rCM;EACE,+BpFn4Kc;A5E632CtB;AgKv/rCM;EACE,cpFx4KgB;A5Ei42CxB;AgKr/rCQ;EACE,yBpFh5Ka;EoFi5Kb,+BpF74KY;EoF84KZ,yBAAA;AhKu/rCV;AgKl/rCQ;EACE,cpFr5Kc;A5Ey42CxB;AgK/+rCI;EACE,yBpF95KiB;EoF+5KjB,kBAAA;AhKi/rCN;AgK7+rCM;EACE,mBpFp6Ke;A5Em52CvB;AgK3+rCI;EACE,6BAAA;EACA,gCAAA;AhK6+rCN;AgK3+rCM;EACE,sBpFh9KA;A5E672CR;AgK1+rCM;EACE,yBpFh7Ke;EoFi7Kf,sBAAA;AhK4+rCR;AgK1+rCQ;EACE,+BpFj7KY;A5E652CtB;AgKp+rCc;EACE,+BpF17KM;A5Eg62CtB;AgKn+rCc;EACE,yBpFl8KO;EoFm8KP,+BpF/7KM;EoFg8KN,YAAA;AhKq+rChB;AgK99rCc;EACE,sBpF/+KR;A5E+82CR;AgK99rCgB;EACE,+BpF38KI;A5E262CtB;AgKx9rCc;EACE,yBpFv9KO;EoFw9KP,yBAAA;EACA,+BpFt9KM;A5Eg72CtB;AgK98rCY;EACE,mBpFt+KS;EoFu+KT,gCAAA;AhKg9rCd;AgK98rCc;EACE,+BpFv+KM;A5Eu72CtB;AgK58rCgB;EACE,WpFnhLV;A5Ei+2CR;AgKx8rCkB;EACE,mBpFt/KG;EoFu/KH,yBAAA;AhK08rCpB;AgKl8rCgB;EACE,2BAAA;AhKo8rClB;AgKh8rCkB;EACE,oCAAA;AhKk8rCpB;AgKx7rCY;EACE,yBpFhhLS;EoFihLT,yBAAA;EACA,+BpF/gLQ;A5Ey82CtB;AgKj7rCQ;EACE,cpF1hLc;A5E682CxB;AgKh7rCQ;EACE,+BpF7hLY;A5E+82CtB;AgK36rCY;EACE,+BpFriLQ;A5Ek92CtB;AgKt6rCY;EACE,0BAAA;AhKw6rCd;AgKp6rCU;EACE,yBpFrjLW;A5E292CvB;AgKl6rCQ;EACE,8BAAA;AhKo6rCV;AgK/5rCQ;EACE,+BpF7jLY;A5E892CtB;AgK55rCQ;EACE,+BpFnkLY;A5Ei+2CtB;AgK35rCQ;EACE,cpFxkLc;A5Eq+2CxB;AgKx5rCI;EACE,uCAAA;EACA,gCAAA;AhK05rCN;AgKt5rCM;;EAEE,yBAAA;AhKw5rCR;AgKr5rCM;EACE,cpFzlLgB;A5Eg/2CxB;AgKp5rCM;EACE,WpFnoLA;EoFooLA,6BpFlpLY;A5Ewi3CpB;AgKn5rCM;EACE,yBpFrmLe;EoFsmLf,yBAAA;AhKq5rCR;AgKh5rCM;EACE,yBpF5mLe;EoF6mLf,+BpFzmLc;A5E2/2CtB;AgK/4rCM;EACE,+BpF7mLc;EoF8mLd,yBpFlnLe;EoFmnLf,6BAAA;AhKi5rCR;AgKh5rCQ;EAEE,yBpFrnLa;A5Esg3CvB;AgK34rCM;EACE,+BpFznLc;A5Esg3CtB;AgKx4rCM;EACE,yBpFnoLe;A5E6g3CvB;AgKx4rCQ;EACE,yBpFtoLa;A5Egh3CvB;AgKt4rCM;EACE,yBAAA;AhKw4rCR;AgKr4rCM;EACE,yBpF/oLe;EoFgpLf,yBAAA;EACA,WpFprLA;A5E2j3CR;AgKp4rCM;;EAEE,yBAAA;AhKs4rCR;AgKp4rCQ;;EACE,iBAAA;EACA,mBpFzpLa;A5Egi3CvB;AgKl4rCI;EACE,yBpFhqLiB;A5Eoi3CvB;AgKh4rCM;EACE,+BpFjqLc;A5Emi3CtB;AgK93rCI;EACE,yBpFzqLiB;EoF0qLjB,yBAAA;AhKg4rCN;AgK93rCM;EACE,yBpF7qLe;EoF8qLf,gCAAA;AhKg4rCR;AgK53rCI;EACE,yBpFprLiB;A5Ekj3CvB;AgKn2rCM;;;;;;;;;;;;;;;;;;;;;;;;EACE,YAAA;AhK43rCR;AgKp3rCU;;EACE,yBpFztLW;A5Egl3CvB;AgKj3rCI;EACE,uCAAA;AhKm3rCN;AgKj3rCM;EACE,+BpF/tLc;A5Ekl3CtB;AgK/2rCI;EACE,oCAAA;AhKi3rCN;AgK92rCI;EACE,yBpF3uLiB;A5E2l3CvB;AgK92rCM;EACE,gCAAA;AhKg3rCR;AgK92rCQ;EACE,+BpF9uLY;EoF+uLZ,gBAAA;AhKg3rCV;AgK32rCQ;EACE,yBpFxvLa;EoFyvLb,+BpFtvLY;EoFuvLZ,yBAAA;AhK62rCV;AgKt2rCQ;EACE,yBpF3vLS;A5Emm3CnB;AgKl2rCM;EACE,+BpFrwLe;A5Eym3CvB;AgKh2rCI;;;EAGE,cpFh1LO;A5Ekr3Cb;AgK91rCM;EAOE,cpFz1LO;A5Emr3Cf;AgKr1rCM;EACE,yBpFjyLe;A5Ewn3CvB;AgKj1rCQ;EACE,oCAAA;EACA,8BAAA;AhKm1rCV;AgK30rCM;EACE,+BpF/yLc;A5E4n3CtB;AgK90rCM;EACE,+BpF/yLc;A5E+n3CtB;AgKj1rCM;EACE,+BpF/yLc;A5Eko3CtB;AgKp1rCM;EACE,+BpF/yLc;A5Eqo3CtB;AgKv1rCM;EACE,+BpF/yLc;A5Ewo3CtB;AgK11rCM;EACE,+BpF/yLc;A5E2o3CtB;AgK71rCM;EACE,+BpF/yLc;A5E8o3CtB;AgKh2rCM;EACE,+BpF/yLc;A5Eip3CtB;AgK31rCU;EACE,2CAAA;EACA,yBpF5zLW;EoF6zLX,kBAAA;AhK61rCZ;AgKx1rCM;EACE,WpFt2LA;EoFu2LA,aAAA;EACA,6BAAA;AhK01rCR;AgKp1rCQ;EACE,cpFz0Lc;A5E+p3CxB;AgKh1rCU;EACE,+BAAA;AhKk1rCZ;AgK70rCU;EACE,cpFt1LY;A5Eqq3CxB;AgK30rCY;;EAEE,cpF51LU;A5Eyq3CxB;AgKn0rCU;EACE,oCAAA;EACA,uBAAA;AhKq0rCZ;AgKn0rCU;EACE,qBpFt2LO;A5E2q3CnB;AgKh0rCY;EACE,yBpFp3LS;A5Esr3CvB;AgK7zrCU;;EAEE,2BAAA;AhK+zrCZ;AgK1zrCM;EACE,yBpFj4Le;A5E6r3CvB;AgKrzrCU;EACE,+BpFr4LU;A5E4r3CtB;AgKpzrCU;EACE,yBpF74LW;A5Ems3CvB;AgK9yrCQ;EACE,+BpFl5LY;A5Eks3CtB;AgK9yrCQ;EACE,+BpFr5LY;A5Eqs3CtB;AgK7yrCQ;EACE,cpF15Lc;A5Eys3CxB;AgKxyrCY;EACE,yBpFp6LS;A5E8s3CvB;AgKxyrCc;EACE,sBpF58LR;EoF68LQ,WpF58LR;A5Esv3CR;AgK9xrCY;EACE,+BpFl7LQ;A5Ekt3CtB;AgK7xrCY;EACE,yBpF17LS;A5Eyt3CvB;AgKpxrCY;EACE,6CAAA;AhKsxrCd;AgKnxrCY;EACE,sCATqB;AhK8xrCnC;AgK/wrCc;EACE,6CAAA;AhKixrChB;AgK9wrCc;EACE,sCApBmB;AhKoyrCnC;AgKhyrCY;EACE,gCAAA;AhKkyrCd;AgK/xrCY;EACE,yBATqB;AhK0yrCnC;AgK3xrCc;EACE,gCAAA;AhK6xrChB;AgK1xrCc;EACE,yBApBmB;AhKgzrCnC;AgK5yrCY;EACE,gCAAA;AhK8yrCd;AgK3yrCY;EACE,yBATqB;AhKszrCnC;AgKvyrCc;EACE,gCAAA;AhKyyrChB;AgKtyrCc;EACE,yBApBmB;AhK4zrCnC;AgKxzrCY;EACE,gCAAA;AhK0zrCd;AgKvzrCY;EACE,yBATqB;AhKk0rCnC;AgKnzrCc;EACE,gCAAA;AhKqzrChB;AgKlzrCc;EACE,yBApBmB;AhKw0rCnC;AgKp0rCY;EACE,gCAAA;AhKs0rCd;AgKn0rCY;EACE,yBATqB;AhK80rCnC;AgK/zrCc;EACE,gCAAA;AhKi0rChB;AgK9zrCc;EACE,yBApBmB;AhKo1rCnC;AgKh1rCY;EACE,gCAAA;AhKk1rCd;AgK/0rCY;EACE,yBATqB;AhK01rCnC;AgK30rCc;EACE,gCAAA;AhK60rChB;AgK10rCc;EACE,yBApBmB;AhKg2rCnC;AgK51rCY;EACE,gCAAA;AhK81rCd;AgK31rCY;EACE,yBATqB;AhKs2rCnC;AgKv1rCc;EACE,gCAAA;AhKy1rChB;AgKt1rCc;EACE,yBApBmB;AhK42rCnC;AgKx2rCY;EACE,gCAAA;AhK02rCd;AgKv2rCY;EACE,yBATqB;AhKk3rCnC;AgKn2rCc;EACE,gCAAA;AhKq2rChB;AgKl2rCc;EACE,yBApBmB;AhKw3rCnC;AgKz1rCU;EACE,6CAAA;AhK21rCZ;AgK51rCU;EACE,gCAAA;AhK81rCZ;AgK/1rCU;EACE,gCAAA;AhKi2rCZ;AgKl2rCU;EACE,gCAAA;AhKo2rCZ;AgKr2rCU;EACE,gCAAA;AhKu2rCZ;AgKx2rCU;EACE,gCAAA;AhK02rCZ;AgK32rCU;EACE,gCAAA;AhK62rCZ;AgK92rCU;EACE,gCAAA;AhKg3rCZ;AgKv2rCU;EACE,iDAAA;EACA,6CAAA;EACA,sBAAA;AhKy2rCZ;AgKl2rCc;EACE,iDAAA;EACA,6CAAA;EACA,sBAAA;AhKo2rChB;AgKj2rCc;EACE,sBAAA;AhKm2rChB;AgKp3rCU;EACE,oCAAA;EACA,gCAAA;EACA,sBAAA;AhKs3rCZ;AgK/2rCc;EACE,oCAAA;EACA,gCAAA;EACA,sBAAA;AhKi3rChB;AgK92rCc;EACE,sBAAA;AhKg3rChB;AgKj4rCU;EACE,oCAAA;EACA,gCAAA;EACA,sBAAA;AhKm4rCZ;AgK53rCc;EACE,oCAAA;EACA,gCAAA;EACA,sBAAA;AhK83rChB;AgK33rCc;EACE,sBAAA;AhK63rChB;AgK94rCU;EACE,oCAAA;EACA,gCAAA;EACA,sBAAA;AhKg5rCZ;AgKz4rCc;EACE,oCAAA;EACA,gCAAA;EACA,sBAAA;AhK24rChB;AgKx4rCc;EACE,sBAAA;AhK04rChB;AgK35rCU;EACE,oCAAA;EACA,gCAAA;EACA,sBAAA;AhK65rCZ;AgKt5rCc;EACE,oCAAA;EACA,gCAAA;EACA,sBAAA;AhKw5rChB;AgKr5rCc;EACE,sBAAA;AhKu5rChB;AgKx6rCU;EACE,oCAAA;EACA,gCAAA;EACA,sBAAA;AhK06rCZ;AgKn6rCc;EACE,oCAAA;EACA,gCAAA;EACA,sBAAA;AhKq6rChB;AgKl6rCc;EACE,sBAAA;AhKo6rChB;AgKr7rCU;EACE,oCAAA;EACA,gCAAA;EACA,sBAAA;AhKu7rCZ;AgKh7rCc;EACE,oCAAA;EACA,gCAAA;EACA,sBAAA;AhKk7rChB;AgK/6rCc;EACE,sBAAA;AhKi7rChB;AgKl8rCU;EACE,oCAAA;EACA,gCAAA;EACA,sBAAA;AhKo8rCZ;AgK77rCc;EACE,oCAAA;EACA,gCAAA;EACA,sBAAA;AhK+7rChB;AgK57rCc;EACE,sBAAA;AhK87rChB;AgKp7rCQ;EACE,+BpFlgMY;EoFmgMZ,gCAAA;AhKs7rCV;AgK/6rCU;;EACE,yBpF9gMW;A5Eg83CvB;AgK96rCY;;EACE,yBpFnhMS;A5Eo83CvB;AgK36rCY;;;EACE,yBpF1hMS;A5Ey83CvB;AgKx6rCY;EACE,yBpFliMS;A5E483CvB;AgKn6rCI;EACE,+BpFviMgB;A5E483CtB;AgK55rCc;;EACE,cpFljMQ;A5Ei93CxB;AgKx5rCc;;EACE,cpF1jMQ;A5Eq93CxB;AgKn5rCY;EACE,sBAAA;AhKq5rCd;AgK74rCM;;;;EAIE,sBAAA;AhK+4rCR;AgK54rCM;EACE,sBAAA;AhK84rCR;AgKz4rCM;EACE,oCAAA;AhK24rCR;AgKz4rCM;EAEE,uCAAA;AhK04rCR;AgKl4rCY;;EAEE,sBAAA;AhKo4rCd;AgKj4rCY;EACE,sBAAA;AhKm4rCd;AgKj4rCc;EACE,sBAAA;AhKm4rChB;AgKr3rCY;;;;;;EAEE,sBAAA;AhK23rCd;AgKx3rCY;;;EACE,sBAAA;AhK43rCd;AgK13rCc;;;EACE,sBAAA;AhK83rChB;AgKn3rCU;EACE,cpFjpMY;A5Esg4CxB;AgKl3rCU;EACE,yBpFxpMW;A5E4g4CvB;AgK32rCU;EACE,+BpF9pMU;A5E2g4CtB;AgKx2rCM;EACE,cpFrqMgB;A5E+g4CxB;AgKl2rCY;EACE,cpF9qMU;A5Ekh4CxB;AgKh2rCU;;EAEE,cpFprMY;A5Esh4CxB;AgK11rCM;;EACE,cpF7rMgB;A5E0h4CxB;AgKz1rCQ;;EACE,cpFlsMc;A5E8h4CxB;AgKt1rCU;;EACE,uBAAA;AhKy1rCZ;AgKt1rCU;;EACE,yBpFhtMW;A5Eyi4CvB;AgKl1rCM;EACE,yBAAA;AhKo1rCR;AgKl1rCQ;EACE,+BAAA;AhKo1rCV;AgK/0rCQ;EACE,cpF9tMc;A5E+i4CxB;AgK10rCQ;EACE,cpFtuMc;A5Ekj4CxB;AgKr0rCQ;EACE,cpF9uMc;A5Eqj4CxB;AgK/zrCU;EACE,+BpFtvMU;A5Euj4CtB;AgKzzrCI;EACE;IACE,+BAAA;EhK2zrCN;AACF;AgKxzrCI;EAGM;IACE,yBpF3wMW;E5Emk4CrB;AACF;AgKpzrCI;EACE,qBpF1wMa;EoF2wMb,yBpFnxMiB;A5Eyk4CvB;AgKrzrCM;EACE,qBpF7wMW;A5Eok4CnB;AgKrzrCM;;EAEE,WpF5zMA;A5Emn4CR;AgKhzrCM;EACE,4BAAA;AhKkzrCR;AgK5yrCQ;EACE,+BpFpyMY;A5Ekl4CtB;AgKxyrCU;EACE,yBpF9yMW;A5Ewl4CvB;AgKpyrCoB;EACE,+BpFlzMA;A5Ewl4CtB;AgKnyrCoB;EACE,gCpFtzMA;A5E2l4CtB;AgK9xrCoB;EACE,0CAAA;AhKgyrCtB;AgK9xrCsB;EACE,2BAAA;EACA,4BAAA;AhKgyrCxB;AgKvxrC0B;EACE,+BpF50MN;A5Eqm4CtB;AgKlxrC8B;EACE,+BpFp1MV;EoFq1MU,gBAAA;AhKoxrChC;AgK5wrCoB;EACE,0CpF71MC;A5E2m4CvB;AgKxwrCsB;EACE,+BpFr2MF;A5E+m4CtB;AgK5vrCgB;EACE,+BpFp3MI;A5Ekn4CtB;AgK3vrCgB;EACE,2BAAA;AhK6vrClB;AgKtvrCY;EACE,+BpFh4MQ;A5Ewn4CtB;AgKhvrCU;EACE,mBpF54MW;A5E8n4CvB;AgKhvrCY;EACE,yBpF/4MS;A5Eio4CvB;AgK9urCkB;EACE,+BpFj5ME;A5Eio4CtB;AgK7urCkB;EACE,mBpFx5MG;A5Euo4CvB;AgK5urCsB;EACE,+BpFz5MF;A5Euo4CtB;AgK5urCwB;EAEE,2BAAA;AhK6urC1B;AgKzurCsB;EACE,mBpFr6MD;A5Egp4CvB;AgKturCkB;EACE,mBpF36MG;A5Emp4CvB;AgKlurC4B;EACE,+BpF/6MR;A5Emp4CtB;AgKttrCM;;EAEE,yBpFl8Me;EoFm8Mf,+BpFh8Mc;A5Ewp4CtB;AgKjtrCc;EACE,mBpF38MO;A5E8p4CvB;AgK9srCoB;EACE,gCAAA;AhKgtrCtB;AgK5srCsB;EACE,+BpFn9MF;A5Eiq4CtB;AgK3srCsB;EACE,gCpFv9MF;A5Eoq4CtB;AgKzsrCoB;;EAEE,yBpFh+MC;A5E2q4CvB;AgKzsrCwB;;EACE,gCAAA;AhK4srC1B;AgKpsrCsB;EACE,0CAAA;AhKssrCxB;AgKpsrCwB;EACE,2BAAA;AhKssrC1B;AgKnsrCwB;EACE,2BAAA;EACA,4BAAA;AhKqsrC1B;AgK5rrC4B;EACE,+BpF3/MR;A5Eyr4CtB;AgKvrrCgC;EACE,+BpFngNZ;EoFogNY,gBAAA;AhKyrrClC;AgKjrrCsB;EACE,0CpF5gND;A5E+r4CvB;AgK7qrCwB;EACE,+BpFphNJ;A5Ems4CtB;AgKrqrC0B;EACE,+BpF/hNN;A5Ess4CtB;AgKpqrC0B;EACE,2BAAA;AhKsqrC5B;AgK1prCY;EACE,+BpFhjNQ;A5E4s4CtB;AgKpprCE;EACE,aAAA;AhKsprCJ;AgKlprCI;EACE,cAAA;AhKoprCN;AgKjprCI;EACE,aAAA;AhKmprCN;;AgK5orCA;;4BAAA;ACvpNA;;4BAAA;AAGA;EACE,eAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;EACA,6BAAA;EACA,yCAAA;AjKyy4CF;AiKvy4CE;EACE,kBAAA;EACA,aAAA;EACA,sBrFyBI;A5Egx4CR;AiKty4CE;EACE,YAAA;EACA,0BAAA;EACA,yBAAA;AjKwy4CJ;AiKry4CE;EACE,UAAA;EACA,kBAAA;AjKuy4CJ;AiKry4CI;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,0CAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AjKuy4CN;AiKpy4CI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;EACA,2BAAA;EACA,iDAAA;EACA,UAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;AjKsy4CN;AiKly4CM;EACE,2BAAA;AjKoy4CR;AiKjy4CM;EAEE,UAAA;EACA,mBAAA;EACA,yBAAA;AjKky4CR;AiK/x4CM;EACE,UAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;AjKiy4CR;AiK7x4CI;EACE,kBAAA;AjK+x4CN;AiK5x4CI;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,MAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,UAAA;EACA,2BAAA;EACA,gDAAA;EACA,yCAAA;AjK8x4CN;AiK3x4CI;EACE,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;AjK6x4CN;;AiKxx4CA;EACE,cAAA;EACA,eAAA;EACA,aAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,sBrF7EM;EqF8EN,UAAA;EACA,yBAAA;AjK2x4CF;AiKzx4CE;EACE,UAAA;EACA,yBAAA;EACA,iDAAA;AjK2x4CJ;AiKxx4CE;;EAEE,kBAAA;AjK0x4CJ;AiKxx4CI;;EACE,4DAAA;EACA,iCAAA;AjK2x4CN;AiKvx4CE;EACE,yBAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AjKyx4CJ;AiKtx4CE;EACE,kBAAA;EACA,gCAAA;AjKwx4CJ;AiKtx4CI;EACE,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,2BAAA;AjKwx4CN;AiKrx4CI;EACE,yBAAA;AjKux4CN;AiKnx4CE;EACE,kBAAA;EACA,+BAAA;EACA,kBAAA;AjKqx4CJ;AiKnx4CM;EACE,aAAA;AjKqx4CR;AiKlx4CI;EACE,aAAA;EACA,mBAAA;AjKox4CN;AiKlx4CM;EACE,eAAA;EACA,iBAAA;AjKox4CR;AiKjx4CM;EACE,yBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,sBrFnJA;EqFoJA,iBAAA;AjKmx4CR;AiK7w4CQ;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AjK+w4CV;AiKxw4CQ;EACE,cAAA;EACA,aAAA;AjK0w4CV;AiKrw4CI;EACE,eAAA;EACA,YAAA;AjKuw4CN;AiKrw4CM;EACE,UAAA;AjKuw4CR;AiKnw4CI;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,yBAAA;EACA,YAAA;AjKqw4CN;AiKnw4CM;EACE,yBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AjKqw4CR;AiKjw4CQ;EACE,yBAAA;AjKmw4CV;AiK9v4CQ;EACE,yBAAA;AjKgw4CV;AiK3v4CQ;EACE,yBAAA;AjK6v4CV;AiKxv4CQ;EACE,yBAAA;AjK0v4CV;AiKrv4CQ;EACE,yBAAA;AjKuv4CV;AiKjv4CM;EACE,yBAAA;AjKmv4CR;AiK9u4CM;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,qBAAA;AjKgv4CR;AiK9u4CQ;EACE,gBAAA;AjKgv4CV;AiK1u4CU;EACE,WAAA;AjK4u4CZ;AiKpu4CM;;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;AjKuu4CR;AiKru4CQ;;EACE,gBAAA;AjKwu4CV;AiK7t4CgB;EAEE,WAAA;EACA,YAAA;EACA,cAAA;AjK8t4ClB;AiK5t4CgB;EAEE,yBAAA;EACA,WAAA;AjK6t4ClB;AiKpt4CkB;EACE,wBAAA;AjKst4CpB;AiK5s4CI;EACE,oBAAA;AjK8s4CN;AiK5s4CM;EACE,cAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AjK8s4CR;AiK3s4CU;EACE,cAAA;EACA,uBAAA;EACA,kBAAA;AjK6s4CZ;AiKzs4CM;EACE,iBAAA;AjK2s4CR;;AiKps4CE;EACE,YAAA;AjKus4CJ;AiKrs4CI;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;AjKus4CN;AiKrs4CM;EACE,kBAAA;EACA,SAAA;EACA,SAAA;AjKus4CR;AiKrs4CQ;EACE,qBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;EACA,sCAAA;EACA,iBAAA;EACA,UAAA;AjKus4CV;AiKrs4CU;EACE,wCAAA;AjKus4CZ;AiKps4CU;EACE,yBrFpYI;A5E0k5ChB;AiKhs4CI;EACE,yBrFvYQ;EqFwYR,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AjKks4CN;AiKhs4CM;EACE,YAAA;EACA,sBrFxXA;A5E0j5CR;AiKhs4CQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,UAAA;AjKks4CV;AiKhs4CU;EACE,WAAA;AjKks4CZ;AiKhs4CY;EACE,wBAAA;AjKks4Cd;AiK7r4CQ;EACE,wBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AjK+r4CV;AiK7r4CU;EACE,kBAAA;AjK+r4CZ;;AiKvr4CA;;4BAAA;ACrcA;;4BAAA;AAIA,iEAAA;AACA;EAIQ;IACE,gBAAA;IACA,yBAAA;ElK8n5CR;EkKxn5CA;IACE,aAAA;ElK0n5CF;AACF;AkKvn5CA;EAGM;IACE,UAAA;ElKun5CN;EkKln5CE;IACE,sBAAA;ElKon5CJ;EkK7m5CQ;IACE,yBAAA;ElK+m5CV;EkK1m5CM;IACE,ctFzBE;E5Eqo5CV;EkKxm5CM;IACE,WAAA;IACA,cAAA;ElK0m5CR;EkKxm5CM;IAEE,UAAA;IACA,2CAAA;IACA,8BAAA;IACA,WAAA;IACA,aAAA;ElKym5CR;EkKrm5CI;IACE,gBAAA;ElKum5CN;EkKlm5CE;IACE,aAAA;ElKom5CJ;EkK9l5CM;IACE,aAAA;ElKgm5CR;EkK1l5CI;IACE,iBAAA;IACA,cAAA;ElK4l5CN;EkKrl5CM;IACE,iBAAA;IACA,cAAA;ElKul5CR;EkK3l5CE;IAOE,gBAAA;IACA,aAAA;ElKul5CJ;EkKpl5CA;IACE,kBAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;ElKsl5CF;EkKrl5CE;IACE,YAAA;ElKul5CJ;EkK9k5CQ;IACE,aAAA;ElKgl5CV;AACF;AkKzk5CA;EAIQ;IACE,iBAAA;ElKwk5CR;EkKrk5CQ;;IAEE,iBAAA;ElKuk5CV;EkK1j5CU;IACE,kBAAA;ElK4j5CZ;AACF;AkKpj5CA;EAOc;IACE,gBAAA;ElKgj5Cd;EkKli5CY;IACE,gBAAA;ElKoi5Cd;AACF;AkK3h5CA;EACE;IACE,aAAA;ElK6h5CF;EkK3h5CA;IACE,cAAA;IACA,aAAA;ElK6h5CF;EkK3h5CA;IACE,cAAA;IACA,aAAA;ElK6h5CF;EkK3h5CA;IACE,eAAA;IACA,cAAA;ElK6h5CF;EkK3h5CA;IACE,cAAA;IACA,aAAA;ElK6h5CF;EkK3h5CA;IACE,cAAA;IACA,aAAA;ElK6h5CF;EkK3h5CA;IACE,cAAA;IACA,aAAA;ElK6h5CF;EkK3h5CA;IACE,iBAAA;IACA,gBAAA;ElK6h5CF;AACF;AkK1h5CA;EACE;;IAEE,aAAA;ElK4h5CF;EkKxh5CE;IACE,mBAAA;IACA,gBAAA;IACA,WAAA;ElK0h5CJ;EkKvh5CE;IACE,YAAA;ElKyh5CJ;AACF;AkKrh5CA;EACE;;IAEE,cAAA;IACA,eAAA;ElKuh5CF;AACF;AkKph5CA;EACE;IACE,aAAA;ElKsh5CF;EkKnh5CA;IACE,gBAAA;ElKqh5CF;EkKjh5CE;IACE,aAAA;ElKmh5CJ;EkKjh5CI;IACE,mBAAA;ElKmh5CN;EkK9g5CA;IACE,aAAA;ElKgh5CF;EkK3g5CI;IACE,aAAA;ElK6g5CN;EkKxg5CI;IACE,eAAA;ElK0g5CN;EkKvg5CI;IACE,mBAAA;ElKyg5CN;EkKng5CM;IACE,eAAA;ElKqg5CR;EkK//4CA;IACE,aAAA;IACA,gBAAA;ElKig5CF;EkK7/4CM;IACE,aAAA;ElK+/4CR;EkKx/4CA;IACE,aAAA;ElK0/4CF;EkKp/4CM;IACE,eAAA;ElKs/4CR;EkKn/4CI;IACE,eAAA;ElKq/4CN;EkKn/4CI;IACE,gBAAA;ElKq/4CN;EkKn/4CI;IACE,gBAAA;IACA,mBAAA;ElKq/4CN;EkKn/4CQ;IACE,WAAA;IACA,YAAA;IACA,YAAA;ElKq/4CV;EkK/+4CE;IACE,WAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;ElKi/4CJ;EkK9+4CE;IACE,aAAA;ElKg/4CJ;EkK3+4CM;IACE,4BAAA;IACA,yBAAA;IACA,iBAAA;IACA,0BAAA;IACA,cAAA;ElK6+4CR;EkKt+4CM;IACE,iBAAA;IACA,gBAAA;ElKw+4CR;EkKj+4CU;IACE,YAAA;IACA,aAAA;ElKm+4CZ;EkK/94CQ;IACE,WAAA;IACA,YAAA;IACA,eAAA;ElKi+4CV;EkKz94CE;IACE,aAAA;ElK294CJ;EkKz94CI;IACE,iBAAA;IACA,gBAAA;ElK294CN;EkKv94CE;IACE,QAAA;IACA,UAAA;ElKy94CJ;EkKl94CI;IACE,iBAAA;ElKo94CN;EkKh94CM;IACE,iBAAA;ElKk94CR;EkK584CA;IACE,aAAA;ElK884CF;EkK184CE;IACE,aAAA;ElK484CJ;EkKv84CE;IACE,iBAAA;IACA,kBAAA;IACA,mBAAA;ElKy84CJ;EkKv84CE;IACE,YAAA;ElKy84CJ;EkKj84CM;IACE,cAAA;ElKm84CR;EkKj84CQ;IACE,WAAA;IACA,kBAAA;ElKm84CV;EkKl84CU;IACE,yBAAA;ElKo84CZ;EkKh84CQ;IACE,kBAAA;ElKk84CV;EkKv74CY;IACE,WAAA;IACA,YAAA;ElKy74Cd;EkKn74CM;IACE,iBAAA;ElKq74CR;EkKn74CQ;IACE,wBAAA;ElKq74CV;EkKl74CQ;IACE,eAAA;ElKo74CV;EkKh74CM;IACE,iBAAA;IACA,cAAA;ElKk74CR;EkKh74CQ;IACE,cAAA;IACA,kBAAA;ElKk74CV;EkKh74CU;IACE,WAAA;IACA,kBAAA;ElKk74CZ;EkKh74CY;IACE,0BAAA;ElKk74Cd;EkK764CQ;IACE,kBAAA;ElK+64CV;EkK764CU;IACE,eAAA;ElK+64CZ;EkKz64CQ;IACE,iBAAA;IACA,UAAA;ElK264CV;EkKx64CQ;IACE,SAAA;ElK064CV;EkKj64CE;IACE,gBAAA;IACA,uBAAA;IACA,mBAAA;IACA,gBAAA;ElKm64CJ;EkK554CI;IACE,qBAAA;ElK854CN;AACF;AkKz54CA;EAEI;IACE,YAAA;ElK054CJ;EkKn54CM;IACE,aAAA;ElKq54CR;EkK544CM;IACE,UAAA;ElK844CR;EkKt44CE;IACE,UAAA;ElKw44CJ;EkKj44CI;IACE,eAAA;ElKm44CN;EkK134CM;IACE,UAAA;ElK434CR;EkKt34CA;IACE,aAAA;ElKw34CF;EkKp34CA;IACE,aAAA;IACA,cAAA;IACA,gBAAA;ElKs34CF;EkKn34CM;IACE,WAAA;ElKq34CR;EkK724CM;IACE,aAAA;ElK+24CR;EkK924CQ;IACE,iBAAA;ElKg34CV;EkK924CQ;IACE,WAAA;IACA,aAAA;ElKg34CV;EkKz24Cc;IACE,eAAA;ElK224ChB;EkKj24CM;IACE,aAAA;ElKm24CR;EkK514CE;IACE,gBAAA;IACA,aAAA;ElK814CJ;EkK114CA;IACE,aAAA;ElK414CF;EkKx14CE;IACE,sBAAA;ElK014CJ;EkKt14CA;IACE,qBAAA;ElKw14CF;EkKp14CE;IACE,kBAAA;IACA,WAAA;ElKs14CJ;EkKj14CE;IACE,qBAAA;IACA,mBAAA;ElKm14CJ;EkKh14CE;IACE,mBAAA;IACA,iBAAA;IACA,kBAAA;IACA,qBAAA;ElKk14CJ;EkK/04CE;IACE,gBAAA;ElKi14CJ;EkK304CE;IACE,eAAA;IACA,mBAAA;ElK604CJ;EkKz04CE;IACE,eAAA;ElK204CJ;EkKv04CE;IACE,mBAAA;ElKy04CJ;EkKp04CA;IACE,aAAA;ElKs04CF;EkKl04CM;IACE,aAAA;ElKo04CR;EkK7z4CE;IACE,aAAA;ElK+z4CJ;EkK1z4CE;IACE,aAAA;IACA,iBAAA;IACA,oBAAA;ElK4z4CJ;EkKxz4CA;IACE,aAAA;ElK0z4CF;EkKrz4CE;IACE,eAAA;ElKuz4CJ;EkKlz4CE;IACE,eAAA;ElKoz4CJ;EkK/y4CE;IACE,aAAA;ElKiz4CJ;EkK3y4CE;IACE,eAAA;ElK6y4CJ;EkK1y4CM;IACE,eAAA;ElK4y4CR;EkKzy4CM;IACE,kBAAA;ElK2y4CR;EkKxy4CM;IACE,eAAA;ElK0y4CR;EkKny4CE;IACE,eAAA;ElKqy4CJ;EkKly4CE;IACE,gBAAA;ElKoy4CJ;EkKhy4CA;IACE,YAAA;IACA,aAAA;ElKky4CF;EkKjy4CE;IACE,YAAA;IACA,aAAA;IACA,eAAA;ElKmy4CJ;EkK9x4CA;IACE,aAAA;ElKgy4CF;EkK1x4CM;IACE,eAAA;ElK4x4CR;EkKzx4CI;IACE,eAAA;ElK2x4CN;EkKzx4CI;IACE,gBAAA;ElK2x4CN;EkKxx4CI;IACE,gBAAA;IACA,mBAAA;ElK0x4CN;EkKvx4CQ;IACE,WAAA;IACA,YAAA;IACA,YAAA;ElKyx4CV;EkKnx4CE;IACE,WAAA;IACA,YAAA;ElKqx4CJ;EkKlx4CE;IACE,aAAA;ElKox4CJ;EkK/w4CM;IACE,4BAAA;IACA,yBAAA;IACA,iBAAA;IACA,0BAAA;IACA,cAAA;ElKix4CR;EkK1w4CM;IACE,iBAAA;IACA,gBAAA;ElK4w4CR;EkKxw4CI;IACE,aAAA;ElK0w4CN;EkKtw4CU;IACE,YAAA;IACA,aAAA;ElKww4CZ;EkKpw4CQ;IACE,WAAA;IACA,YAAA;IACA,eAAA;ElKsw4CV;EkKjw4CQ;IACE,eAAA;IACA,mBAAA;ElKmw4CV;EkKhw4CQ;IACE,cAAA;ElKkw4CV;EkK/v4CQ;IACE,cAAA;ElKiw4CV;EkK5v4CQ;IACE,eAAA;ElK8v4CV;EkKtv4CE;IACE,aAAA;ElKwv4CJ;EkKtv4CI;IACE,iBAAA;IACA,gBAAA;ElKwv4CN;EkKnv4CA;IACE,QAAA;IACA,UAAA;ElKqv4CF;EkKhv4CE;IACE,WAAA;ElKkv4CJ;EkK5u4CE;IACE,eAAA;ElK8u4CJ;EkKtu4CM;IACE,WAAA;ElKwu4CR;EkKhu4CE;IACE,kBAAA;ElKku4CJ;EkKxt4CU;IACE,sBAAA;ElK0t4CZ;EkK/s4CU;IACE,sBAAA;ElKit4CZ;EkKrs4CM;IACE,iBAAA;ElKus4CR;AACF;AkKjs4CA;EAIQ;IACE,iBAAA;ElKgs4CR;EkK5r4CQ;;IAEE,iBAAA;ElK8r4CV;AACF;AkKxr4CA;EAEI;IACE,cAAA;ElKyr4CJ;EkKvr4CE;IACE,kBAAA;IACA,SAAA;IACA,OAAA;IACA,UAAA;IACA,kBAAA;IACA,UAAA;IACA,YAAA;ElKyr4CJ;EkKxr4CI;IACE,WAAA;IACA,QAAA;ElK0r4CN;EkKxr4CI;IACE,UAAA;IACA,mBAAA;ElK0r4CN;EkKvr4CE;IACE,8BAAA;IACA,aAAA;ElKyr4CJ;EkKxr4CI;IACE,gBAAA;ElK0r4CN;EkKtr4CY;IACE,gBAAA;ElKwr4Cd;EkK7q4CM;IACE,YAAA;IACA,eAAA;ElK+q4CR;EkK9q4CQ;IACE,eAAA;ElKgr4CV;EkK/q4CU;IACE,yBAAA;IACA,mBAAA;ElKir4CZ;EkKvq4CI;IACE,YAAA;ElKyq4CN;EkKtq4CU;IACE,cAAA;ElKwq4CZ;EkKvq4CY;IACE,cAAA;ElKyq4Cd;EkKjq4CA;IACE,mBAAA;ElKmq4CF;EkKlq4CE;IACE,gBAAA;ElKoq4CJ;EkKjq4CA;IACE,MAAA;IACA,aAAA;IACA,YAAA;IACA,eAAA;ElKmq4CF;EkKjq4CA;IACE,uBAAA;ElKmq4CF;EkKhq4CA;IACE,aAAA;ElKkq4CF;EkK/p4CE;IACE,YAAA;IACA,iBAAA;ElKiq4CJ;EkK/p4CI;IACE,SAAA;ElKiq4CN;EkK5p4CE;IACE,yBAAA;ElK8p4CJ;EkKvp4CM;IACE,gBAAA;IACA,6BAAA;ElKyp4CR;EkKpp4CE;IACE,kBAAA;ElKsp4CJ;EkKpp4CI;IACE,gBAAA;IACA,wBAAA;IACA,kBAAA;IACA,WAAA;IACA,eAAA;IACA,6BAAA;ElKsp4CN;EkKlp4CA;IACE,gBAAA;ElKop4CF;EkKhp4CI;IACE,cAAA;IACA,kBAAA;ElKkp4CN;EkKzo4CM;IACE,eAAA;IACA,UAAA;ElK2o4CR;EkKro4CgB;IACE,6BAAA;ElKuo4ClB;EkK7n4CU;IACE,eAAA;ElK+n4CZ;EkKpn4CI;IACE,WAAA;ElKsn4CN;EkKpn4CM;IACE,kBAAA;ElKsn4CR;EkK7m4CM;IACE,kBAAA;IACA,WAAA;IACA,UAAA;ElK+m4CR;EkK5m4CU;IACE,WAAA;IACA,YAAA;ElK8m4CZ;EkK5m4CY;IACE,eAAA;ElK8m4Cd;EkKpn4CQ;IAUE,WAAA;IACA,eAAA;ElK6m4CV;EkKjm4CQ;IACE,YAAA;IACA,aAAA;ElKmm4CV;EkK9l4CQ;IACE,YAAA;IACA,aAAA;ElKgm4CV;EkK3l4CQ;IACE,YAAA;IACA,aAAA;ElK6l4CV;EkKvl4CM;IACE,WAAA;ElKyl4CR;EkKnl4CA;IACE,gBAAA;ElKql4CF;EkKll4CA;IACE,aAAA;ElKol4CF;EkKjl4CA;IACE,gBAAA;ElKml4CF;EkK9k4CM;IACE,UAAA;ElKgl4CR;EkK1k4CA;IACE,QAAA;ElK4k4CF;EkKtk4CM;IACE,gBAAA;ElKwk4CR;EkK9j4CQ;IACE,gBAAA;ElKgk4CV;EkKzj4CA;IACE,aAAA;ElK2j4CF;EkKvj4CE;IACE,mBAAA;ElKyj4CJ;EkKrj4CI;IACE,gBAAA;ElKuj4CN;EkK/i4CM;IACE,ctFhzCI;IsFizCJ,eAAA;ElKij4CR;EkK7i4CQ;IACE,eAAA;IACA,iBAAA;ElK+i4CV;EkK1i4CQ;IACE,gBAAA;IACA,iBAAA;IACA,mBAAA;ElK4i4CV;EkKji4CQ;IACE,cAAA;IACA,WAAA;IACA,gBAAA;IACA,gBAAA;ElKmi4CV;EkK5h4CA;IACE,aAAA;ElK8h4CF;EkKzh4CI;IACE,kBAAA;ElK2h4CN;EkKlh4CQ;IACE,eAAA;ElKoh4CV;EkK7g4CA;IACE,4BAAA;ElK+g4CF;EkK1g4CE;IACE,aAAA;IACA,kBAAA;IACA,WAAA;ElK4g4CJ;EkKzg4CE;IACE,aAAA;ElK2g4CJ;EkKxg4CE;IACE,gBAAA;ElK0g4CJ;EkKrg4CE;IACE,kBAAA;IACA,WAAA;ElKug4CJ;EkK//3CM;IACE,cAAA;ElKig4CR;EkKhg4CQ;IACE,kBAAA;IACA,eAAA;ElKkg4CV;EkKz/3CE;IACE,gBAAA;ElK2/3CJ;EkKz/3CI;IACE,eAAA;IACA,gBAAA;IACA,kBAAA;ElK2/3CN;EkKx/3CI;IACE,iBAAA;ElK0/3CN;EkKn/3CE;IACE,gBAAA;ElKq/3CJ;EkKj/3CA;IACE,YAAA;ElKm/3CF;EkKl/3CE;IACE,YAAA;ElKo/3CJ;EkKh/3CM;IACE,eAAA;ElKk/3CR;EkK9+3CI;IACE,WAAA;IACA,kBAAA;IACA,mBAAA;ElKg/3CN;EkKz+3CE;IACE,aAAA;ElK2+3CJ;EkKr+3CE;IACE,mBAAA;ElKu+3CJ;EkKl+3CA;IACE,cAAA;IACA,WAAA;ElKo+3CF;EkKj+3CA;IACE,QAAA;IACA,6BAAA;IACA,UAAA;IACA,4BAAA;IACA,kBAAA;IACA,SAAA;IACA,6BAAA;IACA,UAAA;IACA,sBtFx8CI;IsFy8CJ,2BAAA;ElKm+3CF;EkKj+3CE;IACE,UAAA;IACA,mBAAA;IACA,0BAAA;IACA,2BAAA;IACA,oBAAA;ElKm+3CJ;EkK593CM;IACE,iBAAA;IACA,gBAAA;ElK893CR;EkK193CE;IACE,eAAA;ElK493CJ;EkKz93CI;IACE,YAAA;ElK293CN;EkKt93CM;IACE,YAAA;ElKw93CR;EkKv93CQ;IACE,QAAA;ElKy93CV;EkKt93Cc;IACE,eAAA;ElKw93ChB;EkKt93Cc;IACE,WAAA;IACA,YAAA;ElKw93ChB;EkKl93CM;IACE,SAAA;ElKo93CR;EkK/83CI;IACE,eAAA;ElKi93CN;EkK983CM;IACE,gBAAA;ElKg93CR;EkK583CE;IACE,WAAA;ElK883CJ;EkK783CI;IACE,iBAAA;ElK+83CN;EkK383CI;IACE,aAAA;ElK683CN;EkKv83CM;IACE,iBAAA;ElKy83CR;EkKp83CE;IACE,qBAAA;IACA,0BAAA;ElKs83CJ;EkKl83CA;IACE,cAAA;IACA,4BAAA;IACA,gBAAA;ElKo83CF;EkKh83CE;IACE,cAAA;IACA,YAAA;ElKk83CJ;EkK173CM;IACE,6BAAA;ElK473CR;EkKz73CI;IACE,sCAAA;IACA,yCAAA;ElK273CN;EkKr73CM;IACE,mBAAA;ElKu73CR;EkKn73CI;IACE,kBAAA;ElKq73CN;EkK963CE;IACE,gBAAA;IACA,uBAAA;IACA,gBAAA;ElKg73CJ;EkK363CA;IACE,mBAAA;ElK663CF;EkKz63CA;IACE,QAAA;ElK263CF;EkKr63CI;IACE,uBAAA;ElKu63CN;EkK553CU;IACE,sBAAA;ElK853CZ;EkKn53CU;IACE,sBAAA;ElKq53CZ;EkK343CE;IACE,kBAAA;ElK643CJ;EkKx43CA;IACE,2BAAA;ElK043CF;EkKx43CE;IACE,cAAA;ElK043CJ;EkKp43CE;IACE,UAAA;ElKs43CJ;EkK/33CI;IACE,eAAA;ElKi43CN;AACF;AkK733CA;EAIQ;IACE,gBAAA;ElK433CR;EkKz33CQ;;IAEE,gBAAA;ElK233CV;AACF;AkKr33CA;EAKU;IACE,gBAAA;ElKm33CV;EkK723CA;IACE,SAAA;ElK+23CF;EkK523CE;IACE,oBAAA;ElK823CJ;EkK323CA;IACE,mBAAA;ElK623CF;EkKz23CI;IACE,SAAA;ElK223CN;EkKv23CI;IACE,SAAA;ElKy23CN;EkKv23CI;IACE,cAAA;IACA,uBAAA;ElKy23CN;EkK/13CoB;IACE,wBAAA;ElKi23CtB;EkKv13CM;IACE,gBAAA;ElKy13CR;EkKj13CU;IACE,SAAA;ElKm13CZ;EkK303CM;IACE,0BAAA;IACA,iBAAA;ElK603CR;EkKp03CQ;IACE,kBAAA;IACA,mBAAA;ElKs03CV;EkK9z3CI;IACE,SAAA;ElKg03CN;EkK7z3CI;IACE,SAAA;ElK+z3CN;EkK1z3CE;IACE,uBAAA;ElK4z3CJ;EkKrz3CQ;IACE,SAAA;ElKuz3CV;EkKlz3CQ;IACE,iBAAA;ElKoz3CV;EkKhz3CU;IACE,SAAA;ElKkz3CZ;EkK/y3CU;IACE,SAAA;ElKiz3CZ;EkKvy3CQ;IACE,aAAA;ElKyy3CV;EkKny3CA;IACE,SAAA;ElKqy3CF;EkKny3CA;IACE,kBAAA;ElKqy3CF;EkKny3CA;IACE,SAAA;IACA,wBAAA;ElKqy3CF;EkKly3CA;IACE,WAAA;IACA,SAAA;ElKoy3CF;EkKjy3CA;IACE,oBAAA;ElKmy3CF;EkK/x3CE;IACE,mBAAA;ElKiy3CJ;EkK3x3CI;IAIE,mBAAA;ElK0x3CN;EkKrx3CA;IACE,+BAAA;ElKux3CF;EkKjx3CI;IAEE,kBAAA;IACA,sBAAA;ElKkx3CN;EkK3w3CE;IACE,eAAA;ElK6w3CJ;EkK1w3CE;IACE,mBAAA;ElK4w3CJ;EkK1w3CI;;;IAGE,aAAA;ElK4w3CN;EkKzw3CQ;;;IACE,2BAAA;ElK6w3CV;EkK1w3CQ;;;IACE,8BAAA;ElK8w3CV;EkKvw3CI;IACE,gBAAA;IACA,mBAAA;IACA,kCAAA;ElKyw3CN;EkKpw3CI;IACE,yBAAA;IACA,kCAAA;ElKsw3CN;EkKnw3CQ;IACE,aAAA;ElKqw3CV;EkKlw3CQ;IACE,aAAA;ElKow3CV;EkKjw3CQ;IACE,eAAA;IACA,kBAAA;IACA,4BAAA;IACA,mBAAA;IACA,cAAA;ElKmw3CV;EkKjw3CU;IACE,aAAA;ElKmw3CZ;EkK/v3CQ;IACE,aAAA;ElKiw3CV;EkK3v3CM;IACE,MAAA;ElK6v3CR;EkK1v3CU;IACE,4BAAA;ElK4v3CZ;EkKxv3CQ;IACE,kBAAA;ElK0v3CV;EkKxv3CU;IACE,qBAAA;IACA,YAAA;IACA,eAAA;ElK0v3CZ;EkKvv3CU;IACE,aAAA;ElKyv3CZ;EkKpv3CU;IACE,0BAAA;ElKsv3CZ;EkKlv3CQ;IACE,4BAAA;ElKov3CV;EkKjv3CY;IACE,aAAA;ElKmv3Cd;EkK7u3CM;IACE,gBAAA;IACA,eAAA;ElK+u3CR;EkKvu3CQ;IACE,aAAA;ElKyu3CV;EkKhu3CQ;IACE,aAAA;IACA,eAAA;ElKku3CV;EkK7t3CM;IACE,oBAAA;ElK+t3CR;EkK9t3CQ;IACE,cAAA;ElKgu3CV;EkKzt3CI;IACE,eAAA;ElK2t3CN;EkKxt3CM;IACE,kBAAA;ElK0t3CR;EkKpt3CI;IACE,SAAA;IACA,kBAAA;ElKst3CN;EkKnt3CQ;IACE,SAAA;ElKqt3CV;EkKjt3CM;IACE,eAAA;IACA,aAAA;IACA,mBAAA;ElKmt3CR;EkKht3CM;IACE,eAAA;ElKkt3CR;EkK5s3CQ;IACE,aAAA;ElK8s3CV;EkKvs3CE;;IAEE,yBAAA;ElKys3CJ;EkKts3CM;;IACE,sBAAA;ElKys3CR;EkKns3CE;IACE,8BAAA;ElKqs3CJ;EkKns3CI;IACE,qBAAA;ElKqs3CN;EkK7r3CQ;IACE,+BAAA;ElK+r3CV;EkKpr3CM;IACE,gBAAA;IACA,iBAAA;ElKsr3CR;EkK9q3CE;IACE,mBAAA;ElKgr3CJ;EkK1q3CE;IACE,kBAAA;ElK4q3CJ;EkKtq3CE;IACE,cAAA;ElKwq3CJ;EkKrq3CE;IACE,gBAAA;ElKuq3CJ;EkKhq3CM;IACE,mBAAA;ElKkq3CR;EkK7p3CE;IACE,mBAAA;ElK+p3CJ;EkK1p3CE;;IAEE,gBAAA;ElK4p3CJ;EkKxp3CA;IACE,gBAAA;ElK0p3CF;EkKxp3CE;IACE,aAAA;ElK0p3CJ;EkKvp3CE;;IAEE,mBAAA;ElKyp3CJ;EkKpp3CE;IACE,mBAAA;ElKsp3CJ;EkKjp3CE;IACE,gBAAA;ElKmp3CJ;EkK7o3CI;IACE,gBAAA;ElK+o3CN;EkK1o3CA;IACE,mBAAA;ElK4o3CF;EkKvo3CE;IACE,mBAAA;ElKyo3CJ;EkKto3CM;IACE,mBAAA;ElKwo3CR;EkKro3CM;IACE,UAAA;ElKuo3CR;EkKno3CI;IACE,WAAA;IACA,YAAA;IACA,UAAA;ElKqo3CN;EkKlo3CQ;IACE,aAAA;IACA,YAAA;ElKoo3CV;EkK/n3CQ;IACE,aAAA;IACA,YAAA;ElKio3CV;EkK5n3CQ;IACE,aAAA;IACA,YAAA;ElK8n3CV;EkK1n3CM;IACE,SAAA;ElK4n3CR;EkKrn3CA;IACE,aAAA;ElKun3CF;EkKnn3CA;;IAEE,aAAA;ElKqn3CF;EkK/m3CM;IACE,aAAA;ElKin3CR;EkK1m3CE;IACE,gBAAA;ElK4m3CJ;EkKxm3CA;IACE,qBAAA;ElK0m3CF;EkKvm3CA;IACE,aAAA;ElKym3CF;EkKnm3CM;IACE,aAAA;ElKqm3CR;EkK5l3CM;IACE,WAAA;ElK8l3CR;EkKxl3CA;IACE,kBAAA;ElK0l3CF;EkKtl3CE;IACE,SAAA;IACA,QAAA;ElKwl3CJ;EkKrl3CM;IACE,UAAA;ElKul3CR;EkKpl3CU;IACE,kBAAA;ElKsl3CZ;EkK7k3CE;IACE,kBAAA;ElK+k3CJ;EkK5k3CE;IACE,2BAAA;ElK8k3CJ;EkKxk3CI;IACE,SAAA;IACA,WAAA;ElK0k3CN;EkKtk3CA;IACE,iBAAA;ElKwk3CF;EkKtk3CE;IACE,oCAAA;ElKwk3CJ;EkKrk3CE;IACE,YAAA;ElKuk3CJ;EkKpk3CE;IACE,UAAA;ElKsk3CJ;EkKlk3CI;IACE,aAAA;ElKok3CN;EkKhk3CA;IACE,eAAA;ElKkk3CF;EkK/j3CA;IACE,iBAAA;ElKik3CF;EkK9j3CA;IACE,iBAAA;ElKgk3CF;EkK7j3CA;IACE,iBAAA;ElK+j3CF;EkK3j3CE;IACE,eAAA;ElK6j3CJ;EkK1j3CE;IACE,eAAA;ElK4j3CJ;EkKzj3CE;IACE,eAAA;ElK2j3CJ;EkKxj3CE;IACE,eAAA;ElK0j3CJ;EkKvj3CE;IACE,eAAA;ElKyj3CJ;EkKtj3CE;IACE,eAAA;ElKwj3CJ;EkKpj3CA;IACE,eAAA;ElKsj3CF;EkKnj3CA;IACE,eAAA;ElKqj3CF;EkKlj3CA;IACE,eAAA;ElKoj3CF;EkKjj3CA;IACE,eAAA;ElKmj3CF;EkKhj3CA;IACE,eAAA;ElKkj3CF;EkK/i3CA;IACE,eAAA;ElKij3CF;EkK7i3CE;IACE,6BAAA;ElK+i3CJ;EkKxi3CM;IACE,WAAA;IACA,YAAA;IACA,eAAA;ElK0i3CR;EkKhi3CQ;IACE,gBAAA;ElKki3CV;EkKxh3CM;IACE,oBAAA;IACA,gBAAA;ElK0h3CR;EkKlh3CI;IACE,eAAA;ElKoh3CN;EkKjh3CI;IACE,SAAA;IACA,WAAA;ElKmh3CN;EkK7g3CE;IACE,WAAA;ElK+g3CJ;EkKvg3CM;IACE,mBAAA;ElKyg3CR;EkKlg3CA;IACE,uBAAA;ElKog3CF;EkK7/2CM;IACE,kBAAA;ElK+/2CR;EkKx/2CA;IACE,eAAA;ElK0/2CF;EkKx/2CE;IACE,eAAA;IACA,iBAAA;IACA,eAAA;ElK0/2CJ;EkKv/2CE;IACE,gBAAA;ElKy/2CJ;EkKv/2CI;IACE,gBAAA;IACA,aAAA;ElKy/2CN;EkKr/2CE;IACE,gBAAA;ElKu/2CJ;EkKj/2CE;IACE,iBAAA;IACA,aAAA;ElKm/2CJ;EkK7+2CE;IACE,eAAA;ElK++2CJ;EkK5+2CI;IACE,+BAAA;ElK8+2CN;EkKx+2CA;IACE,cAAA;ElK0+2CF;EkKt+2CA;IACE,WAAA;ElKw+2CF;EkKr+2CA;IACE,WAAA;IACA,YAAA;ElKu+2CF;EkKp+2CA,wBAAA;EAEE;IACE,mBAAA;ElKq+2CJ;EkKj+2CA,uBAAA;EAEA,wBAAA;EACA;IACE,mBAAA;ElKk+2CF;EkK/92CA,uBAAA;EAEA,0BAAA;EAEE;IACE,gBAAA;IACA,mBAAA;ElK+92CJ;EkK392CA,yBAAA;EAEA,yBAAA;EAEE;IACE,mBAAA;IACA,UAAA;ElK292CJ;EkKt92CY;IACE,SAAA;ElKw92Cd;EkKn92CM;IACE,kBAAA;IACA,WAAA;ElKq92CR;EkKl92CQ;IACE,kBAAA;ElKo92CV;EkKn92CU;IACE,mBAAA;ElKq92CZ;EkK/82CE;IACE,UAAA;ElKi92CJ;EkK/82CM;IACE,YAAA;ElKi92CR;EkK382CI;IACE,YAAA;ElK682CN;EkKz82CE;IACE,oBAAA;ElK282CJ;EkKv82CA,wBAAA;EAEA;IACE,mBAAA;ElKw82CF;EkKn82CI;IACE,gBAAA;ElKq82CN;EkK972CE;IACE,mBAAA;ElKg82CJ;EkK772CE;IACE,8BAAA;ElK+72CJ;EkKx72CI;IACE,iBAAA;IACA,gBAAA;ElK072CN;EkKr72CI;IACE,gBAAA;ElKu72CN;EkKl72CA;IACE,gBAAA;ElKo72CF;EkKj72CA;IACE,oBAAA;ElKm72CF;EkKh72CI;IACE,mBAAA;ElKk72CN;EkK362CE;IACE,kBAAA;ElK662CJ;EkKx62CA;IACE,8BAAA;ElK062CF;EkKj62CU;IACE,cAAA;ElKm62CZ;EkK152CA;IACE,gBAAA;ElK452CF;EkKz52CA;IACE,aAAA;ElK252CF;EkKz52CE;IACE,iBAAA;ElK252CJ;EkKx52CE;IACE,cAAA;ElK052CJ;EkKt52CA;IACE,aAAA;ElKw52CF;EkKp52CE;IACE,gBAAA;ElKs52CJ;EkKn52CE;IACE,SAAA;ElKq52CJ;EkK/42CE;IACE,WAAA;IACA,cAAA;ElKi52CJ;EkK942CE;IACE,0BAAA;ElKg52CJ;EkK342CA;IACE,gBAAA;ElK642CF;EkKv42CI;IACE,2BAAA;ElKy42CN;EkKl42CE;IACE,mBAAA;ElKo42CJ;EkK732CI;IACE,mBAAA;ElK+32CN;EkKv32CI;IACE,aAAA;ElKy32CN;EkKl32CU;IACE,iBAAA;ElKo32CZ;EkK122CM;IACE,aAAA;ElK422CR;EkK122CQ;IACE,8BAAA;ElK422CV;EkKr22CE;IACE,SAAA;IACA,SAAA;IACA,aAAA;IACA,WAAA;ElKu22CJ;EkKn22CE;IACE,aAAA;ElKq22CJ;AACF;AkKl22CA;EAIQ;IACE,aAAA;ElKi22CR;EkK912CM;IACE,mCAAA;IACA,8BAAA;ElKg22CR;EkK712CM;IACE,cAAA;ElK+12CR;EkK712CQ;IACE,OAAA;ElK+12CV;EkK512CQ;IACE,aAAA;ElK812CV;AACF;AkKx12CA;EAQgB;IACE,aAAA;ElKm12ChB;AACF;AkKz02CA;EAEI;IACE,WAAA;IACA,YAAA;IACA,aAAA;ElK002CJ;EkKx02CE;IACE,WAAA;ElK002CJ;EkKt02CA;IACE,6BAAA;ElKw02CF;EkKt02CA;IACE,yBAAA;ElKw02CF;EkKv02CE;IACE,WAAA;ElKy02CJ;EkKv02CE;IACE,WAAA;ElKy02CJ;EkKp02CI;IACE,aAAA;ElKs02CN;EkKp02CI;IACE,aAAA;IACA,gBAAA;ElKs02CN;EkKn02CM;IACE,wBAAA;ElKq02CR;EkK3z2CY;IACE,kBAAA;ElK6z2Cd;EkK1z2CU;IACE,mBAAA;ElK4z2CZ;EkKjz2CQ;IACE,WAAA;ElKmz2CV;EkK5y2CE;IACE,aAAA;ElK8y2CJ;EkK1y2CE;IACE,WAAA;ElK4y2CJ;EkK1y2CI;IACE,gBAAA;ElK4y2CN;EkKzy2CI;IACE,WAAA;ElK2y2CN;EkKry2CI;IACE,mBAAA;ElKuy2CN;EkKly2CE;IACE,mBAAA;ElKoy2CJ;EkK9x2CM;IACE,eAAA;ElKgy2CR;EkKxx2CQ;IACE,mBAAA;ElK0x2CV;EkKvx2CQ;IACE,kBAAA;ElKyx2CV;EkKlx2CE;IACE,kBAAA;ElKox2CJ;EkKlx2CI;IACE,WAAA;IACA,eAAA;ElKox2CN;EkK9w2CA;IACE,kBAAA;ElKgx2CF;EkKzw2CM;IACE,WAAA;IACA,UAAA;ElK2w2CR;EkKxw2CU;IACE,WAAA;IACA,YAAA;ElK0w2CZ;EkKjw2CI;IACE,aAAA;ElKmw2CN;EkK1v2CM;IACE,WAAA;ElK4v2CR;EkKnv2CI;IAEE,mBAAA;ElKov2CN;EkK7u2CE;IACE,WAAA;IACA,eAAA;ElK+u2CJ;EkKru2CU;IACE,YAAA;ElKuu2CZ;EkKtu2CY;IACE,kBAAA;IACA,gBAAA;IACA,oBtF1hGD;IsF2hGC,eAAA;IACA,SAAA;IACA,UAAA;ElKwu2Cd;EkKhu2CI;IACE,aAAA;ElKku2CN;EkK5t2CQ;IACE,YAAA;ElK8t2CV;EkKvt2CM;IACE,iBAAA;IACA,YAAA;ElKyt2CR;EkKtt2CI;IACE,oBAAA;ElKwt2CN;EkKpt2CI;IACE,YAAA;ElKst2CN;EkKlt2CA;IACE,eAAA;IACA,WAAA;IACA,gBAAA;ElKot2CF;EkKlt2CE;IACE,YAAA;ElKot2CJ;EkK/s2CI;IACE,iBAAA;ElKit2CN;EkK7s2CA;IACE,qBAAA;IACA,qBAAA;ElK+s2CF;EkK7s2CE;IACE,aAAA;ElK+s2CJ;EkK3s2CE;IACE,iBAAA;ElK6s2CJ;EkK1s2CA;IACE,eAAA;ElK4s2CF;EkK1s2CE;IACE,WAAA;IACA,gBAAA;ElK4s2CJ;EkK1s2CI;IACE,WAAA;ElK4s2CN;EkKts2CA;IACE,gBAAA;ElKws2CF;EkKps2CI;IACE,aAAA;IACA,gBAAA;ElKss2CN;EkKls2CE;IACE,gBAAA;ElKos2CJ;EkKhs2CI;IACE,gBAAA;ElKks2CN;EkK3r2CE;IACE,aAAA;IACA,OAAA;IACA,SAAA;IACA,aAAA;ElK6r2CJ;EkK1r2CE;IACE,gBAAA;ElK4r2CJ;EkKtr2CM;IACE,qBAAA;ElKwr2CR;EkKtr2CQ;IACE,cAAA;ElKwr2CV;EkKlr2CA;IACE,gBAAA;IACA,uBAAA;ElKor2CF;EkKhr2CI;IACE,gBAAA;ElKkr2CN;EkK5q2CI;IACE,eAAA;ElK8q2CN;EkK1q2CA;IACE,iBAAA;ElK4q2CF;EkKxq2CE;IACE,UAAA;ElK0q2CJ;EkKrq2CE;IACE,yBAAA;IACA,WAAA;ElKuq2CJ;EkKrq2CI;IACE,mBAAA;ElKuq2CN;EkKlq2CA;IACE,YAAA;IACA,cAAA;ElKoq2CF;EkKlq2CE;IACE,aAAA;ElKoq2CJ;EkK9p2CI;IACE,aAAA;IACA,SAAA;ElKgq2CN;EkKxp2CM;IACE,ctFlxGI;IsFmxGJ,eAAA;ElK0p2CR;EkKtp2CQ;IACE,eAAA;IACA,iBAAA;IACA,iBAAA;ElKwp2CV;EkKnp2CQ;IACE,eAAA;IACA,kBAAA;ElKqp2CV;EkK3o2CM;IACE,eAAA;ElK6o2CR;EkKhp2CE;IAOE,iBAAA;IACA,UAAA;ElK4o2CJ;EkKxo2CA;IACE,uBAAA;ElK0o2CF;EkKto2CE;IACE,mBAAA;ElKwo2CJ;EkKro2CE;IACE,cAAA;IACA,aAAA;IACA,mBAAA;ElKuo2CJ;EkKho2CM;IACE,cAAA;ElKko2CR;EkK7n2CQ;IACE,WAAA;ElK+n2CV;EkK3n2CM;IACE,WAAA;IACA,2BAAA;IACA,yBAAA;ElK6n2CR;EkKrn2CI;IACE,yBAAA;ElKun2CN;EkKnn2CE;IACE,eAAA;ElKqn2CJ;EkKjn2CI;;IAEE,iBAAA;ElKmn2CN;EkK9m2CI;IACE,aAAA;ElKgn2CN;EkKxm2CU;IACE,0BAAA;ElK0m2CZ;EkKnm2CU;IACE,0BAAA;ElKqm2CZ;EkK7l2CM;;IACE,2BAAA;ElKgm2CR;EkK1l2CI;IACE,0BAAA;IACA,yBAAA;ElK4l2CN;EkKzl2CI;IACE,mBAAA;ElK2l2CN;EkKvl2CM;IACE,yBAAA;IACA,sBAAA;ElKyl2CR;EkKrl2CQ;IACE,eAAA;ElKul2CV;EkKpl2CQ;IACE,sBAAA;ElKsl2CV;EkK5m2CE;IA2BE,eAAA;ElKol2CJ;EkKhl2CA;IACE,kBAAA;ElKkl2CF;EkKhl2CE;IACE,8BAAA;ElKkl2CJ;EkK9k2CA;IACE,kBAAA;ElKgl2CF;EkK9k2CE;IACE,eAAA;IACA,mBAAA;ElKgl2CJ;EkK3k2CE;IACE,eAAA;IACA,wBAAA;ElK6k2CJ;EkKxk2CE;IACE,aAAA;ElK0k2CJ;EkKpk2CE;IACE,aAAA;ElKsk2CJ;EkKhk2CI;IACE,qBAAA;ElKkk2CN;EkK7j2CI;IACE,eAAA;ElK+j2CN;EkK5j2CI;IACE,eAAA;ElK8j2CN;EkK1j2CE;IACE,wBAAA;ElK4j2CJ;EkKxj2CA,0BAAA;EAGI;IACE,gBAAA;ElKwj2CN;EkKhj2CI;IACE,aAAA;ElKkj2CN;EkK/i2CI;IACE,aAAA;ElKij2CN;EkK/i2CM;IACE,mBAAA;ElKij2CR;EkK9i2CM;IACE,gBAAA;ElKgj2CR;EkKvi2CI;IACE,YAAA;ElKyi2CN;EkKri2CE;IACE,SAAA;IACA,YAAA;IACA,cAAA;ElKui2CJ;EkKni2CI;IACE,eAAA;IACA,iBAAA;IACA,iBAAA;ElKqi2CN;EkKhi2CI;IACE,eAAA;ElKki2CN;EkKzh2CM;IACE,mBAAA;ElK2h2CR;EkKxh2CM;IACE,kBAAA;ElK0h2CR;EkKth2CI;IACE,kBAAA;ElKwh2CN;EkKth2CM;IACE,eAAA;IACA,mBAAA;ElKwh2CR;EkK/g2CI;IACE,mBAAA;ElKih2CN;EkK/g2CM;IACE,UAAA;ElKih2CR;EkK9g2CU;IACE,sBAAA;ElKgh2CZ;EkKzh2CE;IAeE,qBAAA;IACA,kBAAA;IACA,WAAA;IACA,OAAA;ElK6g2CJ;EkKrg2CM;IACE,wBAAA;ElKug2CR;EkK//1CE;IACE,WAAA;ElKig2CJ;EkK9/1CE;IACE,gBAAA;ElKgg2CJ;EkK1/1CE;IACE,aAAA;ElK4/1CJ;EkKx/1CA;IACE,aAAA;ElK0/1CF;EkKp/1CI;IACE,QAAA;ElKs/1CN;EkKj/1CA;IACE,aAAA;ElKm/1CF;EkKh/1CA;IACE,aAAA;ElKk/1CF;EkKh/1CE;IACE,eAAA;ElKk/1CJ;EkK3+1CI;IACE,SAAA;ElK6+1CN;EkKt+1CE;IACE,cAAA;ElKw+1CJ;EkKt+1CI;IACE,cAAA;IACA,gBAAA;ElKw+1CN;EkKt+1CQ;IACE,aAAA;ElKw+1CV;EkKl+1CM;IACE,WAAA;IACA,YAAA;ElKo+1CR;EkK991CI;IACE,cAAA;IACA,sBAAA;ElKg+1CN;EkK191CA;IACE,kBAAA;ElK491CF;EkKz91CA;IACE,6BAAA;ElK291CF;EkKx91CA;IACE,aAAA;ElK091CF;EkKv91CA;IACE,2BAAA;ElKy91CF;EkKx91CE;IACE,4BAAA;ElK091CJ;EkKj91CQ;IACE,iBAAA;ElKm91CV;EkKh91CQ;IACE,sBAAA;ElKk91CV;EkK781CQ;IACE,kBAAA;ElK+81CV;EkK381Cc;IACE,gBAAA;ElK681ChB;EkK181Cc;IACE,YAAA;IACA,aAAA;ElK481ChB;EkKh81CE;IACE,gBAAA;IACA,uBAAA;IACA,mBAAA;IACA,gBAAA;ElKk81CJ;EkK771CA;IACE,kBAAA;ElK+71CF;EkKr71CY;IACE,gBAAA;IACA,uBAAA;IACA,mBAAA;IACA,gBAAA;ElKu71Cd;EkK561CY;IACE,uBAAA;IACA,mBAAA;IACA,eAAA;ElK861Cd;EkKn61CU;;IACE,2BAAA;ElKs61CZ;EkKx51CU;IACE,uBAAA;ElK051CZ;EkK/41CU;IACE,uBAAA;ElKi51CZ;EkKz41CE;IACE,kBAAA;ElK241CJ;EkKn41CM;IACE,YAAA;ElKq41CR;EkK931CM;IACE,aAAA;ElKg41CR;EkK331CM;IACE,iBAAA;IACA,mBAAA;ElK631CR;EkKz31CI;;IAEE,mBAAA;ElK231CN;EkKl31CM;IACE,kBAAA;ElKo31CR;EkK921CE;IACE,mBAAA;ElKg31CJ;EkKx21CM;IACE,2BAAA;ElK021CR;EkKl21CE;;IAEE,QAAA;ElKo21CJ;EkK911CE;IACE,iBAAA;IACA,sBtFn3HE;IsFo3HF,iBAAA;IACA,kBAAA;ElKg21CJ;EkK711CE;IACE,WAAA;IACA,kBAAA;IACA,eAAA;ElK+11CJ;EkK911CI;IACE,YAAA;IACA,mBAAA;IACA,iBAAA;ElKg21CN;EkK311CI;IACE,iBAAA;IACA,qBAAA;ElK611CN;EkKz11CE;IACE,2BAAA;ElK211CJ;EkKx11CA;IACE,cAAA;IACA,kBAAA;ElK011CF;EkKt11CI;IACE,aAAA;ElKw11CN;EkKp11CA;IACE,uCAAA;IACA,UAAA;IACA,kBAAA;IACA,gBAAA;IACA,SAAA;IACA,kBAAA;IACA,UAAA;IACA,YAAA;ElKs11CF;EkKp11CE;IACE,oCAAA;IACA,mDAAA;IACA,mBAAA;IACA,UAAA;IACA,YAAA;IACA,UAAA;ElKs11CJ;EkKp11CI;IAEE,WAAA;IACA,kBAAA;IACA,QAAA;IACA,SAAA;IACA,kCAAA;IACA,mCAAA;IACA,6BAAA;IACA,YAAA;IACA,SAAA;ElKq11CN;EkKh11CI;IACE,aAAA;ElKk11CN;EkK301CM;IACE,cAAA;ElK601CR;EkKt01CU;IACE,UAAA;IACA,gBAAA;ElKw01CZ;EkK9z1CM;IACE,UAAA;ElKg01CR;EkK1z1CE;IACE,iBAAA;ElK4z1CJ;EkK1z1CI;IACE,YAAA;ElK4z1CN;EkKzz1CI;IACE,qBAAA;ElK2z1CN;AACF;AkKvz1CA;EAIQ;IACE,aAAA;ElKsz1CR;EkKhz1CE;IACE,cAAA;ElKkz1CJ;EkK3y1CQ;IACE,kBAAA;IACA,iBAAA;ElK6y1CV;EkK1y1CU;IACE,SAAA;IACA,UAAA;ElK4y1CZ;EkK1y1CU;IACE,SAAA;IACA,QAAA;IACA,WAAA;IACA,YAAA;ElK4y1CZ;EkKly1CM;IACE,WAAA;ElKoy1CR;EkK3x1CQ;IACE,aAAA;ElK6x1CV;EkKtx1CE;IACE,cAAA;ElKwx1CJ;EkKhx1CU;IACE,gBAAA;ElKkx1CZ;EkK3w1CA;IACE,iBAAA;ElK6w1CF;EkK3w1CA;IACE,gBAAA;ElK6w1CF;EkK3w1CA;IACE,aAAA;ElK6w1CF;EkKvw1CQ;IACE,UAAA;ElKyw1CV;EkKnw1CA;IACE,wBAAA;IACA,UAAA;IACA,yBAAA;IACA,0CAAA;ElKqw1CF;EkKnw1CE;IACE,UAAA;IACA,iBAAA;ElKqw1CJ;EkKnw1CI;IACE,SAAA;ElKqw1CN;EkKjw1CE;IACE,WAAA;IACA,kBAAA;IACA,aAAA;IACA,kBAAA;ElKmw1CJ;EkKjw1CI;IACE,eAAA;IACA,gBAAA;ElKmw1CN;EkKhw1CI;IACE,gBAAA;ElKkw1CN;EkK3v1CE;IACE,gBAAA;ElK6v1CJ;EkK3v1CE;IACE,iBAAA;ElK6v1CJ;EkK3v1CE;IACE,kBAAA;ElK6v1CJ;EkKxv1CA;IACE,iBAAA;IACA,oBAAA;ElK0v1CF;EkKzv1CE;IACE,mBAAA;ElK2v1CJ;EkKzv1CE;IACE,WAAA;IACA,aAAA;ElK2v1CJ;EkKzv1CM;IACE,kBAAA;ElK2v1CR;EkKzv1CM;IACE,kBAAA;ElK2v1CR;EkKrv1CI;IACE,WAAA;ElKuv1CN;EkKrv1CM;IACE,cAAA;IACA,eAAA;ElKuv1CR;EkK9u1CQ;IACE,YAAA;IACA,WAAA;ElKgv1CV;EkK5u1CM;IACE,gBAAA;ElK8u1CR;EkKzu1CA;IACE,gBAAA;ElK2u1CF;EkKpu1CQ;;IACE,eAAA;ElKuu1CV;EkK7t1CQ;IACE,cAAA;ElK+t1CV;EkK7t1CU;IACE,gBAAA;ElK+t1CZ;EkKrt1CQ;IACE,0BAAA;ElKut1CV;EkKpt1CQ;IACE,WAAA;ElKst1CV;EkK9s1CM;IACE,aAAA;ElKgt1CR;EkKvs1CQ;IACE,aAAA;ElKys1CV;EkKts1CQ;IACE,cAAA;IACA,eAAA;IACA,iBAAA;IACA,4BAAA;IACA,kBAAA;IACA,iBAAA;ElKws1CV;EkKts1CU;IACE,WAAA;ElKws1CZ;EkKhs1CM;IACE,aAAA;ElKks1CR;EkK9r1CU;IACE,eAAA;ElKgs1CZ;EkKxr1CI;IACE,6BAAA;ElK0r1CN;EkKvr1CQ;IACE,SAAA;ElKyr1CV;EkKtr1CY;IACE,aAAA;ElKwr1Cd;EkKhr1Cc;IACE,uBAAA;ElKkr1ChB;EkK1q1CY;IACE,0BAAA;ElK4q1Cd;EkKxq1Cc;IACE,WAAA;ElK0q1ChB;EkKlq1CY;IAEE,qBAAA;IACA,uBAAA;ElKmq1Cd;EkKxp1CQ;IACE,iBAAA;ElK0p1CV;EkKlp1CM;IACE,gBAAA;ElKop1CR;EkK/o1CU;IACE,0BAAA;ElKip1CZ;EkK1o1CA;IACE,mBAAA;ElK4o1CF;EkK3o1CE;IACE,gBAAA;ElK6o1CJ;EkK1o1CA;IACE,aAAA;ElK4o1CF;EkK1o1CA;IACE,kBAAA;ElK4o1CF;EkKvo1CE;IACE,2BAAA;ElKyo1CJ;EkKjo1CM;IACE,kBAAA;ElKmo1CR;EkK9n1CE;IACE,mBAAA;ElKgo1CJ;EkK1n1CE;IACE,oBAAA;ElK4n1CJ;EkKzn1CI;IACE,YAAA;ElK2n1CN;EkKtn1CM;IACE,YAAA;ElKwn1CR;EkKpn1CE;IACE,WAAA;ElKsn1CJ;EkKrn1CI;IACE,UAAA;ElKun1CN;EkKhn1CE;IACE,kBAAA;ElKkn1CJ;EkK9m1CA;IACE,SAAA;ElKgn1CF;EkK3m1CE;IACE,6BAAA;ElK6m1CJ;EkK1m1CE;IACE,mBAAA;ElK4m1CJ;EkKtm1CI;IACE,YAAA;ElKwm1CN;EkKnm1CA;IACE,qBAAA;IACA,qBAAA;ElKqm1CF;EkKlm1CA;IACE,oBAAA;ElKom1CF;EkKhm1CE;IACE,mBAAA;ElKkm1CJ;EkKhm1CI;IAEE,mBAAA;ElKim1CN;EkK3l1CM;IACE,mBAAA;ElK6l1CR;EkKrl1CI;IAIE,mBAAA;ElKol1CN;EkK/k1CA;IACE,+BAAA;ElKil1CF;EkK5k1CE;IACE,kBAAA;ElK8k1CJ;EkK3k1CM;IACE,kBAAA;ElK6k1CR;EkKpk1CM;IACE,iBAAA;ElKsk1CR;EkKpk1CQ;IACE,YAAA;IACA,aAAA;ElKsk1CV;EkKlk1CM;IACE,SAAA;IACA,SAAA;IACA,YAAA;IACA,WAAA;IACA,eAAA;ElKok1CR;EkKlk1CQ;IACE,eAAA;ElKok1CV;EkKhk1CM;IACE,WAAA;ElKkk1CR;EkKhk1CQ;IACE,iBAAA;ElKkk1CV;EkK3j1CQ;IACE,gBAAA;IACA,mBAAA;IACA,gBAAA;IACA,gBAAA;ElK6j1CV;EkKvj1CE;IACE,2BAAA;ElKyj1CJ;EkKpj1CE;IACE,cAAA;ElKsj1CJ;EkKnj1CE;IACE,gBAAA;ElKqj1CJ;EkK9i1CM;IACE,mBAAA;ElKgj1CR;EkK3i1CE;IACE,mBAAA;ElK6i1CJ;EkKzi1CA;IACE,mBAAA;ElK2i1CF;EkKxi1CA;IACE,kBAAA;IACA,iBAAA;ElK0i1CF;EkKvi1CI;IACE,kBAAA;IACA,SAAA;IACA,OAAA;IACA,QAAA;IACA,cAAA;ElKyi1CN;EkKli1CQ;IACE,aAAA;IACA,YAAA;ElKoi1CV;EkK5h1CE;;IAEE,gBAAA;ElK8h1CJ;EkKzh1CM;IACE,kBAAA;ElK2h1CR;EkKrh1CY;IACE,YAAA;ElKuh1Cd;EkK9g1CI;IACE,kBAAA;ElKgh1CN;EkK3g1CA;IACE,eAAA;ElK6g1CF;EkK1g1CA;IACE,gBAAA;ElK4g1CF;EkK1g1CE;IACE,aAAA;ElK4g1CJ;EkKzg1CE;;IAEE,mBAAA;ElK2g1CJ;EkKtg1CE;IACE,mBAAA;ElKwg1CJ;EkKng1CE;IACE,mBAAA;ElKqg1CJ;EkKjg1CA;IACE,gBAAA;ElKmg1CF;EkKhg1CA;IACE,gBAAA;ElKkg1CF;EkK7/0CI;IACE,uBAAA;IACA,wBAAA;ElK+/0CN;EkK7/0CM;IACE,WAAA;IACA,YAAA;ElK+/0CR;EkKv/0CI;IACE,gBAAA;ElKy/0CN;EkKl/0CI;IACE,UAAA;ElKo/0CN;EkKl/0CM;IACE,eAAA;ElKo/0CR;EkK1+0CM;IACE,iBAAA;ElK4+0CR;EkKp+0CE;IACE,mBAAA;ElKs+0CJ;EkKn+0CM;IACE,mBAAA;ElKq+0CR;EkK/90CQ;IACE,aAAA;IACA,YAAA;ElKi+0CV;EkK590CQ;IACE,aAAA;IACA,WAAA;ElK890CV;EkKz90CQ;IACE,aAAA;IACA,YAAA;ElK290CV;EkKn90CA;IACE,aAAA;ElKq90CF;EkK/80CI;IACE,gBAAA;ElKi90CN;EkK780CE;IACE,cAAA;IACA,WAAA;ElK+80CJ;EkK780CI;IACE,WAAA;IACA,eAAA;ElK+80CN;EkK580CI;IACE,WAAA;IACA,gBAAA;ElK880CN;EkKz80CE;IACE,kBAAA;IACA,kBAAA;ElK280CJ;EkKt80CM;IACE,aAAA;ElKw80CR;EkKr80CM;IACE,YAAA;ElKu80CR;EkKp80CI;IACE,yBAAA;ElKs80CN;EkK/70CM;IACE,gBAAA;ElKi80CR;EkKz70CM;IACE,aAAA;IACA,gBAAA;ElK270CR;EkKt70CE;IACE,aAAA;IACA,gBAAA;ElKw70CJ;EkKt70CI;IAGE,aAAA;IACA,gBAAA;ElKs70CN;EkK/60CI;IACE,sBAAA;ElKi70CN;EkK560CI;IACE,gBAAA;ElK860CN;EkKz60CA;IACE,gBAAA;IACA,kBAAA;IACA,mBAAA;ElK260CF;EkKt60CE;IACE,iBAAA;IACA,aAAA;ElKw60CJ;EkKh60CM;IACE,mBAAA;ElKk60CR;EkK150CE;IACE,kBAAA;IACA,iBAAA;ElK450CJ;EkKv50CE;IACE,kBAAA;IACA,kBAAA;ElKy50CJ;EkKr50CA;IACE,mBAAA;ElKu50CF;EkKl50CI;IACE,gBAAA;ElKo50CN;EkK940CA;IACE,kBAAA;ElKg50CF;EkK740CA;IACE,qBAAA;ElK+40CF;EkK340CE;IACE,WAAA;IACA,YAAA;ElK640CJ;EkKx40CI;IACE,WAAA;IACA,YAAA;IACA,eAAA;ElK040CN;EkKx40CI;IACE,gBAAA;ElK040CN;EkKz40CM;IACE,kBAAA;IACA,iBAAA;ElK240CR;EkKt40CA;IACE,aAAA;ElKw40CF;EkKt40CI;IACE,eAAA;ElKw40CN;EkKj40CI;IACE,YAAA;IACA,WAAA;ElKm40CN;EkKj40CM;IACE,eAAA;IACA,oBAAA;ElKm40CR;EkK130CU;IACE,eAAA;ElK430CZ;EkKt30CI;IACE,WAAA;ElKw30CN;EkKl30CE;IACE,2BAAA;ElKo30CJ;EkKh30CA;IACE,kBAAA;ElKk30CF;EkK/20CA;IACE,gBAAA;ElKi30CF;EkK920CA;IACE,YAAA;ElKg30CF;EkK720CA;IACE,kBAAA;ElK+20CF;EkK520CA;IACE,aAAA;ElK820CF;EkK120CE;IACE,2BAAA;ElK420CJ;EkKt20CI;IACE,8BAAA;ElKw20CN;EkKh20CM;IACE,cAAA;ElKk20CR;EkKp10CgB;IACE,0BAAA;ElKs10ClB;EkKn10CgB;IACE,2BAAA;ElKq10ClB;EkKz00CM;IACE,mBAAA;ElK200CR;EkKz00CQ;IACE,gBAAA;ElK200CV;EkKp00CQ;;IAEE,eAAA;ElKs00CV;EkKh00CM;IACE,2BAAA;ElKk00CR;EkKh00CQ;IACE,gBAAA;ElKk00CV;EkKh00CU;IACE,YAAA;IACA,UAAA;ElKk00CZ;EkKh00CY;IACE,uBAAA;ElKk00Cd;EkK/z0CY;IACE,gBAAA;IACA,oBtFvgKD;IsFwgKC,eAAA;IACA,cAAA;ElKi00Cd;EkK7z0CU;IACE,YAAA;IACA,UAAA;ElK+z0CZ;EkK7z0CY;IACE,uBAAA;ElK+z0Cd;EkK5z0CY;IACE,gBAAA;IACA,oBtFvhKD;IsFwhKC,eAAA;IACA,cAAA;ElK8z0Cd;EkKvz0CI;IACE,mBAAA;ElKyz0CN;EkKtz0CQ;IACE,YAAA;ElKwz0CV;EkK9y0CM;IACE,aAAA;ElKgz0CR;EkK9y0CQ;IACE,gBAAA;ElKgz0CV;EkK5y0CM;IACE,cAAA;ElK8y0CR;EkK3y0CM;IACE,gBAAA;ElK6y0CR;EkKvy0CA;IACE,aAAA;ElKyy0CF;EkKry0CE;IACE,SAAA;ElKuy0CJ;EkKly0CM;IACE,6BAAA;ElKoy0CR;EkKjy0CM;IACE,gBAAA;ElKmy0CR;EkK5x0CE;IACE,yBAAA;IACA,gBAAA;ElK8x0CJ;EkK7x0CI;IACE,sBAAA;ElK+x0CN;EkK5x0CI;IACE,gBAAA;ElK8x0CN;EkK1x0CE;IACE,aAAA;ElK4x0CJ;EkKxx0CI;IACE,YAAA;IACA,WAAA;ElK0x0CN;EkKnx0CI;IACE,2DAAA;ElKqx0CN;EkKhx0CI;;IAEE,gBAAA;ElKkx0CN;EkK/w0CI;IACE,gBAAA;ElKix0CN;EkK9w0CI;IACE,gBAAA;ElKgx0CN;EkK7w0CQ;IACE,kBAAA;ElK+w0CV;EkK7w0CU;IACE,aAAA;ElK+w0CZ;EkK3w0CQ;IACE,kBAAA;IACA,mBAAA;ElK6w0CV;EkKtw0CA;IACE,iBAAA;IACA,oBAAA;ElKww0CF;EkKrw0CI;IACE,iBAAA;ElKuw0CN;EkKlw0CI;IACE,cAAA;ElKow0CN;EkKlw0CM;IACE,YAAA;IACA,WAAA;IACA,YAAA;IACA,mBAAA;ElKow0CR;EkK9v0CA;IACE,aAAA;ElKgw0CF;EkK5v0CE;IACE,mBAAA;IACA,kBAAA;ElK8v0CJ;EkKxv0CI;IACE,eAAA;ElK0v0CN;EkKpv0CE;IACE,mBAAA;ElKsv0CJ;EkK9u0CQ;;;IAGE,wBAAA;ElKgv0CV;EkK3u0CI;IACE,mBAAA;ElK6u0CN;EkKvu0CU;;;IACE,2BAAA;ElK2u0CZ;EkKxu0CU;;;IACE,8BAAA;ElK4u0CZ;EkKtu0CI;IACE,qBAAA;ElKwu0CN;EkKru0CI;IACE,iBAAA;IACA,oBAAA;IACA,+BAAA;ElKuu0CN;EkKpu0CQ;IACE,eAAA;ElKsu0CV;EkK/t0CA,oCAAA;EAOE;IACE,6BAAA;ElK2t0CJ;EkK5t0CE;IACE,6BAAA;ElK8t0CJ;EkK/t0CE;IACE,6BAAA;ElKiu0CJ;EkKlu0CE;IACE,6BAAA;ElKou0CJ;EkKru0CE;IACE,6BAAA;ElKuu0CJ;EkKxu0CE;IACE,6BAAA;ElK0u0CJ;EkK3u0CE;IACE,6BAAA;ElK6u0CJ;EkK9u0CE;IACE,6BAAA;ElKgv0CJ;EkK3u0CE;IACE,YAAA;ElK6u0CJ;EkKvu0CE;IACE,cAAA;ElKyu0CJ;EkKru0CI;IACE,aAAA;ElKuu0CN;EkKpu0CI;IACE,aAAA;ElKsu0CN;EkKpu0CM;IACE,6BAAA;IACA,gCAAA;IACA,mBAAA;IACA,iBAAA;ElKsu0CR;EkKju0CM;IACE,iBAAA;IACA,eAAA;ElKmu0CR;EkK9t0CM;IACE,eAAA;ElKgu0CR;EkKzt0CM;IACE,mBAAA;ElK2t0CR;EkKjt0CM;IACE,eAAA;IACA,gBAAA;ElKmt0CR;EkKht0CM;IACE,eAAA;ElKkt0CR;EkKzs0CI;IACE,gBAAA;ElK2s0CN;EkKvs0CE;IACE,gBAAA;ElKys0CJ;EkKps0CA;IACE,cAAA;ElKss0CF;EkKns0CA;IACE,+BAAA;ElKqs0CF;EkKhs0CE;IACE,aAAA;ElKks0CJ;EkKhs0CI;IACE,gBAAA;ElKks0CN;EkK/r0CI;IACE,mBAAA;ElKis0CN;EkK1r0CI;IACE,cAAA;ElK4r0CN;EkKxr0CE;IACE,aAAA;ElK0r0CJ;EkKtr0CI;IACE,eAAA;ElKwr0CN;EkKjr0CI;IACE,UAAA;ElKmr0CN;EkK7q0CA;IACE,eAAA;ElK+q0CF;EkK7q0CE;IACE,gBAAA;ElK+q0CJ;EkK5q0CE;IACE,sBAAA;ElK8q0CJ;EkK3q0CE;IACE,gBAAA;ElK6q0CJ;EkK3q0CI;IACE,iBAAA;ElK6q0CN;EkK1q0CI;IACE,gBAAA;ElK4q0CN;EkKvq0CI;IACE,aAAA;ElKyq0CN;EkKtq0CI;IACE,eAAA;IACA,gBAAA;IACA,mBAAA;ElKwq0CN;EkKhq0CI;IACE,gBAAA;IACA,cAAA;ElKkq0CN;EkK/p0CI;IACE,mBAAA;IACA,gBAAA;ElKiq0CN;EkK9p0CI;IACE,iBAAA;ElKgq0CN;EkK9p0CM;IACE,aAAA;ElKgq0CR;EkK7p0CM;IACE,eAAA;ElK+p0CR;EkK5p0CM;IACE,WAAA;IACA,YAAA;IACA,iBAAA;IACA,eAAA;IACA,cAAA;ElK8p0CR;EkKtp0CE;IACE,mBAAA;ElKwp0CJ;EkKjp0CA;IACE,mBAAA;ElKmp0CF;EkK5o0CE;IACE,gBAAA;IACA,mBAAA;ElK8o0CJ;EkKto0CE;IACE,WAAA;IACA,oBAAA;ElKwo0CJ;EkKro0CE;IACE,WAAA;ElKuo0CJ;EkKjo0CE;IACE,iBAAA;ElKmo0CJ;EkK9n0CA;IACE,kBAAA;ElKgo0CF;EkK9n0CE;IACE,aAAA;IACA,OAAA;IACA,SAAA;IACA,aAAA;ElKgo0CJ;EkK7n0CE;IACE,gBAAA;ElK+n0CJ;EkK5n0CE;IACE,gBAAA;ElK8n0CJ;EkKzn0CA;IACE,gBAAA;ElK2n0CF;EkKxn0CA;IACE,aAAA;ElK0n0CF;EkKxn0CE;IACE,iBAAA;ElK0n0CJ;EkKvn0CE;IACE,cAAA;ElKyn0CJ;EkKrn0CA;IACE,aAAA;ElKun0CF;EkKnn0CE;IACE,gBAAA;ElKqn0CJ;EkKln0CE;IACE,SAAA;ElKon0CJ;EkKhn0CA;IACE,gBAAA;ElKkn0CF;EkK3m0CM;IACE,mBAAA;ElK6m0CR;EkKrm0CE;IACE,2BAAA;ElKum0CJ;EkKnm0CI;IACE,8BAAA;ElKqm0CN;EkK/l0CA;IACE,gBAAA;ElKim0CF;EkK7l0CA;IACE,eAAA;ElK+l0CF;EkKvl0CI;IACE,UAAA;IACA,cAAA;ElKyl0CN;EkKrl0CE;IACE,8BAAA;ElKul0CJ;EkKll0CA;IACE,gBAAA;ElKol0CF;EkKjl0CA;IACE,mBAAA;ElKml0CF;EkK7k0CI;IACE,qBAAA;ElK+k0CN;EkKpk0CU;IACE,eAAA;ElKsk0CZ;EkK3j0CI;IACE,WAAA;ElK6j0CN;EkK1j0CI;IACE,sBAAA;ElK4j0CN;EkKpj0CI;IACE,mBAAA;ElKsj0CN;EkK/i0CE;IACE,gBAAA;ElKij0CJ;EkKzi0CM;IACE,2BAAA;ElK2i0CR;EkKli0CI;IACE,mBAAA;ElKoi0CN;EkK9h0CA;IACE,mBAAA;ElKgi0CF;EkK5h0CA;IACE,kBAAA;ElK8h0CF;EkK1h0CA;IACE,kBAAA;ElK4h0CF;EkKvh0CI;IAEE,aAAA;ElKwh0CN;EkKrh0CI;IACE,eAAA;IACA,yBAAA;IACA,UAAA;IACA,SAAA;ElKuh0CN;EkKhh0CI;IACE,UAAA;IACA,eAAA;IACA,kBAAA;ElKkh0CN;EkKhh0CM;IACE,UAAA;IACA,0BAAA;IACA,mBAAA;IACA,kBAAA;IACA,gBAAA;ElKkh0CR;EkKzg0CQ;IACE,yBAAA;IACA,eAAA;IACA,SAAA;IACA,WAAA;ElK2g0CV;EkKzg0CQ;IACE,yBAAA;IACA,eAAA;IACA,SAAA;IACA,qBAAA;ElK2g0CV;EkKzg0CQ;IACE,UAAA;ElK2g0CV;EkKxg0CQ;IACE,SAAA;ElK0g0CV;EkKlg0CI;IACE,aAAA;ElKog0CN;EkK9/zCE;IACE,UAAA;IACA,WAAA;ElKgg0CJ;EkK1/zCE;IACE,mBAAA;ElK4/zCJ;AACF;AkKx/zCA;EACE;IACE,YAAA;ElK0/zCF;EkKx/zCA;IACE,aAAA;ElK0/zCF;EkKx/zCA;IACE,UAAA;ElK0/zCF;EkKt/zCI;IACE,cAAA;ElKw/zCN;EkKv/zCM;IACE,WAAA;ElKy/zCR;EkKj/zCM;IACE,uBAAA;ElKm/zCR;EkKh/zCQ;IACE,uBAAA;ElKk/zCV;EkK1+zCE;;IAEE,WAAA;ElK4+zCJ;EkK1+zCE;IACE,8BAAA;ElK4+zCJ;EkK1+zCM;IACE,WAAA;ElK4+zCR;EkKx+zCE;IACE,UAAA;ElK0+zCJ;EkKt+zCE;IACE,UAAA;ElKw+zCJ;EkKt+zCE;IACE,OAAA;ElKw+zCJ;EkKt+zCE;IACE,QAAA;ElKw+zCJ;EkKl+zCI;IACE,WAAA;ElKo+zCN;EkK/9zCE;IACE,eAAA;ElKi+zCJ;EkK99zCA;IACE,eAAA;ElKg+zCF;EkK79zCE;IACE,4BAAA;ElK+9zCJ;EkK39zCE;IACE,YAAA;IACA,WAAA;ElK69zCJ;EkK39zCI;IACE,kBAAA;IACA,UAAA;IACA,SAAA;ElK69zCN;EkK39zCM;IACE,uBAAA;IACA,wBAAA;ElK69zCR;EkKz9zCI;IACE,UAAA;IACA,SAAA;ElK29zCN;EkKx9zCI;IACE,OAAA;IACA,MAAA;IACA,cAAA;ElK09zCN;EkKx9zCM;IACE,uBAAA;IACA,wBAAA;ElK09zCR;EkKp9zCI;IACE,uBAAA;IACA,wBAAA;ElKs9zCN;EkKh9zCI;IACE,WAAA;ElKk9zCN;EkKh9zCM;IACE,gBAAA;ElKk9zCR;EkK18zCI;IACE,YAAA;IACA,YAAA;ElK48zCN;EkK18zCM;IAEE,sBAAA;ElK28zCR;EkKr8zCA;IACE,qBAAA;ElKu8zCF;EkKn8zCE;IACE,uBAAA;ElKq8zCJ;EkKh8zCE;IACE,WAAA;ElKk8zCJ;EkK97zCA;IACE,YAAA;ElKg8zCF;EkK57zCE;IACE,kBAAA;ElK87zCJ;EkK17zCI;IACE,aAAA;ElK47zCN;EkKt7zCE;IACE,aAAA;ElKw7zCJ;EkKp7zCA;IACE,UAAA;ElKs7zCF;EkKl7zCM;IACE,eAAA;ElKo7zCR;EkK96zCI;IACE,cAAA;ElKg7zCN;EkK36zCI;IACE,mBAAA;ElK66zCN;EkK16zCI;IACE,eAAA;ElK46zCN;EkKv6zCI;IACE,YAAA;ElKy6zCN;EkKj6zCM;IACE,aAAA;IACA,eAAA;ElKm6zCR;EkK95zCM;IACE,aAAA;ElKg6zCR;EkKr5zCQ;IACE,aAAA;ElKu5zCV;EkKl5zCQ;IACE,aAAA;ElKo5zCV;EkK54zCA;IACE,kBAAA;ElK84zCF;EkK54zCA;IACE,kBAAA;ElK84zCF;EkKz4zCE;IACE,aAAA;ElK24zCJ;EkKz4zCI;IACE,eAAA;ElK24zCN;EkKp4zCI;IACE,SAAA;ElKs4zCN;EkKl4zCM;IACE,iBAAA;ElKo4zCR;EkKt3zCc;IACE,WAAA;IACA,YAAA;ElKw3zChB;EkK72zCA;IACE,kBAAA;IACA,gBAAA;ElK+2zCF;EkK72zCE;IACE,aAAA;IACA,OAAA;IACA,SAAA;IACA,aAAA;ElK+2zCJ;EkK12zCA;IACE,qBAAA;ElK42zCF;EkKv2zCE;IACE,SAAA;ElKy2zCJ;EkKv2zCI;IACE,eAAA;ElKy2zCN;EkKn2zCA;IACE,UAAA;ElKq2zCF;EkK91zCM;IACE,cAAA;ElKg2zCR;EkK/1zCQ;IACE,gBAAA;IACA,kBAAA;ElKi2zCV;AACF;AkK11zCA;EAEI;IACE,UAAA;ElK21zCJ;EkKx1zCA;IACE,eAAA;IACA,gBAAA;ElK01zCF;EkKx1zCE;IACE,sBAAA;ElK01zCJ;EkKx1zCE;IACE,aAAA;ElK01zCJ;EkKr1zCM;IACE,aAAA;ElKu1zCR;EkKl1zCA;IACE,eAAA;ElKo1zCF;EkK30zCU;IACE,qBAAA;ElK60zCZ;EkKh0zCQ;IACE,YAAA;ElKk0zCV;EkK5zzCc;;IAEE,WAAA;IACA,YAAA;ElK8zzChB;EkKnzzCQ;IACE,WAAA;ElKqzzCV;EkK/yzCc;;IAEE,UAAA;IACA,YAAA;ElKizzChB;EkKnyzCM;IACE,eAAA;ElKqyzCR;AACF;AkK/xzCA;EAQgB;IACE,UAAA;ElK0xzChB;EkKhxzCE;IACE,wBAAA;ElKkxzCJ;EkKhxzCE;IACE,iBAAA;ElKkxzCJ;EkK9wzCM;IACE,iBAAA;ElKgxzCR;EkK9wzCM;IACE,iBAAA;ElKgxzCR;EkK1wzCE;IACE,QAAA;IACA,QAAA;ElK4wzCJ;EkK1wzCE;IACE,gBAAA;ElK4wzCJ;EkKzwzCE;IACE,aAAA;IACA,cAAA;ElK2wzCJ;EkK1wzCI;IACE,gBAAA;ElK4wzCN;EkKxwzCA;IACE,WAAA;IACA,kBAAA;IACA,6BAAA;ElK0wzCF;EkKxwzCE;IACE,4BAAA;ElK0wzCJ;EkKvwzCA;IACE,qBAAA;ElKywzCF;EkKvwzCA;IACE,gBAAA;ElKywzCF;EkKtwzCA;IACE,YAAA;ElKwwzCF;EkKlwzCM;IACE,kBAAA;ElKowzCR;EkKlwzCQ;IACE,gBAAA;ElKowzCV;EkK7vzCA;IACE,aAAA;ElK+vzCF;EkK1vzCI;IACE,YAAA;ElK4vzCN;EkKtvzCE;IACE,WAAA;IACA,YAAA;ElKwvzCJ;EkK/uzCQ;IACE,iBAAA;IACA,eAAA;ElKivzCV;EkKvuzCM;IACE,UAAA;IACA,UAAA;ElKyuzCR;EkKtuzCU;IACE,WAAA;IACA,YAAA;ElKwuzCZ;EkKtuzCY;IACE,eAAA;ElKwuzCd;EkK9tzCE;IACE,iBAAA;ElKguzCJ;EkK1tzCI;IACE,aAAA;ElK4tzCN;EkKltzCQ;IACE,aAAA;IACA,YAAA;ElKotzCV;EkK/szCQ;IACE,aAAA;IACA,YAAA;ElKitzCV;EkK5szCQ;IACE,aAAA;IACA,YAAA;ElK8szCV;EkKxszCM;IACE,oBAAA;IACA,uBAAA;IACA,4BAAA;IACA,gBAAA;IACA,qBAAA;ElK0szCR;EkKpszCE;IACE,cAAA;ElKsszCJ;EkKlszCI;IACE,YAAA;ElKoszCN;EkK9rzCM;IACE,eAAA;ElKgszCR;EkK1rzCA;IACE,aAAA;ElK4rzCF;EkKzrzCA;IACE,aAAA;ElK2rzCF;EkKvrzCE;IACE,eAAA;ElKyrzCJ;EkKprzCM;IACE,wBAAA;ElKsrzCR;EkK9qzCI;IACE,gBAAA;ElKgrzCN;EkK5qzCM;IACE,eAAA;ElK8qzCR;EkKvqzCM;IACE,eAAA;ElKyqzCR;EkKlqzCE;IACE,eAAA;ElKoqzCJ;EkKhqzCA;IACE,eAAA;ElKkqzCF;EkK5pzCI;IACE,eAAA;ElK8pzCN;EkK1pzCM;IACE,eAAA;ElK4pzCR;EkKrpzCI;IACE,eAAA;ElKupzCN;EkK9ozCM;IACE,kBAAA;ElKgpzCR;EkK9ozCM;IACE,gBAAA;ElKgpzCR;EkK5ozCE;IACE,aAAA;ElK8ozCJ;EkKtozCM;IACE,iBAAA;ElKwozCR;EkK/nzCI;IACE,iBAAA;ElKiozCN;EkK7nzCE;IACE,oBAAA;ElK+nzCJ;EkK3nzCA;IACE,eAAA;ElK6nzCF;EkKtnzCM;IACE,iBAAA;ElKwnzCR;EkKhnzCQ;IACE,kBAAA;ElKknzCV;EkKtmzCc;IACE,WAAA;IACA,YAAA;ElKwmzChB;EkK/lzCM;IACE,WAAA;ElKimzCR;EkKtlzCQ;IACE,mBAAA;ElKwlzCV;EkK7kzCM;IACE,eAAA;IACA,SAAA;ElK+kzCR;EkK3kzCI;IACE,cAAA;IACA,WAAA;IACA,kBAAA;ElK6kzCN;EkKrkzCI;IACE,cAAA;ElKukzCN;EkK9jzCM;IACE,cAAA;ElKgkzCR;EkKvjzCI;IACE,qBAAA;ElKyjzCN;EkKnjzCA;IACE,wBAAA;ElKqjzCF;EkK/izCI;IACE,iBAAA;ElKijzCN;EkKxizCM;IACE,qBAAA;ElK0izCR;EkKlizCE;IACE,aAAA;IACA,cAAA;ElKoizCJ;EkKjizCM;IACE,wBAAA;ElKmizCR;EkK1hzCI;IACE,gBAAA;ElK4hzCN;EkKrhzCE;IACE,WAAA;ElKuhzCJ;EkKjhzCE;IACE,iBAAA;ElKmhzCJ;EkK/gzCI;IACE,eAAA;ElKihzCN;EkK3gzCA;IACE,cAAA;IACA,kBAAA;ElK6gzCF;EkK3gzCE;IACE,mBAAA;ElK6gzCJ;EkKtgzCI;IACE,eAAA;ElKwgzCN;EkKvgzCM;IACE,eAAA;ElKygzCR;EkKngzCM;IACE,iBAAA;ElKqgzCR;EkKngzCM;IACE,iBAAA;IACA,eAAA;ElKqgzCR;EkK//yCM;IACE,eAAA;ElKigzCR;EkK1/yCE;IACE,2BAAA;IACA,gBAAA;ElK4/yCJ;AACF;AkKx/yCA;EAGM;IACE,cAAA;IACA,eAAA;ElKw/yCN;EkKl/yCE;IACE,aAAA;ElKo/yCJ;AACF;AkKh/yCA;EAMY;IACE,2BAAA;ElK6+yCZ;AACF;AkKr+yCA;;4BAAA;ACr3NE;;EAEE,iBAAA;EACA,yBAAA;EACA,gBvFiCI;A5E8zgDR;;AmK11gDA;EACE,sBvF2BM;EuF1BN,YAAA;EAEA,6CAAA;AnK61gDF;AmK51gDE;EACE,yBvFwBiB;EuFvBjB,cvFVY;EuFWZ,mBAAA;AnK81gDJ;AmK51gDE;EACE,4BAAA;AnK81gDJ;;AmKt1gDM;EACE,yBvFUa;A5E+0gDrB;AmKn1gDM;EACE,4BvFGa;EuFFb,6BAAA;AnKq1gDR;AmK/0gDM;EACE,0BvFLa;EuFMb,6BAAA;AnKi1gDR;AmK30gDM;EACE,2BvFba;EuFcb,6BAAA;AnK60gDR;AmKz0gDE;EACE,yBvFnBiB;EuFoBjB,cvFrDY;A5Eg4gDhB;AmKx0gDI;EACE,yBvFxBe;A5Ek2gDrB;;AmK/zgDM;EACE,iBAAA;EACA,cvFKe;EuFJf,YAAA;EACA,eAAA;EACA,6BAAA;EACA,gBvF3CA;A5E62gDR;AmKj0gDQ;EACE,sBvF7CF;A5Eg3gDR;AmKh0gDM;EACE,iBAAA;EACA,gBAAA;EACA,cvFpEK;EuFqEL,eAAA;AnKk0gDR;AmK7zgDI;EACE,SAAA;AnK+zgDN;;AmKvzgDI;EACE,UAAA;EACA,YAAA;EACA,gBAAA;EACA,2BAAA;EACA,4BAAA;AnK0zgDN;AmKvzgDQ;EACE,yBvFzFU;A5Ek5gDpB;AmKtzgDM;EACE,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,2BAAA;EACA,iBAAA;AnKwzgDR;AmKvzgDQ;EACE,mBAAA;EACA,gBAAA;AnKyzgDV;AmKtzgDM;EACE,aAAA;AnKwzgDR;AmKtzgDM;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,2BAAA;EACA,4BAAA;AnKwzgDR;AmKvzgDQ;EACE,iBAAA;AnKyzgDV;AmKvzgDQ;EAbF;IAcI,kBAAA;EnK0zgDR;AACF;AmKvzgDI;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,qBvFvIY;EuFwIZ,gBAAA;EACA,8BAAA;EACA,+BAAA;EACA,cvFvIO;A5Eg8gDb;;AmKlzgDA;EACE,4BvFnJgB;A5Ew8gDlB;AmKlzgDM;EACE,qBvFvJU;A5E28gDlB;;AmK5ygDM;EACE,gBAAA;AnK+ygDR;AmK3ygDE;EACE,cvFjKS;A5E88gDb;AmK5ygDI;EACE,gBAAA;AnK8ygDN;AmKxygDQ;EACE,kCAAA;AnK0ygDV;;AmKpygDA;EAEE,4CAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;AnKuygDF;AmKtygDE;EACE,cAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,gBvF3KI;A5Em9gDR;AmKvygDI;EACE,sBvF7KE;A5Es9gDR;AmKtygDE;EACE,SAAA;EACA,6BAAA;AnKwygDJ;;AmK/xgDQ;EACE,gCAAA;AnKkygDV;AmKhygDQ;EACE,gCAAA;AnKkygDV;AmKhygDQ;EACE,gCAAA;AnKkygDV;;AmKzxgDM;EACE,SAAA;AnK4xgDR;;AmKtxgDE;EACE,evFzEe;A5Ek2gDnB;;AmKtxgDA;;EAEE,yBAAA;AnKyxgDF;AmKvxgDI;;EACE,cvF5OO;EuF6OP,gBAAA;AnK0xgDN;AmKzxgDM;;EACE,WvF9NA;A5E0/gDR;AmKxxgDE;;;EACE,gBAAA;EACA,gBAAA;EACA,iBAAA;AnK4xgDJ;;AmKvxgDI;EACE,iBAAA;EACA,0BAAA;AnK0xgDN;;AmKpxgDI;EACE,aAAA;AnKuxgDN;;AmKhxgDM;EACE,evFvMS;A5E09gDjB;AmKjxgDM;EACE,QAAA;AnKmxgDR;;AmK1wgDM;EACE,iBAAA;AnK6wgDR;AmK5wgDQ;EAFF;IAGI,iBAAA;EnK+wgDR;AACF;;AmKvwgDI;EACE,eAAA;AnK0wgDN;AmKxwgDI;EACE,WAAA;EACA,YAAA;AnK0wgDN;;AmKlwgDM;EACE,cAAA;EACA,gBAAA;EACA,SAAA;AnKqwgDR;;AoK39gDE;EAxDA,wBC7Bc;ED8Bd,yBC9Bc;ED+Bd,kBC9Ba;ED+Bb,cC5BoB;ArKmjhDtB;;AoK99gDE;;EArEA,cAAA;EAKA,aAAA;ApKwihDF;;AoKn+gDE;;EAEE,0BAAA;ApKs+gDJ;;AoKn+gDE;EAhGA,qBAiG4B;EA7F5B,2BA6FsC;EA1FpC,gBAAA;EA4FA,kBAAA;ApK6+gDJ;;AoK1+gDE;EAtGA,uBAuG4B;EAnG5B,2BAmGwC;EAhGtC,gBAAA;EAkGA,kBAAA;ApKo/gDJ;;AoKj/gDE;EA5GA,qBA6G4B;EAzG5B,yBAyGsC;EApGpC,iBAAA;EAsGA,gBAAA;ApK2/gDJ;;AoKx/gDE;EAlHA,qBAmH4B;EA/G5B,2BA+GsC;EA5GpC,gBAAA;EA8GA,kBAAA;ApKkghDJ;;AoK//gDE;EAxHA,qBAyH4B;EArH5B,uBAqHsC;EA9GpC,kBAAA;EAgHA,kBAAA;ApKyghDJ;;AoKtghDE;EA9HA,uBA+H4B;EA3H5B,uBA2HwC;EApHtC,kBAAA;EAsHA,kBAAA;ApKghhDJ;;AoK7ghDE;EApIA,qBAqI4B;EAjI5B,2BAiIsC;EA9HpC,gBAAA;EAgIA,kBAAA;ApKuhhDJ;;AoKphhDE;EA1IA,uBA2I4B;EAvI5B,2BAuIwC;EApItC,gBAAA;EAsIA,kBAAA;ApK8hhDJ;;AoK3hhDE;EAhJA,mBAkJ4B;EA9I5B,yBA8IoC;EAzIlC,iBAAA;EA2IA,gBAAA;ApKoihDJ;;AoKjihDE;EAvJA,mBAwJ4B;EApJ5B,2BAoJoC;EAjJlC,gBAAA;EAmJA,gBAAA;ApK2ihDJ;;AoKxihDE;EA5HA,0BC7Bc;ED8Bd,iBC5Bc;ED+BZ,qBChCgB;ArKsshDpB;;AoK1ihDE;EACE,UC3JsB;ArKwshD1B;;AoK1ihDE;EA3HA,kBC9Bc;ED+Bd,qBC7Be;ArKsshDjB;;AoK3ihDE;EA1HA,UAAA;EACA,iBCtCc;ArK+shDhB;;AoK5ihDE;EArHA,YAAA;EACA,iBCzCgB;ArK8shDlB;;AoK7ihDE;EApHA,UAAA;EACA,kBC3Ca;ArKgthDf;;AoK9ihDE;EAnHA,UAAA;EACA,kBC7Ce;ArKkthDjB;;AoKjqhDE;EACE,eAoHY;ApKgjhDhB;AoKjqhDE;EACE,aAgHY;ApKmjhDhB;;AoKxqhDE;EACE,eAoHY;ApKujhDhB;AoKxqhDE;EACE,aAgHY;ApK0jhDhB;;AoK/qhDE;EACE,eAoHY;ApK8jhDhB;AoK/qhDE;EACE,aAgHY;ApKikhDhB;;AoKtrhDE;EACE,eAoHY;ApKqkhDhB;AoKtrhDE;EACE,aAgHY;ApKwkhDhB;;AoK7rhDE;EACE,eAoHY;ApK4khDhB;AoK7rhDE;EACE,aAgHY;ApK+khDhB;;AoKpshDE;EACE,eAoHY;ApKmlhDhB;AoKpshDE;EACE,aAgHY;ApKslhDhB;;AoK3shDE;EACE,eAoHY;ApK0lhDhB;AoK3shDE;EACE,aAgHY;ApK6lhDhB;;AoKlthDE;EACE,eAoHY;ApKimhDhB;AoKlthDE;EACE,aAgHY;ApKomhDhB;;AoKzthDE;EACE,eAoHY;ApKwmhDhB;AoKzthDE;EACE,aAgHY;ApK2mhDhB;;AoKhuhDE;EACE,eAoHY;ApK+mhDhB;AoKhuhDE;EACE,aAgHY;ApKknhDhB;;AoKvuhDE;EACE,eAoHY;ApKsnhDhB;AoKvuhDE;EACE,aAgHY;ApKynhDhB;;AoK9uhDE;EACE,eAoHY;ApK6nhDhB;AoK9uhDE;EACE,aAgHY;ApKgohDhB;;AoKrvhDE;EACE,eAoHY;ApKoohDhB;AoKrvhDE;EACE,aAgHY;ApKuohDhB;;AoK5vhDE;EACE,eAoHY;ApK2ohDhB;AoK5vhDE;EACE,aAgHY;ApK8ohDhB;;AoKnwhDE;EACE,eAoHY;ApKkphDhB;AoKnwhDE;EACE,aAgHY;ApKqphDhB;;AoKxohDM;EAxOJ,cAAA;EACA,kBAAA;EACA,WAHyC;ApKu3hD3C;AoKl3hDE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;ApKo3hDJ;AoKj3hDE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ApKm3hDJ;AoKh3hDE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ApKk3hDJ;;AoKjqhDM;EAxOJ,cAAA;EACA,kBAAA;EACA,WAHyC;ApKg5hD3C;AoK34hDE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;ApK64hDJ;AoK14hDE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ApK44hDJ;AoKz4hDE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ApK24hDJ;;AoK1rhDM;EAxOJ,cAAA;EACA,kBAAA;EACA,WAHyC;ApKy6hD3C;AoKp6hDE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;ApKs6hDJ;AoKn6hDE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ApKq6hDJ;AoKl6hDE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ApKo6hDJ;;AoKnthDM;EAxOJ,cAAA;EACA,kBAAA;EACA,WAHyC;ApKk8hD3C;AoK77hDE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;ApK+7hDJ;AoK57hDE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ApK87hDJ;AoK37hDE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ApK67hDJ;;AoK5uhDM;EAxOJ,cAAA;EACA,kBAAA;EACA,WAHyC;ApK29hD3C;AoKt9hDE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;ApKw9hDJ;AoKr9hDE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ApKu9hDJ;AoKp9hDE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ApKs9hDJ;;AoKrwhDM;EAxOJ,cAAA;EACA,kBAAA;EACA,WAHyC;ApKo/hD3C;AoK/+hDE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;ApKi/hDJ;AoK9+hDE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ApKg/hDJ;AoK7+hDE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ApK++hDJ;;AoK9xhDM;EAxOJ,cAAA;EACA,kBAAA;EACA,WAHyC;ApK6giD3C;AoKxgiDE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;ApK0giDJ;AoKvgiDE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ApKygiDJ;AoKtgiDE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ApKwgiDJ;;AoKvzhDM;EAxOJ,cAAA;EACA,kBAAA;EACA,WAHyC;ApKsiiD3C;AoKjiiDE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,qBAAA;ApKmiiDJ;AoKhiiDE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ApKkiiDJ;AoK/hiDE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ApKiiiDJ;;AoKh1hDM;EAxOJ,cAAA;EACA,kBAAA;EACA,WAHyC;ApK+jiD3C;AoK1jiDE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,6BAAA;ApK4jiDJ;AoKzjiDE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ApK2jiDJ;AoKxjiDE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ApK0jiDJ;;AoKz2hDM;EAxOJ,cAAA;EACA,kBAAA;EACA,WAHyC;ApKwliD3C;AoKnliDE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;ApKqliDJ;AoKlliDE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ApKoliDJ;AoKjliDE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ApKmliDJ;;AoKl4hDM;EAxOJ,cAAA;EACA,kBAAA;EACA,WAHyC;ApKiniD3C;AoK5miDE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;ApK8miDJ;AoK3miDE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ApK6miDJ;AoK1miDE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ApK4miDJ;;AoK35hDM;EAxOJ,cAAA;EACA,kBAAA;EACA,WAHyC;ApK0oiD3C;AoKroiDE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;ApKuoiDJ;AoKpoiDE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ApKsoiDJ;AoKnoiDE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ApKqoiDJ;;AoKp7hDM;EAxOJ,cAAA;EACA,kBAAA;EACA,WAHyC;ApKmqiD3C;AoK9piDE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;ApKgqiDJ;AoK7piDE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ApK+piDJ;AoK5piDE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ApK8piDJ;;AoK78hDM;EAxOJ,cAAA;EACA,kBAAA;EACA,WAHyC;ApK4riD3C;AoKvriDE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;ApKyriDJ;AoKtriDE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ApKwriDJ;AoKrriDE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ApKuriDJ;;AoKt+hDM;EAxOJ,cAAA;EACA,kBAAA;EACA,WAHyC;ApKqtiD3C;AoKhtiDE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,qBAAA;ApKktiDJ;AoK/siDE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ApKitiDJ;AoK9siDE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ApKgtiDJ;;AoK//hDM;EAxOJ,cAAA;EACA,kBAAA;EACA,WAHyC;ApK8uiD3C;AoKzuiDE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;ApK2uiDJ;AoKxuiDE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ApK0uiDJ;AoKvuiDE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ApKyuiDJ;;AoKxhiDM;EAxOJ,cAAA;EACA,kBAAA;EACA,WAHyC;ApKuwiD3C;AoKlwiDE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;ApKowiDJ;AoKjwiDE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ApKmwiDJ;AoKhwiDE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ApKkwiDJ;;AsK5xiDA;+BAAA;AAGA;EACC,sBAAA;EACA,6CAAA;EACA,uPAAA;EAIA,mBAAA;EACA,kBAAA;AtK2xiDD;AuKryiDA;;ECWE,sBAAA;EACF,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,mCAAA;EACA,kCAAA;GxK8xiDE,mBwK7xiDA;AxK8xiDF;;AuK7yiDA;;EAEE,wBAAA;EACA,qBAAA;EACA,WAAA;AvKgziDF;;AuK7yiDA,6DAAA;AACA;EACE,oBAAA;EACA,yBAAA;AvKgziDF;;AuK7yiDA,iDAAA;AAEE;;EAEE,eAAA;AvK+yiDJ;;AuK3yiDA,uCAAA;AAGE;;EACE,qBAAA;EACA,qBAAA;EACA,iBAAA;EACA,6BAAA;AvK6yiDJ;AuK5yiDI;;EACE,qBAAA;AvK+yiDN;;AuK1yiDA;EACE,2BEpCe;EFqCf,qBAAA;AvK6yiDF;AuK3yiDE;EAAO,kBAAA;AvK8yiDT;AuK5yiDE;EACE,kBAAA;EACA,qBAAA;EACA,qBE5Ca;EF6Cb,kBAAA;EACA,oBAAA;AvK8yiDJ;;AuKvyiDE;;EACE,aAAA;AvK2yiDJ;;AuKvyiDA;EAAc,cE7DF;AzKw2iDZ;;AuK1yiDA;EAAc,YE7DF;AzK22iDZ;;AuK7yiDA;EAAa,cE7DF;AzK82iDX;;AuK5yiDA;EACE,yBAAA;EACA,4BAAA;EC9CA,kBD+CuB;AvKiziDzB;;AuK3yiDA;EACE,cAAA;AvK8yiDF;AuK7yiDE;EACE,iBAAA;ECxDF,kBDyDyB;AvKiziD3B;;AuK9yiDA;EACE,cAAA;AvKiziDF;AuKhziDE;EACE,iBAAA;EC/DF,kBDgEyB;AvKoziD3B;;AuKjziDA;EACE,cAAA;AvKoziDF;AuKnziDE;EACE,iBAAA;ECtEF,kBDuEyB;AvKuziD3B;;AuKnziDA;EACE,cAAA;AvKsziDF;AuKrziDE;EACE,iBAAA;EC9EF,kBD+EyB;AvKyziD3B;;AuKhziDA;EAAc,YAAA;AvKoziDd;;AuKnziDA;EAAa,WAAA;AvKuziDb;;AuKnziDE;;EACE,mBAAA;AvKuziDJ;AuKrziDE;;EACE,kBAAA;AvKwziDJ;;A0Kp7iDA;+BAAA;AAGA,6BAAA;AF6BE;EACE,kBAAA;EACA,qBAAA;EACA,UAJsB;EAKtB,WALoC;EAMpC,gBANsB;EAOtB,oBAAA;AxK05iDJ;AwKz5iDI;;EAEE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAfuD;EAgBvD,oBAAA;GxK25iDJ,gBwK36iDsC;AxK46iDxC;AwKz5iDI;EACE,cApB6E;GxK+6iDjF,gBwK15iDI;AxK25iDN;;A0Kz8iDA,2BAAA;AACA;EACE,qBAAA;EAIA,kCAAA;A1K48iDF;;A0Kz8iDA,0EAAA;AACA;;EAEE,qBAAA;EACA,qBAAA;A1K48iDF;A0Kz7iDA;EACE;IAAK,uBAAA;E1K69iDL;E0K59iDA;IAAO,yBAAA;E1K+9iDP;AACF;A0Kj9iDA,iCAAA;AACA;EAKE,wBAAA;EACA,gEAAA;A1Km9iDF;;A0Kh9iDA;EAKE,yBAAA;EACA,gEAAA;A1Km9iDF;;A0Kh9iDA;EAKE,yBAAA;EACA,gEAAA;A1Km9iDF;;A0Kh9iDA;EAKE,uBAAA;A1Km9iDF;;A0Kh9iDA;EAKE,uBAAA;A1Km9iDF;;A0Kh9iDA,8CAAA;AAGI;EAAW,qBAAA;A1Kk9iDf;;A2KxjjDA;EAAmB,gBAAA;A3K4jjDnB;;A2K3jjDA;EAAqB,gBAAA;A3K+jjDrB;;A2K9jjDA;EAAmB,gBAAA;A3KkkjDnB;;A2KjkjDA;EAAqB,gBAAA;A3KqkjDrB;;A2KpkjDA;EAAqB,gBAAA;A3KwkjDrB;;A2KvkjDA;EAAoB,gBAAA;A3K2kjDpB;;A2K1kjDA;EAAsB,gBAAA;A3K8kjDtB;;A2K7kjDA;EAAqB,gBAAA;A3KiljDrB;;A2KhljDA;EAAkB,gBAAA;A3KoljDlB;;A2KnljDA;EAAqB,gBAAA;A3KuljDrB;;A2KtljDA;EAAmB,gBAAA;A3K0ljDnB;;A2KzljDA;EAAoB,gBAAA;A3K6ljDpB;;A2K5ljDA;EAAqB,gBAAA;A3KgmjDrB;;A2K/ljDA;EAA4B,gBAAA;A3KmmjD5B;;A2KlmjDA;EAAiC,gBAAA;A3KsmjDjC;;A2KrmjDA;EAAuB,gBAAA;A3KymjDvB;;A2KxmjDA;EAAqB,gBAAA;A3K4mjDrB;;A2K3mjDA;EAAsB,gBAAA;A3K+mjDtB;;A2K9mjDA;EAAuB,gBAAA;A3KknjDvB;;A2KjnjDA;EAAkB,gBAAA;A3KqnjDlB;;A2KpnjDA;EAAoB,gBAAA;A3KwnjDpB;;A2KvnjDA;EAA2B,gBAAA;A3K2njD3B;;A2K1njDA;EAAwB,gBAAA;A3K8njDxB;;A2K7njDA;EAAuB,gBAAA;A3KiojDvB;;A2KhojDA;EAA2B,gBAAA;A3KoojD3B;;A2KnojDA;EAAqB,gBAAA;A3KuojDrB;;A2KtojDA;EAAmB,gBAAA;A3K0ojDnB;;A2KzojDA;EAAkB,gBAAA;A3K6ojDlB;;A2K5ojDA;EAAqB,gBAAA;A3KgpjDrB;;A2K/ojDA;EAAyB,gBAAA;A3KmpjDzB;;A2KlpjDA;EAA2B,gBAAA;A3KspjD3B;;A2KrpjDA;EAA2B,gBAAA;A3KypjD3B;;A2KxpjDA;EAAiB,gBAAA;A3K4pjDjB;;A2K3pjDA;EAAqB,gBAAA;A3K+pjDrB;;A2K9pjDA;EAAoB,gBAAA;A3KkqjDpB;;A2KjqjDA;EAAqB,gBAAA;A3KqqjDrB;;A2KpqjDA;EAAyB,gBAAA;A3KwqjDzB;;A2KvqjDA;EAAqB,gBAAA;A3K2qjDrB;;A2K1qjDA;EAAyB,gBAAA;A3K8qjDzB;;A2K7qjDA;EAAuB,gBAAA;A3KirjDvB;;A2KhrjDA;EAA0B,gBAAA;A3KorjD1B;;A2KnrjDA;EAAyB,gBAAA;A3KurjDzB;;A2KtrjDA;EAAyB,gBAAA;A3K0rjDzB;;A2KzrjDA;EAAmB,gBAAA;A3K6rjDnB;;A2K5rjDA;EAA6B,gBAAA;A3KgsjD7B;;A2K/rjDA;EAAmB,gBAAA;A3KmsjDnB;;A2KlsjDA;EAAqB,gBAAA;A3KssjDrB;;A2KrsjDA;EAAqB,gBAAA;A3KysjDrB;;A2KxsjDA;EAAyB,gBAAA;A3K4sjDzB;;A2K3sjDA;EAAkB,gBAAA;A3K+sjDlB;;A2K9sjDA;EAAqB,gBAAA;A3KktjDrB;;A2KjtjDA;EAAoB,gBAAA;A3KqtjDpB;;A2KptjDA;EAAoB,gBAAA;A3KwtjDpB;;A2KvtjDA;EAA2B,gBAAA;A3K2tjD3B;;A2K1tjDA;EAAwB,gBAAA;A3K8tjDxB;;A2K7tjDA;EAAwB,gBAAA;A3KiujDxB;;A2KhujDA;EAAwB,gBAAA;A3KoujDxB;;A2KnujDA;EAAqB,gBAAA;A3KuujDrB;;A2KtujDA;EAAmB,gBAAA;A3K0ujDnB;;A2KzujDA;EAAuB,gBAAA;A3K6ujDvB;;A2K5ujDA;EAAyB,gBAAA;A3KgvjDzB;;A2K/ujDA;EAAkB,gBAAA;A3KmvjDlB;;A2KlvjDA;EAAqB,gBAAA;A3KsvjDrB;;A2KrvjDA;EAAgC,gBAAA;A3KyvjDhC;;A2KxvjDA;EAAsB,gBAAA;A3K4vjDtB;;A2K3vjDA;EAAkB,gBAAA;A3K+vjDlB;;A2K9vjDA;EAAoB,gBAAA;A3KkwjDpB;;A2KjwjDA;EAAuB,gBAAA;A3KqwjDvB;;A2KpwjDA;EAAsB,gBAAA;A3KwwjDtB;;A2KvwjDA;EAA0B,gBAAA;A3K2wjD1B;;A2K1wjDA;EAAoB,gBAAA;A3K8wjDpB;;A2K7wjDA;EAAmB,gBAAA;A3KixjDnB;;A2KhxjDA;EAAuB,gBAAA;A3KoxjDvB;;A2KnxjDA;EAA0B,gBAAA;A3KuxjD1B;;A2KtxjDA;EAAyB,gBAAA;A3K0xjDzB;;A2KzxjDA;EAAyB,gBAAA;A3K6xjDzB;;A2K5xjDA;EAAoB,gBAAA;A3KgyjDpB;;A2K/xjDA;EAAwB,gBAAA;A3KmyjDxB;;A2KlyjDA;EAAqB,gBAAA;A3KsyjDrB;;A2KryjDA;EAA2B,gBAAA;A3KyyjD3B;;A2KxyjDA;EAAoB,gBAAA;A3K4yjDpB;;A2K3yjDA;EAAwB,gBAAA;A3K+yjDxB;;A2K9yjDA;EAAmB,gBAAA;A3KkzjDnB;;A2KjzjDA;EAAuB,gBAAA;A3KqzjDvB;;A2KpzjDA;EAAyB,gBAAA;A3KwzjDzB;;A2KvzjDA;EAAkB,gBAAA;A3K2zjDlB;;A2K1zjDA;EAAmB,gBAAA;A3K8zjDnB;;A2K7zjDA;EAA8B,gBAAA;A3Ki0jD9B;;A2Kh0jDA;EAAgC,gBAAA;A3Ko0jDhC;;A2Kn0jDA;EAAyB,gBAAA;A3Ku0jDzB;;A2Kt0jDA;EAA8B,gBAAA;A3K00jD9B;;A2Kz0jDA;EAA6B,gBAAA;A3K60jD7B;;A2K50jDA;EAA8B,gBAAA;A3Kg1jD9B;;A2K/0jDA;EAAiC,gBAAA;A3Km1jDjC;;A2Kl1jDA;EAAgC,gBAAA;A3Ks1jDhC;;A2Kr1jDA;EAAgC,gBAAA;A3Ky1jDhC;;A2Kx1jDA;EAA8B,gBAAA;A3K41jD9B;;A2K31jDA;EAAiC,gBAAA;A3K+1jDjC;;A2K91jDA;EAAgC,gBAAA;A3Kk2jDhC;;A2Kj2jDA;EAAgC,gBAAA;A3Kq2jDhC;;A2Kp2jDA;EAAkB,gBAAA;A3Kw2jDlB;;A2Kv2jDA;EAAoB,gBAAA;A3K22jDpB;;A2K12jDA;EAAyB,gBAAA;A3K82jDzB;;A2K72jDA;EAAwB,gBAAA;A3Ki3jDxB;;A2Kh3jDA;EAA4B,gBAAA;A3Ko3jD5B;;A2Kn3jDA;EAAwB,gBAAA;A3Ku3jDxB;;A2Kt3jDA;EAAwB,gBAAA;A3K03jDxB;;A2Kz3jDA;EAAqB,gBAAA;A3K63jDrB;;A2K53jDA;EAAwB,gBAAA;A3Kg4jDxB;;A2K/3jDA;EAAoB,gBAAA;A3Km4jDpB;;A2Kl4jDA;EAAoB,gBAAA;A3Ks4jDpB;;A2Kr4jDA;EAAqB,gBAAA;A3Ky4jDrB;;A2Kx4jDA;EAAuB,gBAAA;A3K44jDvB;;A2K34jDA;EAAyB,gBAAA;A3K+4jDzB;;A2K94jDA;EAAmB,gBAAA;A3Kk5jDnB;;A2Kj5jDA;EAAuB,gBAAA;A3Kq5jDvB;;A2Kp5jDA;EAAyB,gBAAA;A3Kw5jDzB;;A2Kv5jDA;EAAsB,gBAAA;A3K25jDtB;;A2K15jDA;EAAsB,gBAAA;A3K85jDtB;;A2K75jDA;EAAuB,gBAAA;A3Ki6jDvB;;A2Kh6jDA;EAAoB,gBAAA;A3Ko6jDpB;;A2Kn6jDA;EAA0B,gBAAA;A3Ku6jD1B;;A2Kt6jDA;EAAyB,gBAAA;A3K06jDzB;;A2Kz6jDA;EAAqB,gBAAA;A3K66jDrB;;A2K56jDA;EAAsB,gBAAA;A3Kg7jDtB;;A2K/6jDA;EAAqB,gBAAA;A3Km7jDrB;;A2Kl7jDA;EAA0B,gBAAA;A3Ks7jD1B;;A2Kr7jDA;EAAyB,gBAAA;A3Ky7jDzB;;A2Kx7jDA;EAAoB,gBAAA;A3K47jDpB;;A2K37jDA;EAAsB,gBAAA;A3K+7jDtB;;A2K97jDA;EAAwB,gBAAA;A3Kk8jDxB;;A2Kj8jDA;EAAmB,gBAAA;A3Kq8jDnB;;A2Kp8jDA;EAAwB,gBAAA;A3Kw8jDxB;;A2Kv8jDA;EAAwB,gBAAA;A3K28jDxB;;A2K18jDA;EAAoB,gBAAA;A3K88jDpB;;A2K78jDA;EAAsB,gBAAA;A3Ki9jDtB;;A2Kh9jDA;EAAoB,gBAAA;A3Ko9jDpB;;A2Kn9jDA;EAAwB,gBAAA;A3Ku9jDxB;;A2Kt9jDA;EAAoB,gBAAA;A3K09jDpB;;A2Kz9jDA;EAAwB,gBAAA;A3K69jDxB;;A2K59jDA;EAAoB,gBAAA;A3Kg+jDpB;;A2K/9jDA;EAAyB,gBAAA;A3Km+jDzB;;A2Kl+jDA;EAAmB,gBAAA;A3Ks+jDnB;;A2Kr+jDA;EAAuB,gBAAA;A3Ky+jDvB;;A2Kx+jDA;EAAkB,gBAAA;A3K4+jDlB;;A2K3+jDA;EAAsB,gBAAA;A3K++jDtB;;A2K9+jDA;EAAmB,gBAAA;A3Kk/jDnB;;A2Kj/jDA;EAA2B,gBAAA;A3Kq/jD3B;;A2Kp/jDA;EAAmB,gBAAA;A3Kw/jDnB;;A2Kv/jDA;EAAyB,gBAAA;A3K2/jDzB;;A2K1/jDA;EAAqB,gBAAA;A3K8/jDrB;;A2K7/jDA;EAAmB,gBAAA;A3KigkDnB;;A2KhgkDA;EAAuB,gBAAA;A3KogkDvB;;A2KngkDA;EAAuB,gBAAA;A3KugkDvB;;A2KtgkDA;EAAqB,gBAAA;A3K0gkDrB;;A2KzgkDA;EAAmB,gBAAA;A3K6gkDnB;;A2K5gkDA;EAAmB,gBAAA;A3KghkDnB;;A2K/gkDA;EAAwB,gBAAA;A3KmhkDxB;;A2KlhkDA;EAAyB,gBAAA;A3KshkDzB;;A2KrhkDA;EAAwB,gBAAA;A3KyhkDxB;;A2KxhkDA;EAAmB,gBAAA;A3K4hkDnB;;A2K3hkDA;EAAmB,gBAAA;A3K+hkDnB;;A2K9hkDA;EAAqB,gBAAA;A3KkikDrB;;A2KjikDA;EAAoB,gBAAA;A3KqikDpB;;A2KpikDA;EAAmB,gBAAA;A3KwikDnB;;A2KvikDA;EAAqB,gBAAA;A3K2ikDrB;;A2K1ikDA;EAAuB,gBAAA;A3K8ikDvB;;A2K7ikDA;EAAuB,gBAAA;A3KijkDvB;;A2KhjkDA;EAAwB,gBAAA;A3KojkDxB;;A2KnjkDA;EAA4B,gBAAA;A3KujkD5B;;A2KtjkDA;EAAwB,gBAAA;A3K0jkDxB;;A2KzjkDA;EAA2B,gBAAA;A3K6jkD3B;;A2K5jkDA;EAA8B,gBAAA;A3KgkkD9B;;A2K/jkDA;EAA2B,gBAAA;A3KmkkD3B;;A2KlkkDA;EAA4B,gBAAA;A3KskkD5B;;A2KrkkDA;EAA8B,gBAAA;A3KykkD9B;;A2KxkkDA;EAA+B,gBAAA;A3K4kkD/B;;A2K3kkDA;EAAoB,gBAAA;A3K+kkDpB;;A2K9kkDA;EAAuB,gBAAA;A3KklkDvB;;A2KjlkDA;EAAyB,gBAAA;A3KqlkDzB;;A2KplkDA;EAAwB,gBAAA;A3KwlkDxB;;A2KvlkDA;EAAkB,gBAAA;A3K2lkDlB;;A2K1lkDA;EAAuB,gBAAA;A3K8lkDvB;;A2K7lkDA;EAAmB,gBAAA;A3KimkDnB;;A2KhmkDA;EAAmB,gBAAA;A3KomkDnB;;A2KnmkDA;EAAyB,gBAAA;A3KumkDzB;;A2KtmkDA;EAAwB,gBAAA;A3K0mkDxB;;A2KzmkDA;EAA4B,gBAAA;A3K6mkD5B;;A2K5mkDA;EAAyB,gBAAA;A3KgnkDzB;;A2K/mkDA;EAAwB,gBAAA;A3KmnkDxB;;A2KlnkDA;EAA4B,gBAAA;A3KsnkD5B;;A2KrnkDA;EAAsB,gBAAA;A3KynkDtB;;A2KxnkDA;EAAqB,gBAAA;A3K4nkDrB;;A2K3nkDA;EAA0B,gBAAA;A3K+nkD1B;;A2K9nkDA;EAAyB,gBAAA;A3KkokDzB;;A2KjokDA;EAA4B,gBAAA;A3KqokD5B;;A2KpokDA;EAA2B,gBAAA;A3KwokD3B;;A2KvokDA;EAAoB,gBAAA;A3K2okDpB;;A2K1okDA;EAA0B,gBAAA;A3K8okD1B;;A2K7okDA;EAAqB,gBAAA;A3KipkDrB;;A2KhpkDA;EAAoB,gBAAA;A3KopkDpB;;A2KnpkDA;EAAqB,gBAAA;A3KupkDrB;;A2KtpkDA;EAAyB,gBAAA;A3K0pkDzB;;A2KzpkDA;EAAqB,gBAAA;A3K6pkDrB;;A2K5pkDA;EAAyB,gBAAA;A3KgqkDzB;;A2K/pkDA;EAAqB,gBAAA;A3KmqkDrB;;A2KlqkDA;EAA4B,gBAAA;A3KsqkD5B;;A2KrqkDA;EAA2B,gBAAA;A3KyqkD3B;;A2KxqkDA;EAAqB,gBAAA;A3K4qkDrB;;A2K3qkDA;EAA2B,gBAAA;A3K+qkD3B;;A2K9qkDA;EAA8B,gBAAA;A3KkrkD9B;;A2KjrkDA;EAAkC,gBAAA;A3KqrkDlC;;A2KprkDA;EAAsB,gBAAA;A3KwrkDtB;;A2KvrkDA;EAAoB,gBAAA;A3K2rkDpB;;A2K1rkDA;EAA0B,gBAAA;A3K8rkD1B;;A2K7rkDA;EAAoB,gBAAA;A3KiskDpB;;A2KhskDA;EAAwB,gBAAA;A3KoskDxB;;A2KnskDA;EAA8B,gBAAA;A3KuskD9B;;A2KtskDA;EAA6B,gBAAA;A3K0skD7B;;A2KzskDA;EAA0B,gBAAA;A3K6skD1B;;A2K5skDA;EAAsB,gBAAA;A3KgtkDtB;;A2K/skDA;EAAmB,gBAAA;A3KmtkDnB;;A2KltkDA;EAAsB,gBAAA;A3KstkDtB;;A2KrtkDA;EAA0B,gBAAA;A3KytkD1B;;A2KxtkDA;EAAsB,gBAAA;A3K4tkDtB;;A2K3tkDA;EAAmB,gBAAA;A3K+tkDnB;;A2K9tkDA;EAAuB,gBAAA;A3KkukDvB;;A2KjukDA;EAA6B,gBAAA;A3KqukD7B;;A2KpukDA;EAAqB,gBAAA;A3KwukDrB;;A2KvukDA;EAA0B,gBAAA;A3K2ukD1B;;A2K1ukDA;EAA0B,gBAAA;A3K8ukD1B;;A2K7ukDA;EAA0B,gBAAA;A3KivkD1B;;A2KhvkDA;EAAgC,gBAAA;A3KovkDhC;;A2KnvkDA;EAAmC,gBAAA;A3KuvkDnC;;A2KtvkDA;EAAuC,gBAAA;A3K0vkDvC;;A2KzvkDA;EAAyB,gBAAA;A3K6vkDzB;;A2K5vkDA;EAAgC,gBAAA;A3KgwkDhC;;A2K/vkDA;EAA2B,gBAAA;A3KmwkD3B;;A2KlwkDA;EAA6B,gBAAA;A3KswkD7B;;A2KrwkDA;EAA4B,gBAAA;A3KywkD5B;;A2KxwkDA;EAAgC,gBAAA;A3K4wkDhC;;A2K3wkDA;EAAmC,gBAAA;A3K+wkDnC;;A2K9wkDA;EAAkC,gBAAA;A3KkxkDlC;;A2KjxkDA;EAAkC,gBAAA;A3KqxkDlC;;A2KpxkDA;EAAiC,gBAAA;A3KwxkDjC;;A2KvxkDA;EAA0B,gBAAA;A3K2xkD1B;;A2K1xkDA;EAA4B,gBAAA;A3K8xkD5B;;A2K7xkDA;EAAoC,gBAAA;A3KiykDpC;;A2KhykDA;EAA+B,gBAAA;A3KoykD/B;;A2KnykDA;EAAqC,gBAAA;A3KuykDrC;;A2KtykDA;EAAiC,gBAAA;A3K0ykDjC;;A2KzykDA;EAAmC,gBAAA;A3K6ykDnC;;A2K5ykDA;EAAuC,gBAAA;A3KgzkDvC;;A2K/ykDA;EAAyC,gBAAA;A3KmzkDzC;;A2KlzkDA;EAAoC,gBAAA;A3KszkDpC;;A2KrzkDA;EAAgC,gBAAA;A3KyzkDhC;;A2KxzkDA;EAAsC,gBAAA;A3K4zkDtC;;A2K3zkDA;EAAkC,gBAAA;A3K+zkDlC;;A2K9zkDA;EAAgC,gBAAA;A3Kk0kDhC;;A2Kj0kDA;EAAoC,gBAAA;A3Kq0kDpC;;A2Kp0kDA;EAA+B,gBAAA;A3Kw0kD/B;;A2Kv0kDA;EAAsC,gBAAA;A3K20kDtC;;A2K10kDA;EAAgC,gBAAA;A3K80kDhC;;A2K70kDA;EAA2B,gBAAA;A3Ki1kD3B;;A2Kh1kDA;EAA2B,gBAAA;A3Ko1kD3B;;A2Kn1kDA;EAA2B,gBAAA;A3Ku1kD3B;;A2Kt1kDA;EAAiC,gBAAA;A3K01kDjC;;A2Kz1kDA;EAA+B,gBAAA;A3K61kD/B;;A2K51kDA;EAA8B,gBAAA;A3Kg2kD9B;;A2K/1kDA;EAAgC,gBAAA;A3Km2kDhC;;A2Kl2kDA;EAAmC,gBAAA;A3Ks2kDnC;;A2Kr2kDA;EAAkC,gBAAA;A3Ky2kDlC;;A2Kx2kDA;EAA6B,gBAAA;A3K42kD7B;;A2K32kDA;EAA6B,gBAAA;A3K+2kD7B;;A2K92kDA;EAA6B,gBAAA;A3Kk3kD7B;;A2Kj3kDA;EAAyC,gBAAA;A3Kq3kDzC;;A2Kp3kDA;EAAsC,gBAAA;A3Kw3kDtC;;A2Kv3kDA;EAAoC,gBAAA;A3K23kDpC;;A2K13kDA;EAAsB,gBAAA;A3K83kDtB;;A2K73kDA;EAAuB,gBAAA;A3Ki4kDvB;;A2Kh4kDA;EAAuB,gBAAA;A3Ko4kDvB;;A2Kn4kDA;EAA4B,gBAAA;A3Ku4kD5B;;A2Kt4kDA;EAA4B,gBAAA;A3K04kD5B;;A2Kz4kDA;EAA+B,gBAAA;A3K64kD/B;;A2K54kDA;EAA8B,gBAAA;A3Kg5kD9B;;A2K/4kDA;EAA8B,gBAAA;A3Km5kD9B;;A2Kl5kDA;EAAsB,gBAAA;A3Ks5kDtB;;A2Kr5kDA;EAAyB,gBAAA;A3Ky5kDzB;;A2Kx5kDA;EAAuB,gBAAA;A3K45kDvB;;A2K35kDA;EAA0B,gBAAA;A3K+5kD1B;;A2K95kDA;EAAmC,gBAAA;A3Kk6kDnC;;A2Kj6kDA;EAAoC,gBAAA;A3Kq6kDpC;;A2Kp6kDA;EAA6B,gBAAA;A3Kw6kD7B;;A2Kv6kDA;EAA4B,gBAAA;A3K26kD5B;;A2K16kDA;EAA8B,gBAAA;A3K86kD9B;;A2K76kDA;EAAwB,gBAAA;A3Ki7kDxB;;A2Kh7kDA;EAAsB,gBAAA;A3Ko7kDtB;;A2Kn7kDA;EAAoB,gBAAA;A3Ku7kDpB;;A2Kt7kDA;EAAsB,gBAAA;A3K07kDtB;;A2Kz7kDA;EAAmB,gBAAA;A3K67kDnB;;A2K57kDA;EAAqB,gBAAA;A3Kg8kDrB;;A2K/7kDA;EAAoB,gBAAA;A3Km8kDpB;;A2Kl8kDA;EAAoB,gBAAA;A3Ks8kDpB;;A2Kr8kDA;EAAwB,gBAAA;A3Ky8kDxB;;A2Kx8kDA;EAAqB,gBAAA;A3K48kDrB;;A2K38kDA;EAAwB,gBAAA;A3K+8kDxB;;A2K98kDA;EAAyB,gBAAA;A3Kk9kDzB;;A2Kj9kDA;EAAwB,gBAAA;A3Kq9kDxB;;A2Kp9kDA;EAAsB,gBAAA;A3Kw9kDtB;;A2Kv9kDA;EAAuB,gBAAA;A3K29kDvB;;A2K19kDA;EAA+B,gBAAA;A3K89kD/B;;A2K79kDA;EAA+B,gBAAA;A3Ki+kD/B;;A2Kh+kDA;EAA+B,gBAAA;A3Ko+kD/B;;A2Kn+kDA;EAA+B,gBAAA;A3Ku+kD/B;;A2Kt+kDA;EAAiC,gBAAA;A3K0+kDjC;;A2Kz+kDA;EAAiC,gBAAA;A3K6+kDjC;;A2K5+kDA;EAAiC,gBAAA;A3Kg/kDjC;;A2K/+kDA;EAAwB,gBAAA;A3Km/kDxB;;A2Kl/kDA;EAAqB,gBAAA;A3Ks/kDrB;;A2Kr/kDA;EAAqB,gBAAA;A3Ky/kDrB;;A2Kx/kDA;EAAqB,gBAAA;A3K4/kDrB;;A2K3/kDA;EAAuB,gBAAA;A3K+/kDvB;;A2K9/kDA;EAAsB,gBAAA;A3KkglDtB;;A2KjglDA;EAAuB,gBAAA;A3KqglDvB;;A2KpglDA;EAAoB,gBAAA;A3KwglDpB;;A2KvglDA;EAAsB,gBAAA;A3K2glDtB;;A2K1glDA;EAAmB,gBAAA;A3K8glDnB;;A2K7glDA;EAAuB,gBAAA;A3KihlDvB;;A2KhhlDA;EAAoB,gBAAA;A3KohlDpB;;A2KnhlDA;EAAwB,gBAAA;A3KuhlDxB;;A2KthlDA;EAAwB,gBAAA;A3K0hlDxB;;A2KzhlDA;EAA0B,gBAAA;A3K6hlD1B;;A2K5hlDA;EAAyB,gBAAA;A3KgilDzB;;A2K/hlDA;EAAqB,gBAAA;A3KmilDrB;;A2KlilDA;EAA6B,gBAAA;A3KsilD7B;;A2KrilDA;EAAyB,gBAAA;A3KyilDzB;;A2KxilDA;EAAwB,gBAAA;A3K4ilDxB;;A2K3ilDA;EAA4B,gBAAA;A3K+ilD5B;;A2K9ilDA;EAAqB,gBAAA;A3KkjlDrB;;A2KjjlDA;EAA4B,gBAAA;A3KqjlD5B;;A2KpjlDA;EAA4B,gBAAA;A3KwjlD5B;;A2KvjlDA;EAAoB,gBAAA;A3K2jlDpB;;A2K1jlDA;EAAuB,gBAAA;A3K8jlDvB;;A2K7jlDA;EAAqB,gBAAA;A3KiklDrB;;A2KhklDA;EAAoB,gBAAA;A3KoklDpB;;A2KnklDA;EAAyB,gBAAA;A3KuklDzB;;A2KtklDA;EAAoB,gBAAA;A3K0klDpB;;A2KzklDA;EAAqB,gBAAA;A3K6klDrB;;A2K5klDA;EAA0B,gBAAA;A3KgllD1B;;A2K/klDA;EAAmB,gBAAA;A3KmllDnB;;A2KlllDA;EAAkB,gBAAA;A3KsllDlB;;A2KrllDA;EAAsB,gBAAA;A3KyllDtB;;A4Kx7lDA,cAAA;AA2DA,qEAAA;AAMA;EACE,aAAA;EACA,iBAAA;EACA,eAAA;A5K43lDF;;A4Kz3lDA;EACE,uCAAA;EACA,eAAA;EACA,YAAA;A5K43lDF;;A4Kz3lDA,eAAA;AAEA;EACE,qBAAA;EACA,WA/EK;EAgFL,YAhFK;EAiFL,mCAAA;A5K23lDF;;A4Kx3lDA;EACE,mCAAA;EACA,iCAAA;EACA,yBAAA;EACA,uBAzFsB;EA0FtB,2BAAA;A5K23lDF;;A4Kx3lDA,QAAA;AAEA;EACE,sBAAA;A5K03lDF;;A4Kv3lDA;EACE,qBAAA;EACA,8BAAA;EACA,wBAAA;A5K03lDF;;A4Kv3lDA;EACE,qBAAA;A5K03lDF;;A4Kv3lDA,SAAA;AAEA;EACE,6BAAA;EACA,uBAjHsB;EAkHtB,8BAAA;A5Ky3lDF;;A4Kt3lDA,SAAA;AAEA;EACE,6BAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;A5Kw3lDF;;A4Kr3lDA,cAAA;AAEA;EACE,sBAAA;EACA,uBAAA;EACA,2BAAA;A5Ku3lDF;;A4Kp3lDA,cAAA;AAEA;EACE,uCAAA;EACA,sCAAA;EACA,2CAAA;EACA,wBAAA;EACA,6BAAA;A5Ks3lDF;;A4Kn3lDA;EACE,eAAA;EACA,kCAAA;EACA,sCAAA;EACA,wBAAA;EACA,yBAAA;A5Ks3lDF;;A4Kn3lDA;EACE,qBAAA;A5Ks3lDF;;A4Kn3lDA,eAAA;AAEA;EACE,8CAAA;EACA,sCAAA;EACA,2CAAA;EACA,wBAAA;EACA,6BAAA;A5Kq3lDF;;A4Kl3lDA,YAAA;AAEA;EACE,eAAA;EACA,yCAAA;EACA,kCAAA;EACA,wBAAA;A5Ko3lDF;;A4Kh3lDE;EACE,mBAAA;A5Km3lDJ;;A4Kp3lDE;EACE,qBAAA;A5Ku3lDJ;;A4Kx3lDE;EACE,qBAAA;A5K23lDJ;;A4Kv3lDA,SAAA;AAEA;EACE,eAAA;EACA,sCAAA;EACA,kCAAA;EACA,sBAAA;A5Ky3lDF;;A4Kt3lDA;EACE,qBAAA;A5Ky3lDF;;A4Kt3lDA;EACE,qBAAA;A5Ky3lDF;;A4Kt3lDA,SAAA;AAQA,aAAA;AAEA;EACE,eAAA;EACA,kCAAA;EACA,sBAAA;A5Ki3lDF;;A4K92lDA;EACE,sCAAA;A5Ki3lDF;;A4K92lDA;EACE,wCAAA;A5Ki3lDF;;A4K92lDA;EACE,yCAAA;A5Ki3lDF;;A4K92lDA;EACE,uCAAA;A5Ki3lDF;;A4K72lDE;EACE,mBAAA;A5Kg3lDJ;;A4Kj3lDE;EACE,8BAAA;A5Ko3lDJ;;A4Kr3lDE;EACE,8BAAA;A5Kw3lDJ;;A4Kz3lDE;EACE,qBAAA;A5K43lDJ;;A4K73lDE;EACE,8BAAA;A5Kg4lDJ;;A4Kj4lDE;EACE,8BAAA;A5Ko4lDJ;;A4Kh4lDA,SAAA;AAEA;EACE,eAAA;EACA,sCAAA;EACA,sCAAA;EACA,sBAAA;A5Kk4lDF;;A4K/3lDA;EACE,uCAAA;A5Kk4lDF;;A4K93lDE;EACE,mBAAA;A5Ki4lDJ;;A4Kl4lDE;EACE,mBAAA;A5Kq4lDJ;;A4Kt4lDE;EACE,mBAAA;A5Ky4lDJ;;A4Kr4lDA,aAAA;AAEA;EACE,eAAA;EACA,sCAAA;EACA,sCAAA;EACA,sBAAA;A5Ku4lDF;;A4Kp4lDA,QAAA;AAEA;EACE,iBAAA;EACA,4CAAA;EACA,mCAAA;EACA,2BAAA;EACA,kCAAA;EACA,uBAhRsB;A5KspmDxB;;A4Kn4lDA;EACE,mBAAA;A5Ks4lDF;;A4Kn4lDA,cAAA;AAEA;EACE,eAAA;EACA,oCAAA;EACA,mCAAA;EACA,2BAAA;EACA,mCAAA;EACA,uBA/RsB;A5KoqmDxB;;A4Kl4lDA,YAAA;AAEA;EACE,iCAAA;EACA,mCAAA;EACA,8BAAA;EACA,sCAAA;EACA,uBAzSsB;A5K6qmDxB;;A4Kj4lDA;EACE,iCAAA;A5Ko4lDF;;A4Kj4lDA;EACE,iCAAA;A5Ko4lDF;;A4Kj4lDA;EACE,iCAAA;A5Ko4lDF;;A4Kj4lDA;EACE,iCAAA;A5Ko4lDF;;A4Kj4lDA;EACE,iCAAA;A5Ko4lDF;;A4Kj4lDA;EACE,iCAAA;A5Ko4lDF;;A4Kj4lDA;EACE,+BAAA;EACA,wBAAA;EACA,4BAAA;EACA,mCAAA;A5Ko4lDF;;A4Kj4lDA;EACE,+BAAA;EACA,4BAAA;A5Ko4lDF;;A4Kj4lDA;EACE,eAAA;EACA,qBAAA;EACA,sBAAA;EACA,mCAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;A5Ko4lDF;;A4Kj4lDA;EACE,qBAAA;A5Ko4lDF;;A4Kj4lDA;EACE,eAAA;EACA,qBAAA;EACA,mCAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;A5Ko4lDF;;A4Kj4lDA;EACE,qBAAA;A5Ko4lDF;;A4Kj4lDA;EACE,eAAA;EACA,8CAAA;EACA,wBAAA;A5Ko4lDF;;A4Kj4lDA;EACE,eAAA;EACA,gDAAA;EACA,wBAAA;A5Ko4lDF;;A4Kj4lDA;EACE,qBAAA;EACA,8BAAA;EACA,mCAAA;EACA,wBAAA;EACA,mBAAA;EACA,yBAAA;A5Ko4lDF;;A4Kj4lDA;EACE,qBAAA;A5Ko4lDF;;A4Kj4lDA;EACE,6CAAA;EACA,2BAAA;EACA,2BAAA;EACA,4BAAA;EACA,6BAAA;A5Ko4lDF;;A4Kj4lDA;EACE,eAAA;EACA,kCAAA;EACA,sCAAA;EACA,sCAAA;EACA,wBAAA;EACA,wBAAA;EACA,yBAAA;A5Ko4lDF;;A4Kj4lDA;EACE,2BAAA;A5Ko4lDF;;A4Kj4lDA;EACE,+BAAA;EACA,mBAAA;EACA,uBA7ZsB;EA8ZtB,2BAAA;EACA,4BAAA;EACA,6BAAA;A5Ko4lDF;;A4Kj4lDA,eAAA;AAEA;EACE;IACE,uBAAA;E5Km4lDF;E4Kj4lDA;IACE,yBAAA;E5Km4lDF;AACF;A4K/3lDA;EACE;IACE,uBAAA;E5Ki4lDF;E4K/3lDA;IACE,yBAAA;E5Ki4lDF;E4K/3lDA;IACE,uBAAA;E5Ki4lDF;E4K/3lDA;IACE,wBAAA;E5Ki4lDF;E4K/3lDA;IACE,uBAAA;E5Ki4lDF;AACF;A4K73lDA;EACE;IACE,sBAAA;E5K+3lDF;E4K73lDA;IACE,0BAAA;E5K+3lDF;AACF;A4K33lDA;EACE;IACE,iDAAA;E5K63lDF;E4K33lDA;IACE,sCAAA;E5K63lDF;AACF;A4Kz3lDA;EACE;IACE,wBAAA;E5K23lDF;E4Kz3lDA;IACE,2BAAA;E5K23lDF;AACF;A4Kv3lDA;EACE;IACE,wBAAA;E5Ky3lDF;E4Kv3lDA;IACE,2BAAA;E5Ky3lDF;AACF;A4Kr3lDA;EACE;IACE,wBAAA;E5Ku3lDF;E4Kr3lDA;IACE,2BAAA;E5Ku3lDF;E4Kr3lDA;IACE,4CAAA;E5Ku3lDF;AACF;A4Kh3lDA;EAEE;IACE,6BAAA;E5Ki3lDF;E4K92lDE;IAEE,gDAAA;E5K+2lDJ;E4Kj3lDE;IAEE,yDAAA;E5Kk3lDJ;E4Kp3lDE;IAEE,yDAAA;E5Kq3lDJ;E4Kv3lDE;IAEE,wDAAA;E5Kw3lDJ;E4K13lDE;IAEE,yDAAA;E5K23lDJ;E4K73lDE;IAEE,yDAAA;E5K83lDJ;E4Kh4lDE;IAEE,yDAAA;E5Ki4lDJ;E4Kn4lDE;IAEE,yDAAA;E5Ko4lDJ;E4Kt4lDE;IAEE,yDAAA;E5Ku4lDJ;E4Kz4lDE;IAEE,wDAAA;E5K04lDJ;E4K54lDE;IAEE,wDAAA;E5K64lDJ;E4K/4lDE;IAEE,wDAAA;E5Kg5lDJ;E4Kl5lDE;IAEE,wDAAA;E5Km5lDJ;E4Kr5lDE;IAEE,wDAAA;E5Ks5lDJ;E4Kx5lDE;IAEE,wDAAA;E5Ky5lDJ;E4K35lDE;IAEE,wDAAA;E5K45lDJ;E4K95lDE;IAEE,wDAAA;E5K+5lDJ;E4Kj6lDE;IAEE,0DAAA;E5Kk6lDJ;E4Kp6lDE;IAEE,0DAAA;E5Kq6lDJ;E4Kv6lDE;IAEE,0DAAA;E5Kw6lDJ;E4K16lDE;IAEE,0DAAA;E5K26lDJ;E4K76lDE;IAEE,0DAAA;E5K86lDJ;E4Kh7lDE;IAEE,yDAAA;E5Ki7lDJ;E4Kn7lDE;IAEE,0DAAA;E5Ko7lDJ;E4Kt7lDE;IAEE,0DAAA;E5Ku7lDJ;AACF;A4K/6lDA;EAEE;IACE,6BAAA;E5Kg7lDF;E4K76lDE;IAEE,iDAAA;E5K86lDJ;E4Kh7lDE;IAEE,0DAAA;E5Ki7lDJ;E4Kn7lDE;IAEE,0DAAA;E5Ko7lDJ;E4Kt7lDE;IAEE,yDAAA;E5Ku7lDJ;E4Kz7lDE;IAEE,0DAAA;E5K07lDJ;E4K57lDE;IAEE,0DAAA;E5K67lDJ;E4K/7lDE;IAEE,0DAAA;E5Kg8lDJ;E4Kl8lDE;IAEE,0DAAA;E5Km8lDJ;E4Kr8lDE;IAEE,0DAAA;E5Ks8lDJ;E4Kx8lDE;IAEE,yDAAA;E5Ky8lDJ;E4K38lDE;IAEE,yDAAA;E5K48lDJ;E4K98lDE;IAEE,yDAAA;E5K+8lDJ;E4Kj9lDE;IAEE,yDAAA;E5Kk9lDJ;E4Kp9lDE;IAEE,yDAAA;E5Kq9lDJ;E4Kv9lDE;IAEE,yDAAA;E5Kw9lDJ;E4K19lDE;IAEE,yDAAA;E5K29lDJ;E4K79lDE;IAEE,yDAAA;E5K89lDJ;E4Kh+lDE;IAEE,0DAAA;E5Ki+lDJ;E4Kn+lDE;IAEE,0DAAA;E5Ko+lDJ;E4Kt+lDE;IAEE,0DAAA;E5Ku+lDJ;E4Kz+lDE;IAEE,0DAAA;E5K0+lDJ;E4K5+lDE;IAEE,0DAAA;E5K6+lDJ;E4K/+lDE;IAEE,yDAAA;E5Kg/lDJ;E4Kl/lDE;IAEE,0DAAA;E5Km/lDJ;E4Kr/lDE;IAEE,0DAAA;E5Ks/lDJ;AACF;A4K3+lDA;EAEE;IACE,6BAAA;E5K4+lDF;E4Kz+lDE;IAEE,gDAAA;E5K0+lDJ;E4K5+lDE;IAEE,yDAAA;E5K6+lDJ;E4K/+lDE;IAEE,yDAAA;E5Kg/lDJ;E4Kl/lDE;IAEE,wDAAA;E5Km/lDJ;E4Kr/lDE;IAEE,yDAAA;E5Ks/lDJ;E4Kx/lDE;IAEE,yDAAA;E5Ky/lDJ;E4K3/lDE;IAEE,yDAAA;E5K4/lDJ;E4K9/lDE;IAEE,yDAAA;E5K+/lDJ;E4KjgmDE;IAEE,yDAAA;E5KkgmDJ;E4KpgmDE;IAEE,wDAAA;E5KqgmDJ;E4KvgmDE;IAEE,wDAAA;E5KwgmDJ;E4K1gmDE;IAEE,wDAAA;E5K2gmDJ;E4K7gmDE;IAEE,wDAAA;E5K8gmDJ;E4KhhmDE;IAEE,wDAAA;E5KihmDJ;E4KnhmDE;IAEE,wDAAA;E5KohmDJ;E4KthmDE;IAEE,wDAAA;E5KuhmDJ;E4KzhmDE;IAEE,wDAAA;E5K0hmDJ;E4K5hmDE;IAEE,yDAAA;E5K6hmDJ;E4K/hmDE;IAEE,yDAAA;E5KgimDJ;E4KlimDE;IAEE,yDAAA;E5KmimDJ;E4KrimDE;IAEE,yDAAA;E5KsimDJ;E4KximDE;IAEE,yDAAA;E5KyimDJ;E4K3imDE;IAEE,wDAAA;E5K4imDJ;E4K9imDE;IAEE,yDAAA;E5K+imDJ;E4KjjmDE;IAEE,yDAAA;E5KkjmDJ;AACF;A4KximDA;EAEE;IACE,6BAAA;E5KyimDF;E4KtimDE;IAEE,+CAAA;E5KuimDJ;E4KzimDE;IAEE,wDAAA;E5K0imDJ;E4K5imDE;IAEE,wDAAA;E5K6imDJ;E4K/imDE;IAEE,uDAAA;E5KgjmDJ;E4KljmDE;IAEE,wDAAA;E5KmjmDJ;E4KrjmDE;IAEE,wDAAA;E5KsjmDJ;E4KxjmDE;IAEE,wDAAA;E5KyjmDJ;E4K3jmDE;IAEE,wDAAA;E5K4jmDJ;E4K9jmDE;IAEE,wDAAA;E5K+jmDJ;E4KjkmDE;IAEE,uDAAA;E5KkkmDJ;E4KpkmDE;IAEE,uDAAA;E5KqkmDJ;E4KvkmDE;IAEE,uDAAA;E5KwkmDJ;E4K1kmDE;IAEE,uDAAA;E5K2kmDJ;E4K7kmDE;IAEE,uDAAA;E5K8kmDJ;E4KhlmDE;IAEE,uDAAA;E5KilmDJ;E4KnlmDE;IAEE,uDAAA;E5KolmDJ;E4KtlmDE;IAEE,uDAAA;E5KulmDJ;E4KzlmDE;IAEE,yDAAA;E5K0lmDJ;E4K5lmDE;IAEE,yDAAA;E5K6lmDJ;E4K/lmDE;IAEE,yDAAA;E5KgmmDJ;E4KlmmDE;IAEE,yDAAA;E5KmmmDJ;E4KrmmDE;IAEE,yDAAA;E5KsmmDJ;E4KxmmDE;IAEE,wDAAA;E5KymmDJ;E4K3mmDE;IAEE,yDAAA;E5K4mmDJ;E4K9mmDE;IAEE,yDAAA;E5K+mmDJ;AACF;A4KxmmDA;EACE;IACE,eAAA;IACA,iBAAA;E5K0mmDF;E4KxmmDA;IACE,eAAA;IACA,iBAAA;E5K0mmDF;AACF;A4KtmmDA;EACE;IACE,eAAA;IACA,iBAAA;E5KwmmDF;E4KtmmDA;IACE,eAAA;IACA,iBAAA;E5KwmmDF;E4KtmmDA;IACE,eAAA;IACA,iBAAA;E5KwmmDF;AACF;A4KpmmDA;EACE;IACE,eAAA;E5KsmmDF;E4KpmmDA;IACE,eAAA;E5KsmmDF;E4KpmmDA;IACE,eAAA;E5KsmmDF;E4KpmmDA;IACE,eAAA;E5KsmmDF;E4KpmmDA;IACE,eAAA;E5KsmmDF;E4KpmmDA;IACE,eAAA;E5KsmmDF;E4KpmmDA;IACE,eAAA;E5KsmmDF;E4KpmmDA;IACE,eAAA;E5KsmmDF;E4KpmmDA;IACE,eAAA;E5KsmmDF;AACF;A4K/lmDA;EAEI;IAEE,0CAAA;E5K+lmDJ;E4KjmmDE;IAEE,wDAAA;E5KkmmDJ;E4KpmmDE;IAEE,sDAAA;E5KqmmDJ;E4KvmmDE;IAEE,wDAAA;E5KwmmDJ;E4K1mmDE;IAEE,uDAAA;E5K2mmDJ;E4K7mmDE;IAEE,wDAAA;E5K8mmDJ;E4KhnmDE;IAEE,uDAAA;E5KinmDJ;E4KnnmDE;IAEE,wDAAA;E5KonmDJ;E4KtnmDE;IAEE,uDAAA;E5KunmDJ;E4KznmDE;IAEE,wDAAA;E5K0nmDJ;E4K5nmDE;IAEE,uDAAA;E5K6nmDJ;E4K/nmDE;IAEE,wDAAA;E5KgomDJ;E4KlomDE;IAEE,uDAAA;E5KmomDJ;E4KromDE;IAEE,wDAAA;E5KsomDJ;E4KxomDE;IAEE,uDAAA;E5KyomDJ;E4K3omDE;IAEE,wDAAA;E5K4omDJ;E4K9omDE;IAEE,uDAAA;E5K+omDJ;E4KjpmDE;IAEE,wDAAA;E5KkpmDJ;E4KppmDE;IAEE,uDAAA;E5KqpmDJ;E4KvpmDE;IAEE,wDAAA;E5KwpmDJ;E4K1pmDE;IAEE,qDAAA;E5K2pmDJ;E4K7pmDE;IAEE,wDAAA;E5K8pmDJ;E4KhqmDE;IAEE,uDAAA;E5KiqmDJ;E4KnqmDE;IAEE,wDAAA;E5KoqmDJ;E4KtqmDE;IAEE,uDAAA;E5KuqmDJ;E4KzqmDE;IAEE,8CAAA;E5K0qmDJ;E4K5qmDE;IAEE,wDAAA;E5K6qmDJ;E4K/qmDE;IAEE,yDAAA;E5KgrmDJ;E4KlrmDE;IAEE,wDAAA;E5KmrmDJ;E4KrrmDE;IAEE,0DAAA;E5KsrmDJ;E4KxrmDE;IAEE,yDAAA;E5KyrmDJ;E4K3rmDE;IAEE,0DAAA;E5K4rmDJ;E4K9rmDE;IAEE,yDAAA;E5K+rmDJ;E4KjsmDE;IAEE,0DAAA;E5KksmDJ;E4KpsmDE;IAEE,yDAAA;E5KqsmDJ;E4KvsmDE;IAEE,0DAAA;E5KwsmDJ;E4K1smDE;IAEE,yDAAA;E5K2smDJ;E4K7smDE;IAEE,0DAAA;E5K8smDJ;E4KhtmDE;IAEE,yDAAA;E5KitmDJ;E4KntmDE;IAEE,0DAAA;E5KotmDJ;E4KttmDE;IAEE,uDAAA;E5KutmDJ;E4KztmDE;IAEE,0DAAA;E5K0tmDJ;E4K5tmDE;IAEE,yDAAA;E5K6tmDJ;E4K/tmDE;IAEE,0DAAA;E5KgumDJ;E4KlumDE;IAEE,yDAAA;E5KmumDJ;E4KrumDE;IAEE,0DAAA;E5KsumDJ;E4KxumDE;IAEE,yDAAA;E5KyumDJ;E4K3umDE;IAEE,0DAAA;E5K4umDJ;E4K9umDE;IAEE,wDAAA;E5K+umDJ;E4KjvmDE;IAEE,0DAAA;E5KkvmDJ;E4KpvmDE;IAEE,yDAAA;E5KqvmDJ;AACF;A4K3umDA;EAEI;IAEE,2CAAA;E5K2umDJ;E4K7umDE;IAEE,yDAAA;E5K8umDJ;E4KhvmDE;IAEE,uDAAA;E5KivmDJ;E4KnvmDE;IAEE,yDAAA;E5KovmDJ;E4KtvmDE;IAEE,wDAAA;E5KuvmDJ;E4KzvmDE;IAEE,yDAAA;E5K0vmDJ;E4K5vmDE;IAEE,wDAAA;E5K6vmDJ;E4K/vmDE;IAEE,yDAAA;E5KgwmDJ;E4KlwmDE;IAEE,wDAAA;E5KmwmDJ;E4KrwmDE;IAEE,yDAAA;E5KswmDJ;E4KxwmDE;IAEE,wDAAA;E5KywmDJ;E4K3wmDE;IAEE,yDAAA;E5K4wmDJ;E4K9wmDE;IAEE,wDAAA;E5K+wmDJ;E4KjxmDE;IAEE,yDAAA;E5KkxmDJ;E4KpxmDE;IAEE,wDAAA;E5KqxmDJ;E4KvxmDE;IAEE,yDAAA;E5KwxmDJ;E4K1xmDE;IAEE,wDAAA;E5K2xmDJ;E4K7xmDE;IAEE,yDAAA;E5K8xmDJ;E4KhymDE;IAEE,wDAAA;E5KiymDJ;E4KnymDE;IAEE,yDAAA;E5KoymDJ;E4KtymDE;IAEE,sDAAA;E5KuymDJ;E4KzymDE;IAEE,yDAAA;E5K0ymDJ;E4K5ymDE;IAEE,wDAAA;E5K6ymDJ;E4K/ymDE;IAEE,yDAAA;E5KgzmDJ;E4KlzmDE;IAEE,wDAAA;E5KmzmDJ;E4KrzmDE;IAEE,6CAAA;E5KszmDJ;E4KxzmDE;IAEE,uDAAA;E5KyzmDJ;E4K3zmDE;IAEE,wDAAA;E5K4zmDJ;E4K9zmDE;IAEE,uDAAA;E5K+zmDJ;E4Kj0mDE;IAEE,yDAAA;E5Kk0mDJ;E4Kp0mDE;IAEE,wDAAA;E5Kq0mDJ;E4Kv0mDE;IAEE,yDAAA;E5Kw0mDJ;E4K10mDE;IAEE,wDAAA;E5K20mDJ;E4K70mDE;IAEE,yDAAA;E5K80mDJ;E4Kh1mDE;IAEE,wDAAA;E5Ki1mDJ;E4Kn1mDE;IAEE,yDAAA;E5Ko1mDJ;E4Kt1mDE;IAEE,wDAAA;E5Ku1mDJ;E4Kz1mDE;IAEE,yDAAA;E5K01mDJ;E4K51mDE;IAEE,wDAAA;E5K61mDJ;E4K/1mDE;IAEE,yDAAA;E5Kg2mDJ;E4Kl2mDE;IAEE,sDAAA;E5Km2mDJ;E4Kr2mDE;IAEE,yDAAA;E5Ks2mDJ;E4Kx2mDE;IAEE,wDAAA;E5Ky2mDJ;E4K32mDE;IAEE,yDAAA;E5K42mDJ;E4K92mDE;IAEE,wDAAA;E5K+2mDJ;E4Kj3mDE;IAEE,yDAAA;E5Kk3mDJ;E4Kp3mDE;IAEE,wDAAA;E5Kq3mDJ;E4Kv3mDE;IAEE,yDAAA;E5Kw3mDJ;E4K13mDE;IAEE,uDAAA;E5K23mDJ;E4K73mDE;IAEE,yDAAA;E5K83mDJ;E4Kh4mDE;IAEE,wDAAA;E5Ki4mDJ;AACF;A4K13mDA,YAAA;AACA;EACE;IACE,wBAAA;E5K43mDF;E4K13mDA;IACE,8BAAA;E5K43mDF;E4K13mDA;IACE,+BAAA;E5K43mDF;E4K13mDA;IACE,wBAAA;E5K43mDF;AACF;A4Kx3mDA;EACE;IACE,wBAAA;E5K03mDF;E4Kx3mDA;IACE,8BAAA;E5K03mDF;E4Kx3mDA;IACE,+BAAA;E5K03mDF;E4Kx3mDA;IACE,wBAAA;E5K03mDF;AACF;A4Kt3mDA;EACE;IACE,wBAAA;E5Kw3mDF;E4Kt3mDA;IACE,8BAAA;E5Kw3mDF;E4Kt3mDA;IACE,+BAAA;E5Kw3mDF;E4Kt3mDA;IACE,wBAAA;E5Kw3mDF;AACF;A4Kp3mDA;EACE;IACE,wBAAA;E5Ks3mDF;E4Kp3mDA;IACE,8BAAA;E5Ks3mDF;E4Kp3mDA;IACE,+BAAA;E5Ks3mDF;E4Kp3mDA;IACE,wBAAA;E5Ks3mDF;AACF;A4Kl3mDA;EACE;IACE,wBAAA;E5Ko3mDF;E4Kl3mDA;IACE,+BAAA;E5Ko3mDF;E4Kl3mDA;IACE,gCAAA;E5Ko3mDF;E4Kl3mDA;IACE,wBAAA;E5Ko3mDF;AACF;A4Kh3mDA;EACE;IACE,wBAAA;E5Kk3mDF;E4Kh3mDA;IACE,8BAAA;E5Kk3mDF;E4Kh3mDA;IACE,+BAAA;E5Kk3mDF;E4Kh3mDA;IACE,wBAAA;E5Kk3mDF;AACF;A4K92mDA;EACE;IACE,eAAA;IACA,iBAAA;E5Kg3mDF;E4K92mDA;IACE,eAAA;IACA,iBAAA;E5Kg3mDF;E4K92mDA;IACE,eAAA;IACA,iBAAA;E5Kg3mDF;E4K92mDA;IACE,eAAA;IACA,iBAAA;E5Kg3mDF;E4K92mDA;IACE,eAAA;IACA,iBAAA;E5Kg3mDF;E4K92mDA;IACE,eAAA;IACA,iBAAA;E5Kg3mDF;E4K92mDA;IACE,eAAA;IACA,iBAAA;E5Kg3mDF;E4K92mDA;IACE,eAAA;IACA,iBAAA;E5Kg3mDF;E4K92mDA;IACE,eAAA;IACA,iBAAA;E5Kg3mDF;AACF;A4K52mDA;EACE;IACE,wBAAA;E5K82mDF;E4K52mDA;IACE,8BAAA;E5K82mDF;E4K52mDA;IACE,+BAAA;E5K82mDF;E4K52mDA;IACE,wBAAA;E5K82mDF;AACF;A4K12mDA;EACE;IACE,iBAAA;IACA,mBAAA;E5K42mDF;E4K12mDA;IACE,eAAA;IACA,iBAAA;E5K42mDF;E4K12mDA;IACE,iBAAA;IACA,mBAAA;E5K42mDF;AACF;A4Kx2mDA;EACE;IACE,wBAAA;E5K02mDF;E4Kx2mDA;IACE,gCAAA;E5K02mDF;E4Kx2mDA;IACE,gCAAA;E5K02mDF;AACF;A4Kt2mDA;EACE;IACE,gCAAA;E5Kw2mDF;E4Kt2mDA;IACE,+BAAA;E5Kw2mDF;E4Kt2mDA;IACE,+BAAA;E5Kw2mDF;AACF;A4Kp2mDA;EACE;IACE,8BAAA;E5Ks2mDF;E4Kp2mDA;IACE,8BAAA;E5Ks2mDF;AACF;A4Kl2mDA;EACE;IACE,+BAAA;E5Ko2mDF;E4Kl2mDA;IACE,+BAAA;E5Ko2mDF;AACF;A4Kh2mDA;EACE;IACE,wBAAA;E5Kk2mDF;E4Kh2mDA;IACE,8BAAA;E5Kk2mDF;E4Kh2mDA;IACE,+BAAA;E5Kk2mDF;E4Kh2mDA;IACE,wBAAA;E5Kk2mDF;AACF;A6KjuoDA;;;;;;CAAA;AAQA;EACC,sBAAA;EACA,6CAAA;EACA,uPAAA;EACA,mBAAA;EACA,kBAAA;A7KkuoDD;A6K9toDA;EACC,iCAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,sCAAA;EACA,mCAAA;EACA,kCAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA;EACC,gBAAA;A7KguoDD;;A6K7toDA,YAAA;AAEA;EACC,uBAAA;EACA,mBAAA;EACA,oBAAA;A7K+toDD;;A6K5toDA;EACC,cAAA;A7K+toDD;;A6K5toDA;EACC,cAAA;A7K+toDD;;A6K5toDA;EACC,cAAA;A7K+toDD;;A6K5toDA;EACC,cAAA;A7K+toDD;;A6K5toDA;EACC,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;A7K+toDD;;A6K5toDA,oBAAA;AAEA,oBAAA;AAEA;EACC,eAAA;EACA,yBAAA;EACA,qBAAA;A7K6toDD;A6K5toDC;EACC,kBAAA;A7K8toDF;;A6K1toDA;EACC,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;A7K6toDD;;A6K1toDA,YAAA;AAEA;EACC,qBAAA;EAEA,4CAAA;A7K4toDD;A6K5soDA;EACC;IAEC,uBAAA;E7KytoDA;E6KttoDD;IAEC,yBAAA;E7KwtoDA;AACF;A8K7i5DA;EACE,wBAAA;EACA,wBAAA;EACA,4BAAA;A9K+i5DF;;A8K5i5DA;EAEE,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;A9K8i5DF;A8K7i5DE;EACE,YAAA;A9K+i5DJ;A8K7i5DE;EACE,UAAA;A9K+i5DJ;;A8K1i5DE;EACE,0DAAA;A9K6i5DJ;A8K5i5DI;EACE,0DAAA;A9K8i5DN;;A8Kjj5DE;EACE,0DAAA;A9Koj5DJ;A8Knj5DI;EACE,0DAAA;A9Kqj5DN;;A8Kxj5DE;EACE,0DAAA;A9K2j5DJ;A8K1j5DI;EACE,0DAAA;A9K4j5DN;;A8K/j5DE;EACE,0DAAA;A9Kkk5DJ;A8Kjk5DI;EACE,0DAAA;A9Kmk5DN;;A8Ktk5DE;EACE,0DAAA;A9Kyk5DJ;A8Kxk5DI;EACE,0DAAA;A9K0k5DN;;A8K7k5DE;EACE,0DAAA;A9Kgl5DJ;A8K/k5DI;EACE,0DAAA;A9Kil5DN;;A8Kpl5DE;EACE,0DAAA;A9Kul5DJ;A8Ktl5DI;EACE,0DAAA;A9Kwl5DN;;A8K3l5DE;EACE,0DAAA;A9K8l5DJ;A8K7l5DI;EACE,0DAAA;A9K+l5DN;;A8Klm5DE;EACE,0DAAA;A9Kqm5DJ;A8Kpm5DI;EACE,0DAAA;A9Ksm5DN;;A8Kzm5DE;EACE,0DAAA;A9K4m5DJ;A8K3m5DI;EACE,0DAAA;A9K6m5DN;;A8Khn5DE;EACE,0DAAA;A9Kmn5DJ;A8Kln5DI;EACE,0DAAA;A9Kon5DN;;A8Kvn5DE;EACE,0DAAA;A9K0n5DJ;A8Kzn5DI;EACE,0DAAA;A9K2n5DN;;A8K9n5DE;EACE,0DAAA;A9Kio5DJ;A8Kho5DI;EACE,0DAAA;A9Kko5DN;;A8Kro5DE;EACE,0DAAA;A9Kwo5DJ;A8Kvo5DI;EACE,0DAAA;A9Kyo5DN;;A8K5o5DE;EACE,0DAAA;A9K+o5DJ;A8K9o5DI;EACE,0DAAA;A9Kgp5DN;;A8Knp5DE;EACE,0DAAA;A9Ksp5DJ;A8Krp5DI;EACE,0DAAA;A9Kup5DN;;A8K1p5DE;EACE,0DAAA;A9K6p5DJ;A8K5p5DI;EACE,0DAAA;A9K8p5DN;;A8Kjq5DE;EACE,0DAAA;A9Koq5DJ;A8Knq5DI;EACE,0DAAA;A9Kqq5DN;;A8Kxq5DE;EACE,0DAAA;A9K2q5DJ;A8K1q5DI;EACE,0DAAA;A9K4q5DN;;A8K/q5DE;EACE,0DAAA;A9Kkr5DJ;A8Kjr5DI;EACE,0DAAA;A9Kmr5DN;;A8Ktr5DE;EACE,0DAAA;A9Kyr5DJ;A8Kxr5DI;EACE,0DAAA;A9K0r5DN;;A8K7r5DE;EACE,0DAAA;A9Kgs5DJ;A8K/r5DI;EACE,0DAAA;A9Kis5DN;;A8Kps5DE;EACE,0DAAA;A9Kus5DJ;A8Kts5DI;EACE,0DAAA;A9Kws5DN;;A8K3s5DE;EACE,0DAAA;A9K8s5DJ;A8K7s5DI;EACE,0DAAA;A9K+s5DN;;A8Klt5DE;EACE,0DAAA;A9Kqt5DJ;A8Kpt5DI;EACE,0DAAA;A9Kst5DN;;A8Kzt5DE;EACE,0DAAA;A9K4t5DJ;A8K3t5DI;EACE,0DAAA;A9K6t5DN;;A8Khu5DE;EACE,0DAAA;A9Kmu5DJ;A8Klu5DI;EACE,0DAAA;A9Kou5DN;;A8Kvu5DE;EACE,0DAAA;A9K0u5DJ;A8Kzu5DI;EACE,0DAAA;A9K2u5DN;;A8K9u5DE;EACE,0DAAA;A9Kiv5DJ;A8Khv5DI;EACE,0DAAA;A9Kkv5DN;;A8Krv5DE;EACE,0DAAA;A9Kwv5DJ;A8Kvv5DI;EACE,0DAAA;A9Kyv5DN;;A8K5v5DE;EACE,0DAAA;A9K+v5DJ;A8K9v5DI;EACE,0DAAA;A9Kgw5DN;;A8Knw5DE;EACE,0DAAA;A9Ksw5DJ;A8Krw5DI;EACE,0DAAA;A9Kuw5DN;;A8K1w5DE;EACE,0DAAA;A9K6w5DJ;A8K5w5DI;EACE,0DAAA;A9K8w5DN;;A8Kjx5DE;EACE,0DAAA;A9Kox5DJ;A8Knx5DI;EACE,0DAAA;A9Kqx5DN;;A8Kxx5DE;EACE,0DAAA;A9K2x5DJ;A8K1x5DI;EACE,0DAAA;A9K4x5DN;;A8K/x5DE;EACE,0DAAA;A9Kky5DJ;A8Kjy5DI;EACE,0DAAA;A9Kmy5DN;;A8Kty5DE;EACE,0DAAA;A9Kyy5DJ;A8Kxy5DI;EACE,0DAAA;A9K0y5DN;;A8K7y5DE;EACE,0DAAA;A9Kgz5DJ;A8K/y5DI;EACE,0DAAA;A9Kiz5DN;;A8Kpz5DE;EACE,0DAAA;A9Kuz5DJ;A8Ktz5DI;EACE,0DAAA;A9Kwz5DN;;A8K3z5DE;EACE,0DAAA;A9K8z5DJ;A8K7z5DI;EACE,0DAAA;A9K+z5DN;;A8Kl05DE;EACE,0DAAA;A9Kq05DJ;A8Kp05DI;EACE,0DAAA;A9Ks05DN;;A8Kz05DE;EACE,0DAAA;A9K405DJ;A8K305DI;EACE,0DAAA;A9K605DN;;A8Kh15DE;EACE,0DAAA;A9Km15DJ;A8Kl15DI;EACE,0DAAA;A9Ko15DN;;A8Kv15DE;EACE,0DAAA;A9K015DJ;A8Kz15DI;EACE,0DAAA;A9K215DN;;A8K915DE;EACE,0DAAA;A9Ki25DJ;A8Kh25DI;EACE,0DAAA;A9Kk25DN;;A8Kr25DE;EACE,0DAAA;A9Kw25DJ;A8Kv25DI;EACE,0DAAA;A9Ky25DN;;A8K525DE;EACE,0DAAA;A9K+25DJ;A8K925DI;EACE,0DAAA;A9Kg35DN;;A8Kn35DE;EACE,0DAAA;A9Ks35DJ;A8Kr35DI;EACE,0DAAA;A9Ku35DN;;A8K135DE;EACE,0DAAA;A9K635DJ;A8K535DI;EACE,0DAAA;A9K835DN;;A8Kj45DE;EACE,0DAAA;A9Ko45DJ;A8Kn45DI;EACE,0DAAA;A9Kq45DN;;A8Kx45DE;EACE,0DAAA;A9K245DJ;A8K145DI;EACE,0DAAA;A9K445DN;;A8K/45DE;EACE,0DAAA;A9Kk55DJ;A8Kj55DI;EACE,0DAAA;A9Km55DN;;A8Kt55DE;EACE,0DAAA;A9Ky55DJ;A8Kx55DI;EACE,0DAAA;A9K055DN;;A8K755DE;EACE,0DAAA;A9Kg65DJ;A8K/55DI;EACE,0DAAA;A9Ki65DN;;A8Kp65DE;EACE,0DAAA;A9Ku65DJ;A8Kt65DI;EACE,0DAAA;A9Kw65DN;;A8K365DE;EACE,0DAAA;A9K865DJ;A8K765DI;EACE,0DAAA;A9K+65DN;;A8Kl75DE;EACE,0DAAA;A9Kq75DJ;A8Kp75DI;EACE,0DAAA;A9Ks75DN;;A8Kz75DE;EACE,2DAAA;A9K475DJ;A8K375DI;EACE,2DAAA;A9K675DN;;A8Kh85DE;EACE,2DAAA;A9Km85DJ;A8Kl85DI;EACE,2DAAA;A9Ko85DN;;A8Kv85DE;EACE,2DAAA;A9K085DJ;A8Kz85DI;EACE,2DAAA;A9K285DN;;A8K985DE;EACE,2DAAA;A9Ki95DJ;A8Kh95DI;EACE,2DAAA;A9Kk95DN;;A8Kr95DE;EACE,2DAAA;A9Kw95DJ;A8Kv95DI;EACE,2DAAA;A9Ky95DN;;A8K595DE;EACE,2DAAA;A9K+95DJ;A8K995DI;EACE,2DAAA;A9Kg+5DN;;A8Kn+5DE;EACE,2DAAA;A9Ks+5DJ;A8Kr+5DI;EACE,2DAAA;A9Ku+5DN;;A8K1+5DE;EACE,2DAAA;A9K6+5DJ;A8K5+5DI;EACE,2DAAA;A9K8+5DN;;A8Kj/5DE;EACE,2DAAA;A9Ko/5DJ;A8Kn/5DI;EACE,2DAAA;A9Kq/5DN;;A8Kx/5DE;EACE,2DAAA;A9K2/5DJ;A8K1/5DI;EACE,2DAAA;A9K4/5DN;;A8K//5DE;EACE,2DAAA;A9Kkg6DJ;A8Kjg6DI;EACE,2DAAA;A9Kmg6DN;;A8Ktg6DE;EACE,2DAAA;A9Kyg6DJ;A8Kxg6DI;EACE,2DAAA;A9K0g6DN;;A8K7g6DE;EACE,2DAAA;A9Kgh6DJ;A8K/g6DI;EACE,2DAAA;A9Kih6DN;;A8Kph6DE;EACE,2DAAA;A9Kuh6DJ;A8Kth6DI;EACE,2DAAA;A9Kwh6DN;;A8K3h6DE;EACE,2DAAA;A9K8h6DJ;A8K7h6DI;EACE,2DAAA;A9K+h6DN;;A8Kli6DE;EACE,2DAAA;A9Kqi6DJ;A8Kpi6DI;EACE,2DAAA;A9Ksi6DN;;A8Kzi6DE;EACE,2DAAA;A9K4i6DJ;A8K3i6DI;EACE,2DAAA;A9K6i6DN;;A8Khj6DE;EACE,2DAAA;A9Kmj6DJ;A8Klj6DI;EACE,2DAAA;A9Koj6DN;;A8Kvj6DE;EACE,2DAAA;A9K0j6DJ;A8Kzj6DI;EACE,2DAAA;A9K2j6DN;;A8K9j6DE;EACE,2DAAA;A9Kik6DJ;A8Khk6DI;EACE,2DAAA;A9Kkk6DN;;A8Krk6DE;EACE,2DAAA;A9Kwk6DJ;A8Kvk6DI;EACE,2DAAA;A9Kyk6DN;;A8K5k6DE;EACE,2DAAA;A9K+k6DJ;A8K9k6DI;EACE,2DAAA;A9Kgl6DN;;A8Knl6DE;EACE,2DAAA;A9Ksl6DJ;A8Krl6DI;EACE,2DAAA;A9Kul6DN;;A8K1l6DE;EACE,2DAAA;A9K6l6DJ;A8K5l6DI;EACE,2DAAA;A9K8l6DN;;A8Kjm6DE;EACE,2DAAA;A9Kom6DJ;A8Knm6DI;EACE,2DAAA;A9Kqm6DN;;A8Kxm6DE;EACE,2DAAA;A9K2m6DJ;A8K1m6DI;EACE,2DAAA;A9K4m6DN;;A8K/m6DE;EACE,2DAAA;A9Kkn6DJ;A8Kjn6DI;EACE,2DAAA;A9Kmn6DN;;A8Ktn6DE;EACE,2DAAA;A9Kyn6DJ;A8Kxn6DI;EACE,2DAAA;A9K0n6DN;;A8K7n6DE;EACE,2DAAA;A9Kgo6DJ;A8K/n6DI;EACE,2DAAA;A9Kio6DN;;A8Kpo6DE;EACE,2DAAA;A9Kuo6DJ;A8Kto6DI;EACE,2DAAA;A9Kwo6DN;;A8K3o6DE;EACE,2DAAA;A9K8o6DJ;A8K7o6DI;EACE,2DAAA;A9K+o6DN;;A8Klp6DE;EACE,2DAAA;A9Kqp6DJ;A8Kpp6DI;EACE,2DAAA;A9Ksp6DN;;A8Kzp6DE;EACE,2DAAA;A9K4p6DJ;A8K3p6DI;EACE,2DAAA;A9K6p6DN;;A8Khq6DE;EACE,2DAAA;A9Kmq6DJ;A8Klq6DI;EACE,2DAAA;A9Koq6DN;;A8Kvq6DE;EACE,2DAAA;A9K0q6DJ;A8Kzq6DI;EACE,2DAAA;A9K2q6DN;;A8K9q6DE;EACE,2DAAA;A9Kir6DJ;A8Khr6DI;EACE,2DAAA;A9Kkr6DN;;A8Krr6DE;EACE,2DAAA;A9Kwr6DJ;A8Kvr6DI;EACE,2DAAA;A9Kyr6DN;;A8K5r6DE;EACE,2DAAA;A9K+r6DJ;A8K9r6DI;EACE,2DAAA;A9Kgs6DN;;A8Kns6DE;EACE,2DAAA;A9Kss6DJ;A8Krs6DI;EACE,2DAAA;A9Kus6DN;;A8K1s6DE;EACE,2DAAA;A9K6s6DJ;A8K5s6DI;EACE,2DAAA;A9K8s6DN;;A8Kjt6DE;EACE,2DAAA;A9Kot6DJ;A8Knt6DI;EACE,2DAAA;A9Kqt6DN;;A8Kxt6DE;EACE,2DAAA;A9K2t6DJ;A8K1t6DI;EACE,2DAAA;A9K4t6DN;;A8K/t6DE;EACE,2DAAA;A9Kku6DJ;A8Kju6DI;EACE,2DAAA;A9Kmu6DN;;A8Ktu6DE;EACE,2DAAA;A9Kyu6DJ;A8Kxu6DI;EACE,2DAAA;A9K0u6DN;;A8K7u6DE;EACE,2DAAA;A9Kgv6DJ;A8K/u6DI;EACE,2DAAA;A9Kiv6DN;;A8Kpv6DE;EACE,2DAAA;A9Kuv6DJ;A8Ktv6DI;EACE,2DAAA;A9Kwv6DN;;A8K3v6DE;EACE,2DAAA;A9K8v6DJ;A8K7v6DI;EACE,2DAAA;A9K+v6DN;;A8Klw6DE;EACE,2DAAA;A9Kqw6DJ;A8Kpw6DI;EACE,2DAAA;A9Ksw6DN;;A8Kzw6DE;EACE,2DAAA;A9K4w6DJ;A8K3w6DI;EACE,2DAAA;A9K6w6DN;;A8Khx6DE;EACE,2DAAA;A9Kmx6DJ;A8Klx6DI;EACE,2DAAA;A9Kox6DN;;A8Kvx6DE;EACE,2DAAA;A9K0x6DJ;A8Kzx6DI;EACE,2DAAA;A9K2x6DN;;A8K9x6DE;EACE,2DAAA;A9Kiy6DJ;A8Khy6DI;EACE,2DAAA;A9Kky6DN;;A8Kry6DE;EACE,2DAAA;A9Kwy6DJ;A8Kvy6DI;EACE,2DAAA;A9Kyy6DN;;A8K5y6DE;EACE,2DAAA;A9K+y6DJ;A8K9y6DI;EACE,2DAAA;A9Kgz6DN;;A8Knz6DE;EACE,2DAAA;A9Ksz6DJ;A8Krz6DI;EACE,2DAAA;A9Kuz6DN;;A8K1z6DE;EACE,2DAAA;A9K6z6DJ;A8K5z6DI;EACE,2DAAA;A9K8z6DN;;A8Kj06DE;EACE,2DAAA;A9Ko06DJ;A8Kn06DI;EACE,2DAAA;A9Kq06DN;;A8Kx06DE;EACE,2DAAA;A9K206DJ;A8K106DI;EACE,2DAAA;A9K406DN;;A8K/06DE;EACE,2DAAA;A9Kk16DJ;A8Kj16DI;EACE,2DAAA;A9Km16DN;;A8Kt16DE;EACE,2DAAA;A9Ky16DJ;A8Kx16DI;EACE,2DAAA;A9K016DN;;A8K716DE;EACE,2DAAA;A9Kg26DJ;A8K/16DI;EACE,2DAAA;A9Ki26DN;;A8Kp26DE;EACE,2DAAA;A9Ku26DJ;A8Kt26DI;EACE,2DAAA;A9Kw26DN;;A8K326DE;EACE,2DAAA;A9K826DJ;A8K726DI;EACE,2DAAA;A9K+26DN;;A8Kl36DE;EACE,2DAAA;A9Kq36DJ;A8Kp36DI;EACE,2DAAA;A9Ks36DN;;A8Kz36DE;EACE,2DAAA;A9K436DJ;A8K336DI;EACE,2DAAA;A9K636DN;;A8Kh46DE;EACE,2DAAA;A9Km46DJ;A8Kl46DI;EACE,2DAAA;A9Ko46DN;;A8Kv46DE;EACE,2DAAA;A9K046DJ;A8Kz46DI;EACE,2DAAA;A9K246DN;;A8K946DE;EACE,2DAAA;A9Ki56DJ;A8Kh56DI;EACE,2DAAA;A9Kk56DN;;A8Kr56DE;EACE,2DAAA;A9Kw56DJ;A8Kv56DI;EACE,2DAAA;A9Ky56DN;;A8K556DE;EACE,2DAAA;A9K+56DJ;A8K956DI;EACE,2DAAA;A9Kg66DN;;A8Kn66DE;EACE,2DAAA;A9Ks66DJ;A8Kr66DI;EACE,2DAAA;A9Ku66DN;;A8K166DE;EACE,2DAAA;A9K666DJ;A8K566DI;EACE,2DAAA;A9K866DN;;A8Kj76DE;EACE,2DAAA;A9Ko76DJ;A8Kn76DI;EACE,2DAAA;A9Kq76DN;;A8Kx76DE;EACE,2DAAA;A9K276DJ;A8K176DI;EACE,2DAAA;A9K476DN;;A8K/76DE;EACE,2DAAA;A9Kk86DJ;A8Kj86DI;EACE,2DAAA;A9Km86DN;;A8Kt86DE;EACE,2DAAA;A9Ky86DJ;A8Kx86DI;EACE,2DAAA;A9K086DN;;A8K786DE;EACE,2DAAA;A9Kg96DJ;A8K/86DI;EACE,2DAAA;A9Ki96DN;;A8Kp96DE;EACE,2DAAA;A9Ku96DJ;A8Kt96DI;EACE,2DAAA;A9Kw96DN;;A8K396DE;EACE,2DAAA;A9K896DJ;A8K796DI;EACE,2DAAA;A9K+96DN;;A8Kl+6DE;EACE,2DAAA;A9Kq+6DJ;A8Kp+6DI;EACE,2DAAA;A9Ks+6DN;;A8Kz+6DE;EACE,2DAAA;A9K4+6DJ;A8K3+6DI;EACE,2DAAA;A9K6+6DN;;A8Kh/6DE;EACE,2DAAA;A9Km/6DJ;A8Kl/6DI;EACE,2DAAA;A9Ko/6DN;;A8Kv/6DE;EACE,2DAAA;A9K0/6DJ;A8Kz/6DI;EACE,2DAAA;A9K2/6DN;;A8K9/6DE;EACE,2DAAA;A9Kig7DJ;A8Khg7DI;EACE,2DAAA;A9Kkg7DN;;A8Krg7DE;EACE,2DAAA;A9Kwg7DJ;A8Kvg7DI;EACE,2DAAA;A9Kyg7DN;;A8K5g7DE;EACE,2DAAA;A9K+g7DJ;A8K9g7DI;EACE,2DAAA;A9Kgh7DN;;A8Knh7DE;EACE,2DAAA;A9Ksh7DJ;A8Krh7DI;EACE,2DAAA;A9Kuh7DN;;A8K1h7DE;EACE,2DAAA;A9K6h7DJ;A8K5h7DI;EACE,2DAAA;A9K8h7DN;;A8Kji7DE;EACE,2DAAA;A9Koi7DJ;A8Kni7DI;EACE,2DAAA;A9Kqi7DN;;A8Kxi7DE;EACE,2DAAA;A9K2i7DJ;A8K1i7DI;EACE,2DAAA;A9K4i7DN;;A8K/i7DE;EACE,2DAAA;A9Kkj7DJ;A8Kjj7DI;EACE,2DAAA;A9Kmj7DN;;A8Ktj7DE;EACE,2DAAA;A9Kyj7DJ;A8Kxj7DI;EACE,2DAAA;A9K0j7DN;;A8K7j7DE;EACE,2DAAA;A9Kgk7DJ;A8K/j7DI;EACE,2DAAA;A9Kik7DN;;A8Kpk7DE;EACE,2DAAA;A9Kuk7DJ;A8Ktk7DI;EACE,2DAAA;A9Kwk7DN;;A8K3k7DE;EACE,2DAAA;A9K8k7DJ;A8K7k7DI;EACE,2DAAA;A9K+k7DN;;A8Kll7DE;EACE,2DAAA;A9Kql7DJ;A8Kpl7DI;EACE,2DAAA;A9Ksl7DN;;A8Kzl7DE;EACE,2DAAA;A9K4l7DJ;A8K3l7DI;EACE,2DAAA;A9K6l7DN;;A8Khm7DE;EACE,2DAAA;A9Kmm7DJ;A8Klm7DI;EACE,2DAAA;A9Kom7DN;;A8Kvm7DE;EACE,2DAAA;A9K0m7DJ;A8Kzm7DI;EACE,2DAAA;A9K2m7DN;;A8K9m7DE;EACE,2DAAA;A9Kin7DJ;A8Khn7DI;EACE,2DAAA;A9Kkn7DN;;A8Krn7DE;EACE,2DAAA;A9Kwn7DJ;A8Kvn7DI;EACE,2DAAA;A9Kyn7DN;;A8K5n7DE;EACE,2DAAA;A9K+n7DJ;A8K9n7DI;EACE,2DAAA;A9Kgo7DN;;A8Kno7DE;EACE,2DAAA;A9Kso7DJ;A8Kro7DI;EACE,2DAAA;A9Kuo7DN;;A8K1o7DE;EACE,2DAAA;A9K6o7DJ;A8K5o7DI;EACE,2DAAA;A9K8o7DN;;A8Kjp7DE;EACE,2DAAA;A9Kop7DJ;A8Knp7DI;EACE,2DAAA;A9Kqp7DN;;A8Kxp7DE;EACE,2DAAA;A9K2p7DJ;A8K1p7DI;EACE,2DAAA;A9K4p7DN;;A8K/p7DE;EACE,2DAAA;A9Kkq7DJ;A8Kjq7DI;EACE,2DAAA;A9Kmq7DN;;A8Ktq7DE;EACE,2DAAA;A9Kyq7DJ;A8Kxq7DI;EACE,2DAAA;A9K0q7DN;;A8K7q7DE;EACE,2DAAA;A9Kgr7DJ;A8K/q7DI;EACE,2DAAA;A9Kir7DN;;A8Kpr7DE;EACE,2DAAA;A9Kur7DJ;A8Ktr7DI;EACE,2DAAA;A9Kwr7DN;;A8K3r7DE;EACE,2DAAA;A9K8r7DJ;A8K7r7DI;EACE,2DAAA;A9K+r7DN;;A8Kls7DE;EACE,2DAAA;A9Kqs7DJ;A8Kps7DI;EACE,2DAAA;A9Kss7DN;;A8Kzs7DE;EACE,2DAAA;A9K4s7DJ;A8K3s7DI;EACE,2DAAA;A9K6s7DN;;A8Kht7DE;EACE,2DAAA;A9Kmt7DJ;A8Klt7DI;EACE,2DAAA;A9Kot7DN;;A8Kvt7DE;EACE,2DAAA;A9K0t7DJ;A8Kzt7DI;EACE,2DAAA;A9K2t7DN;;A8K9t7DE;EACE,2DAAA;A9Kiu7DJ;A8Khu7DI;EACE,2DAAA;A9Kku7DN;;A8Kru7DE;EACE,2DAAA;A9Kwu7DJ;A8Kvu7DI;EACE,2DAAA;A9Kyu7DN;;A8K5u7DE;EACE,2DAAA;A9K+u7DJ;A8K9u7DI;EACE,2DAAA;A9Kgv7DN;;A8Knv7DE;EACE,2DAAA;A9Ksv7DJ;A8Krv7DI;EACE,2DAAA;A9Kuv7DN;;A8K1v7DE;EACE,2DAAA;A9K6v7DJ;A8K5v7DI;EACE,2DAAA;A9K8v7DN;;A8Kjw7DE;EACE,2DAAA;A9Kow7DJ;A8Knw7DI;EACE,2DAAA;A9Kqw7DN;;A8Kxw7DE;EACE,2DAAA;A9K2w7DJ;A8K1w7DI;EACE,2DAAA;A9K4w7DN;;A8K/w7DE;EACE,2DAAA;A9Kkx7DJ;A8Kjx7DI;EACE,2DAAA;A9Kmx7DN;;A8Ktx7DE;EACE,2DAAA;A9Kyx7DJ;A8Kxx7DI;EACE,2DAAA;A9K0x7DN;;A8K7x7DE;EACE,2DAAA;A9Kgy7DJ;A8K/x7DI;EACE,2DAAA;A9Kiy7DN;;A8Kpy7DE;EACE,2DAAA;A9Kuy7DJ;A8Kty7DI;EACE,2DAAA;A9Kwy7DN;;A8K3y7DE;EACE,2DAAA;A9K8y7DJ;A8K7y7DI;EACE,2DAAA;A9K+y7DN;;A8Klz7DE;EACE,2DAAA;A9Kqz7DJ;A8Kpz7DI;EACE,2DAAA;A9Ksz7DN;;A8Kzz7DE;EACE,2DAAA;A9K4z7DJ;A8K3z7DI;EACE,2DAAA;A9K6z7DN;;A8Kh07DE;EACE,2DAAA;A9Km07DJ;A8Kl07DI;EACE,2DAAA;A9Ko07DN;;A8Kv07DE;EACE,2DAAA;A9K007DJ;A8Kz07DI;EACE,2DAAA;A9K207DN;;A8K907DE;EACE,2DAAA;A9Ki17DJ;A8Kh17DI;EACE,2DAAA;A9Kk17DN;;A8Kr17DE;EACE,2DAAA;A9Kw17DJ;A8Kv17DI;EACE,2DAAA;A9Ky17DN;;A8K517DE;EACE,2DAAA;A9K+17DJ;A8K917DI;EACE,2DAAA;A9Kg27DN;;A8Kn27DE;EACE,2DAAA;A9Ks27DJ;A8Kr27DI;EACE,2DAAA;A9Ku27DN;;A8K127DE;EACE,2DAAA;A9K627DJ;A8K527DI;EACE,2DAAA;A9K827DN;;A8Kj37DE;EACE,2DAAA;A9Ko37DJ;A8Kn37DI;EACE,2DAAA;A9Kq37DN;;A8Kx37DE;EACE,2DAAA;A9K237DJ;A8K137DI;EACE,2DAAA;A9K437DN;;A8K/37DE;EACE,2DAAA;A9Kk47DJ;A8Kj47DI;EACE,2DAAA;A9Km47DN;;A8Kt47DE;EACE,2DAAA;A9Ky47DJ;A8Kx47DI;EACE,2DAAA;A9K047DN;;A8K747DE;EACE,2DAAA;A9Kg57DJ;A8K/47DI;EACE,2DAAA;A9Ki57DN;;A8Kp57DE;EACE,2DAAA;A9Ku57DJ;A8Kt57DI;EACE,2DAAA;A9Kw57DN;;A8K357DE;EACE,2DAAA;A9K857DJ;A8K757DI;EACE,2DAAA;A9K+57DN;;A8Kl67DE;EACE,2DAAA;A9Kq67DJ;A8Kp67DI;EACE,2DAAA;A9Ks67DN;;A8Kz67DE;EACE,2DAAA;A9K467DJ;A8K367DI;EACE,2DAAA;A9K667DN;;A8Kh77DE;EACE,2DAAA;A9Km77DJ;A8Kl77DI;EACE,2DAAA;A9Ko77DN;;A8Kv77DE;EACE,2DAAA;A9K077DJ;A8Kz77DI;EACE,2DAAA;A9K277DN;;A8K977DE;EACE,2DAAA;A9Ki87DJ;A8Kh87DI;EACE,2DAAA;A9Kk87DN;;A8Kr87DE;EACE,2DAAA;A9Kw87DJ;A8Kv87DI;EACE,2DAAA;A9Ky87DN;;A8K587DE;EACE,2DAAA;A9K+87DJ;A8K987DI;EACE,2DAAA;A9Kg97DN;;A8Kn97DE;EACE,2DAAA;A9Ks97DJ;A8Kr97DI;EACE,2DAAA;A9Ku97DN;;A8K197DE;EACE,2DAAA;A9K697DJ;A8K597DI;EACE,2DAAA;A9K897DN;;A8Kj+7DE;EACE,2DAAA;A9Ko+7DJ;A8Kn+7DI;EACE,2DAAA;A9Kq+7DN;;A8Kx+7DE;EACE,2DAAA;A9K2+7DJ;A8K1+7DI;EACE,2DAAA;A9K4+7DN;;A8K/+7DE;EACE,2DAAA;A9Kk/7DJ;A8Kj/7DI;EACE,2DAAA;A9Km/7DN;;A8Kt/7DE;EACE,2DAAA;A9Ky/7DJ;A8Kx/7DI;EACE,2DAAA;A9K0/7DN;;A8K7/7DE;EACE,2DAAA;A9Kgg8DJ;A8K//7DI;EACE,2DAAA;A9Kig8DN;;A8Kpg8DE;EACE,2DAAA;A9Kug8DJ;A8Ktg8DI;EACE,2DAAA;A9Kwg8DN;;A8K3g8DE;EACE,2DAAA;A9K8g8DJ;A8K7g8DI;EACE,2DAAA;A9K+g8DN;;A8Klh8DE;EACE,2DAAA;A9Kqh8DJ;A8Kph8DI;EACE,2DAAA;A9Ksh8DN;;A8Kzh8DE;EACE,2DAAA;A9K4h8DJ;A8K3h8DI;EACE,2DAAA;A9K6h8DN;;A8Khi8DE;EACE,2DAAA;A9Kmi8DJ;A8Kli8DI;EACE,2DAAA;A9Koi8DN;;A8Kvi8DE;EACE,2DAAA;A9K0i8DJ;A8Kzi8DI;EACE,2DAAA;A9K2i8DN;;A8K9i8DE;EACE,2DAAA;A9Kij8DJ;A8Khj8DI;EACE,2DAAA;A9Kkj8DN;;A8Krj8DE;EACE,2DAAA;A9Kwj8DJ;A8Kvj8DI;EACE,2DAAA;A9Kyj8DN;;A8K5j8DE;EACE,2DAAA;A9K+j8DJ;A8K9j8DI;EACE,2DAAA;A9Kgk8DN;;A8Knk8DE;EACE,2DAAA;A9Ksk8DJ;A8Krk8DI;EACE,2DAAA;A9Kuk8DN;;A8K1k8DE;EACE,2DAAA;A9K6k8DJ;A8K5k8DI;EACE,2DAAA;A9K8k8DN;;A8Kjl8DE;EACE,2DAAA;A9Kol8DJ;A8Knl8DI;EACE,2DAAA;A9Kql8DN;;A8Kxl8DE;EACE,2DAAA;A9K2l8DJ;A8K1l8DI;EACE,2DAAA;A9K4l8DN;;A8K/l8DE;EACE,2DAAA;A9Kkm8DJ;A8Kjm8DI;EACE,2DAAA;A9Kmm8DN;;A8Ktm8DE;EACE,2DAAA;A9Kym8DJ;A8Kxm8DI;EACE,2DAAA;A9K0m8DN;;A8K7m8DE;EACE,2DAAA;A9Kgn8DJ;A8K/m8DI;EACE,2DAAA;A9Kin8DN;;A8Kpn8DE;EACE,2DAAA;A9Kun8DJ;A8Ktn8DI;EACE,2DAAA;A9Kwn8DN;;A8K3n8DE;EACE,2DAAA;A9K8n8DJ;A8K7n8DI;EACE,2DAAA;A9K+n8DN;;A8Klo8DE;EACE,2DAAA;A9Kqo8DJ;A8Kpo8DI;EACE,2DAAA;A9Kso8DN;;A8Kzo8DE;EACE,2DAAA;A9K4o8DJ;A8K3o8DI;EACE,2DAAA;A9K6o8DN;;A8Khp8DE;EACE,2DAAA;A9Kmp8DJ;A8Klp8DI;EACE,2DAAA;A9Kop8DN;;A8Kvp8DE;EACE,2DAAA;A9K0p8DJ;A8Kzp8DI;EACE,2DAAA;A9K2p8DN;;A8K9p8DE;EACE,2DAAA;A9Kiq8DJ;A8Khq8DI;EACE,2DAAA;A9Kkq8DN;;A8Krq8DE;EACE,2DAAA;A9Kwq8DJ;A8Kvq8DI;EACE,2DAAA;A9Kyq8DN;;A8K5q8DE;EACE,2DAAA;A9K+q8DJ;A8K9q8DI;EACE,2DAAA;A9Kgr8DN;;A8Knr8DE;EACE,2DAAA;A9Ksr8DJ;A8Krr8DI;EACE,2DAAA;A9Kur8DN;;A8K1r8DE;EACE,2DAAA;A9K6r8DJ;A8K5r8DI;EACE,2DAAA;A9K8r8DN;;A8Kjs8DE;EACE,2DAAA;A9Kos8DJ;A8Kns8DI;EACE,2DAAA;A9Kqs8DN;;A8Kxs8DE;EACE,2DAAA;A9K2s8DJ;A8K1s8DI;EACE,2DAAA;A9K4s8DN;;A8K/s8DE;EACE,2DAAA;A9Kkt8DJ;A8Kjt8DI;EACE,2DAAA;A9Kmt8DN;;A8Ktt8DE;EACE,2DAAA;A9Kyt8DJ;A8Kxt8DI;EACE,2DAAA;A9K0t8DN;;A8K7t8DE;EACE,2DAAA;A9Kgu8DJ;A8K/t8DI;EACE,2DAAA;A9Kiu8DN;;A8Kpu8DE;EACE,2DAAA;A9Kuu8DJ;A8Ktu8DI;EACE,2DAAA;A9Kwu8DN;;A8K3u8DE;EACE,2DAAA;A9K8u8DJ;A8K7u8DI;EACE,2DAAA;A9K+u8DN;;A8Klv8DE;EACE,2DAAA;A9Kqv8DJ;A8Kpv8DI;EACE,2DAAA;A9Ksv8DN;;A8Kzv8DE;EACE,2DAAA;A9K4v8DJ;A8K3v8DI;EACE,2DAAA;A9K6v8DN;;A8Khw8DE;EACE,2DAAA;A9Kmw8DJ;A8Klw8DI;EACE,2DAAA;A9Kow8DN;;A8Kvw8DE;EACE,2DAAA;A9K0w8DJ;A8Kzw8DI;EACE,2DAAA;A9K2w8DN;;A8K9w8DE;EACE,2DAAA;A9Kix8DJ;A8Khx8DI;EACE,2DAAA;A9Kkx8DN;;A8Krx8DE;EACE,2DAAA;A9Kwx8DJ;A8Kvx8DI;EACE,2DAAA;A9Kyx8DN;;A8K5x8DE;EACE,2DAAA;A9K+x8DJ;A8K9x8DI;EACE,2DAAA;A9Kgy8DN;;A8Kny8DE;EACE,2DAAA;A9Ksy8DJ;A8Kry8DI;EACE,2DAAA;A9Kuy8DN;;A6K/z8DA;;;;;;CAAA;AAQA;EACC,sBAAA;EACA,6CAAA;EACA,uPAAA;EACA,mBAAA;EACA,kBAAA;A7Ki08DD;A6K7z8DA;EACC,iCAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,sCAAA;EACA,mCAAA;EACA,kCAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA;EACC,gBAAA;A7K+z8DD;;A6K5z8DA,YAAA;AAEA;EACC,uBAAA;EACA,mBAAA;EACA,oBAAA;A7K8z8DD;;A6K3z8DA;EACC,cAAA;A7K8z8DD;;A6K3z8DA;EACC,cAAA;A7K8z8DD;;A6K3z8DA;EACC,cAAA;A7K8z8DD;;A6K3z8DA;EACC,cAAA;A7K8z8DD;;A6K3z8DA;EACC,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;A7K8z8DD;;A6K3z8DA,oBAAA;AAEA,oBAAA;AAEA;EACC,eAAA;EACA,yBAAA;EACA,qBAAA;A7K4z8DD;A6K3z8DC;EACC,kBAAA;A7K6z8DF;;A6Kzz8DA;EACC,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;A7K4z8DD;;A6Kzz8DA,YAAA;AAEA;EACC,qBAAA;EAEA,4CAAA;A7K2z8DD;A6K3y8DA;EACC;IAEC,uBAAA;E7Kwz8DA;E6Krz8DD;IAEC,yBAAA;E7Kuz8DA;AACF;A+K5otEA;;;EAAA;ACAA;+BAAA;AAGA;EACE,0BAAA;EACA,8CAAA;EACA,sTAAA;EAMA,mBAAA;EACA,kBAAA;AhL4otEF;AiLtptEA;EACE,qBAAA;EACA,6CAAA;EACA,kBAAA;EACA,oBAAA;EACA,mCAAA;EACA,kCAAA;AjLwptEF;;AkL9ptEA,6DAAA;AACA;EACE,yBAAA;EACA,mBAAA;EACA,oBAAA;AlLiqtEF;;AkL/ptEA;EAAwB,cAAA;AlLmqtExB;;AkLlqtEA;EAAwB,cAAA;AlLsqtExB;;AkLrqtEA;EAAwB,cAAA;AlLyqtExB;;AkLxqtEA;EAAwB,cAAA;AlL4qtExB;;AmLtrtEA;EACE,qBAAA;EACA,kBAAA;AnLyrtEF;;AoL1rtEA;EACE,eAAA;EACA,2BCMoB;EDLpB,qBAAA;ApL6rtEF;AoL5rtEE;EAAO,kBAAA;ApL+rtET;;AoL7rtEA;EACE,kBAAA;EACA,qBAAA;EACA,qBCDoB;EDEpB,mBAAA;EACA,kBAAA;ApLgstEF;AoL/rtEE;EACE,qBAAA;ApListEJ;;AsL9stEA;EACE,4BAAA;EACA,yBAAA;EACA,oBAAA;AtLittEF;;AsL9stEA;EAA+B,WAAA;AtLkttE/B;;AsLjttEA;EAAgC,YAAA;AtLqttEhC;;AsLlttEE;EAAgC,mBAAA;AtLsttElC;AsLrttEE;EAAiC,kBAAA;AtLwttEnC;;AsLrttEA,2BAAA;AACA;EAAc,YAAA;AtLyttEd;;AsLxttEA;EAAa,WAAA;AtL4ttEb;;AsLzttEE;EAAc,mBAAA;AtL6ttEhB;AsL5ttEE;EAAe,kBAAA;AtL+ttEjB;;AuLnvtEA;EAEU,qCAAA;AvLsvtEV;;AuLnvtEA;EAEU,uCAAA;AvLsvtEV;AuLxutEA;EACE;IAEU,uBAAA;EvLqvtEV;EuLnvtEA;IAEU,yBAAA;EvLqvtEV;AACF;AwLlxtEA;ECWE,sEAAA;EAGQ,wBAAA;AzL0wtEV;;AwLvxtEA;ECUE,sEAAA;EAGQ,yBAAA;AzLixtEV;;AwL7xtEA;ECSE,sEAAA;EAGQ,yBAAA;AzLwxtEV;;AwLlytEA;ECcE,gFAAA;EAGQ,uBAAA;AzLwxtEV;;AwLxytEA;ECaE,gFAAA;EAGQ,uBAAA;AzL+xtEV;;AwL1ytEA;;;;;EAKE,YAAA;AxL6ytEF;;A0L5ztEA;EACE,kBAAA;EACA,qBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;A1L+ztEF;;A0L7ztEA;EACE,kBAAA;EACA,OAAA;EACA,WAAA;EACA,kBAAA;A1Lg0tEF;;A0L9ztEA;EAA8B,oBAAA;A1Lk0tE9B;;A0Lj0tEA;EAA8B,cAAA;A1Lq0tE9B;;A0Lp0tEA;EAA6B,WLTP;ArLi1tEtB;;A2L31tEA;mEAAA;AAGA;EAAkC,gBNwUnB;ArLshtEf;;A2L71tEA;EAAkC,gBN2dnB;ArLs4sEf;;A2Lh2tEA;EAAmC,gBN0jBnB;ArL0ysEhB;;A2Ln2tEA;EAAuC,gBNsOnB;ArLiotEpB;;A2Lt2tEA;EAAkC,gBNuWnB;ArLmgtEf;;A2Lz2tEA;EAAiC,gBNknBnB;ArL2vsEd;;A2L52tEA;EAAmC,gBNsnBnB;ArL0vsEhB;;A2L/2tEA;EAAiC,gBNytBnB;ArL0psEd;;A2Ll3tEA;EAAiC,gBNmRnB;ArLmmtEd;;A2Lr3tEA;EAAqC,gBNupBnB;ArLkusElB;;A2Lx3tEA;EAA+B,gBNqpBnB;ArLuusEZ;;A2L33tEA;EAAoC,gBNspBnB;ArLyusEjB;;A2L93tEA;EAAkC,gBNyInB;ArLyvtEf;;A2Lj4tEA;;;EAEkC,gBNqqBnB;ArLgusEf;;A2Lp4tEA;EAAwC,gBN8iBnB;ArL01sErB;;A2Lv4tEA;EAAyC,gBN4iBnB;ArL+1sEtB;;A2L14tEA;EAAsC,gBN4fnB;ArLk5sEnB;;A2L74tEA;EAAmC,gBNikBnB;ArLg1sEhB;;A2Lh5tEA;;EACgC,gBNgKnB;ArLovtEb;;A2Ln5tEA;EAAoC,gBN+qBnB;ArLwusEjB;;A2Lt5tEA;EAAiC,gBNwVnB;ArLkktEd;;A2Lz5tEA;EAAmC,gBNuPnB;ArLsqtEhB;;A2L55tEA;EAAoC,gBNgJnB;ArLgxtEjB;;A2L/5tEA;EAAiC,gBNmhBnB;ArLg5sEd;;A2Ll6tEA;EAAqC,gBNgMnB;ArLsutElB;;A2Lr6tEA;EAAgD,gBNYnB;ArL65tE7B;;A2Lx6tEA;EAA8C,gBNcnB;ArL85tE3B;;A2L36tEA;EAAkC,gBNqWnB;ArL0ktEf;;A2L96tEA;EAA0C,gBNwenB;ArL08sEvB;;A2Lj7tEA;;EACmC,gBNsgBnB;ArL+6sEhB;;A2Lp7tEA;EAAoC,gBNggBnB;ArLw7sEjB;;A2Lv7tEA;EAAqC,gBNwYnB;ArLmjtElB;;A2L17tEA;EAAiC,gBN2YnB;ArLmjtEd;;A2L77tEA;EAAiC,gBN4PnB;ArLqstEd;;A2Lh8tEA;EAAuC,gBNoUnB;ArLgotEpB;;A2Ln8tEA;EAAuC,gBNitBnB;ArLsvsEpB;;A2Lt8tEA;EAAwC,gBN+sBnB;ArL2vsErB;;A2Lz8tEA;EAAsC,gBNgtBnB;ArL6vsEnB;;A2L58tEA;EAAmC,gBNyenB;ArLu+sEhB;;A2L/8tEA;EAAoC,gBNwBnB;ArL27tEjB;;A2Ll9tEA;EAAgC,gBNymBnB;ArL62sEb;;A2Lr9tEA;EAAiC,gBNymBnB;ArLg3sEd;;A2Lx9tEA;EAAiC,gBNyDnB;ArLm6tEd;;A2L39tEA;EAAqC,gBNyDnB;ArLs6tElB;;A2L99tEA;EAAkC,gBN+dnB;ArLmgtEf;;A2Lj+tEA;EAAmC,gBN2EnB;ArL05tEhB;;A2Lp+tEA;EAAiC,gBN0PnB;ArL8utEd;;A2Lv+tEA;EAAiC,gBNiDnB;ArL07tEd;;A2L1+tEA;EAAmC,gBN0VnB;ArLoptEhB;;A2L7+tEA;EAAwC,gBNwmBnB;ArLy4sErB;;A2Lh/tEA;EAAuC,gBNwmBnB;ArL44sEpB;;A2Ln/tEA;EAAuC,gBNpCnB;ArL2huEpB;;A2Lt/tEA;EAAyC,gBNvCnB;ArLiiuEtB;;A2Lz/tEA;EAAwC,gBNrCnB;ArLkiuErB;;A2L5/tEA;EAA0C,gBNxCnB;ArLwiuEvB;;A2L//tEA;EAAiC,gBN+WnB;ArLoptEd;;A2LlguEA;;EACoC,gBN2anB;ArL2ltEjB;;A2LrguEA;EAAmC,gBNsUnB;ArLmstEhB;;A2LxguEA;EAAyC,gBNkrBnB;ArL01sEtB;;A2L3guEA;;;EAEsC,gBN0bnB;ArLqltEnB;;A2L9guEA;EAAmC,gBNkbnB;ArLgmtEhB;;A2LjhuEA;EAAuC,gBNwXnB;ArL6ptEpB;;A2LphuEA;EAAmC,gBNtDnB;ArL8kuEhB;;A2LvhuEA;EAAiC,gBNmnBnB;ArLw6sEd;;A2L1huEA;;EAC4C,gBN+anB;ArL+mtEzB;;A2L7huEA;EAA2C,gBN8fnB;ArLmitExB;;A2LhiuEA;EAA2C,gBN+EnB;ArLq9tExB;;A2LniuEA;EAAmC,gBNzBnB;ArLgkuEhB;;A2LtiuEA;EAA0C,gBNmjBnB;ArLu/sEvB;;A2LziuEA;EAA0C,gBNqLnB;ArLw3tEvB;;A2L5iuEA;EAAqC,gBNlBnB;ArLkkuElB;;A2L/iuEA;EAAiC,gBNsbnB;ArL6ntEd;;A2LljuEA;EAAkC,gBNganB;ArLsptEf;;A2LrjuEA;EAAiC,gBNmjBnB;ArLsgtEd;;A2LxjuEA;EAAoC,gBN+NnB;ArL61tEjB;;A2L3juEA;EAAyC,gBNgLnB;ArL+4tEtB;;A2L9juEA;EAAyC,gBN4iBnB;ArLshtEtB;;A2LjkuEA;EAAkC,gBN+InB;ArLs7tEf;;A2LpkuEA;EAAyC,gBNyEnB;ArL+/tEtB;;A2LvkuEA;EAA0C,gBNyEnB;ArLkguEvB;;A2L1kuEA;EAAwC,gBNkbnB;ArL4ptErB;;A2L7kuEA;EAAyC,gBNuXnB;ArL0ttEtB;;A2LhluEA;EAAyC,gBN2lBnB;ArLy/sEtB;;A2LnluEA;EAAyC,gBN2DnB;ArL4huEtB;;A2LtluEA;EAA4C,gBNybnB;ArLiqtEzB;;A2LzluEA;EAAwC,gBN0SnB;ArLmztErB;;A2L5luEA;EAAuC,gBN0GnB;ArLs/tEpB;;A2L/luEA;EAA2C,gBNulBnB;ArL4gtExB;;A2LlmuEA;EAA2C,gBNuDnB;ArL+iuExB;;A2LrmuEA;EAAgC,gBNnCnB;ArL4ouEb;;A2LxmuEA;EAAuC,gBNnDnB;ArL+puEpB;;A2L3muEA;EAAwC,gBNnDnB;ArLkquErB;;A2L9muEA;EAAqC,gBNnDnB;ArLqquElB;;A2LjnuEA;EAAuC,gBNvDnB;ArL4quEpB;;A2LpnuEA;;EACkC,gBN4dnB;ArL4ptEf;;A2LvnuEA;EAAmC,gBN8InB;ArL6+tEhB;;A2L1nuEA;EAAqC,gBNsFnB;ArLwiuElB;;A2L7nuEA;EAAiC,gBN+ZnB;ArLkutEd;;A2LhouEA;EAAkC,gBNoWnB;ArLgytEf;;A2LnouEA;EAAqC,gBNpDnB;ArL2ruElB;;A2LtouEA;EAA+C,gBNuInB;ArLmguE5B;;A2LzouEA;EAAiC,gBNkNnB;ArL27tEd;;A2L5ouEA;EAAiC,gBN0SnB;ArLs2tEd;;A2L/ouEA;EAAiC,gBN6KnB;ArLs+tEd;;A2LlpuEA;EAAgC,gBNyInB;ArL6guEb;;A2LrpuEA;EAAsC,gBNyInB;ArLghuEnB;;A2LxpuEA;;EACiD,gBNiInB;ArL2huE9B;;A2L3puEA;EAAkC,gBN+YnB;ArLgxtEf;;A2L9puEA;EAAqC,gBAAA;A3LkquErC;;A2LjquEA;EAAmC,gBNoanB;ArLiwtEhB;;A2LpquEA;EAAoC,gBNgEnB;ArLwmuEjB;;A2LvquEA;EAAmC,gBN6TnB;ArL82tEhB;;A2L1quEA;EAAuC,gBNuCnB;ArLuouEpB;;A2L7quEA;EAAyC,gBNmCnB;ArL8ouEtB;;A2LhruEA;EAAoC,gBN+anB;ArLqwtEjB;;A2LnruEA;EAA0C,gBNkdnB;ArLqutEvB;;A2LtruEA;EAAmC,gBN0KnB;ArLghuEhB;;A2LzruEA;EAAwC,gBN2KnB;ArLkhuErB;;A2L5ruEA;EAAqC,gBN3EnB;ArL2wuElB;;A2L/ruEA;EAAqC,gBN7EnB;ArLgxuElB;;A2LlsuEA;;EACsC,gBNlEnB;ArLwwuEnB;;A2LrsuEA;EAA2C,gBN+kBnB;ArL0ntExB;;A2LxsuEA;EAA4C,gBN4HnB;ArLgluEzB;;A2L3suEA;EAAyC,gBNTnB;ArLwtuEtB;;A2L9suEA;EAAgC,gBN2QnB;ArLu8tEb;;A2LjtuEA;;EACiC,gBN6CnB;ArLwquEd;;A2LptuEA;EAAqC,gBNkDnB;ArLsquElB;;A2LvtuEA;EAAwC,gBNsiBnB;ArLqrtErB;;A2L1tuEA;EAA0C,gBNoiBnB;ArL0rtEvB;;A2L7tuEA;EAAsC,gBN2enB;ArLsvtEnB;;A2LhuuEA;EAAoC,gBN8NnB;ArLsguEjB;;A2LnuuEA;EAAqC,gBNocnB;ArLmytElB;;A2LtuuEA;EAA4C,gBNuRnB;ArLm9tEzB;;A2LzuuEA;EAAuC,gBN6hBnB;ArLgttEpB;;A2L5uuEA;EAA0C,gBNsGnB;ArL0ouEvB;;A2L/uuEA;EAAoC,gBN8bnB;ArLqztEjB;;A2LlvuEA;EAAmC,gBNqjBnB;ArListEhB;;A2LrvuEA;EAA0C,gBNgLnB;ArLykuEvB;;A2LxvuEA;EAAmC,gBNukBnB;ArLqrtEhB;;A2L3vuEA;EAAoC,gBNqQnB;ArL0/tEjB;;A2L9vuEA;EAAkC,gBNiWnB;ArLi6tEf;;A2LjwuEA;EAAqC,gBN2dnB;ArL0ytElB;;A2LpwuEA;EAAuC,gBNjDnB;ArLyzuEpB;;A2LvwuEA;EAAyC,gBN+VnB;ArL46tEtB;;A2L1wuEA;EAAoC,gBNsjBnB;ArLwttEjB;;A2L7wuEA;;EACqC,gBNgGnB;ArLiruElB;;A2LhxuEA;EAAmC,gBNoKnB;ArLgnuEhB;;A2LnxuEA;EAAmC,gBN0jBnB;ArL6ttEhB;;A2LtxuEA;EAAwC,gBNoCnB;ArLsvuErB;;A2LzxuEA;;EACgC,gBN+YnB;ArL84tEb;;A2L5xuEA;EAAkC,gBNoMnB;ArL4luEf;;A2L/xuEA;EAAqC,gBNrDnB;ArLw1uElB;;A2LlyuEA;EAAiC,gBNhFnB;ArLs3uEd;;A2LryuEA;EAAwC,gBNrBnB;ArL8zuErB;;A2LxyuEA;EAAyC,gBNoLnB;ArLwnuEtB;;A2L3yuEA;EAAwC,gBNkLnB;ArL6nuErB;;A2L9yuEA;EAAsC,gBNmLnB;ArL+nuEnB;;A2LjzuEA;EAAwC,gBN+KnB;ArLsouErB;;A2LpzuEA;EAA8C,gBNrInB;ArL67uE3B;;A2LvzuEA;EAA+C,gBNjInB;ArL47uE5B;;A2L1zuEA;EAA4C,gBNjInB;ArL+7uEzB;;A2L7zuEA;EAA8C,gBNzInB;ArL08uE3B;;A2Lh0uEA;EAAkC,gBN2JnB;ArLyquEf;;A2Ln0uEA;EAAmC,gBN6lBnB;ArL0utEhB;;A2Lt0uEA;EAAkC,gBNqenB;ArLq2tEf;;A2Lz0uEA;EAAmC,gBNyGnB;ArLouuEhB;;A2L50uEA;EAAsC,gBNzEnB;ArLy5uEnB;;A2L/0uEA;EAAuC,gBNlInB;ArLq9uEpB;;A2Ll1uEA;;EACkC,gBNijBnB;ArLqytEf;;A2Lr1uEA;;EACiC,gBN4OnB;ArL6muEd;;A2Lx1uEA;EAAkC,gBNdnB;ArL02uEf;;A2L31uEA;EAAkC,gBN0GnB;ArLqvuEf;;A2L91uEA;;EACqC,gBN6XnB;ArLq+tElB;;A2Lj2uEA;;EACoC,gBN2FnB;ArL0wuEjB;;A2Lp2uEA;EAAsC,gBN6SnB;ArL2juEnB;;A2Lv2uEA;;EACqC,gBNqGnB;ArLswuElB;;A2L12uEA;EAAmC,gBNgbnB;ArL87tEhB;;A2L72uEA;;;EAEiC,gBNlInB;ArLm/uEd;;A2Lh3uEA;EAAoC,gBNsOnB;ArL8ouEjB;;A2Ln3uEA;EAAoC,gBNoOnB;ArLmpuEjB;;A2Lt3uEA;EAA0C,gBN+bnB;ArL27tEvB;;A2Lz3uEA;EAAsC,gBN2gBnB;ArLk3tEnB;;A2L53uEA;EAAkC,gBNucnB;ArLy7tEf;;A2L/3uEA;EAAkC,gBNyOnB;ArL0puEf;;A2Ll4uEA;EAAkC,gBN6fnB;ArLy4tEf;;A2Lr4uEA;EAAsC,gBNmTnB;ArLsluEnB;;A2Lx4uEA;EAA6C,gBNoTnB;ArLwluE1B;;A2L34uEA;EAA+C,gBNgInB;ArL+wuE5B;;A2L94uEA;EAAwC,gBN4HnB;ArLsxuErB;;A2Lj5uEA;EAAkC,gBNqQnB;ArLgpuEf;;A2Lp5uEA;EAAuC,gBNpFnB;ArL4+uEpB;;A2Lv5uEA;EAAqC,gBN9EnB;ArLy+uElB;;A2L15uEA;EAAuC,gBNrFnB;ArLm/uEpB;;A2L75uEA;EAAwC,gBNrFnB;ArLs/uErB;;A2Lh6uEA;EAAoC,gBNhCnB;ArLo8uEjB;;A2Ln6uEA;;EACiC,gBN0YnB;ArL6huEd;;A2Lt6uEA;;EACsC,gBN8YnB;ArL4huEnB;;A2Lz6uEA;;EACqC,gBN2YnB;ArLkiuElB;;A2L56uEA;EAAqC,gBNUnB;ArLs6uElB;;A2L/6uEA;EAAqC,gBNuMnB;ArL4uuElB;;A2Ll7uEA;;EACiC,gBNqfnB;ArLi8tEd;;A2Lr7uEA;;EACkC,gBNoFnB;ArLq2uEf;;A2Lx7uEA;;EACuC,gBN+anB;ArL6guEpB;;A2L37uEA;EAAsC,gBN7CnB;ArL4+uEnB;;A2L97uEA;EAAuC,gBN1CnB;ArL4+uEpB;;A2Lj8uEA;;EACiC,gBNpInB;ArLykvEd;;A2Lp8uEA;EAAoC,gBN6WnB;ArL2luEjB;;A2Lv8uEA;EAAqC,gBNyenB;ArLk+tElB;;A2L18uEA;;EACsC,gBNrEnB;ArLmhvEnB;;A2L78uEA;EAAwC,gBNqLnB;ArL4xuErB;;A2Lh9uEA;EAAqC,gBNGnB;ArLi9uElB;;A2Ln9uEA;EAA2C,gBNnEnB;ArL0hvExB;;A2Lt9uEA;EAAyC,gBNnEnB;ArL6hvEtB;;A2Lz9uEA;EAAoC,gBNifnB;ArL4+tEjB;;A2L59uEA;EAAwC,gBN8YnB;ArLkluErB;;A2L/9uEA;EAAqC,gBNyZnB;ArL0kuElB;;A2Ll+uEA;EAAmC,gBN9JnB;ArLoovEhB;;A2Lr+uEA;EAAmC,gBNlEnB;ArL2ivEhB;;A2Lx+uEA;EAAoC,gBN1CnB;ArLshvEjB;;A2L3+uEA;EAAwC,gBN8BnB;ArLi9uErB;;A2L9+uEA;EAAuC,gBN1InB;ArL4nvEpB;;A2Lj/uEA;EAAuC,gBNsHnB;ArL+3uEpB;;A2Lp/uEA;EAAsC,gBNrOnB;ArL6tvEnB;;A2Lv/uEA;EAAmC,gBN4MnB;ArL+yuEhB;;A2L1/uEA;EAAwC,gBNUnB;ArLo/uErB;;A2L7/uEA;EAAiC,gBN3KnB;ArL4qvEd;;A2LhgvEA;EAAqC,gBNuFnB;ArL66uElB;;A2LngvEA;EAAwC,gBN2QnB;ArL4vuErB;;A2LtgvEA;EAA8C,gBNrOnB;ArL+uvE3B;;A2LzgvEA;EAA+C,gBNrOnB;ArLkvvE5B;;A2L5gvEA;EAA4C,gBNrOnB;ArLqvvEzB;;A2L/gvEA;EAA8C,gBNzOnB;ArL4vvE3B;;A2LlhvEA;EAAuC,gBNrOnB;ArL2vvEpB;;A2LrhvEA;EAAwC,gBNrOnB;ArL8vvErB;;A2LxhvEA;EAAqC,gBNrOnB;ArLiwvElB;;A2L3hvEA;EAAuC,gBNzOnB;ArLwwvEpB;;A2L9hvEA;EAAoC,gBNpDnB;ArLslvEjB;;A2LjivEA;EAAmC,gBN4InB;ArLy5uEhB;;A2LpivEA;EAAmC,gBNwYnB;ArLgquEhB;;A2LvivEA;;EACmC,gBNuMnB;ArLo2uEhB;;A2L1ivEA;EAAqC,gBNzGnB;ArLupvElB;;A2L7ivEA;EAAuC,gBNyQnB;ArLwyuEpB;;A2LhjvEA;EAAwC,gBNyQnB;ArL2yuErB;;A2LnjvEA;EAAoC,gBN+VnB;ArLwtuEjB;;A2LtjvEA;EAAmC,gBN9GnB;ArLwqvEhB;;A2LzjvEA;;EACkC,gBNoRnB;ArLyyuEf;;A2L5jvEA;EAAuC,gBN+CnB;ArLihvEpB;;A2L/jvEA;EAAqC,gBNmBnB;ArLgjvElB;;A2LlkvEA;EAA0C,gBNoBnB;ArLkjvEvB;;A2LrkvEA;EAAoC,gBNqUnB;ArLowuEjB;;A2LxkvEA;EAAoC,gBN2BnB;ArLijvEjB;;A2L3kvEA;EAAkC,gBNgLnB;ArL+5uEf;;A2L9kvEA;EAAoC,gBN2BnB;ArLujvEjB;;A2LjlvEA;EAAuC,gBNuHnB;ArL89uEpB;;A2LplvEA;EAAmC,gBNMnB;ArLklvEhB;;A2LvlvEA;EAA2C,gBNInB;ArLulvExB;;A2L1lvEA;EAAqC,gBN6XnB;ArLiuuElB;;A2L7lvEA;EAAiC,gBNhHnB;ArLitvEd;;A2LhmvEA;;EACsC,gBNuQnB;ArL61uEnB;;A2LnmvEA;;;EAEwC,gBNsVnB;ArLixuErB;;A2LtmvEA;EAA2C,gBNwInB;ArLk+uExB;;A2LzmvEA;EAAiC,gBNhGnB;ArL6svEd;;A2L5mvEA;EAAsC,gBNvHnB;ArLuuvEnB;;A2L/mvEA;;EACyC,gBNtJnB;ArLywvEtB;;A2LlnvEA;EAAqC,gBNyOnB;ArL64uElB;;A2LrnvEA;EAAiC,gBN0FnB;ArL+hvEd;;A2LxnvEA;EAAwC,gBN1DnB;ArLsrvErB;;A2L3nvEA;EAAwC,gBNkWnB;ArL6xuErB;;A2L9nvEA;EAAsC,gBN4VnB;ArLsyuEnB;;A2LjovEA;EAAmC,gBNlEnB;ArLusvEhB;;A2LpovEA;EAAyC,gBNgOnB;ArLw6uEtB;;A2LvovEA;EAAuC,gBN2JnB;ArLg/uEpB;;A2L1ovEA;EAA6C,gBN2JnB;ArLm/uE1B;;A2L7ovEA;EAAmC,gBNsRnB;ArL23uEhB;;A2LhpvEA;EAAuC,gBN5LnB;ArLg1vEpB;;A2LnpvEA;EAA8C,gBNxBnB;ArL+qvE3B;;A2LtpvEA;EAAmC,gBNuPnB;ArLm6uEhB;;A2LzpvEA;EAAmC,gBN6InB;ArLghvEhB;;A2L5pvEA;EAAgD,gBN9JnB;ArL8zvE7B;;A2L/pvEA;EAAiD,gBN9JnB;ArLi0vE9B;;A2LlqvEA;EAA8C,gBN9JnB;ArLo0vE3B;;A2LrqvEA;EAAgD,gBNlKnB;ArL20vE7B;;A2LxqvEA;EAAkC,gBN8DnB;ArL8mvEf;;A2L3qvEA;EAAiC,gBNrHnB;ArLoyvEd;;A2L9qvEA;EAAmC,gBNvSnB;ArLy9vEhB;;A2LjrvEA;EAAuC,gBN2ZnB;ArL0xuEpB;;A2LprvEA;EAAqC,gBNhNnB;ArLw4vElB;;A2LvrvEA;EAAuC,gBN7FnB;ArLwxvEpB;;A2L1rvEA;EAAuC,gBN7FnB;ArL2xvEpB;;A2L7rvEA;EAAuC,gBN+OnB;ArLk9uEpB;;A2LhsvEA;EAAwC,gBNiMnB;ArLmgvErB;;A2LnsvEA;EAAmC,gBN6WnB;ArL01uEhB;;A2LtsvEA;EAAyC,gBN0InB;ArLgkvEtB;;A2LzsvEA;EAA2C,gBN0InB;ArLmkvExB;;A2L5svEA;EAAqC,gBNqFnB;ArL2nvElB;;A2L/svEA;EAAuC,gBNmFnB;ArLgovEpB;;A2LltvEA;EAAyC,gBNnLnB;ArLy4vEtB;;A2LrtvEA;EAA0C,gBN0KnB;ArL+ivEvB;;A2LxtvEA;EAAiD,gBNpFnB;ArLgzvE9B;;A2L3tvEA;EAAyC,gBNwPnB;ArLu+uEtB;;A2L9tvEA;EAAoC,gBNjJnB;ArLm3vEjB;;A2LjuvEA;;EACgD,gBN/MnB;ArLo7vE7B;;A2LpuvEA;;EAC8C,gBN9MnB;ArLs7vE3B;;A2LvuvEA;;EACiD,gBNjNnB;ArL47vE9B;;A2L1uvEA;;EACgC,gBNvGnB;ArLq1vEb;;A2L7uvEA;EAAgC,gBNhCnB;ArLixvEb;;A2LhvvEA;;EACgC,gBNqYnB;ArL+2uEb;;A2LnvvEA;;EACgC,gBN4CnB;ArL2svEb;;A2LtvvEA;;;;EAGgC,gBNgDnB;ArL0svEb;;A2LzvvEA;;;EAEgC,gBNiNnB;ArL4ivEb;;A2L5vvEA;;EACgC,gBN+CnB;ArLitvEb;;A2L/vvEA;;EACgC,gBN3PnB;ArL8/vEb;;A2LlwvEA;EAAiC,gBNhGnB;ArLs2vEd;;A2LrwvEA;EAAsC,gBNpFnB;ArL61vEnB;;A2LxwvEA;EAA2C,gBN0PnB;ArLkhvExB;;A2L3wvEA;EAA4C,gBN0PnB;ArLqhvEzB;;A2L9wvEA;EAA4C,gBN0PnB;ArLwhvEzB;;A2LjxvEA;EAA6C,gBN0PnB;ArL2hvE1B;;A2LpxvEA;EAA6C,gBN6PnB;ArL2hvE1B;;A2LvxvEA;EAA8C,gBN6PnB;ArL8hvE3B;;A2L1xvEA;EAAsC,gBNkUnB;ArL49uEnB;;A2L7xvEA;EAAwC,gBN8TnB;ArLm+uErB;;A2LhyvEA;EAA2C,gBNyanB;ArL23uExB;;A2LnyvEA;EAAoC,gBNsanB;ArLi4uEjB;;A2LtyvEA;EAAiC,gBN2ZnB;ArL+4uEd;;A2LzyvEA;EAAwC,gBN2ZnB;ArLk5uErB;;A2L5yvEA;EAAyC,gBNoanB;ArL44uEtB;;A2L/yvEA;EAAoC,gBNxJnB;ArL28vEjB;;A2LlzvEA;EAA2C,gBN8PnB;ArLwjvExB;;A2LrzvEA;EAAsC,gBNgBnB;ArLyyvEnB;;A2LxzvEA;EAAmC,gBNpFnB;ArLg5vEhB;;A2L3zvEA;EAAgC,gBN3WnB;ArL0qwEb;;A2L9zvEA;EAAsC,gBN/RnB;ArLimwEnB;;A2Lj0vEA;EAA6C,gBN/RnB;ArLomwE1B;;A2Lp0vEA;EAAmC,gBN+UnB;ArLy/uEhB;;A2Lv0vEA;EAA0C,gBN+UnB;ArL4/uEvB;;A2L10vEA;EAA4C,gBNgDnB;ArL8xvEzB;;A2L70vEA;EAA0C,gBNkDnB;ArL+xvEvB;;A2Lh1vEA;EAA4C,gBN+CnB;ArLqyvEzB;;A2Ln1vEA;EAA6C,gBN+CnB;ArLwyvE1B;;A2Lt1vEA;EAAkC,gBNjWnB;ArL2rwEf;;A2Lz1vEA;EAAoC,gBNmYnB;ArL09uEjB;;A2L51vEA;EAAoC,gBN7WnB;ArL6swEjB;;A2L/1vEA;EAAkC,gBNkCnB;ArLi0vEf;;A2Ll2vEA;EAAqC,gBN5KnB;ArLkhwElB;;A2Lr2vEA;EAAkC,gBNgNnB;ArLypvEf;;A2Lx2vEA;EAAuC,gBNxFnB;ArLo8vEpB;;A2L32vEA;EAAmC,gBN4TnB;ArLmjvEhB;;A2L92vEA;EAAmC,gBNtInB;ArLw/vEhB;;A2Lj3vEA;EAAiC,gBN6CnB;ArLw0vEd;;A2Lp3vEA;;EACqC,gBN5DnB;ArLo7vElB;;A2Lv3vEA;EAAkC,gBN8PnB;ArL6nvEf;;A2L13vEA;EAAmC,gBNuEnB;ArLuzvEhB;;A2L73vEA;EAAoC,gBN9WnB;ArL+uwEjB;;A2Lh4vEA;EAAgC,gBNtSnB;ArL0qwEb;;A2Ln4vEA;EAA+B,gBNiWnB;ArLsivEZ;;A2Lt4vEA;EAAkC,gBNuWnB;ArLmivEf;;A2Lz4vEA;EAAmC,gBN+InB;ArL8vvEhB;;A2L54vEA;EAAsC,gBNkFnB;ArL8zvEnB;;A2L/4vEA;EAA2C,gBN6NnB;ArLsrvExB;;A2Ll5vEA;EAAiD,gBN/WnB;ArLqwwE9B;;A2Lr5vEA;EAAgD,gBNjXnB;ArL0wwE7B;;A2Lx5vEA;;EACgD,gBNzRnB;ArLqrwE7B;;A2L35vEA;EAAyC,gBNnMnB;ArLkmwEtB;;A2L95vEA;EAAuC,gBNiWnB;ArLikvEpB;;A2Lj6vEA;EAAyC,gBNoVnB;ArLilvEtB;;A2Lp6vEA;;EACgC,gBN0SnB;ArL8nvEb;;A2Lv6vEA;EAA0C,gBN0GnB;ArLi0vEvB;;A2L16vEA;EAA0C,gBN4MnB;ArLkuvEvB;;A2L76vEA;EAAkC,gBNsLnB;ArL2vvEf;;A2Lh7vEA;EAA4C,gBNzLnB;ArL6mwEzB;;A2Ln7vEA;EAAsC,gBNoWnB;ArLmlvEnB;;A2Lt7vEA;EAAmC,gBN8DnB;ArL43vEhB;;A2Lz7vEA;;;EAEuC,gBN8SnB;ArL+ovEpB;;A2L57vEA;;EAC2C,gBN1FnB;ArL0hwExB;;A2L/7vEA;EAAkC,gBNsWnB;ArL6lvEf;;A2Ll8vEA;EAAmC,gBNlGnB;ArLwiwEhB;;A2Lr8vEA;EAAmC,gBNgHnB;ArLy1vEhB;;A2Lx8vEA;EAA0C,gBNiHnB;ArL21vEvB;;A2L38vEA;EAA+C,gBNyNnB;ArLsvvE5B;;A2L98vEA;EAAwC,gBNuNnB;ArL2vvErB;;A2Lj9vEA;EAAsC,gBN/NnB;ArLorwEnB;;A2Lp9vEA;EAAiC,gBN5NnB;ArLorwEd;;A2Lv9vEA;EAA0C,gBN2EnB;ArLg5vEvB;;A2L19vEA;EAA2C,gBNyEnB;ArLq5vExB;;A2L79vEA;EAAmC,gBNvNnB;ArLwrwEhB;;A2Lh+vEA;EAAmC,gBNzCnB;ArL6gwEhB;;A2Ln+vEA;EAAqC,gBNpCnB;ArL2gwElB;;A2Lt+vEA;EAAgC,gBNtLnB;ArLgqwEb;;A2Lz+vEA;EAAqC,gBN7UnB;ArL0zwElB;;A2L5+vEA;EAAkC,gBN1RnB;ArL0wwEf;;A2L/+vEA;EAAgC,gBNsDnB;ArL67vEb;;A2Ll/vEA;EAAkC,gBNmLnB;ArLm0vEf;;A2Lr/vEA;EAAiC,gBNrPnB;ArL8uwEd;;A2Lx/vEA;EAAkC,gBNrPnB;ArLivwEf;;A2L3/vEA;EAAoC,gBN7WnB;ArL42wEjB;;A2L9/vEA;EAA2C,gBN7WnB;ArL+2wExB;;A2LjgwEA;EAAkC,gBN0LnB;ArL20vEf;;A2LpgwEA;EAAyC,gBN0LnB;ArL80vEtB;;A2LvgwEA;EAAoC,gBNyFnB;ArLk7vEjB;;A2L1gwEA;;EACgC,gBNzUnB;ArLu1wEb;;A2L7gwEA;;EACiC,gBN+MnB;ArLk0vEd;;A2LhhwEA;EAAiC,gBN4PnB;ArLwxvEd;;A2LnhwEA;EAAoC,gBNuKnB;ArLg3vEjB;;A2LthwEA;EAAuC,gBNtPnB;ArLgxwEpB;;A2LzhwEA;EAAuC,gBNiKnB;ArL43vEpB;;A2L5hwEA;EAAqC,gBN9PnB;ArL8xwElB;;A2L/hwEA;EAAuC,gBN/LnB;ArLkuwEpB;;A2LliwEA;EAAwC,gBNxLnB;ArL8twErB;;A2LriwEA;EAAyC,gBNrMnB;ArL8uwEtB;;A2LxiwEA;EAA8C,gBN/LnB;ArL2uwE3B;;A2L3iwEA;;;EAEyC,gBNxMnB;ArLuvwEtB;;A2L9iwEA;;EAC2C,gBN9MnB;ArLgwwExB;;A2LjjwEA;;EACyC,gBN/MnB;ArLowwEtB;;A2LpjwEA;;EACyC,gBNpMnB;ArL4vwEtB;;A2LvjwEA;EAAwC,gBNjNnB;ArL4wwErB;;A2L1jwEA;EAAiC,gBNuRnB;ArLuyvEd;;A2L7jwEA;EAAoC,gBN5SnB;ArL62wEjB;;A2LhkwEA;EAAqC,gBN9EnB;ArLkpwElB;;A2LnkwEA;;;;;EAIsC,gBNnEnB;ArL0owEnB;;A2LtkwEA;EAA2C,gBN/TnB;ArLy4wExB;;A2LzkwEA;;;EAEkC,gBNqDnB;ArLwhwEf;;A2L5kwEA;;EACmC,gBNnQnB;ArLm1wEhB;;A2L/kwEA;EAAuC,gBNzKnB;ArL4vwEpB;;A2LllwEA;EAAgC,gBN3KnB;ArLiwwEb;;A2LrlwEA;;;EAEwC,gBNxJnB;ArLivwErB;;A2LxlwEA;EAA0C,gBN2KnB;ArLi7vEvB;;A2L3lwEA;EAA+B,gBNiCnB;ArL8jwEZ;;A2L9lwEA;;EACmC,gBN0QnB;ArLw1vEhB;;A2LjmwEA;;EACwC,gBNVnB;ArL+mwErB;;A2LpmwEA;;EAC0C,gBNXnB;ArLmnwEvB;;A2LvmwEA;EAAoC,gBN1InB;ArLqvwEjB;;A2L1mwEA;EAAwC,gBNlVnB;ArLg8wErB;;A2L7mwEA;EAAmC,gBNjJnB;ArLkwwEhB;;A2LhnwEA;EAAsC,gBNbnB;ArLiowEnB;;A2LnnwEA;EAAoC,gBN+FnB;ArLwhwEjB;;A2LtnwEA;EAAsC,gBNuEnB;ArLmjwEnB;;A2LznwEA;EAA6C,gBNuEnB;ArLsjwE1B;;A2L5nwEA;EAAiC,gBNzZnB;ArLyhxEd;;A2L/nwEA;;EACqC,gBN5MnB;ArL+0wElB;;A2LlowEA;EAAgC,gBN0MnB;ArL47vEb;;A2LrowEA;EAAuC,gBNxanB;ArLijxEpB;;A2LxowEA;EAAiC,gBNInB;ArLwowEd;;A2L3owEA;EAAuC,gBNuFnB;ArLwjwEpB;;A2L9owEA;EAAmC,gBN2MnB;ArLu8vEhB;;A2LjpwEA;EAAiC,gBN+QnB;ArLs4vEd;;A2LppwEA;EAAwC,gBNzCnB;ArLiswErB;;A2LvpwEA;EAAiC,gBNwPnB;ArLm6vEd;;A2L1pwEA;EAAuC,gBNrZnB;ArLmjxEpB;;A2L7pwEA;EAAmC,gBNvBnB;ArLwrwEhB;;A2LhqwEA;EAA0C,gBN3LnB;ArL+1wEvB;;A2LnqwEA;EAAoC,gBN5XnB;ArLmixEjB;;A2LtqwEA;EAA0C,gBNhYnB;ArL0ixEvB;;A2LzqwEA;EAAwC,gBNnYnB;ArLgjxErB;;A2L5qwEA;EAAoC,gBNtYnB;ArLsjxEjB;;A2L/qwEA;EAAsC,gBNlYnB;ArLqjxEnB;;A2LlrwEA;EAAsC,gBNlYnB;ArLwjxEnB;;A2LrrwEA;EAAuC,gBN3bnB;ArLonxEpB;;A2LxrwEA;EAAyC,gBN3bnB;ArLunxEtB;;A2L3rwEA;EAAkC,gBN+KnB;ArLghwEf;;A2L9rwEA;EAAsC,gBNnVnB;ArLqhxEnB;;A2LjswEA;EAA+B,gBN9dnB;ArLmqxEZ;;A2LpswEA;EAAuC,gBN5RnB;ArLo+wEpB;;A2LvswEA;EAAwC,gBN/CnB;ArL0vwErB;;A2L1swEA;EAA0C,gBN9bnB;ArL4oxEvB;;A2L7swEA;EAAuC,gBNtfnB;ArLusxEpB;;A2LhtwEA;EAAsC,gBN/BnB;ArLmvwEnB;;A2LntwEA;EAAuC,gBNzHnB;ArLg1wEpB;;A2LttwEA;EAAmC,gBNvInB;ArLi2wEhB;;A2LztwEA;EAA0C,gBNvInB;ArLo2wEvB;;A2L5twEA;EAAuC,gBN4JnB;ArLokwEpB;;A2L/twEA;EAAsC,gBN4JnB;ArLukwEnB;;A2LluwEA;EAAoC,gBNxcnB;ArL8qxEjB;;A2LruwEA;EAAgC,gBNjbnB;ArL0pxEb;;A2LxuwEA;EAAoC,gBNvJnB;ArLm4wEjB;;A2L3uwEA;EAAsC,gBN3gBnB;ArL0vxEnB;;A2L9uwEA;EAA+B,gBN7ZnB;ArL+oxEZ;;A2LjvwEA;;;EAEgC,gBNzKnB;ArL85wEb;;A2LpvwEA;EAAqC,gBNpGnB;ArL41wElB;;A2LvvwEA;EAAuC,gBNxbnB;ArLmrxEpB;;A2L1vwEA;EAA2C,gBN5WnB;ArL0mxExB;;A2L7vwEA;EAAqC,gBN9VnB;ArL+lxElB;;A2LhwwEA;EAAqC,gBN9PnB;ArLkgxElB;;A2LnwwEA;EAAoC,gBNrJnB;ArL45wEjB;;A2LtwwEA;EAAmC,gBNenB;ArL2vwEhB;;A2LzwwEA;EAAyC,gBN2BnB;ArLkvwEtB;;A2L5wwEA;EAAwC,gBNoCnB;ArL4uwErB;;A2L/wwEA;EAAqC,gBNqCnB;ArL8uwElB;;A2LlxwEA;EAAsC,gBN5anB;ArLksxEnB;;A2LrxwEA;EAA4C,gBN9anB;ArLusxEzB;;A2LxxwEA;EAAoC,gBN/VnB;ArL2nxEjB;;A2L3xwEA;EAAiC,gBNoBnB;ArL2wwEd;;A2L9xwEA;EAAwC,gBN8KnB;ArLonwErB;;A2LjywEA;EAAuC,gBN/FnB;ArLo4wEpB;;A2LpywEA;EAAwC,gBN6EnB;ArL2twErB;;A2LvywEA;EAAsC,gBN9MnB;ArLy/wEnB;;A2L1ywEA;EAAkC,gBN+KnB;ArL+nwEf;;A2L7ywEA;EAAiC,gBN7HnB;ArL86wEd;;A2LhzwEA;EAAoC,gBNnHnB;ArLu6wEjB;;A2LnzwEA;;EACwC,gBNkInB;ArLqrwErB;;A2LtzwEA;EAA4C,gBNkInB;ArLwrwEzB;;A2LzzwEA;EAAyC,gBN0KnB;ArLmpwEtB;;A2L5zwEA;EAAwC,gBNlInB;ArLk8wErB;;A2L/zwEA;EAAuC,gBNyKnB;ArL0pwEpB;;A2Ll0wEA;EAAwC,gBNnInB;ArLy8wErB;;A2Lr0wEA;EAA0C,gBNlInB;ArL28wEvB;;A2Lx0wEA;EAA0C,gBNpInB;ArLg9wEvB;;A2L30wEA;EAAmC,gBN1GnB;ArLy7wEhB;;A2L90wEA;EAAuC,gBN7QnB;ArL+lxEpB;;A2Lj1wEA;EAA8C,gBN1UnB;ArL+pxE3B;;A2Lp1wEA;EAAwC,gBNzEnB;ArLi6wErB;;A2Lv1wEA;EAAqC,gBNkLnB;ArLyqwElB;;A2L11wEA;EAAmC,gBNXnB;ArLy2wEhB;;A2L71wEA;EAAsC,gBNuJnB;ArL0swEnB;;A2Lh2wEA;EAAuC,gBNwJnB;ArL4swEpB;;A2Ln2wEA;;EACgC,gBN/fnB;ArLs2xEb;;A2Lt2wEA;EAAoC,gBN4JnB;ArL8swEjB;;A2Lz2wEA;EAAkC,gBN8GnB;ArL+vwEf;;A2L52wEA;EAAmC,gBNwDnB;ArLwzwEhB;;A2L/2wEA;EAAmC,gBN9InB;ArLigxEhB;;A2Ll3wEA;;EACyC,gBN0LnB;ArL4rwEtB;;A2Lr3wEA;EAA0C,gBNjHnB;ArL0+wEvB;;A2Lx3wEA;EAAqC,gBNrHnB;ArLi/wElB;;A2L33wEA;EAAyC,gBNnWnB;ArLkuxEtB;;A2L93wEA;;;EAEyC,gBN/gBnB;ArLi5xEtB;;A2Lj4wEA;;EACmD,gBN9gBnB;ArLm5xEhC;;A2Lp4wEA;;EACyC,gBNlhBnB;ArL05xEtB;;A2Lv4wEA;;EAC4C,gBNnhBnB;ArL85xEzB;;A2L14wEA;;EAC0C,gBNxhBnB;ArLs6xEvB;;A2L74wEA;EAA0C,gBN3InB;ArL4hxEvB;;A2Lh5wEA;EAAqC,gBN3OnB;ArL+nxElB;;A2Ln5wEA;EAAyC,gBNxInB;ArL+hxEtB;;A2Lt5wEA;EAA2C,gBNxInB;ArLkixExB;;A2Lz5wEA;EAAwC,gBNwBnB;ArLq4wErB;;A2L55wEA;EAA0C,gBNwBnB;ArLw4wEvB;;A2L/5wEA;EAAmC,gBN/dnB;ArLk4xEhB;;A2Ll6wEA;EAA2C,gBNlenB;ArLw4xExB;;A2Lr6wEA;EAAkC,gBNpcnB;ArL62xEf;;A2Lx6wEA;EAA0C,gBNljBnB;ArL89xEvB;;A2L36wEA;EAAwC,gBNxPnB;ArLuqxErB;;A2L96wEA;;EAC4C,gBNzPnB;ArL2qxEzB;;A2Lj7wEA;;EAC2C,gBN7PnB;ArLkrxExB;;A2Lp7wEA;;EAC0C,gBNhQnB;ArLwrxEvB;;A2Lv7wEA;EAAsC,gBNrQnB;ArLgsxEnB;;A2L17wEA;;EACwC,gBNxRnB;ArLstxErB;;A2L77wEA;;EACyC,gBN7RnB;ArL8txEtB;;A2Lh8wEA;EAA4C,gBN1RnB;ArL8txEzB;;A2Ln8wEA;EAA0C,gBNpSnB;ArL2uxEvB;;A2Lt8wEA;EAAyC,gBN3RnB;ArLquxEtB;;A2Lz8wEA;EAA2C,gBN/RnB;ArL4uxExB;;A2L58wEA;EAAyC,gBNjSnB;ArLivxEtB;;A2L/8wEA;EAAsC,gBN+DnB;ArLo5wEnB;;A2Ll9wEA;EAAuC,gBN/FnB;ArLqjxEpB;;A2Lr9wEA;EAAyC,gBN/bnB;ArLw5xEtB;;A2Lx9wEA;EAA+B,gBNtUnB;ArLkyxEZ;;A2L39wEA;EAAsC,gBNtUnB;ArLqyxEnB;;A2L99wEA;EAAwC,gBNkEnB;ArLg6wErB;;A2Lj+wEA;EAA0C,gBNrKnB;ArL0oxEvB;;A2Lp+wEA;EAAiD,gBNrKnB;ArL6oxE9B;;A2Lv+wEA;EAAuC,gBN5UnB;ArLuzxEpB;;A2L1+wEA;EAAwC,gBNwHnB;ArLs3wErB;;A2L7+wEA;EAAmC,gBNnFnB;ArLokxEhB;;A2Lh/wEA;EAAmC,gBNzenB;ArL69xEhB;;A2Ln/wEA;EAAoC,gBN9WnB;ArLq2xEjB;;A2Lt/wEA;EAAkC,gBNxKnB;ArLkqxEf;;A2Lz/wEA;EAA8C,gBNpQnB;ArLiwxE3B;;A2L5/wEA;;EACuC,gBNSnB;ArLu/wEpB;;A2L//wEA;EAAmC,gBNjdnB;ArLo9xEhB;;A2LlgxEA;EAAkC,gBNzoBnB;ArL+oyEf;;A2LrgxEA;EAAmC,gBN/nBnB;ArLwoyEhB;;A2LxgxEA;EAA4C,gBN3hBnB;ArLuiyEzB;;A2L3gxEA;EAA6C,gBN9hBnB;ArL6iyE1B;;A2L9gxEA;EAA6C,gBN5hBnB;ArL8iyE1B;;A2LjhxEA;EAA6C,gBNjiBnB;ArLsjyE1B;;A2LphxEA;EAAqC,gBNpRnB;ArL4yxElB;;A2LvhxEA;EAAoC,gBN5NnB;ArLuvxEjB;;A2L1hxEA;EAAsC,gBN5NnB;ArL0vxEnB;;A2L7hxEA;EAAkC,gBN/NnB;ArLgwxEf;;A2LhixEA;EAAgC,gBNlOnB;ArLswxEb;;A2LnixEA;EAAuC,gBNpenB;ArL2gyEpB;;A2LtixEA;EAAyC,gBNpenB;ArL8gyEtB;;A2LzixEA;EAAkC,gBNtSnB;ArLm1xEf;;A2L5ixEA;EAAkC,gBNiFnB;ArL+9wEf;;A2L/ixEA;EAAsC,gBNlkBnB;ArLqnyEnB;;A2LljxEA;EAAsC,gBNrXnB;ArL26xEnB;;A2LrjxEA;EAAyC,gBNpInB;ArL6rxEtB;;A2LxjxEA;EAAiC,gBNpcnB;ArLggyEd;;A2L3jxEA;EAA4C,gBNhenB;ArL+hyEzB;;A2L9jxEA;EAAqC,gBNpfnB;ArLsjyElB;;A2LjkxEA;EAAiC,gBNlNnB;ArLuxxEd;;A2LpkxEA;EAAyC,gBN1XnB;ArLk8xEtB;;A2LvkxEA;EAAgC,gBNoDnB;ArLuhxEb;;A2L1kxEA;EAAyC,gBN3JnB;ArLyuxEtB;;A2L7kxEA;EAAqC,gBNzNnB;ArL0yxElB;;A2LhlxEA;EAAmC,gBNlHnB;ArLssxEhB;;A2LnlxEA;EAAyC,gBN7LnB;ArLoxxEtB;;A2LtlxEA;EAA2C,gBN7LnB;ArLuxxExB;;A2LzlxEA;EAAwC,gBN3CnB;ArLwoxErB;;A2L5lxEA;EAA0C,gBN3CnB;ArL2oxEvB;;A2L/lxEA;EAAyC,gBNrGnB;ArLwsxEtB;;A2LlmxEA;EAA4C,gBNrGnB;ArL2sxEzB;;A2LrmxEA;EAAoC,gBN7UnB;ArLs7xEjB;;A2LxmxEA;EAAsC,gBNnlBnB;ArL+ryEnB;;A2L3mxEA;EAAwC,gBNnlBnB;ArLksyErB;;A2L9mxEA;EAAoC,gBN/LnB;ArLizxEjB;;A2LjnxEA;EAAmC,gBNlXnB;ArLu+xEhB;;A2LpnxEA;EAAuC,gBNkFnB;ArLsixEpB;;A2LvnxEA;EAAoC,gBNmFnB;ArLwixEjB;;A2L1nxEA;EAAmC,gBN9cnB;ArL4kyEhB;;A2L7nxEA;EAAwC,gBN2BnB;ArLsmxErB;;A2LhoxEA;EAA2C,gBNmEnB;ArLikxExB;;A2LnoxEA;EAA8C,gBNxKnB;ArL+yxE3B;;A2LtoxEA;EAAkC,gBN9lBnB;ArLwuyEf;;A2LzoxEA;EAA8C,gBNtoBnB;ArLmxyE3B;;A2L5oxEA;EAAiD,gBNqDnB;ArL2lxE9B;;A2L/oxEA;EAAoC,gBNxlBnB;ArL2uyEjB;;A2LlpxEA;EAAwD,gBN5oBnB;ArLkyyErC;;A2LrpxEA;;EACgE,gBN9qBnB;ArLu0yE7C;;A2LxpxEA;;;EAEiC,gBNvfnB;ArLmpyEd;;A2L3pxEA;EAAkC,gBNhYnB;ArL+hyEf;;A2L9pxEA;EAAoC,gBNhYnB;ArLkiyEjB;;A2LjqxEA;;EAC0C,gBN1HnB;ArL+xxEvB;;A2LpqxEA;EAAuC,gBNzRnB;ArLi8xEpB;;A2LvqxEA;EAAmC,gBNiCnB;ArL0oxEhB;;A2L1qxEA;EAA0C,gBNiCnB;ArL6oxEvB;;A2L7qxEA;EAAqC,gBNlHnB;ArLmyxElB;;A2LhrxEA;EAA2C,gBNlHnB;ArLsyxExB;;A2LnrxEA;EAA4C,gBNlHnB;ArLyyxEzB;;A2LtrxEA;EAAuC,gBNrNnB;ArL+4xEpB;;A2LzrxEA;EAAwC,gBNpbnB;ArLinyErB;;A2L5rxEA;EAAkC,gBNmEnB;ArL6nxEf;;A2L/rxEA;EAAsC,gBNpDnB;ArLuvxEnB;;A2LlsxEA;;EACiD,gBNzYnB;ArL+kyE9B;;A2LrsxEA;;EACyC,gBN7anB;ArLsnyEtB;;A2LxsxEA;EAAwC,gBNtXnB;ArLkkyErB;;A2L3sxEA;EAA0C,gBNlfnB;ArLisyEvB;;A2L9sxEA;EAA4C,gBNlfnB;ArLosyEzB;;A2LjtxEA;EAAmC,gBNtTnB;ArL2gyEhB;;A2LptxEA;EAAyC,gBNptBnB;ArL46yEtB;;A2LvtxEA;EAA2C,gBNptBnB;ArL+6yExB;;A2L1txEA;;EACyC,gBNrtBnB;ArLm7yEtB;;A2L7txEA;;EAC2C,gBNttBnB;ArLu7yExB;;A2LhuxEA;EAAwC,gBNJnB;ArLwuxErB;;A2LnuxEA;EAA0C,gBNJnB;ArL2uxEvB;;A2LtuxEA;EAAmC,gBNHnB;ArL6uxEhB;;A2LzuxEA;EAAqC,gBN3WnB;ArLwlyElB;;A2L5uxEA;;EACoC,gBN5WnB;ArL4lyEjB;;A2L/uxEA;;EACsC,gBN7WnB;ArLgmyEnB;;A2LlvxEA;EAAkC,gBNtNnB;ArL48xEf;;A2LrvxEA;EAA2C,gBN3bnB;ArLoryExB;;A2LxvxEA;EAAqC,gBNtFnB;ArLk1xElB;;A2L3vxEA;;;EAE6C,gBNxEnB;ArLu0xE1B;;A2L9vxEA;;EACuD,gBNvEnB;ArLy0xEpC;;A2LjwxEA;;EAC6C,gBN3EnB;ArLg1xE1B;;A2LpwxEA;;EACgD,gBN5EnB;ArLo1xE7B;;A2LvwxEA;;EAC8C,gBNjFnB;ArL41xE3B;;A2L1wxEA;EAAmC,gBN3KnB;ArLy7xEhB;;A2L7wxEA;;;EAEiC,gBNzrBnB;ArL08yEd;;A2LhxxEA;EAAoC,gBNlPnB;ArLsgyEjB;;A2LnxxEA;EAA4C,gBNKnB;ArLkxxEzB;;A2LtxxEA;EAA4C,gBNKnB;ArLqxxEzB;;A2LzxxEA;EAA2C,gBNKnB;ArLwxxExB;;A2L5xxEA;;EACyC,gBNDnB;ArLiyxEtB;;A2L/xxEA;;EAC2C,gBNFnB;ArLqyxExB;;A2LlyxEA;EAAqC,gBNxsBnB;ArL8+yElB;;A2LryxEA;EAAiC,gBNpbnB;ArL6tyEd;;A2LxyxEA;EAAiC,gBN1hBnB;ArLs0yEd;;A2L3yxEA;EAAiC,gBNxYnB;ArLuryEd;;A2L9yxEA;EAAoC,gBN/OnB;ArLiiyEjB;;A2LjzxEA;EAAoC,gBNziBnB;ArL81yEjB;;A2LpzxEA;EAAsC,gBNjUnB;ArLynyEnB;;A2LvzxEA;EAAwC,gBN7KnB;ArLw+xErB;;A2L1zxEA;EAAwC,gBNhInB;ArL87xErB;;A2L7zxEA;EAAuC,gBNJnB;ArLq0xEpB;;A2Lh0xEA;EAAmC,gBNxUnB;ArL4oyEhB;;A4LrlzEA;EH8BE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,SAAA;AzL2jzEF;;AyLjjzEE;EAEE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,UAAA;AzLmjzEJ;;A6L5mzEA;EACE,sBAAA;EACA,yBAAA;A7L+mzEF;A6L9mzEE;EACE,mCAAA;A7LgnzEJ;A6L9mzEE;EACE,sBAAA;A7LgnzEJ;A6L9mzEE;EACE,yBAAA;A7LgnzEJ;A6L9mzEE;EACE,yBAAA;A7LgnzEJ;A6L9mzEE;EACE,yBAAA;A7LgnzEJ;A6L9mzEE;EACE,yBAAA;A7LgnzEJ;A6L9mzEE;EACE,4BAAA;EACA,oBAAA;A7LgnzEJ;;A6L7mzEA;EACE;IACE,8DAAA;IACA,wBAAA;E7LgnzEF;E6L9mzEA;IACE,8DAAA;IACA,wBAAA;E7LgnzEF;E6L9mzEA;IACE,8DAAA;IACA,wBAAA;E7LgnzEF;E6L9mzEA;IACE,8DAAA;IACA,wBAAA;E7LgnzEF;E6L9mzEA;IACE,8DAAA;IACA,wBAAA;E7LgnzEF;E6L9mzEA;IACE,iEAAA;IACA,mCAAA;E7LgnzEF;E6L9mzEA;IACE,iEAAA;IACA,mCAAA;E7LgnzEF;E6L9mzEA;IACE,iEAAA;IACA,mCAAA;E7LgnzEF;E6L9mzEA;IACE,kCAAA;E7LgnzEF;AACF;A6L9mzEA;EACE,sBAAA;EACA,+BAAA;A7LgnzEF;;A6L9mzEA;EACE;IACE,UAAA;E7LinzEF;E6L/mzEA;IACE,UAAA;E7LinzEF;E6L/mzEA;IACE,UAAA;E7LinzEF;E6L/mzEA;IACE,UAAA;E7LinzEF;E6L/mzEA;IACE,UAAA;E7LinzEF;AACF;A6L/mzEA;EACE,qBAAA;A7LinzEF;;A6L/mzEA;EACE;IACE,oBAAA;E7LknzEF;E6LhnzEA;IACE,oCAAA;E7LknzEF;E6LhnzEA;IACE,oBAAA;E7LknzEF;AACF;A6LhnzEA;EACE,qBAAA;A7LknzEF;;A6LhnzEA;EACE;IACE,oBAAA;E7LmnzEF;E6LjnzEA;IACE,iCAAA;E7LmnzEF;E6LjnzEA;IACE,iCAAA;E7LmnzEF;E6LjnzEA;IACE,iCAAA;E7LmnzEF;E6LjnzEA;IACE,iCAAA;E7LmnzEF;E6LjnzEA;IACE,iCAAA;E7LmnzEF;E6LjnzEA;IACE,oBAAA;E7LmnzEF;AACF;A6LjnzEA;EACE,0BAAA;A7LmnzEF;;A6LjnzEA;EACE;IACE,wBAAA;E7LonzEF;E6LlnzEA;IACE,wBAAA;E7LonzEF;E6LlnzEA;IACE,mCAAA;E7LonzEF;E6LlnzEA;IACE,mCAAA;E7LonzEF;E6LlnzEA;IACE,mCAAA;E7LonzEF;E6LlnzEA;IACE,mCAAA;E7LonzEF;E6LlnzEA;IACE,mCAAA;E7LonzEF;E6LlnzEA;IACE,kCAAA;E7LonzEF;E6LlnzEA;IACE,kCAAA;E7LonzEF;E6LlnzEA;IACE,kCAAA;E7LonzEF;E6LlnzEA;IACE,kCAAA;E7LonzEF;AACF;A6LlnzEA;EACE,qBAAA;A7LonzEF;;A6LlnzEA;EACE;IACE,wBAAA;E7LqnzEF;E6LnnzEA;IACE,wBAAA;E7LqnzEF;E6LnnzEA;IACE,0CAAA;E7LqnzEF;E6LnnzEA;IACE,wCAAA;E7LqnzEF;E6LnnzEA;IACE,0CAAA;E7LqnzEF;E6LnnzEA;IACE,wCAAA;E7LqnzEF;AACF;A6LnnzEA;EACE,sCAAA;EACA,yBAAA;A7LqnzEF;;A6LnnzEA;EACE;IACE,wBAAA;E7LsnzEF;E6LpnzEA;IACE,yBAAA;E7LsnzEF;E6LpnzEA;IACE,uBAAA;E7LsnzEF;E6LpnzEA;IACE,wBAAA;E7LsnzEF;E6LpnzEA;IACE,uBAAA;E7LsnzEF;AACF;A6LpnzEA;EACE,4BAAA;EACA,qBAAA;A7LsnzEF;;A6LpnzEA;EACE;IACE,oBAAA;E7LunzEF;E6LrnzEA;IACE,+CAAA;E7LunzEF;E6LrnzEA;IACE,+CAAA;E7LunzEF;E6LrnzEA;IACE,8CAAA;E7LunzEF;E6LrnzEA;IACE,8CAAA;E7LunzEF;E6LrnzEA;IACE,8CAAA;E7LunzEF;E6LrnzEA;IACE,8CAAA;E7LunzEF;E6LrnzEA;IACE,+CAAA;E7LunzEF;E6LrnzEA;IACE,+CAAA;E7LunzEF;E6LrnzEA;IACE,+CAAA;E7LunzEF;E6LrnzEA;IACE,oBAAA;E7LunzEF;AACF;A6LrnzEA;EACE,oBAAA;A7LunzEF;;A6LrnzEA;EACE;IACE,eAAA;E7LwnzEF;E6LtnzEA;IACE,gDAAA;E7LwnzEF;E6LtnzEA;IACE,8CAAA;E7LwnzEF;E6LtnzEA;IACE,gDAAA;E7LwnzEF;E6LtnzEA;IACE,8CAAA;E7LwnzEF;E6LtnzEA;IACE,+CAAA;E7LwnzEF;E6LtnzEA;IACE,eAAA;E7LwnzEF;AACF;A6LtnzEA;EACE,sBAAA;A7LwnzEF;;A6LtnzEA;EACE;IACE,eAAA;E7LynzEF;E6LvnzEA;IACE,eAAA;E7LynzEF;E6LvnzEA;IACE,eAAA;E7LynzEF;E6LvnzEA;IACE,0CAAA;E7LynzEF;E6LvnzEA;IACE,wCAAA;E7LynzEF;E6LvnzEA;IACE,4CAAA;E7LynzEF;E6LvnzEA;IACE,4CAAA;E7LynzEF;E6LvnzEA;IACE,gDAAA;E7LynzEF;E6LvnzEA;IACE,gDAAA;E7LynzEF;E6LvnzEA;IACE,oDAAA;E7LynzEF;AACF;A6LvnzEA;EACE,qBAAA;EACA,wBAAA;A7LynzEF;;A6LvnzEA;EACE;IACE,8DAAA;IACA,UAAA;IACA,iCAAA;E7L0nzEF;E6LxnzEA;IACE,8DAAA;IACA,iCAAA;E7L0nzEF;E6LxnzEA;IACE,8DAAA;IACA,iCAAA;E7L0nzEF;E6LxnzEA;IACE,8DAAA;IACA,UAAA;IACA,oCAAA;E7L0nzEF;E6LxnzEA;IACE,8DAAA;IACA,oCAAA;E7L0nzEF;E6LxnzEA;IACE,8DAAA;IACA,UAAA;IACA,oBAAA;E7L0nzEF;AACF;A6LxnzEA;EACE,wBAAA;A7L0nzEF;;A6LxnzEA;EACE;IACE,8DAAA;IACA,UAAA;IACA,qCAAA;E7L2nzEF;E6LznzEA;IACE,8DAAA;IACA,UAAA;IACA,kCAAA;E7L2nzEF;E6LznzEA;IACE,8DAAA;IACA,mCAAA;E7L2nzEF;E6LznzEA;IACE,8DAAA;IACA,iCAAA;E7L2nzEF;E6LznzEA;IACE,8DAAA;IACA,eAAA;E7L2nzEF;AACF;A6LznzEA;EACE,4BAAA;A7L2nzEF;;A6LznzEA;EACE;IACE,8DAAA;IACA,UAAA;IACA,qCAAA;E7L4nzEF;E6L1nzEA;IACE,8DAAA;IACA,UAAA;IACA,kCAAA;E7L4nzEF;E6L1nzEA;IACE,8DAAA;IACA,mCAAA;E7L4nzEF;E6L1nzEA;IACE,8DAAA;IACA,iCAAA;E7L4nzEF;E6L1nzEA;IACE,8DAAA;IACA,eAAA;E7L4nzEF;AACF;A6L1nzEA;EACE,4BAAA;A7L4nzEF;;A6L1nzEA;EACE;IACE,8DAAA;IACA,UAAA;IACA,oCAAA;E7L6nzEF;E6L3nzEA;IACE,8DAAA;IACA,UAAA;IACA,mCAAA;E7L6nzEF;E6L3nzEA;IACE,8DAAA;IACA,kCAAA;E7L6nzEF;E6L3nzEA;IACE,8DAAA;IACA,kCAAA;E7L6nzEF;E6L3nzEA;IACE,8DAAA;IACA,eAAA;E7L6nzEF;AACF;A6L3nzEA;EACE,6BAAA;A7L6nzEF;;A6L3nzEA;EACE;IACE,8DAAA;IACA,UAAA;IACA,oCAAA;E7L8nzEF;E6L5nzEA;IACE,8DAAA;IACA,UAAA;IACA,mCAAA;E7L8nzEF;E6L5nzEA;IACE,8DAAA;IACA,kCAAA;E7L8nzEF;E6L5nzEA;IACE,8DAAA;IACA,kCAAA;E7L8nzEF;E6L5nzEA;IACE,8DAAA;IACA,wBAAA;E7L8nzEF;AACF;A6L5nzEA;EACE,0BAAA;A7L8nzEF;;A6L5nzEA;EACE;IACE,iCAAA;E7L+nzEF;E6L7nzEA;IACE,UAAA;IACA,iCAAA;E7L+nzEF;E6L7nzEA;IACE,UAAA;IACA,iCAAA;E7L+nzEF;E6L7nzEA;IACE,UAAA;IACA,iCAAA;E7L+nzEF;AACF;A6L7nzEA;EACE,yBAAA;A7L+nzEF;;A6L7nzEA;EACE;IACE,kCAAA;E7LgozEF;E6L9nzEA;IACE,UAAA;IACA,mCAAA;E7LgozEF;E6L9nzEA;IACE,UAAA;IACA,mCAAA;E7LgozEF;E6L9nzEA;IACE,UAAA;IACA,oCAAA;E7LgozEF;AACF;A6L9nzEA;EACE,6BAAA;A7LgozEF;;A6L9nzEA;EACE;IACE,UAAA;IACA,kCAAA;E7LiozEF;E6L/nzEA;IACE,UAAA;IACA,qCAAA;E7LiozEF;AACF;A6L/nzEA;EACE,6BAAA;A7LiozEF;;A6L/nzEA;EACE;IACE,UAAA;IACA,mCAAA;E7LkozEF;E6LhozEA;IACE,UAAA;IACA,oCAAA;E7LkozEF;AACF;A6LhozEA;EACE,8BAAA;A7LkozEF;;A6LhozEA;EACE;IACE,mCAAA;E7LmozEF;E6LjozEA;IACE,UAAA;IACA,kCAAA;E7LmozEF;E6LjozEA;IACE,UAAA;IACA,kCAAA;E7LmozEF;E6LjozEA;IACE,UAAA;IACA,qCAAA;E7LmozEF;AACF;A6LjozEA;EACE,2BAAA;A7LmozEF;;A6LjozEA;EACE;IACE,UAAA;E7LoozEF;E6LlozEA;IACE,UAAA;E7LoozEF;AACF;A6LlozEA;EACE,sBAAA;A7LoozEF;;A6LlozEA;EACE;IACE,UAAA;IACA,mCAAA;E7LqozEF;E6LnozEA;IACE,UAAA;IACA,eAAA;E7LqozEF;AACF;A6LnozEA;EACE,0BAAA;A7LqozEF;;A6LnozEA;EACE;IACE,UAAA;IACA,qCAAA;E7LsozEF;E6LpozEA;IACE,UAAA;IACA,eAAA;E7LsozEF;AACF;A6LpozEA;EACE,6BAAA;A7LsozEF;;A6LpozEA;EACE;IACE,UAAA;IACA,mCAAA;E7LuozEF;E6LrozEA;IACE,UAAA;IACA,eAAA;E7LuozEF;AACF;A6LrozEA;EACE,0BAAA;A7LuozEF;;A6LrozEA;EACE;IACE,UAAA;IACA,qCAAA;E7LwozEF;E6LtozEA;IACE,UAAA;IACA,eAAA;E7LwozEF;AACF;A6LtozEA;EACE,6BAAA;A7LwozEF;;A6LtozEA;EACE;IACE,UAAA;IACA,kCAAA;E7LyozEF;E6LvozEA;IACE,UAAA;IACA,eAAA;E7LyozEF;AACF;A6LvozEA;EACE,2BAAA;A7LyozEF;;A6LvozEA;EACE;IACE,UAAA;IACA,oCAAA;E7L0ozEF;E6LxozEA;IACE,UAAA;IACA,eAAA;E7L0ozEF;AACF;A6LxozEA;EACE,8BAAA;A7L0ozEF;;A6LxozEA;EACE;IACE,UAAA;IACA,kCAAA;E7L2ozEF;E6LzozEA;IACE,UAAA;IACA,eAAA;E7L2ozEF;AACF;A6LzozEA;EACE,wBAAA;A7L2ozEF;;A6LzozEA;EACE;IACE,UAAA;IACA,oCAAA;E7L4ozEF;E6L1ozEA;IACE,UAAA;IACA,eAAA;E7L4ozEF;AACF;A6L1ozEA;EACE,2BAAA;A7L4ozEF;;A6L1ozEA;EACE;IACE,UAAA;E7L6ozEF;E6L3ozEA;IACE,UAAA;E7L6ozEF;AACF;A6L3ozEA;EACE,uBAAA;A7L6ozEF;;A6L3ozEA;EACE;IACE,UAAA;E7L8ozEF;E6L5ozEA;IACE,UAAA;IACA,kCAAA;E7L8ozEF;AACF;A6L5ozEA;EACE,2BAAA;A7L8ozEF;;A6L5ozEA;EACE;IACE,UAAA;E7L+ozEF;E6L7ozEA;IACE,UAAA;IACA,oCAAA;E7L+ozEF;AACF;A6L7ozEA;EACE,8BAAA;A7L+ozEF;;A6L7ozEA;EACE;IACE,UAAA;E7LgpzEF;E6L9ozEA;IACE,UAAA;IACA,mCAAA;E7LgpzEF;AACF;A6L9ozEA;EACE,2BAAA;A7LgpzEF;;A6L9ozEA;EACE;IACE,UAAA;E7LipzEF;E6L/ozEA;IACE,UAAA;IACA,qCAAA;E7LipzEF;AACF;A6L/ozEA;EACE,8BAAA;A7LipzEF;;A6L/ozEA;EACE;IACE,UAAA;E7LkpzEF;E6LhpzEA;IACE,UAAA;IACA,kCAAA;E7LkpzEF;AACF;A6LhpzEA;EACE,4BAAA;A7LkpzEF;;A6LhpzEA;EACE;IACE,UAAA;E7LmpzEF;E6LjpzEA;IACE,UAAA;IACA,oCAAA;E7LmpzEF;AACF;A6LjpzEA;EACE,+BAAA;A7LmpzEF;;A6LjpzEA;EACE;IACE,UAAA;E7LopzEF;E6LlpzEA;IACE,UAAA;IACA,mCAAA;E7LopzEF;AACF;A6LlpzEA;EACE,yBAAA;A7LopzEF;;A6LlpzEA;EACE;IACE,UAAA;E7LqpzEF;E6LnpzEA;IACE,UAAA;IACA,qCAAA;E7LqpzEF;AACF;A6LnpzEA;EACE,4BAAA;A7LqpzEF;;A6LnpzEA;EACE;IACE,6CAAA;IACA,mCAAA;E7LspzEF;E6LppzEA;IACE,gEAAA;IACA,mCAAA;E7LspzEF;E6LppzEA;IACE,gEAAA;IACA,kCAAA;E7LspzEF;E6LppzEA;IACE,uDAAA;IACA,kCAAA;E7LspzEF;E6LppzEA;IACE,6BAAA;IACA,kCAAA;E7LspzEF;AACF;A6LppzEA;EACE;IACE,4CAAA;IACA,kCAAA;IACA,UAAA;E7LspzEF;E6LppzEA;IACE,6CAAA;IACA,kCAAA;E7LspzEF;E6LppzEA;IACE,4CAAA;IACA,UAAA;E7LspzEF;E6LppzEA;IACE,4CAAA;E7LspzEF;E6LppzEA;IACE,6BAAA;E7LspzEF;AACF;A6LppzEA;EACE,uCAAA;EACA,uBAAA;A7LspzEF;;A6LppzEA;EACE;IACE,4CAAA;IACA,kCAAA;IACA,UAAA;E7LupzEF;E6LrpzEA;IACE,6CAAA;IACA,kCAAA;E7LupzEF;E6LrpzEA;IACE,4CAAA;IACA,UAAA;E7LupzEF;E6LrpzEA;IACE,4CAAA;E7LupzEF;E6LrpzEA;IACE,6BAAA;E7LupzEF;AACF;A6LrpzEA;EACE,uCAAA;EACA,uBAAA;A7LupzEF;;A6LrpzEA;EACE;IAEE,6BAAA;E7LupzEF;E6LrpzEA;IAEE,6CAAA;IACA,UAAA;E7LspzEF;E6LppzEA;IAEE,4CAAA;IACA,UAAA;E7LqpzEF;AACF;A6LnpzEA;EACE,wBAAA;EAEA,uCAAA;A7LopzEF;;A6LlpzEA;EACE;IAEE,6BAAA;E7LopzEF;E6LlpzEA;IAEE,6CAAA;IACA,UAAA;E7LmpzEF;E6LjpzEA;IAEE,4CAAA;IACA,UAAA;E7LkpzEF;AACF;A6LhpzEA;EAEE,uCAAA;EACA,wBAAA;A7LipzEF;;A6L/ozEA;EACE;IAEE,gDAAA;IACA,UAAA;E7LipzEF;E6L/ozEA;IAEE,uBAAA;IACA,UAAA;E7LgpzEF;E6L9ozEA;IAEE,uBAAA;IACA,UAAA;E7L+ozEF;E6L7ozEA;IAEE,eAAA;IACA,UAAA;E7L8ozEF;AACF;A6L5ozEA;EACE,4BAAA;EACA,mCAAA;A7L8ozEF;;A6L5ozEA;EACE;IACE,UAAA;E7L+ozEF;E6L7ozEA;IAEE,+CAAA;IACA,UAAA;E7L8ozEF;AACF;A6L5ozEA;EACE,6BAAA;EACA,kCAAA;A7L8ozEF;;A6L5ozEA;EACE;IAEE,wBAAA;IAEA,0BAAA;IACA,UAAA;E7L6ozEF;E6L3ozEA;IAEE,wBAAA;IAEA,eAAA;IACA,UAAA;E7L2ozEF;AACF;A6LzozEA;EACE,wBAAA;A7L2ozEF;;A6LzozEA;EACE;IAEE,6BAAA;IAEA,yBAAA;IACA,UAAA;E7L0ozEF;E6LxozEA;IAEE,6BAAA;IAEA,eAAA;IACA,UAAA;E7LwozEF;AACF;A6LtozEA;EACE,gCAAA;A7LwozEF;;A6LtozEA;EACE;IAEE,8BAAA;IAEA,wBAAA;IACA,UAAA;E7LuozEF;E6LrozEA;IAEE,8BAAA;IAEA,eAAA;IACA,UAAA;E7LqozEF;AACF;A6LnozEA;EACE,iCAAA;A7LqozEF;;A6LnozEA;EACE;IAEE,6BAAA;IAEA,wBAAA;IACA,UAAA;E7LoozEF;E6LlozEA;IAEE,6BAAA;IAEA,eAAA;IACA,UAAA;E7LkozEF;AACF;A6LhozEA;EACE,8BAAA;A7LkozEF;;A6LhozEA;EACE;IAEE,8BAAA;IAEA,yBAAA;IACA,UAAA;E7LiozEF;E6L/nzEA;IAEE,8BAAA;IAEA,eAAA;IACA,UAAA;E7L+nzEF;AACF;A6L7nzEA;EACE,+BAAA;A7L+nzEF;;A6L7nzEA;EACE;IAEE,wBAAA;IACA,UAAA;E7L+nzEF;E6L7nzEA;IAEE,wBAAA;IAEA,yBAAA;IACA,UAAA;E7L6nzEF;AACF;A6L3nzEA;EACE,yBAAA;A7L6nzEF;;A6L3nzEA;EACE;IAEE,6BAAA;IACA,UAAA;E7L6nzEF;E6L3nzEA;IAEE,6BAAA;IAEA,wBAAA;IACA,UAAA;E7L2nzEF;AACF;A6LznzEA;EACE,iCAAA;A7L2nzEF;;A6LznzEA;EACE;IAEE,8BAAA;IACA,UAAA;E7L2nzEF;E6LznzEA;IAEE,8BAAA;IAEA,yBAAA;IACA,UAAA;E7LynzEF;AACF;A6LvnzEA;EACE,kCAAA;A7LynzEF;;A6LvnzEA;EACE;IAEE,6BAAA;IACA,UAAA;E7LynzEF;E6LvnzEA;IAEE,6BAAA;IAEA,yBAAA;IACA,UAAA;E7LunzEF;AACF;A6LrnzEA;EACE,+BAAA;A7LunzEF;;A6LrnzEA;EACE;IAEE,8BAAA;IACA,UAAA;E7LunzEF;E6LrnzEA;IAEE,8BAAA;IAEA,wBAAA;IACA,UAAA;E7LqnzEF;AACF;A6LnnzEA;EACE,gCAAA;A7LqnzEF;;A6LnnzEA;EACE;IAEE,0BAAA;IACA,sCAAA;E7LqnzEF;E6LnnzEA;IAEE,wBAAA;IAEA,0BAAA;IACA,sCAAA;E7LmnzEF;E6LjnzEA;IAEE,wBAAA;IAEA,0BAAA;IACA,sCAAA;E7LinzEF;E6L/mzEA;IAEE,wBAAA;IAEA,0BAAA;IACA,sCAAA;IACA,UAAA;E7L+mzEF;E6L7mzEA;IAEE,wBAAA;IAEA,0BAAA;IACA,sCAAA;IACA,UAAA;E7L6mzEF;E6L3mzEA;IAEE,mCAAA;IACA,UAAA;E7L4mzEF;AACF;A6L1mzEA;EACE,qBAAA;A7L4mzEF;;A6L1mzEA;EACE;IACE,UAAA;IAEA,mCAAA;IAEA,+BAAA;E7L2mzEF;E6LzmzEA;IAEE,yBAAA;E7L0mzEF;E6LxmzEA;IAEE,uBAAA;E7LymzEF;E6LvmzEA;IACE,UAAA;IAEA,mBAAA;E7LwmzEF;AACF;A6LtmzEA;EACE,4BAAA;A7LwmzEF;;A6LtmzEA;EACE;IACE,UAAA;IAEA,mDAAA;E7LwmzEF;E6LtmzEA;IACE,UAAA;IAEA,eAAA;E7LumzEF;AACF;A6LrmzEA;EACE,sBAAA;A7LumzEF;;A6LrmzEA;EACE;IACE,UAAA;E7LwmzEF;E6LtmzEA;IACE,UAAA;IAEA,iDAAA;E7LumzEF;AACF;A6LrmzEA;EACE,uBAAA;A7LumzEF;;A6LrmzEA;EACE;IACE,UAAA;IAEA,iCAAA;E7LumzEF;E6LrmzEA;IACE,UAAA;E7LumzEF;AACF;A6LrmzEA;EACE,sBAAA;A7LumzEF;;A6LrmzEA;EACE;IACE,UAAA;IAEA,4DAAA;IACA,iEAAA;E7LumzEF;E6LrmzEA;IACE,UAAA;IAEA,+DAAA;IACA,8DAAA;E7LsmzEF;AACF;A6LpmzEA;EACE,0BAAA;A7LsmzEF;;A6LpmzEA;EACE;IACE,UAAA;IAEA,4DAAA;IACA,iEAAA;E7LsmzEF;E6LpmzEA;IACE,UAAA;IAEA,+DAAA;IACA,8DAAA;E7LqmzEF;AACF;A6LnmzEA;EACE,0BAAA;A7LqmzEF;;A6LnmzEA;EACE;IACE,UAAA;IAEA,2DAAA;IACA,iEAAA;E7LqmzEF;E6LnmzEA;IACE,UAAA;IAEA,gEAAA;IACA,8DAAA;E7LomzEF;AACF;A6LlmzEA;EACE,2BAAA;A7LomzEF;;A6LlmzEA;EACE;IACE,UAAA;IAEA,2DAAA;IACA,iEAAA;E7LomzEF;E6LlmzEA;IACE,UAAA;IAEA,gEAAA;IACA,8DAAA;E7LmmzEF;AACF;A6LjmzEA;EACE,wBAAA;A7LmmzEF;;A6LjmzEA;EACE;IACE,UAAA;E7LomzEF;E6LlmzEA;IACE,UAAA;IAEA,iCAAA;E7LmmzEF;E6LjmzEA;IACE,UAAA;E7LmmzEF;AACF;A6LjmzEA;EACE,uBAAA;A7LmmzEF;;A6LjmzEA;EACE;IACE,UAAA;IAEA,gEAAA;IACA,iEAAA;E7LmmzEF;E6LjmzEA;IACE,UAAA;IAEA,2DAAA;IAEA,+BAAA;IACA,8DAAA;E7LimzEF;AACF;A6L/lzEA;EACE,2BAAA;A7LimzEF;;A6L/lzEA;EACE;IACE,UAAA;IAEA,+DAAA;E7LimzEF;E6L/lzEA;IACE,UAAA;IAEA,gDAAA;IAEA,6BAAA;E7L+lzEF;AACF;A6L7lzEA;EACE,2BAAA;A7L+lzEF;;A6L7lzEA;EACE;IACE,UAAA;IAEA,gEAAA;E7L+lzEF;E6L7lzEA;IACE,UAAA;IAEA,+CAAA;IAEA,8BAAA;E7L6lzEF;AACF;A6L3lzEA;EACE,4BAAA;A7L6lzEF;;A6L3lzEA;EACE;IACE,UAAA;IAEA,+DAAA;IACA,iEAAA;E7L6lzEF;E6L3lzEA;IACE,UAAA;IAEA,4DAAA;IAEA,+BAAA;IACA,8DAAA;E7L2lzEF;AACF;A6LzlzEA;EACE,yBAAA;A7L2lzEF;;A6LzlzEA;EACE;IAEE,mCAAA;IACA,mBAAA;E7L2lzEF;E6LzlzEA;IAEE,wBAAA;E7L0lzEF;AACF;A6LxlzEA;EACE,2BAAA;A7L0lzEF;;A6LxlzEA;EACE;IAEE,mCAAA;IACA,mBAAA;E7L0lzEF;E6LxlzEA;IAEE,wBAAA;E7LylzEF;AACF;A6LvlzEA;EACE,2BAAA;A7LylzEF;;A6LvlzEA;EACE;IAEE,kCAAA;IACA,mBAAA;E7LylzEF;E6LvlzEA;IAEE,wBAAA;E7LwlzEF;AACF;A6LtlzEA;EACE,4BAAA;A7LwlzEF;;A6LtlzEA;EACE;IAEE,kCAAA;IACA,mBAAA;E7LwlzEF;E6LtlzEA;IAEE,wBAAA;E7LulzEF;AACF;A6LrlzEA;EACE,yBAAA;A7LulzEF;;A6LrlzEA;EACE;IAEE,wBAAA;E7LulzEF;E6LrlzEA;IACE,kBAAA;IAEA,kCAAA;E7LslzEF;AACF;A6LplzEA;EACE,4BAAA;A7LslzEF;;A6LplzEA;EACE;IAEE,wBAAA;E7LslzEF;E6LplzEA;IACE,kBAAA;IAEA,mCAAA;E7LqlzEF;AACF;A6LnlzEA;EACE,4BAAA;A7LqlzEF;;A6LnlzEA;EACE;IAEE,wBAAA;E7LqlzEF;E6LnlzEA;IACE,kBAAA;IAEA,kCAAA;E7LolzEF;AACF;A6LllzEA;EACE,6BAAA;A7LolzEF;;A6LllzEA;EACE;IAEE,wBAAA;E7LolzEF;E6LllzEA;IACE,kBAAA;IAEA,mCAAA;E7LmlzEF;AACF;A6LjlzEA;EACE,0BAAA;A7LmlzEF;;A8Lhh2EA,4DAAA;AACA;EACC,wBAAA;EACA,kBAAA;A9Lmh2ED;;A8Lhh2EA,8EAAA;AACA;EACC,SAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;A9Lmh2ED;;A8Lhh2EA,8HAAA;AAEA;;EAEC,UAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;A9Lkh2ED,E8Ljh2EE,gEAAA;AAEF;EACC,kBAAA;A9Lih2ED;;A8L9g2EA;;EAEC,YAAA,EAAA,MAAA;EACA,cAAA,EAAA,MAAA;A9Lih2ED;;A8L9g2EA;EACC,WAAA;A9Lih2ED;;A8L/g2EA;EACC,iBAAA;EACA,2BAAA;EACA,+BAAA;A9Lkh2ED;;A8Lhh2EA;EACC,qBAAA;A9Lmh2ED;;A8Ljh2EA;EACC,WAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gDAAA;EACA,2BAAA;EACA,UAAA;A9Loh2ED;A8Ljh2EC;EACC,YAAA;A9Lmh2EF;A8Ljh2EC;EACC,6CAAA;EACA,kCAAA;EACA,YAAA;EACA,YAAA;EACA,2BAAA;A9Lmh2EF;A8Lhh2EC;EACC,6BAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;A9Lkh2EF;A8Ljh2EE;EACC,aAAA;EACA,YAAA;EACA,gDAAA;A9Lmh2EH;A8Ljh2EE;EACC,eAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;A9Lmh2EH;A8Ljh2EE;EACC,iBAAA;A9Lmh2EH;A8Lhh2EC;EACC,0CAAA;A9Lkh2EF;A8Lhh2EC;EACC,iBAAA;A9Lkh2EF;A8Lhh2EC;EACC,+DAAA;A9Lkh2EF;A8Lhh2EC;EACC,qDAAA;A9Lkh2EF;A8Lhh2EC;EACC,+DAAA;A9Lkh2EF;;A8L9g2EA,kBAAA;AACA;EACC,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,6CAAA;A9Lih2ED;A8L/g2EC;EACC,kBAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;A9Lih2EF;;A8L7g2EA;EACC;IACC,gBAAA;IACA,iBAAA;E9Lgh2EA;AACF;A+Lvp2EA,yBAAA;AAEE;EACE,uBAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;A/Lwp2EJ;A+Lvp2EI;EACE,iBAAA;A/Lyp2EN;A+Lvp2EI;EACE,mBnHDS;EmHET,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A/Lyp2EN;A+Lxp2EM;EACE,WnHkBA;EmHjBA,eAAA;EACA,WAAA;EACA,YAAA;A/L0p2ER;A+Lvp2EI;EACE,YAAA;EACA,WAAA;A/Lyp2EN;A+Lxp2EM;EACE,eAAA;EACA,oBAAA;A/L0p2ER;A+Lzp2EQ;EACE,2BAAA;A/L2p2EV;A+Lzp2EQ;EACE,2BAAA;A/L2p2EV;A+Ltp2EE;EACE,WAAA;EACA,cAAA;EACA,sBAAA;A/Lwp2EJ;A+Lvp2EI;EACE,aAAA;EACA,mBAAA;A/Lyp2EN;A+Lxp2EM;EACE,gBAAA;EACA,kBAAA;A/L0p2ER;A+Lxp2EM;EACE,eAAA;EACA,qBAAA;EACA,0BAAA;A/L0p2ER;A+Lzp2EQ;EACE,cnH7CK;A5Ews2Ef;A+Lzp2EQ;EACE,cnHnDM;A5E8s2EhB;A+L1p2EU;EACE,yBAAA;EACA,kBAAA;A/L4p2EZ;A+L3p2EY;EACE,cnHxDE;A5Eqt2EhB;A+Lzp2EQ;EACE,4BAAA;EACA,kBAAA;EACA,QAAA;A/L2p2EV;A+Lzp2EQ;EACE,2BAAA;EACA,kBAAA;EACA,QAAA;A/L2p2EV;A+Lxp2EM;EACE,iBAAA;EACA,gBAAA;A/L0p2ER;A+Lvp2EI;EACE,kBAAA;A/Lyp2EN;A+Lxp2EM;EACE,kBAAA;EACA,cnHxFgB;A5Ekv2ExB;A+Lvp2EQ;EACE,gCAAA;A/Lyp2EV;A+Lxp2EU;EACE,cnHlFE;A5E4u2Ed;A+Lvp2EQ;EACE,2BAAA;EACA,eAAA;A/Lyp2EV;A+Ltp2EM;EACE,0BAAA;EACA,aAAA;EACA,gBAAA;A/Lwp2ER;A+Lvp2EQ;EACE,sBAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,0BAAA;A/Lyp2EV;A+Lxp2EU;EACE,yBAAA;EACA,aAAA;A/L0p2EZ;A+Lxp2EU;EACE,yBAAA;EACA,aAAA;A/L0p2EZ;A+Lvp2EQ;EACE,cnHlHK;EmHmHL,kBAAA;A/Lyp2EV;A+Lvp2EQ;EACE,iBAAA;EACA,cAAA;A/Lyp2EV;A+Ltp2EM;EACE,WAAA;EACA,cAAA;EACA,WAAA;A/Lwp2ER;A+Lrp2EI;EACE,iBAAA;EACA,cAAA;A/Lup2EN;A+Lrp2EI;EACE,gBAAA;EACA,SAAA;EACA,UAAA;A/Lup2EN;A+Lpp2EU;EACE,cAAA;A/Lsp2EZ;A+Lrp2EY;EACE,cAAA;A/Lup2Ed;A+Llp2EM;EACE,SAAA;EACA,UAAA;A/Lop2ER;A+Lnp2EQ;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,WAAA;EACA,gCAAA;EAEA,sBAAA;EACA,kBAAA;EACA,iCAAA;A/Lqp2EV;A+Lpp2EU;EACE,eAAA;A/Lsp2EZ;A+Lpp2EU;EACE,cAAA;EACA,eAAA;EACA,sBAAA;EACA,cnH9JA;EmH+JA,qBAAA;EACA,gBAAA;EACA,gBAAA;A/Lsp2EZ;A+Lpp2EU;EACE,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,eAAA;A/Lsp2EZ;A+Lrp2EY;EACE,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,kBAAA;A/Lup2Ed;A+Ltp2Ec;EACE,eAAA;A/Lwp2EhB;A+Ltp2Ec;EACE,yBAAA;EACA,gBnHhKR;EmHiKQ,kBAAA;A/Lwp2EhB;A+Lvp2EgB;EACE,cnH9KN;A5Eu02EZ;A+Lnp2EY;EACE,cnH3LD;EmH4LC,yBAAA;A/Lqp2Ed;A+Lhp2EU;EACE,sCAAA;EACA,kBAAA;A/Lkp2EZ;A+Ljp2EY;EACE,iBAAA;A/Lmp2Ed;A+Ljp2EY;EACE,gBnHvLN;EmHwLM,yBAAA;A/Lmp2Ed;A+Llp2Ec;EACE,WnH1LR;A5E802ER;A+Lhp2EU;EACE,6BAAA;EACA,2BAAA;A/Lkp2EZ;A+L/o2EQ;EACE,0CAAA;A/Lip2EV;A+L7o2EI;EACE,kBAAA;EACA,cnH/NY;A5E822ElB;A+L5o2EE;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,mBnHhPY;EmHiPZ,yBAAA;EACA,WnHrNI;EmHsNJ,aAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;A/L8o2EJ;A+L7o2EI;EACE,mBnHzPU;EmH0PV,yBAAA;A/L+o2EN;A+L7o2EI;EACE,aAAA;EACA,gBAAA;EACA,WnHlOE;A5Ei32ER;A+L7o2EI;EACE,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,qBAAA;A/L+o2EN;A+L7o2EI;EACE,eAAA;EACA,qBAAA;EACA,gBAAA;A/L+o2EN;A+L7o2EI;EACE,UAAA;EACA,kBAAA;A/L+o2EN;A+Lpo2EE;EACE;IACE,mCAAA;E/L8o2EJ;E+L5o2EE;IACE,gBnHlQE;E5Eg52EN;AACF;;A+Lzo2EI;EACE,YAAA;A/L4o2EN;A+Lto2EQ;EACE,YAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;A/Lwo2EV;A+L/n2EU;EACE,iBAAA;A/Lio2EZ;A+L/n2EU;EACE,eAAA;A/Lio2EZ;A+Lho2EY;EACE,WnHnSN;EmHoSM,oBAAA;A/Lko2Ed;A+Lho2EY;EACE,6BAAA;A/Lko2Ed;A+Ljo2Ec;EACE,WnHzSR;A5E462ER;A+L5n2EI;EACE,sBAAA;A/L8n2EN;;A+L1n2EA,uBAAA","sourcesContent":["@charset \"UTF-8\";\n/*!\n * Bootstrap  v5.3.8 (https://getbootstrap.com/)\n * Copyright 2011-2025 The Bootstrap Authors\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n@import \"~react-clock/dist/Clock.css\";\n@import \"~react-datepicker/dist/react-datepicker.css\";\n@import \"~react-image-crop/dist/ReactCrop.css\";\n@import \"~react-bootstrap-typeahead/css/Typeahead.css\";\n@import \"~react-dropzone-uploader/dist/styles.css\";\n@import \"~react-dragula/dist/dragula.css\";\n@import \"~react-toastify/dist/ReactToastify.css\";\n@import \"~react-image-crop/dist/ReactCrop.css\";\n@import \"react-day-picker/dist/style.css\";\n@import \"~react-big-calendar/lib/css/react-big-calendar.css\";\n@import \"~react-vertical-timeline-component/style.min.css\";\n@import \"~easymde/dist/easymde.min.css\";\n@import \"~leaflet/dist/leaflet.css\";\n@import \"~react-18-image-lightbox/style.css\";\n@import \"~react-perfect-scrollbar/dist/css/styles.css\";\n:root,\n[data-bs-theme=light] {\n  --bs-blue: #0d6efd;\n  --bs-indigo: #6610f2;\n  --bs-purple: #6f42c1;\n  --bs-pink: #d63384;\n  --bs-red: #dc3545;\n  --bs-orange: #fd7e14;\n  --bs-yellow: #ffc107;\n  --bs-green: #198754;\n  --bs-teal: #20c997;\n  --bs-cyan: #0dcaf0;\n  --bs-black: #000;\n  --bs-white: #fff;\n  --bs-gray: #6c757d;\n  --bs-gray-dark: #343a40;\n  --bs-gray-100: #f8f9fa;\n  --bs-gray-200: #e9ecef;\n  --bs-gray-300: #dee2e6;\n  --bs-gray-400: #ced4da;\n  --bs-gray-500: #adb5bd;\n  --bs-gray-600: #6c757d;\n  --bs-gray-700: #495057;\n  --bs-gray-800: #343a40;\n  --bs-gray-900: #212529;\n  --bs-primary: #0d6efd;\n  --bs-secondary: #6c757d;\n  --bs-success: #198754;\n  --bs-info: #0dcaf0;\n  --bs-warning: #ffc107;\n  --bs-danger: #dc3545;\n  --bs-light: #f8f9fa;\n  --bs-dark: #212529;\n  --bs-primary-rgb: 13, 110, 253;\n  --bs-secondary-rgb: 108, 117, 125;\n  --bs-success-rgb: 25, 135, 84;\n  --bs-info-rgb: 13, 202, 240;\n  --bs-warning-rgb: 255, 193, 7;\n  --bs-danger-rgb: 220, 53, 69;\n  --bs-light-rgb: 248, 249, 250;\n  --bs-dark-rgb: 33, 37, 41;\n  --bs-primary-text-emphasis: rgb(2.0392156863%, 17.2549019608%, 39.6862745098%);\n  --bs-secondary-text-emphasis: rgb(16.9411764706%, 18.3529411765%, 19.6078431373%);\n  --bs-success-text-emphasis: rgb(3.9215686275%, 21.1764705882%, 13.1764705882%);\n  --bs-info-text-emphasis: rgb(2.0392156863%, 31.6862745098%, 37.6470588235%);\n  --bs-warning-text-emphasis: rgb(40%, 30.2745098039%, 1.0980392157%);\n  --bs-danger-text-emphasis: rgb(34.5098039216%, 8.3137254902%, 10.8235294118%);\n  --bs-light-text-emphasis: #495057;\n  --bs-dark-text-emphasis: #495057;\n  --bs-primary-bg-subtle: rgb(81.0196078431%, 88.6274509804%, 99.8431372549%);\n  --bs-secondary-bg-subtle: rgb(88.4705882353%, 89.1764705882%, 89.8039215686%);\n  --bs-success-bg-subtle: rgb(81.9607843137%, 90.5882352941%, 86.5882352941%);\n  --bs-info-bg-subtle: rgb(81.0196078431%, 95.8431372549%, 98.8235294118%);\n  --bs-warning-bg-subtle: rgb(100%, 95.137254902%, 80.5490196078%);\n  --bs-danger-bg-subtle: rgb(97.2549019608%, 84.1568627451%, 85.4117647059%);\n  --bs-light-bg-subtle: rgb(98.6274509804%, 98.8235294118%, 99.0196078431%);\n  --bs-dark-bg-subtle: #ced4da;\n  --bs-primary-border-subtle: rgb(62.0392156863%, 77.2549019608%, 99.6862745098%);\n  --bs-secondary-border-subtle: rgb(76.9411764706%, 78.3529411765%, 79.6078431373%);\n  --bs-success-border-subtle: rgb(63.9215686275%, 81.1764705882%, 73.1764705882%);\n  --bs-info-border-subtle: rgb(62.0392156863%, 91.6862745098%, 97.6470588235%);\n  --bs-warning-border-subtle: rgb(100%, 90.2745098039%, 61.0980392157%);\n  --bs-danger-border-subtle: rgb(94.5098039216%, 68.3137254902%, 70.8235294118%);\n  --bs-light-border-subtle: #e9ecef;\n  --bs-dark-border-subtle: #adb5bd;\n  --bs-white-rgb: 255, 255, 255;\n  --bs-black-rgb: 0, 0, 0;\n  --bs-font-sans-serif: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));\n  --bs-body-font-family: var(--bs-font-sans-serif);\n  --bs-body-font-size: 1rem;\n  --bs-body-font-weight: 400;\n  --bs-body-line-height: 1.5;\n  --bs-body-color: #212529;\n  --bs-body-color-rgb: 33, 37, 41;\n  --bs-body-bg: #fff;\n  --bs-body-bg-rgb: 255, 255, 255;\n  --bs-emphasis-color: #000;\n  --bs-emphasis-color-rgb: 0, 0, 0;\n  --bs-secondary-color: rgba(33, 37, 41, 0.75);\n  --bs-secondary-color-rgb: 33, 37, 41;\n  --bs-secondary-bg: #e9ecef;\n  --bs-secondary-bg-rgb: 233, 236, 239;\n  --bs-tertiary-color: rgba(33, 37, 41, 0.5);\n  --bs-tertiary-color-rgb: 33, 37, 41;\n  --bs-tertiary-bg: #f8f9fa;\n  --bs-tertiary-bg-rgb: 248, 249, 250;\n  --bs-heading-color: inherit;\n  --bs-link-color: #0d6efd;\n  --bs-link-color-rgb: 13, 110, 253;\n  --bs-link-decoration: underline;\n  --bs-link-hover-color: rgb(4.0784313725%, 34.5098039216%, 79.3725490196%);\n  --bs-link-hover-color-rgb: 10, 88, 202;\n  --bs-code-color: #d63384;\n  --bs-highlight-color: #212529;\n  --bs-highlight-bg: rgb(100%, 95.137254902%, 80.5490196078%);\n  --bs-border-width: 1px;\n  --bs-border-style: solid;\n  --bs-border-color: #dee2e6;\n  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);\n  --bs-border-radius: 0.375rem;\n  --bs-border-radius-sm: 0.25rem;\n  --bs-border-radius-lg: 0.5rem;\n  --bs-border-radius-xl: 1rem;\n  --bs-border-radius-xxl: 2rem;\n  --bs-border-radius-2xl: var(--bs-border-radius-xxl);\n  --bs-border-radius-pill: 50rem;\n  --bs-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n  --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);\n  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);\n  --bs-focus-ring-width: 0.25rem;\n  --bs-focus-ring-opacity: 0.25;\n  --bs-focus-ring-color: rgba(13, 110, 253, 0.25);\n  --bs-form-valid-color: #198754;\n  --bs-form-valid-border-color: #198754;\n  --bs-form-invalid-color: #dc3545;\n  --bs-form-invalid-border-color: #dc3545;\n}\n\n[data-bs-theme=dark] {\n  color-scheme: dark;\n  --bs-body-color: #dee2e6;\n  --bs-body-color-rgb: 222, 226, 230;\n  --bs-body-bg: #212529;\n  --bs-body-bg-rgb: 33, 37, 41;\n  --bs-emphasis-color: #fff;\n  --bs-emphasis-color-rgb: 255, 255, 255;\n  --bs-secondary-color: rgba(222, 226, 230, 0.75);\n  --bs-secondary-color-rgb: 222, 226, 230;\n  --bs-secondary-bg: #343a40;\n  --bs-secondary-bg-rgb: 52, 58, 64;\n  --bs-tertiary-color: rgba(222, 226, 230, 0.5);\n  --bs-tertiary-color-rgb: 222, 226, 230;\n  --bs-tertiary-bg: rgb(16.6666666667%, 18.6274509804%, 20.5882352941%);\n  --bs-tertiary-bg-rgb: 43, 48, 53;\n  --bs-primary-text-emphasis: rgb(43.0588235294%, 65.8823529412%, 99.5294117647%);\n  --bs-secondary-text-emphasis: rgb(65.4117647059%, 67.5294117647%, 69.4117647059%);\n  --bs-success-text-emphasis: rgb(45.8823529412%, 71.7647058824%, 59.7647058824%);\n  --bs-info-text-emphasis: rgb(43.0588235294%, 87.5294117647%, 96.4705882353%);\n  --bs-warning-text-emphasis: rgb(100%, 85.4117647059%, 41.6470588235%);\n  --bs-danger-text-emphasis: rgb(91.7647058824%, 52.4705882353%, 56.2352941176%);\n  --bs-light-text-emphasis: #f8f9fa;\n  --bs-dark-text-emphasis: #dee2e6;\n  --bs-primary-bg-subtle: rgb(1.0196078431%, 8.6274509804%, 19.8431372549%);\n  --bs-secondary-bg-subtle: rgb(8.4705882353%, 9.1764705882%, 9.8039215686%);\n  --bs-success-bg-subtle: rgb(1.9607843137%, 10.5882352941%, 6.5882352941%);\n  --bs-info-bg-subtle: rgb(1.0196078431%, 15.8431372549%, 18.8235294118%);\n  --bs-warning-bg-subtle: rgb(20%, 15.137254902%, 0.5490196078%);\n  --bs-danger-bg-subtle: rgb(17.2549019608%, 4.1568627451%, 5.4117647059%);\n  --bs-light-bg-subtle: #343a40;\n  --bs-dark-bg-subtle: #1a1d20;\n  --bs-primary-border-subtle: rgb(3.0588235294%, 25.8823529412%, 59.5294117647%);\n  --bs-secondary-border-subtle: rgb(25.4117647059%, 27.5294117647%, 29.4117647059%);\n  --bs-success-border-subtle: rgb(5.8823529412%, 31.7647058824%, 19.7647058824%);\n  --bs-info-border-subtle: rgb(3.0588235294%, 47.5294117647%, 56.4705882353%);\n  --bs-warning-border-subtle: rgb(60%, 45.4117647059%, 1.6470588235%);\n  --bs-danger-border-subtle: rgb(51.7647058824%, 12.4705882353%, 16.2352941176%);\n  --bs-light-border-subtle: #495057;\n  --bs-dark-border-subtle: #343a40;\n  --bs-heading-color: inherit;\n  --bs-link-color: rgb(43.0588235294%, 65.8823529412%, 99.5294117647%);\n  --bs-link-hover-color: rgb(54.4470588235%, 72.7058823529%, 99.6235294118%);\n  --bs-link-color-rgb: 110, 168, 254;\n  --bs-link-hover-color-rgb: 139, 185, 254;\n  --bs-code-color: rgb(90.3529411765%, 52%, 71.0588235294%);\n  --bs-highlight-color: #dee2e6;\n  --bs-highlight-bg: rgb(40%, 30.2745098039%, 1.0980392157%);\n  --bs-border-color: #495057;\n  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);\n  --bs-form-valid-color: rgb(45.8823529412%, 71.7647058824%, 59.7647058824%);\n  --bs-form-valid-border-color: rgb(45.8823529412%, 71.7647058824%, 59.7647058824%);\n  --bs-form-invalid-color: rgb(91.7647058824%, 52.4705882353%, 56.2352941176%);\n  --bs-form-invalid-border-color: rgb(91.7647058824%, 52.4705882353%, 56.2352941176%);\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  :root {\n    scroll-behavior: smooth;\n  }\n}\n\nbody {\n  margin: 0;\n  font-family: var(--bs-body-font-family);\n  font-size: var(--bs-body-font-size);\n  font-weight: var(--bs-body-font-weight);\n  line-height: var(--bs-body-line-height);\n  color: var(--bs-body-color);\n  text-align: var(--bs-body-text-align);\n  background-color: var(--bs-body-bg);\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\nhr {\n  margin: 1rem 0;\n  color: inherit;\n  border: 0;\n  border-top: var(--bs-border-width) solid;\n  opacity: 0.25;\n}\n\nh6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  line-height: 1.2;\n  color: var(--bs-heading-color);\n}\n\nh1, .h1 {\n  font-size: calc(1.375rem + 1.5vw);\n}\n@media (min-width: 1200px) {\n  h1, .h1 {\n    font-size: 2.5rem;\n  }\n}\n\nh2, .h2 {\n  font-size: calc(1.325rem + 0.9vw);\n}\n@media (min-width: 1200px) {\n  h2, .h2 {\n    font-size: 2rem;\n  }\n}\n\nh3, .h3 {\n  font-size: calc(1.3rem + 0.6vw);\n}\n@media (min-width: 1200px) {\n  h3, .h3 {\n    font-size: 1.75rem;\n  }\n}\n\nh4, .h4 {\n  font-size: calc(1.275rem + 0.3vw);\n}\n@media (min-width: 1200px) {\n  h4, .h4 {\n    font-size: 1.5rem;\n  }\n}\n\nh5, .h5 {\n  font-size: 1.25rem;\n}\n\nh6, .h6 {\n  font-size: 1rem;\n}\n\np {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nabbr[title] {\n  text-decoration: underline dotted;\n  cursor: help;\n  text-decoration-skip-ink: none;\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: 700;\n}\n\ndd {\n  margin-bottom: 0.5rem;\n  margin-left: 0;\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\nsmall, .small {\n  font-size: 0.875em;\n}\n\nmark, .mark {\n  padding: 0.1875em;\n  color: var(--bs-highlight-color);\n  background-color: var(--bs-highlight-bg);\n}\n\nsub,\nsup {\n  position: relative;\n  font-size: 0.75em;\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\na {\n  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));\n  text-decoration: underline;\n}\na:hover {\n  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);\n}\n\na:not([href]):not([class]), a:not([href]):not([class]):hover {\n  color: inherit;\n  text-decoration: none;\n}\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: var(--bs-font-monospace);\n  font-size: 1em;\n}\n\npre {\n  display: block;\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n  font-size: 0.875em;\n}\npre code {\n  font-size: inherit;\n  color: inherit;\n  word-break: normal;\n}\n\ncode {\n  font-size: 0.875em;\n  color: var(--bs-code-color);\n  word-wrap: break-word;\n}\na > code {\n  color: inherit;\n}\n\nkbd {\n  padding: 0.1875rem 0.375rem;\n  font-size: 0.875em;\n  color: var(--bs-body-bg);\n  background-color: var(--bs-body-color);\n  border-radius: 0.25rem;\n}\nkbd kbd {\n  padding: 0;\n  font-size: 1em;\n}\n\nfigure {\n  margin: 0 0 1rem;\n}\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  color: var(--bs-secondary-color);\n  text-align: left;\n}\n\nth {\n  text-align: inherit;\n  text-align: -webkit-match-parent;\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\nlabel {\n  display: inline-block;\n}\n\nbutton {\n  border-radius: 0;\n}\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n[role=button] {\n  cursor: pointer;\n}\n\nselect {\n  word-wrap: normal;\n}\nselect:disabled {\n  opacity: 1;\n}\n\n[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\nbutton,\n[type=button],\n[type=reset],\n[type=submit] {\n  -webkit-appearance: button;\n}\nbutton:not(:disabled),\n[type=button]:not(:disabled),\n[type=reset]:not(:disabled),\n[type=submit]:not(:disabled) {\n  cursor: pointer;\n}\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ntextarea {\n  resize: vertical;\n}\n\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\nlegend {\n  float: left;\n  width: 100%;\n  padding: 0;\n  margin-bottom: 0.5rem;\n  line-height: inherit;\n  font-size: calc(1.275rem + 0.3vw);\n}\n@media (min-width: 1200px) {\n  legend {\n    font-size: 1.5rem;\n  }\n}\nlegend + * {\n  clear: left;\n}\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n[type=search] {\n  -webkit-appearance: textfield;\n  outline-offset: -2px;\n}\n[type=search]::-webkit-search-cancel-button {\n  cursor: pointer;\n  filter: grayscale(1);\n}\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n::file-selector-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\n\noutput {\n  display: inline-block;\n}\n\niframe {\n  border: 0;\n}\n\nsummary {\n  display: list-item;\n  cursor: pointer;\n}\n\nprogress {\n  vertical-align: baseline;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n.lead {\n  font-size: 1.25rem;\n  font-weight: 300;\n}\n\n.display-1 {\n  font-weight: 300;\n  line-height: 1.2;\n  font-size: calc(1.625rem + 4.5vw);\n}\n@media (min-width: 1200px) {\n  .display-1 {\n    font-size: 5rem;\n  }\n}\n\n.display-2 {\n  font-weight: 300;\n  line-height: 1.2;\n  font-size: calc(1.575rem + 3.9vw);\n}\n@media (min-width: 1200px) {\n  .display-2 {\n    font-size: 4.5rem;\n  }\n}\n\n.display-3 {\n  font-weight: 300;\n  line-height: 1.2;\n  font-size: calc(1.525rem + 3.3vw);\n}\n@media (min-width: 1200px) {\n  .display-3 {\n    font-size: 4rem;\n  }\n}\n\n.display-4 {\n  font-weight: 300;\n  line-height: 1.2;\n  font-size: calc(1.475rem + 2.7vw);\n}\n@media (min-width: 1200px) {\n  .display-4 {\n    font-size: 3.5rem;\n  }\n}\n\n.display-5 {\n  font-weight: 300;\n  line-height: 1.2;\n  font-size: calc(1.425rem + 2.1vw);\n}\n@media (min-width: 1200px) {\n  .display-5 {\n    font-size: 3rem;\n  }\n}\n\n.display-6 {\n  font-weight: 300;\n  line-height: 1.2;\n  font-size: calc(1.375rem + 1.5vw);\n}\n@media (min-width: 1200px) {\n  .display-6 {\n    font-size: 2.5rem;\n  }\n}\n\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline-item {\n  display: inline-block;\n}\n.list-inline-item:not(:last-child) {\n  margin-right: 0.5rem;\n}\n\n.initialism {\n  font-size: 0.875em;\n  text-transform: uppercase;\n}\n\n.blockquote {\n  margin-bottom: 1rem;\n  font-size: 1.25rem;\n}\n.blockquote > :last-child {\n  margin-bottom: 0;\n}\n\n.blockquote-footer {\n  margin-top: -1rem;\n  margin-bottom: 1rem;\n  font-size: 0.875em;\n  color: #6c757d;\n}\n.blockquote-footer::before {\n  content: \"— \";\n}\n\n.img-fluid {\n  max-width: 100%;\n  height: auto;\n}\n\n.img-thumbnail {\n  padding: 0.25rem;\n  background-color: var(--bs-body-bg);\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  border-radius: var(--bs-border-radius);\n  max-width: 100%;\n  height: auto;\n}\n\n.figure {\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: 0.5rem;\n  line-height: 1;\n}\n\n.figure-caption {\n  font-size: 0.875em;\n  color: var(--bs-secondary-color);\n}\n\n.container,\n.container-fluid,\n.container-xxl,\n.container-xl,\n.container-lg,\n.container-md,\n.container-sm {\n  --bs-gutter-x: 1.5rem;\n  --bs-gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@media (min-width: 576px) {\n  .container-sm, .container {\n    max-width: 540px;\n  }\n}\n@media (min-width: 768px) {\n  .container-md, .container-sm, .container {\n    max-width: 720px;\n  }\n}\n@media (min-width: 992px) {\n  .container-lg, .container-md, .container-sm, .container {\n    max-width: 960px;\n  }\n}\n@media (min-width: 1200px) {\n  .container-xl, .container-lg, .container-md, .container-sm, .container {\n    max-width: 1140px;\n  }\n}\n@media (min-width: 1400px) {\n  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {\n    max-width: 1320px;\n  }\n}\n:root {\n  --bs-breakpoint-xs: 0;\n  --bs-breakpoint-sm: 576px;\n  --bs-breakpoint-md: 768px;\n  --bs-breakpoint-lg: 992px;\n  --bs-breakpoint-xl: 1200px;\n  --bs-breakpoint-xxl: 1400px;\n}\n\n.row {\n  --bs-gutter-x: 1.5rem;\n  --bs-gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: calc(-1 * var(--bs-gutter-y));\n  margin-right: calc(-0.5 * var(--bs-gutter-x));\n  margin-left: calc(-0.5 * var(--bs-gutter-x));\n}\n.row > * {\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\n  margin-top: var(--bs-gutter-y);\n}\n\n.col {\n  flex: 1 0 0;\n}\n\n.row-cols-auto > * {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.row-cols-1 > * {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.row-cols-2 > * {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.row-cols-3 > * {\n  flex: 0 0 auto;\n  width: 33.33333333%;\n}\n\n.row-cols-4 > * {\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.row-cols-5 > * {\n  flex: 0 0 auto;\n  width: 20%;\n}\n\n.row-cols-6 > * {\n  flex: 0 0 auto;\n  width: 16.66666667%;\n}\n\n.col-auto {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.col-1 {\n  flex: 0 0 auto;\n  width: 8.33333333%;\n}\n\n.col-2 {\n  flex: 0 0 auto;\n  width: 16.66666667%;\n}\n\n.col-3 {\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.col-4 {\n  flex: 0 0 auto;\n  width: 33.33333333%;\n}\n\n.col-5 {\n  flex: 0 0 auto;\n  width: 41.66666667%;\n}\n\n.col-6 {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.col-7 {\n  flex: 0 0 auto;\n  width: 58.33333333%;\n}\n\n.col-8 {\n  flex: 0 0 auto;\n  width: 66.66666667%;\n}\n\n.col-9 {\n  flex: 0 0 auto;\n  width: 75%;\n}\n\n.col-10 {\n  flex: 0 0 auto;\n  width: 83.33333333%;\n}\n\n.col-11 {\n  flex: 0 0 auto;\n  width: 91.66666667%;\n}\n\n.col-12 {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.offset-1 {\n  margin-left: 8.33333333%;\n}\n\n.offset-2 {\n  margin-left: 16.66666667%;\n}\n\n.offset-3 {\n  margin-left: 25%;\n}\n\n.offset-4 {\n  margin-left: 33.33333333%;\n}\n\n.offset-5 {\n  margin-left: 41.66666667%;\n}\n\n.offset-6 {\n  margin-left: 50%;\n}\n\n.offset-7 {\n  margin-left: 58.33333333%;\n}\n\n.offset-8 {\n  margin-left: 66.66666667%;\n}\n\n.offset-9 {\n  margin-left: 75%;\n}\n\n.offset-10 {\n  margin-left: 83.33333333%;\n}\n\n.offset-11 {\n  margin-left: 91.66666667%;\n}\n\n.g-0,\n.gx-0 {\n  --bs-gutter-x: 0;\n}\n\n.g-0,\n.gy-0 {\n  --bs-gutter-y: 0;\n}\n\n.g-1,\n.gx-1 {\n  --bs-gutter-x: 0.25rem;\n}\n\n.g-1,\n.gy-1 {\n  --bs-gutter-y: 0.25rem;\n}\n\n.g-2,\n.gx-2 {\n  --bs-gutter-x: 0.5rem;\n}\n\n.g-2,\n.gy-2 {\n  --bs-gutter-y: 0.5rem;\n}\n\n.g-3,\n.gx-3 {\n  --bs-gutter-x: 1rem;\n}\n\n.g-3,\n.gy-3 {\n  --bs-gutter-y: 1rem;\n}\n\n.g-4,\n.gx-4 {\n  --bs-gutter-x: 1.5rem;\n}\n\n.g-4,\n.gy-4 {\n  --bs-gutter-y: 1.5rem;\n}\n\n.g-5,\n.gx-5 {\n  --bs-gutter-x: 3rem;\n}\n\n.g-5,\n.gy-5 {\n  --bs-gutter-y: 3rem;\n}\n\n@media (min-width: 576px) {\n  .col-sm {\n    flex: 1 0 0;\n  }\n  .row-cols-sm-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-sm-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-sm-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-sm-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-sm-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-sm-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-sm-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-sm-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-sm-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-sm-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-sm-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-sm-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-sm-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-sm-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-sm-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-sm-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-sm-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-sm-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-sm-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-sm-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-sm-0 {\n    margin-left: 0;\n  }\n  .offset-sm-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-sm-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-sm-3 {\n    margin-left: 25%;\n  }\n  .offset-sm-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-sm-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-sm-6 {\n    margin-left: 50%;\n  }\n  .offset-sm-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-sm-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-sm-9 {\n    margin-left: 75%;\n  }\n  .offset-sm-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-sm-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-sm-0,\n  .gx-sm-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-sm-0,\n  .gy-sm-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-sm-1,\n  .gx-sm-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-sm-1,\n  .gy-sm-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-sm-2,\n  .gx-sm-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-sm-2,\n  .gy-sm-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-sm-3,\n  .gx-sm-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-sm-3,\n  .gy-sm-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-sm-4,\n  .gx-sm-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-sm-4,\n  .gy-sm-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-sm-5,\n  .gx-sm-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-sm-5,\n  .gy-sm-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 768px) {\n  .col-md {\n    flex: 1 0 0;\n  }\n  .row-cols-md-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-md-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-md-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-md-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-md-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-md-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-md-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-md-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-md-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-md-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-md-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-md-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-md-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-md-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-md-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-md-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-md-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-md-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-md-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-md-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-md-0 {\n    margin-left: 0;\n  }\n  .offset-md-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-md-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-md-3 {\n    margin-left: 25%;\n  }\n  .offset-md-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-md-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-md-6 {\n    margin-left: 50%;\n  }\n  .offset-md-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-md-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-md-9 {\n    margin-left: 75%;\n  }\n  .offset-md-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-md-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-md-0,\n  .gx-md-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-md-0,\n  .gy-md-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-md-1,\n  .gx-md-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-md-1,\n  .gy-md-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-md-2,\n  .gx-md-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-md-2,\n  .gy-md-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-md-3,\n  .gx-md-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-md-3,\n  .gy-md-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-md-4,\n  .gx-md-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-md-4,\n  .gy-md-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-md-5,\n  .gx-md-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-md-5,\n  .gy-md-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 992px) {\n  .col-lg {\n    flex: 1 0 0;\n  }\n  .row-cols-lg-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-lg-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-lg-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-lg-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-lg-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-lg-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-lg-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-lg-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-lg-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-lg-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-lg-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-lg-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-lg-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-lg-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-lg-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-lg-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-lg-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-lg-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-lg-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-lg-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-lg-0 {\n    margin-left: 0;\n  }\n  .offset-lg-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-lg-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-lg-3 {\n    margin-left: 25%;\n  }\n  .offset-lg-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-lg-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-lg-6 {\n    margin-left: 50%;\n  }\n  .offset-lg-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-lg-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-lg-9 {\n    margin-left: 75%;\n  }\n  .offset-lg-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-lg-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-lg-0,\n  .gx-lg-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-lg-0,\n  .gy-lg-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-lg-1,\n  .gx-lg-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-lg-1,\n  .gy-lg-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-lg-2,\n  .gx-lg-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-lg-2,\n  .gy-lg-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-lg-3,\n  .gx-lg-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-lg-3,\n  .gy-lg-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-lg-4,\n  .gx-lg-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-lg-4,\n  .gy-lg-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-lg-5,\n  .gx-lg-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-lg-5,\n  .gy-lg-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 1200px) {\n  .col-xl {\n    flex: 1 0 0;\n  }\n  .row-cols-xl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-xl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-xl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-xl-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-xl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-xl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-xl-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-xl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-xl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-xl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-xl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-xl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-xl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-xl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-xl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-xl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-xl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-xl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-xl-0 {\n    margin-left: 0;\n  }\n  .offset-xl-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-xl-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-xl-3 {\n    margin-left: 25%;\n  }\n  .offset-xl-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-xl-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-xl-6 {\n    margin-left: 50%;\n  }\n  .offset-xl-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-xl-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-xl-9 {\n    margin-left: 75%;\n  }\n  .offset-xl-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-xl-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-xl-0,\n  .gx-xl-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-xl-0,\n  .gy-xl-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-xl-1,\n  .gx-xl-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-xl-1,\n  .gy-xl-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-xl-2,\n  .gx-xl-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-xl-2,\n  .gy-xl-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-xl-3,\n  .gx-xl-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-xl-3,\n  .gy-xl-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-xl-4,\n  .gx-xl-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-xl-4,\n  .gy-xl-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-xl-5,\n  .gx-xl-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-xl-5,\n  .gy-xl-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 1400px) {\n  .col-xxl {\n    flex: 1 0 0;\n  }\n  .row-cols-xxl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-xxl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-xxl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-xxl-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-xxl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-xxl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-xxl-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xxl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-xxl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-xxl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xxl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-xxl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-xxl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-xxl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-xxl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-xxl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-xxl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-xxl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-xxl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-xxl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-xxl-0 {\n    margin-left: 0;\n  }\n  .offset-xxl-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-xxl-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-xxl-3 {\n    margin-left: 25%;\n  }\n  .offset-xxl-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-xxl-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-xxl-6 {\n    margin-left: 50%;\n  }\n  .offset-xxl-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-xxl-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-xxl-9 {\n    margin-left: 75%;\n  }\n  .offset-xxl-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-xxl-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-xxl-0,\n  .gx-xxl-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-xxl-0,\n  .gy-xxl-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-xxl-1,\n  .gx-xxl-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-xxl-1,\n  .gy-xxl-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-xxl-2,\n  .gx-xxl-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-xxl-2,\n  .gy-xxl-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-xxl-3,\n  .gx-xxl-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-xxl-3,\n  .gy-xxl-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-xxl-4,\n  .gx-xxl-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-xxl-4,\n  .gy-xxl-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-xxl-5,\n  .gx-xxl-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-xxl-5,\n  .gy-xxl-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n.table {\n  --bs-table-color-type: initial;\n  --bs-table-bg-type: initial;\n  --bs-table-color-state: initial;\n  --bs-table-bg-state: initial;\n  --bs-table-color: var(--bs-emphasis-color);\n  --bs-table-bg: var(--bs-body-bg);\n  --bs-table-border-color: var(--bs-border-color);\n  --bs-table-accent-bg: transparent;\n  --bs-table-striped-color: var(--bs-emphasis-color);\n  --bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05);\n  --bs-table-active-color: var(--bs-emphasis-color);\n  --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1);\n  --bs-table-hover-color: var(--bs-emphasis-color);\n  --bs-table-hover-bg: rgba(var(--bs-emphasis-color-rgb), 0.075);\n  width: 100%;\n  margin-bottom: 1rem;\n  vertical-align: top;\n  border-color: var(--bs-table-border-color);\n}\n.table > :not(caption) > * > * {\n  padding: 0.5rem 0.5rem;\n  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));\n  background-color: var(--bs-table-bg);\n  border-bottom-width: var(--bs-border-width);\n  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));\n}\n.table > tbody {\n  vertical-align: inherit;\n}\n.table > thead {\n  vertical-align: bottom;\n}\n\n.table-group-divider {\n  border-top: calc(var(--bs-border-width) * 2) solid currentcolor;\n}\n\n.caption-top {\n  caption-side: top;\n}\n\n.table-sm > :not(caption) > * > * {\n  padding: 0.25rem 0.25rem;\n}\n\n.table-bordered > :not(caption) > * {\n  border-width: var(--bs-border-width) 0;\n}\n.table-bordered > :not(caption) > * > * {\n  border-width: 0 var(--bs-border-width);\n}\n\n.table-borderless > :not(caption) > * > * {\n  border-bottom-width: 0;\n}\n.table-borderless > :not(:first-child) {\n  border-top-width: 0;\n}\n\n.table-striped > tbody > tr:nth-of-type(odd) > * {\n  --bs-table-color-type: var(--bs-table-striped-color);\n  --bs-table-bg-type: var(--bs-table-striped-bg);\n}\n\n.table-striped-columns > :not(caption) > tr > :nth-child(even) {\n  --bs-table-color-type: var(--bs-table-striped-color);\n  --bs-table-bg-type: var(--bs-table-striped-bg);\n}\n\n.table-active {\n  --bs-table-color-state: var(--bs-table-active-color);\n  --bs-table-bg-state: var(--bs-table-active-bg);\n}\n\n.table-hover > tbody > tr:hover > * {\n  --bs-table-color-state: var(--bs-table-hover-color);\n  --bs-table-bg-state: var(--bs-table-hover-bg);\n}\n\n.table-primary {\n  --bs-table-color: #000;\n  --bs-table-bg: rgb(81.0196078431%, 88.6274509804%, 99.8431372549%);\n  --bs-table-border-color: rgb(64.8156862745%, 70.9019607843%, 79.8745098039%);\n  --bs-table-striped-bg: rgb(76.968627451%, 84.1960784314%, 94.8509803922%);\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: rgb(72.9176470588%, 79.7647058824%, 89.8588235294%);\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: rgb(74.9431372549%, 81.9803921569%, 92.3549019608%);\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-secondary {\n  --bs-table-color: #000;\n  --bs-table-bg: rgb(88.4705882353%, 89.1764705882%, 89.8039215686%);\n  --bs-table-border-color: rgb(70.7764705882%, 71.3411764706%, 71.8431372549%);\n  --bs-table-striped-bg: rgb(84.0470588235%, 84.7176470588%, 85.3137254902%);\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: rgb(79.6235294118%, 80.2588235294%, 80.8235294118%);\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: rgb(81.8352941176%, 82.4882352941%, 83.068627451%);\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-success {\n  --bs-table-color: #000;\n  --bs-table-bg: rgb(81.9607843137%, 90.5882352941%, 86.5882352941%);\n  --bs-table-border-color: rgb(65.568627451%, 72.4705882353%, 69.2705882353%);\n  --bs-table-striped-bg: rgb(77.862745098%, 86.0588235294%, 82.2588235294%);\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: rgb(73.7647058824%, 81.5294117647%, 77.9294117647%);\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: rgb(75.8137254902%, 83.7941176471%, 80.0941176471%);\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-info {\n  --bs-table-color: #000;\n  --bs-table-bg: rgb(81.0196078431%, 95.8431372549%, 98.8235294118%);\n  --bs-table-border-color: rgb(64.8156862745%, 76.6745098039%, 79.0588235294%);\n  --bs-table-striped-bg: rgb(76.968627451%, 91.0509803922%, 93.8823529412%);\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: rgb(72.9176470588%, 86.2588235294%, 88.9411764706%);\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: rgb(74.9431372549%, 88.6549019608%, 91.4117647059%);\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-warning {\n  --bs-table-color: #000;\n  --bs-table-bg: rgb(100%, 95.137254902%, 80.5490196078%);\n  --bs-table-border-color: rgb(80%, 76.1098039216%, 64.4392156863%);\n  --bs-table-striped-bg: rgb(95%, 90.3803921569%, 76.5215686275%);\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: rgb(90%, 85.6235294118%, 72.4941176471%);\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: rgb(92.5%, 88.0019607843%, 74.5078431373%);\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-danger {\n  --bs-table-color: #000;\n  --bs-table-bg: rgb(97.2549019608%, 84.1568627451%, 85.4117647059%);\n  --bs-table-border-color: rgb(77.8039215686%, 67.3254901961%, 68.3294117647%);\n  --bs-table-striped-bg: rgb(92.3921568627%, 79.9490196078%, 81.1411764706%);\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: rgb(87.5294117647%, 75.7411764706%, 76.8705882353%);\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: rgb(89.9607843137%, 77.8450980392%, 79.0058823529%);\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-light {\n  --bs-table-color: #000;\n  --bs-table-bg: #f8f9fa;\n  --bs-table-border-color: rgb(77.8039215686%, 78.1176470588%, 78.431372549%);\n  --bs-table-striped-bg: rgb(92.3921568627%, 92.7647058824%, 93.137254902%);\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: rgb(87.5294117647%, 87.8823529412%, 88.2352941176%);\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: rgb(89.9607843137%, 90.3235294118%, 90.6862745098%);\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-dark {\n  --bs-table-color: #fff;\n  --bs-table-bg: #212529;\n  --bs-table-border-color: rgb(30.3529411765%, 31.6078431373%, 32.862745098%);\n  --bs-table-striped-bg: rgb(17.2941176471%, 18.7843137255%, 20.2745098039%);\n  --bs-table-striped-color: #fff;\n  --bs-table-active-bg: rgb(21.6470588235%, 23.0588235294%, 24.4705882353%);\n  --bs-table-active-color: #fff;\n  --bs-table-hover-bg: rgb(19.4705882353%, 20.9215686275%, 22.3725490196%);\n  --bs-table-hover-color: #fff;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-responsive {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n@media (max-width: 575.98px) {\n  .table-responsive-sm {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 767.98px) {\n  .table-responsive-md {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 991.98px) {\n  .table-responsive-lg {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 1199.98px) {\n  .table-responsive-xl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 1399.98px) {\n  .table-responsive-xxl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n.form-label {\n  margin-bottom: 0.5rem;\n}\n\n.col-form-label {\n  padding-top: calc(0.375rem + var(--bs-border-width));\n  padding-bottom: calc(0.375rem + var(--bs-border-width));\n  margin-bottom: 0;\n  font-size: inherit;\n  line-height: 1.5;\n}\n\n.col-form-label-lg {\n  padding-top: calc(0.5rem + var(--bs-border-width));\n  padding-bottom: calc(0.5rem + var(--bs-border-width));\n  font-size: 1.25rem;\n}\n\n.col-form-label-sm {\n  padding-top: calc(0.25rem + var(--bs-border-width));\n  padding-bottom: calc(0.25rem + var(--bs-border-width));\n  font-size: 0.875rem;\n}\n\n.form-text {\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: var(--bs-secondary-color);\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--bs-body-color);\n  appearance: none;\n  background-color: var(--bs-body-bg);\n  background-clip: padding-box;\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  border-radius: var(--bs-border-radius);\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control {\n    transition: none;\n  }\n}\n.form-control[type=file] {\n  overflow: hidden;\n}\n.form-control[type=file]:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n.form-control:focus {\n  color: var(--bs-body-color);\n  background-color: var(--bs-body-bg);\n  border-color: rgb(52.5490196078%, 71.568627451%, 99.6078431373%);\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n.form-control::-webkit-date-and-time-value {\n  min-width: 85px;\n  height: 1.5em;\n  margin: 0;\n}\n.form-control::-webkit-datetime-edit {\n  display: block;\n  padding: 0;\n}\n.form-control::placeholder {\n  color: var(--bs-secondary-color);\n  opacity: 1;\n}\n.form-control:disabled {\n  background-color: var(--bs-secondary-bg);\n  opacity: 1;\n}\n.form-control::file-selector-button {\n  padding: 0.375rem 0.75rem;\n  margin: -0.375rem -0.75rem;\n  margin-inline-end: 0.75rem;\n  color: var(--bs-body-color);\n  background-color: var(--bs-tertiary-bg);\n  pointer-events: none;\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n  border-inline-end-width: var(--bs-border-width);\n  border-radius: 0;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control::file-selector-button {\n    transition: none;\n  }\n}\n.form-control:hover:not(:disabled):not([readonly])::file-selector-button {\n  background-color: var(--bs-secondary-bg);\n}\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0;\n  margin-bottom: 0;\n  line-height: 1.5;\n  color: var(--bs-body-color);\n  background-color: transparent;\n  border: solid transparent;\n  border-width: var(--bs-border-width) 0;\n}\n.form-control-plaintext:focus {\n  outline: 0;\n}\n.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.form-control-sm {\n  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  border-radius: var(--bs-border-radius-sm);\n}\n.form-control-sm::file-selector-button {\n  padding: 0.25rem 0.5rem;\n  margin: -0.25rem -0.5rem;\n  margin-inline-end: 0.5rem;\n}\n\n.form-control-lg {\n  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));\n  padding: 0.5rem 1rem;\n  font-size: 1.25rem;\n  border-radius: var(--bs-border-radius-lg);\n}\n.form-control-lg::file-selector-button {\n  padding: 0.5rem 1rem;\n  margin: -0.5rem -1rem;\n  margin-inline-end: 1rem;\n}\n\ntextarea.form-control {\n  min-height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));\n}\ntextarea.form-control-sm {\n  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));\n}\ntextarea.form-control-lg {\n  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));\n}\n\n.form-control-color {\n  width: 3rem;\n  height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));\n  padding: 0.375rem;\n}\n.form-control-color:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n.form-control-color::-moz-color-swatch {\n  border: 0 !important;\n  border-radius: var(--bs-border-radius);\n}\n.form-control-color::-webkit-color-swatch {\n  border: 0 !important;\n  border-radius: var(--bs-border-radius);\n}\n.form-control-color.form-control-sm {\n  height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));\n}\n.form-control-color.form-control-lg {\n  height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));\n}\n\n.form-select {\n  --bs-form-select-bg-img: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n  display: block;\n  width: 100%;\n  padding: 0.375rem 2.25rem 0.375rem 0.75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--bs-body-color);\n  appearance: none;\n  background-color: var(--bs-body-bg);\n  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: right 0.75rem center;\n  background-size: 16px 12px;\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  border-radius: var(--bs-border-radius);\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-select {\n    transition: none;\n  }\n}\n.form-select:focus {\n  border-color: rgb(52.5490196078%, 71.568627451%, 99.6078431373%);\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n.form-select[multiple], .form-select[size]:not([size=\"1\"]) {\n  padding-right: 0.75rem;\n  background-image: none;\n}\n.form-select:disabled {\n  background-color: var(--bs-secondary-bg);\n}\n.form-select:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 var(--bs-body-color);\n}\n\n.form-select-sm {\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  padding-left: 0.5rem;\n  font-size: 0.875rem;\n  border-radius: var(--bs-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  padding-left: 1rem;\n  font-size: 1.25rem;\n  border-radius: var(--bs-border-radius-lg);\n}\n\n[data-bs-theme=dark] .form-select {\n  --bs-form-select-bg-img: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23dee2e6' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n}\n\n.form-check {\n  display: block;\n  min-height: 1.5rem;\n  padding-left: 1.5em;\n  margin-bottom: 0.125rem;\n}\n.form-check .form-check-input {\n  float: left;\n  margin-left: -1.5em;\n}\n\n.form-check-reverse {\n  padding-right: 1.5em;\n  padding-left: 0;\n  text-align: right;\n}\n.form-check-reverse .form-check-input {\n  float: right;\n  margin-right: -1.5em;\n  margin-left: 0;\n}\n\n.form-check-input {\n  --bs-form-check-bg: var(--bs-body-bg);\n  flex-shrink: 0;\n  width: 1em;\n  height: 1em;\n  margin-top: 0.25em;\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--bs-form-check-bg);\n  background-image: var(--bs-form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  print-color-adjust: exact;\n}\n.form-check-input[type=checkbox] {\n  border-radius: 0.25em;\n}\n.form-check-input[type=radio] {\n  border-radius: 50%;\n}\n.form-check-input:active {\n  filter: brightness(90%);\n}\n.form-check-input:focus {\n  border-color: rgb(52.5490196078%, 71.568627451%, 99.6078431373%);\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n.form-check-input:checked {\n  background-color: #0d6efd;\n  border-color: #0d6efd;\n}\n.form-check-input:checked[type=checkbox] {\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e\");\n}\n.form-check-input:checked[type=radio] {\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23fff'/%3e%3c/svg%3e\");\n}\n.form-check-input[type=checkbox]:indeterminate {\n  background-color: #0d6efd;\n  border-color: #0d6efd;\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e\");\n}\n.form-check-input:disabled {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.5;\n}\n.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {\n  cursor: default;\n  opacity: 0.5;\n}\n\n.form-switch {\n  padding-left: 2.5em;\n}\n.form-switch .form-check-input {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e\");\n  width: 2em;\n  margin-left: -2.5em;\n  background-image: var(--bs-form-switch-bg);\n  background-position: left center;\n  border-radius: 2em;\n  transition: background-position 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-switch .form-check-input {\n    transition: none;\n  }\n}\n.form-switch .form-check-input:focus {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgb%2852.5490196078%, 71.568627451%, 99.6078431373%%29'/%3e%3c/svg%3e\");\n}\n.form-switch .form-check-input:checked {\n  background-position: right center;\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\");\n}\n.form-switch.form-check-reverse {\n  padding-right: 2.5em;\n  padding-left: 0;\n}\n.form-switch.form-check-reverse .form-check-input {\n  margin-right: -2.5em;\n  margin-left: 0;\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: 1rem;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n.btn-check[disabled] + .btn, .btn-check:disabled + .btn {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.65;\n}\n\n[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%28255, 255, 255, 0.25%29'/%3e%3c/svg%3e\");\n}\n\n.form-range {\n  width: 100%;\n  height: 1.5rem;\n  padding: 0;\n  appearance: none;\n  background-color: transparent;\n}\n.form-range:focus {\n  outline: 0;\n}\n.form-range:focus::-webkit-slider-thumb {\n  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n.form-range:focus::-moz-range-thumb {\n  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n.form-range::-moz-focus-outer {\n  border: 0;\n}\n.form-range::-webkit-slider-thumb {\n  width: 1rem;\n  height: 1rem;\n  margin-top: -0.25rem;\n  appearance: none;\n  background-color: #0d6efd;\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-webkit-slider-thumb {\n    transition: none;\n  }\n}\n.form-range::-webkit-slider-thumb:active {\n  background-color: rgb(71.5294117647%, 82.9411764706%, 99.7647058824%);\n}\n.form-range::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: var(--bs-secondary-bg);\n  border-color: transparent;\n  border-radius: 1rem;\n}\n.form-range::-moz-range-thumb {\n  width: 1rem;\n  height: 1rem;\n  appearance: none;\n  background-color: #0d6efd;\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-moz-range-thumb {\n    transition: none;\n  }\n}\n.form-range::-moz-range-thumb:active {\n  background-color: rgb(71.5294117647%, 82.9411764706%, 99.7647058824%);\n}\n.form-range::-moz-range-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: var(--bs-secondary-bg);\n  border-color: transparent;\n  border-radius: 1rem;\n}\n.form-range:disabled {\n  pointer-events: none;\n}\n.form-range:disabled::-webkit-slider-thumb {\n  background-color: var(--bs-secondary-color);\n}\n.form-range:disabled::-moz-range-thumb {\n  background-color: var(--bs-secondary-color);\n}\n\n.form-floating {\n  position: relative;\n}\n.form-floating > .form-control,\n.form-floating > .form-control-plaintext,\n.form-floating > .form-select {\n  height: calc(3.5rem + calc(var(--bs-border-width) * 2));\n  min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));\n  line-height: 1.25;\n}\n.form-floating > label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2;\n  max-width: 100%;\n  height: 100%;\n  padding: 1rem 0.75rem;\n  overflow: hidden;\n  color: rgba(var(--bs-body-color-rgb), 0.65);\n  text-align: start;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  pointer-events: none;\n  border: var(--bs-border-width) solid transparent;\n  transform-origin: 0 0;\n  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-floating > label {\n    transition: none;\n  }\n}\n.form-floating > .form-control,\n.form-floating > .form-control-plaintext {\n  padding: 1rem 0.75rem;\n}\n.form-floating > .form-control::placeholder,\n.form-floating > .form-control-plaintext::placeholder {\n  color: transparent;\n}\n.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),\n.form-floating > .form-control-plaintext:focus,\n.form-floating > .form-control-plaintext:not(:placeholder-shown) {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-control:-webkit-autofill,\n.form-floating > .form-control-plaintext:-webkit-autofill {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-select {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n  padding-left: 0.75rem;\n}\n.form-floating > .form-control:focus ~ label,\n.form-floating > .form-control:not(:placeholder-shown) ~ label,\n.form-floating > .form-control-plaintext ~ label,\n.form-floating > .form-select ~ label {\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n.form-floating > .form-control:-webkit-autofill ~ label {\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n.form-floating > textarea:focus ~ label::after,\n.form-floating > textarea:not(:placeholder-shown) ~ label::after {\n  position: absolute;\n  inset: 1rem 0.375rem;\n  z-index: -1;\n  height: 1.5em;\n  content: \"\";\n  background-color: var(--bs-body-bg);\n  border-radius: var(--bs-border-radius);\n}\n.form-floating > textarea:disabled ~ label::after {\n  background-color: var(--bs-secondary-bg);\n}\n.form-floating > .form-control-plaintext ~ label {\n  border-width: var(--bs-border-width) 0;\n}\n.form-floating > :disabled ~ label,\n.form-floating > .form-control:disabled ~ label {\n  color: #6c757d;\n}\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  width: 100%;\n}\n.input-group > .form-control,\n.input-group > .form-select,\n.input-group > .form-floating {\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%;\n  min-width: 0;\n}\n.input-group > .form-control:focus,\n.input-group > .form-select:focus,\n.input-group > .form-floating:focus-within {\n  z-index: 5;\n}\n.input-group .btn {\n  position: relative;\n  z-index: 2;\n}\n.input-group .btn:focus {\n  z-index: 5;\n}\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--bs-body-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--bs-tertiary-bg);\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  border-radius: var(--bs-border-radius);\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: 0.5rem 1rem;\n  font-size: 1.25rem;\n  border-radius: var(--bs-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  border-radius: var(--bs-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: 3rem;\n}\n\n.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),\n.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,\n.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),\n.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,\n.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {\n  margin-left: calc(-1 * var(--bs-border-width));\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group > .form-floating:not(:first-child) > .form-control,\n.input-group > .form-floating:not(:first-child) > .form-select {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.valid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: var(--bs-form-valid-color);\n}\n\n.valid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: 0.1rem;\n  font-size: 0.875rem;\n  color: #fff;\n  background-color: var(--bs-success);\n  border-radius: var(--bs-border-radius);\n}\n\n.was-validated :valid ~ .valid-feedback,\n.was-validated :valid ~ .valid-tooltip,\n.is-valid ~ .valid-feedback,\n.is-valid ~ .valid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:valid, .form-control.is-valid {\n  border-color: var(--bs-form-valid-border-color);\n  padding-right: calc(1.5em + 0.75rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .form-control:valid:focus, .form-control.is-valid:focus {\n  border-color: var(--bs-form-valid-border-color);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n}\n\n.was-validated textarea.form-control:valid, textarea.form-control.is-valid {\n  padding-right: calc(1.5em + 0.75rem);\n  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);\n}\n\n.was-validated .form-select:valid, .form-select.is-valid {\n  border-color: var(--bs-form-valid-border-color);\n}\n.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size=\"1\"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size=\"1\"] {\n  --bs-form-select-bg-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1'/%3e%3c/svg%3e\");\n  padding-right: 4.125rem;\n  background-position: right 0.75rem center, center right 2.25rem;\n  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .form-select:valid:focus, .form-select.is-valid:focus {\n  border-color: var(--bs-form-valid-border-color);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n}\n\n.was-validated .form-control-color:valid, .form-control-color.is-valid {\n  width: calc(3rem + calc(1.5em + 0.75rem));\n}\n\n.was-validated .form-check-input:valid, .form-check-input.is-valid {\n  border-color: var(--bs-form-valid-border-color);\n}\n.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {\n  background-color: var(--bs-form-valid-color);\n}\n.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n}\n.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {\n  color: var(--bs-form-valid-color);\n}\n\n.form-check-inline .form-check-input ~ .valid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,\n.was-validated .input-group > .form-select:not(:focus):valid,\n.input-group > .form-select:not(:focus).is-valid,\n.was-validated .input-group > .form-floating:not(:focus-within):valid,\n.input-group > .form-floating:not(:focus-within).is-valid {\n  z-index: 3;\n}\n\n.invalid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: var(--bs-form-invalid-color);\n}\n\n.invalid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: 0.1rem;\n  font-size: 0.875rem;\n  color: #fff;\n  background-color: var(--bs-danger);\n  border-radius: var(--bs-border-radius);\n}\n\n.was-validated :invalid ~ .invalid-feedback,\n.was-validated :invalid ~ .invalid-tooltip,\n.is-invalid ~ .invalid-feedback,\n.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:invalid, .form-control.is-invalid {\n  border-color: var(--bs-form-invalid-border-color);\n  padding-right: calc(1.5em + 0.75rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {\n  border-color: var(--bs-form-invalid-border-color);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n}\n\n.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {\n  padding-right: calc(1.5em + 0.75rem);\n  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);\n}\n\n.was-validated .form-select:invalid, .form-select.is-invalid {\n  border-color: var(--bs-form-invalid-border-color);\n}\n.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size=\"1\"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size=\"1\"] {\n  --bs-form-select-bg-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");\n  padding-right: 4.125rem;\n  background-position: right 0.75rem center, center right 2.25rem;\n  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {\n  border-color: var(--bs-form-invalid-border-color);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n}\n\n.was-validated .form-control-color:invalid, .form-control-color.is-invalid {\n  width: calc(3rem + calc(1.5em + 0.75rem));\n}\n\n.was-validated .form-check-input:invalid, .form-check-input.is-invalid {\n  border-color: var(--bs-form-invalid-border-color);\n}\n.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {\n  background-color: var(--bs-form-invalid-color);\n}\n.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n}\n.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {\n  color: var(--bs-form-invalid-color);\n}\n\n.form-check-inline .form-check-input ~ .invalid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,\n.was-validated .input-group > .form-select:not(:focus):invalid,\n.input-group > .form-select:not(:focus).is-invalid,\n.was-validated .input-group > .form-floating:not(:focus-within):invalid,\n.input-group > .form-floating:not(:focus-within).is-invalid {\n  z-index: 4;\n}\n\n.btn {\n  --bs-btn-padding-x: 0.75rem;\n  --bs-btn-padding-y: 0.375rem;\n  --bs-btn-font-family: ;\n  --bs-btn-font-size: 1rem;\n  --bs-btn-font-weight: 400;\n  --bs-btn-line-height: 1.5;\n  --bs-btn-color: var(--bs-body-color);\n  --bs-btn-bg: transparent;\n  --bs-btn-border-width: var(--bs-border-width);\n  --bs-btn-border-color: transparent;\n  --bs-btn-border-radius: var(--bs-border-radius);\n  --bs-btn-hover-border-color: transparent;\n  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);\n  --bs-btn-disabled-opacity: 0.65;\n  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);\n  display: inline-block;\n  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);\n  font-family: var(--bs-btn-font-family);\n  font-size: var(--bs-btn-font-size);\n  font-weight: var(--bs-btn-font-weight);\n  line-height: var(--bs-btn-line-height);\n  color: var(--bs-btn-color);\n  text-align: center;\n  text-decoration: none;\n  vertical-align: middle;\n  cursor: pointer;\n  user-select: none;\n  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);\n  border-radius: var(--bs-btn-border-radius);\n  background-color: var(--bs-btn-bg);\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .btn {\n    transition: none;\n  }\n}\n.btn:hover {\n  color: var(--bs-btn-hover-color);\n  background-color: var(--bs-btn-hover-bg);\n  border-color: var(--bs-btn-hover-border-color);\n}\n.btn-check + .btn:hover {\n  color: var(--bs-btn-color);\n  background-color: var(--bs-btn-bg);\n  border-color: var(--bs-btn-border-color);\n}\n.btn:focus-visible {\n  color: var(--bs-btn-hover-color);\n  background-color: var(--bs-btn-hover-bg);\n  border-color: var(--bs-btn-hover-border-color);\n  outline: 0;\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n.btn-check:focus-visible + .btn {\n  border-color: var(--bs-btn-hover-border-color);\n  outline: 0;\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {\n  color: var(--bs-btn-active-color);\n  background-color: var(--bs-btn-active-bg);\n  border-color: var(--bs-btn-active-border-color);\n}\n.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n.btn-check:checked:focus-visible + .btn {\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n.btn:disabled, .btn.disabled, fieldset:disabled .btn {\n  color: var(--bs-btn-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-btn-disabled-bg);\n  border-color: var(--bs-btn-disabled-border-color);\n  opacity: var(--bs-btn-disabled-opacity);\n}\n\n.btn-primary {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #0d6efd;\n  --bs-btn-border-color: #0d6efd;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: rgb(4.3333333333%, 36.6666666667%, 84.3333333333%);\n  --bs-btn-hover-border-color: rgb(4.0784313725%, 34.5098039216%, 79.3725490196%);\n  --bs-btn-focus-shadow-rgb: 49, 132, 253;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: rgb(4.0784313725%, 34.5098039216%, 79.3725490196%);\n  --bs-btn-active-border-color: rgb(3.8235294118%, 32.3529411765%, 74.4117647059%);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #0d6efd;\n  --bs-btn-disabled-border-color: #0d6efd;\n}\n\n.btn-secondary {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #6c757d;\n  --bs-btn-border-color: #6c757d;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: rgb(36%, 39%, 41.6666666667%);\n  --bs-btn-hover-border-color: rgb(33.8823529412%, 36.7058823529%, 39.2156862745%);\n  --bs-btn-focus-shadow-rgb: 130, 138, 145;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: rgb(33.8823529412%, 36.7058823529%, 39.2156862745%);\n  --bs-btn-active-border-color: rgb(31.7647058824%, 34.4117647059%, 36.7647058824%);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #6c757d;\n  --bs-btn-disabled-border-color: #6c757d;\n}\n\n.btn-success {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #198754;\n  --bs-btn-border-color: #198754;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: rgb(8.3333333333%, 45%, 28%);\n  --bs-btn-hover-border-color: rgb(7.8431372549%, 42.3529411765%, 26.3529411765%);\n  --bs-btn-focus-shadow-rgb: 60, 153, 110;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: rgb(7.8431372549%, 42.3529411765%, 26.3529411765%);\n  --bs-btn-active-border-color: rgb(7.3529411765%, 39.7058823529%, 24.7058823529%);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #198754;\n  --bs-btn-disabled-border-color: #198754;\n}\n\n.btn-info {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #0dcaf0;\n  --bs-btn-border-color: #0dcaf0;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(19.3333333333%, 82.3333333333%, 95%);\n  --bs-btn-hover-border-color: rgb(14.5882352941%, 81.2941176471%, 94.7058823529%);\n  --bs-btn-focus-shadow-rgb: 11, 172, 204;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(24.0784313725%, 83.3725490196%, 95.2941176471%);\n  --bs-btn-active-border-color: rgb(14.5882352941%, 81.2941176471%, 94.7058823529%);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #0dcaf0;\n  --bs-btn-disabled-border-color: #0dcaf0;\n}\n\n.btn-warning {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #ffc107;\n  --bs-btn-border-color: #ffc107;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(100%, 79.3333333333%, 17.3333333333%);\n  --bs-btn-hover-border-color: rgb(100%, 78.1176470588%, 12.4705882353%);\n  --bs-btn-focus-shadow-rgb: 217, 164, 6;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(100%, 80.5490196078%, 22.1960784314%);\n  --bs-btn-active-border-color: rgb(100%, 78.1176470588%, 12.4705882353%);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #ffc107;\n  --bs-btn-disabled-border-color: #ffc107;\n}\n\n.btn-danger {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #dc3545;\n  --bs-btn-border-color: #dc3545;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: rgb(73.3333333333%, 17.6666666667%, 23%);\n  --bs-btn-hover-border-color: rgb(69.0196078431%, 16.6274509804%, 21.6470588235%);\n  --bs-btn-focus-shadow-rgb: 225, 83, 97;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: rgb(69.0196078431%, 16.6274509804%, 21.6470588235%);\n  --bs-btn-active-border-color: rgb(64.7058823529%, 15.5882352941%, 20.2941176471%);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #dc3545;\n  --bs-btn-disabled-border-color: #dc3545;\n}\n\n.btn-light {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #f8f9fa;\n  --bs-btn-border-color: #f8f9fa;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(82.6666666667%, 83%, 83.3333333333%);\n  --bs-btn-hover-border-color: rgb(77.8039215686%, 78.1176470588%, 78.431372549%);\n  --bs-btn-focus-shadow-rgb: 211, 212, 213;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(77.8039215686%, 78.1176470588%, 78.431372549%);\n  --bs-btn-active-border-color: rgb(72.9411764706%, 73.2352941176%, 73.5294117647%);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #f8f9fa;\n  --bs-btn-disabled-border-color: #f8f9fa;\n}\n\n.btn-dark {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #212529;\n  --bs-btn-border-color: #212529;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: rgb(26%, 27.3333333333%, 28.6666666667%);\n  --bs-btn-hover-border-color: rgb(21.6470588235%, 23.0588235294%, 24.4705882353%);\n  --bs-btn-focus-shadow-rgb: 66, 70, 73;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: rgb(30.3529411765%, 31.6078431373%, 32.862745098%);\n  --bs-btn-active-border-color: rgb(21.6470588235%, 23.0588235294%, 24.4705882353%);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #212529;\n  --bs-btn-disabled-border-color: #212529;\n}\n\n.btn-outline-primary {\n  --bs-btn-color: #0d6efd;\n  --bs-btn-border-color: #0d6efd;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #0d6efd;\n  --bs-btn-hover-border-color: #0d6efd;\n  --bs-btn-focus-shadow-rgb: 13, 110, 253;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #0d6efd;\n  --bs-btn-active-border-color: #0d6efd;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #0d6efd;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #0d6efd;\n  --bs-gradient: none;\n}\n\n.btn-outline-secondary {\n  --bs-btn-color: #6c757d;\n  --bs-btn-border-color: #6c757d;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #6c757d;\n  --bs-btn-hover-border-color: #6c757d;\n  --bs-btn-focus-shadow-rgb: 108, 117, 125;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #6c757d;\n  --bs-btn-active-border-color: #6c757d;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #6c757d;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #6c757d;\n  --bs-gradient: none;\n}\n\n.btn-outline-success {\n  --bs-btn-color: #198754;\n  --bs-btn-border-color: #198754;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #198754;\n  --bs-btn-hover-border-color: #198754;\n  --bs-btn-focus-shadow-rgb: 25, 135, 84;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #198754;\n  --bs-btn-active-border-color: #198754;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #198754;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #198754;\n  --bs-gradient: none;\n}\n\n.btn-outline-info {\n  --bs-btn-color: #0dcaf0;\n  --bs-btn-border-color: #0dcaf0;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #0dcaf0;\n  --bs-btn-hover-border-color: #0dcaf0;\n  --bs-btn-focus-shadow-rgb: 13, 202, 240;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #0dcaf0;\n  --bs-btn-active-border-color: #0dcaf0;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #0dcaf0;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #0dcaf0;\n  --bs-gradient: none;\n}\n\n.btn-outline-warning {\n  --bs-btn-color: #ffc107;\n  --bs-btn-border-color: #ffc107;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #ffc107;\n  --bs-btn-hover-border-color: #ffc107;\n  --bs-btn-focus-shadow-rgb: 255, 193, 7;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #ffc107;\n  --bs-btn-active-border-color: #ffc107;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffc107;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #ffc107;\n  --bs-gradient: none;\n}\n\n.btn-outline-danger {\n  --bs-btn-color: #dc3545;\n  --bs-btn-border-color: #dc3545;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #dc3545;\n  --bs-btn-hover-border-color: #dc3545;\n  --bs-btn-focus-shadow-rgb: 220, 53, 69;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #dc3545;\n  --bs-btn-active-border-color: #dc3545;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #dc3545;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #dc3545;\n  --bs-gradient: none;\n}\n\n.btn-outline-light {\n  --bs-btn-color: #f8f9fa;\n  --bs-btn-border-color: #f8f9fa;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #f8f9fa;\n  --bs-btn-hover-border-color: #f8f9fa;\n  --bs-btn-focus-shadow-rgb: 248, 249, 250;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #f8f9fa;\n  --bs-btn-active-border-color: #f8f9fa;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #f8f9fa;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #f8f9fa;\n  --bs-gradient: none;\n}\n\n.btn-outline-dark {\n  --bs-btn-color: #212529;\n  --bs-btn-border-color: #212529;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #212529;\n  --bs-btn-hover-border-color: #212529;\n  --bs-btn-focus-shadow-rgb: 33, 37, 41;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #212529;\n  --bs-btn-active-border-color: #212529;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #212529;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #212529;\n  --bs-gradient: none;\n}\n\n.btn-link {\n  --bs-btn-font-weight: 400;\n  --bs-btn-color: var(--bs-link-color);\n  --bs-btn-bg: transparent;\n  --bs-btn-border-color: transparent;\n  --bs-btn-hover-color: var(--bs-link-hover-color);\n  --bs-btn-hover-border-color: transparent;\n  --bs-btn-active-color: var(--bs-link-hover-color);\n  --bs-btn-active-border-color: transparent;\n  --bs-btn-disabled-color: #6c757d;\n  --bs-btn-disabled-border-color: transparent;\n  --bs-btn-box-shadow: 0 0 0 #000;\n  --bs-btn-focus-shadow-rgb: 49, 132, 253;\n  text-decoration: underline;\n}\n.btn-link:focus-visible {\n  color: var(--bs-btn-color);\n}\n.btn-link:hover {\n  color: var(--bs-btn-hover-color);\n}\n\n.btn-lg, .btn-group-lg > .btn {\n  --bs-btn-padding-y: 0.5rem;\n  --bs-btn-padding-x: 1rem;\n  --bs-btn-font-size: 1.25rem;\n  --bs-btn-border-radius: var(--bs-border-radius-lg);\n}\n\n.btn-sm, .btn-group-sm > .btn {\n  --bs-btn-padding-y: 0.25rem;\n  --bs-btn-padding-x: 0.5rem;\n  --bs-btn-font-size: 0.875rem;\n  --bs-btn-border-radius: var(--bs-border-radius-sm);\n}\n\n.fade {\n  transition: opacity 0.15s linear;\n}\n@media (prefers-reduced-motion: reduce) {\n  .fade {\n    transition: none;\n  }\n}\n.fade:not(.show) {\n  opacity: 0;\n}\n\n.collapse:not(.show) {\n  display: none;\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  transition: height 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .collapsing {\n    transition: none;\n  }\n}\n.collapsing.collapse-horizontal {\n  width: 0;\n  height: auto;\n  transition: width 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .collapsing.collapse-horizontal {\n    transition: none;\n  }\n}\n\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n}\n.dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0;\n  border-left: 0.3em solid transparent;\n}\n.dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropdown-menu {\n  --bs-dropdown-zindex: 1000;\n  --bs-dropdown-min-width: 10rem;\n  --bs-dropdown-padding-x: 0;\n  --bs-dropdown-padding-y: 0.5rem;\n  --bs-dropdown-spacer: 0.125rem;\n  --bs-dropdown-font-size: 1rem;\n  --bs-dropdown-color: var(--bs-body-color);\n  --bs-dropdown-bg: var(--bs-body-bg);\n  --bs-dropdown-border-color: var(--bs-border-color-translucent);\n  --bs-dropdown-border-radius: var(--bs-border-radius);\n  --bs-dropdown-border-width: var(--bs-border-width);\n  --bs-dropdown-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width));\n  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);\n  --bs-dropdown-divider-margin-y: 0.5rem;\n  --bs-dropdown-box-shadow: var(--bs-box-shadow);\n  --bs-dropdown-link-color: var(--bs-body-color);\n  --bs-dropdown-link-hover-color: var(--bs-body-color);\n  --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);\n  --bs-dropdown-link-active-color: #fff;\n  --bs-dropdown-link-active-bg: #0d6efd;\n  --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);\n  --bs-dropdown-item-padding-x: 1rem;\n  --bs-dropdown-item-padding-y: 0.25rem;\n  --bs-dropdown-header-color: #6c757d;\n  --bs-dropdown-header-padding-x: 1rem;\n  --bs-dropdown-header-padding-y: 0.5rem;\n  position: absolute;\n  z-index: var(--bs-dropdown-zindex);\n  display: none;\n  min-width: var(--bs-dropdown-min-width);\n  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);\n  margin: 0;\n  font-size: var(--bs-dropdown-font-size);\n  color: var(--bs-dropdown-color);\n  text-align: left;\n  list-style: none;\n  background-color: var(--bs-dropdown-bg);\n  background-clip: padding-box;\n  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);\n  border-radius: var(--bs-dropdown-border-radius);\n}\n.dropdown-menu[data-bs-popper] {\n  top: 100%;\n  left: 0;\n  margin-top: var(--bs-dropdown-spacer);\n}\n\n.dropdown-menu-start {\n  --bs-position: start;\n}\n.dropdown-menu-start[data-bs-popper] {\n  right: auto;\n  left: 0;\n}\n\n.dropdown-menu-end {\n  --bs-position: end;\n}\n.dropdown-menu-end[data-bs-popper] {\n  right: 0;\n  left: auto;\n}\n\n@media (min-width: 576px) {\n  .dropdown-menu-sm-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-sm-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-sm-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-sm-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 768px) {\n  .dropdown-menu-md-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-md-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-md-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-md-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 992px) {\n  .dropdown-menu-lg-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-lg-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-lg-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-lg-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1200px) {\n  .dropdown-menu-xl-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-xl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-xl-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-xl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1400px) {\n  .dropdown-menu-xxl-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-xxl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-xxl-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-xxl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n.dropup .dropdown-menu[data-bs-popper] {\n  top: auto;\n  bottom: 100%;\n  margin-top: 0;\n  margin-bottom: var(--bs-dropdown-spacer);\n}\n.dropup .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0.3em solid;\n  border-left: 0.3em solid transparent;\n}\n.dropup .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropend .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: auto;\n  left: 100%;\n  margin-top: 0;\n  margin-left: var(--bs-dropdown-spacer);\n}\n.dropend .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0;\n  border-bottom: 0.3em solid transparent;\n  border-left: 0.3em solid;\n}\n.dropend .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropend .dropdown-toggle::after {\n  vertical-align: 0;\n}\n\n.dropstart .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: 100%;\n  left: auto;\n  margin-top: 0;\n  margin-right: var(--bs-dropdown-spacer);\n}\n.dropstart .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n}\n.dropstart .dropdown-toggle::after {\n  display: none;\n}\n.dropstart .dropdown-toggle::before {\n  display: inline-block;\n  margin-right: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0.3em solid;\n  border-bottom: 0.3em solid transparent;\n}\n.dropstart .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropstart .dropdown-toggle::before {\n  vertical-align: 0;\n}\n\n.dropdown-divider {\n  height: 0;\n  margin: var(--bs-dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--bs-dropdown-divider-bg);\n  opacity: 1;\n}\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);\n  clear: both;\n  font-weight: 400;\n  color: var(--bs-dropdown-link-color);\n  text-align: inherit;\n  text-decoration: none;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n  border-radius: var(--bs-dropdown-item-border-radius, 0);\n}\n.dropdown-item:hover, .dropdown-item:focus {\n  color: var(--bs-dropdown-link-hover-color);\n  background-color: var(--bs-dropdown-link-hover-bg);\n}\n.dropdown-item.active, .dropdown-item:active {\n  color: var(--bs-dropdown-link-active-color);\n  text-decoration: none;\n  background-color: var(--bs-dropdown-link-active-bg);\n}\n.dropdown-item.disabled, .dropdown-item:disabled {\n  color: var(--bs-dropdown-link-disabled-color);\n  pointer-events: none;\n  background-color: transparent;\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n.dropdown-header {\n  display: block;\n  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);\n  margin-bottom: 0;\n  font-size: 0.875rem;\n  color: var(--bs-dropdown-header-color);\n  white-space: nowrap;\n}\n\n.dropdown-item-text {\n  display: block;\n  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);\n  color: var(--bs-dropdown-link-color);\n}\n\n.dropdown-menu-dark {\n  --bs-dropdown-color: #dee2e6;\n  --bs-dropdown-bg: #343a40;\n  --bs-dropdown-border-color: var(--bs-border-color-translucent);\n  --bs-dropdown-box-shadow: ;\n  --bs-dropdown-link-color: #dee2e6;\n  --bs-dropdown-link-hover-color: #fff;\n  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);\n  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);\n  --bs-dropdown-link-active-color: #fff;\n  --bs-dropdown-link-active-bg: #0d6efd;\n  --bs-dropdown-link-disabled-color: #adb5bd;\n  --bs-dropdown-header-color: #adb5bd;\n}\n\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle;\n}\n.btn-group > .btn,\n.btn-group-vertical > .btn {\n  position: relative;\n  flex: 1 1 auto;\n}\n.btn-group > .btn-check:checked + .btn,\n.btn-group > .btn-check:focus + .btn,\n.btn-group > .btn:hover,\n.btn-group > .btn:focus,\n.btn-group > .btn:active,\n.btn-group > .btn.active,\n.btn-group-vertical > .btn-check:checked + .btn,\n.btn-group-vertical > .btn-check:focus + .btn,\n.btn-group-vertical > .btn:hover,\n.btn-group-vertical > .btn:focus,\n.btn-group-vertical > .btn:active,\n.btn-group-vertical > .btn.active {\n  z-index: 1;\n}\n\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n.btn-toolbar .input-group {\n  width: auto;\n}\n\n.btn-group {\n  border-radius: var(--bs-border-radius);\n}\n.btn-group > :not(.btn-check:first-child) + .btn,\n.btn-group > .btn-group:not(:first-child) {\n  margin-left: calc(-1 * var(--bs-border-width));\n}\n.btn-group > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group > .btn.dropdown-toggle-split:first-child,\n.btn-group > .btn-group:not(:last-child) > .btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.btn-group > .btn:nth-child(n+3),\n.btn-group > :not(.btn-check) + .btn,\n.btn-group > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.dropdown-toggle-split {\n  padding-right: 0.5625rem;\n  padding-left: 0.5625rem;\n}\n.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {\n  margin-left: 0;\n}\n.dropstart .dropdown-toggle-split::before {\n  margin-right: 0;\n}\n\n.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {\n  padding-right: 0.375rem;\n  padding-left: 0.375rem;\n}\n\n.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {\n  padding-right: 0.75rem;\n  padding-left: 0.75rem;\n}\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n.btn-group-vertical > .btn,\n.btn-group-vertical > .btn-group {\n  width: 100%;\n}\n.btn-group-vertical > .btn:not(:first-child),\n.btn-group-vertical > .btn-group:not(:first-child) {\n  margin-top: calc(-1 * var(--bs-border-width));\n}\n.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group-vertical > .btn-group:not(:last-child) > .btn {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group-vertical > .btn:nth-child(n+3),\n.btn-group-vertical > :not(.btn-check) + .btn,\n.btn-group-vertical > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav {\n  --bs-nav-link-padding-x: 1rem;\n  --bs-nav-link-padding-y: 0.5rem;\n  --bs-nav-link-font-weight: ;\n  --bs-nav-link-color: var(--bs-link-color);\n  --bs-nav-link-hover-color: var(--bs-link-hover-color);\n  --bs-nav-link-disabled-color: var(--bs-secondary-color);\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);\n  font-size: var(--bs-nav-link-font-size);\n  font-weight: var(--bs-nav-link-font-weight);\n  color: var(--bs-nav-link-color);\n  text-decoration: none;\n  background: none;\n  border: 0;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .nav-link {\n    transition: none;\n  }\n}\n.nav-link:hover, .nav-link:focus {\n  color: var(--bs-nav-link-hover-color);\n}\n.nav-link:focus-visible {\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n.nav-link.disabled, .nav-link:disabled {\n  color: var(--bs-nav-link-disabled-color);\n  pointer-events: none;\n  cursor: default;\n}\n\n.nav-tabs {\n  --bs-nav-tabs-border-width: var(--bs-border-width);\n  --bs-nav-tabs-border-color: var(--bs-border-color);\n  --bs-nav-tabs-border-radius: var(--bs-border-radius);\n  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);\n  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);\n  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);\n  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);\n  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);\n}\n.nav-tabs .nav-link {\n  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));\n  border: var(--bs-nav-tabs-border-width) solid transparent;\n  border-top-left-radius: var(--bs-nav-tabs-border-radius);\n  border-top-right-radius: var(--bs-nav-tabs-border-radius);\n}\n.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {\n  isolation: isolate;\n  border-color: var(--bs-nav-tabs-link-hover-border-color);\n}\n.nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n  color: var(--bs-nav-tabs-link-active-color);\n  background-color: var(--bs-nav-tabs-link-active-bg);\n  border-color: var(--bs-nav-tabs-link-active-border-color);\n}\n.nav-tabs .dropdown-menu {\n  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav-pills {\n  --bs-nav-pills-border-radius: var(--bs-border-radius);\n  --bs-nav-pills-link-active-color: #fff;\n  --bs-nav-pills-link-active-bg: #0d6efd;\n}\n.nav-pills .nav-link {\n  border-radius: var(--bs-nav-pills-border-radius);\n}\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  color: var(--bs-nav-pills-link-active-color);\n  background-color: var(--bs-nav-pills-link-active-bg);\n}\n\n.nav-underline {\n  --bs-nav-underline-gap: 1rem;\n  --bs-nav-underline-border-width: 0.125rem;\n  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);\n  gap: var(--bs-nav-underline-gap);\n}\n.nav-underline .nav-link {\n  padding-right: 0;\n  padding-left: 0;\n  border-bottom: var(--bs-nav-underline-border-width) solid transparent;\n}\n.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {\n  border-bottom-color: currentcolor;\n}\n.nav-underline .nav-link.active,\n.nav-underline .show > .nav-link {\n  font-weight: 700;\n  color: var(--bs-nav-underline-link-active-color);\n  border-bottom-color: currentcolor;\n}\n\n.nav-fill > .nav-link,\n.nav-fill .nav-item {\n  flex: 1 1 auto;\n  text-align: center;\n}\n\n.nav-justified > .nav-link,\n.nav-justified .nav-item {\n  flex-grow: 1;\n  flex-basis: 0;\n  text-align: center;\n}\n\n.nav-fill .nav-item .nav-link,\n.nav-justified .nav-item .nav-link {\n  width: 100%;\n}\n\n.tab-content > .tab-pane {\n  display: none;\n}\n.tab-content > .active {\n  display: block;\n}\n\n.navbar {\n  --bs-navbar-padding-x: 0;\n  --bs-navbar-padding-y: 0.5rem;\n  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);\n  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);\n  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);\n  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);\n  --bs-navbar-brand-padding-y: 0.3125rem;\n  --bs-navbar-brand-margin-end: 1rem;\n  --bs-navbar-brand-font-size: 1.25rem;\n  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);\n  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);\n  --bs-navbar-nav-link-padding-x: 0.5rem;\n  --bs-navbar-toggler-padding-y: 0.25rem;\n  --bs-navbar-toggler-padding-x: 0.75rem;\n  --bs-navbar-toggler-font-size: 1.25rem;\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%2833, 37, 41, 0.75%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);\n  --bs-navbar-toggler-border-radius: var(--bs-border-radius);\n  --bs-navbar-toggler-focus-width: 0.25rem;\n  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);\n}\n.navbar > .container,\n.navbar > .container-fluid,\n.navbar > .container-sm,\n.navbar > .container-md,\n.navbar > .container-lg,\n.navbar > .container-xl,\n.navbar > .container-xxl {\n  display: flex;\n  flex-wrap: inherit;\n  align-items: center;\n  justify-content: space-between;\n}\n.navbar-brand {\n  padding-top: var(--bs-navbar-brand-padding-y);\n  padding-bottom: var(--bs-navbar-brand-padding-y);\n  margin-right: var(--bs-navbar-brand-margin-end);\n  font-size: var(--bs-navbar-brand-font-size);\n  color: var(--bs-navbar-brand-color);\n  text-decoration: none;\n  white-space: nowrap;\n}\n.navbar-brand:hover, .navbar-brand:focus {\n  color: var(--bs-navbar-brand-hover-color);\n}\n\n.navbar-nav {\n  --bs-nav-link-padding-x: 0;\n  --bs-nav-link-padding-y: 0.5rem;\n  --bs-nav-link-font-weight: ;\n  --bs-nav-link-color: var(--bs-navbar-color);\n  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);\n  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {\n  color: var(--bs-navbar-active-color);\n}\n.navbar-nav .dropdown-menu {\n  position: static;\n}\n\n.navbar-text {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  color: var(--bs-navbar-color);\n}\n.navbar-text a,\n.navbar-text a:hover,\n.navbar-text a:focus {\n  color: var(--bs-navbar-active-color);\n}\n\n.navbar-collapse {\n  flex-grow: 1;\n  flex-basis: 100%;\n  align-items: center;\n}\n\n.navbar-toggler {\n  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);\n  font-size: var(--bs-navbar-toggler-font-size);\n  line-height: 1;\n  color: var(--bs-navbar-color);\n  background-color: transparent;\n  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);\n  border-radius: var(--bs-navbar-toggler-border-radius);\n  transition: var(--bs-navbar-toggler-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .navbar-toggler {\n    transition: none;\n  }\n}\n.navbar-toggler:hover {\n  text-decoration: none;\n}\n.navbar-toggler:focus {\n  text-decoration: none;\n  outline: 0;\n  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);\n}\n\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--bs-navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--bs-scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n@media (min-width: 576px) {\n  .navbar-expand-sm {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-sm .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-sm .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-sm .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-sm .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-sm .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-sm .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-sm .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-sm .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-sm .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-expand-md {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-md .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-md .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-md .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-md .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-md .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-md .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-md .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-md .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-md .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 992px) {\n  .navbar-expand-lg {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-lg .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-lg .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-lg .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-lg .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-lg .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-lg .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-lg .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-lg .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-lg .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 1200px) {\n  .navbar-expand-xl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xl .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-xl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xl .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-xl .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-xl .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-xl .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 1400px) {\n  .navbar-expand-xxl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xxl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xxl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xxl .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-xxl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xxl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xxl .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-xxl .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-xxl .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-xxl .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n.navbar-expand {\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n}\n.navbar-expand .navbar-nav {\n  flex-direction: row;\n}\n.navbar-expand .navbar-nav .dropdown-menu {\n  position: absolute;\n}\n.navbar-expand .navbar-nav .nav-link {\n  padding-right: var(--bs-navbar-nav-link-padding-x);\n  padding-left: var(--bs-navbar-nav-link-padding-x);\n}\n.navbar-expand .navbar-nav-scroll {\n  overflow: visible;\n}\n.navbar-expand .navbar-collapse {\n  display: flex !important;\n  flex-basis: auto;\n}\n.navbar-expand .navbar-toggler {\n  display: none;\n}\n.navbar-expand .offcanvas {\n  position: static;\n  z-index: auto;\n  flex-grow: 1;\n  width: auto !important;\n  height: auto !important;\n  visibility: visible !important;\n  background-color: transparent !important;\n  border: 0 !important;\n  transform: none !important;\n  transition: none;\n}\n.navbar-expand .offcanvas .offcanvas-header {\n  display: none;\n}\n.navbar-expand .offcanvas .offcanvas-body {\n  display: flex;\n  flex-grow: 0;\n  padding: 0;\n  overflow-y: visible;\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=dark] {\n  --bs-navbar-color: rgba(255, 255, 255, 0.55);\n  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);\n  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);\n  --bs-navbar-active-color: #fff;\n  --bs-navbar-brand-color: #fff;\n  --bs-navbar-brand-hover-color: #fff;\n  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n[data-bs-theme=dark] .navbar-toggler-icon {\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n.card {\n  --bs-card-spacer-y: 1rem;\n  --bs-card-spacer-x: 1rem;\n  --bs-card-title-spacer-y: 0.5rem;\n  --bs-card-title-color: ;\n  --bs-card-subtitle-color: ;\n  --bs-card-border-width: var(--bs-border-width);\n  --bs-card-border-color: var(--bs-border-color-translucent);\n  --bs-card-border-radius: var(--bs-border-radius);\n  --bs-card-box-shadow: ;\n  --bs-card-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));\n  --bs-card-cap-padding-y: 0.5rem;\n  --bs-card-cap-padding-x: 1rem;\n  --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);\n  --bs-card-cap-color: ;\n  --bs-card-height: ;\n  --bs-card-color: ;\n  --bs-card-bg: var(--bs-body-bg);\n  --bs-card-img-overlay-padding: 1rem;\n  --bs-card-group-margin: 0.75rem;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  height: var(--bs-card-height);\n  color: var(--bs-body-color);\n  word-wrap: break-word;\n  background-color: var(--bs-card-bg);\n  background-clip: border-box;\n  border: var(--bs-card-border-width) solid var(--bs-card-border-color);\n  border-radius: var(--bs-card-border-radius);\n}\n.card > hr {\n  margin-right: 0;\n  margin-left: 0;\n}\n.card > .list-group {\n  border-top: inherit;\n  border-bottom: inherit;\n}\n.card > .list-group:first-child {\n  border-top-width: 0;\n  border-top-left-radius: var(--bs-card-inner-border-radius);\n  border-top-right-radius: var(--bs-card-inner-border-radius);\n}\n.card > .list-group:last-child {\n  border-bottom-width: 0;\n  border-bottom-right-radius: var(--bs-card-inner-border-radius);\n  border-bottom-left-radius: var(--bs-card-inner-border-radius);\n}\n.card > .card-header + .list-group,\n.card > .list-group + .card-footer {\n  border-top: 0;\n}\n\n.card-body {\n  flex: 1 1 auto;\n  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);\n  color: var(--bs-card-color);\n}\n\n.card-title {\n  margin-bottom: var(--bs-card-title-spacer-y);\n  color: var(--bs-card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));\n  margin-bottom: 0;\n  color: var(--bs-card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link + .card-link {\n  margin-left: var(--bs-card-spacer-x);\n}\n\n.card-header {\n  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\n  margin-bottom: 0;\n  color: var(--bs-card-cap-color);\n  background-color: var(--bs-card-cap-bg);\n  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);\n}\n.card-header:first-child {\n  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;\n}\n\n.card-footer {\n  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\n  color: var(--bs-card-cap-color);\n  background-color: var(--bs-card-cap-bg);\n  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);\n}\n.card-footer:last-child {\n  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);\n}\n\n.card-header-tabs {\n  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));\n  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));\n  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));\n  border-bottom: 0;\n}\n.card-header-tabs .nav-link.active {\n  background-color: var(--bs-card-bg);\n  border-bottom-color: var(--bs-card-bg);\n}\n\n.card-header-pills {\n  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));\n  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));\n}\n\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--bs-card-img-overlay-padding);\n  border-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%;\n}\n\n.card-img,\n.card-img-top {\n  border-top-left-radius: var(--bs-card-inner-border-radius);\n  border-top-right-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-img,\n.card-img-bottom {\n  border-bottom-right-radius: var(--bs-card-inner-border-radius);\n  border-bottom-left-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-group > .card {\n  margin-bottom: var(--bs-card-group-margin);\n}\n@media (min-width: 576px) {\n  .card-group {\n    display: flex;\n    flex-flow: row wrap;\n  }\n  .card-group > .card {\n    flex: 1 0 0;\n    margin-bottom: 0;\n  }\n  .card-group > .card + .card {\n    margin-left: 0;\n    border-left: 0;\n  }\n  .card-group > .card:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) > .card-img-top,\n  .card-group > .card:not(:last-child) > .card-header {\n    border-top-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) > .card-img-bottom,\n  .card-group > .card:not(:last-child) > .card-footer {\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) > .card-img-top,\n  .card-group > .card:not(:first-child) > .card-header {\n    border-top-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) > .card-img-bottom,\n  .card-group > .card:not(:first-child) > .card-footer {\n    border-bottom-left-radius: 0;\n  }\n}\n\n.accordion {\n  --bs-accordion-color: var(--bs-body-color);\n  --bs-accordion-bg: var(--bs-body-bg);\n  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;\n  --bs-accordion-border-color: var(--bs-border-color);\n  --bs-accordion-border-width: var(--bs-border-width);\n  --bs-accordion-border-radius: var(--bs-border-radius);\n  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));\n  --bs-accordion-btn-padding-x: 1.25rem;\n  --bs-accordion-btn-padding-y: 1rem;\n  --bs-accordion-btn-color: var(--bs-body-color);\n  --bs-accordion-btn-bg: var(--bs-accordion-bg);\n  --bs-accordion-btn-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='%23212529' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-icon-width: 1.25rem;\n  --bs-accordion-btn-icon-transform: rotate(-180deg);\n  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;\n  --bs-accordion-btn-active-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='rgb%282.0392156863%, 17.2549019608%, 39.6862745098%%29' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n  --bs-accordion-body-padding-x: 1.25rem;\n  --bs-accordion-body-padding-y: 1rem;\n  --bs-accordion-active-color: var(--bs-primary-text-emphasis);\n  --bs-accordion-active-bg: var(--bs-primary-bg-subtle);\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);\n  font-size: 1rem;\n  color: var(--bs-accordion-btn-color);\n  text-align: left;\n  background-color: var(--bs-accordion-btn-bg);\n  border: 0;\n  border-radius: 0;\n  overflow-anchor: none;\n  transition: var(--bs-accordion-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button {\n    transition: none;\n  }\n}\n.accordion-button:not(.collapsed) {\n  color: var(--bs-accordion-active-color);\n  background-color: var(--bs-accordion-active-bg);\n  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);\n}\n.accordion-button:not(.collapsed)::after {\n  background-image: var(--bs-accordion-btn-active-icon);\n  transform: var(--bs-accordion-btn-icon-transform);\n}\n.accordion-button::after {\n  flex-shrink: 0;\n  width: var(--bs-accordion-btn-icon-width);\n  height: var(--bs-accordion-btn-icon-width);\n  margin-left: auto;\n  content: \"\";\n  background-image: var(--bs-accordion-btn-icon);\n  background-repeat: no-repeat;\n  background-size: var(--bs-accordion-btn-icon-width);\n  transition: var(--bs-accordion-btn-icon-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button::after {\n    transition: none;\n  }\n}\n.accordion-button:hover {\n  z-index: 2;\n}\n.accordion-button:focus {\n  z-index: 3;\n  outline: 0;\n  box-shadow: var(--bs-accordion-btn-focus-box-shadow);\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--bs-accordion-color);\n  background-color: var(--bs-accordion-bg);\n  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);\n}\n.accordion-item:first-of-type {\n  border-top-left-radius: var(--bs-accordion-border-radius);\n  border-top-right-radius: var(--bs-accordion-border-radius);\n}\n.accordion-item:first-of-type > .accordion-header .accordion-button {\n  border-top-left-radius: var(--bs-accordion-inner-border-radius);\n  border-top-right-radius: var(--bs-accordion-inner-border-radius);\n}\n.accordion-item:not(:first-of-type) {\n  border-top: 0;\n}\n.accordion-item:last-of-type {\n  border-bottom-right-radius: var(--bs-accordion-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-border-radius);\n}\n.accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {\n  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);\n}\n.accordion-item:last-of-type > .accordion-collapse {\n  border-bottom-right-radius: var(--bs-accordion-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-border-radius);\n}\n\n.accordion-body {\n  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);\n}\n\n.accordion-flush > .accordion-item {\n  border-right: 0;\n  border-left: 0;\n  border-radius: 0;\n}\n.accordion-flush > .accordion-item:first-child {\n  border-top: 0;\n}\n.accordion-flush > .accordion-item:last-child {\n  border-bottom: 0;\n}\n.accordion-flush > .accordion-item > .accordion-collapse,\n.accordion-flush > .accordion-item > .accordion-header .accordion-button,\n.accordion-flush > .accordion-item > .accordion-header .accordion-button.collapsed {\n  border-radius: 0;\n}\n\n[data-bs-theme=dark] .accordion-button::after {\n  --bs-accordion-btn-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='rgb%2843.0588235294%, 65.8823529412%, 99.5294117647%%29'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-active-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='rgb%2843.0588235294%, 65.8823529412%, 99.5294117647%%29'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708'/%3e%3c/svg%3e\");\n}\n\n.breadcrumb {\n  --bs-breadcrumb-padding-x: 0;\n  --bs-breadcrumb-padding-y: 0;\n  --bs-breadcrumb-margin-bottom: 1rem;\n  --bs-breadcrumb-bg: ;\n  --bs-breadcrumb-border-radius: ;\n  --bs-breadcrumb-divider-color: var(--bs-secondary-color);\n  --bs-breadcrumb-item-padding-x: 0.5rem;\n  --bs-breadcrumb-item-active-color: var(--bs-secondary-color);\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);\n  margin-bottom: var(--bs-breadcrumb-margin-bottom);\n  font-size: var(--bs-breadcrumb-font-size);\n  list-style: none;\n  background-color: var(--bs-breadcrumb-bg);\n  border-radius: var(--bs-breadcrumb-border-radius);\n}\n\n.breadcrumb-item + .breadcrumb-item {\n  padding-left: var(--bs-breadcrumb-item-padding-x);\n}\n.breadcrumb-item + .breadcrumb-item::before {\n  float: left;\n  padding-right: var(--bs-breadcrumb-item-padding-x);\n  color: var(--bs-breadcrumb-divider-color);\n  content: var(--bs-breadcrumb-divider, \"/\") /* rtl: var(--bs-breadcrumb-divider, \"/\") */;\n}\n.breadcrumb-item.active {\n  color: var(--bs-breadcrumb-item-active-color);\n}\n\n.pagination {\n  --bs-pagination-padding-x: 0.75rem;\n  --bs-pagination-padding-y: 0.375rem;\n  --bs-pagination-font-size: 1rem;\n  --bs-pagination-color: var(--bs-link-color);\n  --bs-pagination-bg: var(--bs-body-bg);\n  --bs-pagination-border-width: var(--bs-border-width);\n  --bs-pagination-border-color: var(--bs-border-color);\n  --bs-pagination-border-radius: var(--bs-border-radius);\n  --bs-pagination-hover-color: var(--bs-link-hover-color);\n  --bs-pagination-hover-bg: var(--bs-tertiary-bg);\n  --bs-pagination-hover-border-color: var(--bs-border-color);\n  --bs-pagination-focus-color: var(--bs-link-hover-color);\n  --bs-pagination-focus-bg: var(--bs-secondary-bg);\n  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n  --bs-pagination-active-color: #fff;\n  --bs-pagination-active-bg: #0d6efd;\n  --bs-pagination-active-border-color: #0d6efd;\n  --bs-pagination-disabled-color: var(--bs-secondary-color);\n  --bs-pagination-disabled-bg: var(--bs-secondary-bg);\n  --bs-pagination-disabled-border-color: var(--bs-border-color);\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);\n  font-size: var(--bs-pagination-font-size);\n  color: var(--bs-pagination-color);\n  text-decoration: none;\n  background-color: var(--bs-pagination-bg);\n  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .page-link {\n    transition: none;\n  }\n}\n.page-link:hover {\n  z-index: 2;\n  color: var(--bs-pagination-hover-color);\n  background-color: var(--bs-pagination-hover-bg);\n  border-color: var(--bs-pagination-hover-border-color);\n}\n.page-link:focus {\n  z-index: 3;\n  color: var(--bs-pagination-focus-color);\n  background-color: var(--bs-pagination-focus-bg);\n  outline: 0;\n  box-shadow: var(--bs-pagination-focus-box-shadow);\n}\n.page-link.active, .active > .page-link {\n  z-index: 3;\n  color: var(--bs-pagination-active-color);\n  background-color: var(--bs-pagination-active-bg);\n  border-color: var(--bs-pagination-active-border-color);\n}\n.page-link.disabled, .disabled > .page-link {\n  color: var(--bs-pagination-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-pagination-disabled-bg);\n  border-color: var(--bs-pagination-disabled-border-color);\n}\n\n.page-item:not(:first-child) .page-link {\n  margin-left: calc(-1 * var(--bs-border-width));\n}\n.page-item:first-child .page-link {\n  border-top-left-radius: var(--bs-pagination-border-radius);\n  border-bottom-left-radius: var(--bs-pagination-border-radius);\n}\n.page-item:last-child .page-link {\n  border-top-right-radius: var(--bs-pagination-border-radius);\n  border-bottom-right-radius: var(--bs-pagination-border-radius);\n}\n\n.pagination-lg {\n  --bs-pagination-padding-x: 1.5rem;\n  --bs-pagination-padding-y: 0.75rem;\n  --bs-pagination-font-size: 1.25rem;\n  --bs-pagination-border-radius: var(--bs-border-radius-lg);\n}\n\n.pagination-sm {\n  --bs-pagination-padding-x: 0.5rem;\n  --bs-pagination-padding-y: 0.25rem;\n  --bs-pagination-font-size: 0.875rem;\n  --bs-pagination-border-radius: var(--bs-border-radius-sm);\n}\n\n.badge {\n  --bs-badge-padding-x: 0.65em;\n  --bs-badge-padding-y: 0.35em;\n  --bs-badge-font-size: 0.75em;\n  --bs-badge-font-weight: 700;\n  --bs-badge-color: #fff;\n  --bs-badge-border-radius: var(--bs-border-radius);\n  display: inline-block;\n  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);\n  font-size: var(--bs-badge-font-size);\n  font-weight: var(--bs-badge-font-weight);\n  line-height: 1;\n  color: var(--bs-badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: var(--bs-badge-border-radius);\n}\n.badge:empty {\n  display: none;\n}\n\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n.alert {\n  --bs-alert-bg: transparent;\n  --bs-alert-padding-x: 1rem;\n  --bs-alert-padding-y: 1rem;\n  --bs-alert-margin-bottom: 1rem;\n  --bs-alert-color: inherit;\n  --bs-alert-border-color: transparent;\n  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);\n  --bs-alert-border-radius: var(--bs-border-radius);\n  --bs-alert-link-color: inherit;\n  position: relative;\n  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);\n  margin-bottom: var(--bs-alert-margin-bottom);\n  color: var(--bs-alert-color);\n  background-color: var(--bs-alert-bg);\n  border: var(--bs-alert-border);\n  border-radius: var(--bs-alert-border-radius);\n}\n\n.alert-heading {\n  color: inherit;\n}\n\n.alert-link {\n  font-weight: 700;\n  color: var(--bs-alert-link-color);\n}\n\n.alert-dismissible {\n  padding-right: 3rem;\n}\n.alert-dismissible .btn-close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  padding: 1.25rem 1rem;\n}\n\n.alert-primary {\n  --bs-alert-color: var(--bs-primary-text-emphasis);\n  --bs-alert-bg: var(--bs-primary-bg-subtle);\n  --bs-alert-border-color: var(--bs-primary-border-subtle);\n  --bs-alert-link-color: var(--bs-primary-text-emphasis);\n}\n\n.alert-secondary {\n  --bs-alert-color: var(--bs-secondary-text-emphasis);\n  --bs-alert-bg: var(--bs-secondary-bg-subtle);\n  --bs-alert-border-color: var(--bs-secondary-border-subtle);\n  --bs-alert-link-color: var(--bs-secondary-text-emphasis);\n}\n\n.alert-success {\n  --bs-alert-color: var(--bs-success-text-emphasis);\n  --bs-alert-bg: var(--bs-success-bg-subtle);\n  --bs-alert-border-color: var(--bs-success-border-subtle);\n  --bs-alert-link-color: var(--bs-success-text-emphasis);\n}\n\n.alert-info {\n  --bs-alert-color: var(--bs-info-text-emphasis);\n  --bs-alert-bg: var(--bs-info-bg-subtle);\n  --bs-alert-border-color: var(--bs-info-border-subtle);\n  --bs-alert-link-color: var(--bs-info-text-emphasis);\n}\n\n.alert-warning {\n  --bs-alert-color: var(--bs-warning-text-emphasis);\n  --bs-alert-bg: var(--bs-warning-bg-subtle);\n  --bs-alert-border-color: var(--bs-warning-border-subtle);\n  --bs-alert-link-color: var(--bs-warning-text-emphasis);\n}\n\n.alert-danger {\n  --bs-alert-color: var(--bs-danger-text-emphasis);\n  --bs-alert-bg: var(--bs-danger-bg-subtle);\n  --bs-alert-border-color: var(--bs-danger-border-subtle);\n  --bs-alert-link-color: var(--bs-danger-text-emphasis);\n}\n\n.alert-light {\n  --bs-alert-color: var(--bs-light-text-emphasis);\n  --bs-alert-bg: var(--bs-light-bg-subtle);\n  --bs-alert-border-color: var(--bs-light-border-subtle);\n  --bs-alert-link-color: var(--bs-light-text-emphasis);\n}\n\n.alert-dark {\n  --bs-alert-color: var(--bs-dark-text-emphasis);\n  --bs-alert-bg: var(--bs-dark-bg-subtle);\n  --bs-alert-border-color: var(--bs-dark-border-subtle);\n  --bs-alert-link-color: var(--bs-dark-text-emphasis);\n}\n\n@keyframes progress-bar-stripes {\n  0% {\n    background-position-x: var(--bs-progress-height);\n  }\n}\n.progress,\n.progress-stacked {\n  --bs-progress-height: 1rem;\n  --bs-progress-font-size: 0.75rem;\n  --bs-progress-bg: var(--bs-secondary-bg);\n  --bs-progress-border-radius: var(--bs-border-radius);\n  --bs-progress-box-shadow: var(--bs-box-shadow-inset);\n  --bs-progress-bar-color: #fff;\n  --bs-progress-bar-bg: #0d6efd;\n  --bs-progress-bar-transition: width 0.6s ease;\n  display: flex;\n  height: var(--bs-progress-height);\n  overflow: hidden;\n  font-size: var(--bs-progress-font-size);\n  background-color: var(--bs-progress-bg);\n  border-radius: var(--bs-progress-border-radius);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--bs-progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--bs-progress-bar-bg);\n  transition: var(--bs-progress-bar-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar {\n    transition: none;\n  }\n}\n\n.progress-bar-striped {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: var(--bs-progress-height) var(--bs-progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n.progress-bar-animated {\n  animation: 1s linear infinite progress-bar-stripes;\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar-animated {\n    animation: none;\n  }\n}\n\n.list-group {\n  --bs-list-group-color: var(--bs-body-color);\n  --bs-list-group-bg: var(--bs-body-bg);\n  --bs-list-group-border-color: var(--bs-border-color);\n  --bs-list-group-border-width: var(--bs-border-width);\n  --bs-list-group-border-radius: var(--bs-border-radius);\n  --bs-list-group-item-padding-x: 1rem;\n  --bs-list-group-item-padding-y: 0.5rem;\n  --bs-list-group-action-color: var(--bs-secondary-color);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);\n  --bs-list-group-action-active-color: var(--bs-body-color);\n  --bs-list-group-action-active-bg: var(--bs-secondary-bg);\n  --bs-list-group-disabled-color: var(--bs-secondary-color);\n  --bs-list-group-disabled-bg: var(--bs-body-bg);\n  --bs-list-group-active-color: #fff;\n  --bs-list-group-active-bg: #0d6efd;\n  --bs-list-group-active-border-color: #0d6efd;\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  border-radius: var(--bs-list-group-border-radius);\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n}\n.list-group-numbered > .list-group-item::before {\n  content: counters(section, \".\") \". \";\n  counter-increment: section;\n}\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);\n  color: var(--bs-list-group-color);\n  text-decoration: none;\n  background-color: var(--bs-list-group-bg);\n  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);\n}\n.list-group-item:first-child {\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n}\n.list-group-item:last-child {\n  border-bottom-right-radius: inherit;\n  border-bottom-left-radius: inherit;\n}\n.list-group-item.disabled, .list-group-item:disabled {\n  color: var(--bs-list-group-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-list-group-disabled-bg);\n}\n.list-group-item.active {\n  z-index: 2;\n  color: var(--bs-list-group-active-color);\n  background-color: var(--bs-list-group-active-bg);\n  border-color: var(--bs-list-group-active-border-color);\n}\n.list-group-item + .list-group-item {\n  border-top-width: 0;\n}\n.list-group-item + .list-group-item.active {\n  margin-top: calc(-1 * var(--bs-list-group-border-width));\n  border-top-width: var(--bs-list-group-border-width);\n}\n\n.list-group-item-action {\n  width: 100%;\n  color: var(--bs-list-group-action-color);\n  text-align: inherit;\n}\n.list-group-item-action:not(.active):hover, .list-group-item-action:not(.active):focus {\n  z-index: 1;\n  color: var(--bs-list-group-action-hover-color);\n  text-decoration: none;\n  background-color: var(--bs-list-group-action-hover-bg);\n}\n.list-group-item-action:not(.active):active {\n  color: var(--bs-list-group-action-active-color);\n  background-color: var(--bs-list-group-action-active-bg);\n}\n\n.list-group-horizontal {\n  flex-direction: row;\n}\n.list-group-horizontal > .list-group-item:first-child:not(:last-child) {\n  border-bottom-left-radius: var(--bs-list-group-border-radius);\n  border-top-right-radius: 0;\n}\n.list-group-horizontal > .list-group-item:last-child:not(:first-child) {\n  border-top-right-radius: var(--bs-list-group-border-radius);\n  border-bottom-left-radius: 0;\n}\n.list-group-horizontal > .list-group-item.active {\n  margin-top: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item {\n  border-top-width: var(--bs-list-group-border-width);\n  border-left-width: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item.active {\n  margin-left: calc(-1 * var(--bs-list-group-border-width));\n  border-left-width: var(--bs-list-group-border-width);\n}\n\n@media (min-width: 576px) {\n  .list-group-horizontal-sm {\n    flex-direction: row;\n  }\n  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 768px) {\n  .list-group-horizontal-md {\n    flex-direction: row;\n  }\n  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 992px) {\n  .list-group-horizontal-lg {\n    flex-direction: row;\n  }\n  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 1200px) {\n  .list-group-horizontal-xl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 1400px) {\n  .list-group-horizontal-xxl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n.list-group-flush {\n  border-radius: 0;\n}\n.list-group-flush > .list-group-item {\n  border-width: 0 0 var(--bs-list-group-border-width);\n}\n.list-group-flush > .list-group-item:last-child {\n  border-bottom-width: 0;\n}\n\n.list-group-item-primary {\n  --bs-list-group-color: var(--bs-primary-text-emphasis);\n  --bs-list-group-bg: var(--bs-primary-bg-subtle);\n  --bs-list-group-border-color: var(--bs-primary-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);\n  --bs-list-group-active-color: var(--bs-primary-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);\n}\n\n.list-group-item-secondary {\n  --bs-list-group-color: var(--bs-secondary-text-emphasis);\n  --bs-list-group-bg: var(--bs-secondary-bg-subtle);\n  --bs-list-group-border-color: var(--bs-secondary-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);\n  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);\n}\n\n.list-group-item-success {\n  --bs-list-group-color: var(--bs-success-text-emphasis);\n  --bs-list-group-bg: var(--bs-success-bg-subtle);\n  --bs-list-group-border-color: var(--bs-success-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);\n  --bs-list-group-active-color: var(--bs-success-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-success-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);\n}\n\n.list-group-item-info {\n  --bs-list-group-color: var(--bs-info-text-emphasis);\n  --bs-list-group-bg: var(--bs-info-bg-subtle);\n  --bs-list-group-border-color: var(--bs-info-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);\n  --bs-list-group-active-color: var(--bs-info-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-info-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);\n}\n\n.list-group-item-warning {\n  --bs-list-group-color: var(--bs-warning-text-emphasis);\n  --bs-list-group-bg: var(--bs-warning-bg-subtle);\n  --bs-list-group-border-color: var(--bs-warning-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);\n  --bs-list-group-active-color: var(--bs-warning-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);\n}\n\n.list-group-item-danger {\n  --bs-list-group-color: var(--bs-danger-text-emphasis);\n  --bs-list-group-bg: var(--bs-danger-bg-subtle);\n  --bs-list-group-border-color: var(--bs-danger-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);\n  --bs-list-group-active-color: var(--bs-danger-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);\n}\n\n.list-group-item-light {\n  --bs-list-group-color: var(--bs-light-text-emphasis);\n  --bs-list-group-bg: var(--bs-light-bg-subtle);\n  --bs-list-group-border-color: var(--bs-light-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);\n  --bs-list-group-active-color: var(--bs-light-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-light-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);\n}\n\n.list-group-item-dark {\n  --bs-list-group-color: var(--bs-dark-text-emphasis);\n  --bs-list-group-bg: var(--bs-dark-bg-subtle);\n  --bs-list-group-border-color: var(--bs-dark-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);\n  --bs-list-group-active-color: var(--bs-dark-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);\n}\n\n.btn-close {\n  --bs-btn-close-color: #000;\n  --bs-btn-close-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414'/%3e%3c/svg%3e\");\n  --bs-btn-close-opacity: 0.5;\n  --bs-btn-close-hover-opacity: 0.75;\n  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n  --bs-btn-close-focus-opacity: 1;\n  --bs-btn-close-disabled-opacity: 0.25;\n  box-sizing: content-box;\n  width: 1em;\n  height: 1em;\n  padding: 0.25em 0.25em;\n  color: var(--bs-btn-close-color);\n  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;\n  filter: var(--bs-btn-close-filter);\n  border: 0;\n  border-radius: 0.375rem;\n  opacity: var(--bs-btn-close-opacity);\n}\n.btn-close:hover {\n  color: var(--bs-btn-close-color);\n  text-decoration: none;\n  opacity: var(--bs-btn-close-hover-opacity);\n}\n.btn-close:focus {\n  outline: 0;\n  box-shadow: var(--bs-btn-close-focus-shadow);\n  opacity: var(--bs-btn-close-focus-opacity);\n}\n.btn-close:disabled, .btn-close.disabled {\n  pointer-events: none;\n  user-select: none;\n  opacity: var(--bs-btn-close-disabled-opacity);\n}\n\n.btn-close-white {\n  --bs-btn-close-filter: invert(1) grayscale(100%) brightness(200%);\n}\n\n:root,\n[data-bs-theme=light] {\n  --bs-btn-close-filter: ;\n}\n\n[data-bs-theme=dark] {\n  --bs-btn-close-filter: invert(1) grayscale(100%) brightness(200%);\n}\n\n.toast {\n  --bs-toast-zindex: 1090;\n  --bs-toast-padding-x: 0.75rem;\n  --bs-toast-padding-y: 0.5rem;\n  --bs-toast-spacing: 1.5rem;\n  --bs-toast-max-width: 350px;\n  --bs-toast-font-size: 0.875rem;\n  --bs-toast-color: ;\n  --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);\n  --bs-toast-border-width: var(--bs-border-width);\n  --bs-toast-border-color: var(--bs-border-color-translucent);\n  --bs-toast-border-radius: var(--bs-border-radius);\n  --bs-toast-box-shadow: var(--bs-box-shadow);\n  --bs-toast-header-color: var(--bs-secondary-color);\n  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);\n  --bs-toast-header-border-color: var(--bs-border-color-translucent);\n  width: var(--bs-toast-max-width);\n  max-width: 100%;\n  font-size: var(--bs-toast-font-size);\n  color: var(--bs-toast-color);\n  pointer-events: auto;\n  background-color: var(--bs-toast-bg);\n  background-clip: padding-box;\n  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);\n  box-shadow: var(--bs-toast-box-shadow);\n  border-radius: var(--bs-toast-border-radius);\n}\n.toast.showing {\n  opacity: 0;\n}\n.toast:not(.show) {\n  display: none;\n}\n\n.toast-container {\n  --bs-toast-zindex: 1090;\n  position: absolute;\n  z-index: var(--bs-toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n}\n.toast-container > :not(:last-child) {\n  margin-bottom: var(--bs-toast-spacing);\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);\n  color: var(--bs-toast-header-color);\n  background-color: var(--bs-toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);\n  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));\n  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));\n}\n.toast-header .btn-close {\n  margin-right: calc(-0.5 * var(--bs-toast-padding-x));\n  margin-left: var(--bs-toast-padding-x);\n}\n\n.toast-body {\n  padding: var(--bs-toast-padding-x);\n  word-wrap: break-word;\n}\n\n.modal {\n  --bs-modal-zindex: 1055;\n  --bs-modal-width: 500px;\n  --bs-modal-padding: 1rem;\n  --bs-modal-margin: 0.5rem;\n  --bs-modal-color: var(--bs-body-color);\n  --bs-modal-bg: var(--bs-body-bg);\n  --bs-modal-border-color: var(--bs-border-color-translucent);\n  --bs-modal-border-width: var(--bs-border-width);\n  --bs-modal-border-radius: var(--bs-border-radius-lg);\n  --bs-modal-box-shadow: var(--bs-box-shadow-sm);\n  --bs-modal-inner-border-radius: calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));\n  --bs-modal-header-padding-x: 1rem;\n  --bs-modal-header-padding-y: 1rem;\n  --bs-modal-header-padding: 1rem 1rem;\n  --bs-modal-header-border-color: var(--bs-border-color);\n  --bs-modal-header-border-width: var(--bs-border-width);\n  --bs-modal-title-line-height: 1.5;\n  --bs-modal-footer-gap: 0.5rem;\n  --bs-modal-footer-bg: ;\n  --bs-modal-footer-border-color: var(--bs-border-color);\n  --bs-modal-footer-border-width: var(--bs-border-width);\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--bs-modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  outline: 0;\n}\n\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--bs-modal-margin);\n  pointer-events: none;\n}\n.modal.fade .modal-dialog {\n  transform: translate(0, -50px);\n  transition: transform 0.3s ease-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .modal.fade .modal-dialog {\n    transition: none;\n  }\n}\n.modal.show .modal-dialog {\n  transform: none;\n}\n.modal.modal-static .modal-dialog {\n  transform: scale(1.02);\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--bs-modal-margin) * 2);\n}\n.modal-dialog-scrollable .modal-content {\n  max-height: 100%;\n  overflow: hidden;\n}\n.modal-dialog-scrollable .modal-body {\n  overflow-y: auto;\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--bs-modal-margin) * 2);\n}\n\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  color: var(--bs-modal-color);\n  pointer-events: auto;\n  background-color: var(--bs-modal-bg);\n  background-clip: padding-box;\n  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);\n  border-radius: var(--bs-modal-border-radius);\n  outline: 0;\n}\n\n.modal-backdrop {\n  --bs-backdrop-zindex: 1050;\n  --bs-backdrop-bg: #000;\n  --bs-backdrop-opacity: 0.5;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--bs-backdrop-zindex);\n  width: 100vw;\n  height: 100vh;\n  background-color: var(--bs-backdrop-bg);\n}\n.modal-backdrop.fade {\n  opacity: 0;\n}\n.modal-backdrop.show {\n  opacity: var(--bs-backdrop-opacity);\n}\n\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--bs-modal-header-padding);\n  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);\n  border-top-left-radius: var(--bs-modal-inner-border-radius);\n  border-top-right-radius: var(--bs-modal-inner-border-radius);\n}\n.modal-header .btn-close {\n  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);\n  margin-top: calc(-0.5 * var(--bs-modal-header-padding-y));\n  margin-right: calc(-0.5 * var(--bs-modal-header-padding-x));\n  margin-bottom: calc(-0.5 * var(--bs-modal-header-padding-y));\n  margin-left: auto;\n}\n\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--bs-modal-title-line-height);\n}\n\n.modal-body {\n  position: relative;\n  flex: 1 1 auto;\n  padding: var(--bs-modal-padding);\n}\n\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);\n  background-color: var(--bs-modal-footer-bg);\n  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);\n  border-bottom-right-radius: var(--bs-modal-inner-border-radius);\n  border-bottom-left-radius: var(--bs-modal-inner-border-radius);\n}\n.modal-footer > * {\n  margin: calc(var(--bs-modal-footer-gap) * 0.5);\n}\n\n@media (min-width: 576px) {\n  .modal {\n    --bs-modal-margin: 1.75rem;\n    --bs-modal-box-shadow: var(--bs-box-shadow);\n  }\n  .modal-dialog {\n    max-width: var(--bs-modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n  .modal-sm {\n    --bs-modal-width: 300px;\n  }\n}\n@media (min-width: 992px) {\n  .modal-lg,\n  .modal-xl {\n    --bs-modal-width: 800px;\n  }\n}\n@media (min-width: 1200px) {\n  .modal-xl {\n    --bs-modal-width: 1140px;\n  }\n}\n.modal-fullscreen {\n  width: 100vw;\n  max-width: none;\n  height: 100%;\n  margin: 0;\n}\n.modal-fullscreen .modal-content {\n  height: 100%;\n  border: 0;\n  border-radius: 0;\n}\n.modal-fullscreen .modal-header,\n.modal-fullscreen .modal-footer {\n  border-radius: 0;\n}\n.modal-fullscreen .modal-body {\n  overflow-y: auto;\n}\n\n@media (max-width: 575.98px) {\n  .modal-fullscreen-sm-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-sm-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-sm-down .modal-header,\n  .modal-fullscreen-sm-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-sm-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 767.98px) {\n  .modal-fullscreen-md-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-md-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-md-down .modal-header,\n  .modal-fullscreen-md-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-md-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 991.98px) {\n  .modal-fullscreen-lg-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-lg-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-lg-down .modal-header,\n  .modal-fullscreen-lg-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-lg-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 1199.98px) {\n  .modal-fullscreen-xl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-xl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-xl-down .modal-header,\n  .modal-fullscreen-xl-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-xl-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 1399.98px) {\n  .modal-fullscreen-xxl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-header,\n  .modal-fullscreen-xxl-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-body {\n    overflow-y: auto;\n  }\n}\n.tooltip {\n  --bs-tooltip-zindex: 1080;\n  --bs-tooltip-max-width: 200px;\n  --bs-tooltip-padding-x: 0.5rem;\n  --bs-tooltip-padding-y: 0.25rem;\n  --bs-tooltip-margin: ;\n  --bs-tooltip-font-size: 0.875rem;\n  --bs-tooltip-color: var(--bs-body-bg);\n  --bs-tooltip-bg: var(--bs-emphasis-color);\n  --bs-tooltip-border-radius: var(--bs-border-radius);\n  --bs-tooltip-opacity: 0.9;\n  --bs-tooltip-arrow-width: 0.8rem;\n  --bs-tooltip-arrow-height: 0.4rem;\n  z-index: var(--bs-tooltip-zindex);\n  display: block;\n  margin: var(--bs-tooltip-margin);\n  font-family: var(--bs-font-sans-serif);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n  font-size: var(--bs-tooltip-font-size);\n  word-wrap: break-word;\n  opacity: 0;\n}\n.tooltip.show {\n  opacity: var(--bs-tooltip-opacity);\n}\n.tooltip .tooltip-arrow {\n  display: block;\n  width: var(--bs-tooltip-arrow-width);\n  height: var(--bs-tooltip-arrow-height);\n}\n.tooltip .tooltip-arrow::before {\n  position: absolute;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {\n  bottom: calc(-1 * var(--bs-tooltip-arrow-height));\n}\n.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {\n  top: -1px;\n  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;\n  border-top-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {\n  left: calc(-1 * var(--bs-tooltip-arrow-height));\n  width: var(--bs-tooltip-arrow-height);\n  height: var(--bs-tooltip-arrow-width);\n}\n.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {\n  right: -1px;\n  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;\n  border-right-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:end:ignore */\n.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {\n  top: calc(-1 * var(--bs-tooltip-arrow-height));\n}\n.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {\n  bottom: -1px;\n  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);\n  border-bottom-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {\n  right: calc(-1 * var(--bs-tooltip-arrow-height));\n  width: var(--bs-tooltip-arrow-height);\n  height: var(--bs-tooltip-arrow-width);\n}\n.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {\n  left: -1px;\n  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);\n  border-left-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:end:ignore */\n.tooltip-inner {\n  max-width: var(--bs-tooltip-max-width);\n  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);\n  color: var(--bs-tooltip-color);\n  text-align: center;\n  background-color: var(--bs-tooltip-bg);\n  border-radius: var(--bs-tooltip-border-radius);\n}\n\n.popover {\n  --bs-popover-zindex: 1070;\n  --bs-popover-max-width: 276px;\n  --bs-popover-font-size: 0.875rem;\n  --bs-popover-bg: var(--bs-body-bg);\n  --bs-popover-border-width: var(--bs-border-width);\n  --bs-popover-border-color: var(--bs-border-color-translucent);\n  --bs-popover-border-radius: var(--bs-border-radius-lg);\n  --bs-popover-inner-border-radius: calc(var(--bs-border-radius-lg) - var(--bs-border-width));\n  --bs-popover-box-shadow: var(--bs-box-shadow);\n  --bs-popover-header-padding-x: 1rem;\n  --bs-popover-header-padding-y: 0.5rem;\n  --bs-popover-header-font-size: 1rem;\n  --bs-popover-header-color: inherit;\n  --bs-popover-header-bg: var(--bs-secondary-bg);\n  --bs-popover-body-padding-x: 1rem;\n  --bs-popover-body-padding-y: 1rem;\n  --bs-popover-body-color: var(--bs-body-color);\n  --bs-popover-arrow-width: 1rem;\n  --bs-popover-arrow-height: 0.5rem;\n  --bs-popover-arrow-border: var(--bs-popover-border-color);\n  z-index: var(--bs-popover-zindex);\n  display: block;\n  max-width: var(--bs-popover-max-width);\n  font-family: var(--bs-font-sans-serif);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n  font-size: var(--bs-popover-font-size);\n  word-wrap: break-word;\n  background-color: var(--bs-popover-bg);\n  background-clip: padding-box;\n  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);\n  border-radius: var(--bs-popover-border-radius);\n}\n.popover .popover-arrow {\n  display: block;\n  width: var(--bs-popover-arrow-width);\n  height: var(--bs-popover-arrow-height);\n}\n.popover .popover-arrow::before, .popover .popover-arrow::after {\n  position: absolute;\n  display: block;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n  border-width: 0;\n}\n\n.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {\n  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n}\n.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {\n  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;\n}\n.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {\n  bottom: 0;\n  border-top-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {\n  bottom: var(--bs-popover-border-width);\n  border-top-color: var(--bs-popover-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {\n  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n  width: var(--bs-popover-arrow-height);\n  height: var(--bs-popover-arrow-width);\n}\n.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {\n  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;\n}\n.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {\n  left: 0;\n  border-right-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {\n  left: var(--bs-popover-border-width);\n  border-right-color: var(--bs-popover-bg);\n}\n\n/* rtl:end:ignore */\n.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {\n  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n}\n.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {\n  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);\n}\n.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {\n  top: 0;\n  border-bottom-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {\n  top: var(--bs-popover-border-width);\n  border-bottom-color: var(--bs-popover-bg);\n}\n.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  display: block;\n  width: var(--bs-popover-arrow-width);\n  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));\n  content: \"\";\n  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {\n  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n  width: var(--bs-popover-arrow-height);\n  height: var(--bs-popover-arrow-width);\n}\n.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {\n  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);\n}\n.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {\n  right: 0;\n  border-left-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {\n  right: var(--bs-popover-border-width);\n  border-left-color: var(--bs-popover-bg);\n}\n\n/* rtl:end:ignore */\n.popover-header {\n  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);\n  margin-bottom: 0;\n  font-size: var(--bs-popover-header-font-size);\n  color: var(--bs-popover-header-color);\n  background-color: var(--bs-popover-header-bg);\n  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);\n  border-top-left-radius: var(--bs-popover-inner-border-radius);\n  border-top-right-radius: var(--bs-popover-inner-border-radius);\n}\n.popover-header:empty {\n  display: none;\n}\n\n.popover-body {\n  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);\n  color: var(--bs-popover-body-color);\n}\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n.carousel-inner::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  transition: transform 0.6s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-item {\n    transition: none;\n  }\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n.carousel-fade .carousel-item {\n  opacity: 0;\n  transition-property: opacity;\n  transform: none;\n}\n.carousel-fade .carousel-item.active,\n.carousel-fade .carousel-item-next.carousel-item-start,\n.carousel-fade .carousel-item-prev.carousel-item-end {\n  z-index: 1;\n  opacity: 1;\n}\n.carousel-fade .active.carousel-item-start,\n.carousel-fade .active.carousel-item-end {\n  z-index: 0;\n  opacity: 0;\n  transition: opacity 0s 0.6s;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-fade .active.carousel-item-start,\n  .carousel-fade .active.carousel-item-end {\n    transition: none;\n  }\n}\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 15%;\n  padding: 0;\n  color: #fff;\n  text-align: center;\n  background: none;\n  filter: var(--bs-carousel-control-icon-filter);\n  border: 0;\n  opacity: 0.5;\n  transition: opacity 0.15s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-control-prev,\n  .carousel-control-next {\n    transition: none;\n  }\n}\n.carousel-control-prev:hover, .carousel-control-prev:focus,\n.carousel-control-next:hover,\n.carousel-control-next:focus {\n  color: #fff;\n  text-decoration: none;\n  outline: 0;\n  opacity: 0.9;\n}\n\n.carousel-control-prev {\n  left: 0;\n}\n\n.carousel-control-next {\n  right: 0;\n}\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/%3e%3c/svg%3e\") /*rtl:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/%3e%3c/svg%3e\")*/;\n}\n\n.carousel-control-next-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/%3e%3c/svg%3e\") /*rtl:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/%3e%3c/svg%3e\")*/;\n}\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  margin-right: 15%;\n  margin-bottom: 1rem;\n  margin-left: 15%;\n}\n.carousel-indicators [data-bs-target] {\n  box-sizing: content-box;\n  flex: 0 1 auto;\n  width: 30px;\n  height: 3px;\n  padding: 0;\n  margin-right: 3px;\n  margin-left: 3px;\n  text-indent: -999px;\n  cursor: pointer;\n  background-color: var(--bs-carousel-indicator-active-bg);\n  background-clip: padding-box;\n  border: 0;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  opacity: 0.5;\n  transition: opacity 0.6s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-indicators [data-bs-target] {\n    transition: none;\n  }\n}\n.carousel-indicators .active {\n  opacity: 1;\n}\n\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 1.25rem;\n  left: 15%;\n  padding-top: 1.25rem;\n  padding-bottom: 1.25rem;\n  color: var(--bs-carousel-caption-color);\n  text-align: center;\n}\n\n.carousel-dark {\n  --bs-carousel-indicator-active-bg: #000;\n  --bs-carousel-caption-color: #000;\n  --bs-carousel-control-icon-filter: invert(1) grayscale(100);\n}\n\n:root,\n[data-bs-theme=light] {\n  --bs-carousel-indicator-active-bg: #fff;\n  --bs-carousel-caption-color: #fff;\n  --bs-carousel-control-icon-filter: ;\n}\n\n[data-bs-theme=dark] {\n  --bs-carousel-indicator-active-bg: #000;\n  --bs-carousel-caption-color: #000;\n  --bs-carousel-control-icon-filter: invert(1) grayscale(100);\n}\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  flex-shrink: 0;\n  width: var(--bs-spinner-width);\n  height: var(--bs-spinner-height);\n  vertical-align: var(--bs-spinner-vertical-align);\n  border-radius: 50%;\n  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);\n}\n\n@keyframes spinner-border {\n  to {\n    transform: rotate(360deg) /* rtl:ignore */;\n  }\n}\n.spinner-border {\n  --bs-spinner-width: 2rem;\n  --bs-spinner-height: 2rem;\n  --bs-spinner-vertical-align: -0.125em;\n  --bs-spinner-border-width: 0.25em;\n  --bs-spinner-animation-speed: 0.75s;\n  --bs-spinner-animation-name: spinner-border;\n  border: var(--bs-spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  --bs-spinner-width: 1rem;\n  --bs-spinner-height: 1rem;\n  --bs-spinner-border-width: 0.2em;\n}\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n.spinner-grow {\n  --bs-spinner-width: 2rem;\n  --bs-spinner-height: 2rem;\n  --bs-spinner-vertical-align: -0.125em;\n  --bs-spinner-animation-speed: 0.75s;\n  --bs-spinner-animation-name: spinner-grow;\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --bs-spinner-width: 1rem;\n  --bs-spinner-height: 1rem;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .spinner-border,\n  .spinner-grow {\n    --bs-spinner-animation-speed: 1.5s;\n  }\n}\n.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {\n  --bs-offcanvas-zindex: 1045;\n  --bs-offcanvas-width: 400px;\n  --bs-offcanvas-height: 30vh;\n  --bs-offcanvas-padding-x: 1rem;\n  --bs-offcanvas-padding-y: 1rem;\n  --bs-offcanvas-color: var(--bs-body-color);\n  --bs-offcanvas-bg: var(--bs-body-bg);\n  --bs-offcanvas-border-width: var(--bs-border-width);\n  --bs-offcanvas-border-color: var(--bs-border-color-translucent);\n  --bs-offcanvas-box-shadow: var(--bs-box-shadow-sm);\n  --bs-offcanvas-transition: transform 0.3s ease-in-out;\n  --bs-offcanvas-title-line-height: 1.5;\n}\n\n@media (max-width: 575.98px) {\n  .offcanvas-sm {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-sm {\n    transition: none;\n  }\n}\n@media (max-width: 575.98px) {\n  .offcanvas-sm.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-sm.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-sm.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-sm.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 576px) {\n  .offcanvas-sm {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-sm .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-sm .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .offcanvas-md {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-md {\n    transition: none;\n  }\n}\n@media (max-width: 767.98px) {\n  .offcanvas-md.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-md.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-md.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-md.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 768px) {\n  .offcanvas-md {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-md .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-md .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .offcanvas-lg {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-lg {\n    transition: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .offcanvas-lg.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-lg.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-lg.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-lg.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 992px) {\n  .offcanvas-lg {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-lg .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-lg .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .offcanvas-xl {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-xl {\n    transition: none;\n  }\n}\n@media (max-width: 1199.98px) {\n  .offcanvas-xl.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-xl.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-xl.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-xl.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 1200px) {\n  .offcanvas-xl {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-xl .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-xl .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-xxl {\n    transition: none;\n  }\n}\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-xxl.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-xxl.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-xxl.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 1400px) {\n  .offcanvas-xxl {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-xxl .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-xxl .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n.offcanvas {\n  position: fixed;\n  bottom: 0;\n  z-index: var(--bs-offcanvas-zindex);\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n  color: var(--bs-offcanvas-color);\n  visibility: hidden;\n  background-color: var(--bs-offcanvas-bg);\n  background-clip: padding-box;\n  outline: 0;\n  transition: var(--bs-offcanvas-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .offcanvas {\n    transition: none;\n  }\n}\n.offcanvas.offcanvas-start {\n  top: 0;\n  left: 0;\n  width: var(--bs-offcanvas-width);\n  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateX(-100%);\n}\n.offcanvas.offcanvas-end {\n  top: 0;\n  right: 0;\n  width: var(--bs-offcanvas-width);\n  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateX(100%);\n}\n.offcanvas.offcanvas-top {\n  top: 0;\n  right: 0;\n  left: 0;\n  height: var(--bs-offcanvas-height);\n  max-height: 100%;\n  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateY(-100%);\n}\n.offcanvas.offcanvas-bottom {\n  right: 0;\n  left: 0;\n  height: var(--bs-offcanvas-height);\n  max-height: 100%;\n  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateY(100%);\n}\n.offcanvas.showing, .offcanvas.show:not(.hiding) {\n  transform: none;\n}\n.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {\n  visibility: visible;\n}\n\n.offcanvas-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1040;\n  width: 100vw;\n  height: 100vh;\n  background-color: #000;\n}\n.offcanvas-backdrop.fade {\n  opacity: 0;\n}\n.offcanvas-backdrop.show {\n  opacity: 0.5;\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);\n}\n.offcanvas-header .btn-close {\n  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);\n  margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));\n  margin-right: calc(-0.5 * var(--bs-offcanvas-padding-x));\n  margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));\n  margin-left: auto;\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--bs-offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);\n  overflow-y: auto;\n}\n\n.placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: 0.5;\n}\n.placeholder.btn::before {\n  display: inline-block;\n  content: \"\";\n}\n\n.placeholder-xs {\n  min-height: 0.6em;\n}\n\n.placeholder-sm {\n  min-height: 0.8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n.placeholder-glow .placeholder {\n  animation: placeholder-glow 2s ease-in-out infinite;\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: 0.2;\n  }\n}\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n.clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.text-bg-primary {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-secondary {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-success {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-info {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-warning {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-danger {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-light {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-dark {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.link-primary {\n  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-primary:hover, .link-primary:focus {\n  color: RGBA(10, 88, 202, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(10, 88, 202, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-secondary {\n  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-secondary:hover, .link-secondary:focus {\n  color: RGBA(86, 94, 100, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(86, 94, 100, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-success {\n  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-success:hover, .link-success:focus {\n  color: RGBA(20, 108, 67, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(20, 108, 67, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-info {\n  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-info:hover, .link-info:focus {\n  color: RGBA(61, 213, 243, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(61, 213, 243, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-warning {\n  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-warning:hover, .link-warning:focus {\n  color: RGBA(255, 205, 57, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(255, 205, 57, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-danger {\n  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-danger:hover, .link-danger:focus {\n  color: RGBA(176, 42, 55, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(176, 42, 55, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-light {\n  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-light:hover, .link-light:focus {\n  color: RGBA(249, 250, 251, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(249, 250, 251, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-dark {\n  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-dark:hover, .link-dark:focus {\n  color: RGBA(26, 30, 33, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(26, 30, 33, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-body-emphasis {\n  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-body-emphasis:hover, .link-body-emphasis:focus {\n  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;\n  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;\n}\n\n.focus-ring:focus {\n  outline: 0;\n  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);\n}\n\n.icon-link {\n  display: inline-flex;\n  gap: 0.375rem;\n  align-items: center;\n  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));\n  text-underline-offset: 0.25em;\n  backface-visibility: hidden;\n}\n.icon-link > .bi {\n  flex-shrink: 0;\n  width: 1em;\n  height: 1em;\n  fill: currentcolor;\n  transition: 0.2s ease-in-out transform;\n}\n@media (prefers-reduced-motion: reduce) {\n  .icon-link > .bi {\n    transition: none;\n  }\n}\n\n.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {\n  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));\n}\n\n.ratio {\n  position: relative;\n  width: 100%;\n}\n.ratio::before {\n  display: block;\n  padding-top: var(--bs-aspect-ratio);\n  content: \"\";\n}\n.ratio > * {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.ratio-1x1 {\n  --bs-aspect-ratio: 100%;\n}\n\n.ratio-4x3 {\n  --bs-aspect-ratio: 75%;\n}\n\n.ratio-16x9 {\n  --bs-aspect-ratio: 56.25%;\n}\n\n.ratio-21x9 {\n  --bs-aspect-ratio: 42.8571428571%;\n}\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.sticky-top {\n  position: sticky;\n  top: 0;\n  z-index: 1020;\n}\n\n.sticky-bottom {\n  position: sticky;\n  bottom: 0;\n  z-index: 1020;\n}\n\n@media (min-width: 576px) {\n  .sticky-sm-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-sm-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 768px) {\n  .sticky-md-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-md-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 992px) {\n  .sticky-lg-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-lg-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1200px) {\n  .sticky-xl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-xl-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1400px) {\n  .sticky-xxl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-xxl-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n.visually-hidden:not(caption),\n.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {\n  position: absolute !important;\n}\n.visually-hidden *,\n.visually-hidden-focusable:not(:focus):not(:focus-within) * {\n  overflow: hidden !important;\n}\n\n.stretched-link::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  content: \"\";\n}\n\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.vr {\n  display: inline-block;\n  align-self: stretch;\n  width: var(--bs-border-width);\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: 0.25;\n}\n\n.align-baseline {\n  vertical-align: baseline !important;\n}\n\n.align-top {\n  vertical-align: top !important;\n}\n\n.align-middle {\n  vertical-align: middle !important;\n}\n\n.align-bottom {\n  vertical-align: bottom !important;\n}\n\n.align-text-bottom {\n  vertical-align: text-bottom !important;\n}\n\n.align-text-top {\n  vertical-align: text-top !important;\n}\n\n.float-start {\n  float: left !important;\n}\n\n.float-end {\n  float: right !important;\n}\n\n.float-none {\n  float: none !important;\n}\n\n.object-fit-contain {\n  object-fit: contain !important;\n}\n\n.object-fit-cover {\n  object-fit: cover !important;\n}\n\n.object-fit-fill {\n  object-fit: fill !important;\n}\n\n.object-fit-scale {\n  object-fit: scale-down !important;\n}\n\n.object-fit-none {\n  object-fit: none !important;\n}\n\n.opacity-0 {\n  opacity: 0 !important;\n}\n\n.opacity-25 {\n  opacity: 0.25 !important;\n}\n\n.opacity-50 {\n  opacity: 0.5 !important;\n}\n\n.opacity-75 {\n  opacity: 0.75 !important;\n}\n\n.opacity-100 {\n  opacity: 1 !important;\n}\n\n.overflow-auto {\n  overflow: auto !important;\n}\n\n.overflow-hidden {\n  overflow: hidden !important;\n}\n\n.overflow-visible {\n  overflow: visible !important;\n}\n\n.overflow-scroll {\n  overflow: scroll !important;\n}\n\n.overflow-x-auto {\n  overflow-x: auto !important;\n}\n\n.overflow-x-hidden {\n  overflow-x: hidden !important;\n}\n\n.overflow-x-visible {\n  overflow-x: visible !important;\n}\n\n.overflow-x-scroll {\n  overflow-x: scroll !important;\n}\n\n.overflow-y-auto {\n  overflow-y: auto !important;\n}\n\n.overflow-y-hidden {\n  overflow-y: hidden !important;\n}\n\n.overflow-y-visible {\n  overflow-y: visible !important;\n}\n\n.overflow-y-scroll {\n  overflow-y: scroll !important;\n}\n\n.d-inline {\n  display: inline !important;\n}\n\n.d-inline-block {\n  display: inline-block !important;\n}\n\n.d-block {\n  display: block !important;\n}\n\n.d-grid {\n  display: grid !important;\n}\n\n.d-inline-grid {\n  display: inline-grid !important;\n}\n\n.d-table {\n  display: table !important;\n}\n\n.d-table-row {\n  display: table-row !important;\n}\n\n.d-table-cell {\n  display: table-cell !important;\n}\n\n.d-flex {\n  display: flex !important;\n}\n\n.d-inline-flex {\n  display: inline-flex !important;\n}\n\n.d-none {\n  display: none !important;\n}\n\n.shadow {\n  box-shadow: var(--bs-box-shadow) !important;\n}\n\n.shadow-sm {\n  box-shadow: var(--bs-box-shadow-sm) !important;\n}\n\n.shadow-lg {\n  box-shadow: var(--bs-box-shadow-lg) !important;\n}\n\n.shadow-none {\n  box-shadow: none !important;\n}\n\n.focus-ring-primary {\n  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-secondary {\n  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-success {\n  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-info {\n  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-warning {\n  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-danger {\n  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-light {\n  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-dark {\n  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));\n}\n\n.position-static {\n  position: static !important;\n}\n\n.position-relative {\n  position: relative !important;\n}\n\n.position-absolute {\n  position: absolute !important;\n}\n\n.position-fixed {\n  position: fixed !important;\n}\n\n.position-sticky {\n  position: sticky !important;\n}\n\n.top-0 {\n  top: 0 !important;\n}\n\n.top-50 {\n  top: 50% !important;\n}\n\n.top-100 {\n  top: 100% !important;\n}\n\n.bottom-0 {\n  bottom: 0 !important;\n}\n\n.bottom-50 {\n  bottom: 50% !important;\n}\n\n.bottom-100 {\n  bottom: 100% !important;\n}\n\n.start-0 {\n  left: 0 !important;\n}\n\n.start-50 {\n  left: 50% !important;\n}\n\n.start-100 {\n  left: 100% !important;\n}\n\n.end-0 {\n  right: 0 !important;\n}\n\n.end-50 {\n  right: 50% !important;\n}\n\n.end-100 {\n  right: 100% !important;\n}\n\n.translate-middle {\n  transform: translate(-50%, -50%) !important;\n}\n\n.translate-middle-x {\n  transform: translateX(-50%) !important;\n}\n\n.translate-middle-y {\n  transform: translateY(-50%) !important;\n}\n\n.border {\n  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-0 {\n  border: 0 !important;\n}\n\n.border-top {\n  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-top-0 {\n  border-top: 0 !important;\n}\n\n.border-end {\n  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-end-0 {\n  border-right: 0 !important;\n}\n\n.border-bottom {\n  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-bottom-0 {\n  border-bottom: 0 !important;\n}\n\n.border-start {\n  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-start-0 {\n  border-left: 0 !important;\n}\n\n.border-primary {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-secondary {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-success {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-info {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-warning {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-danger {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-light {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-dark {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-black {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-white {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-primary-subtle {\n  border-color: var(--bs-primary-border-subtle) !important;\n}\n\n.border-secondary-subtle {\n  border-color: var(--bs-secondary-border-subtle) !important;\n}\n\n.border-success-subtle {\n  border-color: var(--bs-success-border-subtle) !important;\n}\n\n.border-info-subtle {\n  border-color: var(--bs-info-border-subtle) !important;\n}\n\n.border-warning-subtle {\n  border-color: var(--bs-warning-border-subtle) !important;\n}\n\n.border-danger-subtle {\n  border-color: var(--bs-danger-border-subtle) !important;\n}\n\n.border-light-subtle {\n  border-color: var(--bs-light-border-subtle) !important;\n}\n\n.border-dark-subtle {\n  border-color: var(--bs-dark-border-subtle) !important;\n}\n\n.border-1 {\n  border-width: 1px !important;\n}\n\n.border-2 {\n  border-width: 2px !important;\n}\n\n.border-3 {\n  border-width: 3px !important;\n}\n\n.border-4 {\n  border-width: 4px !important;\n}\n\n.border-5 {\n  border-width: 5px !important;\n}\n\n.border-opacity-10 {\n  --bs-border-opacity: 0.1;\n}\n\n.border-opacity-25 {\n  --bs-border-opacity: 0.25;\n}\n\n.border-opacity-50 {\n  --bs-border-opacity: 0.5;\n}\n\n.border-opacity-75 {\n  --bs-border-opacity: 0.75;\n}\n\n.border-opacity-100 {\n  --bs-border-opacity: 1;\n}\n\n.w-25 {\n  width: 25% !important;\n}\n\n.w-50 {\n  width: 50% !important;\n}\n\n.w-75 {\n  width: 75% !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.w-auto {\n  width: auto !important;\n}\n\n.mw-100 {\n  max-width: 100% !important;\n}\n\n.vw-100 {\n  width: 100vw !important;\n}\n\n.min-vw-100 {\n  min-width: 100vw !important;\n}\n\n.h-25 {\n  height: 25% !important;\n}\n\n.h-50 {\n  height: 50% !important;\n}\n\n.h-75 {\n  height: 75% !important;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n.h-auto {\n  height: auto !important;\n}\n\n.mh-100 {\n  max-height: 100% !important;\n}\n\n.vh-100 {\n  height: 100vh !important;\n}\n\n.min-vh-100 {\n  min-height: 100vh !important;\n}\n\n.flex-fill {\n  flex: 1 1 auto !important;\n}\n\n.flex-row {\n  flex-direction: row !important;\n}\n\n.flex-column {\n  flex-direction: column !important;\n}\n\n.flex-row-reverse {\n  flex-direction: row-reverse !important;\n}\n\n.flex-column-reverse {\n  flex-direction: column-reverse !important;\n}\n\n.flex-grow-0 {\n  flex-grow: 0 !important;\n}\n\n.flex-grow-1 {\n  flex-grow: 1 !important;\n}\n\n.flex-shrink-0 {\n  flex-shrink: 0 !important;\n}\n\n.flex-shrink-1 {\n  flex-shrink: 1 !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n.flex-nowrap {\n  flex-wrap: nowrap !important;\n}\n\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important;\n}\n\n.justify-content-start {\n  justify-content: flex-start !important;\n}\n\n.justify-content-end {\n  justify-content: flex-end !important;\n}\n\n.justify-content-center {\n  justify-content: center !important;\n}\n\n.justify-content-between {\n  justify-content: space-between !important;\n}\n\n.justify-content-around {\n  justify-content: space-around !important;\n}\n\n.justify-content-evenly {\n  justify-content: space-evenly !important;\n}\n\n.align-items-start {\n  align-items: flex-start !important;\n}\n\n.align-items-end {\n  align-items: flex-end !important;\n}\n\n.align-items-center {\n  align-items: center !important;\n}\n\n.align-items-baseline {\n  align-items: baseline !important;\n}\n\n.align-items-stretch {\n  align-items: stretch !important;\n}\n\n.align-content-start {\n  align-content: flex-start !important;\n}\n\n.align-content-end {\n  align-content: flex-end !important;\n}\n\n.align-content-center {\n  align-content: center !important;\n}\n\n.align-content-between {\n  align-content: space-between !important;\n}\n\n.align-content-around {\n  align-content: space-around !important;\n}\n\n.align-content-stretch {\n  align-content: stretch !important;\n}\n\n.align-self-auto {\n  align-self: auto !important;\n}\n\n.align-self-start {\n  align-self: flex-start !important;\n}\n\n.align-self-end {\n  align-self: flex-end !important;\n}\n\n.align-self-center {\n  align-self: center !important;\n}\n\n.align-self-baseline {\n  align-self: baseline !important;\n}\n\n.align-self-stretch {\n  align-self: stretch !important;\n}\n\n.order-first {\n  order: -1 !important;\n}\n\n.order-0 {\n  order: 0 !important;\n}\n\n.order-1 {\n  order: 1 !important;\n}\n\n.order-2 {\n  order: 2 !important;\n}\n\n.order-3 {\n  order: 3 !important;\n}\n\n.order-4 {\n  order: 4 !important;\n}\n\n.order-5 {\n  order: 5 !important;\n}\n\n.order-last {\n  order: 6 !important;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.m-1 {\n  margin: 0.25rem !important;\n}\n\n.m-2 {\n  margin: 0.5rem !important;\n}\n\n.m-3 {\n  margin: 1rem !important;\n}\n\n.m-4 {\n  margin: 1.5rem !important;\n}\n\n.m-5 {\n  margin: 3rem !important;\n}\n\n.m-auto {\n  margin: auto !important;\n}\n\n.mx-0 {\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n\n.mx-1 {\n  margin-right: 0.25rem !important;\n  margin-left: 0.25rem !important;\n}\n\n.mx-2 {\n  margin-right: 0.5rem !important;\n  margin-left: 0.5rem !important;\n}\n\n.mx-3 {\n  margin-right: 1rem !important;\n  margin-left: 1rem !important;\n}\n\n.mx-4 {\n  margin-right: 1.5rem !important;\n  margin-left: 1.5rem !important;\n}\n\n.mx-5 {\n  margin-right: 3rem !important;\n  margin-left: 3rem !important;\n}\n\n.mx-auto {\n  margin-right: auto !important;\n  margin-left: auto !important;\n}\n\n.my-0 {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n\n.my-1 {\n  margin-top: 0.25rem !important;\n  margin-bottom: 0.25rem !important;\n}\n\n.my-2 {\n  margin-top: 0.5rem !important;\n  margin-bottom: 0.5rem !important;\n}\n\n.my-3 {\n  margin-top: 1rem !important;\n  margin-bottom: 1rem !important;\n}\n\n.my-4 {\n  margin-top: 1.5rem !important;\n  margin-bottom: 1.5rem !important;\n}\n\n.my-5 {\n  margin-top: 3rem !important;\n  margin-bottom: 3rem !important;\n}\n\n.my-auto {\n  margin-top: auto !important;\n  margin-bottom: auto !important;\n}\n\n.mt-0 {\n  margin-top: 0 !important;\n}\n\n.mt-1 {\n  margin-top: 0.25rem !important;\n}\n\n.mt-2 {\n  margin-top: 0.5rem !important;\n}\n\n.mt-3 {\n  margin-top: 1rem !important;\n}\n\n.mt-4 {\n  margin-top: 1.5rem !important;\n}\n\n.mt-5 {\n  margin-top: 3rem !important;\n}\n\n.mt-auto {\n  margin-top: auto !important;\n}\n\n.me-0 {\n  margin-right: 0 !important;\n}\n\n.me-1 {\n  margin-right: 0.25rem !important;\n}\n\n.me-2 {\n  margin-right: 0.5rem !important;\n}\n\n.me-3 {\n  margin-right: 1rem !important;\n}\n\n.me-4 {\n  margin-right: 1.5rem !important;\n}\n\n.me-5 {\n  margin-right: 3rem !important;\n}\n\n.me-auto {\n  margin-right: auto !important;\n}\n\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n\n.mb-1 {\n  margin-bottom: 0.25rem !important;\n}\n\n.mb-2 {\n  margin-bottom: 0.5rem !important;\n}\n\n.mb-3 {\n  margin-bottom: 1rem !important;\n}\n\n.mb-4 {\n  margin-bottom: 1.5rem !important;\n}\n\n.mb-5 {\n  margin-bottom: 3rem !important;\n}\n\n.mb-auto {\n  margin-bottom: auto !important;\n}\n\n.ms-0 {\n  margin-left: 0 !important;\n}\n\n.ms-1 {\n  margin-left: 0.25rem !important;\n}\n\n.ms-2 {\n  margin-left: 0.5rem !important;\n}\n\n.ms-3 {\n  margin-left: 1rem !important;\n}\n\n.ms-4 {\n  margin-left: 1.5rem !important;\n}\n\n.ms-5 {\n  margin-left: 3rem !important;\n}\n\n.ms-auto {\n  margin-left: auto !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.p-1 {\n  padding: 0.25rem !important;\n}\n\n.p-2 {\n  padding: 0.5rem !important;\n}\n\n.p-3 {\n  padding: 1rem !important;\n}\n\n.p-4 {\n  padding: 1.5rem !important;\n}\n\n.p-5 {\n  padding: 3rem !important;\n}\n\n.px-0 {\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n}\n\n.px-1 {\n  padding-right: 0.25rem !important;\n  padding-left: 0.25rem !important;\n}\n\n.px-2 {\n  padding-right: 0.5rem !important;\n  padding-left: 0.5rem !important;\n}\n\n.px-3 {\n  padding-right: 1rem !important;\n  padding-left: 1rem !important;\n}\n\n.px-4 {\n  padding-right: 1.5rem !important;\n  padding-left: 1.5rem !important;\n}\n\n.px-5 {\n  padding-right: 3rem !important;\n  padding-left: 3rem !important;\n}\n\n.py-0 {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n\n.py-1 {\n  padding-top: 0.25rem !important;\n  padding-bottom: 0.25rem !important;\n}\n\n.py-2 {\n  padding-top: 0.5rem !important;\n  padding-bottom: 0.5rem !important;\n}\n\n.py-3 {\n  padding-top: 1rem !important;\n  padding-bottom: 1rem !important;\n}\n\n.py-4 {\n  padding-top: 1.5rem !important;\n  padding-bottom: 1.5rem !important;\n}\n\n.py-5 {\n  padding-top: 3rem !important;\n  padding-bottom: 3rem !important;\n}\n\n.pt-0 {\n  padding-top: 0 !important;\n}\n\n.pt-1 {\n  padding-top: 0.25rem !important;\n}\n\n.pt-2 {\n  padding-top: 0.5rem !important;\n}\n\n.pt-3 {\n  padding-top: 1rem !important;\n}\n\n.pt-4 {\n  padding-top: 1.5rem !important;\n}\n\n.pt-5 {\n  padding-top: 3rem !important;\n}\n\n.pe-0 {\n  padding-right: 0 !important;\n}\n\n.pe-1 {\n  padding-right: 0.25rem !important;\n}\n\n.pe-2 {\n  padding-right: 0.5rem !important;\n}\n\n.pe-3 {\n  padding-right: 1rem !important;\n}\n\n.pe-4 {\n  padding-right: 1.5rem !important;\n}\n\n.pe-5 {\n  padding-right: 3rem !important;\n}\n\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n\n.pb-1 {\n  padding-bottom: 0.25rem !important;\n}\n\n.pb-2 {\n  padding-bottom: 0.5rem !important;\n}\n\n.pb-3 {\n  padding-bottom: 1rem !important;\n}\n\n.pb-4 {\n  padding-bottom: 1.5rem !important;\n}\n\n.pb-5 {\n  padding-bottom: 3rem !important;\n}\n\n.ps-0 {\n  padding-left: 0 !important;\n}\n\n.ps-1 {\n  padding-left: 0.25rem !important;\n}\n\n.ps-2 {\n  padding-left: 0.5rem !important;\n}\n\n.ps-3 {\n  padding-left: 1rem !important;\n}\n\n.ps-4 {\n  padding-left: 1.5rem !important;\n}\n\n.ps-5 {\n  padding-left: 3rem !important;\n}\n\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-1 {\n  gap: 0.25rem !important;\n}\n\n.gap-2 {\n  gap: 0.5rem !important;\n}\n\n.gap-3 {\n  gap: 1rem !important;\n}\n\n.gap-4 {\n  gap: 1.5rem !important;\n}\n\n.gap-5 {\n  gap: 3rem !important;\n}\n\n.row-gap-0 {\n  row-gap: 0 !important;\n}\n\n.row-gap-1 {\n  row-gap: 0.25rem !important;\n}\n\n.row-gap-2 {\n  row-gap: 0.5rem !important;\n}\n\n.row-gap-3 {\n  row-gap: 1rem !important;\n}\n\n.row-gap-4 {\n  row-gap: 1.5rem !important;\n}\n\n.row-gap-5 {\n  row-gap: 3rem !important;\n}\n\n.column-gap-0 {\n  column-gap: 0 !important;\n}\n\n.column-gap-1 {\n  column-gap: 0.25rem !important;\n}\n\n.column-gap-2 {\n  column-gap: 0.5rem !important;\n}\n\n.column-gap-3 {\n  column-gap: 1rem !important;\n}\n\n.column-gap-4 {\n  column-gap: 1.5rem !important;\n}\n\n.column-gap-5 {\n  column-gap: 3rem !important;\n}\n\n.font-monospace {\n  font-family: var(--bs-font-monospace) !important;\n}\n\n.fs-1 {\n  font-size: calc(1.375rem + 1.5vw) !important;\n}\n\n.fs-2 {\n  font-size: calc(1.325rem + 0.9vw) !important;\n}\n\n.fs-3 {\n  font-size: calc(1.3rem + 0.6vw) !important;\n}\n\n.fs-4 {\n  font-size: calc(1.275rem + 0.3vw) !important;\n}\n\n.fs-5 {\n  font-size: 1.25rem !important;\n}\n\n.fs-6 {\n  font-size: 1rem !important;\n}\n\n.fst-italic {\n  font-style: italic !important;\n}\n\n.fst-normal {\n  font-style: normal !important;\n}\n\n.fw-lighter {\n  font-weight: lighter !important;\n}\n\n.fw-light {\n  font-weight: 300 !important;\n}\n\n.fw-normal {\n  font-weight: 400 !important;\n}\n\n.fw-medium {\n  font-weight: 500 !important;\n}\n\n.fw-semibold {\n  font-weight: 600 !important;\n}\n\n.fw-bold {\n  font-weight: 700 !important;\n}\n\n.fw-bolder {\n  font-weight: bolder !important;\n}\n\n.lh-1 {\n  line-height: 1 !important;\n}\n\n.lh-sm {\n  line-height: 1.25 !important;\n}\n\n.lh-base {\n  line-height: 1.5 !important;\n}\n\n.lh-lg {\n  line-height: 2 !important;\n}\n\n.text-start {\n  text-align: left !important;\n}\n\n.text-end {\n  text-align: right !important;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n.text-decoration-none {\n  text-decoration: none !important;\n}\n\n.text-decoration-underline {\n  text-decoration: underline !important;\n}\n\n.text-decoration-line-through {\n  text-decoration: line-through !important;\n}\n\n.text-lowercase {\n  text-transform: lowercase !important;\n}\n\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n\n.text-wrap {\n  white-space: normal !important;\n}\n\n.text-nowrap {\n  white-space: nowrap !important;\n}\n\n/* rtl:begin:remove */\n.text-break {\n  word-wrap: break-word !important;\n  word-break: break-word !important;\n}\n\n/* rtl:end:remove */\n.text-primary {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-secondary {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-success {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-info {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-warning {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-danger {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-light {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-dark {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-black {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-white {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-body {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-muted {\n  --bs-text-opacity: 1;\n  color: var(--bs-secondary-color) !important;\n}\n\n.text-black-50 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 0, 0, 0.5) !important;\n}\n\n.text-white-50 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n\n.text-body-secondary {\n  --bs-text-opacity: 1;\n  color: var(--bs-secondary-color) !important;\n}\n\n.text-body-tertiary {\n  --bs-text-opacity: 1;\n  color: var(--bs-tertiary-color) !important;\n}\n\n.text-body-emphasis {\n  --bs-text-opacity: 1;\n  color: var(--bs-emphasis-color) !important;\n}\n\n.text-reset {\n  --bs-text-opacity: 1;\n  color: inherit !important;\n}\n\n.text-opacity-25 {\n  --bs-text-opacity: 0.25;\n}\n\n.text-opacity-50 {\n  --bs-text-opacity: 0.5;\n}\n\n.text-opacity-75 {\n  --bs-text-opacity: 0.75;\n}\n\n.text-opacity-100 {\n  --bs-text-opacity: 1;\n}\n\n.text-primary-emphasis {\n  color: var(--bs-primary-text-emphasis) !important;\n}\n\n.text-secondary-emphasis {\n  color: var(--bs-secondary-text-emphasis) !important;\n}\n\n.text-success-emphasis {\n  color: var(--bs-success-text-emphasis) !important;\n}\n\n.text-info-emphasis {\n  color: var(--bs-info-text-emphasis) !important;\n}\n\n.text-warning-emphasis {\n  color: var(--bs-warning-text-emphasis) !important;\n}\n\n.text-danger-emphasis {\n  color: var(--bs-danger-text-emphasis) !important;\n}\n\n.text-light-emphasis {\n  color: var(--bs-light-text-emphasis) !important;\n}\n\n.text-dark-emphasis {\n  color: var(--bs-dark-text-emphasis) !important;\n}\n\n.link-opacity-10 {\n  --bs-link-opacity: 0.1;\n}\n\n.link-opacity-10-hover:hover {\n  --bs-link-opacity: 0.1;\n}\n\n.link-opacity-25 {\n  --bs-link-opacity: 0.25;\n}\n\n.link-opacity-25-hover:hover {\n  --bs-link-opacity: 0.25;\n}\n\n.link-opacity-50 {\n  --bs-link-opacity: 0.5;\n}\n\n.link-opacity-50-hover:hover {\n  --bs-link-opacity: 0.5;\n}\n\n.link-opacity-75 {\n  --bs-link-opacity: 0.75;\n}\n\n.link-opacity-75-hover:hover {\n  --bs-link-opacity: 0.75;\n}\n\n.link-opacity-100 {\n  --bs-link-opacity: 1;\n}\n\n.link-opacity-100-hover:hover {\n  --bs-link-opacity: 1;\n}\n\n.link-offset-1 {\n  text-underline-offset: 0.125em !important;\n}\n\n.link-offset-1-hover:hover {\n  text-underline-offset: 0.125em !important;\n}\n\n.link-offset-2 {\n  text-underline-offset: 0.25em !important;\n}\n\n.link-offset-2-hover:hover {\n  text-underline-offset: 0.25em !important;\n}\n\n.link-offset-3 {\n  text-underline-offset: 0.375em !important;\n}\n\n.link-offset-3-hover:hover {\n  text-underline-offset: 0.375em !important;\n}\n\n.link-underline-primary {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-secondary {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-success {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-info {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-warning {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-danger {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-light {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-dark {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-underline-opacity-0 {\n  --bs-link-underline-opacity: 0;\n}\n\n.link-underline-opacity-0-hover:hover {\n  --bs-link-underline-opacity: 0;\n}\n\n.link-underline-opacity-10 {\n  --bs-link-underline-opacity: 0.1;\n}\n\n.link-underline-opacity-10-hover:hover {\n  --bs-link-underline-opacity: 0.1;\n}\n\n.link-underline-opacity-25 {\n  --bs-link-underline-opacity: 0.25;\n}\n\n.link-underline-opacity-25-hover:hover {\n  --bs-link-underline-opacity: 0.25;\n}\n\n.link-underline-opacity-50 {\n  --bs-link-underline-opacity: 0.5;\n}\n\n.link-underline-opacity-50-hover:hover {\n  --bs-link-underline-opacity: 0.5;\n}\n\n.link-underline-opacity-75 {\n  --bs-link-underline-opacity: 0.75;\n}\n\n.link-underline-opacity-75-hover:hover {\n  --bs-link-underline-opacity: 0.75;\n}\n\n.link-underline-opacity-100 {\n  --bs-link-underline-opacity: 1;\n}\n\n.link-underline-opacity-100-hover:hover {\n  --bs-link-underline-opacity: 1;\n}\n\n.bg-primary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-secondary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-success {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-info {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-warning {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-light {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-dark {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-black {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-white {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-transparent {\n  --bs-bg-opacity: 1;\n  background-color: transparent !important;\n}\n\n.bg-body-secondary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body-tertiary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-opacity-10 {\n  --bs-bg-opacity: 0.1;\n}\n\n.bg-opacity-25 {\n  --bs-bg-opacity: 0.25;\n}\n\n.bg-opacity-50 {\n  --bs-bg-opacity: 0.5;\n}\n\n.bg-opacity-75 {\n  --bs-bg-opacity: 0.75;\n}\n\n.bg-opacity-100 {\n  --bs-bg-opacity: 1;\n}\n\n.bg-primary-subtle {\n  background-color: var(--bs-primary-bg-subtle) !important;\n}\n\n.bg-secondary-subtle {\n  background-color: var(--bs-secondary-bg-subtle) !important;\n}\n\n.bg-success-subtle {\n  background-color: var(--bs-success-bg-subtle) !important;\n}\n\n.bg-info-subtle {\n  background-color: var(--bs-info-bg-subtle) !important;\n}\n\n.bg-warning-subtle {\n  background-color: var(--bs-warning-bg-subtle) !important;\n}\n\n.bg-danger-subtle {\n  background-color: var(--bs-danger-bg-subtle) !important;\n}\n\n.bg-light-subtle {\n  background-color: var(--bs-light-bg-subtle) !important;\n}\n\n.bg-dark-subtle {\n  background-color: var(--bs-dark-bg-subtle) !important;\n}\n\n.bg-gradient {\n  background-image: var(--bs-gradient) !important;\n}\n\n.user-select-all {\n  user-select: all !important;\n}\n\n.user-select-auto {\n  user-select: auto !important;\n}\n\n.user-select-none {\n  user-select: none !important;\n}\n\n.pe-none {\n  pointer-events: none !important;\n}\n\n.pe-auto {\n  pointer-events: auto !important;\n}\n\n.rounded {\n  border-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n\n.rounded-1 {\n  border-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-2 {\n  border-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-3 {\n  border-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-4 {\n  border-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-5 {\n  border-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-top {\n  border-top-left-radius: var(--bs-border-radius) !important;\n  border-top-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-top-0 {\n  border-top-left-radius: 0 !important;\n  border-top-right-radius: 0 !important;\n}\n\n.rounded-top-1 {\n  border-top-left-radius: var(--bs-border-radius-sm) !important;\n  border-top-right-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-top-2 {\n  border-top-left-radius: var(--bs-border-radius) !important;\n  border-top-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-top-3 {\n  border-top-left-radius: var(--bs-border-radius-lg) !important;\n  border-top-right-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-top-4 {\n  border-top-left-radius: var(--bs-border-radius-xl) !important;\n  border-top-right-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-top-5 {\n  border-top-left-radius: var(--bs-border-radius-xxl) !important;\n  border-top-right-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-top-circle {\n  border-top-left-radius: 50% !important;\n  border-top-right-radius: 50% !important;\n}\n\n.rounded-top-pill {\n  border-top-left-radius: var(--bs-border-radius-pill) !important;\n  border-top-right-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-end {\n  border-top-right-radius: var(--bs-border-radius) !important;\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-end-0 {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.rounded-end-1 {\n  border-top-right-radius: var(--bs-border-radius-sm) !important;\n  border-bottom-right-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-end-2 {\n  border-top-right-radius: var(--bs-border-radius) !important;\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-end-3 {\n  border-top-right-radius: var(--bs-border-radius-lg) !important;\n  border-bottom-right-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-end-4 {\n  border-top-right-radius: var(--bs-border-radius-xl) !important;\n  border-bottom-right-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-end-5 {\n  border-top-right-radius: var(--bs-border-radius-xxl) !important;\n  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-end-circle {\n  border-top-right-radius: 50% !important;\n  border-bottom-right-radius: 50% !important;\n}\n\n.rounded-end-pill {\n  border-top-right-radius: var(--bs-border-radius-pill) !important;\n  border-bottom-right-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-bottom-0 {\n  border-bottom-right-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n\n.rounded-bottom-1 {\n  border-bottom-right-radius: var(--bs-border-radius-sm) !important;\n  border-bottom-left-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-bottom-2 {\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-bottom-3 {\n  border-bottom-right-radius: var(--bs-border-radius-lg) !important;\n  border-bottom-left-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-bottom-4 {\n  border-bottom-right-radius: var(--bs-border-radius-xl) !important;\n  border-bottom-left-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-bottom-5 {\n  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;\n  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-bottom-circle {\n  border-bottom-right-radius: 50% !important;\n  border-bottom-left-radius: 50% !important;\n}\n\n.rounded-bottom-pill {\n  border-bottom-right-radius: var(--bs-border-radius-pill) !important;\n  border-bottom-left-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-start {\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n  border-top-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-start-0 {\n  border-bottom-left-radius: 0 !important;\n  border-top-left-radius: 0 !important;\n}\n\n.rounded-start-1 {\n  border-bottom-left-radius: var(--bs-border-radius-sm) !important;\n  border-top-left-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-start-2 {\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n  border-top-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-start-3 {\n  border-bottom-left-radius: var(--bs-border-radius-lg) !important;\n  border-top-left-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-start-4 {\n  border-bottom-left-radius: var(--bs-border-radius-xl) !important;\n  border-top-left-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-start-5 {\n  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;\n  border-top-left-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-start-circle {\n  border-bottom-left-radius: 50% !important;\n  border-top-left-radius: 50% !important;\n}\n\n.rounded-start-pill {\n  border-bottom-left-radius: var(--bs-border-radius-pill) !important;\n  border-top-left-radius: var(--bs-border-radius-pill) !important;\n}\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n\n.z-n1 {\n  z-index: -1 !important;\n}\n\n.z-0 {\n  z-index: 0 !important;\n}\n\n.z-1 {\n  z-index: 1 !important;\n}\n\n.z-2 {\n  z-index: 2 !important;\n}\n\n.z-3 {\n  z-index: 3 !important;\n}\n\n@media (min-width: 576px) {\n  .float-sm-start {\n    float: left !important;\n  }\n  .float-sm-end {\n    float: right !important;\n  }\n  .float-sm-none {\n    float: none !important;\n  }\n  .object-fit-sm-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-sm-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-sm-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-sm-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-sm-none {\n    object-fit: none !important;\n  }\n  .d-sm-inline {\n    display: inline !important;\n  }\n  .d-sm-inline-block {\n    display: inline-block !important;\n  }\n  .d-sm-block {\n    display: block !important;\n  }\n  .d-sm-grid {\n    display: grid !important;\n  }\n  .d-sm-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-sm-table {\n    display: table !important;\n  }\n  .d-sm-table-row {\n    display: table-row !important;\n  }\n  .d-sm-table-cell {\n    display: table-cell !important;\n  }\n  .d-sm-flex {\n    display: flex !important;\n  }\n  .d-sm-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-sm-none {\n    display: none !important;\n  }\n  .flex-sm-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-sm-row {\n    flex-direction: row !important;\n  }\n  .flex-sm-column {\n    flex-direction: column !important;\n  }\n  .flex-sm-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-sm-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-sm-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-sm-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-sm-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-sm-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-sm-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-sm-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-sm-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-sm-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-sm-center {\n    justify-content: center !important;\n  }\n  .justify-content-sm-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-sm-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-sm-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-sm-start {\n    align-items: flex-start !important;\n  }\n  .align-items-sm-end {\n    align-items: flex-end !important;\n  }\n  .align-items-sm-center {\n    align-items: center !important;\n  }\n  .align-items-sm-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-sm-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-sm-start {\n    align-content: flex-start !important;\n  }\n  .align-content-sm-end {\n    align-content: flex-end !important;\n  }\n  .align-content-sm-center {\n    align-content: center !important;\n  }\n  .align-content-sm-between {\n    align-content: space-between !important;\n  }\n  .align-content-sm-around {\n    align-content: space-around !important;\n  }\n  .align-content-sm-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-sm-auto {\n    align-self: auto !important;\n  }\n  .align-self-sm-start {\n    align-self: flex-start !important;\n  }\n  .align-self-sm-end {\n    align-self: flex-end !important;\n  }\n  .align-self-sm-center {\n    align-self: center !important;\n  }\n  .align-self-sm-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-sm-stretch {\n    align-self: stretch !important;\n  }\n  .order-sm-first {\n    order: -1 !important;\n  }\n  .order-sm-0 {\n    order: 0 !important;\n  }\n  .order-sm-1 {\n    order: 1 !important;\n  }\n  .order-sm-2 {\n    order: 2 !important;\n  }\n  .order-sm-3 {\n    order: 3 !important;\n  }\n  .order-sm-4 {\n    order: 4 !important;\n  }\n  .order-sm-5 {\n    order: 5 !important;\n  }\n  .order-sm-last {\n    order: 6 !important;\n  }\n  .m-sm-0 {\n    margin: 0 !important;\n  }\n  .m-sm-1 {\n    margin: 0.25rem !important;\n  }\n  .m-sm-2 {\n    margin: 0.5rem !important;\n  }\n  .m-sm-3 {\n    margin: 1rem !important;\n  }\n  .m-sm-4 {\n    margin: 1.5rem !important;\n  }\n  .m-sm-5 {\n    margin: 3rem !important;\n  }\n  .m-sm-auto {\n    margin: auto !important;\n  }\n  .mx-sm-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-sm-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-sm-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-sm-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-sm-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-sm-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-sm-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-sm-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-sm-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-sm-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-sm-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-sm-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-sm-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-sm-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-sm-0 {\n    margin-top: 0 !important;\n  }\n  .mt-sm-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-sm-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-sm-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-sm-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-sm-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-sm-auto {\n    margin-top: auto !important;\n  }\n  .me-sm-0 {\n    margin-right: 0 !important;\n  }\n  .me-sm-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-sm-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-sm-3 {\n    margin-right: 1rem !important;\n  }\n  .me-sm-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-sm-5 {\n    margin-right: 3rem !important;\n  }\n  .me-sm-auto {\n    margin-right: auto !important;\n  }\n  .mb-sm-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-sm-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-sm-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-sm-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-sm-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-sm-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-sm-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-sm-0 {\n    margin-left: 0 !important;\n  }\n  .ms-sm-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-sm-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-sm-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-sm-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-sm-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-sm-auto {\n    margin-left: auto !important;\n  }\n  .p-sm-0 {\n    padding: 0 !important;\n  }\n  .p-sm-1 {\n    padding: 0.25rem !important;\n  }\n  .p-sm-2 {\n    padding: 0.5rem !important;\n  }\n  .p-sm-3 {\n    padding: 1rem !important;\n  }\n  .p-sm-4 {\n    padding: 1.5rem !important;\n  }\n  .p-sm-5 {\n    padding: 3rem !important;\n  }\n  .px-sm-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-sm-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-sm-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-sm-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-sm-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-sm-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-sm-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-sm-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-sm-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-sm-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-sm-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-sm-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-sm-0 {\n    padding-top: 0 !important;\n  }\n  .pt-sm-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-sm-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-sm-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-sm-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-sm-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-sm-0 {\n    padding-right: 0 !important;\n  }\n  .pe-sm-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-sm-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-sm-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-sm-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-sm-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-sm-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-sm-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-sm-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-sm-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-sm-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-sm-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-sm-0 {\n    padding-left: 0 !important;\n  }\n  .ps-sm-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-sm-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-sm-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-sm-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-sm-5 {\n    padding-left: 3rem !important;\n  }\n  .gap-sm-0 {\n    gap: 0 !important;\n  }\n  .gap-sm-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-sm-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-sm-3 {\n    gap: 1rem !important;\n  }\n  .gap-sm-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-sm-5 {\n    gap: 3rem !important;\n  }\n  .row-gap-sm-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-sm-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-sm-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-sm-3 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-sm-4 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-sm-5 {\n    row-gap: 3rem !important;\n  }\n  .column-gap-sm-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-sm-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-sm-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-sm-3 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-sm-4 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-sm-5 {\n    column-gap: 3rem !important;\n  }\n  .text-sm-start {\n    text-align: left !important;\n  }\n  .text-sm-end {\n    text-align: right !important;\n  }\n  .text-sm-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 768px) {\n  .float-md-start {\n    float: left !important;\n  }\n  .float-md-end {\n    float: right !important;\n  }\n  .float-md-none {\n    float: none !important;\n  }\n  .object-fit-md-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-md-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-md-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-md-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-md-none {\n    object-fit: none !important;\n  }\n  .d-md-inline {\n    display: inline !important;\n  }\n  .d-md-inline-block {\n    display: inline-block !important;\n  }\n  .d-md-block {\n    display: block !important;\n  }\n  .d-md-grid {\n    display: grid !important;\n  }\n  .d-md-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-md-table {\n    display: table !important;\n  }\n  .d-md-table-row {\n    display: table-row !important;\n  }\n  .d-md-table-cell {\n    display: table-cell !important;\n  }\n  .d-md-flex {\n    display: flex !important;\n  }\n  .d-md-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-md-none {\n    display: none !important;\n  }\n  .flex-md-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-md-row {\n    flex-direction: row !important;\n  }\n  .flex-md-column {\n    flex-direction: column !important;\n  }\n  .flex-md-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-md-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-md-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-md-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-md-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-md-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-md-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-md-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-md-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-md-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-md-center {\n    justify-content: center !important;\n  }\n  .justify-content-md-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-md-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-md-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-md-start {\n    align-items: flex-start !important;\n  }\n  .align-items-md-end {\n    align-items: flex-end !important;\n  }\n  .align-items-md-center {\n    align-items: center !important;\n  }\n  .align-items-md-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-md-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-md-start {\n    align-content: flex-start !important;\n  }\n  .align-content-md-end {\n    align-content: flex-end !important;\n  }\n  .align-content-md-center {\n    align-content: center !important;\n  }\n  .align-content-md-between {\n    align-content: space-between !important;\n  }\n  .align-content-md-around {\n    align-content: space-around !important;\n  }\n  .align-content-md-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-md-auto {\n    align-self: auto !important;\n  }\n  .align-self-md-start {\n    align-self: flex-start !important;\n  }\n  .align-self-md-end {\n    align-self: flex-end !important;\n  }\n  .align-self-md-center {\n    align-self: center !important;\n  }\n  .align-self-md-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-md-stretch {\n    align-self: stretch !important;\n  }\n  .order-md-first {\n    order: -1 !important;\n  }\n  .order-md-0 {\n    order: 0 !important;\n  }\n  .order-md-1 {\n    order: 1 !important;\n  }\n  .order-md-2 {\n    order: 2 !important;\n  }\n  .order-md-3 {\n    order: 3 !important;\n  }\n  .order-md-4 {\n    order: 4 !important;\n  }\n  .order-md-5 {\n    order: 5 !important;\n  }\n  .order-md-last {\n    order: 6 !important;\n  }\n  .m-md-0 {\n    margin: 0 !important;\n  }\n  .m-md-1 {\n    margin: 0.25rem !important;\n  }\n  .m-md-2 {\n    margin: 0.5rem !important;\n  }\n  .m-md-3 {\n    margin: 1rem !important;\n  }\n  .m-md-4 {\n    margin: 1.5rem !important;\n  }\n  .m-md-5 {\n    margin: 3rem !important;\n  }\n  .m-md-auto {\n    margin: auto !important;\n  }\n  .mx-md-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-md-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-md-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-md-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-md-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-md-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-md-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-md-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-md-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-md-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-md-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-md-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-md-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-md-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-md-0 {\n    margin-top: 0 !important;\n  }\n  .mt-md-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-md-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-md-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-md-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-md-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-md-auto {\n    margin-top: auto !important;\n  }\n  .me-md-0 {\n    margin-right: 0 !important;\n  }\n  .me-md-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-md-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-md-3 {\n    margin-right: 1rem !important;\n  }\n  .me-md-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-md-5 {\n    margin-right: 3rem !important;\n  }\n  .me-md-auto {\n    margin-right: auto !important;\n  }\n  .mb-md-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-md-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-md-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-md-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-md-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-md-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-md-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-md-0 {\n    margin-left: 0 !important;\n  }\n  .ms-md-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-md-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-md-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-md-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-md-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-md-auto {\n    margin-left: auto !important;\n  }\n  .p-md-0 {\n    padding: 0 !important;\n  }\n  .p-md-1 {\n    padding: 0.25rem !important;\n  }\n  .p-md-2 {\n    padding: 0.5rem !important;\n  }\n  .p-md-3 {\n    padding: 1rem !important;\n  }\n  .p-md-4 {\n    padding: 1.5rem !important;\n  }\n  .p-md-5 {\n    padding: 3rem !important;\n  }\n  .px-md-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-md-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-md-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-md-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-md-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-md-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-md-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-md-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-md-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-md-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-md-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-md-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-md-0 {\n    padding-top: 0 !important;\n  }\n  .pt-md-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-md-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-md-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-md-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-md-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-md-0 {\n    padding-right: 0 !important;\n  }\n  .pe-md-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-md-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-md-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-md-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-md-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-md-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-md-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-md-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-md-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-md-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-md-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-md-0 {\n    padding-left: 0 !important;\n  }\n  .ps-md-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-md-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-md-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-md-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-md-5 {\n    padding-left: 3rem !important;\n  }\n  .gap-md-0 {\n    gap: 0 !important;\n  }\n  .gap-md-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-md-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-md-3 {\n    gap: 1rem !important;\n  }\n  .gap-md-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-md-5 {\n    gap: 3rem !important;\n  }\n  .row-gap-md-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-md-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-md-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-md-3 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-md-4 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-md-5 {\n    row-gap: 3rem !important;\n  }\n  .column-gap-md-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-md-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-md-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-md-3 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-md-4 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-md-5 {\n    column-gap: 3rem !important;\n  }\n  .text-md-start {\n    text-align: left !important;\n  }\n  .text-md-end {\n    text-align: right !important;\n  }\n  .text-md-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 992px) {\n  .float-lg-start {\n    float: left !important;\n  }\n  .float-lg-end {\n    float: right !important;\n  }\n  .float-lg-none {\n    float: none !important;\n  }\n  .object-fit-lg-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-lg-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-lg-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-lg-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-lg-none {\n    object-fit: none !important;\n  }\n  .d-lg-inline {\n    display: inline !important;\n  }\n  .d-lg-inline-block {\n    display: inline-block !important;\n  }\n  .d-lg-block {\n    display: block !important;\n  }\n  .d-lg-grid {\n    display: grid !important;\n  }\n  .d-lg-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-lg-table {\n    display: table !important;\n  }\n  .d-lg-table-row {\n    display: table-row !important;\n  }\n  .d-lg-table-cell {\n    display: table-cell !important;\n  }\n  .d-lg-flex {\n    display: flex !important;\n  }\n  .d-lg-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-lg-none {\n    display: none !important;\n  }\n  .flex-lg-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-lg-row {\n    flex-direction: row !important;\n  }\n  .flex-lg-column {\n    flex-direction: column !important;\n  }\n  .flex-lg-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-lg-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-lg-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-lg-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-lg-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-lg-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-lg-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-lg-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-lg-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-lg-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-lg-center {\n    justify-content: center !important;\n  }\n  .justify-content-lg-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-lg-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-lg-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-lg-start {\n    align-items: flex-start !important;\n  }\n  .align-items-lg-end {\n    align-items: flex-end !important;\n  }\n  .align-items-lg-center {\n    align-items: center !important;\n  }\n  .align-items-lg-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-lg-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-lg-start {\n    align-content: flex-start !important;\n  }\n  .align-content-lg-end {\n    align-content: flex-end !important;\n  }\n  .align-content-lg-center {\n    align-content: center !important;\n  }\n  .align-content-lg-between {\n    align-content: space-between !important;\n  }\n  .align-content-lg-around {\n    align-content: space-around !important;\n  }\n  .align-content-lg-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-lg-auto {\n    align-self: auto !important;\n  }\n  .align-self-lg-start {\n    align-self: flex-start !important;\n  }\n  .align-self-lg-end {\n    align-self: flex-end !important;\n  }\n  .align-self-lg-center {\n    align-self: center !important;\n  }\n  .align-self-lg-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-lg-stretch {\n    align-self: stretch !important;\n  }\n  .order-lg-first {\n    order: -1 !important;\n  }\n  .order-lg-0 {\n    order: 0 !important;\n  }\n  .order-lg-1 {\n    order: 1 !important;\n  }\n  .order-lg-2 {\n    order: 2 !important;\n  }\n  .order-lg-3 {\n    order: 3 !important;\n  }\n  .order-lg-4 {\n    order: 4 !important;\n  }\n  .order-lg-5 {\n    order: 5 !important;\n  }\n  .order-lg-last {\n    order: 6 !important;\n  }\n  .m-lg-0 {\n    margin: 0 !important;\n  }\n  .m-lg-1 {\n    margin: 0.25rem !important;\n  }\n  .m-lg-2 {\n    margin: 0.5rem !important;\n  }\n  .m-lg-3 {\n    margin: 1rem !important;\n  }\n  .m-lg-4 {\n    margin: 1.5rem !important;\n  }\n  .m-lg-5 {\n    margin: 3rem !important;\n  }\n  .m-lg-auto {\n    margin: auto !important;\n  }\n  .mx-lg-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-lg-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-lg-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-lg-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-lg-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-lg-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-lg-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-lg-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-lg-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-lg-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-lg-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-lg-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-lg-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-lg-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-lg-0 {\n    margin-top: 0 !important;\n  }\n  .mt-lg-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-lg-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-lg-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-lg-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-lg-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-lg-auto {\n    margin-top: auto !important;\n  }\n  .me-lg-0 {\n    margin-right: 0 !important;\n  }\n  .me-lg-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-lg-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-lg-3 {\n    margin-right: 1rem !important;\n  }\n  .me-lg-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-lg-5 {\n    margin-right: 3rem !important;\n  }\n  .me-lg-auto {\n    margin-right: auto !important;\n  }\n  .mb-lg-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-lg-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-lg-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-lg-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-lg-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-lg-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-lg-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-lg-0 {\n    margin-left: 0 !important;\n  }\n  .ms-lg-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-lg-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-lg-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-lg-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-lg-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-lg-auto {\n    margin-left: auto !important;\n  }\n  .p-lg-0 {\n    padding: 0 !important;\n  }\n  .p-lg-1 {\n    padding: 0.25rem !important;\n  }\n  .p-lg-2 {\n    padding: 0.5rem !important;\n  }\n  .p-lg-3 {\n    padding: 1rem !important;\n  }\n  .p-lg-4 {\n    padding: 1.5rem !important;\n  }\n  .p-lg-5 {\n    padding: 3rem !important;\n  }\n  .px-lg-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-lg-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-lg-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-lg-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-lg-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-lg-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-lg-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-lg-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-lg-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-lg-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-lg-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-lg-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-lg-0 {\n    padding-top: 0 !important;\n  }\n  .pt-lg-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-lg-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-lg-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-lg-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-lg-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-lg-0 {\n    padding-right: 0 !important;\n  }\n  .pe-lg-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-lg-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-lg-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-lg-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-lg-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-lg-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-lg-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-lg-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-lg-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-lg-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-lg-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-lg-0 {\n    padding-left: 0 !important;\n  }\n  .ps-lg-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-lg-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-lg-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-lg-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-lg-5 {\n    padding-left: 3rem !important;\n  }\n  .gap-lg-0 {\n    gap: 0 !important;\n  }\n  .gap-lg-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-lg-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-lg-3 {\n    gap: 1rem !important;\n  }\n  .gap-lg-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-lg-5 {\n    gap: 3rem !important;\n  }\n  .row-gap-lg-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-lg-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-lg-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-lg-3 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-lg-4 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-lg-5 {\n    row-gap: 3rem !important;\n  }\n  .column-gap-lg-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-lg-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-lg-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-lg-3 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-lg-4 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-lg-5 {\n    column-gap: 3rem !important;\n  }\n  .text-lg-start {\n    text-align: left !important;\n  }\n  .text-lg-end {\n    text-align: right !important;\n  }\n  .text-lg-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1200px) {\n  .float-xl-start {\n    float: left !important;\n  }\n  .float-xl-end {\n    float: right !important;\n  }\n  .float-xl-none {\n    float: none !important;\n  }\n  .object-fit-xl-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-xl-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-xl-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-xl-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-xl-none {\n    object-fit: none !important;\n  }\n  .d-xl-inline {\n    display: inline !important;\n  }\n  .d-xl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xl-block {\n    display: block !important;\n  }\n  .d-xl-grid {\n    display: grid !important;\n  }\n  .d-xl-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-xl-table {\n    display: table !important;\n  }\n  .d-xl-table-row {\n    display: table-row !important;\n  }\n  .d-xl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xl-flex {\n    display: flex !important;\n  }\n  .d-xl-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-xl-none {\n    display: none !important;\n  }\n  .flex-xl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xl-row {\n    flex-direction: row !important;\n  }\n  .flex-xl-column {\n    flex-direction: column !important;\n  }\n  .flex-xl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-xl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-xl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xl-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-xl-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-xl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xl-center {\n    align-items: center !important;\n  }\n  .align-items-xl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xl-center {\n    align-content: center !important;\n  }\n  .align-content-xl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xl-center {\n    align-self: center !important;\n  }\n  .align-self-xl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xl-stretch {\n    align-self: stretch !important;\n  }\n  .order-xl-first {\n    order: -1 !important;\n  }\n  .order-xl-0 {\n    order: 0 !important;\n  }\n  .order-xl-1 {\n    order: 1 !important;\n  }\n  .order-xl-2 {\n    order: 2 !important;\n  }\n  .order-xl-3 {\n    order: 3 !important;\n  }\n  .order-xl-4 {\n    order: 4 !important;\n  }\n  .order-xl-5 {\n    order: 5 !important;\n  }\n  .order-xl-last {\n    order: 6 !important;\n  }\n  .m-xl-0 {\n    margin: 0 !important;\n  }\n  .m-xl-1 {\n    margin: 0.25rem !important;\n  }\n  .m-xl-2 {\n    margin: 0.5rem !important;\n  }\n  .m-xl-3 {\n    margin: 1rem !important;\n  }\n  .m-xl-4 {\n    margin: 1.5rem !important;\n  }\n  .m-xl-5 {\n    margin: 3rem !important;\n  }\n  .m-xl-auto {\n    margin: auto !important;\n  }\n  .mx-xl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-xl-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-xl-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-xl-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-xl-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-xl-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-xl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-xl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-xl-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-xl-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-xl-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-xl-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-xl-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-xl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-xl-0 {\n    margin-top: 0 !important;\n  }\n  .mt-xl-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-xl-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-xl-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-xl-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-xl-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-xl-auto {\n    margin-top: auto !important;\n  }\n  .me-xl-0 {\n    margin-right: 0 !important;\n  }\n  .me-xl-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-xl-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-xl-3 {\n    margin-right: 1rem !important;\n  }\n  .me-xl-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-xl-5 {\n    margin-right: 3rem !important;\n  }\n  .me-xl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xl-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-xl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-xl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-xl-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-xl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-xl-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-xl-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-xl-0 {\n    margin-left: 0 !important;\n  }\n  .ms-xl-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-xl-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-xl-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-xl-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-xl-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-xl-auto {\n    margin-left: auto !important;\n  }\n  .p-xl-0 {\n    padding: 0 !important;\n  }\n  .p-xl-1 {\n    padding: 0.25rem !important;\n  }\n  .p-xl-2 {\n    padding: 0.5rem !important;\n  }\n  .p-xl-3 {\n    padding: 1rem !important;\n  }\n  .p-xl-4 {\n    padding: 1.5rem !important;\n  }\n  .p-xl-5 {\n    padding: 3rem !important;\n  }\n  .px-xl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-xl-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-xl-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-xl-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-xl-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-xl-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-xl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-xl-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-xl-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-xl-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-xl-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-xl-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-xl-0 {\n    padding-top: 0 !important;\n  }\n  .pt-xl-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-xl-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-xl-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-xl-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-xl-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-xl-0 {\n    padding-right: 0 !important;\n  }\n  .pe-xl-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-xl-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-xl-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-xl-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-xl-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-xl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-xl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-xl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-xl-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-xl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-xl-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-xl-0 {\n    padding-left: 0 !important;\n  }\n  .ps-xl-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-xl-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-xl-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-xl-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-xl-5 {\n    padding-left: 3rem !important;\n  }\n  .gap-xl-0 {\n    gap: 0 !important;\n  }\n  .gap-xl-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-xl-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-xl-3 {\n    gap: 1rem !important;\n  }\n  .gap-xl-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-xl-5 {\n    gap: 3rem !important;\n  }\n  .row-gap-xl-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-xl-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-xl-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-xl-3 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-xl-4 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-xl-5 {\n    row-gap: 3rem !important;\n  }\n  .column-gap-xl-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-xl-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-xl-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-xl-3 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-xl-4 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-xl-5 {\n    column-gap: 3rem !important;\n  }\n  .text-xl-start {\n    text-align: left !important;\n  }\n  .text-xl-end {\n    text-align: right !important;\n  }\n  .text-xl-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1400px) {\n  .float-xxl-start {\n    float: left !important;\n  }\n  .float-xxl-end {\n    float: right !important;\n  }\n  .float-xxl-none {\n    float: none !important;\n  }\n  .object-fit-xxl-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-xxl-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-xxl-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-xxl-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-xxl-none {\n    object-fit: none !important;\n  }\n  .d-xxl-inline {\n    display: inline !important;\n  }\n  .d-xxl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xxl-block {\n    display: block !important;\n  }\n  .d-xxl-grid {\n    display: grid !important;\n  }\n  .d-xxl-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-xxl-table {\n    display: table !important;\n  }\n  .d-xxl-table-row {\n    display: table-row !important;\n  }\n  .d-xxl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xxl-flex {\n    display: flex !important;\n  }\n  .d-xxl-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-xxl-none {\n    display: none !important;\n  }\n  .flex-xxl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xxl-row {\n    flex-direction: row !important;\n  }\n  .flex-xxl-column {\n    flex-direction: column !important;\n  }\n  .flex-xxl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xxl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xxl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xxl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xxl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xxl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-xxl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xxl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xxl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-xxl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xxl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xxl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xxl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xxl-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-xxl-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-xxl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xxl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xxl-center {\n    align-items: center !important;\n  }\n  .align-items-xxl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xxl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xxl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xxl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xxl-center {\n    align-content: center !important;\n  }\n  .align-content-xxl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xxl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xxl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xxl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xxl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xxl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xxl-center {\n    align-self: center !important;\n  }\n  .align-self-xxl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xxl-stretch {\n    align-self: stretch !important;\n  }\n  .order-xxl-first {\n    order: -1 !important;\n  }\n  .order-xxl-0 {\n    order: 0 !important;\n  }\n  .order-xxl-1 {\n    order: 1 !important;\n  }\n  .order-xxl-2 {\n    order: 2 !important;\n  }\n  .order-xxl-3 {\n    order: 3 !important;\n  }\n  .order-xxl-4 {\n    order: 4 !important;\n  }\n  .order-xxl-5 {\n    order: 5 !important;\n  }\n  .order-xxl-last {\n    order: 6 !important;\n  }\n  .m-xxl-0 {\n    margin: 0 !important;\n  }\n  .m-xxl-1 {\n    margin: 0.25rem !important;\n  }\n  .m-xxl-2 {\n    margin: 0.5rem !important;\n  }\n  .m-xxl-3 {\n    margin: 1rem !important;\n  }\n  .m-xxl-4 {\n    margin: 1.5rem !important;\n  }\n  .m-xxl-5 {\n    margin: 3rem !important;\n  }\n  .m-xxl-auto {\n    margin: auto !important;\n  }\n  .mx-xxl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-xxl-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-xxl-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-xxl-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-xxl-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-xxl-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-xxl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-xxl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-xxl-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-xxl-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-xxl-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-xxl-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-xxl-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-xxl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-xxl-0 {\n    margin-top: 0 !important;\n  }\n  .mt-xxl-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-xxl-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-xxl-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-xxl-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-xxl-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-xxl-auto {\n    margin-top: auto !important;\n  }\n  .me-xxl-0 {\n    margin-right: 0 !important;\n  }\n  .me-xxl-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-xxl-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-xxl-3 {\n    margin-right: 1rem !important;\n  }\n  .me-xxl-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-xxl-5 {\n    margin-right: 3rem !important;\n  }\n  .me-xxl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xxl-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-xxl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-xxl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-xxl-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-xxl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-xxl-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-xxl-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-xxl-0 {\n    margin-left: 0 !important;\n  }\n  .ms-xxl-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-xxl-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-xxl-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-xxl-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-xxl-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-xxl-auto {\n    margin-left: auto !important;\n  }\n  .p-xxl-0 {\n    padding: 0 !important;\n  }\n  .p-xxl-1 {\n    padding: 0.25rem !important;\n  }\n  .p-xxl-2 {\n    padding: 0.5rem !important;\n  }\n  .p-xxl-3 {\n    padding: 1rem !important;\n  }\n  .p-xxl-4 {\n    padding: 1.5rem !important;\n  }\n  .p-xxl-5 {\n    padding: 3rem !important;\n  }\n  .px-xxl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-xxl-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-xxl-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-xxl-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-xxl-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-xxl-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-xxl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-xxl-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-xxl-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-xxl-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-xxl-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-xxl-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-xxl-0 {\n    padding-top: 0 !important;\n  }\n  .pt-xxl-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-xxl-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-xxl-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-xxl-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-xxl-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-xxl-0 {\n    padding-right: 0 !important;\n  }\n  .pe-xxl-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-xxl-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-xxl-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-xxl-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-xxl-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-xxl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-xxl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-xxl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-xxl-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-xxl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-xxl-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-xxl-0 {\n    padding-left: 0 !important;\n  }\n  .ps-xxl-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-xxl-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-xxl-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-xxl-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-xxl-5 {\n    padding-left: 3rem !important;\n  }\n  .gap-xxl-0 {\n    gap: 0 !important;\n  }\n  .gap-xxl-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-xxl-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-xxl-3 {\n    gap: 1rem !important;\n  }\n  .gap-xxl-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-xxl-5 {\n    gap: 3rem !important;\n  }\n  .row-gap-xxl-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-xxl-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-xxl-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-xxl-3 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-xxl-4 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-xxl-5 {\n    row-gap: 3rem !important;\n  }\n  .column-gap-xxl-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-xxl-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-xxl-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-xxl-3 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-xxl-4 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-xxl-5 {\n    column-gap: 3rem !important;\n  }\n  .text-xxl-start {\n    text-align: left !important;\n  }\n  .text-xxl-end {\n    text-align: right !important;\n  }\n  .text-xxl-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1200px) {\n  .fs-1 {\n    font-size: 2.5rem !important;\n  }\n  .fs-2 {\n    font-size: 2rem !important;\n  }\n  .fs-3 {\n    font-size: 1.75rem !important;\n  }\n  .fs-4 {\n    font-size: 1.5rem !important;\n  }\n}\n@media print {\n  .d-print-inline {\n    display: inline !important;\n  }\n  .d-print-inline-block {\n    display: inline-block !important;\n  }\n  .d-print-block {\n    display: block !important;\n  }\n  .d-print-grid {\n    display: grid !important;\n  }\n  .d-print-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-print-table {\n    display: table !important;\n  }\n  .d-print-table-row {\n    display: table-row !important;\n  }\n  .d-print-table-cell {\n    display: table-cell !important;\n  }\n  .d-print-flex {\n    display: flex !important;\n  }\n  .d-print-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-print-none {\n    display: none !important;\n  }\n}\n/*! -----------------------------------------------------------------------------------\n\n    Template Name: Cuba Admin\n    Template URI: http://admin.pixelstrap.com/cuba/theme\n    Description: This is Admin theme\n    Author: Pixelstrap\n    Author URI: https://themeforest.net/user/pixelstrap\n\n-----------------------------------------------------------------------------------\n\n\n */\n:root {\n  --theme-default: #7366ff;\n  --theme-secondary: #f73164;\n  --light-background: rgba(242, 243, 247, 0.7);\n  --body-font-color: #2f2f3b;\n  --chart-border: #ecf3fa;\n  --recent-chart-bg: #fcfcfd;\n  --light-bg: #f6f7f9;\n  --white: #fff;\n  --light2: #f5f6f9;\n  --sidebar-border: rgba(0, 0, 0, 0.1);\n  --chart-text-color: rgba(82, 82, 108, 0.8);\n  --recent-dashed-border: rgba(82, 82, 108, 0.3);\n  --chart-dashed-border: rgba(82, 82, 108, 0.2);\n  --chart-progress-light: rgba(82, 82, 108, 0.1);\n  --recent-box-bg: #f2f4f7;\n  --recent-border: rgba(97, 101, 122, 0.25);\n  --course-light-btn: #f2f3f7;\n  --course-bg: #f7f7f7;\n  --balance-profie-bg: #e0dfef;\n  --view-grid-bg: #ecf3fa80;\n  --view-border-marker: #cfcdfc;\n  --fc-button-bg-color: var(--theme-default);\n  --fc-button-active-bg-color: var(--theme-default);\n  --fc-button-active-border-color: var(--theme-default);\n  --fc-button-border-color: var(--theme-default);\n  --fc-button-hover-bg-color: var(--theme-default);\n  --fc-button-hover-border-color: var(--theme-default);\n}\n\nbody[class=dark-only],\nbody.dark-only {\n  --light-background: rgba(31, 32, 40, 0.65);\n  --recent-chart-bg: #262932;\n  --light-bg: #1d1e26;\n  --white: #262932;\n  --sidebar-border: rgba(255, 255, 255, 0.1);\n  --light2: #1d1e26;\n  --chart-border: #374558;\n  --recent-box-bg: #1d1e26;\n  --recent-border: #374558;\n  --body-font-color: rgba(255, 255, 255, 0.6);\n  --course-light-btn: var(--light-bg);\n  --view-grid-bg: var(--light-bg);\n  --view-border-marker: #2c2c45d4;\n  -semi-dark: #1d1e26;\n}\n\n/**=====================\n     Reset css start\n==========================**/\n.font-roboto {\n  font-family: Roboto, sans-serif;\n}\n\n.f-light {\n  color: rgba(82, 82, 108, 0.8);\n}\n\nsvg.f-light {\n  fill: #52526c;\n  opacity: 0.8;\n}\n\n.light-card {\n  background-color: var(--light-background);\n}\n\n.light-background {\n  background-color: var(--light-bg);\n}\n\n.icon-arrow-down.icon-rotate,\n.icon-arrow-up.icon-rotate {\n  transform: rotate(-45deg);\n  display: inline-block;\n}\n\n/*====== Padding css starts ======*/\n.p-0 {\n  padding: 0px;\n}\n\n.p-5 {\n  padding: 5px;\n}\n\n.p-10 {\n  padding: 10px;\n}\n\n.p-15 {\n  padding: 15px;\n}\n\n.p-20 {\n  padding: 20px;\n}\n\n.p-25 {\n  padding: 25px;\n}\n\n.p-30 {\n  padding: 30px;\n}\n\n.p-35 {\n  padding: 35px;\n}\n\n.p-40 {\n  padding: 40px;\n}\n\n.p-45 {\n  padding: 45px;\n}\n\n.p-50 {\n  padding: 50px;\n}\n\n/*====== Padding css ends ======*/\n/*====== Padding-left css starts ======*/\n.p-l-0 {\n  padding-left: 0px;\n}\n\n.p-l-5 {\n  padding-left: 5px;\n}\n\n.p-l-10 {\n  padding-left: 10px;\n}\n\n.p-l-15 {\n  padding-left: 15px;\n}\n\n.p-l-20 {\n  padding-left: 20px;\n}\n\n.p-l-25 {\n  padding-left: 25px;\n}\n\n.p-l-30 {\n  padding-left: 30px;\n}\n\n.p-l-35 {\n  padding-left: 35px;\n}\n\n.p-l-40 {\n  padding-left: 40px;\n}\n\n.p-l-45 {\n  padding-left: 45px;\n}\n\n.p-l-50 {\n  padding-left: 50px;\n}\n\n/*====== Padding-left css ends ======*/\n/*====== Padding-top css starts ======*/\n.p-t-0 {\n  padding-top: 0px !important;\n}\n\n.p-t-5 {\n  padding-top: 5px !important;\n}\n\n.p-t-10 {\n  padding-top: 10px !important;\n}\n\n.p-t-15 {\n  padding-top: 15px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-25 {\n  padding-top: 25px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-35 {\n  padding-top: 35px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-45 {\n  padding-top: 45px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n/*====== Padding-top css ends ======*/\n/*====== Padding-bottom css starts ======*/\n.p-b-0 {\n  padding-bottom: 0px !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-15 {\n  padding-bottom: 15px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-35 {\n  padding-bottom: 35px !important;\n}\n\n.p-b-40 {\n  padding-bottom: 40px !important;\n}\n\n.p-b-45 {\n  padding-bottom: 45px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n/*====== Padding-bottom css ends ======*/\n/*====== Padding-right css starts ======*/\n.p-r-0 {\n  padding-right: 0px;\n}\n\n.p-r-5 {\n  padding-right: 5px;\n}\n\n.p-r-10 {\n  padding-right: 10px;\n}\n\n.p-r-15 {\n  padding-right: 15px;\n}\n\n.p-r-20 {\n  padding-right: 20px;\n}\n\n.p-r-25 {\n  padding-right: 25px;\n}\n\n.p-r-30 {\n  padding-right: 30px;\n}\n\n.p-r-35 {\n  padding-right: 35px;\n}\n\n.p-r-40 {\n  padding-right: 40px;\n}\n\n.p-r-45 {\n  padding-right: 45px;\n}\n\n.p-r-50 {\n  padding-right: 50px;\n}\n\n/*====== Padding-right css ends ======*/\n/*====== Margin css starts ======*/\n.m-0 {\n  margin: 0px !important;\n}\n\n.m-5 {\n  margin: 5px !important;\n}\n\n.m-10 {\n  margin: 10px !important;\n}\n\n.m-15 {\n  margin: 15px !important;\n}\n\n.m-20 {\n  margin: 20px !important;\n}\n\n.m-25 {\n  margin: 25px !important;\n}\n\n.m-30 {\n  margin: 30px !important;\n}\n\n.m-35 {\n  margin: 35px !important;\n}\n\n.m-40 {\n  margin: 40px !important;\n}\n\n.m-45 {\n  margin: 45px !important;\n}\n\n.m-50 {\n  margin: 50px !important;\n}\n\n/*====== Margin css ends ======*/\n/*====== Margin-top css starts ======*/\n.m-t-0 {\n  margin-top: 0px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-25 {\n  margin-top: 25px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-35 {\n  margin-top: 35px !important;\n}\n\n.m-t-40 {\n  margin-top: 40px !important;\n}\n\n.m-t-45 {\n  margin-top: 45px !important;\n}\n\n.m-t-50 {\n  margin-top: 50px !important;\n}\n\n/*====== Margin-top css ends ======*/\n/*====== Margin-Bottom css starts ======*/\n.m-b-0 {\n  margin-bottom: 0px !important;\n}\n\n.m-b-5 {\n  margin-bottom: 5px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-15 {\n  margin-bottom: 15px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-25 {\n  margin-bottom: 25px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-35 {\n  margin-bottom: 35px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-b-45 {\n  margin-bottom: 45px !important;\n}\n\n.m-b-50 {\n  margin-bottom: 50px !important;\n}\n\n/*====== Margin-Bottom css ends ======*/\n/*====== Margin-left css starts ======*/\n.m-l-0 {\n  margin-left: 0px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-15 {\n  margin-left: 15px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-25 {\n  margin-left: 25px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-l-45 {\n  margin-left: 45px !important;\n}\n\n.m-l-50 {\n  margin-left: 50px !important;\n}\n\n/*====== Margin-left css ends ======*/\n/*====== Margin-right css starts ======*/\n.m-r-0 {\n  margin-right: 0px;\n}\n\n.m-r-5 {\n  margin-right: 5px;\n}\n\n.m-r-10 {\n  margin-right: 10px;\n}\n\n.m-r-15 {\n  margin-right: 15px;\n}\n\n.m-r-20 {\n  margin-right: 20px;\n}\n\n.m-r-25 {\n  margin-right: 25px;\n}\n\n.m-r-30 {\n  margin-right: 30px;\n}\n\n.m-r-35 {\n  margin-right: 35px;\n}\n\n.m-r-40 {\n  margin-right: 40px;\n}\n\n.m-r-45 {\n  margin-right: 45px;\n}\n\n.m-r-50 {\n  margin-right: 50px;\n}\n\n/*====== Margin-right css ends ======*/\n/*====== Border-radius css starts ======*/\n.b-r-0 {\n  border-radius: 0px !important;\n}\n\n.b-r-1 {\n  border-radius: 1px !important;\n}\n\n.b-r-2 {\n  border-radius: 2px !important;\n}\n\n.b-r-3 {\n  border-radius: 3px !important;\n}\n\n.b-r-4 {\n  border-radius: 4px !important;\n}\n\n.b-r-5 {\n  border-radius: 5px !important;\n}\n\n.b-r-6 {\n  border-radius: 6px !important;\n}\n\n.b-r-7 {\n  border-radius: 7px !important;\n}\n\n.b-r-8 {\n  border-radius: 8px !important;\n}\n\n.b-r-9 {\n  border-radius: 9px !important;\n}\n\n.b-r-10 {\n  border-radius: 10px !important;\n}\n\n/*====== Border-radius css ends ======*/\n/*====== Font-size css starts ======*/\n.f-12 {\n  font-size: 12px !important;\n}\n\n.f-14 {\n  font-size: 14px !important;\n}\n\n.f-16 {\n  font-size: 16px !important;\n}\n\n.f-18 {\n  font-size: 18px !important;\n}\n\n.f-20 {\n  font-size: 20px !important;\n}\n\n.f-22 {\n  font-size: 22px !important;\n}\n\n.f-24 {\n  font-size: 24px !important;\n}\n\n.f-26 {\n  font-size: 26px !important;\n}\n\n.f-28 {\n  font-size: 28px !important;\n}\n\n.f-30 {\n  font-size: 30px !important;\n}\n\n.f-32 {\n  font-size: 32px !important;\n}\n\n.f-34 {\n  font-size: 34px !important;\n}\n\n.f-36 {\n  font-size: 36px !important;\n}\n\n.f-38 {\n  font-size: 38px !important;\n}\n\n.f-40 {\n  font-size: 40px !important;\n}\n\n.f-42 {\n  font-size: 42px !important;\n}\n\n.f-44 {\n  font-size: 44px !important;\n}\n\n.f-46 {\n  font-size: 46px !important;\n}\n\n.f-48 {\n  font-size: 48px !important;\n}\n\n.f-50 {\n  font-size: 50px !important;\n}\n\n.f-52 {\n  font-size: 52px !important;\n}\n\n.f-54 {\n  font-size: 54px !important;\n}\n\n.f-56 {\n  font-size: 56px !important;\n}\n\n.f-58 {\n  font-size: 58px !important;\n}\n\n.f-60 {\n  font-size: 60px !important;\n}\n\n.f-62 {\n  font-size: 62px !important;\n}\n\n.f-64 {\n  font-size: 64px !important;\n}\n\n.f-66 {\n  font-size: 66px !important;\n}\n\n.f-68 {\n  font-size: 68px !important;\n}\n\n.f-70 {\n  font-size: 70px !important;\n}\n\n.f-72 {\n  font-size: 72px !important;\n}\n\n.f-74 {\n  font-size: 74px !important;\n}\n\n.f-76 {\n  font-size: 76px !important;\n}\n\n.f-78 {\n  font-size: 78px !important;\n}\n\n.f-80 {\n  font-size: 80px !important;\n}\n\n.f-82 {\n  font-size: 82px !important;\n}\n\n.f-84 {\n  font-size: 84px !important;\n}\n\n.f-86 {\n  font-size: 86px !important;\n}\n\n.f-88 {\n  font-size: 88px !important;\n}\n\n.f-90 {\n  font-size: 90px !important;\n}\n\n.f-92 {\n  font-size: 92px !important;\n}\n\n.f-94 {\n  font-size: 94px !important;\n}\n\n.f-96 {\n  font-size: 96px !important;\n}\n\n.f-98 {\n  font-size: 98px !important;\n}\n\n.f-100 {\n  font-size: 100px !important;\n}\n\n/*====== Font-size css ends ======*/\n/*====== Font-weight css starts ======*/\n.f-w-100 {\n  font-weight: 100;\n}\n\n.f-w-300 {\n  font-weight: 300;\n}\n\n.f-w-500 {\n  font-weight: 500;\n}\n\n.f-w-400 {\n  font-weight: 400;\n}\n\n.f-w-600 {\n  font-weight: 600;\n}\n\n.f-w-700 {\n  font-weight: 700;\n}\n\n.f-w-900 {\n  font-weight: 900;\n}\n\n/*====== Font-weight css ends ======*/\n/*====== Font-style css starts ======*/\n.f-s-normal {\n  font-style: normal;\n}\n\n.f-s-italic {\n  font-style: italic;\n}\n\n.f-s-oblique {\n  font-style: oblique;\n}\n\n.f-s-initial {\n  font-style: initial;\n}\n\n.f-s-inherit {\n  font-style: inherit;\n}\n\n/*====== Font-style css ends ======*/\n/*====== Text-Decoration css starts ======*/\n.text-overline {\n  text-decoration: overline;\n}\n\n.text-line-through {\n  text-decoration: line-through;\n}\n\n.text-underline {\n  text-decoration: underline;\n}\n\n.text-dashed {\n  text-decoration: dashed;\n}\n\n.text-blink {\n  text-decoration: blink;\n}\n\n.text-dotted {\n  text-decoration: dotted;\n}\n\n.text-initial {\n  text-decoration: initial;\n}\n\n.text-none {\n  text-decoration: none;\n}\n\n.text-solid {\n  text-decoration: solid;\n}\n\n.text-wavy {\n  text-decoration: wavy;\n}\n\n.text-inherit {\n  text-decoration: inherit;\n}\n\n.text-double {\n  text-decoration: double;\n}\n\n/*====== Text-Decoration css ends ======*/\n/*====== Vertical-Align css starts ======*/\n.baseline {\n  vertical-align: baseline;\n}\n\n.sub {\n  vertical-align: sub;\n}\n\n.super {\n  vertical-align: super;\n}\n\n.top {\n  vertical-align: top;\n}\n\n.text-top {\n  vertical-align: text-top;\n}\n\n.middle {\n  vertical-align: middle;\n}\n\n.bottom {\n  vertical-align: bottom;\n}\n\n.text-bottom {\n  vertical-align: text-bottom;\n}\n\n.initial {\n  vertical-align: initial;\n}\n\n.inherit {\n  vertical-align: inherit;\n}\n\n/*====== Vertical-Align css ends ======*/\n/*====== Position css starts ======*/\n.p-static {\n  position: static;\n}\n\n.p-absolute {\n  position: absolute;\n}\n\n.p-fixed {\n  position: fixed;\n}\n\n.p-relative {\n  position: relative;\n}\n\n.p-initial {\n  position: initial;\n}\n\n.p-inherit {\n  position: inherit;\n}\n\n/*====== Position css ends ======*/\n/*====== Float css starts ======*/\n.f-left {\n  float: left;\n}\n\n.f-right {\n  float: right;\n}\n\n.f-none {\n  float: none;\n}\n\n/*====== Float css ends ======*/\n/*====== Overflow css starts ======*/\n.o-hidden {\n  overflow: hidden;\n}\n\n.o-visible {\n  overflow: visible;\n}\n\n.o-auto {\n  overflow: auto;\n}\n\n/*====== Overflow css ends ======*/\n/*====== Image-sizes css starts ======*/\n.img-10 {\n  width: 10px !important;\n}\n\n.img-20 {\n  width: 20px !important;\n}\n\n.img-30 {\n  width: 30px !important;\n}\n\n.img-40 {\n  width: 40px !important;\n}\n\n.img-50 {\n  width: 50px !important;\n}\n\n.img-60 {\n  width: 60px !important;\n}\n\n.img-70 {\n  width: 70px !important;\n}\n\n.img-80 {\n  width: 80px !important;\n}\n\n.img-90 {\n  width: 90px !important;\n}\n\n.img-100 {\n  width: 100px !important;\n}\n\n/*====== Image-sizes css ends ======*/\n/*======= Text css starts ===========*/\n.font-primary {\n  color: #7366ff !important;\n}\n\n.font-secondary {\n  color: #ff3364 !important;\n}\n\n.font-success {\n  color: #54ba4a !important;\n}\n\n.font-danger {\n  color: #fc4438 !important;\n}\n\n.font-info {\n  color: #16c7f9 !important;\n}\n\n.font-light {\n  color: #f4f4f4 !important;\n}\n\n.font-dark {\n  color: #2c323f !important;\n}\n\n.font-warning {\n  color: #ffaa05 !important;\n}\n\n.font-primary {\n  color: var(--theme-default) !important;\n}\n\n.font-secondary {\n  color: var(--theme-secondary) !important;\n}\n\n/*======= Text css ends ===========*/\n/*======= Label-color css starts  ======= */\n.label {\n  border-radius: 2px;\n  color: #fff;\n  font-size: 12px;\n  line-height: 1;\n  margin-bottom: 0;\n  text-transform: capitalize;\n}\n\n.label-theme {\n  background-color: #7366ff;\n}\n\n.label-primary {\n  background-color: #7366ff;\n}\n\n.label-secondary {\n  background-color: #ff3364;\n}\n\n.label-success {\n  background-color: #54ba4a;\n}\n\n.label-danger {\n  background-color: #fc4438;\n}\n\n.label-info {\n  background-color: #16c7f9;\n}\n\n.label-light {\n  background-color: #f4f4f4;\n}\n\n.label-dark {\n  background-color: #2c323f;\n}\n\n.label-warning {\n  background-color: #ffaa05;\n}\n\n/*======= Label-color css ends  ======= */\n/*======= Badge-color css starts  ======= */\n.badge-primary {\n  background-color: #7366ff;\n}\n\n.badge-secondary {\n  background-color: #ff3364;\n}\n\n.badge-success {\n  background-color: #54ba4a;\n}\n\n.badge-danger {\n  background-color: #fc4438;\n}\n\n.badge-info {\n  background-color: #16c7f9;\n}\n\n.badge-light {\n  background-color: #f4f4f4;\n}\n\n.badge-dark {\n  background-color: #2c323f;\n}\n\n.badge-warning {\n  background-color: #ffaa05;\n}\n\n.badge-primary {\n  background-color: var(--theme-default) !important;\n}\n\n.badge-secondary {\n  background-color: var(--theme-secondary) !important;\n}\n\n/*======= Badge-color css end  ======= */\n/*======= Background-color css starts  ======= */\n.bg-primary {\n  background-color: #7366ff !important;\n  color: #fff;\n}\n\n.bg-light-primary {\n  background-color: rgba(115, 102, 255, 0.1) !important;\n  color: #fff;\n}\n\n.bg-secondary {\n  background-color: #ff3364 !important;\n  color: #fff;\n}\n\n.bg-light-secondary {\n  background-color: rgba(255, 51, 100, 0.1) !important;\n  color: #fff;\n}\n\n.bg-success {\n  background-color: #54ba4a !important;\n  color: #fff;\n}\n\n.bg-light-success {\n  background-color: rgba(84, 186, 74, 0.1) !important;\n  color: #fff;\n}\n\n.bg-danger {\n  background-color: #fc4438 !important;\n  color: #fff;\n}\n\n.bg-light-danger {\n  background-color: rgba(252, 68, 56, 0.1) !important;\n  color: #fff;\n}\n\n.bg-info {\n  background-color: #16c7f9 !important;\n  color: #fff;\n}\n\n.bg-light-info {\n  background-color: rgba(22, 199, 249, 0.1) !important;\n  color: #fff;\n}\n\n.bg-light {\n  background-color: #f4f4f4 !important;\n  color: #fff;\n}\n\n.bg-light-light {\n  background-color: rgba(244, 244, 244, 0.1) !important;\n  color: #fff;\n}\n\n.bg-dark {\n  background-color: #2c323f !important;\n  color: #fff;\n}\n\n.bg-light-dark {\n  background-color: rgba(44, 50, 63, 0.1) !important;\n  color: #fff;\n}\n\n.bg-warning {\n  background-color: #ffaa05 !important;\n  color: #fff;\n}\n\n.bg-light-warning {\n  background-color: rgba(255, 170, 5, 0.1) !important;\n  color: #fff;\n}\n\n.bg-primary {\n  background-color: var(--theme-default) !important;\n}\n\n.bg-secondary {\n  background-color: var(--theme-secondary) !important;\n}\n\n/*======= Background-color css end  ======= */\n/*======= Font-color css starts  ======= */\n.txt-primary {\n  color: #7366ff !important;\n}\n\n.txt-secondary {\n  color: #ff3364 !important;\n}\n\n.txt-success {\n  color: #54ba4a !important;\n}\n\n.txt-danger {\n  color: #fc4438 !important;\n}\n\n.txt-info {\n  color: #16c7f9 !important;\n}\n\n.txt-light {\n  color: #f4f4f4 !important;\n}\n\n.txt-dark {\n  color: #2c323f !important;\n}\n\n.txt-warning {\n  color: #ffaa05 !important;\n}\n\n.txt-google-plus {\n  color: #c64e40 !important;\n}\n\n.txt-twitter {\n  color: #6fa2d8 !important;\n}\n\n.txt-linkedin {\n  color: #0077b5 !important;\n}\n\n.txt-fb {\n  color: #50598e !important;\n}\n\n.txt-primary {\n  color: var(--theme-default) !important;\n}\n\n.txt-secondary {\n  color: var(--theme-secondary) !important;\n}\n\n/*======= Font-color css end  ======= */\n/*======= Button-color css starts  ======= */\n@keyframes push {\n  50% {\n    transform: scale(0.95);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.btn-primary {\n  background-color: #7366ff !important;\n  border-color: #7366ff !important;\n  -webkit-tap-highlight-color: transparent;\n  transform: translateZ(0);\n}\n.btn-primary.disabled, .btn-primary:disabled {\n  background-color: #7366ff !important;\n  border-color: #7366ff !important;\n}\n.btn-primary:focus {\n  box-shadow: 0 0 0 0.2rem white;\n}\n\n.btn-secondary {\n  background-color: #ff3364 !important;\n  border-color: #ff3364 !important;\n  -webkit-tap-highlight-color: transparent;\n  transform: translateZ(0);\n}\n.btn-secondary.disabled, .btn-secondary:disabled {\n  background-color: #ff3364 !important;\n  border-color: #ff3364 !important;\n}\n.btn-secondary:focus {\n  box-shadow: 0 0 0 0.2rem rgb(100%, 80%, 84.8039215686%);\n}\n\n.btn-success {\n  background-color: #54ba4a !important;\n  border-color: #54ba4a !important;\n  -webkit-tap-highlight-color: transparent;\n  transform: translateZ(0);\n}\n.btn-success.disabled, .btn-success:disabled {\n  background-color: #54ba4a !important;\n  border-color: #54ba4a !important;\n}\n.btn-success:focus {\n  box-shadow: 0 0 0 0.2rem rgb(73.9811764706%, 89.5011764706%, 72.4596078431%);\n}\n\n.btn-danger {\n  background-color: #fc4438 !important;\n  border-color: #fc4438 !important;\n  -webkit-tap-highlight-color: transparent;\n  transform: translateZ(0);\n}\n.btn-danger.disabled, .btn-danger:disabled {\n  background-color: #fc4438 !important;\n  border-color: #fc4438 !important;\n}\n.btn-danger:focus {\n  box-shadow: 0 0 0 0.2rem rgb(99.7146185207%, 82.2112211221%, 81.0696952048%);\n}\n\n.btn-info {\n  background-color: #16c7f9 !important;\n  border-color: #16c7f9 !important;\n  -webkit-tap-highlight-color: transparent;\n  transform: translateZ(0);\n  color: #fff;\n}\n.btn-info:hover, .btn-info:focus, .btn-info:active, .btn-info.active {\n  color: #fff;\n}\n.btn-info.disabled, .btn-info:disabled {\n  background-color: #16c7f9 !important;\n  border-color: #16c7f9 !important;\n}\n.btn-info:focus {\n  box-shadow: 0 0 0 0.2rem rgb(67.1211748298%, 92.0977930921%, 99.1533349742%);\n}\n\n.btn-light {\n  background-color: #f4f4f4 !important;\n  border-color: #f4f4f4 !important;\n  -webkit-tap-highlight-color: transparent;\n  transform: translateZ(0);\n}\n.btn-light.disabled, .btn-light:disabled {\n  background-color: #f4f4f4 !important;\n  border-color: #f4f4f4 !important;\n}\n.btn-light:focus {\n  box-shadow: 0 0 0 0.2rem white;\n}\n\n.btn-dark {\n  background-color: #2c323f !important;\n  border-color: #2c323f !important;\n  -webkit-tap-highlight-color: transparent;\n  transform: translateZ(0);\n}\n.btn-dark.disabled, .btn-dark:disabled {\n  background-color: #2c323f !important;\n  border-color: #2c323f !important;\n}\n.btn-dark:focus {\n  box-shadow: 0 0 0 0.2rem rgb(42.2759758109%, 47.7735019241%, 59.6848085028%);\n}\n\n.btn-warning {\n  background-color: #ffaa05 !important;\n  border-color: #ffaa05 !important;\n  -webkit-tap-highlight-color: transparent;\n  transform: translateZ(0);\n}\n.btn-warning.disabled, .btn-warning:disabled {\n  background-color: #ffaa05 !important;\n  border-color: #ffaa05 !important;\n}\n.btn-warning:focus {\n  box-shadow: 0 0 0 0.2rem rgb(100%, 87.0666666667%, 61.9607843137%);\n}\n\n.btn-light {\n  background-color: rgba(115, 102, 255, 0.06) !important;\n  border-color: rgba(115, 102, 255, 0.06) !important;\n}\n.btn-light:hover {\n  background-color: rgba(115, 102, 255, 0.1) !important;\n  border-color: rgba(115, 102, 255, 0.1) !important;\n}\n\n.btn-primary {\n  background-color: var(--theme-default) !important;\n  border-color: var(--theme-default) !important;\n}\n\n.btn-secondary {\n  background-color: var(--theme-secondary) !important;\n  border-color: var(--theme-secondary) !important;\n}\n\n.btn-hover-effect:hover {\n  animation: push 0.5s linear 1;\n}\n\n/*======= Button-color css ends  ======= */\n.btn-outline-primary-2x {\n  border-width: 2px;\n  border-color: #7366ff;\n  color: #7366ff;\n  background-color: transparent;\n}\n.btn-outline-primary-2x:hover, .btn-outline-primary-2x:focus, .btn-outline-primary-2x:active, .btn-outline-primary-2x.active {\n  color: white;\n  background-color: rgb(26.7973856209%, 20%, 100%) !important;\n  border-color: rgb(26.7973856209%, 20%, 100%) !important;\n  box-shadow: none;\n}\n\n.btn-outline-secondary-2x {\n  border-width: 2px;\n  border-color: #ff3364;\n  color: #ff3364;\n  background-color: transparent;\n}\n.btn-outline-secondary-2x:hover, .btn-outline-secondary-2x:focus, .btn-outline-secondary-2x:active, .btn-outline-secondary-2x.active {\n  color: white;\n  background-color: rgb(100%, 0%, 24.0196078431%) !important;\n  border-color: rgb(100%, 0%, 24.0196078431%) !important;\n  box-shadow: none;\n}\n\n.btn-outline-success-2x {\n  border-width: 2px;\n  border-color: #54ba4a;\n  color: #54ba4a;\n  background-color: transparent;\n}\n.btn-outline-success-2x:hover, .btn-outline-success-2x:focus, .btn-outline-success-2x:active, .btn-outline-success-2x.active {\n  color: white;\n  background-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%) !important;\n  border-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%) !important;\n  box-shadow: none;\n}\n\n.btn-outline-danger-2x {\n  border-width: 2px;\n  border-color: #fc4438;\n  color: #fc4438;\n  background-color: transparent;\n}\n.btn-outline-danger-2x:hover, .btn-outline-danger-2x:focus, .btn-outline-danger-2x:active, .btn-outline-danger-2x.active {\n  color: white;\n  background-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%) !important;\n  border-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%) !important;\n  box-shadow: none;\n}\n\n.btn-outline-info-2x {\n  border-width: 2px;\n  border-color: #16c7f9;\n  color: #16c7f9;\n  background-color: transparent;\n}\n.btn-outline-info-2x:hover, .btn-outline-info-2x:focus, .btn-outline-info-2x:active, .btn-outline-info-2x.active {\n  color: white;\n  background-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%) !important;\n  border-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%) !important;\n  box-shadow: none;\n}\n\n.btn-outline-light-2x {\n  border-width: 2px;\n  border-color: #f4f4f4;\n  color: #f4f4f4;\n  background-color: transparent;\n}\n.btn-outline-light-2x:hover, .btn-outline-light-2x:focus, .btn-outline-light-2x:active, .btn-outline-light-2x.active {\n  color: white;\n  background-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%) !important;\n  border-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%) !important;\n  box-shadow: none;\n}\n\n.btn-outline-dark-2x {\n  border-width: 2px;\n  border-color: #2c323f;\n  color: #2c323f;\n  background-color: transparent;\n}\n.btn-outline-dark-2x:hover, .btn-outline-dark-2x:focus, .btn-outline-dark-2x:active, .btn-outline-dark-2x.active {\n  color: white;\n  background-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%) !important;\n  border-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%) !important;\n  box-shadow: none;\n}\n\n.btn-outline-warning-2x {\n  border-width: 2px;\n  border-color: #ffaa05;\n  color: #ffaa05;\n  background-color: transparent;\n}\n.btn-outline-warning-2x:hover, .btn-outline-warning-2x:focus, .btn-outline-warning-2x:active, .btn-outline-warning-2x.active {\n  color: white;\n  background-color: rgb(81.9607843137%, 54.0941176471%, 0%) !important;\n  border-color: rgb(81.9607843137%, 54.0941176471%, 0%) !important;\n  box-shadow: none;\n}\n\n.btn-outline-primary {\n  border-color: #7366ff;\n  color: #7366ff;\n  background-color: transparent;\n}\n.btn-outline-primary.disabled {\n  color: #7366ff;\n}\n.btn-outline-primary:hover, .btn-outline-primary:focus, .btn-outline-primary:active, .btn-outline-primary.active {\n  color: white;\n  background-color: rgb(26.7973856209%, 20%, 100%) !important;\n  border-color: rgb(26.7973856209%, 20%, 100%) !important;\n}\n\n.btn-outline-secondary {\n  border-color: #ff3364;\n  color: #ff3364;\n  background-color: transparent;\n}\n.btn-outline-secondary.disabled {\n  color: #ff3364;\n}\n.btn-outline-secondary:hover, .btn-outline-secondary:focus, .btn-outline-secondary:active, .btn-outline-secondary.active {\n  color: white;\n  background-color: rgb(100%, 0%, 24.0196078431%) !important;\n  border-color: rgb(100%, 0%, 24.0196078431%) !important;\n}\n\n.btn-outline-success {\n  border-color: #54ba4a;\n  color: #54ba4a;\n  background-color: transparent;\n}\n.btn-outline-success.disabled {\n  color: #54ba4a;\n}\n.btn-outline-success:hover, .btn-outline-success:focus, .btn-outline-success:active, .btn-outline-success.active {\n  color: white;\n  background-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%) !important;\n  border-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%) !important;\n}\n\n.btn-outline-danger {\n  border-color: #fc4438;\n  color: #fc4438;\n  background-color: transparent;\n}\n.btn-outline-danger.disabled {\n  color: #fc4438;\n}\n.btn-outline-danger:hover, .btn-outline-danger:focus, .btn-outline-danger:active, .btn-outline-danger.active {\n  color: white;\n  background-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%) !important;\n  border-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%) !important;\n}\n\n.btn-outline-info {\n  border-color: #16c7f9;\n  color: #16c7f9;\n  background-color: transparent;\n}\n.btn-outline-info.disabled {\n  color: #16c7f9;\n}\n.btn-outline-info:hover, .btn-outline-info:focus, .btn-outline-info:active, .btn-outline-info.active {\n  color: white;\n  background-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%) !important;\n  border-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%) !important;\n}\n\n.btn-outline-light {\n  border-color: #f4f4f4;\n  color: #f4f4f4;\n  background-color: transparent;\n}\n.btn-outline-light.disabled {\n  color: #f4f4f4;\n}\n.btn-outline-light {\n  color: #2f2f3b;\n}\n.btn-outline-light:hover, .btn-outline-light:focus, .btn-outline-light:active, .btn-outline-light.active {\n  color: white;\n  background-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%) !important;\n  border-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%) !important;\n}\n\n.btn-outline-dark {\n  border-color: #2c323f;\n  color: #2c323f;\n  background-color: transparent;\n}\n.btn-outline-dark.disabled {\n  color: #2c323f;\n}\n.btn-outline-dark:hover, .btn-outline-dark:focus, .btn-outline-dark:active, .btn-outline-dark.active {\n  color: white;\n  background-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%) !important;\n  border-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%) !important;\n}\n\n.btn-outline-warning {\n  border-color: #ffaa05;\n  color: #ffaa05;\n  background-color: transparent;\n}\n.btn-outline-warning.disabled {\n  color: #ffaa05;\n}\n.btn-outline-warning:hover, .btn-outline-warning:focus, .btn-outline-warning:active, .btn-outline-warning.active {\n  color: white;\n  background-color: rgb(81.9607843137%, 54.0941176471%, 0%) !important;\n  border-color: rgb(81.9607843137%, 54.0941176471%, 0%) !important;\n}\n\n.btn-primary:not([disabled]):not(.disabled).active {\n  background-color: rgb(26.7973856209%, 20%, 100%);\n  border-color: rgb(26.7973856209%, 20%, 100%);\n  box-shadow: none !important;\n}\n.btn-primary:not([disabled]):not(.disabled).active:hover, .btn-primary:not([disabled]):not(.disabled).active:focus, .btn-primary:not([disabled]):not(.disabled).active:active, .btn-primary:not([disabled]):not(.disabled).active.active {\n  color: white;\n  background-color: rgb(26.7973856209%, 20%, 100%);\n  border-color: rgb(26.7973856209%, 20%, 100%);\n}\n\n.btn-secondary:not([disabled]):not(.disabled).active {\n  background-color: rgb(100%, 0%, 24.0196078431%);\n  border-color: rgb(100%, 0%, 24.0196078431%);\n  box-shadow: none !important;\n}\n.btn-secondary:not([disabled]):not(.disabled).active:hover, .btn-secondary:not([disabled]):not(.disabled).active:focus, .btn-secondary:not([disabled]):not(.disabled).active:active, .btn-secondary:not([disabled]):not(.disabled).active.active {\n  color: white;\n  background-color: rgb(100%, 0%, 24.0196078431%);\n  border-color: rgb(100%, 0%, 24.0196078431%);\n}\n\n.btn-success:not([disabled]):not(.disabled).active {\n  background-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%);\n  border-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%);\n  box-shadow: none !important;\n}\n.btn-success:not([disabled]):not(.disabled).active:hover, .btn-success:not([disabled]):not(.disabled).active:focus, .btn-success:not([disabled]):not(.disabled).active:active, .btn-success:not([disabled]):not(.disabled).active.active {\n  color: white;\n  background-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%);\n  border-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%);\n}\n\n.btn-danger:not([disabled]):not(.disabled).active {\n  background-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%);\n  border-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%);\n  box-shadow: none !important;\n}\n.btn-danger:not([disabled]):not(.disabled).active:hover, .btn-danger:not([disabled]):not(.disabled).active:focus, .btn-danger:not([disabled]):not(.disabled).active:active, .btn-danger:not([disabled]):not(.disabled).active.active {\n  color: white;\n  background-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%);\n  border-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%);\n}\n\n.btn-info:not([disabled]):not(.disabled).active {\n  background-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%);\n  border-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%);\n  box-shadow: none !important;\n}\n.btn-info:not([disabled]):not(.disabled).active:hover, .btn-info:not([disabled]):not(.disabled).active:focus, .btn-info:not([disabled]):not(.disabled).active:active, .btn-info:not([disabled]):not(.disabled).active.active {\n  color: white;\n  background-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%);\n  border-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%);\n}\n\n.btn-light:not([disabled]):not(.disabled).active {\n  background-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%);\n  border-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%);\n  box-shadow: none !important;\n}\n.btn-light:not([disabled]):not(.disabled).active:hover, .btn-light:not([disabled]):not(.disabled).active:focus, .btn-light:not([disabled]):not(.disabled).active:active, .btn-light:not([disabled]):not(.disabled).active.active {\n  color: white;\n  background-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%);\n  border-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%);\n}\n\n.btn-dark:not([disabled]):not(.disabled).active {\n  background-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%);\n  border-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%);\n  box-shadow: none !important;\n}\n.btn-dark:not([disabled]):not(.disabled).active:hover, .btn-dark:not([disabled]):not(.disabled).active:focus, .btn-dark:not([disabled]):not(.disabled).active:active, .btn-dark:not([disabled]):not(.disabled).active.active {\n  color: white;\n  background-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%);\n  border-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%);\n}\n\n.btn-warning:not([disabled]):not(.disabled).active {\n  background-color: rgb(81.9607843137%, 54.0941176471%, 0%);\n  border-color: rgb(81.9607843137%, 54.0941176471%, 0%);\n  box-shadow: none !important;\n}\n.btn-warning:not([disabled]):not(.disabled).active:hover, .btn-warning:not([disabled]):not(.disabled).active:focus, .btn-warning:not([disabled]):not(.disabled).active:active, .btn-warning:not([disabled]):not(.disabled).active.active {\n  color: white;\n  background-color: rgb(81.9607843137%, 54.0941176471%, 0%);\n  border-color: rgb(81.9607843137%, 54.0941176471%, 0%);\n}\n\n.btn-outline-primary-2x:not([disabled]):not(.disabled).active {\n  background-color: #7366ff;\n  border-color: #7366ff;\n  box-shadow: none !important;\n  color: white;\n}\n.btn-outline-primary-2x:not([disabled]):not(.disabled).active:hover, .btn-outline-primary-2x:not([disabled]):not(.disabled).active:focus, .btn-outline-primary-2x:not([disabled]):not(.disabled).active:active, .btn-outline-primary-2x:not([disabled]):not(.disabled).active.active {\n  color: white;\n  box-shadow: none !important;\n  background-color: rgb(26.7973856209%, 20%, 100%) !important;\n  border-color: rgb(26.7973856209%, 20%, 100%) !important;\n}\n\n.btn-outline-secondary-2x:not([disabled]):not(.disabled).active {\n  background-color: #ff3364;\n  border-color: #ff3364;\n  box-shadow: none !important;\n  color: white;\n}\n.btn-outline-secondary-2x:not([disabled]):not(.disabled).active:hover, .btn-outline-secondary-2x:not([disabled]):not(.disabled).active:focus, .btn-outline-secondary-2x:not([disabled]):not(.disabled).active:active, .btn-outline-secondary-2x:not([disabled]):not(.disabled).active.active {\n  color: white;\n  box-shadow: none !important;\n  background-color: rgb(100%, 0%, 24.0196078431%) !important;\n  border-color: rgb(100%, 0%, 24.0196078431%) !important;\n}\n\n.btn-outline-success-2x:not([disabled]):not(.disabled).active {\n  background-color: #54ba4a;\n  border-color: #54ba4a;\n  box-shadow: none !important;\n  color: white;\n}\n.btn-outline-success-2x:not([disabled]):not(.disabled).active:hover, .btn-outline-success-2x:not([disabled]):not(.disabled).active:focus, .btn-outline-success-2x:not([disabled]):not(.disabled).active:active, .btn-outline-success-2x:not([disabled]):not(.disabled).active.active {\n  color: white;\n  box-shadow: none !important;\n  background-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%) !important;\n  border-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%) !important;\n}\n\n.btn-outline-danger-2x:not([disabled]):not(.disabled).active {\n  background-color: #fc4438;\n  border-color: #fc4438;\n  box-shadow: none !important;\n  color: white;\n}\n.btn-outline-danger-2x:not([disabled]):not(.disabled).active:hover, .btn-outline-danger-2x:not([disabled]):not(.disabled).active:focus, .btn-outline-danger-2x:not([disabled]):not(.disabled).active:active, .btn-outline-danger-2x:not([disabled]):not(.disabled).active.active {\n  color: white;\n  box-shadow: none !important;\n  background-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%) !important;\n  border-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%) !important;\n}\n\n.btn-outline-info-2x:not([disabled]):not(.disabled).active {\n  background-color: #16c7f9;\n  border-color: #16c7f9;\n  box-shadow: none !important;\n  color: white;\n}\n.btn-outline-info-2x:not([disabled]):not(.disabled).active:hover, .btn-outline-info-2x:not([disabled]):not(.disabled).active:focus, .btn-outline-info-2x:not([disabled]):not(.disabled).active:active, .btn-outline-info-2x:not([disabled]):not(.disabled).active.active {\n  color: white;\n  box-shadow: none !important;\n  background-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%) !important;\n  border-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%) !important;\n}\n\n.btn-outline-light-2x:not([disabled]):not(.disabled).active {\n  background-color: #f4f4f4;\n  border-color: #f4f4f4;\n  box-shadow: none !important;\n  color: white;\n}\n.btn-outline-light-2x:not([disabled]):not(.disabled).active:hover, .btn-outline-light-2x:not([disabled]):not(.disabled).active:focus, .btn-outline-light-2x:not([disabled]):not(.disabled).active:active, .btn-outline-light-2x:not([disabled]):not(.disabled).active.active {\n  color: white;\n  box-shadow: none !important;\n  background-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%) !important;\n  border-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%) !important;\n}\n\n.btn-outline-dark-2x:not([disabled]):not(.disabled).active {\n  background-color: #2c323f;\n  border-color: #2c323f;\n  box-shadow: none !important;\n  color: white;\n}\n.btn-outline-dark-2x:not([disabled]):not(.disabled).active:hover, .btn-outline-dark-2x:not([disabled]):not(.disabled).active:focus, .btn-outline-dark-2x:not([disabled]):not(.disabled).active:active, .btn-outline-dark-2x:not([disabled]):not(.disabled).active.active {\n  color: white;\n  box-shadow: none !important;\n  background-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%) !important;\n  border-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%) !important;\n}\n\n.btn-outline-warning-2x:not([disabled]):not(.disabled).active {\n  background-color: #ffaa05;\n  border-color: #ffaa05;\n  box-shadow: none !important;\n  color: white;\n}\n.btn-outline-warning-2x:not([disabled]):not(.disabled).active:hover, .btn-outline-warning-2x:not([disabled]):not(.disabled).active:focus, .btn-outline-warning-2x:not([disabled]):not(.disabled).active:active, .btn-outline-warning-2x:not([disabled]):not(.disabled).active.active {\n  color: white;\n  box-shadow: none !important;\n  background-color: rgb(81.9607843137%, 54.0941176471%, 0%) !important;\n  border-color: rgb(81.9607843137%, 54.0941176471%, 0%) !important;\n}\n\n/*======= Table-Border-Bottom-color css starts  ======= */\ntable thead .border-bottom-primary th,\ntable tbody .border-bottom-primary th,\ntable tbody .border-bottom-primary td {\n  border-bottom: 1px solid #7366ff !important;\n}\n\ntable thead .border-bottom-secondary th,\ntable tbody .border-bottom-secondary th,\ntable tbody .border-bottom-secondary td {\n  border-bottom: 1px solid #ff3364 !important;\n}\n\ntable thead .border-bottom-success th,\ntable tbody .border-bottom-success th,\ntable tbody .border-bottom-success td {\n  border-bottom: 1px solid #54ba4a !important;\n}\n\ntable thead .border-bottom-danger th,\ntable tbody .border-bottom-danger th,\ntable tbody .border-bottom-danger td {\n  border-bottom: 1px solid #fc4438 !important;\n}\n\ntable thead .border-bottom-info th,\ntable tbody .border-bottom-info th,\ntable tbody .border-bottom-info td {\n  border-bottom: 1px solid #16c7f9 !important;\n}\n\ntable thead .border-bottom-light th,\ntable tbody .border-bottom-light th,\ntable tbody .border-bottom-light td {\n  border-bottom: 1px solid #f4f4f4 !important;\n}\n\ntable thead .border-bottom-dark th,\ntable tbody .border-bottom-dark th,\ntable tbody .border-bottom-dark td {\n  border-bottom: 1px solid #2c323f !important;\n}\n\ntable thead .border-bottom-warning th,\ntable tbody .border-bottom-warning th,\ntable tbody .border-bottom-warning td {\n  border-bottom: 1px solid #ffaa05 !important;\n}\n\n/*======= Table-Border-Bottom-color css ends  ======= */\n/*======= Table styling css starts  ======= */\n.table-styling .table-primary,\n.table-styling.table-primary {\n  background-color: #7366ff;\n  color: #fff;\n  border: 3px solid #7366ff;\n}\n.table-styling .table-primary thead,\n.table-styling.table-primary thead {\n  background-color: rgb(26.7973856209%, 20%, 100%);\n  border: 3px solid rgb(26.7973856209%, 20%, 100%);\n}\n.table-styling .table-primary th,\n.table-styling .table-primary td,\n.table-styling.table-primary th,\n.table-styling.table-primary td {\n  background-color: transparent;\n}\n\n.table-styling .table-secondary,\n.table-styling.table-secondary {\n  background-color: #ff3364;\n  color: #fff;\n  border: 3px solid #ff3364;\n}\n.table-styling .table-secondary thead,\n.table-styling.table-secondary thead {\n  background-color: rgb(100%, 0%, 24.0196078431%);\n  border: 3px solid rgb(100%, 0%, 24.0196078431%);\n}\n.table-styling .table-secondary th,\n.table-styling .table-secondary td,\n.table-styling.table-secondary th,\n.table-styling.table-secondary td {\n  background-color: transparent;\n}\n\n.table-styling .table-success,\n.table-styling.table-success {\n  background-color: #54ba4a;\n  color: #fff;\n  border: 3px solid #54ba4a;\n}\n.table-styling .table-success thead,\n.table-styling.table-success thead {\n  background-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%);\n  border: 3px solid rgb(25.8996078431%, 59.3396078431%, 22.6211764706%);\n}\n.table-styling .table-success th,\n.table-styling .table-success td,\n.table-styling.table-success th,\n.table-styling.table-success td {\n  background-color: transparent;\n}\n\n.table-styling .table-danger,\n.table-styling.table-danger {\n  background-color: #fc4438;\n  color: #fff;\n  border: 3px solid #fc4438;\n}\n.table-styling .table-danger thead,\n.table-styling.table-danger thead {\n  background-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%);\n  border: 3px solid rgb(98.5264997088%, 8.1518151815%, 2.2578140167%);\n}\n.table-styling .table-danger th,\n.table-styling .table-danger td,\n.table-styling.table-danger th,\n.table-styling.table-danger td {\n  background-color: transparent;\n}\n\n.table-styling .table-info,\n.table-styling.table-info {\n  background-color: #16c7f9;\n  color: #fff;\n  border: 3px solid #16c7f9;\n}\n.table-styling .table-info thead,\n.table-styling.table-info thead {\n  background-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%);\n  border: 3px solid rgb(2.1658872754%, 66.0595619001%, 84.1086225285%);\n}\n.table-styling .table-info th,\n.table-styling .table-info td,\n.table-styling.table-info th,\n.table-styling.table-info td {\n  background-color: transparent;\n}\n\n.table-styling .table-light,\n.table-styling.table-light {\n  background-color: #f4f4f4;\n  color: #fff;\n  border: 3px solid #f4f4f4;\n}\n.table-styling .table-light thead,\n.table-styling.table-light thead {\n  background-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%);\n  border: 3px solid rgb(85.6862745098%, 85.6862745098%, 85.6862745098%);\n}\n.table-styling .table-light th,\n.table-styling .table-light td,\n.table-styling.table-light th,\n.table-styling.table-light td {\n  background-color: transparent;\n}\n\n.table-styling .table-dark,\n.table-styling.table-dark {\n  background-color: #2c323f;\n  color: #fff;\n  border: 3px solid #2c323f;\n}\n.table-styling .table-dark thead,\n.table-styling.table-dark thead {\n  background-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%);\n  border: 3px solid rgb(9.0306028954%, 10.2620487447%, 12.9301814184%);\n}\n.table-styling .table-dark th,\n.table-styling .table-dark td,\n.table-styling.table-dark th,\n.table-styling.table-dark td {\n  background-color: transparent;\n}\n\n.table-styling .table-warning,\n.table-styling.table-warning {\n  background-color: #ffaa05;\n  color: #fff;\n  border: 3px solid #ffaa05;\n}\n.table-styling .table-warning thead,\n.table-styling.table-warning thead {\n  background-color: rgb(81.9607843137%, 54.0941176471%, 0%);\n  border: 3px solid rgb(81.9607843137%, 54.0941176471%, 0%);\n}\n.table-styling .table-warning th,\n.table-styling .table-warning td,\n.table-styling.table-warning th,\n.table-styling.table-warning td {\n  background-color: transparent;\n}\n\n/*======= Table styling css ends  ======= */\n/*======= All-Borders-color css starts  ======= */\n.b-primary {\n  border: 1px solid #7366ff !important;\n}\n\n.b-t-primary {\n  border-top: 1px solid #7366ff !important;\n}\n\n.b-b-primary {\n  border-bottom: 1px solid #7366ff !important;\n}\n\n.b-l-primary {\n  border-left: 1px solid #7366ff !important;\n}\n\n.b-r-primary {\n  border-right: 1px solid #7366ff !important;\n}\n\n.b-secondary {\n  border: 1px solid #ff3364 !important;\n}\n\n.b-t-secondary {\n  border-top: 1px solid #ff3364 !important;\n}\n\n.b-b-secondary {\n  border-bottom: 1px solid #ff3364 !important;\n}\n\n.b-l-secondary {\n  border-left: 1px solid #ff3364 !important;\n}\n\n.b-r-secondary {\n  border-right: 1px solid #ff3364 !important;\n}\n\n.b-success {\n  border: 1px solid #54ba4a !important;\n}\n\n.b-t-success {\n  border-top: 1px solid #54ba4a !important;\n}\n\n.b-b-success {\n  border-bottom: 1px solid #54ba4a !important;\n}\n\n.b-l-success {\n  border-left: 1px solid #54ba4a !important;\n}\n\n.b-r-success {\n  border-right: 1px solid #54ba4a !important;\n}\n\n.b-danger {\n  border: 1px solid #fc4438 !important;\n}\n\n.b-t-danger {\n  border-top: 1px solid #fc4438 !important;\n}\n\n.b-b-danger {\n  border-bottom: 1px solid #fc4438 !important;\n}\n\n.b-l-danger {\n  border-left: 1px solid #fc4438 !important;\n}\n\n.b-r-danger {\n  border-right: 1px solid #fc4438 !important;\n}\n\n.b-info {\n  border: 1px solid #16c7f9 !important;\n}\n\n.b-t-info {\n  border-top: 1px solid #16c7f9 !important;\n}\n\n.b-b-info {\n  border-bottom: 1px solid #16c7f9 !important;\n}\n\n.b-l-info {\n  border-left: 1px solid #16c7f9 !important;\n}\n\n.b-r-info {\n  border-right: 1px solid #16c7f9 !important;\n}\n\n.b-light {\n  border: 1px solid #f4f4f4 !important;\n}\n\n.b-t-light {\n  border-top: 1px solid #f4f4f4 !important;\n}\n\n.b-b-light {\n  border-bottom: 1px solid #f4f4f4 !important;\n}\n\n.b-l-light {\n  border-left: 1px solid #f4f4f4 !important;\n}\n\n.b-r-light {\n  border-right: 1px solid #f4f4f4 !important;\n}\n\n.b-dark {\n  border: 1px solid #2c323f !important;\n}\n\n.b-t-dark {\n  border-top: 1px solid #2c323f !important;\n}\n\n.b-b-dark {\n  border-bottom: 1px solid #2c323f !important;\n}\n\n.b-l-dark {\n  border-left: 1px solid #2c323f !important;\n}\n\n.b-r-dark {\n  border-right: 1px solid #2c323f !important;\n}\n\n.b-warning {\n  border: 1px solid #ffaa05 !important;\n}\n\n.b-t-warning {\n  border-top: 1px solid #ffaa05 !important;\n}\n\n.b-b-warning {\n  border-bottom: 1px solid #ffaa05 !important;\n}\n\n.b-l-warning {\n  border-left: 1px solid #ffaa05 !important;\n}\n\n.b-r-warning {\n  border-right: 1px solid #ffaa05 !important;\n}\n\n/*======= All-Borders-color css ends  ======= */\n/*====== Border width css starts ======*/\n.border-1 {\n  border-width: 1px !important;\n}\n\n.border-2 {\n  border-width: 2px !important;\n}\n\n.border-3 {\n  border-width: 3px !important;\n}\n\n.border-4 {\n  border-width: 4px !important;\n}\n\n.border-5 {\n  border-width: 5px !important;\n}\n\n.border-6 {\n  border-width: 6px !important;\n}\n\n.border-7 {\n  border-width: 7px !important;\n}\n\n.border-8 {\n  border-width: 8px !important;\n}\n\n.border-9 {\n  border-width: 9px !important;\n}\n\n.border-10 {\n  border-width: 10px !important;\n}\n\n/*====== Border width css ends ======*/\n.opacity-0 {\n  opacity: 0;\n}\n\n.map-block {\n  height: 350px;\n  width: 100%;\n}\n\n.map-js-height {\n  height: 500px;\n}\n.map-js-height .btn-group input {\n  background-color: #7366ff;\n  color: #fff;\n}\n.map-js-height .btn-group input + input {\n  background-color: #ff3364;\n}\n\n/**====== custom scrollbar css start ======**/\n.custom-scrollbar::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px #ecf3fa;\n}\n.custom-scrollbar::-webkit-scrollbar {\n  width: 6px;\n}\n.custom-scrollbar::-webkit-scrollbar-thumb {\n  background-color: rgba(68, 102, 242, 0.15);\n}\n\n/**====== Custom scrollbar css end ======**/\n/**====== Animation css Start ======**/\n.comment {\n  color: #9f9ba5;\n  font-style: italic;\n}\n\n.line {\n  color: #2c323f;\n}\n.line pre {\n  font-size: 100%;\n}\n\n/**====== Animation css end ======**/\n/**====== list style css Start ======**/\n.list-circle {\n  list-style: circle;\n}\n\n/**====== list style css end ======**/\n/**====== Modal style css Start ======**/\n.theme-close {\n  opacity: 1;\n  height: 40px;\n  width: 40px;\n  position: absolute;\n  font-weight: 400;\n  z-index: 1;\n  right: 0;\n  background-color: #fff !important;\n  border-radius: 5px;\n}\n\n/**====== Modal style css end ======**/\n/**====== Animation css start ======**/\n.options > div {\n  color: #cccccc;\n  display: inline-block;\n  padding: 2px 10px;\n  border: 1px solid;\n  margin: 0 8px 8px 0;\n  transition: all 0.3s ease;\n}\n.options > div:hover {\n  background-color: #7366ff;\n  color: #fff;\n  transition: all 0.3s ease;\n}\n\n/**====== Animation css Ends ======**/\n.modal-footer {\n  flex-wrap: wrap;\n}\n\n.img-cropper #putData {\n  margin-bottom: 0;\n}\n.img-cropper .img-container {\n  min-height: auto;\n  margin-bottom: 0;\n}\n.img-cropper .docs-data > .input-group:last-child {\n  margin-bottom: 0;\n}\n.img-cropper .docs-preview {\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\n\n.dropzone .dz-preview .dz-error-message {\n  background: #fff !important;\n  color: #7366ff !important;\n  border: 1px solid #7366ff;\n}\n.dropzone .dz-preview .dz-error-message:after {\n  border-bottom: 6px solid #7366ff !important;\n}\n\n.typeahead .theme-form .form-group {\n  margin-bottom: 0;\n}\n\n.editor-statusbar {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.125);\n}\n\n.page-builder .ge-canvas.ge-editing .row {\n  padding: 30px;\n  margin-bottom: 0;\n  background-color: rgba(115, 102, 255, 0.02);\n}\n.page-builder .btn-screen {\n  padding: 0 18px 0 0;\n}\n\n.bg-overlay.active {\n  height: 100vh;\n  width: 100vw;\n  background-color: rgba(0, 0, 0, 0.2);\n  position: fixed;\n  z-index: 8;\n  top: 0;\n}\n\nbutton:focus {\n  outline: none !important;\n}\n\n.primary .svg-fill {\n  fill: var(--theme-default);\n}\n.primary .svg-fill:not(.half-circle) {\n  stroke: var(--theme-default);\n}\n.primary .bg-gradient {\n  background-image: linear-gradient(144.16deg, rgba(115, 102, 255, 0.1) 19.06%, rgba(115, 102, 255, 0) 79.03%) !important;\n}\n\n.secondary .svg-fill {\n  fill: var(--theme-secondary);\n}\n.secondary .svg-fill:not(.half-circle) {\n  stroke: var(--theme-secondary);\n}\n.secondary .bg-gradient {\n  background-image: linear-gradient(144.16deg, rgba(255, 51, 100, 0.1) 19.06%, rgba(255, 51, 100, 0) 79.03%) !important;\n}\n\n.success .svg-fill {\n  fill: #54ba4a;\n}\n.success .bg-gradient {\n  background-image: linear-gradient(144.16deg, rgba(84, 186, 74, 0.1) 19.06%, rgba(84, 186, 74, 0) 79.03%) !important;\n}\n\n.warning .svg-fill {\n  fill: #ffaa05;\n}\n.warning .bg-gradient {\n  background-image: linear-gradient(144.16deg, rgba(255, 170, 5, 0.1) 19.06%, rgba(255, 170, 5, 0) 79.03%) !important;\n}\n\n.dotted {\n  border-style: dotted;\n}\n\n.dashed {\n  border-style: dashed;\n}\n\n.double {\n  border-style: double;\n}\n\n.groove {\n  border-style: groove;\n}\n\n.ridge {\n  border-style: ridge;\n}\n\n.inset {\n  border-style: inset;\n}\n\n.outset {\n  border-style: outset;\n}\n\n@keyframes fadeIncustom {\n  0% {\n    opacity: 0;\n    top: 50px;\n  }\n  75% {\n    opacity: 0.6;\n    top: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.daterangepicker select.monthselect, .daterangepicker select.yearselect {\n  border-color: #efefef;\n  background-color: #fff;\n  font-size: 14px;\n  color: #898989;\n  padding: 5px 10px;\n  border-radius: 5px;\n  width: 46%;\n}\n\n.general-widget .cal-date-widget .datepicker {\n  padding: 0;\n}\n.general-widget .cal-date-widget .datepicker .react-datepicker {\n  background-color: transparent;\n  box-shadow: none;\n}\n\n.general-cal .cal-date-widget .react-datepicker {\n  background-color: transparent;\n  box-shadow: none;\n}\n\n/**=====================\n     Reset css Ends\n==========================**/\n.form-check-input:focus {\n  outline: none;\n  box-shadow: none;\n  border: none;\n}\n.form-check-input[type=checkbox] {\n  background-color: transparent;\n  border-color: transparent;\n}\n.form-check-input[type=checkbox]:checked {\n  background-color: transparent;\n  border-color: transparent;\n}\n\n.empty-cart-cls {\n  padding: 60px;\n}\n\n/**=====================\n    Typography css start\n==========================**/\nbody {\n  font-size: 14px;\n  overflow-x: hidden;\n  font-family: Rubik, sans-serif;\n  color: #2f2f3b;\n}\n\nul {\n  padding-left: 0px;\n  list-style-type: none;\n  margin-bottom: 0;\n}\n\n* a {\n  color: var(--theme-default);\n  text-decoration: none;\n  letter-spacing: 1px;\n}\n\na:hover {\n  text-decoration: none;\n  color: var(--theme-default);\n}\na[class*=badge-]:hover {\n  color: #fff;\n}\n\n.btn {\n  font-size: 14px;\n}\n\n*.btn:focus {\n  box-shadow: none !important;\n}\n\np {\n  font-size: 14px;\n  line-height: 1.7;\n  letter-spacing: 0.7px;\n}\n\ncode {\n  color: var(--theme-default) !important;\n  background-color: rgba(115, 102, 255, 0.03);\n  padding: 3px;\n  margin: 0 3px;\n  border-radius: 2px;\n}\n\n.media {\n  display: flex;\n  align-items: flex-start;\n}\n.media .media-body {\n  flex: 1;\n}\n\nblockquote {\n  border-left: 4px solid #ecf3fa;\n  padding: 15px;\n}\n\n.figure.text-center blockquote {\n  border: none !important;\n}\n.figure.text-end blockquote {\n  border-left: none !important;\n  border-right: 4px solid #ecf3fa;\n}\n\n.row > div {\n  position: relative;\n}\n\n:focus {\n  outline-color: var(--theme-default);\n}\n\n.disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\nsvg {\n  vertical-align: baseline;\n}\n\ninput:focus {\n  outline-color: transparent;\n}\n\nlabel {\n  margin-bottom: 0.5rem;\n}\n\n.media-widgets .media-body {\n  margin-bottom: 30px;\n}\n\n.typography h1,\n.typography .h1,\n.typography h2,\n.typography .h2,\n.typography h3,\n.typography .h3,\n.typography h4,\n.typography .h4,\n.typography h5,\n.typography .h5,\n.typography h6,\n.typography .h6 {\n  margin: 20px 0;\n  margin-top: 0;\n}\n.typography h1:last-child,\n.typography .h1:last-child,\n.typography h2:last-child,\n.typography .h2:last-child,\n.typography h3:last-child,\n.typography .h3:last-child,\n.typography h4:last-child,\n.typography .h4:last-child,\n.typography h5:last-child,\n.typography .h5:last-child,\n.typography h6:last-child,\n.typography .h6:last-child {\n  margin-bottom: 0;\n}\n.typography small, .typography .small {\n  padding-left: 10px;\n  color: #2c323f;\n}\n\npre {\n  background-color: rgba(115, 102, 255, 0.03);\n  padding: 20px 0;\n}\n\n.owl-theme .owl-dots .owl-dot span {\n  background: rgb(81.6993464052%, 80%, 100%);\n}\n.owl-theme .owl-dots .owl-dot.active span, .owl-theme .owl-dots .owl-dot:hover span {\n  background: var(--theme-default);\n}\n.owl-theme .owl-nav.disabled + .owl-dots {\n  margin-bottom: -10px;\n  margin-top: 25px;\n}\n\n.click2edit ~ .note-editor.note-frame {\n  margin-bottom: 30px;\n}\n\n.note-editor.note-frame {\n  border-color: #f4f4f4;\n}\n.note-editor.fullscreen .note-toolbar-wrapper {\n  height: 0 !important;\n}\n\n.note-editor.note-frame {\n  border-color: #f4f4f4;\n}\n\n.modal .modal-body .card {\n  box-shadow: none !important;\n}\n\n.modal-dialog .modal-content .modal-body p a {\n  margin-right: 0;\n}\n\n.notify-alert .close {\n  color: #fff;\n}\n[dir=rtl] .notify-alert .close {\n  right: unset !important;\n  left: 10px !important;\n}\n.notify-alert.alert-light .close {\n  color: #2f2f3b;\n}\n\n.alert-theme button {\n  top: 25px !important;\n  right: 20px !important;\n  color: var(--theme-default);\n}\n[dir=rtl] .alert-theme button {\n  right: unset !important;\n  left: 20px !important;\n}\n.alert-theme span + span + span {\n  background-color: #fff;\n  color: var(--theme-default);\n  border-radius: 4px;\n  box-shadow: 0 2px 14px -3px rgba(0, 0, 0, 0.2);\n}\n.alert-theme .close {\n  color: var(--theme-default);\n}\n.alert-theme i {\n  padding: 20px;\n  padding-right: 0 !important;\n  margin-right: 20px !important;\n}\n.alert-theme .progress {\n  margin-top: -2px !important;\n  height: 2px;\n  width: 100%;\n}\n.alert-theme .progress .progress-bar {\n  background-color: var(--theme-default);\n}\n\n.alert-copy {\n  border: 1px solid var(--theme-default);\n  line-height: 1;\n  display: inline-block;\n  width: 300px;\n  color: #fff;\n  background-color: var(--theme-default);\n}\n.alert-copy .close {\n  box-shadow: none;\n  color: #fff;\n  line-height: 1.4;\n  font-weight: 100;\n  top: -15px;\n}\n[dir=rtl] .alert-copy .close {\n  right: unset !important;\n  left: 10px !important;\n}\n.alert-copy .close:focus {\n  outline: none;\n}\n\n.ace-editor {\n  height: 400px;\n  width: 100%;\n}\n\n.editor-toolbar {\n  width: 100% !important;\n}\n.editor-toolbar.fullscreen {\n  z-index: 100;\n}\n\n.CodeMirror {\n  top: 0 !important;\n}\n\n.CodeMirror-fullscreen {\n  top: 50px !important;\n}\n\n.irs-from,\n.irs-to,\n.irs-single {\n  background: var(--theme-default);\n}\n.irs-from:after,\n.irs-to:after,\n.irs-single:after {\n  border-top-color: var(--theme-default);\n}\n\n.irs-line-mid,\n.irs-line-left,\n.irs-line-right,\n.irs-bar,\n.irs-bar-edge {\n  background-color: var(--theme-default);\n}\n\n.swal-button {\n  background-color: var(--theme-default);\n}\n.swal-button:active {\n  background-color: rgb(35.9477124183%, 30%, 100%);\n}\n\n.swal-button--cancel {\n  background-color: #efefee !important;\n}\n\n.clipboaard-container h6, .clipboaard-container .h6 {\n  line-height: 1.6;\n  font-size: 14px;\n}\n\nfieldset .bootstrap-touchspin-postfix,\nfieldset .bootstrap-touchspin-prefix {\n  border-radius: 0;\n  padding: 0.4rem 0.75rem;\n}\nfieldset .input-group-lg .touchspin {\n  height: 50px;\n}\n\n.f1 .f1-steps .f1-step .f1-step-icon {\n  padding: 12px;\n}\n\n.form-inline .form-group {\n  display: flex;\n}\n\n.input-group-text i {\n  line-height: 1.5;\n}\n\n.animated-modal .form-select {\n  display: inline-block;\n  width: auto;\n  vertical-align: middle;\n}\n\n/**=====================\n    Typography css Ends\n==========================**/\n/**=====================\n    24. According CSS start\n==========================**/\n.default-according .avatar-showcase {\n  margin-bottom: 0;\n}\n.default-according .card {\n  margin-bottom: 0;\n  box-shadow: none;\n}\n.default-according .card + .card {\n  margin-top: 10px;\n}\n.default-according .card .btn-link {\n  font-weight: 500;\n  color: #2f2f3b;\n  text-decoration: none;\n}\n.default-according .card .btn-link:focus, .default-according .card .btn-link:hover {\n  text-decoration: none;\n}\n.default-according .card .card-header {\n  padding: 0.75rem 1.25rem;\n  border: 1px solid #ecf3fa;\n}\n.default-according .card .card-header i {\n  position: absolute;\n  left: 18px;\n  font-size: 20px;\n  top: 20px;\n}\n.default-according .card .card-header h5, .default-according .card .card-header .h5 {\n  margin-top: 2px;\n}\n.default-according .card .card-body {\n  border: 1px solid #ecf3fa;\n  border-top: none;\n}\n\n.default-according.style-1 button {\n  width: 100%;\n  text-align: left;\n}\n.default-according.style-1 button:before {\n  right: 20px;\n  position: absolute;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n  font-size: 20px;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n@media (max-width: 575px) {\n  .default-according.style-1 button:before {\n    right: 15px;\n  }\n}\n.default-according.style-1 button[aria-expanded=true]:before {\n  content: \"\\eb73\";\n  font-family: IcoFont;\n}\n.default-according.style-1 button[aria-expanded=false]:before {\n  content: \"\\eb7a\";\n  font-family: IcoFont;\n}\n\n/**=====================\n     24. According CSS Ends\n==========================**/\n/**=====================\n     15. Alert CSS start\n==========================**/\n.notify-alert .close {\n  background: unset;\n  border: none;\n  font-size: 25px;\n}\n\n.alert {\n  border-radius: 0.15rem;\n  padding: 15px;\n}\n.alert svg {\n  vertical-align: middle;\n}\n.alert .progress {\n  margin-top: 15px;\n}\n.alert [data-notify=icon] {\n  margin-right: 10px;\n  line-height: 20px;\n  position: absolute;\n}\n.alert [data-notify=message] {\n  display: inline-block;\n  width: 100%;\n}\n.alert i {\n  margin-right: 5px;\n  font-size: 16px;\n}\n.alert p {\n  margin-bottom: 0;\n}\n.alert .close {\n  opacity: 1;\n}\n.alert .close span {\n  font-size: 24px;\n  font-weight: 400;\n  display: inline-block;\n  border-radius: 3px;\n  text-shadow: none;\n  padding: 0 5px;\n  padding-right: 0;\n}\n\n.alert-dismissible {\n  padding-right: 2.5rem;\n}\n[dir=rtl] .alert-dismissible {\n  padding-right: 15px;\n  padding-left: 2.5rem;\n}\n.alert-dismissible .close {\n  padding: 10px 1.25rem;\n  top: 4px;\n  padding-right: 13px;\n  opacity: 0.5;\n  transition: all 0.3s ease;\n}\n.alert-dismissible .close:hover {\n  transition: all 0.3s ease;\n  opacity: 1;\n  color: inherit;\n}\n\n.card-body button:focus {\n  outline: none;\n}\n.card-body .alert:last-child {\n  margin-bottom: 0;\n}\n.card-body .alert svg {\n  width: 14px;\n  height: 14px;\n  margin-right: 4px;\n  position: absolute;\n  top: 18px;\n}\n.card-body .alert svg ~ p {\n  padding-left: 20px;\n}\n\nstrong {\n  display: inline-block;\n}\nstrong ~ p {\n  display: inline-block;\n}\n\n.alert-primary {\n  background-color: rgba(115, 102, 255, 0.8);\n  border-color: rgba(115, 102, 255, 0.9);\n  color: #fff;\n}\n.alert-primary .progress {\n  height: 5px;\n  background-color: rgb(43.2679738562%, 38%, 100%);\n  border-radius: 0;\n}\n.alert-primary .progress-bar {\n  background-color: white;\n}\n.alert-primary .btn-close {\n  filter: brightness(1) invert(1);\n}\n.alert-primary .alert-link {\n  color: #7366ff;\n}\n.alert-primary hr {\n  border-top-color: #7366ff;\n}\n\n.alert-primary.dark .alert-link {\n  color: #fff;\n}\n.alert-primary.dark {\n  background-color: #7366ff;\n  border-color: #7366ff;\n  color: #fafafa;\n}\n\n.alert-primary.outline, .alert-primary.outline-2x {\n  background-color: transparent;\n  border-color: #7366ff;\n  color: #7366ff;\n}\n.alert-primary.outline .btn-close, .alert-primary.outline-2x .btn-close {\n  filter: unset;\n}\n\n.alert-primary.inverse:before {\n  top: 16px;\n  content: \"\";\n  position: absolute;\n  left: 54px;\n  width: 0;\n  height: 0;\n  border-left: 7px solid #7366ff;\n  border-top: 7px solid transparent;\n  border-bottom: 7px solid transparent;\n}\n@media (max-width: 576px) {\n  .alert-primary.inverse:before {\n    left: 45px;\n  }\n}\n.alert-primary.inverse {\n  background-color: transparent;\n  padding: 13px 20px 13px 65px;\n  border-color: #7366ff;\n  color: #2f2f3b;\n}\n.alert-primary.inverse i {\n  padding: 17px 20px;\n  display: inline-block;\n  background-color: #7366ff;\n  color: #fff;\n  border-radius: 3px 0 0 3px;\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n}\n@media (max-width: 576px) {\n  .alert-primary.inverse i {\n    padding: 17px 14px;\n  }\n}\n.alert-primary.inverse .btn-close {\n  filter: unset;\n  top: -3px;\n}\n\n.alert-secondary {\n  background-color: rgba(255, 51, 100, 0.8);\n  border-color: rgba(255, 51, 100, 0.9);\n  color: #fff;\n}\n.alert-secondary .progress {\n  height: 5px;\n  background-color: rgb(100%, 18%, 37.6960784314%);\n  border-radius: 0;\n}\n.alert-secondary .progress-bar {\n  background-color: white;\n}\n.alert-secondary .btn-close {\n  filter: brightness(1) invert(1);\n}\n.alert-secondary .alert-link {\n  color: #ff3364;\n}\n.alert-secondary hr {\n  border-top-color: #ff3364;\n}\n\n.alert-secondary.dark .alert-link {\n  color: #fff;\n}\n.alert-secondary.dark {\n  background-color: #ff3364;\n  border-color: #ff3364;\n  color: #fafafa;\n}\n\n.alert-secondary.outline, .alert-secondary.outline-2x {\n  background-color: transparent;\n  border-color: #ff3364;\n  color: #ff3364;\n}\n.alert-secondary.outline .btn-close, .alert-secondary.outline-2x .btn-close {\n  filter: unset;\n}\n\n.alert-secondary.inverse:before {\n  top: 16px;\n  content: \"\";\n  position: absolute;\n  left: 54px;\n  width: 0;\n  height: 0;\n  border-left: 7px solid #ff3364;\n  border-top: 7px solid transparent;\n  border-bottom: 7px solid transparent;\n}\n@media (max-width: 576px) {\n  .alert-secondary.inverse:before {\n    left: 45px;\n  }\n}\n.alert-secondary.inverse {\n  background-color: transparent;\n  padding: 13px 20px 13px 65px;\n  border-color: #ff3364;\n  color: #2f2f3b;\n}\n.alert-secondary.inverse i {\n  padding: 17px 20px;\n  display: inline-block;\n  background-color: #ff3364;\n  color: #fff;\n  border-radius: 3px 0 0 3px;\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n}\n@media (max-width: 576px) {\n  .alert-secondary.inverse i {\n    padding: 17px 14px;\n  }\n}\n.alert-secondary.inverse .btn-close {\n  filter: unset;\n  top: -3px;\n}\n\n.alert-success {\n  background-color: rgba(84, 186, 74, 0.8);\n  border-color: rgba(84, 186, 74, 0.9);\n  color: #fff;\n}\n.alert-success .progress {\n  height: 5px;\n  background-color: rgb(31.5876078431%, 72.3716078431%, 27.5891764706%);\n  border-radius: 0;\n}\n.alert-success .progress-bar {\n  background-color: white;\n}\n.alert-success .btn-close {\n  filter: brightness(1) invert(1);\n}\n.alert-success .alert-link {\n  color: #54ba4a;\n}\n.alert-success hr {\n  border-top-color: #54ba4a;\n}\n\n.alert-success.dark .alert-link {\n  color: #fff;\n}\n.alert-success.dark {\n  background-color: #54ba4a;\n  border-color: #54ba4a;\n  color: #fafafa;\n}\n\n.alert-success.outline, .alert-success.outline-2x {\n  background-color: transparent;\n  border-color: #54ba4a;\n  color: #54ba4a;\n}\n.alert-success.outline .btn-close, .alert-success.outline-2x .btn-close {\n  filter: unset;\n}\n\n.alert-success.inverse:before {\n  top: 16px;\n  content: \"\";\n  position: absolute;\n  left: 54px;\n  width: 0;\n  height: 0;\n  border-left: 7px solid #54ba4a;\n  border-top: 7px solid transparent;\n  border-bottom: 7px solid transparent;\n}\n@media (max-width: 576px) {\n  .alert-success.inverse:before {\n    left: 45px;\n  }\n}\n.alert-success.inverse {\n  background-color: transparent;\n  padding: 13px 20px 13px 65px;\n  border-color: #54ba4a;\n  color: #2f2f3b;\n}\n.alert-success.inverse i {\n  padding: 17px 20px;\n  display: inline-block;\n  background-color: #54ba4a;\n  color: #fff;\n  border-radius: 3px 0 0 3px;\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n}\n@media (max-width: 576px) {\n  .alert-success.inverse i {\n    padding: 17px 14px;\n  }\n}\n.alert-success.inverse .btn-close {\n  filter: unset;\n  top: -3px;\n}\n\n.alert-danger {\n  background-color: rgba(252, 68, 56, 0.8);\n  border-color: rgba(252, 68, 56, 0.9);\n  color: #fff;\n}\n.alert-danger .progress {\n  height: 5px;\n  background-color: rgb(98.7938264415%, 24.8151815182%, 19.990487284%);\n  border-radius: 0;\n}\n.alert-danger .progress-bar {\n  background-color: white;\n}\n.alert-danger .btn-close {\n  filter: brightness(1) invert(1);\n}\n.alert-danger .alert-link {\n  color: #fc4438;\n}\n.alert-danger hr {\n  border-top-color: #fc4438;\n}\n\n.alert-danger.dark .alert-link {\n  color: #fff;\n}\n.alert-danger.dark {\n  background-color: #fc4438;\n  border-color: #fc4438;\n  color: #fafafa;\n}\n\n.alert-danger.outline, .alert-danger.outline-2x {\n  background-color: transparent;\n  border-color: #fc4438;\n  color: #fc4438;\n}\n.alert-danger.outline .btn-close, .alert-danger.outline-2x .btn-close {\n  filter: unset;\n}\n\n.alert-danger.inverse:before {\n  top: 16px;\n  content: \"\";\n  position: absolute;\n  left: 54px;\n  width: 0;\n  height: 0;\n  border-left: 7px solid #fc4438;\n  border-top: 7px solid transparent;\n  border-bottom: 7px solid transparent;\n}\n@media (max-width: 576px) {\n  .alert-danger.inverse:before {\n    left: 45px;\n  }\n}\n.alert-danger.inverse {\n  background-color: transparent;\n  padding: 13px 20px 13px 65px;\n  border-color: #fc4438;\n  color: #2f2f3b;\n}\n.alert-danger.inverse i {\n  padding: 17px 20px;\n  display: inline-block;\n  background-color: #fc4438;\n  color: #fff;\n  border-radius: 3px 0 0 3px;\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n}\n@media (max-width: 576px) {\n  .alert-danger.inverse i {\n    padding: 17px 14px;\n  }\n}\n.alert-danger.inverse .btn-close {\n  filter: unset;\n  top: -3px;\n}\n\n.alert-warning {\n  background-color: rgba(255, 170, 5, 0.8);\n  border-color: rgba(255, 170, 5, 0.9);\n  color: #fff;\n}\n.alert-warning .progress {\n  height: 5px;\n  background-color: rgb(99.9607843137%, 65.9741176471%, 0%);\n  border-radius: 0;\n}\n.alert-warning .progress-bar {\n  background-color: white;\n}\n.alert-warning .btn-close {\n  filter: brightness(1) invert(1);\n}\n.alert-warning .alert-link {\n  color: #ffaa05;\n}\n.alert-warning hr {\n  border-top-color: #ffaa05;\n}\n\n.alert-warning.dark .alert-link {\n  color: #fff;\n}\n.alert-warning.dark {\n  background-color: #ffaa05;\n  border-color: #ffaa05;\n  color: #fafafa;\n}\n\n.alert-warning.outline, .alert-warning.outline-2x {\n  background-color: transparent;\n  border-color: #ffaa05;\n  color: #ffaa05;\n}\n.alert-warning.outline .btn-close, .alert-warning.outline-2x .btn-close {\n  filter: unset;\n}\n\n.alert-warning.inverse:before {\n  top: 16px;\n  content: \"\";\n  position: absolute;\n  left: 54px;\n  width: 0;\n  height: 0;\n  border-left: 7px solid #ffaa05;\n  border-top: 7px solid transparent;\n  border-bottom: 7px solid transparent;\n}\n@media (max-width: 576px) {\n  .alert-warning.inverse:before {\n    left: 45px;\n  }\n}\n.alert-warning.inverse {\n  background-color: transparent;\n  padding: 13px 20px 13px 65px;\n  border-color: #ffaa05;\n  color: #2f2f3b;\n}\n.alert-warning.inverse i {\n  padding: 17px 20px;\n  display: inline-block;\n  background-color: #ffaa05;\n  color: #fff;\n  border-radius: 3px 0 0 3px;\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n}\n@media (max-width: 576px) {\n  .alert-warning.inverse i {\n    padding: 17px 14px;\n  }\n}\n.alert-warning.inverse .btn-close {\n  filter: unset;\n  top: -3px;\n}\n\n.alert-info {\n  background-color: rgba(22, 199, 249, 0.8);\n  border-color: rgba(22, 199, 249, 0.9);\n  color: #fff;\n}\n.alert-info .progress {\n  height: 5px;\n  background-color: rgb(6.6776601854%, 77.5705964394%, 97.5968496185%);\n  border-radius: 0;\n}\n.alert-info .progress-bar {\n  background-color: white;\n}\n.alert-info .btn-close {\n  filter: brightness(1) invert(1);\n}\n.alert-info .alert-link {\n  color: #16c7f9;\n}\n.alert-info hr {\n  border-top-color: #16c7f9;\n}\n\n.alert-info.dark .alert-link {\n  color: #fff;\n}\n.alert-info.dark {\n  background-color: #16c7f9;\n  border-color: #16c7f9;\n  color: #fafafa;\n}\n\n.alert-info.outline, .alert-info.outline-2x {\n  background-color: transparent;\n  border-color: #16c7f9;\n  color: #16c7f9;\n}\n.alert-info.outline .btn-close, .alert-info.outline-2x .btn-close {\n  filter: unset;\n}\n\n.alert-info.inverse:before {\n  top: 16px;\n  content: \"\";\n  position: absolute;\n  left: 54px;\n  width: 0;\n  height: 0;\n  border-left: 7px solid #16c7f9;\n  border-top: 7px solid transparent;\n  border-bottom: 7px solid transparent;\n}\n@media (max-width: 576px) {\n  .alert-info.inverse:before {\n    left: 45px;\n  }\n}\n.alert-info.inverse {\n  background-color: transparent;\n  padding: 13px 20px 13px 65px;\n  border-color: #16c7f9;\n  color: #2f2f3b;\n}\n.alert-info.inverse i {\n  padding: 17px 20px;\n  display: inline-block;\n  background-color: #16c7f9;\n  color: #fff;\n  border-radius: 3px 0 0 3px;\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n}\n@media (max-width: 576px) {\n  .alert-info.inverse i {\n    padding: 17px 14px;\n  }\n}\n.alert-info.inverse .btn-close {\n  filter: unset;\n  top: -3px;\n}\n\n.alert-light {\n  background-color: rgba(244, 244, 244, 0.8);\n  border-color: rgba(244, 244, 244, 0.9);\n  color: #fff;\n}\n.alert-light .progress {\n  height: 5px;\n  background-color: rgb(94.6862745098%, 94.6862745098%, 94.6862745098%);\n  border-radius: 0;\n}\n.alert-light .progress-bar {\n  background-color: white;\n}\n.alert-light .btn-close {\n  filter: brightness(1) invert(1);\n}\n.alert-light .alert-link {\n  color: #f4f4f4;\n  color: #2c323f;\n}\n.alert-light {\n  color: #2c323f;\n  background-color: #f4f4f4;\n}\n.alert-light .btn-close {\n  filter: unset;\n}\n.alert-light hr {\n  border-top-color: #f4f4f4;\n}\n\n.alert-light.dark .alert-link {\n  color: #fff;\n  color: #2c323f;\n}\n.alert-light.dark {\n  background-color: #f4f4f4;\n  border-color: #f4f4f4;\n  color: #fafafa;\n  color: #2c323f;\n}\n\n.alert-light.outline, .alert-light.outline-2x {\n  background-color: transparent;\n  border-color: #f4f4f4;\n  color: #f4f4f4;\n}\n.alert-light.outline .btn-close, .alert-light.outline-2x .btn-close {\n  filter: unset;\n}\n.alert-light.outline, .alert-light.outline-2x {\n  color: #2c323f;\n}\n\n.alert-light.inverse:before {\n  top: 16px;\n  content: \"\";\n  position: absolute;\n  left: 54px;\n  width: 0;\n  height: 0;\n  border-left: 7px solid #f4f4f4;\n  border-top: 7px solid transparent;\n  border-bottom: 7px solid transparent;\n}\n@media (max-width: 576px) {\n  .alert-light.inverse:before {\n    left: 45px;\n  }\n}\n.alert-light.inverse {\n  background-color: transparent;\n  padding: 13px 20px 13px 65px;\n  border-color: #f4f4f4;\n  color: #2f2f3b;\n}\n.alert-light.inverse i {\n  padding: 17px 20px;\n  display: inline-block;\n  background-color: #f4f4f4;\n  color: #fff;\n  border-radius: 3px 0 0 3px;\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n}\n@media (max-width: 576px) {\n  .alert-light.inverse i {\n    padding: 17px 14px;\n  }\n}\n.alert-light.inverse .btn-close {\n  filter: unset;\n  top: -3px;\n}\n\n.alert-dark {\n  background-color: rgba(44, 50, 63, 0.8);\n  border-color: rgba(44, 50, 63, 0.9);\n  color: #fff;\n}\n.alert-dark .progress {\n  height: 5px;\n  background-color: rgb(16.4324720542%, 18.673263698%, 23.5283122595%);\n  border-radius: 0;\n}\n.alert-dark .progress-bar {\n  background-color: rgb(65.82737768%, 69.0819131391%, 76.1334066337%);\n}\n.alert-dark .btn-close {\n  filter: brightness(1) invert(1);\n}\n.alert-dark .alert-link {\n  color: #2c323f;\n}\n.alert-dark hr {\n  border-top-color: #2c323f;\n}\n\n.alert-dark.dark .alert-link {\n  color: #fff;\n}\n.alert-dark.dark {\n  background-color: #2c323f;\n  border-color: #2c323f;\n  color: #fafafa;\n}\n\n.alert-dark.outline, .alert-dark.outline-2x {\n  background-color: transparent;\n  border-color: #2c323f;\n  color: #2c323f;\n}\n.alert-dark.outline .btn-close, .alert-dark.outline-2x .btn-close {\n  filter: unset;\n}\n\n.alert-dark.inverse:before {\n  top: 16px;\n  content: \"\";\n  position: absolute;\n  left: 54px;\n  width: 0;\n  height: 0;\n  border-left: 7px solid #2c323f;\n  border-top: 7px solid transparent;\n  border-bottom: 7px solid transparent;\n}\n@media (max-width: 576px) {\n  .alert-dark.inverse:before {\n    left: 45px;\n  }\n}\n.alert-dark.inverse {\n  background-color: transparent;\n  padding: 13px 20px 13px 65px;\n  border-color: #2c323f;\n  color: #2f2f3b;\n}\n.alert-dark.inverse i {\n  padding: 17px 20px;\n  display: inline-block;\n  background-color: #2c323f;\n  color: #fff;\n  border-radius: 3px 0 0 3px;\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n}\n@media (max-width: 576px) {\n  .alert-dark.inverse i {\n    padding: 17px 14px;\n  }\n}\n.alert-dark.inverse .btn-close {\n  filter: unset;\n  top: -3px;\n}\n\n.dismiss-text .alert .btn-close {\n  background: unset;\n  opacity: 1;\n  top: -6px;\n  right: 40px;\n}\n.dismiss-text .alert .btn-close span {\n  display: inline-block;\n  border-radius: 3px;\n  text-shadow: none;\n  padding: 0 5px;\n}\n\n.outline-2x {\n  border-width: 2px;\n  padding: 11px 1.25rem;\n}\n\n/**=====================\n     15. Alert CSS end\n==========================**/\n/**=====================\n    80. avatars CSS start\n==========================**/\n.avatars .avatar {\n  display: inline-block;\n  margin-right: 10px;\n  position: relative;\n  width: auto;\n}\n.avatars .avatar:last-child {\n  margin-right: 0;\n}\n.avatars .avatar .b-r-30 {\n  border-radius: 30px;\n}\n.avatars .avatar .b-r-35 {\n  border-radius: 35px;\n}\n.avatars .avatar .b-r-25 {\n  border-radius: 25px;\n}\n.avatars .avatar .b-r-15 {\n  border-radius: 15px;\n}\n.avatars .avatar.ratio img {\n  width: auto;\n}\n.avatars .avatar .status {\n  position: absolute;\n  background-color: #999999;\n  bottom: 0;\n  right: 4px;\n  border-radius: 100%;\n  border: 1px solid #fff;\n}\n.avatars .avatar .status {\n  position: absolute;\n  height: 12%;\n  width: 12%;\n  background-color: #54ba4a;\n  border-radius: 100%;\n  bottom: 12%;\n  right: 4%;\n}\n\n.customers ul {\n  display: inline-block;\n}\n.customers ul li img {\n  border: 2px solid #fff;\n  transition: 0.5s;\n}\n.customers ul li img:hover {\n  transform: translateY(-4px) scale(1.02);\n  transition: 0.5s;\n}\n.customers ul li + li {\n  margin-left: -7%;\n}\n.customers.avatar-group {\n  margin-right: 30px;\n}\n.customers.avatar-group:last-child {\n  margin-right: 0;\n}\n\n.avatar-showcase {\n  margin-bottom: -10px;\n}\n.avatar-showcase .avatars .avatar {\n  margin-bottom: 10px;\n}\n.avatar-showcase .avatar-group {\n  margin-bottom: 10px;\n}\n.avatar-showcase .ratio > * {\n  position: relative;\n  top: unset;\n  left: unset;\n}\n.avatar-showcase .add-friend .d-block {\n  margin: 8px 0;\n}\n\n/**=====================\n     80. avatars CSS Ends\n==========================**/\n/**=====================\n    49. Badge CSS start\n==========================**/\n.badge {\n  padding: 0.44em 0.7em;\n  font-family: Roboto, sans-serif;\n  font-weight: 500;\n}\n.badge + .badge {\n  margin-left: 5px;\n}\n.badge svg {\n  width: 12px;\n  height: 12px;\n  padding-top: 3px;\n}\n\n.pill-badge-primary {\n  background-color: var(--theme-default);\n  box-shadow: -0.5px 4.33px 16px 0px rgba(var(--theme-default), 0.25);\n  color: #fff;\n  border-radius: 0;\n}\n\n.pill-badge-secondary {\n  background-color: #ff3364;\n  box-shadow: -0.5px 4.33px 16px 0px rgba(255, 51, 100, 0.25);\n  color: #fff;\n  border-radius: 0;\n}\n\n.pill-badge-success {\n  background-color: #54ba4a;\n  box-shadow: -0.5px 4.33px 16px 0px rgba(84, 186, 74, 0.25);\n  color: #fff;\n  border-radius: 0;\n}\n\n.pill-badge-danger {\n  background-color: #fc4438;\n  box-shadow: -0.5px 4.33px 16px 0px rgba(252, 68, 56, 0.25);\n  color: #fff;\n  border-radius: 0;\n}\n\n.pill-badge-info {\n  background-color: #16c7f9;\n  box-shadow: -0.5px 4.33px 16px 0px rgba(22, 199, 249, 0.25);\n  color: #fff;\n  border-radius: 0;\n}\n\n.pill-badge-light {\n  background-color: #f4f4f4;\n  box-shadow: -0.5px 4.33px 16px 0px rgba(244, 244, 244, 0.25);\n  color: #fff;\n  border-radius: 0;\n}\n\n.pill-badge-dark {\n  background-color: #2c323f;\n  box-shadow: -0.5px 4.33px 16px 0px rgba(44, 50, 63, 0.25);\n  color: #fff;\n  border-radius: 0;\n}\n\n.pill-badge-warning {\n  background-color: #ffaa05;\n  box-shadow: -0.5px 4.33px 16px 0px rgba(255, 170, 5, 0.25);\n  color: #fff;\n  border-radius: 0;\n}\n\n.pill-badge-primary {\n  background-color: var(--theme-default);\n}\n\n.pill-badge-secondary {\n  background-color: var(--theme-secondary);\n}\n\n.round-badge-primary {\n  border-radius: 6px;\n  background-color: var(--theme-default);\n  box-shadow: -0.5px -6.67px 14px 0px rgba(var(--theme-default), 0.18);\n  color: #fff !important;\n}\n\n.round-badge-secondary {\n  border-radius: 6px;\n  background-color: #ff3364;\n  box-shadow: -0.5px -6.67px 14px 0px rgba(255, 51, 100, 0.18);\n  color: #fff !important;\n}\n\n.round-badge-success {\n  border-radius: 6px;\n  background-color: #54ba4a;\n  box-shadow: -0.5px -6.67px 14px 0px rgba(84, 186, 74, 0.18);\n  color: #fff !important;\n}\n\n.round-badge-danger {\n  border-radius: 6px;\n  background-color: #fc4438;\n  box-shadow: -0.5px -6.67px 14px 0px rgba(252, 68, 56, 0.18);\n  color: #fff !important;\n}\n\n.round-badge-info {\n  border-radius: 6px;\n  background-color: #16c7f9;\n  box-shadow: -0.5px -6.67px 14px 0px rgba(22, 199, 249, 0.18);\n  color: #fff !important;\n}\n\n.round-badge-light {\n  border-radius: 6px;\n  background-color: #f4f4f4;\n  box-shadow: -0.5px -6.67px 14px 0px rgba(244, 244, 244, 0.18);\n  color: #fff !important;\n}\n\n.round-badge-dark {\n  border-radius: 6px;\n  background-color: #2c323f;\n  box-shadow: -0.5px -6.67px 14px 0px rgba(44, 50, 63, 0.18);\n  color: #fff !important;\n}\n\n.round-badge-warning {\n  border-radius: 6px;\n  background-color: #ffaa05;\n  box-shadow: -0.5px -6.67px 14px 0px rgba(255, 170, 5, 0.18);\n  color: #fff !important;\n}\n\n.round-badge-primary {\n  background-color: var(--theme-default);\n}\n\n.round-badge-secondary {\n  background-color: var(--theme-secondary);\n}\n\n/**=====================\n    49. Badge CSS Ends\n==========================**/\n/**=====================\n    81. Bookmark CSS start\n==========================**/\n.bookmark ul li {\n  display: inline-block;\n}\n.bookmark ul li .search-form {\n  position: absolute;\n  bottom: 53px;\n  z-index: 1;\n}\n.bookmark ul li .search-form .form-control-search {\n  top: 65px;\n  position: absolute;\n  transition: all linear 0.3s;\n  right: -20px;\n  transform: translateY(-35px) scaleY(0);\n  opacity: 0;\n  visibility: hidden;\n}\n.bookmark ul li .search-form .form-control-search input {\n  width: 240px;\n  background-color: #fff;\n  box-shadow: 0 5px 21px rgba(0, 0, 0, 0.1);\n}\n.bookmark ul li .search-form .form-control-search.open {\n  transform: translateY(0px) scaleY(1);\n  opacity: 1;\n  visibility: visible;\n  transition: all linear 0.3s;\n  z-index: 100;\n}\n.bookmark ul li .search-form .form-control-search:after {\n  top: 12px;\n  left: 20px;\n  z-index: 1;\n}\n.bookmark ul li .search-form .form-control-search:before {\n  left: 50px;\n  top: 9px;\n  z-index: 2;\n}\n.bookmark ul li a {\n  position: relative;\n  color: #2f2f3b;\n}\n.bookmark ul li a svg {\n  vertical-align: middle;\n  height: 20px;\n  width: 20px;\n}\n.bookmark ul li + li {\n  margin-left: 10px;\n}\n.bookmark ul li:last-child {\n  padding-right: 0;\n}\n.bookmark ul li:last-child a {\n  border-radius: 5px;\n}\n.bookmark ul li:last-child a svg {\n  color: #ff9f40;\n}\n\n.offcanvas-bookmark.page-wrapper.horizontal-wrapper .page-body-wrapper .page-body .bookmark ul li a {\n  z-index: 99999;\n  color: rgba(255, 255, 255, 0.5);\n}\n.offcanvas-bookmark:before {\n  position: fixed;\n  content: \"\";\n  background-color: rgba(0, 0, 0, 0.5);\n  height: 100%;\n  width: 100%;\n  z-index: 1;\n  right: 0;\n  left: 0;\n}\n\nbody.modal-open .select2-container--open {\n  width: unset !important;\n  display: block;\n}\nbody.modal-open .select2-container--open .select2-dropdown {\n  z-index: 1076;\n}\n\n/**=====================\n    81. Bookmark CSS Ends\n==========================**/\n/**=====================\n    57. breadcrumb CSS Start\n==========================**/\n.breadcrumb-colored {\n  padding: 12px 16px;\n  border-radius: 4px;\n}\n.breadcrumb-colored li a {\n  color: #fff;\n}\n.breadcrumb-colored li.active {\n  color: #fff;\n  opacity: 0.7;\n}\n.breadcrumb-colored .breadcrumb-item:before {\n  color: #fff;\n}\n.breadcrumb-colored .breadcrumb-item.txt-dark:before {\n  color: #000;\n}\n\n.breadcrumb-icon {\n  --bs-breadcrumb-divider: '>';\n}\n.breadcrumb-icon li {\n  display: inline-block;\n}\n\n.breadcrumb-no-divider {\n  --bs-breadcrumb-divider: '';\n}\n\n.breadcrumb-item.active {\n  text-transform: capitalize;\n}\n\n/**=====================\n    57. breadcrumb CSS ends\n==========================**/\n/**=====================\n     35. Form builder css start\n==========================**/\n.form-builder .help-block {\n  margin-bottom: 0;\n  color: #cccccc;\n  text-transform: capitalize;\n}\n.form-builder .btn-light {\n  color: #cccccc;\n}\n.form-builder .copy-btn {\n  padding: 8px;\n}\n.form-builder .nav-primary .nav-link.active, .form-builder .nav-primary .nav-primary .show > .nav-link, .form-builder .nav-primary .nav-pills.nav-primary .nav-link.active, .form-builder .nav-primary .nav-pills.nav-primary .show > .nav-link {\n  border-radius: 5px;\n}\n.form-builder .nav-primary .nav-link, .form-builder .nav-primary .nav-pills.nav-primary .nav-link {\n  color: #000;\n  font-weight: 500;\n}\n.form-builder .theme-form {\n  margin-top: 30px;\n}\n\n/**=====================\n    35. Form builder css Ends\n==========================**/\n/**=====================\n    06. Button CSS start\n==========================**/\n.btn-link {\n  color: var(--theme-default);\n}\n\n.purchase-btn {\n  background: linear-gradient(90deg, var(--theme-default) -18.33%, #563ee0 62.78%);\n  padding: 12px 20px;\n  min-width: 200px;\n  border: none;\n  transition: 0.5s;\n}\n.purchase-btn:hover {\n  background: linear-gradient(90deg, #563ee0 -18.33%, var(--theme-default) 62.78%);\n  transition: 0.5s;\n}\n@media (max-width: 991px) {\n  .purchase-btn {\n    min-width: 160px;\n  }\n}\n@media (max-width: 767px) {\n  .purchase-btn {\n    min-width: 140px;\n    padding: 10px 17px;\n    font-size: 16px;\n  }\n}\n\n.btn-light:not([disabled]):not(.disabled).active.active {\n  color: #2f2f3b;\n  background-color: rgb(93.6862745098%, 93.6862745098%, 93.6862745098%) !important;\n}\n\n.btn-primary-gradien {\n  background-image: linear-gradient(to right, rgb(59.7385620915%, 56%, 100%) 0%, rgb(30.4575163399%, 24%, 100%) 51%, rgb(59.7385620915%, 56%, 100%) 100%);\n  border: none;\n  color: #fff;\n  background-size: auto 200%;\n  transition: all 0.3s ease;\n  color: #fff;\n}\n.btn-primary-gradien:focus, .btn-primary-gradien:active, .btn-primary-gradien.active {\n  transition: 1.5s;\n  background-position: right center;\n  background-image: linear-gradient(to right, rgb(59.7385620915%, 56%, 100%), 0%, rgb(30.4575163399%, 24%, 100%), 100%, #fff) !important;\n}\n\n.btn-secondary-gradien {\n  background-image: linear-gradient(to right, rgb(100%, 36%, 51.3725490196%) 0%, rgb(100%, 4%, 27.0588235294%) 51%, rgb(100%, 36%, 51.3725490196%) 100%);\n  border: none;\n  color: #fff;\n  background-size: auto 200%;\n  transition: all 0.3s ease;\n}\n.btn-secondary-gradien:hover, .btn-secondary-gradien:focus, .btn-secondary-gradien:active, .btn-secondary-gradien.active, .btn-secondary-gradien.hover {\n  transition: 1.5s;\n  background-position: right center;\n  background-image: linear-gradient(to right, rgb(100%, 36%, 51.3725490196%), 0%, rgb(100%, 4%, 27.0588235294%), 100%, #fff) !important;\n}\n\n.btn-success-gradien {\n  background-image: linear-gradient(to right, rgb(43.8851764706%, 77.3571764706%, 40.6036078431%) 0%, rgb(27.1636078431%, 62.2356078431%, 23.7251764706%) 51%, rgb(43.8851764706%, 77.3571764706%, 40.6036078431%) 100%);\n  border: none;\n  color: #fff;\n  background-size: auto 200%;\n  transition: all 0.3s ease;\n}\n.btn-success-gradien:hover, .btn-success-gradien:focus, .btn-success-gradien:active, .btn-success-gradien.active, .btn-success-gradien.hover {\n  transition: 1.5s;\n  background-position: right center;\n  background-image: linear-gradient(to right, rgb(43.8851764706%, 77.3571764706%, 40.6036078431%), 0%, rgb(27.1636078431%, 62.2356078431%, 23.7251764706%), 100%, #fff) !important;\n}\n\n.btn-danger-gradien {\n  background-image: linear-gradient(to right, rgb(99.0611531741%, 41.4785478548%, 37.7231605513%) 0%, rgb(98.5859056494%, 11.8547854785%, 6.1984080761%) 51%, rgb(99.0611531741%, 41.4785478548%, 37.7231605513%) 100%);\n  border: none;\n  color: #fff;\n  background-size: auto 200%;\n  transition: all 0.3s ease;\n}\n.btn-danger-gradien:hover, .btn-danger-gradien:focus, .btn-danger-gradien:active, .btn-danger-gradien.active, .btn-danger-gradien.hover {\n  transition: 1.5s;\n  background-position: right center;\n  background-image: linear-gradient(to right, rgb(99.0611531741%, 41.4785478548%, 37.7231605513%), 0%, rgb(98.5859056494%, 11.8547854785%, 6.1984080761%), 100%, #fff) !important;\n}\n\n.btn-warning-gradien {\n  background-image: linear-gradient(to right, rgb(100%, 72.1066666667%, 17.9607843137%) 0%, rgb(85.9607843137%, 56.7341176471%, 0%) 51%, rgb(100%, 72.1066666667%, 17.9607843137%) 100%);\n  border: none;\n  color: #fff;\n  background-size: auto 200%;\n  transition: all 0.3s ease;\n}\n.btn-warning-gradien:hover, .btn-warning-gradien:focus, .btn-warning-gradien:active, .btn-warning-gradien.active, .btn-warning-gradien.hover {\n  transition: 1.5s;\n  background-position: right center;\n  background-image: linear-gradient(to right, rgb(100%, 72.1066666667%, 17.9607843137%), 0%, rgb(85.9607843137%, 56.7341176471%, 0%), 100%, #fff) !important;\n}\n\n.btn-info-gradien {\n  background-image: linear-gradient(to right, rgb(24.2257773402%, 81.7881696612%, 98.0487324637%) 0%, rgb(2.2663056855%, 69.1223234063%, 88.0082041185%) 51%, rgb(24.2257773402%, 81.7881696612%, 98.0487324637%) 100%);\n  border: none;\n  color: #fff;\n  background-size: auto 200%;\n  transition: all 0.3s ease;\n}\n.btn-info-gradien:hover, .btn-info-gradien:focus, .btn-info-gradien:active, .btn-info-gradien.active, .btn-info-gradien.hover {\n  transition: 1.5s;\n  background-position: right center;\n  background-image: linear-gradient(to right, rgb(24.2257773402%, 81.7881696612%, 98.0487324637%), 0%, rgb(2.2663056855%, 69.1223234063%, 88.0082041185%), 100%, #fff) !important;\n}\n\n.btn-light-gradien {\n  background-image: linear-gradient(to right, white 0%, rgb(87.6862745098%, 87.6862745098%, 87.6862745098%) 51%, white 100%);\n  border: none;\n  color: #fff;\n  background-size: auto 200%;\n  transition: all 0.3s ease;\n}\n.btn-light-gradien:hover, .btn-light-gradien:focus, .btn-light-gradien:active, .btn-light-gradien.active, .btn-light-gradien.hover {\n  transition: 1.5s;\n  background-position: right center;\n  background-image: linear-gradient(to right, white, 0%, rgb(87.6862745098%, 87.6862745098%, 87.6862745098%), 100%, #fff) !important;\n}\n\n.btn-dark-gradien {\n  background-image: linear-gradient(to right, rgb(23.8343412131%, 27.0844786513%, 34.1264431006%) 0%, rgb(10.6754627084%, 12.1312076232%, 15.2853216053%) 51%, rgb(23.8343412131%, 27.0844786513%, 34.1264431006%) 100%);\n  border: none;\n  color: #fff;\n  background-size: auto 200%;\n  transition: all 0.3s ease;\n}\n.btn-dark-gradien:hover, .btn-dark-gradien:focus, .btn-dark-gradien:active, .btn-dark-gradien.active, .btn-dark-gradien.hover {\n  transition: 1.5s;\n  background-position: right center;\n  background-image: linear-gradient(to right, rgb(23.8343412131%, 27.0844786513%, 34.1264431006%), 0%, rgb(10.6754627084%, 12.1312076232%, 15.2853216053%), 100%, #fff) !important;\n}\n\n.btn {\n  padding: 0.375rem 1.75rem;\n}\n\n.btn-lg, .btn-group-lg > .btn {\n  font-size: 18px;\n}\n\n.btn-sm, .btn-group-sm > .btn {\n  font-size: 12px;\n}\n\n.btn-xs {\n  padding: 0.05rem 0.4rem;\n  font-size: 11px;\n}\n\n.large-btn .btn {\n  margin-right: 5px;\n  margin-bottom: 15px;\n}\n.large-btn {\n  margin-bottom: -20px;\n}\n\n.btn-outline-white {\n  border: 1px solid #fff;\n  color: #fff;\n}\n.btn-outline-white:hover, .btn-outline-white:focus {\n  background: #fff;\n  color: #212529;\n}\n\n.btn-air-primary {\n  box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;\n}\n.btn-air-primary:hover, .btn-air-primary:active, .btn-air-primary:not([disabled]):not(.disabled):active {\n  background-color: rgb(26.7973856209%, 20%, 100%);\n  border-color: rgb(26.7973856209%, 20%, 100%);\n}\n\n.input-air-primary {\n  box-shadow: 0 3px 5px 1px rgba(115, 102, 255, 0.1) !important;\n}\n.input-air-primary:focus {\n  border-color: #7366ff;\n}\n\n.btn-air-secondary {\n  box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;\n}\n.btn-air-secondary:hover, .btn-air-secondary:active, .btn-air-secondary:not([disabled]):not(.disabled):active {\n  background-color: rgb(100%, 0%, 24.0196078431%);\n  border-color: rgb(100%, 0%, 24.0196078431%);\n}\n\n.input-air-secondary {\n  box-shadow: 0 3px 5px 1px rgba(255, 51, 100, 0.1) !important;\n}\n.input-air-secondary:focus {\n  border-color: #ff3364;\n}\n\n.btn-air-success {\n  box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;\n}\n.btn-air-success:hover, .btn-air-success:active, .btn-air-success:not([disabled]):not(.disabled):active {\n  background-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%);\n  border-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%);\n}\n\n.input-air-success {\n  box-shadow: 0 3px 5px 1px rgba(84, 186, 74, 0.1) !important;\n}\n.input-air-success:focus {\n  border-color: #54ba4a;\n}\n\n.btn-air-danger {\n  box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;\n}\n.btn-air-danger:hover, .btn-air-danger:active, .btn-air-danger:not([disabled]):not(.disabled):active {\n  background-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%);\n  border-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%);\n}\n\n.input-air-danger {\n  box-shadow: 0 3px 5px 1px rgba(252, 68, 56, 0.1) !important;\n}\n.input-air-danger:focus {\n  border-color: #fc4438;\n}\n\n.btn-air-info {\n  box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;\n}\n.btn-air-info:hover, .btn-air-info:active, .btn-air-info:not([disabled]):not(.disabled):active {\n  background-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%);\n  border-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%);\n}\n\n.input-air-info {\n  box-shadow: 0 3px 5px 1px rgba(22, 199, 249, 0.1) !important;\n}\n.input-air-info:focus {\n  border-color: #16c7f9;\n}\n\n.btn-air-light {\n  box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;\n}\n.btn-air-light:hover, .btn-air-light:active, .btn-air-light:not([disabled]):not(.disabled):active {\n  background-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%);\n  border-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%);\n}\n\n.input-air-light {\n  box-shadow: 0 3px 5px 1px rgba(244, 244, 244, 0.1) !important;\n}\n.input-air-light:focus {\n  border-color: #f4f4f4;\n}\n\n.btn-air-dark {\n  box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;\n}\n.btn-air-dark:hover, .btn-air-dark:active, .btn-air-dark:not([disabled]):not(.disabled):active {\n  background-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%);\n  border-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%);\n}\n\n.input-air-dark {\n  box-shadow: 0 3px 5px 1px rgba(44, 50, 63, 0.1) !important;\n}\n.input-air-dark:focus {\n  border-color: #2c323f;\n}\n\n.btn-air-warning {\n  box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;\n}\n.btn-air-warning:hover, .btn-air-warning:active, .btn-air-warning:not([disabled]):not(.disabled):active {\n  background-color: rgb(81.9607843137%, 54.0941176471%, 0%);\n  border-color: rgb(81.9607843137%, 54.0941176471%, 0%);\n}\n\n.input-air-warning {\n  box-shadow: 0 3px 5px 1px rgba(255, 170, 5, 0.1) !important;\n}\n.input-air-warning:focus {\n  border-color: #ffaa05;\n}\n\n.btn-gradient {\n  color: #fff !important;\n  font-weight: 500;\n  padding: 10px 30px;\n  border-radius: 5px;\n  background: linear-gradient(26deg, var(--theme-default) 0%, #a26cf8 100%);\n  letter-spacing: 0.06rem;\n}\n.btn-gradient:hover {\n  background-size: 100% !important;\n}\n\n.btn-warning {\n  color: #fff;\n}\n.btn-warning:hover, .btn-warning.disabled {\n  color: #fff;\n}\n\n[class*=-gradien]:hover {\n  background-size: 50% 100%;\n  transition: all 0.3s ease;\n  color: #fff;\n}\n\n.btn-square {\n  border-radius: 0px;\n}\n\n.btn-pill {\n  border-radius: 60px;\n}\n\n.btn-group-pill .btn:first-child {\n  border-radius: 60px 0 0 60px;\n}\n.btn-group-pill .btn:last-child {\n  border-radius: 0 60px 60px 0;\n}\n\n.btn-group-square .btn:first-child {\n  border-radius: 0px 0 0 0px;\n}\n.btn-group-square .btn:last-child {\n  border-radius: 0 0px 0px 0;\n}\n\n.btn-showcase .btn {\n  margin-bottom: 10px;\n  margin-right: 10px;\n}\n.btn-showcase {\n  margin-bottom: -10px;\n}\n\n.btn-dropdown-showcase .dropdown {\n  margin-bottom: 10px;\n  margin-right: 18px;\n}\n.btn-dropdown-showcase .btn-group {\n  margin-bottom: 10px;\n  margin-right: 18px;\n}\n.btn-dropdown-showcase {\n  margin-bottom: -10px;\n}\n\n.btn-group .radio label::before {\n  top: 2px;\n}\n.btn-group .radio label::after {\n  top: 7px;\n}\n.btn-group .checkbox label {\n  margin-top: 3px;\n}\n\n.btn-group-showcase > div {\n  margin-bottom: -20px;\n}\n.btn-group-showcase > div label {\n  margin-bottom: 0;\n}\n.btn-group-showcase .btn-group {\n  margin-right: 20px;\n  margin-bottom: 20px;\n}\n.btn-group-showcase .checkbox input[type=checkbox] {\n  display: none;\n}\n\n.tooltiptext {\n  visibility: visible;\n  width: 120px;\n  background-color: #555;\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 5px 0;\n  position: absolute;\n  z-index: 1;\n  bottom: 125%;\n  left: 50%;\n  margin-left: -60px;\n  opacity: 1;\n  transition: opacity 0.3s;\n}\n.tooltiptext::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: #555 transparent transparent transparent;\n}\n\n/**=====================\n     06. Button CSS end\n==========================**/\n/**=====================\n    03.  Card CSS Start\n==========================**/\n.card {\n  margin-bottom: 30px;\n  border: none;\n  transition: all 0.3s ease;\n  letter-spacing: 0.5px;\n  border-radius: 15px;\n  box-shadow: 0px 9px 20px rgba(46, 35, 94, 0.07);\n}\n.card:hover {\n  box-shadow: 0 0 40px rgba(8, 21, 66, 0.05);\n  transition: all 0.3s ease;\n}\n.card .card-header {\n  background-color: #fff;\n  padding: 30px;\n  border-bottom: 1px solid #ecf3fa;\n  border-top-left-radius: 15px;\n  border-top-right-radius: 15px;\n  position: relative;\n}\n.card .card-header.card-no-border {\n  border-bottom: none !important;\n}\n.card .card-header h5:not(.mb-0), .card .card-header .h5:not(.mb-0), .card .card-header h5:not(.m-0), .card .card-header .h5:not(.m-0) {\n  margin-bottom: 0;\n  text-transform: capitalize;\n}\n.card .card-header > span {\n  font-size: 12px;\n  color: #52526c;\n  margin-top: 5px;\n  display: block;\n  letter-spacing: 1px;\n}\n.card .card-header .card-header-right {\n  border-radius: 0 0 0 7px;\n  right: 35px;\n  top: 24px;\n  display: inline-block;\n  float: right;\n  padding: 8px 0;\n  position: absolute;\n  background-color: #fff;\n  z-index: 1;\n}\n.card .card-header .card-header-right .card-option {\n  text-align: right;\n  width: 35px;\n  height: 20px;\n  overflow: hidden;\n  transition: 0.3s ease-in-out;\n}\n.card .card-header .card-header-right .card-option li {\n  display: inline-block;\n}\n.card .card-header .card-header-right .card-option li:first-child i {\n  transition: 1s;\n  font-size: 16px;\n  color: var(--theme-default);\n}\n.card .card-header .card-header-right .card-option li:first-child i.icofont {\n  color: unset;\n}\n.card .card-header .card-header-right i {\n  margin: 0 5px;\n  cursor: pointer;\n  color: #2c323f;\n  line-height: 20px;\n}\n.card .card-header .card-header-right i.icofont-refresh {\n  font-size: 13px;\n}\n.card .card-body {\n  padding: 30px;\n  background-color: transparent;\n}\n.card .card-body p:last-child {\n  margin-bottom: 0;\n}\n.card .sub-title {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  padding-bottom: 5px;\n  margin-bottom: 8px;\n  font-size: 18px;\n}\n.card .card-footer {\n  background-color: #fff;\n  border-top: 1px solid #ecf3fa;\n  padding: 30px;\n  border-bottom-left-radius: 15px;\n  border-bottom-right-radius: 15px;\n}\n.card.card-load .card-loader {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  background-color: rgba(255, 255, 255, 0.7);\n  z-index: 8;\n  align-items: center;\n  justify-content: center;\n}\n.card.card-load .card-loader i {\n  margin: 0 auto;\n  color: var(--theme-default);\n  font-size: 20px;\n}\n.card.full-card {\n  position: fixed;\n  top: 0;\n  z-index: 99999;\n  box-shadow: none;\n  right: 0;\n  border-radius: 0;\n  border: 1px solid #efefef;\n  width: calc(100vw - 12px);\n  height: 100vh;\n}\n.card.full-card .card-body {\n  overflow: auto;\n}\n\n.page-body-wrapper .card .sub-title {\n  font-family: Rubik, sans-serif;\n  font-weight: normal;\n  color: #52526c;\n}\n\n.card-absolute {\n  margin-top: 20px;\n}\n.card-absolute .card-header {\n  position: absolute;\n  top: -20px;\n  left: 15px;\n  border-radius: 0.25rem;\n  padding: 10px 15px;\n}\n.card-absolute .card-header h5, .card-absolute .card-header .h5 {\n  font-size: 17px;\n}\n.card-absolute .card-body {\n  margin-top: 10px;\n}\n\n.card-header .border-tab {\n  margin-bottom: -13px;\n}\n\n.custom-card {\n  overflow: hidden;\n  padding: 30px;\n}\n.custom-card .card-header {\n  padding: 0;\n}\n.custom-card .card-header img {\n  border-radius: 50%;\n  margin-top: -100px;\n  transform: scale(1.5);\n}\n.custom-card .card-profile {\n  text-align: center;\n}\n.custom-card .card-profile img {\n  height: 110px;\n  padding: 7px;\n  background-color: #fff;\n  z-index: 1;\n  position: relative;\n}\n.custom-card .card-social {\n  text-align: center;\n}\n.custom-card .card-social li {\n  display: inline-block;\n  padding: 15px 0;\n}\n.custom-card .card-social li:last-child a {\n  margin-right: 0;\n}\n.custom-card .card-social li a {\n  padding: 0;\n  margin-right: 15px;\n  color: rgb(188, 198, 222);\n  font-size: 16px;\n  transition: all 0.3s ease;\n}\n.custom-card .card-social li a:hover {\n  color: var(--theme-default);\n  transition: all 0.3s ease;\n}\n.custom-card .profile-details h6, .custom-card .profile-details .h6 {\n  margin-bottom: 30px;\n  margin-top: 10px;\n  color: #52526c;\n  font-size: 14px;\n}\n.custom-card .card-footer {\n  padding: 0;\n}\n.custom-card .card-footer > div + div {\n  border-left: 1px solid #efefef;\n}\n.custom-card .card-footer > div {\n  padding: 15px;\n  text-align: center;\n}\n.custom-card .card-footer > div h3, .custom-card .card-footer > div .h3 {\n  margin-bottom: 0;\n  font-size: 24px;\n}\n.custom-card .card-footer > div h6, .custom-card .card-footer > div .h6 {\n  font-size: 14px;\n  color: #52526c;\n}\n.custom-card .card-footer > div h5, .custom-card .card-footer > div .h5 {\n  font-size: 16px;\n  margin-bottom: 0;\n}\n.custom-card .card-footer > div i {\n  font-size: 24px;\n  display: inline-block;\n  margin-bottom: 15px;\n}\n.custom-card .card-footer > div .m-b-card {\n  margin-bottom: 10px;\n}\n\n.social-profile {\n  text-align: center;\n  background-image: url(../../images/dashboard-5/profile-bg.png);\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n.social-profile .card-body {\n  padding-left: 20px;\n  padding-right: 20px;\n}\n@media (max-width: 1399px) {\n  .social-profile .card-body {\n    padding: 23px 15px;\n  }\n}\n.social-details {\n  margin-top: 15px;\n}\n.social-details h5 a, .social-details .h5 a {\n  color: var(--body-font-color);\n}\n.social-details .social-follow {\n  column-count: 3;\n  column-gap: 30px;\n  margin-top: 25px;\n}\n@media (max-width: 1399px) {\n  .social-details .social-follow {\n    column-gap: 23px;\n  }\n}\n.social-details .social-follow li {\n  position: relative;\n}\n.social-details .social-follow li + li::before {\n  position: absolute;\n  content: \"\";\n  width: 1px;\n  height: 14px;\n  background-color: var(--recent-dashed-border);\n  left: -15px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n[dir=rtl] .social-details .social-follow li + li::before {\n  left: unset;\n  right: -15px;\n}\n.social-details .card-social {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  margin-top: 15px;\n}\n.social-img-wrap {\n  background: linear-gradient(253deg, var(--theme-default) 11.51%, rgba(115, 102, 255, 0) 82.07%);\n  display: inline-block;\n  border-radius: 100%;\n  padding: 2px;\n  position: relative;\n}\n.social-img-wrap .edit-icon {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n}\n.social-img-wrap .edit-icon svg {\n  width: 20px;\n  height: 20px;\n  border-radius: 100%;\n  border: 2px solid var(--white);\n  background: var(--white);\n}\n.social-img {\n  padding: 5px;\n  background: var(--white);\n  border-radius: 100%;\n}\n.social-img img {\n  height: 68px;\n  border-radius: 100%;\n}\n\n/**=====================\n    03. Card CSS End\n==========================**/\n/**=====================\n     07. Color CSS Start\n==========================**/\n.color-box {\n  margin-bottom: -10px;\n}\n.color-box button {\n  margin-bottom: 10px;\n}\n.color-box button + button {\n  margin-left: 5px;\n}\n\n.light-font {\n  color: #52526c;\n}\n\n/**=====================\n     07. Color CSS Ends\n==========================**/\n/**=====================\n    52. Datepicker CSS Start\n==========================**/\n.react-datepicker-popper {\n  z-index: 2 !important;\n}\n\n.react-datepicker-wrapper {\n  display: block !important;\n}\n\n.date-picker .react-datepicker__navigation {\n  top: 8px;\n}\n.date-picker .theme-form .input-group {\n  display: block !important;\n}\n.date-picker .theme-form .min-date .react-datepicker-wrapper {\n  display: inline-block !important;\n}\n\n.react-datepicker__day--keyboard-selected,\n.react-datepicker__month-text--keyboard-selected,\n.react-datepicker__quarter-text--keyboard-selected,\n.react-datepicker__year-text--keyboard-selected {\n  background-color: var(--theme-default);\n}\n.react-datepicker__day--keyboard-selected:hover,\n.react-datepicker__month-text--keyboard-selected:hover,\n.react-datepicker__quarter-text--keyboard-selected:hover,\n.react-datepicker__year-text--keyboard-selected:hover {\n  background-color: var(--theme-default);\n}\n\n.react-datepicker {\n  border: none !important;\n  box-shadow: 0 4px 24px rgba(115, 102, 255, 0.08);\n}\n.react-datepicker .react-datepicker__navigation-icon--previous::before,\n.react-datepicker .react-datepicker__navigation-icon--next::before {\n  border-color: #fff;\n}\n.react-datepicker .react-datepicker__time-container {\n  border-left: 1px solid #efefef;\n}\n.react-datepicker .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n  background-color: var(--theme-default) !important;\n}\n.react-datepicker .react-datepicker__today-button {\n  background-color: #fff !important;\n  border-top: 1px solid #efefef;\n}\n.react-datepicker .react-datepicker__triangle {\n  display: none;\n}\n.react-datepicker .react-datepicker__header {\n  background-color: transparent !important;\n  border-bottom: 1px solid #efefef;\n}\n.react-datepicker .react-datepicker__day-name {\n  font-weight: 600;\n}\n.react-datepicker .react-datepicker__current-month {\n  margin-bottom: 10px;\n}\n.react-datepicker .react-datepicker__current-month,\n.react-datepicker .react-datepicker-time__header,\n.react-datepicker .react-datepicker-year-header {\n  color: var(--theme-default) !important;\n}\n.react-datepicker .react-datepicker__day-name,\n.react-datepicker .react-datepicker__day,\n.react-datepicker .react-datepicker__time-name {\n  width: 30px !important;\n  line-height: 30px !important;\n}\n.react-datepicker .react-datepicker__navigation--next {\n  border-left-color: var(--theme-default) !important;\n}\n.react-datepicker .react-datepicker__navigation--previous {\n  border-right-color: var(--theme-default) !important;\n}\n.react-datepicker .react-datepicker__day--selected,\n.react-datepicker .react-datepicker__day--in-selecting-range,\n.react-datepicker .react-datepicker__day--in-range,\n.react-datepicker .react-datepicker__month-text--selected,\n.react-datepicker .react-datepicker__month-text--in-selecting-range,\n.react-datepicker .react-datepicker__month-text--in-range,\n.react-datepicker .react-datepicker__quarter-text--selected,\n.react-datepicker .react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker .react-datepicker__quarter-text--in-range {\n  background-color: var(--theme-default) !important;\n}\n.react-datepicker .react-datepicker__day--selected:hover,\n.react-datepicker .react-datepicker__day--in-selecting-range:hover,\n.react-datepicker .react-datepicker__day--in-range:hover,\n.react-datepicker .react-datepicker__month-text--selected:hover,\n.react-datepicker .react-datepicker__month-text--in-selecting-range:hover,\n.react-datepicker .react-datepicker__month-text--in-range:hover,\n.react-datepicker .react-datepicker__quarter-text--selected:hover,\n.react-datepicker .react-datepicker__quarter-text--in-selecting-range:hover,\n.react-datepicker .react-datepicker__quarter-text--in-range:hover {\n  background-color: var(--theme-default) !important;\n}\n.react-datepicker .react-datepicker__day--in-selecting-range,\n.react-datepicker .react-datepicker__month-text--in-selecting-range,\n.react-datepicker .react-datepicker__quarter-text--in-selecting-range {\n  background-color: rgba(115, 102, 255, 0.15);\n}\n.react-datepicker .react-datepicker__month--selecting-range .react-datepicker__day--in-range,\n.react-datepicker .react-datepicker__month--selecting-range .react-datepicker__month-text--in-range {\n  color: #fff !important;\n}\n.react-datepicker .react-datepicker__quarter-text--in-range {\n  color: #fff !important;\n}\n.react-datepicker .react-datepicker__day--today,\n.react-datepicker .react-datepicker__day--selected {\n  background-color: var(--theme-default) !important;\n  color: #fff !important;\n  border-radius: 0.3rem;\n}\n\n.classic_theme_container {\n  height: 144px !important;\n}\n\n.react_times_button .wrapper {\n  width: 100%;\n}\n\n.time_picker_wrapper2 {\n  display: flex;\n  width: auto !important;\n}\n.time_picker_wrapper2 .time_picker_container {\n  width: 300px;\n}\n.time_picker_wrapper2 .time_picker_modal_container {\n  top: unset !important;\n  bottom: 82px !important;\n}\n\n.time_picker_wrapper,\n.time_picker_wrapper2 {\n  width: 300px;\n}\n.time_picker_wrapper .time_picker_container .time_picker_modal_header,\n.time_picker_wrapper .time_picker_container .time_picker_modal_footer,\n.time_picker_wrapper .time_picker_container .timezone_picker_modal_header,\n.time_picker_wrapper2 .time_picker_container .time_picker_modal_header,\n.time_picker_wrapper2 .time_picker_container .time_picker_modal_footer,\n.time_picker_wrapper2 .time_picker_container .timezone_picker_modal_header {\n  background-color: var(--theme-default);\n}\n.time_picker_wrapper .time_picker_container .picker_pointer,\n.time_picker_wrapper2 .time_picker_container .picker_pointer {\n  background-color: var(--theme-default);\n}\n.time_picker_wrapper .time_picker_container .picker_pointer .pointer_drag,\n.time_picker_wrapper2 .time_picker_container .picker_pointer .pointer_drag {\n  background-color: var(--theme-default);\n}\n.time_picker_wrapper .time_picker_container .picker_center,\n.time_picker_wrapper2 .time_picker_container .picker_center {\n  background-color: var(--theme-default);\n}\n.time_picker_wrapper .time_picker_container .classic_theme_container .classic_time.light.active, .time_picker_wrapper .time_picker_container .classic_theme_container .classic_time.light:hover,\n.time_picker_wrapper2 .time_picker_container .classic_theme_container .classic_time.light.active,\n.time_picker_wrapper2 .time_picker_container .classic_theme_container .classic_time.light:hover {\n  background-color: var(--theme-default);\n}\n.time_picker_wrapper .gap,\n.time_picker_wrapper2 .gap {\n  padding: 10px;\n}\n\n.time_picker_modal_container {\n  width: unset !important;\n}\n\n@media (max-width: 1660px) {\n  .date-range {\n    display: flex;\n  }\n}\n@media (max-width: 1107px) {\n  .date-range {\n    display: unset;\n  }\n  .date-range .react-datepicker-wrapper:last-child {\n    margin-top: 15px;\n  }\n}\n@media (max-width: 575px) {\n  .react-datepicker .react-datepicker__day-name,\n  .react-datepicker .react-datepicker__day,\n  .react-datepicker .react-datepicker__time-name {\n    width: 25px !important;\n    line-height: 25px !important;\n  }\n  .date-picker .theme-form .row .row .col-form-label {\n    padding-left: 0;\n  }\n}\n@media (max-width: 475px) {\n  .date-range .react-datepicker-wrapper:last-child {\n    margin-top: 15px;\n  }\n}\n.calendar-basic .md-sidebar-aside {\n  background-color: #fff;\n}\n.calendar-basic #external-events {\n  padding: 20px;\n  border: 1px solid #d7e2e9;\n  background-color: var(--white);\n  width: 100%;\n}\n.calendar-basic #external-events h4, .calendar-basic #external-events .h4 {\n  margin-bottom: 14px;\n}\n.calendar-basic #external-events p {\n  margin-top: 12px;\n}\n.calendar-basic #external-events .fc-h-event {\n  padding: 12px;\n  background-color: #7366ff;\n  border: 1px solid #7366ff;\n}\n.calendar-basic #external-events .fc-h-event + .fc-h-event {\n  margin-top: 10px;\n}\n.calendar-basic #external-events .fc-h-event .fc-event-main {\n  font-size: 13px;\n}\n.calendar-basic .calendar-default .fc-daygrid-dot-event .fc-event-title {\n  text-overflow: ellipsis;\n}\n.calendar-basic .calendar-default .fc td[role=presentation] {\n  border: 0;\n}\n.calendar-basic .calendar-default .fc .fc-daygrid-day-number,\n.calendar-basic .calendar-default .fc .fc-col-header-cell-cushion {\n  color: #2f2f3b;\n}\n.calendar-basic .calendar-default .fc .fc-button .fc-icon {\n  height: 23px;\n}\n.calendar-basic .calendar-default .fc-h-event {\n  padding: 2px;\n  background-color: #7366ff;\n  border: 1px solid #7366ff;\n}\n.calendar-basic .calendar-default .fc-toolbar-chunk .fc-button-group ~ .fc-today-button {\n  margin: 0 8px;\n}\n\n.fc-event-dragging {\n  padding: 10px;\n  background-color: var(--theme-default);\n}\n\n.fc .fc-toolbar {\n  flex-wrap: wrap;\n  gap: 10px;\n}\n.fc .fc-button-primary:focus {\n  box-shadow: 0 0 0 0.2rem rgba(115, 102, 255, 0.5);\n}\n\n/**=====================\n   52. Datepicker CSS End\n==========================**/\n/**=====================\n    37. Dropdown CSS Start\n==========================**/\n.dropdown-divider {\n  margin: 0;\n}\n\n.dropdown .dropdown-toggle {\n  background-color: rgba(115, 102, 255, 0.08) !important;\n  color: #7366ff;\n  border-radius: 10px;\n  padding: 5px 10px;\n  width: 100px;\n  text-align: left;\n  border: none !important;\n}\n.dropdown .dropdown-toggle:after {\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%);\n  content: \"\\f107\";\n  border: none;\n  font-family: \"FontAwesome\";\n  font-size: 18px;\n  margin: 0;\n}\n.dropdown .dropdown-toggle.btn-primary {\n  color: #fff;\n}\n.dropdown .dropdown-menu {\n  font-family: Rubik, sans-serif;\n}\n\n.docs-toggles .dropdown .dropdown-toggle {\n  width: auto;\n}\n\n.nav-tabs .dropdown .dropdown-toggle {\n  width: 120px;\n}\n@media only screen and (max-width: 575.98px) {\n  .nav-tabs .dropdown .dropdown-toggle {\n    width: 100%;\n    text-align: center;\n  }\n}\n\n.icon-dropdown .dropdown-toggle {\n  background: transparent !important;\n  color: #52526c;\n  padding: 0;\n  width: auto;\n}\n.icon-dropdown .dropdown-toggle i {\n  font-size: 16px;\n}\n.icon-dropdown .dropdown-toggle::after {\n  display: none;\n}\n.icon-dropdown .dropdown-item {\n  line-height: 1.5;\n}\n\n.dropdown-basic {\n  margin-bottom: -10px;\n}\n.dropdown-basic .btn-group {\n  margin-right: 18px;\n}\n.dropdown-basic .btn-group .btn-round {\n  border-radius: 50px;\n}\n.dropdown-basic .separated-btn {\n  margin-left: -6px;\n}\n.dropdown-basic .separated-btn .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  padding: 10px;\n}\n.dropdown-basic button {\n  max-height: 43px;\n}\n.dropdown-basic .dropdown {\n  position: relative;\n  display: inline-block;\n  margin-bottom: 10px;\n}\n.dropdown-basic .dropdown .dropbtn {\n  color: white;\n  padding: 12px 35px;\n  border: none;\n  cursor: pointer;\n}\n.dropdown-basic .dropdown .dropdown-content {\n  display: none;\n  position: absolute;\n  right: 0;\n  background-color: #f9f9f9;\n  min-width: 175px;\n  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n  z-index: 1;\n  left: 0;\n  top: 45px;\n}\n.dropdown-basic .dropdown .dropdown-content a {\n  color: black;\n  padding: 12px 16px;\n  text-decoration: none;\n  display: block;\n}\n.dropdown-basic .dropdown .dropdown-content .dropdown-header {\n  padding: 12px 16px;\n}\n.dropdown-basic .dropdown-content a:hover {\n  background-color: #f1f1f1;\n}\n.dropdown-basic .dropdown:hover .dropdown-content {\n  display: block;\n}\n\n.dropup-basic .dropup {\n  position: relative;\n  display: inline-block;\n}\n.dropup-basic .dropup .dropbtn {\n  color: white;\n  padding: 12px;\n  border: none;\n}\n.dropup-basic .dropup .dropup-content {\n  display: none;\n  position: absolute;\n  background-color: #f9f9f9;\n  min-width: 170px;\n  bottom: 45px;\n  z-index: 999;\n  left: 0;\n}\n.dropup-basic .dropup .dropup-content a {\n  color: black;\n  padding: 12px 16px;\n  text-decoration: none;\n  display: block;\n}\n.dropup-basic .dropup .dropup-content a:hover {\n  background-color: #f1f1f1;\n}\n.dropup-basic .dropup:hover .dropup-content {\n  display: block;\n}\n.dropup-basic .dropup:hover .dropup-content a.active {\n  background-color: #f1f1f1;\n}\n\n/**=====================\n    37. Dropdown CSS Ends\n==========================**/\n/**=====================\n    30. Data-table CSS Start\n==========================**/\ndiv.dt-button-background {\n  display: none !important;\n}\ndiv.DTS div.dataTables_scrollBody table {\n  z-index: 1;\n}\ndiv .table-avtar {\n  height: 32px;\n  margin-right: 10px;\n}\n[dir=rtl] div .table-avtar {\n  margin-right: unset;\n  margin-left: 10px;\n}\ndiv .action {\n  display: flex;\n}\ndiv .action i {\n  font-size: 16px;\n}\ndiv .action .pdf i {\n  font-size: 20px;\n  color: #fc4438;\n}\ndiv .action .edit {\n  margin-right: 5px;\n}\ndiv .action .edit i {\n  color: #54ba4a;\n}\n[dir=rtl] div .action .edit {\n  margin-left: 5px;\n}\ndiv .action .delete i {\n  color: #fc4438;\n}\n\n#auto-generate-content_wrapper.dataTables_wrapper button {\n  background-color: white;\n  border: 1px solid var(--theme-default);\n  color: var(--theme-default);\n}\n\n.dataTables_wrapper {\n  width: calc(100% - 1px);\n}\n.dataTables_wrapper.no-footer .dataTables_scrollBody {\n  border-bottom: 1px solid #ecf3fa;\n}\n.dataTables_wrapper .dt-buttons .btn {\n  border-radius: 0.25rem !important;\n}\n.dataTables_wrapper {\n  padding: 0;\n}\n.dataTables_wrapper .btn-group button {\n  margin-right: 5px;\n}\n.dataTables_wrapper button {\n  font-weight: 400;\n  padding: 0.375rem 0.75rem;\n  font-size: 14px;\n  border-radius: 0.25rem;\n  color: #fff;\n}\n.dataTables_wrapper + .dataTables_wrapper {\n  margin-top: 20px;\n}\n.dataTables_wrapper .dataTables_paginate {\n  margin-left: 15px !important;\n  border: 1px solid #f4f4f4;\n  border-radius: 0.25rem;\n  padding-top: 0;\n}\n.dataTables_wrapper .dataTables_paginate .paginate_button {\n  margin: 0;\n}\n.dataTables_wrapper .dataTables_paginate .paginate_button.current, .dataTables_wrapper .dataTables_paginate .paginate_button:active {\n  background: var(--theme-default);\n  color: #fff !important;\n  box-shadow: none;\n}\n.dataTables_wrapper .dataTables_paginate .paginate_button:hover {\n  border: 1px solid var(--theme-default);\n  color: #2c323f !important;\n  background: transparent !important;\n}\n.dataTables_wrapper .dataTables_length {\n  margin-bottom: 30px;\n}\n.dataTables_wrapper .dataTables_length select {\n  border-color: #f4f4f4;\n  color: #2c323f;\n  padding: 0 10px;\n  margin: 0 10px;\n  height: 2.7142em;\n  background-color: #fff;\n}\n.dataTables_wrapper table.dataTable {\n  border: 1px solid #efefef;\n}\n.dataTables_wrapper table.dataTable tbody td.select-checkbox,\n.dataTables_wrapper table.dataTable tbody th.select-checkbox {\n  padding-right: 40px !important;\n}\n.dataTables_wrapper table.dataTable tbody td.select-checkbox:before,\n.dataTables_wrapper table.dataTable tbody th.select-checkbox:before {\n  right: 20px;\n  top: 22px;\n  left: unset;\n}\n.dataTables_wrapper table.dataTable tbody td.select-checkbox:after,\n.dataTables_wrapper table.dataTable tbody th.select-checkbox:after {\n  margin-top: -5px;\n  margin-left: 21px;\n}\n.dataTables_wrapper table.dataTable thead th,\n.dataTables_wrapper table.dataTable thead td {\n  border-bottom: 2px solid #efefef;\n}\n.dataTables_wrapper table.dataTable th,\n.dataTables_wrapper table.dataTable td {\n  padding: 0.75rem;\n}\n.dataTables_wrapper .dataTables_filter {\n  margin-bottom: 25px;\n  margin-left: 15px;\n}\n.dataTables_wrapper .dataTables_filter input[type=search] {\n  border: 1px solid #efefef;\n  padding: 0 10px;\n  margin-left: 10px;\n  height: 37px;\n  border-radius: 0;\n}\n\n.dataTables_scrollHeadInner {\n  width: 100% !important;\n}\n\ntable .fixedHeader-floating {\n  position: fixed !important;\n  background-color: #fff;\n}\ntable .box > div {\n  padding: 5px 15px;\n  background-color: var(--theme-default);\n  display: inline-block;\n  color: #fff;\n  border-radius: 5px;\n  margin-bottom: 15px;\n  margin-right: 15px;\n}\ntable.dataTable.fixedHeader-locked, table.dataTable.fixedHeader-floating {\n  width: calc(100vw - 250px) !important;\n  max-width: calc(100vw - 250px) !important;\n  overflow: hidden !important;\n  right: 0 !important;\n  z-index: 99;\n  left: 260px !important;\n}\ntable.dataTable:not(.fixedHeader-locked):not(.fixedHeader-floating) {\n  width: 100% !important;\n}\ntable.dataTable {\n  border-collapse: collapse !important;\n  margin-top: 0 !important;\n}\ntable.dataTable thead .sorting:before, table.dataTable thead .sorting:after,\ntable.dataTable thead .sorting_asc:before,\ntable.dataTable thead .sorting_asc:after,\ntable.dataTable thead .sorting_desc:before,\ntable.dataTable thead .sorting_desc:after,\ntable.dataTable thead .sorting_asc_disabled:before,\ntable.dataTable thead .sorting_asc_disabled:after,\ntable.dataTable thead .sorting_desc_disabled:before,\ntable.dataTable thead .sorting_desc_disabled:after {\n  bottom: 12px !important;\n}\ntable.dataTable input,\ntable.dataTable select {\n  border: 1px solid #efefef;\n  height: 37px;\n}\n\n.user-datatable tr td:first-child,\n.user-datatable tr th:first-child {\n  min-width: 150px;\n}\n\n.jsgrid .jsgrid-button {\n  width: 20px;\n  height: 20px;\n}\n.jsgrid .jsgrid-delete-button {\n  background-position: 0 -78px;\n  width: 22px;\n  height: 22px;\n}\n.jsgrid .jsgrid-edit-button {\n  background-position: -2px -122px;\n  width: 22px;\n  height: 22px;\n}\n.jsgrid .jsgrid-insert-mode-button {\n  background-position: -2px -160px;\n  width: 25px;\n  height: 25px;\n}\n.jsgrid .jsgrid-insert-button {\n  background-position: -3px -202px;\n  width: 16px;\n  height: 16px;\n}\n\n.toolbar {\n  padding: 5px 15px;\n  background-color: var(--theme-default);\n  display: inline-block;\n  color: #fff;\n  border-radius: 5px;\n  margin-bottom: 15px;\n  margin-right: 15px;\n}\n\ncode.option {\n  color: #fc4438 !important;\n}\ncode.api {\n  color: #54ba4a !important;\n}\n\n.dt-ext .dataTables_wrapper .page-item.active .page-link {\n  background-color: var(--theme-default) !important;\n  border-color: var(--theme-default) !important;\n  color: #fff;\n}\n.dt-ext .dataTables_wrapper .dataTables_paginate {\n  border: none;\n}\n.dt-ext .dataTables_wrapper .dataTables_paginate .paginate_button {\n  padding: 0;\n  border: none;\n}\n.dt-ext .dataTables_wrapper .dataTables_paginate .paginate_button.disabled, .dt-ext .dataTables_wrapper .dataTables_paginate .paginate_button.hover, .dt-ext .dataTables_wrapper .dataTables_paginate .paginate_button.active {\n  border: none !important;\n}\n.dt-ext .dataTables_wrapper .dataTables_paginate .page-link {\n  margin-left: 0px;\n  color: var(--theme-default);\n}\n.dt-ext .dataTables_wrapper button.dt-button,\n.dt-ext .dataTables_wrapper div.dt-button,\n.dt-ext .dataTables_wrapper a.dt-button,\n.dt-ext .dataTables_wrapper button.dt-button:focus:not(.disabled),\n.dt-ext .dataTables_wrapper div.dt-button:focus:not(.disabled),\n.dt-ext .dataTables_wrapper a.dt-button:focus:not(.disabled),\n.dt-ext .dataTables_wrapper button.dt-button:active:not(.disabled),\n.dt-ext .dataTables_wrapper button.dt-button.active:not(.disabled),\n.dt-ext .dataTables_wrapper div.dt-button:active:not(.disabled),\n.dt-ext .dataTables_wrapper div.dt-button.active:not(.disabled),\n.dt-ext .dataTables_wrapper a.dt-button:active:not(.disabled),\n.dt-ext .dataTables_wrapper a.dt-button.active:not(.disabled) {\n  background-color: var(--theme-default);\n  border-color: var(--theme-default);\n  border-radius: 2px;\n  color: #fff;\n  background-image: none;\n  font-size: 14px;\n}\n.dt-ext .dataTables_wrapper button.dt-button.btn-success,\n.dt-ext .dataTables_wrapper div.dt-button.btn-success,\n.dt-ext .dataTables_wrapper a.dt-button.btn-success {\n  background-color: #54ba4a;\n  border-color: #54ba4a;\n}\n.dt-ext .dataTables_wrapper button.dt-button.btn-primary,\n.dt-ext .dataTables_wrapper div.dt-button.btn-primary,\n.dt-ext .dataTables_wrapper a.dt-button.btn-primary {\n  background-color: var(--theme-default);\n  border-color: var(--theme-default);\n}\n.dt-ext .dataTables_wrapper button.dt-button.btn-danger,\n.dt-ext .dataTables_wrapper div.dt-button.btn-danger,\n.dt-ext .dataTables_wrapper a.dt-button.btn-danger {\n  background-color: #fc4438;\n  border-color: #fc4438;\n}\n.dt-ext .dataTables_wrapper table.dataTable th.focus,\n.dt-ext .dataTables_wrapper table.dataTable td.focus {\n  outline: 3px solid var(--theme-default);\n}\n.dt-ext .dataTables_wrapper table.dataTable.display tbody > tr.odd.selected > .sorting_1,\n.dt-ext .dataTables_wrapper table.dataTable.order-column.stripe tbody > tr.odd.selected > .sorting_1 {\n  background-color: white;\n}\n.dt-ext .dataTables_wrapper table.dataTable.stripe tbody > tr.odd.selected,\n.dt-ext .dataTables_wrapper table.dataTable.stripe tbody > tr.odd > .selected,\n.dt-ext .dataTables_wrapper table.dataTable.display tbody > tr.odd.selected,\n.dt-ext .dataTables_wrapper table.dataTable.display tbody > tr.odd > .selected {\n  background-color: white;\n}\n.dt-ext .dataTables_wrapper table.dataTable.display tbody > tr.even.selected > .sorting_1,\n.dt-ext .dataTables_wrapper table.dataTable.order-column.stripe tbody > tr.even.selected > .sorting_1 {\n  background-color: white;\n}\n.dt-ext .dataTables_wrapper table.dataTable tbody > tr.selected,\n.dt-ext .dataTables_wrapper table.dataTable tbody > tr > .selected {\n  background-color: white;\n}\n\ntd.highlight {\n  background-color: #f4f4f4 !important;\n}\n\ntd.details-control {\n  background: url(\"../../images/details_open.png\") no-repeat center center;\n  cursor: pointer;\n}\n\n.dataTables_scroll ~ .dataTables_paginate {\n  margin-top: 20px !important;\n}\n\n.product-table th:last-child {\n  min-width: 120px;\n}\n.product-table h6, .product-table .h6 {\n  font-weight: 600;\n  color: #2c323f;\n}\n\ntable.dataTable.display tbody tr.odd > .sorting_1 {\n  background-color: #fdfeff;\n}\n\n/**=====================\n     30. Data-table CSS Ends\n==========================**/\n/**=====================\n     29. Form Input CSS Start\n==========================**/\n.icon-addon .addon-md .fa, .icon-addon .addon-md .glyphicon {\n  position: absolute;\n  z-index: 2;\n  left: 10px;\n  font-size: 14px;\n  width: 20px;\n  margin-left: -2.5px;\n  text-align: center;\n  padding: 10px 0;\n  top: 1px;\n}\n\n.icon-addon .glyphicon, .icon-addon .fa {\n  position: absolute;\n  z-index: 2;\n  left: 10px;\n  font-size: 14px;\n  width: 20px;\n  margin-left: -2.5px;\n  text-align: center;\n  padding: 10px 0;\n  top: 1px;\n}\n\n.input-group-square .input-group-text, .input-group-square .form-control {\n  border-radius: 0;\n}\n\n.input-group-solid .input-group-text, .input-group-solid .form-control {\n  background: #f4f4f4;\n}\n\n.input-group-air {\n  box-shadow: 0 3px 20px 0 #efefef;\n}\n\n.icon-addon {\n  position: relative;\n  color: #4c5667;\n  display: block;\n}\n.icon-addon:after {\n  display: table;\n  content: \"\";\n  clear: both;\n}\n.icon-addon:before {\n  display: table;\n  content: \"\";\n}\n.icon-addon .addon-md .form-control {\n  padding-left: 30px;\n  float: left;\n  font-weight: normal;\n}\n.icon-addon .form-control {\n  padding-left: 30px;\n  float: left;\n  font-weight: normal;\n}\n.pill-input-group span:last-child {\n  border-top-right-radius: 1.3rem;\n  border-bottom-right-radius: 1.3rem;\n}\n.pill-input-group span:first-child {\n  border-top-left-radius: 1.3rem;\n  border-bottom-left-radius: 1.3rem;\n}\n\n/**=====================\n     29. Form Input CSS Ends\n==========================**/\n/**=====================\n     48. Form Wizard CSS Start\n==========================**/\nol {\n  display: flex;\n}\nol.progtrckr li {\n  width: 100%;\n}\nol.progtrckr li em {\n  display: none;\n}\nol.progtrckr li.progtrckr-todo:before, ol.progtrckr li.progtrckr-doing:before, ol.progtrckr li.progtrckr-done:before {\n  font-size: 20px !important;\n  width: 30px !important;\n  height: 30px !important;\n  line-height: 30px !important;\n}\n\n.multi-step {\n  position: relative;\n}\n.multi-step .footer-buttons .btn-lg, .multi-step .footer-buttons .btn-group-lg > .btn {\n  font-size: 14px;\n}\n.multi-step .btnsubmit {\n  position: absolute;\n  bottom: -34px;\n  right: 15px;\n}\n\n@media (max-width: 485px) {\n  ol.progtrckr li:before {\n    bottom: -63px !important;\n  }\n  ol.progtrckr li span {\n    padding: 0 !important;\n  }\n  ol.progtrckr li.progtrckr-todo:before, ol.progtrckr li.progtrckr-doing:before, ol.progtrckr li.progtrckr-done:before {\n    font-size: 18px !important;\n    width: 20px !important;\n    height: 20px !important;\n    line-height: 20px !important;\n  }\n}\n/**=====================\n    48. Form Wizard CSS Ends\n==========================**/\n/**=====================\n    26. Form CSS Start\n==========================**/\n.form-label {\n  margin-bottom: 4px;\n}\n\n.col-form-label {\n  padding-bottom: 4px;\n}\n\n.form-space {\n  margin-bottom: -10px;\n}\n.form-space > div {\n  margin-bottom: 10px;\n}\n\n.theme-form .form-control :focus {\n  box-shadow: 0 0 0 0.2rem rgba(171, 140, 228, 0.05);\n}\n.theme-form textarea {\n  border-color: #efefef;\n}\n.theme-form textarea::-webkit-input-placeholder {\n  color: #898989;\n  font-size: 14px;\n  letter-spacing: 1px;\n  font-weight: 100;\n}\n.theme-form input[type=text],\n.theme-form input[type=email],\n.theme-form input[type=search],\n.theme-form input[type=password],\n.theme-form input[type=number],\n.theme-form input[type=tel],\n.theme-form input[type=date],\n.theme-form input[type=datetime-local],\n.theme-form input[type=time],\n.theme-form input[type=datetime-local],\n.theme-form input[type=month],\n.theme-form input[type=week],\n.theme-form input[type=url],\n.theme-form input[type=file],\n.theme-form textarea,\n.theme-form select {\n  border-color: #efefef;\n  background-color: #fff;\n  font-size: 14px;\n  color: #898989;\n  padding: 12px 10px;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n.theme-form input[type=text]::-webkit-input-placeholder,\n.theme-form input[type=email]::-webkit-input-placeholder,\n.theme-form input[type=search]::-webkit-input-placeholder,\n.theme-form input[type=password]::-webkit-input-placeholder,\n.theme-form input[type=number]::-webkit-input-placeholder,\n.theme-form input[type=tel]::-webkit-input-placeholder,\n.theme-form input[type=date]::-webkit-input-placeholder,\n.theme-form input[type=datetime-local]::-webkit-input-placeholder,\n.theme-form input[type=time]::-webkit-input-placeholder,\n.theme-form input[type=datetime-local]::-webkit-input-placeholder,\n.theme-form input[type=month]::-webkit-input-placeholder,\n.theme-form input[type=week]::-webkit-input-placeholder,\n.theme-form input[type=url]::-webkit-input-placeholder,\n.theme-form input[type=file]::-webkit-input-placeholder,\n.theme-form textarea::-webkit-input-placeholder,\n.theme-form select::-webkit-input-placeholder {\n  color: #898989;\n  font-size: 14px;\n  letter-spacing: 1px;\n  font-weight: 100;\n}\n.theme-form input[type=file] {\n  height: auto;\n}\n.theme-form select.form-control:not([size]):not([multiple]) {\n  border-color: #efefef;\n  font-size: 14px;\n}\n.theme-form .checkbox label {\n  padding-left: 10px;\n}\n.theme-form .form-divider {\n  position: relative;\n  clear: both;\n  height: 0;\n  margin: 30px 0;\n  border-top: 1px solid #efefef;\n}\n.theme-form .form-divider:before {\n  position: absolute;\n  top: -11px;\n  left: 40%;\n  margin-left: -10px;\n  padding: 0 5px;\n  content: \"Or Signup With\";\n  color: #242934;\n  background: #fff;\n}\n.theme-form .login-divider {\n  position: relative;\n  clear: both;\n  height: 0;\n  margin: 30px 0;\n  border-top: 1px solid #efefef;\n}\n.theme-form .login-divider:before {\n  position: absolute;\n  top: -11px;\n  left: 40%;\n  margin-left: -10px;\n  padding: 0 5px;\n  color: #242934;\n  background: #fff;\n  content: \"Or Login With\";\n}\n.theme-form .btn-fb,\n.theme-form .btn-twitter,\n.theme-form .btn-google,\n.theme-form .btn-linkedin {\n  color: #fff;\n  width: 100%;\n}\n.theme-form .btn-fb {\n  background-color: #50598e;\n}\n.theme-form .btn-twitter {\n  background-color: #6fa2d8;\n}\n.theme-form .btn-google {\n  background-color: #c64e40;\n}\n.theme-form .btn-linkedin {\n  background-color: #0077b5;\n}\n\n.form-inline {\n  display: flex;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  flex-flow: row wrap;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-bottom: 0;\n}\n.form-inline .col-form-label {\n  margin-right: 5px;\n}\n\n.search-form .form-group:before {\n  position: absolute;\n  content: \"\";\n  width: 1px;\n  height: 25px;\n  background: #e8ebf2;\n  left: 82px;\n  top: 50px;\n}\n.search-form .form-group:after {\n  position: absolute;\n  content: \"\\f002\";\n  font-family: \"FontAwesome\";\n  top: 53px;\n  left: 53px;\n  color: #8e8e8e;\n}\n.search-form input {\n  border: 1px solid #efefef;\n  padding: 10px 10px 10px 70px;\n  border-radius: 10px;\n  background-color: rgba(244, 244, 244, 0.3);\n}\n.search-form input:focus {\n  outline: none !important;\n}\n\n.form-label-align-right label {\n  text-align: right;\n  padding-top: 17px;\n  font-weight: 500;\n}\n\n/**=====================\n    26. Form CSS Ends\n==========================**/\n/**=====================\n    10. ICON CSS Start\n==========================**/\n.icon-lists div {\n  cursor: pointer;\n  line-height: 60px;\n  white-space: nowrap;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n}\n.icon-lists div:hover {\n  background-color: #fafafa;\n}\n.icon-lists div i {\n  margin: 0 15px 0 10px;\n  font-size: 24px;\n}\n.icon-lists.whether-icon svg {\n  height: 50px;\n  width: 50px;\n}\n.icon-lists.feather-icons .media svg {\n  margin: 0 15px 0 10px;\n}\n.icon-lists .feather-icon .icon-first h6, .icon-lists .feather-icon .icon-first .h6 {\n  display: none;\n}\n\n.flag-icons,\n.feather-icons {\n  margin-bottom: -15px;\n  margin-top: -15px;\n}\n.flag-icons div,\n.feather-icons div {\n  line-height: 1;\n  word-wrap: break-word;\n  overflow: auto;\n}\n.flag-icons div .flag-icon,\n.feather-icons div .flag-icon {\n  height: 50px;\n  width: 50px;\n}\n.flag-icons div .media,\n.feather-icons div .media {\n  padding-top: 15px;\n  padding-bottom: 15px;\n  width: 100%;\n}\n.flag-icons div .media-body h6, .flag-icons div .media-body .h6,\n.feather-icons div .media-body h6,\n.feather-icons div .media-body .h6 {\n  margin-bottom: 0;\n  font-size: 14px;\n  font-weight: 400;\n  max-width: 100%;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.flag-icons div .media-body h5, .flag-icons div .media-body .h5,\n.feather-icons div .media-body h5,\n.feather-icons div .media-body .h5 {\n  background-color: var(--theme-default);\n  display: inline-block;\n  padding: 3px 5px;\n  font-size: 11px;\n  border-radius: 3px;\n  margin-bottom: 5px;\n  margin-right: 5px;\n  color: #fff;\n}\n\n.icon-hover-bottom {\n  background-color: #fdfeff;\n  width: 100%;\n  bottom: 0;\n  left: 0;\n  box-shadow: 0px 0px 1px 1px #f4f4f4;\n  z-index: 999;\n}\n.icon-hover-bottom .icon-popup {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n.icon-hover-bottom .icon-popup .close-icon {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  font-size: 20px;\n  color: #cccccc;\n  cursor: pointer;\n}\n[dir=rtl] .icon-hover-bottom .icon-popup .close-icon {\n  right: unset;\n  left: 10px;\n}\n.icon-hover-bottom .icon-popup {\n  padding: 20px;\n}\n.icon-hover-bottom .icon-popup > div {\n  display: inline-block;\n}\n.icon-hover-bottom .icon-popup > div .flag-icon {\n  width: 60px;\n  height: 60px;\n}\n.icon-hover-bottom .icon-popup .icon-class {\n  margin: 0 20px;\n  cursor: pointer;\n}\n.icon-hover-bottom .icon-popup .icon-last .form-inline .form-group {\n  display: initial;\n}\n.icon-hover-bottom .icon-title {\n  display: block;\n  color: #2c323f;\n  text-transform: uppercase;\n  font-weight: 500;\n}\n.icon-hover-bottom span,\n.icon-hover-bottom label,\n.icon-hover-bottom .btn {\n  font-family: Roboto, sans-serif;\n}\n.icon-hover-bottom .form-group input {\n  display: inline-block;\n  width: 300px;\n  background-color: #fff;\n  font-family: Roboto, sans-serif;\n}\n\n.fa-fa-icon-show-div,\n.icons-show-div {\n  display: none;\n}\n\n.icon-first i {\n  color: #898989;\n}\n.icon-first h6, .icon-first .h6 {\n  display: none;\n}\n\n/**=====================\n     10. ICON CSS Ends\n==========================**/\n/**=====================\n     17. List CSS Start\n==========================**/\n.list-group-item.active {\n  background-color: var(--theme-default) !important;\n  border-color: var(--theme-default) !important;\n}\n\n.list-group i {\n  margin-right: 10px;\n}\n.list-group img {\n  height: 40px;\n  width: 40px;\n  margin-right: 10px;\n}\n\n/**=====================\n     17. List CSS Ends\n==========================**/\n/**=====================\n     04. Loader CSS Start\n==========================**/\n.loader-wrapper {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: fixed;\n  background-color: #fff;\n  z-index: 11;\n  top: 0;\n  /*Color Loader*/\n}\n.loader-wrapper .loader-index {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  filter: url(\"#goo\");\n}\n.loader-wrapper .loader-index:after {\n  content: \"\";\n  width: 4em;\n  height: 4em;\n  background: var(--theme-default);\n  border-radius: 50%;\n  position: absolute;\n  transform: scale(0.5);\n  animation: grow 2s cubic-bezier(0.14, 0.05, 0.55, 0.5) infinite alternate;\n}\n.loader-wrapper .loader-index span {\n  width: 2em;\n  height: 2em;\n  background: var(--theme-secondary);\n  border-radius: 50%;\n  margin-right: 2em;\n  position: relative;\n  transform: translateX(7em);\n  animation: move 4s ease-in-out infinite;\n}\n.loader-wrapper .loader-index span:before {\n  content: \"\";\n  width: 2em;\n  height: 2em;\n  background: var(--theme-default);\n  border-radius: 50%;\n  position: absolute;\n  left: 3em;\n  transform: translateX(0em);\n  animation: shrink 2s ease-in-out infinite;\n}\n.loader-wrapper .loader-index span:after {\n  content: \"\";\n  width: 2em;\n  height: 2em;\n  background: #16c7f9;\n  border-radius: 50%;\n  position: absolute;\n  right: 3em;\n  transform: translateX(0em);\n  animation: shrink 2s ease-in-out infinite;\n}\n@keyframes grow {\n  0% {\n    transform: scale(0.5);\n    background: #16c7f9;\n  }\n  50% {\n    transform: scale(1);\n    background: var(--theme-secondary);\n  }\n}\n@keyframes move {\n  0% {\n    transform: translateX(7em);\n  }\n  50% {\n    transform: translateX(-5em);\n  }\n}\n@keyframes shrink {\n  0% {\n    transform: translateX(0em);\n  }\n  50% {\n    transform: translateX(-1em);\n  }\n}\n.loader-wrapper svg {\n  width: 0;\n  height: 0;\n}\n.loader-wrapper {\n  /*Color Loader*/\n}\n.loader-wrapper body {\n  font-family: sans;\n  min-height: 100vh;\n  margin: 0;\n  display: grid;\n  place-content: center;\n  background: black;\n}\n.loader-wrapper h1, .loader-wrapper .h1 {\n  color: #fff;\n  text-align: center;\n  margin-bottom: 2em;\n  letter-spacing: 3px;\n  position: relative;\n  z-index: 2;\n}\n.loader-wrapper h1:before, .loader-wrapper .h1:before {\n  position: absolute;\n  content: \"\";\n  height: 1px;\n  background: linear-gradient(to right, var(--theme-secondary), var(--theme-default), #16c7f9);\n  color: #fff;\n  top: 2.75em;\n  left: 0.75em;\n  width: 2.5em;\n  font-weight: 400;\n  font-variant: small-caps;\n  font-size: 0.5em;\n}\n\n.loader-box {\n  height: 150px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  vertical-align: middle;\n  justify-content: center;\n  transition: 0.3s color, 0.3s border, 0.3s transform, 0.3s opacity;\n}\n.loader-box [class*=loader-] {\n  display: inline-block;\n  width: 50px;\n  height: 50px;\n  color: inherit;\n  vertical-align: middle;\n}\n.loader-box .loader-1 {\n  border: 0.2em dotted var(--theme-default);\n  border-radius: 50%;\n  animation: 1s loader-01 linear infinite;\n}\n@keyframes loader-01 {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.loader-box .loader-2 {\n  border: 0.2em solid transparent;\n  border-left-color: var(--theme-secondary);\n  border-right-color: var(--theme-secondary);\n  border-radius: 50%;\n  animation: 1s loader-02 linear infinite;\n}\n@keyframes loader-02 {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.loader-box .loader-3 {\n  border: 0.2em solid #16c7f9;\n  border-bottom-color: transparent;\n  border-radius: 50%;\n  animation: 1s loader-03 linear infinite;\n  position: relative;\n}\n@keyframes loader-03 {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.loader-box .loader-4 {\n  border: 1px solid #16c7f9;\n  border-radius: 50%;\n  animation: 1s loader-04 linear infinite;\n  position: relative;\n}\n.loader-box .loader-4:before {\n  content: \"\";\n  display: block;\n  width: 0;\n  height: 0;\n  position: absolute;\n  top: -0.2em;\n  left: 50%;\n  border: 0.2em solid #16c7f9;\n  border-radius: 50%;\n}\n@keyframes loader-04 {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.loader-box .loader-5 {\n  border: 0.2em solid transparent;\n  border-top-color: #ffaa05;\n  border-radius: 50%;\n  animation: 1s loader-05 linear infinite;\n  position: relative;\n}\n.loader-box .loader-5:before {\n  content: \"\";\n  display: block;\n  width: inherit;\n  height: inherit;\n  position: absolute;\n  top: -0.2em;\n  left: -0.2em;\n  border: 0.2em solid #ffaa05;\n  border-radius: 50%;\n  opacity: 0.5;\n}\n@keyframes loader-05 {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.loader-box .loader-6 {\n  border: 0.2em solid #fc4438;\n  border-radius: 50%;\n  animation: loader-06 1s ease-out infinite;\n}\n@keyframes loader-06 {\n  0% {\n    transform: scale(0);\n    opacity: 0;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 0;\n  }\n}\n.loader-box .loader-7 {\n  border: 0 solid transparent;\n  border-radius: 50%;\n  position: relative;\n}\n.loader-box .loader-7:before, .loader-box .loader-7:after {\n  content: \"\";\n  border: 0.2em solid var(--theme-default);\n  border-radius: 50%;\n  width: inherit;\n  height: inherit;\n  position: absolute;\n  top: 0;\n  left: 0;\n  animation: loader-07 1s linear infinite;\n  opacity: 0;\n}\n.loader-box .loader-7:before {\n  animation-delay: 1s;\n}\n.loader-box .loader-7:after {\n  animation-delay: 0.5s;\n}\n@keyframes loader-07 {\n  0% {\n    transform: scale(0);\n    opacity: 0;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 0;\n  }\n}\n.loader-box .loader-8 {\n  position: relative;\n}\n.loader-box .loader-8:before, .loader-box .loader-8:after {\n  content: \"\";\n  width: inherit;\n  height: inherit;\n  border-radius: 50%;\n  background-color: var(--theme-secondary);\n  opacity: 0.6;\n  position: absolute;\n  top: 0;\n  left: 0;\n  animation: loader-08 2s infinite ease-in-out;\n}\n.loader-box .loader-8:after {\n  animation-delay: -1s;\n}\n@keyframes loader-08 {\n  0%, 100% {\n    transform: scale(0);\n  }\n  50% {\n    transform: scale(1);\n  }\n}\n.loader-box .loader-9 {\n  background-color: #16c7f9;\n  border-radius: 50%;\n  animation: loader-09 1s infinite ease-in-out;\n}\n@keyframes loader-09 {\n  0% {\n    transform: scale(0);\n  }\n  100% {\n    transform: scale(1);\n    opacity: 0;\n  }\n}\n.loader-box .loader-10 {\n  position: relative;\n  animation: loader-10-1 2s infinite linear;\n}\n.loader-box .loader-10:before, .loader-box .loader-10:after {\n  content: \"\";\n  width: 0;\n  height: 0;\n  border: 0.5em solid #16c7f9;\n  display: block;\n  position: absolute;\n  border-radius: 100%;\n  animation: loader-10-2 2s infinite ease-in-out;\n}\n.loader-box .loader-10:before {\n  top: 0;\n  left: 50%;\n}\n.loader-box .loader-10:after {\n  bottom: 0;\n  right: 50%;\n  animation-delay: -1s;\n}\n@keyframes loader-10-1 {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@keyframes loader-10-2 {\n  0%, 100% {\n    transform: scale(0);\n  }\n  50% {\n    transform: scale(1);\n  }\n}\n.loader-box .loader-11 {\n  background-color: #ffaa05;\n  animation: loader-11 1.2s infinite ease-in-out;\n}\n@keyframes loader-11 {\n  0% {\n    transform: perspective(120px) rotateX(0deg) rotateY(0deg);\n  }\n  50% {\n    transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);\n  }\n  100% {\n    transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);\n  }\n}\n.loader-box .loader-12 {\n  position: relative;\n}\n.loader-box .loader-12:before, .loader-box .loader-12:after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  background-color: #fc4438;\n  left: 50%;\n  right: 0;\n  top: 0;\n  bottom: 50%;\n  box-shadow: -0.5em 0 0 #fc4438;\n  animation: loader-12 1s linear infinite;\n}\n.loader-box .loader-12:after {\n  top: 50%;\n  bottom: 0;\n  animation-delay: 0.25s;\n}\n@keyframes loader-12 {\n  0%, 100% {\n    box-shadow: -0.5em 0 0 transparent;\n    background-color: #fc4438;\n  }\n  50% {\n    box-shadow: -0.5em 0 0 #fc4438;\n    background-color: transparent;\n  }\n}\n.loader-box .loader-13:before,\n.loader-box .loader-13:after,\n.loader-box .loader-13 {\n  border-radius: 50%;\n  animation-fill-mode: both;\n  animation: loader-13 1.8s infinite ease-in-out;\n}\n.loader-box .loader-13 {\n  color: var(--theme-default);\n  position: relative;\n  transform: translateZ(0);\n  animation-delay: -0.16s;\n  top: -1em;\n}\n.loader-box .loader-13:before {\n  right: 100%;\n  animation-delay: -0.32s;\n}\n.loader-box .loader-13:after {\n  left: 100%;\n}\n.loader-box .loader-13:before, .loader-box .loader-13:after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  top: 0;\n  width: inherit;\n  height: inherit;\n}\n@keyframes loader-13 {\n  0%, 80%, 100% {\n    box-shadow: 0 1em 0 -1em;\n  }\n  40% {\n    box-shadow: 0 1em 0 -0.2em;\n  }\n}\n.loader-box .loader-14 {\n  border-radius: 50%;\n  box-shadow: 0 1em 0 -0.2em var(--theme-secondary);\n  position: relative;\n  animation: loader-14 0.8s ease-in-out alternate infinite;\n  animation-delay: 0.32s;\n  top: -1em;\n}\n.loader-box .loader-14:after, .loader-box .loader-14:before {\n  content: \"\";\n  position: absolute;\n  width: inherit;\n  height: inherit;\n  border-radius: inherit;\n  box-shadow: inherit;\n  animation: inherit;\n}\n.loader-box .loader-14:before {\n  left: -1em;\n  animation-delay: 0.48s;\n}\n.loader-box .loader-14:after {\n  right: -1em;\n  animation-delay: 0.16s;\n}\n@keyframes loader-14 {\n  0% {\n    box-shadow: 0 2em 0 -0.2em var(--theme-secondary);\n  }\n  100% {\n    box-shadow: 0 1em 0 -0.2em var(--theme-secondary);\n  }\n}\n.loader-box .loader-15 {\n  background: #16c7f9;\n  position: relative;\n  animation: loader-15 1s ease-in-out infinite;\n  animation-delay: 0.4s;\n  width: 0.25em;\n  height: 0.5em;\n  margin: 0 0.5em;\n}\n.loader-box .loader-15:after, .loader-box .loader-15:before {\n  content: \"\";\n  position: absolute;\n  width: inherit;\n  height: inherit;\n  background: inherit;\n  animation: inherit;\n}\n.loader-box .loader-15:before {\n  right: 0.5em;\n  animation-delay: 0.2s;\n}\n.loader-box .loader-15:after {\n  left: 0.5em;\n  animation-delay: 0.6s;\n}\n@keyframes loader-15 {\n  0%, 100% {\n    box-shadow: 0 0 0 #16c7f9, 0 0 0 #16c7f9;\n  }\n  50% {\n    box-shadow: 0 -0.25em 0 #16c7f9, 0 0.25em 0 #16c7f9;\n  }\n}\n.loader-box .loader-16 {\n  transform: rotateZ(45deg);\n  perspective: 1000px;\n  border-radius: 50%;\n}\n.loader-box .loader-16:before, .loader-box .loader-16:after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: inherit;\n  height: inherit;\n  border-radius: 50%;\n  animation: 1s spin linear infinite;\n}\n.loader-box .loader-16:before {\n  transform: rotateX(70deg);\n}\n.loader-box .loader-16:after {\n  transform: rotateY(70deg);\n  animation-delay: 0.4s;\n}\n@keyframes rotate {\n  0% {\n    transform: translate(-50%, -50%) rotateZ(0deg);\n  }\n  100% {\n    transform: translate(-50%, -50%) rotateZ(360deg);\n  }\n}\n@keyframes rotateccw {\n  0% {\n    transform: translate(-50%, -50%) rotate(0deg);\n  }\n  100% {\n    transform: translate(-50%, -50%) rotate(-360deg);\n  }\n}\n@keyframes spin {\n  0%, 100% {\n    box-shadow: 0.2em 0px 0 0px #16c7f9;\n  }\n  12% {\n    box-shadow: 0.2em 0.2em 0 0 #16c7f9;\n  }\n  25% {\n    box-shadow: 0 0.2em 0 0px #16c7f9;\n  }\n  37% {\n    box-shadow: -0.2em 0.2em 0 0 #16c7f9;\n  }\n  50% {\n    box-shadow: -0.2em 0 0 0 #16c7f9;\n  }\n  62% {\n    box-shadow: -0.2em -0.2em 0 0 #16c7f9;\n  }\n  75% {\n    box-shadow: 0px -0.2em 0 0 #16c7f9;\n  }\n  87% {\n    box-shadow: 0.2em -0.2em 0 0 #16c7f9;\n  }\n}\n.loader-box .loader-17 {\n  position: relative;\n  background-color: #ffaa05;\n  border-radius: 50%;\n}\n.loader-box .loader-17:after, .loader-box .loader-17:before {\n  content: \"\";\n  position: absolute;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  opacity: 0.8;\n}\n.loader-box .loader-17:after {\n  left: -0.5em;\n  top: -0.25em;\n  background-color: #ffaa05;\n  transform-origin: 30px 35px;\n  animation: loader-17 1s linear infinite;\n  opacity: 0.6;\n}\n.loader-box .loader-17:before {\n  left: -1.25em;\n  top: -0.75em;\n  background-color: #ffaa05;\n  transform-origin: 40px 40px;\n  animation: loader-17 2s linear infinite;\n}\n@keyframes loader-17 {\n  0% {\n    transform: rotateZ(0deg) translate3d(0, 0, 0);\n  }\n  100% {\n    transform: rotateZ(360deg) translate3d(0, 0, 0);\n  }\n}\n.loader-box .loader-18 {\n  position: relative;\n}\n.loader-box .loader-18:before, .loader-box .loader-18:after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  border-radius: 50%;\n  border: 0.1em solid transparent;\n  border-bottom-color: #fc4438;\n  top: 0;\n  left: 0;\n  animation: 1s loader-18 linear infinite;\n}\n.loader-box .loader-18:before {\n  width: 40px;\n  height: 40px;\n}\n.loader-box .loader-18:after {\n  width: 30px;\n  height: 30px;\n  top: 0.1em;\n  left: 0.1em;\n  animation-direction: reverse;\n}\n@keyframes loader-18 {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.loader-box .loader-19 {\n  border-top: 0.2em solid var(--theme-default);\n  border-right: 0.2em solid transparent;\n  animation: loader-19 1s linear infinite;\n  border-radius: 100%;\n  position: relative;\n}\n@keyframes loader-19 {\n  to {\n    transform: rotate(360deg);\n  }\n}\n.loader-box .loader-20 {\n  background-color: transparent;\n  box-shadow: inset 0px 0px 0px 0.1em var(--theme-secondary);\n  border-radius: 50%;\n  position: relative;\n}\n.loader-box .loader-20:after, .loader-box .loader-20:before {\n  position: absolute;\n  content: \"\";\n  background-color: var(--theme-secondary);\n  top: 24px;\n  left: 24px;\n  height: 0.1em;\n  transform-origin: left center;\n}\n.loader-box .loader-20:after {\n  width: 0.4em;\n  animation: loader-20 2s linear infinite;\n}\n.loader-box .loader-20:before {\n  width: 20px;\n  animation: loader-20 8s linear infinite;\n}\n@keyframes loader-20 {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.loader-box .loader-21 {\n  position: relative;\n}\n.loader-box .loader-21:before, .loader-box .loader-21:after {\n  position: absolute;\n  content: \"\";\n}\n.loader-box .loader-21:before {\n  width: 80%;\n  height: 80%;\n  left: 10%;\n  bottom: 10%;\n  border-radius: 100% 100% 100% 0;\n  box-shadow: 0px 0px 0px 0.1em #16c7f9;\n  animation: loader-21 1s linear infinite;\n  transform: rotate(-46deg);\n}\n.loader-box .loader-21:after {\n  width: 1em;\n  height: 0.3em;\n  border-radius: 100%;\n  left: 0;\n  background-color: rgba(255, 255, 255, 0.2);\n  bottom: -0.2em;\n  z-index: -1;\n}\n@keyframes loader-21 {\n  0% {\n    top: 0;\n  }\n  50% {\n    top: -5px;\n  }\n  100% {\n    top: 0;\n  }\n}\n.loader-box .loader-22 {\n  border: 0.1em #16c7f9 solid;\n  border-radius: 100%;\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n}\n.loader-box .loader-22:after, .loader-box .loader-22:before {\n  position: absolute;\n  content: \"\";\n  background-color: #16c7f9;\n}\n.loader-box .loader-22:after {\n  width: 50%;\n  height: 0.1em;\n  left: 50%;\n  top: 50%;\n  transform-origin: left center;\n  animation: loader-22 2s linear infinite alternate;\n}\n.loader-box .loader-22:before {\n  width: 100%;\n  height: 40%;\n  left: 0;\n  bottom: 0;\n}\n@keyframes loader-22 {\n  0% {\n    transform: rotate(-160deg);\n  }\n  100% {\n    transform: rotate(-20deg);\n  }\n}\n.loader-box .loader-23 {\n  height: 0.5em;\n  border: 0.1em #ffaa05 solid;\n  border-radius: 0.1em;\n  position: relative;\n  animation: loader-23 5s linear infinite;\n}\n.loader-box .loader-23:after {\n  width: 0.07em;\n  height: 100%;\n  background-color: #ffaa05;\n  border-radius: 0px 0.5em 0.5em 0px;\n  position: absolute;\n  content: \"\";\n  top: 0;\n  left: calc(100% + 0.1em);\n}\n@keyframes loader-23 {\n  0% {\n    box-shadow: inset 0px 0px 0px #ffaa05;\n  }\n  100% {\n    box-shadow: inset 1em 0px 0px #ffaa05;\n  }\n}\n.loader-box .loader-24 {\n  width: 0.8em;\n  height: 1em;\n  border: 0.1em #fc4438 solid;\n  border-radius: 0px 0px 0.2em 0.2em;\n  position: relative;\n}\n.loader-box .loader-24:after, .loader-box .loader-24:before {\n  position: absolute;\n  content: \"\";\n}\n.loader-box .loader-24:after {\n  width: 0.2em;\n  height: 50%;\n  border: 0.1em #fc4438 solid;\n  border-left: none;\n  border-radius: 0px 0.5em 0.5em 0px;\n  left: calc(100% + 0.1em);\n  top: 0.1em;\n}\n.loader-box .loader-24:before {\n  width: 0.1em;\n  height: 0.3em;\n  background-color: #fc4438;\n  top: -0.3em;\n  left: 0.05em;\n  box-shadow: 0.2em 0px 0px 0px #fc4438, 0.2em -0.2em 0px 0px #fc4438, 0.4em 0px 0px 0px #fc4438;\n  animation: loader-24 1s linear infinite alternate;\n}\n@keyframes loader-24 {\n  0% {\n    height: 0px;\n  }\n  100% {\n    height: 6px;\n  }\n}\n.loader-box .loader-25 {\n  border: 0.1em var(--theme-default) solid;\n  position: relative;\n  animation: loader-25-1 5s linear infinite;\n}\n.loader-box .loader-25:after {\n  width: 0.2em;\n  height: 0.2em;\n  position: absolute;\n  content: \"\";\n  background-color: var(--theme-default);\n  bottom: calc(100% + 0.2em);\n  left: -0.4em;\n  animation: loader-25-2 1s ease-in-out infinite;\n}\n@keyframes loader-25-1 {\n  0% {\n    box-shadow: inset 0 0 0 0 var(--theme-default);\n  }\n  100% {\n    box-shadow: inset 0 -1em 0 0 var(--theme-default);\n  }\n}\n@keyframes loader-25-2 {\n  25% {\n    left: calc(100% + 0.2em);\n    bottom: calc(100% + 0.2em);\n  }\n  50% {\n    left: calc(100% + 0.2em);\n    bottom: -0.4em;\n  }\n  75% {\n    left: -0.4em;\n    bottom: -0.4em;\n  }\n  100% {\n    left: -0.4em;\n    bottom: calc(100% + 0.2em);\n  }\n}\n.loader-box .loader-26 {\n  width: 0.5em;\n  height: 0.5em;\n  background-color: var(--theme-secondary);\n  box-shadow: 1em 0px 0px var(--theme-secondary);\n  border-radius: 50%;\n  animation: loader-26 1s ease-in-out infinite alternate;\n}\n@keyframes loader-26 {\n  0% {\n    opacity: 0.1;\n    transform: rotate(0deg) scale(0.5);\n  }\n  100% {\n    opacity: 1;\n    transform: rotate(360deg) scale(1.2);\n  }\n}\n.loader-box .loader-29 {\n  border-radius: 50%;\n  box-shadow: inset 0 0 0 0.1em #16c7f9, -0.5em -0.5em 0 -0.4em #16c7f9, 0 -0.7em 0 -0.4em #16c7f9, 0.5em -0.5em 0 -0.4em #16c7f9, -0.5em 0.5em 0 -0.4em #16c7f9, 0 0.7em 0 -0.4em #16c7f9, 0.5em 0.5em 0 -0.4em #16c7f9, -0.7em 0 0 -0.4em #16c7f9, 0.7em 0 0 -0.4em #16c7f9;\n  animation: 5s loader-29 linear infinite;\n}\n@keyframes loader-29 {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.loader-box .loader-30 {\n  border: 0.2em solid transparent;\n  border-top-color: #16c7f9;\n  border-bottom-color: #16c7f9;\n  border-radius: 50%;\n  position: relative;\n  animation: 1s loader-30 linear infinite;\n}\n.loader-box .loader-30:before, .loader-box .loader-30:after {\n  content: \"\";\n  display: block;\n  width: 0;\n  height: 0;\n  position: absolute;\n  border: 0.2em solid transparent;\n  border-bottom-color: #16c7f9;\n}\n.loader-box .loader-30:before {\n  transform: rotate(135deg);\n  right: -0.3em;\n  top: -0.05em;\n}\n.loader-box .loader-30:after {\n  transform: rotate(-45deg);\n  left: -0.3em;\n  bottom: -0.05em;\n}\n@keyframes loader-30 {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.loader-box .loader-31 {\n  box-shadow: 0 0 2em #ffaa05;\n  background-color: #ffaa05;\n  position: relative;\n  border-radius: 50%;\n  transform: rotateX(-60deg) perspective(1000px);\n}\n.loader-box .loader-31:before, .loader-box .loader-31:after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: inherit;\n  height: inherit;\n  border-radius: inherit;\n  animation: 1s loader-31 ease-out infinite;\n}\n.loader-box .loader-31:after {\n  animation-delay: 0.4s;\n}\n@keyframes loader-31 {\n  0% {\n    opacity: 1;\n    transform: rotate(0deg);\n    box-shadow: 0 0 0 -0.5em #ffaa05, 0 0 0 -0.5em #ffaa05, 0 0 0 -0.5em #ffaa05, 0 0 0 -0.5em #ffaa05, 0 0 0 -0.5em #ffaa05, 0 0 0 -0.5em #ffaa05, 0 0 0 -0.5em #ffaa05, 0 0 0 -0.5em #ffaa05;\n  }\n  100% {\n    opacity: 0;\n    transform: rotate(180deg);\n    box-shadow: -1em -1em 0 -0.35em #ffaa05, 0 -1.5em 0 -0.35em #ffaa05, 1em -1em 0 -0.35em #ffaa05, -1.5em 0 0 -0.35em #ffaa05, 1.5em -0 0 -0.35em #ffaa05, -1em 1em 0 -0.35em #ffaa05, 0 1.5em 0 -0.35em #ffaa05, 1em 1em 0 -0.35em #ffaa05;\n  }\n}\n.loader-box .loader-32 {\n  position: relative;\n  border-radius: 50%;\n  box-shadow: 0 0 1em 0 #fc4438, inset 0 0 1em 0 #fc4438;\n  animation: 1s loader-32 linear infinite;\n}\n.loader-box .loader-32:before, .loader-box .loader-32:after {\n  content: \"\";\n  display: block;\n  width: inherit;\n  height: inherit;\n  position: absolute;\n  border-radius: 50%;\n}\n.loader-box .loader-32:before {\n  border-top: 0.2em solid #fc4438;\n  border-right: 0.2em solid transparent;\n  top: 0.28em;\n  right: calc(50% - 0.22em);\n}\n.loader-box .loader-32:after {\n  border-bottom: 0.2em solid #fc4438;\n  border-left: 0.2em solid transparent;\n  bottom: 0.28em;\n  left: calc(50% - 0.22em);\n}\n@keyframes loader-32 {\n  0% {\n    transform: rotateX(-60deg) rotateZ(0deg);\n  }\n  100% {\n    transform: rotateX(-60deg) rotateZ(360deg);\n  }\n}\n.loader-box .loader-34 {\n  position: relative;\n  width: 1em;\n  height: 0.5em;\n}\n.loader-box .loader-34:after, .loader-box .loader-34:before {\n  position: absolute;\n  content: \"\";\n  height: 0.4em;\n  width: 0.4em;\n  top: 0;\n  background-color: var(--theme-default);\n  border-radius: 50%;\n}\n.loader-box .loader-34:after {\n  right: 0;\n  animation: loader-34-2 0.5s ease-in-out infinite;\n  animation-direction: alternate;\n}\n.loader-box .loader-34:before {\n  left: 0;\n  animation: loader-34-1 0.5s ease-in-out infinite;\n  animation-direction: alternate;\n}\n@keyframes loader-34-1 {\n  0% {\n    transform: translatex(0px);\n  }\n  65% {\n    height: 0.4em;\n    width: 0.4em;\n  }\n  100% {\n    height: 0.5em;\n    width: 0.3em;\n    transform: translatex(0.2em);\n  }\n}\n@keyframes loader-34-2 {\n  0% {\n    transform: translatex(0px);\n  }\n  65% {\n    height: 0.4em;\n    width: 0.4em;\n  }\n  100% {\n    height: 0.5em;\n    width: 0.3em;\n    transform: translatex(-0.2em);\n  }\n}\n.loader-box .loader-35 {\n  margin: 0 0.5em;\n  position: relative;\n}\n.loader-box .loader-35:before {\n  border-radius: 50%;\n  background-color: var(--theme-secondary);\n  animation: loader-35 3s cubic-bezier(0.77, 0, 0.175, 1) infinite;\n  content: \"\";\n  width: inherit;\n  height: inherit;\n  top: 0;\n  left: 0;\n  position: absolute;\n}\n@keyframes loader-35 {\n  0% {\n    transform: translateX(0) scale(1);\n  }\n  25% {\n    transform: translateX(-100%) scale(0.3);\n  }\n  50% {\n    transform: translateX(0) scale(1);\n  }\n  75% {\n    transform: translateX(100%) scale(0.3);\n  }\n  100% {\n    transform: translateX(0) scale(1);\n  }\n}\n.loader-box .loader-37 {\n  border-right: 0.1em solid #16c7f9;\n  border-radius: 100%;\n  animation: loader-37 800ms linear infinite;\n}\n.loader-box .loader-37:before, .loader-box .loader-37:after {\n  content: \"\";\n  width: 0.8em;\n  height: 0.8em;\n  display: block;\n  position: absolute;\n  top: calc(50% - 0.4em);\n  left: calc(50% - 0.4em);\n  border-left: 0.08em solid #16c7f9;\n  border-radius: 100%;\n  animation: loader-37 400ms linear infinite reverse;\n}\n.loader-box .loader-37:after {\n  width: 0.6em;\n  height: 0.6em;\n  top: calc(50% - 0.3em);\n  left: calc(50% - 0.3em);\n  border: 0;\n  border-right: 0.05em solid #16c7f9;\n  animation: none;\n}\n@keyframes loader-37 {\n  from {\n    transform: rotate(360deg);\n  }\n  to {\n    transform: rotate(0deg);\n  }\n}\n.loader-box .loader-38 {\n  height: 0.1em;\n  width: 0.1em;\n  box-shadow: -0.2em -0.2em 0 0.1em #16c7f9, -0.2em -0.2em 0 0.1em #16c7f9, -0.2em -0.2em 0 0.1em #16c7f9, -0.2em -0.2em 0 0.1em #16c7f9;\n  animation: loader-38 6s infinite;\n}\n@keyframes loader-38 {\n  0% {\n    box-shadow: -0.2em -0.2em 0 0.1em #16c7f9, -0.2em -0.2em 0 0.1em #16c7f9, -0.2em -0.2em 0 0.1em #16c7f9, -0.2em -0.2em 0 0.1em #16c7f9;\n  }\n  8.33% {\n    box-shadow: -0.2em -0.2em 0 0.1em #16c7f9, 0.2em -0.2em 0 0.1em #16c7f9, 0.2em -0.2em 0 0.1em #16c7f9, 0.2em -0.2em 0 0.1em #16c7f9;\n  }\n  16.66% {\n    box-shadow: -0.2em -0.2em 0 0.1em #16c7f9, 0.2em -0.2em 0 0.1em #16c7f9, 0.2em 0.2em 0 0.1em #16c7f9, 0.2em 0.2em 0 0.1em #16c7f9;\n  }\n  24.99% {\n    box-shadow: -0.2em -0.2em 0 0.1em #16c7f9, 0.2em -0.2em 0 0.1em #16c7f9, 0.2em 0.2em 0 0.1em #16c7f9, -0.2em 0.2em 0 0.1em #16c7f9;\n  }\n  33.32% {\n    box-shadow: -0.2em -0.2em 0 0.1em #16c7f9, 0.2em -0.2em 0 0.1em #16c7f9, 0.2em 0.2em 0 0.1em #16c7f9, -0.2em -0.2em 0 0.1em #16c7f9;\n  }\n  41.65% {\n    box-shadow: 0.2em -0.2em 0 0.1em #16c7f9, 0.2em -0.2em 0 0.1em #16c7f9, 0.2em 0.2em 0 0.1em #16c7f9, 0.2em -0.2em 0 0.1em #16c7f9;\n  }\n  49.98% {\n    box-shadow: 0.2em 0.2em 0 0.1em #16c7f9, 0.2em 0.2em 0 0.1em #16c7f9, 0.2em 0.2em 0 0.1em #16c7f9, 0.2em 0.2em 0 0.1em #16c7f9;\n  }\n  58.31% {\n    box-shadow: -0.2em 0.2em 0 0.1em #16c7f9, -0.2em 0.2em 0 0.1em #16c7f9, 0.2em 0.2em 0 0.1em #16c7f9, -0.2em 0.2em 0 0.1em #16c7f9;\n  }\n  66.64% {\n    box-shadow: -0.2em -0.2em 0 0.1em #16c7f9, -0.2em -0.2em 0 0.1em #16c7f9, 0.2em 0.2em 0 0.1em #16c7f9, -0.2em 0.2em 0 0.1em #16c7f9;\n  }\n  74.97% {\n    box-shadow: -0.2em -0.2em 0 0.1em #16c7f9, 0.2em -0.2em 0 0.1em #16c7f9, 0.2em 0.2em 0 0.1em #16c7f9, -0.2em 0.2em 0 0.1em #16c7f9;\n  }\n  83.3% {\n    box-shadow: -0.2em -0.2em 0 0.1em #16c7f9, 0.2em 0.2em 0 0.1em #16c7f9, 0.2em 0.2em 0 0.1em #16c7f9, -0.2em 0.2em 0 0.1em #16c7f9;\n  }\n  91.63% {\n    box-shadow: -0.2em -0.2em 0 0.1em #16c7f9, -0.2em 0.2em 0 0.1em #16c7f9, -0.2em 0.2em 0 0.1em #16c7f9, -0.2em 0.2em 0 0.1em #16c7f9;\n  }\n  100% {\n    box-shadow: -0.2em -0.2em 0 0.1em #16c7f9, -0.2em -0.2em 0 0.1em #16c7f9, -0.2em -0.2em 0 0.1em #16c7f9, -0.2em -0.2em 0 0.1em #16c7f9;\n  }\n}\n.loader-box .loader-39 {\n  position: relative;\n  width: 0.15em;\n  height: 0.15em;\n  background-color: #ffaa05;\n  border-radius: 100%;\n  animation: loader-39-1 30s infinite linear;\n}\n.loader-box .loader-39:before, .loader-box .loader-39:after {\n  content: \"\";\n  border-radius: 100%;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.loader-box .loader-39:before {\n  width: 20px;\n  height: 60px;\n  animation: loader-39-2 0.8s linear infinite;\n}\n.loader-box .loader-39:after {\n  width: 60px;\n  height: 20px;\n  animation: loader-39-2 1.2s linear infinite;\n}\n@keyframes loader-39-1 {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@keyframes loader-39-2 {\n  0% {\n    box-shadow: 0.04em -0.04em 0 0.02em #ffaa05;\n  }\n  25% {\n    box-shadow: 0.04em 0.04em 0 0.02em #ffaa05;\n  }\n  50% {\n    box-shadow: -0.04em 0.04em 0 0.02em #ffaa05;\n  }\n  75% {\n    box-shadow: -0.04em -0.04em 0 0.02em #ffaa05;\n  }\n  100% {\n    box-shadow: 0.04em -0.04em 0 0.02em #ffaa05;\n  }\n}\n.loader-box .loader-40 {\n  border: 0.05em #fc4438 solid;\n  border-radius: 0.2em;\n  overflow: hidden;\n  position: relative;\n}\n.loader-box .loader-40:after, .loader-box .loader-40:before {\n  content: \"\";\n  border-radius: 50%;\n  position: absolute;\n  width: inherit;\n  height: inherit;\n  animation: loader-40 2s infinite linear;\n}\n.loader-box .loader-40:before {\n  border-top: 0.2em #fc4438 solid;\n  top: -0.15em;\n  left: calc(-50% - 0.15em);\n  transform-origin: right center;\n}\n.loader-box .loader-40:after {\n  border-bottom: 0.2em #fc4438 solid;\n  top: 0.15em;\n  right: calc(-50% - 0.15em);\n  transform-origin: left center;\n}\n@keyframes loader-40 {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(359deg);\n  }\n}\n.loader-box .loader-41 {\n  border: 0.05em var(--theme-default) solid;\n  border-radius: 0.2em;\n  position: relative;\n  background: linear-gradient(45deg, transparent 48%, var(--theme-default) 50%, var(--theme-default) 50%, transparent 52%, transparent), linear-gradient(-45deg, transparent 48%, var(--theme-default) 50%, var(--theme-default) 50%, transparent 52%, transparent);\n  background-size: 0.5em 0.5em;\n  background-position: 0% 0%;\n  animation: loader-41 1s infinite linear;\n}\n@keyframes loader-41 {\n  from {\n    background-position: 0 0;\n  }\n  to {\n    background-position: -1em 0;\n  }\n}\n.loader-box .loader-42 {\n  width: 2em;\n  height: 0.66em;\n  border: 0.05em var(--theme-secondary) solid;\n  border-radius: 0.1em;\n  background: linear-gradient(-60deg, transparent 0%, transparent 50%, var(--theme-secondary) 50%, var(--theme-secondary) 75%, transparent 75%, transparent);\n  background-size: 1em 2em;\n  background-position: 0 0;\n  animation: loader-42 0.8s infinite linear;\n}\n@keyframes loader-42 {\n  from {\n    background-position: 0 0;\n  }\n  to {\n    background-position: -2em 0;\n  }\n}\n\n/**=====================\n     04. Loader CSS Ends\n==========================**/\n/**=====================\n     16. Popover CSS Start\n==========================**/\n.popover-header {\n  background-color: #2c323f;\n  color: #fff;\n}\n\n.popover-main .btn-showcase a {\n  color: #fff;\n}\n.popover-main .btn-showcase button:last-child {\n  margin-right: 0;\n}\n\n/**=====================\n     16. Popover CSS Ends\n==========================**/\n/**=====================\n     77. Print CSS Start\n==========================**/\n@media print {\n  .sidebar-wrapper, .page-header {\n    display: none;\n  }\n  .page-body {\n    margin: 0;\n  }\n  .page-wrapper .page-title {\n    visibility: hidden;\n  }\n  .page-wrapper .page-body-wrapper .page-title {\n    display: none;\n  }\n  .page-wrapper.compact-wrapper .page-body-wrapper .page-body {\n    margin: 0;\n  }\n  table.fixedHeader-floating {\n    display: none;\n  }\n}\n.invoice-table {\n  margin-top: 16px;\n  margin-bottom: 16px;\n}\n\n.invoice .text-right input {\n  margin-top: 6px;\n}\n.invoice .media {\n  align-items: center;\n}\n\n/**=====================\n    77. Print CSS Ends\n==========================**/\n/**=====================\n     28. Radio CSS Start\n==========================**/\n.animate-chk label {\n  line-height: 1.6;\n  cursor: pointer;\n}\n.animate-chk label:last-child {\n  margin-bottom: 0;\n}\n\n.checkbox_animated {\n  cursor: pointer;\n  position: relative;\n  margin: 0 1rem 0 0;\n}\n.checkbox_animated:before {\n  transition: transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75);\n  transform: rotate(-45deg) scale(0, 0);\n  content: \"\";\n  position: absolute;\n  left: 0.25rem;\n  top: 0.225rem;\n  z-index: 1;\n  width: 0.75rem;\n  height: 0.375rem;\n  border: 2px solid var(--theme-default);\n  border-top-style: none;\n  border-right-style: none;\n}\n.checkbox_animated:after {\n  content: \"\";\n  position: absolute;\n  top: -0.125rem;\n  left: 0;\n  width: 1.3rem;\n  height: 1.3rem;\n  background: #fff;\n  border: 2px solid #ecf3fa;\n  cursor: pointer;\n}\n.checkbox_animated:checked:before {\n  transform: rotate(-45deg) scale(1, 1);\n}\n\n.radio_animated {\n  position: relative;\n  margin: 0 1rem 0 0;\n  cursor: pointer;\n}\n.radio_animated:before {\n  transition: transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75);\n  transform: scale(0, 0);\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0.125rem;\n  z-index: 1;\n  width: 0.75rem;\n  height: 0.75rem;\n  background: var(--theme-default);\n  border-radius: 50%;\n}\n.radio_animated:after {\n  content: \"\";\n  position: absolute;\n  top: -0.25rem;\n  left: -0.125rem;\n  width: 1.25rem;\n  height: 1.25rem;\n  background: #fff;\n  border: 2px solid #ecf3fa;\n  border-radius: 50%;\n}\n.radio_animated:checked:before {\n  transform: scale(1, 1);\n}\n\n.checkbox label {\n  display: inline-block;\n  position: relative;\n  padding-left: 16px;\n  cursor: pointer;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.checkbox label::before {\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  width: 19px;\n  height: 19px;\n  left: 0;\n  margin-left: -16px;\n  border: 1px solid #efefef;\n  border-radius: 3px;\n  background-color: #fff;\n  -webkit-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;\n  -o-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;\n  transition: border 0.15s ease-in-out, color 0.15s ease-in-out;\n}\n.checkbox label::after {\n  display: inline-block;\n  position: absolute;\n  width: 16px;\n  height: 16px;\n  left: 0;\n  top: 0;\n  margin-left: -20px;\n  padding-left: 3px;\n  padding-top: 1px;\n  font-size: 11px;\n  color: #242934;\n}\n.checkbox input[type=checkbox] {\n  opacity: 0;\n}\n.checkbox input[type=checkbox]:focus {\n  outline-offset: -2px;\n}\n.checkbox input[type=checkbox]:focus + label::before {\n  outline-offset: -2px;\n}\n.checkbox input[type=checkbox]:checked + label::before {\n  font-family: themify;\n  content: \"\\e64c\";\n  text-align: center;\n  line-height: 1.2;\n}\n.checkbox input[type=checkbox]:disabled + label {\n  opacity: 0.65;\n}\n.checkbox input[type=checkbox]:disabled + label::before {\n  background-color: #f4f4f4;\n  cursor: not-allowed;\n}\n.checkbox .checkbox-circle label::before {\n  border-radius: 50%;\n}\n.checkbox .checkbox-inline {\n  margin-top: 0;\n}\n\n.m-squar label::before {\n  border-radius: 0;\n}\n.m-squar .checkbox-circle label::before {\n  border-radius: 50%;\n}\n.m-squar .checkbox-inline {\n  margin-top: 0;\n}\n\n.checkbox-primary label::before {\n  border-color: var(--theme-default);\n}\n.checkbox-primary input[type=checkbox]:checked + label::before {\n  border-color: var(--theme-default);\n  color: var(--theme-default);\n}\n.checkbox-primary input[type=checkbox]:checked + label::after {\n  color: #fff;\n}\n\n.checkbox-solid-primary label:before {\n  background-color: var(--theme-default);\n  border-color: var(--theme-default);\n  color: #fff;\n}\n.checkbox-solid-primary input[type=checkbox]:checked + label::before {\n  background-color: var(--theme-default);\n  border-color: var(--theme-default);\n  color: #fff;\n}\n.checkbox-solid-primary input[type=checkbox]:checked + label::after {\n  color: #fff;\n}\n\n.radio-primary input[type=radio] + label::before {\n  border-color: var(--theme-default);\n}\n.radio-primary input[type=radio] + label::after {\n  background-color: var(--theme-default);\n}\n.radio-primary input[type=radio]:checked + label::before {\n  border-color: var(--theme-default);\n}\n.radio-primary input[type=radio]:checked + label::after {\n  background-color: var(--theme-default);\n}\n\n.checkbox-secondary label::before {\n  border-color: #ff3364;\n}\n.checkbox-secondary input[type=checkbox]:checked + label::before {\n  border-color: #ff3364;\n  color: #ff3364;\n}\n.checkbox-secondary input[type=checkbox]:checked + label::after {\n  color: #fff;\n}\n\n.checkbox-solid-secondary label:before {\n  background-color: #ff3364;\n  border-color: #ff3364;\n  color: #fff;\n}\n.checkbox-solid-secondary input[type=checkbox]:checked + label::before {\n  background-color: #ff3364;\n  border-color: #ff3364;\n  color: #fff;\n}\n.checkbox-solid-secondary input[type=checkbox]:checked + label::after {\n  color: #fff;\n}\n\n.radio-secondary input[type=radio] + label::before {\n  border-color: #ff3364;\n}\n.radio-secondary input[type=radio] + label::after {\n  background-color: #ff3364;\n}\n.radio-secondary input[type=radio]:checked + label::before {\n  border-color: #ff3364;\n}\n.radio-secondary input[type=radio]:checked + label::after {\n  background-color: #ff3364;\n}\n\n.checkbox-success label::before {\n  border-color: #54ba4a;\n}\n.checkbox-success input[type=checkbox]:checked + label::before {\n  border-color: #54ba4a;\n  color: #54ba4a;\n}\n.checkbox-success input[type=checkbox]:checked + label::after {\n  color: #fff;\n}\n\n.checkbox-solid-success label:before {\n  background-color: #54ba4a;\n  border-color: #54ba4a;\n  color: #fff;\n}\n.checkbox-solid-success input[type=checkbox]:checked + label::before {\n  background-color: #54ba4a;\n  border-color: #54ba4a;\n  color: #fff;\n}\n.checkbox-solid-success input[type=checkbox]:checked + label::after {\n  color: #fff;\n}\n\n.radio-success input[type=radio] + label::before {\n  border-color: #54ba4a;\n}\n.radio-success input[type=radio] + label::after {\n  background-color: #54ba4a;\n}\n.radio-success input[type=radio]:checked + label::before {\n  border-color: #54ba4a;\n}\n.radio-success input[type=radio]:checked + label::after {\n  background-color: #54ba4a;\n}\n\n.checkbox-danger label::before {\n  border-color: #fc4438;\n}\n.checkbox-danger input[type=checkbox]:checked + label::before {\n  border-color: #fc4438;\n  color: #fc4438;\n}\n.checkbox-danger input[type=checkbox]:checked + label::after {\n  color: #fff;\n}\n\n.checkbox-solid-danger label:before {\n  background-color: #fc4438;\n  border-color: #fc4438;\n  color: #fff;\n}\n.checkbox-solid-danger input[type=checkbox]:checked + label::before {\n  background-color: #fc4438;\n  border-color: #fc4438;\n  color: #fff;\n}\n.checkbox-solid-danger input[type=checkbox]:checked + label::after {\n  color: #fff;\n}\n\n.radio-danger input[type=radio] + label::before {\n  border-color: #fc4438;\n}\n.radio-danger input[type=radio] + label::after {\n  background-color: #fc4438;\n}\n.radio-danger input[type=radio]:checked + label::before {\n  border-color: #fc4438;\n}\n.radio-danger input[type=radio]:checked + label::after {\n  background-color: #fc4438;\n}\n\n.checkbox-info label::before {\n  border-color: #16c7f9;\n}\n.checkbox-info input[type=checkbox]:checked + label::before {\n  border-color: #16c7f9;\n  color: #16c7f9;\n}\n.checkbox-info input[type=checkbox]:checked + label::after {\n  color: #fff;\n}\n\n.checkbox-solid-info label:before {\n  background-color: #16c7f9;\n  border-color: #16c7f9;\n  color: #fff;\n}\n.checkbox-solid-info input[type=checkbox]:checked + label::before {\n  background-color: #16c7f9;\n  border-color: #16c7f9;\n  color: #fff;\n}\n.checkbox-solid-info input[type=checkbox]:checked + label::after {\n  color: #fff;\n}\n\n.radio-info input[type=radio] + label::before {\n  border-color: #16c7f9;\n}\n.radio-info input[type=radio] + label::after {\n  background-color: #16c7f9;\n}\n.radio-info input[type=radio]:checked + label::before {\n  border-color: #16c7f9;\n}\n.radio-info input[type=radio]:checked + label::after {\n  background-color: #16c7f9;\n}\n\n.checkbox-light label::before {\n  border-color: #f4f4f4;\n}\n.checkbox-light input[type=checkbox]:checked + label::before {\n  border-color: #f4f4f4;\n  color: #f4f4f4;\n}\n.checkbox-light input[type=checkbox]:checked + label::after {\n  color: #fff;\n}\n\n.checkbox-solid-light label:before {\n  background-color: #f4f4f4;\n  border-color: #f4f4f4;\n  color: #fff;\n}\n.checkbox-solid-light input[type=checkbox]:checked + label::before {\n  background-color: #f4f4f4;\n  border-color: #f4f4f4;\n  color: #fff;\n}\n.checkbox-solid-light input[type=checkbox]:checked + label::after {\n  color: #fff;\n}\n\n.radio-light input[type=radio] + label::before {\n  border-color: #f4f4f4;\n}\n.radio-light input[type=radio] + label::after {\n  background-color: #f4f4f4;\n}\n.radio-light input[type=radio]:checked + label::before {\n  border-color: #f4f4f4;\n}\n.radio-light input[type=radio]:checked + label::after {\n  background-color: #f4f4f4;\n}\n\n.checkbox-dark label::before {\n  border-color: #2c323f;\n}\n.checkbox-dark input[type=checkbox]:checked + label::before {\n  border-color: #2c323f;\n  color: #2c323f;\n}\n.checkbox-dark input[type=checkbox]:checked + label::after {\n  color: #fff;\n}\n\n.checkbox-solid-dark label:before {\n  background-color: #2c323f;\n  border-color: #2c323f;\n  color: #fff;\n}\n.checkbox-solid-dark input[type=checkbox]:checked + label::before {\n  background-color: #2c323f;\n  border-color: #2c323f;\n  color: #fff;\n}\n.checkbox-solid-dark input[type=checkbox]:checked + label::after {\n  color: #fff;\n}\n\n.radio-dark input[type=radio] + label::before {\n  border-color: #2c323f;\n}\n.radio-dark input[type=radio] + label::after {\n  background-color: #2c323f;\n}\n.radio-dark input[type=radio]:checked + label::before {\n  border-color: #2c323f;\n}\n.radio-dark input[type=radio]:checked + label::after {\n  background-color: #2c323f;\n}\n\n.checkbox-warning label::before {\n  border-color: #ffaa05;\n}\n.checkbox-warning input[type=checkbox]:checked + label::before {\n  border-color: #ffaa05;\n  color: #ffaa05;\n}\n.checkbox-warning input[type=checkbox]:checked + label::after {\n  color: #fff;\n}\n\n.checkbox-solid-warning label:before {\n  background-color: #ffaa05;\n  border-color: #ffaa05;\n  color: #fff;\n}\n.checkbox-solid-warning input[type=checkbox]:checked + label::before {\n  background-color: #ffaa05;\n  border-color: #ffaa05;\n  color: #fff;\n}\n.checkbox-solid-warning input[type=checkbox]:checked + label::after {\n  color: #fff;\n}\n\n.radio-warning input[type=radio] + label::before {\n  border-color: #ffaa05;\n}\n.radio-warning input[type=radio] + label::after {\n  background-color: #ffaa05;\n}\n.radio-warning input[type=radio]:checked + label::before {\n  border-color: #ffaa05;\n}\n.radio-warning input[type=radio]:checked + label::after {\n  background-color: #ffaa05;\n}\n\n.m-checkbox-inline .checkbox {\n  display: inline-block;\n}\n.m-checkbox-inline .radio {\n  display: inline-block;\n}\n.m-checkbox-inline label {\n  margin-right: 20px;\n}\n\n.radio label {\n  display: inline-block;\n  position: relative;\n  padding-left: 5px;\n  cursor: pointer;\n}\n.radio label::before {\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  width: 19px;\n  height: 19px;\n  left: 0;\n  margin-left: -20px;\n  border: 1px solid #efefef;\n  border-radius: 50%;\n  background-color: #fff;\n  -webkit-transition: border 0.15s ease-in-out;\n  -o-transition: border 0.15s ease-in-out;\n  transition: border 0.15s ease-in-out;\n}\n.radio label::after {\n  display: inline-block;\n  position: absolute;\n  content: \" \";\n  width: 9px;\n  height: 9px;\n  left: 5px;\n  top: 5px;\n  margin-left: -20px;\n  border-radius: 50%;\n  background-color: #898989;\n  -webkit-transform: scale(0, 0);\n  -ms-transform: scale(0, 0);\n  -o-transform: scale(0, 0);\n  transform: scale(0, 0);\n  -webkit-transition: -webkit-transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);\n  -moz-transition: -moz-transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);\n  -o-transition: -o-transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);\n  transition: transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);\n}\n.radio input[type=radio] {\n  opacity: 0;\n}\n.radio input[type=radio]:focus + label::before {\n  outline-offset: -2px;\n}\n.radio input[type=radio]:checked + label::after {\n  -webkit-transform: scale(1, 1);\n  -ms-transform: scale(1, 1);\n  -o-transform: scale(1, 1);\n  transform: scale(1, 1);\n}\n.radio input[type=radio]:disabled + label {\n  opacity: 0.65;\n}\n.radio input[type=radio]:disabled + label::before {\n  cursor: not-allowed;\n}\n.radio .radio-inline {\n  margin-top: 0;\n}\n\n/**=====================\n     28. Radio CSS Ends\n==========================**/\n/**=====================\n    56.  Ribbon CSS Start\n==========================**/\n[class*=ribbon-wrapper] {\n  position: relative;\n  padding-top: 40px;\n}\n\n.ribbon {\n  padding: 0 20px;\n  height: 30px;\n  line-height: 30px;\n  clear: left;\n  position: absolute;\n  top: 12px;\n  left: 0px;\n  color: #fff;\n  z-index: 2;\n}\n\n.ribbon-clip {\n  left: -14px;\n}\n.ribbon-clip:before {\n  position: absolute;\n  top: 30px;\n  left: 0;\n  width: 0;\n  height: 0;\n  content: \"\";\n  border: 7px solid transparent;\n  border-top-color: #2c323f;\n  border-right-color: #2c323f;\n}\n\n.ribbon-vertical-left-wrapper {\n  padding-left: 40px;\n  position: relative;\n}\n\n.ribbon-vertical-right-wrapper {\n  padding-right: 40px;\n}\n\n.ribbon-wrapper-bottom {\n  padding-bottom: 40px;\n  padding-top: 0;\n}\n\n.ribbon-wrapper-right-bottom {\n  padding-right: 40px;\n}\n\n.ribbon-space-bottom {\n  top: 0px;\n}\n\n.ribbon-bookmark:before {\n  position: absolute;\n  top: 0;\n  left: 100%;\n  display: block;\n  width: 0;\n  height: 0;\n  content: \"\";\n  border: 15px solid #2c323f;\n  border-right: 10px solid transparent;\n}\n\n.ribbon-right {\n  left: auto;\n  right: -2px;\n}\n\n.ribbon-clip-right {\n  right: -14px;\n}\n.ribbon-clip-right:before {\n  position: absolute;\n  top: 30px;\n  right: 0;\n  width: 0;\n  height: 0;\n  content: \"\";\n  border: 7px solid transparent;\n  border-top-color: #2c323f;\n  border-right-color: #2c323f;\n}\n\n.ribbon-clip-bottom {\n  left: -14px;\n  bottom: 12px;\n  top: auto;\n}\n.ribbon-clip-bottom:before {\n  position: absolute;\n  bottom: 30px;\n  left: 0;\n  width: 0;\n  height: 0;\n  content: \"\";\n  border: 7px solid transparent;\n  border-top-color: #2c323f;\n  border-right-color: #2c323f;\n}\n\n.ribbon-clip-bottom-right {\n  right: -14px;\n  left: auto;\n  bottom: 12px;\n  top: auto;\n}\n.ribbon-clip-bottom-right:before {\n  position: absolute;\n  bottom: 30px;\n  right: 0;\n  width: 0;\n  height: 0;\n  content: \"\";\n  border: 7px solid transparent;\n  border-top-color: #2c323f;\n  border-right-color: #2c323f;\n}\n\n.ribbon-bookmark.ribbon-right:before {\n  right: 100%;\n  left: auto;\n  border-right: 15px solid #2c323f;\n  border-left: 10px solid transparent;\n}\n\n.ribbon-vertical-left {\n  clear: none;\n  padding: 0 5px;\n  height: 70px;\n  width: 30px;\n  line-height: 70px;\n  text-align: center;\n  left: 12px;\n  top: -2px;\n}\n\n.ribbon-vertical-right {\n  clear: none;\n  padding: 0 5px;\n  height: 70px;\n  width: 30px;\n  line-height: 70px;\n  text-align: center;\n  top: -2px;\n  left: auto;\n  right: 12px;\n}\n\n.ribbon-bookmark.ribbon-vertical-left:before, .ribbon-bookmark.ribbon-vertical-right:before {\n  top: 100%;\n  left: 0;\n  margin-top: -14px;\n  border-right: 15px solid #2c323f;\n  border-bottom: 10px solid transparent;\n}\n\n.ribbon-primary {\n  background: #7366ff;\n}\n\n.ribbon-primary {\n  background: #7366ff;\n}\n\n.ribbon-bookmark.ribbon-primary:before {\n  border-color: #7366ff;\n  border-right-color: transparent;\n}\n.ribbon-bookmark.ribbon-right.ribbon-primary:before {\n  border-right-color: #7366ff;\n  border-left-color: transparent;\n}\n.ribbon-bookmark.ribbon-vertical-left.ribbon-primary:before, .ribbon-bookmark.ribbon-vertical-right.ribbon-primary:before {\n  border-right-color: #7366ff;\n  border-bottom-color: transparent;\n}\n\n.ribbon-primary.ribbon-corner:before {\n  border-top-color: #7366ff;\n  border-left-color: #7366ff;\n}\n.ribbon-primary.ribbon-corner.ribbon-right:before {\n  border-right-color: #7366ff;\n  border-left-color: transparent;\n}\n.ribbon-primary.ribbon-corner.ribbon-bottom:before {\n  border-top-color: transparent;\n  border-bottom-color: #7366ff;\n}\n\n.ribbon-primary.ribbon-clip:before {\n  border-color: transparent;\n  border-top-color: rgb(26.7973856209%, 20%, 100%);\n  border-right-color: rgb(26.7973856209%, 20%, 100%);\n}\n\n.ribbon-primary.ribbon-clip-right:before {\n  border-right-color: transparent;\n  border-top-color: rgb(26.7973856209%, 20%, 100%);\n  border-left-color: rgb(26.7973856209%, 20%, 100%);\n}\n\n.ribbon-primary.ribbon-clip-bottom:before {\n  border-top-color: transparent;\n  border-bottom-color: rgb(26.7973856209%, 20%, 100%);\n  border-right-color: rgb(26.7973856209%, 20%, 100%);\n}\n\n.ribbon-primary.ribbon-clip-bottom-right:before {\n  border-top-color: transparent;\n  border-bottom-color: rgb(26.7973856209%, 20%, 100%);\n  border-right-color: transparent;\n  border-left-color: rgb(26.7973856209%, 20%, 100%);\n}\n\n.ribbon-secondary {\n  background: #ff3364;\n}\n\n.ribbon-secondary {\n  background: #ff3364;\n}\n\n.ribbon-bookmark.ribbon-secondary:before {\n  border-color: #ff3364;\n  border-right-color: transparent;\n}\n.ribbon-bookmark.ribbon-right.ribbon-secondary:before {\n  border-right-color: #ff3364;\n  border-left-color: transparent;\n}\n.ribbon-bookmark.ribbon-vertical-left.ribbon-secondary:before, .ribbon-bookmark.ribbon-vertical-right.ribbon-secondary:before {\n  border-right-color: #ff3364;\n  border-bottom-color: transparent;\n}\n\n.ribbon-secondary.ribbon-corner:before {\n  border-top-color: #ff3364;\n  border-left-color: #ff3364;\n}\n.ribbon-secondary.ribbon-corner.ribbon-right:before {\n  border-right-color: #ff3364;\n  border-left-color: transparent;\n}\n.ribbon-secondary.ribbon-corner.ribbon-bottom:before {\n  border-top-color: transparent;\n  border-bottom-color: #ff3364;\n}\n\n.ribbon-secondary.ribbon-clip:before {\n  border-color: transparent;\n  border-top-color: rgb(100%, 0%, 24.0196078431%);\n  border-right-color: rgb(100%, 0%, 24.0196078431%);\n}\n\n.ribbon-secondary.ribbon-clip-right:before {\n  border-right-color: transparent;\n  border-top-color: rgb(100%, 0%, 24.0196078431%);\n  border-left-color: rgb(100%, 0%, 24.0196078431%);\n}\n\n.ribbon-secondary.ribbon-clip-bottom:before {\n  border-top-color: transparent;\n  border-bottom-color: rgb(100%, 0%, 24.0196078431%);\n  border-right-color: rgb(100%, 0%, 24.0196078431%);\n}\n\n.ribbon-secondary.ribbon-clip-bottom-right:before {\n  border-top-color: transparent;\n  border-bottom-color: rgb(100%, 0%, 24.0196078431%);\n  border-right-color: transparent;\n  border-left-color: rgb(100%, 0%, 24.0196078431%);\n}\n\n.ribbon-success {\n  background: #54ba4a;\n}\n\n.ribbon-success {\n  background: #54ba4a;\n}\n\n.ribbon-bookmark.ribbon-success:before {\n  border-color: #54ba4a;\n  border-right-color: transparent;\n}\n.ribbon-bookmark.ribbon-right.ribbon-success:before {\n  border-right-color: #54ba4a;\n  border-left-color: transparent;\n}\n.ribbon-bookmark.ribbon-vertical-left.ribbon-success:before, .ribbon-bookmark.ribbon-vertical-right.ribbon-success:before {\n  border-right-color: #54ba4a;\n  border-bottom-color: transparent;\n}\n\n.ribbon-success.ribbon-corner:before {\n  border-top-color: #54ba4a;\n  border-left-color: #54ba4a;\n}\n.ribbon-success.ribbon-corner.ribbon-right:before {\n  border-right-color: #54ba4a;\n  border-left-color: transparent;\n}\n.ribbon-success.ribbon-corner.ribbon-bottom:before {\n  border-top-color: transparent;\n  border-bottom-color: #54ba4a;\n}\n\n.ribbon-success.ribbon-clip:before {\n  border-color: transparent;\n  border-top-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%);\n  border-right-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%);\n}\n\n.ribbon-success.ribbon-clip-right:before {\n  border-right-color: transparent;\n  border-top-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%);\n  border-left-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%);\n}\n\n.ribbon-success.ribbon-clip-bottom:before {\n  border-top-color: transparent;\n  border-bottom-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%);\n  border-right-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%);\n}\n\n.ribbon-success.ribbon-clip-bottom-right:before {\n  border-top-color: transparent;\n  border-bottom-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%);\n  border-right-color: transparent;\n  border-left-color: rgb(25.8996078431%, 59.3396078431%, 22.6211764706%);\n}\n\n.ribbon-danger {\n  background: #fc4438;\n}\n\n.ribbon-danger {\n  background: #fc4438;\n}\n\n.ribbon-bookmark.ribbon-danger:before {\n  border-color: #fc4438;\n  border-right-color: transparent;\n}\n.ribbon-bookmark.ribbon-right.ribbon-danger:before {\n  border-right-color: #fc4438;\n  border-left-color: transparent;\n}\n.ribbon-bookmark.ribbon-vertical-left.ribbon-danger:before, .ribbon-bookmark.ribbon-vertical-right.ribbon-danger:before {\n  border-right-color: #fc4438;\n  border-bottom-color: transparent;\n}\n\n.ribbon-danger.ribbon-corner:before {\n  border-top-color: #fc4438;\n  border-left-color: #fc4438;\n}\n.ribbon-danger.ribbon-corner.ribbon-right:before {\n  border-right-color: #fc4438;\n  border-left-color: transparent;\n}\n.ribbon-danger.ribbon-corner.ribbon-bottom:before {\n  border-top-color: transparent;\n  border-bottom-color: #fc4438;\n}\n\n.ribbon-danger.ribbon-clip:before {\n  border-color: transparent;\n  border-top-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%);\n  border-right-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%);\n}\n\n.ribbon-danger.ribbon-clip-right:before {\n  border-right-color: transparent;\n  border-top-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%);\n  border-left-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%);\n}\n\n.ribbon-danger.ribbon-clip-bottom:before {\n  border-top-color: transparent;\n  border-bottom-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%);\n  border-right-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%);\n}\n\n.ribbon-danger.ribbon-clip-bottom-right:before {\n  border-top-color: transparent;\n  border-bottom-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%);\n  border-right-color: transparent;\n  border-left-color: rgb(98.5264997088%, 8.1518151815%, 2.2578140167%);\n}\n\n.ribbon-info {\n  background: #16c7f9;\n}\n\n.ribbon-info {\n  background: #16c7f9;\n}\n\n.ribbon-bookmark.ribbon-info:before {\n  border-color: #16c7f9;\n  border-right-color: transparent;\n}\n.ribbon-bookmark.ribbon-right.ribbon-info:before {\n  border-right-color: #16c7f9;\n  border-left-color: transparent;\n}\n.ribbon-bookmark.ribbon-vertical-left.ribbon-info:before, .ribbon-bookmark.ribbon-vertical-right.ribbon-info:before {\n  border-right-color: #16c7f9;\n  border-bottom-color: transparent;\n}\n\n.ribbon-info.ribbon-corner:before {\n  border-top-color: #16c7f9;\n  border-left-color: #16c7f9;\n}\n.ribbon-info.ribbon-corner.ribbon-right:before {\n  border-right-color: #16c7f9;\n  border-left-color: transparent;\n}\n.ribbon-info.ribbon-corner.ribbon-bottom:before {\n  border-top-color: transparent;\n  border-bottom-color: #16c7f9;\n}\n\n.ribbon-info.ribbon-clip:before {\n  border-color: transparent;\n  border-top-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%);\n  border-right-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%);\n}\n\n.ribbon-info.ribbon-clip-right:before {\n  border-right-color: transparent;\n  border-top-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%);\n  border-left-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%);\n}\n\n.ribbon-info.ribbon-clip-bottom:before {\n  border-top-color: transparent;\n  border-bottom-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%);\n  border-right-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%);\n}\n\n.ribbon-info.ribbon-clip-bottom-right:before {\n  border-top-color: transparent;\n  border-bottom-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%);\n  border-right-color: transparent;\n  border-left-color: rgb(2.1658872754%, 66.0595619001%, 84.1086225285%);\n}\n\n.ribbon-light {\n  background: #f4f4f4;\n}\n\n.ribbon-light {\n  background: #f4f4f4;\n}\n\n.ribbon-bookmark.ribbon-light:before {\n  border-color: #f4f4f4;\n  border-right-color: transparent;\n}\n.ribbon-bookmark.ribbon-right.ribbon-light:before {\n  border-right-color: #f4f4f4;\n  border-left-color: transparent;\n}\n.ribbon-bookmark.ribbon-vertical-left.ribbon-light:before, .ribbon-bookmark.ribbon-vertical-right.ribbon-light:before {\n  border-right-color: #f4f4f4;\n  border-bottom-color: transparent;\n}\n\n.ribbon-light.ribbon-corner:before {\n  border-top-color: #f4f4f4;\n  border-left-color: #f4f4f4;\n}\n.ribbon-light.ribbon-corner.ribbon-right:before {\n  border-right-color: #f4f4f4;\n  border-left-color: transparent;\n}\n.ribbon-light.ribbon-corner.ribbon-bottom:before {\n  border-top-color: transparent;\n  border-bottom-color: #f4f4f4;\n}\n\n.ribbon-light.ribbon-clip:before {\n  border-color: transparent;\n  border-top-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%);\n  border-right-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%);\n}\n\n.ribbon-light.ribbon-clip-right:before {\n  border-right-color: transparent;\n  border-top-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%);\n  border-left-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%);\n}\n\n.ribbon-light.ribbon-clip-bottom:before {\n  border-top-color: transparent;\n  border-bottom-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%);\n  border-right-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%);\n}\n\n.ribbon-light.ribbon-clip-bottom-right:before {\n  border-top-color: transparent;\n  border-bottom-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%);\n  border-right-color: transparent;\n  border-left-color: rgb(85.6862745098%, 85.6862745098%, 85.6862745098%);\n}\n\n.ribbon-dark {\n  background: #2c323f;\n}\n\n.ribbon-dark {\n  background: #2c323f;\n}\n\n.ribbon-bookmark.ribbon-dark:before {\n  border-color: #2c323f;\n  border-right-color: transparent;\n}\n.ribbon-bookmark.ribbon-right.ribbon-dark:before {\n  border-right-color: #2c323f;\n  border-left-color: transparent;\n}\n.ribbon-bookmark.ribbon-vertical-left.ribbon-dark:before, .ribbon-bookmark.ribbon-vertical-right.ribbon-dark:before {\n  border-right-color: #2c323f;\n  border-bottom-color: transparent;\n}\n\n.ribbon-dark.ribbon-corner:before {\n  border-top-color: #2c323f;\n  border-left-color: #2c323f;\n}\n.ribbon-dark.ribbon-corner.ribbon-right:before {\n  border-right-color: #2c323f;\n  border-left-color: transparent;\n}\n.ribbon-dark.ribbon-corner.ribbon-bottom:before {\n  border-top-color: transparent;\n  border-bottom-color: #2c323f;\n}\n\n.ribbon-dark.ribbon-clip:before {\n  border-color: transparent;\n  border-top-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%);\n  border-right-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%);\n}\n\n.ribbon-dark.ribbon-clip-right:before {\n  border-right-color: transparent;\n  border-top-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%);\n  border-left-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%);\n}\n\n.ribbon-dark.ribbon-clip-bottom:before {\n  border-top-color: transparent;\n  border-bottom-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%);\n  border-right-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%);\n}\n\n.ribbon-dark.ribbon-clip-bottom-right:before {\n  border-top-color: transparent;\n  border-bottom-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%);\n  border-right-color: transparent;\n  border-left-color: rgb(9.0306028954%, 10.2620487447%, 12.9301814184%);\n}\n\n.ribbon-warning {\n  background: #ffaa05;\n}\n\n.ribbon-warning {\n  background: #ffaa05;\n}\n\n.ribbon-bookmark.ribbon-warning:before {\n  border-color: #ffaa05;\n  border-right-color: transparent;\n}\n.ribbon-bookmark.ribbon-right.ribbon-warning:before {\n  border-right-color: #ffaa05;\n  border-left-color: transparent;\n}\n.ribbon-bookmark.ribbon-vertical-left.ribbon-warning:before, .ribbon-bookmark.ribbon-vertical-right.ribbon-warning:before {\n  border-right-color: #ffaa05;\n  border-bottom-color: transparent;\n}\n\n.ribbon-warning.ribbon-corner:before {\n  border-top-color: #ffaa05;\n  border-left-color: #ffaa05;\n}\n.ribbon-warning.ribbon-corner.ribbon-right:before {\n  border-right-color: #ffaa05;\n  border-left-color: transparent;\n}\n.ribbon-warning.ribbon-corner.ribbon-bottom:before {\n  border-top-color: transparent;\n  border-bottom-color: #ffaa05;\n}\n\n.ribbon-warning.ribbon-clip:before {\n  border-color: transparent;\n  border-top-color: rgb(81.9607843137%, 54.0941176471%, 0%);\n  border-right-color: rgb(81.9607843137%, 54.0941176471%, 0%);\n}\n\n.ribbon-warning.ribbon-clip-right:before {\n  border-right-color: transparent;\n  border-top-color: rgb(81.9607843137%, 54.0941176471%, 0%);\n  border-left-color: rgb(81.9607843137%, 54.0941176471%, 0%);\n}\n\n.ribbon-warning.ribbon-clip-bottom:before {\n  border-top-color: transparent;\n  border-bottom-color: rgb(81.9607843137%, 54.0941176471%, 0%);\n  border-right-color: rgb(81.9607843137%, 54.0941176471%, 0%);\n}\n\n.ribbon-warning.ribbon-clip-bottom-right:before {\n  border-top-color: transparent;\n  border-bottom-color: rgb(81.9607843137%, 54.0941176471%, 0%);\n  border-right-color: transparent;\n  border-left-color: rgb(81.9607843137%, 54.0941176471%, 0%);\n}\n\n/**=====================\n     56. Ribbon CSS Ends\n==========================**/\n/**=====================\n    18. Switch  CSS Start\n==========================**/\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 60px;\n  height: 34px;\n}\n.switch input {\n  display: none;\n}\n.switch input:checked + .switch-state {\n  background-color: var(--theme-default);\n}\n.switch input:checked + .switch-state:before {\n  transform: translateX(26px);\n}\n.switch input:focus + .switch-state {\n  box-shadow: 0 0 1px var(--theme-default);\n}\n\n.switch-state {\n  border-radius: 20px;\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #f4f4f4;\n  transition: 0.4s;\n}\n.switch-state:before {\n  position: absolute;\n  content: \"\";\n  height: 26px;\n  width: 26px;\n  left: 4px;\n  bottom: 4px;\n  background-color: #fff;\n  transition: 0.4s;\n  border-radius: 20px;\n}\n\n.icon-state .switch-state:after {\n  content: \"\\efb8\";\n  font-family: IcoFont;\n  left: 10px;\n  position: absolute;\n  top: 10px;\n  color: #2c323f;\n  transition: 0.4s;\n  opacity: 0.3;\n}\n.icon-state input:checked + .switch-state:after {\n  content: \"\\efad\";\n  left: 36px;\n  opacity: 1;\n  transition: 0.4s;\n}\n\n.switch-lg .switch {\n  width: 75px;\n  height: 40px;\n}\n.switch-lg .switch .switch-state:before {\n  height: 30px;\n  width: 30px;\n  left: 7px;\n  bottom: 5px;\n  top: 4px;\n}\n\n.switch-lg.icon-state .switch .switch-state:after {\n  left: 12px;\n  font-size: 18px;\n}\n.switch-lg.icon-state .switch input:checked + .switch-state:after {\n  left: 47px;\n}\n.switch-lg.icon-state .switch input:checked + .switch-state:before {\n  transform: translateX(32px);\n}\n\n.switch-sm.icon-state .switch .switch-state:after {\n  top: 4px;\n  left: 4px;\n  font-size: 8px;\n}\n.switch-sm.icon-state .switch input:checked + .switch-state:after {\n  left: 13px;\n  top: 4px;\n}\n.switch-sm .switch {\n  width: 25px;\n  height: 16px;\n  margin-top: 10px;\n  margin-bottom: 0px;\n}\n.switch-sm .switch .switch-state:before {\n  height: 8px;\n  width: 8px;\n  left: 4px;\n  bottom: 4px;\n}\n.switch-sm input:checked + .switch-state:before {\n  left: -13px;\n}\n\n.switch-outline .switch-state {\n  background-color: #fff;\n  border: 1px solid var(--theme-default);\n  transition: 0.4s;\n}\n.switch-outline .switch-state:before {\n  background-color: #f4f4f4;\n  bottom: 3px;\n  color: #fff;\n}\n\n.switch-outline .switch input {\n  display: none;\n}\n.switch-outline .switch input:checked + .switch-state {\n  background-color: transparent;\n  border: 1px solid var(--theme-default);\n}\n.switch-outline .switch input:checked + .switch-state:before {\n  background-color: var(--theme-default);\n  bottom: 3px;\n  transform: translateX(26px);\n}\n.switch-outline .switch input:checked + .switch-state:after {\n  color: #fff;\n}\n\n.switch-outline .switch-state.bg-primary {\n  border: 1px solid var(--theme-default);\n  background-color: transparent !important;\n}\n.switch-outline .switch input:checked + .switch-state.bg-primary {\n  background-color: transparent !important;\n  border: 1px solid var(--theme-default);\n}\n.switch-outline .switch input:checked + .switch-state.bg-primary:before {\n  background-color: var(--theme-default);\n}\n.switch-outline .switch-state.bg-dark {\n  border: 1px solid #2c323f;\n  background-color: transparent !important;\n}\n.switch-outline .switch input:checked + .switch-state.bg-dark {\n  background-color: transparent !important;\n  border: 1px solid #2c323f;\n}\n.switch-outline .switch input:checked + .switch-state.bg-dark:before {\n  background-color: #2c323f;\n}\n.switch-outline .switch-state.bg-warning {\n  border: 1px solid #ffaa05;\n  background-color: transparent !important;\n}\n.switch-outline .switch input:checked + .switch-state.bg-warning {\n  background-color: transparent !important;\n  border: 1px solid #ffaa05;\n}\n.switch-outline .switch input:checked + .switch-state.bg-warning:before {\n  background-color: #ffaa05;\n}\n.switch-outline .switch-state.bg-success {\n  border: 1px solid #54ba4a;\n  background-color: transparent !important;\n}\n.switch-outline .switch input:checked + .switch-state.bg-success {\n  background-color: transparent !important;\n  border: 1px solid #54ba4a;\n}\n.switch-outline .switch input:checked + .switch-state.bg-success:before {\n  background-color: #54ba4a;\n}\n.switch-outline .switch-state.bg-info {\n  border: 1px solid #16c7f9;\n  background-color: transparent !important;\n}\n.switch-outline .switch input:checked + .switch-state.bg-info {\n  background-color: transparent !important;\n  border: 1px solid #16c7f9;\n}\n.switch-outline .switch input:checked + .switch-state.bg-info:before {\n  background-color: #16c7f9;\n}\n.switch-outline .switch-state.bg-danger {\n  border: 1px solid #fc4438;\n  background-color: transparent !important;\n}\n.switch-outline .switch input:checked + .switch-state.bg-danger {\n  background-color: transparent !important;\n  border: 1px solid #fc4438;\n}\n.switch-outline .switch input:checked + .switch-state.bg-danger:before {\n  background-color: #fc4438;\n}\n.switch-outline .switch-state.bg-primary {\n  border: 1px solid var(--theme-default);\n  background-color: transparent !important;\n}\n.switch-outline .switch input:checked + .switch-state.bg-primary {\n  background-color: transparent !important;\n  border: 1px solid var(--theme-default);\n}\n.switch-outline .switch input:checked + .switch-state.bg-primary:before {\n  background-color: var(--theme-default);\n}\n.switch-outline .switch-state.bg-secondary {\n  border: 1px solid var(--theme-secondary);\n  background-color: transparent !important;\n}\n.switch-outline .switch input:checked + .switch-state.bg-secondary {\n  background-color: transparent !important;\n  border: 1px solid var(--theme-secondary);\n}\n.switch-outline .switch input:checked + .switch-state.bg-secondary:before {\n  background-color: var(--theme-secondary);\n}\n\n.switch-showcase {\n  margin-bottom: -8px;\n}\n.switch-showcase .media {\n  line-height: 1;\n}\n.switch-showcase .form-check .form-check-input {\n  float: right;\n}\n\n.form-switch .form-check-input:checked {\n  background-color: var(--theme-default);\n  border-color: var(--theme-default);\n}\n\n/**=====================\n     18. Switch  CSS Ends\n==========================**/\n/**=====================\n    44. Tabs CSS Start\n==========================**/\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  background-color: var(--theme-default);\n}\n\n.nav i {\n  margin-right: 10px;\n}\n\n.nav-right {\n  justify-content: flex-end;\n}\n\n.nav-theme .nav-link,\n.nav-pills.nav-theme .nav-link {\n  color: var(--theme-default);\n}\n.nav-theme .nav-link.active,\n.nav-theme .show > .nav-link,\n.nav-pills.nav-theme .nav-link.active,\n.nav-pills.nav-theme .show > .nav-link {\n  background-color: var(--theme-default);\n  color: #fff;\n}\n\n.nav-primary .nav-link,\n.nav-pills.nav-primary .nav-link {\n  color: var(--theme-default);\n}\n.nav-primary .nav-link.active,\n.nav-primary .show > .nav-link,\n.nav-pills.nav-primary .nav-link.active,\n.nav-pills.nav-primary .show > .nav-link {\n  background-color: var(--theme-default);\n  color: #fff;\n}\n\n.nav-secondary .nav-link,\n.nav-pills.nav-secondary .nav-link {\n  color: #ff3364;\n}\n.nav-secondary .nav-link.active,\n.nav-secondary .show > .nav-link,\n.nav-pills.nav-secondary .nav-link.active,\n.nav-pills.nav-secondary .show > .nav-link {\n  background-color: #ff3364;\n  color: #fff;\n}\n\n.nav-success .nav-link,\n.nav-pills.nav-success .nav-link {\n  color: #54ba4a;\n}\n.nav-success .nav-link.active,\n.nav-success .show > .nav-link,\n.nav-pills.nav-success .nav-link.active,\n.nav-pills.nav-success .show > .nav-link {\n  background-color: #54ba4a;\n  color: #fff;\n}\n\n.nav-danger .nav-link,\n.nav-pills.nav-danger .nav-link {\n  color: #fc4438;\n}\n.nav-danger .nav-link.active,\n.nav-danger .show > .nav-link,\n.nav-pills.nav-danger .nav-link.active,\n.nav-pills.nav-danger .show > .nav-link {\n  background-color: #fc4438;\n  color: #fff;\n}\n\n.nav-info .nav-link,\n.nav-pills.nav-info .nav-link {\n  color: #16c7f9;\n}\n.nav-info .nav-link.active,\n.nav-info .show > .nav-link,\n.nav-pills.nav-info .nav-link.active,\n.nav-pills.nav-info .show > .nav-link {\n  background-color: #16c7f9;\n  color: #fff;\n}\n\n.nav-light .nav-link,\n.nav-pills.nav-light .nav-link {\n  color: #f4f4f4;\n}\n.nav-light .nav-link.active,\n.nav-light .show > .nav-link,\n.nav-pills.nav-light .nav-link.active,\n.nav-pills.nav-light .show > .nav-link {\n  background-color: #f4f4f4;\n  color: #fff;\n}\n\n.nav-dark .nav-link,\n.nav-pills.nav-dark .nav-link {\n  color: #2c323f;\n}\n.nav-dark .nav-link.active,\n.nav-dark .show > .nav-link,\n.nav-pills.nav-dark .nav-link.active,\n.nav-pills.nav-dark .show > .nav-link {\n  background-color: #2c323f;\n  color: #fff;\n}\n\n.nav-warning .nav-link,\n.nav-pills.nav-warning .nav-link {\n  color: #ffaa05;\n}\n.nav-warning .nav-link.active,\n.nav-warning .show > .nav-link,\n.nav-pills.nav-warning .nav-link.active,\n.nav-pills.nav-warning .show > .nav-link {\n  background-color: #ffaa05;\n  color: #fff;\n}\n\n.nav-tabs.nav-bottom .nav-item .nav-link.active,\n.nav-tabs.nav-bottom .nav-item .nav-link.focus,\n.nav-tabs.nav-bottom .nav-item .nav-link.hover {\n  border-color: #fff #dee2e6 #dee2e6;\n}\n\n.tab-content ~ .nav-tabs.border-tab {\n  margin-bottom: 0;\n  margin-top: 30px;\n}\n\n.border-tab.nav-tabs {\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n  margin-bottom: 30px;\n}\n.border-tab.nav-tabs .nav-item .nav-link {\n  font-size: 16px;\n  color: #2c323f;\n  text-align: center;\n  padding: 10px 25px;\n  border: none;\n  border-bottom: none;\n  transition: 0.3s;\n}\n.border-tab.nav-tabs .nav-item .nav-link.active, .border-tab.nav-tabs .nav-item .nav-link.show, .border-tab.nav-tabs .nav-item .nav-link:focus, .border-tab.nav-tabs .nav-item .nav-link:hover {\n  color: var(--theme-default);\n}\n.border-tab.nav-tabs .nav-item .nav-link.active, .border-tab.nav-tabs .nav-item .nav-link.show, .border-tab.nav-tabs .nav-item .nav-link:focus {\n  border-bottom: none;\n}\n\n.border-tab.nav-left .nav-link {\n  border-left: 2px solid transparent;\n  transition: all 0.3s ease;\n  color: #2c323f;\n}\n.border-tab.nav-left .nav-link.active,\n.border-tab.nav-left .show > .nav-link {\n  background-color: transparent;\n  border-left-color: var(--theme-default);\n  color: var(--theme-default);\n  border-radius: 0;\n  transition: all 0.3s ease;\n}\n\n.border-tab.nav-right .nav-link {\n  border-right: 2px solid transparent;\n  transition: all 0.3s ease;\n  color: #2c323f;\n  text-align: right;\n}\n.border-tab.nav-right .nav-link.active,\n.border-tab.nav-right .show > .nav-link {\n  background-color: transparent;\n  border-right-color: var(--theme-default);\n  color: var(--theme-default);\n  border-radius: 0;\n  transition: all 0.3s ease;\n}\n\n.border-tab.nav-theme .nav-link.active,\n.border-tab.nav-theme .nav-item.show,\n.border-tab.nav-theme .nav-link:focus,\n.border-tab.nav-theme .nav-link:hover {\n  color: var(--theme-default);\n  background-color: transparent;\n}\n.border-tab.nav-theme .nav-item .nav-link {\n  transition: 0.3s;\n}\n.border-tab.nav-theme .nav-item .nav-link.active, .border-tab.nav-theme .nav-item .nav-link.show, .border-tab.nav-theme .nav-item .nav-link:focus {\n  border-bottom: 2px solid var(--theme-default);\n}\n.border-tab.nav-theme .nav-item .nav-link.active, .border-tab.nav-theme .nav-item .nav-link.show, .border-tab.nav-theme .nav-item .nav-link:focus, .border-tab.nav-theme .nav-item .nav-link:hover {\n  color: var(--theme-default);\n}\n\n.border-tab.nav-left.nav-theme .nav-link.active,\n.border-tab.nav-left.nav-theme .show > .nav-link {\n  border-left-color: var(--theme-default);\n  color: var(--theme-default);\n}\n\n.border-tab.nav-right.nav-theme .nav-link.active,\n.border-tab.nav-right.nav-theme .show > .nav-link {\n  border-right-color: var(--theme-default);\n  color: var(--theme-default);\n}\n\n.border-tab.nav-primary .nav-link.active,\n.border-tab.nav-primary .nav-item.show,\n.border-tab.nav-primary .nav-link:focus,\n.border-tab.nav-primary .nav-link:hover {\n  color: var(--theme-default);\n  background-color: transparent;\n}\n.border-tab.nav-primary .nav-item .nav-link {\n  transition: 0.3s;\n}\n.border-tab.nav-primary .nav-item .nav-link.active, .border-tab.nav-primary .nav-item .nav-link.show, .border-tab.nav-primary .nav-item .nav-link:focus {\n  border-bottom: 2px solid var(--theme-default);\n}\n.border-tab.nav-primary .nav-item .nav-link.active, .border-tab.nav-primary .nav-item .nav-link.show, .border-tab.nav-primary .nav-item .nav-link:focus, .border-tab.nav-primary .nav-item .nav-link:hover {\n  color: var(--theme-default);\n}\n\n.border-tab.nav-left.nav-primary .nav-link.active,\n.border-tab.nav-left.nav-primary .show > .nav-link {\n  border-left-color: var(--theme-default);\n  color: var(--theme-default);\n}\n\n.border-tab.nav-right.nav-primary .nav-link.active,\n.border-tab.nav-right.nav-primary .show > .nav-link {\n  border-right-color: var(--theme-default);\n  color: var(--theme-default);\n}\n\n.border-tab.nav-secondary .nav-link.active,\n.border-tab.nav-secondary .nav-item.show,\n.border-tab.nav-secondary .nav-link:focus,\n.border-tab.nav-secondary .nav-link:hover {\n  color: #ff3364;\n  background-color: transparent;\n}\n.border-tab.nav-secondary .nav-item .nav-link {\n  transition: 0.3s;\n}\n.border-tab.nav-secondary .nav-item .nav-link.active, .border-tab.nav-secondary .nav-item .nav-link.show, .border-tab.nav-secondary .nav-item .nav-link:focus {\n  border-bottom: 2px solid #ff3364;\n}\n.border-tab.nav-secondary .nav-item .nav-link.active, .border-tab.nav-secondary .nav-item .nav-link.show, .border-tab.nav-secondary .nav-item .nav-link:focus, .border-tab.nav-secondary .nav-item .nav-link:hover {\n  color: #ff3364;\n}\n\n.border-tab.nav-left.nav-secondary .nav-link.active,\n.border-tab.nav-left.nav-secondary .show > .nav-link {\n  border-left-color: #ff3364;\n  color: #ff3364;\n}\n\n.border-tab.nav-right.nav-secondary .nav-link.active,\n.border-tab.nav-right.nav-secondary .show > .nav-link {\n  border-right-color: #ff3364;\n  color: #ff3364;\n}\n\n.border-tab.nav-success .nav-link.active,\n.border-tab.nav-success .nav-item.show,\n.border-tab.nav-success .nav-link:focus,\n.border-tab.nav-success .nav-link:hover {\n  color: #54ba4a;\n  background-color: transparent;\n}\n.border-tab.nav-success .nav-item .nav-link {\n  transition: 0.3s;\n}\n.border-tab.nav-success .nav-item .nav-link.active, .border-tab.nav-success .nav-item .nav-link.show, .border-tab.nav-success .nav-item .nav-link:focus {\n  border-bottom: 2px solid #54ba4a;\n}\n.border-tab.nav-success .nav-item .nav-link.active, .border-tab.nav-success .nav-item .nav-link.show, .border-tab.nav-success .nav-item .nav-link:focus, .border-tab.nav-success .nav-item .nav-link:hover {\n  color: #54ba4a;\n}\n\n.border-tab.nav-left.nav-success .nav-link.active,\n.border-tab.nav-left.nav-success .show > .nav-link {\n  border-left-color: #54ba4a;\n  color: #54ba4a;\n}\n\n.border-tab.nav-right.nav-success .nav-link.active,\n.border-tab.nav-right.nav-success .show > .nav-link {\n  border-right-color: #54ba4a;\n  color: #54ba4a;\n}\n\n.border-tab.nav-danger .nav-link.active,\n.border-tab.nav-danger .nav-item.show,\n.border-tab.nav-danger .nav-link:focus,\n.border-tab.nav-danger .nav-link:hover {\n  color: #fc4438;\n  background-color: transparent;\n}\n.border-tab.nav-danger .nav-item .nav-link {\n  transition: 0.3s;\n}\n.border-tab.nav-danger .nav-item .nav-link.active, .border-tab.nav-danger .nav-item .nav-link.show, .border-tab.nav-danger .nav-item .nav-link:focus {\n  border-bottom: 2px solid #fc4438;\n}\n.border-tab.nav-danger .nav-item .nav-link.active, .border-tab.nav-danger .nav-item .nav-link.show, .border-tab.nav-danger .nav-item .nav-link:focus, .border-tab.nav-danger .nav-item .nav-link:hover {\n  color: #fc4438;\n}\n\n.border-tab.nav-left.nav-danger .nav-link.active,\n.border-tab.nav-left.nav-danger .show > .nav-link {\n  border-left-color: #fc4438;\n  color: #fc4438;\n}\n\n.border-tab.nav-right.nav-danger .nav-link.active,\n.border-tab.nav-right.nav-danger .show > .nav-link {\n  border-right-color: #fc4438;\n  color: #fc4438;\n}\n\n.border-tab.nav-info .nav-link.active,\n.border-tab.nav-info .nav-item.show,\n.border-tab.nav-info .nav-link:focus,\n.border-tab.nav-info .nav-link:hover {\n  color: #16c7f9;\n  background-color: transparent;\n}\n.border-tab.nav-info .nav-item .nav-link {\n  transition: 0.3s;\n}\n.border-tab.nav-info .nav-item .nav-link.active, .border-tab.nav-info .nav-item .nav-link.show, .border-tab.nav-info .nav-item .nav-link:focus {\n  border-bottom: 2px solid #16c7f9;\n}\n.border-tab.nav-info .nav-item .nav-link.active, .border-tab.nav-info .nav-item .nav-link.show, .border-tab.nav-info .nav-item .nav-link:focus, .border-tab.nav-info .nav-item .nav-link:hover {\n  color: #16c7f9;\n}\n\n.border-tab.nav-left.nav-info .nav-link.active,\n.border-tab.nav-left.nav-info .show > .nav-link {\n  border-left-color: #16c7f9;\n  color: #16c7f9;\n}\n\n.border-tab.nav-right.nav-info .nav-link.active,\n.border-tab.nav-right.nav-info .show > .nav-link {\n  border-right-color: #16c7f9;\n  color: #16c7f9;\n}\n\n.border-tab.nav-light .nav-link.active,\n.border-tab.nav-light .nav-item.show,\n.border-tab.nav-light .nav-link:focus,\n.border-tab.nav-light .nav-link:hover {\n  color: #f4f4f4;\n  background-color: transparent;\n}\n.border-tab.nav-light .nav-item .nav-link {\n  transition: 0.3s;\n}\n.border-tab.nav-light .nav-item .nav-link.active, .border-tab.nav-light .nav-item .nav-link.show, .border-tab.nav-light .nav-item .nav-link:focus {\n  border-bottom: 2px solid #f4f4f4;\n}\n.border-tab.nav-light .nav-item .nav-link.active, .border-tab.nav-light .nav-item .nav-link.show, .border-tab.nav-light .nav-item .nav-link:focus, .border-tab.nav-light .nav-item .nav-link:hover {\n  color: #f4f4f4;\n}\n\n.border-tab.nav-left.nav-light .nav-link.active,\n.border-tab.nav-left.nav-light .show > .nav-link {\n  border-left-color: #f4f4f4;\n  color: #f4f4f4;\n}\n\n.border-tab.nav-right.nav-light .nav-link.active,\n.border-tab.nav-right.nav-light .show > .nav-link {\n  border-right-color: #f4f4f4;\n  color: #f4f4f4;\n}\n\n.border-tab.nav-dark .nav-link.active,\n.border-tab.nav-dark .nav-item.show,\n.border-tab.nav-dark .nav-link:focus,\n.border-tab.nav-dark .nav-link:hover {\n  color: #2c323f;\n  background-color: transparent;\n}\n.border-tab.nav-dark .nav-item .nav-link {\n  transition: 0.3s;\n}\n.border-tab.nav-dark .nav-item .nav-link.active, .border-tab.nav-dark .nav-item .nav-link.show, .border-tab.nav-dark .nav-item .nav-link:focus {\n  border-bottom: 2px solid #2c323f;\n}\n.border-tab.nav-dark .nav-item .nav-link.active, .border-tab.nav-dark .nav-item .nav-link.show, .border-tab.nav-dark .nav-item .nav-link:focus, .border-tab.nav-dark .nav-item .nav-link:hover {\n  color: #2c323f;\n}\n\n.border-tab.nav-left.nav-dark .nav-link.active,\n.border-tab.nav-left.nav-dark .show > .nav-link {\n  border-left-color: #2c323f;\n  color: #2c323f;\n}\n\n.border-tab.nav-right.nav-dark .nav-link.active,\n.border-tab.nav-right.nav-dark .show > .nav-link {\n  border-right-color: #2c323f;\n  color: #2c323f;\n}\n\n.border-tab.nav-warning .nav-link.active,\n.border-tab.nav-warning .nav-item.show,\n.border-tab.nav-warning .nav-link:focus,\n.border-tab.nav-warning .nav-link:hover {\n  color: #ffaa05;\n  background-color: transparent;\n}\n.border-tab.nav-warning .nav-item .nav-link {\n  transition: 0.3s;\n}\n.border-tab.nav-warning .nav-item .nav-link.active, .border-tab.nav-warning .nav-item .nav-link.show, .border-tab.nav-warning .nav-item .nav-link:focus {\n  border-bottom: 2px solid #ffaa05;\n}\n.border-tab.nav-warning .nav-item .nav-link.active, .border-tab.nav-warning .nav-item .nav-link.show, .border-tab.nav-warning .nav-item .nav-link:focus, .border-tab.nav-warning .nav-item .nav-link:hover {\n  color: #ffaa05;\n}\n\n.border-tab.nav-left.nav-warning .nav-link.active,\n.border-tab.nav-left.nav-warning .show > .nav-link {\n  border-left-color: #ffaa05;\n  color: #ffaa05;\n}\n\n.border-tab.nav-right.nav-warning .nav-link.active,\n.border-tab.nav-right.nav-warning .show > .nav-link {\n  border-right-color: #ffaa05;\n  color: #ffaa05;\n}\n\n.tabbed-card ul {\n  position: absolute;\n  right: 22px;\n  top: 23px;\n  border-bottom: none;\n}\n.tabbed-card ul.border-tab.nav-tabs {\n  top: 12px;\n}\n.tabbed-card ul.border-tab.nav-tabs .nav-item {\n  float: right;\n}\n.tabbed-card ul.border-tab.nav-tabs .nav-item .nav-link {\n  padding: 23px 15px;\n}\n\n/**=====================\n     44. Tabs CSS Ends\n==========================**/\n/**=====================\n    25. Table  CSS Start\n==========================**/\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: #ecf3fa;\n}\n\n.pills-component {\n  width: 20%;\n}\n\n.table {\n  margin-bottom: 0px;\n}\n.table > :not(:last-child) > :last-child > * {\n  border-bottom-color: #ecf3fa;\n}\n.table th,\n.table td {\n  padding: 0.75rem;\n}\n.table.table-primary th {\n  color: #fff;\n}\n.table.table-primary td {\n  color: #fff;\n}\n.table thead.bg-primary tr th {\n  color: #fff;\n}\n.table thead.table-primary tr th {\n  color: #7366ff;\n}\n.table thead.table-success tr th {\n  color: #54ba4a;\n}\n.table tfoot.table-success tr td,\n.table tfoot.table-success tr th {\n  color: #54ba4a;\n}\n.table th {\n  color: #2f2f3b;\n  font-weight: 500;\n}\n.table td {\n  color: #2f2f3b;\n}\n.table [class*=bg-] {\n  color: #fff;\n}\n.table .bg-light {\n  color: #2f2f3b;\n}\n.table tfoot {\n  font-weight: bold;\n}\n\n.table-striped.table-styling > tbody > tr:nth-of-type(odd):hover > * {\n  color: #7366ff;\n}\n.table-striped.table-styling > tbody > tr:nth-of-type(odd) > * {\n  --bs-table-accent-bg: none;\n  color: #fff;\n}\n.table-striped.bg-primary > tbody > tr:nth-of-type(odd) {\n  background-color: rgba(245, 247, 250, 0.5);\n}\n.table-striped.bg-primary > tbody > tr:nth-of-type(odd) * {\n  color: #fff;\n}\n\n.table-dark th {\n  color: #fff;\n}\n\n.table-inverse {\n  color: #fff;\n  background-color: #292b2c;\n}\n.table-inverse th,\n.table-inverse td {\n  border-color: #fff;\n  color: #fff;\n}\n.table-inverse.table-bordered {\n  border: 0;\n}\n\n.table[class*=bg-] th,\n.table[class*=bg-] td {\n  color: #fff;\n}\n\n.table-hover > tbody > tr:hover {\n  --bs-table-accent-bg: unset;\n}\n\n.table-double {\n  border-left: 4px double #dee2e6;\n  border-right: 4px double #dee2e6;\n}\n.table-double thead,\n.table-double tbody,\n.table-double tfoot,\n.table-double tr,\n.table-double td,\n.table-double th {\n  border-style: double;\n  border-width: 4px;\n  border-right: 0;\n  border-left: 0;\n}\n\n.table-dotted {\n  border-left: 2px dotted #dee2e6;\n  border-right: 2px dotted #dee2e6;\n}\n.table-dotted thead,\n.table-dotted tbody,\n.table-dotted tfoot,\n.table-dotted tr,\n.table-dotted td,\n.table-dotted th {\n  border-style: dotted !important;\n  border-width: 2px;\n  border-right: 0;\n  border-left: 0;\n}\n\n.table-dashed {\n  border-left: 2px dashed #dee2e6;\n  border-right: 2px dashed #dee2e6;\n}\n.table-dashed thead,\n.table-dashed tbody,\n.table-dashed tfoot,\n.table-dashed tr,\n.table-dashed td,\n.table-dashed th {\n  border-style: dashed !important;\n  border-width: 2px;\n  border-right: 0;\n  border-left: 0;\n}\n\n.table-xl td,\n.table-xl th {\n  padding: 1.25rem 2rem;\n  font-size: 120%;\n}\n\n.table-lg td,\n.table-lg th {\n  padding: 0.9rem 2rem;\n  font-size: 110%;\n}\n\n.table-de td,\n.table-de th {\n  padding: 0.75rem 2rem;\n}\n\n.table-sm th,\n.table-sm td {\n  padding: 0.5rem 2rem;\n  font-size: 90%;\n}\n\n.table-xs th,\n.table-xs td {\n  padding: 0.2rem 2rem;\n  font-size: 80%;\n}\n\n.table-border-horizontal tr,\n.table-border-horizontal th,\n.table-border-horizontal td {\n  border-top: 1px solid #f2f4ff;\n  padding: 0.75rem;\n}\n\n.table-border-vertical tr,\n.table-border-vertical th,\n.table-border-vertical td {\n  border-top: 0;\n  border-right: 1px solid #f2f4ff;\n}\n.table-border-vertical tr td {\n  border-bottom: 0;\n}\n.table-border-vertical tr td:last-child {\n  border-right: none;\n}\n.table-border-vertical tbody tr th {\n  border-bottom: 0;\n}\n\n.table-bordernone td {\n  border: none !important;\n}\n.table-bordernone thead th {\n  border: none !important;\n}\n.table-bordernone .u-s-tb {\n  padding: 11px;\n}\n\n.table-striped tbody tr:nth-of-type(odd) {\n  --bs-table-accent-bg: rgba(245, 247, 250, 0.5);\n}\n\n.table-bordered thead,\n.table-bordered tbody,\n.table-bordered tfoot,\n.table-bordered tr,\n.table-bordered td,\n.table-bordered th {\n  border-color: #ecf3fa;\n}\n\n.grid-wrrapper .table-striped tbody tr:nth-of-type(odd) {\n  background-color: rgba(115, 102, 255, 0.1);\n  --bs-table-accent-bg: unset;\n}\n.grid-wrrapper .table-striped tbody tr:nth-of-type(odd) th,\n.grid-wrrapper .table-striped tbody tr:nth-of-type(odd) td {\n  color: #7366ff;\n}\n\n/**=====================\n     25.Table CSS Ends\n==========================**/\n.w-20 {\n  width: 20px;\n}\n\n.h-20 {\n  height: 20px;\n}\n\n.app-dark,\n.app-light {\n  display: flex;\n  justify-content: center;\n}\n\n.app-dark .react-timekeeper__clock-wrapper {\n  background-color: #7e7e7e;\n  padding: 18px 0;\n}\n.app-dark .react-timekeeper__clock-wrapper .react-timekeeper-button-reset {\n  color: #2f2f3b !important;\n}\n\n.App .react-timekeeper__clock-wrapper > div:last-of-type {\n  padding: 0 10px;\n  position: relative;\n  z-index: 7;\n  top: 0;\n}\n\n.App .react-timekeeper__top-bar {\n  padding: 4px;\n}\n\n.App .react-timekeeper__top-bar .react-timekeeper__tb-minute-wrapper {\n  width: auto;\n}\n\n.App .react-timekeeper__top-bar * {\n  font-size: 22px !important;\n}\n\n.App .react-timekeeper__done-button {\n  padding: 12px;\n}\n\n.timepicker-form .react-timekeeper__clock ~ div {\n  z-index: 7;\n}\n.timepicker-form .react-timekeeper__hand-circle-outer {\n  fill: var(--theme-default);\n}\n.timepicker-form .react-timekeeper__clock-hand {\n  stroke: var(--theme-default);\n}\n.timepicker-form .react-timekeeper__clock-wrapper .react-timekeeper-button-reset {\n  background-color: #e1eff6;\n}\n.timepicker-form .react-timekeeper__top-bar {\n  background-color: var(--theme-default) !important;\n}\n.timepicker-form .react-timekeeper__tb-hour,\n.timepicker-form .react-timekeeper__tb-colon,\n.timepicker-form .react-timekeeper__tb-minute,\n.timepicker-form .react-timekeeper-button-reset {\n  color: #fff !important;\n}\n.timepicker-form .row > div:last-child .card .card-body .theme-form div.mb-0 {\n  display: flex;\n  justify-content: space-around;\n}\n.timepicker-form .row > div:last-child .card .card-body .theme-form div.mb-0 .react-timekeeper:first-child .react-timekeeper__top-bar {\n  padding: 14px 8px;\n}\n\n@media screen and (max-width: 767px) {\n  .timepicker-form .row > div:last-child .card .card-body .theme-form div.mb-0 {\n    display: block;\n  }\n  .timepicker-form .row > div:last-child .card .card-body .theme-form div.mb-0 .react-timekeeper {\n    display: block;\n    margin: 0 auto;\n  }\n  .timepicker-form .row > div:last-child .card .card-body .theme-form div.mb-0 .react-timekeeper + .react-timekeeper {\n    margin-top: 15px;\n  }\n}\n@media screen and (max-width: 360px) {\n  .timepicker-form .row > div:last-child .card .card-body .theme-form div.mb-0 .react-timekeeper {\n    width: 240px !important;\n  }\n}\n/**=====================\n    20.  Touchspin  CSS Start\n==========================**/\n.bootstrap-touchspin input.touchspin {\n  padding: 0 12px;\n}\n.bootstrap-touchspin .input-group .btn {\n  padding: 0.5rem 1.75rem;\n}\n.bootstrap-touchspin .touchspin-vertical-tab .input-group .input-group-btn-vertical {\n  position: relative;\n  white-space: nowrap;\n  width: 1%;\n  vertical-align: middle;\n  display: table-cell;\n}\n.bootstrap-touchspin .touchspin-vertical-tab .input-group .input-group-btn-vertical .bootstrap-touchspin-down {\n  margin-top: -2px;\n}\n.bootstrap-touchspin .touchspin-vertical-tab .input-group .input-group-btn-vertical i {\n  position: absolute;\n  top: 4px;\n  left: 7px;\n  font-size: 10px;\n  font-weight: normal;\n}\n.bootstrap-touchspin .touchspin-vertical-tab .input-group .input-group-btn-vertical > .btn {\n  display: block;\n  float: none;\n  width: 100%;\n  max-width: 100%;\n  padding: 9px;\n  margin-left: -1px;\n  position: relative;\n}\n.bootstrap-touchspin .input-group {\n  font-family: Rubik, sans-serif;\n}\n.bootstrap-touchspin .input-group .btn {\n  border-radius: 0 !important;\n}\n.bootstrap-touchspin .dropdown-basic .dropdown .dropbtn {\n  padding: 9px 30px;\n}\n.bootstrap-touchspin .dropdown-basic .dropdown .dropdown-content {\n  z-index: 9999;\n}\n\n/**=====================\n     20. Touchspin  CSS Ends\n==========================**/\n/**=====================\n     54. Tour  CSS Start\n==========================**/\n.introjs-helperLayer {\n  background-color: rgba(255, 255, 255, 0.9);\n  border: 1px solid rgba(0, 0, 0, 0.5);\n  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.4);\n}\n\n.introjs-tooltipReferenceLayer {\n  background-color: transparent;\n}\n\n.introjs-helperNumberLayer {\n  color: #fff;\n  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);\n  background: #fc4438;\n  background: linear-gradient(to bottom, var(--theme-default) 0%, var(--theme-default) 100%);\n  border: 3px solid #fff;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.4);\n}\n\n.introjs-arrow {\n  border: 12px solid #fff;\n}\n.introjs-arrow.top {\n  border-top-color: transparent;\n  border-right-color: transparent;\n  border-bottom-color: var(--theme-default);\n  border-left-color: transparent;\n}\n.introjs-arrow.top-right {\n  border-top-color: transparent;\n  border-right-color: transparent;\n  border-bottom-color: var(--theme-default);\n  border-left-color: transparent;\n}\n.introjs-arrow.top-middle {\n  border-top-color: transparent;\n  border-right-color: transparent;\n  border-bottom-color: var(--theme-default);\n  border-left-color: transparent;\n}\n.introjs-arrow.right {\n  border-top-color: transparent;\n  border-right-color: transparent;\n  border-bottom-color: transparent;\n  border-left-color: var(--theme-default);\n}\n.introjs-arrow.right-bottom {\n  border-top-color: transparent;\n  border-right-color: transparent;\n  border-bottom-color: transparent;\n  border-left-color: var(--theme-default);\n}\n.introjs-arrow.bottom {\n  border-top-color: var(--theme-default);\n  border-right-color: transparent;\n  border-bottom-color: transparent;\n  border-left-color: transparent;\n}\n.introjs-arrow.left {\n  border-top-color: transparent;\n  border-right-color: var(--theme-default);\n  border-bottom-color: transparent;\n  border-left-color: transparent;\n}\n.introjs-arrow.left-bottom {\n  border-top-color: transparent;\n  border-right-color: var(--theme-default);\n  border-bottom-color: transparent;\n  border-left-color: transparent;\n}\n\n.introjs-tooltip {\n  background-color: var(--theme-default);\n  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.4);\n  color: #fff;\n  border-color: var(--theme-default);\n}\n\n.introjs-button {\n  border: 1px solid #efefef;\n  text-shadow: 1px 1px 0 #fff;\n  color: #2f2f3b !important;\n  background-color: #fff;\n  background-image: linear-gradient(#fff, #fff);\n}\n.introjs-button:hover {\n  border-color: #efefef;\n}\n.introjs-button:focus, .introjs-button:active {\n  background-image: linear-gradient(#ecf3fa, #efefef);\n}\n\n.introjs-skipbutton {\n  color: var(--theme-default);\n}\n\n.introjs-prevbutton.introjs-fullbutton {\n  border: 1px solid #efefef;\n}\n\n.introjs-disabled {\n  color: var(--theme-default);\n  border-color: #efefef;\n}\n.introjs-disabled:hover, .introjs-disabled:focus {\n  color: var(--theme-default);\n  border-color: #efefef;\n}\n\n.introjs-bullets ul li a {\n  background: #ecf3fa;\n}\n.introjs-bullets ul li a:hover {\n  background: #fff;\n}\n.introjs-bullets ul li a.active {\n  background: #fff;\n}\n\n.introjs-progress {\n  background-color: #f4f4f4;\n}\n\n.introjs-progressbar {\n  background-color: var(--theme-default);\n}\n\n.introjs-hint:hover > .introjs-hint-pulse {\n  border: 5px solid rgba(60, 60, 60, 0.57);\n}\n\n.introjs-hint-pulse {\n  border: 5px solid rgba(60, 60, 60, 0.27);\n  background-color: rgba(136, 136, 136, 0.24);\n}\n\n.introjs-hint-dot {\n  border: 10px solid rgba(146, 146, 146, 0.36);\n}\n\n/**=====================\n    54. Tour  CSS Ends\n==========================**/\n/**=====================\n     typahead-search  CSS Start\n==========================**/\n.Typeahead {\n  width: 100%;\n}\n.Typeahead * {\n  box-sizing: border-box;\n}\n.Typeahead *:before {\n  box-sizing: border-box;\n}\n.Typeahead *:after {\n  box-sizing: border-box;\n}\n.Typeahead .tt-hint {\n  display: none !important;\n}\n\n.u-cf:before {\n  content: \" \";\n  display: table;\n}\n.u-cf:after {\n  content: \" \";\n  display: table;\n  clear: both;\n}\n\n.u-hidden {\n  display: none !important;\n}\n\n.u-posRelative {\n  position: relative;\n}\n\n.Typeahead-spinner {\n  position: absolute;\n  top: 14px;\n  right: 18px;\n  display: none;\n  color: #c5c5c5;\n}\n\n.ProfileCard-avatar svg {\n  height: 18px;\n  vertical-align: bottom;\n}\n.ProfileCard-avatar svg path {\n  color: #7e7c7c !important;\n}\n.ProfileCard-avatar svg polygon {\n  color: #7e7c7c !important;\n}\n\n.Typeahead-hint {\n  width: 100%;\n  padding: 5px 8px;\n  font-size: 24px;\n  line-height: 30px;\n  border: 1px solid #024e6a;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  border-radius: 8px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  color: #ccd6dd;\n  opacity: 1;\n}\n\n.Typeahead-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  padding: 15px;\n  z-index: 100;\n  display: none;\n  width: 100%;\n  overflow: hidden;\n  background-color: #fff;\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n}\n\n.Typeahead-menu.is-open {\n  display: block;\n}\n\n.Typeahead-selectable {\n  cursor: pointer;\n}\n.Typeahead-selectable + .Typeahead-selectable {\n  border-top: 1px solid #ccd6dd;\n}\n\n.ProfileCard {\n  position: relative;\n  padding: 10px;\n  border: 1px solid #cccccc !important;\n  margin-bottom: 10px;\n  border-radius: 10px;\n}\n.ProfileCard:hover .ProfileCard-avatar {\n  border-color: #f5f8fa;\n}\n.ProfileCard:hover {\n  color: #414345;\n  background: #f8f8f8;\n}\n.ProfileCard:hover .ProfileCard-screenName {\n  color: #fff;\n}\n.ProfileCard:hover .ProfileCard-stat-label {\n  color: #fff;\n}\n\n.ProfileCard-avatar {\n  position: absolute;\n  border-radius: 5px;\n}\n\n.ProfileCard-details {\n  padding-left: 35px;\n  float: left;\n}\n\n.ProfileCard-realName {\n  display: inline-block;\n  color: #898989;\n}\n\n.ProfileCard-screenName {\n  display: inline-block;\n  color: #898989;\n}\n\n.ProfileCard-description {\n  margin-top: 5px;\n  font-size: 14px;\n  line-height: 18px;\n}\n\n.ProfileCard-stats {\n  float: right;\n  text-align: right;\n}\n\n.ProfileCard-stat {\n  display: inline-block;\n  font-size: 12px;\n  line-height: 16px;\n  text-transform: uppercase;\n}\n.ProfileCard-stat + .ProfileCard-stat {\n  margin-left: 5px;\n}\n\n.ProfileCard-stat-label {\n  color: #898989;\n  font-weight: 500;\n}\n\n.ProfileCard.is-active {\n  color: #fff;\n  background: var(--theme-default);\n}\n.ProfileCard.is-active .ProfileCard-screenName {\n  color: #fff;\n}\n.ProfileCard.is-active .ProfileCard-stat-label {\n  color: #fff;\n}\n\n.EmptyMessage {\n  position: relative;\n  padding: 10px;\n  font-size: 14px;\n  line-height: 30px;\n  text-align: center;\n}\n\n.Typeahead-spinner {\n  width: 1rem;\n  height: 1rem;\n}\n\n.Typeahead .stroke-icon {\n  stroke: #2f2f3b;\n}\n.Typeahead .fill-icon {\n  fill: #2f2f3b;\n}\n.Typeahead a {\n  color: #2f2f3b;\n}\n.Typeahead .header-search-suggestion {\n  max-height: 320px;\n  overflow: auto;\n}\n\nbody.dark-only .Typeahead .stroke-icon {\n  stroke: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .Typeahead .fill-icon {\n  fill: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .Typeahead a {\n  color: rgba(255, 255, 255, 0.6);\n}\n\n/**=====================\n    typahead-search CSS Ends\n==========================**/\n/**=====================\n      90. React-Plugin CSS Start\n==========================**/\n.simple-list .list-group-item {\n  padding: 0;\n  border: none;\n  background-color: transparent;\n}\n\nbody.dark-only .page-wrapper .list-group:not(.simple-list) .list-group-item,\n.list-group-item {\n  padding: 0;\n  border: none;\n  background-color: transparent;\n}\n\nimg.media {\n  display: unset;\n  border: none;\n  margin-bottom: 0;\n}\n\nul.list-group {\n  display: block;\n}\nul.list-group li.list-group-item.active {\n  background-color: transparent;\n  border-color: transparent;\n}\nul.list-group img {\n  width: auto;\n  height: auto;\n}\nul.list-group i {\n  margin-right: unset;\n}\n\n.slick-page .slick-slider {\n  margin: -8px 0 20px;\n}\n\n.slick-slider {\n  margin: -7px 0 0;\n}\n.slick-slider .item:focus {\n  outline: none;\n}\n.slick-slider .slick-dots li button:before {\n  font-size: 12px;\n  color: var(--theme-default);\n}\n.slick-slider .slick-dots li.slick-active button:before {\n  color: var(--theme-default);\n}\n\n.rangeslider-horizontal .rangeslider__fill,\n.rangeslider-vertical .rangeslider__fill {\n  background-color: var(--theme-default) !important;\n}\n.rangeslider-horizontal .rangeslider__handle:focus,\n.rangeslider-vertical .rangeslider__handle:focus {\n  outline: none;\n}\n\n.slider-vertical .value,\n.vertical-height .value {\n  text-align: center;\n}\n\n.rangeslider-vertical .rangeslider__labels {\n  margin: 0 0 0 32px !important;\n}\n\n.input-range__slider {\n  background: var(--theme-default);\n  border: 1px solid var(--theme-default);\n}\n\n.input-range__track--active {\n  background: var(--theme-default);\n}\n\n.input-range {\n  margin-bottom: 34px;\n}\n\n.dzu-dropzone {\n  border: 2px dashed var(--theme-default) !important;\n  background: rgba(115, 102, 255, 0.2);\n  overflow: auto !important;\n}\n.dzu-dropzone .dz-message .note {\n  background-color: transparent;\n}\n\n.dzu-inputLabel {\n  color: var(--theme-default) !important;\n  text-align: center;\n  margin-bottom: 0;\n}\n\n.dzu-previewContainer {\n  padding: 30px !important;\n  min-height: 115px;\n}\n\n.dzu-inputLabelWithFiles {\n  margin-left: 30px !important;\n  background-color: var(--theme-default) !important;\n  color: #fff !important;\n}\n\n.dzu-submitButton {\n  background-color: var(--theme-default) !important;\n}\n.dzu-submitButton:disabled {\n  background-color: #e6e6e6 !important;\n}\n\n.input-cropper {\n  margin-bottom: 15px;\n  border: 1px solid #ced4da;\n  padding: 10px;\n  border-radius: 4px;\n  width: auto;\n}\n.input-cropper input {\n  width: -webkit-fill-available;\n}\n\n.crop-portion {\n  margin-left: 0;\n  margin-top: 30px;\n  vertical-align: baseline;\n}\n\n.cropper-view-box {\n  outline-color: var(--theme-default);\n  outline: 1px solid var(--theme-default);\n}\n\n.cropper-point {\n  background-color: var(--theme-default);\n}\n\n.note {\n  background-color: rgba(115, 102, 255, 0.3);\n}\n.note:nth-child(2n) {\n  background: rgba(255, 51, 100, 0.3);\n}\n\n.react-stickies-wrapper .close:before, .react-stickies-wrapper .close:after {\n  background: transparent !important;\n}\n.react-stickies-wrapper .react-grid-layout .react-grid-item:nth-child(1n) .note {\n  background: white !important;\n}\n.react-stickies-wrapper .react-grid-layout .react-grid-item:nth-child(2n) .note {\n  background: rgb(100%, 90%, 92.4019607843%) !important;\n}\n.react-stickies-wrapper .react-grid-layout .react-grid-item:nth-child(3n) .note {\n  background: white !important;\n}\n.react-stickies-wrapper .react-grid-layout .react-grid-item:nth-child(4n) .note {\n  background: rgb(67.1211748298%, 92.0977930921%, 99.1533349742%) !important;\n}\n.react-stickies-wrapper .react-grid-layout .react-grid-item:nth-child(5n) .note {\n  background: rgb(100%, 90.4666666667%, 71.9607843137%) !important;\n}\n.react-stickies-wrapper .react-grid-layout .react-grid-item:nth-child(6n) .note {\n  background: rgb(99.5661036692%, 72.9537953795%, 71.2182100563%) !important;\n}\n\n.lead {\n  margin-bottom: 5px;\n}\n\n.swal2-container .swal2-actions .swal2-styled {\n  font-size: 14px;\n}\n\n.swal2-styled.swal2-confirm {\n  background-color: var(--theme-default) !important;\n}\n.swal2-styled.swal2-confirm:focus {\n  box-shadow: 0 0 0 1px #fff, 0 0 0 3px rgba(115, 102, 255, 0.4);\n}\n\n.swal2-title {\n  font-size: 20px !important;\n}\n\n.swal2-progress-steps .swal2-progress-step,\n.swal2-progress-steps .swal2-progress-step-line {\n  background: var(--theme-default) !important;\n}\n.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step {\n  background: var(--theme-default) !important;\n}\n.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step,\n.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step-line {\n  background: rgba(115, 102, 255, 0.2) !important;\n}\n\n.bootstrap-datetimepicker-widget tr th:active, .bootstrap-datetimepicker-widget tr th.active,\n.bootstrap-datetimepicker-widget tr td:active,\n.bootstrap-datetimepicker-widget tr td.active {\n  background-color: var(--theme-default);\n}\n.bootstrap-datetimepicker-widget tr th span:active, .bootstrap-datetimepicker-widget tr th span.active,\n.bootstrap-datetimepicker-widget tr td span:active,\n.bootstrap-datetimepicker-widget tr td span.active {\n  background-color: var(--theme-default);\n}\n\n.fileContainer {\n  padding: 0 !important;\n  margin: 0 !important;\n  box-shadow: none !important;\n}\n.fileContainer .files-gallery {\n  display: flex;\n  justify-content: center;\n}\n.fileContainer .files-gallery .files-gallery-item {\n  width: 45%;\n  display: flex;\n  margin: 0 auto;\n}\n.fileContainer .uploadPictureContainer {\n  margin: 1% !important;\n  padding: 10px;\n}\n.fileContainer .chooseFileButton {\n  margin-top: 0 !important;\n  padding: 6px 23px;\n  background: #ff3364;\n  border-radius: 30px;\n  color: #fff;\n  font-weight: 300;\n  font-size: 14px;\n  margin: 10px 0;\n  transition: all 0.2s ease-in;\n  cursor: pointer;\n  outline: none;\n  border: none;\n}\n\n.daterangepicker td.available:hover,\n.daterangepicker th.available:hover {\n  background-color: var(--theme-default);\n}\n\n.todo .action-box.large .icon .icon-trash,\n.todo .action-box.large .icon .icon-check {\n  color: var(--theme-default);\n}\n.todo .todo-list-wrapper #todo-list li.completed .task-container .task-label {\n  color: var(--theme-default);\n}\n@-webkit-keyframes taskHighlighter {\n  0% {\n    background: rgba(115, 102, 255, 0.5);\n  }\n  100% {\n    background: #fff;\n  }\n}\n@keyframes taskHighlighter {\n  0% {\n    background: rgba(115, 102, 255, 0.5);\n  }\n  100% {\n    background: #fff;\n  }\n}\n\n.react-clock__face {\n  border: 1px solid #fff !important;\n}\n\n.react-clock__mark__body,\n.react-clock__hand__body {\n  background-color: #fff !important;\n}\n\n.scrollarea {\n  max-width: 800px;\n  max-height: 300px;\n}\n.scrollarea .scrollbar-container {\n  z-index: 7 !important;\n}\n\nol.progtrckr {\n  list-style-type: none;\n  padding: 0;\n  display: flex;\n}\nol.progtrckr li {\n  display: inline-block;\n  text-align: center;\n  line-height: 4.5rem;\n  cursor: pointer;\n  width: 100%;\n}\nol.progtrckr li span {\n  padding: 0 1.5rem;\n}\nol.progtrckr li.progtrckr-doing {\n  color: black;\n  border-bottom: 4px solid #cccccc;\n}\nol.progtrckr li.progtrckr-doing:before {\n  content: \"•\";\n  color: white;\n  background-color: #cccccc;\n  width: 1.2em;\n  line-height: 1.2em;\n  border-radius: 1.2em;\n}\nol.progtrckr li.progtrckr-doing:hover:before {\n  color: #ff4500;\n}\nol.progtrckr li.progtrckr-done {\n  color: black;\n  border-bottom: 4px solid #5cb85c;\n}\nol.progtrckr li.progtrckr-done:before {\n  content: \"✓\";\n  color: white;\n  background-color: #5cb85c;\n  width: 1.2em;\n  line-height: 1.2em;\n  border-radius: 1.2em;\n}\nol.progtrckr li.progtrckr-done:hover:before {\n  color: #333;\n}\nol.progtrckr li:after {\n  content: \"  \";\n}\nol.progtrckr li:before {\n  position: relative;\n  bottom: -3.7rem;\n  float: left;\n  left: 50%;\n}\nol.progtrckr li.progtrckr-todo:before {\n  content: \"Ο\";\n  color: silver;\n  background-color: transparent;\n  width: 1.2em;\n  line-height: 1.4em;\n}\nol.progtrckr li.progtrckr-todo:hover:before {\n  color: #ff4500;\n}\n\n.rbc-calendar {\n  height: 1000px !important;\n}\n\n#external-events {\n  position: absolute;\n  z-index: 2;\n  padding: 0 10px;\n  border: 1px solid #ccc;\n  background: #eee;\n  overflow: auto;\n}\n#external-events p strong {\n  font-size: 16px;\n}\n\n#external-events .fc-event {\n  margin: 1em 0;\n  cursor: move;\n}\n\n.rbt-token {\n  color: var(--theme-default) !important;\n  background-color: rgba(115, 102, 255, 0.1) !important;\n}\n.rbt-token .rbt-token-remove-button {\n  top: 1px !important;\n}\n\n.rbt-aux .rbt-close {\n  margin-top: 0;\n}\n\n.react_times_button .wrapper {\n  display: block;\n}\n\n.basic-calendar .demo-app-calendar .fc-daygrid-day-events .fc-event {\n  background-color: #7366ff;\n  border: 1px solid #7366ff;\n  color: white;\n  font-size: 11.9px;\n  padding: 0 10px;\n}\n.basic-calendar .demo-app-calendar .fc-daygrid-day-events .fc-event .fc-daygrid-event-dot {\n  display: none;\n}\n.basic-calendar .demo-app-calendar .fc-daygrid-day-events .fc-event .fc-event-time {\n  display: none;\n}\n.basic-calendar .fc-scrollgrid a {\n  color: var(--body-font-color);\n}\n.basic-calendar .calendar-basic #external-events {\n  background-color: #fff;\n}\n\n.time_picker_wrapper2 {\n  display: flex;\n}\n.time_picker_wrapper2 .time_picker_container {\n  width: 44%;\n}\n.time_picker_wrapper2 .gap {\n  padding: 0 5px;\n}\n\n.Toastify__close-button {\n  font-weight: 500;\n}\n.Toastify__close-button svg {\n  stroke: #fff !important;\n  fill: #fff !important;\n}\n\n.Toastify__toast--success {\n  background: rgb(53.4611764706%, 81.2211764706%, 50.7396078431%) !important;\n  color: #fff !important;\n  font-weight: 500;\n}\n.Toastify__toast--success svg {\n  fill: transparent !important;\n  stroke: #fff !important;\n}\n.Toastify__toast--success .Toastify__progress-bar {\n  background: rgb(80.8211764706%, 92.2611764706%, 79.6996078431%) !important;\n}\n\n.Toastify__toast--info {\n  background: rgb(37.8743129051%, 85.0685043892%, 98.4001968988%) !important;\n  color: #fff !important;\n}\n.Toastify__toast--info svg {\n  fill: transparent !important;\n  stroke: #fff !important;\n}\n.Toastify__toast--info .Toastify__progress-bar {\n  background: rgb(76.8701288047%, 94.4408893264%, 99.4043809993%) !important;\n}\n\n.Toastify__toast--warning {\n  background: rgb(100%, 70.0666666667%, 11.9607843137%) !important;\n  color: #fff !important;\n}\n.Toastify__toast--warning svg {\n  fill: transparent !important;\n  stroke: #fff !important;\n}\n.Toastify__toast--warning .Toastify__progress-bar {\n  background: rgb(100%, 76.8666666667%, 31.9607843137%) !important;\n}\n\n.Toastify__toast--error {\n  background: rgb(99.1205591147%, 45.1815181518%, 41.6637546108%) !important;\n  color: #fff !important;\n  font-weight: 500;\n}\n.Toastify__toast--error svg {\n  fill: transparent !important;\n  stroke: #fff !important;\n}\n.Toastify__toast--error .Toastify__progress-bar {\n  background: rgb(99.4175888177%, 63.696369637%, 61.3667249078%) !important;\n}\n\n.draggable-card > div > div {\n  width: 100%;\n  display: flex;\n}\n.draggable-card > div > div .react-kanban-column {\n  width: 100%;\n}\n.draggable-card > div > div .react-kanban-card {\n  min-width: 100%;\n  max-width: 100%;\n}\n\n.ui-sortable .react-kanban-board div[data-rbd-droppable-id=board-droppable] {\n  width: 100%;\n  display: flex;\n}\n.ui-sortable .react-kanban-board .react-kanban-column {\n  width: 100%;\n}\n.ui-sortable .react-kanban-board .react-kanban-card {\n  max-width: 100%;\n}\n\n.jkanban-container .custom-board .kanban-drag .react-kanban-column:nth-child(2) div[data-rbd-drag-handle-context-id=\"1\"] {\n  background-color: #ffaa05;\n}\n.jkanban-container .custom-board .kanban-drag .react-kanban-column:nth-child(2) div[data-rbd-drag-handle-context-id=\"1\"] ~ div {\n  background-color: rgba(255, 170, 5, 0.3);\n}\n.jkanban-container .custom-board .kanban-drag .react-kanban-column:nth-child(3) div[data-rbd-drag-handle-context-id=\"1\"] {\n  background-color: #54ba4a;\n}\n.jkanban-container .custom-board .kanban-drag .react-kanban-column:nth-child(3) div[data-rbd-drag-handle-context-id=\"1\"] ~ div {\n  background-color: rgba(84, 186, 74, 0.3);\n}\n.jkanban-container .custom-board .kanban-drag div[data-rbd-drag-handle-context-id=\"1\"] {\n  background-color: #16c7f9;\n  color: #fff;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n}\n.jkanban-container .custom-board .kanban-drag div[data-rbd-drag-handle-context-id=\"1\"] ~ div {\n  background-color: rgba(22, 199, 249, 0.3);\n  border-bottom-left-radius: 15px;\n  border-bottom-right-radius: 15px;\n}\n.jkanban-container .custom-board .kanban-drag div[data-rbd-drag-handle-context-id=\"1\"] span {\n  font-weight: 500;\n}\n.jkanban-container .custom-board .kanban-drag div[data-rbd-drag-handle-context-id=\"1\"] span.badge {\n  font-weight: 400;\n}\n.jkanban-container .kanban-container {\n  display: flex;\n}\n.jkanban-container .kanban-container .kanban-board {\n  width: 100%;\n}\n.jkanban-container .kanban-container .kanban-item .customers ul.simple-list li {\n  background-color: transparent;\n}\n.jkanban-container .kanban-container .kanban-item .customers ul.simple-list li + li img {\n  margin: 0;\n}\n.jkanban-container .kanban-container .kanban-item:focus {\n  outline: none;\n}\n.jkanban-container .kanban-container .kanban-item .kanban-box {\n  border: 1px solid #efefef;\n  background-color: #fff !important;\n  color: #2f2f3b;\n}\n.jkanban-container .kanban-container .kanban-item .kanban-box:focus {\n  outline: none;\n}\n.jkanban-container .kanban-container .kanban-drag {\n  width: 100%;\n}\n.jkanban-container .kanban-container .kanban-drag .react-kanban-column-header {\n  font-weight: 500;\n}\n.jkanban-container .kanban-container .kanban-drag .react-kanban-column-header:focus {\n  outline: none;\n}\n.jkanban-container .kanban-container .kanban-drag .react-kanban-column-header > div:focus {\n  outline: none;\n}\n.jkanban-container .kanban-container .kanban-drag > div {\n  padding: 0;\n}\n.jkanban-container .kanban-container .kanban-drag > div > div {\n  display: flex;\n  width: 100%;\n  margin-bottom: -25px;\n}\n.jkanban-container .kanban-container .kanban-drag > div > div .react-kanban-column {\n  width: 98%;\n  background-color: #f8f8f8;\n  border-radius: 8px;\n  padding: 0;\n  margin-bottom: 30px;\n}\n.jkanban-container .kanban-container .kanban-drag > div > div .react-kanban-column > div {\n  width: 100%;\n  padding: 20px;\n  font-size: 16px;\n}\n.jkanban-container .kanban-container .kanban-drag > div > div .react-kanban-column > div[data-rbd-drag-handle-context-id=\"0\"], .jkanban-container .kanban-container .kanban-drag > div > div .react-kanban-column > div[data-rbd-drag-handle-context-id=\"2\"] {\n  border-bottom: 1px solid #efefef;\n}\n.jkanban-container .kanban-container .kanban-drag > div > div .react-kanban-column > div p {\n  font-weight: 400;\n}\n.jkanban-container .kanban-container .kanban-drag > div > div .react-kanban-column > div > div {\n  padding-bottom: 0;\n}\n.jkanban-container .kanban-container .kanban-drag > div > div .react-kanban-column .react-kanban-board > div {\n  width: 100%;\n}\n.jkanban-container .kanban-container .kanban-drag > div > div .react-kanban-column .react-kanban-board + .react-kanban-board {\n  margin-top: 20px;\n}\n.jkanban-container .react-kanban-column {\n  background-color: #f8f8f8;\n}\n.jkanban-container .react-kanban-column > div > div > div {\n  display: block !important;\n}\n.jkanban-container .react-kanban-column div[tabindex=\"0\"] + div[tabindex=\"0\"] {\n  margin-top: 20px;\n}\n\n.ui-sortable .container {\n  display: block;\n  width: 100%;\n  padding: 10px;\n  background-color: var(--theme-default);\n}\n.ui-sortable .container div {\n  padding: 10px;\n  background-color: rgb(43.2679738562%, 38%, 100%);\n  transition: opacity 0.4s ease-in-out;\n  color: #fff;\n}\n.ui-sortable .container div {\n  cursor: move;\n  cursor: grab;\n  cursor: -moz-grab;\n  cursor: -webkit-grab;\n  margin-bottom: 10px;\n}\n.ui-sortable .container div:last-child {\n  margin-bottom: 0;\n}\n.ui-sortable .container.ex-moved {\n  background-color: #e74c3c;\n}\n.ui-sortable .container.ex-over {\n  background-color: var(--theme-default);\n}\n.ui-sortable .container:nth-child(odd) {\n  background-color: var(--theme-default);\n}\n\n.gh-fork {\n  position: fixed;\n  top: 0;\n  right: 0;\n  border: 0;\n}\n\n.gu-mirror {\n  padding: 10px;\n  background-color: rgb(35.9477124183%, 30%, 100%);\n  transition: opacity 0.4s ease-in-out;\n  color: #fff;\n  position: fixed !important;\n  margin: 0 !important;\n  z-index: 9999 !important;\n  opacity: 0.8;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=80)\";\n  filter: alpha(opacity=80);\n}\n\n.gu-hide {\n  display: none !important;\n}\n\n.gu-unselectable {\n  -webkit-user-select: none !important;\n  -moz-user-select: none !important;\n  -ms-user-select: none !important;\n  user-select: none !important;\n}\n\n.gu-transit {\n  opacity: 0.2;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=20)\";\n  filter: alpha(opacity=20);\n}\n\n.wrapper {\n  display: table;\n}\n\n.gu-mirror {\n  cursor: grabbing;\n  cursor: -moz-grabbing;\n  cursor: -webkit-grabbing;\n}\n\n.handle {\n  padding: 0 5px;\n  margin-right: 5px;\n  background-color: rgb(17.6470588235%, 10%, 100%);\n  cursor: move;\n}\n\n.vertical-timeline::before {\n  background: #f4f4f4;\n}\n.vertical-timeline .vertical-timeline-element p {\n  font-size: 13px !important;\n}\n.vertical-timeline .vertical-timeline-element .vertical-timeline-element-icon {\n  color: #fff;\n}\n.vertical-timeline .vertical-timeline-element:first-child .vertical-timeline-element-icon, .vertical-timeline .vertical-timeline-element:nth-child(7) .vertical-timeline-element-icon {\n  background-color: var(--theme-default);\n}\n.vertical-timeline .vertical-timeline-element:nth-child(2) .vertical-timeline-element-icon {\n  background-color: #ff3364;\n}\n.vertical-timeline .vertical-timeline-element:nth-child(3) .vertical-timeline-element-icon, .vertical-timeline .vertical-timeline-element:last-child .vertical-timeline-element-icon {\n  background-color: #54ba4a;\n}\n.vertical-timeline .vertical-timeline-element:nth-child(4) .vertical-timeline-element-icon {\n  background-color: #16c7f9;\n}\n.vertical-timeline .vertical-timeline-element:nth-child(5) .vertical-timeline-element-icon {\n  background-color: #ffaa05;\n}\n.vertical-timeline .vertical-timeline-element:nth-child(6) .vertical-timeline-element-icon {\n  background-color: #fc4438;\n}\n\n.vertical-timeline-element-content {\n  box-shadow: 1px 1px 2px 1px rgba(0, 0, 0, 0.08);\n  background-color: #fdfeff;\n}\n.vertical-timeline-element-content audio {\n  width: 100%;\n  margin-top: 15px;\n}\n.vertical-timeline-element-content .vertical-timeline-element-date {\n  font-size: 14px !important;\n}\n.vertical-timeline-element-content .vertical-timeline-element-content-arrow {\n  border-right: 7px solid #f4f4f4;\n}\n\n.vertical-timeline--two-columns .vertical-timeline-element-content .vertical-timeline-element-date {\n  top: 10px !important;\n}\n\n.vertical-timeline--one-column:before {\n  left: 28px !important;\n}\n.vertical-timeline--one-column .vertical-timeline-element-icon {\n  width: 60px;\n  height: 60px;\n}\n.vertical-timeline--one-column .vertical-timeline-element-content {\n  margin-left: 90px;\n}\n.vertical-timeline--one-column .vertical-timeline-element-content img {\n  width: 500px;\n}\n.vertical-timeline--one-column .vertical-timeline-element-content .vertical-timeline-element-date {\n  float: none;\n  display: block;\n}\n\n.rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(4) .rdt_TableCol_Sortable {\n  justify-content: center;\n}\n.rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(4) .rdt_TableCol_Sortable span {\n  display: none;\n}\n.rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol .rdt_TableCol_Sortable {\n  justify-content: flex-start;\n}\n.rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol .rdt_TableCol_Sortable > div {\n  font-weight: 500 !important;\n}\n.rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell {\n  padding: 12px;\n}\n.rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4) {\n  justify-content: center !important;\n}\n.rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell + .rdt_TableCell {\n  justify-content: flex-start;\n}\n\n.leaflet-top,\n.leaflet-bottom {\n  z-index: 7 !important;\n}\n\n.leaflet-pane {\n  z-index: 1 !important;\n}\n\n.map-block svg g {\n  transform-origin: 0 0;\n}\n\n#gmap-simple svg path {\n  fill: var(--theme-default) !important;\n}\n\n#usa svg path {\n  fill: #ff3364 !important;\n}\n\n#canada svg path {\n  fill: #54ba4a !important;\n}\n\n#asia svg path {\n  fill: #ffaa05 !important;\n}\n\n#europe svg path {\n  fill: #fc4438 !important;\n}\n\n#america svg path {\n  fill: #2c323f !important;\n}\n\n.ace_editor {\n  width: auto !important;\n  overflow: auto;\n}\n\n.carousal .slick-slider .slick-slide {\n  margin-right: 15px;\n}\n\n.jvectormap-zoomin,\n.jvectormap-zoomout {\n  width: 20px;\n  height: 20px;\n}\n\n.jvectormap-zoomin {\n  bottom: 65px;\n}\n\n.jvectormap-zoomout {\n  bottom: 30px;\n}\n\n.jvectormap-zoomin,\n.jvectormap-zoomout,\n.jvectormap-goback {\n  position: absolute;\n  border-radius: 3px;\n  background: #292929;\n  padding: 5px;\n  color: #fff;\n  cursor: pointer;\n  text-align: center;\n  box-sizing: content-box;\n}\n\n.rating {\n  align-items: center;\n}\n.rating span .fa {\n  color: var(--theme-default);\n}\n.rating span span span {\n  color: var(--theme-default);\n}\n\n@media screen and (max-width: 600px) {\n  .jkanban-container .kanban-container .kanban-drag {\n    padding: 0;\n  }\n  .jkanban-container .kanban-container .kanban-drag > div {\n    width: 100% !important;\n  }\n  .jkanban-container .kanban-container .kanban-drag > div > div div[data-rbd-drag-handle-context-id=\"1\"] {\n    width: 100% !important;\n  }\n}\n.page-wrapper .page-header .header-wrapper .bookmark-flip {\n  width: unset !important;\n  box-shadow: unset !important;\n  background-color: transparent !important;\n  overflow: initial;\n}\n.page-wrapper .page-header .header-wrapper .bookmark-flip .Typeahead-menu {\n  background-color: transparent !important;\n  box-shadow: none;\n  left: -1px;\n  max-height: 85px;\n  overflow: auto;\n  top: 75px;\n}\n.page-wrapper .page-header .header-wrapper .bookmark-flip .Typeahead-menu .ProfileCard-realName {\n  width: 100%;\n}\n.page-wrapper .page-header .header-wrapper .bookmark-flip .Typeahead-menu .ProfileCard-details {\n  float: unset;\n  text-align: left;\n}\n.page-wrapper .page-header .header-wrapper .bookmark-flip .Typeahead-menu .ProfileCard {\n  border: none !important;\n  padding: 8px;\n  position: relative;\n  margin: 0;\n}\n.page-wrapper .page-header .header-wrapper .bookmark-flip .Typeahead-menu .ProfileCard:hover {\n  background-color: var(--chart-border);\n}\n.page-wrapper .page-header .header-wrapper .bookmark-flip .Typeahead-menu .ProfileCard .realname {\n  text-transform: capitalize !important;\n  text-decoration: none;\n}\n.page-wrapper .page-header .header-wrapper .bookmark-flip .Typeahead-menu .ProfileCard .pull-right {\n  margin-left: auto;\n}\n.page-wrapper .page-header .header-wrapper .flip-card {\n  width: 220px;\n  height: 245px;\n  background-color: transparent;\n}\n.page-wrapper .page-header .header-wrapper .flip-card .flip-card-inner {\n  position: relative;\n  height: 100%;\n  text-align: center;\n  transition: transform 0.6s;\n  transform-style: preserve-3d;\n}\n.page-wrapper .page-header .header-wrapper .flip-card .flip-card-inner .back {\n  position: absolute;\n  backface-visibility: hidden;\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 0 20px rgba(89, 102, 122, 0.1);\n  width: 220px;\n  height: auto;\n}\n.page-wrapper .page-header .header-wrapper .flip-card .flip-card-inner .back button {\n  background-color: transparent;\n  color: #7366ff;\n  border: none;\n}\n.page-wrapper .page-header .header-wrapper .flip-card .flip-card-inner .back button:focus {\n  outline: transparent;\n}\n.page-wrapper .page-header .header-wrapper .flip-card .flip-card-inner .back {\n  background-color: #fff;\n  transform: rotateY(180deg);\n}\n.page-wrapper .page-header .header-wrapper .flip-card .flip-card-inner .back li:first-child {\n  height: 160px !important;\n  margin-top: 0 !important;\n}\n.page-wrapper .page-header .header-wrapper .flip-card .flip-card-inner .back li:last-child {\n  padding: 20px 0;\n  border-top: 1px solid var(--chart-border);\n}\n.page-wrapper .page-header .header-wrapper .flip-card .flip-card-inner .back button {\n  width: 100%;\n}\n.page-wrapper .page-header .header-wrapper .flip-card .flip-card-inner .back .flip-back-content .Typeahead-menu {\n  max-height: 85px;\n}\n.page-wrapper .page-header .header-wrapper .flip-card .flip-card-inner .back .flip-back-content input {\n  border-radius: 8px;\n  padding: 6px 12px;\n  width: 100%;\n  border: 1px solid var(--chart-border);\n}\n.page-wrapper .page-header .header-wrapper .flip-card .flip-card-inner .back .flip-back-content input:focus {\n  outline: unset;\n}\n.page-wrapper .page-header .header-wrapper .flip-card .flip-card-inner.flipped {\n  transform: rotateY(180deg);\n}\n.page-wrapper .page-header .header-wrapper .flip-card .flip-card-inner.flipped .front {\n  opacity: 0;\n}\n\n.default-datepicker .rdp {\n  margin: 0;\n}\n.default-datepicker .rdp-caption_label {\n  padding: 0;\n}\n.default-datepicker .rdp-nav_button {\n  padding: 0;\n  background: transparent !important;\n  width: unset;\n  height: unset;\n}\n.default-datepicker .rdp-nav_button svg {\n  width: 11px;\n  height: 11px;\n}\n.default-datepicker .rdp-caption_label {\n  color: #2b2b2b;\n  font-size: 20px;\n  font-weight: 500;\n}\n.default-datepicker .rdp-head_cell span {\n  color: #2b2b2b;\n  font-size: 14px;\n  font-weight: bold;\n}\n\n/**=====================\n      90. React-Plugin CSS Ends\n==========================**/\n.product-table.table-bordernone .rdt_Table {\n  border: 1px solid var(--chart-border);\n}\n.product-table.table-bordernone .rdt_Table .rdt_TableHead .rdt_TableHeadRow {\n  border: none;\n}\n.product-table.table-bordernone .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol {\n  border: none;\n}\n.product-table.table-bordernone .rdt_Table .rdt_TableBody .rdt_TableRow {\n  border: none;\n}\n.product-table.orderHistoryTable .order-process {\n  color: #242934;\n  font-weight: 400;\n}\n.product-table.orderHistoryTable .rdt_TableBody .rdt_TableCell div {\n  color: var(--body-font-color);\n  font-weight: 400;\n  font-size: 14px;\n}\n.product-table .gKbhqU {\n  border: none;\n}\n.product-table .rdt_Table {\n  border: 1px solid var(--chart-border);\n}\n.product-table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol {\n  border: none;\n}\n.product-table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol h6, .product-table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol .h6 {\n  margin: 0;\n}\n.product-table .rdt_TableHeadRow .rdt_TableCol {\n  vertical-align: middle;\n  border-top: none;\n  border: 1px solid var(--chart-border);\n  font-size: 16px;\n  font-weight: 600;\n}\n.product-table .rdt_TableHeadRow .rdt_TableCol,\n.product-table .rdt_TableBody .rdt_TableRow .rdt_TableCell {\n  padding: 0.75rem;\n}\n.product-table .rdt_TableBody .rdt_TableRow:nth-child(odd) {\n  background-color: rgb(246, 246, 246);\n  border-color: var(--chart-border);\n}\n.product-table .rdt_TableBody .rdt_TableRow:nth-child(even) {\n  background-color: #fff;\n  border-color: var(--chart-border);\n}\n.product-table .rdt_TableBody .rdt_TableRow:hover {\n  background-color: rgb(246, 246, 246);\n}\n.product-table .rdt_TableBody .rdt_TableRow .rdt_TableCell {\n  vertical-align: middle;\n  color: #999999;\n  font-weight: 600;\n}\n.product-table .rdt_TableBody .rdt_TableRow .rdt_TableCell .product-name a {\n  font-size: 15px;\n  color: #898989;\n  line-height: 25px;\n}\n.product-table .rdt_TableBody .rdt_TableRow .rdt_TableCell .product-name .order-process {\n  font-size: 13px;\n  padding-left: 15px;\n}\n.product-table .rdt_TableBody .rdt_TableRow .rdt_TableCell .product-name .order-process .order-process-circle {\n  position: relative;\n}\n.product-table .rdt_TableBody .rdt_TableRow .rdt_TableCell .product-name .order-process .order-process-circle:before {\n  position: absolute;\n  content: \"\";\n  width: 4px;\n  height: 4px;\n  border-radius: 100%;\n  background-color: #898989;\n  left: -15px;\n  top: 6px;\n}\n.product-table .rdt_TableBody .rdt_TableRow .rdt_TableCell .product-name .order-process .order-process-circle.shipped-order:before {\n  background-color: #54ba4a;\n}\n.product-table .rdt_TableBody .rdt_TableRow .rdt_TableCell .product-name .order-process .order-process-circle.cancel-order:before {\n  background-color: #fc4438;\n}\n.product-table .rdt_TableBody .rdt_TableRow .rdt_TableCell.total-amount {\n  color: #2f2f3b;\n}\n.product-table .product-name h6, .product-table .product-name .h6 {\n  color: #2f2f3b;\n  margin-bottom: unset;\n  font-size: 14px;\n}\n.product-table .product-name span {\n  color: #2f2f3b;\n}\n\n.email-compose .cke_chrome {\n  border: none;\n}\n.email-compose .cke_top {\n  border: none;\n  padding-left: 0;\n  padding-right: 0;\n  background-color: transparent;\n}\n.email-compose .cke_bottom {\n  display: none;\n}\n\n.theme-text {\n  color: var(--body-font-color);\n}\n\n.focuse-none:focus {\n  border: none;\n  box-shadow: none;\n  outline: unset;\n}\n\n.input-group-text-none .input-group-text {\n  display: none;\n}\n\n.img-40 {\n  width: 40px;\n  height: 40px;\n}\n\n.deni-react-treeview-container.classic {\n  width: 100%;\n}\n.deni-react-treeview-container.classic .deni-react-treeview-item-container.classic .treeview-item-example {\n  display: flex;\n}\n.deni-react-treeview-container.classic .deni-react-treeview-item-container.classic .actionButton {\n  margin-left: 6px;\n}\n\nbody.dark-only .gYaFyO {\n  border-bottom: var(--chart-border);\n}\nbody.dark-only .gYaFyO:hover {\n  border-color: var(--chart-border);\n}\nbody.dark-only .qty-box .input-group-prepend {\n  padding: 0;\n}\n\n.datetime-picker .input-group {\n  flex-wrap: unset;\n}\n.datetime-picker .react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {\n  right: 96px;\n}\n\n.react-datepicker__day--keyboard-selected,\n.react-datepicker__month-text--keyboard-selected,\n.react-datepicker__quarter-text--keyboard-selected,\n.react-datepicker__year-text--keyboard-selected {\n  background-color: #7366ff;\n}\n\n.react-datepicker__day--selected,\n.react-datepicker__day--in-selecting-range,\n.react-datepicker__day--in-range,\n.react-datepicker__month-text--selected,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--selected,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--selected,\n.react-datepicker__year-text--in-selecting-range,\n.react-datepicker__year-text--in-range {\n  background-color: #7366ff;\n}\n\n.react-datepicker__day--selected:hover,\n.react-datepicker__day--in-selecting-range:hover,\n.react-datepicker__day--in-range:hover,\n.react-datepicker__month-text--selected:hover,\n.react-datepicker__month-text--in-selecting-range:hover,\n.react-datepicker__month-text--in-range:hover,\n.react-datepicker__quarter-text--selected:hover,\n.react-datepicker__quarter-text--in-selecting-range:hover,\n.react-datepicker__quarter-text--in-range:hover,\n.react-datepicker__year-text--selected:hover,\n.react-datepicker__year-text--in-selecting-range:hover,\n.react-datepicker__year-text--in-range:hover {\n  background-color: #7366ff;\n}\n\n.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range),\n.react-datepicker__month-text--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range),\n.react-datepicker__quarter-text--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range),\n.react-datepicker__year-text--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range) {\n  background-color: rgba(115, 102, 255, 0.2);\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n  background-color: #7366ff;\n}\n\n.react-datepicker__close-icon::after {\n  background-color: #7366ff;\n}\n\n.date-range-picker .daterange-card {\n  padding-bottom: 10px;\n}\n.date-range-picker .react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {\n  right: 96px;\n}\n\n.date-picker .cal-date-widget .react-datepicker {\n  border: none;\n  padding: 8px 16px 0;\n  width: 100%;\n}\n.date-picker .cal-date-widget .react-datepicker__navigation {\n  top: 20px;\n}\n.date-picker .cal-date-widget .react-datepicker__day--keyboard-selected {\n  background-color: #7366ff;\n}\n.date-picker .cal-date-widget .react-datepicker__navigation-icon::before {\n  border-width: 2px 2px 0 0;\n  width: 8px;\n  height: 8px;\n}\n.date-picker .cal-date-widget .react-datepicker__day-name,\n.date-picker .cal-date-widget .react-datepicker__day,\n.date-picker .cal-date-widget .react-datepicker__time-name {\n  height: 32px;\n}\n.date-picker .cal-date-widget .react-datepicker__day--outside-month {\n  color: #cccccc;\n}\n.date-picker .cal-date-widget .react-datepicker__day:hover,\n.date-picker .cal-date-widget .react-datepicker__month-text:hover,\n.date-picker .cal-date-widget .react-datepicker__quarter-text:hover,\n.date-picker .cal-date-widget .react-datepicker__year-text:hover {\n  background-color: #7366ff;\n  color: #fff;\n}\n\n.react-datepicker {\n  border: 1px solid #efefef;\n}\n\n.react-datepicker__header {\n  background-color: #fff;\n  border: none;\n}\n\n.react-datepicker__navigation {\n  background-color: #7366ff;\n  border-radius: 20px;\n  color: #fff;\n  top: 13px;\n}\n.react-datepicker__navigation.react-datepicker__navigation--previous {\n  left: 4px;\n}\n.react-datepicker__navigation.react-datepicker__navigation--next {\n  right: 4px;\n}\n\n.react-datepicker__day--selected {\n  background-color: #7366ff;\n  border-radius: 10px;\n}\n.react-datepicker__day--selected:hover {\n  background-color: #7366ff;\n}\n\n.react-datepicker__navigation-icon--next {\n  left: -3px;\n}\n\n.react-datepicker__navigation-icon {\n  top: 0px;\n}\n\n.react-datepicker__current-month,\n.react-datepicker-time__header,\n.react-datepicker-year-header {\n  color: #7366ff;\n  padding: 10px 10px 20px;\n}\n\n.react-datepicker__navigation-icon--previous {\n  right: 0;\n}\n\n.react-datepicker__day-name {\n  font-weight: bold;\n}\n\n.react-datepicker__week,\n.react-datepicker__day {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.react-datepicker__navigation-icon--next::before,\n.react-datepicker__navigation-icon--previous::before {\n  top: 10px;\n  left: -3px;\n  border-color: #fff;\n}\n\n.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,\n.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {\n  margin-left: -10px;\n}\n\n.support-table .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(4) .rdt_TableCol_Sortable {\n  justify-content: flex-start;\n}\n.support-table .rdt_Table .rdt_TableBody .rdt_TableRow {\n  border-color: var(--chart-border);\n}\n.support-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4) {\n  justify-content: start !important;\n}\n\n.loader-wrapper.loderhide {\n  display: none;\n}\n\n/* Slider test*/\n.slick-slider {\n  position: relative;\n  display: block;\n  box-sizing: border-box;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -ms-touch-action: pan-y;\n  touch-action: pan-y;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.slick-list {\n  position: relative;\n  overflow: hidden;\n  display: block;\n  margin: 0;\n  padding: 0;\n}\n.slick-list:focus {\n  outline: none;\n}\n.slick-list.dragging {\n  cursor: pointer;\n  cursor: hand;\n}\n\n.slick-slider .slick-track,\n.slick-slider .slick-list {\n  -webkit-transform: translate3d(0, 0, 0);\n  -moz-transform: translate3d(0, 0, 0);\n  -ms-transform: translate3d(0, 0, 0);\n  -o-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n}\n\n.slick-track {\n  position: relative;\n  left: 0;\n  top: 0;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n.slick-track:before, .slick-track:after {\n  content: \"\";\n  display: table;\n}\n.slick-track:after {\n  clear: both;\n}\n.slick-loading .slick-track {\n  visibility: hidden;\n}\n\n.slick-slide {\n  float: left;\n  height: 100%;\n  min-height: 1px;\n}\n[dir=rtl] .slick-slide {\n  float: right;\n}\n.slick-slide img {\n  display: block;\n}\n.slick-slide.slick-loading img {\n  display: none;\n}\n.slick-slide {\n  display: none;\n}\n.slick-slide.dragging img {\n  pointer-events: none;\n}\n.slick-initialized .slick-slide {\n  display: block;\n}\n.slick-loading .slick-slide {\n  visibility: hidden;\n}\n.slick-vertical .slick-slide {\n  display: block;\n  height: auto;\n  border: 1px solid transparent;\n}\n\n.slick-arrow.slick-hidden {\n  display: none;\n}\n\n/* Icons */\n@font-face {\n  font-family: \"slick\";\n  src: url(\"../../fonts/slick.eot\");\n  src: url(\"../../fonts/slick.eot?#iefix\") format(\"embedded-opentype\"), url(\"../../fonts/slick.woff\") format(\"woff\"), url(\"../../fonts/slick.ttf\") format(\"truetype\"), url(\"../../fonts/slick.svg#slick\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n}\n/* Arrows */\n.slick-prev,\n.slick-next {\n  position: absolute;\n  display: block;\n  height: 20px;\n  width: 20px;\n  line-height: 0px;\n  font-size: 0px;\n  cursor: pointer;\n  background: transparent;\n  color: transparent;\n  top: 50%;\n  -webkit-transform: translate(0, -50%);\n  -ms-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n  padding: 0;\n  border: none;\n  outline: none;\n}\n.slick-prev:hover, .slick-prev:focus,\n.slick-next:hover,\n.slick-next:focus {\n  outline: none;\n  background: transparent;\n  color: transparent;\n}\n.slick-prev:hover:before, .slick-prev:focus:before,\n.slick-next:hover:before,\n.slick-next:focus:before {\n  opacity: 1;\n}\n.slick-prev.slick-disabled:before,\n.slick-next.slick-disabled:before {\n  opacity: 0.25;\n}\n.slick-prev:before,\n.slick-next:before {\n  font-family: \"slick\";\n  font-size: 20px;\n  line-height: 1;\n  color: white;\n  opacity: 0.75;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.slick-prev {\n  left: -25px;\n}\n[dir=rtl] .slick-prev {\n  left: auto;\n  right: -25px;\n}\n.slick-prev:before {\n  content: \"←\";\n}\n[dir=rtl] .slick-prev:before {\n  content: \"→\";\n}\n\n.slick-next {\n  right: -25px;\n}\n[dir=rtl] .slick-next {\n  left: -25px;\n  right: auto;\n}\n.slick-next:before {\n  content: \"→\";\n}\n[dir=rtl] .slick-next:before {\n  content: \"←\";\n}\n\n/* Dots */\n.slick-dotted.slick-slider {\n  margin-bottom: 30px;\n}\n\n.slick-dots {\n  position: absolute;\n  bottom: -25px;\n  list-style: none;\n  display: block;\n  text-align: center;\n  padding: 0;\n  margin: 0;\n  width: 100%;\n}\n.slick-dots li {\n  position: relative;\n  display: inline-block;\n  height: 20px;\n  width: 20px;\n  margin: 0 5px;\n  padding: 0;\n  cursor: pointer;\n}\n.slick-dots li button {\n  border: 0;\n  background: transparent;\n  display: block;\n  height: 20px;\n  width: 20px;\n  outline: none;\n  line-height: 0px;\n  font-size: 0px;\n  color: transparent;\n  padding: 5px;\n  cursor: pointer;\n}\n.slick-dots li button:hover, .slick-dots li button:focus {\n  outline: none;\n}\n.slick-dots li button:hover:before, .slick-dots li button:focus:before {\n  opacity: 1;\n}\n.slick-dots li button:before {\n  position: absolute;\n  top: 0;\n  left: 0;\n  content: \"•\";\n  width: 20px;\n  height: 20px;\n  font-family: \"slick\";\n  font-size: 6px;\n  line-height: 20px;\n  text-align: center;\n  color: black;\n  opacity: 0.25;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.slick-dots li.slick-active button:before {\n  color: black;\n  opacity: 0.75;\n}\n\n/*=============Scrollable css start=============*/\n.ps-container.ps-active-y > .ps-scrollbar-y-rail, .ps-container.ps-active-x > .ps-scrollbar-x-rail {\n  background-color: transparent;\n  display: block;\n}\n\n.scroll-demo {\n  padding: 10px;\n  position: relative;\n  border: 1px solid #f4f4f4;\n  overflow: auto;\n  height: 300px;\n}\n.scroll-demo .horz-scroll-content {\n  width: 1600px;\n}\n\n.ps-container {\n  touch-action: none;\n  overflow: hidden !important;\n}\n.ps-container.ps-in-scrolling {\n  pointer-events: none;\n}\n.ps-container.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail {\n  background-color: #f4f4f4;\n  opacity: 0.9;\n}\n.ps-container.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail > .ps-scrollbar-x {\n  background-color: #59667a;\n}\n.ps-container.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail {\n  background-color: #f4f4f4;\n  opacity: 0.9;\n}\n.ps-container.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail > .ps-scrollbar-y {\n  background-color: #59667a;\n}\n.ps-container > .ps-scrollbar-x-rail {\n  display: none;\n  position: absolute;\n  border-radius: 4px;\n  opacity: 0;\n  transition: background-color 0.2s linear, opacity 0.2s linear;\n  bottom: 3px;\n  height: 8px;\n}\n.ps-container > .ps-scrollbar-x-rail > .ps-scrollbar-x {\n  position: absolute;\n  background-color: #59667a;\n  border-radius: 4px;\n  transition: background-color 0.2s linear;\n  bottom: 0;\n  height: 8px;\n}\n.ps-container > .ps-scrollbar-y-rail {\n  right: 3px;\n  width: 8px;\n  display: none;\n  position: absolute;\n  border-radius: 4px;\n  opacity: 0;\n  transition: background-color 0.2s linear, opacity 0.2s linear;\n}\n.ps-container > .ps-scrollbar-y-rail > .ps-scrollbar-y {\n  width: 10px;\n  position: absolute;\n  background-color: #59667a;\n  border-radius: 4px;\n  transition: background-color 0.2s linear;\n  right: 0;\n}\n.ps-container:hover.ps-in-scrolling {\n  pointer-events: none;\n}\n.ps-container:hover.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail {\n  background-color: #59667a;\n  opacity: 0.9;\n}\n.ps-container:hover.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail > .ps-scrollbar-x {\n  width: 128px;\n  background-color: #999999;\n}\n.ps-container:hover.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail {\n  background-color: #59667a;\n  opacity: 0.9;\n}\n.ps-container:hover.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail > .ps-scrollbar-y {\n  background-color: #999999;\n}\n.ps-container:hover > .ps-scrollbar-x-rail {\n  opacity: 0.6;\n}\n.ps-container:hover > .ps-scrollbar-x-rail:hover {\n  background-color: #f4f4f4;\n  opacity: 0.9;\n}\n.ps-container:hover > .ps-scrollbar-x-rail:hover > .ps-scrollbar-x {\n  background-color: #999999;\n}\n.ps-container:hover > .ps-scrollbar-y-rail {\n  opacity: 0.6;\n}\n.ps-container:hover > .ps-scrollbar-y-rail:hover {\n  background-color: #f4f4f4;\n  opacity: 0.9;\n}\n.ps-container:hover > .ps-scrollbar-y-rail:hover > .ps-scrollbar-y {\n  background-color: #59667a;\n}\n.always-visible.ps-container > .ps-scrollbar-x-rail {\n  opacity: 0.6;\n}\n.always-visible.ps-container > .ps-scrollbar-y-rail {\n  opacity: 0.6;\n}\n\n.large-margin.ps-container > .ps-scrollbar-x-rail {\n  margin: 0 25%;\n}\n.large-margin.ps-container > .ps-scrollbar-y-rail {\n  margin: 100px 0;\n}\n\n/*=============Scrollable css end=============*/\n/**=====================\n    46. Blog CSS start\n==========================**/\n.blog-box img {\n  border-radius: 0.25rem;\n}\n.blog-box .top-radius-blog {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.blog-box h6, .blog-box .h6 {\n  font-weight: 600;\n  margin: 15px 0;\n}\n.blog-box .blog-details {\n  padding-right: 20px;\n}\n.blog-box .blog-details .blog-social {\n  margin-top: 30px;\n}\n.blog-box .blog-details .blog-social li {\n  display: inline-block;\n  font-size: 12px;\n  color: #52526c;\n}\n.blog-box .blog-details .blog-social li + li {\n  padding-left: 20px;\n  padding-right: 0;\n}\n.blog-box .blog-details .blog-social li i {\n  padding-right: 5px;\n  font-weight: 300;\n}\n.blog-box .blog-details .blog-social li:first-child {\n  border-right: 1px solid gray;\n  padding-right: 20px;\n}\n.blog-box .blog-details-main hr {\n  background-color: #cccccc;\n}\n.blog-box .blog-details-main .blog-social {\n  margin: 20px 0;\n}\n.blog-box .blog-details-main .blog-social li {\n  display: inline-block;\n  font-size: 12px;\n  color: #52526c;\n  padding: 0 24px;\n  border-right: 1px dotted;\n}\n@media (max-width: 1676px) {\n  .blog-box .blog-details-main .blog-social li {\n    padding: 0 10px;\n  }\n}\n.blog-box .blog-details-main .blog-social li:last-child {\n  border-right: 0;\n}\n.blog-box .blog-details-main .blog-social li i {\n  padding-right: 5px;\n}\n.blog-box .blog-details-main .blog-bottom-details {\n  margin: 20px;\n  font-size: 14px;\n  line-height: 1.714;\n  font-weight: 500;\n}\n.blog-box .blog-date {\n  color: #52526c;\n}\n.blog-box .blog-date span {\n  font-size: 36px;\n  font-weight: 500;\n  padding-right: 5px;\n}\n\n.blog-box.blog-shadow:before {\n  box-shadow: inset 0px -200px 100px -13px rgba(0, 0, 0, 0.6);\n  transition: all 0.3s ease;\n  border-radius: 5px;\n  content: \"\";\n  position: absolute;\n  height: 100%;\n  top: 0;\n  width: 100%;\n  bottom: 0;\n}\n.blog-box.blog-shadow:hover:before {\n  box-shadow: inset 0px -200px 100px -13px rgba(0, 0, 0, 0.65);\n  transition: all 0.3s ease;\n}\n.blog-box.blog-shadow .blog-details {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  padding: 20px;\n}\n.blog-box.blog-shadow .blog-details h4, .blog-box.blog-shadow .blog-details .h4 {\n  color: #fff;\n  margin-bottom: 0;\n}\n.blog-box.blog-shadow .blog-details p {\n  font-size: 14px;\n  color: #fff;\n  margin-bottom: 10px;\n}\n.blog-box.blog-shadow .blog-details .blog-social li {\n  color: #fff;\n}\n\n.blog-list .blog-details .blog-social {\n  margin-top: 0;\n}\n.blog-list .blog-details h6, .blog-list .blog-details .h6 {\n  margin-top: 0;\n  color: gray;\n  font-weight: 500;\n}\n.blog-list .blog-details hr {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.blog-list img {\n  padding: 17px;\n}\n\n.blog-grid img {\n  width: 100%;\n}\n.blog-grid .blog-details {\n  padding: 20px;\n}\n.blog-grid .blog-details h6, .blog-grid .blog-details .h6 {\n  font-size: 14px;\n  margin-bottom: 0;\n  line-height: 1.8;\n}\n\n.blog-box {\n  position: relative;\n  max-height: 100%;\n  align-items: center;\n}\n.blog-box .blog-details h6, .blog-box .blog-details .h6 {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  -webkit-line-clamp: 1;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n.blog-box .blog-details p {\n  font-size: 14px;\n  line-height: 1.8;\n  letter-spacing: 0.7px;\n  margin-top: 30px;\n  margin-bottom: 0;\n  color: #52526c;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  -webkit-line-clamp: 3;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n@media (max-width: 1570px) {\n  .blog-box .blog-details p {\n    -webkit-line-clamp: 2;\n  }\n}\n.blog-box .blog-details h4, .blog-box .blog-details .h4 {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 1.5;\n  margin-top: 20px;\n  margin-bottom: 0;\n}\n.blog-box .blog-details .single-blog-content-top {\n  margin-top: 20px;\n  border-top: 1px solid #efefef;\n}\n.blog-box .blog-details .blog-social li,\n.blog-box .blog-details .comment-social li {\n  font-size: 14px;\n}\n\n.comment-box {\n  padding-top: 50px;\n  padding-bottom: 50px;\n}\n.comment-box hr {\n  margin-top: 20px;\n  margin-bottom: 30px;\n}\n.comment-box li {\n  margin-bottom: 30px;\n}\n.comment-box li:last-child {\n  margin-bottom: 0;\n}\n.comment-box ul ul {\n  margin-left: 135px;\n}\n.comment-box p {\n  font-size: 14px;\n  line-height: 2;\n  color: #52526c;\n  text-align: justify;\n  margin-bottom: 0;\n}\n.comment-box h4, .comment-box .h4 {\n  font-weight: 600;\n}\n.comment-box .media img {\n  margin-right: 30px;\n  border-radius: 10px;\n  height: 90px;\n  padding: 7px;\n  width: 90px;\n  border: 1px solid #efefef;\n}\n.comment-box .media h6, .comment-box .media .h6 {\n  font-weight: 500;\n  margin-bottom: 5px;\n}\n.comment-box .media h6 span, .comment-box .media .h6 span {\n  padding-left: 10px;\n  font-size: 13px;\n  color: #52526c;\n  font-weight: 400;\n}\n.comment-box .comment-social li {\n  display: inline-block;\n  color: #cccccc;\n  padding-left: 20px;\n  margin-bottom: 0;\n  text-transform: uppercase;\n}\n.comment-box .comment-social li:first-child {\n  border-right: 1px solid #efefef;\n  padding-right: 20px;\n}\n.comment-box .comment-social li i {\n  padding-right: 10px;\n}\n\n.add-post .cke_top, .add-post .cke_bottom {\n  background-color: transparent;\n}\n\n/**=====================\n    46. Blog CSS ends\n==========================**/\n/**=====================\n     85. bookmark app CSS Start\n==========================**/\n.modal-dialog.modal-bookmark .modal-body,\n.modal-dialog.modal-bookmark .modal-header {\n  padding: 25px;\n}\n.modal-dialog.modal-bookmark .modal-header {\n  border-bottom: 1px solid #dee2e6 !important;\n}\n.modal-dialog.modal-bookmark .modal-header .btn-close {\n  position: relative;\n  top: 0;\n  right: 0;\n  margin-left: auto;\n}\n\n.modal-header {\n  padding: 25px !important;\n}\n\n.bookmark-wrap .btn-mail {\n  color: var(--theme-default) !important;\n}\n.bookmark-wrap .row .col-xl-3 + .col-xl-3 {\n  padding-right: 15px;\n}\n.bookmark-wrap .left-bookmark ul li a {\n  color: #2f2f3b;\n}\n.bookmark-wrap .left-bookmark ul li button {\n  border: none;\n  cursor: pointer;\n}\n.bookmark-wrap .left-bookmark ul li button:focus {\n  outline: none;\n}\n.bookmark-wrap .left-bookmark ul li svg {\n  width: 18px;\n  height: 18px;\n  vertical-align: sub;\n}\n.bookmark-wrap .left-bookmark ul li > .main-title {\n  color: var(--theme-default);\n  font-weight: 600;\n  margin-bottom: 5px;\n  display: block;\n}\n.bookmark-wrap .left-bookmark ul li > .main-title span a:hover {\n  background-color: transparent;\n}\n.bookmark-wrap .left-bookmark ul li > .main-title svg {\n  color: #898989;\n  stroke-width: 1px;\n}\n.bookmark-wrap .left-bookmark ul li a > .title {\n  text-transform: capitalize;\n}\n\n.email-wrap .email-right-aside .email-body.radius-left.card {\n  border-radius: 0 15px 15px 0;\n}\n.email-wrap .email-right-aside .email-body.card {\n  border-radius: 15px 0 0 15px;\n}\n\n.form-bookmark .form-row {\n  display: flex;\n  flex-wrap: wrap;\n}\n.form-bookmark .form-row .fill-color {\n  width: 35px;\n  height: 30px;\n  padding: 3px;\n}\n.form-bookmark a {\n  text-transform: capitalize !important;\n  color: var(--theme-default) !important;\n  line-height: 1 !important;\n  font-weight: 500;\n}\n.form-bookmark a:hover {\n  background-color: transparent !important;\n}\n.form-bookmark input#index_var {\n  display: none;\n}\n.form-bookmark .form-group input,\n.form-bookmark .form-group select {\n  font-size: 14px;\n}\n.form-bookmark .form-group .select2-container .select2-selection--single {\n  border-color: #ced4da !important;\n}\n.form-bookmark .form-group .select2 {\n  width: 100% !important;\n}\n.form-bookmark .form-group .error {\n  margin: 0 !important;\n  font-size: 11px;\n  color: red !important;\n}\n\n.email-wrap.bookmark-wrap .email-body.radius-left.card {\n  border-radius: 15px;\n}\n\n.modal .bookmark-modal.modal-header {\n  padding: 22px;\n}\n\n.contact-profile {\n  margin: 0 auto;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  width: fit-content;\n}\n.contact-profile .img-100 {\n  height: 100px !important;\n}\n.contact-profile .upload {\n  position: absolute;\n  top: 0;\n  opacity: 0;\n}\n.contact-profile .icon-wrapper {\n  text-align: right;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: 35px;\n  height: 35px;\n  background: #fff;\n  border-radius: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n@keyframes displayTransition {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n.bookmark-tabcontent .details-bookmark {\n  height: auto;\n  min-height: 359px;\n}\n.bookmark-tabcontent .details-bookmark .bookmark-card {\n  position: relative;\n  height: 91%;\n}\n.bookmark-tabcontent .details-bookmark .bookmark-card.card .favourite-icon {\n  padding: 3px;\n  border-radius: 4px;\n  background-color: rgba(0, 0, 0, 0.2);\n  width: 30px;\n  position: absolute;\n  right: 15px;\n  top: 15px;\n  opacity: 0;\n  text-align: center;\n}\n.bookmark-tabcontent .details-bookmark .bookmark-card.card .favourite-icon i {\n  color: #fff;\n  font-size: 16px;\n  vertical-align: text-bottom;\n}\n.bookmark-tabcontent .details-bookmark .bookmark-card.card .favourite-icon.favourite i {\n  color: #fed112;\n}\n.bookmark-tabcontent .details-bookmark .bookmark-card.card .desciption-data {\n  width: 100%;\n}\n.bookmark-tabcontent .details-bookmark .bookmark-card.card .desciption-data .content-general {\n  display: none;\n}\n.bookmark-tabcontent .details-bookmark .bookmark-card.card .favourite-icon {\n  transition: 0.5s;\n}\n.bookmark-tabcontent .details-bookmark .bookmark-card.card .title-bookmark {\n  text-align: left;\n  padding: 15px;\n  border-top: 1px solid #f4f4f4;\n}\n.bookmark-tabcontent .details-bookmark .bookmark-card.card .title-bookmark p {\n  margin-bottom: 10px;\n  animation: displayTransition 1s;\n}\n.bookmark-tabcontent .details-bookmark .bookmark-card.card .title-bookmark .hover-block {\n  display: none;\n  margin-top: 15px;\n}\n.bookmark-tabcontent .details-bookmark .bookmark-card.card .title-bookmark .hover-block ul li {\n  display: inline-block;\n}\n.bookmark-tabcontent .details-bookmark .bookmark-card.card .title-bookmark .hover-block ul li + li {\n  margin-left: 5px;\n}\n.bookmark-tabcontent .details-bookmark .bookmark-card.card .title-bookmark .hover-block ul li i {\n  width: 16px;\n  height: 16px;\n  color: #898989;\n}\n.bookmark-tabcontent .details-bookmark .bookmark-card.card:hover {\n  box-shadow: 1px 4px 16px 3px rgba(0, 0, 0, 0.04);\n  transition: 0.5s;\n}\n.bookmark-tabcontent .details-bookmark .bookmark-card.card:hover .title-bookmark p {\n  display: none;\n}\n.bookmark-tabcontent .details-bookmark .bookmark-card.card:hover .title-bookmark .hover-block {\n  display: block;\n  animation: displayTransition 2s;\n}\n.bookmark-tabcontent .details-bookmark .bookmark-card.card:hover .favourite-icon {\n  opacity: 1;\n}\n.bookmark-tabcontent .details-bookmark.list-bookmark .row .col-xl-3 {\n  flex: 0 0 100%;\n  max-width: 100%;\n}\n.bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card {\n  height: unset;\n}\n.bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card .desciption-data .content-general {\n  display: block;\n}\n.bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card .details-website {\n  display: flex;\n  align-items: center;\n}\n.bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card .details-website .title-bookmark p {\n  display: block;\n}\n.bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card .details-website .title-bookmark .hover-block {\n  position: absolute;\n  right: 30px;\n  display: block;\n  text-align: right;\n}\n.bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card .details-website:hover .title-bookmark .hover-block {\n  display: block;\n  animation: displayTransition 0s;\n}\n.bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card.card .title-bookmark {\n  border-top: none;\n}\n.bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card.card .title-bookmark p,\n.bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card.card .title-bookmark h6,\n.bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card.card .title-bookmark .h6 {\n  margin-top: 0;\n  display: inline-block;\n}\n.bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card.card .title-bookmark h6, .bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card.card .title-bookmark .h6 {\n  position: relative;\n  padding-right: 15px;\n}\n.bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card.card .title-bookmark h6::after, .bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card.card .title-bookmark .h6::after {\n  position: absolute;\n  content: \"-\";\n  right: 0;\n  color: #898989;\n}\n.bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card.card .title-bookmark .content-general {\n  margin-top: 5px;\n}\n.bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card.card .title-bookmark .content-general p {\n  width: 68%;\n  margin-right: 20px;\n}\n.bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card img {\n  width: 20%;\n}\n.bookmark-tabcontent .tab-content .card .d-flex {\n  justify-content: space-between;\n}\n.bookmark-tabcontent .tab-content .card .d-flex svg {\n  width: 18px;\n  height: 18px;\n  vertical-align: middle;\n}\n.bookmark-tabcontent .tab-content .card .d-flex ul li {\n  display: inline-block;\n}\n.bookmark-tabcontent .tab-content .card .d-flex ul li + li {\n  margin-left: 10px;\n}\n\n@media (max-width: 1660px) {\n  .bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card.card .title-bookmark {\n    padding-left: 5px;\n  }\n  .bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card.card .title-bookmark .content-general p {\n    display: none;\n  }\n  .bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card.card .title-bookmark .hover-block {\n    margin-top: 6px;\n  }\n}\n@media screen and (min-width: 1200px) and (max-width: 1366px) {\n  .bookmark-wrap .left-bookmark ul li .btn-mail svg {\n    display: none;\n  }\n}\n@media (max-width: 1366px) {\n  .bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card img {\n    width: 40%;\n  }\n}\n@media (max-width: 1199px) {\n  .bookmark-wrap .left-bookmark {\n    height: auto;\n  }\n  .bookmark-tabcontent .details-bookmark {\n    min-height: auto;\n  }\n}\n@media (max-width: 991px) {\n  .bookmark-tabcontent .details-bookmark .bookmark-card {\n    height: 93%;\n  }\n  .bookmark-tabcontent .details-bookmark .bookmark-card.card .title-bookmark p {\n    margin-bottom: 0;\n  }\n  .modal-bookmark .modal-body,\n  .modal-bookmark .modal-header {\n    padding: 20px;\n  }\n  .form-bookmark button {\n    margin-top: 20px;\n  }\n}\n@media (max-width: 767px) {\n  .form-bookmark .row .form-group:last-child {\n    margin-top: 15px;\n  }\n  .bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card .details-website .title-bookmark p {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 172px;\n  }\n  .bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card .details-website:hover .title-bookmark .hover-block p {\n    display: none;\n  }\n  .bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card .details-website:hover .title-bookmark .hover-block ul {\n    position: relative;\n    right: unset;\n    top: unset;\n  }\n  .bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card img {\n    width: 55%;\n  }\n}\n@media (max-width: 575px) {\n  .bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card.card .title-bookmark h6, .bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card.card .title-bookmark .h6 {\n    display: block;\n  }\n  .bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card img {\n    width: 100%;\n  }\n  .bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card .details-website {\n    display: block;\n  }\n  .bookmark-tabcontent .details-bookmark.list-bookmark .bookmark-card .details-website .title-bookmark .hover-block {\n    position: relative;\n    right: unset;\n    text-align: left;\n  }\n  .modal-bookmark .modal-body,\n  .modal-bookmark .modal-header {\n    padding: 15px;\n  }\n  .form-bookmark button {\n    margin-top: 15px;\n  }\n}\n/**=====================\n   85. bookmark app CSS Ends\n==========================**/\n/**=====================\n    82. cart CSS start\n==========================**/\n.cart .total-amount {\n  text-align: right !important;\n  margin-top: 30px;\n  min-width: 140px;\n}\n.cart .total-amount + td {\n  min-width: 160px;\n}\n.cart .amount-space {\n  margin-left: 40px;\n}\n.cart .cart-btn-transform {\n  text-transform: capitalize;\n}\n.cart .qty-box {\n  width: 25%;\n  margin: 0 auto;\n}\n.cart .qty-box .input-group .btn {\n  background-color: transparent !important;\n  border-color: #ddd !important;\n  padding: 8px 12px;\n}\n\n.cart-buttons {\n  margin-top: 30px;\n}\n.cart-buttons .cart-btn {\n  float: right;\n  padding-right: 85px;\n}\n\n/**=====================\n    82. cart CSS Ends\n==========================**/\n/**=====================\n    41. Chart CSS Start\n==========================**/\n.radial-bar.radial-bar-lg > img, .radial-bar.radial-bar-lg:after {\n  width: 70px;\n  height: 70px;\n  margin-left: 15px;\n  margin-top: 15px;\n  line-height: 70px;\n}\n\n.radial-bar.radial-bar-sm > img, .radial-bar.radial-bar-sm:after {\n  width: 35px;\n  height: 35px;\n  margin-left: 7.5px;\n  margin-top: 7.5px;\n  line-height: 35px;\n}\n\n.radial-bar.radial-bar-xs > img, .radial-bar.radial-bar-xs:after {\n  width: 20px;\n  height: 20px;\n  margin-left: 5.5px;\n  margin-top: 4.5px;\n  line-height: 21px;\n}\n\n.chart-block canvas {\n  width: 100% !important;\n}\n.chart-block .chart-overflow {\n  overflow: hidden;\n  text-align: center;\n}\n\n.candidcahrt {\n  width: 100%;\n  height: 470px;\n}\n\n.amcharts-export-canvas {\n  position: absolute;\n  display: none;\n  z-index: 1;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: #fff;\n}\n.amcharts-export-canvas .canvas-container {\n  transition: opacity 0.5s ease-out;\n}\n.amcharts-export-canvas.active {\n  display: block;\n}\n.amcharts-export-canvas.dropbox .canvas-container {\n  opacity: 0.5;\n}\n\n.flot-chart-container {\n  box-sizing: border-box;\n  width: 100%;\n  height: 400px;\n}\n.flot-chart-container #toggling-series-flot {\n  width: 79% !important;\n}\n\n.all-chart .flot-chart-container {\n  height: 350px;\n}\n\n.flot-chart-placeholder {\n  width: 100%;\n  height: 100%;\n  font-size: 14px;\n  line-height: 1.2em;\n  text-align: center;\n}\n.flot-chart-placeholder .legend table {\n  border-spacing: 5px;\n}\n\n.morris-hover {\n  position: absolute;\n  z-index: 1;\n}\n.morris-hover.morris-default-style {\n  border-radius: 10px;\n  padding: 6px;\n  color: #898989;\n  background: #fff;\n  border: solid 1px #ecf3fa;\n  font-family: sans-serif;\n  font-size: 12px;\n  text-align: center;\n}\n.morris-hover.morris-default-style .morris-hover-row-label {\n  font-weight: bold;\n  margin: 0.25em 0;\n}\n.morris-hover.morris-default-style .morris-hover-point {\n  white-space: nowrap;\n  margin: 0.1em 0;\n}\n\n.chart-sparkline {\n  position: absolute;\n  left: 0;\n  top: 0;\n  visibility: hidden;\n  background: rgba(49, 49, 49, 0.7);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=#99000000, endColorstr=#99000000);\n  color: #fff;\n  font: 10px Rubik, sans-serif;\n  text-align: left;\n  white-space: nowrap;\n  padding: 5px;\n  border: 1px solid rgba(49, 49, 49, 0.75);\n  box-sizing: content-box;\n  z-index: 10000;\n  border-radius: 5px;\n}\n.chart-sparkline .jqsfield {\n  color: #fff;\n  font: 10px Rubik, sans-serif;\n  text-align: left;\n}\n\n.radial-bar {\n  position: relative;\n  display: inline-block;\n  border-radius: 50%;\n  background-color: transparent;\n  box-sizing: content-box;\n  width: 80px;\n  height: 80px;\n  font-size: 18px;\n  background-clip: content-box;\n}\n.radial-bar:after {\n  display: inline-block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  border-radius: 50%;\n  text-align: center;\n  font-weight: 500;\n  color: #455a64;\n  content: attr(data-label);\n  background-color: #fff;\n  z-index: 1;\n  width: 56px;\n  height: 56px;\n  margin-left: 12px;\n  margin-top: 12px;\n  line-height: 56px;\n}\n.radial-bar > img {\n  display: inline-block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  border-radius: 50%;\n  text-align: center;\n  font-weight: 500;\n  color: #455a64;\n  z-index: 3;\n  width: 56px;\n  height: 56px;\n  margin-left: 12px;\n  margin-top: 12px;\n  line-height: 56px;\n}\n\n.radial-bar-danger.radial-bar-20 {\n  background-image: linear-gradient(90deg, #efefef 50%, transparent 50%, transparent), linear-gradient(162deg, #fc4438 50%, #efefef 50%, #efefef);\n}\n\n.radial-bar.radial-bar-lg {\n  width: 100px;\n  height: 100px;\n  font-size: 20px;\n}\n.radial-bar.radial-bar-sm {\n  width: 50px;\n  height: 50px;\n  font-size: 12px;\n}\n.radial-bar.radial-bar-xs {\n  width: 30px;\n  height: 30px;\n  font-size: 8px;\n}\n.pieLabel div {\n  color: #fff !important;\n}\n.pieLabel div input[type=checkbox] {\n  margin: 7px;\n}\n\n.knob-chart {\n  min-height: 255px;\n}\n.knob-chart .chart-clock-main {\n  position: relative;\n  width: 200px;\n  margin: 45px auto;\n}\n.knob-chart .chart-clock-main .clock-large {\n  position: absolute;\n  left: -48px;\n  top: -45px;\n}\n.knob-chart .chart-clock-main .clock-medium {\n  position: absolute;\n  left: 2px;\n  top: 5px;\n}\n.knob-chart .chart-clock-main .clock-small {\n  position: absolute;\n  left: 15px;\n  top: 55px;\n}\n\n.peity-charts svg {\n  width: 100%;\n  height: 250px;\n}\n.peity-charts.peity-chart-primary svg polygon {\n  fill: rgba(115, 102, 255, 0.2);\n}\n.peity-charts.peity-chart-primary svg polyline {\n  stroke: var(--theme-default);\n}\n\n.bar-odd-even svg rect:nth-child(odd) {\n  fill: var(--theme-default);\n}\n.bar-odd-even svg rect:nth-child(even) {\n  fill: var(--theme-secondary);\n}\n\n.donut-peity svg path:nth-child(odd) {\n  fill: var(--theme-default);\n}\n.donut-peity svg path:nth-child(even) {\n  fill: var(--theme-secondary);\n}\n\n.small-donut ~ svg path:nth-child(odd),\n.small-donut svg path:nth-child(odd),\n.donut-peity2 ~ svg path:nth-child(odd),\n.donut-peity2 svg path:nth-child(odd),\n.pie-peity ~ svg path:nth-child(odd),\n.pie-peity svg path:nth-child(odd) {\n  fill: var(--theme-default);\n}\n.small-donut ~ svg path:nth-child(even),\n.small-donut svg path:nth-child(even),\n.donut-peity2 ~ svg path:nth-child(even),\n.donut-peity2 svg path:nth-child(even),\n.pie-peity ~ svg path:nth-child(even),\n.pie-peity svg path:nth-child(even) {\n  fill: #efefef;\n}\n\n.small-donut2 ~ svg path:nth-child(odd) {\n  fill: var(--theme-secondary);\n}\n\n.small-donut3 ~ svg path:nth-child(odd) {\n  fill: #54ba4a;\n}\n\n.small-donut4 ~ svg path:nth-child(odd) {\n  fill: #16c7f9;\n}\n\n.small-donut5 ~ svg path:nth-child(odd) {\n  fill: #ffaa05;\n}\n\n.small-donut6 ~ svg path:nth-child(odd) {\n  fill: #fc4438;\n}\n\np.data-attributes svg {\n  margin-right: 10px;\n}\n\n.knob-block {\n  position: relative;\n}\n.knob-block input {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  height: 100% !important;\n  width: 100% !important;\n  left: 0 !important;\n  top: 0 !important;\n  margin-left: 0 !important;\n  margin-top: -3px !important;\n}\n\n.knob-input-disable input {\n  display: none !important;\n}\n\n.apex-chart {\n  margin: 0 auto;\n}\n\n.apexcharts-toolbar {\n  z-index: 1 !important;\n}\n\n.apexcharts-menu-item {\n  width: 110px;\n}\n\n.word-tree {\n  height: 400px;\n}\n\n.ct-series-a .ct-slice-pie,\n.ct-series-a .ct-slice-donut-solid,\n.ct-series-a .ct-area {\n  fill: var(--theme-default);\n}\n.ct-series-a .ct-point,\n.ct-series-a .ct-line,\n.ct-series-a .ct-bar,\n.ct-series-a .ct-slice-donut {\n  stroke: var(--theme-default);\n}\n\n.ct-series-b .ct-point,\n.ct-series-b .ct-line,\n.ct-series-b .ct-bar,\n.ct-series-b .ct-slice-donut {\n  stroke: var(--theme-secondary);\n}\n.ct-series-b .ct-slice-pie,\n.ct-series-b .ct-slice-donut-solid,\n.ct-series-b .ct-area {\n  fill: var(--theme-secondary);\n}\n\n.apache-cotainer {\n  width: 100%;\n  height: 350px;\n  margin: 0;\n}\n\n.boxplot-cotainer {\n  height: 420px;\n}\n\n.apache-cotainer-large {\n  width: 100%;\n  height: 500px;\n  margin: 0;\n}\n\n.test-buttons button + button {\n  margin-left: 10px;\n}\n\n.clip-chart-wrapper .test-chart-block {\n  margin-bottom: -30px;\n}\n\n#echart-gauge .test-chart {\n  width: 100%;\n  height: 395px;\n}\n\n.polar-line {\n  height: 350px;\n}\n\n#dotted {\n  height: 390px;\n}\n\n.apexcharts-canvas .apexcharts-tooltip,\n.apexcharts-canvas .apexcharts-xaxistooltip,\n.apexcharts-canvas .apexcharts-yaxistooltip {\n  z-index: 1;\n}\n\n@media (max-width: 1346px) {\n  .flot-chart-container .flot-chart-placeholder ~ p.float-end {\n    float: left !important;\n  }\n  [dir=rtl] .flot-chart-container .flot-chart-placeholder ~ p.float-end {\n    float: right !important;\n  }\n}\n\n/**=====================\n     41. Chart CSS End\n==========================**/\n/**=====================\n     14. Chat CSS Start\n==========================**/\n.chat-box .toogle-bar {\n  display: none;\n}\n.chat-box .chat-menu {\n  max-width: 340px;\n}\n.chat-box .people-list .search {\n  position: relative;\n}\n.chat-box .people-list .search .form-control {\n  background-color: #fafdff;\n  border: 1px solid #f4f4f4;\n}\n.chat-box .people-list .search .form-control::placeholder {\n  color: #59667a;\n}\n.chat-box .people-list .search i {\n  position: absolute;\n  right: 10px;\n  top: 17px;\n  font-size: 14px;\n  color: #ecf3fa;\n}\n.chat-box .people-list ul {\n  padding: 0;\n}\n.chat-box .people-list ul li {\n  padding-bottom: 20px;\n}\n.chat-box .people-list ul li.active {\n  background-color: transparent !important;\n}\n.chat-box .people-list ul li:last-child {\n  padding-bottom: 0;\n}\n.chat-box .user-image {\n  float: left;\n  width: 52px;\n  height: 52px;\n  margin-right: 5px;\n}\n.chat-box .about {\n  float: left;\n  margin-top: 5px;\n  padding-left: 10px;\n}\n.chat-box .about .name {\n  color: #2c323f;\n  letter-spacing: 1px;\n  font-weight: 500;\n}\n.chat-box .status {\n  color: #59667a;\n  letter-spacing: 1px;\n  font-size: 12px;\n  margin-top: 5px;\n}\n.chat-box .status .chat-status {\n  font-weight: 600;\n  color: #2f2f3b;\n}\n.chat-box .status p {\n  font-size: 14px;\n}\n.chat-box .chat-right-aside .chat .chat-header {\n  padding: 15px;\n  border-bottom: 1px solid #f4f4f4;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.chat-box .chat-right-aside .chat .chat-header img {\n  float: left;\n  width: 50px;\n  height: 50px;\n  box-shadow: 1px 1px 4px 1px #ecf3fa;\n}\n.chat-box .chat-right-aside .chat .chat-header .chat-menu-icons li {\n  margin-right: 24px;\n}\n.chat-box .chat-right-aside .chat .chat-header .chat-menu-icons li a i {\n  color: #52526c;\n  font-size: 25px;\n  cursor: pointer;\n}\n.chat-box .chat-right-aside .chat .chat-header .chat-menu-icons {\n  margin-left: auto;\n}\n.chat-box .chat-right-aside .chat .chat-header .chat-menu-icons svg {\n  color: #52526c;\n  stroke: 1.4px;\n}\n[dir=rtl] .chat-box .chat-right-aside .chat .chat-header .chat-menu-icons {\n  margin-right: auto;\n  margin-left: unset;\n}\n.chat-box .chat-right-aside .chat .chat-msg-box {\n  padding: 20px;\n  overflow-y: auto;\n  height: 560px;\n  margin-bottom: 80px;\n}\n.chat-box .chat-right-aside .chat .chat-msg-box .chat-user-img {\n  margin-top: -35px;\n}\n.chat-box .chat-right-aside .chat .chat-msg-box .message-data {\n  margin-bottom: 10px;\n}\n.chat-box .chat-right-aside .chat .chat-msg-box .message-data-time {\n  letter-spacing: 1px;\n  font-size: 12px;\n  color: #59667a;\n}\n.chat-box .chat-right-aside .chat .chat-msg-box .message {\n  color: #2c323f;\n  padding: 20px;\n  line-height: 1.9;\n  letter-spacing: 1px;\n  font-size: 14px;\n  margin-bottom: 30px;\n  width: 50%;\n  position: relative;\n}\n.chat-box .chat-right-aside .chat .chat-msg-box .my-message {\n  border: 1px solid #f4f4f4;\n  border-radius: 10px;\n  border-top-left-radius: 0;\n}\n.chat-box .chat-right-aside .chat .chat-msg-box .other-message {\n  background-color: #fdfeff;\n  border-radius: 10px;\n  border-top-right-radius: 0;\n}\n.chat-box .chat-right-aside .chat .chat-message {\n  padding: 20px;\n  border-top: 1px solid #fafdff;\n  position: absolute;\n  width: calc(100% - 15px);\n  background-color: #fff;\n  bottom: 0;\n}\n.chat-box .chat-right-aside .chat .chat-message .smiley-box {\n  background: #efefef;\n  padding: 10px;\n  display: block;\n  border-radius: 4px;\n  margin-right: 0.5rem;\n}\n.chat-box .chat-right-aside .chat .chat-message .text-box {\n  position: relative;\n}\n.chat-box .chat-right-aside .chat .chat-message .text-box .input-txt-bx {\n  height: 50px;\n  border: 2px solid var(--theme-default);\n  padding-left: 18px;\n  font-size: 12px;\n  letter-spacing: 1px;\n}\n.chat-box .chat-right-aside .chat .chat-message .text-box i {\n  position: absolute;\n  right: 20px;\n  top: 20px;\n  font-size: 20px;\n  color: #ecf3fa;\n  cursor: pointer;\n}\n.chat-box .chat-right-aside .chat .chat-message .text-box .btn {\n  font-size: 16px;\n  font-weight: 500;\n  padding: 0.74rem 1.75rem;\n  border-radius: 0 5px 5px 0;\n}\n.chat-box .chat-menu {\n  border-left: 1px solid #f4f4f4;\n}\n.chat-box .chat-menu .tab-pane {\n  padding: 0 15px;\n}\n.chat-box .chat-menu ul li .about .status i {\n  font-size: 10px;\n}\n.chat-box .chat-menu .user-profile {\n  margin-top: 30px;\n}\n.chat-box .chat-menu .user-profile .user-content h5, .chat-box .chat-menu .user-profile .user-content .h5 {\n  margin: 25px 0;\n}\n.chat-box .chat-menu .user-profile .user-content hr {\n  margin: 25px 0;\n}\n.chat-box .chat-menu .user-profile .user-content p {\n  font-size: 16px;\n}\n.chat-box .chat-menu .user-profile .border-tab.nav-tabs .nav-item .nav-link.active,\n.chat-box .chat-menu .user-profile .border-tab.nav-tabs .nav-item .nav-link.show,\n.chat-box .chat-menu .user-profile .border-tab.nav-tabs .nav-item .nav-link:focus {\n  border-bottom: 0;\n}\n.chat-box .chat-menu .user-profile .image {\n  position: relative;\n}\n.chat-box .chat-menu .user-profile .image .icon-wrapper {\n  position: absolute;\n  bottom: 0;\n  left: 55%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 35px;\n  width: 35px;\n  border-radius: 50%;\n  background-color: #fff;\n  cursor: pointer;\n  overflow: hidden;\n  margin: 0 auto;\n  font-size: 14px;\n  box-shadow: 1px 1px 3px 1px #f4f4f4;\n}\n.chat-box .chat-menu .user-profile .image .avatar img {\n  border-radius: 50%;\n  border: 5px solid #f4f4f4;\n}\n.chat-box .chat-menu .user-profile .border-right {\n  border-right: 1px solid #dee2e6;\n}\n.chat-box .chat-menu .user-profile .follow {\n  margin-top: 0;\n}\n.chat-box .chat-menu .user-profile .follow .follow-num {\n  font-size: 20px;\n  color: #000;\n}\n.chat-box .chat-menu .user-profile .follow span {\n  color: #242934;\n  font-size: 14px;\n  letter-spacing: 1px;\n}\n.chat-box .chat-menu .user-profile .social-media a {\n  color: #59667a;\n  font-size: 15px;\n  padding: 0 7px;\n}\n.chat-box .chat-menu .user-profile .chat-profile-contact p {\n  font-size: 14px;\n  color: #59667a;\n}\n.chat-box .chat-menu .nav {\n  margin-bottom: 20px;\n}\n.chat-box .chat-menu .nav-tabs .nav-item {\n  width: 33.33%;\n}\n.chat-box .chat-menu .nav-tabs .nav-item a {\n  padding: 15px !important;\n  color: #59667a !important;\n  letter-spacing: 1px;\n  font-size: 14px;\n  font-weight: 500;\n  height: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.chat-box .chat-menu .nav-tabs .nav-item .material-border {\n  border-width: 1px;\n  border-color: var(--theme-default);\n}\n.chat-box .chat-menu .nav-tabs .nav-item .nav-link.active {\n  color: #000 !important;\n}\n.chat-box .chat-history .call-content {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 300px;\n}\n.chat-box .chat-history .total-time h2, .chat-box .chat-history .total-time .h2 {\n  font-size: 50px;\n  color: #efefef;\n  font-weight: 600;\n  margin-bottom: 30px;\n}\n.chat-box .chat-history .receiver-img {\n  margin-top: 55px;\n}\n.chat-box .chat-history .receiver-img img {\n  border-radius: 5px;\n}\n.chat-box .chat-history .call-icons {\n  margin-bottom: 35px;\n}\n.chat-box .chat-history .call-icons ul li {\n  width: 60px;\n  height: 60px;\n  border: 1px solid #f4f4f4;\n  border-radius: 50%;\n  padding: 12px;\n  cursor: pointer;\n}\n.chat-box .chat-history .call-icons ul li + li {\n  margin-left: 10px;\n}\n.chat-box .chat-history .call-icons ul li a {\n  color: #999;\n  font-size: 25px;\n}\n\n.chat-left-aside > .media {\n  margin-bottom: 15px;\n}\n.chat-left-aside .people-list {\n  height: 625px;\n}\n.chat-left-aside ul li {\n  position: relative;\n}\n.chat-left-aside .list-group-item.active {\n  background-color: transparent !important;\n}\n\n.status-circle {\n  width: 12px;\n  height: 12px;\n  position: absolute;\n  top: 4px;\n  left: 44px;\n  border-radius: 50%;\n  border: 2px solid #fff;\n}\n\n.away {\n  background-color: #ffaa05;\n}\n\n.online {\n  background-color: #54ba4a;\n}\n\n.offline {\n  background-color: #fc4438;\n}\n\n.chat-container .aside-chat-left {\n  width: 320px;\n}\n.chat-container .chat-right-aside {\n  width: 320px;\n}\n\n.call-chat-sidebar {\n  max-width: 320px;\n}\n\n.call-chat-sidebar .card .card-body,\n.chat-body .card .card-body {\n  padding: 15px;\n}\n\nbody.dark-only .page-wrapper .people-list .list-group-item.active {\n  background-color: transparent !important;\n}\n\n/**=====================\n    14.  Chat CSS Ends\n==========================**/\n/**=====================\n    84. Checkout CSS start\n==========================**/\n.checkout .checkout-details {\n  background-color: #f9f9f9;\n  border: 1px solid #dddddd;\n  padding: 40px;\n}\n.checkout .checkout-details .order-place {\n  margin-top: 15px;\n}\n\n.order-box .title-box {\n  padding-bottom: 20px;\n  color: #444444;\n  font-size: 22px;\n  border-bottom: 1px solid #ededed;\n  margin-bottom: 20px;\n}\n.order-box .title-box span {\n  width: 35%;\n  float: right;\n  font-weight: 600;\n  text-align: right;\n}\n.order-box .title-box h4, .order-box .title-box .h4 {\n  font-weight: 600;\n}\n.order-box .title-box .checkbox-title {\n  display: flex;\n  justify-content: space-between;\n}\n.order-box .sub-total li {\n  position: relative;\n  display: inline-block;\n  font-size: 16px;\n  font-weight: 600;\n  color: #333333;\n  line-height: 20px;\n  margin-bottom: 20px;\n  width: 100%;\n}\n.order-box .sub-total li .count {\n  position: relative;\n  font-size: 18px;\n  line-height: 20px;\n  font-weight: 400;\n  width: 35%;\n  float: right;\n  text-align: right;\n}\n.order-box .sub-total .shipping-class {\n  margin-bottom: 12px;\n}\n.order-box .sub-total .shipping-class .shopping-checkout-option {\n  margin-top: -4px;\n  position: relative;\n  font-size: 18px;\n  line-height: 20px;\n  color: var(--theme-default);\n  font-weight: 400;\n  width: 35%;\n  float: right;\n  text-align: right;\n}\n.order-box .total {\n  position: relative;\n  margin-bottom: 30px;\n}\n.order-box .total li {\n  position: relative;\n  display: block;\n  font-weight: 400;\n  color: #333333;\n  line-height: 20px;\n  font-size: 18px;\n}\n.order-box .qty {\n  position: relative;\n  border-bottom: 1px solid #ededed;\n  margin-bottom: 30px;\n}\n.order-box .qty li {\n  position: relative;\n  display: block;\n  font-size: 15px;\n  color: #444444;\n  line-height: 20px;\n  margin-bottom: 20px;\n}\n.order-box .qty li span {\n  float: right;\n  font-size: 18px;\n  line-height: 20px;\n  color: #232323;\n  font-weight: 400;\n  width: 35%;\n  text-align: right;\n}\n\n.radio-option {\n  position: relative;\n}\n\n.img-paypal {\n  width: 30%;\n  margin-left: 15px;\n}\n\n/**=====================\n    86. Checkout CSS Ends\n==========================**/\n/**=====================\n    Responsive CSS Start\n==========================**/\n@media screen and (max-width: 1199px) {\n  .checkout .checkout-details {\n    padding: 25px;\n  }\n  .order-box .title-box span {\n    width: 30%;\n  }\n  .order-box .sub-total li .count {\n    width: 38%;\n  }\n  .order-box .sub-total .shipping-class .shopping-checkout-option {\n    width: 46%;\n  }\n  .order-box .qty li span {\n    width: 38%;\n  }\n  .order-box .total li .count {\n    width: 38%;\n  }\n}\n@media screen and (max-width: 991px) {\n  .order-box .sub-total .shipping-class .shopping-checkout-option {\n    width: 38%;\n  }\n}\n@media screen and (max-width: 575px) {\n  .checkout .checkout-details {\n    padding: 15px;\n  }\n  .order-box .sub-total .shipping-class .shopping-checkout-option {\n    width: 50%;\n  }\n  .order-box .sub-total li .count {\n    width: 50%;\n  }\n}\n/**=====================\n    84. Checkout CSS ends\n==========================**/\n/**=====================\n     27. Coming Soon CSS Start\n==========================**/\n.comingsoon-bgimg {\n  background: url(../../images/other-images/coming-soon-bg.jpg);\n  background-position: bottom;\n  background-size: cover;\n}\n\n.comingsoon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  padding: 50px 0;\n}\n.comingsoon .comingsoon-inner h5, .comingsoon .comingsoon-inner .h5 {\n  font-size: 18px;\n  letter-spacing: 1px;\n  color: #52526c;\n  font-weight: 500;\n  margin-bottom: 30px;\n  margin-top: 30px;\n}\n.comingsoon .comingsoon-inner .countdown {\n  padding: 30px 0;\n  border-top: 1px solid #f4f4f4;\n  border-bottom: 1px solid #f4f4f4;\n}\n.comingsoon .comingsoon-inner .countdown .time {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  color: #fff;\n  font-weight: 500;\n  width: 100px;\n  height: 100px;\n  font-size: 36px;\n  background: var(--theme-default);\n}\n.comingsoon .comingsoon-inner .countdown .title {\n  padding-top: 13px;\n  font-size: 14px;\n  font-weight: 400;\n  color: #52526c;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n.comingsoon .comingsoon-inner .countdown ul li {\n  display: inline-block;\n  text-transform: uppercase;\n  margin: 0 20px;\n}\n.comingsoon .comingsoon-inner .countdown ul li span {\n  display: block;\n}\n.comingsoon video {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  min-width: 100%;\n  min-height: 100%;\n  width: auto;\n  height: auto;\n  z-index: -100;\n  transform: translateX(-50%) translateY(-50%);\n  transition: 1s opacity;\n}\n\n/**=====================\n    27. Coming Soon CSS Ends\n==========================**/\n/**=====================\n      86. contacts CSS Start\n==========================**/\n.alert-contactadd {\n  background-color: #fff;\n  border: 1px solid var(--theme-default);\n  width: 12%;\n  padding: 10px;\n}\n\n.updateimg {\n  position: absolute;\n  left: 15px;\n  width: 100px;\n  top: 32px;\n  line-height: 93px;\n  opacity: 0;\n}\n\n#right-history {\n  top: 81px;\n  right: -320px;\n  height: 100%;\n  position: fixed;\n  width: 320px;\n  z-index: 9;\n  background-color: #fff;\n  transition: 0.5s;\n  box-shadow: 0 0 9px rgba(191, 191, 191, 0.36);\n}\n[dir=rtl] #right-history {\n  right: unset;\n  left: -320px;\n}\n#right-history h6 span a, #right-history .h6 span a {\n  color: #2f2f3b;\n}\n#right-history.show {\n  right: 0;\n  transition: 0.3s;\n}\n[dir=rtl] #right-history.show {\n  right: unset;\n  left: 0;\n}\n\n.history-details > div {\n  padding: 30px 0;\n}\n.history-details .media {\n  padding: 30px 15px;\n  border-top: 1px solid #f4f4f4;\n}\n.history-details .media i {\n  padding: 5px;\n  background: #fed112;\n  color: #fff;\n  border-radius: 100%;\n}\n.history-details .media h6, .history-details .media .h6 {\n  margin-bottom: 5px;\n}\n\n.delete-contact {\n  display: none;\n}\n\n.more-data {\n  animation: displayTransition 1s;\n}\n\n.contact-editform {\n  padding: 30px;\n  animation: displayTransition 1s;\n}\n.contact-editform a {\n  display: block;\n}\n.contact-editform button {\n  margin-top: 30px;\n}\n.contact-editform .select2-container .select2-selection--single {\n  height: 39px !important;\n  border-color: #ced4da !important;\n}\n\n#deletemodal .modal-header {\n  border-bottom: none;\n}\n#deletemodal .modal-header .delete-data span svg {\n  vertical-align: middle;\n  margin-right: 15px;\n}\n\n.contact-options li .btn-category {\n  line-height: 39px;\n  border-radius: 3px;\n  padding-left: 40px !important;\n  padding: 0;\n  color: var(--theme-default);\n  font-weight: 500;\n}\n\n.list-persons p {\n  font-family: Roboto, sans-serif;\n}\n.list-persons .profile-mail {\n  padding: 30px 0;\n}\n.list-persons .profile-mail .media img {\n  height: 100px;\n}\n.list-persons .profile-mail .media .media-body h5, .list-persons .profile-mail .media .media-body .h5 {\n  margin-bottom: 5px;\n}\n.list-persons .profile-mail .media .media-body ul {\n  margin-top: 5px;\n}\n.list-persons .profile-mail .media .media-body ul li {\n  display: inline-block;\n}\n.list-persons .profile-mail .media .media-body ul li a {\n  font-size: 13px;\n}\n.list-persons .profile-mail .media .media-body ul li + li {\n  padding-left: 10px;\n  margin-left: 5px;\n  border-left: 2px solid #f4f4f4;\n}\n.list-persons .profile-mail .email-general {\n  padding-top: 50px;\n}\n.list-persons .profile-mail .email-general ul {\n  padding-right: 20px;\n}\n.list-persons .profile-mail .email-general ul li {\n  color: #898989;\n  padding-bottom: 10px;\n  margin-bottom: 10px;\n}\n.list-persons .profile-mail .email-general ul li:last-child {\n  padding-bottom: 0;\n  margin-bottom: 0;\n}\n.list-persons .profile-mail .email-general ul li > span {\n  float: right;\n}\n.list-persons .profile-mail .email-general p span {\n  margin-left: 30px;\n}\n.list-persons .profile-mail .email-general .gender {\n  margin-top: 30px;\n}\n\n.contacts-tabs .nav-pills {\n  border-right: 1px solid #f4f4f4;\n  height: 100%;\n}\n.contacts-tabs .nav-pills .nav-link.active,\n.contacts-tabs .nav-pills .nav-link > .nav-link,\n.contacts-tabs .nav-pills .show.active,\n.contacts-tabs .nav-pills .show > .nav-link {\n  background-color: rgba(115, 102, 255, 0.05);\n  color: #2f2f3b;\n}\n.contacts-tabs .nav-pills .nav-link {\n  color: #2f2f3b;\n  padding: 0;\n}\n.contacts-tabs .nav-pills .nav-link .media .img-50 {\n  height: 50px;\n}\n.contacts-tabs .nav-pills .nav-link + .nav-link {\n  border-top: 1px solid #f4f4f4;\n}\n.contacts-tabs .nav-pills .media {\n  padding: 20px;\n}\n.contacts-tabs .tab-content .tab-content-child {\n  animation: displayTransition 1s;\n}\n\n@media only screen and (max-width: 991px) {\n  #right-history {\n    top: 60px;\n  }\n  .updateimg {\n    top: 21px;\n  }\n  .list-persons .profile-mail {\n    padding: 20px;\n  }\n  .list-persons .profile-mail .email-general .gender {\n    margin-top: 20px;\n  }\n  .contact-editform button {\n    margin-top: 20px;\n  }\n}\n@media only screen and (max-width: 767px) {\n  .contact-editform {\n    padding: 20px;\n  }\n  .contact-editform.pl-0 {\n    padding-left: 20px !important;\n  }\n  .contacts-tabs .nav-pills {\n    border-right: none;\n    border-bottom: 1px solid #f4f4f4;\n  }\n}\n@media only screen and (max-width: 575px) {\n  #right-history {\n    width: 270px;\n  }\n  .updateimg {\n    top: 16px;\n    left: 29px;\n  }\n  .contacts-tabs .media img.m-r-20 {\n    margin-right: 15px;\n  }\n  .contacts-tabs .nav-pills .media {\n    padding: 15px;\n  }\n  .list-persons .profile-mail {\n    padding: 15px;\n  }\n  .list-persons .profile-mail .email-general .gender {\n    margin-top: 15px;\n  }\n  .list-persons .nav-pills .nav-link .media .media-body {\n    text-align: left;\n  }\n  .contact-editform {\n    padding: 15px;\n  }\n  .contact-editform button {\n    margin-top: 15px;\n  }\n  .contact-editform.pl-0 {\n    padding-left: 15px !important;\n  }\n  .contact-editform form .row > div .row > div > div,\n  .contact-options form .row > div .row > div > div {\n    margin-bottom: 0;\n  }\n  .contact-editform form .row > div .row > div + div,\n  .contact-options form .row > div .row > div + div {\n    margin-top: 15px;\n  }\n}\n@media only screen and (max-width: 360px) {\n  .updateimg {\n    line-height: 73px;\n    width: 80px;\n  }\n  .list-persons .profile-mail .email-general p span {\n    margin-left: 10px;\n  }\n  .list-persons .profile-mail .media {\n    display: block;\n  }\n  .list-persons .profile-mail .media img {\n    height: 80px;\n    width: 80px !important;\n    margin-bottom: 15px;\n  }\n}\n/**=====================\n    86. contacts CSS Ends\n==========================**/\n/**=====================\n      67. Dashboard 2 CSS Start\n==========================**/\n.widget-decor {\n  position: absolute;\n  height: 60px;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.balance-widget {\n  background-image: url(../../images/dashboard-2/balance-bg.png);\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: right;\n}\n.balance-widget .mobile-right-img {\n  position: absolute;\n  top: 10px;\n  right: 15px;\n}\n.balance-widget .mobile-right-img .left-mobile-img {\n  margin-right: -20px;\n}\n.balance-widget .mobile-right-img .mobile-img {\n  height: 130px;\n}\n[dir=rtl] .balance-widget .mobile-right-img {\n  right: unset;\n  left: 15px;\n}\n@media (max-width: 480px) {\n  .balance-widget .mobile-right-img {\n    right: 0;\n  }\n  .balance-widget .mobile-right-img .mobile-img {\n    height: 100px;\n  }\n  [dir=rtl] .balance-widget .mobile-right-img {\n    right: unset;\n    left: 0;\n  }\n}\n[dir=rtl] .balance-widget {\n  text-align: right;\n}\n.balance-widget.card-body {\n  padding: 20px 15px;\n}\n.balance-widget .purchase-btn {\n  min-width: 170px;\n}\n\n.small-widget {\n  overflow: hidden;\n}\n.small-widget h4, .small-widget .h4 {\n  margin-bottom: -3px;\n}\n.small-widget i {\n  font-weight: 700;\n  font-size: 11px;\n}\n.small-widget .card-body {\n  padding: 24px 15px;\n}\n.small-widget .bg-gradient {\n  width: 66px;\n  height: 67px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 100px;\n  right: -12px;\n  top: 50%;\n  position: absolute;\n  transform: translateY(-50%);\n}\n[dir=rtl] .small-widget .bg-gradient {\n  right: unset;\n  left: -12px;\n  transform: translateY(-50%) scaleX(-1);\n}\n@media (max-width: 1399px) {\n  .small-widget .bg-gradient {\n    width: 60px;\n    height: 60px;\n  }\n}\n.small-widget .bg-gradient svg {\n  width: 25px;\n  height: 25px;\n}\n@media (max-width: 1399px) {\n  .small-widget .bg-gradient svg {\n    width: 22px;\n    height: 22px;\n  }\n}\n.small-widget:hover {\n  transform: translateY(-5px);\n  transition: 0.5s;\n}\n.small-widget:hover .bg-gradient svg {\n  animation: tada 1.5s ease infinite;\n}\n\n@media (max-width: 1470px) {\n  .appointment .customer-table {\n    height: 268px;\n  }\n}\n@media (max-width: 1399px) {\n  .appointment .customer-table {\n    height: unset;\n  }\n}\n\n.order-wrapper {\n  margin: 0 -24px -17px -17px;\n}\n\n.categories-list {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n@media (max-width: 767px) {\n  .categories-list {\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n}\n.categories-list li {\n  gap: 10px;\n}\n.categories-list li .bg-light {\n  min-width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.categories-list li .bg-light img {\n  width: 25px;\n  height: 25px;\n  object-fit: contain;\n  transition: 0.5s;\n}\n.categories-list li h6 a, .categories-list li .h6 a {\n  transition: 0.5s;\n  color: var(--body-font-color);\n}\n.categories-list li:hover .bg-light img {\n  transition: 0.5s;\n  transform: scale(1.1);\n}\n.categories-list li:hover h6 a, .categories-list li:hover .h6 a {\n  transition: 0.5s;\n  color: var(--theme-default);\n}\n\n.monthly-profit {\n  margin-top: -10px;\n}\n@media (max-width: 1584px) {\n  .monthly-profit {\n    margin: -10px -8px 0;\n  }\n}\n@media (max-width: 1520px) {\n  .monthly-profit {\n    margin: -10px -16px 0;\n  }\n}\n@media (max-width: 1500px) {\n  .monthly-profit {\n    margin: -10px -14px 0;\n  }\n}\n@media (max-width: 1472px) {\n  .monthly-profit {\n    margin: -10px -20px 0;\n  }\n}\n@media (max-width: 1424px) {\n  .monthly-profit {\n    margin: -10px -25px 0;\n  }\n}\n.monthly-profit .apexcharts-canvas .apexcharts-legend-marker {\n  margin-right: 6px;\n}\n.monthly-profit .apexcharts-canvas .apexcharts-datalabels-group .apexcharts-datalabel-value {\n  font-size: 14px;\n  font-weight: 500;\n  font-family: Rubik, sans-serif !important;\n  fill: var(--chart-text-color);\n}\n\n.overview-wrapper {\n  position: relative;\n  z-index: 1;\n}\n\n.back-bar-container {\n  position: absolute;\n  width: calc(100% - 64px);\n  bottom: -8px;\n  margin: 0 auto !important;\n  left: 28px;\n}\n@media (max-width: 1199px) {\n  .back-bar-container {\n    bottom: 22px;\n  }\n}\n@media (max-width: 480px) {\n  .back-bar-container {\n    width: calc(100% - 34px);\n    left: 18px;\n  }\n}\n@media (max-width: 327px) {\n  .back-bar-container {\n    bottom: 42px;\n  }\n}\n\n.overview-card .balance-data {\n  right: 12px;\n}\n[dir=rtl] .overview-card .balance-data {\n  right: unset;\n  left: 12px;\n}\n@media (max-width: 767px) {\n  .overview-card .balance-data {\n    right: -40%;\n  }\n  [dir=rtl] .overview-card .balance-data {\n    left: -40%;\n  }\n}\n\n.order-container .apexcharts-canvas .apexcharts-marker {\n  stroke-width: 4;\n}\n\n.purchase-card.discover {\n  margin-top: 102px;\n}\n.purchase-card.discover img {\n  width: 224px;\n  margin: 0 auto;\n  margin-top: -90px;\n}\n@media (max-width: 1550px) {\n  .purchase-card.discover img {\n    margin-top: -110px;\n  }\n}\n@media (max-width: 1399px) {\n  .purchase-card.discover img {\n    margin-top: -90px;\n  }\n}\n@media (max-width: 991px) {\n  .purchase-card.discover img {\n    margin-top: -110px;\n  }\n}\n@media (max-width: 618px) {\n  .purchase-card.discover img {\n    width: 200px;\n  }\n}\n\n.visitor-card .card-header svg {\n  width: 18px;\n  height: 18px;\n  fill: var(--theme-default);\n}\n\n.visitors-container {\n  margin: 0 -12px -27px -17px;\n}\n.visitors-container svg .apexcharts-series path {\n  clip-path: inset(1% 0% 0% 0% round 3rem);\n}\n.visitors-container svg .apexcharts-legend.apexcharts-align-left .apexcharts-legend-series {\n  display: flex;\n}\n\n.recent-order .nav {\n  gap: 8px;\n  flex-wrap: nowrap;\n  overflow: auto;\n  padding-bottom: 5px;\n  display: flex;\n}\n.recent-order .frame-box {\n  border: 1px solid transparent;\n  padding: 0;\n  transition: 0.5s;\n}\n.recent-order .frame-box.active {\n  border: 1px solid var(--theme-default);\n}\n.recent-order .frame-box:hover {\n  transform: translateY(-5px);\n  transition: 0.5s;\n}\n.recent-order .tab-content {\n  margin-top: 16px;\n}\n\n.recent-table table thead {\n  background: var(--light2);\n}\n.recent-table table thead th {\n  padding-top: 9px;\n  padding-bottom: 9px;\n  border-bottom: none;\n}\n.recent-table table tr td,\n.recent-table table tr th {\n  padding: 12px 8px;\n  vertical-align: middle;\n}\n.recent-table table tr td:first-child,\n.recent-table table tr th:first-child {\n  min-width: 157px;\n}\n@media (max-width: 1660px) {\n  .recent-table table tr td:nth-child(2),\n  .recent-table table tr th:nth-child(2) {\n    min-width: 97px;\n  }\n}\n.recent-table table tr td:last-child,\n.recent-table table tr th:last-child {\n  min-width: 96px;\n}\n.recent-table table tr td:first-child {\n  padding-left: 0;\n}\n[dir=rtl] .recent-table table tr td:first-child {\n  padding-left: unset;\n  padding-right: 0;\n}\n.recent-table table tr td:last-child {\n  padding-right: 0;\n}\n[dir=rtl] .recent-table table tr td:last-child {\n  padding-left: 0;\n  padding-right: unset;\n}\n.recent-table table tr:last-child td {\n  padding-bottom: 0;\n  border-bottom: none;\n}\n.recent-table table tr .product-content h6 a, .recent-table table tr .product-content .h6 a {\n  color: var(--body-font-color);\n  transition: 0.5s;\n}\n.recent-table table tr:hover .product-content h6 a, .recent-table table tr:hover .product-content .h6 a {\n  color: var(--theme-default);\n  transition: 0.5s;\n}\n.recent-table .product-content {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.recent-table .product-content .order-image {\n  background: var(--light2);\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.recent-table svg {\n  width: 20px;\n  height: 20px;\n}\n.recent-table .recent-status {\n  display: flex;\n  align-items: center;\n}\n.recent-table .recent-status.font-success svg {\n  fill: #54ba4a;\n}\n.recent-table .recent-status.font-danger svg {\n  fill: #fc4438;\n}\n\n.recent-activity h5, .recent-activity .h5 {\n  padding: 30px 0 20px;\n  margin-bottom: 0;\n}\n.recent-activity h6, .recent-activity .h6 {\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-line-clamp: 2;\n  display: -webkit-box;\n}\n.recent-activity ul li span {\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-line-clamp: 2;\n  display: -webkit-box;\n}\n\n.notification li .recent-images ul::before {\n  display: none;\n}\n.notification li .recent-images li {\n  padding-bottom: 3px;\n}\n\n.recent-images {\n  margin-top: 10px;\n}\n.recent-images ul {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n.recent-images li {\n  border: 1px dashed var(--recent-dashed-border);\n  padding: 3px;\n  border-radius: 2px;\n}\n.recent-images li .recent-img-wrap {\n  width: 40px;\n  height: 40px;\n  background: var(--light2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.frame-box {\n  background: var(--recent-box-bg);\n  border-radius: 10px;\n  min-width: 76px;\n  box-shadow: 2px 2px 2px var(--recent-border);\n}\n@media (max-width: 575px) {\n  .frame-box {\n    min-width: 65px;\n  }\n}\n.frame-box .frame-image {\n  min-width: 62px;\n  height: 62px;\n  border-color: var(--recent-border) var(--white) var(--white) var(--recent-border);\n  border-width: 1px;\n  border-style: solid;\n  margin: 6px;\n  display: flex;\n  align-items: center;\n  border-radius: 4px;\n}\n@media (max-width: 575px) {\n  .frame-box .frame-image {\n    min-width: 50px;\n    height: 50px;\n    margin: 4px;\n  }\n}\n.frame-box img {\n  margin: 0 auto;\n}\n@media (max-width: 575px) {\n  .frame-box img {\n    height: 30px;\n  }\n}\n\n.support-ticket-font ul {\n  font-size: 12px;\n}\n\n.new-update .media .media-body span,\n.new-update .media .media-body p {\n  font-weight: 500;\n}\n\n.activity-dot-primary {\n  min-width: 6px;\n  width: 6px;\n  height: 6px;\n  background-color: #7366ff;\n  border-radius: 100%;\n  outline: 5px solid rgba(115, 102, 255, 0.25);\n  position: relative;\n  z-index: 2;\n}\n\n.activity-dot-secondary {\n  min-width: 6px;\n  width: 6px;\n  height: 6px;\n  background-color: #ff3364;\n  border-radius: 100%;\n  outline: 5px solid rgba(255, 51, 100, 0.25);\n  position: relative;\n  z-index: 2;\n}\n\n.activity-dot-success {\n  min-width: 6px;\n  width: 6px;\n  height: 6px;\n  background-color: #54ba4a;\n  border-radius: 100%;\n  outline: 5px solid rgba(84, 186, 74, 0.25);\n  position: relative;\n  z-index: 2;\n}\n\n.activity-dot-danger {\n  min-width: 6px;\n  width: 6px;\n  height: 6px;\n  background-color: #fc4438;\n  border-radius: 100%;\n  outline: 5px solid rgba(252, 68, 56, 0.25);\n  position: relative;\n  z-index: 2;\n}\n\n.activity-dot-info {\n  min-width: 6px;\n  width: 6px;\n  height: 6px;\n  background-color: #16c7f9;\n  border-radius: 100%;\n  outline: 5px solid rgba(22, 199, 249, 0.25);\n  position: relative;\n  z-index: 2;\n}\n\n.activity-dot-light {\n  min-width: 6px;\n  width: 6px;\n  height: 6px;\n  background-color: #f4f4f4;\n  border-radius: 100%;\n  outline: 5px solid rgba(244, 244, 244, 0.25);\n  position: relative;\n  z-index: 2;\n}\n\n.activity-dot-dark {\n  min-width: 6px;\n  width: 6px;\n  height: 6px;\n  background-color: #2c323f;\n  border-radius: 100%;\n  outline: 5px solid rgba(44, 50, 63, 0.25);\n  position: relative;\n  z-index: 2;\n}\n\n.activity-dot-warning {\n  min-width: 6px;\n  width: 6px;\n  height: 6px;\n  background-color: #ffaa05;\n  border-radius: 100%;\n  outline: 5px solid rgba(255, 170, 5, 0.25);\n  position: relative;\n  z-index: 2;\n}\n\n@media only screen and (max-width: 1800px) and (min-width: 1400px) {\n  .grid-ed-none {\n    display: none !important;\n  }\n  .grid-ed-12 {\n    width: 100%;\n  }\n}\n@media only screen and (max-width: 1660px) and (min-width: 1400px) {\n  .col-ed-12 {\n    width: 100%;\n  }\n  .col-ed-7 {\n    width: 58%;\n  }\n  .col-ed-5 {\n    width: 42%;\n  }\n  .col-ed-9 {\n    width: 75%;\n  }\n  .col-ed-3 {\n    width: 25%;\n  }\n  .col-ed-6 {\n    width: 50%;\n  }\n  .col-ed-4 {\n    width: 33.33333333%;\n  }\n  .col-ed-8 {\n    width: 66.66%;\n  }\n  .col-ed-none {\n    display: none !important;\n  }\n}\n@media only screen and (max-width: 1660px) and (min-width: 1200px) {\n  .xl-30 {\n    max-width: 30%;\n    flex: 0 0 30%;\n  }\n  .xl-70 {\n    max-width: 70%;\n    flex: 0 0 70%;\n  }\n}\n@media only screen and (max-width: 420px) {\n  .size-column .col-6 {\n    width: 100%;\n  }\n}\n/**=====================\n     67. Dashboard 2  CSS End\n==========================**/\n/**=====================\n     Dashboard 3 CSS Start\n==========================**/\n@keyframes hand-move {\n  0% {\n    transform: rotate(0deg);\n  }\n  20% {\n    transform: rotate(15deg);\n  }\n  50% {\n    transform: rotate(0deg);\n  }\n  80% {\n    transform: rotate(-15deg);\n  }\n  100% {\n    transform: rotate(0deg);\n  }\n}\n.welcome-card {\n  background-image: url(../../images/dashboard-3/bg.jpg);\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  color: #fff;\n}\n.welcome-card h4 img, .welcome-card .h4 img {\n  margin-top: -6px;\n  animation: hand-move 5s infinite ease-in;\n}\n.welcome-card p {\n  width: 75%;\n}\n@media (max-width: 1830px) {\n  .welcome-card p {\n    width: 62%;\n  }\n}\n@media (max-width: 991px) {\n  .welcome-card p {\n    width: 70%;\n  }\n}\n@media (max-width: 480px) {\n  .welcome-card p {\n    width: 100%;\n  }\n}\n.welcome-card .welcome-img {\n  height: 200px;\n  position: absolute;\n  right: 0;\n  bottom: -32px;\n}\n[dir=rtl] .welcome-card .welcome-img {\n  right: unset;\n  left: 0;\n}\n@media (max-width: 1780px) {\n  .welcome-card .welcome-img {\n    height: 180px;\n    bottom: -28px;\n  }\n}\n@media (max-width: 1700px) {\n  .welcome-card .welcome-img {\n    bottom: -23px;\n  }\n}\n@media (max-width: 767px) {\n  .welcome-card .welcome-img {\n    height: 140px;\n    bottom: -18px;\n  }\n}\n@media (max-width: 480px) {\n  .welcome-card .welcome-img {\n    display: none;\n  }\n}\n\n.course-box {\n  overflow: hidden;\n}\n.course-box .card-body {\n  padding: 25px 15px;\n}\n@media (max-width: 1722px) {\n  .course-box .card-body {\n    padding: 20px 15px;\n  }\n}\n@media (max-width: 1660px) {\n  .course-box .card-body {\n    padding: 16px 15px;\n  }\n}\n@media (max-width: 1660px) {\n  .course-box.widget-course .card-body {\n    padding: 25px 15px;\n  }\n}\n.course-box:hover {\n  transform: translateY(-5px);\n  transition: 0.5s;\n}\n.course-box:hover .course-icon svg {\n  animation: tada 1.5s ease infinite;\n}\n\n.course-widget {\n  display: flex;\n  gap: 8px;\n}\n.course-widget .course-icon {\n  position: relative;\n  width: 54px;\n  height: 54px;\n  clip-path: polygon(40% 7.67949%, 43.1596% 6.20615%, 46.52704% 5.30384%, 50% 5%, 53.47296% 5.30384%, 56.8404% 6.20615%, 60% 7.67949%, 81.65064% 20.17949%, 84.50639% 22.17911%, 86.97152% 24.64425%, 88.97114% 27.5%, 90.44449% 30.6596%, 91.34679% 34.02704%, 91.65064% 37.5%, 91.65064% 62.5%, 91.34679% 65.97296%, 90.44449% 69.3404%, 88.97114% 72.5%, 86.97152% 75.35575%, 84.50639% 77.82089%, 81.65064% 79.82051%, 60% 92.32051%, 56.8404% 93.79385%, 53.47296% 94.69616%, 50% 95%, 46.52704% 94.69616%, 43.1596% 93.79385%, 40% 92.32051%, 18.34936% 79.82051%, 15.49361% 77.82089%, 13.02848% 75.35575%, 11.02886% 72.5%, 9.55551% 69.3404%, 8.65321% 65.97296%, 8.34936% 62.5%, 8.34936% 37.5%, 8.65321% 34.02704%, 9.55551% 30.6596%, 11.02886% 27.5%, 13.02848% 24.64425%, 15.49361% 22.17911%, 18.34936% 20.17949%);\n  background: linear-gradient(310.31deg, #ff3364 14.71%, #ff7f9e 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.course-widget .course-icon svg {\n  width: 26px;\n  height: 26px;\n  fill: #fff;\n}\n.course-widget .course-icon.warning {\n  background: linear-gradient(297.08deg, #ff9e2a -4.53%, #ffa941 98.25%);\n}\n.course-widget .btn-light {\n  background: var(--course-light-btn) !important;\n  border: none;\n}\n.course-widget a {\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n  margin-top: 25px;\n}\n.course-widget a span {\n  display: block;\n  margin-bottom: -5px;\n}\n.course-widget a svg {\n  width: 13px;\n  height: 13px;\n}\n\n.get-card .card-header {\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n.square-group {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  transform: scaleX(-1);\n}\n[dir=rtl] .square-group {\n  right: unset;\n  left: 0;\n}\n.square-group .square-1 {\n  width: 12px;\n  height: 18px;\n}\n.square-group .square-2 {\n  width: 12px;\n  height: 10px;\n  margin-bottom: -10px;\n}\n.square-group .square-3 {\n  width: 18px;\n  height: 10px;\n  margin-left: 10px;\n}\n[dir=rtl] .square-group .square-3 {\n  margin-left: unset;\n  margin-right: 10px;\n}\n.square-group .square-4 {\n  width: 16px;\n  height: 16px;\n  position: absolute;\n  top: 20px;\n  right: -15px;\n}\n[dir=rtl] .square-group .square-4 {\n  right: unset;\n  left: -15px;\n}\n.square-group .square-5 {\n  width: 6px;\n  height: 6px;\n  bottom: 22px;\n  position: absolute;\n  right: -1px;\n}\n[dir=rtl] .square-group .square-5 {\n  right: unset;\n  left: -1px;\n}\n.square-group .square-6,\n.square-group .square-7 {\n  position: absolute;\n  width: 4px;\n  height: 4px;\n}\n.square-group .square-6 {\n  right: -23px;\n  bottom: 5px;\n}\n[dir=rtl] .square-group .square-6 {\n  right: unset;\n  left: -23px;\n}\n.square-group .square-7 {\n  right: 8px;\n  bottom: 45px;\n}\n[dir=rtl] .square-group .square-7 {\n  right: unset;\n  left: 8px;\n}\n.square-group .warning1 {\n  background: #ffd497 !important;\n}\n.square-group .warning {\n  background: #ffa73b !important;\n}\n.square-group .primary {\n  background: #7366ff !important;\n}\n.square-group .danger {\n  background: #f54132 !important;\n}\n.square-group .light {\n  background: #e6e8ef !important;\n}\n.square-group .success {\n  background: #54ba4a !important;\n}\n\n.progress-chart-wrap {\n  margin: -40px 0 -22px;\n}\n[dir=rtl] .progress-chart-wrap {\n  direction: ltr;\n}\n@media (max-width: 991px) {\n  .progress-chart-wrap {\n    margin-top: -18px;\n  }\n}\n.progress-chart-wrap .apexcharts-canvas {\n  margin: 0 auto;\n}\n.progress-chart-wrap .apexcharts-canvas .apexcharts-datalabels-group .apexcharts-datalabel-label {\n  fill: var(--chart-text-color);\n}\n\n.get-card .btn {\n  margin-top: 15px;\n  padding: 8px 15px;\n}\n.get-card .btn:hover svg {\n  transform: translateX(5px);\n  transition: 0.5s;\n}\n.get-card .btn svg {\n  width: 13px;\n  height: 13px;\n  fill: #fff;\n  vertical-align: middle;\n  transition: 0.5s;\n}\n\n.default-datepicker .datepicker-inline .datepicker {\n  width: auto;\n  background: #fff;\n  box-shadow: none;\n  padding: 0;\n}\n.default-datepicker .datepicker-inline .datepicker .datepicker--content {\n  padding: 0;\n}\n.default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--days-names {\n  margin: 27px 0 0;\n  padding: 15px 0;\n}\n.default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--days-names .datepicker--day-name {\n  color: #2b2b2b;\n  font-size: 14px;\n}\n.default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--cells .datepicker--cell-day {\n  height: 35px;\n  width: 14%;\n  color: #2b2b2b;\n}\n.default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--cells .datepicker--cell-day.-other-month- {\n  color: #2b2b2b;\n  opacity: 20%;\n}\n.default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--cells .datepicker--cell-day.-weekend- + .-weekend- {\n  color: #fc4438;\n}\n.default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--cells .datepicker--cell {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 17px;\n  z-index: 0;\n  letter-spacing: 2px;\n}\n.default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--cells .datepicker--cell.-selected- {\n  background: var(--theme-default);\n  color: #fff;\n  position: relative;\n  box-shadow: 0px 0px 13px 0 rgba(115, 102, 255, 0.5);\n}\n.default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--cells .datepicker--cell.-current- {\n  background-color: #54ba4a;\n  border: none;\n  color: #fff;\n}\n.default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--cells .datepicker--cell.-current-::after {\n  position: absolute;\n  content: \"\";\n  width: 10px;\n  height: 10px;\n  border: 2px solid var(--white);\n  background: #fc4438;\n  right: -3px;\n  top: -2px;\n  border-radius: 100%;\n}\n.default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--cells .datepicker--cell.-focus- {\n  color: #fff;\n  box-shadow: none;\n}\n.default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker-cell .datepicker--cell-month.-current-.-selected- {\n  background-color: var(--theme-default);\n}\n.default-datepicker .datepicker-inline .datepicker .datepicker--nav {\n  border-bottom: none;\n  padding: 0;\n  text-transform: capitalize;\n  margin-top: 0;\n}\n.default-datepicker .datepicker-inline .datepicker .datepicker--nav .datepicker--nav-action {\n  background-color: transparent;\n  width: 22px;\n  height: 22px;\n}\n.default-datepicker .datepicker-inline .datepicker .datepicker--nav .datepicker--nav-action[data-action=prev] {\n  position: absolute;\n  right: 50px;\n}\n[dir=rtl] .default-datepicker .datepicker-inline .datepicker .datepicker--nav .datepicker--nav-action[data-action=prev] {\n  right: unset;\n  left: 50px;\n}\n.default-datepicker .datepicker-inline .datepicker .datepicker--nav .datepicker--nav-action svg {\n  width: 22px;\n  height: 22px;\n}\n.default-datepicker .datepicker-inline .datepicker .datepicker--nav .datepicker--nav-action path {\n  stroke: var(--chart-text-color);\n}\n.default-datepicker .datepicker-inline .datepicker .datepicker--nav-title {\n  color: #2b2b2b;\n  font-size: 20px;\n  font-weight: 500;\n}\n@media (max-width: 767px) {\n  .default-datepicker .datepicker-inline .datepicker .datepicker--nav-title {\n    font-size: 14px;\n  }\n}\n.default-datepicker .datepicker-inline .datepicker .datepicker--nav-title i {\n  margin-left: 10px;\n  font-weight: 500;\n  font-size: 20px;\n  color: #2b2b2b;\n}\n@media (max-width: 767px) {\n  .default-datepicker .datepicker-inline .datepicker .datepicker--nav-title i {\n    font-size: 14px;\n  }\n}\n\n.learning-wrap {\n  margin: -24px -10px -24px -15px;\n}\n\n.activity-wrap {\n  margin: -22px 0 -22px -28px;\n}\n[dir=rtl] .activity-wrap {\n  margin: -22px -28px -22px 0;\n}\n\n.upcoming-event-wrap {\n  margin-bottom: -39px;\n  margin-left: -24px;\n}\n\n.course-card .dropdown .dropdown-toggle {\n  width: 125px;\n}\n\n.course-wrapper {\n  text-align: center;\n}\n.course-wrapper .course-icon-box {\n  position: relative;\n  padding: 8px;\n}\n@media (max-width: 767px) {\n  .course-wrapper .course-icon-box {\n    padding: 0;\n  }\n}\n.course-wrapper .course-icon-box .icon-wrap {\n  width: 117px;\n  height: 92px;\n  background-color: var(--course-bg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  margin: 0 auto;\n  box-shadow: -18px 15px 20px rgba(119, 119, 119, 0.25);\n}\n@media (max-width: 1880px) {\n  .course-wrapper .course-icon-box .icon-wrap {\n    width: 112px;\n  }\n}\n@media (max-width: 767px) {\n  .course-wrapper .course-icon-box .icon-wrap {\n    box-shadow: none;\n  }\n}\n@media (max-width: 575px) {\n  .course-wrapper .course-icon-box .icon-wrap {\n    width: 92px;\n    height: 82px;\n  }\n}\n.course-wrapper .course-icon-box .icon-wrap img {\n  width: 80px;\n}\n@media (max-width: 575px) {\n  .course-wrapper .course-icon-box .icon-wrap img {\n    width: 70px;\n  }\n}\n.course-wrapper .course-icon-box .arrow-bg {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: calc(100% + 20px);\n  height: 100%;\n}\n[dir=rtl] .course-wrapper .course-icon-box .arrow-bg {\n  left: unset;\n  right: 0;\n  transform: scaleX(-1);\n}\n@media (max-width: 767px) {\n  .course-wrapper .course-icon-box .arrow-bg {\n    display: none;\n  }\n}\n.course-wrapper h6, .course-wrapper .h6 {\n  margin-top: 25px;\n  margin-bottom: 0;\n}\n@media (max-width: 575px) {\n  .course-wrapper h6, .course-wrapper .h6 {\n    margin-top: 15px;\n  }\n}\n\n.course-main-card {\n  display: flex;\n  gap: 20px;\n  justify-content: center;\n}\n@media (max-width: 1880px) {\n  .course-main-card {\n    flex-wrap: wrap;\n  }\n}\n@media (max-width: 767px) {\n  .course-main-card {\n    gap: 12px;\n    flex-wrap: nowrap;\n  }\n}\n@media (max-width: 575px) {\n  .course-main-card {\n    gap: 20px;\n    flex-wrap: wrap;\n  }\n}\n.course-main-card .course-wrapper:last-child .arrow-bg {\n  width: 100%;\n}\n\n.schedule-list {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n@media (max-width: 767px) {\n  .schedule-list {\n    flex-direction: row;\n  }\n}\n@media (max-width: 575px) {\n  .schedule-list {\n    flex-direction: column;\n  }\n}\n.schedule-list li {\n  display: flex;\n  align-items: center;\n}\n.schedule-list li h6, .schedule-list li .h6 {\n  font-size: 14px;\n}\n.schedule-list li ul {\n  column-count: 2;\n  column-rule-style: solid;\n  column-rule-color: var(--chart-text-color);\n  column-gap: 20px;\n  column-rule-width: 1px;\n}\n@media (max-width: 1712px) {\n  .schedule-list li ul {\n    column-gap: 14px;\n  }\n}\n@media (max-width: 1199px) {\n  .schedule-list li ul {\n    display: flex;\n    flex-wrap: wrap;\n  }\n}\n.schedule-list li ul li {\n  gap: 6px;\n}\n.schedule-list li img {\n  border-radius: 100%;\n  width: 37px;\n  height: 37px;\n  padding: 3px;\n}\n.schedule-list li svg {\n  width: 15px;\n  height: 15px;\n}\n.schedule-list li svg.f-success {\n  fill: #54ba4a;\n}\n.schedule-list > li {\n  padding: 15px 20px !important;\n  box-shadow: 4px 7px 17px 5px rgba(46, 35, 94, 0.05) !important;\n  gap: 10px;\n  position: relative;\n  border-radius: 10px;\n}\n@media (max-width: 1712px) {\n  .schedule-list > li {\n    padding: 16px 14px;\n  }\n}\n.schedule-list > li::before {\n  position: absolute;\n  content: \"\";\n  width: 5px;\n  height: 100%;\n  left: 0;\n  top: 0;\n  border-radius: 15px 0 0 15px;\n}\n[dir=rtl] .schedule-list > li::before {\n  left: unset;\n  right: 0;\n  border-radius: 0 15px 15px 0;\n}\n.schedule-list > li.primary::before {\n  background-color: var(--theme-default);\n}\n.schedule-list > li.primary img {\n  border: 1px solid var(--theme-default);\n}\n.schedule-list > li.warning::before {\n  background-color: #ffaa05;\n}\n.schedule-list > li.warning img {\n  border: 1px solid #ffaa05;\n}\n\n.link-only {\n  display: flex;\n  align-items: center;\n  color: #52526c;\n}\n.link-only svg {\n  width: 16px;\n  height: 16px;\n}\n\n.general-cal .react-datepicker__current-month {\n  padding: 0;\n}\n.general-cal .react-datepicker__navigation {\n  top: 0;\n}\n.general-cal .cal-date-widget .cal-datepicker .datepicker-here {\n  width: 100%;\n}\n.general-cal .cal-date-widget .cal-datepicker .datepicker-here .react-datepicker {\n  width: 100%;\n  border: 0;\n}\n.general-cal .cal-date-widget .cal-datepicker .datepicker-here .react-datepicker .react-datepicker__month-container {\n  float: none;\n  width: 100%;\n}\n.general-cal .cal-date-widget .cal-datepicker .datepicker-here .react-datepicker__day,\n.general-cal .cal-date-widget .cal-datepicker .datepicker-here .react-datepicker__time-name {\n  width: 100% !important;\n  line-height: 2.17rem !important;\n  border-radius: 10px;\n}\n.general-cal .cal-date-widget .cal-datepicker .datepicker-here .react-datepicker__day-names {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.general-cal .cal-date-widget .cal-datepicker .datepicker-here .react-datepicker__day-names .react-datepicker__day-name {\n  width: 100% !important;\n}\n.general-cal .datepicker {\n  padding: 20px;\n  border-radius: 20px;\n}\n.general-cal .cal-info h2, .general-cal .cal-info .h2 {\n  font-size: 100px;\n  color: #ecf3fa;\n}\n\n.lessons-lists li {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 0 !important;\n}\n.lessons-lists li img {\n  transition: 0.5s;\n}\n.lessons-lists li + li {\n  border-top: 1px solid var(--chart-dashed-border) !important;\n}\n.lessons-lists li:first-child {\n  padding-top: 0 !important;\n}\n.lessons-lists li:last-child {\n  padding-bottom: 0 !important;\n}\n.lessons-lists li:hover img {\n  transform: scale(1.1);\n  transition: 0.5s;\n}\n\n.lesson-wrap {\n  width: 50px;\n  margin-bottom: -11px;\n  margin-top: -6px;\n}\n.lesson-wrap .apexcharts-canvas .apexcharts-datalabel-label {\n  display: none;\n}\n\n@media only screen and (max-width: 575px) {\n  .default-datepicker .datepicker-inline .datepicker .datepicker--nav-title {\n    font-size: 17px;\n  }\n  .default-datepicker .datepicker-inline .datepicker .datepicker--nav-title i {\n    font-size: 17px;\n    margin-left: 10px;\n  }\n  .default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--cells .datepicker--cell {\n    font-size: 13px;\n  }\n}\n@media only screen and (max-width: 360px) {\n  .default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--cells .datepicker--cell.-selected-:before {\n    height: 36px;\n  }\n  .default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--cells .datepicker--cell-day {\n    height: 36px;\n  }\n  .default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--days-names {\n    margin: 13px 0 13px;\n  }\n  .default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--days-names .datepicker--day-name {\n    font-size: 12px;\n  }\n  .default-datepicker .datepicker-inline .datepicker .datepicker--nav-title i {\n    margin-left: 15px;\n    font-size: 25px;\n  }\n}\n/**=====================\n     Dashboard 4 CSS Start\n==========================**/\n.widget-hover:hover {\n  transform: translateY(-5px);\n  transition: 0.5s;\n}\n\n.currency-widget .currency-icon-widget {\n  width: 35px;\n  height: 35px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 5px;\n  box-shadow: inset 2.66667px -2.66667px 2.66667px rgba(194, 128, 49, 0.1), inset -2.66667px 2.66667px 2.66667px rgba(255, 255, 255, 0.1);\n}\n.currency-widget .currency-icon-widget svg {\n  width: 16px;\n  height: 16px;\n  fill: #fff;\n}\n.currency-widget .card {\n  margin-top: 14px;\n}\n.currency-widget .card .card-body {\n  padding: 15px;\n  gap: 10px;\n  justify-content: space-between;\n}\n@media (max-width: 1660px) {\n  .currency-widget .card .card-body {\n    flex-wrap: wrap;\n  }\n}\n@media (max-width: 575px) {\n  .currency-widget .card .card-body {\n    flex-wrap: unset;\n  }\n}\n.currency-widget .card:hover {\n  transform: translateY(-5px);\n  transition: 0.5s;\n}\n.currency-widget h6, .currency-widget .h6 {\n  margin-bottom: 0;\n}\n.currency-widget .d-flex {\n  gap: 10px;\n  align-items: center;\n}\n.currency-widget span svg {\n  width: 16px;\n  height: 16px;\n  vertical-align: middle;\n}\n.currency-widget div[class*=bg-light-] {\n  color: #2f2f3b;\n  padding: 15px;\n  border-radius: 10px;\n  width: 115px;\n}\n@media (max-width: 1660px) and (min-width: 1200px) {\n  .currency-widget div[class*=bg-light-] {\n    display: none;\n  }\n}\n@media (max-width: 1199px) {\n  .currency-widget div[class*=bg-light-] {\n    width: 100%;\n  }\n}\n@media (max-width: 575px) {\n  .currency-widget div[class*=bg-light-] {\n    width: 50%;\n  }\n}\n@media (max-width: 1199px) and (min-width: 768px) {\n  .currency-widget.widget-currency .card .card-body {\n    flex-wrap: unset;\n  }\n}\n.currency-widget.warning .currency-icon-widget {\n  background-image: linear-gradient(to right, #ffaa05 80%, rgba(255, 170, 5, 0.2));\n}\n.currency-widget.primary .currency-icon-widget {\n  background-image: linear-gradient(to right, #7366ff 80%, rgba(115, 102, 255, 0.2));\n}\n.currency-widget.success .currency-icon-widget {\n  background-image: linear-gradient(to right, #54ba4a 80%, rgba(84, 186, 74, 0.2));\n}\n@media (max-width: 1399px) {\n  .currency-widget.height-equal {\n    min-height: unset !important;\n  }\n}\n\n.currency-chart-wrap {\n  margin: -28px -10px -20px -20px;\n}\n@media (max-width: 575px) {\n  .currency-chart-wrap {\n    width: 50%;\n  }\n}\n.currency-chart-wrap .apexcharts-canvas .apexcharts-tooltip-text-y-label {\n  display: none;\n}\n\n.tranaction-card .header-top {\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.crypto-main-card {\n  background-image: linear-gradient(to bottom right, #5f3deb, #ad79ff);\n  color: #fff;\n}\n@media (max-width: 1199px) {\n  .crypto-main-card .card-body {\n    padding: 20px;\n  }\n}\n.crypto-main-card .btn {\n  padding: 8px 20px;\n}\n@media (max-width: 1660px) {\n  .crypto-main-card .btn {\n    padding: 8px 15px;\n  }\n}\n.crypto-main-card .deposit-wrap > div {\n  width: 65%;\n}\n@media (max-width: 1660px) {\n  .crypto-main-card .deposit-wrap > div {\n    width: 90%;\n  }\n}\n@media (max-width: 1536px) {\n  .crypto-main-card .deposit-wrap > div {\n    width: 100%;\n  }\n}\n@media (max-width: 1399px) {\n  .crypto-main-card .deposit-wrap > div {\n    width: 75%;\n  }\n}\n@media (max-width: 1199px) {\n  .crypto-main-card .deposit-wrap > div {\n    width: 95%;\n  }\n}\n@media (max-width: 1660px) {\n  .crypto-main-card .deposit-wrap > div h5, .crypto-main-card .deposit-wrap > div .h5 {\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    -webkit-line-clamp: 2;\n    display: -webkit-box;\n  }\n}\n@media (max-width: 767px) {\n  .crypto-main-card .deposit-wrap > div h5, .crypto-main-card .deposit-wrap > div .h5 {\n    -webkit-line-clamp: 1;\n  }\n}\n.crypto-main-card .deposit-wrap img {\n  position: absolute;\n  right: 10px;\n  bottom: 10px;\n  width: 55%;\n}\n[dir=rtl] .crypto-main-card .deposit-wrap img {\n  right: unset;\n  left: 10px;\n  transform: scaleX(-1);\n}\n@media (max-width: 1660px) {\n  .crypto-main-card .deposit-wrap img {\n    width: 44%;\n  }\n}\n@media (max-width: 1399px) {\n  .crypto-main-card .deposit-wrap img {\n    width: 52%;\n  }\n}\n@media (max-width: 1199px) {\n  .crypto-main-card .deposit-wrap img {\n    width: 30%;\n  }\n}\n\n.portfolio-card .dropdown-toggle {\n  width: 80px;\n}\n\n.btn-white {\n  color: #7366ff;\n  background-color: #fff;\n}\n\n.radial-progress-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 6px;\n}\n.radial-progress-card.card-body {\n  padding: 23px 20px;\n}\n@media (max-width: 1199px) {\n  .radial-progress-card.card-body {\n    padding: 30px 20px;\n  }\n}\n.radial-progress-card p {\n  -webkit-line-clamp: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n}\n.radial-progress-card h6, .radial-progress-card .h6 {\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-line-clamp: 1;\n  display: -webkit-box;\n}\n.radial-progress-card .sale-details {\n  margin: 10px 0;\n}\n.radial-progress-card .sale-details svg {\n  width: 15px;\n  height: 15px;\n  vertical-align: middle;\n}\n.radial-progress-card .radial-chart-wrap {\n  width: 110px;\n  margin-right: -25px;\n}\n[dir=rtl] .radial-progress-card .radial-chart-wrap {\n  margin-right: unset;\n  margin-left: -25px;\n}\n@media (max-width: 1820px) {\n  .radial-progress-card .radial-chart-wrap {\n    margin-right: -12px;\n  }\n  [dir=rtl] .radial-progress-card .radial-chart-wrap {\n    margin-left: -12px;\n  }\n}\n.radial-progress-card .radial-chart-wrap .apexcharts-canvas .apexcharts-datalabel-label {\n  display: none;\n}\n\n.transaction-table table tr:first-child td {\n  padding-top: 0;\n}\n.transaction-table table tr td:first-child {\n  min-width: unset;\n}\n@media (max-width: 1775px) {\n  .transaction-table table tr td:first-child {\n    min-width: 130px;\n  }\n}\n.transaction-table table tr td:last-child {\n  text-align: right;\n  min-width: 60px;\n}\n.transaction-table table tr,\n.transaction-table table td {\n  border-style: dashed;\n}\n\n.custom-tab {\n  background: var(--light2);\n  padding: 4px;\n  border-radius: 5px;\n}\n.custom-tab.nav-tabs {\n  border: none;\n}\n.custom-tab.nav-tabs .nav-link {\n  border: none;\n  padding: 6px 12px;\n  color: var(--chart-text-color);\n}\n.custom-tab.nav-tabs .nav-link.active {\n  color: var(--theme-default);\n}\n\n.market-chart-container {\n  margin: -24px 0 -24px -15px;\n}\n[dir=rtl] .market-chart-container {\n  margin: -24px -15px -24px 0;\n}\n@media (max-width: 575px) {\n  .market-chart-container {\n    margin-bottom: 0;\n  }\n}\n\n.market-card .balance-card {\n  padding: 10px;\n}\n@media (max-width: 575px) {\n  .market-card .custom-tab {\n    display: none;\n  }\n}\n\n.currency-icon {\n  width: 34px;\n  height: 34px;\n  background-color: var(--light2);\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.currency-icon.warning svg {\n  fill: #ffaa05;\n}\n.currency-icon.success svg {\n  fill: #54ba4a;\n}\n.currency-icon.primary svg {\n  fill: #7366ff;\n}\n.currency-icon.secondary svg {\n  fill: #ff3364;\n}\n.currency-icon.dark-green svg {\n  fill: #1ba27a;\n}\n.currency-icon.light-blue svg {\n  fill: #038de7;\n}\n\n.recent-table tr:hover td:first-child h6, .recent-table tr:hover td:first-child .h6 {\n  color: var(--theme-default);\n}\n.recent-table tr:hover .border-icon .social-circle {\n  transform: scale(1.02);\n  transition: 0.5s;\n}\n.recent-table tr:hover .currency-icon svg {\n  animation: tada 1.5s ease infinite;\n}\n.recent-table tr:hover .badge-light-primary {\n  background-color: var(--theme-default);\n  color: #fff;\n}\n\n.currency-table .change-currency svg {\n  width: 16px;\n  height: 16px;\n  vertical-align: sub;\n}\n.currency-table th:nth-child(3),\n.currency-table td:nth-child(3) {\n  min-width: 110px;\n}\n.currency-table th:nth-child(4),\n.currency-table td:nth-child(4) {\n  min-width: 115px;\n}\n\nselect.crypto-select {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 12px;\n  right: 7px;\n  width: 62px;\n  background-position: right 0.25rem center;\n  padding: 8px;\n  border: none;\n  font-weight: 500;\n  background-size: 8px;\n}\n[dir=rtl] select.crypto-select {\n  right: unset;\n  left: 7px;\n}\nselect.crypto-select.warning {\n  background-color: rgba(255, 170, 5, 0.1) !important;\n  color: #ffaa05 !important;\n}\nselect.crypto-select.primary {\n  background-color: rgba(115, 102, 255, 0.1) !important;\n  color: #7366ff !important;\n}\n\n.crypto-form input::-webkit-outer-spin-button, .crypto-form input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.crypto-form input[type=number] {\n  -moz-appearance: textfield;\n}\n\n.balance-box {\n  text-align: center;\n  background-image: url(../../images/dashboard-4/bg-balance.png);\n  background-position: right;\n  background-size: cover;\n}\n.balance-box .balance-img {\n  display: inline-block;\n  padding: 5px;\n  border: 2px solid var(--chart-border);\n  border-left-color: #54ba4a;\n  border-bottom-color: #54ba4a;\n  border-radius: 100%;\n  position: relative;\n  margin-bottom: 15px;\n}\n.balance-box .balance-img img {\n  background-color: var(--balance-profie-bg);\n  border-radius: 100%;\n}\n.balance-box .balance-img .edit-icon {\n  width: 26px;\n  height: 26px;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid var(--white);\n  background-color: #dfdff4;\n  right: 0;\n  bottom: 0;\n  border-radius: 100%;\n}\n.balance-box .balance-img .edit-icon svg {\n  width: 11px;\n  height: 11px;\n  fill: #7366ff;\n}\n\n.balance-profile ul {\n  display: flex;\n  justify-content: center;\n  gap: 50px;\n  margin-top: 16px;\n}\n@media (max-width: 1660px) {\n  .balance-profile ul {\n    gap: 25px;\n  }\n}\n.balance-profile ul li {\n  position: relative;\n}\n.balance-profile ul li + li::before {\n  position: absolute;\n  content: \"\";\n  left: -25px;\n  top: 50%;\n  height: 40px;\n  transform: translateY(-50%);\n  border: 1px dashed var(--recent-dashed-border);\n}\n[dir=rtl] .balance-profile ul li + li::before {\n  left: unset;\n  right: -25px;\n}\n@media (max-width: 1660px) {\n  .balance-profile ul li + li::before {\n    left: -16px;\n  }\n  [dir=rtl] .balance-profile ul li + li::before {\n    right: -16px;\n  }\n}\n\n@media (max-width: 1399px) {\n  .activity-card .appointment-table {\n    height: 180px;\n  }\n}\n@media (max-width: 575px) {\n  .activity-card .appointment-table {\n    height: unset;\n  }\n}\n.activity-card .appointment-table tr td:nth-child(2) {\n  min-width: 130px;\n}\n\n.balance-item {\n  display: flex;\n  gap: 10px;\n}\n.balance-item .balance-icon-wrap {\n  width: 40px;\n  min-width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n}\n@media (max-width: 1660px) {\n  .balance-item .balance-icon-wrap {\n    width: 25px;\n    min-width: 25px;\n    height: 25px;\n    border-radius: 8px;\n  }\n}\n.balance-item .balance-icon-wrap .balance-icon {\n  width: 16px;\n  height: 16px;\n  border-radius: 100%;\n}\n@media (max-width: 1660px) {\n  .balance-item .balance-icon-wrap .balance-icon {\n    width: 14px;\n    height: 14px;\n  }\n}\n.balance-item .balance-icon-wrap .balance-icon svg {\n  color: #fff;\n  width: 14px;\n  height: 14px;\n}\n@media (max-width: 1660px) {\n  .balance-item .balance-icon-wrap .balance-icon svg {\n    width: 12px;\n    height: 12px;\n    vertical-align: text-top;\n  }\n}\n.balance-item .badge {\n  padding: 8px 10px;\n}\n.balance-item.danger .balance-icon-wrap {\n  background-color: rgba(252, 68, 56, 0.1);\n}\n.balance-item.danger .balance-icon-wrap .balance-icon {\n  background-color: #fc4438;\n}\n.balance-item.success .balance-icon-wrap {\n  background-color: rgba(84, 186, 74, 0.1);\n}\n.balance-item.success .balance-icon-wrap .balance-icon {\n  background-color: #54ba4a;\n}\n\n.portfolio-chart-container {\n  margin-top: -56px;\n}\n@media (max-width: 1399px) {\n  .portfolio-chart-container {\n    margin-top: -20px;\n  }\n}\n\n.portfolio-table .status {\n  width: 6px;\n  height: 6px;\n  border-radius: 100%;\n  display: inline-block;\n}\n.portfolio-table table tr,\n.portfolio-table table td {\n  border-style: dashed;\n}\n@media (max-width: 1755px) {\n  .portfolio-table table tr td:first-child,\n  .portfolio-table table tr th:first-child {\n    min-width: 100px;\n  }\n}\n@media (max-width: 1755px) {\n  .portfolio-table table tr td:last-child,\n  .portfolio-table table tr th:last-child {\n    min-width: 128px;\n  }\n}\n\n/**=====================\n     Dashboard 5 CSS Start\n==========================**/\n.social-img {\n  padding: 5px;\n  background: var(--white);\n  border-radius: 100%;\n}\n.social-widget .card-body {\n  padding: 15px;\n}\n.social-widget .social-icons {\n  min-width: 55px;\n  height: 55px;\n  background: var(--white);\n  box-shadow: 0px 42.1092px 27.8569px rgba(41, 72, 152, 0.0303704), 0px 8.90772px 7.12618px rgba(41, 72, 152, 0.0196296), 0px 2.02448px 3.44162px rgba(41, 72, 152, 0.012037);\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n@media (max-width: 1399px) {\n  .social-widget .social-icons {\n    min-width: 40px;\n    height: 40px;\n  }\n  .social-widget .social-icons img {\n    height: 20px;\n  }\n}\n.social-widget .social-content {\n  margin-top: 20px;\n  display: flex;\n  justify-content: space-between;\n}\n.social-widget .social-content .social-chart {\n  margin: -34px -42px -13px;\n  width: 150px;\n}\n.social-widget .social-content .social-chart .apexcharts-canvas .apexcharts-datalabels-group .apexcharts-datalabel-label {\n  display: none;\n}\n\n.follower-chart {\n  margin: -20px 0 -20px -34px;\n}\n@media (max-width: 717px) {\n  .follower-chart {\n    margin-left: 0;\n  }\n}\n\n@keyframes wave-speaker {\n  0% {\n    transform: translateX(5px);\n  }\n  50% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(5px);\n  }\n}\n.mobile-app-card .card-header {\n  background: transparent;\n  padding: 20px;\n  width: 68%;\n}\n@media (max-width: 1693px) {\n  .mobile-app-card .card-header {\n    width: 75%;\n  }\n}\n@media (max-width: 1316px) {\n  .mobile-app-card .card-header {\n    width: 86%;\n  }\n}\n@media (max-width: 991px) {\n  .mobile-app-card .card-header {\n    width: 64%;\n  }\n}\n@media (max-width: 350px) {\n  .mobile-app-card .card-header {\n    width: 75%;\n  }\n}\n.mobile-app-card .card-body {\n  margin-top: -10px;\n}\n@media (max-width: 1199px) {\n  .mobile-app-card .card-body {\n    margin-top: 26px;\n  }\n}\n@media (max-width: 991px) {\n  .mobile-app-card .card-body {\n    margin-top: 20px;\n  }\n}\n.mobile-app-card .card-body .wavy {\n  width: 26px;\n  margin-right: -37px;\n  margin-top: -10px;\n  animation: wave-speaker 2s ease infinite;\n}\n.mobile-app-card .purchase-btn {\n  padding: 10px 25px;\n  min-width: unset;\n}\n\n.subscriber-chart-container {\n  margin: -22px -10px -24px;\n}\n\n.click-widgets .card-body {\n  padding: 28px 15px;\n}\n.click-widgets .click-chart {\n  margin: 0;\n}\n\n@media (max-width: 1693px) {\n  .follower-wrap .card-body,\n  .follower-wrap .card-header {\n    padding: 22px;\n  }\n}\n.follower-wrap .card-header {\n  padding-bottom: 20px;\n}\n\n.campaign-list {\n  column-count: 2;\n  column-gap: 20px;\n  margin-bottom: 15px;\n}\n.campaign-list li {\n  position: relative;\n}\n.campaign-list li + li::before {\n  position: absolute;\n  content: \"\";\n  width: 1px;\n  height: 20px;\n  background-color: var(--chart-text-color);\n  top: 50%;\n  transform: translateY(-50%);\n  left: -10px;\n  opacity: 0.6;\n}\n[dir=rtl] .campaign-list li + li::before {\n  left: unset;\n  right: -10px;\n}\n.campaign-list .campaign-box {\n  background: linear-gradient(180deg, var(--course-light-btn) 0%, rgba(242, 243, 247, 0) 100%);\n  border-radius: 5px;\n  padding: 6px 10px;\n}\n\n.social-circle {\n  width: 34px;\n  height: 34px;\n  border-width: 1px;\n  border-style: solid;\n  border-radius: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: 0.5s;\n}\n\n.campaign-table table tr:hover td:nth-child(2) {\n  color: var(--theme-default);\n}\n.campaign-table .border-icon > div {\n  border-left: 2px solid #2f84f4;\n  padding-left: 15px;\n}\n[dir=rtl] .campaign-table .border-icon > div {\n  padding-left: unset;\n  padding-right: 15px;\n}\n.campaign-table .facebook > div {\n  border-left: 2px solid #2f84f4;\n}\n[dir=rtl] .campaign-table .facebook > div {\n  border-left: unset;\n  border-right: 2px solid #2f84f4;\n}\n.campaign-table .facebook .social-circle {\n  background-color: rgba(47, 132, 244, 0.1);\n  border-color: #2f84f4;\n  color: #2f84f4;\n}\n.campaign-table .instagram > div {\n  border-left: 2px solid #fc971e;\n}\n[dir=rtl] .campaign-table .instagram > div {\n  border-left: unset;\n  border-right: 2px solid #fc971e;\n}\n.campaign-table .instagram .social-circle {\n  background-color: rgba(252, 151, 30, 0.1);\n  border-color: #fc971e;\n  color: #fc971e;\n}\n.campaign-table .pinterest > div {\n  border-left: 2px solid #ff3364;\n}\n[dir=rtl] .campaign-table .pinterest > div {\n  border-left: unset;\n  border-right: 2px solid #ff3364;\n}\n.campaign-table .pinterest .social-circle {\n  background-color: rgba(255, 51, 100, 0.1);\n  border-color: #ff3364;\n  color: #ff3364;\n}\n.campaign-table .plus-btn {\n  width: 24px;\n  border-radius: 5px;\n  background-color: transparent;\n  border: 1px solid var(--body-font-color);\n  color: var(--body-font-color);\n}\n.campaign-table .plus-btn:hover {\n  background-color: var(--body-font-color);\n  color: var(--white);\n}\n.campaign-table .twitter > div {\n  border-left: 2px solid #57b9f6;\n}\n[dir=rtl] .campaign-table .twitter > div {\n  border-left: unset;\n  border-right: 2px solid #57b9f6;\n}\n.campaign-table .twitter .social-circle {\n  background-color: rgba(87, 185, 246, 0.1);\n  border-color: #57b9f6;\n  color: #57b9f6;\n}\n.campaign-table .you-tube > div {\n  border-left: 2px solid #f42f2f;\n}\n[dir=rtl] .campaign-table .you-tube > div {\n  border-left: unset;\n  border-right: 2px solid #f42f2f;\n}\n.campaign-table .you-tube .social-circle {\n  background-color: rgba(244, 47, 47, 0.1);\n  border-color: #f42f2f;\n  color: #f42f2f;\n}\n.campaign-table .badge-light-primary,\n.campaign-table .badge-light-light {\n  padding: 4px 12px;\n}\n.campaign-table tr td,\n.campaign-table tr th {\n  border-style: dashed;\n}\n.campaign-table tr td:nth-child(5),\n.campaign-table tr th:nth-child(5) {\n  min-width: 190px;\n}\n.campaign-table .recent-table tr td:nth-child(2),\n.campaign-table .recent-table tr th:nth-child(2) {\n  min-width: 120px;\n}\n.campaign-table .recent-table tr td:first-child,\n.campaign-table .recent-table tr th:first-child {\n  min-width: 110px;\n}\n.campaign-table .recent-table tr td:nth-child(3), .campaign-table .recent-table tr td:last-child,\n.campaign-table .recent-table tr th:nth-child(3),\n.campaign-table .recent-table tr th:last-child {\n  min-width: 50px;\n}\n\n.view-container .apexcharts-canvas .apexcharts-grid-row {\n  stroke-width: 15px;\n  stroke: var(--white);\n}\n.view-container .apexcharts-canvas .apexcharts-gridlines-vertical line,\n.view-container .apexcharts-canvas .apexcharts-gridlines-vertical react,\n.view-container .apexcharts-canvas .apexcharts-gridlines-horizontal line,\n.view-container .apexcharts-canvas .apexcharts-gridlines-horizontal react {\n  stroke-width: 15px;\n  stroke: var(--white);\n}\n.view-container .apexcharts-canvas .apexcharts-point-annotations circle {\n  outline: 25px solid #f0effd;\n  border-radius: 100%;\n}\n@media (max-width: 480px) {\n  .view-container .apexcharts-canvas .apexcharts-point-annotations circle {\n    outline-width: 10px;\n  }\n}\n\n/**=====================\n53. Dashboard CSS Start\n==========================**/\n.form-control-plaintext {\n  width: auto !important;\n}\n\n@keyframes bounce-effect {\n  0% {\n    transform: translateY(0);\n    transition: 0.5s;\n  }\n  50% {\n    transform: translateY(-5px);\n    transition: 0.5s;\n  }\n  100% {\n    transform: translateY(0);\n    transition: 0.5s;\n  }\n}\n@keyframes round {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.2);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.badge-light-primary {\n  background-color: white;\n  color: #7366ff;\n}\n\n.badge-light-secondary {\n  background-color: rgb(100%, 96%, 96.9607843137%);\n  color: #ff3364;\n}\n\n.badge-light-success {\n  background-color: rgb(84.9251764706%, 93.9171764706%, 84.0436078431%);\n  color: #54ba4a;\n}\n\n.badge-light-danger {\n  background-color: rgb(99.9522422831%, 97.0231023102%, 96.8320714424%);\n  color: #fc4438;\n}\n\n.badge-light-info {\n  background-color: rgb(82.7195011896%, 95.846747067%, 99.5550086143%);\n  color: #16c7f9;\n}\n\n.badge-light-light {\n  background-color: rgb(71.8687306502%, 71.8687306502%, 78.6410732714%);\n  color: #52526c;\n}\n\n.badge-light-dark {\n  background-color: rgb(51.6965365585%, 56.2968664101%, 66.2642477552%);\n  color: #2c323f;\n}\n\n.badge-light-warning {\n  background-color: rgb(100%, 92.5066666667%, 77.9607843137%);\n  color: #ffaa05;\n}\n\n.badge-light-light {\n  background-color: rgb(91.1950464396%, 91.1950464396%, 93.3147574819%);\n}\n\n.badge-light-primary {\n  background-color: rgba(115, 102, 255, 0.1);\n}\n\n.badge-light-success {\n  background-color: rgba(84, 186, 74, 0.15);\n}\n\n.badge-light-secondary {\n  background-color: rgba(255, 51, 100, 0.08);\n}\n\n.table thead th {\n  border-bottom: 2px solid #ecf3fa;\n}\n\n@media (max-width: 1712px) {\n  .overall-card .balance-card {\n    padding: 12px;\n  }\n}\n@media (max-width: 1662px) and (min-width: 1600px) {\n  .overall-card .col-xl-9 {\n    width: 73%;\n  }\n  .overall-card .col-xl-3 {\n    width: 27%;\n  }\n}\n@media (max-width: 1650px) and (min-width: 1600px) {\n  .overall-card .col-xl-9 {\n    width: 72%;\n  }\n  .overall-card .col-xl-3 {\n    width: 28%;\n  }\n}\n@media (max-width: 1600px) and (min-width: 1500px) {\n  .overall-card .col-xl-9 {\n    width: 70%;\n  }\n  .overall-card .col-xl-3 {\n    width: 30%;\n  }\n}\n@media (max-width: 1500px) and (min-width: 1200px) {\n  .overall-card .col-xl-9 {\n    width: 65%;\n  }\n  .overall-card .col-xl-3 {\n    width: 35%;\n  }\n}\n\n/* Clock styles */\n.clockbox {\n  margin-bottom: -5px;\n}\n.clockbox svg {\n  width: 45px;\n  height: 45px;\n}\n@media (max-width: 767px) {\n  .clockbox svg {\n    height: 36px;\n  }\n}\n\n.clockbox,\n#clock {\n  width: 100%;\n}\n\n.circle {\n  fill: #fff;\n  stroke: rgba(255, 255, 255, 0.4);\n  stroke-width: 80px;\n  stroke-miterlimit: 10;\n}\n\n.mid-circle {\n  fill: #000;\n}\n\n.hour-marks {\n  fill: none;\n  stroke: #52526c;\n  stroke-width: 9;\n  stroke-miterlimit: 10;\n}\n\n.hour-hand {\n  fill: none;\n  stroke: #ff7e00;\n  stroke-width: 17;\n  stroke-miterlimit: 10;\n}\n\n.minute-hand {\n  fill: none;\n  stroke: #ff7e00;\n  stroke-width: 11;\n  stroke-miterlimit: 10;\n}\n\n.second-hand {\n  fill: none;\n  stroke: #ffaa05;\n  stroke-width: 15px;\n  stroke-miterlimit: 10;\n}\n\n.sizing-box {\n  fill: none;\n}\n\n#hour,\n#minute,\n#second {\n  transform-origin: 300px 300px;\n  transition: transform 0.5s ease-in-out;\n}\n\n@media (min-width: 1400px) {\n  .widget-grid .height-equal {\n    min-height: unset !important;\n  }\n}\n@media (min-width: 1400px) {\n  .widget-grid > .col-xxl-auto {\n    width: 22.22%;\n  }\n}\n\n.order-chart > div {\n  margin-top: -25px;\n  margin-bottom: -43px;\n}\n.order-chart svg path {\n  clip-path: inset(7% 0% 0% 0% round 0.6rem);\n}\n\n.growth-wrap .card-header {\n  position: relative;\n  z-index: 1;\n}\n\n.growth-wrapper > div {\n  margin-top: -54px;\n  margin-bottom: -25px;\n}\n@media (max-width: 1481px) {\n  .growth-wrapper > div {\n    margin-top: -50px;\n  }\n}\n\n.profit-chart > div {\n  margin-top: -45px;\n  margin-bottom: -48px;\n}\n.profit-chart .apexcharts-canvas .apexcharts-tooltip-text-label {\n  display: none;\n}\n\n.widget-1 {\n  background-image: url(../../images/dashboard/widget-bg.png);\n  background-size: cover;\n  margin-bottom: 25px;\n}\n.widget-1 i {\n  font-weight: 700;\n  font-size: 12px;\n}\n.widget-1 .f-w-500 {\n  display: flex;\n  align-items: center;\n}\n@media (max-width: 1580px) and (min-width: 1200px) {\n  .widget-1 .f-w-500 {\n    display: none;\n  }\n}\n.widget-1 .card-body {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  padding: 18px 25px;\n}\n@media (max-width: 1720px) {\n  .widget-1 .card-body {\n    padding: 18px;\n  }\n}\n.widget-1 .widget-round {\n  position: relative;\n  display: inline-block;\n  border-width: 1px;\n  border-style: solid;\n  border-radius: 100%;\n}\n.widget-1 .widget-round .bg-round {\n  width: 56px;\n  height: 56px;\n  box-shadow: 1px 2px 21px -2px rgba(214, 214, 227, 0.83);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 100%;\n  margin: 6px;\n  position: relative;\n  z-index: 1;\n}\n.widget-1 .widget-round .bg-round svg {\n  width: 24px;\n  height: 24px;\n}\n.widget-1 .widget-round .bg-round .half-circle {\n  height: 52px;\n  position: absolute;\n  left: -9px;\n  width: 35px;\n  bottom: -8px;\n  background: #fff;\n  z-index: -1;\n}\n@media (max-width: 1600px) {\n  .widget-1 .widget-round .bg-round {\n    width: 40px;\n    height: 40px;\n  }\n  .widget-1 .widget-round .bg-round svg {\n    width: 22px;\n    height: 22px;\n  }\n  .widget-1 .widget-round .bg-round .half-circle {\n    height: 40px;\n    left: -10px;\n    width: 30px;\n    bottom: -8px;\n  }\n}\n.widget-1 .widget-round.primary {\n  border-color: var(--theme-default);\n}\n.widget-1 .widget-round.secondary {\n  border-color: var(--theme-secondary);\n}\n.widget-1 .widget-round.success {\n  border-color: #54ba4a;\n}\n.widget-1 .widget-round.warning {\n  border-color: #ffaa05;\n}\n.widget-1 .widget-content {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n@media (max-width: 1600px) {\n  .widget-1 .widget-content {\n    gap: 10px;\n  }\n}\n.widget-1 .widget-content h4, .widget-1 .widget-content .h4 {\n  margin-bottom: 4px;\n}\n.widget-1:hover {\n  transform: translateY(-5px);\n  transition: 0.5s;\n}\n.widget-1:hover .widget-round .svg-fill:not(.half-circle) {\n  animation: tada 1.5s ease infinite;\n}\n\n.widget-with-chart .card-body {\n  align-items: center;\n}\n\n.profile-box {\n  background: linear-gradient(103.75deg, #33b1ee -13.9%, var(--theme-default) 79.68%);\n  color: #fff;\n}\n.profile-box .cartoon {\n  position: absolute;\n  bottom: -15px;\n  right: 20px;\n  animation: bounce-effect 5s infinite ease-in;\n}\n[dir=rtl] .profile-box .cartoon {\n  right: unset !important;\n  left: 5px;\n}\n@media (max-width: 1660px) {\n  .profile-box .cartoon {\n    right: 30px;\n    text-align: right;\n  }\n  [dir=rtl] .profile-box .cartoon {\n    left: -6px;\n    text-align: left;\n  }\n  .profile-box .cartoon img {\n    width: 80%;\n  }\n}\n@media (max-width: 1500px) {\n  .profile-box .cartoon img {\n    width: 60%;\n  }\n}\n@media (max-width: 767px) {\n  .profile-box .cartoon {\n    right: 10px;\n  }\n  [dir=rtl] .profile-box .cartoon {\n    left: -10px;\n  }\n  .profile-box .cartoon img {\n    width: 52%;\n  }\n}\n@media (max-width: 575px) {\n  .profile-box .cartoon {\n    right: 30px;\n  }\n  [dir=rtl] .profile-box .cartoon {\n    left: 10px;\n  }\n  .profile-box .cartoon img {\n    width: 48%;\n  }\n}\n.profile-box .greeting-user p {\n  width: 60%;\n}\n@media (max-width: 1500px) {\n  .profile-box .greeting-user p {\n    width: 70%;\n  }\n}\n@media (max-width: 1199px) {\n  .profile-box .greeting-user p {\n    width: 80%;\n  }\n}\n@media (max-width: 767px) {\n  .profile-box .greeting-user p {\n    width: 98%;\n  }\n}\n@media (max-width: 600px) {\n  .profile-box .greeting-user p {\n    width: 100%;\n  }\n}\n@media (max-width: 575px) {\n  .profile-box .greeting-user p {\n    width: 98%;\n  }\n}\n.profile-box .whatsnew-btn {\n  margin-top: 3.5rem;\n}\n@media (max-width: 1500px) {\n  .profile-box .whatsnew-btn {\n    margin-top: 1.7rem;\n  }\n}\n@media (max-width: 991px) {\n  .profile-box .whatsnew-btn {\n    margin-top: 3.5rem;\n  }\n}\n@media (max-width: 638px) {\n  .profile-box .whatsnew-btn {\n    margin-top: 2rem;\n  }\n}\n@media (max-width: 767px) {\n  .profile-box .whatsnew-btn .btn {\n    padding: 6px 10px;\n  }\n}\n\n.header-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 4px;\n}\n.header-top a i {\n  font-size: 14px;\n  margin-bottom: -2px;\n}\n.header-top a.btn {\n  padding: 8px 12px;\n}\n@media (max-width: 575px) {\n  .header-top a.btn {\n    padding: 5px;\n  }\n}\n.header-top a.btn.badge-light-primary:hover {\n  background-color: var(--theme-default);\n}\n\n.user-details {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n@media (max-width: 1399px) {\n  .user-details {\n    gap: 6px;\n  }\n}\n.user-details .customers {\n  width: 200px;\n}\n@media (max-width: 575px) {\n  .user-details {\n    flex-wrap: wrap;\n  }\n}\n\n.papernote-wrap .banner-img {\n  border-radius: 15px;\n  width: 100%;\n}\n.papernote-wrap .note-labels {\n  display: flex;\n  align-items: center;\n}\n.papernote-wrap .note-labels > * {\n  padding: 3px 0;\n}\n.papernote-wrap .note-labels ul {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n@media (max-width: 575px) {\n  .papernote-wrap .note-labels ul {\n    gap: 4px;\n  }\n}\n.papernote-wrap .note-labels .badge {\n  font-size: 14px;\n  padding: 6px 12px;\n}\n@media (max-width: 575px) {\n  .papernote-wrap .note-labels .badge {\n    font-size: 12px;\n    padding: 5px 6px;\n  }\n}\n.papernote-wrap .note-labels .last-label {\n  padding-left: 16px;\n  margin-left: 16px;\n  border-left: 1px dashed rgba(82, 82, 108, 0.7);\n}\n[dir=rtl] .papernote-wrap .note-labels .last-label {\n  padding-left: unset;\n  margin-left: unset;\n  margin-right: 16px;\n  padding-right: 16px;\n  border-left: none;\n  border-right: 1px dashed rgba(82, 82, 108, 0.7);\n}\n@media (max-width: 575px) {\n  .papernote-wrap .note-labels .last-label {\n    padding-left: 8px;\n    margin-left: 8px;\n  }\n  [dir=rtl] .papernote-wrap .note-labels .last-label {\n    margin-right: 8px;\n    padding-right: 8px;\n  }\n}\n.papernote-wrap .light-card {\n  width: 40px;\n  height: 40px;\n  border-radius: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--light2);\n  border: 1px solid rgba(82, 82, 108, 0.2);\n}\n\n.appointment-sec .card-header-right-icon select {\n  background-color: rgba(115, 102, 255, 0.08) !important;\n  border: none;\n  color: var(--theme-default) !important;\n  width: auto !important;\n  height: 32px !important;\n  border-radius: 10px;\n  padding: 5px 10px;\n  line-height: 50px !important;\n  font-weight: 500;\n  border: none;\n  outline: none !important;\n}\n.appointment-sec .card-header-right-icon select:hover {\n  background-color: rgba(115, 102, 255, 0.08) !important;\n  color: var(--theme-default) !important;\n}\n.appointment-sec .bottom-btn {\n  text-align: center;\n}\n.appointment-sec .bottom-btn a {\n  font-family: Roboto, sans-serif;\n  font-weight: bold;\n  font-size: 14px;\n  line-height: 16px;\n  letter-spacing: 0.3px;\n  text-decoration-line: underline;\n  text-transform: uppercase;\n}\n\n.notification ul {\n  position: relative;\n}\n.notification ul::before {\n  position: absolute;\n  content: \"\";\n  border: 1px dashed #52526c;\n  opacity: 0.3;\n  top: 12px;\n  left: 2px;\n  height: calc(100% - 12px);\n}\n[dir=rtl] .notification ul::before {\n  left: unset;\n  right: 2px;\n}\n.notification li {\n  padding-bottom: 22px !important;\n  border: none !important;\n}\n.notification div[class*=activity-dot-] {\n  margin-top: 12px;\n  animation: round 1.3s ease-in-out infinite;\n}\n.notification .card .d-flex .w-100 p .badge {\n  color: #fff;\n  margin-left: 10px;\n  font-weight: 500;\n}\n.notification .card .d-flex .w-100 h6, .notification .card .d-flex .w-100 .h6 {\n  margin-bottom: 5px;\n  position: relative;\n}\n.notification .card .d-flex .w-100 h6 ~ p, .notification .card .d-flex .w-100 .h6 ~ p {\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n  text-emphasis: inherit;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: block;\n  width: 260px;\n}\n@media (max-width: 767px) {\n  .notification .card .d-flex .w-100 h6 ~ p, .notification .card .d-flex .w-100 .h6 ~ p {\n    -webkit-line-clamp: unset;\n    text-emphasis: unset;\n    white-space: unset;\n    text-overflow: unset;\n    display: block;\n    width: unset;\n    overflow: visible;\n  }\n}\n@keyframes round {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.2);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.notification .card .d-flex .w-100 span {\n  color: #52526c;\n}\n.notification .card .d-flex:nth-child(2) .media-body h6 .dot-notification, .notification .card .d-flex:nth-child(2) .media-body .h6 .dot-notification {\n  background-color: #ffaa05;\n  border: 5px solid rgb(100%, 87.0666666667%, 61.9607843137%);\n}\n.notification .card .d-flex:last-child {\n  margin-bottom: 0 !important;\n}\n.notification .date-content {\n  padding: 4px 8px;\n  border-radius: 5px;\n}\n\n.schedule-container > div {\n  margin-bottom: -40px;\n}\n.schedule-container svg path {\n  clip-path: inset(1% 0% 0% 0% round 1.5rem);\n}\n\n.purchase-card {\n  text-align: center;\n  margin-top: 200px;\n}\n@media (max-width: 1560px) {\n  .purchase-card {\n    margin-top: 170px;\n  }\n}\n@media (max-width: 1399px) {\n  .purchase-card {\n    margin-top: 160px;\n  }\n}\n@media (max-width: 500px) {\n  .purchase-card {\n    margin-top: 110px;\n  }\n}\n@media (max-width: 420px) {\n  .purchase-card {\n    margin-top: 90px;\n  }\n}\n.purchase-card img {\n  margin-top: -208px;\n}\n@media (max-width: 1560px) {\n  .purchase-card img {\n    margin-top: -170px;\n  }\n}\n@media (max-width: 1399px) {\n  .purchase-card img {\n    width: 70%;\n    margin: -160px auto 0 auto;\n  }\n}\n@media (max-width: 1366px) {\n  .purchase-card img {\n    width: 76%;\n  }\n}\n@media (max-width: 1199px) {\n  .purchase-card img {\n    width: 86%;\n  }\n}\n@media (max-width: 991px) {\n  .purchase-card img {\n    width: 72%;\n  }\n}\n@media (max-width: 767px) {\n  .purchase-card img {\n    width: 50%;\n  }\n}\n@media (max-width: 500px) {\n  .purchase-card img {\n    margin-top: -110px;\n  }\n}\n@media (max-width: 420px) {\n  .purchase-card img {\n    margin-top: -90px;\n    width: 60%;\n  }\n}\n.purchase-card .purchase-btn {\n  min-width: auto;\n}\n\n.user-list {\n  column-count: 2;\n  column-rule-style: dashed;\n  column-rule-color: rgba(82, 82, 108, 0.7);\n  column-gap: 120px;\n  column-rule-width: 1px;\n}\n@media (max-width: 1780px) {\n  .user-list {\n    column-gap: 80px;\n  }\n}\n@media (max-width: 1660px) {\n  .user-list {\n    column-gap: 40px;\n  }\n}\n@media (max-width: 360px) {\n  .user-list {\n    column-gap: 25px;\n  }\n}\n.user-list li {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  width: 100%;\n}\n@media (max-width: 1540px) {\n  .user-list li {\n    gap: 5px;\n  }\n}\n.user-list li i {\n  font-size: 12px;\n  font-weight: 700;\n}\n@media (max-width: 360px) {\n  .user-list li h5, .user-list li .h5 {\n    font-size: 16px;\n  }\n}\n@media (max-width: 360px) {\n  .user-list li span {\n    font-size: 13px;\n  }\n}\n.user-list li:hover .user-box svg {\n  animation: tada 1.5s ease infinite;\n}\n.user-list .user-icon {\n  border-radius: 100%;\n  display: inline-block;\n}\n.user-list .user-icon .user-box {\n  margin: 3px;\n  width: 47px;\n  height: 47px;\n  border-radius: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n@media (max-width: 1540px) {\n  .user-list .user-icon .user-box {\n    width: 30px;\n    height: 30px;\n  }\n  .user-list .user-icon .user-box svg {\n    width: 18px;\n    height: 18px;\n  }\n}\n.user-list .user-icon.primary {\n  border: 1px solid #7366ff;\n}\n.user-list .user-icon.primary .user-box {\n  background: rgb(90.8496732026%, 90%, 100%);\n}\n.user-list .user-icon.success {\n  border: 1px solid #54ba4a;\n}\n.user-list .user-icon.success .user-box {\n  background: rgb(87.6611764706%, 95.0211764706%, 86.9396078431%);\n}\n\n.appointment-table table tr td {\n  position: relative;\n  border-top: none;\n  padding: 15px 0;\n  vertical-align: middle;\n}\n.appointment-table table tr td:first-child {\n  width: 50px;\n}\n.appointment-table table tr td .status-circle {\n  top: 1px;\n  left: 35px;\n  border-width: 3px;\n}\n.appointment-table table tr td p,\n.appointment-table table tr td .btn {\n  font-weight: 500;\n  font-size: 12px;\n}\n.appointment-table table tr td .btn {\n  padding: 4px 12px;\n}\n.appointment-table table tr .img-content-box a {\n  color: var(--body-font-color);\n  transition: 0.5s;\n  display: inline-block !important;\n}\n.appointment-table table tr .img-content-box span {\n  display: block;\n}\n.appointment-table table tr:hover .img-content-box a {\n  color: var(--theme-default);\n  transition: 0.5s;\n}\n.appointment-table table tr:first-child td {\n  padding-top: 0 !important;\n}\n.appointment-table table tr:last-child td {\n  padding-bottom: 0 !important;\n}\n.appointment-table.customer-table table tr td {\n  padding: 10px 0;\n}\n.appointment-table.customer-table table tr td img {\n  min-width: 40px;\n}\n\n.icon-box {\n  width: 50px;\n  height: 32px;\n  background-color: rgba(115, 102, 255, 0.08);\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.icon-box i {\n  color: var(--theme-default);\n  font-size: 22px;\n}\n.icon-box svg {\n  stroke: var(--theme-default);\n}\n\n.balance-card {\n  display: flex;\n  padding: 15px;\n  border-radius: 5px;\n  gap: 15px;\n  transition: 0.5s;\n}\n@media (max-width: 1199px) {\n  .balance-card {\n    gap: 8px;\n  }\n}\n.balance-card .svg-box {\n  width: 43px;\n  height: 43px;\n  background: #fff;\n  box-shadow: 0px 71.2527px 51.5055px rgba(229, 229, 245, 0.189815), 0px 42.3445px 28.0125px rgba(229, 229, 245, 0.151852), 0px 21.9866px 14.2913px rgba(229, 229, 245, 0.125), 0px 8.95749px 7.16599px rgba(229, 229, 245, 0.0981481), 0px 2.03579px 3.46085px rgba(229, 229, 245, 0.0601852);\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n@media (max-width: 1199px) {\n  .balance-card .svg-box {\n    width: 35px;\n    height: 35px;\n  }\n}\n.balance-card .svg-box svg {\n  height: 20px;\n  fill: rgba(82, 82, 108, 0.85);\n}\n@media (max-width: 1199px) {\n  .balance-card .svg-box svg {\n    height: 17px;\n  }\n}\n\n.btn-light-secondary {\n  background-color: rgba(var(--theme-secondary), 0.1);\n  font-size: 12px;\n  padding: 6px 12px;\n  font-weight: 600;\n}\n\n.crm-activity > li + li {\n  border-top: 1px solid #efefef;\n  margin-top: 10px;\n  padding-top: 10px;\n}\n.crm-activity > li + li h6, .crm-activity > li + li .h6 {\n  font-size: 14px;\n  line-height: 18px;\n  margin-bottom: 5px;\n}\n.crm-activity > li h6, .crm-activity > li .h6 {\n  font-size: 14px;\n}\n.crm-activity span {\n  font-size: 40px;\n}\n.crm-activity ul.dates h6, .crm-activity ul.dates .h6 {\n  color: #2f2f3b;\n}\n.crm-activity ul.dates li {\n  color: #52526c;\n  font-size: 12px;\n  display: inline-block;\n  line-height: 1;\n}\n.crm-activity ul.dates li + li {\n  border-left: 1px solid #efefef;\n  padding-left: 10px;\n  margin-left: 5px;\n}\n\n.fill-primary {\n  fill: #7366ff;\n}\n\n.fill-secondary {\n  fill: #ff3364;\n}\n\n.fill-success {\n  fill: #54ba4a;\n}\n\n.fill-warning {\n  fill: #ffaa05;\n}\n\n.fill-info {\n  fill: #16c7f9;\n}\n\n.fill-danger {\n  fill: #fc4438;\n}\n\n.ecommerce-widget {\n  box-shadow: none;\n  border: 1px solid #f1f3ff !important;\n  border-radius: 5px;\n}\n.ecommerce-widget .total-num {\n  color: #2f2f3b;\n  margin: 0;\n  letter-spacing: 1px;\n}\n.ecommerce-widget .total-num span {\n  color: #000;\n}\n.ecommerce-widget .row {\n  align-items: center;\n}\n.ecommerce-widget .progress-showcase {\n  margin-top: 30px;\n}\n.ecommerce-widget span {\n  color: #52526c;\n  margin: 0;\n  cursor: pointer;\n}\n.ecommerce-widget .icon {\n  color: #efefef;\n  font-size: 40px;\n}\n.ecommerce-widget .flot-chart-container {\n  height: 100px;\n  padding: 0;\n  margin: 0;\n  border: transparent;\n}\n.ecommerce-widget .morris-default-style {\n  display: none !important;\n}\n.ecommerce-widget svg {\n  -webkit-filter: drop-shadow(12px 12px 7px rgba(0, 0, 0, 0.3));\n  filter: drop-shadow(12px 12px 7px rgba(0, 0, 0, 0.3));\n}\n\n.redial-social-widget {\n  border-radius: 100%;\n  width: 100px;\n  height: 100px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 25px;\n  margin: 0 auto;\n  background-image: linear-gradient(90deg, #f4f4f4 50%, transparent 50%, transparent), linear-gradient(90deg, #ecf3fa 50%, #f4f4f4 50%, #f4f4f4);\n}\n.redial-social-widget i {\n  background-color: #fff;\n  height: 80px;\n  width: 80px;\n  border-radius: 100%;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.redial-social-widget.radial-bar-70 {\n  background-image: linear-gradient(342deg, var(--theme-default) 50%, transparent 50%, transparent), linear-gradient(270deg, var(--theme-default) 50%, #f4f4f4 50%, #f4f4f4);\n}\n\n.browser-widget:hover img {\n  -webkit-filter: grayscale(0%);\n  filter: grayscale(0%);\n  transition: all 0.3s ease;\n  transform: scale(1.1) rotate(5deg);\n}\n.browser-widget img {\n  height: 80px;\n  filter: grayscale(100%);\n  transform: scale(1) rotate(0deg);\n  transition: all 0.3s ease;\n}\n.browser-widget .media-body {\n  text-align: center;\n  column-count: 3;\n  column-rule: 1px solid #f4f4f4;\n}\n.browser-widget .media-body p {\n  margin-bottom: 5px;\n}\n.browser-widget .media-body span {\n  margin-bottom: 0;\n  color: #52526c;\n}\n.browser-widget .media-body h4, .browser-widget .media-body .h4 {\n  color: #2f2f3b;\n  margin-bottom: 0;\n  font-size: 18px;\n}\n.browser-widget .media-body h4 span, .browser-widget .media-body .h4 span {\n  color: #333333;\n}\n\n.testimonial i {\n  font-size: 60px;\n  color: rgba(43, 43, 43, 0.7);\n  position: absolute;\n  left: 0;\n  top: 0;\n  opacity: 0.1;\n  z-index: -1;\n}\n.testimonial p {\n  color: #52526c;\n  font-style: italic;\n  margin-bottom: 30px;\n  margin-top: 30px;\n}\n.testimonial h5, .testimonial .h5 {\n  color: #2f2f3b;\n  padding-top: 10px;\n}\n.testimonial span {\n  color: #52526c;\n}\n.testimonial img {\n  margin: 0 auto;\n}\n\n.widget-charts .widget-1 .card-body {\n  padding: 30px 25px;\n}\n\n.chart-widget-top #chart-widget1,\n.chart-widget-top #chart-widget2,\n.chart-widget-top #chart-widget3 {\n  margin-bottom: -14px;\n}\n.chart-widget-top #chart-widget1 .apexcharts-xaxistooltip,\n.chart-widget-top #chart-widget2 .apexcharts-xaxistooltip,\n.chart-widget-top #chart-widget3 .apexcharts-xaxistooltip {\n  display: none;\n}\n.chart-widget-top span {\n  color: #6c757d;\n}\n\n.bar-chart-widget .apexcharts-legend {\n  bottom: 0 !important;\n}\n.bar-chart-widget .apexcharts-legend .apexcharts-legend-series {\n  margin: 0 10px !important;\n}\n.bar-chart-widget .apexcharts-legend .apexcharts-legend-marker {\n  margin-right: 5px;\n}\n.bar-chart-widget .top-content {\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n}\n.bar-chart-widget .earning-details {\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  display: flex;\n  letter-spacing: 1px;\n}\n.bar-chart-widget .earning-details i {\n  font-size: 230px;\n  position: absolute;\n  opacity: 0.1;\n  right: -30px;\n  top: 0;\n}\n.bar-chart-widget .earning-details i:hover {\n  transform: rotate(-5deg) scale(1.1);\n  transition: all 0.3s ease;\n}\n.bar-chart-widget .num {\n  font-weight: 600;\n}\n.bar-chart-widget .num .color-bottom {\n  color: #000;\n}\n\n.skill-chart {\n  margin-bottom: -48px;\n}\n.skill-chart .apexcharts-legend .apexcharts-legend-series span {\n  display: block;\n}\n.skill-chart .apexcharts-legend .apexcharts-legend-series .apexcharts-legend-text {\n  margin: 10px 0 20px;\n}\n\n.progress-chart {\n  margin: -11px 0 -20px;\n}\n.progress-chart .apexcharts-canvas svg path,\n.progress-chart .apexcharts-canvas svg rect {\n  clip-path: inset(1% 0% 0% 0% round 1rem);\n}\n\n.bottom-content span {\n  color: #52526c;\n}\n.bottom-content .block-bottom {\n  display: block;\n}\n\n@keyframes am-moving-dashes {\n  100% {\n    stroke-dashoffset: -30px;\n  }\n}\n@-webkit-keyframes am-pulsating {\n  0% {\n    stroke-opacity: 1;\n    stroke-width: 0;\n  }\n  100% {\n    stroke-opacity: 0;\n    stroke-width: 50px;\n  }\n}\n@keyframes am-pulsating {\n  0% {\n    stroke-opacity: 1;\n    stroke-width: 0;\n  }\n  100% {\n    stroke-opacity: 0;\n    stroke-width: 50px;\n  }\n}\n@-webkit-keyframes am-draw {\n  0% {\n    stroke-dashoffset: 500%;\n  }\n  100% {\n    stroke-dashoffset: 0;\n  }\n}\n@keyframes am-draw {\n  0% {\n    stroke-dashoffset: 500%;\n  }\n  100% {\n    stroke-dashoffset: 0;\n  }\n}\n.serial-chart .chart-container {\n  width: 100%;\n  height: 500px;\n}\n.serial-chart .chart-container .lastBullet {\n  animation: am-pulsating 1s ease-out infinite;\n}\n.serial-chart .chart-container .amcharts-graph-column-front {\n  transition: all 0.3s 0.3s ease-out;\n}\n.serial-chart .chart-container .amcharts-graph-column-front:hover {\n  fill: var(--theme-secondary);\n  stroke: var(--theme-secondary);\n  transition: all 0.3s ease-out;\n}\n.serial-chart .chart-container .amcharts-graph-g3 {\n  stroke-linejoin: round;\n  stroke-linecap: round;\n  stroke-dasharray: 0;\n  stroke-dashoffset: 0;\n  animation: am-draw 40s;\n}\n.serial-chart .chart-container .amcharts-graph-g2 .amcharts-graph-stroke {\n  stroke-dasharray: 3px 3px;\n  stroke-linejoin: round;\n  stroke-linecap: round;\n  animation: am-moving-dashes 1s linear infinite;\n}\n\n.chart-container .apexcharts-xaxis-label,\n.chart-container .apexcharts-yaxis-label {\n  font-size: 14px !important;\n  color: #6c757d !important;\n}\n.chart-container .apexcharts-xaxis-annotations rect {\n  clip-path: inset(1% 0% 0% 0% round 0.2rem);\n}\n\n.crypto-chart {\n  margin-left: -20px;\n}\n.crypto-chart .apexcharts-tooltip-title {\n  display: none;\n}\n.crypto-chart .apexcharts-tooltip-series-group:last-child, .crypto-chart .apexcharts-tooltip-series-group.active {\n  padding-bottom: 0;\n}\n\n.speed-chart .chart-container {\n  width: 100%;\n  height: 530px;\n}\n.speed-chart .content {\n  margin-top: -200px;\n  margin-bottom: 20px;\n}\n.speed-chart .content h4, .speed-chart .content .h4 {\n  font-weight: 600;\n  padding-top: 2px;\n}\n\n.status-widget svg {\n  width: 20px;\n  height: 20px;\n  vertical-align: text-top;\n}\n.status-widget .card .card-header h5, .status-widget .card .card-header .h5 {\n  line-height: 1.38;\n}\n.status-widget .status-chart {\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n  overflow: hidden;\n}\n\n.small-chart-widget .chart-container {\n  height: 311px;\n  padding: 0;\n  margin: 0;\n  border: none;\n}\n\n.small-chart-widget .card .card-body {\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n}\n\n.donut-chart-widget .chart-container {\n  height: 300px;\n  border: 0;\n  margin: 0;\n  padding: 0;\n}\n\n.status-details h4, .status-details .h4 {\n  font-weight: 600;\n}\n.status-details h4 span, .status-details .h4 span {\n  color: inherit;\n}\n.status-details span {\n  color: #52526c;\n}\n\n.status-chart .chart-container {\n  height: 200px;\n  border: 0;\n  padding: 0;\n  margin: 0;\n}\n\n.map-chart .chart-container {\n  width: 100%;\n  height: 500px;\n}\n\n.serial-chart {\n  width: 100%;\n}\n\n.live-products,\n.turnover,\n.uses,\n.monthly {\n  height: 300px;\n}\n\n.live-products .ct-series-a .ct-area,\n.live-products .ct-series-a .ct-point,\n.live-products .ct-series-a .ct-line,\n.live-products .ct-series-a .ct-bar,\n.live-products .ct-series-a .ct-slice-donut {\n  stroke: rgba(255, 255, 255, 0.77);\n}\n.live-products .ct-label {\n  fill: #fff;\n  color: #fff;\n}\n.live-products .ct-grid {\n  stroke: rgba(255, 255, 255, 0.7);\n}\n\n.turnover .ct-series-a .ct-area,\n.turnover .ct-series-a .ct-point,\n.turnover .ct-series-a .ct-line,\n.turnover .ct-series-a .ct-bar,\n.turnover .ct-series-a .ct-slice-donut,\n.uses .ct-series-a .ct-area,\n.uses .ct-series-a .ct-point,\n.uses .ct-series-a .ct-line,\n.uses .ct-series-a .ct-bar,\n.uses .ct-series-a .ct-slice-donut,\n.monthly .ct-series-a .ct-area,\n.monthly .ct-series-a .ct-point,\n.monthly .ct-series-a .ct-line,\n.monthly .ct-series-a .ct-bar,\n.monthly .ct-series-a .ct-slice-donut {\n  stroke: rgb(255, 255, 255);\n  fill: transparent;\n}\n.turnover .ct-series-b .ct-area,\n.turnover .ct-series-b .ct-point,\n.turnover .ct-series-b .ct-line,\n.turnover .ct-series-b .ct-bar,\n.turnover .ct-series-b .ct-slice-donut,\n.uses .ct-series-b .ct-area,\n.uses .ct-series-b .ct-point,\n.uses .ct-series-b .ct-line,\n.uses .ct-series-b .ct-bar,\n.uses .ct-series-b .ct-slice-donut,\n.monthly .ct-series-b .ct-area,\n.monthly .ct-series-b .ct-point,\n.monthly .ct-series-b .ct-line,\n.monthly .ct-series-b .ct-bar,\n.monthly .ct-series-b .ct-slice-donut {\n  stroke: rgba(255, 255, 255, 0.7);\n  fill: transparent;\n}\n.turnover .ct-series-c .ct-area,\n.turnover .ct-series-c .ct-point,\n.turnover .ct-series-c .ct-line,\n.turnover .ct-series-c .ct-bar,\n.turnover .ct-series-c .ct-slice-donut,\n.uses .ct-series-c .ct-area,\n.uses .ct-series-c .ct-point,\n.uses .ct-series-c .ct-line,\n.uses .ct-series-c .ct-bar,\n.uses .ct-series-c .ct-slice-donut,\n.monthly .ct-series-c .ct-area,\n.monthly .ct-series-c .ct-point,\n.monthly .ct-series-c .ct-line,\n.monthly .ct-series-c .ct-bar,\n.monthly .ct-series-c .ct-slice-donut {\n  stroke: rgba(255, 255, 255, 0.4);\n  fill: transparent;\n}\n.turnover .ct-label,\n.uses .ct-label,\n.monthly .ct-label {\n  fill: #fff;\n  color: #fff;\n}\n.turnover .ct-grid,\n.uses .ct-grid,\n.monthly .ct-grid {\n  stroke: rgba(255, 255, 255, 0.7);\n}\n\n#draggableMultiple .ui-sortable-handle .card {\n  cursor: move;\n}\n\n.tilt-showcase ul li .line {\n  padding-top: 10px;\n}\n.tilt-showcase .pre-mt {\n  margin-top: 5px;\n}\n\n.wow-title h5, .wow-title .h5 {\n  display: flex;\n  align-items: center;\n  font-size: 18px;\n}\n.wow-title h5 .badge, .wow-title .h5 .badge {\n  -webkit-text-fill-color: #fff;\n}\n\n.alert-center {\n  display: flex !important;\n  align-items: center;\n}\n\n.box-shadow-title .sub-title {\n  margin: 30px 0;\n}\n\n.hovercard .info .social-media ul li {\n  padding-top: 3px;\n}\n.hovercard .cardheader {\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n}\n\n.sticky-header-main .card .card-header h5, .sticky-header-main .card .card-header .h5 {\n  line-height: 35px;\n}\n.sticky-header-main .card .card-header h5 a, .sticky-header-main .card .card-header .h5 a {\n  color: #fff;\n  -webkit-text-fill-color: #fff;\n}\n\n.custom-radio-ml {\n  margin-left: 3px;\n}\n\n.daterangepicker .ltr tr td.active {\n  color: #fff;\n}\n\n.twitter-typeahead {\n  display: block !important;\n}\n\nspan.twitter-typeahead .league-name {\n  font-size: 16px;\n  padding: 6px 10px 0;\n}\nspan.twitter-typeahead .tt-menu {\n  float: left;\n  width: 100%;\n  min-width: 10rem;\n  margin: 0.125rem 0 0;\n  font-size: 1rem;\n  color: #212529;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border-radius: 0.25rem;\n  -webkit-box-shadow: 0 0 20px rgba(89, 102, 122, 0.1);\n  box-shadow: 0 0 20px rgba(89, 102, 122, 0.1);\n  border: none;\n  padding: 0;\n}\nspan.twitter-typeahead .tt-suggestion {\n  color: #2b2b2b;\n  opacity: 0.6;\n  font-size: 13px;\n  padding: 6px 12px;\n  border-top: 1px solid #efefef;\n  background: #fff;\n  cursor: pointer;\n}\nspan.twitter-typeahead .tt-suggestion:hover, span.twitter-typeahead .tt-suggestion:focus {\n  background-color: #fff;\n}\nspan.twitter-typeahead .tt-suggestion.active, span.twitter-typeahead .tt-suggestion:active {\n  color: #fff;\n  background-color: var(--theme-default);\n}\n\n#scrollable-dropdown-menu .twitter-typeahead .tt-menu .tt-dataset {\n  max-height: 100px;\n  overflow-y: auto;\n}\n\n.chart-right {\n  position: relative;\n}\n\n.balance-data {\n  display: flex;\n  gap: 15px;\n  position: absolute;\n  top: -50px;\n  right: 2%;\n}\n[dir=rtl] .balance-data {\n  right: unset;\n  left: 2%;\n}\n@media (max-width: 991px) {\n  .balance-data {\n    top: -42px;\n    right: 0%;\n  }\n}\n@media (max-width: 575px) {\n  .balance-data {\n    display: none !important;\n  }\n}\n.balance-data li {\n  display: flex;\n  align-items: center;\n  font-weight: 500;\n}\n.balance-data .circle {\n  display: inline-block;\n  width: 6px;\n  height: 6px;\n  border-radius: 100%;\n}\n\n.current-sale-container {\n  padding-right: 12px;\n}\n[dir=rtl] .current-sale-container {\n  padding-right: unset;\n  padding-left: 12px;\n}\n.current-sale-container > div {\n  margin: -22px 0 -30px -16px;\n}\n@media (max-width: 1199px) {\n  .current-sale-container > div {\n    margin-bottom: 0;\n  }\n}\n@media (max-width: 404px) {\n  .current-sale-container > div {\n    margin-bottom: -30px;\n  }\n}\n.current-sale-container .apexcharts-xaxistooltip {\n  color: var(--theme-default);\n  background: rgba(115, 102, 255, 0.1);\n  border: 1px solid var(--theme-default);\n}\n.current-sale-container .apexcharts-xaxistooltip-bottom:before {\n  border-bottom-color: var(--theme-default);\n}\n.current-sale-container .apexcharts-tooltip.light .apexcharts-tooltip-title {\n  background: rgba(115, 102, 255, 0.1);\n  color: var(--theme-default);\n}\n@media (max-width: 575px) {\n  .current-sale-container.order-container {\n    padding-right: 0;\n  }\n  [dir=rtl] .current-sale-container.order-container {\n    padding-left: 0;\n  }\n}\n@media (max-width: 404px) {\n  .current-sale-container.order-container > div {\n    margin-bottom: 0;\n  }\n}\n\n.recent-circle {\n  min-width: 10px;\n  height: 10px;\n  border-radius: 100%;\n  display: inline-block;\n  margin-top: 5px;\n}\n\n.recent-wrapper {\n  align-items: center;\n}\n.recent-wrapper .order-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 36px;\n}\n@media (max-width: 1199px) {\n  .recent-wrapper .order-content {\n    gap: 20px;\n  }\n}\n@media (max-width: 575px) {\n  .recent-wrapper .order-content {\n    justify-content: center;\n    flex-wrap: wrap;\n    flex-direction: row;\n  }\n}\n.recent-wrapper .order-content li {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n}\n@media (max-width: 1660px) {\n  .recent-wrapper .recent-chart .apexcharts-canvas .apexcharts-datalabel-label {\n    font-size: 15px;\n  }\n}\n@media (max-width: 1560px) and (min-width: 1400px) {\n  .recent-wrapper > div {\n    width: 100%;\n  }\n}\n@media (max-width: 1560px) and (min-width: 1400px) {\n  .recent-wrapper > div:last-child {\n    display: none;\n  }\n}\n\n.apexcharts-series.apexcharts-radial-series {\n  position: relative;\n}\n.apexcharts-series.apexcharts-radial-series::after {\n  position: absolute;\n  content: \"\";\n  background: linear-gradient(0deg, #ffffff 0.05%, #f4f4f4 19.91%, #f5f6f9 55.02%, #eaecf4 100%);\n  width: calc(100% + 10px);\n  height: calc(100% + 10px);\n  top: 0;\n  left: 0;\n}\n\n.card-block .table-responsive .table caption {\n  padding-left: 10px;\n}\n.card-block .table-responsive .table-bordered td {\n  vertical-align: middle;\n}\n.card-block .table-border-radius {\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n.card-block .default-checkbox-align #checkbox1 {\n  margin-right: 10px;\n}\n.card-block .default-checkbox-align #radio {\n  margin-right: 5px;\n}\n\n#example-style-3_wrapper #example-style-3 tfoot {\n  border-top: 2px solid #efefef;\n}\n\n.chart-vertical-center {\n  display: flex;\n  justify-content: center;\n}\n.chart-vertical-center #myDoughnutGraph,\n.chart-vertical-center #myPolarGraph {\n  width: auto !important;\n}\n\n.cke_focus {\n  padding: 15px;\n  margin-top: 13px;\n}\n\n#editor .ace_scroller .ace_content .ace_layer .ace_print-margin {\n  visibility: hidden !important;\n}\n\n.helper-classes {\n  padding: 30px;\n  margin-bottom: 0;\n  white-space: pre-line;\n}\n\n.starter-kit-fix .page-body {\n  margin-bottom: 52px;\n}\n\n.starter-main .card-body p {\n  font-size: 14px;\n}\n.starter-main .card-body ul {\n  padding-left: 30px;\n  list-style-type: disc;\n  margin-bottom: 15px;\n}\n.starter-main .card-body h5, .starter-main .card-body .h5 {\n  font-size: 18px;\n}\n.starter-main .card-body pre {\n  white-space: pre-line;\n  padding: 30px;\n}\n.starter-main .card-body .alert-primary.inverse:before {\n  top: 32px;\n}\n.starter-main .alert {\n  background-color: rgba(68, 102, 242, 0.2) !important;\n}\n.starter-main .alert i {\n  display: flex;\n  align-items: center;\n}\n\nfooter.blockquote-footer {\n  bottom: unset;\n}\n\n@media only screen and (max-width: 991px) {\n  .notification li {\n    padding-bottom: 20px;\n  }\n  .notification .card .card-body .d-flex .w-100 p {\n    margin: 0;\n  }\n  .notification .card .card-body .d-flex .w-100 h6, .notification .card .card-body .d-flex .w-100 .h6 {\n    margin-top: 10px;\n  }\n}\n@media only screen and (max-width: 767px) {\n  .footer-fix .pull-right {\n    float: none !important;\n    text-align: center !important;\n  }\n}\n@media only screen and (max-width: 575px) {\n  .notification li {\n    padding-bottom: 15px;\n  }\n  .media-dropdown {\n    display: block;\n  }\n  .media-dropdown .media-body {\n    margin-bottom: 15px;\n  }\n}\n@media only screen and (max-width: 360px) {\n  .footer {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n  .footer p {\n    font-size: 12px;\n  }\n  .appointment-table table tr td {\n    min-width: 103px;\n  }\n  .appointment-table table tr td:first-child {\n    min-width: 50px;\n  }\n  .appointment-table table tr td:nth-child(2) {\n    min-width: 120px;\n  }\n}\n/**=====================\n53. Dashboard CSS Ends\n==========================**/\n/**=====================\n    33.  Ecommerce  CSS Start\n==========================**/\n/**====== Product Start ======**/\n.toggle-data {\n  cursor: pointer;\n}\n\n.filter-block ul li {\n  padding-top: 15px !important;\n  opacity: 0.5;\n}\n@media (max-width: 1500px) {\n  .filter-block ul li {\n    padding-top: 10px !important;\n  }\n}\n\n.collection-filter-block svg {\n  width: 50px;\n  height: 25px;\n  stroke: var(--theme-default);\n  fill: #e8e5ff;\n  margin-right: 10px;\n}\n.collection-filter-block h5, .collection-filter-block .h5 {\n  margin-bottom: 0;\n  font-size: 16px;\n}\n.collection-filter-block p {\n  font-size: 13px;\n}\n.collection-filter-block .media-body {\n  opacity: 0.5;\n}\n.collection-filter-block li + li {\n  margin-top: 16px;\n}\n.collection-filter-block ul.pro-services li svg {\n  width: auto;\n}\n\n.qty-box .btn {\n  background-color: transparent !important;\n  border-color: #ecf3fa !important;\n  padding: 8px 12px;\n}\n.qty-box .btn i {\n  color: #898989;\n}\n.qty-box .btn svg {\n  width: 14px !important;\n  stroke: #2c323f;\n}\n.qty-box span {\n  padding: 0 0px;\n}\n.qty-box .input-group {\n  background-color: rgba(44, 50, 63, 0.1);\n}\n.qty-box input {\n  background-color: rgba(44, 50, 63, 0.1);\n  color: #2c323f;\n  max-width: 44px;\n  padding: 0;\n  text-align: center;\n  border: none;\n  max-height: 37px;\n}\n\n.product-social li a {\n  color: #898989;\n  font-size: 15px;\n  border: 1px solid #cccccc;\n  border-radius: 100%;\n  height: 35px;\n  width: 35px;\n  display: inline-block;\n  text-align: center;\n  line-height: 2.3;\n  transition: all 0.3s ease;\n}\n.product-social li a:hover {\n  border-color: #7366ff;\n  color: #7366ff;\n  background-color: rgba(115, 102, 255, 0.1);\n  transition: all 0.3s ease;\n}\n.product-social li:nth-child(n+2) {\n  margin-left: 10px;\n}\n[dir=rtl] .product-social li:nth-child(n+2) {\n  margin-left: unset;\n  margin-right: 10px;\n}\n\n.product-sidebar .filter-section .card .card-header {\n  padding: 16px 30px;\n  border-radius: 5px;\n}\n.product-sidebar .filter-section .card .card-header h6, .product-sidebar .filter-section .card .card-header .h6 {\n  position: relative;\n}\n.product-sidebar .filter-section .card .card-header h6 .pull-right i, .product-sidebar .filter-section .card .card-header .h6 .pull-right i {\n  position: absolute;\n  top: 4px;\n  left: 0;\n  font-size: 10px;\n  width: 100%;\n  height: 10px;\n  text-align: right;\n  cursor: pointer;\n}\n\n.product-wrapper .product-sidebar .filter-section .card .left-filter {\n  z-index: 0;\n  opacity: 0;\n  visibility: hidden;\n  height: 0;\n  transition: 0.3s;\n  min-width: 320px;\n}\n.product-wrapper .product-sidebar .filter-section .card .left-filter .product-filter .irs-with-grid {\n  margin-bottom: 15px;\n}\n.product-wrapper .product-grid .product-wrapper-grid {\n  margin-left: 0;\n  transition: 0.3s;\n}\n.product-wrapper.sidebaron .product-sidebar .filter-section .card .left-filter {\n  z-index: 3;\n  opacity: 1;\n  visibility: visible;\n  position: absolute;\n  width: 100%;\n  background-color: white;\n  top: 53px;\n  height: auto;\n}\n\n.d-none-productlist {\n  display: none;\n}\n.d-none-productlist svg {\n  vertical-align: middle;\n  cursor: pointer;\n}\n\n.product-wrapper-grid.list-view .product-box {\n  display: flex;\n  align-items: center;\n}\n.product-wrapper-grid.list-view .product-box .product-img {\n  width: 20%;\n}\n.product-wrapper-grid.list-view .product-box .product-details {\n  text-align: left;\n}\n\n.slider-product {\n  padding: 15px 0;\n  border-top: 1px solid #f4f4f4;\n  border-bottom: 1px solid #f4f4f4;\n  margin-bottom: 15px;\n}\n\n.products-total {\n  display: flex;\n  align-items: center;\n}\n\n.grid-options {\n  height: 33px;\n  margin-left: 10px;\n}\n.grid-options ul li a {\n  position: relative;\n}\n.grid-options ul li a .line-grid {\n  position: absolute;\n  width: 4px;\n  height: 15px;\n  top: 9px;\n}\n.grid-options ul li a .line-grid-1 {\n  left: 12px;\n}\n.grid-options ul li a .line-grid-2 {\n  left: 18px;\n}\n.grid-options ul li a .line-grid-3 {\n  left: 36px;\n}\n.grid-options ul li a .line-grid-4 {\n  left: 42px;\n}\n.grid-options ul li a .line-grid-5 {\n  left: 48px;\n}\n.grid-options ul li a .line-grid-6 {\n  left: 66px;\n}\n.grid-options ul li a .line-grid-7 {\n  left: 72px;\n}\n.grid-options ul li a .line-grid-8 {\n  left: 78px;\n}\n.grid-options ul li a .line-grid-9 {\n  left: 84px;\n}\n.grid-options ul li a .line-grid-10 {\n  left: 103px;\n}\n.grid-options ul li a .line-grid-11 {\n  left: 109px;\n}\n.grid-options ul li a .line-grid-12 {\n  left: 115px;\n}\n.grid-options ul li a .line-grid-13 {\n  left: 121px;\n}\n.grid-options ul li a .line-grid-14 {\n  left: 127px;\n}\n.grid-options ul li a .line-grid-15 {\n  left: 133px;\n}\n\n.square-product-setting {\n  height: 36px;\n  vertical-align: middle;\n}\n.square-product-setting a {\n  color: #2f2f3b;\n}\n.square-product-setting .icon-grid {\n  padding: 7px;\n  background-color: #fff;\n  display: flex;\n  align-items: center;\n  margin: 0 10px;\n}\n.square-product-setting .icon-grid svg {\n  width: 20px;\n  height: 20px;\n}\n\n.product-filter .banner-product {\n  margin-top: 15px;\n}\n.product-filter h6, .product-filter .h6 {\n  margin-bottom: 15px;\n}\n.product-filter .color-selector {\n  line-height: 0.9;\n}\n.product-filter .color-selector ul li {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  border: 1px solid #444;\n  border-radius: 100%;\n  cursor: pointer;\n}\n.product-filter .color-selector ul li.white {\n  background-color: #fff;\n}\n.product-filter .color-selector ul li.gray {\n  background-color: #52526c;\n}\n.product-filter .color-selector ul li.black {\n  background-color: #000;\n}\n.product-filter .color-selector ul li.orange {\n  background-color: #ffb17a;\n}\n.product-filter .color-selector ul li.green {\n  background-color: #6fb866;\n}\n.product-filter .color-selector ul li.pink {\n  background-color: pink;\n}\n.product-filter .color-selector ul li.yellow {\n  background-color: #f2f896;\n}\n.product-filter .color-selector ul li.blue {\n  background-color: #63b4f2;\n}\n.product-filter .color-selector ul li.red {\n  background-color: #ff647f;\n}\n.product-filter.new-products {\n  margin-top: 20px;\n}\n.product-filter.new-products button {\n  width: auto;\n}\n.product-filter.new-products .owl-theme .owl-nav {\n  margin-top: 0;\n  position: absolute;\n  top: -46px;\n  right: 0;\n}\n.product-filter.new-products .owl-theme .owl-nav button:focus {\n  outline: transparent;\n}\n.product-filter.new-products .owl-theme .owl-nav button span {\n  font-size: 20px;\n}\n.product-filter.new-products .owl-theme .owl-nav button span:focus {\n  outline-color: transparent;\n}\n.product-filter.new-products .owl-theme .owl-nav [class*=owl-]:hover {\n  background-color: transparent;\n  color: inherit;\n}\n.product-filter.new-products .owl-theme .owl-item .item .product-box .product-details {\n  padding: 25px 0;\n}\n.product-filter.new-products .owl-theme .owl-item .item .product-box + .product-box {\n  margin-top: 15px;\n}\n\n.select2-drpdwn-product .form-control {\n  border: none;\n  box-shadow: 1px 5px 24px 0 rgba(68, 102, 242, 0.05);\n  margin-bottom: 10px;\n  height: 36px;\n}\n\n.feature-products form .form-group {\n  position: relative;\n}\n.feature-products form .form-group input {\n  margin-bottom: 15px;\n  border: none;\n  box-shadow: 1px 5px 24px 0 rgba(68, 102, 242, 0.05);\n  height: 50px;\n  padding-left: 30px;\n}\n.feature-products form .form-group i {\n  position: absolute;\n  top: 18px;\n  right: 30px;\n  color: #898989;\n}\n\n.product-page-main {\n  padding: 30px;\n}\n.product-page-main .small-slick {\n  margin-top: 20px;\n}\n.product-page-main .small-slick .item {\n  border: 1px solid #f4f4f4;\n  border-radius: 5px;\n}\n.product-page-main .small-slick .slick-slide {\n  padding: 0 10px;\n}\n.product-page-main .small-slick .slick-slide.slick-current .item {\n  border: 1px solid var(--theme-default);\n}\n\n.modal .modal-header {\n  padding: 0;\n  border: none;\n}\n.modal .modal-header .product-box .product-details {\n  padding: 25px 0;\n}\n.modal .modal-header .product-box .product-details h6, .modal .modal-header .product-box .product-details .h6 {\n  text-transform: capitalize;\n}\n.modal .modal-header .product-box .product-details .product-price {\n  font-size: 22px;\n  margin-bottom: 10px;\n}\n.modal .modal-header .product-box .product-details .product-view {\n  padding: 20px 0;\n  border-top: 1px dotted #59667a;\n  border-bottom: 1px dotted #59667a;\n}\n.modal .modal-header .product-box .product-details .product-size {\n  margin: 20px 0;\n}\n.modal .modal-header .product-box .product-details .product-size ul li {\n  display: inline-block;\n}\n.modal .modal-header .product-box .product-details .product-qnty fieldset {\n  margin-bottom: 20px;\n}\n.modal .modal-header .product-box .product-details .product-qnty fieldset .input-group {\n  width: 35%;\n}\n.modal .modal-header .product-box .product-details .product-qnty fieldset .input-group .btn {\n  padding: 5px 12px;\n}\n.modal .modal-header .product-box .product-details .product-qnty fieldset .input-group .btn-primary {\n  background-color: #59667a !important;\n  border: 1px solid #59667a !important;\n}\n.modal .modal-header .btn-close {\n  position: absolute;\n  right: 15px;\n  top: 10px;\n}\n\n.product-box {\n  border-radius: 10px;\n  overflow: hidden;\n}\n.product-box .product-details {\n  padding: 15px 25px;\n}\n.product-box .product-details > a {\n  color: #2f2f3b;\n}\n.product-box .product-details p {\n  margin-bottom: 0;\n  opacity: 0.8;\n}\n.product-box .product-details h4, .product-box .product-details .h4 {\n  margin-bottom: 0;\n  margin-top: 5px;\n  font-size: 20px;\n  font-family: roboto;\n}\n.product-box .product-details h6, .product-box .product-details .h6 {\n  color: #2f2f3b;\n  text-transform: uppercase;\n  margin-bottom: 10px;\n}\n.product-box .product-details span {\n  color: #898989;\n}\n.product-box .product-details .rating i {\n  font-size: 16px;\n  letter-spacing: 3px;\n  color: #ffa800;\n}\n.product-box .modal .modal-header .product-box .product-details {\n  padding: 25px 0;\n}\n.product-box .modal .modal-header .product-box .product-details h6, .product-box .modal .modal-header .product-box .product-details .h6 {\n  text-transform: capitalize;\n}\n.product-box .modal .modal-header .product-box .product-details .product-price {\n  font-size: 22px;\n  margin-bottom: 10px;\n}\n.product-box .modal .modal-header .product-box .product-details .product-view {\n  padding: 20px 0;\n  border-top: 1px dotted #59667a;\n  border-bottom: 1px dotted #59667a;\n}\n.product-box .modal .modal-header .product-box .product-details .product-size {\n  margin: 20px 0;\n}\n.product-box .modal .modal-header .product-box .product-details .product-size ul li {\n  display: inline-block;\n}\n.product-box .modal .modal-header .product-box .product-details .product-qnty fieldset {\n  margin-bottom: 20px;\n}\n.product-box .modal .modal-header .product-box .product-details .product-qnty fieldset .input-group {\n  width: 35%;\n}\n.product-box .modal .modal-header .product-box .product-details .product-qnty fieldset .input-group .btn {\n  padding: 5px 12px;\n}\n.product-box .modal .modal-header .product-box .product-details .product-qnty fieldset .input-group .btn-primary {\n  background-color: #59667a !important;\n  border: 1px solid #59667a !important;\n}\n.product-box .modal .modal-header .btn-close {\n  position: absolute;\n  right: 15px;\n  top: 10px;\n}\n.product-box .product-img {\n  position: relative;\n}\n.product-box .product-img .product-hover {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  top: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.3);\n  opacity: 0;\n  border-radius: 100%;\n  transform: scale(0);\n  transition: all 0.3s ease;\n}\n.product-box .product-img .product-hover ul li {\n  display: inline-block;\n  box-shadow: 1px 1px 2px 1px rgba(0, 0, 0, 0.08);\n  padding: 10px 12px;\n  background-color: #fff;\n  font-size: 18px;\n  border-radius: 10px;\n  height: 45px;\n  width: 45px;\n  margin: 0 3px;\n  cursor: pointer;\n}\n.product-box .product-img .product-hover ul li i {\n  color: #59667a;\n  font-size: 18px;\n}\n.product-box .product-img .product-hover ul li .btn {\n  padding: 0;\n}\n.product-box .product-img .product-hover ul li:hover {\n  background-color: var(--theme-default);\n  transition: all 0.3s ease;\n}\n.product-box .product-img .product-hover ul li:hover .btn,\n.product-box .product-img .product-hover ul li:hover i {\n  color: #fff;\n}\n.product-box:hover .product-hover {\n  opacity: 1;\n  border-radius: 0%;\n  transform: scale(1);\n  transition: all 0.3s ease;\n}\n\n.product-page-main {\n  padding: 30px;\n}\n.product-page-main .owl-item .item {\n  border: 1px solid #f4f4f4;\n  border-radius: 5px;\n  background-color: #f8f8f8;\n}\n.product-page-main .owl-item.current .item {\n  border: 1px solid var(--theme-default);\n}\n@media (min-width: 1400px) {\n  .product-page-main .product-slider img {\n    height: 520px;\n    object-fit: cover;\n  }\n}\n@media (min-width: 1500px) {\n  .product-page-main .product-slider img {\n    height: 400px;\n    object-fit: cover;\n  }\n}\n.product-page-main .product-color {\n  margin-top: 10px;\n}\n\n.product-page-details h4, .product-page-details .h4 {\n  color: #2f2f3b;\n  text-transform: uppercase;\n  font-size: 18px;\n}\n.product-page-details span {\n  padding-left: 15px;\n}\n\n.br-theme-fontawesome-stars .br-widget a,\n.br-theme-fontawesome-stars .br-widget a.br-selected:after,\n.br-theme-fontawesome-stars .br-widget a.br-active:after {\n  color: #ffa800 !important;\n  font: normal normal normal 14px/1 FontAwesome;\n}\n\n.product-price {\n  font-size: 18px;\n  font-weight: 700;\n  margin-top: 5px;\n  color: var(--theme-default);\n}\n.product-price del {\n  color: rgba(44, 50, 63, 0.4);\n  padding-left: 10px;\n  font-size: 80%;\n}\n\n.product-color li {\n  display: inline-block;\n  border-radius: 100% !important;\n  height: 20px;\n  width: 20px;\n  margin: 0 2px;\n}\n\n.product-page-main p {\n  font-size: 15px;\n}\n.product-page-main .nav-link {\n  text-transform: uppercase;\n  font-weight: 500;\n}\n\n/**====== Product  Ends ======**/\n.payment-opt li {\n  display: inline-block;\n}\n.payment-opt li img {\n  height: 20px;\n  margin: 15px 15px 0 0;\n}\n\n/**=====================\n    33. Ecommerce  CSS End\n==========================**/\n@media screen and (max-width: 1660px) and (min-width: 1200px) {\n  .owl-carousel .owl-item img {\n    max-width: 420px;\n    margin: 0 auto;\n  }\n}\n/**=====================\n    13.  Email Application  CSS Start\n==========================**/\n.email-wrap .row .col-xl-3 + .col-xl-3 {\n  padding-right: 0;\n}\n.email-wrap .row .col-xl-6 {\n  padding-left: 0;\n}\n.email-wrap .dropdown .dropdown-toggle {\n  background-color: rgba(115, 102, 255, 0.08);\n  color: #7366ff;\n  border-radius: 10px;\n  padding: 5px 10px;\n  width: 100px;\n  text-align: left;\n}\n[dir=rtl] .email-wrap .dropdown .dropdown-toggle {\n  text-align: right;\n}\n.email-wrap .dropdown .dropdown-toggle:after {\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%);\n  content: \"\\f107\";\n  border: none;\n  font-family: \"FontAwesome\";\n  font-size: 18px;\n  margin: 0;\n}\n[dir=rtl] .email-wrap .dropdown .dropdown-toggle:after {\n  right: unset;\n  left: 10px;\n}\n.email-wrap .dropdown .dropdown-menu {\n  -webkit-box-shadow: 0 0 20px rgba(89, 102, 122, 0.1);\n  box-shadow: 0 0 20px rgba(89, 102, 122, 0.1);\n  border: none;\n  padding: 0;\n}\n.email-wrap .dropdown .dropdown-menu .dropdown-item {\n  color: #2b2b2b;\n  opacity: 0.6;\n  font-size: 13px;\n  padding: 6px 12px;\n  border-top: 1px solid #f5f5f5;\n  background: #fff;\n  line-height: 19px;\n}\n.email-wrap .dropdown .dropdown-menu .dropdown-item:hover {\n  background-color: #fff;\n}\n.email-wrap .email-app-sidebar .media img {\n  border: 2px solid #ecf3fa;\n}\n.email-wrap .email-app-sidebar .main-menu > li {\n  width: 100%;\n  text-align: left;\n}\n.email-wrap .email-app-sidebar .main-menu > li a {\n  line-height: 39px;\n  text-transform: uppercase;\n  border-radius: 3px;\n}\n.email-wrap .email-app-sidebar .main-menu > li a i {\n  margin-right: 10px;\n}\n.email-wrap .email-app-sidebar .main-menu > li a.active > a {\n  color: #000;\n}\n.email-wrap .email-app-sidebar .main-menu > li a:hover {\n  background-color: #f5f6f9;\n  text-decoration: none;\n}\n.email-wrap .email-app-sidebar ul li a {\n  display: flex;\n  padding-left: 20px;\n  align-items: center;\n}\n.email-wrap .email-app-sidebar ul li a > .title {\n  width: 100%;\n  color: #2c323f;\n}\n.email-wrap .email-app-sidebar ul li a > .badge {\n  align-self: center;\n  color: #898989;\n}\n.email-wrap .email-left-aside {\n  float: left;\n  width: 100%;\n}\n.email-wrap .email-left-aside .card-body {\n  padding: 20px;\n}\n@media (min-width: 1200px) {\n  .email-wrap .email-right-aside .email-body .pr-0 {\n    padding-right: 0;\n  }\n  [dir=rtl] .email-wrap .email-right-aside .email-body .pr-0 {\n    padding-right: 12px;\n    padding-left: 0;\n  }\n}\n@media (min-width: 1200px) {\n  .email-wrap .email-right-aside .email-body .pl-0 {\n    padding-left: 0;\n  }\n  [dir=rtl] .email-wrap .email-right-aside .email-body .pl-0 {\n    padding-left: 12px;\n    padding-right: 0;\n  }\n}\n.email-wrap .email-right-aside .email-body .inbox {\n  overflow: auto;\n}\n@media (max-width: 1199.98px) {\n  .email-wrap .email-right-aside .email-body .inbox {\n    display: flex;\n    flex-wrap: wrap;\n  }\n}\n.email-wrap .email-right-aside .email-body .inbox .media {\n  padding: 20px;\n}\n.email-wrap .email-right-aside .email-body .inbox .media.active {\n  background-color: rgb(99.6862745098%, 99.6862745098%, 99.6862745098%);\n}\n.email-wrap .email-right-aside .radius-left {\n  border-radius: 8px;\n  height: 100%;\n}\n.email-wrap .btn-mail {\n  border-radius: 2px;\n  text-align: left;\n  padding: 13px 15px;\n  margin: 20px 0 20px;\n  letter-spacing: 1px;\n  line-height: 12px !important;\n}\n.email-wrap p {\n  margin-bottom: 0;\n  color: #898989;\n}\n.email-wrap .media-body {\n  margin-top: 5px;\n}\n.email-wrap .media-body h6, .email-wrap .media-body .h6 {\n  margin-bottom: 2px;\n  color: #242934;\n  margin-top: 3px;\n}\n.email-wrap .media-body h6 small, .email-wrap .media-body .h6 small, .email-wrap .media-body h6 .small, .email-wrap .media-body .h6 .small {\n  font-size: 12px;\n}\n.email-wrap .media-body h6 small span, .email-wrap .media-body .h6 small span, .email-wrap .media-body h6 .small span, .email-wrap .media-body .h6 .small span {\n  color: #777777;\n}\n.email-wrap .media-body p {\n  color: #52526c;\n  font-size: 12px;\n}\n.email-wrap .email-top {\n  padding: 20px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  line-height: 49px;\n}\n.email-wrap .email-top i {\n  cursor: pointer;\n}\n.email-wrap .email-top h5, .email-wrap .email-top .h5 {\n  margin-bottom: 0;\n  padding: 12px 0;\n}\n.email-wrap .email-top .d-flex {\n  padding: 13px 0;\n}\n.email-wrap .email-wrapper {\n  padding: 20px;\n}\n.email-wrap .email-wrapper hr {\n  margin-top: 0;\n  margin-bottom: 20px;\n}\n.email-wrap .email-wrapper .d-inline-block {\n  width: 100%;\n}\n.email-wrap .email-wrapper h6, .email-wrap .email-wrapper .h6 {\n  margin-bottom: 11px;\n  float: left;\n}\n.email-wrap .email-wrapper .right-download {\n  float: right;\n}\n.email-wrap .email-wrapper p + p {\n  margin-bottom: 20px;\n}\n.email-wrap .email-wrapper h5, .email-wrap .email-wrapper .h5 {\n  margin-bottom: 20px;\n}\n.email-wrap .email-content .email-top .user-emailid:after {\n  content: \"\";\n  position: relative;\n  height: 20px;\n  width: 1px;\n  right: 0;\n  top: 3px;\n  z-index: 2;\n  border: 1px solid #efefef;\n  float: right;\n  padding: 0;\n  margin: 0 20px;\n}\n.email-wrap .email-body .attachment ul li img {\n  margin-bottom: 20px;\n  width: 80px;\n  height: 80px;\n  object-fit: cover;\n}\n.email-wrap .email-body .attachment .list-inline .list-inline-item {\n  padding-right: 13px;\n}\n.email-wrap .email-body .email-compose .cke_contents.cke_reset {\n  max-height: 178px;\n  width: 100%;\n  border: 1px solid #ecf3fa;\n}\n.email-wrap .email-body .email-compose .email-top h4, .email-wrap .email-body .email-compose .email-top .h4 {\n  padding: 11px 0;\n}\n.email-wrap .email-body .email-compose .compose-border .btn-middle {\n  padding-top: 5px;\n}\n.email-wrap .actions li {\n  display: inline-block;\n  margin-right: 25px;\n}\n\n/**=====================\n    13.  Email Application  CSS Ends\n==========================**/\n/**=====================\n     09. Error-page  CSS Start\n==========================**/\n.error-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  text-align: center;\n}\n.error-wrapper.maintenance-bg {\n  background-image: url(../../images/other-images/maintenance-bg.jpg);\n  background-color: rgba(255, 255, 255, 0.6);\n  background-blend-mode: overlay;\n}\n.error-wrapper .maintenance-icons li i {\n  color: #59667a;\n  font-size: 50px;\n  animation: rotate-effect 40s infinite linear reverse;\n}\n.error-wrapper .maintenance-icons li:nth-child(2) i {\n  font-size: 100px;\n  margin-left: 110px;\n  margin-top: -25px;\n  animation: rotate-effect 40s linear infinite reverse;\n}\n.error-wrapper .maintenance-icons li:nth-child(3) i {\n  animation: rotate-effect 30s infinite linear;\n  font-size: 150px;\n  margin-top: -85px;\n  margin-right: 120px;\n}\n.error-wrapper .maintenance-heading {\n  margin-top: 70px;\n}\n.error-wrapper .maintenance-heading .headline {\n  font-size: 99px;\n  font-weight: 900;\n  letter-spacing: 10px;\n  color: var(--theme-default);\n  z-index: 2;\n  position: relative;\n  margin-top: -70px;\n}\n.error-wrapper .error-heading {\n  margin-top: 115px;\n}\n.error-wrapper .error-heading .headline {\n  font-size: 285px;\n  font-weight: 700;\n  letter-spacing: 1px;\n  margin-top: -130px;\n}\n.error-wrapper .sub-content {\n  font-size: 18px;\n  color: #2f2f3b;\n  letter-spacing: 1px;\n  font-weight: normal;\n  line-height: 35px;\n  z-index: 3;\n  position: relative;\n  margin-top: 30px;\n  margin-bottom: 0;\n}\n.error-wrapper .btn {\n  margin-top: 40px;\n}\n\n.error {\n  margin: 70px 0 100px;\n  color: #000;\n}\n.error .error-title {\n  font-size: 9.5rem;\n  color: #fff;\n  text-shadow: 6px 6px 7px rgba(0, 0, 0, 0.32);\n}\n.error .line-bottom {\n  width: 10%;\n  height: 5px;\n  background-color: #ffaa05;\n  border: none;\n}\n.error .c-white {\n  color: #fff;\n}\n.error .error-btn {\n  text-align: center;\n}\n.error .padd {\n  padding: 10px 30px 10px 30px;\n}\n.error .btn-back-home {\n  background-color: #f4f4f4;\n  color: #000;\n}\n.error .btn-back-home:hover {\n  background-color: #ffaa05;\n  color: #fff;\n  box-shadow: 0 20px 35px 0 rgba(0, 0, 0, 0.21);\n}\n.error .btn-adnc-serc {\n  background-color: #2c323f;\n  color: #fff;\n}\n.error .btn-adnc-serc:hover {\n  background-color: #ffaa05;\n  color: #fff;\n  box-shadow: 0 20px 35px 0 rgba(0, 0, 0, 0.21);\n}\n\n/**=====================\n     09. Error-page CSS Ends\n==========================**/\n/**=====================\n     71. Faq CSS start\n==========================**/\n.knowledgebase-bg {\n  height: 500px;\n  border-radius: 15px;\n  margin-bottom: 30px;\n}\n\n.knowledgebase-search {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  left: 5%;\n}\n.knowledgebase-search .form-inline {\n  background-color: #fff;\n  width: 500px;\n  padding: 12px 50px;\n  border-radius: 10px;\n  border: 1px solid #e6e6e6;\n  margin-top: 10px;\n  position: relative;\n}\n.knowledgebase-search .form-inline ::placeholder {\n  color: #cccccc;\n}\n.knowledgebase-search .form-inline svg {\n  position: absolute;\n  left: 20px;\n  width: 20px;\n  top: 17px;\n  stroke: #cccccc;\n}\n\n.faq-widgets {\n  align-items: center;\n}\n.faq-widgets .media-body h5, .faq-widgets .media-body .h5 {\n  font-weight: 600;\n}\n.faq-widgets .media-body p {\n  padding-right: 20px;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 4;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.faq-widgets svg {\n  width: 50px;\n  height: 50px;\n  opacity: 0.5;\n}\n\n.header-faq h5, .header-faq .h5 {\n  font-weight: 600;\n}\n.header-faq {\n  margin-bottom: 30px;\n}\n\n.features-faq.card .card-body,\n.features-faq.card .card-footer {\n  padding: 20px 25px;\n}\n.features-faq .faq-image img {\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  width: 100%;\n}\n.features-faq .card-body h6, .features-faq .card-body .h6 {\n  font-weight: 500;\n}\n\n.add-project.table td {\n  vertical-align: middle;\n}\n.add-project .text-inherit {\n  color: black;\n}\n\n.faq-accordion.default-according {\n  margin-bottom: 30px;\n}\n.faq-accordion.default-according .card .btn-link {\n  display: flex;\n}\n.faq-accordion.default-according .card .btn-link svg {\n  width: 20px;\n  height: 20px;\n  margin-right: 10px;\n}\n.faq-accordion.default-according .card .faq-header {\n  position: relative;\n  padding: 30px;\n}\n.faq-accordion.default-according .card .faq-header svg {\n  position: absolute;\n  right: 30px;\n  top: 30px;\n  width: 20px;\n  height: 20px;\n}\n.faq-accordion.default-according .card .faq-header span {\n  margin-top: 3px;\n}\n.faq-accordion.default-according .faq-body {\n  padding: 20px !important;\n}\n.faq-accordion.default-according .card-mb-faq {\n  margin-bottom: 30px;\n}\n\n.faq-title {\n  margin: 30px 0;\n}\n.faq-title h6, .faq-title .h6 {\n  color: #999999;\n  font-weight: 600;\n}\n\n.faq-form {\n  position: relative;\n}\n.faq-form .search-icon {\n  position: absolute;\n  right: 12px;\n  top: 9px;\n  width: 20px;\n  height: 20px;\n}\n\n.navigation-btn a {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.navigation-btn a svg {\n  width: 15px;\n  height: 15px;\n}\n.navigation-btn {\n  margin-bottom: 20px;\n}\n\n.navigation-option ul li {\n  position: relative;\n  padding: 8px 8px 8px 0 !important;\n}\n.navigation-option ul li:hover {\n  background-color: #fdfeff;\n}\n.navigation-option ul li a {\n  padding-left: 40px;\n  color: #2f2f3b;\n}\n.navigation-option ul li a svg {\n  position: absolute;\n  width: 15px;\n  height: 15px;\n  top: 11px;\n  left: 15px;\n}\n\n.updates-faq {\n  width: 40px;\n  height: 40px;\n  border: 2px solid var(--theme-default);\n  border-radius: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 20px;\n}\n.updates-faq svg {\n  width: 18px;\n  height: 18px;\n}\n\n.updates-bottom-time p {\n  margin-bottom: 2px;\n}\n.updates-bottom-time p + p {\n  color: #999999;\n}\n\n.updates-faq-main {\n  margin-bottom: 20px;\n}\n.updates-faq-main a {\n  font-weight: 500;\n}\n.updates-faq-main:last-child {\n  margin-bottom: 0;\n}\n\n@media only screen and (max-width: 1399.98px) {\n  .faq-widgets svg {\n    width: 30px;\n    height: 30px;\n  }\n}\n@media only screen and (max-width: 1199px) {\n  .faq-accordion {\n    margin-bottom: 30px;\n  }\n}\n@media only screen and (max-width: 991px) {\n  .faq-accordion.default-according .card .faq-header {\n    padding: 20px !important;\n  }\n  .faq-accordion.default-according .card .faq-header svg {\n    right: 20px;\n    top: 20px;\n  }\n  .navigation-option ul li {\n    padding: 10px 10px 10px 0;\n  }\n  .navigation-option ul li a svg {\n    top: 12px;\n  }\n}\n@media only screen and (max-width: 767px) {\n  .xs-mt-search {\n    margin-top: 30px;\n  }\n}\n@media only screen and (max-width: 575px) {\n  .xs-mt-search {\n    margin-top: 0px;\n  }\n  .faq-widgets svg {\n    width: 30px;\n    height: 30px;\n  }\n  .faq-title {\n    margin: 15px 0;\n  }\n  .header-faq {\n    margin-bottom: 15px;\n    margin-top: 10px;\n  }\n  .faq-accordion {\n    margin-bottom: 0px;\n  }\n  .faq-accordion .faq-header {\n    padding: 15px !important;\n  }\n  .faq-accordion .faq-header .pull-right {\n    float: right;\n  }\n  .faq-accordion .faq-header svg {\n    right: 15px;\n    top: 15px;\n  }\n  .navigation-btn,\n  .updates-faq-main {\n    margin-bottom: 15px;\n  }\n}\n/**=====================\n     71. Faq CSS end\n==========================**/\n/**=====================\n    File Manager\n==========================**/\n.file-sidebar .card .card-body,\n.file-sidebar .card .card-header,\n.file-content .card .card-body,\n.file-content .card .card-header {\n  padding: 20px !important;\n}\n\n.file-sidebar ul li + li {\n  margin-top: 8px;\n}\n.file-sidebar .btn {\n  display: flex;\n  align-items: center;\n}\n.file-sidebar .btn.btn-light:hover {\n  color: var(--theme-default) !important;\n}\n.file-sidebar .btn.btn-light:hover svg {\n  stroke: var(--theme-default);\n}\n.file-sidebar .btn svg {\n  width: 15px;\n  vertical-align: middle;\n  margin-right: 8px;\n}\n.file-sidebar .pricing-plan {\n  border: 1px solid #ecf3fa;\n  border-radius: 5px;\n  margin-top: 10px;\n  padding: 15px;\n  position: relative;\n  overflow: hidden;\n}\n.file-sidebar .pricing-plan h6, .file-sidebar .pricing-plan .h6 {\n  font-weight: 600;\n  font-size: 14px;\n  margin-bottom: 2px;\n  color: #898989;\n}\n.file-sidebar .pricing-plan h5, .file-sidebar .pricing-plan .h5 {\n  font-weight: 800;\n}\n.file-sidebar .pricing-plan p {\n  margin-bottom: 5px;\n  color: #898989;\n}\n.file-sidebar .pricing-plan .btn {\n  display: inline-block;\n}\n.file-sidebar .pricing-plan .bg-img {\n  position: absolute;\n  top: 40px;\n  opacity: 0.1;\n  transform: rotate(-45deg);\n  right: -40px;\n}\n\n.file-manager > h6, .file-manager > .h6 {\n  opacity: 0.6;\n  font-weight: 400 !important;\n  font-size: 15px;\n  margin-bottom: 12px;\n}\n.file-manager .files .file-box:nth-child(1) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 100000ms;\n}\n.file-manager .files .file-box:nth-child(2) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 200000ms;\n}\n.file-manager .files .file-box:nth-child(3) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 300000ms;\n}\n.file-manager .files .file-box:nth-child(4) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 400000ms;\n}\n.file-manager .files .file-box:nth-child(5) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 500000ms;\n}\n.file-manager .files .file-box:nth-child(6) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 600000ms;\n}\n.file-manager .files .file-box:nth-child(7) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 700000ms;\n}\n.file-manager .files .file-box:nth-child(8) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 800000ms;\n}\n.file-manager .files .file-box:nth-child(9) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 900000ms;\n}\n.file-manager .files .file-box:nth-child(10) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 1000000ms;\n}\n.file-manager .files .file-box:nth-child(11) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 1100000ms;\n}\n.file-manager .files .file-box:nth-child(12) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 1200000ms;\n}\n.file-manager .files .file-box:nth-child(13) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 1300000ms;\n}\n.file-manager .files .file-box:nth-child(14) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 1400000ms;\n}\n.file-manager .files .file-box:nth-child(15) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 1500000ms;\n}\n.file-manager .files h6, .file-manager .files .h6 {\n  margin-top: 10px;\n  margin-bottom: 0;\n}\n.file-manager p {\n  opacity: 0.9;\n  font-size: 12px;\n}\n\n.files h6, .files .h6,\n.folder h6,\n.folder .h6 {\n  opacity: 0.9;\n  font-weight: 500 !important;\n  font-size: 14px;\n}\n\n.file-content .ellips {\n  position: absolute;\n  top: 30px;\n  right: 30px;\n  opacity: 0.7;\n}\n.file-content .form-inline {\n  border: 1px solid #f4f4f4;\n  border-radius: 5px;\n  padding: 0 20px;\n}\n.file-content .form-inline i {\n  padding-right: 10px;\n  color: #898989;\n  line-height: 3;\n}\n.file-content .form-inline input::-webkit-input-placeholder {\n  color: #898989;\n}\n.file-content .form-inline input:focus {\n  outline: none !important;\n}\n.file-content .search-form input {\n  padding: 5px 10px 5px 70px;\n  border-radius: 5px;\n}\n.file-content .search-form .form-group:before {\n  left: 82px;\n  top: 37px;\n}\n.file-content .search-form .form-group:after {\n  top: 39px;\n  left: 53px;\n}\n.file-content .btn svg {\n  height: 15px;\n  margin-right: 2px;\n  vertical-align: middle;\n}\n.file-content h4, .file-content .h4 {\n  font-weight: 500;\n}\n.file-content .folder .folder-box {\n  border: 1px solid #f1f1f1;\n  border-radius: 5px;\n  padding: 15px;\n  background-color: #f6f7fb;\n  width: calc(25% - 15px);\n  display: inline-block;\n  margin: 3px;\n}\n.file-content .folder .folder-box:nth-child(1) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 100000ms;\n}\n.file-content .folder .folder-box:nth-child(2) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 200000ms;\n}\n.file-content .folder .folder-box:nth-child(3) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 300000ms;\n}\n.file-content .folder .folder-box:nth-child(4) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 400000ms;\n}\n.file-content .folder .folder-box:nth-child(5) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 500000ms;\n}\n.file-content .folder .folder-box:nth-child(6) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 600000ms;\n}\n.file-content .folder .folder-box:nth-child(7) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 700000ms;\n}\n.file-content .folder .folder-box:nth-child(8) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 800000ms;\n}\n.file-content .folder .folder-box:nth-child(9) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 900000ms;\n}\n.file-content .folder .folder-box:nth-child(10) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 1000000ms;\n}\n.file-content .folder .folder-box:nth-child(11) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 1100000ms;\n}\n.file-content .folder .folder-box:nth-child(12) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 1200000ms;\n}\n.file-content .folder .folder-box:nth-child(13) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 1300000ms;\n}\n.file-content .folder .folder-box:nth-child(14) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 1400000ms;\n}\n.file-content .folder .folder-box:nth-child(15) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 1500000ms;\n}\n.file-content .files .file-box {\n  border: 1px solid #f1f1f1;\n  border-radius: 5px;\n  padding: 15px !important;\n  background-color: #f6f7fb;\n  width: calc(25% - 15px);\n  display: inline-block;\n  position: relative;\n  margin: 3px;\n}\n.file-content .files .file-box .file-top {\n  height: 100px;\n  background-color: #fff;\n  border: 1px solid #ececec;\n  border-radius: 5px;\n  font-size: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n@media screen and (max-width: 1440px) {\n  .file-content .folder .folder-box .media {\n    display: block;\n  }\n  .file-content .folder .folder-box .media .media-body {\n    margin-left: 0 !important;\n    margin-top: 5px;\n  }\n}\n@media screen and (max-width: 1366px) {\n  .file-content .files {\n    margin-bottom: -10px;\n  }\n  .file-content .files .file-box {\n    width: calc(50% - 15px);\n    margin-bottom: 10px;\n  }\n}\n@media screen and (max-width: 768px) {\n  .file-content .folder {\n    margin-bottom: -10px;\n  }\n  .file-content .folder .folder-box {\n    width: calc(50% - 15px);\n    margin-bottom: 10px;\n    margin-right: 8px;\n  }\n  .file-content .media {\n    display: block;\n    text-align: center;\n  }\n  .file-content .media .media-body {\n    margin-top: 20px;\n    text-align: center !important;\n  }\n}\n@media screen and (max-width: 575px) {\n  .file-content .folder .folder-box,\n  .file-content .files .file-box {\n    width: 100%;\n  }\n}\n/**=====================\n     File Manager\n==========================**/\n/**=====================\n     45. Gallery CSS Start\n==========================**/\n.profile-img-style img,\n.scroll-bar-wrap img {\n  width: 100%;\n}\n\n.gallery {\n  margin-bottom: -30px;\n}\n.gallery > a {\n  margin-bottom: 30px;\n}\n.gallery > a:before {\n  content: \"\\edee\";\n  font-family: IcoFont;\n  position: absolute;\n  height: calc(100% - 10px);\n  left: 20px;\n  width: calc(100% - 40px);\n  background-color: rgba(255, 255, 255, 0.27);\n  top: 5px;\n  transform: scale(0);\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 30px;\n  color: #000;\n}\n.gallery > a:hover:before {\n  transform: scale(1);\n  transition: all 0.3s ease;\n}\n.gallery > a .img-thumbnail {\n  border-radius: 0;\n  border: 1px solid var(--bs-border-color) !important;\n}\n\n.my-gallery .img-thumbnail {\n  border: 1px solid var(--bs-border-color) !important;\n}\n\n.gallery-with-description {\n  margin-bottom: -30px;\n}\n.gallery-with-description a .img-thumbnail {\n  border: 1px solid var(--bs-border-color) !important;\n  border-bottom: none !important;\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.gallery-with-description a > div {\n  padding: 10px;\n  border: 1px solid rgb(89.3787795492%, 90.390324354%, 92.5820047645%);\n  margin-bottom: 30px;\n  border-radius: 0 0 5px 5px;\n  border-top: none;\n}\n.gallery-with-description a:hover {\n  text-decoration: none !important;\n}\n.gallery-with-description.masonry-with-dec a .img-thumbnail {\n  padding: 10px 10px 5px 10px !important;\n}\n.gallery-with-description h4, .gallery-with-description .h4 {\n  color: #2c323f;\n  margin-top: 15px;\n  font-size: 18px;\n}\n.gallery-with-description p {\n  color: rgb(63.7254901961%, 63.7254901961%, 63.7254901961%);\n}\n\n.lg-backdrop {\n  background-color: #fff;\n}\n\n.lg-outer .lg-actions .lg-next,\n.lg-outer .lg-actions .lg-prev {\n  background-color: rgb(255, 255, 255);\n  border: 1px solid #efefef;\n}\n.lg-outer .lg-actions .lg-next:hover,\n.lg-outer .lg-actions .lg-prev:hover {\n  color: #2c323f;\n}\n.lg-outer .lg-toolbar {\n  background-color: rgba(255, 255, 255, 0.45);\n  border-bottom: 1px solid #2c323f;\n}\n.lg-outer .lg-toolbar .lg-icon:hover {\n  color: #2c323f;\n}\n.lg-outer #lg-counter {\n  color: #2c323f;\n}\n.lg-outer .lg-sub-html {\n  background-color: rgba(255, 255, 255, 0.45);\n}\n.lg-outer .lg-sub-html h4, .lg-outer .lg-sub-html .h4 {\n  font-size: inherit;\n  color: #2c323f;\n}\n.lg-outer .lg-sub-html p {\n  color: #2c323f;\n}\n.lg-outer .lg-thumb-outer {\n  background-color: #ecf3fa;\n}\n.lg-outer .lg-thumb-item {\n  padding: 4px;\n  border: 1px solid #efefef;\n  border-radius: 0;\n}\n.lg-outer .lg-thumb-item .active, .lg-outer .lg-thumb-item:hover {\n  border-color: #000;\n}\n\n.gallery a:before, .gallery a:after {\n  content: none;\n}\n.gallery .img-hover > div {\n  overflow: hidden;\n}\n.gallery .hover-1 img {\n  -webkit-transform: scale(1);\n  transform: scale(1);\n  -webkit-transition: 0.3s ease-in-out;\n  transition: 0.3s ease-in-out;\n}\n.gallery .hover-1 img:hover {\n  -webkit-transform: scale(1.2);\n  transform: scale(1.2);\n}\n.gallery .hover-2 img {\n  width: 100%;\n  height: auto;\n  -webkit-transition: 0.3s ease-in-out;\n  transition: 0.3s ease-in-out;\n  transform: translateX(0px);\n}\n.gallery .hover-2:hover img {\n  transform: translateX(40px) scale(1.2);\n}\n.gallery .hover-3 img {\n  -webkit-transform: scale(1.2);\n  transform: scale(1.2);\n  -webkit-transition: 0.3s ease-in-out;\n  transition: 0.3s ease-in-out;\n}\n.gallery .hover-3:hover img {\n  -webkit-transform: scale(1);\n  transform: scale(1);\n}\n.gallery .hover-4 img {\n  -webkit-transform: scale(1.5);\n  transform: scale(1.5);\n  -webkit-transition: 0.3s ease-in-out;\n  transition: 0.3s ease-in-out;\n}\n.gallery .hover-4:hover img {\n  -webkit-transform: scale(1);\n  transform: scale(1);\n}\n.gallery .hover-5 img {\n  margin-left: 30px;\n  -webkit-transform: scale(1.3);\n  transform: scale(1.3);\n  -webkit-transition: 0.3s ease-in-out;\n  transition: 0.3s ease-in-out;\n}\n.gallery .hover-5:hover img {\n  margin-left: 0;\n}\n.gallery .hover-6 img {\n  -webkit-transform: rotate(15deg) scale(1.4);\n  transform: rotate(15deg) scale(1.4);\n  -webkit-transition: 0.3s ease-in-out;\n  transition: 0.3s ease-in-out;\n}\n.gallery .hover-6:hover img {\n  -webkit-transform: rotate(0) scale(1);\n  transform: rotate(0) scale(1);\n}\n.gallery .hover-7 img {\n  -webkit-filter: blur(3px);\n  filter: blur(3px);\n  -webkit-transition: 0.3s ease-in-out;\n  transition: 0.3s ease-in-out;\n}\n.gallery .hover-7:hover img {\n  -webkit-filter: blur(0);\n  filter: blur(0);\n}\n.gallery .hover-8 img {\n  -webkit-filter: grayscale(100%);\n  filter: grayscale(100%);\n  -webkit-transition: 0.3s ease-in-out;\n  transition: 0.3s ease-in-out;\n}\n.gallery .hover-8:hover img {\n  -webkit-filter: grayscale(0);\n  filter: grayscale(0);\n}\n.gallery .hover-9 img {\n  -webkit-filter: sepia(100%);\n  filter: sepia(100%);\n  -webkit-transition: 0.3s ease-in-out;\n  transition: 0.3s ease-in-out;\n}\n.gallery .hover-9:hover img {\n  -webkit-filter: sepia(0);\n  filter: sepia(0);\n}\n.gallery .hover-10 img {\n  -webkit-filter: grayscale(0) blur(0);\n  filter: grayscale(0) blur(0);\n  -webkit-transition: 0.3s ease-in-out;\n  transition: 0.3s ease-in-out;\n}\n.gallery .hover-10:hover img {\n  -webkit-filter: grayscale(100%) blur(3px);\n  filter: grayscale(100%) blur(3px);\n}\n.gallery .hover-11 img {\n  opacity: 1;\n  -webkit-transition: 0.3s ease-in-out;\n  transition: 0.3s ease-in-out;\n}\n.gallery .hover-11:hover img {\n  opacity: 0.5;\n}\n@-webkit-keyframes flash {\n  0% {\n    opacity: 0.4;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes flash {\n  0% {\n    opacity: 0.4;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.gallery .hover-13:hover img {\n  opacity: 1;\n  -webkit-animation: flash 1.5s;\n  animation: flash 1.5s;\n}\n@-webkit-keyframes shine {\n  100% {\n    left: 125%;\n  }\n}\n@keyframes shine {\n  100% {\n    left: 125%;\n  }\n}\n.gallery .hover-14 div {\n  position: relative;\n}\n.gallery .hover-14 div:before {\n  position: absolute;\n  top: 0;\n  left: -75%;\n  z-index: 2;\n  display: block;\n  content: \"\";\n  width: 50%;\n  height: 100%;\n  background: -webkit-linear-gradient(left, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.3) 100%);\n  background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.3) 100%);\n  -webkit-transform: skewX(-25deg);\n  transform: skewX(-25deg);\n}\n.gallery .hover-14 div:hover:before {\n  -webkit-animation: shine 0.75s;\n  animation: shine 0.75s;\n}\n.gallery .hover-15 div {\n  position: relative;\n}\n.gallery .hover-15 div:before {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 2;\n  display: block;\n  content: \"\";\n  width: 0;\n  height: 0;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 100%;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  opacity: 0;\n}\n.gallery .hover-15 div:hover:before {\n  -webkit-animation: circle 0.75s;\n  animation: circle 0.75s;\n}\n\n@-webkit-keyframes circle {\n  0% {\n    opacity: 1;\n  }\n  40% {\n    opacity: 1;\n  }\n  100% {\n    width: 200%;\n    height: 200%;\n    opacity: 0;\n  }\n}\n@keyframes circle {\n  0% {\n    opacity: 1;\n  }\n  40% {\n    opacity: 1;\n  }\n  100% {\n    width: 200%;\n    height: 200%;\n    opacity: 0;\n  }\n}\n* {\n  box-sizing: border-box;\n}\n*:after, *:before {\n  box-sizing: border-box;\n}\n\n.grid {\n  position: relative;\n}\n\n/* clear fix */\n.grid:after {\n  content: \"\";\n  display: block;\n  clear: both;\n}\n\n/* ---- .grid-item ---- */\n.grid-item img {\n  max-width: 100%;\n  padding: 0.25rem;\n  background-color: #fff;\n  border: 1px solid #dee2e6;\n}\n\n.gallery-with-description .grid-item img {\n  border: 0;\n  padding: 0;\n}\n\n/**=====================\n     45. Gallery CSS Ends\n==========================**/\n/**=====================\n     74. internationalization css start\n==========================**/\n.hdg_main {\n  position: relative;\n}\n\n.main .langChoice {\n  position: absolute;\n  right: 40px;\n  top: 31px;\n  padding: 10px 12px;\n  background-color: transparent;\n}\n\n@media (max-width: 991px) {\n  .main .langChoice {\n    right: 20px;\n    top: 11px;\n    padding: 8px;\n  }\n}\n@media only screen and (max-width: 575px) {\n  .main .langChoice {\n    top: 14px;\n    padding: 4px 7px;\n  }\n  .language-xs {\n    margin-top: 15px;\n  }\n}\n@media only screen and (max-width: 360px) {\n  .language-header {\n    padding-bottom: 60px !important;\n  }\n  .main .langChoice {\n    left: 0;\n    margin: 0 auto;\n    top: 50px;\n    width: 30%;\n    right: 0;\n  }\n}\n/**=====================\n     74. internationalization CSS end\n==========================**/\n/**=====================\n     72. Job CSS start\n==========================**/\n.filter-cards-view .job-filter:first-child {\n  margin-bottom: 30px;\n}\n.filter-cards-view .checkbox-animated {\n  margin-top: 30px;\n  margin-bottom: 30px;\n}\n\n.location-checkbox span {\n  color: #999999;\n  padding-left: 33px;\n}\n\n.job-accordion .card {\n  margin-bottom: 30px;\n}\n.job-accordion .btn-block {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.job-search p {\n  margin-top: 30px;\n}\n.job-search .media .media-body h6, .job-search .media .media-body .h6 {\n  margin-bottom: 3px;\n}\n.job-search .media .media-body h6 span, .job-search .media .media-body .h6 span {\n  font-size: 13px;\n  color: #999999;\n  font-weight: normal;\n}\n.job-search .media .media-body h6 span.badge, .job-search .media .media-body .h6 span.badge {\n  color: #fff;\n}\n.job-search .media .media-body p {\n  margin-top: 0;\n  color: #999999;\n}\n.job-search .job-description {\n  margin-top: 30px;\n}\n.job-search .job-description h6, .job-search .job-description .h6 {\n  font-weight: 600;\n}\n.job-search .job-description p {\n  margin-top: 0;\n  margin-bottom: 6px;\n}\n.job-search .job-description ul {\n  list-style-type: disc;\n  list-style-position: inside;\n}\n.job-search .job-description ul li {\n  margin-bottom: 10px;\n}\n.job-search .job-description ul li:last-child {\n  margin-bottom: 0;\n}\n.job-search .job-description .theme-form {\n  margin-top: 30px;\n  margin-bottom: 30px;\n}\n.job-search .job-description .theme-form .row div[class^=col-] + div[class^=col-] .select2-container {\n  margin-top: 18px;\n}\n.job-search .job-description .theme-form .row div[class^=col-] .job-select2 ~ .select2-container {\n  margin-top: 0 !important;\n}\n.job-search .job-description .theme-form .row div[class^=col-] .input-group .datepicker-here {\n  font-size: 14px;\n  border: 1px solid #efefef;\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n\n.select2-container .select2-selection--single {\n  border-radius: 0.25rem !important;\n  border-color: #efefef;\n  height: 47px !important;\n  padding: 10px;\n}\n\n.job-pagination {\n  margin-bottom: 30px;\n}\n.job-pagination nav ul {\n  justify-content: center;\n}\n\n@media only screen and (max-width: 1366px) {\n  .xl-mt-job {\n    margin-bottom: 20px;\n  }\n}\n@media only screen and (max-width: 991px) {\n  .filter-cards-view {\n    padding: 20px !important;\n  }\n  .filter-cards-view .job-filter:first-child {\n    margin-bottom: 20px;\n  }\n  .filter-cards-view .checkbox-animated {\n    margin-top: 20px;\n    margin-bottom: 20px;\n  }\n  .job-accordion .animate-chk {\n    padding: 20px !important;\n  }\n  .job-search p {\n    margin-top: 20px;\n  }\n}\n@media only screen and (max-width: 575px) {\n  .filter-cards-view {\n    padding: 15px !important;\n  }\n  .filter-cards-view .job-filter:first-child {\n    margin-bottom: 15px;\n  }\n  .filter-cards-view .checkbox-animated {\n    margin-top: 15px;\n    margin-bottom: 15px;\n  }\n  .job-accordion .animate-chk {\n    padding: 15px !important;\n  }\n  .job-search p {\n    margin-top: 15px;\n  }\n  .job-search .media {\n    display: block;\n    text-align: center;\n  }\n  .job-search .media .media-body h6 .pull-right, .job-search .media .media-body .h6 .pull-right {\n    float: none;\n    margin-top: 3px;\n    display: block;\n  }\n  .job-search .media .media-body h6 a, .job-search .media .media-body .h6 a {\n    display: block;\n  }\n  .job-search .media .media-body p span + span {\n    display: block;\n  }\n  .job-search .media img {\n    margin-bottom: 15px;\n  }\n  .job-search .media .m-r-20 {\n    margin-right: 0;\n  }\n  .job-search .job-description {\n    margin-top: 15px;\n  }\n  .job-search .job-description .theme-form {\n    margin-top: 15px;\n    margin-bottom: 15px;\n  }\n  .job-search .job-description .theme-form .row div[class^=col-] + div[class^=col-] .select2-container {\n    margin-top: 2px;\n  }\n  .job-search .job-description .theme-form .xs-mt-period {\n    margin-top: 15px;\n  }\n  .job-pagination {\n    margin-bottom: 15px;\n  }\n  .xl-mt-job {\n    margin-bottom: 15px;\n  }\n}\n@media only screen and (max-width: 360px) {\n  .job-search .job-description .btn {\n    padding: 6px 12px;\n  }\n}\n/**=====================\n     72. Job CSS end\n==========================**/\n/**=====================\n     31. JS datagrid CSS Start\n==========================**/\n.jsgrid .jsgrid-grid-body .jsgrid-cell {\n  padding: 0.75rem;\n}\n.jsgrid .jsgrid-pager-container {\n  text-align: right;\n}\n.jsgrid .jsgrid-pager {\n  padding: 0;\n  margin-top: 20px;\n}\n.jsgrid .jsgrid-pager .jsgrid-pager-nav-inactive-button {\n  margin-right: -5px;\n}\n.jsgrid .jsgrid-pager .jsgrid-pager-nav-inactive-button:first-child {\n  border-radius: 5px 0 0 5px;\n}\n.jsgrid .jsgrid-pager .jsgrid-pager-page ~ .jsgrid-pager-nav-button {\n  margin-left: -5px;\n}\n.jsgrid .jsgrid-pager .jsgrid-pager-page ~ .jsgrid-pager-nav-button:last-child {\n  border-radius: 0 5px 5px 0;\n}\n.jsgrid .jsgrid-pager [class*=jsgrid-pager] {\n  display: inline-block;\n  min-width: 1.5em;\n  padding: 0.5em 1em;\n  border: 1px solid #f4f4f4;\n}\n.jsgrid .jsgrid-pager .jsgrid-pager-page a {\n  color: #2c323f;\n}\n.jsgrid .jsgrid-pager .jsgrid-pager-current-page {\n  color: #2c323f;\n}\n.jsgrid .jsgrid-selected-row > .jsgrid-cell {\n  background: #f4f4f4;\n  border-color: #fafafa;\n}\n.jsgrid .jsgrid-header-row > .jsgrid-header-cell {\n  padding: 0.75rem;\n  font-weight: 500;\n}\n\n/**=====================\n     31. JS datagrid CSS Ends\n==========================**/\n/**=====================\n   61. base_inputs CSS start\n==========================**/\n.jkanban-container .btn {\n  margin-bottom: 10px;\n}\n.jkanban-container .note a {\n  display: contents;\n}\n\n.kanban-board-header {\n  height: auto;\n  width: auto;\n  line-height: unset;\n  background: #f8f8f8;\n  border-bottom: 1px solid #ddd;\n}\n.kanban-board-header.bg-info ~ .kanban-drag {\n  background-color: rgba(22, 199, 249, 0.3) !important;\n}\n.kanban-board-header.bg-warning ~ .kanban-drag {\n  background-color: rgba(255, 170, 5, 0.3) !important;\n}\n.kanban-board-header.bg-success ~ .kanban-drag {\n  background-color: rgba(84, 186, 74, 0.3) !important;\n}\n\n.kanban-container {\n  display: contents;\n}\n\n.kanban-board {\n  margin-bottom: 30px;\n  transition: all 0.3s ease;\n  letter-spacing: 0.5px;\n  border-radius: 8px;\n  box-shadow: 1px 5px 24px 0 rgba(68, 102, 242, 0.05);\n  overflow: hidden;\n  width: calc(33.3333333333% - 30px) !important;\n}\n.kanban-board .kanban-drag {\n  background: #f8f8f8;\n}\n\n.kanban-item {\n  background: transparent;\n  padding: 0;\n  margin-bottom: 20px;\n}\n.kanban-item p {\n  opacity: 0.7;\n}\n.kanban-item:last-child {\n  margin-bottom: 0;\n}\n.kanban-item .list {\n  display: inline-block;\n  opacity: 0.4;\n}\n.kanban-item .list li {\n  display: inline-block;\n  font-size: 12px;\n}\n.kanban-item .list li i {\n  margin-right: 10px;\n}\n.kanban-item .kanban-box {\n  border: 1px solid #efefef;\n  border-radius: 5px;\n  padding: 20px;\n  position: relative;\n  display: block;\n  color: inherit;\n  background-color: #fff;\n}\n.kanban-item .kanban-box:hover {\n  color: inherit;\n}\n.kanban-item .kanban-box + .kanban-box {\n  margin-top: 20px;\n}\n.kanban-item .kanban-box .badge {\n  font-weight: 400;\n}\n.kanban-item .kanban-box h6, .kanban-item .kanban-box .h6 {\n  font-size: 15px;\n  margin-top: 5px;\n  font-weight: 500;\n}\n.kanban-item .kanban-box .dropdown {\n  display: inline-block;\n  right: 10px;\n  position: absolute;\n  top: 20px;\n}\n.kanban-item .kanban-box .dropdown .dropdown-item {\n  font-size: 13px;\n  font-weight: 500;\n  padding: 5px 10px;\n  text-align: left;\n}\n.kanban-item .kanban-box .dropdown svg {\n  height: 14px;\n}\n.kanban-item .kanban-box .d-flex {\n  justify-content: space-between;\n}\n.kanban-item .kanban-box .dropdown-toggle:after {\n  content: none;\n}\n.kanban-item .kanban-box .customers ul li + li {\n  margin-left: -10px;\n}\n.kanban-item .kanban-box .date {\n  font-size: 11px;\n  opacity: 0.5;\n}\n\nfooter {\n  margin: 0;\n  padding: 0;\n}\n\n@media only screen and (max-width: 1199px) {\n  .jkanban-container .btn {\n    margin-bottom: 10px;\n    margin-left: 20px;\n  }\n  .kanban-container .kanban-board {\n    width: 320px !important;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .kanban-board .kanban-drag,\n  .kanban-container .kanban-item .kanban-box {\n    padding: 10px 15px;\n  }\n  .kanban-container .kanban-board {\n    margin-left: 10px !important;\n    margin-right: 10px !important;\n  }\n}\n@media only screen and (max-width: 480px) {\n  .jkanban-container .card-body {\n    padding: 20px 0 !important;\n  }\n  .kanban-board .kanban-drag,\n  .kanban-container .kanban-item .kanban-box {\n    padding: 10px 15px;\n  }\n  .kanban-container .kanban-board {\n    width: 270px !important;\n  }\n}\n/**=====================\n    61. base_inputs CSS ends\n==========================**/\n/**=====================\n     73. knowledgebase CSS start\n==========================**/\n.browse .browse-articles span {\n  vertical-align: middle;\n  position: relative;\n}\n.browse .browse-articles span:nth-child(2) {\n  padding-left: 20px;\n}\n[dir=rtl] .browse .browse-articles span:nth-child(2) {\n  padding-left: unset;\n  padding-right: 20px;\n}\n.browse .browse-articles span svg {\n  width: 14px;\n  height: 14px;\n  margin-right: 10px;\n  vertical-align: text-top;\n  position: absolute;\n  left: 0;\n  top: 3px;\n}\n[dir=rtl] .browse .browse-articles span svg {\n  left: unset;\n  right: 0;\n}\n.browse .browse-articles h6, .browse .browse-articles .h6 {\n  padding-bottom: 10px;\n  margin-bottom: 0px;\n  border-bottom: 1px solid #fdfeff;\n  padding-left: 25px;\n}\n[dir=rtl] .browse .browse-articles h6, [dir=rtl] .browse .browse-articles .h6 {\n  padding-left: unset;\n  padding-right: 25px;\n}\n.browse .browse-articles h6 span svg, .browse .browse-articles .h6 span svg {\n  width: 16px;\n  height: 16px;\n  vertical-align: text-top;\n  top: 0;\n  left: -30px;\n}\n[dir=rtl] .browse .browse-articles h6 span svg, [dir=rtl] .browse .browse-articles .h6 span svg {\n  left: unset;\n  right: -30px;\n}\n.browse .browse-articles ul li {\n  padding: 8px !important;\n  border-radius: 8px;\n}\n.browse .browse-articles ul li a {\n  color: #2f2f3b;\n}\n.browse .browse-articles ul li:hover {\n  background-color: #fdfeff;\n}\n\n@media only screen and (max-width: 1366px) {\n  .browse div[class^=col-]:nth-child(3) {\n    margin-top: 30px;\n  }\n}\n@media only screen and (max-width: 360px) {\n  .browse .browse-articles ul li a span:nth-child(2) {\n    width: 158px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: inline-block;\n  }\n}\n/**=====================\n     73. knowledgebase CSS end\n==========================**/\n/**=====================\n     76. Language CSS start\n==========================**/\n.current_lang {\n  cursor: pointer;\n  text-transform: uppercase;\n  overflow: hidden;\n}\n\n.lang.selected {\n  display: none;\n}\n.lang span.lang-txt {\n  display: inline-flex;\n  margin-left: 8px;\n  font-weight: 500;\n}\n.lang span span {\n  color: #999;\n  font-weight: 400;\n  margin-left: 5px;\n}\n\n/*more lang*/\n.more_lang {\n  transform: translateY(-20px);\n  opacity: 0;\n  cursor: pointer;\n  display: none;\n  transition: all 0.3s cubic-bezier(0.25, 1.15, 0.35, 1.15);\n}\n\n.translate_wrapper.active .more_lang {\n  display: block;\n  position: absolute;\n  background-color: #fff;\n  top: 47px;\n  right: 0;\n  box-shadow: 0 0 20px rgba(89, 102, 122, 0.1);\n}\n.translate_wrapper.active .more_lang:before {\n  width: 0;\n  height: 0;\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-bottom: 7px solid #fff;\n  content: \"\";\n  top: -7px;\n  position: absolute;\n  right: 20px;\n  z-index: 2;\n}\n.translate_wrapper.active .more_lang:after {\n  width: 0;\n  height: 0;\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-bottom: 7px solid #bdc2c5;\n  content: \"\";\n  top: -7px;\n  position: absolute;\n  right: 20px;\n  z-index: 1;\n}\n\n.more_lang.active {\n  opacity: 1;\n  transform: translateY(-0px);\n}\n.more_lang .lang {\n  padding: 10px 15px;\n  display: flex;\n}\n.more_lang .lang:hover {\n  background: var(--theme-default);\n  color: #fff;\n}\n.more_lang .lang:hover span {\n  color: #fff;\n}\n\n.translate_wrapper.active .more_lang .lang {\n  border-bottom: 1px solid #eaeaea;\n}\n\n/**=====================\n     76. Language CSS end\n==========================**/\n/**=====================\n     75. Learning CSS start\n==========================**/\n.learning-header {\n  margin-bottom: 10px;\n}\n\n.categories {\n  padding: 30px 0;\n}\n.categories .learning-header {\n  padding-left: 15px;\n}\n.categories ul li {\n  padding: 10px 15px !important;\n}\n.categories ul li a {\n  color: #2f2f3b;\n}\n.categories ul li:hover {\n  background-color: #f4f4f4;\n}\n\n.upcoming-course .media + .media {\n  margin-top: 30px;\n}\n\n.job-accordion {\n  margin-bottom: 0;\n}\n\n@media screen and (min-width: 1200px) and (max-width: 1366px) {\n  .learning-comment {\n    margin-left: -14px !important;\n    float: left !important;\n  }\n  .blog-box .blog-details .blog-social li:first-child {\n    padding-right: 30px;\n  }\n  .blog-box .blog-details .blog-social li + li {\n    padding-left: 30px;\n  }\n}\n@media only screen and (max-width: 991px) {\n  .categories {\n    padding: 20px 0;\n  }\n  .upcoming-course .media + .media {\n    margin-top: 20px;\n  }\n}\n@media only screen and (max-width: 575px) {\n  .categories {\n    padding: 15px 0;\n  }\n  .upcoming-course .media + .media {\n    margin-top: 15px;\n  }\n}\n/**=====================\n     75. Learning CSS end\n==========================**/\n/**=====================\n    25. Authentication CSS Start\n==========================**/\n.login-card {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto;\n  background: url(\"../../images/login/login_bg.jpg\");\n  background-position: center;\n  padding: 30px 12px;\n}\n.login-card .logo {\n  display: block;\n  margin-bottom: 30px;\n  text-align: center;\n}\n.login-card .btn-showcase .btn {\n  line-height: 1;\n  padding: 10px 15px;\n  margin: 0;\n}\n.login-card .btn-showcase .btn + .btn {\n  margin-left: 5px;\n}\n.login-card .btn-showcase .btn svg {\n  height: 16px;\n  vertical-align: bottom;\n}\n.login-card .login-main {\n  width: 450px;\n  padding: 40px;\n  border-radius: 10px;\n  box-shadow: 0 0 37px rgba(8, 21, 66, 0.05);\n  margin: 0 auto;\n  background-color: #fff;\n}\n.login-card .login-main .theme-form h4, .login-card .login-main .theme-form .h4 {\n  margin-bottom: 5px;\n}\n.login-card .login-main .theme-form label {\n  font-size: 15px;\n  letter-spacing: 0.4px;\n}\n.login-card .login-main .theme-form .checkbox label::before {\n  background-color: #f9f9fa;\n  border: 1px solid #dfdfdf;\n}\n.login-card .login-main .theme-form .or {\n  position: relative;\n}\n.login-card .login-main .theme-form .or:before {\n  content: \"\";\n  position: absolute;\n  width: 65%;\n  height: 2px;\n  background-color: #f3f3ff;\n  top: 9px;\n  z-index: 0;\n  right: 0;\n}\n.login-card .login-main .theme-form input {\n  background-color: #f3f3ff;\n  transition: all 0.3s ease;\n}\n.login-card .login-main .theme-form input::-webkit-input-placeholder {\n  color: #999999;\n}\n.login-card .login-main .theme-form input:hover, .login-card .login-main .theme-form input:focus {\n  border: 1px solid rgb(72.6772604777%, 75.588699935%, 80.0678375616%);\n  box-shadow: none !important;\n  transition: all 0.3s ease;\n}\n.login-card .login-main .theme-form p {\n  margin-bottom: 25px;\n  font-size: 14px;\n  color: #898989;\n}\n.login-card .login-main .theme-form .form-group {\n  margin-bottom: 10px;\n  position: relative;\n}\n.login-card .login-main .theme-form .link {\n  position: absolute;\n  top: 10px;\n  right: 0;\n}\n.login-card .login-main.login-tab {\n  position: relative;\n  border-top-left-radius: 0;\n  height: 100%;\n}\n.login-card .login-main.login-tab .nav-tabs {\n  border-bottom: none;\n  position: absolute;\n  background-color: #fff;\n  box-shadow: 0 0 37px rgba(8, 21, 66, 0.05);\n  left: -70px;\n  top: 0;\n  margin-bottom: 0;\n}\n.login-card .login-main.login-tab .nav-tabs .nav-item .nav-link {\n  position: relative;\n}\n.login-card .login-main.login-tab .nav-tabs .nav-item .nav-link img {\n  filter: grayscale(100%);\n  width: 20px;\n  height: 20px;\n  transition: 0.5s;\n}\n.login-card .login-main.login-tab .nav-tabs .nav-item .nav-link:after {\n  content: \"\";\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n  top: 12px;\n  border-width: 5px 0 5px 5px;\n  border-left-color: rgb(90.8496732026%, 90%, 100%);\n  opacity: 0;\n  transform: scale(0);\n  color: #fff;\n  left: 14px;\n  z-index: 2;\n  transition: all 0.3s ease;\n}\n.login-card .login-main.login-tab .nav-tabs .nav-item .nav-link span {\n  position: absolute;\n  right: 0;\n  width: max-content;\n  text-align: right;\n  padding: 7px 10px;\n  display: block;\n  top: 0;\n  border-radius: 5px;\n  transform: scale(0);\n  transition: all 0.3s ease;\n  opacity: 0;\n  color: var(--theme-default);\n  background-color: rgb(90.8496732026%, 90%, 100%);\n  box-shadow: 0 0 37px rgba(8, 21, 66, 0.1);\n}\n.login-card .login-main.login-tab .nav-tabs .nav-item .nav-link:hover:after {\n  opacity: 1;\n  transform: scale(1);\n  transition: all 0.3s ease;\n}\n.login-card .login-main.login-tab .nav-tabs .nav-item .nav-link:hover span {\n  opacity: 1;\n  right: 56px;\n  transform: scale(1);\n  transition: all 0.3s ease;\n}\n.login-card .login-main.login-tab .nav-tabs .nav-item .nav-link.active img {\n  filter: initial;\n  transition: 0.5s;\n}\n.login-card .login-main.login-tab .tab-content {\n  height: 512px;\n}\n.login-card .login-main.login-tab .border-tab {\n  border-radius: 0;\n}\n.login-card .login-main.login-tab .border-tab.nav-tabs .nav-item .nav-link {\n  border-bottom: none;\n  border-right: 2px solid transparent;\n  border-top-right-radius: 0;\n}\n.login-card .login-main.login-tab .border-tab.nav-tabs .nav-item .nav-link.active, .login-card .login-main.login-tab .border-tab.nav-tabs .nav-item .nav-link.show, .login-card .login-main.login-tab .border-tab.nav-tabs .nav-item .nav-link:focus {\n  border-right: 2px solid var(--theme-default);\n  border-bottom: none;\n}\n.login-card .login-main.login-tab .auth-content {\n  text-align: center;\n}\n.login-card .login-main.login-tab .auth-content img {\n  height: 300px;\n}\n\n.show-hide {\n  position: absolute;\n  top: 52px;\n  right: 20px;\n  transform: translateY(-50%);\n}\n.show-hide span {\n  cursor: pointer;\n  font-size: 13px;\n  color: var(--theme-default);\n}\n.show-hide span.show:before {\n  content: \"show\";\n}\n.show-hide span:before {\n  content: \"hide\";\n}\n\n.needs-validation .invalid-feedback {\n  color: #898989;\n}\n.needs-validation .show-hide {\n  right: 30px;\n}\n.needs-validation .invalid-tooltip {\n  top: 10px;\n  right: 10px;\n}\n\n/**=====================\n    25. Authentication CSS Ends\n==========================**/\n/**=====================\n   19. Mega option CSS Start\n==========================**/\n.mega-inline {\n  margin-bottom: -30px;\n  display: flex;\n}\n.mega-inline .card {\n  border: 1px solid #f3f3f3;\n  box-shadow: 0 0 10px 0 rgba(68, 102, 242, 0.05);\n}\n.mega-inline .mega-title-badge {\n  display: table;\n  width: 100%;\n  font-size: 14px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n.mega-inline .media .radio {\n  margin-left: 3px;\n}\n\n.mega-vertical {\n  display: flex;\n  flex-wrap: wrap;\n}\n.mega-vertical .card {\n  box-shadow: 0 0 10px 0 rgba(68, 102, 242, 0.05);\n}\n.mega-vertical .mega-title-badge {\n  display: table;\n  width: 100%;\n  font-size: 14px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n.mega-vertical .media .radio {\n  margin-left: 3px;\n}\n\n.mega-title {\n  font-weight: 600;\n}\n\n.mega-horizontal {\n  display: flex;\n  flex-wrap: wrap;\n}\n.mega-horizontal .card {\n  border: 1px solid #f3f3f3;\n  box-shadow: 0 0 10px 0 rgba(68, 102, 242, 0.05);\n}\n.mega-horizontal .mega-title-badge {\n  display: table;\n  width: 100%;\n  font-size: 14px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n.mega-horizontal .media .radio {\n  margin-left: 3px;\n}\n\n.plain-style .card {\n  box-shadow: none;\n  border: none !important;\n}\n\n.border-style .card {\n  box-shadow: none;\n  border: 1px solid #ecf3fa !important;\n}\n\n.offer-style .card {\n  box-shadow: none;\n  border: 1px dashed #ecf3fa !important;\n}\n\n.rating-star-wrapper {\n  color: #797979;\n}\n\n/**=====================\n     19. Mega option CSS Ends\n==========================**/\n/**=====================\n     76. Order History CSS start\n==========================**/\n.prooduct-details-box .close {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  height: 16px;\n  cursor: pointer;\n}\n.prooduct-details-box .media {\n  border: 1px solid #d7e2e9;\n  border-radius: 10px;\n  padding: 15px 0;\n  width: 100%;\n  position: relative;\n}\n.prooduct-details-box .media .media {\n  border: none;\n  border-radius: 0;\n  padding: 0;\n}\n.prooduct-details-box .rating {\n  color: #ffaf45;\n  letter-spacing: 3px;\n}\n.prooduct-details-box .product-name a {\n  color: gray;\n}\n.prooduct-details-box .product-name h6, .prooduct-details-box .product-name .h6 {\n  margin-bottom: 0;\n}\n.prooduct-details-box .btn {\n  position: absolute;\n  right: 15px;\n  bottom: 15px;\n}\n\n.order-history .input-group {\n  text-align: right;\n  max-width: 300px;\n}\n.order-history table th,\n.order-history table td {\n  text-align: center;\n}\n.order-history table thead tr th {\n  vertical-align: middle;\n  border-top: none;\n  background-color: #f8f8f8;\n  border: 1px solid #ecf3fa;\n  padding: 1.25rem;\n  font-size: 16px;\n}\n.order-history table .qty-box {\n  min-width: 270px;\n  margin: 0 auto;\n  border-radius: 5px;\n  overflow: hidden;\n}\n.order-history table .qty-box input {\n  width: 44px;\n  max-width: 44px;\n  background-color: transparent;\n  border: none !important;\n}\n.order-history table .qty-box .input-group {\n  align-items: center;\n  background-color: transparent;\n  border-radius: 5px;\n  border: 1px solid #ecf3fa;\n  overflow: hidden;\n  display: inline-flex;\n  width: unset;\n}\n.order-history table .qty-box .btn {\n  background-color: transparent;\n  border: none;\n}\n.order-history table .qty-box .btn.bootstrap-touchspin-down {\n  border-right: 1px solid;\n}\n[dir=rtl] .order-history table .qty-box .btn.bootstrap-touchspin-down {\n  border-right: unset;\n  border-left: 1px solid;\n}\n.order-history table .qty-box .btn.bootstrap-touchspin-up {\n  border-left: 1px solid;\n}\n[dir=rtl] .order-history table .qty-box .btn.bootstrap-touchspin-up {\n  border-left: unset;\n  border-right: 1px solid;\n}\n.order-history table tbody tr td {\n  vertical-align: middle;\n}\n.order-history table tbody tr td .product-name {\n  min-width: 160px;\n}\n.order-history table tbody tr td .product-name a {\n  font-size: 15px;\n  color: #898989;\n}\n.order-history table tbody tr td .product-name .order-process {\n  font-size: 13px;\n  padding-left: 15px;\n}\n.order-history table tbody tr td .product-name .order-process .order-process-circle {\n  position: relative;\n}\n.order-history table tbody tr td .product-name .order-process .order-process-circle:before {\n  position: absolute;\n  content: \"\";\n  width: 4px;\n  height: 4px;\n  border-radius: 100%;\n  background-color: #898989;\n  left: -15px;\n  top: 4px;\n}\n.order-history table tbody tr td .product-name .order-process .order-process-circle.shipped-order:before {\n  background-color: #54ba4a;\n}\n.order-history table tbody tr td .product-name .order-process .order-process-circle.cancel-order:before {\n  background-color: #fc4438;\n}\n\n@media only screen and (max-width: 1199px) {\n  .order-history table {\n    width: 900px;\n    overflow: auto;\n  }\n}\n/**=====================\n     76. Order History CSS end\n==========================**/\n/**=====================\n     32. pagination CSS Start\n==========================**/\n/*test Nav bar color */\n.pagination-theme .page-item .page-link {\n  color: var(--theme-default) !important;\n}\n@media only screen and (max-width: 575px) {\n  .pagination-theme .page-item .page-link {\n    font-size: 13px;\n  }\n}\n.pagination-theme .page-item.active .page-link {\n  color: #fff !important;\n  background-color: var(--theme-default) !important;\n  border-color: var(--theme-default);\n}\n\n.pagination-primary .page-item .page-link {\n  color: var(--theme-default) !important;\n}\n@media only screen and (max-width: 575px) {\n  .pagination-primary .page-item .page-link {\n    font-size: 13px;\n  }\n}\n.pagination-primary .page-item.active .page-link {\n  color: #fff !important;\n  background-color: var(--theme-default) !important;\n  border-color: var(--theme-default);\n}\n\n.pagination-secondary .page-item .page-link {\n  color: #ff3364 !important;\n}\n@media only screen and (max-width: 575px) {\n  .pagination-secondary .page-item .page-link {\n    font-size: 13px;\n  }\n}\n.pagination-secondary .page-item.active .page-link {\n  color: #fff !important;\n  background-color: #ff3364 !important;\n  border-color: #ff3364;\n}\n\n.pagination-success .page-item .page-link {\n  color: #54ba4a !important;\n}\n@media only screen and (max-width: 575px) {\n  .pagination-success .page-item .page-link {\n    font-size: 13px;\n  }\n}\n.pagination-success .page-item.active .page-link {\n  color: #fff !important;\n  background-color: #54ba4a !important;\n  border-color: #54ba4a;\n}\n\n.pagination-danger .page-item .page-link {\n  color: #fc4438 !important;\n}\n@media only screen and (max-width: 575px) {\n  .pagination-danger .page-item .page-link {\n    font-size: 13px;\n  }\n}\n.pagination-danger .page-item.active .page-link {\n  color: #fff !important;\n  background-color: #fc4438 !important;\n  border-color: #fc4438;\n}\n\n.pagination-info .page-item .page-link {\n  color: #16c7f9 !important;\n}\n@media only screen and (max-width: 575px) {\n  .pagination-info .page-item .page-link {\n    font-size: 13px;\n  }\n}\n.pagination-info .page-item.active .page-link {\n  color: #fff !important;\n  background-color: #16c7f9 !important;\n  border-color: #16c7f9;\n}\n\n.pagination-dark .page-item .page-link {\n  color: #2c323f !important;\n}\n@media only screen and (max-width: 575px) {\n  .pagination-dark .page-item .page-link {\n    font-size: 13px;\n  }\n}\n.pagination-dark .page-item.active .page-link {\n  color: #fff !important;\n  background-color: #2c323f !important;\n  border-color: #2c323f;\n}\n\n.pagination-warning .page-item .page-link {\n  color: #ffaa05 !important;\n}\n@media only screen and (max-width: 575px) {\n  .pagination-warning .page-item .page-link {\n    font-size: 13px;\n  }\n}\n.pagination-warning .page-item.active .page-link {\n  color: #fff !important;\n  background-color: #ffaa05 !important;\n  border-color: #ffaa05;\n}\n\n/**=====================\n     32. pagination CSS Ends\n==========================**/\n/**=====================\n     34. Pricing CSS Start\n==========================**/\n.pricing-simple {\n  box-shadow: 0 0 10px 5px rgba(68, 102, 242, 0.05);\n  margin-bottom: 0 !important;\n}\n.pricing-simple .card-body {\n  border-bottom: none;\n}\n.pricing-simple .card-body h3, .pricing-simple .card-body .h3 {\n  position: relative;\n  margin-bottom: 38px;\n}\n.pricing-simple .card-body h3:before, .pricing-simple .card-body .h3:before {\n  position: absolute;\n  content: \"\";\n  width: 80px;\n  height: 1px;\n  margin: 0 auto;\n  left: 0;\n  right: 0;\n  bottom: -10px;\n  background-color: #999999;\n}\n.pricing-simple .card-body h1, .pricing-simple .card-body .h1 {\n  font-size: 30px;\n  line-height: 0.9;\n  margin-bottom: 30px;\n  font-weight: 400;\n}\n\n.pricingtable {\n  text-align: center;\n  padding-top: 45px;\n  padding-bottom: 45px;\n  border-radius: 10px;\n  box-shadow: 0 0 40px rgba(8, 21, 66, 0.05);\n  overflow: hidden;\n  position: relative;\n  z-index: 1;\n  height: 100%;\n}\n.pricingtable:before, .pricingtable:after {\n  content: \"\";\n  background-color: var(--theme-default);\n  width: 300px;\n  height: 300px;\n  border-radius: 50%;\n  position: absolute;\n  right: -213px;\n  z-index: -1;\n  opacity: 0.1;\n}\n\n.pricingtable:after {\n  background-color: var(--theme-default);\n  height: 300px;\n  width: 300px;\n  top: auto;\n  bottom: -210px;\n  right: auto;\n  left: -160px;\n  opacity: 0.1;\n}\n.pricingtable .title {\n  text-transform: uppercase;\n  margin-bottom: 20px;\n}\n.pricingtable .price-value {\n  color: #fff;\n  background-color: var(--theme-default);\n  width: 130px;\n  height: 130px;\n  padding: 45px 0 0;\n  margin: 0 auto 25px;\n  border-radius: 50%;\n}\n.pricingtable .price-value .duration {\n  margin: 0 0 0 -5px;\n}\n.pricingtable .price-value .amount {\n  font-size: 58px;\n  font-weight: 700;\n  line-height: 45px;\n  display: inline-block;\n}\n.pricingtable .price-value .currency {\n  vertical-align: top;\n}\n.pricingtable .pricing-content {\n  margin: 0 0 25px;\n  display: inline-block;\n}\n.pricingtable .pricing-content li {\n  font-weight: 500;\n  text-align: left;\n  margin: 0 0 20px;\n  position: relative;\n  padding-left: 30px;\n}\n.pricingtable .pricing-content li:last-child {\n  margin: 0;\n}\n.pricingtable .pricing-content li:before {\n  content: \"\\f00c\";\n  color: var(--theme-default);\n  font-family: FontAwesome;\n  text-align: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  position: absolute;\n  top: 1px;\n  left: 0;\n}\n\n@media (max-width: 1470px) {\n  .pricing-block > div {\n    flex: 50%;\n  }\n  .pricing-block > div:nth-child(n+3) {\n    margin-top: 30px;\n  }\n}\n@media only screen and (max-width: 991px) {\n  .pricing-simple .card-body h1, .pricing-simple .card-body .h1 {\n    margin-bottom: 20px;\n  }\n  .pricing-simple .card-body h3, .pricing-simple .card-body .h3 {\n    margin-bottom: 28px;\n  }\n  .pricing-block > div:nth-child(n+2) {\n    margin-top: 20px;\n  }\n}\n@media only screen and (max-width: 575px) {\n  .pricing-simple .card-body h1, .pricing-simple .card-body .h1 {\n    margin-bottom: 15px;\n  }\n  .pricing-block > div {\n    flex: 100%;\n  }\n  .pricingtable {\n    padding-top: 30px;\n    padding-bottom: 30px;\n  }\n}\n/**=====================\n    34. Pricing CSS Ends\n==========================**/\n/**=====================\n     23. Progress CSS Start\n==========================**/\n.progress-showcase .progress {\n  margin-bottom: 10px;\n}\n.progress-showcase .progress:last-child {\n  margin-bottom: 0;\n}\n\n.sm-progress-bar {\n  height: 5px;\n}\n\n.lg-progress-bar {\n  height: 20px;\n}\n\n/**=====================\n     23. Progress CSS Ends\n==========================**/\n.project-list .row {\n  margin: 15px;\n}\n.project-list button:focus {\n  outline: none !important;\n}\n.project-list .theme-form .form-group {\n  margin-bottom: 15px;\n}\n.project-list .border-tab.nav-tabs .nav-item .nav-link {\n  border: 1px solid transparent;\n  padding: 5px 30px 5px 0;\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n}\n.project-list .btn {\n  margin-right: 5px;\n  vertical-align: -12px;\n  float: right;\n}\n[dir=rtl] .project-list .btn {\n  float: left;\n}\n.project-list .btn svg {\n  vertical-align: middle;\n  height: 16px;\n}\n.project-list ul {\n  margin-bottom: 0 !important;\n  border-bottom: 0;\n}\n.project-list ul li svg {\n  height: 18px;\n  vertical-align: middle;\n  margin-right: 5px;\n}\n\n.tab-content .row > div.col-xl-4:nth-child(1) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 100000ms;\n}\n.tab-content .row > div.col-xl-4:nth-child(2) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 200000ms;\n}\n.tab-content .row > div.col-xl-4:nth-child(3) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 300000ms;\n}\n.tab-content .row > div.col-xl-4:nth-child(4) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 400000ms;\n}\n.tab-content .row > div.col-xl-4:nth-child(5) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 500000ms;\n}\n.tab-content .row > div.col-xl-4:nth-child(6) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 600000ms;\n}\n.tab-content .row > div.col-xl-4:nth-child(7) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 700000ms;\n}\n.tab-content .row > div.col-xl-4:nth-child(8) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 800000ms;\n}\n.tab-content .row > div.col-xl-4:nth-child(9) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 900000ms;\n}\n.tab-content .row > div.col-xl-4:nth-child(10) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 1000000ms;\n}\n.tab-content .row > div.col-xl-4:nth-child(11) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 1100000ms;\n}\n.tab-content .row > div.col-xl-4:nth-child(12) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 1200000ms;\n}\n.tab-content .row > div.col-xl-4:nth-child(13) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 1300000ms;\n}\n.tab-content .row > div.col-xl-4:nth-child(14) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 1400000ms;\n}\n.tab-content .row > div.col-xl-4:nth-child(15) {\n  animation-fill-mode: both;\n  animation: fadeIncustom 0.5s linear 1500000ms;\n}\n\n.project-cards .tab-content {\n  margin-bottom: -30px;\n}\n\n.project-box {\n  border: 1px solid #efefef;\n  border-radius: 5px;\n  padding: 30px;\n  background-color: white;\n  margin-bottom: 30px;\n}\n.project-box h6, .project-box .h6 {\n  font-weight: 500 !important;\n}\n.project-box .badge {\n  position: absolute;\n  right: 30px;\n  top: 15px;\n}\n.project-box .project-status p {\n  margin-bottom: 5px;\n  font-weight: 800;\n}\n.project-box .media {\n  margin-bottom: 15px;\n}\n.project-box .media .media-body {\n  opacity: 0.5;\n}\n.project-box .details div {\n  margin-bottom: 5px;\n  opacity: 0.7;\n}\n\n.projectdetails .card .card-body {\n  padding: 20px;\n}\n.projectdetails .card .card-footer {\n  padding: 20px;\n}\n.projectdetails .card select {\n  width: 90px;\n  height: 28px;\n  font-size: 11px;\n  right: 20px;\n  top: 20px;\n}\n\n.projectmore .details .col-4 {\n  margin-bottom: 5px;\n}\n.projectmore .details .col-4:nth-child(even) {\n  opacity: 0.5;\n}\n.projectmore h5, .projectmore .h5 {\n  font-size: 20px;\n  font-weight: 600;\n}\n.projectmore .task-list {\n  position: relative;\n}\n.projectmore .task-list ul li {\n  margin-bottom: 5px;\n}\n.projectmore .task-list ul + ul {\n  position: absolute;\n  left: 50%;\n  top: 0;\n}\n\n.new-users.activity .gradient-round {\n  padding: 13px;\n  font-size: 20px;\n  line-height: 1.4;\n  text-align: center;\n  top: unset !important;\n}\n.new-users.activity .gradient-round::after {\n  display: none;\n}\n\n/**=====================\n     79. social app css start\n==========================**/\n.user-profile .hovercard .socialheader {\n  background: url(../../images/social-app/social-image.png);\n}\n.user-profile .hovercard .user-image .share-icons {\n  position: absolute;\n  right: 100px;\n  top: -27px;\n}\n.user-profile .hovercard .user-image .share-icons li {\n  display: inline-block;\n  margin-right: 10px;\n}\n.user-profile .hovercard .user-image .share-icons li .social-icon {\n  width: 50px;\n  height: 50px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  vertical-align: middle;\n  justify-content: center;\n  border-radius: 100%;\n}\n.user-profile .hovercard .user-image .share-icons li .social-icon i {\n  color: #fff;\n  font-size: 25px;\n}\n.user-profile .hovercard .user-image .share-icons li:last-child {\n  margin-right: 0;\n}\n.user-profile .card-footer > div h3, .user-profile .card-footer > div .h3 {\n  font-size: 16px;\n}\n\n.market-tabs .border-tab.nav-tabs .nav-item .nav-link.active {\n  border-bottom: none !important;\n}\n.market-tabs .nav {\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: center;\n}\n.market-tabs .nav .nav-item {\n  width: 100%;\n}\n.market-tabs .nav .nav-item .nav-link {\n  height: 81px;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  padding-top: 30px;\n  text-align: center;\n}\n\n.tabs-scoial {\n  border-bottom: none;\n  margin-bottom: 20px !important;\n  margin-top: 20px;\n}\n.tabs-scoial li a {\n  font-weight: 600;\n}\n.tabs-scoial li a svg circle {\n  color: #999999;\n}\n\n.social-network span {\n  margin-bottom: 30px;\n  display: block;\n}\n\n.social-list .media {\n  margin-bottom: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.social-list .media:last-child {\n  margin-bottom: 0;\n}\n.social-list .media .media-body a {\n  color: #999999;\n}\n.social-list .media .media-body span {\n  font-weight: 600;\n}\n.social-list .media .media-body:hover a {\n  color: var(--theme-default);\n}\n\n.photos {\n  margin-bottom: -15px;\n}\n.photos ul li {\n  display: inline-block;\n  margin-right: 10px;\n  margin-bottom: 10px;\n  width: 70px;\n}\n.photos ul li:nth-child(4n) {\n  margin-right: 0;\n}\n\n.new-users-social {\n  margin-bottom: 30px;\n}\n.new-users-social svg {\n  cursor: pointer;\n}\n.new-users-social .media img {\n  width: 58px;\n}\n.new-users-social .media .media-body {\n  margin-top: 10px;\n}\n.new-users-social svg circle {\n  color: #999999;\n}\n\n.like-content span i {\n  font-size: 14px;\n}\n\n.timeline-content p {\n  margin-top: 30px;\n  color: #999999;\n}\n.timeline-content .comment-number i {\n  color: #999999;\n  margin-right: 20px;\n}\n.timeline-content .comments-box {\n  margin-top: 30px;\n}\n.timeline-content .comments-box .input-group {\n  margin-top: 6px;\n}\n.timeline-content .comments-box .input-group .input-txt-bx {\n  border: none;\n}\n.timeline-content .comments-box .input-group .input-txt-bx::placeholder {\n  color: #999999;\n}\n.timeline-content .comments-box .input-group .input-group-append .btn i {\n  font-size: 20px;\n  display: flex;\n  color: #999999;\n}\n\n.social-chat {\n  margin-top: 30px;\n}\n.social-chat span span {\n  font-weight: normal;\n  color: #999999;\n  font-size: 12px;\n}\n.social-chat .media-body {\n  padding: 30px;\n  border: 1px solid #f4f4f4;\n  position: relative;\n}\n.social-chat .media-body p {\n  margin-top: 5px;\n}\n.social-chat .media-body:before {\n  content: \"\";\n  position: absolute;\n  top: 19px;\n  right: 100%;\n  border: 7px solid transparent;\n  border-right: 7px solid #59667a;\n}\n.social-chat .media-body:after {\n  content: \"\";\n  position: absolute;\n  top: 19px;\n  right: 100%;\n  border: 7px solid transparent;\n  border-right: 7px solid #fff;\n}\n.social-chat .your-msg,\n.social-chat .other-msg {\n  margin-bottom: 30px;\n}\n.social-chat .other-msg {\n  margin-left: 40px;\n}\n\n.socialprofile span {\n  color: #999999;\n}\n.socialprofile .social-btngroup {\n  margin: 30px 0;\n}\n.socialprofile .likes-profile h5 span, .socialprofile .likes-profile .h5 span {\n  color: #2f2f3b;\n}\n.socialprofile .social-group {\n  margin-top: 30px;\n}\n.socialprofile .social-group ul li:nth-child(4) {\n  margin-left: -22px;\n}\n\n.social-status form .form-group .form-control-social {\n  border: 1px solid #f4f4f4;\n  padding-left: 15px;\n  margin-bottom: 30px;\n}\n.social-status .media {\n  position: relative;\n  margin-bottom: 30px;\n}\n.social-status .media:last-child {\n  margin-bottom: 0;\n}\n.social-status .media .social-status {\n  content: \"\";\n  position: absolute;\n  width: 12px;\n  height: 12px;\n  background-color: #fff;\n  bottom: 0;\n  left: 35px;\n  border-radius: 100%;\n}\n.social-status .media .social-online {\n  border: 3px solid #54ba4a;\n}\n.social-status .media .social-busy {\n  border: 3px solid #ffaa05;\n}\n.social-status .media .social-offline {\n  border: 3px solid #59667a;\n}\n.social-status .media .media-body p {\n  color: #999999;\n  margin-bottom: 5px;\n}\n.social-status .media .media-body span + span {\n  color: #999999;\n}\n.social-status .media .media-body .light-span {\n  color: #999999;\n}\n\n.social-header h5 span:first-child, .social-header .h5 span:first-child {\n  line-height: 1.48;\n}\n.social-header h5 span svg circle, .social-header .h5 span svg circle {\n  color: #999999;\n}\n\n.details-about + .details-about {\n  margin-top: 30px;\n}\n.details-about .your-details p {\n  color: #999999;\n}\n\n.avatar-showcase .friend-pic {\n  margin-right: 8px;\n  margin-bottom: 10px;\n}\n.avatar-showcase .pepole-knows ul li {\n  display: inline-block;\n  margin-right: 20px;\n  margin-bottom: 10px;\n}\n.avatar-showcase .pepole-knows ul li:last-child {\n  margin-right: 0;\n}\n.avatar-showcase .pepole-knows ul li .add-friend h6, .avatar-showcase .pepole-knows ul li .add-friend .h6 {\n  margin-top: 3px;\n}\n\n.activity-log .my-activity + .my-activity {\n  margin-top: 30px;\n}\n.activity-log .my-activity p {\n  margin-bottom: 5px;\n}\n.activity-log .my-activity p span svg {\n  width: 15px;\n  height: 15px;\n}\n\n/**=====================\n     79. social app CSS end\n==========================**/\n/**=====================\n     87. task app CSS Start\n==========================**/\n.modal-open .datepickers-container {\n  z-index: 1075;\n}\n\n.date-details {\n  align-items: center;\n}\n.date-details > div + div {\n  margin-left: 10px;\n}\n\n.taskadd table tr td {\n  border-top: none;\n}\n.taskadd table tr td:first-child {\n  padding-left: 30px;\n}\n.taskadd table tr td:last-child {\n  padding-right: 30px;\n}\n.taskadd table tr td svg {\n  width: 18px;\n  height: 18px;\n  color: #59667a;\n}\n.taskadd table tr:first-child td {\n  padding-top: 30px;\n}\n.taskadd table tr:last-child td {\n  padding-bottom: 30px;\n}\n\n@media only screen and (max-width: 1660px) {\n  .taskadd table tr td:first-child {\n    min-width: 160px;\n  }\n  .taskadd table tr td:nth-child(3) {\n    min-width: 70px;\n  }\n}\n@media only screen and (max-width: 991px) {\n  .date-details {\n    display: block !important;\n    margin-bottom: -10px;\n  }\n  .date-details .d-inline-block {\n    margin-bottom: 10px;\n  }\n  .taskadd table tr td:first-child {\n    padding-left: 20px;\n  }\n  .taskadd table tr:first-child td {\n    padding-top: 20px;\n  }\n  .taskadd table tr:last-child td {\n    padding-bottom: 20px;\n  }\n}\n@media only screen and (max-width: 767px) {\n  .taskadd table tr td:nth-child(2) {\n    min-width: 745px;\n  }\n}\n@media only screen and (max-width: 575px) {\n  .taskadd table tr td:first-child {\n    padding-left: 15px;\n  }\n  .taskadd table tr:first-child td {\n    padding-top: 15px;\n  }\n  .taskadd table tr:last-child td {\n    padding-bottom: 15px;\n  }\n}\n/**=====================\n   87. task app CSS Ends\n==========================**/\n/**=====================\n     42. Timeline CSS Start\n==========================**/\n.activity .media {\n  margin-bottom: 30px;\n}\n.activity .media:last-child {\n  margin-bottom: 0;\n}\n.activity .media .gradient-round {\n  position: relative;\n  width: 53px;\n  height: 53px;\n  background-image: linear-gradient(26deg, var(--theme-default) 0%, #a26cf8 100%);\n  border-radius: 100%;\n  top: -18px;\n}\n.activity .media .gradient-round svg {\n  position: absolute;\n  width: 18px;\n  height: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  left: 0;\n  top: 18px;\n  right: 0;\n  margin: 0 auto;\n}\n.activity .media .gradient-round svg path,\n.activity .media .gradient-round svg line,\n.activity .media .gradient-round svg circle {\n  color: #fff;\n}\n.activity .media .gradient-round.gradient-line-1:after {\n  position: absolute;\n  content: \"\";\n  background-color: #e9e9e9;\n  width: 2px;\n  height: 62px;\n  bottom: -77px;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n}\n.activity .media .gradient-round.small-line:after {\n  position: absolute;\n  content: \"\";\n  background-color: #e9e9e9;\n  width: 2px;\n  height: 19px;\n  bottom: -34px;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n}\n.activity .media .gradient-round.medium-line:after {\n  position: absolute;\n  content: \"\";\n  background-color: #e9e9e9;\n  width: 2px;\n  height: 53px;\n  bottom: -68px;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n}\n.activity .media .media-body h6, .activity .media .media-body .h6 {\n  font-weight: 600;\n  margin-bottom: 30px;\n}\n.activity .media .media-body h6 span, .activity .media .media-body .h6 span {\n  font-weight: normal;\n  color: #999999;\n}\n.activity .media .media-body p {\n  width: 80%;\n}\n\n.timeline-small .media {\n  margin-bottom: 30px;\n}\n.timeline-small .media:last-child {\n  margin-bottom: 0;\n}\n.timeline-small .media .timeline-round {\n  position: relative;\n  width: 53px;\n  height: 53px;\n  border-radius: 100%;\n  border-radius: 15px;\n  top: -18px;\n}\n.timeline-small .media .timeline-round svg {\n  position: absolute;\n  width: 18px;\n  height: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  left: 0;\n  top: 18px;\n  right: 0;\n  margin: 0 auto;\n}\n.timeline-small .media .timeline-round svg path,\n.timeline-small .media .timeline-round svg line,\n.timeline-small .media .timeline-round svg circle {\n  color: #fff;\n}\n.timeline-small .media .timeline-round.timeline-line-1:after {\n  position: absolute;\n  content: \"\";\n  background-color: #e9e9e9;\n  width: 2px;\n  height: 62px;\n  bottom: -88px;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n}\n.timeline-small .media .timeline-round.small-line:after {\n  position: absolute;\n  content: \"\";\n  background-color: #e9e9e9;\n  width: 2px;\n  height: 19px;\n  bottom: -34px;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n}\n.timeline-small .media .timeline-round.medium-line:after {\n  position: absolute;\n  content: \"\";\n  background-color: #e9e9e9;\n  width: 2px;\n  height: 53px;\n  bottom: -68px;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n}\n.timeline-small .media .media-body h6, .timeline-small .media .media-body .h6 {\n  margin-bottom: 30px;\n}\n.timeline-small .media .media-body h6 span, .timeline-small .media .media-body .h6 span {\n  font-weight: normal;\n  color: #999999;\n}\n.timeline-small .media .media-body p {\n  width: 80%;\n}\n\n.cd-container {\n  width: 90%;\n  max-width: 1170px;\n  margin: 0 auto;\n}\n\n.cd-container::after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n\n@media only screen and (min-width: 1170px) {\n  #cd-timeline::before {\n    left: 50% !important;\n    margin-left: -2px;\n  }\n  .cd-timeline-block {\n    margin: 4em 0;\n  }\n  .cd-timeline-block:first-child {\n    margin-top: 0;\n  }\n  .cd-timeline-block:last-child {\n    margin-bottom: 0;\n  }\n  .cd-timeline-block:nth-child(even) .cd-timeline-content {\n    float: right;\n  }\n  .cd-timeline-block:nth-child(even) .cd-timeline-content .cd-date {\n    left: auto;\n    right: 122%;\n    text-align: right;\n  }\n  .cd-timeline-block:nth-child(even) .cd-timeline-content::before {\n    top: 24px;\n    left: auto;\n    right: 100%;\n    border-color: transparent;\n    border-right-color: #f4f4f4;\n  }\n  .cd-timeline-img {\n    width: 60px;\n    height: 60px;\n    left: 50%;\n    margin-left: -30px;\n  }\n  .cd-timeline-img > i {\n    font-size: 18px;\n    top: 50%;\n    left: 50%;\n    padding: 3px;\n  }\n  .cssanimations .cd-timeline-img.is-hidden {\n    visibility: hidden;\n  }\n  .cssanimations .cd-timeline-img.bounce-in {\n    visibility: visible;\n    animation: cd-bounce-1 0.6s;\n  }\n  .cssanimations .cd-timeline-content.is-hidden {\n    visibility: hidden;\n  }\n  .cssanimations .cd-timeline-content.bounce-in {\n    visibility: visible;\n    animation: cd-bounce-2 0.6s;\n  }\n  .cssanimations .cd-timeline-block:nth-child(even) .cd-timeline-content.bounce-in {\n    animation: cd-bounce-2-inverse 0.6s;\n  }\n  .cd-timeline-content {\n    margin-left: 0;\n    padding: 1.6em;\n    width: 45%;\n  }\n  .cd-timeline-content .cd-date {\n    position: absolute;\n    width: 100%;\n    left: 122%;\n    top: 6px;\n    font-size: 16px;\n  }\n  .cd-timeline-content::before {\n    top: 24px;\n    left: 100%;\n    border-color: transparent;\n    border-left-color: #fff;\n  }\n}\n#cd-timeline {\n  position: relative;\n  padding: 2em 0;\n}\n\n#cd-timeline::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  font-size: 1.5rem;\n  height: 100%;\n  width: 2px;\n  background: #f4f4f4;\n  left: -15px;\n}\n\n.cd-timeline-block {\n  position: relative;\n  margin: 30px 0;\n}\n.cd-timeline-block:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.cd-timeline-block:first-child {\n  margin-top: 0;\n}\n.cd-timeline-block:last-child {\n  margin-bottom: 0;\n}\n\n.cd-timeline-img {\n  width: 60px;\n  height: 60px;\n  left: 50%;\n  margin-left: -30px;\n  -webkit-transform: translateZ(0);\n  -webkit-backface-visibility: hidden;\n  position: absolute;\n  top: 0;\n  border-radius: 4px;\n}\n.cd-timeline-img i {\n  display: block;\n  position: relative;\n  left: 45%;\n  top: 44%;\n  margin-left: -12px;\n  margin-top: -12px;\n  font-size: 27px;\n  color: #fff;\n}\n\n@-webkit-keyframes cd-bounce-1 {\n  0% {\n    opacity: 0;\n  }\n  60% {\n    opacity: 1;\n  }\n}\n@-moz-keyframes cd-bounce-1 {\n  0% {\n    opacity: 0;\n  }\n  60% {\n    opacity: 1;\n  }\n}\n@keyframes cd-bounce-1 {\n  0% {\n    opacity: 0;\n    transform: scale(0.5);\n  }\n  60% {\n    opacity: 1;\n    transform: scale(1.2);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.cd-timeline-content {\n  position: relative;\n  background: #fdfeff;\n  border-radius: 4px;\n  padding: 30px;\n  box-shadow: 1px 1px 2px 1px rgba(0, 0, 0, 0.08);\n}\n.cd-timeline-content p {\n  padding-top: 9px;\n}\n.cd-timeline-content h4, .cd-timeline-content .h4 {\n  margin-bottom: 0;\n}\n.cd-timeline-content:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.cd-timeline-content audio {\n  width: 100%;\n}\n.cd-timeline-content .cd-date {\n  font-size: 13px;\n  display: inline-block;\n  float: left;\n  padding: 0.8em 0 0;\n  opacity: 0.7;\n}\n\n.cd-timeline-content::before {\n  content: \"\";\n  position: absolute;\n  top: 16px;\n  right: 100%;\n  height: 0;\n  width: 0;\n  border: 7px solid transparent;\n  border-left: 7px solid #f4f4f4;\n}\n\n@media only screen and (min-width: 768px) {\n  .cd-timeline-content .cd-date {\n    font-size: 14px;\n    padding-bottom: 0;\n  }\n}\n@-webkit-keyframes cd-bounce-2 {\n  0% {\n    opacity: 0;\n  }\n  60% {\n    opacity: 1;\n  }\n}\n@-moz-keyframes cd-bounce-2 {\n  0% {\n    opacity: 0;\n  }\n  60% {\n    opacity: 1;\n  }\n}\n@keyframes cd-bounce-2 {\n  0% {\n    opacity: 0;\n    transform: translateX(-100px);\n  }\n  60% {\n    opacity: 1;\n    transform: translateX(20px);\n  }\n  100% {\n    transform: translateX(0);\n  }\n}\n@-webkit-keyframes cd-bounce-2-inverse {\n  0% {\n    opacity: 0;\n  }\n  60% {\n    opacity: 1;\n  }\n}\n@-moz-keyframes cd-bounce-2-inverse {\n  0% {\n    opacity: 0;\n  }\n  60% {\n    opacity: 1;\n  }\n}\n@keyframes cd-bounce-2-inverse {\n  0% {\n    opacity: 0;\n    transform: translateX(100px);\n  }\n  60% {\n    opacity: 1;\n    transform: translateX(-20px);\n  }\n  100% {\n    transform: translateX(0);\n  }\n}\n@media only screen and (max-width: 1169px) {\n  .cd-timeline-block .cd-timeline-img {\n    left: -2px;\n    height: 30px;\n    width: 30px;\n    margin-left: -30px;\n    top: 14px;\n    z-index: 7;\n  }\n  .cd-timeline-block .cd-timeline-img > i {\n    font-size: 15px;\n    top: 16px;\n    left: 17px;\n    padding: 3px;\n  }\n  .landing-main #cd-timeline::before {\n    left: -39px;\n  }\n  .landing-main .cd-timeline-block .cd-timeline-img {\n    left: -34px;\n    height: 50px;\n    width: 50px;\n    top: 1px;\n    z-index: 8;\n  }\n  .landing-main .cd-timeline-block .cd-timeline-img > i {\n    font-size: 23px;\n    top: 21px;\n    left: 7px;\n    padding: 3px;\n  }\n}\n@media only screen and (max-width: 576px) {\n  .cd-timeline-content {\n    padding: 15px;\n  }\n  .cd-timeline-content h4, .cd-timeline-content .h4 {\n    font-size: 18px;\n  }\n}\n/**=====================\n     42. Timeline  CSS Ends\n==========================**/\n/**=====================\n    43. Timeline 2 CSS Start\n==========================**/\n.timeliny {\n  position: relative;\n  display: block;\n  padding: 10rem 0;\n  width: 100%;\n  border-top: 1px solid rgb(98.6862745098%, 98.6862745098%, 98.6862745098%);\n  border-bottom: 1px solid rgb(98.6862745098%, 98.6862745098%, 98.6862745098%);\n  text-rendering: optimizeLegibility;\n  color: #f4f4f4;\n  opacity: 0;\n  overflow: hidden;\n  cursor: move;\n}\n.timeliny.loaded {\n  opacity: 1;\n}\n.timeliny::before {\n  content: \"\";\n  position: absolute;\n  background-color: #898989;\n  width: 100%;\n  height: 1px;\n  top: 50%;\n  left: 0;\n}\n.timeliny .timeliny-wrapper {\n  display: block;\n  margin: auto;\n  width: 100%;\n  max-width: 1024px;\n}\n.timeliny .timeliny-dot {\n  -webkit-transition: all 0.35s ease-in-out;\n  -moz-transition: all 0.35s ease-in-out;\n  transition: all 0.35s ease-in-out;\n  display: block;\n  position: absolute;\n  top: 50%;\n  left: 0;\n  margin-top: -0.6rem;\n  width: 1.2rem;\n  height: 1.2rem;\n  border-radius: 50%;\n  border: 1px solid #898989;\n  background-color: #fff;\n}\n.timeliny .timeliny-dot::before {\n  -webkit-transition: all 0.35s ease-in-out;\n  -moz-transition: all 0.35s ease-in-out;\n  transition: all 0.35s ease-in-out;\n  content: attr(data-year);\n  display: block;\n  position: absolute;\n  top: -5rem;\n  left: 1.25rem;\n  color: #2c323f;\n  font-family: Rubik, sans-serif;\n  font-size: 22px;\n}\n.timeliny .timeliny-dot::after {\n  -webkit-transition: all 0.35s ease-in-out;\n  -moz-transition: all 0.35s ease-in-out;\n  transition: all 0.35s ease-in-out;\n  -ms-transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%);\n  content: attr(data-text);\n  display: block;\n  position: absolute;\n  width: 256px;\n  top: 5.6rem;\n  left: 1.25rem;\n  color: #f4f4f4;\n  opacity: 0;\n  font-size: 0.9em;\n}\n@media (min-width: 768px) {\n  .timeliny .timeliny-dot::after {\n    width: 341.3333333333px;\n  }\n}\n.timeliny .timeliny-timeline {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  display: table;\n  width: 100%;\n  z-index: 5;\n}\n.timeliny .timeliny-timeline .timeliny-timeblock {\n  display: table-cell;\n  position: relative;\n}\n.timeliny .timeliny-timeline .timeliny-timeblock.active .timeliny-dot {\n  border-color: var(--theme-default);\n  background-color: var(--theme-default);\n  box-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.33);\n}\n.timeliny .timeliny-timeline .timeliny-timeblock.active .timeliny-dot::before {\n  color: #2c323f;\n}\n.timeliny .timeliny-timeline .timeliny-timeblock.active .timeliny-dot::after {\n  color: #2c323f;\n  opacity: 1;\n  background-color: white;\n  border: 1px solid #efefef;\n  padding: 10px;\n  border-radius: 5px;\n}\n.timeliny .timeliny-timeline .timeliny-timeblock.inactive .timeliny-dot {\n  cursor: move;\n}\n.timeliny .timeliny-timeline .timeliny-timeblock.inactive .timeliny-dot::before {\n  color: #f4f4f4;\n}\n.timeliny .timeliny-timeline .timeliny-timeblock:not(.inactive):not(.active) .timeliny-dot:hover {\n  border-color: #2c323f;\n  background-color: #2c323f;\n}\n.timeliny .timeliny-timeline .timeliny-timeblock:not(.inactive):not(.active) .timeliny-dot:hover::before {\n  color: #2c323f;\n}\n.timeliny .timeliny-timeline .timeliny-timeblock .timeliny-dot:hover::after {\n  color: #2c323f;\n  opacity: 1;\n  background-color: #fff;\n  border: 1px solid #efefef;\n  padding: 10px;\n  border-radius: 5px;\n}\n.timeliny .timeliny-vertical-line {\n  position: absolute;\n  display: block;\n  z-index: 1;\n  left: 16%;\n  top: 0;\n  width: 1px;\n  height: 100%;\n  background-color: var(--theme-default);\n}\n@media (min-width: 768px) {\n  .timeliny .timeliny-vertical-line {\n    left: 32%;\n  }\n}\n.timeliny .timeliny-vertical-line::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -7px;\n  width: 0;\n  height: 0;\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  border-top: 8px solid var(--theme-default);\n}\n.timeliny .timeliny-vertical-line::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: -7px;\n  width: 0;\n  height: 0;\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  border-bottom: 8px solid var(--theme-default);\n}\n\n/**=====================\n     43. Timeline 2 CSS Ends\n==========================**/\n/**=====================\n     22. User profile css start\n==========================**/\n.user-profile .ttl-info h6, .user-profile .ttl-info .h6 {\n  font-size: 12px;\n  color: #59667a;\n}\n.user-profile .border-right {\n  border-right: 1px solid #f4f4f4;\n}\n.user-profile hr {\n  margin: 30px 0;\n}\n.user-profile .hovercard .cardheader {\n  background: url(../../images/other-images/bg-profile.png);\n  background-size: cover;\n  background-position: 10%;\n  height: 470px;\n}\n.user-profile .hovercard .user-image {\n  position: relative;\n  height: 0;\n}\n.user-profile .hovercard .user-image .avatar {\n  margin-top: -80px;\n}\n.user-profile .hovercard .user-image .avatar img {\n  width: 100px;\n  height: 100px;\n  max-width: 155px;\n  max-height: 155px;\n  border-radius: 50%;\n  border: 7px solid #fff;\n}\n.user-profile .hovercard .user-image .icon-wrapper {\n  position: absolute;\n  bottom: -20px;\n  left: 51%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  background-color: #fff;\n  cursor: pointer;\n  overflow: hidden;\n  margin: 0 auto;\n  font-size: 17px;\n  box-shadow: 0 0 6px 3px rgba(68, 102, 242, 0.1);\n}\n.user-profile .hovercard .user-image .icon-wrapper .upload {\n  position: absolute;\n  left: 0;\n  right: 0;\n  opacity: 0;\n}\n.user-profile .hovercard .info {\n  padding: 30px;\n}\n.user-profile .hovercard .info .title {\n  margin-bottom: 4px;\n  font-size: 24px;\n  line-height: 1;\n  color: #2c323f;\n  vertical-align: middle;\n}\n.user-profile .hovercard .info .title a {\n  color: #242934;\n  font-size: 20px;\n  text-transform: uppercase;\n  font-weight: 500;\n}\n.user-profile .hovercard .info .desc {\n  overflow: hidden;\n  font-size: 14px;\n  line-height: 20px;\n  color: #59667a;\n  text-overflow: ellipsis;\n  text-transform: uppercase;\n}\n.user-profile .follow {\n  margin-top: 20px;\n}\n.user-profile .follow .follow-num {\n  font-size: 20px;\n  color: #242934;\n  font-family: Rubik, sans-serif;\n  font-weight: 500;\n}\n.user-profile .follow span {\n  color: #59667a;\n}\n.user-profile .profile-img-style {\n  padding: 30px;\n}\n.user-profile .profile-img-style .img-container {\n  margin-top: 30px;\n}\n.user-profile .profile-img-style .user-name {\n  font-size: 14px;\n  color: #242934;\n  margin: 0;\n  font-weight: 600;\n}\n.user-profile .profile-img-style p {\n  line-height: 30px;\n  font-size: 14px;\n  color: #898989;\n  margin-bottom: 0;\n}\n.user-profile .profile-img-style .media img {\n  width: 50px;\n}\n.user-profile .like-comment a {\n  color: #898989;\n}\n.user-profile .like-comment a:hover {\n  color: #fc4438;\n}\n.user-profile .like-comment span {\n  font-family: Rubik, sans-serif;\n}\n.user-profile .social-media a {\n  padding: 0 15px;\n  color: #59667a;\n  font-size: 24px;\n  cursor: pointer;\n}\n.user-profile .social-media a:hover {\n  color: var(--theme-default);\n}\n\n.edit-profile .profile-title .media {\n  align-items: center;\n  margin-bottom: 30px;\n}\n.edit-profile .profile-title .media .media-body {\n  margin-left: 14px;\n}\n.edit-profile .profile-title .media .media-body a {\n  color: #2f2f3b;\n}\n[dir=rtl] .edit-profile .profile-title .media .media-body {\n  margin-left: unset;\n  margin-right: 14px;\n}\n\n/**=====================\n     22. User profile css Ends\n==========================**/\n/**=====================\n    83. Wishlist CSS start\n==========================**/\n.wishlist table tr td svg {\n  color: #898989;\n  cursor: pointer;\n}\n\n/**=====================\n    83. Wishlist CSS Ends\n==========================**/\n/**=====================\n     47. Footer CSS Start\n==========================**/\n.footer {\n  background-color: #fff;\n  box-shadow: 0 0 20px rgba(89, 102, 122, 0.1);\n  padding: 15px;\n  bottom: 0;\n  left: 0;\n  margin-left: 265px;\n  transition: 0.5s;\n}\n.footer.footer-dark {\n  background-color: #242934;\n}\n.footer.footer-dark p {\n  color: #fff;\n}\n\n.footer-fix {\n  width: calc(100% - 265px);\n  position: fixed;\n}\n\n/**=====================\n     47. Footer CSS Ends\n==========================**/\n/**=====================\n      08. GRID CSS Start\n==========================**/\n.grid-showcase {\n  margin-bottom: -10px;\n}\n.grid-showcase span {\n  display: block;\n  border: 1px solid #f4f4f4;\n  padding: 10px;\n  margin-bottom: 10px;\n  text-align: center;\n  background-color: #fff;\n}\n\n.grid-align {\n  margin-bottom: -30px;\n}\n.grid-align .row {\n  padding: 15px 0;\n  min-height: 10rem;\n  border: 1px solid rgba(115, 102, 255, 0.02);\n  margin-bottom: 30px;\n  background-color: rgba(115, 102, 255, 0.02);\n}\n\n/**=====================\n      08. GRID CSS Ends\n==========================**/\n/*======= Page Header css Start ======= */\n.left-header .d-flex {\n  align-items: center;\n}\n[dir=rtl] .left-header .d-flex {\n  justify-content: flex-end;\n}\n.left-header h6, .left-header .h6 {\n  line-height: 1.6;\n}\n@media (max-width: 1199px) {\n  .left-header h6, .left-header .h6 {\n    width: 160px;\n    overflow: hidden;\n    -webkit-line-clamp: 1;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n@media (max-width: 991px) {\n  .left-header h6, .left-header .h6 {\n    width: 120px;\n  }\n}\n@media (max-width: 767px) {\n  .left-header h6, .left-header .h6 {\n    width: 66px;\n  }\n}\n@media (max-width: 755px) {\n  .left-header {\n    display: none;\n  }\n}\n.left-header img {\n  margin-top: -12px;\n  height: 26px;\n}\n.left-header i {\n  font-weight: 600;\n  font-size: 12px;\n  margin-bottom: -4px;\n}\n\n/*======= Page Header css ends  ======= */\n/**======Main Header css Start ======**/\n.offcanvas .page-wrapper .page-body-wrapper .page-body,\n.offcanvas-bookmark .page-wrapper .page-body-wrapper .page-body {\n  position: relative;\n  filter: blur(5px) grayscale(100%);\n}\n\n.offcanvas {\n  position: unset;\n  visibility: visible;\n  background: unset;\n  z-index: 2;\n}\n\n.toggle-sidebar {\n  position: absolute;\n  right: 30px;\n  top: 30px;\n  cursor: pointer;\n}\n.toggle-sidebar svg {\n  width: 20px;\n  height: 20px;\n}\n.toggle-sidebar:before {\n  content: \"\";\n  position: absolute;\n  height: 40px;\n  width: 40px;\n  background-color: rgba(115, 102, 255, 0.1);\n  border-radius: 100%;\n  left: -11px;\n  z-index: -2;\n  top: -8px;\n  transform: scale(0);\n  transition: all 0.3s ease;\n}\n.toggle-sidebar:hover:before {\n  height: 40px;\n  width: 40px;\n  transform: scale(1);\n  transition: all 0.3s ease;\n}\n.toggle-sidebar:hover > svg {\n  color: var(--theme-default) !important;\n  stroke: var(--theme-default) !important;\n}\n\n.onhover-dropdown {\n  cursor: pointer;\n  position: relative;\n}\n.onhover-show-div {\n  top: 80px;\n  position: absolute;\n  z-index: 8;\n  background-color: #fff;\n  transition: all linear 0.3s;\n}\n.onhover-show-div li a svg {\n  margin-top: 0 !important;\n}\n.onhover-show-div li a svg path,\n.onhover-show-div li a svg line {\n  color: #2f2f3b !important;\n}\n\n/**======Main Header css Ends ======**/\n/*=======Mega menu css start=======*/\n.mega-menu .default-according .card .btn-link {\n  font-weight: 500;\n  color: gray;\n}\n.mega-menu .default-according .card .card-body {\n  font-size: 12px;\n}\n.mega-menu .onhover-show-div {\n  width: 1500px;\n}\n.mega-menu .card-body {\n  padding: 20px;\n}\n.mega-menu div > div a {\n  margin-bottom: 0px;\n  display: inline-block;\n  color: #52526c;\n}\n.mega-menu .list-unstyled div a {\n  padding: 8px 35px 8px 0;\n  transition: 0.5s;\n}\n.mega-menu .list-unstyled div a:hover {\n  padding: 8px 35px 8px 10px;\n  transition: 0.5s;\n}\n\n/*=======Mega menu css end=======*/\n/**=====================\n    05. Header CSS Ends\n==========================**/\n/**=====================\n     36. NAV CSS Start\n==========================**/\n#accordionoc #collapseicon,\n#accordionoc #collapseicon1 {\n  padding-top: 0px;\n}\n#accordionoc li button {\n  display: flex;\n  align-items: center;\n}\n\n.navs-icon.default-according.style-1 li button {\n  position: relative;\n}\n.navs-icon.default-according.style-1 li button:hover {\n  color: var(--theme-default) !important;\n}\n.navs-icon.default-according.style-1 li button[aria-expanded=true]:before {\n  right: 2px;\n  top: 6px;\n}\n.navs-icon.default-according.style-1 li button[aria-expanded=false]:before {\n  right: 2px;\n  top: 6px;\n}\n\n.navs-icon {\n  padding: 30px;\n}\n.navs-icon li {\n  padding: 9px 0;\n}\n.navs-icon li a {\n  color: #2f2f3b;\n}\n.navs-icon li a:hover {\n  color: var(--theme-default);\n}\n.navs-icon li ul {\n  padding-top: 9px;\n}\n\n.onhover-dropdown.navs-dropdown:hover .onhover-show-div:before, .onhover-dropdown.navs-dropdown:hover .onhover-show-div:after {\n  right: 77px;\n  left: unset;\n}\n\n.icon-lists {\n  font-family: Rubik, sans-serif;\n}\n\n.pl-navs-inline {\n  padding-left: 30px !important;\n}\n\n.inline-nav li {\n  line-height: 1.3;\n}\n\n/**=====================\n     36. NAV CSS Ends\n==========================**/\n/**=====================\n     51. Search CSS Start\n==========================**/\n.search-page .theme-form input {\n  border: 1px solid var(--theme-default);\n  padding-left: 20px;\n  border-radius: 10px 0 0 10px;\n  flex: 1 1 auto;\n}\n.search-page .theme-form input::placeholder {\n  color: #7366ff;\n}\n.search-page .theme-form input:focus {\n  outline: none;\n}\n.search-page .theme-form .input-group .btn {\n  line-height: 32px;\n  font-size: 16px;\n}\n.search-page .theme-form .input-group .form-control-plaintext {\n  background: transparent;\n}\n.search-page h6, .search-page .h6 {\n  line-height: 1.4;\n}\n.search-page .nav-link {\n  font-weight: 500;\n  text-transform: uppercase;\n}\n.search-page .border-tab.nav-tabs .material-border {\n  border-bottom-width: 1px;\n}\n.search-page .border-tab.nav-tabs .nav-item .nav-link {\n  font-size: 15px;\n  padding: 10px 18px;\n}\n.search-page .media .media-body {\n  overflow: hidden;\n}\n.search-page .info-block {\n  padding: 30px;\n  border-radius: 15px;\n  border: 1px solid #f4f4f4;\n}\n.search-page .info-block a {\n  color: #656565;\n  margin-bottom: 3px;\n  display: block;\n}\n.search-page .info-block h6, .search-page .info-block .h6 {\n  color: #7366ff;\n}\n.search-page .info-block + .info-block {\n  margin-top: 20px;\n}\n.search-page .border-tab.nav-tabs {\n  align-items: left;\n  justify-content: flex-end;\n}\n.search-page .border-tab.nav-tabs .nav-item {\n  width: auto;\n}\n.search-page .search-links h6, .search-page .search-links .h6 {\n  margin-bottom: 10px;\n}\n.search-page p {\n  text-transform: lowercase;\n  margin-bottom: 0;\n  color: #a5a2a2;\n}\n.search-page ul.search-info li {\n  display: inline-block;\n  font-size: 12px;\n  line-height: 1;\n  color: #586082;\n}\n.search-page ul.search-info li + li {\n  border-left: 1px solid rgb(65.82737768%, 69.0819131391%, 76.1334066337%);\n  padding-left: 8px;\n  margin-left: 8px;\n}\n.search-page ul.search-info li i {\n  color: #ffaa05;\n}\n.search-page ul.search-info li i:not(:last-child) {\n  margin-right: 4px;\n}\n.search-page #video-links .embed-responsive + .embed-responsive {\n  margin-top: 30px;\n}\n\n.search-list {\n  margin-bottom: 30px;\n  width: auto;\n  display: inline-flex;\n  border-radius: 10px;\n  overflow: hidden;\n  border: 1px solid #7366ff;\n  border: none;\n}\n.search-list .nav-item {\n  background-color: rgba(115, 102, 255, 0.1);\n}\n.search-list .nav-item .nav-link {\n  border: none;\n  padding: 0.7rem 1.5rem;\n  opacity: 0.5;\n}\n.search-list .nav-item .nav-link.active {\n  background-color: rgba(115, 102, 255, 0.1);\n  color: var(--theme-default);\n  opacity: 1;\n}\n.search-list .nav-item.show, .search-list .nav-item.active {\n  background-color: rgba(115, 102, 255, 0.1);\n}\n\n/**=====================\n    51. Search CSS Ends\n==========================**/\n/**=====================\n     21. Select 2 CSS Start\n==========================**/\n.select2 {\n  max-width: 100%;\n}\n\n.add-post #cke_text-box {\n  border: 1px solid #efefef;\n}\n.add-post form .m-checkbox-inline label {\n  margin-bottom: 0;\n}\n.add-post form .form-control {\n  border: 1px solid #efefef;\n}\n.add-post form .col-form-label {\n  padding-bottom: 0;\n  padding-top: 0;\n}\n.add-post form .col-form-label .select2-container--default {\n  margin-top: 10px;\n  max-width: 100%;\n}\n.add-post form .col-form-label .select2-container--default .selection .select2-selection .select2-search__field {\n  padding: 2px;\n}\n.add-post form .col-form-label .select2-container--default .select2-selection--multiple {\n  border: 1px solid #efefef;\n  max-width: 100%;\n}\n.add-post form .col-form-label .select2-container--default .select2-selection--multiple .select2-selection__rendered li {\n  margin-top: 6px !important;\n}\n.add-post .dropzone {\n  margin-bottom: 30px;\n}\n\n.select2-container--open .select2-dropdown {\n  z-index: 7;\n}\n\n.select2-container {\n  width: 100% !important;\n}\n\n.select2-drpdwn .select2-selection {\n  border-radius: 0 !important;\n  border-color: #f4f4f4 !important;\n  height: 40px !important;\n  padding: 5px;\n}\n.select2-drpdwn .form-control {\n  border-radius: 5px;\n}\n.select2-drpdwn .form-control-primary {\n  border-color: var(--theme-default);\n  color: var(--theme-default);\n}\n.select2-drpdwn .form-control-secondary {\n  border-color: var(--theme-secondary);\n  color: var(--theme-secondary);\n}\n.select2-drpdwn .form-control-success {\n  border-color: #54ba4a;\n  color: #54ba4a;\n}\n.select2-drpdwn .form-control-info {\n  border-color: #16c7f9;\n  color: #16c7f9;\n}\n.select2-drpdwn .form-control-warning {\n  border-color: #ffaa05;\n  color: #ffaa05;\n}\n.select2-drpdwn .form-control-danger {\n  border-color: #fc4438;\n  color: #fc4438;\n}\n.select2-drpdwn .form-control-inverse {\n  border-color: #2c323f;\n  color: #2c323f;\n}\n.select2-drpdwn .form-control-primary-fill {\n  background-color: var(--theme-default);\n  color: #fff;\n}\n.select2-drpdwn .form-control-secondary-fill {\n  background-color: var(--theme-secondary);\n  color: #fff;\n}\n.select2-drpdwn .form-control-success-fill {\n  background-color: #54ba4a;\n  color: #fff;\n}\n.select2-drpdwn .form-control-info-fill {\n  background-color: #16c7f9;\n  color: #fff;\n}\n.select2-drpdwn .form-control-warning-fill {\n  background-color: #ffaa05;\n  color: #fff;\n}\n.select2-drpdwn .form-control-danger-fill {\n  background-color: #fc4438;\n  color: #fff;\n}\n.select2-drpdwn .form-control-inverse-fill {\n  background-color: #2c323f;\n  color: #fff;\n}\n\n.selection .select2-selection {\n  border-radius: 5px !important;\n}\n.selection .select2-selection .select2-search__field {\n  margin-top: 0;\n  padding: 3px;\n}\n\n.select2-container--classic .select2-selection--multiple .select2-selection__choice {\n  padding: 2px 6px !important;\n  margin-top: 0 !important;\n  background-color: var(--theme-default) !important;\n  border-color: var(--theme-default) !important;\n  color: #fff;\n  margin-right: 8px !important;\n}\n.select2-container--classic .select2-selection--multiple .select2-selection__choice__remove {\n  color: #fff !important;\n  float: right;\n  margin-left: 0.5rem;\n}\n.select2-container--classic .select2-results__option--highlighted[aria-selected] {\n  background-color: #e0e0e0 !important;\n  color: #424242 !important;\n}\n.select2-container--classic .select2-results__options .select2-results__option[aria-selected=true] {\n  background-color: var(--theme-default) !important;\n  color: #fff !important;\n}\n\n.select2-container--default .select2-selection--single .select2-selection__arrow {\n  top: 11px !important;\n  right: 10px !important;\n}\n.select2-container--default .select2-selection--multiple .select2-selection__choice {\n  padding: 2px 6px !important;\n  margin-top: 0 !important;\n  background-color: var(--theme-default) !important;\n  border-color: var(--theme-default) !important;\n  color: #fff;\n  margin-right: 8px !important;\n}\n.select2-container--default .select2-selection--multiple .select2-selection__choice__remove {\n  color: #fff !important;\n  float: right;\n  margin-left: 0.5rem;\n}\n.select2-container--default .select2-results__option--highlighted[aria-selected] {\n  background-color: #e0e0e0 !important;\n  color: #424242 !important;\n}\n.select2-container--default .select2-results__options .select2-results__option[aria-selected=true] {\n  background-color: var(--theme-default) !important;\n  color: #fff !important;\n}\n\n/**=====================\n     21. Select 2 CSS Ends\n==========================**/\n/**=====================\n    78. Sidebar CSS Start\n==========================**/\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title h5:after, .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title .h5:after, .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a:after {\n  position: absolute;\n  content: \"\";\n  top: 48%;\n  width: 8px;\n  border-top: 1px solid rgba(82, 82, 108, 0.4);\n}\n\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title h5::before, .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title .h5::before, .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a::before {\n  position: absolute;\n  content: \"\";\n  width: 5px;\n  height: 5px;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 25px;\n  border-radius: 100%;\n  background: var(--theme-default);\n  opacity: 0;\n  visibility: hidden;\n}\n[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title h5::before, .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title [dir=rtl] h5::before, [dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title .h5::before, .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title [dir=rtl] .h5::before, [dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a::before, .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li [dir=rtl] a::before {\n  left: unset;\n  right: 25px;\n}\n\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container::before, .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu::before {\n  position: absolute;\n  content: \"\";\n  width: 1px;\n  height: 0;\n  background: rgba(82, 82, 108, 0.4);\n  top: -10px;\n  left: 27px;\n  transition: height 0.5s;\n}\n[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container::before, .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li [dir=rtl] .mega-menu-container::before, [dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu::before, .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li [dir=rtl] .sidebar-submenu::before {\n  left: unset;\n  right: 27px;\n}\n\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a:after {\n  position: absolute;\n  content: \"\";\n  top: 49%;\n  width: 5px;\n  height: 1px;\n  border-radius: 100%;\n  background-color: #59667a;\n}\n\n.onhover-show-div {\n  box-shadow: 0 0 20px rgba(89, 102, 122, 0.1);\n  transform: translateY(30px);\n  opacity: 0;\n  visibility: hidden;\n  left: 0;\n}\n\n.onhover-dropdown:hover .onhover-show-div {\n  opacity: 1;\n  transform: translateY(0px);\n  visibility: visible;\n  border-radius: 5px;\n  overflow: hidden;\n}\n.onhover-dropdown:hover .onhover-show-div:before {\n  width: 0;\n  height: 0;\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-bottom: 7px solid #fff;\n  content: \"\";\n  top: -7px;\n  position: absolute;\n  left: 10px;\n  z-index: 2;\n}\n.onhover-dropdown:hover .onhover-show-div:after {\n  width: 0;\n  height: 0;\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-bottom: 7px solid #d7e2e9;\n  content: \"\";\n  top: -7px;\n  position: absolute;\n  left: 10px;\n  z-index: 1;\n}\n\n.page-wrapper {\n  position: relative;\n}\n.page-wrapper .page-header {\n  max-width: 100vw;\n  position: fixed;\n  top: 0;\n  z-index: 8;\n  transition: 0.5s;\n  background-color: #fff;\n  box-shadow: 0px 4px 40px rgba(39, 32, 120, 0.1);\n}\n.page-wrapper .page-header .header-wrapper {\n  width: 100%;\n  align-items: center;\n  padding: 22px 30px;\n  position: relative;\n}\n@media (max-width: 1399px) {\n  .page-wrapper .page-header .header-wrapper {\n    padding: 22px 20px;\n  }\n}\n.page-wrapper .page-header .header-wrapper .search-full {\n  background-color: #fff;\n  position: absolute;\n  right: 0;\n  z-index: 1;\n  height: 0;\n  width: 0;\n  transform: scale(0);\n  transition: all 0.3s ease;\n}\n.page-wrapper .page-header .header-wrapper .search-full.open {\n  height: 100%;\n  width: 100%;\n  animation: zoomIn 0.5s ease-in-out;\n  transform: scale(1);\n  transition: all 0.3s ease;\n}\n.page-wrapper .page-header .header-wrapper .search-full input {\n  line-height: 65px;\n  padding-left: 60px;\n  width: 100% !important;\n}\n.page-wrapper .page-header .header-wrapper .search-full input:focus {\n  outline: none !important;\n}\n.page-wrapper .page-header .header-wrapper .search-full .form-group .close-search {\n  position: absolute;\n  font-size: 15px;\n  right: 30px;\n  top: 30px;\n  color: #898989;\n  cursor: pointer;\n}\n.page-wrapper .page-header .header-wrapper .search-full .form-group:before {\n  position: absolute;\n  left: 30px;\n  top: 27px;\n  content: \"\\f002\";\n  font-size: 16px;\n  color: #898989;\n  font-family: FontAwesome;\n}\n.page-wrapper .page-header .header-wrapper .nav-right {\n  justify-content: flex-end;\n}\n.page-wrapper .page-header .header-wrapper .nav-right ul li svg {\n  vertical-align: middle;\n  width: 20px;\n  height: 20px;\n  stroke: rgba(47, 47, 59, 0.9);\n  fill: none;\n}\n.page-wrapper .page-header .header-wrapper .nav-right ul li svg path {\n  color: #242934;\n}\n.page-wrapper .page-header .header-wrapper .nav-right ul li .mode.active svg {\n  fill: #fff;\n}\n.page-wrapper .page-header .header-wrapper .nav-right.right-header ul li .mode {\n  cursor: pointer;\n  text-align: center;\n}\n.page-wrapper .page-header .header-wrapper .nav-right.right-header ul li .mode i {\n  font-size: 18px;\n  font-weight: 600;\n  transition: all 0.3s ease;\n}\n.page-wrapper .page-header .header-wrapper .nav-right.right-header ul li .mode i.fa-lightbulb-o {\n  font-weight: 500;\n  font-size: 22px;\n  transition: all 0.3s ease;\n  animation: zoomIn 300ms ease-in-out;\n}\n.page-wrapper .page-header .header-wrapper .nav-right.right-header ul li .header-search {\n  cursor: pointer;\n}\n.page-wrapper .page-header .header-wrapper .nav-right.right-header ul li .profile-media .media-body {\n  margin-left: 15px;\n}\n.page-wrapper .page-header .header-wrapper .nav-right.right-header ul li .profile-media .media-body span {\n  font-weight: 500;\n}\n.page-wrapper .page-header .header-wrapper .nav-right.right-header ul li .profile-media .media-body p {\n  font-size: 12px;\n  line-height: 1;\n  color: rgba(47, 47, 59, 0.7);\n}\n.page-wrapper .page-header .header-wrapper .nav-right > ul {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n.page-wrapper .page-header .header-wrapper .nav-right > ul > li {\n  padding: 6px 10px;\n  display: inline-block;\n  position: relative;\n}\n.page-wrapper .page-header .header-wrapper .nav-right > ul > li .badge {\n  position: absolute;\n  right: -5px;\n  top: -6px;\n  padding: 2px 4px;\n  font-size: 11px;\n  font-weight: 700;\n  font-family: work-Sans, sans-serif;\n}\n.page-wrapper .page-header .header-wrapper .nav-right > ul > li span ul {\n  left: inherit;\n  right: -10px;\n  width: 130px;\n}\n.page-wrapper .page-header .header-wrapper .nav-right > ul > li span ul:before, .page-wrapper .page-header .header-wrapper .nav-right > ul > li span ul:after {\n  left: inherit;\n  right: 10px;\n}\n.page-wrapper .page-header .header-wrapper .nav-right > ul > li span ul li {\n  display: block;\n}\n.page-wrapper .page-header .header-wrapper .nav-right > ul > li span ul li a {\n  font-size: 14px;\n  color: #2c323f;\n}\n.page-wrapper .page-header .header-wrapper .nav-right > ul > li span ul li a i {\n  margin-left: 10px;\n  font-size: 13px;\n  color: #2c323f;\n}\n.page-wrapper .page-header .header-wrapper .nav-right > ul .flag-icon {\n  font-size: 16px;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .bookmark-flip {\n  width: unset !important;\n  box-shadow: unset !important;\n  background-color: transparent !important;\n  overflow: initial;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .bookmark-flip::after, .page-wrapper .page-header .header-wrapper .nav-right .bookmark-flip::before {\n  display: none;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .bookmark-flip .bookmark-dropdown .bookmark-content {\n  text-align: center;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .bookmark-flip .bookmark-dropdown .bookmark-content .bookmark-icon {\n  width: 52px;\n  height: 52px;\n  background-color: #f9f9f9;\n  border-radius: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .bookmark-flip .bookmark-dropdown .bookmark-content span {\n  font-family: Roboto, sans-serif;\n  font-size: 12px;\n  font-weight: 500;\n  letter-spacing: 0.5px;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .flip-card {\n  width: 300px;\n  height: 260px;\n  background-color: transparent;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner {\n  position: relative;\n  height: 100%;\n  text-align: center;\n  transition: transform 0.6s;\n  transform-style: preserve-3d;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .front,\n.page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .back {\n  position: absolute;\n  backface-visibility: hidden;\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 0 20px rgba(89, 102, 122, 0.1);\n  width: 300px;\n  height: 260px;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .front button,\n.page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .back button {\n  background-color: transparent;\n  color: #7366ff;\n  border: none;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .front button:focus,\n.page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .back button:focus {\n  outline: transparent;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .front {\n  background-color: #fff;\n  transition: 0.3s;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .front svg {\n  stroke: #2c323f;\n  transition: all 0.3s ease;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .front svg:hover {\n  stroke: var(--theme-default);\n  transition: all 0.3s ease;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .back {\n  background-color: #fff;\n  transform: rotateY(180deg);\n}\n.page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .back li:first-child {\n  margin-top: 20px;\n  height: 140px !important;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .back button {\n  width: 100%;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .back .flip-back-content input {\n  border-radius: 25px;\n  padding: 6px 12px;\n  width: 100%;\n  border: 1px solid #ddd;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .back .flip-back-content input:focus {\n  outline: none;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner.flipped {\n  transform: rotateY(180deg);\n}\n.page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner.flipped .front {\n  opacity: 0;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div {\n  width: 330px;\n  top: 50px;\n  right: 0;\n  left: unset;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div .dropdown-title {\n  padding: 20px;\n  text-align: center;\n  border-bottom: 1px solid rgba(145, 142, 153, 0.3);\n}\n.page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div ul {\n  padding: 15px;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div li {\n  padding: 15px;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div li p {\n  font-size: 14px;\n  letter-spacing: 0.3px;\n  margin-bottom: 0;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div li a {\n  text-decoration: underline;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  font-family: Roboto, sans-serif;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div li + li {\n  margin-top: 15px;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div li:last-child {\n  padding-bottom: 15px;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div li .media {\n  position: relative;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div li .media img {\n  width: 40px;\n  position: relative;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div li .media .status-circle {\n  left: 0;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div li .media .media-body > span {\n  letter-spacing: 0.8px;\n  padding-right: 10px;\n  display: inline-block;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div li .media .media-body p {\n  margin-bottom: 8px;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div:before, .page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div:after {\n  right: 10px !important;\n  left: unset !important;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .notification-box {\n  position: relative;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .cart-box {\n  position: relative;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown ul {\n  padding: 0 0 15px;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown li {\n  margin: 0 15px;\n  padding: 10px 0;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown li .media {\n  align-items: center;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown li .media .media-body {\n  margin-right: 20px;\n}\n[dir=rtl] .page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown li .media .media-body {\n  margin-right: unset;\n  margin-left: 20px;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown li + li {\n  margin-top: 0;\n  border-top: 1px solid rgba(145, 142, 153, 0.1);\n}\n.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown li:last-child {\n  padding: 20px 15px;\n  border-top: none;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown p {\n  line-height: 1.3;\n  margin-top: 3px;\n  opacity: 0.6;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown .close-circle {\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown .close-circle a {\n  width: 18px;\n  height: 18px;\n  border-radius: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown .close-circle svg {\n  width: 14px;\n  stroke: #fff;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown .qty-box {\n  margin: 5px 0;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown .qty-box .input-group-text {\n  background-color: transparent;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown .qty-box .input-group {\n  width: 80px;\n  background-color: transparent;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown .qty-box .input-group input {\n  background-color: transparent;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown .qty-box .input-group input,\n.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown .qty-box .input-group .btn {\n  font-size: 10px;\n  font-family: Roboto, sans-serif;\n  font-weight: 700;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown .qty-box .input-group .btn {\n  padding: 2px;\n  background-color: #f7f6ff !important;\n  border-color: #f7f6ff !important;\n  border-radius: 100%;\n  font-size: 14px;\n  color: #2f2f3b;\n  display: flex;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown .total {\n  margin: 0;\n  padding: 15px;\n  background-color: #f9f9f9;\n  border: none;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown .total h6, .page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown .total .h6 {\n  font-family: Roboto, sans-serif;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 14px;\n  letter-spacing: 0.5px;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown .total h6 span, .page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown .total .h6 span {\n  font-size: 14px;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown .view-checkout {\n  text-decoration: unset;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .notification-box svg {\n  animation: swing 1.5s ease infinite;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .notification-dropdown {\n  top: 52px;\n  width: 300px;\n  right: -20px !important;\n  left: unset;\n}\n@media (max-width: 575.98px) {\n  .page-wrapper .page-header .header-wrapper .nav-right .notification-dropdown {\n    width: calc(100vw - 30px);\n  }\n}\n.page-wrapper .page-header .header-wrapper .nav-right .notification-dropdown li {\n  background-color: #f9f9f9;\n  border-radius: 5px;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .notification-dropdown li:last-child {\n  text-align: center;\n  background-color: transparent;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .notification-dropdown li p {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .notification-dropdown li p span {\n  font-size: 11px;\n  vertical-align: middle;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .notification-dropdown:before, .page-wrapper .page-header .header-wrapper .nav-right .notification-dropdown:after {\n  right: 28px !important;\n  left: unset !important;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown {\n  width: 160px;\n  top: 57px;\n  left: -12px;\n  padding: 0 10px;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown li {\n  padding: 10px !important;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown li a {\n  text-decoration: unset;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown li:hover a span {\n  color: var(--theme-default);\n  transition: color 0.3s ease;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown li:hover a svg {\n  stroke: var(--theme-default);\n  transition: stroke 0.3s ease;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown li:hover a svg path {\n  stroke: var(--theme-default);\n  transition: stroke 0.3s ease;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown li + li {\n  margin-top: 0;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown li:last-child {\n  padding-top: 10px !important;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown li span {\n  color: #2c323f;\n}\n.page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown li svg {\n  width: 16px;\n  vertical-align: bottom;\n  margin-right: 10px;\n  stroke: #2c323f;\n}\n.page-wrapper .page-body-wrapper {\n  background-color: #f7f8f9;\n}\n.page-wrapper .page-body-wrapper .page-body {\n  min-height: calc(100vh - 136px);\n  margin-top: 136px;\n  padding: 0 15px 0 15px;\n  position: relative;\n  transition: 0.5s;\n}\n.page-wrapper .page-body-wrapper .page-body:before {\n  animation: fadeIn 0.5s ease-in-out;\n}\n.page-wrapper .page-body-wrapper .page-title {\n  padding: 15px 30px;\n  margin: 0 -27px 30px;\n  background-color: #fff;\n}\n.page-wrapper .page-body-wrapper .page-title > .row {\n  margin: 0;\n}\n.page-wrapper .page-body-wrapper .page-title > .row .col-6 {\n  padding: 0;\n}\n.page-wrapper .page-body-wrapper .page-title .row {\n  align-items: center;\n}\n.page-wrapper .page-body-wrapper .page-title .row h3, .page-wrapper .page-body-wrapper .page-title .row .h3 {\n  font-size: 24px;\n  margin-bottom: 0;\n  text-transform: capitalize;\n}\n.page-wrapper .page-body-wrapper .page-title .row h3 small, .page-wrapper .page-body-wrapper .page-title .row .h3 small, .page-wrapper .page-body-wrapper .page-title .row h3 .small, .page-wrapper .page-body-wrapper .page-title .row .h3 .small {\n  display: block;\n  font-size: 12px;\n  margin-bottom: 5px;\n  text-transform: capitalize;\n  color: #52526c;\n}\n.page-wrapper .page-body-wrapper .page-title .breadcrumb {\n  background-color: transparent;\n  padding: 0;\n  margin-bottom: 0;\n  align-items: center;\n  justify-content: flex-end;\n}\n.page-wrapper .page-body-wrapper .page-title .breadcrumb li {\n  font-size: 13px;\n  letter-spacing: 1px;\n  font-family: Roboto, sans-serif;\n}\n.page-wrapper .page-body-wrapper .page-title .breadcrumb .breadcrumb-item + .breadcrumb-item:before {\n  content: \"/\";\n}\n.page-wrapper .page-body-wrapper .page-title .breadcrumb .breadcrumb-item a svg {\n  width: 16px;\n  height: 16px;\n  stroke: #2c323f;\n  vertical-align: text-top;\n}\n.page-wrapper .page-body-wrapper .page-title .breadcrumb .breadcrumb-item.active {\n  color: var(--theme-default);\n  font-weight: 500;\n}\n.page-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a svg.stroke-icon {\n  stroke: #2c323f;\n}\n.page-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a svg.fill-icon {\n  fill: #757589;\n}\n.page-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a.active svg {\n  transition: all 0.3s ease;\n}\n.page-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a.active svg.stroke-icon {\n  stroke: var(--theme-default);\n}\n.page-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a.active svg.fill-icon {\n  fill: var(--theme-default);\n}\n.page-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a {\n  text-transform: capitalize;\n}\n.page-wrapper.horizontal-wrapper [data-simplebar] {\n  position: relative;\n}\n.page-wrapper.horizontal-wrapper .footer {\n  margin-left: 0;\n}\n.page-wrapper.horizontal-wrapper .header-logo-wrapper {\n  width: 150px;\n}\n.page-wrapper.horizontal-wrapper .header-logo-wrapper .toggle-sidebar {\n  display: none;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper {\n  height: 54px;\n  line-height: inherit;\n  top: 79px;\n  background: #fff;\n  box-shadow: 0px 9px 24px rgba(89, 102, 122, 0.05);\n  overflow-x: hidden;\n  z-index: 1;\n  overflow-y: visible;\n  position: fixed;\n  width: 100vw;\n  border-top: 1px solid #efefef;\n  z-index: 3;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper li {\n  display: inline-block;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .badge {\n  position: absolute;\n  top: 2px;\n  right: 0px;\n  z-index: 1;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .logo-wrapper,\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .logo-icon-wrapper {\n  display: none;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main {\n  text-align: left;\n  position: relative;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .left-arrow,\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .right-arrow {\n  position: absolute;\n  top: 0px;\n  padding: 15px;\n  background-color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1;\n  cursor: pointer;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .left-arrow.disabled,\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .right-arrow.disabled {\n  display: none;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .left-arrow {\n  left: 0;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .right-arrow {\n  right: 0;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  line-height: normal;\n  direction: ltr;\n  text-align: left;\n  display: -webkit-box !important;\n  padding: 0 5px;\n  transition: all 0.5s ease;\n  white-space: nowrap;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links li.sidebar-list a.active .according-menu i:before {\n  content: \"-\";\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links li.sidebar-list a .according-menu {\n  display: none;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links li.sidebar-list:hover > .sidebar-submenu {\n  display: block !important;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links li.sidebar-list:hover > .sidebar-submenu > li > .sidebar-submenu {\n  display: block !important;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links li.sidebar-list:hover > .sidebar-submenu > li .sub-arrow i {\n  font-size: 10px;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links li.sidebar-list:hover > .sidebar-submenu > li:hover {\n  display: block !important;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links li.sidebar-list ul.sidebar-submenu li a.active {\n  color: var(--theme-default);\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links li.sidebar-list ul.sidebar-submenu li a.active:after {\n  background-color: var(--theme-default);\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li {\n  position: relative;\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li:hover > a > span {\n  color: var(--theme-default);\n  transition: all 0.3s ease;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li:hover a {\n  background-color: rgba(115, 102, 255, 0.0015);\n  transition: all 0.3s ease;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li:hover a svg.stroke-icon {\n  stroke: var(--theme-default);\n  transition: all 0.3s ease;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li:hover a svg.fill-icon {\n  fill: var(--theme-default);\n  transition: all 0.3s ease;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li:first-child {\n  display: none !important;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li > a {\n  display: block;\n  color: #2f2f3b;\n  line-height: 23px;\n  text-decoration: none;\n  text-transform: capitalize;\n  padding: 5px 15px;\n  margin: 0 3px;\n  letter-spacing: 0.04em;\n  position: relative;\n  border-radius: 5px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li > a.active {\n  background-color: rgb(85.3594771242%, 84%, 100%);\n  transition: all 0.3s ease;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li > a.active svg,\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li > a.active span {\n  color: var(--theme-default);\n  transition: all 0.3s ease;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li > a .badge {\n  position: absolute;\n  top: -5px;\n  margin-left: 1px;\n  right: 10px;\n  padding: 0.2em 0.7em;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li > a svg {\n  width: 18px;\n  height: 18px;\n  vertical-align: middle;\n  margin-right: 10px;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu {\n  position: fixed;\n  z-index: 4;\n  box-shadow: 0 0 1px 0 #898989;\n  padding: 15px 0px 15px 0px;\n  background: white;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li {\n  border: 0;\n  float: none;\n  position: relative;\n  display: block;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a {\n  background: transparent;\n  padding: 4px 30px;\n  display: block;\n  transition: all 0.5s ease;\n  line-height: 1.9;\n  color: rgba(43, 43, 43, 0.6);\n  letter-spacing: 0.06em;\n  font-weight: 500;\n  font-family: Roboto;\n  transition: all 0.3s ease;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a:after {\n  left: 20px;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a:hover {\n  color: var(--theme-default);\n  letter-spacing: 1.5px;\n  transition: all 0.3s ease;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a:hover:after {\n  background-color: var(--theme-default);\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container {\n  position: fixed;\n  right: 0;\n  left: 0;\n  margin: 0 auto;\n  z-index: 4;\n  box-shadow: 0 0 1px 0 #898989;\n  padding: 30px;\n  background: white;\n  width: 95%;\n  border-radius: 4px;\n  display: block !important;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box {\n  width: 20%;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title h5, .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title .h5 {\n  text-transform: uppercase;\n  font-size: 14px;\n  margin-left: -13px;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content {\n  box-shadow: none;\n  background-color: transparent;\n  position: relative;\n  display: block;\n  padding: 0;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content li {\n  border: 0;\n  float: none;\n  position: relative;\n  display: block;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content li a {\n  border: 0 !important;\n  background: transparent;\n  color: #2f2f3b;\n  border-radius: 0 !important;\n  text-transform: capitalize;\n  padding: 3px 0;\n  font-size: 13px;\n  display: block;\n  letter-spacing: 0.07em;\n  line-height: 1.9;\n  position: relative;\n  transition: all 0.3s ease;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content li a:hover {\n  color: var(--theme-default);\n  letter-spacing: 1.5px;\n  transition: all 0.3s ease;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content li a:hover:after {\n  color: var(--theme-default);\n  transition: all 0.3s ease;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content li a:after {\n  position: absolute;\n  content: \"\";\n  left: -12px;\n  top: 50%;\n  width: 5px;\n  height: 1px;\n  background-color: #59667a;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li:hover > a:after {\n  left: 0;\n  right: 0;\n  opacity: 1;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li.mega-menu {\n  position: unset;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper.overlay-white {\n  background-color: rgba(255, 255, 255, 0.08);\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .toggle-nav {\n  position: relative;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .toggle-nav i {\n  font-size: 24px;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .page-body {\n  margin-top: 135px;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-main-title {\n  display: none !important;\n}\n.page-wrapper.horizontal-wrapper .page-body-wrapper.scorlled .sidebar-wrapper {\n  display: none;\n  transition: all 0.3s ease;\n}\n.page-wrapper.horizontal-wrapper .page-header {\n  width: 100%;\n  box-shadow: none;\n}\n.page-wrapper.horizontal-wrapper .page-header .header-wrapper .form-control-plaintext {\n  width: auto !important;\n}\n.page-wrapper.horizontal-wrapper .page-header .header-wrapper .left-header {\n  width: 30%;\n}\n@media (max-width: 1428px) and (min-width: 1324px) {\n  .page-wrapper.horizontal-wrapper .page-header .header-wrapper .left-header {\n    width: 32%;\n  }\n}\n@media (max-width: 1323px) and (min-width: 1200px) {\n  .page-wrapper.horizontal-wrapper .page-header .header-wrapper .left-header {\n    width: 37%;\n  }\n}\n@media (max-width: 1199px) and (min-width: 992px) {\n  .page-wrapper.horizontal-wrapper .page-header .header-wrapper .left-header {\n    width: 32%;\n  }\n}\n@media (max-width: 1428px) and (min-width: 1324px) {\n  .page-wrapper.horizontal-wrapper .page-header .header-wrapper .nav-right {\n    width: 55%;\n  }\n}\n@media (max-width: 1323px) and (min-width: 1200px) {\n  .page-wrapper.horizontal-wrapper .page-header .header-wrapper .nav-right {\n    width: 40%;\n  }\n}\n@media (max-width: 1199px) and (min-width: 992px) {\n  .page-wrapper.horizontal-wrapper .page-header .header-wrapper .nav-right {\n    width: 50%;\n  }\n}\n.page-wrapper.horizontal-wrapper.enterprice-type footer {\n  margin-left: 0;\n}\n.page-wrapper.material-icon .card {\n  border-radius: 30px;\n  box-shadow: 0 0 20px rgba(115, 102, 255, 0.1);\n}\n.page-wrapper .sidebar-main-title h6, .page-wrapper .sidebar-main-title .h6 {\n  font-size: 14px;\n  font-weight: 600;\n  color: #52526c;\n  text-transform: uppercase;\n  margin-bottom: 0;\n  letter-spacing: 0.4px;\n}\n.page-wrapper.compact-wrapper .page-header {\n  margin-left: 265px;\n  width: calc(100% - 265px);\n}\n.page-wrapper.compact-wrapper .page-header.close_icon {\n  margin-left: 90px;\n  width: calc(100% - 90px);\n}\n.page-wrapper.compact-wrapper .page-header .header-wrapper .logo-wrapper {\n  display: none;\n}\n.page-wrapper.compact-wrapper .page-header .header-wrapper .toggle-sidebar {\n  display: none;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper {\n  position: fixed;\n  top: 0;\n  z-index: 9;\n  height: auto;\n  line-height: inherit;\n  background: #fff;\n  width: 265px;\n  text-align: left;\n  transition: 0.3s;\n  box-shadow: 0 0 21px 0 rgba(89, 102, 122, 0.1);\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .logo-wrapper,\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .logo-icon-wrapper {\n  padding: 27px 30px;\n  box-shadow: -9px 0 20px rgba(89, 102, 122, 0.1);\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .logo-icon-wrapper {\n  display: none;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon {\n  width: auto;\n  transition: all 0.3s ease;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon .badge {\n  opacity: 0;\n  width: 0;\n  padding: 0;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon .sidebar-main .sidebar-links > li {\n  max-width: 86px;\n  margin: 0;\n  transition: all 0.3s ease;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon .sidebar-main .sidebar-links > li .sidebar-submenu a {\n  display: none;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon .sidebar-main .sidebar-links > li a {\n  text-align: center;\n  padding: 12px 14px;\n  transition: all 0.3s ease;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon .sidebar-main-title {\n  display: none !important;\n  opacity: 0;\n  transition: all 0.3s ease;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon .logo-wrapper {\n  display: none;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon .logo-icon-wrapper {\n  text-align: right;\n  display: block;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon:hover {\n  width: 265px;\n  transition: all 0.3s ease;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon:hover .badge {\n  opacity: 1;\n  width: auto;\n  transition: all 0.3s ease;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon:hover .sidebar-main .sidebar-links > li {\n  max-width: unset;\n  margin: initial;\n  transition: all 0.3s ease;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon:hover .sidebar-main .sidebar-links > li a {\n  text-align: left;\n}\n[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon:hover .sidebar-main .sidebar-links > li a {\n  text-align: right;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon:hover .sidebar-main .sidebar-links > li .sidebar-submenu a {\n  display: block;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon:hover .sidebar-main .sidebar-links > li > a {\n  padding: 12px 15px;\n  transition: all 0.3s ease;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon:hover .sidebar-main .sidebar-links > li > a svg {\n  margin-right: 15px;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon:hover .sidebar-main .sidebar-links > li > a span {\n  display: inline-block;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon:hover .sidebar-main-title {\n  opacity: 1;\n  display: block !important;\n  transition: all 0.3s ease;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon:hover .logo-wrapper {\n  display: block;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon:hover .logo-icon-wrapper {\n  display: none;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon .mobile-sidebar {\n  transform: translate(183px);\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon ~ .page-body,\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon ~ footer {\n  margin-left: 90px;\n  transition: 0.5s;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon ~ .footer-fix {\n  width: calc(100% - 90px);\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon .sidebar-main .sidebar-links {\n  height: calc(100vh - 118px);\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon .sidebar-main .sidebar-links > li .sidebar-link::before {\n  right: 20px;\n  left: unset;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon .sidebar-main .sidebar-links > li a svg {\n  margin: 0;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon .sidebar-main .sidebar-links > li a span {\n  display: none;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon .sidebar-main .sidebar-links .sidebar-list .sidebar-title.active ~ .sidebar-submenu {\n  display: none;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon .according-menu {\n  display: none;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .left-arrow,\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .right-arrow {\n  display: none;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links {\n  height: calc(100vh - 115px);\n  left: -300px;\n  z-index: 99;\n  transition: color 1s ease;\n  overflow: auto;\n  color: rgba(0, 0, 0, 0);\n  margin-top: 20px;\n  margin-bottom: 30px;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a {\n  font-weight: 500;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a svg {\n  width: 18px;\n  height: 18px;\n  margin-right: 10px;\n  vertical-align: -2px;\n  float: none;\n  transition: all 0.3s ease;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a span {\n  letter-spacing: 0.7px;\n  text-transform: capitalize;\n  color: rgba(82, 82, 108, 0.8);\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a.link-nav .according-menu {\n  display: none;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li:last-child {\n  border-bottom: none;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links.opennav {\n  left: 0;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .back-btn {\n  display: block;\n  width: 100%;\n  padding: 0;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .back-btn .mobile-back {\n  padding: 20px;\n  color: #242934;\n  font-weight: 700;\n  text-transform: uppercase;\n  border-bottom: 1px solid #efefef;\n  cursor: pointer;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li {\n  display: block;\n  width: 100%;\n  position: relative;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li.sidebar-main-title {\n  padding: 25px 0 6px 20px;\n  margin-top: 10px;\n}\n[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li.sidebar-main-title {\n  padding: 25px 20px 6px 0;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li.sidebar-main-title::before {\n  position: absolute;\n  content: \"\";\n  top: 0;\n  left: 50%;\n  background: var(--sidebar-border);\n  width: calc(100% - 40px);\n  height: 1px;\n  transform: translateX(-50%);\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li.sidebar-main-title:nth-child(2) {\n  margin-top: 0;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li.sidebar-main-title:nth-child(2)::before {\n  display: none;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li.sidebar-list .badge {\n  position: absolute;\n  right: 50px;\n  top: 14.5px;\n  padding: 0.45em 0.8em 0.33em;\n  z-index: 1;\n  font-size: 10px;\n  letter-spacing: 0.7px;\n  font-weight: 600;\n  font-family: Roboto, sans-serif;\n  border-radius: 10px;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li.sidebar-list:hover > a:hover {\n  background-color: rgba(115, 102, 255, 0.07);\n  transition: all 0.3s ease;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li:hover .sidebar-link:not(.active):hover svg {\n  fill: rgba(115, 102, 255, 0.001);\n  stroke: var(--theme-default);\n  transition: all 0.3s ease;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li:hover .sidebar-link:not(.active):hover svg.fill-icon {\n  fill: var(--theme-default);\n  stroke: none;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li:hover .sidebar-link:not(.active):hover span {\n  color: var(--theme-default);\n  transition: all 0.3s ease;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li:hover .sidebar-link:not(.active):hover .according-menu i {\n  color: var(--theme-default);\n  transition: all 0.3s ease;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a {\n  padding: 12px 20px;\n  position: relative;\n  color: #222222;\n  transition: all 0.3s ease;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a .sub-arrow {\n  right: 20px;\n  position: absolute;\n  top: 10px;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a .sub-arrow i {\n  display: none;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a .sub-arrow:before {\n  display: none;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li:first-child {\n  display: none !important;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu {\n  width: 100%;\n  padding: 0;\n  position: relative !important;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu > li a {\n  padding-left: 48px !important;\n  font-weight: 400;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu .submenu-title .according-menu {\n  top: 7px;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu.opensubmenu {\n  display: block;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li:hover > a {\n  color: var(--theme-default);\n  transition: all 0.3s ease;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li .nav-sub-childmenu {\n  display: none;\n  position: relative !important;\n  right: 0;\n  width: 100%;\n  padding: 0;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li .nav-sub-childmenu.opensubchild {\n  display: block;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li .nav-sub-childmenu li a {\n  padding: 6px 45px;\n  padding-left: 56px !important;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li .nav-sub-childmenu li a:after {\n  display: none;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a {\n  padding: 7px 25px;\n  font-size: 14px;\n  color: rgba(47, 47, 59, 0.6);\n  display: block;\n  position: relative;\n  letter-spacing: 0.06em;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a.active {\n  color: var(--theme-default);\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a.active::before {\n  opacity: 1;\n  visibility: visible;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a:after {\n  left: 27px;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a:hover {\n  margin-left: 0;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container {\n  padding: 0;\n  position: relative;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container.opensubmenu {\n  display: block;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box {\n  width: 100%;\n  padding: 0;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section:hover h5, .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section:hover .h5 {\n  color: var(--theme-default) !important;\n  transition: all 0.3s ease;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title {\n  position: relative;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title h5, .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title .h5 {\n  margin-bottom: 0;\n  line-height: 1.9;\n  padding: 6px 25px 6px 45px;\n  font-size: 14px;\n  position: relative;\n  color: rgba(43, 43, 43, 0.6);\n  display: block;\n  letter-spacing: 0.06em;\n  font-weight: 500;\n  font-family: Roboto;\n  cursor: pointer;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title h5:after, .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title .h5:after {\n  left: 28px;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title.active h5, .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title.active .h5 {\n  color: var(--theme-default);\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title.active h5::before, .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title.active .h5::before {\n  opacity: 1;\n  visibility: visible;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title .according-menu {\n  top: 8px;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content.opensubmegamenu li a {\n  margin-bottom: 0;\n  line-height: 1.9;\n  padding: 6px 25px 6px 45px;\n  font-size: 14px;\n  position: relative;\n  color: rgba(43, 43, 43, 0.6);\n  display: block;\n  letter-spacing: 0.06em;\n  font-weight: 500;\n  font-family: Roboto;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content.opensubmegamenu li a:after {\n  display: none;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content.opensubmegamenu li a.active {\n  color: var(--theme-default);\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content ul li a {\n  line-height: 1.9;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content ul li a:hover {\n  margin-left: 0;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li.mega-menu .sidebar-title.active ~ .mega-menu-container {\n  display: block !important;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li.mega-menu .sidebar-title.active ~ .mega-menu-container::before {\n  height: calc(100% - 9px);\n  transition: height 0.5s;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link {\n  transition: all 0.5s ease;\n  display: block;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link::after {\n  position: absolute;\n  content: \"\";\n  width: 4px;\n  height: 35px;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  background-color: #7366ff;\n  border-radius: 5px 0px 0px 5px;\n  opacity: 0;\n  visibility: hidden;\n}\n[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link::after {\n  right: unset;\n  left: 0;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active {\n  transition: all 0.5s ease;\n  position: relative;\n  margin-bottom: 10px;\n  background-color: rgb(94.5098039216%, 94%, 100%);\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active::after {\n  opacity: 1;\n  visibility: visible;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active ~ .sidebar-submenu::before {\n  height: calc(100% - 8px);\n  transition: height 0.5s;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active .according-menu i {\n  color: var(--theme-default);\n}\n.page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active span {\n  color: var(--theme-default);\n  transition: all 0.3s ease;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper .mega-box.col {\n  flex-basis: unset;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper .according-menu {\n  position: absolute;\n  right: 20px;\n  top: 13px;\n  display: block;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper .according-menu i {\n  vertical-align: middle;\n  color: rgba(82, 82, 108, 0.8);\n  font-weight: 500;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper .main-menu.border-section {\n  border: none;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper .main-menu .menu-left .main-menu-right .toggle-nav {\n  position: absolute;\n  z-index: 2;\n  right: 145px;\n  top: 6px;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper .main-menu .menu-left .main-menu-right .toggle-nav .sidebar-name {\n  font-size: 18px;\n  padding-left: 5px;\n  text-transform: uppercase;\n}\n.page-wrapper.compact-wrapper .page-body-wrapper .page-body {\n  min-height: calc(100vh - 80px);\n  margin-top: 80px;\n  margin-left: 265px;\n}\n.page-wrapper.compact-wrapper.dark-sidebar .sidebar-main-title h6, .page-wrapper.compact-wrapper.dark-sidebar .sidebar-main-title .h6, .page-wrapper.compact-wrapper.color-sidebar .sidebar-main-title h6, .page-wrapper.compact-wrapper.color-sidebar .sidebar-main-title .h6 {\n  color: rgba(255, 255, 255, 0.6);\n}\n.page-wrapper.compact-wrapper.dark-sidebar .toggle-sidebar svg, .page-wrapper.compact-wrapper.color-sidebar .toggle-sidebar svg {\n  stroke: var(--theme-default);\n}\n.page-wrapper.compact-wrapper.dark-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a svg.stroke-icon, .page-wrapper.compact-wrapper.color-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a svg.stroke-icon {\n  stroke: rgba(255, 255, 255, 0.6);\n}\n.page-wrapper.compact-wrapper.dark-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a svg.fill-icon, .page-wrapper.compact-wrapper.color-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a svg.fill-icon {\n  fill: rgba(255, 255, 255, 0.6);\n}\n.page-wrapper.compact-wrapper.dark-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a.active svg.stroke-icon, .page-wrapper.compact-wrapper.color-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a.active svg.stroke-icon {\n  stroke: var(--theme-default);\n}\n.page-wrapper.compact-wrapper.dark-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a.active svg.fill-icon, .page-wrapper.compact-wrapper.color-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a.active svg.fill-icon {\n  fill: var(--theme-default);\n}\n.page-wrapper.compact-wrapper.dark-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li.sidebar-main-title::before, .page-wrapper.compact-wrapper.color-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li.sidebar-main-title::before {\n  background: #374558;\n}\n.page-wrapper.compact-wrapper.dark-sidebar div.sidebar-wrapper, .page-wrapper.compact-wrapper.color-sidebar div.sidebar-wrapper {\n  background-color: #262932;\n}\n.page-wrapper.compact-wrapper.dark-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links li a span, .page-wrapper.compact-wrapper.color-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links li a span {\n  color: rgba(255, 255, 255, 0.6);\n}\n.page-wrapper.compact-wrapper.dark-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links li a svg.stroke-icon, .page-wrapper.compact-wrapper.color-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links li a svg.stroke-icon {\n  stroke: rgba(255, 255, 255, 0.6);\n}\n.page-wrapper.compact-wrapper.dark-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links li a svg.fill-icon, .page-wrapper.compact-wrapper.color-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links li a svg.fill-icon {\n  fill: rgba(255, 255, 255, 0.6);\n}\n.page-wrapper.compact-wrapper.dark-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title h5, .page-wrapper.compact-wrapper.dark-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title .h5, .page-wrapper.compact-wrapper.color-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title h5, .page-wrapper.compact-wrapper.color-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title .h5 {\n  color: rgba(255, 255, 255, 0.6);\n}\n.page-wrapper.compact-wrapper.dark-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content.opensubmegamenu li a, .page-wrapper.compact-wrapper.color-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content.opensubmegamenu li a {\n  color: rgba(255, 255, 255, 0.6);\n  font-weight: 400;\n}\n.page-wrapper.compact-wrapper.dark-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container::after, .page-wrapper.compact-wrapper.color-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container::after {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n.page-wrapper.compact-wrapper.dark-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active, .page-wrapper.compact-wrapper.color-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active {\n  background-color: rgba(115, 102, 255, 0.2);\n}\n.page-wrapper.compact-wrapper.dark-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active svg, .page-wrapper.compact-wrapper.color-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active svg {\n  color: var(--theme-default);\n  stroke: var(--theme-default);\n}\n.page-wrapper.compact-wrapper.dark-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a, .page-wrapper.compact-wrapper.color-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a {\n  color: rgba(255, 255, 255, 0.6);\n}\n.page-wrapper.compact-wrapper.dark-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list ul.sidebar-submenu li a span, .page-wrapper.compact-wrapper.color-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list ul.sidebar-submenu li a span {\n  color: rgba(255, 255, 255, 0.6);\n}\n.page-wrapper.compact-wrapper.dark-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list ul.sidebar-submenu li a.active, .page-wrapper.compact-wrapper.color-sidebar div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list ul.sidebar-submenu li a.active {\n  color: var(--theme-default);\n}\n.page-wrapper.compact-wrapper.dark-sidebar div.sidebar-wrapper .logo-wrapper .for-light, .page-wrapper.compact-wrapper.color-sidebar div.sidebar-wrapper .logo-wrapper .for-light {\n  display: none;\n}\n.page-wrapper.compact-wrapper.dark-sidebar div.sidebar-wrapper .logo-wrapper .for-dark, .page-wrapper.compact-wrapper.color-sidebar div.sidebar-wrapper .logo-wrapper .for-dark {\n  display: block;\n}\n.page-wrapper.compact-wrapper.dark-sidebar .according-menu i, .page-wrapper.compact-wrapper.color-sidebar .according-menu i {\n  color: rgba(255, 255, 255, 0.6);\n}\n.page-wrapper.compact-wrapper.color-sidebar div.sidebar-wrapper {\n  background-color: #2f3c4e;\n}\n.page-wrapper.compact-sidebar ~ .bg-overlay1 {\n  transition: 0.8s;\n}\n.page-wrapper.compact-sidebar ~ .bg-overlay1.active {\n  z-index: 8;\n  height: 100vh;\n  width: 100vw;\n  background-color: rgba(0, 0, 0, 0.2);\n  position: fixed;\n  top: 0;\n}\n.page-wrapper.compact-sidebar .toggle-sidebar {\n  position: relative;\n  right: unset;\n  top: unset;\n  margin-right: 15px;\n}\n.page-wrapper.compact-sidebar .sidebar-main-title {\n  display: none;\n}\n.page-wrapper.compact-sidebar .logo-wrapper {\n  display: none;\n}\n.page-wrapper.compact-sidebar .logo-icon-wrapper {\n  display: block;\n  text-align: center;\n  padding: 24px 30px;\n  box-shadow: -9px 0 20px rgba(89, 102, 122, 0.1);\n}\n.page-wrapper.compact-sidebar .page-header {\n  margin-left: 150px;\n  width: calc(100% - 150px);\n}\n.page-wrapper.compact-sidebar .page-header .header-wrapper .logo-wrapper {\n  display: none;\n}\n.page-wrapper.compact-sidebar .page-header .header-wrapper .left-header {\n  width: 30%;\n}\n@media (max-width: 1578px) and (min-width: 1274px) {\n  .page-wrapper.compact-sidebar .page-header .header-wrapper .left-header {\n    width: 38%;\n  }\n}\n@media (max-width: 1273px) and (min-width: 1200px) {\n  .page-wrapper.compact-sidebar .page-header .header-wrapper .left-header {\n    width: 45%;\n  }\n}\n@media (max-width: 991px) and (min-width: 768px) {\n  .page-wrapper.compact-sidebar .page-header .header-wrapper .left-header {\n    width: 36%;\n  }\n}\n@media (max-width: 767px) and (min-width: 756px) {\n  .page-wrapper.compact-sidebar .page-header .header-wrapper .left-header {\n    width: 28%;\n  }\n}\n@media (max-width: 1199px) {\n  .page-wrapper.compact-sidebar .page-header .header-wrapper .left-header h6, .page-wrapper.compact-sidebar .page-header .header-wrapper .left-header .h6 {\n    width: 132px;\n  }\n}\n@media (max-width: 767px) {\n  .page-wrapper.compact-sidebar .page-header .header-wrapper .left-header h6, .page-wrapper.compact-sidebar .page-header .header-wrapper .left-header .h6 {\n    width: 83px;\n  }\n}\n.page-wrapper.compact-sidebar .page-header.close_icon {\n  margin-left: 0;\n  width: calc(100% - 0px);\n}\n.page-wrapper.compact-sidebar .page-body-wrapper .page-body {\n  margin-top: 80px;\n  margin-left: 150px;\n}\n.page-wrapper.compact-sidebar .page-body-wrapper .footer {\n  margin-left: 150px;\n}\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper {\n  position: fixed;\n  top: 0;\n  z-index: 9;\n  background-color: #fff;\n}\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper > div {\n  height: auto;\n  line-height: inherit;\n  background: #fff;\n  width: 150px;\n  text-align: center;\n  transition: 0.3s;\n  box-shadow: 0 0 21px 0 rgba(89, 102, 122, 0.1);\n}\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .left-arrow,\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .right-arrow {\n  display: none;\n}\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links {\n  margin: 30px 0;\n  height: calc(100vh - 113px);\n  overflow: auto;\n}\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a {\n  color: #2c323f;\n}\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a span {\n  text-transform: capitalize;\n  color: #2c323f;\n  font-weight: 500;\n  letter-spacing: 1px;\n  font-size: 14px;\n}\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a.active {\n  background: rgba(115, 102, 255, 0.1);\n  color: #7366ff;\n  border-radius: 20px;\n  margin: 0 10px;\n}\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a.active span {\n  color: #7366ff;\n}\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a.active ~ .sidebar-submenu,\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a.active ~ .mega-menu-container {\n  animation: fadeInLeft 300ms ease-in-out;\n}\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-title {\n  display: block;\n  padding: 20px 0;\n  border-bottom: 1px solid #f3f3f3;\n}\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu,\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container {\n  position: fixed;\n  top: 0px;\n  height: calc(100vh - 0px);\n  overflow: auto;\n  left: 150px;\n  width: 230px;\n  background-color: #fff;\n  box-shadow: 0 16px 15px 15px rgba(126, 55, 216, 0.03);\n  transition: all 0.5s ease-in-out;\n  display: none;\n  padding-top: 20px;\n  z-index: -1;\n}\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu li a,\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container li a {\n  padding: 15px 15px 15px 40px;\n  display: block;\n  position: relative;\n  border-bottom: 1px solid #f1f1f1;\n}\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu li a .sub-arrow,\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container li a .sub-arrow {\n  display: none;\n}\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu li a .according-menu,\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container li a .according-menu {\n  position: absolute;\n  right: 20px;\n  top: 16px;\n}\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu li a.active,\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container li a.active {\n  background-color: rgba(115, 102, 255, 0.1);\n  color: #7366ff;\n  transition: all 0.3s ease;\n}\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu li .submenu-content li a.active,\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container li .submenu-content li a.active {\n  background-color: transparent;\n}\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu > li > a::after,\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container > li > a::after {\n  position: absolute;\n  content: \"\";\n  left: 20px;\n  top: 48%;\n  width: 8px;\n  border-top: 2px solid rgba(82, 82, 108, 0.4);\n}\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu .mega-box,\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container .mega-box {\n  flex: 0 0 100%;\n  max-width: 100%;\n  padding: 0;\n}\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu .mega-box .link-section,\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container .mega-box .link-section {\n  text-align: left;\n}\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu .mega-box .link-section .submenu-title h5, .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu .mega-box .link-section .submenu-title .h5,\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container .mega-box .link-section .submenu-title h5,\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container .mega-box .link-section .submenu-title .h5 {\n  position: relative;\n  font-size: 14px;\n  font-weight: 400;\n  padding: 15px 15px 15px 40px;\n  letter-spacing: 1px;\n  margin-bottom: 0;\n}\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu .mega-box .link-section .submenu-title h5::after, .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu .mega-box .link-section .submenu-title .h5::after,\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container .mega-box .link-section .submenu-title h5::after,\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container .mega-box .link-section .submenu-title .h5::after {\n  position: absolute;\n  content: \"\";\n  left: 20px;\n  top: 48%;\n  width: 6px;\n  border-top: 2px solid #595c60;\n}\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li:hover .sidebar-submenu {\n  display: block !important;\n}\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list {\n  position: relative;\n}\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list .badge {\n  position: absolute;\n  left: 53%;\n  top: 7px;\n  font-weight: 500;\n  font-size: 9px;\n}\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list .sidebar-link {\n  text-align: center;\n}\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list .sidebar-link svg {\n  margin: 0 auto 6px;\n  width: 24px;\n  height: 24px;\n}\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list .sidebar-link > span {\n  display: block;\n  font-weight: 500;\n  letter-spacing: 1px;\n  font-size: 14px;\n  word-break: break-word;\n}\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list .sidebar-link .according-menu {\n  display: none;\n}\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .mega-menu {\n  text-align: center;\n  padding: 0;\n}\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .mega-menu svg {\n  width: 24px;\n  height: 24px;\n}\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .mega-menu .according-menu {\n  position: absolute;\n  right: 20px;\n  top: 13px;\n}\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper[sidebar-layout=stroke-svg] .sidebar-links .mega-menu svg.stroke-icon {\n  display: block;\n  margin: 0 auto 6px;\n}\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper[sidebar-layout=stroke-svg] .sidebar-links .mega-menu svg.fill-icon {\n  display: none;\n}\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper[sidebar-layout=fill-svg] .sidebar-links .mega-menu svg.stroke-icon {\n  display: none;\n}\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper[sidebar-layout=fill-svg] .sidebar-links .mega-menu svg.fill-icon {\n  display: block;\n  margin: 0 auto 6px;\n}\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper.close_icon {\n  transform: translateX(-150px);\n}\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper.close_icon ~ .page-body,\n.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper.close_icon ~ .footer {\n  margin-left: 0px;\n}\n.page-wrapper.compact-small .toggle-sidebar {\n  position: relative;\n  right: unset;\n  top: unset;\n  margin-right: 15px;\n}\n.page-wrapper.compact-small .sidebar-main-title,\n.page-wrapper.compact-small .logo-wrapper {\n  display: none;\n}\n.page-wrapper.compact-small .logo-icon-wrapper {\n  display: block;\n  text-align: center;\n  padding: 27px 30px;\n  box-shadow: -9px 0 20px rgba(89, 102, 122, 0.1);\n}\n.page-wrapper.compact-small .page-header {\n  margin-left: 90px;\n  width: calc(100% - 90px);\n}\n.page-wrapper.compact-small .page-header .header-wrapper .logo-wrapper {\n  display: none;\n}\n.page-wrapper.compact-small .page-header.close_icon {\n  margin-left: 0;\n  width: calc(100% - 0px);\n}\n.page-wrapper.compact-small .page-body-wrapper .page-body {\n  margin-left: 90px;\n}\n.page-wrapper.compact-small .page-body-wrapper .footer {\n  margin-left: 90px;\n}\n.page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper > div {\n  width: 90px;\n}\n@media (max-width: 420px) {\n  .page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links {\n    height: calc(100vh - 105px);\n  }\n}\n.page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-title {\n  display: block;\n  padding: 15px 0;\n}\n.page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu,\n.page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container {\n  left: 90px;\n}\n.page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu li a,\n.page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container li a {\n  padding: 10px 15px 10px 40px;\n}\n.page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu li a .sub-arrow,\n.page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container li a .sub-arrow {\n  display: none;\n}\n.page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu li a .according-menu,\n.page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container li a .according-menu {\n  top: 11px;\n}\n.page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list .badge {\n  display: none;\n}\n.page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list .sidebar-link svg {\n  margin: 0 auto;\n  width: 20px;\n  height: 20px;\n}\n.page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list .sidebar-link > span {\n  display: none;\n}\n.page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .mega-menu svg {\n  margin: 0 auto;\n}\n.page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .mega-menu a > span {\n  display: none;\n}\n.page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper.close_icon {\n  transform: translateX(-150px);\n}\n.page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper.close_icon ~ .page-body,\n.page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper.close_icon ~ .footer {\n  margin-left: 0px;\n}\n.page-wrapper.only-body {\n  background-color: #f2f0fa;\n}\n.page-wrapper.only-body .page-body-wrapper {\n  background-color: #f2f0fa;\n}\n.page-wrapper.only-body .page-header {\n  position: relative;\n}\n.page-wrapper.only-body .page-header .header-logo-wrapper {\n  display: none;\n}\n.page-wrapper.only-body .page-header .header-wrapper {\n  padding: 0 !important;\n}\n.page-wrapper.only-body .page-header .header-wrapper .left-header {\n  display: none;\n}\n.page-wrapper.only-body .page-header .header-wrapper .nav-right {\n  position: absolute;\n  right: 60px;\n  top: 58px;\n}\n.page-wrapper.only-body .page-header .header-wrapper .search-full {\n  top: 37px;\n  width: calc(100% - 50px);\n  left: 25px;\n}\n[dir=rtl] .page-wrapper.only-body .page-header .header-wrapper .search-full {\n  left: unset;\n  right: 25px;\n}\n.page-wrapper.only-body .page-header .header-wrapper .search-full .form-group .Typeahead .u-posRelative {\n  background-color: #fff;\n  border-radius: 15px;\n}\n.page-wrapper.only-body .page-header .header-wrapper .search-full .Typeahead-menu {\n  top: 78px;\n  width: calc(100% - 30px);\n  margin: 0 auto;\n  right: 0;\n}\n.page-wrapper.only-body .page-body-wrapper .page-title {\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n.page-wrapper.only-body .sidebar-wrapper,\n.page-wrapper.only-body footer {\n  display: none;\n}\n.page-wrapper.only-body .page-body-wrapper .page-body {\n  margin-top: 0px;\n  min-height: calc(100vh - 0px);\n}\n.page-wrapper.only-body .page-body-wrapper .page-title {\n  padding-left: 30px;\n  padding-right: 30px;\n  margin: 30px 0;\n  border-radius: 15px;\n}\n@media (max-width: 991.98px) {\n  .page-wrapper.only-body .page-body-wrapper .page-title {\n    padding-left: 20px;\n    padding-right: 20px;\n    margin: 20px 0;\n  }\n}\n.page-wrapper.only-body .page-body-wrapper .page-title > .row .col-6 {\n  flex: 0 0 100%;\n  max-width: 100%;\n}\n.page-wrapper.only-body .page-body-wrapper .page-title .breadcrumb {\n  margin-top: 5px;\n  justify-content: flex-start;\n}\n.page-wrapper.modern-type .progress-chart-wrap {\n  margin-left: -22px;\n}\n[dir=rtl] .page-wrapper.modern-type .progress-chart-wrap {\n  margin-left: unset;\n  margin-right: -22px;\n}\n.page-wrapper.modern-type .ecommerce-widget {\n  border: 1px solid rgb(85.3594771242%, 84%, 100%) !important;\n}\n.page-wrapper.modern-type .file-sidebar .pricing-plan {\n  border: 1px solid rgb(85.3594771242%, 84%, 100%) !important;\n}\n.page-wrapper.modern-type .alert-primary {\n  color: #7366ff;\n}\n.page-wrapper.modern-type .project-box {\n  background-color: rgb(85.3594771242%, 84%, 100%);\n}\n.page-wrapper.modern-type .nav-tabs .nav-link.active {\n  background-color: transparent;\n}\n.page-wrapper.modern-type .simplebar-mask {\n  top: 10px;\n}\n.page-wrapper.modern-type .page-header {\n  margin-left: 0px;\n  width: calc(100% - 0px);\n}\n.page-wrapper.modern-type .page-header.close_icon {\n  margin-left: 0px;\n  width: calc(100% - 0px);\n}\n.page-wrapper.modern-type .page-header .header-wrapper .left-header {\n  width: 30%;\n}\n@media (max-width: 1428px) and (min-width: 1200px) {\n  .page-wrapper.modern-type .page-header .header-wrapper .left-header {\n    width: 37%;\n  }\n}\n@media (max-width: 818px) {\n  .page-wrapper.modern-type .page-header .header-wrapper .left-header {\n    width: 36%;\n  }\n}\n@media (max-width: 1669px) {\n  .page-wrapper.modern-type .page-header .header-wrapper .nav-right {\n    width: 50%;\n  }\n}\n@media (max-width: 1428px) and (min-width: 1200px) {\n  .page-wrapper.modern-type .page-header .header-wrapper .nav-right {\n    width: 40%;\n  }\n}\n.page-wrapper.modern-type .page-header .header-wrapper .header-logo-wrapper {\n  display: flex;\n  align-items: center;\n}\n.page-wrapper.modern-type .page-header .header-wrapper .logo-wrapper {\n  display: block;\n  margin-right: 30px;\n}\n.page-wrapper.modern-type .page-header .header-wrapper .toggle-sidebar {\n  display: block;\n  position: relative;\n  top: unset;\n  right: unset;\n  margin-right: 15px;\n}\n.page-wrapper.modern-type .page-body-wrapper .page-title {\n  background-color: transparent;\n  padding-bottom: 0;\n}\n.page-wrapper.modern-type .page-body-wrapper div.sidebar-wrapper {\n  margin: 30px !important;\n  top: 80px;\n  bottom: 0;\n  border-radius: 15px;\n}\n.page-wrapper.modern-type .page-body-wrapper div.sidebar-wrapper .logo-wrapper,\n.page-wrapper.modern-type .page-body-wrapper div.sidebar-wrapper .logo-icon-wrapper {\n  display: none;\n}\n.page-wrapper.modern-type .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links {\n  height: calc(100vh - 160px);\n}\n.page-wrapper.modern-type .page-body-wrapper div.sidebar-wrapper.close_icon .logo-icon-wrapper {\n  display: none;\n}\n.page-wrapper.modern-type .page-body-wrapper div.sidebar-wrapper.close_icon ~ .page-body {\n  margin-left: 0px;\n}\n.page-wrapper.modern-type .page-body-wrapper div.sidebar-wrapper.close_icon ~ footer {\n  margin-left: 0px;\n  margin-right: 0px;\n}\n.page-wrapper.modern-type .page-body-wrapper div.sidebar-wrapper.close_icon:hover .logo-wrapper {\n  display: none;\n}\n.page-wrapper.modern-type .page-body-wrapper .page-body {\n  margin-left: 296px;\n}\n.page-wrapper.modern-type .page-body-wrapper .page-body .container-fluid, .page-wrapper.modern-type .page-body-wrapper .page-body .container-sm, .page-wrapper.modern-type .page-body-wrapper .page-body .container-md, .page-wrapper.modern-type .page-body-wrapper .page-body .container-lg, .page-wrapper.modern-type .page-body-wrapper .page-body .container-xl, .page-wrapper.modern-type .page-body-wrapper .page-body .container-xxl {\n  max-width: 1500px;\n}\n.page-wrapper.modern-type .page-body-wrapper .footer {\n  margin-left: 360px;\n  margin-right: 70px;\n  border-radius: 10px;\n}\n@media (max-width: 991px) {\n  .page-wrapper.modern-type .page-body-wrapper .footer {\n    margin-right: 0;\n    margin-left: 0;\n  }\n}\n.page-wrapper.material-type {\n  position: relative;\n}\n.page-wrapper.material-type::before {\n  position: absolute;\n  content: \"\";\n  left: 0;\n  top: -50px;\n  width: 100%;\n  height: 300px;\n  background-image: linear-gradient(103.75deg, #33b1ee -13.9%, var(--theme-default) 79.68%);\n}\n.page-wrapper.material-type .card {\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);\n}\n.page-wrapper.material-type .page-header {\n  position: relative;\n  max-width: 1560px;\n  margin: 50px auto 0;\n  border-radius: 15px 15px 0 0;\n}\n.page-wrapper.material-type .page-header .header-wrapper .left-header {\n  width: 31%;\n}\n@media (max-width: 1600px) {\n  .page-wrapper.material-type .page-header .header-wrapper .left-header {\n    width: 33%;\n  }\n}\n@media (max-width: 1366px) {\n  .page-wrapper.material-type .page-header .header-wrapper .left-header {\n    width: 38%;\n  }\n}\n@media (max-width: 1199px) {\n  .page-wrapper.material-type .page-header .header-wrapper .left-header {\n    width: 30%;\n  }\n}\n@media (max-width: 1600px) {\n  .page-wrapper.material-type .page-header .header-wrapper .nav-right {\n    width: 40%;\n  }\n}\n@media (max-width: 1199px) {\n  .page-wrapper.material-type .page-header .header-wrapper .nav-right {\n    width: 45%;\n  }\n}\n.page-wrapper.material-type .page-body-wrapper {\n  background-image: url(../../images/other-images/boxbg.jpg);\n  background-blend-mode: overlay;\n  background-color: rgba(255, 255, 255, 0.5);\n}\n.page-wrapper.material-type .page-body-wrapper .sidebar-wrapper {\n  position: relative;\n  max-width: 1560px;\n  margin: 0 auto;\n  top: unset;\n  height: 56px;\n}\n.page-wrapper.material-type .page-body-wrapper .page-body {\n  margin: 0 auto;\n  max-width: 1560px;\n  background-color: #f8f8f8;\n  box-shadow: 0 0 20px 7px rgba(8, 21, 66, 0.05);\n  border-radius: 0 0 15px 15px;\n}\n.page-wrapper.material-type .footer {\n  margin-top: 40px;\n}\n.page-wrapper.material-type.compact-wrapper .page-header .header-wrapper .left-header {\n  width: 38%;\n}\n@media (max-width: 991px) {\n  .page-wrapper.material-type.compact-wrapper .page-header .header-wrapper .nav-right {\n    width: 50%;\n  }\n}\n.page-wrapper.advance-layout {\n  background-blend-mode: overlay;\n  background-color: #f7f8f9;\n}\n.page-wrapper.advance-layout .card {\n  border-radius: 5px;\n  box-shadow: none;\n  border: 1px solid #ecf3fa;\n}\n.page-wrapper.advance-layout .page-header {\n  position: relative;\n  background-color: #fff;\n  margin: 0 auto;\n}\n.page-wrapper.advance-layout .page-body-wrapper {\n  background: transparent;\n}\n.page-wrapper.advance-layout .page-body-wrapper .sidebar-wrapper {\n  position: relative !important;\n  top: unset !important;\n  height: unset;\n  box-shadow: none;\n  border-top: 1px solid #efefef;\n  border-bottom: 1px solid #efefef;\n}\n.page-wrapper.advance-layout .page-body-wrapper .sidebar-wrapper > div {\n  overflow-x: hidden;\n}\n.page-wrapper.advance-layout .page-body-wrapper .page-body {\n  margin-top: 0 !important;\n}\n\n@keyframes pagebody {\n  from {\n    opacity: 0;\n    transform: scale3d(0.98, 0.98, 0.98) translate(-20px, -50px);\n  }\n  50% {\n    opacity: 1;\n  }\n}\n.md-sidebar {\n  position: relative;\n}\n.md-sidebar .md-sidebar-toggle {\n  display: none;\n  width: fit-content;\n  text-transform: capitalize;\n  margin-bottom: 20px;\n}\n\n@media screen and (max-width: 1480px) {\n  .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container {\n    right: -18%;\n    width: 91%;\n  }\n}\n@media screen and (max-width: 1460px) {\n  .page-wrapper.horizontal-wrapper .page-body-wrapper.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container {\n    right: -54%;\n    width: 75%;\n  }\n  .sidebar-wrapper .sidebar-main .sidebar-links > li {\n    margin-right: 8px;\n  }\n}\n@media screen and (max-width: 1366px) {\n  .page-wrapper.horizontal-wrapper .page-body-wrapper.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container {\n    right: -49%;\n    width: 70%;\n  }\n  .profile-dropdown.onhover-show-div {\n    right: 0;\n    left: unset !important;\n  }\n  .profile-dropdown.onhover-show-div:before, .profile-dropdown.onhover-show-div:after {\n    right: 10px !important;\n    left: unset !important;\n  }\n}\n@media screen and (max-width: 1199px) {\n  .page-wrapper .page-header .header-wrapper .nav-right > ul > li {\n    padding: 6px;\n  }\n  .mobile-title.d-none {\n    display: flex !important;\n    justify-content: space-between;\n    padding: 20px 30px 17px;\n    border-bottom: 1px solid #ddd;\n    margin: 0 -15px;\n  }\n  .mobile-title.d-none h5, .mobile-title.d-none .h5 {\n    color: var(--theme-default);\n  }\n  .mobile-title.d-none svg {\n    stroke: var(--theme-default) !important;\n  }\n  .page-wrapper.horizontal-wrapper .page-body-wrapper.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container {\n    right: -35%;\n    width: 56%;\n  }\n}\n@media screen and (min-width: 992px) {\n  .page-header .header-wrapper .nav-right .notification-dropdown {\n    top: 46px;\n  }\n  .responsive-btn {\n    display: none;\n  }\n  .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-main .sidebar-links .simplebar-mask {\n    top: 0;\n  }\n  .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu {\n    width: 200px;\n    opacity: 0;\n    visibility: hidden;\n    border-radius: 5px;\n    transition: all 0.5s ease;\n  }\n  .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu a .sub-arrow {\n    position: absolute;\n    right: 20px;\n    top: 5px;\n    color: #59667a;\n    font-weight: 100;\n    transition: all 0.5s ease;\n    font-size: 15px;\n    top: 5px;\n  }\n  .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li .nav-sub-childmenu {\n    display: none;\n    border-radius: 4px;\n  }\n  .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li:hover .nav-sub-childmenu {\n    display: block !important;\n    position: absolute;\n    left: 200px;\n    background-color: #fff;\n    top: -10px;\n    padding: 15px 0px 15px 0px;\n    box-shadow: 0 0 1px 0 #898989;\n  }\n  .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a:hover .sub-arrow {\n    right: 16px;\n    transition: all 0.5s ease;\n  }\n  .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-main .sidebar-links > li .mega-menu-container {\n    opacity: 0;\n    visibility: hidden;\n    transition: all 0.5s ease;\n  }\n  .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-main .sidebar-links > li.hoverd .sidebar-submenu {\n    opacity: 1;\n    visibility: visible;\n    margin-top: 8px;\n    transition: all 0.5s ease;\n  }\n  .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-main .sidebar-links > li:hover .mega-menu-container {\n    opacity: 1;\n    visibility: visible;\n    margin-top: 20px;\n    transition: all 0.5s ease;\n  }\n  .page-wrapper.horizontal-wrapper .page-body-wrapper .toggle-nav {\n    display: none;\n  }\n  .page-wrapper.horizontal-wrapper .page-body-wrapper .mobile-back {\n    display: none !important;\n  }\n}\n@media only screen and (min-width: 768px) {\n  .page-wrapper.material-icon {\n    position: relative;\n  }\n  .page-wrapper.material-icon::before {\n    position: absolute;\n    content: \"\";\n    left: 0;\n    width: 100%;\n    height: 200px;\n    background: linear-gradient(103.75deg, #33b1ee -13.9%, var(--theme-default) 79.68%);\n  }\n  .page-wrapper.material-icon .toggle-sidebar {\n    color: rgba(255, 255, 255, 0.8);\n  }\n  .page-wrapper.material-icon .toggle-sidebar:hover > svg {\n    color: #fff !important;\n    stroke: #fff !important;\n  }\n  .page-wrapper.material-icon .page-header {\n    position: relative;\n    background: transparent;\n    padding-left: 90px;\n    max-width: 1660px;\n    margin: 0 auto;\n    width: calc(100% - 0px);\n    box-shadow: none;\n  }\n  .page-wrapper.material-icon .page-header .f-light {\n    color: #fff;\n  }\n  .page-wrapper.material-icon .page-header .header-wrapper .nav-right ul li svg {\n    stroke: #fff;\n  }\n  .page-wrapper.material-icon .page-header .header-wrapper .nav-right ul li .profile-dropdown li svg {\n    stroke: #2f2f3b;\n  }\n  .page-wrapper.material-icon .page-header .header-wrapper .nav-right > ul > li {\n    color: #fff;\n  }\n  .page-wrapper.material-icon .page-header .header-wrapper .nav-right > ul > li .notification-box svg,\n  .page-wrapper.material-icon .page-header .header-wrapper .nav-right > ul > li .cart-box svg {\n    stroke: #fff;\n  }\n  .page-wrapper.material-icon .page-header .header-wrapper .nav-right > ul > li > a > svg {\n    stroke: #fff;\n  }\n  .page-wrapper.material-icon .page-header .header-wrapper .nav-right > ul > li > svg {\n    stroke: #fff;\n  }\n  .page-wrapper.material-icon .page-header .header-wrapper .nav-right .language-nav .more_lang {\n    color: #2f2f3b;\n  }\n  .page-wrapper.material-icon .page-header .header-wrapper .nav-right .onhover-show-div {\n    color: #2f2f3b;\n  }\n  .page-wrapper.material-icon .page-header .header-wrapper .nav-right.right-header ul li .profile-media .media-body p {\n    color: rgba(255, 255, 255, 0.7);\n  }\n  .page-wrapper.material-icon .page-header.close_icon {\n    padding-left: 0;\n    margin: 0 auto !important;\n  }\n  .page-wrapper.material-icon .page-body-wrapper .page-body {\n    margin-top: 0 !important;\n    padding-left: 90px;\n    max-width: 1660px;\n    margin: 0 auto;\n  }\n  .page-wrapper.material-icon .page-body-wrapper div.sidebar-wrapper.close_icon ~ .page-body {\n    padding-left: 15px;\n    margin: 0 auto !important;\n  }\n  .page-wrapper.material-icon .page-body-wrapper .page-title {\n    color: #fff;\n    background-color: transparent;\n    border-bottom: none;\n    box-shadow: none;\n  }\n  .page-wrapper.material-icon .page-body-wrapper .page-title .breadcrumb .breadcrumb-item a svg {\n    stroke: #fff;\n  }\n  .page-wrapper.material-icon .page-body-wrapper .page-title .breadcrumb .breadcrumb-item.active {\n    color: rgba(255, 255, 255, 0.6);\n  }\n  .page-wrapper.material-icon .page-body-wrapper .page-title .breadcrumb .breadcrumb-item + .breadcrumb-item::before {\n    color: rgba(255, 255, 255, 0.8);\n  }\n}\n@media only screen and (min-width: 992px) {\n  .page-wrapper.material-icon::before {\n    height: 240px;\n  }\n}\n@media screen and (max-width: 767px) {\n  .sidebar-wrapper .menu .brand-logo img {\n    width: 120px;\n  }\n}\n@media screen and (max-width: 576px) {\n  .toggle-nav i {\n    font-size: 20px;\n  }\n}\n.page-wrapper[sidebar-layout=stroke-svg] .sidebar-wrapper .stroke-icon,\n.page-wrapper[sidebar-layout=stroke-svg] .page-header .stroke-icon {\n  display: inline-block;\n}\n.page-wrapper[sidebar-layout=stroke-svg] .sidebar-wrapper .fill-icon,\n.page-wrapper[sidebar-layout=stroke-svg] .page-header .fill-icon {\n  display: none;\n}\n.page-wrapper[sidebar-layout=fill-svg] .sidebar-wrapper .stroke-icon,\n.page-wrapper[sidebar-layout=fill-svg] .page-header .stroke-icon {\n  display: none;\n}\n.page-wrapper[sidebar-layout=fill-svg] .sidebar-wrapper .fill-icon,\n.page-wrapper[sidebar-layout=fill-svg] .page-header .fill-icon {\n  display: inline-block;\n}\n\n/**=====================\n    78. Sidebar CSS Ends\n==========================**/\n/**=====================\n    60. RTL CSS Start\n==========================**/\nhtml[dir=rtl] ul {\n  padding-right: 0;\n}\nhtml[dir=rtl] .location-checkbox span {\n  padding-left: 0;\n  padding-right: 33px;\n}\nhtml[dir=rtl] .border-end {\n  border-left: 1px solid var(--chart-border) !important;\n  border-right: initial !important;\n}\nhtml[dir=rtl] .follow .text-md-end {\n  text-align: left !important;\n}\nhtml[dir=rtl] .ms-auto {\n  margin-left: unset !important;\n  margin-right: auto !important;\n}\nhtml[dir=rtl] .f-right {\n  float: left;\n}\nhtml[dir=rtl] .papernote-wrap .note-labels ul {\n  gap: 9px;\n}\nhtml[dir=rtl] .form-check-inline {\n  margin-right: unset;\n  margin-left: 1rem;\n}\nhtml[dir=rtl] .color-box button + button {\n  margin-left: unset;\n  margin-right: 5px;\n}\nhtml[dir=rtl] .knowledgebase-search .form-inline svg {\n  left: unset;\n  right: 20px;\n}\nhtml[dir=rtl] .switch-showcase .form-check .form-check-input {\n  float: left;\n}\nhtml[dir=rtl] .pill-input-group span:last-child {\n  border-top-right-radius: unset !important;\n  border-bottom-right-radius: unset !important;\n  border-top-left-radius: 1.3rem !important;\n  border-bottom-left-radius: 1.3rem !important;\n}\nhtml[dir=rtl] .pill-input-group span:first-child {\n  border-top-left-radius: unset !important;\n  border-top-right-radius: unset !important;\n  border-top-right-radius: 1.3rem !important;\n  border-bottom-right-radius: 1.3rem !important;\n}\nhtml[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper {\n  text-align: right;\n}\nhtml[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper .toggle-sidebar {\n  right: unset;\n  left: 30px;\n}\nhtml[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links {\n  padding: 0;\n}\nhtml[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .badge {\n  left: 50px !important;\n  right: unset !important;\n}\nhtml[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper.close_icon {\n  margin-right: 0;\n  margin-left: unset;\n}\nhtml[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper.close_icon .logo-icon-wrapper {\n  text-align: left;\n}\nhtml[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper.close_icon .logo-icon-wrapper img {\n  margin-left: 8px;\n}\nhtml[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper.close_icon ~ .page-body,\nhtml[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper.close_icon ~ footer {\n  margin-left: 0;\n  margin-right: 100px;\n  transition: 0.5s;\n}\nhtml[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper.close_icon .sidebar-main .sidebar-links > li a svg {\n  margin-left: 0;\n}\nhtml[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper.close_icon .sidebar-main .sidebar-links .sidebar-list .sidebar-title.active ~ .sidebar-submenu {\n  display: none !important;\n}\nhtml[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper.close_icon .according-menu {\n  display: none;\n}\nhtml[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper.close_icon:hover .sidebar-main .sidebar-links > li a svg {\n  margin-left: 13px;\n}\nhtml[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper:hover {\n  transform: translate(0px);\n}\nhtml[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper:hover .sidebar-main .sidebar-links .sidebar-list .sidebar-title.active ~ .sidebar-submenu {\n  display: block !important;\n}\nhtml[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper:hover .sidebar-main .sidebar-links > li a svg {\n  float: none;\n}\nhtml[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper:hover .according-menu {\n  display: block;\n}\nhtml[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu:after {\n  right: 30px;\n  left: unset;\n}\nhtml[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu > li a {\n  padding-right: 45px !important;\n  padding-left: unset !important;\n}\nhtml[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu > li a:after {\n  right: 26px;\n  left: unset;\n}\nhtml[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .page-body {\n  margin-left: unset;\n  margin-right: 265px;\n}\nhtml[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li a svg {\n  margin-right: unset;\n  margin-left: 15px;\n}\nhtml[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper .according-menu {\n  right: unset;\n  left: 20px;\n}\nhtml[dir=rtl] .page-wrapper.only-body .page-header .header-wrapper .nav-right {\n  right: unset;\n  left: 30px;\n}\nhtml[dir=rtl] .date-details > div + div {\n  margin-left: unset;\n  margin-right: 10px;\n}\nhtml[dir=rtl] .contact-editform.ps-0 {\n  padding-left: 20px !important;\n}\nhtml[dir=rtl] .contact-options li .btn-category {\n  padding-left: unset !important;\n  padding-right: 40px;\n}\nhtml[dir=rtl] .list-persons .profile-mail .email-general ul {\n  padding-right: unset;\n  padding-left: 20px;\n}\nhtml[dir=rtl] .list-persons .profile-mail .email-general ul li > span {\n  float: left;\n}\nhtml[dir=rtl] .list-persons .profile-mail .media .media-body ul li + li {\n  padding-left: unset;\n  padding-right: 10px;\n  margin-left: unset;\n  margin-right: 5px;\n  border-left: unset;\n  border-right: 1px solid #f4f4f4;\n}\nhtml[dir=rtl] .file-content .form-inline i {\n  padding-right: unset;\n  padding-left: 10px;\n}\nhtml[dir=rtl] .file-sidebar .btn svg {\n  margin-right: unset;\n  margin-left: 8px;\n}\nhtml[dir=rtl] .form-select {\n  background-position: left 0.75rem center;\n}\nhtml[dir=rtl] .customers ul li + li {\n  margin-left: unset;\n  margin-right: -10%;\n}\nhtml[dir=rtl] .project-list .border-tab.nav-tabs .nav-item .nav-link {\n  padding: 5px 0 5px 30px;\n}\nhtml[dir=rtl] .project-box .badge {\n  right: unset;\n  left: 30px;\n}\nhtml[dir=rtl] .kanban-board {\n  float: right;\n}\nhtml[dir=rtl] .kanban-item .kanban-box .customers ul li + li {\n  margin-left: unset;\n  margin-right: -10px;\n}\nhtml[dir=rtl] .kanban-item .list li i {\n  margin-right: unset;\n  margin-left: 10px;\n}\nhtml[dir=rtl] .page-wrapper.horizontal-wrapper .header-logo-wrapper {\n  text-align: right;\n}\nhtml[dir=rtl] .page-wrapper.horizontal-wrapper .page-body-wrapper .page-body {\n  margin-right: 0;\n}\nhtml[dir=rtl] .page-wrapper.horizontal-wrapper .page-body-wrapper footer {\n  margin-right: 0;\n}\nhtml[dir=rtl] .page-wrapper.material-type .page-body-wrapper .page-body {\n  margin-right: auto;\n}\nhtml[dir=rtl] .page-header .header-wrapper .nav-right > ul > li:first-child {\n  margin-right: 0;\n}\nhtml[dir=rtl] .page-header .header-wrapper .nav-right.right-header ul li .profile-media .media-body {\n  margin-right: 15px;\n  margin-left: unset;\n}\nhtml[dir=rtl] .page-header .header-wrapper .toggle-sidebar {\n  margin-left: 2px;\n  margin-right: unset;\n}\nhtml[dir=rtl] .page-wrapper .page-header .header-wrapper .nav-right .notification-dropdown {\n  left: -20px !important;\n  right: unset !important;\n}\n@media (max-width: 575.98px) {\n  html[dir=rtl] .page-wrapper .page-header .header-wrapper .nav-right .notification-dropdown {\n    left: 12px !important;\n  }\n}\nhtml[dir=rtl] .page-wrapper .page-header .header-wrapper .search-full input {\n  padding-left: unset;\n  padding-right: 60px;\n  text-align: right;\n}\nhtml[dir=rtl] .page-wrapper .page-header .header-wrapper .search-full .form-group:before {\n  left: unset;\n  right: 30px;\n}\nhtml[dir=rtl] .page-wrapper .page-header .header-wrapper .search-full .form-group .close-search {\n  right: unset;\n  left: 0;\n}\nhtml[dir=rtl] .page-wrapper.compact-sidebar .toggle-sidebar {\n  margin-left: 15px;\n  margin-right: unset;\n}\nhtml[dir=rtl] .page-wrapper.compact-sidebar .page-header {\n  margin-left: unset;\n  margin-right: 150px;\n}\nhtml[dir=rtl] .page-wrapper.compact-sidebar .page-header.close_icon {\n  margin-right: 0;\n}\nhtml[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper .page-body {\n  margin-left: unset;\n  margin-right: 150px;\n}\nhtml[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper .footer {\n  margin-left: unset;\n  margin-right: 150px;\n}\nhtml[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper > div {\n  text-align: right;\n}\nhtml[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a.active ~ .sidebar-submenu,\nhtml[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a.active ~ .mega-menu-container {\n  animation: fadeInRight 1000ms ease-in-out;\n}\nhtml[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu,\nhtml[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container {\n  right: 150px;\n  left: unset;\n}\nhtml[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu li a,\nhtml[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container li a {\n  padding: 15px 40px 15px 15px;\n}\nhtml[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu li a .according-menu,\nhtml[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container li a .according-menu {\n  right: 20px;\n}\nhtml[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu > li > a::after,\nhtml[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container > li > a::after {\n  left: unset;\n  right: 20px;\n}\nhtml[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu .mega-box .link-section,\nhtml[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container .mega-box .link-section {\n  text-align: right;\n}\nhtml[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu .mega-box .link-section .submenu-title h5, html[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu .mega-box .link-section .submenu-title .h5,\nhtml[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container .mega-box .link-section .submenu-title h5,\nhtml[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container .mega-box .link-section .submenu-title .h5 {\n  padding: 15px 40px 15px 15px;\n}\nhtml[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu .mega-box .link-section .submenu-title h5::after, html[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu .mega-box .link-section .submenu-title .h5::after,\nhtml[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container .mega-box .link-section .submenu-title h5::after,\nhtml[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container .mega-box .link-section .submenu-title .h5::after {\n  left: unset;\n  right: 20px;\n}\nhtml[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list .badge {\n  left: unset;\n  right: 53%;\n}\nhtml[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list .sidebar-link {\n  text-align: center;\n}\nhtml[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .mega-menu {\n  text-align: center;\n}\nhtml[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .mega-menu .according-menu {\n  right: unset;\n  left: 20px;\n}\nhtml[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper.close_icon {\n  transform: translateX(150px);\n}\nhtml[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper.close_icon ~ .page-body,\nhtml[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper.close_icon ~ .footer {\n  margin-right: 0px;\n}\nhtml[dir=rtl] .page-wrapper.compact-small .page-header {\n  margin-right: 90px;\n}\nhtml[dir=rtl] .page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu,\nhtml[dir=rtl] .page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container {\n  right: 90px;\n}\nhtml[dir=rtl] .page-wrapper.compact-small .page-body-wrapper .footer,\nhtml[dir=rtl] .page-wrapper.compact-small .page-body-wrapper .page-body {\n  margin-right: 90px;\n}\nhtml[dir=rtl] .page-wrapper.material-icon .page-header {\n  padding-left: unset;\n  padding-right: 90px;\n  margin: 0 auto;\n}\nhtml[dir=rtl] .page-wrapper.material-icon .page-header.close_icon {\n  padding-right: 0;\n}\nhtml[dir=rtl] .page-wrapper.material-icon .page-body-wrapper .page-body {\n  padding-left: 15px;\n  padding-right: 90px;\n  margin: 0 auto;\n}\nhtml[dir=rtl] .page-wrapper.material-icon .page-body-wrapper div.sidebar-wrapper.close_icon ~ .page-body {\n  padding-right: 15px;\n  margin: 0 auto !important;\n}\nhtml[dir=rtl] .apexcharts-canvas {\n  direction: ltr;\n}\nhtml[dir=rtl] .email-wrap .btn-mail {\n  text-align: right;\n}\nhtml[dir=rtl] .email-wrap .email-app-sidebar ul li a {\n  padding-left: unset;\n  padding-right: 20px;\n}\nhtml[dir=rtl] .bookmark-tabcontent .details-bookmark .bookmark-card.card .favourite-icon {\n  text-align: center;\n}\nhtml[dir=rtl] .bookmark-tabcontent .details-bookmark .bookmark-card.card .title-bookmark {\n  text-align: right;\n}\nhtml[dir=rtl] .bookmark-wrap .details-bookmark .row > div + div {\n  padding-left: 15px !important;\n}\nhtml[dir=rtl] .appointment-table table tr td .status-circle {\n  left: unset;\n  right: 35px;\n}\nhtml[dir=rtl] .notification .card .d-flex .w-100 p .badge {\n  margin-left: unset;\n  margin-right: 10px;\n}\nhtml[dir=rtl] .progress-gradient-primary {\n  background-image: linear-gradient(to right, var(--theme-default), transparent);\n}\nhtml[dir=rtl] .progress-gradient-primary::after {\n  right: unset;\n  left: -1px;\n}\nhtml[dir=rtl] .progress-gradient-primary .animate-circle {\n  right: unset;\n  left: -8px;\n}\nhtml[dir=rtl] .progress-gradient-secondary {\n  background-image: linear-gradient(to right, #ff3364, transparent);\n}\nhtml[dir=rtl] .progress-gradient-secondary::after {\n  right: unset;\n  left: -1px;\n}\nhtml[dir=rtl] .progress-gradient-secondary .animate-circle {\n  right: unset;\n  left: -8px;\n}\nhtml[dir=rtl] .progress-gradient-success {\n  background-image: linear-gradient(to right, #54ba4a, transparent);\n}\nhtml[dir=rtl] .progress-gradient-success::after {\n  right: unset;\n  left: -1px;\n}\nhtml[dir=rtl] .progress-gradient-success .animate-circle {\n  right: unset;\n  left: -8px;\n}\nhtml[dir=rtl] .progress-gradient-danger {\n  background-image: linear-gradient(to right, #fc4438, transparent);\n}\nhtml[dir=rtl] .progress-gradient-danger::after {\n  right: unset;\n  left: -1px;\n}\nhtml[dir=rtl] .progress-gradient-danger .animate-circle {\n  right: unset;\n  left: -8px;\n}\nhtml[dir=rtl] .progress-gradient-info {\n  background-image: linear-gradient(to right, #16c7f9, transparent);\n}\nhtml[dir=rtl] .progress-gradient-info::after {\n  right: unset;\n  left: -1px;\n}\nhtml[dir=rtl] .progress-gradient-info .animate-circle {\n  right: unset;\n  left: -8px;\n}\nhtml[dir=rtl] .progress-gradient-light {\n  background-image: linear-gradient(to right, #f4f4f4, transparent);\n}\nhtml[dir=rtl] .progress-gradient-light::after {\n  right: unset;\n  left: -1px;\n}\nhtml[dir=rtl] .progress-gradient-light .animate-circle {\n  right: unset;\n  left: -8px;\n}\nhtml[dir=rtl] .progress-gradient-dark {\n  background-image: linear-gradient(to right, #2c323f, transparent);\n}\nhtml[dir=rtl] .progress-gradient-dark::after {\n  right: unset;\n  left: -1px;\n}\nhtml[dir=rtl] .progress-gradient-dark .animate-circle {\n  right: unset;\n  left: -8px;\n}\nhtml[dir=rtl] .progress-gradient-warning {\n  background-image: linear-gradient(to right, #ffaa05, transparent);\n}\nhtml[dir=rtl] .progress-gradient-warning::after {\n  right: unset;\n  left: -1px;\n}\nhtml[dir=rtl] .progress-gradient-warning .animate-circle {\n  right: unset;\n  left: -8px;\n}\nhtml[dir=rtl] .progress-animate span {\n  left: -10px;\n  right: unset;\n}\nhtml[dir=rtl] .me-4 {\n  margin-left: 1.5rem !important;\n  margin-right: unset !important;\n}\nhtml[dir=rtl] .pe-4 {\n  padding-left: 1.5rem !important;\n  padding-right: unset !important;\n}\nhtml[dir=rtl] .me-1 {\n  margin-left: 0.25rem !important;\n  margin-right: unset !important;\n}\nhtml[dir=rtl] .navs-dropdown .onhover-show-div {\n  right: 0;\n}\nhtml[dir=rtl] .default-according.style-1 button {\n  text-align: right;\n}\nhtml[dir=rtl] .default-according.style-1 button:before {\n  left: 20px;\n  right: unset;\n}\n@media (max-width: 575px) {\n  html[dir=rtl] .default-according.style-1 button:before {\n    left: 15px;\n  }\n}\nhtml[dir=rtl] .default-according.style-1 button i {\n  right: 18px;\n  left: unset;\n}\nhtml[dir=rtl] .default-according .card .card-header i {\n  right: 18px;\n  left: unset;\n}\nhtml[dir=rtl] .faq-wrap .faq-accordion .card .card-header .btn-link {\n  padding-right: 20px !important;\n}\n@media (max-width: 575.98px) {\n  html[dir=rtl] .faq-wrap .faq-accordion .card .card-header .btn-link {\n    padding-right: 10px !important;\n  }\n}\nhtml[dir=rtl] .ProfileCard-details {\n  padding-right: 30px;\n  padding-left: unset;\n  float: right;\n}\nhtml[dir=rtl] .starter-main .card-body ul {\n  padding-right: 30px;\n  padding-left: unset;\n}\nhtml[dir=rtl] .theme-tab .tab-title li a svg {\n  margin-left: 5px;\n  margin-right: unset;\n}\nhtml[dir=rtl] .spent .spent-graph .project-budget {\n  margin-left: 30px;\n  margin-right: unset;\n}\nhtml[dir=rtl] .support-table table tbody tr td:first-child {\n  padding-right: 0;\n  padding-left: unset;\n}\nhtml[dir=rtl] .order-box .sub-total .shipping-class .shopping-checkout-option,\nhtml[dir=rtl] .order-box .sub-total .shipping-class span,\nhtml[dir=rtl] .order-box .sub-total li .shopping-checkout-option,\nhtml[dir=rtl] .order-box .sub-total li span,\nhtml[dir=rtl] .order-box .total .shipping-class .shopping-checkout-option,\nhtml[dir=rtl] .order-box .total .shipping-class span,\nhtml[dir=rtl] .order-box .total li .shopping-checkout-option,\nhtml[dir=rtl] .order-box .total li span,\nhtml[dir=rtl] .order-box .qty .shipping-class .shopping-checkout-option,\nhtml[dir=rtl] .order-box .qty .shipping-class span,\nhtml[dir=rtl] .order-box .qty li .shopping-checkout-option,\nhtml[dir=rtl] .order-box .qty li span {\n  float: left;\n}\nhtml[dir=rtl] .order-box .sub-total li .count,\nhtml[dir=rtl] .order-box .total li .count,\nhtml[dir=rtl] .order-box .qty li .count {\n  float: left;\n}\nhtml[dir=rtl] .img-paypal {\n  margin-right: 15px;\n  margin-left: unset;\n}\nhtml[dir=rtl] .cart .qty-box .input-group .btn {\n  border-radius: 0 !important;\n}\nhtml[dir=rtl] .product-qnty fieldset .input-group .input-group-prepend .btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\nhtml[dir=rtl] .grid-options {\n  margin-right: 10px;\n  margin-left: unset;\n}\nhtml[dir=rtl] .grid-options ul li a .line-grid-1 {\n  right: 12px;\n  left: unset;\n}\nhtml[dir=rtl] .grid-options ul li a .line-grid-2 {\n  right: 18px;\n  left: unset;\n}\nhtml[dir=rtl] .grid-options ul li a .line-grid-3 {\n  right: 36px;\n  left: unset;\n}\nhtml[dir=rtl] .grid-options ul li a .line-grid-4 {\n  right: 42px;\n  left: unset;\n}\nhtml[dir=rtl] .grid-options ul li a .line-grid-5 {\n  right: 48px;\n  left: unset;\n}\nhtml[dir=rtl] .grid-options ul li a .line-grid-6 {\n  right: 66px;\n  left: unset;\n}\nhtml[dir=rtl] .grid-options ul li a .line-grid-7 {\n  right: 72px;\n  left: unset;\n}\nhtml[dir=rtl] .grid-options ul li a .line-grid-8 {\n  right: 78px;\n  left: unset;\n}\nhtml[dir=rtl] .grid-options ul li a .line-grid-9 {\n  right: 84px;\n  left: unset;\n}\nhtml[dir=rtl] .grid-options ul li a .line-grid-10 {\n  right: 103px;\n  left: unset;\n}\nhtml[dir=rtl] .grid-options ul li a .line-grid-11 {\n  right: 109px;\n  left: unset;\n}\nhtml[dir=rtl] .grid-options ul li a .line-grid-12 {\n  right: 115px;\n  left: unset;\n}\nhtml[dir=rtl] .grid-options ul li a .line-grid-13 {\n  right: 121px;\n  left: unset;\n}\nhtml[dir=rtl] .grid-options ul li a .line-grid-14 {\n  right: 127px;\n  left: unset;\n}\nhtml[dir=rtl] .grid-options ul li a .line-grid-15 {\n  right: 133px;\n  left: unset;\n}\nhtml[dir=rtl] .product-filter.new-products .owl-theme .owl-nav {\n  left: 0;\n  right: unset;\n}\nhtml[dir=rtl] .product-filter.new-products .owl-theme .owl-item .item .product-box .product-details.text-start {\n  text-align: left !important;\n}\nhtml[dir=rtl] .product-sidebar .filter-section .card .card-header h6 .pull-right i, html[dir=rtl] .product-sidebar .filter-section .card .card-header .h6 .pull-right i {\n  left: auto;\n  right: unset;\n}\nhtml[dir=rtl] .prooduct-details-box .btn {\n  right: unset;\n  left: 15px;\n}\nhtml[dir=rtl] .prooduct-details-box .close {\n  right: unset;\n  left: 10px;\n}\nhtml[dir=rtl] .collection-filter-block svg {\n  margin-right: unset;\n  margin-left: 10px;\n}\nhtml[dir=rtl] .feature-products form .form-group i {\n  left: 30px;\n  right: unset;\n}\nhtml[dir=rtl] .product-wrapper-grid.list-view .product-box .product-details {\n  text-align: right;\n}\nhtml[dir=rtl] .page-wrapper .page-body-wrapper .page-title .breadcrumb {\n  margin-left: unset;\n}\nhtml[dir=rtl] .bookmark ul li + li {\n  margin-left: unset;\n  margin-right: 10px;\n}\nhtml[dir=rtl] .bookmark ul li .search-form .form-control-search {\n  left: -50px;\n  right: unset;\n}\nhtml[dir=rtl] .bookmark ul li .search-form .form-control-search:before {\n  right: 50px;\n  left: unset;\n}\nhtml[dir=rtl] .bookmark ul li .search-form .form-control-search:after {\n  right: 20px;\n  left: unset;\n}\nhtml[dir=rtl] .me-0 {\n  margin-left: 0 !important;\n  margin-right: unset !important;\n}\nhtml[dir=rtl] .footer .pull-right {\n  float: none;\n}\nhtml[dir=rtl] .checkbox_animated,\nhtml[dir=rtl] .radio_animated {\n  margin: 0 8px 0 16px;\n}\nhtml[dir=rtl] .button.remove {\n  left: -10px;\n  right: unset;\n}\nhtml[dir=rtl] .code-box-copy__btn {\n  left: 11px;\n  right: unset;\n}\nhtml[dir=rtl] ul.nav-menus {\n  border-bottom: none;\n}\nhtml[dir=rtl] ul.notification-dropdown.onhover-show-div li {\n  text-align: right;\n}\nhtml[dir=rtl] .badge + .badge {\n  margin-right: 5px;\n  margin-left: unset;\n}\nhtml[dir=rtl] .offset-xl-3 {\n  margin-right: 25%;\n  margin-left: unset;\n}\nhtml[dir=rtl] .m-l-10 {\n  margin-right: 10px !important;\n  margin-left: unset !important;\n}\nhtml[dir=rtl] .m-r-20 {\n  margin-left: 20px;\n  margin-right: unset;\n}\nhtml[dir=rtl] .m-r-30 {\n  margin-left: 30px;\n  margin-right: unset;\n}\nhtml[dir=rtl] .m-r-5 {\n  margin-left: 5px;\n  margin-right: unset;\n}\nhtml[dir=rtl] .text-start {\n  text-align: right !important;\n}\nhtml[dir=rtl] .m-r-10 {\n  margin-left: 10px;\n  margin-right: unset;\n}\nhtml[dir=rtl] .pe-3 {\n  padding-left: 1rem !important;\n  padding-right: unset !important;\n}\nhtml[dir=rtl] .p-r-0 {\n  padding-left: 0;\n  padding-right: 15px;\n}\nhtml[dir=rtl] .m-l-20 {\n  margin-right: 20px !important;\n  margin-left: unset !important;\n}\nhtml[dir=rtl] .ps-3 {\n  padding-right: 1rem !important;\n}\nhtml[dir=rtl] .b-r-light {\n  border-left: 1px solid #f4f4f4 !important;\n  border-right: unset !important;\n}\nhtml[dir=rtl] .float-end {\n  float: left !important;\n}\nhtml[dir=rtl] .float-start {\n  float: right !important;\n}\nhtml[dir=rtl] .text-end {\n  text-align: left !important;\n}\nhtml[dir=rtl] .border-right {\n  border-left: 1px solid #dee2e6 !important;\n  border-right: unset !important;\n}\nhtml[dir=rtl] .pe-0 {\n  padding-left: 0 !important;\n  padding-right: 12px !important;\n}\nhtml[dir=rtl] .ps-0 {\n  padding-right: 0 !important;\n  padding-left: unset !important;\n}\nhtml[dir=rtl] .ms-1 {\n  margin-left: unset !important;\n  margin-right: 0.25rem !important;\n}\nhtml[dir=rtl] .owl-carousel {\n  direction: ltr;\n}\nhtml[dir=rtl] .btn-group > .btn:not(:last-child):not(.dropdown-toggle),\nhtml[dir=rtl] .btn-group > :not(:last-child) > .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\nhtml[dir=rtl] .btn-group > .btn:not(:first-child) {\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\nhtml[dir=rtl] .btn-group > .btn:nth-child(2) {\n  border-radius: 0 !important;\n}\nhtml[dir=rtl] .btn-group .btn-group > :not(:first-child) > .btn {\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\nhtml[dir=rtl] .btn-group .btn + .btn,\nhtml[dir=rtl] .btn-group .btn + .btn-group {\n  margin-right: -1px;\n  border-right: none;\n}\nhtml[dir=rtl] .btn-group .btn-group + .btn,\nhtml[dir=rtl] .btn-group .btn-group + .btn-group {\n  margin-right: -1px;\n}\nhtml[dir=rtl] .btn-group .btn-group-vertical .btn + .btn,\nhtml[dir=rtl] .btn-group .btn-group-vertical .btn + .btn-group {\n  margin-right: -1px;\n}\nhtml[dir=rtl] .btn-group .btn-group-vertical .btn-group + .btn,\nhtml[dir=rtl] .btn-group .btn-group-vertical .btn-group + .btn-group {\n  margin-right: -1px;\n}\nhtml[dir=rtl] .me-3 {\n  margin-right: unset !important;\n  margin-left: 1rem !important;\n}\nhtml[dir=rtl] .me-5 {\n  margin-left: 3rem !important;\n  margin-right: unset !important;\n}\nhtml[dir=rtl] .ms-3 {\n  margin-right: 1rem !important;\n  margin-left: unset !important;\n}\nhtml[dir=rtl] .m-r-15 {\n  margin-left: 15px;\n  margin-right: unset;\n}\nhtml[dir=rtl] .b-l-light {\n  border-right: 1px solid #f4f4f4 !important;\n  border-left: unset !important;\n}\nhtml[dir=rtl] .p-l-0 {\n  padding-left: unset;\n  padding-right: 0px;\n}\nhtml[dir=rtl] .ps-4 {\n  padding-right: 1.5rem !important;\n  padding-left: unset !important;\n}\nhtml[dir=rtl] .me-2 {\n  margin-left: 0.5rem !important;\n  margin-right: unset !important;\n}\nhtml[dir=rtl] .ms-2 {\n  margin-right: 0.5rem !important;\n  margin-left: unset !important;\n}\nhtml[dir=rtl] .pe-2 {\n  padding-right: unset !important;\n  padding-left: 0.5rem !important;\n}\nhtml[dir=rtl] .prooduct-details-box .media-body {\n  margin-right: 0 !important;\n}\nhtml[dir=rtl] .alert {\n  text-align: right;\n}\nhtml[dir=rtl] .pull-right {\n  float: left;\n}\nhtml[dir=rtl] .form-inline .form-group {\n  margin-left: 15px;\n  margin-right: 0;\n}\nhtml[dir=rtl] .card {\n  text-align: right;\n}\nhtml[dir=rtl] .card.social-profile {\n  text-align: center;\n}\nhtml[dir=rtl] .card .card-header h5:not(.mb-0), html[dir=rtl] .card .card-header .h5:not(.mb-0) {\n  float: right;\n}\nhtml[dir=rtl] .card .card-header span {\n  clear: both;\n}\nhtml[dir=rtl] .card .card-header .card-header-right {\n  left: 35px;\n  right: unset;\n}\nhtml[dir=rtl] .card .card-header .card-header-right .card-option {\n  text-align: left;\n}\nhtml[dir=rtl] .card .card-header .card-header-right .card-option.list-unstyled {\n  padding-right: 0;\n  padding-left: unset;\n}\nhtml[dir=rtl] .card .card-header .pull-left {\n  float: right;\n}\nhtml[dir=rtl] .card.full-card {\n  left: 0;\n  right: unset;\n}\nhtml[dir=rtl] .card .card-body .alert svg {\n  margin-left: 4px;\n  margin-right: unset;\n}\nhtml[dir=rtl] .card .card-body .value-left {\n  margin-left: 30px;\n  margin-right: unset;\n}\nhtml[dir=rtl] .card .card-body .square {\n  margin-left: 5px;\n  margin-right: unset;\n}\nhtml[dir=rtl] .balance-box {\n  text-align: center;\n}\nhtml[dir=rtl] .purchase-card {\n  text-align: center;\n}\nhtml[dir=rtl] .modal-header .btn-close {\n  margin: -0.5rem auto -0.5rem -0.5rem;\n}\nhtml[dir=rtl] .modal-footer > :not(:first-child) {\n  margin-right: 0.5rem;\n  margin-left: 0;\n}\nhtml[dir=rtl] .form-inline .form-group .col-form-label {\n  margin-left: 5px;\n  margin-right: 0;\n}\nhtml[dir=rtl] .breadcrumb-item + .breadcrumb-item {\n  padding-right: 0.5rem;\n  padding-left: unset;\n}\nhtml[dir=rtl] .breadcrumb-item + .breadcrumb-item::before {\n  padding-left: 0.5rem;\n  padding-right: unset;\n  float: right;\n}\nhtml[dir=rtl] code[class*=language-],\nhtml[dir=rtl] pre[class*=language-] {\n  text-align: right;\n}\nhtml[dir=rtl] .input-group-prepend {\n  margin-left: -1px;\n  margin-right: unset;\n}\nhtml[dir=rtl] .input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu),\nhtml[dir=rtl] .input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3) {\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\nhtml[dir=rtl] .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {\n  margin-left: unset;\n  margin-right: -1px;\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\nhtml[dir=rtl] .was-validated .form-control:invalid,\nhtml[dir=rtl] .form-control.is-invalid,\nhtml[dir=rtl] .was-validated .form-control:valid,\nhtml[dir=rtl] .form-control.is-valid {\n  background-position: left calc(0.375em + 0.1875rem) center;\n  padding-left: calc(1.5em + 0.75rem);\n  padding-right: 12px;\n}\nhtml[dir=rtl] .input-group > .form-control:not(:last-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\nhtml[dir=rtl] .input-group > .input-group-prepend > .btn,\nhtml[dir=rtl] .input-group > .input-group-prepend > .input-group-text,\nhtml[dir=rtl] .input-group > .input-group-append:not(:last-child) > .btn,\nhtml[dir=rtl] .input-group > .input-group-append:not(:last-child) > .input-group-text,\nhtml[dir=rtl] .input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\nhtml[dir=rtl] .input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\nhtml[dir=rtl] .input-group > .input-group-append > .btn,\nhtml[dir=rtl] .input-group > .input-group-append > .input-group-text,\nhtml[dir=rtl] .input-group > .input-group-prepend:not(:first-child) > .btn,\nhtml[dir=rtl] .input-group > .input-group-prepend:not(:first-child) > .input-group-text,\nhtml[dir=rtl] .input-group > .input-group-prepend:first-child > .btn:not(:first-child),\nhtml[dir=rtl] .input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\nhtml[dir=rtl] .border-tab.nav-left .nav-link {\n  text-align: left;\n}\nhtml[dir=rtl] .socialprofile .social-group ul li:nth-child(4) {\n  margin-right: -22px;\n}\nhtml[dir=rtl] .social-status form .form-group .form-control-social {\n  padding-right: 15px;\n  padding-left: unset;\n}\nhtml[dir=rtl] .social-status .media .social-status {\n  right: 35px;\n  left: unset;\n}\nhtml[dir=rtl] .social-chat .other-msg {\n  margin-right: 40px;\n  margin-left: unset;\n}\nhtml[dir=rtl] .social-chat .media-body:before {\n  left: 100%;\n  right: unset;\n  border-left: 7px solid var(-semi-dark);\n  border-right: unset;\n}\nhtml[dir=rtl] .social-chat .media-body:after {\n  left: 100%;\n  right: unset;\n  border-left: 7px solid #fff;\n  border-right: unset;\n}\nhtml[dir=rtl] .timeline-content .comment-number i {\n  margin-left: 20px;\n  margin-right: unset;\n}\nhtml[dir=rtl] .vertical-timeline.vertical-timeline--one-column-left::before {\n  left: unset;\n  right: 18px;\n}\nhtml[dir=rtl] .vertical-timeline.vertical-timeline--one-column-left .vertical-timeline-element-icon {\n  right: 0;\n  left: unset;\n}\nhtml[dir=rtl] .vertical-timeline.vertical-timeline--one-column-left .vertical-timeline-element-icon svg {\n  right: 50%;\n  left: unset;\n  margin-left: unset;\n  margin-right: -12px;\n}\nhtml[dir=rtl] .vertical-timeline.vertical-timeline--one-column-left .vertical-timeline-element-content {\n  margin-right: 60px;\n  margin-left: unset;\n}\nhtml[dir=rtl] .vertical-timeline.vertical-timeline--one-column-left .vertical-timeline-element-content .vertical-timeline-element-date {\n  float: right;\n}\nhtml[dir=rtl] .vertical-timeline.vertical-timeline--one-column-left .vertical-timeline-element-content .vertical-timeline-element-content-arrow {\n  border-left: 7px solid #f4f4f4;\n  border-right: unset;\n  left: 100%;\n  right: unset;\n}\nhtml[dir=rtl] .vertical-timeline.vertical-timeline--two-columns .vertical-timeline-element-content .vertical-timeline-element-content-arrow {\n  border-left: 7px solid #f4f4f4;\n  border-right: unset;\n}\nhtml[dir=rtl] .vertical-timeline.vertical-timeline--two-columns .vertical-timeline-element-icon svg {\n  right: 50%;\n  left: unset;\n  margin-left: unset;\n  margin-right: -12px;\n}\nhtml[dir=rtl] .vertical-timeline--two-columns .vertical-timeline-element-content .vertical-timeline-element-date {\n  right: 124%;\n  left: unset;\n}\nhtml[dir=rtl] .vertical-timeline--two-columns .vertical-timeline-element.vertical-timeline-element--right .vertical-timeline-element-content .vertical-timeline-element-date {\n  right: auto;\n  left: 124%;\n  text-align: left;\n}\nhtml[dir=rtl] .vertical-timeline--two-columns .vertical-timeline-element:nth-child(even):not(.vertical-timeline-element--left) .vertical-timeline-element-content .vertical-timeline-element-date {\n  right: auto;\n  left: 124%;\n  text-align: left;\n}\nhtml[dir=rtl] .vertical-timeline--two-columns .vertical-timeline-element.vertical-timeline-element--right .vertical-timeline-element-content {\n  float: left;\n}\nhtml[dir=rtl] .vertical-timeline--two-columns .vertical-timeline-element:nth-child(even):not(.vertical-timeline-element--left) .vertical-timeline-element-content {\n  float: left;\n}\n@media only screen and (max-width: 1170px) {\n  html[dir=rtl] .vertical-timeline::before {\n    left: unset;\n    right: 18px;\n  }\n  html[dir=rtl] .vertical-timeline .vertical-timeline-element-icon {\n    right: 0;\n    left: unset;\n  }\n  html[dir=rtl] .vertical-timeline .vertical-timeline-element-icon svg {\n    right: 50%;\n    left: unset;\n    margin-left: unset;\n    margin-right: -12px;\n  }\n  html[dir=rtl] .vertical-timeline .vertical-timeline-element-content {\n    margin-right: 60px;\n    margin-left: unset;\n  }\n  html[dir=rtl] .vertical-timeline .vertical-timeline-element-content .vertical-timeline-element-date {\n    float: right;\n  }\n  html[dir=rtl] .vertical-timeline .vertical-timeline-element-content .vertical-timeline-element-content-arrow {\n    border-left: 7px solid #f4f4f4;\n    border-right: unset;\n    left: 100%;\n    right: unset;\n  }\n}\nhtml[dir=rtl] .vertical-timeline.vertical-timeline--one-column-left .vertical-timeline-element-content .vertical-timeline-element-content-arrow {\n  border-left: 7px solid #1d1e26 !important;\n  border-right: unset !important;\n}\nhtml[dir=rtl] .photos ul li {\n  margin-right: unset;\n  margin-left: 10px;\n}\nhtml[dir=rtl] .avatar-showcase .friend-pic {\n  margin-left: 8px;\n  margin-right: unset;\n}\nhtml[dir=rtl] .avatar-showcase .pepole-knows ul li {\n  margin-left: 21px;\n  margin-right: unset;\n}\nhtml[dir=rtl] .avatar-showcase .pepole-knows ul li:last-child {\n  margin-left: 0;\n}\nhtml[dir=rtl] .user-profile .hovercard .user-image .share-icons {\n  left: 100px;\n  right: unset;\n}\nhtml[dir=rtl] .user-profile .hovercard .user-image .share-icons li {\n  margin-left: 10px;\n  margin-right: unset;\n}\nhtml[dir=rtl] .user-profile .hovercard .user-image .share-icons li:last-child {\n  margin-left: 0;\n}\nhtml[dir=rtl] .faq-form .search-icon {\n  left: 12px;\n  right: unset;\n}\nhtml[dir=rtl] .faq-widgets .media-body p {\n  padding-left: 20px;\n  padding-right: unset;\n}\nhtml[dir=rtl] .header-faq,\nhtml[dir=rtl] .faq-title {\n  text-align: right;\n}\nhtml[dir=rtl] .faq-accordion.default-according .card .faq-header svg {\n  left: 30px;\n  right: unset;\n}\nhtml[dir=rtl] .faq-accordion.default-according .card .btn-link svg {\n  margin-left: 10px;\n  margin-right: unset;\n}\nhtml[dir=rtl] .navigation-option ul li {\n  padding: 8px 0 8px 8px;\n}\nhtml[dir=rtl] .navigation-option ul li a {\n  padding-right: 40px;\n  padding-left: unset;\n}\nhtml[dir=rtl] .navigation-option ul li a svg {\n  right: 15px;\n  left: unset;\n}\nhtml[dir=rtl] .updates-faq {\n  margin-right: unset;\n  margin-left: 20px;\n}\nhtml[dir=rtl] .browse .browse-articles span svg {\n  margin-left: 10px;\n  margin-right: unset;\n}\nhtml[dir=rtl] .categories .learning-header {\n  padding-right: 15px;\n  padding-left: unset;\n}\nhtml[dir=rtl] .main .langChoice {\n  left: 30px;\n  right: unset;\n}\nhtml[dir=rtl] .pricing-block svg {\n  direction: ltr;\n}\nhtml[dir=rtl] p.data-attributes svg {\n  margin-left: 10px;\n  margin-right: unset;\n}\nhtml[dir=rtl] .avatars .avatar {\n  margin-left: 10px;\n  margin-right: unset;\n}\nhtml[dir=rtl] .avatars .avatar:last-child {\n  margin-left: 0;\n}\nhtml[dir=rtl] .avatars .avatar .status {\n  left: 4px;\n  right: unset;\n}\nhtml[dir=rtl] .customers.avatar-group {\n  margin-left: 30px;\n  margin-right: unset;\n}\nhtml[dir=rtl] .card .card-header h5, html[dir=rtl] .card .card-header .h5 {\n  float: none !important;\n}\nhtml[dir=rtl] .knob-chart .chart-clock-main .clock-small {\n  right: 10px;\n  left: unset;\n}\nhtml[dir=rtl] .todo .todo-list-wrapper .mark-all-tasks .btn-label {\n  margin-left: 5px;\n  margin-right: unset;\n}\nhtml[dir=rtl] .todo .todo-list-wrapper .mark-all-tasks {\n  left: 30px;\n  right: unset;\n}\nhtml[dir=rtl] .todo .todo-list-wrapper #todo-list li .task-container .task-action-btn {\n  text-align: left;\n}\nhtml[dir=rtl] .todo .notification-popup {\n  left: 10px;\n  right: unset;\n}\nhtml[dir=rtl] .todo-options .badges-todo h6, html[dir=rtl] .todo-options .badges-todo .h6 {\n  margin-left: 10px;\n  margin-right: unset;\n}\nhtml[dir=rtl] .todo-options .badges-todo h6:last-child, html[dir=rtl] .todo-options .badges-todo .h6:last-child {\n  margin-left: 0;\n}\nhtml[dir=rtl] .todo-list-btns .dropdown-basic .btn-group .form-group .checkbox {\n  padding-right: 14px;\n  border-top-right-radius: 25px;\n  border-bottom-right-radius: 25px;\n  padding-left: unset;\n  border-top-left-radius: unset;\n  border-bottom-left-radius: unset;\n}\nhtml[dir=rtl] .todo-list-btns .dropdown-basic .separated-btn {\n  margin-right: -6px;\n  margin-left: unset;\n}\nhtml[dir=rtl] .todo-list-btns .dropdown-basic .separated-btn .btn {\n  border-top-left-radius: 25px;\n  border-bottom-left-radius: 25px;\n}\nhtml[dir=rtl] .search-todo .dropdown-basic .btn-group {\n  margin-left: 18px;\n  margin-right: unset;\n}\nhtml[dir=rtl] .sticky-note .note {\n  float: right;\n}\nhtml[dir=rtl] .mega-menu .list-unstyled div a {\n  padding: 8px 0 8px 35px;\n}\nhtml[dir=rtl] .mega-menu .list-unstyled div a:hover {\n  padding: 8px 10px 8px 35px;\n}\nhtml[dir=rtl] #testimonial .owl-stage-outer .owl-stage .owl-item .slide--item .media .me-3 {\n  margin-right: 1rem !important;\n  margin-left: unset !important;\n}\nhtml[dir=rtl] .needs-validation .input-group > .form-control:not(:last-child),\nhtml[dir=rtl] .needs-validation .input-group > .custom-select:not(:last-child),\nhtml[dir=rtl] .form-row .input-group > .form-control:not(:last-child),\nhtml[dir=rtl] .form-row .input-group > .custom-select:not(:last-child) {\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\nhtml[dir=rtl] .form-check {\n  padding-right: 1.25rem;\n  padding-left: unset;\n}\nhtml[dir=rtl] .form-check .form-check-input {\n  float: right;\n  margin-left: unset;\n  margin-right: -1.5em;\n}\nhtml[dir=rtl] .mega-menu .default-according .card .btn-link {\n  text-align: right;\n}\nhtml[dir=rtl] .mega-menu .default-according.style-1 button[aria-expanded=true]:before,\nhtml[dir=rtl] .mega-menu .default-according.style-1 button[aria-expanded=false]:before {\n  right: unset;\n  left: 20px;\n}\nhtml[dir=rtl] .email-wrap .row .col-xl-6 {\n  padding-right: 0;\n  padding-left: 15px;\n}\nhtml[dir=rtl] .email-wrap .row .col-xl-3 + .col-xl-3 {\n  padding-left: 0;\n  padding-right: 15px;\n}\nhtml[dir=rtl] .email-wrap .email-app-sidebar .main-menu > li {\n  text-align: right;\n}\nhtml[dir=rtl] .email-wrap .email-app-sidebar .main-menu > li a i {\n  margin-right: unset;\n  margin-left: 10px;\n}\nhtml[dir=rtl] .email-wrap .email-app-sidebar ul {\n  padding-right: 0;\n}\nhtml[dir=rtl] .email-wrap .email-content .email-top .user-emailid:after {\n  float: left;\n}\nhtml[dir=rtl] .email-wrap .email-right-aside .email-body .pe-0 {\n  padding-right: unset !important;\n}\nhtml[dir=rtl] .email-wrap .email-right-aside .radius-left {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n  border-radius: 4px;\n}\nhtml[dir=rtl] #renderRange {\n  float: left;\n  padding-left: unset;\n  padding-right: 12px;\n}\nhtml[dir=rtl] .event-calendar {\n  direction: ltr;\n}\nhtml[dir=rtl] .calendar-wrap .fc {\n  direction: rtl;\n  text-align: right;\n}\nhtml[dir=rtl] .calendar-wrap .fc .fc-toolbar .fc-left {\n  float: right;\n}\nhtml[dir=rtl] .calendar-wrap .fc .fc-toolbar .fc-right {\n  float: left;\n}\nhtml[dir=rtl] .calendar-wrap .fc .fc-toolbar > * > * {\n  margin-left: 0;\n}\nhtml[dir=rtl] .calendar-wrap .fc-events-container {\n  text-align: right;\n}\nhtml[dir=rtl] .calendar-wrap .fc-scroller {\n  margin-right: unset;\n  margin-left: -17px;\n}\nhtml[dir=rtl] .fc-agenda-view .fc-day-grid .fc-row {\n  margin-right: 0 !important;\n}\nhtml[dir=rtl] .fc-unthemed .fc-row {\n  margin-right: 0 !important;\n}\nhtml[dir=rtl] .btn-group-showcase .btn-group {\n  margin-left: 20px;\n  margin-right: unset;\n}\nhtml[dir=rtl] .btn-showcase .btn {\n  margin-right: unset;\n  margin-left: 10px;\n}\nhtml[dir=rtl] .btn-square.dropdown-toggle {\n  border-top-left-radius: 0.25rem !important;\n  border-bottom-left-radius: 0.25rem !important;\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\nhtml[dir=rtl].button-builder ul.the-icons li {\n  float: right;\n}\nhtml[dir=rtl].button-builder .color-slelector {\n  float: right;\n}\nhtml[dir=rtl].button-builder .custom-button-color .form-control {\n  border-radius: 0 5px 5px 0;\n}\nhtml[dir=rtl].button-builder .custom-button-color .form-control.pull-left {\n  float: right;\n}\nhtml[dir=rtl].button-builder .hint-label {\n  float: right;\n  padding: 4px 20px 0 0;\n}\nhtml[dir=rtl] #customer-review .owl-item img {\n  order: 2;\n}\nhtml[dir=rtl] .options > div {\n  margin: 0 0 8px 8px;\n}\nhtml[dir=rtl] .modal-dialog .modal-content .modal-body p a {\n  margin-left: 0;\n}\nhtml[dir=rtl] .drag-box fieldset .component .form-group .text-lg-left {\n  text-align: right !important;\n}\nhtml[dir=rtl] .drag-box fieldset .component .form-group .input-group .input-group-prepend .btn,\nhtml[dir=rtl] .drag-box fieldset .component .form-group .input-group .input-group-prepend .input-group-text {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\nhtml[dir=rtl] .drag-box fieldset .component .form-group .input-group .input-group-prepend .btn-right,\nhtml[dir=rtl] .drag-box fieldset .component .form-group .input-group .input-group-prepend .checkbox-radius {\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\nhtml[dir=rtl] .drag-box fieldset .component .form-group .input-group #prependedcheckbox {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\nhtml[dir=rtl] .drag-box fieldset .component .form-group .input-group #appendedcheckbox {\n  border-right-color: #efefef;\n}\nhtml[dir=rtl] .drag-box fieldset .component .form-group .input-group #buttondropdown {\n  margin-right: unset;\n  margin-left: -1px;\n}\nhtml[dir=rtl] .drag form {\n  text-align: right;\n}\nhtml[dir=rtl] .drag form input {\n  text-align: right;\n}\nhtml[dir=rtl] .drag form label {\n  text-align: right !important;\n}\nhtml[dir=rtl] .drag form .form-group .input-group .input-group-prepend .btn,\nhtml[dir=rtl] .drag form .form-group .input-group .input-group-prepend .input-group-text {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\nhtml[dir=rtl] .drag form .form-group .input-group .input-group-prepend .btn-right,\nhtml[dir=rtl] .drag form .form-group .input-group .input-group-prepend .checkbox-radius {\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\nhtml[dir=rtl] .drag form .form-group .input-group #buttondropdown {\n  margin-right: unset;\n  margin-left: -1px;\n}\nhtml[dir=rtl] .draggable label {\n  text-align: right;\n}\nhtml[dir=rtl] .form-builder-column .tab-content .tab-pane .theme-form .ui-draggable .input-group > .input-group-prepend > .input-group-text {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\nhtml[dir=rtl] .form-builder-column #pills-tabContent .theme-form .form-group .input-group #buttondropdown,\nhtml[dir=rtl] .form-builder-column #pills-tabContent .theme-form .ui-draggable .input-group #buttondropdown {\n  margin-right: unset;\n  margin-left: 15px;\n}\nhtml[dir=rtl] .form-builder-column #pills-tabContent .theme-form .form-group .input-group .input-group-btn button,\nhtml[dir=rtl] .form-builder-column #pills-tabContent .theme-form .ui-draggable .input-group .input-group-btn button {\n  border-radius: 4px !important;\n}\nhtml[dir=rtl] .form-horizontal.theme-form fieldset .tab-content .tab-pane .component .form-group .text-lg-left {\n  text-align: right !important;\n}\nhtml[dir=rtl] .form-horizontal.theme-form fieldset .tab-content .tab-pane .component .form-group .input-group .input-group-prepend .btn,\nhtml[dir=rtl] .form-horizontal.theme-form fieldset .tab-content .tab-pane .component .form-group .input-group .input-group-prepend .input-group-text {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\nhtml[dir=rtl] .form-horizontal.theme-form fieldset .tab-content .tab-pane .component .form-group .input-group .input-group-prepend .btn-right,\nhtml[dir=rtl] .form-horizontal.theme-form fieldset .tab-content .tab-pane .component .form-group .input-group .input-group-prepend .checkbox-radius {\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\nhtml[dir=rtl] .form-horizontal.theme-form fieldset .tab-content .tab-pane .component .form-group .input-group #prependedcheckbox {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\nhtml[dir=rtl] .form-horizontal.theme-form fieldset .tab-content .tab-pane .component .form-group .input-group #appendedcheckbox {\n  border-right-color: #efefef;\n}\nhtml[dir=rtl] .form-builder .component .form-group .input-group #buttondropdown {\n  margin-right: unset;\n  margin-left: -1px;\n}\nhtml[dir=rtl] .form-builder .component .form-group .pl-md-radios {\n  padding-right: 37px;\n  padding-left: unset;\n}\nhtml[dir=rtl] .page-wrapper .page-body-wrapper .logo-wrapper {\n  box-shadow: 9px 0 20px rgba(89, 102, 122, 0.1) !important;\n}\nhtml[dir=rtl] .page-wrapper .page-body-wrapper .logo-wrapper a {\n  transform: translate(-64px);\n}\nhtml[dir=rtl] .search-page .nav i {\n  margin-left: 10px;\n  margin-right: unset;\n}\nhtml[dir=rtl] .product-stts {\n  display: inline-block;\n}\nhtml[dir=rtl] .product-stts .ms-1 {\n  margin-right: 0.25rem !important;\n  margin-left: unset !important;\n}\nhtml[dir=rtl] .search-form input {\n  padding: 10px 70px 10px 10px;\n  text-align: right;\n}\nhtml[dir=rtl] .icon-hover-bottom .icon-title {\n  text-align: right;\n}\nhtml[dir=rtl] .icon-lists div i {\n  margin: 0 10px 0 15px;\n}\nhtml[dir=rtl] .icon-lists ul {\n  padding-right: 0;\n}\nhtml[dir=rtl] ul.icon-lists {\n  padding-right: 30px;\n}\nhtml[dir=rtl] .floated-customizer-btn.third-floated-btn {\n  left: 35px;\n  right: unset;\n}\nhtml[dir=rtl] .floated-customizer-btn > span {\n  margin-right: 10px;\n}\nhtml[dir=rtl] .floated-customizer-panel {\n  text-align: right;\n  left: -85px;\n  right: unset;\n}\nhtml[dir=rtl] .floated-customizer-panel.active {\n  left: 35px;\n  right: unset;\n}\nhtml[dir=rtl] .floated-customizer-panel .close-customizer-btn {\n  left: 30px;\n  right: unset;\n}\nhtml[dir=rtl] .floated-customizer-panel ul {\n  padding-right: 0;\n}\nhtml[dir=rtl] .form-builder-2-header > div nav {\n  float: left;\n}\nhtml[dir=rtl] .radio label {\n  padding-left: 0;\n  padding-right: 15px;\n}\nhtml[dir=rtl] .radio label::before {\n  right: 0;\n  margin-right: -20px;\n  left: unset;\n}\nhtml[dir=rtl] .page-wrapper .page-body-wrapper .page-title .row h3, html[dir=rtl] .page-wrapper .page-body-wrapper .page-title .row .h3 {\n  text-align: right;\n  padding-left: 20px;\n  padding-right: unset !important;\n}\nhtml[dir=rtl] .page-wrapper .page-body-wrapper .page-title .row h6, html[dir=rtl] .page-wrapper .page-body-wrapper .page-title .row .h6 {\n  text-align: right;\n}\nhtml[dir=rtl] .page-wrapper.compact-wrapper .page-header {\n  margin-right: 265px;\n  margin-left: unset;\n  width: calc(100% - 265px);\n}\nhtml[dir=rtl] .page-wrapper.compact-wrapper .page-header.close_icon {\n  margin-right: 100px;\n  margin-left: unset;\n  width: calc(100% - 100px);\n}\nhtml[dir=rtl] .page-wrapper.modern-type .page-header {\n  margin-right: 0;\n  width: calc(100% - 0px);\n}\nhtml[dir=rtl] .page-wrapper.modern-type .page-header.close_icon {\n  margin-right: 0;\n  width: calc(100% - 0px);\n}\nhtml[dir=rtl] .page-wrapper.modern-type .page-header .header-wrapper .logo-wrapper {\n  margin-right: unset;\n  margin-left: 30px;\n}\nhtml[dir=rtl] .page-wrapper.modern-type .page-header .header-wrapper .toggle-sidebar {\n  margin-right: unset;\n  margin-left: 15px;\n}\nhtml[dir=rtl] .page-wrapper.modern-type .page-body-wrapper .page-body {\n  margin-right: 310px;\n}\nhtml[dir=rtl] .page-wrapper.modern-type .page-body-wrapper .footer {\n  margin-left: 55px;\n  margin-right: 360px;\n}\nhtml[dir=rtl] .page-wrapper.modern-type .page-body-wrapper div.sidebar-wrapper.close_icon ~ .page-body {\n  margin-right: 0px;\n}\nhtml[dir=rtl] .page-wrapper.modern-type .page-body-wrapper div.sidebar-wrapper.close_icon ~ footer {\n  margin-right: 0;\n}\nhtml[dir=rtl] .page-header .header-wrapper .nav-right {\n  text-align: right;\n}\nhtml[dir=rtl] .page-header .header-wrapper .nav-right .onhover-show-div {\n  right: unset;\n  left: 0;\n}\n@media (max-width: 575.98px) {\n  html[dir=rtl] .page-header .header-wrapper .nav-right .onhover-show-div {\n    left: 12px;\n  }\n}\n@media (max-width: 575.98px) {\n  html[dir=rtl] .page-header .header-wrapper .nav-right .cart-dropdown li {\n    padding: 10px;\n  }\n}\nhtml[dir=rtl] .page-header .header-wrapper .nav-right .cart-dropdown .close-circle {\n  right: unset;\n  left: 0;\n}\nhtml[dir=rtl] .page-header .header-wrapper .nav-right > ul > li .lang-txt {\n  margin-left: 0;\n  margin-right: 8px;\n}\nhtml[dir=rtl] .page-header .header-wrapper .nav-right > ul > li:before {\n  right: 0;\n  left: unset;\n}\nhtml[dir=rtl] .page-header .header-wrapper .nav-right > ul > li .dot {\n  left: 17px;\n  right: unset;\n}\nhtml[dir=rtl] .page-header .header-wrapper .nav-right > ul > li.onhover-dropdown:hover .onhover-show-div:before {\n  right: 10px;\n  left: unset;\n}\nhtml[dir=rtl] .page-header .header-wrapper .nav-right > ul > li.onhover-dropdown:hover .onhover-show-div:after {\n  right: 10px;\n  left: unset;\n}\nhtml[dir=rtl] .page-header .header-wrapper .nav-right > ul > li.onhover-dropdown:last-child {\n  padding-left: 0;\n  padding-right: 0 !important;\n}\nhtml[dir=rtl] .page-header .header-wrapper .nav-right > ul > li:last-child {\n  padding-right: 20px;\n  padding-left: 0;\n}\nhtml[dir=rtl] .page-header .header-wrapper .nav-right > ul > li {\n  text-align: right;\n}\nhtml[dir=rtl] .page-header .header-wrapper .nav-right > ul > li i.ms-2 {\n  margin-right: 0.5rem !important;\n  margin-left: unset !important;\n}\nhtml[dir=rtl] .page-header .header-wrapper .nav-right .profile-dropdown li svg {\n  margin-right: unset;\n  margin-left: 10px;\n}\nhtml[dir=rtl] .page-header .header-wrapper .mobile-sidebar {\n  padding-left: 20px;\n  padding-right: unset;\n}\nhtml[dir=rtl] .page-header.open {\n  margin-right: 0;\n}\nhtml[dir=rtl] ul.notification-dropdown.onhover-show-div {\n  right: initial;\n  left: -30px;\n  padding: 0;\n}\nhtml[dir=rtl] ul.notification-dropdown.onhover-show-div:before {\n  right: inherit !important;\n  left: 35px !important;\n}\nhtml[dir=rtl] ul.notification-dropdown.onhover-show-div:after {\n  right: inherit !important;\n  left: 35px !important;\n}\nhtml[dir=rtl] ul.notification-dropdown.onhover-show-div li {\n  margin-right: 0 !important;\n}\nhtml[dir=rtl] ul.notification-dropdown.onhover-show-div li span.badge {\n  margin-left: unset !important;\n}\nhtml[dir=rtl] ul.notification-dropdown.onhover-show-div li span svg {\n  margin-right: unset;\n  margin-left: 10px;\n}\nhtml[dir=rtl] ul.notification-dropdown.onhover-show-div li .notification-icon {\n  margin-left: 20px;\n  margin-right: unset;\n}\nhtml[dir=rtl] .card-body .alert svg ~ p {\n  padding-left: unset;\n  padding-right: 20px;\n}\nhtml[dir=rtl] .alert i {\n  margin-left: 5px;\n  margin-right: 0;\n}\nhtml[dir=rtl] .inverse {\n  padding: 13px 65px 13px 20px;\n}\nhtml[dir=rtl] .inverse i {\n  left: unset;\n  right: 0;\n}\nhtml[dir=rtl] .alert-primary.inverse:before {\n  border-right: 7px solid #7366ff;\n  right: 54px;\n  left: unset;\n  border-left: unset;\n}\nhtml[dir=rtl] .alert-secondary.inverse:before {\n  border-right: 7px solid #ff3364;\n  right: 54px;\n  left: unset;\n  border-left: unset;\n}\nhtml[dir=rtl] .alert-success.inverse:before {\n  border-right: 7px solid #54ba4a;\n  right: 54px;\n  left: unset;\n  border-left: unset;\n}\nhtml[dir=rtl] .alert-danger.inverse:before {\n  border-right: 7px solid #fc4438;\n  right: 54px;\n  left: unset;\n  border-left: unset;\n}\nhtml[dir=rtl] .alert-warning.inverse:before {\n  border-right: 7px solid #ffaa05;\n  right: 54px;\n  left: unset;\n  border-left: unset;\n}\nhtml[dir=rtl] .alert-info.inverse:before {\n  border-right: 7px solid #16c7f9;\n  right: 54px;\n  left: unset;\n  border-left: unset;\n}\nhtml[dir=rtl] .alert-light.inverse:before {\n  border-right: 7px solid #f4f4f4;\n  right: 54px;\n  left: unset;\n  border-left: unset;\n}\nhtml[dir=rtl] .alert-dark.inverse:before {\n  border-right: 7px solid #2c323f;\n  right: 54px;\n  left: unset;\n  border-left: unset;\n}\nhtml[dir=rtl] .alert-dismissible .btn-close {\n  left: 0;\n  right: unset;\n}\nhtml[dir=rtl] .alert-dismissible .btn-close span {\n  padding-left: 0;\n  padding-right: unset;\n}\nhtml[dir=rtl] .icofont.icofont-truck {\n  display: inline-block;\n}\nhtml[dir=rtl] .blog-box .blog-details {\n  padding-left: 20px;\n  text-align: right;\n}\nhtml[dir=rtl] .blog-box .blog-details .blog-social {\n  padding-right: 0;\n}\nhtml[dir=rtl] .blog-box .blog-details .blog-social li {\n  padding-left: 40px;\n  padding-right: unset;\n}\nhtml[dir=rtl] .blog-box .blog-details .blog-social li:first-child {\n  border-left: 1px solid #777777;\n  border-right: unset;\n  padding-left: 40px;\n  padding-right: unset;\n}\nhtml[dir=rtl] .blog-box .blog-details .blog-social li + li {\n  margin-right: 30px;\n  margin-left: unset;\n  padding-left: 0;\n}\nhtml[dir=rtl] .blog-box .blog-details-main .blog-social li {\n  border-left: 1px dotted;\n  border-right: unset;\n}\nhtml[dir=rtl] .blog-box .blog-details-main .blog-social li:last-child {\n  border-left: none;\n}\nhtml[dir=rtl] .blog-box .blog-date span {\n  font-size: 36px;\n  font-weight: 500;\n  padding-left: 5px;\n}\nhtml[dir=rtl] .comment-box .media img {\n  margin-left: 45px;\n  margin-right: unset;\n}\nhtml[dir=rtl] .comment-box .media h6, html[dir=rtl] .comment-box .media .h6 {\n  text-align: right;\n}\nhtml[dir=rtl] .comment-box ul ul {\n  margin-right: 135px;\n  margin-left: unset;\n  padding-right: 0;\n}\n@media (max-width: 575.98px) {\n  html[dir=rtl] .comment-box ul ul {\n    margin-right: 30px;\n  }\n}\nhtml[dir=rtl] .comment-box .comment-social {\n  text-align: left;\n}\nhtml[dir=rtl] .comment-box .comment-social li {\n  padding-left: 0;\n  padding-right: 20px;\n}\nhtml[dir=rtl] .comment-box .comment-social li:first-child {\n  border-left: 1px solid #efefef;\n  border-right: unset;\n  padding-right: 0;\n  padding-left: 20px;\n}\nhtml[dir=rtl] .button-builder-wrap .form-group .btn {\n  margin-left: 15px;\n  margin-right: 0;\n  padding: 9px;\n}\nhtml[dir=rtl] .button-builder ul.the-icons {\n  padding-right: 0 !important;\n}\nhtml[dir=rtl] .call-chat-body .chat-box .chat-right-aside .chat .chat-history .caller-img.ps-0 {\n  padding-left: 15px !important;\n}\nhtml[dir=rtl] .chat-box .user-image {\n  float: right;\n  margin-left: 5px;\n  margin-right: 0;\n}\nhtml[dir=rtl] .chat-box .people-list .search i {\n  left: 10px;\n  right: unset;\n}\nhtml[dir=rtl] .chat-box .about {\n  float: right;\n  padding-right: 10px;\n  padding-left: unset;\n  text-align: right;\n}\nhtml[dir=rtl] .chat-box .chat-menu {\n  border-right: 1px solid #f4f4f4;\n  border-left: unset;\n}\nhtml[dir=rtl] .chat-box .chat-menu .nav {\n  padding-right: 0;\n}\nhtml[dir=rtl] .chat-box .chat-menu.ps-0 {\n  padding-left: 15px !important;\n}\nhtml[dir=rtl] .chat-box .chat-right-aside .chat .chat-message .smiley-box {\n  margin-left: 0.5rem;\n  margin-right: unset;\n}\nhtml[dir=rtl] .chat-box .chat-right-aside .chat .chat-message .text-box .btn {\n  border-radius: 5px 0 0 5px;\n}\nhtml[dir=rtl] .chat-box .chat-right-aside.pe-0 {\n  padding-right: 15px !important;\n}\nhtml[dir=rtl] .chat-box .chat .chat-message .text-box .input-group-append {\n  margin-right: -2px;\n}\nhtml[dir=rtl] .chat-msg-box ul {\n  padding-right: 0;\n}\nhtml[dir=rtl] .chat-left-aside .status-circle {\n  left: unset;\n  right: 40px;\n}\nhtml[dir=rtl] .chat-right-aside .chat .chat-header .chat-menu-icons {\n  padding-left: 0;\n  padding-right: unset;\n}\nhtml[dir=rtl] .chat-right-aside .chat .chat-header .chat-menu-icons.float-sm-right {\n  float: left !important;\n}\nhtml[dir=rtl] .chat-right-aside .chat .chat-header img {\n  float: right;\n}\nhtml[dir=rtl] .cke_toolbar,\nhtml[dir=rtl] .cke_toolgroup,\nhtml[dir=rtl] a.cke_button,\nhtml[dir=rtl] .cke_combo_text {\n  float: right;\n}\nhtml[dir=rtl] .cke_reset_all,\nhtml[dir=rtl] .cke_reset_all *,\nhtml[dir=rtl] .cke_reset_all a,\nhtml[dir=rtl] .cke_reset_all textarea {\n  text-align: right;\n}\nhtml[dir=rtl] .cke_combo_text {\n  padding-left: unset;\n  padding-right: 10px;\n}\nhtml[dir=rtl] #editor1 #cke_editor1 #cke_1_contents iframe html {\n  direction: rtl !important;\n}\nhtml[dir=rtl] #clockdiv ul {\n  padding-right: 0;\n}\nhtml[dir=rtl] .custom-card .card-footer > div + div {\n  border-right: 1px solid #efefef;\n  border-left: unset !important;\n}\nhtml[dir=rtl] .card-social {\n  padding-right: 0;\n}\nhtml[dir=rtl] .card-absolute .card-header {\n  right: 15px;\n  left: unset;\n}\nhtml[dir=rtl] .dataTables_wrapper .dataTables_filter input[type=search] {\n  margin-right: 10px;\n  margin-left: 0;\n}\nhtml[dir=rtl] .dataTables_wrapper .dataTables_length {\n  float: right;\n}\nhtml[dir=rtl] .dataTables_wrapper .dataTables_filter {\n  margin-left: unset;\n  margin-right: 15px;\n  float: left;\n}\nhtml[dir=rtl] .dataTables_wrapper .dataTables_info {\n  float: right;\n}\nhtml[dir=rtl] .dataTables_wrapper .advance-5_filter {\n  margin-left: 0;\n}\nhtml[dir=rtl] .dataTables_wrapper .btn-group button {\n  margin-left: 5px;\n  margin-right: unset;\n}\nhtml[dir=rtl] .dataTables_wrapper .btn-group button:last-child {\n  margin-left: 0;\n}\nhtml[dir=rtl] .dataTables_wrapper table.dataTable tbody td.select-checkbox:after,\nhtml[dir=rtl] .dataTables_wrapper table.dataTable tbody th.select-checkbox:after {\n  margin-left: 31px;\n}\nhtml[dir=rtl] div.dataTables_wrapper div.dataTables_paginate {\n  margin-right: 15px !important;\n  margin-left: 0 !important;\n  float: left;\n}\nhtml[dir=rtl] table.dataTable thead > tr > th {\n  padding-left: 30px;\n  padding-right: 12px;\n}\nhtml[dir=rtl] table.dataTable thead > tr > th:before {\n  left: 1em !important;\n  right: unset;\n}\nhtml[dir=rtl] table.dataTable thead > tr > th:after {\n  left: 0.5em !important;\n  right: unset;\n}\nhtml[dir=rtl] table.dataTable thead .sorting:before,\nhtml[dir=rtl] table.dataTable thead .sorting_asc:before,\nhtml[dir=rtl] table.dataTable thead .sorting_desc:before,\nhtml[dir=rtl] table.dataTable thead .sorting_asc_disabled:before,\nhtml[dir=rtl] table.dataTable thead .sorting_desc_disabled:before {\n  left: 1em !important;\n  right: unset;\n}\nhtml[dir=rtl] .dataTables_scrollHeadInner {\n  padding-right: unset !important;\n  padding-left: 0 !important;\n}\nhtml[dir=rtl] div.table-responsive > div.dataTables_wrapper > div.row > div[class^=col-]:first-child {\n  padding-right: 0;\n  padding-left: 0;\n}\nhtml[dir=rtl] div.table-responsive > div.dataTables_wrapper > div.row > div[class^=col-]:last-child {\n  padding-right: 0;\n  padding-left: 0;\n}\nhtml[dir=rtl] .dt-plugin-buttons button.m-r-10 {\n  margin-left: 10px;\n  margin-right: 0;\n}\nhtml[dir=rtl] .datetime-picker .theme-form .form-group label {\n  text-align: left !important;\n}\nhtml[dir=rtl] .datetime-picker .theme-form .form-group .input-group-text {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\nhtml[dir=rtl] .datetime-picker .theme-form .form-group .input-group .form-control {\n  border-radius: 0.25rem;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\nhtml[dir=rtl] .dropdown-basic .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-top-right-radius: 0.25rem !important;\n  border-bottom-right-radius: 0.25rem !important;\n}\nhtml[dir=rtl] .dropdown-basic .separated-btn .btn {\n  border-radius: 0.25rem;\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\nhtml[dir=rtl] .dropdown-basic .btn-group {\n  margin-right: unset;\n  margin-left: 18px;\n}\nhtml[dir=rtl] .error-wrapper .col-md-8.offset-md-2 {\n  margin: 0 auto !important;\n}\nhtml[dir=rtl] .product-price del {\n  padding-left: 20px;\n  padding-right: 0;\n}\nhtml[dir=rtl] .product-box .modal .modal-header .btn-close {\n  right: unset;\n  left: 15px;\n}\nhtml[dir=rtl] .product-box .ribbon-bookmark.ribbon-vertical-left.ribbon-info:before,\nhtml[dir=rtl] .product-box .ribbon-bookmark.ribbon-vertical-right.ribbon-info:before {\n  border-left-color: #007bff;\n}\nhtml[dir=rtl] .product-box .ribbon-bookmark.ribbon-vertical-left:before,\nhtml[dir=rtl] .product-box .ribbon-bookmark.ribbon-vertical-right:before {\n  right: 0;\n  left: unset;\n  border-left: 15px solid #2a3142;\n}\nhtml[dir=rtl] .product-box .ribbon-bookmark.ribbon-info:before {\n  border-left-color: transparent;\n}\nhtml[dir=rtl] .product-box .ribbon-warning.ribbon-clip:before {\n  border-left-color: #ff850d;\n  border-right-color: unset;\n}\nhtml[dir=rtl] .product-box .ribbon-clip {\n  right: -14px;\n  left: unset;\n}\nhtml[dir=rtl] .product-box .ribbon-clip:before {\n  right: 0;\n  left: unset;\n}\nhtml[dir=rtl] .product-hover ul {\n  padding-right: 0;\n}\nhtml[dir=rtl] .customer-review .media img {\n  margin-left: 25px;\n  margin-right: 0;\n}\nhtml[dir=rtl] .nav {\n  padding-right: 0;\n}\nhtml[dir=rtl] .custom-tab {\n  padding: 4px;\n}\nhtml[dir=rtl] .custom-file-label::after {\n  left: 0;\n  right: unset;\n}\nhtml[dir=rtl] .wizard-4 ul.anchor {\n  float: right;\n}\nhtml[dir=rtl] .wizard-4 .step-container {\n  clear: unset;\n}\nhtml[dir=rtl] .wizard-4 .form-group {\n  text-align: right;\n}\nhtml[dir=rtl] .wizard-4 .action-bar .btn {\n  float: left;\n}\nhtml[dir=rtl] .f1 .f1-buttons {\n  text-align: left;\n}\nhtml[dir=rtl] .f1 .f1-steps .f1-step {\n  float: right;\n}\nhtml[dir=rtl] .jstree-default .jstree-node {\n  margin-left: unset;\n  margin-right: 24px;\n  background-position: -292px -4px;\n  background-repeat: repeat-y;\n}\nhtml[dir=rtl] .img-cropper .btn-group {\n  margin-right: 0;\n  margin-left: 10px;\n}\nhtml[dir=rtl] .img-cropper .btn-group button:last-child {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\nhtml[dir=rtl] .img-cropper .btn-group button:first-child {\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\nhtml[dir=rtl] .docs-toggles .btn-group .btn {\n  border-radius: 0;\n}\nhtml[dir=rtl] .docs-toggles .btn-group .btn:last-child {\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\nhtml[dir=rtl] .docs-toggles .btn-group .btn:first-child {\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\nhtml[dir=rtl] .btn-group > .btn:not(:last-child):not(.dropdown-toggle) > .btn-group:not(:last-child) > .btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\nhtml[dir=rtl] .jsgrid-button + .jsgrid-button {\n  margin-right: 5px;\n  margin-left: unset;\n}\nhtml[dir=rtl] .product-table .rdt_TableBody .rdt_TableRow .rdt_TableCell .product-name .order-process {\n  padding-right: 15px;\n  padding-left: unset;\n}\nhtml[dir=rtl] .product-table .rdt_TableBody .rdt_TableRow .rdt_TableCell .product-name .order-process .order-process-circle::before {\n  left: 10px;\n}\nhtml[dir=rtl] .list-group {\n  padding-right: 0;\n}\nhtml[dir=rtl] .list-group i,\nhtml[dir=rtl] .list-group img {\n  margin-left: 10px;\n  margin-right: 0;\n}\nhtml[dir=rtl] .list-group i {\n  margin-left: 0;\n  margin-right: 0;\n}\nhtml[dir=rtl] .authentication-box {\n  text-align: right;\n}\nhtml[dir=rtl] .mega-horizontal .offset-sm-3 {\n  margin-right: 25%;\n  margin-left: unset;\n}\nhtml[dir=rtl] .navs-icon svg {\n  margin-left: 10px;\n  margin-right: unset;\n}\nhtml[dir=rtl] .navs-icon .fa {\n  margin-left: 10px;\n  margin-right: unset;\n}\nhtml[dir=rtl] .nav-list .nav-list-disc {\n  text-align: right;\n  padding-right: 0;\n}\nhtml[dir=rtl] .pl-navs-inline {\n  padding-right: 30px !important;\n  padding-left: 0 !important;\n}\nhtml[dir=rtl] .onhover-dropdown.navs-dropdown:hover .onhover-show-div:before {\n  left: 77px;\n  right: unset;\n}\nhtml[dir=rtl] .onhover-dropdown.navs-dropdown:hover .onhover-show-div:after {\n  left: 77px;\n  right: unset;\n}\nhtml[dir=rtl] .navs-dropdown .onhover-show-div .navs-icon li {\n  text-align: right;\n}\nhtml[dir=rtl] .navs-icon.default-according.style-1 li button[aria-expanded=true]:before {\n  left: 2px;\n  right: unset;\n}\nhtml[dir=rtl] .navs-icon.default-according.style-1 li button[aria-expanded=false]:before {\n  left: 2px;\n  right: unset;\n}\nhtml[dir=rtl] .search-form .form-group:after {\n  right: 53px;\n  left: unset;\n}\nhtml[dir=rtl] .search-form .form-group:before {\n  right: 82px;\n  left: unset;\n}\nhtml[dir=rtl] .order-history table tbody tr td .product-name .order-process .order-process-circle:before {\n  right: -15px;\n  left: unset;\n}\nhtml[dir=rtl] .order-history table th:first-child,\nhtml[dir=rtl] .order-history table td:first-child {\n  text-align: right;\n}\nhtml[dir=rtl] .product-page-details span {\n  padding-right: 15px;\n  padding-left: 0;\n}\nhtml[dir=rtl] .m-checkbox-inline label {\n  margin-left: 20px;\n  margin-right: 0;\n}\nhtml[dir=rtl] .form-label-align-right label {\n  text-align: left;\n}\nhtml[dir=rtl] .br-theme-bars-reversed .br-widget .br-current-rating,\nhtml[dir=rtl] .br-theme-bars-movie .br-widget .br-current-rating,\nhtml[dir=rtl] .br-theme-bars-1to10 .br-widget .br-current-rating,\nhtml[dir=rtl] .br-theme-bars-square .br-widget .br-current-rating {\n  float: right;\n}\nhtml[dir=rtl] .br-theme-bars-reversed .br-widget a,\nhtml[dir=rtl] .br-theme-bars-movie .br-widget a,\nhtml[dir=rtl] .br-theme-bars-1to10 .br-widget a,\nhtml[dir=rtl] .br-theme-bars-square .br-widget a {\n  float: right;\n}\nhtml[dir=rtl] .ribbon-left {\n  right: auto;\n  left: -2px;\n}\nhtml[dir=rtl] .ribbon-vertical-left {\n  right: auto;\n  left: 12px;\n}\nhtml[dir=rtl] .ribbon-vertical-right {\n  right: auto;\n  left: 12px;\n}\nhtml[dir=rtl] .star-ratings ul.search-info {\n  padding-right: 0;\n}\nhtml[dir=rtl] .star-ratings ul.search-info li + li {\n  border-right: 1px solid #a5afc6;\n  border-left: unset;\n  padding-right: 8px;\n  padding-left: 0;\n  margin-right: 8px;\n  margin-left: 0;\n}\nhtml[dir=rtl] .select2-container--default .select2-selection--single .select2-selection__arrow {\n  left: 10px !important;\n  right: unset !important;\n}\nhtml[dir=rtl] .select2-container--default .select2-selection--multiple .select2-selection__choice {\n  float: right;\n}\nhtml[dir=rtl] .selection .select2-selection .select2-search__field {\n  text-align: right;\n}\nhtml[dir=rtl] .select2-results__option {\n  text-align: right;\n}\nhtml[dir=rtl] .editor-statusbar {\n  text-align: left;\n}\nhtml[dir=rtl] .editor-statusbar span {\n  margin-right: 1em;\n  margin-left: unset;\n}\nhtml[dir=rtl] .CodeMirror-scroll {\n  margin-left: -30px;\n  margin-right: unset;\n}\nhtml[dir=rtl] .primary-color ul,\nhtml[dir=rtl] .yellow-color ul {\n  padding-right: 0;\n}\nhtml[dir=rtl] .u-step-desc {\n  text-align: right;\n}\nhtml[dir=rtl] .u-step-number {\n  right: 20px;\n  left: unset;\n}\nhtml[dir=rtl] .u-step-number ~ .u-step-desc {\n  margin-right: 50px;\n}\nhtml[dir=rtl] .u-pearl:after {\n  left: 0;\n  right: unset;\n}\nhtml[dir=rtl] .u-pearl:before {\n  right: 0;\n  left: unset;\n}\nhtml[dir=rtl] .u-step-icon {\n  float: right;\n  margin-left: 0.5em;\n  margin-right: unset;\n}\nhtml[dir=rtl] .list-icons {\n  padding-right: 0;\n}\nhtml[dir=rtl] .card-header.note-toolbar .note-color .dropdown-toggle {\n  padding-right: 5px;\n}\nhtml[dir=rtl] .card-header.note-toolbar .form-group.draggable {\n  text-align: right;\n}\nhtml[dir=rtl] .card-header.note-toolbar .form-check {\n  padding-right: 24px;\n  padding-left: unset;\n}\nhtml[dir=rtl] .card-header.note-toolbar form .custom-control {\n  padding-right: 24px;\n  padding-left: unset;\n}\nhtml[dir=rtl] .card-header.note-toolbar form .custom-control .custom-control-label::after {\n  right: 0;\n  left: unset;\n}\nhtml[dir=rtl] .card-header.note-toolbar form .custom-control .custom-control-label::before {\n  right: 0;\n  left: unset;\n}\nhtml[dir=rtl] .dropdown-toggle::after {\n  margin-right: 0.255em;\n  margin-left: unset;\n}\nhtml[dir=rtl] .tabbed-card ul {\n  left: 22px;\n  right: unset;\n}\nhtml[dir=rtl] .checkbox label {\n  padding-right: 16px;\n  padding-left: unset;\n}\nhtml[dir=rtl] .checkbox label::before {\n  right: 0;\n  left: unset;\n  margin-right: -16px;\n  margin-left: unset;\n}\nhtml[dir=rtl] .radio label::after {\n  right: 5px;\n  left: unset;\n  margin-right: -20px;\n  margin-left: unset;\n}\nhtml[dir=rtl] .cd-timeline-content::before {\n  border-right: 7px solid #f4f4f4;\n  border-left-color: transparent;\n}\nhtml[dir=rtl] .cd-timeline-img i {\n  right: 40%;\n  left: unset;\n  margin-right: -12px;\n  margin-left: unset;\n}\nhtml[dir=rtl] .cd-timeline-block:nth-child(even) .cd-timeline-content {\n  float: left;\n  border-left: 7px solid #eeeeee;\n  border-right: unset;\n}\nhtml[dir=rtl] .cd-timeline-block:nth-child(even) .cd-timeline-content .cd-date {\n  right: auto;\n  left: 122%;\n  text-align: left;\n}\nhtml[dir=rtl] .cd-timeline-block:nth-child(even) .cd-timeline-content::before {\n  right: auto;\n  left: 100%;\n  border-left-color: #eeeeee;\n  border-right-color: transparent;\n}\nhtml[dir=rtl] .cd-timeline-content .cd-date {\n  right: 122%;\n  left: unset;\n}\nhtml[dir=rtl] .introjs-tooltip {\n  right: 0;\n  left: unset;\n}\nhtml[dir=rtl] .introjs-helperNumberLayer {\n  right: -16px;\n  left: unset;\n}\nhtml[dir=rtl] .introjs-tooltipReferenceLayer .introjs-tooltip .introjs-tooltiptext {\n  text-align: right;\n}\nhtml[dir=rtl] .introjs-tooltipReferenceLayer .introjs-tooltip .introjs-tooltipbuttons {\n  text-align: left;\n}\nhtml[dir=rtl] .introjs-tooltipReferenceLayer .introjs-tooltip .introjs-tooltipbuttons .introjs-skipbutton {\n  margin-left: 5px;\n  margin-right: unset;\n}\nhtml[dir=rtl] .introjs-tooltipReferenceLayer .introjs-tooltip .introjs-tooltipbuttons .introjs-nextbutton {\n  -webkit-border-radius: 0.2em 0 0 0.2em;\n  -moz-border-radius: 0.2em 0 0 0.2em;\n  border-radius: 0.2em 0 0 0.2em;\n}\nhtml[dir=rtl] .list-inline-item:not(:last-child) {\n  margin-left: 0.5rem;\n  margin-right: unset;\n}\nhtml[dir=rtl] .like-comment ul.list-inline {\n  padding-right: 0;\n}\nhtml[dir=rtl] .typeahead {\n  text-align: right;\n}\nhtml[dir=rtl] .listing ul {\n  padding-right: 0;\n}\nhtml[dir=rtl] .listing ul .icofont {\n  float: right;\n}\nhtml[dir=rtl] .gallery .hover-5 img {\n  margin-right: 30px;\n}\nhtml[dir=rtl] .gallery .hover-5:hover img {\n  margin-right: 0;\n}\nhtml[dir=rtl] .lg-outer {\n  text-align: right;\n}\nhtml[dir=rtl] .lg-toolbar .lg-icon {\n  float: left;\n}\nhtml[dir=rtl] #lg-counter {\n  padding-right: 20px;\n  padding-left: unset;\n  float: right;\n}\nhtml[dir=rtl] .chart-widget-top .text-end {\n  text-align: left !important;\n}\nhtml[dir=rtl] .chart-widget-top .num .ms-1 {\n  margin-right: 0.25rem !important;\n}\nhtml[dir=rtl] .bar-chart-widget .earning-details i {\n  left: -240px;\n}\nhtml[dir=rtl] .bar-chart-widget .bottom-content .b-r-light {\n  border-left: 1px solid #eeeeee !important;\n  border-right: unset !important;\n}\nhtml[dir=rtl] .bar-chart-widget .bottom-content .num .ms-1 {\n  margin-right: 0.25rem !important;\n}\nhtml[dir=rtl] .chart-vertical-center #myDoughnutGraph,\nhtml[dir=rtl] .chart-vertical-center #myPolarGraph {\n  width: auto !important;\n}\nhtml[dir=rtl] .crm-activity ul.dates li + li {\n  border-right: 1px solid #ddd;\n  padding-right: 10px;\n  margin-right: 5px;\n  border-left: unset;\n  padding-left: unset;\n  margin-left: unset;\n}\nhtml[dir=rtl] div.dt-buttons {\n  float: right;\n}\nhtml[dir=rtl] .dt-button-collection {\n  left: -39px !important;\n}\nhtml[dir=rtl] .dropzone .dz-preview .dz-error-mark,\nhtml[dir=rtl] .dropzone .dz-preview .dz-success-mark {\n  right: 50%;\n  margin-right: -27px;\n  margin-left: unset;\n  left: unset;\n}\nhtml[dir=rtl] .page-wrapper .page-body-wrapper footer {\n  margin-right: 265px;\n  margin-left: unset;\n}\nhtml[dir=rtl] .page-wrapper .page-body-wrapper footer p i {\n  margin-right: 5px;\n  margin-left: unset;\n}\nhtml[dir=rtl] .footer-copyright {\n  text-align: right;\n}\nhtml[dir=rtl] .footer-links {\n  text-align: left;\n}\nhtml[dir=rtl] .page-item:first-child .page-link {\n  margin-right: 0;\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-left: none;\n}\nhtml[dir=rtl] .page-item:last-child .page-link {\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\nhtml[dir=rtl] .popover.top > .arrow:after,\nhtml[dir=rtl] .popover.bottom > .arrow:after {\n  margin-right: -10px;\n  margin-left: unset;\n}\nhtml[dir=rtl] .bootstrap-touchspin > .input-group-append > .btn,\nhtml[dir=rtl] .bootstrap-touchspin > .input-group-append > .input-group-text {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\nhtml[dir=rtl] .bootstrap-touchspin > .form-control:not(:last-child),\nhtml[dir=rtl] .bootstrap-touchspin > .custom-select:not(:last-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\nhtml[dir=rtl] .typeahead span.twitter-typeahead .tt-suggestion {\n  text-align: right;\n}\nhtml[dir=rtl] .typeahead .league-name {\n  text-align: right;\n  margin-right: 5px;\n}\nhtml[dir=rtl] .follow .text-md-right {\n  text-align: left !important;\n}\nhtml[dir=rtl] .jvectormap-zoomin,\nhtml[dir=rtl] .jvectormap-zoomout,\nhtml[dir=rtl] .jvectormap-goback {\n  right: 10px;\n  left: unset;\n}\nhtml[dir=rtl] .customizer-links {\n  right: unset;\n  left: 0;\n}\nhtml[dir=rtl] .customizer-links > .nav {\n  padding-right: 10px;\n}\nhtml[dir=rtl] .customizer-links .nav-link:after {\n  right: -10px;\n  left: unset;\n  border-width: 5px 5px 5px 0;\n  border-left-color: unset;\n  border-right-color: rgb(90.8496732026%, 90%, 100%);\n}\nhtml[dir=rtl] .customizer-links .nav-link span {\n  right: unset;\n  left: -60px;\n}\nhtml[dir=rtl] .customizer-links .nav-link:hover span {\n  left: 48px;\n}\nhtml[dir=rtl] .customizer-links.open {\n  right: unset;\n  left: 330px;\n  border-radius: 0 8px 8px 0;\n}\nhtml[dir=rtl] .customizer-contain {\n  width: 330px;\n  right: unset;\n  left: -330px;\n}\nhtml[dir=rtl] .customizer-contain.open {\n  right: unset;\n  left: 0px;\n}\nhtml[dir=rtl] .customizer-contain .customizer-header .icon-close {\n  left: unset;\n  right: 30px;\n}\nhtml[dir=rtl] .box-layout.page-wrapper.horizontal-wrapper .page-header {\n  padding-right: 250px;\n  padding-left: unset;\n}\nhtml[dir=rtl] .box-layout.page-wrapper.horizontal-wrapper .page-header.open {\n  padding-right: 0;\n}\nhtml[dir=rtl] .box-layout.page-wrapper.compact-wrapper .page-body-wrapper .page-body {\n  margin-left: unset;\n  margin-right: 230px;\n}\nhtml[dir=rtl] .box-layout.page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper.close_icon ~ footer {\n  width: 1280px;\n  padding-left: 0;\n  left: 50%;\n}\nhtml[dir=rtl] .box-layout.page-wrapper.compact-wrapper .page-header {\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: unset;\n  padding-right: 230px;\n}\nhtml[dir=rtl] .box-layout.page-wrapper.compact-wrapper .page-header.close_icon {\n  padding-right: 100px;\n}\nhtml[dir=rtl] body.dark-only .custom-card .card-footer > div + div {\n  border-right: 1px solid #374558;\n}\nhtml[dir=rtl] body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .b-r-light,\nhtml[dir=rtl] body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .border-right {\n  border-right: none !important;\n  border-left: 1px solid #374558 !important;\n}\n@media screen and (max-width: 1660px) {\n  html[dir=rtl] .caller-img {\n    left: unset;\n    right: 15px;\n  }\n}\n@media only screen and (max-width: 1366px) {\n  html[dir=rtl] .profile-dropdown.onhover-show-div {\n    right: unset !important;\n    left: 0 !important;\n  }\n  html[dir=rtl] .product-wrapper .product-grid .feature-products {\n    margin-right: 0;\n  }\n  html[dir=rtl] .product-grid {\n    margin-right: 0;\n  }\n  html[dir=rtl] .d-none-productlist {\n    margin-left: 10px;\n    margin-right: unset;\n  }\n  html[dir=rtl] .photos ul li:nth-child(3n) {\n    margin-left: 15px;\n    margin-right: unset;\n  }\n  html[dir=rtl] .chat-left-aside .status-circle {\n    left: unset;\n    right: 22px;\n  }\n}\n@media (min-width: 1200px) {\n  html[dir=rtl] .float-xl-end {\n    float: left !important;\n  }\n  html[dir=rtl] .chat-box .pe-xl-0 {\n    padding-left: 0 !important;\n    padding-right: 15px !important;\n  }\n  html[dir=rtl] .chat-box .ps-xl-0 {\n    padding-right: 0 !important;\n    padding-left: 15px !important;\n  }\n  html[dir=rtl] .pixelstrap ul a:hover .sub-arrow, html[dir=rtl] .pixelstrap ul a:focus .sub-arrow, html[dir=rtl] .pixelstrap ul a:active .sub-arrow, html[dir=rtl] .pixelstrap ul a.highlighted .sub-arrow {\n    left: 3px;\n    right: unset;\n  }\n}\n@media (min-width: 992px) {\n  html[dir=rtl] .text-lg-start {\n    text-align: right !important;\n  }\n}\n@media only screen and (max-width: 1199.98px) {\n  html[dir=rtl] .jkanban-container .btn {\n    margin-left: unset;\n    margin-right: 20px;\n  }\n  html[dir=rtl] .link-section > div > h6:before, html[dir=rtl] .link-section > div > .h6:before {\n    right: unset;\n    left: 10px;\n  }\n  html[dir=rtl] .page-wrapper .page-header .header-wrapper .nav-right > ul li .submenu li:first-child {\n    padding-right: 15px !important;\n    padding-left: 15px !important;\n  }\n  html[dir=rtl] .user-profile .hovercard .user-image .share-icons {\n    left: 45px;\n  }\n  html[dir=rtl] .email-wrap .row .col-xl-6 {\n    padding-right: 15px;\n  }\n  html[dir=rtl] .email-wrap .row .col-xl-3 + .col-xl-3 {\n    padding-left: 15px;\n  }\n  html[dir=rtl] .email-wrap .email-app-sidebar .main-menu > li {\n    text-align: right;\n  }\n  html[dir=rtl] .email-wrap .email-app-sidebar .main-menu > li a i {\n    margin-right: unset;\n    margin-left: 10px;\n  }\n  html[dir=rtl] .email-wrap .email-app-sidebar ul {\n    padding-right: 0;\n  }\n  html[dir=rtl] .email-wrap .email-content .email-top .user-emailid:after {\n    float: left;\n  }\n  html[dir=rtl] .email-wrap .email-right-aside .email-body .pe-0 {\n    padding-right: unset !important;\n  }\n  html[dir=rtl] .email-wrap .email-right-aside .radius-left {\n    border-top-right-radius: 0 !important;\n    border-bottom-right-radius: 0 !important;\n    border-radius: 4px;\n  }\n  html[dir=rtl] .chat-menu-icons {\n    text-align: left;\n  }\n  html[dir=rtl] .chat-box .chat-history .row .col-sm-7 {\n    padding-left: 0 !important;\n    padding-right: unset !important;\n  }\n  html[dir=rtl] .chat-menu {\n    left: 0;\n    right: unset;\n  }\n}\n@media only screen and (max-width: 991.98px) {\n  html[dir=rtl] .todo .todo-list-wrapper .mark-all-tasks {\n    left: 20px;\n  }\n  html[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon {\n    transform: translate(285px);\n  }\n  html[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon:hover {\n    transform: translate(285px);\n  }\n  html[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .logo-wrapper .back-btn {\n    float: left;\n    transform: rotate(180deg);\n  }\n  html[dir=rtl] .page-wrapper.compact-wrapper .page-header .header-wrapper .toggle-sidebar {\n    margin-right: 0;\n    border-right: none;\n    padding-right: 0;\n    border-left: 1px solid #ddd;\n    margin-left: 15px;\n    padding-left: 15px;\n  }\n  html[dir=rtl] .page-wrapper.compact-sidebar .page-header {\n    margin-right: 0;\n  }\n  html[dir=rtl] .page-wrapper.material-icon .page-header {\n    padding-right: 0;\n  }\n  html[dir=rtl] .page-wrapper.material-icon .page-body-wrapper .page-body {\n    padding-right: 15px;\n  }\n  html[dir=rtl] .faq-accordion .faq-header svg {\n    left: 20px;\n  }\n  html[dir=rtl] .page-wrapper .page-header .header-logo-wrapper .logo-wrapper img {\n    margin-left: 15px;\n    margin-right: unset;\n  }\n  html[dir=rtl] .page-body-wrapper .page-body,\n  html[dir=rtl] .page-body-wrapper footer {\n    margin-right: 0 !important;\n  }\n  html[dir=rtl] .main .langChoice {\n    left: 20px;\n  }\n  html[dir=rtl] .cd-timeline-img i {\n    right: 50% !important;\n  }\n  html[dir=rtl] .page-wrapper .page-body-wrapper .page-title .breadcrumb {\n    margin-right: 0;\n  }\n  html[dir=rtl] .page-wrapper .page-body-wrapper .page-body {\n    min-height: calc(100vh - 60px);\n  }\n  html[dir=rtl] .page-wrapper .page-header {\n    margin-right: 0;\n  }\n  html[dir=rtl] .page-wrapper.compact-wrapper .page-header {\n    margin-right: 0 !important;\n    margin-left: unset !important;\n  }\n  html[dir=rtl] .page-wrapper.compact-wrapper .page-body-wrapper.sidebar-wrapper.close_icon {\n    transform: translate(285px);\n  }\n  html[dir=rtl] .card-body .value-left {\n    margin-left: 20px;\n  }\n  html[dir=rtl] .bookmark ul li .search-form .form-control-search {\n    left: -127px;\n  }\n  html[dir=rtl] .card .card-header .card-header-right {\n    left: 15px;\n  }\n}\n@media only screen and (max-width: 991px) and (min-width: 768px) {\n  html[dir=rtl] .page-wrapper.compact-wrapper.material-type .page-body-wrapper div.sidebar-wrapper {\n    left: unset;\n    right: 0;\n  }\n}\n@media (min-width: 768px) {\n  html[dir=rtl] .float-md-end {\n    float: left !important;\n  }\n  html[dir=rtl] .text-md-end {\n    text-align: left !important;\n  }\n  html[dir=rtl] .offset-md-3 {\n    margin-right: 25%;\n    margin-left: unset;\n  }\n  html[dir=rtl] .text-md-start {\n    text-align: right !important;\n  }\n  html[dir=rtl] .ecommerce-widget .text-md-end {\n    text-align: left !important;\n  }\n  html[dir=rtl] .ecommerce-widget .text-md-end ul {\n    text-align: left;\n  }\n}\n@media only screen and (max-width: 767.98px) {\n  html[dir=rtl] .list-persons .profile-mail .email-general ul {\n    padding-left: 0;\n  }\n  html[dir=rtl] .product-wrapper.sidebaron .product-grid .product-wrapper-grid {\n    margin-right: 0;\n  }\n  html[dir=rtl] .product-sidebar {\n    transform: translateX(300px) scaleX(1);\n  }\n  html[dir=rtl] .product-sidebar.open {\n    transform: translateX(0px) scaleX(1);\n  }\n  html[dir=rtl] .feature-products .filter-toggle {\n    margin-right: 10px;\n    margin-left: unset;\n  }\n  html[dir=rtl] .user-profile .hovercard .user-image .share-icons {\n    left: 25px !important;\n  }\n  html[dir=rtl] .ecommerce-widget .text-md-right {\n    text-align: left !important;\n  }\n  html[dir=rtl] .bar-chart-widget .earning-details i {\n    left: -147px !important;\n  }\n}\n@media (min-width: 576px) {\n  html[dir=rtl] .offset-sm-3 {\n    margin-right: 25%;\n    margin-left: unset;\n  }\n  html[dir=rtl] .text-sm-end {\n    text-align: left !important;\n  }\n  html[dir=rtl] .float-sm-end {\n    float: left !important;\n  }\n  html[dir=rtl] .me-sm-2 {\n    margin-left: 0.5rem !important;\n    margin-right: unset !important;\n  }\n}\n@media only screen and (max-width: 575.98px) {\n  html[dir=rtl] .todo .todo-list-wrapper .mark-all-tasks {\n    left: 15px;\n  }\n  html[dir=rtl] .list-persons .nav-pills .nav-link .media .media-body {\n    text-align: right;\n  }\n  html[dir=rtl] .mega-menu {\n    padding-left: unset;\n    padding-right: 15px;\n  }\n  html[dir=rtl] .page-wrapper .page-header .header-wrapper .nav-right > ul li {\n    margin-right: unset;\n    margin-left: 1px;\n  }\n  html[dir=rtl] .page-wrapper .page-header .header-wrapper .search-full .form-group .close-search {\n    left: 0;\n  }\n  html[dir=rtl] .page-wrapper.compact-wrapper .page-header .header-wrapper .toggle-sidebar, html[dir=rtl] .page-wrapper.compact-sidebar .page-header .header-wrapper .toggle-sidebar {\n    margin-left: 8px;\n    padding-left: 8px;\n    margin-right: unset;\n    padding-right: unset;\n    border-right: unset;\n    border-left: 1px solid #ddd;\n  }\n  html[dir=rtl] .translate_wrapper.active .more_lang.active {\n    left: unset;\n    right: 12px;\n  }\n  html[dir=rtl] .page-header .header-wrapper .nav-right > ul > li:last-child {\n    padding-right: 10px;\n  }\n  html[dir=rtl] .page-header .header-wrapper .nav-right.right-header ul.notification-dropdown {\n    left: unset !important;\n    right: 15px !important;\n  }\n  html[dir=rtl] .faq-accordion .faq-header svg {\n    left: 15px;\n  }\n  html[dir=rtl] .user-profile .hovercard .user-image .share-icons {\n    left: 15px !important;\n  }\n  html[dir=rtl] .user-profile .hovercard .user-image .share-icons li {\n    margin-left: 0px;\n  }\n  html[dir=rtl] .main .langChoice {\n    left: 15px;\n  }\n  html[dir=rtl] .page-wrapper .search-form .form-group {\n    margin-left: 0;\n  }\n  html[dir=rtl] .card-body .value-left {\n    margin-left: 15px;\n  }\n}\n@media only screen and (max-width: 480px) {\n  html[dir=rtl] .page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div {\n    right: unset;\n    left: 20px;\n  }\n  html[dir=rtl] .knob-chart .chart-clock-main {\n    width: unset;\n  }\n  html[dir=rtl] .knob-chart .chart-clock-main .clock-small {\n    right: 32px;\n  }\n  html[dir=rtl] .knob-chart .chart-clock-main .clock-large {\n    right: 0;\n    left: unset;\n  }\n  html[dir=rtl] .knob-chart .chart-clock-main .clock-medium {\n    right: 32px;\n    left: unset;\n  }\n}\n@media only screen and (max-width: 420px) {\n  html[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu,\n  html[dir=rtl] .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container {\n    right: 112px;\n  }\n  html[dir=rtl] .page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu,\n  html[dir=rtl] .page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container {\n    right: 80px;\n  }\n}\n@media only screen and (max-width: 360px) {\n  html[dir=rtl] .prooduct-details-box .close {\n    left: 0;\n  }\n  html[dir=rtl] .social-app-profile .hovercard .user-image .avatar img {\n    width: 85px;\n    height: 85px;\n  }\n  html[dir=rtl] .social-app-profile .hovercard .user-image .avatar {\n    margin-top: -47px;\n  }\n  html[dir=rtl] .social-chat .other-msg {\n    margin-right: 15px;\n  }\n}\n@media screen and (max-width: 1460px) {\n  html[dir=rtl] .sidebar-wrapper .sidebar-main .sidebar-links > li {\n    margin-left: 8px;\n    margin-right: unset;\n  }\n}\n\n@media screen and (min-width: 992px) {\n  .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-main .sidebar-links > li:hover .sidebar-submenu {\n    margin-top: 8px;\n    opacity: 1;\n    transition: all 0.5s ease;\n    visibility: visible;\n  }\n}\n/**=====================\n    60. RTL CSS Ends\n==========================**/\n/**=====================\n    63. Box-layout CSS start\n==========================**/\n.box-layout {\n  background-image: url(../../images/other-images/boxbg.jpg);\n  background-blend-mode: overlay;\n  background-color: rgba(255, 255, 255, 0.5);\n}\n@media only screen and (min-width: 1280px) {\n  .box-layout .learning-filter {\n    order: -1;\n  }\n  .box-layout .md-sidebar .md-sidebar-toggle {\n    display: block;\n  }\n  .box-layout .md-sidebar .md-sidebar-aside {\n    position: absolute;\n    top: 40px;\n    left: 0;\n    opacity: 0;\n    visibility: hidden;\n    z-index: 3;\n    width: 280px;\n  }\n  .box-layout .md-sidebar .md-sidebar-aside.open {\n    opacity: 1;\n    visibility: visible;\n  }\n  .box-layout .job-sidebar {\n    background-color: var(--white);\n    padding: 20px;\n  }\n  .box-layout .widget-1.mb-xl-0 {\n    margin-bottom: 25px !important;\n  }\n  .box-layout .radial-progress-card .radial-chart-wrap {\n    margin-right: -10px;\n  }\n  .box-layout .currency-widget div[class*=bg-light-] {\n    display: none;\n  }\n  .box-layout .box-order .order-1 {\n    order: 1 !important;\n  }\n  .box-layout .activity-card .appointment-table.customer-table {\n    height: 187px;\n  }\n  .box-layout .transaction-table tr td:first-child {\n    min-width: 150px;\n  }\n  .box-layout .welcome-card .welcome-img {\n    height: 170px;\n    bottom: -22px;\n  }\n  .box-layout .purchase-card img {\n    margin: -210px auto 0;\n    width: 80%;\n  }\n  .box-layout .purchase-card.discover {\n    margin-top: 90px;\n  }\n  .box-layout .purchase-card.discover img {\n    margin-top: -90px;\n    width: 64%;\n  }\n  .box-layout .apache-cotainer-large > div,\n  .box-layout .apache-cotainer-large canvas,\n  .box-layout #line-visual > div,\n  .box-layout #line-visual canvas,\n  .box-layout #line-visulH > div,\n  .box-layout #line-visulH canvas {\n    width: 100% !important;\n  }\n  .box-layout .page-wrapper.box-layout, .box-layout.page-wrapper.box-layout {\n    padding-top: 40px;\n    margin-top: 0 !important;\n  }\n  .box-layout .page-wrapper.compact-wrapper, .box-layout.page-wrapper.compact-wrapper {\n    margin-top: 40px;\n  }\n  .box-layout .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper, .box-layout.page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper {\n    width: 230px;\n    top: 40px;\n    border-radius: 10px 0 0 10px;\n  }\n  .box-layout .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper.close_icon ~ footer, .box-layout.page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper.close_icon ~ footer {\n    width: 1200px;\n    left: 47%;\n  }\n  .box-layout .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper.close_icon ~ .footer-fix, .box-layout.page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper.close_icon ~ .footer-fix {\n    padding-left: 0;\n  }\n  .box-layout .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper.close_icon .sidebar-main .sidebar-links, .box-layout.page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper.close_icon .sidebar-main .sidebar-links {\n    height: calc(100vh - 196px);\n  }\n  .box-layout .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper .logo-wrapper, .box-layout.page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper .logo-wrapper {\n    box-shadow: 0 8px 6px -6px rgba(89, 102, 122, 0.1);\n  }\n  .box-layout .page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links, .box-layout.page-wrapper.compact-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links {\n    margin-top: 10px;\n    margin-bottom: 20px;\n    height: calc(100vh - 191px);\n  }\n  .box-layout .page-wrapper.compact-wrapper .page-body-wrapper .page-body, .box-layout.page-wrapper.compact-wrapper .page-body-wrapper .page-body {\n    min-height: calc(100vh - 130px);\n    margin-top: 0;\n    top: 80px;\n    overflow: scroll;\n    max-height: calc(100vh - 220px);\n    padding-bottom: 80px;\n    margin-left: 230px;\n  }\n  .box-layout .page-wrapper.compact-wrapper .page-body-wrapper .page-body::-webkit-scrollbar-track, .box-layout.page-wrapper.compact-wrapper .page-body-wrapper .page-body::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 6px #ecf3fa;\n  }\n  .box-layout .page-wrapper.compact-wrapper .page-body-wrapper .page-body::-webkit-scrollbar, .box-layout.page-wrapper.compact-wrapper .page-body-wrapper .page-body::-webkit-scrollbar {\n    width: 6px;\n  }\n  .box-layout .page-wrapper.compact-wrapper .page-body-wrapper .page-body::-webkit-scrollbar-thumb, .box-layout.page-wrapper.compact-wrapper .page-body-wrapper .page-body::-webkit-scrollbar-thumb {\n    background-color: rgba(68, 102, 242, 0.15);\n  }\n  .box-layout .page-wrapper.compact-sidebar .page-header, .box-layout.page-wrapper.compact-sidebar .page-header {\n    padding-left: 148px;\n  }\n  .box-layout .page-wrapper.compact-sidebar .page-body-wrapper, .box-layout.page-wrapper.compact-sidebar .page-body-wrapper {\n    margin-top: 40px;\n  }\n  .box-layout .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper, .box-layout.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper {\n    top: 40px;\n  }\n  .box-layout .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper.close_icon, .box-layout.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper.close_icon {\n    display: none;\n    transition: 0.5s;\n  }\n  .box-layout .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links, .box-layout.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links {\n    height: calc(100vh - 166px);\n    margin: 0;\n  }\n  .box-layout .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu,\n  .box-layout .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container, .box-layout.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu,\n  .box-layout.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container {\n    left: 470px;\n    top: 40px;\n    height: calc(100vh - 84px);\n  }\n  .box-layout .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a.active ~ .sidebar-submenu,\n  .box-layout .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a.active ~ .mega-menu-container, .box-layout.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a.active ~ .sidebar-submenu,\n  .box-layout.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a.active ~ .mega-menu-container {\n    animation: unset;\n  }\n  .box-layout .page-wrapper.compact-sidebar .page-body-wrapper .footer, .box-layout.page-wrapper.compact-sidebar .page-body-wrapper .footer {\n    margin-left: 0;\n  }\n  .box-layout .page-wrapper.compact-sidebar .page-body-wrapper .page-body, .box-layout.page-wrapper.compact-sidebar .page-body-wrapper .page-body {\n    min-height: calc(100vh - 90px);\n    margin-top: 0;\n    top: 80px;\n    overflow: scroll;\n    max-height: calc(100vh - 170px);\n    padding-bottom: 80px;\n  }\n  .box-layout .page-wrapper.compact-sidebar .page-body-wrapper .page-body::-webkit-scrollbar-track, .box-layout.page-wrapper.compact-sidebar .page-body-wrapper .page-body::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 6px #ecf3fa;\n  }\n  .box-layout .page-wrapper.compact-sidebar .page-body-wrapper .page-body::-webkit-scrollbar, .box-layout.page-wrapper.compact-sidebar .page-body-wrapper .page-body::-webkit-scrollbar {\n    width: 6px;\n  }\n  .box-layout .page-wrapper.compact-sidebar .page-body-wrapper .page-body::-webkit-scrollbar-thumb, .box-layout.page-wrapper.compact-sidebar .page-body-wrapper .page-body::-webkit-scrollbar-thumb {\n    background-color: rgba(68, 102, 242, 0.15);\n  }\n  .box-layout .page-wrapper.compact-sidebar.compact-small .page-header, .box-layout.page-wrapper.compact-sidebar.compact-small .page-header {\n    padding-left: 90px;\n  }\n  .box-layout .page-wrapper.compact-sidebar.compact-small .page-header.close_icon, .box-layout.page-wrapper.compact-sidebar.compact-small .page-header.close_icon {\n    padding-left: 0;\n  }\n  .box-layout .page-wrapper.compact-sidebar.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu,\n  .box-layout .page-wrapper.compact-sidebar.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container, .box-layout.page-wrapper.compact-sidebar.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu,\n  .box-layout.page-wrapper.compact-sidebar.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container {\n    left: 410px;\n  }\n  .box-layout .page-wrapper.horizontal-wrapper:before, .box-layout.page-wrapper.horizontal-wrapper:before {\n    display: none;\n  }\n  .box-layout .page-wrapper.horizontal-wrapper .page-body-wrapper, .box-layout.page-wrapper.horizontal-wrapper .page-body-wrapper {\n    margin-top: 40px;\n  }\n  .box-layout .page-wrapper.horizontal-wrapper .page-body-wrapper .page-body, .box-layout.page-wrapper.horizontal-wrapper .page-body-wrapper .page-body {\n    margin-top: 80px;\n    min-height: calc(100vh - 310px);\n    max-height: calc(100vh - 230px);\n    overflow: scroll;\n  }\n  .box-layout .page-wrapper.horizontal-wrapper .page-body-wrapper .page-body::-webkit-scrollbar-track, .box-layout.page-wrapper.horizontal-wrapper .page-body-wrapper .page-body::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 6px #ecf3fa;\n  }\n  .box-layout .page-wrapper.horizontal-wrapper .page-body-wrapper .page-body::-webkit-scrollbar, .box-layout.page-wrapper.horizontal-wrapper .page-body-wrapper .page-body::-webkit-scrollbar {\n    width: 6px;\n  }\n  .box-layout .page-wrapper.horizontal-wrapper .page-body-wrapper .page-body::-webkit-scrollbar-thumb, .box-layout.page-wrapper.horizontal-wrapper .page-body-wrapper .page-body::-webkit-scrollbar-thumb {\n    background-color: rgba(68, 102, 242, 0.15);\n  }\n  .box-layout .page-wrapper.horizontal-wrapper .page-body-wrapper .footer, .box-layout.page-wrapper.horizontal-wrapper .page-body-wrapper .footer {\n    padding-left: 15px;\n  }\n  .box-layout .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper, .box-layout.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper {\n    width: 1280px;\n    top: 80px;\n    margin: 0;\n    overflow-x: unset;\n    position: relative;\n  }\n  .box-layout .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main #sidebar-menu, .box-layout.page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main #sidebar-menu {\n    left: 0%;\n    transform: translate(0, 0);\n    top: 125px;\n    background-color: #fff;\n  }\n  .box-layout .page-wrapper.horizontal-wrapper .page-header, .box-layout.page-wrapper.horizontal-wrapper .page-header {\n    padding-left: 0;\n  }\n  .box-layout .page-wrapper.modern-type .page-header, .box-layout.page-wrapper.modern-type .page-header {\n    padding-left: 0px;\n  }\n  .box-layout .page-wrapper.modern-type .page-header .header-wrapper .left-header, .box-layout.page-wrapper.modern-type .page-header .header-wrapper .left-header {\n    width: 36%;\n  }\n  .box-layout .page-wrapper.modern-type .page-header .header-wrapper .nav-right, .box-layout.page-wrapper.modern-type .page-header .header-wrapper .nav-right {\n    width: 46%;\n  }\n  .box-layout .page-wrapper.modern-type .page-body-wrapper .page-body, .box-layout.page-wrapper.modern-type .page-body-wrapper .page-body {\n    margin-left: 260px;\n  }\n  .box-layout .page-wrapper.modern-type .page-body-wrapper .sidebar-wrapper, .box-layout.page-wrapper.modern-type .page-body-wrapper .sidebar-wrapper {\n    top: 120px;\n  }\n  .box-layout .page-wrapper.modern-type .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links, .box-layout.page-wrapper.modern-type .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links {\n    height: calc(100vh - 311px);\n  }\n  .box-layout .page-wrapper.modern-type .page-body-wrapper .sidebar-wrapper.close_icon .sidebar-main .sidebar-links, .box-layout.page-wrapper.modern-type .page-body-wrapper .sidebar-wrapper.close_icon .sidebar-main .sidebar-links {\n    height: calc(100vh - 316px);\n  }\n  .box-layout .page-wrapper.modern-type .page-body-wrapper .sidebar-wrapper.close_icon ~ footer, .box-layout.page-wrapper.modern-type .page-body-wrapper .sidebar-wrapper.close_icon ~ footer {\n    width: 1280px;\n    left: 50%;\n    margin-left: 0;\n  }\n  .box-layout .page-wrapper.modern-type .page-body-wrapper .footer, .box-layout.page-wrapper.modern-type .page-body-wrapper .footer {\n    margin-left: 0;\n  }\n  .box-layout .page-wrapper .page-header, .box-layout.page-wrapper .page-header {\n    max-width: 1280px;\n    margin: 0 auto;\n    left: 0;\n    right: 0;\n    transition: 0.5s;\n    padding-left: 230px;\n    margin-top: 40px;\n    border-radius: 10px;\n    width: unset;\n  }\n  .box-layout .page-wrapper .page-header.close_icon, .box-layout.page-wrapper .page-header.close_icon {\n    padding-left: 0;\n    margin-left: auto;\n    width: calc(100% - 0px);\n    transition: 0.5s;\n  }\n  .box-layout .page-wrapper .page-header .header-wrapper, .box-layout.page-wrapper .page-header .header-wrapper {\n    border: 1px solid #f8f8f8;\n    border-radius: 10px 10px 0 0;\n  }\n  .box-layout .page-wrapper.horizontal-wrapper .page-header .header-wrapper .nav-right,\n  .box-layout .page-wrapper.horizontal-wrapper .page-header .header-wrapper .left-header, .box-layout.page-wrapper.horizontal-wrapper .page-header .header-wrapper .nav-right,\n  .box-layout.page-wrapper.horizontal-wrapper .page-header .header-wrapper .left-header {\n    width: 36%;\n  }\n  .box-layout .page-wrapper.material-type .page-body-wrapper, .box-layout.page-wrapper.material-type .page-body-wrapper {\n    margin-top: 0;\n  }\n  .box-layout .page-wrapper.material-type .page-body-wrapper .page-body, .box-layout.page-wrapper.material-type .page-body-wrapper .page-body {\n    margin-top: 0;\n  }\n  .box-layout .page-wrapper.material-type .page-body-wrapper .sidebar-wrapper, .box-layout.page-wrapper.material-type .page-body-wrapper .sidebar-wrapper {\n    top: 0;\n  }\n  .box-layout .page-wrapper.material-icon .page-header.close_icon, .box-layout.page-wrapper.material-icon .page-header.close_icon {\n    margin-top: 40px !important;\n  }\n  .box-layout .page-wrapper.material-icon .page-body-wrapper, .box-layout.page-wrapper.material-icon .page-body-wrapper {\n    margin-top: 0;\n  }\n  .box-layout .page-wrapper.material-icon .page-body-wrapper .page-body, .box-layout.page-wrapper.material-icon .page-body-wrapper .page-body {\n    top: 0;\n    min-height: calc(100vh - 170px);\n    padding-bottom: 40px;\n  }\n  .box-layout .page-wrapper.advance-layout .page-header, .box-layout.page-wrapper.advance-layout .page-header {\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.07);\n  }\n  .box-layout .page-wrapper.advance-layout .page-body-wrapper, .box-layout.page-wrapper.advance-layout .page-body-wrapper {\n    margin-top: 0;\n  }\n  .box-layout .page-wrapper .page-body-wrapper, .box-layout.page-wrapper .page-body-wrapper {\n    width: 1280px;\n    box-shadow: 4px 11px 25px rgba(0, 0, 0, 0.07);\n    margin: 0 auto;\n    overflow: hidden;\n  }\n  .box-layout .page-wrapper .page-body-wrapper .todo .todo-list-wrapper #todo-list li .task-responsive, .box-layout.page-wrapper .page-body-wrapper .todo .todo-list-wrapper #todo-list li .task-responsive {\n    min-width: 1087px;\n    overflow: auto;\n  }\n  .box-layout .page-wrapper .page-body-wrapper .active-order-table, .box-layout.page-wrapper .page-body-wrapper .active-order-table {\n    max-width: 443px;\n    overflow: auto;\n  }\n  .box-layout .page-wrapper .page-body-wrapper .active-order-table table tbody tr td p, .box-layout.page-wrapper .page-body-wrapper .active-order-table table tbody tr td p {\n    width: 100px;\n  }\n  .box-layout .page-wrapper .page-body-wrapper .activity .media .gradient-round.gradient-line-1:after, .box-layout.page-wrapper .page-body-wrapper .activity .media .gradient-round.gradient-line-1:after {\n    height: 57px;\n    bottom: -64px;\n  }\n  .box-layout .page-wrapper .page-body-wrapper .activity .media .gradient-round.small-line:after, .box-layout.page-wrapper .page-body-wrapper .activity .media .gradient-round.small-line:after {\n    height: 36px;\n    bottom: -43px;\n  }\n  .box-layout .page-wrapper .page-body-wrapper .activity .media .gradient-round.medium-line:after, .box-layout.page-wrapper .page-body-wrapper .activity .media .gradient-round.medium-line:after {\n    height: 40px;\n    bottom: -48px;\n  }\n  .box-layout .page-wrapper .page-body-wrapper footer, .box-layout.page-wrapper .page-body-wrapper footer {\n    width: 1280px;\n    margin: 0 auto;\n    padding-left: 230px;\n    margin-bottom: 40px !important;\n    position: fixed;\n    left: 50%;\n    transform: translate(-50%, 0);\n    border-radius: 0 0 10px;\n  }\n  .box-layout .page-wrapper .page-body-wrapper .blockquote-footer, .box-layout.page-wrapper .page-body-wrapper .blockquote-footer {\n    margin-left: 0;\n    width: 100%;\n  }\n  .box-layout .page-wrapper .page-body-wrapper .footer-fix, .box-layout.page-wrapper .page-body-wrapper .footer-fix {\n    padding-left: 230px;\n  }\n  .box-layout .page-wrapper .page-body-wrapper .chat-box .chat-history .call-content, .box-layout.page-wrapper .page-body-wrapper .chat-box .chat-history .call-content {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 300px;\n  }\n  .box-layout .page-wrapper .page-body-wrapper .chat-box .chat-history .call-content > div, .box-layout.page-wrapper .page-body-wrapper .chat-box .chat-history .call-content > div {\n    z-index: 8;\n    background-color: rgba(255, 255, 255, 0.75);\n    background-blend-mode: overlay;\n    width: 100%;\n    padding: 30px;\n    left: 15px;\n  }\n  .box-layout .page-wrapper .page-body-wrapper .chat-box .chat-history .call-content button, .box-layout.page-wrapper .page-body-wrapper .chat-box .chat-history .call-content button {\n    width: 40%;\n    font-size: 14px;\n    margin: 0 auto;\n  }\n  .box-layout .page-wrapper .page-body-wrapper .chat-box .chat-history .call-icons, .box-layout.page-wrapper .page-body-wrapper .chat-box .chat-history .call-icons {\n    margin-top: 20px;\n    margin-bottom: 20px;\n  }\n  .box-layout .page-wrapper .page-body-wrapper .chat-box .chat-history .call-icons ul li, .box-layout.page-wrapper .page-body-wrapper .chat-box .chat-history .call-icons ul li {\n    border: 1px solid #717171;\n    width: 50px;\n    height: 50px;\n    padding: 8px;\n  }\n  .box-layout .page-wrapper .page-body-wrapper .chat-box .chat-history .receiver-img, .box-layout.page-wrapper .page-body-wrapper .chat-box .chat-history .receiver-img {\n    margin-top: 30px;\n    margin-bottom: 30px;\n  }\n  .box-layout .page-wrapper .page-body-wrapper .chat-box .chat-history .receiver-img img, .box-layout.page-wrapper .page-body-wrapper .chat-box .chat-history .receiver-img img {\n    width: 38%;\n  }\n  .box-layout .page-wrapper .page-body-wrapper .chat-box .chat-history .total-time h2, .box-layout .page-wrapper .page-body-wrapper .chat-box .chat-history .total-time .h2, .box-layout.page-wrapper .page-body-wrapper .chat-box .chat-history .total-time h2, .box-layout.page-wrapper .page-body-wrapper .chat-box .chat-history .total-time .h2 {\n    font-size: 28px;\n    color: #717171;\n  }\n  .box-layout .page-wrapper .page-body-wrapper canvas#myLineCharts, .box-layout.page-wrapper .page-body-wrapper canvas#myLineCharts {\n    width: 100%;\n  }\n  .box-layout .page-wrapper .page-body-wrapper .chat-right-aside, .box-layout.page-wrapper .page-body-wrapper .chat-right-aside {\n    flex: 0 0 60%;\n    max-width: 60%;\n    overflow: hidden;\n  }\n  .box-layout .page-wrapper .page-body-wrapper .caller-img, .box-layout.page-wrapper .page-body-wrapper .caller-img {\n    position: absolute;\n    width: 100%;\n    max-width: 100%;\n    left: 15px;\n  }\n  .box-layout .page-wrapper .page-body-wrapper .caller-img img, .box-layout.page-wrapper .page-body-wrapper .caller-img img {\n    opacity: 0.7;\n  }\n  .box-layout .page-wrapper .page-body-wrapper .browser-widget img, .box-layout.page-wrapper .page-body-wrapper .browser-widget img {\n    height: 65px;\n  }\n  .box-layout .page-wrapper .page-body-wrapper .custom-card .card-header img, .box-layout.page-wrapper .page-body-wrapper .custom-card .card-header img {\n    margin-top: -73px;\n  }\n  .box-layout .page-wrapper .page-body-wrapper .custom-card .card-profile img, .box-layout.page-wrapper .page-body-wrapper .custom-card .card-profile img {\n    height: 130px;\n    top: -17px;\n  }\n  .box-layout .page-wrapper .page-body-wrapper .select2, .box-layout.page-wrapper .page-body-wrapper .select2 {\n    width: 901.781px;\n  }\n  .box-layout .page-wrapper ul.close_icon > li label, .box-layout.page-wrapper ul.close_icon > li label {\n    padding: 0;\n  }\n  .box-layout .page-wrapper ul.close_icon > li label:after, .box-layout.page-wrapper ul.close_icon > li label:after {\n    display: none;\n  }\n  .box-layout .page-wrapper .bookmark ul, .box-layout.page-wrapper .bookmark ul {\n    margin-right: -1px;\n  }\n  .box-layout .page-wrapper #batchDelete .jsgrid-grid-header .jsgrid-table tr th .btn, .box-layout.page-wrapper #batchDelete .jsgrid-grid-header .jsgrid-table tr th .btn {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n  .box-layout .page-wrapper .btn-group-showcase .btn-radio .btn-group .radio input[type=radio], .box-layout.page-wrapper .btn-group-showcase .btn-radio .btn-group .radio input[type=radio] {\n    display: none;\n  }\n  .box-layout .page-wrapper .media.bitcoin-graph, .box-layout.page-wrapper .media.bitcoin-graph {\n    display: block;\n  }\n  .box-layout .page-wrapper .media.bitcoin-graph .top-bitcoin, .box-layout.page-wrapper .media.bitcoin-graph .top-bitcoin {\n    display: inline-block;\n    vertical-align: middle;\n  }\n  .box-layout .page-wrapper .media.bitcoin-graph .media-body, .box-layout.page-wrapper .media.bitcoin-graph .media-body {\n    margin-top: 30px;\n  }\n  .box-layout .page-wrapper .media.bitcoin-graph .media-body .bitcoin-content .bitcoin-numbers h6, .box-layout .page-wrapper .media.bitcoin-graph .media-body .bitcoin-content .bitcoin-numbers .h6, .box-layout.page-wrapper .media.bitcoin-graph .media-body .bitcoin-content .bitcoin-numbers h6, .box-layout.page-wrapper .media.bitcoin-graph .media-body .bitcoin-content .bitcoin-numbers .h6 {\n    font-size: 14px;\n  }\n  .box-layout .page-wrapper .media.bitcoin-graph .media-body .bitcoin-content.text-right, .box-layout.page-wrapper .media.bitcoin-graph .media-body .bitcoin-content.text-right {\n    text-align: center !important;\n  }\n  .box-layout .page-wrapper .alert.inverse p, .box-layout.page-wrapper .alert.inverse p {\n    max-width: 238px;\n    display: block;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  .box-layout .page-wrapper .auth-bg-effect .second-effect, .box-layout.page-wrapper .auth-bg-effect .second-effect {\n    left: 55%;\n  }\n  .box-layout .page-wrapper .auth-bg-video video, .box-layout.page-wrapper .auth-bg-video video {\n    min-width: 67%;\n    width: 67%;\n  }\n  .box-layout .page-wrapper .page-builder .ge-canvas.ge-layout-desktop, .box-layout.page-wrapper .page-builder .ge-canvas.ge-layout-desktop {\n    margin-top: 40px;\n  }\n  .box-layout .page-wrapper .page-builder .ge-addRowGroup, .box-layout.page-wrapper .page-builder .ge-addRowGroup {\n    margin-bottom: 10px;\n  }\n  .box-layout .page-wrapper .pricing-wrapper-card, .box-layout.page-wrapper .pricing-wrapper-card {\n    padding: 50px 20px;\n  }\n  .box-layout .page-wrapper .card .blog-box.blog-grid.set-min-height, .box-layout.page-wrapper .card .blog-box.blog-grid.set-min-height {\n    min-height: 400px;\n  }\n  .box-layout .page-wrapper .flot-chart-placeholder#donut-color-chart-morris-daily, .box-layout.page-wrapper .flot-chart-placeholder#donut-color-chart-morris-daily {\n    min-height: 430px;\n  }\n  .box-layout .page-wrapper .flot-chart-placeholder#donut-color-chart-morris, .box-layout.page-wrapper .flot-chart-placeholder#donut-color-chart-morris {\n    min-height: 430px;\n  }\n  .box-layout .page-wrapper .box-col-12, .box-layout.page-wrapper .box-col-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .box-layout .page-wrapper .box-col-6, .box-layout.page-wrapper .box-col-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .box-layout .page-wrapper .box-col-3, .box-layout.page-wrapper .box-col-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .box-layout .page-wrapper .box-col-7, .box-layout.page-wrapper .box-col-7 {\n    flex: 0 0 60%;\n    max-width: 60%;\n  }\n  .box-layout .page-wrapper .box-col-5, .box-layout.page-wrapper .box-col-5 {\n    flex: 0 0 40%;\n    max-width: 40%;\n  }\n  .box-layout .page-wrapper .box-col-8, .box-layout.page-wrapper .box-col-8 {\n    flex: 0 0 70%;\n    max-width: 70%;\n  }\n  .box-layout .page-wrapper .box-col-4e, .box-layout.page-wrapper .box-col-4e {\n    flex: 0 0 30%;\n    max-width: 30%;\n  }\n  .box-layout .page-wrapper .box-col-4, .box-layout.page-wrapper .box-col-4 {\n    flex: 0 0 33.33%;\n    max-width: 33%;\n  }\n  .box-layout .page-wrapper .box-col-8e, .box-layout.page-wrapper .box-col-8e {\n    flex: 0 0 66.67%;\n    max-width: 66.67%;\n  }\n  .box-layout .page-wrapper .box-col-none, .box-layout.page-wrapper .box-col-none {\n    display: none !important;\n  }\n  .box-layout .page-wrapper .chat-box .chat-right-aside .chat .chat-header .chat-menu-icons li a i, .box-layout.page-wrapper .chat-box .chat-right-aside .chat .chat-header .chat-menu-icons li a i {\n    font-size: 19px;\n  }\n  .box-layout .page-wrapper .chat-box .chat-right-aside, .box-layout.page-wrapper .chat-box .chat-right-aside {\n    flex: 0 0 100%;\n    max-width: calc(100% - 15px);\n    overflow: hidden;\n  }\n  .box-layout .page-wrapper .chat-box .toogle-bar, .box-layout.page-wrapper .chat-box .toogle-bar {\n    display: inline-block;\n    margin-right: 0 !important;\n  }\n  .box-layout .page-wrapper .chat-menu, .box-layout.page-wrapper .chat-menu {\n    right: 0;\n    border-top: 1px solid #ddd;\n    opacity: 0;\n    transform: translateY(-30px);\n    visibility: hidden;\n    top: 81px;\n    position: absolute;\n    z-index: 9;\n    background-color: #fff;\n    transition: all linear 0.3s;\n  }\n  .box-layout .page-wrapper .chat-menu.show, .box-layout.page-wrapper .chat-menu.show {\n    opacity: 1;\n    visibility: visible;\n    transform: translateY(0px);\n    transition: all linear 0.3s;\n    padding-bottom: 25px;\n  }\n  .box-layout .page-wrapper .ct-10.total-chart .ct-chart-bar .ct-series .ct-bar, .box-layout.page-wrapper .ct-10.total-chart .ct-chart-bar .ct-series .ct-bar {\n    stroke-width: 23px !important;\n  }\n  .box-layout .page-wrapper .social-app-profile #friends .box-col-4, .box-layout.page-wrapper .social-app-profile #friends .box-col-4 {\n    flex: 0 0 30%;\n    max-width: 30%;\n  }\n  .box-layout .page-wrapper .email-wrap .email-body .email-compose .cke_contents.cke_reset, .box-layout.page-wrapper .email-wrap .email-body .email-compose .cke_contents.cke_reset {\n    max-height: 165px;\n  }\n  .box-layout .page-wrapper .email-wrap .row .col-xl-6, .box-layout.page-wrapper .email-wrap .row .col-xl-6 {\n    padding-left: 12px;\n  }\n  .box-layout .page-wrapper .email-wrap .row .col-xl-3 + .col-xl-3, .box-layout.page-wrapper .email-wrap .row .col-xl-3 + .col-xl-3 {\n    padding-right: 12px;\n  }\n  .box-layout .page-wrapper .email-wrap .email-right-aside .email-body .inbox, .box-layout.page-wrapper .email-wrap .email-right-aside .email-body .inbox {\n    height: 644px;\n  }\n  .box-layout .page-wrapper .email-wrap .email-content .email-top .user-emailid:after, .box-layout.page-wrapper .email-wrap .email-content .email-top .user-emailid:after {\n    right: -10px;\n  }\n  .box-layout .page-wrapper .todo .notification-popup, .box-layout.page-wrapper .todo .notification-popup {\n    right: 320px;\n  }\n  .box-layout .page-wrapper .touchspin, .box-layout.page-wrapper .touchspin {\n    padding: 0 10px;\n  }\n  .box-layout .page-wrapper .vertical-menu-main, .box-layout.page-wrapper .vertical-menu-main {\n    width: 1280px;\n    margin: 0 auto;\n    left: 0;\n    right: 0;\n  }\n  .box-layout .page-wrapper .vertical-menu-main .mega-menu, .box-layout.page-wrapper .vertical-menu-main .mega-menu {\n    width: 1050px !important;\n    max-width: 1050px !important;\n    left: -320px !important;\n  }\n  .box-layout .page-wrapper .comingsoon video, .box-layout.page-wrapper .comingsoon video {\n    min-width: 67%;\n    width: 67%;\n  }\n}\n\n/**=====================\n    63. Box-layout CSS ends\n==========================**/\n/* ---------------------\n\t*** themes **\n-----------------------*/\n/**=====================\n55. theme layout CSS Start\n==========================**/\nbody.dark-only {\n  color: rgba(255, 255, 255, 0.6);\n  background-color: #1d1e26;\n}\nbody.dark-only .page-body .bg-light {\n  background-color: #1d1e26 !important;\n}\nbody.dark-only .edit-profile .card .card-body form .row a h5, body.dark-only .edit-profile .card .card-body form .row a .h5 {\n  color: rgba(255, 255, 255, 0.7);\n}\nbody.dark-only .wizard-4 .step-container {\n  background-color: #262932;\n  border-color: #374558;\n}\nbody.dark-only .wizard-4 .login-card .login-main {\n  background-color: #1d1e26;\n}\nbody.dark-only .icon-state .switch-state:after {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .kanban-board-header {\n  background-color: #1d1e26 !important;\n  border-bottom: 1px solid #262932 !important;\n}\nbody.dark-only .kanban-container .kanban-item .kanban-box {\n  border: 1px solid rgba(115, 102, 255, 0.15);\n  background-color: #1d1e26;\n}\nbody.dark-only .editor-toolbar {\n  border-top: 1px solid #374558;\n  border-left: 1px solid #374558;\n  border-right: 1px solid #374558;\n}\nbody.dark-only .editor-toolbar a {\n  color: rgba(255, 255, 255, 0.6) !important;\n}\nbody.dark-only .editor-toolbar a:hover, body.dark-only .editor-toolbar a.active {\n  background: #374558;\n}\nbody.dark-only .editor-toolbar i.separator {\n  border-left: 1px solid #374558;\n  border-right: 1px solid #374558;\n}\nbody.dark-only .editor-toolbar button {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .editor-toolbar button:hover, body.dark-only .editor-toolbar button:focus, body.dark-only .editor-toolbar button.active {\n  background: #1d1e26;\n  border-color: #374558 #374558;\n}\nbody.dark-only .editor-toolbar.fullscreen::before, body.dark-only .editor-toolbar.fullscreen::after {\n  background: linear-gradient(to right, #1d1e26 0, #1d1e26 100%);\n}\nbody.dark-only .editor-toolbar.disabled-for-preview a:not(.no-disable) {\n  background: #374558;\n}\nbody.dark-only .editor-preview {\n  background-color: #262932;\n}\nbody.dark-only .editor-toolbar.fullscreen,\nbody.dark-only .editor-preview-side {\n  background: #262932;\n  border: 1px solid #98a6ad;\n}\nbody.dark-only .editor-toolbar.disabled-for-preview a:not(.no-disable) {\n  background: #374558;\n}\nbody.dark-only .editor-preview {\n  background-color: #262932;\n}\nbody.dark-only .editor-toolbar.fullscreen,\nbody.dark-only .editor-preview-side {\n  background: #262932;\n  border: 1px solid #98a6ad;\n}\nbody.dark-only .knowledgebase-search {\n  color: #2f2f3b;\n}\nbody.dark-only .knowledgebase-search .form-inline .form-control {\n  background: transparent !important;\n  border-color: transparent !important;\n}\nbody.dark-only .support-table .progress {\n  background: #1d1e26;\n}\nbody.dark-only .jkanban-container .kanban-container .kanban-drag > div > div .react-kanban-column > div[data-rbd-drag-handle-context-id=\"0\"], body.dark-only .jkanban-container .kanban-container .kanban-drag > div > div .react-kanban-column > div[data-rbd-drag-handle-context-id=\"2\"] {\n  border-bottom: 1px solid #374558;\n}\nbody.dark-only .jkanban-container .kanban-container .kanban-drag > div > div .react-kanban-column > div[data-rbd-drag-handle-context-id=\"0\"], body.dark-only .jkanban-container .kanban-container .kanban-drag > div > div .react-kanban-column > div[data-rbd-drag-handle-context-id=\"2\"] {\n  border-bottom: 1px solid #374558;\n}\nbody.dark-only .jkanban-container .kanban-container .kanban-drag > div > div .react-kanban-column {\n  background-color: #1d1e26;\n}\nbody.dark-only .react-kanban-column {\n  background-color: #1d1e26;\n}\nbody.dark-only .react-kanban-column .react-kanban-card {\n  background-color: #262932;\n}\nbody.dark-only .react-kanban-column .react-kanban-card .react-kanban-card__title {\n  border-bottom: 1px solid #374558;\n}\nbody.dark-only .jkanban-container .kanban-container .kanban-item .kanban-box {\n  background-color: #262932 !important;\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .jkanban-container .kanban-container .kanban-item .kanban-box {\n  background-color: #262932 !important;\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .jkanban-container .kanban-container .kanban-item .kanban-box {\n  background-color: #262932 !important;\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .kanban-container .kanban-item .kanban-box {\n  background-color: #262932;\n}\nbody.dark-only .jkanban-container .kanban-container .kanban-item .kanban-box {\n  border: 1px solid #374558;\n}\nbody.dark-only .rdt_TableRow:nth-of-type(odd) {\n  color: rgba(255, 255, 255, 0.6);\n  background-color: #1d1e26;\n}\nbody.dark-only .rdt_TableRow:nth-of-type(even) {\n  color: rgba(255, 255, 255, 0.6);\n  background-color: #262932;\n}\nbody.dark-only .rdt_TableRow:hover {\n  border-color: #262932 !important;\n}\nbody.dark-only .product-table .rdt_TableBody .rdt_TableRow .rdt_TableCell {\n  color: #242934;\n}\nbody.dark-only .product-table .rdt_TableBody .rdt_TableRow .rdt_TableCell:first-child {\n  background-color: #1d1e26;\n}\nbody.dark-only .product-table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(n+2) {\n  background-color: #262932;\n}\nbody.dark-only .product-table .rdt_TableBody .rdt_TableRow:nth-child(odd) .rdt_TableCell:first-child {\n  background-color: #262932;\n}\nbody.dark-only .product-table .rdt_TableBody .rdt_TableRow:nth-child(odd) .rdt_TableCell:nth-child(n+2) {\n  background-color: #1d1e26;\n}\nbody.dark-only .product-table .rdt_TableBody .rdt_TableRow .rdt_TableCell:first-child {\n  background-color: #1d1e26;\n}\nbody.dark-only .product-table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(n+2) {\n  background-color: #262932;\n}\nbody.dark-only .product-table .rdt_TableBody .rdt_TableRow:nth-child(odd) .rdt_TableCell:first-child {\n  background-color: #262932;\n}\nbody.dark-only .product-table .rdt_TableBody .rdt_TableRow:nth-child(odd) .rdt_TableCell:nth-child(n+2) {\n  background-color: #1d1e26;\n}\nbody.dark-only .social-widget .social-icons {\n  box-shadow: 0px 42.1092px 27.8569px #1d1e26, 0px 8.90772px 7.12618px #1d1e26, 0px 2.02448px 3.44162px #1d1e26;\n}\nbody.dark-only .calendar-basic .md-sidebar-aside {\n  background: #262932;\n}\nbody.dark-only .calendar-basic #external-events {\n  border-color: #374558;\n}\nbody.dark-only .calendar-basic .calendar-default .fc .fc-daygrid-day-number,\nbody.dark-only .calendar-basic .calendar-default .fc .fc-col-header-cell-cushion {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .clockpicker-popover .popover-title {\n  background-color: #262932;\n}\nbody.dark-only .clockpicker-popover.bottom > .arrow {\n  border-bottom-color: #1d1e26;\n}\nbody.dark-only .clockpicker-popover.bottom > .arrow:after {\n  border-bottom-color: #262932;\n}\nbody.dark-only .clockpicker-popover.top > .arrow {\n  border-top-color: #1d1e26;\n}\nbody.dark-only .clockpicker-popover.top > .arrow::after {\n  border-top-color: #262932;\n}\nbody.dark-only .clockpicker-popover.left > .arrow {\n  border-left-color: #1d1e26;\n}\nbody.dark-only .clockpicker-popover.left > .arrow::after {\n  border-left-color: #262932;\n}\nbody.dark-only .clockpicker-popover .popover-title {\n  border-bottom-color: #262932;\n}\nbody.dark-only .fc-theme-standard .fc-scrollgrid,\nbody.dark-only .fc-theme-standard .fc-list {\n  border-color: #374558;\n}\nbody.dark-only .fc-theme-standard .fc-list-day-cushion {\n  background-color: #1d1e26;\n}\nbody.dark-only .fc .fc-list-event:hover td {\n  background-color: #1d1e26;\n}\nbody.dark-only .view-container .apexcharts-canvas .apexcharts-point-annotations circle {\n  outline: 25px solid rgba(62, 61, 114, 0.3490196078);\n}\nbody.dark-only .vertical-timeline-element-content {\n  background-color: #1d1e26;\n}\nbody.dark-only .vertical-timeline-element-content .vertical-timeline-element-content-arrow {\n  border-right: 7px solid #1d1e26;\n}\nbody.dark-only .vertical-timeline::before {\n  background: #1d1e26;\n}\nbody.dark-only .vertical-timeline-element-icon {\n  box-shadow: 0 0 0 4px #1d1e26, inset 0 2px 0 rgba(0, 0, 0, 0.08), 0 3px 0 4px rgba(0, 0, 0, 0.05);\n}\nbody.dark-only .currency-widget div[class*=bg-light-] {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .btn.badge-light-primary:hover {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .portfolio-chart-container .apexcharts-canvas .apexcharts-radialbar image {\n  display: none;\n}\nbody.dark-only svg.f-light {\n  fill: rgba(255, 255, 255, 0.6);\n  opacity: 1;\n}\nbody.dark-only .course-widget .btn-light {\n  background-color: #1d1e26 !important;\n}\nbody.dark-only .schedule-list > li {\n  box-shadow: 4px 7px 17px 5px rgba(29, 30, 38, 0.2);\n}\nbody.dark-only .upcoming-event-wrap .apexcharts-canvas .apexcharts-data-labels rect {\n  fill: none;\n  stroke: none;\n}\nbody.dark-only .page-wrapper.advance-layout .page-header {\n  background: #262932;\n}\nbody.dark-only .page-wrapper.advance-layout .page-body-wrapper .sidebar-wrapper {\n  border-bottom: 1px solid #374558;\n}\nbody.dark-only .page-wrapper.only-body {\n  background: #1d1e26;\n}\nbody.dark-only .balance-card .svg-box {\n  background: #262932;\n  box-shadow: none;\n}\nbody.dark-only .balance-card .svg-box svg {\n  fill: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .f-light {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .apexcharts-tooltip.light .apexcharts-tooltip-title {\n  background: #262932;\n  color: #fff;\n}\nbody.dark-only .card {\n  background-color: #262932;\n}\nbody.dark-only .ecommerce-widget {\n  border: 1px solid #374558 !important;\n}\nbody.dark-only .btn-light {\n  color: rgba(255, 255, 255, 0.6) !important;\n}\nbody.dark-only .form-select {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .add-project .text-inherit {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .knowledgebase-search {\n  color: #2f2f3b;\n}\nbody.dark-only .knowledgebase-search .form-control-plaintext {\n  color: #2f2f3b;\n}\nbody.dark-only .btn-close {\n  filter: brightness(0.8) invert(1);\n}\nbody.dark-only .prooduct-details-box .media {\n  border: 1px solid #374558;\n}\nbody.dark-only .product-price del {\n  color: #98a6ad;\n}\nbody.dark-only .ProfileCard {\n  border: 1px solid #374558 !important;\n}\nbody.dark-only .form-control-plaintext {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .form-select {\n  background-color: #1d1e26;\n  border: 1px solid #1d1e26;\n}\nbody.dark-only .box-layout {\n  background-color: #1d1e26;\n}\nbody.dark-only .box-layout .page-wrapper .page-header .header-wrapper, body.dark-only .box-layout.page-wrapper .page-header .header-wrapper {\n  border: 1px solid #1d1e26;\n}\nbody.dark-only .form-check-input {\n  background-color: #1d1e26;\n}\nbody.dark-only .switch-state:before {\n  background-color: #262932;\n}\nbody.dark-only .rdt_Table {\n  border: 1px solid #374558;\n}\nbody.dark-only .rdt_TableHeadRow {\n  background-color: #262932;\n}\nbody.dark-only .rdt_TableCol,\nbody.dark-only .rdt_TableCol_Sortable,\nbody.dark-only .___react-data-table-allow-propagation___ {\n  color: rgba(255, 255, 255, 0.6);\n}\nborder body.dark-only .rdt_TableRow:nth-of-type(odd) {\n  color: rgba(255, 255, 255, 0.6);\n  background-color: #1d1e26;\n}\nbody.dark-only .rdt_TableRow:nth-of-type(even) {\n  color: rgba(255, 255, 255, 0.6);\n  background-color: #262932;\n}\nbody.dark-only .fpZHHx {\n  fill: rgba(255, 255, 255, 0.6);\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .rdt_Pagination {\n  background-color: #262932;\n  border-top-color: #374558;\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .rdt_Pagination button {\n  color: rgba(255, 255, 255, 0.6);\n  fill: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .rdt_Pagination button:disabled {\n  color: #98a6ad;\n  fill: #98a6ad;\n}\nbody.dark-only .rdt_TableCol_Sortable:hover {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .rdt_TableHeader {\n  background-color: #1d1e26 !important;\n}\nbody.dark-only .rdt_TableHeader > div:last-child {\n  background-color: #1d1e26 !important;\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .daterangepicker:before {\n  border-bottom-color: #262932;\n}\nbody.dark-only .daterangepicker .ranges li {\n  background-color: #1d1e26;\n  border-color: #262932;\n  color: #898989;\n}\nbody.dark-only .daterangepicker .daterangepicker_input .form-control {\n  background-color: #1d1e26;\n  border-color: #262932 !important;\n}\nbody.dark-only .daterangepicker .calendar-time select {\n  border-color: #262932;\n  background-color: #1d1e26;\n}\nbody.dark-only .daterangepicker.dropdown-menu {\n  background-color: #262932;\n  -webkit-box-shadow: 0 0 14px #1d1e26;\n  box-shadow: 0 0 14px #1d1e26;\n}\nbody.dark-only .daterangepicker .calendar-table {\n  background-color: #262932;\n  border-color: #262932;\n}\nbody.dark-only .daterangepicker.ltr td.in-range, body.dark-only .daterangepicker.ltr td.off {\n  background-color: #1d1e26;\n  color: #fff;\n}\nbody.dark-only .tooltip.bs-tooltip-top .tooltip-arrow:before, body.dark-only .tooltip.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow:before {\n  border-top-color: #323846;\n}\nbody.dark-only .tooltip.bs-tooltip-bottom .tooltip-arrow:before, body.dark-only .tooltip.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow:before {\n  border-bottom-color: #323846;\n  border-top-color: transparent;\n}\nbody.dark-only .tooltip.bs-tooltip-start .tooltip-arrow:before, body.dark-only .tooltip.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow:before {\n  border-left-color: #323846;\n  border-top-color: transparent;\n}\nbody.dark-only .tooltip.bs-tooltip-end .tooltip-arrow:before, body.dark-only .tooltip.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow:before {\n  border-right-color: #323846;\n  border-top-color: transparent;\n}\nbody.dark-only .tooltip .tooltip-inner {\n  background-color: #323846;\n  color: #fff;\n}\nbody.dark-only .tooltip .tooltip-arrow:before {\n  border-top-color: #323846;\n}\nbody.dark-only .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {\n  background-color: #262932;\n}\nbody.dark-only .react-datepicker .react-datepicker__time-container {\n  border-left: 1px solid #374558;\n}\nbody.dark-only .react-datepicker__time-container .react-datepicker__time {\n  background: #1d1e26;\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .react-datepicker {\n  background-color: #262932;\n}\nbody.dark-only .react-datepicker .react-datepicker__header {\n  background-color: #262932 !important;\n  border-bottom: 1px solid #374558;\n}\nbody.dark-only .react-datepicker .react-datepicker__day-name,\nbody.dark-only .react-datepicker .react-datepicker__day,\nbody.dark-only .react-datepicker .react-datepicker__time-name {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .react-datepicker .react-datepicker__day:hover,\nbody.dark-only .react-datepicker .react-datepicker__month-text:hover,\nbody.dark-only .react-datepicker .react-datepicker__quarter-text:hover,\nbody.dark-only .react-datepicker .react-datepicker__year-text:hover {\n  background-color: #262932;\n}\nbody.dark-only .default-datepicker .react-datepicker .react-datepicker__month,\nbody.dark-only .default-datepicker .react-datepicker .react-datepicker__header {\n  background-color: #262932 !important;\n}\nbody.dark-only .default-datepicker .react-datepicker {\n  background: transparent;\n}\nbody.dark-only .default-datepicker .react-datepicker__day-name,\nbody.dark-only .default-datepicker .react-datepicker__day,\nbody.dark-only .default-datepicker .react-datepicker__time-name {\n  color: rgba(255, 255, 255, 0.7);\n}\nbody.dark-only .default-datepicker .react-datepicker__day--outside-month {\n  color: #98a6ad;\n}\nbody.dark-only .default-datepicker .react-datepicker__header {\n  border-bottom: 1px solid #374558;\n}\nbody.dark-only .default-datepicker .react-datepicker__day:hover,\nbody.dark-only .default-datepicker .react-datepicker__month-text:hover,\nbody.dark-only .default-datepicker .react-datepicker__quarter-text:hover,\nbody.dark-only .default-datepicker .react-datepicker__year-text:hover {\n  background-color: #1d1e26;\n}\nbody.dark-only .draggable-card > div > div div[data-testid=lane] {\n  background-color: #1d1e26;\n}\nbody.dark-only .draggable-card > div > div div[data-testid=card] > div > div {\n  background-color: #262932;\n}\nbody.dark-only .draggable-card > div > div div[data-testid=card] > div > div span > div {\n  border-bottom: 1px solid #374558;\n}\nbody.dark-only .page-wrapper.only-body .page-body-wrapper .page-title > .row .col-6:first-child h6, body.dark-only .page-wrapper.only-body .page-body-wrapper .page-title > .row .col-6:first-child .h6 {\n  color: rgba(255, 255, 255, 0.5);\n}\nbody.dark-only .page-wrapper.only-body .page-header .header-wrapper .search-full .form-group .Typeahead .u-posRelative {\n  background-color: #262932;\n}\nbody.dark-only .page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown li span {\n  color: #fff;\n}\nbody.dark-only .page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .back {\n  background-color: #1d1e26 !important;\n}\nbody.dark-only .page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .back .flip-back-content input {\n  background-color: #1d1e26;\n  border: 1px solid #374558;\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .back li:last-child {\n  border-top: 1px solid #374558;\n}\nbody.dark-only .page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .front {\n  background-color: #1d1e26 !important;\n}\nbody.dark-only .page-wrapper .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .front svg {\n  stroke: #fff;\n}\nbody.dark-only .page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown .total {\n  background-color: #262932;\n}\nbody.dark-only .page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown .qty-box .input-group .btn {\n  color: rgba(255, 255, 255, 0.4);\n  border-color: #262932 !important;\n  background-color: #262932 !important;\n}\nbody.dark-only .qty-box input {\n  color: rgba(255, 255, 255, 0.5);\n}\nbody.dark-only .customizer-contain {\n  color: #1d1e26;\n}\nbody.dark-only .customizer-contain .customizer-body .main-layout .box-layout {\n  background-color: #fff;\n}\nbody.dark-only .login-card .btn-showcase .btn {\n  background-color: #262932 !important;\n  color: #fff;\n  border-color: #262932 !important;\n}\nbody.dark-only .login-card .login-main {\n  box-shadow: 0 0 37px rgba(255, 255, 255, 0.05);\n}\nbody.dark-only .login-card .login-main .theme-form input {\n  background-color: #262932 !important;\n}\nbody.dark-only .login-card .login-main .theme-form .or:before {\n  background-color: #262932;\n}\nbody.dark-only .login-card .login-main .theme-form .checkbox label::before {\n  background-color: #262932 !important;\n  border-color: #262932 !important;\n}\nbody.dark-only .H_ui ~ div {\n  background-color: #1d1e26 !important;\n}\nbody.dark-only .swal-icon--success:after,\nbody.dark-only .swal-icon--success:before {\n  background: #262932;\n}\nbody.dark-only .swal-icon--success__hide-corners {\n  background-color: #262932;\n}\nbody.dark-only .note-editor.note-frame .note-status-output {\n  border-top: 1px solid #262932;\n}\nbody.dark-only .note-editor.note-frame .note-statusbar {\n  border-top: 1px solid #262932;\n}\nbody.dark-only .note-editor.note-frame .note-statusbar .note-resizebar {\n  background-color: #262932;\n}\nbody.dark-only .light-font {\n  color: rgba(255, 255, 255, 0.7);\n}\nbody.dark-only .page-link {\n  background-color: #1d1e26;\n  border: 1px solid #374558;\n}\nbody.dark-only .b-r-light {\n  border-right: 1px solid #374558 !important;\n}\nbody.dark-only .history-details .media {\n  border-top: 1px solid #374558;\n}\nbody.dark-only .modal-header {\n  border-bottom: 1px solid #374558;\n}\nbody.dark-only #right-history {\n  background-color: #262932;\n  box-shadow: 0 0 9px #1d1e26;\n}\nbody.dark-only #right-history h6 span a, body.dark-only #right-history .h6 span a {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .ProfileCard:hover {\n  color: rgba(255, 255, 255, 0.6);\n  background-color: #262932;\n}\nbody.dark-only .translate_wrapper.active .more_lang:before {\n  border-bottom: 7px solid #262932;\n}\nbody.dark-only .translate_wrapper.active .more_lang .lang {\n  border-bottom: 1px solid #1d1e26;\n}\nbody.dark-only .toggle-sidebar svg {\n  stroke: var(--theme-default);\n}\nbody.dark-only .page-wrapper .page-body-wrapper {\n  background-color: #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-title {\n  background-color: #262932;\n  border-bottom: 1px solid #374558;\n  box-shadow: rgba(0, 0, 0, 0.07) 0px 4px 40px;\n}\nbody.dark-only .page-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a svg.stroke-icon {\n  stroke: #fff;\n}\nbody.dark-only .page-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a svg.fill-icon {\n  fill: rgba(255, 255, 255, 0.5);\n  stroke: transparent;\n}\nbody.dark-only .page-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a.active svg.stroke-icon {\n  stroke: var(--theme-default);\n}\nbody.dark-only .page-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li a.active svg.fill-icon {\n  fill: var(--theme-default);\n  stroke: transparent;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .sidebar-main .sidebar-links .sidebar-link.active svg.stroke-icon {\n  stroke: var(--theme-default);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .sidebar-main .sidebar-links li a span {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active {\n  background-color: rgba(115, 102, 255, 0.2);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title h5, body.dark-only .page-wrapper .page-body-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title .h5 {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content.opensubmegamenu li a {\n  color: rgba(255, 255, 255, 0.6);\n  font-weight: 400;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .sidebar-main .sidebar-links > li .mega-menu-container::after {\n  background-color: rgba(255, 255, 255, 0.2);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a.active {\n  color: var(--theme-default);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .sidebar-main .sidebar-links .sidebar-list ul.sidebar-submenu li a span {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .sidebar-main .sidebar-links .sidebar-list ul.sidebar-submenu li a.active {\n  color: var(--theme-default);\n}\nbody.dark-only .page-wrapper.modern-type .page-body-wrapper .page-title {\n  background-color: transparent;\n  border: none;\n}\nbody.dark-only .page-wrapper .sidebar-main-title p {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper {\n  background-color: #262932;\n}\nbody.dark-only .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-link.active svg {\n  stroke: var(--theme-default);\n}\nbody.dark-only .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a span {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active {\n  background-color: rgba(115, 102, 255, 0.2);\n}\nbody.dark-only .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title h5, body.dark-only .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title .h5 {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content.opensubmegamenu li a {\n  color: rgba(255, 255, 255, 0.6);\n  font-weight: 400;\n}\nbody.dark-only .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container::after {\n  background-color: rgba(255, 255, 255, 0.2);\n}\nbody.dark-only .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a.active {\n  color: var(--theme-default);\n}\nbody.dark-only .page-wrapper.compact-wrapper .sidebar-list ul.sidebar-submenu li a span {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper.compact-wrapper .sidebar-list ul.sidebar-submenu li a.active {\n  color: var(--theme-default);\n}\nbody.dark-only .page-wrapper.compact-wrapper .sidebar-list .according-menu i {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper {\n  background: #262932;\n  border-top: 1px solid #374558;\n}\nbody.dark-only .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li > a {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu {\n  background: #262932;\n}\nbody.dark-only .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a.active, body.dark-only .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a:hover {\n  color: var(--theme-default);\n}\nbody.dark-only .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li .nav-sub-childmenu {\n  background: #262932;\n}\nbody.dark-only .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container {\n  background: #262932;\n}\nbody.dark-only .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content li a {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .left-arrow,\nbody.dark-only .page-wrapper .right-arrow {\n  background-color: #262932;\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper > div {\n  background: #262932;\n}\nbody.dark-only .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-title {\n  border-bottom: 1px solid #374558;\n}\nbody.dark-only .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a span {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a svg {\n  stroke: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu,\nbody.dark-only .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container {\n  background-color: #262932;\n}\nbody.dark-only .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu li a,\nbody.dark-only .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container li a {\n  border-bottom: 1px solid #374558;\n}\nbody.dark-only .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active {\n  background-color: rgba(115, 102, 255, 0.2);\n}\nbody.dark-only .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active span {\n  color: var(--theme-default);\n}\nbody.dark-only .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active svg {\n  color: var(--theme-default);\n  stroke: var(--theme-default);\n}\nbody.dark-only .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title h5, body.dark-only .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title .h5 {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content.opensubmegamenu li a {\n  color: rgba(255, 255, 255, 0.6);\n  font-weight: 400;\n}\nbody.dark-only .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container::after {\n  background-color: rgba(255, 255, 255, 0.2);\n}\nbody.dark-only .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list ul.sidebar-submenu li a span {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list ul.sidebar-submenu li a.active {\n  color: var(--theme-default);\n}\nbody.dark-only .page-wrapper.compact-sidebar .page-body-wrapper .according-menu i {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper.material-type .page-header .header-wrapper {\n  border-radius: 15px 15px 0 0;\n}\nbody.dark-only .page-wrapper.material-icon .page-header .header-wrapper {\n  background-color: transparent;\n}\nbody.dark-only .page-wrapper.material-icon .page-header .header-wrapper .nav-right .language-nav .more_lang {\n  color: #fff;\n}\nbody.dark-only .page-wrapper.material-icon .page-header .header-wrapper .nav-right .onhover-show-div {\n  color: #fff;\n}\nbody.dark-only .page-wrapper.material-icon .page-header .header-wrapper .nav-right .flip-card .flip-card-inner .back .flip-back-content input {\n  border: 1px solid #1d1e26;\n  background: #1d1e26;\n  color: #fff;\n}\nbody.dark-only .page-wrapper.material-icon .page-header .header-logo-wrapper {\n  background-color: transparent;\n}\nbody.dark-only .page-wrapper.material-icon .page-body-wrapper .page-body {\n  background-color: transparent;\n}\nbody.dark-only .page-wrapper.advance-layout {\n  background-color: #1d1e26;\n}\nbody.dark-only .page-wrapper.advance-layout .page-header .header-wrapper {\n  background: transparent;\n}\nbody.dark-only .page-wrapper.advance-layout .page-header .header-wrapper .header-logo-wrapper {\n  background: transparent;\n}\nbody.dark-only .page-wrapper.advance-layout .page-body-wrapper {\n  background: transparent;\n}\nbody.dark-only .page-wrapper.advance-layout .page-body-wrapper .page-body {\n  background: transparent;\n}\nbody.dark-only .page-wrapper.material-icon .page-body-wrapper .page-title {\n  background-color: transparent;\n  box-shadow: none;\n  border: none;\n}\nbody.dark-only .page-wrapper .page-header .header-wrapper .search-full {\n  background-color: #262932;\n}\nbody.dark-only .page-wrapper .page-header .header-wrapper .search-full input {\n  color: rgba(255, 255, 255, 0.6);\n}\n@media only screen and (min-width: 768px) {\n  body.dark-only .page-wrapper.material-icon .page-header .header-wrapper .nav-right ul li .profile-dropdown li svg {\n    stroke: #fff;\n  }\n}\nbody.dark-only ::-webkit-calendar-picker-indicator {\n  filter: invert(1);\n}\nbody.dark-only .kanban-board-header {\n  background-color: #1d1e26;\n  border-bottom: 1px solid #262932;\n}\nbody.dark-only .kanban-board .kanban-drag {\n  background: #1d1e26;\n}\nbody.dark-only .kanban-container .kanban-item .kanban-box {\n  border: 1px solid rgba(115, 102, 255, 0.15);\n  background-color: #1d1e26;\n}\nbody.dark-only .project-box {\n  border: 1px solid rgba(115, 102, 255, 0.15);\n  background-color: #1d1e26;\n}\nbody.dark-only .file-content .form-inline {\n  border: 1px solid #1d1e26;\n}\nbody.dark-only .file-content .files .file-box {\n  border: 1px solid rgba(115, 102, 255, 0.15);\n  background-color: #1d1e26;\n}\nbody.dark-only .file-content .files .file-box .file-top {\n  background-color: #262932;\n  border: 1px solid rgba(115, 102, 255, 0.15);\n}\nbody.dark-only .file-content .folder .folder-box {\n  border: 1px solid rgba(115, 102, 255, 0.15);\n  background-color: #1d1e26;\n}\nbody.dark-only .file-sidebar .pricing-plan {\n  border: 1px solid rgba(115, 102, 255, 0.15) !important;\n}\nbody.dark-only .file-sidebar .btn-light {\n  color: rgba(255, 255, 255, 0.6);\n  background-color: #1d1e26 !important;\n  border: 1px solid rgba(115, 102, 255, 0.15) !important;\n}\nbody.dark-only #lnb {\n  border-right: 1px solid #374558;\n}\nbody.dark-only .lnb-new-schedule,\nbody.dark-only .lnb-calendars > div {\n  border-bottom: 1px solid #374558;\n}\nbody.dark-only #menu .sidebar-list .btn-default {\n  color: rgba(255, 255, 255, 0.2);\n}\nbody.dark-only .tui-full-calendar-timegrid-hour {\n  background-color: #262932;\n  color: #fff !important;\n}\nbody.dark-only .tui-full-calendar-timegrid-gridline {\n  border-bottom: 1px solid #374558 !important;\n}\nbody.dark-only .tui-full-calendar-time-date,\nbody.dark-only .tui-full-calendar-weekday-grid-line,\nbody.dark-only .tui-full-calendar-left,\nbody.dark-only .tui-full-calendar-timegrid-timezone {\n  border-right-color: #374558 !important;\n}\nbody.dark-only .tui-full-calendar-popup {\n  color: #2f2f3b;\n}\nbody.dark-only #menu .btn-default {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only #menu .btn-default:hover {\n  color: #2f2f3b;\n}\nbody.dark-only #menu .dropdown-menu {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .tui-full-calendar-dayname-container,\nbody.dark-only .tui-full-calendar-splitter {\n  border-top-color: #374558 !important;\n  border-bottom-color: #374558 !important;\n}\nbody.dark-only span.tui-full-calendar-dayname-date-area {\n  color: #fff !important;\n}\nbody.dark-only .tui-full-calendar-layout {\n  background-color: #262932 !important;\n}\nbody.dark-only .blockquote {\n  border-left: 4px solid #374558;\n}\nbody.dark-only .figure.text-end blockquote {\n  border-right-color: #374558;\n}\nbody.dark-only .contacts-tabs .nav-pills {\n  border-right: 1px solid #374558;\n}\nbody.dark-only .contacts-tabs .nav-pills .nav-link + .nav-link {\n  border-top: 1px solid #374558;\n}\nbody.dark-only .list-persons .profile-mail .media .media-body ul li + li {\n  border-left: 2px solid #374558;\n}\nbody.dark-only .product-wrapper.sidebaron .product-sidebar .filter-section .card .left-filter {\n  background-color: #262932;\n}\nbody.dark-only .apexcharts-gridline {\n  stroke: #1d1e26;\n}\nbody.dark-only .apexcharts-tooltip-title,\nbody.dark-only .apexcharts-tooltip-series-group,\nbody.dark-only .apexcharts-tooltip.light,\nbody.dark-only .apexcharts-menu-item {\n  color: #000;\n}\nbody.dark-only .small-donut ~ svg path:nth-child(even),\nbody.dark-only .small-donut svg path:nth-child(even),\nbody.dark-only .donut-peity2 ~ svg path:nth-child(even),\nbody.dark-only .donut-peity2 svg path:nth-child(even),\nbody.dark-only .pie-peity ~ svg path:nth-child(even),\nbody.dark-only .pie-peity svg path:nth-child(even) {\n  fill: #1d1e26;\n}\nbody.dark-only .appointment-table table tr td.img-content-box .font-roboto {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .notification .card .d-flex .w-100 p span {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .notification .card .d-flex .w-100 span {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .datepicker {\n  background-color: #323846;\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .datepicker .datepicker--cell.-current- {\n  color: #7366ff;\n}\nbody.dark-only .datepicker .datepicker--cell.-current-.-focus- {\n  color: #fff;\n}\nbody.dark-only .datepicker .datepicker--cell-day.-other-month-,\nbody.dark-only .datepicker .datepicker--cell-year.-other-decade- {\n  color: rgba(255, 255, 255, 0.4);\n}\nbody.dark-only .datepicker .datepicker--nav {\n  border-bottom: 1px solid #374558;\n}\nbody.dark-only .datepicker .datepicker--pointer {\n  background: #323846;\n  border-top-color: #323846;\n  border-right-color: #323846;\n}\nbody.dark-only .default-datepicker .datepicker-inline .datepicker {\n  background: #262932;\n}\nbody.dark-only .default-datepicker .datepicker-inline .datepicker .datepicker--nav-title {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .default-datepicker .datepicker-inline .datepicker .datepicker--nav-title i {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--days-names .datepicker--day-name,\nbody.dark-only .default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--days-names .datepicker--cell-day,\nbody.dark-only .default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--cells .datepicker--day-name,\nbody.dark-only .default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--cells .datepicker--cell-day {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--days-names .datepicker--day-name.-selected-,\nbody.dark-only .default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--days-names .datepicker--cell-day.-selected-,\nbody.dark-only .default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--cells .datepicker--day-name.-selected-,\nbody.dark-only .default-datepicker .datepicker-inline .datepicker .datepicker--content .datepicker--days .datepicker--cells .datepicker--cell-day.-selected- {\n  color: #fff;\n}\nbody.dark-only [class*=activity-dot-] {\n  background-color: #262932;\n}\nbody.dark-only .page-header .header-wrapper .nav-right .profile-dropdown li:last-child {\n  border-top: 1px solid #374558 !important;\n}\nbody.dark-only .alert-primary {\n  background-color: rgba(115, 102, 255, 0.8) !important;\n  border-color: rgba(115, 102, 255, 0.9) !important;\n  color: #fff;\n}\nbody.dark-only .alert-primary .progress {\n  height: 5px;\n  background-color: rgb(43.2679738562%, 38%, 100%);\n  border-radius: 0;\n}\nbody.dark-only .alert-primary .progress-bar {\n  background-color: white;\n}\nbody.dark-only .alert-primary.inverse {\n  background-color: transparent !important;\n}\nbody.dark-only .alert-primary.inverse .btn-close {\n  filter: brightness(1) invert(1);\n}\nbody.dark-only .alert-primary.outline .btn-close,\nbody.dark-only .alert-primary.outline-2x .btn-close {\n  filter: brightness(1) invert(1);\n}\nbody.dark-only .dismiss-text .alert-dismissible .btn-close {\n  filter: unset;\n}\nbody.dark-only .dismiss-text .alert-dismissible .btn-close .bg-light {\n  color: #2f2f3b !important;\n}\nbody.dark-only .alert-secondary {\n  background-color: rgba(255, 51, 100, 0.8) !important;\n  border-color: rgba(255, 51, 100, 0.9) !important;\n  color: #fff;\n}\nbody.dark-only .alert-secondary .progress {\n  height: 5px;\n  background-color: rgb(100%, 18%, 37.6960784314%);\n  border-radius: 0;\n}\nbody.dark-only .alert-secondary .progress-bar {\n  background-color: white;\n}\nbody.dark-only .alert-secondary.inverse {\n  background-color: transparent !important;\n}\nbody.dark-only .alert-secondary.inverse .btn-close {\n  filter: brightness(1) invert(1);\n}\nbody.dark-only .alert-secondary.outline .btn-close,\nbody.dark-only .alert-secondary.outline-2x .btn-close {\n  filter: brightness(1) invert(1);\n}\nbody.dark-only .dismiss-text .alert-dismissible .btn-close {\n  filter: unset;\n}\nbody.dark-only .dismiss-text .alert-dismissible .btn-close .bg-light {\n  color: #2f2f3b !important;\n}\nbody.dark-only .alert-success {\n  background-color: rgba(84, 186, 74, 0.8) !important;\n  border-color: rgba(84, 186, 74, 0.9) !important;\n  color: #fff;\n}\nbody.dark-only .alert-success .progress {\n  height: 5px;\n  background-color: rgb(31.5876078431%, 72.3716078431%, 27.5891764706%);\n  border-radius: 0;\n}\nbody.dark-only .alert-success .progress-bar {\n  background-color: white;\n}\nbody.dark-only .alert-success.inverse {\n  background-color: transparent !important;\n}\nbody.dark-only .alert-success.inverse .btn-close {\n  filter: brightness(1) invert(1);\n}\nbody.dark-only .alert-success.outline .btn-close,\nbody.dark-only .alert-success.outline-2x .btn-close {\n  filter: brightness(1) invert(1);\n}\nbody.dark-only .dismiss-text .alert-dismissible .btn-close {\n  filter: unset;\n}\nbody.dark-only .dismiss-text .alert-dismissible .btn-close .bg-light {\n  color: #2f2f3b !important;\n}\nbody.dark-only .alert-danger {\n  background-color: rgba(252, 68, 56, 0.8) !important;\n  border-color: rgba(252, 68, 56, 0.9) !important;\n  color: #fff;\n}\nbody.dark-only .alert-danger .progress {\n  height: 5px;\n  background-color: rgb(98.7938264415%, 24.8151815182%, 19.990487284%);\n  border-radius: 0;\n}\nbody.dark-only .alert-danger .progress-bar {\n  background-color: white;\n}\nbody.dark-only .alert-danger.inverse {\n  background-color: transparent !important;\n}\nbody.dark-only .alert-danger.inverse .btn-close {\n  filter: brightness(1) invert(1);\n}\nbody.dark-only .alert-danger.outline .btn-close,\nbody.dark-only .alert-danger.outline-2x .btn-close {\n  filter: brightness(1) invert(1);\n}\nbody.dark-only .dismiss-text .alert-dismissible .btn-close {\n  filter: unset;\n}\nbody.dark-only .dismiss-text .alert-dismissible .btn-close .bg-light {\n  color: #2f2f3b !important;\n}\nbody.dark-only .alert-warning {\n  background-color: rgba(255, 170, 5, 0.8) !important;\n  border-color: rgba(255, 170, 5, 0.9) !important;\n  color: #fff;\n}\nbody.dark-only .alert-warning .progress {\n  height: 5px;\n  background-color: rgb(99.9607843137%, 65.9741176471%, 0%);\n  border-radius: 0;\n}\nbody.dark-only .alert-warning .progress-bar {\n  background-color: white;\n}\nbody.dark-only .alert-warning.inverse {\n  background-color: transparent !important;\n}\nbody.dark-only .alert-warning.inverse .btn-close {\n  filter: brightness(1) invert(1);\n}\nbody.dark-only .alert-warning.outline .btn-close,\nbody.dark-only .alert-warning.outline-2x .btn-close {\n  filter: brightness(1) invert(1);\n}\nbody.dark-only .dismiss-text .alert-dismissible .btn-close {\n  filter: unset;\n}\nbody.dark-only .dismiss-text .alert-dismissible .btn-close .bg-light {\n  color: #2f2f3b !important;\n}\nbody.dark-only .alert-info {\n  background-color: rgba(22, 199, 249, 0.8) !important;\n  border-color: rgba(22, 199, 249, 0.9) !important;\n  color: #fff;\n}\nbody.dark-only .alert-info .progress {\n  height: 5px;\n  background-color: rgb(6.6776601854%, 77.5705964394%, 97.5968496185%);\n  border-radius: 0;\n}\nbody.dark-only .alert-info .progress-bar {\n  background-color: white;\n}\nbody.dark-only .alert-info.inverse {\n  background-color: transparent !important;\n}\nbody.dark-only .alert-info.inverse .btn-close {\n  filter: brightness(1) invert(1);\n}\nbody.dark-only .alert-info.outline .btn-close,\nbody.dark-only .alert-info.outline-2x .btn-close {\n  filter: brightness(1) invert(1);\n}\nbody.dark-only .dismiss-text .alert-dismissible .btn-close {\n  filter: unset;\n}\nbody.dark-only .dismiss-text .alert-dismissible .btn-close .bg-light {\n  color: #2f2f3b !important;\n}\nbody.dark-only .alert-light {\n  background-color: rgba(244, 244, 244, 0.8) !important;\n  border-color: rgba(244, 244, 244, 0.9) !important;\n  color: #fff;\n}\nbody.dark-only .alert-light .progress {\n  height: 5px;\n  background-color: rgb(94.6862745098%, 94.6862745098%, 94.6862745098%);\n  border-radius: 0;\n}\nbody.dark-only .alert-light .progress-bar {\n  background-color: white;\n}\nbody.dark-only .alert-light.inverse {\n  background-color: transparent !important;\n}\nbody.dark-only .alert-light.inverse .btn-close {\n  filter: brightness(1) invert(1);\n}\nbody.dark-only .alert-light.outline .btn-close,\nbody.dark-only .alert-light.outline-2x .btn-close {\n  filter: brightness(1) invert(1);\n}\nbody.dark-only .dismiss-text .alert-dismissible .btn-close {\n  filter: unset;\n}\nbody.dark-only .dismiss-text .alert-dismissible .btn-close .bg-light {\n  color: #2f2f3b !important;\n}\nbody.dark-only .alert-dark {\n  background-color: rgba(44, 50, 63, 0.8) !important;\n  border-color: rgba(44, 50, 63, 0.9) !important;\n  color: #fff;\n}\nbody.dark-only .alert-dark .progress {\n  height: 5px;\n  background-color: rgb(16.4324720542%, 18.673263698%, 23.5283122595%);\n  border-radius: 0;\n}\nbody.dark-only .alert-dark .progress-bar {\n  background-color: rgb(65.82737768%, 69.0819131391%, 76.1334066337%);\n}\nbody.dark-only .alert-dark.inverse {\n  background-color: transparent !important;\n}\nbody.dark-only .alert-dark.inverse .btn-close {\n  filter: brightness(1) invert(1);\n}\nbody.dark-only .alert-dark.outline .btn-close,\nbody.dark-only .alert-dark.outline-2x .btn-close {\n  filter: brightness(1) invert(1);\n}\nbody.dark-only .dismiss-text .alert-dismissible .btn-close {\n  filter: unset;\n}\nbody.dark-only .dismiss-text .alert-dismissible .btn-close .bg-light {\n  color: #2f2f3b !important;\n}\nbody.dark-only .options > div {\n  border: 1px solid #374558;\n}\nbody.dark-only .was-validated .custom-control-input:invalid ~ .custom-control-label::before {\n  background-color: #1d1e26;\n}\nbody.dark-only .pricing-simple {\n  box-shadow: 1px 1px 2px 1px #1d1e26 !important;\n}\nbody.dark-only .pricing-block {\n  box-shadow: 0 0 10px 5px rgba(115, 102, 255, 0.05) !important;\n}\nbody.dark-only .search-page ul.search-info li + li {\n  border-left: 1px solid #1d1e26;\n}\nbody.dark-only .browse .browse-articles h6, body.dark-only .browse .browse-articles .h6 {\n  border-bottom: 1px solid #1d1e26;\n}\nbody.dark-only .job-search .job-description .theme-form .row div[class^=col-] .input-group .datepicker-here {\n  border: 1px solid #1d1e26;\n}\nbody.dark-only .calendar-wrap .fc-unthemed td,\nbody.dark-only .calendar-wrap .fc-unthemed th {\n  border-color: #1d1e26;\n}\nbody.dark-only .mega-inline .card,\nbody.dark-only .mega-horizontal .card,\nbody.dark-only .mega-vertical .card {\n  box-shadow: 1px 1px 7px 0 rgba(55, 69, 88, 0.5) !important;\n}\nbody.dark-only .mega-inline.plain-style .card, body.dark-only .mega-inline.border-style .card, body.dark-only .mega-inline.offer-style .card,\nbody.dark-only .mega-horizontal.plain-style .card,\nbody.dark-only .mega-horizontal.border-style .card,\nbody.dark-only .mega-horizontal.offer-style .card,\nbody.dark-only .mega-vertical.plain-style .card,\nbody.dark-only .mega-vertical.border-style .card,\nbody.dark-only .mega-vertical.offer-style .card {\n  box-shadow: none !important;\n}\nbody.dark-only .mega-inline.border-style .card,\nbody.dark-only .mega-horizontal.border-style .card,\nbody.dark-only .mega-vertical.border-style .card {\n  border: 1px solid #374558 !important;\n}\nbody.dark-only .mega-inline.offer-style .card,\nbody.dark-only .mega-horizontal.offer-style .card,\nbody.dark-only .mega-vertical.offer-style .card {\n  border: 1px dashed #374558 !important;\n}\nbody.dark-only .setting-dot .setting-bg {\n  background-color: var(--theme-secondary);\n}\nbody.dark-only .bookmark.pull-right {\n  border: none;\n}\nbody.dark-only .popover.bs-popover-bottom .popover-arrow:after, body.dark-only .popover.bs-popover-auto[data-popper-placement^=bottom] .popover-arrow:after {\n  border-bottom-color: #1d1e26;\n  border-right-color: transparent;\n}\nbody.dark-only .popover.bs-popover-top .popover-arrow:after, body.dark-only .popover.bs-popover-auto[data-popper-placement^=top] .popover-arrow:after {\n  border-right-color: transparent;\n  border-top-color: #1d1e26;\n}\nbody.dark-only .popover.bs-popover-start .popover-arrow:after, body.dark-only .popover.bs-popover-auto[data-popper-placement^=left] .popover-arrow:after {\n  border-left-color: #1d1e26;\n}\nbody.dark-only .popover {\n  background-color: #1d1e26;\n}\nbody.dark-only .popover .popover-header {\n  background-color: #262932;\n}\nbody.dark-only .popover .popover-arrow:after {\n  border-right-color: #1d1e26;\n}\nbody.dark-only .popover .popover-body {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .popover code {\n  background-color: unset;\n}\nbody.dark-only .apex-chart-container .apexcharts-legend .apexcharts-legend-series span {\n  color: rgba(255, 255, 255, 0.6) !important;\n}\nbody.dark-only .apexcharts-canvas svg .apexcharts-title-text {\n  fill: #fff;\n}\nbody.dark-only .apexcharts-canvas svg .apexcharts-subtitle-text {\n  fill: #fff;\n}\nbody.dark-only .apexcharts-canvas svg .apexcharts-yaxis .apexcharts-yaxis-texts-g .apexcharts-yaxis-label {\n  fill: #fff;\n}\nbody.dark-only .apexcharts-canvas svg .apexcharts-xaxis .apexcharts-xaxis-texts-g .apexcharts-xaxis-label {\n  fill: #fff;\n}\nbody.dark-only .apexcharts-canvas svg .apexcharts-legend-series span {\n  color: rgba(255, 255, 255, 0.6) !important;\n}\nbody.dark-only .apexcharts-canvas svg .apexcharts-datalabels-group .apexcharts-datalabel-label {\n  fill: #fff;\n}\nbody.dark-only .apexcharts-canvas svg .apexcharts-datalabels-group .apexcharts-datalabel-value {\n  fill: #fff;\n}\nbody.dark-only .Typeahead-menu {\n  background-color: #1d1e26;\n}\nbody.dark-only .ecommerce-widget {\n  border: 1px solid #1d1e26;\n}\nbody.dark-only .bookmark ul li .search-form .form-control-search input {\n  background-color: #1d1e26;\n  border: 1px solid #1d1e26;\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .bookmark ul li .search-form .form-control-search:before {\n  background: #1d1e26;\n}\nbody.dark-only .cart .qty-box .input-group .btn {\n  background-color: #2e3648 !important;\n  border-color: #374558 !important;\n}\nbody.dark-only .checkout .checkout-details {\n  background-color: #1d1e26;\n  border: 1px solid #1d1e26;\n  padding: 40px;\n}\nbody.dark-only .checkout .checkout-details .animate-chk .radio_animated:after {\n  border: 2px solid #262932;\n}\nbody.dark-only .order-box .title-box {\n  color: #bfc2c6;\n  border-bottom: 1px solid #1d1e26;\n}\nbody.dark-only .order-box .qty li {\n  color: #bfc2c6;\n}\nbody.dark-only .order-box .qty li span {\n  color: #bfc2c6;\n}\nbody.dark-only .order-box .qty {\n  border-bottom: 1px solid #1d1e26;\n}\nbody.dark-only .order-box .sub-total li {\n  color: #bfc2c6;\n}\nbody.dark-only .order-box .total li {\n  color: #bfc2c6;\n}\nbody.dark-only .shopping-checkout-option .checkbox_animated:after {\n  border: 2px solid #262932;\n}\nbody.dark-only .animate-chk .radio_animated:after {\n  border: 2px solid #1d1e26;\n}\nbody.dark-only .custom-scrollbar::-webkit-scrollbar-thumb {\n  background-color: rgba(41, 50, 64, 0.52);\n}\nbody.dark-only .product-box .product-img .product-hover ul li .btn {\n  color: #98a6ad;\n}\nbody.dark-only .product-box .product-img .product-hover ul li:hover .btn {\n  color: #fff;\n}\nbody.dark-only .radio_animated:after,\nbody.dark-only .checkbox_animated:after {\n  background: #1d1e26;\n  border: 2px solid #1d1e26;\n}\nbody.dark-only .slider-product {\n  border-top: 1px solid #1d1e26;\n  border-bottom: 1px solid #1d1e26;\n}\nbody.dark-only .square-product-setting .icon-grid {\n  background-color: #262932;\n}\nbody.dark-only .square-product-setting .icon-grid svg {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .active-order-table table thead tr th,\nbody.dark-only .market-table table thead tr th {\n  border-top: none !important;\n}\nbody.dark-only .active-order-table table tbody tr td,\nbody.dark-only .market-table table tbody tr td {\n  border-bottom: 1px solid #1d1e26;\n}\nbody.dark-only .active-order-table table tbody tr:last-child td,\nbody.dark-only .market-table table tbody tr:last-child td {\n  border-bottom: none;\n}\nbody.dark-only .pricing-card-design-2 .pricing-block .pricing-inner ul li {\n  border-bottom: 1px solid #1d1e26;\n}\nbody.dark-only .flot-chart-container .legend .table tbody {\n  background-color: #262932;\n  color: #fff;\n}\nbody.dark-only .flot-chart-container .legend .table tbody .legendLabel {\n  padding-left: 5px;\n}\nbody.dark-only .google-visualization-tooltip text {\n  fill: rgba(0, 0, 0, 0.7) !important;\n}\nbody.dark-only .nav-dark .nav-link,\nbody.dark-only .nav-pills.nav-dark .nav-link {\n  color: #fff;\n}\nbody.dark-only .loader-wrapper {\n  background-color: #1d1e26;\n}\nbody.dark-only .loader-wrapper .loader {\n  background-color: #1d1e26 !important;\n}\nbody.dark-only .page-wrapper .sidebar-main-title h6, body.dark-only .page-wrapper .sidebar-main-title .h6 {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper {\n  /* Main Header start */\n}\nbody.dark-only .page-wrapper .page-header .translate_wrapper.active .more_lang {\n  background-color: #1d1e26;\n}\nbody.dark-only .page-wrapper .page-header .translate_wrapper.active .lang {\n  background-color: #262932;\n}\nbody.dark-only .page-wrapper .page-header form {\n  background-color: #1d1e26;\n}\nbody.dark-only .page-wrapper .page-header .header-wrapper {\n  background-color: #262932;\n}\nbody.dark-only .page-wrapper .page-header .header-wrapper li i {\n  color: #f4f4f4;\n}\nbody.dark-only .page-wrapper .page-header .header-wrapper .nav-right > ul > li svg {\n  stroke: #fff;\n}\nbody.dark-only .page-wrapper .page-header .header-wrapper .nav-right.right-header > ul > li .profile-media .media-body p {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-header .header-wrapper .nav-right .nav-menus li .media .media-body .txt-dark {\n  color: rgba(255, 255, 255, 0.6) !important;\n}\nbody.dark-only .page-wrapper .page-header .header-wrapper .nav-right .nav-menus li .onhover-show-div {\n  background-color: #1d1e26;\n  box-shadow: 0 0 14px #1d1e26;\n}\nbody.dark-only .page-wrapper .page-header .header-wrapper .nav-right .nav-menus li .onhover-show-div li {\n  border-color: #262932;\n}\nbody.dark-only .page-wrapper .page-header .header-wrapper .nav-right .nav-menus li .onhover-show-div p {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-header .header-wrapper .nav-right .nav-menus li .onhover-show-div:before {\n  border-bottom: 7px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-header .header-wrapper .nav-right .nav-menus li .onhover-show-div:after {\n  border-bottom: 7px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-header .header-wrapper .nav-right .nav-menus li .notification-dropdown.onhover-show-div li {\n  background-color: #262932;\n}\nbody.dark-only .page-wrapper .page-header .header-wrapper .nav-right .nav-menus li .notification-dropdown.onhover-show-div li span {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-header .header-wrapper .nav-right .nav-menus li .notification-dropdown.onhover-show-div .bg-light {\n  background-color: #282e38 !important;\n  color: rgba(255, 255, 255, 0.6) !important;\n}\nbody.dark-only .page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown li a {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown li a svg path,\nbody.dark-only .page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown li a svg line,\nbody.dark-only .page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown li a svg circle {\n  color: rgba(255, 255, 255, 0.6) !important;\n}\nbody.dark-only .page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown li a:hover {\n  color: var(--theme-default);\n}\nbody.dark-only .page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown li a:hover svg line,\nbody.dark-only .page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown li a:hover svg path,\nbody.dark-only .page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown li a:hover svg circle {\n  color: var(--theme-default) !important;\n}\nbody.dark-only .page-wrapper .page-header .header-wrapper .nav-right > ul > li .media .media-body .txt-dark {\n  color: rgba(255, 255, 255, 0.6) !important;\n}\nbody.dark-only .page-wrapper .page-header .header-wrapper .nav-right > ul > li .onhover-show-div {\n  background-color: #1d1e26;\n  box-shadow: 0 0 2px 2px #262932;\n}\nbody.dark-only .page-wrapper .page-header .header-wrapper .nav-right > ul > li .onhover-show-div:before {\n  border-bottom: 7px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-header .header-wrapper .nav-right > ul > li .onhover-show-div:after {\n  border-bottom: 7px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-header .header-wrapper .nav-right > ul > li .notification-dropdown.onhover-show-div li {\n  border-color: #262932;\n}\nbody.dark-only .page-wrapper .page-header .header-wrapper .nav-right > ul > li .notification-dropdown.onhover-show-div li span {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-header .header-wrapper .nav-right .bookmark-flip .bookmark-dropdown .bookmark-content .bookmark-icon {\n  background-color: #262932;\n}\nbody.dark-only .page-wrapper .page-header .header-logo-wrapper {\n  background-color: #262932;\n}\nbody.dark-only .page-wrapper .page-header .header-logo-wrapper .logo-wrapper a .image-dark {\n  display: none;\n}\nbody.dark-only .page-wrapper .page-header .header-logo-wrapper .logo-wrapper a .image-light {\n  display: block;\n}\nbody.dark-only .page-wrapper {\n  /* Main Header ends */\n}\nbody.dark-only .page-wrapper .page-body-wrapper {\n  /* body start*/\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .topper-lists table tbody tr td p {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .header-small {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .statistics p {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .feather-main .media-body p,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .feather-main .professor-block p,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .professor-table .media-body p,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .professor-table .professor-block p {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .logs-element span + span {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .progress-block .progress-title span + span {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .ecommerce-icons div span {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .new-users .media .media-body p,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .recent-notification .media .media-body p {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .progress-media .media .media-body span {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .progress-media .progress-change span {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .topper-lists table tbody tr td {\n  border-top: none !important;\n  border-bottom: 1px solid #374558;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .topper-lists table tbody tr:last-child td {\n  border-bottom: none;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .notifiaction-media .media .media-body .circle-left {\n  border: 5px solid #334154;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .upcoming-event .upcoming-innner {\n  border-bottom: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .upcoming-event .upcoming-innner:last-child {\n  border-bottom: none;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .professor-table table tbody tr td {\n  border-top: none !important;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .number-widgets .media .media-body h6, body.dark-only .page-wrapper .page-body-wrapper .page-body .number-widgets .media .media-body .h6 {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .activity .media .gradient-round.gradient-line-1:after, body.dark-only .page-wrapper .page-body-wrapper .page-body .activity .media .gradient-round.small-line:after, body.dark-only .page-wrapper .page-body-wrapper .page-body .activity .media .gradient-round.medium-line:after {\n  background-color: #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .activity .media .media-body h6 span, body.dark-only .page-wrapper .page-body-wrapper .page-body .activity .media .media-body .h6 span {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card.custom-card .card-header {\n  border-bottom: none !important;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .custom-card .card-header img {\n  background-color: #000;\n  opacity: 0.8;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-title .row h3 small, body.dark-only .page-wrapper .page-body-wrapper .page-title .row .h3 small, body.dark-only .page-wrapper .page-body-wrapper .page-title .row h3 .small, body.dark-only .page-wrapper .page-body-wrapper .page-title .row .h3 .small {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-title .breadcrumb li {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-title .breadcrumb .breadcrumb-item a svg {\n  stroke: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body {\n  background-color: #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .default-according .card:not(.email-body) {\n  border: none;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) {\n  background-color: #262932;\n  box-shadow: 1px 1px 2px 1px rgba(29, 28, 28, 0.08);\n  border: 1px solid #374558;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body).widget-1 {\n  background-color: #1b1d24;\n  background-blend-mode: overlay;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body).widget-1 .widget-round .bg-round {\n  box-shadow: 1px 2px 21px -2px rgba(14, 14, 16, 0.83);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body).widget-1 .widget-round .bg-round .half-circle {\n  background: rgba(49, 53, 66, 0);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body).social-profile {\n  background-blend-mode: overlay;\n  background-color: #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table.table-light tr th,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table.table-light tr td {\n  color: #2f2f3b;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) table thead .border-bottom-light th,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) table thead .border-bottom-light td,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) table tbody .border-bottom-light th,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) table tbody .border-bottom-light td {\n  border-bottom: 1px solid #374558 !important;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body).balance-box {\n  background-blend-mode: overlay;\n  background-color: #16171c;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-block #bar-chart2 svg > rect {\n  fill: #262932;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-block #bar-chart2 svg > g text {\n  fill: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-block .word-tree svg > g > rect {\n  fill: #262932;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-block .word-tree svg > g > text {\n  fill: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-header {\n  background-color: transparent;\n  border-bottom: 1px solid #374558;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-header > span {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-header h1, body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-header .h1,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-header h2,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-header .h2,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-header h3,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-header .h3,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-header h4,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-header .h4,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-header h5,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-header .h5,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-header h6,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-header .h6 {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-header .card-header-right {\n  background-color: #262932;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-header .card-header-right i {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-header .card-header-right i.fa-cog {\n  color: var(--theme-default);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-header.note-toolbar {\n  background-color: #262932;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .alert-dark {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .alert-dark a {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .alert-light.outline,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .alert-light.outline-2x,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .alert-light.inverse {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) #animation-box .animate-widget p {\n  color: #98a6ad !important;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .grid-item img {\n  background-color: #262932;\n  border: 1px solid #374558;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .line {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) thead,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) tbody,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) tfoot,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) tr,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) td,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) th {\n  border-color: #374558;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table th,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table td {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table thead th {\n  border-bottom: 1px solid #374558;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table thead .border-bottom-primary th {\n  border-bottom: 1px solid var(--theme-default);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .table-primary th,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .table-primary td,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .table-secondary th,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .table-secondary td,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .table-success th,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .table-success td,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .table-info th,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .table-info td,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .table-warning th,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .table-warning td,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .table-light th,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .table-light td,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .table-danger th,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .table-danger td {\n  color: #262932;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .bg-primary,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .bg-secondary,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .bg-success,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .bg-info,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .bg-warning,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .bg-danger {\n  color: #fff;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .bg-light {\n  color: #000;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table .thead-light th {\n  color: #000;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table tbody .border-bottom-primary th,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table tbody .border-bottom-primary td {\n  border-bottom: 1px solid var(--theme-default);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table[class*=bg-] th,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table[class*=bg-] td {\n  color: #fff;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table-striped tbody tr:nth-of-type(odd) {\n  --bs-table-accent-bg: rgba(0, 0, 0, 0.05);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table-striped tbody tr:nth-of-type(odd):hover th,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table-striped tbody tr:nth-of-type(odd):hover td {\n  color: #fff;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table-double,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table-dotted,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table-dashed {\n  border-left-color: #374558;\n  border-right-color: #374558;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table-bordered {\n  border-color: #374558 !important;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table-bordered td,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table-bordered th {\n  border-color: #374558 !important;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table-inverse tbody tr:nth-of-type(odd):hover td {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table-border-vertical tr,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table-border-vertical th,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table-border-vertical td {\n  border-right: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table-styling thead th,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table-styling thead td,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table-styling tbody th,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .table-styling tbody td {\n  color: #fff;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .card-footer {\n  background-color: #262932;\n  border-top: 1px solid #374558;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .switch .switch-state {\n  background-color: #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .switch input:checked + .switch-state {\n  background-color: var(--theme-default);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .bg-white {\n  background-color: #fff !important;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .b-l-light {\n  border-left: 1px solid #1d1e26 !important;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .ct-grid {\n  stroke: #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .ct-label {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) hr {\n  border-top: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .text-muted {\n  color: rgba(255, 255, 255, 0.6) !important;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .btn-outline-light,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .btn-outline-dark,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .btn-outline-light-2x {\n  color: #fff !important;\n  border: 1px solid #374558;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .btn-outline-light:hover {\n  color: #000 !important;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .border-right {\n  border-right: 1px solid #1d1e26 !important;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .flot-chart-placeholder .flot-text {\n  color: rgba(255, 255, 255, 0.6) !important;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .flot-chart-placeholder svg text {\n  fill: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-overflow#gantt_chart svg g rect:first-child {\n  fill: #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-overflow#gantt_chart rect:nth-child(6) {\n  fill: #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-overflow#line-chart rect, body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-overflow#column-chart1 rect, body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-overflow#column-chart2 rect {\n  fill: #262932;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-overflow svg > rect {\n  fill: #262932;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-overflow svg > g > g > g text {\n  fill: rgb(177, 177, 178);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-overflow svg > g > text {\n  fill: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .radial-bar:after {\n  background-color: #262932;\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .bar-chart-widget .bottom-content .num {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .bar-chart-widget .bottom-content .num .color-bottom {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .b-r-light {\n  border-right: 1px solid #374558 !important;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-container .live-products .ct-labels .ct-label,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-container .turnover .ct-labels .ct-label,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-container .monthly .ct-labels .ct-label,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-container .uses .ct-labels .ct-label {\n  color: #fff;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-container .live-products .ct-grid,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-container .turnover .ct-grid,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-container .monthly .ct-grid,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-container .uses .ct-grid {\n  stroke: #fff;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-container #browser-uses-chart svg text,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .chart-container #website-visiter-chart svg text {\n  fill: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .status-details h4, body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .status-details .h4 {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .status-details h4 span, body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .status-details .h4 span {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .status-details span {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .clipboaard-container .form-control {\n  background-color: #1d1e26;\n  color: #98a6ad;\n  border: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .img-thumbnail {\n  background-color: #1d1e26;\n  border: 1px solid #374558;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper button {\n  color: #000;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper.no-footer .dataTables_scrollBody {\n  border-bottom: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper .btn-danger,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper .btn-success,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper .btn-primary {\n  color: #fff;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper .dataTables_length select {\n  background-color: #1d1e26;\n  color: rgba(255, 255, 255, 0.6);\n  border: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper .dataTables_length,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper .dataTables_filter,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper .dataTables_info,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper .dataTables_processing,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper .dataTables_paginate {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper .dataTables_paginate {\n  border: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper .dataTables_filter input[type=search] {\n  background-color: #1d1e26;\n  border: 1px solid #1d1e26;\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.display tbody tr,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.order-column.stripe tbody tr {\n  background-color: #262932;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.display tbody tr:hover > .sorting_1,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.order-column.stripe tbody tr:hover > .sorting_1 {\n  background-color: #1c212b;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.display tbody tr.odd,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.order-column.stripe tbody tr.odd {\n  background-color: #1f232b;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.display tbody tr.odd > .sorting_1,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.order-column.stripe tbody tr.odd > .sorting_1 {\n  background-color: #1c212b;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.display tbody tr.even > .sorting_1,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.order-column.stripe tbody tr.even > .sorting_1 {\n  background-color: #22262f;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable {\n  border: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable thead th,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable thead td {\n  border-bottom: 2px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable input,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable select {\n  background-color: #1d1e26;\n  color: rgba(255, 255, 255, 0.6);\n  border: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable tbody tr {\n  background-color: #262932;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable tbody td.select-checkbox:before,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable tbody th.select-checkbox:before {\n  border: 1px solid #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper .table-striped tbody tr:nth-of-type(odd) {\n  --bs-table-accent-bg: #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper .dataTables_paginate .paginate_button {\n  color: rgba(255, 255, 255, 0.6) !important;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper .dataTables_paginate .paginate_button.current, body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper .dataTables_paginate .paginate_button:active {\n  border-color: var(--theme-default);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper .dataTables_paginate .paginate_button.disabled {\n  color: #98a6ad !important;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper .dataTables_paginate .paginate_button.disabled:hover,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper .dataTables_paginate .paginate_button.disabled :active {\n  color: #98a6ad !important;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.row-border tbody th,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.row-border tbody td,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.display tbody th,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.display tbody td {\n  border-top: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.display tbody tr.even:hover > .sorting_1,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.order-column.hover tbody tr.even:hover > .sorting_1 {\n  background-color: #191e27;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.hover tbody tr:hover,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.display tbody tr:hover {\n  background-color: #1c212b;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.cell-border th,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.cell-border td {\n  border-top: 1px solid #1d1e26;\n  border-right: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.cell-border th:first-child,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.cell-border td:first-child {\n  border-left: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.order-column tbody tr > .sorting_1,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.order-column tbody tr > .sorting_2,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.order-column tbody tr > .sorting_3,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.display tbody tr > .sorting_1,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.display tbody tr > .sorting_2,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .dataTables_wrapper table.dataTable.display tbody tr > .sorting_3 {\n  background-color: #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) #example-style-3_wrapper #example-style-3 tfoot {\n  border-top: 2px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .page-link {\n  border: 1px solid #374558;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .page-item.disabled .page-link {\n  background-color: #262932;\n  border-color: #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .page-link {\n  color: rgba(255, 255, 255, 0.6);\n  background-color: #262932;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .page-item:hover .page-link {\n  background-color: #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .page-item.active .page-link {\n  background-color: #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .ecommerce-widget .icon {\n  color: #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .ecommerce-widget .total-num {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .ecommerce-widget .total-num span {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .ecommerce-widget span {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .flot-chart-container-small {\n  background-color: #262932;\n  border-top: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .product-table #API-2_wrapper #API-2 tbody td span,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .product-table #API-2_wrapper #API-2 tbody td p {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .product-table h6, body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .product-table .h6 {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .border-tab.nav-tabs {\n  border-bottom: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .border-tab.nav-tabs .nav-item .nav-link {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .border-tab.nav-tabs .nav-link.active, body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .border-tab.nav-tabs .nav-link:focus, body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .border-tab.nav-tabs .nav-link:hover {\n  color: var(--theme-default);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-bars-1to10 .br-widget a,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-bars-movie .br-widget a,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-bars-pill .br-widget a,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-bars-reversed .br-widget a,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-bars-horizontal .br-widget a {\n  background-color: #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-bars-1to10 .br-widget a.br-active, body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-bars-1to10 .br-widget a.br-selected,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-bars-movie .br-widget a.br-active,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-bars-movie .br-widget a.br-selected,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-bars-pill .br-widget a.br-active,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-bars-pill .br-widget a.br-selected,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-bars-reversed .br-widget a.br-active,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-bars-reversed .br-widget a.br-selected,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-bars-horizontal .br-widget a.br-active,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-bars-horizontal .br-widget a.br-selected {\n  background-color: var(--theme-default);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-bars-square .br-widget a {\n  border: 2px solid #1d1e26;\n  background-color: #262932;\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-bars-square .br-widget a.br-active, body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-bars-square .br-widget a.br-selected {\n  border: 2px solid var(--theme-default);\n  color: var(--theme-default);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-fontawesome-stars .br-widget a.br-selected:after, body.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-fontawesome-stars .br-widget a.br-active:after,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-fontawesome-stars-o .br-widget a.br-selected:after,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .br-theme-fontawesome-stars-o .br-widget a.br-active:after {\n  color: var(--theme-default);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .scroll-demo {\n  border: 1px solid #374558;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .search-form input {\n  border: 1px solid #1d1e26;\n  color: rgba(255, 255, 255, 0.6);\n  background-color: #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .search-form .form-group:before {\n  background: #262932;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .cd-timeline-content {\n  background-color: #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .cd-timeline-content::before {\n  border-left: 7px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .cd-timeline-block:nth-child(even) .cd-timeline-content::before {\n  border-right-color: #1d1e26;\n  border-left: transparent;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) .breadcrumb.bg-white {\n  background-color: #262932 !important;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) #donut-color-chart-morris-daily svg,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) #donut-color-chart-morris svg,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) #browser-uses-chart svg,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card:not(.email-body) #website-visiter-chart svg {\n  opacity: 0.5;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .form-builder-header-1,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .form-builder-2-header {\n  background-color: #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .show > .nav-link {\n  color: #fff;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-link {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-link.active {\n  color: #fff;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-pills.nav-primary .show > .nav-link {\n  color: #fff;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-pills.nav-primary .nav-link {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-pills.nav-primary .nav-link.active {\n  color: #fff;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .form-builder .drag-box fieldset {\n  border: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .form-builder .help-block {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body #viewhtml .render {\n  background-color: #262932;\n  color: rgba(255, 255, 255, 0.6);\n  border-color: #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .form-builder-column .drag-bx {\n  border: 1px dotted #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .wizard-4 ul.anchor li a.disabled {\n  color: #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .gallery-with-description h4, body.dark-only .page-wrapper .page-body-wrapper .page-body .gallery-with-description .h4 {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .gallery-with-description a > div {\n  border: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .gallery-with-description p {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-grid-header {\n  background-color: #262932;\n  border: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row > .jsgrid-header-cell,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row > .jsgrid-cell,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row > .jsgrid-header-cell,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row > .jsgrid-cell {\n  background: #262932;\n  border: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row > .jsgrid-header-cell input,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row > .jsgrid-cell input,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row > .jsgrid-header-cell input,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row > .jsgrid-cell input {\n  background-color: #1d1e26;\n  border-color: #1d1e26;\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row > .jsgrid-header-cell input:focus,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row > .jsgrid-cell input:focus,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row > .jsgrid-header-cell input:focus,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row > .jsgrid-cell input:focus {\n  outline: none;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row select,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row select {\n  background-color: #1d1e26;\n  border-color: #1d1e26;\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-row > .jsgrid-cell {\n  background-color: #262932;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-alt-row > .jsgrid-cell {\n  background-color: #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-cell,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-grid-body {\n  border: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-selected-row > .jsgrid-cell {\n  background-color: #1c212b;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid .jsgrid-pager [class*=jsgrid-pager] {\n  border: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid .jsgrid-pager .jsgrid-pager-page a {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .jsgrid-pager-current-page {\n  color: rgba(255, 255, 255, 0.6);\n  font-weight: 700;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .sub-title {\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card .sub-title {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .navs-icon li a {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .navs-icon li a:hover {\n  color: var(--theme-default);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .navs-icon .separator {\n  border-bottom: 1px solid #374558;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .default-according li .text-muted {\n  color: rgba(255, 255, 255, 0.6) !important;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .navs-icon.default-according.style-1 li button:hover {\n  color: var(--theme-default) !important;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .nav-list .nav-list-disc li a {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .nav-list .nav-list-disc li:hover {\n  color: var(--theme-default);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .nav-list .nav-list-disc li:hover a {\n  color: var(--theme-default);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .navs-dropdown .onhover-show-div {\n  background-color: #1d1e26;\n  box-shadow: 0 0 14px 0 #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .navs-dropdown .onhover-show-div .navs-icon li p {\n  color: #fff;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .navs-dropdown .onhover-show-div .navs-icon li a svg path,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .navs-dropdown .onhover-show-div .navs-icon li a svg line,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .navs-dropdown .onhover-show-div .navs-icon li a svg polyline,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .navs-dropdown .onhover-show-div .navs-icon li a svg polygon,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .navs-dropdown .onhover-show-div .navs-icon li a svg rect {\n  color: rgba(255, 255, 255, 0.6) !important;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .navs-dropdown .onhover-show-div .navs-icon li a:hover svg path,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .navs-dropdown .onhover-show-div .navs-icon li a:hover svg line,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .navs-dropdown .onhover-show-div .navs-icon li a:hover svg polyline,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .navs-dropdown .onhover-show-div .navs-icon li a:hover svg polygon,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .navs-dropdown .onhover-show-div .navs-icon li a:hover svg rect {\n  color: var(--theme-default) !important;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .onhover-dropdown:hover .onhover-show-div:before {\n  border-bottom: 7px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .default-according .card .btn-link {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .default-according .card .card-body {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .default-according .card .card-body {\n  border: 1px solid #374558;\n  border-top: none;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .border {\n  border: 1px solid #374558 !important;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .blog-box .blog-date {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .blog-social li,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .blog-social li {\n  color: #98a6ad;\n  border-right: 1px solid #374558;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .blog-social li:first-child,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .blog-social li:first-child {\n  border-right: 1px solid #374558;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .blog-social li:last-child,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .blog-social li:last-child {\n  border-right: none;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details p,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main p {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .single-blog-content-top,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .single-blog-content-top {\n  border-top: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .single-blog-content-top p,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .single-blog-content-top p {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .comment-box .media h6 span, body.dark-only .page-wrapper .page-body-wrapper .page-body .comment-box .media .h6 span {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .comment-box .media img {\n  border: 1px solid #374558;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .comment-box p {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .comment-box .comment-social li {\n  color: #98a6ad;\n  border: none;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .comment-box .comment-social li:first-child {\n  border-right: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .comment-box hr {\n  border-top: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .table-hover > tbody > tr:hover {\n  --bs-table-accent-bg: #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .table-hover > tbody > tr:hover td,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .table-hover > tbody > tr:hover th {\n  color: #fff;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body ul.the-icons li {\n  border: 1px dotted #374558;\n  color: rgba(255, 255, 255, 0.6);\n  display: inline-block;\n  padding: 10px;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body ul.the-icons li:hover {\n  background: #000;\n  box-shadow: 0 0 3px #262932;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body ul.the-icons li em {\n  display: none;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .button-builder-wrap .box {\n  background-color: #262932;\n  border: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .button-builder-wrap .button-preview h2, body.dark-only .page-wrapper .page-body-wrapper .page-body .button-builder-wrap .button-preview .h2 {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .button-builder-wrap pre.well {\n  background-color: #262932 !important;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .crm-activity > li + li {\n  border-top: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .crm-activity > li h6, body.dark-only .page-wrapper .page-body-wrapper .page-body .crm-activity > li .h6 {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .crm-activity ul.dates li {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body #donut-color-chart-morris svg text,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body #donut-color-chart-morris-daily svg text {\n  fill: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .custom-card .card-profile img {\n  background-color: #262932;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .custom-card .profile-details h6, body.dark-only .page-wrapper .page-body-wrapper .page-body .custom-card .profile-details .h6 {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .custom-card .card-social li a {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .custom-card .card-footer > div h6, body.dark-only .page-wrapper .page-body-wrapper .page-body .custom-card .card-footer > div .h6 {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .custom-card .card-footer > div + div {\n  border-left: 1px solid #323846;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .form-control {\n  background-color: #1d1e26;\n  color: rgba(255, 255, 255, 0.6);\n  border: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .form-control.touchspin {\n  background-color: #262932;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .checkbox label::before,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .radio label::before {\n  background-color: #1d1e26;\n  border: 1px solid #1d1e26;\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .dropdown-basic .dropdown .dropdown-content {\n  background-color: #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .dropdown-basic .dropdown .dropdown-content a {\n  color: rgba(255, 255, 255, 0.6);\n  background-color: transparent;\n  border-color: #262932;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .dropdown-basic .dropdown .dropdown-content a:hover {\n  background-color: #262932;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .dropdown-basic .dropdown .dropdown-content .dropdown-header {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .dropdown-basic .dropdown .dropdown-content .dropdown-divider {\n  border: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .dropup-basic .dropup .dropup-content {\n  background-color: #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .dropup-basic .dropup .dropup-content a {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .dropup-basic .dropup .dropup-content a:hover, body.dark-only .page-wrapper .page-body-wrapper .page-body .dropup-basic .dropup .dropup-content a.active {\n  background-color: #262932;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .dropzone.dz-clickable .dz-message h6, body.dark-only .page-wrapper .page-body-wrapper .page-body .dropzone.dz-clickable .dz-message .h6 {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .dropzone.dz-clickable .dz-message span {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .dropzone .dz-preview {\n  background-color: #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .dropzone .dz-preview .dz-details {\n  background-color: #262932;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .browser-widget .media-body {\n  column-rule: 1px solid #374558;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .browser-widget .media-body h4, body.dark-only .page-wrapper .page-body-wrapper .page-body .browser-widget .media-body .h4 {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .browser-widget .media-body h4 span, body.dark-only .page-wrapper .page-body-wrapper .page-body .browser-widget .media-body .h4 span {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .browser-widget .media-body span {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .email-app-sidebar .media img {\n  border: 2px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .email-app-sidebar .main-menu > li a {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .email-app-sidebar .main-menu > li a:hover {\n  background-color: #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .email-app-sidebar ul li a > .title {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .email-right-aside .email-body .row .col-xl-4 {\n  border-right: 1px solid rgba(0, 0, 0, 0.1);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .email-right-aside .email-body .inbox .media.active {\n  background-color: #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body h6, body.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body .h6 {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body h6 small, body.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body .h6 small, body.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body h6 .small, body.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body .h6 .small {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body h6 small span, body.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body .h6 small span, body.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body h6 .small span, body.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body .h6 .small span {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body p {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .email-top {\n  border-bottom: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap p {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .email-content .email-top .user-emailid:after {\n  border: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .email-wrap .notification-popup p {\n  color: #fff;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .dropdown-menu {\n  background-color: #1d1e26;\n  border: 1px solid #262932;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .dropdown-menu a {\n  color: rgba(255, 255, 255, 0.6);\n  background: transparent;\n  border-top-color: #262932;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .dropdown-menu a:hover {\n  background-color: #262932;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .icon-lists div i {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .icon-lists div:hover {\n  background-color: #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .redial-social-widget i {\n  background-color: #262932;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .b-b-light {\n  border-bottom: 1px solid #374558 !important;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .b-r-dark {\n  border-right: 1px solid #fff !important;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .testimonial i {\n  color: #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .testimonial p {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .testimonial h5, body.dark-only .page-wrapper .page-body-wrapper .page-body .testimonial .h5 {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .testimonial span {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .grid-showcase span {\n  background-color: #262932;\n  border: 1px solid #374558;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .grid-align .row {\n  background-color: #1d1e26;\n  border: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .page-builder .ge-html-output {\n  background-color: #1d1e26;\n  color: #98a6ad;\n  border: 1px solid #374558;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .page-builder .btn-grid {\n  background-color: #262932;\n  color: #98a6ad !important;\n  border-right: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .page-builder .ge-mainControls .ge-addRowGroup .ge-row-icon .column {\n  border-left: 3px solid #262932;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .page-builder .btn-code,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .page-builder .btn-screen {\n  color: #98a6ad;\n  border-right: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .page-builder .ge-canvas.ge-editing .row {\n  background-color: #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .page-builder .ge-canvas.ge-editing .column {\n  border: 1px solid #1d1e26;\n  background-color: #262932;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .page-builder .ge-canvas.ge-editing .ge-tools-drawer .ge-details input {\n  background-color: #1d1e26;\n  border-color: #1d1e26;\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .page-builder .ge-canvas.ge-editing .ge-tools-drawer .ge-details .btn-group a {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .page-builder .ge-content-type-ckeditor {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .search-page .info-block {\n  border: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card-absolute .bg-primary h5, body.dark-only .page-wrapper .page-body-wrapper .page-body .card-absolute .bg-primary .h5,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card-absolute .bg-secondary h5,\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .card-absolute .bg-secondary .h5 {\n  color: #fff;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body .timeline-small .media .timeline-round.timeline-line-1:after, body.dark-only .page-wrapper .page-body-wrapper .page-body .timeline-small .media .timeline-round.small-line:after, body.dark-only .page-wrapper .page-body-wrapper .page-body .timeline-small .media .timeline-round.medium-line:after {\n  background-color: #374558;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .page-body {\n  /* body end*/\n}\nbody.dark-only .page-wrapper .page-body-wrapper .footer p {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .footer {\n  border-top: 1px solid #1d1e26;\n  background-color: #262932;\n}\nbody.dark-only .page-wrapper .page-body-wrapper .custom-select,\nbody.dark-only .page-wrapper .page-body-wrapper .custom-file-label {\n  background: #1d1e26;\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .page-body-wrapper .footer-fix {\n  background-color: #262932;\n  border-top: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .note textarea {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .dt-button-info {\n  background-color: #262932;\n  border: 1px solid #98a6ad;\n}\nbody.dark-only .page-wrapper .dt-button-info h2, body.dark-only .page-wrapper .dt-button-info .h2 {\n  background-color: #262932;\n}\nbody.dark-only .page-wrapper .chat-box .about .name {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .chat-box .chat-menu {\n  border-left: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .chat-box .chat-menu .nav-tabs {\n  border-bottom: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .chat-box .chat-menu .nav-tabs .nav-item .nav-link.active {\n  color: rgba(255, 255, 255, 0.6) !important;\n}\nbody.dark-only .page-wrapper .chat-box .chat-menu .user-profile .image .icon-wrapper {\n  background-color: #262932;\n  box-shadow: 1px 1px 3px 1px #1d1e26;\n}\nbody.dark-only .page-wrapper .chat-box .chat-menu .user-profile .image .avatar img {\n  border: 5px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .chat-box .chat-menu .user-profile .social-media a {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .chat-box .chat-menu .user-profile .follow span {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .chat-box .chat-menu .user-profile .follow .follow-num {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .chat-box .status {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .chat-box .status p {\n  color: rgba(255, 255, 255, 0.6) !important;\n}\nbody.dark-only .page-wrapper .chat-box .chat-right-aside .chat .chat-header {\n  border-bottom: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .chat-box .chat-right-aside .chat .chat-header .chat-menu-icons li a i {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .chat-box .chat-right-aside .chat .chat-header img {\n  box-shadow: 1px 1px 4px 1px #1d1e26;\n}\nbody.dark-only .page-wrapper .chat-box .chat-right-aside .chat .chat-msg-box .my-message {\n  border: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .chat-box .chat-right-aside .chat .chat-msg-box .message {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .chat-box .chat-right-aside .chat .chat-msg-box .other-message {\n  background-color: #1d1e26;\n}\nbody.dark-only .page-wrapper .chat-box .chat-right-aside .chat .chat-message {\n  background-color: #262932;\n  border-top: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .chat-box .chat-right-aside .chat .chat-message .input-group .form-control {\n  background-color: #262932;\n}\nbody.dark-only .page-wrapper .chat-box .chat-history .call-icons ul li {\n  border: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .chat-box .chat-history .call-icons ul li a {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper pre {\n  background-color: #1d1e26;\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .scorlled {\n  background-color: #1d1e26;\n}\nbody.dark-only .page-wrapper .input-group-air {\n  box-shadow: 0 3px 20px 0 #1d1e26;\n}\nbody.dark-only .page-wrapper .input-group-text {\n  background-color: #262932;\n  border: 1px solid #1d1e26;\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .input-group-text i {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .input-group-solid .input-group-text,\nbody.dark-only .page-wrapper .input-group-solid .form-control {\n  background: #1d1e26;\n  border: 1px solid #1d1e26;\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .semilight-bg-color,\nbody.dark-only .page-wrapper .header-bg-color {\n  background-color: #fff;\n}\nbody.dark-only .page-wrapper .list-group-item {\n  background-color: #262932;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .list-group-item + .list-group-item {\n  border-top-width: 0;\n}\nbody.dark-only .page-wrapper .list-group-item.active {\n  background-color: var(--theme-default) !important;\n  border-color: var(--theme-default);\n  color: #fff;\n}\nbody.dark-only .page-wrapper .list-group-item:hover, body.dark-only .page-wrapper .list-group-item:focus {\n  z-index: 1;\n  text-decoration: none;\n}\nbody.dark-only .page-wrapper .list-group-item-action:hover:not(.active), body.dark-only .page-wrapper .list-group-item-action:focus {\n  background-color: #1d1e26;\n}\nbody.dark-only .page-wrapper .list-group-flush .list-group-item {\n  border-left: 0;\n  border-right: 0;\n  border-radius: 0;\n}\nbody.dark-only .page-wrapper .list-group-item-primary {\n  color: #004085;\n  background-color: #b8daff;\n}\nbody.dark-only .page-wrapper .list-group-item-secondary {\n  color: #383d41;\n  background-color: #d6d8db;\n}\nbody.dark-only .page-wrapper .list-group-item-success {\n  color: #155724;\n  background-color: #c3e6cb;\n}\nbody.dark-only .page-wrapper .list-group-item-danger {\n  color: #721c24;\n  background-color: #f5c6cb;\n}\nbody.dark-only .page-wrapper .list-group-item-warning {\n  color: #856404;\n  background-color: #ffeeba;\n}\nbody.dark-only .page-wrapper .list-group-item-info {\n  color: #0c5460;\n  background-color: #bee5eb;\n}\nbody.dark-only .page-wrapper .list-group-item-light {\n  color: #818182;\n  background-color: #fdfdfe;\n}\nbody.dark-only .page-wrapper .list-group-item-dark {\n  color: #1b1e21;\n  background-color: #c6c8ca;\n}\nbody.dark-only .page-wrapper .auth-bg {\n  background-blend-mode: overlay;\n  background-color: rgba(54, 64, 74, 0.9);\n}\nbody.dark-only .page-wrapper .auth-bg .authentication-box .card {\n  background-color: #262932;\n}\nbody.dark-only .page-wrapper .auth-bg .authentication-box .card .theme-form .form-group input {\n  color: rgba(255, 255, 255, 0.6);\n  background-color: #1d1e26;\n  border: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .auth-bg .authentication-box .card .theme-form .form-group label {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .auth-bg .authentication-box .card .theme-form .checkbox label {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .auth-bg .authentication-box .card .theme-form .checkbox label::before {\n  background-color: #1d1e26;\n  border: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .auth-bg .authentication-box h3, body.dark-only .page-wrapper .auth-bg .authentication-box .h3,\nbody.dark-only .page-wrapper .auth-bg .authentication-box h4,\nbody.dark-only .page-wrapper .auth-bg .authentication-box .h4,\nbody.dark-only .page-wrapper .auth-bg .authentication-box h6,\nbody.dark-only .page-wrapper .auth-bg .authentication-box .h6 {\n  color: #fff;\n}\nbody.dark-only .page-wrapper .auth-bg-video {\n  background-blend-mode: overlay;\n  background-color: rgba(54, 64, 74, 0.7);\n}\nbody.dark-only .page-wrapper .auth-bg-video .authentication-box h4, body.dark-only .page-wrapper .auth-bg-video .authentication-box .h4,\nbody.dark-only .page-wrapper .auth-bg-video .authentication-box h3,\nbody.dark-only .page-wrapper .auth-bg-video .authentication-box .h3 {\n  color: #fff;\n}\nbody.dark-only .page-wrapper .auth-bg-video .authentication-box h6, body.dark-only .page-wrapper .auth-bg-video .authentication-box .h6 {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .auth-bg-video .authentication-box .card {\n  background-color: #262932;\n}\nbody.dark-only .page-wrapper .auth-bg-video .authentication-box .card .theme-form .form-group input[type=text],\nbody.dark-only .page-wrapper .auth-bg-video .authentication-box .card .theme-form .form-group input[type=password] {\n  background-color: #1d1e26;\n  border: 1px solid #1d1e26;\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .auth-bg-video .authentication-box .card .theme-form .checkbox label::before {\n  background-color: #1d1e26;\n  border: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .error-wrapper .maintenance-icons li i {\n  color: #1d1e26;\n}\nbody.dark-only .page-wrapper .error-wrapper .maintenance-icons li:nth-child(3) i {\n  color: #1d1e26;\n}\nbody.dark-only .page-wrapper .modal-content {\n  background-color: #262932;\n}\nbody.dark-only .page-wrapper .modal-content .modal-header {\n  border-bottom: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .modal-content .modal-header .close {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .modal-content .modal-footer {\n  border-top: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .comingsoon {\n  background-blend-mode: overlay;\n  background-color: rgba(54, 64, 74, 0.9);\n}\nbody.dark-only .page-wrapper .comingsoon .comingsoon-inner h5, body.dark-only .page-wrapper .comingsoon .comingsoon-inner .h5 {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .comingsoon .comingsoon-inner .countdown {\n  border-top: 1px solid #1d1e26;\n  border-bottom: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .comingsoon .comingsoon-inner .countdown .title {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .comingsoon .comingsoon-inner .coming-soon-bottom-link a {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .theme-form .login-divider {\n  border-top: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .theme-form .login-divider:before {\n  background: #1d1e26;\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .authentication-main {\n  background-color: #1d1e26;\n}\nbody.dark-only .page-wrapper .authentication-main .auth-innerright .reset-password-box .card {\n  background-color: #262932;\n}\nbody.dark-only .page-wrapper .authentication-main .auth-innerright .reset-password-box .reset-password-link {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .authentication-main .auth-innerright .reset-password-box .theme-form .form-group label {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .authentication-main .auth-innerright .reset-password-box .theme-form .form-group .form-control {\n  background-color: #1d1e26;\n  color: rgba(255, 255, 255, 0.6);\n  border-color: #1d1e26;\n}\nbody.dark-only .page-wrapper .authentication-main .auth-innerright .reset-password-box .theme-form .opt-box {\n  background-color: #1d1e26;\n}\nbody.dark-only .page-wrapper .authentication-main .auth-innerright .authentication-box h4, body.dark-only .page-wrapper .authentication-main .auth-innerright .authentication-box .h4 {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .authentication-main .auth-innerright .authentication-box h6, body.dark-only .page-wrapper .authentication-main .auth-innerright .authentication-box .h6 {\n  color: #98a6ad;\n}\nbody.dark-only .page-wrapper .authentication-main .auth-innerright .authentication-box h3, body.dark-only .page-wrapper .authentication-main .auth-innerright .authentication-box .h3 {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .authentication-main .auth-innerright .authentication-box .card {\n  background-color: #262932;\n}\nbody.dark-only .page-wrapper .authentication-main .auth-innerright .authentication-box .card .theme-form .form-group input[type=text],\nbody.dark-only .page-wrapper .authentication-main .auth-innerright .authentication-box .card .theme-form .form-group input[type=password] {\n  background-color: #1d1e26;\n  border: 1px solid #1d1e26;\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .page-wrapper .authentication-main .auth-innerright .authentication-box .card .theme-form .checkbox label::before {\n  background-color: #1d1e26;\n  border: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .vertical-menu-main {\n  background-color: #262932;\n}\nbody.dark-only .page-wrapper .mega-menu .title {\n  color: rgba(255, 255, 255, 0.6);\n  border-bottom: 1px solid #1d1e26;\n}\nbody.dark-only .page-wrapper .mega-menu .list-unstyled div a:hover {\n  color: var(--theme-default);\n}\nbody.dark-only .page-wrapper .default-according .card {\n  background-color: #262932;\n}\nbody.dark-only .page-wrapper .default-according .card .btn-link {\n  background-color: #262932;\n  border: 1px solid #374558;\n  border-bottom: none;\n  color: #fff;\n}\nbody.dark-only .page-wrapper .default-according .card .text-muted {\n  color: #98a6ad !important;\n}\nbody.dark-only .page-wrapper .default-according .bg-primary .btn-link {\n  background-color: var(--theme-default);\n  border: 1px solid var(--theme-default);\n}\nbody.dark-only .page-wrapper .default-according .bg-secondary .btn-link {\n  background-color: var(--theme-secondary);\n  border: 1px solid var(--theme-secondary);\n}\nbody.dark-only .page-wrapper .collapse .card-body {\n  background-color: #262932;\n}\nbody.dark-only .page-wrapper .balance-widget.card-body {\n  background-color: #262932;\n  background-blend-mode: overlay;\n}\n@media screen and (max-width: 1660px) {\n  body.dark-only .page-wrapper .chat-box .chat-history .call-icons ul li {\n    border: 1px solid #1d1e26;\n  }\n  body.dark-only .page-wrapper .chat-box .chat-history .total-time h2, body.dark-only .page-wrapper .chat-box .chat-history .total-time .h2 {\n    color: rgba(255, 255, 255, 0.6);\n  }\n  body.dark-only .page-wrapper .caller-img img {\n    opacity: 0.7;\n  }\n  body.dark-only .page-wrapper .chat-box .chat-history .call-content > div {\n    background-color: rgba(0, 0, 0, 0.75);\n    background-blend-mode: overlay;\n  }\n}\n@media only screen and (max-width: 1199px) {\n  body.dark-only .page-wrapper .mobile-title.d-none {\n    border-bottom: 1px solid #374558;\n  }\n  body.dark-only .page-wrapper .chat-menu {\n    border-top: 1px solid #1d1e26;\n    background-color: #262932;\n  }\n  body.dark-only .page-wrapper .error-wrapper .maintenance-icons li i {\n    color: #2c323f;\n  }\n}\n@media only screen and (max-width: 575.98px) {\n  body.dark-only .page-wrapper .user-profile .hovercard .info .user-designation {\n    border-top: 1px solid #1d1e26;\n    border-bottom: 1px solid #1d1e26;\n  }\n  body.dark-only .page-wrapper .page-wrapper.compact-wrapper .page-header .header-wrapper .toggle-sidebar, body.dark-only .page-wrapper .page-wrapper.compact-sidebar .page-header .header-wrapper .toggle-sidebar {\n    border-right: 1px solid #374558;\n  }\n}\nbody.dark-only .lg-backdrop {\n  background-color: #1d1e26;\n}\nbody.dark-only .lg-outer .lg-thumb-outer {\n  background-color: #262932;\n}\nbody.dark-only .drag {\n  background-color: #262932;\n}\nbody.dark-only .drag form {\n  background: #262932;\n  box-shadow: 0 0 30px #1d1e26;\n  border: 1px dotted #1d1e26;\n}\nbody.dark-only .drag form input {\n  background-color: #1d1e26;\n  border: 1px solid #1d1e26;\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .drag form .help-block {\n  text-transform: capitalize;\n  color: #98a6ad;\n}\nbody.dark-only .draggable input {\n  background-color: #1d1e26;\n  color: rgba(255, 255, 255, 0.6);\n  border: 1px solid #1d1e26;\n}\nbody.dark-only .draggable p {\n  color: #98a6ad;\n}\nbody.dark-only .draggable select {\n  background-color: #1d1e26;\n  color: rgba(255, 255, 255, 0.6);\n  border: 1px solid #1d1e26;\n}\nbody.dark-only .draggable .radio label::before,\nbody.dark-only .draggable .checkbox label::before {\n  background-color: #1d1e26;\n  border: 1px solid #1d1e26;\n}\nbody.dark-only .select2-container--default .select2-selection--multiple,\nbody.dark-only .select2-container--default .select2-selection--single {\n  background-color: #1d1e26;\n  border: 1px solid #1d1e26 !important;\n}\nbody.dark-only .select2-container--default .select2-search--inline .select2-search__field {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .select2-container--default .select2-selection--single .select2-selection__rendered {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .select2-container--default .select2-search--dropdown .select2-search__field {\n  background-color: #1d1e26;\n  border: 1px solid #1d1e26;\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .select2-container--default .select2-results__option--highlighted[aria-selected] {\n  background-color: #262932 !important;\n  color: rgba(255, 255, 255, 0.6) !important;\n}\nbody.dark-only .select2-dropdown {\n  background-color: #1d1e26;\n  border: 1px solid #1d1e26;\n}\nbody.dark-only .select2-drpdwn .form-control-primary {\n  border-color: var(--theme-default) !important;\n  color: var(--theme-default) !important;\n}\nbody.dark-only .select2-drpdwn .form-control-secondary {\n  border-color: var(--theme-secondary) !important;\n  color: var(--theme-secondary) !important;\n}\nbody.dark-only .select2-drpdwn .form-control-success {\n  border-color: #54ba4a !important;\n  color: #54ba4a !important;\n}\nbody.dark-only .select2-drpdwn .form-control-info {\n  border-color: #16c7f9 !important;\n  color: #16c7f9 !important;\n}\nbody.dark-only .select2-drpdwn .form-control-warning {\n  border-color: #ffaa05 !important;\n  color: #ffaa05 !important;\n}\nbody.dark-only .select2-drpdwn .form-control-danger {\n  border-color: #fc4438 !important;\n  color: #fc4438 !important;\n}\nbody.dark-only .select2-drpdwn .form-control-inverse {\n  border-color: #fff !important;\n  color: #fff !important;\n}\nbody.dark-only .select2-drpdwn .form-control-primary-fill {\n  background-color: var(--theme-default) !important;\n  color: #fff !important;\n}\nbody.dark-only .select2-drpdwn .form-control-secondary-fill {\n  background-color: var(--theme-secondary) !important;\n  color: #fff !important;\n}\nbody.dark-only .select2-drpdwn .form-control-success-fill {\n  background-color: #54ba4a !important;\n  color: #fff !important;\n}\nbody.dark-only .select2-drpdwn .form-control-info-fill {\n  background-color: #16c7f9 !important;\n  color: #fff !important;\n}\nbody.dark-only .select2-drpdwn .form-control-warning-fill {\n  background-color: #ffaa05 !important;\n  color: #fff !important;\n}\nbody.dark-only .select2-drpdwn .form-control-danger-fill {\n  background-color: #fc4438 !important;\n  color: #fff !important;\n}\nbody.dark-only .select2-drpdwn .form-control-inverse-fill {\n  background-color: #fff !important;\n  color: #000 !important;\n}\nbody.dark-only .select2-container--default.select2-container--disabled .select2-selection--single {\n  background-color: #1d1e26;\n}\nbody.dark-only .theme-form .form-group select.form-control:not([size]):not([multiple]) {\n  background-color: #1d1e26;\n  color: rgba(255, 255, 255, 0.6);\n  border-color: #1d1e26;\n}\nbody.dark-only .theme-form .form-group input[type=text],\nbody.dark-only .theme-form .form-group input[type=email],\nbody.dark-only .theme-form .form-group input[type=search],\nbody.dark-only .theme-form .form-group input[type=password],\nbody.dark-only .theme-form .form-group input[type=number],\nbody.dark-only .theme-form .form-group input[type=tel],\nbody.dark-only .theme-form .form-group input[type=date],\nbody.dark-only .theme-form .form-group input[type=datetime-local],\nbody.dark-only .theme-form .form-group input[type=time],\nbody.dark-only .theme-form .form-group input[type=datetime-local],\nbody.dark-only .theme-form .form-group input[type=month],\nbody.dark-only .theme-form .form-group input[type=week],\nbody.dark-only .theme-form .form-group input[type=url],\nbody.dark-only .theme-form .form-group input[type=file],\nbody.dark-only .theme-form .form-group select {\n  border-color: #1d1e26;\n  background-color: #1d1e26;\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .theme-form .form-group input[type=text]::-webkit-input-placeholder,\nbody.dark-only .theme-form .form-group input[type=email]::-webkit-input-placeholder,\nbody.dark-only .theme-form .form-group input[type=search]::-webkit-input-placeholder,\nbody.dark-only .theme-form .form-group input[type=password]::-webkit-input-placeholder,\nbody.dark-only .theme-form .form-group input[type=number]::-webkit-input-placeholder,\nbody.dark-only .theme-form .form-group input[type=tel]::-webkit-input-placeholder,\nbody.dark-only .theme-form .form-group input[type=date]::-webkit-input-placeholder,\nbody.dark-only .theme-form .form-group input[type=datetime-local]::-webkit-input-placeholder,\nbody.dark-only .theme-form .form-group input[type=time]::-webkit-input-placeholder,\nbody.dark-only .theme-form .form-group input[type=datetime-local]::-webkit-input-placeholder,\nbody.dark-only .theme-form .form-group input[type=month]::-webkit-input-placeholder,\nbody.dark-only .theme-form .form-group input[type=week]::-webkit-input-placeholder,\nbody.dark-only .theme-form .form-group input[type=url]::-webkit-input-placeholder,\nbody.dark-only .theme-form .form-group input[type=file]::-webkit-input-placeholder,\nbody.dark-only .theme-form .form-group select::-webkit-input-placeholder {\n  color: #98a6ad;\n}\nbody.dark-only .theme-form .form-group .form-control {\n  background-color: #1d1e26;\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .theme-form .form-group textarea {\n  border-color: #1d1e26;\n}\nbody.dark-only .theme-form .form-divider {\n  border-top: 1px solid #1d1e26;\n}\nbody.dark-only .theme-form .form-divider::before {\n  background: #262932;\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .CodeMirror {\n  background: #262932;\n  border: 1px solid #98a6ad;\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .CodeMirror .CodeMirror-code pre {\n  background: #262932;\n}\nbody.dark-only .editor-toolbar {\n  border-top: 1px solid #98a6ad;\n  border-left: 1px solid #98a6ad;\n  border-right: 1px solid #98a6ad;\n}\nbody.dark-only .editor-toolbar a {\n  color: rgba(255, 255, 255, 0.6) !important;\n}\nbody.dark-only .editor-toolbar a:hover, body.dark-only .editor-toolbar a.active {\n  background: #1d1e26;\n}\nbody.dark-only .editor-toolbar i.separator {\n  border-left: 1px solid #98a6ad;\n  border-right: 1px solid #98a6ad;\n}\nbody.dark-only .editor-toolbar.fullscreen::before {\n  background: linear-gradient(to right, #1d1e26 0, rgba(0, 0, 0, 0) 100%);\n}\nbody.dark-only .editor-toolbar.fullscreen::after {\n  background: linear-gradient(to right, rgba(0, 0, 0, 0) 0, #1d1e26 100%);\n}\nbody.dark-only .editor-toolbar.disabled-for-preview a:not(.no-disable) {\n  background: #1d1e26;\n}\nbody.dark-only .editor-preview {\n  background-color: #262932;\n}\nbody.dark-only .editor-toolbar.fullscreen,\nbody.dark-only .editor-preview-side {\n  background: #262932;\n  border: 1px solid #98a6ad;\n}\nbody.dark-only .u-step {\n  background: #1d1e26;\n}\nbody.dark-only .u-step.active, body.dark-only .u-step.current {\n  background: var(--theme-default);\n  color: #fff;\n}\nbody.dark-only .u-step-title,\nbody.dark-only .u-pearl-title {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .u-step-number {\n  background-color: #262932;\n}\nbody.dark-only .u-pearl:before {\n  background-color: #1d1e26;\n}\nbody.dark-only .u-pearl-number,\nbody.dark-only .u-pearl-icon {\n  background: #1d1e26;\n  border: 2px solid #1d1e26;\n}\nbody.dark-only .u-pearl.disabled .u-pearl-icon,\nbody.dark-only .u-pearl.disabled .u-pearl-number {\n  background: #1d1e26;\n  border: 2px solid #1d1e26;\n}\nbody.dark-only .u-pearl.disabled:after {\n  background-color: #334053;\n}\nbody.dark-only .u-pearl.error:after {\n  background-color: #1d1e26;\n}\nbody.dark-only .note-editor.note-frame {\n  border-color: #1d1e26;\n}\nbody.dark-only .note-editor.note-frame .note-editing-area .note-editable {\n  background-color: #262932;\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .swal-modal {\n  background-color: #262932;\n}\nbody.dark-only .swal-modal .swal-title {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .swal-modal .swal-text {\n  color: #98a6ad;\n}\nbody.dark-only .swal-modal .swal-content__input {\n  background-color: #1d1e26;\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .nav-tabs {\n  border-bottom: 1px solid #374558;\n}\nbody.dark-only .nav-tabs .nav-link {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .nav-tabs .nav-link.active {\n  background-color: #262932;\n  color: rgba(255, 255, 255, 0.6);\n  border-color: #374558 #374558 #262932;\n}\nbody.dark-only .nav-tabs .nav-link:hover, body.dark-only .nav-tabs .nav-link:focus {\n  border-color: #374558 #374558 #323846;\n}\nbody.dark-only .nav-tabs .nav-item.show .nav-link {\n  background-color: #262932;\n  color: rgba(255, 255, 255, 0.6);\n  border-color: #1d1e26 #1d1e26 #262932;\n}\nbody.dark-only .nav-primary .nav-link.active {\n  background-color: var(--theme-default);\n}\nbody.dark-only .nav-primary .nav-item.show .nav-link {\n  background-color: var(--theme-default);\n}\nbody.dark-only .custom-tab.nav-tabs {\n  border-bottom: none;\n}\nbody.dark-only .nav-tabs.nav-bottom .nav-item .nav-link.active, body.dark-only .nav-tabs.nav-bottom .nav-item .nav-link.focus, body.dark-only .nav-tabs.nav-bottom .nav-item .nav-link.hover {\n  border-color: #262932 #1d1e26 #1d1e26;\n}\nbody.dark-only .border-tab .nav-link.active {\n  background-color: transparent;\n}\nbody.dark-only .border-tab .show > .nav-link {\n  background-color: transparent;\n}\nbody.dark-only .border-tab.nav-left .nav-link,\nbody.dark-only .border-tab.nav-right .nav-link {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .border-tab.nav-left .nav-link.active,\nbody.dark-only .border-tab.nav-right .nav-link.active {\n  color: var(--theme-default);\n}\nbody.dark-only .border-tab.nav-left .show > .nav-link,\nbody.dark-only .border-tab.nav-right .show > .nav-link {\n  color: var(--theme-default);\n}\nbody.dark-only .border-tab.nav-left.nav-secondary .nav-link.active, body.dark-only .border-tab.nav-left.nav-secondary .nav-link:focus, body.dark-only .border-tab.nav-left.nav-secondary .nav-link:hover {\n  border-left-color: var(--theme-secondary);\n  color: var(--theme-secondary) !important;\n}\nbody.dark-only .border-tab.nav-left.nav-secondary .show > .nav-link {\n  border-left-color: var(--theme-secondary);\n  color: var(--theme-secondary) !important;\n}\nbody.dark-only .border-tab.nav-left.nav-secondary .nav-item.show {\n  color: var(--theme-secondary) !important;\n  border-left-color: var(--theme-secondary);\n}\nbody.dark-only .border-tab.nav-left.nav-success .nav-link.active, body.dark-only .border-tab.nav-left.nav-success .nav-link:focus, body.dark-only .border-tab.nav-left.nav-success .nav-link:hover {\n  color: #54ba4a !important;\n}\nbody.dark-only .border-tab.nav-left.nav-success .show > .nav-link {\n  border-left-color: #54ba4a;\n  color: #54ba4a !important;\n}\nbody.dark-only .border-tab.nav-left.nav-success .nav-item.show {\n  color: #54ba4a !important;\n  border-left-color: #54ba4a;\n}\nbody.dark-only .border-tab.nav-right.nav-info .nav-link.active, body.dark-only .border-tab.nav-right.nav-info .nav-link:focus, body.dark-only .border-tab.nav-right.nav-info .nav-link:hover {\n  color: #16c7f9 !important;\n}\nbody.dark-only .border-tab.nav-right.nav-info .show > .nav-link {\n  border-left-color: #16c7f9;\n  color: #16c7f9 !important;\n}\nbody.dark-only .border-tab.nav-right.nav-info .nav-item.show {\n  color: #16c7f9 !important;\n  border-left-color: #16c7f9;\n}\nbody.dark-only .border-tab.nav-secondary .nav-link.active, body.dark-only .border-tab.nav-secondary .nav-link:focus, body.dark-only .border-tab.nav-secondary .nav-link:hover {\n  color: var(--theme-secondary) !important;\n}\nbody.dark-only .border-tab.nav-secondary .nav-item.show {\n  color: var(--theme-secondary) !important;\n}\nbody.dark-only .border-tab.nav-success .nav-link.active, body.dark-only .border-tab.nav-success .nav-link:focus, body.dark-only .border-tab.nav-success .nav-link:hover {\n  color: #54ba4a !important;\n}\nbody.dark-only .border-tab.nav-success .nav-item.show {\n  color: #54ba4a !important;\n}\nbody.dark-only .dropdown-divider {\n  border-top: 1px solid #1d1e26;\n}\nbody.dark-only .icon-hover-bottom {\n  background-color: #262932;\n  box-shadow: 0px 0px 1px 1px #1d1e26;\n}\nbody.dark-only .icon-hover-bottom .icon-title {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .icon-hover-bottom span {\n  color: #98a6ad;\n}\nbody.dark-only .icon-hover-bottom .form-group input {\n  background-color: #1d1e26;\n  color: rgba(255, 255, 255, 0.6);\n  border: 1px solid #1d1e26;\n}\nbody.dark-only .icon-hover-bottom .icon-first i {\n  color: #98a6ad;\n}\nbody.dark-only code {\n  background-color: #1d1e26;\n  border-radius: 2px;\n}\nbody.dark-only #cd-timeline::before {\n  background: #1d1e26;\n}\nbody.dark-only .timeliny {\n  border-top: 1px solid #1d1e26;\n  border-bottom: 1px solid #1d1e26;\n}\nbody.dark-only .timeliny::before {\n  background-color: #fff;\n}\nbody.dark-only .timeliny .timeliny-dot {\n  background-color: #262932;\n  border: 1px solid #fff;\n}\nbody.dark-only .timeliny .timeliny-dot::before {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .timeliny .timeliny-timeline .timeliny-timeblock.active .timeliny-dot::before {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .timeliny .timeliny-timeline .timeliny-timeblock.active .timeliny-dot::after {\n  background-color: #1d1e26;\n  color: rgba(255, 255, 255, 0.6);\n  border: none;\n}\nbody.dark-only .timeliny .timeliny-timeline .timeliny-timeblock:not(.inactive):not(.active) .timeliny-dot:hover {\n  background-color: #fff;\n}\nbody.dark-only .timeliny .timeliny-timeline .timeliny-timeblock:not(.inactive):not(.active) .timeliny-dot:hover::before {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .timeliny .timeliny-timeline .timeliny-timeblock .timeliny-dot:hover::after {\n  background-color: #262932;\n  border: 1px solid #1d1e26;\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .todo .todo-list-wrapper #todo-list li .task-container {\n  background: #262932;\n  border-bottom: 1px solid #1d1e26;\n}\nbody.dark-only .todo .todo-list-wrapper #todo-list li .task-container .task-label {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .todo .todo-list-wrapper #todo-list li .task-container:hover h4, body.dark-only .todo .todo-list-wrapper #todo-list li .task-container:hover .h4 {\n  color: #fff;\n}\nbody.dark-only .todo .todo-list-wrapper #todo-list li .task-container .task-action-btn .action-box:hover:not(.active) {\n  background: #262932;\n  border: 1px solid #1d1e26;\n}\nbody.dark-only .todo .todo-list-wrapper #todo-list li.completed .task-container .task-label {\n  color: var(--theme-default);\n}\nbody.dark-only .todo .todo-list-wrapper #todo-list li.completed .task-container .complete-btn:hover {\n  border: 1px solid #54ba4a !important;\n}\nbody.dark-only .todo .todo-list-wrapper .todo-list-footer .new-task-wrapper textarea {\n  background-color: #262932;\n  border: 1px solid #1d1e26;\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .user-profile .ttl-info h6, body.dark-only .user-profile .ttl-info .h6 {\n  color: #98a6ad;\n}\nbody.dark-only .user-profile .ttl-info span {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .user-profile .hovercard .info .title a {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .user-profile .hovercard .user-image .avatar img {\n  border: 10px solid #262932;\n}\nbody.dark-only .user-profile .hovercard .user-image .icon-wrapper {\n  background-color: #262932;\n}\nbody.dark-only .user-profile .hovercard .tabs-scoial {\n  border-bottom: none !important;\n}\nbody.dark-only .user-profile .follow .follow-num {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .user-profile .profile-img-style .user-name {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .user-profile .profile-img-style p {\n  color: #98a6ad;\n}\nbody.dark-only .introjs-helperLayer {\n  background-color: rgba(54, 64, 74, 0.9);\n  border: rgba(255, 255, 255, 0.5);\n}\nbody.dark-only .jstree-default .jstree-node,\nbody.dark-only .jstree-default .jstree-icon {\n  color: #455869 !important;\n}\nbody.dark-only .jstree-default .jstree-anchor {\n  color: #98a6ad;\n}\nbody.dark-only .jstree-default .jstree-clicked {\n  color: #fff;\n  background-color: transparent;\n}\nbody.dark-only .jstree-default .jstree-hovered {\n  background-color: #1d1e26;\n  border: 1px solid #1d1e26;\n}\nbody.dark-only span.twitter-typeahead .tt-menu {\n  background-color: #1d1e26;\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only span.twitter-typeahead .tt-suggestion {\n  color: rgba(255, 255, 255, 0.6);\n  background-color: #1d1e26;\n  border-top: 1px solid #374558;\n}\nbody.dark-only span.twitter-typeahead .tt-suggestion:hover, body.dark-only span.twitter-typeahead .tt-suggestion:focus {\n  background-color: #262932;\n}\nbody.dark-only .typography small, body.dark-only .typography .small {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .code-box-copy pre {\n  background-color: #1d1e26;\n}\nbody.dark-only .code-box-copy pre code {\n  background-color: #1d1e26;\n}\nbody.dark-only .code-box-copy pre[class*=language-] {\n  border: 1px solid #1d1e26;\n}\nbody.dark-only .code-box-copy .code-box-copy__btn {\n  background-color: #1d1e26;\n  border: 1px solid #1d1e26;\n  color: #fff;\n}\nbody.dark-only .code-box-copy code[class*=language-],\nbody.dark-only .code-box-copy pre[class*=language-] {\n  text-shadow: 0px 1px #000;\n}\nbody.dark-only .code-box-copy code[class*=language-] ::selection,\nbody.dark-only .code-box-copy pre[class*=language-] ::selection {\n  text-shadow: none;\n  background: #262932;\n}\nbody.dark-only table.fixedHeader-floating {\n  background-color: #1d1e26;\n}\nbody.dark-only .note textarea {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .dt-button-info {\n  background-color: #262932;\n  border: 1px solid #1d1e26;\n}\nbody.dark-only .dt-button-info h2, body.dark-only .dt-button-info .h2 {\n  background-color: #262932;\n  border-bottom: 1px solid #1d1e26;\n}\nbody.dark-only pre {\n  background-color: #1d1e26;\n}\nbody.dark-only #keytable_wrapper .dataTables_paginate,\nbody.dark-only #column-selector_wrapper .dataTables_paginate,\nbody.dark-only #auto-fill_wrapper .dataTables_paginate,\nbody.dark-only #custom-button_wrapper .dataTables_paginate,\nbody.dark-only #class-button_wrapper .dataTables_paginate,\nbody.dark-only #keyboard-btn_wrapper .dataTables_paginate,\nbody.dark-only #multilevel-btn_wrapper .dataTables_paginate,\nbody.dark-only #pagelength-btn_wrapper .dataTables_paginate,\nbody.dark-only #basic-colreorder_wrapper .dataTables_paginate,\nbody.dark-only #state-saving_wrapper .dataTables_paginate,\nbody.dark-only #real-time_wrapper .dataTables_paginate,\nbody.dark-only #basic-fixed-header_wrapper .dataTables_paginate,\nbody.dark-only #fixed-header-footer_wrapper .dataTables_paginate,\nbody.dark-only #export-button_wrapper .dataTables_paginate,\nbody.dark-only #excel-cust-bolder_wrapper .dataTables_paginate,\nbody.dark-only #cust-json_wrapper .dataTables_paginate,\nbody.dark-only #basic-key-table_wrapper .dataTables_paginate,\nbody.dark-only #focus-cell_wrapper .dataTables_paginate,\nbody.dark-only #responsive_wrapper .dataTables_paginate,\nbody.dark-only #new-cons_wrapper .dataTables_paginate,\nbody.dark-only #show-hidden-row_wrapper .dataTables_paginate,\nbody.dark-only #basic-row-reorder_wrapper .dataTables_paginate,\nbody.dark-only #full-row_wrapper .dataTables_paginate,\nbody.dark-only #rest-column_wrapper .dataTables_paginate {\n  border: none;\n}\nbody.dark-only #example-style-8_wrapper table.dataTable.stripe tbody tr.odd,\nbody.dark-only #example-style-8_wrapper table.dataTable.display tbody tr.odd {\n  background-color: #1d1e26;\n}\nbody.dark-only .error-wrapper {\n  background-color: rgba(54, 64, 74, 0.8);\n}\nbody.dark-only .error-wrapper .sub-content {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .b-light {\n  border: 1px solid #1d1e26 !important;\n}\nbody.dark-only .modal-content {\n  background-color: #262932;\n}\nbody.dark-only .modal-content .modal-header {\n  border-bottom: 1px solid #374558;\n}\nbody.dark-only .modal-content .modal-header .close {\n  color: rgba(255, 255, 255, 0.6);\n  font-weight: 400;\n}\nbody.dark-only .modal-content .ui-front .form-control {\n  background-color: #262932;\n  color: rgba(255, 255, 255, 0.6);\n  border: 1px solid #374558;\n}\nbody.dark-only .stepwizard .stepwizard-row:before {\n  background-color: #374558;\n}\nbody.dark-only .modal .theme-close {\n  color: rgba(255, 255, 255, 0.2);\n}\nbody.dark-only .token.atrule,\nbody.dark-only .token.attr-value,\nbody.dark-only .token.keyword {\n  color: #16c7f9;\n}\nbody.dark-only .token.boolean, body.dark-only .token.constant, body.dark-only .token.deleted, body.dark-only .token.number, body.dark-only .token.property, body.dark-only .token.symbol, body.dark-only .token.tag {\n  color: #fc4438;\n}\nbody.dark-only .loader-box.card-loader {\n  background-color: #262932;\n}\nbody.dark-only .my-gallery.gallery-with-description img {\n  border: 1px solid #1d1e26 !important;\n  border-bottom: none !important;\n}\nbody.dark-only .alert-primary.inverse {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .alert-secondary.inverse {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .alert-success.inverse {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .alert-danger.inverse {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .alert-warning.inverse {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .alert-info.inverse {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .alert-light.inverse {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .alert-dark.inverse {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .alert-theme span + span + span {\n  border-left: 5px solid var(--theme-default);\n  background-color: #1d1e26;\n  border-radius: 4px;\n}\nbody.dark-only .alert-theme i {\n  color: #fff;\n  padding: 20px;\n  margin-right: 20px !important;\n}\nbody.dark-only .user-card .user-deatils h6, body.dark-only .user-card .user-deatils .h6 {\n  color: #98a6ad;\n}\nbody.dark-only .user-card .card-footer > div:first-child {\n  border-right: 1px solid #1d1e26;\n}\nbody.dark-only .user-card .card-footer .user-footer h6, body.dark-only .user-card .card-footer .user-footer .h6 {\n  color: #98a6ad;\n}\nbody.dark-only .user-card .card-footer .user-footer svg path,\nbody.dark-only .user-card .card-footer .user-footer svg rect {\n  color: #98a6ad;\n}\nbody.dark-only .order-history table .qty-box button {\n  background-color: #1d1e26 !important;\n  border: none !important;\n}\nbody.dark-only .order-history table .qty-box .input-group {\n  border-color: #374558;\n}\nbody.dark-only .order-history table thead tr th {\n  background-color: #1d1e26;\n}\nbody.dark-only .order-history table tr td,\nbody.dark-only .order-history table tr th {\n  border-top: none !important;\n}\nbody.dark-only .order-history .title-orders {\n  background-color: #1d1e26;\n}\nbody.dark-only .navigation-option ul li a {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .navigation-option ul li:hover {\n  background-color: #1d1e26;\n}\nbody.dark-only .product-box .product-details h6, body.dark-only .product-box .product-details .h6 {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .product-box .product-details > a {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .product-box .product-details span {\n  color: #98a6ad;\n}\nbody.dark-only .product-box .product-img .product-hover ul li {\n  background-color: #262932;\n}\nbody.dark-only .product-box .product-img .product-hover ul li:hover {\n  background-color: #000;\n  color: #fff;\n}\nbody.dark-only .browse .browse-articles ul li a {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .browse .browse-articles ul li:hover {\n  background-color: #1d1e26;\n}\nbody.dark-only .radio-primary input[type=radio] + label::before {\n  border-color: var(--theme-default) !important;\n}\nbody.dark-only .radio-primary input[type=radio] + label::after {\n  background-color: var(--theme-default);\n}\nbody.dark-only .radio-primary input[type=radio]:checked + label::before {\n  border-color: var(--theme-default) !important;\n}\nbody.dark-only .radio-primary input[type=radio]:checked + label::after {\n  background-color: var(--theme-default);\n}\nbody.dark-only .radio-secondary input[type=radio] + label::before {\n  border-color: #ff3364 !important;\n}\nbody.dark-only .radio-secondary input[type=radio] + label::after {\n  background-color: #ff3364;\n}\nbody.dark-only .radio-secondary input[type=radio]:checked + label::before {\n  border-color: #ff3364 !important;\n}\nbody.dark-only .radio-secondary input[type=radio]:checked + label::after {\n  background-color: #ff3364;\n}\nbody.dark-only .radio-success input[type=radio] + label::before {\n  border-color: #54ba4a !important;\n}\nbody.dark-only .radio-success input[type=radio] + label::after {\n  background-color: #54ba4a;\n}\nbody.dark-only .radio-success input[type=radio]:checked + label::before {\n  border-color: #54ba4a !important;\n}\nbody.dark-only .radio-success input[type=radio]:checked + label::after {\n  background-color: #54ba4a;\n}\nbody.dark-only .radio-danger input[type=radio] + label::before {\n  border-color: #fc4438 !important;\n}\nbody.dark-only .radio-danger input[type=radio] + label::after {\n  background-color: #fc4438;\n}\nbody.dark-only .radio-danger input[type=radio]:checked + label::before {\n  border-color: #fc4438 !important;\n}\nbody.dark-only .radio-danger input[type=radio]:checked + label::after {\n  background-color: #fc4438;\n}\nbody.dark-only .radio-info input[type=radio] + label::before {\n  border-color: #16c7f9 !important;\n}\nbody.dark-only .radio-info input[type=radio] + label::after {\n  background-color: #16c7f9;\n}\nbody.dark-only .radio-info input[type=radio]:checked + label::before {\n  border-color: #16c7f9 !important;\n}\nbody.dark-only .radio-info input[type=radio]:checked + label::after {\n  background-color: #16c7f9;\n}\nbody.dark-only .radio-light input[type=radio] + label::before {\n  border-color: #f4f4f4 !important;\n}\nbody.dark-only .radio-light input[type=radio] + label::after {\n  background-color: #f4f4f4;\n}\nbody.dark-only .radio-light input[type=radio]:checked + label::before {\n  border-color: #f4f4f4 !important;\n}\nbody.dark-only .radio-light input[type=radio]:checked + label::after {\n  background-color: #f4f4f4;\n}\nbody.dark-only .radio-dark input[type=radio] + label::before {\n  border-color: #2c323f !important;\n}\nbody.dark-only .radio-dark input[type=radio] + label::after {\n  background-color: #2c323f;\n}\nbody.dark-only .radio-dark input[type=radio]:checked + label::before {\n  border-color: #2c323f !important;\n}\nbody.dark-only .radio-dark input[type=radio]:checked + label::after {\n  background-color: #2c323f;\n}\nbody.dark-only .radio-warning input[type=radio] + label::before {\n  border-color: #ffaa05 !important;\n}\nbody.dark-only .radio-warning input[type=radio] + label::after {\n  background-color: #ffaa05;\n}\nbody.dark-only .radio-warning input[type=radio]:checked + label::before {\n  border-color: #ffaa05 !important;\n}\nbody.dark-only .radio-warning input[type=radio]:checked + label::after {\n  background-color: #ffaa05;\n}\nbody.dark-only .checkbox-primary label::before {\n  border-color: var(--theme-default) !important;\n}\nbody.dark-only .checkbox-secondary label::before {\n  border-color: #ff3364 !important;\n}\nbody.dark-only .checkbox-success label::before {\n  border-color: #54ba4a !important;\n}\nbody.dark-only .checkbox-danger label::before {\n  border-color: #fc4438 !important;\n}\nbody.dark-only .checkbox-info label::before {\n  border-color: #16c7f9 !important;\n}\nbody.dark-only .checkbox-light label::before {\n  border-color: #f4f4f4 !important;\n}\nbody.dark-only .checkbox-dark label::before {\n  border-color: #2c323f !important;\n}\nbody.dark-only .checkbox-warning label::before {\n  border-color: #ffaa05 !important;\n}\nbody.dark-only .checkbox-solid-primary label:before {\n  background-color: var(--theme-default) !important;\n  border-color: var(--theme-default) !important;\n  color: #fff !important;\n}\nbody.dark-only .checkbox-solid-primary input[type=checkbox]:checked + label::before {\n  background-color: var(--theme-default) !important;\n  border-color: var(--theme-default) !important;\n  color: #fff !important;\n}\nbody.dark-only .checkbox-solid-primary input[type=checkbox]:checked + label::after {\n  color: #fff !important;\n}\nbody.dark-only .checkbox-solid-secondary label:before {\n  background-color: #ff3364 !important;\n  border-color: #ff3364 !important;\n  color: #fff !important;\n}\nbody.dark-only .checkbox-solid-secondary input[type=checkbox]:checked + label::before {\n  background-color: #ff3364 !important;\n  border-color: #ff3364 !important;\n  color: #fff !important;\n}\nbody.dark-only .checkbox-solid-secondary input[type=checkbox]:checked + label::after {\n  color: #fff !important;\n}\nbody.dark-only .checkbox-solid-success label:before {\n  background-color: #54ba4a !important;\n  border-color: #54ba4a !important;\n  color: #fff !important;\n}\nbody.dark-only .checkbox-solid-success input[type=checkbox]:checked + label::before {\n  background-color: #54ba4a !important;\n  border-color: #54ba4a !important;\n  color: #fff !important;\n}\nbody.dark-only .checkbox-solid-success input[type=checkbox]:checked + label::after {\n  color: #fff !important;\n}\nbody.dark-only .checkbox-solid-danger label:before {\n  background-color: #fc4438 !important;\n  border-color: #fc4438 !important;\n  color: #fff !important;\n}\nbody.dark-only .checkbox-solid-danger input[type=checkbox]:checked + label::before {\n  background-color: #fc4438 !important;\n  border-color: #fc4438 !important;\n  color: #fff !important;\n}\nbody.dark-only .checkbox-solid-danger input[type=checkbox]:checked + label::after {\n  color: #fff !important;\n}\nbody.dark-only .checkbox-solid-info label:before {\n  background-color: #16c7f9 !important;\n  border-color: #16c7f9 !important;\n  color: #fff !important;\n}\nbody.dark-only .checkbox-solid-info input[type=checkbox]:checked + label::before {\n  background-color: #16c7f9 !important;\n  border-color: #16c7f9 !important;\n  color: #fff !important;\n}\nbody.dark-only .checkbox-solid-info input[type=checkbox]:checked + label::after {\n  color: #fff !important;\n}\nbody.dark-only .checkbox-solid-light label:before {\n  background-color: #f4f4f4 !important;\n  border-color: #f4f4f4 !important;\n  color: #fff !important;\n}\nbody.dark-only .checkbox-solid-light input[type=checkbox]:checked + label::before {\n  background-color: #f4f4f4 !important;\n  border-color: #f4f4f4 !important;\n  color: #fff !important;\n}\nbody.dark-only .checkbox-solid-light input[type=checkbox]:checked + label::after {\n  color: #fff !important;\n}\nbody.dark-only .checkbox-solid-dark label:before {\n  background-color: #2c323f !important;\n  border-color: #2c323f !important;\n  color: #fff !important;\n}\nbody.dark-only .checkbox-solid-dark input[type=checkbox]:checked + label::before {\n  background-color: #2c323f !important;\n  border-color: #2c323f !important;\n  color: #fff !important;\n}\nbody.dark-only .checkbox-solid-dark input[type=checkbox]:checked + label::after {\n  color: #fff !important;\n}\nbody.dark-only .checkbox-solid-warning label:before {\n  background-color: #ffaa05 !important;\n  border-color: #ffaa05 !important;\n  color: #fff !important;\n}\nbody.dark-only .checkbox-solid-warning input[type=checkbox]:checked + label::before {\n  background-color: #ffaa05 !important;\n  border-color: #ffaa05 !important;\n  color: #fff !important;\n}\nbody.dark-only .checkbox-solid-warning input[type=checkbox]:checked + label::after {\n  color: #fff !important;\n}\nbody.dark-only .bootstrap-datetimepicker-widget ul li {\n  color: rgba(255, 255, 255, 0.6);\n  border-bottom: 1px solid #1d1e26;\n}\nbody.dark-only .bootstrap-datetimepicker-widget tr th:hover,\nbody.dark-only .bootstrap-datetimepicker-widget tr td:hover {\n  background-color: #262932;\n}\nbody.dark-only .bootstrap-datetimepicker-widget tr th span:hover,\nbody.dark-only .bootstrap-datetimepicker-widget tr td span:hover {\n  background-color: #262932;\n}\nbody.dark-only .bootstrap-datetimepicker-widget tr th.prev:hover, body.dark-only .bootstrap-datetimepicker-widget tr th.next:hover,\nbody.dark-only .bootstrap-datetimepicker-widget tr td.prev:hover,\nbody.dark-only .bootstrap-datetimepicker-widget tr td.next:hover {\n  background-color: #262932;\n}\nbody.dark-only .bootstrap-datetimepicker-widget tr:first-child th:hover {\n  background-color: #262932;\n}\nbody.dark-only .btn-transparent {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only #cal-basic .fc-toolbar .fc-left .fc-next-button .fc-icon-right-single-arrow:after,\nbody.dark-only #cal-basic .fc-toolbar .fc-right .fc-next-button .fc-icon-right-single-arrow:after {\n  color: #98a6ad;\n}\nbody.dark-only #cal-basic .fc-toolbar .fc-left .fc-prev-button .fc-icon-left-single-arrow:after,\nbody.dark-only #cal-basic .fc-toolbar .fc-right .fc-prev-button .fc-icon-left-single-arrow:after {\n  color: #98a6ad;\n}\nbody.dark-only #cal-basic .fc-toolbar .fc-left .fc-button-group .fc-month-button {\n  color: #fff !important;\n}\nbody.dark-only .fc-button-group .fc-basicWeek-button,\nbody.dark-only .fc-button-group .fc-basicDay-button,\nbody.dark-only .fc-button-group .fc-agendaWeek-button,\nbody.dark-only .fc-button-group .fc-agendaDay-button {\n  color: #000 !important;\n}\nbody.dark-only .fc-button-group .fc-month-button {\n  color: #fff !important;\n}\nbody.dark-only .btn-light:not([disabled]):not(.disabled).active.active {\n  background-color: #1d1e26 !important;\n}\nbody.dark-only .btn-light.disabled, body.dark-only .btn-light:disabled {\n  color: rgba(47, 47, 59, 0.5) !important;\n}\nbody.dark-only #cal-agenda-view .fc-toolbar .fc-right .fc-button-group .fc-month-button,\nbody.dark-only #cal-agenda-view .fc-toolbar .fc-right .fc-button-group .btn-light {\n  color: #000 !important;\n}\nbody.dark-only #cal-agenda-view .fc-toolbar .fc-right .fc-button-group .fc-agendaWeek-button {\n  color: #fff !important;\n}\nbody.dark-only #cal-agenda-view .fc-toolbar .fc-right .fc-button-group .fc-agendaWeek-button:hover {\n  color: #000 !important;\n}\nbody.dark-only .basic-calendar .fc-toolbar .fc-right .fc-button-group .fc-basicWeek-button,\nbody.dark-only .basic-calendar .fc-toolbar .fc-right .fc-button-group .btn-light,\nbody.dark-only #cal-bg-events .fc-toolbar .fc-right .fc-button-group .fc-basicWeek-button,\nbody.dark-only #cal-bg-events .fc-toolbar .fc-right .fc-button-group .btn-light,\nbody.dark-only #cal-event-colors .fc-toolbar .fc-right .fc-button-group .fc-basicWeek-button,\nbody.dark-only #cal-event-colors .fc-toolbar .fc-right .fc-button-group .btn-light {\n  color: #000 !important;\n}\nbody.dark-only .basic-calendar .fc-toolbar .fc-right .fc-button-group .fc-month-button,\nbody.dark-only #cal-bg-events .fc-toolbar .fc-right .fc-button-group .fc-month-button,\nbody.dark-only #cal-event-colors .fc-toolbar .fc-right .fc-button-group .fc-month-button {\n  color: #fff !important;\n}\nbody.dark-only .basic-calendar .fc-toolbar .fc-right .fc-button-group .fc-month-button:hover,\nbody.dark-only #cal-bg-events .fc-toolbar .fc-right .fc-button-group .fc-month-button:hover,\nbody.dark-only #cal-event-colors .fc-toolbar .fc-right .fc-button-group .fc-month-button:hover {\n  color: #000 !important;\n}\nbody.dark-only .categories ul li a {\n  color: #98a6ad;\n}\nbody.dark-only .categories ul li:hover {\n  background-color: #1d1e26;\n}\nbody.dark-only .socialprofile .likes-profile h5 span, body.dark-only .socialprofile .likes-profile .h5 span {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-only .socialprofile span {\n  color: #98a6ad;\n}\nbody.dark-only .social-status .media .media-body span + span {\n  color: #98a6ad;\n}\nbody.dark-only .social-status .media .media-body p,\nbody.dark-only .social-status .media .media-body .light-span {\n  color: #98a6ad;\n}\nbody.dark-only .filter-cards-view p,\nbody.dark-only .timeline-content p {\n  color: #98a6ad;\n}\nbody.dark-only .filter-cards-view .comment-number i,\nbody.dark-only .timeline-content .comment-number i {\n  color: #98a6ad;\n}\nbody.dark-only .filter-cards-view .comments-box .input-group .form-control,\nbody.dark-only .timeline-content .comments-box .input-group .form-control {\n  border: none !important;\n}\nbody.dark-only .filter-cards-view .comments-box .input-group .input-group-append,\nbody.dark-only .timeline-content .comments-box .input-group .input-group-append {\n  background-color: #1d1e26;\n}\nbody.dark-only .social-chat .media-body {\n  border: 1px solid #1d1e26;\n}\nbody.dark-only .social-chat .media-body:after {\n  border-right: 7px solid #262932;\n}\nbody.dark-only .social-chat span span {\n  color: #98a6ad;\n}\nbody.dark-only .details-about .your-details p {\n  color: #98a6ad;\n}\nbody.dark-only .activity-log .my-activity p {\n  color: #98a6ad;\n}\nbody.dark-only .bookmark ul li a {\n  color: rgba(255, 255, 255, 0.6);\n}\n@media only screen and (max-width: 991.98px) {\n  body.dark-only .page-wrapper.compact-wrapper .page-header .header-wrapper .toggle-sidebar {\n    border-right: 1px solid #374558;\n  }\n}\n@media only screen and (max-width: 767.98px) {\n  body.dark-only .page-wrapper.material-icon .page-header {\n    background-color: #262932;\n  }\n}\nbody.dark-only .apexcharts-tooltip.light {\n  border-color: #374558;\n  background-color: #1d1e26;\n}\nbody.dark-only .apexcharts-tooltip.light .apexcharts-tooltip-title {\n  border-color: #374558;\n}\nbody.dark-only .apexcharts-tooltip.light .apexcharts-tooltip-text-label,\nbody.dark-only .apexcharts-tooltip.light .apexcharts-tooltip-text-value {\n  color: #fff;\n}\nbody.dark-sidebar .toggle-sidebar svg {\n  stroke: var(--theme-default);\n}\nbody.dark-sidebar .page-wrapper .sidebar-main-title p {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-sidebar .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper {\n  background-color: #262932;\n}\nbody.dark-sidebar .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a span {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-sidebar .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a svg {\n  stroke: rgba(255, 255, 255, 0.6);\n}\nbody.dark-sidebar .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active {\n  background-color: rgba(115, 102, 255, 0.2);\n}\nbody.dark-sidebar .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active svg {\n  color: var(--theme-default);\n  stroke: var(--theme-default);\n}\nbody.dark-sidebar .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title h5, body.dark-sidebar .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title .h5 {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-sidebar .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content.opensubmegamenu li a {\n  color: rgba(255, 255, 255, 0.6);\n  font-weight: 400;\n}\nbody.dark-sidebar .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container::after {\n  background-color: rgba(255, 255, 255, 0.2);\n}\nbody.dark-sidebar .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-sidebar .page-wrapper.compact-wrapper .sidebar-list ul.sidebar-submenu li a span {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-sidebar .page-wrapper.compact-wrapper .sidebar-list ul.sidebar-submenu li a.active {\n  color: var(--theme-default);\n}\nbody.dark-sidebar .page-wrapper.compact-wrapper .sidebar-list .according-menu i {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-sidebar .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper {\n  background: #262932;\n}\nbody.dark-sidebar .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main {\n  background-color: #262932;\n}\nbody.dark-sidebar .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li > a {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-sidebar .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu {\n  background: #262932;\n}\nbody.dark-sidebar .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-sidebar .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a.active, body.dark-sidebar .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a:hover {\n  color: var(--theme-default);\n}\nbody.dark-sidebar .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li .nav-sub-childmenu {\n  background: #262932;\n}\nbody.dark-sidebar .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container {\n  background: #262932;\n}\nbody.dark-sidebar .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content li a {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-sidebar .page-wrapper .left-arrow,\nbody.dark-sidebar .page-wrapper .right-arrow {\n  background-color: #262932;\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper > div {\n  background: #262932;\n}\nbody.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-title {\n  border-bottom: 1px solid #374558;\n}\nbody.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a span {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li a svg {\n  stroke: rgba(255, 255, 255, 0.6);\n}\nbody.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu,\nbody.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container {\n  background-color: #262932;\n}\nbody.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu li a,\nbody.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container li a {\n  border-bottom: 1px solid #374558;\n}\nbody.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active {\n  background-color: rgba(115, 102, 255, 0.2);\n}\nbody.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active span {\n  color: var(--theme-default);\n}\nbody.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-link.active svg {\n  color: var(--theme-default);\n  stroke: var(--theme-default);\n}\nbody.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title h5, body.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-title .h5 {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container .mega-box .link-section .submenu-content.opensubmegamenu li a {\n  color: rgba(255, 255, 255, 0.6);\n  font-weight: 400;\n}\nbody.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .mega-menu-container::after {\n  background-color: rgba(255, 255, 255, 0.2);\n}\nbody.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links > li .sidebar-submenu li a {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list ul.sidebar-submenu li a span {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links .sidebar-list ul.sidebar-submenu li a.active {\n  color: var(--theme-default);\n}\nbody.dark-sidebar .page-wrapper.compact-sidebar .page-body-wrapper .according-menu i {\n  color: rgba(255, 255, 255, 0.6);\n}\nbody .for-dark {\n  display: none;\n}\nbody[class*=dark-] .for-dark {\n  display: block;\n}\nbody[class*=dark-] .for-light {\n  display: none;\n}\n\n/**=====================\n55. theme layout CSS ends\n==========================**/\n/**=====================\n   59. Customizer  CSS Start\n==========================**/\n.customizer-links {\n  position: fixed;\n  right: 0px;\n  top: 50%;\n  z-index: 3;\n  transform: translate(0, -50%);\n  box-shadow: 0 0 37px rgba(8, 21, 66, 0.1);\n}\n.customizer-links > .nav {\n  border-radius: 8px;\n  padding: 10px;\n  background-color: #fff;\n}\n.customizer-links.open {\n  right: 330px;\n  border-radius: 8px 0 0 8px;\n  transition: all 0.3s ease;\n}\n.customizer-links .nav-link {\n  padding: 0;\n  position: relative;\n}\n.customizer-links .nav-link:before {\n  content: \"\";\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  background-color: rgba(115, 102, 255, 0.1);\n  border-radius: 5px;\n  transform: scale(0);\n  transition: all 0.3s ease;\n}\n.customizer-links .nav-link:after {\n  content: \"\";\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n  top: 12px;\n  border-width: 5px 0 5px 5px;\n  border-left-color: rgb(90.8496732026%, 90%, 100%);\n  opacity: 0;\n  transform: scale(0);\n  color: #fff;\n  left: -10px;\n  z-index: 2;\n  transition: all 0.3s ease;\n}\n.customizer-links .nav-link:hover i {\n  color: var(--theme-default);\n}\n.customizer-links .nav-link:hover:before, .customizer-links .nav-link:hover:after {\n  opacity: 1;\n  transform: scale(1);\n  transition: all 0.3s ease;\n}\n.customizer-links .nav-link:hover span {\n  opacity: 1;\n  right: 48px;\n  transform: scale(1);\n  transition: all 0.3s ease;\n}\n.customizer-links .nav-link + .nav-link {\n  margin-bottom: 5px;\n}\n.customizer-links .nav-link span {\n  position: absolute;\n  right: -60px;\n  width: max-content;\n  text-align: right;\n  padding: 7px 10px;\n  display: block;\n  top: 0;\n  border-radius: 5px;\n  transform: scale(0);\n  transition: all 0.3s ease;\n  opacity: 0;\n  color: var(--theme-default);\n  background-color: rgb(90.8496732026%, 90%, 100%);\n  box-shadow: 0 0 37px rgba(8, 21, 66, 0.1);\n}\n.customizer-links .nav-link i {\n  font-size: 17px;\n  padding: 8px 10px;\n  display: inline-block;\n  cursor: pointer;\n  margin: 0;\n  color: gray;\n  border-radius: 5px;\n}\n\n.customizer-contain {\n  direction: ltr;\n  position: fixed;\n  height: 100vh;\n  top: 79px;\n  width: 333px;\n  right: -335px;\n  background-color: #fff;\n  z-index: 8;\n  transition: all 0.3s ease;\n}\n.customizer-contain.open {\n  right: 0px;\n  transition: all 0.3s ease;\n  box-shadow: 0 0 10px 1px rgba(68, 102, 242, 0.05);\n}\n.customizer-contain li,\n.customizer-contain .list-group-item {\n  position: relative;\n}\n.customizer-contain li.active,\n.customizer-contain .list-group-item.active {\n  box-shadow: 0 0 11px 5px rgba(226, 226, 226, 0.5) !important;\n  background-color: #fff !important;\n}\n.customizer-contain h6, .customizer-contain .h6 {\n  text-transform: uppercase;\n  font-weight: 500;\n  letter-spacing: 0.5px;\n  margin-top: 12px;\n  padding-top: 12px;\n  margin-bottom: 5px;\n}\n.customizer-contain .customizer-header {\n  padding: 15px 25px;\n  border-bottom: 1px solid #f4f4f4;\n}\n.customizer-contain .customizer-header .icon-close {\n  position: absolute;\n  font-size: 18px;\n  cursor: pointer;\n  font-weight: 900;\n  right: 24px;\n  color: var(--theme-default);\n}\n.customizer-contain .customizer-header h5, .customizer-contain .customizer-header .h5 {\n  text-transform: uppercase;\n}\n.customizer-contain .customizer-body {\n  padding: 15px 25px;\n  max-height: calc(100vh - 200px);\n  overflow-y: scroll;\n}\n.customizer-contain .customizer-body .fade:not(.show) {\n  display: none;\n}\n.customizer-contain .customizer-body .unlimited-color-layout {\n  display: flex;\n  align-items: center;\n}\n.customizer-contain .customizer-body .unlimited-color-layout .btn {\n  font-size: 15px;\n  padding: 4px 20px;\n}\n.customizer-contain .customizer-body .unlimited-color-layout input {\n  border: 1px solid #cccccc;\n  height: 35px;\n  width: 35px;\n  border-radius: 5px;\n  background-color: #fff;\n  margin-right: 5px;\n}\n.customizer-contain .customizer-body .layout-grid.customizer-mix .color-layout {\n  height: 70px;\n  width: 80px;\n  border: 1px solid #f6f7fb;\n  border-radius: 5px;\n}\n.customizer-contain .customizer-body .tab-pane > h6:first-child, .customizer-contain .customizer-body .tab-pane > .h6:first-child {\n  padding-top: 0;\n  margin-top: 0;\n}\n.customizer-contain .customizer-body li {\n  cursor: pointer;\n  opacity: 0.9;\n}\n.customizer-contain .customizer-body li.active {\n  opacity: 1;\n}\n.customizer-contain .customizer-body .color-layout {\n  height: 35px;\n  width: 35px;\n  border-radius: 6px;\n  display: inline-block;\n  margin-right: 3px;\n  border: 1px solid #b8b8b8;\n  padding: 3px;\n}\n.customizer-contain .customizer-body .color-layout > div {\n  background-color: #7366ff;\n  height: 100%;\n  width: 100%;\n  border-radius: 5px;\n}\n.customizer-contain .customizer-body .color-layout[data-attr=color-2] div {\n  background-color: #4831d4;\n}\n.customizer-contain .customizer-body .color-layout[data-attr=color-3] div {\n  background-color: #d64dcf;\n}\n.customizer-contain .customizer-body .color-layout[data-attr=color-4] div {\n  background-color: #4c2fbf;\n}\n.customizer-contain .customizer-body .color-layout[data-attr=color-5] div {\n  background-color: #7c4dff;\n}\n.customizer-contain .customizer-body .color-layout[data-attr=color-6] div {\n  background-color: #3949ab;\n}\n.customizer-contain .customizer-body .dark > li {\n  background-color: #2f3c4e;\n}\n.customizer-contain .customizer-body .main-layout > li {\n  height: 65px;\n  width: 85px;\n  border: 1px solid #f4f4f4;\n  border-radius: 10px;\n  display: inline-block;\n}\n.customizer-contain .customizer-body .main-layout > li + li {\n  margin-left: 7px;\n}\n.customizer-contain .customizer-body .main-layout .box-layout .body .badge {\n  left: -14px;\n}\n.customizer-contain .customizer-body .sidebar-type > li,\n.customizer-contain .customizer-body .sidebar-setting > li {\n  height: 70px;\n  width: 85px;\n  border: 1px solid #f4f4f4;\n  border-radius: 5px;\n  display: inline-block;\n}\n.customizer-contain .customizer-body .sidebar-type > li + li,\n.customizer-contain .customizer-body .sidebar-setting > li + li {\n  margin-left: 7px;\n}\n.customizer-contain .customizer-body .sidebar-type li[data-attr=normal-sidebar] .body ul li.bg-dark, .customizer-contain .customizer-body .sidebar-type li[data-attr=normal-sidebar] .body ul li.sidebar {\n  width: 100%;\n  height: 10px;\n  display: block;\n}\n.customizer-contain .customizer-body .sidebar-type li[data-attr=normal-sidebar] .body ul li.bg-light, .customizer-contain .customizer-body .sidebar-type li[data-attr=normal-sidebar] .body ul li.body {\n  height: calc(100% - 10px);\n  width: 100%;\n}\n.customizer-contain .customizer-body .sidebar-type li[data-attr=normal-sidebar].body-compact .body ul li.body {\n  width: calc(100% - 25px);\n}\n.customizer-contain .customizer-body .layout-types {\n  margin-bottom: -30px;\n}\n.customizer-contain .customizer-body .layout-types > li {\n  display: block;\n  width: unset;\n  height: unset;\n  margin-bottom: 30px;\n}\n.customizer-contain .customizer-body .layout-types > li .layout-img h6, .customizer-contain .customizer-body .layout-types > li .layout-img .h6 {\n  padding-top: 0;\n  text-transform: inherit;\n  text-align: center;\n}\n.customizer-contain .customizer-body .layout-types .box-layout {\n  background: unset;\n}\n\n.layout-grid:not(.customizer-color) li {\n  padding: 5px;\n}\n.layout-grid:not(.customizer-color) li > .header {\n  height: 9px;\n  border-radius: 3px;\n  position: relative;\n}\n.layout-grid:not(.customizer-color) li > .header ul {\n  position: absolute;\n  top: -8px;\n  left: 5px;\n}\n.layout-grid:not(.customizer-color) li > .header ul > li {\n  display: inline-block;\n  width: 4px;\n  height: 4px;\n  border-radius: 5px;\n  top: calc(50% - 3px);\n  background-color: var(--theme-default);\n  margin-right: 2px;\n  padding: 0;\n}\n.layout-grid:not(.customizer-color) li > .header ul > li:nth-child(2) {\n  background-color: var(--theme-secondary);\n}\n.layout-grid:not(.customizer-color) li > .header ul > li:nth-child(3) {\n  background-color: #54ba4a;\n}\n.layout-grid:not(.customizer-color) li > .body {\n  background-color: #f4f4f4;\n  height: calc(100% - 16px);\n  border-radius: 3px;\n  position: relative;\n  margin-top: 5px;\n  text-align: center;\n  line-height: 3.1;\n}\n.layout-grid:not(.customizer-color) li > .body ul {\n  height: 100%;\n  background-color: #fff;\n}\n.layout-grid:not(.customizer-color) li > .body ul .sidebar {\n  width: 18px;\n  height: 100%;\n  border-radius: 3px;\n  display: inline-block;\n  margin-right: 3px;\n  padding: 0;\n}\n.layout-grid:not(.customizer-color) li > .body ul .sidebar.compact {\n  width: 12px;\n}\n.layout-grid:not(.customizer-color) li > .body ul .sidebar.compact ~ .body {\n  width: calc(100% - 19px);\n}\n.layout-grid:not(.customizer-color) li > .body ul .body {\n  width: calc(100% - 25px);\n  padding: 0;\n  margin: 0;\n  height: 100%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 3px;\n}\n.layout-grid:not(.customizer-color) li > .body ul .body .badge {\n  position: absolute;\n}\n\n/**=====================\n     59.Customizer CSS Ends\n==========================**/\n/**=====================\n     62. Responsive CSS Start\n==========================**/\n/* ========= min and max scss for 1200 to 1366 screen ========= */\n@media (max-width: 1800px) {\n  .todo-wrap .todo-list-body .task-container div.d-flex {\n    min-width: 240px;\n    justify-content: flex-end;\n  }\n  .caller-img {\n    display: none;\n  }\n}\n@media screen and (max-width: 1660px) {\n  .photos ul li {\n    width: 26%;\n  }\n  .bar-chart canvas {\n    width: 100% !important;\n  }\n  .chat-box .chat-history .call-icons ul li {\n    border: 1px solid #898989;\n  }\n  .chat-box .chat-history .total-time h2, .chat-box .chat-history .total-time .h2 {\n    color: #898989;\n  }\n  .chat-box .chat-history .call-content .btn {\n    width: auto;\n    margin: 0 auto;\n  }\n  .chat-box .chat-history .call-content > div {\n    z-index: 2;\n    background-color: rgba(255, 255, 255, 0.75);\n    background-blend-mode: overlay;\n    width: 100%;\n    padding: 30px;\n  }\n  .chat-box .chat-history .receiver-img {\n    margin-top: 25px;\n  }\n  .chat-left-aside .people-list {\n    height: 520px;\n  }\n  .chat-box .chat-right-aside .chat .chat-msg-box {\n    height: 440px;\n  }\n  .chat-box .people-list ul {\n    max-height: 450px;\n    overflow: auto;\n  }\n  .call-chat-body .chat-box .people-list ul {\n    max-height: 550px;\n    overflow: auto;\n  }\n  .call-chat-body .chat-box {\n    overflow: hidden;\n    height: 625px;\n  }\n  .caller-img {\n    position: absolute;\n    width: 100%;\n    max-width: 100%;\n    left: 15px;\n  }\n  .caller-img img {\n    opacity: 0.7;\n  }\n  .timeline-small .media .timeline-round.timeline-line-1:after {\n    bottom: -78px;\n  }\n}\n@media screen and (max-width: 1600px) {\n  .page-wrapper.horizontal-wrapper.material-type .page-header {\n    max-width: 1320px;\n  }\n  .page-wrapper.horizontal-wrapper.material-type .page-body-wrapper .sidebar-wrapper,\n  .page-wrapper.horizontal-wrapper.material-type .page-body-wrapper .page-body {\n    max-width: 1320px;\n  }\n  .chat-box .chat-right-aside .chat .chat-header .chat-menu-icons li {\n    margin-right: 10px;\n  }\n}\n@media (max-width: 1470px) {\n  .basic_table .table-responsive .table tbody tr td:nth-child(n+2) {\n    min-width: 180px;\n  }\n  .signal-table.table-responsive .table tbody tr td:nth-child(n+2) {\n    min-width: 240px;\n  }\n}\n@media screen and (max-width: 1660px) and (min-width: 1200px) {\n  .xl-none {\n    display: none;\n  }\n  .xl-60 {\n    max-width: 60%;\n    flex: 0 0 60%;\n  }\n  .xl-50 {\n    max-width: 50%;\n    flex: 0 0 50%;\n  }\n  .xl-100 {\n    max-width: 100%;\n    flex: 0 0 100%;\n  }\n  .xl-23 {\n    max-width: 23%;\n    flex: 0 0 23%;\n  }\n  .xl-25 {\n    max-width: 25%;\n    flex: 0 0 25%;\n  }\n  .xl-40 {\n    max-width: 40%;\n    flex: 0 0 40%;\n  }\n  .xl-4 {\n    max-width: 33.33%;\n    flex: 0 0 33.33%;\n  }\n}\n@media (max-width: 1280px) {\n  .img-gallery-set1,\n  .img-gallery-set5 {\n    display: none;\n  }\n  .box-layout.page-wrapper.horizontal-wrapper .page-header {\n    padding-left: unset;\n    max-width: unset;\n    left: unset;\n  }\n  .box-layout.page-wrapper.horizontal-wrapper .page-body-wrapper {\n    width: unset;\n  }\n}\n@media screen and (max-width: 1580px) and (min-width: 1200px) {\n  .docs-buttons,\n  .docs-toggles {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n}\n@media screen and (max-width: 1366px) and (min-width: 1200px) {\n  .flot-chart-container-small {\n    height: 227px;\n  }\n  .call-chat-sidebar {\n    max-width: 262px;\n  }\n  .product-box .product-details {\n    padding: 15px;\n  }\n  .product-box .product-details p {\n    margin-bottom: 10px;\n  }\n  .flot-chart-container {\n    height: 130px;\n  }\n  .custom-card .card-profile img {\n    height: 115px;\n  }\n  .custom-card .profile-details h4, .custom-card .profile-details .h4 {\n    font-size: 18px;\n  }\n  .custom-card .profile-details h6, .custom-card .profile-details .h6 {\n    margin-bottom: 24px;\n  }\n  .custom-card .card-footer > div h3, .custom-card .card-footer > div .h3 {\n    font-size: 18px;\n  }\n  .crm-activity {\n    height: 291px;\n    overflow-y: auto;\n  }\n  .crm-activity .media .media-body .dates {\n    display: flex;\n  }\n  .chat-body {\n    padding: 10px;\n  }\n  .chat-box .chat-history .call-content .btn {\n    font-size: 15px;\n  }\n  .chat-box .chat-history .total-time h2, .chat-box .chat-history .total-time .h2 {\n    font-size: 30px;\n  }\n  .chat-box .chat-history .receiver-img {\n    margin-top: 30px;\n  }\n  .chat-box .chat-history .call-icons {\n    margin-top: 20px;\n    margin-bottom: 20px;\n  }\n  .chat-box .chat-history .call-icons ul li {\n    width: 50px;\n    height: 50px;\n    padding: 7px;\n  }\n  .chat-box .user-image {\n    width: 30px;\n    height: 30px;\n    margin-top: 3px;\n    margin-right: 3px;\n  }\n  .chat-box .about {\n    margin-top: 0;\n  }\n  .chat-box .border-tab.nav-tabs .nav-item a {\n    padding: 13px 4px !important;\n    color: #59667a !important;\n    letter-spacing: 0;\n    font-size: 12px !important;\n    line-height: 6;\n  }\n  .chat-box .chat-menu .people-list ul.list {\n    max-height: 376px;\n    overflow-y: auto;\n  }\n  .chat-box .chat-menu .user-profile .image .avatar img {\n    width: 100px;\n    height: 100px;\n  }\n  .chat-box .chat-menu .user-profile .image .icon-wrapper {\n    width: 30px;\n    height: 30px;\n    font-size: 13px;\n  }\n  .chat-left-aside .people-list {\n    height: 420px;\n  }\n  .chat-left-aside .people-list ul {\n    max-height: 376px;\n    overflow-y: auto;\n  }\n  .chat-left-aside .status-circle {\n    top: 4px;\n    left: 36px;\n  }\n  .blog-box .blog-details-main .blog-bottom-details {\n    margin: 20px 10px;\n  }\n  .blog-box .blog-details-main .blog-social li {\n    padding: 0px 10px;\n  }\n  .blog-bottom-content {\n    display: none;\n  }\n  .blog-box.blog-shadow .blog-details {\n    padding: 10px;\n  }\n  .browser-widget .media-img {\n    margin-left: auto;\n    margin-right: auto;\n    margin-bottom: 15px;\n  }\n  .browser-widget img {\n    height: 50px;\n  }\n  .email-wrap .email-left-aside .email-app-sidebar .media {\n    display: block;\n  }\n  .email-wrap .email-left-aside .email-app-sidebar .media .media-size-email {\n    width: 100%;\n    text-align: center;\n  }\n  .email-wrap .email-left-aside .email-app-sidebar .media .media-size-email img {\n    margin: 0 auto !important;\n  }\n  .email-wrap .email-left-aside .email-app-sidebar .media .media-body {\n    text-align: center;\n  }\n  .email-wrap .email-right-aside .email-body .attachment ul li img {\n    width: 73px;\n    height: 73px;\n  }\n  .email-wrap .email-right-aside .email-body .email-top {\n    line-height: 50px;\n  }\n  .email-wrap .email-right-aside .email-body .email-top .float-right {\n    display: none !important;\n  }\n  .email-wrap .email-right-aside .email-body .email-top h5, .email-wrap .email-right-aside .email-body .email-top .h5 {\n    padding: 13px 0;\n  }\n  .email-wrap .email-right-aside .email-body .inbox {\n    max-height: 668px;\n    overflow: auto;\n  }\n  .email-wrap .email-right-aside .email-body .inbox .media {\n    display: block;\n    text-align: center;\n  }\n  .email-wrap .email-right-aside .email-body .inbox .media .media-size-email {\n    width: 100%;\n    text-align: center;\n  }\n  .email-wrap .email-right-aside .email-body .inbox .media .media-size-email .mr-3 {\n    margin-right: 0 !important;\n  }\n  .email-wrap .email-right-aside .email-body .inbox .media-body {\n    text-align: center;\n  }\n  .email-wrap .email-right-aside .email-body .inbox .media-body h6, .email-wrap .email-right-aside .email-body .inbox .media-body .h6 {\n    font-size: 14px;\n  }\n  .email-wrap .email-right-aside .email-body .email-compose .cke_contents.cke_reset {\n    max-height: 144px;\n    width: 99%;\n  }\n  .email-wrap .email-right-aside .email-body .email-compose .compose-border {\n    margin: 0;\n  }\n  .alert-dismissible p {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 181px;\n  }\n  .bootstrap-touchspin .touchspin-vertical-tab .input-group {\n    width: 96% !important;\n  }\n}\n@media only screen and (max-width: 1366px) {\n  .bookmark-wrap .task-sidebar {\n    height: auto;\n  }\n  .grid-options ul li:last-child {\n    display: none;\n  }\n  .product-wrapper-grid.list-view .product-box .product-img {\n    width: 25%;\n  }\n  .cart .qty-box {\n    width: 40%;\n  }\n  .alert-dismissible strong ~ p {\n    display: inline;\n  }\n  .timeline-small .media .media-body p {\n    width: 95%;\n  }\n  .map-js-height {\n    height: 350px;\n  }\n  .chat-right-aside {\n    flex: 0 0 60%;\n    max-width: 60%;\n    overflow: hidden;\n  }\n  .chat-right-aside .chat .chat-message .smiley-box {\n    width: 45px;\n  }\n  .chat-box .chat-right-aside .chat .chat-msg-box {\n    height: 364px;\n  }\n  .chat-box .chat-right-aside .chat .chat-msg-box .chat-user-img {\n    margin-top: -30px;\n  }\n  .chat-box .chat-right-aside .chat .chat-msg-box .message {\n    width: 100%;\n    padding: 15px;\n  }\n  .chat-box .chat-right-aside .chat .chat-header .chat-menu-icons li a i {\n    font-size: 20px;\n  }\n  .chat-box .chat-history .receiver-img img {\n    height: 150px;\n  }\n  .call-chat-body .chat-box {\n    overflow: hidden;\n    height: 565px;\n  }\n  .equal-height-xl {\n    height: 517px;\n  }\n  .authentication-main .auth-innerright {\n    background-size: cover;\n  }\n  .grp-btns {\n    display: inline-block;\n  }\n  .button-builder .button-generator-bx {\n    position: relative;\n    width: 100%;\n  }\n  .page-builder .btn-group {\n    display: inline-block;\n    margin-bottom: 10px;\n  }\n  .page-builder .btn-grid {\n    margin-bottom: 15px;\n    margin-right: 0px;\n    border-right: none;\n    display: inline-block;\n  }\n  .page-builder .ge-canvas.ge-layout-desktop {\n    margin-top: 50px;\n  }\n  .ecommerce-widget .total-num {\n    font-size: 23px;\n    letter-spacing: 0px;\n  }\n  .support-ticket-font .total-num {\n    font-size: 22px;\n  }\n  .order-history table.dataTable.table thead th {\n    padding-right: 50px;\n  }\n  .custom-card {\n    padding: 15px;\n  }\n  .custom-card .card-social li a {\n    padding: 12px;\n  }\n  .map-chart .chart-container {\n    height: 300px;\n  }\n  .speed-chart .chart-container {\n    height: 250px;\n    margin-top: -40px;\n    margin-bottom: 100px;\n  }\n  .candidcahrt {\n    height: 360px;\n  }\n  .status-details h3, .status-details .h3 {\n    font-size: 18px;\n  }\n  .chart-widget-top .total-value {\n    font-size: 20px;\n  }\n  .status-widget .card-body {\n    padding: 10px;\n  }\n  .browser-widget .media {\n    flex-wrap: wrap;\n  }\n  .browser-widget .media .media-body h3, .browser-widget .media .media-body .h3 {\n    font-size: 20px;\n  }\n  .browser-widget .media .media-body p {\n    margin-bottom: 2px;\n  }\n  .browser-widget .media .media-body h4, .browser-widget .media .media-body .h4 {\n    font-size: 20px;\n  }\n  .testimonial i {\n    font-size: 46px;\n  }\n  .testimonial p {\n    margin-top: 20px;\n  }\n  .redial-social-widget {\n    width: 125px;\n    height: 125px;\n  }\n  .redial-social-widget i {\n    width: 100px;\n    height: 100px;\n    font-size: 35px;\n  }\n  .chat-body {\n    padding: 10px;\n  }\n  .chat-box .chat-history .call-content .btn {\n    font-size: 15px;\n  }\n  .chat-box .chat-history .total-time h2, .chat-box .chat-history .total-time .h2 {\n    font-size: 30px;\n  }\n  .chat-box .chat-history .receiver-img {\n    margin-top: 30px;\n  }\n  .chat-box .chat-history .call-icons {\n    margin-top: 20px;\n    margin-bottom: 20px;\n  }\n  .chat-box .chat-history .call-icons ul li {\n    width: 50px;\n    height: 50px;\n    padding: 7px;\n  }\n  .chat-box .user-image {\n    width: 45px;\n    height: 45px;\n  }\n  .chat-box .about {\n    margin-top: 0;\n  }\n  .chat-box .border-tab.nav-tabs .nav-item a {\n    padding: 13px 4px !important;\n    color: #59667a !important;\n    letter-spacing: 0;\n    font-size: 12px !important;\n    line-height: 6;\n  }\n  .chat-box .chat-menu .people-list ul.list {\n    max-height: 455px;\n    overflow-y: auto;\n  }\n  .chat-box .chat-menu .user-profile {\n    margin-top: 0;\n  }\n  .chat-box .chat-menu .user-profile .image .avatar img {\n    width: 100px;\n    height: 100px;\n  }\n  .chat-box .chat-menu .user-profile .image .icon-wrapper {\n    width: 30px;\n    height: 30px;\n    font-size: 13px;\n  }\n  .chat-box .chat-menu .user-profile .user-content p {\n    font-size: 14px;\n    margin-bottom: 10px;\n  }\n  .chat-box .chat-menu .user-profile .user-content h5, .chat-box .chat-menu .user-profile .user-content .h5 {\n    margin: 20px 0;\n  }\n  .chat-box .chat-menu .user-profile .user-content hr {\n    margin: 20px 0;\n  }\n  .chat-box .chat-menu .user-profile .follow .follow-num {\n    font-size: 20px;\n  }\n  .chat-left-aside .people-list {\n    height: 490px;\n  }\n  .chat-left-aside .people-list ul {\n    max-height: 434px;\n    overflow-y: auto;\n  }\n  .status-circle {\n    top: 4px;\n    left: 37px;\n  }\n  .mega-menu .onhover-show-div {\n    left: 164px;\n  }\n  .img-cropper .docs-toggles {\n    margin-top: 8px;\n  }\n  .bootstrap-touchspin .dropdown-basic .dropdown .dropdown-content {\n    left: -21px;\n  }\n  #advance-5_wrapper .dataTables_paginate {\n    margin-bottom: 8px;\n  }\n  #batchDelete .jsgrid-grid-header .jsgrid-table .jsgrid-header-row .jsgrid-header-cell:first-child {\n    width: 67px !important;\n  }\n  #batchDelete .jsgrid-grid-body .jsgrid-table .jsgrid-row .jsgrid-cell:first-child {\n    width: 67px !important;\n  }\n  .reset-password-box .theme-form .form-group .btn {\n    padding: 6px 22px;\n  }\n}\n@media only screen and (max-width: 1366px) and (min-width: 1200px) {\n  .page-wrapper.horizontal-wrapper.material-type .page-header {\n    max-width: 1140px;\n  }\n  .page-wrapper.horizontal-wrapper.material-type .page-body-wrapper .sidebar-wrapper,\n  .page-wrapper.horizontal-wrapper.material-type .page-body-wrapper .page-body {\n    max-width: 1140px;\n  }\n}\n@media only screen and (max-width: 1199.98px) {\n  .md-sidebar .md-sidebar-toggle {\n    display: block;\n  }\n  .md-sidebar .md-sidebar-aside {\n    position: absolute;\n    top: 40px;\n    left: 0;\n    opacity: 0;\n    visibility: hidden;\n    z-index: 3;\n    width: 280px;\n  }\n  [dir=rtl] .md-sidebar .md-sidebar-aside {\n    left: unset;\n    right: 0;\n  }\n  .md-sidebar .md-sidebar-aside.open {\n    opacity: 1;\n    visibility: visible;\n  }\n  .md-sidebar .job-sidebar {\n    background-color: var(--white);\n    padding: 20px;\n  }\n  .md-sidebar .job-sidebar .faq-accordion.default-according {\n    margin-bottom: 0;\n  }\n  .md-sidebar .job-sidebar .faq-accordion.default-according .row > div:last-child .card {\n    margin-bottom: 0;\n  }\n  .jkanban-container .kanban-container .kanban-drag > div {\n    width: 400px;\n    flex-wrap: wrap;\n  }\n  .jkanban-container .kanban-container .kanban-drag > div > div {\n    flex-wrap: wrap;\n  }\n  .jkanban-container .kanban-container .kanban-drag > div > div .react-kanban-column {\n    display: block !important;\n    margin-bottom: 20px;\n  }\n  .jkanban-container .kanban-container .kanban-board {\n    width: 400px;\n  }\n  .jkanban-container .kanban-container .kanban-board .kanban-drag > div > div {\n    display: block;\n  }\n  .jkanban-container .kanban-container .kanban-board .kanban-drag > div > div div[data-testid=lane] {\n    display: block;\n  }\n  .file-sidebar {\n    padding-right: 12px;\n  }\n  [dir=rtl] .file-sidebar {\n    padding-right: 0;\n  }\n  .col-xl-7.b-center.bg-size {\n    top: 0;\n    height: 100vh;\n    opacity: 0.5;\n    position: fixed;\n  }\n  .login-card {\n    background: transparent;\n  }\n  .knowledgebase-bg {\n    height: 400px;\n  }\n  .knowledgebase-search .form-inline {\n    width: 400px;\n    padding: 7px 45px;\n  }\n  .knowledgebase-search .form-inline svg {\n    top: 14px;\n  }\n  .btn-group .btn {\n    padding: 0.375rem 1.25rem;\n  }\n  .link-section > div.active > h6:before, .link-section > div.active > .h6:before {\n    content: \"\\f107\";\n    transition: content 0.3s ease;\n  }\n  .link-section > div > h6, .link-section > div > .h6 {\n    position: relative;\n  }\n  .link-section > div > h6:before, .link-section > div > .h6:before {\n    content: \"\\f105\";\n    font-family: fontAwesome;\n    position: absolute;\n    right: 10px;\n    font-size: 18px;\n    transition: content 0.3s ease;\n  }\n  .alert-theme {\n    min-width: 420px;\n  }\n  .mega-menu-header .header-wrapper .vertical-mobile-sidebar {\n    display: block;\n    margin-right: 15px;\n  }\n  .page-wrapper .page-header .header-wrapper .nav-right {\n    position: unset;\n    padding: 0;\n  }\n  .page-wrapper .page-header .header-wrapper .nav-right > ul li .submenu li:first-child {\n    padding-left: 15px !important;\n  }\n  .page-wrapper .page-header .header-wrapper .mobile-sidebar .switch-sm .switch {\n    margin-top: 6px;\n  }\n  .photos ul li {\n    width: auto;\n  }\n  .photos ul li:nth-child(3n) {\n    margin-right: 15px;\n  }\n  .user-profile .hovercard .user-image .share-icons {\n    position: absolute;\n    right: 45px;\n    top: -22px;\n  }\n  .user-profile .hovercard .user-image .share-icons li .social-icon {\n    width: 40px;\n    height: 40px;\n  }\n  .user-profile .hovercard .user-image .share-icons li .social-icon i {\n    font-size: 18px;\n  }\n  .user-profile .hovercard .user-image .share-icons li {\n    color: #fff;\n    font-size: 25px;\n  }\n  .timeline-small .media .timeline-round.timeline-line-1:after {\n    height: 33px;\n    bottom: -52px;\n  }\n  .timeline-small .media .timeline-round.small-line:after {\n    height: 18px;\n    bottom: -34px;\n  }\n  .timeline-small .media .timeline-round.medium-line:after {\n    height: 30px;\n    bottom: -52px;\n  }\n  .timeline-small .media .media-body p {\n    width: 100%;\n  }\n  .lg-mt-col {\n    margin-top: 30px;\n  }\n  .xl-none {\n    display: none;\n  }\n  .lg-mt {\n    margin-top: 30px;\n  }\n  .product-wrapper-grid.list-view .product-box .product-img {\n    width: 32%;\n  }\n  .debit-card {\n    order: 1;\n  }\n  .typography .row div + div {\n    margin-top: 30px;\n  }\n  .listing .card-body .row > div + div {\n    margin-top: 30px;\n  }\n  .flot-chart-container {\n    height: 200px;\n  }\n  .img-cropper #putData {\n    margin-bottom: 10px;\n  }\n  .img-cropper .docs-toggles > .dropdown {\n    margin-bottom: 0;\n  }\n  .error-wrapper .maintenance-icons li i {\n    color: #f4f4f4;\n    font-size: 40px;\n  }\n  .error-wrapper .maintenance-icons li:nth-child(2) i {\n    font-size: 80px;\n    margin-left: 90px;\n  }\n  .error-wrapper .maintenance-icons li:nth-child(3) i {\n    font-size: 120px;\n    margin-top: -75px;\n    margin-right: 110px;\n  }\n  div.dataTables_wrapper div.dataTables_paginate ~ .dataTables_filter {\n    display: block;\n    width: 100%;\n    margin-top: 20px;\n    margin-bottom: 0;\n  }\n  .jvector-map-height {\n    height: 280px;\n  }\n  .blog-list .blog-details p {\n    margin-bottom: 5px;\n  }\n  .custom-card .card-profile .card-footer > div h3, .custom-card .card-profile .card-footer > div .h3 {\n    font-size: 18px;\n  }\n  .equal-height-lg {\n    min-height: unset !important;\n  }\n  .mega-menu .onhover-show-div {\n    height: 435px;\n    overflow-x: scroll;\n    left: 215px;\n  }\n  .mega-menu .mega-bg {\n    display: none;\n  }\n  .mega-menu .lg-mt {\n    margin-top: 25px;\n  }\n  .button-builder .button-generator-bx {\n    position: relative;\n    width: 100%;\n  }\n  .blog-single .comment-box ul .comment-social {\n    margin-left: 0;\n  }\n  [dir=rtl] .blog-single .comment-box ul .comment-social {\n    margin-left: unset;\n    margin-right: 0;\n  }\n  .error-wrapper .maintenance-heading {\n    margin-top: 30px;\n  }\n  .error-wrapper .maintenance-heading .headline {\n    font-size: 50px;\n    margin-top: -15%;\n    margin-bottom: 0px;\n  }\n  .error-wrapper .maintenance-heading .cloud-second {\n    margin-top: -25px;\n  }\n  .testimonial p {\n    margin-top: 17px;\n  }\n  .browser-widget {\n    padding: 0px;\n  }\n  .browser-widget img {\n    height: 50px;\n  }\n  .browser-widget .media .media-body h4, .browser-widget .media .media-body .h4 {\n    font-size: 17px;\n  }\n  .browser-widget .media .media-img {\n    width: 100%;\n    text-align: center;\n    margin-bottom: 10px;\n  }\n  .crm-overall .overall-chart {\n    height: 200px;\n  }\n  .product-table table.dataTable thead > tr > th {\n    padding-right: 50px;\n  }\n  .chat-menu-icons {\n    display: block;\n    clear: both;\n  }\n  .chat-menu {\n    right: 0;\n    border-top: 1px solid #efefef;\n    opacity: 0;\n    transform: translateY(-30px);\n    visibility: hidden;\n    top: 60px;\n    position: absolute !important;\n    z-index: 3;\n    background-color: #fff;\n    transition: all linear 0.3s;\n  }\n  .chat-menu.show {\n    opacity: 1;\n    visibility: visible;\n    transform: translateY(0px);\n    transition: all linear 0.3s;\n    padding-bottom: 25px;\n  }\n  .chat-box .chat-menu .people-list ul.list {\n    max-height: 444px;\n    overflow-y: auto;\n  }\n  .chat-box .btn-lg, .chat-box .btn-group-lg > .btn {\n    font-size: 12px;\n  }\n  .chat-box .people-list ul {\n    height: auto;\n  }\n  .chat-box .chat-right-aside .chat .chat-header {\n    height: auto;\n  }\n  .chat-box .chat-right-aside .chat .chat-header .chat-menu-icons {\n    gap: 5px;\n  }\n  .chat-box .chat-right-aside .chat .chat-header .chat-menu-icons li a i {\n    font-size: 19px;\n  }\n  .chat-box .chat-right-aside .chat .chat-header .chat-menu-icons li a svg {\n    width: 19px;\n    height: 19px;\n  }\n  .chat-box .chat-right-aside .chat .chat-message {\n    margin: 0;\n  }\n  .chat-box .chat-history .total-time h2, .chat-box .chat-history .total-time .h2 {\n    font-size: 25px;\n  }\n  .chat-box .chat-history .row .col-sm-7 {\n    padding-right: 0;\n  }\n  .chat-box .border-tab.nav-tabs {\n    width: 100%;\n  }\n  .chat-box .border-tab.nav-tabs .nav-item {\n    margin-right: 5px;\n  }\n  .chat-box .chat-left-aside .people-list {\n    height: 493px;\n  }\n  .chat-box .chat-history .call-content > div {\n    padding-top: 70px;\n  }\n  .chat-box .toogle-bar {\n    display: inline-block;\n    margin-right: 0 !important;\n  }\n  .chat-right-aside {\n    flex: 0 0 100%;\n    max-width: calc(100% - 15px);\n    overflow: hidden;\n  }\n  .call-chat-body .chat-box {\n    overflow: auto;\n    height: auto;\n  }\n  .email-wrap .email-right-aside .email-body .b-r-light {\n    border-right: none !important;\n  }\n  .email-wrap .email-right-aside .radius-left {\n    border-top-left-radius: 4px !important;\n    border-bottom-left-radius: 4px !important;\n  }\n  .email-wrap .row .col-xl-3 + .col-xl-3 {\n    padding-right: 15px;\n  }\n  .email-wrap .row .col-xl-6 {\n    padding-left: 15px;\n  }\n  .icon-lists div {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 209px;\n  }\n  .like-comment-lg-mb {\n    margin-bottom: 12px;\n  }\n  .ribbon-space-bottom {\n    top: 9px;\n  }\n  .bootstrap-touchspin .touchspin-vertical-tab .input-group {\n    width: 98.5% !important;\n  }\n  #batchDelete .jsgrid-grid-header .jsgrid-table .jsgrid-header-row .jsgrid-header-cell:first-child {\n    width: 95px !important;\n  }\n  #batchDelete .jsgrid-grid-body .jsgrid-table .jsgrid-row .jsgrid-cell:first-child {\n    width: 95px !important;\n  }\n  .profile-img-style #aniimated-thumbnials-3 {\n    text-align: center;\n  }\n  .vertical-menu-mt {\n    margin-top: 80px !important;\n  }\n  .vertical-menu-mt .xl-none {\n    display: block;\n  }\n  .calendar-wrap .fc-day-grid-event {\n    width: 87%;\n  }\n  .product-page-main .product-page-details h3, .product-page-main .product-page-details .h3 {\n    font-size: 26px;\n  }\n}\n@media only screen and (max-width: 1199px) and (min-width: 992px) {\n  .page-wrapper.horizontal-wrapper.material-type .page-header {\n    max-width: 930px;\n  }\n  .page-wrapper.horizontal-wrapper.material-type .page-body-wrapper .sidebar-wrapper,\n  .page-wrapper.horizontal-wrapper.material-type .page-body-wrapper .page-body {\n    max-width: 930px;\n  }\n}\n@media only screen and (max-width: 991.98px) {\n  .todo-list-wrapper #todo-list li .task-container .task-label {\n    min-width: 460px;\n  }\n  .simplebar-mask {\n    top: 70px;\n  }\n  .project-cards .tab-content {\n    margin-bottom: -20px;\n  }\n  .project-box {\n    margin-bottom: 20px;\n  }\n  .page-wrapper.modern-type .simplebar-mask {\n    top: 70px;\n  }\n  .page-wrapper.compact-sidebar .simplebar-mask {\n    top: 87px;\n  }\n  .page-wrapper.compact-sidebar .page-header {\n    margin-left: 0;\n    width: calc(100% - 0px);\n  }\n  .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper.close_icon .sidebar-main .sidebar-links li .sidebar-link.active ~ .sidebar-submenu {\n    display: none !important;\n  }\n  .page-wrapper.compact-sidebar .page-body-wrapper .page-body {\n    margin-top: 60px;\n  }\n  .page-wrapper.only-body .page-header .header-wrapper .search-full .Typeahead-menu {\n    top: 65px;\n  }\n  .page-wrapper.advance-layout .page-body-wrapper .sidebar-wrapper {\n    position: fixed !important;\n    top: 0 !important;\n  }\n  .product-box .modal .modal-header .product-box .product-details {\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n  .search-form .form-group:before {\n    top: 33px;\n  }\n  .search-form .form-group:after {\n    top: 35px;\n  }\n  .mobile-title.d-none {\n    padding: 11px 30px 10px;\n  }\n  .page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown {\n    top: 50px;\n  }\n  .page-wrapper .page-header .header-wrapper .search-full input {\n    line-height: 50px;\n  }\n  .page-wrapper .page-header .header-wrapper .search-full .form-group .close-search {\n    top: 20px;\n  }\n  .page-wrapper .page-header .header-wrapper .search-full .form-group:before {\n    top: 18px;\n  }\n  .page-wrapper .current_lang .lang span.lang-txt {\n    display: none;\n  }\n  .customizer-contain {\n    top: 62px;\n  }\n  .m-r-30 {\n    margin-right: 20px;\n  }\n  .card.full-card {\n    top: 60px;\n    width: calc(100vw - 0px);\n  }\n  .vertical-mobile-sidebar {\n    right: 75px;\n    top: 18px;\n  }\n  .gallery {\n    margin-bottom: -20px;\n  }\n  .my-gallery figure {\n    margin-bottom: 20px;\n  }\n  #aniimated-thumbnials figure:nth-child(12), #aniimated-thumbnials figure:nth-child(11), #aniimated-thumbnials figure:nth-child(10), #aniimated-thumbnials figure:nth-child(9) {\n    margin-bottom: 20px;\n  }\n  .photoswipe-pb-responsive {\n    padding-bottom: 25px !important;\n  }\n  table.dataTable.fixedHeader-locked, table.dataTable.fixedHeader-floating {\n    left: 0 !important;\n    width: 100% !important;\n  }\n  .page-wrapper .section-space {\n    padding: 60px 0;\n  }\n  .page-wrapper .card {\n    margin-bottom: 30px;\n  }\n  .page-wrapper .card .card-header,\n  .page-wrapper .card .card-body,\n  .page-wrapper .card .card-footer {\n    padding: 20px;\n  }\n  .page-wrapper .card .card-header .tab-content .m-t-30,\n  .page-wrapper .card .card-body .tab-content .m-t-30,\n  .page-wrapper .card .card-footer .tab-content .m-t-30 {\n    margin-top: 20px !important;\n  }\n  .page-wrapper .card .card-header .tab-content .m-b-30,\n  .page-wrapper .card .card-body .tab-content .m-b-30,\n  .page-wrapper .card .card-footer .tab-content .m-b-30 {\n    margin-bottom: 20px !important;\n  }\n  .page-wrapper .page-body-wrapper .footer-fix {\n    margin-left: 0px;\n    padding-right: 15px;\n    width: calc(100% - 0px) !important;\n  }\n  .page-wrapper.compact-wrapper .page-header {\n    margin-left: 0 !important;\n    width: calc(100% - 0px) !important;\n  }\n  .page-wrapper.compact-wrapper .page-header .header-wrapper .maximize {\n    display: none;\n  }\n  .page-wrapper.compact-wrapper .page-header .header-wrapper .header-logo-wrapper {\n    display: flex;\n  }\n  .page-wrapper.compact-wrapper .page-header .header-wrapper .toggle-sidebar {\n    position: unset;\n    margin-right: 15px;\n    border-right: 1px solid #ddd;\n    padding-right: 15px;\n    display: block;\n  }\n  .page-wrapper.compact-wrapper .page-header .header-wrapper .toggle-sidebar:before {\n    display: none;\n  }\n  .page-wrapper.compact-wrapper .page-header .header-wrapper .toggle-nav {\n    display: none;\n  }\n  .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper {\n    top: 0;\n  }\n  .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon:hover {\n    transform: translate(-285px);\n  }\n  .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .logo-wrapper {\n    padding: 17px 30px;\n  }\n  .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .logo-wrapper .back-btn {\n    display: inline-block;\n    float: right;\n    font-size: 20px;\n  }\n  .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .logo-wrapper .toggle-sidebar {\n    display: none;\n  }\n  .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links {\n    height: calc(100vh - 95px);\n  }\n  .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon {\n    transform: translate(-285px);\n  }\n  .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper.close_icon .sidebar-main .sidebar-links {\n    height: unset;\n  }\n  .page-wrapper.compact-wrapper .page-body-wrapper .page-body {\n    margin-top: 60px;\n    padding: 0 15px;\n  }\n  .page-wrapper.compact-sidebar .page-header .header-wrapper .maximize {\n    display: none;\n  }\n  .page-wrapper.modern-type .page-header .header-wrapper .logo-wrapper {\n    display: none;\n    margin-right: 0;\n  }\n  .page-wrapper.modern-type .page-body-wrapper div.sidebar-wrapper {\n    margin: 0 !important;\n  }\n  .page-wrapper.modern-type .page-body-wrapper div.sidebar-wrapper .logo-wrapper {\n    display: block;\n  }\n  .page-wrapper.material-icon .page-header {\n    padding-left: 0;\n  }\n  .page-wrapper.material-icon .page-body-wrapper .page-body {\n    padding-left: 15px;\n  }\n  .page-wrapper .page-header .header-wrapper {\n    margin: 0;\n    padding: 12px 30px;\n  }\n  .page-wrapper .page-header .header-wrapper .nav-right .notification {\n    top: 10px;\n  }\n  .page-wrapper .page-header .header-wrapper > .mobile-toggle {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n  }\n  .page-wrapper .page-header .header-wrapper .header-logo-wrapper {\n    margin-right: 0;\n  }\n  .page-wrapper .page-header .header-logo-wrapper .logo-wrapper img {\n    margin-top: 0;\n  }\n  .page-body-wrapper .page-body,\n  .page-body-wrapper footer {\n    margin-left: 0 !important;\n  }\n  .page-body-wrapper .page-body #customer-review .owl-stage-outer,\n  .page-body-wrapper footer #customer-review .owl-stage-outer {\n    width: 100% !important;\n  }\n  .default-according .card {\n    margin-bottom: 10px !important;\n  }\n  .default-according .card .card-header {\n    padding: 0 !important;\n  }\n  .faq-wrap .faq-accordion.default-according .card .faq-header {\n    padding: 20px 20px 0 !important;\n  }\n  .crm-activity > li + li {\n    margin-top: 10px;\n    padding-top: 10px;\n  }\n  .add-post .dropzone {\n    margin-bottom: 20px;\n  }\n  .customers.avatar-group {\n    margin-right: 20px;\n  }\n  .socialprofile .social-btngroup {\n    margin: 20px 0;\n  }\n  .socialprofile .social-group {\n    margin-top: 20px;\n  }\n  .social-status form .form-group .form-control-social {\n    margin-bottom: 20px;\n  }\n  .social-status .media {\n    margin-bottom: 20px;\n  }\n  .timeline-content p,\n  .timeline-content .comments-box {\n    margin-top: 20px;\n  }\n  .social-chat {\n    margin-top: 20px;\n  }\n  .social-chat .media-body {\n    padding: 20px;\n  }\n  .social-chat .your-msg,\n  .social-chat .other-msg {\n    margin-bottom: 20px;\n  }\n  .social-network span {\n    margin-bottom: 20px;\n  }\n  .details-about + .details-about {\n    margin-top: 20px;\n  }\n  .activity-log .my-activity + .my-activity {\n    margin-top: 20px;\n  }\n  .new-users-social {\n    margin-bottom: 20px;\n  }\n  .timeline-small .media {\n    margin-bottom: 20px;\n  }\n  .timeline-small .media .media-body h6, .timeline-small .media .media-body .h6 {\n    margin-bottom: 20px;\n  }\n  .timeline-small .media .media-body p {\n    width: 75%;\n  }\n  .timeline-small .media .timeline-round {\n    width: 45px;\n    height: 45px;\n    top: -14px;\n  }\n  .timeline-small .media .timeline-round.timeline-line-1:after {\n    bottom: -41px;\n    height: 25px;\n  }\n  .timeline-small .media .timeline-round.small-line:after {\n    bottom: -26px;\n    height: 14px;\n  }\n  .timeline-small .media .timeline-round.medium-line:after {\n    bottom: -33px;\n    height: 17px;\n  }\n  .timeline-small .media .timeline-round svg {\n    top: 14px;\n  }\n  .helper-classes {\n    padding: 20px;\n  }\n  .floated-customizer-btn,\n  .floated-customizer-panel {\n    display: none;\n  }\n  .page-builder .ge-canvas.ge-editing .row {\n    padding: 20px;\n  }\n  .ecommerce-widget .progress-showcase {\n    margin-top: 20px;\n  }\n  .crm-overall {\n    margin: 0 -20px -20px;\n  }\n  .product-page-main {\n    padding: 20px;\n  }\n  .grid-options ul li:nth-child(3) {\n    display: none;\n  }\n  .feature-products form .form-group i {\n    right: 20px;\n  }\n  .tabbed-card ul {\n    padding: 18px 15px;\n  }\n  .tabbed-card ul {\n    top: -7px;\n    right: 0;\n  }\n  .tabbed-card ul.border-tab.nav-tabs {\n    padding: 0;\n  }\n  .tabbed-card ul.border-tab.nav-tabs .nav-item .nav-link {\n    padding: 10px 15px;\n  }\n  .tilt-showcase .tilt-image {\n    text-align: center;\n  }\n  .tilt-showcase .mt-4 {\n    margin-top: 20px !important;\n  }\n  .todo .todo-list-wrapper .mark-all-tasks {\n    top: 20px;\n    right: 20px;\n  }\n  .custom-card {\n    padding-bottom: 0;\n  }\n  .custom-card .card-footer {\n    padding: 0 15px 15px 15px !important;\n  }\n  .custom-card .card-header {\n    border: none;\n  }\n  .custom-card .dashboard-card {\n    padding: 0;\n  }\n  .custom-card .card-profile img {\n    height: 155px;\n  }\n  .display-1 {\n    font-size: 4rem;\n  }\n  .display-2 {\n    font-size: 3.5rem;\n  }\n  .display-3 {\n    font-size: 2.5rem;\n  }\n  .display-4 {\n    font-size: 1.5rem;\n  }\n  .typography .h1 {\n    font-size: 34px;\n  }\n  .typography .h2 {\n    font-size: 30px;\n  }\n  .typography .h3 {\n    font-size: 22px;\n  }\n  .typography .h4 {\n    font-size: 20px;\n  }\n  .typography .h5 {\n    font-size: 18px;\n  }\n  .typography .h6 {\n    font-size: 15px;\n  }\n  h1, .h1 {\n    font-size: 34px;\n  }\n  h2, .h2 {\n    font-size: 28px;\n  }\n  h3, .h3 {\n    font-size: 26px;\n  }\n  h4, .h4 {\n    font-size: 22px;\n  }\n  h5, .h5 {\n    font-size: 18px;\n  }\n  h6, .h6 {\n    font-size: 15px;\n  }\n  .card-absolute .card-header {\n    padding: 10px 15px !important;\n  }\n  .comingsoon .comingsoon-inner .countdown .time {\n    width: 80px;\n    height: 80px;\n    font-size: 26px;\n  }\n  .calendar-wrap .basic-calendar .external-events .fc-event + .fc-event {\n    margin-top: 10px;\n  }\n  .owl-theme .owl-nav.disabled + .owl-dots {\n    margin-bottom: -10px;\n    margin-top: 15px;\n  }\n  .card .card-header h5, .card .card-header .h5 {\n    font-size: 18px;\n  }\n  .card .card-header .card-header-right {\n    top: 12px;\n    right: 15px;\n  }\n  .page-builder .ge-addRowGroup {\n    width: 100%;\n  }\n  .user-profile .hovercard .info .user-designation {\n    margin-bottom: 20px;\n  }\n  .search-list {\n    justify-content: center;\n  }\n  .blog-single .comment-box .comment-social li {\n    padding-left: 15px;\n  }\n  .error-wrapper {\n    padding: 35px 0;\n  }\n  .error-wrapper .sub-content {\n    font-size: 14px;\n    line-height: 25px;\n    margin-top: 0px;\n  }\n  .error-wrapper .error-heading {\n    margin-top: 30px;\n  }\n  .error-wrapper .error-heading .headline {\n    font-size: 180px;\n    margin-top: 0;\n  }\n  .error-wrapper .maintenance-heading {\n    margin-top: 30px;\n  }\n  .editor_container .CodeMirror {\n    min-height: 250px;\n    height: 250px;\n  }\n  .search-page .info-block {\n    flex-wrap: wrap;\n  }\n  .search-page .tab-content .pb-4 {\n    padding-bottom: 20px !important;\n  }\n  .xl-none {\n    display: block;\n  }\n  .top-radius-blog {\n    width: 100%;\n  }\n  .sm-100-w {\n    width: 100%;\n    height: 100%;\n  }\n  /*Form Wizard One start*/\n  .form-wizard .btn-mb {\n    margin-bottom: 20px;\n  }\n  /*Form Wizard One ends*/\n  /*Form Wizard Two Start*/\n  .stepwizard {\n    margin-bottom: 20px;\n  }\n  /*Form Wizard Two Ends*/\n  /*Form Wizard Three Start*/\n  .f1 .f1-steps {\n    margin-top: 20px;\n    margin-bottom: 20px;\n  }\n  /*Form Wizard Three ends*/\n  /*Form Wizard Four Start*/\n  .wizard-4 ul.anchor {\n    padding-right: 20px;\n    width: 40%;\n  }\n  .wizard-4 ul.anchor li a.done h4:before, .wizard-4 ul.anchor li a.done .h4:before {\n    top: -8px;\n  }\n  .wizard-4 ul.anchor li h4, .wizard-4 ul.anchor li .h4 {\n    padding: 11px 18px;\n    width: 50px;\n  }\n  .wizard-4 ul.anchor li + li a {\n    padding-left: 65px;\n  }\n  [dir=rtl] .wizard-4 ul.anchor li + li a {\n    padding-right: 65px;\n  }\n  .wizard-4 .step-container {\n    width: 60%;\n  }\n  .wizard-4 .step-container div.content .wizard-title {\n    width: 380px;\n  }\n  .wizard-4 .login-card .login-main {\n    width: 380px;\n  }\n  .wizard-4 .msg-box {\n    top: 25px !important;\n  }\n  /*Form Wizard Four ends*/\n  .border-tab.nav-tabs {\n    margin-bottom: 20px;\n  }\n  .tab-content ~ .nav-tabs.border-tab {\n    margin-top: 20px;\n  }\n  .dataTables_wrapper .dataTables_length {\n    margin-bottom: 20px;\n  }\n  .dataTables_wrapper table.dataTable {\n    margin-bottom: 20px !important;\n  }\n  .search-page .info-block + .info-block {\n    padding-top: 20px;\n    margin-top: 20px;\n  }\n  .search-page #video-links .embed-responsive + .embed-responsive {\n    margin-top: 20px;\n  }\n  .lg-mt {\n    margin-top: 20px;\n  }\n  .gallery-with-description {\n    margin-bottom: -20px;\n  }\n  .gallery-with-description a > div {\n    margin-bottom: 20px;\n  }\n  .clipboaard-container p {\n    margin-bottom: 8px;\n  }\n  .m-b-30 {\n    margin-bottom: 20px !important;\n  }\n  .email-wrap .email-left-aside .email-app-sidebar ul li hr {\n    margin: 13px 0;\n  }\n  .nav-md-mt {\n    margin-top: 20px;\n  }\n  .navs-icon {\n    padding: 20px;\n  }\n  .navs-icon .main-section {\n    padding-top: 20px;\n  }\n  .navs-icon .separator {\n    margin: 20px 0;\n  }\n  .nav-list {\n    padding: 20px;\n  }\n  .navs-dropdown button {\n    margin-top: 20px;\n  }\n  .navs-dropdown .onhover-show-div {\n    top: 68px;\n  }\n  .animated-modal .form-group {\n    width: 100%;\n    display: block;\n  }\n  .animated-modal .mr-4 {\n    margin-right: 0 !important;\n  }\n  .steps-md-mt {\n    margin-top: 20px;\n  }\n  .btn-group-wrapper .m-b-30:last-child {\n    margin-bottom: 0 !important;\n  }\n  #advance-5_wrapper .dataTables_paginate {\n    margin-bottom: 20px;\n  }\n  .click2edit ~ .note-editor.note-frame {\n    margin-bottom: 20px;\n  }\n  .chat-box .chat-left-aside .people-list {\n    height: 483px;\n  }\n  .chat-box .chat-right-aside .chat .chat-header .chat-menu-icons li {\n    margin-right: 5px;\n  }\n  .card .card-body form.animated-modal {\n    display: flex;\n  }\n  .card .card-body form.animated-modal .animated-modal-md-mb {\n    margin-bottom: 20px !important;\n  }\n  .wizard-4 .msg-box {\n    top: 40px;\n    right: 0%;\n    bottom: unset;\n    left: unset;\n  }\n  .theme-form.form-inline {\n    display: flex;\n  }\n}\n@media only screen and (max-width: 991px) and (min-width: 768px) {\n  .page-wrapper.compact-wrapper.material-type::before {\n    height: 230px;\n  }\n  .page-wrapper.compact-wrapper.material-type .page-header {\n    width: calc(100% - 60px) !important;\n    margin: 50px auto 0 !important;\n  }\n  .page-wrapper.compact-wrapper.material-type .page-body-wrapper {\n    margin: 0 30px;\n  }\n  .page-wrapper.compact-wrapper.material-type .page-body-wrapper div.sidebar-wrapper {\n    left: 0;\n  }\n  .page-wrapper.compact-wrapper.material-type .page-body-wrapper .page-body {\n    margin-top: 0;\n  }\n}\n@media only screen and (max-width: 810px) {\n  .page-wrapper .page-header .header-wrapper .nav-right > ul > li .profile-media .media-body {\n    display: none;\n  }\n}\n@media only screen and (max-width: 767.98px) {\n  .wizard-4 ul.anchor {\n    width: 100%;\n    height: auto;\n    padding: 30px;\n  }\n  .wizard-4 .step-container {\n    width: 100%;\n  }\n  .contact-editform {\n    padding-left: 20px !important;\n  }\n  .event-calendar {\n    display: block !important;\n  }\n  .event-calendar #right {\n    width: 100%;\n  }\n  .event-calendar #calendar {\n    clear: both;\n  }\n  .page-wrapper.material-type::before {\n    display: none;\n  }\n  .page-wrapper.material-type .page-header {\n    margin-top: 0;\n    border-radius: 0;\n  }\n  .page-wrapper.material-type .page-body-wrapper .page-body {\n    margin-top: 0 !important;\n  }\n  .page-wrapper.only-body .page-header .header-wrapper .nav-right > ul > li {\n    margin-right: -2px;\n  }\n  .page-wrapper.only-body .page-header .header-wrapper .nav-right .nav-menus {\n    margin-right: -10px;\n  }\n  .new-products .owl-carousel .product-box.row > div {\n    width: auto;\n  }\n  .profile-media .media-body {\n    display: none;\n  }\n  .form-inline .form-group:not(.form-control-search) {\n    width: 100%;\n  }\n  .form-inline .form-group:not(.form-control-search) + .form-group {\n    margin-top: 10px;\n  }\n  .form-inline .form-group:not(.form-control-search) input {\n    width: 100%;\n  }\n  .credit-card .text-center img {\n    margin-bottom: 20px;\n  }\n  .starter-kit-fix .page-body {\n    margin-bottom: 78px;\n  }\n  .blog-box .blog-details-main .blog-social li {\n    padding: 0 12px;\n  }\n  .blog-box .blog-details .blog-social li:first-child {\n    padding-right: 25px;\n  }\n  .blog-box .blog-details .blog-social li + li {\n    padding-left: 25px;\n  }\n  .footer-copyright ~ div {\n    text-align: center;\n  }\n  .footer-copyright ~ div p {\n    float: none;\n    margin-top: 5px;\n  }\n  .btn-showcase {\n    text-align: center;\n  }\n  .user-profile .hovercard .user-image .share-icons {\n    right: 25px;\n    top: -19px;\n  }\n  .user-profile .hovercard .user-image .share-icons li .social-icon {\n    width: 35px;\n    height: 35px;\n  }\n  .tabs-scoial.border-tab.nav-tabs {\n    display: flex;\n  }\n  .timeline-small .media .media-body p {\n    width: 100%;\n  }\n  .my-gallery figure:nth-child(9), .my-gallery figure:nth-child(10) {\n    margin-bottom: 20px;\n  }\n  .project-list .btn {\n    float: left;\n    margin-top: 5px;\n  }\n  .chat-box .chat-right-aside .chat .chat-message .text-box .btn {\n    font-size: 0;\n  }\n  .chat-box .chat-right-aside .chat .chat-message .text-box .btn:before {\n    position: absolute;\n    content: \"\\e661\";\n    font-family: themify;\n    font-size: 18px;\n    top: 11px;\n    left: 20px;\n  }\n  .chat-box .border-tab.nav-tabs {\n    display: flex;\n  }\n  .chat-box .chat-menu .nav-tabs .nav-item a {\n    height: 50px;\n  }\n  .chat-box .chat-history .call-content > div {\n    padding-top: 40px;\n    height: auto;\n  }\n  .chat-box .chat-history .receiver-img {\n    margin-bottom: unset;\n  }\n  .chat-box .chat-left-aside .people-list {\n    height: auto;\n  }\n  .call-chat-sidebar {\n    max-width: 100%;\n    width: 100%;\n    flex-basis: auto;\n  }\n  .call-chat-sidebar .people-list {\n    height: auto;\n  }\n  .chat-left-aside .people-list ul {\n    max-height: 100px;\n  }\n  .clockpicker-align-top {\n    left: 55px !important;\n    top: 470px !important;\n  }\n  .clockpicker-align-top .arrow {\n    display: none;\n  }\n  .form-builder-column .form-body {\n    min-height: 250px;\n  }\n  .form-builder-2-header {\n    flex-wrap: wrap;\n  }\n  .form-builder-2-header > div {\n    width: 100%;\n    margin-top: 10px;\n  }\n  .form-builder-2-header > div nav {\n    float: none;\n  }\n  .lg-mt-col {\n    margin-top: 20px;\n  }\n  .form-builder .drag-box fieldset {\n    padding: 20px;\n    margin-top: 20px;\n  }\n  .form-builder #components {\n    margin-top: 20px;\n  }\n  .form-builder .component label {\n    padding-top: 0px;\n  }\n  .mega-menu .onhover-show-div {\n    height: 415px;\n    left: 0;\n    top: 61px;\n    padding: 20px;\n  }\n  .mega-menu .lg-mt {\n    margin-top: 15px;\n  }\n  .page-builder .ge-canvas.ge-editing .ge-tools-drawer {\n    margin: 10px 0 0 10px;\n  }\n  .page-builder .ge-canvas.ge-editing .ge-tools-drawer > a {\n    padding: 0 5px;\n  }\n  .reader {\n    margin-top: 15px;\n    height: auto !important;\n  }\n  .range-slider.theme-form .form-group {\n    margin-bottom: 0;\n  }\n  .note-editor .btn-group .btn {\n    font-size: 11px;\n  }\n  .text-md-right {\n    text-align: right;\n  }\n  .star-ratings .stars {\n    padding: 0;\n  }\n  .form-inline.d-inline-block {\n    display: block !important;\n    width: 100%;\n  }\n  .form-inline.d-inline-block .form-control {\n    margin-bottom: 10px;\n  }\n  .reset-password-box {\n    width: 500px;\n    margin: 0 auto;\n  }\n  .reset-password-box .card {\n    padding: 20px;\n  }\n  .custom-card .card-profile img {\n    height: 136px;\n    bottom: 0;\n  }\n  .error-wrapper .maintenance-icons li i {\n    color: #f4f4f4;\n    font-size: 30px;\n  }\n  .error-wrapper .maintenance-icons li:nth-child(2) i {\n    font-size: 60px;\n    margin-top: -10px;\n    margin-left: 70px;\n  }\n  .error-wrapper .maintenance-icons li:nth-child(3) i {\n    font-size: 90px;\n    margin-right: 80px;\n  }\n  .authentication-main .auth-innerright .social-media li {\n    font-size: 14px;\n  }\n  .authentication-main .auth-innerright {\n    min-height: unset;\n    padding: 0;\n  }\n  .loader-box {\n    justify-content: center;\n  }\n  .dataTables_wrapper .dataTables_length {\n    margin-bottom: 20px;\n  }\n  .dataTables_wrapper .dataTables_filter {\n    margin-left: 0;\n    margin-top: 0;\n    margin-bottom: 20px;\n  }\n  div.dataTables_wrapper div.dataTables_info {\n    padding-top: 0;\n  }\n  div.dataTables_wrapper div.dataTables_length label, div.dataTables_wrapper div.dataTables_filter label {\n    float: none;\n  }\n  div.dataTables_wrapper div.dataTables_paginate {\n    float: none;\n    margin-top: 20px !important;\n    margin-left: 0 !important;\n  }\n  .calendar-wrap .fc-basic-view .fc-day-number {\n    padding: 0 0px !important;\n  }\n  .calendar-wrap .fc-events-container {\n    margin-top: 0px;\n  }\n  .calendar-wrap .fc-events-container h6, .calendar-wrap .fc-events-container .h6,\n  .calendar-wrap .fc-events-container .checkbox {\n    text-align: right;\n  }\n  .calendar-wrap .checkbox label {\n    margin-top: 0;\n  }\n  .calendar-wrap .fc-toolbar .fc-left .fc-next-button .fc-icon-right-single-arrow:after {\n    font-size: 12px !important;\n  }\n  .calendar-wrap .fc-toolbar .fc-left .fc-prev-button .fc-icon-left-single-arrow:after {\n    font-size: 12px !important;\n  }\n  .calendar-wrap .fc-toolbar .fc-left .fc-today-button,\n  .calendar-wrap .fc-toolbar .fc-right .fc-today-button {\n    padding-top: 0px !important;\n  }\n  .calendar-wrap .fc button {\n    font-size: 14px !important;\n    padding: 0 5px !important;\n  }\n  .calendar-wrap .fc .fc-left {\n    margin-bottom: 10px;\n  }\n  .calendar-wrap .fc .fc-toolbar > div {\n    display: block !important;\n    float: none !important;\n  }\n  .calendar-wrap .fc .fc-toolbar > * :first-child {\n    font-size: 18px;\n  }\n  .calendar-wrap .fc .fc-toolbar > * > * {\n    float: none !important;\n  }\n  .calendar-wrap .fc {\n    margin-top: 0px;\n  }\n  .btn-group-wrapper {\n    text-align: center;\n  }\n  .btn-group-wrapper .m-b-30 {\n    margin-bottom: 15px !important;\n  }\n  .btn-group-showcase {\n    text-align: center;\n  }\n  .btn-group-showcase .btn-group {\n    margin-right: 0;\n    margin-bottom: 15px;\n  }\n  .btn-group .btn {\n    font-size: 14px;\n    padding: 0.375rem 1.3rem;\n  }\n  .animate-widget .text-center {\n    display: none;\n  }\n  .mega-menu .onhover-show-div {\n    height: 350px;\n  }\n  .page-builder .ge-canvas .column {\n    padding: 0 !important;\n  }\n  .page-builder .ge-content-type-ckeditor h3, .page-builder .ge-content-type-ckeditor .h3 {\n    font-size: 20px;\n  }\n  .page-builder .ge-content-type-ckeditor p {\n    font-size: 12px;\n  }\n  .page-builder .ge-row-icon {\n    display: none !important;\n  }\n  /* font-awesom icon page */\n  .icon-hover-bottom .form-group input {\n    min-width: 270px;\n  }\n  .user-profile .hovercard .cardheader {\n    height: 350px;\n  }\n  .user-profile .hovercard .info {\n    padding: 35px;\n  }\n  .user-profile .hovercard .info .ttl-info {\n    margin-bottom: 20px;\n  }\n  .user-profile .hovercard .info .ttl-sm-mb-0 {\n    margin-bottom: 0;\n  }\n  .calendar-wrap .fc button {\n    padding: 5px;\n  }\n  .calendar-wrap .fc-day-grid-event {\n    margin: 0;\n    padding: 5px;\n    width: inherit;\n  }\n  .calendar-wrap .fc-toolbar h2, .calendar-wrap .fc-toolbar .h2 {\n    font-size: 20px;\n    line-height: 35px;\n    font-weight: bold;\n  }\n  .calendar-wrap .basic-calendar .external-events {\n    margin-top: 0px;\n  }\n  .blog-single .comment-box .media h6, .blog-single .comment-box .media .h6 {\n    margin-bottom: 10px;\n  }\n  .blog-single .comment-box .media img {\n    margin-right: 30px;\n  }\n  .blog-single .comment-box .comment-social {\n    margin-bottom: 5px;\n  }\n  .blog-single .comment-box .comment-social li:first-child {\n    padding-left: 0;\n    padding-right: 15px;\n  }\n  .tabbed-card ul.border-tab {\n    margin-bottom: 15px;\n  }\n  .tabbed-card ul.border-tab.nav-tabs {\n    top: unset;\n  }\n  .tabbed-card ul.border-tab.nav-tabs .nav-item .nav-link {\n    padding: 5px 15px 10px;\n  }\n  .tabbed-card ul {\n    padding: 10px 0 5px 0;\n    position: relative;\n    width: 100%;\n    left: 0;\n  }\n  .search-page #image-links .info-block.m-t-30 {\n    margin-top: 0 !important;\n  }\n  .authentication-main .authentication-box {\n    width: 100%;\n  }\n  .authentication-main .auth-innerright {\n    display: inherit;\n  }\n  .map-chart .chart-container {\n    height: 300px;\n  }\n  .candidcahrt {\n    height: 250px;\n  }\n  .bar-chart-widget .earning-details i {\n    right: 0;\n  }\n  .serial-chart .chart-container {\n    height: 300px;\n  }\n  .bottom-content {\n    padding: 10px;\n  }\n  .bottom-content p {\n    font-size: 12px;\n  }\n  .stepwizard .stepwizard-row:before {\n    top: 17px;\n  }\n  .icon-hover-bottom .icon-popup {\n    display: block;\n  }\n  .icon-hover-bottom .icon-popup > .icon-last {\n    display: block;\n    margin-top: 15px;\n  }\n  .icon-hover-bottom .icon-popup > .icon-last .form-inline .form-group {\n    display: flex;\n  }\n  .icon-hover-bottom .icon-popup div .flag-icon {\n    width: 30px;\n    height: auto;\n  }\n  .icon-hover-bottom .form-group input {\n    display: block;\n    width: auto !important;\n  }\n  .footer-links {\n    text-align: center;\n  }\n  .footer-copyright {\n    text-align: center !important;\n  }\n  .jvector-map-height {\n    height: 150px;\n  }\n  .sm-left-text {\n    text-align: left !important;\n  }\n  [dir=rtl] .sm-left-text {\n    text-align: right !important;\n  }\n  .email-wrap .email-right-aside .email-content .email-top .d-flex {\n    padding-bottom: 0;\n  }\n  .email-wrap .email-right-aside .email-content .email-top .float-right {\n    float: left !important;\n  }\n  .email-wrap .email-right-aside .email-content .email-wrapper .attachment {\n    text-align: center;\n  }\n  .email-wrap .email-right-aside .email-content .email-wrapper .attachment ul li:last-child {\n    padding-right: 0;\n  }\n  .email-wrap .email-right-aside .email-content .email-wrapper .attachment ul li img {\n    width: 140px;\n    height: 140px;\n  }\n  .alert-dismissible p {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 294px;\n  }\n  .button-group-mb-sm {\n    margin-bottom: 5px;\n  }\n  .card-block .table-responsive .table tbody tr td span {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 100px;\n  }\n  .card-block .table-responsive .progress-content tbody tr td span {\n    text-overflow: ellipsis;\n    white-space: normal;\n    max-width: 50px;\n  }\n  .card-block .table-responsive .checkbox-td-width tbody tr td,\n  .card-block .table-responsive .radio-first-col-width tbody tr td {\n    min-width: 200px !important;\n  }\n  #batchDelete .jsgrid-grid-header .jsgrid-table .jsgrid-header-row .jsgrid-header-cell:first-child {\n    width: 119px !important;\n  }\n  #batchDelete .jsgrid-grid-body .jsgrid-table .jsgrid-row .jsgrid-cell:first-child {\n    width: 119px !important;\n  }\n  .jsgrid .jsgrid-pager-container {\n    text-align: center;\n  }\n  .chat-box .chat-right-aside .chat .chat-msg-box {\n    height: auto;\n  }\n  .chat-box .chat-menu .nav-tabs .nav-item {\n    width: 32.33%;\n  }\n  .chat-box .chat-menu .people-list ul.list {\n    max-height: 433px;\n    margin-bottom: 15px;\n  }\n  .chat-box .chat-menu #info-profile,\n  .chat-box .chat-menu #info-contact {\n    margin-bottom: 15px;\n  }\n  .hovercard .info .follow .text-md-right {\n    text-align: center;\n  }\n  .profile-img-style .like-comment-sm-mb {\n    margin-bottom: 20px;\n  }\n  .reset-password-box .theme-form .form-group .btn {\n    margin-top: 15px !important;\n  }\n  .lg-outer .lg-actions .lg-next,\n  .lg-outer .lg-actions .lg-prev {\n    top: 48%;\n  }\n  .feature-products .filter-toggle {\n    padding: 8px 15px;\n    background-color: #fff;\n    margin-left: 10px;\n    border-radius: 5px;\n  }\n  .feature-products .select2-drpdwn-product {\n    float: left;\n    margin-right: 10px;\n    margin-top: 8px;\n  }\n  [dir=rtl] .feature-products .select2-drpdwn-product {\n    float: right;\n    margin-right: unset;\n    margin-left: 10px;\n  }\n  .feature-products span.f-w-600 {\n    padding-top: 15px;\n    display: inline-block;\n  }\n  .feature-products .text-right {\n    text-align: left !important;\n  }\n  .d-none-productlist {\n    display: block;\n    margin-right: 10px;\n  }\n  .grid-options ul li {\n    display: none;\n  }\n  .product-sidebar {\n    transform: translateX(-300px) scaleX(0);\n    opacity: 0;\n    visibility: hidden;\n    transition: 0.3s;\n    height: 0;\n    position: absolute;\n    z-index: 3;\n    width: 300px;\n  }\n  .product-sidebar.open {\n    transform: translateX(0px) scaleX(1);\n    box-shadow: 1px 5px 24px 0 rgba(68, 102, 242, 0.05);\n    visibility: visible;\n    opacity: 1;\n    height: auto;\n    top: -45px;\n  }\n  .product-sidebar.open:before, .product-sidebar.open:after {\n    content: \"\";\n    position: absolute;\n    width: 0;\n    height: 0;\n    border-left: 7px solid transparent;\n    border-right: 7px solid transparent;\n    border-bottom: 7px solid #fff;\n    right: 120px;\n    top: -7px;\n  }\n  .product-sidebar .filter-section .card-header {\n    display: none;\n  }\n  .product-wrapper.sidebaron .product-grid .product-wrapper-grid {\n    margin-left: 0;\n  }\n  .product-wrapper.sidebaron .product-sidebar .filter-section .card .left-filter {\n    top: unset;\n    min-width: unset;\n  }\n  .product-wrapper-grid.list-view .product-box .product-img {\n    width: 42%;\n  }\n  .product-filter .product-box {\n    flex-wrap: nowrap;\n  }\n  .product-filter .product-box .product-img {\n    width: 100px;\n  }\n  .product-filter .product-box .product-details {\n    padding: 0 !important;\n  }\n}\n@media only screen and (max-width: 575.98px) {\n  .todo .todo-list-wrapper .mark-all-tasks .mark-all-tasks-container {\n    display: none;\n  }\n  .border-tab.nav-tabs {\n    display: block;\n  }\n  .page-wrapper .page-header .header-wrapper .search-full input {\n    padding-left: 30px;\n    line-height: 40px;\n  }\n  .page-wrapper .page-header .header-wrapper .search-full .form-group::before {\n    top: 14px;\n    left: 12px;\n  }\n  .page-wrapper .page-header .header-wrapper .search-full .form-group .close-search {\n    top: 18px;\n    right: 0;\n    width: 18px;\n    height: 18px;\n  }\n  .page-wrapper.only-body .page-header .header-wrapper .nav-right {\n    right: 30px;\n  }\n  .date-picker .theme-form > .row > div:last-child {\n    margin-top: 0;\n  }\n  .search-page .info-block {\n    display: block;\n  }\n  .form-bookmark .row > div .row > .col-sm-6 + .col-sm-6 {\n    margin-top: 10px;\n  }\n  .btn {\n    padding: 6px 16px;\n  }\n  .alert-theme {\n    min-width: 380px;\n  }\n  .knowledgebase-bg {\n    height: 250px;\n  }\n  .login-card .login-main .theme-form .or:before {\n    width: 55%;\n  }\n  .knowledgebase-search {\n    width: calc(100% - 30px);\n    left: 15px;\n    height: calc(100% - 30px);\n    background-color: rgba(255, 255, 255, 0.7);\n  }\n  .knowledgebase-search .form-inline {\n    width: 90%;\n    padding: 3px 45px;\n  }\n  .knowledgebase-search .form-inline svg {\n    top: 10px;\n  }\n  .knowledgebase-search > div {\n    width: 100%;\n    text-align: center;\n    padding: 15px;\n    border-right: 10px;\n  }\n  .knowledgebase-search > div h3, .knowledgebase-search > div .h3 {\n    font-size: 20px;\n    margin-bottom: 0;\n  }\n  .knowledgebase-search > div .form-group {\n    margin-bottom: 0;\n  }\n  .invoice .text-md-end {\n    margin-top: 10px;\n  }\n  .invoice .text-right {\n    text-align: right;\n  }\n  .invoice .text-xs-center {\n    text-align: center;\n  }\n  .login-card {\n    padding-top: 40px;\n    padding-bottom: 40px;\n  }\n  .login-card .logo {\n    margin-bottom: 10px;\n  }\n  .login-card .login-main {\n    width: auto;\n    padding: 20px;\n  }\n  .login-card .login-main .theme-form .form-group {\n    margin-bottom: 5px;\n  }\n  .login-card .login-main .theme-form p {\n    margin-bottom: 5px;\n  }\n  .login-card .btn-showcase .btn {\n    width: 100%;\n  }\n  .login-card .btn-showcase .btn + .btn {\n    margin-left: 0;\n    margin-top: 5px;\n  }\n  .bookmark ul li a svg {\n    height: 16px;\n    width: 16px;\n  }\n  .bookmark ul li + li {\n    margin-left: 5px;\n  }\n  .page-wrapper .page-header .header-wrapper .nav-right > ul > li {\n    padding: 4px 6px;\n  }\n  .page-header .header-wrapper .nav-right .cart-box .badge,\n  .page-header .header-wrapper .nav-right .notification-box .badge {\n    font-size: 10px;\n  }\n  .page-wrapper .page-body-wrapper .page-title > .row .col-6:first-child {\n    display: block;\n  }\n  .page-wrapper .page-body-wrapper .page-title > .row .col-6:first-child h3, .page-wrapper .page-body-wrapper .page-title > .row .col-6:first-child .h3 {\n    padding-right: 0;\n  }\n  .page-wrapper .page-header .header-wrapper .nav-right ul li i {\n    font-size: 14px !important;\n  }\n  .page-wrapper .page-header .header-wrapper .nav-right ul li svg {\n    width: 18px;\n  }\n  .page-wrapper .page-body-wrapper .page-title .breadcrumb {\n    margin-top: 0;\n  }\n  .page-wrapper.compact-wrapper .page-header .header-wrapper .logo-wrapper, .page-wrapper.compact-sidebar .page-header .header-wrapper .logo-wrapper {\n    display: none;\n  }\n  .page-wrapper.compact-wrapper .page-header .header-wrapper .toggle-sidebar, .page-wrapper.compact-sidebar .page-header .header-wrapper .toggle-sidebar {\n    margin-left: 0;\n    padding-left: 0;\n    border-left: none;\n    border-right: 1px solid #ddd;\n    padding-right: 8px;\n    margin-right: 8px;\n  }\n  .page-wrapper.compact-wrapper .page-header .header-wrapper .toggle-sidebar svg, .page-wrapper.compact-sidebar .page-header .header-wrapper .toggle-sidebar svg {\n    width: 18px;\n  }\n  .page-wrapper.compact-sidebar .sidebar-wrapper .back-btn {\n    display: none;\n  }\n  .page-wrapper.compact-sidebar .sidebar-wrapper .sidebar-main .sidebar-links > li {\n    margin-right: 0;\n  }\n  .page-wrapper .page-header .header-wrapper {\n    padding: 12px 15px !important;\n  }\n  .page-wrapper .page-header .header-wrapper .nav-right > ul {\n    top: 58px;\n  }\n  .page-wrapper .page-header .header-wrapper .nav-right > ul .search-form i {\n    display: none;\n  }\n  .page-wrapper .page-header .header-wrapper .nav-right.right-header ul li.px-0 {\n    padding: 6px !important;\n  }\n  .page-wrapper .page-header .header-wrapper .nav-right > ul li .flag-icon {\n    font-size: 14px !important;\n  }\n  .page-wrapper .page-header .header-wrapper .nav-right > ul li .profile-media img {\n    width: 25px;\n  }\n  .page-wrapper .page-header .header-wrapper .nav-right .notification-dropdown.onhover-show-div:before, .page-wrapper .page-header .header-wrapper .nav-right .notification-dropdown.onhover-show-div:after {\n    left: 24px !important;\n    right: unset !important;\n  }\n  .page-wrapper .page-body-wrapper .page-title .btn-group .btn {\n    padding: 8px 30px;\n  }\n  .page-wrapper.compact-wrapper .page-body-wrapper .page-body {\n    margin-top: 53px;\n  }\n  .page-wrapper.compact-wrapper .page-body-wrapper.sidebar-wrapper .sidebar-main .sidebar-links {\n    height: calc(100vh - 79px);\n  }\n  .alert-dismissible {\n    padding-right: 30px;\n  }\n  .alert-dismissible p {\n    max-width: 209px;\n  }\n  .customizer-links {\n    display: none;\n  }\n  .m-r-30 {\n    margin-right: 15px;\n  }\n  .wishlist .text-end {\n    text-align: left !important;\n  }\n  .add-post form .m-checkbox-inline label {\n    margin-right: 15px;\n  }\n  .add-post .dropzone {\n    margin-bottom: 15px;\n  }\n  .wizard-4 .msg-box {\n    top: 10px !important;\n  }\n  .wizard-4 .login-card .login-main {\n    width: 280px;\n  }\n  .wizard-4 .step-container div.content .wizard-title {\n    width: 280px;\n  }\n  .wizard-4 .action-bar {\n    right: 10px;\n  }\n  .wizard-4 .action-bar [dir=rtl] {\n    left: 10px;\n  }\n  .customers.avatar-group {\n    margin-right: 15px;\n  }\n  .vertical-mobile-sidebar {\n    top: 19px;\n  }\n  .alert-theme i {\n    margin-right: 10px !important;\n  }\n  .alert-theme button {\n    top: 0px !important;\n  }\n  .bar-chart-widget .earning-details i {\n    right: -30px;\n  }\n  .clockpicker-align-top {\n    left: 45px !important;\n    top: 406px !important;\n  }\n  .gallery {\n    margin-bottom: -15px;\n  }\n  .my-gallery figure {\n    margin-bottom: 15px;\n  }\n  .my-gallery figure:nth-child(9), .my-gallery figure:nth-child(10) {\n    margin-bottom: 15px;\n  }\n  .my-gallery.gallery-with-description figure:last-child {\n    margin-bottom: 20px;\n  }\n  #aniimated-thumbnials figure:nth-child(12), #aniimated-thumbnials figure:nth-child(11), #aniimated-thumbnials figure:nth-child(10), #aniimated-thumbnials figure:nth-child(9) {\n    margin-bottom: 15px;\n  }\n  .photoswipe-pb-responsive {\n    padding-bottom: 30px !important;\n  }\n  .avatar-showcase .pepole-knows {\n    text-align: center;\n  }\n  .avatar-showcase .pepole-knows ul li {\n    margin-right: 14px;\n  }\n  .social-app-profile .hovercard .user-image .avatar {\n    margin-top: -56px;\n  }\n  .social-app-profile .hovercard .user-image .avatar img {\n    width: 100px;\n    height: 100px;\n  }\n  .social-app-profile .hovercard .user-image .icon-wrapper {\n    left: 52%;\n    top: 10px;\n    height: 30px;\n    width: 30px;\n    font-size: 15px;\n  }\n  .social-app-profile .hovercard .user-image .icon-wrapper:hover {\n    font-size: 12px;\n  }\n  .social-app-profile .hovercard .user-image .share-icons {\n    right: 15px;\n  }\n  .social-app-profile .hovercard .user-image .share-icons li {\n    margin-right: 0px;\n  }\n  .social-app-profile .hovercard .info .tabs-scoial .user-designation {\n    border-top: none;\n    border-bottom: none;\n    margin-bottom: 0;\n    padding: 0px 0px;\n  }\n  .social-app-profile .tabs-scoial {\n    margin-bottom: 0 !important;\n  }\n  .socialprofile .social-btngroup {\n    margin: 15px 0;\n  }\n  .socialprofile .social-group {\n    margin-top: 15px;\n  }\n  .social-status form .form-group .form-control-social {\n    margin-bottom: 15px;\n  }\n  .social-status .media {\n    margin-bottom: 15px;\n  }\n  .new-users-social {\n    margin-bottom: 15px;\n  }\n  .tabs-scoial {\n    position: relative;\n    padding-top: 80px;\n  }\n  .tabs-scoial li:nth-child(3) {\n    position: absolute;\n    top: 25px;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n  }\n  .tabs-scoial.border-tab.nav-tabs .nav-item .nav-link {\n    padding: 10px;\n    height: 60px;\n  }\n  .timeline-content p,\n  .timeline-content .comments-box {\n    margin-top: 15px;\n  }\n  .timeline-content .comments-box .media .m-r-20 {\n    margin-right: 10px;\n  }\n  .timeline-content .comments-box .media .media-body .input-group .input-group-append .btn {\n    padding: 6px;\n  }\n  .timeline-content .comment-number i {\n    margin-right: 15px;\n  }\n  #cd-timeline {\n    margin-right: 0;\n  }\n  .social-chat {\n    margin-top: 15px;\n  }\n  .social-chat .media-body {\n    padding: 15px;\n  }\n  .social-chat .your-msg,\n  .social-chat .other-msg {\n    margin-bottom: 15px;\n  }\n  .social-network span {\n    margin-bottom: 15px;\n  }\n  .social-list .media {\n    margin-bottom: 15px;\n  }\n  .details-about + .details-about {\n    margin-top: 15px;\n  }\n  .your-details-xs {\n    margin-top: 15px;\n  }\n  .social-header h5 span.pull-right, .social-header .h5 span.pull-right {\n    float: right !important;\n    margin-top: 0 !important;\n  }\n  .social-header h5 span.pull-right svg, .social-header .h5 span.pull-right svg {\n    width: 18px;\n    height: 18px;\n  }\n  .activity-log .my-activity + .my-activity {\n    margin-top: 15px;\n  }\n  .photos ul li {\n    width: 26%;\n  }\n  .photos ul li:nth-child(3n) {\n    margin-right: 0;\n  }\n  .chat-box .chat-history .call-content > div {\n    padding-top: 30px;\n  }\n  .timeline-small .media {\n    margin-bottom: 15px;\n  }\n  .timeline-small .media .media-body h6, .timeline-small .media .media-body .h6 {\n    margin-bottom: 15px;\n  }\n  .timeline-small .media .timeline-round.timeline-line-1:after {\n    bottom: -39px;\n    height: 30px;\n  }\n  .timeline-small .media .timeline-round.small-line:after {\n    bottom: -17px;\n    height: 8px;\n  }\n  .timeline-small .media .timeline-round.medium-line:after {\n    bottom: -30px;\n    height: 22px;\n  }\n  .helper-classes {\n    padding: 15px;\n  }\n  .form-builder-2-header ul li {\n    text-align: left;\n  }\n  .form-builder-2-header .form-inline {\n    display: block;\n    width: 100%;\n  }\n  .form-builder-2-header .form-inline .form-group {\n    width: 100%;\n    margin-right: 0;\n  }\n  .form-builder-2-header .form-inline button {\n    width: 100%;\n    text-align: left;\n  }\n  .page-builder .btn-grid {\n    margin-bottom: 7px;\n    padding-right: 5px;\n  }\n  .page-builder .ge-canvas.ge-editing .row {\n    padding: 15px;\n  }\n  .page-builder .ge-canvas.ge-editing .ge-tools-drawer {\n    margin: 10px;\n  }\n  .page-builder .ge-canvas.ge-layout-desktop [class*=col-] {\n    width: inherit !important;\n  }\n  .wizard-4 .step-container div.content {\n    margin-top: 10px;\n  }\n  .nav-tabs .nav-item.show .nav-link {\n    border-top: 0;\n    border-bottom: 0;\n  }\n  .nav-tabs .nav-link {\n    border-top: 0;\n    border-bottom: 0;\n  }\n  .nav-tabs .nav-link:hover, .nav-tabs .nav-link.active, .nav-tabs .nav-link:focus {\n    border-top: 0;\n    border-bottom: 0;\n  }\n  .border-tab.nav-tabs .nav-item {\n    width: 100% !important;\n  }\n  .border-tab .ecommerce-widget .progress-showcase {\n    margin-top: 15px;\n  }\n  .nav {\n    display: inherit;\n    text-align: center;\n    border-bottom: none;\n  }\n  .editor_container .CodeMirror {\n    min-height: 190px;\n    height: 190px;\n  }\n  .order-history table.dataTable.table thead th {\n    padding-right: 60px;\n  }\n  .border-tab.nav-left .nav-link {\n    text-align: center;\n    border-left: none;\n  }\n  .border-tab.nav-right .nav-link {\n    text-align: center;\n    border-right: none;\n  }\n  .border-tab.nav-tabs {\n    margin-bottom: 10px;\n  }\n  .tab-content ~ .nav-tabs.border-tab {\n    margin-top: 10px;\n  }\n  .nav-pills {\n    text-align: center;\n  }\n  .crm-overall {\n    margin: 0 -15px -15px;\n  }\n  .product-color li {\n    width: 15px;\n    height: 15px;\n  }\n  .product-social li a {\n    width: 30px;\n    height: 30px;\n    font-size: 13px;\n  }\n  .product-social li:nth-child(n+2) {\n    margin-left: 5px;\n  }\n  [dir=rtl] .product-social li:nth-child(n+2) {\n    margin-left: unset;\n    margin-right: 5px;\n  }\n  .product-page-main {\n    padding: 15px;\n  }\n  .product-page-main .product-page-details h3, .product-page-main .product-page-details .h3 {\n    font-size: 24px;\n  }\n  .todo .action-box.large {\n    height: 25px;\n    width: 25px;\n  }\n  .todo .action-box.large .icon {\n    font-size: 14px;\n    vertical-align: -3px;\n  }\n  .todo .todo-list-wrapper #todo-list li .task-container .task-label {\n    font-size: 14px;\n  }\n  .todo .todo-list-wrapper .mark-all-tasks {\n    right: 15px;\n  }\n  .datetime-picker label {\n    text-align: left !important;\n  }\n  .redial-chart-block {\n    text-align: center;\n  }\n  #nav-tabContent {\n    margin-top: 15px;\n  }\n  .reset-password-box {\n    width: 430px;\n  }\n  .auth-bg {\n    padding: 25px 15px;\n  }\n  .auth-bg-effect {\n    display: none;\n  }\n  .date-picker .text-right {\n    text-align: left !important;\n  }\n  .dataTables_wrapper table.dataTable {\n    margin-bottom: 15px !important;\n  }\n  ul.pagination li:before {\n    line-height: 3;\n  }\n  div.table-responsive > div.dataTables_wrapper > div.row > div[class^=col-]:last-child {\n    padding-left: 0 !important;\n  }\n  div.table-responsive > div.dataTables_wrapper > div.row > div[class^=col-]:first-child {\n    padding-right: 0 !important;\n  }\n  div.dataTables_wrapper div.dataTables_length {\n    margin-bottom: 15px;\n  }\n  div.dataTables_wrapper div.dataTables_length select {\n    min-height: 30px;\n  }\n  div.dataTables_wrapper table.dataTable th,\n  div.dataTables_wrapper table.dataTable td {\n    padding: 0.5rem;\n  }\n  div.dataTables_wrapper div.dataTables_paginate {\n    margin-top: 15px !important;\n  }\n  div.dataTables_wrapper div.dataTables_paginate .paginate_button {\n    padding: 1px 7px;\n  }\n  div.dataTables_wrapper div.dataTables_paginate .paginate_button.previous {\n    font-size: 0;\n    padding: 0;\n  }\n  div.dataTables_wrapper div.dataTables_paginate .paginate_button.previous a {\n    border: none !important;\n  }\n  div.dataTables_wrapper div.dataTables_paginate .paginate_button.previous:before {\n    content: \"\\e64a\";\n    font-family: themify;\n    font-size: 11px;\n    padding: 0 5px;\n  }\n  div.dataTables_wrapper div.dataTables_paginate .paginate_button.next {\n    font-size: 0;\n    padding: 0;\n  }\n  div.dataTables_wrapper div.dataTables_paginate .paginate_button.next a {\n    border: none !important;\n  }\n  div.dataTables_wrapper div.dataTables_paginate .paginate_button.next:before {\n    content: \"\\e649\";\n    font-family: themify;\n    font-size: 11px;\n    padding: 0 5px;\n  }\n  div.dataTables_wrapper .dataTables_filter {\n    margin-bottom: 15px;\n  }\n  div.dataTables_wrapper .dataTables_filter input[type=search] {\n    height: 30px;\n  }\n  .page-wrapper .page-body-wrapper .user-profile .profile-img-style {\n    padding: 15px;\n  }\n  .page-wrapper .page-body-wrapper .user-profile .profile-img-style .img-container {\n    margin-top: 15px;\n  }\n  .page-wrapper .page-body-wrapper .user-profile hr {\n    margin: 15px 0;\n  }\n  .page-wrapper .page-body-wrapper .user-profile .like-comment {\n    margin-top: 15px;\n  }\n  .jvector-map-height {\n    height: 250px;\n  }\n  .user-profile .order-sm-0 {\n    order: -1;\n  }\n  .user-profile .hovercard .info .ttl-info {\n    text-align: center !important;\n  }\n  .user-profile .hovercard .info .ttl-xs-mt {\n    margin-top: 20px;\n  }\n  .icon-hover-bottom .form-group {\n    display: block !important;\n    margin-bottom: 0;\n  }\n  .icon-hover-bottom .form-group input {\n    width: 100% !important;\n  }\n  .icon-hover-bottom .form-group .btn {\n    margin-top: 15px;\n  }\n  .icon-hover-bottom .icon-popup {\n    padding: 15px;\n  }\n  .icon-hover-bottom svg.climacon {\n    height: 50px;\n    width: 50px;\n  }\n  .blog-box.blog-shadow:before {\n    box-shadow: inset 0px -100px 100px -13px rgba(0, 0, 0, 0.6);\n  }\n  .blog-box .blog-details p,\n  .blog-box .blog-details .single-blog-content-top {\n    margin-top: 15px;\n  }\n  .blog-box .blog-details h4, .blog-box .blog-details .h4 {\n    margin-top: 15px;\n  }\n  .blog-box .blog-details .blog-social {\n    margin-top: 15px;\n  }\n  .blog-box .blog-details .blog-social li + li {\n    padding-left: 20px;\n  }\n  .blog-box .blog-details .blog-social li + li > span {\n    display: none;\n  }\n  .blog-box .blog-details .blog-social li:first-child {\n    margin-right: 10px;\n    padding-right: 20px;\n  }\n  .comment-box {\n    padding-top: 40px;\n    padding-bottom: 40px;\n  }\n  .comment-box ul ul {\n    margin-left: 30px;\n  }\n  .comment-box li .media {\n    display: block;\n  }\n  .comment-box li .media img {\n    height: 50px;\n    width: 50px;\n    padding: 3px;\n    margin-bottom: 10px;\n  }\n  .ace-editor {\n    height: 320px;\n  }\n  .gallery > a {\n    margin-bottom: 15px;\n    text-align: center;\n  }\n  .card .card-header h5, .card .card-header .h5 {\n    font-size: 17px;\n  }\n  .theme-form .form-group {\n    margin-bottom: 15px;\n  }\n  .page-wrapper .page-body-wrapper .default-according .card .card-header,\n  .page-wrapper .page-body-wrapper .default-according .card .card-body,\n  .page-wrapper .page-body-wrapper .default-according .card .card-footer {\n    padding: 0.75rem 1.25rem;\n  }\n  .page-wrapper .page-body-wrapper .card {\n    margin-bottom: 20px;\n  }\n  .page-wrapper .page-body-wrapper .card .card-header .tab-content .m-t-30,\n  .page-wrapper .page-body-wrapper .card .card-body .tab-content .m-t-30,\n  .page-wrapper .page-body-wrapper .card .card-footer .tab-content .m-t-30 {\n    margin-top: 20px !important;\n  }\n  .page-wrapper .page-body-wrapper .card .card-header .tab-content .m-b-30,\n  .page-wrapper .page-body-wrapper .card .card-body .tab-content .m-b-30,\n  .page-wrapper .page-body-wrapper .card .card-footer .tab-content .m-b-30 {\n    margin-bottom: 20px !important;\n  }\n  .page-wrapper .page-body-wrapper .page-body {\n    padding: 0 !important;\n  }\n  .page-wrapper .page-body-wrapper .page-title {\n    padding-top: 15px;\n    padding-bottom: 15px;\n    margin: 0 -12px 30px !important;\n  }\n  .page-wrapper .page-body-wrapper .page-title .row h3, .page-wrapper .page-body-wrapper .page-title .row .h3 {\n    font-size: 20px;\n  }\n  /* alert responsive css start here */\n  .alert-primary.inverse {\n    background-color: transparent;\n  }\n  .alert-secondary.inverse {\n    background-color: transparent;\n  }\n  .alert-success.inverse {\n    background-color: transparent;\n  }\n  .alert-danger.inverse {\n    background-color: transparent;\n  }\n  .alert-warning.inverse {\n    background-color: transparent;\n  }\n  .alert-info.inverse {\n    background-color: transparent;\n  }\n  .alert-light.inverse {\n    background-color: transparent;\n  }\n  .alert-dark.inverse {\n    background-color: transparent;\n  }\n  .alert .close {\n    height: 100%;\n  }\n  .user-profile hr {\n    margin: 15px 0;\n  }\n  .user-profile .hovercard .cardheader {\n    height: 300px;\n  }\n  .user-profile .hovercard .info {\n    padding: 20px;\n  }\n  .user-profile .hovercard .info .user-designation {\n    border-top: 1px solid #f4f4f4;\n    border-bottom: 1px solid #f4f4f4;\n    margin-bottom: 15px;\n    padding: 15px 0px;\n  }\n  .user-profile .hovercard .social-media a {\n    margin-right: 0px;\n    font-size: 16px;\n  }\n  .user-profile .hovercard .follow .follow-num {\n    font-size: 20px;\n  }\n  .user-profile .profile-img-style .pictures img {\n    margin-bottom: 10px;\n  }\n  .custom-card .card-footer > div h6, .custom-card .card-footer > div .h6 {\n    font-size: 14px;\n    font-weight: 600;\n  }\n  .custom-card .card-footer > div h3, .custom-card .card-footer > div .h3 {\n    font-size: 24px;\n  }\n  .calendar-wrap .fc-toolbar .fc-center {\n    margin-top: 10px;\n  }\n  .calendar-wrap a.fc-more {\n    font-size: 0.7em;\n  }\n  .mega-inline {\n    display: block;\n  }\n  .megaoptions-border-space-sm {\n    padding-bottom: 30px !important;\n  }\n  .blog-box.blog-shadow .blog-details {\n    padding: 15px;\n  }\n  .blog-box.blog-shadow .blog-details p {\n    margin-bottom: 0;\n  }\n  .blog-box.blog-shadow .blog-details h4, .blog-box.blog-shadow .blog-details .h4 {\n    margin-bottom: 10px;\n  }\n  .blog-box.blog-list .blog-details {\n    padding-top: 0;\n  }\n  .blog-box .blog-details {\n    padding: 20px;\n  }\n  .blog-box .blog-date span {\n    font-size: 25px;\n  }\n  .blog-single .blog-box .blog-details {\n    padding: 0;\n  }\n  .error-wrapper {\n    padding: 20px 0;\n  }\n  .error-wrapper .btn {\n    margin-top: 15px;\n  }\n  .error-wrapper .img-100 {\n    width: 50px !important;\n  }\n  .error-wrapper .error-heading {\n    margin-top: 20px;\n  }\n  .error-wrapper .error-heading .cloud-second {\n    margin-top: -60px;\n  }\n  .error-wrapper .error-heading .headline {\n    font-size: 150px;\n  }\n  .error-wrapper .maintenance-heading .cloud-second {\n    display: none;\n  }\n  .error-wrapper .maintenance-heading .headline {\n    font-size: 25px;\n    margin-top: -10%;\n    letter-spacing: 2px;\n  }\n  .comingsoon .comingsoon-inner .coming-soon-bottom-link {\n    margin-top: 20px;\n    line-height: 1;\n  }\n  .comingsoon .comingsoon-inner h5, .comingsoon .comingsoon-inner .h5 {\n    margin-bottom: 20px;\n    margin-top: 20px;\n  }\n  .comingsoon .comingsoon-inner .countdown {\n    padding: 20px 0px;\n  }\n  .comingsoon .comingsoon-inner .countdown ul li {\n    margin: 0 7px;\n  }\n  .comingsoon .comingsoon-inner .countdown .title {\n    font-size: 12px;\n  }\n  .comingsoon .comingsoon-inner .countdown .time {\n    width: 45px;\n    height: 45px;\n    line-height: 45px;\n    font-size: 16px;\n    margin: 0 auto;\n  }\n  .form-wizard .btn-mb {\n    margin-bottom: 15px;\n  }\n  .stepwizard {\n    margin-bottom: 15px;\n  }\n  .f1 .f1-steps {\n    margin-top: 15px;\n    margin-bottom: 15px;\n  }\n  .wizard-4 ul.anchor {\n    width: 100%;\n    padding-bottom: 15px;\n  }\n  .wizard-4 .step-container {\n    width: 100%;\n  }\n  .status-widget .text-sm-right {\n    text-align: right;\n  }\n  .mega-menu {\n    padding-left: 15px;\n  }\n  .mega-menu .onhover-show-div {\n    height: 405px;\n    left: 0;\n    top: 61px;\n    padding: 15px;\n  }\n  .mega-menu .lg-mt {\n    margin-top: 10px;\n  }\n  .mega-menu .xs-mt {\n    margin-top: 15px;\n  }\n  .nav-md-mt {\n    margin-top: 15px;\n  }\n  .navs-icon {\n    padding: 15px;\n  }\n  .navs-icon .main-section {\n    padding-top: 15px;\n  }\n  .navs-icon .separator {\n    margin: 15px 0;\n  }\n  .nav-list {\n    padding: 15px;\n  }\n  .navs-dropdown button {\n    margin-top: 15px;\n  }\n  .navs-dropdown .onhover-show-div {\n    top: 64px;\n  }\n  .lg-mt {\n    margin-top: 15px;\n  }\n  #aniimated-thumbnials a:last-child img {\n    margin-bottom: 15px;\n  }\n  .tilt-showcase .mt-4 {\n    margin-top: 15px !important;\n  }\n  .tilt-showcase ol .m-b-20 {\n    margin-bottom: 15px !important;\n  }\n  .xs-mt {\n    margin-top: 15px;\n  }\n  span:last-child.tag-pills-sm-mb {\n    margin-top: 3px;\n  }\n  .animated-modal .form-group .form-control {\n    width: 50%;\n    margin: 0 auto;\n  }\n  .animated-modal .animated-modal-md-mb {\n    margin-bottom: 15px !important;\n  }\n  .steps-md-mt {\n    margin-top: 15px;\n  }\n  .steps-sizing-sm-mb {\n    margin-bottom: 15px;\n  }\n  .bootstrap-touchspin .touchspin-vertical-tab .input-group {\n    width: 96% !important;\n  }\n  #API-chield-row_wrapper #API-chield-row tbody tr td:first-child {\n    min-width: 20px;\n  }\n  .chart-block .flot-chart-container p#choices {\n    width: 100%;\n  }\n  .chart-block .flot-chart-container #toggling-series-flot {\n    width: 100% !important;\n  }\n  .click2edit ~ .note-editor.note-frame {\n    margin-bottom: 15px;\n  }\n  .ecommerce-widget .progress-showcase {\n    margin-top: 15px;\n  }\n  .reset-password-box .theme-form .form-group .btn {\n    margin-top: 13px !important;\n  }\n  .gallery-with-description a > div {\n    margin-bottom: 15px;\n  }\n  .gallery-img-mb-sm {\n    margin-bottom: 15px;\n  }\n  .xm-mb-peity {\n    margin-bottom: 8px;\n  }\n  .authentication-main {\n    padding: 30px 15px;\n  }\n  .translate_wrapper.active .more_lang:before, .translate_wrapper.active .more_lang:after {\n    display: none;\n  }\n  .translate_wrapper.active .more_lang.active {\n    position: fixed;\n    width: calc(100vw - 30px);\n    left: 15px;\n    top: 60px;\n  }\n  .onhover-dropdown:hover .onhover-show-div {\n    opacity: 0;\n    transform: none;\n    visibility: hidden;\n  }\n  .onhover-dropdown:hover .onhover-show-div.active {\n    opacity: 1;\n    transform: translateY(0px);\n    visibility: visible;\n    border-radius: 5px;\n    overflow: hidden;\n  }\n  .page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div {\n    width: calc(100vw - 30px);\n    position: fixed;\n    top: 60px;\n    right: 12px;\n  }\n  .page-wrapper .page-header .header-wrapper .nav-right .notification-dropdown {\n    width: calc(100vw - 30px);\n    position: fixed;\n    top: 60px;\n    left: 15px !important;\n  }\n  .page-wrapper .page-header .header-wrapper .nav-right .cart-dropdown {\n    left: 15px;\n  }\n  .page-wrapper .page-header .header-wrapper .nav-right .profile-dropdown {\n    top: 43px;\n  }\n  .wizard-4 .action-bar .btn {\n    margin: 0 2px;\n  }\n  .tabbed-card ul {\n    right: 0px;\n    left: unset;\n  }\n  .dropdown-basic .btn-group {\n    margin-right: unset;\n  }\n}\n@media only screen and (max-width: 480px) {\n  .page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div {\n    width: 280px;\n  }\n  .page-wrapper.only-body .page-header .header-wrapper .nav-right {\n    display: none;\n  }\n  .chat-menu {\n    top: 120px;\n  }\n  .product-wrapper-grid.list-view .product-box {\n    display: block;\n  }\n  .product-wrapper-grid.list-view .product-box .product-img {\n    width: 100%;\n  }\n  .jkanban-container .kanban-container .kanban-drag .react-kanban-board {\n    justify-content: center;\n  }\n  .jkanban-container .kanban-container .kanban-drag > div > div {\n    justify-content: center;\n  }\n  .datetime-picker .react-datepicker__month-container,\n  .datetime-picker .react-datepicker__time-container {\n    width: 100%;\n  }\n  .datetime-picker .react-datepicker__time-container {\n    border-left: 1px solid #efefef;\n  }\n  .datetime-picker .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {\n    width: 100%;\n  }\n  .datetime-picker .react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {\n    right: 1px;\n  }\n  .cal-date-widget .react-datepicker {\n    padding: 0;\n  }\n  .cal-date-widget .react-datepicker__navigation.react-datepicker__navigation--previous {\n    left: 0;\n  }\n  .cal-date-widget .react-datepicker__navigation.react-datepicker__navigation--next {\n    right: 0;\n  }\n  .jkanban-container .kanban-container .kanban-board {\n    width: 100%;\n  }\n  .pagination-lg .page-link {\n    font-size: 1rem;\n  }\n  h6, .h6 {\n    font-size: 14px;\n  }\n  .prooduct-details-box .media-body {\n    margin-left: 0rem !important;\n  }\n  .knob-block .chart-clock-main {\n    margin: auto;\n    width: auto;\n  }\n  .knob-block .chart-clock-main .clock-medium {\n    position: absolute;\n    left: 33px;\n    top: 33px;\n  }\n  .knob-block .chart-clock-main .clock-medium canvas {\n    width: 180px !important;\n    height: 180px !important;\n  }\n  .knob-block .chart-clock-main .clock-small {\n    left: 34px;\n    top: 74px;\n  }\n  .knob-block .chart-clock-main .clock-large {\n    left: 0;\n    top: 0;\n    margin: 0 auto;\n  }\n  .knob-block .chart-clock-main .clock-large canvas {\n    width: 245px !important;\n    height: 245px !important;\n  }\n  .knob-block > div:not(.chart-clock-main) canvas {\n    width: 245px !important;\n    height: 245px !important;\n  }\n  .wizard-4 .action-bar .btn {\n    width: 100%;\n  }\n  .wizard-4 .action-bar .btn + .btn {\n    margin-top: 10px;\n  }\n  ul.notification-dropdown.onhover-show-div {\n    width: 260px;\n    right: -80px;\n  }\n  ul.notification-dropdown.onhover-show-div:before, ul.notification-dropdown.onhover-show-div:after {\n    right: 89px !important;\n  }\n  .inline-block-sm {\n    display: inline-block;\n  }\n  .pagination-lg .page-link {\n    padding: 0.3rem 0.65rem;\n  }\n  .nav-pills li {\n    width: 100%;\n  }\n  .reset-password-box {\n    width: 290px;\n  }\n  .icon-hover-bottom .icon-first {\n    margin-right: 10px;\n  }\n  .icon-hover-bottom .icon-popup .icon-class {\n    display: none;\n  }\n  .error-wrapper .maintenance-heading {\n    margin-top: 0;\n  }\n  .custom-card {\n    padding: 0;\n  }\n  .custom-card .card-footer > div h3, .custom-card .card-footer > div .h3 {\n    font-size: 20px;\n  }\n  .custom-card .card-social li {\n    padding: 5px 0;\n  }\n  .custom-card .profile-details h6, .custom-card .profile-details .h6 {\n    margin-bottom: 15px;\n  }\n  .custom-card .profile-details h4, .custom-card .profile-details .h4 {\n    font-size: 20px;\n  }\n  .custom-card .card-profile img {\n    height: 93px;\n  }\n  .card .card-header .card-header-right i {\n    margin: 0 3px;\n    font-size: 14px;\n  }\n  .card .card-header > span + span {\n    display: none;\n  }\n  .timeline-small .media .timeline-round.timeline-line-1:after {\n    bottom: -50px;\n  }\n  .timeline-small .media .timeline-round.medium-line:after {\n    bottom: -40px;\n  }\n  .dropdown-basic {\n    text-align: center;\n  }\n  .dropup-basic {\n    text-align: center;\n  }\n  .blog-box.blog-shadow .blog-details {\n    padding: 10px;\n  }\n  .blog-box.blog-shadow .blog-details h4, .blog-box.blog-shadow .blog-details .h4 {\n    font-size: 14px;\n  }\n  .stepwizard .stepwizard-row:before {\n    top: 17px;\n  }\n  .stepwizard .stepwizard-row .stepwizard-step .btn {\n    padding: 6px 22px;\n  }\n  .email-wrap .email-right-aside .email-content .email-wrapper .attachment ul li img {\n    width: 83px;\n    height: 83px;\n  }\n  .mega-menu {\n    padding-left: 20px;\n    padding-top: 3px;\n  }\n  .mega-menu .onhover-show-div {\n    height: 405px;\n    left: 0;\n    top: 61px;\n    padding: 15px;\n  }\n  .badge {\n    padding: 0.42em 0.7em;\n  }\n  .alert-dismissible .close {\n    top: -1px;\n  }\n  .alert-dismissible .close span {\n    font-size: 19px;\n  }\n  .notify-alert {\n    width: 90%;\n  }\n  .chat-box .chat-right-aside .chat .chat-header {\n    display: block;\n  }\n  .chat-box .chat-right-aside .chat .chat-header .chat-menu-icons {\n    margin-top: 15px;\n    padding-left: 10px;\n  }\n}\n@media only screen and (max-width: 420px) {\n  .product-sidebar.open {\n    top: -75px;\n  }\n  .alert-theme {\n    font-size: 12px;\n    min-width: 300px;\n  }\n  .alert-theme button {\n    right: 30px !important;\n  }\n  .alert-theme i {\n    display: none;\n  }\n  .alert-theme span + span + span {\n    padding: 15px;\n  }\n  .and-many-more {\n    font-size: 37px;\n  }\n  .tabbed-card ul.border-tab.nav-tabs .nav-item .nav-link {\n    padding: 5px 15px 8px;\n  }\n  .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper > div {\n    width: 112px;\n  }\n  .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu,\n  .page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container {\n    left: 112px;\n    width: 190px;\n  }\n  .page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper > div {\n    width: 80px;\n  }\n  .page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .sidebar-submenu,\n  .page-wrapper.compact-small .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links li .mega-menu-container {\n    left: 80px;\n    width: 210px;\n  }\n  .login-card .login-main .theme-form .link {\n    position: unset;\n  }\n}\n@media only screen and (max-width: 360px) {\n  .product-box .modal .modal-header .product-box .product-details .product-qnty fieldset .input-group {\n    width: 45%;\n  }\n  .cal-date-widget.card-body {\n    padding: 14px !important;\n  }\n  .cal-date-widget .react-datepicker {\n    min-height: 290px;\n  }\n  .cal-date-widget .cal-datepicker .datepicker-here .react-datepicker__day {\n    line-height: 2rem;\n  }\n  .cal-date-widget .cal-datepicker .datepicker-here .react-datepicker__time-name {\n    line-height: 2rem;\n  }\n  .prooduct-details-box .close {\n    right: 0;\n    top: 5px;\n  }\n  .prooduct-details-box .btn {\n    padding: 4px 8px;\n  }\n  .prooduct-details-box .media {\n    padding: 15px;\n    display: block;\n  }\n  .prooduct-details-box .media .media-body {\n    margin-top: 15px;\n  }\n  .datepicker--nav-action {\n    width: 20px;\n    margin-left: -10px;\n    background-color: transparent;\n  }\n  .datepicker--nav-action path {\n    stroke: var(--theme-default);\n  }\n  .clockpicker-align-top {\n    top: 426px !important;\n  }\n  .note {\n    min-width: 250px;\n  }\n  .datepicker {\n    width: 239px;\n  }\n  .add-post form .m-checkbox-inline label {\n    margin-bottom: 8px;\n  }\n  .add-post form .m-checkbox-inline label:last-child {\n    margin-bottom: 0;\n  }\n  .map-js-height {\n    height: 250px;\n  }\n  .bar-chart-widget .earning-details i {\n    right: -73px;\n  }\n  .status-widget svg {\n    width: 18px;\n    height: 18px;\n  }\n  .tabs-scoial.border-tab.nav-tabs .nav-item .nav-link {\n    padding: 10px 5px;\n    font-size: 14px;\n  }\n  .user-profile .hovercard .user-image .share-icons {\n    right: 6px;\n    top: -15px;\n  }\n  .user-profile .hovercard .user-image .share-icons li .social-icon {\n    width: 25px;\n    height: 25px;\n  }\n  .user-profile .hovercard .user-image .share-icons li .social-icon i {\n    font-size: 14px;\n  }\n  .social-chat .other-msg {\n    margin-left: 15px;\n  }\n  .social-header h5 span.pull-right, .social-header .h5 span.pull-right {\n    display: none;\n  }\n  .timeline-small .media .timeline-round.timeline-line-1:after {\n    bottom: -74px;\n    height: 56px;\n  }\n  .timeline-small .media .timeline-round.small-line:after {\n    bottom: -32px;\n    height: 14px;\n  }\n  .timeline-small .media .timeline-round.medium-line:after {\n    bottom: -59px;\n    height: 40px;\n  }\n  .timeline-small .media .media-body p {\n    display: -webkit-box;\n    text-overflow: ellipsis;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    -webkit-line-clamp: 4;\n  }\n  .custom-card .dashboard-card {\n    padding-top: 0;\n  }\n  .custom-card .card-profile img {\n    bottom: 25px;\n  }\n  .custom-card .card-footer > div h6, .custom-card .card-footer > div .h6 {\n    font-size: 12px;\n  }\n  .flot-chart-container {\n    height: 230px;\n  }\n  .map-block {\n    height: 250px;\n  }\n  .img-cropper .docs-tooltip {\n    font-size: 11px;\n  }\n  .img-cropper .docs-toggles .btn-group .btn {\n    padding: 0.375rem 0.2rem;\n  }\n  .blog-box .blog-details p {\n    line-height: 1.5;\n  }\n  .blog-box .blog-details .blog-social li:last-child {\n    padding-left: 0;\n  }\n  .blog-box .blog-details-main .blog-social li {\n    padding: 0 10px;\n  }\n  .button-builder-wrap .btn-lg, .button-builder-wrap .btn-group-lg > .btn {\n    font-size: 18px;\n  }\n  .tabs-responsive-side {\n    max-width: 100%;\n  }\n  .browser-widget .media i {\n    font-size: 52px;\n  }\n  .browser-widget .media .media-body h4, .browser-widget .media .media-body .h4 {\n    font-size: 20px;\n  }\n  .bar-chart-widget .bottom-content .num {\n    font-size: 17px;\n  }\n  .search-page .theme-form .input-group .form-control-plaintext {\n    padding-left: 10px;\n  }\n  .search-page .theme-form .input-group .btn {\n    padding: 6px 4px;\n  }\n  .search-page .info-block {\n    padding: 20px;\n  }\n  .stepwizard .stepwizard-row .stepwizard-step .btn {\n    padding: 6px 20px;\n  }\n  .wizard-4 ul.anchor {\n    padding-top: 15px;\n  }\n  .wizard-4 .msg-box {\n    top: 40px !important;\n  }\n  .xs-width-100 {\n    min-width: 100%;\n  }\n  .email-wrap .action-wrapper .actions li {\n    margin-right: 5px;\n  }\n  .email-wrap .email-body .attachment .list-inline .list-inline-item {\n    padding-right: 5px;\n  }\n  .email-wrap .email-right-aside .email-content .email-wrapper .attachment ul li img {\n    width: 65px;\n    height: 65px;\n  }\n  .email-wrap .email-right-aside .email-top .dropdown-menu {\n    left: -58px;\n  }\n  .form-builder #components .component .form-group #button1id {\n    margin-bottom: 15px;\n  }\n  .default-according .card .card-header i {\n    font-size: 14px;\n    top: 24px;\n  }\n  .default-according .card .btn-link {\n    display: block;\n    width: 100%;\n    padding-left: 17px;\n  }\n  .star-ratings .stars .title {\n    line-height: 1;\n  }\n  .user-profile .hovercard .social-media a {\n    padding: 0 6px;\n  }\n  .bootstrap-touchspin .touchspin-vertical-tab .input-group {\n    width: 93% !important;\n  }\n  .step-container {\n    height: 280px !important;\n  }\n  .sort-panel .d-inline .btn {\n    margin-left: 87px;\n  }\n  .jsgrid .jsgrid-pager-container .jsgrid-pager .jsgrid-pager-page {\n    padding: 0.5em 0.62em;\n  }\n  .chat-box .chat-right-aside {\n    flex: 0 0 96%;\n    max-width: 96%;\n  }\n  .chat-box .chat-right-aside .chat .chat-message {\n    width: calc(100% - 20px);\n  }\n  .error-wrapper .error-heading .headline {\n    font-size: 100px;\n  }\n  .lg-toolbar .lg-icon {\n    width: 40px;\n  }\n  .calendar-wrap a.fc-more {\n    font-size: 0.59em;\n  }\n  .calendar-wrap .fc th {\n    font-size: 10px;\n  }\n  .modal-footer {\n    display: block;\n    text-align: center;\n  }\n  .modal-footer button:first-child {\n    margin-bottom: 10px;\n  }\n  .order-box .qty li {\n    font-size: 14px;\n  }\n  .order-box .qty li span {\n    font-size: 14px;\n  }\n  .order-box ul li span {\n    text-align: right;\n  }\n  .order-box ul li label {\n    text-align: right;\n    font-size: 14px;\n  }\n  .order-box .sub-total li .count {\n    font-size: 14px;\n  }\n  .checkout .text-end {\n    text-align: left !important;\n    margin-top: 15px;\n  }\n}\n@media only screen and (min-width: 576px) {\n  .product-wrapper-grid.list-view .col-sm-6 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .sidebar-wrapper .back-btn {\n    display: none;\n  }\n}\n@media (width: 768px) and (height: 1024px) {\n  .page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper .sidebar-main .sidebar-links {\n    height: calc(100vh - 210px);\n  }\n}\n/**=====================\n     62. Responsive CSS Ends\n==========================**/\n.jsgrid-filter-row select,\n.jsgrid-filter-row input {\n  padding: 6px 10px;\n  border: 1px solid #f2f4ff;\n  background: #fff;\n}\n\n.popover {\n  background-color: #fff;\n  border: none;\n  -webkit-box-shadow: 0 0 20px rgba(115, 102, 255, 0.1);\n  box-shadow: 0 0 20px rgba(115, 102, 255, 0.1);\n}\n.popover .popover-header {\n  background-color: #eae8ff;\n  color: #7366ff;\n  border-bottom: none;\n}\n.popover .popover-body {\n  color: rgba(43, 43, 43, 0.7);\n}\n\n.tooltip.bs-tooltip-top .tooltip-arrow:before, .tooltip.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow:before {\n  border-top-color: #eae8ff;\n}\n.tooltip.bs-tooltip-bottom .tooltip-arrow:before, .tooltip.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow:before {\n  border-bottom-color: #eae8ff;\n  border-top-color: transparent;\n}\n.tooltip.bs-tooltip-start .tooltip-arrow:before, .tooltip.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow:before {\n  border-left-color: #eae8ff;\n  border-top-color: transparent;\n}\n.tooltip.bs-tooltip-end .tooltip-arrow:before, .tooltip.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow:before {\n  border-right-color: #eae8ff;\n  border-top-color: transparent;\n}\n.tooltip .tooltip-inner {\n  background-color: #eae8ff;\n  color: #7366ff;\n}\n.tooltip .tooltip-arrow:before {\n  border-top-color: #eae8ff;\n}\n\n.dropdown-basic .dropdown .dropdown-content a {\n  padding: 6px 16px;\n  color: #2b2b2b;\n  opacity: 0.6;\n  font-size: 13px;\n  border-top: 1px solid #efefef;\n  background: #fff;\n}\n.dropdown-basic .dropdown .dropdown-content a:hover {\n  background-color: #fff;\n}\n.dropdown-basic .dropdown .dropdown-content .dropdown-header {\n  padding: 8px 16px;\n  font-weight: 400;\n  color: #2c323f;\n  font-size: 13px;\n}\n.dropdown-basic .dropup .dropup-content {\n  top: auto;\n}\n\n.default-according .card .card-header {\n  padding: 0;\n  border: none;\n  border-radius: 0;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n}\n.default-according .card .card-header.bg-primary .btn, .default-according .card .card-header.bg-secondary .btn {\n  border-color: transparent;\n}\n.default-according .card .card-header i {\n  position: initial;\n  font-size: 20px;\n  display: inline-block;\n  vertical-align: text-bottom;\n  margin-right: 5px;\n}\n[dir=rtl] .default-according .card .card-header i {\n  margin-right: unset;\n  margin-left: 5px;\n}\n.default-according .card .card-header h5, .default-according .card .card-header .h5 {\n  margin-top: 0;\n}\n.default-according .card .card-header .btn-link {\n  padding: 12px 20px;\n  width: 100%;\n  text-align: left;\n  letter-spacing: 0.7px;\n  font-family: Roboto;\n  border: 1px solid #efefef;\n  border-radius: 0;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n}\n[dir=rtl] .default-according .card .card-header .btn-link {\n  text-align: right;\n}\n@media (max-width: 575px) {\n  .default-according .card .card-header .btn-link {\n    padding: 12px 15px;\n  }\n}\n.default-according .card .card-body {\n  padding: 15px 20px;\n  line-height: 22px;\n  font-size: 13px;\n  border-color: #efefef;\n  border-radius: 0;\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px;\n  color: #2c323f;\n}\n\n.nav-tabs {\n  border-bottom-color: #efefef;\n}\n.nav-tabs .nav-bottom .nav-item .nav-link.active {\n  border-color: #efefef;\n}\n\n.nav-tabs .nav-item.show .nav-link {\n  font-weight: 500;\n}\n.nav-tabs .nav-link {\n  color: #2c323f;\n}\n.nav-tabs .nav-link.active {\n  font-weight: 500;\n}\n.nav-tabs.nav-bottom .nav-item .nav-link.active {\n  border-color: #ecf3fa #ecf3fa #fff;\n}\n\n.dropdown-menu {\n  -webkit-box-shadow: 0 0 20px rgba(89, 102, 122, 0.1);\n  box-shadow: 0 0 20px rgba(89, 102, 122, 0.1);\n  border: none;\n  padding: 0;\n  z-index: 1;\n}\n.dropdown-menu .dropdown-item {\n  color: #2b2b2b;\n  opacity: 0.6;\n  font-size: 13px;\n  padding: 6px 12px;\n  border-top: 1px solid #efefef;\n  background: #fff;\n}\n.dropdown-menu .dropdown-item:hover {\n  background-color: #fff;\n}\n.dropdown-menu .dropdown-divider {\n  margin: 0;\n  border-top: 1px solid #cccccc;\n}\n\n.border-tab .nav-tabs .nav-item .nav-link.active {\n  border-bottom: 2px solid #7366ff;\n}\n.border-tab .nav-tabs .nav-item .nav-link.show {\n  border-bottom: 2px solid #7366ff;\n}\n.border-tab .nav-tabs .nav-item .nav-link:focus {\n  border-bottom: 2px solid #7366ff;\n}\n\n.tabbed-card .nav-tabs .nav-item .nav-link {\n  top: 17px;\n}\n\n.timeliny .timeliny-dot::before {\n  font-size: 18px;\n}\n\n.form-builder-header-1,\n.form-builder-2-header {\n  background-color: #f7f6ff;\n}\n.form-builder-header-1 .nav-primary .nav-link,\n.form-builder-2-header .nav-primary .nav-link {\n  color: #2c323f;\n  font-weight: 400;\n}\n.form-builder-header-1 .nav-primary .nav-link.active,\n.form-builder-2-header .nav-primary .nav-link.active {\n  color: #fff;\n}\n.form-builder-header-1 h6, .form-builder-header-1 .h6,\n.form-builder-2-header h6,\n.form-builder-2-header .h6 {\n  margin-bottom: 0;\n  font-weight: 400;\n  line-height: 36px;\n}\n\n.component .input-group .btn {\n  line-height: 32px;\n  text-transform: capitalize;\n}\n\n.form-builder .drag-box fieldset {\n  margin-top: 0;\n}\n\n.login-card .login-main .theme-form label {\n  font-size: 14px;\n}\n.login-card .login-main .theme-form .show-hide {\n  top: 50%;\n}\n\n.faq-accordion .card .btn-link svg {\n  margin-left: 20px;\n}\n@media (max-width: 575.98px) {\n  .faq-accordion .card .btn-link svg {\n    margin-left: 10px;\n  }\n}\n\n.job-filter .faq-form .form-control {\n  font-size: 14px;\n}\n.job-filter .faq-form .search-icon {\n  width: 16px;\n  height: 16px;\n}\n\nbutton[data-toggle=dropdown]:hover ~ .dropdown-menu {\n  display: block;\n  min-width: 300px;\n  top: 35px;\n}\n\n.ct-label {\n  fill: rgba(0, 0, 0, 0.4);\n  color: rgba(0, 0, 0, 0.4);\n  font-size: 0.75rem;\n  line-height: 1;\n}\n\n.ct-chart-line .ct-label,\n.ct-chart-bar .ct-label {\n  display: block;\n  display: -webkit-box;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  display: flex;\n}\n\n.ct-chart-pie .ct-label,\n.ct-chart-donut .ct-label {\n  dominant-baseline: central;\n}\n\n.ct-label.ct-horizontal.ct-start {\n  -webkit-box-align: flex-end;\n  -webkit-align-items: flex-end;\n  -ms-flex-align: flex-end;\n  align-items: flex-end;\n  -webkit-box-pack: flex-start;\n  -webkit-justify-content: flex-start;\n  -ms-flex-pack: flex-start;\n  justify-content: flex-start;\n  text-align: left;\n  text-anchor: start;\n}\n\n.ct-label.ct-horizontal.ct-end {\n  -webkit-box-align: flex-start;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: flex-start;\n  align-items: flex-start;\n  -webkit-box-pack: flex-start;\n  -webkit-justify-content: flex-start;\n  -ms-flex-pack: flex-start;\n  justify-content: flex-start;\n  text-align: left;\n  text-anchor: start;\n}\n\n.ct-label.ct-vertical.ct-start {\n  -webkit-box-align: flex-end;\n  -webkit-align-items: flex-end;\n  -ms-flex-align: flex-end;\n  align-items: flex-end;\n  -webkit-box-pack: flex-end;\n  -webkit-justify-content: flex-end;\n  -ms-flex-pack: flex-end;\n  justify-content: flex-end;\n  text-align: right;\n  text-anchor: end;\n}\n\n.ct-label.ct-vertical.ct-end {\n  -webkit-box-align: flex-end;\n  -webkit-align-items: flex-end;\n  -ms-flex-align: flex-end;\n  align-items: flex-end;\n  -webkit-box-pack: flex-start;\n  -webkit-justify-content: flex-start;\n  -ms-flex-pack: flex-start;\n  justify-content: flex-start;\n  text-align: left;\n  text-anchor: start;\n}\n\n.ct-chart-bar .ct-label.ct-horizontal.ct-start {\n  -webkit-box-align: flex-end;\n  -webkit-align-items: flex-end;\n  -ms-flex-align: flex-end;\n  align-items: flex-end;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  text-align: center;\n  text-anchor: start;\n}\n\n.ct-chart-bar .ct-label.ct-horizontal.ct-end {\n  -webkit-box-align: flex-start;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: flex-start;\n  align-items: flex-start;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  text-align: center;\n  text-anchor: start;\n}\n\n.ct-chart-bar.ct-horizontal-bars .ct-label.ct-horizontal.ct-start {\n  -webkit-box-align: flex-end;\n  -webkit-align-items: flex-end;\n  -ms-flex-align: flex-end;\n  align-items: flex-end;\n  -webkit-box-pack: flex-start;\n  -webkit-justify-content: flex-start;\n  -ms-flex-pack: flex-start;\n  justify-content: flex-start;\n  text-align: left;\n  text-anchor: start;\n}\n\n.ct-chart-bar.ct-horizontal-bars .ct-label.ct-horizontal.ct-end {\n  -webkit-box-align: flex-start;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: flex-start;\n  align-items: flex-start;\n  -webkit-box-pack: flex-start;\n  -webkit-justify-content: flex-start;\n  -ms-flex-pack: flex-start;\n  justify-content: flex-start;\n  text-align: left;\n  text-anchor: start;\n}\n\n.ct-chart-bar.ct-horizontal-bars .ct-label.ct-vertical.ct-start {\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: flex-end;\n  -webkit-justify-content: flex-end;\n  -ms-flex-pack: flex-end;\n  justify-content: flex-end;\n  text-align: right;\n  text-anchor: end;\n}\n\n.ct-chart-bar.ct-horizontal-bars .ct-label.ct-vertical.ct-end {\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: flex-start;\n  -webkit-justify-content: flex-start;\n  -ms-flex-pack: flex-start;\n  justify-content: flex-start;\n  text-align: left;\n  text-anchor: end;\n}\n\n.ct-grid {\n  stroke: rgba(0, 0, 0, 0.2);\n  stroke-width: 1px;\n  stroke-dasharray: 2px;\n}\n\n.ct-grid-background {\n  fill: none;\n}\n\n.ct-point {\n  stroke-width: 10px;\n  stroke-linecap: round;\n}\n\n.ct-line {\n  fill: none;\n  stroke-width: 4px;\n}\n\n.ct-area {\n  stroke: none;\n  fill-opacity: 0.1;\n}\n\n.ct-bar {\n  fill: none;\n  stroke-width: 10px;\n}\n\n.ct-slice-donut {\n  fill: none;\n  stroke-width: 60px;\n}\n\n.ct-series-a .ct-point, .ct-series-a .ct-line, .ct-series-a .ct-bar, .ct-series-a .ct-slice-donut {\n  stroke: #7366ff;\n}\n.ct-series-a .ct-slice-pie, .ct-series-a .ct-slice-donut-solid, .ct-series-a .ct-area {\n  fill: #7366ff;\n}\n\n.ct-series-b .ct-point, .ct-series-b .ct-line, .ct-series-b .ct-bar, .ct-series-b .ct-slice-donut {\n  stroke: #f73164;\n}\n.ct-series-b .ct-slice-pie, .ct-series-b .ct-slice-donut-solid, .ct-series-b .ct-area {\n  fill: #f73164;\n}\n\n.ct-series-c .ct-point, .ct-series-c .ct-line, .ct-series-c .ct-bar, .ct-series-c .ct-slice-donut {\n  stroke: #51bb25;\n}\n.ct-series-c .ct-slice-pie, .ct-series-c .ct-slice-donut-solid, .ct-series-c .ct-area {\n  fill: #51bb25;\n}\n\n.ct-series-d .ct-point, .ct-series-d .ct-line, .ct-series-d .ct-bar, .ct-series-d .ct-slice-donut {\n  stroke: #f8d62b;\n}\n.ct-series-d .ct-slice-pie, .ct-series-d .ct-slice-donut-solid, .ct-series-d .ct-area {\n  fill: #f8d62b;\n}\n\n.ct-series-e .ct-point, .ct-series-e .ct-line, .ct-series-e .ct-bar, .ct-series-e .ct-slice-donut {\n  stroke: #f8d62b;\n}\n.ct-series-e .ct-slice-pie, .ct-series-e .ct-slice-donut-solid, .ct-series-e .ct-area {\n  fill: #f8d62b;\n}\n\n.ct-series-f .ct-point, .ct-series-f .ct-line, .ct-series-f .ct-bar, .ct-series-f .ct-slice-donut {\n  stroke: #dc3545;\n}\n.ct-series-f .ct-slice-pie, .ct-series-f .ct-slice-donut-solid, .ct-series-f .ct-area {\n  fill: #dc3545;\n}\n\n.ct-series-g .ct-point, .ct-series-g .ct-line, .ct-series-g .ct-bar, .ct-series-g .ct-slice-donut {\n  stroke: #7366ff;\n}\n.ct-series-g .ct-slice-pie, .ct-series-g .ct-slice-donut-solid, .ct-series-g .ct-area {\n  fill: #7366ff;\n}\n\n.ct-series-h .ct-point, .ct-series-h .ct-line, .ct-series-h .ct-bar, .ct-series-h .ct-slice-donut {\n  stroke: #7366ff;\n}\n.ct-series-h .ct-slice-pie, .ct-series-h .ct-slice-donut-solid, .ct-series-h .ct-area {\n  fill: #7366ff;\n}\n\n.ct-series-i .ct-point, .ct-series-i .ct-line, .ct-series-i .ct-bar, .ct-series-i .ct-slice-donut {\n  stroke: #7366ff;\n}\n.ct-series-i .ct-slice-pie, .ct-series-i .ct-slice-donut-solid, .ct-series-i .ct-area {\n  fill: #7366ff;\n}\n\n.ct-series-j .ct-point, .ct-series-j .ct-line, .ct-series-j .ct-bar, .ct-series-j .ct-slice-donut {\n  stroke: #7366ff;\n}\n.ct-series-j .ct-slice-pie, .ct-series-j .ct-slice-donut-solid, .ct-series-j .ct-area {\n  fill: #7366ff;\n}\n\n.ct-series-k .ct-point, .ct-series-k .ct-line, .ct-series-k .ct-bar, .ct-series-k .ct-slice-donut {\n  stroke: #7366ff;\n}\n.ct-series-k .ct-slice-pie, .ct-series-k .ct-slice-donut-solid, .ct-series-k .ct-area {\n  fill: #7366ff;\n}\n\n.ct-series-l .ct-point, .ct-series-l .ct-line, .ct-series-l .ct-bar, .ct-series-l .ct-slice-donut {\n  stroke: #7366ff;\n}\n.ct-series-l .ct-slice-pie, .ct-series-l .ct-slice-donut-solid, .ct-series-l .ct-area {\n  fill: #7366ff;\n}\n\n.ct-series-m .ct-point, .ct-series-m .ct-line, .ct-series-m .ct-bar, .ct-series-m .ct-slice-donut {\n  stroke: #7366ff;\n}\n.ct-series-m .ct-slice-pie, .ct-series-m .ct-slice-donut-solid, .ct-series-m .ct-area {\n  fill: #7366ff;\n}\n\n.ct-series-n .ct-point, .ct-series-n .ct-line, .ct-series-n .ct-bar, .ct-series-n .ct-slice-donut {\n  stroke: #7366ff;\n}\n.ct-series-n .ct-slice-pie, .ct-series-n .ct-slice-donut-solid, .ct-series-n .ct-area {\n  fill: #7366ff;\n}\n\n.ct-series-o .ct-point, .ct-series-o .ct-line, .ct-series-o .ct-bar, .ct-series-o .ct-slice-donut {\n  stroke: #7366ff;\n}\n.ct-series-o .ct-slice-pie, .ct-series-o .ct-slice-donut-solid, .ct-series-o .ct-area {\n  fill: #7366ff;\n}\n\n.ct-square {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-square:before {\n  display: block;\n  float: left;\n  content: \"\";\n  width: 0;\n  height: 0;\n  padding-bottom: 100%;\n}\n.ct-square:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.ct-square > svg {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.ct-minor-second {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-minor-second:before {\n  display: block;\n  float: left;\n  content: \"\";\n  width: 0;\n  height: 0;\n  padding-bottom: 93.75%;\n}\n.ct-minor-second:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.ct-minor-second > svg {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.ct-major-second {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-major-second:before {\n  display: block;\n  float: left;\n  content: \"\";\n  width: 0;\n  height: 0;\n  padding-bottom: 88.8888888889%;\n}\n.ct-major-second:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.ct-major-second > svg {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.ct-minor-third {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-minor-third:before {\n  display: block;\n  float: left;\n  content: \"\";\n  width: 0;\n  height: 0;\n  padding-bottom: 83.3333333333%;\n}\n.ct-minor-third:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.ct-minor-third > svg {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.ct-major-third {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-major-third:before {\n  display: block;\n  float: left;\n  content: \"\";\n  width: 0;\n  height: 0;\n  padding-bottom: 80%;\n}\n.ct-major-third:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.ct-major-third > svg {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.ct-perfect-fourth {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-perfect-fourth:before {\n  display: block;\n  float: left;\n  content: \"\";\n  width: 0;\n  height: 0;\n  padding-bottom: 75%;\n}\n.ct-perfect-fourth:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.ct-perfect-fourth > svg {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.ct-perfect-fifth {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-perfect-fifth:before {\n  display: block;\n  float: left;\n  content: \"\";\n  width: 0;\n  height: 0;\n  padding-bottom: 66.6666666667%;\n}\n.ct-perfect-fifth:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.ct-perfect-fifth > svg {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.ct-minor-sixth {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-minor-sixth:before {\n  display: block;\n  float: left;\n  content: \"\";\n  width: 0;\n  height: 0;\n  padding-bottom: 62.5%;\n}\n.ct-minor-sixth:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.ct-minor-sixth > svg {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.ct-golden-section {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-golden-section:before {\n  display: block;\n  float: left;\n  content: \"\";\n  width: 0;\n  height: 0;\n  padding-bottom: 61.804697157%;\n}\n.ct-golden-section:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.ct-golden-section > svg {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.ct-major-sixth {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-major-sixth:before {\n  display: block;\n  float: left;\n  content: \"\";\n  width: 0;\n  height: 0;\n  padding-bottom: 60%;\n}\n.ct-major-sixth:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.ct-major-sixth > svg {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.ct-minor-seventh {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-minor-seventh:before {\n  display: block;\n  float: left;\n  content: \"\";\n  width: 0;\n  height: 0;\n  padding-bottom: 56.25%;\n}\n.ct-minor-seventh:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.ct-minor-seventh > svg {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.ct-major-seventh {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-major-seventh:before {\n  display: block;\n  float: left;\n  content: \"\";\n  width: 0;\n  height: 0;\n  padding-bottom: 53.3333333333%;\n}\n.ct-major-seventh:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.ct-major-seventh > svg {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.ct-octave {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-octave:before {\n  display: block;\n  float: left;\n  content: \"\";\n  width: 0;\n  height: 0;\n  padding-bottom: 50%;\n}\n.ct-octave:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.ct-octave > svg {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.ct-major-tenth {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-major-tenth:before {\n  display: block;\n  float: left;\n  content: \"\";\n  width: 0;\n  height: 0;\n  padding-bottom: 40%;\n}\n.ct-major-tenth:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.ct-major-tenth > svg {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.ct-major-eleventh {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-major-eleventh:before {\n  display: block;\n  float: left;\n  content: \"\";\n  width: 0;\n  height: 0;\n  padding-bottom: 37.5%;\n}\n.ct-major-eleventh:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.ct-major-eleventh > svg {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.ct-major-twelfth {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-major-twelfth:before {\n  display: block;\n  float: left;\n  content: \"\";\n  width: 0;\n  height: 0;\n  padding-bottom: 33.3333333333%;\n}\n.ct-major-twelfth:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.ct-major-twelfth > svg {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.ct-double-octave {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-double-octave:before {\n  display: block;\n  float: left;\n  content: \"\";\n  width: 0;\n  height: 0;\n  padding-bottom: 25%;\n}\n.ct-double-octave:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.ct-double-octave > svg {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n/* FONT PATH\n * -------------------------- */\n@font-face {\n  font-family: \"themify\";\n  src: url(\"../../../fonts/themify/themify.eot?-fvbane\");\n  src: url(\"../../../fonts/themify/themify.eot?#iefix-fvbane\") format(\"embedded-opentype\"), url(\"../../../fonts/themify/themify.woff?-fvbane\") format(\"woff\"), url(\"../../../fonts/themify//themify.ttf?-fvbane\") format(\"truetype\"), url(\"../../../fonts/themify/themify.svg?-fvbane#themify\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n}\n[class^=icon-],\n[class*=\" icon-\"] {\n  font-family: \"themify\";\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  *margin-right: 0.3em;\n}\n\n[class^=icon-]:before,\n[class*=\" icon-\"]:before {\n  text-decoration: inherit;\n  display: inline-block;\n  speak: none;\n}\n\n/* makes the font 33% larger relative to the icon container */\n.icon-large:before {\n  vertical-align: -10%;\n  font-size: 1.3333333333em;\n}\n\n/* makes sure icons active on rollover in links */\na [class^=icon-],\na [class*=\" icon-\"] {\n  display: inline;\n}\n\n/* increased font size for icon-large */\n[class^=icon-].icon-fixed-width,\n[class*=\" icon-\"].icon-fixed-width {\n  display: inline-block;\n  width: 1.1428571429em;\n  text-align: right;\n  padding-right: 0.2857142857em;\n}\n[class^=icon-].icon-fixed-width.icon-large,\n[class*=\" icon-\"].icon-fixed-width.icon-large {\n  width: 1.4285714286em;\n}\n\n.icons-ul {\n  margin-left: 2.1428571429em;\n  list-style-type: none;\n}\n.icons-ul > li {\n  position: relative;\n}\n.icons-ul .icon-li {\n  position: absolute;\n  left: -2.1428571429em;\n  width: 2.1428571429em;\n  text-align: center;\n  line-height: inherit;\n}\n\n[class^=icon-].hide,\n[class*=\" icon-\"].hide {\n  display: none;\n}\n\n.icon-muted {\n  color: #eeeeee;\n}\n\n.icon-light {\n  color: white;\n}\n\n.icon-dark {\n  color: #333333;\n}\n\n.icon-border {\n  border: solid 1px #eeeeee;\n  padding: 0.2em 0.25em 0.15em;\n  -webkit-border-radius: 3px;\n  -moz-border-radius: 3px;\n  border-radius: 3px;\n}\n\n.icon-2x {\n  font-size: 2em;\n}\n.icon-2x.icon-border {\n  border-width: 2px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n}\n\n.icon-3x {\n  font-size: 3em;\n}\n.icon-3x.icon-border {\n  border-width: 3px;\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  border-radius: 5px;\n}\n\n.icon-4x {\n  font-size: 4em;\n}\n.icon-4x.icon-border {\n  border-width: 4px;\n  -webkit-border-radius: 6px;\n  -moz-border-radius: 6px;\n  border-radius: 6px;\n}\n\n.icon-5x {\n  font-size: 5em;\n}\n.icon-5x.icon-border {\n  border-width: 5px;\n  -webkit-border-radius: 7px;\n  -moz-border-radius: 7px;\n  border-radius: 7px;\n}\n\n.pull-right {\n  float: right;\n}\n\n.pull-left {\n  float: left;\n}\n\n[class^=icon-].pull-left,\n[class*=\" icon-\"].pull-left {\n  margin-right: 0.3em;\n}\n[class^=icon-].pull-right,\n[class*=\" icon-\"].pull-right {\n  margin-left: 0.3em;\n}\n\n/* EXTRAS\n * -------------------------- */\n/* Stacked and layered icon */\n.icon-stack {\n  position: relative;\n  display: inline-block;\n  width: 2em;\n  height: 2em;\n  line-height: 2em;\n  vertical-align: -35%;\n}\n.icon-stack [class^=icon-],\n.icon-stack [class*=\" icon-\"] {\n  display: block;\n  text-align: center;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  font-size: 1em;\n  line-height: inherit;\n  *line-height: 2em;\n}\n.icon-stack .icon-stack-base {\n  font-size: 2em;\n  *line-height: 1em;\n}\n\n/* Animated rotating icon */\n.icon-spin {\n  display: inline-block;\n  -moz-animation: spin 2s infinite linear;\n  -o-animation: spin 2s infinite linear;\n  -webkit-animation: spin 2s infinite linear;\n  animation: spin 2s infinite linear;\n}\n\n/* Prevent stack and spinners from being taken inline when inside a link */\na .icon-stack,\na .icon-spin {\n  display: inline-block;\n  text-decoration: none;\n}\n\n@-moz-keyframes spin {\n  0% {\n    -moz-transform: rotate(0deg);\n  }\n  100% {\n    -moz-transform: rotate(359deg);\n  }\n}\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n  }\n}\n@-o-keyframes spin {\n  0% {\n    -o-transform: rotate(0deg);\n  }\n  100% {\n    -o-transform: rotate(359deg);\n  }\n}\n@-ms-keyframes spin {\n  0% {\n    -ms-transform: rotate(0deg);\n  }\n  100% {\n    -ms-transform: rotate(359deg);\n  }\n}\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(359deg);\n  }\n}\n/* Icon rotations and mirroring */\n.icon-rotate-90:before {\n  -webkit-transform: rotate(90deg);\n  -moz-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  -o-transform: rotate(90deg);\n  transform: rotate(90deg);\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);\n}\n\n.icon-rotate-180:before {\n  -webkit-transform: rotate(180deg);\n  -moz-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  -o-transform: rotate(180deg);\n  transform: rotate(180deg);\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n}\n\n.icon-rotate-270:before {\n  -webkit-transform: rotate(270deg);\n  -moz-transform: rotate(270deg);\n  -ms-transform: rotate(270deg);\n  -o-transform: rotate(270deg);\n  transform: rotate(270deg);\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);\n}\n\n.icon-flip-horizontal:before {\n  -webkit-transform: scale(-1, 1);\n  -moz-transform: scale(-1, 1);\n  -ms-transform: scale(-1, 1);\n  -o-transform: scale(-1, 1);\n  transform: scale(-1, 1);\n}\n\n.icon-flip-vertical:before {\n  -webkit-transform: scale(1, -1);\n  -moz-transform: scale(1, -1);\n  -ms-transform: scale(1, -1);\n  -o-transform: scale(1, -1);\n  transform: scale(1, -1);\n}\n\n/* ensure rotation occurs inside anchor tags */\na .icon-rotate-90:before, a .icon-rotate-180:before, a .icon-rotate-270:before, a .icon-flip-horizontal:before, a .icon-flip-vertical:before {\n  display: inline-block;\n}\n\n.icon-wand:before {\n  content: \"\\e600\";\n}\n\n.icon-volume:before {\n  content: \"\\e601\";\n}\n\n.icon-user:before {\n  content: \"\\e602\";\n}\n\n.icon-unlock:before {\n  content: \"\\e603\";\n}\n\n.icon-unlink:before {\n  content: \"\\e604\";\n}\n\n.icon-trash:before {\n  content: \"\\e605\";\n}\n\n.icon-thought:before {\n  content: \"\\e606\";\n}\n\n.icon-target:before {\n  content: \"\\e607\";\n}\n\n.icon-tag:before {\n  content: \"\\e608\";\n}\n\n.icon-tablet:before {\n  content: \"\\e609\";\n}\n\n.icon-star:before {\n  content: \"\\e60a\";\n}\n\n.icon-spray:before {\n  content: \"\\e60b\";\n}\n\n.icon-signal:before {\n  content: \"\\e60c\";\n}\n\n.icon-shopping-cart:before {\n  content: \"\\e60d\";\n}\n\n.icon-shopping-cart-full:before {\n  content: \"\\e60e\";\n}\n\n.icon-settings:before {\n  content: \"\\e60f\";\n}\n\n.icon-search:before {\n  content: \"\\e610\";\n}\n\n.icon-zoom-in:before {\n  content: \"\\e611\";\n}\n\n.icon-zoom-out:before {\n  content: \"\\e612\";\n}\n\n.icon-cut:before {\n  content: \"\\e613\";\n}\n\n.icon-ruler:before {\n  content: \"\\e614\";\n}\n\n.icon-ruler-pencil:before {\n  content: \"\\e615\";\n}\n\n.icon-ruler-alt:before {\n  content: \"\\e616\";\n}\n\n.icon-bookmark:before {\n  content: \"\\e617\";\n}\n\n.icon-bookmark-alt:before {\n  content: \"\\e618\";\n}\n\n.icon-reload:before {\n  content: \"\\e619\";\n}\n\n.icon-plus:before {\n  content: \"\\e61a\";\n}\n\n.icon-pin:before {\n  content: \"\\e61b\";\n}\n\n.icon-pencil:before {\n  content: \"\\e61c\";\n}\n\n.icon-pencil-alt:before {\n  content: \"\\e61d\";\n}\n\n.icon-paint-roller:before {\n  content: \"\\e61e\";\n}\n\n.icon-paint-bucket:before {\n  content: \"\\e61f\";\n}\n\n.icon-na:before {\n  content: \"\\e620\";\n}\n\n.icon-mobile:before {\n  content: \"\\e621\";\n}\n\n.icon-minus:before {\n  content: \"\\e622\";\n}\n\n.icon-medall:before {\n  content: \"\\e623\";\n}\n\n.icon-medall-alt:before {\n  content: \"\\e624\";\n}\n\n.icon-marker:before {\n  content: \"\\e625\";\n}\n\n.icon-marker-alt:before {\n  content: \"\\e626\";\n}\n\n.icon-arrow-up:before {\n  content: \"\\e627\";\n}\n\n.icon-arrow-right:before {\n  content: \"\\e628\";\n}\n\n.icon-arrow-left:before {\n  content: \"\\e629\";\n}\n\n.icon-arrow-down:before {\n  content: \"\\e62a\";\n}\n\n.icon-lock:before {\n  content: \"\\e62b\";\n}\n\n.icon-location-arrow:before {\n  content: \"\\e62c\";\n}\n\n.icon-link:before {\n  content: \"\\e62d\";\n}\n\n.icon-layout:before {\n  content: \"\\e62e\";\n}\n\n.icon-layers:before {\n  content: \"\\e62f\";\n}\n\n.icon-layers-alt:before {\n  content: \"\\e630\";\n}\n\n.icon-key:before {\n  content: \"\\e631\";\n}\n\n.icon-import:before {\n  content: \"\\e632\";\n}\n\n.icon-image:before {\n  content: \"\\e633\";\n}\n\n.icon-heart:before {\n  content: \"\\e634\";\n}\n\n.icon-heart-broken:before {\n  content: \"\\e635\";\n}\n\n.icon-hand-stop:before {\n  content: \"\\e636\";\n}\n\n.icon-hand-open:before {\n  content: \"\\e637\";\n}\n\n.icon-hand-drag:before {\n  content: \"\\e638\";\n}\n\n.icon-folder:before {\n  content: \"\\e639\";\n}\n\n.icon-flag:before {\n  content: \"\\e63a\";\n}\n\n.icon-flag-alt:before {\n  content: \"\\e63b\";\n}\n\n.icon-flag-alt-2:before {\n  content: \"\\e63c\";\n}\n\n.icon-eye:before {\n  content: \"\\e63d\";\n}\n\n.icon-export:before {\n  content: \"\\e63e\";\n}\n\n.icon-exchange-vertical:before {\n  content: \"\\e63f\";\n}\n\n.icon-desktop:before {\n  content: \"\\e640\";\n}\n\n.icon-cup:before {\n  content: \"\\e641\";\n}\n\n.icon-crown:before {\n  content: \"\\e642\";\n}\n\n.icon-comments:before {\n  content: \"\\e643\";\n}\n\n.icon-comment:before {\n  content: \"\\e644\";\n}\n\n.icon-comment-alt:before {\n  content: \"\\e645\";\n}\n\n.icon-close:before {\n  content: \"\\e646\";\n}\n\n.icon-clip:before {\n  content: \"\\e647\";\n}\n\n.icon-angle-up:before {\n  content: \"\\e648\";\n}\n\n.icon-angle-right:before {\n  content: \"\\e649\";\n}\n\n.icon-angle-left:before {\n  content: \"\\e64a\";\n}\n\n.icon-angle-down:before {\n  content: \"\\e64b\";\n}\n\n.icon-check:before {\n  content: \"\\e64c\";\n}\n\n.icon-check-box:before {\n  content: \"\\e64d\";\n}\n\n.icon-camera:before {\n  content: \"\\e64e\";\n}\n\n.icon-announcement:before {\n  content: \"\\e64f\";\n}\n\n.icon-brush:before {\n  content: \"\\e650\";\n}\n\n.icon-briefcase:before {\n  content: \"\\e651\";\n}\n\n.icon-bolt:before {\n  content: \"\\e652\";\n}\n\n.icon-bolt-alt:before {\n  content: \"\\e653\";\n}\n\n.icon-blackboard:before {\n  content: \"\\e654\";\n}\n\n.icon-bag:before {\n  content: \"\\e655\";\n}\n\n.icon-move:before {\n  content: \"\\e656\";\n}\n\n.icon-arrows-vertical:before {\n  content: \"\\e657\";\n}\n\n.icon-arrows-horizontal:before {\n  content: \"\\e658\";\n}\n\n.icon-fullscreen:before {\n  content: \"\\e659\";\n}\n\n.icon-arrow-top-right:before {\n  content: \"\\e65a\";\n}\n\n.icon-arrow-top-left:before {\n  content: \"\\e65b\";\n}\n\n.icon-arrow-circle-up:before {\n  content: \"\\e65c\";\n}\n\n.icon-arrow-circle-right:before {\n  content: \"\\e65d\";\n}\n\n.icon-arrow-circle-left:before {\n  content: \"\\e65e\";\n}\n\n.icon-arrow-circle-down:before {\n  content: \"\\e65f\";\n}\n\n.icon-angle-double-up:before {\n  content: \"\\e660\";\n}\n\n.icon-angle-double-right:before {\n  content: \"\\e661\";\n}\n\n.icon-angle-double-left:before {\n  content: \"\\e662\";\n}\n\n.icon-angle-double-down:before {\n  content: \"\\e663\";\n}\n\n.icon-zip:before {\n  content: \"\\e664\";\n}\n\n.icon-world:before {\n  content: \"\\e665\";\n}\n\n.icon-wheelchair:before {\n  content: \"\\e666\";\n}\n\n.icon-view-list:before {\n  content: \"\\e667\";\n}\n\n.icon-view-list-alt:before {\n  content: \"\\e668\";\n}\n\n.icon-view-grid:before {\n  content: \"\\e669\";\n}\n\n.icon-uppercase:before {\n  content: \"\\e66a\";\n}\n\n.icon-upload:before {\n  content: \"\\e66b\";\n}\n\n.icon-underline:before {\n  content: \"\\e66c\";\n}\n\n.icon-truck:before {\n  content: \"\\e66d\";\n}\n\n.icon-timer:before {\n  content: \"\\e66e\";\n}\n\n.icon-ticket:before {\n  content: \"\\e66f\";\n}\n\n.icon-thumb-up:before {\n  content: \"\\e670\";\n}\n\n.icon-thumb-down:before {\n  content: \"\\e671\";\n}\n\n.icon-text:before {\n  content: \"\\e672\";\n}\n\n.icon-stats-up:before {\n  content: \"\\e673\";\n}\n\n.icon-stats-down:before {\n  content: \"\\e674\";\n}\n\n.icon-split-v:before {\n  content: \"\\e675\";\n}\n\n.icon-split-h:before {\n  content: \"\\e676\";\n}\n\n.icon-smallcap:before {\n  content: \"\\e677\";\n}\n\n.icon-shine:before {\n  content: \"\\e678\";\n}\n\n.icon-shift-right:before {\n  content: \"\\e679\";\n}\n\n.icon-shift-left:before {\n  content: \"\\e67a\";\n}\n\n.icon-shield:before {\n  content: \"\\e67b\";\n}\n\n.icon-notepad:before {\n  content: \"\\e67c\";\n}\n\n.icon-server:before {\n  content: \"\\e67d\";\n}\n\n.icon-quote-right:before {\n  content: \"\\e67e\";\n}\n\n.icon-quote-left:before {\n  content: \"\\e67f\";\n}\n\n.icon-pulse:before {\n  content: \"\\e680\";\n}\n\n.icon-printer:before {\n  content: \"\\e681\";\n}\n\n.icon-power-off:before {\n  content: \"\\e682\";\n}\n\n.icon-plug:before {\n  content: \"\\e683\";\n}\n\n.icon-pie-chart:before {\n  content: \"\\e684\";\n}\n\n.icon-paragraph:before {\n  content: \"\\e685\";\n}\n\n.icon-panel:before {\n  content: \"\\e686\";\n}\n\n.icon-package:before {\n  content: \"\\e687\";\n}\n\n.icon-music:before {\n  content: \"\\e688\";\n}\n\n.icon-music-alt:before {\n  content: \"\\e689\";\n}\n\n.icon-mouse:before {\n  content: \"\\e68a\";\n}\n\n.icon-mouse-alt:before {\n  content: \"\\e68b\";\n}\n\n.icon-money:before {\n  content: \"\\e68c\";\n}\n\n.icon-microphone:before {\n  content: \"\\e68d\";\n}\n\n.icon-menu:before {\n  content: \"\\e68e\";\n}\n\n.icon-menu-alt:before {\n  content: \"\\e68f\";\n}\n\n.icon-map:before {\n  content: \"\\e690\";\n}\n\n.icon-map-alt:before {\n  content: \"\\e691\";\n}\n\n.icon-loop:before {\n  content: \"\\e692\";\n}\n\n.icon-location-pin:before {\n  content: \"\\e693\";\n}\n\n.icon-list:before {\n  content: \"\\e694\";\n}\n\n.icon-light-bulb:before {\n  content: \"\\e695\";\n}\n\n.icon-Italic:before {\n  content: \"\\e696\";\n}\n\n.icon-info:before {\n  content: \"\\e697\";\n}\n\n.icon-infinite:before {\n  content: \"\\e698\";\n}\n\n.icon-id-badge:before {\n  content: \"\\e699\";\n}\n\n.icon-hummer:before {\n  content: \"\\e69a\";\n}\n\n.icon-home:before {\n  content: \"\\e69b\";\n}\n\n.icon-help:before {\n  content: \"\\e69c\";\n}\n\n.icon-headphone:before {\n  content: \"\\e69d\";\n}\n\n.icon-harddrives:before {\n  content: \"\\e69e\";\n}\n\n.icon-harddrive:before {\n  content: \"\\e69f\";\n}\n\n.icon-gift:before {\n  content: \"\\e6a0\";\n}\n\n.icon-game:before {\n  content: \"\\e6a1\";\n}\n\n.icon-filter:before {\n  content: \"\\e6a2\";\n}\n\n.icon-files:before {\n  content: \"\\e6a3\";\n}\n\n.icon-file:before {\n  content: \"\\e6a4\";\n}\n\n.icon-eraser:before {\n  content: \"\\e6a5\";\n}\n\n.icon-envelope:before {\n  content: \"\\e6a6\";\n}\n\n.icon-download:before {\n  content: \"\\e6a7\";\n}\n\n.icon-direction:before {\n  content: \"\\e6a8\";\n}\n\n.icon-direction-alt:before {\n  content: \"\\e6a9\";\n}\n\n.icon-dashboard:before {\n  content: \"\\e6aa\";\n}\n\n.icon-control-stop:before {\n  content: \"\\e6ab\";\n}\n\n.icon-control-shuffle:before {\n  content: \"\\e6ac\";\n}\n\n.icon-control-play:before {\n  content: \"\\e6ad\";\n}\n\n.icon-control-pause:before {\n  content: \"\\e6ae\";\n}\n\n.icon-control-forward:before {\n  content: \"\\e6af\";\n}\n\n.icon-control-backward:before {\n  content: \"\\e6b0\";\n}\n\n.icon-cloud:before {\n  content: \"\\e6b1\";\n}\n\n.icon-cloud-up:before {\n  content: \"\\e6b2\";\n}\n\n.icon-cloud-down:before {\n  content: \"\\e6b3\";\n}\n\n.icon-clipboard:before {\n  content: \"\\e6b4\";\n}\n\n.icon-car:before {\n  content: \"\\e6b5\";\n}\n\n.icon-calendar:before {\n  content: \"\\e6b6\";\n}\n\n.icon-book:before {\n  content: \"\\e6b7\";\n}\n\n.icon-bell:before {\n  content: \"\\e6b8\";\n}\n\n.icon-basketball:before {\n  content: \"\\e6b9\";\n}\n\n.icon-bar-chart:before {\n  content: \"\\e6ba\";\n}\n\n.icon-bar-chart-alt:before {\n  content: \"\\e6bb\";\n}\n\n.icon-back-right:before {\n  content: \"\\e6bc\";\n}\n\n.icon-back-left:before {\n  content: \"\\e6bd\";\n}\n\n.icon-arrows-corner:before {\n  content: \"\\e6be\";\n}\n\n.icon-archive:before {\n  content: \"\\e6bf\";\n}\n\n.icon-anchor:before {\n  content: \"\\e6c0\";\n}\n\n.icon-align-right:before {\n  content: \"\\e6c1\";\n}\n\n.icon-align-left:before {\n  content: \"\\e6c2\";\n}\n\n.icon-align-justify:before {\n  content: \"\\e6c3\";\n}\n\n.icon-align-center:before {\n  content: \"\\e6c4\";\n}\n\n.icon-alert:before {\n  content: \"\\e6c5\";\n}\n\n.icon-alarm-clock:before {\n  content: \"\\e6c6\";\n}\n\n.icon-agenda:before {\n  content: \"\\e6c7\";\n}\n\n.icon-write:before {\n  content: \"\\e6c8\";\n}\n\n.icon-window:before {\n  content: \"\\e6c9\";\n}\n\n.icon-widgetized:before {\n  content: \"\\e6ca\";\n}\n\n.icon-widget:before {\n  content: \"\\e6cb\";\n}\n\n.icon-widget-alt:before {\n  content: \"\\e6cc\";\n}\n\n.icon-wallet:before {\n  content: \"\\e6cd\";\n}\n\n.icon-video-clapper:before {\n  content: \"\\e6ce\";\n}\n\n.icon-video-camera:before {\n  content: \"\\e6cf\";\n}\n\n.icon-vector:before {\n  content: \"\\e6d0\";\n}\n\n.icon-themify-logo:before {\n  content: \"\\e6d1\";\n}\n\n.icon-themify-favicon:before {\n  content: \"\\e6d2\";\n}\n\n.icon-themify-favicon-alt:before {\n  content: \"\\e6d3\";\n}\n\n.icon-support:before {\n  content: \"\\e6d4\";\n}\n\n.icon-stamp:before {\n  content: \"\\e6d5\";\n}\n\n.icon-split-v-alt:before {\n  content: \"\\e6d6\";\n}\n\n.icon-slice:before {\n  content: \"\\e6d7\";\n}\n\n.icon-shortcode:before {\n  content: \"\\e6d8\";\n}\n\n.icon-shift-right-alt:before {\n  content: \"\\e6d9\";\n}\n\n.icon-shift-left-alt:before {\n  content: \"\\e6da\";\n}\n\n.icon-ruler-alt-2:before {\n  content: \"\\e6db\";\n}\n\n.icon-receipt:before {\n  content: \"\\e6dc\";\n}\n\n.icon-pin2:before {\n  content: \"\\e6dd\";\n}\n\n.icon-pin-alt:before {\n  content: \"\\e6de\";\n}\n\n.icon-pencil-alt2:before {\n  content: \"\\e6df\";\n}\n\n.icon-palette:before {\n  content: \"\\e6e0\";\n}\n\n.icon-more:before {\n  content: \"\\e6e1\";\n}\n\n.icon-more-alt:before {\n  content: \"\\e6e2\";\n}\n\n.icon-microphone-alt:before {\n  content: \"\\e6e3\";\n}\n\n.icon-magnet:before {\n  content: \"\\e6e4\";\n}\n\n.icon-line-double:before {\n  content: \"\\e6e5\";\n}\n\n.icon-line-dotted:before {\n  content: \"\\e6e6\";\n}\n\n.icon-line-dashed:before {\n  content: \"\\e6e7\";\n}\n\n.icon-layout-width-full:before {\n  content: \"\\e6e8\";\n}\n\n.icon-layout-width-default:before {\n  content: \"\\e6e9\";\n}\n\n.icon-layout-width-default-alt:before {\n  content: \"\\e6ea\";\n}\n\n.icon-layout-tab:before {\n  content: \"\\e6eb\";\n}\n\n.icon-layout-tab-window:before {\n  content: \"\\e6ec\";\n}\n\n.icon-layout-tab-v:before {\n  content: \"\\e6ed\";\n}\n\n.icon-layout-tab-min:before {\n  content: \"\\e6ee\";\n}\n\n.icon-layout-slider:before {\n  content: \"\\e6ef\";\n}\n\n.icon-layout-slider-alt:before {\n  content: \"\\e6f0\";\n}\n\n.icon-layout-sidebar-right:before {\n  content: \"\\e6f1\";\n}\n\n.icon-layout-sidebar-none:before {\n  content: \"\\e6f2\";\n}\n\n.icon-layout-sidebar-left:before {\n  content: \"\\e6f3\";\n}\n\n.icon-layout-placeholder:before {\n  content: \"\\e6f4\";\n}\n\n.icon-layout-menu:before {\n  content: \"\\e6f5\";\n}\n\n.icon-layout-menu-v:before {\n  content: \"\\e6f6\";\n}\n\n.icon-layout-menu-separated:before {\n  content: \"\\e6f7\";\n}\n\n.icon-layout-menu-full:before {\n  content: \"\\e6f8\";\n}\n\n.icon-layout-media-right-alt:before {\n  content: \"\\e6f9\";\n}\n\n.icon-layout-media-right:before {\n  content: \"\\e6fa\";\n}\n\n.icon-layout-media-overlay:before {\n  content: \"\\e6fb\";\n}\n\n.icon-layout-media-overlay-alt:before {\n  content: \"\\e6fc\";\n}\n\n.icon-layout-media-overlay-alt-2:before {\n  content: \"\\e6fd\";\n}\n\n.icon-layout-media-left-alt:before {\n  content: \"\\e6fe\";\n}\n\n.icon-layout-media-left:before {\n  content: \"\\e6ff\";\n}\n\n.icon-layout-media-center-alt:before {\n  content: \"\\e700\";\n}\n\n.icon-layout-media-center:before {\n  content: \"\\e701\";\n}\n\n.icon-layout-list-thumb:before {\n  content: \"\\e702\";\n}\n\n.icon-layout-list-thumb-alt:before {\n  content: \"\\e703\";\n}\n\n.icon-layout-list-post:before {\n  content: \"\\e704\";\n}\n\n.icon-layout-list-large-image:before {\n  content: \"\\e705\";\n}\n\n.icon-layout-line-solid:before {\n  content: \"\\e706\";\n}\n\n.icon-layout-grid4:before {\n  content: \"\\e707\";\n}\n\n.icon-layout-grid3:before {\n  content: \"\\e708\";\n}\n\n.icon-layout-grid2:before {\n  content: \"\\e709\";\n}\n\n.icon-layout-grid2-thumb:before {\n  content: \"\\e70a\";\n}\n\n.icon-layout-cta-right:before {\n  content: \"\\e70b\";\n}\n\n.icon-layout-cta-left:before {\n  content: \"\\e70c\";\n}\n\n.icon-layout-cta-center:before {\n  content: \"\\e70d\";\n}\n\n.icon-layout-cta-btn-right:before {\n  content: \"\\e70e\";\n}\n\n.icon-layout-cta-btn-left:before {\n  content: \"\\e70f\";\n}\n\n.icon-layout-column4:before {\n  content: \"\\e710\";\n}\n\n.icon-layout-column3:before {\n  content: \"\\e711\";\n}\n\n.icon-layout-column2:before {\n  content: \"\\e712\";\n}\n\n.icon-layout-accordion-separated:before {\n  content: \"\\e713\";\n}\n\n.icon-layout-accordion-merged:before {\n  content: \"\\e714\";\n}\n\n.icon-layout-accordion-list:before {\n  content: \"\\e715\";\n}\n\n.icon-ink-pen:before {\n  content: \"\\e716\";\n}\n\n.icon-info-alt:before {\n  content: \"\\e717\";\n}\n\n.icon-help-alt:before {\n  content: \"\\e718\";\n}\n\n.icon-headphone-alt:before {\n  content: \"\\e719\";\n}\n\n.icon-hand-point-up:before {\n  content: \"\\e71a\";\n}\n\n.icon-hand-point-right:before {\n  content: \"\\e71b\";\n}\n\n.icon-hand-point-left:before {\n  content: \"\\e71c\";\n}\n\n.icon-hand-point-down:before {\n  content: \"\\e71d\";\n}\n\n.icon-gallery:before {\n  content: \"\\e71e\";\n}\n\n.icon-face-smile:before {\n  content: \"\\e71f\";\n}\n\n.icon-face-sad:before {\n  content: \"\\e720\";\n}\n\n.icon-credit-card:before {\n  content: \"\\e721\";\n}\n\n.icon-control-skip-forward:before {\n  content: \"\\e722\";\n}\n\n.icon-control-skip-backward:before {\n  content: \"\\e723\";\n}\n\n.icon-control-record:before {\n  content: \"\\e724\";\n}\n\n.icon-control-eject:before {\n  content: \"\\e725\";\n}\n\n.icon-comments-smiley:before {\n  content: \"\\e726\";\n}\n\n.icon-brush-alt:before {\n  content: \"\\e727\";\n}\n\n.icon-youtube:before {\n  content: \"\\e728\";\n}\n\n.icon-vimeo:before {\n  content: \"\\e729\";\n}\n\n.icon-twitter:before {\n  content: \"\\e72a\";\n}\n\n.icon-time:before {\n  content: \"\\e72b\";\n}\n\n.icon-tumblr:before {\n  content: \"\\e72c\";\n}\n\n.icon-skype:before {\n  content: \"\\e72d\";\n}\n\n.icon-share:before {\n  content: \"\\e72e\";\n}\n\n.icon-share-alt:before {\n  content: \"\\e72f\";\n}\n\n.icon-rocket:before {\n  content: \"\\e730\";\n}\n\n.icon-pinterest:before {\n  content: \"\\e731\";\n}\n\n.icon-new-window:before {\n  content: \"\\e732\";\n}\n\n.icon-microsoft:before {\n  content: \"\\e733\";\n}\n\n.icon-list-ol:before {\n  content: \"\\e734\";\n}\n\n.icon-linkedin:before {\n  content: \"\\e735\";\n}\n\n.icon-layout-sidebar-2:before {\n  content: \"\\e736\";\n}\n\n.icon-layout-grid4-alt:before {\n  content: \"\\e737\";\n}\n\n.icon-layout-grid3-alt:before {\n  content: \"\\e738\";\n}\n\n.icon-layout-grid2-alt:before {\n  content: \"\\e739\";\n}\n\n.icon-layout-column4-alt:before {\n  content: \"\\e73a\";\n}\n\n.icon-layout-column3-alt:before {\n  content: \"\\e73b\";\n}\n\n.icon-layout-column2-alt:before {\n  content: \"\\e73c\";\n}\n\n.icon-instagram:before {\n  content: \"\\e73d\";\n}\n\n.icon-google:before {\n  content: \"\\e73e\";\n}\n\n.icon-github:before {\n  content: \"\\e73f\";\n}\n\n.icon-flickr:before {\n  content: \"\\e740\";\n}\n\n.icon-facebook:before {\n  content: \"\\e741\";\n}\n\n.icon-dropbox:before {\n  content: \"\\e742\";\n}\n\n.icon-dribbble:before {\n  content: \"\\e743\";\n}\n\n.icon-apple:before {\n  content: \"\\e744\";\n}\n\n.icon-android:before {\n  content: \"\\e745\";\n}\n\n.icon-save:before {\n  content: \"\\e746\";\n}\n\n.icon-save-alt:before {\n  content: \"\\e747\";\n}\n\n.icon-yahoo:before {\n  content: \"\\e748\";\n}\n\n.icon-wordpress:before {\n  content: \"\\e749\";\n}\n\n.icon-vimeo-alt:before {\n  content: \"\\e74a\";\n}\n\n.icon-twitter-alt:before {\n  content: \"\\e74b\";\n}\n\n.icon-tumblr-alt:before {\n  content: \"\\e74c\";\n}\n\n.icon-trello:before {\n  content: \"\\e74d\";\n}\n\n.icon-stack-overflow:before {\n  content: \"\\e74e\";\n}\n\n.icon-soundcloud:before {\n  content: \"\\e74f\";\n}\n\n.icon-sharethis:before {\n  content: \"\\e750\";\n}\n\n.icon-sharethis-alt:before {\n  content: \"\\e751\";\n}\n\n.icon-reddit:before {\n  content: \"\\e752\";\n}\n\n.icon-pinterest-alt:before {\n  content: \"\\e753\";\n}\n\n.icon-microsoft-alt:before {\n  content: \"\\e754\";\n}\n\n.icon-linux:before {\n  content: \"\\e755\";\n}\n\n.icon-jsfiddle:before {\n  content: \"\\e756\";\n}\n\n.icon-joomla:before {\n  content: \"\\e757\";\n}\n\n.icon-html5:before {\n  content: \"\\e758\";\n}\n\n.icon-flickr-alt:before {\n  content: \"\\e759\";\n}\n\n.icon-email:before {\n  content: \"\\e75a\";\n}\n\n.icon-drupal:before {\n  content: \"\\e75b\";\n}\n\n.icon-dropbox-alt:before {\n  content: \"\\e75c\";\n}\n\n.icon-css3:before {\n  content: \"\\e75d\";\n}\n\n.icon-rss:before {\n  content: \"\\e75e\";\n}\n\n.icon-rss-alt:before {\n  content: \"\\e75f\";\n}\n\n/* VARIABLES */\n/* Applies a stroke to the icons. Can use percentage for responsive */\n.climacon_component-stroke {\n  fill: #dcdada;\n  stroke-width: 1px;\n  stroke: #717171;\n}\n\n.climacon_component-fill {\n  fill: rgba(113, 113, 113, 0.2509803922);\n  stroke-width: 0;\n  stroke: #ddd;\n}\n\n/* SVG GLOBAL */\nsvg.climacon {\n  display: inline-block;\n  width: 80px;\n  height: 80px;\n  shape-rendering: geometricPrecision;\n}\n\ng, path, circle, rect {\n  animation-iteration-count: infinite;\n  animation-timing-function: linear;\n  transform-origin: 50% 50%;\n  animation-duration: 18s;\n  animation-direction: normal;\n}\n\n/* SUN */\n.climacon_componentWrap-sun {\n  animation-name: rotate;\n}\n\n.climacon_componentWrap_sunSpoke .climacon_component-stroke_sunSpoke {\n  animation-name: scale;\n  animation-direction: alternate;\n  animation-duration: 4.5s;\n}\n\n.climacon_componentWrap_sunSpoke .climacon_component-stroke_sunSpoke:nth-child(even) {\n  animation-delay: 4.5s;\n}\n\n/* MOON */\n.climacon_componentWrap-moon {\n  animation-name: partialRotate;\n  animation-duration: 18s;\n  animation-direction: alternate;\n}\n\n/* WIND */\n.climacon_componentWrap-wind {\n  animation-name: translateWind;\n  animation-duration: 6s;\n  animation-direction: alternate;\n  animation-timing-function: ease-in-out;\n}\n\n/* SNOWFLAKE */\n.climacon_componentWrap-snowflake {\n  animation-name: rotate;\n  animation-duration: 54s;\n  animation-direction: normal;\n}\n\n/* CLOUD SUN */\n.climacon_componentWrap-sun_cloud {\n  animation-name: behindCloudMove, rotate;\n  animation-iteration-count: 1, infinite;\n  animation-timing-function: ease-out, linear;\n  animation-delay: 0, 4.5s;\n  animation-duration: 4.5s, 18s;\n}\n\n.climacon_componentWrap-sun_cloud .climacon_componentWrap_sunSpoke .climacon_component-stroke_sunSpoke {\n  fill-opacity: 0;\n  animation-name: fillOpacity, scale;\n  animation-iteration-count: 1, infinite;\n  animation-delay: 4.5s, 0;\n  animation-fill-mode: both;\n}\n\n.climacon_componentWrap-sun_cloud .climacon_componentWrap_sunSpoke .climacon_component-stroke_sunSpoke:nth-child(even) {\n  animation-delay: 4.5s;\n}\n\n/* CLOUD MOON */\n.climacon_componentWrap-moon_cloud {\n  animation-name: behindCloudMove, partialRotate;\n  animation-iteration-count: 1, infinite;\n  animation-timing-function: ease-out, linear;\n  animation-delay: 0, 4.5s;\n  animation-duration: 4.5s, 18s;\n}\n\n/* DRIZZLE */\n.climacon_component-stroke_drizzle {\n  fill-opacity: 0;\n  animation-name: drizzleFall, fillOpacity2;\n  animation-timing-function: ease-in;\n  animation-duration: 1.5s;\n}\n\n.climacon_component-stroke_drizzle:nth-child(1) {\n  animation-delay: 0s;\n}\n\n.climacon_component-stroke_drizzle:nth-child(2) {\n  animation-delay: 0.9s;\n}\n\n.climacon_component-stroke_drizzle:nth-child(3) {\n  animation-delay: 1.8s;\n}\n\n/* RAIN */\n.climacon_component-stroke_rain {\n  fill-opacity: 0;\n  animation-name: rainFall, fillOpacity2;\n  animation-timing-function: ease-in;\n  animation-duration: 3s;\n}\n\n.climacon_component-stroke_rain:nth-child(n+4) {\n  animation-delay: 1.5s;\n}\n\n.climacon_component-stroke_rain_alt:nth-child(2) {\n  animation-delay: 1.5s;\n}\n\n/* HAIL */\n/* HAIL ALT */\n.climacon_component-stroke_hailAlt {\n  fill-opacity: 1;\n  animation-timing-function: ease-in;\n  animation-duration: 1s;\n}\n\n.climacon_component-stroke_hailAlt-left {\n  animation-name: hailLeft, fillOpacity2;\n}\n\n.climacon_component-stroke_hailAlt-middle {\n  animation-name: hailMiddle, fillOpacity2;\n}\n\n.climacon_component-stroke_hailAlt-middle:nth-child(2) {\n  animation-name: hailMiddle2, fillOpacity2;\n}\n\n.climacon_component-stroke_hailAlt-right {\n  animation-name: hailRight, fillOpacity2;\n}\n\n.climacon_component-stroke_hailAlt:nth-child(1) {\n  animation-delay: 0s;\n}\n\n.climacon_component-stroke_hailAlt:nth-child(2) {\n  animation-delay: 0.1666666667s;\n}\n\n.climacon_component-stroke_hailAlt:nth-child(3) {\n  animation-delay: 0.3333333333s;\n}\n\n.climacon_component-stroke_hailAlt:nth-child(4) {\n  animation-delay: 0.5s;\n}\n\n.climacon_component-stroke_hailAlt:nth-child(5) {\n  animation-delay: 0.6666666667s;\n}\n\n.climacon_component-stroke_hailAlt:nth-child(6) {\n  animation-delay: 0.8333333333s;\n}\n\n/* SNOW */\n.climacon_component-stroke_snow {\n  fill-opacity: 0;\n  animation-name: snowFall, fillOpacity2;\n  animation-timing-function: ease-in-out;\n  animation-duration: 9s;\n}\n\n.climacon_component-stroke_snow:nth-child(3) {\n  animation-name: snowFall2, fillOpacity2;\n}\n\n.climacon_component-stroke_snow:nth-child(1) {\n  animation-delay: 0s;\n}\n\n.climacon_component-stroke_snow:nth-child(2) {\n  animation-delay: 3s;\n}\n\n.climacon_component-stroke_snow:nth-child(3) {\n  animation-delay: 6s;\n}\n\n/* SNOW ALT */\n.climacon_wrapperComponent-snowAlt {\n  fill-opacity: 0;\n  animation-name: snowFall, fillOpacity2;\n  animation-timing-function: ease-in-out;\n  animation-duration: 9s;\n}\n\n/* FOG */\n.climacon_component-stroke_fogLine {\n  fill-opacity: 0.5;\n  animation-name: translateFog, fillOpacityFog;\n  animation-iteration-count: infinite;\n  animation-direction: normal;\n  animation-timing-function: ease-in;\n  animation-duration: 18s;\n}\n\n.climacon_component-stroke_fogLine:nth-child(even) {\n  animation-delay: 9s;\n}\n\n/* LIGHTNING */\n.climacon_component-stroke_lightning {\n  fill-opacity: 0;\n  animation-name: fillOpacityLightning;\n  animation-iteration-count: infinite;\n  animation-direction: normal;\n  animation-timing-function: ease-out;\n  animation-duration: 18s;\n}\n\n/* TORNADO */\n.climacon_component-stroke_tornadoLine {\n  animation-name: translateTornado1;\n  animation-iteration-count: infinite;\n  animation-direction: alternate;\n  animation-timing-function: ease-in-out;\n  animation-duration: 18s;\n}\n\n.climacon_component-stroke_tornadoLine:nth-child(1) {\n  animation-name: translateTornado1;\n}\n\n.climacon_component-stroke_tornadoLine:nth-child(2) {\n  animation-name: translateTornado2;\n}\n\n.climacon_component-stroke_tornadoLine:nth-child(3) {\n  animation-name: translateTornado3;\n}\n\n.climacon_component-stroke_tornadoLine:nth-child(4) {\n  animation-name: translateTornado4;\n}\n\n.climacon_component-stroke_tornadoLine:nth-child(5) {\n  animation-name: translateTornado5;\n}\n\n.climacon_component-stroke_tornadoLine:nth-child(6) {\n  animation-name: translateTornado6;\n}\n\n.climacon_componentWrap-sunsetAlt {\n  animation-name: translateSunset;\n  animation-duration: 4.5s;\n  animation-iteration-count: 1;\n  animation-timing-function: ease-out;\n}\n\n.climacon_componentWrap-sunsetAlt {\n  animation-name: translateSunset;\n  animation-iteration-count: 1;\n}\n\n.climacon_iconWrap-sun .climacon_component-stroke_sunSpoke, .climacon_iconWrap-sunFill .climacon_component-stroke_sunSpoke {\n  fill-opacity: 1;\n  animation-name: scale;\n  animation-duration: 3s;\n  animation-iteration-count: infinite;\n  animation-delay: 0s;\n  animation-fill-mode: both;\n  animation-direction: alternate;\n}\n\n.climacon_iconWrap-sun .climacon_component-stroke_sunSpoke:nth-child(even), .climacon_iconWrap-sunFill .climacon_component-stroke_sunSpoke:nth-child(even) {\n  animation-delay: 4.5s;\n}\n\n.climacon-iconWrap_sunFill .climacon_component-stroke_sunSpoke {\n  fill-opacity: 1;\n  animation-name: scale;\n  animation-iteration-count: infinite;\n  animation-delay: 0s;\n  animation-fill-mode: both;\n  animation-direction: alternate;\n}\n\n.climacon-iconWrap_sunFill .climacon_component-stroke_sunSpoke:nth-child(even) {\n  animation-delay: 4.5s;\n}\n\n.climacon_component-stroke_arrow-up {\n  fill-opacity: 0;\n  animation-name: fillOpacity2, translateArrowUp;\n  animation-duration: 4.5s;\n}\n\n.climacon_component-stroke_arrow-down {\n  fill-opacity: 0;\n  animation-name: fillOpacity2, translateArrowDown;\n  animation-duration: 4.5s;\n}\n\n.climacon_componentWrap-sunrise .climacon_component-stroke_sunSpoke, .climacon_componentWrap-sunset .climacon_component-stroke_sunSpoke {\n  animation-name: scale;\n  animation-direction: alternate;\n  animation-iteration-count: infinite;\n  animation-duration: 4.5s;\n  animation-delay: 0s;\n  animation-fill-mode: both;\n}\n\n.climacon_componentWrap-sunrise .climacon_component-stroke_sunSpoke:nth-child(even), .climacon_componentWrap-sunset .climacon_component-stroke_sunSpoke:nth-child(even) {\n  animation-delay: 4.5s;\n}\n\n.climacon_componentWrap-sunriseAlt {\n  animation-name: translateSunrise, fillOpacity;\n  animation-duration: 18s, 9s;\n  animation-direction: normal;\n  animation-iteration-count: 1;\n  animation-fill-mode: forwards;\n}\n\n.climacon_componentWrap-sunriseAlt .climacon_component-stroke_sunSpoke {\n  fill-opacity: 0;\n  animation-name: fillOpacity, scale;\n  animation-direction: normal, alternate;\n  animation-iteration-count: 1, infinite;\n  animation-duration: 4.5s;\n  animation-delay: 4.5s, 0;\n  animation-fill-mode: both;\n}\n\n.climacon_componentWrap-sunriseAlt .climacon_component-stroke_sunSpoke:nth-child(even) {\n  animation-delay: 4.5s, 4.5s;\n}\n\n.climacon_componentWrap-sunsetAlt {\n  animation-name: translateSunset;\n  animation-delay: 0s;\n  animation-duration: 18s;\n  animation-direction: normal;\n  animation-iteration-count: 1;\n  animation-fill-mode: forwards;\n}\n\n/* ANIMATIONS */\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@keyframes partialRotate {\n  0% {\n    transform: rotate(0deg);\n  }\n  25% {\n    transform: rotate(-15deg);\n  }\n  50% {\n    transform: rotate(0deg);\n  }\n  75% {\n    transform: rotate(15deg);\n  }\n  100% {\n    transform: rotate(0deg);\n  }\n}\n@keyframes scale {\n  0% {\n    transform: scale(1, 1);\n  }\n  100% {\n    transform: scale(0.5, 0.5);\n  }\n}\n@keyframes behindCloudMove {\n  0% {\n    transform: translateX(-1.75px) translateY(1.75px);\n  }\n  100% {\n    transform: translateX(0) translateY(0);\n  }\n}\n@keyframes drizzleFall {\n  0% {\n    transform: translateY(0);\n  }\n  100% {\n    transform: translateY(21px);\n  }\n}\n@keyframes rainFall {\n  0% {\n    transform: translateY(0);\n  }\n  100% {\n    transform: translateY(14px);\n  }\n}\n@keyframes rainFall2 {\n  0% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(14px);\n  }\n  100% {\n    transform: translateX(14px) translateY(14px);\n  }\n}\n@keyframes hailLeft {\n  50% {\n    transform: translateY(17.5px);\n  }\n  51% {\n    transform: translateY(17.5px) translateX(-0.3px);\n  }\n  53% {\n    transform: translateY(16.4033342063px) translateX(-0.9px);\n  }\n  55% {\n    transform: translateY(15.3239634873px) translateX(-1.5px);\n  }\n  57% {\n    transform: translateY(14.278910164px) translateX(-2.1px);\n  }\n  59% {\n    transform: translateY(13.2846553516px) translateX(-2.7px);\n  }\n  61% {\n    transform: translateY(12.3568790424px) translateX(-3.3px);\n  }\n  63% {\n    transform: translateY(11.5102128231px) translateX(-3.9px);\n  }\n  65% {\n    transform: translateY(10.7580091257px) translateX(-4.5px);\n  }\n  67% {\n    transform: translateY(10.1121306519px) translateX(-5.1px);\n  }\n  69% {\n    transform: translateY(9.5827632909px) translateX(-5.7px);\n  }\n  71% {\n    transform: translateY(9.1782554824px) translateX(-6.3px);\n  }\n  73% {\n    transform: translateY(8.9049865561px) translateX(-6.9px);\n  }\n  75% {\n    transform: translateY(8.7672661263px) translateX(-7.5px);\n  }\n  77% {\n    transform: translateY(8.7672661263px) translateX(-8.1px);\n  }\n  79% {\n    transform: translateY(8.9049865561px) translateX(-8.7px);\n  }\n  81% {\n    transform: translateY(9.1782554824px) translateX(-9.3px);\n  }\n  83% {\n    transform: translateY(9.5827632909px) translateX(-9.9px);\n  }\n  85% {\n    transform: translateY(10.1121306519px) translateX(-10.5px);\n  }\n  87% {\n    transform: translateY(10.7580091257px) translateX(-11.1px);\n  }\n  89% {\n    transform: translateY(11.5102128231px) translateX(-11.7px);\n  }\n  91% {\n    transform: translateY(12.3568790424px) translateX(-12.3px);\n  }\n  93% {\n    transform: translateY(13.2846553516px) translateX(-12.9px);\n  }\n  95% {\n    transform: translateY(14.278910164px) translateX(-13.5px);\n  }\n  97% {\n    transform: translateY(15.3239634873px) translateX(-14.1px);\n  }\n  99% {\n    transform: translateY(16.4033342063px) translateX(-14.7px);\n  }\n}\n@keyframes hailMiddle {\n  50% {\n    transform: translateY(17.5px);\n  }\n  51% {\n    transform: translateY(17.5px) translateX(-0.15px);\n  }\n  53% {\n    transform: translateY(16.4033342063px) translateX(-0.45px);\n  }\n  55% {\n    transform: translateY(15.3239634873px) translateX(-0.75px);\n  }\n  57% {\n    transform: translateY(14.278910164px) translateX(-1.05px);\n  }\n  59% {\n    transform: translateY(13.2846553516px) translateX(-1.35px);\n  }\n  61% {\n    transform: translateY(12.3568790424px) translateX(-1.65px);\n  }\n  63% {\n    transform: translateY(11.5102128231px) translateX(-1.95px);\n  }\n  65% {\n    transform: translateY(10.7580091257px) translateX(-2.25px);\n  }\n  67% {\n    transform: translateY(10.1121306519px) translateX(-2.55px);\n  }\n  69% {\n    transform: translateY(9.5827632909px) translateX(-2.85px);\n  }\n  71% {\n    transform: translateY(9.1782554824px) translateX(-3.15px);\n  }\n  73% {\n    transform: translateY(8.9049865561px) translateX(-3.45px);\n  }\n  75% {\n    transform: translateY(8.7672661263px) translateX(-3.75px);\n  }\n  77% {\n    transform: translateY(8.7672661263px) translateX(-4.05px);\n  }\n  79% {\n    transform: translateY(8.9049865561px) translateX(-4.35px);\n  }\n  81% {\n    transform: translateY(9.1782554824px) translateX(-4.65px);\n  }\n  83% {\n    transform: translateY(9.5827632909px) translateX(-4.95px);\n  }\n  85% {\n    transform: translateY(10.1121306519px) translateX(-5.25px);\n  }\n  87% {\n    transform: translateY(10.7580091257px) translateX(-5.55px);\n  }\n  89% {\n    transform: translateY(11.5102128231px) translateX(-5.85px);\n  }\n  91% {\n    transform: translateY(12.3568790424px) translateX(-6.15px);\n  }\n  93% {\n    transform: translateY(13.2846553516px) translateX(-6.45px);\n  }\n  95% {\n    transform: translateY(14.278910164px) translateX(-6.75px);\n  }\n  97% {\n    transform: translateY(15.3239634873px) translateX(-7.05px);\n  }\n  99% {\n    transform: translateY(16.4033342063px) translateX(-7.35px);\n  }\n}\n@keyframes hailMiddle2 {\n  50% {\n    transform: translateY(17.5px);\n  }\n  51% {\n    transform: translateY(17.5px) translateX(0.15px);\n  }\n  53% {\n    transform: translateY(16.4033342063px) translateX(0.45px);\n  }\n  55% {\n    transform: translateY(15.3239634873px) translateX(0.75px);\n  }\n  57% {\n    transform: translateY(14.278910164px) translateX(1.05px);\n  }\n  59% {\n    transform: translateY(13.2846553516px) translateX(1.35px);\n  }\n  61% {\n    transform: translateY(12.3568790424px) translateX(1.65px);\n  }\n  63% {\n    transform: translateY(11.5102128231px) translateX(1.95px);\n  }\n  65% {\n    transform: translateY(10.7580091257px) translateX(2.25px);\n  }\n  67% {\n    transform: translateY(10.1121306519px) translateX(2.55px);\n  }\n  69% {\n    transform: translateY(9.5827632909px) translateX(2.85px);\n  }\n  71% {\n    transform: translateY(9.1782554824px) translateX(3.15px);\n  }\n  73% {\n    transform: translateY(8.9049865561px) translateX(3.45px);\n  }\n  75% {\n    transform: translateY(8.7672661263px) translateX(3.75px);\n  }\n  77% {\n    transform: translateY(8.7672661263px) translateX(4.05px);\n  }\n  79% {\n    transform: translateY(8.9049865561px) translateX(4.35px);\n  }\n  81% {\n    transform: translateY(9.1782554824px) translateX(4.65px);\n  }\n  83% {\n    transform: translateY(9.5827632909px) translateX(4.95px);\n  }\n  85% {\n    transform: translateY(10.1121306519px) translateX(5.25px);\n  }\n  87% {\n    transform: translateY(10.7580091257px) translateX(5.55px);\n  }\n  89% {\n    transform: translateY(11.5102128231px) translateX(5.85px);\n  }\n  91% {\n    transform: translateY(12.3568790424px) translateX(6.15px);\n  }\n  93% {\n    transform: translateY(13.2846553516px) translateX(6.45px);\n  }\n  95% {\n    transform: translateY(14.278910164px) translateX(6.75px);\n  }\n  97% {\n    transform: translateY(15.3239634873px) translateX(7.05px);\n  }\n  99% {\n    transform: translateY(16.4033342063px) translateX(7.35px);\n  }\n}\n@keyframes hailRight {\n  50% {\n    transform: translateY(17.5px);\n  }\n  51% {\n    transform: translateY(17.5px) translateX(0.3px);\n  }\n  53% {\n    transform: translateY(16.4033342063px) translateX(0.9px);\n  }\n  55% {\n    transform: translateY(15.3239634873px) translateX(1.5px);\n  }\n  57% {\n    transform: translateY(14.278910164px) translateX(2.1px);\n  }\n  59% {\n    transform: translateY(13.2846553516px) translateX(2.7px);\n  }\n  61% {\n    transform: translateY(12.3568790424px) translateX(3.3px);\n  }\n  63% {\n    transform: translateY(11.5102128231px) translateX(3.9px);\n  }\n  65% {\n    transform: translateY(10.7580091257px) translateX(4.5px);\n  }\n  67% {\n    transform: translateY(10.1121306519px) translateX(5.1px);\n  }\n  69% {\n    transform: translateY(9.5827632909px) translateX(5.7px);\n  }\n  71% {\n    transform: translateY(9.1782554824px) translateX(6.3px);\n  }\n  73% {\n    transform: translateY(8.9049865561px) translateX(6.9px);\n  }\n  75% {\n    transform: translateY(8.7672661263px) translateX(7.5px);\n  }\n  77% {\n    transform: translateY(8.7672661263px) translateX(8.1px);\n  }\n  79% {\n    transform: translateY(8.9049865561px) translateX(8.7px);\n  }\n  81% {\n    transform: translateY(9.1782554824px) translateX(9.3px);\n  }\n  83% {\n    transform: translateY(9.5827632909px) translateX(9.9px);\n  }\n  85% {\n    transform: translateY(10.1121306519px) translateX(10.5px);\n  }\n  87% {\n    transform: translateY(10.7580091257px) translateX(11.1px);\n  }\n  89% {\n    transform: translateY(11.5102128231px) translateX(11.7px);\n  }\n  91% {\n    transform: translateY(12.3568790424px) translateX(12.3px);\n  }\n  93% {\n    transform: translateY(13.2846553516px) translateX(12.9px);\n  }\n  95% {\n    transform: translateY(14.278910164px) translateX(13.5px);\n  }\n  97% {\n    transform: translateY(15.3239634873px) translateX(14.1px);\n  }\n  99% {\n    transform: translateY(16.4033342063px) translateX(14.7px);\n  }\n}\n@keyframes fillOpacity {\n  0% {\n    fill-opacity: 0;\n    stroke-opacity: 0;\n  }\n  100% {\n    fill-opacity: 1;\n    stroke-opacity: 1;\n  }\n}\n@keyframes fillOpacity2 {\n  0% {\n    fill-opacity: 0;\n    stroke-opacity: 0;\n  }\n  50% {\n    fill-opacity: 1;\n    stroke-opacity: 1;\n  }\n  100% {\n    fill-opacity: 0;\n    stroke-opacity: 0;\n  }\n}\n@keyframes lightningFlash {\n  0% {\n    fill-opacity: 0;\n  }\n  1% {\n    fill-opacity: 1;\n  }\n  2% {\n    fill-opacity: 0;\n  }\n  50% {\n    fill-opacity: 0;\n  }\n  51% {\n    fill-opacity: 1;\n  }\n  52% {\n    fill-opacity: 0;\n  }\n  53% {\n    fill-opacity: 1;\n  }\n  54% {\n    fill-opacity: 0;\n  }\n  100% {\n    fill-opacity: 0;\n  }\n}\n@keyframes snowFall {\n  0% {\n    transform: translateY(0px) translateX(0px);\n  }\n  2% {\n    transform: translateY(0.35px) translateX(0.7534862344px);\n  }\n  4% {\n    transform: translateY(0.7px) translateX(1.441332186px);\n  }\n  6% {\n    transform: translateY(1.05px) translateX(2.0611944604px);\n  }\n  8% {\n    transform: translateY(1.4px) translateX(2.6112438152px);\n  }\n  10% {\n    transform: translateY(1.75px) translateX(3.0901699437px);\n  }\n  12% {\n    transform: translateY(2.1px) translateX(3.4971832505px);\n  }\n  14% {\n    transform: translateY(2.45px) translateX(3.8320136241px);\n  }\n  16% {\n    transform: translateY(2.8px) translateX(4.0949062299px);\n  }\n  18% {\n    transform: translateY(3.15px) translateX(4.2866143598px);\n  }\n  20% {\n    transform: translateY(3.5px) translateX(4.4083893922px);\n  }\n  22% {\n    transform: translateY(3.85px) translateX(4.4619679282px);\n  }\n  24% {\n    transform: translateY(4.2px) translateX(4.4495561885px);\n  }\n  26% {\n    transform: translateY(4.55px) translateX(4.3738117645px);\n  }\n  28% {\n    transform: translateY(4.9px) translateX(4.2378228353px);\n  }\n  30% {\n    transform: translateY(5.25px) translateX(4.0450849719px);\n  }\n  32% {\n    transform: translateY(5.6px) translateX(3.7994756648px);\n  }\n  34% {\n    transform: translateY(5.95px) translateX(3.5052267202px);\n  }\n  36% {\n    transform: translateY(6.3px) translateX(3.1668946836px);\n  }\n  38% {\n    transform: translateY(6.65px) translateX(2.7893294577px);\n  }\n  40% {\n    transform: translateY(7px) translateX(2.3776412907px);\n  }\n  42% {\n    transform: translateY(7.35px) translateX(1.9371663223px);\n  }\n  44% {\n    transform: translateY(7.7px) translateX(1.4734308761px);\n  }\n  46% {\n    transform: translateY(8.05px) translateX(0.9921147013px);\n  }\n  48% {\n    transform: translateY(8.4px) translateX(0.4990133642px);\n  }\n  50% {\n    transform: translateY(8.75px) translateX(-0px);\n  }\n  52% {\n    transform: translateY(9.1px) translateX(-0.4990133642px);\n  }\n  54% {\n    transform: translateY(9.45px) translateX(-0.9921147013px);\n  }\n  56% {\n    transform: translateY(9.8px) translateX(-1.4734308761px);\n  }\n  58% {\n    transform: translateY(10.15px) translateX(-1.9371663223px);\n  }\n  60% {\n    transform: translateY(10.5px) translateX(-2.3776412907px);\n  }\n  62% {\n    transform: translateY(10.85px) translateX(-2.7893294577px);\n  }\n  64% {\n    transform: translateY(11.2px) translateX(-3.1668946836px);\n  }\n  66% {\n    transform: translateY(11.55px) translateX(-3.5052267202px);\n  }\n  68% {\n    transform: translateY(11.9px) translateX(-3.7994756648px);\n  }\n  70% {\n    transform: translateY(12.25px) translateX(-4.0450849719px);\n  }\n  72% {\n    transform: translateY(12.6px) translateX(-4.2378228353px);\n  }\n  74% {\n    transform: translateY(12.95px) translateX(-4.3738117645px);\n  }\n  76% {\n    transform: translateY(13.3px) translateX(-4.4495561885px);\n  }\n  78% {\n    transform: translateY(13.65px) translateX(-4.4619679282px);\n  }\n  80% {\n    transform: translateY(14px) translateX(-4.4083893922px);\n  }\n  82% {\n    transform: translateY(14.35px) translateX(-4.2866143598px);\n  }\n  84% {\n    transform: translateY(14.7px) translateX(-4.0949062299px);\n  }\n  86% {\n    transform: translateY(15.05px) translateX(-3.8320136241px);\n  }\n  88% {\n    transform: translateY(15.4px) translateX(-3.4971832505px);\n  }\n  90% {\n    transform: translateY(15.75px) translateX(-3.0901699438px);\n  }\n  92% {\n    transform: translateY(16.1px) translateX(-2.6112438152px);\n  }\n  94% {\n    transform: translateY(16.45px) translateX(-2.0611944605px);\n  }\n  96% {\n    transform: translateY(16.8px) translateX(-1.441332186px);\n  }\n  98% {\n    transform: translateY(17.15px) translateX(-0.7534862344px);\n  }\n  100% {\n    transform: translateY(17.5px) translateX(-0.0000000001px);\n  }\n}\n@keyframes snowFall2 {\n  0% {\n    transform: translateY(0px) translateX(-0px);\n  }\n  2% {\n    transform: translateY(0.35px) translateX(-0.7534862344px);\n  }\n  4% {\n    transform: translateY(0.7px) translateX(-1.441332186px);\n  }\n  6% {\n    transform: translateY(1.05px) translateX(-2.0611944604px);\n  }\n  8% {\n    transform: translateY(1.4px) translateX(-2.6112438152px);\n  }\n  10% {\n    transform: translateY(1.75px) translateX(-3.0901699437px);\n  }\n  12% {\n    transform: translateY(2.1px) translateX(-3.4971832505px);\n  }\n  14% {\n    transform: translateY(2.45px) translateX(-3.8320136241px);\n  }\n  16% {\n    transform: translateY(2.8px) translateX(-4.0949062299px);\n  }\n  18% {\n    transform: translateY(3.15px) translateX(-4.2866143598px);\n  }\n  20% {\n    transform: translateY(3.5px) translateX(-4.4083893922px);\n  }\n  22% {\n    transform: translateY(3.85px) translateX(-4.4619679282px);\n  }\n  24% {\n    transform: translateY(4.2px) translateX(-4.4495561885px);\n  }\n  26% {\n    transform: translateY(4.55px) translateX(-4.3738117645px);\n  }\n  28% {\n    transform: translateY(4.9px) translateX(-4.2378228353px);\n  }\n  30% {\n    transform: translateY(5.25px) translateX(-4.0450849719px);\n  }\n  32% {\n    transform: translateY(5.6px) translateX(-3.7994756648px);\n  }\n  34% {\n    transform: translateY(5.95px) translateX(-3.5052267202px);\n  }\n  36% {\n    transform: translateY(6.3px) translateX(-3.1668946836px);\n  }\n  38% {\n    transform: translateY(6.65px) translateX(-2.7893294577px);\n  }\n  40% {\n    transform: translateY(7px) translateX(-2.3776412907px);\n  }\n  42% {\n    transform: translateY(7.35px) translateX(-1.9371663223px);\n  }\n  44% {\n    transform: translateY(7.7px) translateX(-1.4734308761px);\n  }\n  46% {\n    transform: translateY(8.05px) translateX(-0.9921147013px);\n  }\n  48% {\n    transform: translateY(8.4px) translateX(-0.4990133642px);\n  }\n  50% {\n    transform: translateY(8.75px) translateX(0px);\n  }\n  52% {\n    transform: translateY(9.1px) translateX(0.4990133642px);\n  }\n  54% {\n    transform: translateY(9.45px) translateX(0.9921147013px);\n  }\n  56% {\n    transform: translateY(9.8px) translateX(1.4734308761px);\n  }\n  58% {\n    transform: translateY(10.15px) translateX(1.9371663223px);\n  }\n  60% {\n    transform: translateY(10.5px) translateX(2.3776412907px);\n  }\n  62% {\n    transform: translateY(10.85px) translateX(2.7893294577px);\n  }\n  64% {\n    transform: translateY(11.2px) translateX(3.1668946836px);\n  }\n  66% {\n    transform: translateY(11.55px) translateX(3.5052267202px);\n  }\n  68% {\n    transform: translateY(11.9px) translateX(3.7994756648px);\n  }\n  70% {\n    transform: translateY(12.25px) translateX(4.0450849719px);\n  }\n  72% {\n    transform: translateY(12.6px) translateX(4.2378228353px);\n  }\n  74% {\n    transform: translateY(12.95px) translateX(4.3738117645px);\n  }\n  76% {\n    transform: translateY(13.3px) translateX(4.4495561885px);\n  }\n  78% {\n    transform: translateY(13.65px) translateX(4.4619679282px);\n  }\n  80% {\n    transform: translateY(14px) translateX(4.4083893922px);\n  }\n  82% {\n    transform: translateY(14.35px) translateX(4.2866143598px);\n  }\n  84% {\n    transform: translateY(14.7px) translateX(4.0949062299px);\n  }\n  86% {\n    transform: translateY(15.05px) translateX(3.8320136241px);\n  }\n  88% {\n    transform: translateY(15.4px) translateX(3.4971832505px);\n  }\n  90% {\n    transform: translateY(15.75px) translateX(3.0901699438px);\n  }\n  92% {\n    transform: translateY(16.1px) translateX(2.6112438152px);\n  }\n  94% {\n    transform: translateY(16.45px) translateX(2.0611944605px);\n  }\n  96% {\n    transform: translateY(16.8px) translateX(1.441332186px);\n  }\n  98% {\n    transform: translateY(17.15px) translateX(0.7534862344px);\n  }\n  100% {\n    transform: translateY(17.5px) translateX(0.0000000001px);\n  }\n}\n/* Tornado */\n@keyframes translateTornado1 {\n  0% {\n    transform: translateY(0);\n  }\n  25% {\n    transform: translateX(3.997px);\n  }\n  75% {\n    transform: translateX(-3.997px);\n  }\n  100% {\n    transform: translateX(0);\n  }\n}\n@keyframes translateTornado2 {\n  0% {\n    transform: translateY(0);\n  }\n  25% {\n    transform: translateX(2.002px);\n  }\n  75% {\n    transform: translateX(-2.002px);\n  }\n  100% {\n    transform: translateX(0);\n  }\n}\n@keyframes translateTornado3 {\n  0% {\n    transform: translateY(0);\n  }\n  25% {\n    transform: translateX(8.001px);\n  }\n  75% {\n    transform: translateX(-8.001px);\n  }\n  100% {\n    transform: translateX(0);\n  }\n}\n@keyframes translateTornado4 {\n  0% {\n    transform: translateY(0);\n  }\n  25% {\n    transform: translateX(5.999px);\n  }\n  75% {\n    transform: translateX(-5.999px);\n  }\n  100% {\n    transform: translateX(0);\n  }\n}\n@keyframes translateTornado5 {\n  0% {\n    transform: translateY(0);\n  }\n  25% {\n    transform: translateX(10.003px);\n  }\n  75% {\n    transform: translateX(-10.003px);\n  }\n  100% {\n    transform: translateX(0);\n  }\n}\n@keyframes translateTornado6 {\n  0% {\n    transform: translateY(0);\n  }\n  25% {\n    transform: translateX(5.999px);\n  }\n  75% {\n    transform: translateX(-5.999px);\n  }\n  100% {\n    transform: translateX(0);\n  }\n}\n@keyframes fillOpacityLightning {\n  0% {\n    fill-opacity: 0;\n    stroke-opacity: 0;\n  }\n  1% {\n    fill-opacity: 1;\n    stroke-opacity: 1;\n  }\n  7% {\n    fill-opacity: 0;\n    stroke-opacity: 0;\n  }\n  50% {\n    fill-opacity: 0;\n    stroke-opacity: 0;\n  }\n  51% {\n    fill-opacity: 1;\n    stroke-opacity: 1;\n  }\n  53% {\n    fill-opacity: 0;\n    stroke-opacity: 0;\n  }\n  54% {\n    fill-opacity: 1;\n    stroke-opacity: 1;\n  }\n  60% {\n    fill-opacity: 0;\n    stroke-opacity: 0;\n  }\n  100% {\n    fill-opacity: 0;\n    stroke-opacity: 0;\n  }\n}\n@keyframes translateFog {\n  0% {\n    transform: translateY(0);\n  }\n  25% {\n    transform: translateX(2.499px);\n  }\n  75% {\n    transform: translateX(-2.499px);\n  }\n  100% {\n    transform: translateX(0);\n  }\n}\n@keyframes fillOpacityFog {\n  0% {\n    fill-opacity: 0.5;\n    stroke-opacity: 0.5;\n  }\n  50% {\n    fill-opacity: 1;\n    stroke-opacity: 1;\n  }\n  100% {\n    fill-opacity: 0.5;\n    stroke-opacity: 0.5;\n  }\n}\n@keyframes translateSunrise {\n  0% {\n    transform: translateY(0);\n  }\n  25% {\n    transform: translateY(-16.002px);\n  }\n  100% {\n    transform: translateY(-16.002px);\n  }\n}\n@keyframes translateSunset {\n  0% {\n    transform: translateY(-16.002px);\n  }\n  25% {\n    transform: translateY(-3.997px);\n  }\n  100% {\n    transform: translateY(-3.997px);\n  }\n}\n@keyframes translateArrowDown {\n  0% {\n    transform: translateY(2.002px);\n  }\n  100% {\n    transform: translateY(4.998px);\n  }\n}\n@keyframes translateArrowUp {\n  0% {\n    transform: translateY(-2.002px);\n  }\n  100% {\n    transform: translateY(-4.998px);\n  }\n}\n@keyframes translateWind {\n  0% {\n    transform: translateY(0);\n  }\n  25% {\n    transform: translateX(4.998px);\n  }\n  75% {\n    transform: translateX(-4.998px);\n  }\n  100% {\n    transform: translateX(0);\n  }\n}\n/**\n * @package IcoFont by ThemeHunt - https://themehunt.com\n * @version 1.0.0 Beta\n * @author IcoFont http://icofont.com\n * @copyright Copyright (c) 2018 IcoFont\n * @license - http://icofont.com/license/\n*/\n@font-face {\n  font-family: \"icofont\";\n  src: url(\"../../../fonts/ico/icofont.eot?v=1.0.0-beta\");\n  src: url(\"../../../fonts/ico/icofont.eot?v=1.0.0-beta#iefix\") format(\"embedded-opentype\"), url(\"../../../fonts/ico/icofont.ttf?v=1.0.0-beta\") format(\"truetype\"), url(\"../../../fonts/ico/icofont.woff?v=1.0.0-beta\") format(\"woff\"), url(\"../../../fonts/ico/icofont.svg?v=1.0.0-beta#icofont\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n}\n.icofont {\n  font-family: \"IcoFont\" !important;\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icofont-angry-monster:before {\n  content: \"\\e901\";\n}\n\n.icofont-bathtub:before {\n  content: \"\\e902\";\n}\n\n.icofont-bird-wings:before {\n  content: \"\\e903\";\n}\n\n.icofont-bow:before {\n  content: \"\\e904\";\n}\n\n.icofont-brain-alt:before {\n  content: \"\\e905\";\n}\n\n.icofont-butterfly-alt:before {\n  content: \"\\e906\";\n}\n\n.icofont-castle:before {\n  content: \"\\e907\";\n}\n\n.icofont-circuit:before {\n  content: \"\\e908\";\n}\n\n.icofont-dart:before {\n  content: \"\\e909\";\n}\n\n.icofont-dice-alt:before {\n  content: \"\\e90a\";\n}\n\n.icofont-disability-race:before {\n  content: \"\\e90b\";\n}\n\n.icofont-diving-goggle:before {\n  content: \"\\e90c\";\n}\n\n.icofont-fire-alt:before {\n  content: \"\\e90d\";\n}\n\n.icofont-flame-torch:before {\n  content: \"\\e90e\";\n}\n\n.icofont-flora-flower:before {\n  content: \"\\e90f\";\n}\n\n.icofont-flora:before {\n  content: \"\\e910\";\n}\n\n.icofont-gift-box:before {\n  content: \"\\e911\";\n}\n\n.icofont-halloween-pumpkin:before {\n  content: \"\\e912\";\n}\n\n.icofont-hand-power:before {\n  content: \"\\e913\";\n}\n\n.icofont-hand-thunder:before {\n  content: \"\\e914\";\n}\n\n.icofont-king-crown:before {\n  content: \"\\e915\";\n}\n\n.icofont-king-monster:before {\n  content: \"\\e916\";\n}\n\n.icofont-love:before {\n  content: \"\\e917\";\n}\n\n.icofont-magician-hat:before {\n  content: \"\\e918\";\n}\n\n.icofont-native-american:before {\n  content: \"\\e919\";\n}\n\n.icofont-open-eye:before {\n  content: \"\\e91a\";\n}\n\n.icofont-owl-look:before {\n  content: \"\\e91b\";\n}\n\n.icofont-phoenix:before {\n  content: \"\\e91c\";\n}\n\n.icofont-queen-crown:before {\n  content: \"\\e91d\";\n}\n\n.icofont-robot-face:before {\n  content: \"\\e91e\";\n}\n\n.icofont-sand-clock:before {\n  content: \"\\e91f\";\n}\n\n.icofont-shield-alt:before {\n  content: \"\\e920\";\n}\n\n.icofont-ship-wheel:before {\n  content: \"\\e921\";\n}\n\n.icofont-skull-danger:before {\n  content: \"\\e922\";\n}\n\n.icofont-skull-face:before {\n  content: \"\\e923\";\n}\n\n.icofont-snail:before {\n  content: \"\\e924\";\n}\n\n.icofont-snow-alt:before {\n  content: \"\\e925\";\n}\n\n.icofont-snow-flake:before {\n  content: \"\\e926\";\n}\n\n.icofont-snowmobile:before {\n  content: \"\\e927\";\n}\n\n.icofont-space-shuttle:before {\n  content: \"\\e928\";\n}\n\n.icofont-star-shape:before {\n  content: \"\\e929\";\n}\n\n.icofont-swirl:before {\n  content: \"\\e92a\";\n}\n\n.icofont-tattoo-wing:before {\n  content: \"\\e92b\";\n}\n\n.icofont-throne:before {\n  content: \"\\e92c\";\n}\n\n.icofont-touch:before {\n  content: \"\\e92d\";\n}\n\n.icofont-tree-alt:before {\n  content: \"\\e92e\";\n}\n\n.icofont-triangle:before {\n  content: \"\\e92f\";\n}\n\n.icofont-unity-hand:before {\n  content: \"\\e930\";\n}\n\n.icofont-weed:before {\n  content: \"\\e931\";\n}\n\n.icofont-woman-bird:before {\n  content: \"\\e932\";\n}\n\n.icofont-animal-bat:before {\n  content: \"\\e933\";\n}\n\n.icofont-animal-bear-tracks:before {\n  content: \"\\e934\";\n}\n\n.icofont-animal-bear:before {\n  content: \"\\e935\";\n}\n\n.icofont-animal-bird-alt:before {\n  content: \"\\e936\";\n}\n\n.icofont-animal-bird:before {\n  content: \"\\e937\";\n}\n\n.icofont-animal-bone:before {\n  content: \"\\e938\";\n}\n\n.icofont-animal-bull:before {\n  content: \"\\e939\";\n}\n\n.icofont-animal-camel-alt:before {\n  content: \"\\e93a\";\n}\n\n.icofont-animal-camel-head:before {\n  content: \"\\e93b\";\n}\n\n.icofont-animal-camel:before {\n  content: \"\\e93c\";\n}\n\n.icofont-animal-cat-alt-1:before {\n  content: \"\\e93d\";\n}\n\n.icofont-animal-cat-alt-2:before {\n  content: \"\\e93e\";\n}\n\n.icofont-animal-cat-alt-3:before {\n  content: \"\\e93f\";\n}\n\n.icofont-animal-cat-alt-4:before {\n  content: \"\\e940\";\n}\n\n.icofont-animal-cat-with-dog:before {\n  content: \"\\e941\";\n}\n\n.icofont-animal-cat:before {\n  content: \"\\e942\";\n}\n\n.icofont-animal-cow-head:before {\n  content: \"\\e943\";\n}\n\n.icofont-animal-cow:before {\n  content: \"\\e944\";\n}\n\n.icofont-animal-crab:before {\n  content: \"\\e945\";\n}\n\n.icofont-animal-crocodile:before {\n  content: \"\\e946\";\n}\n\n.icofont-animal-deer-head:before {\n  content: \"\\e947\";\n}\n\n.icofont-animal-dog-alt:before {\n  content: \"\\e948\";\n}\n\n.icofont-animal-dog-barking:before {\n  content: \"\\e949\";\n}\n\n.icofont-animal-dog:before {\n  content: \"\\e94a\";\n}\n\n.icofont-animal-dolphin:before {\n  content: \"\\e94b\";\n}\n\n.icofont-animal-duck-tracks:before {\n  content: \"\\e94c\";\n}\n\n.icofont-animal-eagle-head:before {\n  content: \"\\e94d\";\n}\n\n.icofont-animal-eaten-fish:before {\n  content: \"\\e94e\";\n}\n\n.icofont-animal-elephant-alt:before {\n  content: \"\\e94f\";\n}\n\n.icofont-animal-elephant-head-alt:before {\n  content: \"\\e950\";\n}\n\n.icofont-animal-elephant-head:before {\n  content: \"\\e951\";\n}\n\n.icofont-animal-elephant:before {\n  content: \"\\e952\";\n}\n\n.icofont-animal-elk:before {\n  content: \"\\e953\";\n}\n\n.icofont-animal-fish-alt-1:before {\n  content: \"\\e954\";\n}\n\n.icofont-animal-fish-alt-2:before {\n  content: \"\\e955\";\n}\n\n.icofont-animal-fish-alt-3:before {\n  content: \"\\e956\";\n}\n\n.icofont-animal-fish-alt-4:before {\n  content: \"\\e957\";\n}\n\n.icofont-animal-fish:before {\n  content: \"\\e958\";\n}\n\n.icofont-animal-fox-alt:before {\n  content: \"\\e959\";\n}\n\n.icofont-animal-fox:before {\n  content: \"\\e95a\";\n}\n\n.icofont-animal-frog-tracks:before {\n  content: \"\\e95b\";\n}\n\n.icofont-animal-frog:before {\n  content: \"\\e95c\";\n}\n\n.icofont-animal-froggy:before {\n  content: \"\\e95d\";\n}\n\n.icofont-animal-giraffe-alt:before {\n  content: \"\\e95e\";\n}\n\n.icofont-animal-giraffe:before {\n  content: \"\\e95f\";\n}\n\n.icofont-animal-goat-head-alt-1:before {\n  content: \"\\e960\";\n}\n\n.icofont-animal-goat-head-alt-2:before {\n  content: \"\\e961\";\n}\n\n.icofont-animal-goat-head:before {\n  content: \"\\e962\";\n}\n\n.icofont-animal-gorilla:before {\n  content: \"\\e963\";\n}\n\n.icofont-animal-hen-tracks:before {\n  content: \"\\e964\";\n}\n\n.icofont-animal-horse-head-alt-1:before {\n  content: \"\\e965\";\n}\n\n.icofont-animal-horse-head-alt-2:before {\n  content: \"\\e966\";\n}\n\n.icofont-animal-horse-head:before {\n  content: \"\\e967\";\n}\n\n.icofont-animal-horse-tracks:before {\n  content: \"\\e968\";\n}\n\n.icofont-animal-jellyfish:before {\n  content: \"\\e969\";\n}\n\n.icofont-animal-kangaroo:before {\n  content: \"\\e96a\";\n}\n\n.icofont-animal-lemur:before {\n  content: \"\\e96b\";\n}\n\n.icofont-animal-lion-alt:before {\n  content: \"\\e96c\";\n}\n\n.icofont-animal-lion-head-alt:before {\n  content: \"\\e96d\";\n}\n\n.icofont-animal-lion-head:before {\n  content: \"\\e96e\";\n}\n\n.icofont-animal-lion:before {\n  content: \"\\e96f\";\n}\n\n.icofont-animal-monkey-alt-1:before {\n  content: \"\\e970\";\n}\n\n.icofont-animal-monkey-alt-2:before {\n  content: \"\\e971\";\n}\n\n.icofont-animal-monkey-alt-3:before {\n  content: \"\\e972\";\n}\n\n.icofont-animal-monkey:before {\n  content: \"\\e973\";\n}\n\n.icofont-animal-octopus-alt:before {\n  content: \"\\e974\";\n}\n\n.icofont-animal-octopus:before {\n  content: \"\\e975\";\n}\n\n.icofont-animal-owl:before {\n  content: \"\\e976\";\n}\n\n.icofont-animal-panda-alt:before {\n  content: \"\\e977\";\n}\n\n.icofont-animal-panda:before {\n  content: \"\\e978\";\n}\n\n.icofont-animal-panther:before {\n  content: \"\\e979\";\n}\n\n.icofont-animal-parrot-lip:before {\n  content: \"\\e97a\";\n}\n\n.icofont-animal-parrot:before {\n  content: \"\\e97b\";\n}\n\n.icofont-animal-paw:before {\n  content: \"\\e97c\";\n}\n\n.icofont-animal-pelican:before {\n  content: \"\\e97d\";\n}\n\n.icofont-animal-penguin:before {\n  content: \"\\e97e\";\n}\n\n.icofont-animal-pig-alt:before {\n  content: \"\\e97f\";\n}\n\n.icofont-animal-pig:before {\n  content: \"\\e980\";\n}\n\n.icofont-animal-pigeon-alt:before {\n  content: \"\\e981\";\n}\n\n.icofont-animal-pigeon:before {\n  content: \"\\e982\";\n}\n\n.icofont-animal-pigeons:before {\n  content: \"\\e983\";\n}\n\n.icofont-animal-rabbit-running:before {\n  content: \"\\e984\";\n}\n\n.icofont-animal-rat-alt:before {\n  content: \"\\e985\";\n}\n\n.icofont-animal-rhino-head:before {\n  content: \"\\e986\";\n}\n\n.icofont-animal-rhino:before {\n  content: \"\\e987\";\n}\n\n.icofont-animal-rooster:before {\n  content: \"\\e988\";\n}\n\n.icofont-animal-seahorse:before {\n  content: \"\\e989\";\n}\n\n.icofont-animal-seal:before {\n  content: \"\\e98a\";\n}\n\n.icofont-animal-shrimp:before {\n  content: \"\\e98b\";\n}\n\n.icofont-animal-snail-alt-1:before {\n  content: \"\\e98c\";\n}\n\n.icofont-animal-snail-alt-2:before {\n  content: \"\\e98d\";\n}\n\n.icofont-animal-snail:before {\n  content: \"\\e98e\";\n}\n\n.icofont-animal-snake:before {\n  content: \"\\e98f\";\n}\n\n.icofont-animal-squid:before {\n  content: \"\\e990\";\n}\n\n.icofont-animal-squirrel:before {\n  content: \"\\e991\";\n}\n\n.icofont-animal-tiger-alt:before {\n  content: \"\\e992\";\n}\n\n.icofont-animal-tiger:before {\n  content: \"\\e993\";\n}\n\n.icofont-animal-turtle:before {\n  content: \"\\e994\";\n}\n\n.icofont-animal-whale:before {\n  content: \"\\e995\";\n}\n\n.icofont-animal-woodpecker:before {\n  content: \"\\e996\";\n}\n\n.icofont-animal-zebra:before {\n  content: \"\\e997\";\n}\n\n.icofont-brand-acer:before {\n  content: \"\\e998\";\n}\n\n.icofont-brand-adidas:before {\n  content: \"\\e999\";\n}\n\n.icofont-brand-adobe:before {\n  content: \"\\e99a\";\n}\n\n.icofont-brand-air-new-zealand:before {\n  content: \"\\e99b\";\n}\n\n.icofont-brand-airbnb:before {\n  content: \"\\e99c\";\n}\n\n.icofont-brand-aircell:before {\n  content: \"\\e99d\";\n}\n\n.icofont-brand-airtel:before {\n  content: \"\\e99e\";\n}\n\n.icofont-brand-alcatel:before {\n  content: \"\\e99f\";\n}\n\n.icofont-brand-alibaba:before {\n  content: \"\\e9a0\";\n}\n\n.icofont-brand-aliexpress:before {\n  content: \"\\e9a1\";\n}\n\n.icofont-brand-alipay:before {\n  content: \"\\e9a2\";\n}\n\n.icofont-brand-amazon:before {\n  content: \"\\e9a3\";\n}\n\n.icofont-brand-amd:before {\n  content: \"\\e9a4\";\n}\n\n.icofont-brand-american-airlines:before {\n  content: \"\\e9a5\";\n}\n\n.icofont-brand-android-robot:before {\n  content: \"\\e9a6\";\n}\n\n.icofont-brand-android:before {\n  content: \"\\e9a7\";\n}\n\n.icofont-brand-aol:before {\n  content: \"\\e9a8\";\n}\n\n.icofont-brand-apple:before {\n  content: \"\\e9a9\";\n}\n\n.icofont-brand-appstore:before {\n  content: \"\\e9aa\";\n}\n\n.icofont-brand-asus:before {\n  content: \"\\e9ab\";\n}\n\n.icofont-brand-ati:before {\n  content: \"\\e9ac\";\n}\n\n.icofont-brand-att:before {\n  content: \"\\e9ad\";\n}\n\n.icofont-brand-audi:before {\n  content: \"\\e9ae\";\n}\n\n.icofont-brand-axiata:before {\n  content: \"\\e9af\";\n}\n\n.icofont-brand-bada:before {\n  content: \"\\e9b0\";\n}\n\n.icofont-brand-bbc:before {\n  content: \"\\e9b1\";\n}\n\n.icofont-brand-bing:before {\n  content: \"\\e9b2\";\n}\n\n.icofont-brand-blackberry:before {\n  content: \"\\e9b3\";\n}\n\n.icofont-brand-bmw:before {\n  content: \"\\e9b4\";\n}\n\n.icofont-brand-box:before {\n  content: \"\\e9b5\";\n}\n\n.icofont-brand-burger-king:before {\n  content: \"\\e9b6\";\n}\n\n.icofont-brand-business-insider:before {\n  content: \"\\e9b7\";\n}\n\n.icofont-brand-buzzfeed:before {\n  content: \"\\e9b8\";\n}\n\n.icofont-brand-cannon:before {\n  content: \"\\e9b9\";\n}\n\n.icofont-brand-casio:before {\n  content: \"\\e9ba\";\n}\n\n.icofont-brand-china-mobile:before {\n  content: \"\\e9bb\";\n}\n\n.icofont-brand-china-telecom:before {\n  content: \"\\e9bc\";\n}\n\n.icofont-brand-china-unicom:before {\n  content: \"\\e9bd\";\n}\n\n.icofont-brand-cisco:before {\n  content: \"\\e9be\";\n}\n\n.icofont-brand-citibank:before {\n  content: \"\\e9bf\";\n}\n\n.icofont-brand-cnet:before {\n  content: \"\\e9c0\";\n}\n\n.icofont-brand-cnn:before {\n  content: \"\\e9c1\";\n}\n\n.icofont-brand-cocal-cola:before {\n  content: \"\\e9c2\";\n}\n\n.icofont-brand-compaq:before {\n  content: \"\\e9c3\";\n}\n\n.icofont-brand-copy:before {\n  content: \"\\e9c4\";\n}\n\n.icofont-brand-debian:before {\n  content: \"\\e9c5\";\n}\n\n.icofont-brand-delicious:before {\n  content: \"\\e9c6\";\n}\n\n.icofont-brand-dell:before {\n  content: \"\\e9c7\";\n}\n\n.icofont-brand-designbump:before {\n  content: \"\\e9c8\";\n}\n\n.icofont-brand-designfloat:before {\n  content: \"\\e9c9\";\n}\n\n.icofont-brand-disney:before {\n  content: \"\\e9ca\";\n}\n\n.icofont-brand-dodge:before {\n  content: \"\\e9cb\";\n}\n\n.icofont-brand-dove:before {\n  content: \"\\e9cc\";\n}\n\n.icofont-brand-ebay:before {\n  content: \"\\e9cd\";\n}\n\n.icofont-brand-eleven:before {\n  content: \"\\e9ce\";\n}\n\n.icofont-brand-emirates:before {\n  content: \"\\e9cf\";\n}\n\n.icofont-brand-espn:before {\n  content: \"\\e9d0\";\n}\n\n.icofont-brand-etihad-airways:before {\n  content: \"\\e9d1\";\n}\n\n.icofont-brand-etisalat:before {\n  content: \"\\e9d2\";\n}\n\n.icofont-brand-etsy:before {\n  content: \"\\e9d3\";\n}\n\n.icofont-brand-facebook:before {\n  content: \"\\e9d4\";\n}\n\n.icofont-brand-fastrack:before {\n  content: \"\\e9d5\";\n}\n\n.icofont-brand-fedex:before {\n  content: \"\\e9d6\";\n}\n\n.icofont-brand-ferrari:before {\n  content: \"\\e9d7\";\n}\n\n.icofont-brand-fitbit:before {\n  content: \"\\e9d8\";\n}\n\n.icofont-brand-flikr:before {\n  content: \"\\e9d9\";\n}\n\n.icofont-brand-forbes:before {\n  content: \"\\e9da\";\n}\n\n.icofont-brand-foursquare:before {\n  content: \"\\e9db\";\n}\n\n.icofont-brand-fox:before {\n  content: \"\\e9dc\";\n}\n\n.icofont-brand-foxconn:before {\n  content: \"\\e9dd\";\n}\n\n.icofont-brand-fujitsu:before {\n  content: \"\\e9de\";\n}\n\n.icofont-brand-general-electric:before {\n  content: \"\\e9df\";\n}\n\n.icofont-brand-gillette:before {\n  content: \"\\e9e0\";\n}\n\n.icofont-brand-gizmodo:before {\n  content: \"\\e9e1\";\n}\n\n.icofont-brand-gnome:before {\n  content: \"\\e9e2\";\n}\n\n.icofont-brand-google:before {\n  content: \"\\e9e3\";\n}\n\n.icofont-brand-gopro:before {\n  content: \"\\e9e4\";\n}\n\n.icofont-brand-gucci:before {\n  content: \"\\e9e5\";\n}\n\n.icofont-brand-hallmark:before {\n  content: \"\\e9e6\";\n}\n\n.icofont-brand-hi5:before {\n  content: \"\\e9e7\";\n}\n\n.icofont-brand-honda:before {\n  content: \"\\e9e8\";\n}\n\n.icofont-brand-hp:before {\n  content: \"\\e9e9\";\n}\n\n.icofont-brand-hsbc:before {\n  content: \"\\e9ea\";\n}\n\n.icofont-brand-htc:before {\n  content: \"\\e9eb\";\n}\n\n.icofont-brand-huawei:before {\n  content: \"\\e9ec\";\n}\n\n.icofont-brand-hulu:before {\n  content: \"\\e9ed\";\n}\n\n.icofont-brand-hyundai:before {\n  content: \"\\e9ee\";\n}\n\n.icofont-brand-ibm:before {\n  content: \"\\e9ef\";\n}\n\n.icofont-brand-icofont:before {\n  content: \"\\e9f0\";\n}\n\n.icofont-brand-icq:before {\n  content: \"\\e9f1\";\n}\n\n.icofont-brand-ikea:before {\n  content: \"\\e9f2\";\n}\n\n.icofont-brand-imdb:before {\n  content: \"\\e9f3\";\n}\n\n.icofont-brand-indiegogo:before {\n  content: \"\\e9f4\";\n}\n\n.icofont-brand-intel:before {\n  content: \"\\e9f5\";\n}\n\n.icofont-brand-ipair:before {\n  content: \"\\e9f6\";\n}\n\n.icofont-brand-jaguar:before {\n  content: \"\\e9f7\";\n}\n\n.icofont-brand-java:before {\n  content: \"\\e9f8\";\n}\n\n.icofont-brand-joomshaper:before {\n  content: \"\\e9f9\";\n}\n\n.icofont-brand-kickstarter:before {\n  content: \"\\e9fa\";\n}\n\n.icofont-brand-kik:before {\n  content: \"\\e9fb\";\n}\n\n.icofont-brand-lastfm:before {\n  content: \"\\e9fc\";\n}\n\n.icofont-brand-lego:before {\n  content: \"\\e9fd\";\n}\n\n.icofont-brand-lenovo:before {\n  content: \"\\e9fe\";\n}\n\n.icofont-brand-levis:before {\n  content: \"\\e9ff\";\n}\n\n.icofont-brand-lexus:before {\n  content: \"\\ea00\";\n}\n\n.icofont-brand-lg:before {\n  content: \"\\ea01\";\n}\n\n.icofont-brand-life-hacker:before {\n  content: \"\\ea02\";\n}\n\n.icofont-brand-line-messenger:before {\n  content: \"\\ea03\";\n}\n\n.icofont-brand-linkedin:before {\n  content: \"\\ea04\";\n}\n\n.icofont-brand-linux-mint:before {\n  content: \"\\ea05\";\n}\n\n.icofont-brand-linux:before {\n  content: \"\\ea06\";\n}\n\n.icofont-brand-lionix:before {\n  content: \"\\ea07\";\n}\n\n.icofont-brand-live-messenger:before {\n  content: \"\\ea08\";\n}\n\n.icofont-brand-loreal:before {\n  content: \"\\ea09\";\n}\n\n.icofont-brand-louis-vuitton:before {\n  content: \"\\ea0a\";\n}\n\n.icofont-brand-mac-os:before {\n  content: \"\\ea0b\";\n}\n\n.icofont-brand-marvel-app:before {\n  content: \"\\ea0c\";\n}\n\n.icofont-brand-mashable:before {\n  content: \"\\ea0d\";\n}\n\n.icofont-brand-mazda:before {\n  content: \"\\ea0e\";\n}\n\n.icofont-brand-mcdonals:before {\n  content: \"\\ea0f\";\n}\n\n.icofont-brand-mercedes:before {\n  content: \"\\ea10\";\n}\n\n.icofont-brand-micromax:before {\n  content: \"\\ea11\";\n}\n\n.icofont-brand-microsoft:before {\n  content: \"\\ea12\";\n}\n\n.icofont-brand-mobileme:before {\n  content: \"\\ea13\";\n}\n\n.icofont-brand-mobily:before {\n  content: \"\\ea14\";\n}\n\n.icofont-brand-motorola:before {\n  content: \"\\ea15\";\n}\n\n.icofont-brand-msi:before {\n  content: \"\\ea16\";\n}\n\n.icofont-brand-mts:before {\n  content: \"\\ea17\";\n}\n\n.icofont-brand-myspace:before {\n  content: \"\\ea18\";\n}\n\n.icofont-brand-mytv:before {\n  content: \"\\ea19\";\n}\n\n.icofont-brand-nasa:before {\n  content: \"\\ea1a\";\n}\n\n.icofont-brand-natgeo:before {\n  content: \"\\ea1b\";\n}\n\n.icofont-brand-nbc:before {\n  content: \"\\ea1c\";\n}\n\n.icofont-brand-nescafe:before {\n  content: \"\\ea1d\";\n}\n\n.icofont-brand-nestle:before {\n  content: \"\\ea1e\";\n}\n\n.icofont-brand-netflix:before {\n  content: \"\\ea1f\";\n}\n\n.icofont-brand-nexus:before {\n  content: \"\\ea20\";\n}\n\n.icofont-brand-nike:before {\n  content: \"\\ea21\";\n}\n\n.icofont-brand-nokia:before {\n  content: \"\\ea22\";\n}\n\n.icofont-brand-nvidia:before {\n  content: \"\\ea23\";\n}\n\n.icofont-brand-omega:before {\n  content: \"\\ea24\";\n}\n\n.icofont-brand-opensuse:before {\n  content: \"\\ea25\";\n}\n\n.icofont-brand-oracle:before {\n  content: \"\\ea26\";\n}\n\n.icofont-brand-panasonic:before {\n  content: \"\\ea27\";\n}\n\n.icofont-brand-paypal:before {\n  content: \"\\ea28\";\n}\n\n.icofont-brand-pepsi:before {\n  content: \"\\ea29\";\n}\n\n.icofont-brand-philips:before {\n  content: \"\\ea2a\";\n}\n\n.icofont-brand-pizza-hut:before {\n  content: \"\\ea2b\";\n}\n\n.icofont-brand-playstation:before {\n  content: \"\\ea2c\";\n}\n\n.icofont-brand-puma:before {\n  content: \"\\ea2d\";\n}\n\n.icofont-brand-qatar-air:before {\n  content: \"\\ea2e\";\n}\n\n.icofont-brand-qvc:before {\n  content: \"\\ea2f\";\n}\n\n.icofont-brand-readernaut:before {\n  content: \"\\ea30\";\n}\n\n.icofont-brand-redbull:before {\n  content: \"\\ea31\";\n}\n\n.icofont-brand-reebok:before {\n  content: \"\\ea32\";\n}\n\n.icofont-brand-reuters:before {\n  content: \"\\ea33\";\n}\n\n.icofont-brand-samsung:before {\n  content: \"\\ea34\";\n}\n\n.icofont-brand-sap:before {\n  content: \"\\ea35\";\n}\n\n.icofont-brand-saudia-airlines:before {\n  content: \"\\ea36\";\n}\n\n.icofont-brand-scribd:before {\n  content: \"\\ea37\";\n}\n\n.icofont-brand-shell:before {\n  content: \"\\ea38\";\n}\n\n.icofont-brand-siemens:before {\n  content: \"\\ea39\";\n}\n\n.icofont-brand-sk-telecom:before {\n  content: \"\\ea3a\";\n}\n\n.icofont-brand-slideshare:before {\n  content: \"\\ea3b\";\n}\n\n.icofont-brand-smashing-magazine:before {\n  content: \"\\ea3c\";\n}\n\n.icofont-brand-snapchat:before {\n  content: \"\\ea3d\";\n}\n\n.icofont-brand-sony-ericsson:before {\n  content: \"\\ea3e\";\n}\n\n.icofont-brand-sony:before {\n  content: \"\\ea3f\";\n}\n\n.icofont-brand-soundcloud:before {\n  content: \"\\ea40\";\n}\n\n.icofont-brand-sprint:before {\n  content: \"\\ea41\";\n}\n\n.icofont-brand-squidoo:before {\n  content: \"\\ea42\";\n}\n\n.icofont-brand-starbucks:before {\n  content: \"\\ea43\";\n}\n\n.icofont-brand-stc:before {\n  content: \"\\ea44\";\n}\n\n.icofont-brand-steam:before {\n  content: \"\\ea45\";\n}\n\n.icofont-brand-suzuki:before {\n  content: \"\\ea46\";\n}\n\n.icofont-brand-symbian:before {\n  content: \"\\ea47\";\n}\n\n.icofont-brand-t-mobile:before {\n  content: \"\\ea48\";\n}\n\n.icofont-brand-tango:before {\n  content: \"\\ea49\";\n}\n\n.icofont-brand-target:before {\n  content: \"\\ea4a\";\n}\n\n.icofont-brand-tata-indicom:before {\n  content: \"\\ea4b\";\n}\n\n.icofont-brand-techcrunch:before {\n  content: \"\\ea4c\";\n}\n\n.icofont-brand-telenor:before {\n  content: \"\\ea4d\";\n}\n\n.icofont-brand-teliasonera:before {\n  content: \"\\ea4e\";\n}\n\n.icofont-brand-tesla:before {\n  content: \"\\ea4f\";\n}\n\n.icofont-brand-the-verge:before {\n  content: \"\\ea50\";\n}\n\n.icofont-brand-thenextweb:before {\n  content: \"\\ea51\";\n}\n\n.icofont-brand-toshiba:before {\n  content: \"\\ea52\";\n}\n\n.icofont-brand-toyota:before {\n  content: \"\\ea53\";\n}\n\n.icofont-brand-tribenet:before {\n  content: \"\\ea54\";\n}\n\n.icofont-brand-ubuntu:before {\n  content: \"\\ea55\";\n}\n\n.icofont-brand-unilever:before {\n  content: \"\\ea56\";\n}\n\n.icofont-brand-vaio:before {\n  content: \"\\ea57\";\n}\n\n.icofont-brand-verizon:before {\n  content: \"\\ea58\";\n}\n\n.icofont-brand-viber:before {\n  content: \"\\ea59\";\n}\n\n.icofont-brand-vodafone:before {\n  content: \"\\ea5a\";\n}\n\n.icofont-brand-volkswagen:before {\n  content: \"\\ea5b\";\n}\n\n.icofont-brand-walmart:before {\n  content: \"\\ea5c\";\n}\n\n.icofont-brand-warnerbros:before {\n  content: \"\\ea5d\";\n}\n\n.icofont-brand-whatsapp:before {\n  content: \"\\ea5e\";\n}\n\n.icofont-brand-wikipedia:before {\n  content: \"\\ea5f\";\n}\n\n.icofont-brand-windows:before {\n  content: \"\\ea60\";\n}\n\n.icofont-brand-wire:before {\n  content: \"\\ea61\";\n}\n\n.icofont-brand-yahoobuzz:before {\n  content: \"\\ea62\";\n}\n\n.icofont-brand-yamaha:before {\n  content: \"\\ea63\";\n}\n\n.icofont-brand-youtube:before {\n  content: \"\\ea64\";\n}\n\n.icofont-brand-zain:before {\n  content: \"\\ea65\";\n}\n\n.icofont-bank-alt:before {\n  content: \"\\ea66\";\n}\n\n.icofont-barcode:before {\n  content: \"\\ea67\";\n}\n\n.icofont-basket:before {\n  content: \"\\ea68\";\n}\n\n.icofont-bill-alt:before {\n  content: \"\\ea69\";\n}\n\n.icofont-billboard:before {\n  content: \"\\ea6a\";\n}\n\n.icofont-briefcase-alt-1:before {\n  content: \"\\ea6b\";\n}\n\n.icofont-briefcase-alt-2:before {\n  content: \"\\ea6c\";\n}\n\n.icofont-building-alt:before {\n  content: \"\\ea6d\";\n}\n\n.icofont-businessman:before {\n  content: \"\\ea6e\";\n}\n\n.icofont-businesswoman:before {\n  content: \"\\ea6f\";\n}\n\n.icofont-cart-alt:before {\n  content: \"\\ea70\";\n}\n\n.icofont-chair:before {\n  content: \"\\ea71\";\n}\n\n.icofont-clip:before {\n  content: \"\\ea72\";\n}\n\n.icofont-coins:before {\n  content: \"\\ea73\";\n}\n\n.icofont-company:before {\n  content: \"\\ea74\";\n}\n\n.icofont-contact-add:before {\n  content: \"\\ea75\";\n}\n\n.icofont-deal:before {\n  content: \"\\ea76\";\n}\n\n.icofont-files:before {\n  content: \"\\ea77\";\n}\n\n.icofont-growth:before {\n  content: \"\\ea78\";\n}\n\n.icofont-id-card:before {\n  content: \"\\ea79\";\n}\n\n.icofont-idea:before {\n  content: \"\\ea7a\";\n}\n\n.icofont-list:before {\n  content: \"\\ea7b\";\n}\n\n.icofont-meeting-add:before {\n  content: \"\\ea7c\";\n}\n\n.icofont-money-bag:before {\n  content: \"\\ea7d\";\n}\n\n.icofont-people:before {\n  content: \"\\ea7e\";\n}\n\n.icofont-pie-chart:before {\n  content: \"\\ea7f\";\n}\n\n.icofont-presentation-alt:before {\n  content: \"\\ea80\";\n}\n\n.icofont-stamp:before {\n  content: \"\\ea81\";\n}\n\n.icofont-stock-mobile:before {\n  content: \"\\ea82\";\n}\n\n.icofont-support:before {\n  content: \"\\ea83\";\n}\n\n.icofont-tasks-alt:before {\n  content: \"\\ea84\";\n}\n\n.icofont-wheel:before {\n  content: \"\\ea85\";\n}\n\n.icofont-chart-arrows-axis:before {\n  content: \"\\ea86\";\n}\n\n.icofont-chart-bar-graph:before {\n  content: \"\\ea87\";\n}\n\n.icofont-chart-flow-alt-1:before {\n  content: \"\\ea88\";\n}\n\n.icofont-chart-flow-alt-2:before {\n  content: \"\\ea89\";\n}\n\n.icofont-chart-flow:before {\n  content: \"\\ea8a\";\n}\n\n.icofont-chart-histogram-alt:before {\n  content: \"\\ea8b\";\n}\n\n.icofont-chart-histogram:before {\n  content: \"\\ea8c\";\n}\n\n.icofont-chart-line-alt:before {\n  content: \"\\ea8d\";\n}\n\n.icofont-chart-line:before {\n  content: \"\\ea8e\";\n}\n\n.icofont-chart-pie-alt:before {\n  content: \"\\ea8f\";\n}\n\n.icofont-chart-pie:before {\n  content: \"\\ea90\";\n}\n\n.icofont-chart-radar-graph:before {\n  content: \"\\ea91\";\n}\n\n.icofont-cur-afghani-false:before {\n  content: \"\\ea92\";\n}\n\n.icofont-cur-afghani-minus:before {\n  content: \"\\ea93\";\n}\n\n.icofont-cur-afghani-plus:before {\n  content: \"\\ea94\";\n}\n\n.icofont-cur-afghani-true:before {\n  content: \"\\ea95\";\n}\n\n.icofont-cur-afghani:before {\n  content: \"\\ea96\";\n}\n\n.icofont-cur-baht-false:before {\n  content: \"\\ea97\";\n}\n\n.icofont-cur-baht-minus:before {\n  content: \"\\ea98\";\n}\n\n.icofont-cur-baht-plus:before {\n  content: \"\\ea99\";\n}\n\n.icofont-cur-baht-true:before {\n  content: \"\\ea9a\";\n}\n\n.icofont-cur-baht:before {\n  content: \"\\ea9b\";\n}\n\n.icofont-cur-bitcoin-false:before {\n  content: \"\\ea9c\";\n}\n\n.icofont-cur-bitcoin-minus:before {\n  content: \"\\ea9d\";\n}\n\n.icofont-cur-bitcoin-plus:before {\n  content: \"\\ea9e\";\n}\n\n.icofont-cur-bitcoin-true:before {\n  content: \"\\ea9f\";\n}\n\n.icofont-cur-bitcoin:before {\n  content: \"\\eaa0\";\n}\n\n.icofont-cur-dollar-flase:before {\n  content: \"\\eaa1\";\n}\n\n.icofont-cur-dollar-minus:before {\n  content: \"\\eaa2\";\n}\n\n.icofont-cur-dollar-plus:before {\n  content: \"\\eaa3\";\n}\n\n.icofont-cur-dollar-true:before {\n  content: \"\\eaa4\";\n}\n\n.icofont-cur-dollar:before {\n  content: \"\\eaa5\";\n}\n\n.icofont-cur-dong-false:before {\n  content: \"\\eaa6\";\n}\n\n.icofont-cur-dong-minus:before {\n  content: \"\\eaa7\";\n}\n\n.icofont-cur-dong-plus:before {\n  content: \"\\eaa8\";\n}\n\n.icofont-cur-dong-true:before {\n  content: \"\\eaa9\";\n}\n\n.icofont-cur-dong:before {\n  content: \"\\eaaa\";\n}\n\n.icofont-cur-euro-false:before {\n  content: \"\\eaab\";\n}\n\n.icofont-cur-euro-minus:before {\n  content: \"\\eaac\";\n}\n\n.icofont-cur-euro-plus:before {\n  content: \"\\eaad\";\n}\n\n.icofont-cur-euro-true:before {\n  content: \"\\eaae\";\n}\n\n.icofont-cur-euro:before {\n  content: \"\\eaaf\";\n}\n\n.icofont-cur-frank-false:before {\n  content: \"\\eab0\";\n}\n\n.icofont-cur-frank-minus:before {\n  content: \"\\eab1\";\n}\n\n.icofont-cur-frank-plus:before {\n  content: \"\\eab2\";\n}\n\n.icofont-cur-frank-true:before {\n  content: \"\\eab3\";\n}\n\n.icofont-cur-frank:before {\n  content: \"\\eab4\";\n}\n\n.icofont-cur-hryvnia-false:before {\n  content: \"\\eab5\";\n}\n\n.icofont-cur-hryvnia-minus:before {\n  content: \"\\eab6\";\n}\n\n.icofont-cur-hryvnia-plus:before {\n  content: \"\\eab7\";\n}\n\n.icofont-cur-hryvnia-true:before {\n  content: \"\\eab8\";\n}\n\n.icofont-cur-hryvnia:before {\n  content: \"\\eab9\";\n}\n\n.icofont-cur-lira-false:before {\n  content: \"\\eaba\";\n}\n\n.icofont-cur-lira-minus:before {\n  content: \"\\eabb\";\n}\n\n.icofont-cur-lira-plus:before {\n  content: \"\\eabc\";\n}\n\n.icofont-cur-lira-true:before {\n  content: \"\\eabd\";\n}\n\n.icofont-cur-lira:before {\n  content: \"\\eabe\";\n}\n\n.icofont-cur-peseta-false:before {\n  content: \"\\eabf\";\n}\n\n.icofont-cur-peseta-minus:before {\n  content: \"\\eac0\";\n}\n\n.icofont-cur-peseta-plus:before {\n  content: \"\\eac1\";\n}\n\n.icofont-cur-peseta-true:before {\n  content: \"\\eac2\";\n}\n\n.icofont-cur-peseta:before {\n  content: \"\\eac3\";\n}\n\n.icofont-cur-peso-false:before {\n  content: \"\\eac4\";\n}\n\n.icofont-cur-peso-minus:before {\n  content: \"\\eac5\";\n}\n\n.icofont-cur-peso-plus:before {\n  content: \"\\eac6\";\n}\n\n.icofont-cur-peso-true:before {\n  content: \"\\eac7\";\n}\n\n.icofont-cur-peso:before {\n  content: \"\\eac8\";\n}\n\n.icofont-cur-pound-false:before {\n  content: \"\\eac9\";\n}\n\n.icofont-cur-pound-minus:before {\n  content: \"\\eaca\";\n}\n\n.icofont-cur-pound-plus:before {\n  content: \"\\eacb\";\n}\n\n.icofont-cur-pound-true:before {\n  content: \"\\eacc\";\n}\n\n.icofont-cur-pound:before {\n  content: \"\\eacd\";\n}\n\n.icofont-cur-renminbi-false:before {\n  content: \"\\eace\";\n}\n\n.icofont-cur-renminbi-minus:before {\n  content: \"\\eacf\";\n}\n\n.icofont-cur-renminbi-plus:before {\n  content: \"\\ead0\";\n}\n\n.icofont-cur-renminbi-true:before {\n  content: \"\\ead1\";\n}\n\n.icofont-cur-renminbi:before {\n  content: \"\\ead2\";\n}\n\n.icofont-cur-riyal-false:before {\n  content: \"\\ead3\";\n}\n\n.icofont-cur-riyal-minus:before {\n  content: \"\\ead4\";\n}\n\n.icofont-cur-riyal-plus:before {\n  content: \"\\ead5\";\n}\n\n.icofont-cur-riyal-true:before {\n  content: \"\\ead6\";\n}\n\n.icofont-cur-riyal:before {\n  content: \"\\ead7\";\n}\n\n.icofont-cur-rouble-false:before {\n  content: \"\\ead8\";\n}\n\n.icofont-cur-rouble-minus:before {\n  content: \"\\ead9\";\n}\n\n.icofont-cur-rouble-plus:before {\n  content: \"\\eada\";\n}\n\n.icofont-cur-rouble-true:before {\n  content: \"\\eadb\";\n}\n\n.icofont-cur-rouble:before {\n  content: \"\\eadc\";\n}\n\n.icofont-cur-rupee-false:before {\n  content: \"\\eadd\";\n}\n\n.icofont-cur-rupee-minus:before {\n  content: \"\\eade\";\n}\n\n.icofont-cur-rupee-plus:before {\n  content: \"\\eadf\";\n}\n\n.icofont-cur-rupee-true:before {\n  content: \"\\eae0\";\n}\n\n.icofont-cur-rupee:before {\n  content: \"\\eae1\";\n}\n\n.icofont-cur-taka-false:before {\n  content: \"\\eae2\";\n}\n\n.icofont-cur-taka-minus:before {\n  content: \"\\eae3\";\n}\n\n.icofont-cur-taka-plus:before {\n  content: \"\\eae4\";\n}\n\n.icofont-cur-taka-true:before {\n  content: \"\\eae5\";\n}\n\n.icofont-cur-taka:before {\n  content: \"\\eae6\";\n}\n\n.icofont-cur-turkish-lira-false:before {\n  content: \"\\eae7\";\n}\n\n.icofont-cur-turkish-lira-minus:before {\n  content: \"\\eae8\";\n}\n\n.icofont-cur-turkish-lira-plus:before {\n  content: \"\\eae9\";\n}\n\n.icofont-cur-turkish-lira-true:before {\n  content: \"\\eaea\";\n}\n\n.icofont-cur-turkish-lira:before {\n  content: \"\\eaeb\";\n}\n\n.icofont-cur-won-false:before {\n  content: \"\\eaec\";\n}\n\n.icofont-cur-won-minus:before {\n  content: \"\\eaed\";\n}\n\n.icofont-cur-won-plus:before {\n  content: \"\\eaee\";\n}\n\n.icofont-cur-won-true:before {\n  content: \"\\eaef\";\n}\n\n.icofont-cur-won:before {\n  content: \"\\eaf0\";\n}\n\n.icofont-cur-yen-false:before {\n  content: \"\\eaf1\";\n}\n\n.icofont-cur-yen-minus:before {\n  content: \"\\eaf2\";\n}\n\n.icofont-cur-yen-plus:before {\n  content: \"\\eaf3\";\n}\n\n.icofont-cur-yen-true:before {\n  content: \"\\eaf4\";\n}\n\n.icofont-cur-yen:before {\n  content: \"\\eaf5\";\n}\n\n.icofont-android-nexus:before {\n  content: \"\\eaf6\";\n}\n\n.icofont-android-tablet:before {\n  content: \"\\eaf7\";\n}\n\n.icofont-apple-watch:before {\n  content: \"\\eaf8\";\n}\n\n.icofont-drwaing-tablet:before {\n  content: \"\\eaf9\";\n}\n\n.icofont-earphone:before {\n  content: \"\\eafa\";\n}\n\n.icofont-flash-drive:before {\n  content: \"\\eafb\";\n}\n\n.icofont-game-control:before {\n  content: \"\\eafc\";\n}\n\n.icofont-headphone-alt:before {\n  content: \"\\eafd\";\n}\n\n.icofont-htc-one:before {\n  content: \"\\eafe\";\n}\n\n.icofont-imac:before {\n  content: \"\\eaff\";\n}\n\n.icofont-ipad-touch:before {\n  content: \"\\eb00\";\n}\n\n.icofont-iphone:before {\n  content: \"\\eb01\";\n}\n\n.icofont-ipod-nano:before {\n  content: \"\\eb02\";\n}\n\n.icofont-ipod-touch:before {\n  content: \"\\eb03\";\n}\n\n.icofont-keyboard-alt:before {\n  content: \"\\eb04\";\n}\n\n.icofont-keyboard-wireless:before {\n  content: \"\\eb05\";\n}\n\n.icofont-laptop-alt:before {\n  content: \"\\eb06\";\n}\n\n.icofont-macbook:before {\n  content: \"\\eb07\";\n}\n\n.icofont-magic-mouse:before {\n  content: \"\\eb08\";\n}\n\n.icofont-microphone-alt:before {\n  content: \"\\eb09\";\n}\n\n.icofont-monitor:before {\n  content: \"\\eb0a\";\n}\n\n.icofont-mouse:before {\n  content: \"\\eb0b\";\n}\n\n.icofont-nintendo:before {\n  content: \"\\eb0c\";\n}\n\n.icofont-playstation:before {\n  content: \"\\eb0d\";\n}\n\n.icofont-psvita:before {\n  content: \"\\eb0e\";\n}\n\n.icofont-radio-mic:before {\n  content: \"\\eb0f\";\n}\n\n.icofont-refrigerator:before {\n  content: \"\\eb10\";\n}\n\n.icofont-samsung-galaxy:before {\n  content: \"\\eb11\";\n}\n\n.icofont-surface-tablet:before {\n  content: \"\\eb12\";\n}\n\n.icofont-washing-machine:before {\n  content: \"\\eb13\";\n}\n\n.icofont-wifi-router:before {\n  content: \"\\eb14\";\n}\n\n.icofont-wii-u:before {\n  content: \"\\eb15\";\n}\n\n.icofont-windows-lumia:before {\n  content: \"\\eb16\";\n}\n\n.icofont-wireless-mouse:before {\n  content: \"\\eb17\";\n}\n\n.icofont-xbox-360:before {\n  content: \"\\eb18\";\n}\n\n.icofont-arrow-down:before {\n  content: \"\\eb19\";\n}\n\n.icofont-arrow-left:before {\n  content: \"\\eb1a\";\n}\n\n.icofont-arrow-right:before {\n  content: \"\\eb1b\";\n}\n\n.icofont-arrow-up:before {\n  content: \"\\eb1c\";\n}\n\n.icofont-block-down:before {\n  content: \"\\eb1d\";\n}\n\n.icofont-block-left:before {\n  content: \"\\eb1e\";\n}\n\n.icofont-block-right:before {\n  content: \"\\eb1f\";\n}\n\n.icofont-block-up:before {\n  content: \"\\eb20\";\n}\n\n.icofont-bubble-down:before {\n  content: \"\\eb21\";\n}\n\n.icofont-bubble-left:before {\n  content: \"\\eb22\";\n}\n\n.icofont-bubble-right:before {\n  content: \"\\eb23\";\n}\n\n.icofont-bubble-up:before {\n  content: \"\\eb24\";\n}\n\n.icofont-caret-down:before {\n  content: \"\\eb25\";\n}\n\n.icofont-caret-left:before {\n  content: \"\\eb26\";\n}\n\n.icofont-caret-right:before {\n  content: \"\\eb27\";\n}\n\n.icofont-caret-up:before {\n  content: \"\\eb28\";\n}\n\n.icofont-circled-down:before {\n  content: \"\\eb29\";\n}\n\n.icofont-circled-left:before {\n  content: \"\\eb2a\";\n}\n\n.icofont-circled-right:before {\n  content: \"\\eb2b\";\n}\n\n.icofont-circled-up:before {\n  content: \"\\eb2c\";\n}\n\n.icofont-collapse:before {\n  content: \"\\eb2d\";\n}\n\n.icofont-cursor-drag:before {\n  content: \"\\eb2e\";\n}\n\n.icofont-curved-double-left:before {\n  content: \"\\eb2f\";\n}\n\n.icofont-curved-double-right:before {\n  content: \"\\eb30\";\n}\n\n.icofont-curved-down:before {\n  content: \"\\eb31\";\n}\n\n.icofont-curved-left:before {\n  content: \"\\eb32\";\n}\n\n.icofont-curved-right:before {\n  content: \"\\eb33\";\n}\n\n.icofont-curved-up:before {\n  content: \"\\eb34\";\n}\n\n.icofont-dotted-down:before {\n  content: \"\\eb35\";\n}\n\n.icofont-dotted-left:before {\n  content: \"\\eb36\";\n}\n\n.icofont-dotted-right:before {\n  content: \"\\eb37\";\n}\n\n.icofont-dotted-up:before {\n  content: \"\\eb38\";\n}\n\n.icofont-double-left:before {\n  content: \"\\eb39\";\n}\n\n.icofont-double-right:before {\n  content: \"\\eb3a\";\n}\n\n.icofont-drag:before {\n  content: \"\\eb3b\";\n}\n\n.icofont-drag1:before {\n  content: \"\\eb3c\";\n}\n\n.icofont-drag2:before {\n  content: \"\\eb3d\";\n}\n\n.icofont-drag3:before {\n  content: \"\\eb3e\";\n}\n\n.icofont-expand-alt:before {\n  content: \"\\eb3f\";\n}\n\n.icofont-hand-down:before {\n  content: \"\\eb40\";\n}\n\n.icofont-hand-drag:before {\n  content: \"\\eb41\";\n}\n\n.icofont-hand-drag1:before {\n  content: \"\\eb42\";\n}\n\n.icofont-hand-drag2:before {\n  content: \"\\eb43\";\n}\n\n.icofont-hand-drawn-alt-down:before {\n  content: \"\\eb44\";\n}\n\n.icofont-hand-drawn-alt-left:before {\n  content: \"\\eb45\";\n}\n\n.icofont-hand-drawn-alt-right:before {\n  content: \"\\eb46\";\n}\n\n.icofont-hand-drawn-alt-up:before {\n  content: \"\\eb47\";\n}\n\n.icofont-hand-drawn-down:before {\n  content: \"\\eb48\";\n}\n\n.icofont-hand-drawn-left:before {\n  content: \"\\eb49\";\n}\n\n.icofont-hand-drawn-right:before {\n  content: \"\\eb4a\";\n}\n\n.icofont-hand-drawn-up:before {\n  content: \"\\eb4b\";\n}\n\n.icofont-hand-left:before {\n  content: \"\\eb4c\";\n}\n\n.icofont-hand-right:before {\n  content: \"\\eb4d\";\n}\n\n.icofont-hand-up:before {\n  content: \"\\eb4e\";\n}\n\n.icofont-line-block-down:before {\n  content: \"\\eb4f\";\n}\n\n.icofont-line-block-left:before {\n  content: \"\\eb50\";\n}\n\n.icofont-line-block-right:before {\n  content: \"\\eb51\";\n}\n\n.icofont-line-block-up:before {\n  content: \"\\eb52\";\n}\n\n.icofont-long-arrow-down:before {\n  content: \"\\eb53\";\n}\n\n.icofont-long-arrow-left:before {\n  content: \"\\eb54\";\n}\n\n.icofont-long-arrow-right:before {\n  content: \"\\eb55\";\n}\n\n.icofont-long-arrow-up:before {\n  content: \"\\eb56\";\n}\n\n.icofont-rounded-collapse:before {\n  content: \"\\eb57\";\n}\n\n.icofont-rounded-double-left:before {\n  content: \"\\eb58\";\n}\n\n.icofont-rounded-double-right:before {\n  content: \"\\eb59\";\n}\n\n.icofont-rounded-down:before {\n  content: \"\\eb5a\";\n}\n\n.icofont-rounded-expand:before {\n  content: \"\\eb5b\";\n}\n\n.icofont-rounded-left-down:before {\n  content: \"\\eb5c\";\n}\n\n.icofont-rounded-left-up:before {\n  content: \"\\eb5d\";\n}\n\n.icofont-rounded-left:before {\n  content: \"\\eb5e\";\n}\n\n.icofont-rounded-right-down:before {\n  content: \"\\eb5f\";\n}\n\n.icofont-rounded-right-up:before {\n  content: \"\\eb60\";\n}\n\n.icofont-rounded-right:before {\n  content: \"\\eb61\";\n}\n\n.icofont-rounded-up:before {\n  content: \"\\eb62\";\n}\n\n.icofont-scroll-bubble-down:before {\n  content: \"\\eb63\";\n}\n\n.icofont-scroll-bubble-left:before {\n  content: \"\\eb64\";\n}\n\n.icofont-scroll-bubble-right:before {\n  content: \"\\eb65\";\n}\n\n.icofont-scroll-bubble-up:before {\n  content: \"\\eb66\";\n}\n\n.icofont-scroll-double-down:before {\n  content: \"\\eb67\";\n}\n\n.icofont-scroll-double-left:before {\n  content: \"\\eb68\";\n}\n\n.icofont-scroll-double-right:before {\n  content: \"\\eb69\";\n}\n\n.icofont-scroll-double-up:before {\n  content: \"\\eb6a\";\n}\n\n.icofont-scroll-down:before {\n  content: \"\\eb6b\";\n}\n\n.icofont-scroll-left:before {\n  content: \"\\eb6c\";\n}\n\n.icofont-scroll-long-down:before {\n  content: \"\\eb6d\";\n}\n\n.icofont-scroll-long-left:before {\n  content: \"\\eb6e\";\n}\n\n.icofont-scroll-long-right:before {\n  content: \"\\eb6f\";\n}\n\n.icofont-scroll-long-up:before {\n  content: \"\\eb70\";\n}\n\n.icofont-scroll-right:before {\n  content: \"\\eb71\";\n}\n\n.icofont-scroll-up:before {\n  content: \"\\eb72\";\n}\n\n.icofont-simple-down:before {\n  content: \"\\eb73\";\n}\n\n.icofont-simple-left-down:before {\n  content: \"\\eb74\";\n}\n\n.icofont-simple-left-up:before {\n  content: \"\\eb75\";\n}\n\n.icofont-simple-left:before {\n  content: \"\\eb76\";\n}\n\n.icofont-simple-right-down:before {\n  content: \"\\eb77\";\n}\n\n.icofont-simple-right-up:before {\n  content: \"\\eb78\";\n}\n\n.icofont-simple-right:before {\n  content: \"\\eb79\";\n}\n\n.icofont-simple-up:before {\n  content: \"\\eb7a\";\n}\n\n.icofont-square-down:before {\n  content: \"\\eb7b\";\n}\n\n.icofont-square-left:before {\n  content: \"\\eb7c\";\n}\n\n.icofont-square-right:before {\n  content: \"\\eb7d\";\n}\n\n.icofont-square-up:before {\n  content: \"\\eb7e\";\n}\n\n.icofont-stylish-down:before {\n  content: \"\\eb7f\";\n}\n\n.icofont-stylish-left:before {\n  content: \"\\eb80\";\n}\n\n.icofont-stylish-right:before {\n  content: \"\\eb81\";\n}\n\n.icofont-stylish-up:before {\n  content: \"\\eb82\";\n}\n\n.icofont-swoosh-down:before {\n  content: \"\\eb83\";\n}\n\n.icofont-swoosh-left:before {\n  content: \"\\eb84\";\n}\n\n.icofont-swoosh-right:before {\n  content: \"\\eb85\";\n}\n\n.icofont-swoosh-up:before {\n  content: \"\\eb86\";\n}\n\n.icofont-thin-double-left:before {\n  content: \"\\eb87\";\n}\n\n.icofont-thin-double-right:before {\n  content: \"\\eb88\";\n}\n\n.icofont-thin-down:before {\n  content: \"\\eb89\";\n}\n\n.icofont-thin-left:before {\n  content: \"\\eb8a\";\n}\n\n.icofont-thin-right:before {\n  content: \"\\eb8b\";\n}\n\n.icofont-thin-up:before {\n  content: \"\\eb8c\";\n}\n\n.icofont-atom:before {\n  content: \"\\eb8d\";\n}\n\n.icofont-award:before {\n  content: \"\\eb8e\";\n}\n\n.icofont-bell-alt:before {\n  content: \"\\eb8f\";\n}\n\n.icofont-book-alt:before {\n  content: \"\\eb90\";\n}\n\n.icofont-brainstorming:before {\n  content: \"\\eb91\";\n}\n\n.icofont-certificate-alt-1:before {\n  content: \"\\eb92\";\n}\n\n.icofont-certificate-alt-2:before {\n  content: \"\\eb93\";\n}\n\n.icofont-dna-alt-2:before {\n  content: \"\\eb94\";\n}\n\n.icofont-education:before {\n  content: \"\\eb95\";\n}\n\n.icofont-electron:before {\n  content: \"\\eb96\";\n}\n\n.icofont-fountain-pen:before {\n  content: \"\\eb97\";\n}\n\n.icofont-globe-alt:before {\n  content: \"\\eb98\";\n}\n\n.icofont-graduate-alt:before {\n  content: \"\\eb99\";\n}\n\n.icofont-group-students:before {\n  content: \"\\eb9a\";\n}\n\n.icofont-hat-alt:before {\n  content: \"\\eb9b\";\n}\n\n.icofont-hat:before {\n  content: \"\\eb9c\";\n}\n\n.icofont-instrument:before {\n  content: \"\\eb9d\";\n}\n\n.icofont-lamp-light:before {\n  content: \"\\eb9e\";\n}\n\n.icofont-microscope-alt:before {\n  content: \"\\eb9f\";\n}\n\n.icofont-paper:before {\n  content: \"\\eba0\";\n}\n\n.icofont-pen-alt-4:before {\n  content: \"\\eba1\";\n}\n\n.icofont-pen-nib:before {\n  content: \"\\eba2\";\n}\n\n.icofont-pencil-alt-5:before {\n  content: \"\\eba3\";\n}\n\n.icofont-quill-pen:before {\n  content: \"\\eba4\";\n}\n\n.icofont-read-book-alt:before {\n  content: \"\\eba5\";\n}\n\n.icofont-read-book:before {\n  content: \"\\eba6\";\n}\n\n.icofont-school-bag:before {\n  content: \"\\eba7\";\n}\n\n.icofont-school-bus:before {\n  content: \"\\eba8\";\n}\n\n.icofont-student-alt:before {\n  content: \"\\eba9\";\n}\n\n.icofont-student:before {\n  content: \"\\ebaa\";\n}\n\n.icofont-teacher:before {\n  content: \"\\ebab\";\n}\n\n.icofont-test-bulb:before {\n  content: \"\\ebac\";\n}\n\n.icofont-test-tube-alt:before {\n  content: \"\\ebad\";\n}\n\n.icofont-university:before {\n  content: \"\\ebae\";\n}\n\n.icofont-emo-angry:before {\n  content: \"\\ebaf\";\n}\n\n.icofont-emo-astonished:before {\n  content: \"\\ebb0\";\n}\n\n.icofont-emo-confounded:before {\n  content: \"\\ebb1\";\n}\n\n.icofont-emo-confused:before {\n  content: \"\\ebb2\";\n}\n\n.icofont-emo-crying:before {\n  content: \"\\ebb3\";\n}\n\n.icofont-emo-dizzy:before {\n  content: \"\\ebb4\";\n}\n\n.icofont-emo-expressionless:before {\n  content: \"\\ebb5\";\n}\n\n.icofont-emo-heart-eyes:before {\n  content: \"\\ebb6\";\n}\n\n.icofont-emo-laughing:before {\n  content: \"\\ebb7\";\n}\n\n.icofont-emo-nerd-smile:before {\n  content: \"\\ebb8\";\n}\n\n.icofont-emo-open-mouth:before {\n  content: \"\\ebb9\";\n}\n\n.icofont-emo-rage:before {\n  content: \"\\ebba\";\n}\n\n.icofont-emo-rolling-eyes:before {\n  content: \"\\ebbb\";\n}\n\n.icofont-emo-sad:before {\n  content: \"\\ebbc\";\n}\n\n.icofont-emo-simple-smile:before {\n  content: \"\\ebbd\";\n}\n\n.icofont-emo-slightly-smile:before {\n  content: \"\\ebbe\";\n}\n\n.icofont-emo-smirk:before {\n  content: \"\\ebbf\";\n}\n\n.icofont-emo-stuck-out-tongue:before {\n  content: \"\\ebc0\";\n}\n\n.icofont-emo-wink-smile:before {\n  content: \"\\ebc1\";\n}\n\n.icofont-emo-worried:before {\n  content: \"\\ebc2\";\n}\n\n.icofont-architecture-alt:before {\n  content: \"\\ebc3\";\n}\n\n.icofont-architecture:before {\n  content: \"\\ebc4\";\n}\n\n.icofont-barricade:before {\n  content: \"\\ebc5\";\n}\n\n.icofont-bricks:before {\n  content: \"\\ebc6\";\n}\n\n.icofont-calculations:before {\n  content: \"\\ebc7\";\n}\n\n.icofont-cement-mix:before {\n  content: \"\\ebc8\";\n}\n\n.icofont-cement-mixer:before {\n  content: \"\\ebc9\";\n}\n\n.icofont-danger-zone:before {\n  content: \"\\ebca\";\n}\n\n.icofont-drill:before {\n  content: \"\\ebcb\";\n}\n\n.icofont-eco-energy:before {\n  content: \"\\ebcc\";\n}\n\n.icofont-eco-environmen:before {\n  content: \"\\ebcd\";\n}\n\n.icofont-energy-air:before {\n  content: \"\\ebce\";\n}\n\n.icofont-energy-oil:before {\n  content: \"\\ebcf\";\n}\n\n.icofont-energy-savings:before {\n  content: \"\\ebd0\";\n}\n\n.icofont-energy-solar:before {\n  content: \"\\ebd1\";\n}\n\n.icofont-energy-water:before {\n  content: \"\\ebd2\";\n}\n\n.icofont-engineer:before {\n  content: \"\\ebd3\";\n}\n\n.icofont-fire-extinguisher-alt:before {\n  content: \"\\ebd4\";\n}\n\n.icofont-fix-tools:before {\n  content: \"\\ebd5\";\n}\n\n.icofont-glue-oil:before {\n  content: \"\\ebd6\";\n}\n\n.icofont-hammer-alt:before {\n  content: \"\\ebd7\";\n}\n\n.icofont-help-robot:before {\n  content: \"\\ebd8\";\n}\n\n.icofont-industries-alt-1:before {\n  content: \"\\ebd9\";\n}\n\n.icofont-industries-alt-2:before {\n  content: \"\\ebda\";\n}\n\n.icofont-industries-alt-3:before {\n  content: \"\\ebdb\";\n}\n\n.icofont-industries-alt-4:before {\n  content: \"\\ebdc\";\n}\n\n.icofont-industries-alt-5:before {\n  content: \"\\ebdd\";\n}\n\n.icofont-industries:before {\n  content: \"\\ebde\";\n}\n\n.icofont-labour:before {\n  content: \"\\ebdf\";\n}\n\n.icofont-mining:before {\n  content: \"\\ebe0\";\n}\n\n.icofont-paint-brush:before {\n  content: \"\\ebe1\";\n}\n\n.icofont-pollution:before {\n  content: \"\\ebe2\";\n}\n\n.icofont-power-zone:before {\n  content: \"\\ebe3\";\n}\n\n.icofont-radio-active:before {\n  content: \"\\ebe4\";\n}\n\n.icofont-recycle-alt:before {\n  content: \"\\ebe5\";\n}\n\n.icofont-recycling-man:before {\n  content: \"\\ebe6\";\n}\n\n.icofont-safety-hat-light:before {\n  content: \"\\ebe7\";\n}\n\n.icofont-safety-hat:before {\n  content: \"\\ebe8\";\n}\n\n.icofont-saw:before {\n  content: \"\\ebe9\";\n}\n\n.icofont-screw-driver:before {\n  content: \"\\ebea\";\n}\n\n.icofont-settings-alt:before {\n  content: \"\\ebeb\";\n}\n\n.icofont-tools-alt-1:before {\n  content: \"\\ebec\";\n}\n\n.icofont-tools-alt-2:before {\n  content: \"\\ebed\";\n}\n\n.icofont-tools-bag:before {\n  content: \"\\ebee\";\n}\n\n.icofont-trolley:before {\n  content: \"\\ebef\";\n}\n\n.icofont-trowel:before {\n  content: \"\\ebf0\";\n}\n\n.icofont-under-construction-alt:before {\n  content: \"\\ebf1\";\n}\n\n.icofont-under-construction:before {\n  content: \"\\ebf2\";\n}\n\n.icofont-vehicle-cement:before {\n  content: \"\\ebf3\";\n}\n\n.icofont-vehicle-crane:before {\n  content: \"\\ebf4\";\n}\n\n.icofont-vehicle-delivery-van:before {\n  content: \"\\ebf5\";\n}\n\n.icofont-vehicle-dozer:before {\n  content: \"\\ebf6\";\n}\n\n.icofont-vehicle-excavator:before {\n  content: \"\\ebf7\";\n}\n\n.icofont-vehicle-trucktor:before {\n  content: \"\\ebf8\";\n}\n\n.icofont-vehicle-wrecking:before {\n  content: \"\\ebf9\";\n}\n\n.icofont-worker-group:before {\n  content: \"\\ebfa\";\n}\n\n.icofont-worker:before {\n  content: \"\\ebfb\";\n}\n\n.icofont-wrench:before {\n  content: \"\\ebfc\";\n}\n\n.icofont-file-audio:before {\n  content: \"\\ebfd\";\n}\n\n.icofont-file-avi-mp4:before {\n  content: \"\\ebfe\";\n}\n\n.icofont-file-bmp:before {\n  content: \"\\ebff\";\n}\n\n.icofont-file-code:before {\n  content: \"\\ec00\";\n}\n\n.icofont-file-css:before {\n  content: \"\\ec01\";\n}\n\n.icofont-file-document:before {\n  content: \"\\ec02\";\n}\n\n.icofont-file-eps:before {\n  content: \"\\ec03\";\n}\n\n.icofont-file-excel:before {\n  content: \"\\ec04\";\n}\n\n.icofont-file-exe:before {\n  content: \"\\ec05\";\n}\n\n.icofont-file-file:before {\n  content: \"\\ec06\";\n}\n\n.icofont-file-flv:before {\n  content: \"\\ec07\";\n}\n\n.icofont-file-gif:before {\n  content: \"\\ec08\";\n}\n\n.icofont-file-html5:before {\n  content: \"\\ec09\";\n}\n\n.icofont-file-image:before {\n  content: \"\\ec0a\";\n}\n\n.icofont-file-iso:before {\n  content: \"\\ec0b\";\n}\n\n.icofont-file-java:before {\n  content: \"\\ec0c\";\n}\n\n.icofont-file-javascript:before {\n  content: \"\\ec0d\";\n}\n\n.icofont-file-jpg:before {\n  content: \"\\ec0e\";\n}\n\n.icofont-file-midi:before {\n  content: \"\\ec0f\";\n}\n\n.icofont-file-mov:before {\n  content: \"\\ec10\";\n}\n\n.icofont-file-mp3:before {\n  content: \"\\ec11\";\n}\n\n.icofont-file-pdf:before {\n  content: \"\\ec12\";\n}\n\n.icofont-file-php:before {\n  content: \"\\ec13\";\n}\n\n.icofont-file-png:before {\n  content: \"\\ec14\";\n}\n\n.icofont-file-powerpoint:before {\n  content: \"\\ec15\";\n}\n\n.icofont-file-presentation:before {\n  content: \"\\ec16\";\n}\n\n.icofont-file-psb:before {\n  content: \"\\ec17\";\n}\n\n.icofont-file-psd:before {\n  content: \"\\ec18\";\n}\n\n.icofont-file-python:before {\n  content: \"\\ec19\";\n}\n\n.icofont-file-ruby:before {\n  content: \"\\ec1a\";\n}\n\n.icofont-file-spreadsheet:before {\n  content: \"\\ec1b\";\n}\n\n.icofont-file-sql:before {\n  content: \"\\ec1c\";\n}\n\n.icofont-file-svg:before {\n  content: \"\\ec1d\";\n}\n\n.icofont-file-text:before {\n  content: \"\\ec1e\";\n}\n\n.icofont-file-tiff:before {\n  content: \"\\ec1f\";\n}\n\n.icofont-file-video:before {\n  content: \"\\ec20\";\n}\n\n.icofont-file-wave:before {\n  content: \"\\ec21\";\n}\n\n.icofont-file-wmv:before {\n  content: \"\\ec22\";\n}\n\n.icofont-file-word:before {\n  content: \"\\ec23\";\n}\n\n.icofont-file-zip:before {\n  content: \"\\ec24\";\n}\n\n.icofont-apple:before {\n  content: \"\\ec25\";\n}\n\n.icofont-arabian-coffee:before {\n  content: \"\\ec26\";\n}\n\n.icofont-artichoke:before {\n  content: \"\\ec27\";\n}\n\n.icofont-asparagus:before {\n  content: \"\\ec28\";\n}\n\n.icofont-avocado:before {\n  content: \"\\ec29\";\n}\n\n.icofont-baby-food:before {\n  content: \"\\ec2a\";\n}\n\n.icofont-banana:before {\n  content: \"\\ec2b\";\n}\n\n.icofont-bbq:before {\n  content: \"\\ec2c\";\n}\n\n.icofont-beans:before {\n  content: \"\\ec2d\";\n}\n\n.icofont-beer:before {\n  content: \"\\ec2e\";\n}\n\n.icofont-bell-pepper-capsicum:before {\n  content: \"\\ec2f\";\n}\n\n.icofont-birthday-cake:before {\n  content: \"\\ec30\";\n}\n\n.icofont-bread:before {\n  content: \"\\ec31\";\n}\n\n.icofont-broccoli:before {\n  content: \"\\ec32\";\n}\n\n.icofont-burger:before {\n  content: \"\\ec33\";\n}\n\n.icofont-cabbage:before {\n  content: \"\\ec34\";\n}\n\n.icofont-carrot:before {\n  content: \"\\ec35\";\n}\n\n.icofont-cauli-flower:before {\n  content: \"\\ec36\";\n}\n\n.icofont-cheese:before {\n  content: \"\\ec37\";\n}\n\n.icofont-chef:before {\n  content: \"\\ec38\";\n}\n\n.icofont-cherry:before {\n  content: \"\\ec39\";\n}\n\n.icofont-chicken-fry:before {\n  content: \"\\ec3a\";\n}\n\n.icofont-chicken:before {\n  content: \"\\ec3b\";\n}\n\n.icofont-cocktail:before {\n  content: \"\\ec3c\";\n}\n\n.icofont-coconut:before {\n  content: \"\\ec3d\";\n}\n\n.icofont-coffee-alt:before {\n  content: \"\\ec3e\";\n}\n\n.icofont-coffee-mug:before {\n  content: \"\\ec3f\";\n}\n\n.icofont-coffee-pot:before {\n  content: \"\\ec40\";\n}\n\n.icofont-cola:before {\n  content: \"\\ec41\";\n}\n\n.icofont-corn:before {\n  content: \"\\ec42\";\n}\n\n.icofont-croissant:before {\n  content: \"\\ec43\";\n}\n\n.icofont-crop-plant:before {\n  content: \"\\ec44\";\n}\n\n.icofont-cucumber:before {\n  content: \"\\ec45\";\n}\n\n.icofont-cup-cake:before {\n  content: \"\\ec46\";\n}\n\n.icofont-dining-table:before {\n  content: \"\\ec47\";\n}\n\n.icofont-donut:before {\n  content: \"\\ec48\";\n}\n\n.icofont-egg-plant:before {\n  content: \"\\ec49\";\n}\n\n.icofont-egg-poached:before {\n  content: \"\\ec4a\";\n}\n\n.icofont-farmer:before {\n  content: \"\\ec4b\";\n}\n\n.icofont-farmer1:before {\n  content: \"\\ec4c\";\n}\n\n.icofont-fast-food:before {\n  content: \"\\ec4d\";\n}\n\n.icofont-fish:before {\n  content: \"\\ec4e\";\n}\n\n.icofont-food-basket:before {\n  content: \"\\ec4f\";\n}\n\n.icofont-food-cart:before {\n  content: \"\\ec50\";\n}\n\n.icofont-fork-and-knife:before {\n  content: \"\\ec51\";\n}\n\n.icofont-french-fries:before {\n  content: \"\\ec52\";\n}\n\n.icofont-fresh-juice:before {\n  content: \"\\ec53\";\n}\n\n.icofont-fruits:before {\n  content: \"\\ec54\";\n}\n\n.icofont-grapes:before {\n  content: \"\\ec55\";\n}\n\n.icofont-honey:before {\n  content: \"\\ec56\";\n}\n\n.icofont-hot-dog:before {\n  content: \"\\ec57\";\n}\n\n.icofont-hotel-alt:before {\n  content: \"\\ec58\";\n}\n\n.icofont-ice-cream-alt:before {\n  content: \"\\ec59\";\n}\n\n.icofont-ice-cream:before {\n  content: \"\\ec5a\";\n}\n\n.icofont-ketchup:before {\n  content: \"\\ec5b\";\n}\n\n.icofont-kiwi:before {\n  content: \"\\ec5c\";\n}\n\n.icofont-layered-cake:before {\n  content: \"\\ec5d\";\n}\n\n.icofont-lemon-alt:before {\n  content: \"\\ec5e\";\n}\n\n.icofont-lobster:before {\n  content: \"\\ec5f\";\n}\n\n.icofont-mango:before {\n  content: \"\\ec60\";\n}\n\n.icofont-milk:before {\n  content: \"\\ec61\";\n}\n\n.icofont-mushroom:before {\n  content: \"\\ec62\";\n}\n\n.icofont-noodles:before {\n  content: \"\\ec63\";\n}\n\n.icofont-onion:before {\n  content: \"\\ec64\";\n}\n\n.icofont-orange:before {\n  content: \"\\ec65\";\n}\n\n.icofont-pear:before {\n  content: \"\\ec66\";\n}\n\n.icofont-peas:before {\n  content: \"\\ec67\";\n}\n\n.icofont-pepper:before {\n  content: \"\\ec68\";\n}\n\n.icofont-pie-alt:before {\n  content: \"\\ec69\";\n}\n\n.icofont-pineapple:before {\n  content: \"\\ec6a\";\n}\n\n.icofont-pizza-slice:before {\n  content: \"\\ec6b\";\n}\n\n.icofont-pizza:before {\n  content: \"\\ec6c\";\n}\n\n.icofont-plant:before {\n  content: \"\\ec6d\";\n}\n\n.icofont-popcorn:before {\n  content: \"\\ec6e\";\n}\n\n.icofont-potato:before {\n  content: \"\\ec6f\";\n}\n\n.icofont-pumpkin:before {\n  content: \"\\ec70\";\n}\n\n.icofont-raddish:before {\n  content: \"\\ec71\";\n}\n\n.icofont-restaurant-menu:before {\n  content: \"\\ec72\";\n}\n\n.icofont-restaurant:before {\n  content: \"\\ec73\";\n}\n\n.icofont-salt-and-pepper:before {\n  content: \"\\ec74\";\n}\n\n.icofont-sandwich:before {\n  content: \"\\ec75\";\n}\n\n.icofont-sausage:before {\n  content: \"\\ec76\";\n}\n\n.icofont-shrimp:before {\n  content: \"\\ec77\";\n}\n\n.icofont-sof-drinks:before {\n  content: \"\\ec78\";\n}\n\n.icofont-soup-bowl:before {\n  content: \"\\ec79\";\n}\n\n.icofont-spoon-and-fork:before {\n  content: \"\\ec7a\";\n}\n\n.icofont-steak:before {\n  content: \"\\ec7b\";\n}\n\n.icofont-strawberry:before {\n  content: \"\\ec7c\";\n}\n\n.icofont-sub-sandwich:before {\n  content: \"\\ec7d\";\n}\n\n.icofont-sushi:before {\n  content: \"\\ec7e\";\n}\n\n.icofont-taco:before {\n  content: \"\\ec7f\";\n}\n\n.icofont-tea-pot:before {\n  content: \"\\ec80\";\n}\n\n.icofont-tea:before {\n  content: \"\\ec81\";\n}\n\n.icofont-tomato:before {\n  content: \"\\ec82\";\n}\n\n.icofont-waiter-alt:before {\n  content: \"\\ec83\";\n}\n\n.icofont-watermelon:before {\n  content: \"\\ec84\";\n}\n\n.icofont-wheat:before {\n  content: \"\\ec85\";\n}\n\n.icofont-abc:before {\n  content: \"\\ec86\";\n}\n\n.icofont-baby-cloth:before {\n  content: \"\\ec87\";\n}\n\n.icofont-baby-milk-bottle:before {\n  content: \"\\ec88\";\n}\n\n.icofont-baby-trolley:before {\n  content: \"\\ec89\";\n}\n\n.icofont-back-pack:before {\n  content: \"\\ec8a\";\n}\n\n.icofont-candy:before {\n  content: \"\\ec8b\";\n}\n\n.icofont-cycling:before {\n  content: \"\\ec8c\";\n}\n\n.icofont-holding-hands:before {\n  content: \"\\ec8d\";\n}\n\n.icofont-infant-nipple:before {\n  content: \"\\ec8e\";\n}\n\n.icofont-kids-scooter:before {\n  content: \"\\ec8f\";\n}\n\n.icofont-safety-pin:before {\n  content: \"\\ec90\";\n}\n\n.icofont-teddy-bear:before {\n  content: \"\\ec91\";\n}\n\n.icofont-toy-ball:before {\n  content: \"\\ec92\";\n}\n\n.icofont-toy-cat:before {\n  content: \"\\ec93\";\n}\n\n.icofont-toy-duck:before {\n  content: \"\\ec94\";\n}\n\n.icofont-toy-elephant:before {\n  content: \"\\ec95\";\n}\n\n.icofont-toy-hand:before {\n  content: \"\\ec96\";\n}\n\n.icofont-toy-horse:before {\n  content: \"\\ec97\";\n}\n\n.icofont-toy-lattu:before {\n  content: \"\\ec98\";\n}\n\n.icofont-toy-train:before {\n  content: \"\\ec99\";\n}\n\n.icofont-unique-idea:before {\n  content: \"\\ec9a\";\n}\n\n.icofont-bag-alt:before {\n  content: \"\\ec9b\";\n}\n\n.icofont-burglar:before {\n  content: \"\\ec9c\";\n}\n\n.icofont-cannon-firing:before {\n  content: \"\\ec9d\";\n}\n\n.icofont-cc-camera:before {\n  content: \"\\ec9e\";\n}\n\n.icofont-cop-badge:before {\n  content: \"\\ec9f\";\n}\n\n.icofont-cop:before {\n  content: \"\\eca0\";\n}\n\n.icofont-court-hammer:before {\n  content: \"\\eca1\";\n}\n\n.icofont-court:before {\n  content: \"\\eca2\";\n}\n\n.icofont-finger-print:before {\n  content: \"\\eca3\";\n}\n\n.icofont-handcuff-alt:before {\n  content: \"\\eca4\";\n}\n\n.icofont-handcuff:before {\n  content: \"\\eca5\";\n}\n\n.icofont-investigation:before {\n  content: \"\\eca6\";\n}\n\n.icofont-investigator:before {\n  content: \"\\eca7\";\n}\n\n.icofont-jail:before {\n  content: \"\\eca8\";\n}\n\n.icofont-judge:before {\n  content: \"\\eca9\";\n}\n\n.icofont-law-alt-1:before {\n  content: \"\\ecaa\";\n}\n\n.icofont-law-alt-2:before {\n  content: \"\\ecab\";\n}\n\n.icofont-law-alt-3:before {\n  content: \"\\ecac\";\n}\n\n.icofont-law-book:before {\n  content: \"\\ecad\";\n}\n\n.icofont-law-document:before {\n  content: \"\\ecae\";\n}\n\n.icofont-law:before {\n  content: \"\\ecaf\";\n}\n\n.icofont-lawyer-alt-1:before {\n  content: \"\\ecb0\";\n}\n\n.icofont-lawyer-alt-2:before {\n  content: \"\\ecb1\";\n}\n\n.icofont-lawyer:before {\n  content: \"\\ecb2\";\n}\n\n.icofont-order:before {\n  content: \"\\ecb3\";\n}\n\n.icofont-pistol:before {\n  content: \"\\ecb4\";\n}\n\n.icofont-police-badge:before {\n  content: \"\\ecb5\";\n}\n\n.icofont-police-cap:before {\n  content: \"\\ecb6\";\n}\n\n.icofont-police-car-alt-1:before {\n  content: \"\\ecb7\";\n}\n\n.icofont-police-car-alt-2:before {\n  content: \"\\ecb8\";\n}\n\n.icofont-police-hat:before {\n  content: \"\\ecb9\";\n}\n\n.icofont-police-van:before {\n  content: \"\\ecba\";\n}\n\n.icofont-police:before {\n  content: \"\\ecbb\";\n}\n\n.icofont-protect:before {\n  content: \"\\ecbc\";\n}\n\n.icofont-scales:before {\n  content: \"\\ecbd\";\n}\n\n.icofont-thief-alt:before {\n  content: \"\\ecbe\";\n}\n\n.icofont-thief:before {\n  content: \"\\ecbf\";\n}\n\n.icofont-abacus-alt:before {\n  content: \"\\ecc0\";\n}\n\n.icofont-abacus:before {\n  content: \"\\ecc1\";\n}\n\n.icofont-angle:before {\n  content: \"\\ecc2\";\n}\n\n.icofont-calculator-alt-1:before {\n  content: \"\\ecc3\";\n}\n\n.icofont-calculator-alt-2:before {\n  content: \"\\ecc4\";\n}\n\n.icofont-circle-ruler-alt:before {\n  content: \"\\ecc5\";\n}\n\n.icofont-circle-ruler:before {\n  content: \"\\ecc6\";\n}\n\n.icofont-compass-alt-1:before {\n  content: \"\\ecc7\";\n}\n\n.icofont-compass-alt-2:before {\n  content: \"\\ecc8\";\n}\n\n.icofont-compass-alt-3:before {\n  content: \"\\ecc9\";\n}\n\n.icofont-compass-alt-4:before {\n  content: \"\\ecca\";\n}\n\n.icofont-degrees-alt-1:before {\n  content: \"\\eccb\";\n}\n\n.icofont-degrees-alt-2:before {\n  content: \"\\eccc\";\n}\n\n.icofont-degrees:before {\n  content: \"\\eccd\";\n}\n\n.icofont-golden-ratio:before {\n  content: \"\\ecce\";\n}\n\n.icofont-marker-alt-1:before {\n  content: \"\\eccf\";\n}\n\n.icofont-marker-alt-2:before {\n  content: \"\\ecd0\";\n}\n\n.icofont-marker-alt-3:before {\n  content: \"\\ecd1\";\n}\n\n.icofont-mathematical-alt-1:before {\n  content: \"\\ecd2\";\n}\n\n.icofont-mathematical-alt-2:before {\n  content: \"\\ecd3\";\n}\n\n.icofont-mathematical:before {\n  content: \"\\ecd4\";\n}\n\n.icofont-pen-alt-1:before {\n  content: \"\\ecd5\";\n}\n\n.icofont-pen-alt-2:before {\n  content: \"\\ecd6\";\n}\n\n.icofont-pen-alt-3:before {\n  content: \"\\ecd7\";\n}\n\n.icofont-pen-holder-alt-1:before {\n  content: \"\\ecd8\";\n}\n\n.icofont-pen-holder:before {\n  content: \"\\ecd9\";\n}\n\n.icofont-pencil-alt-1:before {\n  content: \"\\ecda\";\n}\n\n.icofont-pencil-alt-2:before {\n  content: \"\\ecdb\";\n}\n\n.icofont-pencil-alt-3:before {\n  content: \"\\ecdc\";\n}\n\n.icofont-pencil-alt-4:before {\n  content: \"\\ecdd\";\n}\n\n.icofont-ruler-alt-1:before {\n  content: \"\\ecde\";\n}\n\n.icofont-ruler-alt-2:before {\n  content: \"\\ecdf\";\n}\n\n.icofont-ruler-compass-alt:before {\n  content: \"\\ece0\";\n}\n\n.icofont-ruler-compass:before {\n  content: \"\\ece1\";\n}\n\n.icofont-ruler-pencil-alt-1:before {\n  content: \"\\ece2\";\n}\n\n.icofont-ruler-pencil-alt-2:before {\n  content: \"\\ece3\";\n}\n\n.icofont-ruler-pencil:before {\n  content: \"\\ece4\";\n}\n\n.icofont-ruler:before {\n  content: \"\\ece5\";\n}\n\n.icofont-rulers-alt:before {\n  content: \"\\ece6\";\n}\n\n.icofont-rulers:before {\n  content: \"\\ece7\";\n}\n\n.icofont-square-root:before {\n  content: \"\\ece8\";\n}\n\n.icofont-aids:before {\n  content: \"\\ece9\";\n}\n\n.icofont-ambulance:before {\n  content: \"\\ecea\";\n}\n\n.icofont-autism:before {\n  content: \"\\eceb\";\n}\n\n.icofont-bandage:before {\n  content: \"\\ecec\";\n}\n\n.icofont-bed-patient:before {\n  content: \"\\eced\";\n}\n\n.icofont-blind:before {\n  content: \"\\ecee\";\n}\n\n.icofont-blood-drop:before {\n  content: \"\\ecef\";\n}\n\n.icofont-blood-test:before {\n  content: \"\\ecf0\";\n}\n\n.icofont-blood:before {\n  content: \"\\ecf1\";\n}\n\n.icofont-capsule:before {\n  content: \"\\ecf2\";\n}\n\n.icofont-crutches:before {\n  content: \"\\ecf3\";\n}\n\n.icofont-dna-alt-1:before {\n  content: \"\\ecf4\";\n}\n\n.icofont-dna:before {\n  content: \"\\ecf5\";\n}\n\n.icofont-doctor-alt:before {\n  content: \"\\ecf6\";\n}\n\n.icofont-doctor:before {\n  content: \"\\ecf7\";\n}\n\n.icofont-drug-pack:before {\n  content: \"\\ecf8\";\n}\n\n.icofont-drug:before {\n  content: \"\\ecf9\";\n}\n\n.icofont-eye-alt:before {\n  content: \"\\ecfa\";\n}\n\n.icofont-first-aid-alt:before {\n  content: \"\\ecfb\";\n}\n\n.icofont-garbage:before {\n  content: \"\\ecfc\";\n}\n\n.icofont-heart-alt:before {\n  content: \"\\ecfd\";\n}\n\n.icofont-heartbeat:before {\n  content: \"\\ecfe\";\n}\n\n.icofont-herbal:before {\n  content: \"\\ecff\";\n}\n\n.icofont-hospital:before {\n  content: \"\\ed00\";\n}\n\n.icofont-icu:before {\n  content: \"\\ed01\";\n}\n\n.icofont-injection-syringe:before {\n  content: \"\\ed02\";\n}\n\n.icofont-laboratory:before {\n  content: \"\\ed03\";\n}\n\n.icofont-medical-sign-alt:before {\n  content: \"\\ed04\";\n}\n\n.icofont-medical-sign:before {\n  content: \"\\ed05\";\n}\n\n.icofont-nurse-alt:before {\n  content: \"\\ed06\";\n}\n\n.icofont-nurse:before {\n  content: \"\\ed07\";\n}\n\n.icofont-nursing-home:before {\n  content: \"\\ed08\";\n}\n\n.icofont-operation-theater:before {\n  content: \"\\ed09\";\n}\n\n.icofont-paralysis-disability:before {\n  content: \"\\ed0a\";\n}\n\n.icofont-pills:before {\n  content: \"\\ed0b\";\n}\n\n.icofont-prescription:before {\n  content: \"\\ed0c\";\n}\n\n.icofont-pulse:before {\n  content: \"\\ed0d\";\n}\n\n.icofont-stethoscope-alt:before {\n  content: \"\\ed0e\";\n}\n\n.icofont-stethoscope:before {\n  content: \"\\ed0f\";\n}\n\n.icofont-stretcher:before {\n  content: \"\\ed10\";\n}\n\n.icofont-surgeon-alt:before {\n  content: \"\\ed11\";\n}\n\n.icofont-surgeon:before {\n  content: \"\\ed12\";\n}\n\n.icofont-tablets:before {\n  content: \"\\ed13\";\n}\n\n.icofont-test-bottle:before {\n  content: \"\\ed14\";\n}\n\n.icofont-test-tube:before {\n  content: \"\\ed15\";\n}\n\n.icofont-thermometer-alt:before {\n  content: \"\\ed16\";\n}\n\n.icofont-tooth:before {\n  content: \"\\ed17\";\n}\n\n.icofont-xray:before {\n  content: \"\\ed18\";\n}\n\n.icofont-ui-add:before {\n  content: \"\\ed19\";\n}\n\n.icofont-ui-alarm:before {\n  content: \"\\ed1a\";\n}\n\n.icofont-ui-battery:before {\n  content: \"\\ed1b\";\n}\n\n.icofont-ui-block:before {\n  content: \"\\ed1c\";\n}\n\n.icofont-ui-bluetooth:before {\n  content: \"\\ed1d\";\n}\n\n.icofont-ui-brightness:before {\n  content: \"\\ed1e\";\n}\n\n.icofont-ui-browser:before {\n  content: \"\\ed1f\";\n}\n\n.icofont-ui-calculator:before {\n  content: \"\\ed20\";\n}\n\n.icofont-ui-calendar:before {\n  content: \"\\ed21\";\n}\n\n.icofont-ui-call:before {\n  content: \"\\ed22\";\n}\n\n.icofont-ui-camera:before {\n  content: \"\\ed23\";\n}\n\n.icofont-ui-cart:before {\n  content: \"\\ed24\";\n}\n\n.icofont-ui-cell-phone:before {\n  content: \"\\ed25\";\n}\n\n.icofont-ui-chat:before {\n  content: \"\\ed26\";\n}\n\n.icofont-ui-check:before {\n  content: \"\\ed27\";\n}\n\n.icofont-ui-clip-board:before {\n  content: \"\\ed28\";\n}\n\n.icofont-ui-clip:before {\n  content: \"\\ed29\";\n}\n\n.icofont-ui-clock:before {\n  content: \"\\ed2a\";\n}\n\n.icofont-ui-close:before {\n  content: \"\\ed2b\";\n}\n\n.icofont-ui-contact-list:before {\n  content: \"\\ed2c\";\n}\n\n.icofont-ui-copy:before {\n  content: \"\\ed2d\";\n}\n\n.icofont-ui-cut:before {\n  content: \"\\ed2e\";\n}\n\n.icofont-ui-delete:before {\n  content: \"\\ed2f\";\n}\n\n.icofont-ui-dial-phone:before {\n  content: \"\\ed30\";\n}\n\n.icofont-ui-edit:before {\n  content: \"\\ed31\";\n}\n\n.icofont-ui-email:before {\n  content: \"\\ed32\";\n}\n\n.icofont-ui-file:before {\n  content: \"\\ed33\";\n}\n\n.icofont-ui-fire-wall:before {\n  content: \"\\ed34\";\n}\n\n.icofont-ui-flash-light:before {\n  content: \"\\ed35\";\n}\n\n.icofont-ui-flight:before {\n  content: \"\\ed36\";\n}\n\n.icofont-ui-folder:before {\n  content: \"\\ed37\";\n}\n\n.icofont-ui-game:before {\n  content: \"\\ed38\";\n}\n\n.icofont-ui-handicapped:before {\n  content: \"\\ed39\";\n}\n\n.icofont-ui-head-phone:before {\n  content: \"\\ed3a\";\n}\n\n.icofont-ui-home:before {\n  content: \"\\ed3b\";\n}\n\n.icofont-ui-image:before {\n  content: \"\\ed3c\";\n}\n\n.icofont-ui-keyboard:before {\n  content: \"\\ed3d\";\n}\n\n.icofont-ui-laoding:before {\n  content: \"\\ed3e\";\n}\n\n.icofont-ui-lock:before {\n  content: \"\\ed3f\";\n}\n\n.icofont-ui-love-add:before {\n  content: \"\\ed40\";\n}\n\n.icofont-ui-love-broken:before {\n  content: \"\\ed41\";\n}\n\n.icofont-ui-love-remove:before {\n  content: \"\\ed42\";\n}\n\n.icofont-ui-love:before {\n  content: \"\\ed43\";\n}\n\n.icofont-ui-map:before {\n  content: \"\\ed44\";\n}\n\n.icofont-ui-message:before {\n  content: \"\\ed45\";\n}\n\n.icofont-ui-messaging:before {\n  content: \"\\ed46\";\n}\n\n.icofont-ui-movie:before {\n  content: \"\\ed47\";\n}\n\n.icofont-ui-music-player:before {\n  content: \"\\ed48\";\n}\n\n.icofont-ui-music:before {\n  content: \"\\ed49\";\n}\n\n.icofont-ui-mute:before {\n  content: \"\\ed4a\";\n}\n\n.icofont-ui-network:before {\n  content: \"\\ed4b\";\n}\n\n.icofont-ui-next:before {\n  content: \"\\ed4c\";\n}\n\n.icofont-ui-note:before {\n  content: \"\\ed4d\";\n}\n\n.icofont-ui-office:before {\n  content: \"\\ed4e\";\n}\n\n.icofont-ui-password:before {\n  content: \"\\ed4f\";\n}\n\n.icofont-ui-pause:before {\n  content: \"\\ed50\";\n}\n\n.icofont-ui-play-stop:before {\n  content: \"\\ed51\";\n}\n\n.icofont-ui-play:before {\n  content: \"\\ed52\";\n}\n\n.icofont-ui-pointer:before {\n  content: \"\\ed53\";\n}\n\n.icofont-ui-power:before {\n  content: \"\\ed54\";\n}\n\n.icofont-ui-press:before {\n  content: \"\\ed55\";\n}\n\n.icofont-ui-previous:before {\n  content: \"\\ed56\";\n}\n\n.icofont-ui-rate-add:before {\n  content: \"\\ed57\";\n}\n\n.icofont-ui-rate-blank:before {\n  content: \"\\ed58\";\n}\n\n.icofont-ui-rate-remove:before {\n  content: \"\\ed59\";\n}\n\n.icofont-ui-rating:before {\n  content: \"\\ed5a\";\n}\n\n.icofont-ui-record:before {\n  content: \"\\ed5b\";\n}\n\n.icofont-ui-remove:before {\n  content: \"\\ed5c\";\n}\n\n.icofont-ui-reply:before {\n  content: \"\\ed5d\";\n}\n\n.icofont-ui-rotation:before {\n  content: \"\\ed5e\";\n}\n\n.icofont-ui-rss:before {\n  content: \"\\ed5f\";\n}\n\n.icofont-ui-search:before {\n  content: \"\\ed60\";\n}\n\n.icofont-ui-settings:before {\n  content: \"\\ed61\";\n}\n\n.icofont-ui-social-link:before {\n  content: \"\\ed62\";\n}\n\n.icofont-ui-tag:before {\n  content: \"\\ed63\";\n}\n\n.icofont-ui-text-chat:before {\n  content: \"\\ed64\";\n}\n\n.icofont-ui-text-loading:before {\n  content: \"\\ed65\";\n}\n\n.icofont-ui-theme:before {\n  content: \"\\ed66\";\n}\n\n.icofont-ui-timer:before {\n  content: \"\\ed67\";\n}\n\n.icofont-ui-touch-phone:before {\n  content: \"\\ed68\";\n}\n\n.icofont-ui-travel:before {\n  content: \"\\ed69\";\n}\n\n.icofont-ui-unlock:before {\n  content: \"\\ed6a\";\n}\n\n.icofont-ui-user-group:before {\n  content: \"\\ed6b\";\n}\n\n.icofont-ui-user:before {\n  content: \"\\ed6c\";\n}\n\n.icofont-ui-v-card:before {\n  content: \"\\ed6d\";\n}\n\n.icofont-ui-video-chat:before {\n  content: \"\\ed6e\";\n}\n\n.icofont-ui-video-message:before {\n  content: \"\\ed6f\";\n}\n\n.icofont-ui-video-play:before {\n  content: \"\\ed70\";\n}\n\n.icofont-ui-video:before {\n  content: \"\\ed71\";\n}\n\n.icofont-ui-volume:before {\n  content: \"\\ed72\";\n}\n\n.icofont-ui-weather:before {\n  content: \"\\ed73\";\n}\n\n.icofont-ui-wifi:before {\n  content: \"\\ed74\";\n}\n\n.icofont-ui-zoom-in:before {\n  content: \"\\ed75\";\n}\n\n.icofont-ui-zoom-out:before {\n  content: \"\\ed76\";\n}\n\n.icofont-cassette-player:before {\n  content: \"\\ed77\";\n}\n\n.icofont-cassette:before {\n  content: \"\\ed78\";\n}\n\n.icofont-forward:before {\n  content: \"\\ed79\";\n}\n\n.icofont-game:before {\n  content: \"\\ed7a\";\n}\n\n.icofont-guiter:before {\n  content: \"\\ed7b\";\n}\n\n.icofont-headphone-alt-1:before {\n  content: \"\\ed7c\";\n}\n\n.icofont-headphone-alt-2:before {\n  content: \"\\ed7d\";\n}\n\n.icofont-headphone-alt-3:before {\n  content: \"\\ed7e\";\n}\n\n.icofont-listening:before {\n  content: \"\\ed7f\";\n}\n\n.icofont-megaphone-alt:before {\n  content: \"\\ed80\";\n}\n\n.icofont-megaphone:before {\n  content: \"\\ed81\";\n}\n\n.icofont-movie:before {\n  content: \"\\ed82\";\n}\n\n.icofont-mp3-player:before {\n  content: \"\\ed83\";\n}\n\n.icofont-multimedia:before {\n  content: \"\\ed84\";\n}\n\n.icofont-music-disk:before {\n  content: \"\\ed85\";\n}\n\n.icofont-music-note:before {\n  content: \"\\ed86\";\n}\n\n.icofont-pause:before {\n  content: \"\\ed87\";\n}\n\n.icofont-play-alt-1:before {\n  content: \"\\ed88\";\n}\n\n.icofont-play-alt-2:before {\n  content: \"\\ed89\";\n}\n\n.icofont-play-alt-3:before {\n  content: \"\\ed8a\";\n}\n\n.icofont-play-pause:before {\n  content: \"\\ed8b\";\n}\n\n.icofont-record:before {\n  content: \"\\ed8c\";\n}\n\n.icofont-retro-music-disk:before {\n  content: \"\\ed8d\";\n}\n\n.icofont-rewind:before {\n  content: \"\\ed8e\";\n}\n\n.icofont-song-notes:before {\n  content: \"\\ed8f\";\n}\n\n.icofont-sound-wave-alt:before {\n  content: \"\\ed90\";\n}\n\n.icofont-sound-wave:before {\n  content: \"\\ed91\";\n}\n\n.icofont-stop:before {\n  content: \"\\ed92\";\n}\n\n.icofont-video-alt:before {\n  content: \"\\ed93\";\n}\n\n.icofont-video-cam:before {\n  content: \"\\ed94\";\n}\n\n.icofont-volume-bar:before {\n  content: \"\\ed95\";\n}\n\n.icofont-volume-mute:before {\n  content: \"\\ed96\";\n}\n\n.icofont-youtube-play:before {\n  content: \"\\ed97\";\n}\n\n.icofont-amazon-alt:before {\n  content: \"\\ed98\";\n}\n\n.icofont-amazon:before {\n  content: \"\\ed99\";\n}\n\n.icofont-american-express-alt:before {\n  content: \"\\ed9a\";\n}\n\n.icofont-american-express:before {\n  content: \"\\ed9b\";\n}\n\n.icofont-apple-pay-alt:before {\n  content: \"\\ed9c\";\n}\n\n.icofont-apple-pay:before {\n  content: \"\\ed9d\";\n}\n\n.icofont-bank-transfer-alt:before {\n  content: \"\\ed9e\";\n}\n\n.icofont-bank-transfer:before {\n  content: \"\\ed9f\";\n}\n\n.icofont-braintree-alt:before {\n  content: \"\\eda0\";\n}\n\n.icofont-braintree:before {\n  content: \"\\eda1\";\n}\n\n.icofont-cash-on-delivery-alt:before {\n  content: \"\\eda2\";\n}\n\n.icofont-cash-on-delivery:before {\n  content: \"\\eda3\";\n}\n\n.icofont-checkout-alt:before {\n  content: \"\\eda4\";\n}\n\n.icofont-checkout:before {\n  content: \"\\eda5\";\n}\n\n.icofont-diners-club-alt-1:before {\n  content: \"\\eda6\";\n}\n\n.icofont-diners-club-alt-2:before {\n  content: \"\\eda7\";\n}\n\n.icofont-diners-club-alt-3:before {\n  content: \"\\eda8\";\n}\n\n.icofont-diners-club:before {\n  content: \"\\eda9\";\n}\n\n.icofont-discover-alt:before {\n  content: \"\\edaa\";\n}\n\n.icofont-discover:before {\n  content: \"\\edab\";\n}\n\n.icofont-eway-alt:before {\n  content: \"\\edac\";\n}\n\n.icofont-eway:before {\n  content: \"\\edad\";\n}\n\n.icofont-google-wallet-alt-1:before {\n  content: \"\\edae\";\n}\n\n.icofont-google-wallet-alt-2:before {\n  content: \"\\edaf\";\n}\n\n.icofont-google-wallet-alt-3:before {\n  content: \"\\edb0\";\n}\n\n.icofont-google-wallet:before {\n  content: \"\\edb1\";\n}\n\n.icofont-jcb-alt:before {\n  content: \"\\edb2\";\n}\n\n.icofont-jcb:before {\n  content: \"\\edb3\";\n}\n\n.icofont-maestro-alt:before {\n  content: \"\\edb4\";\n}\n\n.icofont-maestro:before {\n  content: \"\\edb5\";\n}\n\n.icofont-mastercard-alt:before {\n  content: \"\\edb6\";\n}\n\n.icofont-mastercard:before {\n  content: \"\\edb7\";\n}\n\n.icofont-payoneer-alt:before {\n  content: \"\\edb8\";\n}\n\n.icofont-payoneer:before {\n  content: \"\\edb9\";\n}\n\n.icofont-paypal-alt:before {\n  content: \"\\edba\";\n}\n\n.icofont-paypal:before {\n  content: \"\\edbb\";\n}\n\n.icofont-sage-alt:before {\n  content: \"\\edbc\";\n}\n\n.icofont-sage:before {\n  content: \"\\edbd\";\n}\n\n.icofont-skrill-alt:before {\n  content: \"\\edbe\";\n}\n\n.icofont-skrill:before {\n  content: \"\\edbf\";\n}\n\n.icofont-stripe-alt:before {\n  content: \"\\edc0\";\n}\n\n.icofont-stripe:before {\n  content: \"\\edc1\";\n}\n\n.icofont-visa-alt:before {\n  content: \"\\edc2\";\n}\n\n.icofont-visa-electron:before {\n  content: \"\\edc3\";\n}\n\n.icofont-visa:before {\n  content: \"\\edc4\";\n}\n\n.icofont-western-union-alt:before {\n  content: \"\\edc5\";\n}\n\n.icofont-western-union:before {\n  content: \"\\edc6\";\n}\n\n.icofont-boy:before {\n  content: \"\\edc7\";\n}\n\n.icofont-business-man-alt-1:before {\n  content: \"\\edc8\";\n}\n\n.icofont-business-man-alt-2:before {\n  content: \"\\edc9\";\n}\n\n.icofont-business-man-alt-3:before {\n  content: \"\\edca\";\n}\n\n.icofont-business-man:before {\n  content: \"\\edcb\";\n}\n\n.icofont-funky-man:before {\n  content: \"\\edcc\";\n}\n\n.icofont-girl-alt:before {\n  content: \"\\edcd\";\n}\n\n.icofont-girl:before {\n  content: \"\\edce\";\n}\n\n.icofont-hotel-boy-alt:before {\n  content: \"\\edcf\";\n}\n\n.icofont-hotel-boy:before {\n  content: \"\\edd0\";\n}\n\n.icofont-man-in-glasses:before {\n  content: \"\\edd1\";\n}\n\n.icofont-user-alt-1:before {\n  content: \"\\edd2\";\n}\n\n.icofont-user-alt-2:before {\n  content: \"\\edd3\";\n}\n\n.icofont-user-alt-3:before {\n  content: \"\\edd4\";\n}\n\n.icofont-user-alt-4:before {\n  content: \"\\edd5\";\n}\n\n.icofont-user-alt-5:before {\n  content: \"\\edd6\";\n}\n\n.icofont-user-alt-6:before {\n  content: \"\\edd7\";\n}\n\n.icofont-user-alt-7:before {\n  content: \"\\edd8\";\n}\n\n.icofont-user-female:before {\n  content: \"\\edd9\";\n}\n\n.icofont-user-male:before {\n  content: \"\\edda\";\n}\n\n.icofont-user-suited:before {\n  content: \"\\eddb\";\n}\n\n.icofont-user:before {\n  content: \"\\eddc\";\n}\n\n.icofont-users-alt-1:before {\n  content: \"\\eddd\";\n}\n\n.icofont-users-alt-2:before {\n  content: \"\\edde\";\n}\n\n.icofont-users-alt-3:before {\n  content: \"\\eddf\";\n}\n\n.icofont-users-alt-4:before {\n  content: \"\\ede0\";\n}\n\n.icofont-users-alt-5:before {\n  content: \"\\ede1\";\n}\n\n.icofont-users-alt-6:before {\n  content: \"\\ede2\";\n}\n\n.icofont-users-social:before {\n  content: \"\\ede3\";\n}\n\n.icofont-users:before {\n  content: \"\\ede4\";\n}\n\n.icofont-waiter:before {\n  content: \"\\ede5\";\n}\n\n.icofont-woman-in-glasses:before {\n  content: \"\\ede6\";\n}\n\n.icofont-document-search:before {\n  content: \"\\ede7\";\n}\n\n.icofont-folder-search:before {\n  content: \"\\ede8\";\n}\n\n.icofont-home-search:before {\n  content: \"\\ede9\";\n}\n\n.icofont-job-search:before {\n  content: \"\\edea\";\n}\n\n.icofont-map-search:before {\n  content: \"\\edeb\";\n}\n\n.icofont-restaurant-search:before {\n  content: \"\\edec\";\n}\n\n.icofont-search-alt-1:before {\n  content: \"\\eded\";\n}\n\n.icofont-search-alt-2:before {\n  content: \"\\edee\";\n}\n\n.icofont-search:before {\n  content: \"\\edef\";\n}\n\n.icofont-stock-search:before {\n  content: \"\\edf0\";\n}\n\n.icofont-user-search:before {\n  content: \"\\edf1\";\n}\n\n.icofont-social-aim:before {\n  content: \"\\edf2\";\n}\n\n.icofont-social-badoo:before {\n  content: \"\\edf3\";\n}\n\n.icofont-social-bebo:before {\n  content: \"\\edf4\";\n}\n\n.icofont-social-behance:before {\n  content: \"\\edf5\";\n}\n\n.icofont-social-blogger:before {\n  content: \"\\edf6\";\n}\n\n.icofont-social-bootstrap:before {\n  content: \"\\edf7\";\n}\n\n.icofont-social-brightkite:before {\n  content: \"\\edf8\";\n}\n\n.icofont-social-cloudapp:before {\n  content: \"\\edf9\";\n}\n\n.icofont-social-concrete5:before {\n  content: \"\\edfa\";\n}\n\n.icofont-social-designbump:before {\n  content: \"\\edfb\";\n}\n\n.icofont-social-designfloat:before {\n  content: \"\\edfc\";\n}\n\n.icofont-social-deviantart:before {\n  content: \"\\edfd\";\n}\n\n.icofont-social-digg:before {\n  content: \"\\edfe\";\n}\n\n.icofont-social-dotcms:before {\n  content: \"\\edff\";\n}\n\n.icofont-social-dribble:before {\n  content: \"\\ee00\";\n}\n\n.icofont-social-dropbox:before {\n  content: \"\\ee01\";\n}\n\n.icofont-brand-drupal:before {\n  content: \"\\ee02\";\n}\n\n.icofont-social-ebuddy:before {\n  content: \"\\ee03\";\n}\n\n.icofont-social-ello:before {\n  content: \"\\ee04\";\n}\n\n.icofont-social-ember:before {\n  content: \"\\ee05\";\n}\n\n.icofont-social-envato:before {\n  content: \"\\ee06\";\n}\n\n.icofont-social-evernote:before {\n  content: \"\\ee07\";\n}\n\n.icofont-social-facebook:before {\n  content: \"\\ee08\";\n}\n\n.icofont-social-feedburner:before {\n  content: \"\\ee09\";\n}\n\n.icofont-social-folkd:before {\n  content: \"\\ee0a\";\n}\n\n.icofont-social-friendfeed:before {\n  content: \"\\ee0b\";\n}\n\n.icofont-social-ghost:before {\n  content: \"\\ee0c\";\n}\n\n.icofont-social-github:before {\n  content: \"\\ee0d\";\n}\n\n.icofont-social-gnome:before {\n  content: \"\\ee0e\";\n}\n\n.icofont-social-google-buzz:before {\n  content: \"\\ee0f\";\n}\n\n.icofont-social-google-map:before {\n  content: \"\\ee10\";\n}\n\n.icofont-social-google-plus:before {\n  content: \"\\ee11\";\n}\n\n.icofont-social-google-talk:before {\n  content: \"\\ee12\";\n}\n\n.icofont-social-hype-machine:before {\n  content: \"\\ee13\";\n}\n\n.icofont-social-instagram:before {\n  content: \"\\ee14\";\n}\n\n.icofont-brand-joomla:before {\n  content: \"\\ee15\";\n}\n\n.icofont-social-kickstarter:before {\n  content: \"\\ee16\";\n}\n\n.icofont-social-line:before {\n  content: \"\\ee17\";\n}\n\n.icofont-social-linux-mint:before {\n  content: \"\\ee18\";\n}\n\n.icofont-social-livejournal:before {\n  content: \"\\ee19\";\n}\n\n.icofont-social-magento:before {\n  content: \"\\ee1a\";\n}\n\n.icofont-social-meetup:before {\n  content: \"\\ee1b\";\n}\n\n.icofont-social-mixx:before {\n  content: \"\\ee1c\";\n}\n\n.icofont-social-newsvine:before {\n  content: \"\\ee1d\";\n}\n\n.icofont-social-nimbuss:before {\n  content: \"\\ee1e\";\n}\n\n.icofont-social-opencart:before {\n  content: \"\\ee1f\";\n}\n\n.icofont-social-oscommerce:before {\n  content: \"\\ee20\";\n}\n\n.icofont-social-pandora:before {\n  content: \"\\ee21\";\n}\n\n.icofont-social-picasa:before {\n  content: \"\\ee22\";\n}\n\n.icofont-social-pinterest:before {\n  content: \"\\ee23\";\n}\n\n.icofont-social-prestashop:before {\n  content: \"\\ee24\";\n}\n\n.icofont-social-qik:before {\n  content: \"\\ee25\";\n}\n\n.icofont-social-readernaut:before {\n  content: \"\\ee26\";\n}\n\n.icofont-social-reddit:before {\n  content: \"\\ee27\";\n}\n\n.icofont-social-rss:before {\n  content: \"\\ee28\";\n}\n\n.icofont-social-shopify:before {\n  content: \"\\ee29\";\n}\n\n.icofont-social-silverstripe:before {\n  content: \"\\ee2a\";\n}\n\n.icofont-social-skype:before {\n  content: \"\\ee2b\";\n}\n\n.icofont-social-slashdot:before {\n  content: \"\\ee2c\";\n}\n\n.icofont-social-smugmug:before {\n  content: \"\\ee2d\";\n}\n\n.icofont-social-steam:before {\n  content: \"\\ee2e\";\n}\n\n.icofont-social-stumbleupon:before {\n  content: \"\\ee2f\";\n}\n\n.icofont-social-technorati:before {\n  content: \"\\ee30\";\n}\n\n.icofont-social-telegram:before {\n  content: \"\\ee31\";\n}\n\n.icofont-social-tinder:before {\n  content: \"\\ee32\";\n}\n\n.icofont-social-tumblr:before {\n  content: \"\\ee33\";\n}\n\n.icofont-social-twitter:before {\n  content: \"\\ee34\";\n}\n\n.icofont-social-typo3:before {\n  content: \"\\ee35\";\n}\n\n.icofont-social-ubercart:before {\n  content: \"\\ee36\";\n}\n\n.icofont-social-viber:before {\n  content: \"\\ee37\";\n}\n\n.icofont-social-viddler:before {\n  content: \"\\ee38\";\n}\n\n.icofont-social-vimeo:before {\n  content: \"\\ee39\";\n}\n\n.icofont-social-vine:before {\n  content: \"\\ee3a\";\n}\n\n.icofont-social-virb:before {\n  content: \"\\ee3b\";\n}\n\n.icofont-social-virtuemart:before {\n  content: \"\\ee3c\";\n}\n\n.icofont-social-wechat:before {\n  content: \"\\ee3d\";\n}\n\n.icofont-brand-wordpress:before {\n  content: \"\\ee3e\";\n}\n\n.icofont-social-xing:before {\n  content: \"\\ee3f\";\n}\n\n.icofont-social-yahoo:before {\n  content: \"\\ee40\";\n}\n\n.icofont-social-yelp:before {\n  content: \"\\ee41\";\n}\n\n.icofont-social-zencart:before {\n  content: \"\\ee42\";\n}\n\n.icofont-badminton-birdie:before {\n  content: \"\\ee43\";\n}\n\n.icofont-baseball:before {\n  content: \"\\ee44\";\n}\n\n.icofont-baseballer:before {\n  content: \"\\ee45\";\n}\n\n.icofont-basketball-hoop:before {\n  content: \"\\ee46\";\n}\n\n.icofont-basketball:before {\n  content: \"\\ee47\";\n}\n\n.icofont-billiard-ball:before {\n  content: \"\\ee48\";\n}\n\n.icofont-boot-alt-1:before {\n  content: \"\\ee49\";\n}\n\n.icofont-boot-alt-2:before {\n  content: \"\\ee4a\";\n}\n\n.icofont-bowling-alt:before {\n  content: \"\\ee4b\";\n}\n\n.icofont-bowling:before {\n  content: \"\\ee4c\";\n}\n\n.icofont-canoe:before {\n  content: \"\\ee4d\";\n}\n\n.icofont-cheer-leader:before {\n  content: \"\\ee4e\";\n}\n\n.icofont-climbing:before {\n  content: \"\\ee4f\";\n}\n\n.icofont-corner:before {\n  content: \"\\ee50\";\n}\n\n.icofont-cyclist:before {\n  content: \"\\ee51\";\n}\n\n.icofont-dumbbell-alt:before {\n  content: \"\\ee52\";\n}\n\n.icofont-dumbbell:before {\n  content: \"\\ee53\";\n}\n\n.icofont-field-alt:before {\n  content: \"\\ee54\";\n}\n\n.icofont-field:before {\n  content: \"\\ee55\";\n}\n\n.icofont-football-alt:before {\n  content: \"\\ee56\";\n}\n\n.icofont-foul:before {\n  content: \"\\ee57\";\n}\n\n.icofont-goal-keeper:before {\n  content: \"\\ee58\";\n}\n\n.icofont-goal:before {\n  content: \"\\ee59\";\n}\n\n.icofont-golf-alt:before {\n  content: \"\\ee5a\";\n}\n\n.icofont-golf-bag:before {\n  content: \"\\ee5b\";\n}\n\n.icofont-golf-field:before {\n  content: \"\\ee5c\";\n}\n\n.icofont-golf:before {\n  content: \"\\ee5d\";\n}\n\n.icofont-golfer:before {\n  content: \"\\ee5e\";\n}\n\n.icofont-gym-alt-1:before {\n  content: \"\\ee5f\";\n}\n\n.icofont-gym-alt-2:before {\n  content: \"\\ee60\";\n}\n\n.icofont-gym-alt-3:before {\n  content: \"\\ee61\";\n}\n\n.icofont-gym:before {\n  content: \"\\ee62\";\n}\n\n.icofont-hand-grippers:before {\n  content: \"\\ee63\";\n}\n\n.icofont-heart-beat-alt:before {\n  content: \"\\ee64\";\n}\n\n.icofont-helmet:before {\n  content: \"\\ee65\";\n}\n\n.icofont-hockey-alt:before {\n  content: \"\\ee66\";\n}\n\n.icofont-hockey:before {\n  content: \"\\ee67\";\n}\n\n.icofont-ice-skate:before {\n  content: \"\\ee68\";\n}\n\n.icofont-jersey-alt:before {\n  content: \"\\ee69\";\n}\n\n.icofont-jersey:before {\n  content: \"\\ee6a\";\n}\n\n.icofont-jumping:before {\n  content: \"\\ee6b\";\n}\n\n.icofont-kick:before {\n  content: \"\\ee6c\";\n}\n\n.icofont-leg:before {\n  content: \"\\ee6d\";\n}\n\n.icofont-match-review:before {\n  content: \"\\ee6e\";\n}\n\n.icofont-medal-alt:before {\n  content: \"\\ee6f\";\n}\n\n.icofont-muscle-alt:before {\n  content: \"\\ee70\";\n}\n\n.icofont-muscle:before {\n  content: \"\\ee71\";\n}\n\n.icofont-offside:before {\n  content: \"\\ee72\";\n}\n\n.icofont-olympic-logo:before {\n  content: \"\\ee73\";\n}\n\n.icofont-olympic:before {\n  content: \"\\ee74\";\n}\n\n.icofont-padding:before {\n  content: \"\\ee75\";\n}\n\n.icofont-penalty-card:before {\n  content: \"\\ee76\";\n}\n\n.icofont-racer:before {\n  content: \"\\ee77\";\n}\n\n.icofont-racing-car:before {\n  content: \"\\ee78\";\n}\n\n.icofont-racing-flag-alt:before {\n  content: \"\\ee79\";\n}\n\n.icofont-racing-flag:before {\n  content: \"\\ee7a\";\n}\n\n.icofont-racings-wheel:before {\n  content: \"\\ee7b\";\n}\n\n.icofont-referee:before {\n  content: \"\\ee7c\";\n}\n\n.icofont-refree-jersey:before {\n  content: \"\\ee7d\";\n}\n\n.icofont-result:before {\n  content: \"\\ee7e\";\n}\n\n.icofont-rugby-ball:before {\n  content: \"\\ee7f\";\n}\n\n.icofont-rugby-player:before {\n  content: \"\\ee80\";\n}\n\n.icofont-rugby:before {\n  content: \"\\ee81\";\n}\n\n.icofont-runner-alt-1:before {\n  content: \"\\ee82\";\n}\n\n.icofont-runner-alt-2:before {\n  content: \"\\ee83\";\n}\n\n.icofont-runner:before {\n  content: \"\\ee84\";\n}\n\n.icofont-score-board:before {\n  content: \"\\ee85\";\n}\n\n.icofont-skiing-man:before {\n  content: \"\\ee86\";\n}\n\n.icofont-skydiving-goggles:before {\n  content: \"\\ee87\";\n}\n\n.icofont-snow-mobile:before {\n  content: \"\\ee88\";\n}\n\n.icofont-steering:before {\n  content: \"\\ee89\";\n}\n\n.icofont-substitute:before {\n  content: \"\\ee8a\";\n}\n\n.icofont-swimmer:before {\n  content: \"\\ee8b\";\n}\n\n.icofont-table-tennis:before {\n  content: \"\\ee8c\";\n}\n\n.icofont-team-alt:before {\n  content: \"\\ee8d\";\n}\n\n.icofont-team:before {\n  content: \"\\ee8e\";\n}\n\n.icofont-tennis-player:before {\n  content: \"\\ee8f\";\n}\n\n.icofont-tennis:before {\n  content: \"\\ee90\";\n}\n\n.icofont-time:before {\n  content: \"\\ee91\";\n}\n\n.icofont-track:before {\n  content: \"\\ee92\";\n}\n\n.icofont-tracking:before {\n  content: \"\\ee93\";\n}\n\n.icofont-trophy-alt:before {\n  content: \"\\ee94\";\n}\n\n.icofont-trophy:before {\n  content: \"\\ee95\";\n}\n\n.icofont-volleyball-alt:before {\n  content: \"\\ee96\";\n}\n\n.icofont-volleyball-fire:before {\n  content: \"\\ee97\";\n}\n\n.icofont-volleyball:before {\n  content: \"\\ee98\";\n}\n\n.icofont-water-bottle:before {\n  content: \"\\ee99\";\n}\n\n.icofont-whisle:before {\n  content: \"\\ee9a\";\n}\n\n.icofont-win-trophy:before {\n  content: \"\\ee9b\";\n}\n\n.icofont-align-center:before {\n  content: \"\\ee9c\";\n}\n\n.icofont-align-left:before {\n  content: \"\\ee9d\";\n}\n\n.icofont-align-right:before {\n  content: \"\\ee9e\";\n}\n\n.icofont-all-caps:before {\n  content: \"\\ee9f\";\n}\n\n.icofont-bold:before {\n  content: \"\\eea0\";\n}\n\n.icofont-brush:before {\n  content: \"\\eea1\";\n}\n\n.icofont-clip-board:before {\n  content: \"\\eea2\";\n}\n\n.icofont-code-alt:before {\n  content: \"\\eea3\";\n}\n\n.icofont-color-bucket:before {\n  content: \"\\eea4\";\n}\n\n.icofont-color-picker:before {\n  content: \"\\eea5\";\n}\n\n.icofont-copy-alt:before {\n  content: \"\\eea6\";\n}\n\n.icofont-copy-black:before {\n  content: \"\\eea7\";\n}\n\n.icofont-cut:before {\n  content: \"\\eea8\";\n}\n\n.icofont-delete-alt:before {\n  content: \"\\eea9\";\n}\n\n.icofont-edit-alt:before {\n  content: \"\\eeaa\";\n}\n\n.icofont-eraser-alt:before {\n  content: \"\\eeab\";\n}\n\n.icofont-file-alt:before {\n  content: \"\\eeac\";\n}\n\n.icofont-font:before {\n  content: \"\\eead\";\n}\n\n.icofont-header:before {\n  content: \"\\eeae\";\n}\n\n.icofont-indent:before {\n  content: \"\\eeaf\";\n}\n\n.icofont-italic-alt:before {\n  content: \"\\eeb0\";\n}\n\n.icofont-justify-all:before {\n  content: \"\\eeb1\";\n}\n\n.icofont-justify-center:before {\n  content: \"\\eeb2\";\n}\n\n.icofont-justify-left:before {\n  content: \"\\eeb3\";\n}\n\n.icofont-justify-right:before {\n  content: \"\\eeb4\";\n}\n\n.icofont-line-height:before {\n  content: \"\\eeb5\";\n}\n\n.icofont-link-alt:before {\n  content: \"\\eeb6\";\n}\n\n.icofont-listine-dots:before {\n  content: \"\\eeb7\";\n}\n\n.icofont-listing-box:before {\n  content: \"\\eeb8\";\n}\n\n.icofont-listing-number:before {\n  content: \"\\eeb9\";\n}\n\n.icofont-marker:before {\n  content: \"\\eeba\";\n}\n\n.icofont-outdent:before {\n  content: \"\\eebb\";\n}\n\n.icofont-paper-clip:before {\n  content: \"\\eebc\";\n}\n\n.icofont-paragraph:before {\n  content: \"\\eebd\";\n}\n\n.icofont-pin:before {\n  content: \"\\eebe\";\n}\n\n.icofont-printer:before {\n  content: \"\\eebf\";\n}\n\n.icofont-redo:before {\n  content: \"\\eec0\";\n}\n\n.icofont-rotation:before {\n  content: \"\\eec1\";\n}\n\n.icofont-save:before {\n  content: \"\\eec2\";\n}\n\n.icofont-small-cap:before {\n  content: \"\\eec3\";\n}\n\n.icofont-strike-through:before {\n  content: \"\\eec4\";\n}\n\n.icofont-sub-listing:before {\n  content: \"\\eec5\";\n}\n\n.icofont-subscript:before {\n  content: \"\\eec6\";\n}\n\n.icofont-superscript:before {\n  content: \"\\eec7\";\n}\n\n.icofont-table:before {\n  content: \"\\eec8\";\n}\n\n.icofont-text-height:before {\n  content: \"\\eec9\";\n}\n\n.icofont-text-width:before {\n  content: \"\\eeca\";\n}\n\n.icofont-trash:before {\n  content: \"\\eecb\";\n}\n\n.icofont-underline:before {\n  content: \"\\eecc\";\n}\n\n.icofont-undo:before {\n  content: \"\\eecd\";\n}\n\n.icofont-unlink:before {\n  content: \"\\eece\";\n}\n\n.icofont-air-balloon:before {\n  content: \"\\eecf\";\n}\n\n.icofont-airplane-alt:before {\n  content: \"\\eed0\";\n}\n\n.icofont-airplane:before {\n  content: \"\\eed1\";\n}\n\n.icofont-ambulance-crescent:before {\n  content: \"\\eed2\";\n}\n\n.icofont-ambulance-cross:before {\n  content: \"\\eed3\";\n}\n\n.icofont-articulated-truck:before {\n  content: \"\\eed4\";\n}\n\n.icofont-auto-rickshaw:before {\n  content: \"\\eed5\";\n}\n\n.icofont-bicycle-alt-1:before {\n  content: \"\\eed6\";\n}\n\n.icofont-bicycle-alt-2:before {\n  content: \"\\eed7\";\n}\n\n.icofont-bull-dozer:before {\n  content: \"\\eed8\";\n}\n\n.icofont-bus-alt-1:before {\n  content: \"\\eed9\";\n}\n\n.icofont-bus-alt-2:before {\n  content: \"\\eeda\";\n}\n\n.icofont-bus-alt-3:before {\n  content: \"\\eedb\";\n}\n\n.icofont-cable-car:before {\n  content: \"\\eedc\";\n}\n\n.icofont-car-alt-1:before {\n  content: \"\\eedd\";\n}\n\n.icofont-car-alt-2:before {\n  content: \"\\eede\";\n}\n\n.icofont-car-alt-3:before {\n  content: \"\\eedf\";\n}\n\n.icofont-car-alt-4:before {\n  content: \"\\eee0\";\n}\n\n.icofont-concrete-mixer:before {\n  content: \"\\eee1\";\n}\n\n.icofont-delivery-time:before {\n  content: \"\\eee2\";\n}\n\n.icofont-excavator:before {\n  content: \"\\eee3\";\n}\n\n.icofont-fast-delivery:before {\n  content: \"\\eee4\";\n}\n\n.icofont-fire-truck-alt:before {\n  content: \"\\eee5\";\n}\n\n.icofont-fire-truck:before {\n  content: \"\\eee6\";\n}\n\n.icofont-fork-lift:before {\n  content: \"\\eee7\";\n}\n\n.icofont-free-delivery:before {\n  content: \"\\eee8\";\n}\n\n.icofont-golf-cart:before {\n  content: \"\\eee9\";\n}\n\n.icofont-helicopter:before {\n  content: \"\\eeea\";\n}\n\n.icofont-motor-bike-alt:before {\n  content: \"\\eeeb\";\n}\n\n.icofont-motor-bike:before {\n  content: \"\\eeec\";\n}\n\n.icofont-motor-biker:before {\n  content: \"\\eeed\";\n}\n\n.icofont-oil-truck:before {\n  content: \"\\eeee\";\n}\n\n.icofont-police-car:before {\n  content: \"\\eeef\";\n}\n\n.icofont-rickshaw:before {\n  content: \"\\eef0\";\n}\n\n.icofont-rocket-alt-1:before {\n  content: \"\\eef1\";\n}\n\n.icofont-rocket-alt-2:before {\n  content: \"\\eef2\";\n}\n\n.icofont-sail-boat:before {\n  content: \"\\eef3\";\n}\n\n.icofont-scooter:before {\n  content: \"\\eef4\";\n}\n\n.icofont-sea-plane:before {\n  content: \"\\eef5\";\n}\n\n.icofont-ship-alt:before {\n  content: \"\\eef6\";\n}\n\n.icofont-speed-boat:before {\n  content: \"\\eef7\";\n}\n\n.icofont-taxi:before {\n  content: \"\\eef8\";\n}\n\n.icofont-tow-truck:before {\n  content: \"\\eef9\";\n}\n\n.icofont-tractor:before {\n  content: \"\\eefa\";\n}\n\n.icofont-traffic-light:before {\n  content: \"\\eefb\";\n}\n\n.icofont-train-line:before {\n  content: \"\\eefc\";\n}\n\n.icofont-train-steam:before {\n  content: \"\\eefd\";\n}\n\n.icofont-tram:before {\n  content: \"\\eefe\";\n}\n\n.icofont-truck-alt:before {\n  content: \"\\eeff\";\n}\n\n.icofont-truck-loaded:before {\n  content: \"\\ef00\";\n}\n\n.icofont-truck:before {\n  content: \"\\ef01\";\n}\n\n.icofont-van-alt:before {\n  content: \"\\ef02\";\n}\n\n.icofont-van:before {\n  content: \"\\ef03\";\n}\n\n.icofont-yacht:before {\n  content: \"\\ef04\";\n}\n\n.icofont-5-star-hotel:before {\n  content: \"\\ef05\";\n}\n\n.icofont-anchor-alt:before {\n  content: \"\\ef06\";\n}\n\n.icofont-beach-bed:before {\n  content: \"\\ef07\";\n}\n\n.icofont-camping-vest:before {\n  content: \"\\ef08\";\n}\n\n.icofont-coconut-alt:before {\n  content: \"\\ef09\";\n}\n\n.icofont-direction-sign:before {\n  content: \"\\ef0a\";\n}\n\n.icofont-hill-side:before {\n  content: \"\\ef0b\";\n}\n\n.icofont-island-alt:before {\n  content: \"\\ef0c\";\n}\n\n.icofont-long-drive:before {\n  content: \"\\ef0d\";\n}\n\n.icofont-map-pins:before {\n  content: \"\\ef0e\";\n}\n\n.icofont-plane-ticket:before {\n  content: \"\\ef0f\";\n}\n\n.icofont-sail-boat-alt-1:before {\n  content: \"\\ef10\";\n}\n\n.icofont-sail-boat-alt-2:before {\n  content: \"\\ef11\";\n}\n\n.icofont-sandals-female:before {\n  content: \"\\ef12\";\n}\n\n.icofont-sandals-male:before {\n  content: \"\\ef13\";\n}\n\n.icofont-travelling:before {\n  content: \"\\ef14\";\n}\n\n.icofont-breakdown:before {\n  content: \"\\ef15\";\n}\n\n.icofont-celsius:before {\n  content: \"\\ef16\";\n}\n\n.icofont-clouds:before {\n  content: \"\\ef17\";\n}\n\n.icofont-cloudy:before {\n  content: \"\\ef18\";\n}\n\n.icofont-compass-alt:before {\n  content: \"\\ef19\";\n}\n\n.icofont-dust:before {\n  content: \"\\ef1a\";\n}\n\n.icofont-eclipse:before {\n  content: \"\\ef1b\";\n}\n\n.icofont-fahrenheit:before {\n  content: \"\\ef1c\";\n}\n\n.icofont-forest-fire:before {\n  content: \"\\ef1d\";\n}\n\n.icofont-full-night:before {\n  content: \"\\ef1e\";\n}\n\n.icofont-full-sunny:before {\n  content: \"\\ef1f\";\n}\n\n.icofont-hail-night:before {\n  content: \"\\ef20\";\n}\n\n.icofont-hail-rainy-night:before {\n  content: \"\\ef21\";\n}\n\n.icofont-hail-rainy-sunny:before {\n  content: \"\\ef22\";\n}\n\n.icofont-hail-rainy:before {\n  content: \"\\ef23\";\n}\n\n.icofont-hail-sunny:before {\n  content: \"\\ef24\";\n}\n\n.icofont-hail-thunder-night:before {\n  content: \"\\ef25\";\n}\n\n.icofont-hail-thunder-sunny:before {\n  content: \"\\ef26\";\n}\n\n.icofont-hail-thunder:before {\n  content: \"\\ef27\";\n}\n\n.icofont-hail:before {\n  content: \"\\ef28\";\n}\n\n.icofont-hill-night:before {\n  content: \"\\ef29\";\n}\n\n.icofont-hill-sunny:before {\n  content: \"\\ef2a\";\n}\n\n.icofont-hill:before {\n  content: \"\\ef2b\";\n}\n\n.icofont-hurricane:before {\n  content: \"\\ef2c\";\n}\n\n.icofont-island:before {\n  content: \"\\ef2d\";\n}\n\n.icofont-meteor:before {\n  content: \"\\ef2e\";\n}\n\n.icofont-night:before {\n  content: \"\\ef2f\";\n}\n\n.icofont-rainy-night:before {\n  content: \"\\ef30\";\n}\n\n.icofont-rainy-sunny:before {\n  content: \"\\ef31\";\n}\n\n.icofont-rainy-thunder:before {\n  content: \"\\ef32\";\n}\n\n.icofont-rainy:before {\n  content: \"\\ef33\";\n}\n\n.icofont-showy-night-hail:before {\n  content: \"\\ef34\";\n}\n\n.icofont-snow-temp:before {\n  content: \"\\ef35\";\n}\n\n.icofont-snow:before {\n  content: \"\\ef36\";\n}\n\n.icofont-snowy-hail:before {\n  content: \"\\ef37\";\n}\n\n.icofont-snowy-night-rainy:before {\n  content: \"\\ef38\";\n}\n\n.icofont-snowy-night:before {\n  content: \"\\ef39\";\n}\n\n.icofont-snowy-rainy:before {\n  content: \"\\ef3a\";\n}\n\n.icofont-snowy-sunny-hail:before {\n  content: \"\\ef3b\";\n}\n\n.icofont-snowy-sunny-rainy:before {\n  content: \"\\ef3c\";\n}\n\n.icofont-snowy-sunny:before {\n  content: \"\\ef3d\";\n}\n\n.icofont-snowy-thunder-night:before {\n  content: \"\\ef3e\";\n}\n\n.icofont-snowy-thunder-sunny:before {\n  content: \"\\ef3f\";\n}\n\n.icofont-snowy-thunder:before {\n  content: \"\\ef40\";\n}\n\n.icofont-snowy-windy-night:before {\n  content: \"\\ef41\";\n}\n\n.icofont-snowy-windy-sunny:before {\n  content: \"\\ef42\";\n}\n\n.icofont-snowy-windy:before {\n  content: \"\\ef43\";\n}\n\n.icofont-snowy:before {\n  content: \"\\ef44\";\n}\n\n.icofont-sun-alt:before {\n  content: \"\\ef45\";\n}\n\n.icofont-sun-rise:before {\n  content: \"\\ef46\";\n}\n\n.icofont-sun-set:before {\n  content: \"\\ef47\";\n}\n\n.icofont-sunny-day-temp:before {\n  content: \"\\ef48\";\n}\n\n.icofont-sunny:before {\n  content: \"\\ef49\";\n}\n\n.icofont-thermometer:before {\n  content: \"\\ef4a\";\n}\n\n.icofont-thinder-light:before {\n  content: \"\\ef4b\";\n}\n\n.icofont-tornado:before {\n  content: \"\\ef4c\";\n}\n\n.icofont-umbrella-alt:before {\n  content: \"\\ef4d\";\n}\n\n.icofont-volcano:before {\n  content: \"\\ef4e\";\n}\n\n.icofont-wave:before {\n  content: \"\\ef4f\";\n}\n\n.icofont-wind-scale-0:before {\n  content: \"\\ef50\";\n}\n\n.icofont-wind-scale-1:before {\n  content: \"\\ef51\";\n}\n\n.icofont-wind-scale-2:before {\n  content: \"\\ef52\";\n}\n\n.icofont-wind-scale-3:before {\n  content: \"\\ef53\";\n}\n\n.icofont-wind-scale-4:before {\n  content: \"\\ef54\";\n}\n\n.icofont-wind-scale-5:before {\n  content: \"\\ef55\";\n}\n\n.icofont-wind-scale-6:before {\n  content: \"\\ef56\";\n}\n\n.icofont-wind-scale-7:before {\n  content: \"\\ef57\";\n}\n\n.icofont-wind-scale-8:before {\n  content: \"\\ef58\";\n}\n\n.icofont-wind-scale-9:before {\n  content: \"\\ef59\";\n}\n\n.icofont-wind-scale-10:before {\n  content: \"\\ef5a\";\n}\n\n.icofont-wind-scale-11:before {\n  content: \"\\ef5b\";\n}\n\n.icofont-wind-scale-12:before {\n  content: \"\\ef5c\";\n}\n\n.icofont-wind-waves:before {\n  content: \"\\ef5d\";\n}\n\n.icofont-wind:before {\n  content: \"\\ef5e\";\n}\n\n.icofont-windy-hail:before {\n  content: \"\\ef5f\";\n}\n\n.icofont-windy-night:before {\n  content: \"\\ef60\";\n}\n\n.icofont-windy-raining:before {\n  content: \"\\ef61\";\n}\n\n.icofont-windy-sunny:before {\n  content: \"\\ef62\";\n}\n\n.icofont-windy-thunder-raining:before {\n  content: \"\\ef63\";\n}\n\n.icofont-windy-thunder:before {\n  content: \"\\ef64\";\n}\n\n.icofont-windy:before {\n  content: \"\\ef65\";\n}\n\n.icofont-addons:before {\n  content: \"\\ef66\";\n}\n\n.icofont-address-book:before {\n  content: \"\\ef67\";\n}\n\n.icofont-adjust:before {\n  content: \"\\ef68\";\n}\n\n.icofont-alarm:before {\n  content: \"\\ef69\";\n}\n\n.icofont-anchor:before {\n  content: \"\\ef6a\";\n}\n\n.icofont-archive:before {\n  content: \"\\ef6b\";\n}\n\n.icofont-at:before {\n  content: \"\\ef6c\";\n}\n\n.icofont-attachment:before {\n  content: \"\\ef6d\";\n}\n\n.icofont-audio:before {\n  content: \"\\ef6e\";\n}\n\n.icofont-auto-mobile:before {\n  content: \"\\ef6f\";\n}\n\n.icofont-automation:before {\n  content: \"\\ef70\";\n}\n\n.icofont-baby:before {\n  content: \"\\ef71\";\n}\n\n.icofont-badge:before {\n  content: \"\\ef72\";\n}\n\n.icofont-bag:before {\n  content: \"\\ef73\";\n}\n\n.icofont-ban:before {\n  content: \"\\ef74\";\n}\n\n.icofont-bank:before {\n  content: \"\\ef75\";\n}\n\n.icofont-bar-code:before {\n  content: \"\\ef76\";\n}\n\n.icofont-bars:before {\n  content: \"\\ef77\";\n}\n\n.icofont-battery-empty:before {\n  content: \"\\ef78\";\n}\n\n.icofont-battery-full:before {\n  content: \"\\ef79\";\n}\n\n.icofont-battery-half:before {\n  content: \"\\ef7a\";\n}\n\n.icofont-battery-low:before {\n  content: \"\\ef7b\";\n}\n\n.icofont-beach:before {\n  content: \"\\ef7c\";\n}\n\n.icofont-beaker:before {\n  content: \"\\ef7d\";\n}\n\n.icofont-bear:before {\n  content: \"\\ef7e\";\n}\n\n.icofont-beard:before {\n  content: \"\\ef7f\";\n}\n\n.icofont-bed:before {\n  content: \"\\ef80\";\n}\n\n.icofont-bell:before {\n  content: \"\\ef81\";\n}\n\n.icofont-beverage:before {\n  content: \"\\ef82\";\n}\n\n.icofont-bicycle:before {\n  content: \"\\ef83\";\n}\n\n.icofont-bill:before {\n  content: \"\\ef84\";\n}\n\n.icofont-bin:before {\n  content: \"\\ef85\";\n}\n\n.icofont-binary:before {\n  content: \"\\ef86\";\n}\n\n.icofont-binoculars:before {\n  content: \"\\ef87\";\n}\n\n.icofont-bird:before {\n  content: \"\\ef88\";\n}\n\n.icofont-birds:before {\n  content: \"\\ef89\";\n}\n\n.icofont-black-board:before {\n  content: \"\\ef8a\";\n}\n\n.icofont-bluetooth:before {\n  content: \"\\ef8b\";\n}\n\n.icofont-bolt:before {\n  content: \"\\ef8c\";\n}\n\n.icofont-bomb:before {\n  content: \"\\ef8d\";\n}\n\n.icofont-book-mark:before {\n  content: \"\\ef8e\";\n}\n\n.icofont-book:before {\n  content: \"\\ef8f\";\n}\n\n.icofont-boot:before {\n  content: \"\\ef90\";\n}\n\n.icofont-box:before {\n  content: \"\\ef91\";\n}\n\n.icofont-brain:before {\n  content: \"\\ef92\";\n}\n\n.icofont-briefcase:before {\n  content: \"\\ef93\";\n}\n\n.icofont-broken:before {\n  content: \"\\ef94\";\n}\n\n.icofont-bucket:before {\n  content: \"\\ef95\";\n}\n\n.icofont-bucket1:before {\n  content: \"\\ef96\";\n}\n\n.icofont-bucket2:before {\n  content: \"\\ef97\";\n}\n\n.icofont-bug:before {\n  content: \"\\ef98\";\n}\n\n.icofont-building:before {\n  content: \"\\ef99\";\n}\n\n.icofont-bullet:before {\n  content: \"\\ef9a\";\n}\n\n.icofont-bullhorn:before {\n  content: \"\\ef9b\";\n}\n\n.icofont-bullseye:before {\n  content: \"\\ef9c\";\n}\n\n.icofont-bus:before {\n  content: \"\\ef9d\";\n}\n\n.icofont-butterfly:before {\n  content: \"\\ef9e\";\n}\n\n.icofont-cab:before {\n  content: \"\\ef9f\";\n}\n\n.icofont-calculator:before {\n  content: \"\\efa0\";\n}\n\n.icofont-calendar:before {\n  content: \"\\efa1\";\n}\n\n.icofont-camera-alt:before {\n  content: \"\\efa2\";\n}\n\n.icofont-camera:before {\n  content: \"\\efa3\";\n}\n\n.icofont-car:before {\n  content: \"\\efa4\";\n}\n\n.icofont-card:before {\n  content: \"\\efa5\";\n}\n\n.icofont-cart:before {\n  content: \"\\efa6\";\n}\n\n.icofont-cc:before {\n  content: \"\\efa7\";\n}\n\n.icofont-certificate:before {\n  content: \"\\efa8\";\n}\n\n.icofont-charging:before {\n  content: \"\\efa9\";\n}\n\n.icofont-chat:before {\n  content: \"\\efaa\";\n}\n\n.icofont-check-alt:before {\n  content: \"\\efab\";\n}\n\n.icofont-check-circled:before {\n  content: \"\\efac\";\n}\n\n.icofont-check:before {\n  content: \"\\efad\";\n}\n\n.icofont-checked:before {\n  content: \"\\efae\";\n}\n\n.icofont-children-care:before {\n  content: \"\\efaf\";\n}\n\n.icofont-clock-time:before {\n  content: \"\\efb0\";\n}\n\n.icofont-close-circled:before {\n  content: \"\\efb1\";\n}\n\n.icofont-close-line-circled:before {\n  content: \"\\efb2\";\n}\n\n.icofont-close-line-squared-alt:before {\n  content: \"\\efb3\";\n}\n\n.icofont-close-line-squared:before {\n  content: \"\\efb4\";\n}\n\n.icofont-close-line:before {\n  content: \"\\efb5\";\n}\n\n.icofont-close-squared-alt:before {\n  content: \"\\efb6\";\n}\n\n.icofont-close-squared:before {\n  content: \"\\efb7\";\n}\n\n.icofont-close:before {\n  content: \"\\efb8\";\n}\n\n.icofont-cloud-download:before {\n  content: \"\\efb9\";\n}\n\n.icofont-cloud-refresh:before {\n  content: \"\\efba\";\n}\n\n.icofont-cloud-upload:before {\n  content: \"\\efbb\";\n}\n\n.icofont-cloud:before {\n  content: \"\\efbc\";\n}\n\n.icofont-code-not-allowed:before {\n  content: \"\\efbd\";\n}\n\n.icofont-code:before {\n  content: \"\\efbe\";\n}\n\n.icofont-coffee-cup:before {\n  content: \"\\efbf\";\n}\n\n.icofont-comment:before {\n  content: \"\\efc0\";\n}\n\n.icofont-compass:before {\n  content: \"\\efc1\";\n}\n\n.icofont-computer:before {\n  content: \"\\efc2\";\n}\n\n.icofont-connection:before {\n  content: \"\\efc3\";\n}\n\n.icofont-console:before {\n  content: \"\\efc4\";\n}\n\n.icofont-contacts:before {\n  content: \"\\efc5\";\n}\n\n.icofont-contrast:before {\n  content: \"\\efc6\";\n}\n\n.icofont-copy:before {\n  content: \"\\efc7\";\n}\n\n.icofont-copyright:before {\n  content: \"\\efc8\";\n}\n\n.icofont-credit-card:before {\n  content: \"\\efc9\";\n}\n\n.icofont-crop:before {\n  content: \"\\efca\";\n}\n\n.icofont-crown:before {\n  content: \"\\efcb\";\n}\n\n.icofont-cube:before {\n  content: \"\\efcc\";\n}\n\n.icofont-cubes:before {\n  content: \"\\efcd\";\n}\n\n.icofont-culinary:before {\n  content: \"\\efce\";\n}\n\n.icofont-dashboard-web:before {\n  content: \"\\efcf\";\n}\n\n.icofont-dashboard:before {\n  content: \"\\efd0\";\n}\n\n.icofont-data:before {\n  content: \"\\efd1\";\n}\n\n.icofont-database-add:before {\n  content: \"\\efd2\";\n}\n\n.icofont-database-locked:before {\n  content: \"\\efd3\";\n}\n\n.icofont-database-remove:before {\n  content: \"\\efd4\";\n}\n\n.icofont-database:before {\n  content: \"\\efd5\";\n}\n\n.icofont-delete:before {\n  content: \"\\efd6\";\n}\n\n.icofont-diamond:before {\n  content: \"\\efd7\";\n}\n\n.icofont-dice:before {\n  content: \"\\efd8\";\n}\n\n.icofont-disabled:before {\n  content: \"\\efd9\";\n}\n\n.icofont-disc:before {\n  content: \"\\efda\";\n}\n\n.icofont-diskette:before {\n  content: \"\\efdb\";\n}\n\n.icofont-document-folder:before {\n  content: \"\\efdc\";\n}\n\n.icofont-download-alt:before {\n  content: \"\\efdd\";\n}\n\n.icofont-download:before {\n  content: \"\\efde\";\n}\n\n.icofont-downloaded:before {\n  content: \"\\efdf\";\n}\n\n.icofont-earth:before {\n  content: \"\\efe0\";\n}\n\n.icofont-ebook:before {\n  content: \"\\efe1\";\n}\n\n.icofont-edit:before {\n  content: \"\\efe2\";\n}\n\n.icofont-eject:before {\n  content: \"\\efe3\";\n}\n\n.icofont-email:before {\n  content: \"\\efe4\";\n}\n\n.icofont-envelope-open:before {\n  content: \"\\efe5\";\n}\n\n.icofont-envelope:before {\n  content: \"\\efe6\";\n}\n\n.icofont-eraser:before {\n  content: \"\\efe7\";\n}\n\n.icofont-error:before {\n  content: \"\\efe8\";\n}\n\n.icofont-exchange:before {\n  content: \"\\efe9\";\n}\n\n.icofont-exclamation-circle:before {\n  content: \"\\efea\";\n}\n\n.icofont-exclamation-square:before {\n  content: \"\\efeb\";\n}\n\n.icofont-exclamation-tringle:before {\n  content: \"\\efec\";\n}\n\n.icofont-exclamation:before {\n  content: \"\\efed\";\n}\n\n.icofont-exit:before {\n  content: \"\\efee\";\n}\n\n.icofont-expand:before {\n  content: \"\\efef\";\n}\n\n.icofont-external-link:before {\n  content: \"\\eff0\";\n}\n\n.icofont-external:before {\n  content: \"\\eff1\";\n}\n\n.icofont-eye-blocked:before {\n  content: \"\\eff2\";\n}\n\n.icofont-eye-dropper:before {\n  content: \"\\eff3\";\n}\n\n.icofont-eye:before {\n  content: \"\\eff4\";\n}\n\n.icofont-favourite:before {\n  content: \"\\eff5\";\n}\n\n.icofont-fax:before {\n  content: \"\\eff6\";\n}\n\n.icofont-female:before {\n  content: \"\\eff7\";\n}\n\n.icofont-file:before {\n  content: \"\\eff8\";\n}\n\n.icofont-film:before {\n  content: \"\\eff9\";\n}\n\n.icofont-filter:before {\n  content: \"\\effa\";\n}\n\n.icofont-fire-burn:before {\n  content: \"\\effb\";\n}\n\n.icofont-fire-extinguisher:before {\n  content: \"\\effc\";\n}\n\n.icofont-fire:before {\n  content: \"\\effd\";\n}\n\n.icofont-first-aid:before {\n  content: \"\\effe\";\n}\n\n.icofont-flag-alt-1:before {\n  content: \"\\efff\";\n}\n\n.icofont-flag-alt-2:before {\n  content: \"\\f000\";\n}\n\n.icofont-flag:before {\n  content: \"\\f001\";\n}\n\n.icofont-flash-light:before {\n  content: \"\\f002\";\n}\n\n.icofont-flash:before {\n  content: \"\\f003\";\n}\n\n.icofont-flask:before {\n  content: \"\\f004\";\n}\n\n.icofont-focus:before {\n  content: \"\\f005\";\n}\n\n.icofont-folder-open:before {\n  content: \"\\f006\";\n}\n\n.icofont-folder:before {\n  content: \"\\f007\";\n}\n\n.icofont-foot-print:before {\n  content: \"\\f008\";\n}\n\n.icofont-football-american:before {\n  content: \"\\f009\";\n}\n\n.icofont-football:before {\n  content: \"\\f00a\";\n}\n\n.icofont-game-console:before {\n  content: \"\\f00b\";\n}\n\n.icofont-game-pad:before {\n  content: \"\\f00c\";\n}\n\n.icofont-gavel:before {\n  content: \"\\f00d\";\n}\n\n.icofont-gear:before {\n  content: \"\\f00e\";\n}\n\n.icofont-gears:before {\n  content: \"\\f00f\";\n}\n\n.icofont-gift:before {\n  content: \"\\f010\";\n}\n\n.icofont-glass:before {\n  content: \"\\f011\";\n}\n\n.icofont-globe:before {\n  content: \"\\f012\";\n}\n\n.icofont-graduate:before {\n  content: \"\\f013\";\n}\n\n.icofont-graffiti:before {\n  content: \"\\f014\";\n}\n\n.icofont-grocery:before {\n  content: \"\\f015\";\n}\n\n.icofont-group:before {\n  content: \"\\f016\";\n}\n\n.icofont-hammer:before {\n  content: \"\\f017\";\n}\n\n.icofont-hand:before {\n  content: \"\\f018\";\n}\n\n.icofont-hanger:before {\n  content: \"\\f019\";\n}\n\n.icofont-hard-disk:before {\n  content: \"\\f01a\";\n}\n\n.icofont-headphone:before {\n  content: \"\\f01b\";\n}\n\n.icofont-heart-beat:before {\n  content: \"\\f01c\";\n}\n\n.icofont-heart:before {\n  content: \"\\f01d\";\n}\n\n.icofont-history:before {\n  content: \"\\f01e\";\n}\n\n.icofont-home:before {\n  content: \"\\f01f\";\n}\n\n.icofont-horn:before {\n  content: \"\\f020\";\n}\n\n.icofont-hotel:before {\n  content: \"\\f021\";\n}\n\n.icofont-hour-glass:before {\n  content: \"\\f022\";\n}\n\n.icofont-id:before {\n  content: \"\\f023\";\n}\n\n.icofont-image:before {\n  content: \"\\f024\";\n}\n\n.icofont-inbox:before {\n  content: \"\\f025\";\n}\n\n.icofont-infinite:before {\n  content: \"\\f026\";\n}\n\n.icofont-info-circle:before {\n  content: \"\\f027\";\n}\n\n.icofont-info-square:before {\n  content: \"\\f028\";\n}\n\n.icofont-info:before {\n  content: \"\\f029\";\n}\n\n.icofont-institution:before {\n  content: \"\\f02a\";\n}\n\n.icofont-interface:before {\n  content: \"\\f02b\";\n}\n\n.icofont-invisible:before {\n  content: \"\\f02c\";\n}\n\n.icofont-italic:before {\n  content: \"\\f02d\";\n}\n\n.icofont-jacket:before {\n  content: \"\\f02e\";\n}\n\n.icofont-jar:before {\n  content: \"\\f02f\";\n}\n\n.icofont-jewlery:before {\n  content: \"\\f030\";\n}\n\n.icofont-karate:before {\n  content: \"\\f031\";\n}\n\n.icofont-key-hole:before {\n  content: \"\\f032\";\n}\n\n.icofont-key:before {\n  content: \"\\f033\";\n}\n\n.icofont-keyboard:before {\n  content: \"\\f034\";\n}\n\n.icofont-kid:before {\n  content: \"\\f035\";\n}\n\n.icofont-label:before {\n  content: \"\\f036\";\n}\n\n.icofont-lamp:before {\n  content: \"\\f037\";\n}\n\n.icofont-laptop:before {\n  content: \"\\f038\";\n}\n\n.icofont-layers:before {\n  content: \"\\f039\";\n}\n\n.icofont-layout:before {\n  content: \"\\f03a\";\n}\n\n.icofont-leaf:before {\n  content: \"\\f03b\";\n}\n\n.icofont-leaflet:before {\n  content: \"\\f03c\";\n}\n\n.icofont-learn:before {\n  content: \"\\f03d\";\n}\n\n.icofont-legal:before {\n  content: \"\\f03e\";\n}\n\n.icofont-lego:before {\n  content: \"\\f03f\";\n}\n\n.icofont-lemon:before {\n  content: \"\\f040\";\n}\n\n.icofont-lens:before {\n  content: \"\\f041\";\n}\n\n.icofont-letter:before {\n  content: \"\\f042\";\n}\n\n.icofont-letterbox:before {\n  content: \"\\f043\";\n}\n\n.icofont-library:before {\n  content: \"\\f044\";\n}\n\n.icofont-license:before {\n  content: \"\\f045\";\n}\n\n.icofont-life-bouy:before {\n  content: \"\\f046\";\n}\n\n.icofont-life-buoy:before {\n  content: \"\\f047\";\n}\n\n.icofont-life-jacket:before {\n  content: \"\\f048\";\n}\n\n.icofont-life-ring:before {\n  content: \"\\f049\";\n}\n\n.icofont-light-bulb:before {\n  content: \"\\f04a\";\n}\n\n.icofont-lighter:before {\n  content: \"\\f04b\";\n}\n\n.icofont-lightning-ray:before {\n  content: \"\\f04c\";\n}\n\n.icofont-like:before {\n  content: \"\\f04d\";\n}\n\n.icofont-link:before {\n  content: \"\\f04e\";\n}\n\n.icofont-live-support:before {\n  content: \"\\f04f\";\n}\n\n.icofont-location-arrow:before {\n  content: \"\\f050\";\n}\n\n.icofont-location-pin:before {\n  content: \"\\f051\";\n}\n\n.icofont-lock:before {\n  content: \"\\f052\";\n}\n\n.icofont-login:before {\n  content: \"\\f053\";\n}\n\n.icofont-logout:before {\n  content: \"\\f054\";\n}\n\n.icofont-lollipop:before {\n  content: \"\\f055\";\n}\n\n.icofont-look:before {\n  content: \"\\f056\";\n}\n\n.icofont-loop:before {\n  content: \"\\f057\";\n}\n\n.icofont-luggage:before {\n  content: \"\\f058\";\n}\n\n.icofont-lunch:before {\n  content: \"\\f059\";\n}\n\n.icofont-lungs:before {\n  content: \"\\f05a\";\n}\n\n.icofont-magic-alt:before {\n  content: \"\\f05b\";\n}\n\n.icofont-magic:before {\n  content: \"\\f05c\";\n}\n\n.icofont-magnet:before {\n  content: \"\\f05d\";\n}\n\n.icofont-mail-box:before {\n  content: \"\\f05e\";\n}\n\n.icofont-mail:before {\n  content: \"\\f05f\";\n}\n\n.icofont-male:before {\n  content: \"\\f060\";\n}\n\n.icofont-map:before {\n  content: \"\\f061\";\n}\n\n.icofont-math:before {\n  content: \"\\f062\";\n}\n\n.icofont-maximize:before {\n  content: \"\\f063\";\n}\n\n.icofont-measure:before {\n  content: \"\\f064\";\n}\n\n.icofont-medal:before {\n  content: \"\\f065\";\n}\n\n.icofont-medical:before {\n  content: \"\\f066\";\n}\n\n.icofont-medicine:before {\n  content: \"\\f067\";\n}\n\n.icofont-mega-phone:before {\n  content: \"\\f068\";\n}\n\n.icofont-memorial:before {\n  content: \"\\f069\";\n}\n\n.icofont-memory-card:before {\n  content: \"\\f06a\";\n}\n\n.icofont-mic-mute:before {\n  content: \"\\f06b\";\n}\n\n.icofont-mic:before {\n  content: \"\\f06c\";\n}\n\n.icofont-micro-chip:before {\n  content: \"\\f06d\";\n}\n\n.icofont-microphone:before {\n  content: \"\\f06e\";\n}\n\n.icofont-microscope:before {\n  content: \"\\f06f\";\n}\n\n.icofont-military:before {\n  content: \"\\f070\";\n}\n\n.icofont-mill:before {\n  content: \"\\f071\";\n}\n\n.icofont-minus-circle:before {\n  content: \"\\f072\";\n}\n\n.icofont-minus-square:before {\n  content: \"\\f073\";\n}\n\n.icofont-minus:before {\n  content: \"\\f074\";\n}\n\n.icofont-mobile-phone:before {\n  content: \"\\f075\";\n}\n\n.icofont-molecule:before {\n  content: \"\\f076\";\n}\n\n.icofont-money:before {\n  content: \"\\f077\";\n}\n\n.icofont-moon:before {\n  content: \"\\f078\";\n}\n\n.icofont-mop:before {\n  content: \"\\f079\";\n}\n\n.icofont-muffin:before {\n  content: \"\\f07a\";\n}\n\n.icofont-music-alt:before {\n  content: \"\\f07b\";\n}\n\n.icofont-music-notes:before {\n  content: \"\\f07c\";\n}\n\n.icofont-music:before {\n  content: \"\\f07d\";\n}\n\n.icofont-mustache:before {\n  content: \"\\f07e\";\n}\n\n.icofont-mute-volume:before {\n  content: \"\\f07f\";\n}\n\n.icofont-navigation-menu:before {\n  content: \"\\f080\";\n}\n\n.icofont-navigation:before {\n  content: \"\\f081\";\n}\n\n.icofont-network-tower:before {\n  content: \"\\f082\";\n}\n\n.icofont-network:before {\n  content: \"\\f083\";\n}\n\n.icofont-news:before {\n  content: \"\\f084\";\n}\n\n.icofont-newspaper:before {\n  content: \"\\f085\";\n}\n\n.icofont-no-smoking:before {\n  content: \"\\f086\";\n}\n\n.icofont-not-allowed:before {\n  content: \"\\f087\";\n}\n\n.icofont-notebook:before {\n  content: \"\\f088\";\n}\n\n.icofont-notepad:before {\n  content: \"\\f089\";\n}\n\n.icofont-notification:before {\n  content: \"\\f08a\";\n}\n\n.icofont-numbered:before {\n  content: \"\\f08b\";\n}\n\n.icofont-opposite:before {\n  content: \"\\f08c\";\n}\n\n.icofont-optic:before {\n  content: \"\\f08d\";\n}\n\n.icofont-options:before {\n  content: \"\\f08e\";\n}\n\n.icofont-package:before {\n  content: \"\\f08f\";\n}\n\n.icofont-page:before {\n  content: \"\\f090\";\n}\n\n.icofont-paint:before {\n  content: \"\\f091\";\n}\n\n.icofont-paper-plane:before {\n  content: \"\\f092\";\n}\n\n.icofont-paperclip:before {\n  content: \"\\f093\";\n}\n\n.icofont-papers:before {\n  content: \"\\f094\";\n}\n\n.icofont-paw:before {\n  content: \"\\f095\";\n}\n\n.icofont-pay:before {\n  content: \"\\f096\";\n}\n\n.icofont-pen:before {\n  content: \"\\f097\";\n}\n\n.icofont-pencil:before {\n  content: \"\\f098\";\n}\n\n.icofont-penguin-linux:before {\n  content: \"\\f099\";\n}\n\n.icofont-pestle:before {\n  content: \"\\f09a\";\n}\n\n.icofont-phone-circle:before {\n  content: \"\\f09b\";\n}\n\n.icofont-phone:before {\n  content: \"\\f09c\";\n}\n\n.icofont-picture:before {\n  content: \"\\f09d\";\n}\n\n.icofont-pie:before {\n  content: \"\\f09e\";\n}\n\n.icofont-pine:before {\n  content: \"\\f09f\";\n}\n\n.icofont-pixels:before {\n  content: \"\\f0a0\";\n}\n\n.icofont-play:before {\n  content: \"\\f0a1\";\n}\n\n.icofont-plugin:before {\n  content: \"\\f0a2\";\n}\n\n.icofont-plus-circle:before {\n  content: \"\\f0a3\";\n}\n\n.icofont-plus-square:before {\n  content: \"\\f0a4\";\n}\n\n.icofont-plus:before {\n  content: \"\\f0a5\";\n}\n\n.icofont-polygonal:before {\n  content: \"\\f0a6\";\n}\n\n.icofont-power:before {\n  content: \"\\f0a7\";\n}\n\n.icofont-presentation:before {\n  content: \"\\f0a8\";\n}\n\n.icofont-price:before {\n  content: \"\\f0a9\";\n}\n\n.icofont-print:before {\n  content: \"\\f0aa\";\n}\n\n.icofont-puzzle:before {\n  content: \"\\f0ab\";\n}\n\n.icofont-qr-code:before {\n  content: \"\\f0ac\";\n}\n\n.icofont-queen:before {\n  content: \"\\f0ad\";\n}\n\n.icofont-question-circle:before {\n  content: \"\\f0ae\";\n}\n\n.icofont-question-square:before {\n  content: \"\\f0af\";\n}\n\n.icofont-question:before {\n  content: \"\\f0b0\";\n}\n\n.icofont-quote-left:before {\n  content: \"\\f0b1\";\n}\n\n.icofont-quote-right:before {\n  content: \"\\f0b2\";\n}\n\n.icofont-radio:before {\n  content: \"\\f0b3\";\n}\n\n.icofont-random:before {\n  content: \"\\f0b4\";\n}\n\n.icofont-recycle:before {\n  content: \"\\f0b5\";\n}\n\n.icofont-refresh:before {\n  content: \"\\f0b6\";\n}\n\n.icofont-repair:before {\n  content: \"\\f0b7\";\n}\n\n.icofont-reply-all:before {\n  content: \"\\f0b8\";\n}\n\n.icofont-reply:before {\n  content: \"\\f0b9\";\n}\n\n.icofont-resize:before {\n  content: \"\\f0ba\";\n}\n\n.icofont-responsive:before {\n  content: \"\\f0bb\";\n}\n\n.icofont-retweet:before {\n  content: \"\\f0bc\";\n}\n\n.icofont-road:before {\n  content: \"\\f0bd\";\n}\n\n.icofont-robot:before {\n  content: \"\\f0be\";\n}\n\n.icofont-rocket:before {\n  content: \"\\f0bf\";\n}\n\n.icofont-royal:before {\n  content: \"\\f0c0\";\n}\n\n.icofont-rss-feed:before {\n  content: \"\\f0c1\";\n}\n\n.icofont-safety:before {\n  content: \"\\f0c2\";\n}\n\n.icofont-sale-discount:before {\n  content: \"\\f0c3\";\n}\n\n.icofont-satellite:before {\n  content: \"\\f0c4\";\n}\n\n.icofont-send-mail:before {\n  content: \"\\f0c5\";\n}\n\n.icofont-server:before {\n  content: \"\\f0c6\";\n}\n\n.icofont-settings:before {\n  content: \"\\f0c7\";\n}\n\n.icofont-share-alt:before {\n  content: \"\\f0c8\";\n}\n\n.icofont-share-boxed:before {\n  content: \"\\f0c9\";\n}\n\n.icofont-share:before {\n  content: \"\\f0ca\";\n}\n\n.icofont-shield:before {\n  content: \"\\f0cb\";\n}\n\n.icofont-ship:before {\n  content: \"\\f0cc\";\n}\n\n.icofont-shopping-cart:before {\n  content: \"\\f0cd\";\n}\n\n.icofont-sign-in:before {\n  content: \"\\f0ce\";\n}\n\n.icofont-sign-out:before {\n  content: \"\\f0cf\";\n}\n\n.icofont-signal:before {\n  content: \"\\f0d0\";\n}\n\n.icofont-site-map:before {\n  content: \"\\f0d1\";\n}\n\n.icofont-smart-phone:before {\n  content: \"\\f0d2\";\n}\n\n.icofont-soccer:before {\n  content: \"\\f0d3\";\n}\n\n.icofont-sort-alt:before {\n  content: \"\\f0d4\";\n}\n\n.icofont-sort:before {\n  content: \"\\f0d5\";\n}\n\n.icofont-space:before {\n  content: \"\\f0d6\";\n}\n\n.icofont-spanner:before {\n  content: \"\\f0d7\";\n}\n\n.icofont-speech-comments:before {\n  content: \"\\f0d8\";\n}\n\n.icofont-speed-meter:before {\n  content: \"\\f0d9\";\n}\n\n.icofont-spinner-alt-1:before {\n  content: \"\\f0da\";\n}\n\n.icofont-spinner-alt-2:before {\n  content: \"\\f0db\";\n}\n\n.icofont-spinner-alt-3:before {\n  content: \"\\f0dc\";\n}\n\n.icofont-spinner-alt-4:before {\n  content: \"\\f0dd\";\n}\n\n.icofont-spinner-alt-5:before {\n  content: \"\\f0de\";\n}\n\n.icofont-spinner-alt-6:before {\n  content: \"\\f0df\";\n}\n\n.icofont-spinner:before {\n  content: \"\\f0e0\";\n}\n\n.icofont-spreadsheet:before {\n  content: \"\\f0e1\";\n}\n\n.icofont-square:before {\n  content: \"\\f0e2\";\n}\n\n.icofont-ssl-security:before {\n  content: \"\\f0e3\";\n}\n\n.icofont-star-alt-1:before {\n  content: \"\\f0e4\";\n}\n\n.icofont-star-alt-2:before {\n  content: \"\\f0e5\";\n}\n\n.icofont-star:before {\n  content: \"\\f0e6\";\n}\n\n.icofont-street-view:before {\n  content: \"\\f0e7\";\n}\n\n.icofont-sun:before {\n  content: \"\\f0e8\";\n}\n\n.icofont-support-faq:before {\n  content: \"\\f0e9\";\n}\n\n.icofont-tack-pin:before {\n  content: \"\\f0ea\";\n}\n\n.icofont-tag:before {\n  content: \"\\f0eb\";\n}\n\n.icofont-tags:before {\n  content: \"\\f0ec\";\n}\n\n.icofont-tasks:before {\n  content: \"\\f0ed\";\n}\n\n.icofont-telephone:before {\n  content: \"\\f0ee\";\n}\n\n.icofont-telescope:before {\n  content: \"\\f0ef\";\n}\n\n.icofont-terminal:before {\n  content: \"\\f0f0\";\n}\n\n.icofont-thumbs-down:before {\n  content: \"\\f0f1\";\n}\n\n.icofont-thumbs-up:before {\n  content: \"\\f0f2\";\n}\n\n.icofont-tick-boxed:before {\n  content: \"\\f0f3\";\n}\n\n.icofont-tick-mark:before {\n  content: \"\\f0f4\";\n}\n\n.icofont-ticket:before {\n  content: \"\\f0f5\";\n}\n\n.icofont-tie:before {\n  content: \"\\f0f6\";\n}\n\n.icofont-toggle-off:before {\n  content: \"\\f0f7\";\n}\n\n.icofont-toggle-on:before {\n  content: \"\\f0f8\";\n}\n\n.icofont-tools:before {\n  content: \"\\f0f9\";\n}\n\n.icofont-transparent:before {\n  content: \"\\f0fa\";\n}\n\n.icofont-tree:before {\n  content: \"\\f0fb\";\n}\n\n.icofont-umbrella:before {\n  content: \"\\f0fc\";\n}\n\n.icofont-unlock:before {\n  content: \"\\f0fd\";\n}\n\n.icofont-unlocked:before {\n  content: \"\\f0fe\";\n}\n\n.icofont-upload-alt:before {\n  content: \"\\f0ff\";\n}\n\n.icofont-upload:before {\n  content: \"\\f100\";\n}\n\n.icofont-usb-drive:before {\n  content: \"\\f101\";\n}\n\n.icofont-usb:before {\n  content: \"\\f102\";\n}\n\n.icofont-vector-path:before {\n  content: \"\\f103\";\n}\n\n.icofont-verification-check:before {\n  content: \"\\f104\";\n}\n\n.icofont-video-clapper:before {\n  content: \"\\f105\";\n}\n\n.icofont-video:before {\n  content: \"\\f106\";\n}\n\n.icofont-volume-down:before {\n  content: \"\\f107\";\n}\n\n.icofont-volume-off:before {\n  content: \"\\f108\";\n}\n\n.icofont-volume-up:before {\n  content: \"\\f109\";\n}\n\n.icofont-wall-clock:before {\n  content: \"\\f10a\";\n}\n\n.icofont-wall:before {\n  content: \"\\f10b\";\n}\n\n.icofont-wallet:before {\n  content: \"\\f10c\";\n}\n\n.icofont-warning-alt:before {\n  content: \"\\f10d\";\n}\n\n.icofont-warning:before {\n  content: \"\\f10e\";\n}\n\n.icofont-water-drop:before {\n  content: \"\\f10f\";\n}\n\n.icofont-web:before {\n  content: \"\\f110\";\n}\n\n.icofont-wheelchair:before {\n  content: \"\\f111\";\n}\n\n.icofont-wifi-alt:before {\n  content: \"\\f112\";\n}\n\n.icofont-wifi:before {\n  content: \"\\f113\";\n}\n\n.icofont-world:before {\n  content: \"\\f114\";\n}\n\n.icofont-zigzag:before {\n  content: \"\\f115\";\n}\n\n.icofont-zipped:before {\n  content: \"\\f116\";\n}\n\n.icofont-social-500px:before {\n  content: \"\\f117\";\n}\n\n.icofont-social-baidu-tieba:before {\n  content: \"\\f118\";\n}\n\n.icofont-social-bbm-messenger:before {\n  content: \"\\f119\";\n}\n\n.icofont-social-delicious:before {\n  content: \"\\f11a\";\n}\n\n.icofont-social-dribbble:before {\n  content: \"\\f11b\";\n}\n\n.icofont-social-facebook-messenger:before {\n  content: \"\\f11c\";\n}\n\n.icofont-social-flikr:before {\n  content: \"\\f11d\";\n}\n\n.icofont-social-foursquare:before {\n  content: \"\\f11e\";\n}\n\n.icofont-social-google-hangouts:before {\n  content: \"\\f11f\";\n}\n\n.icofont-social-kakaotalk:before {\n  content: \"\\f120\";\n}\n\n.icofont-social-kik:before {\n  content: \"\\f121\";\n}\n\n.icofont-social-kiwibox:before {\n  content: \"\\f122\";\n}\n\n.icofont-social-linkedin:before {\n  content: \"\\f123\";\n}\n\n.icofont-social-meetme:before {\n  content: \"\\f124\";\n}\n\n.icofont-social-odnoklassniki:before {\n  content: \"\\f125\";\n}\n\n.icofont-social-photobucket:before {\n  content: \"\\f126\";\n}\n\n.icofont-social-qq:before {\n  content: \"\\f127\";\n}\n\n.icofont-social-renren:before {\n  content: \"\\f128\";\n}\n\n.icofont-social-slack:before {\n  content: \"\\f129\";\n}\n\n.icofont-social-slidshare:before {\n  content: \"\\f12a\";\n}\n\n.icofont-social-snapchat:before {\n  content: \"\\f12b\";\n}\n\n.icofont-social-soundcloud:before {\n  content: \"\\f12c\";\n}\n\n.icofont-social-spotify:before {\n  content: \"\\f12d\";\n}\n\n.icofont-social-stack-exchange:before {\n  content: \"\\f12e\";\n}\n\n.icofont-social-stack-overflow:before {\n  content: \"\\f12f\";\n}\n\n.icofont-social-tagged:before {\n  content: \"\\f130\";\n}\n\n.icofont-social-trello:before {\n  content: \"\\f131\";\n}\n\n.icofont-social-twitch:before {\n  content: \"\\f132\";\n}\n\n.icofont-social-vk:before {\n  content: \"\\f133\";\n}\n\n.icofont-social-weibo:before {\n  content: \"\\f134\";\n}\n\n.icofont-social-whatsapp:before {\n  content: \"\\f135\";\n}\n\n.icofont-social-youku:before {\n  content: \"\\f136\";\n}\n\n.icofont-social-youtube-play:before {\n  content: \"\\f137\";\n}\n\n.icofont-social-youtube:before {\n  content: \"\\f138\";\n}\n\n.icofont-brand-xiaomi:before {\n  content: \"\\f139\";\n}\n\n/*Font size*/\n.icofont-lg {\n  font-size: 1.33333333em;\n  line-height: 0.75em;\n  vertical-align: -15%;\n}\n\n.icofont-2x {\n  font-size: 2em;\n}\n\n.icofont-3x {\n  font-size: 3em;\n}\n\n.icofont-4x {\n  font-size: 4em;\n}\n\n.icofont-5x {\n  font-size: 5em;\n}\n\n.icofont-fw {\n  display: inline-block;\n  width: 1.28571429em;\n  text-align: center;\n  width: 1.28571429em;\n  text-align: center;\n}\n\n/*Fixed Width Icons*/\n/*Custom list icons*/\n.icofont-ul {\n  padding-left: 0;\n  margin-left: 2.14285714em;\n  list-style-type: none;\n}\n.icofont-ul > li {\n  position: relative;\n}\n\n.icofont-li {\n  position: absolute;\n  left: -2.14285714em;\n  width: 2.14285714em;\n  top: 0.14285714em;\n  text-align: center;\n}\n\n/*Animation*/\n.icofont-rotate {\n  display: inline-block;\n  -webkit-animation: icofont-rotate 2s infinite linear;\n  animation: icofont-rotate 2s infinite linear;\n}\n\n@-webkit-keyframes icofont-rotate {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n@keyframes icofont-rotate {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n.flag-icon-background, .flag-icon {\n  background-size: contain;\n  background-position: 50%;\n  background-repeat: no-repeat;\n}\n\n.flag-icon {\n  position: relative;\n  display: inline-block;\n  width: 1.3333333333em;\n  line-height: 1em;\n}\n.flag-icon:before {\n  content: \" \";\n}\n.flag-icon.flag-icon-squared {\n  width: 1em;\n}\n\n.flag-icon-es-ct {\n  background-image: url(../../../fonts/flag-icon/es-ct.svg);\n}\n.flag-icon-es-ct.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/es-ct.svg);\n}\n\n.flag-icon-eu {\n  background-image: url(../../../fonts/flag-icon/eu.svg);\n}\n.flag-icon-eu.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/eu.svg);\n}\n\n.flag-icon-gb-eng {\n  background-image: url(../../../fonts/flag-icon/gb-eng.svg);\n}\n.flag-icon-gb-eng.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/gb-eng.svg);\n}\n\n.flag-icon-gb-nir {\n  background-image: url(../../../fonts/flag-icon/gb-nir.svg);\n}\n.flag-icon-gb-nir.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/gb-nir.svg);\n}\n\n.flag-icon-gb-sct {\n  background-image: url(../../../fonts/flag-icon/gb-sct.svg);\n}\n.flag-icon-gb-sct.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/gb-sct.svg);\n}\n\n.flag-icon-gb-wls {\n  background-image: url(../../../fonts/flag-icon/gb-wls.svg);\n}\n.flag-icon-gb-wls.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/gb-wls.svg);\n}\n\n.flag-icon-un {\n  background-image: url(../../../fonts/flag-icon/un.svg);\n}\n.flag-icon-un.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/un.svg);\n}\n\n.flag-icon-ad {\n  background-image: url(../../../fonts/flag-icon/ad.svg);\n}\n.flag-icon-ad.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ad.svg);\n}\n\n.flag-icon-ae {\n  background-image: url(../../../fonts/flag-icon/ae.svg);\n}\n.flag-icon-ae.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ae.svg);\n}\n\n.flag-icon-af {\n  background-image: url(../../../fonts/flag-icon/af.svg);\n}\n.flag-icon-af.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/af.svg);\n}\n\n.flag-icon-ag {\n  background-image: url(../../../fonts/flag-icon/ag.svg);\n}\n.flag-icon-ag.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ag.svg);\n}\n\n.flag-icon-ai {\n  background-image: url(../../../fonts/flag-icon/ai.svg);\n}\n.flag-icon-ai.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ai.svg);\n}\n\n.flag-icon-al {\n  background-image: url(../../../fonts/flag-icon/al.svg);\n}\n.flag-icon-al.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/al.svg);\n}\n\n.flag-icon-am {\n  background-image: url(../../../fonts/flag-icon/am.svg);\n}\n.flag-icon-am.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/am.svg);\n}\n\n.flag-icon-ao {\n  background-image: url(../../../fonts/flag-icon/ao.svg);\n}\n.flag-icon-ao.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ao.svg);\n}\n\n.flag-icon-aq {\n  background-image: url(../../../fonts/flag-icon/aq.svg);\n}\n.flag-icon-aq.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/aq.svg);\n}\n\n.flag-icon-ar {\n  background-image: url(../../../fonts/flag-icon/ar.svg);\n}\n.flag-icon-ar.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ar.svg);\n}\n\n.flag-icon-as {\n  background-image: url(../../../fonts/flag-icon/as.svg);\n}\n.flag-icon-as.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/as.svg);\n}\n\n.flag-icon-at {\n  background-image: url(../../../fonts/flag-icon/at.svg);\n}\n.flag-icon-at.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/at.svg);\n}\n\n.flag-icon-au {\n  background-image: url(../../../fonts/flag-icon/au.svg);\n}\n.flag-icon-au.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/au.svg);\n}\n\n.flag-icon-aw {\n  background-image: url(../../../fonts/flag-icon/aw.svg);\n}\n.flag-icon-aw.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/aw.svg);\n}\n\n.flag-icon-ax {\n  background-image: url(../../../fonts/flag-icon/ax.svg);\n}\n.flag-icon-ax.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ax.svg);\n}\n\n.flag-icon-az {\n  background-image: url(../../../fonts/flag-icon/az.svg);\n}\n.flag-icon-az.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/az.svg);\n}\n\n.flag-icon-ba {\n  background-image: url(../../../fonts/flag-icon/ba.svg);\n}\n.flag-icon-ba.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ba.svg);\n}\n\n.flag-icon-bb {\n  background-image: url(../../../fonts/flag-icon/bb.svg);\n}\n.flag-icon-bb.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/bb.svg);\n}\n\n.flag-icon-bd {\n  background-image: url(../../../fonts/flag-icon/bd.svg);\n}\n.flag-icon-bd.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/bd.svg);\n}\n\n.flag-icon-be {\n  background-image: url(../../../fonts/flag-icon/be.svg);\n}\n.flag-icon-be.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/be.svg);\n}\n\n.flag-icon-bf {\n  background-image: url(../../../fonts/flag-icon/bf.svg);\n}\n.flag-icon-bf.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/bf.svg);\n}\n\n.flag-icon-bg {\n  background-image: url(../../../fonts/flag-icon/bg.svg);\n}\n.flag-icon-bg.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/bg.svg);\n}\n\n.flag-icon-bh {\n  background-image: url(../../../fonts/flag-icon/bh.svg);\n}\n.flag-icon-bh.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/bh.svg);\n}\n\n.flag-icon-bi {\n  background-image: url(../../../fonts/flag-icon/bi.svg);\n}\n.flag-icon-bi.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/bi.svg);\n}\n\n.flag-icon-bj {\n  background-image: url(../../../fonts/flag-icon/bj.svg);\n}\n.flag-icon-bj.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/bj.svg);\n}\n\n.flag-icon-bl {\n  background-image: url(../../../fonts/flag-icon/bl.svg);\n}\n.flag-icon-bl.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/bl.svg);\n}\n\n.flag-icon-bm {\n  background-image: url(../../../fonts/flag-icon/bm.svg);\n}\n.flag-icon-bm.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/bm.svg);\n}\n\n.flag-icon-bn {\n  background-image: url(../../../fonts/flag-icon/bn.svg);\n}\n.flag-icon-bn.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/bn.svg);\n}\n\n.flag-icon-bo {\n  background-image: url(../../../fonts/flag-icon/bo.svg);\n}\n.flag-icon-bo.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/bo.svg);\n}\n\n.flag-icon-bq {\n  background-image: url(../../../fonts/flag-icon/bq.svg);\n}\n.flag-icon-bq.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/bq.svg);\n}\n\n.flag-icon-br {\n  background-image: url(../../../fonts/flag-icon/br.svg);\n}\n.flag-icon-br.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/br.svg);\n}\n\n.flag-icon-bs {\n  background-image: url(../../../fonts/flag-icon/bs.svg);\n}\n.flag-icon-bs.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/bs.svg);\n}\n\n.flag-icon-bt {\n  background-image: url(../../../fonts/flag-icon/bt.svg);\n}\n.flag-icon-bt.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/bt.svg);\n}\n\n.flag-icon-bv {\n  background-image: url(../../../fonts/flag-icon/bv.svg);\n}\n.flag-icon-bv.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/bv.svg);\n}\n\n.flag-icon-bw {\n  background-image: url(../../../fonts/flag-icon/bw.svg);\n}\n.flag-icon-bw.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/bw.svg);\n}\n\n.flag-icon-by {\n  background-image: url(../../../fonts/flag-icon/by.svg);\n}\n.flag-icon-by.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/by.svg);\n}\n\n.flag-icon-bz {\n  background-image: url(../../../fonts/flag-icon/bz.svg);\n}\n.flag-icon-bz.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/bz.svg);\n}\n\n.flag-icon-ca {\n  background-image: url(../../../fonts/flag-icon/ca.svg);\n}\n.flag-icon-ca.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ca.svg);\n}\n\n.flag-icon-cc {\n  background-image: url(../../../fonts/flag-icon/cc.svg);\n}\n.flag-icon-cc.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/cc.svg);\n}\n\n.flag-icon-cd {\n  background-image: url(../../../fonts/flag-icon/cd.svg);\n}\n.flag-icon-cd.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/cd.svg);\n}\n\n.flag-icon-cf {\n  background-image: url(../../../fonts/flag-icon/cf.svg);\n}\n.flag-icon-cf.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/cf.svg);\n}\n\n.flag-icon-cg {\n  background-image: url(../../../fonts/flag-icon/cg.svg);\n}\n.flag-icon-cg.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/cg.svg);\n}\n\n.flag-icon-ch {\n  background-image: url(../../../fonts/flag-icon/ch.svg);\n}\n.flag-icon-ch.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ch.svg);\n}\n\n.flag-icon-ci {\n  background-image: url(../../../fonts/flag-icon/ci.svg);\n}\n.flag-icon-ci.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ci.svg);\n}\n\n.flag-icon-ck {\n  background-image: url(../../../fonts/flag-icon/ck.svg);\n}\n.flag-icon-ck.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ck.svg);\n}\n\n.flag-icon-cl {\n  background-image: url(../../../fonts/flag-icon/cl.svg);\n}\n.flag-icon-cl.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/cl.svg);\n}\n\n.flag-icon-cm {\n  background-image: url(../../../fonts/flag-icon/cm.svg);\n}\n.flag-icon-cm.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/cm.svg);\n}\n\n.flag-icon-cn {\n  background-image: url(../../../fonts/flag-icon/cn.svg);\n}\n.flag-icon-cn.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/cn.svg);\n}\n\n.flag-icon-co {\n  background-image: url(../../../fonts/flag-icon/co.svg);\n}\n.flag-icon-co.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/co.svg);\n}\n\n.flag-icon-cr {\n  background-image: url(../../../fonts/flag-icon/cr.svg);\n}\n.flag-icon-cr.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/cr.svg);\n}\n\n.flag-icon-cu {\n  background-image: url(../../../fonts/flag-icon/cu.svg);\n}\n.flag-icon-cu.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/cu.svg);\n}\n\n.flag-icon-cv {\n  background-image: url(../../../fonts/flag-icon/cv.svg);\n}\n.flag-icon-cv.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/cv.svg);\n}\n\n.flag-icon-cw {\n  background-image: url(../../../fonts/flag-icon/cw.svg);\n}\n.flag-icon-cw.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/cw.svg);\n}\n\n.flag-icon-cx {\n  background-image: url(../../../fonts/flag-icon/cx.svg);\n}\n.flag-icon-cx.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/cx.svg);\n}\n\n.flag-icon-cy {\n  background-image: url(../../../fonts/flag-icon/cy.svg);\n}\n.flag-icon-cy.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/cy.svg);\n}\n\n.flag-icon-cz {\n  background-image: url(../../../fonts/flag-icon/cz.svg);\n}\n.flag-icon-cz.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/cz.svg);\n}\n\n.flag-icon-de {\n  background-image: url(../../../fonts/flag-icon/de.svg);\n}\n.flag-icon-de.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/de.svg);\n}\n\n.flag-icon-dj {\n  background-image: url(../../../fonts/flag-icon/dj.svg);\n}\n.flag-icon-dj.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/dj.svg);\n}\n\n.flag-icon-dk {\n  background-image: url(../../../fonts/flag-icon/dk.svg);\n}\n.flag-icon-dk.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/dk.svg);\n}\n\n.flag-icon-dm {\n  background-image: url(../../../fonts/flag-icon/dm.svg);\n}\n.flag-icon-dm.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/dm.svg);\n}\n\n.flag-icon-do {\n  background-image: url(../../../fonts/flag-icon/do.svg);\n}\n.flag-icon-do.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/do.svg);\n}\n\n.flag-icon-dz {\n  background-image: url(../../../fonts/flag-icon/dz.svg);\n}\n.flag-icon-dz.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/dz.svg);\n}\n\n.flag-icon-ec {\n  background-image: url(../../../fonts/flag-icon/ec.svg);\n}\n.flag-icon-ec.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ec.svg);\n}\n\n.flag-icon-ee {\n  background-image: url(../../../fonts/flag-icon/ee.svg);\n}\n.flag-icon-ee.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ee.svg);\n}\n\n.flag-icon-eg {\n  background-image: url(../../../fonts/flag-icon/eg.svg);\n}\n.flag-icon-eg.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/eg.svg);\n}\n\n.flag-icon-eh {\n  background-image: url(../../../fonts/flag-icon/eh.svg);\n}\n.flag-icon-eh.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/eh.svg);\n}\n\n.flag-icon-er {\n  background-image: url(../../../fonts/flag-icon/er.svg);\n}\n.flag-icon-er.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/er.svg);\n}\n\n.flag-icon-es {\n  background-image: url(../../../fonts/flag-icon/es.svg);\n}\n.flag-icon-es.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/es.svg);\n}\n\n.flag-icon-et {\n  background-image: url(../../../fonts/flag-icon/et.svg);\n}\n.flag-icon-et.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/et.svg);\n}\n\n.flag-icon-fi {\n  background-image: url(../../../fonts/flag-icon/fi.svg);\n}\n.flag-icon-fi.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/fi.svg);\n}\n\n.flag-icon-fj {\n  background-image: url(../../../fonts/flag-icon/fj.svg);\n}\n.flag-icon-fj.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/fj.svg);\n}\n\n.flag-icon-fk {\n  background-image: url(../../../fonts/flag-icon/fk.svg);\n}\n.flag-icon-fk.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/fk.svg);\n}\n\n.flag-icon-fm {\n  background-image: url(../../../fonts/flag-icon/fm.svg);\n}\n.flag-icon-fm.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/fm.svg);\n}\n\n.flag-icon-fo {\n  background-image: url(../../../fonts/flag-icon/fo.svg);\n}\n.flag-icon-fo.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/fo.svg);\n}\n\n.flag-icon-fr {\n  background-image: url(../../../fonts/flag-icon/fr.svg);\n}\n.flag-icon-fr.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/fr.svg);\n}\n\n.flag-icon-ga {\n  background-image: url(../../../fonts/flag-icon/ga.svg);\n}\n.flag-icon-ga.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ga.svg);\n}\n\n.flag-icon-gb {\n  background-image: url(../../../fonts/flag-icon/gb.svg);\n}\n.flag-icon-gb.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/gb.svg);\n}\n\n.flag-icon-gd {\n  background-image: url(../../../fonts/flag-icon/gd.svg);\n}\n.flag-icon-gd.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/gd.svg);\n}\n\n.flag-icon-ge {\n  background-image: url(../../../fonts/flag-icon/ge.svg);\n}\n.flag-icon-ge.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ge.svg);\n}\n\n.flag-icon-gf {\n  background-image: url(../../../fonts/flag-icon/gf.svg);\n}\n.flag-icon-gf.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/gf.svg);\n}\n\n.flag-icon-gg {\n  background-image: url(../../../fonts/flag-icon/gg.svg);\n}\n.flag-icon-gg.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/gg.svg);\n}\n\n.flag-icon-gh {\n  background-image: url(../../../fonts/flag-icon/gh.svg);\n}\n.flag-icon-gh.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/gh.svg);\n}\n\n.flag-icon-gi {\n  background-image: url(../../../fonts/flag-icon/gi.svg);\n}\n.flag-icon-gi.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/gi.svg);\n}\n\n.flag-icon-gl {\n  background-image: url(../../../fonts/flag-icon/gl.svg);\n}\n.flag-icon-gl.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/gl.svg);\n}\n\n.flag-icon-gm {\n  background-image: url(../../../fonts/flag-icon/gm.svg);\n}\n.flag-icon-gm.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/gm.svg);\n}\n\n.flag-icon-gn {\n  background-image: url(../../../fonts/flag-icon/gn.svg);\n}\n.flag-icon-gn.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/gn.svg);\n}\n\n.flag-icon-gp {\n  background-image: url(../../../fonts/flag-icon/gp.svg);\n}\n.flag-icon-gp.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/gp.svg);\n}\n\n.flag-icon-gq {\n  background-image: url(../../../fonts/flag-icon/gq.svg);\n}\n.flag-icon-gq.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/gq.svg);\n}\n\n.flag-icon-gr {\n  background-image: url(../../../fonts/flag-icon/gr.svg);\n}\n.flag-icon-gr.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/gr.svg);\n}\n\n.flag-icon-gs {\n  background-image: url(../../../fonts/flag-icon/gs.svg);\n}\n.flag-icon-gs.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/gs.svg);\n}\n\n.flag-icon-gt {\n  background-image: url(../../../fonts/flag-icon/gt.svg);\n}\n.flag-icon-gt.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/gt.svg);\n}\n\n.flag-icon-gu {\n  background-image: url(../../../fonts/flag-icon/gu.svg);\n}\n.flag-icon-gu.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/gu.svg);\n}\n\n.flag-icon-gw {\n  background-image: url(../../../fonts/flag-icon/gw.svg);\n}\n.flag-icon-gw.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/gw.svg);\n}\n\n.flag-icon-gy {\n  background-image: url(../../../fonts/flag-icon/gy.svg);\n}\n.flag-icon-gy.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/gy.svg);\n}\n\n.flag-icon-hk {\n  background-image: url(../../../fonts/flag-icon/hk.svg);\n}\n.flag-icon-hk.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/hk.svg);\n}\n\n.flag-icon-hm {\n  background-image: url(../../../fonts/flag-icon/hm.svg);\n}\n.flag-icon-hm.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/hm.svg);\n}\n\n.flag-icon-hn {\n  background-image: url(../../../fonts/flag-icon/hn.svg);\n}\n.flag-icon-hn.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/hn.svg);\n}\n\n.flag-icon-hr {\n  background-image: url(../../../fonts/flag-icon/hr.svg);\n}\n.flag-icon-hr.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/hr.svg);\n}\n\n.flag-icon-ht {\n  background-image: url(../../../fonts/flag-icon/ht.svg);\n}\n.flag-icon-ht.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ht.svg);\n}\n\n.flag-icon-hu {\n  background-image: url(../../../fonts/flag-icon/hu.svg);\n}\n.flag-icon-hu.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/hu.svg);\n}\n\n.flag-icon-id {\n  background-image: url(../../../fonts/flag-icon/id.svg);\n}\n.flag-icon-id.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/id.svg);\n}\n\n.flag-icon-ie {\n  background-image: url(../../../fonts/flag-icon/ie.svg);\n}\n.flag-icon-ie.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ie.svg);\n}\n\n.flag-icon-il {\n  background-image: url(../../../fonts/flag-icon/il.svg);\n}\n.flag-icon-il.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/il.svg);\n}\n\n.flag-icon-im {\n  background-image: url(../../../fonts/flag-icon/im.svg);\n}\n.flag-icon-im.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/im.svg);\n}\n\n.flag-icon-in {\n  background-image: url(../../../fonts/flag-icon/in.svg);\n}\n.flag-icon-in.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/in.svg);\n}\n\n.flag-icon-io {\n  background-image: url(../../../fonts/flag-icon/io.svg);\n}\n.flag-icon-io.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/io.svg);\n}\n\n.flag-icon-iq {\n  background-image: url(../../../fonts/flag-icon/iq.svg);\n}\n.flag-icon-iq.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/iq.svg);\n}\n\n.flag-icon-ir {\n  background-image: url(../../../fonts/flag-icon/ir.svg);\n}\n.flag-icon-ir.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ir.svg);\n}\n\n.flag-icon-is {\n  background-image: url(../../../fonts/flag-icon/is.svg);\n}\n.flag-icon-is.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/is.svg);\n}\n\n.flag-icon-it {\n  background-image: url(../../../fonts/flag-icon/it.svg);\n}\n.flag-icon-it.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/it.svg);\n}\n\n.flag-icon-je {\n  background-image: url(../../../fonts/flag-icon/je.svg);\n}\n.flag-icon-je.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/je.svg);\n}\n\n.flag-icon-jm {\n  background-image: url(../../../fonts/flag-icon/jm.svg);\n}\n.flag-icon-jm.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/jm.svg);\n}\n\n.flag-icon-jo {\n  background-image: url(../../../fonts/flag-icon/jo.svg);\n}\n.flag-icon-jo.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/jo.svg);\n}\n\n.flag-icon-jp {\n  background-image: url(../../../fonts/flag-icon/jp.svg);\n}\n.flag-icon-jp.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/jp.svg);\n}\n\n.flag-icon-ke {\n  background-image: url(../../../fonts/flag-icon/ke.svg);\n}\n.flag-icon-ke.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ke.svg);\n}\n\n.flag-icon-kg {\n  background-image: url(../../../fonts/flag-icon/kg.svg);\n}\n.flag-icon-kg.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/kg.svg);\n}\n\n.flag-icon-kh {\n  background-image: url(../../../fonts/flag-icon/kh.svg);\n}\n.flag-icon-kh.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/kh.svg);\n}\n\n.flag-icon-ki {\n  background-image: url(../../../fonts/flag-icon/ki.svg);\n}\n.flag-icon-ki.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ki.svg);\n}\n\n.flag-icon-km {\n  background-image: url(../../../fonts/flag-icon/km.svg);\n}\n.flag-icon-km.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/km.svg);\n}\n\n.flag-icon-kn {\n  background-image: url(../../../fonts/flag-icon/kn.svg);\n}\n.flag-icon-kn.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/kn.svg);\n}\n\n.flag-icon-kp {\n  background-image: url(../../../fonts/flag-icon/kp.svg);\n}\n.flag-icon-kp.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/kp.svg);\n}\n\n.flag-icon-kr {\n  background-image: url(../../../fonts/flag-icon/kr.svg);\n}\n.flag-icon-kr.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/kr.svg);\n}\n\n.flag-icon-kw {\n  background-image: url(../../../fonts/flag-icon/kw.svg);\n}\n.flag-icon-kw.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/kw.svg);\n}\n\n.flag-icon-ky {\n  background-image: url(../../../fonts/flag-icon/ky.svg);\n}\n.flag-icon-ky.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ky.svg);\n}\n\n.flag-icon-kz {\n  background-image: url(../../../fonts/flag-icon/kz.svg);\n}\n.flag-icon-kz.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/kz.svg);\n}\n\n.flag-icon-la {\n  background-image: url(../../../fonts/flag-icon/la.svg);\n}\n.flag-icon-la.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/la.svg);\n}\n\n.flag-icon-lb {\n  background-image: url(../../../fonts/flag-icon/lb.svg);\n}\n.flag-icon-lb.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/lb.svg);\n}\n\n.flag-icon-lc {\n  background-image: url(../../../fonts/flag-icon/lc.svg);\n}\n.flag-icon-lc.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/lc.svg);\n}\n\n.flag-icon-li {\n  background-image: url(../../../fonts/flag-icon/li.svg);\n}\n.flag-icon-li.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/li.svg);\n}\n\n.flag-icon-lk {\n  background-image: url(../../../fonts/flag-icon/lk.svg);\n}\n.flag-icon-lk.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/lk.svg);\n}\n\n.flag-icon-lr {\n  background-image: url(../../../fonts/flag-icon/lr.svg);\n}\n.flag-icon-lr.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/lr.svg);\n}\n\n.flag-icon-ls {\n  background-image: url(../../../fonts/flag-icon/ls.svg);\n}\n.flag-icon-ls.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ls.svg);\n}\n\n.flag-icon-lt {\n  background-image: url(../../../fonts/flag-icon/lt.svg);\n}\n.flag-icon-lt.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/lt.svg);\n}\n\n.flag-icon-lu {\n  background-image: url(../../../fonts/flag-icon/lu.svg);\n}\n.flag-icon-lu.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/lu.svg);\n}\n\n.flag-icon-lv {\n  background-image: url(../../../fonts/flag-icon/lv.svg);\n}\n.flag-icon-lv.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/lv.svg);\n}\n\n.flag-icon-ly {\n  background-image: url(../../../fonts/flag-icon/ly.svg);\n}\n.flag-icon-ly.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ly.svg);\n}\n\n.flag-icon-ma {\n  background-image: url(../../../fonts/flag-icon/ma.svg);\n}\n.flag-icon-ma.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ma.svg);\n}\n\n.flag-icon-mc {\n  background-image: url(../../../fonts/flag-icon/mc.svg);\n}\n.flag-icon-mc.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/mc.svg);\n}\n\n.flag-icon-md {\n  background-image: url(../../../fonts/flag-icon/md.svg);\n}\n.flag-icon-md.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/md.svg);\n}\n\n.flag-icon-me {\n  background-image: url(../../../fonts/flag-icon/me.svg);\n}\n.flag-icon-me.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/me.svg);\n}\n\n.flag-icon-mf {\n  background-image: url(../../../fonts/flag-icon/mf.svg);\n}\n.flag-icon-mf.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/mf.svg);\n}\n\n.flag-icon-mg {\n  background-image: url(../../../fonts/flag-icon/mg.svg);\n}\n.flag-icon-mg.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/mg.svg);\n}\n\n.flag-icon-mh {\n  background-image: url(../../../fonts/flag-icon/mh.svg);\n}\n.flag-icon-mh.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/mh.svg);\n}\n\n.flag-icon-mk {\n  background-image: url(../../../fonts/flag-icon/mk.svg);\n}\n.flag-icon-mk.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/mk.svg);\n}\n\n.flag-icon-ml {\n  background-image: url(../../../fonts/flag-icon/ml.svg);\n}\n.flag-icon-ml.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ml.svg);\n}\n\n.flag-icon-mm {\n  background-image: url(../../../fonts/flag-icon/mm.svg);\n}\n.flag-icon-mm.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/mm.svg);\n}\n\n.flag-icon-mn {\n  background-image: url(../../../fonts/flag-icon/mn.svg);\n}\n.flag-icon-mn.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/mn.svg);\n}\n\n.flag-icon-mo {\n  background-image: url(../../../fonts/flag-icon/mo.svg);\n}\n.flag-icon-mo.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/mo.svg);\n}\n\n.flag-icon-mp {\n  background-image: url(../../../fonts/flag-icon/mp.svg);\n}\n.flag-icon-mp.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/mp.svg);\n}\n\n.flag-icon-mq {\n  background-image: url(../../../fonts/flag-icon/mq.svg);\n}\n.flag-icon-mq.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/mq.svg);\n}\n\n.flag-icon-mr {\n  background-image: url(../../../fonts/flag-icon/mr.svg);\n}\n.flag-icon-mr.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/mr.svg);\n}\n\n.flag-icon-ms {\n  background-image: url(../../../fonts/flag-icon/ms.svg);\n}\n.flag-icon-ms.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ms.svg);\n}\n\n.flag-icon-mt {\n  background-image: url(../../../fonts/flag-icon/mt.svg);\n}\n.flag-icon-mt.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/mt.svg);\n}\n\n.flag-icon-mu {\n  background-image: url(../../../fonts/flag-icon/mu.svg);\n}\n.flag-icon-mu.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/mu.svg);\n}\n\n.flag-icon-mv {\n  background-image: url(../../../fonts/flag-icon/mv.svg);\n}\n.flag-icon-mv.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/mv.svg);\n}\n\n.flag-icon-mw {\n  background-image: url(../../../fonts/flag-icon/mw.svg);\n}\n.flag-icon-mw.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/mw.svg);\n}\n\n.flag-icon-mx {\n  background-image: url(../../../fonts/flag-icon/mx.svg);\n}\n.flag-icon-mx.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/mx.svg);\n}\n\n.flag-icon-my {\n  background-image: url(../../../fonts/flag-icon/my.svg);\n}\n.flag-icon-my.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/my.svg);\n}\n\n.flag-icon-mz {\n  background-image: url(../../../fonts/flag-icon/mz.svg);\n}\n.flag-icon-mz.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/mz.svg);\n}\n\n.flag-icon-na {\n  background-image: url(../../../fonts/flag-icon/na.svg);\n}\n.flag-icon-na.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/na.svg);\n}\n\n.flag-icon-nc {\n  background-image: url(../../../fonts/flag-icon/nc.svg);\n}\n.flag-icon-nc.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/nc.svg);\n}\n\n.flag-icon-ne {\n  background-image: url(../../../fonts/flag-icon/ne.svg);\n}\n.flag-icon-ne.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ne.svg);\n}\n\n.flag-icon-nf {\n  background-image: url(../../../fonts/flag-icon/nf.svg);\n}\n.flag-icon-nf.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/nf.svg);\n}\n\n.flag-icon-ng {\n  background-image: url(../../../fonts/flag-icon/ng.svg);\n}\n.flag-icon-ng.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ng.svg);\n}\n\n.flag-icon-ni {\n  background-image: url(../../../fonts/flag-icon/ni.svg);\n}\n.flag-icon-ni.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ni.svg);\n}\n\n.flag-icon-nl {\n  background-image: url(../../../fonts/flag-icon/nl.svg);\n}\n.flag-icon-nl.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/nl.svg);\n}\n\n.flag-icon-no {\n  background-image: url(../../../fonts/flag-icon/no.svg);\n}\n.flag-icon-no.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/no.svg);\n}\n\n.flag-icon-np {\n  background-image: url(../../../fonts/flag-icon/np.svg);\n}\n.flag-icon-np.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/np.svg);\n}\n\n.flag-icon-nr {\n  background-image: url(../../../fonts/flag-icon/nr.svg);\n}\n.flag-icon-nr.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/nr.svg);\n}\n\n.flag-icon-nu {\n  background-image: url(../../../fonts/flag-icon/nu.svg);\n}\n.flag-icon-nu.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/nu.svg);\n}\n\n.flag-icon-nz {\n  background-image: url(../../../fonts/flag-icon/nz.svg);\n}\n.flag-icon-nz.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/nz.svg);\n}\n\n.flag-icon-om {\n  background-image: url(../../../fonts/flag-icon/om.svg);\n}\n.flag-icon-om.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/om.svg);\n}\n\n.flag-icon-pa {\n  background-image: url(../../../fonts/flag-icon/pa.svg);\n}\n.flag-icon-pa.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/pa.svg);\n}\n\n.flag-icon-pe {\n  background-image: url(../../../fonts/flag-icon/pe.svg);\n}\n.flag-icon-pe.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/pe.svg);\n}\n\n.flag-icon-pf {\n  background-image: url(../../../fonts/flag-icon/pf.svg);\n}\n.flag-icon-pf.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/pf.svg);\n}\n\n.flag-icon-pg {\n  background-image: url(../../../fonts/flag-icon/pg.svg);\n}\n.flag-icon-pg.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/pg.svg);\n}\n\n.flag-icon-ph {\n  background-image: url(../../../fonts/flag-icon/ph.svg);\n}\n.flag-icon-ph.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ph.svg);\n}\n\n.flag-icon-pk {\n  background-image: url(../../../fonts/flag-icon/pk.svg);\n}\n.flag-icon-pk.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/pk.svg);\n}\n\n.flag-icon-pl {\n  background-image: url(../../../fonts/flag-icon/pl.svg);\n}\n.flag-icon-pl.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/pl.svg);\n}\n\n.flag-icon-pm {\n  background-image: url(../../../fonts/flag-icon/pm.svg);\n}\n.flag-icon-pm.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/pm.svg);\n}\n\n.flag-icon-pn {\n  background-image: url(../../../fonts/flag-icon/pn.svg);\n}\n.flag-icon-pn.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/pn.svg);\n}\n\n.flag-icon-pr {\n  background-image: url(../../../fonts/flag-icon/pr.svg);\n}\n.flag-icon-pr.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/pr.svg);\n}\n\n.flag-icon-ps {\n  background-image: url(../../../fonts/flag-icon/ps.svg);\n}\n.flag-icon-ps.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ps.svg);\n}\n\n.flag-icon-pt {\n  background-image: url(../../../fonts/flag-icon/pt.svg);\n}\n.flag-icon-pt.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/pt.svg);\n}\n\n.flag-icon-pw {\n  background-image: url(../../../fonts/flag-icon/pw.svg);\n}\n.flag-icon-pw.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/pw.svg);\n}\n\n.flag-icon-py {\n  background-image: url(../../../fonts/flag-icon/py.svg);\n}\n.flag-icon-py.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/py.svg);\n}\n\n.flag-icon-qa {\n  background-image: url(../../../fonts/flag-icon/qa.svg);\n}\n.flag-icon-qa.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/qa.svg);\n}\n\n.flag-icon-re {\n  background-image: url(../../../fonts/flag-icon/re.svg);\n}\n.flag-icon-re.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/re.svg);\n}\n\n.flag-icon-ro {\n  background-image: url(../../../fonts/flag-icon/ro.svg);\n}\n.flag-icon-ro.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ro.svg);\n}\n\n.flag-icon-rs {\n  background-image: url(../../../fonts/flag-icon/rs.svg);\n}\n.flag-icon-rs.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/rs.svg);\n}\n\n.flag-icon-ru {\n  background-image: url(../../../fonts/flag-icon/ru.svg);\n}\n.flag-icon-ru.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ru.svg);\n}\n\n.flag-icon-rw {\n  background-image: url(../../../fonts/flag-icon/rw.svg);\n}\n.flag-icon-rw.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/rw.svg);\n}\n\n.flag-icon-sa {\n  background-image: url(../../../fonts/flag-icon/sa.svg);\n}\n.flag-icon-sa.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/sa.svg);\n}\n\n.flag-icon-sb {\n  background-image: url(../../../fonts/flag-icon/sb.svg);\n}\n.flag-icon-sb.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/sb.svg);\n}\n\n.flag-icon-sc {\n  background-image: url(../../../fonts/flag-icon/sc.svg);\n}\n.flag-icon-sc.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/sc.svg);\n}\n\n.flag-icon-sd {\n  background-image: url(../../../fonts/flag-icon/sd.svg);\n}\n.flag-icon-sd.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/sd.svg);\n}\n\n.flag-icon-se {\n  background-image: url(../../../fonts/flag-icon/se.svg);\n}\n.flag-icon-se.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/se.svg);\n}\n\n.flag-icon-sg {\n  background-image: url(../../../fonts/flag-icon/sg.svg);\n}\n.flag-icon-sg.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/sg.svg);\n}\n\n.flag-icon-sh {\n  background-image: url(../../../fonts/flag-icon/sh.svg);\n}\n.flag-icon-sh.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/sh.svg);\n}\n\n.flag-icon-si {\n  background-image: url(../../../fonts/flag-icon/si.svg);\n}\n.flag-icon-si.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/si.svg);\n}\n\n.flag-icon-sj {\n  background-image: url(../../../fonts/flag-icon/sj.svg);\n}\n.flag-icon-sj.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/sj.svg);\n}\n\n.flag-icon-sk {\n  background-image: url(../../../fonts/flag-icon/sk.svg);\n}\n.flag-icon-sk.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/sk.svg);\n}\n\n.flag-icon-sl {\n  background-image: url(../../../fonts/flag-icon/sl.svg);\n}\n.flag-icon-sl.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/sl.svg);\n}\n\n.flag-icon-sm {\n  background-image: url(../../../fonts/flag-icon/sm.svg);\n}\n.flag-icon-sm.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/sm.svg);\n}\n\n.flag-icon-sn {\n  background-image: url(../../../fonts/flag-icon/sn.svg);\n}\n.flag-icon-sn.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/sn.svg);\n}\n\n.flag-icon-so {\n  background-image: url(../../../fonts/flag-icon/so.svg);\n}\n.flag-icon-so.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/so.svg);\n}\n\n.flag-icon-sr {\n  background-image: url(../../../fonts/flag-icon/sr.svg);\n}\n.flag-icon-sr.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/sr.svg);\n}\n\n.flag-icon-ss {\n  background-image: url(../../../fonts/flag-icon/ss.svg);\n}\n.flag-icon-ss.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ss.svg);\n}\n\n.flag-icon-st {\n  background-image: url(../../../fonts/flag-icon/st.svg);\n}\n.flag-icon-st.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/st.svg);\n}\n\n.flag-icon-sv {\n  background-image: url(../../../fonts/flag-icon/sv.svg);\n}\n.flag-icon-sv.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/sv.svg);\n}\n\n.flag-icon-sx {\n  background-image: url(../../../fonts/flag-icon/sx.svg);\n}\n.flag-icon-sx.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/sx.svg);\n}\n\n.flag-icon-sy {\n  background-image: url(../../../fonts/flag-icon/sy.svg);\n}\n.flag-icon-sy.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/sy.svg);\n}\n\n.flag-icon-sz {\n  background-image: url(../../../fonts/flag-icon/sz.svg);\n}\n.flag-icon-sz.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/sz.svg);\n}\n\n.flag-icon-tc {\n  background-image: url(../../../fonts/flag-icon/tc.svg);\n}\n.flag-icon-tc.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/tc.svg);\n}\n\n.flag-icon-td {\n  background-image: url(../../../fonts/flag-icon/td.svg);\n}\n.flag-icon-td.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/td.svg);\n}\n\n.flag-icon-tf {\n  background-image: url(../../../fonts/flag-icon/tf.svg);\n}\n.flag-icon-tf.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/tf.svg);\n}\n\n.flag-icon-tg {\n  background-image: url(../../../fonts/flag-icon/tg.svg);\n}\n.flag-icon-tg.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/tg.svg);\n}\n\n.flag-icon-th {\n  background-image: url(../../../fonts/flag-icon/th.svg);\n}\n.flag-icon-th.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/th.svg);\n}\n\n.flag-icon-tj {\n  background-image: url(../../../fonts/flag-icon/tj.svg);\n}\n.flag-icon-tj.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/tj.svg);\n}\n\n.flag-icon-tk {\n  background-image: url(../../../fonts/flag-icon/tk.svg);\n}\n.flag-icon-tk.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/tk.svg);\n}\n\n.flag-icon-tl {\n  background-image: url(../../../fonts/flag-icon/tl.svg);\n}\n.flag-icon-tl.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/tl.svg);\n}\n\n.flag-icon-tm {\n  background-image: url(../../../fonts/flag-icon/tm.svg);\n}\n.flag-icon-tm.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/tm.svg);\n}\n\n.flag-icon-tn {\n  background-image: url(../../../fonts/flag-icon/tn.svg);\n}\n.flag-icon-tn.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/tn.svg);\n}\n\n.flag-icon-to {\n  background-image: url(../../../fonts/flag-icon/to.svg);\n}\n.flag-icon-to.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/to.svg);\n}\n\n.flag-icon-tr {\n  background-image: url(../../../fonts/flag-icon/tr.svg);\n}\n.flag-icon-tr.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/tr.svg);\n}\n\n.flag-icon-tt {\n  background-image: url(../../../fonts/flag-icon/tt.svg);\n}\n.flag-icon-tt.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/tt.svg);\n}\n\n.flag-icon-tv {\n  background-image: url(../../../fonts/flag-icon/tv.svg);\n}\n.flag-icon-tv.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/tv.svg);\n}\n\n.flag-icon-tw {\n  background-image: url(../../../fonts/flag-icon/tw.svg);\n}\n.flag-icon-tw.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/tw.svg);\n}\n\n.flag-icon-tz {\n  background-image: url(../../../fonts/flag-icon/tz.svg);\n}\n.flag-icon-tz.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/tz.svg);\n}\n\n.flag-icon-ua {\n  background-image: url(../../../fonts/flag-icon/ua.svg);\n}\n.flag-icon-ua.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ua.svg);\n}\n\n.flag-icon-ug {\n  background-image: url(../../../fonts/flag-icon/ug.svg);\n}\n.flag-icon-ug.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ug.svg);\n}\n\n.flag-icon-um {\n  background-image: url(../../../fonts/flag-icon/um.svg);\n}\n.flag-icon-um.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/um.svg);\n}\n\n.flag-icon-us {\n  background-image: url(../../../fonts/flag-icon/us.svg);\n}\n.flag-icon-us.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/us.svg);\n}\n\n.flag-icon-uy {\n  background-image: url(../../../fonts/flag-icon/uy.svg);\n}\n.flag-icon-uy.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/uy.svg);\n}\n\n.flag-icon-uz {\n  background-image: url(../../../fonts/flag-icon/uz.svg);\n}\n.flag-icon-uz.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/uz.svg);\n}\n\n.flag-icon-va {\n  background-image: url(../../../fonts/flag-icon/va.svg);\n}\n.flag-icon-va.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/va.svg);\n}\n\n.flag-icon-vc {\n  background-image: url(../../../fonts/flag-icon/vc.svg);\n}\n.flag-icon-vc.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/vc.svg);\n}\n\n.flag-icon-ve {\n  background-image: url(../../../fonts/flag-icon/ve.svg);\n}\n.flag-icon-ve.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ve.svg);\n}\n\n.flag-icon-vg {\n  background-image: url(../../../fonts/flag-icon/vg.svg);\n}\n.flag-icon-vg.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/vg.svg);\n}\n\n.flag-icon-vi {\n  background-image: url(../../../fonts/flag-icon/vi.svg);\n}\n.flag-icon-vi.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/vi.svg);\n}\n\n.flag-icon-vn {\n  background-image: url(../../../fonts/flag-icon/vn.svg);\n}\n.flag-icon-vn.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/vn.svg);\n}\n\n.flag-icon-vu {\n  background-image: url(../../../fonts/flag-icon/vu.svg);\n}\n.flag-icon-vu.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/vu.svg);\n}\n\n.flag-icon-wf {\n  background-image: url(../../../fonts/flag-icon/wf.svg);\n}\n.flag-icon-wf.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/wf.svg);\n}\n\n.flag-icon-ws {\n  background-image: url(../../../fonts/flag-icon/ws.svg);\n}\n.flag-icon-ws.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ws.svg);\n}\n\n.flag-icon-ye {\n  background-image: url(../../../fonts/flag-icon/ye.svg);\n}\n.flag-icon-ye.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/ye.svg);\n}\n\n.flag-icon-yt {\n  background-image: url(../../../fonts/flag-icon/yt.svg);\n}\n.flag-icon-yt.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/yt.svg);\n}\n\n.flag-icon-za {\n  background-image: url(../../../fonts/flag-icon/za.svg);\n}\n.flag-icon-za.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/za.svg);\n}\n\n.flag-icon-zm {\n  background-image: url(../../../fonts/flag-icon/zm.svg);\n}\n.flag-icon-zm.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/zm.svg);\n}\n\n.flag-icon-zw {\n  background-image: url(../../../fonts/flag-icon/zw.svg);\n}\n.flag-icon-zw.flag-icon-squared {\n  background-image: url(../../../fonts/flag-icon/zw.svg);\n}\n\n/**\n * @package IcoFont by ThemeHunt - https://themehunt.com\n * @version 1.0.0 Beta\n * @author IcoFont http://icofont.com\n * @copyright Copyright (c) 2018 IcoFont\n * @license - http://icofont.com/license/\n*/\n@font-face {\n  font-family: \"icofont\";\n  src: url(\"../../../fonts/ico/icofont.eot?v=1.0.0-beta\");\n  src: url(\"../../../fonts/ico/icofont.eot?v=1.0.0-beta#iefix\") format(\"embedded-opentype\"), url(\"../../../fonts/ico/icofont.ttf?v=1.0.0-beta\") format(\"truetype\"), url(\"../../../fonts/ico/icofont.woff?v=1.0.0-beta\") format(\"woff\"), url(\"../../../fonts/ico/icofont.svg?v=1.0.0-beta#icofont\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n}\n.icofont {\n  font-family: \"IcoFont\" !important;\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icofont-angry-monster:before {\n  content: \"\\e901\";\n}\n\n.icofont-bathtub:before {\n  content: \"\\e902\";\n}\n\n.icofont-bird-wings:before {\n  content: \"\\e903\";\n}\n\n.icofont-bow:before {\n  content: \"\\e904\";\n}\n\n.icofont-brain-alt:before {\n  content: \"\\e905\";\n}\n\n.icofont-butterfly-alt:before {\n  content: \"\\e906\";\n}\n\n.icofont-castle:before {\n  content: \"\\e907\";\n}\n\n.icofont-circuit:before {\n  content: \"\\e908\";\n}\n\n.icofont-dart:before {\n  content: \"\\e909\";\n}\n\n.icofont-dice-alt:before {\n  content: \"\\e90a\";\n}\n\n.icofont-disability-race:before {\n  content: \"\\e90b\";\n}\n\n.icofont-diving-goggle:before {\n  content: \"\\e90c\";\n}\n\n.icofont-fire-alt:before {\n  content: \"\\e90d\";\n}\n\n.icofont-flame-torch:before {\n  content: \"\\e90e\";\n}\n\n.icofont-flora-flower:before {\n  content: \"\\e90f\";\n}\n\n.icofont-flora:before {\n  content: \"\\e910\";\n}\n\n.icofont-gift-box:before {\n  content: \"\\e911\";\n}\n\n.icofont-halloween-pumpkin:before {\n  content: \"\\e912\";\n}\n\n.icofont-hand-power:before {\n  content: \"\\e913\";\n}\n\n.icofont-hand-thunder:before {\n  content: \"\\e914\";\n}\n\n.icofont-king-crown:before {\n  content: \"\\e915\";\n}\n\n.icofont-king-monster:before {\n  content: \"\\e916\";\n}\n\n.icofont-love:before {\n  content: \"\\e917\";\n}\n\n.icofont-magician-hat:before {\n  content: \"\\e918\";\n}\n\n.icofont-native-american:before {\n  content: \"\\e919\";\n}\n\n.icofont-open-eye:before {\n  content: \"\\e91a\";\n}\n\n.icofont-owl-look:before {\n  content: \"\\e91b\";\n}\n\n.icofont-phoenix:before {\n  content: \"\\e91c\";\n}\n\n.icofont-queen-crown:before {\n  content: \"\\e91d\";\n}\n\n.icofont-robot-face:before {\n  content: \"\\e91e\";\n}\n\n.icofont-sand-clock:before {\n  content: \"\\e91f\";\n}\n\n.icofont-shield-alt:before {\n  content: \"\\e920\";\n}\n\n.icofont-ship-wheel:before {\n  content: \"\\e921\";\n}\n\n.icofont-skull-danger:before {\n  content: \"\\e922\";\n}\n\n.icofont-skull-face:before {\n  content: \"\\e923\";\n}\n\n.icofont-snail:before {\n  content: \"\\e924\";\n}\n\n.icofont-snow-alt:before {\n  content: \"\\e925\";\n}\n\n.icofont-snow-flake:before {\n  content: \"\\e926\";\n}\n\n.icofont-snowmobile:before {\n  content: \"\\e927\";\n}\n\n.icofont-space-shuttle:before {\n  content: \"\\e928\";\n}\n\n.icofont-star-shape:before {\n  content: \"\\e929\";\n}\n\n.icofont-swirl:before {\n  content: \"\\e92a\";\n}\n\n.icofont-tattoo-wing:before {\n  content: \"\\e92b\";\n}\n\n.icofont-throne:before {\n  content: \"\\e92c\";\n}\n\n.icofont-touch:before {\n  content: \"\\e92d\";\n}\n\n.icofont-tree-alt:before {\n  content: \"\\e92e\";\n}\n\n.icofont-triangle:before {\n  content: \"\\e92f\";\n}\n\n.icofont-unity-hand:before {\n  content: \"\\e930\";\n}\n\n.icofont-weed:before {\n  content: \"\\e931\";\n}\n\n.icofont-woman-bird:before {\n  content: \"\\e932\";\n}\n\n.icofont-animal-bat:before {\n  content: \"\\e933\";\n}\n\n.icofont-animal-bear-tracks:before {\n  content: \"\\e934\";\n}\n\n.icofont-animal-bear:before {\n  content: \"\\e935\";\n}\n\n.icofont-animal-bird-alt:before {\n  content: \"\\e936\";\n}\n\n.icofont-animal-bird:before {\n  content: \"\\e937\";\n}\n\n.icofont-animal-bone:before {\n  content: \"\\e938\";\n}\n\n.icofont-animal-bull:before {\n  content: \"\\e939\";\n}\n\n.icofont-animal-camel-alt:before {\n  content: \"\\e93a\";\n}\n\n.icofont-animal-camel-head:before {\n  content: \"\\e93b\";\n}\n\n.icofont-animal-camel:before {\n  content: \"\\e93c\";\n}\n\n.icofont-animal-cat-alt-1:before {\n  content: \"\\e93d\";\n}\n\n.icofont-animal-cat-alt-2:before {\n  content: \"\\e93e\";\n}\n\n.icofont-animal-cat-alt-3:before {\n  content: \"\\e93f\";\n}\n\n.icofont-animal-cat-alt-4:before {\n  content: \"\\e940\";\n}\n\n.icofont-animal-cat-with-dog:before {\n  content: \"\\e941\";\n}\n\n.icofont-animal-cat:before {\n  content: \"\\e942\";\n}\n\n.icofont-animal-cow-head:before {\n  content: \"\\e943\";\n}\n\n.icofont-animal-cow:before {\n  content: \"\\e944\";\n}\n\n.icofont-animal-crab:before {\n  content: \"\\e945\";\n}\n\n.icofont-animal-crocodile:before {\n  content: \"\\e946\";\n}\n\n.icofont-animal-deer-head:before {\n  content: \"\\e947\";\n}\n\n.icofont-animal-dog-alt:before {\n  content: \"\\e948\";\n}\n\n.icofont-animal-dog-barking:before {\n  content: \"\\e949\";\n}\n\n.icofont-animal-dog:before {\n  content: \"\\e94a\";\n}\n\n.icofont-animal-dolphin:before {\n  content: \"\\e94b\";\n}\n\n.icofont-animal-duck-tracks:before {\n  content: \"\\e94c\";\n}\n\n.icofont-animal-eagle-head:before {\n  content: \"\\e94d\";\n}\n\n.icofont-animal-eaten-fish:before {\n  content: \"\\e94e\";\n}\n\n.icofont-animal-elephant-alt:before {\n  content: \"\\e94f\";\n}\n\n.icofont-animal-elephant-head-alt:before {\n  content: \"\\e950\";\n}\n\n.icofont-animal-elephant-head:before {\n  content: \"\\e951\";\n}\n\n.icofont-animal-elephant:before {\n  content: \"\\e952\";\n}\n\n.icofont-animal-elk:before {\n  content: \"\\e953\";\n}\n\n.icofont-animal-fish-alt-1:before {\n  content: \"\\e954\";\n}\n\n.icofont-animal-fish-alt-2:before {\n  content: \"\\e955\";\n}\n\n.icofont-animal-fish-alt-3:before {\n  content: \"\\e956\";\n}\n\n.icofont-animal-fish-alt-4:before {\n  content: \"\\e957\";\n}\n\n.icofont-animal-fish:before {\n  content: \"\\e958\";\n}\n\n.icofont-animal-fox-alt:before {\n  content: \"\\e959\";\n}\n\n.icofont-animal-fox:before {\n  content: \"\\e95a\";\n}\n\n.icofont-animal-frog-tracks:before {\n  content: \"\\e95b\";\n}\n\n.icofont-animal-frog:before {\n  content: \"\\e95c\";\n}\n\n.icofont-animal-froggy:before {\n  content: \"\\e95d\";\n}\n\n.icofont-animal-giraffe-alt:before {\n  content: \"\\e95e\";\n}\n\n.icofont-animal-giraffe:before {\n  content: \"\\e95f\";\n}\n\n.icofont-animal-goat-head-alt-1:before {\n  content: \"\\e960\";\n}\n\n.icofont-animal-goat-head-alt-2:before {\n  content: \"\\e961\";\n}\n\n.icofont-animal-goat-head:before {\n  content: \"\\e962\";\n}\n\n.icofont-animal-gorilla:before {\n  content: \"\\e963\";\n}\n\n.icofont-animal-hen-tracks:before {\n  content: \"\\e964\";\n}\n\n.icofont-animal-horse-head-alt-1:before {\n  content: \"\\e965\";\n}\n\n.icofont-animal-horse-head-alt-2:before {\n  content: \"\\e966\";\n}\n\n.icofont-animal-horse-head:before {\n  content: \"\\e967\";\n}\n\n.icofont-animal-horse-tracks:before {\n  content: \"\\e968\";\n}\n\n.icofont-animal-jellyfish:before {\n  content: \"\\e969\";\n}\n\n.icofont-animal-kangaroo:before {\n  content: \"\\e96a\";\n}\n\n.icofont-animal-lemur:before {\n  content: \"\\e96b\";\n}\n\n.icofont-animal-lion-alt:before {\n  content: \"\\e96c\";\n}\n\n.icofont-animal-lion-head-alt:before {\n  content: \"\\e96d\";\n}\n\n.icofont-animal-lion-head:before {\n  content: \"\\e96e\";\n}\n\n.icofont-animal-lion:before {\n  content: \"\\e96f\";\n}\n\n.icofont-animal-monkey-alt-1:before {\n  content: \"\\e970\";\n}\n\n.icofont-animal-monkey-alt-2:before {\n  content: \"\\e971\";\n}\n\n.icofont-animal-monkey-alt-3:before {\n  content: \"\\e972\";\n}\n\n.icofont-animal-monkey:before {\n  content: \"\\e973\";\n}\n\n.icofont-animal-octopus-alt:before {\n  content: \"\\e974\";\n}\n\n.icofont-animal-octopus:before {\n  content: \"\\e975\";\n}\n\n.icofont-animal-owl:before {\n  content: \"\\e976\";\n}\n\n.icofont-animal-panda-alt:before {\n  content: \"\\e977\";\n}\n\n.icofont-animal-panda:before {\n  content: \"\\e978\";\n}\n\n.icofont-animal-panther:before {\n  content: \"\\e979\";\n}\n\n.icofont-animal-parrot-lip:before {\n  content: \"\\e97a\";\n}\n\n.icofont-animal-parrot:before {\n  content: \"\\e97b\";\n}\n\n.icofont-animal-paw:before {\n  content: \"\\e97c\";\n}\n\n.icofont-animal-pelican:before {\n  content: \"\\e97d\";\n}\n\n.icofont-animal-penguin:before {\n  content: \"\\e97e\";\n}\n\n.icofont-animal-pig-alt:before {\n  content: \"\\e97f\";\n}\n\n.icofont-animal-pig:before {\n  content: \"\\e980\";\n}\n\n.icofont-animal-pigeon-alt:before {\n  content: \"\\e981\";\n}\n\n.icofont-animal-pigeon:before {\n  content: \"\\e982\";\n}\n\n.icofont-animal-pigeons:before {\n  content: \"\\e983\";\n}\n\n.icofont-animal-rabbit-running:before {\n  content: \"\\e984\";\n}\n\n.icofont-animal-rat-alt:before {\n  content: \"\\e985\";\n}\n\n.icofont-animal-rhino-head:before {\n  content: \"\\e986\";\n}\n\n.icofont-animal-rhino:before {\n  content: \"\\e987\";\n}\n\n.icofont-animal-rooster:before {\n  content: \"\\e988\";\n}\n\n.icofont-animal-seahorse:before {\n  content: \"\\e989\";\n}\n\n.icofont-animal-seal:before {\n  content: \"\\e98a\";\n}\n\n.icofont-animal-shrimp:before {\n  content: \"\\e98b\";\n}\n\n.icofont-animal-snail-alt-1:before {\n  content: \"\\e98c\";\n}\n\n.icofont-animal-snail-alt-2:before {\n  content: \"\\e98d\";\n}\n\n.icofont-animal-snail:before {\n  content: \"\\e98e\";\n}\n\n.icofont-animal-snake:before {\n  content: \"\\e98f\";\n}\n\n.icofont-animal-squid:before {\n  content: \"\\e990\";\n}\n\n.icofont-animal-squirrel:before {\n  content: \"\\e991\";\n}\n\n.icofont-animal-tiger-alt:before {\n  content: \"\\e992\";\n}\n\n.icofont-animal-tiger:before {\n  content: \"\\e993\";\n}\n\n.icofont-animal-turtle:before {\n  content: \"\\e994\";\n}\n\n.icofont-animal-whale:before {\n  content: \"\\e995\";\n}\n\n.icofont-animal-woodpecker:before {\n  content: \"\\e996\";\n}\n\n.icofont-animal-zebra:before {\n  content: \"\\e997\";\n}\n\n.icofont-brand-acer:before {\n  content: \"\\e998\";\n}\n\n.icofont-brand-adidas:before {\n  content: \"\\e999\";\n}\n\n.icofont-brand-adobe:before {\n  content: \"\\e99a\";\n}\n\n.icofont-brand-air-new-zealand:before {\n  content: \"\\e99b\";\n}\n\n.icofont-brand-airbnb:before {\n  content: \"\\e99c\";\n}\n\n.icofont-brand-aircell:before {\n  content: \"\\e99d\";\n}\n\n.icofont-brand-airtel:before {\n  content: \"\\e99e\";\n}\n\n.icofont-brand-alcatel:before {\n  content: \"\\e99f\";\n}\n\n.icofont-brand-alibaba:before {\n  content: \"\\e9a0\";\n}\n\n.icofont-brand-aliexpress:before {\n  content: \"\\e9a1\";\n}\n\n.icofont-brand-alipay:before {\n  content: \"\\e9a2\";\n}\n\n.icofont-brand-amazon:before {\n  content: \"\\e9a3\";\n}\n\n.icofont-brand-amd:before {\n  content: \"\\e9a4\";\n}\n\n.icofont-brand-american-airlines:before {\n  content: \"\\e9a5\";\n}\n\n.icofont-brand-android-robot:before {\n  content: \"\\e9a6\";\n}\n\n.icofont-brand-android:before {\n  content: \"\\e9a7\";\n}\n\n.icofont-brand-aol:before {\n  content: \"\\e9a8\";\n}\n\n.icofont-brand-apple:before {\n  content: \"\\e9a9\";\n}\n\n.icofont-brand-appstore:before {\n  content: \"\\e9aa\";\n}\n\n.icofont-brand-asus:before {\n  content: \"\\e9ab\";\n}\n\n.icofont-brand-ati:before {\n  content: \"\\e9ac\";\n}\n\n.icofont-brand-att:before {\n  content: \"\\e9ad\";\n}\n\n.icofont-brand-audi:before {\n  content: \"\\e9ae\";\n}\n\n.icofont-brand-axiata:before {\n  content: \"\\e9af\";\n}\n\n.icofont-brand-bada:before {\n  content: \"\\e9b0\";\n}\n\n.icofont-brand-bbc:before {\n  content: \"\\e9b1\";\n}\n\n.icofont-brand-bing:before {\n  content: \"\\e9b2\";\n}\n\n.icofont-brand-blackberry:before {\n  content: \"\\e9b3\";\n}\n\n.icofont-brand-bmw:before {\n  content: \"\\e9b4\";\n}\n\n.icofont-brand-box:before {\n  content: \"\\e9b5\";\n}\n\n.icofont-brand-burger-king:before {\n  content: \"\\e9b6\";\n}\n\n.icofont-brand-business-insider:before {\n  content: \"\\e9b7\";\n}\n\n.icofont-brand-buzzfeed:before {\n  content: \"\\e9b8\";\n}\n\n.icofont-brand-cannon:before {\n  content: \"\\e9b9\";\n}\n\n.icofont-brand-casio:before {\n  content: \"\\e9ba\";\n}\n\n.icofont-brand-china-mobile:before {\n  content: \"\\e9bb\";\n}\n\n.icofont-brand-china-telecom:before {\n  content: \"\\e9bc\";\n}\n\n.icofont-brand-china-unicom:before {\n  content: \"\\e9bd\";\n}\n\n.icofont-brand-cisco:before {\n  content: \"\\e9be\";\n}\n\n.icofont-brand-citibank:before {\n  content: \"\\e9bf\";\n}\n\n.icofont-brand-cnet:before {\n  content: \"\\e9c0\";\n}\n\n.icofont-brand-cnn:before {\n  content: \"\\e9c1\";\n}\n\n.icofont-brand-cocal-cola:before {\n  content: \"\\e9c2\";\n}\n\n.icofont-brand-compaq:before {\n  content: \"\\e9c3\";\n}\n\n.icofont-brand-copy:before {\n  content: \"\\e9c4\";\n}\n\n.icofont-brand-debian:before {\n  content: \"\\e9c5\";\n}\n\n.icofont-brand-delicious:before {\n  content: \"\\e9c6\";\n}\n\n.icofont-brand-dell:before {\n  content: \"\\e9c7\";\n}\n\n.icofont-brand-designbump:before {\n  content: \"\\e9c8\";\n}\n\n.icofont-brand-designfloat:before {\n  content: \"\\e9c9\";\n}\n\n.icofont-brand-disney:before {\n  content: \"\\e9ca\";\n}\n\n.icofont-brand-dodge:before {\n  content: \"\\e9cb\";\n}\n\n.icofont-brand-dove:before {\n  content: \"\\e9cc\";\n}\n\n.icofont-brand-ebay:before {\n  content: \"\\e9cd\";\n}\n\n.icofont-brand-eleven:before {\n  content: \"\\e9ce\";\n}\n\n.icofont-brand-emirates:before {\n  content: \"\\e9cf\";\n}\n\n.icofont-brand-espn:before {\n  content: \"\\e9d0\";\n}\n\n.icofont-brand-etihad-airways:before {\n  content: \"\\e9d1\";\n}\n\n.icofont-brand-etisalat:before {\n  content: \"\\e9d2\";\n}\n\n.icofont-brand-etsy:before {\n  content: \"\\e9d3\";\n}\n\n.icofont-brand-facebook:before {\n  content: \"\\e9d4\";\n}\n\n.icofont-brand-fastrack:before {\n  content: \"\\e9d5\";\n}\n\n.icofont-brand-fedex:before {\n  content: \"\\e9d6\";\n}\n\n.icofont-brand-ferrari:before {\n  content: \"\\e9d7\";\n}\n\n.icofont-brand-fitbit:before {\n  content: \"\\e9d8\";\n}\n\n.icofont-brand-flikr:before {\n  content: \"\\e9d9\";\n}\n\n.icofont-brand-forbes:before {\n  content: \"\\e9da\";\n}\n\n.icofont-brand-foursquare:before {\n  content: \"\\e9db\";\n}\n\n.icofont-brand-fox:before {\n  content: \"\\e9dc\";\n}\n\n.icofont-brand-foxconn:before {\n  content: \"\\e9dd\";\n}\n\n.icofont-brand-fujitsu:before {\n  content: \"\\e9de\";\n}\n\n.icofont-brand-general-electric:before {\n  content: \"\\e9df\";\n}\n\n.icofont-brand-gillette:before {\n  content: \"\\e9e0\";\n}\n\n.icofont-brand-gizmodo:before {\n  content: \"\\e9e1\";\n}\n\n.icofont-brand-gnome:before {\n  content: \"\\e9e2\";\n}\n\n.icofont-brand-google:before {\n  content: \"\\e9e3\";\n}\n\n.icofont-brand-gopro:before {\n  content: \"\\e9e4\";\n}\n\n.icofont-brand-gucci:before {\n  content: \"\\e9e5\";\n}\n\n.icofont-brand-hallmark:before {\n  content: \"\\e9e6\";\n}\n\n.icofont-brand-hi5:before {\n  content: \"\\e9e7\";\n}\n\n.icofont-brand-honda:before {\n  content: \"\\e9e8\";\n}\n\n.icofont-brand-hp:before {\n  content: \"\\e9e9\";\n}\n\n.icofont-brand-hsbc:before {\n  content: \"\\e9ea\";\n}\n\n.icofont-brand-htc:before {\n  content: \"\\e9eb\";\n}\n\n.icofont-brand-huawei:before {\n  content: \"\\e9ec\";\n}\n\n.icofont-brand-hulu:before {\n  content: \"\\e9ed\";\n}\n\n.icofont-brand-hyundai:before {\n  content: \"\\e9ee\";\n}\n\n.icofont-brand-ibm:before {\n  content: \"\\e9ef\";\n}\n\n.icofont-brand-icofont:before {\n  content: \"\\e9f0\";\n}\n\n.icofont-brand-icq:before {\n  content: \"\\e9f1\";\n}\n\n.icofont-brand-ikea:before {\n  content: \"\\e9f2\";\n}\n\n.icofont-brand-imdb:before {\n  content: \"\\e9f3\";\n}\n\n.icofont-brand-indiegogo:before {\n  content: \"\\e9f4\";\n}\n\n.icofont-brand-intel:before {\n  content: \"\\e9f5\";\n}\n\n.icofont-brand-ipair:before {\n  content: \"\\e9f6\";\n}\n\n.icofont-brand-jaguar:before {\n  content: \"\\e9f7\";\n}\n\n.icofont-brand-java:before {\n  content: \"\\e9f8\";\n}\n\n.icofont-brand-joomshaper:before {\n  content: \"\\e9f9\";\n}\n\n.icofont-brand-kickstarter:before {\n  content: \"\\e9fa\";\n}\n\n.icofont-brand-kik:before {\n  content: \"\\e9fb\";\n}\n\n.icofont-brand-lastfm:before {\n  content: \"\\e9fc\";\n}\n\n.icofont-brand-lego:before {\n  content: \"\\e9fd\";\n}\n\n.icofont-brand-lenovo:before {\n  content: \"\\e9fe\";\n}\n\n.icofont-brand-levis:before {\n  content: \"\\e9ff\";\n}\n\n.icofont-brand-lexus:before {\n  content: \"\\ea00\";\n}\n\n.icofont-brand-lg:before {\n  content: \"\\ea01\";\n}\n\n.icofont-brand-life-hacker:before {\n  content: \"\\ea02\";\n}\n\n.icofont-brand-line-messenger:before {\n  content: \"\\ea03\";\n}\n\n.icofont-brand-linkedin:before {\n  content: \"\\ea04\";\n}\n\n.icofont-brand-linux-mint:before {\n  content: \"\\ea05\";\n}\n\n.icofont-brand-linux:before {\n  content: \"\\ea06\";\n}\n\n.icofont-brand-lionix:before {\n  content: \"\\ea07\";\n}\n\n.icofont-brand-live-messenger:before {\n  content: \"\\ea08\";\n}\n\n.icofont-brand-loreal:before {\n  content: \"\\ea09\";\n}\n\n.icofont-brand-louis-vuitton:before {\n  content: \"\\ea0a\";\n}\n\n.icofont-brand-mac-os:before {\n  content: \"\\ea0b\";\n}\n\n.icofont-brand-marvel-app:before {\n  content: \"\\ea0c\";\n}\n\n.icofont-brand-mashable:before {\n  content: \"\\ea0d\";\n}\n\n.icofont-brand-mazda:before {\n  content: \"\\ea0e\";\n}\n\n.icofont-brand-mcdonals:before {\n  content: \"\\ea0f\";\n}\n\n.icofont-brand-mercedes:before {\n  content: \"\\ea10\";\n}\n\n.icofont-brand-micromax:before {\n  content: \"\\ea11\";\n}\n\n.icofont-brand-microsoft:before {\n  content: \"\\ea12\";\n}\n\n.icofont-brand-mobileme:before {\n  content: \"\\ea13\";\n}\n\n.icofont-brand-mobily:before {\n  content: \"\\ea14\";\n}\n\n.icofont-brand-motorola:before {\n  content: \"\\ea15\";\n}\n\n.icofont-brand-msi:before {\n  content: \"\\ea16\";\n}\n\n.icofont-brand-mts:before {\n  content: \"\\ea17\";\n}\n\n.icofont-brand-myspace:before {\n  content: \"\\ea18\";\n}\n\n.icofont-brand-mytv:before {\n  content: \"\\ea19\";\n}\n\n.icofont-brand-nasa:before {\n  content: \"\\ea1a\";\n}\n\n.icofont-brand-natgeo:before {\n  content: \"\\ea1b\";\n}\n\n.icofont-brand-nbc:before {\n  content: \"\\ea1c\";\n}\n\n.icofont-brand-nescafe:before {\n  content: \"\\ea1d\";\n}\n\n.icofont-brand-nestle:before {\n  content: \"\\ea1e\";\n}\n\n.icofont-brand-netflix:before {\n  content: \"\\ea1f\";\n}\n\n.icofont-brand-nexus:before {\n  content: \"\\ea20\";\n}\n\n.icofont-brand-nike:before {\n  content: \"\\ea21\";\n}\n\n.icofont-brand-nokia:before {\n  content: \"\\ea22\";\n}\n\n.icofont-brand-nvidia:before {\n  content: \"\\ea23\";\n}\n\n.icofont-brand-omega:before {\n  content: \"\\ea24\";\n}\n\n.icofont-brand-opensuse:before {\n  content: \"\\ea25\";\n}\n\n.icofont-brand-oracle:before {\n  content: \"\\ea26\";\n}\n\n.icofont-brand-panasonic:before {\n  content: \"\\ea27\";\n}\n\n.icofont-brand-paypal:before {\n  content: \"\\ea28\";\n}\n\n.icofont-brand-pepsi:before {\n  content: \"\\ea29\";\n}\n\n.icofont-brand-philips:before {\n  content: \"\\ea2a\";\n}\n\n.icofont-brand-pizza-hut:before {\n  content: \"\\ea2b\";\n}\n\n.icofont-brand-playstation:before {\n  content: \"\\ea2c\";\n}\n\n.icofont-brand-puma:before {\n  content: \"\\ea2d\";\n}\n\n.icofont-brand-qatar-air:before {\n  content: \"\\ea2e\";\n}\n\n.icofont-brand-qvc:before {\n  content: \"\\ea2f\";\n}\n\n.icofont-brand-readernaut:before {\n  content: \"\\ea30\";\n}\n\n.icofont-brand-redbull:before {\n  content: \"\\ea31\";\n}\n\n.icofont-brand-reebok:before {\n  content: \"\\ea32\";\n}\n\n.icofont-brand-reuters:before {\n  content: \"\\ea33\";\n}\n\n.icofont-brand-samsung:before {\n  content: \"\\ea34\";\n}\n\n.icofont-brand-sap:before {\n  content: \"\\ea35\";\n}\n\n.icofont-brand-saudia-airlines:before {\n  content: \"\\ea36\";\n}\n\n.icofont-brand-scribd:before {\n  content: \"\\ea37\";\n}\n\n.icofont-brand-shell:before {\n  content: \"\\ea38\";\n}\n\n.icofont-brand-siemens:before {\n  content: \"\\ea39\";\n}\n\n.icofont-brand-sk-telecom:before {\n  content: \"\\ea3a\";\n}\n\n.icofont-brand-slideshare:before {\n  content: \"\\ea3b\";\n}\n\n.icofont-brand-smashing-magazine:before {\n  content: \"\\ea3c\";\n}\n\n.icofont-brand-snapchat:before {\n  content: \"\\ea3d\";\n}\n\n.icofont-brand-sony-ericsson:before {\n  content: \"\\ea3e\";\n}\n\n.icofont-brand-sony:before {\n  content: \"\\ea3f\";\n}\n\n.icofont-brand-soundcloud:before {\n  content: \"\\ea40\";\n}\n\n.icofont-brand-sprint:before {\n  content: \"\\ea41\";\n}\n\n.icofont-brand-squidoo:before {\n  content: \"\\ea42\";\n}\n\n.icofont-brand-starbucks:before {\n  content: \"\\ea43\";\n}\n\n.icofont-brand-stc:before {\n  content: \"\\ea44\";\n}\n\n.icofont-brand-steam:before {\n  content: \"\\ea45\";\n}\n\n.icofont-brand-suzuki:before {\n  content: \"\\ea46\";\n}\n\n.icofont-brand-symbian:before {\n  content: \"\\ea47\";\n}\n\n.icofont-brand-t-mobile:before {\n  content: \"\\ea48\";\n}\n\n.icofont-brand-tango:before {\n  content: \"\\ea49\";\n}\n\n.icofont-brand-target:before {\n  content: \"\\ea4a\";\n}\n\n.icofont-brand-tata-indicom:before {\n  content: \"\\ea4b\";\n}\n\n.icofont-brand-techcrunch:before {\n  content: \"\\ea4c\";\n}\n\n.icofont-brand-telenor:before {\n  content: \"\\ea4d\";\n}\n\n.icofont-brand-teliasonera:before {\n  content: \"\\ea4e\";\n}\n\n.icofont-brand-tesla:before {\n  content: \"\\ea4f\";\n}\n\n.icofont-brand-the-verge:before {\n  content: \"\\ea50\";\n}\n\n.icofont-brand-thenextweb:before {\n  content: \"\\ea51\";\n}\n\n.icofont-brand-toshiba:before {\n  content: \"\\ea52\";\n}\n\n.icofont-brand-toyota:before {\n  content: \"\\ea53\";\n}\n\n.icofont-brand-tribenet:before {\n  content: \"\\ea54\";\n}\n\n.icofont-brand-ubuntu:before {\n  content: \"\\ea55\";\n}\n\n.icofont-brand-unilever:before {\n  content: \"\\ea56\";\n}\n\n.icofont-brand-vaio:before {\n  content: \"\\ea57\";\n}\n\n.icofont-brand-verizon:before {\n  content: \"\\ea58\";\n}\n\n.icofont-brand-viber:before {\n  content: \"\\ea59\";\n}\n\n.icofont-brand-vodafone:before {\n  content: \"\\ea5a\";\n}\n\n.icofont-brand-volkswagen:before {\n  content: \"\\ea5b\";\n}\n\n.icofont-brand-walmart:before {\n  content: \"\\ea5c\";\n}\n\n.icofont-brand-warnerbros:before {\n  content: \"\\ea5d\";\n}\n\n.icofont-brand-whatsapp:before {\n  content: \"\\ea5e\";\n}\n\n.icofont-brand-wikipedia:before {\n  content: \"\\ea5f\";\n}\n\n.icofont-brand-windows:before {\n  content: \"\\ea60\";\n}\n\n.icofont-brand-wire:before {\n  content: \"\\ea61\";\n}\n\n.icofont-brand-yahoobuzz:before {\n  content: \"\\ea62\";\n}\n\n.icofont-brand-yamaha:before {\n  content: \"\\ea63\";\n}\n\n.icofont-brand-youtube:before {\n  content: \"\\ea64\";\n}\n\n.icofont-brand-zain:before {\n  content: \"\\ea65\";\n}\n\n.icofont-bank-alt:before {\n  content: \"\\ea66\";\n}\n\n.icofont-barcode:before {\n  content: \"\\ea67\";\n}\n\n.icofont-basket:before {\n  content: \"\\ea68\";\n}\n\n.icofont-bill-alt:before {\n  content: \"\\ea69\";\n}\n\n.icofont-billboard:before {\n  content: \"\\ea6a\";\n}\n\n.icofont-briefcase-alt-1:before {\n  content: \"\\ea6b\";\n}\n\n.icofont-briefcase-alt-2:before {\n  content: \"\\ea6c\";\n}\n\n.icofont-building-alt:before {\n  content: \"\\ea6d\";\n}\n\n.icofont-businessman:before {\n  content: \"\\ea6e\";\n}\n\n.icofont-businesswoman:before {\n  content: \"\\ea6f\";\n}\n\n.icofont-cart-alt:before {\n  content: \"\\ea70\";\n}\n\n.icofont-chair:before {\n  content: \"\\ea71\";\n}\n\n.icofont-clip:before {\n  content: \"\\ea72\";\n}\n\n.icofont-coins:before {\n  content: \"\\ea73\";\n}\n\n.icofont-company:before {\n  content: \"\\ea74\";\n}\n\n.icofont-contact-add:before {\n  content: \"\\ea75\";\n}\n\n.icofont-deal:before {\n  content: \"\\ea76\";\n}\n\n.icofont-files:before {\n  content: \"\\ea77\";\n}\n\n.icofont-growth:before {\n  content: \"\\ea78\";\n}\n\n.icofont-id-card:before {\n  content: \"\\ea79\";\n}\n\n.icofont-idea:before {\n  content: \"\\ea7a\";\n}\n\n.icofont-list:before {\n  content: \"\\ea7b\";\n}\n\n.icofont-meeting-add:before {\n  content: \"\\ea7c\";\n}\n\n.icofont-money-bag:before {\n  content: \"\\ea7d\";\n}\n\n.icofont-people:before {\n  content: \"\\ea7e\";\n}\n\n.icofont-pie-chart:before {\n  content: \"\\ea7f\";\n}\n\n.icofont-presentation-alt:before {\n  content: \"\\ea80\";\n}\n\n.icofont-stamp:before {\n  content: \"\\ea81\";\n}\n\n.icofont-stock-mobile:before {\n  content: \"\\ea82\";\n}\n\n.icofont-support:before {\n  content: \"\\ea83\";\n}\n\n.icofont-tasks-alt:before {\n  content: \"\\ea84\";\n}\n\n.icofont-wheel:before {\n  content: \"\\ea85\";\n}\n\n.icofont-chart-arrows-axis:before {\n  content: \"\\ea86\";\n}\n\n.icofont-chart-bar-graph:before {\n  content: \"\\ea87\";\n}\n\n.icofont-chart-flow-alt-1:before {\n  content: \"\\ea88\";\n}\n\n.icofont-chart-flow-alt-2:before {\n  content: \"\\ea89\";\n}\n\n.icofont-chart-flow:before {\n  content: \"\\ea8a\";\n}\n\n.icofont-chart-histogram-alt:before {\n  content: \"\\ea8b\";\n}\n\n.icofont-chart-histogram:before {\n  content: \"\\ea8c\";\n}\n\n.icofont-chart-line-alt:before {\n  content: \"\\ea8d\";\n}\n\n.icofont-chart-line:before {\n  content: \"\\ea8e\";\n}\n\n.icofont-chart-pie-alt:before {\n  content: \"\\ea8f\";\n}\n\n.icofont-chart-pie:before {\n  content: \"\\ea90\";\n}\n\n.icofont-chart-radar-graph:before {\n  content: \"\\ea91\";\n}\n\n.icofont-cur-afghani-false:before {\n  content: \"\\ea92\";\n}\n\n.icofont-cur-afghani-minus:before {\n  content: \"\\ea93\";\n}\n\n.icofont-cur-afghani-plus:before {\n  content: \"\\ea94\";\n}\n\n.icofont-cur-afghani-true:before {\n  content: \"\\ea95\";\n}\n\n.icofont-cur-afghani:before {\n  content: \"\\ea96\";\n}\n\n.icofont-cur-baht-false:before {\n  content: \"\\ea97\";\n}\n\n.icofont-cur-baht-minus:before {\n  content: \"\\ea98\";\n}\n\n.icofont-cur-baht-plus:before {\n  content: \"\\ea99\";\n}\n\n.icofont-cur-baht-true:before {\n  content: \"\\ea9a\";\n}\n\n.icofont-cur-baht:before {\n  content: \"\\ea9b\";\n}\n\n.icofont-cur-bitcoin-false:before {\n  content: \"\\ea9c\";\n}\n\n.icofont-cur-bitcoin-minus:before {\n  content: \"\\ea9d\";\n}\n\n.icofont-cur-bitcoin-plus:before {\n  content: \"\\ea9e\";\n}\n\n.icofont-cur-bitcoin-true:before {\n  content: \"\\ea9f\";\n}\n\n.icofont-cur-bitcoin:before {\n  content: \"\\eaa0\";\n}\n\n.icofont-cur-dollar-flase:before {\n  content: \"\\eaa1\";\n}\n\n.icofont-cur-dollar-minus:before {\n  content: \"\\eaa2\";\n}\n\n.icofont-cur-dollar-plus:before {\n  content: \"\\eaa3\";\n}\n\n.icofont-cur-dollar-true:before {\n  content: \"\\eaa4\";\n}\n\n.icofont-cur-dollar:before {\n  content: \"\\eaa5\";\n}\n\n.icofont-cur-dong-false:before {\n  content: \"\\eaa6\";\n}\n\n.icofont-cur-dong-minus:before {\n  content: \"\\eaa7\";\n}\n\n.icofont-cur-dong-plus:before {\n  content: \"\\eaa8\";\n}\n\n.icofont-cur-dong-true:before {\n  content: \"\\eaa9\";\n}\n\n.icofont-cur-dong:before {\n  content: \"\\eaaa\";\n}\n\n.icofont-cur-euro-false:before {\n  content: \"\\eaab\";\n}\n\n.icofont-cur-euro-minus:before {\n  content: \"\\eaac\";\n}\n\n.icofont-cur-euro-plus:before {\n  content: \"\\eaad\";\n}\n\n.icofont-cur-euro-true:before {\n  content: \"\\eaae\";\n}\n\n.icofont-cur-euro:before {\n  content: \"\\eaaf\";\n}\n\n.icofont-cur-frank-false:before {\n  content: \"\\eab0\";\n}\n\n.icofont-cur-frank-minus:before {\n  content: \"\\eab1\";\n}\n\n.icofont-cur-frank-plus:before {\n  content: \"\\eab2\";\n}\n\n.icofont-cur-frank-true:before {\n  content: \"\\eab3\";\n}\n\n.icofont-cur-frank:before {\n  content: \"\\eab4\";\n}\n\n.icofont-cur-hryvnia-false:before {\n  content: \"\\eab5\";\n}\n\n.icofont-cur-hryvnia-minus:before {\n  content: \"\\eab6\";\n}\n\n.icofont-cur-hryvnia-plus:before {\n  content: \"\\eab7\";\n}\n\n.icofont-cur-hryvnia-true:before {\n  content: \"\\eab8\";\n}\n\n.icofont-cur-hryvnia:before {\n  content: \"\\eab9\";\n}\n\n.icofont-cur-lira-false:before {\n  content: \"\\eaba\";\n}\n\n.icofont-cur-lira-minus:before {\n  content: \"\\eabb\";\n}\n\n.icofont-cur-lira-plus:before {\n  content: \"\\eabc\";\n}\n\n.icofont-cur-lira-true:before {\n  content: \"\\eabd\";\n}\n\n.icofont-cur-lira:before {\n  content: \"\\eabe\";\n}\n\n.icofont-cur-peseta-false:before {\n  content: \"\\eabf\";\n}\n\n.icofont-cur-peseta-minus:before {\n  content: \"\\eac0\";\n}\n\n.icofont-cur-peseta-plus:before {\n  content: \"\\eac1\";\n}\n\n.icofont-cur-peseta-true:before {\n  content: \"\\eac2\";\n}\n\n.icofont-cur-peseta:before {\n  content: \"\\eac3\";\n}\n\n.icofont-cur-peso-false:before {\n  content: \"\\eac4\";\n}\n\n.icofont-cur-peso-minus:before {\n  content: \"\\eac5\";\n}\n\n.icofont-cur-peso-plus:before {\n  content: \"\\eac6\";\n}\n\n.icofont-cur-peso-true:before {\n  content: \"\\eac7\";\n}\n\n.icofont-cur-peso:before {\n  content: \"\\eac8\";\n}\n\n.icofont-cur-pound-false:before {\n  content: \"\\eac9\";\n}\n\n.icofont-cur-pound-minus:before {\n  content: \"\\eaca\";\n}\n\n.icofont-cur-pound-plus:before {\n  content: \"\\eacb\";\n}\n\n.icofont-cur-pound-true:before {\n  content: \"\\eacc\";\n}\n\n.icofont-cur-pound:before {\n  content: \"\\eacd\";\n}\n\n.icofont-cur-renminbi-false:before {\n  content: \"\\eace\";\n}\n\n.icofont-cur-renminbi-minus:before {\n  content: \"\\eacf\";\n}\n\n.icofont-cur-renminbi-plus:before {\n  content: \"\\ead0\";\n}\n\n.icofont-cur-renminbi-true:before {\n  content: \"\\ead1\";\n}\n\n.icofont-cur-renminbi:before {\n  content: \"\\ead2\";\n}\n\n.icofont-cur-riyal-false:before {\n  content: \"\\ead3\";\n}\n\n.icofont-cur-riyal-minus:before {\n  content: \"\\ead4\";\n}\n\n.icofont-cur-riyal-plus:before {\n  content: \"\\ead5\";\n}\n\n.icofont-cur-riyal-true:before {\n  content: \"\\ead6\";\n}\n\n.icofont-cur-riyal:before {\n  content: \"\\ead7\";\n}\n\n.icofont-cur-rouble-false:before {\n  content: \"\\ead8\";\n}\n\n.icofont-cur-rouble-minus:before {\n  content: \"\\ead9\";\n}\n\n.icofont-cur-rouble-plus:before {\n  content: \"\\eada\";\n}\n\n.icofont-cur-rouble-true:before {\n  content: \"\\eadb\";\n}\n\n.icofont-cur-rouble:before {\n  content: \"\\eadc\";\n}\n\n.icofont-cur-rupee-false:before {\n  content: \"\\eadd\";\n}\n\n.icofont-cur-rupee-minus:before {\n  content: \"\\eade\";\n}\n\n.icofont-cur-rupee-plus:before {\n  content: \"\\eadf\";\n}\n\n.icofont-cur-rupee-true:before {\n  content: \"\\eae0\";\n}\n\n.icofont-cur-rupee:before {\n  content: \"\\eae1\";\n}\n\n.icofont-cur-taka-false:before {\n  content: \"\\eae2\";\n}\n\n.icofont-cur-taka-minus:before {\n  content: \"\\eae3\";\n}\n\n.icofont-cur-taka-plus:before {\n  content: \"\\eae4\";\n}\n\n.icofont-cur-taka-true:before {\n  content: \"\\eae5\";\n}\n\n.icofont-cur-taka:before {\n  content: \"\\eae6\";\n}\n\n.icofont-cur-turkish-lira-false:before {\n  content: \"\\eae7\";\n}\n\n.icofont-cur-turkish-lira-minus:before {\n  content: \"\\eae8\";\n}\n\n.icofont-cur-turkish-lira-plus:before {\n  content: \"\\eae9\";\n}\n\n.icofont-cur-turkish-lira-true:before {\n  content: \"\\eaea\";\n}\n\n.icofont-cur-turkish-lira:before {\n  content: \"\\eaeb\";\n}\n\n.icofont-cur-won-false:before {\n  content: \"\\eaec\";\n}\n\n.icofont-cur-won-minus:before {\n  content: \"\\eaed\";\n}\n\n.icofont-cur-won-plus:before {\n  content: \"\\eaee\";\n}\n\n.icofont-cur-won-true:before {\n  content: \"\\eaef\";\n}\n\n.icofont-cur-won:before {\n  content: \"\\eaf0\";\n}\n\n.icofont-cur-yen-false:before {\n  content: \"\\eaf1\";\n}\n\n.icofont-cur-yen-minus:before {\n  content: \"\\eaf2\";\n}\n\n.icofont-cur-yen-plus:before {\n  content: \"\\eaf3\";\n}\n\n.icofont-cur-yen-true:before {\n  content: \"\\eaf4\";\n}\n\n.icofont-cur-yen:before {\n  content: \"\\eaf5\";\n}\n\n.icofont-android-nexus:before {\n  content: \"\\eaf6\";\n}\n\n.icofont-android-tablet:before {\n  content: \"\\eaf7\";\n}\n\n.icofont-apple-watch:before {\n  content: \"\\eaf8\";\n}\n\n.icofont-drwaing-tablet:before {\n  content: \"\\eaf9\";\n}\n\n.icofont-earphone:before {\n  content: \"\\eafa\";\n}\n\n.icofont-flash-drive:before {\n  content: \"\\eafb\";\n}\n\n.icofont-game-control:before {\n  content: \"\\eafc\";\n}\n\n.icofont-headphone-alt:before {\n  content: \"\\eafd\";\n}\n\n.icofont-htc-one:before {\n  content: \"\\eafe\";\n}\n\n.icofont-imac:before {\n  content: \"\\eaff\";\n}\n\n.icofont-ipad-touch:before {\n  content: \"\\eb00\";\n}\n\n.icofont-iphone:before {\n  content: \"\\eb01\";\n}\n\n.icofont-ipod-nano:before {\n  content: \"\\eb02\";\n}\n\n.icofont-ipod-touch:before {\n  content: \"\\eb03\";\n}\n\n.icofont-keyboard-alt:before {\n  content: \"\\eb04\";\n}\n\n.icofont-keyboard-wireless:before {\n  content: \"\\eb05\";\n}\n\n.icofont-laptop-alt:before {\n  content: \"\\eb06\";\n}\n\n.icofont-macbook:before {\n  content: \"\\eb07\";\n}\n\n.icofont-magic-mouse:before {\n  content: \"\\eb08\";\n}\n\n.icofont-microphone-alt:before {\n  content: \"\\eb09\";\n}\n\n.icofont-monitor:before {\n  content: \"\\eb0a\";\n}\n\n.icofont-mouse:before {\n  content: \"\\eb0b\";\n}\n\n.icofont-nintendo:before {\n  content: \"\\eb0c\";\n}\n\n.icofont-playstation:before {\n  content: \"\\eb0d\";\n}\n\n.icofont-psvita:before {\n  content: \"\\eb0e\";\n}\n\n.icofont-radio-mic:before {\n  content: \"\\eb0f\";\n}\n\n.icofont-refrigerator:before {\n  content: \"\\eb10\";\n}\n\n.icofont-samsung-galaxy:before {\n  content: \"\\eb11\";\n}\n\n.icofont-surface-tablet:before {\n  content: \"\\eb12\";\n}\n\n.icofont-washing-machine:before {\n  content: \"\\eb13\";\n}\n\n.icofont-wifi-router:before {\n  content: \"\\eb14\";\n}\n\n.icofont-wii-u:before {\n  content: \"\\eb15\";\n}\n\n.icofont-windows-lumia:before {\n  content: \"\\eb16\";\n}\n\n.icofont-wireless-mouse:before {\n  content: \"\\eb17\";\n}\n\n.icofont-xbox-360:before {\n  content: \"\\eb18\";\n}\n\n.icofont-arrow-down:before {\n  content: \"\\eb19\";\n}\n\n.icofont-arrow-left:before {\n  content: \"\\eb1a\";\n}\n\n.icofont-arrow-right:before {\n  content: \"\\eb1b\";\n}\n\n.icofont-arrow-up:before {\n  content: \"\\eb1c\";\n}\n\n.icofont-block-down:before {\n  content: \"\\eb1d\";\n}\n\n.icofont-block-left:before {\n  content: \"\\eb1e\";\n}\n\n.icofont-block-right:before {\n  content: \"\\eb1f\";\n}\n\n.icofont-block-up:before {\n  content: \"\\eb20\";\n}\n\n.icofont-bubble-down:before {\n  content: \"\\eb21\";\n}\n\n.icofont-bubble-left:before {\n  content: \"\\eb22\";\n}\n\n.icofont-bubble-right:before {\n  content: \"\\eb23\";\n}\n\n.icofont-bubble-up:before {\n  content: \"\\eb24\";\n}\n\n.icofont-caret-down:before {\n  content: \"\\eb25\";\n}\n\n.icofont-caret-left:before {\n  content: \"\\eb26\";\n}\n\n.icofont-caret-right:before {\n  content: \"\\eb27\";\n}\n\n.icofont-caret-up:before {\n  content: \"\\eb28\";\n}\n\n.icofont-circled-down:before {\n  content: \"\\eb29\";\n}\n\n.icofont-circled-left:before {\n  content: \"\\eb2a\";\n}\n\n.icofont-circled-right:before {\n  content: \"\\eb2b\";\n}\n\n.icofont-circled-up:before {\n  content: \"\\eb2c\";\n}\n\n.icofont-collapse:before {\n  content: \"\\eb2d\";\n}\n\n.icofont-cursor-drag:before {\n  content: \"\\eb2e\";\n}\n\n.icofont-curved-double-left:before {\n  content: \"\\eb2f\";\n}\n\n.icofont-curved-double-right:before {\n  content: \"\\eb30\";\n}\n\n.icofont-curved-down:before {\n  content: \"\\eb31\";\n}\n\n.icofont-curved-left:before {\n  content: \"\\eb32\";\n}\n\n.icofont-curved-right:before {\n  content: \"\\eb33\";\n}\n\n.icofont-curved-up:before {\n  content: \"\\eb34\";\n}\n\n.icofont-dotted-down:before {\n  content: \"\\eb35\";\n}\n\n.icofont-dotted-left:before {\n  content: \"\\eb36\";\n}\n\n.icofont-dotted-right:before {\n  content: \"\\eb37\";\n}\n\n.icofont-dotted-up:before {\n  content: \"\\eb38\";\n}\n\n.icofont-double-left:before {\n  content: \"\\eb39\";\n}\n\n.icofont-double-right:before {\n  content: \"\\eb3a\";\n}\n\n.icofont-drag:before {\n  content: \"\\eb3b\";\n}\n\n.icofont-drag1:before {\n  content: \"\\eb3c\";\n}\n\n.icofont-drag2:before {\n  content: \"\\eb3d\";\n}\n\n.icofont-drag3:before {\n  content: \"\\eb3e\";\n}\n\n.icofont-expand-alt:before {\n  content: \"\\eb3f\";\n}\n\n.icofont-hand-down:before {\n  content: \"\\eb40\";\n}\n\n.icofont-hand-drag:before {\n  content: \"\\eb41\";\n}\n\n.icofont-hand-drag1:before {\n  content: \"\\eb42\";\n}\n\n.icofont-hand-drag2:before {\n  content: \"\\eb43\";\n}\n\n.icofont-hand-drawn-alt-down:before {\n  content: \"\\eb44\";\n}\n\n.icofont-hand-drawn-alt-left:before {\n  content: \"\\eb45\";\n}\n\n.icofont-hand-drawn-alt-right:before {\n  content: \"\\eb46\";\n}\n\n.icofont-hand-drawn-alt-up:before {\n  content: \"\\eb47\";\n}\n\n.icofont-hand-drawn-down:before {\n  content: \"\\eb48\";\n}\n\n.icofont-hand-drawn-left:before {\n  content: \"\\eb49\";\n}\n\n.icofont-hand-drawn-right:before {\n  content: \"\\eb4a\";\n}\n\n.icofont-hand-drawn-up:before {\n  content: \"\\eb4b\";\n}\n\n.icofont-hand-left:before {\n  content: \"\\eb4c\";\n}\n\n.icofont-hand-right:before {\n  content: \"\\eb4d\";\n}\n\n.icofont-hand-up:before {\n  content: \"\\eb4e\";\n}\n\n.icofont-line-block-down:before {\n  content: \"\\eb4f\";\n}\n\n.icofont-line-block-left:before {\n  content: \"\\eb50\";\n}\n\n.icofont-line-block-right:before {\n  content: \"\\eb51\";\n}\n\n.icofont-line-block-up:before {\n  content: \"\\eb52\";\n}\n\n.icofont-long-arrow-down:before {\n  content: \"\\eb53\";\n}\n\n.icofont-long-arrow-left:before {\n  content: \"\\eb54\";\n}\n\n.icofont-long-arrow-right:before {\n  content: \"\\eb55\";\n}\n\n.icofont-long-arrow-up:before {\n  content: \"\\eb56\";\n}\n\n.icofont-rounded-collapse:before {\n  content: \"\\eb57\";\n}\n\n.icofont-rounded-double-left:before {\n  content: \"\\eb58\";\n}\n\n.icofont-rounded-double-right:before {\n  content: \"\\eb59\";\n}\n\n.icofont-rounded-down:before {\n  content: \"\\eb5a\";\n}\n\n.icofont-rounded-expand:before {\n  content: \"\\eb5b\";\n}\n\n.icofont-rounded-left-down:before {\n  content: \"\\eb5c\";\n}\n\n.icofont-rounded-left-up:before {\n  content: \"\\eb5d\";\n}\n\n.icofont-rounded-left:before {\n  content: \"\\eb5e\";\n}\n\n.icofont-rounded-right-down:before {\n  content: \"\\eb5f\";\n}\n\n.icofont-rounded-right-up:before {\n  content: \"\\eb60\";\n}\n\n.icofont-rounded-right:before {\n  content: \"\\eb61\";\n}\n\n.icofont-rounded-up:before {\n  content: \"\\eb62\";\n}\n\n.icofont-scroll-bubble-down:before {\n  content: \"\\eb63\";\n}\n\n.icofont-scroll-bubble-left:before {\n  content: \"\\eb64\";\n}\n\n.icofont-scroll-bubble-right:before {\n  content: \"\\eb65\";\n}\n\n.icofont-scroll-bubble-up:before {\n  content: \"\\eb66\";\n}\n\n.icofont-scroll-double-down:before {\n  content: \"\\eb67\";\n}\n\n.icofont-scroll-double-left:before {\n  content: \"\\eb68\";\n}\n\n.icofont-scroll-double-right:before {\n  content: \"\\eb69\";\n}\n\n.icofont-scroll-double-up:before {\n  content: \"\\eb6a\";\n}\n\n.icofont-scroll-down:before {\n  content: \"\\eb6b\";\n}\n\n.icofont-scroll-left:before {\n  content: \"\\eb6c\";\n}\n\n.icofont-scroll-long-down:before {\n  content: \"\\eb6d\";\n}\n\n.icofont-scroll-long-left:before {\n  content: \"\\eb6e\";\n}\n\n.icofont-scroll-long-right:before {\n  content: \"\\eb6f\";\n}\n\n.icofont-scroll-long-up:before {\n  content: \"\\eb70\";\n}\n\n.icofont-scroll-right:before {\n  content: \"\\eb71\";\n}\n\n.icofont-scroll-up:before {\n  content: \"\\eb72\";\n}\n\n.icofont-simple-down:before {\n  content: \"\\eb73\";\n}\n\n.icofont-simple-left-down:before {\n  content: \"\\eb74\";\n}\n\n.icofont-simple-left-up:before {\n  content: \"\\eb75\";\n}\n\n.icofont-simple-left:before {\n  content: \"\\eb76\";\n}\n\n.icofont-simple-right-down:before {\n  content: \"\\eb77\";\n}\n\n.icofont-simple-right-up:before {\n  content: \"\\eb78\";\n}\n\n.icofont-simple-right:before {\n  content: \"\\eb79\";\n}\n\n.icofont-simple-up:before {\n  content: \"\\eb7a\";\n}\n\n.icofont-square-down:before {\n  content: \"\\eb7b\";\n}\n\n.icofont-square-left:before {\n  content: \"\\eb7c\";\n}\n\n.icofont-square-right:before {\n  content: \"\\eb7d\";\n}\n\n.icofont-square-up:before {\n  content: \"\\eb7e\";\n}\n\n.icofont-stylish-down:before {\n  content: \"\\eb7f\";\n}\n\n.icofont-stylish-left:before {\n  content: \"\\eb80\";\n}\n\n.icofont-stylish-right:before {\n  content: \"\\eb81\";\n}\n\n.icofont-stylish-up:before {\n  content: \"\\eb82\";\n}\n\n.icofont-swoosh-down:before {\n  content: \"\\eb83\";\n}\n\n.icofont-swoosh-left:before {\n  content: \"\\eb84\";\n}\n\n.icofont-swoosh-right:before {\n  content: \"\\eb85\";\n}\n\n.icofont-swoosh-up:before {\n  content: \"\\eb86\";\n}\n\n.icofont-thin-double-left:before {\n  content: \"\\eb87\";\n}\n\n.icofont-thin-double-right:before {\n  content: \"\\eb88\";\n}\n\n.icofont-thin-down:before {\n  content: \"\\eb89\";\n}\n\n.icofont-thin-left:before {\n  content: \"\\eb8a\";\n}\n\n.icofont-thin-right:before {\n  content: \"\\eb8b\";\n}\n\n.icofont-thin-up:before {\n  content: \"\\eb8c\";\n}\n\n.icofont-atom:before {\n  content: \"\\eb8d\";\n}\n\n.icofont-award:before {\n  content: \"\\eb8e\";\n}\n\n.icofont-bell-alt:before {\n  content: \"\\eb8f\";\n}\n\n.icofont-book-alt:before {\n  content: \"\\eb90\";\n}\n\n.icofont-brainstorming:before {\n  content: \"\\eb91\";\n}\n\n.icofont-certificate-alt-1:before {\n  content: \"\\eb92\";\n}\n\n.icofont-certificate-alt-2:before {\n  content: \"\\eb93\";\n}\n\n.icofont-dna-alt-2:before {\n  content: \"\\eb94\";\n}\n\n.icofont-education:before {\n  content: \"\\eb95\";\n}\n\n.icofont-electron:before {\n  content: \"\\eb96\";\n}\n\n.icofont-fountain-pen:before {\n  content: \"\\eb97\";\n}\n\n.icofont-globe-alt:before {\n  content: \"\\eb98\";\n}\n\n.icofont-graduate-alt:before {\n  content: \"\\eb99\";\n}\n\n.icofont-group-students:before {\n  content: \"\\eb9a\";\n}\n\n.icofont-hat-alt:before {\n  content: \"\\eb9b\";\n}\n\n.icofont-hat:before {\n  content: \"\\eb9c\";\n}\n\n.icofont-instrument:before {\n  content: \"\\eb9d\";\n}\n\n.icofont-lamp-light:before {\n  content: \"\\eb9e\";\n}\n\n.icofont-microscope-alt:before {\n  content: \"\\eb9f\";\n}\n\n.icofont-paper:before {\n  content: \"\\eba0\";\n}\n\n.icofont-pen-alt-4:before {\n  content: \"\\eba1\";\n}\n\n.icofont-pen-nib:before {\n  content: \"\\eba2\";\n}\n\n.icofont-pencil-alt-5:before {\n  content: \"\\eba3\";\n}\n\n.icofont-quill-pen:before {\n  content: \"\\eba4\";\n}\n\n.icofont-read-book-alt:before {\n  content: \"\\eba5\";\n}\n\n.icofont-read-book:before {\n  content: \"\\eba6\";\n}\n\n.icofont-school-bag:before {\n  content: \"\\eba7\";\n}\n\n.icofont-school-bus:before {\n  content: \"\\eba8\";\n}\n\n.icofont-student-alt:before {\n  content: \"\\eba9\";\n}\n\n.icofont-student:before {\n  content: \"\\ebaa\";\n}\n\n.icofont-teacher:before {\n  content: \"\\ebab\";\n}\n\n.icofont-test-bulb:before {\n  content: \"\\ebac\";\n}\n\n.icofont-test-tube-alt:before {\n  content: \"\\ebad\";\n}\n\n.icofont-university:before {\n  content: \"\\ebae\";\n}\n\n.icofont-emo-angry:before {\n  content: \"\\ebaf\";\n}\n\n.icofont-emo-astonished:before {\n  content: \"\\ebb0\";\n}\n\n.icofont-emo-confounded:before {\n  content: \"\\ebb1\";\n}\n\n.icofont-emo-confused:before {\n  content: \"\\ebb2\";\n}\n\n.icofont-emo-crying:before {\n  content: \"\\ebb3\";\n}\n\n.icofont-emo-dizzy:before {\n  content: \"\\ebb4\";\n}\n\n.icofont-emo-expressionless:before {\n  content: \"\\ebb5\";\n}\n\n.icofont-emo-heart-eyes:before {\n  content: \"\\ebb6\";\n}\n\n.icofont-emo-laughing:before {\n  content: \"\\ebb7\";\n}\n\n.icofont-emo-nerd-smile:before {\n  content: \"\\ebb8\";\n}\n\n.icofont-emo-open-mouth:before {\n  content: \"\\ebb9\";\n}\n\n.icofont-emo-rage:before {\n  content: \"\\ebba\";\n}\n\n.icofont-emo-rolling-eyes:before {\n  content: \"\\ebbb\";\n}\n\n.icofont-emo-sad:before {\n  content: \"\\ebbc\";\n}\n\n.icofont-emo-simple-smile:before {\n  content: \"\\ebbd\";\n}\n\n.icofont-emo-slightly-smile:before {\n  content: \"\\ebbe\";\n}\n\n.icofont-emo-smirk:before {\n  content: \"\\ebbf\";\n}\n\n.icofont-emo-stuck-out-tongue:before {\n  content: \"\\ebc0\";\n}\n\n.icofont-emo-wink-smile:before {\n  content: \"\\ebc1\";\n}\n\n.icofont-emo-worried:before {\n  content: \"\\ebc2\";\n}\n\n.icofont-architecture-alt:before {\n  content: \"\\ebc3\";\n}\n\n.icofont-architecture:before {\n  content: \"\\ebc4\";\n}\n\n.icofont-barricade:before {\n  content: \"\\ebc5\";\n}\n\n.icofont-bricks:before {\n  content: \"\\ebc6\";\n}\n\n.icofont-calculations:before {\n  content: \"\\ebc7\";\n}\n\n.icofont-cement-mix:before {\n  content: \"\\ebc8\";\n}\n\n.icofont-cement-mixer:before {\n  content: \"\\ebc9\";\n}\n\n.icofont-danger-zone:before {\n  content: \"\\ebca\";\n}\n\n.icofont-drill:before {\n  content: \"\\ebcb\";\n}\n\n.icofont-eco-energy:before {\n  content: \"\\ebcc\";\n}\n\n.icofont-eco-environmen:before {\n  content: \"\\ebcd\";\n}\n\n.icofont-energy-air:before {\n  content: \"\\ebce\";\n}\n\n.icofont-energy-oil:before {\n  content: \"\\ebcf\";\n}\n\n.icofont-energy-savings:before {\n  content: \"\\ebd0\";\n}\n\n.icofont-energy-solar:before {\n  content: \"\\ebd1\";\n}\n\n.icofont-energy-water:before {\n  content: \"\\ebd2\";\n}\n\n.icofont-engineer:before {\n  content: \"\\ebd3\";\n}\n\n.icofont-fire-extinguisher-alt:before {\n  content: \"\\ebd4\";\n}\n\n.icofont-fix-tools:before {\n  content: \"\\ebd5\";\n}\n\n.icofont-glue-oil:before {\n  content: \"\\ebd6\";\n}\n\n.icofont-hammer-alt:before {\n  content: \"\\ebd7\";\n}\n\n.icofont-help-robot:before {\n  content: \"\\ebd8\";\n}\n\n.icofont-industries-alt-1:before {\n  content: \"\\ebd9\";\n}\n\n.icofont-industries-alt-2:before {\n  content: \"\\ebda\";\n}\n\n.icofont-industries-alt-3:before {\n  content: \"\\ebdb\";\n}\n\n.icofont-industries-alt-4:before {\n  content: \"\\ebdc\";\n}\n\n.icofont-industries-alt-5:before {\n  content: \"\\ebdd\";\n}\n\n.icofont-industries:before {\n  content: \"\\ebde\";\n}\n\n.icofont-labour:before {\n  content: \"\\ebdf\";\n}\n\n.icofont-mining:before {\n  content: \"\\ebe0\";\n}\n\n.icofont-paint-brush:before {\n  content: \"\\ebe1\";\n}\n\n.icofont-pollution:before {\n  content: \"\\ebe2\";\n}\n\n.icofont-power-zone:before {\n  content: \"\\ebe3\";\n}\n\n.icofont-radio-active:before {\n  content: \"\\ebe4\";\n}\n\n.icofont-recycle-alt:before {\n  content: \"\\ebe5\";\n}\n\n.icofont-recycling-man:before {\n  content: \"\\ebe6\";\n}\n\n.icofont-safety-hat-light:before {\n  content: \"\\ebe7\";\n}\n\n.icofont-safety-hat:before {\n  content: \"\\ebe8\";\n}\n\n.icofont-saw:before {\n  content: \"\\ebe9\";\n}\n\n.icofont-screw-driver:before {\n  content: \"\\ebea\";\n}\n\n.icofont-settings-alt:before {\n  content: \"\\ebeb\";\n}\n\n.icofont-tools-alt-1:before {\n  content: \"\\ebec\";\n}\n\n.icofont-tools-alt-2:before {\n  content: \"\\ebed\";\n}\n\n.icofont-tools-bag:before {\n  content: \"\\ebee\";\n}\n\n.icofont-trolley:before {\n  content: \"\\ebef\";\n}\n\n.icofont-trowel:before {\n  content: \"\\ebf0\";\n}\n\n.icofont-under-construction-alt:before {\n  content: \"\\ebf1\";\n}\n\n.icofont-under-construction:before {\n  content: \"\\ebf2\";\n}\n\n.icofont-vehicle-cement:before {\n  content: \"\\ebf3\";\n}\n\n.icofont-vehicle-crane:before {\n  content: \"\\ebf4\";\n}\n\n.icofont-vehicle-delivery-van:before {\n  content: \"\\ebf5\";\n}\n\n.icofont-vehicle-dozer:before {\n  content: \"\\ebf6\";\n}\n\n.icofont-vehicle-excavator:before {\n  content: \"\\ebf7\";\n}\n\n.icofont-vehicle-trucktor:before {\n  content: \"\\ebf8\";\n}\n\n.icofont-vehicle-wrecking:before {\n  content: \"\\ebf9\";\n}\n\n.icofont-worker-group:before {\n  content: \"\\ebfa\";\n}\n\n.icofont-worker:before {\n  content: \"\\ebfb\";\n}\n\n.icofont-wrench:before {\n  content: \"\\ebfc\";\n}\n\n.icofont-file-audio:before {\n  content: \"\\ebfd\";\n}\n\n.icofont-file-avi-mp4:before {\n  content: \"\\ebfe\";\n}\n\n.icofont-file-bmp:before {\n  content: \"\\ebff\";\n}\n\n.icofont-file-code:before {\n  content: \"\\ec00\";\n}\n\n.icofont-file-css:before {\n  content: \"\\ec01\";\n}\n\n.icofont-file-document:before {\n  content: \"\\ec02\";\n}\n\n.icofont-file-eps:before {\n  content: \"\\ec03\";\n}\n\n.icofont-file-excel:before {\n  content: \"\\ec04\";\n}\n\n.icofont-file-exe:before {\n  content: \"\\ec05\";\n}\n\n.icofont-file-file:before {\n  content: \"\\ec06\";\n}\n\n.icofont-file-flv:before {\n  content: \"\\ec07\";\n}\n\n.icofont-file-gif:before {\n  content: \"\\ec08\";\n}\n\n.icofont-file-html5:before {\n  content: \"\\ec09\";\n}\n\n.icofont-file-image:before {\n  content: \"\\ec0a\";\n}\n\n.icofont-file-iso:before {\n  content: \"\\ec0b\";\n}\n\n.icofont-file-java:before {\n  content: \"\\ec0c\";\n}\n\n.icofont-file-javascript:before {\n  content: \"\\ec0d\";\n}\n\n.icofont-file-jpg:before {\n  content: \"\\ec0e\";\n}\n\n.icofont-file-midi:before {\n  content: \"\\ec0f\";\n}\n\n.icofont-file-mov:before {\n  content: \"\\ec10\";\n}\n\n.icofont-file-mp3:before {\n  content: \"\\ec11\";\n}\n\n.icofont-file-pdf:before {\n  content: \"\\ec12\";\n}\n\n.icofont-file-php:before {\n  content: \"\\ec13\";\n}\n\n.icofont-file-png:before {\n  content: \"\\ec14\";\n}\n\n.icofont-file-powerpoint:before {\n  content: \"\\ec15\";\n}\n\n.icofont-file-presentation:before {\n  content: \"\\ec16\";\n}\n\n.icofont-file-psb:before {\n  content: \"\\ec17\";\n}\n\n.icofont-file-psd:before {\n  content: \"\\ec18\";\n}\n\n.icofont-file-python:before {\n  content: \"\\ec19\";\n}\n\n.icofont-file-ruby:before {\n  content: \"\\ec1a\";\n}\n\n.icofont-file-spreadsheet:before {\n  content: \"\\ec1b\";\n}\n\n.icofont-file-sql:before {\n  content: \"\\ec1c\";\n}\n\n.icofont-file-svg:before {\n  content: \"\\ec1d\";\n}\n\n.icofont-file-text:before {\n  content: \"\\ec1e\";\n}\n\n.icofont-file-tiff:before {\n  content: \"\\ec1f\";\n}\n\n.icofont-file-video:before {\n  content: \"\\ec20\";\n}\n\n.icofont-file-wave:before {\n  content: \"\\ec21\";\n}\n\n.icofont-file-wmv:before {\n  content: \"\\ec22\";\n}\n\n.icofont-file-word:before {\n  content: \"\\ec23\";\n}\n\n.icofont-file-zip:before {\n  content: \"\\ec24\";\n}\n\n.icofont-apple:before {\n  content: \"\\ec25\";\n}\n\n.icofont-arabian-coffee:before {\n  content: \"\\ec26\";\n}\n\n.icofont-artichoke:before {\n  content: \"\\ec27\";\n}\n\n.icofont-asparagus:before {\n  content: \"\\ec28\";\n}\n\n.icofont-avocado:before {\n  content: \"\\ec29\";\n}\n\n.icofont-baby-food:before {\n  content: \"\\ec2a\";\n}\n\n.icofont-banana:before {\n  content: \"\\ec2b\";\n}\n\n.icofont-bbq:before {\n  content: \"\\ec2c\";\n}\n\n.icofont-beans:before {\n  content: \"\\ec2d\";\n}\n\n.icofont-beer:before {\n  content: \"\\ec2e\";\n}\n\n.icofont-bell-pepper-capsicum:before {\n  content: \"\\ec2f\";\n}\n\n.icofont-birthday-cake:before {\n  content: \"\\ec30\";\n}\n\n.icofont-bread:before {\n  content: \"\\ec31\";\n}\n\n.icofont-broccoli:before {\n  content: \"\\ec32\";\n}\n\n.icofont-burger:before {\n  content: \"\\ec33\";\n}\n\n.icofont-cabbage:before {\n  content: \"\\ec34\";\n}\n\n.icofont-carrot:before {\n  content: \"\\ec35\";\n}\n\n.icofont-cauli-flower:before {\n  content: \"\\ec36\";\n}\n\n.icofont-cheese:before {\n  content: \"\\ec37\";\n}\n\n.icofont-chef:before {\n  content: \"\\ec38\";\n}\n\n.icofont-cherry:before {\n  content: \"\\ec39\";\n}\n\n.icofont-chicken-fry:before {\n  content: \"\\ec3a\";\n}\n\n.icofont-chicken:before {\n  content: \"\\ec3b\";\n}\n\n.icofont-cocktail:before {\n  content: \"\\ec3c\";\n}\n\n.icofont-coconut:before {\n  content: \"\\ec3d\";\n}\n\n.icofont-coffee-alt:before {\n  content: \"\\ec3e\";\n}\n\n.icofont-coffee-mug:before {\n  content: \"\\ec3f\";\n}\n\n.icofont-coffee-pot:before {\n  content: \"\\ec40\";\n}\n\n.icofont-cola:before {\n  content: \"\\ec41\";\n}\n\n.icofont-corn:before {\n  content: \"\\ec42\";\n}\n\n.icofont-croissant:before {\n  content: \"\\ec43\";\n}\n\n.icofont-crop-plant:before {\n  content: \"\\ec44\";\n}\n\n.icofont-cucumber:before {\n  content: \"\\ec45\";\n}\n\n.icofont-cup-cake:before {\n  content: \"\\ec46\";\n}\n\n.icofont-dining-table:before {\n  content: \"\\ec47\";\n}\n\n.icofont-donut:before {\n  content: \"\\ec48\";\n}\n\n.icofont-egg-plant:before {\n  content: \"\\ec49\";\n}\n\n.icofont-egg-poached:before {\n  content: \"\\ec4a\";\n}\n\n.icofont-farmer:before {\n  content: \"\\ec4b\";\n}\n\n.icofont-farmer1:before {\n  content: \"\\ec4c\";\n}\n\n.icofont-fast-food:before {\n  content: \"\\ec4d\";\n}\n\n.icofont-fish:before {\n  content: \"\\ec4e\";\n}\n\n.icofont-food-basket:before {\n  content: \"\\ec4f\";\n}\n\n.icofont-food-cart:before {\n  content: \"\\ec50\";\n}\n\n.icofont-fork-and-knife:before {\n  content: \"\\ec51\";\n}\n\n.icofont-french-fries:before {\n  content: \"\\ec52\";\n}\n\n.icofont-fresh-juice:before {\n  content: \"\\ec53\";\n}\n\n.icofont-fruits:before {\n  content: \"\\ec54\";\n}\n\n.icofont-grapes:before {\n  content: \"\\ec55\";\n}\n\n.icofont-honey:before {\n  content: \"\\ec56\";\n}\n\n.icofont-hot-dog:before {\n  content: \"\\ec57\";\n}\n\n.icofont-hotel-alt:before {\n  content: \"\\ec58\";\n}\n\n.icofont-ice-cream-alt:before {\n  content: \"\\ec59\";\n}\n\n.icofont-ice-cream:before {\n  content: \"\\ec5a\";\n}\n\n.icofont-ketchup:before {\n  content: \"\\ec5b\";\n}\n\n.icofont-kiwi:before {\n  content: \"\\ec5c\";\n}\n\n.icofont-layered-cake:before {\n  content: \"\\ec5d\";\n}\n\n.icofont-lemon-alt:before {\n  content: \"\\ec5e\";\n}\n\n.icofont-lobster:before {\n  content: \"\\ec5f\";\n}\n\n.icofont-mango:before {\n  content: \"\\ec60\";\n}\n\n.icofont-milk:before {\n  content: \"\\ec61\";\n}\n\n.icofont-mushroom:before {\n  content: \"\\ec62\";\n}\n\n.icofont-noodles:before {\n  content: \"\\ec63\";\n}\n\n.icofont-onion:before {\n  content: \"\\ec64\";\n}\n\n.icofont-orange:before {\n  content: \"\\ec65\";\n}\n\n.icofont-pear:before {\n  content: \"\\ec66\";\n}\n\n.icofont-peas:before {\n  content: \"\\ec67\";\n}\n\n.icofont-pepper:before {\n  content: \"\\ec68\";\n}\n\n.icofont-pie-alt:before {\n  content: \"\\ec69\";\n}\n\n.icofont-pineapple:before {\n  content: \"\\ec6a\";\n}\n\n.icofont-pizza-slice:before {\n  content: \"\\ec6b\";\n}\n\n.icofont-pizza:before {\n  content: \"\\ec6c\";\n}\n\n.icofont-plant:before {\n  content: \"\\ec6d\";\n}\n\n.icofont-popcorn:before {\n  content: \"\\ec6e\";\n}\n\n.icofont-potato:before {\n  content: \"\\ec6f\";\n}\n\n.icofont-pumpkin:before {\n  content: \"\\ec70\";\n}\n\n.icofont-raddish:before {\n  content: \"\\ec71\";\n}\n\n.icofont-restaurant-menu:before {\n  content: \"\\ec72\";\n}\n\n.icofont-restaurant:before {\n  content: \"\\ec73\";\n}\n\n.icofont-salt-and-pepper:before {\n  content: \"\\ec74\";\n}\n\n.icofont-sandwich:before {\n  content: \"\\ec75\";\n}\n\n.icofont-sausage:before {\n  content: \"\\ec76\";\n}\n\n.icofont-shrimp:before {\n  content: \"\\ec77\";\n}\n\n.icofont-sof-drinks:before {\n  content: \"\\ec78\";\n}\n\n.icofont-soup-bowl:before {\n  content: \"\\ec79\";\n}\n\n.icofont-spoon-and-fork:before {\n  content: \"\\ec7a\";\n}\n\n.icofont-steak:before {\n  content: \"\\ec7b\";\n}\n\n.icofont-strawberry:before {\n  content: \"\\ec7c\";\n}\n\n.icofont-sub-sandwich:before {\n  content: \"\\ec7d\";\n}\n\n.icofont-sushi:before {\n  content: \"\\ec7e\";\n}\n\n.icofont-taco:before {\n  content: \"\\ec7f\";\n}\n\n.icofont-tea-pot:before {\n  content: \"\\ec80\";\n}\n\n.icofont-tea:before {\n  content: \"\\ec81\";\n}\n\n.icofont-tomato:before {\n  content: \"\\ec82\";\n}\n\n.icofont-waiter-alt:before {\n  content: \"\\ec83\";\n}\n\n.icofont-watermelon:before {\n  content: \"\\ec84\";\n}\n\n.icofont-wheat:before {\n  content: \"\\ec85\";\n}\n\n.icofont-abc:before {\n  content: \"\\ec86\";\n}\n\n.icofont-baby-cloth:before {\n  content: \"\\ec87\";\n}\n\n.icofont-baby-milk-bottle:before {\n  content: \"\\ec88\";\n}\n\n.icofont-baby-trolley:before {\n  content: \"\\ec89\";\n}\n\n.icofont-back-pack:before {\n  content: \"\\ec8a\";\n}\n\n.icofont-candy:before {\n  content: \"\\ec8b\";\n}\n\n.icofont-cycling:before {\n  content: \"\\ec8c\";\n}\n\n.icofont-holding-hands:before {\n  content: \"\\ec8d\";\n}\n\n.icofont-infant-nipple:before {\n  content: \"\\ec8e\";\n}\n\n.icofont-kids-scooter:before {\n  content: \"\\ec8f\";\n}\n\n.icofont-safety-pin:before {\n  content: \"\\ec90\";\n}\n\n.icofont-teddy-bear:before {\n  content: \"\\ec91\";\n}\n\n.icofont-toy-ball:before {\n  content: \"\\ec92\";\n}\n\n.icofont-toy-cat:before {\n  content: \"\\ec93\";\n}\n\n.icofont-toy-duck:before {\n  content: \"\\ec94\";\n}\n\n.icofont-toy-elephant:before {\n  content: \"\\ec95\";\n}\n\n.icofont-toy-hand:before {\n  content: \"\\ec96\";\n}\n\n.icofont-toy-horse:before {\n  content: \"\\ec97\";\n}\n\n.icofont-toy-lattu:before {\n  content: \"\\ec98\";\n}\n\n.icofont-toy-train:before {\n  content: \"\\ec99\";\n}\n\n.icofont-unique-idea:before {\n  content: \"\\ec9a\";\n}\n\n.icofont-bag-alt:before {\n  content: \"\\ec9b\";\n}\n\n.icofont-burglar:before {\n  content: \"\\ec9c\";\n}\n\n.icofont-cannon-firing:before {\n  content: \"\\ec9d\";\n}\n\n.icofont-cc-camera:before {\n  content: \"\\ec9e\";\n}\n\n.icofont-cop-badge:before {\n  content: \"\\ec9f\";\n}\n\n.icofont-cop:before {\n  content: \"\\eca0\";\n}\n\n.icofont-court-hammer:before {\n  content: \"\\eca1\";\n}\n\n.icofont-court:before {\n  content: \"\\eca2\";\n}\n\n.icofont-finger-print:before {\n  content: \"\\eca3\";\n}\n\n.icofont-handcuff-alt:before {\n  content: \"\\eca4\";\n}\n\n.icofont-handcuff:before {\n  content: \"\\eca5\";\n}\n\n.icofont-investigation:before {\n  content: \"\\eca6\";\n}\n\n.icofont-investigator:before {\n  content: \"\\eca7\";\n}\n\n.icofont-jail:before {\n  content: \"\\eca8\";\n}\n\n.icofont-judge:before {\n  content: \"\\eca9\";\n}\n\n.icofont-law-alt-1:before {\n  content: \"\\ecaa\";\n}\n\n.icofont-law-alt-2:before {\n  content: \"\\ecab\";\n}\n\n.icofont-law-alt-3:before {\n  content: \"\\ecac\";\n}\n\n.icofont-law-book:before {\n  content: \"\\ecad\";\n}\n\n.icofont-law-document:before {\n  content: \"\\ecae\";\n}\n\n.icofont-law:before {\n  content: \"\\ecaf\";\n}\n\n.icofont-lawyer-alt-1:before {\n  content: \"\\ecb0\";\n}\n\n.icofont-lawyer-alt-2:before {\n  content: \"\\ecb1\";\n}\n\n.icofont-lawyer:before {\n  content: \"\\ecb2\";\n}\n\n.icofont-order:before {\n  content: \"\\ecb3\";\n}\n\n.icofont-pistol:before {\n  content: \"\\ecb4\";\n}\n\n.icofont-police-badge:before {\n  content: \"\\ecb5\";\n}\n\n.icofont-police-cap:before {\n  content: \"\\ecb6\";\n}\n\n.icofont-police-car-alt-1:before {\n  content: \"\\ecb7\";\n}\n\n.icofont-police-car-alt-2:before {\n  content: \"\\ecb8\";\n}\n\n.icofont-police-hat:before {\n  content: \"\\ecb9\";\n}\n\n.icofont-police-van:before {\n  content: \"\\ecba\";\n}\n\n.icofont-police:before {\n  content: \"\\ecbb\";\n}\n\n.icofont-protect:before {\n  content: \"\\ecbc\";\n}\n\n.icofont-scales:before {\n  content: \"\\ecbd\";\n}\n\n.icofont-thief-alt:before {\n  content: \"\\ecbe\";\n}\n\n.icofont-thief:before {\n  content: \"\\ecbf\";\n}\n\n.icofont-abacus-alt:before {\n  content: \"\\ecc0\";\n}\n\n.icofont-abacus:before {\n  content: \"\\ecc1\";\n}\n\n.icofont-angle:before {\n  content: \"\\ecc2\";\n}\n\n.icofont-calculator-alt-1:before {\n  content: \"\\ecc3\";\n}\n\n.icofont-calculator-alt-2:before {\n  content: \"\\ecc4\";\n}\n\n.icofont-circle-ruler-alt:before {\n  content: \"\\ecc5\";\n}\n\n.icofont-circle-ruler:before {\n  content: \"\\ecc6\";\n}\n\n.icofont-compass-alt-1:before {\n  content: \"\\ecc7\";\n}\n\n.icofont-compass-alt-2:before {\n  content: \"\\ecc8\";\n}\n\n.icofont-compass-alt-3:before {\n  content: \"\\ecc9\";\n}\n\n.icofont-compass-alt-4:before {\n  content: \"\\ecca\";\n}\n\n.icofont-degrees-alt-1:before {\n  content: \"\\eccb\";\n}\n\n.icofont-degrees-alt-2:before {\n  content: \"\\eccc\";\n}\n\n.icofont-degrees:before {\n  content: \"\\eccd\";\n}\n\n.icofont-golden-ratio:before {\n  content: \"\\ecce\";\n}\n\n.icofont-marker-alt-1:before {\n  content: \"\\eccf\";\n}\n\n.icofont-marker-alt-2:before {\n  content: \"\\ecd0\";\n}\n\n.icofont-marker-alt-3:before {\n  content: \"\\ecd1\";\n}\n\n.icofont-mathematical-alt-1:before {\n  content: \"\\ecd2\";\n}\n\n.icofont-mathematical-alt-2:before {\n  content: \"\\ecd3\";\n}\n\n.icofont-mathematical:before {\n  content: \"\\ecd4\";\n}\n\n.icofont-pen-alt-1:before {\n  content: \"\\ecd5\";\n}\n\n.icofont-pen-alt-2:before {\n  content: \"\\ecd6\";\n}\n\n.icofont-pen-alt-3:before {\n  content: \"\\ecd7\";\n}\n\n.icofont-pen-holder-alt-1:before {\n  content: \"\\ecd8\";\n}\n\n.icofont-pen-holder:before {\n  content: \"\\ecd9\";\n}\n\n.icofont-pencil-alt-1:before {\n  content: \"\\ecda\";\n}\n\n.icofont-pencil-alt-2:before {\n  content: \"\\ecdb\";\n}\n\n.icofont-pencil-alt-3:before {\n  content: \"\\ecdc\";\n}\n\n.icofont-pencil-alt-4:before {\n  content: \"\\ecdd\";\n}\n\n.icofont-ruler-alt-1:before {\n  content: \"\\ecde\";\n}\n\n.icofont-ruler-alt-2:before {\n  content: \"\\ecdf\";\n}\n\n.icofont-ruler-compass-alt:before {\n  content: \"\\ece0\";\n}\n\n.icofont-ruler-compass:before {\n  content: \"\\ece1\";\n}\n\n.icofont-ruler-pencil-alt-1:before {\n  content: \"\\ece2\";\n}\n\n.icofont-ruler-pencil-alt-2:before {\n  content: \"\\ece3\";\n}\n\n.icofont-ruler-pencil:before {\n  content: \"\\ece4\";\n}\n\n.icofont-ruler:before {\n  content: \"\\ece5\";\n}\n\n.icofont-rulers-alt:before {\n  content: \"\\ece6\";\n}\n\n.icofont-rulers:before {\n  content: \"\\ece7\";\n}\n\n.icofont-square-root:before {\n  content: \"\\ece8\";\n}\n\n.icofont-aids:before {\n  content: \"\\ece9\";\n}\n\n.icofont-ambulance:before {\n  content: \"\\ecea\";\n}\n\n.icofont-autism:before {\n  content: \"\\eceb\";\n}\n\n.icofont-bandage:before {\n  content: \"\\ecec\";\n}\n\n.icofont-bed-patient:before {\n  content: \"\\eced\";\n}\n\n.icofont-blind:before {\n  content: \"\\ecee\";\n}\n\n.icofont-blood-drop:before {\n  content: \"\\ecef\";\n}\n\n.icofont-blood-test:before {\n  content: \"\\ecf0\";\n}\n\n.icofont-blood:before {\n  content: \"\\ecf1\";\n}\n\n.icofont-capsule:before {\n  content: \"\\ecf2\";\n}\n\n.icofont-crutches:before {\n  content: \"\\ecf3\";\n}\n\n.icofont-dna-alt-1:before {\n  content: \"\\ecf4\";\n}\n\n.icofont-dna:before {\n  content: \"\\ecf5\";\n}\n\n.icofont-doctor-alt:before {\n  content: \"\\ecf6\";\n}\n\n.icofont-doctor:before {\n  content: \"\\ecf7\";\n}\n\n.icofont-drug-pack:before {\n  content: \"\\ecf8\";\n}\n\n.icofont-drug:before {\n  content: \"\\ecf9\";\n}\n\n.icofont-eye-alt:before {\n  content: \"\\ecfa\";\n}\n\n.icofont-first-aid-alt:before {\n  content: \"\\ecfb\";\n}\n\n.icofont-garbage:before {\n  content: \"\\ecfc\";\n}\n\n.icofont-heart-alt:before {\n  content: \"\\ecfd\";\n}\n\n.icofont-heartbeat:before {\n  content: \"\\ecfe\";\n}\n\n.icofont-herbal:before {\n  content: \"\\ecff\";\n}\n\n.icofont-hospital:before {\n  content: \"\\ed00\";\n}\n\n.icofont-icu:before {\n  content: \"\\ed01\";\n}\n\n.icofont-injection-syringe:before {\n  content: \"\\ed02\";\n}\n\n.icofont-laboratory:before {\n  content: \"\\ed03\";\n}\n\n.icofont-medical-sign-alt:before {\n  content: \"\\ed04\";\n}\n\n.icofont-medical-sign:before {\n  content: \"\\ed05\";\n}\n\n.icofont-nurse-alt:before {\n  content: \"\\ed06\";\n}\n\n.icofont-nurse:before {\n  content: \"\\ed07\";\n}\n\n.icofont-nursing-home:before {\n  content: \"\\ed08\";\n}\n\n.icofont-operation-theater:before {\n  content: \"\\ed09\";\n}\n\n.icofont-paralysis-disability:before {\n  content: \"\\ed0a\";\n}\n\n.icofont-pills:before {\n  content: \"\\ed0b\";\n}\n\n.icofont-prescription:before {\n  content: \"\\ed0c\";\n}\n\n.icofont-pulse:before {\n  content: \"\\ed0d\";\n}\n\n.icofont-stethoscope-alt:before {\n  content: \"\\ed0e\";\n}\n\n.icofont-stethoscope:before {\n  content: \"\\ed0f\";\n}\n\n.icofont-stretcher:before {\n  content: \"\\ed10\";\n}\n\n.icofont-surgeon-alt:before {\n  content: \"\\ed11\";\n}\n\n.icofont-surgeon:before {\n  content: \"\\ed12\";\n}\n\n.icofont-tablets:before {\n  content: \"\\ed13\";\n}\n\n.icofont-test-bottle:before {\n  content: \"\\ed14\";\n}\n\n.icofont-test-tube:before {\n  content: \"\\ed15\";\n}\n\n.icofont-thermometer-alt:before {\n  content: \"\\ed16\";\n}\n\n.icofont-tooth:before {\n  content: \"\\ed17\";\n}\n\n.icofont-xray:before {\n  content: \"\\ed18\";\n}\n\n.icofont-ui-add:before {\n  content: \"\\ed19\";\n}\n\n.icofont-ui-alarm:before {\n  content: \"\\ed1a\";\n}\n\n.icofont-ui-battery:before {\n  content: \"\\ed1b\";\n}\n\n.icofont-ui-block:before {\n  content: \"\\ed1c\";\n}\n\n.icofont-ui-bluetooth:before {\n  content: \"\\ed1d\";\n}\n\n.icofont-ui-brightness:before {\n  content: \"\\ed1e\";\n}\n\n.icofont-ui-browser:before {\n  content: \"\\ed1f\";\n}\n\n.icofont-ui-calculator:before {\n  content: \"\\ed20\";\n}\n\n.icofont-ui-calendar:before {\n  content: \"\\ed21\";\n}\n\n.icofont-ui-call:before {\n  content: \"\\ed22\";\n}\n\n.icofont-ui-camera:before {\n  content: \"\\ed23\";\n}\n\n.icofont-ui-cart:before {\n  content: \"\\ed24\";\n}\n\n.icofont-ui-cell-phone:before {\n  content: \"\\ed25\";\n}\n\n.icofont-ui-chat:before {\n  content: \"\\ed26\";\n}\n\n.icofont-ui-check:before {\n  content: \"\\ed27\";\n}\n\n.icofont-ui-clip-board:before {\n  content: \"\\ed28\";\n}\n\n.icofont-ui-clip:before {\n  content: \"\\ed29\";\n}\n\n.icofont-ui-clock:before {\n  content: \"\\ed2a\";\n}\n\n.icofont-ui-close:before {\n  content: \"\\ed2b\";\n}\n\n.icofont-ui-contact-list:before {\n  content: \"\\ed2c\";\n}\n\n.icofont-ui-copy:before {\n  content: \"\\ed2d\";\n}\n\n.icofont-ui-cut:before {\n  content: \"\\ed2e\";\n}\n\n.icofont-ui-delete:before {\n  content: \"\\ed2f\";\n}\n\n.icofont-ui-dial-phone:before {\n  content: \"\\ed30\";\n}\n\n.icofont-ui-edit:before {\n  content: \"\\ed31\";\n}\n\n.icofont-ui-email:before {\n  content: \"\\ed32\";\n}\n\n.icofont-ui-file:before {\n  content: \"\\ed33\";\n}\n\n.icofont-ui-fire-wall:before {\n  content: \"\\ed34\";\n}\n\n.icofont-ui-flash-light:before {\n  content: \"\\ed35\";\n}\n\n.icofont-ui-flight:before {\n  content: \"\\ed36\";\n}\n\n.icofont-ui-folder:before {\n  content: \"\\ed37\";\n}\n\n.icofont-ui-game:before {\n  content: \"\\ed38\";\n}\n\n.icofont-ui-handicapped:before {\n  content: \"\\ed39\";\n}\n\n.icofont-ui-head-phone:before {\n  content: \"\\ed3a\";\n}\n\n.icofont-ui-home:before {\n  content: \"\\ed3b\";\n}\n\n.icofont-ui-image:before {\n  content: \"\\ed3c\";\n}\n\n.icofont-ui-keyboard:before {\n  content: \"\\ed3d\";\n}\n\n.icofont-ui-laoding:before {\n  content: \"\\ed3e\";\n}\n\n.icofont-ui-lock:before {\n  content: \"\\ed3f\";\n}\n\n.icofont-ui-love-add:before {\n  content: \"\\ed40\";\n}\n\n.icofont-ui-love-broken:before {\n  content: \"\\ed41\";\n}\n\n.icofont-ui-love-remove:before {\n  content: \"\\ed42\";\n}\n\n.icofont-ui-love:before {\n  content: \"\\ed43\";\n}\n\n.icofont-ui-map:before {\n  content: \"\\ed44\";\n}\n\n.icofont-ui-message:before {\n  content: \"\\ed45\";\n}\n\n.icofont-ui-messaging:before {\n  content: \"\\ed46\";\n}\n\n.icofont-ui-movie:before {\n  content: \"\\ed47\";\n}\n\n.icofont-ui-music-player:before {\n  content: \"\\ed48\";\n}\n\n.icofont-ui-music:before {\n  content: \"\\ed49\";\n}\n\n.icofont-ui-mute:before {\n  content: \"\\ed4a\";\n}\n\n.icofont-ui-network:before {\n  content: \"\\ed4b\";\n}\n\n.icofont-ui-next:before {\n  content: \"\\ed4c\";\n}\n\n.icofont-ui-note:before {\n  content: \"\\ed4d\";\n}\n\n.icofont-ui-office:before {\n  content: \"\\ed4e\";\n}\n\n.icofont-ui-password:before {\n  content: \"\\ed4f\";\n}\n\n.icofont-ui-pause:before {\n  content: \"\\ed50\";\n}\n\n.icofont-ui-play-stop:before {\n  content: \"\\ed51\";\n}\n\n.icofont-ui-play:before {\n  content: \"\\ed52\";\n}\n\n.icofont-ui-pointer:before {\n  content: \"\\ed53\";\n}\n\n.icofont-ui-power:before {\n  content: \"\\ed54\";\n}\n\n.icofont-ui-press:before {\n  content: \"\\ed55\";\n}\n\n.icofont-ui-previous:before {\n  content: \"\\ed56\";\n}\n\n.icofont-ui-rate-add:before {\n  content: \"\\ed57\";\n}\n\n.icofont-ui-rate-blank:before {\n  content: \"\\ed58\";\n}\n\n.icofont-ui-rate-remove:before {\n  content: \"\\ed59\";\n}\n\n.icofont-ui-rating:before {\n  content: \"\\ed5a\";\n}\n\n.icofont-ui-record:before {\n  content: \"\\ed5b\";\n}\n\n.icofont-ui-remove:before {\n  content: \"\\ed5c\";\n}\n\n.icofont-ui-reply:before {\n  content: \"\\ed5d\";\n}\n\n.icofont-ui-rotation:before {\n  content: \"\\ed5e\";\n}\n\n.icofont-ui-rss:before {\n  content: \"\\ed5f\";\n}\n\n.icofont-ui-search:before {\n  content: \"\\ed60\";\n}\n\n.icofont-ui-settings:before {\n  content: \"\\ed61\";\n}\n\n.icofont-ui-social-link:before {\n  content: \"\\ed62\";\n}\n\n.icofont-ui-tag:before {\n  content: \"\\ed63\";\n}\n\n.icofont-ui-text-chat:before {\n  content: \"\\ed64\";\n}\n\n.icofont-ui-text-loading:before {\n  content: \"\\ed65\";\n}\n\n.icofont-ui-theme:before {\n  content: \"\\ed66\";\n}\n\n.icofont-ui-timer:before {\n  content: \"\\ed67\";\n}\n\n.icofont-ui-touch-phone:before {\n  content: \"\\ed68\";\n}\n\n.icofont-ui-travel:before {\n  content: \"\\ed69\";\n}\n\n.icofont-ui-unlock:before {\n  content: \"\\ed6a\";\n}\n\n.icofont-ui-user-group:before {\n  content: \"\\ed6b\";\n}\n\n.icofont-ui-user:before {\n  content: \"\\ed6c\";\n}\n\n.icofont-ui-v-card:before {\n  content: \"\\ed6d\";\n}\n\n.icofont-ui-video-chat:before {\n  content: \"\\ed6e\";\n}\n\n.icofont-ui-video-message:before {\n  content: \"\\ed6f\";\n}\n\n.icofont-ui-video-play:before {\n  content: \"\\ed70\";\n}\n\n.icofont-ui-video:before {\n  content: \"\\ed71\";\n}\n\n.icofont-ui-volume:before {\n  content: \"\\ed72\";\n}\n\n.icofont-ui-weather:before {\n  content: \"\\ed73\";\n}\n\n.icofont-ui-wifi:before {\n  content: \"\\ed74\";\n}\n\n.icofont-ui-zoom-in:before {\n  content: \"\\ed75\";\n}\n\n.icofont-ui-zoom-out:before {\n  content: \"\\ed76\";\n}\n\n.icofont-cassette-player:before {\n  content: \"\\ed77\";\n}\n\n.icofont-cassette:before {\n  content: \"\\ed78\";\n}\n\n.icofont-forward:before {\n  content: \"\\ed79\";\n}\n\n.icofont-game:before {\n  content: \"\\ed7a\";\n}\n\n.icofont-guiter:before {\n  content: \"\\ed7b\";\n}\n\n.icofont-headphone-alt-1:before {\n  content: \"\\ed7c\";\n}\n\n.icofont-headphone-alt-2:before {\n  content: \"\\ed7d\";\n}\n\n.icofont-headphone-alt-3:before {\n  content: \"\\ed7e\";\n}\n\n.icofont-listening:before {\n  content: \"\\ed7f\";\n}\n\n.icofont-megaphone-alt:before {\n  content: \"\\ed80\";\n}\n\n.icofont-megaphone:before {\n  content: \"\\ed81\";\n}\n\n.icofont-movie:before {\n  content: \"\\ed82\";\n}\n\n.icofont-mp3-player:before {\n  content: \"\\ed83\";\n}\n\n.icofont-multimedia:before {\n  content: \"\\ed84\";\n}\n\n.icofont-music-disk:before {\n  content: \"\\ed85\";\n}\n\n.icofont-music-note:before {\n  content: \"\\ed86\";\n}\n\n.icofont-pause:before {\n  content: \"\\ed87\";\n}\n\n.icofont-play-alt-1:before {\n  content: \"\\ed88\";\n}\n\n.icofont-play-alt-2:before {\n  content: \"\\ed89\";\n}\n\n.icofont-play-alt-3:before {\n  content: \"\\ed8a\";\n}\n\n.icofont-play-pause:before {\n  content: \"\\ed8b\";\n}\n\n.icofont-record:before {\n  content: \"\\ed8c\";\n}\n\n.icofont-retro-music-disk:before {\n  content: \"\\ed8d\";\n}\n\n.icofont-rewind:before {\n  content: \"\\ed8e\";\n}\n\n.icofont-song-notes:before {\n  content: \"\\ed8f\";\n}\n\n.icofont-sound-wave-alt:before {\n  content: \"\\ed90\";\n}\n\n.icofont-sound-wave:before {\n  content: \"\\ed91\";\n}\n\n.icofont-stop:before {\n  content: \"\\ed92\";\n}\n\n.icofont-video-alt:before {\n  content: \"\\ed93\";\n}\n\n.icofont-video-cam:before {\n  content: \"\\ed94\";\n}\n\n.icofont-volume-bar:before {\n  content: \"\\ed95\";\n}\n\n.icofont-volume-mute:before {\n  content: \"\\ed96\";\n}\n\n.icofont-youtube-play:before {\n  content: \"\\ed97\";\n}\n\n.icofont-amazon-alt:before {\n  content: \"\\ed98\";\n}\n\n.icofont-amazon:before {\n  content: \"\\ed99\";\n}\n\n.icofont-american-express-alt:before {\n  content: \"\\ed9a\";\n}\n\n.icofont-american-express:before {\n  content: \"\\ed9b\";\n}\n\n.icofont-apple-pay-alt:before {\n  content: \"\\ed9c\";\n}\n\n.icofont-apple-pay:before {\n  content: \"\\ed9d\";\n}\n\n.icofont-bank-transfer-alt:before {\n  content: \"\\ed9e\";\n}\n\n.icofont-bank-transfer:before {\n  content: \"\\ed9f\";\n}\n\n.icofont-braintree-alt:before {\n  content: \"\\eda0\";\n}\n\n.icofont-braintree:before {\n  content: \"\\eda1\";\n}\n\n.icofont-cash-on-delivery-alt:before {\n  content: \"\\eda2\";\n}\n\n.icofont-cash-on-delivery:before {\n  content: \"\\eda3\";\n}\n\n.icofont-checkout-alt:before {\n  content: \"\\eda4\";\n}\n\n.icofont-checkout:before {\n  content: \"\\eda5\";\n}\n\n.icofont-diners-club-alt-1:before {\n  content: \"\\eda6\";\n}\n\n.icofont-diners-club-alt-2:before {\n  content: \"\\eda7\";\n}\n\n.icofont-diners-club-alt-3:before {\n  content: \"\\eda8\";\n}\n\n.icofont-diners-club:before {\n  content: \"\\eda9\";\n}\n\n.icofont-discover-alt:before {\n  content: \"\\edaa\";\n}\n\n.icofont-discover:before {\n  content: \"\\edab\";\n}\n\n.icofont-eway-alt:before {\n  content: \"\\edac\";\n}\n\n.icofont-eway:before {\n  content: \"\\edad\";\n}\n\n.icofont-google-wallet-alt-1:before {\n  content: \"\\edae\";\n}\n\n.icofont-google-wallet-alt-2:before {\n  content: \"\\edaf\";\n}\n\n.icofont-google-wallet-alt-3:before {\n  content: \"\\edb0\";\n}\n\n.icofont-google-wallet:before {\n  content: \"\\edb1\";\n}\n\n.icofont-jcb-alt:before {\n  content: \"\\edb2\";\n}\n\n.icofont-jcb:before {\n  content: \"\\edb3\";\n}\n\n.icofont-maestro-alt:before {\n  content: \"\\edb4\";\n}\n\n.icofont-maestro:before {\n  content: \"\\edb5\";\n}\n\n.icofont-mastercard-alt:before {\n  content: \"\\edb6\";\n}\n\n.icofont-mastercard:before {\n  content: \"\\edb7\";\n}\n\n.icofont-payoneer-alt:before {\n  content: \"\\edb8\";\n}\n\n.icofont-payoneer:before {\n  content: \"\\edb9\";\n}\n\n.icofont-paypal-alt:before {\n  content: \"\\edba\";\n}\n\n.icofont-paypal:before {\n  content: \"\\edbb\";\n}\n\n.icofont-sage-alt:before {\n  content: \"\\edbc\";\n}\n\n.icofont-sage:before {\n  content: \"\\edbd\";\n}\n\n.icofont-skrill-alt:before {\n  content: \"\\edbe\";\n}\n\n.icofont-skrill:before {\n  content: \"\\edbf\";\n}\n\n.icofont-stripe-alt:before {\n  content: \"\\edc0\";\n}\n\n.icofont-stripe:before {\n  content: \"\\edc1\";\n}\n\n.icofont-visa-alt:before {\n  content: \"\\edc2\";\n}\n\n.icofont-visa-electron:before {\n  content: \"\\edc3\";\n}\n\n.icofont-visa:before {\n  content: \"\\edc4\";\n}\n\n.icofont-western-union-alt:before {\n  content: \"\\edc5\";\n}\n\n.icofont-western-union:before {\n  content: \"\\edc6\";\n}\n\n.icofont-boy:before {\n  content: \"\\edc7\";\n}\n\n.icofont-business-man-alt-1:before {\n  content: \"\\edc8\";\n}\n\n.icofont-business-man-alt-2:before {\n  content: \"\\edc9\";\n}\n\n.icofont-business-man-alt-3:before {\n  content: \"\\edca\";\n}\n\n.icofont-business-man:before {\n  content: \"\\edcb\";\n}\n\n.icofont-funky-man:before {\n  content: \"\\edcc\";\n}\n\n.icofont-girl-alt:before {\n  content: \"\\edcd\";\n}\n\n.icofont-girl:before {\n  content: \"\\edce\";\n}\n\n.icofont-hotel-boy-alt:before {\n  content: \"\\edcf\";\n}\n\n.icofont-hotel-boy:before {\n  content: \"\\edd0\";\n}\n\n.icofont-man-in-glasses:before {\n  content: \"\\edd1\";\n}\n\n.icofont-user-alt-1:before {\n  content: \"\\edd2\";\n}\n\n.icofont-user-alt-2:before {\n  content: \"\\edd3\";\n}\n\n.icofont-user-alt-3:before {\n  content: \"\\edd4\";\n}\n\n.icofont-user-alt-4:before {\n  content: \"\\edd5\";\n}\n\n.icofont-user-alt-5:before {\n  content: \"\\edd6\";\n}\n\n.icofont-user-alt-6:before {\n  content: \"\\edd7\";\n}\n\n.icofont-user-alt-7:before {\n  content: \"\\edd8\";\n}\n\n.icofont-user-female:before {\n  content: \"\\edd9\";\n}\n\n.icofont-user-male:before {\n  content: \"\\edda\";\n}\n\n.icofont-user-suited:before {\n  content: \"\\eddb\";\n}\n\n.icofont-user:before {\n  content: \"\\eddc\";\n}\n\n.icofont-users-alt-1:before {\n  content: \"\\eddd\";\n}\n\n.icofont-users-alt-2:before {\n  content: \"\\edde\";\n}\n\n.icofont-users-alt-3:before {\n  content: \"\\eddf\";\n}\n\n.icofont-users-alt-4:before {\n  content: \"\\ede0\";\n}\n\n.icofont-users-alt-5:before {\n  content: \"\\ede1\";\n}\n\n.icofont-users-alt-6:before {\n  content: \"\\ede2\";\n}\n\n.icofont-users-social:before {\n  content: \"\\ede3\";\n}\n\n.icofont-users:before {\n  content: \"\\ede4\";\n}\n\n.icofont-waiter:before {\n  content: \"\\ede5\";\n}\n\n.icofont-woman-in-glasses:before {\n  content: \"\\ede6\";\n}\n\n.icofont-document-search:before {\n  content: \"\\ede7\";\n}\n\n.icofont-folder-search:before {\n  content: \"\\ede8\";\n}\n\n.icofont-home-search:before {\n  content: \"\\ede9\";\n}\n\n.icofont-job-search:before {\n  content: \"\\edea\";\n}\n\n.icofont-map-search:before {\n  content: \"\\edeb\";\n}\n\n.icofont-restaurant-search:before {\n  content: \"\\edec\";\n}\n\n.icofont-search-alt-1:before {\n  content: \"\\eded\";\n}\n\n.icofont-search-alt-2:before {\n  content: \"\\edee\";\n}\n\n.icofont-search:before {\n  content: \"\\edef\";\n}\n\n.icofont-stock-search:before {\n  content: \"\\edf0\";\n}\n\n.icofont-user-search:before {\n  content: \"\\edf1\";\n}\n\n.icofont-social-aim:before {\n  content: \"\\edf2\";\n}\n\n.icofont-social-badoo:before {\n  content: \"\\edf3\";\n}\n\n.icofont-social-bebo:before {\n  content: \"\\edf4\";\n}\n\n.icofont-social-behance:before {\n  content: \"\\edf5\";\n}\n\n.icofont-social-blogger:before {\n  content: \"\\edf6\";\n}\n\n.icofont-social-bootstrap:before {\n  content: \"\\edf7\";\n}\n\n.icofont-social-brightkite:before {\n  content: \"\\edf8\";\n}\n\n.icofont-social-cloudapp:before {\n  content: \"\\edf9\";\n}\n\n.icofont-social-concrete5:before {\n  content: \"\\edfa\";\n}\n\n.icofont-social-designbump:before {\n  content: \"\\edfb\";\n}\n\n.icofont-social-designfloat:before {\n  content: \"\\edfc\";\n}\n\n.icofont-social-deviantart:before {\n  content: \"\\edfd\";\n}\n\n.icofont-social-digg:before {\n  content: \"\\edfe\";\n}\n\n.icofont-social-dotcms:before {\n  content: \"\\edff\";\n}\n\n.icofont-social-dribble:before {\n  content: \"\\ee00\";\n}\n\n.icofont-social-dropbox:before {\n  content: \"\\ee01\";\n}\n\n.icofont-brand-drupal:before {\n  content: \"\\ee02\";\n}\n\n.icofont-social-ebuddy:before {\n  content: \"\\ee03\";\n}\n\n.icofont-social-ello:before {\n  content: \"\\ee04\";\n}\n\n.icofont-social-ember:before {\n  content: \"\\ee05\";\n}\n\n.icofont-social-envato:before {\n  content: \"\\ee06\";\n}\n\n.icofont-social-evernote:before {\n  content: \"\\ee07\";\n}\n\n.icofont-social-facebook:before {\n  content: \"\\ee08\";\n}\n\n.icofont-social-feedburner:before {\n  content: \"\\ee09\";\n}\n\n.icofont-social-folkd:before {\n  content: \"\\ee0a\";\n}\n\n.icofont-social-friendfeed:before {\n  content: \"\\ee0b\";\n}\n\n.icofont-social-ghost:before {\n  content: \"\\ee0c\";\n}\n\n.icofont-social-github:before {\n  content: \"\\ee0d\";\n}\n\n.icofont-social-gnome:before {\n  content: \"\\ee0e\";\n}\n\n.icofont-social-google-buzz:before {\n  content: \"\\ee0f\";\n}\n\n.icofont-social-google-map:before {\n  content: \"\\ee10\";\n}\n\n.icofont-social-google-plus:before {\n  content: \"\\ee11\";\n}\n\n.icofont-social-google-talk:before {\n  content: \"\\ee12\";\n}\n\n.icofont-social-hype-machine:before {\n  content: \"\\ee13\";\n}\n\n.icofont-social-instagram:before {\n  content: \"\\ee14\";\n}\n\n.icofont-brand-joomla:before {\n  content: \"\\ee15\";\n}\n\n.icofont-social-kickstarter:before {\n  content: \"\\ee16\";\n}\n\n.icofont-social-line:before {\n  content: \"\\ee17\";\n}\n\n.icofont-social-linux-mint:before {\n  content: \"\\ee18\";\n}\n\n.icofont-social-livejournal:before {\n  content: \"\\ee19\";\n}\n\n.icofont-social-magento:before {\n  content: \"\\ee1a\";\n}\n\n.icofont-social-meetup:before {\n  content: \"\\ee1b\";\n}\n\n.icofont-social-mixx:before {\n  content: \"\\ee1c\";\n}\n\n.icofont-social-newsvine:before {\n  content: \"\\ee1d\";\n}\n\n.icofont-social-nimbuss:before {\n  content: \"\\ee1e\";\n}\n\n.icofont-social-opencart:before {\n  content: \"\\ee1f\";\n}\n\n.icofont-social-oscommerce:before {\n  content: \"\\ee20\";\n}\n\n.icofont-social-pandora:before {\n  content: \"\\ee21\";\n}\n\n.icofont-social-picasa:before {\n  content: \"\\ee22\";\n}\n\n.icofont-social-pinterest:before {\n  content: \"\\ee23\";\n}\n\n.icofont-social-prestashop:before {\n  content: \"\\ee24\";\n}\n\n.icofont-social-qik:before {\n  content: \"\\ee25\";\n}\n\n.icofont-social-readernaut:before {\n  content: \"\\ee26\";\n}\n\n.icofont-social-reddit:before {\n  content: \"\\ee27\";\n}\n\n.icofont-social-rss:before {\n  content: \"\\ee28\";\n}\n\n.icofont-social-shopify:before {\n  content: \"\\ee29\";\n}\n\n.icofont-social-silverstripe:before {\n  content: \"\\ee2a\";\n}\n\n.icofont-social-skype:before {\n  content: \"\\ee2b\";\n}\n\n.icofont-social-slashdot:before {\n  content: \"\\ee2c\";\n}\n\n.icofont-social-smugmug:before {\n  content: \"\\ee2d\";\n}\n\n.icofont-social-steam:before {\n  content: \"\\ee2e\";\n}\n\n.icofont-social-stumbleupon:before {\n  content: \"\\ee2f\";\n}\n\n.icofont-social-technorati:before {\n  content: \"\\ee30\";\n}\n\n.icofont-social-telegram:before {\n  content: \"\\ee31\";\n}\n\n.icofont-social-tinder:before {\n  content: \"\\ee32\";\n}\n\n.icofont-social-tumblr:before {\n  content: \"\\ee33\";\n}\n\n.icofont-social-twitter:before {\n  content: \"\\ee34\";\n}\n\n.icofont-social-typo3:before {\n  content: \"\\ee35\";\n}\n\n.icofont-social-ubercart:before {\n  content: \"\\ee36\";\n}\n\n.icofont-social-viber:before {\n  content: \"\\ee37\";\n}\n\n.icofont-social-viddler:before {\n  content: \"\\ee38\";\n}\n\n.icofont-social-vimeo:before {\n  content: \"\\ee39\";\n}\n\n.icofont-social-vine:before {\n  content: \"\\ee3a\";\n}\n\n.icofont-social-virb:before {\n  content: \"\\ee3b\";\n}\n\n.icofont-social-virtuemart:before {\n  content: \"\\ee3c\";\n}\n\n.icofont-social-wechat:before {\n  content: \"\\ee3d\";\n}\n\n.icofont-brand-wordpress:before {\n  content: \"\\ee3e\";\n}\n\n.icofont-social-xing:before {\n  content: \"\\ee3f\";\n}\n\n.icofont-social-yahoo:before {\n  content: \"\\ee40\";\n}\n\n.icofont-social-yelp:before {\n  content: \"\\ee41\";\n}\n\n.icofont-social-zencart:before {\n  content: \"\\ee42\";\n}\n\n.icofont-badminton-birdie:before {\n  content: \"\\ee43\";\n}\n\n.icofont-baseball:before {\n  content: \"\\ee44\";\n}\n\n.icofont-baseballer:before {\n  content: \"\\ee45\";\n}\n\n.icofont-basketball-hoop:before {\n  content: \"\\ee46\";\n}\n\n.icofont-basketball:before {\n  content: \"\\ee47\";\n}\n\n.icofont-billiard-ball:before {\n  content: \"\\ee48\";\n}\n\n.icofont-boot-alt-1:before {\n  content: \"\\ee49\";\n}\n\n.icofont-boot-alt-2:before {\n  content: \"\\ee4a\";\n}\n\n.icofont-bowling-alt:before {\n  content: \"\\ee4b\";\n}\n\n.icofont-bowling:before {\n  content: \"\\ee4c\";\n}\n\n.icofont-canoe:before {\n  content: \"\\ee4d\";\n}\n\n.icofont-cheer-leader:before {\n  content: \"\\ee4e\";\n}\n\n.icofont-climbing:before {\n  content: \"\\ee4f\";\n}\n\n.icofont-corner:before {\n  content: \"\\ee50\";\n}\n\n.icofont-cyclist:before {\n  content: \"\\ee51\";\n}\n\n.icofont-dumbbell-alt:before {\n  content: \"\\ee52\";\n}\n\n.icofont-dumbbell:before {\n  content: \"\\ee53\";\n}\n\n.icofont-field-alt:before {\n  content: \"\\ee54\";\n}\n\n.icofont-field:before {\n  content: \"\\ee55\";\n}\n\n.icofont-football-alt:before {\n  content: \"\\ee56\";\n}\n\n.icofont-foul:before {\n  content: \"\\ee57\";\n}\n\n.icofont-goal-keeper:before {\n  content: \"\\ee58\";\n}\n\n.icofont-goal:before {\n  content: \"\\ee59\";\n}\n\n.icofont-golf-alt:before {\n  content: \"\\ee5a\";\n}\n\n.icofont-golf-bag:before {\n  content: \"\\ee5b\";\n}\n\n.icofont-golf-field:before {\n  content: \"\\ee5c\";\n}\n\n.icofont-golf:before {\n  content: \"\\ee5d\";\n}\n\n.icofont-golfer:before {\n  content: \"\\ee5e\";\n}\n\n.icofont-gym-alt-1:before {\n  content: \"\\ee5f\";\n}\n\n.icofont-gym-alt-2:before {\n  content: \"\\ee60\";\n}\n\n.icofont-gym-alt-3:before {\n  content: \"\\ee61\";\n}\n\n.icofont-gym:before {\n  content: \"\\ee62\";\n}\n\n.icofont-hand-grippers:before {\n  content: \"\\ee63\";\n}\n\n.icofont-heart-beat-alt:before {\n  content: \"\\ee64\";\n}\n\n.icofont-helmet:before {\n  content: \"\\ee65\";\n}\n\n.icofont-hockey-alt:before {\n  content: \"\\ee66\";\n}\n\n.icofont-hockey:before {\n  content: \"\\ee67\";\n}\n\n.icofont-ice-skate:before {\n  content: \"\\ee68\";\n}\n\n.icofont-jersey-alt:before {\n  content: \"\\ee69\";\n}\n\n.icofont-jersey:before {\n  content: \"\\ee6a\";\n}\n\n.icofont-jumping:before {\n  content: \"\\ee6b\";\n}\n\n.icofont-kick:before {\n  content: \"\\ee6c\";\n}\n\n.icofont-leg:before {\n  content: \"\\ee6d\";\n}\n\n.icofont-match-review:before {\n  content: \"\\ee6e\";\n}\n\n.icofont-medal-alt:before {\n  content: \"\\ee6f\";\n}\n\n.icofont-muscle-alt:before {\n  content: \"\\ee70\";\n}\n\n.icofont-muscle:before {\n  content: \"\\ee71\";\n}\n\n.icofont-offside:before {\n  content: \"\\ee72\";\n}\n\n.icofont-olympic-logo:before {\n  content: \"\\ee73\";\n}\n\n.icofont-olympic:before {\n  content: \"\\ee74\";\n}\n\n.icofont-padding:before {\n  content: \"\\ee75\";\n}\n\n.icofont-penalty-card:before {\n  content: \"\\ee76\";\n}\n\n.icofont-racer:before {\n  content: \"\\ee77\";\n}\n\n.icofont-racing-car:before {\n  content: \"\\ee78\";\n}\n\n.icofont-racing-flag-alt:before {\n  content: \"\\ee79\";\n}\n\n.icofont-racing-flag:before {\n  content: \"\\ee7a\";\n}\n\n.icofont-racings-wheel:before {\n  content: \"\\ee7b\";\n}\n\n.icofont-referee:before {\n  content: \"\\ee7c\";\n}\n\n.icofont-refree-jersey:before {\n  content: \"\\ee7d\";\n}\n\n.icofont-result:before {\n  content: \"\\ee7e\";\n}\n\n.icofont-rugby-ball:before {\n  content: \"\\ee7f\";\n}\n\n.icofont-rugby-player:before {\n  content: \"\\ee80\";\n}\n\n.icofont-rugby:before {\n  content: \"\\ee81\";\n}\n\n.icofont-runner-alt-1:before {\n  content: \"\\ee82\";\n}\n\n.icofont-runner-alt-2:before {\n  content: \"\\ee83\";\n}\n\n.icofont-runner:before {\n  content: \"\\ee84\";\n}\n\n.icofont-score-board:before {\n  content: \"\\ee85\";\n}\n\n.icofont-skiing-man:before {\n  content: \"\\ee86\";\n}\n\n.icofont-skydiving-goggles:before {\n  content: \"\\ee87\";\n}\n\n.icofont-snow-mobile:before {\n  content: \"\\ee88\";\n}\n\n.icofont-steering:before {\n  content: \"\\ee89\";\n}\n\n.icofont-substitute:before {\n  content: \"\\ee8a\";\n}\n\n.icofont-swimmer:before {\n  content: \"\\ee8b\";\n}\n\n.icofont-table-tennis:before {\n  content: \"\\ee8c\";\n}\n\n.icofont-team-alt:before {\n  content: \"\\ee8d\";\n}\n\n.icofont-team:before {\n  content: \"\\ee8e\";\n}\n\n.icofont-tennis-player:before {\n  content: \"\\ee8f\";\n}\n\n.icofont-tennis:before {\n  content: \"\\ee90\";\n}\n\n.icofont-time:before {\n  content: \"\\ee91\";\n}\n\n.icofont-track:before {\n  content: \"\\ee92\";\n}\n\n.icofont-tracking:before {\n  content: \"\\ee93\";\n}\n\n.icofont-trophy-alt:before {\n  content: \"\\ee94\";\n}\n\n.icofont-trophy:before {\n  content: \"\\ee95\";\n}\n\n.icofont-volleyball-alt:before {\n  content: \"\\ee96\";\n}\n\n.icofont-volleyball-fire:before {\n  content: \"\\ee97\";\n}\n\n.icofont-volleyball:before {\n  content: \"\\ee98\";\n}\n\n.icofont-water-bottle:before {\n  content: \"\\ee99\";\n}\n\n.icofont-whisle:before {\n  content: \"\\ee9a\";\n}\n\n.icofont-win-trophy:before {\n  content: \"\\ee9b\";\n}\n\n.icofont-align-center:before {\n  content: \"\\ee9c\";\n}\n\n.icofont-align-left:before {\n  content: \"\\ee9d\";\n}\n\n.icofont-align-right:before {\n  content: \"\\ee9e\";\n}\n\n.icofont-all-caps:before {\n  content: \"\\ee9f\";\n}\n\n.icofont-bold:before {\n  content: \"\\eea0\";\n}\n\n.icofont-brush:before {\n  content: \"\\eea1\";\n}\n\n.icofont-clip-board:before {\n  content: \"\\eea2\";\n}\n\n.icofont-code-alt:before {\n  content: \"\\eea3\";\n}\n\n.icofont-color-bucket:before {\n  content: \"\\eea4\";\n}\n\n.icofont-color-picker:before {\n  content: \"\\eea5\";\n}\n\n.icofont-copy-alt:before {\n  content: \"\\eea6\";\n}\n\n.icofont-copy-black:before {\n  content: \"\\eea7\";\n}\n\n.icofont-cut:before {\n  content: \"\\eea8\";\n}\n\n.icofont-delete-alt:before {\n  content: \"\\eea9\";\n}\n\n.icofont-edit-alt:before {\n  content: \"\\eeaa\";\n}\n\n.icofont-eraser-alt:before {\n  content: \"\\eeab\";\n}\n\n.icofont-file-alt:before {\n  content: \"\\eeac\";\n}\n\n.icofont-font:before {\n  content: \"\\eead\";\n}\n\n.icofont-header:before {\n  content: \"\\eeae\";\n}\n\n.icofont-indent:before {\n  content: \"\\eeaf\";\n}\n\n.icofont-italic-alt:before {\n  content: \"\\eeb0\";\n}\n\n.icofont-justify-all:before {\n  content: \"\\eeb1\";\n}\n\n.icofont-justify-center:before {\n  content: \"\\eeb2\";\n}\n\n.icofont-justify-left:before {\n  content: \"\\eeb3\";\n}\n\n.icofont-justify-right:before {\n  content: \"\\eeb4\";\n}\n\n.icofont-line-height:before {\n  content: \"\\eeb5\";\n}\n\n.icofont-link-alt:before {\n  content: \"\\eeb6\";\n}\n\n.icofont-listine-dots:before {\n  content: \"\\eeb7\";\n}\n\n.icofont-listing-box:before {\n  content: \"\\eeb8\";\n}\n\n.icofont-listing-number:before {\n  content: \"\\eeb9\";\n}\n\n.icofont-marker:before {\n  content: \"\\eeba\";\n}\n\n.icofont-outdent:before {\n  content: \"\\eebb\";\n}\n\n.icofont-paper-clip:before {\n  content: \"\\eebc\";\n}\n\n.icofont-paragraph:before {\n  content: \"\\eebd\";\n}\n\n.icofont-pin:before {\n  content: \"\\eebe\";\n}\n\n.icofont-printer:before {\n  content: \"\\eebf\";\n}\n\n.icofont-redo:before {\n  content: \"\\eec0\";\n}\n\n.icofont-rotation:before {\n  content: \"\\eec1\";\n}\n\n.icofont-save:before {\n  content: \"\\eec2\";\n}\n\n.icofont-small-cap:before {\n  content: \"\\eec3\";\n}\n\n.icofont-strike-through:before {\n  content: \"\\eec4\";\n}\n\n.icofont-sub-listing:before {\n  content: \"\\eec5\";\n}\n\n.icofont-subscript:before {\n  content: \"\\eec6\";\n}\n\n.icofont-superscript:before {\n  content: \"\\eec7\";\n}\n\n.icofont-table:before {\n  content: \"\\eec8\";\n}\n\n.icofont-text-height:before {\n  content: \"\\eec9\";\n}\n\n.icofont-text-width:before {\n  content: \"\\eeca\";\n}\n\n.icofont-trash:before {\n  content: \"\\eecb\";\n}\n\n.icofont-underline:before {\n  content: \"\\eecc\";\n}\n\n.icofont-undo:before {\n  content: \"\\eecd\";\n}\n\n.icofont-unlink:before {\n  content: \"\\eece\";\n}\n\n.icofont-air-balloon:before {\n  content: \"\\eecf\";\n}\n\n.icofont-airplane-alt:before {\n  content: \"\\eed0\";\n}\n\n.icofont-airplane:before {\n  content: \"\\eed1\";\n}\n\n.icofont-ambulance-crescent:before {\n  content: \"\\eed2\";\n}\n\n.icofont-ambulance-cross:before {\n  content: \"\\eed3\";\n}\n\n.icofont-articulated-truck:before {\n  content: \"\\eed4\";\n}\n\n.icofont-auto-rickshaw:before {\n  content: \"\\eed5\";\n}\n\n.icofont-bicycle-alt-1:before {\n  content: \"\\eed6\";\n}\n\n.icofont-bicycle-alt-2:before {\n  content: \"\\eed7\";\n}\n\n.icofont-bull-dozer:before {\n  content: \"\\eed8\";\n}\n\n.icofont-bus-alt-1:before {\n  content: \"\\eed9\";\n}\n\n.icofont-bus-alt-2:before {\n  content: \"\\eeda\";\n}\n\n.icofont-bus-alt-3:before {\n  content: \"\\eedb\";\n}\n\n.icofont-cable-car:before {\n  content: \"\\eedc\";\n}\n\n.icofont-car-alt-1:before {\n  content: \"\\eedd\";\n}\n\n.icofont-car-alt-2:before {\n  content: \"\\eede\";\n}\n\n.icofont-car-alt-3:before {\n  content: \"\\eedf\";\n}\n\n.icofont-car-alt-4:before {\n  content: \"\\eee0\";\n}\n\n.icofont-concrete-mixer:before {\n  content: \"\\eee1\";\n}\n\n.icofont-delivery-time:before {\n  content: \"\\eee2\";\n}\n\n.icofont-excavator:before {\n  content: \"\\eee3\";\n}\n\n.icofont-fast-delivery:before {\n  content: \"\\eee4\";\n}\n\n.icofont-fire-truck-alt:before {\n  content: \"\\eee5\";\n}\n\n.icofont-fire-truck:before {\n  content: \"\\eee6\";\n}\n\n.icofont-fork-lift:before {\n  content: \"\\eee7\";\n}\n\n.icofont-free-delivery:before {\n  content: \"\\eee8\";\n}\n\n.icofont-golf-cart:before {\n  content: \"\\eee9\";\n}\n\n.icofont-helicopter:before {\n  content: \"\\eeea\";\n}\n\n.icofont-motor-bike-alt:before {\n  content: \"\\eeeb\";\n}\n\n.icofont-motor-bike:before {\n  content: \"\\eeec\";\n}\n\n.icofont-motor-biker:before {\n  content: \"\\eeed\";\n}\n\n.icofont-oil-truck:before {\n  content: \"\\eeee\";\n}\n\n.icofont-police-car:before {\n  content: \"\\eeef\";\n}\n\n.icofont-rickshaw:before {\n  content: \"\\eef0\";\n}\n\n.icofont-rocket-alt-1:before {\n  content: \"\\eef1\";\n}\n\n.icofont-rocket-alt-2:before {\n  content: \"\\eef2\";\n}\n\n.icofont-sail-boat:before {\n  content: \"\\eef3\";\n}\n\n.icofont-scooter:before {\n  content: \"\\eef4\";\n}\n\n.icofont-sea-plane:before {\n  content: \"\\eef5\";\n}\n\n.icofont-ship-alt:before {\n  content: \"\\eef6\";\n}\n\n.icofont-speed-boat:before {\n  content: \"\\eef7\";\n}\n\n.icofont-taxi:before {\n  content: \"\\eef8\";\n}\n\n.icofont-tow-truck:before {\n  content: \"\\eef9\";\n}\n\n.icofont-tractor:before {\n  content: \"\\eefa\";\n}\n\n.icofont-traffic-light:before {\n  content: \"\\eefb\";\n}\n\n.icofont-train-line:before {\n  content: \"\\eefc\";\n}\n\n.icofont-train-steam:before {\n  content: \"\\eefd\";\n}\n\n.icofont-tram:before {\n  content: \"\\eefe\";\n}\n\n.icofont-truck-alt:before {\n  content: \"\\eeff\";\n}\n\n.icofont-truck-loaded:before {\n  content: \"\\ef00\";\n}\n\n.icofont-truck:before {\n  content: \"\\ef01\";\n}\n\n.icofont-van-alt:before {\n  content: \"\\ef02\";\n}\n\n.icofont-van:before {\n  content: \"\\ef03\";\n}\n\n.icofont-yacht:before {\n  content: \"\\ef04\";\n}\n\n.icofont-5-star-hotel:before {\n  content: \"\\ef05\";\n}\n\n.icofont-anchor-alt:before {\n  content: \"\\ef06\";\n}\n\n.icofont-beach-bed:before {\n  content: \"\\ef07\";\n}\n\n.icofont-camping-vest:before {\n  content: \"\\ef08\";\n}\n\n.icofont-coconut-alt:before {\n  content: \"\\ef09\";\n}\n\n.icofont-direction-sign:before {\n  content: \"\\ef0a\";\n}\n\n.icofont-hill-side:before {\n  content: \"\\ef0b\";\n}\n\n.icofont-island-alt:before {\n  content: \"\\ef0c\";\n}\n\n.icofont-long-drive:before {\n  content: \"\\ef0d\";\n}\n\n.icofont-map-pins:before {\n  content: \"\\ef0e\";\n}\n\n.icofont-plane-ticket:before {\n  content: \"\\ef0f\";\n}\n\n.icofont-sail-boat-alt-1:before {\n  content: \"\\ef10\";\n}\n\n.icofont-sail-boat-alt-2:before {\n  content: \"\\ef11\";\n}\n\n.icofont-sandals-female:before {\n  content: \"\\ef12\";\n}\n\n.icofont-sandals-male:before {\n  content: \"\\ef13\";\n}\n\n.icofont-travelling:before {\n  content: \"\\ef14\";\n}\n\n.icofont-breakdown:before {\n  content: \"\\ef15\";\n}\n\n.icofont-celsius:before {\n  content: \"\\ef16\";\n}\n\n.icofont-clouds:before {\n  content: \"\\ef17\";\n}\n\n.icofont-cloudy:before {\n  content: \"\\ef18\";\n}\n\n.icofont-compass-alt:before {\n  content: \"\\ef19\";\n}\n\n.icofont-dust:before {\n  content: \"\\ef1a\";\n}\n\n.icofont-eclipse:before {\n  content: \"\\ef1b\";\n}\n\n.icofont-fahrenheit:before {\n  content: \"\\ef1c\";\n}\n\n.icofont-forest-fire:before {\n  content: \"\\ef1d\";\n}\n\n.icofont-full-night:before {\n  content: \"\\ef1e\";\n}\n\n.icofont-full-sunny:before {\n  content: \"\\ef1f\";\n}\n\n.icofont-hail-night:before {\n  content: \"\\ef20\";\n}\n\n.icofont-hail-rainy-night:before {\n  content: \"\\ef21\";\n}\n\n.icofont-hail-rainy-sunny:before {\n  content: \"\\ef22\";\n}\n\n.icofont-hail-rainy:before {\n  content: \"\\ef23\";\n}\n\n.icofont-hail-sunny:before {\n  content: \"\\ef24\";\n}\n\n.icofont-hail-thunder-night:before {\n  content: \"\\ef25\";\n}\n\n.icofont-hail-thunder-sunny:before {\n  content: \"\\ef26\";\n}\n\n.icofont-hail-thunder:before {\n  content: \"\\ef27\";\n}\n\n.icofont-hail:before {\n  content: \"\\ef28\";\n}\n\n.icofont-hill-night:before {\n  content: \"\\ef29\";\n}\n\n.icofont-hill-sunny:before {\n  content: \"\\ef2a\";\n}\n\n.icofont-hill:before {\n  content: \"\\ef2b\";\n}\n\n.icofont-hurricane:before {\n  content: \"\\ef2c\";\n}\n\n.icofont-island:before {\n  content: \"\\ef2d\";\n}\n\n.icofont-meteor:before {\n  content: \"\\ef2e\";\n}\n\n.icofont-night:before {\n  content: \"\\ef2f\";\n}\n\n.icofont-rainy-night:before {\n  content: \"\\ef30\";\n}\n\n.icofont-rainy-sunny:before {\n  content: \"\\ef31\";\n}\n\n.icofont-rainy-thunder:before {\n  content: \"\\ef32\";\n}\n\n.icofont-rainy:before {\n  content: \"\\ef33\";\n}\n\n.icofont-showy-night-hail:before {\n  content: \"\\ef34\";\n}\n\n.icofont-snow-temp:before {\n  content: \"\\ef35\";\n}\n\n.icofont-snow:before {\n  content: \"\\ef36\";\n}\n\n.icofont-snowy-hail:before {\n  content: \"\\ef37\";\n}\n\n.icofont-snowy-night-rainy:before {\n  content: \"\\ef38\";\n}\n\n.icofont-snowy-night:before {\n  content: \"\\ef39\";\n}\n\n.icofont-snowy-rainy:before {\n  content: \"\\ef3a\";\n}\n\n.icofont-snowy-sunny-hail:before {\n  content: \"\\ef3b\";\n}\n\n.icofont-snowy-sunny-rainy:before {\n  content: \"\\ef3c\";\n}\n\n.icofont-snowy-sunny:before {\n  content: \"\\ef3d\";\n}\n\n.icofont-snowy-thunder-night:before {\n  content: \"\\ef3e\";\n}\n\n.icofont-snowy-thunder-sunny:before {\n  content: \"\\ef3f\";\n}\n\n.icofont-snowy-thunder:before {\n  content: \"\\ef40\";\n}\n\n.icofont-snowy-windy-night:before {\n  content: \"\\ef41\";\n}\n\n.icofont-snowy-windy-sunny:before {\n  content: \"\\ef42\";\n}\n\n.icofont-snowy-windy:before {\n  content: \"\\ef43\";\n}\n\n.icofont-snowy:before {\n  content: \"\\ef44\";\n}\n\n.icofont-sun-alt:before {\n  content: \"\\ef45\";\n}\n\n.icofont-sun-rise:before {\n  content: \"\\ef46\";\n}\n\n.icofont-sun-set:before {\n  content: \"\\ef47\";\n}\n\n.icofont-sunny-day-temp:before {\n  content: \"\\ef48\";\n}\n\n.icofont-sunny:before {\n  content: \"\\ef49\";\n}\n\n.icofont-thermometer:before {\n  content: \"\\ef4a\";\n}\n\n.icofont-thinder-light:before {\n  content: \"\\ef4b\";\n}\n\n.icofont-tornado:before {\n  content: \"\\ef4c\";\n}\n\n.icofont-umbrella-alt:before {\n  content: \"\\ef4d\";\n}\n\n.icofont-volcano:before {\n  content: \"\\ef4e\";\n}\n\n.icofont-wave:before {\n  content: \"\\ef4f\";\n}\n\n.icofont-wind-scale-0:before {\n  content: \"\\ef50\";\n}\n\n.icofont-wind-scale-1:before {\n  content: \"\\ef51\";\n}\n\n.icofont-wind-scale-2:before {\n  content: \"\\ef52\";\n}\n\n.icofont-wind-scale-3:before {\n  content: \"\\ef53\";\n}\n\n.icofont-wind-scale-4:before {\n  content: \"\\ef54\";\n}\n\n.icofont-wind-scale-5:before {\n  content: \"\\ef55\";\n}\n\n.icofont-wind-scale-6:before {\n  content: \"\\ef56\";\n}\n\n.icofont-wind-scale-7:before {\n  content: \"\\ef57\";\n}\n\n.icofont-wind-scale-8:before {\n  content: \"\\ef58\";\n}\n\n.icofont-wind-scale-9:before {\n  content: \"\\ef59\";\n}\n\n.icofont-wind-scale-10:before {\n  content: \"\\ef5a\";\n}\n\n.icofont-wind-scale-11:before {\n  content: \"\\ef5b\";\n}\n\n.icofont-wind-scale-12:before {\n  content: \"\\ef5c\";\n}\n\n.icofont-wind-waves:before {\n  content: \"\\ef5d\";\n}\n\n.icofont-wind:before {\n  content: \"\\ef5e\";\n}\n\n.icofont-windy-hail:before {\n  content: \"\\ef5f\";\n}\n\n.icofont-windy-night:before {\n  content: \"\\ef60\";\n}\n\n.icofont-windy-raining:before {\n  content: \"\\ef61\";\n}\n\n.icofont-windy-sunny:before {\n  content: \"\\ef62\";\n}\n\n.icofont-windy-thunder-raining:before {\n  content: \"\\ef63\";\n}\n\n.icofont-windy-thunder:before {\n  content: \"\\ef64\";\n}\n\n.icofont-windy:before {\n  content: \"\\ef65\";\n}\n\n.icofont-addons:before {\n  content: \"\\ef66\";\n}\n\n.icofont-address-book:before {\n  content: \"\\ef67\";\n}\n\n.icofont-adjust:before {\n  content: \"\\ef68\";\n}\n\n.icofont-alarm:before {\n  content: \"\\ef69\";\n}\n\n.icofont-anchor:before {\n  content: \"\\ef6a\";\n}\n\n.icofont-archive:before {\n  content: \"\\ef6b\";\n}\n\n.icofont-at:before {\n  content: \"\\ef6c\";\n}\n\n.icofont-attachment:before {\n  content: \"\\ef6d\";\n}\n\n.icofont-audio:before {\n  content: \"\\ef6e\";\n}\n\n.icofont-auto-mobile:before {\n  content: \"\\ef6f\";\n}\n\n.icofont-automation:before {\n  content: \"\\ef70\";\n}\n\n.icofont-baby:before {\n  content: \"\\ef71\";\n}\n\n.icofont-badge:before {\n  content: \"\\ef72\";\n}\n\n.icofont-bag:before {\n  content: \"\\ef73\";\n}\n\n.icofont-ban:before {\n  content: \"\\ef74\";\n}\n\n.icofont-bank:before {\n  content: \"\\ef75\";\n}\n\n.icofont-bar-code:before {\n  content: \"\\ef76\";\n}\n\n.icofont-bars:before {\n  content: \"\\ef77\";\n}\n\n.icofont-battery-empty:before {\n  content: \"\\ef78\";\n}\n\n.icofont-battery-full:before {\n  content: \"\\ef79\";\n}\n\n.icofont-battery-half:before {\n  content: \"\\ef7a\";\n}\n\n.icofont-battery-low:before {\n  content: \"\\ef7b\";\n}\n\n.icofont-beach:before {\n  content: \"\\ef7c\";\n}\n\n.icofont-beaker:before {\n  content: \"\\ef7d\";\n}\n\n.icofont-bear:before {\n  content: \"\\ef7e\";\n}\n\n.icofont-beard:before {\n  content: \"\\ef7f\";\n}\n\n.icofont-bed:before {\n  content: \"\\ef80\";\n}\n\n.icofont-bell:before {\n  content: \"\\ef81\";\n}\n\n.icofont-beverage:before {\n  content: \"\\ef82\";\n}\n\n.icofont-bicycle:before {\n  content: \"\\ef83\";\n}\n\n.icofont-bill:before {\n  content: \"\\ef84\";\n}\n\n.icofont-bin:before {\n  content: \"\\ef85\";\n}\n\n.icofont-binary:before {\n  content: \"\\ef86\";\n}\n\n.icofont-binoculars:before {\n  content: \"\\ef87\";\n}\n\n.icofont-bird:before {\n  content: \"\\ef88\";\n}\n\n.icofont-birds:before {\n  content: \"\\ef89\";\n}\n\n.icofont-black-board:before {\n  content: \"\\ef8a\";\n}\n\n.icofont-bluetooth:before {\n  content: \"\\ef8b\";\n}\n\n.icofont-bolt:before {\n  content: \"\\ef8c\";\n}\n\n.icofont-bomb:before {\n  content: \"\\ef8d\";\n}\n\n.icofont-book-mark:before {\n  content: \"\\ef8e\";\n}\n\n.icofont-book:before {\n  content: \"\\ef8f\";\n}\n\n.icofont-boot:before {\n  content: \"\\ef90\";\n}\n\n.icofont-box:before {\n  content: \"\\ef91\";\n}\n\n.icofont-brain:before {\n  content: \"\\ef92\";\n}\n\n.icofont-briefcase:before {\n  content: \"\\ef93\";\n}\n\n.icofont-broken:before {\n  content: \"\\ef94\";\n}\n\n.icofont-bucket:before {\n  content: \"\\ef95\";\n}\n\n.icofont-bucket1:before {\n  content: \"\\ef96\";\n}\n\n.icofont-bucket2:before {\n  content: \"\\ef97\";\n}\n\n.icofont-bug:before {\n  content: \"\\ef98\";\n}\n\n.icofont-building:before {\n  content: \"\\ef99\";\n}\n\n.icofont-bullet:before {\n  content: \"\\ef9a\";\n}\n\n.icofont-bullhorn:before {\n  content: \"\\ef9b\";\n}\n\n.icofont-bullseye:before {\n  content: \"\\ef9c\";\n}\n\n.icofont-bus:before {\n  content: \"\\ef9d\";\n}\n\n.icofont-butterfly:before {\n  content: \"\\ef9e\";\n}\n\n.icofont-cab:before {\n  content: \"\\ef9f\";\n}\n\n.icofont-calculator:before {\n  content: \"\\efa0\";\n}\n\n.icofont-calendar:before {\n  content: \"\\efa1\";\n}\n\n.icofont-camera-alt:before {\n  content: \"\\efa2\";\n}\n\n.icofont-camera:before {\n  content: \"\\efa3\";\n}\n\n.icofont-car:before {\n  content: \"\\efa4\";\n}\n\n.icofont-card:before {\n  content: \"\\efa5\";\n}\n\n.icofont-cart:before {\n  content: \"\\efa6\";\n}\n\n.icofont-cc:before {\n  content: \"\\efa7\";\n}\n\n.icofont-certificate:before {\n  content: \"\\efa8\";\n}\n\n.icofont-charging:before {\n  content: \"\\efa9\";\n}\n\n.icofont-chat:before {\n  content: \"\\efaa\";\n}\n\n.icofont-check-alt:before {\n  content: \"\\efab\";\n}\n\n.icofont-check-circled:before {\n  content: \"\\efac\";\n}\n\n.icofont-check:before {\n  content: \"\\efad\";\n}\n\n.icofont-checked:before {\n  content: \"\\efae\";\n}\n\n.icofont-children-care:before {\n  content: \"\\efaf\";\n}\n\n.icofont-clock-time:before {\n  content: \"\\efb0\";\n}\n\n.icofont-close-circled:before {\n  content: \"\\efb1\";\n}\n\n.icofont-close-line-circled:before {\n  content: \"\\efb2\";\n}\n\n.icofont-close-line-squared-alt:before {\n  content: \"\\efb3\";\n}\n\n.icofont-close-line-squared:before {\n  content: \"\\efb4\";\n}\n\n.icofont-close-line:before {\n  content: \"\\efb5\";\n}\n\n.icofont-close-squared-alt:before {\n  content: \"\\efb6\";\n}\n\n.icofont-close-squared:before {\n  content: \"\\efb7\";\n}\n\n.icofont-close:before {\n  content: \"\\efb8\";\n}\n\n.icofont-cloud-download:before {\n  content: \"\\efb9\";\n}\n\n.icofont-cloud-refresh:before {\n  content: \"\\efba\";\n}\n\n.icofont-cloud-upload:before {\n  content: \"\\efbb\";\n}\n\n.icofont-cloud:before {\n  content: \"\\efbc\";\n}\n\n.icofont-code-not-allowed:before {\n  content: \"\\efbd\";\n}\n\n.icofont-code:before {\n  content: \"\\efbe\";\n}\n\n.icofont-coffee-cup:before {\n  content: \"\\efbf\";\n}\n\n.icofont-comment:before {\n  content: \"\\efc0\";\n}\n\n.icofont-compass:before {\n  content: \"\\efc1\";\n}\n\n.icofont-computer:before {\n  content: \"\\efc2\";\n}\n\n.icofont-connection:before {\n  content: \"\\efc3\";\n}\n\n.icofont-console:before {\n  content: \"\\efc4\";\n}\n\n.icofont-contacts:before {\n  content: \"\\efc5\";\n}\n\n.icofont-contrast:before {\n  content: \"\\efc6\";\n}\n\n.icofont-copy:before {\n  content: \"\\efc7\";\n}\n\n.icofont-copyright:before {\n  content: \"\\efc8\";\n}\n\n.icofont-credit-card:before {\n  content: \"\\efc9\";\n}\n\n.icofont-crop:before {\n  content: \"\\efca\";\n}\n\n.icofont-crown:before {\n  content: \"\\efcb\";\n}\n\n.icofont-cube:before {\n  content: \"\\efcc\";\n}\n\n.icofont-cubes:before {\n  content: \"\\efcd\";\n}\n\n.icofont-culinary:before {\n  content: \"\\efce\";\n}\n\n.icofont-dashboard-web:before {\n  content: \"\\efcf\";\n}\n\n.icofont-dashboard:before {\n  content: \"\\efd0\";\n}\n\n.icofont-data:before {\n  content: \"\\efd1\";\n}\n\n.icofont-database-add:before {\n  content: \"\\efd2\";\n}\n\n.icofont-database-locked:before {\n  content: \"\\efd3\";\n}\n\n.icofont-database-remove:before {\n  content: \"\\efd4\";\n}\n\n.icofont-database:before {\n  content: \"\\efd5\";\n}\n\n.icofont-delete:before {\n  content: \"\\efd6\";\n}\n\n.icofont-diamond:before {\n  content: \"\\efd7\";\n}\n\n.icofont-dice:before {\n  content: \"\\efd8\";\n}\n\n.icofont-disabled:before {\n  content: \"\\efd9\";\n}\n\n.icofont-disc:before {\n  content: \"\\efda\";\n}\n\n.icofont-diskette:before {\n  content: \"\\efdb\";\n}\n\n.icofont-document-folder:before {\n  content: \"\\efdc\";\n}\n\n.icofont-download-alt:before {\n  content: \"\\efdd\";\n}\n\n.icofont-download:before {\n  content: \"\\efde\";\n}\n\n.icofont-downloaded:before {\n  content: \"\\efdf\";\n}\n\n.icofont-earth:before {\n  content: \"\\efe0\";\n}\n\n.icofont-ebook:before {\n  content: \"\\efe1\";\n}\n\n.icofont-edit:before {\n  content: \"\\efe2\";\n}\n\n.icofont-eject:before {\n  content: \"\\efe3\";\n}\n\n.icofont-email:before {\n  content: \"\\efe4\";\n}\n\n.icofont-envelope-open:before {\n  content: \"\\efe5\";\n}\n\n.icofont-envelope:before {\n  content: \"\\efe6\";\n}\n\n.icofont-eraser:before {\n  content: \"\\efe7\";\n}\n\n.icofont-error:before {\n  content: \"\\efe8\";\n}\n\n.icofont-exchange:before {\n  content: \"\\efe9\";\n}\n\n.icofont-exclamation-circle:before {\n  content: \"\\efea\";\n}\n\n.icofont-exclamation-square:before {\n  content: \"\\efeb\";\n}\n\n.icofont-exclamation-tringle:before {\n  content: \"\\efec\";\n}\n\n.icofont-exclamation:before {\n  content: \"\\efed\";\n}\n\n.icofont-exit:before {\n  content: \"\\efee\";\n}\n\n.icofont-expand:before {\n  content: \"\\efef\";\n}\n\n.icofont-external-link:before {\n  content: \"\\eff0\";\n}\n\n.icofont-external:before {\n  content: \"\\eff1\";\n}\n\n.icofont-eye-blocked:before {\n  content: \"\\eff2\";\n}\n\n.icofont-eye-dropper:before {\n  content: \"\\eff3\";\n}\n\n.icofont-eye:before {\n  content: \"\\eff4\";\n}\n\n.icofont-favourite:before {\n  content: \"\\eff5\";\n}\n\n.icofont-fax:before {\n  content: \"\\eff6\";\n}\n\n.icofont-female:before {\n  content: \"\\eff7\";\n}\n\n.icofont-file:before {\n  content: \"\\eff8\";\n}\n\n.icofont-film:before {\n  content: \"\\eff9\";\n}\n\n.icofont-filter:before {\n  content: \"\\effa\";\n}\n\n.icofont-fire-burn:before {\n  content: \"\\effb\";\n}\n\n.icofont-fire-extinguisher:before {\n  content: \"\\effc\";\n}\n\n.icofont-fire:before {\n  content: \"\\effd\";\n}\n\n.icofont-first-aid:before {\n  content: \"\\effe\";\n}\n\n.icofont-flag-alt-1:before {\n  content: \"\\efff\";\n}\n\n.icofont-flag-alt-2:before {\n  content: \"\\f000\";\n}\n\n.icofont-flag:before {\n  content: \"\\f001\";\n}\n\n.icofont-flash-light:before {\n  content: \"\\f002\";\n}\n\n.icofont-flash:before {\n  content: \"\\f003\";\n}\n\n.icofont-flask:before {\n  content: \"\\f004\";\n}\n\n.icofont-focus:before {\n  content: \"\\f005\";\n}\n\n.icofont-folder-open:before {\n  content: \"\\f006\";\n}\n\n.icofont-folder:before {\n  content: \"\\f007\";\n}\n\n.icofont-foot-print:before {\n  content: \"\\f008\";\n}\n\n.icofont-football-american:before {\n  content: \"\\f009\";\n}\n\n.icofont-football:before {\n  content: \"\\f00a\";\n}\n\n.icofont-game-console:before {\n  content: \"\\f00b\";\n}\n\n.icofont-game-pad:before {\n  content: \"\\f00c\";\n}\n\n.icofont-gavel:before {\n  content: \"\\f00d\";\n}\n\n.icofont-gear:before {\n  content: \"\\f00e\";\n}\n\n.icofont-gears:before {\n  content: \"\\f00f\";\n}\n\n.icofont-gift:before {\n  content: \"\\f010\";\n}\n\n.icofont-glass:before {\n  content: \"\\f011\";\n}\n\n.icofont-globe:before {\n  content: \"\\f012\";\n}\n\n.icofont-graduate:before {\n  content: \"\\f013\";\n}\n\n.icofont-graffiti:before {\n  content: \"\\f014\";\n}\n\n.icofont-grocery:before {\n  content: \"\\f015\";\n}\n\n.icofont-group:before {\n  content: \"\\f016\";\n}\n\n.icofont-hammer:before {\n  content: \"\\f017\";\n}\n\n.icofont-hand:before {\n  content: \"\\f018\";\n}\n\n.icofont-hanger:before {\n  content: \"\\f019\";\n}\n\n.icofont-hard-disk:before {\n  content: \"\\f01a\";\n}\n\n.icofont-headphone:before {\n  content: \"\\f01b\";\n}\n\n.icofont-heart-beat:before {\n  content: \"\\f01c\";\n}\n\n.icofont-heart:before {\n  content: \"\\f01d\";\n}\n\n.icofont-history:before {\n  content: \"\\f01e\";\n}\n\n.icofont-home:before {\n  content: \"\\f01f\";\n}\n\n.icofont-horn:before {\n  content: \"\\f020\";\n}\n\n.icofont-hotel:before {\n  content: \"\\f021\";\n}\n\n.icofont-hour-glass:before {\n  content: \"\\f022\";\n}\n\n.icofont-id:before {\n  content: \"\\f023\";\n}\n\n.icofont-image:before {\n  content: \"\\f024\";\n}\n\n.icofont-inbox:before {\n  content: \"\\f025\";\n}\n\n.icofont-infinite:before {\n  content: \"\\f026\";\n}\n\n.icofont-info-circle:before {\n  content: \"\\f027\";\n}\n\n.icofont-info-square:before {\n  content: \"\\f028\";\n}\n\n.icofont-info:before {\n  content: \"\\f029\";\n}\n\n.icofont-institution:before {\n  content: \"\\f02a\";\n}\n\n.icofont-interface:before {\n  content: \"\\f02b\";\n}\n\n.icofont-invisible:before {\n  content: \"\\f02c\";\n}\n\n.icofont-italic:before {\n  content: \"\\f02d\";\n}\n\n.icofont-jacket:before {\n  content: \"\\f02e\";\n}\n\n.icofont-jar:before {\n  content: \"\\f02f\";\n}\n\n.icofont-jewlery:before {\n  content: \"\\f030\";\n}\n\n.icofont-karate:before {\n  content: \"\\f031\";\n}\n\n.icofont-key-hole:before {\n  content: \"\\f032\";\n}\n\n.icofont-key:before {\n  content: \"\\f033\";\n}\n\n.icofont-keyboard:before {\n  content: \"\\f034\";\n}\n\n.icofont-kid:before {\n  content: \"\\f035\";\n}\n\n.icofont-label:before {\n  content: \"\\f036\";\n}\n\n.icofont-lamp:before {\n  content: \"\\f037\";\n}\n\n.icofont-laptop:before {\n  content: \"\\f038\";\n}\n\n.icofont-layers:before {\n  content: \"\\f039\";\n}\n\n.icofont-layout:before {\n  content: \"\\f03a\";\n}\n\n.icofont-leaf:before {\n  content: \"\\f03b\";\n}\n\n.icofont-leaflet:before {\n  content: \"\\f03c\";\n}\n\n.icofont-learn:before {\n  content: \"\\f03d\";\n}\n\n.icofont-legal:before {\n  content: \"\\f03e\";\n}\n\n.icofont-lego:before {\n  content: \"\\f03f\";\n}\n\n.icofont-lemon:before {\n  content: \"\\f040\";\n}\n\n.icofont-lens:before {\n  content: \"\\f041\";\n}\n\n.icofont-letter:before {\n  content: \"\\f042\";\n}\n\n.icofont-letterbox:before {\n  content: \"\\f043\";\n}\n\n.icofont-library:before {\n  content: \"\\f044\";\n}\n\n.icofont-license:before {\n  content: \"\\f045\";\n}\n\n.icofont-life-bouy:before {\n  content: \"\\f046\";\n}\n\n.icofont-life-buoy:before {\n  content: \"\\f047\";\n}\n\n.icofont-life-jacket:before {\n  content: \"\\f048\";\n}\n\n.icofont-life-ring:before {\n  content: \"\\f049\";\n}\n\n.icofont-light-bulb:before {\n  content: \"\\f04a\";\n}\n\n.icofont-lighter:before {\n  content: \"\\f04b\";\n}\n\n.icofont-lightning-ray:before {\n  content: \"\\f04c\";\n}\n\n.icofont-like:before {\n  content: \"\\f04d\";\n}\n\n.icofont-link:before {\n  content: \"\\f04e\";\n}\n\n.icofont-live-support:before {\n  content: \"\\f04f\";\n}\n\n.icofont-location-arrow:before {\n  content: \"\\f050\";\n}\n\n.icofont-location-pin:before {\n  content: \"\\f051\";\n}\n\n.icofont-lock:before {\n  content: \"\\f052\";\n}\n\n.icofont-login:before {\n  content: \"\\f053\";\n}\n\n.icofont-logout:before {\n  content: \"\\f054\";\n}\n\n.icofont-lollipop:before {\n  content: \"\\f055\";\n}\n\n.icofont-look:before {\n  content: \"\\f056\";\n}\n\n.icofont-loop:before {\n  content: \"\\f057\";\n}\n\n.icofont-luggage:before {\n  content: \"\\f058\";\n}\n\n.icofont-lunch:before {\n  content: \"\\f059\";\n}\n\n.icofont-lungs:before {\n  content: \"\\f05a\";\n}\n\n.icofont-magic-alt:before {\n  content: \"\\f05b\";\n}\n\n.icofont-magic:before {\n  content: \"\\f05c\";\n}\n\n.icofont-magnet:before {\n  content: \"\\f05d\";\n}\n\n.icofont-mail-box:before {\n  content: \"\\f05e\";\n}\n\n.icofont-mail:before {\n  content: \"\\f05f\";\n}\n\n.icofont-male:before {\n  content: \"\\f060\";\n}\n\n.icofont-map:before {\n  content: \"\\f061\";\n}\n\n.icofont-math:before {\n  content: \"\\f062\";\n}\n\n.icofont-maximize:before {\n  content: \"\\f063\";\n}\n\n.icofont-measure:before {\n  content: \"\\f064\";\n}\n\n.icofont-medal:before {\n  content: \"\\f065\";\n}\n\n.icofont-medical:before {\n  content: \"\\f066\";\n}\n\n.icofont-medicine:before {\n  content: \"\\f067\";\n}\n\n.icofont-mega-phone:before {\n  content: \"\\f068\";\n}\n\n.icofont-memorial:before {\n  content: \"\\f069\";\n}\n\n.icofont-memory-card:before {\n  content: \"\\f06a\";\n}\n\n.icofont-mic-mute:before {\n  content: \"\\f06b\";\n}\n\n.icofont-mic:before {\n  content: \"\\f06c\";\n}\n\n.icofont-micro-chip:before {\n  content: \"\\f06d\";\n}\n\n.icofont-microphone:before {\n  content: \"\\f06e\";\n}\n\n.icofont-microscope:before {\n  content: \"\\f06f\";\n}\n\n.icofont-military:before {\n  content: \"\\f070\";\n}\n\n.icofont-mill:before {\n  content: \"\\f071\";\n}\n\n.icofont-minus-circle:before {\n  content: \"\\f072\";\n}\n\n.icofont-minus-square:before {\n  content: \"\\f073\";\n}\n\n.icofont-minus:before {\n  content: \"\\f074\";\n}\n\n.icofont-mobile-phone:before {\n  content: \"\\f075\";\n}\n\n.icofont-molecule:before {\n  content: \"\\f076\";\n}\n\n.icofont-money:before {\n  content: \"\\f077\";\n}\n\n.icofont-moon:before {\n  content: \"\\f078\";\n}\n\n.icofont-mop:before {\n  content: \"\\f079\";\n}\n\n.icofont-muffin:before {\n  content: \"\\f07a\";\n}\n\n.icofont-music-alt:before {\n  content: \"\\f07b\";\n}\n\n.icofont-music-notes:before {\n  content: \"\\f07c\";\n}\n\n.icofont-music:before {\n  content: \"\\f07d\";\n}\n\n.icofont-mustache:before {\n  content: \"\\f07e\";\n}\n\n.icofont-mute-volume:before {\n  content: \"\\f07f\";\n}\n\n.icofont-navigation-menu:before {\n  content: \"\\f080\";\n}\n\n.icofont-navigation:before {\n  content: \"\\f081\";\n}\n\n.icofont-network-tower:before {\n  content: \"\\f082\";\n}\n\n.icofont-network:before {\n  content: \"\\f083\";\n}\n\n.icofont-news:before {\n  content: \"\\f084\";\n}\n\n.icofont-newspaper:before {\n  content: \"\\f085\";\n}\n\n.icofont-no-smoking:before {\n  content: \"\\f086\";\n}\n\n.icofont-not-allowed:before {\n  content: \"\\f087\";\n}\n\n.icofont-notebook:before {\n  content: \"\\f088\";\n}\n\n.icofont-notepad:before {\n  content: \"\\f089\";\n}\n\n.icofont-notification:before {\n  content: \"\\f08a\";\n}\n\n.icofont-numbered:before {\n  content: \"\\f08b\";\n}\n\n.icofont-opposite:before {\n  content: \"\\f08c\";\n}\n\n.icofont-optic:before {\n  content: \"\\f08d\";\n}\n\n.icofont-options:before {\n  content: \"\\f08e\";\n}\n\n.icofont-package:before {\n  content: \"\\f08f\";\n}\n\n.icofont-page:before {\n  content: \"\\f090\";\n}\n\n.icofont-paint:before {\n  content: \"\\f091\";\n}\n\n.icofont-paper-plane:before {\n  content: \"\\f092\";\n}\n\n.icofont-paperclip:before {\n  content: \"\\f093\";\n}\n\n.icofont-papers:before {\n  content: \"\\f094\";\n}\n\n.icofont-paw:before {\n  content: \"\\f095\";\n}\n\n.icofont-pay:before {\n  content: \"\\f096\";\n}\n\n.icofont-pen:before {\n  content: \"\\f097\";\n}\n\n.icofont-pencil:before {\n  content: \"\\f098\";\n}\n\n.icofont-penguin-linux:before {\n  content: \"\\f099\";\n}\n\n.icofont-pestle:before {\n  content: \"\\f09a\";\n}\n\n.icofont-phone-circle:before {\n  content: \"\\f09b\";\n}\n\n.icofont-phone:before {\n  content: \"\\f09c\";\n}\n\n.icofont-picture:before {\n  content: \"\\f09d\";\n}\n\n.icofont-pie:before {\n  content: \"\\f09e\";\n}\n\n.icofont-pine:before {\n  content: \"\\f09f\";\n}\n\n.icofont-pixels:before {\n  content: \"\\f0a0\";\n}\n\n.icofont-play:before {\n  content: \"\\f0a1\";\n}\n\n.icofont-plugin:before {\n  content: \"\\f0a2\";\n}\n\n.icofont-plus-circle:before {\n  content: \"\\f0a3\";\n}\n\n.icofont-plus-square:before {\n  content: \"\\f0a4\";\n}\n\n.icofont-plus:before {\n  content: \"\\f0a5\";\n}\n\n.icofont-polygonal:before {\n  content: \"\\f0a6\";\n}\n\n.icofont-power:before {\n  content: \"\\f0a7\";\n}\n\n.icofont-presentation:before {\n  content: \"\\f0a8\";\n}\n\n.icofont-price:before {\n  content: \"\\f0a9\";\n}\n\n.icofont-print:before {\n  content: \"\\f0aa\";\n}\n\n.icofont-puzzle:before {\n  content: \"\\f0ab\";\n}\n\n.icofont-qr-code:before {\n  content: \"\\f0ac\";\n}\n\n.icofont-queen:before {\n  content: \"\\f0ad\";\n}\n\n.icofont-question-circle:before {\n  content: \"\\f0ae\";\n}\n\n.icofont-question-square:before {\n  content: \"\\f0af\";\n}\n\n.icofont-question:before {\n  content: \"\\f0b0\";\n}\n\n.icofont-quote-left:before {\n  content: \"\\f0b1\";\n}\n\n.icofont-quote-right:before {\n  content: \"\\f0b2\";\n}\n\n.icofont-radio:before {\n  content: \"\\f0b3\";\n}\n\n.icofont-random:before {\n  content: \"\\f0b4\";\n}\n\n.icofont-recycle:before {\n  content: \"\\f0b5\";\n}\n\n.icofont-refresh:before {\n  content: \"\\f0b6\";\n}\n\n.icofont-repair:before {\n  content: \"\\f0b7\";\n}\n\n.icofont-reply-all:before {\n  content: \"\\f0b8\";\n}\n\n.icofont-reply:before {\n  content: \"\\f0b9\";\n}\n\n.icofont-resize:before {\n  content: \"\\f0ba\";\n}\n\n.icofont-responsive:before {\n  content: \"\\f0bb\";\n}\n\n.icofont-retweet:before {\n  content: \"\\f0bc\";\n}\n\n.icofont-road:before {\n  content: \"\\f0bd\";\n}\n\n.icofont-robot:before {\n  content: \"\\f0be\";\n}\n\n.icofont-rocket:before {\n  content: \"\\f0bf\";\n}\n\n.icofont-royal:before {\n  content: \"\\f0c0\";\n}\n\n.icofont-rss-feed:before {\n  content: \"\\f0c1\";\n}\n\n.icofont-safety:before {\n  content: \"\\f0c2\";\n}\n\n.icofont-sale-discount:before {\n  content: \"\\f0c3\";\n}\n\n.icofont-satellite:before {\n  content: \"\\f0c4\";\n}\n\n.icofont-send-mail:before {\n  content: \"\\f0c5\";\n}\n\n.icofont-server:before {\n  content: \"\\f0c6\";\n}\n\n.icofont-settings:before {\n  content: \"\\f0c7\";\n}\n\n.icofont-share-alt:before {\n  content: \"\\f0c8\";\n}\n\n.icofont-share-boxed:before {\n  content: \"\\f0c9\";\n}\n\n.icofont-share:before {\n  content: \"\\f0ca\";\n}\n\n.icofont-shield:before {\n  content: \"\\f0cb\";\n}\n\n.icofont-ship:before {\n  content: \"\\f0cc\";\n}\n\n.icofont-shopping-cart:before {\n  content: \"\\f0cd\";\n}\n\n.icofont-sign-in:before {\n  content: \"\\f0ce\";\n}\n\n.icofont-sign-out:before {\n  content: \"\\f0cf\";\n}\n\n.icofont-signal:before {\n  content: \"\\f0d0\";\n}\n\n.icofont-site-map:before {\n  content: \"\\f0d1\";\n}\n\n.icofont-smart-phone:before {\n  content: \"\\f0d2\";\n}\n\n.icofont-soccer:before {\n  content: \"\\f0d3\";\n}\n\n.icofont-sort-alt:before {\n  content: \"\\f0d4\";\n}\n\n.icofont-sort:before {\n  content: \"\\f0d5\";\n}\n\n.icofont-space:before {\n  content: \"\\f0d6\";\n}\n\n.icofont-spanner:before {\n  content: \"\\f0d7\";\n}\n\n.icofont-speech-comments:before {\n  content: \"\\f0d8\";\n}\n\n.icofont-speed-meter:before {\n  content: \"\\f0d9\";\n}\n\n.icofont-spinner-alt-1:before {\n  content: \"\\f0da\";\n}\n\n.icofont-spinner-alt-2:before {\n  content: \"\\f0db\";\n}\n\n.icofont-spinner-alt-3:before {\n  content: \"\\f0dc\";\n}\n\n.icofont-spinner-alt-4:before {\n  content: \"\\f0dd\";\n}\n\n.icofont-spinner-alt-5:before {\n  content: \"\\f0de\";\n}\n\n.icofont-spinner-alt-6:before {\n  content: \"\\f0df\";\n}\n\n.icofont-spinner:before {\n  content: \"\\f0e0\";\n}\n\n.icofont-spreadsheet:before {\n  content: \"\\f0e1\";\n}\n\n.icofont-square:before {\n  content: \"\\f0e2\";\n}\n\n.icofont-ssl-security:before {\n  content: \"\\f0e3\";\n}\n\n.icofont-star-alt-1:before {\n  content: \"\\f0e4\";\n}\n\n.icofont-star-alt-2:before {\n  content: \"\\f0e5\";\n}\n\n.icofont-star:before {\n  content: \"\\f0e6\";\n}\n\n.icofont-street-view:before {\n  content: \"\\f0e7\";\n}\n\n.icofont-sun:before {\n  content: \"\\f0e8\";\n}\n\n.icofont-support-faq:before {\n  content: \"\\f0e9\";\n}\n\n.icofont-tack-pin:before {\n  content: \"\\f0ea\";\n}\n\n.icofont-tag:before {\n  content: \"\\f0eb\";\n}\n\n.icofont-tags:before {\n  content: \"\\f0ec\";\n}\n\n.icofont-tasks:before {\n  content: \"\\f0ed\";\n}\n\n.icofont-telephone:before {\n  content: \"\\f0ee\";\n}\n\n.icofont-telescope:before {\n  content: \"\\f0ef\";\n}\n\n.icofont-terminal:before {\n  content: \"\\f0f0\";\n}\n\n.icofont-thumbs-down:before {\n  content: \"\\f0f1\";\n}\n\n.icofont-thumbs-up:before {\n  content: \"\\f0f2\";\n}\n\n.icofont-tick-boxed:before {\n  content: \"\\f0f3\";\n}\n\n.icofont-tick-mark:before {\n  content: \"\\f0f4\";\n}\n\n.icofont-ticket:before {\n  content: \"\\f0f5\";\n}\n\n.icofont-tie:before {\n  content: \"\\f0f6\";\n}\n\n.icofont-toggle-off:before {\n  content: \"\\f0f7\";\n}\n\n.icofont-toggle-on:before {\n  content: \"\\f0f8\";\n}\n\n.icofont-tools:before {\n  content: \"\\f0f9\";\n}\n\n.icofont-transparent:before {\n  content: \"\\f0fa\";\n}\n\n.icofont-tree:before {\n  content: \"\\f0fb\";\n}\n\n.icofont-umbrella:before {\n  content: \"\\f0fc\";\n}\n\n.icofont-unlock:before {\n  content: \"\\f0fd\";\n}\n\n.icofont-unlocked:before {\n  content: \"\\f0fe\";\n}\n\n.icofont-upload-alt:before {\n  content: \"\\f0ff\";\n}\n\n.icofont-upload:before {\n  content: \"\\f100\";\n}\n\n.icofont-usb-drive:before {\n  content: \"\\f101\";\n}\n\n.icofont-usb:before {\n  content: \"\\f102\";\n}\n\n.icofont-vector-path:before {\n  content: \"\\f103\";\n}\n\n.icofont-verification-check:before {\n  content: \"\\f104\";\n}\n\n.icofont-video-clapper:before {\n  content: \"\\f105\";\n}\n\n.icofont-video:before {\n  content: \"\\f106\";\n}\n\n.icofont-volume-down:before {\n  content: \"\\f107\";\n}\n\n.icofont-volume-off:before {\n  content: \"\\f108\";\n}\n\n.icofont-volume-up:before {\n  content: \"\\f109\";\n}\n\n.icofont-wall-clock:before {\n  content: \"\\f10a\";\n}\n\n.icofont-wall:before {\n  content: \"\\f10b\";\n}\n\n.icofont-wallet:before {\n  content: \"\\f10c\";\n}\n\n.icofont-warning-alt:before {\n  content: \"\\f10d\";\n}\n\n.icofont-warning:before {\n  content: \"\\f10e\";\n}\n\n.icofont-water-drop:before {\n  content: \"\\f10f\";\n}\n\n.icofont-web:before {\n  content: \"\\f110\";\n}\n\n.icofont-wheelchair:before {\n  content: \"\\f111\";\n}\n\n.icofont-wifi-alt:before {\n  content: \"\\f112\";\n}\n\n.icofont-wifi:before {\n  content: \"\\f113\";\n}\n\n.icofont-world:before {\n  content: \"\\f114\";\n}\n\n.icofont-zigzag:before {\n  content: \"\\f115\";\n}\n\n.icofont-zipped:before {\n  content: \"\\f116\";\n}\n\n.icofont-social-500px:before {\n  content: \"\\f117\";\n}\n\n.icofont-social-baidu-tieba:before {\n  content: \"\\f118\";\n}\n\n.icofont-social-bbm-messenger:before {\n  content: \"\\f119\";\n}\n\n.icofont-social-delicious:before {\n  content: \"\\f11a\";\n}\n\n.icofont-social-dribbble:before {\n  content: \"\\f11b\";\n}\n\n.icofont-social-facebook-messenger:before {\n  content: \"\\f11c\";\n}\n\n.icofont-social-flikr:before {\n  content: \"\\f11d\";\n}\n\n.icofont-social-foursquare:before {\n  content: \"\\f11e\";\n}\n\n.icofont-social-google-hangouts:before {\n  content: \"\\f11f\";\n}\n\n.icofont-social-kakaotalk:before {\n  content: \"\\f120\";\n}\n\n.icofont-social-kik:before {\n  content: \"\\f121\";\n}\n\n.icofont-social-kiwibox:before {\n  content: \"\\f122\";\n}\n\n.icofont-social-linkedin:before {\n  content: \"\\f123\";\n}\n\n.icofont-social-meetme:before {\n  content: \"\\f124\";\n}\n\n.icofont-social-odnoklassniki:before {\n  content: \"\\f125\";\n}\n\n.icofont-social-photobucket:before {\n  content: \"\\f126\";\n}\n\n.icofont-social-qq:before {\n  content: \"\\f127\";\n}\n\n.icofont-social-renren:before {\n  content: \"\\f128\";\n}\n\n.icofont-social-slack:before {\n  content: \"\\f129\";\n}\n\n.icofont-social-slidshare:before {\n  content: \"\\f12a\";\n}\n\n.icofont-social-snapchat:before {\n  content: \"\\f12b\";\n}\n\n.icofont-social-soundcloud:before {\n  content: \"\\f12c\";\n}\n\n.icofont-social-spotify:before {\n  content: \"\\f12d\";\n}\n\n.icofont-social-stack-exchange:before {\n  content: \"\\f12e\";\n}\n\n.icofont-social-stack-overflow:before {\n  content: \"\\f12f\";\n}\n\n.icofont-social-tagged:before {\n  content: \"\\f130\";\n}\n\n.icofont-social-trello:before {\n  content: \"\\f131\";\n}\n\n.icofont-social-twitch:before {\n  content: \"\\f132\";\n}\n\n.icofont-social-vk:before {\n  content: \"\\f133\";\n}\n\n.icofont-social-weibo:before {\n  content: \"\\f134\";\n}\n\n.icofont-social-whatsapp:before {\n  content: \"\\f135\";\n}\n\n.icofont-social-youku:before {\n  content: \"\\f136\";\n}\n\n.icofont-social-youtube-play:before {\n  content: \"\\f137\";\n}\n\n.icofont-social-youtube:before {\n  content: \"\\f138\";\n}\n\n.icofont-brand-xiaomi:before {\n  content: \"\\f139\";\n}\n\n/*Font size*/\n.icofont-lg {\n  font-size: 1.33333333em;\n  line-height: 0.75em;\n  vertical-align: -15%;\n}\n\n.icofont-2x {\n  font-size: 2em;\n}\n\n.icofont-3x {\n  font-size: 3em;\n}\n\n.icofont-4x {\n  font-size: 4em;\n}\n\n.icofont-5x {\n  font-size: 5em;\n}\n\n.icofont-fw {\n  display: inline-block;\n  width: 1.28571429em;\n  text-align: center;\n  width: 1.28571429em;\n  text-align: center;\n}\n\n/*Fixed Width Icons*/\n/*Custom list icons*/\n.icofont-ul {\n  padding-left: 0;\n  margin-left: 2.14285714em;\n  list-style-type: none;\n}\n.icofont-ul > li {\n  position: relative;\n}\n\n.icofont-li {\n  position: absolute;\n  left: -2.14285714em;\n  width: 2.14285714em;\n  top: 0.14285714em;\n  text-align: center;\n}\n\n/*Animation*/\n.icofont-rotate {\n  display: inline-block;\n  -webkit-animation: icofont-rotate 2s infinite linear;\n  animation: icofont-rotate 2s infinite linear;\n}\n\n@-webkit-keyframes icofont-rotate {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n@keyframes icofont-rotate {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n/*!\n *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */\n/* FONT PATH\n * -------------------------- */\n@font-face {\n  font-family: \"FontAwesome\";\n  src: url(\"../../../fonts/font-awesome/fontawesome-webfont.eot?v=4.7.0\");\n  src: url(\"../../../fonts/font-awesome/fontawesome-webfont.eot?#iefix&v=4.7.0\") format(\"embedded-opentype\"), url(\"../../../fonts/font-awesome/fontawesome-webfont.woff2?v=4.7.0\") format(\"woff2\"), url(\"../../../fonts/font-awesome/fontawesome-webfont.woff?v=4.7.0\") format(\"woff\"), url(\"../../../fonts/font-awesome/fontawesome-webfont.ttf?v=4.7.0\") format(\"truetype\"), url(\"../../../fonts/font-awesome/fontawesome-webfont.svg?v=4.7.0#fontawesomeregular\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n}\n.fa {\n  display: inline-block;\n  font: normal normal normal 14px/1 FontAwesome;\n  font-size: inherit;\n  text-rendering: auto;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* makes the font 33% larger relative to the icon container */\n.fa-lg {\n  font-size: 1.3333333333em;\n  line-height: 0.75em;\n  vertical-align: -15%;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-fw {\n  width: 1.2857142857em;\n  text-align: center;\n}\n\n.fa-ul {\n  padding-left: 0;\n  margin-left: 2.1428571429em;\n  list-style-type: none;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  position: absolute;\n  left: -2.1428571429em;\n  width: 2.1428571429em;\n  top: 0.1428571429em;\n  text-align: center;\n}\n.fa-li.fa-lg {\n  left: -1.8571428571em;\n}\n\n.fa-border {\n  padding: 0.2em 0.25em 0.15em;\n  border: solid 0.08em #eee;\n  border-radius: 0.1em;\n}\n\n.fa-pull-left {\n  float: left;\n}\n\n.fa-pull-right {\n  float: right;\n}\n\n.fa.fa-pull-left {\n  margin-right: 0.3em;\n}\n.fa.fa-pull-right {\n  margin-left: 0.3em;\n}\n\n/* Deprecated as of 4.4.0 */\n.pull-right {\n  float: right;\n}\n\n.pull-left {\n  float: left;\n}\n\n.fa.pull-left {\n  margin-right: 0.3em;\n}\n.fa.pull-right {\n  margin-left: 0.3em;\n}\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n  animation: fa-spin 2s infinite linear;\n}\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n  animation: fa-spin 1s infinite steps(8);\n}\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n.fa-rotate-90 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n  -webkit-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n  -webkit-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n  -webkit-transform: rotate(270deg);\n  -ms-transform: rotate(270deg);\n  transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\n  -webkit-transform: scale(-1, 1);\n  -ms-transform: scale(-1, 1);\n  transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(1, -1);\n  -ms-transform: scale(1, -1);\n  transform: scale(1, -1);\n}\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical {\n  filter: none;\n}\n\n.fa-stack {\n  position: relative;\n  display: inline-block;\n  width: 2em;\n  height: 2em;\n  line-height: 2em;\n  vertical-align: middle;\n}\n\n.fa-stack-1x, .fa-stack-2x {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  text-align: center;\n}\n\n.fa-stack-1x {\n  line-height: inherit;\n}\n\n.fa-stack-2x {\n  font-size: 2em;\n}\n\n.fa-inverse {\n  color: #fff;\n}\n\n/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen\n   readers do not read off random characters that represent icons */\n.fa-glass:before {\n  content: \"\\f000\";\n}\n\n.fa-music:before {\n  content: \"\\f001\";\n}\n\n.fa-search:before {\n  content: \"\\f002\";\n}\n\n.fa-envelope-o:before {\n  content: \"\\f003\";\n}\n\n.fa-heart:before {\n  content: \"\\f004\";\n}\n\n.fa-star:before {\n  content: \"\\f005\";\n}\n\n.fa-star-o:before {\n  content: \"\\f006\";\n}\n\n.fa-user:before {\n  content: \"\\f007\";\n}\n\n.fa-film:before {\n  content: \"\\f008\";\n}\n\n.fa-th-large:before {\n  content: \"\\f009\";\n}\n\n.fa-th:before {\n  content: \"\\f00a\";\n}\n\n.fa-th-list:before {\n  content: \"\\f00b\";\n}\n\n.fa-check:before {\n  content: \"\\f00c\";\n}\n\n.fa-remove:before,\n.fa-close:before,\n.fa-times:before {\n  content: \"\\f00d\";\n}\n\n.fa-search-plus:before {\n  content: \"\\f00e\";\n}\n\n.fa-search-minus:before {\n  content: \"\\f010\";\n}\n\n.fa-power-off:before {\n  content: \"\\f011\";\n}\n\n.fa-signal:before {\n  content: \"\\f012\";\n}\n\n.fa-gear:before,\n.fa-cog:before {\n  content: \"\\f013\";\n}\n\n.fa-trash-o:before {\n  content: \"\\f014\";\n}\n\n.fa-home:before {\n  content: \"\\f015\";\n}\n\n.fa-file-o:before {\n  content: \"\\f016\";\n}\n\n.fa-clock-o:before {\n  content: \"\\f017\";\n}\n\n.fa-road:before {\n  content: \"\\f018\";\n}\n\n.fa-download:before {\n  content: \"\\f019\";\n}\n\n.fa-arrow-circle-o-down:before {\n  content: \"\\f01a\";\n}\n\n.fa-arrow-circle-o-up:before {\n  content: \"\\f01b\";\n}\n\n.fa-inbox:before {\n  content: \"\\f01c\";\n}\n\n.fa-play-circle-o:before {\n  content: \"\\f01d\";\n}\n\n.fa-rotate-right:before,\n.fa-repeat:before {\n  content: \"\\f01e\";\n}\n\n.fa-refresh:before {\n  content: \"\\f021\";\n}\n\n.fa-list-alt:before {\n  content: \"\\f022\";\n}\n\n.fa-lock:before {\n  content: \"\\f023\";\n}\n\n.fa-flag:before {\n  content: \"\\f024\";\n}\n\n.fa-headphones:before {\n  content: \"\\f025\";\n}\n\n.fa-volume-off:before {\n  content: \"\\f026\";\n}\n\n.fa-volume-down:before {\n  content: \"\\f027\";\n}\n\n.fa-volume-up:before {\n  content: \"\\f028\";\n}\n\n.fa-qrcode:before {\n  content: \"\\f029\";\n}\n\n.fa-barcode:before {\n  content: \"\\f02a\";\n}\n\n.fa-tag:before {\n  content: \"\\f02b\";\n}\n\n.fa-tags:before {\n  content: \"\\f02c\";\n}\n\n.fa-book:before {\n  content: \"\\f02d\";\n}\n\n.fa-bookmark:before {\n  content: \"\\f02e\";\n}\n\n.fa-print:before {\n  content: \"\\f02f\";\n}\n\n.fa-camera:before {\n  content: \"\\f030\";\n}\n\n.fa-font:before {\n  content: \"\\f031\";\n}\n\n.fa-bold:before {\n  content: \"\\f032\";\n}\n\n.fa-italic:before {\n  content: \"\\f033\";\n}\n\n.fa-text-height:before {\n  content: \"\\f034\";\n}\n\n.fa-text-width:before {\n  content: \"\\f035\";\n}\n\n.fa-align-left:before {\n  content: \"\\f036\";\n}\n\n.fa-align-center:before {\n  content: \"\\f037\";\n}\n\n.fa-align-right:before {\n  content: \"\\f038\";\n}\n\n.fa-align-justify:before {\n  content: \"\\f039\";\n}\n\n.fa-list:before {\n  content: \"\\f03a\";\n}\n\n.fa-dedent:before,\n.fa-outdent:before {\n  content: \"\\f03b\";\n}\n\n.fa-indent:before {\n  content: \"\\f03c\";\n}\n\n.fa-video-camera:before {\n  content: \"\\f03d\";\n}\n\n.fa-photo:before,\n.fa-image:before,\n.fa-picture-o:before {\n  content: \"\\f03e\";\n}\n\n.fa-pencil:before {\n  content: \"\\f040\";\n}\n\n.fa-map-marker:before {\n  content: \"\\f041\";\n}\n\n.fa-adjust:before {\n  content: \"\\f042\";\n}\n\n.fa-tint:before {\n  content: \"\\f043\";\n}\n\n.fa-edit:before,\n.fa-pencil-square-o:before {\n  content: \"\\f044\";\n}\n\n.fa-share-square-o:before {\n  content: \"\\f045\";\n}\n\n.fa-check-square-o:before {\n  content: \"\\f046\";\n}\n\n.fa-arrows:before {\n  content: \"\\f047\";\n}\n\n.fa-step-backward:before {\n  content: \"\\f048\";\n}\n\n.fa-fast-backward:before {\n  content: \"\\f049\";\n}\n\n.fa-backward:before {\n  content: \"\\f04a\";\n}\n\n.fa-play:before {\n  content: \"\\f04b\";\n}\n\n.fa-pause:before {\n  content: \"\\f04c\";\n}\n\n.fa-stop:before {\n  content: \"\\f04d\";\n}\n\n.fa-forward:before {\n  content: \"\\f04e\";\n}\n\n.fa-fast-forward:before {\n  content: \"\\f050\";\n}\n\n.fa-step-forward:before {\n  content: \"\\f051\";\n}\n\n.fa-eject:before {\n  content: \"\\f052\";\n}\n\n.fa-chevron-left:before {\n  content: \"\\f053\";\n}\n\n.fa-chevron-right:before {\n  content: \"\\f054\";\n}\n\n.fa-plus-circle:before {\n  content: \"\\f055\";\n}\n\n.fa-minus-circle:before {\n  content: \"\\f056\";\n}\n\n.fa-times-circle:before {\n  content: \"\\f057\";\n}\n\n.fa-check-circle:before {\n  content: \"\\f058\";\n}\n\n.fa-question-circle:before {\n  content: \"\\f059\";\n}\n\n.fa-info-circle:before {\n  content: \"\\f05a\";\n}\n\n.fa-crosshairs:before {\n  content: \"\\f05b\";\n}\n\n.fa-times-circle-o:before {\n  content: \"\\f05c\";\n}\n\n.fa-check-circle-o:before {\n  content: \"\\f05d\";\n}\n\n.fa-ban:before {\n  content: \"\\f05e\";\n}\n\n.fa-arrow-left:before {\n  content: \"\\f060\";\n}\n\n.fa-arrow-right:before {\n  content: \"\\f061\";\n}\n\n.fa-arrow-up:before {\n  content: \"\\f062\";\n}\n\n.fa-arrow-down:before {\n  content: \"\\f063\";\n}\n\n.fa-mail-forward:before,\n.fa-share:before {\n  content: \"\\f064\";\n}\n\n.fa-expand:before {\n  content: \"\\f065\";\n}\n\n.fa-compress:before {\n  content: \"\\f066\";\n}\n\n.fa-plus:before {\n  content: \"\\f067\";\n}\n\n.fa-minus:before {\n  content: \"\\f068\";\n}\n\n.fa-asterisk:before {\n  content: \"\\f069\";\n}\n\n.fa-exclamation-circle:before {\n  content: \"\\f06a\";\n}\n\n.fa-gift:before {\n  content: \"\\f06b\";\n}\n\n.fa-leaf:before {\n  content: \"\\f06c\";\n}\n\n.fa-fire:before {\n  content: \"\\f06d\";\n}\n\n.fa-eye:before {\n  content: \"\\f06e\";\n}\n\n.fa-eye-slash:before {\n  content: \"\\f070\";\n}\n\n.fa-warning:before,\n.fa-exclamation-triangle:before {\n  content: \"\\f071\";\n}\n\n.fa-plane:before {\n  content: \"\\f072\";\n}\n\n.fa-calendar:before {\n  content: \"\\f073\";\n}\n\n.fa-random:before {\n  content: \"\\f074\";\n}\n\n.fa-comment:before {\n  content: \"\\f075\";\n}\n\n.fa-magnet:before {\n  content: \"\\f076\";\n}\n\n.fa-chevron-up:before {\n  content: \"\\f077\";\n}\n\n.fa-chevron-down:before {\n  content: \"\\f078\";\n}\n\n.fa-retweet:before {\n  content: \"\\f079\";\n}\n\n.fa-shopping-cart:before {\n  content: \"\\f07a\";\n}\n\n.fa-folder:before {\n  content: \"\\f07b\";\n}\n\n.fa-folder-open:before {\n  content: \"\\f07c\";\n}\n\n.fa-arrows-v:before {\n  content: \"\\f07d\";\n}\n\n.fa-arrows-h:before {\n  content: \"\\f07e\";\n}\n\n.fa-bar-chart-o:before,\n.fa-bar-chart:before {\n  content: \"\\f080\";\n}\n\n.fa-twitter-square:before {\n  content: \"\\f081\";\n}\n\n.fa-facebook-square:before {\n  content: \"\\f082\";\n}\n\n.fa-camera-retro:before {\n  content: \"\\f083\";\n}\n\n.fa-key:before {\n  content: \"\\f084\";\n}\n\n.fa-gears:before,\n.fa-cogs:before {\n  content: \"\\f085\";\n}\n\n.fa-comments:before {\n  content: \"\\f086\";\n}\n\n.fa-thumbs-o-up:before {\n  content: \"\\f087\";\n}\n\n.fa-thumbs-o-down:before {\n  content: \"\\f088\";\n}\n\n.fa-star-half:before {\n  content: \"\\f089\";\n}\n\n.fa-heart-o:before {\n  content: \"\\f08a\";\n}\n\n.fa-sign-out:before {\n  content: \"\\f08b\";\n}\n\n.fa-linkedin-square:before {\n  content: \"\\f08c\";\n}\n\n.fa-thumb-tack:before {\n  content: \"\\f08d\";\n}\n\n.fa-external-link:before {\n  content: \"\\f08e\";\n}\n\n.fa-sign-in:before {\n  content: \"\\f090\";\n}\n\n.fa-trophy:before {\n  content: \"\\f091\";\n}\n\n.fa-github-square:before {\n  content: \"\\f092\";\n}\n\n.fa-upload:before {\n  content: \"\\f093\";\n}\n\n.fa-lemon-o:before {\n  content: \"\\f094\";\n}\n\n.fa-phone:before {\n  content: \"\\f095\";\n}\n\n.fa-square-o:before {\n  content: \"\\f096\";\n}\n\n.fa-bookmark-o:before {\n  content: \"\\f097\";\n}\n\n.fa-phone-square:before {\n  content: \"\\f098\";\n}\n\n.fa-twitter:before {\n  content: \"\\f099\";\n}\n\n.fa-facebook-f:before,\n.fa-facebook:before {\n  content: \"\\f09a\";\n}\n\n.fa-github:before {\n  content: \"\\f09b\";\n}\n\n.fa-unlock:before {\n  content: \"\\f09c\";\n}\n\n.fa-credit-card:before {\n  content: \"\\f09d\";\n}\n\n.fa-feed:before,\n.fa-rss:before {\n  content: \"\\f09e\";\n}\n\n.fa-hdd-o:before {\n  content: \"\\f0a0\";\n}\n\n.fa-bullhorn:before {\n  content: \"\\f0a1\";\n}\n\n.fa-bell:before {\n  content: \"\\f0f3\";\n}\n\n.fa-certificate:before {\n  content: \"\\f0a3\";\n}\n\n.fa-hand-o-right:before {\n  content: \"\\f0a4\";\n}\n\n.fa-hand-o-left:before {\n  content: \"\\f0a5\";\n}\n\n.fa-hand-o-up:before {\n  content: \"\\f0a6\";\n}\n\n.fa-hand-o-down:before {\n  content: \"\\f0a7\";\n}\n\n.fa-arrow-circle-left:before {\n  content: \"\\f0a8\";\n}\n\n.fa-arrow-circle-right:before {\n  content: \"\\f0a9\";\n}\n\n.fa-arrow-circle-up:before {\n  content: \"\\f0aa\";\n}\n\n.fa-arrow-circle-down:before {\n  content: \"\\f0ab\";\n}\n\n.fa-globe:before {\n  content: \"\\f0ac\";\n}\n\n.fa-wrench:before {\n  content: \"\\f0ad\";\n}\n\n.fa-tasks:before {\n  content: \"\\f0ae\";\n}\n\n.fa-filter:before {\n  content: \"\\f0b0\";\n}\n\n.fa-briefcase:before {\n  content: \"\\f0b1\";\n}\n\n.fa-arrows-alt:before {\n  content: \"\\f0b2\";\n}\n\n.fa-group:before,\n.fa-users:before {\n  content: \"\\f0c0\";\n}\n\n.fa-chain:before,\n.fa-link:before {\n  content: \"\\f0c1\";\n}\n\n.fa-cloud:before {\n  content: \"\\f0c2\";\n}\n\n.fa-flask:before {\n  content: \"\\f0c3\";\n}\n\n.fa-cut:before,\n.fa-scissors:before {\n  content: \"\\f0c4\";\n}\n\n.fa-copy:before,\n.fa-files-o:before {\n  content: \"\\f0c5\";\n}\n\n.fa-paperclip:before {\n  content: \"\\f0c6\";\n}\n\n.fa-save:before,\n.fa-floppy-o:before {\n  content: \"\\f0c7\";\n}\n\n.fa-square:before {\n  content: \"\\f0c8\";\n}\n\n.fa-navicon:before,\n.fa-reorder:before,\n.fa-bars:before {\n  content: \"\\f0c9\";\n}\n\n.fa-list-ul:before {\n  content: \"\\f0ca\";\n}\n\n.fa-list-ol:before {\n  content: \"\\f0cb\";\n}\n\n.fa-strikethrough:before {\n  content: \"\\f0cc\";\n}\n\n.fa-underline:before {\n  content: \"\\f0cd\";\n}\n\n.fa-table:before {\n  content: \"\\f0ce\";\n}\n\n.fa-magic:before {\n  content: \"\\f0d0\";\n}\n\n.fa-truck:before {\n  content: \"\\f0d1\";\n}\n\n.fa-pinterest:before {\n  content: \"\\f0d2\";\n}\n\n.fa-pinterest-square:before {\n  content: \"\\f0d3\";\n}\n\n.fa-google-plus-square:before {\n  content: \"\\f0d4\";\n}\n\n.fa-google-plus:before {\n  content: \"\\f0d5\";\n}\n\n.fa-money:before {\n  content: \"\\f0d6\";\n}\n\n.fa-caret-down:before {\n  content: \"\\f0d7\";\n}\n\n.fa-caret-up:before {\n  content: \"\\f0d8\";\n}\n\n.fa-caret-left:before {\n  content: \"\\f0d9\";\n}\n\n.fa-caret-right:before {\n  content: \"\\f0da\";\n}\n\n.fa-columns:before {\n  content: \"\\f0db\";\n}\n\n.fa-unsorted:before,\n.fa-sort:before {\n  content: \"\\f0dc\";\n}\n\n.fa-sort-down:before,\n.fa-sort-desc:before {\n  content: \"\\f0dd\";\n}\n\n.fa-sort-up:before,\n.fa-sort-asc:before {\n  content: \"\\f0de\";\n}\n\n.fa-envelope:before {\n  content: \"\\f0e0\";\n}\n\n.fa-linkedin:before {\n  content: \"\\f0e1\";\n}\n\n.fa-rotate-left:before,\n.fa-undo:before {\n  content: \"\\f0e2\";\n}\n\n.fa-legal:before,\n.fa-gavel:before {\n  content: \"\\f0e3\";\n}\n\n.fa-dashboard:before,\n.fa-tachometer:before {\n  content: \"\\f0e4\";\n}\n\n.fa-comment-o:before {\n  content: \"\\f0e5\";\n}\n\n.fa-comments-o:before {\n  content: \"\\f0e6\";\n}\n\n.fa-flash:before,\n.fa-bolt:before {\n  content: \"\\f0e7\";\n}\n\n.fa-sitemap:before {\n  content: \"\\f0e8\";\n}\n\n.fa-umbrella:before {\n  content: \"\\f0e9\";\n}\n\n.fa-paste:before,\n.fa-clipboard:before {\n  content: \"\\f0ea\";\n}\n\n.fa-lightbulb-o:before {\n  content: \"\\f0eb\";\n}\n\n.fa-exchange:before {\n  content: \"\\f0ec\";\n}\n\n.fa-cloud-download:before {\n  content: \"\\f0ed\";\n}\n\n.fa-cloud-upload:before {\n  content: \"\\f0ee\";\n}\n\n.fa-user-md:before {\n  content: \"\\f0f0\";\n}\n\n.fa-stethoscope:before {\n  content: \"\\f0f1\";\n}\n\n.fa-suitcase:before {\n  content: \"\\f0f2\";\n}\n\n.fa-bell-o:before {\n  content: \"\\f0a2\";\n}\n\n.fa-coffee:before {\n  content: \"\\f0f4\";\n}\n\n.fa-cutlery:before {\n  content: \"\\f0f5\";\n}\n\n.fa-file-text-o:before {\n  content: \"\\f0f6\";\n}\n\n.fa-building-o:before {\n  content: \"\\f0f7\";\n}\n\n.fa-hospital-o:before {\n  content: \"\\f0f8\";\n}\n\n.fa-ambulance:before {\n  content: \"\\f0f9\";\n}\n\n.fa-medkit:before {\n  content: \"\\f0fa\";\n}\n\n.fa-fighter-jet:before {\n  content: \"\\f0fb\";\n}\n\n.fa-beer:before {\n  content: \"\\f0fc\";\n}\n\n.fa-h-square:before {\n  content: \"\\f0fd\";\n}\n\n.fa-plus-square:before {\n  content: \"\\f0fe\";\n}\n\n.fa-angle-double-left:before {\n  content: \"\\f100\";\n}\n\n.fa-angle-double-right:before {\n  content: \"\\f101\";\n}\n\n.fa-angle-double-up:before {\n  content: \"\\f102\";\n}\n\n.fa-angle-double-down:before {\n  content: \"\\f103\";\n}\n\n.fa-angle-left:before {\n  content: \"\\f104\";\n}\n\n.fa-angle-right:before {\n  content: \"\\f105\";\n}\n\n.fa-angle-up:before {\n  content: \"\\f106\";\n}\n\n.fa-angle-down:before {\n  content: \"\\f107\";\n}\n\n.fa-desktop:before {\n  content: \"\\f108\";\n}\n\n.fa-laptop:before {\n  content: \"\\f109\";\n}\n\n.fa-tablet:before {\n  content: \"\\f10a\";\n}\n\n.fa-mobile-phone:before,\n.fa-mobile:before {\n  content: \"\\f10b\";\n}\n\n.fa-circle-o:before {\n  content: \"\\f10c\";\n}\n\n.fa-quote-left:before {\n  content: \"\\f10d\";\n}\n\n.fa-quote-right:before {\n  content: \"\\f10e\";\n}\n\n.fa-spinner:before {\n  content: \"\\f110\";\n}\n\n.fa-circle:before {\n  content: \"\\f111\";\n}\n\n.fa-mail-reply:before,\n.fa-reply:before {\n  content: \"\\f112\";\n}\n\n.fa-github-alt:before {\n  content: \"\\f113\";\n}\n\n.fa-folder-o:before {\n  content: \"\\f114\";\n}\n\n.fa-folder-open-o:before {\n  content: \"\\f115\";\n}\n\n.fa-smile-o:before {\n  content: \"\\f118\";\n}\n\n.fa-frown-o:before {\n  content: \"\\f119\";\n}\n\n.fa-meh-o:before {\n  content: \"\\f11a\";\n}\n\n.fa-gamepad:before {\n  content: \"\\f11b\";\n}\n\n.fa-keyboard-o:before {\n  content: \"\\f11c\";\n}\n\n.fa-flag-o:before {\n  content: \"\\f11d\";\n}\n\n.fa-flag-checkered:before {\n  content: \"\\f11e\";\n}\n\n.fa-terminal:before {\n  content: \"\\f120\";\n}\n\n.fa-code:before {\n  content: \"\\f121\";\n}\n\n.fa-mail-reply-all:before,\n.fa-reply-all:before {\n  content: \"\\f122\";\n}\n\n.fa-star-half-empty:before,\n.fa-star-half-full:before,\n.fa-star-half-o:before {\n  content: \"\\f123\";\n}\n\n.fa-location-arrow:before {\n  content: \"\\f124\";\n}\n\n.fa-crop:before {\n  content: \"\\f125\";\n}\n\n.fa-code-fork:before {\n  content: \"\\f126\";\n}\n\n.fa-unlink:before,\n.fa-chain-broken:before {\n  content: \"\\f127\";\n}\n\n.fa-question:before {\n  content: \"\\f128\";\n}\n\n.fa-info:before {\n  content: \"\\f129\";\n}\n\n.fa-exclamation:before {\n  content: \"\\f12a\";\n}\n\n.fa-superscript:before {\n  content: \"\\f12b\";\n}\n\n.fa-subscript:before {\n  content: \"\\f12c\";\n}\n\n.fa-eraser:before {\n  content: \"\\f12d\";\n}\n\n.fa-puzzle-piece:before {\n  content: \"\\f12e\";\n}\n\n.fa-microphone:before {\n  content: \"\\f130\";\n}\n\n.fa-microphone-slash:before {\n  content: \"\\f131\";\n}\n\n.fa-shield:before {\n  content: \"\\f132\";\n}\n\n.fa-calendar-o:before {\n  content: \"\\f133\";\n}\n\n.fa-fire-extinguisher:before {\n  content: \"\\f134\";\n}\n\n.fa-rocket:before {\n  content: \"\\f135\";\n}\n\n.fa-maxcdn:before {\n  content: \"\\f136\";\n}\n\n.fa-chevron-circle-left:before {\n  content: \"\\f137\";\n}\n\n.fa-chevron-circle-right:before {\n  content: \"\\f138\";\n}\n\n.fa-chevron-circle-up:before {\n  content: \"\\f139\";\n}\n\n.fa-chevron-circle-down:before {\n  content: \"\\f13a\";\n}\n\n.fa-html5:before {\n  content: \"\\f13b\";\n}\n\n.fa-css3:before {\n  content: \"\\f13c\";\n}\n\n.fa-anchor:before {\n  content: \"\\f13d\";\n}\n\n.fa-unlock-alt:before {\n  content: \"\\f13e\";\n}\n\n.fa-bullseye:before {\n  content: \"\\f140\";\n}\n\n.fa-ellipsis-h:before {\n  content: \"\\f141\";\n}\n\n.fa-ellipsis-v:before {\n  content: \"\\f142\";\n}\n\n.fa-rss-square:before {\n  content: \"\\f143\";\n}\n\n.fa-play-circle:before {\n  content: \"\\f144\";\n}\n\n.fa-ticket:before {\n  content: \"\\f145\";\n}\n\n.fa-minus-square:before {\n  content: \"\\f146\";\n}\n\n.fa-minus-square-o:before {\n  content: \"\\f147\";\n}\n\n.fa-level-up:before {\n  content: \"\\f148\";\n}\n\n.fa-level-down:before {\n  content: \"\\f149\";\n}\n\n.fa-check-square:before {\n  content: \"\\f14a\";\n}\n\n.fa-pencil-square:before {\n  content: \"\\f14b\";\n}\n\n.fa-external-link-square:before {\n  content: \"\\f14c\";\n}\n\n.fa-share-square:before {\n  content: \"\\f14d\";\n}\n\n.fa-compass:before {\n  content: \"\\f14e\";\n}\n\n.fa-toggle-down:before,\n.fa-caret-square-o-down:before {\n  content: \"\\f150\";\n}\n\n.fa-toggle-up:before,\n.fa-caret-square-o-up:before {\n  content: \"\\f151\";\n}\n\n.fa-toggle-right:before,\n.fa-caret-square-o-right:before {\n  content: \"\\f152\";\n}\n\n.fa-euro:before,\n.fa-eur:before {\n  content: \"\\f153\";\n}\n\n.fa-gbp:before {\n  content: \"\\f154\";\n}\n\n.fa-dollar:before,\n.fa-usd:before {\n  content: \"\\f155\";\n}\n\n.fa-rupee:before,\n.fa-inr:before {\n  content: \"\\f156\";\n}\n\n.fa-cny:before,\n.fa-rmb:before,\n.fa-yen:before,\n.fa-jpy:before {\n  content: \"\\f157\";\n}\n\n.fa-ruble:before,\n.fa-rouble:before,\n.fa-rub:before {\n  content: \"\\f158\";\n}\n\n.fa-won:before,\n.fa-krw:before {\n  content: \"\\f159\";\n}\n\n.fa-bitcoin:before,\n.fa-btc:before {\n  content: \"\\f15a\";\n}\n\n.fa-file:before {\n  content: \"\\f15b\";\n}\n\n.fa-file-text:before {\n  content: \"\\f15c\";\n}\n\n.fa-sort-alpha-asc:before {\n  content: \"\\f15d\";\n}\n\n.fa-sort-alpha-desc:before {\n  content: \"\\f15e\";\n}\n\n.fa-sort-amount-asc:before {\n  content: \"\\f160\";\n}\n\n.fa-sort-amount-desc:before {\n  content: \"\\f161\";\n}\n\n.fa-sort-numeric-asc:before {\n  content: \"\\f162\";\n}\n\n.fa-sort-numeric-desc:before {\n  content: \"\\f163\";\n}\n\n.fa-thumbs-up:before {\n  content: \"\\f164\";\n}\n\n.fa-thumbs-down:before {\n  content: \"\\f165\";\n}\n\n.fa-youtube-square:before {\n  content: \"\\f166\";\n}\n\n.fa-youtube:before {\n  content: \"\\f167\";\n}\n\n.fa-xing:before {\n  content: \"\\f168\";\n}\n\n.fa-xing-square:before {\n  content: \"\\f169\";\n}\n\n.fa-youtube-play:before {\n  content: \"\\f16a\";\n}\n\n.fa-dropbox:before {\n  content: \"\\f16b\";\n}\n\n.fa-stack-overflow:before {\n  content: \"\\f16c\";\n}\n\n.fa-instagram:before {\n  content: \"\\f16d\";\n}\n\n.fa-flickr:before {\n  content: \"\\f16e\";\n}\n\n.fa-adn:before {\n  content: \"\\f170\";\n}\n\n.fa-bitbucket:before {\n  content: \"\\f171\";\n}\n\n.fa-bitbucket-square:before {\n  content: \"\\f172\";\n}\n\n.fa-tumblr:before {\n  content: \"\\f173\";\n}\n\n.fa-tumblr-square:before {\n  content: \"\\f174\";\n}\n\n.fa-long-arrow-down:before {\n  content: \"\\f175\";\n}\n\n.fa-long-arrow-up:before {\n  content: \"\\f176\";\n}\n\n.fa-long-arrow-left:before {\n  content: \"\\f177\";\n}\n\n.fa-long-arrow-right:before {\n  content: \"\\f178\";\n}\n\n.fa-apple:before {\n  content: \"\\f179\";\n}\n\n.fa-windows:before {\n  content: \"\\f17a\";\n}\n\n.fa-android:before {\n  content: \"\\f17b\";\n}\n\n.fa-linux:before {\n  content: \"\\f17c\";\n}\n\n.fa-dribbble:before {\n  content: \"\\f17d\";\n}\n\n.fa-skype:before {\n  content: \"\\f17e\";\n}\n\n.fa-foursquare:before {\n  content: \"\\f180\";\n}\n\n.fa-trello:before {\n  content: \"\\f181\";\n}\n\n.fa-female:before {\n  content: \"\\f182\";\n}\n\n.fa-male:before {\n  content: \"\\f183\";\n}\n\n.fa-gittip:before,\n.fa-gratipay:before {\n  content: \"\\f184\";\n}\n\n.fa-sun-o:before {\n  content: \"\\f185\";\n}\n\n.fa-moon-o:before {\n  content: \"\\f186\";\n}\n\n.fa-archive:before {\n  content: \"\\f187\";\n}\n\n.fa-bug:before {\n  content: \"\\f188\";\n}\n\n.fa-vk:before {\n  content: \"\\f189\";\n}\n\n.fa-weibo:before {\n  content: \"\\f18a\";\n}\n\n.fa-renren:before {\n  content: \"\\f18b\";\n}\n\n.fa-pagelines:before {\n  content: \"\\f18c\";\n}\n\n.fa-stack-exchange:before {\n  content: \"\\f18d\";\n}\n\n.fa-arrow-circle-o-right:before {\n  content: \"\\f18e\";\n}\n\n.fa-arrow-circle-o-left:before {\n  content: \"\\f190\";\n}\n\n.fa-toggle-left:before,\n.fa-caret-square-o-left:before {\n  content: \"\\f191\";\n}\n\n.fa-dot-circle-o:before {\n  content: \"\\f192\";\n}\n\n.fa-wheelchair:before {\n  content: \"\\f193\";\n}\n\n.fa-vimeo-square:before {\n  content: \"\\f194\";\n}\n\n.fa-turkish-lira:before,\n.fa-try:before {\n  content: \"\\f195\";\n}\n\n.fa-plus-square-o:before {\n  content: \"\\f196\";\n}\n\n.fa-space-shuttle:before {\n  content: \"\\f197\";\n}\n\n.fa-slack:before {\n  content: \"\\f198\";\n}\n\n.fa-envelope-square:before {\n  content: \"\\f199\";\n}\n\n.fa-wordpress:before {\n  content: \"\\f19a\";\n}\n\n.fa-openid:before {\n  content: \"\\f19b\";\n}\n\n.fa-institution:before,\n.fa-bank:before,\n.fa-university:before {\n  content: \"\\f19c\";\n}\n\n.fa-mortar-board:before,\n.fa-graduation-cap:before {\n  content: \"\\f19d\";\n}\n\n.fa-yahoo:before {\n  content: \"\\f19e\";\n}\n\n.fa-google:before {\n  content: \"\\f1a0\";\n}\n\n.fa-reddit:before {\n  content: \"\\f1a1\";\n}\n\n.fa-reddit-square:before {\n  content: \"\\f1a2\";\n}\n\n.fa-stumbleupon-circle:before {\n  content: \"\\f1a3\";\n}\n\n.fa-stumbleupon:before {\n  content: \"\\f1a4\";\n}\n\n.fa-delicious:before {\n  content: \"\\f1a5\";\n}\n\n.fa-digg:before {\n  content: \"\\f1a6\";\n}\n\n.fa-pied-piper-pp:before {\n  content: \"\\f1a7\";\n}\n\n.fa-pied-piper-alt:before {\n  content: \"\\f1a8\";\n}\n\n.fa-drupal:before {\n  content: \"\\f1a9\";\n}\n\n.fa-joomla:before {\n  content: \"\\f1aa\";\n}\n\n.fa-language:before {\n  content: \"\\f1ab\";\n}\n\n.fa-fax:before {\n  content: \"\\f1ac\";\n}\n\n.fa-building:before {\n  content: \"\\f1ad\";\n}\n\n.fa-child:before {\n  content: \"\\f1ae\";\n}\n\n.fa-paw:before {\n  content: \"\\f1b0\";\n}\n\n.fa-spoon:before {\n  content: \"\\f1b1\";\n}\n\n.fa-cube:before {\n  content: \"\\f1b2\";\n}\n\n.fa-cubes:before {\n  content: \"\\f1b3\";\n}\n\n.fa-behance:before {\n  content: \"\\f1b4\";\n}\n\n.fa-behance-square:before {\n  content: \"\\f1b5\";\n}\n\n.fa-steam:before {\n  content: \"\\f1b6\";\n}\n\n.fa-steam-square:before {\n  content: \"\\f1b7\";\n}\n\n.fa-recycle:before {\n  content: \"\\f1b8\";\n}\n\n.fa-automobile:before,\n.fa-car:before {\n  content: \"\\f1b9\";\n}\n\n.fa-cab:before,\n.fa-taxi:before {\n  content: \"\\f1ba\";\n}\n\n.fa-tree:before {\n  content: \"\\f1bb\";\n}\n\n.fa-spotify:before {\n  content: \"\\f1bc\";\n}\n\n.fa-deviantart:before {\n  content: \"\\f1bd\";\n}\n\n.fa-soundcloud:before {\n  content: \"\\f1be\";\n}\n\n.fa-database:before {\n  content: \"\\f1c0\";\n}\n\n.fa-file-pdf-o:before {\n  content: \"\\f1c1\";\n}\n\n.fa-file-word-o:before {\n  content: \"\\f1c2\";\n}\n\n.fa-file-excel-o:before {\n  content: \"\\f1c3\";\n}\n\n.fa-file-powerpoint-o:before {\n  content: \"\\f1c4\";\n}\n\n.fa-file-photo-o:before,\n.fa-file-picture-o:before,\n.fa-file-image-o:before {\n  content: \"\\f1c5\";\n}\n\n.fa-file-zip-o:before,\n.fa-file-archive-o:before {\n  content: \"\\f1c6\";\n}\n\n.fa-file-sound-o:before,\n.fa-file-audio-o:before {\n  content: \"\\f1c7\";\n}\n\n.fa-file-movie-o:before,\n.fa-file-video-o:before {\n  content: \"\\f1c8\";\n}\n\n.fa-file-code-o:before {\n  content: \"\\f1c9\";\n}\n\n.fa-vine:before {\n  content: \"\\f1ca\";\n}\n\n.fa-codepen:before {\n  content: \"\\f1cb\";\n}\n\n.fa-jsfiddle:before {\n  content: \"\\f1cc\";\n}\n\n.fa-life-bouy:before,\n.fa-life-buoy:before,\n.fa-life-saver:before,\n.fa-support:before,\n.fa-life-ring:before {\n  content: \"\\f1cd\";\n}\n\n.fa-circle-o-notch:before {\n  content: \"\\f1ce\";\n}\n\n.fa-ra:before,\n.fa-resistance:before,\n.fa-rebel:before {\n  content: \"\\f1d0\";\n}\n\n.fa-ge:before,\n.fa-empire:before {\n  content: \"\\f1d1\";\n}\n\n.fa-git-square:before {\n  content: \"\\f1d2\";\n}\n\n.fa-git:before {\n  content: \"\\f1d3\";\n}\n\n.fa-y-combinator-square:before,\n.fa-yc-square:before,\n.fa-hacker-news:before {\n  content: \"\\f1d4\";\n}\n\n.fa-tencent-weibo:before {\n  content: \"\\f1d5\";\n}\n\n.fa-qq:before {\n  content: \"\\f1d6\";\n}\n\n.fa-wechat:before,\n.fa-weixin:before {\n  content: \"\\f1d7\";\n}\n\n.fa-send:before,\n.fa-paper-plane:before {\n  content: \"\\f1d8\";\n}\n\n.fa-send-o:before,\n.fa-paper-plane-o:before {\n  content: \"\\f1d9\";\n}\n\n.fa-history:before {\n  content: \"\\f1da\";\n}\n\n.fa-circle-thin:before {\n  content: \"\\f1db\";\n}\n\n.fa-header:before {\n  content: \"\\f1dc\";\n}\n\n.fa-paragraph:before {\n  content: \"\\f1dd\";\n}\n\n.fa-sliders:before {\n  content: \"\\f1de\";\n}\n\n.fa-share-alt:before {\n  content: \"\\f1e0\";\n}\n\n.fa-share-alt-square:before {\n  content: \"\\f1e1\";\n}\n\n.fa-bomb:before {\n  content: \"\\f1e2\";\n}\n\n.fa-soccer-ball-o:before,\n.fa-futbol-o:before {\n  content: \"\\f1e3\";\n}\n\n.fa-tty:before {\n  content: \"\\f1e4\";\n}\n\n.fa-binoculars:before {\n  content: \"\\f1e5\";\n}\n\n.fa-plug:before {\n  content: \"\\f1e6\";\n}\n\n.fa-slideshare:before {\n  content: \"\\f1e7\";\n}\n\n.fa-twitch:before {\n  content: \"\\f1e8\";\n}\n\n.fa-yelp:before {\n  content: \"\\f1e9\";\n}\n\n.fa-newspaper-o:before {\n  content: \"\\f1ea\";\n}\n\n.fa-wifi:before {\n  content: \"\\f1eb\";\n}\n\n.fa-calculator:before {\n  content: \"\\f1ec\";\n}\n\n.fa-paypal:before {\n  content: \"\\f1ed\";\n}\n\n.fa-google-wallet:before {\n  content: \"\\f1ee\";\n}\n\n.fa-cc-visa:before {\n  content: \"\\f1f0\";\n}\n\n.fa-cc-mastercard:before {\n  content: \"\\f1f1\";\n}\n\n.fa-cc-discover:before {\n  content: \"\\f1f2\";\n}\n\n.fa-cc-amex:before {\n  content: \"\\f1f3\";\n}\n\n.fa-cc-paypal:before {\n  content: \"\\f1f4\";\n}\n\n.fa-cc-stripe:before {\n  content: \"\\f1f5\";\n}\n\n.fa-bell-slash:before {\n  content: \"\\f1f6\";\n}\n\n.fa-bell-slash-o:before {\n  content: \"\\f1f7\";\n}\n\n.fa-trash:before {\n  content: \"\\f1f8\";\n}\n\n.fa-copyright:before {\n  content: \"\\f1f9\";\n}\n\n.fa-at:before {\n  content: \"\\f1fa\";\n}\n\n.fa-eyedropper:before {\n  content: \"\\f1fb\";\n}\n\n.fa-paint-brush:before {\n  content: \"\\f1fc\";\n}\n\n.fa-birthday-cake:before {\n  content: \"\\f1fd\";\n}\n\n.fa-area-chart:before {\n  content: \"\\f1fe\";\n}\n\n.fa-pie-chart:before {\n  content: \"\\f200\";\n}\n\n.fa-line-chart:before {\n  content: \"\\f201\";\n}\n\n.fa-lastfm:before {\n  content: \"\\f202\";\n}\n\n.fa-lastfm-square:before {\n  content: \"\\f203\";\n}\n\n.fa-toggle-off:before {\n  content: \"\\f204\";\n}\n\n.fa-toggle-on:before {\n  content: \"\\f205\";\n}\n\n.fa-bicycle:before {\n  content: \"\\f206\";\n}\n\n.fa-bus:before {\n  content: \"\\f207\";\n}\n\n.fa-ioxhost:before {\n  content: \"\\f208\";\n}\n\n.fa-angellist:before {\n  content: \"\\f209\";\n}\n\n.fa-cc:before {\n  content: \"\\f20a\";\n}\n\n.fa-shekel:before,\n.fa-sheqel:before,\n.fa-ils:before {\n  content: \"\\f20b\";\n}\n\n.fa-meanpath:before {\n  content: \"\\f20c\";\n}\n\n.fa-buysellads:before {\n  content: \"\\f20d\";\n}\n\n.fa-connectdevelop:before {\n  content: \"\\f20e\";\n}\n\n.fa-dashcube:before {\n  content: \"\\f210\";\n}\n\n.fa-forumbee:before {\n  content: \"\\f211\";\n}\n\n.fa-leanpub:before {\n  content: \"\\f212\";\n}\n\n.fa-sellsy:before {\n  content: \"\\f213\";\n}\n\n.fa-shirtsinbulk:before {\n  content: \"\\f214\";\n}\n\n.fa-simplybuilt:before {\n  content: \"\\f215\";\n}\n\n.fa-skyatlas:before {\n  content: \"\\f216\";\n}\n\n.fa-cart-plus:before {\n  content: \"\\f217\";\n}\n\n.fa-cart-arrow-down:before {\n  content: \"\\f218\";\n}\n\n.fa-diamond:before {\n  content: \"\\f219\";\n}\n\n.fa-ship:before {\n  content: \"\\f21a\";\n}\n\n.fa-user-secret:before {\n  content: \"\\f21b\";\n}\n\n.fa-motorcycle:before {\n  content: \"\\f21c\";\n}\n\n.fa-street-view:before {\n  content: \"\\f21d\";\n}\n\n.fa-heartbeat:before {\n  content: \"\\f21e\";\n}\n\n.fa-venus:before {\n  content: \"\\f221\";\n}\n\n.fa-mars:before {\n  content: \"\\f222\";\n}\n\n.fa-mercury:before {\n  content: \"\\f223\";\n}\n\n.fa-intersex:before,\n.fa-transgender:before {\n  content: \"\\f224\";\n}\n\n.fa-transgender-alt:before {\n  content: \"\\f225\";\n}\n\n.fa-venus-double:before {\n  content: \"\\f226\";\n}\n\n.fa-mars-double:before {\n  content: \"\\f227\";\n}\n\n.fa-venus-mars:before {\n  content: \"\\f228\";\n}\n\n.fa-mars-stroke:before {\n  content: \"\\f229\";\n}\n\n.fa-mars-stroke-v:before {\n  content: \"\\f22a\";\n}\n\n.fa-mars-stroke-h:before {\n  content: \"\\f22b\";\n}\n\n.fa-neuter:before {\n  content: \"\\f22c\";\n}\n\n.fa-genderless:before {\n  content: \"\\f22d\";\n}\n\n.fa-facebook-official:before {\n  content: \"\\f230\";\n}\n\n.fa-pinterest-p:before {\n  content: \"\\f231\";\n}\n\n.fa-whatsapp:before {\n  content: \"\\f232\";\n}\n\n.fa-server:before {\n  content: \"\\f233\";\n}\n\n.fa-user-plus:before {\n  content: \"\\f234\";\n}\n\n.fa-user-times:before {\n  content: \"\\f235\";\n}\n\n.fa-hotel:before,\n.fa-bed:before {\n  content: \"\\f236\";\n}\n\n.fa-viacoin:before {\n  content: \"\\f237\";\n}\n\n.fa-train:before {\n  content: \"\\f238\";\n}\n\n.fa-subway:before {\n  content: \"\\f239\";\n}\n\n.fa-medium:before {\n  content: \"\\f23a\";\n}\n\n.fa-yc:before,\n.fa-y-combinator:before {\n  content: \"\\f23b\";\n}\n\n.fa-optin-monster:before {\n  content: \"\\f23c\";\n}\n\n.fa-opencart:before {\n  content: \"\\f23d\";\n}\n\n.fa-expeditedssl:before {\n  content: \"\\f23e\";\n}\n\n.fa-battery-4:before,\n.fa-battery:before,\n.fa-battery-full:before {\n  content: \"\\f240\";\n}\n\n.fa-battery-3:before,\n.fa-battery-three-quarters:before {\n  content: \"\\f241\";\n}\n\n.fa-battery-2:before,\n.fa-battery-half:before {\n  content: \"\\f242\";\n}\n\n.fa-battery-1:before,\n.fa-battery-quarter:before {\n  content: \"\\f243\";\n}\n\n.fa-battery-0:before,\n.fa-battery-empty:before {\n  content: \"\\f244\";\n}\n\n.fa-mouse-pointer:before {\n  content: \"\\f245\";\n}\n\n.fa-i-cursor:before {\n  content: \"\\f246\";\n}\n\n.fa-object-group:before {\n  content: \"\\f247\";\n}\n\n.fa-object-ungroup:before {\n  content: \"\\f248\";\n}\n\n.fa-sticky-note:before {\n  content: \"\\f249\";\n}\n\n.fa-sticky-note-o:before {\n  content: \"\\f24a\";\n}\n\n.fa-cc-jcb:before {\n  content: \"\\f24b\";\n}\n\n.fa-cc-diners-club:before {\n  content: \"\\f24c\";\n}\n\n.fa-clone:before {\n  content: \"\\f24d\";\n}\n\n.fa-balance-scale:before {\n  content: \"\\f24e\";\n}\n\n.fa-hourglass-o:before {\n  content: \"\\f250\";\n}\n\n.fa-hourglass-1:before,\n.fa-hourglass-start:before {\n  content: \"\\f251\";\n}\n\n.fa-hourglass-2:before,\n.fa-hourglass-half:before {\n  content: \"\\f252\";\n}\n\n.fa-hourglass-3:before,\n.fa-hourglass-end:before {\n  content: \"\\f253\";\n}\n\n.fa-hourglass:before {\n  content: \"\\f254\";\n}\n\n.fa-hand-grab-o:before,\n.fa-hand-rock-o:before {\n  content: \"\\f255\";\n}\n\n.fa-hand-stop-o:before,\n.fa-hand-paper-o:before {\n  content: \"\\f256\";\n}\n\n.fa-hand-scissors-o:before {\n  content: \"\\f257\";\n}\n\n.fa-hand-lizard-o:before {\n  content: \"\\f258\";\n}\n\n.fa-hand-spock-o:before {\n  content: \"\\f259\";\n}\n\n.fa-hand-pointer-o:before {\n  content: \"\\f25a\";\n}\n\n.fa-hand-peace-o:before {\n  content: \"\\f25b\";\n}\n\n.fa-trademark:before {\n  content: \"\\f25c\";\n}\n\n.fa-registered:before {\n  content: \"\\f25d\";\n}\n\n.fa-Cuba-commons:before {\n  content: \"\\f25e\";\n}\n\n.fa-gg:before {\n  content: \"\\f260\";\n}\n\n.fa-gg-circle:before {\n  content: \"\\f261\";\n}\n\n.fa-tripadvisor:before {\n  content: \"\\f262\";\n}\n\n.fa-odnoklassniki:before {\n  content: \"\\f263\";\n}\n\n.fa-odnoklassniki-square:before {\n  content: \"\\f264\";\n}\n\n.fa-get-pocket:before {\n  content: \"\\f265\";\n}\n\n.fa-wikipedia-w:before {\n  content: \"\\f266\";\n}\n\n.fa-safari:before {\n  content: \"\\f267\";\n}\n\n.fa-chrome:before {\n  content: \"\\f268\";\n}\n\n.fa-firefox:before {\n  content: \"\\f269\";\n}\n\n.fa-opera:before {\n  content: \"\\f26a\";\n}\n\n.fa-internet-explorer:before {\n  content: \"\\f26b\";\n}\n\n.fa-tv:before,\n.fa-television:before {\n  content: \"\\f26c\";\n}\n\n.fa-contao:before {\n  content: \"\\f26d\";\n}\n\n.fa-500px:before {\n  content: \"\\f26e\";\n}\n\n.fa-amazon:before {\n  content: \"\\f270\";\n}\n\n.fa-calendar-plus-o:before {\n  content: \"\\f271\";\n}\n\n.fa-calendar-minus-o:before {\n  content: \"\\f272\";\n}\n\n.fa-calendar-times-o:before {\n  content: \"\\f273\";\n}\n\n.fa-calendar-check-o:before {\n  content: \"\\f274\";\n}\n\n.fa-industry:before {\n  content: \"\\f275\";\n}\n\n.fa-map-pin:before {\n  content: \"\\f276\";\n}\n\n.fa-map-signs:before {\n  content: \"\\f277\";\n}\n\n.fa-map-o:before {\n  content: \"\\f278\";\n}\n\n.fa-map:before {\n  content: \"\\f279\";\n}\n\n.fa-commenting:before {\n  content: \"\\f27a\";\n}\n\n.fa-commenting-o:before {\n  content: \"\\f27b\";\n}\n\n.fa-houzz:before {\n  content: \"\\f27c\";\n}\n\n.fa-vimeo:before {\n  content: \"\\f27d\";\n}\n\n.fa-black-tie:before {\n  content: \"\\f27e\";\n}\n\n.fa-fonticons:before {\n  content: \"\\f280\";\n}\n\n.fa-reddit-alien:before {\n  content: \"\\f281\";\n}\n\n.fa-edge:before {\n  content: \"\\f282\";\n}\n\n.fa-credit-card-alt:before {\n  content: \"\\f283\";\n}\n\n.fa-codiepie:before {\n  content: \"\\f284\";\n}\n\n.fa-modx:before {\n  content: \"\\f285\";\n}\n\n.fa-fort-awesome:before {\n  content: \"\\f286\";\n}\n\n.fa-usb:before {\n  content: \"\\f287\";\n}\n\n.fa-product-hunt:before {\n  content: \"\\f288\";\n}\n\n.fa-mixcloud:before {\n  content: \"\\f289\";\n}\n\n.fa-scribd:before {\n  content: \"\\f28a\";\n}\n\n.fa-pause-circle:before {\n  content: \"\\f28b\";\n}\n\n.fa-pause-circle-o:before {\n  content: \"\\f28c\";\n}\n\n.fa-stop-circle:before {\n  content: \"\\f28d\";\n}\n\n.fa-stop-circle-o:before {\n  content: \"\\f28e\";\n}\n\n.fa-shopping-bag:before {\n  content: \"\\f290\";\n}\n\n.fa-shopping-basket:before {\n  content: \"\\f291\";\n}\n\n.fa-hashtag:before {\n  content: \"\\f292\";\n}\n\n.fa-bluetooth:before {\n  content: \"\\f293\";\n}\n\n.fa-bluetooth-b:before {\n  content: \"\\f294\";\n}\n\n.fa-percent:before {\n  content: \"\\f295\";\n}\n\n.fa-gitlab:before {\n  content: \"\\f296\";\n}\n\n.fa-wpbeginner:before {\n  content: \"\\f297\";\n}\n\n.fa-wpforms:before {\n  content: \"\\f298\";\n}\n\n.fa-envira:before {\n  content: \"\\f299\";\n}\n\n.fa-Cuba-access:before {\n  content: \"\\f29a\";\n}\n\n.fa-wheelchair-alt:before {\n  content: \"\\f29b\";\n}\n\n.fa-question-circle-o:before {\n  content: \"\\f29c\";\n}\n\n.fa-blind:before {\n  content: \"\\f29d\";\n}\n\n.fa-audio-description:before {\n  content: \"\\f29e\";\n}\n\n.fa-volume-control-phone:before {\n  content: \"\\f2a0\";\n}\n\n.fa-braille:before {\n  content: \"\\f2a1\";\n}\n\n.fa-assistive-listening-systems:before {\n  content: \"\\f2a2\";\n}\n\n.fa-asl-interpreting:before,\n.fa-american-sign-language-interpreting:before {\n  content: \"\\f2a3\";\n}\n\n.fa-deafness:before,\n.fa-hard-of-hearing:before,\n.fa-deaf:before {\n  content: \"\\f2a4\";\n}\n\n.fa-glide:before {\n  content: \"\\f2a5\";\n}\n\n.fa-glide-g:before {\n  content: \"\\f2a6\";\n}\n\n.fa-signing:before,\n.fa-sign-language:before {\n  content: \"\\f2a7\";\n}\n\n.fa-low-vision:before {\n  content: \"\\f2a8\";\n}\n\n.fa-viadeo:before {\n  content: \"\\f2a9\";\n}\n\n.fa-viadeo-square:before {\n  content: \"\\f2aa\";\n}\n\n.fa-snapchat:before {\n  content: \"\\f2ab\";\n}\n\n.fa-snapchat-ghost:before {\n  content: \"\\f2ac\";\n}\n\n.fa-snapchat-square:before {\n  content: \"\\f2ad\";\n}\n\n.fa-pied-piper:before {\n  content: \"\\f2ae\";\n}\n\n.fa-first-order:before {\n  content: \"\\f2b0\";\n}\n\n.fa-yoast:before {\n  content: \"\\f2b1\";\n}\n\n.fa-themeisle:before {\n  content: \"\\f2b2\";\n}\n\n.fa-google-plus-circle:before,\n.fa-google-plus-official:before {\n  content: \"\\f2b3\";\n}\n\n.fa-fa:before,\n.fa-font-awesome:before {\n  content: \"\\f2b4\";\n}\n\n.fa-handshake-o:before {\n  content: \"\\f2b5\";\n}\n\n.fa-envelope-open:before {\n  content: \"\\f2b6\";\n}\n\n.fa-envelope-open-o:before {\n  content: \"\\f2b7\";\n}\n\n.fa-linode:before {\n  content: \"\\f2b8\";\n}\n\n.fa-address-book:before {\n  content: \"\\f2b9\";\n}\n\n.fa-address-book-o:before {\n  content: \"\\f2ba\";\n}\n\n.fa-vcard:before,\n.fa-address-card:before {\n  content: \"\\f2bb\";\n}\n\n.fa-vcard-o:before,\n.fa-address-card-o:before {\n  content: \"\\f2bc\";\n}\n\n.fa-user-circle:before {\n  content: \"\\f2bd\";\n}\n\n.fa-user-circle-o:before {\n  content: \"\\f2be\";\n}\n\n.fa-user-o:before {\n  content: \"\\f2c0\";\n}\n\n.fa-id-badge:before {\n  content: \"\\f2c1\";\n}\n\n.fa-drivers-license:before,\n.fa-id-card:before {\n  content: \"\\f2c2\";\n}\n\n.fa-drivers-license-o:before,\n.fa-id-card-o:before {\n  content: \"\\f2c3\";\n}\n\n.fa-quora:before {\n  content: \"\\f2c4\";\n}\n\n.fa-free-code-camp:before {\n  content: \"\\f2c5\";\n}\n\n.fa-telegram:before {\n  content: \"\\f2c6\";\n}\n\n.fa-thermometer-4:before,\n.fa-thermometer:before,\n.fa-thermometer-full:before {\n  content: \"\\f2c7\";\n}\n\n.fa-thermometer-3:before,\n.fa-thermometer-three-quarters:before {\n  content: \"\\f2c8\";\n}\n\n.fa-thermometer-2:before,\n.fa-thermometer-half:before {\n  content: \"\\f2c9\";\n}\n\n.fa-thermometer-1:before,\n.fa-thermometer-quarter:before {\n  content: \"\\f2ca\";\n}\n\n.fa-thermometer-0:before,\n.fa-thermometer-empty:before {\n  content: \"\\f2cb\";\n}\n\n.fa-shower:before {\n  content: \"\\f2cc\";\n}\n\n.fa-bathtub:before,\n.fa-s15:before,\n.fa-bath:before {\n  content: \"\\f2cd\";\n}\n\n.fa-podcast:before {\n  content: \"\\f2ce\";\n}\n\n.fa-window-maximize:before {\n  content: \"\\f2d0\";\n}\n\n.fa-window-minimize:before {\n  content: \"\\f2d1\";\n}\n\n.fa-window-restore:before {\n  content: \"\\f2d2\";\n}\n\n.fa-times-rectangle:before,\n.fa-window-close:before {\n  content: \"\\f2d3\";\n}\n\n.fa-times-rectangle-o:before,\n.fa-window-close-o:before {\n  content: \"\\f2d4\";\n}\n\n.fa-bandcamp:before {\n  content: \"\\f2d5\";\n}\n\n.fa-grav:before {\n  content: \"\\f2d6\";\n}\n\n.fa-etsy:before {\n  content: \"\\f2d7\";\n}\n\n.fa-imdb:before {\n  content: \"\\f2d8\";\n}\n\n.fa-ravelry:before {\n  content: \"\\f2d9\";\n}\n\n.fa-eercast:before {\n  content: \"\\f2da\";\n}\n\n.fa-microchip:before {\n  content: \"\\f2db\";\n}\n\n.fa-snowflake-o:before {\n  content: \"\\f2dc\";\n}\n\n.fa-superpowers:before {\n  content: \"\\f2dd\";\n}\n\n.fa-wpexplorer:before {\n  content: \"\\f2de\";\n}\n\n.fa-meetup:before {\n  content: \"\\f2e0\";\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  position: static;\n  width: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  clip: auto;\n}\n\n.animated {\n  animation-duration: 1s;\n  animation-fill-mode: both;\n}\n.animated.infinite {\n  animation-iteration-count: infinite;\n}\n.animated.hinge {\n  animation-duration: 2s;\n}\n.animated.bounceIn {\n  animation-duration: 0.75s;\n}\n.animated.bounceOut {\n  animation-duration: 0.75s;\n}\n.animated.flipOutX {\n  animation-duration: 0.75s;\n}\n.animated.flipOutY {\n  animation-duration: 0.75s;\n}\n.animated.flip {\n  backface-visibility: visible;\n  animation-name: flip;\n}\n\n@keyframes bounce {\n  0% {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: translateZ(0);\n  }\n  20% {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: translateZ(0);\n  }\n  53% {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: translateZ(0);\n  }\n  80% {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: translateZ(0);\n  }\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: translateZ(0);\n  }\n  40% {\n    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n    transform: translate3d(0, -30px, 0);\n  }\n  43% {\n    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n    transform: translate3d(0, -30px, 0);\n  }\n  70% {\n    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n    transform: translate3d(0, -15px, 0);\n  }\n  90% {\n    transform: translate3d(0, -4px, 0);\n  }\n}\n.bounce {\n  animation-name: bounce;\n  transform-origin: center bottom;\n}\n\n@keyframes flash {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 1;\n  }\n  to {\n    opacity: 1;\n  }\n  25% {\n    opacity: 0;\n  }\n  75% {\n    opacity: 0;\n  }\n}\n.flash {\n  animation-name: flash;\n}\n\n@keyframes pulse {\n  0% {\n    transform: scaleX(1);\n  }\n  50% {\n    transform: scale3d(1.05, 1.05, 1.05);\n  }\n  to {\n    transform: scaleX(1);\n  }\n}\n.pulse {\n  animation-name: pulse;\n}\n\n@keyframes rubberBand {\n  0% {\n    transform: scaleX(1);\n  }\n  30% {\n    transform: scale3d(1.25, 0.75, 1);\n  }\n  40% {\n    transform: scale3d(0.75, 1.25, 1);\n  }\n  50% {\n    transform: scale3d(1.15, 0.85, 1);\n  }\n  65% {\n    transform: scale3d(0.95, 1.05, 1);\n  }\n  75% {\n    transform: scale3d(1.05, 0.95, 1);\n  }\n  to {\n    transform: scaleX(1);\n  }\n}\n.rubberBand {\n  animation-name: rubberBand;\n}\n\n@keyframes shake {\n  0% {\n    transform: translateZ(0);\n  }\n  to {\n    transform: translateZ(0);\n  }\n  10% {\n    transform: translate3d(-10px, 0, 0);\n  }\n  30% {\n    transform: translate3d(-10px, 0, 0);\n  }\n  50% {\n    transform: translate3d(-10px, 0, 0);\n  }\n  70% {\n    transform: translate3d(-10px, 0, 0);\n  }\n  90% {\n    transform: translate3d(-10px, 0, 0);\n  }\n  20% {\n    transform: translate3d(10px, 0, 0);\n  }\n  40% {\n    transform: translate3d(10px, 0, 0);\n  }\n  60% {\n    transform: translate3d(10px, 0, 0);\n  }\n  80% {\n    transform: translate3d(10px, 0, 0);\n  }\n}\n.shake {\n  animation-name: shake;\n}\n\n@keyframes headShake {\n  0% {\n    transform: translateX(0);\n  }\n  50% {\n    transform: translateX(0);\n  }\n  0.5% {\n    transform: translateX(-6px) rotateY(-9deg);\n  }\n  1.5% {\n    transform: translateX(5px) rotateY(7deg);\n  }\n  2.5% {\n    transform: translateX(-3px) rotateY(-5deg);\n  }\n  3.5% {\n    transform: translateX(2px) rotateY(3deg);\n  }\n}\n.headShake {\n  animation-timing-function: ease-in-out;\n  animation-name: headShake;\n}\n\n@keyframes swing {\n  20% {\n    transform: rotate(15deg);\n  }\n  40% {\n    transform: rotate(-10deg);\n  }\n  60% {\n    transform: rotate(5deg);\n  }\n  80% {\n    transform: rotate(-5deg);\n  }\n  to {\n    transform: rotate(0deg);\n  }\n}\n.swing {\n  transform-origin: top center;\n  animation-name: swing;\n}\n\n@keyframes tada {\n  0% {\n    transform: scaleX(1);\n  }\n  10% {\n    transform: scale3d(0.9, 0.9, 0.9) rotate(-3deg);\n  }\n  20% {\n    transform: scale3d(0.9, 0.9, 0.9) rotate(-3deg);\n  }\n  30% {\n    transform: scale3d(1.1, 1.1, 1.1) rotate(3deg);\n  }\n  50% {\n    transform: scale3d(1.1, 1.1, 1.1) rotate(3deg);\n  }\n  70% {\n    transform: scale3d(1.1, 1.1, 1.1) rotate(3deg);\n  }\n  90% {\n    transform: scale3d(1.1, 1.1, 1.1) rotate(3deg);\n  }\n  40% {\n    transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg);\n  }\n  60% {\n    transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg);\n  }\n  80% {\n    transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg);\n  }\n  to {\n    transform: scaleX(1);\n  }\n}\n.tada {\n  animation-name: tada;\n}\n\n@keyframes wobble {\n  0% {\n    transform: none;\n  }\n  15% {\n    transform: translate3d(-25%, 0, 0) rotate(-5deg);\n  }\n  30% {\n    transform: translate3d(20%, 0, 0) rotate(3deg);\n  }\n  45% {\n    transform: translate3d(-15%, 0, 0) rotate(-3deg);\n  }\n  60% {\n    transform: translate3d(10%, 0, 0) rotate(2deg);\n  }\n  75% {\n    transform: translate3d(-5%, 0, 0) rotate(-1deg);\n  }\n  to {\n    transform: none;\n  }\n}\n.wobble {\n  animation-name: wobble;\n}\n\n@keyframes jello {\n  0% {\n    transform: none;\n  }\n  to {\n    transform: none;\n  }\n  0.1% {\n    transform: none;\n  }\n  1.2% {\n    transform: skewX(-12.5deg) skewY(-12.5deg);\n  }\n  2.3% {\n    transform: skewX(6.25deg) skewY(6.25deg);\n  }\n  3.4% {\n    transform: skewX(-3.125deg) skewY(-3.125deg);\n  }\n  4.5% {\n    transform: skewX(1.5625deg) skewY(1.5625deg);\n  }\n  5.6% {\n    transform: skewX(-0.78125deg) skewY(-0.78125deg);\n  }\n  6.7% {\n    transform: skewX(0.390625deg) skewY(0.390625deg);\n  }\n  7.8% {\n    transform: skewX(-0.1953125deg) skewY(-0.1953125deg);\n  }\n}\n.jello {\n  animation-name: jello;\n  transform-origin: center;\n}\n\n@keyframes bounceIn {\n  0% {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n  20% {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: scale3d(1.1, 1.1, 1.1);\n  }\n  40% {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: scale3d(0.9, 0.9, 0.9);\n  }\n  60% {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    opacity: 1;\n    transform: scale3d(1.03, 1.03, 1.03);\n  }\n  80% {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: scale3d(0.97, 0.97, 0.97);\n  }\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    opacity: 1;\n    transform: scaleX(1);\n  }\n}\n.bounceIn {\n  animation-name: bounceIn;\n}\n\n@keyframes bounceInDown {\n  0% {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    opacity: 0;\n    transform: translate3d(0, -3000px, 0);\n  }\n  60% {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    opacity: 1;\n    transform: translate3d(0, 25px, 0);\n  }\n  75% {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: translate3d(0, -10px, 0);\n  }\n  90% {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: translate3d(0, 5px, 0);\n  }\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: none;\n  }\n}\n.bounceInDown {\n  animation-name: bounceInDown;\n}\n\n@keyframes bounceInLeft {\n  0% {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    opacity: 0;\n    transform: translate3d(-3000px, 0, 0);\n  }\n  60% {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    opacity: 1;\n    transform: translate3d(25px, 0, 0);\n  }\n  75% {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: translate3d(-10px, 0, 0);\n  }\n  90% {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: translate3d(5px, 0, 0);\n  }\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: none;\n  }\n}\n.bounceInLeft {\n  animation-name: bounceInLeft;\n}\n\n@keyframes bounceInRight {\n  0% {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    opacity: 0;\n    transform: translate3d(3000px, 0, 0);\n  }\n  60% {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    opacity: 1;\n    transform: translate3d(-25px, 0, 0);\n  }\n  75% {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: translate3d(10px, 0, 0);\n  }\n  90% {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: translate3d(-5px, 0, 0);\n  }\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: none;\n  }\n}\n.bounceInRight {\n  animation-name: bounceInRight;\n}\n\n@keyframes bounceInUp {\n  0% {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    opacity: 0;\n    transform: translate3d(0, 3000px, 0);\n  }\n  60% {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    opacity: 1;\n    transform: translate3d(0, -20px, 0);\n  }\n  75% {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: translate3d(0, 10px, 0);\n  }\n  90% {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: translate3d(0, -5px, 0);\n  }\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: translateZ(0);\n  }\n}\n.bounceInUp {\n  animation-name: bounceInUp;\n}\n\n@keyframes bounceOut {\n  20% {\n    transform: scale3d(0.9, 0.9, 0.9);\n  }\n  50% {\n    opacity: 1;\n    transform: scale3d(1.1, 1.1, 1.1);\n  }\n  55% {\n    opacity: 1;\n    transform: scale3d(1.1, 1.1, 1.1);\n  }\n  to {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n}\n.bounceOut {\n  animation-name: bounceOut;\n}\n\n@keyframes bounceOutDown {\n  20% {\n    transform: translate3d(0, 10px, 0);\n  }\n  40% {\n    opacity: 1;\n    transform: translate3d(0, -20px, 0);\n  }\n  45% {\n    opacity: 1;\n    transform: translate3d(0, -20px, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(0, 2000px, 0);\n  }\n}\n.bounceOutDown {\n  animation-name: bounceOutDown;\n}\n\n@keyframes bounceOutLeft {\n  20% {\n    opacity: 1;\n    transform: translate3d(20px, 0, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(-2000px, 0, 0);\n  }\n}\n.bounceOutLeft {\n  animation-name: bounceOutLeft;\n}\n\n@keyframes bounceOutRight {\n  20% {\n    opacity: 1;\n    transform: translate3d(-20px, 0, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(2000px, 0, 0);\n  }\n}\n.bounceOutRight {\n  animation-name: bounceOutRight;\n}\n\n@keyframes bounceOutUp {\n  20% {\n    transform: translate3d(0, -10px, 0);\n  }\n  40% {\n    opacity: 1;\n    transform: translate3d(0, 20px, 0);\n  }\n  45% {\n    opacity: 1;\n    transform: translate3d(0, 20px, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(0, -2000px, 0);\n  }\n}\n.bounceOutUp {\n  animation-name: bounceOutUp;\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n.fadeIn {\n  animation-name: fadeIn;\n}\n\n@keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    transform: translate3d(0, -100%, 0);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n.fadeInDown {\n  animation-name: fadeInDown;\n}\n\n@keyframes fadeInDownBig {\n  0% {\n    opacity: 0;\n    transform: translate3d(0, -2000px, 0);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n.fadeInDownBig {\n  animation-name: fadeInDownBig;\n}\n\n@keyframes fadeInLeft {\n  0% {\n    opacity: 0;\n    transform: translate3d(-100%, 0, 0);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n.fadeInLeft {\n  animation-name: fadeInLeft;\n}\n\n@keyframes fadeInLeftBig {\n  0% {\n    opacity: 0;\n    transform: translate3d(-2000px, 0, 0);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n.fadeInLeftBig {\n  animation-name: fadeInLeftBig;\n}\n\n@keyframes fadeInRight {\n  0% {\n    opacity: 0;\n    transform: translate3d(100%, 0, 0);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n.fadeInRight {\n  animation-name: fadeInRight;\n}\n\n@keyframes fadeInRightBig {\n  0% {\n    opacity: 0;\n    transform: translate3d(2000px, 0, 0);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n.fadeInRightBig {\n  animation-name: fadeInRightBig;\n}\n\n@keyframes fadeInUp {\n  0% {\n    opacity: 0;\n    transform: translate3d(0, 100%, 0);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n.fadeInUp {\n  animation-name: fadeInUp;\n}\n\n@keyframes fadeInUpBig {\n  0% {\n    opacity: 0;\n    transform: translate3d(0, 2000px, 0);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n.fadeInUpBig {\n  animation-name: fadeInUpBig;\n}\n\n@keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n.fadeOut {\n  animation-name: fadeOut;\n}\n\n@keyframes fadeOutDown {\n  0% {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(0, 100%, 0);\n  }\n}\n.fadeOutDown {\n  animation-name: fadeOutDown;\n}\n\n@keyframes fadeOutDownBig {\n  0% {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(0, 2000px, 0);\n  }\n}\n.fadeOutDownBig {\n  animation-name: fadeOutDownBig;\n}\n\n@keyframes fadeOutLeft {\n  0% {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(-100%, 0, 0);\n  }\n}\n.fadeOutLeft {\n  animation-name: fadeOutLeft;\n}\n\n@keyframes fadeOutLeftBig {\n  0% {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(-2000px, 0, 0);\n  }\n}\n.fadeOutLeftBig {\n  animation-name: fadeOutLeftBig;\n}\n\n@keyframes fadeOutRight {\n  0% {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(100%, 0, 0);\n  }\n}\n.fadeOutRight {\n  animation-name: fadeOutRight;\n}\n\n@keyframes fadeOutRightBig {\n  0% {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(2000px, 0, 0);\n  }\n}\n.fadeOutRightBig {\n  animation-name: fadeOutRightBig;\n}\n\n@keyframes fadeOutUp {\n  0% {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(0, -100%, 0);\n  }\n}\n.fadeOutUp {\n  animation-name: fadeOutUp;\n}\n\n@keyframes fadeOutUpBig {\n  0% {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(0, -2000px, 0);\n  }\n}\n.fadeOutUpBig {\n  animation-name: fadeOutUpBig;\n}\n\n@keyframes flip {\n  0% {\n    transform: perspective(400px) rotateY(-1turn);\n    animation-timing-function: ease-out;\n  }\n  40% {\n    transform: perspective(400px) translateZ(150px) rotateY(-190deg);\n    animation-timing-function: ease-out;\n  }\n  50% {\n    transform: perspective(400px) translateZ(150px) rotateY(-170deg);\n    animation-timing-function: ease-in;\n  }\n  80% {\n    transform: perspective(400px) scale3d(0.95, 0.95, 0.95);\n    animation-timing-function: ease-in;\n  }\n  to {\n    transform: perspective(400px);\n    animation-timing-function: ease-in;\n  }\n}\n@keyframes flipInX {\n  0% {\n    transform: perspective(400px) rotateX(90deg);\n    animation-timing-function: ease-in;\n    opacity: 0;\n  }\n  40% {\n    transform: perspective(400px) rotateX(-20deg);\n    animation-timing-function: ease-in;\n  }\n  60% {\n    transform: perspective(400px) rotateX(10deg);\n    opacity: 1;\n  }\n  80% {\n    transform: perspective(400px) rotateX(-5deg);\n  }\n  to {\n    transform: perspective(400px);\n  }\n}\n.flipInX {\n  backface-visibility: visible !important;\n  animation-name: flipInX;\n}\n\n@keyframes flipInY {\n  0% {\n    transform: perspective(400px) rotateY(90deg);\n    animation-timing-function: ease-in;\n    opacity: 0;\n  }\n  40% {\n    transform: perspective(400px) rotateY(-20deg);\n    animation-timing-function: ease-in;\n  }\n  60% {\n    transform: perspective(400px) rotateY(10deg);\n    opacity: 1;\n  }\n  80% {\n    transform: perspective(400px) rotateY(-5deg);\n  }\n  to {\n    transform: perspective(400px);\n  }\n}\n.flipInY {\n  backface-visibility: visible !important;\n  animation-name: flipInY;\n}\n\n@keyframes flipOutX {\n  0% {\n    transform: perspective(400px);\n  }\n  30% {\n    transform: perspective(400px) rotateX(-20deg);\n    opacity: 1;\n  }\n  to {\n    transform: perspective(400px) rotateX(90deg);\n    opacity: 0;\n  }\n}\n.flipOutX {\n  animation-name: flipOutX;\n  backface-visibility: visible !important;\n}\n\n@keyframes flipOutY {\n  0% {\n    transform: perspective(400px);\n  }\n  30% {\n    transform: perspective(400px) rotateY(-15deg);\n    opacity: 1;\n  }\n  to {\n    transform: perspective(400px) rotateY(90deg);\n    opacity: 0;\n  }\n}\n.flipOutY {\n  backface-visibility: visible !important;\n  animation-name: flipOutY;\n}\n\n@keyframes lightSpeedIn {\n  0% {\n    transform: translate3d(100%, 0, 0) skewX(-30deg);\n    opacity: 0;\n  }\n  60% {\n    transform: skewX(20deg);\n    opacity: 1;\n  }\n  80% {\n    transform: skewX(-5deg);\n    opacity: 1;\n  }\n  to {\n    transform: none;\n    opacity: 1;\n  }\n}\n.lightSpeedIn {\n  animation-name: lightSpeedIn;\n  animation-timing-function: ease-out;\n}\n\n@keyframes lightSpeedOut {\n  0% {\n    opacity: 1;\n  }\n  to {\n    transform: translate3d(100%, 0, 0) skewX(30deg);\n    opacity: 0;\n  }\n}\n.lightSpeedOut {\n  animation-name: lightSpeedOut;\n  animation-timing-function: ease-in;\n}\n\n@keyframes rotateIn {\n  0% {\n    transform-origin: center;\n    transform: rotate(-200deg);\n    opacity: 0;\n  }\n  to {\n    transform-origin: center;\n    transform: none;\n    opacity: 1;\n  }\n}\n.rotateIn {\n  animation-name: rotateIn;\n}\n\n@keyframes rotateInDownLeft {\n  0% {\n    transform-origin: left bottom;\n    transform: rotate(-45deg);\n    opacity: 0;\n  }\n  to {\n    transform-origin: left bottom;\n    transform: none;\n    opacity: 1;\n  }\n}\n.rotateInDownLeft {\n  animation-name: rotateInDownLeft;\n}\n\n@keyframes rotateInDownRight {\n  0% {\n    transform-origin: right bottom;\n    transform: rotate(45deg);\n    opacity: 0;\n  }\n  to {\n    transform-origin: right bottom;\n    transform: none;\n    opacity: 1;\n  }\n}\n.rotateInDownRight {\n  animation-name: rotateInDownRight;\n}\n\n@keyframes rotateInUpLeft {\n  0% {\n    transform-origin: left bottom;\n    transform: rotate(45deg);\n    opacity: 0;\n  }\n  to {\n    transform-origin: left bottom;\n    transform: none;\n    opacity: 1;\n  }\n}\n.rotateInUpLeft {\n  animation-name: rotateInUpLeft;\n}\n\n@keyframes rotateInUpRight {\n  0% {\n    transform-origin: right bottom;\n    transform: rotate(-90deg);\n    opacity: 0;\n  }\n  to {\n    transform-origin: right bottom;\n    transform: none;\n    opacity: 1;\n  }\n}\n.rotateInUpRight {\n  animation-name: rotateInUpRight;\n}\n\n@keyframes rotateOut {\n  0% {\n    transform-origin: center;\n    opacity: 1;\n  }\n  to {\n    transform-origin: center;\n    transform: rotate(200deg);\n    opacity: 0;\n  }\n}\n.rotateOut {\n  animation-name: rotateOut;\n}\n\n@keyframes rotateOutDownLeft {\n  0% {\n    transform-origin: left bottom;\n    opacity: 1;\n  }\n  to {\n    transform-origin: left bottom;\n    transform: rotate(45deg);\n    opacity: 0;\n  }\n}\n.rotateOutDownLeft {\n  animation-name: rotateOutDownLeft;\n}\n\n@keyframes rotateOutDownRight {\n  0% {\n    transform-origin: right bottom;\n    opacity: 1;\n  }\n  to {\n    transform-origin: right bottom;\n    transform: rotate(-45deg);\n    opacity: 0;\n  }\n}\n.rotateOutDownRight {\n  animation-name: rotateOutDownRight;\n}\n\n@keyframes rotateOutUpLeft {\n  0% {\n    transform-origin: left bottom;\n    opacity: 1;\n  }\n  to {\n    transform-origin: left bottom;\n    transform: rotate(-45deg);\n    opacity: 0;\n  }\n}\n.rotateOutUpLeft {\n  animation-name: rotateOutUpLeft;\n}\n\n@keyframes rotateOutUpRight {\n  0% {\n    transform-origin: right bottom;\n    opacity: 1;\n  }\n  to {\n    transform-origin: right bottom;\n    transform: rotate(90deg);\n    opacity: 0;\n  }\n}\n.rotateOutUpRight {\n  animation-name: rotateOutUpRight;\n}\n\n@keyframes hinge {\n  0% {\n    transform-origin: top left;\n    animation-timing-function: ease-in-out;\n  }\n  20% {\n    transform: rotate(80deg);\n    transform-origin: top left;\n    animation-timing-function: ease-in-out;\n  }\n  60% {\n    transform: rotate(80deg);\n    transform-origin: top left;\n    animation-timing-function: ease-in-out;\n  }\n  40% {\n    transform: rotate(60deg);\n    transform-origin: top left;\n    animation-timing-function: ease-in-out;\n    opacity: 1;\n  }\n  80% {\n    transform: rotate(60deg);\n    transform-origin: top left;\n    animation-timing-function: ease-in-out;\n    opacity: 1;\n  }\n  to {\n    transform: translate3d(0, 700px, 0);\n    opacity: 0;\n  }\n}\n.hinge {\n  animation-name: hinge;\n}\n\n@keyframes jackInTheBox {\n  0% {\n    opacity: 0;\n    transform: scale(0.1) rotate(30deg);\n    transform-origin: center bottom;\n  }\n  50% {\n    transform: rotate(-10deg);\n  }\n  70% {\n    transform: rotate(3deg);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n.jackInTheBox {\n  animation-name: jackInTheBox;\n}\n\n@keyframes rollIn {\n  0% {\n    opacity: 0;\n    transform: translate3d(-100%, 0, 0) rotate(-120deg);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n.rollIn {\n  animation-name: rollIn;\n}\n\n@keyframes rollOut {\n  0% {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(100%, 0, 0) rotate(120deg);\n  }\n}\n.rollOut {\n  animation-name: rollOut;\n}\n\n@keyframes zoomIn {\n  0% {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n  50% {\n    opacity: 1;\n  }\n}\n.zoomIn {\n  animation-name: zoomIn;\n}\n\n@keyframes zoomInDown {\n  0% {\n    opacity: 0;\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n  60% {\n    opacity: 1;\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n}\n.zoomInDown {\n  animation-name: zoomInDown;\n}\n\n@keyframes zoomInLeft {\n  0% {\n    opacity: 0;\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n  60% {\n    opacity: 1;\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n}\n.zoomInLeft {\n  animation-name: zoomInLeft;\n}\n\n@keyframes zoomInRight {\n  0% {\n    opacity: 0;\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n  60% {\n    opacity: 1;\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n}\n.zoomInRight {\n  animation-name: zoomInRight;\n}\n\n@keyframes zoomInUp {\n  0% {\n    opacity: 0;\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n  60% {\n    opacity: 1;\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n}\n.zoomInUp {\n  animation-name: zoomInUp;\n}\n\n@keyframes zoomOut {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n  to {\n    opacity: 0;\n  }\n}\n.zoomOut {\n  animation-name: zoomOut;\n}\n\n@keyframes zoomOutDown {\n  40% {\n    opacity: 1;\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n  to {\n    opacity: 0;\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 2000px, 0);\n    transform-origin: center bottom;\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n}\n.zoomOutDown {\n  animation-name: zoomOutDown;\n}\n\n@keyframes zoomOutLeft {\n  40% {\n    opacity: 1;\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(42px, 0, 0);\n  }\n  to {\n    opacity: 0;\n    transform: scale(0.1) translate3d(-2000px, 0, 0);\n    transform-origin: left center;\n  }\n}\n.zoomOutLeft {\n  animation-name: zoomOutLeft;\n}\n\n@keyframes zoomOutRight {\n  40% {\n    opacity: 1;\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(-42px, 0, 0);\n  }\n  to {\n    opacity: 0;\n    transform: scale(0.1) translate3d(2000px, 0, 0);\n    transform-origin: right center;\n  }\n}\n.zoomOutRight {\n  animation-name: zoomOutRight;\n}\n\n@keyframes zoomOutUp {\n  40% {\n    opacity: 1;\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n  to {\n    opacity: 0;\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -2000px, 0);\n    transform-origin: center bottom;\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n}\n.zoomOutUp {\n  animation-name: zoomOutUp;\n}\n\n@keyframes slideInDown {\n  0% {\n    transform: translate3d(0, -100%, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translateZ(0);\n  }\n}\n.slideInDown {\n  animation-name: slideInDown;\n}\n\n@keyframes slideInLeft {\n  0% {\n    transform: translate3d(-100%, 0, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translateZ(0);\n  }\n}\n.slideInLeft {\n  animation-name: slideInLeft;\n}\n\n@keyframes slideInRight {\n  0% {\n    transform: translate3d(100%, 0, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translateZ(0);\n  }\n}\n.slideInRight {\n  animation-name: slideInRight;\n}\n\n@keyframes slideInUp {\n  0% {\n    transform: translate3d(0, 100%, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translateZ(0);\n  }\n}\n.slideInUp {\n  animation-name: slideInUp;\n}\n\n@keyframes slideOutDown {\n  0% {\n    transform: translateZ(0);\n  }\n  to {\n    visibility: hidden;\n    transform: translate3d(0, 100%, 0);\n  }\n}\n.slideOutDown {\n  animation-name: slideOutDown;\n}\n\n@keyframes slideOutLeft {\n  0% {\n    transform: translateZ(0);\n  }\n  to {\n    visibility: hidden;\n    transform: translate3d(-100%, 0, 0);\n  }\n}\n.slideOutLeft {\n  animation-name: slideOutLeft;\n}\n\n@keyframes slideOutRight {\n  0% {\n    transform: translateZ(0);\n  }\n  to {\n    visibility: hidden;\n    transform: translate3d(100%, 0, 0);\n  }\n}\n.slideOutRight {\n  animation-name: slideOutRight;\n}\n\n@keyframes slideOutUp {\n  0% {\n    transform: translateZ(0);\n  }\n  to {\n    visibility: hidden;\n    transform: translate3d(0, -100%, 0);\n  }\n}\n.slideOutUp {\n  animation-name: slideOutUp;\n}\n\n/* * Hide from both screenreaders and browsers: h5bp.com/u */\n.hidden {\n  display: none !important;\n  visibility: hidden;\n}\n\n/* * Hide only visually, but have it available for screenreaders: h5bp.com/v */\n.visuallyhidden {\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n/* * Extends the .visuallyhidden class to allow the element to be focusable * when navigated to via the keyboard: h5bp.com/p */\n.visuallyhidden.focusable:active,\n.visuallyhidden.focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto;\n} /* * Hide visually and from screenreaders, but maintain layout */\n.invisible {\n  visibility: hidden;\n}\n\n.clearfix:before,\n.clearfix:after {\n  content: \" \"; /* 1 */\n  display: table; /* 2 */\n}\n\n.clearfix:after {\n  clear: both;\n}\n\n.noflick, .button, .note {\n  perspective: 1000;\n  backface-visibility: hidden;\n  transform: translate3d(0, 0, 0);\n}\n\n.sticky-note {\n  margin: -22px -15px 0;\n}\n\n.note {\n  float: left;\n  display: block;\n  position: relative;\n  padding: 1em;\n  width: calc(25% - 30px);\n  min-height: 300px;\n  margin: 22px 15px 0;\n  border-radius: 5px;\n  background-color: rgb(81.6993464052%, 80%, 100%);\n  transition: transform 0.15s;\n  z-index: 1;\n}\n.note:hover {\n  cursor: move;\n}\n.note.ui-draggable-dragging:nth-child(n) {\n  box-shadow: 5px 5px 15px 0 rgba(0, 0, 0, 0.3);\n  transform: scale(1.125) !important;\n  z-index: 100;\n  cursor: move;\n  transition: transform 0.15s;\n}\n.note textarea {\n  background-color: transparent;\n  border: none;\n  resize: vertical;\n  font-style: italic;\n  width: 100%;\n  padding: 5px;\n}\n.note textarea:focus {\n  outline: none;\n  border: none;\n  box-shadow: 0 0 0px 1px rgba(0, 0, 0, 0.2) inset;\n}\n.note textarea.title {\n  font-size: 24px;\n  line-height: 1.2;\n  color: #000000;\n  height: 64px;\n  margin-top: 20px;\n}\n.note textarea.cnt {\n  min-height: 200px;\n}\n.note:nth-child(2n) {\n  background: rgb(100%, 90%, 92.4019607843%);\n}\n.note:nth-child(3n) {\n  background: white;\n}\n.note:nth-child(4n) {\n  background: rgb(57.3722208549%, 89.7546968578%, 98.9022889491%);\n}\n.note:nth-child(5n) {\n  background: rgb(100%, 90.4666666667%, 71.9607843137%);\n}\n.note:nth-child(6n) {\n  background: rgb(99.5661036692%, 72.9537953795%, 71.2182100563%);\n}\n\n/* Button style  */\n.button {\n  color: #FFFFFF;\n  padding: 1em 2em;\n  text-decoration: none;\n  transition: transform 0.15s, background 0.01s;\n}\n.button.remove {\n  position: absolute;\n  top: 0;\n  right: -10px;\n  color: #999;\n}\n\n@media (max-width: 1199px) {\n  .note {\n    min-width: 260px;\n    min-height: 260px;\n  }\n}\n/*====todo css start====*/\n.todo .action-box {\n  background: transparent;\n  height: 20px;\n  width: 20px;\n  display: inline-block;\n  text-align: center;\n  cursor: pointer;\n  transition: all 300ms ease;\n}\n.todo .action-box .icon {\n  vertical-align: 0;\n}\n.todo .action-box.completed {\n  background: #fc4438;\n  border: 1px solid #fc4438;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.todo .action-box.completed .icon {\n  color: #fff;\n  font-size: 14px;\n  width: 16px;\n  height: 16px;\n}\n.todo .action-box.large {\n  height: 30px;\n  width: 30px;\n}\n.todo .action-box.large .icon {\n  font-size: 20px;\n  vertical-align: -5px;\n}\n.todo .action-box.large .icon .icon-trash {\n  color: var(--theme-default);\n}\n.todo .action-box.large .icon .icon-check {\n  color: var(--theme-default);\n}\n.todo .todo-list-wrapper {\n  width: 100%;\n  margin: 0 auto;\n  box-sizing: border-box;\n}\n.todo .todo-list-wrapper .mark-all-tasks {\n  display: flex;\n  align-items: center;\n}\n.todo .todo-list-wrapper .mark-all-tasks .mark-all-tasks-container {\n  overflow: hidden;\n  position: relative;\n}\n.todo .todo-list-wrapper .mark-all-tasks .mark-all-btn {\n  cursor: pointer;\n  display: inline-block;\n  transition: all 200ms ease;\n}\n.todo .todo-list-wrapper .mark-all-tasks .mark-all-btn#mark-all-finished {\n  color: #fc4438;\n}\n.todo .todo-list-wrapper .mark-all-tasks .mark-all-btn#mark-all-incomplete {\n  color: #54ba4a;\n}\n.todo .todo-list-wrapper .mark-all-tasks .mark-all-btn#mark-all-incomplete .action-box {\n  border: 2px solid #54ba4a;\n  border-radius: 4px;\n}\n.todo .todo-list-wrapper .mark-all-tasks .mark-all-btn#mark-all-incomplete .action-box .icon {\n  color: #54ba4a;\n}\n.todo .todo-list-wrapper .mark-all-tasks .mark-all-btn.move-up {\n  transform: translateY(-30px);\n  position: absolute;\n  right: 0;\n}\n.todo .todo-list-wrapper .mark-all-tasks .mark-all-btn.move-down {\n  transform: translateY(30px);\n  position: absolute;\n  right: 0;\n}\n.todo .todo-list-wrapper .mark-all-tasks .btn-label {\n  margin-right: 5px;\n  font-weight: 600;\n}\n.todo .todo-list-wrapper .todo-list-footer {\n  position: relative;\n}\n.todo .todo-list-wrapper .todo-list-footer h5, .todo .todo-list-wrapper .todo-list-footer .h5 {\n  text-align: center;\n  color: #2f2f3b;\n}\n.todo .todo-list-wrapper .todo-list-footer .add-task-btn:hover {\n  background: var(--theme-default);\n}\n.todo .todo-list-wrapper .todo-list-footer .add-task-btn:hover .icon {\n  color: #f4f4f4;\n}\n.todo .todo-list-wrapper .todo-list-footer .add-task-btn .icon {\n  color: var(--theme-default);\n  font-size: 20px;\n}\n.todo .todo-list-wrapper .todo-list-footer .new-task-wrapper {\n  transition: all 300ms ease;\n  max-height: 0;\n  overflow: hidden;\n}\n.todo .todo-list-wrapper .todo-list-footer .new-task-wrapper textarea {\n  box-sizing: border-box;\n  width: 100%;\n  border: 1px solid #f4f4f4;\n  height: 90px;\n  padding: 10px 15px;\n  margin-bottom: 10px;\n  border-radius: 4px;\n  transition: all 300ms ease;\n}\n.todo .todo-list-wrapper .todo-list-footer .new-task-wrapper textarea:focus {\n  border: 1px solid #efefef;\n  outline: none;\n}\n.todo .todo-list-wrapper .todo-list-footer .new-task-wrapper textarea.error {\n  border: 1px solid #fc4438;\n  outline: none;\n}\n.todo .todo-list-wrapper .todo-list-footer .new-task-wrapper .error-message {\n  color: #fc4438;\n  font-style: italic;\n}\n.todo .todo-list-wrapper .todo-list-footer .new-task-wrapper.visible {\n  max-height: 300px;\n  overflow: auto;\n}\n.todo .todo-list-wrapper .todo-list-footer .new-task-wrapper::after {\n  content: \"\";\n  display: block;\n  clear: both;\n}\n.todo .todo-list-wrapper .todo-list-body {\n  max-height: 500px;\n  overflow: auto;\n}\n.todo .todo-list-wrapper #todo-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.todo .todo-list-wrapper #todo-list .task:first-child .task-container {\n  padding-top: 0;\n}\n.todo .todo-list-wrapper #todo-list .task:first-child .task-container h4, .todo .todo-list-wrapper #todo-list .task:first-child .task-container .h4 {\n  padding-top: 0;\n}\n.todo .todo-list-wrapper #todo-list li {\n  margin: 0;\n  padding: 0;\n}\n.todo .todo-list-wrapper #todo-list li .task-container {\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 0;\n  width: 100%;\n  border-bottom: 1px solid #f4f4f4;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  position: relative;\n  transition: background 200ms ease;\n}\n.todo .todo-list-wrapper #todo-list li .task-container .assign-name {\n  font-size: 14px;\n}\n.todo .todo-list-wrapper #todo-list li .task-container .task-label {\n  display: block;\n  font-size: 17px;\n  vertical-align: middle;\n  color: #898989;\n  word-break: break-all;\n  padding-top: 5px;\n  font-weight: 300;\n}\n.todo .todo-list-wrapper #todo-list li .task-container .task-action-btn {\n  display: table-cell;\n  vertical-align: middle;\n  text-align: right;\n  min-width: 65px;\n}\n.todo .todo-list-wrapper #todo-list li .task-container .task-action-btn .action-box {\n  margin-left: 5px;\n  margin-top: 2px;\n  border: 1px solid transparent;\n  margin-bottom: 2px;\n}\n.todo .todo-list-wrapper #todo-list li .task-container .task-action-btn .action-box .icon {\n  font-size: 16px;\n}\n.todo .todo-list-wrapper #todo-list li .task-container .task-action-btn .action-box:hover {\n  border: 1px solid #59667a;\n  background: #fff;\n  border-radius: 4px;\n}\n.todo .todo-list-wrapper #todo-list li .task-container .task-action-btn .action-box:hover .icon {\n  color: #59667a;\n}\n.todo .todo-list-wrapper #todo-list li .task-container:hover h4, .todo .todo-list-wrapper #todo-list li .task-container:hover .h4 {\n  color: #2c323f;\n  transition: all 0.3s ease;\n}\n.todo .todo-list-wrapper #todo-list li.completed .task-container .complete-btn {\n  border: 1px solid var(--theme-default);\n  border-radius: 4px;\n}\n.todo .todo-list-wrapper #todo-list li.completed .task-container .complete-btn .icon {\n  font-weight: bold;\n}\n.todo .todo-list-wrapper #todo-list li.completed .task-container .complete-btn:hover {\n  background: #fff;\n  border: 1px solid #54ba4a;\n}\n.todo .todo-list-wrapper #todo-list li.completed .task-container .complete-btn:hover .icon {\n  color: #fff;\n}\n.todo .todo-list-wrapper #todo-list li.completed .task-container .task-label {\n  text-decoration: line-through;\n  color: var(--theme-default);\n}\n.todo .todo-list-wrapper #todo-list li.new .task-container {\n  animation: taskHighlighter 2000ms linear 1;\n}\n.todo .todo-list-wrapper .todo-list-header h5, .todo .todo-list-wrapper .todo-list-header .h5 {\n  text-align: center;\n  color: #efefef;\n}\n.todo .notification-popup {\n  position: fixed;\n  top: 85px;\n  right: 10px;\n  width: 300px;\n  display: inline-block;\n  background: #54ba4a;\n  border: 1px solid #54ba4a;\n  color: #fff;\n  padding: 20px;\n  opacity: 0.9;\n  border-radius: 2px;\n  box-sizing: border-box;\n  transition: all 300ms ease;\n}\n.todo .notification-popup.success {\n  background: #54ba4a;\n  border: 1px solid #54ba4a;\n}\n.todo .notification-popup p {\n  margin-top: 0;\n  margin-bottom: 0;\n  color: #fff;\n}\n.todo .notification-popup .task {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  max-width: 100%;\n  display: inline-block;\n}\n.todo .notification-popup .notification-text {\n  font-size: 14px;\n  display: inline-block;\n  overflow: hidden;\n}\n.todo .notification-popup.hide {\n  opacity: 0;\n  visibility: hidden;\n}\n@-webkit-keyframes taskHighlighter {\n  0% {\n    background: rgba(68, 102, 242, 0.5);\n  }\n  100% {\n    background: #fff;\n  }\n}\n@keyframes taskHighlighter {\n  0% {\n    background: rgba(68, 102, 242, 0.5);\n  }\n  100% {\n    background: #fff;\n  }\n}\n\n.todo-wrap .todo-list-body .assign-name {\n  opacity: 0.4;\n}\n.todo-wrap .left-bookmark ul li .iconbg {\n  padding: 8px;\n  border-radius: 30px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.todo-wrap.email-wrap .email-app-sidebar .main-menu > li + li {\n  padding-top: 12px;\n}\n.todo-wrap.email-wrap .email-app-sidebar .main-menu > li a {\n  padding: 0 16px;\n}\n.todo-wrap.email-wrap .email-app-sidebar .main-menu > li a .badge {\n  color: #fff;\n  padding: 4px 5px 3px;\n}\n.todo-wrap.email-wrap .email-app-sidebar .main-menu > li a:hover {\n  background-color: transparent;\n}\n.todo-wrap.email-wrap .email-app-sidebar .main-menu > li a:hover .badge {\n  color: #fff;\n}\n.todo-wrap.email-wrap .btn-mail {\n  color: #fff !important;\n}\n\n/*====todo css end====*/","@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.3.8 (https://getbootstrap.com/)\n   * Copyright 2011-2025 The Bootstrap Authors\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// scss-docs-start color-mode-mixin\n@mixin color-mode($mode: light, $root: false) {\n  @if $color-mode-type == \"media-query\" {\n    @if $root == true {\n      @media (prefers-color-scheme: $mode) {\n        :root {\n          @content;\n        }\n      }\n    } @else {\n      @media (prefers-color-scheme: $mode) {\n        @content;\n      }\n    }\n  } @else {\n    [data-bs-theme=\"#{$mode}\"] {\n      @content;\n    }\n  }\n}\n// scss-docs-end color-mode-mixin\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n  @include font-size($legend-font-size);\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n\n  // 3. Better affordance and consistent appearance for search cancel button\n  &::-webkit-search-cancel-button {\n    cursor: pointer;\n    filter: grayscale(1);\n  }\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.2 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG/#contrast-minimum\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(mix(color-contrast($link-color), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(-1 * #{$pagination-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n// fusv-disable\n$accordion-button-focus-border-color:     $input-focus-border-color !default; // Deprecated in v5.3.3\n// fusv-enable\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-color}' stroke-linecap='round' stroke-linejoin='round'><path d='m2 5 6 6 6-6'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-active-color}' stroke-linecap='round' stroke-linejoin='round'><path d='m2 5 6 6 6-6'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               var(--#{$prefix}body-color) !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n$carousel-control-icon-filter:       null !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default; // Deprecated in v5.3.4\n$carousel-dark-caption-color:        $black !default; // Deprecated in v5.3.4\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default; // Deprecated in v5.3.4\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-filter:           null !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default; // Deprecated in v5.3.4\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n\n@import \"variables-dark\"; // TODO: can be removed safely in v6, only here to avoid breaking changes in v5.3\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n    @include font-size($font-size);\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0;\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is an invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefore we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius, 0);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    max-width: 100%;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n    padding-left: $form-floating-padding-x;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      transform: $form-floating-label-transform;\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      transform: $form-floating-label-transform;\n    }\n  }\n  > textarea:focus,\n  > textarea:not(:placeholder-shown) {\n    ~ label::after {\n      position: absolute;\n      inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n      z-index: -1;\n      height: $form-floating-label-height;\n      content: \"\";\n      background-color: $input-bg;\n      @include border-radius($input-border-radius);\n    }\n  }\n  > textarea:disabled ~ label::after {\n    background-color: $input-disabled-bg;\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc(-1 * #{$input-border-width}); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($input-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($form-select-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  .btn-check:checked:focus-visible + & {\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down($width: $caret-width) {\n  border-top: $width solid;\n  border-right: $width solid transparent;\n  border-bottom: 0;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-up($width: $caret-width) {\n  border-top: 0;\n  border-right: $width solid transparent;\n  border-bottom: $width solid;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-end($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: 0;\n  border-bottom: $width solid transparent;\n  border-left: $width solid;\n}\n\n@mixin caret-start($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: $width solid;\n  border-bottom: $width solid transparent;\n}\n\n@mixin caret(\n  $direction: down,\n  $width: $caret-width,\n  $spacing: $caret-spacing,\n  $vertical-align: $caret-vertical-align\n) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $spacing;\n      vertical-align: $vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down($width);\n      } @else if $direction == up {\n        @include caret-up($width);\n      } @else if $direction == end {\n        @include caret-end($width);\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $spacing;\n        vertical-align: $vertical-align;\n        content: \"\";\n        @include caret-start($width);\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(-1 * #{$btn-border-width}); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(-1 * #{$btn-border-width}); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  // The top radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-grow: 1;\n    flex-basis: 0;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-grow: 1;\n  flex-basis: 100%;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      flex: 1 0 0;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          > .card-img-top,\n          > .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          > .card-img-bottom,\n          > .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          > .card-img-top,\n          > .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          > .card-img-bottom,\n          > .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    > .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  > .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    // stylelint-disable selector-max-class\n    > .accordion-collapse,\n    > .accordion-header .accordion-button,\n    > .accordion-header .accordion-button.collapsed {\n      @include border-radius(0);\n    }\n    // stylelint-enable selector-max-class\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(-1 * #{$pagination-border-width}) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: var(--#{$prefix}progress-height); }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  &:not(.active) {\n    // Hover state\n    &:hover,\n    &:focus {\n      z-index: 1; // Place hover/focus items above their siblings for proper border styling\n      color: var(--#{$prefix}list-group-action-hover-color);\n      text-decoration: none;\n      background-color: var(--#{$prefix}list-group-action-hover-bg);\n    }\n\n    &:active {\n      color: var(--#{$prefix}list-group-action-active-color);\n      background-color: var(--#{$prefix}list-group-action-active-bg);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  filter: var(--#{$prefix}btn-close-filter);\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  --#{$prefix}btn-close-filter: #{$btn-close-filter-dark};\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n:root,\n[data-bs-theme=\"light\"] {\n  --#{$prefix}btn-close-filter: #{$btn-close-filter};\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    @include btn-close-white();\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    transform: $modal-fade-transform;\n    @include transition($modal-transition);\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    // Split properties to avoid invalid calc() function if value is 0\n    margin-top: calc(-.5 * var(--#{$prefix}modal-header-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}modal-header-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}modal-header-padding-y));\n    margin-left: auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  filter: var(--#{$prefix}carousel-control-icon-filter);\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-next-icon-bg) + \"*/\"};\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-prev-icon-bg) + \"*/\"};\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: var(--#{$prefix}carousel-indicator-active-bg);\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: var(--#{$prefix}carousel-caption-color);\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-indicator-active-bg-dark};\n  --#{$prefix}carousel-caption-color: #{$carousel-caption-color-dark};\n  --#{$prefix}carousel-control-icon-filter: #{$carousel-control-icon-filter-dark};\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n:root,\n[data-bs-theme=\"light\"] {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-indicator-active-bg};\n  --#{$prefix}carousel-caption-color: #{$carousel-caption-color};\n  --#{$prefix}carousel-control-icon-filter: #{$carousel-control-icon-filter};\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    @include carousel-dark();\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  flex-shrink: 0;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    // Split properties to avoid invalid calc() function if value is 0\n    margin-top: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}offcanvas-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-left: auto;\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n\n  // Fix to prevent overflowing children to become focusable\n  * {\n    overflow: hidden !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/WAI/WCAG22/Techniques/general/G1.html\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","/*! -----------------------------------------------------------------------------------\n\n    Template Name: Cuba Admin\n    Template URI: http://admin.pixelstrap.com/cuba/theme\n    Description: This is Admin theme\n    Author: Pixelstrap\n    Author URI: https://themeforest.net/user/pixelstrap\n\n-----------------------------------------------------------------------------------\n\n\n */\n\n// *** utils ***\n\n@import \"utils/variables\";\n\n:root {\n  --theme-default: #7366ff;\n  --theme-secondary: #f73164;\n  --light-background: rgba(242, 243, 247, 0.7);\n  --body-font-color: #2f2f3b;\n  --chart-border: #ecf3fa;\n  --recent-chart-bg: #fcfcfd;\n  --light-bg: #f6f7f9;\n  --white: #fff;\n  --light2: #f5f6f9;\n  --sidebar-border: rgba(0, 0, 0, 0.1);\n  --chart-text-color: rgba(82, 82, 108, 0.8);\n  --recent-dashed-border: rgba(82, 82, 108, 0.3);\n  --chart-dashed-border: rgba(82, 82, 108, 0.2);\n  --chart-progress-light: rgba(82, 82, 108, 0.1);\n  --recent-box-bg: #f2f4f7;\n  --recent-border: rgba(97, 101, 122, 0.25);\n  --course-light-btn: #f2f3f7;\n  --course-bg: #f7f7f7;\n  --balance-profie-bg: #e0dfef;\n  --view-grid-bg: #ecf3fa80;\n  --view-border-marker: #cfcdfc;\n\n  --fc-button-bg-color: var(--theme-default);\n  --fc-button-active-bg-color: var(--theme-default);\n  --fc-button-active-border-color: var(--theme-default);\n  --fc-button-border-color: var(--theme-default);\n  --fc-button-hover-bg-color: var(--theme-default);\n  --fc-button-hover-border-color: var(--theme-default);\n}\n\nbody[class=\"dark-only\"],\nbody.dark-only {\n  --light-background: rgba(31, 32, 40, 0.65);\n  --recent-chart-bg: #262932;\n  --light-bg: #1d1e26;\n  --white: #262932;\n  --sidebar-border: rgba(255, 255, 255, 0.1);\n  --light2: #1d1e26;\n  --chart-border: #374558;\n  --recent-box-bg: #1d1e26;\n  --recent-border: #374558;\n  --body-font-color: rgba(255, 255, 255, 0.6);\n  --course-light-btn: var(--light-bg);\n  --view-grid-bg: var(--light-bg);\n  --view-border-marker: #2c2c45d4;\n  -semi-dark: #1d1e26;\n}\n\n// *** base ***\n@import \"base/reset\";\n@import \"base/typography\";\n\n//  *** components ***\n@import \"components/according\";\n@import \"components/alert\";\n@import \"components/avatars\";\n@import \"components/badge\";\n@import \"components/bookmark\";\n@import \"components/breadcrumb\";\n@import \"components/builders\";\n\n@import \"components/buttons\";\n\n@import \"components/card\";\n@import \"components/color\";\n@import \"components/datepicker\";\n@import \"components/dropdown\";\n@import \"components/datatable\";\n// @import \"components/form-builder\";\n@import \"components/form-input\";\n@import \"components/form-wizard\";\n@import \"components/forms\";\n// @import \"components/form_builder-2\";\n@import \"components/icons\";\n@import \"components/list\";\n@import \"components/loader\";\n@import \"components/popover\";\n@import \"components/print\";\n@import \"components/radio\";\n@import \"components/ribbon\";\n@import \"components/switch\";\n@import \"components/tab\";\n@import \"components/table\";\n@import \"components/timePeeker\";\n@import \"components/touchspin\";\n@import \"components/tour\";\n@import \"components/typeahead-search\";\n@import \"components/react-plugin\";\n@import \"components/slick.scss\";\n@import \"components/slick-theme.scss\";\n@import \"components/scrollbar\";\n\n//\t*** pages ***\n\n@import \"pages/blog.scss\";\n@import \"pages/bookmark-app.scss\";\n@import \"pages/cart.scss\";\n@import \"pages/chart.scss\";\n@import \"pages/chat.scss\";\n@import \"pages/checkout.scss\";\n@import \"pages/comingsoon.scss\";\n@import \"pages/contacts.scss\";\n@import \"pages/dashboard_2.scss\";\n@import \"pages/dashboard_3.scss\";\n@import \"pages/dashboard_4.scss\";\n@import \"pages/dashboard_5.scss\";\n@import \"pages/dashboard_default.scss\";\n@import \"pages/ecommerce.scss\";\n@import \"pages/email-application.scss\";\n@import \"pages/errorpage.scss\";\n@import \"pages/faq.scss\";\n@import \"pages/file.scss\";\n@import \"pages/gallery.scss\";\n@import \"pages/internationalization.scss\";\n@import \"pages/job-search.scss\";\n@import \"pages/jsgrid.scss\";\n@import \"pages/kanban.scss\";\n@import \"pages/knowledgebase.scss\";\n@import \"pages/language.scss\";\n@import \"pages/learning.scss\";\n@import \"pages/login.scss\";\n@import \"pages/megaoption.scss\";\n@import \"pages/order-history.scss\";\n@import \"pages/page.scss\";\n@import \"pages/pricing.scss\";\n@import \"pages/progress.scss\";\n@import \"pages/projectlist.scss\";\n@import \"pages/social-app.scss\";\n@import \"pages/task.scss\";\n@import \"pages/timeline-v.scss\";\n@import \"pages/timeliny.scss\";\n@import \"pages/user-profile.scss\";\n@import \"pages/wishlist.scss\";\n\n// *** layout ***\n@import \"layout/footer.scss\";\n@import \"layout/grid.scss\";\n@import \"layout/header.scss\";\n@import \"layout/navs.scss\";\n@import \"layout/search.scss\";\n@import \"layout/select2.scss\";\n@import \"layout/sidebar.scss\";\n@import \"layout/rtl.scss\";\n@import \"layout/box-layout\";\n\n/* ---------------------\n\t*** themes **\n-----------------------*/\n@import \"themes/dark\";\n@import \"themes/theme-customizer\";\n@import \"themes/responsive\";\n@import \"themes/update\";\n","/**=====================\n     Reset css start\n==========================**/\n.font-roboto {\n  font-family: $font-roboto, $font-serif;\n}\n.f-light {\n  color: rgba($theme-body-sub-title-color, 0.8);\n}\nsvg {\n  &.f-light {\n    fill: $theme-body-sub-title-color;\n    opacity: 0.8;\n  }\n}\n.light-card {\n  background-color: var(--light-background);\n}\n.light-background {\n  background-color: var(--light-bg);\n}\n\n.icon-arrow-down,\n.icon-arrow-up {\n  &.icon-rotate {\n    transform: rotate(-45deg);\n    display: inline-block;\n  }\n}\n\n/*====== Padding css starts ======*/\n$i: 0;\n\n@while $i<=50 {\n  .p-#{$i} {\n    padding: #{$i}px;\n  }\n\n  $i: $i + 5;\n}\n\n/*====== Padding css ends ======*/\n\n/*====== Padding-left css starts ======*/\n$i: 0;\n\n@while $i<=50 {\n  .p-l-#{$i} {\n    padding-left: #{$i}px;\n  }\n\n  $i: $i + 5;\n}\n\n/*====== Padding-left css ends ======*/\n\n/*====== Padding-top css starts ======*/\n$i: 0;\n\n@while $i<=50 {\n  .p-t-#{$i} {\n    padding-top: #{$i}px !important;\n  }\n\n  $i: $i + 5;\n}\n\n/*====== Padding-top css ends ======*/\n\n/*====== Padding-bottom css starts ======*/\n$i: 0;\n\n@while $i<=50 {\n  .p-b-#{$i} {\n    padding-bottom: #{$i}px !important;\n  }\n\n  $i: $i + 5;\n}\n\n/*====== Padding-bottom css ends ======*/\n\n/*====== Padding-right css starts ======*/\n$i: 0;\n\n@while $i<=50 {\n  .p-r-#{$i} {\n    padding-right: #{$i}px;\n  }\n\n  $i: $i + 5;\n}\n\n/*====== Padding-right css ends ======*/\n\n/*====== Margin css starts ======*/\n$i: 0;\n\n@while $i<=50 {\n  .m-#{$i} {\n    margin: #{$i}px !important;\n  }\n\n  $i: $i + 5;\n}\n\n/*====== Margin css ends ======*/\n\n/*====== Margin-top css starts ======*/\n$i: 0;\n\n@while $i<=50 {\n  .m-t-#{$i} {\n    margin-top: #{$i}px !important;\n  }\n\n  $i: $i + 5;\n}\n\n/*====== Margin-top css ends ======*/\n\n/*====== Margin-Bottom css starts ======*/\n$i: 0;\n\n@while $i<=50 {\n  .m-b-#{$i} {\n    margin-bottom: #{$i}px !important;\n  }\n\n  $i: $i + 5;\n}\n\n/*====== Margin-Bottom css ends ======*/\n\n/*====== Margin-left css starts ======*/\n$i: 0;\n\n@while $i<=50 {\n  .m-l-#{$i} {\n    margin-left: #{$i}px !important;\n  }\n\n  $i: $i + 5;\n}\n\n/*====== Margin-left css ends ======*/\n\n/*====== Margin-right css starts ======*/\n$i: 0;\n\n@while $i<=50 {\n  .m-r-#{$i} {\n    margin-right: #{$i}px;\n  }\n\n  $i: $i + 5;\n}\n\n/*====== Margin-right css ends ======*/\n\n/*====== Border-radius css starts ======*/\n$i: 0;\n\n@while $i<=10 {\n  .b-r-#{$i} {\n    border-radius: #{$i}px !important;\n  }\n\n  $i: $i + 1;\n}\n\n/*====== Border-radius css ends ======*/\n\n/*====== Font-size css starts ======*/\n$i: 12;\n\n@while $i<=100 {\n  .f-#{$i} {\n    font-size: #{$i}px !important;\n  }\n\n  $i: $i + 2;\n}\n\n/*====== Font-size css ends ======*/\n\n/*====== Font-weight css starts ======*/\n$i: 100, 300, 500, 400, 600, 700, 900;\n\n@each $val in $i {\n  .f-w-#{$val} {\n    font-weight: $val;\n  }\n}\n\n/*====== Font-weight css ends ======*/\n\n/*====== Font-style css starts ======*/\n$i: normal, italic, oblique, initial, inherit;\n\n@each $val in $i {\n  .f-s-#{$val} {\n    font-style: $val;\n  }\n}\n\n/*====== Font-style css ends ======*/\n\n/*====== Text-Decoration css starts ======*/\n\n$i: overline, line-through, underline, dashed, blink, dotted, initial, none, solid, wavy, inherit, double;\n\n@each $val in $i {\n  .text-#{$val} {\n    text-decoration: $val;\n  }\n}\n\n/*====== Text-Decoration css ends ======*/\n\n/*====== Vertical-Align css starts ======*/\n$i: baseline, sub, super, top, text-top, middle, bottom, text-bottom, initial, inherit;\n\n@each $val in $i {\n  .#{$val} {\n    vertical-align: $val;\n  }\n}\n\n/*====== Vertical-Align css ends ======*/\n\n/*====== Position css starts ======*/\n\n$i: static, absolute, fixed, relative, initial, inherit;\n\n@each $val in $i {\n  .p-#{$val} {\n    position: $val;\n  }\n}\n\n/*====== Position css ends ======*/\n\n/*====== Float css starts ======*/\n$i: left, right, none;\n\n@each $val in $i {\n  .f-#{$val} {\n    float: $val;\n  }\n}\n\n/*====== Float css ends ======*/\n\n/*====== Overflow css starts ======*/\n$i: hidden, visible, auto;\n\n@each $val in $i {\n  .o-#{$val} {\n    overflow: $val;\n  }\n}\n\n/*====== Overflow css ends ======*/\n\n/*====== Image-sizes css starts ======*/\n$i: 10;\n\n@while $i<=100 {\n  .img-#{$i} {\n    width: #{$i}px !important;\n  }\n\n  $i: $i + 10;\n}\n\n/*====== Image-sizes css ends ======*/\n\n/*======= Text css starts ===========*/\n$text-name: primary, secondary, success, danger, info, light, dark, warning;\n$text-color: $primary-color, $secondary-color, $success-color, $danger-color, $info-color, $light-color, $dark-color, $warning-color;\n\n@each $var in $text-name {\n  $i: index($text-name, $var);\n\n  .font-#{$var} {\n    color: nth($text-color, $i) !important;\n  }\n}\n\n.font-primary {\n  color: var(--theme-default) !important;\n}\n\n.font-secondary {\n  color: var(--theme-secondary) !important;\n}\n\n/*======= Text css ends ===========*/\n\n/*======= Label-color css starts  ======= */\n\n.label {\n  border-radius: 2px;\n  color: $white;\n  font-size: 12px;\n  line-height: 1;\n  margin-bottom: 0;\n  text-transform: capitalize;\n}\n\n$label-name: theme, primary, secondary, success, danger, info, light, dark, warning;\n$label-color: $primary-color, $primary-color, $secondary-color, $success-color, $danger-color, $info-color, $light-color, $dark-color, $warning-color;\n\n@each $var in $label-name {\n  $i: index($label-name, $var);\n\n  .label-#{$var} {\n    background-color: nth($label-color, $i);\n  }\n}\n\n/*======= Label-color css ends  ======= */\n\n/*======= Badge-color css starts  ======= */\n\n$badge-name: primary, secondary, success, danger, info, light, dark, warning;\n$badge-color: $primary-color, $secondary-color, $success-color, $danger-color, $info-color, $light-color, $dark-color, $warning-color;\n\n@each $var in $badge-name {\n  $i: index($badge-name, $var);\n\n  .badge-#{$var} {\n    background-color: nth($badge-color, $i);\n\n    @if ($badge-name== \"light\") {\n      color: $theme-body-font-color !important;\n    }\n  }\n}\n\n.badge-primary {\n  background-color: var(--theme-default) !important;\n}\n\n.badge-secondary {\n  background-color: var(--theme-secondary) !important;\n}\n\n/*======= Badge-color css end  ======= */\n\n/*======= Background-color css starts  ======= */\n\n$background-name: primary, secondary, success, danger, info, light, dark, warning;\n$background-color: $primary-color, $secondary-color, $success-color, $danger-color, $info-color, $light-color, $dark-color, $warning-color;\n\n@each $var in $background-name {\n  $i: index($background-name, $var);\n\n  .bg-#{$var} {\n    background-color: nth($background-color, $i) !important;\n    color: $white;\n  }\n\n  .bg-light-#{$var} {\n    background-color: rgba(nth($background-color, $i), 0.1) !important;\n    color: $white;\n  }\n}\n\n.bg-primary {\n  background-color: var(--theme-default) !important;\n}\n\n.bg-secondary {\n  background-color: var(--theme-secondary) !important;\n}\n\n/*======= Background-color css end  ======= */\n\n/*======= Font-color css starts  ======= */\n\n$text-name: primary, secondary, success, danger, info, light, dark, warning, google-plus, twitter, linkedin, fb;\n$label-color: $primary-color, $secondary-color, $success-color, $danger-color, $info-color, $light-color, $dark-color, $warning-color, $google-plus, $twitter, $linkedin, $fb;\n\n@each $var in $text-name {\n  $i: index($text-name, $var);\n\n  .txt-#{$var} {\n    color: nth($label-color, $i) !important;\n  }\n}\n\n.txt-primary {\n  color: var(--theme-default) !important;\n}\n\n.txt-secondary {\n  color: var(--theme-secondary) !important;\n}\n\n/*======= Font-color css end  ======= */\n\n/*======= Button-color css starts  ======= */\n// btn--color//\n@keyframes push {\n  50% {\n    transform: scale(0.95);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n@each $btn-name, $btn-color in (primary, $primary-color), (secondary, $secondary-color), (success, $success-color), (danger, $danger-color), (info, $info-color), (light, $light-color), (dark, $dark-color), (warning, $warning-color) {\n  .btn-#{$btn-name} {\n    background-color: $btn-color !important;\n    border-color: $btn-color !important;\n    -webkit-tap-highlight-color: transparent;\n    transform: translateZ(0);\n\n    @if ($btn-name== \"info\") {\n      color: $white;\n      &:hover,\n      &:focus,\n      &:active,\n      &.active {\n        color: $white;\n      }\n    }\n\n    &.disabled,\n    &:disabled {\n      background-color: $btn-color !important;\n      border-color: $btn-color !important;\n    }\n\n    &:focus {\n      box-shadow: 0 0 0 0.2rem lighten($btn-color, 30%);\n    }\n  }\n}\n\n.btn-light {\n  background-color: rgba($primary-color, 0.06) !important;\n  border-color: rgba($primary-color, 0.06) !important;\n\n  &:hover {\n    background-color: rgba($primary-color, 0.1) !important;\n    border-color: rgba($primary-color, 0.1) !important;\n  }\n}\n\n.btn-primary {\n  background-color: var(--theme-default) !important;\n  border-color: var(--theme-default) !important;\n}\n\n.btn-secondary {\n  background-color: var(--theme-secondary) !important;\n  border-color: var(--theme-secondary) !important;\n}\n\n.btn-hover-effect {\n  &:hover {\n    animation: push 0.5s linear 1;\n  }\n}\n\n/*======= Button-color css ends  ======= */\n@each $btn-name, $btn-color in (primary, $primary-color), (secondary, $secondary-color), (success, $success-color), (danger, $danger-color), (info, $info-color), (light, $light-color), (dark, $dark-color), (warning, $warning-color) {\n  .btn-outline-#{$btn-name}-2x {\n    border-width: 2px;\n    border-color: $btn-color;\n    color: $btn-color;\n    background-color: transparent;\n\n    &:hover,\n    &:focus,\n    &:active,\n    &.active {\n      color: white;\n      background-color: darken($btn-color, 10%) !important;\n      border-color: darken($btn-color, 10%) !important;\n      box-shadow: none;\n    }\n  }\n}\n\n// outline buttons//\n@each $btn-name, $btn-color in (primary, $primary-color), (secondary, $secondary-color), (success, $success-color), (danger, $danger-color), (info, $info-color), (light, $light-color), (dark, $dark-color), (warning, $warning-color) {\n  .btn-outline-#{$btn-name} {\n    border-color: $btn-color;\n    color: $btn-color;\n    background-color: transparent;\n\n    &.disabled {\n      color: $btn-color;\n    }\n\n    @if ($btn-name== \"light\") {\n      color: $theme-body-font-color;\n    }\n\n    &:hover,\n    &:focus,\n    &:active,\n    &.active {\n      color: white;\n      background-color: darken($btn-color, 10%) !important;\n      border-color: darken($btn-color, 10%) !important;\n    }\n  }\n}\n\n//active button css //\n\n@each $btn-name, $btn-color in (primary, $primary-color), (secondary, $secondary-color), (success, $success-color), (danger, $danger-color), (info, $info-color), (light, $light-color), (dark, $dark-color), (warning, $warning-color) {\n  .btn-#{$btn-name}:not([disabled]):not(.disabled).active {\n    background-color: darken($btn-color, 10%);\n    border-color: darken($btn-color, 10%);\n    box-shadow: none !important;\n\n    &:hover,\n    &:focus,\n    &:active,\n    &.active {\n      color: white;\n      background-color: darken($btn-color, 10%);\n      border-color: darken($btn-color, 10%);\n    }\n  }\n}\n\n//* active button css end *//\n\n@each $btn-name, $btn-color in (primary, $primary-color), (secondary, $secondary-color), (success, $success-color), (danger, $danger-color), (info, $info-color), (light, $light-color), (dark, $dark-color), (warning, $warning-color) {\n  .btn-outline-#{$btn-name}-2x:not([disabled]):not(.disabled).active {\n    background-color: $btn-color;\n    border-color: $btn-color;\n    box-shadow: none !important;\n    color: white;\n\n    &:hover,\n    &:focus,\n    &:active,\n    &.active {\n      color: white;\n      box-shadow: none !important;\n      background-color: darken($btn-color, 10%) !important;\n      border-color: darken($btn-color, 10%) !important;\n    }\n  }\n}\n\n/*======= Table-Border-Bottom-color css starts  ======= */\n\n$border-name: primary, secondary, success, danger, info, light, dark, warning;\n$border-color: $primary-color, $secondary-color, $success-color, $danger-color, $info-color, $light-color, $dark-color, $warning-color;\n\n@each $var in $border-name {\n  $i: index($border-name, $var);\n\n  table thead .border-bottom-#{$var} th,\n  table tbody .border-bottom-#{$var} th,\n  table tbody .border-bottom-#{$var} td {\n    border-bottom: 1px solid nth($border-color, $i) !important;\n  }\n}\n\n/*======= Table-Border-Bottom-color css ends  ======= */\n\n/*======= Table styling css starts  ======= */\n\n$table-name: primary, secondary, success, danger, info, light, dark, warning;\n$table-color: $primary-color, $secondary-color, $success-color, $danger-color, $info-color, $light-color, $dark-color, $warning-color;\n\n@each $var in $table-name {\n  $i: index($table-name, $var);\n\n  .table-styling .table-#{$var},\n  .table-styling.table-#{$var} {\n    background-color: nth($border-color, $i);\n    color: $white;\n    border: 3px solid nth($border-color, $i);\n\n    thead {\n      background-color: darken(nth($border-color, $i), 10%);\n      border: 3px solid darken(nth($border-color, $i), 10%);\n    }\n\n    th,\n    td {\n      background-color: transparent;\n    }\n  }\n}\n\n/*======= Table styling css ends  ======= */\n\n/*======= All-Borders-color css starts  ======= */\n\n$b-name: primary, secondary, success, danger, info, light, dark, warning;\n$b-color: $primary-color, $secondary-color, $success-color, $danger-color, $info-color, $light-color, $dark-color, $warning-color;\n\n@each $var in $b-name {\n  $i: index($b-name, $var);\n\n  .b-#{$var} {\n    border: 1px solid nth($b-color, $i) !important;\n  }\n\n  .b-t-#{$var} {\n    border-top: 1px solid nth($b-color, $i) !important;\n  }\n\n  .b-b-#{$var} {\n    border-bottom: 1px solid nth($b-color, $i) !important;\n  }\n\n  .b-l-#{$var} {\n    border-left: 1px solid nth($b-color, $i) !important;\n  }\n\n  .b-r-#{$var} {\n    border-right: 1px solid nth($b-color, $i) !important;\n  }\n}\n\n/*======= All-Borders-color css ends  ======= */\n\n/*====== Border width css starts ======*/\n$i: 1;\n\n@while $i<=10 {\n  .border-#{$i} {\n    border-width: #{$i}px !important;\n  }\n\n  $i: $i + 1;\n}\n\n/*====== Border width css ends ======*/\n\n.opacity-0 {\n  opacity: 0;\n}\n\n.map-block {\n  height: 350px;\n  width: 100%;\n}\n\n.map-js-height {\n  height: 500px;\n\n  .btn-group {\n    input {\n      background-color: $primary-color;\n      color: $white;\n\n      & + input {\n        background-color: $secondary-color;\n      }\n    }\n  }\n}\n\n/**====== custom scrollbar css start ======**/\n.custom-scrollbar {\n  &::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 6px $light-gray;\n  }\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: rgba(68, 102, 242, 0.15);\n  }\n}\n\n/**====== Custom scrollbar css end ======**/\n\n/**====== Animation css Start ======**/\n.comment {\n  color: #9f9ba5;\n  font-style: italic;\n}\n\n.line {\n  color: $dark-color;\n\n  pre {\n    font-size: 100%;\n  }\n}\n\n/**====== Animation css end ======**/\n\n/**====== list style css Start ======**/\n.list-circle {\n  list-style: circle;\n}\n\n/**====== list style css end ======**/\n\n/**====== Modal style css Start ======**/\n.theme-close {\n  opacity: 1;\n  height: 40px;\n  width: 40px;\n  position: absolute;\n  font-weight: 400;\n  z-index: 1;\n  right: 0;\n  background-color: $white !important;\n  border-radius: 5px;\n}\n\n/**====== Modal style css end ======**/\n\n/**====== Animation css start ======**/\n.options {\n  > div {\n    color: $gray-60;\n    display: inline-block;\n    padding: 2px 10px;\n    border: 1px solid;\n    margin: 0 8px 8px 0;\n    transition: all 0.3s ease;\n\n    &:hover {\n      background-color: $primary-color;\n      color: $white;\n      transition: all 0.3s ease;\n    }\n  }\n}\n\n/**====== Animation css Ends ======**/\n\n.modal-footer {\n  flex-wrap: wrap;\n}\n\n.img-cropper {\n  #putData {\n    margin-bottom: 0;\n  }\n\n  .img-container {\n    min-height: auto;\n    margin-bottom: 0;\n  }\n\n  .docs-data {\n    > .input-group {\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n  }\n\n  .docs-preview {\n    margin-top: 20px;\n    margin-bottom: 10px;\n  }\n}\n\n.dropzone {\n  .dz-preview {\n    .dz-error-message {\n      background: $white !important;\n      color: $primary-color !important;\n      border: 1px solid $primary-color;\n\n      &:after {\n        border-bottom: 6px solid $primary-color !important;\n      }\n    }\n  }\n}\n\n.typeahead {\n  .theme-form {\n    .form-group {\n      margin-bottom: 0;\n    }\n  }\n}\n\n.editor-statusbar {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.125);\n}\n\n.page-builder {\n  .ge-canvas {\n    &.ge-editing {\n      .row {\n        padding: 30px;\n        margin-bottom: 0;\n        background-color: rgba($primary-color, 0.02);\n      }\n    }\n  }\n\n  .btn-screen {\n    padding: 0 18px 0 0;\n  }\n}\n\n.bg-overlay {\n  &.active {\n    height: 100vh;\n    width: 100vw;\n    background-color: rgba($black, 0.2);\n    position: fixed;\n    z-index: 8;\n    top: 0;\n  }\n}\n\nbutton {\n  &:focus {\n    outline: none !important;\n  }\n}\n.primary {\n  .svg-fill {\n    fill: var(--theme-default);\n    &:not(.half-circle) {\n      stroke: var(--theme-default);\n    }\n  }\n  .bg-gradient {\n    background-image: linear-gradient(144.16deg, rgba($primary-color, 0.1) 19.06%, rgba($primary-color, 0) 79.03%) !important;\n  }\n}\n.secondary {\n  .svg-fill {\n    fill: var(--theme-secondary);\n    &:not(.half-circle) {\n      stroke: var(--theme-secondary);\n    }\n  }\n  .bg-gradient {\n    background-image: linear-gradient(144.16deg, rgba($secondary-color, 0.1) 19.06%, rgba($secondary-color, 0) 79.03%) !important;\n  }\n}\n.success {\n  .svg-fill {\n    fill: $success-color;\n  }\n  .bg-gradient {\n    background-image: linear-gradient(144.16deg, rgba($success-color, 0.1) 19.06%, rgba($success-color, 0) 79.03%) !important;\n  }\n}\n.warning {\n  .svg-fill {\n    fill: $warning-color;\n  }\n  .bg-gradient {\n    background-image: linear-gradient(144.16deg, rgba($warning-color, 0.1) 19.06%, rgba($warning-color, 0) 79.03%) !important;\n  }\n}\n\n.dotted {\n  border-style: dotted;\n}\n\n.dashed {\n  border-style: dashed;\n}\n\n.double {\n  border-style: double;\n}\n\n.groove {\n  border-style: groove;\n}\n\n.ridge {\n  border-style: ridge;\n}\n\n.inset {\n  border-style: inset;\n}\n\n.outset {\n  border-style: outset;\n}\n\n@keyframes fadeIncustom {\n  0% {\n    opacity: 0;\n    top: 50px;\n  }\n\n  75% {\n    opacity: 0.6;\n    top: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n.daterangepicker {\n  select {\n    &.monthselect,\n    &.yearselect {\n      border-color: #efefef;\n      background-color: #fff;\n      font-size: 14px;\n      color: #898989;\n      padding: 5px 10px;\n      border-radius: 5px;\n      width: 46%;\n    }\n  }\n}\n.general-widget {\n  .cal-date-widget {\n    .datepicker {\n      padding: 0;\n\n      .react-datepicker {\n        background-color: transparent;\n        box-shadow: none;\n      }\n    }\n  }\n}\n.general-cal {\n  .cal-date-widget {\n    .react-datepicker {\n      background-color: transparent;\n      box-shadow: none;\n    }\n  }\n}\n/**=====================\n     Reset css Ends\n==========================**/\n.form-check-input {\n  &:focus {\n    outline: none;\n    box-shadow: none;\n    border: none;\n  }\n  &[type=\"checkbox\"] {\n    background-color: transparent;\n    border-color: transparent;\n    &:checked {\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n}\n\n.empty-cart-cls {\n  padding: 60px;\n}\n","// General variables\n$theme-font-color: #242934;\n$theme-body-font-color: #2f2f3b;\n$theme-body-sub-title-color: #52526c;\n$body-color: #f8f8f8;\n$main-body-color: #f7f8f9;\n\n// Theme colors variables\n$primary-color: #7366ff;\n$secondary-color: #ff3364;\n$success-color: #54ba4a;\n$info-color: #16c7f9;\n$warning-color: #ffaa05;\n$danger-color: #fc4438;\n$light-color: #f4f4f4;\n$badge-light-color: #52526c;\n$light-gray: #ecf3fa;\n$light-widget-border: #efeeff;\n$light-semi-gray: #efefef;\n$font-gray-color: #6c757d;\n$dark-light: $theme-font-color;\n$dark-gray: #898989;\n$dark-color: #2c323f;\n$gray-60: #cccccc;\n$card-body-color: #f9f9fa;\n$transparent-color: transparent;\n$auth-bg-color: #fafafa;\n$light: #fdfeff;\n$semi-dark: #59667a;\n$light-text: #999999;\n$light-paragraph: #8f8f8f;\n$light-background: #d7e2e9;\n$light-font: rgba(27, 49, 85, 0.4);\n$light-semi-font: $semi-dark;\n$light-chartist-grid-color: #f6f9fd;\n$pitch-color: #fe8a7d;\n$color-scarpa: #4c5667;\n$color-fiord: #455a64;\n$black: #000;\n$white: #fff;\n$off-white: #f7f6ff;\n$theme-medium-color: #eae8ff;\n$dropdown-border-color: #918e99;\n\n// gradient colors\n$gradient-primary: linear-gradient(26deg, var(--theme-default) 0%, #a26cf8 100%);\n$gradient-bg-primary: linear-gradient(103.75deg, #33b1ee -13.9%, var(--theme-default) 79.68%);\n\n//social colors\n$fb: #50598e;\n$twitter: #6fa2d8;\n$google-plus: #c64e40;\n$linkedin: #0077b5;\n\n// soical table\n$fb-color: #2f84f4;\n$insta-color: #fc971e;\n$pintrest-color: $secondary-color;\n$twitter-color: #57b9f6;\n$youtube-color: #f42f2f;\n\n//error input color start\n$light-body-bg-color: #fafdff;\n\n//fonts\n$font-rubik: Rubik;\n$font-roboto: Roboto;\n$font-serif: sans-serif;\n$landing-cursive: \"Caveat\", cursive;\n$font-themify: themify;\n$font-awesome: FontAwesome;\n$font-ICO: IcoFont;\n\n// dark layout variables\n$dark-body-background: #1d1e26;\n$dark-card-background: #262932;\n$dark-card-inbox: #323846;\n$dark-small-font-color: #98a6ad;\n$dark-all-font-color: rgba(255, 255, 255, 0.6);\n$light-all-font-color: rgba(255, 255, 255, 0.2);\n$sidebar-submenu-font-color: rgba(255, 255, 255, 0.6);\n$dark-border-color: $dark-body-background;\n$dark-card-border: #374558;\n$dark-editor-document: #2b2b2b;\n$bg-dark-color: #1f2533;\n$dark-datatable-odd: #1f232b;\n$dark-datatable-sorting: #1c212b;\n$dark-datatable-sorting-even: #22262f;\n$dark-even-hover-sorting: #191e27;\n\n//General tag settings\n$body-font-size: 14px;\n$body-font-color: $theme-body-font-color;\n$ul-padding-left: 0px;\n$ancher-color: var(--theme-default);\n$btn-focus-box-shadow: none;\n$all-focus-outline-color: var(--theme-default);\n\n$paragraph-font-size: 14px;\n$paragraph-line-height: 1.7;\n$paragraph-letter-spacing: 0.7px;\n\n$code-tag-color: var(--theme-default);\n$code-tag-bg-color: rgba($primary-color, 0.03);\n$code-tag-padding: 3px;\n$code-tag-margin: 0 3px;\n$code-tag-border-radious: 2px;\n\n$blockquote-padding: 15px;\n$blockquote-border: 4px solid $light-gray;\n\n$small-tag-padding: 10px;\n$small-tag-color: $dark-color;\n\n$pre-tag-bg-color: rgba($primary-color, 0.03);\n$pre-tag-padding: 20px 0;\n\n$list-group-active-bg-color: var(--theme-default);\n$list-group-active-border-color: var(--theme-default);\n$list-group-img-size: 40px;\n$list-group-margin: 10px;\n\n// Tables settings\n$table-b-margin: 0px;\n$table-heading-color: $theme-body-font-color;\n$table-row-color: $theme-body-font-color;\n$table-footer-font-weight: bold;\n$table-inverse-color: $white;\n$table-hover-color: $light;\n$table-padding: 0.75rem;\n$table-xl-padding: 1.25rem 2rem;\n$table-xl-font: 120%;\n$table-lg-padding: 0.9rem 2rem;\n$table-lg-font: 110%;\n$table-de-padding: 0.75rem 2rem;\n$table-de-font: 100%;\n$table-sm-padding: 0.5rem 2rem;\n$table-sm-font: 90%;\n$table-xs-padding: 0.2rem 2rem;\n$table-xs-font: 80%;\n$horizontal-border-color: #f2f4ff;\n$horizontal-padding: 0.75rem 2rem;\n$table-inverse-bg-color: #292b2c;\n\n//According setting\n$according-card-top-margin: 10px;\n$according-btn-weight: 500;\n$according-btn-color: $theme-body-font-color;\n$according-card-header-padding: 0.75rem 1.25rem;\n$according-card-header-icon: $font-ICO;\n$according-open-icon: \"\\eb73\";\n$according-close-icon: \"\\eb7a\";\n\n//Alert settings\n$alert-hover-color: $dark-color;\n$alert-border-radious: 0.15rem;\n$alert-padding: 15px;\n$alert-msg-icon-size: 16px;\n\n//badge settings\n$badge-padding: 0.44em 0.7em;\n$badge-svg-size: 12px;\n\n//form input settings\n$form-group-margin-bottom: 1.25em;\n$col-form-label-font-size: 14px;\n$form-control-font-size: 14px;\n$form-control-border-radious: 2px;\n$form-control-border-color: $light-gray;\n\n//breadcrumb setting\n$breadcrumb-ancher-color: $white;\n$breadcrumb-ancher-dark-color: $black;\n\n//buttons setting\n$btn-font-size: 14px;\n$btn-padding: 0.375rem 1.75rem;\n$btn-lg-font-size: 18px;\n$btn-sm-font-size: 12px;\n$btn-xs-font-size: 11px;\n$btn-xs-padding: 0.05rem 0.4rem;\n\n//Card settings\n$card-padding: 30px;\n$card-margin-bottom: 30px;\n$card-border-color: 1px solid $light-gray;\n$card-border-radious: 15px;\n$common-shadow-color: rgba($info-color, 0.08);\n$card-box-shadow: 0px 9px 20px rgba(46, 35, 94, 0.07);\n$card-header-bg-color: $white;\n$card-header-font-transform: capitalize;\n$card-header-span-size: 12px;\n$card-header-span-color: $theme-body-sub-title-color;\n$card-body-bg-color: $transparent-color;\n$card-footer-bg-color: $white;\n$card-hover-box-shadow: 0 0 40px rgba(8, 21, 66, 0.05);\n\n//footer settings\n$footer_bg_color: $white;\n$footer_box_shadow: 0 0 20px rgba($semi-dark, 0.1);\n$footer_dark_color: $theme-font-color;\n$footer_dark__txt_color: $white;\n\n//form settings\n$form-group-margin-bottom: 20px;\n$sm-form-margin-bottom: 14px;\n$form-placeholder-color: $dark-gray;\n$form-placeholder-font-size: 14px;\n$form-placeholder-letter-spacing: 1px;\n$form-placeholder-font-weight: 100;\n$form-input-border-color: $light-semi-gray;\n$form-input-bg-color: $white;\n\n//Tour settings\n$tour-color: var(--theme-default);\n\n//sidabr main settings\n$sidebar-width: 255px;\n$sidebar-position: fixed;\n$sidebar-background-color: $white;\n$sidebar-shadow: 0 0 11px rgba(69, 110, 243, 0.13);\n$sidebar-overflow: auto;\n$sidebar-z-index: 9;\n$sidebar-transition: 0.5s;\n$sidebar-fill-icon-color: #757589;\n\n//sidebar profile settings\n$sidebar-profile-edit-icon-size: 14px;\n$sidebar-profile-name-txt-color: var(--theme-default);\n$sidebar-profile-name-txt-transfer: uppercase;\n$sidebar-profile-name-txt-weight: 600;\n$sidebar-profile-name-letter-specing: 1.5px;\n$sidebar-profile-name-marging: 3px;\n$sidebar-profile-sub-title-font-size: 10px;\n$sidebar-profile-sub-title-margin: 0px;\n$sidebar-profile-img-shadow: 0 0 15px rgba(68, 102, 242, 0.3);\n\n//Sidebar main menu setting\n$sidebar-menu-padding: 15px;\n$sidebar-menu-list-style: none;\n$sidebar-menu-list-margin: 0;\n$sidebar-icon-size: 14px;\n$sidebar-icon-margin: 14px;\n$sidebar-icon-stroke-width: 3px;\n$sidebar-font-size: 14px;\n$sidebar-letter-specing: 0.5px;\n$sidebar-txt-transform: capitalize;\n$sidebar-font-weight: 600;\n$sidebar-font-color: $theme-body-font-color;\n$sidebar-padding-top: 12px;\n$sidebar-padding-bottom: 12px;\n$sidebar-sub-header-padding: 15px;\n$sidebar-sub-header-margin: 0;\n$sidebar-heading-hover-padding: 5px;\n$sidebar-hover-txt-color: var(--theme-default);\n$sidebar-arrow-margin-top: 2px;\n$sidebar-arrow-size: 15px;\n$sidebar-arrow-color: $theme-body-font-color;\n$sidebar-open-icon: \"\\f107\";\n$sidebar-close-icon: \"\\f105\";\n$sidebar-icon-font-family: $font-awesome;\n$sidebar-height: calc(100vh - 115px);\n$sidebar-compact-width: 265px;\n\n//Header settings\n$main-header-position: fixed;\n$main-header-top: 0;\n$main-header-shadow: 0 0 20px rgba($semi-dark, 0.1);\n$main-header-shadow-1: 0px 4px 40px rgba(39, 32, 120, 0.1);\n\n//page settings\n$page-body-padding: 0 15px 0 15px;\n$page-body-bg-color: $light-color;\n$page-body-margin-bottom: 0px;\n$page-title-padding: 15px 30px;\n$common-box-shadow: 2px 3.464px 8px 0px rgba(22, 145, 248, 0.18);\n$page-title-font-size: 24px;\n$page-title-margin-bottom: 0;\n$page-title-text-tranform: capitalize;\n$page-small-title-display: block;\n$page-small-title-font-size: 12px;\n$page-small-title-margin-bottom: 5px;\n$page-small-title-text-transform: capitalize;\n$page-small-title-text-color: $theme-body-sub-title-color;\n$breadcrumb-size: 16px;\n$breadcrumb-content: \"/\";\n\n//main header left settings\n$header-left-bg-color: $white;\n$main-header-padding: 27px 22px;\n$main-header-z-index: 8;\n$header-wrapper-padding: 22px 30px;\n$header-wrapper-nav-right: 0px;\n$header-wrapper-nav-icon-size: 20px;\n$header-wrapper-nav-icon-color: $theme-font-color;\n$header-wrapper-nav-icon-align: middle;\n$header-size: 136px;\n$box-layout-space: 40px;\n\n// widgets variables\n$widget-shadow: 1px 2px 21px -2px rgba(214, 214, 227, 0.83);\n","/**=====================\n    Typography css start\n==========================**/\n//Custom css Start\nbody {\n  font-size: $body-font-size;\n  overflow-x: hidden;\n  font-family: $font-rubik, $font-serif;\n  color: $theme-body-font-color;\n}\n\nul {\n  padding-left: $ul-padding-left;\n  list-style-type: none;\n  margin-bottom: 0;\n}\n\n* a {\n  color: var(--theme-default);\n  text-decoration: none;\n  letter-spacing: 1px;\n}\n\na {\n  &:hover {\n    text-decoration: none;\n    color: var(--theme-default);\n  }\n  &[class*=\"badge-\"] {\n    &:hover {\n      color: $white;\n    }\n  }\n}\n\n.btn {\n  font-size: 14px;\n}\n\n*.btn:focus {\n  box-shadow: $btn-focus-box-shadow !important;\n}\n\np {\n  font-size: $paragraph-font-size;\n  line-height: $paragraph-line-height;\n  letter-spacing: $paragraph-letter-spacing;\n}\n\ncode {\n  color: $code-tag-color !important;\n  background-color: $code-tag-bg-color;\n  padding: $code-tag-padding;\n  margin: $code-tag-margin;\n  border-radius: $code-tag-border-radious;\n}\n\n.media {\n  display: flex;\n  align-items: flex-start;\n\n  .media-body {\n    flex: 1;\n  }\n}\n\nblockquote {\n  border-left: $blockquote-border;\n  padding: $blockquote-padding;\n}\n.figure {\n  &.text-center {\n    blockquote {\n      border: none !important;\n    }\n  }\n  &.text-end {\n    blockquote {\n      border-left: none !important;\n      border-right: $blockquote-border;\n    }\n  }\n}\n\n.row {\n  > div {\n    position: relative;\n  }\n}\n\n:focus {\n  outline-color: $all-focus-outline-color;\n}\n\n.disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\nsvg {\n  vertical-align: baseline;\n}\n\ninput {\n  &:focus {\n    outline-color: $transparent-color;\n  }\n}\n\nlabel {\n  margin-bottom: 0.5rem;\n}\n\n.media-widgets {\n  .media-body {\n    margin-bottom: 30px;\n  }\n}\n\n//Custom css End\n\n//Typography css start\n.typography {\n  h1,\n  .h1,\n  h2,\n  .h2,\n  h3,\n  .h3,\n  h4,\n  .h4,\n  h5,\n  .h5,\n  h6,\n  .h6 {\n    margin: 20px 0;\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  small {\n    padding-left: $small-tag-padding;\n    color: $small-tag-color;\n  }\n}\n\npre {\n  background-color: $pre-tag-bg-color;\n  padding: $pre-tag-padding;\n}\n\n//Typography css end\n.owl-theme {\n  .owl-dots {\n    .owl-dot {\n      span {\n        background: lighten($primary-color, 20%);\n      }\n\n      &.active,\n      &:hover {\n        span {\n          background: var(--theme-default);\n        }\n      }\n    }\n  }\n\n  .owl-nav {\n    &.disabled {\n      & + .owl-dots {\n        margin-bottom: -10px;\n        margin-top: 25px;\n      }\n    }\n  }\n}\n\n.click2edit {\n  & ~ .note-editor {\n    &.note-frame {\n      margin-bottom: 30px;\n    }\n  }\n}\n\n.note-editor {\n  &.note-frame {\n    border-color: $light-color;\n  }\n  &.fullscreen {\n    .note-toolbar-wrapper {\n      height: 0 !important;\n    }\n  }\n}\n\n.note-editor {\n  &.note-frame {\n    border-color: $light-color;\n  }\n}\n\n// modal page\n.modal {\n  .modal-body {\n    .card {\n      box-shadow: none !important;\n    }\n  }\n}\n\n.modal-dialog {\n  .modal-content {\n    .modal-body {\n      p {\n        a {\n          margin-right: 0;\n        }\n      }\n    }\n  }\n}\n\n// index page notify\n.notify-alert {\n  .close {\n    color: $white;\n    [dir=\"rtl\"] & {\n      right: unset !important;\n      left: 10px !important;\n    }\n  }\n  &.alert-light {\n    .close {\n      color: $theme-body-font-color;\n    }\n  }\n}\n.alert-theme {\n  button {\n    top: 25px !important;\n    right: 20px !important;\n    color: var(--theme-default);\n    [dir=\"rtl\"] & {\n      right: unset !important;\n      left: 20px !important;\n    }\n  }\n  span {\n    + span {\n      + span {\n        // border: 2px solid var(--theme-default);\n        background-color: $white;\n        color: var(--theme-default);\n        border-radius: 4px;\n        box-shadow: 0 2px 14px -3px rgba($black, 0.2);\n      }\n    }\n  }\n\n  .close {\n    color: var(--theme-default);\n  }\n\n  i {\n    padding: 20px;\n    padding-right: 0 !important;\n    margin-right: 20px !important;\n  }\n\n  .progress {\n    margin-top: -2px !important;\n    height: 2px;\n    width: 100%;\n    .progress-bar {\n      background-color: var(--theme-default);\n    }\n  }\n}\n\n.alert-copy {\n  border: 1px solid var(--theme-default);\n  line-height: 1;\n  display: inline-block;\n  width: 300px;\n  color: $white;\n  background-color: var(--theme-default);\n\n  .close {\n    box-shadow: none;\n    color: $white;\n    line-height: 1.4;\n    font-weight: 100;\n    top: -15px;\n    [dir=\"rtl\"] & {\n      right: unset !important;\n      left: 10px !important;\n    }\n\n    &:focus {\n      outline: none;\n    }\n  }\n}\n\n.ace-editor {\n  height: 400px;\n  width: 100%;\n}\n\n.editor-toolbar {\n  width: 100% !important;\n  &.fullscreen {\n    z-index: 100;\n  }\n}\n\n.CodeMirror {\n  top: 0 !important;\n}\n.CodeMirror-fullscreen {\n  top: 50px !important;\n}\n\n// rangeslider\n.irs-from,\n.irs-to,\n.irs-single {\n  background: var(--theme-default);\n\n  &:after {\n    border-top-color: var(--theme-default);\n  }\n}\n\n.irs-line-mid,\n.irs-line-left,\n.irs-line-right,\n.irs-bar,\n.irs-bar-edge {\n  background-color: var(--theme-default);\n}\n\n// sweetalert css\n.swal-button {\n  background-color: var(--theme-default);\n\n  &:active {\n    background-color: darken($primary-color, 5%);\n  }\n}\n\n.swal-button--cancel {\n  background-color: #efefee !important;\n}\n\n.clipboaard-container {\n  h6 {\n    line-height: 1.6;\n    font-size: $paragraph-font-size;\n  }\n}\n\nfieldset {\n  .bootstrap-touchspin-postfix,\n  .bootstrap-touchspin-prefix {\n    border-radius: 0;\n    padding: 0.4rem 0.75rem;\n  }\n\n  .input-group-lg {\n    .touchspin {\n      height: 50px;\n    }\n  }\n}\n\n.f1 .f1-steps .f1-step .f1-step-icon {\n  padding: 12px;\n}\n\n.form-inline .form-group {\n  display: flex;\n}\n\n.input-group-text {\n  i {\n    line-height: 1.5;\n  }\n}\n\n// animated modal css\n.animated-modal {\n  .form-select {\n    display: inline-block;\n    width: auto;\n    vertical-align: middle;\n  }\n}\n\n/**=====================\n    Typography css Ends\n==========================**/\n","/**=====================\n    24. According CSS start\n==========================**/\n.default-according{\n    .avatar-showcase {\n        margin-bottom: 0;\n    }\n    .card{\n        margin-bottom: 0;\n        box-shadow: none;\n        &+.card{\n            margin-top: $according-card-top-margin;\n        }\n        .btn-link{\n            font-weight: $according-btn-weight;\n            color: $theme-body-font-color;\n            text-decoration: none;\n        }\n        .btn-link{\n            &:focus,&:hover{\n                text-decoration: none;\n            }\n        }\n        .card-header{\n            padding: $according-card-header-padding;\n            border: $card-border-color;\n            i{\n                position: absolute;\n                left: 18px;\n                font-size: 20px;\n                top: 20px;\n            }\n            h5{\n                margin-top: 2px;\n            }\n        }\n        .card-body {\n            border: $card-border-color;\n            border-top: none;\n        }\n    }\n}\n.default-according.style-1{\n    button{\n        width: 100%;\n        text-align: left;\n        &:before{\n            right: 20px;\n            position: absolute;\n            -webkit-transition: 0.4s;\n            transition: 0.4s;\n            font-size: 20px;\n            top: 50%;\n            -webkit-transform: translateY(-50%);\n            transform: translateY(-50%);\n            @media (max-width: 575px) {\n                right: 15px;\n            }\n        }\n        &[aria-expanded=\"true\"]{\n            &:before{\n                content: $according-open-icon;\n                font-family: $according-card-header-icon;\n            }\n        }\n        &[aria-expanded=\"false\"]{\n            &:before{\n                content: $according-close-icon;\n                font-family: $according-card-header-icon;\n            }\n        }\n    }\n}\n/**=====================\n     24. According CSS Ends\n==========================**/","/**=====================\n     15. Alert CSS start\n==========================**/\n.notify-alert {\n  .close {\n    background: unset;\n    border: none;\n    font-size: 25px;\n  }\n}\n.alert{\n  border-radius: $alert-border-radious;\n  padding: 15px;\n  svg{\n    vertical-align: middle;\n  }\n  .progress{\n    margin-top: $alert-padding;\n  }\n  [data-notify='icon'] {\n    margin-right: 10px;\n    line-height: 20px;\n    position: absolute;\n  }\n\n  [data-notify='message'] {\n    display: inline-block;\n    width: 100%;\n  }\n  i{\n    margin-right: 5px;\n    font-size: $alert-msg-icon-size;\n  }\n  p{\n    margin-bottom: 0;\n  }\n  .close{\n    opacity: 1;\n    span{\n      font-size: 24px;\n      font-weight: 400;\n      display: inline-block;\n      border-radius: 3px;\n      text-shadow: none;\n      padding: 0 5px;\n      padding-right: 0;\n    }\n  }\n}\n.alert-dismissible {\n  padding-right: 2.5rem;\n  [dir=\"rtl\"] & {\n    padding-right: 15px;\n    padding-left: 2.5rem;\n  }\n  .close {\n    padding: 10px 1.25rem;\n    top:4px;\n    padding-right: 13px;\n    opacity: 0.5;\n    transition: all 0.3s ease;\n    &:hover{\n      transition: all 0.3s ease;\n      opacity: 1;\n      color: inherit;\n    }\n  }\n}\n.card-body{\n  button{\n    &:focus{\n      outline: none;\n    }\n  }\n  .alert{\n    &:last-child{\n      margin-bottom: 0;\n    }\n    svg{\n      width: 14px;\n      height: 14px;\n      margin-right: 4px;\n      position: absolute;\n      top:18px;\n      &~p{\n        padding-left: 20px;\n      }\n    }\n  }\n}\nstrong{\n  display: inline-block;\n  &~p{\n    display: inline-block;\n  }\n}\n\n$alert-name:primary,\nsecondary,\nsuccess,\ndanger,\nwarning,\ninfo,\nlight,\ndark;\n\n$alert-color : $primary-color,\n$secondary-color,\n$success-color,\n$danger-color,\n$warning-color,\n$info-color,\n$light-color,\n$dark-color;\n\n@each $var in $alert-name {\n  $i: index($alert-name, $var);\n  .alert-#{$var}{\n    background-color: rgba(nth($alert-color, $i), 0.8);\n    border-color: rgba(nth($alert-color, $i), 0.9);\n    color: $white;\n    .progress {\n      height: 5px;\n      background-color: darken(nth($alert-color, $i), 1%);\n      border-radius: 0;\n    }\n    .progress-bar{\n      background-color: lighten(nth($alert-color, $i), 50%);\n    }\n     .btn-close {\n       filter: brightness(1) invert(1);\n     }\n    .alert-link{\n      color: nth($alert-color, $i);\n      @if($var == \"light\"){\n        color: $dark-color;\n      }\n    }\n    @if($var == \"light\"){\n      color: $dark-color;\n      background-color: $light-color;\n      .btn-close {\n        filter: unset;\n      }\n    }\n    hr{\n      border-top-color: nth($alert-color, $i);\n    }\n  }\n  .alert-#{$var}.dark {\n    .alert-link{\n      color: $white;\n      @if($var == \"light\"){\n        color: $dark-color;\n      }\n    }\n    background-color: nth($alert-color, $i);\n    border-color: nth($alert-color, $i);\n    color: $auth-bg-color;\n\n    @if($var == \"light\"){\n      color: $dark-color;\n    }\n  }\n  .alert-#{$var}.outline,.alert-#{$var}.outline-2x {\n    background-color: $transparent-color;\n    border-color: nth($alert-color, $i);\n    color: nth($alert-color, $i);\n    .btn-close {\n      filter: unset;\n    }\n    @if($var == \"light\"){\n      color: $dark-color;\n    }\n  }\n  .alert-#{$var}.inverse{\n    &:before{\n      top: 16px;\n      content: \"\";\n      position: absolute;\n      left: 54px;\n      width: 0;\n      height: 0;\n      border-left: 7px solid nth($alert-color, $i);\n      border-top: 7px solid transparent;\n      border-bottom: 7px solid transparent;\n      @media (max-width: 576px) {\n        left: 45px;\n      }\n    }\n    background-color: transparent;\n    padding: 13px 20px 13px 65px;\n    border-color: nth($alert-color, $i);\n    color: $theme-body-font-color;\n    i{\n      padding: 17px 20px;\n      display: inline-block;\n      background-color: nth($alert-color, $i);\n      color: $white;\n      border-radius: 3px 0 0 3px;\n      position: absolute;\n      left: 0;\n      top: 0;\n      height:100%;\n      @media (max-width: 576px) {\n        padding: 17px 14px;\n      }\n    }\n    .btn-close {\n      filter: unset;\n      top: -3px;\n    }\n  }\n}\n.dismiss-text {\n  .alert {\n    .btn-close {\n      background: unset;\n      opacity: 1;\n      top: -6px;\n      right: 40px;\n\n      span {\n        display: inline-block;\n        border-radius: 3px;\n        text-shadow: none;\n        padding: 0 5px;\n      }\n    }\n  }\n}\n.outline-2x{\n  border-width: 2px;\n  padding: 11px 1.25rem;\n}\n\n/**=====================\n     15. Alert CSS end\n==========================**/\n","/**=====================\n    80. avatars CSS start\n==========================**/\n.avatars{\n    .avatar{\n        display: inline-block;\n        margin-right: 10px;\n        position: relative;\n        width: auto;\n        &:last-child{\n            margin-right: 0;\n        }\n        .b-r-30 {\n            border-radius: 30px;\n        }\n        .b-r-35 {\n            border-radius: 35px;\n        }\n        .b-r-25 {\n            border-radius: 25px;\n        }\n        .b-r-15 {\n            border-radius: 15px;\n        }\n        &.ratio{\n            img{\n                width: auto;\n            }\n        }        \n        .status{\n            position: absolute;\n            background-color: $light-text;\n            bottom: 0;\n            right: 4px;\n            border-radius: 100%;\n            border: 1px solid $white;\n        }\n        .status{\n            position: absolute;\n            height: 12%;\n            width: 12%;\n            background-color: $success-color;\n            border-radius: 100%;\n            bottom: 12%;\n            right: 4%;\n        }\n    }\n}\n.customers{\n    ul{\n        display: inline-block;\n        li{\n            img{\n                border: 2px solid $white;\n                transition: 0.5s;\n                &:hover{\n                    transform: translateY(-4px) scale(1.02);\n                    transition: 0.5s;\n                }\n            }\n            + li{\n                margin-left: -7%;\n            }\n        }\n    }\n    &.avatar-group{\n       margin-right: 30px;\n        &:last-child{\n            margin-right: 0;\n        }\n    }\n}\n.avatar-showcase{\n    margin-bottom: -10px;\n    .avatars{\n        .avatar{\n            margin-bottom: 10px;\n        }\n    }\n    .avatar-group{\n        margin-bottom: 10px;\n    }\n    .ratio {\n        >* {\n            position: relative;\n            top: unset;\n            left: unset;\n        }\n    }\n    .add-friend {\n        .d-block {\n            margin: 8px 0;\n        }\n    }\n}\n/**=====================\n     80. avatars CSS Ends\n==========================**/\n","/**=====================\n    49. Badge CSS start\n==========================**/\n.badge {\n  padding: $badge-padding;\n  font-family: $font-roboto, $font-serif;\n  font-weight: 500;\n\n  & + .badge {\n    margin-left: 5px;\n  }\n\n  svg {\n    width: $badge-svg-size;\n    height: $badge-svg-size;\n    padding-top: 3px;\n  }\n}\n\n// flat badge loop css\n@each $pill-badge-name, $pill-badge-color in (primary, var(--theme-default)), (secondary, $secondary-color), (success, $success-color), (danger, $danger-color), (info, $info-color), (light, $light-color), (dark, $dark-color), (warning, $warning-color) {\n  .pill-badge-#{$pill-badge-name} {\n    background-color: $pill-badge-color;\n    box-shadow: -0.5px 4.33px 16px 0px rgba($pill-badge-color, 0.25);\n    color: $white;\n    border-radius: 0;\n  }\n}\n\n.pill-badge-primary {\n  background-color: var(--theme-default);\n}\n\n.pill-badge-secondary {\n  background-color: var(--theme-secondary);\n}\n\n// round badge loop css\n@each $round-badge-name, $round-badge-color in (primary, var(--theme-default)), (secondary, $secondary-color), (success, $success-color), (danger, $danger-color), (info, $info-color), (light, $light-color), (dark, $dark-color), (warning, $warning-color) {\n  .round-badge-#{$round-badge-name} {\n    border-radius: 6px;\n    background-color: $round-badge-color;\n    box-shadow: -0.5px -6.67px 14px 0px rgba($round-badge-color, 0.18);\n    color: $white !important;\n  }\n}\n\n.round-badge-primary {\n  background-color: var(--theme-default);\n}\n\n.round-badge-secondary {\n  background-color: var(--theme-secondary);\n}\n\n/**=====================\n    49. Badge CSS Ends\n==========================**/\n","/**=====================\n    81. Bookmark CSS start\n==========================**/\n.bookmark {\n  ul {\n    li {\n      display: inline-block;\n      .search-form {\n        position: absolute;\n        bottom: 53px;\n        z-index: 1;\n        .form-control-search {\n          top: 65px;\n          position: absolute;\n          transition: all linear 0.3s;\n          right: -20px;\n          transform: translateY(-35px) scaleY(0);\n          opacity: 0;\n          visibility: hidden;\n          input {\n            width: 240px;\n            background-color: $white;\n            box-shadow: 0 5px 21px rgba(0, 0, 0, 0.10);\n          }\n          &.open {\n            transform: translateY(0px) scaleY(1);\n            opacity: 1;\n            visibility: visible;\n            transition: all linear 0.3s;\n            z-index: 100;\n          }\n          &:after {\n            top: 12px;\n            left: 20px;\n            z-index: 1;\n          }\n          &:before {\n            left: 50px;\n            top: 9px;\n            z-index: 2;\n          }\n        }\n      }\n      a{\n        position: relative;\n        color: $theme-body-font-color;\n        svg {\n          vertical-align: middle;\n          height: 20px;\n          width: 20px;\n        }\n      }\n      + li {\n        margin-left: 10px;\n      }\n      &:last-child {\n        padding-right: 0;\n        a {\n          border-radius: 5px;\n          svg {\n            color: #ff9f40;\n          }\n        }\n      }\n    }\n  }\n}\n.offcanvas-bookmark {\n  &.page-wrapper.horizontal-wrapper {\n    .page-body-wrapper {\n      .page-body {\n        .bookmark {\n          ul {\n            li {\n              a {\n                z-index: 99999;\n                color: rgba(255, 255, 255, 0.5);\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  &:before {\n    position: fixed;\n    content: '';\n    background-color: rgba(0,0,0,0.5);\n    height: 100%;\n    width: 100%;\n    z-index: 1;\n    right: 0;\n    left: 0;\n  }\n}\nbody.modal-open {\n  .select2-container--open {\n    width: unset !important;\n    display: block;\n    .select2-dropdown {\n      z-index: 1076;\n    }\n  }\n}\n/**=====================\n    81. Bookmark CSS Ends\n==========================**/\n","/**=====================\n    57. breadcrumb CSS Start\n==========================**/\n.breadcrumb-colored{\n\tpadding: 12px 16px;\n\tborder-radius: 4px;\n\tli{\n\t\ta{\n\t\t\tcolor: $breadcrumb-ancher-color;\n\t\t}\n\t\t&.active{\n\t\t\tcolor: $breadcrumb-ancher-color;\n\t\t\topacity:0.7;\n\t\t}\n\t}\n\t.breadcrumb-item{\n\t\t&:before{\n\t\t\tcolor: $breadcrumb-ancher-color;\n\t\t}\n\t}\n\t.breadcrumb-item.txt-dark{\n\t\t&:before{\n\t\t\tcolor: $breadcrumb-ancher-dark-color;\n\t\t}\n\t}\n}\n.breadcrumb-icon {\n\t--bs-breadcrumb-divider: '>';\n\n\tli {\n\t\tdisplay: inline-block;\n\t}\n}\n\n.breadcrumb-no-divider {\n\t--bs-breadcrumb-divider: '';\n}\n.breadcrumb-item{\n\t&.active{\n\t\ttext-transform: capitalize;\n\t}\n}\n/**=====================\n    57. breadcrumb CSS ends\n==========================**/\n","/**=====================\n     35. Form builder css start\n==========================**/\n.form-builder{\n  .help-block {\n    margin-bottom: 0;\n    color: $gray-60;\n    text-transform: capitalize;\n  }\n  .btn-light {\n    color: $gray-60;\n  }\n  .copy-btn{\n    padding: 8px;\n  }\n  .nav-primary {\n    .nav-link.active, .nav-primary .show > .nav-link, .nav-pills.nav-primary .nav-link.active, .nav-pills.nav-primary .show > .nav-link{\n      border-radius: 5px;\n    }\n    .nav-link, .nav-pills.nav-primary .nav-link {\n      color: $black;\n      font-weight: 500;\n    }\n  }\n  .theme-form{\n    margin-top: 30px;  \n  }\n}\n/**=====================\n    35. Form builder css Ends\n==========================**/\n","/**=====================\n    06. Button CSS start\n==========================**/\n.btn-link {\n  color: var(--theme-default);\n}\n\n.purchase-btn {\n  background: linear-gradient(90deg, var(--theme-default) -18.33%, #563ee0 62.78%);\n  padding: 12px 20px;\n  min-width: 200px;\n  border: none;\n  transition: 0.5s;\n  &:hover {\n    background: linear-gradient(90deg, #563ee0 -18.33%, var(--theme-default) 62.78%);\n    transition: 0.5s;\n  }\n  @media (max-width: 991px) {\n    min-width: 160px;\n  }\n  @media (max-width: 767px) {\n    min-width: 140px;\n    padding: 10px 17px;\n    font-size: 16px;\n  }\n}\n.btn-light {\n  &:not([disabled]):not(.disabled).active.active {\n    color: $theme-body-font-color;\n    background-color: darken($light-color, 2%) !important;\n  }\n}\n\n@mixin btn-gradien($deg, $leftcolor, $leftcolor-per, $rightcolor, $rightcolor-per, $font-color) {\n  background-image: linear-gradient(to right, $leftcolor 0%, $rightcolor 51%, $leftcolor 100%);\n  border: none;\n  color: $font-color;\n  background-size: auto 200%;\n  transition: all 0.3s ease;\n}\n.btn-primary-gradien {\n  @include btn-gradien(60, lighten($primary-color, 8%), 0%, darken($primary-color, 8%), 100%, $white);\n  color: $white;\n  &:focus,\n  &:active,\n  &.active {\n    transition: 1.5s;\n    background-position: right center;\n    background-image: linear-gradient(to right, lighten($primary-color, 8%), 0%, darken($primary-color, 8%), 100%, $white) !important;\n  }\n}\n.btn-secondary-gradien {\n  @include btn-gradien(60, lighten($secondary-color, 8%), 0%, darken($secondary-color, 8%), 100%, $white);\n  &:hover,\n  &:focus,\n  &:active,\n  &.active,\n  &.hover {\n    transition: 1.5s;\n    background-position: right center;\n    background-image: linear-gradient(to right, lighten($secondary-color, 8%), 0%, darken($secondary-color, 8%), 100%, $white) !important;\n  }\n}\n.btn-success-gradien {\n  @include btn-gradien(60, lighten($success-color, 8%), 0%, darken($success-color, 8%), 100%, $white);\n  &:hover,\n  &:focus,\n  &:active,\n  &.active,\n  &.hover {\n    transition: 1.5s;\n    background-position: right center;\n    background-image: linear-gradient(to right, lighten($success-color, 8%), 0%, darken($success-color, 8%), 100%, $white) !important;\n  }\n}\n.btn-danger-gradien {\n  @include btn-gradien(60, lighten($danger-color, 8%), 0%, darken($danger-color, 8%), 100%, $white);\n  &:hover,\n  &:focus,\n  &:active,\n  &.active,\n  &.hover {\n    transition: 1.5s;\n    background-position: right center;\n    background-image: linear-gradient(to right, lighten($danger-color, 8%), 0%, darken($danger-color, 8%), 100%, $white) !important;\n  }\n}\n.btn-warning-gradien {\n  @include btn-gradien(60, lighten($warning-color, 8%), 0%, darken($warning-color, 8%), 100%, $white);\n  &:hover,\n  &:focus,\n  &:active,\n  &.active,\n  &.hover {\n    transition: 1.5s;\n    background-position: right center;\n    background-image: linear-gradient(to right, lighten($warning-color, 8%), 0%, darken($warning-color, 8%), 100%, $white) !important;\n  }\n}\n.btn-info-gradien {\n  @include btn-gradien(60, lighten($info-color, 8%), 0%, darken($info-color, 8%), 100%, $white);\n  &:hover,\n  &:focus,\n  &:active,\n  &.active,\n  &.hover {\n    transition: 1.5s;\n    background-position: right center;\n    background-image: linear-gradient(to right, lighten($info-color, 8%), 0%, darken($info-color, 8%), 100%, $white) !important;\n  }\n}\n.btn-light-gradien {\n  @include btn-gradien(60, lighten($light-color, 8%), 0%, darken($light-color, 8%), 100%, $white);\n  &:hover,\n  &:focus,\n  &:active,\n  &.active,\n  &.hover {\n    transition: 1.5s;\n    background-position: right center;\n    background-image: linear-gradient(to right, lighten($light-color, 8%), 0%, darken($light-color, 8%), 100%, $white) !important;\n  }\n}\n.btn-dark-gradien {\n  @include btn-gradien(60, lighten($dark-color, 8%), 0%, darken($dark-color, 8%), 100%, $white);\n  &:hover,\n  &:focus,\n  &:active,\n  &.active,\n  &.hover {\n    transition: 1.5s;\n    background-position: right center;\n    background-image: linear-gradient(to right, lighten($dark-color, 8%), 0%, darken($dark-color, 8%), 100%, $white) !important;\n  }\n}\n\n@mixin btn-squre($border-radius) {\n  border-radius: $border-radius + px;\n}\n@mixin btn-pill($border-radius) {\n  border-radius: $border-radius + px;\n}\n@mixin btn-pill-first($radius) {\n  border-radius: $radius + px 0 0 $radius + px;\n}\n@mixin btn-pill-last($radius) {\n  border-radius: 0 $radius + px $radius + px 0;\n}\n\n.btn {\n  padding: $btn-padding;\n}\n.btn-lg {\n  font-size: $btn-lg-font-size;\n}\n.btn-sm {\n  font-size: $btn-sm-font-size;\n}\n.btn-xs {\n  padding: $btn-xs-padding;\n  font-size: $btn-xs-font-size;\n}\n.large-btn {\n  .btn {\n    margin-right: 5px;\n    margin-bottom: 15px;\n  }\n  margin-bottom: -20px;\n}\n.btn-outline-white {\n  border: 1px solid $white;\n  color: $white;\n  &:hover,\n  &:focus {\n    background: $white;\n    color: #212529;\n  }\n}\n// outline buttons//\n@each $btn-name, $btn-color in (primary, $primary-color), (secondary, $secondary-color), (success, $success-color), (danger, $danger-color), (info, $info-color), (light, $light-color), (dark, $dark-color), (warning, $warning-color) {\n  .btn-air-#{$btn-name} {\n    box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;\n    &:hover,\n    &:active,\n    &:not([disabled]):not(.disabled):active {\n      background-color: darken($btn-color, 10%);\n      border-color: darken($btn-color, 10%);\n    }\n  }\n  .input-air-#{$btn-name} {\n    box-shadow: 0 3px 5px 1px rgba($btn-color, 0.1) !important;\n    &:focus {\n      border-color: $btn-color;\n    }\n  }\n}\n\n.btn-gradient {\n  color: $white !important;\n  font-weight: 500;\n  padding: 10px 30px;\n  border-radius: 5px;\n  background: $gradient-primary;\n  letter-spacing: 0.06rem;\n  &:hover {\n    background-size: 100% !important;\n  }\n}\n\n.btn-warning {\n  color: $white;\n  &:hover,\n  &.disabled {\n    color: $white;\n  }\n}\n\n[class*=\"-gradien\"] {\n  &:hover {\n    background-size: 50% 100%;\n    transition: all 0.3s ease;\n    color: $white;\n  }\n}\n\n.btn-square {\n  @include btn-squre(0);\n}\n.btn-pill {\n  @include btn-squre(60);\n}\n.btn-group-pill {\n  .btn {\n    &:first-child {\n      @include btn-pill-first(60);\n    }\n    &:last-child {\n      @include btn-pill-last(60);\n    }\n  }\n}\n.btn-group-square {\n  .btn {\n    &:first-child {\n      @include btn-pill-first(0);\n    }\n    &:last-child {\n      @include btn-pill-last(0);\n    }\n  }\n}\n.btn-showcase {\n  .btn {\n    margin-bottom: 10px;\n    margin-right: 10px;\n  }\n  margin-bottom: -10px;\n}\n\n.btn-dropdown-showcase {\n  .dropdown {\n    margin-bottom: 10px;\n    margin-right: 18px;\n  }\n  .btn-group {\n    margin-bottom: 10px;\n    margin-right: 18px;\n  }\n  margin-bottom: -10px;\n}\n.btn-group {\n  .radio {\n    label {\n      &::before {\n        top: 2px;\n      }\n      &::after {\n        top: 7px;\n      }\n    }\n  }\n  .checkbox {\n    label {\n      margin-top: 3px;\n    }\n  }\n}\n.btn-group-showcase {\n  > div {\n    margin-bottom: -20px;\n    label {\n      margin-bottom: 0;\n    }\n  }\n  .btn-group {\n    margin-right: 20px;\n    margin-bottom: 20px;\n  }\n  .checkbox {\n    input[type=\"checkbox\"] {\n      display: none;\n    }\n  }\n}\n.tooltiptext {\n  visibility: visible;\n  width: 120px;\n  background-color: #555;\n  color: $white;\n  text-align: center;\n  border-radius: 6px;\n  padding: 5px 0;\n  position: absolute;\n  z-index: 1;\n  bottom: 125%;\n  left: 50%;\n  margin-left: -60px;\n  opacity: 1;\n  transition: opacity 0.3s;\n  &::after {\n    content: \"\";\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    margin-left: -5px;\n    border-width: 5px;\n    border-style: solid;\n    border-color: #555 transparent transparent transparent;\n  }\n}\n/**=====================\n     06. Button CSS end\n==========================**/\n","/**=====================\n    03.  Card CSS Start\n==========================**/\n//Card css\n.card {\n  margin-bottom: $card-margin-bottom;\n  border: none;\n  transition: all 0.3s ease;\n  letter-spacing: 0.5px;\n  border-radius: $card-border-radious;\n  box-shadow: $card-box-shadow;\n\n  &:hover {\n    box-shadow: $card-hover-box-shadow;\n    transition: all 0.3s ease;\n  }\n\n  .card-header {\n    background-color: $card-header-bg-color;\n    padding: $card-padding;\n    border-bottom: $card-border-color;\n    border-top-left-radius: $card-border-radious;\n    border-top-right-radius: $card-border-radious;\n    position: relative;\n\n    &.card-no-border {\n      border-bottom: none !important;\n    }\n\n    h5 {\n      &:not(.mb-0),\n      &:not(.m-0) {\n        margin-bottom: 0;\n        text-transform: $card-header-font-transform;\n      }\n    }\n\n    > span {\n      font-size: $card-header-span-size;\n      color: $card-header-span-color;\n      margin-top: 5px;\n      display: block;\n      letter-spacing: 1px;\n    }\n\n    .card-header-right {\n      border-radius: 0 0 0 7px;\n      right: 35px;\n      top: 24px;\n      display: inline-block;\n      float: right;\n      padding: 8px 0;\n      position: absolute;\n      background-color: $white;\n      z-index: 1;\n\n      .card-option {\n        text-align: right;\n        width: 35px;\n        height: 20px;\n        overflow: hidden;\n        transition: 0.3s ease-in-out;\n\n        li {\n          display: inline-block;\n\n          &:first-child {\n            i {\n              transition: 1s;\n              font-size: 16px;\n              color: var(--theme-default);\n\n              &.icofont {\n                color: unset;\n              }\n            }\n          }\n        }\n      }\n\n      i {\n        margin: 0 5px;\n        cursor: pointer;\n        color: $dark-color;\n        line-height: 20px;\n\n        &.icofont-refresh {\n          font-size: 13px;\n        }\n      }\n    }\n  }\n\n  .card-body {\n    padding: $card-padding;\n    background-color: $card-body-bg-color;\n\n    p {\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n  }\n\n  .sub-title {\n    border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n    padding-bottom: 5px;\n    margin-bottom: 8px;\n    font-size: 18px;\n  }\n\n  .card-footer {\n    background-color: $card-footer-bg-color;\n    border-top: $card-border-color;\n    padding: $card-padding;\n    border-bottom-left-radius: $card-border-radious;\n    border-bottom-right-radius: $card-border-radious;\n  }\n\n  &.card-load {\n    .card-loader {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      display: flex;\n      background-color: rgba(255, 255, 255, 0.7);\n      z-index: 8;\n      align-items: center;\n      justify-content: center;\n\n      i {\n        margin: 0 auto;\n        color: var(--theme-default);\n        font-size: 20px;\n      }\n    }\n  }\n\n  &.full-card {\n    position: fixed;\n    top: 0;\n    z-index: 99999;\n    box-shadow: none;\n    right: 0;\n    border-radius: 0;\n    border: 1px solid $light-semi-gray;\n    width: calc(100vw - 12px);\n    height: calc(100vh);\n\n    .card-body {\n      overflow: auto;\n    }\n  }\n}\n.page-body-wrapper {\n  .card {\n    .sub-title {\n      font-family: $font-rubik, $font-serif;\n      font-weight: normal;\n      color: $theme-body-sub-title-color;\n    }\n  }\n}\n\n.card-absolute {\n  margin-top: 20px;\n\n  .card-header {\n    position: absolute;\n    top: -20px;\n    left: 15px;\n    border-radius: 0.25rem;\n    padding: 10px 15px;\n\n    h5 {\n      font-size: 17px;\n    }\n  }\n\n  .card-body {\n    margin-top: 10px;\n  }\n}\n\n.card-header {\n  .border-tab {\n    margin-bottom: -13px;\n  }\n}\n\n.custom-card {\n  overflow: hidden;\n  padding: 30px;\n  .card-header {\n    padding: 0;\n\n    img {\n      border-radius: 50%;\n      margin-top: -100px;\n      transform: scale(1.5);\n    }\n  }\n\n  .card-profile {\n    text-align: center;\n\n    img {\n      height: 110px;\n      padding: 7px;\n      background-color: $white;\n      z-index: 1;\n      position: relative;\n    }\n  }\n\n  .card-social {\n    text-align: center;\n\n    li {\n      display: inline-block;\n      padding: 15px 0;\n      &:last-child {\n        a {\n          margin-right: 0;\n        }\n      }\n      a {\n        padding: 0;\n        margin-right: 15px;\n        color: rgb(188, 198, 222);\n        font-size: 16px;\n        transition: all 0.3s ease;\n\n        &:hover {\n          color: var(--theme-default);\n          transition: all 0.3s ease;\n        }\n      }\n    }\n  }\n\n  .profile-details {\n    h6 {\n      margin-bottom: 30px;\n      margin-top: 10px;\n      color: $theme-body-sub-title-color;\n      font-size: 14px;\n    }\n  }\n\n  .card-footer {\n    padding: 0;\n\n    > div {\n      + div {\n        border-left: 1px solid $light-semi-gray;\n      }\n\n      padding: 15px;\n      text-align: center;\n\n      h3 {\n        margin-bottom: 0;\n        font-size: 24px;\n      }\n\n      h6 {\n        font-size: 14px;\n        color: $theme-body-sub-title-color;\n      }\n      h5 {\n        font-size: 16px;\n        margin-bottom: 0;\n      }\n      i {\n        font-size: 24px;\n        display: inline-block;\n        margin-bottom: 15px;\n      }\n\n      .m-b-card {\n        margin-bottom: 10px;\n      }\n    }\n  }\n}\n\n.social {\n  &-profile {\n    text-align: center;\n    background-image: url(../../images/dashboard-5/profile-bg.png);\n    background-repeat: no-repeat;\n    background-size: cover;\n    .card-body {\n      padding-left: 20px;\n      padding-right: 20px;\n      @media (max-width: 1399px) {\n        padding: 23px 15px;\n      }\n    }\n  }\n  &-details {\n    margin-top: 15px;\n    h5 {\n      a {\n        color: var(--body-font-color);\n      }\n    }\n    .social-follow {\n      column-count: 3;\n      column-gap: 30px;\n      margin-top: 25px;\n      @media (max-width: 1399px) {\n        column-gap: 23px;\n      }\n      li {\n        position: relative;\n        + li {\n          &::before {\n            position: absolute;\n            content: \"\";\n            width: 1px;\n            height: 14px;\n            background-color: var(--recent-dashed-border);\n            left: -15px;\n            top: 50%;\n            transform: translateY(-50%);\n            [dir=\"rtl\"] & {\n              left: unset;\n              right: -15px;\n            }\n          }\n        }\n      }\n    }\n    .card-social {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 10px;\n      margin-top: 15px;\n    }\n  }\n  &-img-wrap {\n    background: linear-gradient(253deg, var(--theme-default) 11.51%, rgba(115, 102, 255, 0) 82.07%);\n    display: inline-block;\n    border-radius: 100%;\n    padding: 2px;\n    position: relative;\n    .edit-icon {\n      position: absolute;\n      right: 0;\n      bottom: 0;\n      svg {\n        width: 20px;\n        height: 20px;\n        border-radius: 100%;\n        border: 2px solid var(--white);\n        background: var(--white);\n      }\n    }\n  }\n  &-img {\n    padding: 5px;\n    background: var(--white);\n    border-radius: 100%;\n    img {\n      height: 68px;\n      border-radius: 100%;\n    }\n  }\n}\n\n/**=====================\n    03. Card CSS End\n==========================**/\n","/**=====================\n     07. Color CSS Start\n==========================**/\n.color-box {\n  margin-bottom: -10px;\n\n  button {\n    margin-bottom: 10px;\n\n    +button {\n      margin-left: 5px;\n    }\n  }\n}\n\n\n.light-font {\n  color: $theme-body-sub-title-color;\n}\n\n/**=====================\n     07. Color CSS Ends\n==========================**/","/**=====================\n    52. Datepicker CSS Start\n==========================**/\n.react-datepicker-popper {\n  z-index: 2 !important;\n}\n.react-datepicker-wrapper {\n  display: block !important;\n}\n.date-picker {\n  .react-datepicker__navigation {\n    top: 8px;\n  }\n  .theme-form {\n    .input-group {\n      display: block !important;\n    }\n    .min-date {\n      .react-datepicker-wrapper {\n        display: inline-block !important;\n      }\n    }\n  }\n}\n\n.react-datepicker__day--keyboard-selected,\n.react-datepicker__month-text--keyboard-selected,\n.react-datepicker__quarter-text--keyboard-selected,\n.react-datepicker__year-text--keyboard-selected {\n  background-color: var(--theme-default);\n  &:hover {\n    background-color: var(--theme-default);\n  }\n}\n.react-datepicker {\n  border: none !important;\n  box-shadow: 0 4px 24px rgba($primary-color, 0.08);\n  .react-datepicker__navigation-icon--previous,\n  .react-datepicker__navigation-icon--next {\n    &::before {\n      border-color: $white;\n    }\n  }\n  .react-datepicker__time-container {\n    border-left: 1px solid #efefef;\n    .react-datepicker__time {\n      .react-datepicker__time-box {\n        ul {\n          &.react-datepicker__time-list {\n            li {\n              &.react-datepicker__time-list-item--selected {\n                background-color: var(--theme-default) !important;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  .react-datepicker__today-button {\n    background-color: $white !important;\n    border-top: 1px solid #efefef;\n  }\n  .react-datepicker__triangle {\n    display: none;\n  }\n  .react-datepicker__header {\n    background-color: $transparent-color !important;\n    border-bottom: 1px solid #efefef;\n  }\n  .react-datepicker__day-name {\n    font-weight: 600;\n  }\n  .react-datepicker__current-month {\n    margin-bottom: 10px;\n  }\n  .react-datepicker__current-month,\n  .react-datepicker-time__header,\n  .react-datepicker-year-header {\n    color: var(--theme-default) !important;\n  }\n  .react-datepicker__day-name,\n  .react-datepicker__day,\n  .react-datepicker__time-name {\n    width: 30px !important;\n    line-height: 30px !important;\n  }\n  .react-datepicker__navigation--next {\n    border-left-color: var(--theme-default) !important;\n  }\n  .react-datepicker__navigation--previous {\n    border-right-color: var(--theme-default) !important;\n  }\n  .react-datepicker__day--selected,\n  .react-datepicker__day--in-selecting-range,\n  .react-datepicker__day--in-range,\n  .react-datepicker__month-text--selected,\n  .react-datepicker__month-text--in-selecting-range,\n  .react-datepicker__month-text--in-range,\n  .react-datepicker__quarter-text--selected,\n  .react-datepicker__quarter-text--in-selecting-range,\n  .react-datepicker__quarter-text--in-range {\n    background-color: var(--theme-default) !important;\n    &:hover {\n      background-color: var(--theme-default) !important;\n    }\n  }\n  .react-datepicker__day--in-selecting-range,\n  .react-datepicker__month-text--in-selecting-range,\n  .react-datepicker__quarter-text--in-selecting-range {\n    background-color: rgba($primary-color, 0.15);\n  }\n  .react-datepicker__month--selecting-range {\n    .react-datepicker__day--in-range,\n    .react-datepicker__month-text--in-range {\n      color: $white !important;\n    }\n  }\n  .react-datepicker__quarter-text--in-range {\n    color: $white !important;\n  }\n  .react-datepicker__day--today,\n  .react-datepicker__day--selected {\n    background-color: var(--theme-default) !important;\n    color: $white !important;\n    border-radius: 0.3rem;\n  }\n}\n// timepicker\n\n.classic_theme_container {\n  height: 144px !important;\n}\n.react_times_button {\n  .wrapper {\n    width: 100%;\n  }\n}\n.time_picker_wrapper2 {\n  display: flex;\n  width: auto !important;\n  .time_picker_container {\n    width: 300px;\n  }\n  .time_picker_modal_container {\n    top: unset !important;\n    bottom: 82px !important;\n  }\n}\n.time_picker_wrapper,\n.time_picker_wrapper2 {\n  width: 300px;\n  .time_picker_container {\n    .time_picker_modal_header,\n    .time_picker_modal_footer,\n    .timezone_picker_modal_header {\n      background-color: var(--theme-default);\n    }\n    .picker_pointer {\n      background-color: var(--theme-default);\n      .pointer_drag {\n        background-color: var(--theme-default);\n      }\n    }\n    .picker_center {\n      background-color: var(--theme-default);\n    }\n    .classic_theme_container {\n      .classic_time {\n        &.light {\n          &.active,\n          &:hover {\n            background-color: var(--theme-default);\n          }\n        }\n      }\n    }\n  }\n  .gap {\n    padding: 10px;\n  }\n}\n.time_picker_modal_container {\n  width: unset !important;\n}\n// responsive\n@media (max-width: 1660px) {\n  .date-range {\n    display: flex;\n  }\n}\n@media (max-width: 1107px) {\n  .date-range {\n    display: unset;\n    .react-datepicker-wrapper {\n      &:last-child {\n        margin-top: 15px;\n      }\n    }\n  }\n}\n@media (max-width: 575px) {\n  .react-datepicker {\n    .react-datepicker__day-name,\n    .react-datepicker__day,\n    .react-datepicker__time-name {\n      width: 25px !important;\n      line-height: 25px !important;\n    }\n  }\n  .date-picker {\n    .theme-form {\n      .row {\n        .row {\n          .col-form-label {\n            padding-left: 0;\n          }\n        }\n      }\n    }\n  }\n}\n@media (max-width: 475px) {\n  .date-range {\n    .react-datepicker-wrapper {\n      &:last-child {\n        margin-top: 15px;\n      }\n    }\n  }\n}\n\n// calendar css\n.calendar-basic {\n  .md-sidebar-aside {\n    background-color: $white;\n  }\n  #external-events {\n    padding: 20px;\n    border: 1px solid $light-background;\n    background-color: var(--white);\n    width: 100%;\n    h4 {\n      margin-bottom: 14px;\n    }\n    p {\n      margin-top: 12px;\n    }\n    .fc-h-event {\n      padding: 12px;\n      background-color: $primary-color;\n      border: 1px solid $primary-color;\n      + .fc-h-event {\n        margin-top: 10px;\n      }\n      .fc-event-main {\n        font-size: 13px;\n      }\n    }\n  }\n  .calendar-default {\n    .fc-daygrid-dot-event {\n      .fc-event-title {\n        text-overflow: ellipsis;\n      }\n    }\n    .fc {\n      td[role=\"presentation\"] {\n        border: 0;\n      }\n      .fc-daygrid-day-number,\n      .fc-col-header-cell-cushion {\n        color: $theme-body-font-color;\n      }\n      .fc-button {\n        .fc-icon {\n          height: 23px;\n        }\n      }\n    }\n    .fc-h-event {\n      padding: 2px;\n      background-color: $primary-color;\n      border: 1px solid $primary-color;\n    }\n    .fc-toolbar-chunk {\n      .fc-button-group {\n        ~ .fc-today-button {\n          margin: 0 8px;\n        }\n      }\n    }\n  }\n}\n.fc-event-dragging {\n  padding: 10px;\n  background-color: var(--theme-default);\n}\n.fc {\n  .fc-toolbar {\n    flex-wrap: wrap;\n    gap: 10px;\n  }\n  .fc-button-primary {\n    &:focus {\n      box-shadow: 0 0 0 0.2rem rgba($primary-color, 0.5);\n    }\n  }\n}\n/**=====================\n   52. Datepicker CSS End\n==========================**/\n","/**=====================\n    37. Dropdown CSS Start\n==========================**/\n.dropdown-divider {\n  margin: 0;\n}\n.dropdown {\n  .dropdown-toggle {\n    background-color: rgba(115, 102, 255, 0.08) !important;\n    color: $primary-color;\n    border-radius: 10px;\n    padding: 5px 10px;\n    width: 100px;\n    text-align: left;\n    border: none !important;\n    &:after {\n      position: absolute;\n      top: 50%;\n      right: 10px;\n      -webkit-transform: translateY(-50%);\n      transform: translateY(-50%);\n      content: '\\f107';\n      border: none;\n      font-family: 'FontAwesome';\n      font-size: 18px;\n      margin: 0;\n    }\n    &.btn-primary {\n      color: $white;\n    }\n  }\n  .dropdown-menu {\n    font-family: $font-rubik, $font-serif;\n  }\n}\n.docs-toggles {\n  .dropdown {\n    .dropdown-toggle {\n      width: auto;\n    }\n  }\n}\n.nav-tabs {\n  .dropdown {\n    .dropdown-toggle {\n      width: 120px;\n      @media only screen and (max-width: 575.98px) {\n        width: 100%;\n        text-align: center;\n      }\n    }\n  }\n}\n.icon-dropdown {\n  .dropdown-toggle {\n    background: transparent !important;\n    color: $theme-body-sub-title-color;\n    padding: 0;\n    width: auto;\n    i {\n      font-size: 16px;\n    }\n    &::after {\n      display: none;\n    }\n  }\n  .dropdown-item {\n    line-height: 1.5;\n  }\n}\n.dropdown-basic {\n  margin-bottom: -10px;\n  .btn-group {\n    margin-right: 18px;\n    .btn-round {\n      border-radius: 50px;\n    }\n  }\n  .separated-btn {\n    margin-left: -6px;\n    .btn {\n      border-top-left-radius: 0;\n      border-bottom-left-radius: 0;\n      padding: 10px;\n    }\n  }\n  button {\n    max-height: 43px;\n  }\n  .dropdown {\n    position: relative;\n    display: inline-block;\n    margin-bottom: 10px;\n    .dropbtn {\n      color: white;\n      padding: 12px 35px;\n      border: none;\n      cursor: pointer;\n    }\n    .dropdown-content {\n      display: none;\n      position: absolute;\n      right: 0;\n      background-color: #f9f9f9;\n      min-width: 175px;\n      box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n      z-index: 1;\n      left: 0;\n      top: 45px;\n      a {\n        color: black;\n        padding: 12px 16px;\n        text-decoration: none;\n        display: block;\n      }\n      .dropdown-header {\n        padding: 12px 16px;\n      }\n    }\n  }\n\n  .dropdown-content a:hover {\n    background-color: #f1f1f1;\n  }\n  .dropdown:hover .dropdown-content {\n    display: block;\n  }\n}\n.dropup-basic {\n  .dropup {\n    position: relative;\n    display: inline-block;\n    .dropbtn {\n      color: white;\n      padding: 12px;\n      border: none;\n    }\n    .dropup-content {\n      display: none;\n      position: absolute;\n      background-color: #f9f9f9;\n      min-width: 170px;\n      bottom: 45px;\n      z-index: 999;\n      left: 0;\n      a {\n        color: black;\n        padding: 12px 16px;\n        text-decoration: none;\n        display: block;\n      }\n    }\n  }\n\n  .dropup .dropup-content a:hover {\n    background-color: #f1f1f1;\n  }\n  .dropup:hover .dropup-content {\n    display: block;\n    a {\n      &.active {\n        background-color: #f1f1f1;\n      }\n    }\n  }\n}\n\n/**=====================\n    37. Dropdown CSS Ends\n==========================**/\n","/**=====================\n    30. Data-table CSS Start\n==========================**/\ndiv {\n  &.dt-button-background {\n    display: none !important;\n  }\n  &.DTS {\n    div {\n      &.dataTables_scrollBody {\n        table {\n          z-index: 1;\n        }\n      }\n    }\n  }\n  .table-avtar {\n    height: 32px;\n    margin-right: 10px;\n    [dir=\"rtl\"] & {\n      margin-right: unset;\n      margin-left: 10px;\n    }\n  }\n  .action {\n    display: flex;\n    i {\n      font-size: 16px;\n    }\n    .pdf {\n      i {\n        font-size: 20px;\n        color: $danger-color;\n      }\n    }\n    .edit {\n      margin-right: 5px;\n      i {\n        color: $success-color;\n      }\n      [dir=\"rtl\"] & {\n        margin-left: 5px;\n      }\n    }\n    .delete {\n      i {\n        color: $danger-color;\n      }\n    }\n  }\n}\n#auto-generate-content_wrapper {\n  &.dataTables_wrapper {\n    button {\n      background-color: white;\n      border: 1px solid var(--theme-default);\n      color: var(--theme-default);\n    }\n  }\n}\n.dataTables_wrapper {\n  width: calc(100% - 1px);\n  &.no-footer {\n    .dataTables_scrollBody {\n      border-bottom: 1px solid $light-gray;\n    }\n  }\n  .dt-buttons {\n    .btn {\n      border-radius: 0.25rem !important;\n    }\n  }\n  padding: 0;\n  .btn-group {\n    button {\n      margin-right: 5px;\n    }\n  }\n  button {\n    font-weight: 400;\n    padding: 0.375rem 0.75rem;\n    font-size: 14px;\n    border-radius: 0.25rem;\n    color: $white;\n  }\n  & + .dataTables_wrapper {\n    margin-top: 20px;\n  }\n  .dataTables_paginate {\n    margin-left: 15px !important;\n    border: 1px solid $light-color;\n    border-radius: 0.25rem;\n    padding-top: 0;\n    .paginate_button {\n      margin: 0;\n      &.current,\n      &:active {\n        background: var(--theme-default);\n        color: $white !important;\n        box-shadow: none;\n      }\n      &:hover {\n        border: 1px solid var(--theme-default);\n        color: $dark-color !important;\n        background: transparent !important;\n      }\n    }\n  }\n  .dataTables_length {\n    margin-bottom: 30px;\n    select {\n      border-color: $light-color;\n      color: $dark-color;\n      padding: 0 10px;\n      margin: 0 10px;\n      height: 2.7142em;\n      background-color: $white;\n    }\n  }\n  table.dataTable {\n    border: 1px solid $light-semi-gray;\n    tbody {\n      td,\n      th {\n        &.select-checkbox {\n          padding-right: 40px !important;\n          &:before {\n            right: 20px;\n            top: 22px;\n            left: unset;\n          }\n          &:after {\n            margin-top: -5px;\n            margin-left: 21px;\n          }\n        }\n      }\n    }\n    thead {\n      th,\n      td {\n        border-bottom: 2px solid $light-semi-gray;\n      }\n    }\n    th,\n    td {\n      padding: 0.75rem;\n    }\n  }\n  .dataTables_filter {\n    margin-bottom: 25px;\n    margin-left: 15px;\n    input[type=\"search\"] {\n      border: 1px solid $light-semi-gray;\n      padding: 0 10px;\n      margin-left: 10px;\n      height: 37px;\n      border-radius: 0;\n    }\n  }\n}\n.dataTables_scrollHeadInner {\n  width: 100% !important;\n}\ntable {\n  .fixedHeader-floating {\n    position: fixed !important;\n    background-color: $white;\n  }\n  .box {\n    > div {\n      padding: 5px 15px;\n      background-color: var(--theme-default);\n      display: inline-block;\n      color: $white;\n      border-radius: 5px;\n      margin-bottom: 15px;\n      margin-right: 15px;\n    }\n  }\n  &.dataTable {\n    &.fixedHeader-locked,\n    &.fixedHeader-floating {\n      width: calc(100vw - 250px) !important;\n      max-width: calc(100vw - 250px) !important;\n      overflow: hidden !important;\n      right: 0 !important;\n      z-index: 99;\n      left: 260px !important;\n    }\n    &:not(.fixedHeader-locked) {\n      &:not(.fixedHeader-floating) {\n        width: 100% !important;\n      }\n    }\n  }\n  &.dataTable {\n    border-collapse: collapse !important;\n    margin-top: 0 !important;\n    thead {\n      .sorting,\n      .sorting_asc,\n      .sorting_desc,\n      .sorting_asc_disabled,\n      .sorting_desc_disabled {\n        &:before,\n        &:after {\n          bottom: 12px !important;\n        }\n      }\n    }\n    input,\n    select {\n      border: 1px solid $light-semi-gray;\n      height: 37px;\n    }\n  }\n}\n.user-datatable {\n  tr {\n    td,\n    th {\n      &:first-child {\n        min-width: 150px;\n      }\n    }\n  }\n}\n.jsgrid {\n  .jsgrid-button {\n    width: 20px;\n    height: 20px;\n  }\n  .jsgrid-delete-button {\n    background-position: 0 -78px;\n    width: 22px;\n    height: 22px;\n  }\n  .jsgrid-edit-button {\n    background-position: -2px -122px;\n    width: 22px;\n    height: 22px;\n  }\n  .jsgrid-insert-mode-button {\n    background-position: -2px -160px;\n    width: 25px;\n    height: 25px;\n  }\n  .jsgrid-insert-button {\n    background-position: -3px -202px;\n    width: 16px;\n    height: 16px;\n  }\n}\n.toolbar {\n  padding: 5px 15px;\n  background-color: var(--theme-default);\n  display: inline-block;\n  color: $white;\n  border-radius: 5px;\n  margin-bottom: 15px;\n  margin-right: 15px;\n}\ncode {\n  &.option {\n    color: $danger-color !important;\n  }\n  &.api {\n    color: $success-color !important;\n  }\n}\n\n// Datatable extension\n.dt-ext {\n  .dataTables_wrapper {\n    .page-item {\n      &.active {\n        .page-link {\n          background-color: var(--theme-default) !important;\n          border-color: var(--theme-default) !important;\n          color: $white;\n        }\n      }\n    }\n\n    .dataTables_paginate {\n      border: none;\n      .paginate_button {\n        padding: 0;\n        border: none;\n        &.disabled,\n        &.hover,\n        &.active {\n          border: none !important;\n        }\n      }\n      .page-link {\n        margin-left: 0px;\n        color: var(--theme-default);\n      }\n    }\n    button.dt-button,\n    div.dt-button,\n    a.dt-button,\n    button.dt-button:focus:not(.disabled),\n    div.dt-button:focus:not(.disabled),\n    a.dt-button:focus:not(.disabled),\n    button.dt-button:active:not(.disabled),\n    button.dt-button.active:not(.disabled),\n    div.dt-button:active:not(.disabled),\n    div.dt-button.active:not(.disabled),\n    a.dt-button:active:not(.disabled),\n    a.dt-button.active:not(.disabled) {\n      background-color: var(--theme-default);\n      border-color: var(--theme-default);\n      border-radius: 2px;\n      color: $white;\n      background-image: none;\n      font-size: 14px;\n    }\n    button.dt-button.btn-success,\n    div.dt-button.btn-success,\n    a.dt-button.btn-success {\n      background-color: $success-color;\n      border-color: $success-color;\n    }\n    button.dt-button.btn-primary,\n    div.dt-button.btn-primary,\n    a.dt-button.btn-primary {\n      background-color: var(--theme-default);\n      border-color: var(--theme-default);\n    }\n    button.dt-button.btn-danger,\n    div.dt-button.btn-danger,\n    a.dt-button.btn-danger {\n      background-color: $danger-color;\n      border-color: $danger-color;\n    }\n    table.dataTable th.focus,\n    table.dataTable td.focus {\n      outline: 3px solid var(--theme-default);\n    }\n    table.dataTable.display tbody > tr.odd.selected > .sorting_1,\n    table.dataTable.order-column.stripe tbody > tr.odd.selected > .sorting_1 {\n      background-color: lighten($primary-color, 38%);\n    }\n    table.dataTable.stripe tbody > tr.odd.selected,\n    table.dataTable.stripe tbody > tr.odd > .selected,\n    table.dataTable.display tbody > tr.odd.selected,\n    table.dataTable.display tbody > tr.odd > .selected {\n      background-color: lighten($primary-color, 38%);\n    }\n    table.dataTable.display tbody > tr.even.selected > .sorting_1,\n    table.dataTable.order-column.stripe tbody > tr.even.selected > .sorting_1 {\n      background-color: lighten($primary-color, 38%);\n    }\n    table.dataTable tbody > tr.selected,\n    table.dataTable tbody > tr > .selected {\n      background-color: lighten($primary-color, 38%);\n    }\n  }\n}\n\ntd.highlight {\n  background-color: $light-color !important;\n}\ntd.details-control {\n  background: url(\"../../images/details_open.png\") no-repeat center center;\n  cursor: pointer;\n}\n// tr.shown td.details-control {\n//   background: url('../../images/details_close.png') no-repeat center center;\n// }\n.dataTables_scroll {\n  & ~ .dataTables_paginate {\n    margin-top: 20px !important;\n  }\n}\n.product-table {\n  th {\n    &:last-child {\n      min-width: 120px;\n    }\n  }\n  h6 {\n    font-weight: 600;\n    color: $dark-color;\n  }\n}\ntable {\n  &.dataTable {\n    &.display {\n      tbody {\n        tr {\n          &.odd {\n            > .sorting_1 {\n              background-color: $light;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n/**=====================\n     30. Data-table CSS Ends\n==========================**/\n","/**=====================\n     29. Form Input CSS Start\n==========================**/\n%input-mixin1 {\n\tposition: absolute;\n\tz-index: 2;\n\tleft: 10px;\n\tfont-size: 14px;\n\twidth: 20px;\n\tmargin-left: -2.5px;\n\ttext-align: center;\n\tpadding: 10px 0;\n\ttop: 1px;\n}\n%input-mixin2 {\n\tposition: absolute;\n\tz-index: 2;\n\tleft: 10px;\n\tfont-size: 14px;\n\twidth: 20px;\n\tmargin-left: -2.5px;\n\ttext-align: center;\n\tpadding: 10px 0;\n\ttop: 1px;\n}\n.input-group-square {\n\t.input-group-text ,.form-control{\n\t\tborder-radius: 0;\n\t}\n}\n.input-group-solid {\n\t.input-group-text ,.form-control{\n\t\tbackground: $light-color;\n\t}\n}\n.input-group-air {\n\tbox-shadow: 0 3px 20px 0 $light-semi-gray;\n}\n.icon-addon {\n\tposition: relative;\n\tcolor: $color-scarpa;\n\tdisplay: block;\n\t&:after {\n\t\tdisplay: table;\n\t\tcontent: \"\";\n\t\tclear: both;\n\t}\n\t&:before {\n\t\tdisplay: table;\n\t\tcontent: \"\";\n\t}\n\t.addon-md {\n\t\t.form-control {\n\t\t\tpadding-left: 30px;\n\t\t\tfloat: left;\n\t\t\tfont-weight: normal;\n\t\t}\n\t\t.glyphicon {\n\t\t\t@extend %input-mixin1;\n\t\t}\n\t\t.fa {\n\t\t\t@extend %input-mixin1;\n\t\t}\n\t}\n\t.form-control {\n\t\tpadding-left: 30px;\n\t\tfloat: left;\n\t\tfont-weight: normal;\n\t}\n\t.glyphicon,.fa {\n\t\t@extend %input-mixin2;\n\t}\n}\n.pill-input-group span {\n\t&:last-child {\n\t\tborder-top-right-radius: 1.3rem;\n\t\tborder-bottom-right-radius: 1.3rem;\n\t}\n\n\t&:first-child {\n\t\tborder-top-left-radius: 1.3rem;\n\t\tborder-bottom-left-radius: 1.3rem;\n\t}\n}\n/**=====================\n     29. Form Input CSS Ends\n==========================**/","/**=====================\n     48. Form Wizard CSS Start\n==========================**/\n\nol {\n  display: flex;\n  &.progtrckr {\n    li {\n      width: 100%;\n      em {\n        display: none;\n      }\n      &.progtrckr-todo,\n      &.progtrckr-doing,\n      &.progtrckr-done {\n        &:before {\n          font-size: 20px !important;\n          width: 30px !important;\n          height: 30px !important;\n          line-height: 30px !important;\n        }\n      }\n    }\n  }\n}\n.multi-step {\n  position: relative;\n  .footer-buttons {\n    .btn-lg {\n      font-size: 14px;\n    }\n  }\n  .btnsubmit {\n    position: absolute;\n    bottom: -34px;\n    right: 15px;\n  }\n}\n\n@media (max-width: 485px) {\n  ol {\n    &.progtrckr {\n      li {\n        &:before {\n          bottom: -63px !important;\n        }\n        span {\n          padding: 0 !important;\n        }\n        &.progtrckr-todo,\n        &.progtrckr-doing,\n        &.progtrckr-done {\n          &:before {\n            font-size: 18px !important;\n            width: 20px !important;\n            height: 20px !important;\n            line-height: 20px !important;\n          }\n        }\n      }\n    }\n  }\n}\n/**=====================\n    48. Form Wizard CSS Ends\n==========================**/\n","/**=====================\n    26. Form CSS Start\n==========================**/\n.form-label {\n  margin-bottom: 4px;\n}\n.col-form-label {\n  padding-bottom: 4px;\n}\n.form-space {\n  margin-bottom: -10px;\n\n  >div {\n    margin-bottom: 10px;\n  }\n}\n.theme-form {\n  .form-control {\n    :focus {\n      box-shadow: 0 0 0 0.2rem rgba(171, 140, 228, 0.05);\n    }\n  }\n\n   textarea {\n     border-color: $form-input-border-color;\n\n     &::-webkit-input-placeholder {\n       color: $form-placeholder-color;\n       font-size: $form-placeholder-font-size;\n       letter-spacing: $form-placeholder-letter-spacing;\n       font-weight: $form-placeholder-font-weight;\n     }\n   }\n\n   input[type=text],\n   input[type=email],\n   input[type=search],\n   input[type=password],\n   input[type=number],\n   input[type=tel],\n   input[type=date],\n   input[type=datetime-local],\n   input[type=time],\n   input[type=datetime-local],\n   input[type=month],\n   input[type=week],\n   input[type=url],\n   input[type=file],\n   textarea,\n   select {\n     border-color: $form-input-border-color;\n     background-color: $form-input-bg-color;\n     font-size: $form-placeholder-font-size;\n     color: $form-placeholder-color;\n     padding: 12px 10px;\n     -webkit-box-shadow: none;\n     box-shadow: none;\n     &::-webkit-input-placeholder {\n       color: $form-placeholder-color;\n       font-size: $form-placeholder-font-size;\n       letter-spacing: $form-placeholder-letter-spacing;\n       font-weight: $form-placeholder-font-weight;\n     }\n   }\n\n   input[type=file] {\n    height: auto;\n   }\n\n   select.form-control:not([size]):not([multiple]) {\n     border-color: $form-input-border-color;\n     font-size: $form-placeholder-font-size;\n   }\n  .checkbox {\n    label {\n      padding-left: 10px;\n    }\n  }\n\n  .form-divider {\n    position: relative;\n    clear: both;\n    height: 0;\n    margin: 30px 0;\n    border-top: 1px solid $light-semi-gray;\n\n    &:before {\n      position: absolute;\n      top: -11px;\n      left: 40%;\n      margin-left: -10px;\n      padding: 0 5px;\n      content: \"Or Signup With\";\n      color: $theme-font-color;\n      background: $white;\n    }\n  }\n\n  .login-divider {\n    position: relative;\n    clear: both;\n    height: 0;\n    margin: 30px 0;\n    border-top: 1px solid $light-semi-gray;\n\n    &:before {\n      position: absolute;\n      top: -11px;\n      left: 40%;\n      margin-left: -10px;\n      padding: 0 5px;\n      color: $theme-font-color;\n      background: $white;\n      content: \"Or Login With\";\n    }\n  }\n\n  .btn-fb,\n  .btn-twitter,\n  .btn-google,\n  .btn-linkedin {\n    color: $white;\n    width: 100%;\n  }\n\n  .btn-fb {\n    background-color: $fb;\n  }\n\n  .btn-twitter {\n    background-color: $twitter;\n  }\n\n  .btn-google {\n    background-color: $google-plus;\n  }\n\n  .btn-linkedin {\n    background-color: $linkedin;\n  }\n}\n\n.form-inline {\n    display: flex;\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    flex-flow: row wrap;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    margin-bottom: 0;\n  .col-form-label {\n    margin-right: 5px;\n  }\n}\n\n.search-form {\n  .form-group {\n    &:before {\n      position: absolute;\n      content: \"\";\n      width: 1px;\n      height: 25px;\n      background: #e8ebf2;\n      left: 82px;\n      top: 50px;\n    }\n\n    &:after {\n      position: absolute;\n      content: \"\\f002\";\n      font-family: \"FontAwesome\";\n      top: 53px;\n      left: 53px;\n      color: #8e8e8e;\n    }\n  }\n\n  input {\n    border: 1px solid $light-semi-gray;\n    padding: 10px 10px 10px 70px;\n    border-radius: 10px;\n    background-color: rgba($light-color, 0.3);\n\n    &:focus {\n      outline: none !important;\n    }\n  }\n}\n\n.form-label-align-right {\n  label {\n    text-align: right;\n    padding-top: 17px;\n    font-weight: 500;\n  }\n}\n\n/**=====================\n    26. Form CSS Ends\n==========================**/","/**=====================\n    10. ICON CSS Start\n==========================**/\n.icon-lists {\n  div {\n    cursor: pointer;\n    line-height: 60px;\n    white-space: nowrap;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n\n    &:hover {\n      background-color: $auth-bg-color;\n    }\n    i {\n      margin: 0 15px 0 10px;\n      font-size: 24px;\n    }\n  }\n  &.whether-icon {\n    svg {\n      height: 50px;\n      width: 50px;\n    }\n  }\n  &.feather-icons {\n    .media {\n      svg {\n        margin: 0 15px 0 10px;\n      }\n    }\n  }\n  .feather-icon {\n    .icon-first {\n      h6 {\n        display: none;\n      }\n    }\n  }\n}\n.flag-icons,\n.feather-icons {\n  margin-bottom: -15px;\n  margin-top: -15px;\n  div {\n    line-height: 1;\n    word-wrap: break-word;\n    overflow: auto;\n    .flag-icon {\n      height: 50px;\n      width: 50px;\n    }\n    .media {\n      padding-top: 15px;\n      padding-bottom: 15px;\n      width: 100%;\n    }\n    .media-body {\n      h6 {\n        margin-bottom: 0;\n        font-size: 14px;\n        font-weight: 400;\n        max-width: 100%;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        overflow: hidden;\n      }\n      h5 {\n        background-color: var(--theme-default);\n        display: inline-block;\n        padding: 3px 5px;\n        font-size: 11px;\n        border-radius: 3px;\n        margin-bottom: 5px;\n        margin-right: 5px;\n        color: $white;\n      }\n    }\n  }\n}\n.icon-hover-bottom {\n  background-color: $light;\n  width: 100%;\n  bottom: 0;\n  left: 0;\n  box-shadow: 0px 0px 1px 1px $light-color;\n  z-index: 999;\n  .icon-popup {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    .close-icon {\n      position: absolute;\n      right: 10px;\n      top: 10px;\n      font-size: 20px;\n      color: $gray-60;\n      cursor: pointer;\n      [dir=\"rtl\"] & {\n        right: unset;\n        left: 10px;\n      }\n    }\n    padding: 20px;\n    > div {\n      display: inline-block;\n      .flag-icon {\n        width: 60px;\n        height: 60px;\n      }\n    }\n    .icon-class {\n      margin: 0 20px;\n      cursor: pointer;\n    }\n    .icon-last {\n      .form-inline {\n        .form-group {\n          display: initial;\n        }\n      }\n    }\n  }\n  .icon-title {\n    display: block;\n    color: $dark-color;\n    text-transform: uppercase;\n    font-weight: 500;\n  }\n  span,\n  label,\n  .btn {\n    font-family: $font-roboto, $font-serif;\n  }\n  .form-group {\n    input {\n      display: inline-block;\n      width: 300px;\n      background-color: $white;\n      font-family: $font-roboto, $font-serif;\n    }\n  }\n}\n.fa-fa-icon-show-div,\n.icons-show-div {\n  display: none;\n}\n.icon-first {\n  i {\n    color: $dark-gray;\n  }\n  h6 {\n    display: none;\n  }\n}\n/**=====================\n     10. ICON CSS Ends\n==========================**/\n","/**=====================\n     17. List CSS Start\n==========================**/\n.list-group-item.active {\n  background-color: var(--theme-default) !important;\n  border-color: var(--theme-default) !important;\n}\n.list-group {\n  i {\n    margin-right: $list-group-margin;\n  }\n  img {\n    height: 40px;\n    width: 40px;\n    margin-right: $list-group-margin;\n  }\n}\n/**=====================\n     17. List CSS Ends\n==========================**/\n","/**=====================\n     04. Loader CSS Start\n==========================**/\n.loader-wrapper {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: fixed;\n  background-color: $white;\n  z-index: 11;\n  top: 0;\n\n  /*Color Loader*/\n  .loader-index {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    filter: url(\"#goo\");\n\n    &:after {\n      content: \"\";\n      width: 4em;\n      height: 4em;\n      background: var(--theme-default);\n      border-radius: 50%;\n      position: absolute;\n      transform: scale(0.5);\n      animation: grow 2s cubic-bezier(0.14, 0.05, 0.55, 0.5) infinite alternate;\n    }\n\n    span {\n      width: 2em;\n      height: 2em;\n      background: var(--theme-secondary);\n      border-radius: 50%;\n      margin-right: 2em;\n      position: relative;\n      transform: translateX(7em);\n      animation: move 4s ease-in-out infinite;\n\n      &:before {\n        content: \"\";\n        width: 2em;\n        height: 2em;\n        background: var(--theme-default);\n        border-radius: 50%;\n        position: absolute;\n        left: 3em;\n        transform: translateX(0em);\n        animation: shrink 2s ease-in-out infinite;\n      }\n\n      &:after {\n        content: \"\";\n        width: 2em;\n        height: 2em;\n        background: $info-color;\n        border-radius: 50%;\n        position: absolute;\n        right: 3em;\n        transform: translateX(0em);\n        animation: shrink 2s ease-in-out infinite;\n      }\n    }\n  }\n\n  @keyframes grow {\n    0% {\n      transform: scale(0.5);\n      background: $info-color;\n    }\n\n    50% {\n      transform: scale(1);\n      background: var(--theme-secondary);\n    }\n  }\n\n  @keyframes move {\n    0% {\n      transform: translateX(7em);\n    }\n\n    50% {\n      transform: translateX(-5em);\n    }\n  }\n\n  @keyframes shrink {\n    0% {\n      transform: translateX(0em);\n    }\n\n    50% {\n      transform: translateX(-1em);\n    }\n  }\n\n  svg {\n    width: 0;\n    height: 0;\n  }\n\n  /*Color Loader*/\n\n  body {\n    font-family: sans;\n    min-height: 100vh;\n    margin: 0;\n    display: grid;\n    place-content: center;\n    background: black;\n  }\n\n  h1 {\n    color: #fff;\n    text-align: center;\n    margin-bottom: 2em;\n    letter-spacing: 3px;\n\n    position: relative;\n    z-index: 2;\n\n    &:before {\n      position: absolute;\n      content: \"\";\n      height: 1px;\n      background: linear-gradient(to right, var(--theme-secondary), var(--theme-default), $info-color);\n      color: #fff;\n      top: 2.75em;\n      left: 0.75em;\n      width: 2.5em;\n      font-weight: 400;\n      font-variant: small-caps;\n      font-size: 0.5em;\n    }\n  }\n}\n\n.loader-box {\n  height: 150px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  vertical-align: middle;\n  justify-content: center;\n  transition: 0.3s color, 0.3s border, 0.3s transform, 0.3s opacity;\n\n  [class*=\"loader-\"] {\n    display: inline-block;\n    width: 50px;\n    height: 50px;\n    color: inherit;\n    vertical-align: middle;\n  }\n\n  .loader-1 {\n    border: 0.2em dotted var(--theme-default);\n    border-radius: 50%;\n    animation: 1s loader-01 linear infinite;\n  }\n\n  @keyframes loader-01 {\n    0% {\n      transform: rotate(0deg);\n    }\n\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n  .loader-2 {\n    border: 0.2em solid transparent;\n    border-left-color: var(--theme-secondary);\n    border-right-color: var(--theme-secondary);\n    border-radius: 50%;\n    animation: 1s loader-02 linear infinite;\n  }\n\n  @keyframes loader-02 {\n    0% {\n      transform: rotate(0deg);\n    }\n\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n  .loader-3 {\n    border: 0.2em solid $info-color;\n    border-bottom-color: transparent;\n    border-radius: 50%;\n    animation: 1s loader-03 linear infinite;\n    position: relative;\n  }\n\n  @keyframes loader-03 {\n    0% {\n      transform: rotate(0deg);\n    }\n\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n  .loader-4 {\n    border: 1px solid $info-color;\n    border-radius: 50%;\n    animation: 1s loader-04 linear infinite;\n    position: relative;\n\n    &:before {\n      content: \"\";\n      display: block;\n      width: 0;\n      height: 0;\n      position: absolute;\n      top: -0.2em;\n      left: 50%;\n      border: 0.2em solid $info-color;\n      border-radius: 50%;\n    }\n  }\n\n  @keyframes loader-04 {\n    0% {\n      transform: rotate(0deg);\n    }\n\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n  .loader-5 {\n    border: 0.2em solid transparent;\n    border-top-color: $warning-color;\n    border-radius: 50%;\n    animation: 1s loader-05 linear infinite;\n    position: relative;\n\n    &:before {\n      content: \"\";\n      display: block;\n      width: inherit;\n      height: inherit;\n      position: absolute;\n      top: -0.2em;\n      left: -0.2em;\n      border: 0.2em solid $warning-color;\n      border-radius: 50%;\n      opacity: 0.5;\n    }\n  }\n\n  @keyframes loader-05 {\n    0% {\n      transform: rotate(0deg);\n    }\n\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n  .loader-6 {\n    border: 0.2em solid $danger-color;\n    border-radius: 50%;\n    animation: loader-06 1s ease-out infinite;\n  }\n\n  @keyframes loader-06 {\n    0% {\n      transform: scale(0);\n      opacity: 0;\n    }\n\n    50% {\n      opacity: 1;\n    }\n\n    100% {\n      transform: scale(1);\n      opacity: 0;\n    }\n  }\n\n  .loader-7 {\n    border: 0 solid transparent;\n    border-radius: 50%;\n    position: relative;\n\n    &:before,\n    &:after {\n      content: \"\";\n      border: 0.2em solid var(--theme-default);\n      border-radius: 50%;\n      width: inherit;\n      height: inherit;\n      position: absolute;\n      top: 0;\n      left: 0;\n      animation: loader-07 1s linear infinite;\n      opacity: 0;\n    }\n\n    &:before {\n      animation-delay: 1s;\n    }\n\n    &:after {\n      animation-delay: 0.5s;\n    }\n  }\n\n  @keyframes loader-07 {\n    0% {\n      transform: scale(0);\n      opacity: 0;\n    }\n\n    50% {\n      opacity: 1;\n    }\n\n    100% {\n      transform: scale(1);\n      opacity: 0;\n    }\n  }\n\n  .loader-8 {\n    position: relative;\n\n    &:before,\n    &:after {\n      content: \"\";\n      width: inherit;\n      height: inherit;\n      border-radius: 50%;\n      background-color: var(--theme-secondary);\n      opacity: 0.6;\n      position: absolute;\n      top: 0;\n      left: 0;\n      animation: loader-08 2s infinite ease-in-out;\n    }\n\n    &:after {\n      animation-delay: -1s;\n    }\n  }\n\n  @keyframes loader-08 {\n    0%,\n    100% {\n      transform: scale(0);\n    }\n\n    50% {\n      transform: scale(1);\n    }\n  }\n\n  .loader-9 {\n    background-color: $info-color;\n    border-radius: 50%;\n    animation: loader-09 1s infinite ease-in-out;\n  }\n\n  @keyframes loader-09 {\n    0% {\n      transform: scale(0);\n    }\n\n    100% {\n      transform: scale(1);\n      opacity: 0;\n    }\n  }\n\n  .loader-10 {\n    position: relative;\n    animation: loader-10-1 2s infinite linear;\n\n    &:before,\n    &:after {\n      content: \"\";\n      width: 0;\n      height: 0;\n      border: 0.5em solid $info-color;\n      display: block;\n      position: absolute;\n      border-radius: 100%;\n      animation: loader-10-2 2s infinite ease-in-out;\n    }\n\n    &:before {\n      top: 0;\n      left: 50%;\n    }\n\n    &:after {\n      bottom: 0;\n      right: 50%;\n      animation-delay: -1s;\n    }\n  }\n\n  @keyframes loader-10-1 {\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n  @keyframes loader-10-2 {\n    0%,\n    100% {\n      transform: scale(0);\n    }\n\n    50% {\n      transform: scale(1);\n    }\n  }\n\n  .loader-11 {\n    background-color: $warning-color;\n    animation: loader-11 1.2s infinite ease-in-out;\n  }\n\n  @keyframes loader-11 {\n    0% {\n      transform: perspective(120px) rotateX(0deg) rotateY(0deg);\n    }\n\n    50% {\n      transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);\n    }\n\n    100% {\n      transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);\n    }\n  }\n\n  .loader-12 {\n    position: relative;\n\n    &:before,\n    &:after {\n      content: \"\";\n      display: block;\n      position: absolute;\n      background-color: $danger-color;\n      left: 50%;\n      right: 0;\n      top: 0;\n      bottom: 50%;\n      box-shadow: -0.5em 0 0 $danger-color;\n      animation: loader-12 1s linear infinite;\n    }\n\n    &:after {\n      top: 50%;\n      bottom: 0;\n      animation-delay: 0.25s;\n    }\n  }\n\n  @keyframes loader-12 {\n    0%,\n    100% {\n      box-shadow: -0.5em 0 0 transparent;\n      background-color: $danger-color;\n    }\n\n    50% {\n      box-shadow: -0.5em 0 0 $danger-color;\n      background-color: transparent;\n    }\n  }\n\n  .loader-13:before,\n  .loader-13:after,\n  .loader-13 {\n    border-radius: 50%;\n    animation-fill-mode: both;\n    animation: loader-13 1.8s infinite ease-in-out;\n  }\n\n  .loader-13 {\n    color: var(--theme-default);\n    position: relative;\n    transform: translateZ(0);\n    animation-delay: -0.16s;\n    top: -1em;\n\n    &:before {\n      right: 100%;\n      animation-delay: -0.32s;\n    }\n\n    &:after {\n      left: 100%;\n    }\n\n    &:before,\n    &:after {\n      content: \"\";\n      display: block;\n      position: absolute;\n      top: 0;\n      width: inherit;\n      height: inherit;\n    }\n  }\n\n  @keyframes loader-13 {\n    0%,\n    80%,\n    100% {\n      box-shadow: 0 1em 0 -1em;\n    }\n\n    40% {\n      box-shadow: 0 1em 0 -0.2em;\n    }\n  }\n\n  .loader-14 {\n    border-radius: 50%;\n    box-shadow: 0 1em 0 -0.2em var(--theme-secondary);\n    position: relative;\n    animation: loader-14 0.8s ease-in-out alternate infinite;\n    animation-delay: 0.32s;\n    top: -1em;\n\n    &:after,\n    &:before {\n      content: \"\";\n      position: absolute;\n      width: inherit;\n      height: inherit;\n      border-radius: inherit;\n      box-shadow: inherit;\n      animation: inherit;\n    }\n\n    &:before {\n      left: -1em;\n      animation-delay: 0.48s;\n    }\n\n    &:after {\n      right: -1em;\n      animation-delay: 0.16s;\n    }\n  }\n\n  @keyframes loader-14 {\n    0% {\n      box-shadow: 0 2em 0 -0.2em var(--theme-secondary);\n    }\n\n    100% {\n      box-shadow: 0 1em 0 -0.2em var(--theme-secondary);\n    }\n  }\n\n  .loader-15 {\n    background: $info-color;\n    position: relative;\n    animation: loader-15 1s ease-in-out infinite;\n    animation-delay: 0.4s;\n    width: 0.25em;\n    height: 0.5em;\n    margin: 0 0.5em;\n\n    &:after,\n    &:before {\n      content: \"\";\n      position: absolute;\n      width: inherit;\n      height: inherit;\n      background: inherit;\n      animation: inherit;\n    }\n\n    &:before {\n      right: 0.5em;\n      animation-delay: 0.2s;\n    }\n\n    &:after {\n      left: 0.5em;\n      animation-delay: 0.6s;\n    }\n  }\n\n  @keyframes loader-15 {\n    0%,\n    100% {\n      box-shadow: 0 0 0 $info-color, 0 0 0 $info-color;\n    }\n\n    50% {\n      box-shadow: 0 -0.25em 0 $info-color, 0 0.25em 0 $info-color;\n    }\n  }\n\n  .loader-16 {\n    transform: rotateZ(45deg);\n    perspective: 1000px;\n    border-radius: 50%;\n\n    &:before,\n    &:after {\n      content: \"\";\n      display: block;\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: inherit;\n      height: inherit;\n      border-radius: 50%;\n      animation: 1s spin linear infinite;\n    }\n\n    &:before {\n      transform: rotateX(70deg);\n    }\n\n    &:after {\n      transform: rotateY(70deg);\n      animation-delay: 0.4s;\n    }\n  }\n\n  @keyframes rotate {\n    0% {\n      transform: translate(-50%, -50%) rotateZ(0deg);\n    }\n\n    100% {\n      transform: translate(-50%, -50%) rotateZ(360deg);\n    }\n  }\n\n  @keyframes rotateccw {\n    0% {\n      transform: translate(-50%, -50%) rotate(0deg);\n    }\n\n    100% {\n      transform: translate(-50%, -50%) rotate(-360deg);\n    }\n  }\n\n  @keyframes spin {\n    0%,\n    100% {\n      box-shadow: 0.2em 0px 0 0px $info-color;\n    }\n\n    12% {\n      box-shadow: 0.2em 0.2em 0 0 $info-color;\n    }\n\n    25% {\n      box-shadow: 0 0.2em 0 0px $info-color;\n    }\n\n    37% {\n      box-shadow: -0.2em 0.2em 0 0 $info-color;\n    }\n\n    50% {\n      box-shadow: -0.2em 0 0 0 $info-color;\n    }\n\n    62% {\n      box-shadow: -0.2em -0.2em 0 0 $info-color;\n    }\n\n    75% {\n      box-shadow: 0px -0.2em 0 0 $info-color;\n    }\n\n    87% {\n      box-shadow: 0.2em -0.2em 0 0 $info-color;\n    }\n  }\n\n  .loader-17 {\n    position: relative;\n    background-color: $warning-color;\n    border-radius: 50%;\n\n    &:after,\n    &:before {\n      content: \"\";\n      position: absolute;\n      width: 10px;\n      height: 10px;\n      border-radius: 50%;\n      opacity: 0.8;\n    }\n\n    &:after {\n      left: -0.5em;\n      top: -0.25em;\n      background-color: $warning-color;\n      transform-origin: 30px 35px;\n      animation: loader-17 1s linear infinite;\n      opacity: 0.6;\n    }\n\n    &:before {\n      left: -1.25em;\n      top: -0.75em;\n      background-color: $warning-color;\n      transform-origin: 40px 40px;\n      animation: loader-17 2s linear infinite;\n    }\n  }\n\n  @keyframes loader-17 {\n    0% {\n      transform: rotateZ(0deg) translate3d(0, 0, 0);\n    }\n\n    100% {\n      transform: rotateZ(360deg) translate3d(0, 0, 0);\n    }\n  }\n\n  .loader-18 {\n    position: relative;\n\n    &:before,\n    &:after {\n      content: \"\";\n      display: block;\n      position: absolute;\n      border-radius: 50%;\n      border: 0.1em solid transparent;\n      border-bottom-color: $danger-color;\n      top: 0;\n      left: 0;\n      animation: 1s loader-18 linear infinite;\n    }\n\n    &:before {\n      width: 40px;\n      height: 40px;\n    }\n\n    &:after {\n      width: 30px;\n      height: 30px;\n      top: 0.1em;\n      left: 0.1em;\n      animation-direction: reverse;\n    }\n  }\n\n  @keyframes loader-18 {\n    0% {\n      transform: rotate(0deg);\n    }\n\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n  .loader-19 {\n    border-top: 0.2em solid var(--theme-default);\n    border-right: 0.2em solid transparent;\n    animation: loader-19 1s linear infinite;\n    border-radius: 100%;\n    position: relative;\n  }\n\n  @keyframes loader-19 {\n    to {\n      transform: rotate(360deg);\n    }\n  }\n\n  .loader-20 {\n    background-color: transparent;\n    box-shadow: inset 0px 0px 0px 0.1em var(--theme-secondary);\n    border-radius: 50%;\n    position: relative;\n\n    &:after,\n    &:before {\n      position: absolute;\n      content: \"\";\n      background-color: var(--theme-secondary);\n      top: 24px;\n      left: 24px;\n      height: 0.1em;\n      transform-origin: left center;\n    }\n\n    &:after {\n      width: 0.4em;\n      animation: loader-20 2s linear infinite;\n    }\n\n    &:before {\n      width: 20px;\n      animation: loader-20 8s linear infinite;\n    }\n  }\n\n  @keyframes loader-20 {\n    0% {\n      transform: rotate(0deg);\n    }\n\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n  .loader-21 {\n    position: relative;\n\n    &:before,\n    &:after {\n      position: absolute;\n      content: \"\";\n    }\n\n    &:before {\n      width: 80%;\n      height: 80%;\n      left: 10%;\n      bottom: 10%;\n      border-radius: 100% 100% 100% 0;\n      box-shadow: 0px 0px 0px 0.1em $info-color;\n      animation: loader-21 1s linear infinite;\n      transform: rotate(-46deg);\n    }\n\n    &:after {\n      width: 1em;\n      height: 0.3em;\n      border-radius: 100%;\n      left: 0;\n      background-color: rgba(255, 255, 255, 0.2);\n      bottom: -0.2em;\n      z-index: -1;\n    }\n  }\n\n  @keyframes loader-21 {\n    0% {\n      top: 0;\n    }\n\n    50% {\n      top: -5px;\n    }\n\n    100% {\n      top: 0;\n    }\n  }\n\n  .loader-22 {\n    border: 0.1em $info-color solid;\n    border-radius: 100%;\n    position: relative;\n    overflow: hidden;\n    z-index: 1;\n\n    &:after,\n    &:before {\n      position: absolute;\n      content: \"\";\n      background-color: $info-color;\n    }\n\n    &:after {\n      width: 50%;\n      height: 0.1em;\n      left: 50%;\n      top: 50%;\n      transform-origin: left center;\n      animation: loader-22 2s linear infinite alternate;\n    }\n\n    &:before {\n      width: 100%;\n      height: 40%;\n      left: 0;\n      bottom: 0;\n    }\n  }\n\n  @keyframes loader-22 {\n    0% {\n      transform: rotate(-160deg);\n    }\n\n    100% {\n      transform: rotate(-20deg);\n    }\n  }\n\n  .loader-23 {\n    height: 0.5em;\n    border: 0.1em $warning-color solid;\n    border-radius: 0.1em;\n    position: relative;\n    animation: loader-23 5s linear infinite;\n\n    &:after {\n      width: 0.07em;\n      height: 100%;\n      background-color: $warning-color;\n      border-radius: 0px 0.5em 0.5em 0px;\n      position: absolute;\n      content: \"\";\n      top: 0;\n      left: calc(100% + 0.1em);\n    }\n  }\n\n  @keyframes loader-23 {\n    0% {\n      box-shadow: inset 0px 0px 0px $warning-color;\n    }\n\n    100% {\n      box-shadow: inset 1em 0px 0px $warning-color;\n    }\n  }\n\n  .loader-24 {\n    width: 0.8em;\n    height: 1em;\n    border: 0.1em $danger-color solid;\n    border-radius: 0px 0px 0.2em 0.2em;\n    position: relative;\n\n    &:after,\n    &:before {\n      position: absolute;\n      content: \"\";\n    }\n\n    &:after {\n      width: 0.2em;\n      height: 50%;\n      border: 0.1em $danger-color solid;\n      border-left: none;\n      border-radius: 0px 0.5em 0.5em 0px;\n      left: calc(100% + 0.1em);\n      top: 0.1em;\n    }\n\n    &:before {\n      width: 0.1em;\n      height: 0.3em;\n      background-color: $danger-color;\n      top: -0.3em;\n      left: 0.05em;\n      box-shadow: 0.2em 0px 0px 0px $danger-color, 0.2em -0.2em 0px 0px $danger-color, 0.4em 0px 0px 0px $danger-color;\n      animation: loader-24 1s linear infinite alternate;\n    }\n  }\n\n  @keyframes loader-24 {\n    0% {\n      height: 0px;\n    }\n\n    100% {\n      height: 6px;\n    }\n  }\n\n  .loader-25 {\n    border: 0.1em var(--theme-default) solid;\n    position: relative;\n    animation: loader-25-1 5s linear infinite;\n\n    &:after {\n      width: 0.2em;\n      height: 0.2em;\n      position: absolute;\n      content: \"\";\n      background-color: var(--theme-default);\n      bottom: calc(100% + 0.2em);\n      left: -0.4em;\n      animation: loader-25-2 1s ease-in-out infinite;\n    }\n  }\n\n  @keyframes loader-25-1 {\n    0% {\n      box-shadow: inset 0 0 0 0 var(--theme-default);\n    }\n\n    100% {\n      box-shadow: inset 0 -1em 0 0 var(--theme-default);\n    }\n  }\n\n  @keyframes loader-25-2 {\n    25% {\n      left: calc(100% + 0.2em);\n      bottom: calc(100% + 0.2em);\n    }\n\n    50% {\n      left: calc(100% + 0.2em);\n      bottom: -0.4em;\n    }\n\n    75% {\n      left: -0.4em;\n      bottom: -0.4em;\n    }\n\n    100% {\n      left: -0.4em;\n      bottom: calc(100% + 0.2em);\n    }\n  }\n\n  .loader-26 {\n    width: 0.5em;\n    height: 0.5em;\n    background-color: var(--theme-secondary);\n    box-shadow: 1em 0px 0px var(--theme-secondary);\n    border-radius: 50%;\n    animation: loader-26 1s ease-in-out infinite alternate;\n  }\n\n  @keyframes loader-26 {\n    0% {\n      opacity: 0.1;\n      transform: rotate(0deg) scale(0.5);\n    }\n\n    100% {\n      opacity: 1;\n      transform: rotate(360deg) scale(1.2);\n    }\n  }\n\n  .loader-29 {\n    border-radius: 50%;\n    box-shadow: inset 0 0 0 0.1em $info-color, -0.5em -0.5em 0 -0.4em $info-color, 0 -0.7em 0 -0.4em $info-color, 0.5em -0.5em 0 -0.4em $info-color, -0.5em 0.5em 0 -0.4em $info-color, 0 0.7em 0 -0.4em $info-color, 0.5em 0.5em 0 -0.4em $info-color, -0.7em 0 0 -0.4em $info-color, 0.7em 0 0 -0.4em $info-color;\n    animation: 5s loader-29 linear infinite;\n  }\n\n  @keyframes loader-29 {\n    0% {\n      transform: rotate(0deg);\n    }\n\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n  .loader-30 {\n    border: 0.2em solid transparent;\n    border-top-color: $info-color;\n    border-bottom-color: $info-color;\n    border-radius: 50%;\n    position: relative;\n    animation: 1s loader-30 linear infinite;\n\n    &:before,\n    &:after {\n      content: \"\";\n      display: block;\n      width: 0;\n      height: 0;\n      position: absolute;\n      border: 0.2em solid transparent;\n      border-bottom-color: $info-color;\n    }\n\n    &:before {\n      transform: rotate(135deg);\n      right: -0.3em;\n      top: -0.05em;\n    }\n\n    &:after {\n      transform: rotate(-45deg);\n      left: -0.3em;\n      bottom: -0.05em;\n    }\n  }\n\n  @keyframes loader-30 {\n    0% {\n      transform: rotate(0deg);\n    }\n\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n  .loader-31 {\n    box-shadow: 0 0 2em $warning-color;\n    background-color: $warning-color;\n    position: relative;\n    border-radius: 50%;\n    transform: rotateX(-60deg) perspective(1000px);\n\n    &:before,\n    &:after {\n      content: \"\";\n      display: block;\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: inherit;\n      height: inherit;\n      border-radius: inherit;\n      animation: 1s loader-31 ease-out infinite;\n    }\n\n    &:after {\n      animation-delay: 0.4s;\n    }\n  }\n\n  @keyframes loader-31 {\n    0% {\n      opacity: 1;\n      transform: rotate(0deg);\n      box-shadow: 0 0 0 -0.5em $warning-color, 0 0 0 -0.5em $warning-color, 0 0 0 -0.5em $warning-color, 0 0 0 -0.5em $warning-color, 0 0 0 -0.5em $warning-color, 0 0 0 -0.5em $warning-color, 0 0 0 -0.5em $warning-color, 0 0 0 -0.5em $warning-color;\n    }\n\n    100% {\n      opacity: 0;\n      transform: rotate(180deg);\n      box-shadow: -1em -1em 0 -0.35em $warning-color, 0 -1.5em 0 -0.35em $warning-color, 1em -1em 0 -0.35em $warning-color, -1.5em 0 0 -0.35em $warning-color, 1.5em -0 0 -0.35em $warning-color, -1em 1em 0 -0.35em $warning-color, 0 1.5em 0 -0.35em $warning-color, 1em 1em 0 -0.35em $warning-color;\n    }\n  }\n\n  .loader-32 {\n    position: relative;\n    border-radius: 50%;\n    box-shadow: 0 0 1em 0 $danger-color, inset 0 0 1em 0 $danger-color;\n    animation: 1s loader-32 linear infinite;\n\n    &:before,\n    &:after {\n      content: \"\";\n      display: block;\n      width: inherit;\n      height: inherit;\n      position: absolute;\n      border-radius: 50%;\n    }\n\n    &:before {\n      border-top: 0.2em solid $danger-color;\n      border-right: 0.2em solid transparent;\n      top: 0.28em;\n      right: calc(50% - 0.22em);\n    }\n\n    &:after {\n      border-bottom: 0.2em solid $danger-color;\n      border-left: 0.2em solid transparent;\n      bottom: 0.28em;\n      left: calc(50% - 0.22em);\n    }\n  }\n\n  @keyframes loader-32 {\n    0% {\n      transform: rotateX(-60deg) rotateZ(0deg);\n    }\n\n    100% {\n      transform: rotateX(-60deg) rotateZ(360deg);\n    }\n  }\n\n  .loader-34 {\n    position: relative;\n    width: 1em;\n    height: 0.5em;\n\n    &:after,\n    &:before {\n      position: absolute;\n      content: \"\";\n      height: 0.4em;\n      width: 0.4em;\n      top: 0;\n      background-color: var(--theme-default);\n      border-radius: 50%;\n    }\n\n    &:after {\n      right: 0;\n      animation: loader-34-2 0.5s ease-in-out infinite;\n      animation-direction: alternate;\n    }\n\n    &:before {\n      left: 0;\n      animation: loader-34-1 0.5s ease-in-out infinite;\n      animation-direction: alternate;\n    }\n  }\n\n  @keyframes loader-34-1 {\n    0% {\n      transform: translatex(0px);\n    }\n\n    65% {\n      height: 0.4em;\n      width: 0.4em;\n    }\n\n    100% {\n      height: 0.5em;\n      width: 0.3em;\n      transform: translatex(0.2em);\n    }\n  }\n\n  @keyframes loader-34-2 {\n    0% {\n      transform: translatex(0px);\n    }\n\n    65% {\n      height: 0.4em;\n      width: 0.4em;\n    }\n\n    100% {\n      height: 0.5em;\n      width: 0.3em;\n      transform: translatex(-0.2em);\n    }\n  }\n\n  .loader-35 {\n    margin: 0 0.5em;\n    position: relative;\n\n    &:before {\n      border-radius: 50%;\n      background-color: var(--theme-secondary);\n      animation: loader-35 3s cubic-bezier(0.77, 0, 0.175, 1) infinite;\n      content: \"\";\n      width: inherit;\n      height: inherit;\n      top: 0;\n      left: 0;\n      position: absolute;\n    }\n  }\n\n  @keyframes loader-35 {\n    0% {\n      transform: translateX(0) scale(1);\n    }\n\n    25% {\n      transform: translateX(-100%) scale(0.3);\n    }\n\n    50% {\n      transform: translateX(0) scale(1);\n    }\n\n    75% {\n      transform: translateX(100%) scale(0.3);\n    }\n\n    100% {\n      transform: translateX(0) scale(1);\n    }\n  }\n\n  .loader-37 {\n    border-right: 0.1em solid $info-color;\n    border-radius: 100%;\n    animation: loader-37 800ms linear infinite;\n\n    &:before,\n    &:after {\n      content: \"\";\n      width: 0.8em;\n      height: 0.8em;\n      display: block;\n      position: absolute;\n      top: calc(50% - 0.4em);\n      left: calc(50% - 0.4em);\n      border-left: 0.08em solid $info-color;\n      border-radius: 100%;\n      animation: loader-37 400ms linear infinite reverse;\n    }\n\n    &:after {\n      width: 0.6em;\n      height: 0.6em;\n      top: calc(50% - 0.3em);\n      left: calc(50% - 0.3em);\n      border: 0;\n      border-right: 0.05em solid $info-color;\n      animation: none;\n    }\n  }\n\n  @keyframes loader-37 {\n    from {\n      transform: rotate(360deg);\n    }\n\n    to {\n      transform: rotate(0deg);\n    }\n  }\n\n  .loader-38 {\n    height: 0.1em;\n    width: 0.1em;\n    box-shadow: -0.2em -0.2em 0 0.1em $info-color, -0.2em -0.2em 0 0.1em $info-color, -0.2em -0.2em 0 0.1em $info-color, -0.2em -0.2em 0 0.1em $info-color;\n    animation: loader-38 6s infinite;\n  }\n\n  @keyframes loader-38 {\n    0% {\n      box-shadow: -0.2em -0.2em 0 0.1em $info-color, -0.2em -0.2em 0 0.1em $info-color, -0.2em -0.2em 0 0.1em $info-color, -0.2em -0.2em 0 0.1em $info-color;\n    }\n\n    8.33% {\n      box-shadow: -0.2em -0.2em 0 0.1em $info-color, 0.2em -0.2em 0 0.1em $info-color, 0.2em -0.2em 0 0.1em $info-color, 0.2em -0.2em 0 0.1em $info-color;\n    }\n\n    16.66% {\n      box-shadow: -0.2em -0.2em 0 0.1em $info-color, 0.2em -0.2em 0 0.1em $info-color, 0.2em 0.2em 0 0.1em $info-color, 0.2em 0.2em 0 0.1em $info-color;\n    }\n\n    24.99% {\n      box-shadow: -0.2em -0.2em 0 0.1em $info-color, 0.2em -0.2em 0 0.1em $info-color, 0.2em 0.2em 0 0.1em $info-color, -0.2em 0.2em 0 0.1em $info-color;\n    }\n\n    33.32% {\n      box-shadow: -0.2em -0.2em 0 0.1em $info-color, 0.2em -0.2em 0 0.1em $info-color, 0.2em 0.2em 0 0.1em $info-color, -0.2em -0.2em 0 0.1em $info-color;\n    }\n\n    41.65% {\n      box-shadow: 0.2em -0.2em 0 0.1em $info-color, 0.2em -0.2em 0 0.1em $info-color, 0.2em 0.2em 0 0.1em $info-color, 0.2em -0.2em 0 0.1em $info-color;\n    }\n\n    49.98% {\n      box-shadow: 0.2em 0.2em 0 0.1em $info-color, 0.2em 0.2em 0 0.1em $info-color, 0.2em 0.2em 0 0.1em $info-color, 0.2em 0.2em 0 0.1em $info-color;\n    }\n\n    58.31% {\n      box-shadow: -0.2em 0.2em 0 0.1em $info-color, -0.2em 0.2em 0 0.1em $info-color, 0.2em 0.2em 0 0.1em $info-color, -0.2em 0.2em 0 0.1em $info-color;\n    }\n\n    66.64% {\n      box-shadow: -0.2em -0.2em 0 0.1em $info-color, -0.2em -0.2em 0 0.1em $info-color, 0.2em 0.2em 0 0.1em $info-color, -0.2em 0.2em 0 0.1em $info-color;\n    }\n\n    74.97% {\n      box-shadow: -0.2em -0.2em 0 0.1em $info-color, 0.2em -0.2em 0 0.1em $info-color, 0.2em 0.2em 0 0.1em $info-color, -0.2em 0.2em 0 0.1em $info-color;\n    }\n\n    83.3% {\n      box-shadow: -0.2em -0.2em 0 0.1em $info-color, 0.2em 0.2em 0 0.1em $info-color, 0.2em 0.2em 0 0.1em $info-color, -0.2em 0.2em 0 0.1em $info-color;\n    }\n\n    91.63% {\n      box-shadow: -0.2em -0.2em 0 0.1em $info-color, -0.2em 0.2em 0 0.1em $info-color, -0.2em 0.2em 0 0.1em $info-color, -0.2em 0.2em 0 0.1em $info-color;\n    }\n\n    100% {\n      box-shadow: -0.2em -0.2em 0 0.1em $info-color, -0.2em -0.2em 0 0.1em $info-color, -0.2em -0.2em 0 0.1em $info-color, -0.2em -0.2em 0 0.1em $info-color;\n    }\n  }\n\n  .loader-39 {\n    position: relative;\n    width: 0.15em;\n    height: 0.15em;\n    background-color: $warning-color;\n    border-radius: 100%;\n    animation: loader-39-1 30s infinite linear;\n\n    &:before,\n    &:after {\n      content: \"\";\n      border-radius: 100%;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n    }\n\n    &:before {\n      width: 20px;\n      height: 60px;\n      animation: loader-39-2 0.8s linear infinite;\n    }\n\n    &:after {\n      width: 60px;\n      height: 20px;\n      animation: loader-39-2 1.2s linear infinite;\n    }\n  }\n\n  @keyframes loader-39-1 {\n    0% {\n      transform: rotate(0deg);\n    }\n\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n  @keyframes loader-39-2 {\n    0% {\n      box-shadow: 0.04em -0.04em 0 0.02em $warning-color;\n    }\n\n    25% {\n      box-shadow: 0.04em 0.04em 0 0.02em $warning-color;\n    }\n\n    50% {\n      box-shadow: -0.04em 0.04em 0 0.02em $warning-color;\n    }\n\n    75% {\n      box-shadow: -0.04em -0.04em 0 0.02em $warning-color;\n    }\n\n    100% {\n      box-shadow: 0.04em -0.04em 0 0.02em $warning-color;\n    }\n  }\n\n  .loader-40 {\n    border: 0.05em $danger-color solid;\n    border-radius: 0.2em;\n    overflow: hidden;\n    position: relative;\n\n    &:after,\n    &:before {\n      content: \"\";\n      border-radius: 50%;\n      position: absolute;\n      width: inherit;\n      height: inherit;\n      animation: loader-40 2s infinite linear;\n    }\n\n    &:before {\n      border-top: 0.2em $danger-color solid;\n      top: -0.15em;\n      left: calc(-50% - 0.15em);\n      transform-origin: right center;\n    }\n\n    &:after {\n      border-bottom: 0.2em $danger-color solid;\n      top: 0.15em;\n      right: calc(-50% - 0.15em);\n      transform-origin: left center;\n    }\n  }\n\n  @keyframes loader-40 {\n    from {\n      transform: rotate(0deg);\n    }\n\n    to {\n      transform: rotate(359deg);\n    }\n  }\n\n  .loader-41 {\n    border: 0.05em var(--theme-default) solid;\n    border-radius: 0.2em;\n    position: relative;\n    background: linear-gradient(45deg, transparent 48%, var(--theme-default) 50%, var(--theme-default) 50%, transparent 52%, transparent), linear-gradient(-45deg, transparent 48%, var(--theme-default) 50%, var(--theme-default) 50%, transparent 52%, transparent);\n    background-size: 0.5em 0.5em;\n    background-position: 0% 0%;\n    animation: loader-41 1s infinite linear;\n  }\n\n  @keyframes loader-41 {\n    from {\n      background-position: 0 0;\n    }\n\n    to {\n      background-position: -1em 0;\n    }\n  }\n\n  .loader-42 {\n    width: 2em;\n    height: 0.66em;\n    border: 0.05em var(--theme-secondary) solid;\n    border-radius: 0.1em;\n    background: linear-gradient(-60deg, transparent 0%, transparent 50%, var(--theme-secondary) 50%, var(--theme-secondary) 75%, transparent 75%, transparent);\n    background-size: 1em 2em;\n    background-position: 0 0;\n    animation: loader-42 0.8s infinite linear;\n  }\n\n  @keyframes loader-42 {\n    from {\n      background-position: 0 0;\n    }\n\n    to {\n      background-position: -2em 0;\n    }\n  }\n}\n\n/**=====================\n     04. Loader CSS Ends\n==========================**/\n","/**=====================\n     16. Popover CSS Start\n==========================**/\n.popover-header {\n  background-color: $dark-color;\n  color: $white;\n}\n.popover-main{\n  .btn-showcase{\n    a{\n      color: $white;\n    }\n    button{\n      &:last-child{\n        margin-right: 0;\n      }\n    }\n  }\n}\n/**=====================\n     16. Popover CSS Ends\n==========================**/","/**=====================\n     77. Print CSS Start\n==========================**/\n@media print {\n  .sidebar-wrapper, .page-header {\n    display: none;\n  }\n\n   .page-body {\n          margin: 0;\n        }\n.page-wrapper {\n    .page-title {\n      visibility: hidden;\n    }\n    .page-body-wrapper {\n      .page-title {\n        display: none;\n      }\n    }\n    &.compact-wrapper {\n      .page-body-wrapper {\n        .page-body {\n          margin: 0;\n        }\n      }\n    }\n  }\n  table.fixedHeader-floating {\n    display: none;\n  }\n}\n.invoice-table{\n  margin-top: 16px;\n  margin-bottom: 16px;\n}\n.invoice{\n  .text-right{\n    input{\n      margin-top: 6px;\n    }\n  }\n  .media {\n    align-items: center;\n  }\n}\n/**=====================\n    77. Print CSS Ends\n==========================**/\n","/**=====================\n     28. Radio CSS Start\n==========================**/\n.animate-chk {\n  label {\n    line-height: 1.6;\n    cursor: pointer;\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n}\n.checkbox_animated {\n  cursor: pointer;\n  position: relative;\n  margin: 0 1rem 0 0;\n  &:before {\n    transition: transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75);\n    transform: rotate(-45deg) scale(0, 0);\n    content: \"\";\n    position: absolute;\n    left: 0.25rem;\n    top: 0.225rem;\n    z-index: 1;\n    width: 0.75rem;\n    height: 0.375rem;\n    border: 2px solid var(--theme-default);\n    border-top-style: none;\n    border-right-style: none;\n  }\n  &:after {\n    content: \"\";\n    position: absolute;\n    top: -0.125rem;\n    left: 0;\n    width: 1.3rem;\n    height: 1.3rem;\n    background: $white;\n    border: 2px solid $light-gray;\n    cursor: pointer;\n  }\n  &:checked:before {\n    transform: rotate(-45deg) scale(1, 1);\n  }\n}\n.radio_animated {\n  position: relative;\n  margin: 0 1rem 0 0;\n  cursor: pointer;\n  &:before {\n    transition: transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75);\n    transform: scale(0, 0);\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0.125rem;\n    z-index: 1;\n    width: 0.75rem;\n    height: 0.75rem;\n    background: var(--theme-default);\n    border-radius: 50%;\n  }\n  &:after {\n    content: \"\";\n    position: absolute;\n    top: -0.25rem;\n    left: -0.125rem;\n    width: 1.25rem;\n    height: 1.25rem;\n    background: $white;\n    border: 2px solid $light-gray;\n    border-radius: 50%;\n  }\n  &:checked:before {\n    transform: scale(1, 1);\n  }\n}\n\n.checkbox {\n  label {\n    display: inline-block;\n    position: relative;\n    padding-left: 16px;\n    cursor: pointer;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    &::before {\n      content: \"\";\n      display: inline-block;\n      position: absolute;\n      width: 19px;\n      height: 19px;\n      left: 0;\n      margin-left: -16px;\n      border: 1px solid $light-semi-gray;\n      border-radius: 3px;\n      background-color: $white;\n      -webkit-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;\n      -o-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;\n      transition: border 0.15s ease-in-out, color 0.15s ease-in-out;\n    }\n    &::after {\n      display: inline-block;\n      position: absolute;\n      width: 16px;\n      height: 16px;\n      left: 0;\n      top: 0;\n      margin-left: -20px;\n      padding-left: 3px;\n      padding-top: 1px;\n      font-size: 11px;\n      color: $theme-font-color;\n    }\n  }\n  input[type=\"checkbox\"] {\n    opacity: 0;\n    &:focus {\n      outline-offset: -2px;\n      & + label {\n        &::before {\n          outline-offset: -2px;\n        }\n      }\n    }\n  }\n  input[type=\"checkbox\"] {\n    &:checked {\n      & + label {\n        &::before {\n          font-family: $font-themify;\n          content: \"\\e64c\";\n          text-align: center;\n          line-height: 1.2;\n        }\n      }\n    }\n    &:disabled {\n      & + label {\n        opacity: 0.65;\n        &::before {\n          background-color: $light-color;\n          cursor: not-allowed;\n        }\n      }\n    }\n  }\n  .checkbox-circle {\n    label {\n      &::before {\n        border-radius: 50%;\n      }\n    }\n  }\n  .checkbox-inline {\n    margin-top: 0;\n  }\n}\n.m-squar {\n  label {\n    &::before {\n      border-radius: 0;\n    }\n  }\n  .checkbox-circle {\n    label {\n      &::before {\n        border-radius: 50%;\n      }\n    }\n  }\n  .checkbox-inline {\n    margin-top: 0;\n  }\n}\n@each $btn-name, $btn-color in (primary, var(--theme-default)), (secondary, $secondary-color), (success, $success-color), (danger, $danger-color), (info, $info-color), (light, $light-color), (dark, $dark-color), (warning, $warning-color) {\n  .checkbox-#{$btn-name} {\n    label {\n      &::before {\n        border-color: $btn-color;\n      }\n    }\n    input[type=\"checkbox\"] {\n      &:checked {\n        & + label {\n          &::before {\n            border-color: $btn-color;\n            color: $btn-color;\n          }\n          &::after {\n            color: $white;\n          }\n        }\n      }\n    }\n  }\n  .checkbox-solid-#{$btn-name} {\n    label {\n      &:before {\n        background-color: $btn-color;\n        border-color: $btn-color;\n        color: $white;\n      }\n    }\n    input[type=\"checkbox\"] {\n      &:checked {\n        & + label {\n          &::before {\n            background-color: $btn-color;\n            border-color: $btn-color;\n            color: $white;\n          }\n          &::after {\n            color: $white;\n          }\n        }\n      }\n    }\n  }\n  .radio-#{$btn-name} {\n    input[type=\"radio\"] {\n      & + label {\n        &::before {\n          border-color: $btn-color;\n        }\n        &::after {\n          background-color: $btn-color;\n        }\n      }\n      &:checked {\n        & + label {\n          &::before {\n            border-color: $btn-color;\n          }\n          &::after {\n            background-color: $btn-color;\n          }\n        }\n      }\n    }\n  }\n}\n.m-checkbox-inline {\n  .checkbox {\n    display: inline-block;\n  }\n  .radio {\n    display: inline-block;\n  }\n  label {\n    margin-right: 20px;\n  }\n}\n.radio {\n  label {\n    display: inline-block;\n    position: relative;\n    padding-left: 5px;\n    cursor: pointer;\n    &::before {\n      content: \"\";\n      display: inline-block;\n      position: absolute;\n      width: 19px;\n      height: 19px;\n      left: 0;\n      margin-left: -20px;\n      border: 1px solid $light-semi-gray;\n      border-radius: 50%;\n      background-color: $white;\n      -webkit-transition: border 0.15s ease-in-out;\n      -o-transition: border 0.15s ease-in-out;\n      transition: border 0.15s ease-in-out;\n    }\n    &::after {\n      display: inline-block;\n      position: absolute;\n      content: \" \";\n      width: 9px;\n      height: 9px;\n      left: 5px;\n      top: 5px;\n      margin-left: -20px;\n      border-radius: 50%;\n      background-color: $dark-gray;\n      -webkit-transform: scale(0, 0);\n      -ms-transform: scale(0, 0);\n      -o-transform: scale(0, 0);\n      transform: scale(0, 0);\n      -webkit-transition: -webkit-transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);\n      -moz-transition: -moz-transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);\n      -o-transition: -o-transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);\n      transition: transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);\n    }\n  }\n  input[type=\"radio\"] {\n    opacity: 0;\n    &:focus {\n      & + label {\n        &::before {\n          outline-offset: -2px;\n        }\n      }\n    }\n    &:checked {\n      & + label {\n        &::after {\n          -webkit-transform: scale(1, 1);\n          -ms-transform: scale(1, 1);\n          -o-transform: scale(1, 1);\n          transform: scale(1, 1);\n        }\n      }\n    }\n    &:disabled {\n      & + label {\n        opacity: 0.65;\n        &::before {\n          cursor: not-allowed;\n        }\n      }\n    }\n  }\n  .radio-inline {\n    margin-top: 0;\n  }\n}\n/**=====================\n     28. Radio CSS Ends\n==========================**/\n","/**=====================\n    56.  Ribbon CSS Start\n==========================**/\n[class*=\"ribbon-wrapper\"]{\n  position: relative;\n  padding-top: 40px;\n}\n.ribbon {\n  padding: 0 20px;\n  height: 30px;\n  line-height: 30px;\n  clear: left;\n  position: absolute;\n  top: 12px;\n  left: 0px;\n  color: $white;\n  z-index:2;\n}\n.ribbon-clip{\n  left: -14px;\n  &:before{\n    position: absolute;\n    top: 30px;\n    left: 0;\n    width: 0;\n    height: 0;\n    content: \"\";\n    border: 7px solid transparent;\n    border-top-color: $dark-color;\n    border-right-color: $dark-color;\n  }\n}\n\n.ribbon-vertical-left-wrapper {\n  padding-left: 40px;\n  position: relative;\n}\n\n.ribbon-vertical-right-wrapper{\n  padding-right: 40px;\n}\n.ribbon-wrapper-bottom {\n  padding-bottom: 40px;\n  padding-top: 0;\n}\n.ribbon-wrapper-right-bottom {\n  padding-right: 40px;\n}\n\n.ribbon-space-bottom{\n  top:0px;\n}\n\n.ribbon-bookmark{\n  &:before {\n    position: absolute;\n    top: 0;\n    left: 100%;\n    display: block;\n    width: 0;\n    height: 0;\n    content: '';\n    border: 15px solid $dark-color;\n    border-right: 10px solid transparent;\n  }\n}\n.ribbon-right {\n  left: auto;\n  right: -2px;\n}\n.ribbon-clip-right{\n  right: -14px;\n  &:before{\n    position: absolute;\n    top: 30px;\n    right: 0;\n    width: 0;\n    height: 0;\n    content: \"\";\n    border: 7px solid transparent;\n    border-top-color: $dark-color;\n    border-right-color: $dark-color;\n  }\n}\n.ribbon-clip-bottom{\n  left: -14px;\n  bottom:12px;\n  top:auto;\n  &:before{\n    position: absolute;\n    bottom: 30px;\n    left: 0;\n    width: 0;\n    height: 0;\n    content: \"\";\n    border: 7px solid transparent;\n    border-top-color: $dark-color;\n    border-right-color: $dark-color;\n  }\n}\n.ribbon-clip-bottom-right{\n  right: -14px;\n  left:auto;\n  bottom:12px;\n  top:auto;\n  &:before{\n    position: absolute;\n    bottom: 30px;\n    right: 0;\n    width: 0;\n    height: 0;\n    content: \"\";\n    border: 7px solid transparent;\n    border-top-color: $dark-color;\n    border-right-color: $dark-color;\n  }\n}\n.ribbon-bookmark.ribbon-right:before {\n  right: 100%;\n  left: auto;\n  border-right: 15px solid $dark-color;\n  border-left: 10px solid transparent;\n}\n.ribbon-vertical-left {\n  clear: none;\n  padding: 0 5px;\n  height: 70px;\n  width: 30px;\n  line-height: 70px;\n  text-align: center;\n  left: 12px;\n  top: -2px;\n}\n.ribbon-vertical-right {\n  clear: none;\n  padding: 0 5px;\n  height: 70px;\n  width: 30px;\n  line-height: 70px;\n  text-align: center;\n  top: -2px;\n  left: auto;\n  right: 12px;\n}\n.ribbon-bookmark {\n  &.ribbon-vertical-left:before, &.ribbon-vertical-right:before {\n    top: 100%;\n    left: 0;\n    margin-top: -14px;\n    border-right: 15px solid $dark-color;\n    border-bottom: 10px solid transparent;\n  }\n}\n\n\n@each $ribbon-name, $ribbon-color in (primary, $primary-color),\n        (secondary, $secondary-color) ,\n        (success, $success-color),\n        (danger, $danger-color),\n        (info, $info-color),\n        (light, $light-color),\n        (dark, $dark-color),\n        (warning, $warning-color) {\n  .ribbon-#{$ribbon-name}{\n    background: $ribbon-color;\n  }\n  .ribbon-#{$ribbon-name} {\n    background: $ribbon-color;\n  }\n  .ribbon-bookmark {\n    &.ribbon-#{$ribbon-name}:before {\n      border-color: $ribbon-color;\n      border-right-color: transparent;\n    }\n    &.ribbon-right.ribbon-#{$ribbon-name}:before {\n      border-right-color: $ribbon-color;\n      border-left-color: transparent;\n    }\n    &.ribbon-vertical-left.ribbon-#{$ribbon-name}:before, &.ribbon-vertical-right.ribbon-#{$ribbon-name}:before {\n      border-right-color: $ribbon-color;\n      border-bottom-color: transparent;\n    }\n  }\n  .ribbon-#{$ribbon-name}.ribbon-corner {\n    &:before {\n      border-top-color: $ribbon-color;\n      border-left-color: $ribbon-color;\n    }\n    &.ribbon-right:before {\n      border-right-color: $ribbon-color;\n      border-left-color: transparent;\n    }\n    &.ribbon-bottom:before {\n      border-top-color: transparent;\n      border-bottom-color: $ribbon-color;\n    }\n  }\n  .ribbon-#{$ribbon-name}.ribbon-clip{\n    &:before{\n      border-color: transparent;\n      border-top-color: darken($ribbon-color, 10%);\n      border-right-color: darken($ribbon-color, 10%);\n    }\n  }\n  .ribbon-#{$ribbon-name}.ribbon-clip-right{\n    &:before{\n      border-right-color: transparent;\n      border-top-color: darken($ribbon-color, 10%);\n      border-left-color: darken($ribbon-color, 10%);\n    }\n  }\n  .ribbon-#{$ribbon-name}.ribbon-clip-bottom{\n    &:before{\n      border-top-color: transparent;\n      border-bottom-color: darken($ribbon-color, 10%);\n      border-right-color: darken($ribbon-color, 10%);\n    }\n  }\n  .ribbon-#{$ribbon-name}.ribbon-clip-bottom-right{\n    &:before{\n      border-top-color: transparent;\n      border-bottom-color: darken($ribbon-color, 10%);\n      border-right-color: transparent;\n      border-left-color: darken($ribbon-color, 10%);\n    }\n  }\n}\n/**=====================\n     56. Ribbon CSS Ends\n==========================**/","/**=====================\n    18. Switch  CSS Start\n==========================**/\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 60px;\n  height: 34px;\n\n  input {\n    display: none;\n\n    &:checked + .switch-state {\n      background-color: var(--theme-default);\n\n      &:before {\n        transform: translateX(26px);\n      }\n    }\n\n    &:focus + .switch-state {\n      box-shadow: 0 0 1px var(--theme-default);\n    }\n  }\n}\n\n.switch-state {\n  border-radius: 20px;\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: $light-color;\n  transition: 0.4s;\n\n  &:before {\n    position: absolute;\n    content: \"\";\n    height: 26px;\n    width: 26px;\n    left: 4px;\n    bottom: 4px;\n    background-color: $white;\n    transition: 0.4s;\n    border-radius: 20px;\n  }\n}\n\n.icon-state {\n  .switch-state {\n    &:after {\n      content: \"\\efb8\";\n      font-family: $font-ICO;\n      left: 10px;\n      position: absolute;\n      top: 10px;\n      color: $dark-color;\n      transition: 0.4s;\n      opacity: 0.3;\n    }\n  }\n\n  input {\n    &:checked + .switch-state {\n      &:after {\n        content: \"\\efad\";\n        left: 36px;\n        opacity: 1;\n        transition: 0.4s;\n      }\n    }\n  }\n}\n\n.switch-lg {\n  .switch {\n    width: 75px;\n    height: 40px;\n\n    .switch-state {\n      &:before {\n        height: 30px;\n        width: 30px;\n        left: 7px;\n        bottom: 5px;\n        top: 4px;\n      }\n    }\n  }\n}\n\n.switch-lg.icon-state {\n  .switch {\n    .switch-state {\n      &:after {\n        left: 12px;\n        font-size: 18px;\n      }\n    }\n\n    input {\n      &:checked + .switch-state {\n        &:after {\n          left: 47px;\n        }\n\n        &:before {\n          transform: translateX(32px);\n        }\n      }\n    }\n  }\n}\n\n.switch-sm {\n  &.icon-state {\n    .switch {\n      .switch-state {\n        &:after {\n          top: 4px;\n          left: 4px;\n          font-size: 8px;\n        }\n      }\n\n      input {\n        &:checked + .switch-state {\n          &:after {\n            left: 13px;\n            top: 4px;\n          }\n        }\n      }\n    }\n  }\n\n  .switch {\n    width: 25px;\n    height: 16px;\n    margin-top: 10px;\n    margin-bottom: 0px;\n\n    .switch-state {\n      &:before {\n        height: 8px;\n        width: 8px;\n        left: 4px;\n        bottom: 4px;\n      }\n    }\n  }\n\n  input {\n    &:checked + .switch-state {\n      &:before {\n        left: -13px;\n      }\n    }\n  }\n}\n\n.switch-outline {\n  .switch-state {\n    background-color: $white;\n    border: 1px solid var(--theme-default);\n    transition: 0.4s;\n\n    &:before {\n      background-color: $light-color;\n      bottom: 3px;\n      color: $white;\n    }\n  }\n}\n\n.switch-outline {\n  .switch {\n    input {\n      display: none;\n\n      &:checked + .switch-state {\n        background-color: $transparent-color;\n        border: 1px solid var(--theme-default);\n\n        &:before {\n          background-color: var(--theme-default);\n          bottom: 3px;\n          transform: translateX(26px);\n        }\n\n        &:after {\n          color: $white;\n        }\n      }\n    }\n  }\n}\n\n.switch-outline {\n  .switch-state.bg-primary {\n    border: 1px solid var(--theme-default);\n    background-color: $transparent-color !important;\n  }\n\n  .switch {\n    input {\n      &:checked + .switch-state.bg-primary {\n        background-color: $transparent-color !important;\n        border: 1px solid var(--theme-default);\n\n        &:before {\n          background-color: var(--theme-default);\n        }\n      }\n    }\n  }\n\n  .switch-state.bg-dark {\n    border: 1px solid $dark-color;\n    background-color: $transparent-color !important;\n  }\n\n  .switch {\n    input {\n      &:checked + .switch-state.bg-dark {\n        background-color: $transparent-color !important;\n        border: 1px solid $dark-color;\n\n        &:before {\n          background-color: $dark-color;\n        }\n      }\n    }\n  }\n\n  .switch-state.bg-warning {\n    border: 1px solid $warning-color;\n    background-color: $transparent-color !important;\n  }\n\n  .switch {\n    input {\n      &:checked + .switch-state.bg-warning {\n        background-color: $transparent-color !important;\n        border: 1px solid $warning-color;\n\n        &:before {\n          background-color: $warning-color;\n        }\n      }\n    }\n  }\n\n  .switch-state.bg-success {\n    border: 1px solid $success-color;\n    background-color: $transparent-color !important;\n  }\n\n  .switch {\n    input {\n      &:checked + .switch-state.bg-success {\n        background-color: $transparent-color !important;\n        border: 1px solid $success-color;\n\n        &:before {\n          background-color: $success-color;\n        }\n      }\n    }\n  }\n\n  .switch-state.bg-info {\n    border: 1px solid $info-color;\n    background-color: $transparent-color !important;\n  }\n\n  .switch {\n    input {\n      &:checked + .switch-state.bg-info {\n        background-color: $transparent-color !important;\n        border: 1px solid $info-color;\n\n        &:before {\n          background-color: $info-color;\n        }\n      }\n    }\n  }\n\n  .switch-state.bg-danger {\n    border: 1px solid $danger-color;\n    background-color: $transparent-color !important;\n  }\n\n  .switch {\n    input {\n      &:checked + .switch-state.bg-danger {\n        background-color: $transparent-color !important;\n        border: 1px solid $danger-color;\n\n        &:before {\n          background-color: $danger-color;\n        }\n      }\n    }\n  }\n\n  .switch-state.bg-primary {\n    border: 1px solid var(--theme-default);\n    background-color: $transparent-color !important;\n  }\n\n  .switch {\n    input {\n      &:checked + .switch-state.bg-primary {\n        background-color: $transparent-color !important;\n        border: 1px solid var(--theme-default);\n\n        &:before {\n          background-color: var(--theme-default);\n        }\n      }\n    }\n  }\n\n  .switch-state.bg-secondary {\n    border: 1px solid var(--theme-secondary);\n    background-color: $transparent-color !important;\n  }\n\n  .switch {\n    input {\n      &:checked + .switch-state.bg-secondary {\n        background-color: $transparent-color !important;\n        border: 1px solid var(--theme-secondary);\n\n        &:before {\n          background-color: var(--theme-secondary);\n        }\n      }\n    }\n  }\n}\n\n.switch-showcase {\n  margin-bottom: -8px;\n\n  .media {\n    line-height: 1;\n  }\n\n  .form-check {\n    .form-check-input {\n      float: right;\n    }\n  }\n}\n.form-switch {\n  .form-check-input {\n    &:checked {\n      background-color: var(--theme-default);\n      border-color: var(--theme-default);\n    }\n  }\n}\n\n/**=====================\n     18. Switch  CSS Ends\n==========================**/\n","/**=====================\n    44. Tabs CSS Start\n==========================**/\n.nav-pills {\n  .nav-link.active,\n  .show > .nav-link {\n    background-color: var(--theme-default);\n  }\n}\n.nav {\n  i {\n    margin-right: 10px;\n  }\n}\n\n.nav-right {\n  justify-content: flex-end;\n}\n\n$nav-name: theme, primary, secondary, success, danger, info, light, dark, warning;\n$nav-color: var(--theme-default), var(--theme-default), $secondary-color, $success-color, $danger-color, $info-color, $light-color, $dark-color, $warning-color;\n@each $var in $nav-name {\n  $i: index($label-name, $var);\n  .nav-#{$var},\n  .nav-pills.nav-#{$var} {\n    .nav-link {\n      color: nth($nav-color, $i);\n    }\n    .nav-link.active,\n    .show > .nav-link {\n      background-color: nth($nav-color, $i);\n      color: $white;\n    }\n  }\n}\n.nav-tabs.nav-bottom {\n  .nav-item {\n    .nav-link.active,\n    .nav-link.focus,\n    .nav-link.hover {\n      border-color: $white #dee2e6 #dee2e6;\n    }\n  }\n}\n.tab-content {\n  ~ .nav-tabs {\n    &.border-tab {\n      margin-bottom: 0;\n      margin-top: 30px;\n    }\n  }\n}\n// Material style css\n.border-tab.nav-tabs {\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n  margin-bottom: 30px;\n  .nav-item {\n    .nav-link {\n      font-size: 16px;\n      color: $dark-color;\n      text-align: center;\n      padding: 10px 25px;\n      border: none;\n      border-bottom: none;\n      transition: 0.3s;\n      &.active,\n      &.show,\n      &:focus,\n      &:hover {\n        color: var(--theme-default);\n      }\n      &.active,\n      &.show,\n      &:focus {\n        border-bottom: none;\n      }\n    }\n  }\n}\n.border-tab.nav-left {\n  .nav-link {\n    border-left: 2px solid transparent;\n    transition: all 0.3s ease;\n    color: $dark-color;\n  }\n  .nav-link.active,\n  .show > .nav-link {\n    background-color: transparent;\n    border-left-color: var(--theme-default);\n    color: var(--theme-default);\n    border-radius: 0;\n    transition: all 0.3s ease;\n  }\n}\n.border-tab.nav-right {\n  .nav-link {\n    border-right: 2px solid transparent;\n    transition: all 0.3s ease;\n    color: $dark-color;\n    text-align: right;\n  }\n  .nav-link.active,\n  .show > .nav-link {\n    background-color: transparent;\n    border-right-color: var(--theme-default);\n    color: var(--theme-default);\n    border-radius: 0;\n    transition: all 0.3s ease;\n  }\n}\n$m-nav-name: theme, primary, secondary, success, danger, info, light, dark, warning;\n$nav-color: var(--theme-default), var(--theme-default), $secondary-color, $success-color, $danger-color, $info-color, $light-color, $dark-color, $warning-color;\n@each $var in $m-nav-name {\n  $i: index($label-name, $var);\n  .border-tab.nav-#{$var} {\n    .nav-link.active,\n    .nav-item.show,\n    .nav-link:focus,\n    .nav-link:hover {\n      color: nth($nav-color, $i);\n      background-color: transparent;\n    }\n    .nav-item {\n      .nav-link {\n        transition: 0.3s;\n        &.active,\n        &.show,\n        &:focus {\n          border-bottom: 2px solid nth($nav-color, $i);\n        }\n        &.active,\n        &.show,\n        &:focus,\n        &:hover {\n          color: nth($nav-color, $i);\n        }\n      }\n    }\n  }\n  .border-tab.nav-left.nav-#{$var} {\n    .nav-link.active,\n    .show > .nav-link {\n      border-left-color: nth($nav-color, $i);\n      color: nth($nav-color, $i);\n    }\n  }\n  .border-tab.nav-right.nav-#{$var} {\n    .nav-link.active,\n    .show > .nav-link {\n      border-right-color: nth($nav-color, $i);\n      color: nth($nav-color, $i);\n    }\n  }\n}\n.tabbed-card {\n  ul {\n    position: absolute;\n    right: 22px;\n    top: 23px;\n    border-bottom: none;\n    &.border-tab {\n      &.nav-tabs {\n        top: 12px;\n        .nav-item {\n          float: right;\n          .nav-link {\n            padding: 23px 15px;\n          }\n        }\n      }\n    }\n  }\n}\n\n/**=====================\n     44. Tabs CSS Ends\n==========================**/\n","/**=====================\n    25. Table  CSS Start\n==========================**/\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: $light-gray;\n}\n.pills-component {\n  width: 20%;\n}\n.table {\n  margin-bottom: $table-b-margin;\n  > :not(:last-child) {\n    > :last-child {\n      > * {\n        border-bottom-color: $light-gray;\n      }\n    }\n  }\n  th,\n  td {\n    padding: 0.75rem;\n  }\n  &.table-primary {\n    th {\n      color: $white;\n    }\n    td {\n      color: $white;\n    }\n  }\n  thead {\n    &.bg-primary {\n      tr {\n        th {\n          color: $white;\n        }\n      }\n    }\n    &.table-primary {\n      tr {\n        th {\n          color: $primary-color;\n        }\n      }\n    }\n    &.table-success {\n      tr {\n        th {\n          color: $success-color;\n        }\n      }\n    }\n  }\n  tfoot {\n    &.table-success {\n      tr {\n        td,\n        th {\n          color: $success-color;\n        }\n      }\n    }\n  }\n  th {\n    color: $table-heading-color;\n    font-weight: 500;\n  }\n  td {\n    color: $table-row-color;\n  }\n\n  [class*='bg-'] {\n    color: $white;\n  }\n  .bg-light {\n    color: $theme-body-font-color;\n  }\n  tfoot {\n    font-weight: $table-footer-font-weight;\n  }\n}\n.table-striped {\n  &.table-styling {\n    > tbody {\n      > tr {\n        &:nth-of-type(odd) {\n          &:hover {\n            > * {\n              color: $primary-color;\n            }\n          }\n          > * {\n            --bs-table-accent-bg: none;\n            color: $white;\n          }\n        }\n      }\n    }\n  }\n  &.bg-primary {\n    > tbody {\n      > tr {\n        &:nth-of-type(odd) {\n          background-color: rgb(245 247 250 / 50%);\n          * {\n            color: $white;\n          }\n        }\n      }\n    }\n  }\n}\n.table-dark {\n  th {\n    color: $white;\n  }\n}\n.table-inverse {\n  color: $white;\n  background-color: $table-inverse-bg-color;\n  th,\n  td {\n    border-color: $white;\n    color: $white;\n  }\n  &.table-bordered {\n    border: 0;\n  }\n}\n.table[class*='bg-'] {\n  th,\n  td {\n    color: $white;\n  }\n}\n.table-hover {\n  > tbody {\n    > tr:hover {\n      --bs-table-accent-bg: unset;\n    }\n  }\n}\n.table-double {\n  border-left: 4px double #dee2e6;\n  border-right: 4px double #dee2e6;\n  thead,\n  tbody,\n  tfoot,\n  tr,\n  td,\n  th {\n    border-style: double;\n    border-width: 4px;\n    border-right: 0;\n    border-left: 0;\n  }\n}\n.table-dotted {\n  border-left: 2px dotted #dee2e6;\n  border-right: 2px dotted #dee2e6;\n  thead,\n  tbody,\n  tfoot,\n  tr,\n  td,\n  th {\n    border-style: dotted !important;\n    border-width: 2px;\n    border-right: 0;\n    border-left: 0;\n  }\n}\n.table-dashed {\n  border-left: 2px dashed #dee2e6;\n  border-right: 2px dashed #dee2e6;\n  thead,\n  tbody,\n  tfoot,\n  tr,\n  td,\n  th {\n    border-style: dashed !important;\n    border-width: 2px;\n    border-right: 0;\n    border-left: 0;\n  }\n}\n//Sizing class\n.table-xl {\n  td,\n  th {\n    padding: $table-xl-padding;\n    font-size: $table-xl-font;\n  }\n}\n.table-lg {\n  td,\n  th {\n    padding: $table-lg-padding;\n    font-size: $table-lg-font;\n  }\n}\n.table-de {\n  td,\n  th {\n    padding: $table-de-padding;\n  }\n}\n.table-sm {\n  th,\n  td {\n    padding: $table-sm-padding;\n    font-size: $table-sm-font;\n  }\n}\n.table-xs {\n  th,\n  td {\n    padding: $table-xs-padding;\n    font-size: $table-xs-font;\n  }\n}\n//Table Border\n.table-border-horizontal {\n  tr,\n  th,\n  td {\n    border-top: 1px solid $horizontal-border-color;\n    padding: 0.75rem;\n  }\n}\n.table-border-vertical {\n  tr,\n  th,\n  td {\n    border-top: 0;\n    border-right: 1px solid $horizontal-border-color;\n  }\n  tr {\n    td {\n      border-bottom: 0;\n\n      &:last-child {\n        border-right: none;\n      }\n    }\n  }\n  tbody {\n    tr {\n      th {\n        border-bottom: 0;\n      }\n    }\n  }\n}\n.table-bordernone {\n  td {\n    border: none !important;\n  }\n  thead {\n    th {\n      border: none !important;\n    }\n  }\n  .u-s-tb {\n    padding: 11px;\n  }\n}\n.table-striped {\n  tbody {\n    tr {\n      &:nth-of-type(odd) {\n        --bs-table-accent-bg: rgba(245, 247, 250, 0.5);\n      }\n    }\n  }\n}\n.table-bordered {\n  thead,\n  tbody,\n  tfoot,\n  tr,\n  td,\n  th {\n    border-color: $light-gray;\n  }\n}\n.grid-wrrapper {\n  .table-striped {\n    tbody {\n      tr {\n        &:nth-of-type(odd) {\n          background-color: rgba($primary-color, 0.1);\n          --bs-table-accent-bg: unset;\n          th,\n          td {\n            color: $primary-color;\n          }\n        }\n      }\n    }\n  }\n}\n/**=====================\n     25.Table CSS Ends\n==========================**/\n.w-20 {\n  width: 20px;\n}\n.h-20 {\n  height: 20px;\n}\n",".app-dark,\n.app-light {\n  display: flex;\n  justify-content: center;\n}\n.app-dark .react-timekeeper__clock-wrapper {\n  background-color: #7e7e7e;\n  padding: 18px 0;\n  .react-timekeeper-button-reset {\n    color: $theme-body-font-color !important;\n  }\n}\n.App .react-timekeeper__clock-wrapper > div:last-of-type {\n  padding: 0 10px;\n  position: relative;\n  z-index: 7;\n  top: 0;\n}\n.App .react-timekeeper__top-bar {\n  padding: 4px;\n}\n.App .react-timekeeper__top-bar .react-timekeeper__tb-minute-wrapper {\n  width: auto;\n}\n.App .react-timekeeper__top-bar * {\n  font-size: 22px !important;\n}\n.App .react-timekeeper__done-button {\n  padding: 12px;\n}\n.timepicker-form {\n  .react-timekeeper__clock {\n    ~ div {\n      z-index: 7;\n    }\n  }\n  .react-timekeeper__hand-circle-outer {\n    fill: var(--theme-default);\n  }\n  .react-timekeeper__clock-hand {\n    stroke: var(--theme-default);\n  }\n  .react-timekeeper__clock-wrapper {\n    .react-timekeeper-button-reset {\n      background-color: #e1eff6;\n    }\n  }\n  .react-timekeeper__top-bar {\n    background-color: var(--theme-default) !important;\n  }\n  .react-timekeeper__tb-hour,\n  .react-timekeeper__tb-colon,\n  .react-timekeeper__tb-minute,\n  .react-timekeeper-button-reset {\n    color: $white !important;\n  }\n  .row {\n    > div {\n      &:last-child {\n        .card {\n          .card-body {\n            .theme-form {\n              div.mb-0 {\n                display: flex;\n                justify-content: space-around;\n                .react-timekeeper {\n                  &:first-child {\n                    .react-timekeeper__top-bar {\n                      padding: 14px 8px;\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n@media screen and (max-width: 767px) {\n  .timepicker-form {\n    .row {\n      > div {\n        &:last-child {\n          .card {\n            .card-body {\n              .theme-form {\n                div.mb-0 {\n                  display: block;\n                  .react-timekeeper {\n                    display: block;\n                    margin: 0 auto;\n                    + .react-timekeeper {\n                      margin-top: 15px;\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n@media screen and (max-width: 360px) {\n  .timepicker-form {\n    .row {\n      > div {\n        &:last-child {\n          .card {\n            .card-body {\n              .theme-form {\n                div.mb-0 {\n                  .react-timekeeper {\n                    width: 240px !important;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n","/**=====================\n    20.  Touchspin  CSS Start\n==========================**/\n.bootstrap-touchspin {\n  input{\n    &.touchspin {\n      padding: 0 12px;\n    }\n  }\n  .input-group .btn{\n    padding: 0.5rem 1.75rem;\n  }\n  .touchspin-vertical-tab {\n    .input-group {\n      .input-group-btn-vertical {\n        position: relative;\n        white-space: nowrap;\n        width: 1%;\n        vertical-align: middle;\n        display: table-cell;\n        .bootstrap-touchspin-down {\n          margin-top: -2px;\n        }\n        i {\n          position: absolute;\n          top: 4px;\n          left: 7px;\n          font-size: 10px;\n          font-weight: normal;\n        }\n        > .btn {\n          display: block;\n          float: none;\n          width: 100%;\n          max-width: 100%;\n          padding: 9px;\n          margin-left: -1px;\n          position: relative;\n        }\n      }\n    }\n  }\n  .input-group{\n    font-family: $font-rubik, $font-serif;\n    .btn{\n      border-radius: 0 !important;\n    }\n  }\n  .dropdown-basic{\n    .dropdown{\n      .dropbtn{\n        padding: 9px 30px;\n      }\n      .dropdown-content{\n        z-index: 9999;\n      }\n    }\n  }\n}\n/**=====================\n     20. Touchspin  CSS Ends\n==========================**/\n","/**=====================\n     54. Tour  CSS Start\n==========================**/\n\n.introjs-helperLayer {\n  background-color: rgba(255, 255, 255, 0.9);\n  border: 1px solid rgba(0, 0, 0, 0.5);\n  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.4);\n}\n.introjs-tooltipReferenceLayer {\n  background-color: transparent;\n}\n.introjs-helperNumberLayer {\n  color: $white;\n  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);\n  background: $danger-color;\n  background: linear-gradient(to bottom, $tour-color 0%, $tour-color 100%);\n  border: 3px solid $white;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.4);\n}\n.introjs-arrow {\n  border: 12px solid $white;\n  &.top {\n    border-top-color: transparent;\n    border-right-color: transparent;\n    border-bottom-color: $tour-color;\n    border-left-color: transparent;\n  }\n  &.top-right {\n    border-top-color: transparent;\n    border-right-color: transparent;\n    border-bottom-color: $tour-color;\n    border-left-color: transparent;\n  }\n  &.top-middle {\n    border-top-color: transparent;\n    border-right-color: transparent;\n    border-bottom-color: $tour-color;\n    border-left-color: transparent;\n  }\n  &.right {\n    border-top-color: transparent;\n    border-right-color: transparent;\n    border-bottom-color: transparent;\n    border-left-color: $tour-color;\n  }\n  &.right-bottom {\n    border-top-color: transparent;\n    border-right-color: transparent;\n    border-bottom-color: transparent;\n    border-left-color: $tour-color;\n  }\n  &.bottom {\n    border-top-color: $tour-color;\n    border-right-color: transparent;\n    border-bottom-color: transparent;\n    border-left-color: transparent;\n  }\n  &.left {\n    border-top-color: transparent;\n    border-right-color: $tour-color;\n    border-bottom-color: transparent;\n    border-left-color: transparent;\n  }\n  &.left-bottom {\n    border-top-color: transparent;\n    border-right-color: $tour-color;\n    border-bottom-color: transparent;\n    border-left-color: transparent;\n  }\n}\n.introjs-tooltip {\n  background-color: $tour-color;\n  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.4);\n  color: $white;\n  border-color: $tour-color;\n}\n.introjs-button {\n  border: 1px solid $light-semi-gray;\n  text-shadow: 1px 1px 0 $white;\n  color: $theme-body-font-color !important;\n  background-color: $white;\n  background-image: linear-gradient($white, $white);\n  &:hover {\n    border-color: $light-semi-gray;\n  }\n  &:focus, &:active {\n    background-image: linear-gradient($light-gray, $light-semi-gray);\n  }\n}\n.introjs-skipbutton {\n  color: $tour-color;\n}\n.introjs-prevbutton {\n  &.introjs-fullbutton {\n    border: 1px solid $light-semi-gray;\n  }\n}\n.introjs-disabled {\n  color: $tour-color;\n  border-color: $light-semi-gray;\n  &:hover, &:focus {\n    color: $tour-color;\n    border-color: $light-semi-gray;\n  }\n}\n.introjs-bullets {\n  ul {\n    li {\n      a {\n        background: $light-gray;\n        &:hover {\n          background: $white;\n        }\n        &.active {\n          background: $white;\n        }\n      }\n    }\n  }\n}\n.introjs-progress {\n  background-color: $light-color;\n}\n.introjs-progressbar {\n  background-color: $tour-color;\n}\n.introjs-hint:hover > .introjs-hint-pulse {\n  border: 5px solid rgba(60, 60, 60, 0.57);\n}\n.introjs-hint-pulse {\n  border: 5px solid rgba(60, 60, 60, 0.27);\n  background-color: rgba(136, 136, 136, 0.24);\n}\n.introjs-hint-dot {\n  border: 10px solid rgba(146, 146, 146, 0.36);\n}\n/**=====================\n    54. Tour  CSS Ends\n==========================**/","/**=====================\n     typahead-search  CSS Start\n==========================**/\n.Typeahead {\n  width: 100%;\n\n  * {\n    box-sizing: border-box;\n\n    &:before {\n      box-sizing: border-box;\n    }\n\n    &:after {\n      box-sizing: border-box;\n    }\n  }\n\n  .tt-hint {\n    display: none !important;\n  }\n}\n\n.u-cf {\n  &:before {\n    content: \" \";\n    display: table;\n  }\n\n  &:after {\n    content: \" \";\n    display: table;\n    clear: both;\n  }\n}\n\n.u-hidden {\n  display: none !important;\n}\n\n.u-posRelative {\n  position: relative;\n}\n\n.Typeahead-spinner {\n  position: absolute;\n  top: 14px;\n  right: 18px;\n  display: none;\n  color: #c5c5c5;\n}\n\n.ProfileCard-avatar {\n  svg {\n    height: 18px;\n    vertical-align: bottom;\n\n    path {\n      color: #7e7c7c !important;\n    }\n\n    polygon {\n      color: #7e7c7c !important;\n    }\n  }\n}\n\n.Typeahead-hint {\n  width: 100%;\n  padding: 5px 8px;\n  font-size: 24px;\n  line-height: 30px;\n  border: 1px solid #024e6a;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  border-radius: 8px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  color: #ccd6dd;\n  opacity: 1;\n}\n\n.Typeahead-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  padding: 15px;\n  z-index: 100;\n  display: none;\n  width: 100%;\n  overflow: hidden;\n  background-color: $white;\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n}\n\n.Typeahead-menu.is-open {\n  display: block;\n}\n\n.Typeahead-selectable {\n  cursor: pointer;\n\n  + {\n    .Typeahead-selectable {\n      border-top: 1px solid #ccd6dd;\n    }\n  }\n}\n\n.ProfileCard {\n  position: relative;\n  padding: 10px;\n  border: 1px solid $gray-60 !important;\n  margin-bottom: 10px;\n  border-radius: 10px;\n\n  &:hover {\n    .ProfileCard-avatar {\n      border-color: #f5f8fa;\n    }\n\n    color: #414345;\n    background: #f8f8f8;\n\n    .ProfileCard-screenName {\n      color: $white;\n    }\n\n    .ProfileCard-stat-label {\n      color: $white;\n    }\n  }\n}\n\n.ProfileCard-avatar {\n  position: absolute;\n  border-radius: 5px;\n}\n\n.ProfileCard-details {\n  padding-left: 35px;\n  float: left;\n}\n\n.ProfileCard-realName {\n  display: inline-block;\n  color: $dark-gray;\n}\n\n.ProfileCard-screenName {\n  display: inline-block;\n  color: $dark-gray;\n}\n\n.ProfileCard-description {\n  margin-top: 5px;\n  font-size: 14px;\n  line-height: 18px;\n}\n\n.ProfileCard-stats {\n  float: right;\n  text-align: right;\n}\n\n.ProfileCard-stat {\n  display: inline-block;\n  font-size: 12px;\n  line-height: 16px;\n  text-transform: uppercase;\n\n  + {\n    .ProfileCard-stat {\n      margin-left: 5px;\n    }\n  }\n}\n\n.ProfileCard-stat-label {\n  color: $dark-gray;\n  font-weight: 500;\n}\n\n.ProfileCard.is-active {\n  color: $white;\n  background: var(--theme-default);\n\n  .ProfileCard-screenName {\n    color: $white;\n  }\n\n  .ProfileCard-stat-label {\n    color: $white;\n  }\n}\n\n.EmptyMessage {\n  position: relative;\n  padding: 10px;\n  font-size: 14px;\n  line-height: 30px;\n  text-align: center;\n}\n\n.Typeahead-spinner {\n  width: 1rem;\n  height: 1rem;\n}\n.Typeahead {\n  .stroke-icon {\n    stroke: $theme-body-font-color;\n  }\n  .fill-icon {\n    fill: $theme-body-font-color;\n  }\n  a {\n    color: $theme-body-font-color;\n  }\n  .header-search-suggestion {\n    max-height: 320px;\n    overflow: auto;\n  }\n}\nbody.dark-only {\n  .Typeahead {\n    .stroke-icon {\n      stroke: rgba($white, 0.6);\n    }\n    .fill-icon {\n      fill: rgba($white, 0.6);\n    }\n    a {\n      color: rgba($white, 0.6);\n    }\n  }\n}\n/**=====================\n    typahead-search CSS Ends\n==========================**/\n","/**=====================\n      90. React-Plugin CSS Start\n==========================**/\n.simple-list {\n  .list-group-item {\n    padding: 0;\n    border: none;\n    background-color: transparent;\n  }\n}\nbody.dark-only .page-wrapper .list-group:not(.simple-list) .list-group-item,\n.list-group-item {\n  padding: 0;\n  border: none;\n  background-color: transparent;\n}\nimg.media {\n  display: unset;\n  border: none;\n  margin-bottom: 0;\n}\nul.list-group {\n  display: block;\n  li.list-group-item.active {\n    background-color: $transparent-color;\n    border-color: $transparent-color;\n  }\n  img {\n    width: auto;\n    height: auto;\n  }\n  i {\n    margin-right: unset;\n  }\n}\n// slick\n.slick-page {\n  .slick-slider {\n    margin: -8px 0 20px;\n  }\n}\n\n.slick-slider {\n  margin: -7px 0 0;\n\n  .item {\n    &:focus {\n      outline: none;\n    }\n  }\n\n  .slick-dots {\n    li {\n      button {\n        &:before {\n          font-size: 12px;\n          color: var(--theme-default);\n        }\n      }\n\n      &.slick-active {\n        button {\n          &:before {\n            color: var(--theme-default);\n          }\n        }\n      }\n    }\n  }\n}\n\n// range slider\n.rangeslider-horizontal,\n.rangeslider-vertical {\n  .rangeslider__fill {\n    background-color: var(--theme-default) !important;\n  }\n\n  .rangeslider__handle {\n    &:focus {\n      outline: none;\n    }\n  }\n}\n\n.slider-vertical,\n.vertical-height {\n  .value {\n    text-align: center;\n  }\n}\n\n.rangeslider-vertical {\n  .rangeslider__labels {\n    margin: 0 0 0 32px !important;\n  }\n}\n\n.input-range__slider {\n  background: var(--theme-default);\n  border: 1px solid var(--theme-default);\n}\n\n.input-range__track--active {\n  background: var(--theme-default);\n}\n\n.input-range {\n  margin-bottom: 34px;\n}\n\n// dropzone\n.dzu-dropzone {\n  border: 2px dashed var(--theme-default) !important;\n  background: rgba($primary-color, 0.2);\n  overflow: auto !important;\n\n  .dz-message {\n    .note {\n      background-color: $transparent-color;\n    }\n  }\n}\n\n.dzu-inputLabel {\n  color: var(--theme-default) !important;\n  text-align: center;\n  margin-bottom: 0;\n}\n\n.dzu-previewContainer {\n  padding: 30px !important;\n  min-height: 115px;\n}\n\n.dzu-inputLabelWithFiles {\n  margin-left: 30px !important;\n  background-color: var(--theme-default) !important;\n  color: $white !important;\n}\n\n.dzu-submitButton {\n  background-color: var(--theme-default) !important;\n\n  &:disabled {\n    background-color: #e6e6e6 !important;\n  }\n}\n\n// Image Cropper\n.input-cropper {\n  margin-bottom: 15px;\n  border: 1px solid #ced4da;\n  padding: 10px;\n  border-radius: 4px;\n  width: auto;\n\n  input {\n    width: -webkit-fill-available;\n  }\n}\n\n.crop-portion {\n  margin-left: 0;\n  margin-top: 30px;\n  vertical-align: baseline;\n}\n\n.cropper-view-box {\n  outline-color: var(--theme-default);\n  outline: 1px solid var(--theme-default);\n}\n\n.cropper-point {\n  background-color: var(--theme-default);\n}\n\n// sticky\n.note {\n  background-color: rgba($primary-color, 0.3);\n\n  &:nth-child(2n) {\n    background: rgba($secondary-color, 0.3);\n  }\n}\n\n.react-stickies-wrapper {\n  .close {\n    &:before,\n    &:after {\n      background: $transparent-color !important;\n    }\n  }\n\n  .react-grid-layout {\n    .react-grid-item {\n      &:nth-child(1n) {\n        .note {\n          background: lighten($primary-color, 35%) !important;\n        }\n      }\n\n      &:nth-child(2n) {\n        .note {\n          background: lighten($secondary-color, 35%) !important;\n        }\n      }\n\n      &:nth-child(3n) {\n        .note {\n          background: lighten($success-color, 50%) !important;\n        }\n      }\n\n      &:nth-child(4n) {\n        .note {\n          background: lighten($info-color, 30%) !important;\n        }\n      }\n\n      &:nth-child(5n) {\n        .note {\n          background: lighten($warning-color, 35%) !important;\n        }\n      }\n\n      &:nth-child(6n) {\n        .note {\n          background: lighten($danger-color, 25%) !important;\n        }\n      }\n    }\n  }\n}\n\n// sweetalert\n.lead {\n  margin-bottom: 5px;\n}\n\n.swal2-container {\n  .swal2-actions {\n    .swal2-styled {\n      font-size: 14px;\n    }\n  }\n}\n\n.swal2-styled {\n  &.swal2-confirm {\n    background-color: var(--theme-default) !important;\n\n    &:focus {\n      box-shadow: 0 0 0 1px $white, 0 0 0 3px rgba($primary-color, 0.4);\n    }\n  }\n}\n\n.swal2-title {\n  font-size: 20px !important;\n}\n\n.swal2-progress-steps {\n  .swal2-progress-step,\n  .swal2-progress-step-line {\n    background: var(--theme-default) !important;\n  }\n\n  .swal2-progress-step {\n    &.swal2-active-progress-step {\n      background: var(--theme-default) !important;\n\n      ~ .swal2-progress-step,\n      ~ .swal2-progress-step-line {\n        background: rgba($primary-color, 0.2) !important;\n      }\n    }\n  }\n}\n\n// datetime picker\n.bootstrap-datetimepicker-widget {\n  tr {\n    th,\n    td {\n      &:active,\n      &.active {\n        background-color: var(--theme-default);\n      }\n\n      span {\n        &:active,\n        &.active {\n          background-color: var(--theme-default);\n        }\n      }\n    }\n  }\n}\n\n// upload\n.fileContainer {\n  padding: 0 !important;\n  margin: 0 !important;\n  box-shadow: none !important;\n\n  .files-gallery {\n    display: flex;\n    justify-content: center;\n\n    .files-gallery-item {\n      width: 45%;\n      display: flex;\n      margin: 0 auto;\n    }\n  }\n\n  .uploadPictureContainer {\n    margin: 1% !important;\n    padding: 10px;\n  }\n\n  .chooseFileButton {\n    margin-top: 0 !important;\n    padding: 6px 23px;\n    background: $secondary-color;\n    border-radius: 30px;\n    color: $white;\n    font-weight: 300;\n    font-size: 14px;\n    margin: 10px 0;\n    transition: all 0.2s ease-in;\n    cursor: pointer;\n    outline: none;\n    border: none;\n  }\n}\n\n// daterange picker\n.daterangepicker {\n  td,\n  th {\n    &.available {\n      &:hover {\n        background-color: var(--theme-default);\n      }\n    }\n  }\n}\n\n// to-do\n.todo {\n  .action-box {\n    &.large {\n      .icon {\n        .icon-trash,\n        .icon-check {\n          color: var(--theme-default);\n        }\n      }\n    }\n  }\n\n  .todo-list-wrapper {\n    #todo-list {\n      li {\n        &.completed {\n          .task-container {\n            .task-label {\n              color: var(--theme-default);\n            }\n          }\n        }\n      }\n    }\n  }\n\n  @-webkit-keyframes taskHighlighter {\n    0% {\n      background: rgba($primary-color, 0.5);\n    }\n\n    100% {\n      background: $white;\n    }\n  }\n\n  @keyframes taskHighlighter {\n    0% {\n      background: rgba($primary-color, 0.5);\n    }\n\n    100% {\n      background: $white;\n    }\n  }\n}\n\n// clock\n.react-clock__face {\n  border: 1px solid $white !important;\n}\n\n.react-clock__mark__body,\n.react-clock__hand__body {\n  background-color: $white !important;\n}\n\n// scrollable page\n.scrollarea {\n  max-width: 800px;\n  max-height: 300px;\n\n  .scrollbar-container {\n    z-index: 7 !important;\n  }\n}\n\n//form wizard\nol {\n  &.progtrckr {\n    list-style-type: none;\n    padding: 0;\n    display: flex;\n\n    li {\n      display: inline-block;\n      text-align: center;\n      line-height: 4.5rem;\n      cursor: pointer;\n      width: 100%;\n\n      span {\n        padding: 0 1.5rem;\n      }\n\n      &.progtrckr-doing {\n        color: black;\n        border-bottom: 4px solid #cccccc;\n\n        &:before {\n          content: \"\\2022\";\n          color: white;\n          background-color: #cccccc;\n          width: 1.2em;\n          line-height: 1.2em;\n          border-radius: 1.2em;\n        }\n\n        &:hover {\n          &:before {\n            color: #ff4500;\n          }\n        }\n      }\n\n      &.progtrckr-done {\n        color: black;\n        border-bottom: 4px solid #5cb85c;\n\n        &:before {\n          content: \"\\2713\";\n          color: white;\n          background-color: #5cb85c;\n          width: 1.2em;\n          line-height: 1.2em;\n          border-radius: 1.2em;\n        }\n\n        &:hover {\n          &:before {\n            color: #333;\n          }\n        }\n      }\n\n      &:after {\n        content: \"\\00a0\\00a0\";\n      }\n\n      &:before {\n        position: relative;\n        bottom: -3.7rem;\n        float: left;\n        left: 50%;\n      }\n\n      &.progtrckr-todo {\n        &:before {\n          content: \"\\039F\";\n          color: silver;\n          background-color: $transparent-color;\n          width: 1.2em;\n          line-height: 1.4em;\n        }\n\n        &:hover {\n          &:before {\n            color: #ff4500;\n          }\n        }\n      }\n    }\n  }\n}\n\n// calender\n.rbc-calendar {\n  height: 1000px !important;\n}\n\n#external-events {\n  position: absolute;\n  z-index: 2;\n  padding: 0 10px;\n  border: 1px solid #ccc;\n  background: #eee;\n  overflow: auto;\n\n  p {\n    strong {\n      font-size: 16px;\n    }\n  }\n}\n\n#external-events .fc-event {\n  margin: 1em 0;\n  cursor: move;\n}\n\n//   base-typeahead\n.rbt-token {\n  color: var(--theme-default) !important;\n  background-color: rgba($primary-color, 0.1) !important;\n\n  .rbt-token-remove-button {\n    top: 1px !important;\n  }\n}\n.rbt-aux {\n  .rbt-close {\n    margin-top: 0;\n  }\n}\n\n// time-picker\n.react_times_button {\n  .wrapper {\n    display: block;\n  }\n}\n\n.basic-calendar {\n  .demo-app-calendar {\n    .fc-daygrid-day-events {\n      .fc-event {\n        background-color: #7366ff;\n        border: 1px solid #7366ff;\n        color: white;\n        font-size: 11.9px;\n        padding: 0 10px;\n        .fc-daygrid-event-dot {\n          display: none;\n        }\n        .fc-event-time {\n          display: none;\n        }\n      }\n    }\n  }\n\n  .fc-scrollgrid {\n    a {\n      color: var(--body-font-color);\n    }\n  }\n  .calendar-basic #external-events {\n    background-color: $white;\n  }\n}\n\n.time_picker_wrapper2 {\n  display: flex;\n\n  .time_picker_container {\n    width: 44%;\n  }\n\n  .gap {\n    padding: 0 5px;\n  }\n}\n\n// toastr\n.Toastify__close-button {\n  font-weight: 500;\n\n  svg {\n    stroke: $white !important;\n    fill: $white !important;\n  }\n}\n\n.Toastify__toast--success {\n  background: lighten($success-color, 15%) !important;\n  color: $white !important;\n  font-weight: 500;\n\n  svg {\n    fill: transparent !important;\n    stroke: $white !important;\n  }\n\n  .Toastify__progress-bar {\n    background: lighten($success-color, 35%) !important;\n  }\n}\n\n.Toastify__toast--info {\n  background: lighten($info-color, 15%) !important;\n  color: $white !important;\n\n  svg {\n    fill: transparent !important;\n    stroke: $white !important;\n  }\n\n  .Toastify__progress-bar {\n    background: lighten($info-color, 35%) !important;\n  }\n}\n\n.Toastify__toast--warning {\n  background: lighten($warning-color, 5%) !important;\n  color: $white !important;\n\n  svg {\n    fill: transparent !important;\n    stroke: $white !important;\n  }\n\n  .Toastify__progress-bar {\n    background: lighten($warning-color, 15%) !important;\n  }\n}\n\n.Toastify__toast--error {\n  background: lighten($danger-color, 10%) !important;\n  color: $white !important;\n  font-weight: 500;\n\n  svg {\n    fill: transparent !important;\n    stroke: $white !important;\n  }\n\n  .Toastify__progress-bar {\n    background: lighten($danger-color, 20%) !important;\n  }\n}\n\n// draggable card\n.draggable-card {\n  > div {\n    > div {\n      width: 100%;\n      display: flex;\n\n      .react-kanban-column {\n        width: 100%;\n      }\n\n      .react-kanban-card {\n        min-width: 100%;\n        max-width: 100%;\n      }\n    }\n  }\n}\n\n.ui-sortable {\n  .react-kanban-board {\n    div[data-rbd-droppable-id=\"board-droppable\"] {\n      width: 100%;\n      display: flex;\n    }\n\n    .react-kanban-column {\n      width: 100%;\n    }\n\n    .react-kanban-card {\n      max-width: 100%;\n    }\n  }\n}\n\n.jkanban-container {\n  .custom-board {\n    .kanban-drag {\n      .react-kanban-column {\n        &:nth-child(2) {\n          div[data-rbd-drag-handle-context-id=\"1\"] {\n            background-color: $warning-color;\n\n            ~ div {\n              background-color: rgba($warning-color, 0.3);\n            }\n          }\n        }\n\n        &:nth-child(3) {\n          div[data-rbd-drag-handle-context-id=\"1\"] {\n            background-color: $success-color;\n\n            ~ div {\n              background-color: rgba($success-color, 0.3);\n            }\n          }\n        }\n      }\n\n      div[data-rbd-drag-handle-context-id=\"1\"] {\n        background-color: $info-color;\n        color: $white;\n        border-top-left-radius: 8px;\n        border-top-right-radius: 8px;\n\n        ~ div {\n          background-color: rgba($info-color, 0.3);\n          border-bottom-left-radius: 15px;\n          border-bottom-right-radius: 15px;\n        }\n\n        span {\n          font-weight: 500;\n        }\n\n        span.badge {\n          font-weight: 400;\n        }\n      }\n    }\n  }\n\n  .kanban-container {\n    display: flex;\n\n    .kanban-board {\n      width: 100%;\n    }\n\n    .kanban-item {\n      .customers {\n        ul.simple-list {\n          li {\n            background-color: $transparent-color;\n\n            + li {\n              img {\n                margin: 0;\n              }\n            }\n          }\n        }\n      }\n\n      &:focus {\n        outline: none;\n      }\n\n      .kanban-box {\n        border: 1px solid $light-semi-gray;\n        background-color: $white !important;\n        color: $theme-body-font-color;\n\n        &:focus {\n          outline: none;\n        }\n      }\n    }\n\n    .kanban-drag {\n      width: 100%;\n\n      .react-kanban-column-header {\n        font-weight: 500;\n\n        &:focus {\n          outline: none;\n        }\n\n        > div {\n          &:focus {\n            outline: none;\n          }\n        }\n      }\n\n      > div {\n        padding: 0;\n\n        > div {\n          display: flex;\n          width: 100%;\n          margin-bottom: -25px;\n\n          .react-kanban-column {\n            width: 98%;\n            background-color: $body-color;\n            border-radius: 8px;\n            padding: 0;\n            margin-bottom: 30px;\n\n            > div {\n              width: 100%;\n              padding: 20px;\n              font-size: 16px;\n              &[data-rbd-drag-handle-context-id=\"0\"],\n              &[data-rbd-drag-handle-context-id=\"2\"] {\n                border-bottom: 1px solid $light-semi-gray;\n              }\n              p {\n                font-weight: 400;\n              }\n\n              > div {\n                padding-bottom: 0;\n              }\n            }\n\n            .react-kanban-board {\n              > div {\n                width: 100%;\n              }\n\n              + .react-kanban-board {\n                margin-top: 20px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .react-kanban-column {\n    background-color: $body-color;\n\n    > div {\n      > div {\n        > div {\n          display: block !important;\n        }\n      }\n    }\n\n    div[tabindex=\"0\"] {\n      + div[tabindex=\"0\"] {\n        margin-top: 20px;\n      }\n    }\n  }\n}\n\n//DragNDrop\n.ui-sortable {\n  .container {\n    display: block;\n    width: 100%;\n    padding: 10px;\n    background-color: var(--theme-default);\n\n    div {\n      padding: 10px;\n      background-color: darken($primary-color, 1%);\n      transition: opacity 0.4s ease-in-out;\n      color: $white;\n    }\n\n    div {\n      cursor: move;\n      cursor: grab;\n      cursor: -moz-grab;\n      cursor: -webkit-grab;\n      margin-bottom: 10px;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n\n    &.ex-moved {\n      background-color: #e74c3c;\n    }\n\n    &.ex-over {\n      background-color: var(--theme-default);\n    }\n\n    &:nth-child(odd) {\n      background-color: var(--theme-default);\n    }\n  }\n}\n\n.gh-fork {\n  position: fixed;\n  top: 0;\n  right: 0;\n  border: 0;\n}\n\n.gu-mirror {\n  padding: 10px;\n  background-color: darken($primary-color, 5%);\n  transition: opacity 0.4s ease-in-out;\n  color: $white;\n  position: fixed !important;\n  margin: 0 !important;\n  z-index: 9999 !important;\n  opacity: 0.8;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=80)\";\n  filter: alpha(opacity=80);\n}\n\n.gu-hide {\n  display: none !important;\n}\n\n.gu-unselectable {\n  -webkit-user-select: none !important;\n  -moz-user-select: none !important;\n  -ms-user-select: none !important;\n  user-select: none !important;\n}\n\n.gu-transit {\n  opacity: 0.2;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=20)\";\n  filter: alpha(opacity=20);\n}\n\n.wrapper {\n  display: table;\n}\n\n.gu-mirror {\n  cursor: grabbing;\n  cursor: -moz-grabbing;\n  cursor: -webkit-grabbing;\n}\n\n.handle {\n  padding: 0 5px;\n  margin-right: 5px;\n  background-color: darken($primary-color, 15%);\n  cursor: move;\n}\n\n// timeline\n.vertical-timeline {\n  &::before {\n    background: $light-color;\n  }\n\n  .vertical-timeline-element {\n    p {\n      font-size: 13px !important;\n    }\n\n    .vertical-timeline-element-icon {\n      color: $white;\n    }\n\n    &:first-child,\n    &:nth-child(7) {\n      .vertical-timeline-element-icon {\n        background-color: var(--theme-default);\n      }\n    }\n\n    &:nth-child(2) {\n      .vertical-timeline-element-icon {\n        background-color: $secondary-color;\n      }\n    }\n\n    &:nth-child(3),\n    &:last-child {\n      .vertical-timeline-element-icon {\n        background-color: $success-color;\n      }\n    }\n\n    &:nth-child(4) {\n      .vertical-timeline-element-icon {\n        background-color: $info-color;\n      }\n    }\n\n    &:nth-child(5) {\n      .vertical-timeline-element-icon {\n        background-color: $warning-color;\n      }\n    }\n\n    &:nth-child(6) {\n      .vertical-timeline-element-icon {\n        background-color: $danger-color;\n      }\n    }\n  }\n}\n\n.vertical-timeline-element-content {\n  box-shadow: 1px 1px 2px 1px rgba($black, 0.08);\n  background-color: $light;\n\n  audio {\n    width: 100%;\n    margin-top: 15px;\n  }\n\n  .vertical-timeline-element-date {\n    font-size: 14px !important;\n  }\n\n  .vertical-timeline-element-content-arrow {\n    border-right: 7px solid $light-color;\n  }\n}\n\n.vertical-timeline--two-columns {\n  .vertical-timeline-element-content {\n    .vertical-timeline-element-date {\n      top: 10px !important;\n    }\n  }\n}\n\n.vertical-timeline--one-column {\n  &:before {\n    left: 28px !important;\n  }\n\n  .vertical-timeline-element-icon {\n    width: 60px;\n    height: 60px;\n  }\n\n  .vertical-timeline-element-content {\n    margin-left: 90px;\n\n    img {\n      width: 500px;\n    }\n\n    .vertical-timeline-element-date {\n      float: none;\n      display: block;\n    }\n  }\n}\n\n.rdt_Table {\n  .rdt_TableHead {\n    .rdt_TableHeadRow {\n      .rdt_TableCol {\n        &:nth-child(4) {\n          .rdt_TableCol_Sortable {\n            justify-content: center;\n\n            span {\n              display: none;\n            }\n          }\n        }\n\n        .rdt_TableCol_Sortable {\n          justify-content: flex-start;\n\n          > div {\n            font-weight: 500 !important;\n          }\n        }\n      }\n    }\n  }\n\n  .rdt_TableBody {\n    .rdt_TableRow {\n      .rdt_TableCell {\n        padding: 12px;\n\n        &:nth-child(4) {\n          justify-content: center !important;\n        }\n\n        + .rdt_TableCell {\n          justify-content: flex-start;\n        }\n      }\n    }\n  }\n}\n\n// leafleft map\n.leaflet-top,\n.leaflet-bottom {\n  z-index: 7 !important;\n}\n\n.leaflet-pane {\n  z-index: 1 !important;\n}\n\n// vector map\n.map-block {\n  svg {\n    g {\n      transform-origin: 0 0;\n    }\n  }\n}\n\n#gmap-simple {\n  svg {\n    path {\n      fill: var(--theme-default) !important;\n    }\n  }\n}\n\n#usa {\n  svg {\n    path {\n      fill: $secondary-color !important;\n    }\n  }\n}\n\n#canada {\n  svg {\n    path {\n      fill: $success-color !important;\n    }\n  }\n}\n\n#asia {\n  svg {\n    path {\n      fill: $warning-color !important;\n    }\n  }\n}\n\n#europe {\n  svg {\n    path {\n      fill: $danger-color !important;\n    }\n  }\n}\n\n#america {\n  svg {\n    path {\n      fill: $dark-color !important;\n    }\n  }\n}\n.ace_editor {\n  width: auto !important;\n  overflow: auto;\n}\n.carousal {\n  .slick-slider {\n    .slick-slide {\n      margin-right: 15px;\n    }\n  }\n}\n.jvectormap-zoomin,\n.jvectormap-zoomout {\n  width: 20px;\n  height: 20px;\n}\n\n.jvectormap-zoomin {\n  bottom: 65px;\n}\n\n.jvectormap-zoomout {\n  bottom: 30px;\n}\n\n.jvectormap-zoomin,\n.jvectormap-zoomout,\n.jvectormap-goback {\n  position: absolute;\n  border-radius: 3px;\n  background: #292929;\n  padding: 5px;\n  color: #fff;\n  cursor: pointer;\n  text-align: center;\n  box-sizing: content-box;\n}\n\n// rating\n.rating {\n  align-items: center;\n\n  span {\n    .fa {\n      color: var(--theme-default);\n    }\n\n    span {\n      span {\n        color: var(--theme-default);\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .jkanban-container {\n    .kanban-container {\n      .kanban-drag {\n        padding: 0;\n\n        > div {\n          width: 100% !important;\n\n          > div {\n            div[data-rbd-drag-handle-context-id=\"1\"] {\n              width: 100% !important;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n.page-wrapper .page-header .header-wrapper {\n  .bookmark-flip {\n    width: unset !important;\n    box-shadow: unset !important;\n    background-color: transparent !important;\n    overflow: initial;\n    .Typeahead-menu {\n      background-color: transparent !important;\n      box-shadow: none;\n      left: -1px;\n      max-height: 85px;\n      overflow: auto;\n      top: 75px;\n      .ProfileCard-realName {\n        width: 100%;\n      }\n      .ProfileCard-details {\n        float: unset;\n        text-align: left;\n      }\n\n      .ProfileCard {\n        border: none !important;\n        padding: 8px;\n        position: relative;\n        margin: 0;\n        &:hover {\n          background-color: var(--chart-border);\n        }\n        .realname {\n          text-transform: capitalize !important;\n          text-decoration: none;\n        }\n        .pull-right {\n          margin-left: auto;\n        }\n      }\n    }\n  }\n  .flip-card {\n    width: 220px;\n    height: 245px;\n    background-color: transparent;\n    .flip-card-inner {\n      position: relative;\n      height: 100%;\n      text-align: center;\n      transition: transform 0.6s;\n      transform-style: preserve-3d;\n      .back {\n        position: absolute;\n        backface-visibility: hidden;\n        border-radius: 10px;\n        overflow: hidden;\n        box-shadow: 0 0 20px rgba(89, 102, 122, 0.1);\n        width: 220px;\n        height: auto;\n        button {\n          background-color: $transparent-color;\n          color: $primary-color;\n          border: none;\n          &:focus {\n            outline: $transparent-color;\n          }\n        }\n      }\n\n      .back {\n        background-color: $white;\n        transform: rotateY(180deg);\n        li {\n          &:first-child {\n            height: 160px !important;\n            margin-top: 0 !important;\n          }\n          &:last-child {\n            padding: 20px 0;\n            border-top: 1px solid var(--chart-border);\n          }\n        }\n        button {\n          width: 100%;\n        }\n        .flip-back-content {\n          .Typeahead-menu {\n            max-height: 85px;\n          }\n          input {\n            border-radius: 8px;\n            padding: 6px 12px;\n            width: 100%;\n            border: 1px solid var(--chart-border);\n            &:focus {\n              outline: unset;\n            }\n          }\n        }\n      }\n      &.flipped {\n        transform: rotateY(180deg);\n        .front {\n          opacity: 0;\n        }\n      }\n    }\n  }\n}\n\n.default-datepicker {\n  .rdp {\n    margin: 0;\n    &-caption_label {\n      padding: 0;\n    }\n    &-nav {\n      &_button {\n        padding: 0;\n        background: transparent !important;\n        width: unset;\n        height: unset;\n        svg {\n          width: 11px;\n          height: 11px;\n        }\n      }\n    }\n    &-caption_label {\n      color: #2b2b2b;\n      font-size: 20px;\n      font-weight: 500;\n    }\n    &-head_cell {\n      span {\n        color: #2b2b2b;\n        font-size: 14px;\n        font-weight: bold;\n      }\n    }\n  }\n}\n\n/**=====================\n      90. React-Plugin CSS Ends\n==========================**/\n\n.product-table {\n  &.table-bordernone {\n    .rdt_Table {\n      border: 1px solid var(--chart-border);\n      .rdt_TableHead {\n        .rdt_TableHeadRow {\n          border: none;\n          .rdt_TableCol {\n            border: none;\n          }\n        }\n      }\n      .rdt_TableBody {\n        .rdt_TableRow {\n          border: none;\n        }\n      }\n    }\n  }\n  &.orderHistoryTable {\n    .order-process {\n      color: $theme-font-color;\n      font-weight: 400;\n    }\n    .rdt_TableBody {\n      .rdt_TableCell {\n        div {\n          color: var(--body-font-color);\n          font-weight: 400;\n          font-size: 14px;\n        }\n      }\n    }\n  }\n  .gKbhqU {\n    border: none;\n  }\n  .rdt_Table {\n    border: 1px solid var(--chart-border);\n  }\n  .rdt_TableHead {\n    .rdt_TableHeadRow {\n      .rdt_TableCol {\n        border: none;\n        h6 {\n          margin: 0;\n        }\n      }\n    }\n  }\n\n  .rdt_TableHeadRow .rdt_TableCol {\n    vertical-align: middle;\n    border-top: none;\n    border: 1px solid var(--chart-border);\n    font-size: 16px;\n    font-weight: 600;\n  }\n  .rdt_TableHeadRow .rdt_TableCol,\n  .rdt_TableBody .rdt_TableRow .rdt_TableCell {\n    padding: 0.75rem;\n  }\n\n  .rdt_TableBody {\n    .rdt_TableRow {\n      &:nth-child(odd) {\n        background-color: rgb(246 246 246);\n        border-color: var(--chart-border);\n      }\n      &:nth-child(even) {\n        background-color: #fff;\n        border-color: var(--chart-border);\n      }\n      &:hover {\n        background-color: rgb(246 246 246);\n      }\n      .rdt_TableCell {\n        vertical-align: middle;\n        color: $light-text;\n        font-weight: 600;\n        .product-name {\n          a {\n            font-size: 15px;\n            color: $dark-gray;\n            line-height: 25px;\n          }\n          .order-process {\n            font-size: 13px;\n            padding-left: 15px;\n\n            .order-process-circle {\n              position: relative;\n              &:before {\n                position: absolute;\n                content: \"\";\n                width: 4px;\n                height: 4px;\n                border-radius: 100%;\n                background-color: $dark-gray;\n                left: -15px;\n                top: 6px;\n              }\n\n              &.shipped-order {\n                &:before {\n                  background-color: $success-color;\n                }\n              }\n\n              &.cancel-order {\n                &:before {\n                  background-color: $danger-color;\n                }\n              }\n            }\n          }\n        }\n        &.total-amount {\n          color: $theme-body-font-color;\n        }\n      }\n    }\n  }\n\n  .product-name {\n    h6 {\n      color: $theme-body-font-color;\n      margin-bottom: unset;\n      font-size: 14px;\n    }\n    span {\n      color: $theme-body-font-color;\n    }\n  }\n}\n\n.email-compose {\n  .cke_chrome {\n    border: none;\n  }\n  .cke_top {\n    border: none;\n    padding-left: 0;\n    padding-right: 0;\n    background-color: transparent;\n  }\n  .cke_bottom {\n    display: none;\n  }\n}\n\n.theme-text {\n  color: var(--body-font-color);\n}\n\n.focuse-none {\n  &:focus {\n    border: none;\n    box-shadow: none;\n    outline: unset;\n  }\n}\n\n.input-group-text-none {\n  .input-group-text {\n    display: none;\n  }\n}\n\n.img-40 {\n  width: 40px;\n  height: 40px;\n}\n.deni-react-treeview-container.classic {\n  width: 100%;\n  .deni-react-treeview-item-container.classic {\n    .treeview-item-example {\n      display: flex;\n    }\n    .actionButton {\n      margin-left: 6px;\n    }\n  }\n}\nbody.dark-only {\n  .gYaFyO {\n    border-bottom: var(--chart-border);\n    &:hover {\n      border-color: var(--chart-border);\n    }\n  }\n  .qty-box {\n    .input-group-prepend {\n      padding: 0;\n    }\n  }\n}\n\n.datetime-picker {\n  .input-group {\n    flex-wrap: unset;\n  }\n  .react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {\n    right: 96px;\n  }\n}\n.react-datepicker__day--keyboard-selected,\n.react-datepicker__month-text--keyboard-selected,\n.react-datepicker__quarter-text--keyboard-selected,\n.react-datepicker__year-text--keyboard-selected {\n  background-color: $primary-color;\n}\n.react-datepicker__day--selected,\n.react-datepicker__day--in-selecting-range,\n.react-datepicker__day--in-range,\n.react-datepicker__month-text--selected,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--selected,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--selected,\n.react-datepicker__year-text--in-selecting-range,\n.react-datepicker__year-text--in-range {\n  background-color: $primary-color;\n}\n.react-datepicker__day--selected:hover,\n.react-datepicker__day--in-selecting-range:hover,\n.react-datepicker__day--in-range:hover,\n.react-datepicker__month-text--selected:hover,\n.react-datepicker__month-text--in-selecting-range:hover,\n.react-datepicker__month-text--in-range:hover,\n.react-datepicker__quarter-text--selected:hover,\n.react-datepicker__quarter-text--in-selecting-range:hover,\n.react-datepicker__quarter-text--in-range:hover,\n.react-datepicker__year-text--selected:hover,\n.react-datepicker__year-text--in-selecting-range:hover,\n.react-datepicker__year-text--in-range:hover {\n  background-color: $primary-color;\n}\n.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range),\n.react-datepicker__month-text--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range),\n.react-datepicker__quarter-text--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range),\n.react-datepicker__year-text--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range) {\n  background-color: rgba($primary-color, 0.2);\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n  background-color: $primary-color;\n}\n.react-datepicker__close-icon {\n  &::after {\n    background-color: $primary-color;\n  }\n}\n.date-range-picker {\n  .daterange-card {\n    padding-bottom: 10px;\n  }\n  .react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {\n    right: 96px;\n  }\n}\n.date-picker .cal-date-widget {\n  .react-datepicker {\n    border: none;\n    padding: 8px 16px 0;\n    width: 100%;\n  }\n  .react-datepicker__navigation {\n    top: 20px;\n  }\n  .react-datepicker__day--keyboard-selected {\n    background-color: $primary-color;\n  }\n  .react-datepicker__navigation-icon {\n    &::before {\n      border-width: 2px 2px 0 0;\n      width: 8px;\n      height: 8px;\n    }\n  }\n  .react-datepicker__day-name,\n  .react-datepicker__day,\n  .react-datepicker__time-name {\n    height: 32px;\n  }\n  .react-datepicker__day--outside-month {\n    color: $gray-60;\n  }\n  .react-datepicker__day,\n  .react-datepicker__month-text,\n  .react-datepicker__quarter-text,\n  .react-datepicker__year-text {\n    &:hover {\n      background-color: $primary-color;\n      color: $white;\n    }\n  }\n}\n.react-datepicker {\n  border: 1px solid $light-semi-gray;\n}\n.react-datepicker__header {\n  background-color: $white;\n  border: none;\n}\n.react-datepicker__navigation {\n  background-color: $primary-color;\n  border-radius: 20px;\n  color: $white;\n  top: 13px;\n  &.react-datepicker__navigation--previous {\n    left: 4px;\n  }\n  &.react-datepicker__navigation--next {\n    right: 4px;\n  }\n}\n.react-datepicker__day--selected {\n  background-color: $primary-color;\n  border-radius: 10px;\n  &:hover {\n    background-color: $primary-color;\n  }\n}\n.react-datepicker__navigation-icon--next {\n  left: -3px;\n}\n.react-datepicker__navigation-icon {\n  top: 0px;\n}\n.react-datepicker__current-month,\n.react-datepicker-time__header,\n.react-datepicker-year-header {\n  color: $primary-color;\n  padding: 10px 10px 20px;\n}\n.react-datepicker__navigation-icon--previous {\n  right: 0;\n}\n.react-datepicker__day-name {\n  font-weight: bold;\n}\n.react-datepicker__week,\n.react-datepicker__day {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.react-datepicker__navigation-icon--next,\n.react-datepicker__navigation-icon--previous {\n  &::before {\n    top: 10px;\n    left: -3px;\n    border-color: $white;\n  }\n}\n.react-datepicker-popper[data-placement^=\"top\"],\n.react-datepicker-popper[data-placement^=\"bottom\"] {\n  .react-datepicker__triangle {\n    margin-left: -10px;\n  }\n}\n.support-table {\n  .rdt_Table {\n    .rdt_TableHead {\n      .rdt_TableHeadRow {\n        .rdt_TableCol:nth-child(4) {\n          .rdt_TableCol_Sortable {\n            justify-content: flex-start;\n          }\n        }\n      }\n    }\n    .rdt_TableBody {\n      .rdt_TableRow {\n        border-color: var(--chart-border);\n        .rdt_TableCell:nth-child(4) {\n          justify-content: start !important;\n        }\n      }\n    }\n  }\n}\n\n.loader-wrapper.loderhide {\n  display: none;\n}\n","/* Slider test*/\n\n.slick-slider {\n  position: relative;\n  display: block;\n  box-sizing: border-box;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -ms-touch-action: pan-y;\n  touch-action: pan-y;\n  -webkit-tap-highlight-color: transparent;\n}\n.slick-list {\n  position: relative;\n  overflow: hidden;\n  display: block;\n  margin: 0;\n  padding: 0;\n\n  &:focus {\n    outline: none;\n  }\n\n  &.dragging {\n    cursor: pointer;\n    cursor: hand;\n  }\n}\n.slick-slider .slick-track,\n.slick-slider .slick-list {\n  -webkit-transform: translate3d(0, 0, 0);\n  -moz-transform: translate3d(0, 0, 0);\n  -ms-transform: translate3d(0, 0, 0);\n  -o-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n}\n\n.slick-track {\n  position: relative;\n  left: 0;\n  top: 0;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n\n  &:before,\n  &:after {\n    content: '';\n    display: table;\n  }\n\n  &:after {\n    clear: both;\n  }\n\n  .slick-loading & {\n    visibility: hidden;\n  }\n}\n.slick-slide {\n  float: left;\n  height: 100%;\n  min-height: 1px;\n  [dir='rtl'] & {\n    float: right;\n  }\n  img {\n    display: block;\n  }\n  &.slick-loading img {\n    display: none;\n  }\n\n  display: none;\n\n  &.dragging img {\n    pointer-events: none;\n  }\n\n  .slick-initialized & {\n    display: block;\n  }\n\n  .slick-loading & {\n    visibility: hidden;\n  }\n\n  .slick-vertical & {\n    display: block;\n    height: auto;\n    border: 1px solid transparent;\n  }\n}\n.slick-arrow.slick-hidden {\n  display: none;\n}\n","@charset \"UTF-8\";\n\n// Default Variables\n\n// Slick icon entity codes outputs the following\n// \"\\2190\" outputs ascii character \"←\"\n// \"\\2192\" outputs ascii character \"→\"\n// \"\\2022\" outputs ascii character \"•\"\n\n$slick-font-path: \"../../fonts/\" !default;\n$slick-font-family: \"slick\" !default;\n$slick-loader-path: \"../\" !default;\n$slick-arrow-color: white !default;\n$slick-dot-color: black !default;\n$slick-dot-color-active: $slick-dot-color !default;\n$slick-prev-character: \"\\2190\" !default;\n$slick-next-character: \"\\2192\" !default;\n$slick-dot-character: \"\\2022\" !default;\n$slick-dot-size: 6px !default;\n$slick-opacity-default: 0.75 !default;\n$slick-opacity-on-hover: 1 !default;\n$slick-opacity-not-active: 0.25 !default;\n\n@function slick-image-url($url) {\n  @if function-exists(image-url) {\n    @return image-url($url);\n  } @else {\n    @return url($slick-loader-path + $url);\n  }\n}\n\n@function slick-font-url($url) {\n  @if function-exists(font-url) {\n    @return font-url($url);\n  } @else {\n    @return url($slick-font-path + $url);\n  }\n}\n\n\n/* Icons */\n@if $slick-font-family == \"slick\" {\n  @font-face {\n    font-family: \"slick\";\n    src: slick-font-url(\"slick.eot\");\n    src: slick-font-url(\"slick.eot?#iefix\") format(\"embedded-opentype\"),\n      slick-font-url(\"slick.woff\") format(\"woff\"),\n      slick-font-url(\"slick.ttf\") format(\"truetype\"),\n      slick-font-url(\"slick.svg#slick\") format(\"svg\");\n    font-weight: normal;\n    font-style: normal;\n  }\n}\n\n/* Arrows */\n\n.slick-prev,\n.slick-next {\n  position: absolute;\n  display: block;\n  height: 20px;\n  width: 20px;\n  line-height: 0px;\n  font-size: 0px;\n  cursor: pointer;\n  background: transparent;\n  color: transparent;\n  top: 50%;\n  -webkit-transform: translate(0, -50%);\n  -ms-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n  padding: 0;\n  border: none;\n  outline: none;\n  &:hover,\n  &:focus {\n    outline: none;\n    background: transparent;\n    color: transparent;\n    &:before {\n      opacity: $slick-opacity-on-hover;\n    }\n  }\n  &.slick-disabled:before {\n    opacity: $slick-opacity-not-active;\n  }\n  &:before {\n    font-family: $slick-font-family;\n    font-size: 20px;\n    line-height: 1;\n    color: $slick-arrow-color;\n    opacity: $slick-opacity-default;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n}\n\n.slick-prev {\n  left: -25px;\n  [dir=\"rtl\"] & {\n    left: auto;\n    right: -25px;\n  }\n  &:before {\n    content: $slick-prev-character;\n    [dir=\"rtl\"] & {\n      content: $slick-next-character;\n    }\n  }\n}\n\n.slick-next {\n  right: -25px;\n  [dir=\"rtl\"] & {\n    left: -25px;\n    right: auto;\n  }\n  &:before {\n    content: $slick-next-character;\n    [dir=\"rtl\"] & {\n      content: $slick-prev-character;\n    }\n  }\n}\n\n/* Dots */\n\n.slick-dotted.slick-slider {\n  margin-bottom: 30px;\n}\n\n.slick-dots {\n  position: absolute;\n  bottom: -25px;\n  list-style: none;\n  display: block;\n  text-align: center;\n  padding: 0;\n  margin: 0;\n  width: 100%;\n  li {\n    position: relative;\n    display: inline-block;\n    height: 20px;\n    width: 20px;\n    margin: 0 5px;\n    padding: 0;\n    cursor: pointer;\n    button {\n      border: 0;\n      background: transparent;\n      display: block;\n      height: 20px;\n      width: 20px;\n      outline: none;\n      line-height: 0px;\n      font-size: 0px;\n      color: transparent;\n      padding: 5px;\n      cursor: pointer;\n      &:hover,\n      &:focus {\n        outline: none;\n        &:before {\n          opacity: $slick-opacity-on-hover;\n        }\n      }\n      &:before {\n        position: absolute;\n        top: 0;\n        left: 0;\n        content: $slick-dot-character;\n        width: 20px;\n        height: 20px;\n        font-family: $slick-font-family;\n        font-size: $slick-dot-size;\n        line-height: 20px;\n        text-align: center;\n        color: $slick-dot-color;\n        opacity: $slick-opacity-not-active;\n        -webkit-font-smoothing: antialiased;\n        -moz-osx-font-smoothing: grayscale;\n      }\n    }\n    &.slick-active button:before {\n      color: $slick-dot-color-active;\n      opacity: $slick-opacity-default;\n    }\n  }\n}\n","/*=============Scrollable css start=============*/\n\n%scroll-xy {\n  background-color: $transparent-color;\n  display: block;\n}\n.scroll-demo {\n  padding: 10px;\n  position: relative;\n  border: 1px solid $light-color;\n  overflow: auto;\n  height: 300px;\n  .horz-scroll-content {\n    width: 1600px;\n  }\n}\n.ps-container {\n  touch-action: none;\n  overflow: hidden !important;\n  &.ps-in-scrolling {\n    pointer-events: none;\n    &.ps-x > .ps-scrollbar-x-rail {\n      background-color: $light-color;\n      opacity: 0.9;\n      > .ps-scrollbar-x {\n        background-color: $semi-dark;\n      }\n    }\n    &.ps-y > .ps-scrollbar-y-rail {\n      background-color: $light-color;\n      opacity: 0.9;\n      > .ps-scrollbar-y {\n        background-color: $semi-dark;\n      }\n    }\n  }\n  > {\n    .ps-scrollbar-x-rail {\n      display: none;\n      position: absolute;\n      border-radius: 4px;\n      opacity: 0;\n      transition: background-color 0.2s linear, opacity 0.2s linear;\n      bottom: 3px;\n      height: 8px;\n      > .ps-scrollbar-x {\n        position: absolute;\n        background-color: $semi-dark;\n        border-radius: 4px;\n        transition: background-color 0.2s linear;\n        bottom: 0;\n        height: 8px;\n      }\n    }\n    .ps-scrollbar-y-rail {\n      right: 3px;\n      width: 8px;\n      display: none;\n      position: absolute;\n      border-radius: 4px;\n      opacity: 0;\n      transition: background-color 0.2s linear, opacity 0.2s linear;\n      > .ps-scrollbar-y {\n        width: 10px;\n        position: absolute;\n        background-color: $semi-dark;\n        border-radius: 4px;\n        transition: background-color 0.2s linear;\n        right: 0;\n      }\n    }\n  }\n  &:hover {\n    &.ps-in-scrolling {\n      pointer-events: none;\n      &.ps-x > .ps-scrollbar-x-rail {\n        background-color: $semi-dark;\n        opacity: 0.9;\n        > .ps-scrollbar-x {\n          width: 128px;\n          background-color: lighten($black, 60%);\n        }\n      }\n      &.ps-y > .ps-scrollbar-y-rail {\n        background-color: $semi-dark;\n        opacity: 0.9;\n        > .ps-scrollbar-y {\n          background-color: lighten($black, 60%);\n        }\n      }\n    }\n    > {\n      .ps-scrollbar-x-rail {\n        opacity: 0.6;\n        &:hover {\n          background-color: $light-color;\n          opacity: 0.9;\n          > .ps-scrollbar-x {\n            background-color: lighten($black, 60%);\n          }\n        }\n      }\n      .ps-scrollbar-y-rail {\n        opacity: 0.6;\n        &:hover {\n          background-color: $light-color;\n          opacity: 0.9;\n          > .ps-scrollbar-y {\n            background-color: $semi-dark;\n          }\n        }\n      }\n    }\n  }\n  &.ps-active-x > .ps-scrollbar-x-rail {\n    @extend %scroll-xy;\n  }\n  &.ps-active-y > .ps-scrollbar-y-rail {\n    @extend %scroll-xy;\n  }\n}\n.always-visible.ps-container > {\n  .ps-scrollbar-x-rail {\n    opacity: 0.6;\n  }\n  .ps-scrollbar-y-rail {\n    opacity: 0.6;\n  }\n}\n.large-margin.ps-container > {\n  .ps-scrollbar-x-rail {\n    margin: 0 25%;\n  }\n  .ps-scrollbar-y-rail {\n    margin: 100px 0;\n  }\n}\n/*=============Scrollable css end=============*/\n","/**=====================\n    46. Blog CSS start\n==========================**/\n.blog-box {\n  img {\n    border-radius: 0.25rem;\n  }\n  .top-radius-blog {\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  h6 {\n    font-weight: 600;\n    margin: 15px 0;\n  }\n  .blog-details {\n    padding-right: 20px;\n    .blog-social {\n      margin-top: 30px;\n      li {\n        display: inline-block;\n        font-size: 12px;\n        color: $theme-body-sub-title-color;\n        + li {\n          padding-left: 20px;\n          padding-right: 0;\n        }\n        i {\n          padding-right: 5px;\n          font-weight: 300;\n        }\n        &:first-child {\n          border-right: 1px solid gray;\n          padding-right: 20px;\n        }\n      }\n    }\n  }\n  .blog-details-main {\n    hr {\n      background-color: $gray-60;\n    }\n    .blog-social {\n      margin: 20px 0;\n      li {\n        display: inline-block;\n        font-size: 12px;\n        color: $theme-body-sub-title-color;\n        padding: 0 24px;\n        border-right: 1px dotted;\n        @media (max-width: 1676px) {\n          padding: 0 10px;\n        }\n        &:last-child {\n          border-right: 0;\n        }\n        i {\n          padding-right: 5px;\n        }\n      }\n    }\n    .blog-bottom-details {\n      margin: 20px;\n      font-size: 14px;\n      line-height: 1.714;\n      font-weight: 500;\n    }\n  }\n  .blog-date {\n    color: $theme-body-sub-title-color;\n    span {\n      font-size: 36px;\n      font-weight: 500;\n      padding-right: 5px;\n    }\n  }\n}\n.blog-box.blog-shadow {\n  &:before {\n    box-shadow: inset 0px -200px 100px -13px rgba(0, 0, 0, 0.6);\n    transition: all 0.3s ease;\n    border-radius: 5px;\n    content: '';\n    position: absolute;\n    height: 100%;\n    top: 0;\n    width: 100%;\n    bottom: 0;\n  }\n  &:hover {\n    &:before {\n      box-shadow: inset 0px -200px 100px -13px rgba(0, 0, 0, 0.65);\n      transition: all 0.3s ease;\n    }\n  }\n  .blog-details {\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    padding: 20px;\n    h4 {\n      color: $white;\n      margin-bottom: 0;\n    }\n    p {\n      font-size: 14px;\n      color: $white;\n      margin-bottom: 10px;\n    }\n    .blog-social {\n      li {\n        color: $white;\n      }\n    }\n  }\n}\n.blog-list {\n  .blog-details {\n    .blog-social {\n      margin-top: 0;\n    }\n    h6 {\n      margin-top: 0;\n      color: gray;\n      font-weight: 500;\n    }\n    hr {\n      margin-top: 10px;\n      margin-bottom: 10px;\n    }\n  }\n  img {\n    padding: 17px;\n  }\n}\n.blog-grid {\n  img {\n    width: 100%;\n  }\n  .blog-details {\n    padding: 20px;\n    h6 {\n      font-size: 14px;\n      margin-bottom: 0;\n      line-height: 1.8;\n    }\n  }\n}\n\n.blog-box {\n  position: relative;\n  max-height: 100%;\n  align-items: center;\n  .blog-details {\n    h6 {\n      text-overflow: ellipsis;\n      overflow: hidden;\n      -webkit-line-clamp: 1;\n      display: -webkit-box;\n      -webkit-box-orient: vertical;\n    }\n    p {\n      font-size: 14px;\n      line-height: 1.8;\n      letter-spacing: 0.7px;\n      margin-top: 30px;\n      margin-bottom: 0;\n      color: $theme-body-sub-title-color;\n      text-overflow: ellipsis;\n      overflow: hidden;\n      -webkit-line-clamp: 3;\n      display: -webkit-box;\n      -webkit-box-orient: vertical;\n      @media (max-width: 1570px) {\n        -webkit-line-clamp: 2;\n      }\n    }\n    h4 {\n      font-size: 18px;\n      font-weight: 500;\n      line-height: 1.5;\n      margin-top: 20px;\n      margin-bottom: 0;\n    }\n    .single-blog-content-top {\n      margin-top: 20px;\n      border-top: 1px solid $light-semi-gray;\n    }\n    .blog-social,\n    .comment-social {\n      li {\n        font-size: 14px;\n      }\n    }\n  }\n}\n.comment-box {\n  padding-top: 50px;\n  padding-bottom: 50px;\n  hr {\n    margin-top: 20px;\n    margin-bottom: 30px;\n  }\n  li {\n    margin-bottom: 30px;\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n  ul {\n    ul {\n      margin-left: 135px;\n    }\n  }\n  p {\n    font-size: 14px;\n    line-height: 2;\n    color: $theme-body-sub-title-color;\n    text-align: justify;\n    margin-bottom: 0;\n  }\n  h4 {\n    font-weight: 600;\n  }\n  .media {\n    img {\n      margin-right: 30px;\n      border-radius: 10px;\n      height: 90px;\n      padding: 7px;\n      width: 90px;\n      border: 1px solid $light-semi-gray;\n    }\n    h6 {\n      font-weight: 500;\n      margin-bottom: 5px;\n      span {\n        padding-left: 10px;\n        font-size: 13px;\n        color: $theme-body-sub-title-color;\n        font-weight: 400;\n      }\n    }\n  }\n  .comment-social {\n    li {\n      display: inline-block;\n      color: $gray-60;\n      padding-left: 20px;\n      margin-bottom: 0;\n      text-transform: uppercase;\n      &:first-child {\n        border-right: 1px solid $light-semi-gray;\n        padding-right: 20px;\n      }\n      i {\n        padding-right: 10px;\n      }\n    }\n  }\n}\n\n.add-post {\n  .cke_top,.cke_bottom {\n background-color: transparent;\n  }\n}\n/**=====================\n    46. Blog CSS ends\n==========================**/\n","/**=====================\n     85. bookmark app CSS Start\n==========================**/\n.modal-dialog {\n  &.modal-bookmark {\n    .modal-body,\n    .modal-header {\n      padding: 25px;\n    }\n    .modal-header {\n      border-bottom: 1px solid #dee2e6 !important;\n      .btn-close {\n        position: relative;\n        top: 0;\n        right: 0;\n        margin-left: auto;\n      }\n    }\n  }\n}\n.modal-header {\n  padding: 25px !important;\n}\n.bookmark-wrap {\n  .btn-mail {\n    color: var(--theme-default) !important;\n  }\n  .row {\n    .col-xl-3 {\n      + .col-xl-3 {\n        padding-right: 15px;\n      }\n    }\n  }\n  .left-bookmark {\n    ul {\n      li {\n        a {\n          color: $theme-body-font-color;\n        }\n        button {\n          border: none;\n          cursor: pointer;\n          &:focus {\n            outline: none;\n          }\n        }\n        svg {\n          width: 18px;\n          height: 18px;\n          vertical-align: sub;\n        }\n        > .main-title {\n          color: var(--theme-default);\n          font-weight: 600;\n          margin-bottom: 5px;\n          display: block;\n          span {\n            a {\n              &:hover {\n                background-color: $transparent-color;\n              }\n            }\n          }\n          svg {\n            color: $dark-gray;\n            stroke-width: 1px;\n          }\n        }\n        a {\n          > .title {\n            text-transform: capitalize;\n          }\n        }\n      }\n    }\n  }\n}\n.email-wrap {\n  .email-right-aside {\n    .email-body.radius-left.card {\n      border-radius: 0 15px 15px 0;\n    }\n  }\n  .email-right-aside {\n    .email-body.card {\n      border-radius: 15px 0 0 15px;\n    }\n  }\n}\n.form-bookmark {\n  .form-row {\n    display: flex;\n    flex-wrap: wrap;\n    .fill-color {\n      width: 35px;\n      height: 30px;\n      padding: 3px;\n    }\n  }\n\n  a {\n    text-transform: capitalize !important;\n    color: var(--theme-default) !important;\n    line-height: 1 !important;\n    font-weight: 500;\n    &:hover {\n      background-color: $transparent-color !important;\n    }\n  }\n  input {\n    &#index_var {\n      display: none;\n    }\n  }\n  .form-group {\n    input,\n    select {\n      font-size: 14px;\n    }\n    .select2-container {\n      .select2-selection--single {\n        border-color: #ced4da !important;\n      }\n    }\n    .select2 {\n      width: 100% !important;\n    }\n    .error {\n      margin: 0 !important;\n      font-size: 11px;\n      color: red !important;\n    }\n  }\n}\n.email-wrap.bookmark-wrap {\n  .email-body.radius-left.card {\n    border-radius: 15px;\n  }\n}\n.modal {\n  .bookmark-modal.modal-header {\n    padding: 22px;\n  }\n}\n.contact-profile {\n  margin: 0 auto;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  width: fit-content;\n  .img-100 {\n    height: 100px !important;\n  }\n  .upload {\n    position: absolute;\n    top: 0;\n    opacity: 0;\n  }\n  .icon-wrapper {\n    text-align: right;\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    width: 35px;\n    height: 35px;\n    background: $white;\n    border-radius: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n@keyframes displayTransition {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n.bookmark-tabcontent {\n  .details-bookmark {\n    height: auto;\n    min-height: 359px;\n    .bookmark-card {\n      position: relative;\n      height: 91%;\n      &.card {\n        .favourite-icon {\n          padding: 3px;\n          border-radius: 4px;\n          background-color: rgba($black, 0.2);\n          width: 30px;\n          position: absolute;\n          right: 15px;\n          top: 15px;\n          opacity: 0;\n          text-align: center;\n          i {\n            color: $white;\n            font-size: 16px;\n            vertical-align: text-bottom;\n          }\n          &.favourite {\n            i {\n              color: #fed112;\n            }\n          }\n        }\n        .desciption-data {\n          width: 100%;\n          .content-general {\n            display: none;\n          }\n        }\n        .favourite-icon {\n          transition: 0.5s;\n        }\n        .title-bookmark {\n          text-align: left;\n          padding: 15px;\n          border-top: 1px solid $light-color;\n          p {\n            margin-bottom: 10px;\n            animation: displayTransition 1s;\n          }\n          .hover-block {\n            display: none;\n            margin-top: 15px;\n            ul {\n              li {\n                display: inline-block;\n                + li {\n                  margin-left: 5px;\n                }\n                i {\n                  width: 16px;\n                  height: 16px;\n                  color: $dark-gray;\n                }\n              }\n            }\n          }\n        }\n        &:hover {\n          box-shadow: 1px 4px 16px 3px rgba($black, 0.04);\n          transition: 0.5s;\n          .title-bookmark {\n            p {\n              display: none;\n            }\n            .hover-block {\n              display: block;\n              animation: displayTransition 2s;\n            }\n          }\n          .favourite-icon {\n            opacity: 1;\n          }\n        }\n      }\n    }\n    &.list-bookmark {\n      .row {\n        .col-xl-3 {\n          flex: 0 0 100%;\n          max-width: 100%;\n        }\n      }\n      .bookmark-card {\n        height: unset;\n        .desciption-data {\n          .content-general {\n            display: block;\n          }\n        }\n        .details-website {\n          display: flex;\n          align-items: center;\n          .title-bookmark {\n            p {\n              display: block;\n            }\n            .hover-block {\n              position: absolute;\n              right: 30px;\n              display: block;\n              text-align: right;\n            }\n          }\n          &:hover {\n            .title-bookmark {\n              .hover-block {\n                display: block;\n                animation: displayTransition 0s;\n              }\n            }\n          }\n        }\n        &.card {\n          .title-bookmark {\n            border-top: none;\n            p,\n            h6 {\n              margin-top: 0;\n              display: inline-block;\n            }\n            h6 {\n              position: relative;\n              padding-right: 15px;\n              &::after {\n                position: absolute;\n                content: \"-\";\n                right: 0;\n                color: $dark-gray;\n              }\n            }\n            .content-general {\n              margin-top: 5px;\n              p {\n                width: 68%;\n                margin-right: 20px;\n              }\n            }\n          }\n        }\n        img {\n          width: 20%;\n        }\n      }\n    }\n  }\n  .tab-content {\n    .card {\n      .d-flex {\n        justify-content: space-between;\n        svg {\n          width: 18px;\n          height: 18px;\n          vertical-align: middle;\n        }\n        ul {\n          li {\n            display: inline-block;\n            + li {\n              margin-left: 10px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n// responsive\n@media (max-width: 1660px) {\n  .bookmark-tabcontent {\n    .details-bookmark {\n      &.list-bookmark {\n        .bookmark-card {\n          &.card {\n            .title-bookmark {\n              padding-left: 5px;\n              .content-general {\n                p {\n                  display: none;\n                }\n              }\n              .hover-block {\n                margin-top: 6px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n@media screen and (min-width: 1200px) and (max-width: 1366px) {\n  .bookmark-wrap {\n    .left-bookmark {\n      ul {\n        li {\n          .btn-mail {\n            svg {\n              display: none;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n@media (max-width: 1366px) {\n  .bookmark-tabcontent {\n    .details-bookmark {\n      &.list-bookmark {\n        .bookmark-card {\n          img {\n            width: 40%;\n          }\n        }\n      }\n    }\n  }\n}\n@media (max-width: 1199px) {\n  .bookmark-wrap {\n    .left-bookmark {\n      height: auto;\n    }\n  }\n  .bookmark-tabcontent {\n    .details-bookmark {\n      min-height: auto;\n    }\n  }\n}\n@media (max-width: 991px) {\n  .bookmark-tabcontent {\n    .details-bookmark {\n      .bookmark-card {\n        height: 93%;\n      }\n      .bookmark-card.card {\n        .title-bookmark {\n          p {\n            margin-bottom: 0;\n          }\n        }\n      }\n    }\n  }\n  .modal-bookmark {\n    .modal-body,\n    .modal-header {\n      padding: 20px;\n    }\n  }\n  .form-bookmark {\n    button {\n      margin-top: 20px;\n    }\n  }\n}\n@media (max-width: 767px) {\n  .form-bookmark {\n    .row {\n      .form-group {\n        &:last-child {\n          margin-top: 15px;\n        }\n      }\n    }\n  }\n  .bookmark-tabcontent {\n    .details-bookmark {\n      &.list-bookmark {\n        .bookmark-card {\n          .details-website {\n            .title-bookmark {\n              p {\n                overflow: hidden;\n                text-overflow: ellipsis;\n                white-space: nowrap;\n                max-width: 172px;\n              }\n            }\n            &:hover {\n              .title-bookmark {\n                .hover-block {\n                  p {\n                    display: none;\n                  }\n                  ul {\n                    position: relative;\n                    right: unset;\n                    top: unset;\n                  }\n                }\n              }\n            }\n          }\n          img {\n            width: 55%;\n          }\n        }\n      }\n    }\n  }\n}\n@media (max-width: 575px) {\n  .bookmark-tabcontent {\n    .details-bookmark {\n      &.list-bookmark {\n        .bookmark-card.card {\n          .title-bookmark {\n            h6 {\n              display: block;\n            }\n          }\n        }\n        .bookmark-card {\n          img {\n            width: 100%;\n          }\n          .details-website {\n            display: block;\n            .title-bookmark {\n              .hover-block {\n                position: relative;\n                right: unset;\n                text-align: left;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  .modal-bookmark {\n    .modal-body,\n    .modal-header {\n      padding: 15px;\n    }\n  }\n  .form-bookmark {\n    button {\n      margin-top: 15px;\n    }\n  }\n}\n/**=====================\n   85. bookmark app CSS Ends\n==========================**/\n","/**=====================\n    82. cart CSS start\n==========================**/\n.cart {\n  .total-amount {\n    text-align: right !important;\n    margin-top: 30px;\n    min-width: 140px;\n    & + td {\n      min-width: 160px;\n    }\n  }\n  .amount-space {\n    margin-left: 40px;\n  }\n  .cart-btn-transform {\n    text-transform: capitalize;\n  }\n  .qty-box {\n    width: 25%;\n    margin: 0 auto;\n    .input-group {\n      .btn {\n        background-color: transparent !important;\n        border-color: #ddd !important;\n        padding: 8px 12px;\n      }\n    }\n  }\n}\n.cart-buttons {\n  margin-top: 30px;\n  .cart-btn {\n    float: right;\n    padding-right: 85px;\n  }\n}\n/**=====================\n    82. cart CSS Ends\n==========================**/\n","/**=====================\n    41. Chart CSS Start\n==========================**/\n//urls\n$url-0: url(data:image/svg+xml;charset=utf8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTciPjxwYXRoIGZpbGw9IiM4ODgiIGQ9Ik0wIDE2aDE0djFIMHoiLz48cGF0aCB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTIsLTEwKSIgZmlsbD0iIzg4OCIgZD0iTTE3LjA5OCAyMC4zMDVjLS4xNDIuMTQ2LjEwMS4wNC4xMzcuMDA0LjAyNy0uMDI4LjIwNC0uMDkuNDg0LS4wOS4zMzguMC42MjYuMDkyLjc4Ny4yNTUuNDczLjQ3Mi40MjQuOTMyLjM5MyAxLjA3OGwtMi41MjEgMS4wNTUtMS41NzctMS41NzcgMS4wNTQtMi41MmMuMDM5LS4wMDkuMTA1LS4wMTguMTg4LS4wMTguMjE5LjAuNTU1LjA2OS44OTMuNDA3LjM3OC4zNzguMjQ2IDEuMTg4LjE2NiAxLjI3MUMxNy4wNjIgMjAuMjA3IDE3LjA2MiAyMC4yNjkgMTcuMDk4IDIwLjMwNXpNMjYuOTg0IDE0LjQ3MmMtLjAwOC0uNjc0LS42MS0xLjI1Ny0xLjMxLTEuOTMzLS4xMzQtLjEyOS0uNjc5LS42NzMtLjgwOS0uODA4LS42NzktLjcwMi0xLjI2Ni0xLjMxLTEuOTQzLTEuMzEtLjM3LjAtLjczNC4yMDctMS4xMTQuNTg3bC02Ljg1MiA2Ljg0N2MtLjAxMi4wMTYtMi44NzcgNy4zNTQtMi44NzcgNy4zNTQtLjAxMi4wMzIuMC4wNjMuMDIyLjA5MS4wMjEuMDIxLjA0NC4wMjkuMDY3LjAyOS4wMS4wLjAxOC0uMDAzLjAyOC0uMDA3LjAuMCA3LjM1Ny0yLjg2NCA3LjM2OS0yLjg3N2w2Ljg1NC02Ljg0N0MyNi44MDMgMTUuMjE2IDI2Ljk4OCAxNC44NDggMjYuOTg0IDE0LjQ3MnoiLz48L3N2Zz4=);\n$url-1: url(data:image/svg+xml;charset=utf8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTciPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0wIDE2aDE0djFIMHoiLz48cGF0aCB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTIsLTEwKSIgZmlsbD0iI2ZmZiIgZD0iTTE3LjA5OCAyMC4zMDVjLS4xNDIuMTQ2LjEwMS4wNC4xMzcuMDA0LjAyNy0uMDI4LjIwNC0uMDkuNDg0LS4wOS4zMzguMC42MjYuMDkyLjc4Ny4yNTUuNDczLjQ3Mi40MjQuOTMyLjM5MyAxLjA3OGwtMi41MjEgMS4wNTUtMS41NzctMS41NzcgMS4wNTQtMi41MmMuMDM5LS4wMDkuMTA1LS4wMTguMTg4LS4wMTguMjE5LjAuNTU1LjA2OS44OTMuNDA3LjM3OC4zNzguMjQ2IDEuMTg4LjE2NiAxLjI3MUMxNy4wNjIgMjAuMjA3IDE3LjA2MiAyMC4yNjkgMTcuMDk4IDIwLjMwNXpNMjYuOTg0IDE0LjQ3MmMtLjAwOC0uNjc0LS42MS0xLjI1Ny0xLjMxLTEuOTMzLS4xMzQtLjEyOS0uNjc5LS42NzMtLjgwOS0uODA4LS42NzktLjcwMi0xLjI2Ni0xLjMxLTEuOTQzLTEuMzEtLjM3LjAtLjczNC4yMDctMS4xMTQuNTg3bC02Ljg1MiA2Ljg0N2MtLjAxMi4wMTYtMi44NzcgNy4zNTQtMi44NzcgNy4zNTQtLjAxMi4wMzIuMC4wNjMuMDIyLjA5MS4wMjEuMDIxLjA0NC4wMjkuMDY3LjAyOS4wMS4wLjAxOC0uMDAzLjAyOC0uMDA3LjAuMCA3LjM1Ny0yLjg2NCA3LjM2OS0yLjg3N2w2Ljg1NC02Ljg0N0MyNi44MDMgMTUuMjE2IDI2Ljk4OCAxNC44NDggMjYuOTg0IDE0LjQ3MnoiLz48L3N2Zz4=);\n$url-2: url(data:image/svg+xml;charset=utf8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTEiIGhlaWdodD0iMTQiPjxwYXRoIGQ9Ik0zIDBIOFY1aDNMNS41IDEwIDAgNUgzVjAiIGZpbGw9IiM4ODgiLz48cGF0aCBmaWxsPSIjODg4IiBkPSJNMCAxMmgxMXYySDB6Ii8+PC9zdmc+);\n$url-3: url(data:image/svg+xml;charset=utf8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTEiIGhlaWdodD0iMTQiPjxwYXRoIGQ9Ik0zIDBIOFY1aDNMNS41IDEwIDAgNUgzVjAiIGZpbGw9IiNmZmYiLz48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMCAxMmgxMXYySDB6Ii8+PC9zdmc+);\n$url-4: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAQCAYAAADNo/U5AAAACXBIWXMAAAsTAAALEwEAmpwYAABBsGlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS41LWMwMjEgNzkuMTU1NzcyLCAyMDE0LzAxLzEzLTE5OjQ0OjAwICAgICAgICAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIKICAgICAgICAgICAgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiCiAgICAgICAgICAgIHhtbG5zOnN0RXZ0PSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VFdmVudCMiCiAgICAgICAgICAgIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIKICAgICAgICAgICAgeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIgogICAgICAgICAgICB4bWxuczpwaG90b3Nob3A9Imh0dHA6Ly9ucy5hZG9iZS5jb20vcGhvdG9zaG9wLzEuMC8iCiAgICAgICAgICAgIHhtbG5zOnRpZmY9Imh0dHA6Ly9ucy5hZG9iZS5jb20vdGlmZi8xLjAvIgogICAgICAgICAgICB4bWxuczpleGlmPSJodHRwOi8vbnMuYWRvYmUuY29tL2V4aWYvMS4wLyI+CiAgICAgICAgIDx4bXBNTTpPcmlnaW5hbERvY3VtZW50SUQ+eG1wLmRpZDo4M2Q5NDllYS1lMjE3LTQ3Y2QtYTU1Ni04MTQ3NmRjNWEwYWQ8L3htcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD4KICAgICAgICAgPHhtcE1NOkRvY3VtZW50SUQ+YWRvYmU6ZG9jaWQ6cGhvdG9zaG9wOjZhMTQ5MTc1LTNiODItMTE3OC05ZjZmLWY0MWMwNTYyYzQxYTwveG1wTU06RG9jdW1lbnRJRD4KICAgICAgICAgPHhtcE1NOkluc3RhbmNlSUQ+eG1wLmlpZDpkZGFhNTJkMi1mZDRiLTRkMmMtODEzOC01ZTEzNmQ4NGFjMDE8L3htcE1NOkluc3RhbmNlSUQ+CiAgICAgICAgIDx4bXBNTTpEZXJpdmVkRnJvbSByZGY6cGFyc2VUeXBlPSJSZXNvdXJjZSI+CiAgICAgICAgICAgIDxzdFJlZjppbnN0YW5jZUlEPnhtcC5paWQ6MDdhZmI1Y2UtYzQ1OS00YzQxLWJkMjItMTllMDJlMGE5YzVjPC9zdFJlZjppbnN0YW5jZUlEPgogICAgICAgICAgICA8c3RSZWY6ZG9jdW1lbnRJRD54bXAuZGlkOjA3YWZiNWNlLWM0NTktNGM0MS1iZDIyLTE5ZTAyZTBhOWM1Yzwvc3RSZWY6ZG9jdW1lbnRJRD4KICAgICAgICAgICAgPHN0UmVmOm9yaWdpbmFsRG9jdW1lbnRJRD54bXAuZGlkOjgzZDk0OWVhLWUyMTctNDdjZC1hNTU2LTgxNDc2ZGM1YTBhZDwvc3RSZWY6b3JpZ2luYWxEb2N1bWVudElEPgogICAgICAgICA8L3htcE1NOkRlcml2ZWRGcm9tPgogICAgICAgICA8eG1wTU06SGlzdG9yeT4KICAgICAgICAgICAgPHJkZjpTZXE+CiAgICAgICAgICAgICAgIDxyZGY6bGkgcmRmOnBhcnNlVHlwZT0iUmVzb3VyY2UiPgogICAgICAgICAgICAgICAgICA8c3RFdnQ6YWN0aW9uPnNhdmVkPC9zdEV2dDphY3Rpb24+CiAgICAgICAgICAgICAgICAgIDxzdEV2dDppbnN0YW5jZUlEPnhtcC5paWQ6YmY3ZmRlNGYtZDk2MS00Njk4LWI0ZjAtMDJlYjEwOWE4OTA4PC9zdEV2dDppbnN0YW5jZUlEPgogICAgICAgICAgICAgICAgICA8c3RFdnQ6d2hlbj4yMDE1LTA1LTE1VDEzOjE3OjQ5KzAyOjAwPC9zdEV2dDp3aGVuPgogICAgICAgICAgICAgICAgICA8c3RFdnQ6c29mdHdhcmVBZ2VudD5BZG9iZSBQaG90b3Nob3AgQ0MgMjAyMSAoTWFjaW50b3NoKTwvc3RFdnQ6c29mdHdhcmVBZ2VudD4KICAgICAgICAgICAgICAgICAgPHN0RXZ0OmNoYW5nZWQ+Lzwvc3RFdnQ6Y2hhbmdlZD4KICAgICAgICAgICAgICAgPC9yZGY6bGk+CiAgICAgICAgICAgICAgIDxyZGY6bGkgcmRmOnBhcnNlVHlwZT0iUmVzb3VyY2UiPgogICAgICAgICAgICAgICAgICA8c3RFdnQ6YWN0aW9uPmNvbnZlcnRlZDwvc3RFdnQ6YWN0aW9uPgogICAgICAgICAgICAgICAgICA8c3RFdnQ6cGFyYW1ldGVycz5mcm9tIGltYWdlL3BuZyB0byBhcHBsaWNhdGlvbi92bmQuYWRvYmUucGhvdG9zaG9wPC9zdEV2dDpwYXJhbWV0ZXJzPgogICAgICAgICAgICAgICA8L3JkZjpsaT4KICAgICAgICAgICAgICAgPHJkZjpsaSByZGY6cGFyc2VUeXBlPSJSZXNvdXJjZSI+CiAgICAgICAgICAgICAgICAgIDxzdEV2dDphY3Rpb24+ZGVyaXZlZDwvc3RFdnQ6YWN0aW9uPgogICAgICAgICAgICAgICAgICA8c3RFdnQ6cGFyYW1ldGVycz5jb252ZXJ0ZWQgZnJvbSBpbWFnZS9wbmcgdG8gYXBwbGljYXRpb24vdm5kLmFkb2JlLnBob3Rvc2hvcDwvc3RFdnQ6cGFyYW1ldGVycz4KICAgICAgICAgICAgICAgPC9yZGY6bGk+CiAgICAgICAgICAgICAgIDxyZGY6bGkgcmRmOnBhcnNlVHlwZT0iUmVzb3VyY2UiPgogICAgICAgICAgICAgICAgICA8c3RFdnQ6YWN0aW9uPnNhdmVkPC9zdEV2dDphY3Rpb24+CiAgICAgICAgICAgICAgICAgIDxzdEV2dDppbnN0YW5jZUlEPnhtcC5paWQ6MDdhZmI1Y2UtYzQ1OS00YzQxLWJkMjItMTllMDJlMGE5YzVjPC9zdEV2dDppbnN0YW5jZUlEPgogICAgICAgICAgICAgICAgICA8c3RFdnQ6d2hlbj4yMDE1LTA1LTE1VDEzOjE3OjQ5KzAyOjAwPC9zdEV2dDp3aGVuPgogICAgICAgICAgICAgICAgICA8c3RFdnQ6c29mdHdhcmVBZ2VudD5BZG9iZSBQaG90b3Nob3AgQ0MgMjAyMSAoTWFjaW50b3NoKTwvc3RFdnQ6c29mdHdhcmVBZ2VudD4KICAgICAgICAgICAgICAgICAgPHN0RXZ0OmNoYW5nZWQ+Lzwvc3RFdnQ6Y2hhbmdlZD4KICAgICAgICAgICAgICAgPC9yZGY6bGk+CiAgICAgICAgICAgICAgIDxyZGY6bGkgcmRmOnBhcnNlVHlwZT0iUmVzb3VyY2UiPgogICAgICAgICAgICAgICAgICA8c3RFdnQ6YWN0aW9uPmRlcml2ZWQ8L3N0RXZ0OmFjdGlvbj4KICAgICAgICAgICAgICAgICAgPHN0RXZ0OnBhcmFtZXRlcnM+Y29udmVydGVkIGZyb20gYXBwbGljYXRpb24vdm5kLmFkb2JlLnBob3Rvc2hvcCB0byBpbWFnZS9wbmc8L3N0RXZ0OnBhcmFtZXRlcnM+CiAgICAgICAgICAgICAgIDwvcmRmOmxpPgogICAgICAgICAgICAgICA8cmRmOmxpIHJkZjpwYXJzZVR5cGU9IlJlc291cmNlIj4KICAgICAgICAgICAgICAgICAgPHN0RXZ0OmFjdGlvbj5zYXZlZDwvc3RFdnQ6YWN0aW9uPgogICAgICAgICAgICAgICAgICA8c3RFdnQ6aW5zdGFuY2VJRD54bXAuaWlkOmRkYWE1MmQyLWZkNGItNGQyYy04MTM4LTVlMTM2ZDg0YWMwMTwvc3RFdnQ6aW5zdGFuY2VJRD4KICAgICAgICAgICAgICAgICAgPHN0RXZ0OndoZW4+MjAxNS0wNS0xNVQxMzoyMToyMSswMjowMDwvc3RFdnQ6d2hlbj4KICAgICAgICAgICAgICAgICAgPHN0RXZ0OnNvZnR3YXJlQWdlbnQ+QWRvYmUgUGhvdG9zaG9wIENDIDIwMjEgKE1hY2ludG9zaCk8L3N0RXZ0OnNvZnR3YXJlQWdlbnQ+CiAgICAgICAgICAgICAgICAgIDxzdEV2dDpjaGFuZ2VkPi88L3N0RXZ0OmNoYW5nZWQ+CiAgICAgICAgICAgICAgIDwvcmRmOmxpPgogICAgICAgICAgICA8L3JkZjpTZXE+CiAgICAgICAgIDwveG1wTU06SGlzdG9yeT4KICAgICAgICAgPHhtcDpDcmVhdG9yVG9vbD5BZG9iZSBQaG90b3Nob3AgQ0MgMjAxNCAoTWFjaW50b3NoKTwveG1wOkNyZWF0b3JUb29sPgogICAgICAgICA8eG1wOkNyZWF0ZURhdGU+MjAxNS0wNS0xNVQxMzoxMzoxNyswMjowMDwveG1wOkNyZWF0ZURhdGU+CiAgICAgICAgIDx4bXA6TW9kaWZ5RGF0ZT4yMDE1LTA1LTE1VDEzOjIxOjIxKzAyOjAwPC94bXA6TW9kaWZ5RGF0ZT4KICAgICAgICAgPHhtcDpNZXRhZGF0YURhdGU+MjAxNS0wNS0xNVQxMzoyMToyMSswMjowMDwveG1wOk1ldGFkYXRhRGF0ZT4KICAgICAgICAgPGRjOmZvcm1hdD5pbWFnZS9wbmc8L2RjOmZvcm1hdD4KICAgICAgICAgPHBob3Rvc2hvcDpDb2xvck1vZGU+MzwvcGhvdG9zaG9wOkNvbG9yTW9kZT4KICAgICAgICAgPHBob3Rvc2hvcDpUZXh0TGF5ZXJzPgogICAgICAgICAgICA8cmRmOkJhZz4KICAgICAgICAgICAgICAgPHJkZjpsaSByZGY6cGFyc2VUeXBlPSJSZXNvdXJjZSI+CiAgICAgICAgICAgICAgICAgIDxwaG90b3Nob3A6TGF5ZXJOYW1lPlg8L3Bob3Rvc2hvcDpMYXllck5hbWU+CiAgICAgICAgICAgICAgICAgIDxwaG90b3Nob3A6TGF5ZXJUZXh0Plg8L3Bob3Rvc2hvcDpMYXllclRleHQ+CiAgICAgICAgICAgICAgIDwvcmRmOmxpPgogICAgICAgICAgICA8L3JkZjpCYWc+CiAgICAgICAgIDwvcGhvdG9zaG9wOlRleHRMYXllcnM+CiAgICAgICAgIDx0aWZmOk9yaWVudGF0aW9uPjE8L3RpZmY6T3JpZW50YXRpb24+CiAgICAgICAgIDx0aWZmOlhSZXNvbHV0aW9uPjcyMDAwMC8xMDAwMDwvdGlmZjpYUmVzb2x1dGlvbj4KICAgICAgICAgPHRpZmY6WVJlc29sdXRpb24+NzIwMDAwLzEwMDAwPC90aWZmOllSZXNvbHV0aW9uPgogICAgICAgICA8dGlmZjpSZXNvbHV0aW9uVW5pdD4yPC90aWZmOlJlc29sdXRpb25Vbml0PgogICAgICAgICA8ZXhpZjpDb2xvclNwYWNlPjY1NTM1PC9leGlmOkNvbG9yU3BhY2U+CiAgICAgICAgIDxleGlmOlBpeGVsWERpbWVuc2lvbj4xMzwvZXhpZjpQaXhlbFhEaW1lbnNpb24+CiAgICAgICAgIDxleGlmOlBpeGVsWURpbWVuc2lvbj4xNjwvZXhpZjpQaXhlbFlEaW1lbnNpb24+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgIAo8P3hwYWNrZXQgZW5kPSJ3Ij8+HyMp+AAAACBjSFJNAAB6JQAAgIMAAPn/AACA6QAAdTAAAOpgAAA6mAAAF2+SX8VGAAAA3UlEQVR42rSSXZECQQyEPygMrIVFAidhkQASQEIjYVsCSOAksBJAAlhAwvKSWcJBUQVVl6fM5Ke7k4z6vudTG/OFTQAktcAs/ja2TyVBUgVsgQq42F5PItYBCn8PTFNjAYvw5wM92x3gCNSSFCh1araLvAdNBi53VgMtgCuweRqE7RyogAPQxHsdcQBGf0cuaZ80APzaXn468urtniQ1CaXoayStct5AL4QfgToKfoBzIF2BadGVkVZRkIU7UdQDkqRZoDwJl3ROzea2u4LUvtpHOavkty9H/m9XfhsA0l9VuzQDWrIAAAAASUVORK5CYII=);\n\n%chart-1 {\n  width: 70px;\n  height: 70px;\n  margin-left: 15px;\n  margin-top: 15px;\n  line-height: 70px;\n}\n\n%chart-2 {\n  width: 35px;\n  height: 35px;\n  margin-left: 7.5px;\n  margin-top: 7.5px;\n  line-height: 35px;\n}\n\n%chart-3 {\n  width: 20px;\n  height: 20px;\n  margin-left: 5.5px;\n  margin-top: 4.5px;\n  line-height: 21px;\n}\n\n.chart-block {\n  canvas {\n    width: 100% !important;\n  }\n\n  .chart-overflow {\n    overflow: hidden;\n    text-align: center;\n  }\n}\n\n.candidcahrt {\n  width: 100%;\n  height: 470px;\n}\n\n.amcharts-export-canvas {\n  position: absolute;\n  display: none;\n  z-index: 1;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: $white;\n\n  .canvas-container {\n    transition: opacity 0.5s ease-out;\n  }\n\n  &.active {\n    display: block;\n  }\n\n  &.dropbox .canvas-container {\n    opacity: 0.5;\n  }\n}\n\n.flot-chart-container {\n  //Instead of the line below you could use @include box-sizing($bs)\n  box-sizing: border-box;\n  width: 100%;\n  height: 400px;\n\n  #toggling-series-flot {\n    width: 79% !important;\n  }\n}\n\n.all-chart {\n  .flot-chart-container {\n    height: 350px;\n  }\n}\n\n.flot-chart-placeholder {\n  width: 100%;\n  height: 100%;\n  font-size: 14px;\n  line-height: 1.2em;\n  text-align: center;\n\n  .legend table {\n    border-spacing: 5px;\n  }\n}\n\n.morris-hover {\n  position: absolute;\n  z-index: 1;\n\n  &.morris-default-style {\n    border-radius: 10px;\n    padding: 6px;\n    color: $dark-gray;\n    background: $white;\n    border: solid 1px $light-gray;\n    font-family: $font-serif;\n    font-size: 12px;\n    text-align: center;\n\n    .morris-hover-row-label {\n      font-weight: bold;\n      margin: 0.25em 0;\n    }\n\n    .morris-hover-point {\n      white-space: nowrap;\n      margin: 0.1em 0;\n    }\n  }\n}\n\n.chart-sparkline {\n  position: absolute;\n  left: 0;\n  top: 0;\n  visibility: hidden;\n  background: rgba(49, 49, 49, 0.7);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=#99000000, endColorstr=#99000000);\n  color: $white;\n  font: 10px $font-rubik, $font-serif;\n  text-align: left;\n  white-space: nowrap;\n  padding: 5px;\n  border: 1px solid rgba(49, 49, 49, 0.75);\n  box-sizing: content-box;\n  z-index: 10000;\n  border-radius: 5px;\n\n  .jqsfield {\n    color: $white;\n    font: 10px $font-rubik, $font-serif;\n    text-align: left;\n  }\n}\n\n.radial-bar {\n  position: relative;\n  display: inline-block;\n  border-radius: 50%;\n  background-color: transparent;\n  box-sizing: content-box;\n  width: 80px;\n  height: 80px;\n  font-size: 18px;\n  background-clip: content-box;\n\n  &:after {\n    display: inline-block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    border-radius: 50%;\n    text-align: center;\n    font-weight: 500;\n    color: $color-fiord;\n    content: attr(data-label);\n    background-color: $white;\n    z-index: 1;\n    width: 56px;\n    height: 56px;\n    margin-left: 12px;\n    margin-top: 12px;\n    line-height: 56px;\n  }\n\n  > img {\n    display: inline-block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    border-radius: 50%;\n    text-align: center;\n    font-weight: 500;\n    color: $color-fiord;\n    z-index: 3;\n    width: 56px;\n    height: 56px;\n    margin-left: 12px;\n    margin-top: 12px;\n    line-height: 56px;\n  }\n}\n\n.radial-bar-danger {\n  &.radial-bar-20 {\n    background-image: linear-gradient(90deg, $light-semi-gray 50%, transparent 50%, transparent), linear-gradient(162deg, $danger-color 50%, $light-semi-gray 50%, $light-semi-gray);\n  }\n}\n\n.radial-bar {\n  &.radial-bar-lg {\n    width: 100px;\n    height: 100px;\n    font-size: 20px;\n\n    &:after {\n      @extend %chart-1;\n    }\n\n    > img {\n      @extend %chart-1;\n    }\n  }\n\n  &.radial-bar-sm {\n    width: 50px;\n    height: 50px;\n    font-size: 12px;\n\n    &:after {\n      @extend %chart-2;\n    }\n\n    > img {\n      @extend %chart-2;\n    }\n  }\n\n  &.radial-bar-xs {\n    width: 30px;\n    height: 30px;\n    font-size: 8px;\n\n    &:after {\n      @extend %chart-3;\n    }\n\n    > img {\n      @extend %chart-3;\n    }\n  }\n}\n\n.pieLabel {\n  div {\n    color: $white !important;\n\n    input[type=\"checkbox\"] {\n      margin: 7px;\n    }\n  }\n}\n\n// knob chart css\n.knob-chart {\n  min-height: 255px;\n\n  .chart-clock-main {\n    position: relative;\n    width: 200px;\n    margin: 45px auto;\n\n    .clock-large {\n      position: absolute;\n      left: -48px;\n      top: -45px;\n    }\n\n    .clock-medium {\n      position: absolute;\n      left: 2px;\n      top: 5px;\n    }\n\n    .clock-small {\n      position: absolute;\n      left: 15px;\n      top: 55px;\n    }\n  }\n}\n\n// peity chart css\n.peity-charts {\n  svg {\n    width: 100%;\n    height: 250px;\n  }\n\n  &.peity-chart-primary {\n    svg {\n      polygon {\n        fill: rgba($primary-color, 0.2);\n      }\n\n      polyline {\n        stroke: var(--theme-default);\n      }\n    }\n  }\n}\n\n.bar-odd-even {\n  svg {\n    rect {\n      &:nth-child(odd) {\n        fill: var(--theme-default);\n      }\n\n      &:nth-child(even) {\n        fill: var(--theme-secondary);\n      }\n    }\n  }\n}\n\n.donut-peity {\n  svg {\n    path {\n      &:nth-child(odd) {\n        fill: var(--theme-default);\n      }\n\n      &:nth-child(even) {\n        fill: var(--theme-secondary);\n      }\n    }\n  }\n}\n\n.small-donut,\n.donut-peity2,\n.pie-peity {\n  ~ svg,\n  svg {\n    path {\n      &:nth-child(odd) {\n        fill: var(--theme-default);\n      }\n\n      &:nth-child(even) {\n        fill: $light-semi-gray;\n      }\n    }\n  }\n}\n\n.small-donut2 {\n  ~ svg {\n    path {\n      &:nth-child(odd) {\n        fill: var(--theme-secondary);\n      }\n    }\n  }\n}\n\n.small-donut3 {\n  ~ svg {\n    path {\n      &:nth-child(odd) {\n        fill: $success-color;\n      }\n    }\n  }\n}\n\n.small-donut4 {\n  ~ svg {\n    path {\n      &:nth-child(odd) {\n        fill: $info-color;\n      }\n    }\n  }\n}\n\n.small-donut5 {\n  ~ svg {\n    path {\n      &:nth-child(odd) {\n        fill: $warning-color;\n      }\n    }\n  }\n}\n\n.small-donut6 {\n  ~ svg {\n    path {\n      &:nth-child(odd) {\n        fill: $danger-color;\n      }\n    }\n  }\n}\n\np {\n  &.data-attributes {\n    svg {\n      margin-right: 10px;\n    }\n  }\n}\n\n// knob chart\n.knob-block {\n  position: relative;\n\n  input {\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    height: 100% !important;\n    width: 100% !important;\n    left: 0 !important;\n    top: 0 !important;\n    margin-left: 0 !important;\n    margin-top: -3px !important;\n  }\n}\n\n.knob-input-disable {\n  input {\n    display: none !important;\n  }\n}\n\n// apex chart\n.apex-chart {\n  margin: 0 auto;\n}\n.apexcharts-toolbar {\n  z-index: 1 !important;\n}\n\n.apexcharts-menu-item {\n  width: 110px;\n}\n\n.word-tree {\n  height: 400px;\n}\n\n// chartist chat\n.ct-series-a {\n  .ct-slice-pie,\n  .ct-slice-donut-solid,\n  .ct-area {\n    fill: var(--theme-default);\n  }\n\n  .ct-point,\n  .ct-line,\n  .ct-bar,\n  .ct-slice-donut {\n    stroke: var(--theme-default);\n  }\n}\n\n.ct-series-b {\n  .ct-point,\n  .ct-line,\n  .ct-bar,\n  .ct-slice-donut {\n    stroke: var(--theme-secondary);\n  }\n\n  .ct-slice-pie,\n  .ct-slice-donut-solid,\n  .ct-area {\n    fill: var(--theme-secondary);\n  }\n}\n\n// echart css\n.apache-cotainer {\n  width: 100%;\n  height: 350px;\n  margin: 0;\n}\n\n.boxplot-cotainer {\n  height: 420px;\n}\n\n.apache-cotainer-large {\n  width: 100%;\n  height: 500px;\n  margin: 0;\n}\n\n.test-buttons {\n  button {\n    + button {\n      margin-left: 10px;\n    }\n  }\n}\n\n.clip-chart-wrapper {\n  .test-chart-block {\n    margin-bottom: -30px;\n  }\n}\n\n#echart-gauge {\n  .test-chart {\n    width: 100%;\n    height: 395px;\n  }\n}\n\n.polar-line {\n  height: 350px;\n}\n\n#dotted {\n  height: 390px;\n}\n\n.apexcharts-canvas {\n  .apexcharts-tooltip,\n  .apexcharts-xaxistooltip,\n  .apexcharts-yaxistooltip {\n    z-index: 1;\n  }\n}\n\n.flot-chart-container {\n  .flot-chart-placeholder {\n    ~ p.float-end {\n      @media (max-width: 1346px) {\n        float: left !important;\n        [dir=\"rtl\"] & {\n          float: right !important;\n        }\n      }\n    }\n  }\n}\n/**=====================\n     41. Chart CSS End\n==========================**/\n","/**=====================\n     14. Chat CSS Start\n==========================**/\n.chat-box {\n  .toogle-bar {\n    display: none;\n  }\n  .chat-menu {\n    max-width: 340px;\n  }\n  .people-list {\n    .search {\n      position: relative;\n      .form-control {\n        background-color: $light-body-bg-color;\n        border: 1px solid $light-color;\n        &::placeholder {\n          color: $semi-dark;\n        }\n      }\n      i {\n        position: absolute;\n        right: 10px;\n        top: 17px;\n        font-size: 14px;\n        color: $light-gray;\n      }\n    }\n    ul {\n      padding: 0;\n      li {\n        padding-bottom: 20px;\n        &.active {\n          background-color: transparent !important;\n        }\n        &:last-child {\n          padding-bottom: 0;\n        }\n      }\n    }\n  }\n  .user-image {\n    float: left;\n    width: 52px;\n    height: 52px;\n    margin-right: 5px;\n  }\n  .about {\n    float: left;\n    margin-top: 5px;\n    padding-left: 10px;\n    .name {\n      color: $dark-color;\n      letter-spacing: 1px;\n      font-weight: 500;\n    }\n  }\n  .status {\n    color: $semi-dark;\n    letter-spacing: 1px;\n    font-size: 12px;\n    margin-top: 5px;\n    .chat-status {\n      font-weight: 600;\n      color: $theme-body-font-color;\n    }\n    p {\n      font-size: 14px;\n    }\n  }\n  .chat-right-aside {\n    .chat {\n      .chat-header {\n        padding: 15px;\n        border-bottom: 1px solid $light-color;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        img {\n          float: left;\n          width: 50px;\n          height: 50px;\n          box-shadow: 1px 1px 4px 1px $light-gray;\n        }\n        .chat-menu-icons {\n          li {\n            margin-right: 24px;\n            a i {\n              color: $theme-body-sub-title-color;\n              font-size: 25px;\n              cursor: pointer;\n            }\n          }\n        }\n\n        .chat-menu-icons {\n          margin-left: auto;\n          svg {\n            color: #52526c;\n            stroke: 1.4px;\n          }\n          [dir=\"rtl\"] & {\n            margin-right: auto;\n            margin-left: unset;\n          }\n        }\n      }\n      .chat-msg-box {\n        padding: 20px;\n        overflow-y: auto;\n        height: 560px;\n        margin-bottom: 80px;\n        .chat-user-img {\n          margin-top: -35px;\n        }\n        .message-data {\n          margin-bottom: 10px;\n        }\n        .message-data-time {\n          letter-spacing: 1px;\n          font-size: 12px;\n          color: $semi-dark;\n        }\n        .message {\n          color: $dark-color;\n          padding: 20px;\n          line-height: 1.9;\n          letter-spacing: 1px;\n          font-size: 14px;\n          margin-bottom: 30px;\n          width: 50%;\n          position: relative;\n        }\n        .my-message {\n          border: 1px solid $light-color;\n          border-radius: 10px;\n          border-top-left-radius: 0;\n        }\n        .other-message {\n          background-color: $light;\n          border-radius: 10px;\n          border-top-right-radius: 0;\n        }\n      }\n      .chat-message {\n        padding: 20px;\n        border-top: 1px solid $light-body-bg-color;\n        position: absolute;\n        width: calc(100% - 15px);\n        background-color: $white;\n        bottom: 0;\n        .smiley-box {\n          background: $light-semi-gray;\n          padding: 10px;\n          display: block;\n          border-radius: 4px;\n          margin-right: 0.5rem;\n        }\n        .text-box {\n          position: relative;\n          .input-txt-bx {\n            height: 50px;\n            border: 2px solid var(--theme-default);\n            padding-left: 18px;\n            font-size: 12px;\n            letter-spacing: 1px;\n          }\n          i {\n            position: absolute;\n            right: 20px;\n            top: 20px;\n            font-size: 20px;\n            color: $light-gray;\n            cursor: pointer;\n          }\n          .btn {\n            font-size: 16px;\n            font-weight: 500;\n            padding: 0.74rem 1.75rem;\n            border-radius: 0 5px 5px 0;\n          }\n        }\n      }\n    }\n  }\n  .chat-menu {\n    border-left: 1px solid $light-color;\n    .tab-pane {\n      padding: 0 15px;\n    }\n    ul {\n      li {\n        .about {\n          .status {\n            i {\n              font-size: 10px;\n            }\n          }\n        }\n      }\n    }\n    .user-profile {\n      margin-top: 30px;\n      .user-content {\n        h5 {\n          margin: 25px 0;\n        }\n        hr {\n          margin: 25px 0;\n        }\n        p {\n          font-size: 16px;\n        }\n      }\n      .border-tab.nav-tabs .nav-item .nav-link.active,\n      .border-tab.nav-tabs .nav-item .nav-link.show,\n      .border-tab.nav-tabs .nav-item .nav-link:focus {\n        border-bottom: 0;\n      }\n      .image {\n        position: relative;\n        .icon-wrapper {\n          position: absolute;\n          bottom: 0;\n          left: 55%;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          height: 35px;\n          width: 35px;\n          border-radius: 50%;\n          background-color: $white;\n          cursor: pointer;\n          overflow: hidden;\n          margin: 0 auto;\n          font-size: 14px;\n          box-shadow: 1px 1px 3px 1px $light-color;\n        }\n        .avatar img {\n          border-radius: 50%;\n          border: 5px solid $light-color;\n        }\n      }\n      .border-right {\n        border-right: 1px solid #dee2e6;\n      }\n      .follow {\n        margin-top: 0;\n        .follow-num {\n          font-size: 20px;\n          color: $black;\n        }\n        span {\n          color: $theme-font-color;\n          font-size: 14px;\n          letter-spacing: 1px;\n        }\n      }\n      .social-media a {\n        color: $semi-dark;\n        font-size: 15px;\n        padding: 0 7px;\n      }\n      .chat-profile-contact {\n        p {\n          font-size: 14px;\n          color: $semi-dark;\n        }\n      }\n    }\n    .nav {\n      margin-bottom: 20px;\n    }\n    .nav-tabs .nav-item {\n      width: 33.33%;\n      a {\n        padding: 15px !important;\n        color: $semi-dark !important;\n        letter-spacing: 1px;\n        font-size: 14px;\n        font-weight: 500;\n        height: 60px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n      .material-border {\n        border-width: 1px;\n        border-color: var(--theme-default);\n      }\n      .nav-link.active {\n        color: $black !important;\n      }\n    }\n  }\n  .chat-history {\n    .call-content {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      min-width: 300px;\n    }\n    .total-time h2 {\n      font-size: 50px;\n      color: $light-semi-gray;\n      font-weight: 600;\n      margin-bottom: 30px;\n    }\n    .receiver-img {\n      margin-top: 55px;\n      img {\n        border-radius: 5px;\n      }\n    }\n    .call-icons {\n      margin-bottom: 35px;\n      ul {\n        li {\n          width: 60px;\n          height: 60px;\n          border: 1px solid $light-color;\n          border-radius: 50%;\n          padding: 12px;\n          cursor: pointer;\n          + li {\n            margin-left: 10px;\n          }\n          a {\n            color: #999;\n            font-size: 25px;\n          }\n        }\n      }\n    }\n  }\n}\n.chat-left-aside {\n  > .media {\n    margin-bottom: 15px;\n  }\n  .people-list {\n    height: 625px;\n  }\n  ul li {\n    position: relative;\n  }\n  .list-group-item {\n    &.active {\n      background-color: transparent !important;\n    }\n  }\n}\n.status-circle {\n  width: 12px;\n  height: 12px;\n  position: absolute;\n  top: 4px;\n  left: 44px;\n  border-radius: 50%;\n  border: 2px solid $white;\n}\n.away {\n  background-color: $warning-color;\n}\n.online {\n  background-color: $success-color;\n}\n.offline {\n  background-color: $danger-color;\n}\n.chat-container {\n  .aside-chat-left {\n    width: 320px;\n  }\n  .chat-right-aside {\n    width: 320px;\n  }\n}\n.call-chat-sidebar {\n  max-width: 320px;\n}\n.call-chat-sidebar,\n.chat-body {\n  .card {\n    .card-body {\n      padding: 15px;\n    }\n  }\n}\nbody.dark-only .page-wrapper {\n  .people-list {\n    .list-group-item.active {\n      background-color: transparent !important;\n    }\n  }\n}\n/**=====================\n    14.  Chat CSS Ends\n==========================**/\n","/**=====================\n    84. Checkout CSS start\n==========================**/\n.checkout {\n  .checkout-details {\n    background-color: #f9f9f9;\n    border: 1px solid #dddddd;\n    padding: 40px;\n    .order-place {\n      margin-top: 15px;\n    }\n  }\n}\n\n.order-box {\n  .title-box {\n    padding-bottom: 20px;\n    color: #444444;\n    font-size: 22px;\n    border-bottom: 1px solid #ededed;\n    margin-bottom: 20px;\n\n    span {\n      width: 35%;\n      float: right;\n      font-weight: 600;\n      text-align: right;\n    }\n\n    h4 {\n      font-weight: 600;\n    }\n\n    .checkbox-title {\n      display: flex;\n      justify-content: space-between;\n    }\n  }\n\n  .sub-total {\n    li {\n      position: relative;\n      display: inline-block;\n      font-size: 16px;\n      font-weight: 600;\n      color: #333333;\n      line-height: 20px;\n      margin-bottom: 20px;\n      width: 100%;\n\n      .count {\n        position: relative;\n        font-size: 18px;\n        line-height: 20px;\n        font-weight: 400;\n        width: 35%;\n        float: right;\n        text-align: right;\n      }\n    }\n\n    .shipping-class {\n      margin-bottom: 12px;\n\n      .shopping-checkout-option {\n        margin-top: -4px;\n        position: relative;\n        font-size: 18px;\n        line-height: 20px;\n        color: var(--theme-default);\n        font-weight: 400;\n        width: 35%;\n        float: right;\n        text-align: right;\n      }\n    }\n  }\n\n  .total {\n    position: relative;\n    margin-bottom: 30px;\n\n    li {\n      position: relative;\n      display: block;\n      font-weight: 400;\n      color: #333333;\n      line-height: 20px;\n      font-size: 18px;\n    }\n  }\n\n  .qty {\n    position: relative;\n    border-bottom: 1px solid #ededed;\n    margin-bottom: 30px;\n\n    li {\n      position: relative;\n      display: block;\n      font-size: 15px;\n      color: #444444;\n      line-height: 20px;\n      margin-bottom: 20px;\n\n      span {\n        float: right;\n        font-size: 18px;\n        line-height: 20px;\n        color: #232323;\n        font-weight: 400;\n        width: 35%;\n        text-align: right;\n      }\n    }\n  }\n}\n\n.radio-option {\n  position: relative;\n}\n\n.img-paypal {\n  width: 30%;\n  margin-left: 15px;\n}\n\n/**=====================\n    86. Checkout CSS Ends\n==========================**/\n\n/**=====================\n    Responsive CSS Start\n==========================**/\n@media screen and (max-width: 1199px) {\n  .checkout {\n    .checkout-details {\n      padding: 25px;\n    }\n  }\n\n  .order-box {\n    .title-box {\n      span {\n        width: 30%;\n      }\n    }\n\n    .sub-total {\n      li {\n        .count {\n          width: 38%;\n        }\n      }\n\n      .shipping-class {\n        .shopping-checkout-option {\n          width: 46%;\n        }\n      }\n    }\n\n    .qty {\n      li {\n        span {\n          width: 38%;\n        }\n      }\n    }\n\n    .total {\n      li {\n        .count {\n          width: 38%;\n        }\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 991px) {\n  .order-box {\n    .sub-total {\n      .shipping-class {\n        .shopping-checkout-option {\n          width: 38%;\n        }\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 575px) {\n  .checkout {\n    .checkout-details {\n      padding: 15px;\n    }\n  }\n  .order-box {\n    .sub-total {\n      .shipping-class {\n        .shopping-checkout-option {\n          width: 50%;\n        }\n      }\n\n      li {\n        .count {\n          width: 50%;\n        }\n      }\n    }\n  }\n}\n\n/**=====================\n    84. Checkout CSS ends\n==========================**/\n","/**=====================\n     27. Coming Soon CSS Start\n==========================**/\n.comingsoon-bgimg {\n  background: url(../../images/other-images/coming-soon-bg.jpg);\n  background-position: bottom;\n  background-size: cover;\n}\n\n.comingsoon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  padding: 50px 0;\n\n  .comingsoon-inner {\n    h5 {\n      font-size: 18px;\n      letter-spacing: 1px;\n      color: $theme-body-sub-title-color;\n      font-weight: 500;\n      margin-bottom: 30px;\n      margin-top: 30px;\n    }\n\n    .countdown {\n      padding: 30px 0;\n      border-top: 1px solid $light-color;\n      border-bottom: 1px solid $light-color;\n\n      .time {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        border-radius: 50%;\n        color: $white;\n        font-weight: 500;\n        width: 100px;\n        height: 100px;\n        font-size: 36px;\n        background: var(--theme-default);\n      }\n\n      .title {\n        padding-top: 13px;\n        font-size: 14px;\n        font-weight: 400;\n        color: $theme-body-sub-title-color;\n        text-transform: uppercase;\n        letter-spacing: 1px;\n      }\n\n      ul li {\n        display: inline-block;\n        text-transform: uppercase;\n        margin: 0 20px;\n\n        span {\n          display: block;\n        }\n      }\n    }\n  }\n\n  video {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    min-width: 100%;\n    min-height: 100%;\n    width: auto;\n    height: auto;\n    z-index: -100;\n    transform: translateX(-50%) translateY(-50%);\n    transition: 1s opacity;\n  }\n}\n\n/**=====================\n    27. Coming Soon CSS Ends\n==========================**/\n","/**=====================\n      86. contacts CSS Start\n==========================**/\n.alert-contactadd {\n  background-color: $white;\n  border: 1px solid var(--theme-default);\n  width: 12%;\n  padding: 10px;\n}\n\n.updateimg {\n  position: absolute;\n  left: 15px;\n  width: 100px;\n  top: 32px;\n  line-height: 93px;\n  opacity: 0;\n}\n\n#right-history {\n  top: 81px;\n  right: -320px;\n  height: 100%;\n  position: fixed;\n  width: 320px;\n  z-index: 9;\n  background-color: $white;\n  transition: 0.5s;\n  box-shadow: 0 0 9px rgba(191, 191, 191, 0.36);\n  [dir=\"rtl\"] & {\n    right: unset;\n    left: -320px;\n  }\n\n  h6 {\n    span {\n      a {\n        color: $theme-body-font-color;\n      }\n    }\n  }\n\n  &.show {\n    right: 0;\n    transition: 0.3s;\n    [dir=\"rtl\"] & {\n      right: unset;\n      left: 0;\n    }\n  }\n}\n\n.history-details {\n  > div {\n    padding: 30px 0;\n  }\n\n  .media {\n    padding: 30px 15px;\n    border-top: 1px solid $light-color;\n\n    i {\n      padding: 5px;\n      background: #fed112;\n      color: $white;\n      border-radius: 100%;\n    }\n\n    h6 {\n      margin-bottom: 5px;\n    }\n  }\n}\n\n.delete-contact {\n  display: none;\n}\n\n.more-data {\n  animation: displayTransition 1s;\n}\n\n.contact-editform {\n  padding: 30px;\n  animation: displayTransition 1s;\n\n  a {\n    display: block;\n  }\n\n  button {\n    margin-top: 30px;\n  }\n\n  .select2-container {\n    .select2-selection--single {\n      height: 39px !important;\n      border-color: #ced4da !important;\n    }\n  }\n}\n\n#deletemodal {\n  .modal-header {\n    border-bottom: none;\n\n    .delete-data {\n      span {\n        svg {\n          vertical-align: middle;\n          margin-right: 15px;\n        }\n      }\n    }\n  }\n}\n\n.contact-options {\n  li {\n    .btn-category {\n      line-height: 39px;\n      border-radius: 3px;\n      padding-left: 40px !important;\n      padding: 0;\n      color: var(--theme-default);\n      font-weight: 500;\n    }\n  }\n}\n\n.list-persons {\n  p {\n    font-family: $font-roboto, $font-serif;\n  }\n\n  .profile-mail {\n    padding: 30px 0;\n\n    .media {\n      img {\n        height: 100px;\n      }\n\n      .media-body {\n        h5 {\n          margin-bottom: 5px;\n        }\n\n        ul {\n          margin-top: 5px;\n\n          li {\n            display: inline-block;\n\n            a {\n              font-size: 13px;\n            }\n\n            + li {\n              padding-left: 10px;\n              margin-left: 5px;\n              border-left: 2px solid $light-color;\n            }\n          }\n        }\n      }\n    }\n\n    .email-general {\n      padding-top: 50px;\n\n      ul {\n        padding-right: 20px;\n\n        li {\n          color: $dark-gray;\n          padding-bottom: 10px;\n          margin-bottom: 10px;\n\n          &:last-child {\n            padding-bottom: 0;\n            margin-bottom: 0;\n          }\n\n          > span {\n            float: right;\n          }\n        }\n      }\n\n      p {\n        span {\n          margin-left: 30px;\n        }\n      }\n\n      .gender {\n        margin-top: 30px;\n      }\n    }\n  }\n}\n\n.contacts-tabs {\n  .nav-pills {\n    border-right: 1px solid $light-color;\n    height: 100%;\n\n    .nav-link,\n    .show {\n      &.active,\n      > .nav-link {\n        background-color: rgba($primary-color, 0.05);\n        color: $theme-body-font-color;\n      }\n    }\n\n    .nav-link {\n      color: $theme-body-font-color;\n      padding: 0;\n\n      .media {\n        .img-50 {\n          height: 50px;\n        }\n      }\n\n      + .nav-link {\n        border-top: 1px solid $light-color;\n      }\n    }\n\n    .media {\n      padding: 20px;\n    }\n  }\n\n  .tab-content {\n    .tab-content-child {\n      animation: displayTransition 1s;\n    }\n  }\n}\n\n// responsive\n@media only screen and (max-width: 991px) {\n  #right-history {\n    top: 60px;\n  }\n\n  .updateimg {\n    top: 21px;\n  }\n\n  .list-persons {\n    .profile-mail {\n      padding: 20px;\n\n      .email-general {\n        .gender {\n          margin-top: 20px;\n        }\n      }\n    }\n  }\n\n  .contact-editform {\n    button {\n      margin-top: 20px;\n    }\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .contact-editform {\n    padding: 20px;\n\n    &.pl-0 {\n      padding-left: 20px !important;\n    }\n  }\n\n  .contacts-tabs {\n    .nav-pills {\n      border-right: none;\n      border-bottom: 1px solid $light-color;\n    }\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  #right-history {\n    width: 270px;\n  }\n\n  .updateimg {\n    top: 16px;\n    left: 29px;\n  }\n\n  .contacts-tabs {\n    .media {\n      img {\n        &.m-r-20 {\n          margin-right: 15px;\n        }\n      }\n    }\n\n    .nav-pills {\n      .media {\n        padding: 15px;\n      }\n    }\n  }\n\n  .list-persons {\n    .profile-mail {\n      padding: 15px;\n\n      .email-general {\n        .gender {\n          margin-top: 15px;\n        }\n      }\n    }\n\n    .nav-pills {\n      .nav-link {\n        .media {\n          .media-body {\n            text-align: left;\n          }\n        }\n      }\n    }\n  }\n\n  .contact-editform {\n    padding: 15px;\n\n    button {\n      margin-top: 15px;\n    }\n\n    &.pl-0 {\n      padding-left: 15px !important;\n    }\n  }\n\n  .contact-editform,\n  .contact-options {\n    form {\n      .row {\n        > div {\n          .row {\n            > div {\n              > div {\n                margin-bottom: 0;\n              }\n\n              + div {\n                margin-top: 15px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 360px) {\n  .updateimg {\n    line-height: 73px;\n    width: 80px;\n  }\n\n  .list-persons {\n    .profile-mail {\n      .email-general {\n        p {\n          span {\n            margin-left: 10px;\n          }\n        }\n      }\n\n      .media {\n        display: block;\n\n        img {\n          height: 80px;\n          width: 80px !important;\n          margin-bottom: 15px;\n        }\n      }\n    }\n  }\n}\n\n/**=====================\n    86. contacts CSS Ends\n==========================**/\n","/**=====================\n      67. Dashboard 2 CSS Start\n==========================**/\n.widget-decor {\n  position: absolute;\n  height: 60px;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.balance-widget {\n  background-image: url(../../images/dashboard-2/balance-bg.png);\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: right;\n  .mobile-right-img {\n    position: absolute;\n    top: 10px;\n    right: 15px;\n    .left-mobile-img {\n      margin-right: -20px;\n    }\n    .mobile-img {\n      height: 130px;\n    }\n    [dir=\"rtl\"] & {\n      right: unset;\n      left: 15px;\n    }\n    @media (max-width: 480px) {\n      right: 0;\n      .mobile-img {\n        height: 100px;\n      }\n      [dir=\"rtl\"] & {\n        right: unset;\n        left: 0;\n      }\n    }\n  }\n  [dir=\"rtl\"] & {\n    text-align: right;\n  }\n  &.card-body {\n    padding: 20px 15px;\n  }\n  .purchase-btn {\n    min-width: 170px;\n  }\n}\n.small-widget {\n  overflow: hidden;\n  h4 {\n    margin-bottom: -3px;\n  }\n  i {\n    font-weight: 700;\n    font-size: 11px;\n  }\n  .card-body {\n    padding: 24px 15px;\n  }\n  .bg-gradient {\n    width: 66px;\n    height: 67px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 100px;\n    right: -12px;\n    top: 50%;\n    position: absolute;\n    transform: translateY(-50%);\n    [dir=\"rtl\"] & {\n      right: unset;\n      left: -12px;\n      transform: translateY(-50%) scaleX(-1);\n    }\n    @media (max-width: 1399px) {\n      width: 60px;\n      height: 60px;\n    }\n    svg {\n      width: 25px;\n      height: 25px;\n      @media (max-width: 1399px) {\n        width: 22px;\n        height: 22px;\n      }\n    }\n  }\n  &:hover {\n    transform: translateY(-5px);\n    transition: 0.5s;\n    .bg-gradient {\n      svg {\n        animation: tada 1.5s ease infinite;\n      }\n    }\n  }\n}\n.appointment {\n  .customer-table {\n    @media (max-width: 1470px) {\n      height: 268px;\n    }\n    @media (max-width: 1399px) {\n      height: unset;\n    }\n  }\n}\n.order-wrapper {\n  margin: 0 -24px -17px -17px;\n}\n.categories-list {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  @media (max-width: 767px) {\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n  li {\n    gap: 10px;\n    .bg-light {\n      min-width: 40px;\n      height: 40px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      img {\n        width: 25px;\n        height: 25px;\n        object-fit: contain;\n        transition: 0.5s;\n      }\n    }\n    h6 {\n      a {\n        transition: 0.5s;\n        color: var(--body-font-color);\n      }\n    }\n    &:hover {\n      .bg-light {\n        img {\n          transition: 0.5s;\n          transform: scale(1.1);\n        }\n      }\n      h6 {\n        a {\n          transition: 0.5s;\n          color: var(--theme-default);\n        }\n      }\n    }\n  }\n}\n.monthly-profit {\n  margin-top: -10px;\n  @media (max-width: 1584px) {\n    margin: -10px -8px 0;\n  }\n  @media (max-width: 1520px) {\n    margin: -10px -16px 0;\n  }\n  @media (max-width: 1500px) {\n    margin: -10px -14px 0;\n  }\n  @media (max-width: 1472px) {\n    margin: -10px -20px 0;\n  }\n  @media (max-width: 1424px) {\n    margin: -10px -25px 0;\n  }\n  .apexcharts-canvas {\n    .apexcharts-legend-marker {\n      margin-right: 6px;\n    }\n    .apexcharts-datalabels-group {\n      .apexcharts-datalabel-value {\n        font-size: 14px;\n        font-weight: 500;\n        font-family: $font-rubik, $font-serif !important;\n        fill: var(--chart-text-color);\n      }\n    }\n  }\n}\n.overview-wrapper {\n  position: relative;\n  z-index: 1;\n}\n.back-bar-container {\n  position: absolute;\n  width: calc(100% - 64px);\n  bottom: -8px;\n  margin: 0 auto !important;\n  left: 28px;\n  @media (max-width: 1199px) {\n    bottom: 22px;\n  }\n  @media (max-width: 480px) {\n    width: calc(100% - 34px);\n    left: 18px;\n  }\n  @media (max-width: 327px) {\n    bottom: 42px;\n  }\n}\n.overview-card {\n  .balance-data {\n    right: 12px;\n    [dir=\"rtl\"] & {\n      right: unset;\n      left: 12px;\n    }\n    @media (max-width: 767px) {\n      right: -40%;\n      [dir=\"rtl\"] & {\n        left: -40%;\n      }\n    }\n  }\n}\n.order-container {\n  .apexcharts-canvas {\n    .apexcharts-marker {\n      stroke-width: 4;\n    }\n  }\n}\n.purchase-card.discover {\n  margin-top: 102px;\n  img {\n    width: 224px;\n    margin: 0 auto;\n    margin-top: -90px;\n    @media (max-width: 1550px) {\n      margin-top: -110px;\n    }\n    @media (max-width: 1399px) {\n      margin-top: -90px;\n    }\n    @media (max-width: 991px) {\n      margin-top: -110px;\n    }\n    @media (max-width: 618px) {\n      width: 200px;\n    }\n  }\n}\n.visitor-card {\n  .card-header {\n    svg {\n      width: 18px;\n      height: 18px;\n      fill: var(--theme-default);\n    }\n  }\n}\n.visitors-container {\n  margin: 0 -12px -27px -17px;\n  svg {\n    .apexcharts-series {\n      path {\n        clip-path: inset(1% 0% 0% 0% round 3rem);\n      }\n    }\n    .apexcharts-legend.apexcharts-align-left {\n      .apexcharts-legend-series {\n        display: flex;\n      }\n    }\n  }\n}\n.recent-order {\n  .nav {\n    gap: 8px;\n    flex-wrap: nowrap;\n    overflow: auto;\n    padding-bottom: 5px;\n    display: flex;\n  }\n  .frame-box {\n    border: 1px solid transparent;\n    padding: 0;\n    transition: 0.5s;\n    &.active {\n      border: 1px solid var(--theme-default);\n    }\n    &:hover {\n      transform: translateY(-5px);\n      transition: 0.5s;\n    }\n  }\n  .tab-content {\n    margin-top: 16px;\n  }\n}\n.recent-table {\n  table {\n    thead {\n      background: var(--light2);\n      th {\n        padding-top: 9px;\n        padding-bottom: 9px;\n        border-bottom: none;\n      }\n    }\n    tr {\n      td,\n      th {\n        padding: 12px 8px;\n        vertical-align: middle;\n        &:first-child {\n          min-width: 157px;\n        }\n        &:nth-child(2) {\n          @media (max-width: 1660px) {\n            min-width: 97px;\n          }\n        }\n        &:last-child {\n          min-width: 96px;\n        }\n      }\n      td {\n        &:first-child {\n          padding-left: 0;\n          [dir=\"rtl\"] & {\n            padding-left: unset;\n            padding-right: 0;\n          }\n        }\n        &:last-child {\n          padding-right: 0;\n          [dir=\"rtl\"] & {\n            padding-left: 0;\n            padding-right: unset;\n          }\n        }\n      }\n      &:last-child {\n        td {\n          padding-bottom: 0;\n          border-bottom: none;\n        }\n      }\n      .product-content {\n        h6 {\n          a {\n            color: var(--body-font-color);\n            transition: 0.5s;\n          }\n        }\n      }\n      &:hover {\n        .product-content {\n          h6 {\n            a {\n              color: var(--theme-default);\n              transition: 0.5s;\n            }\n          }\n        }\n      }\n    }\n  }\n  .product-content {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    .order-image {\n      background: var(--light2);\n      width: 40px;\n      height: 40px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n  }\n  svg {\n    width: 20px;\n    height: 20px;\n  }\n  .recent-status {\n    display: flex;\n    align-items: center;\n    &.font-success {\n      svg {\n        fill: $success-color;\n      }\n    }\n    &.font-danger {\n      svg {\n        fill: $danger-color;\n      }\n    }\n  }\n}\n.recent-activity {\n  h5 {\n    padding: 30px 0 20px;\n    margin-bottom: 0;\n  }\n  h6 {\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    -webkit-line-clamp: 2;\n    display: -webkit-box;\n  }\n  ul {\n    li {\n      span {\n        -webkit-box-orient: vertical;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        -webkit-line-clamp: 2;\n        display: -webkit-box;\n      }\n    }\n  }\n}\n.notification {\n  li {\n    .recent-images {\n      ul {\n        &::before {\n          display: none;\n        }\n      }\n      li {\n        padding-bottom: 3px;\n      }\n    }\n  }\n}\n.recent-images {\n  margin-top: 10px;\n  ul {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n  li {\n    border: 1px dashed var(--recent-dashed-border);\n    padding: 3px;\n    border-radius: 2px;\n    .recent-img-wrap {\n      width: 40px;\n      height: 40px;\n      background: var(--light2);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n  }\n}\n.frame-box {\n  background: var(--recent-box-bg);\n  border-radius: 10px;\n  min-width: 76px;\n  box-shadow: 2px 2px 2px var(--recent-border);\n  @media (max-width: 575px) {\n    min-width: 65px;\n  }\n  .frame-image {\n    min-width: 62px;\n    height: 62px;\n    border-color: var(--recent-border) var(--white) var(--white) var(--recent-border);\n    border-width: 1px;\n    border-style: solid;\n    margin: 6px;\n    display: flex;\n    align-items: center;\n    border-radius: 4px;\n    @media (max-width: 575px) {\n      min-width: 50px;\n      height: 50px;\n      margin: 4px;\n    }\n  }\n  img {\n    margin: 0 auto;\n    @media (max-width: 575px) {\n      height: 30px;\n    }\n  }\n}\n\n.support-ticket-font {\n  ul {\n    font-size: 12px;\n  }\n}\n.new-update {\n  .media {\n    .media-body {\n      span,\n      p {\n        font-weight: 500;\n      }\n    }\n  }\n}\n\n@each $activity-dot-name, $activity-dot-color in (primary, $primary-color), (secondary, $secondary-color), (success, $success-color), (danger, $danger-color), (info, $info-color), (light, $light-color), (dark, $dark-color), (warning, $warning-color) {\n  .activity-dot-#{$activity-dot-name} {\n    min-width: 6px;\n    width: 6px;\n    height: 6px;\n    background-color: $activity-dot-color;\n    border-radius: 100%;\n    outline: 5px solid rgba($activity-dot-color, 0.25);\n    position: relative;\n    z-index: 2;\n  }\n}\n\n// responsive\n@media only screen and (max-width: 1800px) and (min-width: 1400px) {\n  .grid-ed-none {\n    display: none !important;\n  }\n  .grid-ed-12 {\n    width: 100%;\n  }\n}\n@media only screen and (max-width: 1660px) and (min-width: 1400px) {\n  .col-ed-12 {\n    width: 100%;\n  }\n  .col-ed-7 {\n    width: 58%;\n  }\n  .col-ed-5 {\n    width: 42%;\n  }\n  .col-ed-9 {\n    width: 75%;\n  }\n  .col-ed-3 {\n    width: 25%;\n  }\n  .col-ed-6 {\n    width: 50%;\n  }\n  .col-ed-4 {\n    width: 33.33333333%;\n  }\n  .col-ed-8 {\n    width: 66.66%;\n  }\n  .col-ed-none {\n    display: none !important;\n  }\n}\n@media only screen and (max-width: 1660px) and (min-width: 1200px) {\n  .xl-30 {\n    max-width: 30%;\n    flex: 0 0 30%;\n  }\n  .xl-70 {\n    max-width: 70%;\n    flex: 0 0 70%;\n  }\n}\n\n@media only screen and (max-width: 420px) {\n  .size-column {\n    .col-6 {\n      width: 100%;\n    }\n  }\n}\n\n/**=====================\n     67. Dashboard 2  CSS End\n==========================**/\n","/**=====================\n     Dashboard 3 CSS Start\n==========================**/\n@keyframes hand-move {\n  0% {\n    transform: rotate(0deg);\n  }\n  20% {\n    transform: rotate(15deg);\n  }\n  50% {\n    transform: rotate(0deg);\n  }\n  80% {\n    transform: rotate(-15deg);\n  }\n  100% {\n    transform: rotate(0deg);\n  }\n}\n.welcome-card {\n  background-image: url(../../images/dashboard-3/bg.jpg);\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  color: $white;\n  h4 {\n    img {\n      margin-top: -6px;\n      animation: hand-move 5s infinite ease-in;\n    }\n  }\n  p {\n    width: 75%;\n    @media (max-width: 1830px) {\n      width: 62%;\n    }\n    @media (max-width: 991px) {\n      width: 70%;\n    }\n    @media (max-width: 480px) {\n      width: 100%;\n    }\n  }\n  .welcome-img {\n    height: 200px;\n    position: absolute;\n    right: 0;\n    bottom: -32px;\n    [dir=\"rtl\"] & {\n      right: unset;\n      left: 0;\n    }\n    @media (max-width: 1780px) {\n      height: 180px;\n      bottom: -28px;\n    }\n    @media (max-width: 1700px) {\n      bottom: -23px;\n    }\n    @media (max-width: 767px) {\n      height: 140px;\n      bottom: -18px;\n    }\n    @media (max-width: 480px) {\n      display: none;\n    }\n  }\n}\n.course-box {\n  overflow: hidden;\n  .card-body {\n    padding: 25px 15px;\n    @media (max-width: 1722px) {\n      padding: 20px 15px;\n    }\n    @media (max-width: 1660px) {\n      padding: 16px 15px;\n    }\n  }\n  &.widget-course {\n    .card-body {\n      @media (max-width: 1660px) {\n        padding: 25px 15px;\n      }\n    }\n  }\n  &:hover {\n    transform: translateY(-5px);\n    transition: 0.5s;\n    .course-icon {\n      svg {\n        animation: tada 1.5s ease infinite;\n      }\n    }\n  }\n}\n.course-widget {\n  display: flex;\n  gap: 8px;\n  .course-icon {\n    position: relative;\n    width: 54px;\n    height: 54px;\n    clip-path: polygon(\n      40% 7.67949%,\n      43.1596% 6.20615%,\n      46.52704% 5.30384%,\n      50% 5%,\n      53.47296% 5.30384%,\n      56.8404% 6.20615%,\n      60% 7.67949%,\n      81.65064% 20.17949%,\n      84.50639% 22.17911%,\n      86.97152% 24.64425%,\n      88.97114% 27.5%,\n      90.44449% 30.6596%,\n      91.34679% 34.02704%,\n      91.65064% 37.5%,\n      91.65064% 62.5%,\n      91.34679% 65.97296%,\n      90.44449% 69.3404%,\n      88.97114% 72.5%,\n      86.97152% 75.35575%,\n      84.50639% 77.82089%,\n      81.65064% 79.82051%,\n      60% 92.32051%,\n      56.8404% 93.79385%,\n      53.47296% 94.69616%,\n      50% 95%,\n      46.52704% 94.69616%,\n      43.1596% 93.79385%,\n      40% 92.32051%,\n      18.34936% 79.82051%,\n      15.49361% 77.82089%,\n      13.02848% 75.35575%,\n      11.02886% 72.5%,\n      9.55551% 69.3404%,\n      8.65321% 65.97296%,\n      8.34936% 62.5%,\n      8.34936% 37.5%,\n      8.65321% 34.02704%,\n      9.55551% 30.6596%,\n      11.02886% 27.5%,\n      13.02848% 24.64425%,\n      15.49361% 22.17911%,\n      18.34936% 20.17949%\n    );\n    background: linear-gradient(310.31deg, #ff3364 14.71%, #ff7f9e 100%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    svg {\n      width: 26px;\n      height: 26px;\n      fill: $white;\n    }\n    &.warning {\n      background: linear-gradient(297.08deg, #ff9e2a -4.53%, #ffa941 98.25%);\n    }\n  }\n  .btn-light {\n    background: var(--course-light-btn) !important;\n    border: none;\n  }\n  a {\n    display: flex;\n    align-items: center;\n    padding: 8px 12px;\n    margin-top: 25px;\n    span {\n      display: block;\n      margin-bottom: -5px;\n    }\n    svg {\n      width: 13px;\n      height: 13px;\n    }\n  }\n}\n.get-card {\n  .card-header {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n}\n.square-group {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  transform: scaleX(-1);\n  [dir=\"rtl\"] & {\n    right: unset;\n    left: 0;\n  }\n  .square-1 {\n    width: 12px;\n    height: 18px;\n  }\n  .square-2 {\n    width: 12px;\n    height: 10px;\n    margin-bottom: -10px;\n  }\n  .square-3 {\n    width: 18px;\n    height: 10px;\n    margin-left: 10px;\n    [dir=\"rtl\"] & {\n      margin-left: unset;\n      margin-right: 10px;\n    }\n  }\n  .square-4 {\n    width: 16px;\n    height: 16px;\n    position: absolute;\n    top: 20px;\n    right: -15px;\n    [dir=\"rtl\"] & {\n      right: unset;\n      left: -15px;\n    }\n  }\n  .square-5 {\n    width: 6px;\n    height: 6px;\n    bottom: 22px;\n    position: absolute;\n    right: -1px;\n    [dir=\"rtl\"] & {\n      right: unset;\n      left: -1px;\n    }\n  }\n  .square-6,\n  .square-7 {\n    position: absolute;\n    width: 4px;\n    height: 4px;\n  }\n  .square-6 {\n    right: -23px;\n    bottom: 5px;\n    [dir=\"rtl\"] & {\n      right: unset;\n      left: -23px;\n    }\n  }\n  .square-7 {\n    right: 8px;\n    bottom: 45px;\n    [dir=\"rtl\"] & {\n      right: unset;\n      left: 8px;\n    }\n  }\n  .warning1 {\n    background: #ffd497 !important;\n  }\n  .warning {\n    background: #ffa73b !important;\n  }\n  .primary {\n    background: $primary-color !important;\n  }\n  .danger {\n    background: #f54132 !important;\n  }\n  .light {\n    background: #e6e8ef !important;\n  }\n  .success {\n    background: $success-color !important;\n  }\n}\n.progress-chart-wrap {\n  margin: -40px 0 -22px;\n  [dir=\"rtl\"] & {\n    direction: ltr;\n  }\n  @media (max-width: 991px) {\n    margin-top: -18px;\n  }\n  .apexcharts-canvas {\n    margin: 0 auto;\n    .apexcharts-datalabels-group {\n      .apexcharts-datalabel-label {\n        fill: var(--chart-text-color);\n      }\n    }\n  }\n}\n.get-card {\n  .btn {\n    margin-top: 15px;\n    padding: 8px 15px;\n    &:hover {\n      svg {\n        transform: translateX(5px);\n        transition: 0.5s;\n      }\n    }\n    svg {\n      width: 13px;\n      height: 13px;\n      fill: $white;\n      vertical-align: middle;\n      transition: 0.5s;\n    }\n  }\n}\n.default-datepicker {\n  .datepicker-inline {\n    .datepicker {\n      width: auto;\n      background: $white;\n      box-shadow: none;\n      padding: 0;\n\n      .datepicker--content {\n        padding: 0;\n        .datepicker--days {\n          .datepicker--days-names {\n            margin: 27px 0 0;\n            padding: 15px 0;\n\n            .datepicker--day-name {\n              color: $dark-editor-document;\n              font-size: 14px;\n            }\n          }\n\n          .datepicker--cells {\n            .datepicker--cell-day {\n              height: 35px;\n              width: 14%;\n              color: $dark-editor-document;\n\n              &.-other-month- {\n                color: $dark-editor-document;\n                opacity: 20%;\n              }\n              &.-weekend- {\n                + .-weekend- {\n                  color: $danger-color;\n                }\n              }\n            }\n\n            .datepicker--cell {\n              font-weight: 500;\n              font-size: 14px;\n              line-height: 17px;\n              z-index: 0;\n              letter-spacing: 2px;\n\n              &.-selected- {\n                background: var(--theme-default);\n                color: $white;\n                position: relative;\n                box-shadow: 0px 0px 13px 0 rgba($primary-color, 0.5);\n              }\n\n              &.-current- {\n                background-color: $success-color;\n                border: none;\n                color: $white;\n                &::after {\n                  position: absolute;\n                  content: \"\";\n                  width: 10px;\n                  height: 10px;\n                  border: 2px solid var(--white);\n                  background: $danger-color;\n                  right: -3px;\n                  top: -2px;\n                  border-radius: 100%;\n                }\n              }\n\n              &.-focus- {\n                color: $white;\n                box-shadow: none;\n              }\n            }\n          }\n        }\n\n        .datepicker-cell {\n          .datepicker--cell-month {\n            &.-current- {\n              &.-selected- {\n                background-color: var(--theme-default);\n              }\n            }\n          }\n        }\n      }\n\n      .datepicker--nav {\n        border-bottom: none;\n        padding: 0;\n        text-transform: capitalize;\n        margin-top: 0;\n\n        .datepicker--nav-action {\n          background-color: transparent;\n          width: 22px;\n          height: 22px;\n          &[data-action=\"prev\"] {\n            position: absolute;\n            right: 50px;\n            [dir=\"rtl\"] & {\n              right: unset;\n              left: 50px;\n            }\n          }\n          svg {\n            width: 22px;\n            height: 22px;\n          }\n          path {\n            stroke: var(--chart-text-color);\n          }\n        }\n      }\n\n      .datepicker--nav-title {\n        color: $dark-editor-document;\n        font-size: 20px;\n        font-weight: 500;\n        @media (max-width: 767px) {\n          font-size: 14px;\n        }\n\n        i {\n          margin-left: 10px;\n          font-weight: 500;\n          font-size: 20px;\n          color: $dark-editor-document;\n          @media (max-width: 767px) {\n            font-size: 14px;\n          }\n        }\n      }\n    }\n  }\n}\n.learning-wrap {\n  margin: -24px -10px -24px -15px;\n}\n.activity-wrap {\n  margin: -22px 0 -22px -28px;\n  [dir=\"rtl\"] & {\n    margin: -22px -28px -22px 0;\n  }\n}\n.upcoming-event-wrap {\n  margin-bottom: -39px;\n  margin-left: -24px;\n}\n.course-card {\n  .dropdown {\n    .dropdown-toggle {\n      width: 125px;\n    }\n  }\n}\n.course-wrapper {\n  text-align: center;\n  .course-icon-box {\n    position: relative;\n    padding: 8px;\n    @media (max-width: 767px) {\n      padding: 0;\n    }\n    .icon-wrap {\n      width: 117px;\n      height: 92px;\n      background-color: var(--course-bg);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 8px;\n      margin: 0 auto;\n      box-shadow: -18px 15px 20px rgba(119, 119, 119, 0.25);\n      @media (max-width: 1880px) {\n        width: 112px;\n      }\n      @media (max-width: 767px) {\n        box-shadow: none;\n      }\n      @media (max-width: 575px) {\n        width: 92px;\n        height: 82px;\n      }\n      img {\n        width: 80px;\n        @media (max-width: 575px) {\n          width: 70px;\n        }\n      }\n    }\n    .arrow-bg {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: calc(100% + 20px);\n      height: 100%;\n      [dir=\"rtl\"] & {\n        left: unset;\n        right: 0;\n        transform: scaleX(-1);\n      }\n      @media (max-width: 767px) {\n        display: none;\n      }\n    }\n  }\n  h6 {\n    margin-top: 25px;\n    margin-bottom: 0;\n    @media (max-width: 575px) {\n      margin-top: 15px;\n    }\n  }\n}\n.course-main-card {\n  display: flex;\n  gap: 20px;\n  justify-content: center;\n  @media (max-width: 1880px) {\n    flex-wrap: wrap;\n  }\n  @media (max-width: 767px) {\n    gap: 12px;\n    flex-wrap: nowrap;\n  }\n  @media (max-width: 575px) {\n    gap: 20px;\n    flex-wrap: wrap;\n  }\n  .course-wrapper {\n    &:last-child {\n      .arrow-bg {\n        width: 100%;\n      }\n    }\n  }\n}\n.schedule-list {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  @media (max-width: 767px) {\n    flex-direction: row;\n  }\n  @media (max-width: 575px) {\n    flex-direction: column;\n  }\n  li {\n    display: flex;\n    align-items: center;\n    h6 {\n      font-size: 14px;\n    }\n    ul {\n      column-count: 2;\n      column-rule-style: solid;\n      column-rule-color: var(--chart-text-color);\n      column-gap: 20px;\n      column-rule-width: 1px;\n      @media (max-width: 1712px) {\n        column-gap: 14px;\n      }\n      @media (max-width: 1199px) {\n        display: flex;\n        flex-wrap: wrap;\n      }\n      li {\n        gap: 6px;\n      }\n    }\n    img {\n      border-radius: 100%;\n      width: 37px;\n      height: 37px;\n      padding: 3px;\n    }\n    svg {\n      width: 15px;\n      height: 15px;\n      &.f-success {\n        fill: $success-color;\n      }\n    }\n  }\n  > li {\n    padding: 15px 20px !important;\n    box-shadow: 4px 7px 17px 5px rgba(46, 35, 94, 0.05) !important;\n    gap: 10px;\n    position: relative;\n    border-radius: 10px;\n    @media (max-width: 1712px) {\n      padding: 16px 14px;\n    }\n    &::before {\n      position: absolute;\n      content: \"\";\n      width: 5px;\n      height: 100%;\n      left: 0;\n      top: 0;\n      border-radius: 15px 0 0 15px;\n      [dir=\"rtl\"] & {\n        left: unset;\n        right: 0;\n        border-radius: 0 15px 15px 0;\n      }\n    }\n    &.primary {\n      &::before {\n        background-color: var(--theme-default);\n      }\n      img {\n        border: 1px solid var(--theme-default);\n      }\n    }\n    &.warning {\n      &::before {\n        background-color: $warning-color;\n      }\n      img {\n        border: 1px solid $warning-color;\n      }\n    }\n  }\n}\n.link-only {\n  display: flex;\n  align-items: center;\n  color: $theme-body-sub-title-color;\n  svg {\n    width: 16px;\n    height: 16px;\n  }\n}\n.general-cal {\n  .react-datepicker__current-month {\n    padding: 0;\n  }\n  .react-datepicker__navigation {\n    top: 0;\n  }\n  .cal-date-widget {\n    .cal-datepicker {\n      .datepicker-here {\n        width: 100%;\n        .react-datepicker {\n          width: 100%;\n          border: 0;\n          .react-datepicker__month-container {\n            float: none;\n            width: 100%;\n          }\n        }\n\n        .react-datepicker__day,\n        .react-datepicker__time-name {\n          width: 100% !important;\n          line-height: 2.17rem !important;\n          border-radius: 10px;\n        }\n        .react-datepicker__day-names {\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          .react-datepicker__day-name {\n            width: 100% !important;\n          }\n        }\n      }\n    }\n  }\n  .datepicker {\n    padding: 20px;\n    border-radius: 20px;\n  }\n  .cal-info h2 {\n    font-size: 100px;\n    color: $light-gray;\n  }\n}\n.lessons-lists {\n  li {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 12px 0 !important;\n    img {\n      transition: 0.5s;\n    }\n    + li {\n      border-top: 1px solid var(--chart-dashed-border) !important;\n    }\n    &:first-child {\n      padding-top: 0 !important;\n    }\n    &:last-child {\n      padding-bottom: 0 !important;\n    }\n    &:hover {\n      img {\n        transform: scale(1.1);\n        transition: 0.5s;\n      }\n    }\n  }\n}\n.lesson-wrap {\n  width: 50px;\n  margin-bottom: -11px;\n  margin-top: -6px;\n  .apexcharts-canvas {\n    .apexcharts-datalabel-label {\n      display: none;\n    }\n  }\n}\n\n// responsive\n\n@media only screen and (max-width: 575px) {\n  .default-datepicker {\n    .datepicker-inline {\n      .datepicker {\n        .datepicker--nav-title {\n          font-size: 17px;\n\n          i {\n            font-size: 17px;\n            margin-left: 10px;\n          }\n        }\n\n        .datepicker--content {\n          .datepicker--days {\n            .datepicker--cells {\n              .datepicker--cell {\n                font-size: 13px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 360px) {\n  .default-datepicker {\n    .datepicker-inline {\n      .datepicker {\n        .datepicker--content {\n          .datepicker--days {\n            .datepicker--cells {\n              .datepicker--cell {\n                &.-selected- {\n                  &:before {\n                    height: 36px;\n                  }\n                }\n              }\n\n              .datepicker--cell-day {\n                height: 36px;\n              }\n            }\n\n            .datepicker--days-names {\n              margin: 13px 0 13px;\n\n              .datepicker--day-name {\n                font-size: 12px;\n              }\n            }\n          }\n        }\n\n        .datepicker--nav-title {\n          i {\n            margin-left: 15px;\n            font-size: 25px;\n          }\n        }\n      }\n    }\n  }\n}\n","/**=====================\n     Dashboard 4 CSS Start\n==========================**/\n.widget-hover {\n  &:hover {\n    transform: translateY(-5px);\n    transition: 0.5s;\n  }\n}\n.currency-widget {\n  .currency-icon-widget {\n    width: 35px;\n    height: 35px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 5px;\n    box-shadow: inset 2.66667px -2.66667px 2.66667px rgba(194, 128, 49, 0.1), inset -2.66667px 2.66667px 2.66667px rgba(255, 255, 255, 0.1);\n    svg {\n      width: 16px;\n      height: 16px;\n      fill: $white;\n    }\n  }\n  .card {\n    margin-top: 14px;\n    .card-body {\n      padding: 15px;\n      gap: 10px;\n      justify-content: space-between;\n      @media (max-width: 1660px) {\n        flex-wrap: wrap;\n      }\n      @media (max-width: 575px) {\n        flex-wrap: unset;\n      }\n    }\n    &:hover {\n      transform: translateY(-5px);\n      transition: 0.5s;\n    }\n  }\n  h6 {\n    margin-bottom: 0;\n  }\n  .d-flex {\n    gap: 10px;\n    align-items: center;\n  }\n  span {\n    svg {\n      width: 16px;\n      height: 16px;\n      vertical-align: middle;\n    }\n  }\n  div[class*=\"bg-light-\"] {\n    color: $theme-body-font-color;\n    padding: 15px;\n    border-radius: 10px;\n    width: 115px;\n    @media (max-width: 1660px) and (min-width: 1200px) {\n      display: none;\n    }\n    @media (max-width: 1199px) {\n      width: 100%;\n    }\n    @media (max-width: 575px) {\n      width: 50%;\n    }\n  }\n  &.widget-currency {\n    .card {\n      .card-body {\n        @media (max-width: 1199px) and (min-width: 768px) {\n          flex-wrap: unset;\n        }\n      }\n    }\n  }\n  &.warning {\n    .currency-icon-widget {\n      background-image: linear-gradient(to right, $warning-color 80%, rgba($warning-color, 0.2));\n    }\n  }\n  &.primary {\n    .currency-icon-widget {\n      background-image: linear-gradient(to right, $primary-color 80%, rgba($primary-color, 0.2));\n    }\n  }\n  &.success {\n    .currency-icon-widget {\n      background-image: linear-gradient(to right, $success-color 80%, rgba($success-color, 0.2));\n    }\n  }\n  &.height-equal {\n    @media (max-width: 1399px) {\n      min-height: unset !important;\n    }\n  }\n}\n.currency-chart-wrap {\n  margin: -28px -10px -20px -20px;\n  @media (max-width: 575px) {\n    width: 50%;\n  }\n  .apexcharts-canvas {\n    .apexcharts-tooltip-text-y-label {\n      display: none;\n    }\n  }\n}\n.tranaction-card {\n  .header-top {\n    flex-wrap: wrap;\n    gap: 10px;\n  }\n}\n.crypto-main-card {\n  background-image: linear-gradient(to bottom right, #5f3deb, #ad79ff);\n  color: $white;\n  .card-body {\n    @media (max-width: 1199px) {\n      padding: 20px;\n    }\n  }\n  .btn {\n    padding: 8px 20px;\n    @media (max-width: 1660px) {\n      padding: 8px 15px;\n    }\n  }\n  .deposit-wrap {\n    > div {\n      width: 65%;\n      @media (max-width: 1660px) {\n        width: 90%;\n      }\n      @media (max-width: 1536px) {\n        width: 100%;\n      }\n      @media (max-width: 1399px) {\n        width: 75%;\n      }\n      @media (max-width: 1199px) {\n        width: 95%;\n      }\n      h5 {\n        @media (max-width: 1660px) {\n          -webkit-box-orient: vertical;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          -webkit-line-clamp: 2;\n          display: -webkit-box;\n        }\n        @media (max-width: 767px) {\n          -webkit-line-clamp: 1;\n        }\n      }\n    }\n    img {\n      position: absolute;\n      right: 10px;\n      bottom: 10px;\n      width: 55%;\n      [dir=\"rtl\"] & {\n        right: unset;\n        left: 10px;\n        transform: scaleX(-1);\n      }\n      @media (max-width: 1660px) {\n        width: 44%;\n      }\n      @media (max-width: 1399px) {\n        width: 52%;\n      }\n      @media (max-width: 1199px) {\n        width: 30%;\n      }\n    }\n  }\n}\n.portfolio-card {\n  .dropdown-toggle {\n    width: 80px;\n  }\n}\n.btn-white {\n  color: $primary-color;\n  background-color: $white;\n}\n.radial-progress-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 6px;\n  &.card-body {\n    padding: 23px 20px;\n    @media (max-width: 1199px) {\n      padding: 30px 20px;\n    }\n  }\n  p {\n    -webkit-line-clamp: 1;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    -webkit-box-orient: vertical;\n    display: -webkit-box;\n  }\n  h6 {\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    -webkit-line-clamp: 1;\n    display: -webkit-box;\n  }\n\n  .sale-details {\n    margin: 10px 0;\n    svg {\n      width: 15px;\n      height: 15px;\n      vertical-align: middle;\n    }\n  }\n  .radial-chart-wrap {\n    width: 110px;\n    margin-right: -25px;\n    [dir=\"rtl\"] & {\n      margin-right: unset;\n      margin-left: -25px;\n    }\n    @media (max-width: 1820px) {\n      margin-right: -12px;\n      [dir=\"rtl\"] & {\n        margin-left: -12px;\n      }\n    }\n    .apexcharts-canvas {\n      .apexcharts-datalabel-label {\n        display: none;\n      }\n    }\n  }\n}\n.transaction-table {\n  table {\n    tr {\n      &:first-child {\n        td {\n          padding-top: 0;\n        }\n      }\n      td {\n        &:first-child {\n          min-width: unset;\n          @media (max-width: 1775px) {\n            min-width: 130px;\n          }\n        }\n        &:last-child {\n          text-align: right;\n          min-width: 60px;\n        }\n      }\n    }\n    tr,\n    td {\n      border-style: dashed;\n    }\n  }\n}\n.custom-tab {\n  background: var(--light2);\n  padding: 4px;\n  border-radius: 5px;\n  &.nav-tabs {\n    border: none;\n    .nav-link {\n      border: none;\n      padding: 6px 12px;\n      color: var(--chart-text-color);\n      &.active {\n        color: var(--theme-default);\n      }\n    }\n  }\n}\n.market-chart-container {\n  margin: -24px 0 -24px -15px;\n  [dir=\"rtl\"] & {\n    margin: -24px -15px -24px 0;\n  }\n  @media (max-width: 575px) {\n    margin-bottom: 0;\n  }\n}\n.market-card {\n  .balance-card {\n    padding: 10px;\n  }\n  .custom-tab {\n    @media (max-width: 575px) {\n      display: none;\n    }\n  }\n}\n.currency-icon {\n  width: 34px;\n  height: 34px;\n  background-color: var(--light2);\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  &.warning {\n    svg {\n      fill: $warning-color;\n    }\n  }\n  &.success {\n    svg {\n      fill: $success-color;\n    }\n  }\n  &.primary {\n    svg {\n      fill: $primary-color;\n    }\n  }\n  &.secondary {\n    svg {\n      fill: $secondary-color;\n    }\n  }\n  &.dark-green {\n    svg {\n      fill: #1ba27a;\n    }\n  }\n  &.light-blue {\n    svg {\n      fill: #038de7;\n    }\n  }\n}\n.recent-table {\n  tr {\n    &:hover {\n      td {\n        &:first-child {\n          h6 {\n            color: var(--theme-default);\n          }\n        }\n      }\n      .border-icon {\n        .social-circle {\n          transform: scale(1.02);\n          transition: 0.5s;\n        }\n      }\n      .currency-icon {\n        svg {\n          animation: tada 1.5s ease infinite;\n        }\n      }\n      .badge-light-primary {\n        background-color: var(--theme-default);\n        color: $white;\n      }\n    }\n  }\n}\n.currency-table {\n  .change-currency {\n    svg {\n      width: 16px;\n      height: 16px;\n      vertical-align: sub;\n    }\n  }\n  th,\n  td {\n    &:nth-child(3) {\n      min-width: 110px;\n    }\n    &:nth-child(4) {\n      min-width: 115px;\n    }\n  }\n}\n\nselect {\n  &.crypto-select {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    font-size: 12px;\n    right: 7px;\n    width: 62px;\n    background-position: right 0.25rem center;\n    padding: 8px;\n    border: none;\n    font-weight: 500;\n    background-size: 8px;\n    [dir=\"rtl\"] & {\n      right: unset;\n      left: 7px;\n    }\n    &.warning {\n      background-color: rgba($warning-color, 0.1) !important;\n      color: $warning-color !important;\n    }\n    &.primary {\n      background-color: rgba($primary-color, 0.1) !important;\n      color: $primary-color !important;\n    }\n  }\n}\n\n.crypto-form {\n  input {\n    &::-webkit-outer-spin-button,\n    &::-webkit-inner-spin-button {\n      -webkit-appearance: none;\n      margin: 0;\n    }\n    &[type=\"number\"] {\n      -moz-appearance: textfield;\n    }\n  }\n}\n.balance-box {\n  text-align: center;\n  background-image: url(../../images/dashboard-4/bg-balance.png);\n  background-position: right;\n  background-size: cover;\n  .balance-img {\n    display: inline-block;\n    padding: 5px;\n    border: 2px solid var(--chart-border);\n    border-left-color: $success-color;\n    border-bottom-color: $success-color;\n    border-radius: 100%;\n    position: relative;\n    margin-bottom: 15px;\n    img {\n      background-color: var(--balance-profie-bg);\n      border-radius: 100%;\n    }\n    .edit-icon {\n      width: 26px;\n      height: 26px;\n      position: absolute;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border: 2px solid var(--white);\n      background-color: #dfdff4;\n      right: 0;\n      bottom: 0;\n      border-radius: 100%;\n      svg {\n        width: 11px;\n        height: 11px;\n        fill: $primary-color;\n      }\n    }\n  }\n}\n.balance-profile {\n  ul {\n    display: flex;\n    justify-content: center;\n    gap: 50px;\n    margin-top: 16px;\n    @media (max-width: 1660px) {\n      gap: 25px;\n    }\n    li {\n      position: relative;\n      + li {\n        &::before {\n          position: absolute;\n          content: \"\";\n          left: -25px;\n          top: 50%;\n          height: 40px;\n          transform: translateY(-50%);\n          border: 1px dashed var(--recent-dashed-border);\n          [dir=\"rtl\"] & {\n            left: unset;\n            right: -25px;\n          }\n          @media (max-width: 1660px) {\n            left: -16px;\n            [dir=\"rtl\"] & {\n              right: -16px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n.activity-card {\n  .appointment-table {\n    @media (max-width: 1399px) {\n      height: 180px;\n    }\n    @media (max-width: 575px) {\n      height: unset;\n    }\n    tr {\n      td {\n        &:nth-child(2) {\n          min-width: 130px;\n        }\n      }\n    }\n  }\n}\n.balance-item {\n  display: flex;\n  gap: 10px;\n  .balance-icon-wrap {\n    width: 40px;\n    min-width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 10px;\n    @media (max-width: 1660px) {\n      width: 25px;\n      min-width: 25px;\n      height: 25px;\n      border-radius: 8px;\n    }\n    .balance-icon {\n      width: 16px;\n      height: 16px;\n      border-radius: 100%;\n      @media (max-width: 1660px) {\n        width: 14px;\n        height: 14px;\n      }\n      svg {\n        color: $white;\n        width: 14px;\n        height: 14px;\n        @media (max-width: 1660px) {\n          width: 12px;\n          height: 12px;\n          vertical-align: text-top;\n        }\n      }\n    }\n  }\n  .badge {\n    padding: 8px 10px;\n  }\n  &.danger {\n    .balance-icon-wrap {\n      background-color: rgba($danger-color, 0.1);\n      .balance-icon {\n        background-color: $danger-color;\n      }\n    }\n  }\n  &.success {\n    .balance-icon-wrap {\n      background-color: rgba($success-color, 0.1);\n      .balance-icon {\n        background-color: $success-color;\n      }\n    }\n  }\n}\n.portfolio-chart-container {\n  margin-top: -56px;\n  @media (max-width: 1399px) {\n    margin-top: -20px;\n  }\n}\n.portfolio-table {\n  .status {\n    width: 6px;\n    height: 6px;\n    border-radius: 100%;\n    display: inline-block;\n  }\n  table {\n    tr,\n    td {\n      border-style: dashed;\n    }\n    tr {\n      td,\n      th {\n        &:first-child {\n          @media (max-width: 1755px) {\n            min-width: 100px;\n          }\n        }\n        &:last-child {\n          @media (max-width: 1755px) {\n            min-width: 128px;\n          }\n        }\n      }\n    }\n  }\n}\n","/**=====================\n     Dashboard 5 CSS Start\n==========================**/\n.social {\n  &-img {\n    padding: 5px;\n    background: var(--white);\n    border-radius: 100%;\n  }\n\n  &-widget {\n    .card-body {\n      padding: 15px;\n    }\n    .social-icons {\n      min-width: 55px;\n      height: 55px;\n      background: var(--white);\n      box-shadow: 0px 42.1092px 27.8569px rgba(41, 72, 152, 0.0303704), 0px 8.90772px 7.12618px rgba(41, 72, 152, 0.0196296), 0px 2.02448px 3.44162px rgba(41, 72, 152, 0.012037);\n      border-radius: 10px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      @media (max-width: 1399px) {\n        min-width: 40px;\n        height: 40px;\n        img {\n          height: 20px;\n        }\n      }\n    }\n    .social-content {\n      margin-top: 20px;\n      display: flex;\n      justify-content: space-between;\n      .social-chart {\n        margin: -34px -42px -13px;\n        width: 150px;\n        .apexcharts-canvas {\n          .apexcharts-datalabels-group {\n            .apexcharts-datalabel-label {\n              display: none;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n.follower-chart {\n  margin: -20px 0 -20px -34px;\n  @media (max-width: 717px) {\n    margin-left: 0;\n  }\n}\n@keyframes wave-speaker {\n  0% {\n    transform: translateX(5px);\n  }\n  50% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(5px);\n  }\n}\n.mobile-app-card {\n  .card-header {\n    background: transparent;\n    padding: 20px;\n    width: 68%;\n    @media (max-width: 1693px) {\n      width: 75%;\n    }\n    @media (max-width: 1316px) {\n      width: 86%;\n    }\n    @media (max-width: 991px) {\n      width: 64%;\n    }\n    @media (max-width: 350px) {\n      width: 75%;\n    }\n  }\n  .card-body {\n    margin-top: -10px;\n    @media (max-width: 1199px) {\n      margin-top: 26px;\n    }\n    @media (max-width: 991px) {\n      margin-top: 20px;\n    }\n    .wavy {\n      width: 26px;\n      margin-right: -37px;\n      margin-top: -10px;\n      animation: wave-speaker 2s ease infinite;\n    }\n  }\n  .purchase-btn {\n    padding: 10px 25px;\n    min-width: unset;\n  }\n}\n.subscriber-chart-container {\n  margin: -22px -10px -24px;\n}\n.click-widgets {\n  .card-body {\n    padding: 28px 15px;\n  }\n  .click-chart {\n    margin: 0;\n  }\n}\n.follower-wrap {\n  .card-body,\n  .card-header {\n    @media (max-width: 1693px) {\n      padding: 22px;\n    }\n  }\n  .card-header {\n    padding-bottom: 20px;\n  }\n}\n.campaign-list {\n  column-count: 2;\n  column-gap: 20px;\n  margin-bottom: 15px;\n  li {\n    position: relative;\n    + li {\n      &::before {\n        position: absolute;\n        content: \"\";\n        width: 1px;\n        height: 20px;\n        background-color: var(--chart-text-color);\n        top: 50%;\n        transform: translateY(-50%);\n        left: -10px;\n        opacity: 0.6;\n        [dir=\"rtl\"] & {\n          left: unset;\n          right: -10px;\n        }\n      }\n    }\n  }\n  .campaign-box {\n    background: linear-gradient(180deg, var(--course-light-btn) 0%, rgba(242, 243, 247, 0) 100%);\n    border-radius: 5px;\n    padding: 6px 10px;\n  }\n}\n.social-circle {\n  width: 34px;\n  height: 34px;\n  border-width: 1px;\n  border-style: solid;\n  border-radius: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: 0.5s;\n}\n.campaign-table {\n  table {\n    tr {\n      &:hover {\n        td {\n          &:nth-child(2) {\n            color: var(--theme-default);\n          }\n        }\n      }\n    }\n  }\n  .border-icon {\n    > div {\n      border-left: 2px solid $fb-color;\n      padding-left: 15px;\n      [dir=\"rtl\"] & {\n        padding-left: unset;\n        padding-right: 15px;\n      }\n    }\n  }\n  .facebook {\n    > div {\n      border-left: 2px solid $fb-color;\n      [dir=\"rtl\"] & {\n        border-left: unset;\n        border-right: 2px solid $fb-color;\n      }\n    }\n    .social-circle {\n      background-color: rgba($fb-color, 0.1);\n      border-color: $fb-color;\n      color: $fb-color;\n    }\n  }\n  .instagram {\n    > div {\n      border-left: 2px solid $insta-color;\n      [dir=\"rtl\"] & {\n        border-left: unset;\n        border-right: 2px solid $insta-color;\n      }\n    }\n    .social-circle {\n      background-color: rgba($insta-color, 0.1);\n      border-color: $insta-color;\n      color: $insta-color;\n    }\n  }\n  .pinterest {\n    > div {\n      border-left: 2px solid $pintrest-color;\n      [dir=\"rtl\"] & {\n        border-left: unset;\n        border-right: 2px solid $pintrest-color;\n      }\n    }\n    .social-circle {\n      background-color: rgba($pintrest-color, 0.1);\n      border-color: $pintrest-color;\n      color: $pintrest-color;\n    }\n  }\n  .plus-btn {\n    width: 24px;\n    border-radius: 5px;\n    background-color: transparent;\n    border: 1px solid var(--body-font-color);\n    color: var(--body-font-color);\n    &:hover {\n      background-color: var(--body-font-color);\n      color: var(--white);\n    }\n  }\n  .twitter {\n    > div {\n      border-left: 2px solid $twitter-color;\n      [dir=\"rtl\"] & {\n        border-left: unset;\n        border-right: 2px solid $twitter-color;\n      }\n    }\n    .social-circle {\n      background-color: rgba($twitter-color, 0.1);\n      border-color: $twitter-color;\n      color: $twitter-color;\n    }\n  }\n  .you-tube {\n    > div {\n      border-left: 2px solid $youtube-color;\n      [dir=\"rtl\"] & {\n        border-left: unset;\n        border-right: 2px solid $youtube-color;\n      }\n    }\n    .social-circle {\n      background-color: rgba($youtube-color, 0.1);\n      border-color: $youtube-color;\n      color: $youtube-color;\n    }\n  }\n  .badge-light-primary,\n  .badge-light-light {\n    padding: 4px 12px;\n  }\n  tr {\n    td,\n    th {\n      border-style: dashed;\n      &:nth-child(5) {\n        min-width: 190px;\n      }\n    }\n  }\n  .recent-table {\n    tr {\n      td,\n      th {\n        &:nth-child(2) {\n          min-width: 120px;\n        }\n        &:first-child {\n          min-width: 110px;\n        }\n        &:nth-child(3),\n        &:last-child {\n          min-width: 50px;\n        }\n      }\n    }\n  }\n}\n\n.view-container {\n  .apexcharts-canvas {\n    .apexcharts-grid-row {\n      stroke-width: 15px;\n      stroke: var(--white);\n    }\n    .apexcharts-gridlines-vertical,\n    .apexcharts-gridlines-horizontal {\n      line,\n      react {\n        stroke-width: 15px;\n        stroke: var(--white);\n      }\n    }\n    .apexcharts-point-annotations {\n      circle {\n        outline: 25px solid #f0effd;\n        border-radius: 100%;\n        @media (max-width: 480px) {\n          outline-width: 10px;\n        }\n      }\n    }\n  }\n}\n","/**=====================\n53. Dashboard CSS Start\n==========================**/\n//index dashboard css start\n\n.form-control-plaintext {\n  width: auto !important;\n}\n\n@keyframes bounce-effect {\n  0% {\n    transform: translateY(0);\n    transition: 0.5s;\n  }\n  50% {\n    transform: translateY(-5px);\n    transition: 0.5s;\n  }\n  100% {\n    transform: translateY(0);\n    transition: 0.5s;\n  }\n}\n\n@keyframes round {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.2);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n@each $badge-light-name, $badge-light-color in (primary, $primary-color), (secondary, $secondary-color), (success, $success-color), (danger, $danger-color), (info, $info-color), (light, $badge-light-color), (dark, $dark-color), (warning, $warning-color) {\n  .badge-light-#{$badge-light-name} {\n    background-color: lighten($badge-light-color, 38%);\n    color: $badge-light-color;\n  }\n}\n.badge-light-light {\n  background-color: lighten($badge-light-color, 55%);\n}\n.badge-light-primary {\n  background-color: rgba($primary-color, 0.1);\n}\n\n.badge-light-success {\n  background-color: rgba($success-color, 0.15);\n}\n.badge-light-secondary {\n  background-color: rgba($secondary-color, 0.08);\n}\n\n.table {\n  thead {\n    th {\n      border-bottom: 2px solid $light-gray;\n    }\n  }\n}\n.overall-card {\n  .balance-card {\n    @media (max-width: 1712px) {\n      padding: 12px;\n    }\n  }\n  @media (max-width: 1662px) and (min-width: 1600px) {\n    .col-xl-9 {\n      width: 73%;\n    }\n    .col-xl-3 {\n      width: 27%;\n    }\n  }\n  @media (max-width: 1650px) and (min-width: 1600px) {\n    .col-xl-9 {\n      width: 72%;\n    }\n    .col-xl-3 {\n      width: 28%;\n    }\n  }\n  @media (max-width: 1600px) and (min-width: 1500px) {\n    .col-xl-9 {\n      width: 70%;\n    }\n    .col-xl-3 {\n      width: 30%;\n    }\n  }\n  @media (max-width: 1500px) and (min-width: 1200px) {\n    .col-xl-9 {\n      width: 65%;\n    }\n    .col-xl-3 {\n      width: 35%;\n    }\n  }\n}\n/* Clock styles */\n.clockbox {\n  margin-bottom: -5px;\n  svg {\n    width: 45px;\n    height: 45px;\n    @media (max-width: 767px) {\n      height: 36px;\n    }\n  }\n}\n.clockbox,\n#clock {\n  width: 100%;\n}\n.circle {\n  fill: $white;\n  stroke: rgba($white, 0.4);\n  stroke-width: 80px;\n  stroke-miterlimit: 10;\n}\n\n.mid-circle {\n  fill: #000;\n}\n.hour-marks {\n  fill: none;\n  stroke: $theme-body-sub-title-color;\n  stroke-width: 9;\n  stroke-miterlimit: 10;\n}\n\n.hour-hand {\n  fill: none;\n  stroke: #ff7e00;\n  stroke-width: 17;\n  stroke-miterlimit: 10;\n}\n\n.minute-hand {\n  fill: none;\n  stroke: #ff7e00;\n  stroke-width: 11;\n  stroke-miterlimit: 10;\n}\n\n.second-hand {\n  fill: none;\n  stroke: $warning-color;\n  stroke-width: 15px;\n  stroke-miterlimit: 10;\n}\n.sizing-box {\n  fill: none;\n}\n#hour,\n#minute,\n#second {\n  transform-origin: 300px 300px;\n  transition: transform 0.5s ease-in-out;\n}\n.widget-grid {\n  .height-equal {\n    @media (min-width: 1400px) {\n      min-height: unset !important;\n    }\n  }\n  > .col-xxl-auto {\n    @media (min-width: 1400px) {\n      width: 22.22%;\n    }\n  }\n}\n.order-chart {\n  > div {\n    margin-top: -25px;\n    margin-bottom: -43px;\n  }\n  svg {\n    path {\n      clip-path: inset(7% 0% 0% 0% round 0.6rem);\n    }\n  }\n}\n.growth-wrap {\n  .card-header {\n    position: relative;\n    z-index: 1;\n  }\n}\n.growth-wrapper {\n  > div {\n    margin-top: -54px;\n    margin-bottom: -25px;\n    @media (max-width: 1481px) {\n      margin-top: -50px;\n    }\n  }\n}\n.profit-chart {\n  > div {\n    margin-top: -45px;\n    margin-bottom: -48px;\n  }\n  .apexcharts-canvas {\n    .apexcharts-tooltip-text-label {\n      display: none;\n    }\n  }\n}\n.widget-1 {\n  background-image: url(../../images/dashboard/widget-bg.png);\n  background-size: cover;\n  margin-bottom: 25px;\n  i {\n    font-weight: 700;\n    font-size: 12px;\n  }\n  .f-w-500 {\n    display: flex;\n    align-items: center;\n    @media (max-width: 1580px) and (min-width: 1200px) {\n      display: none;\n    }\n  }\n  .card-body {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n    padding: 18px 25px;\n    @media (max-width: 1720px) {\n      padding: 18px;\n    }\n  }\n  .widget-round {\n    position: relative;\n    display: inline-block;\n    border-width: 1px;\n    border-style: solid;\n    border-radius: 100%;\n    .bg-round {\n      width: 56px;\n      height: 56px;\n      box-shadow: $widget-shadow;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 100%;\n      margin: 6px;\n      position: relative;\n      z-index: 1;\n      svg {\n        width: 24px;\n        height: 24px;\n      }\n      .half-circle {\n        height: 52px;\n        position: absolute;\n        left: -9px;\n        width: 35px;\n        bottom: -8px;\n        background: $white;\n        z-index: -1;\n      }\n      @media (max-width: 1600px) {\n        width: 40px;\n        height: 40px;\n        svg {\n          width: 22px;\n          height: 22px;\n        }\n        .half-circle {\n          height: 40px;\n          left: -10px;\n          width: 30px;\n          bottom: -8px;\n        }\n      }\n    }\n    &.primary {\n      border-color: var(--theme-default);\n    }\n    &.secondary {\n      border-color: var(--theme-secondary);\n    }\n    &.success {\n      border-color: $success-color;\n    }\n    &.warning {\n      border-color: $warning-color;\n    }\n  }\n  .widget-content {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    @media (max-width: 1600px) {\n      gap: 10px;\n    }\n    h4 {\n      margin-bottom: 4px;\n    }\n  }\n  &:hover {\n    transform: translateY(-5px);\n    transition: 0.5s;\n    .widget-round {\n      .svg-fill:not(.half-circle) {\n        animation: tada 1.5s ease infinite;\n      }\n    }\n  }\n}\n.widget-with-chart {\n  .card-body {\n    align-items: center;\n  }\n}\n\n.profile-box {\n  background: $gradient-bg-primary;\n  color: $white;\n  .cartoon {\n    position: absolute;\n    bottom: -15px;\n    right: 20px;\n    animation: bounce-effect 5s infinite ease-in;\n    [dir=\"rtl\"] & {\n      right: unset !important;\n      left: 5px;\n    }\n    @media (max-width: 1660px) {\n      right: 30px;\n      text-align: right;\n      [dir=\"rtl\"] & {\n        left: -6px;\n        text-align: left;\n      }\n      img {\n        width: 80%;\n      }\n    }\n    @media (max-width: 1500px) {\n      img {\n        width: 60%;\n      }\n    }\n    @media (max-width: 767px) {\n      right: 10px;\n      [dir=\"rtl\"] & {\n        left: -10px;\n      }\n      img {\n        width: 52%;\n      }\n    }\n    @media (max-width: 575px) {\n      right: 30px;\n      [dir=\"rtl\"] & {\n        left: 10px;\n      }\n      img {\n        width: 48%;\n      }\n    }\n  }\n  .greeting-user {\n    p {\n      width: 60%;\n      @media (max-width: 1500px) {\n        width: 70%;\n      }\n      @media (max-width: 1199px) {\n        width: 80%;\n      }\n      @media (max-width: 767px) {\n        width: 98%;\n      }\n      @media (max-width: 600px) {\n        width: 100%;\n      }\n      @media (max-width: 575px) {\n        width: 98%;\n      }\n    }\n  }\n  .whatsnew-btn {\n    margin-top: 3.5rem;\n    @media (max-width: 1500px) {\n      margin-top: 1.7rem;\n    }\n    @media (max-width: 991px) {\n      margin-top: 3.5rem;\n    }\n    @media (max-width: 638px) {\n      margin-top: 2rem;\n    }\n    .btn {\n      @media (max-width: 767px) {\n        padding: 6px 10px;\n      }\n    }\n  }\n}\n\n.header-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 4px;\n  a {\n    i {\n      font-size: 14px;\n      margin-bottom: -2px;\n    }\n    &.btn {\n      padding: 8px 12px;\n      @media (max-width: 575px) {\n        padding: 5px;\n      }\n      &.badge-light-primary {\n        &:hover {\n          background-color: var(--theme-default);\n        }\n      }\n    }\n  }\n}\n.user-details {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  @media (max-width: 1399px) {\n    gap: 6px;\n  }\n  .customers {\n    width: 200px;\n  }\n  @media (max-width: 575px) {\n    flex-wrap: wrap;\n  }\n}\n.papernote-wrap {\n  .banner-img {\n    border-radius: 15px;\n    width: 100%;\n  }\n  .note-labels {\n    display: flex;\n    align-items: center;\n    > * {\n      padding: 3px 0;\n    }\n    ul {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      flex-wrap: wrap;\n      @media (max-width: 575px) {\n        gap: 4px;\n      }\n    }\n    .badge {\n      font-size: 14px;\n      padding: 6px 12px;\n      @media (max-width: 575px) {\n        font-size: 12px;\n        padding: 5px 6px;\n      }\n    }\n    .last-label {\n      padding-left: 16px;\n      margin-left: 16px;\n      border-left: 1px dashed rgba($theme-body-sub-title-color, 0.7);\n      [dir=\"rtl\"] & {\n        padding-left: unset;\n        margin-left: unset;\n        margin-right: 16px;\n        padding-right: 16px;\n        border-left: none;\n        border-right: 1px dashed rgba($theme-body-sub-title-color, 0.7);\n      }\n      @media (max-width: 575px) {\n        padding-left: 8px;\n        margin-left: 8px;\n        [dir=\"rtl\"] & {\n          margin-right: 8px;\n          padding-right: 8px;\n        }\n      }\n    }\n  }\n  .light-card {\n    width: 40px;\n    height: 40px;\n    border-radius: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: var(--light2);\n    border: 1px solid rgba($theme-body-sub-title-color, 0.2);\n  }\n}\n.appointment-sec {\n  .card-header-right-icon {\n    select {\n      background-color: rgba($primary-color, 0.08) !important;\n      border: none;\n      color: var(--theme-default) !important;\n      width: auto !important;\n      height: 32px !important;\n      border-radius: 10px;\n      padding: 5px 10px;\n      line-height: 50px !important;\n      font-weight: 500;\n      border: none;\n      outline: none !important;\n\n      &:hover {\n        background-color: rgba($primary-color, 0.08) !important;\n        color: var(--theme-default) !important;\n      }\n    }\n  }\n  .bottom-btn {\n    text-align: center;\n    a {\n      font-family: $font-roboto, $font-serif;\n      font-weight: bold;\n      font-size: 14px;\n      line-height: 16px;\n      letter-spacing: 0.3px;\n      text-decoration-line: underline;\n      text-transform: uppercase;\n    }\n  }\n}\n\n.notification {\n  ul {\n    position: relative;\n    &::before {\n      position: absolute;\n      content: \"\";\n      border: 1px dashed $theme-body-sub-title-color;\n      opacity: 0.3;\n      top: 12px;\n      left: 2px;\n      height: calc(100% - 12px);\n      [dir=\"rtl\"] & {\n        left: unset;\n        right: 2px;\n      }\n    }\n  }\n  li {\n    padding-bottom: 22px !important;\n    border: none !important;\n  }\n  div[class*=\"activity-dot-\"] {\n    margin-top: 12px;\n    animation: round 1.3s ease-in-out infinite;\n  }\n  .card {\n    .d-flex {\n      .w-100 {\n        p {\n          .badge {\n            color: $white;\n            margin-left: 10px;\n            font-weight: 500;\n          }\n        }\n\n        h6 {\n          margin-bottom: 5px;\n          position: relative;\n          ~ p {\n            -webkit-box-orient: vertical;\n            -webkit-line-clamp: 1;\n            text-emphasis: inherit;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            display: block;\n            width: 260px;\n            @media (max-width: 767px) {\n              -webkit-line-clamp: unset;\n              text-emphasis: unset;\n              white-space: unset;\n              text-overflow: unset;\n              display: block;\n              width: unset;\n              overflow: visible;\n            }\n          }\n\n          @keyframes round {\n            0% {\n              transform: scale(1);\n            }\n\n            50% {\n              transform: scale(1.2);\n            }\n\n            100% {\n              transform: scale(1);\n            }\n          }\n        }\n\n        span {\n          color: $theme-body-sub-title-color;\n        }\n      }\n\n      &:nth-child(2) {\n        .media-body {\n          h6 {\n            .dot-notification {\n              background-color: $warning-color;\n              border: 5px solid lighten($warning-color, 30%);\n            }\n          }\n        }\n      }\n\n      &:last-child {\n        margin-bottom: 0 !important;\n      }\n    }\n  }\n  .date-content {\n    padding: 4px 8px;\n    border-radius: 5px;\n  }\n}\n\n.schedule-container {\n  > div {\n    margin-bottom: -40px;\n  }\n  svg {\n    path {\n      clip-path: inset(1% 0% 0% 0% round 1.5rem);\n    }\n  }\n}\n\n.purchase-card {\n  text-align: center;\n  margin-top: 200px;\n  @media (max-width: 1560px) {\n    margin-top: 170px;\n  }\n  @media (max-width: 1399px) {\n    margin-top: 160px;\n  }\n  @media (max-width: 500px) {\n    margin-top: 110px;\n  }\n  @media (max-width: 420px) {\n    margin-top: 90px;\n  }\n  img {\n    margin-top: -208px;\n    @media (max-width: 1560px) {\n      margin-top: -170px;\n    }\n    @media (max-width: 1399px) {\n      width: 70%;\n      margin: -160px auto 0 auto;\n    }\n    @media (max-width: 1366px) {\n      width: 76%;\n    }\n    @media (max-width: 1199px) {\n      width: 86%;\n    }\n    @media (max-width: 991px) {\n      width: 72%;\n    }\n    @media (max-width: 767px) {\n      width: 50%;\n    }\n    @media (max-width: 500px) {\n      margin-top: -110px;\n    }\n    @media (max-width: 420px) {\n      margin-top: -90px;\n      width: 60%;\n    }\n  }\n  .purchase-btn {\n    min-width: auto;\n  }\n}\n\n.user-list {\n  column-count: 2;\n  column-rule-style: dashed;\n  column-rule-color: rgba($theme-body-sub-title-color, 0.7);\n  column-gap: 120px;\n  column-rule-width: 1px;\n  @media (max-width: 1780px) {\n    column-gap: 80px;\n  }\n  @media (max-width: 1660px) {\n    column-gap: 40px;\n  }\n  @media (max-width: 360px) {\n    column-gap: 25px;\n  }\n  li {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    width: 100%;\n    @media (max-width: 1540px) {\n      gap: 5px;\n    }\n    i {\n      font-size: 12px;\n      font-weight: 700;\n    }\n    h5 {\n      @media (max-width: 360px) {\n        font-size: 16px;\n      }\n    }\n    span {\n      @media (max-width: 360px) {\n        font-size: 13px;\n      }\n    }\n    &:hover {\n      .user-box {\n        svg {\n          animation: tada 1.5s ease infinite;\n        }\n      }\n    }\n  }\n  .user-icon {\n    border-radius: 100%;\n    display: inline-block;\n    .user-box {\n      margin: 3px;\n      width: 47px;\n      height: 47px;\n      border-radius: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      @media (max-width: 1540px) {\n        width: 30px;\n        height: 30px;\n        svg {\n          width: 18px;\n          height: 18px;\n        }\n      }\n    }\n    &.primary {\n      border: 1px solid $primary-color;\n      .user-box {\n        background: lighten($primary-color, 25%);\n      }\n    }\n    &.success {\n      border: 1px solid $success-color;\n      .user-box {\n        background: lighten($success-color, 40%);\n      }\n    }\n  }\n}\n\n.appointment-table {\n  table {\n    tr {\n      td {\n        position: relative;\n        border-top: none;\n        padding: 15px 0;\n        vertical-align: middle;\n        &:first-child {\n          width: 50px;\n        }\n\n        .status-circle {\n          top: 1px;\n          left: 35px;\n          border-width: 3px;\n        }\n\n        p,\n        .btn {\n          font-weight: 500;\n          font-size: 12px;\n        }\n\n        .btn {\n          padding: 4px 12px;\n        }\n      }\n      .img-content-box {\n        a {\n          color: var(--body-font-color);\n          transition: 0.5s;\n          display: inline-block !important;\n        }\n        span {\n          display: block;\n        }\n      }\n      &:hover {\n        .img-content-box {\n          a {\n            color: var(--theme-default);\n            transition: 0.5s;\n          }\n        }\n      }\n      &:first-child {\n        td {\n          padding-top: 0 !important;\n        }\n      }\n      &:last-child {\n        td {\n          padding-bottom: 0 !important;\n        }\n      }\n    }\n  }\n  &.customer-table {\n    table {\n      tr {\n        td {\n          padding: 10px 0;\n          img {\n            min-width: 40px;\n          }\n        }\n      }\n    }\n  }\n}\n\n.icon-box {\n  width: 50px;\n  height: 32px;\n  background-color: rgba($primary-color, 0.08);\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  i {\n    color: var(--theme-default);\n    font-size: 22px;\n  }\n  svg {\n    stroke: var(--theme-default);\n  }\n}\n.balance-card {\n  display: flex;\n  padding: 15px;\n  border-radius: 5px;\n  gap: 15px;\n  transition: 0.5s;\n  @media (max-width: 1199px) {\n    gap: 8px;\n  }\n  .svg-box {\n    width: 43px;\n    height: 43px;\n    background: $white;\n    box-shadow: 0px 71.2527px 51.5055px rgba(229, 229, 245, 0.189815), 0px 42.3445px 28.0125px rgba(229, 229, 245, 0.151852), 0px 21.9866px 14.2913px rgba(229, 229, 245, 0.125), 0px 8.95749px 7.16599px rgba(229, 229, 245, 0.0981481), 0px 2.03579px 3.46085px rgba(229, 229, 245, 0.0601852);\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    @media (max-width: 1199px) {\n      width: 35px;\n      height: 35px;\n    }\n    svg {\n      height: 20px;\n      fill: rgba($theme-body-sub-title-color, 0.85);\n      @media (max-width: 1199px) {\n        height: 17px;\n      }\n    }\n  }\n}\n\n.btn-light-secondary {\n  background-color: rgba(var(--theme-secondary), 0.1);\n  font-size: 12px;\n  padding: 6px 12px;\n  font-weight: 600;\n}\n\n//index dashboard css ends\n\n.crm-activity {\n  > li {\n    + li {\n      border-top: 1px solid $light-semi-gray;\n      margin-top: 10px;\n      padding-top: 10px;\n\n      h6 {\n        font-size: 14px;\n        line-height: 18px;\n        margin-bottom: 5px;\n      }\n    }\n\n    h6 {\n      font-size: 14px;\n    }\n  }\n\n  span {\n    font-size: 40px;\n  }\n\n  ul.dates {\n    h6 {\n      color: $theme-body-font-color;\n    }\n\n    li {\n      color: $theme-body-sub-title-color;\n      font-size: 12px;\n      display: inline-block;\n      line-height: 1;\n\n      + li {\n        border-left: 1px solid $light-semi-gray;\n        padding-left: 10px;\n        margin-left: 5px;\n      }\n    }\n  }\n}\n\n//general widget css start\n\n.fill-primary {\n  fill: $primary-color;\n}\n.fill-secondary {\n  fill: $secondary-color;\n}\n.fill-success {\n  fill: $success-color;\n}\n.fill-warning {\n  fill: $warning-color;\n}\n.fill-info {\n  fill: $info-color;\n}\n.fill-danger {\n  fill: $danger-color;\n}\n\n.ecommerce-widget {\n  box-shadow: none;\n  border: 1px solid #f1f3ff !important;\n  border-radius: 5px;\n  .total-num {\n    color: $theme-body-font-color;\n    margin: 0;\n    letter-spacing: 1px;\n\n    span {\n      color: $black;\n    }\n  }\n\n  .row {\n    align-items: center;\n  }\n\n  .progress-showcase {\n    margin-top: 30px;\n  }\n\n  span {\n    color: $theme-body-sub-title-color;\n    margin: 0;\n    cursor: pointer;\n  }\n\n  .icon {\n    color: $light-semi-gray;\n    font-size: 40px;\n  }\n\n  .flot-chart-container {\n    height: 100px;\n    padding: 0;\n    margin: 0;\n    border: transparent;\n  }\n\n  .morris-default-style {\n    display: none !important;\n  }\n\n  svg {\n    -webkit-filter: drop-shadow(12px 12px 7px rgba(0, 0, 0, 0.3));\n    filter: drop-shadow(12px 12px 7px rgba(0, 0, 0, 0.3));\n  }\n}\n\n.redial-social-widget {\n  border-radius: 100%;\n  width: 100px;\n  height: 100px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 25px;\n  margin: 0 auto;\n  background-image: linear-gradient(90deg, $light-color 50%, transparent 50%, transparent), linear-gradient(90deg, $light-gray 50%, $light-color 50%, $light-color);\n\n  i {\n    background-color: $white;\n    height: 80px;\n    width: 80px;\n    border-radius: 100%;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  &.radial-bar-70 {\n    background-image: linear-gradient(342deg, var(--theme-default) 50%, transparent 50%, transparent), linear-gradient(270deg, var(--theme-default) 50%, $light-color 50%, $light-color);\n  }\n}\n\n.browser-widget {\n  &:hover {\n    img {\n      -webkit-filter: grayscale(0%);\n      filter: grayscale(0%);\n      transition: all 0.3s ease;\n      transform: scale(1.1) rotate(5deg);\n    }\n  }\n\n  img {\n    height: 80px;\n    filter: grayscale(100%);\n    transform: scale(1) rotate(0deg);\n    transition: all 0.3s ease;\n  }\n\n  .media-body {\n    text-align: center;\n    column-count: 3;\n    column-rule: 1px solid $light-color;\n    p {\n      margin-bottom: 5px;\n    }\n    span {\n      margin-bottom: 0;\n      color: $theme-body-sub-title-color;\n    }\n\n    h4 {\n      color: $theme-body-font-color;\n      margin-bottom: 0;\n      font-size: $btn-lg-font-size;\n\n      span {\n        color: #333333;\n      }\n    }\n  }\n}\n\n.testimonial {\n  i {\n    font-size: 60px;\n    color: rgba(43, 43, 43, 0.7);\n    position: absolute;\n    left: 0;\n    top: 0;\n    opacity: 0.1;\n    z-index: -1;\n  }\n\n  p {\n    color: $theme-body-sub-title-color;\n    font-style: italic;\n    margin-bottom: 30px;\n    margin-top: 30px;\n  }\n\n  h5 {\n    color: $theme-body-font-color;\n    padding-top: 10px;\n  }\n\n  span {\n    color: $theme-body-sub-title-color;\n  }\n\n  img {\n    margin: 0 auto;\n  }\n}\n\n//general widget css start\n.widget-charts {\n  .widget-1 {\n    .card-body {\n      padding: 30px 25px;\n    }\n  }\n}\n\n//chart widget css\n.chart-widget-top {\n  #chart-widget1,\n  #chart-widget2,\n  #chart-widget3 {\n    margin-bottom: -14px;\n    .apexcharts-xaxistooltip {\n      display: none;\n    }\n  }\n  span {\n    color: $font-gray-color;\n  }\n}\n.bar-chart-widget {\n  .apexcharts-legend {\n    bottom: 0 !important;\n    .apexcharts-legend-series {\n      margin: 0 10px !important;\n    }\n    .apexcharts-legend-marker {\n      margin-right: 5px;\n    }\n  }\n  .top-content {\n    border-top-left-radius: 4px;\n    border-top-right-radius: 4px;\n  }\n\n  .earning-details {\n    height: 100%;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    display: flex;\n    letter-spacing: 1px;\n\n    i {\n      font-size: 230px;\n      position: absolute;\n      opacity: 0.1;\n      right: -30px;\n      top: 0;\n\n      &:hover {\n        transform: rotate(-5deg) scale(1.1);\n        transition: all 0.3s ease;\n      }\n    }\n  }\n\n  .num {\n    font-weight: 600;\n\n    .color-bottom {\n      color: $black;\n    }\n  }\n}\n.skill-chart {\n  margin-bottom: -48px;\n  .apexcharts-legend {\n    .apexcharts-legend-series {\n      span {\n        display: block;\n      }\n      .apexcharts-legend-text {\n        margin: 10px 0 20px;\n      }\n    }\n  }\n}\n.progress-chart {\n  margin: -11px 0 -20px;\n  .apexcharts-canvas {\n    svg {\n      path,\n      rect {\n        clip-path: inset(1% 0% 0% 0% round 1rem);\n      }\n    }\n  }\n}\n.bottom-content {\n  span {\n    color: $theme-body-sub-title-color;\n  }\n  .block-bottom {\n    display: block;\n  }\n}\n\n@keyframes am-moving-dashes {\n  100% {\n    stroke-dashoffset: -30px;\n  }\n}\n\n@-webkit-keyframes am-pulsating {\n  0% {\n    stroke-opacity: 1;\n    stroke-width: 0;\n  }\n\n  100% {\n    stroke-opacity: 0;\n    stroke-width: 50px;\n  }\n}\n\n@keyframes am-pulsating {\n  0% {\n    stroke-opacity: 1;\n    stroke-width: 0;\n  }\n\n  100% {\n    stroke-opacity: 0;\n    stroke-width: 50px;\n  }\n}\n\n@-webkit-keyframes am-draw {\n  0% {\n    stroke-dashoffset: 500%;\n  }\n\n  100% {\n    stroke-dashoffset: 0;\n  }\n}\n\n@keyframes am-draw {\n  0% {\n    stroke-dashoffset: 500%;\n  }\n\n  100% {\n    stroke-dashoffset: 0;\n  }\n}\n\n.serial-chart .chart-container {\n  width: 100%;\n  height: 500px;\n\n  .lastBullet {\n    animation: am-pulsating 1s ease-out infinite;\n  }\n\n  .amcharts-graph-column-front {\n    transition: all 0.3s 0.3s ease-out;\n\n    &:hover {\n      fill: var(--theme-secondary);\n      stroke: var(--theme-secondary);\n      transition: all 0.3s ease-out;\n    }\n  }\n\n  .amcharts-graph-g3 {\n    stroke-linejoin: round;\n    stroke-linecap: round;\n    stroke-dasharray: 0;\n    stroke-dashoffset: 0;\n    animation: am-draw 40s;\n  }\n\n  .amcharts-graph-g2 .amcharts-graph-stroke {\n    stroke-dasharray: 3px 3px;\n    stroke-linejoin: round;\n    stroke-linecap: round;\n    animation: am-moving-dashes 1s linear infinite;\n  }\n}\n.chart-container {\n  .apexcharts-xaxis-label,\n  .apexcharts-yaxis-label {\n    font-size: 14px !important;\n    color: $font-gray-color !important;\n  }\n  .apexcharts-xaxis-annotations {\n    rect {\n      clip-path: inset(1% 0% 0% 0% round 0.2rem);\n    }\n  }\n}\n\n.crypto-chart {\n  margin-left: -20px;\n  .apexcharts-tooltip-title {\n    display: none;\n  }\n  .apexcharts-tooltip-series-group {\n    &:last-child,\n    &.active {\n      padding-bottom: 0;\n    }\n  }\n}\n\n.speed-chart {\n  .chart-container {\n    width: 100%;\n    height: 530px;\n  }\n\n  .content {\n    margin-top: -200px;\n    margin-bottom: 20px;\n\n    h4 {\n      font-weight: 600;\n      padding-top: 2px;\n    }\n  }\n}\n\n.status-widget {\n  svg {\n    width: 20px;\n    height: 20px;\n    vertical-align: text-top;\n  }\n\n  .card {\n    .card-header {\n      h5 {\n        line-height: 1.38;\n      }\n    }\n  }\n\n  .status-chart {\n    border-bottom-left-radius: 8px;\n    border-bottom-right-radius: 8px;\n    overflow: hidden;\n  }\n}\n\n.small-chart-widget .chart-container {\n  height: 311px;\n  padding: 0;\n  margin: 0;\n  border: none;\n}\n\n.small-chart-widget {\n  .card {\n    .card-body {\n      border-bottom-left-radius: 8px;\n      border-bottom-right-radius: 8px;\n    }\n  }\n}\n\n.donut-chart-widget .chart-container {\n  height: 300px;\n  border: 0;\n  margin: 0;\n  padding: 0;\n}\n\n.status-details {\n  h4 {\n    font-weight: 600;\n\n    span {\n      color: inherit;\n    }\n  }\n\n  span {\n    color: $theme-body-sub-title-color;\n  }\n}\n\n.status-chart .chart-container {\n  height: 200px;\n  border: 0;\n  padding: 0;\n  margin: 0;\n}\n\n.map-chart .chart-container {\n  width: 100%;\n  height: 500px;\n}\n\n.serial-chart {\n  width: 100%;\n}\n\n.live-products,\n.turnover,\n.uses,\n.monthly {\n  height: 300px;\n}\n\n.live-products {\n  .ct-series-a {\n    .ct-area,\n    .ct-point,\n    .ct-line,\n    .ct-bar,\n    .ct-slice-donut {\n      stroke: rgba(255, 255, 255, 0.77);\n    }\n  }\n\n  .ct-label {\n    fill: $white;\n    color: $white;\n  }\n\n  .ct-grid {\n    stroke: rgba(255, 255, 255, 0.7);\n  }\n}\n\n.turnover,\n.uses,\n.monthly {\n  .ct-series-a {\n    .ct-area,\n    .ct-point,\n    .ct-line,\n    .ct-bar,\n    .ct-slice-donut {\n      stroke: rgba(255, 255, 255, 1);\n      fill: transparent;\n    }\n  }\n\n  .ct-series-b {\n    .ct-area,\n    .ct-point,\n    .ct-line,\n    .ct-bar,\n    .ct-slice-donut {\n      stroke: rgba(255, 255, 255, 0.7);\n      fill: transparent;\n    }\n  }\n\n  .ct-series-c {\n    .ct-area,\n    .ct-point,\n    .ct-line,\n    .ct-bar,\n    .ct-slice-donut {\n      stroke: rgba(255, 255, 255, 0.4);\n      fill: transparent;\n    }\n  }\n\n  .ct-label {\n    fill: $white;\n    color: $white;\n  }\n\n  .ct-grid {\n    stroke: rgba(255, 255, 255, 0.7);\n  }\n}\n\n// draggable card\n#draggableMultiple {\n  .ui-sortable-handle {\n    .card {\n      cursor: move;\n    }\n  }\n}\n\n// tilt page\n.tilt-showcase {\n  ul {\n    li {\n      .line {\n        padding-top: 10px;\n      }\n    }\n  }\n\n  .pre-mt {\n    margin-top: 5px;\n  }\n}\n\n// wow page\n.wow-title {\n  h5 {\n    display: flex;\n    align-items: center;\n    font-size: 18px;\n\n    .badge {\n      -webkit-text-fill-color: $white;\n    }\n  }\n}\n\n// alert page\n.alert-center {\n  display: flex !important;\n  align-items: center;\n}\n\n// box-shadow\n.box-shadow-title {\n  .sub-title {\n    margin: 30px 0;\n  }\n}\n\n// tour page\n.hovercard {\n  .info {\n    .social-media {\n      ul {\n        li {\n          padding-top: 3px;\n        }\n      }\n    }\n  }\n\n  .cardheader {\n    border-top-left-radius: 5px;\n    border-top-right-radius: 5px;\n  }\n}\n\n// sticky page\n.sticky-header-main {\n  .card {\n    .card-header {\n      h5 {\n        line-height: 35px;\n\n        a {\n          color: $white;\n          -webkit-text-fill-color: $white;\n        }\n      }\n    }\n  }\n}\n\n// radio-checkbox-control page\n.custom-radio-ml {\n  margin-left: 3px;\n}\n\n// date range picker page\n.daterangepicker {\n  .ltr {\n    tr {\n      td {\n        &.active {\n          color: $white;\n        }\n      }\n    }\n  }\n}\n\n// typeahead page\n// typeahead page\n.twitter-typeahead {\n  display: block !important;\n}\n\nspan.twitter-typeahead {\n  .league-name {\n    font-size: 16px;\n    padding: 6px 10px 0;\n  }\n\n  .tt-menu {\n    float: left;\n    width: 100%;\n    min-width: 10rem;\n    margin: 0.125rem 0 0;\n    font-size: 1rem;\n    color: #212529;\n    text-align: left;\n    list-style: none;\n    background-color: $white;\n    background-clip: padding-box;\n    border-radius: 0.25rem;\n    -webkit-box-shadow: 0 0 20px rgba(89, 102, 122, 0.1);\n    box-shadow: 0 0 20px rgba(89, 102, 122, 0.1);\n    border: none;\n    padding: 0;\n  }\n\n  .tt-suggestion {\n    color: $dark-editor-document;\n    opacity: 0.6;\n    font-size: 13px;\n    padding: 6px 12px;\n    border-top: 1px solid $light-semi-gray;\n    background: $white;\n    cursor: pointer;\n    &:hover,\n    &:focus {\n      background-color: $white;\n    }\n\n    &.active,\n    &:active {\n      color: $white;\n      background-color: var(--theme-default);\n    }\n  }\n}\n\n#scrollable-dropdown-menu {\n  .twitter-typeahead {\n    .tt-menu {\n      .tt-dataset {\n        max-height: 100px;\n        overflow-y: auto;\n      }\n    }\n  }\n}\n.chart-right {\n  position: relative;\n}\n.balance-data {\n  display: flex;\n  gap: 15px;\n  position: absolute;\n  top: -50px;\n  right: 2%;\n  [dir=\"rtl\"] & {\n    right: unset;\n    left: 2%;\n  }\n  @media (max-width: 991px) {\n    top: -42px;\n    right: 0%;\n    // [dir=\"rtl\"] & {\n    //   left: -65%;\n    // }\n  }\n  @media (max-width: 575px) {\n    display: none !important;\n  }\n  li {\n    display: flex;\n    align-items: center;\n    font-weight: 500;\n  }\n  .circle {\n    display: inline-block;\n    width: 6px;\n    height: 6px;\n    border-radius: 100%;\n  }\n}\n.current-sale-container {\n  padding-right: 12px;\n  [dir=\"rtl\"] & {\n    padding-right: unset;\n    padding-left: 12px;\n  }\n  > div {\n    margin: -22px 0 -30px -16px;\n    @media (max-width: 1199px) {\n      margin-bottom: 0;\n    }\n    @media (max-width: 404px) {\n      margin-bottom: -30px;\n    }\n  }\n  .apexcharts-xaxistooltip {\n    color: var(--theme-default);\n    background: rgba($primary-color, 0.1);\n    border: 1px solid var(--theme-default);\n  }\n\n  .apexcharts-xaxistooltip-bottom:before {\n    border-bottom-color: var(--theme-default);\n  }\n\n  .apexcharts-tooltip.light .apexcharts-tooltip-title {\n    background: rgba($primary-color, 0.1);\n    color: var(--theme-default);\n  }\n  &.order-container {\n    @media (max-width: 575px) {\n      padding-right: 0;\n      [dir=\"rtl\"] & {\n        padding-left: 0;\n      }\n    }\n    > div {\n      @media (max-width: 404px) {\n        margin-bottom: 0;\n      }\n    }\n  }\n}\n.recent-circle {\n  min-width: 10px;\n  height: 10px;\n  border-radius: 100%;\n  display: inline-block;\n  margin-top: 5px;\n}\n.recent-wrapper {\n  align-items: center;\n  .order-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 36px;\n    @media (max-width: 1199px) {\n      gap: 20px;\n    }\n    @media (max-width: 575px) {\n      justify-content: center;\n      flex-wrap: wrap;\n      flex-direction: row;\n    }\n    li {\n      display: flex;\n      align-items: flex-start;\n      gap: 8px;\n    }\n  }\n  .recent-chart {\n    .apexcharts-canvas {\n      .apexcharts-datalabel-label {\n        @media (max-width: 1660px) {\n          font-size: 15px;\n        }\n      }\n    }\n  }\n  > div {\n    @media (max-width: 1560px) and (min-width: 1400px) {\n      width: 100%;\n    }\n    &:last-child {\n      @media (max-width: 1560px) and (min-width: 1400px) {\n        display: none;\n      }\n    }\n  }\n}\n.apexcharts-series.apexcharts-radial-series {\n  position: relative;\n  &::after {\n    position: absolute;\n    content: \"\";\n    background: linear-gradient(0deg, #ffffff 0.05%, #f4f4f4 19.91%, #f5f6f9 55.02%, #eaecf4 100%);\n    width: calc(100% + 10px);\n    height: calc(100% + 10px);\n    top: 0;\n    left: 0;\n  }\n}\n\n// bootstrap basic table page\n.card-block {\n  .table-responsive {\n    .table {\n      caption {\n        padding-left: 10px;\n      }\n    }\n\n    .table-bordered {\n      td {\n        vertical-align: middle;\n      }\n    }\n  }\n\n  .table-border-radius {\n    border-bottom-left-radius: 4px;\n    border-bottom-right-radius: 4px;\n  }\n\n  .default-checkbox-align {\n    #checkbox1 {\n      margin-right: 10px;\n    }\n\n    #radio {\n      margin-right: 5px;\n    }\n  }\n}\n\n// datatable styling page\n#example-style-3_wrapper {\n  #example-style-3 {\n    tfoot {\n      border-top: 2px solid $light-semi-gray;\n    }\n  }\n}\n\n// chartjs page\n.chart-vertical-center {\n  display: flex;\n  justify-content: center;\n\n  #myDoughnutGraph,\n  #myPolarGraph {\n    width: auto !important;\n  }\n}\n\n// ckeditor page\n.cke_focus {\n  padding: 15px;\n  margin-top: 13px;\n}\n\n// ace-code-editor page\n#editor {\n  .ace_scroller {\n    .ace_content {\n      .ace_layer {\n        .ace_print-margin {\n          visibility: hidden !important;\n        }\n      }\n    }\n  }\n}\n\n// Helper classes page css\n.helper-classes {\n  padding: 30px;\n  margin-bottom: 0;\n  white-space: pre-line;\n}\n\n// starter kit page css\n.starter-kit-fix {\n  .page-body {\n    margin-bottom: 52px;\n  }\n}\n\n.starter-main {\n  .card-body {\n    p {\n      font-size: 14px;\n    }\n\n    ul {\n      padding-left: 30px;\n      list-style-type: disc;\n      margin-bottom: 15px;\n    }\n\n    h5 {\n      font-size: 18px;\n    }\n\n    pre {\n      white-space: pre-line;\n      padding: 30px;\n    }\n\n    .alert-primary {\n      &.inverse {\n        &:before {\n          top: 32px;\n        }\n      }\n    }\n  }\n\n  .alert {\n    background-color: rgba(68, 102, 242, 0.2) !important;\n\n    i {\n      display: flex;\n      align-items: center;\n    }\n  }\n}\n\n//typography//\nfooter {\n  &.blockquote-footer {\n    bottom: unset;\n  }\n}\n\n// index responsive css\n\n@media only screen and (max-width: 991px) {\n  .notification {\n    li {\n      padding-bottom: 20px;\n    }\n    .card {\n      .card-body {\n        .d-flex {\n          .w-100 {\n            p {\n              margin: 0;\n            }\n\n            h6 {\n              margin-top: 10px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .footer-fix {\n    .pull-right {\n      float: none !important;\n      text-align: center !important;\n    }\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  .notification {\n    li {\n      padding-bottom: 15px;\n    }\n  }\n\n  .media-dropdown {\n    display: block;\n\n    .media-body {\n      margin-bottom: 15px;\n    }\n  }\n}\n\n@media only screen and (max-width: 360px) {\n  .footer {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n\n    p {\n      font-size: 12px;\n    }\n  }\n\n  .appointment-table {\n    table {\n      tr {\n        td {\n          min-width: 103px;\n\n          &:first-child {\n            min-width: 50px;\n          }\n\n          &:nth-child(2) {\n            min-width: 120px;\n          }\n        }\n      }\n    }\n  }\n}\n\n/**=====================\n53. Dashboard CSS Ends\n==========================**/\n","/**=====================\n    33.  Ecommerce  CSS Start\n==========================**/\n\n/**====== Product Start ======**/\n.toggle-data {\n  cursor: pointer;\n}\n\n.filter-block {\n  ul {\n    li {\n      padding-top: 15px !important;\n      opacity: 0.5;\n      @media (max-width: 1500px) {\n        padding-top: 10px !important;\n      }\n    }\n  }\n}\n.collection-filter-block {\n  svg {\n    width: 50px;\n    height: 25px;\n    stroke: var(--theme-default);\n    fill: #e8e5ff;\n    margin-right: 10px;\n  }\n\n  h5 {\n    margin-bottom: 0;\n    font-size: 16px;\n  }\n  p {\n    font-size: 13px;\n  }\n\n  .media-body {\n    opacity: 0.5;\n  }\n  li {\n    & + li {\n      margin-top: 16px;\n    }\n  }\n  ul.pro-services {\n    li {\n      svg {\n        width: auto;\n      }\n    }\n  }\n}\n\n.qty-box {\n  .btn {\n    background-color: transparent !important;\n    border-color: $light-gray !important;\n    padding: 8px 12px;\n    i {\n      color: $dark-gray;\n    }\n    svg {\n      width: 14px !important;\n      stroke: $dark-color;\n    }\n  }\n\n  span {\n    padding: 0 0px;\n  }\n  .input-group {\n    background-color: rgba($dark-color, 0.1);\n    // width:100px;\n  }\n\n  input {\n    background-color: rgba($dark-color, 0.1);\n    color: $dark-color;\n    max-width: 44px;\n    padding: 0;\n    text-align: center;\n    border: none;\n    max-height: 37px;\n  }\n}\n.product-social {\n  li {\n    a {\n      color: $dark-gray;\n      font-size: 15px;\n      border: 1px solid $gray-60;\n      border-radius: 100%;\n      height: 35px;\n      width: 35px;\n      display: inline-block;\n      text-align: center;\n      line-height: 2.3;\n      transition: all 0.3s ease;\n\n      &:hover {\n        border-color: $primary-color;\n        color: $primary-color;\n        background-color: rgba($primary-color, 0.1);\n        transition: all 0.3s ease;\n      }\n    }\n    &:nth-child(n + 2) {\n      margin-left: 10px;\n      [dir=\"rtl\"] & {\n        margin-left: unset;\n        margin-right: 10px;\n      }\n    }\n  }\n}\n\n.product-sidebar {\n  .filter-section {\n    .card {\n      .card-header {\n        padding: 16px 30px;\n        border-radius: 5px;\n        h6 {\n          position: relative;\n          .pull-right {\n            i {\n              position: absolute;\n              top: 4px;\n              left: 0;\n              font-size: 10px;\n              width: 100%;\n              height: 10px;\n              text-align: right;\n              cursor: pointer;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.product-wrapper {\n  .product-sidebar {\n    .filter-section {\n      .card {\n        .left-filter {\n          z-index: 0;\n          opacity: 0;\n          visibility: hidden;\n          height: 0;\n          transition: 0.3s;\n          min-width: 320px;\n\n          .product-filter {\n            .irs-with-grid {\n              margin-bottom: 15px;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .product-grid {\n    .product-wrapper-grid {\n      margin-left: 0;\n      transition: 0.3s;\n    }\n  }\n\n  &.sidebaron {\n    .product-sidebar {\n      .filter-section {\n        .card {\n          .left-filter {\n            z-index: 3;\n            opacity: 1;\n            visibility: visible;\n            position: absolute;\n            width: 100%;\n            background-color: white;\n            top: 53px;\n            height: auto;\n          }\n        }\n      }\n    }\n  }\n}\n\n.d-none-productlist {\n  display: none;\n\n  svg {\n    vertical-align: middle;\n    cursor: pointer;\n  }\n}\n\n.product-wrapper-grid {\n  &.list-view {\n    .product-box {\n      display: flex;\n      align-items: center;\n\n      .product-img {\n        width: 20%;\n      }\n\n      .product-details {\n        text-align: left;\n      }\n    }\n  }\n}\n\n.slider-product {\n  padding: 15px 0;\n  border-top: 1px solid $light-color;\n  border-bottom: 1px solid $light-color;\n  margin-bottom: 15px;\n}\n\n.products-total {\n  display: flex;\n  align-items: center;\n}\n\n.grid-options {\n  height: 33px;\n  margin-left: 10px;\n\n  ul {\n    li {\n      a {\n        position: relative;\n\n        .line-grid {\n          position: absolute;\n          width: 4px;\n          height: 15px;\n          top: 9px;\n        }\n\n        .line-grid-1 {\n          left: 12px;\n        }\n\n        .line-grid-2 {\n          left: 18px;\n        }\n\n        .line-grid-3 {\n          left: 36px;\n        }\n\n        .line-grid-4 {\n          left: 42px;\n        }\n\n        .line-grid-5 {\n          left: 48px;\n        }\n\n        .line-grid-6 {\n          left: 66px;\n        }\n\n        .line-grid-7 {\n          left: 72px;\n        }\n\n        .line-grid-8 {\n          left: 78px;\n        }\n\n        .line-grid-9 {\n          left: 84px;\n        }\n\n        .line-grid-10 {\n          left: 103px;\n        }\n\n        .line-grid-11 {\n          left: 109px;\n        }\n\n        .line-grid-12 {\n          left: 115px;\n        }\n\n        .line-grid-13 {\n          left: 121px;\n        }\n\n        .line-grid-14 {\n          left: 127px;\n        }\n\n        .line-grid-15 {\n          left: 133px;\n        }\n      }\n    }\n  }\n}\n\n.square-product-setting {\n  height: 36px;\n  vertical-align: middle;\n\n  a {\n    color: $theme-body-font-color;\n  }\n\n  .icon-grid {\n    padding: 7px;\n    background-color: $white;\n    display: flex;\n    align-items: center;\n    margin: 0 10px;\n\n    svg {\n      width: 20px;\n      height: 20px;\n    }\n  }\n}\n\n.product-filter {\n  .banner-product {\n    margin-top: 15px;\n  }\n\n  h6 {\n    margin-bottom: 15px;\n  }\n\n  .color-selector {\n    line-height: 0.9;\n\n    ul {\n      li {\n        display: inline-block;\n        width: 20px;\n        height: 20px;\n        border: 1px solid #444;\n        border-radius: 100%;\n        cursor: pointer;\n\n        &.white {\n          background-color: $white;\n        }\n\n        &.gray {\n          background-color: $theme-body-sub-title-color;\n        }\n\n        &.black {\n          background-color: $black;\n        }\n\n        &.orange {\n          background-color: #ffb17a;\n        }\n\n        &.green {\n          background-color: #6fb866;\n        }\n\n        &.pink {\n          background-color: pink;\n        }\n\n        &.yellow {\n          background-color: #f2f896;\n        }\n\n        &.blue {\n          background-color: #63b4f2;\n        }\n\n        &.red {\n          background-color: #ff647f;\n        }\n      }\n    }\n  }\n\n  &.new-products {\n    margin-top: 20px;\n\n    button {\n      width: auto;\n    }\n\n    .owl-theme {\n      .owl-nav {\n        margin-top: 0;\n        position: absolute;\n        top: -46px;\n        right: 0;\n\n        button {\n          &:focus {\n            outline: $transparent-color;\n          }\n\n          span {\n            font-size: 20px;\n\n            &:focus {\n              outline-color: $transparent-color;\n            }\n          }\n        }\n      }\n\n      .owl-nav [class*=\"owl-\"] {\n        &:hover {\n          background-color: $transparent-color;\n          color: inherit;\n        }\n      }\n\n      .owl-item {\n        .item {\n          .product-box {\n            .product-details {\n              padding: 25px 0;\n            }\n\n            + .product-box {\n              margin-top: 15px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.select2-drpdwn-product {\n  .form-control {\n    border: none;\n    box-shadow: 1px 5px 24px 0 rgba(68, 102, 242, 0.05);\n    margin-bottom: 10px;\n    height: 36px;\n  }\n}\n\n.feature-products {\n  form {\n    .form-group {\n      position: relative;\n\n      input {\n        margin-bottom: 15px;\n        border: none;\n        box-shadow: 1px 5px 24px 0 rgba(68, 102, 242, 0.05);\n        height: 50px;\n        padding-left: 30px;\n      }\n\n      i {\n        position: absolute;\n        top: 18px;\n        right: 30px;\n        color: $dark-gray;\n      }\n    }\n  }\n}\n.product-page-main {\n  padding: 30px;\n\n  .small-slick {\n    margin-top: 20px;\n    .item {\n      border: 1px solid $light-color;\n      border-radius: 5px;\n    }\n    .slick-slide {\n      padding: 0 10px;\n      &.slick-current {\n        .item {\n          border: 1px solid var(--theme-default);\n        }\n      }\n    }\n  }\n}\n\n.modal {\n  .modal-header {\n    padding: 0;\n    border: none;\n    .product-box {\n      .product-details {\n        padding: 25px 0;\n\n        h6 {\n          text-transform: capitalize;\n        }\n\n        .product-price {\n          font-size: 22px;\n          margin-bottom: 10px;\n        }\n\n        .product-view {\n          padding: 20px 0;\n          border-top: 1px dotted $semi-dark;\n          border-bottom: 1px dotted $semi-dark;\n        }\n\n        .product-size {\n          margin: 20px 0;\n\n          ul {\n            li {\n              display: inline-block;\n            }\n          }\n        }\n\n        .product-qnty {\n          fieldset {\n            margin-bottom: 20px;\n\n            .input-group {\n              width: 35%;\n\n              .btn {\n                padding: 5px 12px;\n              }\n\n              .btn-primary {\n                background-color: $semi-dark !important;\n                border: 1px solid $semi-dark !important;\n              }\n            }\n          }\n        }\n      }\n    }\n    .btn-close {\n      position: absolute;\n      right: 15px;\n      top: 10px;\n    }\n  }\n}\n.product-box {\n  border-radius: 10px;\n  overflow: hidden;\n\n  .product-details {\n    padding: 15px 25px;\n\n    > a {\n      color: $theme-body-font-color;\n    }\n\n    p {\n      margin-bottom: 0;\n      opacity: 0.8;\n    }\n\n    h4 {\n      margin-bottom: 0;\n      margin-top: 5px;\n      font-size: 20px;\n      font-family: roboto;\n    }\n\n    h6 {\n      color: $theme-body-font-color;\n      text-transform: uppercase;\n      margin-bottom: 10px;\n    }\n\n    span {\n      color: $dark-gray;\n    }\n\n    .rating {\n      i {\n        font-size: 16px;\n        letter-spacing: 3px;\n        color: #ffa800;\n      }\n    }\n  }\n\n  .modal {\n    .modal-header {\n      .product-box {\n        .product-details {\n          padding: 25px 0;\n\n          h6 {\n            text-transform: capitalize;\n          }\n\n          .product-price {\n            font-size: 22px;\n            margin-bottom: 10px;\n          }\n\n          .product-view {\n            padding: 20px 0;\n            border-top: 1px dotted $semi-dark;\n            border-bottom: 1px dotted $semi-dark;\n          }\n\n          .product-size {\n            margin: 20px 0;\n\n            ul {\n              li {\n                display: inline-block;\n              }\n            }\n          }\n\n          .product-qnty {\n            fieldset {\n              margin-bottom: 20px;\n\n              .input-group {\n                width: 35%;\n\n                .btn {\n                  padding: 5px 12px;\n                }\n\n                .btn-primary {\n                  background-color: $semi-dark !important;\n                  border: 1px solid $semi-dark !important;\n                }\n              }\n            }\n          }\n        }\n      }\n      .btn-close {\n        position: absolute;\n        right: 15px;\n        top: 10px;\n      }\n    }\n  }\n\n  .product-img {\n    position: relative;\n\n    .product-hover {\n      position: absolute;\n      height: 100%;\n      width: 100%;\n      top: 0;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background-color: rgba($black, 0.3);\n      opacity: 0;\n      border-radius: 100%;\n      transform: scale(0);\n      transition: all 0.3s ease;\n\n      ul {\n        li {\n          display: inline-block;\n          box-shadow: 1px 1px 2px 1px rgba(0, 0, 0, 0.08);\n          padding: 10px 12px;\n          background-color: $white;\n          font-size: 18px;\n          border-radius: 10px;\n          height: 45px;\n          width: 45px;\n          margin: 0 3px;\n          cursor: pointer;\n\n          i {\n            color: $semi-dark;\n            font-size: 18px;\n          }\n\n          .btn {\n            padding: 0;\n          }\n\n          &:hover {\n            background-color: var(--theme-default);\n            transition: all 0.3s ease;\n\n            .btn,\n            i {\n              color: $white;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  &:hover {\n    .product-hover {\n      opacity: 1;\n      border-radius: 0%;\n      transform: scale(1);\n      transition: all 0.3s ease;\n    }\n  }\n}\n\n.product-page-main {\n  padding: 30px;\n  .owl-item {\n    .item {\n      border: 1px solid $light-color;\n      border-radius: 5px;\n      background-color: #f8f8f8;\n    }\n    &.current {\n      .item {\n        border: 1px solid var(--theme-default);\n      }\n    }\n  }\n  .product-slider {\n    img {\n      @media (min-width: 1400px) {\n        height: 520px;\n        object-fit: cover;\n      }\n      @media (min-width: 1500px) {\n        height: 400px;\n        object-fit: cover;\n      }\n    }\n  }\n  .product-color {\n    margin-top: 10px;\n  }\n}\n\n.product-page-details {\n  h4 {\n    color: $theme-body-font-color;\n    text-transform: uppercase;\n    font-size: 18px;\n  }\n\n  span {\n    padding-left: 15px;\n  }\n}\n\n.br-theme-fontawesome-stars {\n  .br-widget {\n    a,\n    a.br-selected:after,\n    a.br-active:after {\n      color: #ffa800 !important;\n      font: normal normal normal 14px/1 FontAwesome;\n    }\n  }\n}\n\n.product-price {\n  font-size: 18px;\n  font-weight: 700;\n  margin-top: 5px;\n  color: var(--theme-default);\n\n  del {\n    color: rgba($dark-color, 0.4);\n    padding-left: 10px;\n    font-size: 80%;\n  }\n}\n\n.product-color {\n  li {\n    display: inline-block;\n    border-radius: 100% !important;\n    height: 20px;\n    width: 20px;\n    margin: 0 2px;\n  }\n}\n\n.product-page-main {\n  p {\n    font-size: 15px;\n  }\n\n  .nav-link {\n    text-transform: uppercase;\n    font-weight: 500;\n  }\n}\n\n/**====== Product  Ends ======**/\n\n.payment-opt {\n  li {\n    display: inline-block;\n\n    img {\n      height: 20px;\n      margin: 15px 15px 0 0;\n    }\n  }\n}\n\n/**=====================\n    33. Ecommerce  CSS End\n==========================**/\n@media screen and (max-width: 1660px) and (min-width: 1200px) {\n  .owl-carousel .owl-item img {\n    max-width: 420px;\n    margin: 0 auto;\n  }\n}\n","/**=====================\n    13.  Email Application  CSS Start\n==========================**/\n%email-mixin {\n  background: transparent;\n  font-size: 15px;\n  line-height: 25px;\n}\n.email-wrap {   \n  // margin-bottom:30px;\n  .row {\n    .col-xl-3 {\n      &+.col-xl-3 {\n        padding-right: 0;\n      }\n    }\n    .col-xl-6 {\n      padding-left: 0;\n    }\n  }\n  .dropdown {\n    .dropdown-toggle {\n      background-color: rgba(115,102,255,0.08);\n      color: $primary-color;\n      border-radius: 10px;\n      padding: 5px 10px;\n      width: 100px;\n      text-align: left;\n      [dir=\"rtl\"] & {\n        text-align: right;\n      }\n      &:after {\n        position: absolute;\n        top: 50%;\n        right: 10px;\n        -webkit-transform: translateY(-50%);\n        transform: translateY(-50%);\n        content: \"\\f107\";\n        border: none;\n        font-family: \"FontAwesome\";\n        font-size: 18px;\n        margin: 0;\n        [dir=\"rtl\"] & {\n          right: unset;\n          left: 10px;\n        }\n      }\n    }\n    .dropdown-menu {\n      -webkit-box-shadow: 0 0 20px rgba(89,102,122,0.1);\n      box-shadow: 0 0 20px rgba(89,102,122,0.1);\n      border: none;\n      padding: 0;\n      .dropdown-item {\n        color: #2b2b2b;\n        opacity: 0.6;\n        font-size: 13px;\n        padding: 6px 12px;\n        border-top: 1px solid #f5f5f5;\n        background: $white;\n        line-height: 19px;\n        &:hover {\n          background-color: $white;\n        }\n      }\n    }\n  }\n  .email-app-sidebar {\n    .media img {\n      border: 2px solid $light-gray;\n    }\n    .main-menu {\n      >li {\n        width: 100%;\n        text-align: left;\n        a {\n          line-height: 39px;\n          text-transform: uppercase;\n          border-radius: 3px;\n          i {\n            margin-right: 10px;\n          }\n          &.active>a {\n            color: $black;\n          }\n          &:hover {\n            background-color:#f5f6f9;\n            text-decoration: none;\n          }\n        }\n      }\n    }\n\n    ul li {\n      a {\n        display: flex;\n        padding-left: 20px;\n        align-items: center;\n\n        > {\n          .title {\n            width: 100%;\n            color: $dark-color;\n          }\n\n          .badge {\n            align-self: center;\n            color: $dark-gray;\n          }\n        }\n      }\n    }\n  }\n\n  .email-left-aside {\n    float: left;\n    width: 100%;\n\n    .card-body {\n      padding: 20px;\n    }\n  }\n\n  .email-right-aside {   \n    .email-body {\n      .pr-0{\n        @media (min-width: 1200px) {\n          padding-right: 0;\n          [dir=\"rtl\"] & {\n            padding-right: 12px;\n            padding-left: 0;\n          }\n        }\n\n      }\n      .pl-0{\n        @media (min-width: 1200px) {\n          padding-left: 0;\n          [dir=\"rtl\"] & {\n            padding-left: 12px;\n            padding-right: 0;\n          }\n        }\n      }\n      .inbox {\n        overflow: auto;\n        @media (max-width: 1199.98px) {\n          display: flex;\n          flex-wrap: wrap;\n        }\n        .media {\n          padding: 20px;\n\n          &.active {\n            background-color: lighten($light-color, 4%);\n          }\n        }\n      }\n    }\n\n    .radius-left {\n      border-radius: 8px;\n      height: 100%;\n    }\n  }\n\n  .btn-mail {\n    border-radius: 2px;\n    text-align: left;\n    padding: 13px 15px;\n    margin: 20px 0 20px;\n    letter-spacing: 1px;\n    line-height: 12px !important;\n  }\n\n  p {\n    margin-bottom: 0;\n    color: $dark-gray;\n  }\n\n  .media-body {\n    margin-top: 5px;\n\n    h6 {\n      margin-bottom: 2px;\n      color: $theme-font-color;\n      margin-top: 3px;\n\n      small {\n        font-size: 12px;\n        span {\n          color: #777777;\n        }\n      }\n    }\n\n    p {\n      color: $theme-body-sub-title-color;\n      font-size: 12px;\n    }\n  }\n\n  .email-top {\n    padding: 20px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n    line-height: 49px;\n    i{\n      cursor: pointer;\n    }\n    h5 {\n      margin-bottom: 0;\n      padding: 12px 0;\n    }\n\n    .d-flex {\n      padding: 13px 0;\n    }\n  }\n  .email-wrapper {\n    padding: 20px;\n    hr {\n      margin-top: 0;\n      margin-bottom: 20px;\n    }\n    .d-inline-block {\n      width: 100%;\n    }\n    h6 {\n      margin-bottom: 11px;\n      float: left;\n    }\n    .right-download {\n      float: right;\n    }\n    p {\n      &+p {\n        margin-bottom: 20px;\n      }\n    }\n\n    h5 {\n      margin-bottom: 20px;\n    }\n  }\n\n  .email-content .email-top .user-emailid:after {\n    content: \"\";\n    position: relative;\n    height: 20px;\n    width: 1px;\n    right: 0;\n    top: 3px;\n    z-index: 2;\n    border: 1px solid $light-semi-gray;\n    float: right;\n    padding: 0;\n    margin: 0 20px;\n  }\n\n  .email-body {\n    .attachment {\n      ul {\n        li {\n          img {\n            margin-bottom: 20px;\n            width: 80px;\n            height: 80px;\n            object-fit: cover;\n          }\n        }\n      }\n\n      .list-inline {\n        .list-inline-item {\n          padding-right: 13px;\n        }\n      }\n\n    }\n\n    .email-compose {\n      .cke_contents.cke_reset {\n        max-height: 178px;\n        width: 100%;\n        border: 1px solid $form-control-border-color;\n      }\n\n      .email-top {\n        h4 {\n          padding: 11px 0;\n        }\n      }\n\n      .compose-border {\n        // margin: -1px;\n        .btn-middle {\n          padding-top: 5px;\n        }\n      }\n    }\n  }\n\n  .actions li {\n    display: inline-block;\n    margin-right: 25px;\n  }\n}\n\n/**=====================\n    13.  Email Application  CSS Ends\n==========================**/","/**=====================\n     09. Error-page  CSS Start\n==========================**/\n.error-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  text-align: center;\n  &.maintenance-bg {\n    background-image: url(../../images/other-images/maintenance-bg.jpg);\n    background-color: rgba(255, 255, 255, 0.6);\n    background-blend-mode: overlay;\n  }\n  .maintenance-icons {\n    li {\n      i {\n        color: $semi-dark;\n        font-size: 50px;\n        animation: rotate-effect 40s infinite linear reverse;\n      }\n      &:nth-child(2) {\n        i {\n          font-size: 100px;\n          margin-left: 110px;\n          margin-top: -25px;\n          animation: rotate-effect 40s linear infinite reverse;\n        }\n      }\n      &:nth-child(3) {\n        i {\n          animation: rotate-effect 30s infinite linear;\n          font-size: 150px;\n          margin-top: -85px;\n          margin-right: 120px;\n        }\n      }\n    }\n  }\n  .maintenance-heading {\n    margin-top: 70px;\n    .headline {\n      font-size: 99px;\n      font-weight: 900;\n      letter-spacing: 10px;\n      color: var(--theme-default);\n      z-index: 2;\n      position: relative;\n      margin-top: -70px;\n    }\n  }\n  .error-heading {\n    margin-top: 115px;\n    .headline {\n      font-size: 285px;\n      font-weight: 700;\n      letter-spacing: 1px;\n      margin-top: -130px;\n    }\n  }\n  .sub-content {\n    font-size: 18px;\n    color: $theme-body-font-color;\n    letter-spacing: 1px;\n    font-weight: normal;\n    line-height: 35px;\n    z-index: 3;\n    position: relative;\n    margin-top: 30px;\n    margin-bottom: 0;\n  }\n  .btn {\n    margin-top: 40px;\n  }\n}\n.error {\n  margin: 70px 0 100px;\n  color: $black;\n  .error-title {\n    font-size: 9.5rem;\n    color: $white;\n    text-shadow: 6px 6px 7px rgba(0, 0, 0, 0.32);\n  }\n  .line-bottom {\n    width: 10%;\n    height: 5px;\n    background-color: $warning-color;\n    border: none;\n  }\n  .c-white {\n    color: $white;\n  }\n  .error-btn {\n    text-align: center;\n  }\n  .padd {\n    padding: 10px 30px 10px 30px;\n  }\n  .btn-back-home {\n    background-color: $light-color;\n    color: $black;\n\n    &:hover {\n      background-color: $warning-color;\n      color: $white;\n      box-shadow: 0 20px 35px 0 rgba(0, 0, 0, 0.21);\n    }\n  }\n  .btn-adnc-serc {\n    background-color: $dark-color;\n    color: $white;\n    &:hover {\n      background-color: $warning-color;\n      color: $white;\n      box-shadow: 0 20px 35px 0 rgba(0, 0, 0, 0.21);\n    }\n  }\n}\n/**=====================\n     09. Error-page CSS Ends\n==========================**/\n","//According settings\n$card-padding: 30px;\n$card-margin-bottom: 30px;\n$card-border-width: 0px;\n$card-border-color: $light-color;\n$card-border-radious: 8px;\n$card-box-shadow: 0 0 10px 0 rgba(68, 102, 242, 0.05);\n$card-header-font-weight: 600;\n$card-header-bg-color: $white;\n$card-header-font-size: 18px;\n$card-header-font-transform: uppercase;\n$card-header-font-color: $theme-body-font-color;\n$card-header-span-size: 12px;\n$card-header-span-color: $theme-body-sub-title-color;\n$card-body-bg-color: $transparent-color;\n$card-footer-bg-color: $white;\n\n/**=====================\n     71. Faq CSS start\n==========================**/\n.knowledgebase-bg {\n  height: 500px;\n  border-radius: 15px;\n  margin-bottom: 30px;\n}\n\n.knowledgebase-search {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  left: 5%;\n\n  .form-inline {\n    background-color: $white;\n    width: 500px;\n    padding: 12px 50px;\n    border-radius: 10px;\n    border: 1px solid #e6e6e6;\n    margin-top: 10px;\n    position: relative;\n\n    ::placeholder {\n      color: $gray-60;\n    }\n\n    svg {\n      position: absolute;\n      left: 20px;\n      width: 20px;\n      top: 17px;\n      stroke: $gray-60;\n    }\n  }\n}\n\n.faq-widgets {\n  align-items: center;\n\n  .media-body {\n    h5 {\n      font-weight: 600;\n    }\n\n    p {\n      padding-right: 20px;\n      display: -webkit-box;\n      -webkit-box-orient: vertical;\n      -webkit-line-clamp: 4;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n\n  svg {\n    width: 50px;\n    height: 50px;\n    opacity: 0.5;\n  }\n}\n\n.header-faq {\n  h5 {\n    font-weight: 600;\n  }\n\n  margin-bottom: 30px;\n}\n\n.features-faq {\n  &.card {\n    .card-body,\n    .card-footer {\n      padding: 20px 25px;\n    }\n  }\n\n  .faq-image {\n    img {\n      border-top-left-radius: 8px;\n      border-top-right-radius: 8px;\n      width: 100%;\n    }\n  }\n\n  .card-body {\n    h6 {\n      font-weight: 500;\n    }\n  }\n}\n\n.add-project {\n  &.table td {\n    vertical-align: middle;\n  }\n\n  .text-inherit {\n    color: black;\n  }\n}\n\n.faq-accordion.default-according {\n  margin-bottom: 30px;\n\n  .card {\n    .btn-link {\n      display: flex;\n\n      svg {\n        width: 20px;\n        height: 20px;\n        margin-right: 10px;\n      }\n    }\n    .faq-header {\n      position: relative;\n      padding: 30px;\n\n      svg {\n        position: absolute;\n        right: 30px;\n        top: 30px;\n        width: 20px;\n        height: 20px;\n      }\n\n      span {\n        margin-top: 3px;\n      }\n    }\n  }\n\n  .faq-body {\n    padding: 20px !important;\n  }\n\n  .card-mb-faq {\n    margin-bottom: 30px;\n  }\n}\n\n.faq-title {\n  margin: 30px 0;\n\n  h6 {\n    color: $light-text;\n    font-weight: 600;\n  }\n}\n\n.faq-form {\n  position: relative;\n\n  .search-icon {\n    position: absolute;\n    right: 12px;\n    top: 9px;\n    width: 20px;\n    height: 20px;\n  }\n}\n\n.navigation-btn {\n  a {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    svg {\n      width: 15px;\n      height: 15px;\n    }\n  }\n\n  margin-bottom: 20px;\n}\n\n.navigation-option {\n  ul {\n    li {\n      position: relative;\n      padding: 8px 8px 8px 0 !important;\n\n      &:hover {\n        background-color: $light;\n      }\n\n      a {\n        padding-left: 40px;\n        color: $theme-body-font-color;\n\n        svg {\n          position: absolute;\n          width: 15px;\n          height: 15px;\n          top: 11px;\n          left: 15px;\n        }\n      }\n    }\n  }\n}\n\n.updates-faq {\n  width: 40px;\n  height: 40px;\n  border: 2px solid var(--theme-default);\n  border-radius: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 20px;\n\n  svg {\n    width: 18px;\n    height: 18px;\n  }\n}\n\n.updates-bottom-time {\n  p {\n    margin-bottom: 2px;\n\n    + p {\n      color: $light-text;\n    }\n  }\n}\n\n.updates-faq-main {\n  margin-bottom: 20px;\n\n  a {\n    font-weight: 500;\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n@media only screen and (max-width: 1399.98px) {\n  .faq-widgets {\n    svg {\n      width: 30px;\n      height: 30px;\n    }\n  }\n}\n\n@media only screen and (max-width: 1199px) {\n  .faq-accordion {\n    margin-bottom: 30px;\n  }\n}\n\n@media only screen and (max-width: 991px) {\n  .faq-accordion.default-according {\n    .card {\n      .faq-header {\n        padding: 20px !important;\n\n        svg {\n          right: 20px;\n          top: 20px;\n        }\n      }\n    }\n  }\n\n  .navigation-option {\n    ul {\n      li {\n        padding: 10px 10px 10px 0;\n\n        a {\n          svg {\n            top: 12px;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .xs-mt-search {\n    margin-top: 30px;\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  .xs-mt-search {\n    margin-top: 0px;\n  }\n\n  .faq-widgets {\n    svg {\n      width: 30px;\n      height: 30px;\n    }\n  }\n\n  .faq-title {\n    margin: 15px 0;\n  }\n\n  .header-faq {\n    margin-bottom: 15px;\n    margin-top: 10px;\n  }\n\n  .faq-accordion {\n    margin-bottom: 0px;\n\n    .faq-header {\n      padding: 15px !important;\n\n      .pull-right {\n        float: right;\n      }\n\n      svg {\n        right: 15px;\n        top: 15px;\n      }\n    }\n  }\n\n  .navigation-btn,\n  .updates-faq-main {\n    margin-bottom: 15px;\n  }\n}\n\n/**=====================\n     71. Faq CSS end\n==========================**/\n","/**=====================\n    File Manager\n==========================**/\n\n.file-sidebar,\n.file-content {\n  .card {\n    .card-body,\n    .card-header {\n      padding: 20px !important;\n    }\n  }\n}\n\n.file-sidebar {\n  ul {\n    li {\n      & + li {\n        margin-top: 8px;\n      }\n    }\n  }\n\n  .btn {\n    display: flex;\n    align-items: center;\n\n    &.btn-light {\n      &:hover {\n        color: var(--theme-default) !important;\n\n        svg {\n          stroke: var(--theme-default);\n        }\n      }\n    }\n\n    svg {\n      width: 15px;\n      vertical-align: middle;\n      margin-right: 8px;\n    }\n  }\n\n  .pricing-plan {\n    border: 1px solid $light-gray;\n    border-radius: 5px;\n    margin-top: 10px;\n    padding: 15px;\n    position: relative;\n    overflow: hidden;\n\n    h6 {\n      font-weight: 600;\n      font-size: 14px;\n      margin-bottom: 2px;\n      color: $dark-gray;\n    }\n\n    h5 {\n      font-weight: 800;\n    }\n\n    p {\n      margin-bottom: 5px;\n      color: $dark-gray;\n    }\n\n    .btn {\n      display: inline-block;\n    }\n\n    .bg-img {\n      position: absolute;\n      top: 40px;\n      opacity: 0.1;\n      transform: rotate(-45deg);\n      right: -40px;\n    }\n  }\n}\n\n.file-manager {\n  > h6 {\n    opacity: 0.6;\n    font-weight: 400 !important;\n    font-size: 15px;\n    margin-bottom: 12px;\n  }\n\n  .files {\n    .file-box {\n      $show-numbers: true;\n\n      @if $show-numbers {\n        @for $i from 1 through 15 {\n          &:nth-child(#{$i}) {\n            animation-fill-mode: both;\n            animation: fadeIncustom 0.5s linear #{$i}00000ms;\n          }\n        }\n      }\n    }\n\n    h6 {\n      margin-top: 10px;\n      margin-bottom: 0;\n    }\n  }\n\n  p {\n    opacity: 0.9;\n    font-size: 12px;\n  }\n}\n\n.files,\n.folder {\n  h6 {\n    opacity: 0.9;\n    font-weight: 500 !important;\n    font-size: 14px;\n  }\n}\n\n.file-content {\n  .ellips {\n    position: absolute;\n    top: 30px;\n    right: 30px;\n    opacity: 0.7;\n  }\n\n  .form-inline {\n    border: 1px solid #f4f4f4;\n    border-radius: 5px;\n    padding: 0 20px;\n\n    i {\n      padding-right: 10px;\n      color: $dark-gray;\n      line-height: 3;\n    }\n\n    input {\n      &::-webkit-input-placeholder {\n        color: $dark-gray;\n      }\n\n      &:focus {\n        outline: none !important;\n      }\n    }\n  }\n\n  .search-form {\n    input {\n      padding: 5px 10px 5px 70px;\n      border-radius: 5px;\n    }\n\n    .form-group {\n      &:before {\n        left: 82px;\n        top: 37px;\n      }\n\n      &:after {\n        top: 39px;\n        left: 53px;\n      }\n    }\n  }\n\n  .btn {\n    svg {\n      height: 15px;\n      margin-right: 2px;\n      vertical-align: middle;\n    }\n  }\n\n  h4 {\n    font-weight: 500;\n  }\n\n  .folder {\n    .folder-box {\n      border: 1px solid #f1f1f1;\n      border-radius: 5px;\n      padding: 15px;\n      background-color: #f6f7fb;\n      width: calc(25% - 15px);\n      display: inline-block;\n      margin: 3px;\n\n      $show-numbers: true;\n\n      @if $show-numbers {\n        @for $i from 1 through 15 {\n          &:nth-child(#{$i}) {\n            animation-fill-mode: both;\n            animation: fadeIncustom 0.5s linear #{$i}00000ms;\n          }\n        }\n      }\n    }\n  }\n\n  .files {\n    .file-box {\n      border: 1px solid #f1f1f1;\n      border-radius: 5px;\n      padding: 15px !important;\n      background-color: #f6f7fb;\n      width: calc(25% - 15px);\n      display: inline-block;\n      position: relative;\n      margin: 3px;\n\n      .file-top {\n        height: 100px;\n        background-color: #fff;\n        border: 1px solid #ececec;\n        border-radius: 5px;\n        font-size: 36px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 1440px) {\n  .file-content .folder .folder-box .media {\n    display: block;\n\n    .media-body {\n      margin-left: 0 !important;\n      margin-top: 5px;\n    }\n  }\n}\n\n@media screen and (max-width: 1366px) {\n  .file-content .files {\n    margin-bottom: -10px;\n\n    .file-box {\n      width: calc(50% - 15px);\n      margin-bottom: 10px;\n    }\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .file-content {\n    .folder {\n      margin-bottom: -10px;\n\n      .folder-box {\n        width: calc(50% - 15px);\n        margin-bottom: 10px;\n        margin-right: 8px;\n      }\n    }\n\n    .media {\n      display: block;\n      text-align: center;\n\n      .media-body {\n        margin-top: 20px;\n        text-align: center !important;\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 575px) {\n  .file-content .folder .folder-box,\n  .file-content .files .file-box {\n    width: calc(100%);\n  }\n\n  .file-content {\n    .btn-outline-primary {\n      // margin-top: 10px;\n    }\n  }\n}\n\n/**=====================\n     File Manager\n==========================**/\n","/**=====================\n     45. Gallery CSS Start\n==========================**/\n.profile-img-style,\n.scroll-bar-wrap {\n  img {\n    width: 100%;\n  }\n}\n.gallery {\n  margin-bottom: -30px;\n  > a {\n    margin-bottom: 30px;\n    &:before {\n      content: '\\edee';\n      font-family: $font-ICO;\n      position: absolute;\n      height: calc(100% - 10px);\n      left: 20px;\n      width: calc(100% - 40px);\n      background-color: rgba(255, 255, 255, 0.27);\n      top: 5px;\n      transform: scale(0);\n      transition: all 0.3s ease;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-size: 30px;\n      color: $black;\n    }\n    &:hover {\n      &:before {\n        transform: scale(1);\n        transition: all 0.3s ease;\n      }\n    }\n    .img-thumbnail {\n      border-radius: 0;\n      border: 1px solid var(--bs-border-color) !important;\n    }\n  }\n}\n.my-gallery {\n  .img-thumbnail {\n    border: 1px solid var(--bs-border-color) !important;\n  }\n}\n.gallery-with-description {\n  margin-bottom: -30px;\n  a {\n    .img-thumbnail {\n      border: 1px solid var(--bs-border-color) !important;\n      border-bottom: none !important;\n      border-bottom-left-radius: 0;\n      border-bottom-right-radius: 0;\n    }\n    > div {\n      padding: 10px;\n      border: 1px solid lighten($dark-color, 70%);\n      margin-bottom: 30px;\n      border-radius: 0 0 5px 5px;\n      border-top: none;\n    }\n    &:hover {\n      text-decoration: none !important;\n    }\n  }\n  &.masonry-with-dec {\n    a {\n      .img-thumbnail {\n        padding: 10px 10px 5px 10px !important;\n      }\n    }\n  }\n  h4 {\n    color: $dark-color;\n    margin-top: 15px;\n    font-size: 18px;\n  }\n  p {\n    color: lighten($dark-gray, 10%);\n  }\n}\n.lg-backdrop {\n  background-color: $white;\n}\n.lg-outer {\n  .lg-actions {\n    .lg-next,\n    .lg-prev {\n      background-color: rgb(255, 255, 255);\n      border: 1px solid $light-semi-gray;\n      &:hover {\n        color: $dark-color;\n      }\n    }\n  }\n  .lg-toolbar {\n    background-color: rgba(255, 255, 255, 0.45);\n    border-bottom: 1px solid $dark-color;\n    .lg-icon:hover {\n      color: $dark-color;\n    }\n  }\n  #lg-counter {\n    color: $dark-color;\n  }\n  .lg-sub-html {\n    background-color: rgba(255, 255, 255, 0.45);\n    h4 {\n      font-size: inherit;\n      color: $dark-color;\n    }\n    p {\n      color: $dark-color;\n    }\n  }\n  .lg-thumb-outer {\n    background-color: $light-gray;\n  }\n  .lg-thumb-item {\n    padding: 4px;\n    border: 1px solid $light-semi-gray;\n    border-radius: 0;\n    .active,\n    &:hover {\n      border-color: $black;\n    }\n  }\n}\n.gallery {\n  a {\n    &:before,\n    &:after {\n      content: none;\n    }\n  }\n  .img-hover {\n    > div {\n      overflow: hidden;\n    }\n  }\n  .hover-1 {\n    img {\n      -webkit-transform: scale(1);\n      transform: scale(1);\n      -webkit-transition: 0.3s ease-in-out;\n      transition: 0.3s ease-in-out;\n      &:hover {\n        -webkit-transform: scale(1.2);\n        transform: scale(1.2);\n      }\n    }\n  }\n  .hover-2 {\n    img {\n      width: 100%;\n      height: auto;\n      -webkit-transition: 0.3s ease-in-out;\n      transition: 0.3s ease-in-out;\n      transform: translateX(0px);\n    }\n    &:hover {\n      img {\n        transform: translateX(40px) scale(1.2);\n      }\n    }\n  }\n  .hover-3 {\n    img {\n      -webkit-transform: scale(1.2);\n      transform: scale(1.2);\n      -webkit-transition: 0.3s ease-in-out;\n      transition: 0.3s ease-in-out;\n    }\n    &:hover {\n      img {\n        -webkit-transform: scale(1);\n        transform: scale(1);\n      }\n    }\n  }\n  .hover-4 {\n    img {\n      -webkit-transform: scale(1.5);\n      transform: scale(1.5);\n      -webkit-transition: 0.3s ease-in-out;\n      transition: 0.3s ease-in-out;\n    }\n    &:hover {\n      img {\n        -webkit-transform: scale(1);\n        transform: scale(1);\n      }\n    }\n  }\n  .hover-5 {\n    img {\n      margin-left: 30px;\n      -webkit-transform: scale(1.3);\n      transform: scale(1.3);\n      -webkit-transition: 0.3s ease-in-out;\n      transition: 0.3s ease-in-out;\n    }\n    &:hover {\n      img {\n        margin-left: 0;\n      }\n    }\n  }\n  .hover-6 {\n    img {\n      -webkit-transform: rotate(15deg) scale(1.4);\n      transform: rotate(15deg) scale(1.4);\n      -webkit-transition: 0.3s ease-in-out;\n      transition: 0.3s ease-in-out;\n    }\n    &:hover {\n      img {\n        -webkit-transform: rotate(0) scale(1);\n        transform: rotate(0) scale(1);\n      }\n    }\n  }\n  .hover-7 {\n    img {\n      -webkit-filter: blur(3px);\n      filter: blur(3px);\n      -webkit-transition: 0.3s ease-in-out;\n      transition: 0.3s ease-in-out;\n    }\n    &:hover {\n      img {\n        -webkit-filter: blur(0);\n        filter: blur(0);\n      }\n    }\n  }\n\n  .hover-8 {\n    img {\n      -webkit-filter: grayscale(100%);\n      filter: grayscale(100%);\n      -webkit-transition: 0.3s ease-in-out;\n      transition: 0.3s ease-in-out;\n    }\n    &:hover {\n      img {\n        -webkit-filter: grayscale(0);\n        filter: grayscale(0);\n      }\n    }\n  }\n\n  .hover-9 {\n    img {\n      -webkit-filter: sepia(100%);\n      filter: sepia(100%);\n      -webkit-transition: 0.3s ease-in-out;\n      transition: 0.3s ease-in-out;\n    }\n    &:hover {\n      img {\n        -webkit-filter: sepia(0);\n        filter: sepia(0);\n      }\n    }\n  }\n  .hover-10 {\n    img {\n      -webkit-filter: grayscale(0) blur(0);\n      filter: grayscale(0) blur(0);\n      -webkit-transition: 0.3s ease-in-out;\n      transition: 0.3s ease-in-out;\n    }\n    &:hover {\n      img {\n        -webkit-filter: grayscale(100%) blur(3px);\n        filter: grayscale(100%) blur(3px);\n      }\n    }\n  }\n  .hover-11 {\n    img {\n      opacity: 1;\n      -webkit-transition: 0.3s ease-in-out;\n      transition: 0.3s ease-in-out;\n    }\n    &:hover {\n      img {\n        opacity: 0.5;\n      }\n    }\n  }\n\n  @-webkit-keyframes flash {\n    0% {\n      opacity: 0.4;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n  @keyframes flash {\n    0% {\n      opacity: 0.4;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n\n  .hover-13 {\n    &:hover {\n      img {\n        opacity: 1;\n        -webkit-animation: flash 1.5s;\n        animation: flash 1.5s;\n      }\n    }\n  }\n\n  @-webkit-keyframes shine {\n    100% {\n      left: 125%;\n    }\n  }\n  @keyframes shine {\n    100% {\n      left: 125%;\n    }\n  }\n  .hover-14 {\n    div {\n      position: relative;\n      &:before {\n        position: absolute;\n        top: 0;\n        left: -75%;\n        z-index: 2;\n        display: block;\n        content: '';\n        width: 50%;\n        height: 100%;\n        background: -webkit-linear-gradient(left, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.3) 100%);\n        background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.3) 100%);\n        -webkit-transform: skewX(-25deg);\n        transform: skewX(-25deg);\n      }\n      &:hover {\n        &:before {\n          -webkit-animation: shine 0.75s;\n          animation: shine 0.75s;\n        }\n      }\n    }\n  }\n  .hover-15 {\n    div {\n      position: relative;\n      &:before {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        z-index: 2;\n        display: block;\n        content: '';\n        width: 0;\n        height: 0;\n        background: rgba(255, 255, 255, 0.2);\n        border-radius: 100%;\n        -webkit-transform: translate(-50%, -50%);\n        transform: translate(-50%, -50%);\n        opacity: 0;\n      }\n      &:hover {\n        &:before {\n          -webkit-animation: circle 0.75s;\n          animation: circle 0.75s;\n        }\n      }\n    }\n  }\n}\n\n@-webkit-keyframes circle {\n  0% {\n    opacity: 1;\n  }\n  40% {\n    opacity: 1;\n  }\n  100% {\n    width: 200%;\n    height: 200%;\n    opacity: 0;\n  }\n}\n@keyframes circle {\n  0% {\n    opacity: 1;\n  }\n  40% {\n    opacity: 1;\n  }\n  100% {\n    width: 200%;\n    height: 200%;\n    opacity: 0;\n  }\n}\n* {\n  box-sizing: border-box;\n  &:after,\n  &:before {\n    box-sizing: border-box;\n  }\n}\n.grid {\n  position: relative;\n}\n/* clear fix */\n.grid:after {\n  content: '';\n  display: block;\n  clear: both;\n}\n/* ---- .grid-item ---- */\n.grid-item {\n  img {\n    max-width: 100%;\n    padding: 0.25rem;\n    background-color: $white;\n    border: 1px solid #dee2e6;\n  }\n}\n.gallery-with-description {\n  .grid-item {\n    img {\n      border: 0;\n      padding: 0;\n    }\n  }\n}\n\n/**=====================\n     45. Gallery CSS Ends\n==========================**/\n","/**=====================\n     74. internationalization css start\n==========================**/\n.hdg_main{\n  position: relative;\n}\n.main {\n  .langChoice{\n    position: absolute;\n    right: 40px;\n    top: 31px;\n    padding: 10px 12px;\n    background-color: $transparent-color;\n  }\n}\n// responsive css \n@media (max-width: 991px) {\n  .main{\n    .langChoice {\n      right: 20px;\n      top: 11px;\n      padding: 8px;\n    }\n  }\n}\n\n@media only screen and (max-width: 575px) {\n   .main {\n    .langChoice {\n      top: 14px;\n      padding: 4px 7px;\n    }\n  }\n  .language-xs{\n    margin-top: 15px;\n  }\n}\n\n@media only screen and (max-width: 360px) {\n   .language-header{\n    padding-bottom: 60px !important;\n  }\n  .main  {\n    .langChoice {\n      left: 0;\n      margin: 0 auto;\n      top: 50px;\n      width: 30%;\n      right: 0;\n    }\n  }\n}\n/**=====================\n     74. internationalization CSS end\n==========================**/\n","/**=====================\n     72. Job CSS start\n==========================**/\n.filter-cards-view {\n  .job-filter {\n    &:first-child {\n      margin-bottom: 30px;\n    }\n  }\n\n  .checkbox-animated {\n    margin-top: 30px;\n    margin-bottom: 30px;\n  }\n}\n\n.location-checkbox {\n  span {\n    color: $light-text;\n    padding-left: 33px;\n  }\n}\n\n.job-accordion {\n  .card {\n    margin-bottom: 30px;\n  }\n\n  .btn-block {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n  }\n}\n\n.job-search {\n  p {\n    margin-top: 30px;\n  }\n\n  .media {\n    .media-body {\n      h6 {\n        margin-bottom: 3px;\n\n        span {\n          font-size: 13px;\n          color: $light-text;\n          font-weight: normal;\n\n          &.badge {\n            color: $white;\n          }\n        }\n      }\n\n      p {\n        margin-top: 0;\n        color: $light-text;\n      }\n    }\n  }\n\n  .job-description {\n    margin-top: 30px;\n\n    h6 {\n      font-weight: 600;\n    }\n\n    p {\n      margin-top: 0;\n      margin-bottom: 6px;\n    }\n\n    ul {\n      list-style-type: disc;\n      list-style-position: inside;\n\n      li {\n        margin-bottom: 10px;\n\n        &:last-child {\n          margin-bottom: 0;\n        }\n      }\n    }\n\n    .theme-form {\n      margin-top: 30px;\n      margin-bottom: 30px;\n\n      .row {\n        div[class^=\"col-\"] {\n          +div[class^=\"col-\"] {\n            .select2-container {\n              margin-top: 18px;\n            }\n          }\n\n          .job-select2 {\n            ~.select2-container {\n              margin-top: 0 !important;\n            }\n          }\n\n          .input-group {\n            .datepicker-here {\n              font-size: 14px;\n              border: 1px solid $light-semi-gray;\n              padding-top: 12px;\n              padding-bottom: 12px;\n            }\n          }\n        }\n      }\n\n    }\n  }\n}\n\n.select2-container {\n  .select2-selection--single {\n    border-radius: 0.25rem !important;\n    border-color: $light-semi-gray;\n    height: 47px !important;\n    padding: 10px;\n  }\n}\n\n.job-pagination {\n  margin-bottom: 30px;\n\n  nav {\n    ul {\n      justify-content: center;\n    }\n  }\n}\n\n@media only screen and (max-width: 1366px) {\n  .xl-mt-job {\n    margin-bottom: 20px;\n  }\n}\n\n@media only screen and (max-width: 991px) {\n  .filter-cards-view {\n    padding: 20px !important;\n\n    .job-filter {\n      &:first-child {\n        margin-bottom: 20px;\n      }\n    }\n\n    .checkbox-animated {\n      margin-top: 20px;\n      margin-bottom: 20px;\n    }\n  }\n\n  .job-accordion {\n    .animate-chk {\n      padding: 20px !important;\n    }\n  }\n\n  .job-search {\n    p {\n      margin-top: 20px;\n    }\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  .filter-cards-view {\n    padding: 15px !important;\n\n    .job-filter {\n      &:first-child {\n        margin-bottom: 15px;\n      }\n    }\n\n    .checkbox-animated {\n      margin-top: 15px;\n      margin-bottom: 15px;\n    }\n  }\n\n  .job-accordion {\n    .animate-chk {\n      padding: 15px !important;\n    }\n  }\n\n  .job-search {\n    p {\n      margin-top: 15px;\n    }\n\n    .media {\n      display: block;\n      text-align: center;\n\n      .media-body {\n        h6 {\n          .pull-right {\n            float: none;\n            margin-top: 3px;\n            display: block;\n          }\n\n          a {\n            display: block;\n          }\n        }\n\n        p {\n          span {\n            +span {\n              display: block;\n            }\n          }\n        }\n      }\n\n      img {\n        margin-bottom: 15px;\n      }\n\n      .m-r-20 {\n        margin-right: 0;\n      }\n    }\n\n    .job-description {\n      margin-top: 15px;\n\n      .theme-form {\n        margin-top: 15px;\n        margin-bottom: 15px;\n\n        .row {\n          div[class^=\"col-\"] {\n            +div[class^=\"col-\"] {\n              .select2-container {\n                margin-top: 2px;\n              }\n            }\n          }\n        }\n\n        .xs-mt-period {\n          margin-top: 15px;\n        }\n      }\n    }\n  }\n\n  .job-pagination {\n    margin-bottom: 15px;\n  }\n\n  .xl-mt-job {\n    margin-bottom: 15px;\n  }\n}\n\n@media only screen and (max-width: 360px) {\n  .job-search {\n    .job-description {\n      .btn {\n        padding: 6px 12px;\n      }\n    }\n  }\n}\n\n/**=====================\n     72. Job CSS end\n==========================**/","/**=====================\n     31. JS datagrid CSS Start\n==========================**/\n.jsgrid{\n  .jsgrid-grid-body{\n    .jsgrid-cell{\n      padding: 0.75rem;\n    }\n  }\n  .jsgrid-pager-container{\n    text-align: right;\n  }\n  .jsgrid-pager{\n    padding: 0;\n    margin-top: 20px;\n    .jsgrid-pager-nav-inactive-button{\n      margin-right: -5px;\n      &:first-child{\n        border-radius: 5px 0 0 5px;\n      }\n    }\n    .jsgrid-pager-page{\n      &~.jsgrid-pager-nav-button{\n        margin-left: -5px;\n        &:last-child{\n          border-radius:0 5px 5px 0;\n        }\n      }\n    }\n    [class*=\"jsgrid-pager\"]{\n      display: inline-block;\n      min-width: 1.5em;\n      padding: 0.5em 1em;\n      border: 1px solid $light-color;\n    }\n    .jsgrid-pager-page{\n      a{\n        color: $dark-color;\n      }\n    }\n    .jsgrid-pager-current-page{\n      color: $dark-color;\n    }\n  }\n  .jsgrid-selected-row{\n    >.jsgrid-cell{\n      background: $light-color;\n      border-color: $auth-bg-color;\n    }\n  }\n  .jsgrid-header-row{\n    > .jsgrid-header-cell{\n      padding: 0.75rem;\n      font-weight: 500;\n    }\n  }\n}\n/**=====================\n     31. JS datagrid CSS Ends\n==========================**/\n","/**=====================\n   61. base_inputs CSS start\n==========================**/\n.jkanban-container {\n  .btn {\n    margin-bottom: 10px;\n  }\n\n  .note {\n    a {\n      display: contents;\n    }\n  }\n}\n\n.kanban-board-header {\n  height: auto;\n  width: auto;\n  line-height: unset;\n  background: $body-color;\n  border-bottom: 1px solid #ddd;\n\n  &.bg-info {\n    &~.kanban-drag {\n      background-color: rgba($info-color, 0.3) !important;\n    }\n  }\n\n  &.bg-warning {\n    &~.kanban-drag {\n      background-color: rgba($warning-color, 0.3) !important;\n    }\n  }\n\n  &.bg-success {\n    &~.kanban-drag {\n      background-color: rgba($success-color, 0.3) !important;\n    }\n  }\n}\n\n.kanban-container {\n  display: contents;\n}\n\n.kanban-board {\n  margin-bottom: 30px;\n  transition: all 0.3s ease;\n  letter-spacing: 0.5px;\n  border-radius: 8px;\n  box-shadow: 1px 5px 24px 0 rgba(68, 102, 242, 0.05);\n  overflow: hidden;\n  width: calc(100% / 3 - 30px) !important;\n  .kanban-drag {\n    background: $body-color;\n  }\n}\n\n.kanban-item {\n  background: transparent;\n  padding: 0;\n  margin-bottom: 20px;\n\n  p {\n    opacity: 0.7;\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  .list {\n    display: inline-block;\n    opacity: 0.4;\n\n    li {\n      display: inline-block;\n      font-size: 12px;\n\n      i {\n        margin-right: 10px;\n      }\n    }\n  }\n\n  .kanban-box {\n    border: 1px solid #efefef;\n    border-radius: 5px;\n    padding: 20px;\n    position: relative;\n    display: block;\n    color: inherit;\n    background-color: $white;\n\n    &:hover {\n      color: inherit;\n    }\n\n    &+.kanban-box {\n      margin-top: 20px;\n    }\n\n    .badge {\n      font-weight: 400;\n    }\n\n    h6 {\n      font-size: 15px;\n      margin-top: 5px;\n      font-weight: 500;\n    }\n\n    .dropdown {\n      display: inline-block;\n      right: 10px;\n      position: absolute;\n      top: 20px;\n\n      .dropdown-item {\n        font-size: 13px;\n        font-weight: 500;\n        padding: 5px 10px;\n        text-align: left;\n      }\n\n      svg {\n        height: 14px;\n      }\n    }\n\n    .d-flex {\n      justify-content: space-between;\n    }\n\n    .dropdown-toggle {\n      &:after {\n        content: none;\n      }\n    }\n\n    .customers ul li+li {\n      margin-left: -10px;\n    }\n\n    .date {\n      font-size: 11px;\n      opacity: 0.5;\n    }\n  }\n}\n\nfooter {\n  margin: 0;\n  padding: 0;\n}\n\n@media only screen and (max-width: 1199px) {\n  .jkanban-container .btn {\n    margin-bottom: 10px;\n    margin-left: 20px;\n  }\n  .kanban-container {\n    .kanban-board {\n      width: 320px !important;\n    }\n  }\n}\n\n@media only screen and (max-width: 600px) {\n\n  .kanban-board .kanban-drag,\n  .kanban-container .kanban-item .kanban-box {\n    padding: 10px 15px;\n  }\n\n  .kanban-container .kanban-board {\n    margin-left: 10px !important;\n    margin-right: 10px !important;\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  .jkanban-container {\n    .card-body {\n      padding: 20px 0 !important;\n    }\n  }\n\n  .kanban-board .kanban-drag,\n  .kanban-container .kanban-item .kanban-box {\n    padding: 10px 15px;\n  }\n\n  .kanban-container .kanban-board {\n    width: 270px !important;\n  }\n}\n\n/**=====================\n    61. base_inputs CSS ends\n==========================**/","/**=====================\n     73. knowledgebase CSS start\n==========================**/\n.browse {\n  .browse-articles {\n    span {\n      vertical-align: middle;\n      position: relative;\n      &:nth-child(2) {\n        padding-left: 20px;\n        [dir='rtl'] & {\n          padding-left: unset;\n          padding-right: 20px;\n        }\n      }\n      svg {\n        width: 14px;\n        height: 14px;\n        margin-right: 10px;\n        vertical-align: text-top;\n        position: absolute;\n        left: 0;\n        top: 3px;\n        [dir='rtl'] & {\n          left: unset;\n          right: 0;\n        }\n      }\n    }\n    h6 {\n      padding-bottom: 10px;\n      margin-bottom: 0px;\n      border-bottom: 1px solid $light;\n      padding-left: 25px;\n      [dir='rtl'] & {\n        padding-left: unset;\n        padding-right: 25px;\n      }\n      span {\n        svg {\n          width: 16px;\n          height: 16px;\n          vertical-align: text-top;\n          top: 0;\n          left: -30px;\n          [dir='rtl'] & {\n            left: unset;\n            right: -30px;\n          }\n        }\n      }\n    }\n    ul {\n      li {\n        padding: 8px !important;\n        border-radius: 8px;\n        a {\n          color: $theme-body-font-color;\n        }\n        &:hover {\n          background-color: $light;\n        }\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 1366px) {\n  .browse {\n    div[class^='col-'] {\n      &:nth-child(3) {\n        margin-top: 30px;\n      }\n    }\n  }\n}\n@media only screen and (max-width: 360px) {\n  .browse {\n    .browse-articles {\n      ul {\n        li {\n          a {\n            span {\n              &:nth-child(2) {\n                width: 158px;\n                white-space: nowrap;\n                overflow: hidden;\n                text-overflow: ellipsis;\n                display: inline-block;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n/**=====================\n     73. knowledgebase CSS end\n==========================**/\n","/**=====================\n     76. Language CSS start\n==========================**/\n.current_lang {\n  cursor: pointer;\n  text-transform: uppercase;\n  overflow: hidden;\n}\n.lang {\n  &.selected {\n    display: none;\n  }\n  span.lang-txt {\n    display: inline-flex;\n    margin-left: 8px;\n    font-weight: 500;\n  }\n\n  span {\n    span {\n      color: #999;\n      font-weight: 400;\n      margin-left: 5px;\n    }\n  }\n}\n\n/*more lang*/\n\n.more_lang {\n  transform: translateY(-20px);\n  opacity: 0;\n  cursor: pointer;\n  display: none;\n  transition: all 0.3s cubic-bezier(0.25, 1.15, 0.35, 1.15);\n}\n.translate_wrapper.active .more_lang {\n  display: block;\n  position: absolute;\n  background-color: $white;\n  top: 47px;\n  right: 0;\n  box-shadow: 0 0 20px rgba(89, 102, 122, 0.1);\n  &:before {\n    width: 0;\n    height: 0;\n    border-left: 7px solid transparent;\n    border-right: 7px solid transparent;\n    border-bottom: 7px solid #fff;\n    content: \"\";\n    top: -7px;\n    position: absolute;\n    right: 20px;\n    z-index: 2;\n  }\n  &:after {\n    width: 0;\n    height: 0;\n    border-left: 7px solid transparent;\n    border-right: 7px solid transparent;\n    border-bottom: 7px solid #bdc2c5;\n    content: \"\";\n    top: -7px;\n    position: absolute;\n    right: 20px;\n    z-index: 1;\n  }\n}\n\n.more_lang {\n  &.active {\n    opacity: 1;\n    transform: translateY(-0px);\n  }\n  .lang {\n    padding: 10px 15px;\n    display: flex;\n    &:hover {\n      background: var(--theme-default);\n      color: $white;\n      span {\n        color: $white;\n      }\n    }\n  }\n}\n\n.translate_wrapper {\n  &.active {\n    .more_lang {\n      .lang {\n        border-bottom: 1px solid #eaeaea;\n      }\n    }\n  }\n}\n/**=====================\n     76. Language CSS end\n==========================**/\n","/**=====================\n     75. Learning CSS start\n==========================**/\n.learning-header {\n  margin-bottom: 10px;\n}\n\n.categories {\n  padding: 30px 0;\n\n  .learning-header {\n    padding-left: 15px;\n  }\n\n  ul {\n    li {\n      padding: 10px 15px !important;\n\n      a {\n        color: $theme-body-font-color;\n      }\n\n      &:hover {\n        background-color: $light-color;\n      }\n    }\n  }\n}\n\n.upcoming-course {\n  .media {\n    +.media {\n      margin-top: 30px;\n    }\n  }\n}\n\n.job-accordion {\n  margin-bottom: 0;\n}\n\n@media screen and (min-width: 1200px) and (max-width: 1366px) {\n  .learning-comment {\n    margin-left: -14px !important;\n    float: left !important;\n  }\n\n  .blog-box {\n    .blog-details {\n      .blog-social {\n        li {\n          &:first-child {\n            padding-right: 30px;\n          }\n\n          +li {\n            padding-left: 30px;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 991px) {\n  .categories {\n    padding: 20px 0;\n  }\n\n  .upcoming-course {\n    .media {\n      +.media {\n        margin-top: 20px;\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  .categories {\n    padding: 15px 0;\n  }\n\n  .upcoming-course {\n    .media {\n      +.media {\n        margin-top: 15px;\n      }\n    }\n  }\n}\n\n/**=====================\n     75. Learning CSS end\n==========================**/","/**=====================\n    25. Authentication CSS Start\n==========================**/\n\n.login-card {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto;\n  background: url(\"../../images/login/login_bg.jpg\");\n  background-position: center;\n  padding: 30px 12px;\n\n  .logo {\n    display: block;\n    margin-bottom: 30px;\n    text-align: center;\n  }\n\n  .btn-showcase {\n    .btn {\n      line-height: 1;\n      padding: 10px 15px;\n      margin: 0;\n\n      & + .btn {\n        margin-left: 5px;\n      }\n\n      svg {\n        height: 16px;\n        vertical-align: bottom;\n      }\n    }\n  }\n\n  .login-main {\n    width: 450px;\n    padding: 40px;\n    border-radius: 10px;\n    box-shadow: 0 0 37px rgba(8, 21, 66, 0.05);\n    margin: 0 auto;\n    background-color: $white;\n\n    .theme-form {\n      h4 {\n        margin-bottom: 5px;\n      }\n\n      label {\n        font-size: 15px;\n        letter-spacing: 0.4px;\n      }\n\n      .checkbox label::before {\n        background-color: $card-body-color;\n        border: 1px solid #dfdfdf;\n      }\n\n      .or {\n        position: relative;\n\n        &:before {\n          content: \"\";\n          position: absolute;\n          width: 65%;\n          height: 2px;\n          background-color: #f3f3ff;\n          top: 9px;\n          z-index: 0;\n          right: 0;\n        }\n      }\n\n      input {\n        background-color: #f3f3ff;\n        transition: all 0.3s ease;\n\n        &::-webkit-input-placeholder {\n          color: $light-text;\n        }\n\n        &:hover,\n        &:focus {\n          border: 1px solid lighten($semi-dark, 35%);\n          box-shadow: none !important;\n          transition: all 0.3s ease;\n        }\n      }\n\n      p {\n        margin-bottom: 25px;\n        font-size: 14px;\n        color: $dark-gray;\n      }\n\n      .form-group {\n        margin-bottom: 10px;\n        position: relative;\n      }\n\n      .link {\n        position: absolute;\n        top: 10px;\n        right: 0;\n      }\n    }\n    &.login-tab {\n      position: relative;\n      border-top-left-radius: 0;\n      height: 100%;\n      .nav-tabs {\n        border-bottom: none;\n        position: absolute;\n        background-color: $white;\n        box-shadow: 0 0 37px rgba(8, 21, 66, 0.05);\n        left: -70px;\n        top: 0;\n        margin-bottom: 0;\n        .nav-item {\n          .nav-link {\n            position: relative;\n            img {\n              filter: grayscale(100%);\n              width: 20px;\n              height: 20px;\n              transition: 0.5s;\n            }\n            &:after {\n              content: \"\";\n              position: absolute;\n              width: 0;\n              height: 0;\n              border-color: transparent;\n              border-style: solid;\n              top: 12px;\n              border-width: 5px 0 5px 5px;\n              border-left-color: lighten($primary-color, 25%);\n              opacity: 0;\n              transform: scale(0);\n              color: #fff;\n              left: 14px;\n              z-index: 2;\n              transition: all 0.3s ease;\n            }\n            span {\n              position: absolute;\n              right: 0;\n              width: max-content;\n              text-align: right;\n              padding: 7px 10px;\n              display: block;\n              top: 0;\n              border-radius: 5px;\n              transform: scale(0);\n              transition: all 0.3s ease;\n              opacity: 0;\n              color: var(--theme-default);\n              background-color: lighten($primary-color, 25%);\n              box-shadow: 0 0 37px rgba(8, 21, 66, 0.1);\n            }\n\n            &:hover {\n              &:after {\n                opacity: 1;\n                transform: scale(1);\n                transition: all 0.3s ease;\n              }\n\n              span {\n                opacity: 1;\n                right: 56px;\n                transform: scale(1);\n                transition: all 0.3s ease;\n              }\n            }\n            &.active {\n              img {\n                filter: initial;\n                transition: 0.5s;\n              }\n            }\n          }\n        }\n      }\n      .tab-content {\n        height: 512px;\n      }\n\n      .border-tab {\n        border-radius: 0;\n        &.nav-tabs {\n          .nav-item {\n            .nav-link {\n              border-bottom: none;\n              border-right: 2px solid transparent;\n              border-top-right-radius: 0;\n              &.active,\n              &.show,\n              &:focus {\n                border-right: 2px solid var(--theme-default);\n                border-bottom: none;\n              }\n            }\n          }\n        }\n      }\n      .auth-content {\n        text-align: center;\n        img {\n          height: 300px;\n        }\n      }\n    }\n  }\n}\n\n.show-hide {\n  position: absolute;\n  top: 52px;\n  right: 20px;\n  transform: translateY(-50%);\n\n  span {\n    cursor: pointer;\n    font-size: 13px;\n    color: var(--theme-default);\n\n    &.show {\n      &:before {\n        content: \"show\";\n      }\n    }\n\n    &:before {\n      content: \"hide\";\n    }\n  }\n}\n\n.needs-validation {\n  .invalid-feedback {\n    color: $dark-gray;\n  }\n\n  .show-hide {\n    right: 30px;\n  }\n\n  .invalid-tooltip {\n    top: 10px;\n    right: 10px;\n  }\n}\n\n/**=====================\n    25. Authentication CSS Ends\n==========================**/\n","/**=====================\n   19. Mega option CSS Start\n==========================**/\n.mega-inline{\n\tmargin-bottom: -30px;\n\tdisplay: flex;\n\t.card{\n\t\tborder: 1px solid #f3f3f3;\n\t\tbox-shadow: $card-box-shadow;\n\t}\n\t.mega-title-badge{\n\t\tdisplay:table;\n\t\twidth: 100%;\n\t\tfont-size: 14px;\n    \tfont-weight: 600;\n    \ttext-transform: uppercase;\n\t}\n\t.media{\n\t\t.radio{\n\t\t\tmargin-left: 3px;\n\t\t}\n\t}\n}\n.mega-vertical{\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\t.card{\n\t\tbox-shadow: $card-box-shadow;\n\t}\n\t.mega-title-badge{\n\t\tdisplay:table;\n\t\twidth: 100%;\n\t\tfont-size: 14px;\n    \tfont-weight: 600;\n    \ttext-transform: uppercase;\n\t}\n\t.media{\n\t\t.radio{\n\t\t\tmargin-left: 3px;\n\t\t}\n\t}\n}\n.mega-title{\n\tfont-weight: 600;\n}\n.mega-horizontal{\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\t.card{\n\t\tborder: 1px solid #f3f3f3;\n\t\tbox-shadow: $card-box-shadow;\n\t}\n\t.mega-title-badge{\n\t\tdisplay:table;\n\t\twidth: 100%;\n\t\tfont-size: 14px;\n    \tfont-weight: 600;\n    \ttext-transform: uppercase;\n\t}\n\t.media{\n\t\t.radio{\n\t\t\tmargin-left: 3px;\n\t\t}\n\t}\n}\n.plain-style{\n\t.card{\n\t\tbox-shadow: none;\n\t\tborder: none !important;\n\t}\n}\n.border-style{\n\t.card{\n\t\tbox-shadow: none;\n\t\tborder: 1px solid $light-gray !important;\n\t}\n}\n.offer-style{\n\t.card{\n\t\tbox-shadow: none;\n\t\tborder: 1px dashed $light-gray !important;\n\t}\n}\n.rating-star-wrapper{\n\tcolor: #797979;\n}\n/**=====================\n     19. Mega option CSS Ends\n==========================**/","/**=====================\n     76. Order History CSS start\n==========================**/\n.prooduct-details-box {\n  .close {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    height: 16px;\n    cursor: pointer;\n  }\n\n  .media {\n    border: 1px solid $light-background;\n    border-radius: 10px;\n    padding: 15px 0;\n    width: 100%;\n    position: relative;\n    .media {\n      border: none;\n      border-radius: 0;\n      padding: 0;\n    }\n  }\n\n  .rating {\n    color: #ffaf45;\n    letter-spacing: 3px;\n  }\n\n  .product-name {\n    a {\n      color: gray;\n    }\n    h6 {\n      margin-bottom: 0;\n    }\n  }\n\n  .btn {\n    position: absolute;\n    right: 15px;\n    bottom: 15px;\n  }\n}\n\n.order-history {\n  .input-group {\n    text-align: right;\n    max-width: 300px;\n  }\n  table {\n    th,\n    td {\n      text-align: center;\n    }\n    thead {\n      tr {\n        th {\n          vertical-align: middle;\n          border-top: none;\n          background-color: $body-color;\n          border: 1px solid $light-gray;\n          padding: 1.25rem;\n          font-size: 16px;\n        }\n      }\n    }\n\n    .qty-box {\n      min-width: 270px;\n      margin: 0 auto;\n      border-radius: 5px;\n      overflow: hidden;\n      input {\n        width: 44px;\n        max-width: 44px;\n        background-color: transparent;\n        border: none !important;\n      }\n      .input-group {\n        align-items: center;\n        background-color: transparent;\n        border-radius: 5px;\n        border: 1px solid $light-gray;\n        overflow: hidden;\n        display: inline-flex;\n        width: unset;\n      }\n      .btn {\n        background-color: transparent;\n        border: none;\n        &.bootstrap-touchspin-down {\n          border-right: 1px solid;\n          [dir='rtl'] & {\n            border-right: unset;\n            border-left: 1px solid;\n          }\n        }\n        &.bootstrap-touchspin-up {\n          border-left: 1px solid;\n          [dir='rtl'] & {\n            border-left: unset;\n            border-right: 1px solid;\n          }\n        }\n      }\n    }\n\n    tbody {\n      tr {\n        td {\n          vertical-align: middle;\n\n          .product-name {\n            min-width: 160px;\n            a {\n              font-size: 15px;\n              color: $dark-gray;\n            }\n\n            .order-process {\n              font-size: 13px;\n              padding-left: 15px;\n\n              .order-process-circle {\n                position: relative;\n\n                &:before {\n                  position: absolute;\n                  content: '';\n                  width: 4px;\n                  height: 4px;\n                  border-radius: 100%;\n                  background-color: $dark-gray;\n                  left: -15px;\n                  top: 4px;\n                }\n\n                &.shipped-order {\n                  &:before {\n                    background-color: $success-color;\n                  }\n                }\n\n                &.cancel-order {\n                  &:before {\n                    background-color: $danger-color;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 1199px) {\n  .order-history {\n    table {\n      width: 900px;\n      overflow: auto;\n    }\n  }\n}\n\n/**=====================\n     76. Order History CSS end\n==========================**/\n","/**=====================\n     32. pagination CSS Start\n==========================**/\n/*test Nav bar color */\n$page-name: theme, primary, secondary, success, danger, info, dark, warning;\n$page-color: var(--theme-default), var(--theme-default), $secondary-color, $success-color, $danger-color, $info-color, $dark-color, $warning-color;\n@each $var in $page-name {\n  $i: index($page-name, $var);\n  .pagination-#{$var} {\n    .page-item {\n      .page-link {\n        color: nth($page-color, $i) !important;\n        @media only screen and (max-width: 575px) {\n          font-size: 13px;\n        }\n      }\n      &.active {\n        .page-link {\n          color: $white !important;\n          background-color: nth($page-color, $i) !important;\n          border-color: nth($page-color, $i);\n        }\n      }\n    }\n  }\n}\n/**=====================\n     32. pagination CSS Ends\n==========================**/\n","/**=====================\n     34. Pricing CSS Start\n==========================**/\n.pricing-simple {\n  box-shadow: 0 0 10px 5px rgba(68, 102, 242, 0.05);\n  margin-bottom: 0 !important;\n  .card-body {\n    border-bottom: none;\n    h3 {\n      position: relative;\n      margin-bottom: 38px;\n\n      &:before {\n        position: absolute;\n        content: \"\";\n        width: 80px;\n        height: 1px;\n        margin: 0 auto;\n        left: 0;\n        right: 0;\n        bottom: -10px;\n        background-color: $light-text;\n      }\n    }\n\n    h1 {\n      font-size: 30px;\n      line-height: 0.9;\n      margin-bottom: 30px;\n      font-weight: 400;\n    }\n  }\n}\n\n.pricingtable {\n  text-align: center;\n  padding-top: 45px;\n  padding-bottom: 45px;\n  border-radius: 10px;\n  box-shadow: $card-hover-box-shadow;\n  overflow: hidden;\n  position: relative;\n  z-index: 1;\n  height: 100%;\n  &:before,\n  &:after {\n    content: \"\";\n    background-color: var(--theme-default);\n    width: 300px;\n    height: 300px;\n    border-radius: 50%;\n    position: absolute;\n    right: -213px;\n    z-index: -1;\n    opacity: 0.1;\n  }\n}\n\n.pricingtable {\n  &:after {\n    background-color: var(--theme-default);\n    height: 300px;\n    width: 300px;\n    top: auto;\n    bottom: -210px;\n    right: auto;\n    left: -160px;\n    opacity: 0.1;\n  }\n\n  .title {\n    text-transform: uppercase;\n    margin-bottom: 20px;\n  }\n\n  .price-value {\n    color: $white;\n    background-color: var(--theme-default);\n    width: 130px;\n    height: 130px;\n    padding: 45px 0 0;\n    margin: 0 auto 25px;\n    border-radius: 50%;\n    .duration {\n      margin: 0 0 0 -5px;\n    }\n    .amount {\n      font-size: 58px;\n      font-weight: 700;\n      line-height: 45px;\n      display: inline-block;\n    }\n\n    .currency {\n      vertical-align: top;\n    }\n  }\n\n  .pricing-content {\n    margin: 0 0 25px;\n    display: inline-block;\n    li {\n      font-weight: 500;\n      text-align: left;\n      margin: 0 0 20px;\n      position: relative;\n      padding-left: 30px;\n\n      &:last-child {\n        margin: 0;\n      }\n\n      &:before {\n        content: \"\\f00c\";\n        color: var(--theme-default);\n        font-family: FontAwesome;\n        text-align: center;\n        width: 20px;\n        height: 20px;\n        border-radius: 50%;\n        position: absolute;\n        top: 1px;\n        left: 0;\n      }\n    }\n  }\n}\n\n@media (max-width: 1470px) {\n  .pricing-block {\n    > div {\n      flex: 50%;\n      &:nth-child(n + 3) {\n        margin-top: 30px;\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 991px) {\n  .pricing-simple {\n    .card-body {\n      h1 {\n        margin-bottom: 20px;\n      }\n      h3 {\n        margin-bottom: 28px;\n      }\n    }\n  }\n\n  .pricing-block {\n    > div {\n      &:nth-child(n + 2) {\n        margin-top: 20px;\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  .pricing-simple {\n    .card-body {\n      h1 {\n        margin-bottom: 15px;\n      }\n    }\n  }\n  .pricing-block {\n    > div {\n      flex: 100%;\n    }\n  }\n\n  .pricingtable {\n    padding-top: 30px;\n    padding-bottom: 30px;\n  }\n}\n\n/**=====================\n    34. Pricing CSS Ends\n==========================**/\n","/**=====================\n     23. Progress CSS Start\n==========================**/\n.progress-showcase{\n\t.progress{\n\t\tmargin-bottom: 10px;\n\t\t&:last-child{\n\t\t\tmargin-bottom: 0;\n\t\t}\n    }\n}\n.sm-progress-bar{\n\theight:5px;\n}\n.lg-progress-bar{\n\theight:20px;\n}\n/**=====================\n     23. Progress CSS Ends\n==========================**/\n",".project-list {\n\t.row {\n\t\tmargin: 15px;\n\t}\n\tbutton:focus {\n\t\toutline: none !important;\n\t}\n\t.theme-form .form-group {\n\t\tmargin-bottom: 15px;\n\t}\n\n\t.border-tab.nav-tabs {\n\t\t.nav-item .nav-link {\n\t\t\tborder: 1px solid transparent;\n\t\t\tpadding: 5px 30px 5px 0;\n\t\t\tborder-radius: 5px;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t}\n\t}\n\t.btn {\n\t\tmargin-right: 5px;\n\t\tvertical-align: -12px;\n\t\tfloat:right;\n\t\t[dir=\"rtl\"] & {\n\t\t\tfloat:left;\n\t\t}\n\t\tsvg {\n\t\t\tvertical-align: middle;\n\t\t\theight: 16px;\n\t\t}\n\t}\n\n\tul {\n\t\tmargin-bottom: 0 !important;\n\t\tborder-bottom: 0;\n\n\t\tli {\n\t\t\tsvg {\n\t\t\t\theight: 18px;\n\t\t\t\tvertical-align: middle;\n\t\t\t\tmargin-right: 5px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.tab-content {\n\t.row {\n\t\t>div.col-xl-4 {\n\n\t\t\t$show-numbers: true;\n\n\t\t\t@if $show-numbers {\n\t\t\t\t@for $i from 1 through 15 {\n\t\t\t\t\t&:nth-child(#{$i}) {\n\t\t\t\t\t\tanimation-fill-mode: both;\n\t\t\t\t\t\tanimation: fadeIncustom .5s linear #{$i}00000ms;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.project-cards {\n\t.tab-content {\n\t\tmargin-bottom: -30px;\n\t}\n}\n.project-box {\n\tborder: 1px solid $light-semi-gray;\n\tborder-radius: 5px;\n\tpadding: 30px;\n\tbackground-color: lighten($light, 2%);\n\tmargin-bottom: 30px;\n\n\th6 {\n\t\tfont-weight: 500 !important;\n\t}\n\n\t.badge {\n\t\tposition: absolute;\n\t\tright: 30px;\n\t\ttop: 15px;\n\t}\n\n\t.project-status {\n\t\tp {\n\t\t\tmargin-bottom: 5px;\n\t\t\tfont-weight: 800;\n\t\t}\n\t}\n\n\t.media {\n\t\tmargin-bottom: 15px;\n\n\t\t.media-body {\n\t\t\topacity: 0.5;\n\t\t}\n\t}\n\n\t.details {\n\t\tdiv {\n\t\t\tmargin-bottom: 5px;\n\t\t\topacity: 0.7;\n\t\t}\n\t}\n}\n\n.projectdetails {\n\t.card {\n\t\t.card-body {\n\t\t\tpadding: 20px;\n\t\t}\n\n\t\t.card-footer {\n\t\t\tpadding: 20px;\n\t\t}\n\n\t\tselect {\n\t\t\twidth: 90px;\n\t\t\theight: 28px;\n\t\t\tfont-size: 11px;\n\t\t\tright: 20px;\n\t\t\ttop: 20px;\n\t\t}\n\t}\n}\n\n.projectmore {\n\t.details {\n\t\t.col-4 {\n\t\t\tmargin-bottom: 5px;\n\n\t\t\t&:nth-child(even) {\n\t\t\t\topacity: 0.5;\n\t\t\t}\n\t\t}\n\t}\n\n\th5 {\n\t\tfont-size: 20px;\n\t\tfont-weight: 600;\n\t}\n\n\t.task-list {\n\t\tposition: relative;\n\n\t\tul {\n\t\t\tli {\n\t\t\t\tmargin-bottom: 5px\n\t\t\t}\n\n\t\t\t&+ul {\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: 50%;\n\t\t\t\ttop: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.new-users {\n\t&.activity {\n\t\t.gradient-round {\n\t\t\tpadding: 13px;\n\t\t\tfont-size: 20px;\n\t\t\tline-height: 1.4;\n\t\t\ttext-align: center;\n\t\t\ttop: unset !important;\n\n\t\t\t&::after {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n}\n","/**=====================\n     79. social app css start\n==========================**/\n.user-profile {\n  .hovercard {\n    .socialheader {\n      background: url(../../images/social-app/social-image.png);\n    }\n\n    .user-image {\n      .share-icons {\n        position: absolute;\n        right: 100px;\n        top: -27px;\n\n        li {\n          display: inline-block;\n          margin-right: 10px;\n\n          .social-icon {\n            width: 50px;\n            height: 50px;\n            text-align: center;\n            display: flex;\n            align-items: center;\n            vertical-align: middle;\n            justify-content: center;\n            border-radius: 100%;\n\n            i {\n              color: $white;\n              font-size: 25px;\n            }\n          }\n\n          &:last-child {\n            margin-right: 0;\n          }\n        }\n      }\n    }\n  }\n  .card-footer {\n    > div {\n      h3 {\n        font-size: 16px;\n      }\n    }\n  }\n}\n\n.market-tabs {\n  .border-tab.nav-tabs .nav-item .nav-link.active {\n    border-bottom: none !important;\n  }\n\n  .nav {\n    flex-wrap: nowrap;\n    align-items: center;\n    justify-content: center;\n\n    .nav-item {\n      width: 100%;\n\n      .nav-link {\n        height: 81px;\n        border-top-left-radius: 0;\n        border-top-right-radius: 0;\n        padding-top: 30px;\n        text-align: center;\n      }\n    }\n  }\n}\n\n.tabs-scoial {\n  border-bottom: none;\n  margin-bottom: 20px !important;\n  margin-top: 20px;\n\n  li {\n    a {\n      font-weight: 600;\n\n      svg {\n        circle {\n          color: $light-text;\n        }\n      }\n    }\n  }\n}\n\n.social-network {\n  span {\n    margin-bottom: 30px;\n    display: block;\n  }\n}\n\n.social-list {\n  .media {\n    margin-bottom: 20px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    .media-body {\n      a {\n        color: $light-text;\n      }\n\n      span {\n        font-weight: 600;\n      }\n\n      &:hover {\n        a {\n          color: var(--theme-default);\n        }\n      }\n    }\n  }\n}\n\n.photos {\n  margin-bottom: -15px;\n\n  ul {\n    li {\n      display: inline-block;\n      margin-right: 10px;\n      margin-bottom: 10px;\n      width: 70px;\n\n      &:nth-child(4n) {\n        margin-right: 0;\n      }\n    }\n  }\n}\n\n.new-users-social {\n  margin-bottom: 30px;\n  svg {\n    cursor: pointer;\n  }\n  .media {\n    img {\n      width: 58px;\n    }\n\n    .media-body {\n      margin-top: 10px;\n    }\n  }\n\n  svg {\n    circle {\n      color: $light-text;\n    }\n  }\n}\n\n.like-content {\n  span {\n    i {\n      font-size: 14px;\n    }\n  }\n}\n\n.timeline-content {\n  p {\n    margin-top: 30px;\n    color: $light-text;\n  }\n\n  .comment-number {\n    i {\n      color: $light-text;\n      margin-right: 20px;\n    }\n  }\n\n  .comments-box {\n    margin-top: 30px;\n\n    .input-group {\n      margin-top: 6px;\n\n      .input-txt-bx {\n        border: none;\n\n        &::placeholder {\n          color: $light-text;\n        }\n      }\n\n      .input-group-append {\n        .btn {\n          i {\n            font-size: 20px;\n            display: flex;\n            color: $light-text;\n          }\n        }\n      }\n    }\n  }\n}\n\n.social-chat {\n  margin-top: 30px;\n\n  span {\n    span {\n      font-weight: normal;\n      color: $light-text;\n      font-size: 12px;\n    }\n  }\n\n  .media-body {\n    padding: 30px;\n    border: 1px solid $light-color;\n    position: relative;\n\n    p {\n      margin-top: 5px;\n    }\n\n    &:before {\n      content: \"\";\n      position: absolute;\n      top: 19px;\n      right: 100%;\n      border: 7px solid transparent;\n      border-right: 7px solid $semi-dark;\n    }\n\n    &:after {\n      content: \"\";\n      position: absolute;\n      top: 19px;\n      right: 100%;\n      border: 7px solid transparent;\n      border-right: 7px solid $white;\n    }\n  }\n\n  .your-msg,\n  .other-msg {\n    margin-bottom: 30px;\n  }\n\n  .other-msg {\n    margin-left: 40px;\n  }\n}\n\n.socialprofile {\n  span {\n    color: $light-text;\n  }\n\n  .social-btngroup {\n    margin: 30px 0;\n  }\n\n  .likes-profile {\n    h5 {\n      span {\n        color: $theme-body-font-color;\n      }\n    }\n  }\n\n  .social-group {\n    margin-top: 30px;\n\n    ul {\n      li {\n        &:nth-child(4) {\n          margin-left: -22px;\n        }\n      }\n    }\n  }\n}\n\n.social-status {\n  form {\n    .form-group {\n      .form-control-social {\n        border: 1px solid $light-color;\n        padding-left: 15px;\n        margin-bottom: 30px;\n      }\n    }\n  }\n\n  .media {\n    position: relative;\n    margin-bottom: 30px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    .social-status {\n      content: \"\";\n      position: absolute;\n      width: 12px;\n      height: 12px;\n      background-color: #fff;\n      bottom: 0;\n      left: 35px;\n      border-radius: 100%;\n    }\n\n    .social-online {\n      border: 3px solid $success-color;\n    }\n\n    .social-busy {\n      border: 3px solid $warning-color;\n    }\n\n    .social-offline {\n      border: 3px solid $semi-dark;\n    }\n\n    .media-body {\n      p {\n        color: $light-text;\n        margin-bottom: 5px;\n      }\n\n      span {\n        + span {\n          color: $light-text;\n        }\n      }\n\n      .light-span {\n        color: $light-text;\n      }\n    }\n  }\n}\n\n.social-header {\n  h5 {\n    span {\n      &:first-child {\n        line-height: 1.48;\n      }\n\n      svg {\n        circle {\n          color: $light-text;\n        }\n      }\n    }\n  }\n}\n\n.details-about {\n  + .details-about {\n    margin-top: 30px;\n  }\n\n  .your-details {\n    p {\n      color: $light-text;\n    }\n  }\n}\n\n.avatar-showcase {\n  .friend-pic {\n    margin-right: 8px;\n    margin-bottom: 10px;\n  }\n\n  .pepole-knows {\n    ul {\n      li {\n        display: inline-block;\n        margin-right: 20px;\n        margin-bottom: 10px;\n\n        &:last-child {\n          margin-right: 0;\n        }\n\n        .add-friend {\n          h6 {\n            margin-top: 3px;\n          }\n        }\n      }\n    }\n  }\n}\n\n.activity-log {\n  .my-activity {\n    + .my-activity {\n      margin-top: 30px;\n    }\n\n    p {\n      margin-bottom: 5px;\n\n      span {\n        svg {\n          width: 15px;\n          height: 15px;\n        }\n      }\n    }\n  }\n}\n\n/**=====================\n     79. social app CSS end\n==========================**/\n","/**=====================\n     87. task app CSS Start\n==========================**/\n.modal-open {\n  .datepickers-container {\n    z-index: 1075;\n  }\n}\n.date-details {\n  align-items: center;\n  > div {\n    + div {\n      margin-left: 10px;\n    }\n  }\n}\n.taskadd {\n  table {\n    tr {\n      td {\n        border-top: none;\n        &:first-child {\n          padding-left: 30px;\n        }\n        &:last-child {\n          padding-right: 30px;\n        }\n        svg {\n          width: 18px;\n          height: 18px;\n          color: $semi-dark;\n        }\n      }\n      &:first-child {\n        td {\n          padding-top: 30px;\n        }\n      }\n      &:last-child {\n        td {\n          padding-bottom: 30px;\n        }\n      }\n    }\n  }\n}\n// responsive\n@media only screen and (max-width: 1660px) {\n  .taskadd {\n    table {\n      tr {\n        td {\n          &:first-child {\n            min-width: 160px;\n          }\n          &:nth-child(3) {\n            min-width: 70px;\n          }\n        }\n      }\n    }\n  }\n}\n@media only screen and (max-width: 991px) {\n  .date-details {\n    display: block ! important;\n    margin-bottom: -10px;\n    .d-inline-block {\n      margin-bottom: 10px;\n    }\n  }\n  .taskadd {\n    table {\n      tr {\n        td {\n          &:first-child {\n            padding-left: 20px;\n          }\n        }\n        &:first-child {\n          td {\n            padding-top: 20px;\n          }\n        }\n        &:last-child {\n          td {\n            padding-bottom: 20px;\n          }\n        }\n      }\n    }\n  }\n}\n@media only screen and (max-width: 767px) {\n  .taskadd {\n    table {\n      tr {\n        td {\n          &:nth-child(2) {\n            min-width: 745px;\n          }\n        }\n      }\n    }\n  }\n}\n@media only screen and (max-width: 575px) {\n  .taskadd {\n    table {\n      tr {\n        td {\n          &:first-child {\n            padding-left: 15px;\n          }\n        }\n        &:first-child {\n          td {\n            padding-top: 15px;\n          }\n        }\n        &:last-child {\n          td {\n            padding-bottom: 15px;\n          }\n        }\n      }\n    }\n  }\n}\n/**=====================\n   87. task app CSS Ends\n==========================**/\n","/**=====================\n     42. Timeline CSS Start\n==========================**/\n.activity {\n\t.media {\n\t\tmargin-bottom: 30px;\n\n\t\t&:last-child {\n\t\t\tmargin-bottom: 0;\n\t\t}\n\n\t\t.gradient-round {\n\t\t\tposition: relative;\n\t\t\twidth: 53px;\n\t\t\theight: 53px;\n\t\t\tbackground-image: $gradient-primary;\n\t\t\tborder-radius: 100%;\n\t\t\ttop: -18px;\n\n\t\t\tsvg {\n\t\t\t\tposition: absolute;\n\t\t\t\twidth: 18px;\n\t\t\t\theight: 18px;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\tleft: 0;\n\t\t\t\ttop: 18px;\n\t\t\t\tright: 0;\n\t\t\t\tmargin: 0 auto;\n\n\t\t\t\tpath,\n\t\t\t\tline,\n\t\t\t\tcircle {\n\t\t\t\t\tcolor: $white;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&.gradient-line-1 {\n\t\t\t\t&:after {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tcontent: '';\n\t\t\t\t\tbackground-color: #e9e9e9;\n\t\t\t\t\twidth: 2px;\n\t\t\t\t\theight: 62px;\n\t\t\t\t\tbottom: -77px;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\tright: 0;\n\t\t\t\t\tmargin: 0 auto;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&.small-line {\n\t\t\t\t&:after {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tcontent: '';\n\t\t\t\t\tbackground-color: #e9e9e9;\n\t\t\t\t\twidth: 2px;\n\t\t\t\t\theight: 19px;\n\t\t\t\t\tbottom: -34px;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\tright: 0;\n\t\t\t\t\tmargin: 0 auto;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&.medium-line {\n\t\t\t\t&:after {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tcontent: '';\n\t\t\t\t\tbackground-color: #e9e9e9;\n\t\t\t\t\twidth: 2px;\n\t\t\t\t\theight: 53px;\n\t\t\t\t\tbottom: -68px;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\tright: 0;\n\t\t\t\t\tmargin: 0 auto;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.media-body {\n\t\t\th6 {\n\t\t\t\tfont-weight: 600;\n\t\t\t\tmargin-bottom: 30px;\n\n\t\t\t\tspan {\n\t\t\t\t\tfont-weight: normal;\n\t\t\t\t\tcolor: $light-text;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tp {\n\t\t\t\twidth: 80%;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.timeline-small {\n\t.media {\n\t\tmargin-bottom: 30px;\n\n\t\t&:last-child {\n\t\t\tmargin-bottom: 0;\n\t\t}\n\n\t\t.timeline-round {\n\t\t\tposition: relative;\n\t\t\twidth: 53px;\n\t\t\theight: 53px;\n\t\t\tborder-radius: 100%;\n\t\t\tborder-radius: 15px;\n\t\t\ttop: -18px;\n\n\t\t\tsvg {\n\t\t\t\tposition: absolute;\n\t\t\t\twidth: 18px;\n\t\t\t\theight: 18px;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\tleft: 0;\n\t\t\t\ttop: 18px;\n\t\t\t\tright: 0;\n\t\t\t\tmargin: 0 auto;\n\n\t\t\t\tpath,\n\t\t\t\tline,\n\t\t\t\tcircle {\n\t\t\t\t\tcolor: $white;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&.timeline-line-1 {\n\t\t\t\t&:after {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tcontent: '';\n\t\t\t\t\tbackground-color: #e9e9e9;\n\t\t\t\t\twidth: 2px;\n\t\t\t\t\theight: 62px;\n\t\t\t\t\tbottom: -88px;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\tright: 0;\n\t\t\t\t\tmargin: 0 auto;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&.small-line {\n\t\t\t\t&:after {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tcontent: '';\n\t\t\t\t\tbackground-color: #e9e9e9;\n\t\t\t\t\twidth: 2px;\n\t\t\t\t\theight: 19px;\n\t\t\t\t\tbottom: -34px;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\tright: 0;\n\t\t\t\t\tmargin: 0 auto;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&.medium-line {\n\t\t\t\t&:after {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tcontent: '';\n\t\t\t\t\tbackground-color: #e9e9e9;\n\t\t\t\t\twidth: 2px;\n\t\t\t\t\theight: 53px;\n\t\t\t\t\tbottom: -68px;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\tright: 0;\n\t\t\t\t\tmargin: 0 auto;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.media-body {\n\t\t\th6 {\n\t\t\t\tmargin-bottom: 30px;\n\n\t\t\t\tspan {\n\t\t\t\t\tfont-weight: normal;\n\t\t\t\t\tcolor: $light-text;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tp {\n\t\t\t\twidth: 80%;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.cd-container {\n\twidth: 90%;\n\tmax-width: 1170px;\n\tmargin: 0 auto;\n}\n\n.cd-container::after {\n\tcontent: '';\n\tdisplay: table;\n\tclear: both;\n}\n\n@media only screen and (min-width: 1170px) {\n\n\t#cd-timeline::before {\n\t\tleft: 50% !important;\n\t\tmargin-left: -2px;\n\t}\n\n\t.cd-timeline-block {\n\t\tmargin: 4em 0;\n\n\t\t&:first-child {\n\t\t\tmargin-top: 0;\n\t\t}\n\n\t\t&:last-child {\n\t\t\tmargin-bottom: 0;\n\t\t}\n\n\t\t&:nth-child(even) {\n\t\t\t.cd-timeline-content {\n\t\t\t\tfloat: right;\n\n\t\t\t\t.cd-date {\n\t\t\t\t\tleft: auto;\n\t\t\t\t\tright: 122%;\n\t\t\t\t\ttext-align: right;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.cd-timeline-content::before {\n\t\t\t\ttop: 24px;\n\t\t\t\tleft: auto;\n\t\t\t\tright: 100%;\n\t\t\t\tborder-color: transparent;\n\t\t\t\tborder-right-color: $light-color;\n\t\t\t}\n\t\t}\n\t}\n\n\t.cd-timeline-img {\n\t\twidth: 60px;\n\t\theight: 60px;\n\t\tleft: 50%;\n\t\tmargin-left: -30px;\n\n\t\t>i {\n\t\t\tfont-size: 18px;\n\t\t\ttop: 50%;\n\t\t\tleft: 50%;\n\t\t\tpadding: 3px;\n\t\t}\n\t}\n\n\t.cssanimations {\n\t\t.cd-timeline-img {\n\t\t\t&.is-hidden {\n\t\t\t\tvisibility: hidden;\n\t\t\t}\n\n\t\t\t&.bounce-in {\n\t\t\t\tvisibility: visible;\n\t\t\t\tanimation: cd-bounce-1 0.6s;\n\t\t\t}\n\t\t}\n\n\t\t.cd-timeline-content {\n\t\t\t&.is-hidden {\n\t\t\t\tvisibility: hidden;\n\t\t\t}\n\n\t\t\t&.bounce-in {\n\t\t\t\tvisibility: visible;\n\t\t\t\tanimation: cd-bounce-2 0.6s;\n\t\t\t}\n\t\t}\n\n\t\t.cd-timeline-block:nth-child(even) .cd-timeline-content.bounce-in {\n\t\t\tanimation: cd-bounce-2-inverse 0.6s;\n\t\t}\n\t}\n\n\t.cd-timeline-content {\n\t\tmargin-left: 0;\n\t\tpadding: 1.6em;\n\t\twidth: 45%;\n\n\t\t.cd-date {\n\t\t\tposition: absolute;\n\t\t\twidth: 100%;\n\t\t\tleft: 122%;\n\t\t\ttop: 6px;\n\t\t\tfont-size: 16px;\n\t\t}\n\t}\n\n\t.cd-timeline-content::before {\n\t\ttop: 24px;\n\t\tleft: 100%;\n\t\tborder-color: transparent;\n\t\tborder-left-color: $white;\n\t}\n}\n\n#cd-timeline {\n\tposition: relative;\n\tpadding: 2em 0;\n}\n\n#cd-timeline::before {\n\tcontent: '';\n\tposition: absolute;\n\ttop: 0;\n\tfont-size: 1.5rem;\n\theight: 100%;\n\twidth: 2px;\n\tbackground: $light-color;\n\tleft: -15px;\n}\n\n.cd-timeline-block {\n\tposition: relative;\n\tmargin: 30px 0;\n\n\t&:after {\n\t\tcontent: \"\";\n\t\tdisplay: table;\n\t\tclear: both;\n\t}\n\n\t&:first-child {\n\t\tmargin-top: 0;\n\t}\n\n\t&:last-child {\n\t\tmargin-bottom: 0;\n\t}\n}\n\n.cd-timeline-img {\n\twidth: 60px;\n\theight: 60px;\n\tleft: 50%;\n\tmargin-left: -30px;\n\t-webkit-transform: translateZ(0);\n\t-webkit-backface-visibility: hidden;\n\tposition: absolute;\n\ttop: 0;\n\tborder-radius: 4px;\n\n\ti {\n\t\tdisplay: block;\n\t\tposition: relative;\n\t\tleft: 45%;\n\t\ttop: 44%;\n\t\tmargin-left: -12px;\n\t\tmargin-top: -12px;\n\t\tfont-size: 27px;\n\t\tcolor: $white;\n\t}\n}\n\n@-webkit-keyframes cd-bounce-1 {\n\t0% {\n\t\topacity: 0;\n\t}\n\n\t60% {\n\t\topacity: 1;\n\t}\n}\n\n@-moz-keyframes cd-bounce-1 {\n\t0% {\n\t\topacity: 0;\n\t}\n\n\t60% {\n\t\topacity: 1;\n\t}\n}\n\n@keyframes cd-bounce-1 {\n\t0% {\n\t\topacity: 0;\n\t\ttransform: scale(0.5);\n\t}\n\n\t60% {\n\t\topacity: 1;\n\t\ttransform: scale(1.2);\n\t}\n\n\t100% {\n\t\ttransform: scale(1);\n\t}\n}\n\n.cd-timeline-content {\n\tposition: relative;\n\tbackground: $light;\n\tborder-radius: 4px;\n\tpadding: 30px;\n\tbox-shadow: 1px 1px 2px 1px rgba(0, 0, 0, 0.08);\n\n\tp {\n\t\tpadding-top: 9px;\n\t}\n\n\th4 {\n\t\tmargin-bottom: 0;\n\t}\n\n\t&:after {\n\t\tcontent: \"\";\n\t\tdisplay: table;\n\t\tclear: both;\n\t}\n\n\taudio {\n\t\twidth: 100%;\n\t}\n\n\t.cd-date {\n\t\tfont-size: 13px;\n\t\tdisplay: inline-block;\n\t\tfloat: left;\n\t\tpadding: .8em 0 0;\n\t\topacity: .7;\n\t}\n}\n\n.cd-timeline-content::before {\n\tcontent: '';\n\tposition: absolute;\n\ttop: 16px;\n\tright: 100%;\n\theight: 0;\n\twidth: 0;\n\tborder: 7px solid transparent;\n\tborder-left: 7px solid $light-color;\n}\n\n@media only screen and (min-width: 768px) {\n\t.cd-timeline-content {\n\t\t.cd-date {\n\t\t\tfont-size: 14px;\n\t\t\tpadding-bottom: 0;\n\t\t}\n\t}\n}\n\n@-webkit-keyframes cd-bounce-2 {\n\t0% {\n\t\topacity: 0;\n\t}\n\n\t60% {\n\t\topacity: 1;\n\t}\n}\n\n@-moz-keyframes cd-bounce-2 {\n\t0% {\n\t\topacity: 0;\n\t}\n\n\t60% {\n\t\topacity: 1;\n\t}\n\n\t100% {}\n}\n\n@keyframes cd-bounce-2 {\n\t0% {\n\t\topacity: 0;\n\t\ttransform: translateX(-100px);\n\t}\n\n\t60% {\n\t\topacity: 1;\n\t\ttransform: translateX(20px);\n\t}\n\n\t100% {\n\t\ttransform: translateX(0);\n\t}\n}\n\n@-webkit-keyframes cd-bounce-2-inverse {\n\t0% {\n\t\topacity: 0;\n\t}\n\n\t60% {\n\t\topacity: 1;\n\t}\n}\n\n@-moz-keyframes cd-bounce-2-inverse {\n\t0% {\n\t\topacity: 0;\n\t}\n\n\t60% {\n\t\topacity: 1;\n\t}\n\n\t100% {}\n}\n\n@keyframes cd-bounce-2-inverse {\n\t0% {\n\t\topacity: 0;\n\t\ttransform: translateX(100px);\n\t}\n\n\t60% {\n\t\topacity: 1;\n\t\ttransform: translateX(-20px);\n\t}\n\n\t100% {\n\t\ttransform: translateX(0);\n\t}\n}\n\n@media only screen and (max-width: 1169px) {\n\t.cd-timeline-block {\n\t\t.cd-timeline-img {\n\t\t\tleft: -2px;\n\t\t\theight: 30px;\n\t\t\twidth: 30px;\n\t\t\tmargin-left: -30px;\n\t\t\ttop: 14px;\n\t\t\tz-index: 7;\n\n\t\t\t>i {\n\t\t\t\tfont-size: 15px;\n\t\t\t\ttop: 16px;\n\t\t\t\tleft: 17px;\n\t\t\t\tpadding: 3px;\n\t\t\t}\n\t\t}\n\t}\n\n\t.landing-main {\n\t\t#cd-timeline::before {\n\t\t\tleft: -39px;\n\t\t}\n\n\t\t.cd-timeline-block {\n\t\t\t.cd-timeline-img {\n\t\t\t\tleft: -34px;\n\t\t\t\theight: 50px;\n\t\t\t\twidth: 50px;\n\t\t\t\ttop: 1px;\n\t\t\t\tz-index: 8;\n\n\t\t\t\t>i {\n\t\t\t\t\tfont-size: 23px;\n\t\t\t\t\ttop: 21px;\n\t\t\t\t\tleft: 7px;\n\t\t\t\t\tpadding: 3px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n@media only screen and (max-width: 576px) {\n\t.cd-timeline-content {\n\t\tpadding: 15px;\n\n\t\th4 {\n\t\t\tfont-size: 18px;\n\t\t}\n\t}\n}\n\n/**=====================\n     42. Timeline  CSS Ends\n==========================**/","/**=====================\n    43. Timeline 2 CSS Start\n==========================**/\n$timeliny_classname: \"timeliny\";\n$timeliny_dots-radius: 0.6rem;\n$timeliny_global-width: 100%;\n$timeliny_max-inner-width: 1024px;\n$timeliny_spacings: 5rem;\n$timeliny_transition-time: 0.35s;\n$timeliny_vertical-line-pos: 32%;\n$timeliny_small-breakdown: 768px;\n\n.#{$timeliny_classname} {\n  position: relative;\n  display: block;\n  padding: $timeliny_spacings * 2 0;\n  width: $timeliny_global-width;\n  border-top: 1px solid lighten($light-color, 3%);\n  border-bottom: 1px solid lighten($light-color, 3%);\n  text-rendering: optimizeLegibility;\n  color: $light-color;\n  opacity: 0;\n  overflow: hidden;\n  cursor: move;\n  &.loaded {\n    opacity: 1;\n  }\n  &::before {\n    content: \"\";\n    position: absolute;\n    background-color: $dark-gray;\n    width: 100%;\n    height: 1px;\n    top: 50%;\n    left: 0;\n  }\n  .#{$timeliny_classname}-wrapper {\n    display: block;\n    margin: auto;\n    width: 100%;\n    max-width: $timeliny_max-inner-width;\n  }\n  .#{$timeliny_classname}-dot {\n    -webkit-transition: all $timeliny_transition-time ease-in-out;\n    -moz-transition: all $timeliny_transition-time ease-in-out;\n    transition: all $timeliny_transition-time ease-in-out;\n    display: block;\n    position: absolute;\n    top: 50%;\n    left: 0;\n    margin-top: -$timeliny_dots-radius;\n    width: $timeliny_dots-radius * 2;\n    height: $timeliny_dots-radius * 2;\n    border-radius: 50%;\n    border: 1px solid $dark-gray;\n    background-color: $white;\n    &::before {\n      -webkit-transition: all $timeliny_transition-time ease-in-out;\n      -moz-transition: all $timeliny_transition-time ease-in-out;\n      transition: all $timeliny_transition-time ease-in-out;\n      content: attr(data-year);\n      display: block;\n      position: absolute;\n      top: -$timeliny_spacings;\n      left: calc($timeliny_spacings / 4);\n      color: $dark-color;\n      font-family: $font-rubik, $font-serif;\n      font-size: 22px;\n    }\n    &::after {\n      -webkit-transition: all $timeliny_transition-time ease-in-out;\n      -moz-transition: all $timeliny_transition-time ease-in-out;\n      transition: all $timeliny_transition-time ease-in-out;\n      -ms-transform: translateY(-50%);\n      -webkit-transform: translateY(-50%);\n      transform: translateY(-50%);\n      content: attr(data-text);\n      display: block;\n      position: absolute;\n      width: calc($timeliny_max-inner-width / 4);\n      top: $timeliny_spacings + $timeliny_dots-radius;\n      left: calc($timeliny_spacings / 4);\n      color: $light-color;\n      opacity: 0;\n      font-size: 0.9em;\n      @media (min-width: $timeliny_small-breakdown) {\n        width: calc($timeliny_max-inner-width / 3);\n      }\n    }\n  }\n  .#{$timeliny_classname}-timeline {\n    position: absolute;\n    top: 50%;\n    left: 0;\n    display: table;\n    width: 100%;\n    z-index: 5;\n    .#{$timeliny_classname}-timeblock {\n      display: table-cell;\n      position: relative;\n      &.active {\n        .#{$timeliny_classname}-dot {\n          border-color: var(--theme-default);\n          background-color: var(--theme-default);\n          box-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.33);\n          &::before {\n            color: $dark-color;\n          }\n          &::after {\n            color: $dark-color;\n            opacity: 1;\n            background-color: lighten($primary-color, 38%);\n            border: 1px solid $light-semi-gray;\n            padding: 10px;\n            border-radius: 5px;\n          }\n        }\n      }\n\n      &.inactive {\n        .#{$timeliny_classname}-dot {\n          cursor: move;\n\n          &::before {\n            color: $light-color;\n          }\n        }\n      }\n\n      &:not(.inactive):not(.active) {\n        .#{$timeliny_classname}-dot:hover {\n          border-color: $dark-color;\n          background-color: $dark-color;\n          &::before {\n            color: $dark-color;\n          }\n        }\n      }\n\n      .#{$timeliny_classname}-dot:hover {\n        &::after {\n          color: $dark-color;\n          opacity: 1;\n          background-color: $white;\n          border: 1px solid $light-semi-gray;\n          padding: 10px;\n          border-radius: 5px;\n        }\n      }\n    }\n  }\n\n  .#{$timeliny_classname}-vertical-line {\n    position: absolute;\n    display: block;\n    z-index: 1;\n    left: calc($timeliny_vertical-line-pos / 2);\n    top: 0;\n    width: 1px;\n    height: 100%;\n    background-color: var(--theme-default);\n\n    @media (min-width: $timeliny_small-breakdown) {\n      left: $timeliny_vertical-line-pos;\n    }\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 0;\n      left: -7px;\n      width: 0;\n      height: 0;\n      border-left: 8px solid transparent;\n      border-right: 8px solid transparent;\n      border-top: 8px solid var(--theme-default);\n    }\n    &::after {\n      content: \"\";\n      position: absolute;\n      bottom: 0;\n      left: -7px;\n      width: 0;\n      height: 0;\n      border-left: 8px solid transparent;\n      border-right: 8px solid transparent;\n      border-bottom: 8px solid var(--theme-default);\n    }\n  }\n}\n/**=====================\n     43. Timeline 2 CSS Ends\n==========================**/\n","/**=====================\n     22. User profile css start\n==========================**/\n.user-profile {\n  .ttl-info {\n    h6 {\n      font-size: 12px;\n      color: $semi-dark;\n    }\n  }\n  .border-right {\n    border-right: 1px solid $light-color;\n  }\n  hr {\n    margin: 30px 0;\n  }\n  .hovercard {\n    .cardheader {\n      background: url(../../images/other-images/bg-profile.png);\n      background-size: cover;\n      background-position: 10%;\n      height: 470px;\n    }\n    .user-image {\n      position: relative;\n      height: 0;\n      .avatar {\n        margin-top: -80px;\n        img {\n          width: 100px;\n          height: 100px;\n          max-width: 155px;\n          max-height: 155px;\n          border-radius: 50%;\n          border: 7px solid $white;\n        }\n      }\n      .icon-wrapper {\n        position: absolute;\n        bottom: -20px;\n        left: 51%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        height: 40px;\n        width: 40px;\n        border-radius: 50%;\n        background-color: $white;\n        cursor: pointer;\n        overflow: hidden;\n        margin: 0 auto;\n        font-size: 17px;\n        box-shadow: 0 0 6px 3px rgba(68, 102, 242, 0.1);\n        .upload {\n          position: absolute;\n          left: 0;\n          right: 0;\n          opacity: 0;\n        }\n      }\n    }\n    .info {\n      padding: 30px;\n      .title {\n        margin-bottom: 4px;\n        font-size: 24px;\n        line-height: 1;\n        color: $dark-color;\n        vertical-align: middle;\n        a {\n          color: $theme-font-color;\n          font-size: 20px;\n          text-transform: uppercase;\n          font-weight: 500;\n        }\n      }\n      .desc {\n        overflow: hidden;\n        font-size: 14px;\n        line-height: 20px;\n        color: $semi-dark;\n        text-overflow: ellipsis;\n        text-transform: uppercase;\n      }\n    }\n  }\n  .follow {\n    margin-top: 20px;\n    .follow-num {\n      font-size: 20px;\n      color: $theme-font-color;\n      font-family: $font-rubik, $font-serif;\n      font-weight: 500;\n    }\n    span {\n      color: $semi-dark;\n    }\n  }\n  .profile-img-style {\n    padding: 30px;\n    .img-container {\n      margin-top: 30px;\n    }\n    .user-name {\n      font-size: 14px;\n      color: $theme-font-color;\n      margin: 0;\n      font-weight: 600;\n    }\n    p {\n      line-height: 30px;\n      font-size: 14px;\n      color: $dark-gray;\n      margin-bottom: 0;\n    }\n    .media {\n      img {\n        width: 50px;\n      }\n    }\n  }\n  .like-comment {\n    a {\n      color: $dark-gray;\n      &:hover {\n        color: $danger-color;\n      }\n    }\n    span {\n      font-family: $font-rubik, $font-serif;\n    }\n  }\n  .social-media {\n    a {\n      padding: 0 15px;\n      color: $semi-dark;\n      font-size: 24px;\n      cursor: pointer;\n      &:hover {\n        color: var(--theme-default);\n      }\n    }\n  }\n}\n\n//Edit profile //\n.edit-profile {\n  .profile-title {\n    .media {\n      align-items: center;\n      margin-bottom: 30px;\n      .media-body {\n        margin-left: 14px;\n        a {\n          color: $theme-body-font-color;\n        }\n        [dir=\"rtl\"] & {\n          margin-left: unset;\n          margin-right: 14px;\n        }\n      }\n    }\n  }\n}\n\n/**=====================\n     22. User profile css Ends\n==========================**/\n","/**=====================\n    83. Wishlist CSS start\n==========================**/\n.wishlist{\n\ttable{\n\t\ttr{\n\t\t\ttd{\n\t\t\t\tsvg{\n\t\t\t\t\tcolor: $dark-gray;\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t\n\t}\n}\n/**=====================\n    83. Wishlist CSS Ends\n==========================**/\n","/**=====================\n     47. Footer CSS Start\n==========================**/\n.footer{\n  background-color: $footer_bg_color;\n  box-shadow: $footer_box_shadow;\n  padding: 15px;\n  bottom: 0;\n  left: 0;\n  margin-left: $sidebar-compact-width;\n  transition: 0.5s;  \n  &.footer-dark{\n    background-color: $footer_dark_color;\n    p{\n      color: $white;\n    }\n  }\n}\n.footer-fix{\n  width: calc(100% - $sidebar-compact-width);\n  position: fixed;\n}\n/**=====================\n     47. Footer CSS Ends\n==========================**/\n","/**=====================\n      08. GRID CSS Start\n==========================**/\n.grid-showcase {\n  margin-bottom: -10px;\n\n  span {\n    display: block;\n    border: 1px solid $light-color;\n    padding: 10px;\n    margin-bottom: 10px;\n    text-align: center;\n    background-color: $white;\n  }\n}\n\n.grid-align {\n  margin-bottom: -30px;\n\n  .row {\n    padding: 15px 0;\n    min-height: 10rem;\n    border: 1px solid rgba($primary-color, 0.02);\n    margin-bottom: 30px;\n    background-color: rgba($primary-color, 0.02);\n  }\n}\n\n/**=====================\n      08. GRID CSS Ends\n==========================**/","/*======= Page Header css Start ======= */\n.left-header {\n  .d-flex {\n    align-items: center;\n    [dir=\"rtl\"] & {\n      justify-content: flex-end;\n    }\n  }\n  h6 {\n    line-height: 1.6;\n    @media (max-width: 1199px) {\n      width: 160px;\n      overflow: hidden;\n      -webkit-line-clamp: 1;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n    @media (max-width: 991px) {\n      width: 120px;\n    }\n    @media (max-width: 767px) {\n      width: 66px;\n    }\n  }\n  @media (max-width: 755px) {\n    display: none;\n  }\n  img {\n    margin-top: -12px;\n    height: 26px;\n  }\n  i {\n    font-weight: 600;\n    font-size: 12px;\n    margin-bottom: -4px;\n  }\n}\n/*======= Page Header css ends  ======= */\n\n/**======Main Header css Start ======**/\n.offcanvas,\n.offcanvas-bookmark {\n  .page-wrapper {\n    .page-body-wrapper {\n      .page-body {\n        position: relative;\n        filter: blur(5px) grayscale(100%);\n      }\n    }\n  }\n}\n.offcanvas {\n  position: unset;\n  visibility: visible;\n  background: unset;\n  z-index: 2;\n}\n\n.toggle-sidebar {\n  position: absolute;\n  right: 30px;\n  top: 30px;\n  cursor: pointer;\n\n  svg {\n    width: $header-wrapper-nav-icon-size;\n    height: $header-wrapper-nav-icon-size;\n  }\n\n  &:before {\n    content: \"\";\n    position: absolute;\n    height: 40px;\n    width: 40px;\n    background-color: rgba($primary-color, 0.1);\n    border-radius: 100%;\n    left: -11px;\n    z-index: -2;\n    top: -8px;\n    transform: scale(0);\n    transition: all 0.3s ease;\n  }\n\n  &:hover {\n    &:before {\n      height: 40px;\n      width: 40px;\n      transform: scale(1);\n      transition: all 0.3s ease;\n    }\n\n    > svg {\n      color: var(--theme-default) !important;\n      stroke: var(--theme-default) !important;\n    }\n  }\n}\n\n.onhover-dropdown {\n  cursor: pointer;\n  position: relative;\n\n  &:hover {\n    .onhover-show-div {\n      @extend %for-animated-hover-box;\n    }\n  }\n}\n\n.onhover-show-div {\n  top: 80px;\n  position: absolute;\n  z-index: 8;\n  background-color: $white;\n  transition: all linear 0.3s;\n  @extend %for-animated-hover;\n\n  li {\n    a {\n      svg {\n        margin-top: 0 !important;\n\n        path,\n        line {\n          color: $theme-body-font-color !important;\n        }\n      }\n    }\n  }\n}\n\n/**======Main Header css Ends ======**/\n\n/*=======Mega menu css start=======*/\n.mega-menu {\n  .default-according {\n    .card {\n      .btn-link {\n        font-weight: 500;\n        color: gray;\n      }\n\n      .card-body {\n        font-size: 12px;\n      }\n    }\n  }\n\n  .onhover-show-div {\n    width: 1500px;\n  }\n\n  .card-body {\n    padding: 20px;\n  }\n\n  div {\n    > div {\n      a {\n        margin-bottom: 0px;\n        display: inline-block;\n        color: $theme-body-sub-title-color;\n      }\n    }\n  }\n\n  .list-unstyled {\n    div {\n      a {\n        padding: 8px 35px 8px 0;\n        transition: $sidebar-transition;\n\n        &:hover {\n          padding: 8px 35px 8px 10px;\n          transition: $sidebar-transition;\n        }\n      }\n    }\n  }\n}\n\n/*=======Mega menu css end=======*/\n\n/**=====================\n    05. Header CSS Ends\n==========================**/\n","/**=====================\n     36. NAV CSS Start\n==========================**/\n#accordionoc {\n  #collapseicon,\n  #collapseicon1 {\n    padding-top: 0px;\n  }\n  li {\n    button {\n      display: flex;\n      align-items: center;\n    }\n  }\n}\n.navs-icon.default-according.style-1 {\n  li {\n    button {\n      position: relative;\n      &:hover {\n        color: var(--theme-default) !important;\n      }\n    }\n    button[aria-expanded=\"true\"] {\n      &:before {\n        right: 2px;\n        top: 6px;\n      }\n    }\n    button[aria-expanded=\"false\"]:before {\n      right: 2px;\n      top: 6px;\n    }\n  }\n}\n.navs-icon {\n  padding: 30px;\n  li {\n    padding: 9px 0;\n    a {\n      color: $theme-body-font-color;\n      &:hover {\n        color: var(--theme-default);\n      }\n    }\n    ul {\n      padding-top: 9px;\n    }\n  }\n}\n.onhover-dropdown {\n  &.navs-dropdown {\n    &:hover {\n      .onhover-show-div {\n        &:before,\n        &:after {\n          right: 77px;\n          left: unset;\n        }\n      }\n    }\n  }\n}\n.icon-lists {\n  font-family: $font-rubik, $font-serif;\n}\n.pl-navs-inline {\n  padding-left: 30px !important;\n}\n.inline-nav {\n  li {\n    line-height: 1.3;\n  }\n}\n/**=====================\n     36. NAV CSS Ends\n==========================**/\n","/**=====================\n     51. Search CSS Start\n==========================**/\n.search-page {\n  .theme-form {\n    input {\n      border: 1px solid var(--theme-default);\n      padding-left: 20px;\n      border-radius: 10px 0 0 10px;\n      flex: 1 1 auto;\n      &::placeholder {\n        color: $primary-color;\n      }\n      &:focus {\n        outline: none;\n      }\n    }\n    .input-group {\n      .btn {\n        line-height: 32px;\n        font-size: 16px;\n      }\n      .form-control-plaintext {\n        background: transparent;\n      }\n    }\n  }\n\n  h6 {\n    line-height: 1.4;\n  }\n\n  .nav-link {\n    font-weight: 500;\n    text-transform: uppercase;\n  }\n\n  .border-tab {\n    &.nav-tabs {\n      .material-border {\n        border-bottom-width: 1px;\n      }\n\n      .nav-item {\n        .nav-link {\n          font-size: 15px;\n          padding: 10px 18px;\n        }\n      }\n    }\n  }\n\n  .media {\n    .media-body {\n      overflow: hidden;\n    }\n  }\n\n  .info-block {\n    padding: 30px;\n    border-radius: 15px;\n    border: 1px solid $light-color;\n\n    a {\n      color: #656565;\n      margin-bottom: 3px;\n      display: block;\n    }\n\n    h6 {\n      color: $primary-color;\n    }\n\n    + .info-block {\n      margin-top: 20px;\n    }\n  }\n\n  .border-tab.nav-tabs {\n    align-items: left;\n    justify-content: flex-end;\n\n    .nav-item {\n      width: auto;\n    }\n  }\n\n  .search-links {\n    h6 {\n      margin-bottom: 10px;\n    }\n  }\n\n  p {\n    text-transform: lowercase;\n    margin-bottom: 0;\n    color: #a5a2a2;\n  }\n\n  ul.search-info {\n    li {\n      display: inline-block;\n      font-size: 12px;\n      line-height: 1;\n      color: #586082;\n\n      + li {\n        border-left: 1px solid lighten($dark-color, 50%);\n        padding-left: 8px;\n        margin-left: 8px;\n      }\n\n      i {\n        color: $warning-color;\n        &:not(:last-child) {\n          margin-right: 4px;\n        }\n      }\n    }\n  }\n\n  #video-links {\n    .embed-responsive + .embed-responsive {\n      margin-top: 30px;\n    }\n  }\n}\n\n.search-list {\n  margin-bottom: 30px;\n  width: auto;\n  display: inline-flex;\n  border-radius: 10px;\n  overflow: hidden;\n  border: 1px solid $primary-color;\n  border: none;\n\n  .nav-item {\n    background-color: rgba($primary-color, 0.1);\n\n    .nav-link {\n      border: none;\n      padding: 0.7rem 1.5rem;\n      opacity: 0.5;\n\n      &.active {\n        background-color: rgba($primary-color, 0.1);\n        color: var(--theme-default);\n        opacity: 1;\n      }\n    }\n\n    &.show,\n    &.active {\n      background-color: rgba($primary-color, 0.1);\n    }\n  }\n}\n\n/**=====================\n    51. Search CSS Ends\n==========================**/\n","/**=====================\n     21. Select 2 CSS Start\n==========================**/\n.select2 {\n  max-width: 100%;\n}\n\n.add-post {\n  #cke_text-box {\n    border: 1px solid $light-semi-gray;\n  }\n\n  form {\n    .m-checkbox-inline {\n      label {\n        margin-bottom: 0;\n      }\n    }\n\n    .form-control {\n      border: 1px solid $light-semi-gray;\n    }\n\n    .col-form-label {\n      padding-bottom: 0;\n      padding-top: 0;\n\n      .select2-container--default {\n        margin-top: 10px;\n        max-width: 100%;\n\n        .selection {\n          .select2-selection {\n            .select2-search__field {\n              padding: 2px;\n            }\n          }\n        }\n\n        .select2-selection--multiple {\n          border: 1px solid $light-semi-gray;\n          max-width: 100%;\n\n          .select2-selection__rendered {\n            li {\n              margin-top: 6px !important;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .dropzone {\n    margin-bottom: 30px;\n  }\n}\n\n.select2-container--open {\n  .select2-dropdown {\n    z-index: 7;\n  }\n}\n\n.select2-container {\n  width: 100% !important;\n}\n\n.select2-drpdwn {\n  .select2-selection {\n    border-radius: 0 !important;\n    border-color: $light-color !important;\n    height: 40px !important;\n    padding: 5px;\n  }\n\n  .form-control {\n    border-radius: 5px;\n  }\n\n  .form-control-primary {\n    border-color: var(--theme-default);\n    color: var(--theme-default);\n  }\n\n  .form-control-secondary {\n    border-color: var(--theme-secondary);\n    color: var(--theme-secondary);\n  }\n\n  .form-control-success {\n    border-color: $success-color;\n    color: $success-color;\n  }\n\n  .form-control-info {\n    border-color: $info-color;\n    color: $info-color;\n  }\n\n  .form-control-warning {\n    border-color: $warning-color;\n    color: $warning-color;\n  }\n\n  .form-control-danger {\n    border-color: $danger-color;\n    color: $danger-color;\n  }\n\n  .form-control-inverse {\n    border-color: $dark-color;\n    color: $dark-color;\n  }\n\n  .form-control-primary-fill {\n    background-color: var(--theme-default);\n    color: $white;\n  }\n\n  .form-control-secondary-fill {\n    background-color: var(--theme-secondary);\n    color: $white;\n  }\n\n  .form-control-success-fill {\n    background-color: $success-color;\n    color: $white;\n  }\n\n  .form-control-info-fill {\n    background-color: $info-color;\n    color: $white;\n  }\n\n  .form-control-warning-fill {\n    background-color: $warning-color;\n    color: $white;\n  }\n\n  .form-control-danger-fill {\n    background-color: $danger-color;\n    color: $white;\n  }\n\n  .form-control-inverse-fill {\n    background-color: $dark-color;\n    color: $white;\n  }\n}\n\n//colors\n$color_bon_jour_approx: #e0e0e0;\n$color_cape_cod_approx: #424242;\n\n.selection {\n  .select2-selection {\n    border-radius: 5px !important;\n\n    .select2-search__field {\n      margin-top: 0;\n      padding: 3px;\n    }\n  }\n}\n\n.select2-container--classic {\n  .select2-selection--multiple {\n    .select2-selection__choice {\n      padding: 2px 6px !important;\n      margin-top: 0 !important;\n      background-color: var(--theme-default) !important;\n      border-color: var(--theme-default) !important;\n      color: $white;\n      margin-right: 8px !important;\n    }\n\n    .select2-selection__choice__remove {\n      color: $white !important;\n      float: right;\n      margin-left: 0.5rem;\n    }\n  }\n\n  .select2-results__option--highlighted[aria-selected] {\n    background-color: $color_bon_jour_approx !important;\n    color: $color_cape_cod_approx !important;\n  }\n\n  .select2-results__options .select2-results__option[aria-selected=\"true\"] {\n    background-color: var(--theme-default) !important;\n    color: $white !important;\n  }\n}\n\n.select2-container--default {\n  .select2-selection--single {\n    .select2-selection__arrow {\n      top: 11px !important;\n      right: 10px !important;\n    }\n  }\n\n  .select2-selection--multiple {\n    .select2-selection__choice {\n      padding: 2px 6px !important;\n      margin-top: 0 !important;\n      background-color: var(--theme-default) !important;\n      border-color: var(--theme-default) !important;\n      color: $white;\n      margin-right: 8px !important;\n    }\n\n    .select2-selection__choice__remove {\n      color: $white !important;\n      float: right;\n      margin-left: 0.5rem;\n    }\n  }\n\n  .select2-results__option--highlighted[aria-selected] {\n    background-color: $color_bon_jour_approx !important;\n    color: $color_cape_cod_approx !important;\n  }\n\n  .select2-results__options .select2-results__option[aria-selected=\"true\"] {\n    background-color: var(--theme-default) !important;\n    color: $white !important;\n  }\n}\n\n/**=====================\n     21. Select 2 CSS Ends\n==========================**/\n","/**=====================\n    78. Sidebar CSS Start\n==========================**/\n%sidebar-after {\n  position: absolute;\n  content: \"\";\n  top: 48%;\n  width: 8px;\n  border-top: 1px solid rgba($theme-body-sub-title-color, 0.4);\n}\n\n%sidebar-active-dot {\n  position: absolute;\n  content: \"\";\n  width: 5px;\n  height: 5px;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 25px;\n  border-radius: 100%;\n  background: var(--theme-default);\n  opacity: 0;\n  visibility: hidden;\n  [dir=\"rtl\"] & {\n    left: unset;\n    right: 25px;\n  }\n}\n\n%sidebar-before {\n  position: absolute;\n  content: \"\";\n  width: 1px;\n  height: 0;\n  background: rgba($theme-body-sub-title-color, 0.4);\n  top: -10px;\n  left: 27px;\n  transition: height 0.5s;\n  [dir=\"rtl\"] & {\n    left: unset;\n    right: 27px;\n  }\n}\n\n%horizontal-after {\n  position: absolute;\n  content: \"\";\n  top: 49%;\n  width: 5px;\n  height: 1px;\n  border-radius: 100%;\n  background-color: #59667a;\n}\n\n%for-animated-hover {\n  box-shadow: $main-header-shadow;\n  transform: translateY(30px);\n  opacity: 0;\n  visibility: hidden;\n  left: 0;\n}\n\n%for-animated-hover-box {\n  opacity: 1;\n  transform: translateY(0px);\n  visibility: visible;\n  border-radius: 5px;\n  overflow: hidden;\n\n  &:before {\n    width: 0;\n    height: 0;\n    border-left: 7px solid transparent;\n    border-right: 7px solid transparent;\n    border-bottom: 7px solid $white;\n    content: \"\";\n    top: -7px;\n    position: absolute;\n    left: 10px;\n    z-index: 2;\n  }\n\n  &:after {\n    width: 0;\n    height: 0;\n    border-left: 7px solid transparent;\n    border-right: 7px solid transparent;\n    border-bottom: 7px solid $light-background;\n    content: \"\";\n    top: -7px;\n    position: absolute;\n    left: 10px;\n    z-index: 1;\n  }\n}\n.page-wrapper {\n  position: relative;\n  .page-header {\n    max-width: 100vw;\n    position: $main-header-position;\n    top: $main-header-top;\n    z-index: $main-header-z-index;\n    transition: $sidebar-transition;\n    background-color: $white;\n    box-shadow: $main-header-shadow-1;\n    .header-wrapper {\n      width: 100%;\n      align-items: center;\n      padding: $header-wrapper-padding;\n      position: relative;\n      @media (max-width: 1399px) {\n        padding: 22px 20px;\n      }\n      .search-full {\n        background-color: $white;\n        position: absolute;\n        right: 0;\n        z-index: 1;\n        height: 0;\n        width: 0;\n        transform: scale(0);\n        transition: all 0.3s ease;\n        &.open {\n          height: 100%;\n          width: 100%;\n          animation: zoomIn 0.5s ease-in-out;\n          transform: scale(1);\n          transition: all 0.3s ease;\n        }\n        input {\n          line-height: 65px;\n          padding-left: 60px;\n          width: 100% !important;\n\n          &:focus {\n            outline: none !important;\n          }\n        }\n\n        .form-group {\n          .close-search {\n            position: absolute;\n            font-size: 15px;\n            right: 30px;\n            top: 30px;\n            color: $dark-gray;\n            cursor: pointer;\n          }\n\n          &:before {\n            position: absolute;\n            left: 30px;\n            top: 27px;\n            content: \"\\f002\";\n            font-size: 16px;\n            color: $dark-gray;\n            font-family: FontAwesome;\n          }\n        }\n      }\n\n      .nav-right {\n        justify-content: flex-end;\n\n        ul {\n          li {\n            svg {\n              vertical-align: $header-wrapper-nav-icon-align;\n              width: $header-wrapper-nav-icon-size;\n              height: $header-wrapper-nav-icon-size;\n              stroke: rgba($theme-body-font-color, 0.9);\n              fill: none;\n              path {\n                color: $header-wrapper-nav-icon-color;\n              }\n            }\n            .mode {\n              &.active {\n                svg {\n                  fill: $white;\n                }\n              }\n            }\n          }\n        }\n\n        &.right-header {\n          ul {\n            li {\n              .mode {\n                cursor: pointer;\n                text-align: center;\n\n                i {\n                  font-size: 18px;\n                  font-weight: 600;\n                  transition: all 0.3s ease;\n\n                  &.fa-lightbulb-o {\n                    font-weight: 500;\n                    font-size: 22px;\n                    transition: all 0.3s ease;\n                    animation: zoomIn 300ms ease-in-out;\n                  }\n                }\n              }\n\n              .header-search {\n                cursor: pointer;\n              }\n\n              .profile-media {\n                .media-body {\n                  margin-left: 15px;\n\n                  span {\n                    font-weight: 500;\n                  }\n\n                  p {\n                    font-size: 12px;\n                    line-height: 1;\n                    color: rgba($theme-body-font-color, 0.7);\n                  }\n                }\n              }\n            }\n          }\n        }\n\n        > ul {\n          display: flex;\n          align-items: center;\n          justify-content: flex-end;\n\n          > li {\n            padding: 6px 10px;\n            display: inline-block;\n            position: relative;\n\n            .badge {\n              position: absolute;\n              right: -5px;\n              top: -6px;\n              padding: 2px 4px;\n              font-size: 11px;\n              font-weight: 700;\n              font-family: work-Sans, sans-serif;\n            }\n\n            span {\n              ul {\n                left: inherit;\n                right: -10px;\n                width: 130px;\n\n                &:before,\n                &:after {\n                  left: inherit;\n                  right: 10px;\n                }\n\n                li {\n                  display: block;\n\n                  a {\n                    font-size: 14px;\n                    color: $dark-color;\n\n                    i {\n                      margin-left: 10px;\n                      font-size: 13px;\n                      color: $dark-color;\n                    }\n                  }\n                }\n              }\n            }\n          }\n\n          .flag-icon {\n            font-size: 16px;\n          }\n        }\n\n        .bookmark-flip {\n          width: unset !important;\n          box-shadow: unset !important;\n          background-color: transparent !important;\n          overflow: initial;\n          &::after,\n          &::before {\n            display: none;\n          }\n\n          .bookmark-dropdown {\n            .bookmark-content {\n              text-align: center;\n              .bookmark-icon {\n                width: 52px;\n                height: 52px;\n                background-color: #f9f9f9;\n                border-radius: 100%;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                margin: 0 auto;\n              }\n              span {\n                font-family: $font-roboto, $font-serif;\n                font-size: 12px;\n                font-weight: 500;\n                letter-spacing: 0.5px;\n              }\n            }\n          }\n        }\n\n        .flip-card {\n          width: 300px;\n          height: 260px;\n          background-color: transparent;\n\n          .flip-card-inner {\n            position: relative;\n            height: 100%;\n            text-align: center;\n            transition: transform 0.6s;\n            transform-style: preserve-3d;\n\n            .front,\n            .back {\n              position: absolute;\n              backface-visibility: hidden;\n              border-radius: 10px;\n              overflow: hidden;\n              box-shadow: 0 0 20px rgba(89, 102, 122, 0.1);\n              width: 300px;\n              height: 260px;\n\n              button {\n                background-color: $transparent-color;\n                color: $primary-color;\n                border: none;\n\n                &:focus {\n                  outline: $transparent-color;\n                }\n              }\n            }\n\n            .front {\n              background-color: $white;\n              transition: 0.3s;\n\n              svg {\n                stroke: $dark-color;\n                transition: all 0.3s ease;\n\n                &:hover {\n                  stroke: var(--theme-default);\n                  transition: all 0.3s ease;\n                }\n              }\n            }\n\n            .back {\n              background-color: $white;\n              transform: rotateY(180deg);\n\n              li {\n                &:first-child {\n                  margin-top: 20px;\n                  height: 140px !important;\n                }\n              }\n\n              button {\n                width: 100%;\n              }\n\n              .flip-back-content {\n                input {\n                  border-radius: 25px;\n                  padding: 6px 12px;\n                  width: 100%;\n                  border: 1px solid #ddd;\n                  &:focus {\n                    outline: none;\n                  }\n                }\n              }\n            }\n\n            &.flipped {\n              transform: rotateY(180deg);\n\n              .front {\n                opacity: 0;\n              }\n            }\n          }\n        }\n\n        .onhover-show-div {\n          width: 330px;\n          top: 50px;\n          right: 0;\n          left: unset;\n          .dropdown-title {\n            padding: 20px;\n            text-align: center;\n            border-bottom: 1px solid rgba($dropdown-border-color, 0.3);\n          }\n          ul {\n            padding: 15px;\n          }\n          li {\n            padding: 15px;\n            p {\n              font-size: 14px;\n              letter-spacing: 0.3px;\n              margin-bottom: 0;\n            }\n            a {\n              text-decoration: underline;\n              text-transform: uppercase;\n              letter-spacing: 0.3px;\n              font-family: $font-roboto, $font-serif;\n            }\n\n            & + li {\n              margin-top: 15px;\n            }\n\n            &:last-child {\n              padding-bottom: 15px;\n            }\n\n            .media {\n              position: relative;\n\n              img {\n                width: 40px;\n                position: relative;\n              }\n\n              .status-circle {\n                left: 0;\n              }\n\n              .media-body {\n                > span {\n                  letter-spacing: 0.8px;\n                  padding-right: 10px;\n                  display: inline-block;\n                }\n\n                p {\n                  margin-bottom: 8px;\n                }\n              }\n            }\n          }\n\n          &:before,\n          &:after {\n            right: 10px !important;\n            left: unset !important;\n          }\n        }\n\n        .notification-box {\n          position: relative;\n        }\n\n        .cart-box {\n          position: relative;\n        }\n\n        .cart-dropdown {\n          ul {\n            padding: 0 0 15px;\n          }\n          li {\n            margin: 0 15px;\n            padding: 10px 0;\n            .media {\n              align-items: center;\n              .media-body {\n                margin-right: 20px;\n                [dir=\"rtl\"] & {\n                  margin-right: unset;\n                  margin-left: 20px;\n                }\n              }\n            }\n\n            & + li {\n              margin-top: 0;\n              border-top: 1px solid rgba($dropdown-border-color, 0.1);\n            }\n            &:last-child {\n              padding: 20px 15px;\n              border-top: none;\n            }\n          }\n\n          p {\n            line-height: 1.3;\n            margin-top: 3px;\n            opacity: 0.6;\n          }\n\n          .close-circle {\n            position: absolute;\n            right: 0;\n            top: 0;\n            a {\n              width: 18px;\n              height: 18px;\n              border-radius: 100%;\n              display: flex;\n              align-items: center;\n              justify-content: center;\n            }\n\n            svg {\n              width: 14px;\n              stroke: $white;\n            }\n          }\n          .qty-box {\n            margin: 5px 0;\n            .input-group-text {\n              background-color: transparent;\n            }\n            .input-group {\n              width: 80px;\n              background-color: transparent;\n              input {\n                background-color: transparent;\n              }\n              input,\n              .btn {\n                font-size: 10px;\n                font-family: $font-roboto, $font-serif;\n                font-weight: 700;\n              }\n              .btn {\n                padding: 2px;\n                background-color: $off-white !important;\n                border-color: $off-white !important;\n                border-radius: 100%;\n                font-size: 14px;\n                color: $theme-body-font-color;\n                display: flex;\n              }\n            }\n          }\n          .total {\n            margin: 0;\n            padding: 15px;\n            background-color: #f9f9f9;\n            border: none;\n            h6 {\n              font-family: $font-roboto, $font-serif;\n              font-weight: 500;\n              font-size: 12px;\n              line-height: 14px;\n              letter-spacing: 0.5px;\n              span {\n                font-size: 14px;\n              }\n            }\n          }\n          .view-checkout {\n            text-decoration: unset;\n          }\n        }\n\n        .notification-box {\n          svg {\n            animation: swing 1.5s ease infinite;\n          }\n        }\n        .notification-dropdown {\n          top: 52px;\n          width: 300px;\n          right: -20px !important;\n          left: unset;\n          @media (max-width: 575.98px) {\n            width: calc(100vw - 30px);\n          }\n          li {\n            background-color: #f9f9f9;\n            border-radius: 5px;\n            &:last-child {\n              text-align: center;\n              background-color: transparent;\n            }\n\n            p {\n              display: flex;\n              align-items: center;\n              justify-content: space-between;\n              span {\n                font-size: 11px;\n                vertical-align: middle;\n              }\n            }\n          }\n\n          &:before,\n          &:after {\n            right: 28px !important;\n            left: unset !important;\n          }\n        }\n\n        .profile-dropdown {\n          width: 160px;\n          top: 57px;\n          left: -12px;\n          padding: 0 10px;\n\n          li {\n            padding: 10px !important;\n            a {\n              text-decoration: unset;\n            }\n\n            &:hover {\n              a {\n                span {\n                  color: var(--theme-default);\n                  transition: color 0.3s ease;\n                }\n\n                svg {\n                  stroke: var(--theme-default);\n                  transition: stroke 0.3s ease;\n\n                  path {\n                    stroke: var(--theme-default);\n                    transition: stroke 0.3s ease;\n                  }\n                }\n              }\n            }\n            + li {\n              margin-top: 0;\n            }\n\n            &:last-child {\n              padding-top: 10px !important;\n            }\n\n            span {\n              color: $dark-color;\n            }\n\n            svg {\n              width: 16px;\n              vertical-align: bottom;\n              margin-right: 10px;\n              stroke: $dark-color;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .page-body-wrapper {\n    background-color: $main-body-color;\n\n    .page-body {\n      min-height: calc(100vh - #{$header-size});\n      margin-top: $header-size;\n      padding: $page-body-padding;\n      position: relative;\n      transition: 0.5s;\n\n      &:before {\n        animation: fadeIn 0.5s ease-in-out;\n      }\n    }\n\n    .page-title {\n      padding: $page-title-padding;\n      margin: 0 -27px 30px;\n      background-color: $white;\n      > .row {\n        margin: 0;\n        .col-6 {\n          padding: 0;\n        }\n      }\n\n      .row {\n        align-items: center;\n\n        h3 {\n          font-size: $page-title-font-size;\n          margin-bottom: $page-title-margin-bottom;\n          text-transform: $page-title-text-tranform;\n\n          small {\n            display: $page-small-title-display;\n            font-size: $page-small-title-font-size;\n            margin-bottom: $page-small-title-margin-bottom;\n            text-transform: $page-small-title-text-transform;\n            color: $theme-body-sub-title-color;\n          }\n        }\n      }\n\n      .breadcrumb {\n        background-color: $transparent-color;\n        padding: 0;\n        margin-bottom: 0;\n        align-items: center;\n        justify-content: flex-end;\n\n        li {\n          font-size: 13px;\n          letter-spacing: 1px;\n          font-family: $font-roboto, $font-serif;\n        }\n\n        .breadcrumb-item {\n          & + .breadcrumb-item {\n            &:before {\n              content: $breadcrumb-content;\n            }\n          }\n\n          a {\n            svg {\n              width: 16px;\n              height: 16px;\n              stroke: $dark-color;\n              vertical-align: text-top;\n            }\n          }\n          &.active {\n            color: var(--theme-default);\n            font-weight: 500;\n          }\n        }\n      }\n    }\n\n    div.sidebar-wrapper {\n      .sidebar-main {\n        .sidebar-links {\n          > li {\n            a {\n              svg {\n                &.stroke-icon {\n                  stroke: $dark-color;\n                }\n                &.fill-icon {\n                  fill: $sidebar-fill-icon-color;\n                }\n              }\n              &.active {\n                svg {\n                  transition: all 0.3s ease;\n                  &.stroke-icon {\n                    stroke: var(--theme-default);\n                  }\n                  &.fill-icon {\n                    fill: var(--theme-default);\n                  }\n                }\n              }\n            }\n          }\n          li {\n            a {\n              text-transform: capitalize;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  &.horizontal-wrapper {\n    [data-simplebar] {\n      position: relative;\n    }\n    .footer {\n      margin-left: 0;\n    }\n\n    .header-logo-wrapper {\n      width: 150px;\n\n      .toggle-sidebar {\n        display: none;\n      }\n    }\n\n    .page-body-wrapper {\n      .sidebar-wrapper {\n        height: 54px;\n        line-height: inherit;\n        top: 79px;\n        background: $white;\n        box-shadow: 0px 9px 24px rgba($semi-dark, 0.05);\n        overflow-x: hidden;\n        z-index: 1;\n        overflow-y: visible;\n        position: fixed;\n        width: 100vw;\n        border-top: 1px solid $light-semi-gray;\n        z-index: 3;\n        li {\n          display: inline-block;\n        }\n        .badge {\n          position: absolute;\n          top: 2px;\n          right: 0px;\n          z-index: 1;\n        }\n\n        .logo-wrapper,\n        .logo-icon-wrapper {\n          display: none;\n        }\n\n        .sidebar-main {\n          text-align: left;\n          position: relative;\n\n          .left-arrow,\n          .right-arrow {\n            position: absolute;\n            top: 0px;\n            padding: 15px;\n            background-color: $white;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            z-index: 1;\n            cursor: pointer;\n\n            &.disabled {\n              display: none;\n            }\n          }\n\n          .left-arrow {\n            left: 0;\n          }\n\n          .right-arrow {\n            right: 0;\n          }\n\n          .sidebar-links {\n            list-style: none;\n            margin: 0;\n            padding: 0;\n            line-height: normal;\n            direction: ltr;\n            text-align: left;\n            display: -webkit-box !important;\n            padding: 0 5px;\n            transition: all 0.5s ease;\n            white-space: nowrap;\n\n            li {\n              &.sidebar-list {\n                a {\n                  &.active {\n                    .according-menu {\n                      i {\n                        &:before {\n                          content: \"-\";\n                        }\n                      }\n                    }\n                  }\n\n                  .according-menu {\n                    display: none;\n                  }\n                }\n                &:hover {\n                  > .sidebar-submenu {\n                    display: block !important;\n                    > li {\n                      > .sidebar-submenu {\n                        display: block !important;\n                      }\n                      .sub-arrow {\n                        i {\n                          font-size: 10px;\n                        }\n                      }\n                      &:hover {\n                        display: block !important;\n                      }\n                    }\n                  }\n                }\n                ul.sidebar-submenu {\n                  li {\n                    a {\n                      &.active {\n                        color: var(--theme-default);\n\n                        &:after {\n                          background-color: var(--theme-default);\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n\n            > li {\n              position: relative;\n              padding-top: 10px;\n              padding-bottom: 10px;\n\n              &:hover {\n                > a {\n                  > span {\n                    color: var(--theme-default);\n                    transition: all 0.3s ease;\n                  }\n                }\n\n                a {\n                  background-color: rgba($primary-color, 0.15%);\n                  transition: all 0.3s ease;\n\n                  svg {\n                    &.stroke-icon {\n                      stroke: var(--theme-default);\n                      transition: all 0.3s ease;\n                    }\n                    &.fill-icon {\n                      fill: var(--theme-default);\n                      transition: all 0.3s ease;\n                    }\n                  }\n                }\n              }\n\n              &:first-child {\n                display: none !important;\n              }\n\n              > a {\n                display: block;\n                color: $theme-body-font-color;\n                line-height: 23px;\n                text-decoration: none;\n                text-transform: capitalize;\n                padding: 5px 15px;\n                margin: 0 3px;\n                letter-spacing: 0.04em;\n                position: relative;\n                border-radius: 5px;\n                font-weight: 500;\n                transition: all 0.3s ease;\n\n                &.active {\n                  //background-image: linear-gradient(90deg, var(--theme-default) 0%, #a26cf8 100%);\n                  background-color: lighten($primary-color, 22%);\n                  transition: all 0.3s ease;\n\n                  svg,\n                  span {\n                    color: var(--theme-default);\n                    transition: all 0.3s ease;\n                  }\n                }\n\n                .badge {\n                  position: absolute;\n                  top: -5px;\n                  margin-left: 1px;\n                  right: 10px;\n                  padding: 0.2em 0.7em;\n                }\n\n                svg {\n                  width: 18px;\n                  height: 18px;\n                  vertical-align: middle;\n                  margin-right: 10px;\n                }\n              }\n\n              .sidebar-submenu {\n                position: fixed;\n                // left: 0;\n                z-index: 4;\n                box-shadow: 0 0 1px 0 $dark-gray;\n                padding: 15px 0px 15px 0px;\n                background: white;\n                li {\n                  border: 0;\n                  float: none;\n                  position: relative;\n                  display: block;\n\n                  a {\n                    background: transparent;\n                    padding: 4px 30px;\n                    display: block;\n                    transition: all 0.5s ease;\n                    line-height: 1.9;\n                    color: rgba(43, 43, 43, 0.6);\n                    letter-spacing: 0.06em;\n                    font-weight: 500;\n                    font-family: Roboto;\n                    transition: all 0.3s ease;\n\n                    &:after {\n                      left: 20px;\n                      @extend %horizontal-after;\n                    }\n\n                    &:hover {\n                      color: var(--theme-default);\n                      letter-spacing: 1.5px;\n                      transition: all 0.3s ease;\n\n                      &:after {\n                        background-color: var(--theme-default);\n                      }\n                    }\n                  }\n                }\n              }\n\n              .mega-menu-container {\n                position: fixed;\n                right: 0;\n                left: 0;\n                margin: 0 auto;\n                z-index: 4;\n                box-shadow: 0 0 1px 0 $dark-gray;\n                padding: 30px;\n                background: white;\n                width: 95%;\n                border-radius: 4px;\n                display: block !important;\n\n                .mega-box {\n                  width: 20%;\n\n                  .link-section {\n                    .submenu-title {\n                      h5 {\n                        text-transform: uppercase;\n                        font-size: 14px;\n                        margin-left: -13px;\n                      }\n                    }\n\n                    .submenu-content {\n                      box-shadow: none;\n                      background-color: transparent;\n                      position: relative;\n                      display: block;\n                      padding: 0;\n                      li {\n                        border: 0;\n                        float: none;\n                        position: relative;\n                        display: block;\n\n                        a {\n                          border: 0 !important;\n                          background: transparent;\n                          color: $theme-body-font-color;\n                          border-radius: 0 !important;\n                          text-transform: capitalize;\n                          padding: 3px 0;\n                          font-size: 13px;\n                          display: block;\n                          letter-spacing: 0.07em;\n                          line-height: 1.9;\n                          position: relative;\n                          transition: all 0.3s ease;\n\n                          &:hover {\n                            color: var(--theme-default);\n                            letter-spacing: 1.5px;\n                            transition: all 0.3s ease;\n\n                            &:after {\n                              color: var(--theme-default);\n                              transition: all 0.3s ease;\n                            }\n                          }\n\n                          &:after {\n                            position: absolute;\n                            content: \"\";\n                            left: -12px;\n                            top: 50%;\n                            width: 5px;\n                            height: 1px;\n                            background-color: $light-semi-font;\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n\n              &:hover {\n                > a {\n                  &:after {\n                    left: 0;\n                    right: 0;\n                    opacity: 1;\n                  }\n                }\n              }\n\n              &.mega-menu {\n                position: unset;\n              }\n            }\n          }\n        }\n\n        &.overlay-white {\n          background-color: rgba(255, 255, 255, 0.08);\n        }\n      }\n\n      .toggle-nav {\n        position: relative;\n        display: flex;\n        align-items: center;\n        cursor: pointer;\n        i {\n          font-size: 24px;\n        }\n      }\n      .page-body {\n        margin-top: 135px;\n      }\n      .sidebar-main-title {\n        display: none !important;\n      }\n      &.scorlled {\n        .sidebar-wrapper {\n          display: none;\n          transition: all 0.3s ease;\n        }\n      }\n    }\n\n    .page-header {\n      width: 100%;\n      box-shadow: none;\n\n      .header-wrapper {\n        .form-control-plaintext {\n          width: auto !important;\n        }\n        .left-header {\n          width: 30%;\n          @media (max-width: 1428px) and (min-width: 1324px) {\n            width: 32%;\n          }\n          @media (max-width: 1323px) and (min-width: 1200px) {\n            width: 37%;\n          }\n          @media (max-width: 1199px) and (min-width: 992px) {\n            width: 32%;\n          }\n        }\n        .nav-right {\n          @media (max-width: 1428px) and (min-width: 1324px) {\n            width: 55%;\n          }\n          @media (max-width: 1323px) and (min-width: 1200px) {\n            width: 40%;\n          }\n          @media (max-width: 1199px) and (min-width: 992px) {\n            width: 50%;\n          }\n        }\n      }\n    }\n\n    &.enterprice-type {\n      footer {\n        margin-left: 0;\n      }\n    }\n  }\n  &.material-icon {\n    .card {\n      border-radius: 30px;\n      box-shadow: 0 0 20px rgba($primary-color, 0.1);\n    }\n  }\n  .sidebar-main-title {\n    h6 {\n      font-size: 14px;\n      font-weight: 600;\n      color: $theme-body-sub-title-color;\n      text-transform: uppercase;\n      margin-bottom: 0;\n      letter-spacing: 0.4px;\n    }\n  }\n\n  // left sidebar css\n  &.compact-wrapper {\n    .page-header {\n      margin-left: $sidebar-compact-width;\n      width: calc(100% - #{$sidebar-compact-width});\n\n      &.close_icon {\n        margin-left: 90px;\n        width: calc(100% - 90px);\n      }\n\n      .header-wrapper {\n        .logo-wrapper {\n          display: none;\n        }\n\n        .toggle-sidebar {\n          display: none;\n        }\n      }\n    }\n\n    .page-body-wrapper {\n      div {\n        &.sidebar-wrapper {\n          position: fixed;\n          top: 0;\n          z-index: 9;\n          height: auto;\n          line-height: inherit;\n          background: $white;\n          width: $sidebar-compact-width;\n          text-align: left;\n          transition: 0.3s;\n          box-shadow: 0 0 21px 0 rgba($semi-dark, 0.1);\n\n          .logo-wrapper,\n          .logo-icon-wrapper {\n            padding: 27px 30px;\n            box-shadow: -9px 0 20px rgba($semi-dark, 0.1);\n          }\n\n          .logo-icon-wrapper {\n            display: none;\n          }\n          &.close_icon {\n            width: auto;\n            transition: all 0.3s ease;\n            .badge {\n              opacity: 0;\n              width: 0;\n              padding: 0;\n            }\n            .sidebar-main {\n              .sidebar-links {\n                > li {\n                  max-width: 86px;\n                  margin: 0;\n                  transition: all 0.3s ease;\n                  .sidebar-submenu {\n                    a {\n                      display: none;\n                    }\n                  }\n\n                  a {\n                    text-align: center;\n                    padding: 12px 14px;\n                    transition: all 0.3s ease;\n                  }\n                }\n              }\n            }\n\n            .sidebar-main-title {\n              display: none !important;\n              opacity: 0;\n              transition: all 0.3s ease;\n            }\n\n            .logo-wrapper {\n              display: none;\n            }\n\n            .logo-icon-wrapper {\n              text-align: right;\n              display: block;\n            }\n\n            &:hover {\n              width: 265px;\n              transition: all 0.3s ease;\n\n              .badge {\n                opacity: 1;\n                width: auto;\n                transition: all 0.3s ease;\n              }\n\n              .sidebar-main {\n                .sidebar-links {\n                  > li {\n                    max-width: unset;\n                    margin: initial;\n                    transition: all 0.3s ease;\n                    a {\n                      text-align: left;\n                      [dir=\"rtl\"] & {\n                        text-align: right;\n                      }\n                    }\n\n                    .sidebar-submenu {\n                      a {\n                        display: block;\n                      }\n                    }\n\n                    > a {\n                      padding: 12px 15px;\n                      transition: all 0.3s ease;\n                      svg {\n                        margin-right: 15px;\n                      }\n                      span {\n                        display: inline-block;\n                      }\n                    }\n                  }\n                }\n              }\n\n              .sidebar-main-title {\n                opacity: 1;\n                display: block !important;\n                transition: all 0.3s ease;\n              }\n\n              .logo-wrapper {\n                display: block;\n              }\n\n              .logo-icon-wrapper {\n                display: none;\n              }\n            }\n\n            .mobile-sidebar {\n              transform: translate(183px);\n            }\n\n            ~ .page-body,\n            ~ footer {\n              margin-left: 90px;\n              transition: 0.5s;\n            }\n\n            ~ .footer-fix {\n              width: calc(100% - 90px);\n            }\n\n            .sidebar-main {\n              .sidebar-links {\n                height: calc(100vh - 118px);\n\n                > li {\n                  .sidebar-link {\n                    &::before {\n                      right: 20px;\n                      left: unset;\n                    }\n                  }\n\n                  a {\n                    svg {\n                      margin: 0;\n                    }\n                    span {\n                      display: none;\n                    }\n                  }\n                }\n                .sidebar-list {\n                  .sidebar-title {\n                    &.active {\n                      ~ .sidebar-submenu {\n                        display: none;\n                      }\n                    }\n                  }\n                }\n              }\n            }\n\n            .according-menu {\n              display: none;\n            }\n          }\n\n          .sidebar-main {\n            .left-arrow,\n            .right-arrow {\n              display: none;\n            }\n\n            .sidebar-links {\n              height: $sidebar-height;\n              left: -300px;\n              z-index: 99;\n              transition: color 1s ease;\n              overflow: auto;\n              color: rgba(0, 0, 0, 0);\n              margin-top: 20px;\n              margin-bottom: 30px;\n\n              li {\n                a {\n                  font-weight: 500;\n\n                  svg {\n                    width: 18px;\n                    height: 18px;\n                    margin-right: 10px;\n                    vertical-align: -2px;\n                    float: none;\n                    transition: all 0.3s ease;\n                  }\n\n                  span {\n                    letter-spacing: 0.7px;\n                    text-transform: capitalize;\n                    color: rgba($theme-body-sub-title-color, 0.8);\n                  }\n\n                  &.link-nav {\n                    .according-menu {\n                      display: none;\n                    }\n                  }\n                }\n\n                &:last-child {\n                  border-bottom: none;\n                }\n              }\n\n              &.opennav {\n                left: 0;\n              }\n\n              .back-btn {\n                display: block;\n                width: 100%;\n                padding: 0;\n\n                .mobile-back {\n                  padding: 20px;\n                  color: $theme-font-color;\n                  font-weight: 700;\n                  text-transform: uppercase;\n                  border-bottom: 1px solid #efefef;\n                  cursor: pointer;\n                  display: flex;\n                  justify-content: flex-end;\n                  align-items: center;\n                }\n              }\n\n              > li {\n                display: block;\n                width: 100%;\n                position: relative;\n\n                &.sidebar-main-title {\n                  padding: 25px 0 6px 20px;\n                  margin-top: 10px;\n                  [dir=\"rtl\"] & {\n                    padding: 25px 20px 6px 0;\n                  }\n                  &::before {\n                    position: absolute;\n                    content: \"\";\n                    top: 0;\n                    left: 50%;\n                    background: var(--sidebar-border);\n                    width: calc(100% - 40px);\n                    height: 1px;\n                    transform: translateX(-50%);\n                  }\n                  &:nth-child(2) {\n                    margin-top: 0;\n                    &::before {\n                      display: none;\n                    }\n                  }\n                }\n\n                &.sidebar-list {\n                  .badge {\n                    position: absolute;\n                    right: 50px;\n                    top: 14.5px;\n                    padding: 0.45em 0.8em 0.33em;\n                    z-index: 1;\n                    font-size: 10px;\n                    letter-spacing: 0.7px;\n                    font-weight: 600;\n                    font-family: $font-roboto, $font-serif;\n                    border-radius: 10px;\n                  }\n\n                  &:hover {\n                    > a {\n                      &:hover {\n                        background-color: rgba($primary-color, 0.07);\n                        transition: all 0.3s ease;\n                      }\n                    }\n                  }\n                }\n\n                &:hover {\n                  .sidebar-link:not(.active) {\n                    &:hover {\n                      svg {\n                        fill: rgba($primary-color, 0.1%);\n                        stroke: var(--theme-default);\n                        transition: all 0.3s ease;\n                        &.fill-icon {\n                          fill: var(--theme-default);\n                          stroke: none;\n                        }\n                      }\n\n                      span {\n                        color: var(--theme-default);\n                        transition: all 0.3s ease;\n                      }\n\n                      .according-menu {\n                        i {\n                          color: var(--theme-default);\n                          transition: all 0.3s ease;\n                        }\n                      }\n                    }\n                  }\n                }\n\n                a {\n                  padding: 12px 20px;\n                  position: relative;\n                  color: #222222;\n                  transition: all 0.3s ease;\n\n                  .sub-arrow {\n                    right: 20px;\n                    position: absolute;\n                    top: 10px;\n\n                    i {\n                      display: none;\n                    }\n\n                    &:before {\n                      display: none;\n                    }\n                  }\n                }\n\n                &:first-child {\n                  display: none !important;\n                }\n\n                .sidebar-submenu {\n                  width: 100%;\n                  padding: 0;\n                  position: relative !important;\n                  &::before {\n                    @extend %sidebar-before;\n                  }\n\n                  > li {\n                    a {\n                      padding-left: 48px !important;\n                      font-weight: 400;\n                    }\n                  }\n\n                  .submenu-title {\n                    .according-menu {\n                      top: 7px;\n                    }\n                  }\n\n                  &.opensubmenu {\n                    display: block;\n                  }\n\n                  li {\n                    &:hover {\n                      > a {\n                        color: var(--theme-default);\n                        transition: all 0.3s ease;\n                      }\n                    }\n\n                    .nav-sub-childmenu {\n                      display: none;\n                      position: relative !important;\n                      right: 0;\n                      width: 100%;\n                      padding: 0;\n\n                      &.opensubchild {\n                        display: block;\n                      }\n\n                      li {\n                        a {\n                          padding: 6px 45px;\n                          padding-left: 56px !important;\n\n                          &:after {\n                            display: none;\n                          }\n                        }\n                      }\n                    }\n                    a {\n                      padding: 7px 25px;\n                      font-size: 14px;\n                      color: rgba($theme-body-font-color, 0.6);\n                      display: block;\n                      position: relative;\n                      letter-spacing: 0.06em;\n                      font-weight: 500;\n                      transition: all 0.3s ease;\n                      white-space: nowrap;\n                      overflow: hidden;\n                      text-overflow: ellipsis;\n                      &::before {\n                        @extend %sidebar-active-dot;\n                      }\n                      &.active {\n                        color: var(--theme-default);\n                        &::before {\n                          opacity: 1;\n                          visibility: visible;\n                        }\n                      }\n\n                      &:after {\n                        left: 27px;\n                        @extend %sidebar-after;\n                      }\n\n                      &:hover {\n                        margin-left: 0;\n                      }\n                    }\n                  }\n                }\n\n                .mega-menu-container {\n                  padding: 0;\n                  position: relative;\n                  &::before {\n                    @extend %sidebar-before;\n                  }\n\n                  &.opensubmenu {\n                    display: block;\n                  }\n\n                  .mega-box {\n                    width: 100%;\n                    padding: 0;\n\n                    .link-section {\n                      &:hover {\n                        h5 {\n                          color: var(--theme-default) !important;\n                          transition: all 0.3s ease;\n                        }\n                      }\n\n                      .submenu-title {\n                        position: relative;\n\n                        h5 {\n                          margin-bottom: 0;\n                          line-height: 1.9;\n                          padding: 6px 25px 6px 45px;\n                          font-size: 14px;\n                          position: relative;\n                          color: rgba(43, 43, 43, 0.6);\n                          display: block;\n                          letter-spacing: 0.06em;\n                          font-weight: 500;\n                          font-family: Roboto;\n                          cursor: pointer;\n\n                          &:after {\n                            left: 28px;\n                            @extend %sidebar-after;\n                          }\n                          &::before {\n                            @extend %sidebar-active-dot;\n                          }\n                        }\n                        &.active {\n                          h5 {\n                            color: var(--theme-default);\n                            &::before {\n                              opacity: 1;\n                              visibility: visible;\n                            }\n                          }\n                        }\n\n                        .according-menu {\n                          top: 8px;\n                        }\n                      }\n\n                      .submenu-content {\n                        &.opensubmegamenu {\n                          li {\n                            a {\n                              margin-bottom: 0;\n                              line-height: 1.9;\n                              padding: 6px 25px 6px 45px;\n                              font-size: 14px;\n                              position: relative;\n                              color: rgba(43, 43, 43, 0.6);\n                              display: block;\n                              letter-spacing: 0.06em;\n                              font-weight: 500;\n                              font-family: Roboto;\n\n                              &:after {\n                                display: none;\n                              }\n\n                              &.active {\n                                color: var(--theme-default);\n                              }\n                            }\n                          }\n                        }\n\n                        ul {\n                          li {\n                            a {\n                              line-height: 1.9;\n\n                              &:hover {\n                                margin-left: 0;\n                              }\n                            }\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n\n                &.mega-menu {\n                  .sidebar-title {\n                    &.active {\n                      ~ .mega-menu-container {\n                        display: block !important;\n                        &::before {\n                          height: calc(100% - 9px);\n                          transition: height 0.5s;\n                        }\n                      }\n                    }\n                  }\n                }\n\n                .sidebar-link {\n                  transition: all 0.5s ease;\n                  display: block;\n                  &::after {\n                    position: absolute;\n                    content: \"\";\n                    width: 4px;\n                    height: 35px;\n                    right: 0;\n                    top: 50%;\n                    transform: translateY(-50%);\n                    background-color: $primary-color;\n                    border-radius: 5px 0px 0px 5px;\n                    opacity: 0;\n                    visibility: hidden;\n                    [dir=\"rtl\"] & {\n                      right: unset;\n                      left: 0;\n                    }\n                  }\n                  &.active {\n                    transition: all 0.5s ease;\n                    position: relative;\n                    margin-bottom: 10px;\n                    background-color: lighten($primary-color, 27%);\n                    &::after {\n                      opacity: 1;\n                      visibility: visible;\n                    }\n                    ~ .sidebar-submenu {\n                      &::before {\n                        height: calc(100% - 8px);\n                        transition: height 0.5s;\n                      }\n                    }\n                    .according-menu {\n                      i {\n                        color: var(--theme-default);\n                      }\n                    }\n\n                    span {\n                      color: var(--theme-default);\n                      transition: all 0.3s ease;\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n\n      .mega-box {\n        &.col {\n          flex-basis: unset;\n        }\n      }\n\n      .according-menu {\n        position: absolute;\n        right: 20px;\n        top: 13px;\n        display: block;\n\n        i {\n          vertical-align: middle;\n          color: rgba($theme-body-sub-title-color, 0.8);\n          font-weight: 500;\n        }\n      }\n\n      .main-menu {\n        &.border-section {\n          border: none;\n        }\n\n        .menu-left {\n          .main-menu-right {\n            .toggle-nav {\n              position: absolute;\n              z-index: 2;\n              right: 145px;\n              top: 6px;\n\n              .sidebar-name {\n                font-size: 18px;\n                padding-left: 5px;\n                text-transform: uppercase;\n              }\n            }\n          }\n        }\n      }\n\n      .page-body {\n        min-height: calc(100vh - 80px);\n        margin-top: 80px;\n        margin-left: $sidebar-compact-width;\n        // animation: pagebody 1000ms ease-in-out;\n      }\n    }\n\n    &.dark-sidebar,\n    &.color-sidebar {\n      .sidebar-main-title {\n        h6 {\n          color: $dark-all-font-color;\n        }\n      }\n      .toggle-sidebar {\n        svg {\n          stroke: var(--theme-default);\n        }\n      }\n      .page-body-wrapper {\n        div.sidebar-wrapper {\n          .sidebar-main {\n            .sidebar-links {\n              > li {\n                a {\n                  svg {\n                    &.stroke-icon {\n                      stroke: $dark-all-font-color;\n                    }\n                    &.fill-icon {\n                      fill: $dark-all-font-color;\n                    }\n                  }\n                  &.active {\n                    svg {\n                      &.stroke-icon {\n                        stroke: var(--theme-default);\n                      }\n                      &.fill-icon {\n                        fill: var(--theme-default);\n                      }\n                    }\n                  }\n                }\n                &.sidebar-main-title {\n                  &::before {\n                    background: $dark-card-border;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n\n      div.sidebar-wrapper {\n        background-color: $dark-card-background;\n\n        .sidebar-main {\n          .sidebar-links {\n            li {\n              a {\n                span {\n                  color: $dark-all-font-color;\n                }\n\n                svg {\n                  &.stroke-icon {\n                    stroke: $dark-all-font-color;\n                  }\n                  &.fill-icon {\n                    fill: $dark-all-font-color;\n                  }\n                }\n              }\n            }\n\n            > li {\n              .mega-menu-container {\n                .mega-box {\n                  .link-section {\n                    .submenu-title {\n                      h5 {\n                        color: $dark-all-font-color;\n                      }\n                    }\n\n                    .submenu-content {\n                      &.opensubmegamenu {\n                        li {\n                          a {\n                            color: $dark-all-font-color;\n                            font-weight: 400;\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n\n                &::after {\n                  background-color: $light-all-font-color;\n                }\n              }\n\n              .sidebar-link {\n                &.active {\n                  background-color: rgba($primary-color, 0.2);\n\n                  svg {\n                    color: var(--theme-default);\n                    stroke: var(--theme-default);\n                  }\n                }\n              }\n\n              .sidebar-submenu {\n                li {\n                  a {\n                    color: $dark-all-font-color;\n                  }\n                }\n              }\n            }\n\n            .sidebar-list {\n              ul.sidebar-submenu {\n                li {\n                  a {\n                    span {\n                      color: $dark-all-font-color;\n                    }\n\n                    &.active {\n                      color: var(--theme-default);\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n\n        .logo-wrapper {\n          .for-light {\n            display: none;\n          }\n\n          .for-dark {\n            display: block;\n          }\n        }\n      }\n\n      .according-menu {\n        i {\n          color: $dark-all-font-color;\n        }\n      }\n    }\n\n    &.color-sidebar {\n      div.sidebar-wrapper {\n        background-color: #2f3c4e;\n      }\n    }\n  }\n\n  // compact icon css\n  &.compact-sidebar {\n    ~ .bg-overlay1 {\n      transition: 0.8s;\n\n      &.active {\n        z-index: 8;\n        height: 100vh;\n        width: 100vw;\n        background-color: rgba($black, 0.2);\n        position: fixed;\n        top: 0;\n      }\n    }\n\n    .toggle-sidebar {\n      position: relative;\n      right: unset;\n      top: unset;\n      margin-right: 15px;\n    }\n\n    .sidebar-main-title {\n      display: none;\n    }\n\n    .logo-wrapper {\n      display: none;\n    }\n\n    .logo-icon-wrapper {\n      display: block;\n      text-align: center;\n      padding: 24px 30px;\n      box-shadow: -9px 0 20px rgba(89, 102, 122, 0.1);\n    }\n    .page-header {\n      margin-left: 150px;\n      width: calc(100% - 150px);\n\n      .header-wrapper {\n        .logo-wrapper {\n          display: none;\n        }\n        .left-header {\n          width: 30%;\n          @media (max-width: 1578px) and (min-width: 1274px) {\n            width: 38%;\n          }\n          @media (max-width: 1273px) and (min-width: 1200px) {\n            width: 45%;\n          }\n          @media (max-width: 991px) and (min-width: 768px) {\n            width: 36%;\n          }\n          @media (max-width: 767px) and (min-width: 756px) {\n            width: 28%;\n          }\n          h6 {\n            @media (max-width: 1199px) {\n              width: 132px;\n            }\n            @media (max-width: 767px) {\n              width: 83px;\n            }\n          }\n        }\n      }\n\n      &.close_icon {\n        margin-left: 0;\n        width: calc(100% - 0px);\n      }\n    }\n\n    .page-body-wrapper {\n      .page-body {\n        margin-top: 80px;\n        margin-left: 150px;\n      }\n\n      .footer {\n        margin-left: 150px;\n      }\n\n      div.sidebar-wrapper {\n        position: fixed;\n        top: 0;\n        z-index: 9;\n        background-color: $white;\n        > div {\n          height: auto;\n          line-height: inherit;\n          background: $white;\n          width: 150px;\n          text-align: center;\n          transition: 0.3s;\n          box-shadow: 0 0 21px 0 rgba(89, 102, 122, 0.1);\n        }\n\n        .sidebar-main {\n          .left-arrow,\n          .right-arrow {\n            display: none;\n          }\n\n          .sidebar-links {\n            margin: 30px 0;\n            height: calc(100vh - 113px);\n            overflow: auto;\n\n            li {\n              a {\n                color: $dark-color;\n\n                span {\n                  text-transform: capitalize;\n                  color: $dark-color;\n                  font-weight: 500;\n                  letter-spacing: 1px;\n                  font-size: 14px;\n                }\n\n                &.active {\n                  background: rgba($primary-color, 0.1);\n                  color: $primary-color;\n                  border-radius: 20px;\n                  margin: 0 10px;\n                  span {\n                    color: $primary-color;\n                  }\n\n                  ~ .sidebar-submenu,\n                  ~ .mega-menu-container {\n                    animation: fadeInLeft 300ms ease-in-out;\n                  }\n                }\n              }\n\n              .sidebar-title {\n                display: block;\n                padding: 20px 0;\n                border-bottom: 1px solid #f3f3f3;\n              }\n\n              .sidebar-submenu,\n              .mega-menu-container {\n                position: fixed;\n                top: 0px;\n                height: calc(100vh - 0px);\n                overflow: auto;\n                left: 150px;\n                width: 230px;\n                background-color: $white;\n                box-shadow: 0 16px 15px 15px rgba(126, 55, 216, 0.03);\n                transition: all 0.5s ease-in-out;\n                display: none;\n                padding-top: 20px;\n                z-index: -1;\n\n                li {\n                  a {\n                    padding: 15px 15px 15px 40px;\n                    display: block;\n                    position: relative;\n                    border-bottom: 1px solid #f1f1f1;\n\n                    .sub-arrow {\n                      display: none;\n                    }\n\n                    .according-menu {\n                      position: absolute;\n                      right: 20px;\n                      top: 16px;\n                    }\n\n                    &.active {\n                      background-color: rgba($primary-color, 0.1);\n                      color: $primary-color;\n                      transition: all 0.3s ease;\n                    }\n                  }\n\n                  .submenu-content {\n                    li {\n                      a {\n                        &.active {\n                          background-color: $transparent-color;\n                        }\n                      }\n                    }\n                  }\n                }\n\n                > li {\n                  > a {\n                    &::after {\n                      position: absolute;\n                      content: \"\";\n                      left: 20px;\n                      top: 48%;\n                      width: 8px;\n                      border-top: 2px solid rgba($theme-body-sub-title-color, 0.4);\n                    }\n                  }\n                }\n\n                .mega-box {\n                  flex: 0 0 100%;\n                  max-width: 100%;\n                  padding: 0;\n\n                  .link-section {\n                    text-align: left;\n\n                    .submenu-title {\n                      h5 {\n                        position: relative;\n                        font-size: 14px;\n                        font-weight: 400;\n                        padding: 15px 15px 15px 40px;\n                        letter-spacing: 1px;\n                        margin-bottom: 0;\n\n                        &::after {\n                          position: absolute;\n                          content: \"\";\n                          left: 20px;\n                          top: 48%;\n                          width: 6px;\n                          border-top: 2px solid #595c60;\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n              &:hover {\n                .sidebar-submenu {\n                  display: block !important;\n                }\n              }\n            }\n\n            .sidebar-list {\n              position: relative;\n\n              .badge {\n                position: absolute;\n                left: 53%;\n                top: 7px;\n                font-weight: 500;\n                font-size: 9px;\n              }\n\n              .sidebar-link {\n                text-align: center;\n\n                svg {\n                  margin: 0 auto 6px;\n                  width: 24px;\n                  height: 24px;\n                }\n\n                > span {\n                  display: block;\n                  font-weight: 500;\n                  letter-spacing: 1px;\n                  font-size: 14px;\n                  word-break: break-word;\n                }\n\n                .according-menu {\n                  display: none;\n                }\n              }\n            }\n\n            .mega-menu {\n              text-align: center;\n              padding: 0;\n              svg {\n                width: 24px;\n                height: 24px;\n              }\n\n              .according-menu {\n                position: absolute;\n                right: 20px;\n                top: 13px;\n              }\n            }\n          }\n        }\n\n        &[sidebar-layout=\"stroke-svg\"] {\n          .sidebar-links {\n            .mega-menu {\n              svg {\n                &.stroke-icon {\n                  display: block;\n                  margin: 0 auto 6px;\n                }\n                &.fill-icon {\n                  display: none;\n                }\n              }\n            }\n          }\n        }\n        &[sidebar-layout=\"fill-svg\"] {\n          .sidebar-links {\n            .mega-menu {\n              svg {\n                &.stroke-icon {\n                  display: none;\n                }\n                &.fill-icon {\n                  display: block;\n                  margin: 0 auto 6px;\n                }\n              }\n            }\n          }\n        }\n\n        &.close_icon {\n          transform: translateX(-150px);\n\n          ~ .page-body,\n          ~ .footer {\n            margin-left: 0px;\n          }\n        }\n      }\n    }\n  }\n\n  // compact small css\n  &.compact-small {\n    .toggle-sidebar {\n      position: relative;\n      right: unset;\n      top: unset;\n      margin-right: 15px;\n    }\n\n    .sidebar-main-title,\n    .logo-wrapper {\n      display: none;\n    }\n\n    .logo-icon-wrapper {\n      display: block;\n      text-align: center;\n      padding: 27px 30px;\n      box-shadow: -9px 0 20px rgba(89, 102, 122, 0.1);\n    }\n\n    .page-header {\n      margin-left: 90px;\n      width: calc(100% - 90px);\n\n      .header-wrapper {\n        .logo-wrapper {\n          display: none;\n        }\n      }\n\n      &.close_icon {\n        margin-left: 0;\n        width: calc(100% - 0px);\n      }\n    }\n\n    .page-body-wrapper {\n      .page-body {\n        margin-left: 90px;\n      }\n\n      .footer {\n        margin-left: 90px;\n      }\n\n      div.sidebar-wrapper {\n        > div {\n          width: 90px;\n        }\n\n        .sidebar-main {\n          .sidebar-links {\n            @media (max-width: 420px) {\n              height: calc(100vh - 105px);\n            }\n\n            li {\n              .sidebar-title {\n                display: block;\n                padding: 15px 0;\n              }\n\n              .sidebar-submenu,\n              .mega-menu-container {\n                left: 90px;\n\n                li {\n                  a {\n                    padding: 10px 15px 10px 40px;\n\n                    .sub-arrow {\n                      display: none;\n                    }\n\n                    .according-menu {\n                      top: 11px;\n                    }\n                  }\n                }\n              }\n            }\n\n            .sidebar-list {\n              .badge {\n                display: none;\n              }\n\n              .sidebar-link {\n                svg {\n                  margin: 0 auto;\n                  width: 20px;\n                  height: 20px;\n                }\n\n                > span {\n                  display: none;\n                }\n              }\n            }\n\n            .mega-menu {\n              svg {\n                margin: 0 auto;\n              }\n\n              a {\n                > span {\n                  display: none;\n                }\n              }\n            }\n          }\n        }\n\n        &.close_icon {\n          transform: translateX(-150px);\n\n          ~ .page-body,\n          ~ .footer {\n            margin-left: 0px;\n          }\n        }\n      }\n    }\n  }\n\n  // only body css\n  &.only-body {\n    background-color: #f2f0fa;\n    .page-body-wrapper {\n      background-color: #f2f0fa;\n    }\n    .page-header {\n      position: relative;\n      .header-logo-wrapper {\n        display: none;\n      }\n\n      .header-wrapper {\n        padding: 0 !important;\n        .left-header {\n          display: none;\n        }\n        .nav-right {\n          position: absolute;\n          right: 60px;\n          top: 58px;\n        }\n        .search-full {\n          top: 37px;\n          width: calc(100% - 50px);\n          left: 25px;\n          [dir=\"rtl\"] & {\n            left: unset;\n            right: 25px;\n          }\n          .form-group {\n            .Typeahead {\n              .u-posRelative {\n                background-color: $white;\n                border-radius: 15px;\n              }\n            }\n          }\n\n          .Typeahead-menu {\n            top: 78px;\n            width: calc(100% - 30px);\n            margin: 0 auto;\n            right: 0;\n          }\n        }\n      }\n    }\n    .page-body-wrapper {\n      .page-title {\n        padding-top: 20px;\n        padding-bottom: 20px;\n      }\n    }\n    .sidebar-wrapper,\n    footer {\n      display: none;\n    }\n\n    .page-body-wrapper {\n      .page-body {\n        margin-top: 0px;\n        min-height: calc(100vh - 0px);\n      }\n\n      .page-title {\n        padding-left: 30px;\n        padding-right: 30px;\n        margin: 30px 0;\n        border-radius: 15px;\n        @media (max-width: 991.98px) {\n          padding-left: 20px;\n          padding-right: 20px;\n          margin: 20px 0;\n        }\n        > .row {\n          .col-6 {\n            flex: 0 0 100%;\n            max-width: 100%;\n          }\n        }\n\n        .breadcrumb {\n          margin-top: 5px;\n          justify-content: flex-start;\n        }\n      }\n    }\n  }\n\n  // modern css\n  &.modern-type {\n    .progress-chart-wrap {\n      margin-left: -22px;\n      [dir=\"rtl\"] & {\n        margin-left: unset;\n        margin-right: -22px;\n      }\n    }\n    .ecommerce-widget {\n      border: 1px solid lighten($primary-color, 22%) !important;\n    }\n    .file-sidebar .pricing-plan {\n      border: 1px solid lighten($primary-color, 22%) !important;\n    }\n    .alert-primary {\n      color: $primary-color;\n    }\n    .project-box {\n      background-color: lighten($primary-color, 22%);\n    }\n    .nav-tabs .nav-link.active {\n      background-color: transparent;\n    }\n    .simplebar-mask {\n      top: 10px;\n    }\n    .page-header {\n      margin-left: 0px;\n      width: calc(100% - 0px);\n\n      &.close_icon {\n        margin-left: 0px;\n        width: calc(100% - 0px);\n      }\n\n      .header-wrapper {\n        .left-header {\n          width: 30%;\n          @media (max-width: 1428px) and (min-width: 1200px) {\n            width: 37%;\n          }\n          @media (max-width: 818px) {\n            width: 36%;\n          }\n        }\n        .nav-right {\n          @media (max-width: 1669px) {\n            width: 50%;\n          }\n          @media (max-width: 1428px) and (min-width: 1200px) {\n            width: 40%;\n          }\n        }\n        .header-logo-wrapper {\n          display: flex;\n          align-items: center;\n        }\n\n        .logo-wrapper {\n          display: block;\n          margin-right: 30px;\n        }\n\n        .toggle-sidebar {\n          display: block;\n          position: relative;\n          top: unset;\n          right: unset;\n          margin-right: 15px;\n        }\n      }\n    }\n\n    .page-body-wrapper {\n      .page-title {\n        background-color: transparent;\n        padding-bottom: 0;\n      }\n      div.sidebar-wrapper {\n        margin: 30px !important;\n        top: 80px;\n        bottom: 0;\n        border-radius: 15px;\n\n        .logo-wrapper,\n        .logo-icon-wrapper {\n          display: none;\n        }\n\n        .sidebar-main {\n          .sidebar-links {\n            height: calc(100vh - 160px);\n          }\n        }\n\n        &.close_icon {\n          .logo-icon-wrapper {\n            display: none;\n          }\n\n          ~ .page-body {\n            margin-left: 0px;\n          }\n\n          ~ footer {\n            margin-left: 0px;\n            margin-right: 0px;\n          }\n\n          &:hover {\n            .logo-wrapper {\n              display: none;\n            }\n          }\n        }\n      }\n\n      .page-body {\n        margin-left: 296px;\n\n        .container-fluid {\n          max-width: 1500px;\n        }\n      }\n      .footer {\n        margin-left: 360px;\n        margin-right: 70px;\n        border-radius: 10px;\n        @media (max-width: 991px) {\n          margin-right: 0;\n          margin-left: 0;\n        }\n      }\n    }\n  }\n\n  // material css\n  &.material-type {\n    position: relative;\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      left: 0;\n      top: -50px;\n      width: 100%;\n      height: 300px;\n      background-image: $gradient-bg-primary;\n    }\n\n    .card {\n      box-shadow: 0 0 20px rgba($black, 0.05);\n    }\n\n    .page-header {\n      position: relative;\n      max-width: 1560px;\n      margin: 50px auto 0;\n      border-radius: 15px 15px 0 0;\n      .header-wrapper {\n        .left-header {\n          width: 31%;\n          @media (max-width: 1600px) {\n            width: 33%;\n          }\n          @media (max-width: 1366px) {\n            width: 38%;\n          }\n          @media (max-width: 1199px) {\n            width: 30%;\n          }\n        }\n        .nav-right {\n          @media (max-width: 1600px) {\n            width: 40%;\n          }\n          @media (max-width: 1199px) {\n            width: 45%;\n          }\n        }\n      }\n    }\n\n    .page-body-wrapper {\n      background-image: url(../../images/other-images/boxbg.jpg);\n      background-blend-mode: overlay;\n      background-color: rgba($white, 0.5);\n\n      .sidebar-wrapper {\n        position: relative;\n        max-width: 1560px;\n        margin: 0 auto;\n        top: unset;\n        height: 56px;\n      }\n\n      .page-body {\n        margin: 0 auto;\n        max-width: 1560px;\n        background-color: $body-color;\n        box-shadow: 0 0 20px 7px rgba(8, 21, 66, 0.05);\n        border-radius: 0 0 15px 15px;\n      }\n    }\n\n    .footer {\n      margin-top: 40px;\n    }\n    &.compact-wrapper {\n      .page-header {\n        .header-wrapper {\n          .left-header {\n            width: 38%;\n          }\n          .nav-right {\n            @media (max-width: 991px) {\n              width: 50%;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  &.advance-layout {\n    background-blend-mode: overlay;\n    background-color: $main-body-color;\n    .card {\n      border-radius: 5px;\n      box-shadow: none;\n      border: 1px solid #ecf3fa;\n    }\n\n    .page-header {\n      position: relative;\n      background-color: $white;\n      margin: 0 auto;\n    }\n\n    .page-body-wrapper {\n      background: transparent;\n\n      .sidebar-wrapper {\n        position: relative !important;\n        top: unset !important;\n        height: unset;\n        box-shadow: none;\n        border-top: 1px solid #efefef;\n        border-bottom: 1px solid #efefef;\n        > div {\n          overflow-x: hidden;\n        }\n      }\n\n      .page-body {\n        margin-top: 0 !important;\n      }\n    }\n  }\n}\n\n@keyframes pagebody {\n  from {\n    opacity: 0;\n    transform: scale3d(0.98, 0.98, 0.98) translate(-20px, -50px);\n  }\n\n  50% {\n    opacity: 1;\n  }\n}\n\n// sidebar filter\n.md-sidebar {\n  position: relative;\n  .md-sidebar-toggle {\n    display: none;\n    width: fit-content;\n    text-transform: capitalize;\n    margin-bottom: 20px;\n  }\n}\n\n// Responsive menu css start //\n// @media screen and (max-width: 1780px) {\n//   .page-wrapper {\n//     &.horizontal-wrapper {\n//       .page-body-wrapper {\n//         .sidebar-wrapper {\n//           .sidebar-main {\n//             .sidebar-links {\n//               .simplebar-wrapper {\n//                 .simplebar-mask {\n//                   .simplebar-content-wrapper {\n//                     .simplebar-content {\n//                        >li {\n//                          .mega-menu-container {\n\n//                            right: -18%;\n//                            width: 91%;\n//                          }\n//                        }\n//                     }\n//                   }\n//                 }\n//               }\n\n//             }\n//           }\n//         }\n//       }\n//     }\n//   }\n// }\n\n@media screen and (max-width: 1480px) {\n  .page-wrapper {\n    &.horizontal-wrapper {\n      .page-body-wrapper {\n        .sidebar-wrapper {\n          .sidebar-main {\n            .sidebar-links {\n              > li {\n                .mega-menu-container {\n                  right: -18%;\n                  width: 91%;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 1460px) {\n  .page-wrapper {\n    &.horizontal-wrapper {\n      .page-body-wrapper {\n        &.sidebar-wrapper {\n          .sidebar-main {\n            .sidebar-links {\n              > li {\n                .mega-menu-container {\n                  right: -54%;\n                  width: 75%;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .sidebar-wrapper {\n    .sidebar-main {\n      .sidebar-links {\n        > li {\n          margin-right: 8px;\n        }\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 1366px) {\n  .page-wrapper {\n    &.horizontal-wrapper {\n      .page-body-wrapper {\n        &.sidebar-wrapper {\n          .sidebar-main {\n            .sidebar-links {\n              > li {\n                .mega-menu-container {\n                  right: -49%;\n                  width: 70%;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .profile-dropdown {\n    &.onhover-show-div {\n      right: 0;\n      left: unset !important;\n\n      &:before,\n      &:after {\n        right: 10px !important;\n        left: unset !important;\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 1199px) {\n  .page-wrapper {\n    .page-header {\n      .header-wrapper {\n        .nav-right {\n          > ul {\n            > li {\n              padding: 6px;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .mobile-title {\n    &.d-none {\n      display: flex !important;\n      justify-content: space-between;\n      padding: 20px 30px 17px;\n      border-bottom: 1px solid #ddd;\n      margin: 0 -15px;\n\n      h5 {\n        color: var(--theme-default);\n      }\n\n      svg {\n        stroke: var(--theme-default) !important;\n      }\n    }\n  }\n\n  .page-wrapper {\n    &.horizontal-wrapper {\n      .page-body-wrapper {\n        &.sidebar-wrapper {\n          .sidebar-main {\n            .sidebar-links {\n              > li {\n                .mega-menu-container {\n                  right: -35%;\n                  width: 56%;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media screen and (min-width: 992px) {\n  .page-header {\n    .header-wrapper {\n      .nav-right {\n        .notification-dropdown {\n          top: 46px;\n        }\n      }\n    }\n  }\n\n  .responsive-btn {\n    display: none;\n  }\n\n  .page-wrapper {\n    &.horizontal-wrapper {\n      .page-body-wrapper {\n        .sidebar-main {\n          .sidebar-links {\n            .simplebar-mask {\n              top: 0;\n            }\n\n            > li {\n              .sidebar-submenu {\n                width: 200px;\n                opacity: 0;\n                visibility: hidden;\n                border-radius: 5px;\n                transition: all 0.5s ease;\n\n                a {\n                  .sub-arrow {\n                    position: absolute;\n                    right: 20px;\n                    top: 5px;\n                    color: $light-semi-font;\n                    font-weight: 100;\n                    transition: all 0.5s ease;\n                    font-size: 15px;\n                    top: 5px;\n                  }\n                }\n\n                li {\n                  .nav-sub-childmenu {\n                    display: none;\n                    border-radius: 4px;\n                  }\n\n                  &:hover {\n                    .nav-sub-childmenu {\n                      display: block !important;\n                      position: absolute;\n                      left: 200px;\n                      background-color: $white;\n                      top: -10px;\n                      padding: 15px 0px 15px 0px;\n                      box-shadow: 0 0 1px 0 #898989;\n                    }\n                  }\n\n                  a {\n                    &:hover {\n                      .sub-arrow {\n                        right: 16px;\n                        transition: all 0.5s ease;\n                      }\n                    }\n                  }\n                }\n              }\n\n              .mega-menu-container {\n                opacity: 0;\n                visibility: hidden;\n                transition: all 0.5s ease;\n              }\n\n              &.hoverd {\n                .sidebar-submenu {\n                  opacity: 1;\n                  visibility: visible;\n                  margin-top: 8px;\n                  transition: all 0.5s ease;\n                }\n              }\n              &:hover {\n                .mega-menu-container {\n                  opacity: 1;\n                  visibility: visible;\n                  margin-top: 20px;\n                  transition: all 0.5s ease;\n                }\n              }\n            }\n          }\n        }\n\n        .toggle-nav {\n          display: none;\n        }\n\n        .mobile-back {\n          display: none !important;\n        }\n      }\n    }\n  }\n}\n\n@media only screen and (min-width: 768px) {\n  // material icon css\n  .page-wrapper {\n    &.material-icon {\n      position: relative;\n\n      &::before {\n        position: absolute;\n        content: \"\";\n        left: 0;\n        width: 100%;\n        height: 200px;\n        background: $gradient-bg-primary;\n      }\n      .toggle-sidebar {\n        color: rgba($white, 0.8);\n\n        &:hover {\n          > svg {\n            color: $white !important;\n            stroke: $white !important;\n          }\n        }\n      }\n\n      .page-header {\n        position: relative;\n        background: transparent;\n        padding-left: 90px;\n        max-width: 1660px;\n        margin: 0 auto;\n        width: calc(100% - 0px);\n        box-shadow: none;\n        .f-light {\n          color: $white;\n        }\n\n        .header-wrapper {\n          .nav-right {\n            ul {\n              li {\n                svg {\n                  stroke: $white;\n                }\n                .profile-dropdown {\n                  li {\n                    svg {\n                      stroke: $theme-body-font-color;\n                    }\n                  }\n                }\n              }\n            }\n            > ul {\n              > li {\n                color: $white;\n\n                .notification-box,\n                .cart-box {\n                  svg {\n                    stroke: $white;\n                  }\n                }\n\n                > a {\n                  > svg {\n                    stroke: $white;\n                  }\n                }\n\n                > svg {\n                  stroke: $white;\n                }\n              }\n            }\n\n            .language-nav {\n              .more_lang {\n                color: $theme-body-font-color;\n              }\n            }\n\n            .onhover-show-div {\n              color: $theme-body-font-color;\n            }\n\n            &.right-header {\n              ul {\n                li {\n                  .profile-media {\n                    .media-body {\n                      p {\n                        color: rgba($white, 0.7);\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n\n        &.close_icon {\n          padding-left: 0;\n          margin: 0 auto !important;\n        }\n      }\n\n      .page-body-wrapper {\n        .page-body {\n          margin-top: 0 !important;\n          padding-left: 90px;\n          max-width: 1660px;\n          margin: 0 auto;\n        }\n\n        div.sidebar-wrapper {\n          &.close_icon {\n            ~ .page-body {\n              padding-left: 15px;\n              margin: 0 auto !important;\n            }\n          }\n        }\n\n        .page-title {\n          color: $white;\n          background-color: transparent;\n          border-bottom: none;\n          box-shadow: none;\n          .breadcrumb {\n            .breadcrumb-item {\n              a {\n                svg {\n                  stroke: $white;\n                }\n              }\n\n              &.active {\n                color: rgba($white, 0.6);\n              }\n\n              + .breadcrumb-item {\n                &::before {\n                  color: rgba($white, 0.8);\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media only screen and (min-width: 992px) {\n  // material icon css\n  .page-wrapper {\n    &.material-icon {\n      &::before {\n        height: 240px;\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .sidebar-wrapper {\n    .menu {\n      .brand-logo {\n        img {\n          width: 120px;\n        }\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 576px) {\n  .toggle-nav {\n    i {\n      font-size: 20px;\n    }\n  }\n}\n\n.page-wrapper {\n  &[sidebar-layout=\"stroke-svg\"] {\n    .sidebar-wrapper,\n    .page-header {\n      .stroke-icon {\n        display: inline-block;\n      }\n      .fill-icon {\n        display: none;\n      }\n    }\n  }\n  &[sidebar-layout=\"fill-svg\"] {\n    .sidebar-wrapper,\n    .page-header {\n      .stroke-icon {\n        display: none;\n      }\n      .fill-icon {\n        display: inline-block;\n      }\n    }\n  }\n}\n\n/**=====================\n    78. Sidebar CSS Ends\n==========================**/\n","/**=====================\n    60. RTL CSS Start\n==========================**/\n\nhtml[dir=\"rtl\"] {\n  ul {\n    padding-right: 0;\n  }\n  .location-checkbox span {\n    padding-left: 0;\n    padding-right: 33px;\n  }\n  .border-end {\n    border-left: 1px solid var(--chart-border) !important;\n    border-right: initial !important;\n  }\n  .follow .text-md-end {\n    text-align: left !important;\n  }\n  .ms-auto {\n    margin-left: unset !important;\n    margin-right: auto !important;\n  }\n  .f-right {\n    float: left;\n  }\n  .papernote-wrap {\n    .note-labels {\n      ul {\n        gap: 9px;\n      }\n    }\n  }\n  .form-check-inline {\n    margin-right: unset;\n    margin-left: 1rem;\n  }\n  .color-box {\n    button {\n      + button {\n        margin-left: unset;\n        margin-right: 5px;\n      }\n    }\n  }\n  .knowledgebase-search {\n    .form-inline {\n      svg {\n        left: unset;\n        right: 20px;\n      }\n    }\n  }\n  .switch-showcase {\n    .form-check {\n      .form-check-input {\n        float: left;\n      }\n    }\n  }\n  .pill-input-group span {\n    &:last-child {\n      border-top-right-radius: unset !important;\n      border-bottom-right-radius: unset !important;\n      border-top-left-radius: 1.3rem !important;\n      border-bottom-left-radius: 1.3rem !important;\n    }\n\n    &:first-child {\n      border-top-left-radius: unset !important;\n      border-top-right-radius: unset !important;\n      border-top-right-radius: 1.3rem !important;\n      border-bottom-right-radius: 1.3rem !important;\n    }\n  }\n  .page-wrapper {\n    &.compact-wrapper {\n      .page-body-wrapper {\n        .sidebar-wrapper {\n          text-align: right;\n\n          .toggle-sidebar {\n            right: unset;\n            left: 30px;\n          }\n\n          .sidebar-main .sidebar-links {\n            padding: 0;\n\n            > li .badge {\n              left: 50px !important;\n              right: unset !important;\n            }\n          }\n\n          &.close_icon {\n            margin-right: 0;\n            margin-left: unset;\n            .logo-icon-wrapper {\n              text-align: left;\n              img {\n                margin-left: 8px;\n              }\n            }\n            ~ .page-body,\n            ~ footer {\n              margin-left: 0;\n              margin-right: 100px;\n              transition: 0.5s;\n            }\n\n            .sidebar-main {\n              .sidebar-links {\n                > li {\n                  a {\n                    svg {\n                      margin-left: 0;\n                    }\n                  }\n                }\n                .sidebar-list {\n                  .sidebar-title {\n                    &.active {\n                      ~ .sidebar-submenu {\n                        display: none !important;\n                      }\n                    }\n                  }\n                }\n              }\n            }\n\n            .according-menu {\n              display: none;\n            }\n\n            &:hover {\n              .sidebar-main {\n                .sidebar-links {\n                  > li {\n                    a {\n                      svg {\n                        margin-left: 13px;\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n\n          &:hover {\n            transform: translate(0px);\n\n            .sidebar-main {\n              .sidebar-links {\n                .sidebar-list {\n                  .sidebar-title {\n                    &.active {\n                      ~ .sidebar-submenu {\n                        display: block !important;\n                      }\n                    }\n                  }\n                }\n\n                > li {\n                  a {\n                    svg {\n                      float: none;\n                    }\n                  }\n                }\n              }\n            }\n\n            .according-menu {\n              display: block;\n            }\n          }\n\n          .sidebar-main {\n            .sidebar-links {\n              > li {\n                .sidebar-submenu {\n                  &:after {\n                    right: 30px;\n                    left: unset;\n                  }\n\n                  > li {\n                    a {\n                      padding-right: 45px !important;\n                      padding-left: unset !important;\n\n                      &:after {\n                        right: 26px;\n                        left: unset;\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n\n        .page-body {\n          margin-left: unset;\n          margin-right: 265px;\n        }\n\n        .sidebar-wrapper {\n          .sidebar-main {\n            .sidebar-links {\n              > li {\n                a {\n                  svg {\n                    margin-right: unset;\n                    margin-left: 15px;\n                  }\n                }\n              }\n            }\n          }\n        }\n\n        .according-menu {\n          right: unset;\n          left: 20px;\n        }\n      }\n    }\n    &.only-body {\n      .page-header {\n        .header-wrapper {\n          .nav-right {\n            right: unset;\n            left: 30px;\n          }\n        }\n      }\n    }\n  }\n  // task page css\n  .date-details {\n    > div {\n      + div {\n        margin-left: unset;\n        margin-right: 10px;\n      }\n    }\n  }\n  // contact page css\n  .contact-editform {\n    &.ps-0 {\n      padding-left: 20px !important;\n    }\n  }\n  .contact-options {\n    li {\n      .btn-category {\n        padding-left: unset !important;\n        padding-right: 40px;\n      }\n    }\n  }\n  .list-persons {\n    .profile-mail {\n      .email-general {\n        ul {\n          padding-right: unset;\n          padding-left: 20px;\n          li {\n            > span {\n              float: left;\n            }\n          }\n        }\n      }\n      .media {\n        .media-body {\n          ul {\n            li {\n              + li {\n                padding-left: unset;\n                padding-right: 10px;\n                margin-left: unset;\n                margin-right: 5px;\n                border-left: unset;\n                border-right: 1px solid $light-color;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  // file manager css\n  .file-content {\n    .form-inline {\n      i {\n        padding-right: unset;\n        padding-left: 10px;\n      }\n    }\n  }\n  .file-sidebar {\n    .btn {\n      svg {\n        margin-right: unset;\n        margin-left: 8px;\n      }\n    }\n  }\n  // projects page css\n  .form-select {\n    background-position: left 0.75rem center;\n  }\n  .customers {\n    ul {\n      li {\n        + li {\n          margin-left: unset;\n          margin-right: -10%;\n        }\n      }\n    }\n  }\n  .project-list {\n    .border-tab {\n      &.nav-tabs {\n        .nav-item {\n          .nav-link {\n            padding: 5px 0 5px 30px;\n          }\n        }\n      }\n    }\n  }\n  .project-box {\n    .badge {\n      right: unset;\n      left: 30px;\n    }\n  }\n  // kanban board css\n  .kanban-board {\n    float: right;\n  }\n\n  .kanban-item {\n    .kanban-box {\n      .customers {\n        ul {\n          li {\n            + li {\n              margin-left: unset;\n              margin-right: -10px;\n            }\n          }\n        }\n      }\n    }\n    .list {\n      li {\n        i {\n          margin-right: unset;\n          margin-left: 10px;\n        }\n      }\n    }\n  }\n  //horizontal-sidebar\n  .page-wrapper {\n    &.horizontal-wrapper {\n      .header-logo-wrapper {\n        text-align: right;\n      }\n      .page-body-wrapper {\n        .page-body {\n          margin-right: 0;\n        }\n        footer {\n          margin-right: 0;\n        }\n      }\n    }\n    &.material-type {\n      .page-body-wrapper {\n        .page-body {\n          margin-right: auto;\n        }\n      }\n    }\n  }\n  .page-header {\n    .header-wrapper {\n      .nav-right {\n        > ul {\n          > li {\n            &:first-child {\n              margin-right: 0;\n            }\n          }\n        }\n        &.right-header {\n          ul {\n            li {\n              .profile-media {\n                .media-body {\n                  margin-right: 15px;\n                  margin-left: unset;\n                }\n              }\n            }\n          }\n        }\n      }\n      .toggle-sidebar {\n        margin-left: 2px;\n        margin-right: unset;\n      }\n    }\n  }\n  // compact icon css\n  .page-wrapper {\n    .page-header {\n      .header-wrapper {\n        .nav-right {\n          .notification-dropdown {\n            left: -20px !important;\n            right: unset !important;\n            @media (max-width: 575.98px) {\n              left: 12px !important;\n            }\n          }\n        }\n        .search-full {\n          input {\n            padding-left: unset;\n            padding-right: 60px;\n            text-align: right;\n          }\n          .form-group {\n            &:before {\n              left: unset;\n              right: 30px;\n            }\n            .close-search {\n              right: unset;\n              left: 0;\n            }\n          }\n        }\n      }\n    }\n    &.compact-sidebar {\n      .toggle-sidebar {\n        margin-left: 15px;\n        margin-right: unset;\n      }\n\n      .page-header {\n        margin-left: unset;\n        margin-right: 150px;\n\n        &.close_icon {\n          margin-right: 0;\n        }\n      }\n\n      .page-body-wrapper {\n        .page-body {\n          margin-left: unset;\n          margin-right: 150px;\n        }\n\n        .footer {\n          margin-left: unset;\n          margin-right: 150px;\n        }\n\n        div.sidebar-wrapper {\n          > div {\n            text-align: right;\n          }\n\n          .sidebar-main {\n            .sidebar-links {\n              li {\n                a {\n                  &.active {\n                    ~ .sidebar-submenu,\n                    ~ .mega-menu-container {\n                      animation: fadeInRight 1000ms ease-in-out;\n                    }\n                  }\n                }\n\n                .sidebar-submenu,\n                .mega-menu-container {\n                  right: 150px;\n                  left: unset;\n\n                  li {\n                    a {\n                      padding: 15px 40px 15px 15px;\n\n                      .according-menu {\n                        right: 20px;\n                      }\n                    }\n                  }\n\n                  > li {\n                    > a {\n                      &::after {\n                        left: unset;\n                        right: 20px;\n                      }\n                    }\n                  }\n\n                  .mega-box {\n                    .link-section {\n                      text-align: right;\n\n                      .submenu-title {\n                        h5 {\n                          padding: 15px 40px 15px 15px;\n\n                          &::after {\n                            left: unset;\n                            right: 20px;\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n\n              .sidebar-list {\n                .badge {\n                  left: unset;\n                  right: 53%;\n                }\n\n                .sidebar-link {\n                  text-align: center;\n                }\n              }\n\n              .mega-menu {\n                text-align: center;\n\n                .according-menu {\n                  right: unset;\n                  left: 20px;\n                }\n              }\n            }\n          }\n\n          &.close_icon {\n            transform: translateX(150px);\n\n            ~ .page-body,\n            ~ .footer {\n              margin-right: 0px;\n            }\n          }\n        }\n      }\n    }\n    &.compact-small {\n      .page-header {\n        margin-right: 90px;\n      }\n      .page-body-wrapper {\n        div.sidebar-wrapper {\n          .sidebar-main {\n            .sidebar-links {\n              li {\n                .sidebar-submenu,\n                .mega-menu-container {\n                  right: 90px;\n                }\n              }\n            }\n          }\n        }\n        .footer,\n        .page-body {\n          margin-right: 90px;\n        }\n      }\n    }\n    &.material-icon {\n      .page-header {\n        padding-left: unset;\n        padding-right: 90px;\n        margin: 0 auto;\n        &.close_icon {\n          padding-right: 0;\n        }\n      }\n      .page-body-wrapper {\n        .page-body {\n          padding-left: 15px;\n          padding-right: 90px;\n          margin: 0 auto;\n        }\n        div.sidebar-wrapper {\n          &.close_icon {\n            ~ .page-body {\n              padding-right: 15px;\n              margin: 0 auto !important;\n            }\n          }\n        }\n      }\n    }\n  }\n  .apexcharts-canvas {\n    direction: ltr;\n  }\n  // bookmark app css\n  .email-wrap {\n    .btn-mail {\n      text-align: right;\n    }\n    .email-app-sidebar {\n      ul {\n        li {\n          a {\n            padding-left: unset;\n            padding-right: 20px;\n          }\n        }\n      }\n    }\n  }\n  .bookmark-tabcontent {\n    .details-bookmark {\n      .bookmark-card {\n        &.card {\n          .favourite-icon {\n            text-align: center;\n          }\n          .title-bookmark {\n            text-align: right;\n          }\n        }\n      }\n    }\n  }\n  .bookmark-wrap {\n    .details-bookmark {\n      .row {\n        > div {\n          + div {\n            padding-left: 15px !important;\n          }\n        }\n      }\n    }\n  }\n  // index page css start\n  .appointment-table {\n    table {\n      tr {\n        td {\n          .status-circle {\n            left: unset;\n            right: 35px;\n          }\n        }\n      }\n    }\n  }\n  .notification {\n    .card {\n      .d-flex {\n        .w-100 {\n          p {\n            .badge {\n              margin-left: unset;\n              margin-right: 10px;\n            }\n          }\n        }\n      }\n    }\n  }\n  // index page css end\n  @each $progress-gradient-name, $progress-gradient-color in (primary, var(--theme-default)), (secondary, $secondary-color), (success, $success-color), (danger, $danger-color), (info, $info-color), (light, $light-color), (dark, $dark-color), (warning, $warning-color) {\n    .progress-gradient-#{$progress-gradient-name} {\n      background-image: linear-gradient(to right, $progress-gradient-color, $transparent-color);\n      &::after {\n        right: unset;\n        left: -1px;\n      }\n      .animate-circle {\n        right: unset;\n        left: -8px;\n      }\n    }\n  }\n  .progress-animate {\n    span {\n      left: -10px;\n      right: unset;\n    }\n  }\n  // ecommerce dashboard css end\n  .me-4 {\n    margin-left: 1.5rem !important;\n    margin-right: unset !important;\n  }\n  .pe-4 {\n    padding-left: 1.5rem !important;\n    padding-right: unset !important;\n  }\n  .me-1 {\n    margin-left: 0.25rem !important;\n    margin-right: unset !important;\n  }\n  .navs-dropdown {\n    .onhover-show-div {\n      right: 0;\n    }\n  }\n  .default-according {\n    &.style-1 {\n      button {\n        text-align: right;\n        &:before {\n          left: 20px;\n          right: unset;\n          @media (max-width: 575px) {\n            left: 15px;\n          }\n        }\n        i {\n          right: 18px;\n          left: unset;\n        }\n      }\n    }\n    .card {\n      .card-header {\n        i {\n          right: 18px;\n          left: unset;\n        }\n      }\n    }\n  }\n  .faq-wrap {\n    .faq-accordion {\n      .card {\n        .card-header {\n          .btn-link {\n            padding-right: 20px !important;\n            @media (max-width: 575.98px) {\n              padding-right: 10px !important;\n            }\n          }\n        }\n      }\n    }\n  }\n  .ProfileCard-details {\n    padding-right: 30px;\n    padding-left: unset;\n    float: right;\n  }\n  .starter-main {\n    .card-body {\n      ul {\n        padding-right: 30px;\n        padding-left: unset;\n      }\n    }\n  }\n  .theme-tab {\n    .tab-title {\n      li {\n        a {\n          svg {\n            margin-left: 5px;\n            margin-right: unset;\n          }\n        }\n      }\n    }\n  }\n  .spent {\n    .spent-graph {\n      .project-budget {\n        margin-left: 30px;\n        margin-right: unset;\n      }\n    }\n  }\n  .support-table {\n    table {\n      tbody {\n        tr {\n          td {\n            &:first-child {\n              padding-right: 0;\n              padding-left: unset;\n            }\n          }\n        }\n      }\n    }\n  }\n  .order-box {\n    .sub-total,\n    .total,\n    .qty {\n      .shipping-class,\n      li {\n        .shopping-checkout-option,\n        span {\n          float: left;\n        }\n      }\n      li {\n        .count {\n          float: left;\n        }\n      }\n    }\n  }\n  .img-paypal {\n    margin-right: 15px;\n    margin-left: unset;\n  }\n  .cart {\n    .qty-box {\n      .input-group {\n        .btn {\n          border-radius: 0 !important;\n        }\n      }\n    }\n  }\n  .product-qnty {\n    fieldset {\n      .input-group {\n        .input-group-prepend {\n          .btn {\n            border-top-right-radius: 0;\n            border-bottom-right-radius: 0;\n          }\n        }\n      }\n    }\n  }\n  .grid-options {\n    margin-right: 10px;\n    margin-left: unset;\n    ul {\n      li {\n        a {\n          .line-grid-1 {\n            right: 12px;\n            left: unset;\n          }\n          .line-grid-2 {\n            right: 18px;\n            left: unset;\n          }\n          .line-grid-3 {\n            right: 36px;\n            left: unset;\n          }\n          .line-grid-4 {\n            right: 42px;\n            left: unset;\n          }\n          .line-grid-5 {\n            right: 48px;\n            left: unset;\n          }\n          .line-grid-6 {\n            right: 66px;\n            left: unset;\n          }\n          .line-grid-7 {\n            right: 72px;\n            left: unset;\n          }\n          .line-grid-8 {\n            right: 78px;\n            left: unset;\n          }\n          .line-grid-9 {\n            right: 84px;\n            left: unset;\n          }\n          .line-grid-10 {\n            right: 103px;\n            left: unset;\n          }\n          .line-grid-11 {\n            right: 109px;\n            left: unset;\n          }\n          .line-grid-12 {\n            right: 115px;\n            left: unset;\n          }\n          .line-grid-13 {\n            right: 121px;\n            left: unset;\n          }\n          .line-grid-14 {\n            right: 127px;\n            left: unset;\n          }\n          .line-grid-15 {\n            right: 133px;\n            left: unset;\n          }\n        }\n      }\n    }\n  }\n  .product-filter {\n    &.new-products {\n      .owl-theme {\n        .owl-nav {\n          left: 0;\n          right: unset;\n        }\n        .owl-item {\n          .item {\n            .product-box {\n              .product-details {\n                &.text-start {\n                  text-align: left !important;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  .product-sidebar {\n    .filter-section {\n      .card {\n        .card-header {\n          h6 {\n            .pull-right {\n              i {\n                left: auto;\n                right: unset;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  .prooduct-details-box {\n    .btn {\n      right: unset;\n      left: 15px;\n    }\n    .close {\n      right: unset;\n      left: 10px;\n    }\n  }\n  .collection-filter-block {\n    svg {\n      margin-right: unset;\n      margin-left: 10px;\n    }\n  }\n  .feature-products {\n    form {\n      .form-group {\n        i {\n          left: 30px;\n          right: unset;\n        }\n      }\n    }\n  }\n  .product-wrapper-grid {\n    &.list-view {\n      .product-box {\n        .product-details {\n          text-align: right;\n        }\n      }\n    }\n  }\n  .page-wrapper {\n    .page-body-wrapper {\n      .page-title {\n        .breadcrumb {\n          margin-left: unset;\n        }\n      }\n    }\n  }\n  .bookmark {\n    ul {\n      li {\n        + li {\n          margin-left: unset;\n          margin-right: 10px;\n        }\n        .search-form {\n          .form-control-search {\n            left: -50px;\n            right: unset;\n            &:before {\n              right: 50px;\n              left: unset;\n            }\n            &:after {\n              right: 20px;\n              left: unset;\n            }\n          }\n        }\n      }\n    }\n  }\n  .me-0 {\n    margin-left: 0 !important;\n    margin-right: unset !important;\n  }\n  .footer {\n    .pull-right {\n      float: none;\n    }\n  }\n  .checkbox_animated,\n  .radio_animated {\n    margin: 0 8px 0 16px;\n  }\n  .button.remove {\n    left: -10px;\n    right: unset;\n  }\n  .code-box-copy__btn {\n    left: 11px;\n    right: unset;\n  }\n  ul {\n    &.nav-menus {\n      border-bottom: none;\n    }\n    &.notification-dropdown {\n      &.onhover-show-div {\n        li {\n          text-align: right;\n        }\n      }\n    }\n  }\n  .badge {\n    + .badge {\n      margin-right: 5px;\n      margin-left: unset;\n    }\n  }\n  .offset-xl-3 {\n    margin-right: 25%;\n    margin-left: unset;\n  }\n  .m-l-10 {\n    margin-right: 10px !important;\n    margin-left: unset !important;\n  }\n  .m-r-20 {\n    margin-left: 20px;\n    margin-right: unset;\n  }\n  .m-r-30 {\n    margin-left: 30px;\n    margin-right: unset;\n  }\n  .m-r-5 {\n    margin-left: 5px;\n    margin-right: unset;\n  }\n  .text-start {\n    text-align: right !important;\n  }\n  .m-r-10 {\n    margin-left: 10px;\n    margin-right: unset;\n  }\n  .pe-3 {\n    padding-left: 1rem !important;\n    padding-right: unset !important;\n  }\n  .p-r-0 {\n    padding-left: 0;\n    padding-right: 15px;\n  }\n  .m-l-20 {\n    margin-right: 20px !important;\n    margin-left: unset !important;\n  }\n  .ps-3 {\n    padding-right: 1rem !important;\n  }\n  .b-r-light {\n    border-left: 1px solid $light-color !important;\n    border-right: unset !important;\n  }\n  .float-end {\n    float: left !important;\n  }\n  .float-start {\n    float: right !important;\n  }\n  .text-end {\n    text-align: left !important;\n  }\n  .border-right {\n    border-left: 1px solid #dee2e6 !important;\n    border-right: unset !important;\n  }\n  .pe-0 {\n    padding-left: 0 !important;\n    padding-right: 12px !important;\n  }\n  .ps-0 {\n    padding-right: 0 !important;\n    padding-left: unset !important;\n  }\n  .ms-1 {\n    margin-left: unset !important;\n    margin-right: 0.25rem !important;\n  }\n  .owl-carousel {\n    direction: ltr;\n  }\n  .btn-group {\n    > {\n      .btn:not(:last-child):not(.dropdown-toggle),\n      :not(:last-child) > .btn {\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0;\n        border-top-right-radius: 0.25rem;\n        border-bottom-right-radius: 0.25rem;\n      }\n      .btn:not(:first-child) {\n        border-top-left-radius: 0.25rem;\n        border-bottom-left-radius: 0.25rem;\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n      }\n      .btn:nth-child(2) {\n        border-radius: 0 !important;\n      }\n    }\n\n    .btn-group > :not(:first-child) > .btn {\n      border-top-left-radius: 0.25rem;\n      border-bottom-left-radius: 0.25rem;\n      border-top-right-radius: 0;\n      border-bottom-right-radius: 0;\n    }\n    .btn + {\n      .btn,\n      .btn-group {\n        margin-right: -1px;\n        border-right: none;\n      }\n    }\n    .btn-group + {\n      .btn,\n      .btn-group {\n        margin-right: -1px;\n      }\n    }\n    .btn-group-vertical {\n      .btn + {\n        .btn,\n        .btn-group {\n          margin-right: -1px;\n        }\n      }\n      .btn-group + {\n        .btn,\n        .btn-group {\n          margin-right: -1px;\n        }\n      }\n    }\n  }\n  .me-3 {\n    margin-right: unset !important;\n    margin-left: 1rem !important;\n  }\n  .me-5 {\n    margin-left: 3rem !important;\n    margin-right: unset !important;\n  }\n  .ms-3 {\n    margin-right: 1rem !important;\n    margin-left: unset !important;\n  }\n  .m-r-15 {\n    margin-left: 15px;\n    margin-right: unset;\n  }\n  .b-l-light {\n    border-right: 1px solid $light-color !important;\n    border-left: unset !important;\n  }\n  .p-l-0 {\n    padding-left: unset;\n    padding-right: 0px;\n  }\n  .ps-4 {\n    padding-right: 1.5rem !important;\n    padding-left: unset !important;\n  }\n  .me-2 {\n    margin-left: 0.5rem !important;\n    margin-right: unset !important;\n  }\n  .ms-2 {\n    margin-right: 0.5rem !important;\n    margin-left: unset !important;\n  }\n  .pe-2 {\n    padding-right: unset !important;\n    padding-left: 0.5rem !important;\n  }\n  .prooduct-details-box {\n    .media-body {\n      margin-right: 0 !important;\n    }\n  }\n  .alert {\n    text-align: right;\n  }\n  .pull-right {\n    float: left;\n  }\n  .form-inline {\n    .form-group {\n      margin-left: 15px;\n      margin-right: 0;\n    }\n  }\n  .card {\n    text-align: right;\n    &.social-profile {\n      text-align: center;\n    }\n    .card-header {\n      h5:not(.mb-0) {\n        float: right;\n      }\n      span {\n        clear: both;\n      }\n      .card-header-right {\n        left: 35px;\n        right: unset;\n        .card-option {\n          text-align: left;\n          &.list-unstyled {\n            padding-right: 0;\n            padding-left: unset;\n          }\n        }\n      }\n      .pull-left {\n        float: right;\n      }\n    }\n    &.full-card {\n      left: 0;\n      right: unset;\n    }\n    .card-body {\n      .alert {\n        svg {\n          margin-left: 4px;\n          margin-right: unset;\n        }\n      }\n      .value-left {\n        margin-left: 30px;\n        margin-right: unset;\n      }\n      .square {\n        margin-left: 5px;\n        margin-right: unset;\n      }\n    }\n  }\n  .balance-box {\n    text-align: center;\n  }\n  .purchase-card {\n    text-align: center;\n  }\n  .modal-header {\n    .btn-close {\n      margin: -0.5rem auto -0.5rem -0.5rem;\n    }\n  }\n  .modal-footer {\n    > :not(:first-child) {\n      margin-right: 0.5rem;\n      margin-left: 0;\n    }\n  }\n  .form-inline {\n    .form-group {\n      .col-form-label {\n        margin-left: 5px;\n        margin-right: 0;\n      }\n    }\n  }\n  .breadcrumb-item {\n    & + .breadcrumb-item {\n      padding-right: 0.5rem;\n      padding-left: unset;\n      &::before {\n        padding-left: 0.5rem;\n        padding-right: unset;\n        float: right;\n      }\n    }\n  }\n  code[class*=\"language-\"],\n  pre[class*=\"language-\"] {\n    text-align: right;\n  }\n  .input-group-prepend {\n    margin-left: -1px;\n    margin-right: unset;\n  }\n  .input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu),\n  .input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n + 3) {\n    border-top-right-radius: 0.25rem;\n    border-bottom-right-radius: 0.25rem;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {\n    margin-left: unset;\n    margin-right: -1px;\n    border-top-left-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  .was-validated .form-control:invalid,\n  .form-control.is-invalid,\n  .was-validated .form-control:valid,\n  .form-control.is-valid {\n    background-position: left calc(0.375em + 0.1875rem) center;\n    padding-left: calc(1.5em + 0.75rem);\n    padding-right: 12px;\n  }\n  .input-group > .form-control:not(:last-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  .input-group > .input-group-prepend > .btn,\n  .input-group > .input-group-prepend > .input-group-text,\n  .input-group > .input-group-append:not(:last-child) > .btn,\n  .input-group > .input-group-append:not(:last-child) > .input-group-text,\n  .input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n  .input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n    border-top-right-radius: 0.25rem;\n    border-bottom-right-radius: 0.25rem;\n  }\n  .input-group > .input-group-append > .btn,\n  .input-group > .input-group-append > .input-group-text,\n  .input-group > .input-group-prepend:not(:first-child) > .btn,\n  .input-group > .input-group-prepend:not(:first-child) > .input-group-text,\n  .input-group > .input-group-prepend:first-child > .btn:not(:first-child),\n  .input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  .border-tab.nav-left .nav-link {\n    text-align: left;\n  }\n  // social app page css\n  .socialprofile {\n    .social-group {\n      ul {\n        li {\n          &:nth-child(4) {\n            margin-right: -22px;\n          }\n        }\n      }\n    }\n  }\n  .social-status {\n    form {\n      .form-group {\n        .form-control-social {\n          padding-right: 15px;\n          padding-left: unset;\n        }\n      }\n    }\n    .media {\n      .social-status {\n        right: 35px;\n        left: unset;\n      }\n    }\n  }\n  .social-chat {\n    .other-msg {\n      margin-right: 40px;\n      margin-left: unset;\n    }\n    .media-body {\n      &:before {\n        left: 100%;\n        right: unset;\n        border-left: 7px solid var(-semi-dark);\n        border-right: unset;\n      }\n      &:after {\n        left: 100%;\n        right: unset;\n        border-left: 7px solid $white;\n        border-right: unset;\n      }\n    }\n  }\n  .timeline-content {\n    .comment-number {\n      i {\n        margin-left: 20px;\n        margin-right: unset;\n      }\n    }\n  }\n  .vertical-timeline.vertical-timeline--one-column-left {\n    &::before {\n      left: unset;\n      right: 18px;\n    }\n    .vertical-timeline-element-icon {\n      right: 0;\n      left: unset;\n      svg {\n        right: 50%;\n        left: unset;\n        margin-left: unset;\n        margin-right: -12px;\n      }\n    }\n    .vertical-timeline-element-content {\n      margin-right: 60px;\n      margin-left: unset;\n      .vertical-timeline-element-date {\n        float: right;\n      }\n      .vertical-timeline-element-content-arrow {\n        border-left: 7px solid $light-color;\n        border-right: unset;\n        left: 100%;\n        right: unset;\n      }\n    }\n  }\n  .vertical-timeline.vertical-timeline--two-columns {\n    .vertical-timeline-element-content {\n      .vertical-timeline-element-content-arrow {\n        border-left: 7px solid $light-color;\n        border-right: unset;\n      }\n    }\n    .vertical-timeline-element-icon {\n      svg {\n        right: 50%;\n        left: unset;\n        margin-left: unset;\n        margin-right: -12px;\n      }\n    }\n  }\n  .vertical-timeline--two-columns {\n    .vertical-timeline-element-content {\n      .vertical-timeline-element-date {\n        right: 124%;\n        left: unset;\n      }\n    }\n  }\n  .vertical-timeline--two-columns {\n    .vertical-timeline-element.vertical-timeline-element--right {\n      .vertical-timeline-element-content {\n        .vertical-timeline-element-date {\n          right: auto;\n          left: 124%;\n          text-align: left;\n        }\n      }\n    }\n    .vertical-timeline-element {\n      &:nth-child(even) {\n        &:not(.vertical-timeline-element--left) {\n          .vertical-timeline-element-content {\n            .vertical-timeline-element-date {\n              right: auto;\n              left: 124%;\n              text-align: left;\n            }\n          }\n        }\n      }\n    }\n  }\n  .vertical-timeline--two-columns {\n    .vertical-timeline-element.vertical-timeline-element--right {\n      .vertical-timeline-element-content {\n        float: left;\n      }\n    }\n    .vertical-timeline-element {\n      &:nth-child(even) {\n        &:not(.vertical-timeline-element--left) {\n          .vertical-timeline-element-content {\n            float: left;\n          }\n        }\n      }\n    }\n  }\n\n  @media only screen and (max-width: 1170px) {\n    .vertical-timeline {\n      &::before {\n        left: unset;\n        right: 18px;\n      }\n      .vertical-timeline-element-icon {\n        right: 0;\n        left: unset;\n        svg {\n          right: 50%;\n          left: unset;\n          margin-left: unset;\n          margin-right: -12px;\n        }\n      }\n      .vertical-timeline-element-content {\n        margin-right: 60px;\n        margin-left: unset;\n        .vertical-timeline-element-date {\n          float: right;\n        }\n        .vertical-timeline-element-content-arrow {\n          border-left: 7px solid $light-color;\n          border-right: unset;\n          left: 100%;\n          right: unset;\n        }\n      }\n    }\n  }\n  .vertical-timeline.vertical-timeline--one-column-left {\n    .vertical-timeline-element-content {\n      .vertical-timeline-element-content-arrow {\n        border-left: 7px solid $dark-body-background !important;\n        border-right: unset !important;\n      }\n    }\n  }\n  .photos {\n    ul {\n      li {\n        margin-right: unset;\n        margin-left: 10px;\n      }\n    }\n  }\n  .avatar-showcase {\n    .friend-pic {\n      margin-left: 8px;\n      margin-right: unset;\n    }\n    .pepole-knows {\n      ul {\n        li {\n          margin-left: 21px;\n          margin-right: unset;\n          &:last-child {\n            margin-left: 0;\n          }\n        }\n      }\n    }\n  }\n  .user-profile {\n    .hovercard {\n      .user-image {\n        .share-icons {\n          left: 100px;\n          right: unset;\n          li {\n            margin-left: 10px;\n            margin-right: unset;\n            &:last-child {\n              margin-left: 0;\n            }\n          }\n        }\n      }\n    }\n  }\n  // faq page css\n  .faq-form {\n    .search-icon {\n      left: 12px;\n      right: unset;\n    }\n  }\n  .faq-widgets {\n    .media-body {\n      p {\n        padding-left: 20px;\n        padding-right: unset;\n      }\n    }\n  }\n  .header-faq,\n  .faq-title {\n    text-align: right;\n  }\n  .faq-accordion.default-according {\n    .card {\n      .faq-header {\n        svg {\n          left: 30px;\n          right: unset;\n        }\n      }\n      .btn-link {\n        svg {\n          margin-left: 10px;\n          margin-right: unset;\n        }\n      }\n    }\n  }\n  .navigation-option {\n    ul {\n      li {\n        padding: 8px 0 8px 8px;\n        a {\n          padding-right: 40px;\n          padding-left: unset;\n          svg {\n            right: 15px;\n            left: unset;\n          }\n        }\n      }\n    }\n  }\n  .updates-faq {\n    margin-right: unset;\n    margin-left: 20px;\n  }\n  // knowledgebase page css\n  .browse {\n    .browse-articles {\n      span {\n        svg {\n          margin-left: 10px;\n          margin-right: unset;\n        }\n      }\n    }\n  }\n  // learning app page css\n  .categories {\n    .learning-header {\n      padding-right: 15px;\n      padding-left: unset;\n    }\n  }\n  // internationalization page css\n  .main {\n    .langChoice {\n      left: 30px;\n      right: unset;\n    }\n  }\n  .pricing-block {\n    svg {\n      direction: ltr;\n    }\n  }\n  // chart peity css\n  p {\n    &.data-attributes {\n      svg {\n        margin-left: 10px;\n        margin-right: unset;\n      }\n    }\n  }\n  // avatars page css\n  .avatars {\n    .avatar {\n      margin-left: 10px;\n      margin-right: unset;\n      &:last-child {\n        margin-left: 0;\n      }\n      .status {\n        left: 4px;\n        right: unset;\n      }\n    }\n  }\n  .customers {\n    &.avatar-group {\n      margin-left: 30px;\n      margin-right: unset;\n    }\n  }\n  .card {\n    .card-header {\n      h5 {\n        float: none !important;\n      }\n    }\n  }\n  // knob chart css\n  .knob-chart {\n    .chart-clock-main {\n      .clock-small {\n        right: 10px;\n        left: unset;\n      }\n    }\n  }\n  // to-do css\n  .todo {\n    .todo-list-wrapper {\n      .mark-all-tasks {\n        .btn-label {\n          margin-left: 5px;\n          margin-right: unset;\n        }\n        left: 30px;\n        right: unset;\n      }\n      #todo-list {\n        li {\n          .task-container {\n            .task-action-btn {\n              text-align: left;\n            }\n          }\n        }\n      }\n    }\n    .notification-popup {\n      left: 10px;\n      right: unset;\n    }\n  }\n  .todo-options {\n    .badges-todo {\n      h6 {\n        margin-left: 10px;\n        margin-right: unset;\n        &:last-child {\n          margin-left: 0;\n        }\n      }\n    }\n  }\n  .todo-list-btns {\n    .dropdown-basic {\n      .btn-group {\n        .form-group {\n          .checkbox {\n            padding-right: 14px;\n            border-top-right-radius: 25px;\n            border-bottom-right-radius: 25px;\n            padding-left: unset;\n            border-top-left-radius: unset;\n            border-bottom-left-radius: unset;\n          }\n        }\n      }\n      .separated-btn {\n        margin-right: -6px;\n        margin-left: unset;\n        .btn {\n          border-top-left-radius: 25px;\n          border-bottom-left-radius: 25px;\n        }\n      }\n    }\n  }\n  .search-todo {\n    .dropdown-basic {\n      .btn-group {\n        margin-left: 18px;\n        margin-right: unset;\n      }\n    }\n  }\n  //sticky note css\n  .sticky-note {\n    .note {\n      float: right;\n    }\n  }\n  // mega-menu css\n  .mega-menu {\n    .list-unstyled {\n      div {\n        a {\n          padding: 8px 0 8px 35px;\n          &:hover {\n            padding: 8px 10px 8px 35px;\n          }\n        }\n      }\n    }\n  }\n  #testimonial {\n    .owl-stage-outer {\n      .owl-stage {\n        .owl-item {\n          .slide--item {\n            .media {\n              .me-3 {\n                margin-right: 1rem !important;\n                margin-left: unset !important;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  .needs-validation,\n  .form-row {\n    .input-group > .form-control:not(:last-child),\n    .input-group > .custom-select:not(:last-child) {\n      border-top-left-radius: 0.25rem;\n      border-bottom-left-radius: 0.25rem;\n      border-top-right-radius: 0;\n      border-bottom-right-radius: 0;\n    }\n  }\n  .form-check {\n    padding-right: 1.25rem;\n    padding-left: unset;\n    .form-check-input {\n      float: right;\n      margin-left: unset;\n      margin-right: -1.5em;\n    }\n  }\n  .mega-menu {\n    .default-according {\n      .card {\n        .btn-link {\n          text-align: right;\n        }\n      }\n      &.style-1 {\n        button[aria-expanded=\"true\"],\n        button[aria-expanded=\"false\"] {\n          &:before {\n            right: unset;\n            left: 20px;\n          }\n        }\n      }\n    }\n  }\n  // email css\n  .email-wrap {\n    .row {\n      .col-xl-6 {\n        padding-right: 0;\n        padding-left: 15px;\n      }\n      .col-xl-3 {\n        + .col-xl-3 {\n          padding-left: 0;\n          padding-right: 15px;\n        }\n      }\n    }\n    .email-app-sidebar {\n      .main-menu {\n        & > li {\n          text-align: right;\n          a {\n            i {\n              margin-right: unset;\n              margin-left: 10px;\n            }\n          }\n        }\n      }\n      ul {\n        padding-right: 0;\n      }\n    }\n    .email-content {\n      .email-top {\n        .user-emailid {\n          &:after {\n            float: left;\n          }\n        }\n      }\n    }\n    .email-right-aside {\n      .email-body {\n        .pe-0 {\n          padding-right: unset !important;\n        }\n      }\n      .radius-left {\n        border-top-right-radius: 0 !important;\n        border-bottom-right-radius: 0 !important;\n        border-radius: 4px;\n      }\n    }\n  }\n  // calender css\n  #renderRange {\n    float: left;\n    padding-left: unset;\n    padding-right: 12px;\n  }\n  .event-calendar {\n    direction: ltr;\n  }\n  .calendar-wrap {\n    .fc {\n      direction: rtl;\n      text-align: right;\n\n      .fc-toolbar {\n        .fc-left {\n          float: right;\n        }\n        .fc-right {\n          float: left;\n        }\n        & > * {\n          & > * {\n            margin-left: 0;\n          }\n        }\n      }\n    }\n    .fc-events-container {\n      text-align: right;\n    }\n    .fc-scroller {\n      margin-right: unset;\n      margin-left: -17px;\n    }\n  }\n  .fc-agenda-view {\n    .fc-day-grid {\n      .fc-row {\n        margin-right: 0 !important;\n      }\n    }\n  }\n  .fc-unthemed {\n    .fc-row {\n      margin-right: 0 !important;\n    }\n  }\n  // buttons css\n  .btn-group-showcase {\n    .btn-group {\n      margin-left: 20px;\n      margin-right: unset;\n    }\n  }\n  .btn-showcase {\n    .btn {\n      margin-right: unset;\n      margin-left: 10px;\n    }\n  }\n  .btn-square {\n    &.dropdown-toggle {\n      border-top-left-radius: 0.25rem !important;\n      border-bottom-left-radius: 0.25rem !important;\n      border-top-right-radius: 0 !important;\n      border-bottom-right-radius: 0 !important;\n    }\n  }\n  // button-builder css\n  &.button-builder {\n    ul.the-icons {\n      li {\n        float: right;\n      }\n    }\n    .color-slelector {\n      float: right;\n    }\n    .custom-button-color {\n      .form-control {\n        border-radius: 0 5px 5px 0;\n        &.pull-left {\n          float: right;\n        }\n      }\n    }\n    .hint-label {\n      float: right;\n      padding: 4px 020px 0 0;\n    }\n  }\n  #customer-review {\n    .owl-item {\n      img {\n        order: 2;\n      }\n    }\n  }\n  .options {\n    > div {\n      margin: 0 0 8px 8px;\n    }\n  }\n  // modal page\n  .modal-dialog {\n    .modal-content {\n      .modal-body {\n        p {\n          a {\n            margin-left: 0;\n          }\n        }\n      }\n    }\n  }\n  // forms page\n  .drag-box {\n    fieldset {\n      .component {\n        .form-group {\n          .text-lg-left {\n            text-align: right !important;\n          }\n          .input-group {\n            .input-group-prepend {\n              .btn,\n              .input-group-text {\n                border-top-left-radius: 0;\n                border-bottom-left-radius: 0;\n                border-top-right-radius: 0.25rem;\n                border-bottom-right-radius: 0.25rem;\n              }\n              .btn-right,\n              .checkbox-radius {\n                border-top-left-radius: 0.25rem;\n                border-bottom-left-radius: 0.25rem;\n                border-top-right-radius: 0;\n                border-bottom-right-radius: 0;\n              }\n            }\n            #prependedcheckbox {\n              border-top-right-radius: 0 !important;\n              border-bottom-right-radius: 0 !important;\n            }\n            #appendedcheckbox {\n              border-right-color: $light-semi-gray;\n            }\n            #buttondropdown {\n              margin-right: unset;\n              margin-left: -1px;\n            }\n          }\n        }\n      }\n    }\n  }\n  .drag {\n    form {\n      text-align: right;\n      input {\n        text-align: right;\n      }\n      label {\n        text-align: right !important;\n      }\n      .form-group {\n        .input-group {\n          .input-group-prepend {\n            .btn,\n            .input-group-text {\n              border-top-left-radius: 0;\n              border-bottom-left-radius: 0;\n              border-top-right-radius: 0.25rem;\n              border-bottom-right-radius: 0.25rem;\n            }\n            .btn-right,\n            .checkbox-radius {\n              border-top-left-radius: 0.25rem;\n              border-bottom-left-radius: 0.25rem;\n              border-top-right-radius: 0;\n              border-bottom-right-radius: 0;\n            }\n          }\n          #buttondropdown {\n            margin-right: unset;\n            margin-left: -1px;\n          }\n        }\n      }\n    }\n  }\n  .draggable {\n    label {\n      text-align: right;\n    }\n  }\n  .form-builder-column {\n    .tab-content {\n      .tab-pane {\n        .theme-form {\n          .ui-draggable {\n            .input-group {\n              > .input-group-prepend {\n                > .input-group-text {\n                  border-top-left-radius: 0;\n                  border-bottom-left-radius: 0;\n                  border-top-right-radius: 0.25rem;\n                  border-bottom-right-radius: 0.25rem;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    #pills-tabContent {\n      .theme-form {\n        .form-group,\n        .ui-draggable {\n          .input-group {\n            #buttondropdown {\n              margin-right: unset;\n              margin-left: 15px;\n            }\n            .input-group-btn {\n              button {\n                border-radius: 4px !important;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  .form-horizontal {\n    &.theme-form {\n      fieldset {\n        .tab-content {\n          .tab-pane {\n            .component {\n              .form-group {\n                .text-lg-left {\n                  text-align: right !important;\n                }\n                .input-group {\n                  .input-group-prepend {\n                    .btn,\n                    .input-group-text {\n                      border-top-left-radius: 0;\n                      border-bottom-left-radius: 0;\n                      border-top-right-radius: 0.25rem;\n                      border-bottom-right-radius: 0.25rem;\n                    }\n                    .btn-right,\n                    .checkbox-radius {\n                      border-top-left-radius: 0.25rem;\n                      border-bottom-left-radius: 0.25rem;\n                      border-top-right-radius: 0;\n                      border-bottom-right-radius: 0;\n                    }\n                  }\n                  #prependedcheckbox {\n                    border-top-right-radius: 0 !important;\n                    border-bottom-right-radius: 0 !important;\n                  }\n                  #appendedcheckbox {\n                    border-right-color: $light-semi-gray;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  .form-builder {\n    .component {\n      .form-group {\n        .input-group {\n          #buttondropdown {\n            margin-right: unset;\n            margin-left: -1px;\n          }\n        }\n        .pl-md-radios {\n          padding-right: 37px;\n          padding-left: unset;\n        }\n      }\n    }\n  }\n  // compact small page\n  .page-wrapper {\n    .page-body-wrapper {\n      .logo-wrapper {\n        box-shadow: 9px 0 20px rgba($semi-dark, 0.1) !important;\n        a {\n          transform: translate(-64px);\n        }\n      }\n    }\n  }\n  // search page\n  .search-page {\n    .nav i {\n      margin-left: 10px;\n      margin-right: unset;\n    }\n  }\n  .product-stts {\n    display: inline-block;\n    .ms-1 {\n      margin-right: 0.25rem !important;\n      margin-left: unset !important;\n    }\n  }\n  .search-form input {\n    padding: 10px 70px 10px 10px;\n    text-align: right;\n  }\n  // icons page\n  .icon-hover-bottom {\n    .icon-title {\n      text-align: right;\n    }\n  }\n  .icon-lists {\n    div {\n      i {\n        margin: 0 10px 0 15px;\n      }\n    }\n    ul {\n      padding-right: 0;\n    }\n  }\n  ul {\n    &.icon-lists {\n      padding-right: 30px;\n    }\n  }\n  // customizer\n  .floated-customizer-btn {\n    &.third-floated-btn {\n      left: 35px;\n      right: unset;\n    }\n    & > span {\n      margin-right: 10px;\n    }\n  }\n  .floated-customizer-panel {\n    text-align: right;\n    left: -85px;\n    right: unset;\n    &.active {\n      left: 35px;\n      right: unset;\n    }\n    .close-customizer-btn {\n      left: 30px;\n      right: unset;\n    }\n    ul {\n      padding-right: 0;\n    }\n  }\n  // form builder-2 page\n  .form-builder-2-header {\n    > div {\n      nav {\n        float: left;\n      }\n    }\n  }\n  .radio {\n    label {\n      padding-left: 0;\n      padding-right: 15px;\n      &::before {\n        right: 0;\n        margin-right: -20px;\n        left: unset;\n      }\n    }\n  }\n  // sidebar main page\n  .page-wrapper {\n    .page-body-wrapper {\n      .page-title {\n        .row {\n          h3 {\n            text-align: right;\n            padding-left: 20px;\n            padding-right: unset !important;\n          }\n          h6 {\n            text-align: right;\n          }\n        }\n      }\n    }\n    &.compact-wrapper {\n      .page-header {\n        margin-right: 265px;\n        margin-left: unset;\n        width: calc(100% - 265px);\n        &.close_icon {\n          margin-right: 100px;\n          margin-left: unset;\n          width: calc(100% - 100px);\n        }\n      }\n    }\n    &.modern-type {\n      .page-header {\n        margin-right: 0;\n        width: calc(100% - 0px);\n        &.close_icon {\n          margin-right: 0;\n          width: calc(100% - 0px);\n        }\n        .header-wrapper {\n          .logo-wrapper {\n            margin-right: unset;\n            margin-left: 30px;\n          }\n          .toggle-sidebar {\n            margin-right: unset;\n            margin-left: 15px;\n          }\n        }\n      }\n      .page-body-wrapper {\n        .page-body {\n          margin-right: 310px;\n        }\n        .footer {\n          margin-left: 55px;\n          margin-right: 360px;\n        }\n        div.sidebar-wrapper {\n          &.close_icon {\n            ~ .page-body {\n              margin-right: 0px;\n            }\n            ~ footer {\n              margin-right: 0;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // page main header\n  .page-header {\n    .header-wrapper {\n      .nav-right {\n        text-align: right;\n        .onhover-show-div {\n          right: unset;\n          left: 0;\n          @media (max-width: 575.98px) {\n            left: 12px;\n          }\n        }\n        .cart-dropdown {\n          @media (max-width: 575.98px) {\n            li {\n              padding: 10px;\n            }\n          }\n          .close-circle {\n            right: unset;\n            left: 0;\n          }\n        }\n        > ul {\n          > li {\n            .lang-txt {\n              margin-left: 0;\n              margin-right: 8px;\n            }\n            &:before {\n              right: 0;\n              left: unset;\n            }\n            .dot {\n              left: 17px;\n              right: unset;\n            }\n            &.onhover-dropdown {\n              &:hover {\n                .onhover-show-div {\n                  &:before {\n                    right: 10px;\n                    left: unset;\n                  }\n                  &:after {\n                    right: 10px;\n                    left: unset;\n                  }\n                }\n              }\n              &:last-child {\n                padding-left: 0;\n                padding-right: 0 !important;\n              }\n            }\n            &:last-child {\n              padding-right: 20px;\n              padding-left: 0;\n            }\n            text-align: right;\n            i {\n              &.ms-2 {\n                margin-right: 0.5rem !important;\n                margin-left: unset !important;\n              }\n            }\n          }\n        }\n        .profile-dropdown {\n          li {\n            svg {\n              margin-right: unset;\n              margin-left: 10px;\n            }\n          }\n        }\n      }\n      .mobile-sidebar {\n        padding-left: 20px;\n        padding-right: unset;\n      }\n    }\n    &.open {\n      margin-right: 0;\n    }\n  }\n  ul {\n    &.notification-dropdown {\n      &.onhover-show-div {\n        right: initial;\n        left: -30px;\n        padding: 0;\n        &:before {\n          right: inherit !important;\n          left: 35px !important;\n        }\n        &:after {\n          right: inherit !important;\n          left: 35px !important;\n        }\n        li {\n          margin-right: 0 !important;\n          span {\n            &.badge {\n              margin-left: unset !important;\n            }\n            svg {\n              margin-right: unset;\n              margin-left: 10px;\n            }\n          }\n          .notification-icon {\n            margin-left: 20px;\n            margin-right: unset;\n          }\n        }\n      }\n    }\n  }\n  // alert page\n  .card-body {\n    .alert {\n      svg {\n        ~ p {\n          padding-left: unset;\n          padding-right: 20px;\n        }\n      }\n    }\n  }\n  .alert {\n    i {\n      margin-left: 5px;\n      margin-right: 0;\n    }\n  }\n  .inverse {\n    padding: 13px 65px 13px 20px;\n    i {\n      left: unset;\n      right: 0;\n    }\n  }\n  @each $var in $alert-name {\n    $i: index($alert-name, $var);\n    .alert-#{$var}.inverse {\n      &:before {\n        border-right: 7px solid nth($alert-color, $i);\n        right: 54px;\n        left: unset;\n        border-left: unset;\n      }\n    }\n  }\n  .alert-dismissible {\n    .btn-close {\n      left: 0;\n      right: unset;\n      span {\n        padding-left: 0;\n        padding-right: unset;\n      }\n    }\n  }\n  .icofont {\n    &.icofont-truck {\n      display: inline-block;\n    }\n  }\n  // blog page\n  .blog-box {\n    .blog-details {\n      padding-left: 20px;\n      text-align: right;\n      .blog-social {\n        padding-right: 0;\n        li {\n          padding-left: 40px;\n          padding-right: unset;\n          &:first-child {\n            border-left: 1px solid #777777;\n            border-right: unset;\n            padding-left: 40px;\n            padding-right: unset;\n          }\n          & + li {\n            margin-right: 30px;\n            margin-left: unset;\n            padding-left: 0;\n          }\n        }\n      }\n    }\n    .blog-details-main {\n      .blog-social {\n        li {\n          border-left: 1px dotted;\n          border-right: unset;\n          &:last-child {\n            border-left: none;\n          }\n        }\n      }\n    }\n    .blog-date {\n      span {\n        font-size: 36px;\n        font-weight: 500;\n        padding-left: 5px;\n      }\n    }\n  }\n  .comment-box {\n    .media {\n      img {\n        margin-left: 45px;\n        margin-right: unset;\n      }\n      h6 {\n        text-align: right;\n      }\n    }\n    ul {\n      ul {\n        margin-right: 135px;\n        margin-left: unset;\n        padding-right: 0;\n        @media (max-width: 575.98px) {\n          margin-right: 30px;\n        }\n      }\n    }\n    .comment-social {\n      text-align: left;\n      li {\n        padding-left: 0;\n        padding-right: 20px;\n        &:first-child {\n          border-left: 1px solid $light-semi-gray;\n          border-right: unset;\n          padding-right: 0;\n          padding-left: 20px;\n        }\n      }\n    }\n  }\n  // button builder page\n  .button-builder-wrap {\n    .form-group {\n      .btn {\n        margin-left: 15px;\n        margin-right: 0;\n        padding: 9px;\n      }\n    }\n  }\n  .button-builder {\n    ul {\n      &.the-icons {\n        padding-right: 0 !important;\n      }\n    }\n  }\n  // chat page\n  .call-chat-body {\n    .chat-box {\n      .chat-right-aside {\n        .chat {\n          .chat-history {\n            .caller-img {\n              &.ps-0 {\n                padding-left: 15px !important;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  .chat-box {\n    .user-image {\n      float: right;\n      margin-left: 5px;\n      margin-right: 0;\n    }\n    .people-list {\n      .search {\n        i {\n          left: 10px;\n          right: unset;\n        }\n      }\n    }\n    .about {\n      float: right;\n      padding-right: 10px;\n      padding-left: unset;\n      text-align: right;\n    }\n    .chat-menu {\n      border-right: 1px solid $light-color;\n      border-left: unset;\n      .nav {\n        padding-right: 0;\n      }\n      &.ps-0 {\n        padding-left: 15px !important;\n      }\n    }\n    .chat-right-aside {\n      .chat {\n        .chat-message {\n          .smiley-box {\n            margin-left: 0.5rem;\n            margin-right: unset;\n          }\n          .text-box {\n            .btn {\n              border-radius: 5px 0 0 5px;\n            }\n          }\n        }\n      }\n      &.pe-0 {\n        padding-right: 15px !important;\n      }\n    }\n    .chat {\n      .chat-message {\n        .text-box {\n          .input-group-append {\n            margin-right: -2px;\n          }\n        }\n      }\n    }\n  }\n  .chat-msg-box {\n    ul {\n      padding-right: 0;\n    }\n  }\n  .chat-left-aside {\n    .status-circle {\n      left: unset;\n      right: 40px;\n    }\n  }\n  .chat-right-aside {\n    .chat {\n      .chat-header {\n        .chat-menu-icons {\n          padding-left: 0;\n          padding-right: unset;\n          &.float-sm-right {\n            float: left !important;\n          }\n        }\n        img {\n          float: right;\n        }\n      }\n    }\n  }\n  // cke editor page\n  .cke_toolbar,\n  .cke_toolgroup,\n  a.cke_button,\n  .cke_combo_text {\n    float: right;\n  }\n  .cke_reset_all,\n  .cke_reset_all *,\n  .cke_reset_all a,\n  .cke_reset_all textarea {\n    text-align: right;\n  }\n  .cke_combo_text {\n    padding-left: unset;\n    padding-right: 10px;\n  }\n  #editor1 {\n    #cke_editor1 {\n      #cke_1_contents {\n        iframe {\n          html {\n            direction: rtl !important;\n          }\n        }\n      }\n    }\n  }\n  // coming soon page\n  #clockdiv {\n    ul {\n      padding-right: 0;\n    }\n  }\n  // social app page\n  .custom-card {\n    .card-footer {\n      & > div {\n        & + div {\n          border-right: 1px solid $light-semi-gray;\n          border-left: unset !important;\n        }\n      }\n    }\n  }\n  .card-social {\n    padding-right: 0;\n  }\n  .card-absolute {\n    .card-header {\n      right: 15px;\n      left: unset;\n    }\n  }\n  // datatables page\n  .dataTables_wrapper {\n    .dataTables_filter {\n      input[type=\"search\"] {\n        margin-right: 10px;\n        margin-left: 0;\n      }\n    }\n    .dataTables_length {\n      float: right;\n    }\n    .dataTables_filter {\n      margin-left: unset;\n      margin-right: 15px;\n      float: left;\n    }\n    .dataTables_info {\n      float: right;\n    }\n    .advance-5_filter {\n      margin-left: 0;\n    }\n    .btn-group {\n      button {\n        margin-left: 5px;\n        margin-right: unset;\n        &:last-child {\n          margin-left: 0;\n        }\n      }\n    }\n    table {\n      &.dataTable {\n        tbody {\n          td,\n          th {\n            &.select-checkbox {\n              &:after {\n                margin-left: 31px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  div {\n    &.dataTables_wrapper {\n      div {\n        &.dataTables_paginate {\n          margin-right: 15px !important;\n          margin-left: 0 !important;\n          float: left;\n        }\n      }\n    }\n  }\n  table {\n    &.dataTable {\n      thead {\n        & > tr {\n          & > th {\n            padding-left: 30px;\n            padding-right: 12px;\n            &:before {\n              left: 1em !important;\n              right: unset;\n            }\n            &:after {\n              left: 0.5em !important;\n              right: unset;\n            }\n          }\n        }\n      }\n    }\n  }\n  table.dataTable thead .sorting:before,\n  table.dataTable thead .sorting_asc:before,\n  table.dataTable thead .sorting_desc:before,\n  table.dataTable thead .sorting_asc_disabled:before,\n  table.dataTable thead .sorting_desc_disabled:before {\n    left: 1em !important;\n    right: unset;\n  }\n  .dataTables_scrollHeadInner {\n    padding-right: unset !important;\n    padding-left: 0 !important;\n  }\n  div {\n    &.table-responsive {\n      & > div {\n        &.dataTables_wrapper {\n          & > div {\n            &.row {\n              & > div[class^=\"col-\"]:first-child {\n                padding-right: 0;\n                padding-left: 0;\n              }\n              & > div[class^=\"col-\"]:last-child {\n                padding-right: 0;\n                padding-left: 0;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  .dt-plugin-buttons {\n    button {\n      &.m-r-10 {\n        margin-left: 10px;\n        margin-right: 0;\n      }\n    }\n  }\n  // datetime picker page\n  .datetime-picker {\n    .theme-form {\n      .form-group {\n        label {\n          text-align: left !important;\n        }\n        .input-group-text {\n          border-top-right-radius: 0;\n          border-bottom-right-radius: 0;\n        }\n        .input-group {\n          .form-control {\n            border-radius: 0.25rem;\n            border-top-left-radius: 0;\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n  // dropdown page\n  .dropdown-basic {\n    .btn {\n      border-top-left-radius: 0;\n      border-bottom-left-radius: 0;\n      border-top-right-radius: 0.25rem !important;\n      border-bottom-right-radius: 0.25rem !important;\n    }\n    .separated-btn {\n      .btn {\n        border-radius: 0.25rem;\n        border-top-right-radius: 0 !important;\n        border-bottom-right-radius: 0 !important;\n      }\n    }\n    .btn-group {\n      margin-right: unset;\n      margin-left: 18px;\n    }\n  }\n  // error page\n  .error-wrapper {\n    .col-md-8 {\n      &.offset-md-2 {\n        margin: 0 auto !important;\n      }\n    }\n  }\n  // product page\n  .product-price {\n    del {\n      padding-left: 20px;\n      padding-right: 0;\n    }\n  }\n  .product-box {\n    .modal {\n      .modal-header {\n        .btn-close {\n          right: unset;\n          left: 15px;\n        }\n      }\n    }\n    .ribbon-bookmark.ribbon-vertical-left.ribbon-info:before,\n    .ribbon-bookmark.ribbon-vertical-right.ribbon-info:before {\n      border-left-color: #007bff;\n    }\n    .ribbon-bookmark.ribbon-vertical-left:before,\n    .ribbon-bookmark.ribbon-vertical-right:before {\n      right: 0;\n      left: unset;\n      border-left: 15px solid #2a3142;\n    }\n    .ribbon-bookmark.ribbon-info:before {\n      border-left-color: transparent;\n    }\n    .ribbon-warning.ribbon-clip:before {\n      border-left-color: #ff850d;\n      border-right-color: unset;\n    }\n    .ribbon-clip {\n      right: -14px;\n      left: unset;\n      &:before {\n        right: 0;\n        left: unset;\n      }\n    }\n  }\n  .product-hover {\n    ul {\n      padding-right: 0;\n    }\n  }\n  .customer-review {\n    .media {\n      img {\n        margin-left: 25px;\n        margin-right: 0;\n      }\n    }\n  }\n  .nav {\n    padding-right: 0;\n  }\n  .custom-tab {\n    padding: 4px;\n  }\n  .custom-file-label {\n    &::after {\n      left: 0;\n      right: unset;\n    }\n  }\n  // form wizard 4 page\n  .wizard-4 {\n    ul {\n      &.anchor {\n        float: right;\n      }\n    }\n    .step-container {\n      clear: unset;\n    }\n    .form-group {\n      text-align: right;\n    }\n    .action-bar {\n      .btn {\n        float: left;\n      }\n    }\n  }\n  .f1 {\n    .f1-buttons {\n      text-align: left;\n    }\n    .f1-steps {\n      .f1-step {\n        float: right;\n      }\n    }\n  }\n  // tree view page\n  .jstree-default {\n    .jstree-node {\n      margin-left: unset;\n      margin-right: 24px;\n      background-position: -292px -4px;\n      background-repeat: repeat-y;\n    }\n  }\n  // image cropper page\n  .img-cropper {\n    .btn-group {\n      margin-right: 0;\n      margin-left: 10px;\n      button {\n        &:last-child {\n          border-top-right-radius: 0;\n          border-bottom-right-radius: 0;\n          border-top-left-radius: 0.25rem;\n          border-bottom-left-radius: 0.25rem;\n        }\n        &:first-child {\n          border-top-right-radius: 0.25rem;\n          border-bottom-right-radius: 0.25rem;\n          border-top-left-radius: 0;\n          border-bottom-left-radius: 0;\n        }\n      }\n    }\n  }\n  .docs-toggles {\n    .btn-group {\n      .btn {\n        border-radius: 0;\n        &:last-child {\n          border-top-left-radius: 0.25rem;\n          border-bottom-left-radius: 0.25rem;\n        }\n        &:first-child {\n          border-top-right-radius: 0.25rem;\n          border-bottom-right-radius: 0.25rem;\n        }\n      }\n    }\n  }\n  .btn-group {\n    > .btn:not(:last-child):not(.dropdown-toggle) {\n      > .btn-group:not(:last-child) > .btn {\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n      }\n    }\n  }\n  .jsgrid-button {\n    + .jsgrid-button {\n      margin-right: 5px;\n      margin-left: unset;\n    }\n  }\n  .product-table .rdt_TableBody .rdt_TableRow .rdt_TableCell .product-name .order-process {\n    padding-right: 15px;\n    padding-left: unset;\n    .order-process-circle {\n      &::before {\n        left: 10px;\n      }\n    }\n  }\n  .list-group {\n    padding-right: 0;\n    i,\n    img {\n      margin-left: 10px;\n      margin-right: 0;\n    }\n  }\n  .list-group i {\n    margin-left: 0;\n    margin-right: 0;\n  }\n  // authentication page\n  .authentication-box {\n    text-align: right;\n  }\n  // mega options page\n  .mega-horizontal {\n    .offset-sm-3 {\n      margin-right: 25%;\n      margin-left: unset;\n    }\n  }\n  // navs page\n  .navs-icon {\n    svg {\n      margin-left: 10px;\n      margin-right: unset;\n    }\n    .fa {\n      margin-left: 10px;\n      margin-right: unset;\n    }\n  }\n  .nav-list {\n    .nav-list-disc {\n      text-align: right;\n      padding-right: 0;\n    }\n  }\n  .pl-navs-inline {\n    padding-right: 30px !important;\n    padding-left: 0 !important;\n  }\n  .onhover-dropdown.navs-dropdown:hover .onhover-show-div:before {\n    left: 77px;\n    right: unset;\n  }\n  .onhover-dropdown.navs-dropdown:hover .onhover-show-div:after {\n    left: 77px;\n    right: unset;\n  }\n  .navs-dropdown {\n    .onhover-show-div {\n      .navs-icon {\n        li {\n          text-align: right;\n        }\n      }\n    }\n  }\n  .navs-icon.default-according.style-1 {\n    li {\n      button[aria-expanded=\"true\"] {\n        &:before {\n          left: 2px;\n          right: unset;\n        }\n      }\n      button[aria-expanded=\"false\"]:before {\n        left: 2px;\n        right: unset;\n      }\n    }\n  }\n  // search page css\n  .search-form {\n    .form-group {\n      &:after {\n        right: 53px;\n        left: unset;\n      }\n      &:before {\n        right: 82px;\n        left: unset;\n      }\n    }\n  }\n  // order history page css\n  .order-history {\n    table {\n      tbody {\n        tr {\n          td {\n            .product-name {\n              .order-process {\n                .order-process-circle {\n                  &:before {\n                    right: -15px;\n                    left: unset;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n      th,\n      td {\n        &:first-child {\n          text-align: right;\n        }\n      }\n    }\n  }\n  // product-page\n  .product-page-details {\n    span {\n      padding-right: 15px;\n      padding-left: 0;\n    }\n  }\n  .m-checkbox-inline {\n    label {\n      margin-left: 20px;\n      margin-right: 0;\n    }\n  }\n  .form-label-align-right {\n    label {\n      text-align: left;\n    }\n  }\n  // rating page\n  .br-theme-bars-reversed,\n  .br-theme-bars-movie,\n  .br-theme-bars-1to10,\n  .br-theme-bars-square {\n    .br-widget {\n      .br-current-rating {\n        float: right;\n      }\n      a {\n        float: right;\n      }\n    }\n  }\n  // ribbons page\n  .ribbon-left {\n    right: auto;\n    left: -2px;\n  }\n  .ribbon-vertical-left {\n    right: auto;\n    left: 12px;\n  }\n  .ribbon-vertical-right {\n    right: auto;\n    left: 12px;\n  }\n  // search page\n  .star-ratings {\n    ul {\n      &.search-info {\n        padding-right: 0;\n        li {\n          & + li {\n            border-right: 1px solid #a5afc6;\n            border-left: unset;\n            padding-right: 8px;\n            padding-left: 0;\n            margin-right: 8px;\n            margin-left: 0;\n          }\n        }\n      }\n    }\n  }\n  // select 2 page\n  .select2-container--default {\n    .select2-selection--single {\n      .select2-selection__arrow {\n        left: 10px !important;\n        right: unset !important;\n      }\n    }\n    .select2-selection--multiple {\n      .select2-selection__choice {\n        float: right;\n      }\n    }\n  }\n  .selection {\n    .select2-selection {\n      .select2-search__field {\n        text-align: right;\n      }\n    }\n  }\n  .select2-results__option {\n    text-align: right;\n  }\n  .editor-statusbar {\n    text-align: left;\n    span {\n      margin-right: 1em;\n      margin-left: unset;\n    }\n  }\n  .CodeMirror-scroll {\n    margin-left: -30px;\n    margin-right: unset;\n  }\n  .primary-color,\n  .yellow-color {\n    ul {\n      padding-right: 0;\n    }\n  }\n  // steps page\n  .u-step-desc {\n    text-align: right;\n  }\n  .u-step-number {\n    right: 20px;\n    left: unset;\n    & ~ .u-step-desc {\n      margin-right: 50px;\n    }\n  }\n  .u-pearl {\n    &:after {\n      left: 0;\n      right: unset;\n    }\n    &:before {\n      right: 0;\n      left: unset;\n    }\n  }\n  .u-step-icon {\n    float: right;\n    margin-left: 0.5em;\n    margin-right: unset;\n  }\n  // summernote page\n  .list-icons {\n    padding-right: 0;\n  }\n  .card-header.note-toolbar {\n    .note-color {\n      .dropdown-toggle {\n        padding-right: 5px;\n      }\n    }\n    .form-group {\n      &.draggable {\n        text-align: right;\n      }\n    }\n\n    .form-check {\n      padding-right: 24px;\n      padding-left: unset;\n    }\n    form {\n      .custom-control {\n        padding-right: 24px;\n        padding-left: unset;\n        .custom-control-label {\n          &::after {\n            right: 0;\n            left: unset;\n          }\n          &::before {\n            right: 0;\n            left: unset;\n          }\n        }\n      }\n    }\n  }\n  // input group page\n  .dropdown-toggle::after {\n    margin-right: 0.255em;\n    margin-left: unset;\n  }\n  // tabbed card page\n  .tabbed-card {\n    ul {\n      left: 22px;\n      right: unset;\n    }\n  }\n  // checkbox & radios page\n  .checkbox {\n    label {\n      padding-right: 16px;\n      padding-left: unset;\n      &::before {\n        right: 0;\n        left: unset;\n        margin-right: -16px;\n        margin-left: unset;\n      }\n    }\n  }\n  .radio {\n    label {\n      &::after {\n        right: 5px;\n        left: unset;\n        margin-right: -20px;\n        margin-left: unset;\n      }\n    }\n  }\n  // timeline page\n  .cd-timeline-content {\n    &::before {\n      border-right: 7px solid $light-color;\n      border-left-color: transparent;\n    }\n  }\n  .cd-timeline-img {\n    i {\n      right: 40%;\n      left: unset;\n      margin-right: -12px;\n      margin-left: unset;\n    }\n  }\n  .cd-timeline-block {\n    &:nth-child(even) {\n      .cd-timeline-content {\n        float: left;\n        border-left: 7px solid #eeeeee;\n        border-right: unset;\n        .cd-date {\n          right: auto;\n          left: 122%;\n          text-align: left;\n        }\n        &::before {\n          right: auto;\n          left: 100%;\n          border-left-color: #eeeeee;\n          border-right-color: transparent;\n        }\n      }\n    }\n  }\n  .cd-timeline-content {\n    .cd-date {\n      right: 122%;\n      left: unset;\n    }\n  }\n  // tour page\n  .introjs-tooltip {\n    right: 0;\n    left: unset;\n  }\n  .introjs-helperNumberLayer {\n    right: -16px;\n    left: unset;\n  }\n  .introjs-tooltipReferenceLayer {\n    .introjs-tooltip {\n      .introjs-tooltiptext {\n        text-align: right;\n      }\n      .introjs-tooltipbuttons {\n        text-align: left;\n        .introjs-skipbutton {\n          margin-left: 5px;\n          margin-right: unset;\n        }\n        .introjs-nextbutton {\n          -webkit-border-radius: 0.2em 0 0 0.2em;\n          -moz-border-radius: 0.2em 0 0 0.2em;\n          border-radius: 0.2em 0 0 0.2em;\n        }\n      }\n    }\n  }\n  .list-inline-item {\n    &:not(:last-child) {\n      margin-left: 0.5rem;\n      margin-right: unset;\n    }\n  }\n  .like-comment {\n    ul {\n      &.list-inline {\n        padding-right: 0;\n      }\n    }\n  }\n  .typeahead {\n    text-align: right;\n  }\n  .listing {\n    ul {\n      padding-right: 0;\n      .icofont {\n        float: right;\n      }\n    }\n  }\n  // gallery page\n  .gallery {\n    .hover-5 {\n      img {\n        margin-right: 30px;\n      }\n      &:hover {\n        img {\n          margin-right: 0;\n        }\n      }\n    }\n  }\n  .lg-outer {\n    text-align: right;\n  }\n  .lg-toolbar .lg-icon {\n    float: left;\n  }\n  #lg-counter {\n    padding-right: 20px;\n    padding-left: unset;\n    float: right;\n  }\n  // chart widget page\n  .chart-widget-top {\n    .text-end {\n      text-align: left !important;\n    }\n    .num {\n      .ms-1 {\n        margin-right: 0.25rem !important;\n      }\n    }\n  }\n  .bar-chart-widget {\n    .earning-details {\n      i {\n        left: -240px;\n      }\n    }\n    .bottom-content {\n      .b-r-light {\n        border-left: 1px solid #eeeeee !important;\n        border-right: unset !important;\n      }\n      .num {\n        .ms-1 {\n          margin-right: 0.25rem !important;\n        }\n      }\n    }\n  }\n  // dashboard project page\n  .chart-vertical-center {\n    #myDoughnutGraph,\n    #myPolarGraph {\n      width: auto !important;\n    }\n  }\n  .crm-activity {\n    ul {\n      &.dates {\n        li {\n          + li {\n            border-right: 1px solid #ddd;\n            padding-right: 10px;\n            margin-right: 5px;\n            border-left: unset;\n            padding-left: unset;\n            margin-left: unset;\n          }\n        }\n      }\n    }\n  }\n  div {\n    &.dt-buttons {\n      float: right;\n    }\n  }\n  .dt-button-collection {\n    left: -39px !important;\n  }\n  // dropzone page\n  .dropzone {\n    .dz-preview {\n      .dz-error-mark,\n      .dz-success-mark {\n        right: 50%;\n        margin-right: -27px;\n        margin-left: unset;\n        left: unset;\n      }\n    }\n  }\n  // footer page\n  .page-wrapper {\n    .page-body-wrapper {\n      footer {\n        margin-right: 265px;\n        margin-left: unset;\n        p {\n          i {\n            margin-right: 5px;\n            margin-left: unset;\n          }\n        }\n      }\n    }\n  }\n  .footer-copyright {\n    text-align: right;\n  }\n  .footer-links {\n    text-align: left;\n  }\n  .page-item {\n    &:first-child {\n      .page-link {\n        margin-right: 0;\n        border-top-right-radius: 0.25rem;\n        border-bottom-right-radius: 0.25rem;\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0;\n        border-left: none;\n      }\n    }\n    &:last-child {\n      .page-link {\n        border-top-left-radius: 0.25rem;\n        border-bottom-left-radius: 0.25rem;\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n      }\n    }\n  }\n  // popover page\n  .popover.top,\n  .popover.bottom {\n    > .arrow:after {\n      margin-right: -10px;\n      margin-left: unset;\n    }\n  }\n  // touchspin page\n  .bootstrap-touchspin {\n    > .input-group-append {\n      > .btn,\n      > .input-group-text {\n        border-top-right-radius: 0 !important;\n        border-bottom-right-radius: 0 !important;\n        border-top-left-radius: 0 !important;\n        border-bottom-left-radius: 0 !important;\n      }\n    }\n    > .form-control,\n    > .custom-select {\n      &:not(:last-child) {\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0;\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n      }\n    }\n  }\n  // typahead page\n  .typeahead {\n    span {\n      &.twitter-typeahead {\n        .tt-suggestion {\n          text-align: right;\n        }\n      }\n    }\n    .league-name {\n      text-align: right;\n      margin-right: 5px;\n    }\n  }\n  // call-chat page\n  .follow {\n    .text-md-right {\n      text-align: left !important;\n    }\n  }\n  // vector map page\n  .jvectormap-zoomin,\n  .jvectormap-zoomout,\n  .jvectormap-goback {\n    right: 10px;\n    left: unset;\n  }\n\n  //customizer rtl css\n  .customizer-links {\n    right: unset;\n    left: 0;\n    > .nav {\n      padding-right: 10px;\n    }\n    .nav-link {\n      &:after {\n        right: -10px;\n        left: unset;\n        border-width: 5px 5px 5px 0;\n        border-left-color: unset;\n        border-right-color: lighten($primary-color, 25%);\n      }\n      span {\n        right: unset;\n        left: -60px;\n      }\n      &:hover {\n        span {\n          left: 48px;\n        }\n      }\n    }\n    &.open {\n      right: unset;\n      left: 330px;\n      border-radius: 0 8px 8px 0;\n    }\n  }\n  .customizer-contain {\n    width: 330px;\n    right: unset;\n    left: -330px;\n    &.open {\n      right: unset;\n      left: 0px;\n    }\n    .customizer-header {\n      .icon-close {\n        left: unset;\n        right: 30px;\n      }\n    }\n  }\n  // boxes layout rtl css\n  .box-layout {\n    &.page-wrapper.horizontal-wrapper {\n      .page-header {\n        padding-right: 250px;\n        padding-left: unset;\n        &.open {\n          padding-right: 0;\n        }\n      }\n    }\n    &.page-wrapper {\n      &.compact-wrapper {\n        .page-body-wrapper {\n          .page-body {\n            margin-left: unset;\n            margin-right: 230px;\n          }\n          .sidebar-wrapper {\n            &.close_icon {\n              ~ footer {\n                width: 1280px;\n                padding-left: 0;\n                left: 50%;\n              }\n            }\n          }\n        }\n        .page-header {\n          margin-left: auto;\n          margin-right: auto;\n          padding-left: unset;\n          padding-right: 230px;\n          &.close_icon {\n            padding-right: 100px;\n          }\n        }\n      }\n    }\n  }\n  body.dark-only {\n    .custom-card {\n      .card-footer {\n        > div {\n          + div {\n            border-right: 1px solid $dark-card-border;\n          }\n        }\n      }\n    }\n    .page-wrapper {\n      .page-body-wrapper {\n        .page-body {\n          .card:not(.email-body) {\n            .b-r-light,\n            .border-right {\n              border-right: none !important;\n              border-left: 1px solid $dark-card-border !important;\n            }\n          }\n        }\n      }\n    }\n  }\n  // responsive css\n  @media screen and (max-width: 1660px) {\n    // video chat page\n    .caller-img {\n      left: unset;\n      right: 15px;\n    }\n  }\n  @media only screen and (max-width: 1366px) {\n    .profile-dropdown {\n      &.onhover-show-div {\n        right: unset !important;\n        left: 0 !important;\n      }\n    }\n    .product-wrapper {\n      .product-grid {\n        .feature-products {\n          margin-right: 0;\n        }\n      }\n    }\n    .product-grid {\n      margin-right: 0;\n    }\n    .d-none-productlist {\n      margin-left: 10px;\n      margin-right: unset;\n    }\n    .photos {\n      ul {\n        li {\n          &:nth-child(3n) {\n            margin-left: 15px;\n            margin-right: unset;\n          }\n        }\n      }\n    }\n    // chat page\n    .chat-left-aside {\n      .status-circle {\n        left: unset;\n        right: 22px;\n      }\n    }\n  }\n  @media (min-width: 1200px) {\n    .float-xl-end {\n      float: left !important;\n    }\n    // chat page\n    .chat-box {\n      .pe-xl-0 {\n        padding-left: 0 !important;\n        padding-right: 15px !important;\n      }\n      .ps-xl-0 {\n        padding-right: 0 !important;\n        padding-left: 15px !important;\n      }\n    }\n    // vertical page\n    .pixelstrap {\n      ul {\n        a {\n          &:hover,\n          &:focus,\n          &:active,\n          &.highlighted {\n            .sub-arrow {\n              left: 3px;\n              right: unset;\n            }\n          }\n        }\n      }\n    }\n  }\n  @media (min-width: 992px) {\n    .text-lg-start {\n      text-align: right !important;\n    }\n  }\n  @media only screen and (max-width: 1199.98px) {\n    .jkanban-container {\n      .btn {\n        margin-left: unset;\n        margin-right: 20px;\n      }\n    }\n    .link-section > div > h6:before {\n      right: unset;\n      left: 10px;\n    }\n    .page-wrapper {\n      .page-header {\n        .header-wrapper {\n          .nav-right {\n            > ul {\n              li {\n                .submenu {\n                  li {\n                    &:first-child {\n                      padding-right: 15px !important;\n                      padding-left: 15px !important;\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .user-profile {\n      .hovercard {\n        .user-image {\n          .share-icons {\n            left: 45px;\n          }\n        }\n      }\n    }\n    .email-wrap {\n      .row {\n        .col-xl-6 {\n          padding-right: 15px;\n        }\n        .col-xl-3 {\n          + .col-xl-3 {\n            padding-left: 15px;\n          }\n        }\n      }\n      .email-app-sidebar {\n        .main-menu {\n          & > li {\n            text-align: right;\n            a {\n              i {\n                margin-right: unset;\n                margin-left: 10px;\n              }\n            }\n          }\n        }\n        ul {\n          padding-right: 0;\n        }\n      }\n      .email-content {\n        .email-top {\n          .user-emailid {\n            &:after {\n              float: left;\n            }\n          }\n        }\n      }\n      .email-right-aside {\n        .email-body {\n          .pe-0 {\n            padding-right: unset !important;\n          }\n        }\n        .radius-left {\n          border-top-right-radius: 0 !important;\n          border-bottom-right-radius: 0 !important;\n          border-radius: 4px;\n        }\n      }\n    }\n    .chat-menu-icons {\n      text-align: left;\n    }\n    .chat-box {\n      .chat-history {\n        .row {\n          .col-sm-7 {\n            padding-left: 0 !important;\n            padding-right: unset !important;\n          }\n        }\n      }\n    }\n    .chat-menu {\n      left: 0;\n      right: unset;\n    }\n  }\n  @media only screen and (max-width: 991.98px) {\n    .todo {\n      .todo-list-wrapper {\n        .mark-all-tasks {\n          left: 20px;\n        }\n      }\n    }\n    .page-wrapper {\n      &.compact-wrapper {\n        .page-body-wrapper {\n          div.sidebar-wrapper {\n            &.close_icon {\n              transform: translate(285px);\n              &:hover {\n                transform: translate(285px);\n              }\n            }\n            .logo-wrapper {\n              .back-btn {\n                float: left;\n                transform: rotate(180deg);\n              }\n            }\n          }\n        }\n        .page-header {\n          .header-wrapper {\n            .toggle-sidebar {\n              margin-right: 0;\n              border-right: none;\n              padding-right: 0;\n              border-left: 1px solid #ddd;\n              margin-left: 15px;\n              padding-left: 15px;\n            }\n          }\n        }\n      }\n      &.compact-sidebar {\n        .page-header {\n          margin-right: 0;\n        }\n      }\n      &.material-icon {\n        .page-header {\n          padding-right: 0;\n        }\n        .page-body-wrapper {\n          .page-body {\n            padding-right: 15px;\n          }\n        }\n      }\n    }\n    .faq-accordion {\n      .faq-header {\n        svg {\n          left: 20px;\n        }\n      }\n    }\n    .page-wrapper {\n      .page-header {\n        .header-logo-wrapper {\n          .logo-wrapper {\n            img {\n              margin-left: 15px;\n              margin-right: unset;\n            }\n          }\n        }\n      }\n    }\n    .page-body-wrapper {\n      .page-body,\n      footer {\n        margin-right: 0 !important;\n      }\n    }\n    .main {\n      .langChoice {\n        left: 20px;\n      }\n    }\n    .cd-timeline-img {\n      i {\n        right: 50% !important;\n      }\n    }\n    .page-wrapper {\n      .page-body-wrapper {\n        .page-title {\n          .breadcrumb {\n            margin-right: 0;\n          }\n        }\n        .page-body {\n          min-height: calc(100vh - 60px);\n        }\n      }\n      .page-header {\n        margin-right: 0;\n      }\n      &.compact-wrapper {\n        .page-header {\n          margin-right: 0 !important;\n          margin-left: unset !important;\n        }\n        .page-body-wrapper {\n          &.sidebar-wrapper {\n            &.close_icon {\n              transform: translate(285px);\n            }\n          }\n        }\n      }\n    }\n    .card-body {\n      .value-left {\n        margin-left: 20px;\n      }\n    }\n    .bookmark {\n      ul {\n        li {\n          .search-form {\n            .form-control-search {\n              left: -127px;\n            }\n          }\n        }\n      }\n    }\n    .card {\n      .card-header {\n        .card-header-right {\n          left: 15px;\n        }\n      }\n    }\n  }\n  @media only screen and (max-width: 991px) and (min-width: 768px) {\n    .page-wrapper {\n      &.compact-wrapper {\n        &.material-type {\n          .page-body-wrapper {\n            div.sidebar-wrapper {\n              left: unset;\n              right: 0;\n            }\n          }\n        }\n      }\n    }\n  }\n  @media (min-width: 768px) {\n    .float-md-end {\n      float: left !important;\n    }\n    .text-md-end {\n      text-align: left !important;\n    }\n    .offset-md-3 {\n      margin-right: 25%;\n      margin-left: unset;\n    }\n    .text-md-start {\n      text-align: right !important;\n    }\n    .ecommerce-widget {\n      .text-md-end {\n        text-align: left !important;\n        ul {\n          text-align: left;\n        }\n      }\n    }\n  }\n  @media only screen and (max-width: 767.98px) {\n    .list-persons {\n      .profile-mail {\n        .email-general {\n          ul {\n            padding-left: 0;\n          }\n        }\n      }\n    }\n    .product-wrapper {\n      &.sidebaron {\n        .product-grid {\n          .product-wrapper-grid {\n            margin-right: 0;\n          }\n        }\n      }\n    }\n    .product-sidebar {\n      transform: translateX(300px) scaleX(1);\n      &.open {\n        transform: translateX(0px) scaleX(1);\n      }\n    }\n    .feature-products {\n      .filter-toggle {\n        margin-right: 10px;\n        margin-left: unset;\n      }\n    }\n    .user-profile {\n      .hovercard {\n        .user-image {\n          .share-icons {\n            left: 25px !important;\n          }\n        }\n      }\n    }\n    .ecommerce-widget {\n      .text-md-right {\n        text-align: left !important;\n      }\n    }\n    .bar-chart-widget {\n      .earning-details {\n        i {\n          left: -147px !important;\n        }\n      }\n    }\n  }\n  @media (min-width: 576px) {\n    .offset-sm-3 {\n      margin-right: 25%;\n      margin-left: unset;\n    }\n    .text-sm-end {\n      text-align: left !important;\n    }\n    .float-sm-end {\n      float: left !important;\n    }\n    .me-sm-2 {\n      margin-left: 0.5rem !important;\n      margin-right: unset !important;\n    }\n  }\n  @media only screen and (max-width: 575.98px) {\n    .todo {\n      .todo-list-wrapper {\n        .mark-all-tasks {\n          left: 15px;\n        }\n      }\n    }\n    .list-persons {\n      .nav-pills {\n        .nav-link {\n          .media {\n            .media-body {\n              text-align: right;\n            }\n          }\n        }\n      }\n    }\n    .mega-menu {\n      padding-left: unset;\n      padding-right: 15px;\n    }\n    .page-wrapper {\n      .page-header {\n        .header-wrapper {\n          .nav-right {\n            > ul {\n              li {\n                margin-right: unset;\n                margin-left: 1px;\n              }\n            }\n          }\n          .search-full {\n            .form-group {\n              .close-search {\n                left: 0;\n              }\n            }\n          }\n        }\n      }\n      &.compact-wrapper,\n      &.compact-sidebar {\n        .page-header {\n          .header-wrapper {\n            .toggle-sidebar {\n              margin-left: 8px;\n              padding-left: 8px;\n              margin-right: unset;\n              padding-right: unset;\n              border-right: unset;\n              border-left: 1px solid #ddd;\n            }\n          }\n        }\n      }\n    }\n    .translate_wrapper {\n      &.active {\n        .more_lang {\n          &.active {\n            left: unset;\n            right: 12px;\n          }\n        }\n      }\n    }\n    .page-header {\n      .header-wrapper {\n        .nav-right {\n          > ul {\n            > li {\n              &:last-child {\n                padding-right: 10px;\n              }\n            }\n          }\n          &.right-header {\n            ul {\n              &.notification-dropdown {\n                left: unset !important;\n                right: 15px !important;\n              }\n            }\n          }\n        }\n      }\n    }\n    .faq-accordion {\n      .faq-header {\n        svg {\n          left: 15px;\n        }\n      }\n    }\n    .user-profile {\n      .hovercard {\n        .user-image {\n          .share-icons {\n            left: 15px !important;\n            li {\n              margin-left: 0px;\n            }\n          }\n        }\n      }\n    }\n    .main {\n      .langChoice {\n        left: 15px;\n      }\n    }\n    .page-wrapper {\n      .search-form {\n        .form-group {\n          margin-left: 0;\n        }\n      }\n    }\n    .card-body {\n      .value-left {\n        margin-left: 15px;\n      }\n    }\n  }\n  @media only screen and (max-width: 480px) {\n    .page-wrapper {\n      .page-header {\n        .header-wrapper {\n          .nav-right {\n            .onhover-show-div {\n              right: unset;\n              left: 20px;\n            }\n          }\n        }\n      }\n    }\n    .knob-chart {\n      .chart-clock-main {\n        width: unset;\n        .clock-small {\n          right: 32px;\n        }\n        .clock-large {\n          right: 0;\n          left: unset;\n        }\n        .clock-medium {\n          right: 32px;\n          left: unset;\n        }\n      }\n    }\n  }\n  @media only screen and (max-width: 420px) {\n    .page-wrapper {\n      &.compact-sidebar {\n        .page-body-wrapper {\n          div.sidebar-wrapper {\n            .sidebar-main {\n              .sidebar-links {\n                li {\n                  .sidebar-submenu,\n                  .mega-menu-container {\n                    right: 112px;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n      &.compact-small {\n        .page-body-wrapper {\n          div.sidebar-wrapper {\n            .sidebar-main {\n              .sidebar-links {\n                li {\n                  .sidebar-submenu,\n                  .mega-menu-container {\n                    right: 80px;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  @media only screen and (max-width: 360px) {\n    .prooduct-details-box {\n      .close {\n        left: 0;\n      }\n    }\n    .social-app-profile {\n      .hovercard {\n        .user-image {\n          .avatar {\n            img {\n              width: 85px;\n              height: 85px;\n            }\n            margin-top: -47px;\n          }\n        }\n      }\n    }\n    .social-chat {\n      .other-msg {\n        margin-right: 15px;\n      }\n    }\n  }\n  @media screen and (max-width: 1460px) {\n    .sidebar-wrapper {\n      .sidebar-main {\n        .sidebar-links {\n          > li {\n            margin-left: 8px;\n            margin-right: unset;\n          }\n        }\n      }\n    }\n  }\n}\n@media screen and (min-width: 992px) {\n  .page-wrapper.horizontal-wrapper .page-body-wrapper .sidebar-main .sidebar-links > li:hover .sidebar-submenu {\n    margin-top: 8px;\n    opacity: 1;\n    transition: all 0.5s ease;\n    visibility: visible;\n  }\n}\n\n/**=====================\n    60. RTL CSS Ends\n==========================**/\n","/**=====================\n    63. Box-layout CSS start\n==========================**/\n\n.box-layout {\n  background-image: url(../../images/other-images/boxbg.jpg);\n  background-blend-mode: overlay;\n  background-color: rgba($white, 0.5);\n\n  @media only screen and (min-width: 1280px) {\n    .learning-filter {\n      order: -1;\n    }\n    .md-sidebar {\n      .md-sidebar-toggle {\n        display: block;\n      }\n      .md-sidebar-aside {\n        position: absolute;\n        top: 40px;\n        left: 0;\n        opacity: 0;\n        visibility: hidden;\n        z-index: 3;\n        width: 280px;\n        &.open {\n          opacity: 1;\n          visibility: visible;\n        }\n      }\n    }\n    .job-sidebar {\n      background-color: var(--white);\n      padding: 20px;\n    }\n    .widget-1 {\n      &.mb-xl-0 {\n        margin-bottom: 25px !important;\n      }\n    }\n    .radial-progress-card {\n      .radial-chart-wrap {\n        margin-right: -10px;\n      }\n    }\n    .currency-widget {\n      div[class*='bg-light-'] {\n        display: none;\n      }\n    }\n    .box-order {\n      .order-1 {\n        order: 1 !important;\n      }\n    }\n    .activity-card {\n      .appointment-table {\n        &.customer-table {\n          height: 187px;\n        }\n      }\n    }\n    .transaction-table {\n      tr {\n        td {\n          &:first-child {\n            min-width: 150px;\n          }\n        }\n      }\n    }\n    .welcome-card {\n      .welcome-img {\n        height: 170px;\n        bottom: -22px;\n      }\n    }\n    .purchase-card {\n      img {\n        margin: -210px auto 0;\n        width: 80%;\n      }\n      &.discover {\n        margin-top: 90px;\n        img {\n          margin-top: -90px;\n          width: 64%;\n        }\n      }\n    }\n    .apache-cotainer-large,\n    #line-visual,\n    #line-visulH {\n      > div,\n      canvas {\n        width: 100% !important;\n      }\n    }\n\n    .page-wrapper,\n    &.page-wrapper {\n      &.box-layout {\n        padding-top: 40px;\n        margin-top: 0 !important;\n      }\n      &.compact-wrapper {\n        margin-top: $box-layout-space;\n\n        .page-body-wrapper {\n          .sidebar-wrapper {\n            width: 230px;\n            top: $box-layout-space;\n            border-radius: 10px 0 0 10px;\n\n            &.close_icon {\n              ~ footer {\n                width: 1200px;\n                left: 47%;\n              }\n\n              ~ .footer-fix {\n                padding-left: 0;\n              }\n\n              .sidebar-main {\n                .sidebar-links {\n                  height: calc(100vh - 196px);\n                }\n              }\n            }\n\n            .logo-wrapper {\n              box-shadow: 0 8px 6px -6px rgba(89, 102, 122, 0.1);\n            }\n\n            .sidebar-main {\n              .sidebar-links {\n                margin-top: 10px;\n                margin-bottom: 20px;\n                height: calc(100vh - 191px);\n              }\n            }\n          }\n\n          .page-body {\n            min-height: calc(100vh - 130px);\n            margin-top: 0;\n            top: 80px;\n            overflow: scroll;\n            max-height: calc(100vh - 220px);\n            padding-bottom: 80px;\n            margin-left: 230px;\n\n            &::-webkit-scrollbar-track {\n              -webkit-box-shadow: inset 0 0 6px $light-gray;\n            }\n\n            &::-webkit-scrollbar {\n              width: 6px;\n            }\n\n            &::-webkit-scrollbar-thumb {\n              background-color: rgba(68, 102, 242, 0.15);\n            }\n          }\n        }\n      }\n\n      &.compact-sidebar {\n        .page-header {\n          padding-left: 148px;\n        }\n\n        .page-body-wrapper {\n          margin-top: 40px;\n\n          div.sidebar-wrapper {\n            top: 40px;\n\n            &.close_icon {\n              display: none;\n              transition: 0.5s;\n            }\n\n            .sidebar-main {\n              .sidebar-links {\n                height: calc(100vh - 166px);\n                margin: 0;\n\n                li {\n                  .sidebar-submenu,\n                  .mega-menu-container {\n                    left: 470px;\n                    top: 40px;\n                    height: calc(100vh - 84px);\n                  }\n\n                  a {\n                    &.active {\n                      ~ .sidebar-submenu,\n                      ~ .mega-menu-container {\n                        animation: unset;\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n\n          .footer {\n            margin-left: 0;\n          }\n\n          .page-body {\n            min-height: calc(100vh - 90px);\n            margin-top: 0;\n            top: 80px;\n            overflow: scroll;\n            max-height: calc(100vh - 170px);\n            padding-bottom: 80px;\n\n            &::-webkit-scrollbar-track {\n              -webkit-box-shadow: inset 0 0 6px $light-gray;\n            }\n\n            &::-webkit-scrollbar {\n              width: 6px;\n            }\n\n            &::-webkit-scrollbar-thumb {\n              background-color: rgba(68, 102, 242, 0.15);\n            }\n          }\n        }\n\n        &.compact-small {\n          .page-header {\n            padding-left: 90px;\n\n            &.close_icon {\n              padding-left: 0;\n            }\n          }\n\n          .page-body-wrapper {\n            div.sidebar-wrapper {\n              .sidebar-main {\n                .sidebar-links {\n                  li {\n                    .sidebar-submenu,\n                    .mega-menu-container {\n                      left: 410px;\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n\n      &.horizontal-wrapper {\n        &:before {\n          display: none;\n        }\n\n        .page-body-wrapper {\n          margin-top: 40px;\n\n          .page-body {\n            margin-top: 80px;\n            min-height: calc(100vh - 310px);\n            max-height: calc(100vh - 230px);\n            overflow: scroll;\n\n            &::-webkit-scrollbar-track {\n              -webkit-box-shadow: inset 0 0 6px $light-gray;\n            }\n\n            &::-webkit-scrollbar {\n              width: 6px;\n            }\n\n            &::-webkit-scrollbar-thumb {\n              background-color: rgba(68, 102, 242, 0.15);\n            }\n          }\n\n          .footer {\n            padding-left: 15px;\n          }\n\n          .sidebar-wrapper {\n            width: 1280px;\n            top: 80px;\n            margin: 0;\n            overflow-x: unset;\n            position: relative;\n\n            .sidebar-main {\n              #sidebar-menu {\n                left: 0%;\n                transform: translate(0, 0);\n                top: 125px;\n                background-color: $white;\n              }\n            }\n          }\n        }\n\n        .page-header {\n          padding-left: 0;\n        }\n      }\n\n      &.modern-type {\n        .page-header {\n          padding-left: 0px;\n\n          .header-wrapper {\n            .left-header {\n              width: 36%;\n            }\n            .nav-right {\n              width: 46%;\n            }\n          }\n        }\n\n        .page-body-wrapper {\n          .page-body {\n            margin-left: 260px;\n          }\n\n          .sidebar-wrapper {\n            top: 120px;\n\n            .sidebar-main {\n              .sidebar-links {\n                height: calc(100vh - 311px);\n              }\n            }\n\n            &.close_icon {\n              .sidebar-main {\n                .sidebar-links {\n                  height: calc(100vh - 316px);\n                }\n              }\n\n              ~ footer {\n                width: 1280px;\n                left: 50%;\n                margin-left: 0;\n              }\n            }\n          }\n\n          .footer {\n            margin-left: 0;\n          }\n        }\n      }\n\n      .page-header {\n        max-width: 1280px;\n        margin: 0 auto;\n        left: 0;\n        right: 0;\n        transition: $sidebar-transition;\n        padding-left: 230px;\n        margin-top: $box-layout-space;\n        border-radius: 10px;\n        width: unset;\n\n        &.close_icon {\n          padding-left: 0;\n          margin-left: auto;\n          width: calc(100% - 0px);\n          transition: $sidebar-transition;\n        }\n\n        .header-wrapper {\n          border: 1px solid #f8f8f8;\n          border-radius: 10px 10px 0 0;\n        }\n      }\n\n      &.horizontal-wrapper {\n        .page-header {\n          .header-wrapper {\n            .nav-right,\n            .left-header {\n              width: 36%;\n            }\n          }\n        }\n      }\n\n      &.material-type {\n        .page-body-wrapper {\n          margin-top: 0;\n\n          .page-body {\n            margin-top: 0;\n          }\n\n          .sidebar-wrapper {\n            top: 0;\n          }\n        }\n      }\n\n      &.material-icon {\n        .page-header {\n          &.close_icon {\n            margin-top: 40px !important;\n          }\n        }\n\n        .page-body-wrapper {\n          margin-top: 0;\n\n          .page-body {\n            top: 0;\n            min-height: calc(100vh - 170px);\n            padding-bottom: 40px;\n          }\n        }\n      }\n\n      &.advance-layout {\n        .page-header {\n          box-shadow: 0px 0px 10px rgba($black, 0.07);\n        }\n\n        .page-body-wrapper {\n          margin-top: 0;\n        }\n      }\n\n      .page-body-wrapper {\n        width: 1280px;\n        box-shadow: 4px 11px 25px rgba(0, 0, 0, 0.07);\n        margin: 0 auto;\n        overflow: hidden;\n\n        .todo {\n          .todo-list-wrapper {\n            #todo-list {\n              li {\n                .task-responsive {\n                  min-width: 1087px;\n                  overflow: auto;\n                }\n              }\n            }\n          }\n        }\n\n        .active-order-table {\n          max-width: 443px;\n          overflow: auto;\n\n          table {\n            tbody {\n              tr {\n                td {\n                  p {\n                    width: 100px;\n                  }\n                }\n              }\n            }\n          }\n        }\n\n        .activity {\n          .media {\n            .gradient-round {\n              &.gradient-line-1 {\n                &:after {\n                  height: 57px;\n                  bottom: -64px;\n                }\n              }\n\n              &.small-line {\n                &:after {\n                  height: 36px;\n                  bottom: -43px;\n                }\n              }\n\n              &.medium-line {\n                &:after {\n                  height: 40px;\n                  bottom: -48px;\n                }\n              }\n            }\n          }\n        }\n\n        footer {\n          width: 1280px;\n          margin: 0 auto;\n          padding-left: 230px;\n          margin-bottom: 40px !important;\n          position: fixed;\n          left: 50%;\n          transform: translate(-50%, 0);\n          border-radius: 0 0 10px;\n        }\n\n        .blockquote-footer {\n          margin-left: 0;\n          width: 100%;\n        }\n\n        .footer-fix {\n          padding-left: 230px;\n        }\n\n        .chat-box {\n          .chat-history {\n            .call-content {\n              display: flex;\n              align-items: center;\n              justify-content: center;\n              min-width: 300px;\n\n              > div {\n                z-index: 8;\n                background-color: rgba(255, 255, 255, 0.75);\n                background-blend-mode: overlay;\n                width: 100%;\n                padding: 30px;\n                left: 15px;\n              }\n\n              button {\n                width: 40%;\n                font-size: 14px;\n                margin: 0 auto;\n              }\n            }\n\n            .call-icons {\n              margin-top: 20px;\n              margin-bottom: 20px;\n\n              ul {\n                li {\n                  border: 1px solid #717171;\n                  width: 50px;\n                  height: 50px;\n                  padding: 8px;\n                }\n              }\n            }\n\n            .receiver-img {\n              margin-top: 30px;\n              margin-bottom: 30px;\n\n              img {\n                width: 38%;\n              }\n            }\n\n            .total-time {\n              h2 {\n                font-size: 28px;\n                color: #717171;\n              }\n            }\n          }\n        }\n\n        canvas {\n          &#myLineCharts {\n            width: 100%;\n          }\n        }\n\n        .chat-right-aside {\n          flex: 0 0 60%;\n          max-width: 60%;\n          overflow: hidden;\n        }\n\n        .caller-img {\n          position: absolute;\n          width: 100%;\n          max-width: 100%;\n          left: 15px;\n\n          img {\n            opacity: 0.7;\n          }\n        }\n\n        .browser-widget {\n          img {\n            height: 65px;\n          }\n        }\n\n        .custom-card {\n          .card-header {\n            img {\n              margin-top: -73px;\n            }\n          }\n\n          .card-profile {\n            img {\n              height: 130px;\n              top: -17px;\n            }\n          }\n        }\n\n        .select2 {\n          width: 901.781px;\n        }\n      }\n\n      ul {\n        &.close_icon {\n          > li {\n            label {\n              padding: 0;\n\n              &:after {\n                display: none;\n              }\n            }\n          }\n        }\n      }\n\n      .bookmark {\n        ul {\n          margin-right: -1px;\n        }\n      }\n\n      #batchDelete {\n        .jsgrid-grid-header {\n          .jsgrid-table {\n            tr {\n              th {\n                .btn {\n                  padding-left: 20px;\n                  padding-right: 20px;\n                }\n              }\n            }\n          }\n        }\n      }\n\n      .btn-group-showcase {\n        .btn-radio {\n          .btn-group {\n            .radio {\n              input[type='radio'] {\n                display: none;\n              }\n            }\n          }\n        }\n      }\n\n      .media.bitcoin-graph {\n        display: block;\n\n        .top-bitcoin {\n          display: inline-block;\n          vertical-align: middle;\n        }\n\n        .media-body {\n          margin-top: 30px;\n\n          .bitcoin-content {\n            .bitcoin-numbers {\n              h6 {\n                font-size: 14px;\n              }\n            }\n\n            &.text-right {\n              text-align: center !important;\n            }\n          }\n        }\n      }\n\n      .alert {\n        &.inverse {\n          p {\n            max-width: 238px;\n            display: block;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n          }\n        }\n      }\n\n      .auth-bg-effect {\n        .second-effect {\n          left: 55%;\n        }\n      }\n\n      .auth-bg-video {\n        video {\n          min-width: 67%;\n          width: 67%;\n        }\n      }\n\n      .page-builder {\n        .ge-canvas.ge-layout-desktop {\n          margin-top: $box-layout-space;\n        }\n\n        .ge-addRowGroup {\n          margin-bottom: 10px;\n        }\n      }\n\n      .pricing-wrapper-card {\n        padding: 50px 20px;\n      }\n\n      .card {\n        .blog-box {\n          &.blog-grid {\n            &.set-min-height {\n              min-height: 400px;\n            }\n          }\n        }\n      }\n\n      .flot-chart-placeholder {\n        &#donut-color-chart-morris-daily {\n          min-height: 430px;\n        }\n      }\n\n      .flot-chart-placeholder {\n        &#donut-color-chart-morris {\n          min-height: 430px;\n        }\n      }\n\n      .box-col-12 {\n        flex: 0 0 100%;\n        max-width: 100%;\n      }\n\n      .box-col-6 {\n        flex: 0 0 50%;\n        max-width: 50%;\n      }\n\n      .box-col-3 {\n        flex: 0 0 25%;\n        max-width: 25%;\n      }\n\n      .box-col-7 {\n        flex: 0 0 60%;\n        max-width: 60%;\n      }\n\n      .box-col-5 {\n        flex: 0 0 40%;\n        max-width: 40%;\n      }\n\n      .box-col-8 {\n        flex: 0 0 70%;\n        max-width: 70%;\n      }\n\n      .box-col-4e {\n        flex: 0 0 30%;\n        max-width: 30%;\n      }\n\n      .box-col-4 {\n        flex: 0 0 33.33%;\n        max-width: 33%;\n      }\n\n      .box-col-8e {\n        flex: 0 0 66.67%;\n        max-width: 66.67%;\n      }\n\n      .box-col-none {\n        display: none !important;\n      }\n\n      .chat-box {\n        .chat-right-aside {\n          .chat {\n            .chat-header {\n              .chat-menu-icons {\n                li {\n                  a {\n                    i {\n                      font-size: 19px;\n                    }\n                  }\n                }\n              }\n            }\n          }\n\n          flex: 0 0 100%;\n          max-width: calc(100% - 15px);\n          overflow: hidden;\n        }\n\n        .toogle-bar {\n          display: inline-block;\n          margin-right: 0 !important;\n        }\n      }\n\n      .chat-menu {\n        right: 0;\n        border-top: 1px solid #ddd;\n        opacity: 0;\n        transform: translateY(-30px);\n        visibility: hidden;\n        top: 81px;\n        position: absolute;\n        z-index: 9;\n        background-color: #fff;\n        transition: all linear 0.3s;\n\n        &.show {\n          opacity: 1;\n          visibility: visible;\n          transform: translateY(0px);\n          transition: all linear 0.3s;\n          padding-bottom: 25px;\n        }\n      }\n\n      .ct-10.total-chart {\n        .ct-chart-bar {\n          .ct-series {\n            .ct-bar {\n              stroke-width: 23px !important;\n            }\n          }\n        }\n      }\n\n      .social-app-profile {\n        #friends {\n          .box-col-4 {\n            flex: 0 0 30%;\n            max-width: 30%;\n          }\n        }\n      }\n\n      .email-wrap {\n        .email-body {\n          .email-compose {\n            .cke_contents {\n              &.cke_reset {\n                max-height: 165px;\n              }\n            }\n          }\n        }\n\n        .row {\n          .col-xl-6 {\n            padding-left: 12px;\n          }\n\n          .col-xl-3 {\n            + .col-xl-3 {\n              padding-right: 12px;\n            }\n          }\n        }\n\n        .email-right-aside {\n          .email-body {\n            .inbox {\n              height: 644px;\n            }\n          }\n        }\n\n        .email-content {\n          .email-top {\n            .user-emailid {\n              &:after {\n                right: -10px;\n              }\n            }\n          }\n        }\n      }\n\n      .todo {\n        .notification-popup {\n          right: 320px;\n        }\n      }\n\n      .touchspin {\n        padding: 0 10px;\n      }\n\n      .vertical-menu-main {\n        width: 1280px;\n        margin: 0 auto;\n        left: 0;\n        right: 0;\n\n        .mega-menu {\n          width: 1050px !important;\n          max-width: 1050px !important;\n          left: -320px !important;\n        }\n      }\n\n      .comingsoon {\n        video {\n          min-width: 67%;\n          width: 67%;\n        }\n      }\n    }\n  }\n}\n\n/**=====================\n    63. Box-layout CSS ends\n==========================**/\n","/**=====================\n55. theme layout CSS Start\n==========================**/\n\nbody {\n  &.dark-only {\n    color: $dark-all-font-color;\n    background-color: $dark-body-background;\n    .page-body {\n      .bg-light {\n        background-color: $dark-body-background !important;\n      }\n    }\n\n    .edit-profile .card .card-body form .row a h5 {\n      color: rgb(255 255 255 / 70%);\n    }\n\n    .wizard-4 {\n      .step-container {\n        background-color: $dark-card-background;\n        border-color: $dark-card-border;\n      }\n      .login-card {\n        .login-main {\n          background-color: $dark-body-background;\n        }\n      }\n    }\n    .icon-state {\n      .switch-state {\n        &:after {\n          color: $dark-all-font-color;\n        }\n      }\n    }\n    .kanban-board-header {\n      background-color: $dark-body-background !important;\n      border-bottom: 1px solid $dark-card-background !important;\n    }\n    .kanban-container {\n      .kanban-item {\n        .kanban-box {\n          border: 1px solid rgba($primary-color, 0.15);\n          background-color: $dark-body-background;\n        }\n      }\n    }\n    // mde editor\n    .editor-toolbar {\n      border-top: 1px solid $dark-card-border;\n      border-left: 1px solid $dark-card-border;\n      border-right: 1px solid $dark-card-border;\n      a {\n        color: $dark-all-font-color !important;\n        &:hover,\n        &.active {\n          background: $dark-card-border;\n        }\n      }\n      i.separator {\n        border-left: 1px solid $dark-card-border;\n        border-right: 1px solid $dark-card-border;\n      }\n      button {\n        color: $dark-all-font-color;\n        &:hover,\n        &:focus,\n        &.active {\n          background: $dark-body-background;\n          border-color: $dark-card-border$dark-card-border;\n        }\n      }\n      &.fullscreen {\n        &::before,\n        &::after {\n          background: linear-gradient(to right, $dark-body-background 0, $dark-body-background 100%);\n        }\n      }\n    }\n    .editor-toolbar.disabled-for-preview {\n      a {\n        &:not(.no-disable) {\n          background: $dark-card-border;\n        }\n      }\n    }\n    .editor-preview {\n      background-color: $dark-card-background;\n    }\n    .editor-toolbar.fullscreen,\n    .editor-preview-side {\n      background: $dark-card-background;\n      border: 1px solid $dark-small-font-color;\n    }\n    .editor-toolbar.disabled-for-preview {\n      a {\n        &:not(.no-disable) {\n          background: $dark-card-border;\n        }\n      }\n    }\n\n    .editor-preview {\n      background-color: $dark-card-background;\n    }\n\n    .editor-toolbar.fullscreen,\n    .editor-preview-side {\n      background: $dark-card-background;\n      border: 1px solid $dark-small-font-color;\n    }\n\n    .knowledgebase-search {\n      color: $theme-body-font-color;\n      .form-inline {\n        .form-control {\n          background: transparent !important;\n          border-color: transparent !important;\n        }\n      }\n    }\n    .support-table {\n      .progress {\n        background: $dark-body-background;\n      }\n    }\n    .jkanban-container {\n      .kanban-container {\n        .kanban-drag {\n          > div {\n            > div {\n              .react-kanban-column {\n                > div {\n                  &[data-rbd-drag-handle-context-id=\"0\"],\n                  &[data-rbd-drag-handle-context-id=\"2\"] {\n                    border-bottom: 1px solid $dark-card-border;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    .jkanban-container {\n      .kanban-container {\n        .kanban-drag {\n          > div {\n            > div {\n              .react-kanban-column {\n                > div {\n                  &[data-rbd-drag-handle-context-id=\"0\"],\n                  &[data-rbd-drag-handle-context-id=\"2\"] {\n                    border-bottom: 1px solid $dark-card-border;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    .jkanban-container {\n      .kanban-container {\n        .kanban-drag {\n          > div {\n            > div {\n              .react-kanban-column {\n                background-color: $dark-body-background;\n              }\n            }\n          }\n        }\n      }\n    }\n    .react-kanban-column {\n      background-color: $dark-body-background;\n      .react-kanban-card {\n        background-color: $dark-card-background;\n        .react-kanban-card__title {\n          border-bottom: 1px solid $dark-card-border;\n        }\n      }\n    }\n    .jkanban-container {\n      .kanban-container {\n        .kanban-item {\n          .kanban-box {\n            background-color: $dark-card-background !important;\n            color: $dark-all-font-color;\n          }\n        }\n      }\n    }\n    .jkanban-container {\n      .kanban-container {\n        .kanban-item {\n          .kanban-box {\n            background-color: $dark-card-background !important;\n            color: $dark-all-font-color;\n          }\n        }\n      }\n    }\n    .jkanban-container {\n      .kanban-container {\n        .kanban-item {\n          .kanban-box {\n            background-color: $dark-card-background !important;\n            color: $dark-all-font-color;\n          }\n        }\n      }\n    }\n\n    // kanban board\n    .kanban-container {\n      .kanban-item {\n        .kanban-box {\n          background-color: $dark-card-background;\n        }\n      }\n    }\n    .jkanban-container {\n      .kanban-container {\n        .kanban-item {\n          .kanban-box {\n            border: 1px solid $dark-card-border;\n          }\n        }\n      }\n    }\n    .rdt_TableRow {\n      &:nth-of-type(odd) {\n        color: $dark-all-font-color;\n        background-color: $dark-body-background;\n      }\n      &:nth-of-type(even) {\n        color: $dark-all-font-color;\n        background-color: $dark-card-background;\n      }\n      &:hover {\n        border-color: $dark-card-background !important;\n      }\n    }\n    .product-table {\n      .rdt_TableBody {\n        .rdt_TableRow {\n          .rdt_TableCell {\n            color: $theme-font-color;\n          }\n          .rdt_TableCell:first-child {\n            background-color: $dark-body-background;\n          }\n          .rdt_TableCell:nth-child(n + 2) {\n            background-color: $dark-card-background;\n          }\n        }\n        .rdt_TableRow:nth-child(odd) {\n          .rdt_TableCell:first-child {\n            background-color: $dark-card-background;\n          }\n          .rdt_TableCell:nth-child(n + 2) {\n            background-color: $dark-body-background;\n          }\n        }\n      }\n    }\n    .product-table {\n      .rdt_TableBody {\n        .rdt_TableRow {\n          .rdt_TableCell:first-child {\n            background-color: $dark-body-background;\n          }\n          .rdt_TableCell:nth-child(n + 2) {\n            background-color: $dark-card-background;\n          }\n        }\n        .rdt_TableRow:nth-child(odd) {\n          .rdt_TableCell:first-child {\n            background-color: $dark-card-background;\n          }\n          .rdt_TableCell:nth-child(n + 2) {\n            background-color: $dark-body-background;\n          }\n        }\n      }\n    }\n    .social-widget {\n      .social-icons {\n        box-shadow: 0px 42.1092px 27.8569px $dark-body-background, 0px 8.90772px 7.12618px $dark-body-background, 0px 2.02448px 3.44162px $dark-body-background;\n      }\n    }\n    .calendar-basic {\n      .md-sidebar-aside {\n        background: $dark-card-background;\n      }\n      #external-events {\n        border-color: $dark-card-border;\n      }\n      .calendar-default {\n        .fc {\n          .fc-daygrid-day-number,\n          .fc-col-header-cell-cushion {\n            color: $dark-all-font-color;\n          }\n        }\n      }\n    }\n    .clockpicker-popover {\n      .popover-title {\n        background-color: $dark-card-background;\n      }\n      &.bottom {\n        > .arrow {\n          border-bottom-color: $dark-body-background;\n          &:after {\n            border-bottom-color: $dark-card-background;\n          }\n        }\n      }\n      &.top {\n        > .arrow {\n          border-top-color: $dark-body-background;\n          &::after {\n            border-top-color: $dark-card-background;\n          }\n        }\n      }\n      &.left {\n        > .arrow {\n          border-left-color: $dark-body-background;\n          &::after {\n            border-left-color: $dark-card-background;\n          }\n        }\n      }\n      .popover-title {\n        border-bottom-color: $dark-card-background;\n      }\n    }\n    .fc-theme-standard {\n      .fc-scrollgrid,\n      .fc-list {\n        border-color: $dark-card-border;\n      }\n      .fc-list-day-cushion {\n        background-color: $dark-body-background;\n      }\n    }\n    .fc {\n      .fc-list-event {\n        &:hover {\n          td {\n            background-color: $dark-body-background;\n          }\n        }\n      }\n    }\n    .view-container {\n      .apexcharts-canvas {\n        .apexcharts-point-annotations {\n          circle {\n            outline: 25px solid #3e3d7259;\n          }\n        }\n      }\n    }\n\n    // timeline css\n    .vertical-timeline-element-content {\n      background-color: $dark-body-background;\n      .vertical-timeline-element-content-arrow {\n        border-right: 7px solid $dark-body-background;\n      }\n    }\n    .vertical-timeline {\n      &::before {\n        background: $dark-body-background;\n      }\n    }\n    .vertical-timeline-element-icon {\n      box-shadow: 0 0 0 4px $dark-body-background, inset 0 2px 0 rgba($black, 0.08), 0 3px 0 4px rgba($black, 0.05);\n    }\n\n    // crypto dashboard\n    .currency-widget {\n      div[class*=\"bg-light-\"] {\n        color: $dark-all-font-color;\n      }\n    }\n    .btn {\n      &.badge-light-primary {\n        &:hover {\n          color: rgba($white, 0.6);\n        }\n      }\n    }\n    .portfolio-chart-container {\n      .apexcharts-canvas {\n        .apexcharts-radialbar {\n          image {\n            display: none;\n          }\n        }\n      }\n    }\n    // online course dashboard css start\n    svg.f-light {\n      fill: rgba($white, 0.6);\n      opacity: 1;\n    }\n    .course-widget {\n      .btn-light {\n        background-color: $dark-body-background !important;\n      }\n    }\n    .schedule-list {\n      > li {\n        box-shadow: 4px 7px 17px 5px rgba($dark-body-background, 0.2);\n      }\n    }\n    .upcoming-event-wrap {\n      .apexcharts-canvas {\n        .apexcharts-data-labels {\n          rect {\n            fill: none;\n            stroke: none;\n          }\n        }\n      }\n    }\n    // online course dashboard  css end\n    .page-wrapper {\n      &.advance-layout {\n        .page-header {\n          background: $dark-card-background;\n        }\n        .page-body-wrapper {\n          .sidebar-wrapper {\n            border-bottom: 1px solid $dark-card-border;\n          }\n        }\n      }\n      &.only-body {\n        background: $dark-body-background;\n      }\n    }\n    .balance-card {\n      .svg-box {\n        background: $dark-card-background;\n        box-shadow: none;\n        svg {\n          fill: $dark-all-font-color;\n        }\n      }\n    }\n    .f-light {\n      color: $dark-all-font-color;\n    }\n    .apexcharts-tooltip.light {\n      .apexcharts-tooltip-title {\n        background: $dark-card-background;\n        color: $white;\n      }\n    }\n    .card {\n      background-color: $dark-card-background;\n    }\n    .ecommerce-widget {\n      border: 1px solid $dark-card-border !important;\n    }\n    .btn-light {\n      color: $dark-all-font-color !important;\n    }\n    .form-select {\n      color: $dark-all-font-color;\n    }\n    .add-project {\n      .text-inherit {\n        color: $dark-all-font-color;\n      }\n    }\n    .knowledgebase-search {\n      color: $theme-body-font-color;\n      .form-control-plaintext {\n        color: $theme-body-font-color;\n      }\n    }\n    .btn-close {\n      filter: brightness(0.8) invert(1);\n    }\n    .prooduct-details-box {\n      .media {\n        border: 1px solid $dark-card-border;\n      }\n    }\n    .product-price {\n      del {\n        color: $dark-small-font-color;\n      }\n    }\n    .ProfileCard {\n      border: 1px solid $dark-card-border !important;\n    }\n    .form-control-plaintext {\n      color: $dark-all-font-color;\n    }\n    .form-select {\n      background-color: $dark-body-background;\n      border: 1px solid $dark-border-color;\n    }\n    .box-layout {\n      background-color: $dark-body-background;\n\n      .page-wrapper,\n      &.page-wrapper {\n        .page-header {\n          .header-wrapper {\n            border: 1px solid $dark-border-color;\n          }\n        }\n      }\n    }\n    .form-check-input {\n      background-color: $dark-body-background;\n    }\n    .switch-state {\n      &:before {\n        background-color: $dark-card-background;\n      }\n    }\n    // react datatable\n    .rdt_Table {\n      border: 1px solid $dark-card-border;\n    }\n    .rdt_TableHeadRow {\n      background-color: $dark-card-background;\n    }\n    .rdt_TableCol,\n    .rdt_TableCol_Sortable,\n    .___react-data-table-allow-propagation___ {\n      color: $dark-all-font-color;\n    }\n    .rdt_TableRow {\n      border &:nth-of-type(odd) {\n        color: $dark-all-font-color;\n        background-color: $dark-body-background;\n      }\n      &:nth-of-type(even) {\n        color: $dark-all-font-color;\n        background-color: $dark-card-background;\n      }\n    }\n    .fpZHHx {\n      fill: $dark-all-font-color;\n      color: $dark-all-font-color;\n    }\n    .rdt_Pagination {\n      background-color: $dark-card-background;\n      border-top-color: $dark-card-border;\n      color: $dark-all-font-color;\n      button {\n        color: $dark-all-font-color;\n        fill: $dark-all-font-color;\n        &:disabled {\n          color: $dark-small-font-color;\n          fill: $dark-small-font-color;\n        }\n      }\n    }\n    .rdt_TableCol_Sortable {\n      &:hover {\n        color: $dark-all-font-color;\n      }\n    }\n    .rdt_TableHeader {\n      background-color: $dark-body-background !important;\n      > div {\n        &:last-child {\n          background-color: $dark-body-background !important;\n          color: $dark-all-font-color;\n        }\n      }\n    }\n    // daterangepicker css start\n    .daterangepicker {\n      &:before {\n        border-bottom-color: $dark-card-background;\n      }\n      .ranges {\n        li {\n          background-color: $dark-body-background;\n          border-color: $dark-card-background;\n          color: $dark-gray;\n        }\n      }\n      .daterangepicker_input {\n        .form-control {\n          background-color: $dark-body-background;\n          border-color: $dark-card-background !important;\n        }\n      }\n      .calendar-time {\n        select {\n          border-color: $dark-card-background;\n          background-color: $dark-body-background;\n        }\n      }\n      &.dropdown-menu {\n        background-color: $dark-card-background;\n        -webkit-box-shadow: 0 0 14px $dark-body-background;\n        box-shadow: 0 0 14px $dark-body-background;\n      }\n      .calendar-table {\n        background-color: $dark-card-background;\n        border-color: $dark-card-background;\n      }\n      &.ltr {\n        td {\n          &.in-range,\n          &.off {\n            background-color: $dark-body-background;\n            color: $white;\n          }\n        }\n      }\n    }\n    // daterangepicker css end\n    // tooltip css start\n    // tooltip css start\n    .tooltip {\n      &.bs-tooltip-top {\n        .tooltip-arrow {\n          &:before {\n            border-top-color: $dark-card-inbox;\n          }\n        }\n      }\n      &.bs-tooltip-bottom {\n        .tooltip-arrow {\n          &:before {\n            border-bottom-color: $dark-card-inbox;\n            border-top-color: $transparent-color;\n          }\n        }\n      }\n      &.bs-tooltip-start {\n        .tooltip-arrow {\n          &:before {\n            border-left-color: $dark-card-inbox;\n            border-top-color: $transparent-color;\n          }\n        }\n      }\n      &.bs-tooltip-end {\n        .tooltip-arrow {\n          &:before {\n            border-right-color: $dark-card-inbox;\n            border-top-color: $transparent-color;\n          }\n        }\n      }\n      .tooltip-inner {\n        background-color: $dark-card-inbox;\n        color: $white;\n      }\n      .tooltip-arrow {\n        &:before {\n          border-top-color: $dark-card-inbox;\n        }\n      }\n    }\n\n    .react-datepicker__time-container {\n      .react-datepicker__time {\n        .react-datepicker__time-box {\n          ul.react-datepicker__time-list {\n            li.react-datepicker__time-list-item {\n              &:hover {\n                background-color: $dark-card-background;\n              }\n            }\n          }\n        }\n      }\n    }\n    .react-datepicker {\n      .react-datepicker__time-container {\n        border-left: 1px solid $dark-card-border;\n      }\n    }\n    .react-datepicker__time-container {\n      .react-datepicker__time {\n        background: $dark-body-background;\n        color: $dark-all-font-color;\n      }\n    }\n    .react-datepicker {\n      background-color: $dark-card-background;\n      .react-datepicker__header {\n        background-color: $dark-card-background !important;\n        border-bottom: 1px solid $dark-card-border;\n      }\n      .react-datepicker__day-name,\n      .react-datepicker__day,\n      .react-datepicker__time-name {\n        color: $dark-all-font-color;\n      }\n      .react-datepicker__day,\n      .react-datepicker__month-text,\n      .react-datepicker__quarter-text,\n      .react-datepicker__year-text {\n        &:hover {\n          background-color: $dark-card-background;\n        }\n      }\n    }\n    .default-datepicker {\n      .react-datepicker {\n        .react-datepicker__month,\n        .react-datepicker__header {\n          background-color: $dark-card-background !important;\n        }\n      }\n    }\n    .default-datepicker {\n      .react-datepicker {\n        background: transparent;\n      }\n      .react-datepicker__day-name,\n      .react-datepicker__day,\n      .react-datepicker__time-name {\n        color: rgba($white, 0.7);\n      }\n      .react-datepicker__day--outside-month {\n        color: $dark-small-font-color;\n      }\n      .react-datepicker__header {\n        border-bottom: 1px solid $dark-card-border;\n      }\n\n      .react-datepicker__day,\n      .react-datepicker__month-text,\n      .react-datepicker__quarter-text,\n      .react-datepicker__year-text {\n        &:hover {\n          background-color: $dark-body-background;\n        }\n      }\n    }\n    // draggable card\n    .draggable-card {\n      > div {\n        > div {\n          div[data-testid=\"lane\"] {\n            background-color: $dark-body-background;\n          }\n          div[data-testid=\"card\"] {\n            > div {\n              > div {\n                background-color: $dark-card-background;\n                span {\n                  > div {\n                    border-bottom: 1px solid $dark-card-border;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    // tooltip css end\n    .page-wrapper {\n      &.only-body {\n        .page-body-wrapper {\n          .page-title {\n            > .row {\n              .col-6 {\n                &:first-child {\n                  h6 {\n                    color: rgba($dark-all-font-color, 0.5);\n                  }\n                }\n              }\n            }\n          }\n        }\n        .page-header {\n          .header-wrapper {\n            .search-full {\n              .form-group {\n                .Typeahead {\n                  .u-posRelative {\n                    background-color: $dark-card-background;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n\n      .page-header {\n        .header-wrapper {\n          .nav-right {\n            .profile-dropdown li span {\n              color: $white;\n            }\n\n            .flip-card .flip-card-inner {\n              .back {\n                background-color: $dark-body-background !important;\n                .flip-back-content {\n                  input {\n                    background-color: $dark-body-background;\n                    border: 1px solid $dark-card-border;\n                    color: $dark-all-font-color;\n                  }\n                }\n                li {\n                  &:last-child {\n                    border-top: 1px solid $dark-card-border;\n                  }\n                }\n              }\n\n              .front {\n                background-color: $dark-body-background !important;\n\n                svg {\n                  stroke: $white;\n                }\n              }\n            }\n\n            .cart-dropdown {\n              .total {\n                background-color: $dark-card-background;\n              }\n              .qty-box {\n                .input-group {\n                  .btn {\n                    color: rgba($white, 0.4);\n                    border-color: $dark-card-background !important;\n                    background-color: $dark-card-background !important;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .qty-box {\n      input {\n        color: rgba($white, 0.5);\n      }\n    }\n\n    .customizer-contain {\n      color: $dark-body-background;\n\n      .customizer-body {\n        .main-layout {\n          .box-layout {\n            background-color: $white;\n          }\n        }\n      }\n    }\n\n    .login-card {\n      .btn-showcase .btn {\n        background-color: $dark-card-background !important;\n        color: #fff;\n        border-color: $dark-card-background !important;\n      }\n\n      .login-main {\n        box-shadow: 0 0 37px rgba($white, 0.05);\n\n        .theme-form {\n          input {\n            background-color: $dark-card-background !important;\n          }\n\n          .or {\n            &:before {\n              background-color: $dark-card-background;\n            }\n          }\n\n          .checkbox label::before {\n            background-color: $dark-card-background !important;\n            border-color: $dark-card-background !important;\n          }\n        }\n      }\n    }\n\n    .H_ui {\n      ~ div {\n        background-color: $dark-body-background !important;\n      }\n    }\n\n    .swal-icon--success:after,\n    .swal-icon--success:before {\n      background: $dark-card-background;\n    }\n\n    .swal-icon--success__hide-corners {\n      background-color: $dark-card-background;\n    }\n\n    .note-editor.note-frame {\n      .note-status-output {\n        border-top: 1px solid $dark-card-background;\n      }\n\n      .note-statusbar {\n        border-top: 1px solid $dark-card-background;\n\n        .note-resizebar {\n          background-color: $dark-card-background;\n        }\n      }\n    }\n\n    .light-font {\n      color: rgba(255, 255, 255, 70%);\n    }\n\n    .page-link {\n      background-color: $dark-body-background;\n      border: 1px solid $dark-card-border;\n    }\n\n    .b-r-light {\n      border-right: 1px solid $dark-card-border !important;\n    }\n\n    .history-details {\n      .media {\n        border-top: 1px solid $dark-card-border;\n      }\n    }\n\n    .modal-header {\n      border-bottom: 1px solid $dark-card-border;\n    }\n\n    #right-history {\n      background-color: $dark-card-background;\n      box-shadow: 0 0 9px $dark-body-background;\n      h6 {\n        span {\n          a {\n            color: $dark-all-font-color;\n          }\n        }\n      }\n    }\n\n    .ProfileCard {\n      &:hover {\n        color: $dark-all-font-color;\n        background-color: $dark-card-background;\n      }\n    }\n\n    .translate_wrapper.active .more_lang {\n      &:before {\n        border-bottom: 7px solid $dark-card-background;\n      }\n\n      .lang {\n        border-bottom: 1px solid $dark-body-background;\n      }\n    }\n\n    .toggle-sidebar {\n      svg {\n        stroke: var(--theme-default);\n      }\n    }\n\n    .page-wrapper {\n      .page-body-wrapper {\n        background-color: $dark-body-background;\n        .page-title {\n          background-color: $dark-card-background;\n          border-bottom: 1px solid $dark-card-border;\n          box-shadow: rgba(0, 0, 0, 0.07) 0px 4px 40px;\n        }\n        div.sidebar-wrapper {\n          .sidebar-main {\n            .sidebar-links {\n              > li {\n                a {\n                  svg {\n                    &.stroke-icon {\n                      stroke: $white;\n                    }\n                    &.fill-icon {\n                      fill: rgba($white, 0.5);\n                      stroke: transparent;\n                    }\n                  }\n                  &.active {\n                    svg {\n                      &.stroke-icon {\n                        stroke: var(--theme-default);\n                      }\n                      &.fill-icon {\n                        fill: var(--theme-default);\n                        stroke: transparent;\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n        .sidebar-main {\n          .sidebar-links {\n            .sidebar-link.active {\n              svg {\n                &.stroke-icon {\n                  stroke: var(--theme-default);\n                }\n              }\n            }\n\n            li {\n              a {\n                span {\n                  color: $dark-all-font-color;\n                }\n              }\n            }\n\n            > li {\n              .sidebar-link {\n                &.active {\n                  background-color: rgba($primary-color, 0.2);\n                }\n              }\n\n              .mega-menu-container {\n                .mega-box {\n                  .link-section {\n                    .submenu-title {\n                      h5 {\n                        color: $dark-all-font-color;\n                      }\n                    }\n\n                    .submenu-content {\n                      &.opensubmegamenu {\n                        li {\n                          a {\n                            color: $dark-all-font-color;\n                            font-weight: 400;\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n\n                &::after {\n                  background-color: $light-all-font-color;\n                }\n              }\n\n              .sidebar-submenu {\n                li {\n                  a {\n                    color: $dark-all-font-color;\n                    &.active {\n                      color: var(--theme-default);\n                    }\n                  }\n                }\n              }\n            }\n            .sidebar-list {\n              ul.sidebar-submenu {\n                li {\n                  a {\n                    span {\n                      color: $dark-all-font-color;\n                    }\n\n                    &.active {\n                      color: var(--theme-default);\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n\n      &.modern-type {\n        .page-body-wrapper {\n          .page-title {\n            background-color: transparent;\n            border: none;\n          }\n        }\n      }\n\n      .sidebar-main-title {\n        p {\n          color: $dark-all-font-color;\n        }\n      }\n\n      &.compact-wrapper {\n        .page-body-wrapper {\n          div.sidebar-wrapper {\n            background-color: $dark-card-background;\n\n            .sidebar-main {\n              .sidebar-links {\n                .sidebar-link.active {\n                  svg {\n                    stroke: var(--theme-default);\n                  }\n                }\n\n                li {\n                  a {\n                    span {\n                      color: $dark-all-font-color;\n                    }\n                  }\n                }\n\n                > li {\n                  .sidebar-link {\n                    &.active {\n                      background-color: rgba($primary-color, 0.2);\n                    }\n                  }\n\n                  .mega-menu-container {\n                    .mega-box {\n                      .link-section {\n                        .submenu-title {\n                          h5 {\n                            color: $dark-all-font-color;\n                          }\n                        }\n\n                        .submenu-content {\n                          &.opensubmegamenu {\n                            li {\n                              a {\n                                color: $dark-all-font-color;\n                                font-weight: 400;\n                              }\n                            }\n                          }\n                        }\n                      }\n                    }\n\n                    &::after {\n                      background-color: $light-all-font-color;\n                    }\n                  }\n\n                  .sidebar-submenu {\n                    li {\n                      a {\n                        color: $dark-all-font-color;\n                        &.active {\n                          color: var(--theme-default);\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n        .sidebar-list {\n          ul.sidebar-submenu {\n            li {\n              a {\n                span {\n                  color: $dark-all-font-color;\n                }\n\n                &.active {\n                  color: var(--theme-default);\n                }\n              }\n            }\n          }\n\n          .according-menu {\n            i {\n              color: $dark-all-font-color;\n            }\n          }\n        }\n      }\n\n      &.horizontal-wrapper {\n        .page-body-wrapper {\n          .sidebar-wrapper {\n            background: $dark-card-background;\n            border-top: 1px solid $dark-card-border;\n\n            .sidebar-main {\n              .sidebar-links {\n                > li {\n                  > a {\n                    color: $dark-all-font-color;\n                  }\n\n                  .sidebar-submenu {\n                    background: $dark-card-background;\n\n                    li {\n                      a {\n                        color: $dark-all-font-color;\n\n                        &.active,\n                        &:hover {\n                          color: var(--theme-default);\n                        }\n                      }\n\n                      .nav-sub-childmenu {\n                        background: $dark-card-background;\n                      }\n                    }\n                  }\n\n                  .mega-menu-container {\n                    background: $dark-card-background;\n\n                    .mega-box {\n                      .link-section {\n                        .submenu-content {\n                          li {\n                            a {\n                              color: $dark-all-font-color;\n                            }\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n\n      .left-arrow,\n      .right-arrow {\n        background-color: $dark-card-background;\n        color: $dark-all-font-color;\n      }\n\n      &.compact-sidebar {\n        .page-body-wrapper {\n          div {\n            &.sidebar-wrapper {\n              > div {\n                background: $dark-card-background;\n              }\n\n              .sidebar-main {\n                .sidebar-links {\n                  li {\n                    .sidebar-title {\n                      border-bottom: 1px solid $dark-card-border;\n                    }\n                    a {\n                      span {\n                        color: $dark-all-font-color;\n                      }\n\n                      svg {\n                        stroke: $dark-all-font-color;\n                      }\n                    }\n\n                    .sidebar-submenu,\n                    .mega-menu-container {\n                      background-color: $dark-card-background;\n                      li {\n                        a {\n                          border-bottom: 1px solid $dark-card-border;\n                        }\n                      }\n                    }\n                  }\n\n                  > li {\n                    .sidebar-link {\n                      &.active {\n                        background-color: rgba($primary-color, 0.2);\n\n                        span {\n                          color: var(--theme-default);\n                        }\n\n                        svg {\n                          color: var(--theme-default);\n                          stroke: var(--theme-default);\n                        }\n                      }\n                    }\n\n                    .mega-menu-container {\n                      .mega-box {\n                        .link-section {\n                          .submenu-title {\n                            h5 {\n                              color: $dark-all-font-color;\n                            }\n                          }\n\n                          .submenu-content {\n                            &.opensubmegamenu {\n                              li {\n                                a {\n                                  color: $dark-all-font-color;\n                                  font-weight: 400;\n                                }\n                              }\n                            }\n                          }\n                        }\n                      }\n\n                      &::after {\n                        background-color: $light-all-font-color;\n                      }\n                    }\n\n                    .sidebar-submenu {\n                      li {\n                        a {\n                          color: $dark-all-font-color;\n                        }\n                      }\n                    }\n                  }\n\n                  .sidebar-list {\n                    ul.sidebar-submenu {\n                      li {\n                        a {\n                          span {\n                            color: $dark-all-font-color;\n                          }\n\n                          &.active {\n                            color: var(--theme-default);\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n\n          .according-menu {\n            i {\n              color: $dark-all-font-color;\n            }\n          }\n        }\n      }\n\n      &.material-type {\n        .page-header {\n          .header-wrapper {\n            border-radius: 15px 15px 0 0;\n          }\n        }\n      }\n\n      // material icon css\n      &.material-icon {\n        .page-header {\n          .header-wrapper {\n            background-color: $transparent-color;\n\n            .nav-right {\n              .language-nav {\n                .more_lang {\n                  color: $white;\n                }\n              }\n\n              .onhover-show-div {\n                color: $white;\n              }\n\n              .flip-card {\n                .flip-card-inner {\n                  .back {\n                    .flip-back-content {\n                      input {\n                        border: 1px solid $dark-border-color;\n                        background: $dark-body-background;\n                        color: $white;\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n\n          .header-logo-wrapper {\n            background-color: $transparent-color;\n          }\n        }\n\n        .page-body-wrapper {\n          .page-body {\n            background-color: $transparent-color;\n          }\n        }\n      }\n\n      &.advance-layout {\n        background-color: $dark-body-background;\n        .page-header {\n          .header-wrapper {\n            background: $transparent-color;\n\n            .header-logo-wrapper {\n              background: $transparent-color;\n            }\n          }\n        }\n\n        .page-body-wrapper {\n          background: $transparent-color;\n\n          .page-body {\n            background: $transparent-color;\n          }\n        }\n      }\n\n      &.material-icon {\n        .page-body-wrapper {\n          .page-title {\n            background-color: transparent;\n            box-shadow: none;\n            border: none;\n          }\n        }\n      }\n\n      .page-header {\n        .header-wrapper {\n          .search-full {\n            background-color: $dark-card-background;\n\n            input {\n              color: $dark-all-font-color;\n            }\n          }\n        }\n      }\n    }\n    @media only screen and (min-width: 768px) {\n      .page-wrapper {\n        &.material-icon {\n          .page-header {\n            .header-wrapper {\n              .nav-right {\n                ul {\n                  li {\n                    .profile-dropdown {\n                      li {\n                        svg {\n                          stroke: $white;\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n\n    ::-webkit-calendar-picker-indicator {\n      filter: invert(1);\n    }\n\n    .kanban-board-header {\n      background-color: $dark-body-background;\n      border-bottom: 1px solid $dark-card-background;\n    }\n\n    .kanban-board .kanban-drag {\n      background: $dark-body-background;\n    }\n\n    .kanban-container {\n      .kanban-item {\n        .kanban-box {\n          border: 1px solid rgba($primary-color, 0.15);\n          background-color: $dark-body-background;\n        }\n      }\n    }\n\n    .project-box {\n      border: 1px solid rgba($primary-color, 0.15);\n      background-color: $dark-body-background;\n    }\n\n    .file-content {\n      .form-inline {\n        border: 1px solid $dark-body-background;\n      }\n\n      .files {\n        .file-box {\n          border: 1px solid rgba($primary-color, 0.15);\n          background-color: $dark-body-background;\n\n          .file-top {\n            background-color: $dark-card-background;\n            border: 1px solid rgba($primary-color, 0.15);\n          }\n        }\n      }\n\n      .folder .folder-box {\n        border: 1px solid rgba($primary-color, 0.15);\n        background-color: $dark-body-background;\n      }\n    }\n\n    .file-sidebar {\n      .pricing-plan {\n        border: 1px solid rgba($primary-color, 0.15) !important;\n      }\n\n      .btn-light {\n        color: $dark-all-font-color;\n        background-color: $dark-body-background !important;\n        border: 1px solid rgba($primary-color, 0.15) !important;\n      }\n    }\n\n    #lnb {\n      border-right: 1px solid $dark-card-border;\n    }\n\n    .lnb-new-schedule,\n    .lnb-calendars > div {\n      border-bottom: 1px solid $dark-card-border;\n    }\n\n    #menu .sidebar-list .btn-default {\n      color: rgba($dark-all-font-color, 0.2);\n    }\n\n    .tui-full-calendar-timegrid-hour {\n      background-color: $dark-card-background;\n      color: $white !important;\n    }\n\n    .tui-full-calendar-timegrid-gridline {\n      border-bottom: 1px solid $dark-card-border !important;\n    }\n\n    .tui-full-calendar-time-date,\n    .tui-full-calendar-weekday-grid-line,\n    .tui-full-calendar-left,\n    .tui-full-calendar-timegrid-timezone {\n      border-right-color: $dark-card-border !important;\n    }\n\n    .tui-full-calendar-popup {\n      color: $theme-body-font-color;\n    }\n\n    #menu {\n      .btn-default {\n        color: $dark-all-font-color;\n        &:hover {\n          color: $theme-body-font-color;\n        }\n      }\n      .dropdown-menu {\n        color: $dark-all-font-color;\n      }\n    }\n\n    .tui-full-calendar-dayname-container,\n    .tui-full-calendar-splitter {\n      border-top-color: $dark-card-border !important;\n      border-bottom-color: $dark-card-border !important;\n    }\n\n    span.tui-full-calendar-dayname-date-area {\n      color: $white !important;\n    }\n\n    .tui-full-calendar-layout {\n      background-color: $dark-card-background !important;\n    }\n\n    // index page css end\n    .blockquote {\n      border-left: 4px solid $dark-card-border;\n    }\n    .figure {\n      &.text-end {\n        blockquote {\n          border-right-color: $dark-card-border;\n        }\n      }\n    }\n\n    .contacts-tabs {\n      .nav-pills {\n        border-right: 1px solid $dark-card-border;\n\n        .nav-link {\n          + .nav-link {\n            border-top: 1px solid $dark-card-border;\n          }\n        }\n      }\n    }\n\n    .list-persons {\n      .profile-mail {\n        .media {\n          .media-body {\n            ul {\n              li {\n                + li {\n                  border-left: 2px solid $dark-card-border;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .product-wrapper {\n      &.sidebaron {\n        .product-sidebar {\n          .filter-section {\n            .card {\n              .left-filter {\n                background-color: $dark-card-background;\n              }\n            }\n          }\n        }\n      }\n    }\n    .apexcharts-gridline {\n      stroke: $dark-border-color;\n    }\n\n    .apexcharts-tooltip-title,\n    .apexcharts-tooltip-series-group,\n    .apexcharts-tooltip.light,\n    .apexcharts-menu-item {\n      color: $black;\n    }\n\n    // peity chart css\n    .small-donut,\n    .donut-peity2,\n    .pie-peity {\n      ~ svg,\n      svg {\n        path {\n          &:nth-child(even) {\n            fill: $dark-body-background;\n          }\n        }\n      }\n    }\n\n    // index page css start\n    .appointment-table {\n      table {\n        tr {\n          td {\n            &.img-content-box {\n              .font-roboto {\n                color: $dark-all-font-color;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .notification {\n      .card {\n        .d-flex {\n          .w-100 {\n            p {\n              span {\n                color: $dark-all-font-color;\n              }\n            }\n\n            span {\n              color: $dark-all-font-color;\n            }\n          }\n        }\n      }\n    }\n    .datepicker {\n      background-color: $dark-card-inbox;\n      color: $dark-all-font-color;\n      .datepicker--cell.-current- {\n        color: $primary-color;\n      }\n      .datepicker--cell.-current-.-focus- {\n        color: $white;\n      }\n      .datepicker--cell-day.-other-month-,\n      .datepicker--cell-year.-other-decade- {\n        color: rgba($white, 0.4);\n      }\n      .datepicker--nav {\n        border-bottom: 1px solid $dark-card-border;\n      }\n      .datepicker--pointer {\n        background: $dark-card-inbox;\n        border-top-color: $dark-card-inbox;\n        border-right-color: $dark-card-inbox;\n      }\n    }\n    .default-datepicker {\n      .datepicker-inline {\n        .datepicker {\n          background: $dark-card-background;\n\n          .datepicker--nav-title {\n            color: $dark-all-font-color;\n\n            i {\n              color: $dark-all-font-color;\n            }\n          }\n\n          .datepicker--content {\n            .datepicker--days {\n              .datepicker--days-names,\n              .datepicker--cells {\n                .datepicker--day-name,\n                .datepicker--cell-day {\n                  color: $dark-all-font-color;\n\n                  &.-selected- {\n                    color: $white;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n\n    // index page css end\n    // ecommerce dashboard css start\n    [class*=\"activity-dot-\"] {\n      background-color: $dark-card-background;\n    }\n\n    // ecommerce dashboard css end\n    .page-header {\n      .header-wrapper {\n        .nav-right {\n          .profile-dropdown {\n            li {\n              &:last-child {\n                border-top: 1px solid $dark-card-border !important;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    $alert-name: primary, secondary, success, danger, warning, info, light, dark;\n    $alert-color: $primary-color, $secondary-color, $success-color, $danger-color, $warning-color, $info-color, $light-color, $dark-color;\n\n    @each $var in $alert-name {\n      $i: index($alert-name, $var);\n\n      .alert-#{$var} {\n        background-color: rgba(nth($alert-color, $i), 0.8) !important;\n        border-color: rgba(nth($alert-color, $i), 0.9) !important;\n        color: $white;\n\n        .progress {\n          height: 5px;\n          background-color: darken(nth($alert-color, $i), 1%);\n          border-radius: 0;\n        }\n\n        .progress-bar {\n          background-color: lighten(nth($alert-color, $i), 50%);\n        }\n      }\n\n      .alert-#{$var}.inverse {\n        background-color: $transparent-color !important;\n        .btn-close {\n          filter: brightness(1) invert(1);\n        }\n      }\n      .alert-#{$var}.outline,\n      .alert-#{$var}.outline-2x {\n        .btn-close {\n          filter: brightness(1) invert(1);\n        }\n      }\n      .dismiss-text {\n        .alert-dismissible {\n          .btn-close {\n            filter: unset;\n\n            .bg-light {\n              color: $theme-body-font-color !important;\n            }\n          }\n        }\n      }\n    }\n\n    .options {\n      > div {\n        border: 1px solid $dark-card-border;\n      }\n    }\n\n    .was-validated {\n      .custom-control-input {\n        &:invalid {\n          ~ .custom-control-label {\n            &::before {\n              background-color: $dark-body-background;\n            }\n          }\n        }\n      }\n    }\n\n    .pricing-simple {\n      box-shadow: 1px 1px 2px 1px $dark-body-background !important;\n    }\n\n    .pricing-block {\n      box-shadow: 0 0 10px 5px rgba($primary-color, 0.05) !important;\n    }\n\n    .search-page {\n      ul {\n        &.search-info {\n          li {\n            + li {\n              border-left: 1px solid $dark-body-background;\n            }\n          }\n        }\n      }\n    }\n\n    .browse {\n      .browse-articles {\n        h6 {\n          border-bottom: 1px solid $dark-border-color;\n        }\n      }\n    }\n\n    .job-search {\n      .job-description {\n        .theme-form {\n          .row {\n            div[class^=\"col-\"] {\n              .input-group {\n                .datepicker-here {\n                  border: 1px solid $dark-body-background;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .calendar-wrap {\n      .fc-unthemed {\n        td,\n        th {\n          border-color: $dark-body-background;\n        }\n      }\n    }\n\n    .mega-inline,\n    .mega-horizontal,\n    .mega-vertical {\n      .card {\n        box-shadow: 1px 1px 7px 0 rgba($dark-card-border, 0.5) !important;\n      }\n\n      &.plain-style,\n      &.border-style,\n      &.offer-style {\n        .card {\n          box-shadow: none !important;\n        }\n      }\n\n      &.border-style {\n        .card {\n          border: 1px solid $dark-card-border !important;\n        }\n      }\n\n      &.offer-style {\n        .card {\n          border: 1px dashed $dark-card-border !important;\n        }\n      }\n    }\n\n    .setting-dot {\n      .setting-bg {\n        background-color: var(--theme-secondary);\n      }\n    }\n\n    .bookmark.pull-right {\n      border: none;\n    }\n    // popover css start\n    .popover {\n      &.bs-popover-bottom {\n        .popover-arrow {\n          &:after {\n            border-bottom-color: $dark-body-background;\n            border-right-color: $transparent-color;\n          }\n        }\n      }\n      &.bs-popover-top {\n        .popover-arrow {\n          &:after {\n            border-right-color: $transparent-color;\n            border-top-color: $dark-body-background;\n          }\n        }\n      }\n      &.bs-popover-start {\n        .popover-arrow {\n          &:after {\n            border-left-color: $dark-body-background;\n          }\n        }\n      }\n      background-color: $dark-body-background;\n      .popover-header {\n        background-color: $dark-card-background;\n      }\n      .popover-arrow {\n        &:after {\n          border-right-color: $dark-body-background;\n        }\n      }\n      .popover-body {\n        color: rgba(255, 255, 255, 0.6);\n      }\n      code {\n        background-color: unset;\n      }\n    }\n    // popover css end\n    // apex chart css start\n    .apex-chart-container {\n      .apexcharts-legend {\n        .apexcharts-legend-series {\n          span {\n            color: $dark-all-font-color !important;\n          }\n        }\n      }\n    }\n\n    .apexcharts-canvas {\n      svg {\n        .apexcharts-title-text {\n          fill: $white;\n        }\n\n        .apexcharts-subtitle-text {\n          fill: $white;\n        }\n\n        .apexcharts-yaxis {\n          .apexcharts-yaxis-texts-g {\n            .apexcharts-yaxis-label {\n              fill: $white;\n            }\n          }\n        }\n\n        .apexcharts-xaxis {\n          .apexcharts-xaxis-texts-g {\n            .apexcharts-xaxis-label {\n              fill: $white;\n            }\n          }\n        }\n\n        .apexcharts-legend-series {\n          span {\n            color: $dark-all-font-color !important;\n          }\n        }\n\n        .apexcharts-datalabels-group {\n          .apexcharts-datalabel-label {\n            fill: $white;\n          }\n\n          .apexcharts-datalabel-value {\n            fill: $white;\n          }\n        }\n      }\n    }\n    // apex chart css end\n    .Typeahead-menu {\n      background-color: $dark-body-background;\n    }\n\n    .ecommerce-widget {\n      border: 1px solid $dark-border-color;\n    }\n\n    .bookmark {\n      ul {\n        li {\n          .search-form {\n            .form-control-search {\n              input {\n                background-color: $dark-body-background;\n                border: 1px solid $dark-border-color;\n                color: $dark-all-font-color;\n              }\n\n              &:before {\n                background: $dark-border-color;\n              }\n            }\n          }\n        }\n      }\n    }\n    // cart css start\n    .cart {\n      .qty-box {\n        .input-group {\n          .btn {\n            background-color: #2e3648 !important;\n            border-color: $dark-card-border !important;\n          }\n        }\n      }\n    }\n\n    // cart css end\n    // checkout css start\n    .checkout {\n      .checkout-details {\n        background-color: $dark-body-background;\n        border: 1px solid $dark-border-color;\n        padding: 40px;\n\n        .animate-chk {\n          .radio_animated {\n            &:after {\n              border: 2px solid $dark-card-background;\n            }\n          }\n        }\n      }\n    }\n    // checkout css end\n    .order-box {\n      .title-box {\n        color: #bfc2c6;\n        border-bottom: 1px solid $dark-border-color;\n      }\n\n      .qty {\n        li {\n          color: #bfc2c6;\n\n          span {\n            color: #bfc2c6;\n          }\n        }\n\n        border-bottom: 1px solid $dark-border-color;\n      }\n\n      .sub-total {\n        li {\n          color: #bfc2c6;\n        }\n      }\n\n      .total {\n        li {\n          color: #bfc2c6;\n        }\n      }\n    }\n\n    .shopping-checkout-option {\n      .checkbox_animated {\n        &:after {\n          border: 2px solid $dark-card-background;\n        }\n      }\n    }\n\n    .animate-chk {\n      .radio_animated {\n        &:after {\n          border: 2px solid $dark-border-color;\n        }\n      }\n    }\n\n    .custom-scrollbar::-webkit-scrollbar-thumb {\n      background-color: rgba(41, 50, 64, 0.52);\n    }\n\n    .product-box {\n      .product-img {\n        .product-hover {\n          ul {\n            li {\n              .btn {\n                color: $dark-small-font-color;\n              }\n\n              &:hover {\n                .btn {\n                  color: $white;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .radio_animated,\n    .checkbox_animated {\n      &:after {\n        background: $dark-body-background;\n        border: 2px solid $dark-body-background;\n      }\n    }\n\n    .slider-product {\n      border-top: 1px solid $dark-border-color;\n      border-bottom: 1px solid $dark-border-color;\n    }\n\n    .square-product-setting {\n      .icon-grid {\n        background-color: $dark-card-background;\n\n        svg {\n          color: $dark-all-font-color;\n        }\n      }\n    }\n\n    .active-order-table,\n    .market-table {\n      table {\n        thead {\n          tr {\n            th {\n              border-top: none !important;\n            }\n          }\n        }\n\n        tbody {\n          tr {\n            td {\n              border-bottom: 1px solid $dark-border-color;\n            }\n\n            &:last-child {\n              td {\n                border-bottom: none;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .pricing-card-design-2 {\n      .pricing-block {\n        .pricing-inner {\n          ul {\n            li {\n              border-bottom: 1px solid $dark-border-color;\n            }\n          }\n        }\n      }\n    }\n\n    .flot-chart-container {\n      .legend {\n        .table {\n          tbody {\n            background-color: $dark-card-background;\n            color: $white;\n\n            .legendLabel {\n              padding-left: 5px;\n            }\n          }\n        }\n      }\n    }\n\n    .google-visualization-tooltip {\n      text {\n        fill: rgba(0, 0, 0, 0.7) !important;\n      }\n    }\n\n    .nav-dark,\n    .nav-pills.nav-dark {\n      .nav-link {\n        color: $white;\n      }\n    }\n\n    .loader-wrapper {\n      background-color: $dark-body-background;\n\n      .loader {\n        background-color: $dark-body-background !important;\n      }\n    }\n\n    .page-wrapper {\n      .sidebar-main-title {\n        h6 {\n          color: $dark-all-font-color;\n        }\n      }\n      /* Main Header start */\n      .page-header {\n        .translate_wrapper {\n          &.active {\n            .more_lang {\n              background-color: $dark-body-background;\n            }\n\n            .lang {\n              background-color: $dark-card-background;\n            }\n          }\n        }\n\n        form {\n          background-color: $dark-body-background;\n        }\n\n        .header-wrapper {\n          background-color: $dark-card-background;\n\n          li {\n            i {\n              color: $light-color;\n            }\n          }\n\n          .nav-right {\n            > ul {\n              > li {\n                svg {\n                  stroke: $white;\n                }\n              }\n            }\n\n            &.right-header {\n              > ul {\n                > li {\n                  .profile-media {\n                    .media-body {\n                      p {\n                        color: $dark-all-font-color;\n                      }\n                    }\n                  }\n                }\n              }\n            }\n\n            .nav-menus {\n              li {\n                .media {\n                  .media-body {\n                    .txt-dark {\n                      color: $dark-all-font-color !important;\n                    }\n                  }\n                }\n\n                .onhover-show-div {\n                  background-color: $dark-body-background;\n                  box-shadow: 0 0 14px $dark-body-background;\n\n                  li {\n                    border-color: $dark-card-background;\n                  }\n\n                  p {\n                    color: $dark-all-font-color;\n                  }\n\n                  &:before {\n                    border-bottom: 7px solid $dark-body-background;\n                  }\n\n                  &:after {\n                    border-bottom: 7px solid $dark-body-background;\n                  }\n                }\n\n                .notification-dropdown.onhover-show-div {\n                  li {\n                    background-color: $dark-card-background;\n                    span {\n                      color: $dark-small-font-color;\n                    }\n                  }\n\n                  .bg-light {\n                    background-color: #282e38 !important;\n                    color: $dark-all-font-color !important;\n                  }\n                }\n              }\n            }\n\n            .profile-dropdown {\n              li {\n                a {\n                  color: $dark-all-font-color;\n\n                  svg {\n                    path,\n                    line,\n                    circle {\n                      color: $dark-all-font-color !important;\n                    }\n                  }\n\n                  &:hover {\n                    color: var(--theme-default);\n\n                    svg {\n                      line,\n                      path,\n                      circle {\n                        color: var(--theme-default) !important;\n                      }\n                    }\n                  }\n                }\n              }\n            }\n\n            > ul {\n              > li {\n                .media {\n                  .media-body {\n                    .txt-dark {\n                      color: $dark-all-font-color !important;\n                    }\n                  }\n                }\n\n                .onhover-show-div {\n                  background-color: $dark-body-background;\n                  box-shadow: 0 0 2px 2px $dark-card-background;\n\n                  &:before {\n                    border-bottom: 7px solid $dark-body-background;\n                  }\n\n                  &:after {\n                    border-bottom: 7px solid $dark-body-background;\n                  }\n                }\n\n                .notification-dropdown.onhover-show-div {\n                  li {\n                    border-color: $dark-card-background;\n\n                    span {\n                      color: $dark-small-font-color;\n                    }\n                  }\n                }\n              }\n            }\n\n            .bookmark-flip {\n              .bookmark-dropdown {\n                .bookmark-content {\n                  .bookmark-icon {\n                    background-color: $dark-card-background;\n                  }\n                }\n              }\n            }\n          }\n        }\n\n        .header-logo-wrapper {\n          background-color: $dark-card-background;\n\n          .logo-wrapper {\n            a {\n              .image-dark {\n                display: none;\n              }\n\n              .image-light {\n                display: block;\n              }\n            }\n          }\n        }\n      }\n\n      /* Main Header ends */\n      .page-body-wrapper {\n        /* body start*/\n        .page-body {\n          .topper-lists {\n            table {\n              tbody {\n                tr {\n                  td {\n                    p {\n                      color: $dark-small-font-color;\n                    }\n                  }\n                }\n              }\n            }\n          }\n\n          .header-small {\n            color: $dark-small-font-color;\n          }\n\n          .statistics {\n            p {\n              color: $dark-small-font-color;\n            }\n          }\n\n          .feather-main,\n          .professor-table {\n            .media-body,\n            .professor-block {\n              p {\n                color: $dark-small-font-color;\n              }\n            }\n          }\n\n          .logs-element {\n            span {\n              + span {\n                color: $dark-small-font-color;\n              }\n            }\n          }\n\n          .progress-block {\n            .progress-title {\n              span {\n                + span {\n                  color: $dark-small-font-color;\n                }\n              }\n            }\n          }\n\n          .ecommerce-icons {\n            div {\n              span {\n                color: $dark-small-font-color;\n              }\n            }\n          }\n\n          .new-users,\n          .recent-notification {\n            .media {\n              .media-body {\n                p {\n                  color: $dark-small-font-color;\n                }\n              }\n            }\n          }\n\n          .progress-media {\n            .media {\n              .media-body {\n                span {\n                  color: $dark-small-font-color;\n                }\n              }\n            }\n\n            .progress-change {\n              span {\n                color: $dark-small-font-color;\n              }\n            }\n          }\n\n          .topper-lists {\n            table {\n              tbody {\n                tr {\n                  td {\n                    border-top: none !important;\n                    border-bottom: 1px solid $dark-card-border;\n                  }\n\n                  &:last-child {\n                    td {\n                      border-bottom: none;\n                    }\n                  }\n                }\n              }\n            }\n          }\n\n          .notifiaction-media {\n            .media {\n              .media-body {\n                .circle-left {\n                  border: 5px solid #334154;\n                }\n              }\n            }\n          }\n\n          .upcoming-event {\n            .upcoming-innner {\n              border-bottom: 1px solid $dark-border-color;\n\n              &:last-child {\n                border-bottom: none;\n              }\n            }\n          }\n\n          .professor-table {\n            table {\n              tbody {\n                tr {\n                  td {\n                    border-top: none !important;\n                  }\n                }\n              }\n            }\n          }\n\n          .number-widgets {\n            .media {\n              .media-body {\n                h6 {\n                  color: $dark-all-font-color;\n                }\n              }\n            }\n          }\n\n          .activity {\n            .media {\n              .gradient-round {\n                &.gradient-line-1,\n                &.small-line,\n                &.medium-line {\n                  &:after {\n                    background-color: $dark-border-color;\n                  }\n                }\n              }\n\n              .media-body {\n                h6 {\n                  span {\n                    color: $dark-small-font-color;\n                  }\n                }\n              }\n            }\n          }\n\n          .card.custom-card {\n            .card-header {\n              border-bottom: none !important;\n            }\n          }\n        }\n\n        .custom-card .card-header img {\n          background-color: $black;\n          opacity: 0.8;\n        }\n\n        .page-title {\n          .row {\n            h3 {\n              small {\n                color: $dark-small-font-color;\n              }\n            }\n          }\n\n          .breadcrumb {\n            li {\n              color: $dark-all-font-color;\n            }\n            .breadcrumb-item {\n              a {\n                svg {\n                  stroke: $dark-all-font-color;\n                }\n              }\n            }\n          }\n        }\n\n        .page-body {\n          background-color: $dark-body-background;\n          .default-according {\n            .card:not(.email-body) {\n              border: none;\n            }\n          }\n          .card:not(.email-body) {\n            background-color: $dark-card-background;\n            box-shadow: 1px 1px 2px 1px rgba(29, 28, 28, 0.08);\n            border: 1px solid $dark-card-border;\n            &.widget-1 {\n              background-color: #1b1d24;\n              background-blend-mode: overlay;\n              .widget-round {\n                .bg-round {\n                  box-shadow: 1px 2px 21px -2px rgba(14, 14, 16, 0.83);\n                  .half-circle {\n                    background: rgba(49, 53, 66, 0);\n                  }\n                }\n              }\n            }\n            &.social-profile {\n              background-blend-mode: overlay;\n              background-color: $dark-body-background;\n            }\n            .table {\n              &.table-light {\n                tr {\n                  th,\n                  td {\n                    color: $theme-body-font-color;\n                  }\n                }\n              }\n            }\n            table {\n              thead,\n              tbody {\n                .border-bottom-light {\n                  th,\n                  td {\n                    border-bottom: 1px solid $dark-card-border !important;\n                  }\n                }\n              }\n            }\n            // cypto dashboard css start\n            &.balance-box {\n              background-blend-mode: overlay;\n              background-color: #16171c;\n            }\n            // cypto dashboard css end\n\n            .chart-block {\n              #bar-chart2 {\n                svg {\n                  > rect {\n                    fill: $dark-card-background;\n                  }\n\n                  > g {\n                    text {\n                      fill: $dark-all-font-color;\n                    }\n                  }\n                }\n              }\n\n              .word-tree {\n                svg {\n                  > g {\n                    > rect {\n                      fill: $dark-card-background;\n                    }\n\n                    > text {\n                      fill: $dark-all-font-color;\n                    }\n                  }\n                }\n              }\n            }\n\n            .card-header {\n              background-color: $transparent-color;\n              border-bottom: 1px solid $dark-card-border;\n\n              > span {\n                color: $dark-all-font-color;\n              }\n\n              h1,\n              h2,\n              h3,\n              h4,\n              h5,\n              h6 {\n                color: $dark-all-font-color;\n              }\n\n              .card-header-right {\n                background-color: $dark-card-background;\n\n                i {\n                  color: $dark-all-font-color;\n\n                  &.fa-cog {\n                    color: var(--theme-default);\n                  }\n                }\n              }\n              &.note-toolbar {\n                background-color: $dark-card-background;\n              }\n            }\n\n            .alert-dark {\n              color: $dark-small-font-color;\n\n              a {\n                color: $dark-small-font-color;\n              }\n            }\n\n            .alert-light.outline,\n            .alert-light.outline-2x,\n            .alert-light.inverse {\n              color: $dark-all-font-color;\n            }\n\n            #animation-box {\n              .animate-widget {\n                p {\n                  color: $dark-small-font-color !important;\n                }\n              }\n            }\n\n            .grid-item {\n              img {\n                background-color: $dark-card-background;\n                border: 1px solid $dark-card-border;\n              }\n            }\n\n            .line {\n              color: $dark-all-font-color;\n            }\n\n            thead,\n            tbody,\n            tfoot,\n            tr,\n            td,\n            th {\n              border-color: $dark-card-border;\n            }\n            .table {\n              th,\n              td {\n                color: $dark-all-font-color;\n              }\n\n              thead {\n                th {\n                  border-bottom: 1px solid $dark-card-border;\n                }\n\n                .border-bottom-primary {\n                  th {\n                    border-bottom: 1px solid var(--theme-default);\n                  }\n                }\n              }\n\n              .table-primary,\n              .table-secondary,\n              .table-success,\n              .table-info,\n              .table-warning,\n              .table-light,\n              .table-danger {\n                th,\n                td {\n                  color: $dark-card-background;\n                }\n              }\n\n              .bg-primary,\n              .bg-secondary,\n              .bg-success,\n              .bg-info,\n              .bg-warning,\n              .bg-danger {\n                color: $white;\n              }\n\n              .bg-light {\n                color: $black;\n              }\n\n              .thead-light {\n                th {\n                  color: $black;\n                }\n              }\n\n              tbody {\n                .border-bottom-primary {\n                  th,\n                  td {\n                    border-bottom: 1px solid var(--theme-default);\n                  }\n                }\n              }\n            }\n\n            .table[class*=\"bg-\"] {\n              th,\n              td {\n                color: $white;\n              }\n            }\n\n            .table-striped {\n              tbody {\n                tr {\n                  &:nth-of-type(odd) {\n                    --bs-table-accent-bg: rgba(0, 0, 0, 0.05);\n\n                    &:hover {\n                      th,\n                      td {\n                        color: $white;\n                      }\n                    }\n                  }\n                }\n              }\n            }\n\n            .table-double,\n            .table-dotted,\n            .table-dashed {\n              border-left-color: $dark-card-border;\n              border-right-color: $dark-card-border;\n            }\n\n            .table-bordered {\n              border-color: $dark-card-border !important;\n\n              td,\n              th {\n                border-color: $dark-card-border !important;\n              }\n            }\n\n            .table-inverse {\n              tbody {\n                tr {\n                  &:nth-of-type(odd) {\n                    &:hover {\n                      td {\n                        color: $dark-all-font-color;\n                      }\n                    }\n                  }\n                }\n              }\n            }\n\n            .table-border-vertical {\n              tr,\n              th,\n              td {\n                border-right: 1px solid $dark-border-color;\n              }\n            }\n\n            .table-styling {\n              thead,\n              tbody {\n                th,\n                td {\n                  color: $white;\n                }\n              }\n            }\n\n            .card-footer {\n              background-color: $dark-card-background;\n              border-top: 1px solid $dark-card-border;\n            }\n\n            .switch {\n              .switch-state {\n                background-color: $dark-body-background;\n              }\n\n              input {\n                &:checked {\n                  + .switch-state {\n                    background-color: var(--theme-default);\n                  }\n                }\n              }\n            }\n\n            .bg-white {\n              background-color: $white !important;\n            }\n\n            .b-l-light {\n              border-left: 1px solid $dark-border-color !important;\n            }\n\n            .ct-grid {\n              stroke: $dark-border-color;\n            }\n\n            .ct-label {\n              color: $dark-small-font-color;\n            }\n\n            hr {\n              border-top: 1px solid $dark-border-color;\n            }\n\n            .text-muted {\n              color: $sidebar-submenu-font-color !important;\n            }\n\n            .btn-outline-light,\n            .btn-outline-dark,\n            .btn-outline-light-2x {\n              color: $white !important;\n              border: 1px solid $dark-card-border;\n            }\n            .btn-outline-light {\n              &:hover {\n                color: $black !important;\n              }\n            }\n            .border-right {\n              border-right: 1px solid $dark-border-color !important;\n            }\n            .flot-chart-placeholder {\n              .flot-text {\n                color: $dark-all-font-color !important;\n              }\n              svg {\n                text {\n                  fill: $dark-all-font-color;\n                }\n              }\n            }\n            .chart-overflow {\n              &#gantt_chart {\n                svg {\n                  g {\n                    rect {\n                      &:first-child {\n                        fill: $dark-body-background;\n                      }\n                    }\n                  }\n                }\n                rect {\n                  &:nth-child(6) {\n                    fill: $dark-body-background;\n                  }\n                }\n              }\n              &#line-chart,\n              &#column-chart1,\n              &#column-chart2 {\n                rect {\n                  fill: $dark-card-background;\n                }\n              }\n              svg {\n                > rect {\n                  fill: $dark-card-background;\n                }\n\n                > g {\n                  > g {\n                    > g {\n                      text {\n                        fill: rgb(177, 177, 178);\n                      }\n                    }\n                  }\n\n                  > text {\n                    fill: $dark-all-font-color;\n                  }\n                }\n              }\n            }\n\n            .radial-bar {\n              &:after {\n                background-color: $dark-card-background;\n                color: $dark-all-font-color;\n              }\n            }\n\n            .bar-chart-widget {\n              .bottom-content {\n                .num {\n                  color: $dark-all-font-color;\n\n                  .color-bottom {\n                    color: $dark-all-font-color;\n                  }\n                }\n              }\n            }\n\n            .b-r-light {\n              border-right: 1px solid $dark-card-border !important;\n            }\n\n            .chart-container {\n              .live-products,\n              .turnover,\n              .monthly,\n              .uses {\n                .ct-labels {\n                  .ct-label {\n                    color: $white;\n                  }\n                }\n\n                .ct-grid {\n                  stroke: $white;\n                }\n              }\n\n              #browser-uses-chart,\n              #website-visiter-chart {\n                svg {\n                  text {\n                    fill: $dark-all-font-color;\n                  }\n                }\n              }\n            }\n\n            .status-details {\n              h4 {\n                color: $dark-all-font-color;\n\n                span {\n                  color: $dark-all-font-color;\n                }\n              }\n\n              span {\n                color: $dark-small-font-color;\n              }\n            }\n\n            .clipboaard-container {\n              .form-control {\n                background-color: $dark-body-background;\n                color: $dark-small-font-color;\n                border: 1px solid $dark-border-color;\n              }\n            }\n\n            .img-thumbnail {\n              background-color: $dark-body-background;\n              border: 1px solid $dark-card-border;\n            }\n\n            .dataTables_wrapper {\n              button {\n                color: $black;\n              }\n\n              &.no-footer {\n                .dataTables_scrollBody {\n                  border-bottom: 1px solid $dark-body-background;\n                }\n              }\n\n              .btn-danger,\n              .btn-success,\n              .btn-primary {\n                color: $white;\n              }\n\n              .dataTables_length {\n                select {\n                  background-color: $dark-body-background;\n                  color: $dark-all-font-color;\n                  border: 1px solid $dark-border-color;\n                }\n              }\n\n              .dataTables_length,\n              .dataTables_filter,\n              .dataTables_info,\n              .dataTables_processing,\n              .dataTables_paginate {\n                color: $dark-all-font-color;\n              }\n\n              .dataTables_paginate {\n                border: 1px solid $dark-border-color;\n              }\n\n              .dataTables_filter {\n                input[type=\"search\"] {\n                  background-color: $dark-body-background;\n                  border: 1px solid $dark-border-color;\n                  color: $dark-all-font-color;\n                }\n              }\n\n              table.dataTable.display,\n              table.dataTable.order-column.stripe {\n                tbody {\n                  tr {\n                    background-color: $dark-card-background;\n\n                    &:hover {\n                      > .sorting_1 {\n                        background-color: $dark-datatable-sorting;\n                      }\n                    }\n                  }\n\n                  tr.odd {\n                    background-color: $dark-datatable-odd;\n\n                    > .sorting_1 {\n                      background-color: $dark-datatable-sorting;\n                    }\n                  }\n\n                  tr.even {\n                    > .sorting_1 {\n                      background-color: $dark-datatable-sorting-even;\n                    }\n                  }\n                }\n              }\n\n              table.dataTable {\n                border: 1px solid $dark-border-color;\n\n                thead {\n                  th,\n                  td {\n                    border-bottom: 2px solid $dark-border-color;\n                  }\n                }\n\n                input,\n                select {\n                  background-color: $dark-body-background;\n                  color: $dark-all-font-color;\n                  border: 1px solid $dark-border-color;\n                }\n\n                tbody {\n                  tr {\n                    background-color: $dark-card-background;\n                  }\n\n                  td.select-checkbox,\n                  th.select-checkbox {\n                    &:before {\n                      border: 1px solid $dark-small-font-color;\n                    }\n                  }\n                }\n              }\n\n              .table-striped {\n                tbody {\n                  tr {\n                    &:nth-of-type(odd) {\n                      --bs-table-accent-bg: #1d1e26;\n                    }\n                  }\n                }\n              }\n\n              .dataTables_paginate {\n                .paginate_button {\n                  color: $dark-all-font-color !important;\n\n                  &.current,\n                  &:active {\n                    border-color: var(--theme-default);\n                  }\n                }\n\n                .paginate_button.disabled {\n                  color: $dark-small-font-color !important;\n\n                  &:hover,\n                  :active {\n                    color: $dark-small-font-color !important;\n                  }\n                }\n              }\n\n              table.dataTable.row-border,\n              table.dataTable.display {\n                tbody {\n                  th,\n                  td {\n                    border-top: 1px solid $dark-border-color;\n                  }\n                }\n              }\n\n              table.dataTable.display,\n              table.dataTable.order-column.hover {\n                tbody {\n                  tr.even {\n                    &:hover {\n                      > .sorting_1 {\n                        background-color: $dark-even-hover-sorting;\n                      }\n                    }\n                  }\n                }\n              }\n\n              table.dataTable.hover,\n              table.dataTable.display {\n                tbody {\n                  tr {\n                    &:hover {\n                      background-color: $dark-datatable-sorting;\n                    }\n                  }\n                }\n              }\n\n              table.dataTable.cell-border {\n                th,\n                td {\n                  border-top: 1px solid $dark-border-color;\n                  border-right: 1px solid $dark-border-color;\n\n                  &:first-child {\n                    border-left: 1px solid $dark-border-color;\n                  }\n                }\n              }\n\n              table.dataTable.order-column,\n              table.dataTable.display {\n                tbody {\n                  tr {\n                    > .sorting_1,\n                    > .sorting_2,\n                    > .sorting_3 {\n                      background-color: $dark-body-background;\n                    }\n                  }\n                }\n              }\n            }\n\n            #example-style-3_wrapper {\n              #example-style-3 {\n                tfoot {\n                  border-top: 2px solid $dark-border-color;\n                }\n              }\n            }\n\n            .page-link {\n              border: 1px solid $dark-card-border;\n            }\n\n            .page-item.disabled {\n              .page-link {\n                background-color: $dark-card-background;\n                border-color: $dark-border-color;\n              }\n            }\n\n            .page-link {\n              color: $dark-all-font-color;\n              background-color: $dark-card-background;\n            }\n\n            .page-item {\n              &:hover {\n                .page-link {\n                  background-color: $dark-body-background;\n                }\n              }\n            }\n\n            .page-item.active {\n              .page-link {\n                background-color: $dark-body-background;\n              }\n            }\n\n            .ecommerce-widget {\n              .icon {\n                color: $dark-body-background;\n              }\n\n              .total-num {\n                color: $dark-all-font-color;\n\n                span {\n                  color: $dark-all-font-color;\n                }\n              }\n\n              span {\n                color: $dark-small-font-color;\n              }\n            }\n\n            .flot-chart-container-small {\n              background-color: $dark-card-background;\n              border-top: 1px solid $dark-border-color;\n            }\n\n            .product-table {\n              #API-2_wrapper {\n                #API-2 {\n                  tbody {\n                    td {\n                      span,\n                      p {\n                        color: $dark-small-font-color;\n                      }\n                    }\n                  }\n                }\n              }\n\n              h6 {\n                color: $dark-small-font-color;\n              }\n            }\n\n            .border-tab.nav-tabs {\n              border-bottom: 1px solid $dark-border-color;\n\n              .nav-item {\n                .nav-link {\n                  color: $dark-all-font-color;\n                }\n              }\n\n              .nav-link {\n                &.active,\n                &:focus,\n                &:hover {\n                  color: var(--theme-default);\n                }\n              }\n            }\n\n            .br-theme-bars-1to10,\n            .br-theme-bars-movie,\n            .br-theme-bars-pill,\n            .br-theme-bars-reversed,\n            .br-theme-bars-horizontal {\n              .br-widget {\n                a {\n                  background-color: $dark-border-color;\n\n                  &.br-active,\n                  &.br-selected {\n                    background-color: var(--theme-default);\n                  }\n                }\n              }\n            }\n\n            .br-theme-bars-square {\n              .br-widget {\n                a {\n                  border: 2px solid $dark-border-color;\n                  background-color: $dark-card-background;\n                  color: $dark-all-font-color;\n\n                  &.br-active,\n                  &.br-selected {\n                    border: 2px solid var(--theme-default);\n                    color: var(--theme-default);\n                  }\n                }\n              }\n            }\n\n            .br-theme-fontawesome-stars,\n            .br-theme-fontawesome-stars-o {\n              .br-widget {\n                a {\n                  &.br-selected,\n                  &.br-active {\n                    &:after {\n                      color: var(--theme-default);\n                    }\n                  }\n                }\n              }\n            }\n\n            .scroll-demo {\n              border: 1px solid $dark-card-border;\n            }\n\n            .search-form {\n              input {\n                border: 1px solid $dark-border-color;\n                color: $dark-all-font-color;\n                background-color: $dark-body-background;\n              }\n\n              .form-group {\n                &:before {\n                  background: $dark-card-background;\n                }\n              }\n            }\n\n            .cd-timeline-content {\n              background-color: $dark-border-color;\n\n              &::before {\n                border-left: 7px solid $dark-border-color;\n              }\n            }\n\n            .cd-timeline-block {\n              &:nth-child(even) {\n                .cd-timeline-content {\n                  &::before {\n                    border-right-color: $dark-border-color;\n                    border-left: $transparent-color;\n                  }\n                }\n              }\n            }\n\n            .breadcrumb {\n              &.bg-white {\n                background-color: $dark-card-background !important;\n              }\n            }\n\n            #donut-color-chart-morris-daily,\n            #donut-color-chart-morris,\n            #browser-uses-chart,\n            #website-visiter-chart {\n              svg {\n                opacity: 0.5;\n              }\n            }\n          }\n\n          .form-builder-header-1,\n          .form-builder-2-header {\n            background-color: $dark-body-background;\n          }\n\n          .form-builder {\n            .nav-primary {\n              .show {\n                > .nav-link {\n                  color: $white;\n                }\n              }\n\n              .nav-link {\n                color: $dark-all-font-color;\n\n                &.active {\n                  color: $white;\n                }\n              }\n\n              .nav-pills.nav-primary {\n                .show {\n                  > .nav-link {\n                    color: $white;\n                  }\n                }\n\n                .nav-link {\n                  color: $dark-all-font-color;\n\n                  &.active {\n                    color: $white;\n                  }\n                }\n              }\n            }\n\n            .drag-box {\n              fieldset {\n                border: 1px solid $dark-border-color;\n              }\n            }\n\n            .help-block {\n              color: $dark-small-font-color;\n            }\n          }\n\n          #viewhtml {\n            .render {\n              background-color: $dark-card-background;\n              color: $dark-all-font-color;\n              border-color: $dark-border-color;\n            }\n          }\n\n          .form-builder-column {\n            .drag-bx {\n              border: 1px dotted $dark-border-color;\n            }\n          }\n\n          .wizard-4 {\n            ul.anchor {\n              li {\n                a.disabled {\n                  color: $dark-body-background;\n                }\n              }\n            }\n          }\n\n          .gallery-with-description {\n            h4 {\n              color: $dark-all-font-color;\n            }\n\n            a {\n              > div {\n                border: 1px solid $dark-border-color;\n              }\n            }\n\n            p {\n              color: $dark-small-font-color;\n            }\n          }\n\n          .jsgrid-grid-header {\n            background-color: $dark-card-background;\n            border: 1px solid $dark-border-color;\n          }\n\n          .jsgrid-header-row,\n          .jsgrid-filter-row {\n            > .jsgrid-header-cell,\n            > .jsgrid-cell {\n              background: $dark-card-background;\n              border: 1px solid $dark-border-color;\n\n              input {\n                background-color: $dark-body-background;\n                border-color: $dark-border-color;\n                color: $dark-all-font-color;\n\n                &:focus {\n                  outline: none;\n                }\n              }\n            }\n\n            select {\n              background-color: $dark-body-background;\n              border-color: $dark-border-color;\n              color: $dark-all-font-color;\n            }\n          }\n\n          .jsgrid-row {\n            > .jsgrid-cell {\n              background-color: $dark-card-background;\n            }\n          }\n\n          .jsgrid-alt-row {\n            > .jsgrid-cell {\n              background-color: $dark-body-background;\n            }\n          }\n\n          .jsgrid-cell,\n          .jsgrid-grid-body {\n            border: 1px solid $dark-border-color;\n          }\n\n          .jsgrid-selected-row {\n            > .jsgrid-cell {\n              background-color: $dark-datatable-sorting;\n            }\n          }\n\n          .jsgrid {\n            .jsgrid-pager {\n              [class*=\"jsgrid-pager\"] {\n                border: 1px solid $dark-border-color;\n              }\n\n              .jsgrid-pager-page {\n                a {\n                  color: $dark-all-font-color;\n                }\n              }\n            }\n          }\n\n          .jsgrid-pager-current-page {\n            color: $dark-all-font-color;\n            font-weight: 700;\n          }\n\n          .sub-title {\n            border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n          }\n\n          .card {\n            .sub-title {\n              color: $dark-all-font-color;\n            }\n          }\n\n          .navs-icon {\n            li {\n              a {\n                color: $dark-all-font-color;\n\n                &:hover {\n                  color: var(--theme-default);\n                }\n              }\n            }\n\n            .separator {\n              border-bottom: 1px solid $dark-card-border;\n            }\n          }\n\n          .default-according {\n            li {\n              .text-muted {\n                color: $dark-all-font-color !important;\n              }\n            }\n          }\n\n          .navs-icon.default-according.style-1 {\n            li {\n              button {\n                &:hover {\n                  color: var(--theme-default) !important;\n                }\n              }\n            }\n          }\n\n          .nav-list {\n            .nav-list-disc {\n              li {\n                a {\n                  color: $dark-all-font-color;\n                }\n\n                &:hover {\n                  color: var(--theme-default);\n\n                  a {\n                    color: var(--theme-default);\n                  }\n                }\n              }\n            }\n          }\n\n          .navs-dropdown {\n            .onhover-show-div {\n              background-color: $dark-body-background;\n              box-shadow: 0 0 14px 0 $dark-body-background;\n\n              .navs-icon {\n                li {\n                  p {\n                    color: $white;\n                  }\n\n                  a {\n                    svg {\n                      path,\n                      line,\n                      polyline,\n                      polygon,\n                      rect {\n                        color: $dark-all-font-color !important;\n                      }\n                    }\n\n                    &:hover {\n                      svg {\n                        path,\n                        line,\n                        polyline,\n                        polygon,\n                        rect {\n                          color: var(--theme-default) !important;\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n\n          .onhover-dropdown {\n            &:hover {\n              .onhover-show-div {\n                &:before {\n                  border-bottom: 7px solid $dark-body-background;\n                }\n              }\n            }\n          }\n\n          .default-according {\n            .card {\n              .btn-link {\n                color: $dark-all-font-color;\n              }\n\n              .card-body {\n                color: $dark-small-font-color;\n              }\n\n              .card-body {\n                border: 1px solid $dark-card-border;\n                border-top: none;\n              }\n            }\n          }\n\n          .border {\n            border: 1px solid $dark-card-border !important;\n          }\n\n          .blog-box {\n            .blog-date {\n              color: $dark-all-font-color;\n            }\n\n            .blog-details,\n            .blog-details-main {\n              .blog-social {\n                li {\n                  color: $dark-small-font-color;\n                  border-right: 1px solid $dark-card-border;\n\n                  &:first-child {\n                    border-right: 1px solid $dark-card-border;\n                  }\n\n                  &:last-child {\n                    border-right: none;\n                  }\n                }\n              }\n\n              p {\n                color: $dark-all-font-color;\n              }\n\n              .single-blog-content-top {\n                border-top: 1px solid $dark-border-color;\n\n                p {\n                  color: $dark-small-font-color;\n                }\n              }\n            }\n          }\n\n          .comment-box {\n            .media {\n              h6 {\n                span {\n                  color: $dark-small-font-color;\n                }\n              }\n\n              img {\n                border: 1px solid $dark-card-border;\n              }\n            }\n\n            p {\n              color: $dark-small-font-color;\n            }\n\n            .comment-social {\n              li {\n                color: $dark-small-font-color;\n                border: none;\n                &:first-child {\n                  border-right: 1px solid $dark-border-color;\n                }\n              }\n            }\n\n            hr {\n              border-top: 1px solid $dark-border-color;\n            }\n          }\n\n          .table-hover {\n            > tbody {\n              > tr {\n                &:hover {\n                  --bs-table-accent-bg: #1d1e26;\n\n                  td,\n                  th {\n                    color: $white;\n                  }\n                }\n              }\n            }\n          }\n\n          ul.the-icons {\n            li {\n              border: 1px dotted $dark-card-border;\n              color: $sidebar-submenu-font-color;\n              display: inline-block;\n              padding: 10px;\n\n              &:hover {\n                background: $black;\n                box-shadow: 0 0 3px $dark-card-background;\n              }\n              em {\n                display: none;\n              }\n            }\n          }\n\n          .button-builder-wrap {\n            .box {\n              background-color: $dark-card-background;\n              border: 1px solid $dark-border-color;\n            }\n\n            .button-preview {\n              h2 {\n                color: $dark-all-font-color;\n              }\n            }\n\n            pre.well {\n              background-color: $dark-card-background !important;\n            }\n          }\n\n          .crm-activity {\n            > li {\n              + li {\n                border-top: 1px solid $dark-border-color;\n              }\n\n              h6 {\n                color: $dark-all-font-color;\n              }\n            }\n\n            ul.dates {\n              li {\n                color: $dark-small-font-color;\n              }\n            }\n          }\n\n          #donut-color-chart-morris,\n          #donut-color-chart-morris-daily {\n            svg {\n              text {\n                fill: $dark-all-font-color;\n              }\n            }\n          }\n\n          .custom-card {\n            .card-profile {\n              img {\n                background-color: $dark-card-background;\n              }\n            }\n\n            .profile-details {\n              h6 {\n                color: $dark-small-font-color;\n              }\n            }\n\n            .card-social {\n              li {\n                a {\n                  color: $dark-small-font-color;\n                }\n              }\n            }\n\n            .card-footer {\n              > div {\n                h6 {\n                  color: $dark-small-font-color;\n                }\n\n                + div {\n                  border-left: 1px solid $dark-card-inbox;\n                }\n              }\n            }\n          }\n\n          .form-control {\n            background-color: $dark-body-background;\n            color: $dark-all-font-color;\n            border: 1px solid $dark-border-color;\n            &.touchspin {\n              background-color: $dark-card-background;\n            }\n          }\n\n          .checkbox,\n          .radio {\n            label {\n              &::before {\n                background-color: $dark-body-background;\n                border: 1px solid $dark-border-color;\n                color: $dark-all-font-color;\n              }\n            }\n          }\n\n          .dropdown-basic {\n            .dropdown {\n              .dropdown-content {\n                background-color: $dark-body-background;\n\n                a {\n                  color: $dark-all-font-color;\n                  background-color: $transparent-color;\n                  border-color: $dark-card-background;\n                  &:hover {\n                    background-color: $dark-card-background;\n                  }\n                }\n                .dropdown-header {\n                  color: $dark-all-font-color;\n                }\n                .dropdown-divider {\n                  border: 1px solid $dark-border-color;\n                }\n              }\n            }\n          }\n\n          .dropup-basic {\n            .dropup {\n              .dropup-content {\n                background-color: $dark-body-background;\n\n                a {\n                  color: $dark-all-font-color;\n\n                  &:hover,\n                  &.active {\n                    background-color: $dark-card-background;\n                  }\n                }\n              }\n            }\n          }\n\n          .dropzone.dz-clickable {\n            .dz-message {\n              h6 {\n                color: $dark-all-font-color;\n              }\n\n              span {\n                color: $dark-small-font-color;\n              }\n            }\n          }\n\n          .dropzone {\n            .dz-preview {\n              background-color: $dark-body-background;\n\n              .dz-details {\n                background-color: $dark-card-background;\n              }\n            }\n          }\n\n          .browser-widget {\n            .media-body {\n              column-rule: 1px solid $dark-card-border;\n\n              h4 {\n                color: $dark-all-font-color;\n\n                span {\n                  color: $dark-all-font-color;\n                }\n              }\n\n              span {\n                color: $dark-small-font-color;\n              }\n            }\n          }\n\n          .email-wrap {\n            .email-app-sidebar {\n              .media {\n                img {\n                  border: 2px solid $dark-body-background;\n                }\n              }\n\n              .main-menu {\n                > li {\n                  a {\n                    color: $dark-all-font-color;\n\n                    &:hover {\n                      background-color: $dark-body-background;\n                    }\n                  }\n                }\n              }\n              ul {\n                li {\n                  a {\n                    > .title {\n                      color: $dark-all-font-color;\n                    }\n                  }\n                }\n              }\n            }\n\n            .email-right-aside {\n              .email-body {\n                .row {\n                  .col-xl-4 {\n                    border-right: 1px solid rgba(0, 0, 0, 0.1);\n                  }\n                }\n                .inbox {\n                  .media.active {\n                    background-color: $dark-body-background;\n                  }\n                }\n              }\n            }\n\n            .media-body {\n              h6 {\n                color: $dark-all-font-color;\n\n                small {\n                  color: $dark-small-font-color;\n\n                  span {\n                    color: $dark-small-font-color;\n                  }\n                }\n              }\n\n              p {\n                color: $dark-small-font-color;\n              }\n            }\n\n            .email-top {\n              border-bottom: 1px solid $dark-border-color;\n            }\n\n            p {\n              color: $dark-small-font-color;\n            }\n\n            .email-content {\n              .email-top {\n                .user-emailid:after {\n                  border: 1px solid $dark-border-color;\n                }\n              }\n            }\n            .notification-popup {\n              p {\n                color: $white;\n              }\n            }\n          }\n\n          .dropdown-menu {\n            background-color: $dark-body-background;\n            border: 1px solid $dark-card-background;\n            a {\n              color: $dark-all-font-color;\n              background: $transparent-color;\n              border-top-color: $dark-card-background;\n              &:hover {\n                background-color: $dark-card-background;\n              }\n            }\n          }\n\n          .icon-lists {\n            div {\n              i {\n                color: $dark-small-font-color;\n              }\n\n              &:hover {\n                background-color: $dark-body-background;\n              }\n            }\n          }\n\n          .redial-social-widget {\n            i {\n              background-color: $dark-card-background;\n            }\n          }\n\n          .b-b-light {\n            border-bottom: 1px solid $dark-card-border !important;\n          }\n\n          .b-r-dark {\n            border-right: 1px solid $white !important;\n          }\n\n          .testimonial {\n            i {\n              color: $dark-border-color;\n            }\n\n            p {\n              color: $dark-all-font-color;\n            }\n\n            h5 {\n              color: $dark-all-font-color;\n            }\n\n            span {\n              color: $dark-small-font-color;\n            }\n          }\n\n          .grid-showcase {\n            span {\n              background-color: $dark-card-background;\n              border: 1px solid $dark-card-border;\n            }\n          }\n\n          .grid-align {\n            .row {\n              background-color: $dark-border-color;\n              border: 1px solid $dark-border-color;\n            }\n          }\n\n          .page-builder {\n            .ge-html-output {\n              background-color: $dark-body-background;\n              color: $dark-small-font-color;\n              border: 1px solid $dark-card-border;\n            }\n\n            .btn-grid {\n              background-color: $dark-card-background;\n              color: $dark-small-font-color !important;\n              border-right: 1px solid $dark-border-color;\n            }\n\n            .ge-mainControls {\n              .ge-addRowGroup {\n                .ge-row-icon {\n                  .column {\n                    border-left: 3px solid $dark-card-background;\n                  }\n                }\n              }\n            }\n\n            .btn-code,\n            .btn-screen {\n              color: $dark-small-font-color;\n              border-right: 1px solid $dark-border-color;\n            }\n\n            .ge-canvas.ge-editing {\n              .row {\n                background-color: $dark-body-background;\n              }\n\n              .column {\n                border: 1px solid $dark-border-color;\n                background-color: $dark-card-background;\n              }\n\n              .ge-tools-drawer {\n                .ge-details {\n                  input {\n                    background-color: $dark-body-background;\n                    border-color: $dark-border-color;\n                    color: $dark-small-font-color;\n                  }\n\n                  .btn-group {\n                    a {\n                      color: $dark-small-font-color;\n                    }\n                  }\n                }\n              }\n            }\n\n            .ge-content-type-ckeditor {\n              color: $dark-all-font-color;\n            }\n          }\n\n          .search-page {\n            .info-block {\n              border: 1px solid $dark-border-color;\n            }\n          }\n\n          .card-absolute {\n            .bg-primary,\n            .bg-secondary {\n              h5 {\n                color: $white;\n              }\n            }\n          }\n\n          .timeline-small {\n            .media {\n              .timeline-round {\n                &.timeline-line-1,\n                &.small-line,\n                &.medium-line {\n                  &:after {\n                    background-color: $dark-card-border;\n                  }\n                }\n              }\n            }\n          }\n\n          /* body end*/\n        }\n\n        .footer {\n          p {\n            color: $dark-all-font-color;\n          }\n\n          border-top: 1px solid $dark-body-background;\n          background-color: $dark-card-background;\n        }\n\n        .custom-select,\n        .custom-file-label {\n          background: $dark-body-background;\n          color: $dark-all-font-color;\n        }\n\n        .footer-fix {\n          background-color: $dark-card-background;\n          border-top: 1px solid $dark-border-color;\n        }\n      }\n\n      .note {\n        textarea {\n          color: $dark-all-font-color;\n        }\n      }\n\n      .dt-button-info {\n        background-color: $dark-card-background;\n        border: 1px solid $dark-small-font-color;\n\n        h2 {\n          background-color: $dark-card-background;\n        }\n      }\n\n      .chat-box {\n        .about {\n          .name {\n            color: $dark-all-font-color;\n          }\n        }\n\n        .chat-menu {\n          border-left: 1px solid $dark-border-color;\n\n          .nav-tabs {\n            border-bottom: 1px solid $dark-border-color;\n\n            .nav-item {\n              .nav-link {\n                &.active {\n                  color: $dark-all-font-color !important;\n                }\n              }\n            }\n          }\n\n          .user-profile {\n            .image {\n              .icon-wrapper {\n                background-color: $dark-card-background;\n                box-shadow: 1px 1px 3px 1px $dark-body-background;\n              }\n\n              .avatar {\n                img {\n                  border: 5px solid $dark-border-color;\n                }\n              }\n            }\n\n            .social-media {\n              a {\n                color: $dark-small-font-color;\n              }\n            }\n\n            .follow {\n              span {\n                color: $dark-small-font-color;\n              }\n\n              .follow-num {\n                color: $dark-all-font-color;\n              }\n            }\n          }\n        }\n\n        .status {\n          color: $dark-small-font-color;\n\n          p {\n            color: $dark-all-font-color !important;\n          }\n        }\n\n        .chat-right-aside {\n          .chat {\n            .chat-header {\n              border-bottom: 1px solid $dark-border-color;\n\n              .chat-menu-icons {\n                li {\n                  a {\n                    i {\n                      color: $dark-small-font-color;\n                    }\n                  }\n                }\n              }\n\n              img {\n                box-shadow: 1px 1px 4px 1px $dark-body-background;\n              }\n            }\n\n            .chat-msg-box {\n              .my-message {\n                border: 1px solid $dark-border-color;\n              }\n\n              .message {\n                color: $dark-all-font-color;\n              }\n\n              .other-message {\n                background-color: $dark-body-background;\n              }\n            }\n\n            .chat-message {\n              background-color: $dark-card-background;\n              border-top: 1px solid $dark-border-color;\n\n              .input-group {\n                .form-control {\n                  background-color: $dark-card-background;\n                }\n              }\n            }\n          }\n        }\n\n        .chat-history {\n          .call-icons {\n            ul {\n              li {\n                border: 1px solid $dark-border-color;\n\n                a {\n                  color: $dark-small-font-color;\n                }\n              }\n            }\n          }\n        }\n      }\n\n      pre {\n        background-color: $dark-border-color;\n        color: $dark-all-font-color;\n      }\n\n      .scorlled {\n        background-color: $dark-body-background;\n      }\n\n      .input-group-air {\n        box-shadow: 0 3px 20px 0 $dark-border-color;\n      }\n      .input-group-text {\n        background-color: $dark-card-background;\n        border: 1px solid $dark-body-background;\n        color: rgba(255, 255, 255, 0.6);\n        i {\n          color: rgba(255, 255, 255, 0.6);\n        }\n      }\n      .input-group-solid {\n        .input-group-text,\n        .form-control {\n          background: $dark-body-background;\n          border: 1px solid $dark-border-color;\n          color: $dark-all-font-color;\n        }\n      }\n\n      .semilight-bg-color,\n      .header-bg-color {\n        background-color: $white;\n      }\n\n      .list-group-item {\n        background-color: $dark-card-background;\n        border: 1px solid rgba(255, 255, 255, 0.3);\n        color: $dark-all-font-color;\n\n        + .list-group-item {\n          border-top-width: 0;\n        }\n\n        &.active {\n          background-color: var(--theme-default) !important;\n          border-color: var(--theme-default);\n          color: $white;\n        }\n\n        &:hover,\n        &:focus {\n          z-index: 1;\n          text-decoration: none;\n        }\n      }\n\n      .list-group-item-action {\n        &:hover:not(.active),\n        &:focus {\n          background-color: $dark-body-background;\n        }\n      }\n\n      .list-group-flush {\n        .list-group-item {\n          border-left: 0;\n          border-right: 0;\n          border-radius: 0;\n        }\n      }\n\n      .list-group-item-primary {\n        color: #004085;\n        background-color: #b8daff;\n      }\n\n      .list-group-item-secondary {\n        color: #383d41;\n        background-color: #d6d8db;\n      }\n\n      .list-group-item-success {\n        color: #155724;\n        background-color: #c3e6cb;\n      }\n\n      .list-group-item-danger {\n        color: #721c24;\n        background-color: #f5c6cb;\n      }\n\n      .list-group-item-warning {\n        color: #856404;\n        background-color: #ffeeba;\n      }\n\n      .list-group-item-info {\n        color: #0c5460;\n        background-color: #bee5eb;\n      }\n\n      .list-group-item-light {\n        color: #818182;\n        background-color: #fdfdfe;\n      }\n\n      .list-group-item-dark {\n        color: #1b1e21;\n        background-color: #c6c8ca;\n      }\n\n      .auth-bg {\n        background-blend-mode: overlay;\n        background-color: rgba(54, 64, 74, 0.9);\n\n        .authentication-box {\n          .card {\n            background-color: $dark-card-background;\n\n            .theme-form {\n              .form-group {\n                input {\n                  color: $dark-all-font-color;\n                  background-color: $dark-body-background;\n                  border: 1px solid $dark-border-color;\n                }\n\n                label {\n                  color: $dark-all-font-color;\n                }\n              }\n\n              .checkbox {\n                label {\n                  color: $dark-all-font-color;\n\n                  &::before {\n                    background-color: $dark-body-background;\n                    border: 1px solid $dark-border-color;\n                  }\n                }\n              }\n            }\n          }\n\n          h3,\n          h4,\n          h6 {\n            color: $white;\n          }\n        }\n      }\n\n      .auth-bg-video {\n        background-blend-mode: overlay;\n        background-color: rgba(54, 64, 74, 0.7);\n\n        .authentication-box {\n          h4,\n          h3 {\n            color: $white;\n          }\n\n          h6 {\n            color: $dark-small-font-color;\n          }\n\n          .card {\n            background-color: $dark-card-background;\n\n            .theme-form {\n              .form-group {\n                input[type=\"text\"],\n                input[type=\"password\"] {\n                  background-color: $dark-body-background;\n                  border: 1px solid $dark-border-color;\n                  color: $dark-all-font-color;\n                }\n              }\n\n              .checkbox {\n                label {\n                  &::before {\n                    background-color: $dark-body-background;\n                    border: 1px solid $dark-border-color;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n\n      .error-wrapper {\n        .maintenance-icons {\n          li {\n            i {\n              color: $dark-border-color;\n            }\n\n            &:nth-child(3) {\n              i {\n                color: $dark-border-color;\n              }\n            }\n          }\n        }\n      }\n\n      .modal-content {\n        background-color: $dark-card-background;\n\n        .modal-header {\n          border-bottom: 1px solid $dark-border-color;\n\n          .close {\n            color: $dark-small-font-color;\n          }\n        }\n\n        .modal-footer {\n          border-top: 1px solid $dark-border-color;\n        }\n      }\n\n      .comingsoon {\n        background-blend-mode: overlay;\n        background-color: rgba(54, 64, 74, 0.9);\n\n        .comingsoon-inner {\n          h5 {\n            color: $dark-all-font-color;\n          }\n\n          .countdown {\n            border-top: 1px solid $dark-border-color;\n            border-bottom: 1px solid $dark-border-color;\n\n            .title {\n              color: $dark-all-font-color;\n            }\n          }\n\n          .coming-soon-bottom-link {\n            a {\n              color: $dark-all-font-color;\n            }\n          }\n        }\n      }\n\n      .theme-form {\n        .login-divider {\n          border-top: 1px solid $dark-border-color;\n\n          &:before {\n            background: $dark-border-color;\n            color: $dark-all-font-color;\n          }\n        }\n      }\n\n      .authentication-main {\n        background-color: $dark-border-color;\n\n        .auth-innerright {\n          .reset-password-box {\n            .card {\n              background-color: $dark-card-background;\n            }\n\n            .reset-password-link {\n              color: $dark-small-font-color;\n            }\n\n            .theme-form {\n              .form-group {\n                label {\n                  color: $dark-small-font-color;\n                }\n\n                .form-control {\n                  background-color: $dark-body-background;\n                  color: $dark-all-font-color;\n                  border-color: $dark-border-color;\n                }\n              }\n\n              .opt-box {\n                background-color: $dark-border-color;\n              }\n            }\n          }\n\n          .authentication-box {\n            h4 {\n              color: $dark-all-font-color;\n            }\n\n            h6 {\n              color: $dark-small-font-color;\n            }\n\n            h3 {\n              color: $dark-all-font-color;\n            }\n\n            .card {\n              background-color: $dark-card-background;\n\n              .theme-form {\n                .form-group {\n                  input[type=\"text\"],\n                  input[type=\"password\"] {\n                    background-color: $dark-body-background;\n                    border: 1px solid $dark-border-color;\n                    color: $dark-all-font-color;\n                  }\n                }\n\n                .checkbox {\n                  label {\n                    &::before {\n                      background-color: $dark-body-background;\n                      border: 1px solid $dark-border-color;\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n\n      .vertical-menu-main {\n        background-color: $dark-card-background;\n      }\n\n      .mega-menu {\n        .title {\n          color: $dark-all-font-color;\n          border-bottom: 1px solid $dark-border-color;\n        }\n\n        .list-unstyled {\n          div {\n            a {\n              &:hover {\n                color: var(--theme-default);\n              }\n            }\n          }\n        }\n      }\n\n      .default-according {\n        .card {\n          background-color: $dark-card-background;\n\n          .btn-link {\n            background-color: $dark-card-background;\n            border: 1px solid $dark-card-border;\n            border-bottom: none;\n            color: $white;\n          }\n\n          .text-muted {\n            color: $dark-small-font-color !important;\n          }\n        }\n\n        .bg-primary {\n          .btn-link {\n            background-color: var(--theme-default);\n            border: 1px solid var(--theme-default);\n          }\n        }\n\n        .bg-secondary {\n          .btn-link {\n            background-color: var(--theme-secondary);\n            border: 1px solid var(--theme-secondary);\n          }\n        }\n      }\n\n      .collapse {\n        .card-body {\n          background-color: $dark-card-background;\n        }\n      }\n      .balance-widget.card-body {\n        background-color: $dark-card-background;\n        background-blend-mode: overlay;\n      }\n\n      @media screen and (max-width: 1660px) {\n        .chat-box {\n          .chat-history {\n            .call-icons {\n              ul {\n                li {\n                  border: 1px solid $dark-border-color;\n                }\n              }\n            }\n\n            .total-time {\n              h2 {\n                color: $dark-all-font-color;\n              }\n            }\n          }\n        }\n\n        .caller-img {\n          img {\n            opacity: 0.7;\n          }\n        }\n\n        .chat-box {\n          .chat-history {\n            .call-content {\n              > div {\n                background-color: rgba(0, 0, 0, 0.75);\n                background-blend-mode: overlay;\n              }\n            }\n          }\n        }\n      }\n      @media only screen and (max-width: 1199px) {\n        .mobile-title {\n          &.d-none {\n            border-bottom: 1px solid $dark-card-border;\n          }\n        }\n        .chat-menu {\n          border-top: 1px solid $dark-border-color;\n          background-color: $dark-card-background;\n        }\n\n        .error-wrapper {\n          .maintenance-icons {\n            li {\n              i {\n                color: $dark-color;\n              }\n            }\n          }\n        }\n      }\n\n      @media only screen and (max-width: 575.98px) {\n        .user-profile {\n          .hovercard {\n            .info {\n              .user-designation {\n                border-top: 1px solid $dark-border-color;\n                border-bottom: 1px solid $dark-border-color;\n              }\n            }\n          }\n        }\n        .page-wrapper {\n          &.compact-wrapper,\n          &.compact-sidebar {\n            .page-header {\n              .header-wrapper {\n                .toggle-sidebar {\n                  border-right: 1px solid $dark-card-border;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .lg-backdrop {\n      background-color: $dark-body-background;\n    }\n\n    .lg-outer {\n      .lg-thumb-outer {\n        background-color: $dark-card-background;\n      }\n    }\n\n    .drag {\n      background-color: $dark-card-background;\n\n      form {\n        background: $dark-card-background;\n        box-shadow: 0 0 30px $dark-border-color;\n        border: 1px dotted $dark-border-color;\n\n        input {\n          background-color: $dark-body-background;\n          border: 1px solid $dark-border-color;\n          color: $dark-all-font-color;\n        }\n\n        .help-block {\n          text-transform: capitalize;\n          color: $dark-small-font-color;\n        }\n      }\n    }\n\n    .draggable {\n      input {\n        background-color: $dark-body-background;\n        color: $dark-all-font-color;\n        border: 1px solid $dark-border-color;\n      }\n\n      p {\n        color: $dark-small-font-color;\n      }\n\n      select {\n        background-color: $dark-body-background;\n        color: $dark-all-font-color;\n        border: 1px solid $dark-border-color;\n      }\n\n      .radio,\n      .checkbox {\n        label {\n          &::before {\n            background-color: $dark-body-background;\n            border: 1px solid $dark-border-color;\n          }\n        }\n      }\n    }\n\n    .select2-container--default {\n      .select2-selection--multiple,\n      .select2-selection--single {\n        background-color: $dark-body-background;\n        border: 1px solid $dark-border-color !important;\n      }\n\n      .select2-search--inline {\n        .select2-search__field {\n          color: $dark-all-font-color;\n        }\n      }\n\n      .select2-selection--single {\n        .select2-selection__rendered {\n          color: $dark-all-font-color;\n        }\n      }\n\n      .select2-search--dropdown {\n        .select2-search__field {\n          background-color: $dark-body-background;\n          border: 1px solid $dark-border-color;\n          color: $dark-all-font-color;\n        }\n      }\n\n      .select2-results__option--highlighted[aria-selected] {\n        background-color: $dark-card-background !important;\n        color: $dark-all-font-color !important;\n      }\n    }\n\n    .select2-dropdown {\n      background-color: $dark-body-background;\n      border: 1px solid $dark-border-color;\n    }\n\n    .select2-drpdwn {\n      .form-control-primary {\n        border-color: var(--theme-default) !important;\n        color: var(--theme-default) !important;\n      }\n\n      .form-control-secondary {\n        border-color: var(--theme-secondary) !important;\n        color: var(--theme-secondary) !important;\n      }\n\n      .form-control-success {\n        border-color: $success-color !important;\n        color: $success-color !important;\n      }\n\n      .form-control-info {\n        border-color: $info-color !important;\n        color: $info-color !important;\n      }\n\n      .form-control-warning {\n        border-color: $warning-color !important;\n        color: $warning-color !important;\n      }\n\n      .form-control-danger {\n        border-color: $danger-color !important;\n        color: $danger-color !important;\n      }\n\n      .form-control-inverse {\n        border-color: $white !important;\n        color: $white !important;\n      }\n\n      .form-control-primary-fill {\n        background-color: var(--theme-default) !important;\n        color: $white !important;\n      }\n\n      .form-control-secondary-fill {\n        background-color: var(--theme-secondary) !important;\n        color: $white !important;\n      }\n\n      .form-control-success-fill {\n        background-color: $success-color !important;\n        color: $white !important;\n      }\n\n      .form-control-info-fill {\n        background-color: $info-color !important;\n        color: $white !important;\n      }\n\n      .form-control-warning-fill {\n        background-color: $warning-color !important;\n        color: $white !important;\n      }\n\n      .form-control-danger-fill {\n        background-color: $danger-color !important;\n        color: $white !important;\n      }\n\n      .form-control-inverse-fill {\n        background-color: $white !important;\n        color: $black !important;\n      }\n    }\n\n    .select2-container--default.select2-container--disabled {\n      .select2-selection--single {\n        background-color: $dark-border-color;\n      }\n    }\n\n    .theme-form {\n      .form-group {\n        select.form-control:not([size]):not([multiple]) {\n          background-color: $dark-body-background;\n          color: $dark-all-font-color;\n          border-color: $dark-border-color;\n        }\n\n        input[type=\"text\"],\n        input[type=\"email\"],\n        input[type=\"search\"],\n        input[type=\"password\"],\n        input[type=\"number\"],\n        input[type=\"tel\"],\n        input[type=\"date\"],\n        input[type=\"datetime-local\"],\n        input[type=\"time\"],\n        input[type=\"datetime-local\"],\n        input[type=\"month\"],\n        input[type=\"week\"],\n        input[type=\"url\"],\n        input[type=\"file\"],\n        select {\n          border-color: $dark-border-color;\n          background-color: $dark-body-background;\n          color: $dark-all-font-color;\n\n          &::-webkit-input-placeholder {\n            color: $dark-small-font-color;\n          }\n        }\n\n        .form-control {\n          background-color: $dark-body-background;\n          color: $dark-all-font-color;\n        }\n\n        textarea {\n          border-color: $dark-border-color;\n        }\n      }\n\n      .form-divider {\n        border-top: 1px solid $dark-border-color;\n\n        &::before {\n          background: $dark-card-background;\n          color: $dark-all-font-color;\n        }\n      }\n    }\n\n    .CodeMirror {\n      background: $dark-card-background;\n      border: 1px solid $dark-small-font-color;\n      color: $dark-all-font-color;\n\n      .CodeMirror-code {\n        pre {\n          background: $dark-card-background;\n        }\n      }\n    }\n\n    .editor-toolbar {\n      border-top: 1px solid $dark-small-font-color;\n      border-left: 1px solid $dark-small-font-color;\n      border-right: 1px solid $dark-small-font-color;\n\n      a {\n        color: $dark-all-font-color !important;\n\n        &:hover,\n        &.active {\n          background: $dark-border-color;\n        }\n      }\n\n      i.separator {\n        border-left: 1px solid $dark-small-font-color;\n        border-right: 1px solid $dark-small-font-color;\n      }\n      &.fullscreen {\n        &::before {\n          background: linear-gradient(to right, $dark-body-background 0, rgba(0, 0, 0, 0) 100%);\n        }\n        &::after {\n          background: linear-gradient(to right, rgba(0, 0, 0, 0) 0, $dark-body-background 100%);\n        }\n      }\n    }\n\n    .editor-toolbar.disabled-for-preview {\n      a {\n        &:not(.no-disable) {\n          background: $dark-border-color;\n        }\n      }\n    }\n\n    .editor-preview {\n      background-color: $dark-card-background;\n    }\n\n    .editor-toolbar.fullscreen,\n    .editor-preview-side {\n      background: $dark-card-background;\n      border: 1px solid $dark-small-font-color;\n    }\n\n    .u-step {\n      background: $dark-border-color;\n\n      &.active,\n      &.current {\n        background: var(--theme-default);\n        color: $white;\n      }\n    }\n\n    .u-step-title,\n    .u-pearl-title {\n      color: $dark-all-font-color;\n    }\n\n    .u-step-number {\n      background-color: $dark-card-background;\n    }\n\n    .u-pearl {\n      &:before {\n        background-color: $dark-border-color;\n      }\n    }\n\n    .u-pearl-number,\n    .u-pearl-icon {\n      background: $dark-body-background;\n      border: 2px solid $dark-body-background;\n    }\n\n    .u-pearl.disabled {\n      .u-pearl-icon,\n      .u-pearl-number {\n        background: $dark-border-color;\n        border: 2px solid $dark-border-color;\n      }\n\n      &:after {\n        background-color: #334053;\n      }\n    }\n\n    .u-pearl.error {\n      &:after {\n        background-color: $dark-body-background;\n      }\n    }\n\n    .note-editor.note-frame {\n      border-color: $dark-border-color;\n\n      .note-editing-area {\n        .note-editable {\n          background-color: $dark-card-background;\n          color: $dark-all-font-color;\n        }\n      }\n    }\n\n    .swal-modal {\n      background-color: $dark-card-background;\n\n      .swal-title {\n        color: $dark-all-font-color;\n      }\n\n      .swal-text {\n        color: $dark-small-font-color;\n      }\n\n      .swal-content__input {\n        background-color: $dark-body-background;\n        color: $dark-all-font-color;\n      }\n    }\n\n    .nav-tabs {\n      border-bottom: 1px solid $dark-card-border;\n\n      .nav-link {\n        color: $dark-all-font-color;\n        &.active {\n          background-color: $dark-card-background;\n          color: $dark-all-font-color;\n          border-color: $dark-card-border $dark-card-border $dark-card-background;\n        }\n\n        &:hover,\n        &:focus {\n          border-color: $dark-card-border $dark-card-border $dark-card-inbox;\n        }\n      }\n\n      .nav-item.show {\n        .nav-link {\n          background-color: $dark-card-background;\n          color: $dark-all-font-color;\n          border-color: $dark-border-color $dark-border-color $dark-card-background;\n        }\n      }\n    }\n\n    .nav-primary {\n      .nav-link {\n        &.active {\n          background-color: var(--theme-default);\n        }\n      }\n\n      .nav-item.show {\n        .nav-link {\n          background-color: var(--theme-default);\n        }\n      }\n    }\n\n    .custom-tab {\n      &.nav-tabs {\n        border-bottom: none;\n      }\n    }\n\n    .nav-tabs.nav-bottom {\n      .nav-item {\n        .nav-link {\n          &.active,\n          &.focus,\n          &.hover {\n            border-color: $dark-card-background $dark-border-color $dark-border-color;\n          }\n        }\n      }\n    }\n    .border-tab {\n      .nav-link {\n        &.active {\n          background-color: transparent;\n        }\n      }\n\n      .show {\n        > .nav-link {\n          background-color: transparent;\n        }\n      }\n    }\n    .border-tab.nav-left,\n    .border-tab.nav-right {\n      .nav-link {\n        color: $dark-all-font-color;\n\n        &.active {\n          color: var(--theme-default);\n        }\n      }\n\n      .show {\n        > .nav-link {\n          color: var(--theme-default);\n        }\n      }\n    }\n\n    .border-tab.nav-left.nav-secondary {\n      .nav-link {\n        &.active,\n        &:focus,\n        &:hover {\n          border-left-color: var(--theme-secondary);\n          color: var(--theme-secondary) !important;\n        }\n      }\n\n      .show > .nav-link {\n        border-left-color: var(--theme-secondary);\n        color: var(--theme-secondary) !important;\n      }\n\n      .nav-item.show {\n        color: var(--theme-secondary) !important;\n        border-left-color: var(--theme-secondary);\n      }\n    }\n\n    .border-tab.nav-left.nav-success {\n      .nav-link {\n        &.active,\n        &:focus,\n        &:hover {\n          color: $success-color !important;\n        }\n      }\n\n      .show > .nav-link {\n        border-left-color: $success-color;\n        color: $success-color !important;\n      }\n\n      .nav-item.show {\n        color: $success-color !important;\n        border-left-color: $success-color;\n      }\n    }\n\n    .border-tab.nav-right.nav-info {\n      .nav-link {\n        &.active,\n        &:focus,\n        &:hover {\n          color: $info-color !important;\n        }\n      }\n\n      .show > .nav-link {\n        border-left-color: $info-color;\n        color: $info-color !important;\n      }\n\n      .nav-item.show {\n        color: $info-color !important;\n        border-left-color: $info-color;\n      }\n    }\n\n    .border-tab.nav-secondary {\n      .nav-link {\n        &.active,\n        &:focus,\n        &:hover {\n          color: var(--theme-secondary) !important;\n        }\n      }\n\n      .nav-item {\n        &.show {\n          color: var(--theme-secondary) !important;\n        }\n      }\n    }\n\n    .border-tab.nav-success {\n      .nav-link {\n        &.active,\n        &:focus,\n        &:hover {\n          color: $success-color !important;\n        }\n      }\n\n      .nav-item {\n        &.show {\n          color: $success-color !important;\n        }\n      }\n    }\n\n    .dropdown-divider {\n      border-top: 1px solid $dark-border-color;\n    }\n\n    .icon-hover-bottom {\n      background-color: $dark-card-background;\n      box-shadow: 0px 0px 1px 1px $dark-border-color;\n\n      .icon-title {\n        color: $dark-all-font-color;\n      }\n\n      span {\n        color: $dark-small-font-color;\n      }\n\n      .form-group {\n        input {\n          background-color: $dark-body-background;\n          color: $dark-all-font-color;\n          border: 1px solid $dark-border-color;\n        }\n      }\n\n      .icon-first {\n        i {\n          color: $dark-small-font-color;\n        }\n      }\n    }\n\n    code {\n      background-color: $dark-body-background;\n      border-radius: 2px;\n    }\n\n    #cd-timeline {\n      &::before {\n        background: $dark-border-color;\n      }\n    }\n\n    .timeliny {\n      border-top: 1px solid $dark-border-color;\n      border-bottom: 1px solid $dark-border-color;\n\n      &::before {\n        background-color: $white;\n      }\n\n      .timeliny-dot {\n        background-color: $dark-card-background;\n        border: 1px solid $white;\n\n        &::before {\n          color: $dark-all-font-color;\n        }\n      }\n\n      .timeliny-timeline {\n        .timeliny-timeblock {\n          &.active {\n            .timeliny-dot {\n              &::before {\n                color: $dark-all-font-color;\n              }\n\n              &::after {\n                background-color: $dark-border-color;\n                color: $dark-all-font-color;\n                border: none;\n              }\n            }\n          }\n\n          &:not(.inactive):not(.active) {\n            .timeliny-dot {\n              &:hover {\n                background-color: $white;\n\n                &::before {\n                  color: $dark-all-font-color;\n                }\n              }\n            }\n          }\n\n          .timeliny-dot {\n            &:hover {\n              &::after {\n                background-color: $dark-card-background;\n                border: 1px solid $dark-border-color;\n                color: $dark-all-font-color;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .todo {\n      .todo-list-wrapper {\n        #todo-list {\n          li {\n            .task-container {\n              background: $dark-card-background;\n              border-bottom: 1px solid $dark-border-color;\n\n              .task-label {\n                color: $dark-all-font-color;\n              }\n\n              &:hover {\n                h4 {\n                  color: $white;\n                }\n              }\n\n              .task-action-btn {\n                .action-box {\n                  &:hover:not(.active) {\n                    background: $dark-card-background;\n                    border: 1px solid $dark-border-color;\n                  }\n                }\n              }\n            }\n\n            &.completed {\n              .task-container {\n                .task-label {\n                  color: var(--theme-default);\n                }\n\n                .complete-btn {\n                  &:hover {\n                    border: 1px solid $success-color !important;\n                  }\n                }\n              }\n            }\n          }\n        }\n\n        .todo-list-footer {\n          .new-task-wrapper {\n            textarea {\n              background-color: $dark-card-background;\n              border: 1px solid $dark-border-color;\n              color: $dark-all-font-color;\n            }\n          }\n        }\n      }\n    }\n\n    .user-profile {\n      .ttl-info {\n        h6 {\n          color: $dark-small-font-color;\n        }\n\n        span {\n          color: $dark-all-font-color;\n        }\n      }\n\n      .hovercard {\n        .info {\n          .title {\n            a {\n              color: $dark-all-font-color;\n            }\n          }\n        }\n\n        .user-image {\n          .avatar {\n            img {\n              border: 10px solid $dark-card-background;\n            }\n          }\n\n          .icon-wrapper {\n            background-color: $dark-card-background;\n          }\n        }\n\n        .tabs-scoial {\n          border-bottom: none !important;\n        }\n      }\n\n      .follow {\n        .follow-num {\n          color: $dark-all-font-color;\n        }\n      }\n\n      .profile-img-style {\n        .user-name {\n          color: $dark-all-font-color;\n        }\n\n        p {\n          color: $dark-small-font-color;\n        }\n      }\n    }\n\n    .introjs-helperLayer {\n      background-color: rgba(54, 64, 74, 0.9);\n      border: rgba(255, 255, 255, 0.5);\n    }\n\n    .jstree-default {\n      .jstree-node,\n      .jstree-icon {\n        color: #455869 !important;\n      }\n\n      .jstree-anchor {\n        color: $dark-small-font-color;\n      }\n\n      .jstree-clicked {\n        color: $white;\n        background-color: $transparent-color;\n      }\n\n      .jstree-hovered {\n        background-color: $dark-body-background;\n        border: 1px solid $dark-border-color;\n      }\n    }\n\n    span.twitter-typeahead {\n      .tt-menu {\n        background-color: $dark-body-background;\n        color: $dark-all-font-color;\n      }\n\n      .tt-suggestion {\n        color: $dark-all-font-color;\n        background-color: $dark-body-background;\n        border-top: 1px solid $dark-card-border;\n        &:hover,\n        &:focus {\n          background-color: $dark-card-background;\n        }\n      }\n    }\n\n    .typography {\n      small {\n        color: $dark-all-font-color;\n      }\n    }\n\n    .code-box-copy {\n      pre {\n        background-color: $dark-body-background;\n\n        code {\n          background-color: $dark-body-background;\n        }\n      }\n\n      pre[class*=\"language-\"] {\n        border: 1px solid $dark-border-color;\n      }\n\n      .code-box-copy__btn {\n        background-color: $dark-body-background;\n        border: 1px solid $dark-border-color;\n        color: $white;\n      }\n\n      code[class*=\"language-\"],\n      pre[class*=\"language-\"] {\n        text-shadow: 0px 1px $black;\n\n        ::selection {\n          text-shadow: none;\n          background: $dark-card-background;\n        }\n      }\n    }\n\n    table.fixedHeader-floating {\n      background-color: $dark-body-background;\n    }\n\n    .note {\n      textarea {\n        color: $dark-all-font-color;\n      }\n    }\n\n    .dt-button-info {\n      background-color: $dark-card-background;\n      border: 1px solid $dark-border-color;\n\n      h2 {\n        background-color: $dark-card-background;\n        border-bottom: 1px solid $dark-border-color;\n      }\n    }\n\n    pre {\n      background-color: $dark-body-background;\n    }\n\n    #keytable_wrapper,\n    #column-selector_wrapper,\n    #auto-fill_wrapper,\n    #custom-button_wrapper,\n    #class-button_wrapper,\n    #keyboard-btn_wrapper,\n    #multilevel-btn_wrapper,\n    #pagelength-btn_wrapper,\n    #basic-colreorder_wrapper,\n    #state-saving_wrapper,\n    #real-time_wrapper,\n    #basic-fixed-header_wrapper,\n    #fixed-header-footer_wrapper,\n    #export-button_wrapper,\n    #excel-cust-bolder_wrapper,\n    #cust-json_wrapper,\n    #basic-key-table_wrapper,\n    #focus-cell_wrapper,\n    #responsive_wrapper,\n    #new-cons_wrapper,\n    #show-hidden-row_wrapper,\n    #basic-row-reorder_wrapper,\n    #full-row_wrapper,\n    #rest-column_wrapper {\n      .dataTables_paginate {\n        border: none;\n      }\n    }\n\n    #example-style-8_wrapper {\n      table.dataTable.stripe,\n      table.dataTable.display {\n        tbody {\n          tr.odd {\n            background-color: $dark-border-color;\n          }\n        }\n      }\n    }\n\n    .error-wrapper {\n      background-color: rgba(54, 64, 74, 0.8);\n\n      .sub-content {\n        color: $dark-all-font-color;\n      }\n    }\n\n    .b-light {\n      border: 1px solid $dark-border-color !important;\n    }\n\n    .modal-content {\n      background-color: $dark-card-background;\n\n      .modal-header {\n        border-bottom: 1px solid $dark-card-border;\n\n        .close {\n          color: $dark-all-font-color;\n          font-weight: 400;\n        }\n      }\n\n      .ui-front {\n        .form-control {\n          background-color: $dark-card-background;\n          color: $dark-all-font-color;\n          border: 1px solid $dark-card-border;\n        }\n      }\n    }\n\n    .stepwizard {\n      .stepwizard-row {\n        &:before {\n          background-color: $dark-card-border;\n        }\n      }\n    }\n\n    .modal {\n      .theme-close {\n        color: $light-all-font-color;\n      }\n    }\n\n    .token.atrule,\n    .token.attr-value,\n    .token.keyword {\n      color: $info-color;\n    }\n\n    .token {\n      &.boolean,\n      &.constant,\n      &.deleted,\n      &.number,\n      &.property,\n      &.symbol,\n      &.tag {\n        color: $danger-color;\n      }\n    }\n\n    .loader-box {\n      &.card-loader {\n        background-color: $dark-card-background;\n      }\n    }\n\n    .my-gallery {\n      &.gallery-with-description {\n        img {\n          border: 1px solid $dark-border-color !important;\n          border-bottom: none !important;\n        }\n      }\n    }\n\n    @each $var in $alert-name {\n      $i: index($alert-name, $var);\n\n      .alert-#{$var}.inverse {\n        color: $dark-all-font-color;\n      }\n    }\n\n    .alert-theme {\n      span {\n        + span {\n          + span {\n            border-left: 5px solid var(--theme-default);\n            background-color: $dark-body-background;\n            border-radius: 4px;\n          }\n        }\n      }\n\n      i {\n        color: $white;\n        padding: 20px;\n        margin-right: 20px !important;\n      }\n    }\n\n    .user-card {\n      .user-deatils {\n        h6 {\n          color: $dark-small-font-color;\n        }\n      }\n\n      .card-footer {\n        > div {\n          &:first-child {\n            border-right: 1px solid $dark-border-color;\n          }\n        }\n\n        .user-footer {\n          h6 {\n            color: $dark-small-font-color;\n          }\n\n          svg {\n            path,\n            rect {\n              color: $dark-small-font-color;\n            }\n          }\n        }\n      }\n    }\n\n    .order-history {\n      table {\n        .qty-box {\n          button {\n            background-color: $dark-body-background !important;\n            border: none !important;\n          }\n          .input-group {\n            border-color: $dark-card-border;\n          }\n        }\n        thead {\n          tr {\n            th {\n              background-color: $dark-body-background;\n            }\n          }\n        }\n        tr {\n          td,\n          th {\n            border-top: none !important;\n          }\n        }\n      }\n\n      .title-orders {\n        background-color: $dark-body-background;\n      }\n    }\n\n    .navigation-option {\n      ul {\n        li {\n          a {\n            color: $dark-all-font-color;\n          }\n\n          &:hover {\n            background-color: $dark-body-background;\n          }\n        }\n      }\n    }\n\n    .product-box {\n      .product-details {\n        h6 {\n          color: $dark-all-font-color;\n        }\n        > a {\n          color: $dark-all-font-color;\n        }\n\n        span {\n          color: $dark-small-font-color;\n        }\n      }\n\n      .product-img {\n        .product-hover {\n          ul {\n            li {\n              background-color: $dark-card-background;\n\n              &:hover {\n                background-color: $black;\n                color: $white;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .browse {\n      .browse-articles {\n        ul {\n          li {\n            a {\n              color: $dark-all-font-color;\n            }\n\n            &:hover {\n              background-color: $dark-body-background;\n            }\n          }\n        }\n      }\n    }\n\n    @each $btn-name, $btn-color in (primary, var(--theme-default)), (secondary, $secondary-color), (success, $success-color), (danger, $danger-color), (info, $info-color), (light, $light-color), (dark, $dark-color), (warning, $warning-color) {\n      .radio-#{$btn-name} {\n        input[type=\"radio\"] {\n          & + label {\n            &::before {\n              border-color: $btn-color !important;\n            }\n\n            &::after {\n              background-color: $btn-color;\n            }\n          }\n\n          &:checked {\n            & + label {\n              &::before {\n                border-color: $btn-color !important;\n              }\n\n              &::after {\n                background-color: $btn-color;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    @each $btn-name, $btn-color in (primary, var(--theme-default)), (secondary, $secondary-color), (success, $success-color), (danger, $danger-color), (info, $info-color), (light, $light-color), (dark, $dark-color), (warning, $warning-color) {\n      .checkbox-#{$btn-name} {\n        label {\n          &::before {\n            border-color: $btn-color !important;\n          }\n        }\n      }\n    }\n\n    @each $btn-name, $btn-color in (primary, var(--theme-default)), (secondary, $secondary-color), (success, $success-color), (danger, $danger-color), (info, $info-color), (light, $light-color), (dark, $dark-color), (warning, $warning-color) {\n      .checkbox-solid-#{$btn-name} {\n        label {\n          &:before {\n            background-color: $btn-color !important;\n            border-color: $btn-color !important;\n            color: $white !important;\n          }\n        }\n\n        input[type=\"checkbox\"] {\n          &:checked {\n            & + label {\n              &::before {\n                background-color: $btn-color !important;\n                border-color: $btn-color !important;\n                color: $white !important;\n              }\n\n              &::after {\n                color: $white !important;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .bootstrap-datetimepicker-widget {\n      ul {\n        li {\n          color: $dark-all-font-color;\n          border-bottom: 1px solid $dark-border-color;\n        }\n      }\n\n      tr {\n        th,\n        td {\n          &:hover {\n            background-color: $dark-card-background;\n          }\n\n          span {\n            &:hover {\n              background-color: $dark-card-background;\n            }\n          }\n\n          &.prev,\n          &.next {\n            &:hover {\n              background-color: $dark-card-background;\n            }\n          }\n        }\n\n        &:first-child {\n          th {\n            &:hover {\n              background-color: $dark-card-background;\n            }\n          }\n        }\n      }\n    }\n\n    .btn-transparent {\n      color: $dark-all-font-color;\n    }\n\n    #cal-basic {\n      .fc-toolbar {\n        .fc-left,\n        .fc-right {\n          .fc-next-button {\n            .fc-icon-right-single-arrow {\n              &:after {\n                color: $dark-small-font-color;\n              }\n            }\n          }\n\n          .fc-prev-button {\n            .fc-icon-left-single-arrow {\n              &:after {\n                color: $dark-small-font-color;\n              }\n            }\n          }\n        }\n\n        .fc-left {\n          .fc-button-group {\n            .fc-month-button {\n              color: $white !important;\n            }\n          }\n        }\n      }\n    }\n\n    .fc-button-group {\n      .fc-basicWeek-button,\n      .fc-basicDay-button,\n      .fc-agendaWeek-button,\n      .fc-agendaDay-button {\n        color: $black !important;\n      }\n\n      .fc-month-button {\n        color: $white !important;\n      }\n    }\n\n    .btn-light {\n      &:not([disabled]):not(.disabled).active.active {\n        background-color: $dark-body-background !important;\n      }\n      &.disabled,\n      &:disabled {\n        color: rgba($theme-body-font-color, 0.5) !important;\n      }\n    }\n\n    #cal-agenda-view {\n      .fc-toolbar {\n        .fc-right {\n          .fc-button-group {\n            .fc-month-button,\n            .btn-light {\n              color: $black !important;\n            }\n\n            .fc-agendaWeek-button {\n              color: $white !important;\n\n              &:hover {\n                color: $black !important;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .basic-calendar,\n    #cal-bg-events,\n    #cal-event-colors {\n      .fc-toolbar {\n        .fc-right {\n          .fc-button-group {\n            .fc-basicWeek-button,\n            .btn-light {\n              color: $black !important;\n            }\n\n            .fc-month-button {\n              color: $white !important;\n\n              &:hover {\n                color: $black !important;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .categories {\n      ul {\n        li {\n          a {\n            color: $dark-small-font-color;\n          }\n\n          &:hover {\n            background-color: $dark-body-background;\n          }\n        }\n      }\n    }\n\n    .socialprofile {\n      .likes-profile {\n        h5 {\n          span {\n            color: $dark-all-font-color;\n          }\n        }\n      }\n\n      span {\n        color: $dark-small-font-color;\n      }\n    }\n\n    .social-status {\n      .media {\n        .media-body {\n          span {\n            + span {\n              color: $dark-small-font-color;\n            }\n          }\n\n          p,\n          .light-span {\n            color: $dark-small-font-color;\n          }\n        }\n      }\n    }\n\n    .filter-cards-view,\n    .timeline-content {\n      p {\n        color: $dark-small-font-color;\n      }\n\n      .comment-number {\n        i {\n          color: $dark-small-font-color;\n        }\n      }\n\n      .comments-box {\n        .input-group {\n          .form-control {\n            border: none !important;\n          }\n\n          .input-group-append {\n            background-color: $dark-body-background;\n          }\n        }\n      }\n    }\n\n    .social-chat {\n      .media-body {\n        border: 1px solid $dark-border-color;\n\n        &:after {\n          border-right: 7px solid $dark-card-background;\n        }\n      }\n\n      span {\n        span {\n          color: $dark-small-font-color;\n        }\n      }\n    }\n\n    .details-about {\n      .your-details {\n        p {\n          color: $dark-small-font-color;\n        }\n      }\n    }\n\n    .activity-log {\n      .my-activity {\n        p {\n          color: $dark-small-font-color;\n        }\n      }\n    }\n\n    .bookmark {\n      ul {\n        li {\n          a {\n            color: $dark-all-font-color;\n          }\n        }\n      }\n    }\n\n    //index page\n\n    @media only screen and (max-width: 991.98px) {\n      .page-wrapper.compact-wrapper .page-header .header-wrapper .toggle-sidebar {\n        border-right: 1px solid $dark-card-border;\n      }\n    }\n\n    @media only screen and (max-width: 767.98px) {\n      .page-wrapper {\n        &.material-icon {\n          .page-header {\n            background-color: $dark-card-background;\n          }\n        }\n      }\n    }\n    .apexcharts-tooltip.light {\n      border-color: $dark-card-border;\n      background-color: $dark-body-background;\n      .apexcharts-tooltip-title {\n        border-color: $dark-card-border;\n      }\n      .apexcharts-tooltip-text-label,\n      .apexcharts-tooltip-text-value {\n        color: $white;\n      }\n    }\n  }\n\n  &.dark-sidebar {\n    .toggle-sidebar {\n      svg {\n        stroke: var(--theme-default);\n      }\n    }\n\n    .page-wrapper {\n      .sidebar-main-title {\n        p {\n          color: $dark-all-font-color;\n        }\n      }\n\n      &.compact-wrapper {\n        .page-body-wrapper {\n          div.sidebar-wrapper {\n            background-color: $dark-card-background;\n\n            .sidebar-main {\n              .sidebar-links {\n                li {\n                  a {\n                    span {\n                      color: $dark-all-font-color;\n                    }\n\n                    svg {\n                      stroke: $dark-all-font-color;\n                    }\n                  }\n                }\n\n                > li {\n                  .sidebar-link {\n                    &.active {\n                      background-color: rgba($primary-color, 0.2);\n\n                      svg {\n                        color: var(--theme-default);\n                        stroke: var(--theme-default);\n                      }\n                    }\n                  }\n\n                  .mega-menu-container {\n                    .mega-box {\n                      .link-section {\n                        .submenu-title {\n                          h5 {\n                            color: $dark-all-font-color;\n                          }\n                        }\n\n                        .submenu-content {\n                          &.opensubmegamenu {\n                            li {\n                              a {\n                                color: $dark-all-font-color;\n                                font-weight: 400;\n                              }\n                            }\n                          }\n                        }\n                      }\n                    }\n\n                    &::after {\n                      background-color: $light-all-font-color;\n                    }\n                  }\n\n                  .sidebar-submenu {\n                    li {\n                      a {\n                        color: $dark-all-font-color;\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n\n        .sidebar-list {\n          ul.sidebar-submenu {\n            li {\n              a {\n                span {\n                  color: $dark-all-font-color;\n                }\n\n                &.active {\n                  color: var(--theme-default);\n                }\n              }\n            }\n          }\n\n          .according-menu {\n            i {\n              color: $dark-all-font-color;\n            }\n          }\n        }\n      }\n\n      &.horizontal-wrapper {\n        .page-body-wrapper {\n          .sidebar-wrapper {\n            background: $dark-card-background;\n\n            .sidebar-main {\n              background-color: $dark-card-background;\n\n              .sidebar-links {\n                > li {\n                  > a {\n                    color: $dark-all-font-color;\n                  }\n\n                  .sidebar-submenu {\n                    background: $dark-card-background;\n\n                    li {\n                      a {\n                        color: $dark-all-font-color;\n\n                        &.active,\n                        &:hover {\n                          color: var(--theme-default);\n                        }\n                      }\n\n                      .nav-sub-childmenu {\n                        background: $dark-card-background;\n                      }\n                    }\n                  }\n\n                  .mega-menu-container {\n                    background: $dark-card-background;\n\n                    .mega-box {\n                      .link-section {\n                        .submenu-content {\n                          li {\n                            a {\n                              color: $dark-all-font-color;\n                            }\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n\n      .left-arrow,\n      .right-arrow {\n        background-color: $dark-card-background;\n        color: $dark-all-font-color;\n      }\n\n      &.compact-sidebar {\n        .page-body-wrapper {\n          div {\n            &.sidebar-wrapper {\n              > div {\n                background: $dark-card-background;\n              }\n              .sidebar-main {\n                .sidebar-links {\n                  li {\n                    .sidebar-title {\n                      border-bottom: 1px solid $dark-card-border;\n                    }\n\n                    a {\n                      span {\n                        color: $dark-all-font-color;\n                      }\n\n                      svg {\n                        stroke: $dark-all-font-color;\n                      }\n                    }\n\n                    .sidebar-submenu,\n                    .mega-menu-container {\n                      background-color: $dark-card-background;\n                      li {\n                        a {\n                          border-bottom: 1px solid $dark-card-border;\n                        }\n                      }\n                    }\n                  }\n\n                  > li {\n                    .sidebar-link {\n                      &.active {\n                        background-color: rgba($primary-color, 0.2);\n\n                        span {\n                          color: var(--theme-default);\n                        }\n\n                        svg {\n                          color: var(--theme-default);\n                          stroke: var(--theme-default);\n                        }\n                      }\n                    }\n\n                    .mega-menu-container {\n                      .mega-box {\n                        .link-section {\n                          .submenu-title {\n                            h5 {\n                              color: $dark-all-font-color;\n                            }\n                          }\n\n                          .submenu-content {\n                            &.opensubmegamenu {\n                              li {\n                                a {\n                                  color: $dark-all-font-color;\n                                  font-weight: 400;\n                                }\n                              }\n                            }\n                          }\n                        }\n                      }\n\n                      &::after {\n                        background-color: $light-all-font-color;\n                      }\n                    }\n\n                    .sidebar-submenu {\n                      li {\n                        a {\n                          color: $dark-all-font-color;\n                        }\n                      }\n                    }\n                  }\n\n                  .sidebar-list {\n                    ul.sidebar-submenu {\n                      li {\n                        a {\n                          span {\n                            color: $dark-all-font-color;\n                          }\n\n                          &.active {\n                            color: var(--theme-default);\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n\n          .according-menu {\n            i {\n              color: $dark-all-font-color;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .for-dark {\n    display: none;\n  }\n\n  &[class*=\"dark-\"] {\n    .for-dark {\n      display: block;\n    }\n\n    .for-light {\n      display: none;\n    }\n  }\n}\n\n// =======================  Dark Body only  ======================= //\n\n/**=====================\n55. theme layout CSS ends\n==========================**/\n","/**=====================\n   59. Customizer  CSS Start\n==========================**/\n.customizer-links {\n  position: fixed;\n  right: 00px;\n  top: 50%;\n  z-index: 3;\n  transform: translate(0, -50%);\n  box-shadow: 0 0 37px rgba(8, 21, 66, 0.1);\n\n  > .nav {\n    border-radius: 8px;\n    padding: 10px;\n    background-color: $white;\n  }\n\n  &.open {\n    right: 330px;\n    border-radius: 8px 0 0 8px;\n    transition: all 0.3s ease;\n  }\n\n  .nav-link {\n    padding: 0;\n    position: relative;\n\n    &:before {\n      content: \"\";\n      position: absolute;\n      height: 100%;\n      width: 100%;\n      background-color: rgba(115, 102, 255, 0.1);\n      border-radius: 5px;\n      transform: scale(0);\n      transition: all 0.3s ease;\n    }\n\n    &:after {\n      content: \"\";\n      position: absolute;\n      width: 0;\n      height: 0;\n      border-color: transparent;\n      border-style: solid;\n      top: 12px;\n      border-width: 5px 0 5px 5px;\n      border-left-color: lighten($primary-color, 25%);\n      opacity: 0;\n      transform: scale(0);\n      color: #fff;\n      left: -10px;\n      z-index: 2;\n      transition: all 0.3s ease;\n    }\n\n    &:hover {\n      i {\n        color: var(--theme-default);\n      }\n\n      &:before,\n      &:after {\n        opacity: 1;\n        transform: scale(1);\n        transition: all 0.3s ease;\n      }\n\n      span {\n        opacity: 1;\n        right: 48px;\n        transform: scale(1);\n        transition: all 0.3s ease;\n      }\n    }\n\n    & + .nav-link {\n      margin-bottom: 5px;\n    }\n\n    span {\n      position: absolute;\n      right: -60px;\n      width: max-content;\n      text-align: right;\n      padding: 7px 10px;\n      display: block;\n      top: 0;\n      border-radius: 5px;\n      transform: scale(0);\n      transition: all 0.3s ease;\n      opacity: 0;\n      color: var(--theme-default);\n      background-color: lighten($primary-color, 25%);\n      box-shadow: 0 0 37px rgba(8, 21, 66, 0.1);\n    }\n\n    i {\n      font-size: 17px;\n      padding: 8px 10px;\n      display: inline-block;\n      cursor: pointer;\n      margin: 0;\n      color: gray;\n      border-radius: 5px;\n    }\n  }\n}\n\n.customizer-contain {\n  direction: ltr;\n  position: fixed;\n  height: calc(100vh);\n  top: 79px;\n  width: 333px;\n  right: -335px;\n  background-color: $white;\n  z-index: 8;\n  transition: all 0.3s ease;\n\n  &.open {\n    right: 0px;\n    transition: all 0.3s ease;\n    box-shadow: 0 0 10px 1px rgba(68, 102, 242, 0.05);\n  }\n\n  li,\n  .list-group-item {\n    position: relative;\n\n    &.active {\n      box-shadow: 0 0 11px 5px rgba(226, 226, 226, 0.5) !important;\n      background-color: $white !important;\n    }\n  }\n\n  h6 {\n    text-transform: uppercase;\n    font-weight: 500;\n    letter-spacing: 0.5px;\n    margin-top: 12px;\n    padding-top: 12px;\n    margin-bottom: 5px;\n  }\n\n  .customizer-header {\n    padding: 15px 25px;\n    border-bottom: 1px solid $light-color;\n\n    .icon-close {\n      position: absolute;\n      font-size: 18px;\n      cursor: pointer;\n      font-weight: 900;\n      right: 24px;\n      color: var(--theme-default);\n    }\n\n    h5 {\n      text-transform: uppercase;\n    }\n  }\n\n  .customizer-body {\n    padding: 15px 25px;\n    max-height: calc(100vh - 200px);\n    overflow-y: scroll;\n    .fade {\n      &:not(.show) {\n        display: none;\n      }\n    }\n    .unlimited-color-layout {\n      display: flex;\n      align-items: center;\n\n      .btn {\n        font-size: 15px;\n        padding: 4px 20px;\n      }\n\n      input {\n        border: 1px solid $gray-60;\n        height: 35px;\n        width: 35px;\n        border-radius: 5px;\n        background-color: $white;\n        margin-right: 5px;\n      }\n    }\n\n    .layout-grid {\n      &.customizer-mix {\n        .color-layout {\n          height: 70px;\n          width: 80px;\n          border: 1px solid #f6f7fb;\n          border-radius: 5px;\n        }\n      }\n    }\n\n    .tab-pane {\n      > h6 {\n        &:first-child {\n          padding-top: 0;\n          margin-top: 0;\n        }\n      }\n    }\n\n    li {\n      cursor: pointer;\n      opacity: 0.9;\n\n      &.active {\n        opacity: 1;\n      }\n    }\n\n    .color-layout {\n      height: 35px;\n      width: 35px;\n      border-radius: 6px;\n      display: inline-block;\n      margin-right: 3px;\n      border: 1px solid #b8b8b8;\n      padding: 3px;\n\n      > div {\n        background-color: #7366ff;\n        height: 100%;\n        width: 100%;\n        border-radius: 5px;\n      }\n\n      &[data-attr=\"color-2\"] {\n        div {\n          background-color: #4831d4;\n        }\n      }\n\n      &[data-attr=\"color-3\"] {\n        div {\n          background-color: #d64dcf;\n        }\n      }\n\n      &[data-attr=\"color-4\"] {\n        div {\n          background-color: #4c2fbf;\n        }\n      }\n\n      &[data-attr=\"color-5\"] {\n        div {\n          background-color: #7c4dff;\n        }\n      }\n\n      &[data-attr=\"color-6\"] {\n        div {\n          background-color: #3949ab;\n        }\n      }\n    }\n\n    .dark {\n      > li {\n        background-color: #2f3c4e;\n      }\n    }\n\n    .main-layout {\n      > li {\n        height: 65px;\n        width: 85px;\n        border: 1px solid $light-color;\n        border-radius: 10px;\n        display: inline-block;\n\n        & + li {\n          margin-left: 7px;\n        }\n      }\n\n      .box-layout {\n        .body {\n          .badge {\n            left: -14px;\n          }\n        }\n      }\n    }\n\n    .sidebar-type,\n    .sidebar-setting {\n      > li {\n        height: 70px;\n        width: 85px;\n        border: 1px solid $light-color;\n        border-radius: 5px;\n        display: inline-block;\n\n        & + li {\n          margin-left: 7px;\n        }\n      }\n    }\n\n    .sidebar-type {\n      li {\n        &[data-attr=\"normal-sidebar\"] {\n          .body {\n            ul {\n              li {\n                &.bg-dark,\n                &.sidebar {\n                  width: 100%;\n                  height: 10px;\n                  display: block;\n                }\n                &.bg-light,\n                &.body {\n                  height: calc(100% - 10px);\n                  width: 100%;\n                }\n              }\n            }\n          }\n          &.body-compact {\n            .body {\n              ul {\n                li {\n                  &.body {\n                    width: calc(100% - 25px);\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .layout-types {\n      margin-bottom: -30px;\n\n      > li {\n        display: block;\n        width: unset;\n        height: unset;\n        margin-bottom: 30px;\n\n        .layout-img {\n          h6 {\n            padding-top: 0;\n            text-transform: inherit;\n            text-align: center;\n          }\n        }\n      }\n      .box-layout {\n        background: unset;\n      }\n    }\n  }\n}\n\n.layout-grid:not(.customizer-color) {\n  li {\n    padding: 5px;\n\n    > .header {\n      height: 9px;\n      border-radius: 3px;\n      position: relative;\n\n      ul {\n        position: absolute;\n        top: -8px;\n        left: 5px;\n\n        > li {\n          display: inline-block;\n          width: 4px;\n          height: 4px;\n          border-radius: 5px;\n          top: calc(50% - 3px);\n          background-color: var(--theme-default);\n          margin-right: 2px;\n          padding: 0;\n\n          &:nth-child(2) {\n            background-color: var(--theme-secondary);\n          }\n\n          &:nth-child(3) {\n            background-color: $success-color;\n          }\n        }\n      }\n    }\n\n    > .body {\n      background-color: $light-color;\n      height: calc(100% - 16px);\n      border-radius: 3px;\n      position: relative;\n      margin-top: 5px;\n      text-align: center;\n      line-height: 3.1;\n\n      ul {\n        height: 100%;\n        background-color: $white;\n\n        .sidebar {\n          width: 18px;\n          height: 100%;\n          border-radius: 3px;\n          display: inline-block;\n          margin-right: 3px;\n          padding: 0;\n\n          &.compact {\n            width: 12px;\n\n            & ~ .body {\n              width: calc(100% - 19px);\n            }\n          }\n        }\n\n        .body {\n          width: calc(100% - 25px);\n          padding: 0;\n          margin: 0;\n          height: 100%;\n          display: inline-flex;\n          align-items: center;\n          justify-content: center;\n          border-radius: 3px;\n\n          .badge {\n            position: absolute;\n          }\n        }\n      }\n    }\n  }\n}\n\n/**=====================\n     59.Customizer CSS Ends\n==========================**/\n","/**=====================\n     62. Responsive CSS Start\n==========================**/\n\n/* ========= min and max scss for 1200 to 1366 screen ========= */\n@media (max-width: 1800px) {\n  .todo-wrap {\n    .todo-list-body {\n      .task-container {\n        div.d-flex {\n          min-width: 240px;\n          justify-content: flex-end;\n        }\n      }\n    }\n  }\n  // chat page //\n  .caller-img {\n    display: none;\n  }\n}\n\n@media screen and (max-width: 1660px) {\n  .photos {\n    ul {\n      li {\n        width: 26%;\n      }\n    }\n  }\n  .bar-chart {\n    canvas {\n      width: 100% !important;\n    }\n  }\n  .chat-box {\n    .chat-history {\n      .call-icons {\n        ul {\n          li {\n            border: 1px solid $dark-gray;\n          }\n        }\n      }\n      .total-time {\n        h2 {\n          color: $dark-gray;\n        }\n      }\n      .call-content {\n        .btn {\n          width: auto;\n          margin: 0 auto;\n        }\n        > div {\n          //height: 545px;\n          z-index: 2;\n          background-color: rgba(255, 255, 255, 0.75);\n          background-blend-mode: overlay;\n          width: 100%;\n          padding: 30px;\n        }\n      }\n\n      .receiver-img {\n        margin-top: 25px;\n      }\n    }\n  }\n  .chat-left-aside {\n    .people-list {\n      height: 520px;\n    }\n  }\n  .chat-box {\n    .chat-right-aside {\n      .chat {\n        .chat-msg-box {\n          height: 440px;\n        }\n      }\n    }\n\n    .people-list {\n      ul {\n        max-height: 450px;\n        overflow: auto;\n      }\n    }\n  }\n  .call-chat-body {\n    .chat-box {\n      .people-list {\n        ul {\n          max-height: 550px;\n          overflow: auto;\n        }\n      }\n      overflow: hidden;\n      height: 625px;\n    }\n  }\n  .caller-img {\n    position: absolute;\n    width: 100%;\n    max-width: 100%;\n    left: 15px;\n    img {\n      opacity: 0.7;\n    }\n  }\n\n  // timeline small page\n  .timeline-small {\n    .media {\n      .timeline-round {\n        &.timeline-line-1 {\n          &:after {\n            bottom: -78px;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 1600px) {\n  .page-wrapper {\n    &.horizontal-wrapper {\n      &.material-type {\n        .page-header {\n          max-width: 1320px;\n        }\n        .page-body-wrapper {\n          .sidebar-wrapper,\n          .page-body {\n            max-width: 1320px;\n          }\n        }\n      }\n    }\n  }\n\n  // chat page //\n  .chat-box {\n    .chat-right-aside {\n      .chat {\n        .chat-header {\n          .chat-menu-icons {\n            li {\n              margin-right: 10px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 1470px) {\n  .basic_table {\n    .table-responsive {\n      .table {\n        tbody {\n          tr {\n            td {\n              &:nth-child(n + 2) {\n                min-width: 180px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  .signal-table {\n    &.table-responsive {\n      .table {\n        tbody {\n          tr {\n            td {\n              &:nth-child(n + 2) {\n                min-width: 240px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 1660px) and (min-width: 1200px) {\n  .xl-none {\n    display: none;\n  }\n  .xl-60 {\n    max-width: 60%;\n    flex: 0 0 60%;\n  }\n  .xl-50 {\n    max-width: 50%;\n    flex: 0 0 50%;\n  }\n  .xl-100 {\n    max-width: 100%;\n    flex: 0 0 100%;\n  }\n  .xl-23 {\n    max-width: 23%;\n    flex: 0 0 23%;\n  }\n  .xl-25 {\n    max-width: 25%;\n    flex: 0 0 25%;\n  }\n  .xl-40 {\n    max-width: 40%;\n    flex: 0 0 40%;\n  }\n  .xl-4 {\n    max-width: 33.33%;\n    flex: 0 0 33.33%;\n  }\n}\n\n@media (max-width: 1280px) {\n  .img-gallery-set1,\n  .img-gallery-set5 {\n    display: none;\n  }\n\n  .box-layout.page-wrapper.horizontal-wrapper {\n    .page-header {\n      padding-left: unset;\n      max-width: unset;\n      left: unset;\n    }\n\n    .page-body-wrapper {\n      width: unset;\n    }\n  }\n}\n\n@media screen and (max-width: 1580px) and (min-width: 1200px) {\n  .docs-buttons,\n  .docs-toggles {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n}\n\n@media screen and (max-width: 1366px) and (min-width: 1200px) {\n  .flot-chart-container-small {\n    height: 227px;\n  }\n\n  .call-chat-sidebar {\n    max-width: 262px;\n  }\n\n  .product-box {\n    .product-details {\n      padding: 15px;\n\n      p {\n        margin-bottom: 10px;\n      }\n    }\n  }\n\n  .flot-chart-container {\n    height: 130px;\n  }\n\n  .custom-card {\n    .card-profile {\n      img {\n        height: 115px;\n      }\n    }\n\n    .profile-details {\n      h4 {\n        font-size: 18px;\n      }\n\n      h6 {\n        margin-bottom: 24px;\n      }\n    }\n\n    .card-footer {\n      > div {\n        h3 {\n          font-size: 18px;\n        }\n      }\n    }\n  }\n\n  .crm-activity {\n    height: 291px;\n    overflow-y: auto;\n\n    .media {\n      .media-body {\n        .dates {\n          display: flex;\n        }\n      }\n    }\n  }\n\n  // chat\n  .chat-body {\n    padding: 10px;\n  }\n\n  .chat-box {\n    .chat-history {\n      .call-content {\n        .btn {\n          font-size: 15px;\n        }\n      }\n      .total-time h2 {\n        font-size: 30px;\n      }\n      .receiver-img {\n        margin-top: 30px;\n      }\n      .call-icons {\n        margin-top: 20px;\n        margin-bottom: 20px;\n        ul {\n          li {\n            width: 50px;\n            height: 50px;\n            padding: 7px;\n          }\n        }\n      }\n    }\n\n    .user-image {\n      width: 30px;\n      height: 30px;\n      margin-top: 3px;\n      margin-right: 3px;\n    }\n\n    .about {\n      margin-top: 0;\n    }\n\n    .border-tab.nav-tabs {\n      .nav-item {\n        a {\n          padding: 13px 4px !important;\n          color: $semi-dark !important;\n          letter-spacing: 0;\n          font-size: 12px !important;\n          line-height: 6;\n        }\n      }\n    }\n\n    .chat-menu {\n      .people-list {\n        ul.list {\n          max-height: 376px;\n          overflow-y: auto;\n        }\n      }\n\n      .user-profile {\n        .image {\n          .avatar {\n            img {\n              width: 100px;\n              height: 100px;\n            }\n          }\n\n          .icon-wrapper {\n            width: 30px;\n            height: 30px;\n            font-size: 13px;\n          }\n        }\n      }\n    }\n  }\n\n  .chat-left-aside {\n    .people-list {\n      height: 420px;\n\n      ul {\n        max-height: 376px;\n        overflow-y: auto;\n      }\n    }\n\n    .status-circle {\n      top: 4px;\n      left: 36px;\n    }\n  }\n\n  //blog scss\n  .blog-box {\n    .blog-details-main {\n      .blog-bottom-details {\n        margin: 20px 10px;\n      }\n\n      .blog-social {\n        li {\n          padding: 0px 10px;\n        }\n      }\n    }\n  }\n\n  .blog-bottom-content {\n    display: none;\n  }\n\n  .blog-box.blog-shadow {\n    .blog-details {\n      padding: 10px;\n    }\n  }\n\n  .browser-widget {\n    .media-img {\n      margin-left: auto;\n      margin-right: auto;\n      margin-bottom: 15px;\n    }\n    img {\n      height: 50px;\n    }\n  }\n\n  // email-app\n  .email-wrap {\n    .email-left-aside {\n      .email-app-sidebar {\n        .media {\n          display: block;\n\n          .media-size-email {\n            width: 100%;\n            text-align: center;\n            img {\n              margin: 0 auto !important;\n            }\n          }\n\n          .media-body {\n            text-align: center;\n          }\n        }\n      }\n    }\n\n    .email-right-aside {\n      .email-body {\n        .attachment {\n          ul {\n            li {\n              img {\n                width: 73px;\n                height: 73px;\n              }\n            }\n          }\n        }\n\n        .email-top {\n          line-height: 50px;\n\n          .float-right {\n            display: none !important;\n          }\n\n          h5 {\n            padding: 13px 0;\n          }\n        }\n\n        .inbox {\n          max-height: 668px;\n          overflow: auto;\n\n          .media {\n            display: block;\n            text-align: center;\n\n            .media-size-email {\n              width: 100%;\n              text-align: center;\n\n              .mr-3 {\n                margin-right: 0 !important;\n              }\n            }\n          }\n\n          .media-body {\n            text-align: center;\n\n            h6 {\n              font-size: 14px;\n            }\n          }\n        }\n\n        .email-compose {\n          .cke_contents.cke_reset {\n            max-height: 144px;\n            width: 99%;\n          }\n\n          .compose-border {\n            margin: 0;\n          }\n        }\n      }\n    }\n  }\n\n  // alert page\n  .alert-dismissible {\n    p {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      max-width: 181px;\n    }\n  }\n\n  // touchspin page\n  .bootstrap-touchspin {\n    .touchspin-vertical-tab {\n      .input-group {\n        width: 96% !important;\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 1366px) {\n  .bookmark-wrap {\n    .task-sidebar {\n      height: auto;\n    }\n  }\n  // product page\n  .grid-options {\n    ul {\n      li {\n        &:last-child {\n          display: none;\n        }\n      }\n    }\n  }\n\n  .product-wrapper-grid {\n    &.list-view {\n      .product-box {\n        .product-img {\n          width: 25%;\n        }\n      }\n    }\n  }\n\n  // cart page\n  .cart {\n    .qty-box {\n      width: 40%;\n    }\n  }\n\n  // alert page\n  .alert-dismissible {\n    strong {\n      & ~ p {\n        display: inline;\n      }\n    }\n  }\n\n  // timeline small page\n  .timeline-small {\n    .media {\n      .media-body {\n        p {\n          width: 95%;\n        }\n      }\n    }\n  }\n\n  .map-js-height {\n    height: 350px;\n  }\n\n  // chat page\n  .chat-right-aside {\n    flex: 0 0 60%;\n    max-width: 60%;\n    overflow: hidden;\n    .chat {\n      .chat-message {\n        .smiley-box {\n          width: 45px;\n        }\n      }\n    }\n  }\n  .chat-box {\n    .chat-right-aside {\n      .chat {\n        .chat-msg-box {\n          height: 364px;\n          .chat-user-img {\n            margin-top: -30px;\n          }\n          .message {\n            width: 100%;\n            padding: 15px;\n          }\n        }\n        .chat-header {\n          .chat-menu-icons {\n            li {\n              a {\n                i {\n                  font-size: 20px;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    .chat-history {\n      .receiver-img {\n        img {\n          height: 150px;\n        }\n      }\n    }\n  }\n\n  .call-chat-body {\n    .chat-box {\n      overflow: hidden;\n      height: 565px;\n    }\n  }\n\n  .equal-height-xl {\n    height: 517px;\n  }\n\n  .authentication-main {\n    .auth-innerright {\n      background-size: cover;\n    }\n  }\n\n  .grp-btns {\n    display: inline-block;\n  }\n\n  .button-builder {\n    .button-generator-bx {\n      position: relative;\n      width: 100%;\n    }\n  }\n\n  .page-builder {\n    .btn-group {\n      display: inline-block;\n      margin-bottom: 10px;\n    }\n\n    .btn-grid {\n      margin-bottom: 15px;\n      margin-right: 0px;\n      border-right: none;\n      display: inline-block;\n    }\n\n    .ge-canvas.ge-layout-desktop {\n      margin-top: 50px;\n    }\n  }\n\n  //ecommerce dashboard\n  .ecommerce-widget {\n    .total-num {\n      font-size: 23px;\n      letter-spacing: 0px;\n    }\n  }\n  .support-ticket-font {\n    .total-num {\n      font-size: 22px;\n    }\n  }\n  .order-history {\n    table.dataTable.table thead th {\n      padding-right: 50px;\n    }\n  }\n\n  //default dashboard\n  .custom-card {\n    padding: 15px;\n\n    .card-social {\n      li {\n        a {\n          padding: 12px;\n        }\n      }\n    }\n  }\n\n  .map-chart {\n    .chart-container {\n      height: 300px;\n    }\n  }\n\n  .speed-chart {\n    .chart-container {\n      height: 250px;\n      margin-top: -40px;\n      margin-bottom: 100px;\n    }\n  }\n\n  .candidcahrt {\n    height: 360px;\n  }\n\n  //chart widget\n  .status-details {\n    h3 {\n      font-size: 18px;\n    }\n  }\n\n  .chart-widget-top {\n    .total-value {\n      font-size: 20px;\n    }\n  }\n\n  .status-widget {\n    .card-body {\n      padding: 10px;\n    }\n  }\n\n  //general widget\n  .browser-widget {\n    .media {\n      flex-wrap: wrap;\n\n      .media-body {\n        h3 {\n          font-size: 20px;\n        }\n\n        p {\n          margin-bottom: 2px;\n        }\n\n        h4 {\n          font-size: 20px;\n        }\n      }\n    }\n  }\n\n  .testimonial {\n    i {\n      font-size: 46px;\n    }\n\n    p {\n      margin-top: 20px;\n    }\n  }\n\n  .redial-social-widget {\n    width: 125px;\n    height: 125px;\n    i {\n      width: 100px;\n      height: 100px;\n      font-size: 35px;\n    }\n  }\n\n  //chat\n  .chat-body {\n    padding: 10px;\n  }\n\n  .chat-box {\n    .chat-history {\n      .call-content {\n        .btn {\n          font-size: 15px;\n        }\n      }\n      .total-time h2 {\n        font-size: 30px;\n      }\n      .receiver-img {\n        margin-top: 30px;\n        //margin-bottom: 30px;\n      }\n      .call-icons {\n        margin-top: 20px;\n        margin-bottom: 20px;\n\n        ul {\n          li {\n            width: 50px;\n            height: 50px;\n            padding: 7px;\n          }\n        }\n      }\n    }\n\n    .user-image {\n      width: 45px;\n      height: 45px;\n    }\n\n    .about {\n      margin-top: 0;\n    }\n\n    .border-tab.nav-tabs {\n      .nav-item {\n        a {\n          padding: 13px 4px !important;\n          color: $semi-dark !important;\n          letter-spacing: 0;\n          font-size: 12px !important;\n          line-height: 6;\n        }\n      }\n    }\n\n    .chat-menu {\n      .people-list {\n        ul.list {\n          max-height: 455px;\n          overflow-y: auto;\n        }\n      }\n\n      .user-profile {\n        margin-top: 0;\n\n        .image {\n          .avatar {\n            img {\n              width: 100px;\n              height: 100px;\n            }\n          }\n\n          .icon-wrapper {\n            width: 30px;\n            height: 30px;\n            font-size: 13px;\n          }\n        }\n\n        .user-content {\n          p {\n            font-size: 14px;\n            margin-bottom: 10px;\n          }\n\n          h5 {\n            margin: 20px 0;\n          }\n\n          hr {\n            margin: 20px 0;\n          }\n        }\n\n        .follow {\n          .follow-num {\n            font-size: 20px;\n          }\n        }\n      }\n    }\n  }\n\n  .chat-left-aside {\n    .people-list {\n      height: 490px;\n\n      ul {\n        max-height: 434px;\n        overflow-y: auto;\n      }\n    }\n  }\n\n  .status-circle {\n    top: 4px;\n    left: 37px;\n  }\n\n  // mega-menu\n  .mega-menu {\n    .onhover-show-div {\n      left: 164px;\n    }\n  }\n\n  // image cropper page\n  .img-cropper {\n    .docs-toggles {\n      margin-top: 8px;\n    }\n  }\n\n  // touchspin page\n  .bootstrap-touchspin {\n    .dropdown-basic {\n      .dropdown {\n        .dropdown-content {\n          left: -21px;\n        }\n      }\n    }\n  }\n\n  // datatable advance page\n  #advance-5_wrapper {\n    .dataTables_paginate {\n      margin-bottom: 8px;\n    }\n  }\n\n  // jsgrid-table page\n  #batchDelete {\n    .jsgrid-grid-header {\n      .jsgrid-table {\n        .jsgrid-header-row {\n          .jsgrid-header-cell {\n            &:first-child {\n              width: 67px !important;\n            }\n          }\n        }\n      }\n    }\n\n    .jsgrid-grid-body {\n      .jsgrid-table {\n        .jsgrid-row {\n          .jsgrid-cell {\n            &:first-child {\n              width: 67px !important;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // forget password page\n  .reset-password-box {\n    .theme-form {\n      .form-group {\n        .btn {\n          padding: 6px 22px;\n        }\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 1366px) and (min-width: 1200px) {\n  .page-wrapper {\n    &.horizontal-wrapper {\n      &.material-type {\n        .page-header {\n          max-width: 1140px;\n        }\n\n        .page-body-wrapper {\n          .sidebar-wrapper,\n          .page-body {\n            max-width: 1140px;\n          }\n        }\n      }\n    }\n  }\n}\n@media only screen and (max-width: 1199.98px) {\n  .md-sidebar {\n    .md-sidebar-toggle {\n      display: block;\n    }\n    .md-sidebar-aside {\n      position: absolute;\n      top: 40px;\n      left: 0;\n      opacity: 0;\n      visibility: hidden;\n      z-index: 3;\n      width: 280px;\n      [dir=\"rtl\"] & {\n        left: unset;\n        right: 0;\n      }\n      &.open {\n        opacity: 1;\n        visibility: visible;\n      }\n    }\n    .job-sidebar {\n      background-color: var(--white);\n      padding: 20px;\n      .faq-accordion.default-according {\n        margin-bottom: 0;\n        .row {\n          > div {\n            &:last-child {\n              .card {\n                margin-bottom: 0;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  .jkanban-container {\n    .kanban-container {\n      .kanban-drag {\n        > div {\n          width: 400px;\n          flex-wrap: wrap;\n          > div {\n            flex-wrap: wrap;\n            .react-kanban-column {\n              display: block !important;\n              margin-bottom: 20px;\n            }\n          }\n        }\n      }\n    }\n  }\n  // kanban board\n  .jkanban-container {\n    .kanban-container {\n      .kanban-board {\n        width: 400px;\n        .kanban-drag {\n          > div {\n            > div {\n              display: block;\n              div[data-testid=\"lane\"] {\n                display: block;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  .file-sidebar {\n    padding-right: 12px;\n    [dir=\"rtl\"] & {\n      padding-right: 0;\n    }\n  }\n  .col-xl-7.b-center.bg-size {\n    top: 0;\n    height: 100vh;\n    opacity: 0.5;\n    position: fixed;\n  }\n  .login-card {\n    background: transparent;\n  }\n\n  .knowledgebase-bg {\n    height: 400px;\n  }\n  .knowledgebase-search {\n    .form-inline {\n      width: 400px;\n      padding: 7px 45px;\n\n      svg {\n        top: 14px;\n      }\n    }\n  }\n  .btn-group {\n    .btn {\n      padding: 0.375rem 1.25rem;\n    }\n  }\n\n  .link-section > div {\n    &.active {\n      > h6 {\n        &:before {\n          content: \"\\f107\";\n          transition: content 0.3s ease;\n        }\n      }\n    }\n\n    > h6 {\n      position: relative;\n\n      &:before {\n        content: \"\\f105\";\n        font-family: fontAwesome;\n        position: absolute;\n        right: 10px;\n        font-size: 18px;\n        transition: content 0.3s ease;\n      }\n    }\n  }\n  .alert-theme {\n    min-width: 420px;\n  }\n  .mega-menu-header {\n    .header-wrapper {\n      .vertical-mobile-sidebar {\n        display: block;\n        margin-right: 15px;\n      }\n    }\n  }\n\n  // sidebar css\n  .page-wrapper {\n    .page-header {\n      .header-wrapper {\n        .nav-right {\n          position: unset;\n          padding: 0;\n\n          > ul {\n            li {\n              .submenu {\n                li {\n                  &:first-child {\n                    padding-left: 15px !important;\n                  }\n                }\n              }\n            }\n          }\n        }\n\n        .mobile-sidebar {\n          .switch-sm {\n            .switch {\n              margin-top: 6px;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // social app page\n  .photos {\n    ul {\n      li {\n        width: auto;\n\n        &:nth-child(3n) {\n          margin-right: 15px;\n        }\n      }\n    }\n  }\n\n  .user-profile {\n    .hovercard {\n      .user-image {\n        .share-icons {\n          position: absolute;\n          right: 45px;\n          top: -22px;\n\n          li {\n            .social-icon {\n              width: 40px;\n              height: 40px;\n\n              i {\n                font-size: 18px;\n              }\n            }\n\n            color: #fff;\n            font-size: 25px;\n          }\n        }\n      }\n    }\n  }\n\n  // timeline small page\n  .timeline-small {\n    .media {\n      .timeline-round {\n        &.timeline-line-1 {\n          &:after {\n            height: 33px;\n            bottom: -52px;\n          }\n        }\n\n        &.small-line {\n          &:after {\n            height: 18px;\n            bottom: -34px;\n          }\n        }\n\n        &.medium-line {\n          &:after {\n            height: 30px;\n            bottom: -52px;\n          }\n        }\n      }\n\n      .media-body {\n        p {\n          width: 100%;\n        }\n      }\n    }\n  }\n\n  .lg-mt-col {\n    margin-top: 30px;\n  }\n\n  .xl-none {\n    display: none;\n  }\n\n  .lg-mt {\n    margin-top: 30px;\n  }\n  .product-wrapper-grid {\n    &.list-view {\n      .product-box {\n        .product-img {\n          width: 32%;\n        }\n      }\n    }\n  }\n\n  .debit-card {\n    order: 1;\n  }\n\n  .typography {\n    .row {\n      div {\n        & + div {\n          margin-top: 30px;\n        }\n      }\n    }\n  }\n\n  .listing {\n    .card-body {\n      .row {\n        > div {\n          & + div {\n            margin-top: 30px;\n          }\n        }\n      }\n    }\n  }\n\n  .flot-chart-container {\n    height: 200px;\n  }\n\n  .img-cropper {\n    #putData {\n      margin-bottom: 10px;\n    }\n\n    .docs-toggles {\n      > .dropdown {\n        margin-bottom: 0;\n      }\n    }\n  }\n\n  .error-wrapper {\n    .maintenance-icons {\n      li {\n        i {\n          color: $light-color;\n          font-size: 40px;\n        }\n\n        &:nth-child(2) {\n          i {\n            font-size: 80px;\n            margin-left: 90px;\n          }\n        }\n\n        &:nth-child(3) {\n          i {\n            font-size: 120px;\n            margin-top: -75px;\n            margin-right: 110px;\n          }\n        }\n      }\n    }\n  }\n\n  div {\n    &.dataTables_wrapper {\n      div {\n        &.dataTables_paginate {\n          & ~ .dataTables_filter {\n            display: block;\n            width: 100%;\n            margin-top: 20px;\n            margin-bottom: 0;\n          }\n        }\n      }\n    }\n  }\n\n  .jvector-map-height {\n    height: 280px;\n  }\n\n  .blog-list {\n    .blog-details {\n      p {\n        margin-bottom: 5px;\n      }\n    }\n  }\n\n  .custom-card {\n    .card-profile {\n      .card-footer {\n        > div {\n          h3 {\n            font-size: 18px;\n          }\n        }\n      }\n    }\n  }\n\n  .equal-height-lg {\n    min-height: unset !important;\n  }\n\n  //mega menu\n  .mega-menu {\n    .onhover-show-div {\n      height: 435px;\n      overflow-x: scroll;\n      left: 215px;\n    }\n\n    .mega-bg {\n      display: none;\n    }\n\n    .lg-mt {\n      margin-top: 25px;\n    }\n  }\n\n  .button-builder {\n    .button-generator-bx {\n      position: relative;\n      width: 100%;\n    }\n  }\n\n  //blog\n  .blog-single {\n    .comment-box {\n      ul {\n        .comment-social {\n          margin-left: 0;\n          [dir=\"rtl\"] & {\n            margin-left: unset;\n            margin-right: 0;\n          }\n        }\n      }\n    }\n  }\n\n  //error and maintenace\n  .error-wrapper {\n    .maintenance-heading {\n      margin-top: 30px;\n\n      .headline {\n        font-size: 50px;\n        margin-top: -15%;\n        margin-bottom: 0px;\n      }\n\n      .cloud-second {\n        margin-top: -25px;\n      }\n    }\n  }\n\n  // general widget\n  .testimonial {\n    p {\n      margin-top: 17px;\n    }\n  }\n\n  .browser-widget {\n    padding: 0px;\n    img {\n      height: 50px;\n    }\n    .media {\n      .media-body {\n        h4 {\n          font-size: 17px;\n        }\n      }\n\n      .media-img {\n        width: 100%;\n        text-align: center;\n        margin-bottom: 10px;\n      }\n    }\n  }\n\n  //ecommerce dashboard\n  .crm-overall {\n    .overall-chart {\n      height: 200px;\n    }\n  }\n\n  // eccommerce product\n  .product-table {\n    table.dataTable thead > tr > th {\n      padding-right: 50px;\n    }\n  }\n\n  //chat\n  .chat-menu-icons {\n    display: block;\n    clear: both;\n  }\n\n  .chat-menu {\n    right: 0;\n    border-top: 1px solid $light-semi-gray;\n    opacity: 0;\n    transform: translateY(-30px);\n    visibility: hidden;\n    top: 60px;\n    position: absolute !important;\n    z-index: 3;\n    background-color: $white;\n    transition: all linear 0.3s;\n\n    &.show {\n      opacity: 1;\n      visibility: visible;\n      transform: translateY(0px);\n      transition: all linear 0.3s;\n      padding-bottom: 25px;\n    }\n  }\n\n  .chat-box {\n    .chat-menu {\n      .people-list {\n        ul.list {\n          max-height: 444px;\n          overflow-y: auto;\n        }\n      }\n    }\n    .btn-lg {\n      font-size: 12px;\n    }\n    .people-list {\n      ul {\n        height: auto;\n      }\n    }\n    .chat-right-aside {\n      .chat {\n        .chat-header {\n          height: auto;\n          .chat-menu-icons {\n            gap: 5px;\n            li {\n              a {\n                i {\n                  font-size: 19px;\n                }\n                svg {\n                  width: 19px;\n                  height: 19px;\n                }\n              }\n            }\n          }\n        }\n        .chat-message {\n          margin: 0;\n        }\n      }\n    }\n    .chat-history {\n      .total-time h2 {\n        font-size: 25px;\n      }\n      .row {\n        .col-sm-7 {\n          padding-right: 0;\n        }\n      }\n    }\n    .border-tab.nav-tabs {\n      width: 100%;\n      .nav-item {\n        margin-right: 5px;\n      }\n    }\n    .chat-left-aside {\n      .people-list {\n        height: 493px;\n      }\n    }\n\n    .chat-history {\n      .call-content {\n        > div {\n          padding-top: 70px;\n        }\n      }\n    }\n\n    .toogle-bar {\n      display: inline-block;\n      margin-right: 0 !important;\n    }\n  }\n\n  .chat-right-aside {\n    flex: 0 0 100%;\n    max-width: calc(100% - 15px);\n    overflow: hidden;\n  }\n\n  .call-chat-body {\n    .chat-box {\n      overflow: auto;\n      height: auto;\n    }\n  }\n\n  // Email app\n  .email-wrap {\n    .email-right-aside {\n      .email-body {\n        .b-r-light {\n          border-right: none !important;\n        }\n      }\n      .radius-left {\n        border-top-left-radius: 4px !important;\n        border-bottom-left-radius: 4px !important;\n      }\n    }\n\n    .row {\n      .col-xl-3 {\n        & + .col-xl-3 {\n          padding-right: 15px;\n        }\n      }\n\n      .col-xl-6 {\n        padding-left: 15px;\n      }\n    }\n  }\n\n  // icons\n  .icon-lists {\n    div {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      max-width: 209px;\n    }\n  }\n\n  // tour page\n  .like-comment-lg-mb {\n    margin-bottom: 12px;\n  }\n\n  // ribbons page\n  .ribbon-space-bottom {\n    top: 9px;\n  }\n\n  // touchspin page\n  .bootstrap-touchspin {\n    .touchspin-vertical-tab {\n      .input-group {\n        width: 98.5% !important;\n      }\n    }\n  }\n\n  // jsgrid-table page\n  #batchDelete {\n    .jsgrid-grid-header {\n      .jsgrid-table {\n        .jsgrid-header-row {\n          .jsgrid-header-cell {\n            &:first-child {\n              width: 95px !important;\n            }\n          }\n        }\n      }\n    }\n\n    .jsgrid-grid-body {\n      .jsgrid-table {\n        .jsgrid-row {\n          .jsgrid-cell {\n            &:first-child {\n              width: 95px !important;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // user-profile page\n  .profile-img-style {\n    #aniimated-thumbnials-3 {\n      text-align: center;\n    }\n  }\n\n  // vertical page\n  .vertical-menu-mt {\n    margin-top: 80px !important;\n\n    .xl-none {\n      display: block;\n    }\n  }\n\n  // calender page\n  .calendar-wrap {\n    .fc-day-grid-event {\n      width: 87%;\n    }\n  }\n\n  // product-page //\n  .product-page-main {\n    .product-page-details {\n      h3 {\n        font-size: 26px;\n      }\n    }\n  }\n}\n@media only screen and (max-width: 1199px) and (min-width: 992px) {\n  .page-wrapper {\n    &.horizontal-wrapper {\n      &.material-type {\n        .page-header {\n          max-width: 930px;\n        }\n        .page-body-wrapper {\n          .sidebar-wrapper,\n          .page-body {\n            max-width: 930px;\n          }\n        }\n      }\n    }\n  }\n}\n@media only screen and (max-width: 991.98px) {\n  .todo-list-wrapper {\n    #todo-list {\n      li {\n        .task-container {\n          .task-label {\n            min-width: 460px;\n          }\n        }\n      }\n    }\n  }\n  .simplebar-mask {\n    top: 70px;\n  }\n  .project-cards {\n    .tab-content {\n      margin-bottom: -20px;\n    }\n  }\n  .project-box {\n    margin-bottom: 20px;\n  }\n  .page-wrapper {\n    &.modern-type {\n      .simplebar-mask {\n        top: 70px;\n      }\n    }\n    &.compact-sidebar {\n      .simplebar-mask {\n        top: 87px;\n      }\n      .page-header {\n        margin-left: 0;\n        width: calc(100% - 0px);\n      }\n      .page-body-wrapper {\n        div.sidebar-wrapper {\n          &.close_icon {\n            .sidebar-main {\n              .sidebar-links {\n                li {\n                  .sidebar-link {\n                    &.active {\n                      ~ .sidebar-submenu {\n                        display: none !important;\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n\n        .page-body {\n          margin-top: 60px;\n        }\n      }\n    }\n    &.only-body {\n      .page-header {\n        .header-wrapper {\n          .search-full {\n            .Typeahead-menu {\n              top: 65px;\n            }\n          }\n        }\n      }\n    }\n    &.advance-layout {\n      .page-body-wrapper {\n        .sidebar-wrapper {\n          position: fixed !important;\n          top: 0 !important;\n        }\n      }\n    }\n  }\n  .product-box {\n    .modal {\n      .modal-header {\n        .product-box {\n          .product-details {\n            padding-left: 15px;\n            padding-right: 15px;\n          }\n        }\n      }\n    }\n  }\n  .search-form {\n    .form-group {\n      &:before {\n        top: 33px;\n      }\n\n      &:after {\n        top: 35px;\n      }\n    }\n  }\n  .mobile-title {\n    &.d-none {\n      padding: 11px 30px 10px;\n    }\n  }\n  .page-wrapper {\n    .page-header {\n      .header-wrapper {\n        .nav-right {\n          .profile-dropdown {\n            top: 50px;\n          }\n        }\n\n        .search-full {\n          input {\n            line-height: 50px;\n          }\n\n          .form-group {\n            .close-search {\n              top: 20px;\n            }\n\n            &:before {\n              top: 18px;\n            }\n          }\n        }\n      }\n    }\n\n    .current_lang {\n      .lang {\n        span {\n          &.lang-txt {\n            display: none;\n          }\n        }\n      }\n    }\n  }\n  .customizer-contain {\n    top: 62px;\n  }\n  .m-r-30 {\n    margin-right: 20px;\n  }\n  .card.full-card {\n    top: 60px;\n    width: calc(100vw - 0px);\n  }\n\n  .vertical-mobile-sidebar {\n    right: 75px;\n    top: 18px;\n  }\n\n  .gallery {\n    margin-bottom: -20px;\n  }\n\n  .my-gallery {\n    figure {\n      margin-bottom: 20px;\n    }\n  }\n\n  #aniimated-thumbnials {\n    figure {\n      &:nth-child(12),\n      &:nth-child(11),\n      &:nth-child(10),\n      &:nth-child(9) {\n        margin-bottom: 20px;\n      }\n    }\n  }\n\n  .photoswipe-pb-responsive {\n    padding-bottom: 25px !important;\n  }\n\n  // datatable css\n  table {\n    &.dataTable {\n      &.fixedHeader-locked,\n      &.fixedHeader-floating {\n        left: 0 !important;\n        width: 100% !important;\n      }\n    }\n  }\n\n  // main header css\n  .page-wrapper {\n    .section-space {\n      padding: 60px 0;\n    }\n\n    .card {\n      margin-bottom: 30px;\n\n      .card-header,\n      .card-body,\n      .card-footer {\n        padding: 20px;\n\n        .tab-content {\n          .m-t-30 {\n            margin-top: 20px !important;\n          }\n\n          .m-b-30 {\n            margin-bottom: 20px !important;\n          }\n        }\n      }\n    }\n\n    .page-body-wrapper {\n      .footer-fix {\n        margin-left: 0px;\n        padding-right: 15px;\n        width: calc(100% - 0px) !important;\n      }\n    }\n\n    &.compact-wrapper {\n      .page-header {\n        margin-left: 0 !important;\n        width: calc(100% - 0px) !important;\n\n        .header-wrapper {\n          .maximize {\n            display: none;\n          }\n\n          .header-logo-wrapper {\n            display: flex;\n          }\n\n          .toggle-sidebar {\n            position: unset;\n            margin-right: 15px;\n            border-right: 1px solid #ddd;\n            padding-right: 15px;\n            display: block;\n\n            &:before {\n              display: none;\n            }\n          }\n\n          .toggle-nav {\n            display: none;\n          }\n        }\n      }\n\n      .page-body-wrapper {\n        div.sidebar-wrapper {\n          top: 0;\n\n          &.close_icon {\n            &:hover {\n              transform: translate(-285px);\n            }\n          }\n\n          .logo-wrapper {\n            padding: 17px 30px;\n\n            .back-btn {\n              display: inline-block;\n              float: right;\n              font-size: 20px;\n            }\n\n            .toggle-sidebar {\n              display: none;\n            }\n          }\n\n          .sidebar-main {\n            .sidebar-links {\n              height: calc(100vh - 95px);\n            }\n          }\n\n          &.close_icon {\n            transform: translate(-285px);\n\n            .sidebar-main {\n              .sidebar-links {\n                height: unset;\n              }\n            }\n          }\n        }\n\n        .page-body {\n          margin-top: 60px;\n          padding: 0 15px;\n        }\n      }\n    }\n\n    &.compact-sidebar {\n      .page-header {\n        .header-wrapper {\n          .maximize {\n            display: none;\n          }\n        }\n      }\n    }\n\n    &.modern-type {\n      .page-header {\n        .header-wrapper {\n          .logo-wrapper {\n            display: none;\n            margin-right: 0;\n          }\n        }\n      }\n      .page-body-wrapper {\n        div.sidebar-wrapper {\n          margin: 0 !important;\n          .logo-wrapper {\n            display: block;\n          }\n        }\n      }\n    }\n\n    &.material-icon {\n      .page-header {\n        padding-left: 0;\n      }\n      .page-body-wrapper {\n        .page-body {\n          padding-left: 15px;\n        }\n      }\n    }\n\n    .page-header {\n      .header-wrapper {\n        margin: 0;\n        padding: 12px 30px;\n\n        .nav-right {\n          .notification {\n            top: 10px;\n          }\n        }\n\n        > .mobile-toggle {\n          cursor: pointer;\n          display: flex;\n          align-items: center;\n        }\n\n        .header-logo-wrapper {\n          margin-right: 0;\n        }\n      }\n\n      .header-logo-wrapper {\n        .logo-wrapper {\n          img {\n            margin-top: 0;\n          }\n        }\n      }\n    }\n  }\n  .page-body-wrapper {\n    .page-body,\n    footer {\n      margin-left: 0 !important;\n\n      #customer-review {\n        .owl-stage-outer {\n          width: 100% !important;\n        }\n      }\n    }\n  }\n  .default-according {\n    .card {\n      margin-bottom: 10px !important;\n\n      .card-header {\n        padding: 0 !important;\n      }\n    }\n  }\n  .faq-wrap {\n    .faq-accordion {\n      &.default-according {\n        .card {\n          .faq-header {\n            padding: 20px 20px 0 !important;\n          }\n        }\n      }\n    }\n  }\n\n  // general widget page\n  .crm-activity {\n    > {\n      li {\n        + li {\n          margin-top: 10px;\n          padding-top: 10px;\n        }\n      }\n    }\n  }\n\n  // add post page\n  .add-post {\n    .dropzone {\n      margin-bottom: 20px;\n    }\n  }\n\n  // avatar page\n  .customers {\n    &.avatar-group {\n      margin-right: 20px;\n    }\n  }\n\n  //social app page css\n  .socialprofile {\n    .social-btngroup {\n      margin: 20px 0;\n    }\n\n    .social-group {\n      margin-top: 20px;\n    }\n  }\n\n  .social-status {\n    form {\n      .form-group {\n        .form-control-social {\n          margin-bottom: 20px;\n        }\n      }\n    }\n\n    .media {\n      margin-bottom: 20px;\n    }\n  }\n\n  .timeline-content {\n    p,\n    .comments-box {\n      margin-top: 20px;\n    }\n  }\n\n  .social-chat {\n    margin-top: 20px;\n\n    .media-body {\n      padding: 20px;\n    }\n\n    .your-msg,\n    .other-msg {\n      margin-bottom: 20px;\n    }\n  }\n\n  .social-network {\n    span {\n      margin-bottom: 20px;\n    }\n  }\n\n  .details-about {\n    + .details-about {\n      margin-top: 20px;\n    }\n  }\n\n  .activity-log {\n    .my-activity {\n      + .my-activity {\n        margin-top: 20px;\n      }\n    }\n  }\n\n  .new-users-social {\n    margin-bottom: 20px;\n  }\n\n  // timeline small page css\n  .timeline-small {\n    .media {\n      margin-bottom: 20px;\n\n      .media-body {\n        h6 {\n          margin-bottom: 20px;\n        }\n\n        p {\n          width: 75%;\n        }\n      }\n\n      .timeline-round {\n        width: 45px;\n        height: 45px;\n        top: -14px;\n\n        &.timeline-line-1 {\n          &:after {\n            bottom: -41px;\n            height: 25px;\n          }\n        }\n\n        &.small-line {\n          &:after {\n            bottom: -26px;\n            height: 14px;\n          }\n        }\n\n        &.medium-line {\n          &:after {\n            bottom: -33px;\n            height: 17px;\n          }\n        }\n\n        svg {\n          top: 14px;\n        }\n      }\n    }\n  }\n\n  // helper classes page start\n  .helper-classes {\n    padding: 20px;\n  }\n\n  // helper classes page ends\n  .floated-customizer-btn,\n  .floated-customizer-panel {\n    display: none;\n  }\n\n  .page-builder {\n    .ge-canvas {\n      &.ge-editing {\n        .row {\n          padding: 20px;\n        }\n      }\n    }\n  }\n\n  .ecommerce-widget {\n    .progress-showcase {\n      margin-top: 20px;\n    }\n  }\n\n  .crm-overall {\n    margin: 0 -20px -20px;\n  }\n\n  .product-page-main {\n    padding: 20px;\n  }\n\n  .grid-options {\n    ul {\n      li {\n        &:nth-child(3) {\n          display: none;\n        }\n      }\n    }\n  }\n\n  .feature-products {\n    form {\n      .form-group {\n        i {\n          right: 20px;\n        }\n      }\n    }\n  }\n\n  .tabbed-card ul {\n    padding: 18px 15px;\n  }\n\n  .tabbed-card {\n    ul {\n      top: -7px;\n      right: 0;\n\n      &.border-tab {\n        &.nav-tabs {\n          padding: 0;\n\n          .nav-item {\n            .nav-link {\n              padding: 10px 15px;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .tilt-showcase {\n    .tilt-image {\n      text-align: center;\n    }\n\n    .mt-4 {\n      margin-top: 20px !important;\n    }\n  }\n\n  .todo {\n    .todo-list-wrapper {\n      .mark-all-tasks {\n        top: 20px;\n        right: 20px;\n      }\n    }\n  }\n  .custom-card {\n    padding-bottom: 0;\n\n    .card-footer {\n      padding: 0 15px 15px 15px !important;\n    }\n\n    .card-header {\n      border: none;\n    }\n\n    .dashboard-card {\n      padding: 0;\n    }\n\n    .card-profile {\n      img {\n        height: 155px;\n      }\n    }\n  }\n  .display-1 {\n    font-size: 4rem;\n  }\n\n  .display-2 {\n    font-size: 3.5rem;\n  }\n\n  .display-3 {\n    font-size: 2.5rem;\n  }\n\n  .display-4 {\n    font-size: 1.5rem;\n  }\n\n  .typography {\n    .h1 {\n      font-size: 34px;\n    }\n\n    .h2 {\n      font-size: 30px;\n    }\n\n    .h3 {\n      font-size: 22px;\n    }\n\n    .h4 {\n      font-size: 20px;\n    }\n\n    .h5 {\n      font-size: 18px;\n    }\n\n    .h6 {\n      font-size: 15px;\n    }\n  }\n\n  h1 {\n    font-size: 34px;\n  }\n\n  h2 {\n    font-size: 28px;\n  }\n\n  h3 {\n    font-size: 26px;\n  }\n\n  h4 {\n    font-size: 22px;\n  }\n\n  h5 {\n    font-size: 18px;\n  }\n\n  h6 {\n    font-size: 15px;\n  }\n\n  .card-absolute {\n    .card-header {\n      padding: 10px 15px !important;\n    }\n  }\n\n  .comingsoon {\n    .comingsoon-inner {\n      .countdown {\n        .time {\n          width: 80px;\n          height: 80px;\n          font-size: 26px;\n        }\n      }\n    }\n  }\n\n  .calendar-wrap {\n    .basic-calendar {\n      .external-events {\n        .fc-event {\n          & + .fc-event {\n            margin-top: 10px;\n          }\n        }\n      }\n    }\n  }\n\n  .owl-theme {\n    .owl-nav {\n      &.disabled {\n        & + .owl-dots {\n          margin-bottom: -10px;\n          margin-top: 15px;\n        }\n      }\n    }\n  }\n\n  .card {\n    .card-header {\n      h5 {\n        font-size: 18px;\n      }\n\n      .card-header-right {\n        top: 12px;\n        right: 15px;\n      }\n    }\n  }\n\n  .page-builder {\n    .ge-addRowGroup {\n      width: 100%;\n    }\n  }\n\n  //user profile\n  .user-profile {\n    .hovercard {\n      .info {\n        .user-designation {\n          margin-bottom: 20px;\n        }\n      }\n    }\n  }\n\n  // search page //\n  .search-list {\n    justify-content: center;\n  }\n\n  //blog\n  .blog-single {\n    .comment-box {\n      .comment-social {\n        li {\n          padding-left: 15px;\n        }\n      }\n    }\n  }\n\n  //error and maintenace\n  .error-wrapper {\n    padding: 35px 0;\n\n    .sub-content {\n      font-size: 14px;\n      line-height: 25px;\n      margin-top: 0px;\n    }\n\n    .error-heading {\n      margin-top: 30px;\n\n      .headline {\n        font-size: 180px;\n        margin-top: 0;\n      }\n    }\n\n    .maintenance-heading {\n      margin-top: 30px;\n    }\n  }\n\n  // editor_container //\n  .editor_container {\n    .CodeMirror {\n      min-height: 250px;\n      height: 250px;\n    }\n  }\n\n  //search\n  .search-page {\n    .info-block {\n      flex-wrap: wrap;\n    }\n    .tab-content {\n      .pb-4 {\n        padding-bottom: 20px !important;\n      }\n    }\n  }\n\n  // general widget\n  .xl-none {\n    display: block;\n  }\n\n  //blog\n  .top-radius-blog {\n    width: 100%;\n  }\n\n  .sm-100-w {\n    width: 100%;\n    height: 100%;\n  }\n\n  /*Form Wizard One start*/\n  .form-wizard {\n    .btn-mb {\n      margin-bottom: 20px;\n    }\n  }\n\n  /*Form Wizard One ends*/\n\n  /*Form Wizard Two Start*/\n  .stepwizard {\n    margin-bottom: 20px;\n  }\n\n  /*Form Wizard Two Ends*/\n\n  /*Form Wizard Three Start*/\n  .f1 {\n    .f1-steps {\n      margin-top: 20px;\n      margin-bottom: 20px;\n    }\n  }\n\n  /*Form Wizard Three ends*/\n\n  /*Form Wizard Four Start*/\n  .wizard-4 {\n    ul.anchor {\n      padding-right: 20px;\n      width: 40%;\n      li {\n        a {\n          &.done {\n            h4 {\n              &:before {\n                top: -8px;\n              }\n            }\n          }\n        }\n        h4 {\n          padding: 11px 18px;\n          width: 50px;\n        }\n        + li {\n          a {\n            padding-left: 65px;\n            [dir=\"rtl\"] & {\n              padding-right: 65px;\n            }\n          }\n        }\n      }\n    }\n    .step-container {\n      width: 60%;\n      div.content {\n        .wizard-title {\n          width: 380px;\n        }\n      }\n    }\n\n    .login-card {\n      .login-main {\n        width: 380px;\n      }\n    }\n\n    .msg-box {\n      top: 25px !important;\n    }\n  }\n\n  /*Form Wizard Four ends*/\n  // tab material\n  .border-tab.nav-tabs {\n    margin-bottom: 20px;\n  }\n\n  .tab-content {\n    ~ .nav-tabs {\n      &.border-tab {\n        margin-top: 20px;\n      }\n    }\n  }\n\n  // support ticket\n  .dataTables_wrapper {\n    .dataTables_length {\n      margin-bottom: 20px;\n    }\n\n    table.dataTable {\n      margin-bottom: 20px !important;\n    }\n  }\n\n  // search page\n  .search-page {\n    .info-block {\n      + .info-block {\n        padding-top: 20px;\n        margin-top: 20px;\n      }\n    }\n\n    #video-links {\n      .embed-responsive + .embed-responsive {\n        margin-top: 20px;\n      }\n    }\n  }\n\n  .lg-mt {\n    margin-top: 20px;\n  }\n\n  .gallery-with-description {\n    margin-bottom: -20px;\n\n    a {\n      > div {\n        margin-bottom: 20px;\n      }\n    }\n  }\n\n  // clipboard\n  .clipboaard-container {\n    p {\n      margin-bottom: 8px;\n    }\n  }\n\n  // summer-note\n  .m-b-30 {\n    margin-bottom: 20px !important;\n  }\n\n  // email app\n  .email-wrap {\n    .email-left-aside {\n      .email-app-sidebar {\n        ul {\n          li {\n            hr {\n              margin: 13px 0;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // navs page\n  .nav-md-mt {\n    margin-top: 20px;\n  }\n\n  .navs-icon {\n    padding: 20px;\n\n    .main-section {\n      padding-top: 20px;\n    }\n\n    .separator {\n      margin: 20px 0;\n    }\n  }\n\n  .nav-list {\n    padding: 20px;\n  }\n\n  .navs-dropdown {\n    button {\n      margin-top: 20px;\n    }\n\n    .onhover-show-div {\n      top: 68px;\n    }\n  }\n\n  // animated modal page\n  .animated-modal {\n    .form-group {\n      width: 100%;\n      display: block;\n    }\n\n    .mr-4 {\n      margin-right: 0 !important;\n    }\n  }\n\n  // steps page\n  .steps-md-mt {\n    margin-top: 20px;\n  }\n\n  // button group page\n  .btn-group-wrapper {\n    .m-b-30 {\n      &:last-child {\n        margin-bottom: 0 !important;\n      }\n    }\n  }\n\n  // datatable advance page\n  #advance-5_wrapper {\n    .dataTables_paginate {\n      margin-bottom: 20px;\n    }\n  }\n\n  // summer-note page\n  .click2edit {\n    & ~ .note-editor {\n      &.note-frame {\n        margin-bottom: 20px;\n      }\n    }\n  }\n\n  // call-chat page\n  .chat-box {\n    .chat-left-aside {\n      .people-list {\n        height: 483px;\n      }\n    }\n    .chat-right-aside {\n      .chat {\n        .chat-header {\n          .chat-menu-icons {\n            li {\n              margin-right: 5px;\n            }\n          }\n        }\n      }\n    }\n  }\n  .card {\n    .card-body {\n      form {\n        &.animated-modal {\n          display: flex;\n\n          .animated-modal-md-mb {\n            margin-bottom: 20px !important;\n          }\n        }\n      }\n    }\n  }\n  .wizard-4 {\n    .msg-box {\n      top: 40px;\n      right: 0%;\n      bottom: unset;\n      left: unset;\n    }\n  }\n  .theme-form {\n    &.form-inline {\n      display: flex;\n    }\n  }\n}\n@media only screen and (max-width: 991px) and (min-width: 768px) {\n  .page-wrapper {\n    &.compact-wrapper {\n      &.material-type {\n        &::before {\n          height: 230px;\n        }\n\n        .page-header {\n          width: calc(100% - 60px) !important;\n          margin: 50px auto 0 !important;\n        }\n\n        .page-body-wrapper {\n          margin: 0 30px;\n\n          div.sidebar-wrapper {\n            left: 0;\n          }\n\n          .page-body {\n            margin-top: 0;\n          }\n        }\n      }\n    }\n  }\n}\n@media only screen and (max-width: 810px) {\n  .page-wrapper {\n    .page-header {\n      .header-wrapper {\n        .nav-right {\n          > ul {\n            > li {\n              .profile-media {\n                .media-body {\n                  display: none;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 767.98px) {\n  .wizard-4 {\n    ul.anchor {\n      width: 100%;\n      height: auto;\n      padding: 30px;\n    }\n    .step-container {\n      width: 100%;\n    }\n  }\n\n  .contact-editform {\n    padding-left: 20px !important;\n  }\n  .event-calendar {\n    display: block !important;\n    #right {\n      width: 100%;\n    }\n    #calendar {\n      clear: both;\n    }\n  }\n  .page-wrapper {\n    &.material-type {\n      &::before {\n        display: none;\n      }\n      .page-header {\n        margin-top: 0;\n        border-radius: 0;\n      }\n      .page-body-wrapper {\n        .page-body {\n          margin-top: 0 !important;\n        }\n      }\n    }\n\n    &.only-body {\n      .page-header {\n        .header-wrapper {\n          .nav-right {\n            > ul {\n              > li {\n                margin-right: -2px;\n              }\n            }\n            .nav-menus {\n              margin-right: -10px;\n            }\n          }\n        }\n      }\n    }\n  }\n  .new-products {\n    .owl-carousel {\n      .product-box {\n        &.row {\n          > div {\n            width: auto;\n          }\n        }\n      }\n    }\n  }\n  .profile-media {\n    .media-body {\n      display: none;\n    }\n  }\n  .form-inline {\n    .form-group:not(.form-control-search) {\n      width: 100%;\n\n      + .form-group {\n        margin-top: 10px;\n      }\n\n      input {\n        width: 100%;\n      }\n    }\n  }\n  .credit-card {\n    .text-center {\n      img {\n        margin-bottom: 20px;\n      }\n    }\n  }\n  .starter-kit-fix {\n    .page-body {\n      margin-bottom: 78px;\n    }\n  }\n  .blog-box {\n    .blog-details-main {\n      .blog-social {\n        li {\n          padding: 0 12px;\n        }\n      }\n    }\n\n    .blog-details {\n      .blog-social {\n        li {\n          &:first-child {\n            padding-right: 25px;\n          }\n\n          + li {\n            padding-left: 25px;\n          }\n        }\n      }\n    }\n  }\n  .footer-copyright {\n    ~ div {\n      text-align: center;\n\n      p {\n        float: none;\n        margin-top: 5px;\n      }\n    }\n  }\n\n  // button page //\n  .btn-showcase {\n    text-align: center;\n  }\n\n  // social app page css\n  .user-profile {\n    .hovercard {\n      .user-image {\n        .share-icons {\n          right: 25px;\n          top: -19px;\n\n          li {\n            .social-icon {\n              width: 35px;\n              height: 35px;\n            }\n          }\n        }\n      }\n    }\n  }\n  .tabs-scoial {\n    &.border-tab {\n      &.nav-tabs {\n        display: flex;\n      }\n    }\n  }\n\n  // timeline small page css\n  .timeline-small {\n    .media {\n      .media-body {\n        p {\n          width: 100%;\n        }\n      }\n    }\n  }\n\n  // icon-compact layout page\n  .my-gallery {\n    figure {\n      &:nth-child(9),\n      &:nth-child(10) {\n        margin-bottom: 20px;\n      }\n    }\n  }\n\n  // project list //\n  .project-list {\n    .btn {\n      float: left;\n      margin-top: 5px;\n    }\n  }\n\n  // chat\n  .chat-box {\n    .chat-right-aside {\n      .chat {\n        .chat-message {\n          .text-box {\n            .btn {\n              font-size: 0;\n              &:before {\n                position: absolute;\n                content: \"\\e661\";\n                font-family: $font-themify;\n                font-size: 18px;\n                top: 11px;\n                left: 20px;\n              }\n            }\n          }\n        }\n      }\n    }\n    .border-tab {\n      &.nav-tabs {\n        display: flex;\n      }\n    }\n    .chat-menu {\n      .nav-tabs {\n        .nav-item {\n          a {\n            height: 50px;\n          }\n        }\n      }\n    }\n    .chat-history {\n      .call-content {\n        > div {\n          padding-top: 40px;\n          height: auto;\n        }\n      }\n      .receiver-img {\n        margin-bottom: unset;\n      }\n    }\n    .chat-left-aside {\n      .people-list {\n        height: auto;\n      }\n    }\n  }\n  .call-chat-sidebar {\n    max-width: 100%;\n    width: 100%;\n    flex-basis: auto;\n\n    .people-list {\n      height: auto;\n    }\n  }\n  .chat-left-aside {\n    .people-list {\n      ul {\n        max-height: 100px;\n      }\n    }\n  }\n  .clockpicker-align-top {\n    left: 55px !important;\n    top: 470px !important;\n\n    .arrow {\n      display: none;\n    }\n  }\n  .form-builder-column {\n    .form-body {\n      min-height: 250px;\n    }\n  }\n  .form-builder-2-header {\n    flex-wrap: wrap;\n\n    > div {\n      width: 100%;\n      margin-top: 10px;\n\n      nav {\n        float: none;\n      }\n    }\n  }\n\n  // form-builder\n  .lg-mt-col {\n    margin-top: 20px;\n  }\n  .form-builder {\n    .drag-box {\n      fieldset {\n        padding: 20px;\n        margin-top: 20px;\n      }\n    }\n\n    #components {\n      margin-top: 20px;\n    }\n\n    .component {\n      label {\n        padding-top: 0px;\n      }\n    }\n  }\n\n  //mega menu\n  .mega-menu {\n    .onhover-show-div {\n      height: 415px;\n      left: 0;\n      top: 61px;\n      padding: 20px;\n    }\n\n    .lg-mt {\n      margin-top: 15px;\n    }\n  }\n  .page-builder {\n    .ge-canvas {\n      &.ge-editing {\n        .ge-tools-drawer {\n          margin: 10px 0 0 10px;\n\n          > a {\n            padding: 0 5px;\n          }\n        }\n      }\n    }\n  }\n  .reader {\n    margin-top: 15px;\n    height: auto !important;\n  }\n  .range-slider {\n    &.theme-form {\n      .form-group {\n        margin-bottom: 0;\n      }\n    }\n  }\n  .note-editor {\n    .btn-group {\n      .btn {\n        font-size: 11px;\n      }\n    }\n  }\n  .text-md-right {\n    text-align: right;\n  }\n\n  .star-ratings {\n    .stars {\n      padding: 0;\n    }\n  }\n\n  .form-inline {\n    &.d-inline-block {\n      display: block !important;\n      width: 100%;\n\n      .form-control {\n        margin-bottom: 10px;\n      }\n    }\n  }\n\n  .reset-password-box {\n    width: 500px;\n    margin: 0 auto;\n\n    .card {\n      padding: 20px;\n    }\n  }\n\n  .custom-card {\n    .card-profile {\n      img {\n        height: 136px;\n        bottom: 0;\n      }\n    }\n  }\n\n  .error-wrapper {\n    .maintenance-icons {\n      li {\n        i {\n          color: $light-color;\n          font-size: 30px;\n        }\n\n        &:nth-child(2) {\n          i {\n            font-size: 60px;\n            margin-top: -10px;\n            margin-left: 70px;\n          }\n        }\n\n        &:nth-child(3) {\n          i {\n            font-size: 90px;\n            margin-right: 80px;\n          }\n        }\n      }\n    }\n  }\n\n  .authentication-main {\n    .auth-innerright {\n      .social-media {\n        li {\n          font-size: 14px;\n        }\n      }\n\n      min-height: unset;\n      padding: 0;\n    }\n  }\n\n  .loader-box {\n    justify-content: center;\n  }\n\n  .dataTables_wrapper {\n    .dataTables_length {\n      margin-bottom: 20px;\n    }\n\n    .dataTables_filter {\n      margin-left: 0;\n      margin-top: 0;\n      margin-bottom: 20px;\n    }\n  }\n\n  div {\n    &.dataTables_wrapper {\n      div {\n        &.dataTables_info {\n          padding-top: 0;\n        }\n\n        &.dataTables_length,\n        &.dataTables_filter {\n          label {\n            float: none;\n          }\n        }\n\n        &.dataTables_paginate {\n          float: none;\n          margin-top: 20px !important;\n          margin-left: 0 !important;\n        }\n      }\n    }\n  }\n\n  .calendar-wrap {\n    .fc-basic-view {\n      .fc-day-number {\n        padding: 0 0px !important;\n      }\n    }\n\n    .fc-events-container {\n      margin-top: 0px;\n    }\n\n    .fc-events-container {\n      h6,\n      .checkbox {\n        text-align: right;\n      }\n    }\n\n    .checkbox {\n      label {\n        margin-top: 0;\n      }\n    }\n\n    .fc-toolbar {\n      .fc-left {\n        .fc-next-button {\n          .fc-icon-right-single-arrow {\n            &:after {\n              font-size: 12px !important;\n            }\n          }\n        }\n\n        .fc-prev-button {\n          .fc-icon-left-single-arrow {\n            &:after {\n              font-size: 12px !important;\n            }\n          }\n        }\n      }\n\n      .fc-left,\n      .fc-right {\n        .fc-today-button {\n          padding-top: 0px !important;\n        }\n      }\n    }\n\n    .fc {\n      button {\n        font-size: 14px !important;\n        padding: 0 5px !important;\n      }\n\n      .fc-left {\n        margin-bottom: 10px;\n      }\n\n      .fc-toolbar {\n        > div {\n          display: block !important;\n          float: none !important;\n        }\n\n        > * {\n          :first-child {\n            font-size: 18px;\n          }\n\n          > * {\n            float: none !important;\n          }\n        }\n      }\n\n      margin-top: 0px;\n    }\n  }\n\n  .btn-group-wrapper {\n    text-align: center;\n\n    .m-b-30 {\n      margin-bottom: 15px !important;\n    }\n  }\n\n  .btn-group-showcase {\n    text-align: center;\n\n    .btn-group {\n      margin-right: 0;\n      margin-bottom: 15px;\n    }\n  }\n\n  .btn-group {\n    .btn {\n      font-size: 14px;\n      padding: 0.375rem 1.3rem;\n    }\n  }\n\n  .animate-widget {\n    .text-center {\n      display: none;\n    }\n  }\n\n  //mega menu\n  .mega-menu {\n    .onhover-show-div {\n      height: 350px;\n    }\n  }\n\n  .page-builder {\n    .ge-canvas {\n      .column {\n        padding: 0 !important;\n      }\n    }\n\n    .ge-content-type-ckeditor {\n      h3 {\n        font-size: 20px;\n      }\n\n      p {\n        font-size: 12px;\n      }\n    }\n\n    .ge-row-icon {\n      display: none !important;\n    }\n  }\n\n  /* font-awesom icon page */\n  .icon-hover-bottom {\n    .form-group {\n      input {\n        min-width: 270px;\n      }\n    }\n  }\n\n  //user profile\n  .user-profile {\n    .hovercard {\n      .cardheader {\n        height: 350px;\n      }\n\n      .info {\n        padding: 35px;\n\n        .ttl-info {\n          margin-bottom: 20px;\n        }\n\n        .ttl-sm-mb-0 {\n          margin-bottom: 0;\n        }\n      }\n    }\n  }\n\n  //calendar\n  .calendar-wrap {\n    .fc {\n      button {\n        padding: 5px;\n      }\n    }\n\n    .fc-day-grid-event {\n      margin: 0;\n      padding: 5px;\n      width: inherit;\n    }\n\n    .fc-toolbar {\n      h2 {\n        font-size: 20px;\n        line-height: 35px;\n        font-weight: bold;\n      }\n    }\n\n    .basic-calendar {\n      .external-events {\n        margin-top: 0px;\n      }\n    }\n  }\n\n  //blog\n  .blog-single {\n    .comment-box {\n      .media {\n        h6 {\n          margin-bottom: 10px;\n        }\n\n        img {\n          margin-right: 30px;\n        }\n      }\n\n      .comment-social {\n        margin-bottom: 5px;\n\n        li:first-child {\n          padding-left: 0;\n          padding-right: 15px;\n        }\n      }\n    }\n  }\n\n  //material tab\n  .tabbed-card {\n    ul {\n      &.border-tab {\n        margin-bottom: 15px;\n\n        &.nav-tabs {\n          top: unset;\n\n          .nav-item {\n            .nav-link {\n              padding: 5px 15px 10px;\n            }\n          }\n        }\n      }\n\n      padding: 10px 0 5px 0;\n      position: relative;\n      width: 100%;\n      left: 0;\n    }\n  }\n\n  //search\n  .search-page {\n    #image-links {\n      .info-block {\n        &.m-t-30 {\n          margin-top: 0 !important;\n        }\n      }\n    }\n  }\n\n  //authentication\n  .authentication-main {\n    .authentication-box {\n      width: 100%;\n    }\n\n    .auth-innerright {\n      display: inherit;\n    }\n  }\n\n  //default dashboard\n  .map-chart {\n    .chart-container {\n      height: 300px;\n    }\n  }\n\n  .candidcahrt {\n    height: 250px;\n  }\n\n  //chart widget\n  .bar-chart-widget {\n    .earning-details {\n      i {\n        right: 0;\n      }\n    }\n  }\n\n  .serial-chart .chart-container {\n    height: 300px;\n  }\n\n  .bottom-content {\n    padding: 10px;\n\n    p {\n      font-size: 12px;\n    }\n  }\n\n  // from wizard two\n  .stepwizard {\n    .stepwizard-row {\n      &:before {\n        top: 17px;\n      }\n    }\n  }\n\n  // icons\n  .icon-hover-bottom {\n    .icon-popup {\n      display: block;\n\n      > .icon-last {\n        display: block;\n        margin-top: 15px;\n        .form-inline {\n          .form-group {\n            display: flex;\n          }\n        }\n      }\n\n      div {\n        .flag-icon {\n          width: 30px;\n          height: auto;\n        }\n      }\n    }\n\n    .form-group {\n      input {\n        display: block;\n        width: auto !important;\n      }\n    }\n  }\n\n  //footer\n  .footer-links {\n    text-align: center;\n  }\n\n  .footer-copyright {\n    text-align: center !important;\n  }\n\n  .jvector-map-height {\n    height: 150px;\n  }\n\n  .sm-left-text {\n    text-align: left !important;\n    [dir=\"rtl\"] & {\n      text-align: right !important;\n    }\n  }\n\n  // email app\n  .email-wrap {\n    .email-right-aside {\n      .email-content {\n        .email-top {\n          .d-flex {\n            padding-bottom: 0;\n          }\n\n          .float-right {\n            float: left !important;\n          }\n        }\n\n        .email-wrapper {\n          .attachment {\n            text-align: center;\n\n            ul {\n              li {\n                &:last-child {\n                  padding-right: 0;\n                }\n\n                img {\n                  width: 140px;\n                  height: 140px;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // alert page\n  .alert-dismissible {\n    p {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      max-width: 294px;\n    }\n  }\n\n  // button group page\n  .button-group-mb-sm {\n    margin-bottom: 5px;\n  }\n\n  // table components page\n  .card-block {\n    .table-responsive {\n      .table {\n        tbody {\n          tr {\n            td {\n              span {\n                overflow: hidden;\n                text-overflow: ellipsis;\n                white-space: nowrap;\n                max-width: 100px;\n              }\n            }\n          }\n        }\n      }\n\n      .progress-content {\n        tbody {\n          tr {\n            td {\n              span {\n                text-overflow: ellipsis;\n                white-space: normal;\n                max-width: 50px;\n              }\n            }\n          }\n        }\n      }\n\n      .checkbox-td-width,\n      .radio-first-col-width {\n        tbody {\n          tr {\n            td {\n              min-width: 200px !important;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // jsgrid-table page\n  #batchDelete {\n    .jsgrid-grid-header {\n      .jsgrid-table {\n        .jsgrid-header-row {\n          .jsgrid-header-cell {\n            &:first-child {\n              width: 119px !important;\n            }\n          }\n        }\n      }\n    }\n\n    .jsgrid-grid-body {\n      .jsgrid-table {\n        .jsgrid-row {\n          .jsgrid-cell {\n            &:first-child {\n              width: 119px !important;\n            }\n          }\n        }\n      }\n    }\n  }\n  .jsgrid {\n    .jsgrid-pager-container {\n      text-align: center;\n    }\n  }\n\n  // chat page\n  .chat-box {\n    .chat-right-aside {\n      .chat {\n        .chat-msg-box {\n          height: auto;\n        }\n      }\n    }\n\n    .chat-menu {\n      .nav-tabs {\n        .nav-item {\n          width: 32.33%;\n        }\n      }\n\n      .people-list {\n        ul.list {\n          max-height: 433px;\n          margin-bottom: 15px;\n        }\n      }\n\n      #info-profile,\n      #info-contact {\n        margin-bottom: 15px;\n      }\n    }\n  }\n\n  // user-profile page\n  .hovercard {\n    .info {\n      .follow {\n        .text-md-right {\n          text-align: center;\n        }\n      }\n    }\n  }\n  .profile-img-style {\n    .like-comment-sm-mb {\n      margin-bottom: 20px;\n    }\n  }\n\n  // forget-password page\n  .reset-password-box {\n    .theme-form {\n      .form-group {\n        .btn {\n          margin-top: 15px !important;\n        }\n      }\n    }\n  }\n\n  // gallery page\n  .lg-outer {\n    .lg-actions .lg-next,\n    .lg-actions .lg-prev {\n      top: 48%;\n    }\n  }\n\n  // product page\n  .feature-products {\n    .filter-toggle {\n      padding: 8px 15px;\n      background-color: $white;\n      margin-left: 10px;\n      border-radius: 5px;\n    }\n\n    .select2-drpdwn-product {\n      float: left;\n      margin-right: 10px;\n      margin-top: 8px;\n      [dir=\"rtl\"] & {\n        float: right;\n        margin-right: unset;\n        margin-left: 10px;\n      }\n    }\n\n    span {\n      &.f-w-600 {\n        padding-top: 15px;\n        display: inline-block;\n      }\n    }\n\n    .text-right {\n      text-align: left !important;\n    }\n  }\n  .d-none-productlist {\n    display: block;\n    margin-right: 10px;\n  }\n  .grid-options {\n    ul {\n      li {\n        display: none;\n      }\n    }\n  }\n  .product-sidebar {\n    transform: translateX(-300px) scaleX(0);\n    opacity: 0;\n    visibility: hidden;\n    transition: 0.3s;\n    height: 0;\n    position: absolute;\n    z-index: 3;\n    width: 300px;\n\n    &.open {\n      transform: translateX(0px) scaleX(1);\n      box-shadow: 1px 5px 24px 0 rgba(68, 102, 242, 0.05);\n      visibility: visible;\n      opacity: 1;\n      height: auto;\n      top: -45px;\n\n      &:before,\n      &:after {\n        content: \"\";\n        position: absolute;\n        width: 0;\n        height: 0;\n        border-left: 7px solid $transparent-color;\n        border-right: 7px solid $transparent-color;\n        border-bottom: 7px solid $white;\n        right: 120px;\n        top: -7px;\n      }\n    }\n\n    .filter-section {\n      .card-header {\n        display: none;\n      }\n    }\n  }\n  .product-wrapper {\n    &.sidebaron {\n      .product-grid {\n        .product-wrapper-grid {\n          margin-left: 0;\n        }\n      }\n\n      .product-sidebar {\n        .filter-section {\n          .card {\n            .left-filter {\n              top: unset;\n              min-width: unset;\n            }\n          }\n        }\n      }\n    }\n  }\n  .product-wrapper-grid {\n    &.list-view {\n      .product-box {\n        .product-img {\n          width: 42%;\n        }\n      }\n    }\n  }\n  .product-filter {\n    .product-box {\n      flex-wrap: nowrap;\n\n      .product-img {\n        width: 100px;\n      }\n\n      .product-details {\n        padding: 0 !important;\n      }\n    }\n  }\n}\n@media only screen and (max-width: 575.98px) {\n  .todo {\n    .todo-list-wrapper {\n      .mark-all-tasks {\n        .mark-all-tasks-container {\n          display: none;\n        }\n      }\n    }\n  }\n  .border-tab {\n    &.nav-tabs {\n      display: block;\n    }\n  }\n  .page-wrapper {\n    .page-header {\n      .header-wrapper {\n        .search-full {\n          input {\n            padding-left: 30px;\n            line-height: 40px;\n          }\n          .form-group {\n            &::before {\n              top: 14px;\n              left: 12px;\n            }\n            .close-search {\n              top: 18px;\n              right: 0;\n              width: 18px;\n              height: 18px;\n            }\n          }\n        }\n      }\n    }\n  }\n  .page-wrapper.only-body {\n    .page-header {\n      .header-wrapper {\n        .nav-right {\n          right: 30px;\n        }\n      }\n    }\n  }\n  .date-picker {\n    .theme-form {\n      > .row {\n        > div {\n          &:last-child {\n            margin-top: 0;\n          }\n        }\n      }\n    }\n  }\n  .search-page {\n    .info-block {\n      display: block;\n    }\n  }\n  .form-bookmark {\n    .row {\n      > div {\n        .row {\n          > .col-sm-6 {\n            + .col-sm-6 {\n              margin-top: 10px;\n            }\n          }\n        }\n      }\n    }\n  }\n  .btn {\n    padding: 6px 16px;\n  }\n  .alert-theme {\n    min-width: 380px;\n  }\n  .knowledgebase-bg {\n    height: 250px;\n  }\n  .login-card {\n    .login-main {\n      .theme-form {\n        .or {\n          &:before {\n            width: 55%;\n          }\n        }\n      }\n    }\n  }\n  .knowledgebase-search {\n    width: calc(100% - 30px);\n    left: 15px;\n    height: calc(100% - 30px);\n    background-color: rgba($white, 0.7);\n\n    .form-inline {\n      width: 90%;\n      padding: 3px 45px;\n\n      svg {\n        top: 10px;\n      }\n    }\n\n    > div {\n      width: 100%;\n      text-align: center;\n      padding: 15px;\n      border-right: 10px;\n\n      h3 {\n        font-size: 20px;\n        margin-bottom: 0;\n      }\n\n      .form-group {\n        margin-bottom: 0;\n      }\n    }\n  }\n\n  // invoice template page\n  .invoice {\n    .text-md-end {\n      margin-top: 10px;\n    }\n    .text-right {\n      text-align: right;\n    }\n    .text-xs-center {\n      text-align: center;\n    }\n  }\n\n  // Login page\n  .login-card {\n    padding-top: 40px;\n    padding-bottom: 40px;\n    .logo {\n      margin-bottom: 10px;\n    }\n    .login-main {\n      width: auto;\n      padding: 20px;\n      .theme-form {\n        .form-group {\n          margin-bottom: 5px;\n        }\n        p {\n          margin-bottom: 5px;\n        }\n      }\n    }\n\n    .btn-showcase {\n      .btn {\n        width: 100%;\n\n        + .btn {\n          margin-left: 0;\n          margin-top: 5px;\n        }\n      }\n    }\n  }\n  .bookmark {\n    ul {\n      li {\n        a {\n          svg {\n            height: 16px;\n            width: 16px;\n          }\n        }\n\n        & + li {\n          margin-left: 5px;\n        }\n      }\n    }\n  }\n  .page-wrapper .page-header .header-wrapper .nav-right > ul > li {\n    padding: 4px 6px;\n  }\n  .page-header {\n    .header-wrapper {\n      .nav-right {\n        .cart-box,\n        .notification-box {\n          .badge {\n            font-size: 10px;\n          }\n        }\n      }\n    }\n  }\n  .page-wrapper {\n    .page-body-wrapper {\n      .page-title > .row {\n        .col-6 {\n          &:first-child {\n            display: block;\n\n            h3 {\n              padding-right: 0;\n            }\n          }\n        }\n      }\n    }\n\n    .page-header {\n      .header-wrapper .nav-right ul {\n        li {\n          i {\n            font-size: 14px !important;\n          }\n\n          svg {\n            width: 18px;\n          }\n        }\n      }\n    }\n\n    .page-body-wrapper {\n      .page-title {\n        .breadcrumb {\n          margin-top: 0;\n        }\n      }\n    }\n\n    &.compact-wrapper,\n    &.compact-sidebar {\n      .page-header {\n        .header-wrapper {\n          .logo-wrapper {\n            display: none;\n          }\n\n          .toggle-sidebar {\n            margin-left: 0;\n            padding-left: 0;\n            border-left: none;\n            border-right: 1px solid #ddd;\n            padding-right: 8px;\n            margin-right: 8px;\n\n            svg {\n              width: 18px;\n            }\n          }\n        }\n      }\n    }\n    &.compact-sidebar {\n      .sidebar-wrapper {\n        .back-btn {\n          display: none;\n        }\n        .sidebar-main {\n          .sidebar-links {\n            > li {\n              margin-right: 0;\n            }\n          }\n        }\n      }\n    }\n\n    .page-header {\n      .header-wrapper {\n        padding: 12px 15px !important;\n\n        .nav-right {\n          > ul {\n            top: 58px;\n\n            .search-form {\n              i {\n                display: none;\n              }\n            }\n          }\n\n          &.right-header {\n            ul {\n              li {\n                &.px-0 {\n                  padding: 6px !important;\n                }\n              }\n            }\n          }\n\n          > ul {\n            li {\n              .flag-icon {\n                font-size: 14px !important;\n              }\n\n              .profile-media {\n                img {\n                  width: 25px;\n                }\n              }\n            }\n          }\n\n          .notification-dropdown {\n            &.onhover-show-div {\n              &:before,\n              &:after {\n                left: 24px !important;\n                right: unset !important;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .page-body-wrapper {\n      .page-title {\n        .btn-group {\n          .btn {\n            padding: 8px 30px;\n          }\n        }\n      }\n    }\n\n    &.compact-wrapper {\n      .page-body-wrapper {\n        .page-body {\n          margin-top: 53px;\n        }\n\n        &.sidebar-wrapper {\n          .sidebar-main {\n            .sidebar-links {\n              height: calc(100vh - 79px);\n            }\n          }\n        }\n      }\n    }\n  }\n  .alert-dismissible {\n    padding-right: 30px;\n    p {\n      max-width: 209px;\n    }\n  }\n  .customizer-links {\n    display: none;\n  }\n  .m-r-30 {\n    margin-right: 15px;\n  }\n\n  // cart page //\n  .wishlist {\n    .text-end {\n      text-align: left !important;\n    }\n  }\n\n  // Add post page css\n  .add-post {\n    form {\n      .m-checkbox-inline {\n        label {\n          margin-right: 15px;\n        }\n      }\n    }\n\n    .dropzone {\n      margin-bottom: 15px;\n    }\n  }\n\n  //form-wizard-four page css\n  .wizard-4 {\n    .msg-box {\n      top: 10px !important;\n    }\n    .login-card {\n      .login-main {\n        width: 280px;\n      }\n    }\n    .step-container {\n      div.content {\n        .wizard-title {\n          width: 280px;\n        }\n      }\n    }\n    .action-bar {\n      right: 10px;\n      [dir=\"rtl\"] {\n        left: 10px;\n      }\n    }\n  }\n\n  // avatar page css\n  .customers {\n    &.avatar-group {\n      margin-right: 15px;\n    }\n  }\n\n  .vertical-mobile-sidebar {\n    top: 19px;\n  }\n\n  //notify index page\n  .alert-theme {\n    i {\n      margin-right: 10px !important;\n    }\n\n    button {\n      top: 0px !important;\n    }\n  }\n\n  .bar-chart-widget {\n    .earning-details {\n      i {\n        right: -30px;\n      }\n    }\n  }\n\n  .clockpicker-align-top {\n    left: 45px !important;\n    top: 406px !important;\n  }\n\n  .gallery {\n    margin-bottom: -15px;\n  }\n\n  .my-gallery {\n    figure {\n      margin-bottom: 15px;\n\n      &:nth-child(9),\n      &:nth-child(10) {\n        margin-bottom: 15px;\n      }\n    }\n\n    &.gallery-with-description {\n      figure {\n        &:last-child {\n          margin-bottom: 20px;\n        }\n      }\n    }\n  }\n\n  #aniimated-thumbnials {\n    figure {\n      &:nth-child(12),\n      &:nth-child(11),\n      &:nth-child(10),\n      &:nth-child(9) {\n        margin-bottom: 15px;\n      }\n    }\n  }\n\n  .photoswipe-pb-responsive {\n    padding-bottom: 30px !important;\n  }\n\n  // social app page css\n  .avatar-showcase {\n    .pepole-knows {\n      text-align: center;\n\n      ul {\n        li {\n          margin-right: 14px;\n        }\n      }\n    }\n  }\n\n  .social-app-profile {\n    .hovercard {\n      .user-image {\n        .avatar {\n          margin-top: -56px;\n\n          img {\n            width: 100px;\n            height: 100px;\n          }\n        }\n\n        .icon-wrapper {\n          left: 52%;\n          top: 10px;\n          height: 30px;\n          width: 30px;\n          font-size: 15px;\n\n          &:hover {\n            font-size: 12px;\n          }\n        }\n\n        .share-icons {\n          right: 15px;\n\n          li {\n            margin-right: 0px;\n          }\n        }\n      }\n\n      .info {\n        .tabs-scoial {\n          .user-designation {\n            border-top: none;\n            border-bottom: none;\n            margin-bottom: 0;\n            padding: 0px 0px;\n          }\n        }\n      }\n    }\n\n    .tabs-scoial {\n      margin-bottom: 0 !important;\n    }\n  }\n\n  .socialprofile {\n    .social-btngroup {\n      margin: 15px 0;\n    }\n\n    .social-group {\n      margin-top: 15px;\n    }\n  }\n\n  .social-status {\n    form {\n      .form-group {\n        .form-control-social {\n          margin-bottom: 15px;\n        }\n      }\n    }\n\n    .media {\n      margin-bottom: 15px;\n    }\n  }\n\n  .new-users-social {\n    margin-bottom: 15px;\n  }\n\n  .tabs-scoial {\n    position: relative;\n    padding-top: 80px;\n\n    li {\n      &:nth-child(3) {\n        position: absolute;\n        top: 25px;\n        left: 0;\n        right: 0;\n        margin: 0 auto;\n      }\n    }\n\n    &.border-tab {\n      &.nav-tabs {\n        .nav-item {\n          .nav-link {\n            padding: 10px;\n            height: 60px;\n          }\n        }\n      }\n    }\n  }\n\n  .timeline-content {\n    p,\n    .comments-box {\n      margin-top: 15px;\n    }\n\n    .comments-box {\n      .media {\n        .m-r-20 {\n          margin-right: 10px;\n        }\n\n        .media-body {\n          .input-group {\n            .input-group-append {\n              .btn {\n                padding: 6px;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .comment-number {\n      i {\n        margin-right: 15px;\n      }\n    }\n  }\n\n  #cd-timeline {\n    margin-right: 0;\n  }\n\n  .social-chat {\n    margin-top: 15px;\n\n    .media-body {\n      padding: 15px;\n    }\n\n    .your-msg,\n    .other-msg {\n      margin-bottom: 15px;\n    }\n  }\n\n  .social-network {\n    span {\n      margin-bottom: 15px;\n    }\n  }\n\n  .social-list {\n    .media {\n      margin-bottom: 15px;\n    }\n  }\n\n  .details-about + .details-about {\n    margin-top: 15px;\n  }\n\n  .your-details-xs {\n    margin-top: 15px;\n  }\n\n  .social-header {\n    h5 {\n      span.pull-right {\n        float: right !important;\n        margin-top: 0 !important;\n\n        svg {\n          width: 18px;\n          height: 18px;\n        }\n      }\n    }\n  }\n\n  .activity-log {\n    .my-activity {\n      + .my-activity {\n        margin-top: 15px;\n      }\n    }\n  }\n\n  .photos {\n    ul {\n      li {\n        width: 26%;\n\n        &:nth-child(3n) {\n          margin-right: 0;\n        }\n      }\n    }\n  }\n\n  // chat page //\n  .chat-box {\n    .chat-history {\n      .call-content {\n        > div {\n          padding-top: 30px;\n        }\n      }\n    }\n  }\n\n  // timeline small page css\n  .timeline-small {\n    .media {\n      margin-bottom: 15px;\n\n      .media-body {\n        h6 {\n          margin-bottom: 15px;\n        }\n      }\n\n      .timeline-round {\n        &.timeline-line-1 {\n          &:after {\n            bottom: -39px;\n            height: 30px;\n          }\n        }\n\n        &.small-line {\n          &:after {\n            bottom: -17px;\n            height: 8px;\n          }\n        }\n\n        &.medium-line {\n          &:after {\n            bottom: -30px;\n            height: 22px;\n          }\n        }\n      }\n    }\n  }\n\n  // helper classes page start\n  .helper-classes {\n    padding: 15px;\n  }\n\n  // helper classes page ends\n  .form-builder-2-header {\n    ul {\n      li {\n        text-align: left;\n      }\n    }\n\n    .form-inline {\n      display: block;\n      width: 100%;\n\n      .form-group {\n        width: 100%;\n        margin-right: 0;\n      }\n\n      button {\n        width: 100%;\n        text-align: left;\n      }\n    }\n  }\n  .page-builder {\n    .btn-grid {\n      margin-bottom: 7px;\n      padding-right: 5px;\n    }\n\n    .ge-canvas {\n      &.ge-editing {\n        .row {\n          padding: 15px;\n        }\n\n        .ge-tools-drawer {\n          margin: 10px;\n        }\n      }\n      &.ge-layout-desktop [class*=\"col-\"] {\n        width: inherit !important;\n      }\n    }\n  }\n  .wizard-4 {\n    .step-container {\n      div {\n        &.content {\n          margin-top: 10px;\n        }\n      }\n    }\n  }\n  .nav-tabs {\n    .nav-item {\n      &.show {\n        .nav-link {\n          border-top: 0;\n          border-bottom: 0;\n        }\n      }\n    }\n\n    .nav-link {\n      border-top: 0;\n      border-bottom: 0;\n\n      &:hover,\n      &.active,\n      &:focus {\n        border-top: 0;\n        border-bottom: 0;\n      }\n    }\n  }\n\n  .border-tab {\n    &.nav-tabs {\n      .nav-item {\n        width: 100% !important;\n      }\n    }\n\n    .ecommerce-widget {\n      .progress-showcase {\n        margin-top: 15px;\n      }\n    }\n  }\n\n  .nav {\n    display: inherit;\n    text-align: center;\n    border-bottom: none;\n  }\n\n  // editor_container //\n  .editor_container {\n    .CodeMirror {\n      min-height: 190px;\n      height: 190px;\n    }\n  }\n\n  // order history //\n  .order-history {\n    table.dataTable.table {\n      thead {\n        th {\n          padding-right: 60px;\n        }\n      }\n    }\n  }\n\n  // tab material start\n  .border-tab.nav-left {\n    .nav-link {\n      text-align: center;\n      border-left: none;\n    }\n  }\n\n  .border-tab.nav-right {\n    .nav-link {\n      text-align: center;\n      border-right: none;\n    }\n  }\n\n  .border-tab.nav-tabs {\n    margin-bottom: 10px;\n  }\n\n  .tab-content {\n    ~ .nav-tabs {\n      &.border-tab {\n        margin-top: 10px;\n      }\n    }\n  }\n\n  // tab material end\n  .nav-pills {\n    text-align: center;\n  }\n\n  .crm-overall {\n    margin: 0 -15px -15px;\n  }\n\n  .product-color {\n    li {\n      width: 15px;\n      height: 15px;\n    }\n  }\n  .product-social {\n    li {\n      a {\n        width: 30px;\n        height: 30px;\n        font-size: 13px;\n      }\n      &:nth-child(n + 2) {\n        margin-left: 5px;\n        [dir=\"rtl\"] & {\n          margin-left: unset;\n          margin-right: 5px;\n        }\n      }\n    }\n  }\n  .product-page-main {\n    padding: 15px;\n    .product-page-details {\n      h3 {\n        font-size: 24px;\n      }\n    }\n  }\n\n  .todo {\n    .action-box {\n      &.large {\n        height: 25px;\n        width: 25px;\n\n        .icon {\n          font-size: 14px;\n          vertical-align: -3px;\n        }\n      }\n    }\n\n    .todo-list-wrapper {\n      #todo-list {\n        li {\n          .task-container {\n            .task-label {\n              font-size: 14px;\n            }\n          }\n        }\n      }\n\n      .mark-all-tasks {\n        right: 15px;\n      }\n    }\n  }\n\n  .datetime-picker {\n    label {\n      text-align: left !important;\n    }\n  }\n\n  .redial-chart-block {\n    text-align: center;\n  }\n\n  #nav-tabContent {\n    margin-top: 15px;\n  }\n\n  .reset-password-box {\n    width: 430px;\n  }\n\n  .auth-bg {\n    padding: 25px 15px;\n  }\n\n  .auth-bg-effect {\n    display: none;\n  }\n\n  .date-picker {\n    .text-right {\n      text-align: left !important;\n    }\n  }\n\n  .dataTables_wrapper {\n    table {\n      &.dataTable {\n        margin-bottom: 15px !important;\n      }\n    }\n  }\n\n  ul {\n    &.pagination {\n      li {\n        &:before {\n          line-height: 3;\n        }\n      }\n    }\n  }\n\n  div {\n    &.table-responsive {\n      > div {\n        &.dataTables_wrapper {\n          > div {\n            &.row {\n              > div {\n                &[class^=\"col-\"] {\n                  &:last-child {\n                    padding-left: 0 !important;\n                  }\n\n                  &:first-child {\n                    padding-right: 0 !important;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n\n    &.dataTables_wrapper {\n      div {\n        &.dataTables_length {\n          margin-bottom: 15px;\n\n          select {\n            min-height: 30px;\n          }\n        }\n      }\n\n      table {\n        &.dataTable {\n          th,\n          td {\n            padding: 0.5rem;\n          }\n        }\n      }\n\n      div {\n        &.dataTables_paginate {\n          margin-top: 15px !important;\n\n          .paginate_button {\n            padding: 1px 7px;\n\n            &.previous {\n              font-size: 0;\n              padding: 0;\n\n              a {\n                border: none !important;\n              }\n\n              &:before {\n                content: \"\\e64a\";\n                font-family: $font-themify;\n                font-size: 11px;\n                padding: 0 5px;\n              }\n            }\n\n            &.next {\n              font-size: 0;\n              padding: 0;\n\n              a {\n                border: none !important;\n              }\n\n              &:before {\n                content: \"\\e649\";\n                font-family: $font-themify;\n                font-size: 11px;\n                padding: 0 5px;\n              }\n            }\n          }\n        }\n      }\n\n      .dataTables_filter {\n        margin-bottom: 15px;\n\n        input {\n          &[type=\"search\"] {\n            height: 30px;\n          }\n        }\n      }\n    }\n  }\n\n  .page-wrapper {\n    .page-body-wrapper {\n      .user-profile {\n        .profile-img-style {\n          padding: 15px;\n\n          .img-container {\n            margin-top: 15px;\n          }\n        }\n\n        hr {\n          margin: 15px 0;\n        }\n\n        .like-comment {\n          margin-top: 15px;\n        }\n      }\n    }\n  }\n\n  .jvector-map-height {\n    height: 250px;\n  }\n\n  .user-profile {\n    .order-sm-0 {\n      order: -1;\n    }\n\n    .hovercard {\n      .info {\n        .ttl-info {\n          text-align: center !important;\n        }\n\n        .ttl-xs-mt {\n          margin-top: 20px;\n        }\n      }\n    }\n  }\n\n  .icon-hover-bottom {\n    .form-group {\n      display: block !important;\n      margin-bottom: 0;\n      input {\n        width: 100% !important;\n      }\n\n      .btn {\n        margin-top: 15px;\n      }\n    }\n\n    .icon-popup {\n      padding: 15px;\n    }\n\n    svg {\n      &.climacon {\n        height: 50px;\n        width: 50px;\n      }\n    }\n  }\n\n  .blog-box {\n    &.blog-shadow {\n      &:before {\n        box-shadow: inset 0px -100px 100px -13px rgba(0, 0, 0, 0.6);\n      }\n    }\n\n    .blog-details {\n      p,\n      .single-blog-content-top {\n        margin-top: 15px;\n      }\n\n      h4 {\n        margin-top: 15px;\n      }\n\n      .blog-social {\n        margin-top: 15px;\n\n        li {\n          & + li {\n            padding-left: 20px;\n\n            > span {\n              display: none;\n            }\n          }\n\n          &:first-child {\n            margin-right: 10px;\n            padding-right: 20px;\n          }\n        }\n      }\n    }\n  }\n\n  .comment-box {\n    padding-top: 40px;\n    padding-bottom: 40px;\n\n    ul {\n      ul {\n        margin-left: 30px;\n      }\n    }\n\n    li {\n      .media {\n        display: block;\n\n        img {\n          height: 50px;\n          width: 50px;\n          padding: 3px;\n          margin-bottom: 10px;\n        }\n      }\n    }\n  }\n\n  .ace-editor {\n    height: 320px;\n  }\n\n  .gallery {\n    > a {\n      margin-bottom: 15px;\n      text-align: center;\n    }\n  }\n\n  .card {\n    .card-header {\n      h5 {\n        font-size: 17px;\n      }\n    }\n  }\n\n  .theme-form {\n    .form-group {\n      margin-bottom: 15px;\n    }\n  }\n\n  .page-wrapper {\n    .page-body-wrapper {\n      .default-according {\n        .card {\n          .card-header,\n          .card-body,\n          .card-footer {\n            padding: 0.75rem 1.25rem;\n          }\n        }\n      }\n\n      .card {\n        margin-bottom: 20px;\n\n        .card-header,\n        .card-body,\n        .card-footer {\n          .tab-content {\n            .m-t-30 {\n              margin-top: 20px !important;\n            }\n\n            .m-b-30 {\n              margin-bottom: 20px !important;\n            }\n          }\n        }\n      }\n\n      .page-body {\n        padding: 0 !important;\n      }\n\n      .page-title {\n        padding-top: 15px;\n        padding-bottom: 15px;\n        margin: 0 -12px 30px !important;\n\n        .row {\n          h3 {\n            font-size: 20px;\n          }\n        }\n      }\n    }\n  }\n\n  /* alert responsive css start here */\n  $alert-name: primary, secondary, success, danger, warning, info, light, dark;\n  $alert-color: var(--theme-default), $secondary-color, $success-color, $danger-color, $warning-color, $info-color, $light-color, $dark-color;\n\n  @each $var in $alert-name {\n    $i: index($alert-name, $var);\n\n    .alert-#{$var}.inverse {\n      background-color: transparent;\n    }\n  }\n\n  .alert {\n    .close {\n      height: 100%;\n    }\n  }\n\n  //user profile\n  .user-profile {\n    hr {\n      margin: 15px 0;\n    }\n\n    .hovercard {\n      .cardheader {\n        height: 300px;\n      }\n\n      .info {\n        padding: 20px;\n\n        .user-designation {\n          border-top: 1px solid $light-color;\n          border-bottom: 1px solid $light-color;\n          margin-bottom: 15px;\n          padding: 15px 0px;\n        }\n      }\n\n      .social-media {\n        a {\n          margin-right: 0px;\n          font-size: 16px;\n        }\n      }\n\n      .follow {\n        .follow-num {\n          font-size: 20px;\n        }\n      }\n    }\n\n    .profile-img-style {\n      .pictures {\n        img {\n          margin-bottom: 10px;\n        }\n      }\n    }\n  }\n\n  //user card\n  .custom-card {\n    .card-footer {\n      > div {\n        h6 {\n          font-size: 14px;\n          font-weight: 600;\n        }\n\n        h3 {\n          font-size: 24px;\n        }\n      }\n    }\n  }\n\n  //calendar\n  .calendar-wrap {\n    .fc-toolbar {\n      .fc-center {\n        margin-top: 10px;\n      }\n    }\n\n    a.fc-more {\n      font-size: 0.7em;\n    }\n  }\n\n  // megaoption page responsive scss\n  .mega-inline {\n    display: block;\n  }\n\n  .megaoptions-border-space-sm {\n    padding-bottom: 30px !important;\n  }\n\n  //blog\n  .blog-box.blog-shadow {\n    .blog-details {\n      padding: 15px;\n\n      p {\n        margin-bottom: 0;\n      }\n\n      h4 {\n        margin-bottom: 10px;\n      }\n    }\n  }\n\n  .blog-box {\n    &.blog-list {\n      .blog-details {\n        padding-top: 0;\n      }\n    }\n\n    .blog-details {\n      padding: 20px;\n    }\n\n    .blog-date {\n      span {\n        font-size: 25px;\n      }\n    }\n  }\n\n  .blog-single {\n    .blog-box {\n      .blog-details {\n        padding: 0;\n      }\n    }\n  }\n\n  //error and maintenace\n  .error-wrapper {\n    padding: 20px 0;\n\n    .btn {\n      margin-top: 15px;\n    }\n\n    .img-100 {\n      width: 50px !important;\n    }\n\n    .error-heading {\n      margin-top: 20px;\n\n      .cloud-second {\n        margin-top: -60px;\n      }\n\n      .headline {\n        font-size: 150px;\n      }\n    }\n\n    .maintenance-heading {\n      .cloud-second {\n        display: none;\n      }\n\n      .headline {\n        font-size: 25px;\n        margin-top: -10%;\n        letter-spacing: 2px;\n      }\n    }\n  }\n\n  //coming soon\n  .comingsoon {\n    .comingsoon-inner {\n      .coming-soon-bottom-link {\n        margin-top: 20px;\n        line-height: 1;\n      }\n\n      h5 {\n        margin-bottom: 20px;\n        margin-top: 20px;\n      }\n\n      .countdown {\n        padding: 20px 0px;\n\n        ul li {\n          margin: 0 7px;\n        }\n\n        .title {\n          font-size: 12px;\n        }\n\n        .time {\n          width: 45px;\n          height: 45px;\n          line-height: 45px;\n          font-size: 16px;\n          margin: 0 auto;\n        }\n      }\n    }\n  }\n\n  // Form Wizard One start\n  .form-wizard {\n    .btn-mb {\n      margin-bottom: 15px;\n    }\n  }\n\n  // Form Wizard One ends\n\n  // Form Wizard Two Start\n  .stepwizard {\n    margin-bottom: 15px;\n  }\n\n  // Form Wizard Two Ends\n\n  // Form Wizard Three Start\n  .f1 {\n    .f1-steps {\n      margin-top: 15px;\n      margin-bottom: 15px;\n    }\n  }\n\n  //Form Wizard Three ends\n\n  // form wizard--4 scss\n  .wizard-4 {\n    ul.anchor {\n      width: 100%;\n      padding-bottom: 15px;\n    }\n\n    .step-container {\n      width: 100%;\n    }\n  }\n\n  //chart\n  .status-widget {\n    .text-sm-right {\n      text-align: right;\n    }\n  }\n\n  //mega menu\n  .mega-menu {\n    padding-left: 15px;\n\n    .onhover-show-div {\n      height: 405px;\n      left: 0;\n      top: 61px;\n      padding: 15px;\n    }\n\n    .lg-mt {\n      margin-top: 10px;\n    }\n\n    .xs-mt {\n      margin-top: 15px;\n    }\n  }\n\n  // navs page\n  .nav-md-mt {\n    margin-top: 15px;\n  }\n\n  .navs-icon {\n    padding: 15px;\n\n    .main-section {\n      padding-top: 15px;\n    }\n\n    .separator {\n      margin: 15px 0;\n    }\n  }\n\n  .nav-list {\n    padding: 15px;\n  }\n\n  .navs-dropdown {\n    button {\n      margin-top: 15px;\n    }\n\n    .onhover-show-div {\n      top: 64px;\n    }\n  }\n\n  .lg-mt {\n    margin-top: 15px;\n  }\n\n  // scroll reval\n  #aniimated-thumbnials {\n    a {\n      &:last-child {\n        img {\n          margin-bottom: 15px;\n        }\n      }\n    }\n  }\n\n  // tilt\n  .tilt-showcase {\n    .mt-4 {\n      margin-top: 15px !important;\n    }\n\n    ol {\n      .m-b-20 {\n        margin-bottom: 15px !important;\n      }\n    }\n  }\n\n  // state color page\n  .xs-mt {\n    margin-top: 15px;\n  }\n\n  // tag-pills page\n  span:last-child.tag-pills-sm-mb {\n    margin-top: 3px;\n  }\n\n  // alert page\n\n  // animated modal page\n  .animated-modal {\n    .form-group {\n      .form-control {\n        width: 50%;\n        margin: 0 auto;\n      }\n    }\n\n    .animated-modal-md-mb {\n      margin-bottom: 15px !important;\n    }\n  }\n\n  // steps page\n  .steps-md-mt {\n    margin-top: 15px;\n  }\n\n  .steps-sizing-sm-mb {\n    margin-bottom: 15px;\n  }\n\n  // touchspin page\n  .bootstrap-touchspin {\n    .touchspin-vertical-tab {\n      .input-group {\n        width: 96% !important;\n      }\n    }\n  }\n\n  // datatable API page\n  #API-chield-row_wrapper {\n    #API-chield-row {\n      tbody {\n        tr {\n          td {\n            &:first-child {\n              min-width: 20px;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // chart-flot page\n  .chart-block {\n    .flot-chart-container {\n      p#choices {\n        width: 100%;\n      }\n\n      #toggling-series-flot {\n        width: 100% !important;\n      }\n    }\n  }\n\n  // summer-note page\n  .click2edit {\n    & ~ .note-editor {\n      &.note-frame {\n        margin-bottom: 15px;\n      }\n    }\n  }\n\n  // support ticket page\n  .ecommerce-widget {\n    .progress-showcase {\n      margin-top: 15px;\n    }\n  }\n\n  // forget-password page\n  .reset-password-box {\n    .theme-form {\n      .form-group {\n        .btn {\n          margin-top: 13px !important;\n        }\n      }\n    }\n  }\n\n  // gallery-with-description page\n  .gallery-with-description {\n    a {\n      > div {\n        margin-bottom: 15px;\n      }\n    }\n  }\n\n  // gallery hover page\n  .gallery-img-mb-sm {\n    margin-bottom: 15px;\n  }\n\n  // peity chart page\n  .xm-mb-peity {\n    margin-bottom: 8px;\n  }\n\n  // login page\n  .authentication-main {\n    padding: 30px 15px;\n  }\n\n  .translate_wrapper.active {\n    .more_lang {\n      &:before,\n      &:after {\n        display: none;\n      }\n\n      &.active {\n        position: fixed;\n        width: calc(100vw - 30px);\n        left: 15px;\n        top: 60px;\n      }\n    }\n  }\n\n  .onhover-dropdown {\n    &:hover {\n      .onhover-show-div {\n        opacity: 0;\n        transform: none;\n        visibility: hidden;\n\n        &.active {\n          opacity: 1;\n          transform: translateY(0px);\n          visibility: visible;\n          border-radius: 5px;\n          overflow: hidden;\n        }\n      }\n    }\n  }\n  .page-wrapper {\n    .page-header {\n      .header-wrapper {\n        .nav-right {\n          .onhover-show-div {\n            width: calc(100vw - 30px);\n            position: fixed;\n            top: 60px;\n            right: 12px;\n          }\n          .notification-dropdown {\n            width: calc(100vw - 30px);\n            position: fixed;\n            top: 60px;\n            left: 15px !important;\n          }\n          .cart-dropdown {\n            left: 15px;\n          }\n\n          .profile-dropdown {\n            top: 43px;\n          }\n        }\n      }\n    }\n  }\n  .wizard-4 {\n    .action-bar {\n      .btn {\n        margin: 0 2px;\n      }\n    }\n  }\n\n  .tabbed-card {\n    ul {\n      right: 0px;\n      left: unset;\n    }\n  }\n\n  // dropdown-basic //\n  .dropdown-basic {\n    .btn-group {\n      margin-right: unset;\n    }\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  .page-wrapper .page-header .header-wrapper .nav-right .onhover-show-div {\n    width: 280px;\n  }\n  .page-wrapper.only-body .page-header .header-wrapper .nav-right {\n    display: none;\n  }\n  .chat-menu {\n    top: 120px;\n  }\n  .product-wrapper-grid {\n    &.list-view {\n      .product-box {\n        display: block;\n        .product-img {\n          width: 100%;\n        }\n      }\n    }\n  }\n  .jkanban-container {\n    .kanban-container {\n      .kanban-drag {\n        .react-kanban-board {\n          justify-content: center;\n        }\n        > div {\n          > div {\n            justify-content: center;\n          }\n        }\n      }\n    }\n  }\n  // datepicker\n  .datetime-picker {\n    .react-datepicker__month-container,\n    .react-datepicker__time-container {\n      width: 100%;\n    }\n    .react-datepicker__time-container {\n      border-left: 1px solid $light-semi-gray;\n      .react-datepicker__time {\n        .react-datepicker__time-box {\n          width: 100%;\n        }\n      }\n    }\n    .react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {\n      right: 1px;\n    }\n  }\n  .cal-date-widget {\n    .react-datepicker {\n      padding: 0;\n    }\n    .react-datepicker__navigation.react-datepicker__navigation--previous {\n      left: 0;\n    }\n    .react-datepicker__navigation.react-datepicker__navigation--next {\n      right: 0;\n    }\n  }\n  // kanban board\n  .jkanban-container {\n    .kanban-container {\n      .kanban-board {\n        width: 100%;\n      }\n    }\n  }\n  .pagination-lg {\n    .page-link {\n      font-size: 1rem;\n    }\n  }\n  h6 {\n    font-size: 14px;\n  }\n  .prooduct-details-box {\n    .media-body {\n      margin-left: 0rem !important;\n    }\n  }\n  .knob-block {\n    .chart-clock-main {\n      margin: auto;\n      width: auto;\n\n      .clock-medium {\n        position: absolute;\n        left: 33px;\n        top: 33px;\n\n        canvas {\n          width: 180px !important;\n          height: 180px !important;\n        }\n      }\n\n      .clock-small {\n        left: 34px;\n        top: 74px;\n      }\n\n      .clock-large {\n        left: 0;\n        top: 0;\n        margin: 0 auto;\n\n        canvas {\n          width: 245px !important;\n          height: 245px !important;\n        }\n      }\n    }\n\n    > div:not(.chart-clock-main) {\n      canvas {\n        width: 245px !important;\n        height: 245px !important;\n      }\n    }\n  }\n  .wizard-4 {\n    .action-bar {\n      .btn {\n        width: 100%;\n\n        & + .btn {\n          margin-top: 10px;\n        }\n      }\n    }\n  }\n\n  ul {\n    &.notification-dropdown {\n      &.onhover-show-div {\n        width: 260px;\n        right: -80px;\n\n        &:before,\n        &:after {\n          right: 89px !important;\n        }\n      }\n    }\n  }\n\n  .inline-block-sm {\n    display: inline-block;\n  }\n\n  .pagination-lg {\n    .page-link {\n      padding: 0.3rem 0.65rem;\n    }\n  }\n\n  .nav-pills {\n    li {\n      width: 100%;\n    }\n  }\n\n  .reset-password-box {\n    width: 290px;\n  }\n\n  .icon-hover-bottom {\n    .icon-first {\n      margin-right: 10px;\n    }\n\n    .icon-popup {\n      .icon-class {\n        display: none;\n      }\n    }\n  }\n\n  .error-wrapper {\n    .maintenance-heading {\n      margin-top: 0;\n    }\n  }\n\n  .custom-card {\n    padding: 0;\n\n    .card-footer {\n      > div {\n        h3 {\n          font-size: 20px;\n        }\n      }\n    }\n\n    .card-social {\n      li {\n        padding: 5px 0;\n      }\n    }\n\n    .profile-details {\n      h6 {\n        margin-bottom: 15px;\n      }\n\n      h4 {\n        font-size: 20px;\n      }\n    }\n\n    .card-profile {\n      img {\n        height: 93px;\n      }\n    }\n  }\n\n  .card {\n    .card-header {\n      .card-header-right {\n        i {\n          margin: 0 3px;\n          font-size: 14px;\n        }\n      }\n\n      > span {\n        & + span {\n          display: none;\n        }\n      }\n    }\n  }\n\n  // timeline small page css\n  .timeline-small {\n    .media {\n      .timeline-round {\n        &.timeline-line-1 {\n          &:after {\n            bottom: -50px;\n          }\n        }\n\n        &.medium-line {\n          &:after {\n            bottom: -40px;\n          }\n        }\n      }\n    }\n  }\n\n  // dropdown page //\n  .dropdown-basic {\n    text-align: center;\n  }\n  .dropup-basic {\n    text-align: center;\n  }\n\n  //blog\n  .blog-box.blog-shadow {\n    .blog-details {\n      padding: 10px;\n\n      h4 {\n        font-size: 14px;\n      }\n    }\n  }\n  // from wizard two\n  .stepwizard {\n    .stepwizard-row {\n      &:before {\n        top: 17px;\n      }\n\n      .stepwizard-step {\n        .btn {\n          padding: 6px 22px;\n        }\n      }\n    }\n  }\n\n  // email app\n  .email-wrap {\n    .email-right-aside {\n      .email-content {\n        .email-wrapper {\n          .attachment {\n            ul {\n              li {\n                img {\n                  width: 83px;\n                  height: 83px;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  //mega menu\n  .mega-menu {\n    padding-left: 20px;\n    padding-top: 3px;\n\n    .onhover-show-div {\n      height: 405px;\n      left: 0;\n      top: 61px;\n      padding: 15px;\n    }\n  }\n\n  //  tag-pills\n  .badge {\n    padding: 0.42em 0.7em;\n  }\n\n  // alert page\n  .alert-dismissible {\n    .close {\n      top: -1px;\n\n      span {\n        font-size: 19px;\n      }\n    }\n  }\n\n  // bootstrap notify page\n  .notify-alert {\n    width: 90%;\n  }\n\n  // chat page //\n  .chat-box {\n    .chat-right-aside {\n      .chat {\n        .chat-header {\n          display: block;\n          .chat-menu-icons {\n            margin-top: 15px;\n            padding-left: 10px;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 420px) {\n  .product-sidebar {\n    &.open {\n      top: -75px;\n    }\n  }\n  .alert-theme {\n    font-size: 12px;\n    min-width: 300px;\n\n    button {\n      right: 30px !important;\n    }\n    i {\n      display: none;\n    }\n\n    span {\n      + span {\n        + span {\n          padding: 15px;\n        }\n      }\n    }\n  }\n  .and-many-more {\n    font-size: 37px;\n  }\n\n  // tab css\n  .tabbed-card {\n    ul {\n      &.border-tab {\n        &.nav-tabs {\n          .nav-item {\n            .nav-link {\n              padding: 5px 15px 8px;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // compact sidebar css\n  .page-wrapper {\n    &.compact-sidebar {\n      .page-body-wrapper {\n        div.sidebar-wrapper {\n          > div {\n            width: 112px;\n          }\n\n          .sidebar-main {\n            .sidebar-links {\n              li {\n                .sidebar-submenu,\n                .mega-menu-container {\n                  left: 112px;\n                  width: 190px;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    &.compact-small {\n      .page-body-wrapper {\n        div.sidebar-wrapper {\n          > div {\n            width: 80px;\n          }\n\n          .sidebar-main {\n            .sidebar-links {\n              li {\n                .sidebar-submenu,\n                .mega-menu-container {\n                  left: 80px;\n                  width: 210px;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // login form //\n  .login-card {\n    .login-main {\n      .theme-form {\n        .link {\n          position: unset;\n        }\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 360px) {\n  .product-box {\n    .modal {\n      .modal-header {\n        .product-box {\n          .product-details {\n            .product-qnty {\n              fieldset {\n                .input-group {\n                  width: 45%;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  .cal-date-widget {\n    &.card-body {\n      padding: 14px !important;\n    }\n    .react-datepicker {\n      min-height: 290px;\n    }\n    .cal-datepicker {\n      .datepicker-here {\n        .react-datepicker__day {\n          line-height: 2rem;\n        }\n        .react-datepicker__time-name {\n          line-height: 2rem;\n        }\n      }\n    }\n  }\n  .prooduct-details-box {\n    .close {\n      right: 0;\n      top: 5px;\n    }\n    .btn {\n      padding: 4px 8px;\n    }\n\n    .media {\n      padding: 15px;\n      display: block;\n      .media-body {\n        margin-top: 15px;\n      }\n    }\n  }\n  .datepicker--nav-action {\n    width: 20px;\n    margin-left: -10px;\n    background-color: transparent;\n\n    path {\n      stroke: var(--theme-default);\n    }\n  }\n  .clockpicker-align-top {\n    top: 426px !important;\n  }\n  .note {\n    min-width: 250px;\n  }\n\n  .datepicker {\n    width: 239px;\n  }\n\n  .add-post {\n    form {\n      .m-checkbox-inline {\n        label {\n          margin-bottom: 8px;\n\n          &:last-child {\n            margin-bottom: 0;\n          }\n        }\n      }\n    }\n  }\n\n  .map-js-height {\n    height: 250px;\n  }\n\n  .bar-chart-widget {\n    .earning-details {\n      i {\n        right: -73px;\n      }\n    }\n  }\n  // chart widget page css\n  .status-widget {\n    svg {\n      width: 18px;\n      height: 18px;\n    }\n  }\n\n  // social app page css\n  .tabs-scoial {\n    &.border-tab {\n      &.nav-tabs {\n        .nav-item {\n          .nav-link {\n            padding: 10px 5px;\n            font-size: 14px;\n          }\n        }\n      }\n    }\n  }\n\n  .user-profile {\n    .hovercard {\n      .user-image {\n        .share-icons {\n          right: 6px;\n          top: -15px;\n\n          li {\n            .social-icon {\n              width: 25px;\n              height: 25px;\n\n              i {\n                font-size: 14px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .social-chat {\n    .other-msg {\n      margin-left: 15px;\n    }\n  }\n\n  .social-header {\n    h5 {\n      span.pull-right {\n        display: none;\n      }\n    }\n  }\n\n  // timeline small page css\n  .timeline-small {\n    .media {\n      .timeline-round {\n        &.timeline-line-1 {\n          &:after {\n            bottom: -74px;\n            height: 56px;\n          }\n        }\n\n        &.small-line {\n          &:after {\n            bottom: -32px;\n            height: 14px;\n          }\n        }\n\n        &.medium-line {\n          &:after {\n            bottom: -59px;\n            height: 40px;\n          }\n        }\n      }\n\n      .media-body {\n        p {\n          display: -webkit-box;\n          text-overflow: ellipsis;\n          -webkit-box-orient: vertical;\n          overflow: hidden;\n          -webkit-line-clamp: 4;\n        }\n      }\n    }\n  }\n  .custom-card {\n    .dashboard-card {\n      padding-top: 0;\n    }\n\n    .card-profile {\n      img {\n        bottom: 25px;\n      }\n    }\n\n    .card-footer {\n      > div {\n        h6 {\n          font-size: 12px;\n        }\n      }\n    }\n  }\n\n  .flot-chart-container {\n    height: 230px;\n  }\n\n  .map-block {\n    height: 250px;\n  }\n\n  .img-cropper {\n    .docs-tooltip {\n      font-size: 11px;\n    }\n\n    .docs-toggles {\n      .btn-group {\n        .btn {\n          padding: 0.375rem 0.2rem;\n        }\n      }\n    }\n  }\n\n  .blog-box {\n    .blog-details {\n      p {\n        line-height: 1.5;\n      }\n\n      .blog-social {\n        li:last-child {\n          padding-left: 0;\n        }\n      }\n    }\n\n    .blog-details-main {\n      .blog-social {\n        li {\n          padding: 0 10px;\n        }\n      }\n    }\n  }\n\n  .button-builder-wrap {\n    .btn-lg {\n      font-size: 18px;\n    }\n  }\n\n  .tabs-responsive-side {\n    max-width: 100%;\n  }\n\n  //default dashboard\n  .browser-widget {\n    .media {\n      i {\n        font-size: 52px;\n      }\n\n      .media-body {\n        h4 {\n          font-size: 20px;\n        }\n      }\n    }\n  }\n  .bar-chart-widget {\n    .bottom-content {\n      .num {\n        font-size: 17px;\n      }\n    }\n  }\n\n  // serach page //\n  .search-page {\n    .theme-form {\n      .input-group {\n        .form-control-plaintext {\n          padding-left: 10px;\n        }\n        .btn {\n          padding: 6px 4px;\n        }\n      }\n    }\n    .info-block {\n      padding: 20px;\n    }\n  }\n\n  // from wizard two\n  .stepwizard {\n    .stepwizard-row {\n      .stepwizard-step {\n        .btn {\n          padding: 6px 20px;\n        }\n      }\n    }\n  }\n\n  //from wizard four\n  .wizard-4 {\n    ul {\n      &.anchor {\n        padding-top: 15px;\n      }\n    }\n\n    .msg-box {\n      top: 40px !important;\n    }\n  }\n\n  .xs-width-100 {\n    min-width: 100%;\n  }\n\n  // email app\n  .email-wrap {\n    .action-wrapper {\n      .actions {\n        li {\n          margin-right: 5px;\n        }\n      }\n    }\n\n    .email-body {\n      .attachment {\n        .list-inline {\n          .list-inline-item {\n            padding-right: 5px;\n          }\n        }\n      }\n    }\n\n    .email-right-aside {\n      .email-content {\n        .email-wrapper {\n          .attachment {\n            ul {\n              li {\n                img {\n                  width: 65px;\n                  height: 65px;\n                }\n              }\n            }\n          }\n        }\n      }\n\n      .email-top {\n        .dropdown-menu {\n          left: -58px;\n        }\n      }\n    }\n  }\n\n  // form-builder\n  .form-builder {\n    #components {\n      .component {\n        .form-group {\n          #button1id {\n            margin-bottom: 15px;\n          }\n        }\n      }\n    }\n  }\n\n  // according\n  .default-according {\n    .card {\n      .card-header {\n        i {\n          font-size: 14px;\n          top: 24px;\n        }\n      }\n\n      .btn-link {\n        display: block;\n        width: 100%;\n        padding-left: 17px;\n      }\n    }\n  }\n\n  //rating\n  .star-ratings {\n    .stars {\n      .title {\n        line-height: 1;\n      }\n    }\n  }\n\n  // tour page\n  .user-profile {\n    .hovercard {\n      .social-media {\n        a {\n          padding: 0 6px;\n        }\n      }\n    }\n  }\n\n  // touchspin page\n  .bootstrap-touchspin {\n    .touchspin-vertical-tab {\n      .input-group {\n        width: 93% !important;\n      }\n    }\n  }\n\n  // form-wizard-four page\n  .step-container {\n    height: 280px !important;\n  }\n\n  // jsgrid-table page\n  .sort-panel {\n    .d-inline {\n      .btn {\n        margin-left: 87px;\n      }\n    }\n  }\n\n  // jsgrid-table css\n  .jsgrid {\n    .jsgrid-pager-container {\n      .jsgrid-pager {\n        .jsgrid-pager-page {\n          padding: 0.5em 0.62em;\n        }\n      }\n    }\n  }\n\n  // chat page\n  .chat-box {\n    .chat-right-aside {\n      flex: 0 0 96%;\n      max-width: 96%;\n\n      .chat {\n        .chat-message {\n          width: calc(100% - 20px);\n        }\n      }\n    }\n  }\n\n  // error 400 page\n  .error-wrapper {\n    .error-heading {\n      .headline {\n        font-size: 100px;\n      }\n    }\n  }\n\n  // gallery page\n  .lg-toolbar {\n    .lg-icon {\n      width: 40px;\n    }\n  }\n\n  // calender page\n  .calendar-wrap {\n    a.fc-more {\n      font-size: 0.59em;\n    }\n\n    .fc {\n      th {\n        font-size: 10px;\n      }\n    }\n  }\n\n  //modal footer\n  .modal-footer {\n    display: block;\n    text-align: center;\n\n    button:first-child {\n      margin-bottom: 10px;\n    }\n  }\n\n  // checkout //\n  .order-box {\n    .qty {\n      li {\n        font-size: 14px;\n        span {\n          font-size: 14px;\n        }\n      }\n    }\n    ul {\n      li {\n        span {\n          text-align: right;\n        }\n        label {\n          text-align: right;\n          font-size: 14px;\n        }\n      }\n    }\n    .sub-total {\n      li {\n        .count {\n          font-size: 14px;\n        }\n      }\n    }\n  }\n\n  .checkout {\n    .text-end {\n      text-align: left !important;\n      margin-top: 15px;\n    }\n  }\n}\n\n@media only screen and (min-width: 576px) {\n  .product-wrapper-grid {\n    &.list-view {\n      .col-sm-6 {\n        flex: 0 0 100%;\n        max-width: 100%;\n      }\n    }\n  }\n\n  .sidebar-wrapper {\n    .back-btn {\n      display: none;\n    }\n  }\n}\n\n@media (width: 768px) and (height: 1024px) {\n  .page-wrapper {\n    &.compact-wrapper {\n      .page-body-wrapper {\n        div.sidebar-wrapper {\n          .sidebar-main {\n            .sidebar-links {\n              height: calc(100vh - 210px);\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n/**=====================\n     62. Responsive CSS Ends\n==========================**/\n","// jsgrid css\n.jsgrid-filter-row {\n  select,\n  input {\n    padding: 6px 10px;\n    border: 1px solid $horizontal-border-color;\n    background: $white;\n  }\n}\n\n// popover\n.popover {\n  background-color: $white;\n  border: none;\n  -webkit-box-shadow: 0 0 20px rgba($primary-color, 0.1);\n  box-shadow: 0 0 20px rgba($primary-color, 0.1);\n  .popover-header {\n    background-color: $theme-medium-color;\n    color: $primary-color;\n    border-bottom: none;\n  }\n  .popover-body {\n    color: rgba(43, 43, 43, 0.7);\n  }\n}\n\n// tooltip css start\n.tooltip {\n  &.bs-tooltip-top {\n    .tooltip-arrow {\n      &:before {\n        border-top-color: $theme-medium-color;\n      }\n    }\n  }\n  &.bs-tooltip-bottom {\n    .tooltip-arrow {\n      &:before {\n        border-bottom-color: $theme-medium-color;\n        border-top-color: transparent;\n      }\n    }\n  }\n  &.bs-tooltip-start {\n    .tooltip-arrow {\n      &:before {\n        border-left-color: $theme-medium-color;\n        border-top-color: transparent;\n      }\n    }\n  }\n  &.bs-tooltip-end {\n    .tooltip-arrow {\n      &:before {\n        border-right-color: $theme-medium-color;\n        border-top-color: transparent;\n      }\n    }\n  }\n  .tooltip-inner {\n    background-color: $theme-medium-color;\n    color: $primary-color;\n  }\n  .tooltip-arrow {\n    &:before {\n      border-top-color: $theme-medium-color;\n    }\n  }\n}\n\n// tooltip css end\n\n// dropdown css start\n.dropdown-basic {\n  .dropdown {\n    .dropdown-content {\n      a {\n        padding: 6px 16px;\n        color: $dark-editor-document;\n        opacity: 0.6;\n        font-size: 13px;\n        border-top: 1px solid $light-semi-gray;\n        background: $white;\n        &:hover {\n          background-color: $white;\n        }\n      }\n      .dropdown-header {\n        padding: 8px 16px;\n        font-weight: 400;\n        color: $dark-color;\n        font-size: 13px;\n      }\n    }\n  }\n  .dropup {\n    .dropup-content {\n      top: auto;\n    }\n  }\n}\n// dropdown css end\n// accordian css start\n.default-according {\n  .card {\n    .card-header {\n      padding: 0;\n      border: none;\n      border-radius: 0;\n      border-top-left-radius: 5px;\n      border-top-right-radius: 5px;\n      &.bg-primary,\n      &.bg-secondary {\n        .btn {\n          border-color: $transparent-color;\n        }\n      }\n      i {\n        position: initial;\n        font-size: 20px;\n        display: inline-block;\n        vertical-align: text-bottom;\n        margin-right: 5px;\n        [dir='rtl'] & {\n          margin-right: unset;\n          margin-left: 5px;\n        }\n      }\n      h5 {\n        margin-top: 0;\n      }\n      .btn-link {\n        padding: 12px 20px;\n        width: 100%;\n        text-align: left;\n        letter-spacing: 0.7px;\n        font-family: Roboto;\n        border: 1px solid $light-semi-gray;\n        border-radius: 0;\n        border-top-left-radius: 5px;\n        border-top-right-radius: 5px;\n        [dir='rtl'] & {\n          text-align: right;\n        }\n        @media (max-width: 575px) {\n          padding: 12px 15px;\n        }\n      }\n    }\n    .card-body {\n      padding: 15px 20px;\n      line-height: 22px;\n      font-size: 13px;\n      border-color: $light-semi-gray;\n      border-radius: 0;\n      border-bottom-left-radius: 5px;\n      border-bottom-right-radius: 5px;\n      color: $dark-color;\n    }\n  }\n}\n// accordian css end\n\n// tab-bootstrap css start\n.nav-tabs {\n  border-bottom-color: $light-semi-gray;\n  .nav-bottom {\n    .nav-item {\n      .nav-link.active {\n        border-color: $light-semi-gray;\n      }\n    }\n  }\n}\n.nav-tabs {\n  .nav-item {\n    &.show {\n      .nav-link {\n        font-weight: 500;\n      }\n    }\n  }\n  .nav-link {\n    color: $dark-color;\n    &.active {\n      font-weight: 500;\n    }\n  }\n  &.nav-bottom {\n    .nav-item {\n      .nav-link {\n        &.active {\n          border-color: $light-gray $light-gray #fff;\n        }\n      }\n    }\n  }\n}\n.dropdown-menu {\n  -webkit-box-shadow: 0 0 20px rgba(89, 102, 122, 0.1);\n  box-shadow: 0 0 20px rgba(89, 102, 122, 0.1);\n  border: none;\n  padding: 0;\n  z-index: 1;\n  .dropdown-item {\n    color: #2b2b2b;\n    opacity: 0.6;\n    font-size: 13px;\n    padding: 6px 12px;\n    border-top: 1px solid $light-semi-gray;\n    background: $white;\n    &:hover {\n      background-color: $white;\n    }\n  }\n  .dropdown-divider {\n    margin: 0;\n    border-top: 1px solid #cccccc;\n  }\n}\n// tab-bootstrap css end\n\n.border-tab {\n  .nav-tabs {\n    .nav-item {\n      .nav-link {\n        &.active {\n          border-bottom: 2px solid $primary-color;\n        }\n        &.show {\n          border-bottom: 2px solid $primary-color;\n        }\n        &:focus {\n          border-bottom: 2px solid $primary-color;\n        }\n      }\n    }\n  }\n}\n.tabbed-card {\n  .nav-tabs {\n    .nav-item {\n      .nav-link {\n        top: 17px;\n      }\n    }\n  }\n}\n.timeliny {\n  .timeliny-dot::before {\n    font-size: $btn-lg-font-size;\n  }\n}\n.form-builder-header-1,\n.form-builder-2-header {\n  background-color: #f7f6ff;\n  .nav-primary {\n    .nav-link {\n      color: $dark-color;\n      font-weight: 400;\n      &.active {\n        color: $white;\n      }\n    }\n  }\n  h6 {\n    margin-bottom: 0;\n    font-weight: 400;\n    line-height: 36px;\n  }\n}\n.component {\n  .input-group {\n    .btn {\n      line-height: 32px;\n      text-transform: capitalize;\n    }\n  }\n}\n.form-builder {\n  .drag-box {\n    fieldset {\n      margin-top: 0;\n    }\n  }\n}\n.login-card {\n  .login-main {\n    .theme-form {\n      label {\n        font-size: $body-font-size;\n      }\n      .show-hide {\n        top: 50%;\n      }\n    }\n  }\n}\n// faq css start\n.faq-accordion {\n  .card {\n    .btn-link {\n      svg {\n        margin-left: 20px;\n        @media (max-width: 575.98px) {\n          margin-left: 10px;\n        }\n      }\n    }\n  }\n}\n// faq css end\n.job-filter {\n  .faq-form {\n    .form-control {\n      font-size: 14px;\n    }\n    .search-icon {\n      width: 16px;\n      height: 16px;\n    }\n  }\n}\n// editor css\nbutton[data-toggle='dropdown'] {\n  &:hover {\n    ~ {\n      .dropdown-menu {\n        display: block;\n        min-width: 300px;\n        top: 35px;\n      }\n    }\n  }\n}\n","@import \"chartist-settings\";\n\n@mixin ct-responsive-svg-container($width: 100%, $ratio: $ct-container-ratio) {\n  display: block;\n  position: relative;\n  width: $width;\n\n  &:before {\n    display: block;\n    float: left;\n    content: \"\";\n    width: 0;\n    height: 0;\n    padding-bottom: $ratio * 100%;\n  }\n\n  &:after {\n    content: \"\";\n    display: table;\n    clear: both;\n  }\n\n  > svg {\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n}\n\n@mixin ct-align-justify($ct-text-align: $ct-text-align, $ct-text-justify: $ct-text-justify) {\n  -webkit-box-align: $ct-text-align;\n  -webkit-align-items: $ct-text-align;\n  -ms-flex-align: $ct-text-align;\n  align-items: $ct-text-align;\n  -webkit-box-pack: $ct-text-justify;\n  -webkit-justify-content: $ct-text-justify;\n  -ms-flex-pack: $ct-text-justify;\n  justify-content: $ct-text-justify;\n  // Fallback to text-align for non-flex browsers\n  @if($ct-text-justify == 'flex-start') {\n    text-align: left;\n  } @else if ($ct-text-justify == 'flex-end') {\n    text-align: right;\n  } @else {\n    text-align: center;\n  }\n}\n\n@mixin ct-flex() {\n  // Fallback to block\n  display: block;\n  display: -webkit-box;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  display: flex;\n}\n\n@mixin ct-chart-label($ct-text-color: $ct-text-color, $ct-text-size: $ct-text-size, $ct-text-line-height: $ct-text-line-height) {\n  fill: $ct-text-color;\n  color: $ct-text-color;\n  font-size: $ct-text-size;\n  line-height: $ct-text-line-height;\n}\n\n@mixin ct-chart-grid($ct-grid-color: $ct-grid-color, $ct-grid-width: $ct-grid-width, $ct-grid-dasharray: $ct-grid-dasharray) {\n  stroke: $ct-grid-color;\n  stroke-width: $ct-grid-width;\n\n  @if ($ct-grid-dasharray) {\n    stroke-dasharray: $ct-grid-dasharray;\n  }\n}\n\n@mixin ct-chart-point($ct-point-size: $ct-point-size, $ct-point-shape: $ct-point-shape) {\n  stroke-width: $ct-point-size;\n  stroke-linecap: $ct-point-shape;\n}\n\n@mixin ct-chart-line($ct-line-width: $ct-line-width, $ct-line-dasharray: $ct-line-dasharray) {\n  fill: none;\n  stroke-width: $ct-line-width;\n\n  @if ($ct-line-dasharray) {\n    stroke-dasharray: $ct-line-dasharray;\n  }\n}\n\n@mixin ct-chart-area($ct-area-opacity: $ct-area-opacity) {\n  stroke: none;\n  fill-opacity: $ct-area-opacity;\n}\n\n@mixin ct-chart-bar($ct-bar-width: $ct-bar-width) {\n  fill: none;\n  stroke-width: $ct-bar-width;\n}\n\n@mixin ct-chart-donut($ct-donut-width: $ct-donut-width) {\n  fill: none;\n  stroke-width: $ct-donut-width;\n}\n\n@mixin ct-chart-series-color($color) {\n  .#{$ct-class-point}, .#{$ct-class-line}, .#{$ct-class-bar}, .#{$ct-class-slice-donut} {\n    stroke: $color;\n  }\n\n  .#{$ct-class-slice-pie}, .#{$ct-class-slice-donut-solid}, .#{$ct-class-area} {\n    fill: $color;\n  }\n}\n\n@mixin ct-chart($ct-container-ratio: $ct-container-ratio, $ct-text-color: $ct-text-color, $ct-text-size: $ct-text-size, $ct-grid-color: $ct-grid-color, $ct-grid-width: $ct-grid-width, $ct-grid-dasharray: $ct-grid-dasharray, $ct-point-size: $ct-point-size, $ct-point-shape: $ct-point-shape, $ct-line-width: $ct-line-width, $ct-bar-width: $ct-bar-width, $ct-donut-width: $ct-donut-width, $ct-series-names: $ct-series-names, $ct-series-colors: $ct-series-colors) {\n\n  .#{$ct-class-label} {\n    @include ct-chart-label($ct-text-color, $ct-text-size);\n  }\n\n  .#{$ct-class-chart-line} .#{$ct-class-label},\n  .#{$ct-class-chart-bar} .#{$ct-class-label} {\n    @include ct-flex();\n  }\n\n  .#{$ct-class-chart-pie} .#{$ct-class-label},\n  .#{$ct-class-chart-donut} .#{$ct-class-label} {\n    dominant-baseline: central;\n  }\n\n  .#{$ct-class-label}.#{$ct-class-horizontal}.#{$ct-class-start} {\n    @include ct-align-justify(flex-end, flex-start);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-label}.#{$ct-class-horizontal}.#{$ct-class-end} {\n    @include ct-align-justify(flex-start, flex-start);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-label}.#{$ct-class-vertical}.#{$ct-class-start} {\n    @include ct-align-justify(flex-end, flex-end);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: end;\n  }\n\n  .#{$ct-class-label}.#{$ct-class-vertical}.#{$ct-class-end} {\n    @include ct-align-justify(flex-end, flex-start);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-chart-bar} .#{$ct-class-label}.#{$ct-class-horizontal}.#{$ct-class-start} {\n    @include ct-align-justify(flex-end, center);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-chart-bar} .#{$ct-class-label}.#{$ct-class-horizontal}.#{$ct-class-end} {\n    @include ct-align-justify(flex-start, center);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-chart-bar}.#{$ct-class-horizontal-bars} .#{$ct-class-label}.#{$ct-class-horizontal}.#{$ct-class-start} {\n    @include ct-align-justify(flex-end, flex-start);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-chart-bar}.#{$ct-class-horizontal-bars} .#{$ct-class-label}.#{$ct-class-horizontal}.#{$ct-class-end} {\n    @include ct-align-justify(flex-start, flex-start);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-chart-bar}.#{$ct-class-horizontal-bars} .#{$ct-class-label}.#{$ct-class-vertical}.#{$ct-class-start} {\n    //@include ct-chart-label($ct-text-color, $ct-text-size, center, $ct-vertical-text-justify);\n    @include ct-align-justify(center, flex-end);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: end;\n  }\n\n  .#{$ct-class-chart-bar}.#{$ct-class-horizontal-bars} .#{$ct-class-label}.#{$ct-class-vertical}.#{$ct-class-end} {\n    @include ct-align-justify(center, flex-start);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: end;\n  }\n\n  .#{$ct-class-grid} {\n    @include ct-chart-grid($ct-grid-color, $ct-grid-width, $ct-grid-dasharray);\n  }\n\n  .#{$ct-class-grid-background} {\n    fill: $ct-grid-background-fill;\n  }\n\n  .#{$ct-class-point} {\n    @include ct-chart-point($ct-point-size, $ct-point-shape);\n  }\n\n  .#{$ct-class-line} {\n    @include ct-chart-line($ct-line-width);\n  }\n\n  .#{$ct-class-area} {\n    @include ct-chart-area();\n  }\n\n  .#{$ct-class-bar} {\n    @include ct-chart-bar($ct-bar-width);\n  }\n\n  .#{$ct-class-slice-donut} {\n    @include ct-chart-donut($ct-donut-width);\n  }\n\n  @if $ct-include-colored-series {\n    @for $i from 0 to length($ct-series-names) {\n      .#{$ct-class-series}-#{nth($ct-series-names, $i + 1)} {\n        $color: nth($ct-series-colors, $i + 1);\n\n        @include ct-chart-series-color($color);\n      }\n    }\n  }\n}\n\n@if $ct-include-classes {\n  @include ct-chart();\n\n  @if $ct-include-alternative-responsive-containers {\n    @for $i from 0 to length($ct-scales-names) {\n      .#{nth($ct-scales-names, $i + 1)} {\n        @include ct-responsive-svg-container($ratio: nth($ct-scales, $i + 1));\n      }\n    }\n  }\n}\n","// Scales for responsive SVG containers\n$ct-scales: ((1), (15/16), (8/9), (5/6), (4/5), (3/4), (2/3), (5/8), (1/1.618), (3/5), (9/16), (8/15), (1/2), (2/5), (3/8), (1/3), (1/4)) !default;\n$ct-scales-names: (ct-square, ct-minor-second, ct-major-second, ct-minor-third, ct-major-third, ct-perfect-fourth, ct-perfect-fifth, ct-minor-sixth, ct-golden-section, ct-major-sixth, ct-minor-seventh, ct-major-seventh, ct-octave, ct-major-tenth, ct-major-eleventh, ct-major-twelfth, ct-double-octave) !default;\n\n// Class names to be used when generating CSS\n$ct-class-chart: ct-chart !default;\n$ct-class-chart-line: ct-chart-line !default;\n$ct-class-chart-bar: ct-chart-bar !default;\n$ct-class-horizontal-bars: ct-horizontal-bars !default;\n$ct-class-chart-pie: ct-chart-pie !default;\n$ct-class-chart-donut: ct-chart-donut !default;\n$ct-class-label: ct-label !default;\n$ct-class-series: ct-series !default;\n$ct-class-line: ct-line !default;\n$ct-class-point: ct-point !default;\n$ct-class-area: ct-area !default;\n$ct-class-bar: ct-bar !default;\n$ct-class-slice-pie: ct-slice-pie !default;\n$ct-class-slice-donut: ct-slice-donut !default;\n$ct-class-slice-donut-solid: ct-slice-donut-solid !default;\n$ct-class-grid: ct-grid !default;\n$ct-class-grid-background: ct-grid-background !default;\n$ct-class-vertical: ct-vertical !default;\n$ct-class-horizontal: ct-horizontal !default;\n$ct-class-start: ct-start !default;\n$ct-class-end: ct-end !default;\n\n// Container ratio\n$ct-container-ratio: (1/1.618) !default;\n\n// Text styles for labels\n$ct-text-color: rgba(0, 0, 0, 0.4) !default;\n$ct-text-size: 0.75rem !default;\n$ct-text-align: flex-start !default;\n$ct-text-justify: flex-start !default;\n$ct-text-line-height: 1;\n\n// Grid styles\n$ct-grid-color: rgba(0, 0, 0, 0.2) !default;\n$ct-grid-dasharray: 2px !default;\n$ct-grid-width: 1px !default;\n$ct-grid-background-fill: none !default;\n\n// Line chart properties\n$ct-line-width: 4px !default;\n$ct-line-dasharray: false !default;\n$ct-point-size: 10px !default;\n// Line chart point, can be either round or square\n$ct-point-shape: round !default;\n// Area fill transparency between 0 and 1\n$ct-area-opacity: 0.1 !default;\n\n// Bar chart bar width\n$ct-bar-width: 10px !default;\n\n// Donut width (If donut width is to big it can cause issues where the shape gets distorted)\n$ct-donut-width: 60px !default;\n\n// If set to true it will include the default classes and generate CSS output. If you're planning to use the mixins you\n// should set this property to false\n$ct-include-classes: true !default;\n\n// If this is set to true the CSS will contain colored series. You can extend or change the color with the\n// properties below\n$ct-include-colored-series: $ct-include-classes !default;\n\n// If set to true this will include all responsive container variations using the scales defined at the top of the script\n$ct-include-alternative-responsive-containers: $ct-include-classes !default;\n\n// Series names and colors. This can be extended or customized as desired. Just add more series and colors.\n$ct-series-names: (a, b, c, d, e, f, g, h, i, j, k, l, m, n, o) !default;\n$ct-series-colors: (\n  #7366ff,\n  #f73164,\n  #51bb25,\n  #f8d62b,\n  #f8d62b,\n  #dc3545,\n  #7366ff,\n  #7366ff,\n  #7366ff,\n  #7366ff,\n  #7366ff,\n  #7366ff,\n  #7366ff,\n  #7366ff,\n  #7366ff\n) !default;\n","/* FONT PATH\n * -------------------------- */\n\n@font-face {\n\tfont-family: 'themify';\n\tsrc:url('#{$ti-font-path}/themify.eot?-fvbane');\n\tsrc:url('#{$ti-font-path}/themify.eot?#iefix-fvbane') format('embedded-opentype'),\n\t\turl('#{$ti-font-path}/themify.woff?-fvbane') format('woff'),\n\t\turl('#{$ti-font-path}//themify.ttf?-fvbane') format('truetype'),\n\t\turl('#{$ti-font-path}/themify.svg?-fvbane#themify') format('svg');\n\tfont-weight: normal;\n\tfont-style: normal;\n}\n","\n[class^=\"icon-\"],\n[class*=\" icon-\"] {\n  @include icon-themify-icons();\n}\n\n[class^=\"icon-\"]:before,\n[class*=\" icon-\"]:before {\n  text-decoration: inherit;\n  display: inline-block;\n  speak: none;\n}\n\n/* makes the font 33% larger relative to the icon container */\n.icon-large:before {\n  vertical-align: -10%;\n  font-size: (4em/3);\n}\n\n/* makes sure icons active on rollover in links */\na {\n  [class^=\"icon-\"],\n  [class*=\" icon-\"] {\n    display: inline;\n  }\n}\n\n/* increased font size for icon-large */\n[class^=\"icon-\"],\n[class*=\" icon-\"] {\n  &.icon-fixed-width {\n    display: inline-block;\n    width: (16em/14);\n    text-align: right;\n    padding-right: (4em/14);\n    &.icon-large {\n      width: (20em/14);\n    }\n  }\n}\n\n.icons-ul {\n  margin-left: $icons-li-width;\n  list-style-type: none;\n\n  > li { position: relative; }\n\n  .icon-li {\n    position: absolute;\n    left: -$icons-li-width;\n    width: $icons-li-width;\n    text-align: center;\n    line-height: inherit;\n  }\n}\n\n// allows usage of the hide class directly on font awesome icons\n[class^=\"icon-\"],\n[class*=\" icon-\"] {\n  &.hide {\n    display: none;\n  }\n}\n\n.icon-muted { color: $iconMuted; }\n.icon-light { color: $iconLight; }\n.icon-dark { color: $iconDark; }\n\n// Icon Borders\n// -------------------------\n\n.icon-border {\n  border: solid 1px $borderColor;\n  padding: .2em .25em .15em;\n  @include border-radius(3px);\n}\n\n// Icon Sizes\n// -------------------------\n\n.icon-2x {\n  font-size: 2em;\n  &.icon-border {\n    border-width: 2px;\n    @include border-radius(4px);\n  }\n}\n.icon-3x {\n  font-size: 3em;\n  &.icon-border {\n    border-width: 3px;\n    @include border-radius(5px);\n  }\n}\n.icon-4x {\n  font-size: 4em;\n  &.icon-border {\n    border-width: 4px;\n    @include border-radius(6px);\n  }\n}\n\n.icon-5x {\n  font-size: 5em;\n  &.icon-border {\n    border-width: 5px;\n    @include border-radius(7px);\n  }\n}\n\n\n// Floats & Margins\n// -------------------------\n\n// Quick floats\n.pull-right { float: right; }\n.pull-left { float: left; }\n\n[class^=\"icon-\"],\n[class*=\" icon-\"] {\n  &.pull-left {\n    margin-right: .3em;\n  }\n  &.pull-right {\n    margin-left: .3em;\n  }\n}\n","// Mixins\n// --------------------------\n\n// FONT / MARGINS / FONT SIZE / COLOUR\n@mixin icon($i, $m:10px, $fs:18px, $c:inherit) {\n  &:before { @include icon-themify-icons(); content: $i; margin-right: $m; font-size: $fs; color:$c;}\n}\n@mixin iconafter($i, $m:10px, $fs:18px, $c:inherit) {\n  &:after { @include icon-themify-icons(); content: $i; margin-left: $m; font-size: $fs; color:$c; }\n}\n\n@mixin icon-themify-icons() {\n  font-family: 'themify';\nspeak: none;\nfont-style: normal;\nfont-weight: normal;\nfont-variant: normal;\ntext-transform: none;\nline-height: 1;\n-webkit-font-smoothing: antialiased;\n-moz-osx-font-smoothing: grayscale;\n  *margin-right: .3em; // fixes ie7 issues\n}\n\n@mixin border-radius($radius) {\n  -webkit-border-radius: $radius;\n  -moz-border-radius: $radius;\n  border-radius: $radius;\n}\n\n\n@mixin icon-stack($width: 2em, $height: 2em, $top-font-size: 1em, $base-font-size: 2em) {\n  .icon-stack {\n    position: relative;\n    display: inline-block;\n    width: $width;\n    height: $height;\n    line-height: $width;\n    vertical-align: -35%;\n    [class^=\"icon-\"],\n    [class*=\" icon-\"] {\n      display: block;\n      text-align: center;\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      font-size: $top-font-size;\n      line-height: inherit;\n      *line-height: $height;\n    }\n    .icon-stack-base {\n      font-size: $base-font-size;\n      *line-height: #{$height / $base-font-size}em;\n    }\n  }\n}\n","$ti-font-path: \"../../../fonts/themify\" !default;\n\n$borderColor: #eeeeee !default;\n$iconMuted: #eeeeee !default;\n$iconLight: white !default;\n$iconDark: #333333 !default;\n$icons-li-width: (30em/14);\n\n\n$wand : \"\\e600\";\n$volume : \"\\e601\";\n$user : \"\\e602\";\n$unlock : \"\\e603\";\n$unlink : \"\\e604\";\n$trash : \"\\e605\";\n$thought : \"\\e606\";\n$target : \"\\e607\";\n$tag : \"\\e608\";\n$tablet : \"\\e609\";\n$star : \"\\e60a\";\n$spray : \"\\e60b\";\n$signal : \"\\e60c\";\n$shopping-cart : \"\\e60d\";\n$shopping-cart-full : \"\\e60e\";\n$settings : \"\\e60f\";\n$search : \"\\e610\";\n$zoom-in : \"\\e611\";\n$zoom-out : \"\\e612\";\n$cut : \"\\e613\";\n$ruler : \"\\e614\";\n$ruler-pencil : \"\\e615\";\n$ruler-alt : \"\\e616\";\n$bookmark : \"\\e617\";\n$bookmark-alt : \"\\e618\";\n$reload : \"\\e619\";\n$plus : \"\\e61a\";\n$pin : \"\\e61b\";\n$pencil : \"\\e61c\";\n$pencil-alt : \"\\e61d\";\n$paint-roller : \"\\e61e\";\n$paint-bucket : \"\\e61f\";\n$na : \"\\e620\";\n$mobile : \"\\e621\";\n$minus : \"\\e622\";\n$medall : \"\\e623\";\n$medall-alt : \"\\e624\";\n$marker : \"\\e625\";\n$marker-alt : \"\\e626\";\n$arrow-up : \"\\e627\";\n$arrow-right : \"\\e628\";\n$arrow-left : \"\\e629\";\n$arrow-down : \"\\e62a\";\n$lock : \"\\e62b\";\n$location-arrow : \"\\e62c\";\n$link : \"\\e62d\";\n$layout : \"\\e62e\";\n$layers : \"\\e62f\";\n$layers-alt : \"\\e630\";\n$key : \"\\e631\";\n$import : \"\\e632\";\n$image : \"\\e633\";\n$heart : \"\\e634\";\n$heart-broken : \"\\e635\";\n$hand-stop : \"\\e636\";\n$hand-open : \"\\e637\";\n$hand-drag : \"\\e638\";\n$folder : \"\\e639\";\n$flag : \"\\e63a\";\n$flag-alt : \"\\e63b\";\n$flag-alt-2 : \"\\e63c\";\n$eye : \"\\e63d\";\n$export : \"\\e63e\";\n$exchange-vertical : \"\\e63f\";\n$desktop : \"\\e640\";\n$cup : \"\\e641\";\n$crown : \"\\e642\";\n$comments : \"\\e643\";\n$comment : \"\\e644\";\n$comment-alt : \"\\e645\";\n$close : \"\\e646\";\n$clip : \"\\e647\";\n$angle-up : \"\\e648\";\n$angle-right : \"\\e649\";\n$angle-left : \"\\e64a\";\n$angle-down : \"\\e64b\";\n$check : \"\\e64c\";\n$check-box : \"\\e64d\";\n$camera : \"\\e64e\";\n$announcement : \"\\e64f\";\n$brush : \"\\e650\";\n$briefcase : \"\\e651\";\n$bolt : \"\\e652\";\n$bolt-alt : \"\\e653\";\n$blackboard : \"\\e654\";\n$bag : \"\\e655\";\n$move : \"\\e656\";\n$arrows-vertical : \"\\e657\";\n$arrows-horizontal : \"\\e658\";\n$fullscreen : \"\\e659\";\n$arrow-top-right : \"\\e65a\";\n$arrow-top-left : \"\\e65b\";\n$arrow-circle-up : \"\\e65c\";\n$arrow-circle-right : \"\\e65d\";\n$arrow-circle-left : \"\\e65e\";\n$arrow-circle-down : \"\\e65f\";\n$angle-double-up : \"\\e660\";\n$angle-double-right : \"\\e661\";\n$angle-double-left : \"\\e662\";\n$angle-double-down : \"\\e663\";\n$zip : \"\\e664\";\n$world : \"\\e665\";\n$wheelchair : \"\\e666\";\n$view-list : \"\\e667\";\n$view-list-alt : \"\\e668\";\n$view-grid : \"\\e669\";\n$uppercase : \"\\e66a\";\n$upload : \"\\e66b\";\n$underline : \"\\e66c\";\n$truck : \"\\e66d\";\n$timer : \"\\e66e\";\n$ticket : \"\\e66f\";\n$thumb-up : \"\\e670\";\n$thumb-down : \"\\e671\";\n$text : \"\\e672\";\n$stats-up : \"\\e673\";\n$stats-down : \"\\e674\";\n$split-v : \"\\e675\";\n$split-h : \"\\e676\";\n$smallcap : \"\\e677\";\n$shine : \"\\e678\";\n$shift-right : \"\\e679\";\n$shift-left : \"\\e67a\";\n$shield : \"\\e67b\";\n$notepad : \"\\e67c\";\n$server : \"\\e67d\";\n$quote-right : \"\\e67e\";\n$quote-left : \"\\e67f\";\n$pulse : \"\\e680\";\n$printer : \"\\e681\";\n$power-off : \"\\e682\";\n$plug : \"\\e683\";\n$pie-chart : \"\\e684\";\n$paragraph : \"\\e685\";\n$panel : \"\\e686\";\n$package : \"\\e687\";\n$music : \"\\e688\";\n$music-alt : \"\\e689\";\n$mouse : \"\\e68a\";\n$mouse-alt : \"\\e68b\";\n$money : \"\\e68c\";\n$microphone : \"\\e68d\";\n$menu : \"\\e68e\";\n$menu-alt : \"\\e68f\";\n$map : \"\\e690\";\n$map-alt : \"\\e691\";\n$loop : \"\\e692\";\n$location-pin : \"\\e693\";\n$list : \"\\e694\";\n$light-bulb : \"\\e695\";\n$Italic : \"\\e696\";\n$info : \"\\e697\";\n$infinite : \"\\e698\";\n$id-badge : \"\\e699\";\n$hummer : \"\\e69a\";\n$home : \"\\e69b\";\n$help : \"\\e69c\";\n$headphone : \"\\e69d\";\n$harddrives : \"\\e69e\";\n$harddrive : \"\\e69f\";\n$gift : \"\\e6a0\";\n$game : \"\\e6a1\";\n$filter : \"\\e6a2\";\n$files : \"\\e6a3\";\n$file : \"\\e6a4\";\n$eraser : \"\\e6a5\";\n$envelope : \"\\e6a6\";\n$download : \"\\e6a7\";\n$direction : \"\\e6a8\";\n$direction-alt : \"\\e6a9\";\n$dashboard : \"\\e6aa\";\n$control-stop : \"\\e6ab\";\n$control-shuffle : \"\\e6ac\";\n$control-play : \"\\e6ad\";\n$control-pause : \"\\e6ae\";\n$control-forward : \"\\e6af\";\n$control-backward : \"\\e6b0\";\n$cloud : \"\\e6b1\";\n$cloud-up : \"\\e6b2\";\n$cloud-down : \"\\e6b3\";\n$clipboard : \"\\e6b4\";\n$car : \"\\e6b5\";\n$calendar : \"\\e6b6\";\n$book : \"\\e6b7\";\n$bell : \"\\e6b8\";\n$basketball : \"\\e6b9\";\n$bar-chart : \"\\e6ba\";\n$bar-chart-alt : \"\\e6bb\";\n$back-right : \"\\e6bc\";\n$back-left : \"\\e6bd\";\n$arrows-corner : \"\\e6be\";\n$archive : \"\\e6bf\";\n$anchor : \"\\e6c0\";\n$align-right : \"\\e6c1\";\n$align-left : \"\\e6c2\";\n$align-justify : \"\\e6c3\";\n$align-center : \"\\e6c4\";\n$alert : \"\\e6c5\";\n$alarm-clock : \"\\e6c6\";\n$agenda : \"\\e6c7\";\n$write : \"\\e6c8\";\n$window : \"\\e6c9\";\n$widgetized : \"\\e6ca\";\n$widget : \"\\e6cb\";\n$widget-alt : \"\\e6cc\";\n$wallet : \"\\e6cd\";\n$video-clapper : \"\\e6ce\";\n$video-camera : \"\\e6cf\";\n$vector : \"\\e6d0\";\n$themify-logo : \"\\e6d1\";\n$themify-favicon : \"\\e6d2\";\n$themify-favicon-alt : \"\\e6d3\";\n$support : \"\\e6d4\";\n$stamp : \"\\e6d5\";\n$split-v-alt : \"\\e6d6\";\n$slice : \"\\e6d7\";\n$shortcode : \"\\e6d8\";\n$shift-right-alt : \"\\e6d9\";\n$shift-left-alt : \"\\e6da\";\n$ruler-alt-2 : \"\\e6db\";\n$receipt : \"\\e6dc\";\n$pin2 : \"\\e6dd\";\n$pin-alt : \"\\e6de\";\n$pencil-alt2 : \"\\e6df\";\n$palette : \"\\e6e0\";\n$more : \"\\e6e1\";\n$more-alt : \"\\e6e2\";\n$microphone-alt : \"\\e6e3\";\n$magnet : \"\\e6e4\";\n$line-double : \"\\e6e5\";\n$line-dotted : \"\\e6e6\";\n$line-dashed : \"\\e6e7\";\n$layout-width-full : \"\\e6e8\";\n$layout-width-default : \"\\e6e9\";\n$layout-width-default-alt : \"\\e6ea\";\n$layout-tab : \"\\e6eb\";\n$layout-tab-window : \"\\e6ec\";\n$layout-tab-v : \"\\e6ed\";\n$layout-tab-min : \"\\e6ee\";\n$layout-slider : \"\\e6ef\";\n$layout-slider-alt : \"\\e6f0\";\n$layout-sidebar-right : \"\\e6f1\";\n$layout-sidebar-none : \"\\e6f2\";\n$layout-sidebar-left : \"\\e6f3\";\n$layout-placeholder : \"\\e6f4\";\n$layout-menu : \"\\e6f5\";\n$layout-menu-v : \"\\e6f6\";\n$layout-menu-separated : \"\\e6f7\";\n$layout-menu-full : \"\\e6f8\";\n$layout-media-right-alt : \"\\e6f9\";\n$layout-media-right : \"\\e6fa\";\n$layout-media-overlay : \"\\e6fb\";\n$layout-media-overlay-alt : \"\\e6fc\";\n$layout-media-overlay-alt-2 : \"\\e6fd\";\n$layout-media-left-alt : \"\\e6fe\";\n$layout-media-left : \"\\e6ff\";\n$layout-media-center-alt : \"\\e700\";\n$layout-media-center : \"\\e701\";\n$layout-list-thumb : \"\\e702\";\n$layout-list-thumb-alt : \"\\e703\";\n$layout-list-post : \"\\e704\";\n$layout-list-large-image : \"\\e705\";\n$layout-line-solid : \"\\e706\";\n$layout-grid4 : \"\\e707\";\n$layout-grid3 : \"\\e708\";\n$layout-grid2 : \"\\e709\";\n$layout-grid2-thumb : \"\\e70a\";\n$layout-cta-right : \"\\e70b\";\n$layout-cta-left : \"\\e70c\";\n$layout-cta-center : \"\\e70d\";\n$layout-cta-btn-right : \"\\e70e\";\n$layout-cta-btn-left : \"\\e70f\";\n$layout-column4 : \"\\e710\";\n$layout-column3 : \"\\e711\";\n$layout-column2 : \"\\e712\";\n$layout-accordion-separated : \"\\e713\";\n$layout-accordion-merged : \"\\e714\";\n$layout-accordion-list : \"\\e715\";\n$ink-pen : \"\\e716\";\n$info-alt : \"\\e717\";\n$help-alt : \"\\e718\";\n$headphone-alt : \"\\e719\";\n$hand-point-up : \"\\e71a\";\n$hand-point-right : \"\\e71b\";\n$hand-point-left : \"\\e71c\";\n$hand-point-down : \"\\e71d\";\n$gallery : \"\\e71e\";\n$face-smile : \"\\e71f\";\n$face-sad : \"\\e720\";\n$credit-card : \"\\e721\";\n$control-skip-forward : \"\\e722\";\n$control-skip-backward : \"\\e723\";\n$control-record : \"\\e724\";\n$control-eject : \"\\e725\";\n$comments-smiley : \"\\e726\";\n$brush-alt : \"\\e727\";\n$youtube : \"\\e728\";\n$vimeo : \"\\e729\";\n$twitter : \"\\e72a\";\n$time : \"\\e72b\";\n$tumblr : \"\\e72c\";\n$skype : \"\\e72d\";\n$share : \"\\e72e\";\n$share-alt : \"\\e72f\";\n$rocket : \"\\e730\";\n$pinterest : \"\\e731\";\n$new-window : \"\\e732\";\n$microsoft : \"\\e733\";\n$list-ol : \"\\e734\";\n$linkedin : \"\\e735\";\n$layout-sidebar-2 : \"\\e736\";\n$layout-grid4-alt : \"\\e737\";\n$layout-grid3-alt : \"\\e738\";\n$layout-grid2-alt : \"\\e739\";\n$layout-column4-alt : \"\\e73a\";\n$layout-column3-alt : \"\\e73b\";\n$layout-column2-alt : \"\\e73c\";\n$instagram : \"\\e73d\";\n$google : \"\\e73e\";\n$github : \"\\e73f\";\n$flickr : \"\\e740\";\n$facebook : \"\\e741\";\n$dropbox : \"\\e742\";\n$dribbble : \"\\e743\";\n$apple : \"\\e744\";\n$android : \"\\e745\";\n$save : \"\\e746\";\n$save-alt : \"\\e747\";\n$yahoo : \"\\e748\";\n$wordpress : \"\\e749\";\n$vimeo-alt : \"\\e74a\";\n$twitter-alt : \"\\e74b\";\n$tumblr-alt : \"\\e74c\";\n$trello : \"\\e74d\";\n$stack-overflow : \"\\e74e\";\n$soundcloud : \"\\e74f\";\n$sharethis : \"\\e750\";\n$sharethis-alt : \"\\e751\";\n$reddit : \"\\e752\";\n$pinterest-alt : \"\\e753\";\n$microsoft-alt : \"\\e754\";\n$linux : \"\\e755\";\n$jsfiddle : \"\\e756\";\n$joomla : \"\\e757\";\n$html5 : \"\\e758\";\n$flickr-alt : \"\\e759\";\n$email : \"\\e75a\";\n$drupal : \"\\e75b\";\n$dropbox-alt : \"\\e75c\";\n$css3 : \"\\e75d\";\n$rss : \"\\e75e\";\n$rss-alt: \"\\e75f\";\n","/* EXTRAS\n * -------------------------- */\n\n/* Stacked and layered icon */\n@include icon-stack();\n\n/* Animated rotating icon */\n.icon-spin {\n  display: inline-block;\n  -moz-animation: spin 2s infinite linear;\n  -o-animation: spin 2s infinite linear;\n  -webkit-animation: spin 2s infinite linear;\n  animation: spin 2s infinite linear;\n}\n\n/* Prevent stack and spinners from being taken inline when inside a link */\na .icon-stack,\na .icon-spin {\n  display: inline-block;\n  text-decoration: none;\n}\n\n@-moz-keyframes spin {\n  0% { -moz-transform: rotate(0deg); }\n  100% { -moz-transform: rotate(359deg); }\n}\n@-webkit-keyframes spin {\n  0% { -webkit-transform: rotate(0deg); }\n  100% { -webkit-transform: rotate(359deg); }\n}\n@-o-keyframes spin {\n  0% { -o-transform: rotate(0deg); }\n  100% { -o-transform: rotate(359deg); }\n}\n@-ms-keyframes spin {\n  0% { -ms-transform: rotate(0deg); }\n  100% { -ms-transform: rotate(359deg); }\n}\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(359deg); }\n}\n\n@mixin spinicon(){\n  @include icon-FontAwesome();\n  \n  display: inline-block;\n  -moz-animation: spin 2s infinite linear;\n  -o-animation: spin 2s infinite linear;\n  -webkit-animation: spin 2s infinite linear;\n  animation: spin 2s infinite linear;\n\n  content: $spinner;\n}\n\n/* Icon rotations and mirroring */\n.icon-rotate-90:before {\n  -webkit-transform: rotate(90deg);\n  -moz-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  -o-transform: rotate(90deg);\n  transform: rotate(90deg);\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);\n}\n\n.icon-rotate-180:before {\n  -webkit-transform: rotate(180deg);\n  -moz-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  -o-transform: rotate(180deg);\n  transform: rotate(180deg);\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n}\n\n.icon-rotate-270:before {\n  -webkit-transform: rotate(270deg);\n  -moz-transform: rotate(270deg);\n  -ms-transform: rotate(270deg);\n  -o-transform: rotate(270deg);\n  transform: rotate(270deg);\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);\n}\n\n.icon-flip-horizontal:before {\n  -webkit-transform: scale(-1, 1);\n  -moz-transform: scale(-1, 1);\n  -ms-transform: scale(-1, 1);\n  -o-transform: scale(-1, 1);\n  transform: scale(-1, 1);\n}\n\n.icon-flip-vertical:before {\n  -webkit-transform: scale(1, -1);\n  -moz-transform: scale(1, -1);\n  -ms-transform: scale(1, -1);\n  -o-transform: scale(1, -1);\n  transform: scale(1, -1);\n}\n\n/* ensure rotation occurs inside anchor tags */\na {\n  .icon-rotate-90, .icon-rotate-180, .icon-rotate-270, .icon-flip-horizontal, .icon-flip-vertical {\n    &:before { display: inline-block; }\n  }\n}\n",".icon-wand:before {content: \"\\e600\";}\n.icon-volume:before {content: \"\\e601\";}\n.icon-user:before {content: \"\\e602\";}\n.icon-unlock:before {content: \"\\e603\";}\n.icon-unlink:before {content: \"\\e604\";}\n.icon-trash:before {content: \"\\e605\";}\n.icon-thought:before {content: \"\\e606\";}\n.icon-target:before {content: \"\\e607\";}\n.icon-tag:before {content: \"\\e608\";}\n.icon-tablet:before {content: \"\\e609\";}\n.icon-star:before {content: \"\\e60a\";}\n.icon-spray:before {content: \"\\e60b\";}\n.icon-signal:before {content: \"\\e60c\";}\n.icon-shopping-cart:before {content: \"\\e60d\";}\n.icon-shopping-cart-full:before {content: \"\\e60e\";}\n.icon-settings:before {content: \"\\e60f\";}\n.icon-search:before {content: \"\\e610\";}\n.icon-zoom-in:before {content: \"\\e611\";}\n.icon-zoom-out:before {content: \"\\e612\";}\n.icon-cut:before {content: \"\\e613\";}\n.icon-ruler:before {content: \"\\e614\";}\n.icon-ruler-pencil:before {content: \"\\e615\";}\n.icon-ruler-alt:before {content: \"\\e616\";}\n.icon-bookmark:before {content: \"\\e617\";}\n.icon-bookmark-alt:before {content: \"\\e618\";}\n.icon-reload:before {content: \"\\e619\";}\n.icon-plus:before {content: \"\\e61a\";}\n.icon-pin:before {content: \"\\e61b\";}\n.icon-pencil:before {content: \"\\e61c\";}\n.icon-pencil-alt:before {content: \"\\e61d\";}\n.icon-paint-roller:before {content: \"\\e61e\";}\n.icon-paint-bucket:before {content: \"\\e61f\";}\n.icon-na:before {content: \"\\e620\";}\n.icon-mobile:before {content: \"\\e621\";}\n.icon-minus:before {content: \"\\e622\";}\n.icon-medall:before {content: \"\\e623\";}\n.icon-medall-alt:before {content: \"\\e624\";}\n.icon-marker:before {content: \"\\e625\";}\n.icon-marker-alt:before {content: \"\\e626\";}\n.icon-arrow-up:before {content: \"\\e627\";}\n.icon-arrow-right:before {content: \"\\e628\";}\n.icon-arrow-left:before {content: \"\\e629\";}\n.icon-arrow-down:before {content: \"\\e62a\";}\n.icon-lock:before {content: \"\\e62b\";}\n.icon-location-arrow:before {content: \"\\e62c\";}\n.icon-link:before {content: \"\\e62d\";}\n.icon-layout:before {content: \"\\e62e\";}\n.icon-layers:before {content: \"\\e62f\";}\n.icon-layers-alt:before {content: \"\\e630\";}\n.icon-key:before {content: \"\\e631\";}\n.icon-import:before {content: \"\\e632\";}\n.icon-image:before {content: \"\\e633\";}\n.icon-heart:before {content: \"\\e634\";}\n.icon-heart-broken:before {content: \"\\e635\";}\n.icon-hand-stop:before {content: \"\\e636\";}\n.icon-hand-open:before {content: \"\\e637\";}\n.icon-hand-drag:before {content: \"\\e638\";}\n.icon-folder:before {content: \"\\e639\";}\n.icon-flag:before {content: \"\\e63a\";}\n.icon-flag-alt:before {content: \"\\e63b\";}\n.icon-flag-alt-2:before {content: \"\\e63c\";}\n.icon-eye:before {content: \"\\e63d\";}\n.icon-export:before {content: \"\\e63e\";}\n.icon-exchange-vertical:before {content: \"\\e63f\";}\n.icon-desktop:before {content: \"\\e640\";}\n.icon-cup:before {content: \"\\e641\";}\n.icon-crown:before {content: \"\\e642\";}\n.icon-comments:before {content: \"\\e643\";}\n.icon-comment:before {content: \"\\e644\";}\n.icon-comment-alt:before {content: \"\\e645\";}\n.icon-close:before {content: \"\\e646\";}\n.icon-clip:before {content: \"\\e647\";}\n.icon-angle-up:before {content: \"\\e648\";}\n.icon-angle-right:before {content: \"\\e649\";}\n.icon-angle-left:before {content: \"\\e64a\";}\n.icon-angle-down:before {content: \"\\e64b\";}\n.icon-check:before {content: \"\\e64c\";}\n.icon-check-box:before {content: \"\\e64d\";}\n.icon-camera:before {content: \"\\e64e\";}\n.icon-announcement:before {content: \"\\e64f\";}\n.icon-brush:before {content: \"\\e650\";}\n.icon-briefcase:before {content: \"\\e651\";}\n.icon-bolt:before {content: \"\\e652\";}\n.icon-bolt-alt:before {content: \"\\e653\";}\n.icon-blackboard:before {content: \"\\e654\";}\n.icon-bag:before {content: \"\\e655\";}\n.icon-move:before {content: \"\\e656\";}\n.icon-arrows-vertical:before {content: \"\\e657\";}\n.icon-arrows-horizontal:before {content: \"\\e658\";}\n.icon-fullscreen:before {content: \"\\e659\";}\n.icon-arrow-top-right:before {content: \"\\e65a\";}\n.icon-arrow-top-left:before {content: \"\\e65b\";}\n.icon-arrow-circle-up:before {content: \"\\e65c\";}\n.icon-arrow-circle-right:before {content: \"\\e65d\";}\n.icon-arrow-circle-left:before {content: \"\\e65e\";}\n.icon-arrow-circle-down:before {content: \"\\e65f\";}\n.icon-angle-double-up:before {content: \"\\e660\";}\n.icon-angle-double-right:before {content: \"\\e661\";}\n.icon-angle-double-left:before {content: \"\\e662\";}\n.icon-angle-double-down:before {content: \"\\e663\";}\n.icon-zip:before {content: \"\\e664\";}\n.icon-world:before {content: \"\\e665\";}\n.icon-wheelchair:before {content: \"\\e666\";}\n.icon-view-list:before {content: \"\\e667\";}\n.icon-view-list-alt:before {content: \"\\e668\";}\n.icon-view-grid:before {content: \"\\e669\";}\n.icon-uppercase:before {content: \"\\e66a\";}\n.icon-upload:before {content: \"\\e66b\";}\n.icon-underline:before {content: \"\\e66c\";}\n.icon-truck:before {content: \"\\e66d\";}\n.icon-timer:before {content: \"\\e66e\";}\n.icon-ticket:before {content: \"\\e66f\";}\n.icon-thumb-up:before {content: \"\\e670\";}\n.icon-thumb-down:before {content: \"\\e671\";}\n.icon-text:before {content: \"\\e672\";}\n.icon-stats-up:before {content: \"\\e673\";}\n.icon-stats-down:before {content: \"\\e674\";}\n.icon-split-v:before {content: \"\\e675\";}\n.icon-split-h:before {content: \"\\e676\";}\n.icon-smallcap:before {content: \"\\e677\";}\n.icon-shine:before {content: \"\\e678\";}\n.icon-shift-right:before {content: \"\\e679\";}\n.icon-shift-left:before {content: \"\\e67a\";}\n.icon-shield:before {content: \"\\e67b\";}\n.icon-notepad:before {content: \"\\e67c\";}\n.icon-server:before {content: \"\\e67d\";}\n.icon-quote-right:before {content: \"\\e67e\";}\n.icon-quote-left:before {content: \"\\e67f\";}\n.icon-pulse:before {content: \"\\e680\";}\n.icon-printer:before {content: \"\\e681\";}\n.icon-power-off:before {content: \"\\e682\";}\n.icon-plug:before {content: \"\\e683\";}\n.icon-pie-chart:before {content: \"\\e684\";}\n.icon-paragraph:before {content: \"\\e685\";}\n.icon-panel:before {content: \"\\e686\";}\n.icon-package:before {content: \"\\e687\";}\n.icon-music:before {content: \"\\e688\";}\n.icon-music-alt:before {content: \"\\e689\";}\n.icon-mouse:before {content: \"\\e68a\";}\n.icon-mouse-alt:before {content: \"\\e68b\";}\n.icon-money:before {content: \"\\e68c\";}\n.icon-microphone:before {content: \"\\e68d\";}\n.icon-menu:before {content: \"\\e68e\";}\n.icon-menu-alt:before {content: \"\\e68f\";}\n.icon-map:before {content: \"\\e690\";}\n.icon-map-alt:before {content: \"\\e691\";}\n.icon-loop:before {content: \"\\e692\";}\n.icon-location-pin:before {content: \"\\e693\";}\n.icon-list:before {content: \"\\e694\";}\n.icon-light-bulb:before {content: \"\\e695\";}\n.icon-Italic:before {content: \"\\e696\";}\n.icon-info:before {content: \"\\e697\";}\n.icon-infinite:before {content: \"\\e698\";}\n.icon-id-badge:before {content: \"\\e699\";}\n.icon-hummer:before {content: \"\\e69a\";}\n.icon-home:before {content: \"\\e69b\";}\n.icon-help:before {content: \"\\e69c\";}\n.icon-headphone:before {content: \"\\e69d\";}\n.icon-harddrives:before {content: \"\\e69e\";}\n.icon-harddrive:before {content: \"\\e69f\";}\n.icon-gift:before {content: \"\\e6a0\";}\n.icon-game:before {content: \"\\e6a1\";}\n.icon-filter:before {content: \"\\e6a2\";}\n.icon-files:before {content: \"\\e6a3\";}\n.icon-file:before {content: \"\\e6a4\";}\n.icon-eraser:before {content: \"\\e6a5\";}\n.icon-envelope:before {content: \"\\e6a6\";}\n.icon-download:before {content: \"\\e6a7\";}\n.icon-direction:before {content: \"\\e6a8\";}\n.icon-direction-alt:before {content: \"\\e6a9\";}\n.icon-dashboard:before {content: \"\\e6aa\";}\n.icon-control-stop:before {content: \"\\e6ab\";}\n.icon-control-shuffle:before {content: \"\\e6ac\";}\n.icon-control-play:before {content: \"\\e6ad\";}\n.icon-control-pause:before {content: \"\\e6ae\";}\n.icon-control-forward:before {content: \"\\e6af\";}\n.icon-control-backward:before {content: \"\\e6b0\";}\n.icon-cloud:before {content: \"\\e6b1\";}\n.icon-cloud-up:before {content: \"\\e6b2\";}\n.icon-cloud-down:before {content: \"\\e6b3\";}\n.icon-clipboard:before {content: \"\\e6b4\";}\n.icon-car:before {content: \"\\e6b5\";}\n.icon-calendar:before {content: \"\\e6b6\";}\n.icon-book:before {content: \"\\e6b7\";}\n.icon-bell:before {content: \"\\e6b8\";}\n.icon-basketball:before {content: \"\\e6b9\";}\n.icon-bar-chart:before {content: \"\\e6ba\";}\n.icon-bar-chart-alt:before {content: \"\\e6bb\";}\n.icon-back-right:before {content: \"\\e6bc\";}\n.icon-back-left:before {content: \"\\e6bd\";}\n.icon-arrows-corner:before {content: \"\\e6be\";}\n.icon-archive:before {content: \"\\e6bf\";}\n.icon-anchor:before {content: \"\\e6c0\";}\n.icon-align-right:before {content: \"\\e6c1\";}\n.icon-align-left:before {content: \"\\e6c2\";}\n.icon-align-justify:before {content: \"\\e6c3\";}\n.icon-align-center:before {content: \"\\e6c4\";}\n.icon-alert:before {content: \"\\e6c5\";}\n.icon-alarm-clock:before {content: \"\\e6c6\";}\n.icon-agenda:before {content: \"\\e6c7\";}\n.icon-write:before {content: \"\\e6c8\";}\n.icon-window:before {content: \"\\e6c9\";}\n.icon-widgetized:before {content: \"\\e6ca\";}\n.icon-widget:before {content: \"\\e6cb\";}\n.icon-widget-alt:before {content: \"\\e6cc\";}\n.icon-wallet:before {content: \"\\e6cd\";}\n.icon-video-clapper:before {content: \"\\e6ce\";}\n.icon-video-camera:before {content: \"\\e6cf\";}\n.icon-vector:before {content: \"\\e6d0\";}\n.icon-themify-logo:before {content: \"\\e6d1\";}\n.icon-themify-favicon:before {content: \"\\e6d2\";}\n.icon-themify-favicon-alt:before {content: \"\\e6d3\";}\n.icon-support:before {content: \"\\e6d4\";}\n.icon-stamp:before {content: \"\\e6d5\";}\n.icon-split-v-alt:before {content: \"\\e6d6\";}\n.icon-slice:before {content: \"\\e6d7\";}\n.icon-shortcode:before {content: \"\\e6d8\";}\n.icon-shift-right-alt:before {content: \"\\e6d9\";}\n.icon-shift-left-alt:before {content: \"\\e6da\";}\n.icon-ruler-alt-2:before {content: \"\\e6db\";}\n.icon-receipt:before {content: \"\\e6dc\";}\n.icon-pin2:before {content: \"\\e6dd\";}\n.icon-pin-alt:before {content: \"\\e6de\";}\n.icon-pencil-alt2:before {content: \"\\e6df\";}\n.icon-palette:before {content: \"\\e6e0\";}\n.icon-more:before {content: \"\\e6e1\";}\n.icon-more-alt:before {content: \"\\e6e2\";}\n.icon-microphone-alt:before {content: \"\\e6e3\";}\n.icon-magnet:before {content: \"\\e6e4\";}\n.icon-line-double:before {content: \"\\e6e5\";}\n.icon-line-dotted:before {content: \"\\e6e6\";}\n.icon-line-dashed:before {content: \"\\e6e7\";}\n.icon-layout-width-full:before {content: \"\\e6e8\";}\n.icon-layout-width-default:before {content: \"\\e6e9\";}\n.icon-layout-width-default-alt:before {content: \"\\e6ea\";}\n.icon-layout-tab:before {content: \"\\e6eb\";}\n.icon-layout-tab-window:before {content: \"\\e6ec\";}\n.icon-layout-tab-v:before {content: \"\\e6ed\";}\n.icon-layout-tab-min:before {content: \"\\e6ee\";}\n.icon-layout-slider:before {content: \"\\e6ef\";}\n.icon-layout-slider-alt:before {content: \"\\e6f0\";}\n.icon-layout-sidebar-right:before {content: \"\\e6f1\";}\n.icon-layout-sidebar-none:before {content: \"\\e6f2\";}\n.icon-layout-sidebar-left:before {content: \"\\e6f3\";}\n.icon-layout-placeholder:before {content: \"\\e6f4\";}\n.icon-layout-menu:before {content: \"\\e6f5\";}\n.icon-layout-menu-v:before {content: \"\\e6f6\";}\n.icon-layout-menu-separated:before {content: \"\\e6f7\";}\n.icon-layout-menu-full:before {content: \"\\e6f8\";}\n.icon-layout-media-right-alt:before {content: \"\\e6f9\";}\n.icon-layout-media-right:before {content: \"\\e6fa\";}\n.icon-layout-media-overlay:before {content: \"\\e6fb\";}\n.icon-layout-media-overlay-alt:before {content: \"\\e6fc\";}\n.icon-layout-media-overlay-alt-2:before {content: \"\\e6fd\";}\n.icon-layout-media-left-alt:before {content: \"\\e6fe\";}\n.icon-layout-media-left:before {content: \"\\e6ff\";}\n.icon-layout-media-center-alt:before {content: \"\\e700\";}\n.icon-layout-media-center:before {content: \"\\e701\";}\n.icon-layout-list-thumb:before {content: \"\\e702\";}\n.icon-layout-list-thumb-alt:before {content: \"\\e703\";}\n.icon-layout-list-post:before {content: \"\\e704\";}\n.icon-layout-list-large-image:before {content: \"\\e705\";}\n.icon-layout-line-solid:before {content: \"\\e706\";}\n.icon-layout-grid4:before {content: \"\\e707\";}\n.icon-layout-grid3:before {content: \"\\e708\";}\n.icon-layout-grid2:before {content: \"\\e709\";}\n.icon-layout-grid2-thumb:before {content: \"\\e70a\";}\n.icon-layout-cta-right:before {content: \"\\e70b\";}\n.icon-layout-cta-left:before {content: \"\\e70c\";}\n.icon-layout-cta-center:before {content: \"\\e70d\";}\n.icon-layout-cta-btn-right:before {content: \"\\e70e\";}\n.icon-layout-cta-btn-left:before {content: \"\\e70f\";}\n.icon-layout-column4:before {content: \"\\e710\";}\n.icon-layout-column3:before {content: \"\\e711\";}\n.icon-layout-column2:before {content: \"\\e712\";}\n.icon-layout-accordion-separated:before {content: \"\\e713\";}\n.icon-layout-accordion-merged:before {content: \"\\e714\";}\n.icon-layout-accordion-list:before {content: \"\\e715\";}\n.icon-ink-pen:before {content: \"\\e716\";}\n.icon-info-alt:before {content: \"\\e717\";}\n.icon-help-alt:before {content: \"\\e718\";}\n.icon-headphone-alt:before {content: \"\\e719\";}\n.icon-hand-point-up:before {content: \"\\e71a\";}\n.icon-hand-point-right:before {content: \"\\e71b\";}\n.icon-hand-point-left:before {content: \"\\e71c\";}\n.icon-hand-point-down:before {content: \"\\e71d\";}\n.icon-gallery:before {content: \"\\e71e\";}\n.icon-face-smile:before {content: \"\\e71f\";}\n.icon-face-sad:before {content: \"\\e720\";}\n.icon-credit-card:before {content: \"\\e721\";}\n.icon-control-skip-forward:before {content: \"\\e722\";}\n.icon-control-skip-backward:before {content: \"\\e723\";}\n.icon-control-record:before {content: \"\\e724\";}\n.icon-control-eject:before {content: \"\\e725\";}\n.icon-comments-smiley:before {content: \"\\e726\";}\n.icon-brush-alt:before {content: \"\\e727\";}\n.icon-youtube:before {content: \"\\e728\";}\n.icon-vimeo:before {content: \"\\e729\";}\n.icon-twitter:before {content: \"\\e72a\";}\n.icon-time:before {content: \"\\e72b\";}\n.icon-tumblr:before {content: \"\\e72c\";}\n.icon-skype:before {content: \"\\e72d\";}\n.icon-share:before {content: \"\\e72e\";}\n.icon-share-alt:before {content: \"\\e72f\";}\n.icon-rocket:before {content: \"\\e730\";}\n.icon-pinterest:before {content: \"\\e731\";}\n.icon-new-window:before {content: \"\\e732\";}\n.icon-microsoft:before {content: \"\\e733\";}\n.icon-list-ol:before {content: \"\\e734\";}\n.icon-linkedin:before {content: \"\\e735\";}\n.icon-layout-sidebar-2:before {content: \"\\e736\";}\n.icon-layout-grid4-alt:before {content: \"\\e737\";}\n.icon-layout-grid3-alt:before {content: \"\\e738\";}\n.icon-layout-grid2-alt:before {content: \"\\e739\";}\n.icon-layout-column4-alt:before {content: \"\\e73a\";}\n.icon-layout-column3-alt:before {content: \"\\e73b\";}\n.icon-layout-column2-alt:before {content: \"\\e73c\";}\n.icon-instagram:before {content: \"\\e73d\";}\n.icon-google:before {content: \"\\e73e\";}\n.icon-github:before {content: \"\\e73f\";}\n.icon-flickr:before {content: \"\\e740\";}\n.icon-facebook:before {content: \"\\e741\";}\n.icon-dropbox:before {content: \"\\e742\";}\n.icon-dribbble:before {content: \"\\e743\";}\n.icon-apple:before {content: \"\\e744\";}\n.icon-android:before {content: \"\\e745\";}\n.icon-save:before {content: \"\\e746\";}\n.icon-save-alt:before {content: \"\\e747\";}\n.icon-yahoo:before {content: \"\\e748\";}\n.icon-wordpress:before {content: \"\\e749\";}\n.icon-vimeo-alt:before {content: \"\\e74a\";}\n.icon-twitter-alt:before {content: \"\\e74b\";}\n.icon-tumblr-alt:before {content: \"\\e74c\";}\n.icon-trello:before {content: \"\\e74d\";}\n.icon-stack-overflow:before {content: \"\\e74e\";}\n.icon-soundcloud:before {content: \"\\e74f\";}\n.icon-sharethis:before {content: \"\\e750\";}\n.icon-sharethis-alt:before {content: \"\\e751\";}\n.icon-reddit:before {content: \"\\e752\";}\n.icon-pinterest-alt:before {content: \"\\e753\";}\n.icon-microsoft-alt:before {content: \"\\e754\";}\n.icon-linux:before {content: \"\\e755\";}\n.icon-jsfiddle:before {content: \"\\e756\";}\n.icon-joomla:before {content: \"\\e757\";}\n.icon-html5:before {content: \"\\e758\";}\n.icon-flickr-alt:before {content: \"\\e759\";}\n.icon-email:before {content: \"\\e75a\";}\n.icon-drupal:before {content: \"\\e75b\";}\n.icon-dropbox-alt:before {content: \"\\e75c\";}\n.icon-css3:before {content: \"\\e75d\";}\n.icon-rss:before {content: \"\\e75e\";}\n.icon-rss-alt:before {content: \"\\e75f\";}\n","/* VARIABLES */\n$baseAnimationDuration: 18s;\n$size: 80px;\n$svgSize: 70px;\n@function pi() {\n  @return 3.14159265359;\n}\n@function fact($number) {\n  $value: 1;\n  @if $number > 0 {\n    @for $i from 1 through $number {\n      $value: $value * $i;\n    }\n  }\n  @return $value;\n}\n@function rad($angle) {\n  $unit: unit($angle);\n  $unitless: $angle / ($angle * 0 + 1);\n  // If the angle has 'deg' as unit, convert to radians.\n  @if $unit == deg {\n    $unitless: $unitless / 180 * pi();\n  }\n  @return $unitless;\n}\n@function pow($number, $exp) {\n  $value: 1;\n  @if $exp > 0 {\n    @for $i from 1 through $exp {\n      $value: $value * $number;\n    }\n  }\n  @else if $exp < 0 {\n    @for $i from 1 through -$exp {\n      $value: $value / $number;\n    }\n  }\n  @return $value;\n}\n@function sin($angle) {\n  $sin: 0;\n  $angle: rad($angle);\n  // Iterate a bunch of times.\n  @for $i from 0 through 10 {\n    $sin: $sin + pow(-1, $i) * pow($angle, (2 * $i + 1)) / fact(2 * $i + 1);\n  }\n  @return $sin;\n}\n\n\n//vars specific for curves\n$animationStep: 2;\n$increase: pi() / 100;\n\n$backgroundColor: skyblue;\n$fontColor: white;\n$strokeColor: white;\n$fillColor: #aedef4;\n\n/* Applies a stroke to the icons. Can use percentage for responsive */\n$strokeStrokeWidth: 0%;\n$strokeStrokeColor: black;\n$fillStrokeWidth: 0%;\n$fillStrokeColor: black;\n\n.climacon_component-stroke {\n  fill: #dcdada;\n  stroke-width: 1px;\n  stroke: #717171;\n}\n\n.climacon_component-fill {\n  fill: #71717140;\n  stroke-width: 0;\n  stroke: #ddd;\n}\n\n/* SVG GLOBAL */\n\nsvg.climacon {\n  display: inline-block;\n  width: $size;\n  height: $size;\n  shape-rendering: geometricPrecision;\n}\n\ng, path, circle, rect {\n  animation-iteration-count: infinite;\n  animation-timing-function: linear;\n  transform-origin: 50% 50%;\n  animation-duration: $baseAnimationDuration;\n  animation-direction: normal;\n}\n\n/* SUN */\n\n.climacon_componentWrap-sun {\n  animation-name: rotate;\n}\n\n.climacon_componentWrap_sunSpoke .climacon_component-stroke_sunSpoke {\n  animation-name: scale;\n  animation-direction: alternate;\n  animation-duration: $baseAnimationDuration / 4;\n}\n\n.climacon_componentWrap_sunSpoke .climacon_component-stroke_sunSpoke:nth-child(even) {\n  animation-delay: $baseAnimationDuration / 4;\n}\n\n/* MOON */\n\n.climacon_componentWrap-moon {\n  animation-name: partialRotate;\n  animation-duration: $baseAnimationDuration;\n  animation-direction: alternate;\n}\n\n/* WIND */\n\n.climacon_componentWrap-wind {\n  animation-name: translateWind;\n  animation-duration: $baseAnimationDuration / 3;\n  animation-direction: alternate;\n  animation-timing-function: ease-in-out;\n}\n\n/* SNOWFLAKE */\n\n.climacon_componentWrap-snowflake {\n  animation-name: rotate;\n  animation-duration: $baseAnimationDuration * 3;\n  animation-direction: normal;\n}\n\n/* CLOUD SUN */\n\n.climacon_componentWrap-sun_cloud {\n  animation-name: behindCloudMove, rotate;\n  animation-iteration-count: 1, infinite;\n  animation-timing-function: ease-out, linear;\n  animation-delay: 0, $baseAnimationDuration / 4;\n  animation-duration: $baseAnimationDuration / 4, $baseAnimationDuration;\n}\n\n.climacon_componentWrap-sun_cloud .climacon_componentWrap_sunSpoke .climacon_component-stroke_sunSpoke {\n  fill-opacity: 0;\n  animation-name: fillOpacity, scale;\n  animation-iteration-count: 1, infinite;\n  animation-delay: $baseAnimationDuration / 4, 0;\n  animation-fill-mode: both;\n}\n\n.climacon_componentWrap-sun_cloud .climacon_componentWrap_sunSpoke .climacon_component-stroke_sunSpoke:nth-child(even) {\n  animation-delay: $baseAnimationDuration / 4;\n}\n\n/* CLOUD MOON */\n\n.climacon_componentWrap-moon_cloud {\n  animation-name: behindCloudMove, partialRotate;\n  animation-iteration-count: 1, infinite;\n  animation-timing-function: ease-out, linear;\n  animation-delay: 0, $baseAnimationDuration / 4;\n  animation-duration: $baseAnimationDuration / 4, $baseAnimationDuration;\n}\n\n/* DRIZZLE */\n\n.climacon_component-stroke_drizzle {\n  fill-opacity: 0;\n  animation-name: drizzleFall, fillOpacity2;\n  animation-timing-function: ease-in;\n  animation-duration: $baseAnimationDuration / 12;\n}\n\n@for $i from 1 through 3 {\n  .climacon_component-stroke_drizzle:nth-child(#{$i}) {\n    animation-delay: $baseAnimationDuration * 0.05 * $i - $baseAnimationDuration * 0.05;\n  }\n}\n\n/* RAIN */\n\n.climacon_component-stroke_rain {\n  fill-opacity: 0;\n  animation-name: rainFall, fillOpacity2;\n  animation-timing-function: ease-in;\n  animation-duration: $baseAnimationDuration / 6;\n}\n\n.climacon_component-stroke_rain:nth-child(n+4) {\n  animation-delay: $baseAnimationDuration / 12;\n}\n\n.climacon_component-stroke_rain_alt:nth-child(2) {\n  animation-delay: $baseAnimationDuration / 12;\n}\n\n/* HAIL */\n\n.climacon_component-stroke_hail {\n  //animation-name: translateY, fillOpacity2\n  //animation-timing-function: ease-in\n  //animation-duration: $baseAnimationDuration / 24\n}\n\n/* HAIL ALT */\n\n.climacon_component-stroke_hailAlt {\n  fill-opacity: 1;\n  animation-timing-function: ease-in;\n  animation-duration: $baseAnimationDuration / 18;\n}\n\n.climacon_component-stroke_hailAlt-left {\n  animation-name: hailLeft, fillOpacity2;\n}\n\n.climacon_component-stroke_hailAlt-middle {\n  animation-name: hailMiddle, fillOpacity2;\n}\n\n.climacon_component-stroke_hailAlt-middle:nth-child(2) {\n  animation-name: hailMiddle2, fillOpacity2;\n}\n\n.climacon_component-stroke_hailAlt-right {\n  animation-name: hailRight, fillOpacity2;\n}\n\n@for $i from 1 through 6 {\n  .climacon_component-stroke_hailAlt:nth-child(#{$i}) {\n    animation-delay: $baseAnimationDuration / 18 / 6 * $i - $baseAnimationDuration / 18 / 6;\n  }\n}\n\n/* SNOW */\n\n.climacon_component-stroke_snow {\n  fill-opacity: 0;\n  animation-name: snowFall, fillOpacity2;\n  animation-timing-function: ease-in-out;\n  animation-duration: $baseAnimationDuration / 2;\n}\n\n.climacon_component-stroke_snow:nth-child(3) {\n  animation-name: snowFall2, fillOpacity2;\n}\n\n@for $i from 1 through 3 {\n  .climacon_component-stroke_snow:nth-child(#{$i}) {\n    animation-delay: $baseAnimationDuration / 2 / 3 * $i - $baseAnimationDuration / 2 / 3;\n  }\n}\n\n/* SNOW ALT */\n\n.climacon_wrapperComponent-snowAlt {\n  fill-opacity: 0;\n  animation-name: snowFall, fillOpacity2;\n  animation-timing-function: ease-in-out;\n  animation-duration: $baseAnimationDuration / 2;\n}\n\n/* FOG */\n\n.climacon_component-stroke_fogLine {\n  fill-opacity: 0.5;\n  animation-name: translateFog, fillOpacityFog;\n  animation-iteration-count: infinite;\n  animation-direction: normal;\n  animation-timing-function: ease-in;\n  animation-duration: $baseAnimationDuration;\n}\n\n.climacon_component-stroke_fogLine:nth-child(even) {\n  animation-delay: $baseAnimationDuration / 2;\n}\n\n/* LIGHTNING */\n\n.climacon_component-stroke_lightning {\n  fill-opacity: 0;\n  animation-name: fillOpacityLightning;\n  animation-iteration-count: infinite;\n  animation-direction: normal;\n  animation-timing-function: ease-out;\n  animation-duration: $baseAnimationDuration;\n}\n\n/* TORNADO */\n\n.climacon_component-stroke_tornadoLine {\n  animation-name: translateTornado1;\n  animation-iteration-count: infinite;\n  animation-direction: alternate;\n  animation-timing-function: ease-in-out;\n  animation-duration: $baseAnimationDuration;\n}\n\n.climacon_component-stroke_tornadoLine:nth-child(1) {\n  animation-name: translateTornado1;\n}\n\n.climacon_component-stroke_tornadoLine:nth-child(2) {\n  animation-name: translateTornado2;\n}\n\n.climacon_component-stroke_tornadoLine:nth-child(3) {\n  animation-name: translateTornado3;\n}\n\n.climacon_component-stroke_tornadoLine:nth-child(4) {\n  animation-name: translateTornado4;\n}\n\n.climacon_component-stroke_tornadoLine:nth-child(5) {\n  animation-name: translateTornado5;\n}\n\n.climacon_component-stroke_tornadoLine:nth-child(6) {\n  animation-name: translateTornado6;\n}\n\n.climacon_componentWrap-sunsetAlt {\n  animation-name: translateSunset;\n  animation-duration: $baseAnimationDuration / 4;\n  animation-iteration-count: 1;\n  animation-timing-function: ease-out;\n}\n\n.climacon_componentWrap-sunsetAlt {\n  animation-name: translateSunset;\n  animation-iteration-count: 1;\n}\n\n.climacon_iconWrap-sun .climacon_component-stroke_sunSpoke, .climacon_iconWrap-sunFill .climacon_component-stroke_sunSpoke {\n  fill-opacity: 1;\n  animation-name: scale;\n  animation-duration: 3s;\n  animation-iteration-count: infinite;\n  animation-delay: 0s;\n  animation-fill-mode: both;\n  animation-direction: alternate;\n}\n\n.climacon_iconWrap-sun .climacon_component-stroke_sunSpoke:nth-child(even), .climacon_iconWrap-sunFill .climacon_component-stroke_sunSpoke:nth-child(even) {\n  animation-delay: $baseAnimationDuration / 4;\n}\n\n.climacon-iconWrap_sunFill .climacon_component-stroke_sunSpoke {\n  fill-opacity: 1;\n  animation-name: scale;\n  animation-iteration-count: infinite;\n  animation-delay: 0s;\n  animation-fill-mode: both;\n  animation-direction: alternate;\n}\n\n.climacon-iconWrap_sunFill .climacon_component-stroke_sunSpoke:nth-child(even) {\n  animation-delay: $baseAnimationDuration / 4;\n}\n\n.climacon_component-stroke_arrow-up {\n  fill-opacity: 0;\n  animation-name: fillOpacity2, translateArrowUp;\n  animation-duration: $baseAnimationDuration / 4;\n}\n\n.climacon_component-stroke_arrow-down {\n  fill-opacity: 0;\n  animation-name: fillOpacity2, translateArrowDown;\n  animation-duration: $baseAnimationDuration / 4;\n}\n\n.climacon_componentWrap-sunrise .climacon_component-stroke_sunSpoke, .climacon_componentWrap-sunset .climacon_component-stroke_sunSpoke {\n  animation-name: scale;\n  animation-direction: alternate;\n  animation-iteration-count: infinite;\n  animation-duration: $baseAnimationDuration / 4;\n  animation-delay: 0s;\n  animation-fill-mode: both;\n}\n\n.climacon_componentWrap-sunrise .climacon_component-stroke_sunSpoke:nth-child(even), .climacon_componentWrap-sunset .climacon_component-stroke_sunSpoke:nth-child(even) {\n  animation-delay: $baseAnimationDuration / 4;\n}\n\n.climacon_componentWrap-sunriseAlt {\n  animation-name: translateSunrise, fillOpacity;\n  animation-duration: $baseAnimationDuration, $baseAnimationDuration / 2;\n  animation-direction: normal;\n  animation-iteration-count: 1;\n  animation-fill-mode: forwards;\n}\n\n.climacon_componentWrap-sunriseAlt .climacon_component-stroke_sunSpoke {\n  fill-opacity: 0;\n  animation-name: fillOpacity, scale;\n  animation-direction: normal, alternate;\n  animation-iteration-count: 1, infinite;\n  animation-duration: $baseAnimationDuration / 4;\n  animation-delay: $baseAnimationDuration / 4, 0;\n  animation-fill-mode: both;\n}\n\n.climacon_componentWrap-sunriseAlt .climacon_component-stroke_sunSpoke:nth-child(even) {\n  animation-delay: $baseAnimationDuration / 4, $baseAnimationDuration / 4;\n}\n\n.climacon_componentWrap-sunsetAlt {\n  animation-name: translateSunset;\n  animation-delay: 0s;\n  animation-duration: $baseAnimationDuration;\n  animation-direction: normal;\n  animation-iteration-count: 1;\n  animation-fill-mode: forwards;\n}\n\n/* ANIMATIONS */\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n\n@keyframes partialRotate {\n  0% {\n    transform: rotate(0deg);\n  }\n  25% {\n    transform: rotate(-15deg);\n  }\n  50% {\n    transform: rotate(0deg);\n  }\n  75% {\n    transform: rotate(15deg);\n  }\n  100% {\n    transform: rotate(0deg);\n  }\n}\n\n\n@keyframes scale {\n  0% {\n    transform: scale(1, 1);\n  }\n  100% {\n    transform: scale(0.5, 0.5);\n  }\n}\n\n\n@keyframes behindCloudMove {\n  0% {\n    transform: translateX(-$svgSize * 0.025) translateY($svgSize * 0.025);\n  }\n  100% {\n    transform: translateX(0) translateY(0);\n  }\n}\n\n\n@keyframes drizzleFall {\n  0% {\n    transform: translateY(0);\n  }\n  100% {\n    transform: translateY($svgSize * 0.3);\n  }\n}\n\n\n@keyframes rainFall {\n  0% {\n    transform: translateY(0);\n  }\n  100% {\n    transform: translateY($svgSize * 0.2);\n  }\n}\n\n\n@keyframes rainFall2 {\n  0% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY($svgSize * 0.2);\n  }\n  100% {\n    transform: translateX($svgSize * 0.2) translateY($svgSize * 0.2);\n  }\n}\n\n\n$i: 51;\n$t: 0;\n\n@keyframes hailLeft {\n  0% {}\n  50% {\n    transform: translateY($svgSize * 0.25);\n  }\n  @while $i <= 100 {\n    #{$i}% {\n      $eq: sin($t) / 2;\n      transform: translateY($eq * -($svgSize * 0.25) + $svgSize * 0.25) translateX(-0.3px * ($i - 50));\n    }\n    $t: $t + $increase * $animationStep * 2;\n    $i: $i + $animationStep;\n  }\n}\n\n$i: 51;\n$t: 0;\n@keyframes hailMiddle {\n  0% {}\n  50% {\n    transform: translateY($svgSize * 0.25);\n  }\n  @while $i <= 100 {\n    #{$i}% {\n      $eq: sin($t) / 2;\n      transform: translateY($eq * -($svgSize * 0.25) + $svgSize * 0.25) translateX(-0.15px * ($i - 50));\n    }\n    $t: $t + $increase * $animationStep * 2;\n    $i: $i + $animationStep;\n  }\n}\n\n\n$increase: pi() / 100;\n$i: 51;\n$t: 0;\n\n@keyframes hailMiddle2 {\n  0% {}\n  50% {\n    transform: translateY($svgSize * 0.25);\n  }\n  @while $i <= 100 {\n    #{$i}% {\n      $eq: sin($t) / 2;\n      transform: translateY($eq * -($svgSize * 0.25) + $svgSize * 0.25) translateX(0.15px * ($i - 50));\n    }\n    $t: $t + $increase * $animationStep * 2;\n    $i: $i + $animationStep;\n  }\n}\n\n\n$i: 51;\n$t: 0;\n\n@keyframes hailRight {\n  0% {}\n  50% {\n    transform: translateY($svgSize * 0.25);\n  }\n  @while $i <= 100 {\n    #{$i}% {\n      $eq: sin($t) / 2;\n      transform: translateY($eq * -($svgSize * 0.25) + $svgSize * 0.25) translateX(0.3px * ($i - 50));\n    }\n    $t: $t + $increase * $animationStep * 2;\n    $i: $i + $animationStep;\n  }\n}\n\n\n@keyframes fillOpacity {\n  0% {\n    fill-opacity: 0;\n    stroke-opacity: 0;\n  }\n  100% {\n    fill-opacity: 1;\n    stroke-opacity: 1;\n  }\n}\n\n\n@keyframes fillOpacity2 {\n  0% {\n    fill-opacity: 0;\n    stroke-opacity: 0;\n  }\n  50% {\n    fill-opacity: 1;\n    stroke-opacity: 1;\n  }\n  100% {\n    fill-opacity: 0;\n    stroke-opacity: 0;\n  }\n}\n\n\n@keyframes lightningFlash {\n  0% {\n    fill-opacity: 0;\n  }\n  1% {\n    fill-opacity: 1;\n  }\n  2% {\n    fill-opacity: 0;\n  }\n  50% {\n    fill-opacity: 0;\n  }\n  51% {\n    fill-opacity: 1;\n  }\n  52% {\n    fill-opacity: 0;\n  }\n  53% {\n    fill-opacity: 1;\n  }\n  54% {\n    fill-opacity: 0;\n  }\n  100% {\n    fill-opacity: 0;\n  }\n}\n\n\n$i: 0;\n$t: 0;\n\n@keyframes snowFall {\n  @while $i <= 100 {\n    #{$i}% {\n      $eq: sin($t);\n      transform: translateY($svgSize * 0.25 * $i * 0.01) translateX(-$eq * ($i - 50) * 1px / 4);\n    }\n    $t: $t + $increase * $animationStep;\n    $i: $i + $animationStep;\n  }\n}\n\n\n$i: 0;\n$t: 0;\n\n@keyframes snowFall2 {\n  @while $i <= 100 {\n    #{$i}% {\n      $eq: sin($t);\n      transform: translateY($svgSize * 0.25 * $i * 0.01) translateX($eq * ($i - 50) * 1px / 4);\n    }\n    $t: $t + $increase * $animationStep;\n    $i: $i + $animationStep;\n  }\n}\n\n\n/* Tornado */\n@keyframes translateTornado1 {\n  0% {\n    transform: translateY(0);\n  }\n  25% {\n    transform: translateX($svgSize * 0.0571);\n  }\n  75% {\n    transform: translateX(-$svgSize * 0.0571);\n  }\n  100% {\n    transform: translateX(0);\n  }\n}\n\n\n@keyframes translateTornado2 {\n  0% {\n    transform: translateY(0);\n  }\n  25% {\n    transform: translateX($svgSize * 0.0286);\n  }\n  75% {\n    transform: translateX(-$svgSize * 0.0286);\n  }\n  100% {\n    transform: translateX(0);\n  }\n}\n\n\n@keyframes translateTornado3 {\n  0% {\n    transform: translateY(0);\n  }\n  25% {\n    transform: translateX($svgSize * 0.1143);\n  }\n  75% {\n    transform: translateX(-$svgSize * 0.1143);\n  }\n  100% {\n    transform: translateX(0);\n  }\n}\n\n\n@keyframes translateTornado4 {\n  0% {\n    transform: translateY(0);\n  }\n  25% {\n    transform: translateX($svgSize * 0.0857);\n  }\n  75% {\n    transform: translateX(-$svgSize * 0.0857);\n  }\n  100% {\n    transform: translateX(0);\n  }\n}\n\n\n@keyframes translateTornado5 {\n  0% {\n    transform: translateY(0);\n  }\n  25% {\n    transform: translateX($svgSize * 0.1429);\n  }\n  75% {\n    transform: translateX(-$svgSize * 0.1429);\n  }\n  100% {\n    transform: translateX(0);\n  }\n}\n\n\n@keyframes translateTornado6 {\n  0% {\n    transform: translateY(0);\n  }\n  25% {\n    transform: translateX($svgSize * 0.0857);\n  }\n  75% {\n    transform: translateX(-$svgSize * 0.0857);\n  }\n  100% {\n    transform: translateX(0);\n  }\n}\n\n\n@keyframes fillOpacityLightning {\n  0% {\n    fill-opacity: 0;\n    stroke-opacity: 0;\n  }\n  1% {\n    fill-opacity: 1;\n    stroke-opacity: 1;\n  }\n  7% {\n    fill-opacity: 0;\n    stroke-opacity: 0;\n  }\n  50% {\n    fill-opacity: 0;\n    stroke-opacity: 0;\n  }\n  51% {\n    fill-opacity: 1;\n    stroke-opacity: 1;\n  }\n  53% {\n    fill-opacity: 0;\n    stroke-opacity: 0;\n  }\n  54% {\n    fill-opacity: 1;\n    stroke-opacity: 1;\n  }\n  60% {\n    fill-opacity: 0;\n    stroke-opacity: 0;\n  }\n  100% {\n    fill-opacity: 0;\n    stroke-opacity: 0;\n  }\n}\n\n\n@keyframes translateFog {\n  0% {\n    transform: translateY(0);\n  }\n  25% {\n    transform: translateX($svgSize * 0.0357);\n  }\n  75% {\n    transform: translateX(-$svgSize * 0.0357);\n  }\n  100% {\n    transform: translateX(0);\n  }\n}\n\n\n@keyframes fillOpacityFog {\n  0% {\n    fill-opacity: 0.5;\n    stroke-opacity: 0.5;\n  }\n  50% {\n    fill-opacity: 1;\n    stroke-opacity: 1;\n  }\n  100% {\n    fill-opacity: 0.5;\n    stroke-opacity: 0.5;\n  }\n}\n\n\n@keyframes translateSunrise {\n  0% {\n    transform: translateY(0);\n  }\n  25% {\n    transform: translateY(-$svgSize * 0.2286);\n  }\n  100% {\n    transform: translateY(-$svgSize * 0.2286);\n  }\n}\n\n\n@keyframes translateSunset {\n  0% {\n    transform: translateY(-$svgSize * 0.2286);\n  }\n  25% {\n    transform: translateY(-$svgSize * 0.0571);\n  }\n  100% {\n    transform: translateY(-$svgSize * 0.0571);\n  }\n}\n\n\n@keyframes translateArrowDown {\n  0% {\n    transform: translateY($svgSize * 0.0286);\n  }\n  100% {\n    transform: translateY($svgSize * 0.0714);\n  }\n}\n\n\n@keyframes translateArrowUp {\n  0% {\n    transform: translateY(-$svgSize * 0.0286);\n  }\n  100% {\n    transform: translateY(-$svgSize * 0.0714);\n  }\n}\n\n\n@keyframes translateWind {\n  0% {\n    transform: translateY(0);\n  }\n  25% {\n    transform: translateX($svgSize * 0.0714);\n  }\n  75% {\n    transform: translateX(-$svgSize * 0.0714);\n  }\n  100% {\n    transform: translateX(0);\n  }\n}","/**\n * @package IcoFont by ThemeHunt - https://themehunt.com\n * @version 1.0.0 Beta\n * @author IcoFont http://icofont.com\n * @copyright Copyright (c) 2018 IcoFont\n * @license - http://icofont.com/license/\n*/\n\n@font-face {\n\tfont-family: 'icofont';\n\tsrc: url('../../../fonts/ico/icofont.eot?v=1.0.0-beta');\n\tsrc: url('../../../fonts/ico/icofont.eot?v=1.0.0-beta#iefix') format(\"embedded-opentype\"), url('../../../fonts/ico/icofont.ttf?v=1.0.0-beta') format(\"truetype\"), url('../../../fonts/ico/icofont.woff?v=1.0.0-beta') format(\"woff\"), url('../../../fonts/ico/icofont.svg?v=1.0.0-beta#icofont') format(\"svg\");\n\tfont-weight: normal;\n\tfont-style: normal;\n}\n\n\n.icofont {\n\tfont-family: 'IcoFont' !important;\n\tspeak: none;\n\tfont-style: normal;\n\tfont-weight: normal;\n\tfont-variant: normal;\n\ttext-transform: none;\n\tline-height: 1;\n\t/* Better Font Rendering =========== */\n\t-webkit-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: grayscale;\n}\n\n.icofont-angry-monster:before {\n\tcontent: \"\\e901\";\n}\n\n.icofont-bathtub:before {\n\tcontent: \"\\e902\";\n}\n\n.icofont-bird-wings:before {\n\tcontent: \"\\e903\";\n}\n\n.icofont-bow:before {\n\tcontent: \"\\e904\";\n}\n\n.icofont-brain-alt:before {\n\tcontent: \"\\e905\";\n}\n\n.icofont-butterfly-alt:before {\n\tcontent: \"\\e906\";\n}\n\n.icofont-castle:before {\n\tcontent: \"\\e907\";\n}\n\n.icofont-circuit:before {\n\tcontent: \"\\e908\";\n}\n\n.icofont-dart:before {\n\tcontent: \"\\e909\";\n}\n\n.icofont-dice-alt:before {\n\tcontent: \"\\e90a\";\n}\n\n.icofont-disability-race:before {\n\tcontent: \"\\e90b\";\n}\n\n.icofont-diving-goggle:before {\n\tcontent: \"\\e90c\";\n}\n\n.icofont-fire-alt:before {\n\tcontent: \"\\e90d\";\n}\n\n.icofont-flame-torch:before {\n\tcontent: \"\\e90e\";\n}\n\n.icofont-flora-flower:before {\n\tcontent: \"\\e90f\";\n}\n\n.icofont-flora:before {\n\tcontent: \"\\e910\";\n}\n\n.icofont-gift-box:before {\n\tcontent: \"\\e911\";\n}\n\n.icofont-halloween-pumpkin:before {\n\tcontent: \"\\e912\";\n}\n\n.icofont-hand-power:before {\n\tcontent: \"\\e913\";\n}\n\n.icofont-hand-thunder:before {\n\tcontent: \"\\e914\";\n}\n\n.icofont-king-crown:before {\n\tcontent: \"\\e915\";\n}\n\n.icofont-king-monster:before {\n\tcontent: \"\\e916\";\n}\n\n.icofont-love:before {\n\tcontent: \"\\e917\";\n}\n\n.icofont-magician-hat:before {\n\tcontent: \"\\e918\";\n}\n\n.icofont-native-american:before {\n\tcontent: \"\\e919\";\n}\n\n.icofont-open-eye:before {\n\tcontent: \"\\e91a\";\n}\n\n.icofont-owl-look:before {\n\tcontent: \"\\e91b\";\n}\n\n.icofont-phoenix:before {\n\tcontent: \"\\e91c\";\n}\n\n.icofont-queen-crown:before {\n\tcontent: \"\\e91d\";\n}\n\n.icofont-robot-face:before {\n\tcontent: \"\\e91e\";\n}\n\n.icofont-sand-clock:before {\n\tcontent: \"\\e91f\";\n}\n\n.icofont-shield-alt:before {\n\tcontent: \"\\e920\";\n}\n\n.icofont-ship-wheel:before {\n\tcontent: \"\\e921\";\n}\n\n.icofont-skull-danger:before {\n\tcontent: \"\\e922\";\n}\n\n.icofont-skull-face:before {\n\tcontent: \"\\e923\";\n}\n\n.icofont-snail:before {\n\tcontent: \"\\e924\";\n}\n\n.icofont-snow-alt:before {\n\tcontent: \"\\e925\";\n}\n\n.icofont-snow-flake:before {\n\tcontent: \"\\e926\";\n}\n\n.icofont-snowmobile:before {\n\tcontent: \"\\e927\";\n}\n\n.icofont-space-shuttle:before {\n\tcontent: \"\\e928\";\n}\n\n.icofont-star-shape:before {\n\tcontent: \"\\e929\";\n}\n\n.icofont-swirl:before {\n\tcontent: \"\\e92a\";\n}\n\n.icofont-tattoo-wing:before {\n\tcontent: \"\\e92b\";\n}\n\n.icofont-throne:before {\n\tcontent: \"\\e92c\";\n}\n\n.icofont-touch:before {\n\tcontent: \"\\e92d\";\n}\n\n.icofont-tree-alt:before {\n\tcontent: \"\\e92e\";\n}\n\n.icofont-triangle:before {\n\tcontent: \"\\e92f\";\n}\n\n.icofont-unity-hand:before {\n\tcontent: \"\\e930\";\n}\n\n.icofont-weed:before {\n\tcontent: \"\\e931\";\n}\n\n.icofont-woman-bird:before {\n\tcontent: \"\\e932\";\n}\n\n.icofont-animal-bat:before {\n\tcontent: \"\\e933\";\n}\n\n.icofont-animal-bear-tracks:before {\n\tcontent: \"\\e934\";\n}\n\n.icofont-animal-bear:before {\n\tcontent: \"\\e935\";\n}\n\n.icofont-animal-bird-alt:before {\n\tcontent: \"\\e936\";\n}\n\n.icofont-animal-bird:before {\n\tcontent: \"\\e937\";\n}\n\n.icofont-animal-bone:before {\n\tcontent: \"\\e938\";\n}\n\n.icofont-animal-bull:before {\n\tcontent: \"\\e939\";\n}\n\n.icofont-animal-camel-alt:before {\n\tcontent: \"\\e93a\";\n}\n\n.icofont-animal-camel-head:before {\n\tcontent: \"\\e93b\";\n}\n\n.icofont-animal-camel:before {\n\tcontent: \"\\e93c\";\n}\n\n.icofont-animal-cat-alt-1:before {\n\tcontent: \"\\e93d\";\n}\n\n.icofont-animal-cat-alt-2:before {\n\tcontent: \"\\e93e\";\n}\n\n.icofont-animal-cat-alt-3:before {\n\tcontent: \"\\e93f\";\n}\n\n.icofont-animal-cat-alt-4:before {\n\tcontent: \"\\e940\";\n}\n\n.icofont-animal-cat-with-dog:before {\n\tcontent: \"\\e941\";\n}\n\n.icofont-animal-cat:before {\n\tcontent: \"\\e942\";\n}\n\n.icofont-animal-cow-head:before {\n\tcontent: \"\\e943\";\n}\n\n.icofont-animal-cow:before {\n\tcontent: \"\\e944\";\n}\n\n.icofont-animal-crab:before {\n\tcontent: \"\\e945\";\n}\n\n.icofont-animal-crocodile:before {\n\tcontent: \"\\e946\";\n}\n\n.icofont-animal-deer-head:before {\n\tcontent: \"\\e947\";\n}\n\n.icofont-animal-dog-alt:before {\n\tcontent: \"\\e948\";\n}\n\n.icofont-animal-dog-barking:before {\n\tcontent: \"\\e949\";\n}\n\n.icofont-animal-dog:before {\n\tcontent: \"\\e94a\";\n}\n\n.icofont-animal-dolphin:before {\n\tcontent: \"\\e94b\";\n}\n\n.icofont-animal-duck-tracks:before {\n\tcontent: \"\\e94c\";\n}\n\n.icofont-animal-eagle-head:before {\n\tcontent: \"\\e94d\";\n}\n\n.icofont-animal-eaten-fish:before {\n\tcontent: \"\\e94e\";\n}\n\n.icofont-animal-elephant-alt:before {\n\tcontent: \"\\e94f\";\n}\n\n.icofont-animal-elephant-head-alt:before {\n\tcontent: \"\\e950\";\n}\n\n.icofont-animal-elephant-head:before {\n\tcontent: \"\\e951\";\n}\n\n.icofont-animal-elephant:before {\n\tcontent: \"\\e952\";\n}\n\n.icofont-animal-elk:before {\n\tcontent: \"\\e953\";\n}\n\n.icofont-animal-fish-alt-1:before {\n\tcontent: \"\\e954\";\n}\n\n.icofont-animal-fish-alt-2:before {\n\tcontent: \"\\e955\";\n}\n\n.icofont-animal-fish-alt-3:before {\n\tcontent: \"\\e956\";\n}\n\n.icofont-animal-fish-alt-4:before {\n\tcontent: \"\\e957\";\n}\n\n.icofont-animal-fish:before {\n\tcontent: \"\\e958\";\n}\n\n.icofont-animal-fox-alt:before {\n\tcontent: \"\\e959\";\n}\n\n.icofont-animal-fox:before {\n\tcontent: \"\\e95a\";\n}\n\n.icofont-animal-frog-tracks:before {\n\tcontent: \"\\e95b\";\n}\n\n.icofont-animal-frog:before {\n\tcontent: \"\\e95c\";\n}\n\n.icofont-animal-froggy:before {\n\tcontent: \"\\e95d\";\n}\n\n.icofont-animal-giraffe-alt:before {\n\tcontent: \"\\e95e\";\n}\n\n.icofont-animal-giraffe:before {\n\tcontent: \"\\e95f\";\n}\n\n.icofont-animal-goat-head-alt-1:before {\n\tcontent: \"\\e960\";\n}\n\n.icofont-animal-goat-head-alt-2:before {\n\tcontent: \"\\e961\";\n}\n\n.icofont-animal-goat-head:before {\n\tcontent: \"\\e962\";\n}\n\n.icofont-animal-gorilla:before {\n\tcontent: \"\\e963\";\n}\n\n.icofont-animal-hen-tracks:before {\n\tcontent: \"\\e964\";\n}\n\n.icofont-animal-horse-head-alt-1:before {\n\tcontent: \"\\e965\";\n}\n\n.icofont-animal-horse-head-alt-2:before {\n\tcontent: \"\\e966\";\n}\n\n.icofont-animal-horse-head:before {\n\tcontent: \"\\e967\";\n}\n\n.icofont-animal-horse-tracks:before {\n\tcontent: \"\\e968\";\n}\n\n.icofont-animal-jellyfish:before {\n\tcontent: \"\\e969\";\n}\n\n.icofont-animal-kangaroo:before {\n\tcontent: \"\\e96a\";\n}\n\n.icofont-animal-lemur:before {\n\tcontent: \"\\e96b\";\n}\n\n.icofont-animal-lion-alt:before {\n\tcontent: \"\\e96c\";\n}\n\n.icofont-animal-lion-head-alt:before {\n\tcontent: \"\\e96d\";\n}\n\n.icofont-animal-lion-head:before {\n\tcontent: \"\\e96e\";\n}\n\n.icofont-animal-lion:before {\n\tcontent: \"\\e96f\";\n}\n\n.icofont-animal-monkey-alt-1:before {\n\tcontent: \"\\e970\";\n}\n\n.icofont-animal-monkey-alt-2:before {\n\tcontent: \"\\e971\";\n}\n\n.icofont-animal-monkey-alt-3:before {\n\tcontent: \"\\e972\";\n}\n\n.icofont-animal-monkey:before {\n\tcontent: \"\\e973\";\n}\n\n.icofont-animal-octopus-alt:before {\n\tcontent: \"\\e974\";\n}\n\n.icofont-animal-octopus:before {\n\tcontent: \"\\e975\";\n}\n\n.icofont-animal-owl:before {\n\tcontent: \"\\e976\";\n}\n\n.icofont-animal-panda-alt:before {\n\tcontent: \"\\e977\";\n}\n\n.icofont-animal-panda:before {\n\tcontent: \"\\e978\";\n}\n\n.icofont-animal-panther:before {\n\tcontent: \"\\e979\";\n}\n\n.icofont-animal-parrot-lip:before {\n\tcontent: \"\\e97a\";\n}\n\n.icofont-animal-parrot:before {\n\tcontent: \"\\e97b\";\n}\n\n.icofont-animal-paw:before {\n\tcontent: \"\\e97c\";\n}\n\n.icofont-animal-pelican:before {\n\tcontent: \"\\e97d\";\n}\n\n.icofont-animal-penguin:before {\n\tcontent: \"\\e97e\";\n}\n\n.icofont-animal-pig-alt:before {\n\tcontent: \"\\e97f\";\n}\n\n.icofont-animal-pig:before {\n\tcontent: \"\\e980\";\n}\n\n.icofont-animal-pigeon-alt:before {\n\tcontent: \"\\e981\";\n}\n\n.icofont-animal-pigeon:before {\n\tcontent: \"\\e982\";\n}\n\n.icofont-animal-pigeons:before {\n\tcontent: \"\\e983\";\n}\n\n.icofont-animal-rabbit-running:before {\n\tcontent: \"\\e984\";\n}\n\n.icofont-animal-rat-alt:before {\n\tcontent: \"\\e985\";\n}\n\n.icofont-animal-rhino-head:before {\n\tcontent: \"\\e986\";\n}\n\n.icofont-animal-rhino:before {\n\tcontent: \"\\e987\";\n}\n\n.icofont-animal-rooster:before {\n\tcontent: \"\\e988\";\n}\n\n.icofont-animal-seahorse:before {\n\tcontent: \"\\e989\";\n}\n\n.icofont-animal-seal:before {\n\tcontent: \"\\e98a\";\n}\n\n.icofont-animal-shrimp:before {\n\tcontent: \"\\e98b\";\n}\n\n.icofont-animal-snail-alt-1:before {\n\tcontent: \"\\e98c\";\n}\n\n.icofont-animal-snail-alt-2:before {\n\tcontent: \"\\e98d\";\n}\n\n.icofont-animal-snail:before {\n\tcontent: \"\\e98e\";\n}\n\n.icofont-animal-snake:before {\n\tcontent: \"\\e98f\";\n}\n\n.icofont-animal-squid:before {\n\tcontent: \"\\e990\";\n}\n\n.icofont-animal-squirrel:before {\n\tcontent: \"\\e991\";\n}\n\n.icofont-animal-tiger-alt:before {\n\tcontent: \"\\e992\";\n}\n\n.icofont-animal-tiger:before {\n\tcontent: \"\\e993\";\n}\n\n.icofont-animal-turtle:before {\n\tcontent: \"\\e994\";\n}\n\n.icofont-animal-whale:before {\n\tcontent: \"\\e995\";\n}\n\n.icofont-animal-woodpecker:before {\n\tcontent: \"\\e996\";\n}\n\n.icofont-animal-zebra:before {\n\tcontent: \"\\e997\";\n}\n\n.icofont-brand-acer:before {\n\tcontent: \"\\e998\";\n}\n\n.icofont-brand-adidas:before {\n\tcontent: \"\\e999\";\n}\n\n.icofont-brand-adobe:before {\n\tcontent: \"\\e99a\";\n}\n\n.icofont-brand-air-new-zealand:before {\n\tcontent: \"\\e99b\";\n}\n\n.icofont-brand-airbnb:before {\n\tcontent: \"\\e99c\";\n}\n\n.icofont-brand-aircell:before {\n\tcontent: \"\\e99d\";\n}\n\n.icofont-brand-airtel:before {\n\tcontent: \"\\e99e\";\n}\n\n.icofont-brand-alcatel:before {\n\tcontent: \"\\e99f\";\n}\n\n.icofont-brand-alibaba:before {\n\tcontent: \"\\e9a0\";\n}\n\n.icofont-brand-aliexpress:before {\n\tcontent: \"\\e9a1\";\n}\n\n.icofont-brand-alipay:before {\n\tcontent: \"\\e9a2\";\n}\n\n.icofont-brand-amazon:before {\n\tcontent: \"\\e9a3\";\n}\n\n.icofont-brand-amd:before {\n\tcontent: \"\\e9a4\";\n}\n\n.icofont-brand-american-airlines:before {\n\tcontent: \"\\e9a5\";\n}\n\n.icofont-brand-android-robot:before {\n\tcontent: \"\\e9a6\";\n}\n\n.icofont-brand-android:before {\n\tcontent: \"\\e9a7\";\n}\n\n.icofont-brand-aol:before {\n\tcontent: \"\\e9a8\";\n}\n\n.icofont-brand-apple:before {\n\tcontent: \"\\e9a9\";\n}\n\n.icofont-brand-appstore:before {\n\tcontent: \"\\e9aa\";\n}\n\n.icofont-brand-asus:before {\n\tcontent: \"\\e9ab\";\n}\n\n.icofont-brand-ati:before {\n\tcontent: \"\\e9ac\";\n}\n\n.icofont-brand-att:before {\n\tcontent: \"\\e9ad\";\n}\n\n.icofont-brand-audi:before {\n\tcontent: \"\\e9ae\";\n}\n\n.icofont-brand-axiata:before {\n\tcontent: \"\\e9af\";\n}\n\n.icofont-brand-bada:before {\n\tcontent: \"\\e9b0\";\n}\n\n.icofont-brand-bbc:before {\n\tcontent: \"\\e9b1\";\n}\n\n.icofont-brand-bing:before {\n\tcontent: \"\\e9b2\";\n}\n\n.icofont-brand-blackberry:before {\n\tcontent: \"\\e9b3\";\n}\n\n.icofont-brand-bmw:before {\n\tcontent: \"\\e9b4\";\n}\n\n.icofont-brand-box:before {\n\tcontent: \"\\e9b5\";\n}\n\n.icofont-brand-burger-king:before {\n\tcontent: \"\\e9b6\";\n}\n\n.icofont-brand-business-insider:before {\n\tcontent: \"\\e9b7\";\n}\n\n.icofont-brand-buzzfeed:before {\n\tcontent: \"\\e9b8\";\n}\n\n.icofont-brand-cannon:before {\n\tcontent: \"\\e9b9\";\n}\n\n.icofont-brand-casio:before {\n\tcontent: \"\\e9ba\";\n}\n\n.icofont-brand-china-mobile:before {\n\tcontent: \"\\e9bb\";\n}\n\n.icofont-brand-china-telecom:before {\n\tcontent: \"\\e9bc\";\n}\n\n.icofont-brand-china-unicom:before {\n\tcontent: \"\\e9bd\";\n}\n\n.icofont-brand-cisco:before {\n\tcontent: \"\\e9be\";\n}\n\n.icofont-brand-citibank:before {\n\tcontent: \"\\e9bf\";\n}\n\n.icofont-brand-cnet:before {\n\tcontent: \"\\e9c0\";\n}\n\n.icofont-brand-cnn:before {\n\tcontent: \"\\e9c1\";\n}\n\n.icofont-brand-cocal-cola:before {\n\tcontent: \"\\e9c2\";\n}\n\n.icofont-brand-compaq:before {\n\tcontent: \"\\e9c3\";\n}\n\n.icofont-brand-copy:before {\n\tcontent: \"\\e9c4\";\n}\n\n.icofont-brand-debian:before {\n\tcontent: \"\\e9c5\";\n}\n\n.icofont-brand-delicious:before {\n\tcontent: \"\\e9c6\";\n}\n\n.icofont-brand-dell:before {\n\tcontent: \"\\e9c7\";\n}\n\n.icofont-brand-designbump:before {\n\tcontent: \"\\e9c8\";\n}\n\n.icofont-brand-designfloat:before {\n\tcontent: \"\\e9c9\";\n}\n\n.icofont-brand-disney:before {\n\tcontent: \"\\e9ca\";\n}\n\n.icofont-brand-dodge:before {\n\tcontent: \"\\e9cb\";\n}\n\n.icofont-brand-dove:before {\n\tcontent: \"\\e9cc\";\n}\n\n.icofont-brand-ebay:before {\n\tcontent: \"\\e9cd\";\n}\n\n.icofont-brand-eleven:before {\n\tcontent: \"\\e9ce\";\n}\n\n.icofont-brand-emirates:before {\n\tcontent: \"\\e9cf\";\n}\n\n.icofont-brand-espn:before {\n\tcontent: \"\\e9d0\";\n}\n\n.icofont-brand-etihad-airways:before {\n\tcontent: \"\\e9d1\";\n}\n\n.icofont-brand-etisalat:before {\n\tcontent: \"\\e9d2\";\n}\n\n.icofont-brand-etsy:before {\n\tcontent: \"\\e9d3\";\n}\n\n.icofont-brand-facebook:before {\n\tcontent: \"\\e9d4\";\n}\n\n.icofont-brand-fastrack:before {\n\tcontent: \"\\e9d5\";\n}\n\n.icofont-brand-fedex:before {\n\tcontent: \"\\e9d6\";\n}\n\n.icofont-brand-ferrari:before {\n\tcontent: \"\\e9d7\";\n}\n\n.icofont-brand-fitbit:before {\n\tcontent: \"\\e9d8\";\n}\n\n.icofont-brand-flikr:before {\n\tcontent: \"\\e9d9\";\n}\n\n.icofont-brand-forbes:before {\n\tcontent: \"\\e9da\";\n}\n\n.icofont-brand-foursquare:before {\n\tcontent: \"\\e9db\";\n}\n\n.icofont-brand-fox:before {\n\tcontent: \"\\e9dc\";\n}\n\n.icofont-brand-foxconn:before {\n\tcontent: \"\\e9dd\";\n}\n\n.icofont-brand-fujitsu:before {\n\tcontent: \"\\e9de\";\n}\n\n.icofont-brand-general-electric:before {\n\tcontent: \"\\e9df\";\n}\n\n.icofont-brand-gillette:before {\n\tcontent: \"\\e9e0\";\n}\n\n.icofont-brand-gizmodo:before {\n\tcontent: \"\\e9e1\";\n}\n\n.icofont-brand-gnome:before {\n\tcontent: \"\\e9e2\";\n}\n\n.icofont-brand-google:before {\n\tcontent: \"\\e9e3\";\n}\n\n.icofont-brand-gopro:before {\n\tcontent: \"\\e9e4\";\n}\n\n.icofont-brand-gucci:before {\n\tcontent: \"\\e9e5\";\n}\n\n.icofont-brand-hallmark:before {\n\tcontent: \"\\e9e6\";\n}\n\n.icofont-brand-hi5:before {\n\tcontent: \"\\e9e7\";\n}\n\n.icofont-brand-honda:before {\n\tcontent: \"\\e9e8\";\n}\n\n.icofont-brand-hp:before {\n\tcontent: \"\\e9e9\";\n}\n\n.icofont-brand-hsbc:before {\n\tcontent: \"\\e9ea\";\n}\n\n.icofont-brand-htc:before {\n\tcontent: \"\\e9eb\";\n}\n\n.icofont-brand-huawei:before {\n\tcontent: \"\\e9ec\";\n}\n\n.icofont-brand-hulu:before {\n\tcontent: \"\\e9ed\";\n}\n\n.icofont-brand-hyundai:before {\n\tcontent: \"\\e9ee\";\n}\n\n.icofont-brand-ibm:before {\n\tcontent: \"\\e9ef\";\n}\n\n.icofont-brand-icofont:before {\n\tcontent: \"\\e9f0\";\n}\n\n.icofont-brand-icq:before {\n\tcontent: \"\\e9f1\";\n}\n\n.icofont-brand-ikea:before {\n\tcontent: \"\\e9f2\";\n}\n\n.icofont-brand-imdb:before {\n\tcontent: \"\\e9f3\";\n}\n\n.icofont-brand-indiegogo:before {\n\tcontent: \"\\e9f4\";\n}\n\n.icofont-brand-intel:before {\n\tcontent: \"\\e9f5\";\n}\n\n.icofont-brand-ipair:before {\n\tcontent: \"\\e9f6\";\n}\n\n.icofont-brand-jaguar:before {\n\tcontent: \"\\e9f7\";\n}\n\n.icofont-brand-java:before {\n\tcontent: \"\\e9f8\";\n}\n\n.icofont-brand-joomshaper:before {\n\tcontent: \"\\e9f9\";\n}\n\n.icofont-brand-kickstarter:before {\n\tcontent: \"\\e9fa\";\n}\n\n.icofont-brand-kik:before {\n\tcontent: \"\\e9fb\";\n}\n\n.icofont-brand-lastfm:before {\n\tcontent: \"\\e9fc\";\n}\n\n.icofont-brand-lego:before {\n\tcontent: \"\\e9fd\";\n}\n\n.icofont-brand-lenovo:before {\n\tcontent: \"\\e9fe\";\n}\n\n.icofont-brand-levis:before {\n\tcontent: \"\\e9ff\";\n}\n\n.icofont-brand-lexus:before {\n\tcontent: \"\\ea00\";\n}\n\n.icofont-brand-lg:before {\n\tcontent: \"\\ea01\";\n}\n\n.icofont-brand-life-hacker:before {\n\tcontent: \"\\ea02\";\n}\n\n.icofont-brand-line-messenger:before {\n\tcontent: \"\\ea03\";\n}\n\n.icofont-brand-linkedin:before {\n\tcontent: \"\\ea04\";\n}\n\n.icofont-brand-linux-mint:before {\n\tcontent: \"\\ea05\";\n}\n\n.icofont-brand-linux:before {\n\tcontent: \"\\ea06\";\n}\n\n.icofont-brand-lionix:before {\n\tcontent: \"\\ea07\";\n}\n\n.icofont-brand-live-messenger:before {\n\tcontent: \"\\ea08\";\n}\n\n.icofont-brand-loreal:before {\n\tcontent: \"\\ea09\";\n}\n\n.icofont-brand-louis-vuitton:before {\n\tcontent: \"\\ea0a\";\n}\n\n.icofont-brand-mac-os:before {\n\tcontent: \"\\ea0b\";\n}\n\n.icofont-brand-marvel-app:before {\n\tcontent: \"\\ea0c\";\n}\n\n.icofont-brand-mashable:before {\n\tcontent: \"\\ea0d\";\n}\n\n.icofont-brand-mazda:before {\n\tcontent: \"\\ea0e\";\n}\n\n.icofont-brand-mcdonals:before {\n\tcontent: \"\\ea0f\";\n}\n\n.icofont-brand-mercedes:before {\n\tcontent: \"\\ea10\";\n}\n\n.icofont-brand-micromax:before {\n\tcontent: \"\\ea11\";\n}\n\n.icofont-brand-microsoft:before {\n\tcontent: \"\\ea12\";\n}\n\n.icofont-brand-mobileme:before {\n\tcontent: \"\\ea13\";\n}\n\n.icofont-brand-mobily:before {\n\tcontent: \"\\ea14\";\n}\n\n.icofont-brand-motorola:before {\n\tcontent: \"\\ea15\";\n}\n\n.icofont-brand-msi:before {\n\tcontent: \"\\ea16\";\n}\n\n.icofont-brand-mts:before {\n\tcontent: \"\\ea17\";\n}\n\n.icofont-brand-myspace:before {\n\tcontent: \"\\ea18\";\n}\n\n.icofont-brand-mytv:before {\n\tcontent: \"\\ea19\";\n}\n\n.icofont-brand-nasa:before {\n\tcontent: \"\\ea1a\";\n}\n\n.icofont-brand-natgeo:before {\n\tcontent: \"\\ea1b\";\n}\n\n.icofont-brand-nbc:before {\n\tcontent: \"\\ea1c\";\n}\n\n.icofont-brand-nescafe:before {\n\tcontent: \"\\ea1d\";\n}\n\n.icofont-brand-nestle:before {\n\tcontent: \"\\ea1e\";\n}\n\n.icofont-brand-netflix:before {\n\tcontent: \"\\ea1f\";\n}\n\n.icofont-brand-nexus:before {\n\tcontent: \"\\ea20\";\n}\n\n.icofont-brand-nike:before {\n\tcontent: \"\\ea21\";\n}\n\n.icofont-brand-nokia:before {\n\tcontent: \"\\ea22\";\n}\n\n.icofont-brand-nvidia:before {\n\tcontent: \"\\ea23\";\n}\n\n.icofont-brand-omega:before {\n\tcontent: \"\\ea24\";\n}\n\n.icofont-brand-opensuse:before {\n\tcontent: \"\\ea25\";\n}\n\n.icofont-brand-oracle:before {\n\tcontent: \"\\ea26\";\n}\n\n.icofont-brand-panasonic:before {\n\tcontent: \"\\ea27\";\n}\n\n.icofont-brand-paypal:before {\n\tcontent: \"\\ea28\";\n}\n\n.icofont-brand-pepsi:before {\n\tcontent: \"\\ea29\";\n}\n\n.icofont-brand-philips:before {\n\tcontent: \"\\ea2a\";\n}\n\n.icofont-brand-pizza-hut:before {\n\tcontent: \"\\ea2b\";\n}\n\n.icofont-brand-playstation:before {\n\tcontent: \"\\ea2c\";\n}\n\n.icofont-brand-puma:before {\n\tcontent: \"\\ea2d\";\n}\n\n.icofont-brand-qatar-air:before {\n\tcontent: \"\\ea2e\";\n}\n\n.icofont-brand-qvc:before {\n\tcontent: \"\\ea2f\";\n}\n\n.icofont-brand-readernaut:before {\n\tcontent: \"\\ea30\";\n}\n\n.icofont-brand-redbull:before {\n\tcontent: \"\\ea31\";\n}\n\n.icofont-brand-reebok:before {\n\tcontent: \"\\ea32\";\n}\n\n.icofont-brand-reuters:before {\n\tcontent: \"\\ea33\";\n}\n\n.icofont-brand-samsung:before {\n\tcontent: \"\\ea34\";\n}\n\n.icofont-brand-sap:before {\n\tcontent: \"\\ea35\";\n}\n\n.icofont-brand-saudia-airlines:before {\n\tcontent: \"\\ea36\";\n}\n\n.icofont-brand-scribd:before {\n\tcontent: \"\\ea37\";\n}\n\n.icofont-brand-shell:before {\n\tcontent: \"\\ea38\";\n}\n\n.icofont-brand-siemens:before {\n\tcontent: \"\\ea39\";\n}\n\n.icofont-brand-sk-telecom:before {\n\tcontent: \"\\ea3a\";\n}\n\n.icofont-brand-slideshare:before {\n\tcontent: \"\\ea3b\";\n}\n\n.icofont-brand-smashing-magazine:before {\n\tcontent: \"\\ea3c\";\n}\n\n.icofont-brand-snapchat:before {\n\tcontent: \"\\ea3d\";\n}\n\n.icofont-brand-sony-ericsson:before {\n\tcontent: \"\\ea3e\";\n}\n\n.icofont-brand-sony:before {\n\tcontent: \"\\ea3f\";\n}\n\n.icofont-brand-soundcloud:before {\n\tcontent: \"\\ea40\";\n}\n\n.icofont-brand-sprint:before {\n\tcontent: \"\\ea41\";\n}\n\n.icofont-brand-squidoo:before {\n\tcontent: \"\\ea42\";\n}\n\n.icofont-brand-starbucks:before {\n\tcontent: \"\\ea43\";\n}\n\n.icofont-brand-stc:before {\n\tcontent: \"\\ea44\";\n}\n\n.icofont-brand-steam:before {\n\tcontent: \"\\ea45\";\n}\n\n.icofont-brand-suzuki:before {\n\tcontent: \"\\ea46\";\n}\n\n.icofont-brand-symbian:before {\n\tcontent: \"\\ea47\";\n}\n\n.icofont-brand-t-mobile:before {\n\tcontent: \"\\ea48\";\n}\n\n.icofont-brand-tango:before {\n\tcontent: \"\\ea49\";\n}\n\n.icofont-brand-target:before {\n\tcontent: \"\\ea4a\";\n}\n\n.icofont-brand-tata-indicom:before {\n\tcontent: \"\\ea4b\";\n}\n\n.icofont-brand-techcrunch:before {\n\tcontent: \"\\ea4c\";\n}\n\n.icofont-brand-telenor:before {\n\tcontent: \"\\ea4d\";\n}\n\n.icofont-brand-teliasonera:before {\n\tcontent: \"\\ea4e\";\n}\n\n.icofont-brand-tesla:before {\n\tcontent: \"\\ea4f\";\n}\n\n.icofont-brand-the-verge:before {\n\tcontent: \"\\ea50\";\n}\n\n.icofont-brand-thenextweb:before {\n\tcontent: \"\\ea51\";\n}\n\n.icofont-brand-toshiba:before {\n\tcontent: \"\\ea52\";\n}\n\n.icofont-brand-toyota:before {\n\tcontent: \"\\ea53\";\n}\n\n.icofont-brand-tribenet:before {\n\tcontent: \"\\ea54\";\n}\n\n.icofont-brand-ubuntu:before {\n\tcontent: \"\\ea55\";\n}\n\n.icofont-brand-unilever:before {\n\tcontent: \"\\ea56\";\n}\n\n.icofont-brand-vaio:before {\n\tcontent: \"\\ea57\";\n}\n\n.icofont-brand-verizon:before {\n\tcontent: \"\\ea58\";\n}\n\n.icofont-brand-viber:before {\n\tcontent: \"\\ea59\";\n}\n\n.icofont-brand-vodafone:before {\n\tcontent: \"\\ea5a\";\n}\n\n.icofont-brand-volkswagen:before {\n\tcontent: \"\\ea5b\";\n}\n\n.icofont-brand-walmart:before {\n\tcontent: \"\\ea5c\";\n}\n\n.icofont-brand-warnerbros:before {\n\tcontent: \"\\ea5d\";\n}\n\n.icofont-brand-whatsapp:before {\n\tcontent: \"\\ea5e\";\n}\n\n.icofont-brand-wikipedia:before {\n\tcontent: \"\\ea5f\";\n}\n\n.icofont-brand-windows:before {\n\tcontent: \"\\ea60\";\n}\n\n.icofont-brand-wire:before {\n\tcontent: \"\\ea61\";\n}\n\n.icofont-brand-yahoobuzz:before {\n\tcontent: \"\\ea62\";\n}\n\n.icofont-brand-yamaha:before {\n\tcontent: \"\\ea63\";\n}\n\n.icofont-brand-youtube:before {\n\tcontent: \"\\ea64\";\n}\n\n.icofont-brand-zain:before {\n\tcontent: \"\\ea65\";\n}\n\n.icofont-bank-alt:before {\n\tcontent: \"\\ea66\";\n}\n\n.icofont-barcode:before {\n\tcontent: \"\\ea67\";\n}\n\n.icofont-basket:before {\n\tcontent: \"\\ea68\";\n}\n\n.icofont-bill-alt:before {\n\tcontent: \"\\ea69\";\n}\n\n.icofont-billboard:before {\n\tcontent: \"\\ea6a\";\n}\n\n.icofont-briefcase-alt-1:before {\n\tcontent: \"\\ea6b\";\n}\n\n.icofont-briefcase-alt-2:before {\n\tcontent: \"\\ea6c\";\n}\n\n.icofont-building-alt:before {\n\tcontent: \"\\ea6d\";\n}\n\n.icofont-businessman:before {\n\tcontent: \"\\ea6e\";\n}\n\n.icofont-businesswoman:before {\n\tcontent: \"\\ea6f\";\n}\n\n.icofont-cart-alt:before {\n\tcontent: \"\\ea70\";\n}\n\n.icofont-chair:before {\n\tcontent: \"\\ea71\";\n}\n\n.icofont-clip:before {\n\tcontent: \"\\ea72\";\n}\n\n.icofont-coins:before {\n\tcontent: \"\\ea73\";\n}\n\n.icofont-company:before {\n\tcontent: \"\\ea74\";\n}\n\n.icofont-contact-add:before {\n\tcontent: \"\\ea75\";\n}\n\n.icofont-deal:before {\n\tcontent: \"\\ea76\";\n}\n\n.icofont-files:before {\n\tcontent: \"\\ea77\";\n}\n\n.icofont-growth:before {\n\tcontent: \"\\ea78\";\n}\n\n.icofont-id-card:before {\n\tcontent: \"\\ea79\";\n}\n\n.icofont-idea:before {\n\tcontent: \"\\ea7a\";\n}\n\n.icofont-list:before {\n\tcontent: \"\\ea7b\";\n}\n\n.icofont-meeting-add:before {\n\tcontent: \"\\ea7c\";\n}\n\n.icofont-money-bag:before {\n\tcontent: \"\\ea7d\";\n}\n\n.icofont-people:before {\n\tcontent: \"\\ea7e\";\n}\n\n.icofont-pie-chart:before {\n\tcontent: \"\\ea7f\";\n}\n\n.icofont-presentation-alt:before {\n\tcontent: \"\\ea80\";\n}\n\n.icofont-stamp:before {\n\tcontent: \"\\ea81\";\n}\n\n.icofont-stock-mobile:before {\n\tcontent: \"\\ea82\";\n}\n\n.icofont-support:before {\n\tcontent: \"\\ea83\";\n}\n\n.icofont-tasks-alt:before {\n\tcontent: \"\\ea84\";\n}\n\n.icofont-wheel:before {\n\tcontent: \"\\ea85\";\n}\n\n.icofont-chart-arrows-axis:before {\n\tcontent: \"\\ea86\";\n}\n\n.icofont-chart-bar-graph:before {\n\tcontent: \"\\ea87\";\n}\n\n.icofont-chart-flow-alt-1:before {\n\tcontent: \"\\ea88\";\n}\n\n.icofont-chart-flow-alt-2:before {\n\tcontent: \"\\ea89\";\n}\n\n.icofont-chart-flow:before {\n\tcontent: \"\\ea8a\";\n}\n\n.icofont-chart-histogram-alt:before {\n\tcontent: \"\\ea8b\";\n}\n\n.icofont-chart-histogram:before {\n\tcontent: \"\\ea8c\";\n}\n\n.icofont-chart-line-alt:before {\n\tcontent: \"\\ea8d\";\n}\n\n.icofont-chart-line:before {\n\tcontent: \"\\ea8e\";\n}\n\n.icofont-chart-pie-alt:before {\n\tcontent: \"\\ea8f\";\n}\n\n.icofont-chart-pie:before {\n\tcontent: \"\\ea90\";\n}\n\n.icofont-chart-radar-graph:before {\n\tcontent: \"\\ea91\";\n}\n\n.icofont-cur-afghani-false:before {\n\tcontent: \"\\ea92\";\n}\n\n.icofont-cur-afghani-minus:before {\n\tcontent: \"\\ea93\";\n}\n\n.icofont-cur-afghani-plus:before {\n\tcontent: \"\\ea94\";\n}\n\n.icofont-cur-afghani-true:before {\n\tcontent: \"\\ea95\";\n}\n\n.icofont-cur-afghani:before {\n\tcontent: \"\\ea96\";\n}\n\n.icofont-cur-baht-false:before {\n\tcontent: \"\\ea97\";\n}\n\n.icofont-cur-baht-minus:before {\n\tcontent: \"\\ea98\";\n}\n\n.icofont-cur-baht-plus:before {\n\tcontent: \"\\ea99\";\n}\n\n.icofont-cur-baht-true:before {\n\tcontent: \"\\ea9a\";\n}\n\n.icofont-cur-baht:before {\n\tcontent: \"\\ea9b\";\n}\n\n.icofont-cur-bitcoin-false:before {\n\tcontent: \"\\ea9c\";\n}\n\n.icofont-cur-bitcoin-minus:before {\n\tcontent: \"\\ea9d\";\n}\n\n.icofont-cur-bitcoin-plus:before {\n\tcontent: \"\\ea9e\";\n}\n\n.icofont-cur-bitcoin-true:before {\n\tcontent: \"\\ea9f\";\n}\n\n.icofont-cur-bitcoin:before {\n\tcontent: \"\\eaa0\";\n}\n\n.icofont-cur-dollar-flase:before {\n\tcontent: \"\\eaa1\";\n}\n\n.icofont-cur-dollar-minus:before {\n\tcontent: \"\\eaa2\";\n}\n\n.icofont-cur-dollar-plus:before {\n\tcontent: \"\\eaa3\";\n}\n\n.icofont-cur-dollar-true:before {\n\tcontent: \"\\eaa4\";\n}\n\n.icofont-cur-dollar:before {\n\tcontent: \"\\eaa5\";\n}\n\n.icofont-cur-dong-false:before {\n\tcontent: \"\\eaa6\";\n}\n\n.icofont-cur-dong-minus:before {\n\tcontent: \"\\eaa7\";\n}\n\n.icofont-cur-dong-plus:before {\n\tcontent: \"\\eaa8\";\n}\n\n.icofont-cur-dong-true:before {\n\tcontent: \"\\eaa9\";\n}\n\n.icofont-cur-dong:before {\n\tcontent: \"\\eaaa\";\n}\n\n.icofont-cur-euro-false:before {\n\tcontent: \"\\eaab\";\n}\n\n.icofont-cur-euro-minus:before {\n\tcontent: \"\\eaac\";\n}\n\n.icofont-cur-euro-plus:before {\n\tcontent: \"\\eaad\";\n}\n\n.icofont-cur-euro-true:before {\n\tcontent: \"\\eaae\";\n}\n\n.icofont-cur-euro:before {\n\tcontent: \"\\eaaf\";\n}\n\n.icofont-cur-frank-false:before {\n\tcontent: \"\\eab0\";\n}\n\n.icofont-cur-frank-minus:before {\n\tcontent: \"\\eab1\";\n}\n\n.icofont-cur-frank-plus:before {\n\tcontent: \"\\eab2\";\n}\n\n.icofont-cur-frank-true:before {\n\tcontent: \"\\eab3\";\n}\n\n.icofont-cur-frank:before {\n\tcontent: \"\\eab4\";\n}\n\n.icofont-cur-hryvnia-false:before {\n\tcontent: \"\\eab5\";\n}\n\n.icofont-cur-hryvnia-minus:before {\n\tcontent: \"\\eab6\";\n}\n\n.icofont-cur-hryvnia-plus:before {\n\tcontent: \"\\eab7\";\n}\n\n.icofont-cur-hryvnia-true:before {\n\tcontent: \"\\eab8\";\n}\n\n.icofont-cur-hryvnia:before {\n\tcontent: \"\\eab9\";\n}\n\n.icofont-cur-lira-false:before {\n\tcontent: \"\\eaba\";\n}\n\n.icofont-cur-lira-minus:before {\n\tcontent: \"\\eabb\";\n}\n\n.icofont-cur-lira-plus:before {\n\tcontent: \"\\eabc\";\n}\n\n.icofont-cur-lira-true:before {\n\tcontent: \"\\eabd\";\n}\n\n.icofont-cur-lira:before {\n\tcontent: \"\\eabe\";\n}\n\n.icofont-cur-peseta-false:before {\n\tcontent: \"\\eabf\";\n}\n\n.icofont-cur-peseta-minus:before {\n\tcontent: \"\\eac0\";\n}\n\n.icofont-cur-peseta-plus:before {\n\tcontent: \"\\eac1\";\n}\n\n.icofont-cur-peseta-true:before {\n\tcontent: \"\\eac2\";\n}\n\n.icofont-cur-peseta:before {\n\tcontent: \"\\eac3\";\n}\n\n.icofont-cur-peso-false:before {\n\tcontent: \"\\eac4\";\n}\n\n.icofont-cur-peso-minus:before {\n\tcontent: \"\\eac5\";\n}\n\n.icofont-cur-peso-plus:before {\n\tcontent: \"\\eac6\";\n}\n\n.icofont-cur-peso-true:before {\n\tcontent: \"\\eac7\";\n}\n\n.icofont-cur-peso:before {\n\tcontent: \"\\eac8\";\n}\n\n.icofont-cur-pound-false:before {\n\tcontent: \"\\eac9\";\n}\n\n.icofont-cur-pound-minus:before {\n\tcontent: \"\\eaca\";\n}\n\n.icofont-cur-pound-plus:before {\n\tcontent: \"\\eacb\";\n}\n\n.icofont-cur-pound-true:before {\n\tcontent: \"\\eacc\";\n}\n\n.icofont-cur-pound:before {\n\tcontent: \"\\eacd\";\n}\n\n.icofont-cur-renminbi-false:before {\n\tcontent: \"\\eace\";\n}\n\n.icofont-cur-renminbi-minus:before {\n\tcontent: \"\\eacf\";\n}\n\n.icofont-cur-renminbi-plus:before {\n\tcontent: \"\\ead0\";\n}\n\n.icofont-cur-renminbi-true:before {\n\tcontent: \"\\ead1\";\n}\n\n.icofont-cur-renminbi:before {\n\tcontent: \"\\ead2\";\n}\n\n.icofont-cur-riyal-false:before {\n\tcontent: \"\\ead3\";\n}\n\n.icofont-cur-riyal-minus:before {\n\tcontent: \"\\ead4\";\n}\n\n.icofont-cur-riyal-plus:before {\n\tcontent: \"\\ead5\";\n}\n\n.icofont-cur-riyal-true:before {\n\tcontent: \"\\ead6\";\n}\n\n.icofont-cur-riyal:before {\n\tcontent: \"\\ead7\";\n}\n\n.icofont-cur-rouble-false:before {\n\tcontent: \"\\ead8\";\n}\n\n.icofont-cur-rouble-minus:before {\n\tcontent: \"\\ead9\";\n}\n\n.icofont-cur-rouble-plus:before {\n\tcontent: \"\\eada\";\n}\n\n.icofont-cur-rouble-true:before {\n\tcontent: \"\\eadb\";\n}\n\n.icofont-cur-rouble:before {\n\tcontent: \"\\eadc\";\n}\n\n.icofont-cur-rupee-false:before {\n\tcontent: \"\\eadd\";\n}\n\n.icofont-cur-rupee-minus:before {\n\tcontent: \"\\eade\";\n}\n\n.icofont-cur-rupee-plus:before {\n\tcontent: \"\\eadf\";\n}\n\n.icofont-cur-rupee-true:before {\n\tcontent: \"\\eae0\";\n}\n\n.icofont-cur-rupee:before {\n\tcontent: \"\\eae1\";\n}\n\n.icofont-cur-taka-false:before {\n\tcontent: \"\\eae2\";\n}\n\n.icofont-cur-taka-minus:before {\n\tcontent: \"\\eae3\";\n}\n\n.icofont-cur-taka-plus:before {\n\tcontent: \"\\eae4\";\n}\n\n.icofont-cur-taka-true:before {\n\tcontent: \"\\eae5\";\n}\n\n.icofont-cur-taka:before {\n\tcontent: \"\\eae6\";\n}\n\n.icofont-cur-turkish-lira-false:before {\n\tcontent: \"\\eae7\";\n}\n\n.icofont-cur-turkish-lira-minus:before {\n\tcontent: \"\\eae8\";\n}\n\n.icofont-cur-turkish-lira-plus:before {\n\tcontent: \"\\eae9\";\n}\n\n.icofont-cur-turkish-lira-true:before {\n\tcontent: \"\\eaea\";\n}\n\n.icofont-cur-turkish-lira:before {\n\tcontent: \"\\eaeb\";\n}\n\n.icofont-cur-won-false:before {\n\tcontent: \"\\eaec\";\n}\n\n.icofont-cur-won-minus:before {\n\tcontent: \"\\eaed\";\n}\n\n.icofont-cur-won-plus:before {\n\tcontent: \"\\eaee\";\n}\n\n.icofont-cur-won-true:before {\n\tcontent: \"\\eaef\";\n}\n\n.icofont-cur-won:before {\n\tcontent: \"\\eaf0\";\n}\n\n.icofont-cur-yen-false:before {\n\tcontent: \"\\eaf1\";\n}\n\n.icofont-cur-yen-minus:before {\n\tcontent: \"\\eaf2\";\n}\n\n.icofont-cur-yen-plus:before {\n\tcontent: \"\\eaf3\";\n}\n\n.icofont-cur-yen-true:before {\n\tcontent: \"\\eaf4\";\n}\n\n.icofont-cur-yen:before {\n\tcontent: \"\\eaf5\";\n}\n\n.icofont-android-nexus:before {\n\tcontent: \"\\eaf6\";\n}\n\n.icofont-android-tablet:before {\n\tcontent: \"\\eaf7\";\n}\n\n.icofont-apple-watch:before {\n\tcontent: \"\\eaf8\";\n}\n\n.icofont-drwaing-tablet:before {\n\tcontent: \"\\eaf9\";\n}\n\n.icofont-earphone:before {\n\tcontent: \"\\eafa\";\n}\n\n.icofont-flash-drive:before {\n\tcontent: \"\\eafb\";\n}\n\n.icofont-game-control:before {\n\tcontent: \"\\eafc\";\n}\n\n.icofont-headphone-alt:before {\n\tcontent: \"\\eafd\";\n}\n\n.icofont-htc-one:before {\n\tcontent: \"\\eafe\";\n}\n\n.icofont-imac:before {\n\tcontent: \"\\eaff\";\n}\n\n.icofont-ipad-touch:before {\n\tcontent: \"\\eb00\";\n}\n\n.icofont-iphone:before {\n\tcontent: \"\\eb01\";\n}\n\n.icofont-ipod-nano:before {\n\tcontent: \"\\eb02\";\n}\n\n.icofont-ipod-touch:before {\n\tcontent: \"\\eb03\";\n}\n\n.icofont-keyboard-alt:before {\n\tcontent: \"\\eb04\";\n}\n\n.icofont-keyboard-wireless:before {\n\tcontent: \"\\eb05\";\n}\n\n.icofont-laptop-alt:before {\n\tcontent: \"\\eb06\";\n}\n\n.icofont-macbook:before {\n\tcontent: \"\\eb07\";\n}\n\n.icofont-magic-mouse:before {\n\tcontent: \"\\eb08\";\n}\n\n.icofont-microphone-alt:before {\n\tcontent: \"\\eb09\";\n}\n\n.icofont-monitor:before {\n\tcontent: \"\\eb0a\";\n}\n\n.icofont-mouse:before {\n\tcontent: \"\\eb0b\";\n}\n\n.icofont-nintendo:before {\n\tcontent: \"\\eb0c\";\n}\n\n.icofont-playstation:before {\n\tcontent: \"\\eb0d\";\n}\n\n.icofont-psvita:before {\n\tcontent: \"\\eb0e\";\n}\n\n.icofont-radio-mic:before {\n\tcontent: \"\\eb0f\";\n}\n\n.icofont-refrigerator:before {\n\tcontent: \"\\eb10\";\n}\n\n.icofont-samsung-galaxy:before {\n\tcontent: \"\\eb11\";\n}\n\n.icofont-surface-tablet:before {\n\tcontent: \"\\eb12\";\n}\n\n.icofont-washing-machine:before {\n\tcontent: \"\\eb13\";\n}\n\n.icofont-wifi-router:before {\n\tcontent: \"\\eb14\";\n}\n\n.icofont-wii-u:before {\n\tcontent: \"\\eb15\";\n}\n\n.icofont-windows-lumia:before {\n\tcontent: \"\\eb16\";\n}\n\n.icofont-wireless-mouse:before {\n\tcontent: \"\\eb17\";\n}\n\n.icofont-xbox-360:before {\n\tcontent: \"\\eb18\";\n}\n\n.icofont-arrow-down:before {\n\tcontent: \"\\eb19\";\n}\n\n.icofont-arrow-left:before {\n\tcontent: \"\\eb1a\";\n}\n\n.icofont-arrow-right:before {\n\tcontent: \"\\eb1b\";\n}\n\n.icofont-arrow-up:before {\n\tcontent: \"\\eb1c\";\n}\n\n.icofont-block-down:before {\n\tcontent: \"\\eb1d\";\n}\n\n.icofont-block-left:before {\n\tcontent: \"\\eb1e\";\n}\n\n.icofont-block-right:before {\n\tcontent: \"\\eb1f\";\n}\n\n.icofont-block-up:before {\n\tcontent: \"\\eb20\";\n}\n\n.icofont-bubble-down:before {\n\tcontent: \"\\eb21\";\n}\n\n.icofont-bubble-left:before {\n\tcontent: \"\\eb22\";\n}\n\n.icofont-bubble-right:before {\n\tcontent: \"\\eb23\";\n}\n\n.icofont-bubble-up:before {\n\tcontent: \"\\eb24\";\n}\n\n.icofont-caret-down:before {\n\tcontent: \"\\eb25\";\n}\n\n.icofont-caret-left:before {\n\tcontent: \"\\eb26\";\n}\n\n.icofont-caret-right:before {\n\tcontent: \"\\eb27\";\n}\n\n.icofont-caret-up:before {\n\tcontent: \"\\eb28\";\n}\n\n.icofont-circled-down:before {\n\tcontent: \"\\eb29\";\n}\n\n.icofont-circled-left:before {\n\tcontent: \"\\eb2a\";\n}\n\n.icofont-circled-right:before {\n\tcontent: \"\\eb2b\";\n}\n\n.icofont-circled-up:before {\n\tcontent: \"\\eb2c\";\n}\n\n.icofont-collapse:before {\n\tcontent: \"\\eb2d\";\n}\n\n.icofont-cursor-drag:before {\n\tcontent: \"\\eb2e\";\n}\n\n.icofont-curved-double-left:before {\n\tcontent: \"\\eb2f\";\n}\n\n.icofont-curved-double-right:before {\n\tcontent: \"\\eb30\";\n}\n\n.icofont-curved-down:before {\n\tcontent: \"\\eb31\";\n}\n\n.icofont-curved-left:before {\n\tcontent: \"\\eb32\";\n}\n\n.icofont-curved-right:before {\n\tcontent: \"\\eb33\";\n}\n\n.icofont-curved-up:before {\n\tcontent: \"\\eb34\";\n}\n\n.icofont-dotted-down:before {\n\tcontent: \"\\eb35\";\n}\n\n.icofont-dotted-left:before {\n\tcontent: \"\\eb36\";\n}\n\n.icofont-dotted-right:before {\n\tcontent: \"\\eb37\";\n}\n\n.icofont-dotted-up:before {\n\tcontent: \"\\eb38\";\n}\n\n.icofont-double-left:before {\n\tcontent: \"\\eb39\";\n}\n\n.icofont-double-right:before {\n\tcontent: \"\\eb3a\";\n}\n\n.icofont-drag:before {\n\tcontent: \"\\eb3b\";\n}\n\n.icofont-drag1:before {\n\tcontent: \"\\eb3c\";\n}\n\n.icofont-drag2:before {\n\tcontent: \"\\eb3d\";\n}\n\n.icofont-drag3:before {\n\tcontent: \"\\eb3e\";\n}\n\n.icofont-expand-alt:before {\n\tcontent: \"\\eb3f\";\n}\n\n.icofont-hand-down:before {\n\tcontent: \"\\eb40\";\n}\n\n.icofont-hand-drag:before {\n\tcontent: \"\\eb41\";\n}\n\n.icofont-hand-drag1:before {\n\tcontent: \"\\eb42\";\n}\n\n.icofont-hand-drag2:before {\n\tcontent: \"\\eb43\";\n}\n\n.icofont-hand-drawn-alt-down:before {\n\tcontent: \"\\eb44\";\n}\n\n.icofont-hand-drawn-alt-left:before {\n\tcontent: \"\\eb45\";\n}\n\n.icofont-hand-drawn-alt-right:before {\n\tcontent: \"\\eb46\";\n}\n\n.icofont-hand-drawn-alt-up:before {\n\tcontent: \"\\eb47\";\n}\n\n.icofont-hand-drawn-down:before {\n\tcontent: \"\\eb48\";\n}\n\n.icofont-hand-drawn-left:before {\n\tcontent: \"\\eb49\";\n}\n\n.icofont-hand-drawn-right:before {\n\tcontent: \"\\eb4a\";\n}\n\n.icofont-hand-drawn-up:before {\n\tcontent: \"\\eb4b\";\n}\n\n.icofont-hand-left:before {\n\tcontent: \"\\eb4c\";\n}\n\n.icofont-hand-right:before {\n\tcontent: \"\\eb4d\";\n}\n\n.icofont-hand-up:before {\n\tcontent: \"\\eb4e\";\n}\n\n.icofont-line-block-down:before {\n\tcontent: \"\\eb4f\";\n}\n\n.icofont-line-block-left:before {\n\tcontent: \"\\eb50\";\n}\n\n.icofont-line-block-right:before {\n\tcontent: \"\\eb51\";\n}\n\n.icofont-line-block-up:before {\n\tcontent: \"\\eb52\";\n}\n\n.icofont-long-arrow-down:before {\n\tcontent: \"\\eb53\";\n}\n\n.icofont-long-arrow-left:before {\n\tcontent: \"\\eb54\";\n}\n\n.icofont-long-arrow-right:before {\n\tcontent: \"\\eb55\";\n}\n\n.icofont-long-arrow-up:before {\n\tcontent: \"\\eb56\";\n}\n\n.icofont-rounded-collapse:before {\n\tcontent: \"\\eb57\";\n}\n\n.icofont-rounded-double-left:before {\n\tcontent: \"\\eb58\";\n}\n\n.icofont-rounded-double-right:before {\n\tcontent: \"\\eb59\";\n}\n\n.icofont-rounded-down:before {\n\tcontent: \"\\eb5a\";\n}\n\n.icofont-rounded-expand:before {\n\tcontent: \"\\eb5b\";\n}\n\n.icofont-rounded-left-down:before {\n\tcontent: \"\\eb5c\";\n}\n\n.icofont-rounded-left-up:before {\n\tcontent: \"\\eb5d\";\n}\n\n.icofont-rounded-left:before {\n\tcontent: \"\\eb5e\";\n}\n\n.icofont-rounded-right-down:before {\n\tcontent: \"\\eb5f\";\n}\n\n.icofont-rounded-right-up:before {\n\tcontent: \"\\eb60\";\n}\n\n.icofont-rounded-right:before {\n\tcontent: \"\\eb61\";\n}\n\n.icofont-rounded-up:before {\n\tcontent: \"\\eb62\";\n}\n\n.icofont-scroll-bubble-down:before {\n\tcontent: \"\\eb63\";\n}\n\n.icofont-scroll-bubble-left:before {\n\tcontent: \"\\eb64\";\n}\n\n.icofont-scroll-bubble-right:before {\n\tcontent: \"\\eb65\";\n}\n\n.icofont-scroll-bubble-up:before {\n\tcontent: \"\\eb66\";\n}\n\n.icofont-scroll-double-down:before {\n\tcontent: \"\\eb67\";\n}\n\n.icofont-scroll-double-left:before {\n\tcontent: \"\\eb68\";\n}\n\n.icofont-scroll-double-right:before {\n\tcontent: \"\\eb69\";\n}\n\n.icofont-scroll-double-up:before {\n\tcontent: \"\\eb6a\";\n}\n\n.icofont-scroll-down:before {\n\tcontent: \"\\eb6b\";\n}\n\n.icofont-scroll-left:before {\n\tcontent: \"\\eb6c\";\n}\n\n.icofont-scroll-long-down:before {\n\tcontent: \"\\eb6d\";\n}\n\n.icofont-scroll-long-left:before {\n\tcontent: \"\\eb6e\";\n}\n\n.icofont-scroll-long-right:before {\n\tcontent: \"\\eb6f\";\n}\n\n.icofont-scroll-long-up:before {\n\tcontent: \"\\eb70\";\n}\n\n.icofont-scroll-right:before {\n\tcontent: \"\\eb71\";\n}\n\n.icofont-scroll-up:before {\n\tcontent: \"\\eb72\";\n}\n\n.icofont-simple-down:before {\n\tcontent: \"\\eb73\";\n}\n\n.icofont-simple-left-down:before {\n\tcontent: \"\\eb74\";\n}\n\n.icofont-simple-left-up:before {\n\tcontent: \"\\eb75\";\n}\n\n.icofont-simple-left:before {\n\tcontent: \"\\eb76\";\n}\n\n.icofont-simple-right-down:before {\n\tcontent: \"\\eb77\";\n}\n\n.icofont-simple-right-up:before {\n\tcontent: \"\\eb78\";\n}\n\n.icofont-simple-right:before {\n\tcontent: \"\\eb79\";\n}\n\n.icofont-simple-up:before {\n\tcontent: \"\\eb7a\";\n}\n\n.icofont-square-down:before {\n\tcontent: \"\\eb7b\";\n}\n\n.icofont-square-left:before {\n\tcontent: \"\\eb7c\";\n}\n\n.icofont-square-right:before {\n\tcontent: \"\\eb7d\";\n}\n\n.icofont-square-up:before {\n\tcontent: \"\\eb7e\";\n}\n\n.icofont-stylish-down:before {\n\tcontent: \"\\eb7f\";\n}\n\n.icofont-stylish-left:before {\n\tcontent: \"\\eb80\";\n}\n\n.icofont-stylish-right:before {\n\tcontent: \"\\eb81\";\n}\n\n.icofont-stylish-up:before {\n\tcontent: \"\\eb82\";\n}\n\n.icofont-swoosh-down:before {\n\tcontent: \"\\eb83\";\n}\n\n.icofont-swoosh-left:before {\n\tcontent: \"\\eb84\";\n}\n\n.icofont-swoosh-right:before {\n\tcontent: \"\\eb85\";\n}\n\n.icofont-swoosh-up:before {\n\tcontent: \"\\eb86\";\n}\n\n.icofont-thin-double-left:before {\n\tcontent: \"\\eb87\";\n}\n\n.icofont-thin-double-right:before {\n\tcontent: \"\\eb88\";\n}\n\n.icofont-thin-down:before {\n\tcontent: \"\\eb89\";\n}\n\n.icofont-thin-left:before {\n\tcontent: \"\\eb8a\";\n}\n\n.icofont-thin-right:before {\n\tcontent: \"\\eb8b\";\n}\n\n.icofont-thin-up:before {\n\tcontent: \"\\eb8c\";\n}\n\n.icofont-atom:before {\n\tcontent: \"\\eb8d\";\n}\n\n.icofont-award:before {\n\tcontent: \"\\eb8e\";\n}\n\n.icofont-bell-alt:before {\n\tcontent: \"\\eb8f\";\n}\n\n.icofont-book-alt:before {\n\tcontent: \"\\eb90\";\n}\n\n.icofont-brainstorming:before {\n\tcontent: \"\\eb91\";\n}\n\n.icofont-certificate-alt-1:before {\n\tcontent: \"\\eb92\";\n}\n\n.icofont-certificate-alt-2:before {\n\tcontent: \"\\eb93\";\n}\n\n.icofont-dna-alt-2:before {\n\tcontent: \"\\eb94\";\n}\n\n.icofont-education:before {\n\tcontent: \"\\eb95\";\n}\n\n.icofont-electron:before {\n\tcontent: \"\\eb96\";\n}\n\n.icofont-fountain-pen:before {\n\tcontent: \"\\eb97\";\n}\n\n.icofont-globe-alt:before {\n\tcontent: \"\\eb98\";\n}\n\n.icofont-graduate-alt:before {\n\tcontent: \"\\eb99\";\n}\n\n.icofont-group-students:before {\n\tcontent: \"\\eb9a\";\n}\n\n.icofont-hat-alt:before {\n\tcontent: \"\\eb9b\";\n}\n\n.icofont-hat:before {\n\tcontent: \"\\eb9c\";\n}\n\n.icofont-instrument:before {\n\tcontent: \"\\eb9d\";\n}\n\n.icofont-lamp-light:before {\n\tcontent: \"\\eb9e\";\n}\n\n.icofont-microscope-alt:before {\n\tcontent: \"\\eb9f\";\n}\n\n.icofont-paper:before {\n\tcontent: \"\\eba0\";\n}\n\n.icofont-pen-alt-4:before {\n\tcontent: \"\\eba1\";\n}\n\n.icofont-pen-nib:before {\n\tcontent: \"\\eba2\";\n}\n\n.icofont-pencil-alt-5:before {\n\tcontent: \"\\eba3\";\n}\n\n.icofont-quill-pen:before {\n\tcontent: \"\\eba4\";\n}\n\n.icofont-read-book-alt:before {\n\tcontent: \"\\eba5\";\n}\n\n.icofont-read-book:before {\n\tcontent: \"\\eba6\";\n}\n\n.icofont-school-bag:before {\n\tcontent: \"\\eba7\";\n}\n\n.icofont-school-bus:before {\n\tcontent: \"\\eba8\";\n}\n\n.icofont-student-alt:before {\n\tcontent: \"\\eba9\";\n}\n\n.icofont-student:before {\n\tcontent: \"\\ebaa\";\n}\n\n.icofont-teacher:before {\n\tcontent: \"\\ebab\";\n}\n\n.icofont-test-bulb:before {\n\tcontent: \"\\ebac\";\n}\n\n.icofont-test-tube-alt:before {\n\tcontent: \"\\ebad\";\n}\n\n.icofont-university:before {\n\tcontent: \"\\ebae\";\n}\n\n.icofont-emo-angry:before {\n\tcontent: \"\\ebaf\";\n}\n\n.icofont-emo-astonished:before {\n\tcontent: \"\\ebb0\";\n}\n\n.icofont-emo-confounded:before {\n\tcontent: \"\\ebb1\";\n}\n\n.icofont-emo-confused:before {\n\tcontent: \"\\ebb2\";\n}\n\n.icofont-emo-crying:before {\n\tcontent: \"\\ebb3\";\n}\n\n.icofont-emo-dizzy:before {\n\tcontent: \"\\ebb4\";\n}\n\n.icofont-emo-expressionless:before {\n\tcontent: \"\\ebb5\";\n}\n\n.icofont-emo-heart-eyes:before {\n\tcontent: \"\\ebb6\";\n}\n\n.icofont-emo-laughing:before {\n\tcontent: \"\\ebb7\";\n}\n\n.icofont-emo-nerd-smile:before {\n\tcontent: \"\\ebb8\";\n}\n\n.icofont-emo-open-mouth:before {\n\tcontent: \"\\ebb9\";\n}\n\n.icofont-emo-rage:before {\n\tcontent: \"\\ebba\";\n}\n\n.icofont-emo-rolling-eyes:before {\n\tcontent: \"\\ebbb\";\n}\n\n.icofont-emo-sad:before {\n\tcontent: \"\\ebbc\";\n}\n\n.icofont-emo-simple-smile:before {\n\tcontent: \"\\ebbd\";\n}\n\n.icofont-emo-slightly-smile:before {\n\tcontent: \"\\ebbe\";\n}\n\n.icofont-emo-smirk:before {\n\tcontent: \"\\ebbf\";\n}\n\n.icofont-emo-stuck-out-tongue:before {\n\tcontent: \"\\ebc0\";\n}\n\n.icofont-emo-wink-smile:before {\n\tcontent: \"\\ebc1\";\n}\n\n.icofont-emo-worried:before {\n\tcontent: \"\\ebc2\";\n}\n\n.icofont-architecture-alt:before {\n\tcontent: \"\\ebc3\";\n}\n\n.icofont-architecture:before {\n\tcontent: \"\\ebc4\";\n}\n\n.icofont-barricade:before {\n\tcontent: \"\\ebc5\";\n}\n\n.icofont-bricks:before {\n\tcontent: \"\\ebc6\";\n}\n\n.icofont-calculations:before {\n\tcontent: \"\\ebc7\";\n}\n\n.icofont-cement-mix:before {\n\tcontent: \"\\ebc8\";\n}\n\n.icofont-cement-mixer:before {\n\tcontent: \"\\ebc9\";\n}\n\n.icofont-danger-zone:before {\n\tcontent: \"\\ebca\";\n}\n\n.icofont-drill:before {\n\tcontent: \"\\ebcb\";\n}\n\n.icofont-eco-energy:before {\n\tcontent: \"\\ebcc\";\n}\n\n.icofont-eco-environmen:before {\n\tcontent: \"\\ebcd\";\n}\n\n.icofont-energy-air:before {\n\tcontent: \"\\ebce\";\n}\n\n.icofont-energy-oil:before {\n\tcontent: \"\\ebcf\";\n}\n\n.icofont-energy-savings:before {\n\tcontent: \"\\ebd0\";\n}\n\n.icofont-energy-solar:before {\n\tcontent: \"\\ebd1\";\n}\n\n.icofont-energy-water:before {\n\tcontent: \"\\ebd2\";\n}\n\n.icofont-engineer:before {\n\tcontent: \"\\ebd3\";\n}\n\n.icofont-fire-extinguisher-alt:before {\n\tcontent: \"\\ebd4\";\n}\n\n.icofont-fix-tools:before {\n\tcontent: \"\\ebd5\";\n}\n\n.icofont-glue-oil:before {\n\tcontent: \"\\ebd6\";\n}\n\n.icofont-hammer-alt:before {\n\tcontent: \"\\ebd7\";\n}\n\n.icofont-help-robot:before {\n\tcontent: \"\\ebd8\";\n}\n\n.icofont-industries-alt-1:before {\n\tcontent: \"\\ebd9\";\n}\n\n.icofont-industries-alt-2:before {\n\tcontent: \"\\ebda\";\n}\n\n.icofont-industries-alt-3:before {\n\tcontent: \"\\ebdb\";\n}\n\n.icofont-industries-alt-4:before {\n\tcontent: \"\\ebdc\";\n}\n\n.icofont-industries-alt-5:before {\n\tcontent: \"\\ebdd\";\n}\n\n.icofont-industries:before {\n\tcontent: \"\\ebde\";\n}\n\n.icofont-labour:before {\n\tcontent: \"\\ebdf\";\n}\n\n.icofont-mining:before {\n\tcontent: \"\\ebe0\";\n}\n\n.icofont-paint-brush:before {\n\tcontent: \"\\ebe1\";\n}\n\n.icofont-pollution:before {\n\tcontent: \"\\ebe2\";\n}\n\n.icofont-power-zone:before {\n\tcontent: \"\\ebe3\";\n}\n\n.icofont-radio-active:before {\n\tcontent: \"\\ebe4\";\n}\n\n.icofont-recycle-alt:before {\n\tcontent: \"\\ebe5\";\n}\n\n.icofont-recycling-man:before {\n\tcontent: \"\\ebe6\";\n}\n\n.icofont-safety-hat-light:before {\n\tcontent: \"\\ebe7\";\n}\n\n.icofont-safety-hat:before {\n\tcontent: \"\\ebe8\";\n}\n\n.icofont-saw:before {\n\tcontent: \"\\ebe9\";\n}\n\n.icofont-screw-driver:before {\n\tcontent: \"\\ebea\";\n}\n\n.icofont-settings-alt:before {\n\tcontent: \"\\ebeb\";\n}\n\n.icofont-tools-alt-1:before {\n\tcontent: \"\\ebec\";\n}\n\n.icofont-tools-alt-2:before {\n\tcontent: \"\\ebed\";\n}\n\n.icofont-tools-bag:before {\n\tcontent: \"\\ebee\";\n}\n\n.icofont-trolley:before {\n\tcontent: \"\\ebef\";\n}\n\n.icofont-trowel:before {\n\tcontent: \"\\ebf0\";\n}\n\n.icofont-under-construction-alt:before {\n\tcontent: \"\\ebf1\";\n}\n\n.icofont-under-construction:before {\n\tcontent: \"\\ebf2\";\n}\n\n.icofont-vehicle-cement:before {\n\tcontent: \"\\ebf3\";\n}\n\n.icofont-vehicle-crane:before {\n\tcontent: \"\\ebf4\";\n}\n\n.icofont-vehicle-delivery-van:before {\n\tcontent: \"\\ebf5\";\n}\n\n.icofont-vehicle-dozer:before {\n\tcontent: \"\\ebf6\";\n}\n\n.icofont-vehicle-excavator:before {\n\tcontent: \"\\ebf7\";\n}\n\n.icofont-vehicle-trucktor:before {\n\tcontent: \"\\ebf8\";\n}\n\n.icofont-vehicle-wrecking:before {\n\tcontent: \"\\ebf9\";\n}\n\n.icofont-worker-group:before {\n\tcontent: \"\\ebfa\";\n}\n\n.icofont-worker:before {\n\tcontent: \"\\ebfb\";\n}\n\n.icofont-wrench:before {\n\tcontent: \"\\ebfc\";\n}\n\n.icofont-file-audio:before {\n\tcontent: \"\\ebfd\";\n}\n\n.icofont-file-avi-mp4:before {\n\tcontent: \"\\ebfe\";\n}\n\n.icofont-file-bmp:before {\n\tcontent: \"\\ebff\";\n}\n\n.icofont-file-code:before {\n\tcontent: \"\\ec00\";\n}\n\n.icofont-file-css:before {\n\tcontent: \"\\ec01\";\n}\n\n.icofont-file-document:before {\n\tcontent: \"\\ec02\";\n}\n\n.icofont-file-eps:before {\n\tcontent: \"\\ec03\";\n}\n\n.icofont-file-excel:before {\n\tcontent: \"\\ec04\";\n}\n\n.icofont-file-exe:before {\n\tcontent: \"\\ec05\";\n}\n\n.icofont-file-file:before {\n\tcontent: \"\\ec06\";\n}\n\n.icofont-file-flv:before {\n\tcontent: \"\\ec07\";\n}\n\n.icofont-file-gif:before {\n\tcontent: \"\\ec08\";\n}\n\n.icofont-file-html5:before {\n\tcontent: \"\\ec09\";\n}\n\n.icofont-file-image:before {\n\tcontent: \"\\ec0a\";\n}\n\n.icofont-file-iso:before {\n\tcontent: \"\\ec0b\";\n}\n\n.icofont-file-java:before {\n\tcontent: \"\\ec0c\";\n}\n\n.icofont-file-javascript:before {\n\tcontent: \"\\ec0d\";\n}\n\n.icofont-file-jpg:before {\n\tcontent: \"\\ec0e\";\n}\n\n.icofont-file-midi:before {\n\tcontent: \"\\ec0f\";\n}\n\n.icofont-file-mov:before {\n\tcontent: \"\\ec10\";\n}\n\n.icofont-file-mp3:before {\n\tcontent: \"\\ec11\";\n}\n\n.icofont-file-pdf:before {\n\tcontent: \"\\ec12\";\n}\n\n.icofont-file-php:before {\n\tcontent: \"\\ec13\";\n}\n\n.icofont-file-png:before {\n\tcontent: \"\\ec14\";\n}\n\n.icofont-file-powerpoint:before {\n\tcontent: \"\\ec15\";\n}\n\n.icofont-file-presentation:before {\n\tcontent: \"\\ec16\";\n}\n\n.icofont-file-psb:before {\n\tcontent: \"\\ec17\";\n}\n\n.icofont-file-psd:before {\n\tcontent: \"\\ec18\";\n}\n\n.icofont-file-python:before {\n\tcontent: \"\\ec19\";\n}\n\n.icofont-file-ruby:before {\n\tcontent: \"\\ec1a\";\n}\n\n.icofont-file-spreadsheet:before {\n\tcontent: \"\\ec1b\";\n}\n\n.icofont-file-sql:before {\n\tcontent: \"\\ec1c\";\n}\n\n.icofont-file-svg:before {\n\tcontent: \"\\ec1d\";\n}\n\n.icofont-file-text:before {\n\tcontent: \"\\ec1e\";\n}\n\n.icofont-file-tiff:before {\n\tcontent: \"\\ec1f\";\n}\n\n.icofont-file-video:before {\n\tcontent: \"\\ec20\";\n}\n\n.icofont-file-wave:before {\n\tcontent: \"\\ec21\";\n}\n\n.icofont-file-wmv:before {\n\tcontent: \"\\ec22\";\n}\n\n.icofont-file-word:before {\n\tcontent: \"\\ec23\";\n}\n\n.icofont-file-zip:before {\n\tcontent: \"\\ec24\";\n}\n\n.icofont-apple:before {\n\tcontent: \"\\ec25\";\n}\n\n.icofont-arabian-coffee:before {\n\tcontent: \"\\ec26\";\n}\n\n.icofont-artichoke:before {\n\tcontent: \"\\ec27\";\n}\n\n.icofont-asparagus:before {\n\tcontent: \"\\ec28\";\n}\n\n.icofont-avocado:before {\n\tcontent: \"\\ec29\";\n}\n\n.icofont-baby-food:before {\n\tcontent: \"\\ec2a\";\n}\n\n.icofont-banana:before {\n\tcontent: \"\\ec2b\";\n}\n\n.icofont-bbq:before {\n\tcontent: \"\\ec2c\";\n}\n\n.icofont-beans:before {\n\tcontent: \"\\ec2d\";\n}\n\n.icofont-beer:before {\n\tcontent: \"\\ec2e\";\n}\n\n.icofont-bell-pepper-capsicum:before {\n\tcontent: \"\\ec2f\";\n}\n\n.icofont-birthday-cake:before {\n\tcontent: \"\\ec30\";\n}\n\n.icofont-bread:before {\n\tcontent: \"\\ec31\";\n}\n\n.icofont-broccoli:before {\n\tcontent: \"\\ec32\";\n}\n\n.icofont-burger:before {\n\tcontent: \"\\ec33\";\n}\n\n.icofont-cabbage:before {\n\tcontent: \"\\ec34\";\n}\n\n.icofont-carrot:before {\n\tcontent: \"\\ec35\";\n}\n\n.icofont-cauli-flower:before {\n\tcontent: \"\\ec36\";\n}\n\n.icofont-cheese:before {\n\tcontent: \"\\ec37\";\n}\n\n.icofont-chef:before {\n\tcontent: \"\\ec38\";\n}\n\n.icofont-cherry:before {\n\tcontent: \"\\ec39\";\n}\n\n.icofont-chicken-fry:before {\n\tcontent: \"\\ec3a\";\n}\n\n.icofont-chicken:before {\n\tcontent: \"\\ec3b\";\n}\n\n.icofont-cocktail:before {\n\tcontent: \"\\ec3c\";\n}\n\n.icofont-coconut:before {\n\tcontent: \"\\ec3d\";\n}\n\n.icofont-coffee-alt:before {\n\tcontent: \"\\ec3e\";\n}\n\n.icofont-coffee-mug:before {\n\tcontent: \"\\ec3f\";\n}\n\n.icofont-coffee-pot:before {\n\tcontent: \"\\ec40\";\n}\n\n.icofont-cola:before {\n\tcontent: \"\\ec41\";\n}\n\n.icofont-corn:before {\n\tcontent: \"\\ec42\";\n}\n\n.icofont-croissant:before {\n\tcontent: \"\\ec43\";\n}\n\n.icofont-crop-plant:before {\n\tcontent: \"\\ec44\";\n}\n\n.icofont-cucumber:before {\n\tcontent: \"\\ec45\";\n}\n\n.icofont-cup-cake:before {\n\tcontent: \"\\ec46\";\n}\n\n.icofont-dining-table:before {\n\tcontent: \"\\ec47\";\n}\n\n.icofont-donut:before {\n\tcontent: \"\\ec48\";\n}\n\n.icofont-egg-plant:before {\n\tcontent: \"\\ec49\";\n}\n\n.icofont-egg-poached:before {\n\tcontent: \"\\ec4a\";\n}\n\n.icofont-farmer:before {\n\tcontent: \"\\ec4b\";\n}\n\n.icofont-farmer1:before {\n\tcontent: \"\\ec4c\";\n}\n\n.icofont-fast-food:before {\n\tcontent: \"\\ec4d\";\n}\n\n.icofont-fish:before {\n\tcontent: \"\\ec4e\";\n}\n\n.icofont-food-basket:before {\n\tcontent: \"\\ec4f\";\n}\n\n.icofont-food-cart:before {\n\tcontent: \"\\ec50\";\n}\n\n.icofont-fork-and-knife:before {\n\tcontent: \"\\ec51\";\n}\n\n.icofont-french-fries:before {\n\tcontent: \"\\ec52\";\n}\n\n.icofont-fresh-juice:before {\n\tcontent: \"\\ec53\";\n}\n\n.icofont-fruits:before {\n\tcontent: \"\\ec54\";\n}\n\n.icofont-grapes:before {\n\tcontent: \"\\ec55\";\n}\n\n.icofont-honey:before {\n\tcontent: \"\\ec56\";\n}\n\n.icofont-hot-dog:before {\n\tcontent: \"\\ec57\";\n}\n\n.icofont-hotel-alt:before {\n\tcontent: \"\\ec58\";\n}\n\n.icofont-ice-cream-alt:before {\n\tcontent: \"\\ec59\";\n}\n\n.icofont-ice-cream:before {\n\tcontent: \"\\ec5a\";\n}\n\n.icofont-ketchup:before {\n\tcontent: \"\\ec5b\";\n}\n\n.icofont-kiwi:before {\n\tcontent: \"\\ec5c\";\n}\n\n.icofont-layered-cake:before {\n\tcontent: \"\\ec5d\";\n}\n\n.icofont-lemon-alt:before {\n\tcontent: \"\\ec5e\";\n}\n\n.icofont-lobster:before {\n\tcontent: \"\\ec5f\";\n}\n\n.icofont-mango:before {\n\tcontent: \"\\ec60\";\n}\n\n.icofont-milk:before {\n\tcontent: \"\\ec61\";\n}\n\n.icofont-mushroom:before {\n\tcontent: \"\\ec62\";\n}\n\n.icofont-noodles:before {\n\tcontent: \"\\ec63\";\n}\n\n.icofont-onion:before {\n\tcontent: \"\\ec64\";\n}\n\n.icofont-orange:before {\n\tcontent: \"\\ec65\";\n}\n\n.icofont-pear:before {\n\tcontent: \"\\ec66\";\n}\n\n.icofont-peas:before {\n\tcontent: \"\\ec67\";\n}\n\n.icofont-pepper:before {\n\tcontent: \"\\ec68\";\n}\n\n.icofont-pie-alt:before {\n\tcontent: \"\\ec69\";\n}\n\n.icofont-pineapple:before {\n\tcontent: \"\\ec6a\";\n}\n\n.icofont-pizza-slice:before {\n\tcontent: \"\\ec6b\";\n}\n\n.icofont-pizza:before {\n\tcontent: \"\\ec6c\";\n}\n\n.icofont-plant:before {\n\tcontent: \"\\ec6d\";\n}\n\n.icofont-popcorn:before {\n\tcontent: \"\\ec6e\";\n}\n\n.icofont-potato:before {\n\tcontent: \"\\ec6f\";\n}\n\n.icofont-pumpkin:before {\n\tcontent: \"\\ec70\";\n}\n\n.icofont-raddish:before {\n\tcontent: \"\\ec71\";\n}\n\n.icofont-restaurant-menu:before {\n\tcontent: \"\\ec72\";\n}\n\n.icofont-restaurant:before {\n\tcontent: \"\\ec73\";\n}\n\n.icofont-salt-and-pepper:before {\n\tcontent: \"\\ec74\";\n}\n\n.icofont-sandwich:before {\n\tcontent: \"\\ec75\";\n}\n\n.icofont-sausage:before {\n\tcontent: \"\\ec76\";\n}\n\n.icofont-shrimp:before {\n\tcontent: \"\\ec77\";\n}\n\n.icofont-sof-drinks:before {\n\tcontent: \"\\ec78\";\n}\n\n.icofont-soup-bowl:before {\n\tcontent: \"\\ec79\";\n}\n\n.icofont-spoon-and-fork:before {\n\tcontent: \"\\ec7a\";\n}\n\n.icofont-steak:before {\n\tcontent: \"\\ec7b\";\n}\n\n.icofont-strawberry:before {\n\tcontent: \"\\ec7c\";\n}\n\n.icofont-sub-sandwich:before {\n\tcontent: \"\\ec7d\";\n}\n\n.icofont-sushi:before {\n\tcontent: \"\\ec7e\";\n}\n\n.icofont-taco:before {\n\tcontent: \"\\ec7f\";\n}\n\n.icofont-tea-pot:before {\n\tcontent: \"\\ec80\";\n}\n\n.icofont-tea:before {\n\tcontent: \"\\ec81\";\n}\n\n.icofont-tomato:before {\n\tcontent: \"\\ec82\";\n}\n\n.icofont-waiter-alt:before {\n\tcontent: \"\\ec83\";\n}\n\n.icofont-watermelon:before {\n\tcontent: \"\\ec84\";\n}\n\n.icofont-wheat:before {\n\tcontent: \"\\ec85\";\n}\n\n.icofont-abc:before {\n\tcontent: \"\\ec86\";\n}\n\n.icofont-baby-cloth:before {\n\tcontent: \"\\ec87\";\n}\n\n.icofont-baby-milk-bottle:before {\n\tcontent: \"\\ec88\";\n}\n\n.icofont-baby-trolley:before {\n\tcontent: \"\\ec89\";\n}\n\n.icofont-back-pack:before {\n\tcontent: \"\\ec8a\";\n}\n\n.icofont-candy:before {\n\tcontent: \"\\ec8b\";\n}\n\n.icofont-cycling:before {\n\tcontent: \"\\ec8c\";\n}\n\n.icofont-holding-hands:before {\n\tcontent: \"\\ec8d\";\n}\n\n.icofont-infant-nipple:before {\n\tcontent: \"\\ec8e\";\n}\n\n.icofont-kids-scooter:before {\n\tcontent: \"\\ec8f\";\n}\n\n.icofont-safety-pin:before {\n\tcontent: \"\\ec90\";\n}\n\n.icofont-teddy-bear:before {\n\tcontent: \"\\ec91\";\n}\n\n.icofont-toy-ball:before {\n\tcontent: \"\\ec92\";\n}\n\n.icofont-toy-cat:before {\n\tcontent: \"\\ec93\";\n}\n\n.icofont-toy-duck:before {\n\tcontent: \"\\ec94\";\n}\n\n.icofont-toy-elephant:before {\n\tcontent: \"\\ec95\";\n}\n\n.icofont-toy-hand:before {\n\tcontent: \"\\ec96\";\n}\n\n.icofont-toy-horse:before {\n\tcontent: \"\\ec97\";\n}\n\n.icofont-toy-lattu:before {\n\tcontent: \"\\ec98\";\n}\n\n.icofont-toy-train:before {\n\tcontent: \"\\ec99\";\n}\n\n.icofont-unique-idea:before {\n\tcontent: \"\\ec9a\";\n}\n\n.icofont-bag-alt:before {\n\tcontent: \"\\ec9b\";\n}\n\n.icofont-burglar:before {\n\tcontent: \"\\ec9c\";\n}\n\n.icofont-cannon-firing:before {\n\tcontent: \"\\ec9d\";\n}\n\n.icofont-cc-camera:before {\n\tcontent: \"\\ec9e\";\n}\n\n.icofont-cop-badge:before {\n\tcontent: \"\\ec9f\";\n}\n\n.icofont-cop:before {\n\tcontent: \"\\eca0\";\n}\n\n.icofont-court-hammer:before {\n\tcontent: \"\\eca1\";\n}\n\n.icofont-court:before {\n\tcontent: \"\\eca2\";\n}\n\n.icofont-finger-print:before {\n\tcontent: \"\\eca3\";\n}\n\n.icofont-handcuff-alt:before {\n\tcontent: \"\\eca4\";\n}\n\n.icofont-handcuff:before {\n\tcontent: \"\\eca5\";\n}\n\n.icofont-investigation:before {\n\tcontent: \"\\eca6\";\n}\n\n.icofont-investigator:before {\n\tcontent: \"\\eca7\";\n}\n\n.icofont-jail:before {\n\tcontent: \"\\eca8\";\n}\n\n.icofont-judge:before {\n\tcontent: \"\\eca9\";\n}\n\n.icofont-law-alt-1:before {\n\tcontent: \"\\ecaa\";\n}\n\n.icofont-law-alt-2:before {\n\tcontent: \"\\ecab\";\n}\n\n.icofont-law-alt-3:before {\n\tcontent: \"\\ecac\";\n}\n\n.icofont-law-book:before {\n\tcontent: \"\\ecad\";\n}\n\n.icofont-law-document:before {\n\tcontent: \"\\ecae\";\n}\n\n.icofont-law:before {\n\tcontent: \"\\ecaf\";\n}\n\n.icofont-lawyer-alt-1:before {\n\tcontent: \"\\ecb0\";\n}\n\n.icofont-lawyer-alt-2:before {\n\tcontent: \"\\ecb1\";\n}\n\n.icofont-lawyer:before {\n\tcontent: \"\\ecb2\";\n}\n\n.icofont-order:before {\n\tcontent: \"\\ecb3\";\n}\n\n.icofont-pistol:before {\n\tcontent: \"\\ecb4\";\n}\n\n.icofont-police-badge:before {\n\tcontent: \"\\ecb5\";\n}\n\n.icofont-police-cap:before {\n\tcontent: \"\\ecb6\";\n}\n\n.icofont-police-car-alt-1:before {\n\tcontent: \"\\ecb7\";\n}\n\n.icofont-police-car-alt-2:before {\n\tcontent: \"\\ecb8\";\n}\n\n.icofont-police-hat:before {\n\tcontent: \"\\ecb9\";\n}\n\n.icofont-police-van:before {\n\tcontent: \"\\ecba\";\n}\n\n.icofont-police:before {\n\tcontent: \"\\ecbb\";\n}\n\n.icofont-protect:before {\n\tcontent: \"\\ecbc\";\n}\n\n.icofont-scales:before {\n\tcontent: \"\\ecbd\";\n}\n\n.icofont-thief-alt:before {\n\tcontent: \"\\ecbe\";\n}\n\n.icofont-thief:before {\n\tcontent: \"\\ecbf\";\n}\n\n.icofont-abacus-alt:before {\n\tcontent: \"\\ecc0\";\n}\n\n.icofont-abacus:before {\n\tcontent: \"\\ecc1\";\n}\n\n.icofont-angle:before {\n\tcontent: \"\\ecc2\";\n}\n\n.icofont-calculator-alt-1:before {\n\tcontent: \"\\ecc3\";\n}\n\n.icofont-calculator-alt-2:before {\n\tcontent: \"\\ecc4\";\n}\n\n.icofont-circle-ruler-alt:before {\n\tcontent: \"\\ecc5\";\n}\n\n.icofont-circle-ruler:before {\n\tcontent: \"\\ecc6\";\n}\n\n.icofont-compass-alt-1:before {\n\tcontent: \"\\ecc7\";\n}\n\n.icofont-compass-alt-2:before {\n\tcontent: \"\\ecc8\";\n}\n\n.icofont-compass-alt-3:before {\n\tcontent: \"\\ecc9\";\n}\n\n.icofont-compass-alt-4:before {\n\tcontent: \"\\ecca\";\n}\n\n.icofont-degrees-alt-1:before {\n\tcontent: \"\\eccb\";\n}\n\n.icofont-degrees-alt-2:before {\n\tcontent: \"\\eccc\";\n}\n\n.icofont-degrees:before {\n\tcontent: \"\\eccd\";\n}\n\n.icofont-golden-ratio:before {\n\tcontent: \"\\ecce\";\n}\n\n.icofont-marker-alt-1:before {\n\tcontent: \"\\eccf\";\n}\n\n.icofont-marker-alt-2:before {\n\tcontent: \"\\ecd0\";\n}\n\n.icofont-marker-alt-3:before {\n\tcontent: \"\\ecd1\";\n}\n\n.icofont-mathematical-alt-1:before {\n\tcontent: \"\\ecd2\";\n}\n\n.icofont-mathematical-alt-2:before {\n\tcontent: \"\\ecd3\";\n}\n\n.icofont-mathematical:before {\n\tcontent: \"\\ecd4\";\n}\n\n.icofont-pen-alt-1:before {\n\tcontent: \"\\ecd5\";\n}\n\n.icofont-pen-alt-2:before {\n\tcontent: \"\\ecd6\";\n}\n\n.icofont-pen-alt-3:before {\n\tcontent: \"\\ecd7\";\n}\n\n.icofont-pen-holder-alt-1:before {\n\tcontent: \"\\ecd8\";\n}\n\n.icofont-pen-holder:before {\n\tcontent: \"\\ecd9\";\n}\n\n.icofont-pencil-alt-1:before {\n\tcontent: \"\\ecda\";\n}\n\n.icofont-pencil-alt-2:before {\n\tcontent: \"\\ecdb\";\n}\n\n.icofont-pencil-alt-3:before {\n\tcontent: \"\\ecdc\";\n}\n\n.icofont-pencil-alt-4:before {\n\tcontent: \"\\ecdd\";\n}\n\n.icofont-ruler-alt-1:before {\n\tcontent: \"\\ecde\";\n}\n\n.icofont-ruler-alt-2:before {\n\tcontent: \"\\ecdf\";\n}\n\n.icofont-ruler-compass-alt:before {\n\tcontent: \"\\ece0\";\n}\n\n.icofont-ruler-compass:before {\n\tcontent: \"\\ece1\";\n}\n\n.icofont-ruler-pencil-alt-1:before {\n\tcontent: \"\\ece2\";\n}\n\n.icofont-ruler-pencil-alt-2:before {\n\tcontent: \"\\ece3\";\n}\n\n.icofont-ruler-pencil:before {\n\tcontent: \"\\ece4\";\n}\n\n.icofont-ruler:before {\n\tcontent: \"\\ece5\";\n}\n\n.icofont-rulers-alt:before {\n\tcontent: \"\\ece6\";\n}\n\n.icofont-rulers:before {\n\tcontent: \"\\ece7\";\n}\n\n.icofont-square-root:before {\n\tcontent: \"\\ece8\";\n}\n\n.icofont-aids:before {\n\tcontent: \"\\ece9\";\n}\n\n.icofont-ambulance:before {\n\tcontent: \"\\ecea\";\n}\n\n.icofont-autism:before {\n\tcontent: \"\\eceb\";\n}\n\n.icofont-bandage:before {\n\tcontent: \"\\ecec\";\n}\n\n.icofont-bed-patient:before {\n\tcontent: \"\\eced\";\n}\n\n.icofont-blind:before {\n\tcontent: \"\\ecee\";\n}\n\n.icofont-blood-drop:before {\n\tcontent: \"\\ecef\";\n}\n\n.icofont-blood-test:before {\n\tcontent: \"\\ecf0\";\n}\n\n.icofont-blood:before {\n\tcontent: \"\\ecf1\";\n}\n\n.icofont-capsule:before {\n\tcontent: \"\\ecf2\";\n}\n\n.icofont-crutches:before {\n\tcontent: \"\\ecf3\";\n}\n\n.icofont-dna-alt-1:before {\n\tcontent: \"\\ecf4\";\n}\n\n.icofont-dna:before {\n\tcontent: \"\\ecf5\";\n}\n\n.icofont-doctor-alt:before {\n\tcontent: \"\\ecf6\";\n}\n\n.icofont-doctor:before {\n\tcontent: \"\\ecf7\";\n}\n\n.icofont-drug-pack:before {\n\tcontent: \"\\ecf8\";\n}\n\n.icofont-drug:before {\n\tcontent: \"\\ecf9\";\n}\n\n.icofont-eye-alt:before {\n\tcontent: \"\\ecfa\";\n}\n\n.icofont-first-aid-alt:before {\n\tcontent: \"\\ecfb\";\n}\n\n.icofont-garbage:before {\n\tcontent: \"\\ecfc\";\n}\n\n.icofont-heart-alt:before {\n\tcontent: \"\\ecfd\";\n}\n\n.icofont-heartbeat:before {\n\tcontent: \"\\ecfe\";\n}\n\n.icofont-herbal:before {\n\tcontent: \"\\ecff\";\n}\n\n.icofont-hospital:before {\n\tcontent: \"\\ed00\";\n}\n\n.icofont-icu:before {\n\tcontent: \"\\ed01\";\n}\n\n.icofont-injection-syringe:before {\n\tcontent: \"\\ed02\";\n}\n\n.icofont-laboratory:before {\n\tcontent: \"\\ed03\";\n}\n\n.icofont-medical-sign-alt:before {\n\tcontent: \"\\ed04\";\n}\n\n.icofont-medical-sign:before {\n\tcontent: \"\\ed05\";\n}\n\n.icofont-nurse-alt:before {\n\tcontent: \"\\ed06\";\n}\n\n.icofont-nurse:before {\n\tcontent: \"\\ed07\";\n}\n\n.icofont-nursing-home:before {\n\tcontent: \"\\ed08\";\n}\n\n.icofont-operation-theater:before {\n\tcontent: \"\\ed09\";\n}\n\n.icofont-paralysis-disability:before {\n\tcontent: \"\\ed0a\";\n}\n\n.icofont-pills:before {\n\tcontent: \"\\ed0b\";\n}\n\n.icofont-prescription:before {\n\tcontent: \"\\ed0c\";\n}\n\n.icofont-pulse:before {\n\tcontent: \"\\ed0d\";\n}\n\n.icofont-stethoscope-alt:before {\n\tcontent: \"\\ed0e\";\n}\n\n.icofont-stethoscope:before {\n\tcontent: \"\\ed0f\";\n}\n\n.icofont-stretcher:before {\n\tcontent: \"\\ed10\";\n}\n\n.icofont-surgeon-alt:before {\n\tcontent: \"\\ed11\";\n}\n\n.icofont-surgeon:before {\n\tcontent: \"\\ed12\";\n}\n\n.icofont-tablets:before {\n\tcontent: \"\\ed13\";\n}\n\n.icofont-test-bottle:before {\n\tcontent: \"\\ed14\";\n}\n\n.icofont-test-tube:before {\n\tcontent: \"\\ed15\";\n}\n\n.icofont-thermometer-alt:before {\n\tcontent: \"\\ed16\";\n}\n\n.icofont-tooth:before {\n\tcontent: \"\\ed17\";\n}\n\n.icofont-xray:before {\n\tcontent: \"\\ed18\";\n}\n\n.icofont-ui-add:before {\n\tcontent: \"\\ed19\";\n}\n\n.icofont-ui-alarm:before {\n\tcontent: \"\\ed1a\";\n}\n\n.icofont-ui-battery:before {\n\tcontent: \"\\ed1b\";\n}\n\n.icofont-ui-block:before {\n\tcontent: \"\\ed1c\";\n}\n\n.icofont-ui-bluetooth:before {\n\tcontent: \"\\ed1d\";\n}\n\n.icofont-ui-brightness:before {\n\tcontent: \"\\ed1e\";\n}\n\n.icofont-ui-browser:before {\n\tcontent: \"\\ed1f\";\n}\n\n.icofont-ui-calculator:before {\n\tcontent: \"\\ed20\";\n}\n\n.icofont-ui-calendar:before {\n\tcontent: \"\\ed21\";\n}\n\n.icofont-ui-call:before {\n\tcontent: \"\\ed22\";\n}\n\n.icofont-ui-camera:before {\n\tcontent: \"\\ed23\";\n}\n\n.icofont-ui-cart:before {\n\tcontent: \"\\ed24\";\n}\n\n.icofont-ui-cell-phone:before {\n\tcontent: \"\\ed25\";\n}\n\n.icofont-ui-chat:before {\n\tcontent: \"\\ed26\";\n}\n\n.icofont-ui-check:before {\n\tcontent: \"\\ed27\";\n}\n\n.icofont-ui-clip-board:before {\n\tcontent: \"\\ed28\";\n}\n\n.icofont-ui-clip:before {\n\tcontent: \"\\ed29\";\n}\n\n.icofont-ui-clock:before {\n\tcontent: \"\\ed2a\";\n}\n\n.icofont-ui-close:before {\n\tcontent: \"\\ed2b\";\n}\n\n.icofont-ui-contact-list:before {\n\tcontent: \"\\ed2c\";\n}\n\n.icofont-ui-copy:before {\n\tcontent: \"\\ed2d\";\n}\n\n.icofont-ui-cut:before {\n\tcontent: \"\\ed2e\";\n}\n\n.icofont-ui-delete:before {\n\tcontent: \"\\ed2f\";\n}\n\n.icofont-ui-dial-phone:before {\n\tcontent: \"\\ed30\";\n}\n\n.icofont-ui-edit:before {\n\tcontent: \"\\ed31\";\n}\n\n.icofont-ui-email:before {\n\tcontent: \"\\ed32\";\n}\n\n.icofont-ui-file:before {\n\tcontent: \"\\ed33\";\n}\n\n.icofont-ui-fire-wall:before {\n\tcontent: \"\\ed34\";\n}\n\n.icofont-ui-flash-light:before {\n\tcontent: \"\\ed35\";\n}\n\n.icofont-ui-flight:before {\n\tcontent: \"\\ed36\";\n}\n\n.icofont-ui-folder:before {\n\tcontent: \"\\ed37\";\n}\n\n.icofont-ui-game:before {\n\tcontent: \"\\ed38\";\n}\n\n.icofont-ui-handicapped:before {\n\tcontent: \"\\ed39\";\n}\n\n.icofont-ui-head-phone:before {\n\tcontent: \"\\ed3a\";\n}\n\n.icofont-ui-home:before {\n\tcontent: \"\\ed3b\";\n}\n\n.icofont-ui-image:before {\n\tcontent: \"\\ed3c\";\n}\n\n.icofont-ui-keyboard:before {\n\tcontent: \"\\ed3d\";\n}\n\n.icofont-ui-laoding:before {\n\tcontent: \"\\ed3e\";\n}\n\n.icofont-ui-lock:before {\n\tcontent: \"\\ed3f\";\n}\n\n.icofont-ui-love-add:before {\n\tcontent: \"\\ed40\";\n}\n\n.icofont-ui-love-broken:before {\n\tcontent: \"\\ed41\";\n}\n\n.icofont-ui-love-remove:before {\n\tcontent: \"\\ed42\";\n}\n\n.icofont-ui-love:before {\n\tcontent: \"\\ed43\";\n}\n\n.icofont-ui-map:before {\n\tcontent: \"\\ed44\";\n}\n\n.icofont-ui-message:before {\n\tcontent: \"\\ed45\";\n}\n\n.icofont-ui-messaging:before {\n\tcontent: \"\\ed46\";\n}\n\n.icofont-ui-movie:before {\n\tcontent: \"\\ed47\";\n}\n\n.icofont-ui-music-player:before {\n\tcontent: \"\\ed48\";\n}\n\n.icofont-ui-music:before {\n\tcontent: \"\\ed49\";\n}\n\n.icofont-ui-mute:before {\n\tcontent: \"\\ed4a\";\n}\n\n.icofont-ui-network:before {\n\tcontent: \"\\ed4b\";\n}\n\n.icofont-ui-next:before {\n\tcontent: \"\\ed4c\";\n}\n\n.icofont-ui-note:before {\n\tcontent: \"\\ed4d\";\n}\n\n.icofont-ui-office:before {\n\tcontent: \"\\ed4e\";\n}\n\n.icofont-ui-password:before {\n\tcontent: \"\\ed4f\";\n}\n\n.icofont-ui-pause:before {\n\tcontent: \"\\ed50\";\n}\n\n.icofont-ui-play-stop:before {\n\tcontent: \"\\ed51\";\n}\n\n.icofont-ui-play:before {\n\tcontent: \"\\ed52\";\n}\n\n.icofont-ui-pointer:before {\n\tcontent: \"\\ed53\";\n}\n\n.icofont-ui-power:before {\n\tcontent: \"\\ed54\";\n}\n\n.icofont-ui-press:before {\n\tcontent: \"\\ed55\";\n}\n\n.icofont-ui-previous:before {\n\tcontent: \"\\ed56\";\n}\n\n.icofont-ui-rate-add:before {\n\tcontent: \"\\ed57\";\n}\n\n.icofont-ui-rate-blank:before {\n\tcontent: \"\\ed58\";\n}\n\n.icofont-ui-rate-remove:before {\n\tcontent: \"\\ed59\";\n}\n\n.icofont-ui-rating:before {\n\tcontent: \"\\ed5a\";\n}\n\n.icofont-ui-record:before {\n\tcontent: \"\\ed5b\";\n}\n\n.icofont-ui-remove:before {\n\tcontent: \"\\ed5c\";\n}\n\n.icofont-ui-reply:before {\n\tcontent: \"\\ed5d\";\n}\n\n.icofont-ui-rotation:before {\n\tcontent: \"\\ed5e\";\n}\n\n.icofont-ui-rss:before {\n\tcontent: \"\\ed5f\";\n}\n\n.icofont-ui-search:before {\n\tcontent: \"\\ed60\";\n}\n\n.icofont-ui-settings:before {\n\tcontent: \"\\ed61\";\n}\n\n.icofont-ui-social-link:before {\n\tcontent: \"\\ed62\";\n}\n\n.icofont-ui-tag:before {\n\tcontent: \"\\ed63\";\n}\n\n.icofont-ui-text-chat:before {\n\tcontent: \"\\ed64\";\n}\n\n.icofont-ui-text-loading:before {\n\tcontent: \"\\ed65\";\n}\n\n.icofont-ui-theme:before {\n\tcontent: \"\\ed66\";\n}\n\n.icofont-ui-timer:before {\n\tcontent: \"\\ed67\";\n}\n\n.icofont-ui-touch-phone:before {\n\tcontent: \"\\ed68\";\n}\n\n.icofont-ui-travel:before {\n\tcontent: \"\\ed69\";\n}\n\n.icofont-ui-unlock:before {\n\tcontent: \"\\ed6a\";\n}\n\n.icofont-ui-user-group:before {\n\tcontent: \"\\ed6b\";\n}\n\n.icofont-ui-user:before {\n\tcontent: \"\\ed6c\";\n}\n\n.icofont-ui-v-card:before {\n\tcontent: \"\\ed6d\";\n}\n\n.icofont-ui-video-chat:before {\n\tcontent: \"\\ed6e\";\n}\n\n.icofont-ui-video-message:before {\n\tcontent: \"\\ed6f\";\n}\n\n.icofont-ui-video-play:before {\n\tcontent: \"\\ed70\";\n}\n\n.icofont-ui-video:before {\n\tcontent: \"\\ed71\";\n}\n\n.icofont-ui-volume:before {\n\tcontent: \"\\ed72\";\n}\n\n.icofont-ui-weather:before {\n\tcontent: \"\\ed73\";\n}\n\n.icofont-ui-wifi:before {\n\tcontent: \"\\ed74\";\n}\n\n.icofont-ui-zoom-in:before {\n\tcontent: \"\\ed75\";\n}\n\n.icofont-ui-zoom-out:before {\n\tcontent: \"\\ed76\";\n}\n\n.icofont-cassette-player:before {\n\tcontent: \"\\ed77\";\n}\n\n.icofont-cassette:before {\n\tcontent: \"\\ed78\";\n}\n\n.icofont-forward:before {\n\tcontent: \"\\ed79\";\n}\n\n.icofont-game:before {\n\tcontent: \"\\ed7a\";\n}\n\n.icofont-guiter:before {\n\tcontent: \"\\ed7b\";\n}\n\n.icofont-headphone-alt-1:before {\n\tcontent: \"\\ed7c\";\n}\n\n.icofont-headphone-alt-2:before {\n\tcontent: \"\\ed7d\";\n}\n\n.icofont-headphone-alt-3:before {\n\tcontent: \"\\ed7e\";\n}\n\n.icofont-listening:before {\n\tcontent: \"\\ed7f\";\n}\n\n.icofont-megaphone-alt:before {\n\tcontent: \"\\ed80\";\n}\n\n.icofont-megaphone:before {\n\tcontent: \"\\ed81\";\n}\n\n.icofont-movie:before {\n\tcontent: \"\\ed82\";\n}\n\n.icofont-mp3-player:before {\n\tcontent: \"\\ed83\";\n}\n\n.icofont-multimedia:before {\n\tcontent: \"\\ed84\";\n}\n\n.icofont-music-disk:before {\n\tcontent: \"\\ed85\";\n}\n\n.icofont-music-note:before {\n\tcontent: \"\\ed86\";\n}\n\n.icofont-pause:before {\n\tcontent: \"\\ed87\";\n}\n\n.icofont-play-alt-1:before {\n\tcontent: \"\\ed88\";\n}\n\n.icofont-play-alt-2:before {\n\tcontent: \"\\ed89\";\n}\n\n.icofont-play-alt-3:before {\n\tcontent: \"\\ed8a\";\n}\n\n.icofont-play-pause:before {\n\tcontent: \"\\ed8b\";\n}\n\n.icofont-record:before {\n\tcontent: \"\\ed8c\";\n}\n\n.icofont-retro-music-disk:before {\n\tcontent: \"\\ed8d\";\n}\n\n.icofont-rewind:before {\n\tcontent: \"\\ed8e\";\n}\n\n.icofont-song-notes:before {\n\tcontent: \"\\ed8f\";\n}\n\n.icofont-sound-wave-alt:before {\n\tcontent: \"\\ed90\";\n}\n\n.icofont-sound-wave:before {\n\tcontent: \"\\ed91\";\n}\n\n.icofont-stop:before {\n\tcontent: \"\\ed92\";\n}\n\n.icofont-video-alt:before {\n\tcontent: \"\\ed93\";\n}\n\n.icofont-video-cam:before {\n\tcontent: \"\\ed94\";\n}\n\n.icofont-volume-bar:before {\n\tcontent: \"\\ed95\";\n}\n\n.icofont-volume-mute:before {\n\tcontent: \"\\ed96\";\n}\n\n.icofont-youtube-play:before {\n\tcontent: \"\\ed97\";\n}\n\n.icofont-amazon-alt:before {\n\tcontent: \"\\ed98\";\n}\n\n.icofont-amazon:before {\n\tcontent: \"\\ed99\";\n}\n\n.icofont-american-express-alt:before {\n\tcontent: \"\\ed9a\";\n}\n\n.icofont-american-express:before {\n\tcontent: \"\\ed9b\";\n}\n\n.icofont-apple-pay-alt:before {\n\tcontent: \"\\ed9c\";\n}\n\n.icofont-apple-pay:before {\n\tcontent: \"\\ed9d\";\n}\n\n.icofont-bank-transfer-alt:before {\n\tcontent: \"\\ed9e\";\n}\n\n.icofont-bank-transfer:before {\n\tcontent: \"\\ed9f\";\n}\n\n.icofont-braintree-alt:before {\n\tcontent: \"\\eda0\";\n}\n\n.icofont-braintree:before {\n\tcontent: \"\\eda1\";\n}\n\n.icofont-cash-on-delivery-alt:before {\n\tcontent: \"\\eda2\";\n}\n\n.icofont-cash-on-delivery:before {\n\tcontent: \"\\eda3\";\n}\n\n.icofont-checkout-alt:before {\n\tcontent: \"\\eda4\";\n}\n\n.icofont-checkout:before {\n\tcontent: \"\\eda5\";\n}\n\n.icofont-diners-club-alt-1:before {\n\tcontent: \"\\eda6\";\n}\n\n.icofont-diners-club-alt-2:before {\n\tcontent: \"\\eda7\";\n}\n\n.icofont-diners-club-alt-3:before {\n\tcontent: \"\\eda8\";\n}\n\n.icofont-diners-club:before {\n\tcontent: \"\\eda9\";\n}\n\n.icofont-discover-alt:before {\n\tcontent: \"\\edaa\";\n}\n\n.icofont-discover:before {\n\tcontent: \"\\edab\";\n}\n\n.icofont-eway-alt:before {\n\tcontent: \"\\edac\";\n}\n\n.icofont-eway:before {\n\tcontent: \"\\edad\";\n}\n\n.icofont-google-wallet-alt-1:before {\n\tcontent: \"\\edae\";\n}\n\n.icofont-google-wallet-alt-2:before {\n\tcontent: \"\\edaf\";\n}\n\n.icofont-google-wallet-alt-3:before {\n\tcontent: \"\\edb0\";\n}\n\n.icofont-google-wallet:before {\n\tcontent: \"\\edb1\";\n}\n\n.icofont-jcb-alt:before {\n\tcontent: \"\\edb2\";\n}\n\n.icofont-jcb:before {\n\tcontent: \"\\edb3\";\n}\n\n.icofont-maestro-alt:before {\n\tcontent: \"\\edb4\";\n}\n\n.icofont-maestro:before {\n\tcontent: \"\\edb5\";\n}\n\n.icofont-mastercard-alt:before {\n\tcontent: \"\\edb6\";\n}\n\n.icofont-mastercard:before {\n\tcontent: \"\\edb7\";\n}\n\n.icofont-payoneer-alt:before {\n\tcontent: \"\\edb8\";\n}\n\n.icofont-payoneer:before {\n\tcontent: \"\\edb9\";\n}\n\n.icofont-paypal-alt:before {\n\tcontent: \"\\edba\";\n}\n\n.icofont-paypal:before {\n\tcontent: \"\\edbb\";\n}\n\n.icofont-sage-alt:before {\n\tcontent: \"\\edbc\";\n}\n\n.icofont-sage:before {\n\tcontent: \"\\edbd\";\n}\n\n.icofont-skrill-alt:before {\n\tcontent: \"\\edbe\";\n}\n\n.icofont-skrill:before {\n\tcontent: \"\\edbf\";\n}\n\n.icofont-stripe-alt:before {\n\tcontent: \"\\edc0\";\n}\n\n.icofont-stripe:before {\n\tcontent: \"\\edc1\";\n}\n\n.icofont-visa-alt:before {\n\tcontent: \"\\edc2\";\n}\n\n.icofont-visa-electron:before {\n\tcontent: \"\\edc3\";\n}\n\n.icofont-visa:before {\n\tcontent: \"\\edc4\";\n}\n\n.icofont-western-union-alt:before {\n\tcontent: \"\\edc5\";\n}\n\n.icofont-western-union:before {\n\tcontent: \"\\edc6\";\n}\n\n.icofont-boy:before {\n\tcontent: \"\\edc7\";\n}\n\n.icofont-business-man-alt-1:before {\n\tcontent: \"\\edc8\";\n}\n\n.icofont-business-man-alt-2:before {\n\tcontent: \"\\edc9\";\n}\n\n.icofont-business-man-alt-3:before {\n\tcontent: \"\\edca\";\n}\n\n.icofont-business-man:before {\n\tcontent: \"\\edcb\";\n}\n\n.icofont-funky-man:before {\n\tcontent: \"\\edcc\";\n}\n\n.icofont-girl-alt:before {\n\tcontent: \"\\edcd\";\n}\n\n.icofont-girl:before {\n\tcontent: \"\\edce\";\n}\n\n.icofont-hotel-boy-alt:before {\n\tcontent: \"\\edcf\";\n}\n\n.icofont-hotel-boy:before {\n\tcontent: \"\\edd0\";\n}\n\n.icofont-man-in-glasses:before {\n\tcontent: \"\\edd1\";\n}\n\n.icofont-user-alt-1:before {\n\tcontent: \"\\edd2\";\n}\n\n.icofont-user-alt-2:before {\n\tcontent: \"\\edd3\";\n}\n\n.icofont-user-alt-3:before {\n\tcontent: \"\\edd4\";\n}\n\n.icofont-user-alt-4:before {\n\tcontent: \"\\edd5\";\n}\n\n.icofont-user-alt-5:before {\n\tcontent: \"\\edd6\";\n}\n\n.icofont-user-alt-6:before {\n\tcontent: \"\\edd7\";\n}\n\n.icofont-user-alt-7:before {\n\tcontent: \"\\edd8\";\n}\n\n.icofont-user-female:before {\n\tcontent: \"\\edd9\";\n}\n\n.icofont-user-male:before {\n\tcontent: \"\\edda\";\n}\n\n.icofont-user-suited:before {\n\tcontent: \"\\eddb\";\n}\n\n.icofont-user:before {\n\tcontent: \"\\eddc\";\n}\n\n.icofont-users-alt-1:before {\n\tcontent: \"\\eddd\";\n}\n\n.icofont-users-alt-2:before {\n\tcontent: \"\\edde\";\n}\n\n.icofont-users-alt-3:before {\n\tcontent: \"\\eddf\";\n}\n\n.icofont-users-alt-4:before {\n\tcontent: \"\\ede0\";\n}\n\n.icofont-users-alt-5:before {\n\tcontent: \"\\ede1\";\n}\n\n.icofont-users-alt-6:before {\n\tcontent: \"\\ede2\";\n}\n\n.icofont-users-social:before {\n\tcontent: \"\\ede3\";\n}\n\n.icofont-users:before {\n\tcontent: \"\\ede4\";\n}\n\n.icofont-waiter:before {\n\tcontent: \"\\ede5\";\n}\n\n.icofont-woman-in-glasses:before {\n\tcontent: \"\\ede6\";\n}\n\n.icofont-document-search:before {\n\tcontent: \"\\ede7\";\n}\n\n.icofont-folder-search:before {\n\tcontent: \"\\ede8\";\n}\n\n.icofont-home-search:before {\n\tcontent: \"\\ede9\";\n}\n\n.icofont-job-search:before {\n\tcontent: \"\\edea\";\n}\n\n.icofont-map-search:before {\n\tcontent: \"\\edeb\";\n}\n\n.icofont-restaurant-search:before {\n\tcontent: \"\\edec\";\n}\n\n.icofont-search-alt-1:before {\n\tcontent: \"\\eded\";\n}\n\n.icofont-search-alt-2:before {\n\tcontent: \"\\edee\";\n}\n\n.icofont-search:before {\n\tcontent: \"\\edef\";\n}\n\n.icofont-stock-search:before {\n\tcontent: \"\\edf0\";\n}\n\n.icofont-user-search:before {\n\tcontent: \"\\edf1\";\n}\n\n.icofont-social-aim:before {\n\tcontent: \"\\edf2\";\n}\n\n.icofont-social-badoo:before {\n\tcontent: \"\\edf3\";\n}\n\n.icofont-social-bebo:before {\n\tcontent: \"\\edf4\";\n}\n\n.icofont-social-behance:before {\n\tcontent: \"\\edf5\";\n}\n\n.icofont-social-blogger:before {\n\tcontent: \"\\edf6\";\n}\n\n.icofont-social-bootstrap:before {\n\tcontent: \"\\edf7\";\n}\n\n.icofont-social-brightkite:before {\n\tcontent: \"\\edf8\";\n}\n\n.icofont-social-cloudapp:before {\n\tcontent: \"\\edf9\";\n}\n\n.icofont-social-concrete5:before {\n\tcontent: \"\\edfa\";\n}\n\n.icofont-social-designbump:before {\n\tcontent: \"\\edfb\";\n}\n\n.icofont-social-designfloat:before {\n\tcontent: \"\\edfc\";\n}\n\n.icofont-social-deviantart:before {\n\tcontent: \"\\edfd\";\n}\n\n.icofont-social-digg:before {\n\tcontent: \"\\edfe\";\n}\n\n.icofont-social-dotcms:before {\n\tcontent: \"\\edff\";\n}\n\n.icofont-social-dribble:before {\n\tcontent: \"\\ee00\";\n}\n\n.icofont-social-dropbox:before {\n\tcontent: \"\\ee01\";\n}\n\n.icofont-brand-drupal:before {\n\tcontent: \"\\ee02\";\n}\n\n.icofont-social-ebuddy:before {\n\tcontent: \"\\ee03\";\n}\n\n.icofont-social-ello:before {\n\tcontent: \"\\ee04\";\n}\n\n.icofont-social-ember:before {\n\tcontent: \"\\ee05\";\n}\n\n.icofont-social-envato:before {\n\tcontent: \"\\ee06\";\n}\n\n.icofont-social-evernote:before {\n\tcontent: \"\\ee07\";\n}\n\n.icofont-social-facebook:before {\n\tcontent: \"\\ee08\";\n}\n\n.icofont-social-feedburner:before {\n\tcontent: \"\\ee09\";\n}\n\n.icofont-social-folkd:before {\n\tcontent: \"\\ee0a\";\n}\n\n.icofont-social-friendfeed:before {\n\tcontent: \"\\ee0b\";\n}\n\n.icofont-social-ghost:before {\n\tcontent: \"\\ee0c\";\n}\n\n.icofont-social-github:before {\n\tcontent: \"\\ee0d\";\n}\n\n.icofont-social-gnome:before {\n\tcontent: \"\\ee0e\";\n}\n\n.icofont-social-google-buzz:before {\n\tcontent: \"\\ee0f\";\n}\n\n.icofont-social-google-map:before {\n\tcontent: \"\\ee10\";\n}\n\n.icofont-social-google-plus:before {\n\tcontent: \"\\ee11\";\n}\n\n.icofont-social-google-talk:before {\n\tcontent: \"\\ee12\";\n}\n\n.icofont-social-hype-machine:before {\n\tcontent: \"\\ee13\";\n}\n\n.icofont-social-instagram:before {\n\tcontent: \"\\ee14\";\n}\n\n.icofont-brand-joomla:before {\n\tcontent: \"\\ee15\";\n}\n\n.icofont-social-kickstarter:before {\n\tcontent: \"\\ee16\";\n}\n\n.icofont-social-line:before {\n\tcontent: \"\\ee17\";\n}\n\n.icofont-social-linux-mint:before {\n\tcontent: \"\\ee18\";\n}\n\n.icofont-social-livejournal:before {\n\tcontent: \"\\ee19\";\n}\n\n.icofont-social-magento:before {\n\tcontent: \"\\ee1a\";\n}\n\n.icofont-social-meetup:before {\n\tcontent: \"\\ee1b\";\n}\n\n.icofont-social-mixx:before {\n\tcontent: \"\\ee1c\";\n}\n\n.icofont-social-newsvine:before {\n\tcontent: \"\\ee1d\";\n}\n\n.icofont-social-nimbuss:before {\n\tcontent: \"\\ee1e\";\n}\n\n.icofont-social-opencart:before {\n\tcontent: \"\\ee1f\";\n}\n\n.icofont-social-oscommerce:before {\n\tcontent: \"\\ee20\";\n}\n\n.icofont-social-pandora:before {\n\tcontent: \"\\ee21\";\n}\n\n.icofont-social-picasa:before {\n\tcontent: \"\\ee22\";\n}\n\n.icofont-social-pinterest:before {\n\tcontent: \"\\ee23\";\n}\n\n.icofont-social-prestashop:before {\n\tcontent: \"\\ee24\";\n}\n\n.icofont-social-qik:before {\n\tcontent: \"\\ee25\";\n}\n\n.icofont-social-readernaut:before {\n\tcontent: \"\\ee26\";\n}\n\n.icofont-social-reddit:before {\n\tcontent: \"\\ee27\";\n}\n\n.icofont-social-rss:before {\n\tcontent: \"\\ee28\";\n}\n\n.icofont-social-shopify:before {\n\tcontent: \"\\ee29\";\n}\n\n.icofont-social-silverstripe:before {\n\tcontent: \"\\ee2a\";\n}\n\n.icofont-social-skype:before {\n\tcontent: \"\\ee2b\";\n}\n\n.icofont-social-slashdot:before {\n\tcontent: \"\\ee2c\";\n}\n\n.icofont-social-smugmug:before {\n\tcontent: \"\\ee2d\";\n}\n\n.icofont-social-steam:before {\n\tcontent: \"\\ee2e\";\n}\n\n.icofont-social-stumbleupon:before {\n\tcontent: \"\\ee2f\";\n}\n\n.icofont-social-technorati:before {\n\tcontent: \"\\ee30\";\n}\n\n.icofont-social-telegram:before {\n\tcontent: \"\\ee31\";\n}\n\n.icofont-social-tinder:before {\n\tcontent: \"\\ee32\";\n}\n\n.icofont-social-tumblr:before {\n\tcontent: \"\\ee33\";\n}\n\n.icofont-social-twitter:before {\n\tcontent: \"\\ee34\";\n}\n\n.icofont-social-typo3:before {\n\tcontent: \"\\ee35\";\n}\n\n.icofont-social-ubercart:before {\n\tcontent: \"\\ee36\";\n}\n\n.icofont-social-viber:before {\n\tcontent: \"\\ee37\";\n}\n\n.icofont-social-viddler:before {\n\tcontent: \"\\ee38\";\n}\n\n.icofont-social-vimeo:before {\n\tcontent: \"\\ee39\";\n}\n\n.icofont-social-vine:before {\n\tcontent: \"\\ee3a\";\n}\n\n.icofont-social-virb:before {\n\tcontent: \"\\ee3b\";\n}\n\n.icofont-social-virtuemart:before {\n\tcontent: \"\\ee3c\";\n}\n\n.icofont-social-wechat:before {\n\tcontent: \"\\ee3d\";\n}\n\n.icofont-brand-wordpress:before {\n\tcontent: \"\\ee3e\";\n}\n\n.icofont-social-xing:before {\n\tcontent: \"\\ee3f\";\n}\n\n.icofont-social-yahoo:before {\n\tcontent: \"\\ee40\";\n}\n\n.icofont-social-yelp:before {\n\tcontent: \"\\ee41\";\n}\n\n.icofont-social-zencart:before {\n\tcontent: \"\\ee42\";\n}\n\n.icofont-badminton-birdie:before {\n\tcontent: \"\\ee43\";\n}\n\n.icofont-baseball:before {\n\tcontent: \"\\ee44\";\n}\n\n.icofont-baseballer:before {\n\tcontent: \"\\ee45\";\n}\n\n.icofont-basketball-hoop:before {\n\tcontent: \"\\ee46\";\n}\n\n.icofont-basketball:before {\n\tcontent: \"\\ee47\";\n}\n\n.icofont-billiard-ball:before {\n\tcontent: \"\\ee48\";\n}\n\n.icofont-boot-alt-1:before {\n\tcontent: \"\\ee49\";\n}\n\n.icofont-boot-alt-2:before {\n\tcontent: \"\\ee4a\";\n}\n\n.icofont-bowling-alt:before {\n\tcontent: \"\\ee4b\";\n}\n\n.icofont-bowling:before {\n\tcontent: \"\\ee4c\";\n}\n\n.icofont-canoe:before {\n\tcontent: \"\\ee4d\";\n}\n\n.icofont-cheer-leader:before {\n\tcontent: \"\\ee4e\";\n}\n\n.icofont-climbing:before {\n\tcontent: \"\\ee4f\";\n}\n\n.icofont-corner:before {\n\tcontent: \"\\ee50\";\n}\n\n.icofont-cyclist:before {\n\tcontent: \"\\ee51\";\n}\n\n.icofont-dumbbell-alt:before {\n\tcontent: \"\\ee52\";\n}\n\n.icofont-dumbbell:before {\n\tcontent: \"\\ee53\";\n}\n\n.icofont-field-alt:before {\n\tcontent: \"\\ee54\";\n}\n\n.icofont-field:before {\n\tcontent: \"\\ee55\";\n}\n\n.icofont-football-alt:before {\n\tcontent: \"\\ee56\";\n}\n\n.icofont-foul:before {\n\tcontent: \"\\ee57\";\n}\n\n.icofont-goal-keeper:before {\n\tcontent: \"\\ee58\";\n}\n\n.icofont-goal:before {\n\tcontent: \"\\ee59\";\n}\n\n.icofont-golf-alt:before {\n\tcontent: \"\\ee5a\";\n}\n\n.icofont-golf-bag:before {\n\tcontent: \"\\ee5b\";\n}\n\n.icofont-golf-field:before {\n\tcontent: \"\\ee5c\";\n}\n\n.icofont-golf:before {\n\tcontent: \"\\ee5d\";\n}\n\n.icofont-golfer:before {\n\tcontent: \"\\ee5e\";\n}\n\n.icofont-gym-alt-1:before {\n\tcontent: \"\\ee5f\";\n}\n\n.icofont-gym-alt-2:before {\n\tcontent: \"\\ee60\";\n}\n\n.icofont-gym-alt-3:before {\n\tcontent: \"\\ee61\";\n}\n\n.icofont-gym:before {\n\tcontent: \"\\ee62\";\n}\n\n.icofont-hand-grippers:before {\n\tcontent: \"\\ee63\";\n}\n\n.icofont-heart-beat-alt:before {\n\tcontent: \"\\ee64\";\n}\n\n.icofont-helmet:before {\n\tcontent: \"\\ee65\";\n}\n\n.icofont-hockey-alt:before {\n\tcontent: \"\\ee66\";\n}\n\n.icofont-hockey:before {\n\tcontent: \"\\ee67\";\n}\n\n.icofont-ice-skate:before {\n\tcontent: \"\\ee68\";\n}\n\n.icofont-jersey-alt:before {\n\tcontent: \"\\ee69\";\n}\n\n.icofont-jersey:before {\n\tcontent: \"\\ee6a\";\n}\n\n.icofont-jumping:before {\n\tcontent: \"\\ee6b\";\n}\n\n.icofont-kick:before {\n\tcontent: \"\\ee6c\";\n}\n\n.icofont-leg:before {\n\tcontent: \"\\ee6d\";\n}\n\n.icofont-match-review:before {\n\tcontent: \"\\ee6e\";\n}\n\n.icofont-medal-alt:before {\n\tcontent: \"\\ee6f\";\n}\n\n.icofont-muscle-alt:before {\n\tcontent: \"\\ee70\";\n}\n\n.icofont-muscle:before {\n\tcontent: \"\\ee71\";\n}\n\n.icofont-offside:before {\n\tcontent: \"\\ee72\";\n}\n\n.icofont-olympic-logo:before {\n\tcontent: \"\\ee73\";\n}\n\n.icofont-olympic:before {\n\tcontent: \"\\ee74\";\n}\n\n.icofont-padding:before {\n\tcontent: \"\\ee75\";\n}\n\n.icofont-penalty-card:before {\n\tcontent: \"\\ee76\";\n}\n\n.icofont-racer:before {\n\tcontent: \"\\ee77\";\n}\n\n.icofont-racing-car:before {\n\tcontent: \"\\ee78\";\n}\n\n.icofont-racing-flag-alt:before {\n\tcontent: \"\\ee79\";\n}\n\n.icofont-racing-flag:before {\n\tcontent: \"\\ee7a\";\n}\n\n.icofont-racings-wheel:before {\n\tcontent: \"\\ee7b\";\n}\n\n.icofont-referee:before {\n\tcontent: \"\\ee7c\";\n}\n\n.icofont-refree-jersey:before {\n\tcontent: \"\\ee7d\";\n}\n\n.icofont-result:before {\n\tcontent: \"\\ee7e\";\n}\n\n.icofont-rugby-ball:before {\n\tcontent: \"\\ee7f\";\n}\n\n.icofont-rugby-player:before {\n\tcontent: \"\\ee80\";\n}\n\n.icofont-rugby:before {\n\tcontent: \"\\ee81\";\n}\n\n.icofont-runner-alt-1:before {\n\tcontent: \"\\ee82\";\n}\n\n.icofont-runner-alt-2:before {\n\tcontent: \"\\ee83\";\n}\n\n.icofont-runner:before {\n\tcontent: \"\\ee84\";\n}\n\n.icofont-score-board:before {\n\tcontent: \"\\ee85\";\n}\n\n.icofont-skiing-man:before {\n\tcontent: \"\\ee86\";\n}\n\n.icofont-skydiving-goggles:before {\n\tcontent: \"\\ee87\";\n}\n\n.icofont-snow-mobile:before {\n\tcontent: \"\\ee88\";\n}\n\n.icofont-steering:before {\n\tcontent: \"\\ee89\";\n}\n\n.icofont-substitute:before {\n\tcontent: \"\\ee8a\";\n}\n\n.icofont-swimmer:before {\n\tcontent: \"\\ee8b\";\n}\n\n.icofont-table-tennis:before {\n\tcontent: \"\\ee8c\";\n}\n\n.icofont-team-alt:before {\n\tcontent: \"\\ee8d\";\n}\n\n.icofont-team:before {\n\tcontent: \"\\ee8e\";\n}\n\n.icofont-tennis-player:before {\n\tcontent: \"\\ee8f\";\n}\n\n.icofont-tennis:before {\n\tcontent: \"\\ee90\";\n}\n\n.icofont-time:before {\n\tcontent: \"\\ee91\";\n}\n\n.icofont-track:before {\n\tcontent: \"\\ee92\";\n}\n\n.icofont-tracking:before {\n\tcontent: \"\\ee93\";\n}\n\n.icofont-trophy-alt:before {\n\tcontent: \"\\ee94\";\n}\n\n.icofont-trophy:before {\n\tcontent: \"\\ee95\";\n}\n\n.icofont-volleyball-alt:before {\n\tcontent: \"\\ee96\";\n}\n\n.icofont-volleyball-fire:before {\n\tcontent: \"\\ee97\";\n}\n\n.icofont-volleyball:before {\n\tcontent: \"\\ee98\";\n}\n\n.icofont-water-bottle:before {\n\tcontent: \"\\ee99\";\n}\n\n.icofont-whisle:before {\n\tcontent: \"\\ee9a\";\n}\n\n.icofont-win-trophy:before {\n\tcontent: \"\\ee9b\";\n}\n\n.icofont-align-center:before {\n\tcontent: \"\\ee9c\";\n}\n\n.icofont-align-left:before {\n\tcontent: \"\\ee9d\";\n}\n\n.icofont-align-right:before {\n\tcontent: \"\\ee9e\";\n}\n\n.icofont-all-caps:before {\n\tcontent: \"\\ee9f\";\n}\n\n.icofont-bold:before {\n\tcontent: \"\\eea0\";\n}\n\n.icofont-brush:before {\n\tcontent: \"\\eea1\";\n}\n\n.icofont-clip-board:before {\n\tcontent: \"\\eea2\";\n}\n\n.icofont-code-alt:before {\n\tcontent: \"\\eea3\";\n}\n\n.icofont-color-bucket:before {\n\tcontent: \"\\eea4\";\n}\n\n.icofont-color-picker:before {\n\tcontent: \"\\eea5\";\n}\n\n.icofont-copy-alt:before {\n\tcontent: \"\\eea6\";\n}\n\n.icofont-copy-black:before {\n\tcontent: \"\\eea7\";\n}\n\n.icofont-cut:before {\n\tcontent: \"\\eea8\";\n}\n\n.icofont-delete-alt:before {\n\tcontent: \"\\eea9\";\n}\n\n.icofont-edit-alt:before {\n\tcontent: \"\\eeaa\";\n}\n\n.icofont-eraser-alt:before {\n\tcontent: \"\\eeab\";\n}\n\n.icofont-file-alt:before {\n\tcontent: \"\\eeac\";\n}\n\n.icofont-font:before {\n\tcontent: \"\\eead\";\n}\n\n.icofont-header:before {\n\tcontent: \"\\eeae\";\n}\n\n.icofont-indent:before {\n\tcontent: \"\\eeaf\";\n}\n\n.icofont-italic-alt:before {\n\tcontent: \"\\eeb0\";\n}\n\n.icofont-justify-all:before {\n\tcontent: \"\\eeb1\";\n}\n\n.icofont-justify-center:before {\n\tcontent: \"\\eeb2\";\n}\n\n.icofont-justify-left:before {\n\tcontent: \"\\eeb3\";\n}\n\n.icofont-justify-right:before {\n\tcontent: \"\\eeb4\";\n}\n\n.icofont-line-height:before {\n\tcontent: \"\\eeb5\";\n}\n\n.icofont-link-alt:before {\n\tcontent: \"\\eeb6\";\n}\n\n.icofont-listine-dots:before {\n\tcontent: \"\\eeb7\";\n}\n\n.icofont-listing-box:before {\n\tcontent: \"\\eeb8\";\n}\n\n.icofont-listing-number:before {\n\tcontent: \"\\eeb9\";\n}\n\n.icofont-marker:before {\n\tcontent: \"\\eeba\";\n}\n\n.icofont-outdent:before {\n\tcontent: \"\\eebb\";\n}\n\n.icofont-paper-clip:before {\n\tcontent: \"\\eebc\";\n}\n\n.icofont-paragraph:before {\n\tcontent: \"\\eebd\";\n}\n\n.icofont-pin:before {\n\tcontent: \"\\eebe\";\n}\n\n.icofont-printer:before {\n\tcontent: \"\\eebf\";\n}\n\n.icofont-redo:before {\n\tcontent: \"\\eec0\";\n}\n\n.icofont-rotation:before {\n\tcontent: \"\\eec1\";\n}\n\n.icofont-save:before {\n\tcontent: \"\\eec2\";\n}\n\n.icofont-small-cap:before {\n\tcontent: \"\\eec3\";\n}\n\n.icofont-strike-through:before {\n\tcontent: \"\\eec4\";\n}\n\n.icofont-sub-listing:before {\n\tcontent: \"\\eec5\";\n}\n\n.icofont-subscript:before {\n\tcontent: \"\\eec6\";\n}\n\n.icofont-superscript:before {\n\tcontent: \"\\eec7\";\n}\n\n.icofont-table:before {\n\tcontent: \"\\eec8\";\n}\n\n.icofont-text-height:before {\n\tcontent: \"\\eec9\";\n}\n\n.icofont-text-width:before {\n\tcontent: \"\\eeca\";\n}\n\n.icofont-trash:before {\n\tcontent: \"\\eecb\";\n}\n\n.icofont-underline:before {\n\tcontent: \"\\eecc\";\n}\n\n.icofont-undo:before {\n\tcontent: \"\\eecd\";\n}\n\n.icofont-unlink:before {\n\tcontent: \"\\eece\";\n}\n\n.icofont-air-balloon:before {\n\tcontent: \"\\eecf\";\n}\n\n.icofont-airplane-alt:before {\n\tcontent: \"\\eed0\";\n}\n\n.icofont-airplane:before {\n\tcontent: \"\\eed1\";\n}\n\n.icofont-ambulance-crescent:before {\n\tcontent: \"\\eed2\";\n}\n\n.icofont-ambulance-cross:before {\n\tcontent: \"\\eed3\";\n}\n\n.icofont-articulated-truck:before {\n\tcontent: \"\\eed4\";\n}\n\n.icofont-auto-rickshaw:before {\n\tcontent: \"\\eed5\";\n}\n\n.icofont-bicycle-alt-1:before {\n\tcontent: \"\\eed6\";\n}\n\n.icofont-bicycle-alt-2:before {\n\tcontent: \"\\eed7\";\n}\n\n.icofont-bull-dozer:before {\n\tcontent: \"\\eed8\";\n}\n\n.icofont-bus-alt-1:before {\n\tcontent: \"\\eed9\";\n}\n\n.icofont-bus-alt-2:before {\n\tcontent: \"\\eeda\";\n}\n\n.icofont-bus-alt-3:before {\n\tcontent: \"\\eedb\";\n}\n\n.icofont-cable-car:before {\n\tcontent: \"\\eedc\";\n}\n\n.icofont-car-alt-1:before {\n\tcontent: \"\\eedd\";\n}\n\n.icofont-car-alt-2:before {\n\tcontent: \"\\eede\";\n}\n\n.icofont-car-alt-3:before {\n\tcontent: \"\\eedf\";\n}\n\n.icofont-car-alt-4:before {\n\tcontent: \"\\eee0\";\n}\n\n.icofont-concrete-mixer:before {\n\tcontent: \"\\eee1\";\n}\n\n.icofont-delivery-time:before {\n\tcontent: \"\\eee2\";\n}\n\n.icofont-excavator:before {\n\tcontent: \"\\eee3\";\n}\n\n.icofont-fast-delivery:before {\n\tcontent: \"\\eee4\";\n}\n\n.icofont-fire-truck-alt:before {\n\tcontent: \"\\eee5\";\n}\n\n.icofont-fire-truck:before {\n\tcontent: \"\\eee6\";\n}\n\n.icofont-fork-lift:before {\n\tcontent: \"\\eee7\";\n}\n\n.icofont-free-delivery:before {\n\tcontent: \"\\eee8\";\n}\n\n.icofont-golf-cart:before {\n\tcontent: \"\\eee9\";\n}\n\n.icofont-helicopter:before {\n\tcontent: \"\\eeea\";\n}\n\n.icofont-motor-bike-alt:before {\n\tcontent: \"\\eeeb\";\n}\n\n.icofont-motor-bike:before {\n\tcontent: \"\\eeec\";\n}\n\n.icofont-motor-biker:before {\n\tcontent: \"\\eeed\";\n}\n\n.icofont-oil-truck:before {\n\tcontent: \"\\eeee\";\n}\n\n.icofont-police-car:before {\n\tcontent: \"\\eeef\";\n}\n\n.icofont-rickshaw:before {\n\tcontent: \"\\eef0\";\n}\n\n.icofont-rocket-alt-1:before {\n\tcontent: \"\\eef1\";\n}\n\n.icofont-rocket-alt-2:before {\n\tcontent: \"\\eef2\";\n}\n\n.icofont-sail-boat:before {\n\tcontent: \"\\eef3\";\n}\n\n.icofont-scooter:before {\n\tcontent: \"\\eef4\";\n}\n\n.icofont-sea-plane:before {\n\tcontent: \"\\eef5\";\n}\n\n.icofont-ship-alt:before {\n\tcontent: \"\\eef6\";\n}\n\n.icofont-speed-boat:before {\n\tcontent: \"\\eef7\";\n}\n\n.icofont-taxi:before {\n\tcontent: \"\\eef8\";\n}\n\n.icofont-tow-truck:before {\n\tcontent: \"\\eef9\";\n}\n\n.icofont-tractor:before {\n\tcontent: \"\\eefa\";\n}\n\n.icofont-traffic-light:before {\n\tcontent: \"\\eefb\";\n}\n\n.icofont-train-line:before {\n\tcontent: \"\\eefc\";\n}\n\n.icofont-train-steam:before {\n\tcontent: \"\\eefd\";\n}\n\n.icofont-tram:before {\n\tcontent: \"\\eefe\";\n}\n\n.icofont-truck-alt:before {\n\tcontent: \"\\eeff\";\n}\n\n.icofont-truck-loaded:before {\n\tcontent: \"\\ef00\";\n}\n\n.icofont-truck:before {\n\tcontent: \"\\ef01\";\n}\n\n.icofont-van-alt:before {\n\tcontent: \"\\ef02\";\n}\n\n.icofont-van:before {\n\tcontent: \"\\ef03\";\n}\n\n.icofont-yacht:before {\n\tcontent: \"\\ef04\";\n}\n\n.icofont-5-star-hotel:before {\n\tcontent: \"\\ef05\";\n}\n\n.icofont-anchor-alt:before {\n\tcontent: \"\\ef06\";\n}\n\n.icofont-beach-bed:before {\n\tcontent: \"\\ef07\";\n}\n\n.icofont-camping-vest:before {\n\tcontent: \"\\ef08\";\n}\n\n.icofont-coconut-alt:before {\n\tcontent: \"\\ef09\";\n}\n\n.icofont-direction-sign:before {\n\tcontent: \"\\ef0a\";\n}\n\n.icofont-hill-side:before {\n\tcontent: \"\\ef0b\";\n}\n\n.icofont-island-alt:before {\n\tcontent: \"\\ef0c\";\n}\n\n.icofont-long-drive:before {\n\tcontent: \"\\ef0d\";\n}\n\n.icofont-map-pins:before {\n\tcontent: \"\\ef0e\";\n}\n\n.icofont-plane-ticket:before {\n\tcontent: \"\\ef0f\";\n}\n\n.icofont-sail-boat-alt-1:before {\n\tcontent: \"\\ef10\";\n}\n\n.icofont-sail-boat-alt-2:before {\n\tcontent: \"\\ef11\";\n}\n\n.icofont-sandals-female:before {\n\tcontent: \"\\ef12\";\n}\n\n.icofont-sandals-male:before {\n\tcontent: \"\\ef13\";\n}\n\n.icofont-travelling:before {\n\tcontent: \"\\ef14\";\n}\n\n.icofont-breakdown:before {\n\tcontent: \"\\ef15\";\n}\n\n.icofont-celsius:before {\n\tcontent: \"\\ef16\";\n}\n\n.icofont-clouds:before {\n\tcontent: \"\\ef17\";\n}\n\n.icofont-cloudy:before {\n\tcontent: \"\\ef18\";\n}\n\n.icofont-compass-alt:before {\n\tcontent: \"\\ef19\";\n}\n\n.icofont-dust:before {\n\tcontent: \"\\ef1a\";\n}\n\n.icofont-eclipse:before {\n\tcontent: \"\\ef1b\";\n}\n\n.icofont-fahrenheit:before {\n\tcontent: \"\\ef1c\";\n}\n\n.icofont-forest-fire:before {\n\tcontent: \"\\ef1d\";\n}\n\n.icofont-full-night:before {\n\tcontent: \"\\ef1e\";\n}\n\n.icofont-full-sunny:before {\n\tcontent: \"\\ef1f\";\n}\n\n.icofont-hail-night:before {\n\tcontent: \"\\ef20\";\n}\n\n.icofont-hail-rainy-night:before {\n\tcontent: \"\\ef21\";\n}\n\n.icofont-hail-rainy-sunny:before {\n\tcontent: \"\\ef22\";\n}\n\n.icofont-hail-rainy:before {\n\tcontent: \"\\ef23\";\n}\n\n.icofont-hail-sunny:before {\n\tcontent: \"\\ef24\";\n}\n\n.icofont-hail-thunder-night:before {\n\tcontent: \"\\ef25\";\n}\n\n.icofont-hail-thunder-sunny:before {\n\tcontent: \"\\ef26\";\n}\n\n.icofont-hail-thunder:before {\n\tcontent: \"\\ef27\";\n}\n\n.icofont-hail:before {\n\tcontent: \"\\ef28\";\n}\n\n.icofont-hill-night:before {\n\tcontent: \"\\ef29\";\n}\n\n.icofont-hill-sunny:before {\n\tcontent: \"\\ef2a\";\n}\n\n.icofont-hill:before {\n\tcontent: \"\\ef2b\";\n}\n\n.icofont-hurricane:before {\n\tcontent: \"\\ef2c\";\n}\n\n.icofont-island:before {\n\tcontent: \"\\ef2d\";\n}\n\n.icofont-meteor:before {\n\tcontent: \"\\ef2e\";\n}\n\n.icofont-night:before {\n\tcontent: \"\\ef2f\";\n}\n\n.icofont-rainy-night:before {\n\tcontent: \"\\ef30\";\n}\n\n.icofont-rainy-sunny:before {\n\tcontent: \"\\ef31\";\n}\n\n.icofont-rainy-thunder:before {\n\tcontent: \"\\ef32\";\n}\n\n.icofont-rainy:before {\n\tcontent: \"\\ef33\";\n}\n\n.icofont-showy-night-hail:before {\n\tcontent: \"\\ef34\";\n}\n\n.icofont-snow-temp:before {\n\tcontent: \"\\ef35\";\n}\n\n.icofont-snow:before {\n\tcontent: \"\\ef36\";\n}\n\n.icofont-snowy-hail:before {\n\tcontent: \"\\ef37\";\n}\n\n.icofont-snowy-night-rainy:before {\n\tcontent: \"\\ef38\";\n}\n\n.icofont-snowy-night:before {\n\tcontent: \"\\ef39\";\n}\n\n.icofont-snowy-rainy:before {\n\tcontent: \"\\ef3a\";\n}\n\n.icofont-snowy-sunny-hail:before {\n\tcontent: \"\\ef3b\";\n}\n\n.icofont-snowy-sunny-rainy:before {\n\tcontent: \"\\ef3c\";\n}\n\n.icofont-snowy-sunny:before {\n\tcontent: \"\\ef3d\";\n}\n\n.icofont-snowy-thunder-night:before {\n\tcontent: \"\\ef3e\";\n}\n\n.icofont-snowy-thunder-sunny:before {\n\tcontent: \"\\ef3f\";\n}\n\n.icofont-snowy-thunder:before {\n\tcontent: \"\\ef40\";\n}\n\n.icofont-snowy-windy-night:before {\n\tcontent: \"\\ef41\";\n}\n\n.icofont-snowy-windy-sunny:before {\n\tcontent: \"\\ef42\";\n}\n\n.icofont-snowy-windy:before {\n\tcontent: \"\\ef43\";\n}\n\n.icofont-snowy:before {\n\tcontent: \"\\ef44\";\n}\n\n.icofont-sun-alt:before {\n\tcontent: \"\\ef45\";\n}\n\n.icofont-sun-rise:before {\n\tcontent: \"\\ef46\";\n}\n\n.icofont-sun-set:before {\n\tcontent: \"\\ef47\";\n}\n\n.icofont-sunny-day-temp:before {\n\tcontent: \"\\ef48\";\n}\n\n.icofont-sunny:before {\n\tcontent: \"\\ef49\";\n}\n\n.icofont-thermometer:before {\n\tcontent: \"\\ef4a\";\n}\n\n.icofont-thinder-light:before {\n\tcontent: \"\\ef4b\";\n}\n\n.icofont-tornado:before {\n\tcontent: \"\\ef4c\";\n}\n\n.icofont-umbrella-alt:before {\n\tcontent: \"\\ef4d\";\n}\n\n.icofont-volcano:before {\n\tcontent: \"\\ef4e\";\n}\n\n.icofont-wave:before {\n\tcontent: \"\\ef4f\";\n}\n\n.icofont-wind-scale-0:before {\n\tcontent: \"\\ef50\";\n}\n\n.icofont-wind-scale-1:before {\n\tcontent: \"\\ef51\";\n}\n\n.icofont-wind-scale-2:before {\n\tcontent: \"\\ef52\";\n}\n\n.icofont-wind-scale-3:before {\n\tcontent: \"\\ef53\";\n}\n\n.icofont-wind-scale-4:before {\n\tcontent: \"\\ef54\";\n}\n\n.icofont-wind-scale-5:before {\n\tcontent: \"\\ef55\";\n}\n\n.icofont-wind-scale-6:before {\n\tcontent: \"\\ef56\";\n}\n\n.icofont-wind-scale-7:before {\n\tcontent: \"\\ef57\";\n}\n\n.icofont-wind-scale-8:before {\n\tcontent: \"\\ef58\";\n}\n\n.icofont-wind-scale-9:before {\n\tcontent: \"\\ef59\";\n}\n\n.icofont-wind-scale-10:before {\n\tcontent: \"\\ef5a\";\n}\n\n.icofont-wind-scale-11:before {\n\tcontent: \"\\ef5b\";\n}\n\n.icofont-wind-scale-12:before {\n\tcontent: \"\\ef5c\";\n}\n\n.icofont-wind-waves:before {\n\tcontent: \"\\ef5d\";\n}\n\n.icofont-wind:before {\n\tcontent: \"\\ef5e\";\n}\n\n.icofont-windy-hail:before {\n\tcontent: \"\\ef5f\";\n}\n\n.icofont-windy-night:before {\n\tcontent: \"\\ef60\";\n}\n\n.icofont-windy-raining:before {\n\tcontent: \"\\ef61\";\n}\n\n.icofont-windy-sunny:before {\n\tcontent: \"\\ef62\";\n}\n\n.icofont-windy-thunder-raining:before {\n\tcontent: \"\\ef63\";\n}\n\n.icofont-windy-thunder:before {\n\tcontent: \"\\ef64\";\n}\n\n.icofont-windy:before {\n\tcontent: \"\\ef65\";\n}\n\n.icofont-addons:before {\n\tcontent: \"\\ef66\";\n}\n\n.icofont-address-book:before {\n\tcontent: \"\\ef67\";\n}\n\n.icofont-adjust:before {\n\tcontent: \"\\ef68\";\n}\n\n.icofont-alarm:before {\n\tcontent: \"\\ef69\";\n}\n\n.icofont-anchor:before {\n\tcontent: \"\\ef6a\";\n}\n\n.icofont-archive:before {\n\tcontent: \"\\ef6b\";\n}\n\n.icofont-at:before {\n\tcontent: \"\\ef6c\";\n}\n\n.icofont-attachment:before {\n\tcontent: \"\\ef6d\";\n}\n\n.icofont-audio:before {\n\tcontent: \"\\ef6e\";\n}\n\n.icofont-auto-mobile:before {\n\tcontent: \"\\ef6f\";\n}\n\n.icofont-automation:before {\n\tcontent: \"\\ef70\";\n}\n\n.icofont-baby:before {\n\tcontent: \"\\ef71\";\n}\n\n.icofont-badge:before {\n\tcontent: \"\\ef72\";\n}\n\n.icofont-bag:before {\n\tcontent: \"\\ef73\";\n}\n\n.icofont-ban:before {\n\tcontent: \"\\ef74\";\n}\n\n.icofont-bank:before {\n\tcontent: \"\\ef75\";\n}\n\n.icofont-bar-code:before {\n\tcontent: \"\\ef76\";\n}\n\n.icofont-bars:before {\n\tcontent: \"\\ef77\";\n}\n\n.icofont-battery-empty:before {\n\tcontent: \"\\ef78\";\n}\n\n.icofont-battery-full:before {\n\tcontent: \"\\ef79\";\n}\n\n.icofont-battery-half:before {\n\tcontent: \"\\ef7a\";\n}\n\n.icofont-battery-low:before {\n\tcontent: \"\\ef7b\";\n}\n\n.icofont-beach:before {\n\tcontent: \"\\ef7c\";\n}\n\n.icofont-beaker:before {\n\tcontent: \"\\ef7d\";\n}\n\n.icofont-bear:before {\n\tcontent: \"\\ef7e\";\n}\n\n.icofont-beard:before {\n\tcontent: \"\\ef7f\";\n}\n\n.icofont-bed:before {\n\tcontent: \"\\ef80\";\n}\n\n.icofont-bell:before {\n\tcontent: \"\\ef81\";\n}\n\n.icofont-beverage:before {\n\tcontent: \"\\ef82\";\n}\n\n.icofont-bicycle:before {\n\tcontent: \"\\ef83\";\n}\n\n.icofont-bill:before {\n\tcontent: \"\\ef84\";\n}\n\n.icofont-bin:before {\n\tcontent: \"\\ef85\";\n}\n\n.icofont-binary:before {\n\tcontent: \"\\ef86\";\n}\n\n.icofont-binoculars:before {\n\tcontent: \"\\ef87\";\n}\n\n.icofont-bird:before {\n\tcontent: \"\\ef88\";\n}\n\n.icofont-birds:before {\n\tcontent: \"\\ef89\";\n}\n\n.icofont-black-board:before {\n\tcontent: \"\\ef8a\";\n}\n\n.icofont-bluetooth:before {\n\tcontent: \"\\ef8b\";\n}\n\n.icofont-bolt:before {\n\tcontent: \"\\ef8c\";\n}\n\n.icofont-bomb:before {\n\tcontent: \"\\ef8d\";\n}\n\n.icofont-book-mark:before {\n\tcontent: \"\\ef8e\";\n}\n\n.icofont-book:before {\n\tcontent: \"\\ef8f\";\n}\n\n.icofont-boot:before {\n\tcontent: \"\\ef90\";\n}\n\n.icofont-box:before {\n\tcontent: \"\\ef91\";\n}\n\n.icofont-brain:before {\n\tcontent: \"\\ef92\";\n}\n\n.icofont-briefcase:before {\n\tcontent: \"\\ef93\";\n}\n\n.icofont-broken:before {\n\tcontent: \"\\ef94\";\n}\n\n.icofont-bucket:before {\n\tcontent: \"\\ef95\";\n}\n\n.icofont-bucket1:before {\n\tcontent: \"\\ef96\";\n}\n\n.icofont-bucket2:before {\n\tcontent: \"\\ef97\";\n}\n\n.icofont-bug:before {\n\tcontent: \"\\ef98\";\n}\n\n.icofont-building:before {\n\tcontent: \"\\ef99\";\n}\n\n.icofont-bullet:before {\n\tcontent: \"\\ef9a\";\n}\n\n.icofont-bullhorn:before {\n\tcontent: \"\\ef9b\";\n}\n\n.icofont-bullseye:before {\n\tcontent: \"\\ef9c\";\n}\n\n.icofont-bus:before {\n\tcontent: \"\\ef9d\";\n}\n\n.icofont-butterfly:before {\n\tcontent: \"\\ef9e\";\n}\n\n.icofont-cab:before {\n\tcontent: \"\\ef9f\";\n}\n\n.icofont-calculator:before {\n\tcontent: \"\\efa0\";\n}\n\n.icofont-calendar:before {\n\tcontent: \"\\efa1\";\n}\n\n.icofont-camera-alt:before {\n\tcontent: \"\\efa2\";\n}\n\n.icofont-camera:before {\n\tcontent: \"\\efa3\";\n}\n\n.icofont-car:before {\n\tcontent: \"\\efa4\";\n}\n\n.icofont-card:before {\n\tcontent: \"\\efa5\";\n}\n\n.icofont-cart:before {\n\tcontent: \"\\efa6\";\n}\n\n.icofont-cc:before {\n\tcontent: \"\\efa7\";\n}\n\n.icofont-certificate:before {\n\tcontent: \"\\efa8\";\n}\n\n.icofont-charging:before {\n\tcontent: \"\\efa9\";\n}\n\n.icofont-chat:before {\n\tcontent: \"\\efaa\";\n}\n\n.icofont-check-alt:before {\n\tcontent: \"\\efab\";\n}\n\n.icofont-check-circled:before {\n\tcontent: \"\\efac\";\n}\n\n.icofont-check:before {\n\tcontent: \"\\efad\";\n}\n\n.icofont-checked:before {\n\tcontent: \"\\efae\";\n}\n\n.icofont-children-care:before {\n\tcontent: \"\\efaf\";\n}\n\n.icofont-clock-time:before {\n\tcontent: \"\\efb0\";\n}\n\n.icofont-close-circled:before {\n\tcontent: \"\\efb1\";\n}\n\n.icofont-close-line-circled:before {\n\tcontent: \"\\efb2\";\n}\n\n.icofont-close-line-squared-alt:before {\n\tcontent: \"\\efb3\";\n}\n\n.icofont-close-line-squared:before {\n\tcontent: \"\\efb4\";\n}\n\n.icofont-close-line:before {\n\tcontent: \"\\efb5\";\n}\n\n.icofont-close-squared-alt:before {\n\tcontent: \"\\efb6\";\n}\n\n.icofont-close-squared:before {\n\tcontent: \"\\efb7\";\n}\n\n.icofont-close:before {\n\tcontent: \"\\efb8\";\n}\n\n.icofont-cloud-download:before {\n\tcontent: \"\\efb9\";\n}\n\n.icofont-cloud-refresh:before {\n\tcontent: \"\\efba\";\n}\n\n.icofont-cloud-upload:before {\n\tcontent: \"\\efbb\";\n}\n\n.icofont-cloud:before {\n\tcontent: \"\\efbc\";\n}\n\n.icofont-code-not-allowed:before {\n\tcontent: \"\\efbd\";\n}\n\n.icofont-code:before {\n\tcontent: \"\\efbe\";\n}\n\n.icofont-coffee-cup:before {\n\tcontent: \"\\efbf\";\n}\n\n.icofont-comment:before {\n\tcontent: \"\\efc0\";\n}\n\n.icofont-compass:before {\n\tcontent: \"\\efc1\";\n}\n\n.icofont-computer:before {\n\tcontent: \"\\efc2\";\n}\n\n.icofont-connection:before {\n\tcontent: \"\\efc3\";\n}\n\n.icofont-console:before {\n\tcontent: \"\\efc4\";\n}\n\n.icofont-contacts:before {\n\tcontent: \"\\efc5\";\n}\n\n.icofont-contrast:before {\n\tcontent: \"\\efc6\";\n}\n\n.icofont-copy:before {\n\tcontent: \"\\efc7\";\n}\n\n.icofont-copyright:before {\n\tcontent: \"\\efc8\";\n}\n\n.icofont-credit-card:before {\n\tcontent: \"\\efc9\";\n}\n\n.icofont-crop:before {\n\tcontent: \"\\efca\";\n}\n\n.icofont-crown:before {\n\tcontent: \"\\efcb\";\n}\n\n.icofont-cube:before {\n\tcontent: \"\\efcc\";\n}\n\n.icofont-cubes:before {\n\tcontent: \"\\efcd\";\n}\n\n.icofont-culinary:before {\n\tcontent: \"\\efce\";\n}\n\n.icofont-dashboard-web:before {\n\tcontent: \"\\efcf\";\n}\n\n.icofont-dashboard:before {\n\tcontent: \"\\efd0\";\n}\n\n.icofont-data:before {\n\tcontent: \"\\efd1\";\n}\n\n.icofont-database-add:before {\n\tcontent: \"\\efd2\";\n}\n\n.icofont-database-locked:before {\n\tcontent: \"\\efd3\";\n}\n\n.icofont-database-remove:before {\n\tcontent: \"\\efd4\";\n}\n\n.icofont-database:before {\n\tcontent: \"\\efd5\";\n}\n\n.icofont-delete:before {\n\tcontent: \"\\efd6\";\n}\n\n.icofont-diamond:before {\n\tcontent: \"\\efd7\";\n}\n\n.icofont-dice:before {\n\tcontent: \"\\efd8\";\n}\n\n.icofont-disabled:before {\n\tcontent: \"\\efd9\";\n}\n\n.icofont-disc:before {\n\tcontent: \"\\efda\";\n}\n\n.icofont-diskette:before {\n\tcontent: \"\\efdb\";\n}\n\n.icofont-document-folder:before {\n\tcontent: \"\\efdc\";\n}\n\n.icofont-download-alt:before {\n\tcontent: \"\\efdd\";\n}\n\n.icofont-download:before {\n\tcontent: \"\\efde\";\n}\n\n.icofont-downloaded:before {\n\tcontent: \"\\efdf\";\n}\n\n.icofont-earth:before {\n\tcontent: \"\\efe0\";\n}\n\n.icofont-ebook:before {\n\tcontent: \"\\efe1\";\n}\n\n.icofont-edit:before {\n\tcontent: \"\\efe2\";\n}\n\n.icofont-eject:before {\n\tcontent: \"\\efe3\";\n}\n\n.icofont-email:before {\n\tcontent: \"\\efe4\";\n}\n\n.icofont-envelope-open:before {\n\tcontent: \"\\efe5\";\n}\n\n.icofont-envelope:before {\n\tcontent: \"\\efe6\";\n}\n\n.icofont-eraser:before {\n\tcontent: \"\\efe7\";\n}\n\n.icofont-error:before {\n\tcontent: \"\\efe8\";\n}\n\n.icofont-exchange:before {\n\tcontent: \"\\efe9\";\n}\n\n.icofont-exclamation-circle:before {\n\tcontent: \"\\efea\";\n}\n\n.icofont-exclamation-square:before {\n\tcontent: \"\\efeb\";\n}\n\n.icofont-exclamation-tringle:before {\n\tcontent: \"\\efec\";\n}\n\n.icofont-exclamation:before {\n\tcontent: \"\\efed\";\n}\n\n.icofont-exit:before {\n\tcontent: \"\\efee\";\n}\n\n.icofont-expand:before {\n\tcontent: \"\\efef\";\n}\n\n.icofont-external-link:before {\n\tcontent: \"\\eff0\";\n}\n\n.icofont-external:before {\n\tcontent: \"\\eff1\";\n}\n\n.icofont-eye-blocked:before {\n\tcontent: \"\\eff2\";\n}\n\n.icofont-eye-dropper:before {\n\tcontent: \"\\eff3\";\n}\n\n.icofont-eye:before {\n\tcontent: \"\\eff4\";\n}\n\n.icofont-favourite:before {\n\tcontent: \"\\eff5\";\n}\n\n.icofont-fax:before {\n\tcontent: \"\\eff6\";\n}\n\n.icofont-female:before {\n\tcontent: \"\\eff7\";\n}\n\n.icofont-file:before {\n\tcontent: \"\\eff8\";\n}\n\n.icofont-film:before {\n\tcontent: \"\\eff9\";\n}\n\n.icofont-filter:before {\n\tcontent: \"\\effa\";\n}\n\n.icofont-fire-burn:before {\n\tcontent: \"\\effb\";\n}\n\n.icofont-fire-extinguisher:before {\n\tcontent: \"\\effc\";\n}\n\n.icofont-fire:before {\n\tcontent: \"\\effd\";\n}\n\n.icofont-first-aid:before {\n\tcontent: \"\\effe\";\n}\n\n.icofont-flag-alt-1:before {\n\tcontent: \"\\efff\";\n}\n\n.icofont-flag-alt-2:before {\n\tcontent: \"\\f000\";\n}\n\n.icofont-flag:before {\n\tcontent: \"\\f001\";\n}\n\n.icofont-flash-light:before {\n\tcontent: \"\\f002\";\n}\n\n.icofont-flash:before {\n\tcontent: \"\\f003\";\n}\n\n.icofont-flask:before {\n\tcontent: \"\\f004\";\n}\n\n.icofont-focus:before {\n\tcontent: \"\\f005\";\n}\n\n.icofont-folder-open:before {\n\tcontent: \"\\f006\";\n}\n\n.icofont-folder:before {\n\tcontent: \"\\f007\";\n}\n\n.icofont-foot-print:before {\n\tcontent: \"\\f008\";\n}\n\n.icofont-football-american:before {\n\tcontent: \"\\f009\";\n}\n\n.icofont-football:before {\n\tcontent: \"\\f00a\";\n}\n\n.icofont-game-console:before {\n\tcontent: \"\\f00b\";\n}\n\n.icofont-game-pad:before {\n\tcontent: \"\\f00c\";\n}\n\n.icofont-gavel:before {\n\tcontent: \"\\f00d\";\n}\n\n.icofont-gear:before {\n\tcontent: \"\\f00e\";\n}\n\n.icofont-gears:before {\n\tcontent: \"\\f00f\";\n}\n\n.icofont-gift:before {\n\tcontent: \"\\f010\";\n}\n\n.icofont-glass:before {\n\tcontent: \"\\f011\";\n}\n\n.icofont-globe:before {\n\tcontent: \"\\f012\";\n}\n\n.icofont-graduate:before {\n\tcontent: \"\\f013\";\n}\n\n.icofont-graffiti:before {\n\tcontent: \"\\f014\";\n}\n\n.icofont-grocery:before {\n\tcontent: \"\\f015\";\n}\n\n.icofont-group:before {\n\tcontent: \"\\f016\";\n}\n\n.icofont-hammer:before {\n\tcontent: \"\\f017\";\n}\n\n.icofont-hand:before {\n\tcontent: \"\\f018\";\n}\n\n.icofont-hanger:before {\n\tcontent: \"\\f019\";\n}\n\n.icofont-hard-disk:before {\n\tcontent: \"\\f01a\";\n}\n\n.icofont-headphone:before {\n\tcontent: \"\\f01b\";\n}\n\n.icofont-heart-beat:before {\n\tcontent: \"\\f01c\";\n}\n\n.icofont-heart:before {\n\tcontent: \"\\f01d\";\n}\n\n.icofont-history:before {\n\tcontent: \"\\f01e\";\n}\n\n.icofont-home:before {\n\tcontent: \"\\f01f\";\n}\n\n.icofont-horn:before {\n\tcontent: \"\\f020\";\n}\n\n.icofont-hotel:before {\n\tcontent: \"\\f021\";\n}\n\n.icofont-hour-glass:before {\n\tcontent: \"\\f022\";\n}\n\n.icofont-id:before {\n\tcontent: \"\\f023\";\n}\n\n.icofont-image:before {\n\tcontent: \"\\f024\";\n}\n\n.icofont-inbox:before {\n\tcontent: \"\\f025\";\n}\n\n.icofont-infinite:before {\n\tcontent: \"\\f026\";\n}\n\n.icofont-info-circle:before {\n\tcontent: \"\\f027\";\n}\n\n.icofont-info-square:before {\n\tcontent: \"\\f028\";\n}\n\n.icofont-info:before {\n\tcontent: \"\\f029\";\n}\n\n.icofont-institution:before {\n\tcontent: \"\\f02a\";\n}\n\n.icofont-interface:before {\n\tcontent: \"\\f02b\";\n}\n\n.icofont-invisible:before {\n\tcontent: \"\\f02c\";\n}\n\n.icofont-italic:before {\n\tcontent: \"\\f02d\";\n}\n\n.icofont-jacket:before {\n\tcontent: \"\\f02e\";\n}\n\n.icofont-jar:before {\n\tcontent: \"\\f02f\";\n}\n\n.icofont-jewlery:before {\n\tcontent: \"\\f030\";\n}\n\n.icofont-karate:before {\n\tcontent: \"\\f031\";\n}\n\n.icofont-key-hole:before {\n\tcontent: \"\\f032\";\n}\n\n.icofont-key:before {\n\tcontent: \"\\f033\";\n}\n\n.icofont-keyboard:before {\n\tcontent: \"\\f034\";\n}\n\n.icofont-kid:before {\n\tcontent: \"\\f035\";\n}\n\n.icofont-label:before {\n\tcontent: \"\\f036\";\n}\n\n.icofont-lamp:before {\n\tcontent: \"\\f037\";\n}\n\n.icofont-laptop:before {\n\tcontent: \"\\f038\";\n}\n\n.icofont-layers:before {\n\tcontent: \"\\f039\";\n}\n\n.icofont-layout:before {\n\tcontent: \"\\f03a\";\n}\n\n.icofont-leaf:before {\n\tcontent: \"\\f03b\";\n}\n\n.icofont-leaflet:before {\n\tcontent: \"\\f03c\";\n}\n\n.icofont-learn:before {\n\tcontent: \"\\f03d\";\n}\n\n.icofont-legal:before {\n\tcontent: \"\\f03e\";\n}\n\n.icofont-lego:before {\n\tcontent: \"\\f03f\";\n}\n\n.icofont-lemon:before {\n\tcontent: \"\\f040\";\n}\n\n.icofont-lens:before {\n\tcontent: \"\\f041\";\n}\n\n.icofont-letter:before {\n\tcontent: \"\\f042\";\n}\n\n.icofont-letterbox:before {\n\tcontent: \"\\f043\";\n}\n\n.icofont-library:before {\n\tcontent: \"\\f044\";\n}\n\n.icofont-license:before {\n\tcontent: \"\\f045\";\n}\n\n.icofont-life-bouy:before {\n\tcontent: \"\\f046\";\n}\n\n.icofont-life-buoy:before {\n\tcontent: \"\\f047\";\n}\n\n.icofont-life-jacket:before {\n\tcontent: \"\\f048\";\n}\n\n.icofont-life-ring:before {\n\tcontent: \"\\f049\";\n}\n\n.icofont-light-bulb:before {\n\tcontent: \"\\f04a\";\n}\n\n.icofont-lighter:before {\n\tcontent: \"\\f04b\";\n}\n\n.icofont-lightning-ray:before {\n\tcontent: \"\\f04c\";\n}\n\n.icofont-like:before {\n\tcontent: \"\\f04d\";\n}\n\n.icofont-link:before {\n\tcontent: \"\\f04e\";\n}\n\n.icofont-live-support:before {\n\tcontent: \"\\f04f\";\n}\n\n.icofont-location-arrow:before {\n\tcontent: \"\\f050\";\n}\n\n.icofont-location-pin:before {\n\tcontent: \"\\f051\";\n}\n\n.icofont-lock:before {\n\tcontent: \"\\f052\";\n}\n\n.icofont-login:before {\n\tcontent: \"\\f053\";\n}\n\n.icofont-logout:before {\n\tcontent: \"\\f054\";\n}\n\n.icofont-lollipop:before {\n\tcontent: \"\\f055\";\n}\n\n.icofont-look:before {\n\tcontent: \"\\f056\";\n}\n\n.icofont-loop:before {\n\tcontent: \"\\f057\";\n}\n\n.icofont-luggage:before {\n\tcontent: \"\\f058\";\n}\n\n.icofont-lunch:before {\n\tcontent: \"\\f059\";\n}\n\n.icofont-lungs:before {\n\tcontent: \"\\f05a\";\n}\n\n.icofont-magic-alt:before {\n\tcontent: \"\\f05b\";\n}\n\n.icofont-magic:before {\n\tcontent: \"\\f05c\";\n}\n\n.icofont-magnet:before {\n\tcontent: \"\\f05d\";\n}\n\n.icofont-mail-box:before {\n\tcontent: \"\\f05e\";\n}\n\n.icofont-mail:before {\n\tcontent: \"\\f05f\";\n}\n\n.icofont-male:before {\n\tcontent: \"\\f060\";\n}\n\n.icofont-map:before {\n\tcontent: \"\\f061\";\n}\n\n.icofont-math:before {\n\tcontent: \"\\f062\";\n}\n\n.icofont-maximize:before {\n\tcontent: \"\\f063\";\n}\n\n.icofont-measure:before {\n\tcontent: \"\\f064\";\n}\n\n.icofont-medal:before {\n\tcontent: \"\\f065\";\n}\n\n.icofont-medical:before {\n\tcontent: \"\\f066\";\n}\n\n.icofont-medicine:before {\n\tcontent: \"\\f067\";\n}\n\n.icofont-mega-phone:before {\n\tcontent: \"\\f068\";\n}\n\n.icofont-memorial:before {\n\tcontent: \"\\f069\";\n}\n\n.icofont-memory-card:before {\n\tcontent: \"\\f06a\";\n}\n\n.icofont-mic-mute:before {\n\tcontent: \"\\f06b\";\n}\n\n.icofont-mic:before {\n\tcontent: \"\\f06c\";\n}\n\n.icofont-micro-chip:before {\n\tcontent: \"\\f06d\";\n}\n\n.icofont-microphone:before {\n\tcontent: \"\\f06e\";\n}\n\n.icofont-microscope:before {\n\tcontent: \"\\f06f\";\n}\n\n.icofont-military:before {\n\tcontent: \"\\f070\";\n}\n\n.icofont-mill:before {\n\tcontent: \"\\f071\";\n}\n\n.icofont-minus-circle:before {\n\tcontent: \"\\f072\";\n}\n\n.icofont-minus-square:before {\n\tcontent: \"\\f073\";\n}\n\n.icofont-minus:before {\n\tcontent: \"\\f074\";\n}\n\n.icofont-mobile-phone:before {\n\tcontent: \"\\f075\";\n}\n\n.icofont-molecule:before {\n\tcontent: \"\\f076\";\n}\n\n.icofont-money:before {\n\tcontent: \"\\f077\";\n}\n\n.icofont-moon:before {\n\tcontent: \"\\f078\";\n}\n\n.icofont-mop:before {\n\tcontent: \"\\f079\";\n}\n\n.icofont-muffin:before {\n\tcontent: \"\\f07a\";\n}\n\n.icofont-music-alt:before {\n\tcontent: \"\\f07b\";\n}\n\n.icofont-music-notes:before {\n\tcontent: \"\\f07c\";\n}\n\n.icofont-music:before {\n\tcontent: \"\\f07d\";\n}\n\n.icofont-mustache:before {\n\tcontent: \"\\f07e\";\n}\n\n.icofont-mute-volume:before {\n\tcontent: \"\\f07f\";\n}\n\n.icofont-navigation-menu:before {\n\tcontent: \"\\f080\";\n}\n\n.icofont-navigation:before {\n\tcontent: \"\\f081\";\n}\n\n.icofont-network-tower:before {\n\tcontent: \"\\f082\";\n}\n\n.icofont-network:before {\n\tcontent: \"\\f083\";\n}\n\n.icofont-news:before {\n\tcontent: \"\\f084\";\n}\n\n.icofont-newspaper:before {\n\tcontent: \"\\f085\";\n}\n\n.icofont-no-smoking:before {\n\tcontent: \"\\f086\";\n}\n\n.icofont-not-allowed:before {\n\tcontent: \"\\f087\";\n}\n\n.icofont-notebook:before {\n\tcontent: \"\\f088\";\n}\n\n.icofont-notepad:before {\n\tcontent: \"\\f089\";\n}\n\n.icofont-notification:before {\n\tcontent: \"\\f08a\";\n}\n\n.icofont-numbered:before {\n\tcontent: \"\\f08b\";\n}\n\n.icofont-opposite:before {\n\tcontent: \"\\f08c\";\n}\n\n.icofont-optic:before {\n\tcontent: \"\\f08d\";\n}\n\n.icofont-options:before {\n\tcontent: \"\\f08e\";\n}\n\n.icofont-package:before {\n\tcontent: \"\\f08f\";\n}\n\n.icofont-page:before {\n\tcontent: \"\\f090\";\n}\n\n.icofont-paint:before {\n\tcontent: \"\\f091\";\n}\n\n.icofont-paper-plane:before {\n\tcontent: \"\\f092\";\n}\n\n.icofont-paperclip:before {\n\tcontent: \"\\f093\";\n}\n\n.icofont-papers:before {\n\tcontent: \"\\f094\";\n}\n\n.icofont-paw:before {\n\tcontent: \"\\f095\";\n}\n\n.icofont-pay:before {\n\tcontent: \"\\f096\";\n}\n\n.icofont-pen:before {\n\tcontent: \"\\f097\";\n}\n\n.icofont-pencil:before {\n\tcontent: \"\\f098\";\n}\n\n.icofont-penguin-linux:before {\n\tcontent: \"\\f099\";\n}\n\n.icofont-pestle:before {\n\tcontent: \"\\f09a\";\n}\n\n.icofont-phone-circle:before {\n\tcontent: \"\\f09b\";\n}\n\n.icofont-phone:before {\n\tcontent: \"\\f09c\";\n}\n\n.icofont-picture:before {\n\tcontent: \"\\f09d\";\n}\n\n.icofont-pie:before {\n\tcontent: \"\\f09e\";\n}\n\n.icofont-pine:before {\n\tcontent: \"\\f09f\";\n}\n\n.icofont-pixels:before {\n\tcontent: \"\\f0a0\";\n}\n\n.icofont-play:before {\n\tcontent: \"\\f0a1\";\n}\n\n.icofont-plugin:before {\n\tcontent: \"\\f0a2\";\n}\n\n.icofont-plus-circle:before {\n\tcontent: \"\\f0a3\";\n}\n\n.icofont-plus-square:before {\n\tcontent: \"\\f0a4\";\n}\n\n.icofont-plus:before {\n\tcontent: \"\\f0a5\";\n}\n\n.icofont-polygonal:before {\n\tcontent: \"\\f0a6\";\n}\n\n.icofont-power:before {\n\tcontent: \"\\f0a7\";\n}\n\n.icofont-presentation:before {\n\tcontent: \"\\f0a8\";\n}\n\n.icofont-price:before {\n\tcontent: \"\\f0a9\";\n}\n\n.icofont-print:before {\n\tcontent: \"\\f0aa\";\n}\n\n.icofont-puzzle:before {\n\tcontent: \"\\f0ab\";\n}\n\n.icofont-qr-code:before {\n\tcontent: \"\\f0ac\";\n}\n\n.icofont-queen:before {\n\tcontent: \"\\f0ad\";\n}\n\n.icofont-question-circle:before {\n\tcontent: \"\\f0ae\";\n}\n\n.icofont-question-square:before {\n\tcontent: \"\\f0af\";\n}\n\n.icofont-question:before {\n\tcontent: \"\\f0b0\";\n}\n\n.icofont-quote-left:before {\n\tcontent: \"\\f0b1\";\n}\n\n.icofont-quote-right:before {\n\tcontent: \"\\f0b2\";\n}\n\n.icofont-radio:before {\n\tcontent: \"\\f0b3\";\n}\n\n.icofont-random:before {\n\tcontent: \"\\f0b4\";\n}\n\n.icofont-recycle:before {\n\tcontent: \"\\f0b5\";\n}\n\n.icofont-refresh:before {\n\tcontent: \"\\f0b6\";\n}\n\n.icofont-repair:before {\n\tcontent: \"\\f0b7\";\n}\n\n.icofont-reply-all:before {\n\tcontent: \"\\f0b8\";\n}\n\n.icofont-reply:before {\n\tcontent: \"\\f0b9\";\n}\n\n.icofont-resize:before {\n\tcontent: \"\\f0ba\";\n}\n\n.icofont-responsive:before {\n\tcontent: \"\\f0bb\";\n}\n\n.icofont-retweet:before {\n\tcontent: \"\\f0bc\";\n}\n\n.icofont-road:before {\n\tcontent: \"\\f0bd\";\n}\n\n.icofont-robot:before {\n\tcontent: \"\\f0be\";\n}\n\n.icofont-rocket:before {\n\tcontent: \"\\f0bf\";\n}\n\n.icofont-royal:before {\n\tcontent: \"\\f0c0\";\n}\n\n.icofont-rss-feed:before {\n\tcontent: \"\\f0c1\";\n}\n\n.icofont-safety:before {\n\tcontent: \"\\f0c2\";\n}\n\n.icofont-sale-discount:before {\n\tcontent: \"\\f0c3\";\n}\n\n.icofont-satellite:before {\n\tcontent: \"\\f0c4\";\n}\n\n.icofont-send-mail:before {\n\tcontent: \"\\f0c5\";\n}\n\n.icofont-server:before {\n\tcontent: \"\\f0c6\";\n}\n\n.icofont-settings:before {\n\tcontent: \"\\f0c7\";\n}\n\n.icofont-share-alt:before {\n\tcontent: \"\\f0c8\";\n}\n\n.icofont-share-boxed:before {\n\tcontent: \"\\f0c9\";\n}\n\n.icofont-share:before {\n\tcontent: \"\\f0ca\";\n}\n\n.icofont-shield:before {\n\tcontent: \"\\f0cb\";\n}\n\n.icofont-ship:before {\n\tcontent: \"\\f0cc\";\n}\n\n.icofont-shopping-cart:before {\n\tcontent: \"\\f0cd\";\n}\n\n.icofont-sign-in:before {\n\tcontent: \"\\f0ce\";\n}\n\n.icofont-sign-out:before {\n\tcontent: \"\\f0cf\";\n}\n\n.icofont-signal:before {\n\tcontent: \"\\f0d0\";\n}\n\n.icofont-site-map:before {\n\tcontent: \"\\f0d1\";\n}\n\n.icofont-smart-phone:before {\n\tcontent: \"\\f0d2\";\n}\n\n.icofont-soccer:before {\n\tcontent: \"\\f0d3\";\n}\n\n.icofont-sort-alt:before {\n\tcontent: \"\\f0d4\";\n}\n\n.icofont-sort:before {\n\tcontent: \"\\f0d5\";\n}\n\n.icofont-space:before {\n\tcontent: \"\\f0d6\";\n}\n\n.icofont-spanner:before {\n\tcontent: \"\\f0d7\";\n}\n\n.icofont-speech-comments:before {\n\tcontent: \"\\f0d8\";\n}\n\n.icofont-speed-meter:before {\n\tcontent: \"\\f0d9\";\n}\n\n.icofont-spinner-alt-1:before {\n\tcontent: \"\\f0da\";\n}\n\n.icofont-spinner-alt-2:before {\n\tcontent: \"\\f0db\";\n}\n\n.icofont-spinner-alt-3:before {\n\tcontent: \"\\f0dc\";\n}\n\n.icofont-spinner-alt-4:before {\n\tcontent: \"\\f0dd\";\n}\n\n.icofont-spinner-alt-5:before {\n\tcontent: \"\\f0de\";\n}\n\n.icofont-spinner-alt-6:before {\n\tcontent: \"\\f0df\";\n}\n\n.icofont-spinner:before {\n\tcontent: \"\\f0e0\";\n}\n\n.icofont-spreadsheet:before {\n\tcontent: \"\\f0e1\";\n}\n\n.icofont-square:before {\n\tcontent: \"\\f0e2\";\n}\n\n.icofont-ssl-security:before {\n\tcontent: \"\\f0e3\";\n}\n\n.icofont-star-alt-1:before {\n\tcontent: \"\\f0e4\";\n}\n\n.icofont-star-alt-2:before {\n\tcontent: \"\\f0e5\";\n}\n\n.icofont-star:before {\n\tcontent: \"\\f0e6\";\n}\n\n.icofont-street-view:before {\n\tcontent: \"\\f0e7\";\n}\n\n.icofont-sun:before {\n\tcontent: \"\\f0e8\";\n}\n\n.icofont-support-faq:before {\n\tcontent: \"\\f0e9\";\n}\n\n.icofont-tack-pin:before {\n\tcontent: \"\\f0ea\";\n}\n\n.icofont-tag:before {\n\tcontent: \"\\f0eb\";\n}\n\n.icofont-tags:before {\n\tcontent: \"\\f0ec\";\n}\n\n.icofont-tasks:before {\n\tcontent: \"\\f0ed\";\n}\n\n.icofont-telephone:before {\n\tcontent: \"\\f0ee\";\n}\n\n.icofont-telescope:before {\n\tcontent: \"\\f0ef\";\n}\n\n.icofont-terminal:before {\n\tcontent: \"\\f0f0\";\n}\n\n.icofont-thumbs-down:before {\n\tcontent: \"\\f0f1\";\n}\n\n.icofont-thumbs-up:before {\n\tcontent: \"\\f0f2\";\n}\n\n.icofont-tick-boxed:before {\n\tcontent: \"\\f0f3\";\n}\n\n.icofont-tick-mark:before {\n\tcontent: \"\\f0f4\";\n}\n\n.icofont-ticket:before {\n\tcontent: \"\\f0f5\";\n}\n\n.icofont-tie:before {\n\tcontent: \"\\f0f6\";\n}\n\n.icofont-toggle-off:before {\n\tcontent: \"\\f0f7\";\n}\n\n.icofont-toggle-on:before {\n\tcontent: \"\\f0f8\";\n}\n\n.icofont-tools:before {\n\tcontent: \"\\f0f9\";\n}\n\n.icofont-transparent:before {\n\tcontent: \"\\f0fa\";\n}\n\n.icofont-tree:before {\n\tcontent: \"\\f0fb\";\n}\n\n.icofont-umbrella:before {\n\tcontent: \"\\f0fc\";\n}\n\n.icofont-unlock:before {\n\tcontent: \"\\f0fd\";\n}\n\n.icofont-unlocked:before {\n\tcontent: \"\\f0fe\";\n}\n\n.icofont-upload-alt:before {\n\tcontent: \"\\f0ff\";\n}\n\n.icofont-upload:before {\n\tcontent: \"\\f100\";\n}\n\n.icofont-usb-drive:before {\n\tcontent: \"\\f101\";\n}\n\n.icofont-usb:before {\n\tcontent: \"\\f102\";\n}\n\n.icofont-vector-path:before {\n\tcontent: \"\\f103\";\n}\n\n.icofont-verification-check:before {\n\tcontent: \"\\f104\";\n}\n\n.icofont-video-clapper:before {\n\tcontent: \"\\f105\";\n}\n\n.icofont-video:before {\n\tcontent: \"\\f106\";\n}\n\n.icofont-volume-down:before {\n\tcontent: \"\\f107\";\n}\n\n.icofont-volume-off:before {\n\tcontent: \"\\f108\";\n}\n\n.icofont-volume-up:before {\n\tcontent: \"\\f109\";\n}\n\n.icofont-wall-clock:before {\n\tcontent: \"\\f10a\";\n}\n\n.icofont-wall:before {\n\tcontent: \"\\f10b\";\n}\n\n.icofont-wallet:before {\n\tcontent: \"\\f10c\";\n}\n\n.icofont-warning-alt:before {\n\tcontent: \"\\f10d\";\n}\n\n.icofont-warning:before {\n\tcontent: \"\\f10e\";\n}\n\n.icofont-water-drop:before {\n\tcontent: \"\\f10f\";\n}\n\n.icofont-web:before {\n\tcontent: \"\\f110\";\n}\n\n.icofont-wheelchair:before {\n\tcontent: \"\\f111\";\n}\n\n.icofont-wifi-alt:before {\n\tcontent: \"\\f112\";\n}\n\n.icofont-wifi:before {\n\tcontent: \"\\f113\";\n}\n\n.icofont-world:before {\n\tcontent: \"\\f114\";\n}\n\n.icofont-zigzag:before {\n\tcontent: \"\\f115\";\n}\n\n.icofont-zipped:before {\n\tcontent: \"\\f116\";\n}\n\n.icofont-social-500px:before {\n\tcontent: \"\\f117\";\n}\n\n.icofont-social-baidu-tieba:before {\n\tcontent: \"\\f118\";\n}\n\n.icofont-social-bbm-messenger:before {\n\tcontent: \"\\f119\";\n}\n\n.icofont-social-delicious:before {\n\tcontent: \"\\f11a\";\n}\n\n.icofont-social-dribbble:before {\n\tcontent: \"\\f11b\";\n}\n\n.icofont-social-facebook-messenger:before {\n\tcontent: \"\\f11c\";\n}\n\n.icofont-social-flikr:before {\n\tcontent: \"\\f11d\";\n}\n\n.icofont-social-foursquare:before {\n\tcontent: \"\\f11e\";\n}\n\n.icofont-social-google-hangouts:before {\n\tcontent: \"\\f11f\";\n}\n\n.icofont-social-kakaotalk:before {\n\tcontent: \"\\f120\";\n}\n\n.icofont-social-kik:before {\n\tcontent: \"\\f121\";\n}\n\n.icofont-social-kiwibox:before {\n\tcontent: \"\\f122\";\n}\n\n.icofont-social-linkedin:before {\n\tcontent: \"\\f123\";\n}\n\n.icofont-social-meetme:before {\n\tcontent: \"\\f124\";\n}\n\n.icofont-social-odnoklassniki:before {\n\tcontent: \"\\f125\";\n}\n\n.icofont-social-photobucket:before {\n\tcontent: \"\\f126\";\n}\n\n.icofont-social-qq:before {\n\tcontent: \"\\f127\";\n}\n\n.icofont-social-renren:before {\n\tcontent: \"\\f128\";\n}\n\n.icofont-social-slack:before {\n\tcontent: \"\\f129\";\n}\n\n.icofont-social-slidshare:before {\n\tcontent: \"\\f12a\";\n}\n\n.icofont-social-snapchat:before {\n\tcontent: \"\\f12b\";\n}\n\n.icofont-social-soundcloud:before {\n\tcontent: \"\\f12c\";\n}\n\n.icofont-social-spotify:before {\n\tcontent: \"\\f12d\";\n}\n\n.icofont-social-stack-exchange:before {\n\tcontent: \"\\f12e\";\n}\n\n.icofont-social-stack-overflow:before {\n\tcontent: \"\\f12f\";\n}\n\n.icofont-social-tagged:before {\n\tcontent: \"\\f130\";\n}\n\n.icofont-social-trello:before {\n\tcontent: \"\\f131\";\n}\n\n.icofont-social-twitch:before {\n\tcontent: \"\\f132\";\n}\n\n.icofont-social-vk:before {\n\tcontent: \"\\f133\";\n}\n\n.icofont-social-weibo:before {\n\tcontent: \"\\f134\";\n}\n\n.icofont-social-whatsapp:before {\n\tcontent: \"\\f135\";\n}\n\n.icofont-social-youku:before {\n\tcontent: \"\\f136\";\n}\n\n.icofont-social-youtube-play:before {\n\tcontent: \"\\f137\";\n}\n\n.icofont-social-youtube:before {\n\tcontent: \"\\f138\";\n}\n\n.icofont-brand-xiaomi:before {\n\tcontent: \"\\f139\";\n}\n\n/*Font size*/\n\n.icofont-lg {\n\tfont-size: 1.33333333em;\n\tline-height: .75em;\n\tvertical-align: -15%;\n}\n\n.icofont-2x {\n\tfont-size: 2em;\n}\n\n.icofont-3x {\n\tfont-size: 3em;\n}\n\n.icofont-4x {\n\tfont-size: 4em;\n}\n\n.icofont-5x {\n\tfont-size: 5em;\n}\n\n.icofont-fw {\n\tdisplay: inline-block;\n\twidth: 1.28571429em;\n\ttext-align: center;\n\twidth: 1.28571429em;\n\ttext-align: center;\n}\n\n/*Fixed Width Icons*/\n\n/*Custom list icons*/\n\n.icofont-ul {\n\tpadding-left: 0;\n\tmargin-left: 2.14285714em;\n\tlist-style-type: none;\n\t> li {\n\t\tposition: relative;\n\t}\n}\n\n.icofont-li {\n\tposition: absolute;\n\tleft: -2.14285714em;\n\twidth: 2.14285714em;\n\ttop: .14285714em;\n\ttext-align: center;\n}\n\n/*Animation*/\n\n.icofont-rotate {\n\tdisplay: inline-block;\n\t-webkit-animation: icofont-rotate 2s infinite linear;\n\tanimation: icofont-rotate 2s infinite linear;\n}\n\n@-webkit-keyframes icofont-rotate {\n\t0% {\n\t\t-webkit-transform: rotate(0deg);\n\t\ttransform: rotate(0deg);\n\t}\n\n\t100% {\n\t\t-webkit-transform: rotate(359deg);\n\t\ttransform: rotate(359deg);\n\t}\n}\n\n\n@keyframes icofont-rotate {\n\t0% {\n\t\t-webkit-transform: rotate(0deg);\n\t\ttransform: rotate(0deg);\n\t}\n\n\t100% {\n\t\t-webkit-transform: rotate(359deg);\n\t\ttransform: rotate(359deg);\n\t}\n}",".flag-icon-background {\n  background-size: contain;\n  background-position: 50%;\n  background-repeat: no-repeat;\n}\n\n.flag-icon {\n  @extend .flag-icon-background;\n  position: relative;\n  display: inline-block;\n  width: (4 / 3) * 1em;\n  line-height: 1em;\n  &:before {\n    content: '\\00a0';\n  }\n  &.flag-icon-squared {\n    width: 1em;\n  }\n}\n\n@mixin flag-icon($country) {\n  .flag-icon-#{$country} {\n    background-image: url(../../../fonts/flag-icon/#{$country}.svg);\n    &.flag-icon-squared {\n      background-image: url(../../../fonts/flag-icon/#{$country}.svg);\n    }\n  }\n}\n","/*!\n *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */\n\n@import \"font-awesome/variables\";\n@import \"font-awesome/mixins\";\n@import \"font-awesome/path\";\n@import \"font-awesome/core\";\n@import \"font-awesome/larger\";\n@import \"font-awesome/fixed-width\";\n@import \"font-awesome/list\";\n@import \"font-awesome/bordered-pulled\";\n@import \"font-awesome/animated\";\n@import \"font-awesome/rotated-flipped\";\n@import \"font-awesome/stacked\";\n@import \"font-awesome/icons\";\n@import \"font-awesome/screen-reader\";\n","/* FONT PATH\n * -------------------------- */\n\n@font-face {\n  font-family: 'FontAwesome';\n  src: url('#{$fa-font-path}/font-awesome/fontawesome-webfont.eot?v=#{$fa-version}');\n  src: url('#{$fa-font-path}/font-awesome/fontawesome-webfont.eot?#iefix&v=#{$fa-version}') format('embedded-opentype'),\n    url('#{$fa-font-path}/font-awesome/fontawesome-webfont.woff2?v=#{$fa-version}') format('woff2'),\n    url('#{$fa-font-path}/font-awesome/fontawesome-webfont.woff?v=#{$fa-version}') format('woff'),\n    url('#{$fa-font-path}/font-awesome/fontawesome-webfont.ttf?v=#{$fa-version}') format('truetype'),\n    url('#{$fa-font-path}/font-awesome/fontawesome-webfont.svg?v=#{$fa-version}#fontawesomeregular') format('svg');\n\n  font-weight: normal;\n  font-style: normal;\n}\n","// Base Class Definition\n// -------------------------\n\n.#{$fa-css-prefix} {\n  display: inline-block;\n  font: normal normal normal #{$fa-font-size-base}/#{$fa-line-height-base} FontAwesome; // shortening font declaration\n  font-size: inherit; // can't have font-size inherit on line above, so need to override\n  text-rendering: auto; // optimizelegibility throws things off #1094\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n}\n","// Icon Sizes\n// -------------------------\n\n/* makes the font 33% larger relative to the icon container */\n.#{$fa-css-prefix}-lg {\n  font-size: (4em / 3);\n  line-height: (3em / 4);\n  vertical-align: -15%;\n}\n.#{$fa-css-prefix}-2x { font-size: 2em; }\n.#{$fa-css-prefix}-3x { font-size: 3em; }\n.#{$fa-css-prefix}-4x { font-size: 4em; }\n.#{$fa-css-prefix}-5x { font-size: 5em; }\n","// Fixed Width Icons\n// -------------------------\n.#{$fa-css-prefix}-fw {\n  width: (18em / 14);\n  text-align: center;\n}\n","// List Icons\n// -------------------------\n\n.#{$fa-css-prefix}-ul {\n  padding-left: 0;\n  margin-left: $fa-li-width;\n  list-style-type: none;\n  > li { position: relative; }\n}\n.#{$fa-css-prefix}-li {\n  position: absolute;\n  left: -$fa-li-width;\n  width: $fa-li-width;\n  top: (2em / 14);\n  text-align: center;\n  &.#{$fa-css-prefix}-lg {\n    left: -$fa-li-width + (4em / 14);\n  }\n}\n","// Variables\n// --------------------------\n\n$fa-font-path:        \"../../../fonts\" !default;\n$fa-font-size-base:   14px !default;\n$fa-line-height-base: 1 !default;\n//$fa-font-path:        \"//netdna.bootstrapcdn.com/font-awesome/4.7.0/fonts\" !default; // for referencing Bootstrap CDN font files directly\n$fa-css-prefix:       fa !default;\n$fa-version:          \"4.7.0\" !default;\n$fa-border-color:     #eee !default;\n$fa-inverse:          #fff !default;\n$fa-li-width:         (30em / 14) !default;\n\n$fa-var-500px: \"\\f26e\";\n$fa-var-address-book: \"\\f2b9\";\n$fa-var-address-book-o: \"\\f2ba\";\n$fa-var-address-card: \"\\f2bb\";\n$fa-var-address-card-o: \"\\f2bc\";\n$fa-var-adjust: \"\\f042\";\n$fa-var-adn: \"\\f170\";\n$fa-var-align-center: \"\\f037\";\n$fa-var-align-justify: \"\\f039\";\n$fa-var-align-left: \"\\f036\";\n$fa-var-align-right: \"\\f038\";\n$fa-var-amazon: \"\\f270\";\n$fa-var-ambulance: \"\\f0f9\";\n$fa-var-american-sign-language-interpreting: \"\\f2a3\";\n$fa-var-anchor: \"\\f13d\";\n$fa-var-android: \"\\f17b\";\n$fa-var-angellist: \"\\f209\";\n$fa-var-angle-double-down: \"\\f103\";\n$fa-var-angle-double-left: \"\\f100\";\n$fa-var-angle-double-right: \"\\f101\";\n$fa-var-angle-double-up: \"\\f102\";\n$fa-var-angle-down: \"\\f107\";\n$fa-var-angle-left: \"\\f104\";\n$fa-var-angle-right: \"\\f105\";\n$fa-var-angle-up: \"\\f106\";\n$fa-var-apple: \"\\f179\";\n$fa-var-archive: \"\\f187\";\n$fa-var-area-chart: \"\\f1fe\";\n$fa-var-arrow-circle-down: \"\\f0ab\";\n$fa-var-arrow-circle-left: \"\\f0a8\";\n$fa-var-arrow-circle-o-down: \"\\f01a\";\n$fa-var-arrow-circle-o-left: \"\\f190\";\n$fa-var-arrow-circle-o-right: \"\\f18e\";\n$fa-var-arrow-circle-o-up: \"\\f01b\";\n$fa-var-arrow-circle-right: \"\\f0a9\";\n$fa-var-arrow-circle-up: \"\\f0aa\";\n$fa-var-arrow-down: \"\\f063\";\n$fa-var-arrow-left: \"\\f060\";\n$fa-var-arrow-right: \"\\f061\";\n$fa-var-arrow-up: \"\\f062\";\n$fa-var-arrows: \"\\f047\";\n$fa-var-arrows-alt: \"\\f0b2\";\n$fa-var-arrows-h: \"\\f07e\";\n$fa-var-arrows-v: \"\\f07d\";\n$fa-var-asl-interpreting: \"\\f2a3\";\n$fa-var-assistive-listening-systems: \"\\f2a2\";\n$fa-var-asterisk: \"\\f069\";\n$fa-var-at: \"\\f1fa\";\n$fa-var-audio-description: \"\\f29e\";\n$fa-var-automobile: \"\\f1b9\";\n$fa-var-backward: \"\\f04a\";\n$fa-var-balance-scale: \"\\f24e\";\n$fa-var-ban: \"\\f05e\";\n$fa-var-bandcamp: \"\\f2d5\";\n$fa-var-bank: \"\\f19c\";\n$fa-var-bar-chart: \"\\f080\";\n$fa-var-bar-chart-o: \"\\f080\";\n$fa-var-barcode: \"\\f02a\";\n$fa-var-bars: \"\\f0c9\";\n$fa-var-bath: \"\\f2cd\";\n$fa-var-bathtub: \"\\f2cd\";\n$fa-var-battery: \"\\f240\";\n$fa-var-battery-0: \"\\f244\";\n$fa-var-battery-1: \"\\f243\";\n$fa-var-battery-2: \"\\f242\";\n$fa-var-battery-3: \"\\f241\";\n$fa-var-battery-4: \"\\f240\";\n$fa-var-battery-empty: \"\\f244\";\n$fa-var-battery-full: \"\\f240\";\n$fa-var-battery-half: \"\\f242\";\n$fa-var-battery-quarter: \"\\f243\";\n$fa-var-battery-three-quarters: \"\\f241\";\n$fa-var-bed: \"\\f236\";\n$fa-var-beer: \"\\f0fc\";\n$fa-var-behance: \"\\f1b4\";\n$fa-var-behance-square: \"\\f1b5\";\n$fa-var-bell: \"\\f0f3\";\n$fa-var-bell-o: \"\\f0a2\";\n$fa-var-bell-slash: \"\\f1f6\";\n$fa-var-bell-slash-o: \"\\f1f7\";\n$fa-var-bicycle: \"\\f206\";\n$fa-var-binoculars: \"\\f1e5\";\n$fa-var-birthday-cake: \"\\f1fd\";\n$fa-var-bitbucket: \"\\f171\";\n$fa-var-bitbucket-square: \"\\f172\";\n$fa-var-bitcoin: \"\\f15a\";\n$fa-var-black-tie: \"\\f27e\";\n$fa-var-blind: \"\\f29d\";\n$fa-var-bluetooth: \"\\f293\";\n$fa-var-bluetooth-b: \"\\f294\";\n$fa-var-bold: \"\\f032\";\n$fa-var-bolt: \"\\f0e7\";\n$fa-var-bomb: \"\\f1e2\";\n$fa-var-book: \"\\f02d\";\n$fa-var-bookmark: \"\\f02e\";\n$fa-var-bookmark-o: \"\\f097\";\n$fa-var-braille: \"\\f2a1\";\n$fa-var-briefcase: \"\\f0b1\";\n$fa-var-btc: \"\\f15a\";\n$fa-var-bug: \"\\f188\";\n$fa-var-building: \"\\f1ad\";\n$fa-var-building-o: \"\\f0f7\";\n$fa-var-bullhorn: \"\\f0a1\";\n$fa-var-bullseye: \"\\f140\";\n$fa-var-bus: \"\\f207\";\n$fa-var-buysellads: \"\\f20d\";\n$fa-var-cab: \"\\f1ba\";\n$fa-var-calculator: \"\\f1ec\";\n$fa-var-calendar: \"\\f073\";\n$fa-var-calendar-check-o: \"\\f274\";\n$fa-var-calendar-minus-o: \"\\f272\";\n$fa-var-calendar-o: \"\\f133\";\n$fa-var-calendar-plus-o: \"\\f271\";\n$fa-var-calendar-times-o: \"\\f273\";\n$fa-var-camera: \"\\f030\";\n$fa-var-camera-retro: \"\\f083\";\n$fa-var-car: \"\\f1b9\";\n$fa-var-caret-down: \"\\f0d7\";\n$fa-var-caret-left: \"\\f0d9\";\n$fa-var-caret-right: \"\\f0da\";\n$fa-var-caret-square-o-down: \"\\f150\";\n$fa-var-caret-square-o-left: \"\\f191\";\n$fa-var-caret-square-o-right: \"\\f152\";\n$fa-var-caret-square-o-up: \"\\f151\";\n$fa-var-caret-up: \"\\f0d8\";\n$fa-var-cart-arrow-down: \"\\f218\";\n$fa-var-cart-plus: \"\\f217\";\n$fa-var-cc: \"\\f20a\";\n$fa-var-cc-amex: \"\\f1f3\";\n$fa-var-cc-diners-club: \"\\f24c\";\n$fa-var-cc-discover: \"\\f1f2\";\n$fa-var-cc-jcb: \"\\f24b\";\n$fa-var-cc-mastercard: \"\\f1f1\";\n$fa-var-cc-paypal: \"\\f1f4\";\n$fa-var-cc-stripe: \"\\f1f5\";\n$fa-var-cc-visa: \"\\f1f0\";\n$fa-var-certificate: \"\\f0a3\";\n$fa-var-chain: \"\\f0c1\";\n$fa-var-chain-broken: \"\\f127\";\n$fa-var-check: \"\\f00c\";\n$fa-var-check-circle: \"\\f058\";\n$fa-var-check-circle-o: \"\\f05d\";\n$fa-var-check-square: \"\\f14a\";\n$fa-var-check-square-o: \"\\f046\";\n$fa-var-chevron-circle-down: \"\\f13a\";\n$fa-var-chevron-circle-left: \"\\f137\";\n$fa-var-chevron-circle-right: \"\\f138\";\n$fa-var-chevron-circle-up: \"\\f139\";\n$fa-var-chevron-down: \"\\f078\";\n$fa-var-chevron-left: \"\\f053\";\n$fa-var-chevron-right: \"\\f054\";\n$fa-var-chevron-up: \"\\f077\";\n$fa-var-child: \"\\f1ae\";\n$fa-var-chrome: \"\\f268\";\n$fa-var-circle: \"\\f111\";\n$fa-var-circle-o: \"\\f10c\";\n$fa-var-circle-o-notch: \"\\f1ce\";\n$fa-var-circle-thin: \"\\f1db\";\n$fa-var-clipboard: \"\\f0ea\";\n$fa-var-clock-o: \"\\f017\";\n$fa-var-clone: \"\\f24d\";\n$fa-var-close: \"\\f00d\";\n$fa-var-cloud: \"\\f0c2\";\n$fa-var-cloud-download: \"\\f0ed\";\n$fa-var-cloud-upload: \"\\f0ee\";\n$fa-var-cny: \"\\f157\";\n$fa-var-code: \"\\f121\";\n$fa-var-code-fork: \"\\f126\";\n$fa-var-codepen: \"\\f1cb\";\n$fa-var-codiepie: \"\\f284\";\n$fa-var-coffee: \"\\f0f4\";\n$fa-var-cog: \"\\f013\";\n$fa-var-cogs: \"\\f085\";\n$fa-var-columns: \"\\f0db\";\n$fa-var-comment: \"\\f075\";\n$fa-var-comment-o: \"\\f0e5\";\n$fa-var-commenting: \"\\f27a\";\n$fa-var-commenting-o: \"\\f27b\";\n$fa-var-comments: \"\\f086\";\n$fa-var-comments-o: \"\\f0e6\";\n$fa-var-compass: \"\\f14e\";\n$fa-var-compress: \"\\f066\";\n$fa-var-connectdevelop: \"\\f20e\";\n$fa-var-contao: \"\\f26d\";\n$fa-var-copy: \"\\f0c5\";\n$fa-var-copyright: \"\\f1f9\";\n$fa-var-Cuba-commons: \"\\f25e\";\n$fa-var-credit-card: \"\\f09d\";\n$fa-var-credit-card-alt: \"\\f283\";\n$fa-var-crop: \"\\f125\";\n$fa-var-crosshairs: \"\\f05b\";\n$fa-var-css3: \"\\f13c\";\n$fa-var-cube: \"\\f1b2\";\n$fa-var-cubes: \"\\f1b3\";\n$fa-var-cut: \"\\f0c4\";\n$fa-var-cutlery: \"\\f0f5\";\n$fa-var-dashboard: \"\\f0e4\";\n$fa-var-dashcube: \"\\f210\";\n$fa-var-database: \"\\f1c0\";\n$fa-var-deaf: \"\\f2a4\";\n$fa-var-deafness: \"\\f2a4\";\n$fa-var-dedent: \"\\f03b\";\n$fa-var-delicious: \"\\f1a5\";\n$fa-var-desktop: \"\\f108\";\n$fa-var-deviantart: \"\\f1bd\";\n$fa-var-diamond: \"\\f219\";\n$fa-var-digg: \"\\f1a6\";\n$fa-var-dollar: \"\\f155\";\n$fa-var-dot-circle-o: \"\\f192\";\n$fa-var-download: \"\\f019\";\n$fa-var-dribbble: \"\\f17d\";\n$fa-var-drivers-license: \"\\f2c2\";\n$fa-var-drivers-license-o: \"\\f2c3\";\n$fa-var-dropbox: \"\\f16b\";\n$fa-var-drupal: \"\\f1a9\";\n$fa-var-edge: \"\\f282\";\n$fa-var-edit: \"\\f044\";\n$fa-var-eercast: \"\\f2da\";\n$fa-var-eject: \"\\f052\";\n$fa-var-ellipsis-h: \"\\f141\";\n$fa-var-ellipsis-v: \"\\f142\";\n$fa-var-empire: \"\\f1d1\";\n$fa-var-envelope: \"\\f0e0\";\n$fa-var-envelope-o: \"\\f003\";\n$fa-var-envelope-open: \"\\f2b6\";\n$fa-var-envelope-open-o: \"\\f2b7\";\n$fa-var-envelope-square: \"\\f199\";\n$fa-var-envira: \"\\f299\";\n$fa-var-eraser: \"\\f12d\";\n$fa-var-etsy: \"\\f2d7\";\n$fa-var-eur: \"\\f153\";\n$fa-var-euro: \"\\f153\";\n$fa-var-exchange: \"\\f0ec\";\n$fa-var-exclamation: \"\\f12a\";\n$fa-var-exclamation-circle: \"\\f06a\";\n$fa-var-exclamation-triangle: \"\\f071\";\n$fa-var-expand: \"\\f065\";\n$fa-var-expeditedssl: \"\\f23e\";\n$fa-var-external-link: \"\\f08e\";\n$fa-var-external-link-square: \"\\f14c\";\n$fa-var-eye: \"\\f06e\";\n$fa-var-eye-slash: \"\\f070\";\n$fa-var-eyedropper: \"\\f1fb\";\n$fa-var-fa: \"\\f2b4\";\n$fa-var-facebook: \"\\f09a\";\n$fa-var-facebook-f: \"\\f09a\";\n$fa-var-facebook-official: \"\\f230\";\n$fa-var-facebook-square: \"\\f082\";\n$fa-var-fast-backward: \"\\f049\";\n$fa-var-fast-forward: \"\\f050\";\n$fa-var-fax: \"\\f1ac\";\n$fa-var-feed: \"\\f09e\";\n$fa-var-female: \"\\f182\";\n$fa-var-fighter-jet: \"\\f0fb\";\n$fa-var-file: \"\\f15b\";\n$fa-var-file-archive-o: \"\\f1c6\";\n$fa-var-file-audio-o: \"\\f1c7\";\n$fa-var-file-code-o: \"\\f1c9\";\n$fa-var-file-excel-o: \"\\f1c3\";\n$fa-var-file-image-o: \"\\f1c5\";\n$fa-var-file-movie-o: \"\\f1c8\";\n$fa-var-file-o: \"\\f016\";\n$fa-var-file-pdf-o: \"\\f1c1\";\n$fa-var-file-photo-o: \"\\f1c5\";\n$fa-var-file-picture-o: \"\\f1c5\";\n$fa-var-file-powerpoint-o: \"\\f1c4\";\n$fa-var-file-sound-o: \"\\f1c7\";\n$fa-var-file-text: \"\\f15c\";\n$fa-var-file-text-o: \"\\f0f6\";\n$fa-var-file-video-o: \"\\f1c8\";\n$fa-var-file-word-o: \"\\f1c2\";\n$fa-var-file-zip-o: \"\\f1c6\";\n$fa-var-files-o: \"\\f0c5\";\n$fa-var-film: \"\\f008\";\n$fa-var-filter: \"\\f0b0\";\n$fa-var-fire: \"\\f06d\";\n$fa-var-fire-extinguisher: \"\\f134\";\n$fa-var-firefox: \"\\f269\";\n$fa-var-first-order: \"\\f2b0\";\n$fa-var-flag: \"\\f024\";\n$fa-var-flag-checkered: \"\\f11e\";\n$fa-var-flag-o: \"\\f11d\";\n$fa-var-flash: \"\\f0e7\";\n$fa-var-flask: \"\\f0c3\";\n$fa-var-flickr: \"\\f16e\";\n$fa-var-floppy-o: \"\\f0c7\";\n$fa-var-folder: \"\\f07b\";\n$fa-var-folder-o: \"\\f114\";\n$fa-var-folder-open: \"\\f07c\";\n$fa-var-folder-open-o: \"\\f115\";\n$fa-var-font: \"\\f031\";\n$fa-var-font-awesome: \"\\f2b4\";\n$fa-var-fonticons: \"\\f280\";\n$fa-var-fort-awesome: \"\\f286\";\n$fa-var-forumbee: \"\\f211\";\n$fa-var-forward: \"\\f04e\";\n$fa-var-foursquare: \"\\f180\";\n$fa-var-free-code-camp: \"\\f2c5\";\n$fa-var-frown-o: \"\\f119\";\n$fa-var-futbol-o: \"\\f1e3\";\n$fa-var-gamepad: \"\\f11b\";\n$fa-var-gavel: \"\\f0e3\";\n$fa-var-gbp: \"\\f154\";\n$fa-var-ge: \"\\f1d1\";\n$fa-var-gear: \"\\f013\";\n$fa-var-gears: \"\\f085\";\n$fa-var-genderless: \"\\f22d\";\n$fa-var-get-pocket: \"\\f265\";\n$fa-var-gg: \"\\f260\";\n$fa-var-gg-circle: \"\\f261\";\n$fa-var-gift: \"\\f06b\";\n$fa-var-git: \"\\f1d3\";\n$fa-var-git-square: \"\\f1d2\";\n$fa-var-github: \"\\f09b\";\n$fa-var-github-alt: \"\\f113\";\n$fa-var-github-square: \"\\f092\";\n$fa-var-gitlab: \"\\f296\";\n$fa-var-gittip: \"\\f184\";\n$fa-var-glass: \"\\f000\";\n$fa-var-glide: \"\\f2a5\";\n$fa-var-glide-g: \"\\f2a6\";\n$fa-var-globe: \"\\f0ac\";\n$fa-var-google: \"\\f1a0\";\n$fa-var-google-plus: \"\\f0d5\";\n$fa-var-google-plus-circle: \"\\f2b3\";\n$fa-var-google-plus-official: \"\\f2b3\";\n$fa-var-google-plus-square: \"\\f0d4\";\n$fa-var-google-wallet: \"\\f1ee\";\n$fa-var-graduation-cap: \"\\f19d\";\n$fa-var-gratipay: \"\\f184\";\n$fa-var-grav: \"\\f2d6\";\n$fa-var-group: \"\\f0c0\";\n$fa-var-h-square: \"\\f0fd\";\n$fa-var-hacker-news: \"\\f1d4\";\n$fa-var-hand-grab-o: \"\\f255\";\n$fa-var-hand-lizard-o: \"\\f258\";\n$fa-var-hand-o-down: \"\\f0a7\";\n$fa-var-hand-o-left: \"\\f0a5\";\n$fa-var-hand-o-right: \"\\f0a4\";\n$fa-var-hand-o-up: \"\\f0a6\";\n$fa-var-hand-paper-o: \"\\f256\";\n$fa-var-hand-peace-o: \"\\f25b\";\n$fa-var-hand-pointer-o: \"\\f25a\";\n$fa-var-hand-rock-o: \"\\f255\";\n$fa-var-hand-scissors-o: \"\\f257\";\n$fa-var-hand-spock-o: \"\\f259\";\n$fa-var-hand-stop-o: \"\\f256\";\n$fa-var-handshake-o: \"\\f2b5\";\n$fa-var-hard-of-hearing: \"\\f2a4\";\n$fa-var-hashtag: \"\\f292\";\n$fa-var-hdd-o: \"\\f0a0\";\n$fa-var-header: \"\\f1dc\";\n$fa-var-headphones: \"\\f025\";\n$fa-var-heart: \"\\f004\";\n$fa-var-heart-o: \"\\f08a\";\n$fa-var-heartbeat: \"\\f21e\";\n$fa-var-history: \"\\f1da\";\n$fa-var-home: \"\\f015\";\n$fa-var-hospital-o: \"\\f0f8\";\n$fa-var-hotel: \"\\f236\";\n$fa-var-hourglass: \"\\f254\";\n$fa-var-hourglass-1: \"\\f251\";\n$fa-var-hourglass-2: \"\\f252\";\n$fa-var-hourglass-3: \"\\f253\";\n$fa-var-hourglass-end: \"\\f253\";\n$fa-var-hourglass-half: \"\\f252\";\n$fa-var-hourglass-o: \"\\f250\";\n$fa-var-hourglass-start: \"\\f251\";\n$fa-var-houzz: \"\\f27c\";\n$fa-var-html5: \"\\f13b\";\n$fa-var-i-cursor: \"\\f246\";\n$fa-var-id-badge: \"\\f2c1\";\n$fa-var-id-card: \"\\f2c2\";\n$fa-var-id-card-o: \"\\f2c3\";\n$fa-var-ils: \"\\f20b\";\n$fa-var-image: \"\\f03e\";\n$fa-var-imdb: \"\\f2d8\";\n$fa-var-inbox: \"\\f01c\";\n$fa-var-indent: \"\\f03c\";\n$fa-var-industry: \"\\f275\";\n$fa-var-info: \"\\f129\";\n$fa-var-info-circle: \"\\f05a\";\n$fa-var-inr: \"\\f156\";\n$fa-var-instagram: \"\\f16d\";\n$fa-var-institution: \"\\f19c\";\n$fa-var-internet-explorer: \"\\f26b\";\n$fa-var-intersex: \"\\f224\";\n$fa-var-ioxhost: \"\\f208\";\n$fa-var-italic: \"\\f033\";\n$fa-var-joomla: \"\\f1aa\";\n$fa-var-jpy: \"\\f157\";\n$fa-var-jsfiddle: \"\\f1cc\";\n$fa-var-key: \"\\f084\";\n$fa-var-keyboard-o: \"\\f11c\";\n$fa-var-krw: \"\\f159\";\n$fa-var-language: \"\\f1ab\";\n$fa-var-laptop: \"\\f109\";\n$fa-var-lastfm: \"\\f202\";\n$fa-var-lastfm-square: \"\\f203\";\n$fa-var-leaf: \"\\f06c\";\n$fa-var-leanpub: \"\\f212\";\n$fa-var-legal: \"\\f0e3\";\n$fa-var-lemon-o: \"\\f094\";\n$fa-var-level-down: \"\\f149\";\n$fa-var-level-up: \"\\f148\";\n$fa-var-life-bouy: \"\\f1cd\";\n$fa-var-life-buoy: \"\\f1cd\";\n$fa-var-life-ring: \"\\f1cd\";\n$fa-var-life-saver: \"\\f1cd\";\n$fa-var-lightbulb-o: \"\\f0eb\";\n$fa-var-line-chart: \"\\f201\";\n$fa-var-link: \"\\f0c1\";\n$fa-var-linkedin: \"\\f0e1\";\n$fa-var-linkedin-square: \"\\f08c\";\n$fa-var-linode: \"\\f2b8\";\n$fa-var-linux: \"\\f17c\";\n$fa-var-list: \"\\f03a\";\n$fa-var-list-alt: \"\\f022\";\n$fa-var-list-ol: \"\\f0cb\";\n$fa-var-list-ul: \"\\f0ca\";\n$fa-var-location-arrow: \"\\f124\";\n$fa-var-lock: \"\\f023\";\n$fa-var-long-arrow-down: \"\\f175\";\n$fa-var-long-arrow-left: \"\\f177\";\n$fa-var-long-arrow-right: \"\\f178\";\n$fa-var-long-arrow-up: \"\\f176\";\n$fa-var-low-vision: \"\\f2a8\";\n$fa-var-magic: \"\\f0d0\";\n$fa-var-magnet: \"\\f076\";\n$fa-var-mail-forward: \"\\f064\";\n$fa-var-mail-reply: \"\\f112\";\n$fa-var-mail-reply-all: \"\\f122\";\n$fa-var-male: \"\\f183\";\n$fa-var-map: \"\\f279\";\n$fa-var-map-marker: \"\\f041\";\n$fa-var-map-o: \"\\f278\";\n$fa-var-map-pin: \"\\f276\";\n$fa-var-map-signs: \"\\f277\";\n$fa-var-mars: \"\\f222\";\n$fa-var-mars-double: \"\\f227\";\n$fa-var-mars-stroke: \"\\f229\";\n$fa-var-mars-stroke-h: \"\\f22b\";\n$fa-var-mars-stroke-v: \"\\f22a\";\n$fa-var-maxcdn: \"\\f136\";\n$fa-var-meanpath: \"\\f20c\";\n$fa-var-medium: \"\\f23a\";\n$fa-var-medkit: \"\\f0fa\";\n$fa-var-meetup: \"\\f2e0\";\n$fa-var-meh-o: \"\\f11a\";\n$fa-var-mercury: \"\\f223\";\n$fa-var-microchip: \"\\f2db\";\n$fa-var-microphone: \"\\f130\";\n$fa-var-microphone-slash: \"\\f131\";\n$fa-var-minus: \"\\f068\";\n$fa-var-minus-circle: \"\\f056\";\n$fa-var-minus-square: \"\\f146\";\n$fa-var-minus-square-o: \"\\f147\";\n$fa-var-mixcloud: \"\\f289\";\n$fa-var-mobile: \"\\f10b\";\n$fa-var-mobile-phone: \"\\f10b\";\n$fa-var-modx: \"\\f285\";\n$fa-var-money: \"\\f0d6\";\n$fa-var-moon-o: \"\\f186\";\n$fa-var-mortar-board: \"\\f19d\";\n$fa-var-motorcycle: \"\\f21c\";\n$fa-var-mouse-pointer: \"\\f245\";\n$fa-var-music: \"\\f001\";\n$fa-var-navicon: \"\\f0c9\";\n$fa-var-neuter: \"\\f22c\";\n$fa-var-newspaper-o: \"\\f1ea\";\n$fa-var-object-group: \"\\f247\";\n$fa-var-object-ungroup: \"\\f248\";\n$fa-var-odnoklassniki: \"\\f263\";\n$fa-var-odnoklassniki-square: \"\\f264\";\n$fa-var-opencart: \"\\f23d\";\n$fa-var-openid: \"\\f19b\";\n$fa-var-opera: \"\\f26a\";\n$fa-var-optin-monster: \"\\f23c\";\n$fa-var-outdent: \"\\f03b\";\n$fa-var-pagelines: \"\\f18c\";\n$fa-var-paint-brush: \"\\f1fc\";\n$fa-var-paper-plane: \"\\f1d8\";\n$fa-var-paper-plane-o: \"\\f1d9\";\n$fa-var-paperclip: \"\\f0c6\";\n$fa-var-paragraph: \"\\f1dd\";\n$fa-var-paste: \"\\f0ea\";\n$fa-var-pause: \"\\f04c\";\n$fa-var-pause-circle: \"\\f28b\";\n$fa-var-pause-circle-o: \"\\f28c\";\n$fa-var-paw: \"\\f1b0\";\n$fa-var-paypal: \"\\f1ed\";\n$fa-var-pencil: \"\\f040\";\n$fa-var-pencil-square: \"\\f14b\";\n$fa-var-pencil-square-o: \"\\f044\";\n$fa-var-percent: \"\\f295\";\n$fa-var-phone: \"\\f095\";\n$fa-var-phone-square: \"\\f098\";\n$fa-var-photo: \"\\f03e\";\n$fa-var-picture-o: \"\\f03e\";\n$fa-var-pie-chart: \"\\f200\";\n$fa-var-pied-piper: \"\\f2ae\";\n$fa-var-pied-piper-alt: \"\\f1a8\";\n$fa-var-pied-piper-pp: \"\\f1a7\";\n$fa-var-pinterest: \"\\f0d2\";\n$fa-var-pinterest-p: \"\\f231\";\n$fa-var-pinterest-square: \"\\f0d3\";\n$fa-var-plane: \"\\f072\";\n$fa-var-play: \"\\f04b\";\n$fa-var-play-circle: \"\\f144\";\n$fa-var-play-circle-o: \"\\f01d\";\n$fa-var-plug: \"\\f1e6\";\n$fa-var-plus: \"\\f067\";\n$fa-var-plus-circle: \"\\f055\";\n$fa-var-plus-square: \"\\f0fe\";\n$fa-var-plus-square-o: \"\\f196\";\n$fa-var-podcast: \"\\f2ce\";\n$fa-var-power-off: \"\\f011\";\n$fa-var-print: \"\\f02f\";\n$fa-var-product-hunt: \"\\f288\";\n$fa-var-puzzle-piece: \"\\f12e\";\n$fa-var-qq: \"\\f1d6\";\n$fa-var-qrcode: \"\\f029\";\n$fa-var-question: \"\\f128\";\n$fa-var-question-circle: \"\\f059\";\n$fa-var-question-circle-o: \"\\f29c\";\n$fa-var-quora: \"\\f2c4\";\n$fa-var-quote-left: \"\\f10d\";\n$fa-var-quote-right: \"\\f10e\";\n$fa-var-ra: \"\\f1d0\";\n$fa-var-random: \"\\f074\";\n$fa-var-ravelry: \"\\f2d9\";\n$fa-var-rebel: \"\\f1d0\";\n$fa-var-recycle: \"\\f1b8\";\n$fa-var-reddit: \"\\f1a1\";\n$fa-var-reddit-alien: \"\\f281\";\n$fa-var-reddit-square: \"\\f1a2\";\n$fa-var-refresh: \"\\f021\";\n$fa-var-registered: \"\\f25d\";\n$fa-var-remove: \"\\f00d\";\n$fa-var-renren: \"\\f18b\";\n$fa-var-reorder: \"\\f0c9\";\n$fa-var-repeat: \"\\f01e\";\n$fa-var-reply: \"\\f112\";\n$fa-var-reply-all: \"\\f122\";\n$fa-var-resistance: \"\\f1d0\";\n$fa-var-retweet: \"\\f079\";\n$fa-var-rmb: \"\\f157\";\n$fa-var-road: \"\\f018\";\n$fa-var-rocket: \"\\f135\";\n$fa-var-rotate-left: \"\\f0e2\";\n$fa-var-rotate-right: \"\\f01e\";\n$fa-var-rouble: \"\\f158\";\n$fa-var-rss: \"\\f09e\";\n$fa-var-rss-square: \"\\f143\";\n$fa-var-rub: \"\\f158\";\n$fa-var-ruble: \"\\f158\";\n$fa-var-rupee: \"\\f156\";\n$fa-var-s15: \"\\f2cd\";\n$fa-var-safari: \"\\f267\";\n$fa-var-save: \"\\f0c7\";\n$fa-var-scissors: \"\\f0c4\";\n$fa-var-scribd: \"\\f28a\";\n$fa-var-search: \"\\f002\";\n$fa-var-search-minus: \"\\f010\";\n$fa-var-search-plus: \"\\f00e\";\n$fa-var-sellsy: \"\\f213\";\n$fa-var-send: \"\\f1d8\";\n$fa-var-send-o: \"\\f1d9\";\n$fa-var-server: \"\\f233\";\n$fa-var-share: \"\\f064\";\n$fa-var-share-alt: \"\\f1e0\";\n$fa-var-share-alt-square: \"\\f1e1\";\n$fa-var-share-square: \"\\f14d\";\n$fa-var-share-square-o: \"\\f045\";\n$fa-var-shekel: \"\\f20b\";\n$fa-var-sheqel: \"\\f20b\";\n$fa-var-shield: \"\\f132\";\n$fa-var-ship: \"\\f21a\";\n$fa-var-shirtsinbulk: \"\\f214\";\n$fa-var-shopping-bag: \"\\f290\";\n$fa-var-shopping-basket: \"\\f291\";\n$fa-var-shopping-cart: \"\\f07a\";\n$fa-var-shower: \"\\f2cc\";\n$fa-var-sign-in: \"\\f090\";\n$fa-var-sign-language: \"\\f2a7\";\n$fa-var-sign-out: \"\\f08b\";\n$fa-var-signal: \"\\f012\";\n$fa-var-signing: \"\\f2a7\";\n$fa-var-simplybuilt: \"\\f215\";\n$fa-var-sitemap: \"\\f0e8\";\n$fa-var-skyatlas: \"\\f216\";\n$fa-var-skype: \"\\f17e\";\n$fa-var-slack: \"\\f198\";\n$fa-var-sliders: \"\\f1de\";\n$fa-var-slideshare: \"\\f1e7\";\n$fa-var-smile-o: \"\\f118\";\n$fa-var-snapchat: \"\\f2ab\";\n$fa-var-snapchat-ghost: \"\\f2ac\";\n$fa-var-snapchat-square: \"\\f2ad\";\n$fa-var-snowflake-o: \"\\f2dc\";\n$fa-var-soccer-ball-o: \"\\f1e3\";\n$fa-var-sort: \"\\f0dc\";\n$fa-var-sort-alpha-asc: \"\\f15d\";\n$fa-var-sort-alpha-desc: \"\\f15e\";\n$fa-var-sort-amount-asc: \"\\f160\";\n$fa-var-sort-amount-desc: \"\\f161\";\n$fa-var-sort-asc: \"\\f0de\";\n$fa-var-sort-desc: \"\\f0dd\";\n$fa-var-sort-down: \"\\f0dd\";\n$fa-var-sort-numeric-asc: \"\\f162\";\n$fa-var-sort-numeric-desc: \"\\f163\";\n$fa-var-sort-up: \"\\f0de\";\n$fa-var-soundcloud: \"\\f1be\";\n$fa-var-space-shuttle: \"\\f197\";\n$fa-var-spinner: \"\\f110\";\n$fa-var-spoon: \"\\f1b1\";\n$fa-var-spotify: \"\\f1bc\";\n$fa-var-square: \"\\f0c8\";\n$fa-var-square-o: \"\\f096\";\n$fa-var-stack-exchange: \"\\f18d\";\n$fa-var-stack-overflow: \"\\f16c\";\n$fa-var-star: \"\\f005\";\n$fa-var-star-half: \"\\f089\";\n$fa-var-star-half-empty: \"\\f123\";\n$fa-var-star-half-full: \"\\f123\";\n$fa-var-star-half-o: \"\\f123\";\n$fa-var-star-o: \"\\f006\";\n$fa-var-steam: \"\\f1b6\";\n$fa-var-steam-square: \"\\f1b7\";\n$fa-var-step-backward: \"\\f048\";\n$fa-var-step-forward: \"\\f051\";\n$fa-var-stethoscope: \"\\f0f1\";\n$fa-var-sticky-note: \"\\f249\";\n$fa-var-sticky-note-o: \"\\f24a\";\n$fa-var-stop: \"\\f04d\";\n$fa-var-stop-circle: \"\\f28d\";\n$fa-var-stop-circle-o: \"\\f28e\";\n$fa-var-street-view: \"\\f21d\";\n$fa-var-strikethrough: \"\\f0cc\";\n$fa-var-stumbleupon: \"\\f1a4\";\n$fa-var-stumbleupon-circle: \"\\f1a3\";\n$fa-var-subscript: \"\\f12c\";\n$fa-var-subway: \"\\f239\";\n$fa-var-suitcase: \"\\f0f2\";\n$fa-var-sun-o: \"\\f185\";\n$fa-var-superpowers: \"\\f2dd\";\n$fa-var-superscript: \"\\f12b\";\n$fa-var-support: \"\\f1cd\";\n$fa-var-table: \"\\f0ce\";\n$fa-var-tablet: \"\\f10a\";\n$fa-var-tachometer: \"\\f0e4\";\n$fa-var-tag: \"\\f02b\";\n$fa-var-tags: \"\\f02c\";\n$fa-var-tasks: \"\\f0ae\";\n$fa-var-taxi: \"\\f1ba\";\n$fa-var-telegram: \"\\f2c6\";\n$fa-var-television: \"\\f26c\";\n$fa-var-tencent-weibo: \"\\f1d5\";\n$fa-var-terminal: \"\\f120\";\n$fa-var-text-height: \"\\f034\";\n$fa-var-text-width: \"\\f035\";\n$fa-var-th: \"\\f00a\";\n$fa-var-th-large: \"\\f009\";\n$fa-var-th-list: \"\\f00b\";\n$fa-var-themeisle: \"\\f2b2\";\n$fa-var-thermometer: \"\\f2c7\";\n$fa-var-thermometer-0: \"\\f2cb\";\n$fa-var-thermometer-1: \"\\f2ca\";\n$fa-var-thermometer-2: \"\\f2c9\";\n$fa-var-thermometer-3: \"\\f2c8\";\n$fa-var-thermometer-4: \"\\f2c7\";\n$fa-var-thermometer-empty: \"\\f2cb\";\n$fa-var-thermometer-full: \"\\f2c7\";\n$fa-var-thermometer-half: \"\\f2c9\";\n$fa-var-thermometer-quarter: \"\\f2ca\";\n$fa-var-thermometer-three-quarters: \"\\f2c8\";\n$fa-var-thumb-tack: \"\\f08d\";\n$fa-var-thumbs-down: \"\\f165\";\n$fa-var-thumbs-o-down: \"\\f088\";\n$fa-var-thumbs-o-up: \"\\f087\";\n$fa-var-thumbs-up: \"\\f164\";\n$fa-var-ticket: \"\\f145\";\n$fa-var-times: \"\\f00d\";\n$fa-var-times-circle: \"\\f057\";\n$fa-var-times-circle-o: \"\\f05c\";\n$fa-var-times-rectangle: \"\\f2d3\";\n$fa-var-times-rectangle-o: \"\\f2d4\";\n$fa-var-tint: \"\\f043\";\n$fa-var-toggle-down: \"\\f150\";\n$fa-var-toggle-left: \"\\f191\";\n$fa-var-toggle-off: \"\\f204\";\n$fa-var-toggle-on: \"\\f205\";\n$fa-var-toggle-right: \"\\f152\";\n$fa-var-toggle-up: \"\\f151\";\n$fa-var-trademark: \"\\f25c\";\n$fa-var-train: \"\\f238\";\n$fa-var-transgender: \"\\f224\";\n$fa-var-transgender-alt: \"\\f225\";\n$fa-var-trash: \"\\f1f8\";\n$fa-var-trash-o: \"\\f014\";\n$fa-var-tree: \"\\f1bb\";\n$fa-var-trello: \"\\f181\";\n$fa-var-tripadvisor: \"\\f262\";\n$fa-var-trophy: \"\\f091\";\n$fa-var-truck: \"\\f0d1\";\n$fa-var-try: \"\\f195\";\n$fa-var-tty: \"\\f1e4\";\n$fa-var-tumblr: \"\\f173\";\n$fa-var-tumblr-square: \"\\f174\";\n$fa-var-turkish-lira: \"\\f195\";\n$fa-var-tv: \"\\f26c\";\n$fa-var-twitch: \"\\f1e8\";\n$fa-var-twitter: \"\\f099\";\n$fa-var-twitter-square: \"\\f081\";\n$fa-var-umbrella: \"\\f0e9\";\n$fa-var-underline: \"\\f0cd\";\n$fa-var-undo: \"\\f0e2\";\n$fa-var-Cuba-access: \"\\f29a\";\n$fa-var-university: \"\\f19c\";\n$fa-var-unlink: \"\\f127\";\n$fa-var-unlock: \"\\f09c\";\n$fa-var-unlock-alt: \"\\f13e\";\n$fa-var-unsorted: \"\\f0dc\";\n$fa-var-upload: \"\\f093\";\n$fa-var-usb: \"\\f287\";\n$fa-var-usd: \"\\f155\";\n$fa-var-user: \"\\f007\";\n$fa-var-user-circle: \"\\f2bd\";\n$fa-var-user-circle-o: \"\\f2be\";\n$fa-var-user-md: \"\\f0f0\";\n$fa-var-user-o: \"\\f2c0\";\n$fa-var-user-plus: \"\\f234\";\n$fa-var-user-secret: \"\\f21b\";\n$fa-var-user-times: \"\\f235\";\n$fa-var-users: \"\\f0c0\";\n$fa-var-vcard: \"\\f2bb\";\n$fa-var-vcard-o: \"\\f2bc\";\n$fa-var-venus: \"\\f221\";\n$fa-var-venus-double: \"\\f226\";\n$fa-var-venus-mars: \"\\f228\";\n$fa-var-viacoin: \"\\f237\";\n$fa-var-viadeo: \"\\f2a9\";\n$fa-var-viadeo-square: \"\\f2aa\";\n$fa-var-video-camera: \"\\f03d\";\n$fa-var-vimeo: \"\\f27d\";\n$fa-var-vimeo-square: \"\\f194\";\n$fa-var-vine: \"\\f1ca\";\n$fa-var-vk: \"\\f189\";\n$fa-var-volume-control-phone: \"\\f2a0\";\n$fa-var-volume-down: \"\\f027\";\n$fa-var-volume-off: \"\\f026\";\n$fa-var-volume-up: \"\\f028\";\n$fa-var-warning: \"\\f071\";\n$fa-var-wechat: \"\\f1d7\";\n$fa-var-weibo: \"\\f18a\";\n$fa-var-weixin: \"\\f1d7\";\n$fa-var-whatsapp: \"\\f232\";\n$fa-var-wheelchair: \"\\f193\";\n$fa-var-wheelchair-alt: \"\\f29b\";\n$fa-var-wifi: \"\\f1eb\";\n$fa-var-wikipedia-w: \"\\f266\";\n$fa-var-window-close: \"\\f2d3\";\n$fa-var-window-close-o: \"\\f2d4\";\n$fa-var-window-maximize: \"\\f2d0\";\n$fa-var-window-minimize: \"\\f2d1\";\n$fa-var-window-restore: \"\\f2d2\";\n$fa-var-windows: \"\\f17a\";\n$fa-var-won: \"\\f159\";\n$fa-var-wordpress: \"\\f19a\";\n$fa-var-wpbeginner: \"\\f297\";\n$fa-var-wpexplorer: \"\\f2de\";\n$fa-var-wpforms: \"\\f298\";\n$fa-var-wrench: \"\\f0ad\";\n$fa-var-xing: \"\\f168\";\n$fa-var-xing-square: \"\\f169\";\n$fa-var-y-combinator: \"\\f23b\";\n$fa-var-y-combinator-square: \"\\f1d4\";\n$fa-var-yahoo: \"\\f19e\";\n$fa-var-yc: \"\\f23b\";\n$fa-var-yc-square: \"\\f1d4\";\n$fa-var-yelp: \"\\f1e9\";\n$fa-var-yen: \"\\f157\";\n$fa-var-yoast: \"\\f2b1\";\n$fa-var-youtube: \"\\f167\";\n$fa-var-youtube-play: \"\\f16a\";\n$fa-var-youtube-square: \"\\f166\";\n\n","// Bordered & Pulled\n// -------------------------\n\n.#{$fa-css-prefix}-border {\n  padding: .2em .25em .15em;\n  border: solid .08em $fa-border-color;\n  border-radius: .1em;\n}\n\n.#{$fa-css-prefix}-pull-left { float: left; }\n.#{$fa-css-prefix}-pull-right { float: right; }\n\n.#{$fa-css-prefix} {\n  &.#{$fa-css-prefix}-pull-left { margin-right: .3em; }\n  &.#{$fa-css-prefix}-pull-right { margin-left: .3em; }\n}\n\n/* Deprecated as of 4.4.0 */\n.pull-right { float: right; }\n.pull-left { float: left; }\n\n.#{$fa-css-prefix} {\n  &.pull-left { margin-right: .3em; }\n  &.pull-right { margin-left: .3em; }\n}\n","// Spinning Icons\n// --------------------------\n\n.#{$fa-css-prefix}-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear;\n}\n\n.#{$fa-css-prefix}-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8);\n}\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n  }\n}\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n  }\n}\n","// Rotated & Flipped Icons\n// -------------------------\n\n.#{$fa-css-prefix}-rotate-90  { @include fa-icon-rotate(90deg, 1);  }\n.#{$fa-css-prefix}-rotate-180 { @include fa-icon-rotate(180deg, 2); }\n.#{$fa-css-prefix}-rotate-270 { @include fa-icon-rotate(270deg, 3); }\n\n.#{$fa-css-prefix}-flip-horizontal { @include fa-icon-flip(-1, 1, 0); }\n.#{$fa-css-prefix}-flip-vertical   { @include fa-icon-flip(1, -1, 2); }\n\n// Hook for IE8-9\n// -------------------------\n\n:root .#{$fa-css-prefix}-rotate-90,\n:root .#{$fa-css-prefix}-rotate-180,\n:root .#{$fa-css-prefix}-rotate-270,\n:root .#{$fa-css-prefix}-flip-horizontal,\n:root .#{$fa-css-prefix}-flip-vertical {\n  filter: none;\n}\n","// Mixins\n// --------------------------\n\n@mixin fa-icon() {\n  display: inline-block;\n  font: normal normal normal #{$fa-font-size-base}/#{$fa-line-height-base} FontAwesome; // shortening font declaration\n  font-size: inherit; // can't have font-size inherit on line above, so need to override\n  text-rendering: auto; // optimizelegibility throws things off #1094\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n}\n\n@mixin fa-icon-rotate($degrees, $rotation) {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=#{$rotation})\";\n  -webkit-transform: rotate($degrees);\n      -ms-transform: rotate($degrees);\n          transform: rotate($degrees);\n}\n\n@mixin fa-icon-flip($horiz, $vert, $rotation) {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=#{$rotation}, mirror=1)\";\n  -webkit-transform: scale($horiz, $vert);\n      -ms-transform: scale($horiz, $vert);\n          transform: scale($horiz, $vert);\n}\n\n\n// Only display content to screen readers. A la Bootstrap 4.\n//\n// See: http://a11yproject.com/posts/how-to-hide-content/\n\n@mixin sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0,0,0,0);\n  border: 0;\n}\n\n// Use in conjunction with .sr-only to only display content when it's focused.\n//\n// Useful for \"Skip to main content\" links; see http://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n//\n// Credit: HTML5 Boilerplate\n\n@mixin sr-only-focusable {\n  &:active,\n  &:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    margin: 0;\n    overflow: visible;\n    clip: auto;\n  }\n}\n","// Stacked Icons\n// -------------------------\n\n.#{$fa-css-prefix}-stack {\n  position: relative;\n  display: inline-block;\n  width: 2em;\n  height: 2em;\n  line-height: 2em;\n  vertical-align: middle;\n}\n.#{$fa-css-prefix}-stack-1x, .#{$fa-css-prefix}-stack-2x {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  text-align: center;\n}\n.#{$fa-css-prefix}-stack-1x { line-height: inherit; }\n.#{$fa-css-prefix}-stack-2x { font-size: 2em; }\n.#{$fa-css-prefix}-inverse { color: $fa-inverse; }\n","/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen\n   readers do not read off random characters that represent icons */\n\n.#{$fa-css-prefix}-glass:before { content: $fa-var-glass; }\n.#{$fa-css-prefix}-music:before { content: $fa-var-music; }\n.#{$fa-css-prefix}-search:before { content: $fa-var-search; }\n.#{$fa-css-prefix}-envelope-o:before { content: $fa-var-envelope-o; }\n.#{$fa-css-prefix}-heart:before { content: $fa-var-heart; }\n.#{$fa-css-prefix}-star:before { content: $fa-var-star; }\n.#{$fa-css-prefix}-star-o:before { content: $fa-var-star-o; }\n.#{$fa-css-prefix}-user:before { content: $fa-var-user; }\n.#{$fa-css-prefix}-film:before { content: $fa-var-film; }\n.#{$fa-css-prefix}-th-large:before { content: $fa-var-th-large; }\n.#{$fa-css-prefix}-th:before { content: $fa-var-th; }\n.#{$fa-css-prefix}-th-list:before { content: $fa-var-th-list; }\n.#{$fa-css-prefix}-check:before { content: $fa-var-check; }\n.#{$fa-css-prefix}-remove:before,\n.#{$fa-css-prefix}-close:before,\n.#{$fa-css-prefix}-times:before { content: $fa-var-times; }\n.#{$fa-css-prefix}-search-plus:before { content: $fa-var-search-plus; }\n.#{$fa-css-prefix}-search-minus:before { content: $fa-var-search-minus; }\n.#{$fa-css-prefix}-power-off:before { content: $fa-var-power-off; }\n.#{$fa-css-prefix}-signal:before { content: $fa-var-signal; }\n.#{$fa-css-prefix}-gear:before,\n.#{$fa-css-prefix}-cog:before { content: $fa-var-cog; }\n.#{$fa-css-prefix}-trash-o:before { content: $fa-var-trash-o; }\n.#{$fa-css-prefix}-home:before { content: $fa-var-home; }\n.#{$fa-css-prefix}-file-o:before { content: $fa-var-file-o; }\n.#{$fa-css-prefix}-clock-o:before { content: $fa-var-clock-o; }\n.#{$fa-css-prefix}-road:before { content: $fa-var-road; }\n.#{$fa-css-prefix}-download:before { content: $fa-var-download; }\n.#{$fa-css-prefix}-arrow-circle-o-down:before { content: $fa-var-arrow-circle-o-down; }\n.#{$fa-css-prefix}-arrow-circle-o-up:before { content: $fa-var-arrow-circle-o-up; }\n.#{$fa-css-prefix}-inbox:before { content: $fa-var-inbox; }\n.#{$fa-css-prefix}-play-circle-o:before { content: $fa-var-play-circle-o; }\n.#{$fa-css-prefix}-rotate-right:before,\n.#{$fa-css-prefix}-repeat:before { content: $fa-var-repeat; }\n.#{$fa-css-prefix}-refresh:before { content: $fa-var-refresh; }\n.#{$fa-css-prefix}-list-alt:before { content: $fa-var-list-alt; }\n.#{$fa-css-prefix}-lock:before { content: $fa-var-lock; }\n.#{$fa-css-prefix}-flag:before { content: $fa-var-flag; }\n.#{$fa-css-prefix}-headphones:before { content: $fa-var-headphones; }\n.#{$fa-css-prefix}-volume-off:before { content: $fa-var-volume-off; }\n.#{$fa-css-prefix}-volume-down:before { content: $fa-var-volume-down; }\n.#{$fa-css-prefix}-volume-up:before { content: $fa-var-volume-up; }\n.#{$fa-css-prefix}-qrcode:before { content: $fa-var-qrcode; }\n.#{$fa-css-prefix}-barcode:before { content: $fa-var-barcode; }\n.#{$fa-css-prefix}-tag:before { content: $fa-var-tag; }\n.#{$fa-css-prefix}-tags:before { content: $fa-var-tags; }\n.#{$fa-css-prefix}-book:before { content: $fa-var-book; }\n.#{$fa-css-prefix}-bookmark:before { content: $fa-var-bookmark; }\n.#{$fa-css-prefix}-print:before { content: $fa-var-print; }\n.#{$fa-css-prefix}-camera:before { content: $fa-var-camera; }\n.#{$fa-css-prefix}-font:before { content: $fa-var-font; }\n.#{$fa-css-prefix}-bold:before { content: $fa-var-bold; }\n.#{$fa-css-prefix}-italic:before { content: $fa-var-italic; }\n.#{$fa-css-prefix}-text-height:before { content: $fa-var-text-height; }\n.#{$fa-css-prefix}-text-width:before { content: $fa-var-text-width; }\n.#{$fa-css-prefix}-align-left:before { content: $fa-var-align-left; }\n.#{$fa-css-prefix}-align-center:before { content: $fa-var-align-center; }\n.#{$fa-css-prefix}-align-right:before { content: $fa-var-align-right; }\n.#{$fa-css-prefix}-align-justify:before { content: $fa-var-align-justify; }\n.#{$fa-css-prefix}-list:before { content: $fa-var-list; }\n.#{$fa-css-prefix}-dedent:before,\n.#{$fa-css-prefix}-outdent:before { content: $fa-var-outdent; }\n.#{$fa-css-prefix}-indent:before { content: $fa-var-indent; }\n.#{$fa-css-prefix}-video-camera:before { content: $fa-var-video-camera; }\n.#{$fa-css-prefix}-photo:before,\n.#{$fa-css-prefix}-image:before,\n.#{$fa-css-prefix}-picture-o:before { content: $fa-var-picture-o; }\n.#{$fa-css-prefix}-pencil:before { content: $fa-var-pencil; }\n.#{$fa-css-prefix}-map-marker:before { content: $fa-var-map-marker; }\n.#{$fa-css-prefix}-adjust:before { content: $fa-var-adjust; }\n.#{$fa-css-prefix}-tint:before { content: $fa-var-tint; }\n.#{$fa-css-prefix}-edit:before,\n.#{$fa-css-prefix}-pencil-square-o:before { content: $fa-var-pencil-square-o; }\n.#{$fa-css-prefix}-share-square-o:before { content: $fa-var-share-square-o; }\n.#{$fa-css-prefix}-check-square-o:before { content: $fa-var-check-square-o; }\n.#{$fa-css-prefix}-arrows:before { content: $fa-var-arrows; }\n.#{$fa-css-prefix}-step-backward:before { content: $fa-var-step-backward; }\n.#{$fa-css-prefix}-fast-backward:before { content: $fa-var-fast-backward; }\n.#{$fa-css-prefix}-backward:before { content: $fa-var-backward; }\n.#{$fa-css-prefix}-play:before { content: $fa-var-play; }\n.#{$fa-css-prefix}-pause:before { content: $fa-var-pause; }\n.#{$fa-css-prefix}-stop:before { content: $fa-var-stop; }\n.#{$fa-css-prefix}-forward:before { content: $fa-var-forward; }\n.#{$fa-css-prefix}-fast-forward:before { content: $fa-var-fast-forward; }\n.#{$fa-css-prefix}-step-forward:before { content: $fa-var-step-forward; }\n.#{$fa-css-prefix}-eject:before { content: $fa-var-eject; }\n.#{$fa-css-prefix}-chevron-left:before { content: $fa-var-chevron-left; }\n.#{$fa-css-prefix}-chevron-right:before { content: $fa-var-chevron-right; }\n.#{$fa-css-prefix}-plus-circle:before { content: $fa-var-plus-circle; }\n.#{$fa-css-prefix}-minus-circle:before { content: $fa-var-minus-circle; }\n.#{$fa-css-prefix}-times-circle:before { content: $fa-var-times-circle; }\n.#{$fa-css-prefix}-check-circle:before { content: $fa-var-check-circle; }\n.#{$fa-css-prefix}-question-circle:before { content: $fa-var-question-circle; }\n.#{$fa-css-prefix}-info-circle:before { content: $fa-var-info-circle; }\n.#{$fa-css-prefix}-crosshairs:before { content: $fa-var-crosshairs; }\n.#{$fa-css-prefix}-times-circle-o:before { content: $fa-var-times-circle-o; }\n.#{$fa-css-prefix}-check-circle-o:before { content: $fa-var-check-circle-o; }\n.#{$fa-css-prefix}-ban:before { content: $fa-var-ban; }\n.#{$fa-css-prefix}-arrow-left:before { content: $fa-var-arrow-left; }\n.#{$fa-css-prefix}-arrow-right:before { content: $fa-var-arrow-right; }\n.#{$fa-css-prefix}-arrow-up:before { content: $fa-var-arrow-up; }\n.#{$fa-css-prefix}-arrow-down:before { content: $fa-var-arrow-down; }\n.#{$fa-css-prefix}-mail-forward:before,\n.#{$fa-css-prefix}-share:before { content: $fa-var-share; }\n.#{$fa-css-prefix}-expand:before { content: $fa-var-expand; }\n.#{$fa-css-prefix}-compress:before { content: $fa-var-compress; }\n.#{$fa-css-prefix}-plus:before { content: $fa-var-plus; }\n.#{$fa-css-prefix}-minus:before { content: $fa-var-minus; }\n.#{$fa-css-prefix}-asterisk:before { content: $fa-var-asterisk; }\n.#{$fa-css-prefix}-exclamation-circle:before { content: $fa-var-exclamation-circle; }\n.#{$fa-css-prefix}-gift:before { content: $fa-var-gift; }\n.#{$fa-css-prefix}-leaf:before { content: $fa-var-leaf; }\n.#{$fa-css-prefix}-fire:before { content: $fa-var-fire; }\n.#{$fa-css-prefix}-eye:before { content: $fa-var-eye; }\n.#{$fa-css-prefix}-eye-slash:before { content: $fa-var-eye-slash; }\n.#{$fa-css-prefix}-warning:before,\n.#{$fa-css-prefix}-exclamation-triangle:before { content: $fa-var-exclamation-triangle; }\n.#{$fa-css-prefix}-plane:before { content: $fa-var-plane; }\n.#{$fa-css-prefix}-calendar:before { content: $fa-var-calendar; }\n.#{$fa-css-prefix}-random:before { content: $fa-var-random; }\n.#{$fa-css-prefix}-comment:before { content: $fa-var-comment; }\n.#{$fa-css-prefix}-magnet:before { content: $fa-var-magnet; }\n.#{$fa-css-prefix}-chevron-up:before { content: $fa-var-chevron-up; }\n.#{$fa-css-prefix}-chevron-down:before { content: $fa-var-chevron-down; }\n.#{$fa-css-prefix}-retweet:before { content: $fa-var-retweet; }\n.#{$fa-css-prefix}-shopping-cart:before { content: $fa-var-shopping-cart; }\n.#{$fa-css-prefix}-folder:before { content: $fa-var-folder; }\n.#{$fa-css-prefix}-folder-open:before { content: $fa-var-folder-open; }\n.#{$fa-css-prefix}-arrows-v:before { content: $fa-var-arrows-v; }\n.#{$fa-css-prefix}-arrows-h:before { content: $fa-var-arrows-h; }\n.#{$fa-css-prefix}-bar-chart-o:before,\n.#{$fa-css-prefix}-bar-chart:before { content: $fa-var-bar-chart; }\n.#{$fa-css-prefix}-twitter-square:before { content: $fa-var-twitter-square; }\n.#{$fa-css-prefix}-facebook-square:before { content: $fa-var-facebook-square; }\n.#{$fa-css-prefix}-camera-retro:before { content: $fa-var-camera-retro; }\n.#{$fa-css-prefix}-key:before { content: $fa-var-key; }\n.#{$fa-css-prefix}-gears:before,\n.#{$fa-css-prefix}-cogs:before { content: $fa-var-cogs; }\n.#{$fa-css-prefix}-comments:before { content: $fa-var-comments; }\n.#{$fa-css-prefix}-thumbs-o-up:before { content: $fa-var-thumbs-o-up; }\n.#{$fa-css-prefix}-thumbs-o-down:before { content: $fa-var-thumbs-o-down; }\n.#{$fa-css-prefix}-star-half:before { content: $fa-var-star-half; }\n.#{$fa-css-prefix}-heart-o:before { content: $fa-var-heart-o; }\n.#{$fa-css-prefix}-sign-out:before { content: $fa-var-sign-out; }\n.#{$fa-css-prefix}-linkedin-square:before { content: $fa-var-linkedin-square; }\n.#{$fa-css-prefix}-thumb-tack:before { content: $fa-var-thumb-tack; }\n.#{$fa-css-prefix}-external-link:before { content: $fa-var-external-link; }\n.#{$fa-css-prefix}-sign-in:before { content: $fa-var-sign-in; }\n.#{$fa-css-prefix}-trophy:before { content: $fa-var-trophy; }\n.#{$fa-css-prefix}-github-square:before { content: $fa-var-github-square; }\n.#{$fa-css-prefix}-upload:before { content: $fa-var-upload; }\n.#{$fa-css-prefix}-lemon-o:before { content: $fa-var-lemon-o; }\n.#{$fa-css-prefix}-phone:before { content: $fa-var-phone; }\n.#{$fa-css-prefix}-square-o:before { content: $fa-var-square-o; }\n.#{$fa-css-prefix}-bookmark-o:before { content: $fa-var-bookmark-o; }\n.#{$fa-css-prefix}-phone-square:before { content: $fa-var-phone-square; }\n.#{$fa-css-prefix}-twitter:before { content: $fa-var-twitter; }\n.#{$fa-css-prefix}-facebook-f:before,\n.#{$fa-css-prefix}-facebook:before { content: $fa-var-facebook; }\n.#{$fa-css-prefix}-github:before { content: $fa-var-github; }\n.#{$fa-css-prefix}-unlock:before { content: $fa-var-unlock; }\n.#{$fa-css-prefix}-credit-card:before { content: $fa-var-credit-card; }\n.#{$fa-css-prefix}-feed:before,\n.#{$fa-css-prefix}-rss:before { content: $fa-var-rss; }\n.#{$fa-css-prefix}-hdd-o:before { content: $fa-var-hdd-o; }\n.#{$fa-css-prefix}-bullhorn:before { content: $fa-var-bullhorn; }\n.#{$fa-css-prefix}-bell:before { content: $fa-var-bell; }\n.#{$fa-css-prefix}-certificate:before { content: $fa-var-certificate; }\n.#{$fa-css-prefix}-hand-o-right:before { content: $fa-var-hand-o-right; }\n.#{$fa-css-prefix}-hand-o-left:before { content: $fa-var-hand-o-left; }\n.#{$fa-css-prefix}-hand-o-up:before { content: $fa-var-hand-o-up; }\n.#{$fa-css-prefix}-hand-o-down:before { content: $fa-var-hand-o-down; }\n.#{$fa-css-prefix}-arrow-circle-left:before { content: $fa-var-arrow-circle-left; }\n.#{$fa-css-prefix}-arrow-circle-right:before { content: $fa-var-arrow-circle-right; }\n.#{$fa-css-prefix}-arrow-circle-up:before { content: $fa-var-arrow-circle-up; }\n.#{$fa-css-prefix}-arrow-circle-down:before { content: $fa-var-arrow-circle-down; }\n.#{$fa-css-prefix}-globe:before { content: $fa-var-globe; }\n.#{$fa-css-prefix}-wrench:before { content: $fa-var-wrench; }\n.#{$fa-css-prefix}-tasks:before { content: $fa-var-tasks; }\n.#{$fa-css-prefix}-filter:before { content: $fa-var-filter; }\n.#{$fa-css-prefix}-briefcase:before { content: $fa-var-briefcase; }\n.#{$fa-css-prefix}-arrows-alt:before { content: $fa-var-arrows-alt; }\n.#{$fa-css-prefix}-group:before,\n.#{$fa-css-prefix}-users:before { content: $fa-var-users; }\n.#{$fa-css-prefix}-chain:before,\n.#{$fa-css-prefix}-link:before { content: $fa-var-link; }\n.#{$fa-css-prefix}-cloud:before { content: $fa-var-cloud; }\n.#{$fa-css-prefix}-flask:before { content: $fa-var-flask; }\n.#{$fa-css-prefix}-cut:before,\n.#{$fa-css-prefix}-scissors:before { content: $fa-var-scissors; }\n.#{$fa-css-prefix}-copy:before,\n.#{$fa-css-prefix}-files-o:before { content: $fa-var-files-o; }\n.#{$fa-css-prefix}-paperclip:before { content: $fa-var-paperclip; }\n.#{$fa-css-prefix}-save:before,\n.#{$fa-css-prefix}-floppy-o:before { content: $fa-var-floppy-o; }\n.#{$fa-css-prefix}-square:before { content: $fa-var-square; }\n.#{$fa-css-prefix}-navicon:before,\n.#{$fa-css-prefix}-reorder:before,\n.#{$fa-css-prefix}-bars:before { content: $fa-var-bars; }\n.#{$fa-css-prefix}-list-ul:before { content: $fa-var-list-ul; }\n.#{$fa-css-prefix}-list-ol:before { content: $fa-var-list-ol; }\n.#{$fa-css-prefix}-strikethrough:before { content: $fa-var-strikethrough; }\n.#{$fa-css-prefix}-underline:before { content: $fa-var-underline; }\n.#{$fa-css-prefix}-table:before { content: $fa-var-table; }\n.#{$fa-css-prefix}-magic:before { content: $fa-var-magic; }\n.#{$fa-css-prefix}-truck:before { content: $fa-var-truck; }\n.#{$fa-css-prefix}-pinterest:before { content: $fa-var-pinterest; }\n.#{$fa-css-prefix}-pinterest-square:before { content: $fa-var-pinterest-square; }\n.#{$fa-css-prefix}-google-plus-square:before { content: $fa-var-google-plus-square; }\n.#{$fa-css-prefix}-google-plus:before { content: $fa-var-google-plus; }\n.#{$fa-css-prefix}-money:before { content: $fa-var-money; }\n.#{$fa-css-prefix}-caret-down:before { content: $fa-var-caret-down; }\n.#{$fa-css-prefix}-caret-up:before { content: $fa-var-caret-up; }\n.#{$fa-css-prefix}-caret-left:before { content: $fa-var-caret-left; }\n.#{$fa-css-prefix}-caret-right:before { content: $fa-var-caret-right; }\n.#{$fa-css-prefix}-columns:before { content: $fa-var-columns; }\n.#{$fa-css-prefix}-unsorted:before,\n.#{$fa-css-prefix}-sort:before { content: $fa-var-sort; }\n.#{$fa-css-prefix}-sort-down:before,\n.#{$fa-css-prefix}-sort-desc:before { content: $fa-var-sort-desc; }\n.#{$fa-css-prefix}-sort-up:before,\n.#{$fa-css-prefix}-sort-asc:before { content: $fa-var-sort-asc; }\n.#{$fa-css-prefix}-envelope:before { content: $fa-var-envelope; }\n.#{$fa-css-prefix}-linkedin:before { content: $fa-var-linkedin; }\n.#{$fa-css-prefix}-rotate-left:before,\n.#{$fa-css-prefix}-undo:before { content: $fa-var-undo; }\n.#{$fa-css-prefix}-legal:before,\n.#{$fa-css-prefix}-gavel:before { content: $fa-var-gavel; }\n.#{$fa-css-prefix}-dashboard:before,\n.#{$fa-css-prefix}-tachometer:before { content: $fa-var-tachometer; }\n.#{$fa-css-prefix}-comment-o:before { content: $fa-var-comment-o; }\n.#{$fa-css-prefix}-comments-o:before { content: $fa-var-comments-o; }\n.#{$fa-css-prefix}-flash:before,\n.#{$fa-css-prefix}-bolt:before { content: $fa-var-bolt; }\n.#{$fa-css-prefix}-sitemap:before { content: $fa-var-sitemap; }\n.#{$fa-css-prefix}-umbrella:before { content: $fa-var-umbrella; }\n.#{$fa-css-prefix}-paste:before,\n.#{$fa-css-prefix}-clipboard:before { content: $fa-var-clipboard; }\n.#{$fa-css-prefix}-lightbulb-o:before { content: $fa-var-lightbulb-o; }\n.#{$fa-css-prefix}-exchange:before { content: $fa-var-exchange; }\n.#{$fa-css-prefix}-cloud-download:before { content: $fa-var-cloud-download; }\n.#{$fa-css-prefix}-cloud-upload:before { content: $fa-var-cloud-upload; }\n.#{$fa-css-prefix}-user-md:before { content: $fa-var-user-md; }\n.#{$fa-css-prefix}-stethoscope:before { content: $fa-var-stethoscope; }\n.#{$fa-css-prefix}-suitcase:before { content: $fa-var-suitcase; }\n.#{$fa-css-prefix}-bell-o:before { content: $fa-var-bell-o; }\n.#{$fa-css-prefix}-coffee:before { content: $fa-var-coffee; }\n.#{$fa-css-prefix}-cutlery:before { content: $fa-var-cutlery; }\n.#{$fa-css-prefix}-file-text-o:before { content: $fa-var-file-text-o; }\n.#{$fa-css-prefix}-building-o:before { content: $fa-var-building-o; }\n.#{$fa-css-prefix}-hospital-o:before { content: $fa-var-hospital-o; }\n.#{$fa-css-prefix}-ambulance:before { content: $fa-var-ambulance; }\n.#{$fa-css-prefix}-medkit:before { content: $fa-var-medkit; }\n.#{$fa-css-prefix}-fighter-jet:before { content: $fa-var-fighter-jet; }\n.#{$fa-css-prefix}-beer:before { content: $fa-var-beer; }\n.#{$fa-css-prefix}-h-square:before { content: $fa-var-h-square; }\n.#{$fa-css-prefix}-plus-square:before { content: $fa-var-plus-square; }\n.#{$fa-css-prefix}-angle-double-left:before { content: $fa-var-angle-double-left; }\n.#{$fa-css-prefix}-angle-double-right:before { content: $fa-var-angle-double-right; }\n.#{$fa-css-prefix}-angle-double-up:before { content: $fa-var-angle-double-up; }\n.#{$fa-css-prefix}-angle-double-down:before { content: $fa-var-angle-double-down; }\n.#{$fa-css-prefix}-angle-left:before { content: $fa-var-angle-left; }\n.#{$fa-css-prefix}-angle-right:before { content: $fa-var-angle-right; }\n.#{$fa-css-prefix}-angle-up:before { content: $fa-var-angle-up; }\n.#{$fa-css-prefix}-angle-down:before { content: $fa-var-angle-down; }\n.#{$fa-css-prefix}-desktop:before { content: $fa-var-desktop; }\n.#{$fa-css-prefix}-laptop:before { content: $fa-var-laptop; }\n.#{$fa-css-prefix}-tablet:before { content: $fa-var-tablet; }\n.#{$fa-css-prefix}-mobile-phone:before,\n.#{$fa-css-prefix}-mobile:before { content: $fa-var-mobile; }\n.#{$fa-css-prefix}-circle-o:before { content: $fa-var-circle-o; }\n.#{$fa-css-prefix}-quote-left:before { content: $fa-var-quote-left; }\n.#{$fa-css-prefix}-quote-right:before { content: $fa-var-quote-right; }\n.#{$fa-css-prefix}-spinner:before { content: $fa-var-spinner; }\n.#{$fa-css-prefix}-circle:before { content: $fa-var-circle; }\n.#{$fa-css-prefix}-mail-reply:before,\n.#{$fa-css-prefix}-reply:before { content: $fa-var-reply; }\n.#{$fa-css-prefix}-github-alt:before { content: $fa-var-github-alt; }\n.#{$fa-css-prefix}-folder-o:before { content: $fa-var-folder-o; }\n.#{$fa-css-prefix}-folder-open-o:before { content: $fa-var-folder-open-o; }\n.#{$fa-css-prefix}-smile-o:before { content: $fa-var-smile-o; }\n.#{$fa-css-prefix}-frown-o:before { content: $fa-var-frown-o; }\n.#{$fa-css-prefix}-meh-o:before { content: $fa-var-meh-o; }\n.#{$fa-css-prefix}-gamepad:before { content: $fa-var-gamepad; }\n.#{$fa-css-prefix}-keyboard-o:before { content: $fa-var-keyboard-o; }\n.#{$fa-css-prefix}-flag-o:before { content: $fa-var-flag-o; }\n.#{$fa-css-prefix}-flag-checkered:before { content: $fa-var-flag-checkered; }\n.#{$fa-css-prefix}-terminal:before { content: $fa-var-terminal; }\n.#{$fa-css-prefix}-code:before { content: $fa-var-code; }\n.#{$fa-css-prefix}-mail-reply-all:before,\n.#{$fa-css-prefix}-reply-all:before { content: $fa-var-reply-all; }\n.#{$fa-css-prefix}-star-half-empty:before,\n.#{$fa-css-prefix}-star-half-full:before,\n.#{$fa-css-prefix}-star-half-o:before { content: $fa-var-star-half-o; }\n.#{$fa-css-prefix}-location-arrow:before { content: $fa-var-location-arrow; }\n.#{$fa-css-prefix}-crop:before { content: $fa-var-crop; }\n.#{$fa-css-prefix}-code-fork:before { content: $fa-var-code-fork; }\n.#{$fa-css-prefix}-unlink:before,\n.#{$fa-css-prefix}-chain-broken:before { content: $fa-var-chain-broken; }\n.#{$fa-css-prefix}-question:before { content: $fa-var-question; }\n.#{$fa-css-prefix}-info:before { content: $fa-var-info; }\n.#{$fa-css-prefix}-exclamation:before { content: $fa-var-exclamation; }\n.#{$fa-css-prefix}-superscript:before { content: $fa-var-superscript; }\n.#{$fa-css-prefix}-subscript:before { content: $fa-var-subscript; }\n.#{$fa-css-prefix}-eraser:before { content: $fa-var-eraser; }\n.#{$fa-css-prefix}-puzzle-piece:before { content: $fa-var-puzzle-piece; }\n.#{$fa-css-prefix}-microphone:before { content: $fa-var-microphone; }\n.#{$fa-css-prefix}-microphone-slash:before { content: $fa-var-microphone-slash; }\n.#{$fa-css-prefix}-shield:before { content: $fa-var-shield; }\n.#{$fa-css-prefix}-calendar-o:before { content: $fa-var-calendar-o; }\n.#{$fa-css-prefix}-fire-extinguisher:before { content: $fa-var-fire-extinguisher; }\n.#{$fa-css-prefix}-rocket:before { content: $fa-var-rocket; }\n.#{$fa-css-prefix}-maxcdn:before { content: $fa-var-maxcdn; }\n.#{$fa-css-prefix}-chevron-circle-left:before { content: $fa-var-chevron-circle-left; }\n.#{$fa-css-prefix}-chevron-circle-right:before { content: $fa-var-chevron-circle-right; }\n.#{$fa-css-prefix}-chevron-circle-up:before { content: $fa-var-chevron-circle-up; }\n.#{$fa-css-prefix}-chevron-circle-down:before { content: $fa-var-chevron-circle-down; }\n.#{$fa-css-prefix}-html5:before { content: $fa-var-html5; }\n.#{$fa-css-prefix}-css3:before { content: $fa-var-css3; }\n.#{$fa-css-prefix}-anchor:before { content: $fa-var-anchor; }\n.#{$fa-css-prefix}-unlock-alt:before { content: $fa-var-unlock-alt; }\n.#{$fa-css-prefix}-bullseye:before { content: $fa-var-bullseye; }\n.#{$fa-css-prefix}-ellipsis-h:before { content: $fa-var-ellipsis-h; }\n.#{$fa-css-prefix}-ellipsis-v:before { content: $fa-var-ellipsis-v; }\n.#{$fa-css-prefix}-rss-square:before { content: $fa-var-rss-square; }\n.#{$fa-css-prefix}-play-circle:before { content: $fa-var-play-circle; }\n.#{$fa-css-prefix}-ticket:before { content: $fa-var-ticket; }\n.#{$fa-css-prefix}-minus-square:before { content: $fa-var-minus-square; }\n.#{$fa-css-prefix}-minus-square-o:before { content: $fa-var-minus-square-o; }\n.#{$fa-css-prefix}-level-up:before { content: $fa-var-level-up; }\n.#{$fa-css-prefix}-level-down:before { content: $fa-var-level-down; }\n.#{$fa-css-prefix}-check-square:before { content: $fa-var-check-square; }\n.#{$fa-css-prefix}-pencil-square:before { content: $fa-var-pencil-square; }\n.#{$fa-css-prefix}-external-link-square:before { content: $fa-var-external-link-square; }\n.#{$fa-css-prefix}-share-square:before { content: $fa-var-share-square; }\n.#{$fa-css-prefix}-compass:before { content: $fa-var-compass; }\n.#{$fa-css-prefix}-toggle-down:before,\n.#{$fa-css-prefix}-caret-square-o-down:before { content: $fa-var-caret-square-o-down; }\n.#{$fa-css-prefix}-toggle-up:before,\n.#{$fa-css-prefix}-caret-square-o-up:before { content: $fa-var-caret-square-o-up; }\n.#{$fa-css-prefix}-toggle-right:before,\n.#{$fa-css-prefix}-caret-square-o-right:before { content: $fa-var-caret-square-o-right; }\n.#{$fa-css-prefix}-euro:before,\n.#{$fa-css-prefix}-eur:before { content: $fa-var-eur; }\n.#{$fa-css-prefix}-gbp:before { content: $fa-var-gbp; }\n.#{$fa-css-prefix}-dollar:before,\n.#{$fa-css-prefix}-usd:before { content: $fa-var-usd; }\n.#{$fa-css-prefix}-rupee:before,\n.#{$fa-css-prefix}-inr:before { content: $fa-var-inr; }\n.#{$fa-css-prefix}-cny:before,\n.#{$fa-css-prefix}-rmb:before,\n.#{$fa-css-prefix}-yen:before,\n.#{$fa-css-prefix}-jpy:before { content: $fa-var-jpy; }\n.#{$fa-css-prefix}-ruble:before,\n.#{$fa-css-prefix}-rouble:before,\n.#{$fa-css-prefix}-rub:before { content: $fa-var-rub; }\n.#{$fa-css-prefix}-won:before,\n.#{$fa-css-prefix}-krw:before { content: $fa-var-krw; }\n.#{$fa-css-prefix}-bitcoin:before,\n.#{$fa-css-prefix}-btc:before { content: $fa-var-btc; }\n.#{$fa-css-prefix}-file:before { content: $fa-var-file; }\n.#{$fa-css-prefix}-file-text:before { content: $fa-var-file-text; }\n.#{$fa-css-prefix}-sort-alpha-asc:before { content: $fa-var-sort-alpha-asc; }\n.#{$fa-css-prefix}-sort-alpha-desc:before { content: $fa-var-sort-alpha-desc; }\n.#{$fa-css-prefix}-sort-amount-asc:before { content: $fa-var-sort-amount-asc; }\n.#{$fa-css-prefix}-sort-amount-desc:before { content: $fa-var-sort-amount-desc; }\n.#{$fa-css-prefix}-sort-numeric-asc:before { content: $fa-var-sort-numeric-asc; }\n.#{$fa-css-prefix}-sort-numeric-desc:before { content: $fa-var-sort-numeric-desc; }\n.#{$fa-css-prefix}-thumbs-up:before { content: $fa-var-thumbs-up; }\n.#{$fa-css-prefix}-thumbs-down:before { content: $fa-var-thumbs-down; }\n.#{$fa-css-prefix}-youtube-square:before { content: $fa-var-youtube-square; }\n.#{$fa-css-prefix}-youtube:before { content: $fa-var-youtube; }\n.#{$fa-css-prefix}-xing:before { content: $fa-var-xing; }\n.#{$fa-css-prefix}-xing-square:before { content: $fa-var-xing-square; }\n.#{$fa-css-prefix}-youtube-play:before { content: $fa-var-youtube-play; }\n.#{$fa-css-prefix}-dropbox:before { content: $fa-var-dropbox; }\n.#{$fa-css-prefix}-stack-overflow:before { content: $fa-var-stack-overflow; }\n.#{$fa-css-prefix}-instagram:before { content: $fa-var-instagram; }\n.#{$fa-css-prefix}-flickr:before { content: $fa-var-flickr; }\n.#{$fa-css-prefix}-adn:before { content: $fa-var-adn; }\n.#{$fa-css-prefix}-bitbucket:before { content: $fa-var-bitbucket; }\n.#{$fa-css-prefix}-bitbucket-square:before { content: $fa-var-bitbucket-square; }\n.#{$fa-css-prefix}-tumblr:before { content: $fa-var-tumblr; }\n.#{$fa-css-prefix}-tumblr-square:before { content: $fa-var-tumblr-square; }\n.#{$fa-css-prefix}-long-arrow-down:before { content: $fa-var-long-arrow-down; }\n.#{$fa-css-prefix}-long-arrow-up:before { content: $fa-var-long-arrow-up; }\n.#{$fa-css-prefix}-long-arrow-left:before { content: $fa-var-long-arrow-left; }\n.#{$fa-css-prefix}-long-arrow-right:before { content: $fa-var-long-arrow-right; }\n.#{$fa-css-prefix}-apple:before { content: $fa-var-apple; }\n.#{$fa-css-prefix}-windows:before { content: $fa-var-windows; }\n.#{$fa-css-prefix}-android:before { content: $fa-var-android; }\n.#{$fa-css-prefix}-linux:before { content: $fa-var-linux; }\n.#{$fa-css-prefix}-dribbble:before { content: $fa-var-dribbble; }\n.#{$fa-css-prefix}-skype:before { content: $fa-var-skype; }\n.#{$fa-css-prefix}-foursquare:before { content: $fa-var-foursquare; }\n.#{$fa-css-prefix}-trello:before { content: $fa-var-trello; }\n.#{$fa-css-prefix}-female:before { content: $fa-var-female; }\n.#{$fa-css-prefix}-male:before { content: $fa-var-male; }\n.#{$fa-css-prefix}-gittip:before,\n.#{$fa-css-prefix}-gratipay:before { content: $fa-var-gratipay; }\n.#{$fa-css-prefix}-sun-o:before { content: $fa-var-sun-o; }\n.#{$fa-css-prefix}-moon-o:before { content: $fa-var-moon-o; }\n.#{$fa-css-prefix}-archive:before { content: $fa-var-archive; }\n.#{$fa-css-prefix}-bug:before { content: $fa-var-bug; }\n.#{$fa-css-prefix}-vk:before { content: $fa-var-vk; }\n.#{$fa-css-prefix}-weibo:before { content: $fa-var-weibo; }\n.#{$fa-css-prefix}-renren:before { content: $fa-var-renren; }\n.#{$fa-css-prefix}-pagelines:before { content: $fa-var-pagelines; }\n.#{$fa-css-prefix}-stack-exchange:before { content: $fa-var-stack-exchange; }\n.#{$fa-css-prefix}-arrow-circle-o-right:before { content: $fa-var-arrow-circle-o-right; }\n.#{$fa-css-prefix}-arrow-circle-o-left:before { content: $fa-var-arrow-circle-o-left; }\n.#{$fa-css-prefix}-toggle-left:before,\n.#{$fa-css-prefix}-caret-square-o-left:before { content: $fa-var-caret-square-o-left; }\n.#{$fa-css-prefix}-dot-circle-o:before { content: $fa-var-dot-circle-o; }\n.#{$fa-css-prefix}-wheelchair:before { content: $fa-var-wheelchair; }\n.#{$fa-css-prefix}-vimeo-square:before { content: $fa-var-vimeo-square; }\n.#{$fa-css-prefix}-turkish-lira:before,\n.#{$fa-css-prefix}-try:before { content: $fa-var-try; }\n.#{$fa-css-prefix}-plus-square-o:before { content: $fa-var-plus-square-o; }\n.#{$fa-css-prefix}-space-shuttle:before { content: $fa-var-space-shuttle; }\n.#{$fa-css-prefix}-slack:before { content: $fa-var-slack; }\n.#{$fa-css-prefix}-envelope-square:before { content: $fa-var-envelope-square; }\n.#{$fa-css-prefix}-wordpress:before { content: $fa-var-wordpress; }\n.#{$fa-css-prefix}-openid:before { content: $fa-var-openid; }\n.#{$fa-css-prefix}-institution:before,\n.#{$fa-css-prefix}-bank:before,\n.#{$fa-css-prefix}-university:before { content: $fa-var-university; }\n.#{$fa-css-prefix}-mortar-board:before,\n.#{$fa-css-prefix}-graduation-cap:before { content: $fa-var-graduation-cap; }\n.#{$fa-css-prefix}-yahoo:before { content: $fa-var-yahoo; }\n.#{$fa-css-prefix}-google:before { content: $fa-var-google; }\n.#{$fa-css-prefix}-reddit:before { content: $fa-var-reddit; }\n.#{$fa-css-prefix}-reddit-square:before { content: $fa-var-reddit-square; }\n.#{$fa-css-prefix}-stumbleupon-circle:before { content: $fa-var-stumbleupon-circle; }\n.#{$fa-css-prefix}-stumbleupon:before { content: $fa-var-stumbleupon; }\n.#{$fa-css-prefix}-delicious:before { content: $fa-var-delicious; }\n.#{$fa-css-prefix}-digg:before { content: $fa-var-digg; }\n.#{$fa-css-prefix}-pied-piper-pp:before { content: $fa-var-pied-piper-pp; }\n.#{$fa-css-prefix}-pied-piper-alt:before { content: $fa-var-pied-piper-alt; }\n.#{$fa-css-prefix}-drupal:before { content: $fa-var-drupal; }\n.#{$fa-css-prefix}-joomla:before { content: $fa-var-joomla; }\n.#{$fa-css-prefix}-language:before { content: $fa-var-language; }\n.#{$fa-css-prefix}-fax:before { content: $fa-var-fax; }\n.#{$fa-css-prefix}-building:before { content: $fa-var-building; }\n.#{$fa-css-prefix}-child:before { content: $fa-var-child; }\n.#{$fa-css-prefix}-paw:before { content: $fa-var-paw; }\n.#{$fa-css-prefix}-spoon:before { content: $fa-var-spoon; }\n.#{$fa-css-prefix}-cube:before { content: $fa-var-cube; }\n.#{$fa-css-prefix}-cubes:before { content: $fa-var-cubes; }\n.#{$fa-css-prefix}-behance:before { content: $fa-var-behance; }\n.#{$fa-css-prefix}-behance-square:before { content: $fa-var-behance-square; }\n.#{$fa-css-prefix}-steam:before { content: $fa-var-steam; }\n.#{$fa-css-prefix}-steam-square:before { content: $fa-var-steam-square; }\n.#{$fa-css-prefix}-recycle:before { content: $fa-var-recycle; }\n.#{$fa-css-prefix}-automobile:before,\n.#{$fa-css-prefix}-car:before { content: $fa-var-car; }\n.#{$fa-css-prefix}-cab:before,\n.#{$fa-css-prefix}-taxi:before { content: $fa-var-taxi; }\n.#{$fa-css-prefix}-tree:before { content: $fa-var-tree; }\n.#{$fa-css-prefix}-spotify:before { content: $fa-var-spotify; }\n.#{$fa-css-prefix}-deviantart:before { content: $fa-var-deviantart; }\n.#{$fa-css-prefix}-soundcloud:before { content: $fa-var-soundcloud; }\n.#{$fa-css-prefix}-database:before { content: $fa-var-database; }\n.#{$fa-css-prefix}-file-pdf-o:before { content: $fa-var-file-pdf-o; }\n.#{$fa-css-prefix}-file-word-o:before { content: $fa-var-file-word-o; }\n.#{$fa-css-prefix}-file-excel-o:before { content: $fa-var-file-excel-o; }\n.#{$fa-css-prefix}-file-powerpoint-o:before { content: $fa-var-file-powerpoint-o; }\n.#{$fa-css-prefix}-file-photo-o:before,\n.#{$fa-css-prefix}-file-picture-o:before,\n.#{$fa-css-prefix}-file-image-o:before { content: $fa-var-file-image-o; }\n.#{$fa-css-prefix}-file-zip-o:before,\n.#{$fa-css-prefix}-file-archive-o:before { content: $fa-var-file-archive-o; }\n.#{$fa-css-prefix}-file-sound-o:before,\n.#{$fa-css-prefix}-file-audio-o:before { content: $fa-var-file-audio-o; }\n.#{$fa-css-prefix}-file-movie-o:before,\n.#{$fa-css-prefix}-file-video-o:before { content: $fa-var-file-video-o; }\n.#{$fa-css-prefix}-file-code-o:before { content: $fa-var-file-code-o; }\n.#{$fa-css-prefix}-vine:before { content: $fa-var-vine; }\n.#{$fa-css-prefix}-codepen:before { content: $fa-var-codepen; }\n.#{$fa-css-prefix}-jsfiddle:before { content: $fa-var-jsfiddle; }\n.#{$fa-css-prefix}-life-bouy:before,\n.#{$fa-css-prefix}-life-buoy:before,\n.#{$fa-css-prefix}-life-saver:before,\n.#{$fa-css-prefix}-support:before,\n.#{$fa-css-prefix}-life-ring:before { content: $fa-var-life-ring; }\n.#{$fa-css-prefix}-circle-o-notch:before { content: $fa-var-circle-o-notch; }\n.#{$fa-css-prefix}-ra:before,\n.#{$fa-css-prefix}-resistance:before,\n.#{$fa-css-prefix}-rebel:before { content: $fa-var-rebel; }\n.#{$fa-css-prefix}-ge:before,\n.#{$fa-css-prefix}-empire:before { content: $fa-var-empire; }\n.#{$fa-css-prefix}-git-square:before { content: $fa-var-git-square; }\n.#{$fa-css-prefix}-git:before { content: $fa-var-git; }\n.#{$fa-css-prefix}-y-combinator-square:before,\n.#{$fa-css-prefix}-yc-square:before,\n.#{$fa-css-prefix}-hacker-news:before { content: $fa-var-hacker-news; }\n.#{$fa-css-prefix}-tencent-weibo:before { content: $fa-var-tencent-weibo; }\n.#{$fa-css-prefix}-qq:before { content: $fa-var-qq; }\n.#{$fa-css-prefix}-wechat:before,\n.#{$fa-css-prefix}-weixin:before { content: $fa-var-weixin; }\n.#{$fa-css-prefix}-send:before,\n.#{$fa-css-prefix}-paper-plane:before { content: $fa-var-paper-plane; }\n.#{$fa-css-prefix}-send-o:before,\n.#{$fa-css-prefix}-paper-plane-o:before { content: $fa-var-paper-plane-o; }\n.#{$fa-css-prefix}-history:before { content: $fa-var-history; }\n.#{$fa-css-prefix}-circle-thin:before { content: $fa-var-circle-thin; }\n.#{$fa-css-prefix}-header:before { content: $fa-var-header; }\n.#{$fa-css-prefix}-paragraph:before { content: $fa-var-paragraph; }\n.#{$fa-css-prefix}-sliders:before { content: $fa-var-sliders; }\n.#{$fa-css-prefix}-share-alt:before { content: $fa-var-share-alt; }\n.#{$fa-css-prefix}-share-alt-square:before { content: $fa-var-share-alt-square; }\n.#{$fa-css-prefix}-bomb:before { content: $fa-var-bomb; }\n.#{$fa-css-prefix}-soccer-ball-o:before,\n.#{$fa-css-prefix}-futbol-o:before { content: $fa-var-futbol-o; }\n.#{$fa-css-prefix}-tty:before { content: $fa-var-tty; }\n.#{$fa-css-prefix}-binoculars:before { content: $fa-var-binoculars; }\n.#{$fa-css-prefix}-plug:before { content: $fa-var-plug; }\n.#{$fa-css-prefix}-slideshare:before { content: $fa-var-slideshare; }\n.#{$fa-css-prefix}-twitch:before { content: $fa-var-twitch; }\n.#{$fa-css-prefix}-yelp:before { content: $fa-var-yelp; }\n.#{$fa-css-prefix}-newspaper-o:before { content: $fa-var-newspaper-o; }\n.#{$fa-css-prefix}-wifi:before { content: $fa-var-wifi; }\n.#{$fa-css-prefix}-calculator:before { content: $fa-var-calculator; }\n.#{$fa-css-prefix}-paypal:before { content: $fa-var-paypal; }\n.#{$fa-css-prefix}-google-wallet:before { content: $fa-var-google-wallet; }\n.#{$fa-css-prefix}-cc-visa:before { content: $fa-var-cc-visa; }\n.#{$fa-css-prefix}-cc-mastercard:before { content: $fa-var-cc-mastercard; }\n.#{$fa-css-prefix}-cc-discover:before { content: $fa-var-cc-discover; }\n.#{$fa-css-prefix}-cc-amex:before { content: $fa-var-cc-amex; }\n.#{$fa-css-prefix}-cc-paypal:before { content: $fa-var-cc-paypal; }\n.#{$fa-css-prefix}-cc-stripe:before { content: $fa-var-cc-stripe; }\n.#{$fa-css-prefix}-bell-slash:before { content: $fa-var-bell-slash; }\n.#{$fa-css-prefix}-bell-slash-o:before { content: $fa-var-bell-slash-o; }\n.#{$fa-css-prefix}-trash:before { content: $fa-var-trash; }\n.#{$fa-css-prefix}-copyright:before { content: $fa-var-copyright; }\n.#{$fa-css-prefix}-at:before { content: $fa-var-at; }\n.#{$fa-css-prefix}-eyedropper:before { content: $fa-var-eyedropper; }\n.#{$fa-css-prefix}-paint-brush:before { content: $fa-var-paint-brush; }\n.#{$fa-css-prefix}-birthday-cake:before { content: $fa-var-birthday-cake; }\n.#{$fa-css-prefix}-area-chart:before { content: $fa-var-area-chart; }\n.#{$fa-css-prefix}-pie-chart:before { content: $fa-var-pie-chart; }\n.#{$fa-css-prefix}-line-chart:before { content: $fa-var-line-chart; }\n.#{$fa-css-prefix}-lastfm:before { content: $fa-var-lastfm; }\n.#{$fa-css-prefix}-lastfm-square:before { content: $fa-var-lastfm-square; }\n.#{$fa-css-prefix}-toggle-off:before { content: $fa-var-toggle-off; }\n.#{$fa-css-prefix}-toggle-on:before { content: $fa-var-toggle-on; }\n.#{$fa-css-prefix}-bicycle:before { content: $fa-var-bicycle; }\n.#{$fa-css-prefix}-bus:before { content: $fa-var-bus; }\n.#{$fa-css-prefix}-ioxhost:before { content: $fa-var-ioxhost; }\n.#{$fa-css-prefix}-angellist:before { content: $fa-var-angellist; }\n.#{$fa-css-prefix}-cc:before { content: $fa-var-cc; }\n.#{$fa-css-prefix}-shekel:before,\n.#{$fa-css-prefix}-sheqel:before,\n.#{$fa-css-prefix}-ils:before { content: $fa-var-ils; }\n.#{$fa-css-prefix}-meanpath:before { content: $fa-var-meanpath; }\n.#{$fa-css-prefix}-buysellads:before { content: $fa-var-buysellads; }\n.#{$fa-css-prefix}-connectdevelop:before { content: $fa-var-connectdevelop; }\n.#{$fa-css-prefix}-dashcube:before { content: $fa-var-dashcube; }\n.#{$fa-css-prefix}-forumbee:before { content: $fa-var-forumbee; }\n.#{$fa-css-prefix}-leanpub:before { content: $fa-var-leanpub; }\n.#{$fa-css-prefix}-sellsy:before { content: $fa-var-sellsy; }\n.#{$fa-css-prefix}-shirtsinbulk:before { content: $fa-var-shirtsinbulk; }\n.#{$fa-css-prefix}-simplybuilt:before { content: $fa-var-simplybuilt; }\n.#{$fa-css-prefix}-skyatlas:before { content: $fa-var-skyatlas; }\n.#{$fa-css-prefix}-cart-plus:before { content: $fa-var-cart-plus; }\n.#{$fa-css-prefix}-cart-arrow-down:before { content: $fa-var-cart-arrow-down; }\n.#{$fa-css-prefix}-diamond:before { content: $fa-var-diamond; }\n.#{$fa-css-prefix}-ship:before { content: $fa-var-ship; }\n.#{$fa-css-prefix}-user-secret:before { content: $fa-var-user-secret; }\n.#{$fa-css-prefix}-motorcycle:before { content: $fa-var-motorcycle; }\n.#{$fa-css-prefix}-street-view:before { content: $fa-var-street-view; }\n.#{$fa-css-prefix}-heartbeat:before { content: $fa-var-heartbeat; }\n.#{$fa-css-prefix}-venus:before { content: $fa-var-venus; }\n.#{$fa-css-prefix}-mars:before { content: $fa-var-mars; }\n.#{$fa-css-prefix}-mercury:before { content: $fa-var-mercury; }\n.#{$fa-css-prefix}-intersex:before,\n.#{$fa-css-prefix}-transgender:before { content: $fa-var-transgender; }\n.#{$fa-css-prefix}-transgender-alt:before { content: $fa-var-transgender-alt; }\n.#{$fa-css-prefix}-venus-double:before { content: $fa-var-venus-double; }\n.#{$fa-css-prefix}-mars-double:before { content: $fa-var-mars-double; }\n.#{$fa-css-prefix}-venus-mars:before { content: $fa-var-venus-mars; }\n.#{$fa-css-prefix}-mars-stroke:before { content: $fa-var-mars-stroke; }\n.#{$fa-css-prefix}-mars-stroke-v:before { content: $fa-var-mars-stroke-v; }\n.#{$fa-css-prefix}-mars-stroke-h:before { content: $fa-var-mars-stroke-h; }\n.#{$fa-css-prefix}-neuter:before { content: $fa-var-neuter; }\n.#{$fa-css-prefix}-genderless:before { content: $fa-var-genderless; }\n.#{$fa-css-prefix}-facebook-official:before { content: $fa-var-facebook-official; }\n.#{$fa-css-prefix}-pinterest-p:before { content: $fa-var-pinterest-p; }\n.#{$fa-css-prefix}-whatsapp:before { content: $fa-var-whatsapp; }\n.#{$fa-css-prefix}-server:before { content: $fa-var-server; }\n.#{$fa-css-prefix}-user-plus:before { content: $fa-var-user-plus; }\n.#{$fa-css-prefix}-user-times:before { content: $fa-var-user-times; }\n.#{$fa-css-prefix}-hotel:before,\n.#{$fa-css-prefix}-bed:before { content: $fa-var-bed; }\n.#{$fa-css-prefix}-viacoin:before { content: $fa-var-viacoin; }\n.#{$fa-css-prefix}-train:before { content: $fa-var-train; }\n.#{$fa-css-prefix}-subway:before { content: $fa-var-subway; }\n.#{$fa-css-prefix}-medium:before { content: $fa-var-medium; }\n.#{$fa-css-prefix}-yc:before,\n.#{$fa-css-prefix}-y-combinator:before { content: $fa-var-y-combinator; }\n.#{$fa-css-prefix}-optin-monster:before { content: $fa-var-optin-monster; }\n.#{$fa-css-prefix}-opencart:before { content: $fa-var-opencart; }\n.#{$fa-css-prefix}-expeditedssl:before { content: $fa-var-expeditedssl; }\n.#{$fa-css-prefix}-battery-4:before,\n.#{$fa-css-prefix}-battery:before,\n.#{$fa-css-prefix}-battery-full:before { content: $fa-var-battery-full; }\n.#{$fa-css-prefix}-battery-3:before,\n.#{$fa-css-prefix}-battery-three-quarters:before { content: $fa-var-battery-three-quarters; }\n.#{$fa-css-prefix}-battery-2:before,\n.#{$fa-css-prefix}-battery-half:before { content: $fa-var-battery-half; }\n.#{$fa-css-prefix}-battery-1:before,\n.#{$fa-css-prefix}-battery-quarter:before { content: $fa-var-battery-quarter; }\n.#{$fa-css-prefix}-battery-0:before,\n.#{$fa-css-prefix}-battery-empty:before { content: $fa-var-battery-empty; }\n.#{$fa-css-prefix}-mouse-pointer:before { content: $fa-var-mouse-pointer; }\n.#{$fa-css-prefix}-i-cursor:before { content: $fa-var-i-cursor; }\n.#{$fa-css-prefix}-object-group:before { content: $fa-var-object-group; }\n.#{$fa-css-prefix}-object-ungroup:before { content: $fa-var-object-ungroup; }\n.#{$fa-css-prefix}-sticky-note:before { content: $fa-var-sticky-note; }\n.#{$fa-css-prefix}-sticky-note-o:before { content: $fa-var-sticky-note-o; }\n.#{$fa-css-prefix}-cc-jcb:before { content: $fa-var-cc-jcb; }\n.#{$fa-css-prefix}-cc-diners-club:before { content: $fa-var-cc-diners-club; }\n.#{$fa-css-prefix}-clone:before { content: $fa-var-clone; }\n.#{$fa-css-prefix}-balance-scale:before { content: $fa-var-balance-scale; }\n.#{$fa-css-prefix}-hourglass-o:before { content: $fa-var-hourglass-o; }\n.#{$fa-css-prefix}-hourglass-1:before,\n.#{$fa-css-prefix}-hourglass-start:before { content: $fa-var-hourglass-start; }\n.#{$fa-css-prefix}-hourglass-2:before,\n.#{$fa-css-prefix}-hourglass-half:before { content: $fa-var-hourglass-half; }\n.#{$fa-css-prefix}-hourglass-3:before,\n.#{$fa-css-prefix}-hourglass-end:before { content: $fa-var-hourglass-end; }\n.#{$fa-css-prefix}-hourglass:before { content: $fa-var-hourglass; }\n.#{$fa-css-prefix}-hand-grab-o:before,\n.#{$fa-css-prefix}-hand-rock-o:before { content: $fa-var-hand-rock-o; }\n.#{$fa-css-prefix}-hand-stop-o:before,\n.#{$fa-css-prefix}-hand-paper-o:before { content: $fa-var-hand-paper-o; }\n.#{$fa-css-prefix}-hand-scissors-o:before { content: $fa-var-hand-scissors-o; }\n.#{$fa-css-prefix}-hand-lizard-o:before { content: $fa-var-hand-lizard-o; }\n.#{$fa-css-prefix}-hand-spock-o:before { content: $fa-var-hand-spock-o; }\n.#{$fa-css-prefix}-hand-pointer-o:before { content: $fa-var-hand-pointer-o; }\n.#{$fa-css-prefix}-hand-peace-o:before { content: $fa-var-hand-peace-o; }\n.#{$fa-css-prefix}-trademark:before { content: $fa-var-trademark; }\n.#{$fa-css-prefix}-registered:before { content: $fa-var-registered; }\n.#{$fa-css-prefix}-Cuba-commons:before { content: $fa-var-Cuba-commons; }\n.#{$fa-css-prefix}-gg:before { content: $fa-var-gg; }\n.#{$fa-css-prefix}-gg-circle:before { content: $fa-var-gg-circle; }\n.#{$fa-css-prefix}-tripadvisor:before { content: $fa-var-tripadvisor; }\n.#{$fa-css-prefix}-odnoklassniki:before { content: $fa-var-odnoklassniki; }\n.#{$fa-css-prefix}-odnoklassniki-square:before { content: $fa-var-odnoklassniki-square; }\n.#{$fa-css-prefix}-get-pocket:before { content: $fa-var-get-pocket; }\n.#{$fa-css-prefix}-wikipedia-w:before { content: $fa-var-wikipedia-w; }\n.#{$fa-css-prefix}-safari:before { content: $fa-var-safari; }\n.#{$fa-css-prefix}-chrome:before { content: $fa-var-chrome; }\n.#{$fa-css-prefix}-firefox:before { content: $fa-var-firefox; }\n.#{$fa-css-prefix}-opera:before { content: $fa-var-opera; }\n.#{$fa-css-prefix}-internet-explorer:before { content: $fa-var-internet-explorer; }\n.#{$fa-css-prefix}-tv:before,\n.#{$fa-css-prefix}-television:before { content: $fa-var-television; }\n.#{$fa-css-prefix}-contao:before { content: $fa-var-contao; }\n.#{$fa-css-prefix}-500px:before { content: $fa-var-500px; }\n.#{$fa-css-prefix}-amazon:before { content: $fa-var-amazon; }\n.#{$fa-css-prefix}-calendar-plus-o:before { content: $fa-var-calendar-plus-o; }\n.#{$fa-css-prefix}-calendar-minus-o:before { content: $fa-var-calendar-minus-o; }\n.#{$fa-css-prefix}-calendar-times-o:before { content: $fa-var-calendar-times-o; }\n.#{$fa-css-prefix}-calendar-check-o:before { content: $fa-var-calendar-check-o; }\n.#{$fa-css-prefix}-industry:before { content: $fa-var-industry; }\n.#{$fa-css-prefix}-map-pin:before { content: $fa-var-map-pin; }\n.#{$fa-css-prefix}-map-signs:before { content: $fa-var-map-signs; }\n.#{$fa-css-prefix}-map-o:before { content: $fa-var-map-o; }\n.#{$fa-css-prefix}-map:before { content: $fa-var-map; }\n.#{$fa-css-prefix}-commenting:before { content: $fa-var-commenting; }\n.#{$fa-css-prefix}-commenting-o:before { content: $fa-var-commenting-o; }\n.#{$fa-css-prefix}-houzz:before { content: $fa-var-houzz; }\n.#{$fa-css-prefix}-vimeo:before { content: $fa-var-vimeo; }\n.#{$fa-css-prefix}-black-tie:before { content: $fa-var-black-tie; }\n.#{$fa-css-prefix}-fonticons:before { content: $fa-var-fonticons; }\n.#{$fa-css-prefix}-reddit-alien:before { content: $fa-var-reddit-alien; }\n.#{$fa-css-prefix}-edge:before { content: $fa-var-edge; }\n.#{$fa-css-prefix}-credit-card-alt:before { content: $fa-var-credit-card-alt; }\n.#{$fa-css-prefix}-codiepie:before { content: $fa-var-codiepie; }\n.#{$fa-css-prefix}-modx:before { content: $fa-var-modx; }\n.#{$fa-css-prefix}-fort-awesome:before { content: $fa-var-fort-awesome; }\n.#{$fa-css-prefix}-usb:before { content: $fa-var-usb; }\n.#{$fa-css-prefix}-product-hunt:before { content: $fa-var-product-hunt; }\n.#{$fa-css-prefix}-mixcloud:before { content: $fa-var-mixcloud; }\n.#{$fa-css-prefix}-scribd:before { content: $fa-var-scribd; }\n.#{$fa-css-prefix}-pause-circle:before { content: $fa-var-pause-circle; }\n.#{$fa-css-prefix}-pause-circle-o:before { content: $fa-var-pause-circle-o; }\n.#{$fa-css-prefix}-stop-circle:before { content: $fa-var-stop-circle; }\n.#{$fa-css-prefix}-stop-circle-o:before { content: $fa-var-stop-circle-o; }\n.#{$fa-css-prefix}-shopping-bag:before { content: $fa-var-shopping-bag; }\n.#{$fa-css-prefix}-shopping-basket:before { content: $fa-var-shopping-basket; }\n.#{$fa-css-prefix}-hashtag:before { content: $fa-var-hashtag; }\n.#{$fa-css-prefix}-bluetooth:before { content: $fa-var-bluetooth; }\n.#{$fa-css-prefix}-bluetooth-b:before { content: $fa-var-bluetooth-b; }\n.#{$fa-css-prefix}-percent:before { content: $fa-var-percent; }\n.#{$fa-css-prefix}-gitlab:before { content: $fa-var-gitlab; }\n.#{$fa-css-prefix}-wpbeginner:before { content: $fa-var-wpbeginner; }\n.#{$fa-css-prefix}-wpforms:before { content: $fa-var-wpforms; }\n.#{$fa-css-prefix}-envira:before { content: $fa-var-envira; }\n.#{$fa-css-prefix}-Cuba-access:before { content: $fa-var-Cuba-access; }\n.#{$fa-css-prefix}-wheelchair-alt:before { content: $fa-var-wheelchair-alt; }\n.#{$fa-css-prefix}-question-circle-o:before { content: $fa-var-question-circle-o; }\n.#{$fa-css-prefix}-blind:before { content: $fa-var-blind; }\n.#{$fa-css-prefix}-audio-description:before { content: $fa-var-audio-description; }\n.#{$fa-css-prefix}-volume-control-phone:before { content: $fa-var-volume-control-phone; }\n.#{$fa-css-prefix}-braille:before { content: $fa-var-braille; }\n.#{$fa-css-prefix}-assistive-listening-systems:before { content: $fa-var-assistive-listening-systems; }\n.#{$fa-css-prefix}-asl-interpreting:before,\n.#{$fa-css-prefix}-american-sign-language-interpreting:before { content: $fa-var-american-sign-language-interpreting; }\n.#{$fa-css-prefix}-deafness:before,\n.#{$fa-css-prefix}-hard-of-hearing:before,\n.#{$fa-css-prefix}-deaf:before { content: $fa-var-deaf; }\n.#{$fa-css-prefix}-glide:before { content: $fa-var-glide; }\n.#{$fa-css-prefix}-glide-g:before { content: $fa-var-glide-g; }\n.#{$fa-css-prefix}-signing:before,\n.#{$fa-css-prefix}-sign-language:before { content: $fa-var-sign-language; }\n.#{$fa-css-prefix}-low-vision:before { content: $fa-var-low-vision; }\n.#{$fa-css-prefix}-viadeo:before { content: $fa-var-viadeo; }\n.#{$fa-css-prefix}-viadeo-square:before { content: $fa-var-viadeo-square; }\n.#{$fa-css-prefix}-snapchat:before { content: $fa-var-snapchat; }\n.#{$fa-css-prefix}-snapchat-ghost:before { content: $fa-var-snapchat-ghost; }\n.#{$fa-css-prefix}-snapchat-square:before { content: $fa-var-snapchat-square; }\n.#{$fa-css-prefix}-pied-piper:before { content: $fa-var-pied-piper; }\n.#{$fa-css-prefix}-first-order:before { content: $fa-var-first-order; }\n.#{$fa-css-prefix}-yoast:before { content: $fa-var-yoast; }\n.#{$fa-css-prefix}-themeisle:before { content: $fa-var-themeisle; }\n.#{$fa-css-prefix}-google-plus-circle:before,\n.#{$fa-css-prefix}-google-plus-official:before { content: $fa-var-google-plus-official; }\n.#{$fa-css-prefix}-fa:before,\n.#{$fa-css-prefix}-font-awesome:before { content: $fa-var-font-awesome; }\n.#{$fa-css-prefix}-handshake-o:before { content: $fa-var-handshake-o; }\n.#{$fa-css-prefix}-envelope-open:before { content: $fa-var-envelope-open; }\n.#{$fa-css-prefix}-envelope-open-o:before { content: $fa-var-envelope-open-o; }\n.#{$fa-css-prefix}-linode:before { content: $fa-var-linode; }\n.#{$fa-css-prefix}-address-book:before { content: $fa-var-address-book; }\n.#{$fa-css-prefix}-address-book-o:before { content: $fa-var-address-book-o; }\n.#{$fa-css-prefix}-vcard:before,\n.#{$fa-css-prefix}-address-card:before { content: $fa-var-address-card; }\n.#{$fa-css-prefix}-vcard-o:before,\n.#{$fa-css-prefix}-address-card-o:before { content: $fa-var-address-card-o; }\n.#{$fa-css-prefix}-user-circle:before { content: $fa-var-user-circle; }\n.#{$fa-css-prefix}-user-circle-o:before { content: $fa-var-user-circle-o; }\n.#{$fa-css-prefix}-user-o:before { content: $fa-var-user-o; }\n.#{$fa-css-prefix}-id-badge:before { content: $fa-var-id-badge; }\n.#{$fa-css-prefix}-drivers-license:before,\n.#{$fa-css-prefix}-id-card:before { content: $fa-var-id-card; }\n.#{$fa-css-prefix}-drivers-license-o:before,\n.#{$fa-css-prefix}-id-card-o:before { content: $fa-var-id-card-o; }\n.#{$fa-css-prefix}-quora:before { content: $fa-var-quora; }\n.#{$fa-css-prefix}-free-code-camp:before { content: $fa-var-free-code-camp; }\n.#{$fa-css-prefix}-telegram:before { content: $fa-var-telegram; }\n.#{$fa-css-prefix}-thermometer-4:before,\n.#{$fa-css-prefix}-thermometer:before,\n.#{$fa-css-prefix}-thermometer-full:before { content: $fa-var-thermometer-full; }\n.#{$fa-css-prefix}-thermometer-3:before,\n.#{$fa-css-prefix}-thermometer-three-quarters:before { content: $fa-var-thermometer-three-quarters; }\n.#{$fa-css-prefix}-thermometer-2:before,\n.#{$fa-css-prefix}-thermometer-half:before { content: $fa-var-thermometer-half; }\n.#{$fa-css-prefix}-thermometer-1:before,\n.#{$fa-css-prefix}-thermometer-quarter:before { content: $fa-var-thermometer-quarter; }\n.#{$fa-css-prefix}-thermometer-0:before,\n.#{$fa-css-prefix}-thermometer-empty:before { content: $fa-var-thermometer-empty; }\n.#{$fa-css-prefix}-shower:before { content: $fa-var-shower; }\n.#{$fa-css-prefix}-bathtub:before,\n.#{$fa-css-prefix}-s15:before,\n.#{$fa-css-prefix}-bath:before { content: $fa-var-bath; }\n.#{$fa-css-prefix}-podcast:before { content: $fa-var-podcast; }\n.#{$fa-css-prefix}-window-maximize:before { content: $fa-var-window-maximize; }\n.#{$fa-css-prefix}-window-minimize:before { content: $fa-var-window-minimize; }\n.#{$fa-css-prefix}-window-restore:before { content: $fa-var-window-restore; }\n.#{$fa-css-prefix}-times-rectangle:before,\n.#{$fa-css-prefix}-window-close:before { content: $fa-var-window-close; }\n.#{$fa-css-prefix}-times-rectangle-o:before,\n.#{$fa-css-prefix}-window-close-o:before { content: $fa-var-window-close-o; }\n.#{$fa-css-prefix}-bandcamp:before { content: $fa-var-bandcamp; }\n.#{$fa-css-prefix}-grav:before { content: $fa-var-grav; }\n.#{$fa-css-prefix}-etsy:before { content: $fa-var-etsy; }\n.#{$fa-css-prefix}-imdb:before { content: $fa-var-imdb; }\n.#{$fa-css-prefix}-ravelry:before { content: $fa-var-ravelry; }\n.#{$fa-css-prefix}-eercast:before { content: $fa-var-eercast; }\n.#{$fa-css-prefix}-microchip:before { content: $fa-var-microchip; }\n.#{$fa-css-prefix}-snowflake-o:before { content: $fa-var-snowflake-o; }\n.#{$fa-css-prefix}-superpowers:before { content: $fa-var-superpowers; }\n.#{$fa-css-prefix}-wpexplorer:before { content: $fa-var-wpexplorer; }\n.#{$fa-css-prefix}-meetup:before { content: $fa-var-meetup; }\n","// Screen Readers\n// -------------------------\n\n.sr-only { @include sr-only(); }\n.sr-only-focusable { @include sr-only-focusable(); }\n",".animated {\n  animation-duration: 1s;\n  animation-fill-mode: both;\n  &.infinite {\n    animation-iteration-count: infinite;\n  }\n  &.hinge {\n    animation-duration: 2s;\n  }\n  &.bounceIn {\n    animation-duration: .75s;\n  }\n  &.bounceOut {\n    animation-duration: .75s;\n  }\n  &.flipOutX {\n    animation-duration: .75s;\n  }\n  &.flipOutY {\n    animation-duration: .75s;\n  }\n  &.flip {\n    backface-visibility: visible;\n    animation-name: flip;\n  }\n}\n@keyframes bounce {\n  0% {\n    animation-timing-function: cubic-bezier(.215, .61, .355, 1);\n    transform: translateZ(0);\n  }\n  20% {\n    animation-timing-function: cubic-bezier(.215, .61, .355, 1);\n    transform: translateZ(0);\n  }\n  53% {\n    animation-timing-function: cubic-bezier(.215, .61, .355, 1);\n    transform: translateZ(0);\n  }\n  80% {\n    animation-timing-function: cubic-bezier(.215, .61, .355, 1);\n    transform: translateZ(0);\n  }\n  to {\n    animation-timing-function: cubic-bezier(.215, .61, .355, 1);\n    transform: translateZ(0);\n  }\n  40% {\n    animation-timing-function: cubic-bezier(.755, .05, .855, .06);\n    transform: translate3d(0, -30px, 0);\n  }\n  43% {\n    animation-timing-function: cubic-bezier(.755, .05, .855, .06);\n    transform: translate3d(0, -30px, 0);\n  }\n  70% {\n    animation-timing-function: cubic-bezier(.755, .05, .855, .06);\n    transform: translate3d(0, -15px, 0);\n  }\n  90% {\n    transform: translate3d(0, -4px, 0);\n  }\n}\n.bounce {\n  animation-name: bounce;\n  transform-origin: center bottom;\n}\n@keyframes flash {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 1;\n  }\n  to {\n    opacity: 1;\n  }\n  25% {\n    opacity: 0;\n  }\n  75% {\n    opacity: 0;\n  }\n}\n.flash {\n  animation-name: flash;\n}\n@keyframes pulse {\n  0% {\n    transform: scaleX(1);\n  }\n  50% {\n    transform: scale3d(1.05, 1.05, 1.05);\n  }\n  to {\n    transform: scaleX(1);\n  }\n}\n.pulse {\n  animation-name: pulse;\n}\n@keyframes rubberBand {\n  0% {\n    transform: scaleX(1);\n  }\n  30% {\n    transform: scale3d(1.25, .75, 1);\n  }\n  40% {\n    transform: scale3d(.75, 1.25, 1);\n  }\n  50% {\n    transform: scale3d(1.15, .85, 1);\n  }\n  65% {\n    transform: scale3d(.95, 1.05, 1);\n  }\n  75% {\n    transform: scale3d(1.05, .95, 1);\n  }\n  to {\n    transform: scaleX(1);\n  }\n}\n.rubberBand {\n  animation-name: rubberBand;\n}\n@keyframes shake {\n  0% {\n    transform: translateZ(0);\n  }\n  to {\n    transform: translateZ(0);\n  }\n  10% {\n    transform: translate3d(-10px, 0, 0);\n  }\n  30% {\n    transform: translate3d(-10px, 0, 0);\n  }\n  50% {\n    transform: translate3d(-10px, 0, 0);\n  }\n  70% {\n    transform: translate3d(-10px, 0, 0);\n  }\n  90% {\n    transform: translate3d(-10px, 0, 0);\n  }\n  20% {\n    transform: translate3d(10px, 0, 0);\n  }\n  40% {\n    transform: translate3d(10px, 0, 0);\n  }\n  60% {\n    transform: translate3d(10px, 0, 0);\n  }\n  80% {\n    transform: translate3d(10px, 0, 0);\n  }\n}\n.shake {\n  animation-name: shake;\n}\n@keyframes headShake {\n  0% {\n    transform: translateX(0);\n  }\n  50% {\n    transform: translateX(0);\n  }\n  0.5% {\n    transform: translateX(-6px) rotateY(-9deg);\n  }\n  1.5% {\n    transform: translateX(5px) rotateY(7deg);\n  }\n  2.5% {\n    transform: translateX(-3px) rotateY(-5deg);\n  }\n  3.5% {\n    transform: translateX(2px) rotateY(3deg);\n  }\n}\n.headShake {\n  animation-timing-function: ease-in-out;\n  animation-name: headShake;\n}\n@keyframes swing {\n  20% {\n    transform: rotate(15deg);\n  }\n  40% {\n    transform: rotate(-10deg);\n  }\n  60% {\n    transform: rotate(5deg);\n  }\n  80% {\n    transform: rotate(-5deg);\n  }\n  to {\n    transform: rotate(0deg);\n  }\n}\n.swing {\n  transform-origin: top center;\n  animation-name: swing;\n}\n@keyframes tada {\n  0% {\n    transform: scaleX(1);\n  }\n  10% {\n    transform: scale3d(.9, .9, .9) rotate(-3deg);\n  }\n  20% {\n    transform: scale3d(.9, .9, .9) rotate(-3deg);\n  }\n  30% {\n    transform: scale3d(1.1, 1.1, 1.1) rotate(3deg);\n  }\n  50% {\n    transform: scale3d(1.1, 1.1, 1.1) rotate(3deg);\n  }\n  70% {\n    transform: scale3d(1.1, 1.1, 1.1) rotate(3deg);\n  }\n  90% {\n    transform: scale3d(1.1, 1.1, 1.1) rotate(3deg);\n  }\n  40% {\n    transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg);\n  }\n  60% {\n    transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg);\n  }\n  80% {\n    transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg);\n  }\n  to {\n    transform: scaleX(1);\n  }\n}\n.tada {\n  animation-name: tada;\n}\n@keyframes wobble {\n  0% {\n    transform: none;\n  }\n  15% {\n    transform: translate3d(-25%, 0, 0) rotate(-5deg);\n  }\n  30% {\n    transform: translate3d(20%, 0, 0) rotate(3deg);\n  }\n  45% {\n    transform: translate3d(-15%, 0, 0) rotate(-3deg);\n  }\n  60% {\n    transform: translate3d(10%, 0, 0) rotate(2deg);\n  }\n  75% {\n    transform: translate3d(-5%, 0, 0) rotate(-1deg);\n  }\n  to {\n    transform: none;\n  }\n}\n.wobble {\n  animation-name: wobble;\n}\n@keyframes jello {\n  0% {\n    transform: none;\n  }\n  to {\n    transform: none;\n  }\n  0.1% {\n    transform: none;\n  }\n  1.2% {\n    transform: skewX(-12.5deg) skewY(-12.5deg);\n  }\n  2.3% {\n    transform: skewX(6.25deg) skewY(6.25deg);\n  }\n  3.4% {\n    transform: skewX(-3.125deg) skewY(-3.125deg);\n  }\n  4.5% {\n    transform: skewX(1.5625deg) skewY(1.5625deg);\n  }\n  5.6% {\n    transform: skewX(-.78125deg) skewY(-.78125deg);\n  }\n  6.7% {\n    transform: skewX(.390625deg) skewY(.390625deg);\n  }\n  7.8% {\n    transform: skewX(-.1953125deg) skewY(-.1953125deg);\n  }\n}\n.jello {\n  animation-name: jello;\n  transform-origin: center;\n}\n@keyframes bounceIn {\n  0% {\n    animation-timing-function: cubic-bezier(.215, .61, .355, 1);\n    opacity: 0;\n    transform: scale3d(.3, .3, .3);\n  }\n  20% {\n    animation-timing-function: cubic-bezier(.215, .61, .355, 1);\n    transform: scale3d(1.1, 1.1, 1.1);\n  }\n  40% {\n    animation-timing-function: cubic-bezier(.215, .61, .355, 1);\n    transform: scale3d(.9, .9, .9);\n  }\n  60% {\n    animation-timing-function: cubic-bezier(.215, .61, .355, 1);\n    opacity: 1;\n    transform: scale3d(1.03, 1.03, 1.03);\n  }\n  80% {\n    animation-timing-function: cubic-bezier(.215, .61, .355, 1);\n    transform: scale3d(.97, .97, .97);\n  }\n  to {\n    animation-timing-function: cubic-bezier(.215, .61, .355, 1);\n    opacity: 1;\n    transform: scaleX(1);\n  }\n}\n.bounceIn {\n  animation-name: bounceIn;\n}\n@keyframes bounceInDown {\n  0% {\n    animation-timing-function: cubic-bezier(.215, .61, .355, 1);\n    opacity: 0;\n    transform: translate3d(0, -3000px, 0);\n  }\n  60% {\n    animation-timing-function: cubic-bezier(.215, .61, .355, 1);\n    opacity: 1;\n    transform: translate3d(0, 25px, 0);\n  }\n  75% {\n    animation-timing-function: cubic-bezier(.215, .61, .355, 1);\n    transform: translate3d(0, -10px, 0);\n  }\n  90% {\n    animation-timing-function: cubic-bezier(.215, .61, .355, 1);\n    transform: translate3d(0, 5px, 0);\n  }\n  to {\n    animation-timing-function: cubic-bezier(.215, .61, .355, 1);\n    transform: none;\n  }\n}\n.bounceInDown {\n  animation-name: bounceInDown;\n}\n@keyframes bounceInLeft {\n  0% {\n    animation-timing-function: cubic-bezier(.215, .61, .355, 1);\n    opacity: 0;\n    transform: translate3d(-3000px, 0, 0);\n  }\n  60% {\n    animation-timing-function: cubic-bezier(.215, .61, .355, 1);\n    opacity: 1;\n    transform: translate3d(25px, 0, 0);\n  }\n  75% {\n    animation-timing-function: cubic-bezier(.215, .61, .355, 1);\n    transform: translate3d(-10px, 0, 0);\n  }\n  90% {\n    animation-timing-function: cubic-bezier(.215, .61, .355, 1);\n    transform: translate3d(5px, 0, 0);\n  }\n  to {\n    animation-timing-function: cubic-bezier(.215, .61, .355, 1);\n    transform: none;\n  }\n}\n.bounceInLeft {\n  animation-name: bounceInLeft;\n}\n@keyframes bounceInRight {\n  0% {\n    animation-timing-function: cubic-bezier(.215, .61, .355, 1);\n    opacity: 0;\n    transform: translate3d(3000px, 0, 0);\n  }\n  60% {\n    animation-timing-function: cubic-bezier(.215, .61, .355, 1);\n    opacity: 1;\n    transform: translate3d(-25px, 0, 0);\n  }\n  75% {\n    animation-timing-function: cubic-bezier(.215, .61, .355, 1);\n    transform: translate3d(10px, 0, 0);\n  }\n  90% {\n    animation-timing-function: cubic-bezier(.215, .61, .355, 1);\n    transform: translate3d(-5px, 0, 0);\n  }\n  to {\n    animation-timing-function: cubic-bezier(.215, .61, .355, 1);\n    transform: none;\n  }\n}\n.bounceInRight {\n  animation-name: bounceInRight;\n}\n@keyframes bounceInUp {\n  0% {\n    animation-timing-function: cubic-bezier(.215, .61, .355, 1);\n    opacity: 0;\n    transform: translate3d(0, 3000px, 0);\n  }\n  60% {\n    animation-timing-function: cubic-bezier(.215, .61, .355, 1);\n    opacity: 1;\n    transform: translate3d(0, -20px, 0);\n  }\n  75% {\n    animation-timing-function: cubic-bezier(.215, .61, .355, 1);\n    transform: translate3d(0, 10px, 0);\n  }\n  90% {\n    animation-timing-function: cubic-bezier(.215, .61, .355, 1);\n    transform: translate3d(0, -5px, 0);\n  }\n  to {\n    animation-timing-function: cubic-bezier(.215, .61, .355, 1);\n    transform: translateZ(0);\n  }\n}\n.bounceInUp {\n  animation-name: bounceInUp;\n}\n@keyframes bounceOut {\n  20% {\n    transform: scale3d(.9, .9, .9);\n  }\n  50% {\n    opacity: 1;\n    transform: scale3d(1.1, 1.1, 1.1);\n  }\n  55% {\n    opacity: 1;\n    transform: scale3d(1.1, 1.1, 1.1);\n  }\n  to {\n    opacity: 0;\n    transform: scale3d(.3, .3, .3);\n  }\n}\n.bounceOut {\n  animation-name: bounceOut;\n}\n@keyframes bounceOutDown {\n  20% {\n    transform: translate3d(0, 10px, 0);\n  }\n  40% {\n    opacity: 1;\n    transform: translate3d(0, -20px, 0);\n  }\n  45% {\n    opacity: 1;\n    transform: translate3d(0, -20px, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(0, 2000px, 0);\n  }\n}\n.bounceOutDown {\n  animation-name: bounceOutDown;\n}\n@keyframes bounceOutLeft {\n  20% {\n    opacity: 1;\n    transform: translate3d(20px, 0, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(-2000px, 0, 0);\n  }\n}\n.bounceOutLeft {\n  animation-name: bounceOutLeft;\n}\n@keyframes bounceOutRight {\n  20% {\n    opacity: 1;\n    transform: translate3d(-20px, 0, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(2000px, 0, 0);\n  }\n}\n.bounceOutRight {\n  animation-name: bounceOutRight;\n}\n@keyframes bounceOutUp {\n  20% {\n    transform: translate3d(0, -10px, 0);\n  }\n  40% {\n    opacity: 1;\n    transform: translate3d(0, 20px, 0);\n  }\n  45% {\n    opacity: 1;\n    transform: translate3d(0, 20px, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(0, -2000px, 0);\n  }\n}\n.bounceOutUp {\n  animation-name: bounceOutUp;\n}\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n.fadeIn {\n  animation-name: fadeIn;\n}\n@keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    transform: translate3d(0, -100%, 0);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n.fadeInDown {\n  animation-name: fadeInDown;\n}\n@keyframes fadeInDownBig {\n  0% {\n    opacity: 0;\n    transform: translate3d(0, -2000px, 0);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n.fadeInDownBig {\n  animation-name: fadeInDownBig;\n}\n@keyframes fadeInLeft {\n  0% {\n    opacity: 0;\n    transform: translate3d(-100%, 0, 0);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n.fadeInLeft {\n  animation-name: fadeInLeft;\n}\n@keyframes fadeInLeftBig {\n  0% {\n    opacity: 0;\n    transform: translate3d(-2000px, 0, 0);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n.fadeInLeftBig {\n  animation-name: fadeInLeftBig;\n}\n@keyframes fadeInRight {\n  0% {\n    opacity: 0;\n    transform: translate3d(100%, 0, 0);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n.fadeInRight {\n  animation-name: fadeInRight;\n}\n@keyframes fadeInRightBig {\n  0% {\n    opacity: 0;\n    transform: translate3d(2000px, 0, 0);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n.fadeInRightBig {\n  animation-name: fadeInRightBig;\n}\n@keyframes fadeInUp {\n  0% {\n    opacity: 0;\n    transform: translate3d(0, 100%, 0);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n.fadeInUp {\n  animation-name: fadeInUp;\n}\n@keyframes fadeInUpBig {\n  0% {\n    opacity: 0;\n    transform: translate3d(0, 2000px, 0);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n.fadeInUpBig {\n  animation-name: fadeInUpBig;\n}\n@keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n.fadeOut {\n  animation-name: fadeOut;\n}\n@keyframes fadeOutDown {\n  0% {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(0, 100%, 0);\n  }\n}\n.fadeOutDown {\n  animation-name: fadeOutDown;\n}\n@keyframes fadeOutDownBig {\n  0% {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(0, 2000px, 0);\n  }\n}\n.fadeOutDownBig {\n  animation-name: fadeOutDownBig;\n}\n@keyframes fadeOutLeft {\n  0% {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(-100%, 0, 0);\n  }\n}\n.fadeOutLeft {\n  animation-name: fadeOutLeft;\n}\n@keyframes fadeOutLeftBig {\n  0% {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(-2000px, 0, 0);\n  }\n}\n.fadeOutLeftBig {\n  animation-name: fadeOutLeftBig;\n}\n@keyframes fadeOutRight {\n  0% {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(100%, 0, 0);\n  }\n}\n.fadeOutRight {\n  animation-name: fadeOutRight;\n}\n@keyframes fadeOutRightBig {\n  0% {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(2000px, 0, 0);\n  }\n}\n.fadeOutRightBig {\n  animation-name: fadeOutRightBig;\n}\n@keyframes fadeOutUp {\n  0% {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(0, -100%, 0);\n  }\n}\n.fadeOutUp {\n  animation-name: fadeOutUp;\n}\n@keyframes fadeOutUpBig {\n  0% {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(0, -2000px, 0);\n  }\n}\n.fadeOutUpBig {\n  animation-name: fadeOutUpBig;\n}\n@keyframes flip {\n  0% {\n    transform: perspective(400px) rotateY(-1turn);\n    animation-timing-function: ease-out;\n  }\n  40% {\n    transform: perspective(400px) translateZ(150px) rotateY(-190deg);\n    animation-timing-function: ease-out;\n  }\n  50% {\n    transform: perspective(400px) translateZ(150px) rotateY(-170deg);\n    animation-timing-function: ease-in;\n  }\n  80% {\n    transform: perspective(400px) scale3d(.95, .95, .95);\n    animation-timing-function: ease-in;\n  }\n  to {\n    transform: perspective(400px);\n    animation-timing-function: ease-in;\n  }\n}\n@keyframes flipInX {\n  0% {\n    transform: perspective(400px) rotateX(90deg);\n    animation-timing-function: ease-in;\n    opacity: 0;\n  }\n  40% {\n    transform: perspective(400px) rotateX(-20deg);\n    animation-timing-function: ease-in;\n  }\n  60% {\n    transform: perspective(400px) rotateX(10deg);\n    opacity: 1;\n  }\n  80% {\n    transform: perspective(400px) rotateX(-5deg);\n  }\n  to {\n    transform: perspective(400px);\n  }\n}\n.flipInX {\n  backface-visibility: visible!important;\n  animation-name: flipInX;\n}\n@keyframes flipInY {\n  0% {\n    transform: perspective(400px) rotateY(90deg);\n    animation-timing-function: ease-in;\n    opacity: 0;\n  }\n  40% {\n    transform: perspective(400px) rotateY(-20deg);\n    animation-timing-function: ease-in;\n  }\n  60% {\n    transform: perspective(400px) rotateY(10deg);\n    opacity: 1;\n  }\n  80% {\n    transform: perspective(400px) rotateY(-5deg);\n  }\n  to {\n    transform: perspective(400px);\n  }\n}\n.flipInY {\n  backface-visibility: visible!important;\n  animation-name: flipInY;\n}\n@keyframes flipOutX {\n  0% {\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: perspective(400px);\n  }\n  30% {\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: perspective(400px) rotateX(-20deg);\n    opacity: 1;\n  }\n  to {\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: perspective(400px) rotateX(90deg);\n    opacity: 0;\n  }\n}\n.flipOutX {\n  animation-name: flipOutX;\n  //Instead of the line below you could use @include backface-visibility($visibility)\n  backface-visibility: visible!important;\n}\n@keyframes flipOutY {\n  0% {\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: perspective(400px);\n  }\n  30% {\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: perspective(400px) rotateY(-15deg);\n    opacity: 1;\n  }\n  to {\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: perspective(400px) rotateY(90deg);\n    opacity: 0;\n  }\n}\n.flipOutY {\n  //Instead of the line below you could use @include backface-visibility($visibility)\n  backface-visibility: visible!important;\n  animation-name: flipOutY;\n}\n@keyframes lightSpeedIn {\n  0% {\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: translate3d(100%, 0, 0) skewX(-30deg);\n    opacity: 0;\n  }\n  60% {\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: skewX(20deg);\n    opacity: 1;\n  }\n  80% {\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: skewX(-5deg);\n    opacity: 1;\n  }\n  to {\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: none;\n    opacity: 1;\n  }\n}\n.lightSpeedIn {\n  animation-name: lightSpeedIn;\n  animation-timing-function: ease-out;\n}\n@keyframes lightSpeedOut {\n  0% {\n    opacity: 1;\n  }\n  to {\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: translate3d(100%, 0, 0) skewX(30deg);\n    opacity: 0;\n  }\n}\n.lightSpeedOut {\n  animation-name: lightSpeedOut;\n  animation-timing-function: ease-in;\n}\n@keyframes rotateIn {\n  0% {\n    //Instead of the line below you could use @include transform-origin($origin-x, $origin-y, $origin-z, $only3d)\n    transform-origin: center;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: rotate(-200deg);\n    opacity: 0;\n  }\n  to {\n    //Instead of the line below you could use @include transform-origin($origin-x, $origin-y, $origin-z, $only3d)\n    transform-origin: center;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: none;\n    opacity: 1;\n  }\n}\n.rotateIn {\n  animation-name: rotateIn;\n}\n@keyframes rotateInDownLeft {\n  0% {\n    //Instead of the line below you could use @include transform-origin($origin-x, $origin-y, $origin-z, $only3d)\n    transform-origin: left bottom;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: rotate(-45deg);\n    opacity: 0;\n  }\n  to {\n    //Instead of the line below you could use @include transform-origin($origin-x, $origin-y, $origin-z, $only3d)\n    transform-origin: left bottom;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: none;\n    opacity: 1;\n  }\n}\n.rotateInDownLeft {\n  animation-name: rotateInDownLeft;\n}\n@keyframes rotateInDownRight {\n  0% {\n    //Instead of the line below you could use @include transform-origin($origin-x, $origin-y, $origin-z, $only3d)\n    transform-origin: right bottom;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: rotate(45deg);\n    opacity: 0;\n  }\n  to {\n    //Instead of the line below you could use @include transform-origin($origin-x, $origin-y, $origin-z, $only3d)\n    transform-origin: right bottom;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: none;\n    opacity: 1;\n  }\n}\n.rotateInDownRight {\n  animation-name: rotateInDownRight;\n}\n@keyframes rotateInUpLeft {\n  0% {\n    //Instead of the line below you could use @include transform-origin($origin-x, $origin-y, $origin-z, $only3d)\n    transform-origin: left bottom;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: rotate(45deg);\n    opacity: 0;\n  }\n  to {\n    //Instead of the line below you could use @include transform-origin($origin-x, $origin-y, $origin-z, $only3d)\n    transform-origin: left bottom;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: none;\n    opacity: 1;\n  }\n}\n.rotateInUpLeft {\n  animation-name: rotateInUpLeft;\n}\n@keyframes rotateInUpRight {\n  0% {\n    //Instead of the line below you could use @include transform-origin($origin-x, $origin-y, $origin-z, $only3d)\n    transform-origin: right bottom;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: rotate(-90deg);\n    opacity: 0;\n  }\n  to {\n    //Instead of the line below you could use @include transform-origin($origin-x, $origin-y, $origin-z, $only3d)\n    transform-origin: right bottom;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: none;\n    opacity: 1;\n  }\n}\n.rotateInUpRight {\n  animation-name: rotateInUpRight;\n}\n@keyframes rotateOut {\n  0% {\n    //Instead of the line below you could use @include transform-origin($origin-x, $origin-y, $origin-z, $only3d)\n    transform-origin: center;\n    opacity: 1;\n  }\n  to {\n    //Instead of the line below you could use @include transform-origin($origin-x, $origin-y, $origin-z, $only3d)\n    transform-origin: center;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: rotate(200deg);\n    opacity: 0;\n  }\n}\n.rotateOut {\n  animation-name: rotateOut;\n}\n@keyframes rotateOutDownLeft {\n  0% {\n    //Instead of the line below you could use @include transform-origin($origin-x, $origin-y, $origin-z, $only3d)\n    transform-origin: left bottom;\n    opacity: 1;\n  }\n  to {\n    //Instead of the line below you could use @include transform-origin($origin-x, $origin-y, $origin-z, $only3d)\n    transform-origin: left bottom;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: rotate(45deg);\n    opacity: 0;\n  }\n}\n.rotateOutDownLeft {\n  animation-name: rotateOutDownLeft;\n}\n@keyframes rotateOutDownRight {\n  0% {\n    //Instead of the line below you could use @include transform-origin($origin-x, $origin-y, $origin-z, $only3d)\n    transform-origin: right bottom;\n    opacity: 1;\n  }\n  to {\n    //Instead of the line below you could use @include transform-origin($origin-x, $origin-y, $origin-z, $only3d)\n    transform-origin: right bottom;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: rotate(-45deg);\n    opacity: 0;\n  }\n}\n.rotateOutDownRight {\n  animation-name: rotateOutDownRight;\n}\n@keyframes rotateOutUpLeft {\n  0% {\n    //Instead of the line below you could use @include transform-origin($origin-x, $origin-y, $origin-z, $only3d)\n    transform-origin: left bottom;\n    opacity: 1;\n  }\n  to {\n    //Instead of the line below you could use @include transform-origin($origin-x, $origin-y, $origin-z, $only3d)\n    transform-origin: left bottom;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: rotate(-45deg);\n    opacity: 0;\n  }\n}\n.rotateOutUpLeft {\n  animation-name: rotateOutUpLeft;\n}\n@keyframes rotateOutUpRight {\n  0% {\n    //Instead of the line below you could use @include transform-origin($origin-x, $origin-y, $origin-z, $only3d)\n    transform-origin: right bottom;\n    opacity: 1;\n  }\n  to {\n    //Instead of the line below you could use @include transform-origin($origin-x, $origin-y, $origin-z, $only3d)\n    transform-origin: right bottom;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: rotate(90deg);\n    opacity: 0;\n  }\n}\n.rotateOutUpRight {\n  animation-name: rotateOutUpRight;\n}\n@keyframes hinge {\n  0% {\n    //Instead of the line below you could use @include transform-origin($origin-x, $origin-y, $origin-z, $only3d)\n    transform-origin: top left;\n    animation-timing-function: ease-in-out;\n  }\n  20% {\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: rotate(80deg);\n    //Instead of the line below you could use @include transform-origin($origin-x, $origin-y, $origin-z, $only3d)\n    transform-origin: top left;\n    animation-timing-function: ease-in-out;\n  }\n  60% {\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: rotate(80deg);\n    //Instead of the line below you could use @include transform-origin($origin-x, $origin-y, $origin-z, $only3d)\n    transform-origin: top left;\n    animation-timing-function: ease-in-out;\n  }\n  40% {\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: rotate(60deg);\n    //Instead of the line below you could use @include transform-origin($origin-x, $origin-y, $origin-z, $only3d)\n    transform-origin: top left;\n    animation-timing-function: ease-in-out;\n    opacity: 1;\n  }\n  80% {\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: rotate(60deg);\n    //Instead of the line below you could use @include transform-origin($origin-x, $origin-y, $origin-z, $only3d)\n    transform-origin: top left;\n    animation-timing-function: ease-in-out;\n    opacity: 1;\n  }\n  to {\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: translate3d(0, 700px, 0);\n    opacity: 0;\n  }\n}\n.hinge {\n  animation-name: hinge;\n}\n@keyframes jackInTheBox {\n  0% {\n    opacity: 0;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: scale(.1) rotate(30deg);\n    //Instead of the line below you could use @include transform-origin($origin-x, $origin-y, $origin-z, $only3d)\n    transform-origin: center bottom;\n  }\n  50% {\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: rotate(-10deg);\n  }\n  70% {\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: rotate(3deg);\n  }\n  to {\n    opacity: 1;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: scale(1);\n  }\n}\n.jackInTheBox {\n  animation-name: jackInTheBox;\n}\n@keyframes rollIn {\n  0% {\n    opacity: 0;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: translate3d(-100%, 0, 0) rotate(-120deg);\n  }\n  to {\n    opacity: 1;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: none;\n  }\n}\n.rollIn {\n  animation-name: rollIn;\n}\n@keyframes rollOut {\n  0% {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: translate3d(100%, 0, 0) rotate(120deg);\n  }\n}\n.rollOut {\n  animation-name: rollOut;\n}\n@keyframes zoomIn {\n  0% {\n    opacity: 0;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: scale3d(.3, .3, .3);\n  }\n  50% {\n    opacity: 1;\n  }\n}\n.zoomIn {\n  animation-name: zoomIn;\n}\n@keyframes zoomInDown {\n  0% {\n    opacity: 0;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: scale3d(.1, .1, .1) translate3d(0, -1000px, 0);\n    animation-timing-function: cubic-bezier(.55, .055, .675, .19);\n  }\n  60% {\n    opacity: 1;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);\n    animation-timing-function: cubic-bezier(.175, .885, .32, 1);\n  }\n}\n.zoomInDown {\n  animation-name: zoomInDown;\n}\n@keyframes zoomInLeft {\n  0% {\n    opacity: 0;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: scale3d(.1, .1, .1) translate3d(-1000px, 0, 0);\n    animation-timing-function: cubic-bezier(.55, .055, .675, .19);\n  }\n  60% {\n    opacity: 1;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: scale3d(.475, .475, .475) translate3d(10px, 0, 0);\n    animation-timing-function: cubic-bezier(.175, .885, .32, 1);\n  }\n}\n.zoomInLeft {\n  animation-name: zoomInLeft;\n}\n@keyframes zoomInRight {\n  0% {\n    opacity: 0;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: scale3d(.1, .1, .1) translate3d(1000px, 0, 0);\n    animation-timing-function: cubic-bezier(.55, .055, .675, .19);\n  }\n  60% {\n    opacity: 1;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: scale3d(.475, .475, .475) translate3d(-10px, 0, 0);\n    animation-timing-function: cubic-bezier(.175, .885, .32, 1);\n  }\n}\n.zoomInRight {\n  animation-name: zoomInRight;\n}\n@keyframes zoomInUp {\n  0% {\n    opacity: 0;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: scale3d(.1, .1, .1) translate3d(0, 1000px, 0);\n    animation-timing-function: cubic-bezier(.55, .055, .675, .19);\n  }\n  60% {\n    opacity: 1;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);\n    animation-timing-function: cubic-bezier(.175, .885, .32, 1);\n  }\n}\n.zoomInUp {\n  animation-name: zoomInUp;\n}\n@keyframes zoomOut {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: scale3d(.3, .3, .3);\n  }\n  to {\n    opacity: 0;\n  }\n}\n.zoomOut {\n  animation-name: zoomOut;\n}\n@keyframes zoomOutDown {\n  40% {\n    opacity: 1;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);\n    animation-timing-function: cubic-bezier(.55, .055, .675, .19);\n  }\n  to {\n    opacity: 0;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: scale3d(.1, .1, .1) translate3d(0, 2000px, 0);\n    //Instead of the line below you could use @include transform-origin($origin-x, $origin-y, $origin-z, $only3d)\n    transform-origin: center bottom;\n    animation-timing-function: cubic-bezier(.175, .885, .32, 1);\n  }\n}\n.zoomOutDown {\n  animation-name: zoomOutDown;\n}\n@keyframes zoomOutLeft {\n  40% {\n    opacity: 1;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: scale3d(.475, .475, .475) translate3d(42px, 0, 0);\n  }\n  to {\n    opacity: 0;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: scale(.1) translate3d(-2000px, 0, 0);\n    //Instead of the line below you could use @include transform-origin($origin-x, $origin-y, $origin-z, $only3d)\n    transform-origin: left center;\n  }\n}\n.zoomOutLeft {\n  animation-name: zoomOutLeft;\n}\n@keyframes zoomOutRight {\n  40% {\n    opacity: 1;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: scale3d(.475, .475, .475) translate3d(-42px, 0, 0);\n  }\n  to {\n    opacity: 0;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: scale(.1) translate3d(2000px, 0, 0);\n    //Instead of the line below you could use @include transform-origin($origin-x, $origin-y, $origin-z, $only3d)\n    transform-origin: right center;\n  }\n}\n.zoomOutRight {\n  animation-name: zoomOutRight;\n}\n@keyframes zoomOutUp {\n  40% {\n    opacity: 1;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);\n    animation-timing-function: cubic-bezier(.55, .055, .675, .19);\n  }\n  to {\n    opacity: 0;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: scale3d(.1, .1, .1) translate3d(0, -2000px, 0);\n    //Instead of the line below you could use @include transform-origin($origin-x, $origin-y, $origin-z, $only3d)\n    transform-origin: center bottom;\n    animation-timing-function: cubic-bezier(.175, .885, .32, 1);\n  }\n}\n.zoomOutUp {\n  animation-name: zoomOutUp;\n}\n@keyframes slideInDown {\n  0% {\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: translate3d(0, -100%, 0);\n    visibility: visible;\n  }\n  to {\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: translateZ(0);\n  }\n}\n.slideInDown {\n  animation-name: slideInDown;\n}\n@keyframes slideInLeft {\n  0% {\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: translate3d(-100%, 0, 0);\n    visibility: visible;\n  }\n  to {\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: translateZ(0);\n  }\n}\n.slideInLeft {\n  animation-name: slideInLeft;\n}\n@keyframes slideInRight {\n  0% {\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: translate3d(100%, 0, 0);\n    visibility: visible;\n  }\n  to {\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: translateZ(0);\n  }\n}\n.slideInRight {\n  animation-name: slideInRight;\n}\n@keyframes slideInUp {\n  0% {\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: translate3d(0, 100%, 0);\n    visibility: visible;\n  }\n  to {\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: translateZ(0);\n  }\n}\n.slideInUp {\n  animation-name: slideInUp;\n}\n@keyframes slideOutDown {\n  0% {\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: translateZ(0);\n  }\n  to {\n    visibility: hidden;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: translate3d(0, 100%, 0);\n  }\n}\n.slideOutDown {\n  animation-name: slideOutDown;\n}\n@keyframes slideOutLeft {\n  0% {\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: translateZ(0);\n  }\n  to {\n    visibility: hidden;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: translate3d(-100%, 0, 0);\n  }\n}\n.slideOutLeft {\n  animation-name: slideOutLeft;\n}\n@keyframes slideOutRight {\n  0% {\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: translateZ(0);\n  }\n  to {\n    visibility: hidden;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: translate3d(100%, 0, 0);\n  }\n}\n.slideOutRight {\n  animation-name: slideOutRight;\n}\n@keyframes slideOutUp {\n  0% {\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: translateZ(0);\n  }\n  to {\n    visibility: hidden;\n    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n    transform: translate3d(0, -100%, 0);\n  }\n}\n.slideOutUp {\n  animation-name: slideOutUp;\n}","/* * Hide from both screenreaders and browsers: h5bp.com/u */\n.hidden {\n\tdisplay: none !important;\n\tvisibility: hidden;\n}\n\n/* * Hide only visually, but have it available for screenreaders: h5bp.com/v */\n.visuallyhidden {\n\tborder: 0;\n\tclip: rect(0 0 0 0);\n\theight: 1px;\n\tmargin: -1px;\n\toverflow: hidden;\n\tpadding: 0;\n\tposition: absolute;\n\twidth: 1px;\n}\n\n/* * Extends the .visuallyhidden class to allow the element to be focusable * when navigated to via the keyboard: h5bp.com/p */\n\n.visuallyhidden.focusable:active,\n.visuallyhidden.focusable:focus {\n\tclip: auto;\n\theight: auto;\n\tmargin: 0;\n\toverflow: visible;\n\tposition: static;\n\twidth: auto;\n} /* * Hide visually and from screenreaders, but maintain layout */\n\n.invisible {\n\tvisibility: hidden;\n}\n\n.clearfix:before,\n.clearfix:after {\n\tcontent: \" \"; /* 1 */\n\tdisplay: table; /* 2 */\n}\n\n.clearfix:after {\n\tclear: both;\n}\n.noflick {\n\tperspective: 1000;\n\tbackface-visibility: hidden;\n\ttransform: translate3d(0,0,0);\n}\n.sticky-note{\n\tmargin: -22px -15px 0;\n}\n.note {\n\tfloat: left;\n\tdisplay: block;\n\tposition: relative;\n\tpadding: 1em;\n\twidth: calc(25% - 30px);\n\tmin-height: 300px;\n\tmargin: 22px 15px 0;\n\tborder-radius: 5px;\n\tbackground-color: lighten($primary-color,20%);\n\ttransition: transform .15s;\n\tz-index: 1;\n\t@extend .noflick;\n\n\t&:hover {\n\t\tcursor: move;\n\t}\n\t&.ui-draggable-dragging:nth-child(n) {\n\t\tbox-shadow: 5px 5px 15px 0 rgba(0,0,0,.3);\n\t\ttransform: scale(1.125) !important;\n\t\tz-index: 100;\n\t\tcursor: move;\n\t\ttransition: transform .150s;\n\t}\n\n\ttextarea {\n\t\tbackground-color: transparent;\n\t\tborder: none;\n\t\tresize: vertical;\n\t\tfont-style: italic;\n\t\twidth: 100%;\n\t\tpadding: 5px;\n\t\t&:focus {\n\t\t\toutline: none;\n\t\t\tborder: none;\n\t\t\tbox-shadow: 0 0 0px 1px rgba(0,0,0,.2) inset;\n\t\t}\n\t\t&.title {\n\t\t\tfont-size: 24px;\n\t\t\tline-height: 1.2;\n\t\t\tcolor: #000000;\n\t\t\theight: 64px;\n\t\t\tmargin-top: 20px;\n\t\t}\n\t\t&.cnt {\n\t\t\tmin-height: 200px;\n\t\t}\n\t}\n\t&:nth-child(2n) {\n\t\tbackground: lighten($secondary-color ,35%);\n\t}\n\t&:nth-child(3n) {\n\t\tbackground: lighten($success-color ,50%);\n\t}\n\t&:nth-child(4n) {\n\t\tbackground: lighten($info-color ,25%);\n\t}\n\t&:nth-child(5n) {\n\t\tbackground: lighten($warning-color ,35%);\n\t}\n\t&:nth-child(6n) {\n\t\tbackground: lighten($danger-color ,25%);\n\t}\n}\n\n/* Button style  */\n.button {\n\tcolor: #FFFFFF;\n\tpadding: 1em 2em;\n\ttext-decoration: none;\n\ttransition: transform .150s, background .01s;\n\t@extend .noflick;\n\t&.remove {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tright: -10px;\n\t\tcolor: #999;\n\t}\n}\n\n@media (max-width: 1199px) {\n\t.note {\n\t\tmin-width: 260px;\n\t\tmin-height: 260px;\n\t}\n}","/*====todo css start====*/\n.todo {\n  .action-box {\n    background: transparent;\n    height: 20px;\n    width: 20px;\n    display: inline-block;\n    text-align: center;\n    cursor: pointer;\n    transition: all 300ms ease;\n    .icon {\n      vertical-align: 0;\n    }\n    &.completed {\n      background: $danger-color;\n      border: 1px solid $danger-color;\n      border-radius: 4px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      .icon {\n        color: $white;\n        font-size: 14px;\n        width: 16px;\n        height: 16px;\n      }\n    }\n    &.large {\n      height: 30px;\n      width: 30px;\n      .icon {\n        font-size: 20px;\n        vertical-align: -5px;\n        .icon-trash {\n          color: var(--theme-default);\n        }\n        .icon-check {\n          color: var(--theme-default);\n        }\n      }\n    }\n  }\n  .todo-list-wrapper {\n    width: 100%;\n    margin: 0 auto;\n    box-sizing: border-box;\n    .mark-all-tasks {\n      display: flex;\n      align-items: center;\n      .mark-all-tasks-container {\n        overflow: hidden;\n        position: relative;\n      }\n      .mark-all-btn {\n        cursor: pointer;\n        display: inline-block;\n        transition: all 200ms ease;\n        &#mark-all-finished {\n          color: $danger-color;\n        }\n        &#mark-all-incomplete {\n          color: $success-color;\n          .action-box {\n            border: 2px solid $success-color;\n            border-radius: 4px;\n            .icon {\n              color: $success-color;\n            }\n          }\n        }\n        &.move-up {\n          transform: translateY(-30px);\n          position: absolute;\n          right: 0;\n        }\n        &.move-down {\n          transform: translateY(30px);\n          position: absolute;\n          right: 0;\n        }\n      }\n      .btn-label {\n        margin-right: 5px;\n        font-weight: 600;\n      }\n    }\n    .todo-list-footer {\n      position: relative;\n      h5 {\n        text-align: center;\n        color: $theme-body-font-color;\n      }\n      .add-task-btn {\n        &:hover {\n          background: var(--theme-default);\n          .icon {\n            color: $light-color;\n          }\n        }\n        .icon {\n          color: var(--theme-default);\n          font-size: 20px;\n        }\n      }\n      .new-task-wrapper {\n        transition: all 300ms ease;\n        max-height: 0;\n        overflow: hidden;\n        textarea {\n          box-sizing: border-box;\n          width: 100%;\n          border: 1px solid $light-color;\n          height: 90px;\n          padding: 10px 15px;\n          margin-bottom: 10px;\n          border-radius: 4px;\n          transition: all 300ms ease;\n          &:focus {\n            border: 1px solid $light-semi-gray;\n            outline: none;\n          }\n          &.error {\n            border: 1px solid $danger-color;\n            outline: none;\n          }\n        }\n        .error-message {\n          color: $danger-color;\n          font-style: italic;\n        }\n        &.visible {\n          max-height: 300px;\n          overflow: auto;\n        }\n      }\n      .new-task-wrapper::after {\n        content: \"\";\n        display: block;\n        clear: both;\n      }\n    }\n    .todo-list-body {\n      max-height: 500px;\n      overflow: auto;\n    }\n    #todo-list {\n      list-style: none;\n      margin: 0;\n      padding: 0;\n      .task {\n        &:first-child {\n          .task-container {\n            padding-top: 0;\n            h4 {\n              padding-top: 0;\n            }\n          }\n        }\n      }\n      li {\n        margin: 0;\n        padding: 0;\n        .task-container {\n          display: flex;\n          justify-content: space-between;\n          padding: 10px 0;\n          width: 100%;\n          border-bottom: 1px solid $light-color;\n          -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n          position: relative;\n          transition: background 200ms ease;\n          .assign-name {\n            font-size: 14px;\n          }\n          .task-label {\n            display: block;\n            font-size: 17px;\n            vertical-align: middle;\n            color: $dark-gray;\n            word-break: break-all;\n            padding-top: 5px;\n            font-weight: 300;\n          }\n          .task-action-btn {\n            display: table-cell;\n            vertical-align: middle;\n            text-align: right;\n            min-width: 65px;\n            .action-box {\n              margin-left: 5px;\n              margin-top: 2px;\n              border: 1px solid transparent;\n              margin-bottom: 2px;\n              .icon {\n                font-size: 16px;\n              }\n              &:hover {\n                border: 1px solid $semi-dark;\n                background: $white;\n                border-radius: 4px;\n                .icon {\n                  color: $semi-dark;\n                }\n              }\n            }\n          }\n          &:hover {\n            h4 {\n              color: $dark-color;\n              transition: all 0.3s ease;\n            }\n          }\n        }\n        &.completed .task-container {\n          .complete-btn {\n            border: 1px solid var(--theme-default);\n            border-radius: 4px;\n            .icon {\n              font-weight: bold;\n            }\n            &:hover {\n              background: $white;\n              border: 1px solid $success-color;\n              .icon {\n                color: $white;\n              }\n            }\n          }\n          .task-label {\n            text-decoration: line-through;\n            color: var(--theme-default);\n          }\n        }\n        &.new .task-container {\n          animation: taskHighlighter 2000ms linear 1;\n        }\n      }\n    }\n    .todo-list-header h5 {\n      text-align: center;\n      color: $light-semi-gray;\n    }\n  }\n  .notification-popup {\n    position: fixed;\n    top: 85px;\n    right: 10px;\n    width: 300px;\n    display: inline-block;\n    background: $success-color;\n    border: 1px solid $success-color;\n    color: $white;\n    padding: 20px;\n    opacity: 0.9;\n    border-radius: 2px;\n    box-sizing: border-box;\n    transition: all 300ms ease;\n    &.success {\n      background: $success-color;\n      border: 1px solid $success-color;\n    }\n    p {\n      margin-top: 0;\n      margin-bottom: 0;\n      color: $white;\n    }\n    .task {\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      max-width: 100%;\n      display: inline-block;\n    }\n    .notification-text {\n      font-size: 14px;\n      display: inline-block;\n      overflow: hidden;\n    }\n    &.hide {\n      opacity: 0;\n      visibility: hidden;\n    }\n  }\n  @-webkit-keyframes taskHighlighter {\n    0% {\n      background: rgba(68, 102, 242, 0.5);\n    }\n    100% {\n      background: $white;\n    }\n  }\n  @keyframes taskHighlighter {\n    0% {\n      background: rgba(68, 102, 242, 0.5);\n    }\n    100% {\n      background: $white;\n    }\n  }\n}\n.todo-wrap {\n  .todo-list-body {\n    .assign-name {\n      opacity: 0.4;\n    }\n  }\n  .left-bookmark {\n    ul {\n      li {\n        .iconbg {\n          padding: 8px;\n          border-radius: 30px;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n        }\n      }\n    }\n  }\n  &.email-wrap {\n    .email-app-sidebar {\n      .main-menu {\n        > li {\n          + li {\n            padding-top: 12px;\n          }\n          a {\n            padding: 0 16px;\n            .badge {\n              color: $white;\n              padding: 4px 5px 3px;\n            }\n            &:hover {\n              background-color: transparent;\n              .badge {\n                color: $white;\n              }\n            }\n          }\n        }\n      }\n    }\n    .btn-mail {\n      color: $white !important;\n    }\n  }\n}\n/*====todo css end====*/\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
